export default function ngLoadApp(angular) {
/**
 *    APP SETTINGS
 */

angular
.module('espui.core')
.factory('appConst', appConst);

/* @ngInject */
function appConst() {

	var _settings = {
		app: app(),
		feeds: feeds(),
		orders: orders(),
		match: matchSet()
	};

	return _settings;


	/**
	 *    APP
	 */

	function app() {
		return {
			liveDate: new Date(2014, 9, 1, 0, 0, 0),  // Oct 1, 2015 task: change this to the real live date
			query: {
				dateRange: 7,
				dateRangeMax: 30,
				useEntities: true,
				useDates: true,
				pagingSize: 2000
			},
			display: {
				pagingSize: 50
			},
			color: {
				chartBars: function(theme) {
					switch(theme) {
						case '':
							return [
								'#0074b2', // primary
								'#4EA701', // secondary
								'#e7b006', // chart yellow
								'#e71106' // chart red
							];
						case 'B':
							return [
								'#0CBAB3', // primary
								'#BBBBBB', // light gray
								'#00827A', // primary dark
								'#555659' // charcoal
							];
						default:
							throw new Error('appConst.app.color.chartBars, unknown color theme: ' + theme);
					}
				},
				chart340B: '#0CBAB3',
				chartGPO: '#BBBBBB',
				chartWAC: '#3b3b3b',
				chart: {
					primary: '#0CBAB3', // primary
					primaryDark: '#00827A', // primary dark
					gray: '#BBBBBB', // light gray
					charcoal: '#555659' // charcoal
				}
			}
		};
	}

	function feeds() {
		return {
			query: {
				dateRange: 32,
				dateRangeMax: 32
			}
		};
	}

	function orders() {
		return {
			query: {
				dateRange: 90,
				dateRangeMax: 90
			}
		};
	}

	function matchSet() {
		return {
			query: {
				dateRange: 32,
				dateRangeMax: 32
			}
		};
	}

}
 
/**
 *    APP-WIDE EXCEPTION HANDLING
 *    all unhandled JavaScript errors are routed through this method
 *    replaces the default angular handler which just writes to the console
 *
 *    note: all trapped espui errors will call the errSvc methods
 */

errHandler.$inject = ['$injector', '$window', '$log'];
errSvc.$inject = ['$rootScope', '$window'];
angular
.module('espui.core')
.factory('$exceptionHandler', errHandler);

/* @ngInject */
function errHandler($injector, $window, $log) {

	return appErrHandler;

	function appErrHandler(exception, cause) {

		// parse and display the error
		displayErr(parseErr(exception));

		function parseErr(err) {

			// blank error structure
			var errInfo = errVM();

			// err content exists
			if(!!err) {

				// error is just a string
				if(typeof(err) === 'string') {
					errInfo.msg = err;
				}
				else {

					// error is an object, try to fill in our structure

					// error line number (only for FF, Chrome)
					var errLine = '';
					if(!isNaN(err.lineNumber)) {
						errLine = err.lineNumber.toString();
					}

					// convert err object into error VM
					errInfo = errVM(err.msgType, err.message || err.msg, err.stack, err.status, err.detail, errLine);

				}
			}

			return errInfo;

		}

		function displayErr(errInfo) {

			// display either as espui gui (event sent to msgbox) or default to console + alert

			var espuiGui = false;

			// get rootScope using the injector
			if(!!$injector) {
				var rScope = $injector.get('$rootScope');
				if(!!rScope) {
					espuiGui = true;
					rScope.$emit('espui>error', errInfo);
				}
			}

			// couldn't get root scope? log and alert
			if(!espuiGui) {
				$log.error(errInfo);
				alert('Unexpected Error\n' + errInfo.msg + '\n' + errInfo.stack);
			}

		}
	}


	/**
	 *    APP-WIDE ERROR VIEW MODEL
	 *    all error and message services use this format
	 *    note: errors are injected before any service, this has to be repeated inside every factory or provider which uses it
	 */

	function errVM(msgType, msg, stack, status, detail, line) {
		return {
			msgType: msgType || 'error.unexpected',
			msg: msg || 'unknown',
			stack: $window.location.toString() + (!!stack ? ' stack: ' + stack.toString() : ' no stack found'),
			status: status || !isNaN(status) ? status.toString() : '',
			detail: detail || '',
			line: line || ''
		};
	}

}


/**
 *    ERROR SERVICE
 *    simplified methods to generate an espui error
 */

angular
.module('espui.core')
.factory('errSvc', errSvc);

/* @ngInject */
function errSvc($rootScope, $window) {

	var service = {
		VM: errVM,
		info: info,
		warn: warn,
		error: error,
		ok: okMsg
	};

	return service;


	/**
	 *    APP-WIDE ERROR VIEW MODEL
	 *    all error and message services use this format
	 *    note: errors are injected before any service, this has to be repeated inside every factory or provider which uses it
	 */

	function errVM(msgType, msg, stack, status, detail, line) {
		return {
			msgType: msgType || 'error.unexpected',
			msg: msg || 'unknown',
			stack: $window.location.toString() + '-- stack: ' + (!!stack ? stack.toString() : 'none'),
			status: isNaN(status) ? '' : status.toString(),
			detail: detail || '',
			line: line || ''
		};
	}


	function emitError(msgType, msg, stack, status, detail, line) {
		$rootScope.$emit('espui>error', errVM(msgType, msg, stack, status, detail, line));
	}


	/**
	 *    OK
	 *    emitted as not an error
	 *    shows a simple ok message, no stack or details
	 *    same as msgSvc.ok()
	 */

	function okMsg (titleTxt, msgTxt) {

		// show an ok dialog

		// emit event
		$rootScope.$emit('espui>msgbox.show', {
			msgType: 'ok',
			title: titleTxt,
			msg: msgTxt
		});

	}


	/**
	 *    INFO
	 *    use to notify the user of non-critical information, no failures
	 *    note: this is NOT shown as an error on UI
	 */
	function info(msg, stack, status, detail) {
		emitError('error.info', msg, stack, status, detail);
	}


	/**
	 *    WARN
	 *    a minor fail issue, like validation etc, try again scenarios
	 */
	function warn(msg, stack, status, detail) {
		emitError('error.warn', msg, stack, status, detail);
	}


	/**
	 *    UNEXPECTED
	 *    major deal, should not have happened, the feature cannot continue
	 *    reload the app after user clicks ok on message
	 */
	function unexpected(msg, stack, status, detail, line) {
		emitError('error.unexpected', msg, stack, status, detail, line);
	}
	function error(msg, stack, status, detail, line) {
		// same as unexpected
		emitError('error.unexpected', msg, stack, status, detail, line);
	}

}
 
/**
 *    GLOBAL EVENT SERVICE
 *    app-wide event handling
 */

eventSvc.$inject = ['$rootScope'];
angular
.module('espui.core')
.factory('eventSvc', eventSvc);

/* @ngInject */
function eventSvc($rootScope) {

    var service = {
        rootEmit: rootEmit
    };

    return service;

    function rootEmit(description, evtObject) {
        $rootScope.$emit('espui>' + description, evtObject);
    }

}
 
affOptionsRepo.$inject = ['$rootScope', '$q', 'apiService', 'errSvc', 'eventSvc', 'msgSvc', 'utilSvc', 'validSvc', 'vmSvc'];angular
.module('espui.core.affoptions')
.factory('affOptionsRepo', affOptionsRepo);


/* @ngInject */
function affOptionsRepo($rootScope, $q, apiService, errSvc, eventSvc, msgSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _currentPurl = '',
		_apiPaging = vmSvc.api.paging(),
		_pendingModel = {},
		_pendingQuery = {};

	// service definition
	var service = {
		queryVM: queryVM,

		getVendor: getVendor,
		getVendorList: getVendorList,

		getNdcList: getNdcList,
		saveNdcList: saveNdcList,
		addNdcItem: addNdcItem,
		removeNdcItem: removeNdcItem,
		toggleNdcItemState: toggleNdcItemState,
		ndcExportExcel: ndcExportExcel,
		ndcImportCsv: ndcImportCsv,

		// global manufacturer exclusion list
		getManufacturerExclusionList: getManufacturerExclusionList,

		getAdminSettings: getAdminSettings,
		exportAdminSettings: exportAdminSettings,
		importAdminSettings: importAdminSettings
	};

	return service;


	/**
	 *    QUERY VIEW MODEL
	 */

	function queryVM() {

		return {
			CE: validSvc.newProp($rootScope.User.CE),
			RX: validSvc.newProp($rootScope.User.RX),
			VEN: validSvc.newProp('NONE'),
			AccumulatorType: '',
			RxBizModel: '',
			RxSplit: false
		};

	}


	/**
	 *    GET VENDOR
	 */

	function getVendor(ceid, rxid, venid, accumType) {

		// params
		if(!validSvc.isCE(ceid) || !validSvc.isRX(rxid) || !validSvc.isVEN(venid) || !validSvc.isText(accumType)) {
			throw new Error('affOptionsRepo.getVendor, ceid, rxid, venid, acct type required: ' + ceid + '/' + rxid);
		}

		_currentPurl = 'ops/affs/vendor/list';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid],
				RXID: [rxid]
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('Id')]
		};

		_pendingQuery = {
			CE: ceid,
			RX: rxid,
			VEN: venid,
			AccumType: accumType
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okGetVendor, errGetVendor);

		function okGetVendor(r) {

			// custom response validator
			if(!!!r || r.status !== 200 || !!!r.data || !!!r.data.Entity || !Array.isArray(r.data.Entity.Items)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// find vendor
			var items = r.data.Entity.Items,
				ven = null,
				venid = _pendingQuery.VEN,
				accumType = _pendingQuery.AccumType;

			for(var i = 0; i < items.length; i++) {
				if(items[i].Vendor == venid && items[i].AccumulatorType == accumType) {
					ven = items[i];
					break;
				}
			}

			defer.resolve(ven);

		}

		function errGetVendor(r) {

			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);

		}

		return defer.promise;

	}

	function getVendorList(ceid, rxid) {

		// params
		if(!validSvc.isCE(ceid) || !validSvc.isRX(rxid)) {
			throw new Error('affOptionsRepo.getVendorList, ceid or rxid is missing: ' + ceid + '/' + rxid);
		}

		_currentPurl = 'ops/affs/vendor/list';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid],
				RXID: [rxid]
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('Id')]
		};

		_pendingQuery = {
			CE: ceid,
			RX: rxid
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okGetVendorList, errGetVendorList);

		function okGetVendorList(r) {

			// custom response validator
			if(!!!r || r.status !== 200 || !!!r.data || !!!r.data.Entity || !Array.isArray(r.data.Entity.Items)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update CE and Rx user choice
			eventSvc.rootEmit('context.change', {
				CE: _pendingQuery.CE,
				RX: _pendingQuery.RX
			});

			defer.resolve(r.data.Entity.Items);

		}

		function errGetVendorList(r) {

			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);

		}

		return defer.promise;

	}


	/**
	 *    GET NDC LIST
	 */

	function getNdcList(ceid, rxid, entity, listType, scope) {
		//console.log("list type", listType, "ceid", ceid, "rxid", rxid, "acctId", entity);
		var apiRequest = {
			Context: {
				CEID: [ceid],
				RXID:[rxid]
			},
			Params: {
				Scope: scope,
				ListType: listTypeCode(listType),
				Entity:entity
			},
			Paging: {
				Size: 10000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('ItemCode')]
		};
		_currentPurl = 'ops/ndcex/list';
		var defer = $q.defer();
		// call api
		_pendingModel = listType;
		apiService.post(_currentPurl, apiRequest).then(okGetNdcList, errGetNdcList);

		function okGetNdcList(r) {

			if(validSvc.httpGetListResp(r)) {
				defer.resolve(r.data.Entity);
			}else {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}

		}

		function errGetNdcList(r) {

			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);

		}

		return defer.promise;

	}

	/**
	 *    NDC SAVE
	 */

	function saveNdcList(ceid, rxid, entity, listType, scope, model) {
		_pendingModel = model;
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [ceid],
				RXID: [rxid]
			}
		};

		// Took away change logs when we saving the lists, backend will still append them
		for (var i = 0; i < model.Items.length; i++) {
			model.Items[i].ChangeLog = null;
		}

		_currentPurl = 'ops/ndcex/save';
		apiRequest.Params = {
			Entity: entity,
			Scope: scope,
			ListType: listTypeCode(listType),
			Items: model.Items
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okSaveNdcList, errSaveNdcList);

		function okSaveNdcList(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errSaveNdcList(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				var list = [];
				for(var i = 0; i < r.data.Entity.Fields.length; i++) {
					list.push(r.data.Entity.Fields[i].Name);
				}
				var msg = {
					id: 'ops.transform.group',
					title: 'Cannot Save',
					msg: 'Some items may already exist in a conflicting ndc list. Remove them and try again.',
					buttons: [
						{text:'OK', result:'YES', cancel: false},
						{text:'Copy to clipboard', result: 'COPY', cancel: false},
					],			
					detail: list.join(',')
				};
				msgSvc.confirm(msg);
				defer.reject(null);
			}
			else {
				throw new Error(_currentPurl + ', unexpected error result');
			}

		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// bad NDCs
			var badNdc = '',
				fieldObj = null,
				items = m.Items,
				foundNdc = false;

			for(var i = 0; i < entity.Fields.length; i++) {

				badNdc = entity.Fields[i].Name;

				foundNdc = false;
				for(var ii = 0; ii < items.length; ii++) {
					if(items[ii].ItemCode == badNdc) {
						items[ii].fail = 'yes';
						items[ii].msg = entity.Fields[i].Rule;
						foundNdc = true;
					}
				}

				if(!foundNdc) {
					throw new Error('affOptionsRepo.mapApiErrorsToModel, 422: NDC ItemCode not found: ' + badNdc);
				}

			}

			return m;

		}

		return defer.promise;
	}

	function addNdcItem(ceid, rxid,entity, listType,scope, id, replaceItemCode) {
		_currentPurl = 'ops/ndcex/add';
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [ceid],
				RXID:[rxid],
			},
			Entity: {
				ItemCode: id,
				Scope:scope,
				Type: listTypeCode(listType),
				EntityId : entity,
				ReplaceItemCode: replaceItemCode
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okAddNdc, errAddNdc);

		function okAddNdc(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errAddNdc(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.msg = r.data.Entity.Fields[0].Rule;
				defer.reject(r);
			}
			else {
				throw new Error(_currentPurl + ', unexpected error result');
			}

		}

		return defer.promise;
	}

	function removeNdcItem(ceid, rxid, acctId, listType, id) {
		_currentPurl ='ops/ndcex/remove';
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [ceid],
				RXID:[rxid],
				VENID:[acctId]
			},
			Params: {
				Id: id,
				Entity:acctId
			}
		};


		apiService.post(_currentPurl, apiRequest).then(okRemoveNdc, errRemoveNdc);

		function okRemoveNdc(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errRemoveNdc(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.msg = r.data.Entity.Fields[0].Rule;
				defer.reject(r);
			}
			else {
				throw new Error(_currentPurl + ', unexpected error result');
			}

		}

		return defer.promise;
	}

	function toggleNdcItemState(ceid, rxid,entity, listType,scope, id, replaceItemCode) {
		_currentPurl ='ops/ndcex/togglestate';
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [ceid],
				RXID:[rxid],
			},
			Entity: {
				ItemCode: id,
				ReplaceItemCode: replaceItemCode,
				Scope:scope,
				Type: listTypeCode(listType),
				EntityId : entity
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okToggleNdcItemState, errToggleNdcItemState);

		function okToggleNdcItemState(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errToggleNdcItemState(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.msg = r.data.Entity.Fields[0].Rule;
				defer.reject(r);
			}
			else {
				throw new Error(_currentPurl + ', unexpected error result');
			}

		}

		return defer.promise;
	}

	/**
	 *    EXCEL
	 *    file created on api server, expecting a binary file stream instead of JSON
	 */

	function ndcExportExcel(ceid, rxid, acctId, listType, scope,filename) {
		_currentPurl = 'ops/ndcex/export';
					
		var defer = $q.defer();
		var apiRequest = {
			Context: {
				CEID: [ceid],
				rxid:[rxid],
				RXID:[rxid]
			},
			Params: {
				ListType: listTypeCode(listType),
				Scope:scope,
				Entity:acctId,
			},
			Paging: {
				Size: 10000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('ItemCode')]
		};

		// call api
		apiService.postGetBinary(_currentPurl, apiRequest).then(okExcel, errExcel);

		function okExcel(r) {
			defer.resolve(r.data);
		}

		function errExcel(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    NDC FILE IMPORT
	 */

	function ndcImportCsv(ceid, rxid, acctId, listType, scope, importFile) {
		_currentPurl =  'ops/ndcex/import';
		var defer = $q.defer();
		var apiRequest = {
			Context :{
				CEID: [ceid],
				RXID: [rxid],
			},
			Params : {
				Entity: acctId,
				Scope:scope,
				ListType: listTypeCode(listType)
			}
		};

		// create multi-part form data
		var fd = new FormData();
		fd.append('context', angular.toJson(apiRequest)); // stringify JSON into one "context" property
		fd.append('file', importFile);

		apiService.postFile(_currentPurl, fd, false).then(okFileImport, errFileImport);

		function okFileImport(r) {

			// bad upsert response format
			if(!!!r || !!!r.data) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			var ent = r.data.Entity;
			if(validSvc.isInteger(ent.ProcessedCount)) {
				ent.Count = ent.ProcessedCount;
			}

			// add record errors to 200 response
			ent.importErrors = Array.isArray(ent.RecordErrors) && ent.RecordErrors.length > 0 ? ent.RecordErrors : [];
			
			defer.resolve(ent);
		}

		function errFileImport(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!!!r || !validSvc.isNumber(r.status) || !!!r.data) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 422) {
				r.importErrors = mapApiImportErrors(r.data.Entity);
				defer.reject(r);
			}
			else {
				errSvc.error('Unexpected error', _currentPurl + 'transformRepo.errFileImport', r.status, utilSvc.http.safeResponse(r));
			}

		}

		function mapApiImportErrors(entity) {

			// map server 422 fields onto import error text lines

			if(Array.isArray(entity.RecordErrors) && entity.RecordErrors.length > 0) {
				return entity.RecordErrors;
			}
			else if(entity.ROOT.length > 0) {
				return [{Name: 'File Error', Rule: entity.ROOT.join(',')}];
			}
			else {
				throw new Error('affOptionsRepo.422FileImport, Api returned no errors to display');
			}
			
		}


		return defer.promise;

	}


	/**
	 *    Manufacturer Exclusion List: GET
	 */
	function getManufacturerExclusionList() {
		_currentPurl = 'ops/ndcex/global/exclusion/manufacturer/get';
		var defer = $q.defer();

		var apiRequest = {
			SortBy: [utilSvc.sorting.sortByApiStyle('Name')]
		};

		apiService.post(_currentPurl, apiRequest).then(okList, errList);

		function okList(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			var result = utilSvc.array.sortASC(r.data.Entity, 'Name');
			defer.resolve(result);

		}

		function errList(r) {

			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 *    ADMIN SETTINGS
	 */

	function getAdminSettings(ceid, rxid) {

		// params
		if(!validSvc.isCE(ceid) || !validSvc.isRX(rxid)) {
			throw new Error('affOptionsRepo.getAdminSettings, ceid, rxid required');
		}

		_currentPurl = 'ops/affs/settings/get';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid],
				RXID: [rxid]
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okGetSettings, errGetSettings);

		function okGetSettings(r) {

			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.error('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errGetSettings(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function exportAdminSettings(query, filename) {

		// params
		query = query || {};
		if((!Array.isArray(query.CeVals) && !Array.isArray(query.RxVals)) || !validSvc.isText(filename)) {
			throw new Error('affOptionsRepo.exportAdminSettings, ce / rx / filename required');
		}

		var defer = $q.defer();
		_currentPurl = query.ViewType == 'EXCEL' ? 'admin/settings/excel' : 'admin/settings/export';

		var apiRequest = {
			Context: {
				CEID: query.CeVals,
				RXID: query.RxVals
			},
			Params: {
				Tabs: [],
				IncludeLocations: query.IncludeLocations,
				IncludeNPIs: query.IncludeNPIs,
				IncludePayors: query.IncludePayors,
				IncludeMedicaid: query.IncludeMedicaid,
				IncludeADT: query.IncludeADT
			}
		};

		// add tabs
		if(query.chkCE == 'yes') {
			apiRequest.Params.Tabs.push('CE');
		}
		if(query.chkRX == 'yes') {
			apiRequest.Params.Tabs.push('RX');
		}
		if(query.chkAffInfo == 'yes') {
			apiRequest.Params.Tabs.push('AFF');
		}
		if(query.chkAffVendors == 'yes') {
			apiRequest.Params.Tabs.push('AFFVENDORS');
		}

		apiService.postGetBinary(_currentPurl, apiRequest).then(okGetExcel, errGetExcel);

		function okGetExcel(r) {
			defer.resolve(r.data);
		}

		function errGetExcel(r) {
			if(r !== null) {
				r = r || {};
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function importAdminSettings(importFile) {

		// params
		if(!!!importFile) {
			throw new Error('affOptionsRepo.importAdminSettings, required: import file');
		}

		_currentPurl = 'admin/settings/import';
		var defer = $q.defer();

		// create multi-part form data
		var fd = new FormData();
		fd.append('context', angular.toJson({})); // stringify JSON into one "context" property
		fd.append('file', importFile);

		apiService.postFile(_currentPurl, fd, false).then(okFileImport, errFileImport);

		function okFileImport(r) {

			// bad upsert response format
			if(!!!r || !!!r.data) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});

		}

		function errFileImport(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else {
				errSvc.warn('Unexpected import error', _currentPurl + 'affOptionsRepo.errFileImport', r.status, utilSvc.http.safeResponse(r));
			}

		}

		return defer.promise;

	}


	/**
	 *    HELPERS
	 */

	function listTypeCode(listType) {
		
		// convert property name into list Type code
		switch(listType) {
			case 'AlwaysSplit':
				return 'AW';
			case 'NeverSplit':
				return 'NV';
			case 'OrderExcls':
				return 'OE';
			case 'OrderPref':
				return 'OI';
			case 'NO340B':
				return 'NB';
			case 'OWNUSEALTDRUGS':
				return 'AN';
			case '340BALTDRUGS':
				return 'TA';
			case "AFFORDEREXCLUSION":
				 return "OE";
			case "NDCOPTEXCLUDELIST":
				return "NE";
			case "GPIINCLUDE":
				return "GL";
			case "GPIEXCLUDE":
				return "GL";
			case 'GENERIC':
				return 'GEN';
			case 'MATCHREVIEWNDCLIST':
				return 'MRI';
			case 'DISPENSEFEELIST':
				return 'DF';
			default:
				throw new Error('affOptionsRepo.listTypeCode, unknown list type: ' + listType);
		}

	}

}
 /**
 *    OPS ASYNC REPOSITORY
 *    handles async job creation, status polling, listing, and retrieval
 */

opsAsyncRepo.$inject = ['$q', 'apiService', 'errSvc', 'utilSvc', 'validSvc'];
angular
.module('espui.core.async')
.factory('opsAsyncRepo', opsAsyncRepo);

/* @ngInject */
function opsAsyncRepo($q, apiService, errSvc, utilSvc, validSvc) {

	var _currentPurl = '';

	var BinaryFileType = {
		None: 0,
		Excel: 1,
		Csv: 2,
		Pdf: 3,
		Zip: 4
	};

	var service = {
		create: createAsyncJob,
		status: getAsyncJobStatus,
		list: getAsyncJobList,
		get: getAsyncJob
	};

	return service;


	/**
	 *    CREATE ASYNC JOB
	 *    creates a new async job; resolves with job entity
	 */
	function createAsyncJob(asyncRequest) {

		_currentPurl = 'ops/async/create';
		var defer = $q.defer();

		if (!!!asyncRequest) {
			throw new Error('opsAsyncRepo.create, async request required');
		}

		apiService.post(_currentPurl, asyncRequest).then(okCreateAsyncJob, errCreateAsyncJob);

		function okCreateAsyncJob(r) {

			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errCreateAsyncJob(r) {
			if(!!!r) {
				defer.reject(null);
			}
			else if(r.status != 422) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				defer.reject(r);
			}
		}

		return defer.promise;
	}


	/**
	 *    GET ASYNC JOB STATUS
	 *    polls for status of a running async job; resolves with entity { Id, Status }
	 */
	function getAsyncJobStatus(id) {

		_currentPurl = 'ops/export/status';
		var defer = $q.defer();

		if (!id) {
			errSvc.warn('opsAsyncRepo.status', 'id required', '', '');
			defer.reject(null);
			return defer.promise;
		}

		var apiRequest = {
			Params: { jobId: String(id) }
		};

		apiService.post(_currentPurl, apiRequest).then(okStatus, errStatus);

		function okStatus(r) {
			if (!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}
			defer.resolve(r.data.Entity);
		}

		function errStatus(r) {
			if (!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 *    GET ASYNC JOB LIST
	 *    retrieves list of async jobs; resolves with array of job entities
	 */
	function getAsyncJobList(query) {

		_currentPurl = 'ops/export/list';
		var defer = $q.defer();

		var apiRequest = {
			Context: {},
			Params: query || {}
		};

		apiService.post(_currentPurl, apiRequest).then(okGetAsyncList, errGetAsyncList);

		function okGetAsyncList(r) {

			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			var items = Array.isArray(r.data.Entity) ? r.data.Entity : [];

			defer.resolve(items);
		}

		function errGetAsyncList(r) {
			defer.reject(errAsyncHandler(r));
		}

		return defer.promise;
	}


	/**
	 *    GET ASYNC JOB
	 *    retrieves async job result file; saves as binary file
	 */
	function getAsyncJob(id, fileName, fileType) {

		_currentPurl = 'ops/export/file';
		var defer = $q.defer();
		fileType = fileType || BinaryFileType.Excel;

		if (!id) {
			errSvc.warn('opsAsyncRepo.get', 'id required', '', '');
			defer.reject(null);
			return defer.promise;
		}

		var apiRequest = {
			Params: {
				jobId: String(id)
			}
		};

		apiService.postGetBinary(_currentPurl, apiRequest).then(okGetAsyncJob, errGetAsyncJob);

		function okGetAsyncJob(r) {
			var blob = new Blob([r.data], { type: binaryFileType(fileType) });
			var name = utilSvc.regex.cleanFilename(fileName || 'export') + binaryFileExtension(fileType);
			window.saveAs(blob, name);
			defer.resolve();
		}

		function errGetAsyncJob(r) {
			defer.reject(errAsyncHandler(r));
		}

		return defer.promise;
	}


	/**
	 *    ERROR HANDLER
	 *    shared handler for async job requests
	 */
	function errAsyncHandler(r) {

		if (!!r) {
			if(r.status == 422) {
				return {errors: r.data.Entity.Fields};
			}
			else {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
		}

		return null;
	}

	// #sym:binaryFileType
	function binaryFileType(fileType) {
		switch (fileType) {
			case BinaryFileType.Excel:
				return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
			case BinaryFileType.Csv:
				return 'text/csv';
			case BinaryFileType.Pdf:
				return 'application/pdf';
			case BinaryFileType.Zip:
				return 'application/zip';
			default:
				throw new Error('binaryFileType, unknown file type: ' + fileType);
		}
	}

	// #sym:binaryFileExtension
	function binaryFileExtension(fileType) {
		switch (fileType) {
			case BinaryFileType.Excel:
				return '.xlsx';
			case BinaryFileType.Csv:
				return '.csv';
			case BinaryFileType.Pdf:
				return '.pdf';
			case BinaryFileType.Zip:
				return '.zip';
			default:
				throw new Error('binaryFileExtension, unknown file type: ' + fileType);
		}
	}

}
 
/**
 *    CHART REPOSITORY
 *    handles all chart data requests by chart type
 */

chartRepo.$inject = ['$rootScope', '$q', 'apiService', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
.module('espui.core.chart')
.factory('chartRepo', chartRepo);

/* @ngInject */
function chartRepo($rootScope, $q, apiService, errSvc, eventSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _pending = null,
		_apiPaging = vmSvc.api.paging();

	// service definition
	var service = {
		load: load,
		reset: reset
	};

	return service;

	function reset() {
		// controller destroy resets pending charts
		_pending = null;
	}

	function load(chartType, chartId, query) {

		// params
		if(!validSvc.isText(chartType) || !validSvc.isText(chartId) || !query) {
			throw new Error('chartRepo.load, chart type, id and query are required for chart: ' + chartId);
		}

		// setup pending
		if(!!!_pending) {
			_pending = {};
		}

		// already pending on this chart?
		if(_pending[chartId]) {
			throw new Error('chartRepo.load, already pending for this chart id: ' + chartId);
		}

		var defer = $q.defer();
		_pending[chartId] = buildChartRequest(chartType, query);

		// call api, embed chart type in callback closure
		apiService.post(_pending[chartId].purl, _pending[chartId].request).then(
			function(r) {okLoad(chartId, r);},
			function(r) {errLoad(chartId, r);}
		);

		function okLoad(chartId, r) {

			// ui reset, ignore response
			if(!!!_pending) {
				defer.reject(null);
				return;
			}

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _pending[chartId].purl + chartId + ' repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// reset pending
			_pending[chartId] = null;

			defer.resolve({
				id: chartId,
				data: r.data.Entity
			});

		}

		function errLoad(chartId, r) {

			// ui reset, ignore response
			if(!!!_pending) {
				defer.reject(null);
				return;
			}

			// reset pending
			_pending[chartId] = null;

			var err = r || {status:0};
			defer.reject({
				id: chartId,
				err:err
			});

		}

		return defer.promise;

	}


	/**
	 *    HELPERS
	 */

	function buildChartRequest(chartType, query) {

		// build api request based on chart type

		switch(chartType) {

			case 'TOP_DRUGS':
				return {
					purl: 'widget/topdrugs',
					request: ceWeeksRequest(query.CE, query.Weeks),
					query: query
				};

			case 'NDC_HIGH_WAC':
				return {
					purl: 'widget/ndchighwac',
					request: ceWeeksRequest(query.CE, query.Weeks),
					query: query
				};

			case 'TOP_UNKNOWN':
				return {
					purl: 'widget/topunknown',
					request: ceRxWeeksRequest(query.CE, query.RX, query.Weeks),
					query: query
				};

			case 'CONTRACT_SAVE':
				return {
					purl: 'widget/savings',
					request: ceWeeksRequest(query.CE, query.Weeks),
					query: query
				};

			case 'DISPENSE_FEES':
				return {
					purl: 'widget/fees',
					request: ceWeeksRequest(query.CE, query.Weeks),
					query: query
				};

			case 'MATCH_ELIG':
				return {
					purl: 'widget/matcheligibility',
					request: ceWeeksRequest(query.CE, query.Weeks),
					query: query
				};

			case 'MATCH_VISIT':
				return {
					purl: 'widget/matchratios',
					request: ceWeeksRequest(query.CE, query.Weeks),
					query: query
				};

			case 'SPLIT_SPEND':
				return {
					purl: 'widget/splitsaving',
					request: ceRxWeeksRequest(query.CE, query.RX, query.Weeks),
					query: query
				};

			case 'WACREM_SPEND':
				return {
					purl: 'widget/wacremspend',
					request: ceRxWeeksRequest(query.CE, query.RX, query.Weeks),
					query: query
				};

			default:
				throw new Error('chartRepo.buildChartRequest, chart type unknown: ' + chartType);
		}

		function ceWeeksRequest(ceid, weeks) {
			return {
				Context: {
					CEID: [ceid]
				},
				Params: {
					Weeks: weeks
				}
			};
		}

		function ceRxWeeksRequest(ceid, rxid, weeks) {
			var result = ceWeeksRequest(ceid, weeks);
			result.Context.RXID = [rxid];
			return result;
		}

	}

}
 
lookupRepo.$inject = ['$rootScope', '$q', 'apiService', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
.module('espui.core.lookup')
.factory('lookupRepo', lookupRepo);


/* @ngInject */
function lookupRepo($rootScope, $q, apiService, errSvc, eventSvc, utilSvc, validSvc, vmSvc) {


	// service definition
	var service = {
		CeInfo: lookupCE,
		RxInfo: lookupRX,
		AffInfo: lookupAff,
		VendorList: lookupVendorList,
		ShareGroupAffList: lookupShareGroup,
		DataSwitchList: lookupDataSwitchList,
		CERefNPIList: lookupCeRefNPIList,
	};

	return service;

	function lookupCE(ceids) {

		if(!Array.isArray(ceids) || ceids.length < 1) {
			throw new Error('lookupRepo.CE, ceids required');
		}

		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: ceids
			}
		};

		apiService.post('ops/lookup/cedisplay', apiRequest).then(okLookupCE, errLookupCE);

		function okLookupCE(r) {

			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', 'lookupCE', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errLookupCE(r) {
			if(!!r) {
				errSvc.warn('Api request failed', 'lookupCE', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function lookupRX(rxids) {

		if(!Array.isArray(rxids) || rxids.length < 1) {
			throw new Error('reportRepo.lookupRX, rxids required');
		}

		var defer = $q.defer();

		var apiRequest = {
			Context: {
				RXID: rxids
			}
		};

		apiService.post('ops/lookup/rxdisplay', apiRequest).then(okLookupRX, errLookupRX);

		function okLookupRX(r) {

			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', 'lookupRX', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errLookupRX(r) {
			if(!!r) {
				errSvc.warn('Api request failed', 'lookupRX', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function lookupAff(ceids, rxids) {

		if(!Array.isArray(ceids) || ceids.length < 1 || !Array.isArray(rxids) || rxids.length < 1) {
			throw new Error('lookupAFF, ceids and rxids required');
		}

		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: ceids,
				RXID: rxids
			}
		};

		apiService.post('ops/lookup/affdisplay', apiRequest).then(okLookupAFF, errLookupAFF);

		function okLookupAFF(r) {

			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', 'lookupAFF', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errLookupAFF(r) {
			if(!!r) {
				errSvc.warn('Api request failed', 'lookupAFF', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	function lookupVendorList() {

		var defer = $q.defer();
		apiService.post('ops/lookup/vendisplay', {}).then(okLookupVEN, errLookupVEN);

		function okLookupVEN(r) {
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', 'lookupRepo.venlist', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errLookupVEN(r) {
			if(!!r) {
				errSvc.warn('Api request failed', 'lookupAFF', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	function lookupDataSwitchList() {

		var defer = $q.defer();
		apiService.post('ops/lookup/dataswitch', {}).then(okLookupDS, errLookupDS);

		function okLookupDS(r) {
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', 'lookupRepo.dataswitch', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errLookupDS(r) {
			if(!!r) {
				errSvc.warn('Api request failed', 'lookupDS', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	function lookupCeRefNPIList() {

		var defer = $q.defer();
		apiService.post('ops/lookup/cereferral', {}).then(okLookupCEref, errLookupCEref);

		function okLookupCEref(r) {
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', 'lookupRepo.cereferral', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errLookupCEref(r) {
			if(!!r) {
				errSvc.warn('Api request failed', 'cereferral', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	function lookupShareGroup(sharegroup) {

		if(!!!sharegroup) {
			throw new Error('lookupShareGroup, sharegroup id required');
		}

		var defer = $q.defer();

		var apiRequest = {
			Context: {
			},
			Params: {
				Id: sharegroup
			}
		};

		apiService.post('ops/lookup/sharegroup', apiRequest).then(oklookupShareGroup, errlookupShareGroup);

		function oklookupShareGroup(r) {

			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', 'lookupAFF', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errlookupShareGroup(r) {
			if(!!r) {
				errSvc.warn('Api request failed', 'lookupAFF', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}
}
 
ndcRepo.$inject = ['$rootScope', '$q', 'apiService', 'errSvc', 'vmSvc', 'utilSvc', 'validSvc'];angular
.module('espui.core.ndc')
.factory('ndcRepo', ndcRepo);

// FUTURE location for NDC list CRUD so its off the affOptionsRepo

/* @ngInject */
function ndcRepo($rootScope, $q, apiService, errSvc, vmSvc, utilSvc, validSvc) {

	// private
	var _currentPurl = '',
		_apiPaging = vmSvc.api.paging();

	// service definition
	var service = {

		// reads
		getListCounts: getListCounts,
		getList: getList,
		getOrderAcctList: getOrderAcctList,
		getCloneToAccounts: getCloneToAccounts,
		getExcel: getExcel,

		// edits
		save: save,
		importFile: importFile,
		updateStatus: updateStatus,
		clone: clone
	};

	return service;


	/**
	 *    GET COUNTS AND LIST
	 */

	function ndcRequest(ctx) {
		// build ndc api request
		// note: converts UI constant friendly name into API code

		var requireCE = false,
			requireRX = false,
			ceid = '',
			rxid = '',
			scope = ctx.listScope,
			listType = '',
			entityId = ctx.EntityId,
			year = 0;

		switch(ctx.key) {
			case 'GLOBAL_EXCLUSION':
				listType = 'GOE';
				scope = 'GL';
				break;
			case 'GLOBAL_OUTER_PACK':
				listType = 'OP';
				scope = 'GL';
				break;
			case 'AFF_OUTER_PACK':
				listType = 'OP';
				scope = 'AF';
				ceid = ctx.CE;
				rxid = ctx.RX;
				requireCE = true;
				requireRX = true;
				break;
			case 'GLOBAL_IRA':
				listType = 'IRA';
				scope = 'GL';
				year = parseInt(ctx.importYear);
				break;
			case 'AFF_IRA':
				listType = 'IRA';
				scope = 'AF';
				ceid = ctx.CE;
				rxid = ctx.RX;
				requireCE = true;
				requireRX = true;
				break;
			case 'GLOBAL_REB':
				listType = 'REB';
				scope = 'GL';
				break;
			case 'AFF_REB':
				listType = 'REB';
				scope = 'AF';
				ceid = ctx.CE;
				rxid = ctx.RX;
				requireCE = true;
				requireRX = true;
				break;
			case 'NON_340B':
				listType = 'NB';
				scope = 'CE';
				ceid = ctx.CE;
				requireCE = true;
				break;
			case 'CE_PRICE':
				listType = 'CB';
				scope = 'CE';
				ceid = ctx.CE;
				requireCE = true;
				break;
			case 'OWNUSE_ALT':
				listType = 'AN';
				scope = 'AF';
				ceid = ctx.CE;
				rxid = ctx.RX;
				requireCE = true;
				requireRX = true;
				break;
			case '340B_ALT':
				listType = 'TA';
				scope = 'AF';
				ceid = ctx.CE;
				rxid = ctx.RX;
				requireCE = true;
				requireRX = true;
				break;
			case 'AFF_ORDER_EXCLUSION':
				listType = 'OE';
				scope = 'AF';
				ceid = ctx.CE;
				rxid = ctx.RX;
				requireCE = true;
				requireRX = true;
				break;
			case 'RX_ORDER_EXCLUSION':
				listType = 'OE';
				scope = 'RX';
				rxid = ctx.RX;
				requireRX = true;
				break;
			case 'VERISAVE_NEVER_SWITCH_TO':
				listType = 'NST';
				scope = 'AF';
				ceid = ctx.CE;
				rxid = ctx.RX;
				requireCE = true;
				requireRX = true;
				break;
			case 'VERISAVE_NEVER_SWITCH_TO_RX':
				listType = 'NST';
				scope = 'RX';
				rxid = ctx.RX;
				requireRX = true;
				break;
			case 'VERISAVE_NEVER_SWITCH_FROM':
				listType = 'SE';
				scope = 'AF';
				ceid = ctx.CE;
				rxid = ctx.RX;
				requireCE = true;
				requireRX = true;
				break;
			case 'VERISAVE_NEVER_SWITCH_FROM_RX':
				listType = 'SE';
				scope = 'RX';
				rxid = ctx.RX;
				requireRX = true;
				break;
			case 'VERISAVE_PREF':
				listType = 'SP';
				scope = 'AF';
				ceid = ctx.CE;
				rxid = ctx.RX;
				requireCE = true;
				requireRX = true;
				break;
			case 'VERISAVE_PREF_RX':
				listType = 'SP';
				scope = 'RX';
				rxid = ctx.RX;
				requireRX = true;
				break;	
			case 'MATCH_REVIEW_INCLUSION':
				listType = 'MRI';
				scope = 'AF';
				ceid = ctx.CE;
				rxid = ctx.RX;
				requireCE = true;
				requireRX = true;
				break;
			case 'MATCH_EXCLUSION':
				listType = 'ME';
				scope = 'AF';
				ceid = ctx.CE;
				rxid = ctx.RX;
				requireCE = true;
				requireRX = true;
				break;
			case 'DISPENSE_FEE':
				listType = 'DF';
				scope = 'AF';
				ceid = ctx.CE;
				rxid = ctx.RX;
				requireCE = true;
				requireRX = true;
				break;
			case 'ALWAYS_SPLIT':
			case 'NEVER_SPLIT':
				listType = ctx.key == 'ALWAYS_SPLIT' ? 'AW' : 'NV';
				scope = 'OA';
				ceid = ctx.CE;
				rxid = ctx.RX;
				requireCE = true;
				requireRX = true;
				break;
			case 'ALWAYS_ORDER':
			case 'NEVER_ORDER':
				listType = ctx.key == 'ALWAYS_ORDER' ? 'OI' : 'OE';
				scope = 'OA';
				ceid = ctx.CE;
				rxid = ctx.RX;
				requireCE = true;
				requireRX = true;
				break;
			case 'ISP_ORDER':
				listType = 'ISP';
				scope = 'OA';
				ceid = ctx.CE;
				rxid = ctx.RX;
				requireCE = true;
				requireRX = true;
				break;
			case 'NDC_OPTIMIZER_NDC_EXCLUSION':
				listType = 'NE';
				scope = 'RX';
				rxid = ctx.RX;
				requireRX = true;
				break;
			case 'NDC_OPTIMIZER_GPI_EXCLUSION':
				listType = 'GE';
				scope = 'RX';
				rxid = ctx.RX;
				requireRX = true;
				break;
			case 'NDC_OPTIMIZER_GPI_INCLUSION':
				listType = 'GI';
				scope = 'RX';
				rxid = ctx.RX;
				requireRX = true;
				break;
			case 'CENTRAL_FILL':
				listType = 'CF';
				scope = 'RX';
				rxid = ctx.RX;
				requireRX = true;
				break;
			case 'GENERIC_RX':
				listType = 'GEN';
				scope = 'RX';
				rxid = ctx.RX;
				requireRX = true;
				break;
			case 'SPECIALTY_RX':
				listType = 'SPE';
				scope = 'RX';
				rxid = ctx.RX;
				requireRX = true;
				break;
			case 'TPA_EXCLUSION':
				listType = 'EX';
				scope = 'RX';
				rxid = ctx.RX;
				requireRX = true;
				break;
			default:
				throw new Error('ndcRepo.ndcRequest, unknown UI key: ' + ctx.key);
		}

		// CE/RX required
		if(requireCE && !validSvc.isCE(ceid)) {
			throw new Error('ndcRepo.ndcRequest, CEID required');
		}
		if(requireRX && !validSvc.isRX(rxid)) {
			throw new Error('ndcRepo.ndcRequest, RXID required');
		}

		return {
			Context: {
				CEID: requireCE ? [ceid] : [],
				RXID: requireRX ? [rxid] : []
			},
			Params: {
				Scope: scope,
				ListType: listType,
				Entity: entityId,
				Year: year
			}
		};
	}

	function listCountsVM(searchType, r) {
		// convert API list constants to more friendly constants (used in the controller)
		
		r = r || {};
		var result = {
			EntityId: r.Id, // api now returns entity Id for Global, CE, AFF searches
			items:[] 
		};
		
		// helper
		function addCount(items, count, uiKey, title) {
			if (!!count && count.Use) {
				items.push({
					key: uiKey,
					title: title,
					count: count.Count,
				});
			}
			return items;
		}

		switch(searchType) {
			case 'GLOBAL':
				var g = r.Global || {};
				result.items = addCount([], g.GOE, 'GLOBAL_EXCLUSION', 'Global Exclusion');
				result.items = addCount(result.items, g.OP, 'GLOBAL_OUTER_PACK', 'Global Inner/Outer Pack');
				result.items = addCount(result.items, g.IRA, 'GLOBAL_IRA', 'Global IRA');
				result.items = addCount(result.items, g.REB, 'GLOBAL_REB', 'Global Manufacturer Rebate');
				break;
			case 'CE':
				var ce = r.CE || {};
				result.items = addCount([], ce.NB, 'NON_340B', 'Non 340B Drugs', '');
				result.items = addCount(result.items, ce.CB, 'CE_PRICE', '340B Ceiling Price');
				break;
			case 'RX':
				var rx = r.RX || {};
				result.items = addCount([], rx.OE, 'RX_ORDER_EXCLUSION', 'Order Exclusion');
				result.items = addCount(result.items, rx.SE, 'VERISAVE_NEVER_SWITCH_FROM_RX', 'Verisave Never Switch From');
				result.items = addCount(result.items, rx.NST, 'VERISAVE_NEVER_SWITCH_TO_RX', 'Verisave Never Switch To');
				result.items = addCount(result.items, rx.SP, 'VERISAVE_PREF_RX', 'Verisave Preferred');
				result.items = addCount(result.items, rx.NE, 'NDC_OPTIMIZER_NDC_EXCLUSION', 'NDC Optimizer NDC Exclusion');
				result.items = addCount(result.items, rx.GE, 'NDC_OPTIMIZER_GPI_EXCLUSION', 'NDC Optimizer GPI Exclusion');
				result.items = addCount(result.items, rx.GI, 'NDC_OPTIMIZER_GPI_INCLUSION', 'NDC Optimizer GPI Inclusion');
				result.items = addCount(result.items, rx.CF, 'CENTRAL_FILL', 'Central Fill NDC List');
				result.items = addCount(result.items, rx.GEN, 'GENERIC_RX', 'Generic NDC List');
				result.items = addCount(result.items, rx.SPE, 'SPECIALTY_RX', 'Specialty NDC List');
				result.items = addCount(result.items, rx.EX, 'TPA_EXCLUSION', 'TPA Exclusion List');
				break;
			case 'AFF':
				var aff = r.AFF || {};
				result.items = addCount([], aff.OE, 'AFF_ORDER_EXCLUSION', 'Order Exclusion');
				result.items = addCount(result.items, aff.SE, 'VERISAVE_NEVER_SWITCH_FROM', 'Verisave Never Switch From');
				result.items = addCount(result.items, aff.NST, 'VERISAVE_NEVER_SWITCH_TO', 'Verisave Never Switch To');
				result.items = addCount(result.items, aff.SP, 'VERISAVE_PREF', 'Verisave Preferred');
				result.items = addCount(result.items, aff.MRI, 'MATCH_REVIEW_INCLUSION', 'Match Review Inclusion');
				result.items = addCount(result.items, aff.ME, 'MATCH_EXCLUSION', 'Match Exclusion');
				result.items = addCount(result.items, aff.OP, 'AFF_OUTER_PACK', 'Inner/Outer Pack');
				result.items = addCount(result.items, aff.DF, 'DISPENSE_FEE', 'Dispense Fee');
				result.items = addCount(result.items, aff.AN, 'OWNUSE_ALT', 'Own Use Alternate Drugs', '');
				result.items = addCount(result.items, aff.TA, '340B_ALT', '340B Alternate Drugs', '');
				result.items = addCount(result.items, aff.IRA, 'AFF_IRA', 'IRA Opt-Out');
				result.items = addCount(result.items, aff.REB, 'AFF_REB', 'Manufacturer Rebate Opt-In');
				break;
			case 'VEN':
				var ven = r.VEN || {};
				result.items = addCount([], ven.AW, 'ALWAYS_SPLIT', 'Always Split');
				result.items = addCount(result.items, ven.NV, 'NEVER_SPLIT', 'Never Split');
				result.items = addCount(result.items, ven.OI, 'ALWAYS_ORDER', 'Always Order');
				result.items = addCount(result.items, ven.OE, 'NEVER_ORDER', 'Never Order');
				result.items = addCount(result.items, ven.ISP, 'ISP_ORDER', 'ISP Order');
				break;
			default:
				throw new Error('ndcRepo.listCountsVM, unknown search type: ' + searchType);
		}

		return result;
	}

	function getListCounts(q) {
		var ceid = q.CE.val,
			rxid = q.RX.val,
			venacct = q.VEN.val;

		var req = {
			Context: {
				CEID: [],
				RXID: []
			},
			Params: {
				Entity: '',
				Scope: '',
				ItemCode: ''
			}
		};

		switch(q.SearchType) {
			case 'GLOBAL':
				req.Params.Scope = 'GL';
				break;
			case 'CE':
				if(!validSvc.isCE(ceid)) {
					throw new Error('ndcRepo.getListCounts, CE required');
				}
				req.Context.CEID.push(q.CE.val);
				req.Params.Scope = 'CE';
				break;
			case 'RX':
				if(!validSvc.isRX(rxid)) {
					throw new Error('ndcRepo.getListCounts, RX required');
				}
				req.Context.RXID.push(rxid);
				req.Params.Scope = 'RX';
				break;
			case 'AFF':
			case 'VEN':
				if(!validSvc.isCE(ceid) || !validSvc.isRX(rxid)) {
					throw new Error('ndcRepo.getListCounts, CE and RX required');
				}
				req.Context.CEID.push(ceid);
				req.Context.RXID.push(rxid);
				req.Params.Scope = 'AF';

				// add vendor acct if needed
				if(q.SearchType == 'VEN') {
					req.Params.Scope = 'OA';
					if(!validSvc.isText(venacct) || venacct == 'NONE') {
						throw new Error('ndcRepo.getListCounts, VEN required');
					}
					req.Params.Entity = venacct;
				}
				break;
			default:
				throw new Error('ndcRepo.getListCounts, unknown ndc search type');
		}

		_currentPurl = 'ops/ndcex/count';
		var defer = $q.defer();

		apiService.post(_currentPurl, req).then(okListCount, errListCount);

		function okListCount(r) {
			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + ' repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			defer.resolve(listCountsVM(q.SearchType, r.data.Entity));
		}

		function errListCount(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	function getList(ctx) {
		var apiRequest = ndcRequest(ctx);
		
		// add list paging and INACTIVE param
		apiRequest.Params.UseInactiveStatus = true;
		apiRequest.Paging = {
			Page: 1,
			Size: 10000
		};
		apiRequest.SortBy = [utilSvc.sorting.sortByApiStyle('ItemCode')];

		_currentPurl = 'ops/ndcex/list';
		var defer = $q.defer();

		apiService.post(_currentPurl, apiRequest).then(okList, errList);

		function okList(r) {
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + ' repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			defer.resolve({
				Items : r.data.Entity, 
				TooMany: r.data.Entity.length > 10000
			});
		}

		function errList(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	function getOrderAcctList(ceid, rxid) {

		// params
		if(!validSvc.isCE(ceid) || !validSvc.isRX(rxid)) {
			throw new Error('ndcRepo.getOrderAcctList, ceid and rxid required');
		}

		_currentPurl = 'ops/affs/vendor/list';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid],
				RXID: [rxid]
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('Id')]
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okAcctList, errAcctList);

		function okAcctList(r) {

			// custom response validator
			if(!!r && r.status == 200 && !!r.data && !!r.data.Entity) {
				var items = Array.isArray(r.data.Entity.Items) ? r.data.Entity.Items : [];
				defer.resolve(items);
			}
			else {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
		}

		function errAcctList(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + ' repo', '', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	function getCloneToAccounts(ctx) {
		var apiRequest = ndcRequest(ctx);		
		apiRequest.Paging = {
			Page: 1,
			Size: 100000
		};
		apiRequest.SortBy = [utilSvc.sorting.sortByApiStyle('CEID')];

		_currentPurl = 'ops/ndcex/vendor/cloneto';
		var defer = $q.defer();

		apiService.post(_currentPurl, apiRequest).then(okGetCloneTo, errGetCloneTo);

		function okGetCloneTo(r) {
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + ' repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			defer.resolve({
				Items: r.data.Entity,
				TooMany: r.data.Entity.length > 100000
			});
		}

		function errGetCloneTo(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	
	/**
	 * 		EDITS
	 */

	function ndcEditRequest(ctx) {
		// convert list request into an edit request
		var apiRequest = ndcRequest(ctx);
		apiRequest.Entity = apiRequest.Params; // move Params to Entity
		apiRequest.Params = undefined;
		apiRequest.Entity.Type = apiRequest.Entity.ListType; // move ListType to Type
		apiRequest.Entity.ListType = undefined;
		apiRequest.Entity.EntityId = apiRequest.Entity.Entity; // move Entity to EntityId
		apiRequest.Entity.Entity = undefined;

		return apiRequest;
	}

	function save(ctx, m) {
		// params
		if(!validSvc.isText(m.ItemCode)) {
			throw new Error('ndcRepo.save, ndc required');
		}
		if(ctx.editAltItemCode && !validSvc.isText(m.AltItemCode)) {
			throw new Error('ndcRepo.save, alt ndc required');
		}

		if(ctx.editMargin && !validSvc.isNumber(m.Margin)) {
			throw new Error('ndcRepo.save, dollar margin required');
		}
		
		if(ctx.editAutoIneligibleDays && !!m.AutoIneligibleDays && !validSvc.isNumber(m.AutoIneligibleDays)) {
			throw new Error('ndcRepo.save, auto ineligible days required');
		}

		if(ctx.editDispenseFee && !validSvc.isNumber(m.Margin)) {
			throw new Error('ndcRepo.save, dollar fee required');
		}

		var apiRequest = ndcEditRequest(ctx);
		apiRequest.Entity.ItemCode = m.ItemCode;
		apiRequest.Entity.GPI = m.GPI;
		if(ctx.editAltItemCode) {
			apiRequest.Entity.ReplaceItemCode = m.AltItemCode;
		}
		if(ctx.editMargin) {
			apiRequest.Entity.Value = m.Margin;
			apiRequest.Entity.ValueMeaning = m.ValueMeaning;
			apiRequest.Entity.AccountType = m.AccountType;
		}
		if(ctx.editDispenseFee) {
			apiRequest.Entity.Value = m.Margin;
			apiRequest.Entity.VariablePercentage = m.VariablePercentage;
			apiRequest.Entity.MinDispFee = m.MinDispFee;
			apiRequest.Entity.MaxDispFee = m.MaxDispFee;
		}
		if(ctx.editAutoIneligibleDays) {
			apiRequest.Entity.AutoIneligibleDays = parseInt(m.AutoIneligibleDays);
		}
		if(ctx.editReportingProps) {
			apiRequest.Entity.ReportingPlatform = m.ReportingPlatform;
			apiRequest.Entity.ReportType = m.ReportType;
		}

		if(ctx.editCeilingPrice) {
			if(!validSvc.isNumber(m.CeilingPrice)) {
				throw new Error('ndcRepo.save, ceiling price required');
			}
			apiRequest.Entity.Value = m.CeilingPrice;
			apiRequest.Entity.ValueMeaning = 'DOLLAR';
		}

		_currentPurl = 'ops/ndcex/add';
		var defer = $q.defer();

		apiService.post(_currentPurl, apiRequest).then(okAddNdc, errAddNdc);

		function okAddNdc(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errAddNdc(r) {
			defer.reject(handleErrResult(r, _currentPurl, parse422FirstField));
		}

		return defer.promise;
	}

	function updateStatus(ctx, ndc, ndcAlt, status) {
		// params
		if(!validSvc.isText(ndc)) {
			throw new Error('ndcRepo.updateStatus, ndc required');
		}
		if(status != 'ACTIVE' && status != 'INACTIVE') {
			throw new Error('ndcRepo.updateStatus, status unknown: ' + status);
		}
		
		var apiRequest = ndcEditRequest(ctx);
		apiRequest.Entity.ItemCode = ndc;
		apiRequest.Entity.ObjectState = status;

		// add alternate NDC (part of the key)
		if(ctx.editAltItemCode) {
			apiRequest.Entity.ReplaceItemCode = ndcAlt;
		}
		

		_currentPurl = 'ops/ndcex/status';
		var defer = $q.defer();

		apiService.post(_currentPurl, apiRequest).then(okStatus, errStatus);

		function okStatus(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errStatus(r) {
			defer.reject(handleErrResult(r, _currentPurl, parse422FirstField));
		}

		return defer.promise;
	}

	function clone(ctx, toCE, toRX, toAcct) {
		// params
		switch(ctx.listScope) {
			case 'RX':
				if(!validSvc.isRX(ctx.RX) || !validSvc.isRX(toRX)) {
					throw new Error('ndcRepo.clone, from/to RX required');
				}
				break;
			default:
				if(!validSvc.isCE(ctx.CE) || !validSvc.isCE(toCE)) {
					throw new Error('ndcRepo.clone, from/to CE required');
				}
				break;
		}
		
		var apiRequest = ndcRequest(ctx);
		apiRequest.Params.ToCE = toCE;
		apiRequest.Params.ToRX = toRX;
		apiRequest.Params.ToOrderAcct = toAcct;

		_currentPurl = 'ops/ndcex/clone';
		var defer = $q.defer();

		apiService.post(_currentPurl, apiRequest, false, true).then(okClone, errClone);

		function okClone(r) {
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}
			defer.resolve({});
		}

		function errClone(r) {
			defer.reject(handleErrResult(r, _currentPurl));
		}

		return defer.promise;
	}


	function handleErrResult(r, purl, fnParse422) {
		if(r === null) {
			// already handled upstream
			return null;
		}
		else if(!validSvc.httpUpsertErrResp(r)) {
			// bad error response format
			errSvc.warn('Api request failed with unknown error response format', purl + ' repo', r.status, utilSvc.http.safeResponse(r));
			return null;
		}
		else if(r.status == 409) {
			// 409 error is a duplicate or timeout
			//r.msg = !!r.timeout ? 'timeout' : 'ndc already exists';
			r.msg = !!r.timeout ? 'timeout' : r.data.error;
			return r;
		}
		else if(r.status == 422 && !!fnParse422) {
			return fnParse422(r);
		}
		else {
			throw new Error(_currentPurl + ', unexpected error result');
		}
	}

	function parse422FirstField(r) {
		r = r || {};
		if(r.status == 422 && !!r.data && !!r.data.Entity && Array.isArray(r.data.Entity.Fields) && r.data.Entity.Fields.length > 0) {
			r.msg = r.data.Entity.Fields[0].Rule;
		}
		return r;
	}


	/**
	 *    EXCEL
	 *    file created on api server, expecting a binary file stream instead of JSON
	 */

	function getExcel(ctx) {
		// params
		if(!!!ctx) {
			throw new Error('ndcRepo.getExcel, context required');
		}
		
		var apiRequest = ndcRequest(ctx); // excel uses Params
		_currentPurl =  'ops/ndcex/export';
		var defer = $q.defer();

		apiService.postGetBinary(_currentPurl, apiRequest).then(okExcel, errExcel);
		
		function okExcel(r) {
			defer.resolve(r.data);
		}

		function errExcel(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 *    NDC FILE IMPORT
	 */

	function importFile(ctx, importFile) {
		// params
		if(!!!importFile) {
			throw new Error('ndcRepo.importFile, file required');
		}
		
		var apiRequest = ndcRequest(ctx); // import uses Params
		_currentPurl =  'ops/ndcex/import';
		var defer = $q.defer();

		// create multi-part form data
		var fd = new FormData();
		fd.append('context', angular.toJson(apiRequest)); // stringify JSON into one "context" property
		fd.append('file', importFile);

		apiService.postFile(_currentPurl, fd, false,false,true).then(okFileImport, errFileImport);

		function okFileImport(r) {
			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}
			r.data.Entity.status = 200;
			defer.resolve(r.data.Entity);
		}

		function errFileImport(r) {
			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(r.status == 409 && !!r.data) {
				defer.reject(r);
			}
			else if(r.status == 422 && !!r.data && !!r.data.Entity) {
				r.data.Entity.status = 422;
				defer.resolve(r.data.Entity);
			}
			else {
				errSvc.error('Unexpected error', _currentPurl + 'ndcRepo.errFileImport', r.status, utilSvc.http.safeResponse(r));
			}
		}

		return defer.promise;
	}


	/**
	 *    HELPERS
	 */

	function listTypeCode(listType) {
		
		// convert property name into list Type code
		switch(listType) {
			case 'AlwaysSplit':
				return 'AW';
			case 'NeverSplit':
				return 'NV';
			case 'OrderExcls':
				return 'OE';
			case 'OrderPref':
				return 'OI';
			case 'NO340B':
				return 'NB';
			case 'OWNUSEALTDRUGS':
				return 'AN';
			case '340BALTDRUGS':
				return 'TA';
			case "AFFORDEREXCLUSION":
				 return "OE";
			case "NDCOPTEXCLUDELIST":
				return "NE";
			case "GPIINCLUDE":
				return "GL";
			case "GPIEXCLUDE":
				return "GL";
			case 'GENERIC':
				return 'GEN';
			case 'SPECIALTY':
				return 'SPE';
			default:
				throw new Error('ndcRepo.listTypeCode, unknown list type: ' + listType);
		}

	}

}
 
/**
 *    USER PREFERENCES REPOSITORY
 *    accesses user preferences
 */

prefsRepo.$inject = ['$q', 'apiService', 'validSvc', 'utilSvc', 'errSvc'];
angular
.module('espui.core.prefs')
.factory('prefsRepo', prefsRepo);

/* @ngInject */
function prefsRepo($q, apiService, validSvc, utilSvc, errSvc) {

	var _pending = {},
		_currentPurl = '';

	var service = {
		save: save,
		saveTableView: saveTableView,
		savedReports: savedReports,
		setCurrentTableView: setCurrentTableView,
		getAlertInfo: getAlertInfo
	};

	return service;


	/**
	 *    PUBLIC METHODS
	 */

	function save(prefType, prefStringVal) {

		// save user pref into Profile array

		// params
		if((prefType != 'DASHBOARD' && prefType != 'FILTERSWAP' && prefType != 'TABLEVIEW' && prefType != 'ADMIN' && prefType != 'SAVEDREPORTS') || !validSvc.isText(prefStringVal)) {
			throw new Error('prefsRepo.save, prefType unknown: ' + prefType);
		}

		var defer = $q.defer();
		_currentPurl = 'user/myaccount/prefsave';

		var apiRequest = {
			Entity: {
				Prefs: [{Type:prefType, Value: prefStringVal }]
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okSavePrefs, errSavePrefs);

		function okSavePrefs(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errSavePrefs(r) {

			if(!!r) {
				errSvc.error('Unexpected api error', 'prefsRepo/' + _currentPurl, r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);

		}

		return defer.promise;

	}


	/**
	 *    CUSTOM TABLE VIEWS
	 */

	function saveTableView(tblView) {

		// get latest TABLEVIEW prefs from db, then upsert this key/val

		// params
		if(!!!tblView || !validSvc.isText(tblView.name) || !Array.isArray(tblView.views) || !validSvc.isText(tblView.current)) {
			throw new Error('prefsRepo.saveTableView, name, views and current id required');
		}

		var defer = $q.defer();

		_pending = tblView;

		// first get latest prefs from db
		apiService.getUserPrefs().then(okUserPrefs, errSaveTableView);

		function okUserPrefs(r) {

			var userPrefs = utilSvc.user.parseLoginProfile({Profile:r}),
				saveKey = _pending.name,
				foundKey = false;
			var views = userPrefs.TableViews;

			// find this key in table views
			for(var i = 0; i < views.length; i++) {
				if(views[i].name == saveKey) {
					foundKey = true;
					views[i] = _pending;
					break;
				}
			}
			if(!foundKey) {
				views.push(_pending);
			}

			save('TABLEVIEW', angular.toJson(views)).then(okSaveTableView, errSaveTableView);

		}

		function okSaveTableView() {
			defer.resolve({});
		}

		function errSaveTableView(r) {
			if(!!r) {
				errSvc.warn('Api request failed', 'prefsRepo.saveTableView', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}


		return defer.promise;

	}

	function setCurrentTableView(storageKey, current) {

		// get latest TABLEVIEW prefs from db, then set the current view chosen by user

		// params
		if(!validSvc.isText(storageKey) || !validSvc.isText(current)) {
			throw new Error('prefsRepo.setCurrentTableView, key / current id required');
		}

		var defer = $q.defer();

		_pending = {
			name: storageKey,
			current: current
		};

		// first get latest prefs from db
		apiService.getUserPrefs().then(okUserPrefs, errSetTableView);

		function okUserPrefs(r) {

			var userPrefs = utilSvc.user.parseLoginProfile({Profile:r}),
				saveKey = _pending.name,
				foundKey = false;
			var views = userPrefs.TableViews;

			// find this key in table views
			for(var i = 0; i < views.length; i++) {
				if(views[i].name == saveKey) {
					foundKey = true;
					views[i].current = _pending.current;
					break;
				}
			}

			save('TABLEVIEW', angular.toJson(views)).then(okSetTableView, errSetTableView);

		}

		function okSetTableView() {
			defer.resolve({});
		}

		function errSetTableView(r) {
			if(!!r) {
				errSvc.warn('Api request failed', 'prefsRepo.setTableView', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}


		return defer.promise;

	}


	/**
	 *    SAVED REPORTS
	 */

	function savedReports(name, version, reports) {

		// get latest SAVEDREPORTS prefs from db, then upsert this key/val

		// params
		if(!validSvc.isText(name) || !validSvc.isInteger(version) || !Array.isArray(reports)) {
			throw new Error('prefsRepo.savedReports, name, verion and reports required');
		}

		var defer = $q.defer();

		_pending = {
			name: name,
			version: version,
			reports: reports
		};

		// first get latest prefs from db
		apiService.getUserPrefs().then(okUserPrefs, errSavedRpt);

		function okUserPrefs(r) {

			var userPrefs = utilSvc.user.parseLoginProfile({Profile:r}),
				saveKey = _pending.name,
				foundKey = false;
			var reports = userPrefs.SavedReports;

			// find this key in all reports
			for(var i = 0; i < reports.length; i++) {
				if(reports[i].name == saveKey) {
					foundKey = true;
					reports[i] = _pending;
					break;
				}
			}
			if(!foundKey) {
				reports.push(_pending);
			}

			save('SAVEDREPORTS', angular.toJson(reports)).then(okSavedRpt, errSavedRpt);

		}

		function okSavedRpt() {
			defer.resolve({});
		}

		function errSavedRpt(r) {
			if(!!r) {
				errSvc.warn('Api request failed', 'prefsRepo.savedReports', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}


		return defer.promise;

	}


	/**
	 *    IN-APP ALERTS
	 */

	function getAlertInfo() {

		var defer = $q.defer();
		apiService.post('ops/monitor/alert/summary', {keepTimestamp:true}).then(okGetAlerts, errGetAlerts);

		function okGetAlerts(r) {

			// bad upsert response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', 'ops/monitor/alert', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			//var alerts = Array.isArray(r.data.Entity) ? r.data.Entity : [];
			defer.resolve(r.data.Entity);
		}

		function errGetAlerts(r) {
			// silent fail, never elevate alert status checks
			defer.reject(null);
		}

		return defer.promise;
	}
}
 
/**
 *    SESSION REPOSITORY
 *    holds all angular session in-memory and inside windows session (if available)
 */

sessionRepo.$inject = ['$window', 'validSvc', 'utilSvc'];
angular
.module('espui.core.session')
.factory('sessionRepo', sessionRepo);

/* @ngInject */
function sessionRepo($window, validSvc, utilSvc) {

	var _session = newSession(),
		_userInfo = null,
		_hasStore = false;

	var service = {
		valid: valid,
		hasStore: hasStore,
		set: set,
		get: get,
		clear: clear,
		clearKey: clearKey,
		parseLoginToUserObj: parseLoginToUserObj,
		hasLocalStorage: hasLocalStorage,
		setLocalStoreKey: setLocalStoreKey,
		getLocalStoreKey: getLocalStoreKey,
		removeLocalStoreKey: removeLocalStoreKey,
		clearLocalStore: clearLocalStore
	};

	init();

	return service;


	/**
	 *    INIT
	 */

	function newSession() {

		// always populate an empty token property
		return {
			token: ''
		};

	}

	function init() {

		_session = newSession();
		_userInfo = null;

		// check for browser session storage
		_hasStore = !!$window.sessionStorage;
		if(_hasStore) {
			var getEsp = loadStore('espui');
			if(getEsp !== null) {
				_session = getEsp;
			}
		}

	}


	/**
	 *    PUBLIC METHODS
	 */

	function hasStore() {
		return _hasStore;
	}

	function valid() {

		// valid session has a token
		return !!_session && validSvc.isText(_session.token) && !!_userInfo;

	}

	function set (keyName, newVal) {

		switch(keyName) {

			case 'User':
				_userInfo = newVal;
				break;

			case 'deepLink':
			case 'token':
				// save to espui token
				_session[keyName] = newVal;
				if(_hasStore) {
					$window.sessionStorage.setItem('espui', angular.toJson(_session));
				}
				break;

			default:
				// anything else has its own session store key (upgrade, viewstate, tblview, ...)
				if(_hasStore && validSvc.isText(keyName) && !!newVal) {
					$window.sessionStorage.setItem(keyName, angular.toJson(newVal));
				}
		}

	}

	function get (keyName, ctx) {

		switch(keyName) {

			case 'User':
				return _userInfo;

			case 'deepLink':
			case 'token':
				return _session[keyName];

			default:
				// anything else has its own session store key (upgrade, viewstate, tblview, ...)
				if(!_hasStore || !validSvc.isText(keyName)) {
					return null;
				}

				var keyVal = loadStore(keyName);
				if(keyVal === null) {
					return null;
				}

				// match incoming context to saved context
				if(!!ctx && !!keyVal.ctx) {
					for (var propName in ctx) {
						if(ctx.hasOwnProperty(propName)) {
							if(!keyVal.ctx.hasOwnProperty(propName) || ctx[propName] !== keyVal.ctx[propName]) {
								// ctx is old, clear keyName, return nothing
								clearKey(keyName);
								return null;
							}
						}
					}
				}

				// success
				return keyVal;
		}

	}

	function clear() {

		// clear the entire session storage

		_session = newSession();
		_userInfo = null;

		if(_hasStore) {
			try {
				$window.sessionStorage.clear();
			}
			catch(err) {
				// do nothing
			}
		}

	}

	function clearKey(key) {

		// clear a single session store key

		if(_hasStore && validSvc.isText(key)) {
			try {
				$window.sessionStorage.removeItem(key);
			}
			catch(err) {
				// do nothing
			}
		}

	}


	/**
	 * 		LOCAL STORAGE
	 */

	function hasLocalStorage() {
		try {
			if(setLocalStoreKey('test', {id:'test'})) {
				var testVal = getLocalStoreKey('test');
				if(!!testVal && testVal.id == 'test') {
					$window.localStorage.removeItem('test');
					return true;
				}
			}
		}
		catch(err) {
			// do nothing on catch
			console.log(err);
		}
		return false;
	}

	function setLocalStoreKey(keyName, val) {
		if(!!$window.localStorage && validSvc.isText(keyName) && !!val) {
			$window.localStorage.setItem(keyName, JSON.stringify(val));
			return true;
		}
		return false;
	}

	function getLocalStoreKey(keyName) {
		if(!!$window.localStorage && validSvc.isText(keyName)) {
			return JSON.parse($window.localStorage.getItem(keyName));
		}
		return null;
	}

	function removeLocalStoreKey(keyName) {
		if(!!$window.localStorage && validSvc.isText(keyName)) {
			$window.localStorage.removeItem(keyName);
		}
	}

	function clearLocalStore() {
		if(!!$window.localStorage) {
			$window.localStorage.clear();
		}
	}

	/**
	 *    PARSE USER OBJECT
	 */

	function parseLoginToUserObj(usr) {

		// convert login User Json to session User object

		if(!validLoginJson(usr)) {
			return;
		}

		// parse user entities
		var primaryCERX = parsePrimaryCERX(usr.UserType, usr.Affiliations);
		var userPrefs = utilSvc.user.parseLoginProfile(usr);

		// store table views and saved reports prefs in session instead of rootscope memory
		savePrefsToSession(userPrefs.TableViews);
		savePrefsToSession(userPrefs.SavedReports);

		// save user info to session
		_userInfo = {
			Impersonate: usr.Impersonate,
			CoBrand: validSvc.isText(usr.CoBrand) ? usr.CoBrand.toLowerCase() : 'verity',
			UserName: usr.UserName,
			Status: usr.Status,
			PwdDaysToExpire: usr.PwdDaysToExpire,
			TwoFactor: !!usr.TwoFactor,
			Tou: !!usr.Tou,
			IpValid: !!usr.IpValid,
			ShowReleaseNote: !!usr.ShowReleaseNote,
			ChallengeSet: !!usr.ChallengeSet,
			Fname: usr.FirstName,
			Lname: usr.LastName,
			Company: !!usr.Company ? usr.Company : '',
			Type: usr.UserType,
			CE: primaryCERX.ceid,
			RX: primaryCERX.rxid,
			Features: usr.Features,
			AffList: usr.Affiliations,
			AffRxLookup: usr.AffilRxLookup,
			AffCeLookup: usr.AffilCeLookup,
			ManufacturerExclusionList: usr.ManufacturerExclusionList,
			Dashboard: userPrefs.Dashboard,
			FilterSwap: userPrefs.FilterSwap,
			AdminPrefs: !!userPrefs.AdminPrefs ? userPrefs.AdminPrefs : {},
			VeriSaveOnly: !!usr.VeriSaveOnly,
			IsAuthorizer: !!usr.IsAuthorizer,
			IsVhub: !!usr.IsVhub,
			UsersToReview: Array.isArray(usr.UsersToReview) ? usr.UsersToReview : [],
			UsersToReviewDueDate: validSvc.isDate(usr.UsersToReviewDueDate) ? usr.UsersToReviewDueDate : null,
			Timestamp: Date.now().toString()
		};

	}


	/**
	 *    HELPERS
	 */

	function savePrefsToSession(items) {

		// save preferences into browser session store instead of in-memory rootScope

		if(!_hasStore) {
			return;
		}

		try {
			items = Array.isArray(items) ? items : [];
			for(var i = 0; i < items.length; i++) {
				$window.sessionStorage.setItem(items[i].name, angular.toJson(items[i]));
			}
		}
		catch(err) {
			// do nothing
		}

	}

	function loadStore(storeKey) {

		var result = null;

		try {
			var windowSession = $window.sessionStorage.getItem(storeKey);
			if(validSvc.isText(windowSession)) {
				// all session keys will be json
				result = angular.fromJson(windowSession);
			}
		}
		catch(err) {
			// do nothing
			result = null;
		}

		return result;
	}

	function validLoginJson(usr) {

		var result = '';

		// user check
		if(!!!usr || !!!usr.FirstName || !!!usr.LastName || !!!usr.UserType) {
			result = 'Entity.User object needs first/last name, id and Type';
		}
		else if(!Array.isArray(usr.Features) || usr.Features.length < 1) {
			// features check
			result = 'Entity.User.Features is a required array with length > 0';
		}
		else if(!Array.isArray(usr.Affiliations) || usr.Affiliations.length < 1) {
			// aff list check
			result = 'Entity.User.Affiliations is a required array with length > 0';
		}
		else if(!!!usr.AffilRxLookup || !!!usr.AffilCeLookup) {
			// aff rx/ce lookup check
			result = 'Entity.User.AffilRxLookup and AffilCeLookup are required';
		}

		if(result !== '') {
			throw new Error('sessionRepo.validLoginData, ' + result);
		}

		return result === '';

	}

	function parsePrimaryCERX(userType, affs) {

		// CE, RX or RXROLLUP users have 1 primary entity

		var cePrimary = 'NONE',
			rxPrimary = 'NONE',
			found = [];

		switch(userType) {

			case 'CE':
				found = utilSvc.aff.ceList(affs);
				if(found.length === 1) {
					cePrimary = found[0];
				}
				break;

			case 'RX':
				found = utilSvc.aff.rxList(utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']));
				if(found.length === 1) {
					rxPrimary = found[0];
				}
				break;

			case 'RXROLLUP':
				found = utilSvc.aff.rxList(utilSvc.aff.findRxType(affs, ['ROLLUP']));
				if(found.length === 1) {
					rxPrimary = found[0];
				}
				break;

			case 'VERITYSA':
			case 'VERITY':
				// no primary
				break;

			default:
				throw new Error('authService.parsePrimaryCERX, unknown user type: ' + userType);

		}

		return {
			ceid: cePrimary,
			rxid: rxPrimary
		};

	}
}
 
/**
 *    HTTP RESPONSE ERRORS
 *    handle all major api response errors
 */

apiErrors.$inject = ['$rootScope', '$q', 'validSvc'];
angular
.module('espui.core.api')
.factory('apiErrors', apiErrors);

/* @ngInject */
function apiErrors($rootScope, $q, validSvc) {

	var service = {
		canHandle: canHandle,
		errEvent: errEvent
	};

	return service;


	/**
	 *    CAN HANDLE?
	 *    look at error response, some error codes throw app-wide events
	 *    other codes are expected errors like validation, etc
	 */

	function canHandle(r, purl) {

		// response is corrupt, HTTP 520 is server unknown error
		if(!!!r || !validSvc.isNumber(r.status)) {
			return errEvent('resp.error.corrupt', 520, purl + ': ' + safeResponse(r));
		}

		switch(r.status) {

			case -1:
				// connection refused
				// angular returns connection refused as status -1 ERR_CONNECTION_REFUSED
				return errEvent('resp.error.refusedConnection', -1, purl + safeResponse(r));

			case 0:
				// no connection
				// angular returns connection timeout as status 0
				return errEvent('resp.error.noConnection', 0, purl + safeResponse(r));

			case 502:
				// no connection
				// angular returns connection timeout as status 0
				return errEvent('resp.error.badgateway', 502, purl + safeResponse(r));

			case 400:
				// Bad Request
				// the request is unreadable or corrupted, cannot be parsed
				return errEvent('resp.error.badRequest', 400, purl + ': ' + safeResponse(r));

			case 401:
				// Unauthorized
				// needs login token or token is bad / timed out
				$rootScope.$emit('espui>auth.logout', {reason:''});
				return errEvent('resp.error.noAuth', 401, purl);

			case 403:
				// Forbidden
				// user auth token is valid but they do not have claim rights

				// shape check
				if(!!r.data && r.data.errorCode == 'BLOCK0001') {
					$rootScope.$emit('espui>auth.logout', {reason:'block', token: r.data.errorId});
					return errEvent('BLOCK', 403);
				}
				else {
					return errEvent('resp.error.forbidden', 403, purl);
				}
				break;
			case 404:
				// Not Found
				// The requested resource is not available
				return null;
			case 409:
				// Conflict
				// doesn't need a body
				return null;

			case 422:
				// Unprocessable Entity
				// validation error
				return verifyValidationFormat(r, purl);

			case 423:
				// Locked
				// user is locked out of api server
				$rootScope.$emit('espui>auth.logout', {reason: 'locked'});
				return errEvent('resp.error.lockout', 423, purl);

			case 503:
				// 503 Service Unavailable
				// under maintenance, ui will show "under maintenance page"
				return errEvent('resp.error.maintenance', 503, purl);

			case 504:
				// 504 Gateway timeout (email server is having issues)
				// note: would have used 502 but Angular is already using it
				return errEvent('resp.error.bademail', 504, purl);

			default:
				return errEvent('resp.error.unknown', r.status, purl + safeResponse(r));
		}

	}

	function verifyValidationFormat(r, purl) {

		/**
		 *    422 VALIDATION ERROR FORMATS
		 *    simple = validation response for a single entity
		 *    complex = validation response for more than one entity
		 */

		/* simple validation responses must have the Json format:

		response: {
			status: 422,
			data: {
				Entity: {
					Root: [
						‘rule text’,
						'rule text'
					],
					Fields: [
						{Id: ‘rule text’},
						{Id: ‘rule text’}
					]
				}
			}
		}

		*/

		var entity = null;

		// always need data and data.Entity
		if(!!!r.data && !!!r.data.Entity) {
			return errEvent('resp.error.422.format', 422, purl + ' response.data or response.data.Entity are missing');
		}
		entity = r.data.Entity;

		// stop checking if this is a complex validation response (more than 1 entity)
		if(!Array.isArray(entity.Root) || !Array.isArray(entity.Fields)) {
			return null;
		}

		// single entity validation response, validate its format
		var valid = false;
		var item = null;

		// valid Root items
		for (i = 0; i < entity.Root.length; i++ ) {
			item = entity.Root[i];
			valid = typeof(item) === 'string';
			if(!valid){
				break;
			}
		}

		// valid field items
		if(valid) {
			for (i = 0; i < entity.Fields.length; i++ ) {

				// check field Name and Rule exist and have a string value
				item = entity.Fields[i];
				if( !!!item ||
					!!!item.Name || typeof(item.Name) !== 'string' || item.Name.trim() === '' ||
					!!!item.Rule || typeof(item.Rule) !== 'string' || item.Rule.trim() === '') {
					valid = false;
					break;
				}
			}
		}

		// result
		if(valid) {
			return null;
		}
		else {
			return errEvent('resp.error.422.format', 422, purl + ' validation error format unknown for: ' + safeResponse(r));
		}

	}

	/*

	TBD: other errors to handle specifically instead of throwing an unrecoverable error

	404 Not Found
	End point doesn’t exist to execute any action

	5xx Server Error

	500 Internal Server Error
	Unexpected error in server code not related to client request content
	General catch all for GO Server errors

	501 Not Implemented
	Endpoint is only a stub
	No implementation yet but does exist for future

	*/


	/**
	 *    ERR EVENT
	 *    format an api response error to throw as event
	 *    note: also used by the core.api.service to throw response events
	 */

	function errEvent(code, httpStatus, desc) {

		// create api error event object

		return {
			type: 'error',
			code: code,
			status: httpStatus,
			desc: desc
		};

	}

	function safeResponse(resp) {

		var output = {
			status: -1,
			data: {
				error: 'no data'
			}
		};

		if(!!resp) {

			if(!isNaN(resp.status)) {
				output.status = resp.status;
			}

			if(!!resp.data) {

				try {
					var test = angular.toJson(resp.data);
					output.data.error = resp.data;
				}
				catch(err) {
					// do nothing, can't include the response data, it will not serialize
				}
			}
		}

		return angular.toJson(output);

	}

}


 
/**
 *    API SERVICE
 *    used by core services, no feature should be calling the api directly
 *    handles the auth token storage internally, see AUTH TOKEN section below
 */

apiService.$inject = ['$rootScope', '$http', '$q', 'apiErrors', 'sessionRepo', 'errSvc', 'utilSvc', 'validSvc'];
angular
.module('espui.core.api')
.factory('apiService', apiService);

/* @ngInject */
function apiService($rootScope, $http, $q, apiErrors, sessionRepo, errSvc, utilSvc, validSvc) {

	var _apiPath = null;

	var service = {
		getConfig: getConfig,
		post: post,

		// special case post types
		login: login,
		checkToken: checkToken,
		logout: logout,
		pong: pong,
		refreshUser: refreshUser,
		getUserPrefs: getUserPrefs,
		postGetBinary: postGetBinary,
		postFile: postFile,
		postDebug: postDebug

	};

	return service;


	/**
	 *    CONFIG JSON
	 *    on app start, get the appConfig.json file from the web server
	 */
	function getConfig(purl) {

		var defer = $q.defer(),
			myPurl = purl;

		$http.get(purl).then(okConfig, errConfig);

		function okConfig(r) {

			// validate response
			var configGood = false;
			if(!!!r || !!!r.data) {
				defer.reject({message: '200: response is empty'});
				return;
			}

			// missing major config keys
			var appConfig = r.data;
			if(!!!appConfig.maint) {
				defer.reject({message: '200: appConfig.json is missing maint key: ' + utilSvc.json.stringify(appConfig, true)});
				return;
			}

			// good
			defer.resolve(appConfig);

		}
		function errConfig(r) {

			// don't use central error handling when getting the config file, that app is not fully started yet

			// clean up response (if needed)
			r = r || {};
			r.status = validSvc.isNumber(r.status) ? r.status : -1;
			r.data = r.data || {};

			defer.reject({status: r.status, message: utilSvc.json.stringify(r.data, true)});
		}

		return defer.promise;
	}


	/**
	 *    API PATH
	 *    get out of the appConfig.json file stored in rootScope at start up
	 */

	function apiPath() {

		if(!!!_apiPath) {

			if(!validSvc.isText($rootScope.appConfig.apiPath)) {
				throw new Error('apiSvc.apiPath, api path is missing on rootscope');
			}

			_apiPath = $rootScope.appConfig.apiPath;
		}

		return _apiPath;

	}


	/**
	 *    REQUEST HEADERS
	 *    add token from sessionRepo into'token' request headers
	 */

	function authHeader() {

		// get value from token store on request, this should be stateless
		return {
			'headers': {
				'Authorization': sessionRepo.get('token')
			}
		};
	}


	/**
	 *    PUBLIC AJAX METHODS
	 *    all core services use these methods
	 */

	function post(purl, data, skipUserCheck, expectTimeout) {

		var defer = $q.defer(),
			myPurl = purl,
			errEvent = null;

		// mock response
		var mock = null;
		if($rootScope.apiLog) {
			mock = findMock(purl);
		}

		// resolve mock or post to server
		if(!!mock) {
			if(mock.status == 200) {
				defer.resolve(mock);
			}
			else {
				defer.reject(mock);
			}
		}
		else {
			$http.post(apiPath() + purl, data, authHeader()).then(ok, err);
		}

		if(!!data && !!data.keepTimestamp) {
			// avoid timestamp reset
			// note: pong and alert polling shouldn't reset UI session inactivity
		}
		else {
			$rootScope.pongTimestamp = new Date();
		}

		function ok(r) {

			// user logged out during request
			if(!!!skipUserCheck && !!!$rootScope.User) {
				defer.reject(null);
			}

			// api log
			if ($rootScope.apiLog) {
				logRequest(purl, data, r);
			}

			errEvent = checkResponse(r, myPurl);
			if(errEvent != null) {
				errSvc.warn('Api 200 response error: ' + errEvent.code, myPurl, errEvent.status, errEvent.desc);
				defer.reject(null);
			}
			else {
				defer.resolve(r);
			}
		}

		function err(r) {

			// api log
			if ($rootScope.apiLog) {
				logRequest(purl, data, r);
			}

			// expect 503 timeouts? convert to 409 for ctl to handle it
			if(!!expectTimeout && !!r && r.status == 503) {
				r.status = 409;
				r.timeout = true;
			}
			
			errEvent = apiErrors.canHandle(r, myPurl);
			if(errEvent !== null) {

				// don't display anything on BLOCK, 401 or 423
				if(errEvent.code != 'BLOCK' && errEvent.status != 401 && errEvent.status != 423 && !!$rootScope.User) {
					errSvc.warn(errEvent.code, myPurl, errEvent.status, errEvent.desc);
				}

				defer.reject(null);
			}
			else {
				defer.reject(r);
			}

		}

		return defer.promise;

	}

	function postDebug(purl, data) {

		var defer = $q.defer(),
			myPurl = purl,
			errEvent = null;

		$http.post(apiPath() + purl, data, authHeader()).then(ok, err);
		$rootScope.pongTimestamp = new Date();

		function ok(r) {
			errEvent = checkResponse(r, myPurl);
			if(errEvent != null) {
				r.errEvent = errEvent;
				defer.reject(r);
			}
			else {
				defer.resolve(r);
			}
		}
		function err(r) {

			errEvent = apiErrors.canHandle(r, myPurl);
			if(errEvent != null) {
				errSvc.warn(errEvent.code, myPurl, errEvent.status, errEvent.desc);
			}

			defer.reject(r);
		}

		return defer.promise;

	}


	/**
	 *    LOGIN / LOGOUT
	 *    special handlers needed
	 */


	function login(data) {

		var defer = $q.defer(),
			myPurl = 'security/login';

		$http.post(apiPath() + myPurl, data, authHeader()).then(okLogin, errLogin);

		function okLogin(r) {

			var errEvent = checkResponse(r, myPurl);
			if(errEvent != null) {
				errSvc.error('Login 200 response malformed', errEvent.code + myPurl, errEvent.status, errEvent.desc);
				defer.reject(null);
			}
			else {
				if(!!r.data && !!r.data.Entity) {
					utilSvc.dt.setBizTimeOffset(r.data.Entity.BusinessTimeOffset);
				}
				defer.resolve(r);
			}

		}

		function errLogin(r) {
			r = r || {};
			var status = validSvc.isInteger(r.status) ? r.status : 0;

			// login will handle display for: 401 bad login, 422 validation, 423 lockout
			if(status == 401 || status == 422 || status == 423) {
				defer.reject(r);
			}
			else {	
				// unknown error
				var errEvent = apiErrors.canHandle(r, myPurl);
				errEvent = errEvent || {
					code: '',
					status: '',
					desc: utilSvc.http.safeResponse(r)
				};

				// no message box for block
				if(errEvent.code != 'BLOCK') {
					errSvc.error('Unknown error during login', errEvent.code + myPurl, errEvent.status, errEvent.desc);
				}
				defer.reject(null);
			}
		}

		return defer.promise;

	}

	function checkToken(purl, data) {

		var defer = $q.defer(),
			myPurl = purl;

		$http.post(apiPath() + myPurl, data, authHeader()).then(okCheckToken, errCheckToken);

		function okCheckToken(r) {

			var errEvent = checkResponse(r, myPurl);
			if(errEvent != null) {
				errSvc.error('Login 200 r is corrupt', errEvent.code + myPurl, errEvent.status, errEvent.desc);
				defer.reject(null);
			}
			else {
				defer.resolve(r);
			}

		}

		function errCheckToken(r) {

			// 401 bad login or 423 lockout
			if(!!r && !isNaN(r.status) && (r.status == 401 || r.status == 423 || r.status == 422)) {
				defer.reject(r);
				return;
			}

			// unknown error
			var errEvent = apiErrors.canHandle(r, myPurl);
			errEvent = errEvent || {
				code: '',
				status: '',
				desc: utilSvc.http.safeResponse(r)
			};
			errSvc.error('Unknown error during login', errEvent.code + myPurl, errEvent.status, errEvent.desc);
			defer.reject(null);

		}

		return defer.promise;

	}

	function logout() {
		// this is a throw away call, pass it back to caller to handle
		return $http.post(apiPath() + 'security/logout', {}, authHeader());
	}


	/**
	 *    PONG
	 *    timer on a loop checks server token, throw no bugs!
	 */

	function pong() {

		// note: pong is a special case

		var defer = $q.defer();
		$http.post(apiPath() + 'security/pong', {}, authHeader()).then(okPong, errPong);

		function okPong(r) {
			defer.resolve({});
		}

		function errPong(r) {
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    POST WITH BINARY RETURN
	 *    send JSON post, receives binary files (like Excel files)
	 */

	function postGetBinary(purl, data) {

		var defer = $q.defer(),
			myPurl = purl,
			errEvent = null;

		var postConfig = authHeader();
		postConfig.responseType = 'arraybuffer';

		$rootScope.pongTimestamp = new Date();
		$http.post(apiPath() + purl, data, postConfig).then(ok, err);

		function ok(r) {

			// user logged out during request
			if(!!!$rootScope.User) {
				defer.reject(null);
			}

			errEvent = checkResponse(r, myPurl);
			if(errEvent != null) {
				errSvc.warn('Api 200 response error: ' + errEvent.code, myPurl, errEvent.status, errEvent.desc);
				defer.reject(null);
			}
			else {
				defer.resolve(r);
			}
		}

		function err(r) {

			errEvent = apiErrors.canHandle(r, myPurl);
			if(errEvent !== null) {

				// don't display anything on 401 or 423
				if(errEvent.status != 401 && errEvent.status != 423 && !!$rootScope.User) {
					errSvc.warn(errEvent.code, myPurl, errEvent.status, errEvent.desc);
				}

				defer.reject(null);
			}
			else {
				defer.reject(r);
			}

		}

		return defer.promise;

	}


	/**
	 *    REFRESH USER
	 *    used by app and admin features to ensure User data is fresh
	 */

	function refreshUser(skipUserCheck) {

		// will refresh session User object in rootScope and session

		var defer = $q.defer(),
			myPurl = 'security/login/refresh';

		post(myPurl, {}, !!skipUserCheck).then(okRefreshUser, errRefreshUser);

		function okRefreshUser(r) {
			// note: see authService.login() for same User state reload steps below, only exception is SessionId is NOT returned on a refresh

			// validate login data
			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.error('Bad 200 api login response format', 'apiService.refreshUser', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// parse Json into session User
			var entity = r.data.Entity;
			sessionRepo.parseLoginToUserObj(entity.User);
			$rootScope.User = sessionRepo.get('User');
			$rootScope.BIVersion = r.data.Entity.BIVersion;
			$rootScope.$emit('espui>cobrand', $rootScope.User.CoBrand);
			utilSvc.dt.setBizTimeOffset(entity.BusinessTimeOffset);

			defer.resolve({});
		}

		function errRefreshUser(r) {
			if(!!r) {
				errSvc.error('Unknown error, on user affiliations refresh', myPurl, r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    GET USER PREFS FROM LOGIN CONTENT
	 *    used by core repositories to get the user prefs out of the login response content
	 */

	function getUserPrefs() {

		// get Profile node from content returned on login

		var defer = $q.defer(),
			myPurl = 'security/login/refresh';

		post(myPurl, {}).then(okGetUserPrefs, errGetUserPrefs);

		function okGetUserPrefs(r) {

			// validate login data
			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.error('Bad 200 api login response format', 'apiService.getUserPrefs', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// prefs exist?
			var ent = r.data.Entity;
			if(!!ent && !!ent.User && Array.isArray(ent.User.Profile)) {
				defer.resolve(ent.User.Profile);
			}
			else {
				defer.resolve([]);
			}

		}

		function errGetUserPrefs(r) {
			if(!!r) {
				errSvc.error('Unknown error, apiService.errGetUserPrefs', myPurl, r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    POST FILE IN MULTI-PART FORM
	 *    send Multi-part form, receive JSON response
	 *    note: uses FormData object, browser must support this
	 */

	function postFile(purl, formData, isFileResponse, expectTimeout,return409) {

		var defer = $q.defer(),
			myPurl = purl,
			errEvent = null;

		var postOptions = {
			'headers': {
				'Authorization': sessionRepo.get('token'),
				'enctype': 'multipart/form-data',
				'Content-Type': undefined
			}
		};

		// expecting a file response
		if(isFileResponse) {
			postOptions.responseType = 'arraybuffer';
		}

		$rootScope.pongTimestamp = new Date();
		$http.post(apiPath() + purl, formData, postOptions).then(ok, err);

		function ok(r) {

			// user logged out during request
			if(!!!$rootScope.User) {
				defer.reject(null);
			}

			// pre-screen for error file return (it comes back as a 200, not 422)
			if(!!isFileResponse && !!r && !!!r.data.ok) {
				r.status = 422;
				defer.reject(r);
			}
			else {

				errEvent = checkResponse(r, myPurl);
				if(errEvent != null) {
					errSvc.warn('Api 200 r error: ' + errEvent.code, myPurl, errEvent.status, errEvent.desc);
					defer.reject(null);
				}
				else {
					defer.resolve(r);
				}

			}

		}

		function err(r) {
		
			if(!!return409 && !!r && r.status === 409) {
				defer.reject(r);
			}
			// pre-screen for 422 file return
			else if(!!isFileResponse && !!r && r.status === 422) {
				defer.reject(r);
			}
    		// expect 503 timeouts? convert to 409 for ctl to handle it
        	else if(!!expectTimeout && !!r && r.status == 503) {
				r.status = 409;
				r.timeout = true;
				defer.reject(r);
			}
			else {
				errEvent = apiErrors.canHandle(r, myPurl);
				if(errEvent !== null) {
					// don't display anything on 401 or 423 locked
					if(errEvent.status != 401 && errEvent.status != 423 && !!$rootScope.User) {
						errSvc.warn(errEvent.code, myPurl, errEvent.status, errEvent.desc);
					}

					defer.reject(null);
				}
				else {
					defer.reject(r);
				}

			}

		}

		return defer.promise;

	}


	/**
	 *    HELPERS
	 */

	function checkResponse(r, purl) {
		// verify the format of a successful response object

		// null or missing response
		if(!!!r || !!!r.status || !!!r.data) {
			return apiErrors.errEvent('resp.ok.corrupt', 200, purl + angular.toJson(r));
		}
		else {
			return null;
		}
	}

	function cleanPath(dirtyPurl) {

		// assign purl
		if(!validSvc.isText(dirtyPurl)) {
			alert('cleanPath, purl must be a valid string');
			return null;
		}

		// remove all leading and trailing '/'
		var fix = dirtyPurl.trim();
		while(fix.length > 1 && fix.substr(0,1) == '/' || fix.substr(fix.length - 1, 1) == '/') {

			if(fix.substr(0,1) == '/') {
				fix = fix.substr(1);
			}

			if(fix.substr(fix.length - 1, 1) == '/') {
				fix = fix.substr(0, fix.length - 1);
			}

		}

		return fix;

	}

	function findMock(purl) {
		var purls = sessionRepo.getLocalStoreKey('purls'),
			purlSaved = {};
		purls = Array.isArray(purls) ? purls : [];
		for(var i = 0; i < purls.length; i++) {
			purlSaved = purls[i];
			if(purlSaved.name == purl && purlSaved.type == 'MOCK') {
				console.log("apiService.MockResponse ", purl);
				return purls[i].response;
			}
		}

		return null;
	}

	function logRequest(purl, data, r) {
		r = r || {};
		if(!!r.config && !!r.config.headers) {
			r.config.headers.Authorization = '';
		}
		
		try {
			// resp too big?
			var jsonResp = JSON.stringify(r),
				status = validSvc.isInteger(r.status) ? r.status.toString() : '';

			var logEntry = {
				name: cleanPath(purl),
				json: data,
				response: jsonResp.length < 1000000 ? r : {data:"response is to big for api log: " + jsonResp.length},
				type: 'SAVE',
				status: status
			};

			var log = sessionRepo.getLocalStoreKey('apilog');
			log = Array.isArray(log) ? log : [];
			log.unshift(logEntry);
			if(log.length > 10) {
				log.pop();
			}

			sessionRepo.setLocalStoreKey('apilog', log);
		}
		catch(err) {
			console.log('apiService.logRequest error: ' + err.message);
		}
	}	

}
 
/**
 *    AUTH SERVICE
 *    features use this service for login, logout, managing the token repository
 *    note: ui features should never call the api service login() method directly
 */

authService.$inject = ['$rootScope', '$q', '$timeout', 'apiService', 'sessionRepo', 'utilSvc', 'validSvc', 'errSvc'];
angular
.module('espui.core.auth')
.factory('authService', authService);

/* @ngInject */
function authService($rootScope, $q, $timeout, apiService, sessionRepo, utilSvc, validSvc, errSvc) {

	var _pendingModel = null,
		_pendingTabKey = '';

	var service = {
		login: login,
		loginOkta: loginOkta,
		checkToken: checkToken,
		pwdRequestEmail: pwdRequestEmail,
		pwdRequestAnswer: pwdRequestAnswer,
		pwdSave: pwdSave,
		logout: logout,
		termsGet: termsGet,
		termsAgree: termsAgree,
		twoFactor: twoFactor,
		newTabRequest: newTabRequest,
		newTabActivate: newTabActivate,
		ipValidCheck: ipValidCheck
	};

	return service;


	/**
	 *    LOGIN / LOGOUT
	 */

	// PARTNER SSO: Phase 4 Login UI - 4.1 User Name Prompt (sends email to security/login)
	function login (email, pwd) {

		var defer = $q.defer();

		var remToken = sessionRepo.getLocalStoreKey('rem340b');
		if(!validSvc.isText(remToken)) {
			remToken = '';
		}

		var data = {
			Username : email,
			Password : pwd,
			RememberToken: remToken
		};

		sessionRepo.clear();
		apiService.login(data).then(okLogin, errLogin);

		function okLogin(r) {
			// note: see apiService.refreshUser() for same User reload steps below

			// validate login data
			if(!validSvc.httpGetEntityResp(r) || !validSvc.isText(r.data.Entity.SessionId)) {
				errSvc.error('Bad 200 api login response format', 'authService.login', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				// parse Json into session User
				var usr = r.data.Entity.User;
				sessionRepo.parseLoginToUserObj(usr);
				$rootScope.User = sessionRepo.get('User');
				$rootScope.BIVersion = r.data.Entity.BIVersion;
				$rootScope.$emit('espui>cobrand', $rootScope.User.CoBrand);
	
				// set token as last step
				sessionRepo.set('token', r.data.Entity.SessionId);
	
				defer.resolve({
					Status: usr.Status,
					TwoFactor: usr.TwoFactor,
					OktaCustomer: usr.OktaCustomer,
					OktaMfaPhone: usr.OktaMfaPhone,
					OktaDefaultFactor:usr.OktaDefaultFactor
				});
			}

		}

		function errLogin(r) {
			defer.reject(r);
		}

		return defer.promise;
	}

	// PARTNER SSO: Phase 4 Login UI - 4.7 Okta Return Success (shared workforce + partner)
	function loginOkta () {
		// similar to login() but no parmeters needed, session token already exists after okta return

		var defer = $q.defer();
		apiService.refreshUser(true).then(okOkta, errOkta);

		function okOkta(r) {
			// User and session setup by refreshUser
			defer.resolve({});
		}

		function errOkta(r) {
			defer.reject(r);
		}

		return defer.promise;
	}

	function logout() {

		var defer = $q.defer();
		apiService.logout().then(logoutDone, logoutDone);

		function logoutDone(r) {
			// do the same thing on ok or error, doesn't matter
			sessionRepo.clear();
			$rootScope.$emit('espui>auth.logout', {reason: ''});

			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 *    TOKENS
	 */

	// PARTNER SSO: Phase 3 Registration UI - 3.1 Detect activatesso Route (token validation)
	function checkToken (tokenType, token) {

		var defer = $q.defer(),
			purl = '';

		// new tab (token value is a tab id saved in local storage)
		// note the data stored in this local storage key is actually the JWT token
		if(tokenType == 'newtab') {
			console.log('AUTH SVC CHECK TOKEN: ' + token);
			var tabId = token;
			var storeToken = sessionRepo.getLocalStoreKey(tabId);
			if(!!!storeToken || !validSvc.isText(storeToken.data)) {
				defer.reject(null);
				return;
			}
			sessionRepo.removeLocalStoreKey(tabId);
			token = storeToken.data;
			console.log('AUTH SVC FOUND TOKEN');
		}

		var apiRequest = {
			Entity: {
				Token: token
			}
		};

		switch(tokenType) {
			case 'activate':
            case 'activatesso':
				purl = 'user/activate';
				break;
			case 'pwdreset':
				purl = 'user/pwdreset';
				break;
			case 'newtab':
				purl = 'user/tabactivate';
				break;
			default:
				throw new Error('authService.checkToken, unknown token type: ' + tokenType);
		}

		apiService.checkToken(purl, apiRequest).then(okCheckToken, errCheckToken);

		function okCheckToken(r) {
			console.log('AUTH SVC: OK TOKEN');

			// token ok
			if(!validSvc.httpGetEntityResp(r) || !validSvc.isText(r.data.Entity.SessionId)) {
				errSvc.error('Bad 200 api response format', 'user/activate', '', utilSvc.http.safeResponse(r));
			}

			var ent = r.data.Entity;
			sessionRepo.set('token', ent.SessionId);

			// token check receives CoBrand info for this user
            var cobrand = validSvc.isText(ent.CoBrand) ? ent.CoBrand : '';

            // note: do not lowercase partner SSO CoBrand info
            if(tokenType !== 'activatesso') {
                cobrand = validSvc.isText(cobrand) ? cobrand.toLowerCase() : 'verity';
            }
			$rootScope.$emit('espui>cobrand', cobrand);

			defer.resolve({
				cobrand: cobrand  // pass back to login so it doesn't need a listener for cobrand
			});

		}

		function errCheckToken(r) {
			console.log('AUTH SVC: ERR TOKEN');
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 *    USER PASSWORD RESET
	 */

	function pwdRequestEmail (userName) {

		// params
		if(!validSvc.isText(userName)) {
			throw new Error('authService.pwdRequest, userName required');
		}

		var defer = $q.defer();

		var apiRequest = {
			Entity: {
				UserName: userName
			}
		};

		apiService.post('user/pwdrequest', apiRequest, true).then(okPwdRequestEmail, errPwdRequestEmail);

		function okPwdRequestEmail(r) {

			// token ok
			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.error('Bad 200 api response format', 'user/pwdrequest', '', utilSvc.http.safeResponse(r));
			}

			defer.resolve({Question: r.data.Entity.Question});

		}

		function errPwdRequestEmail(r) {
			if(r === null) {
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', 'user/pwdrequest' + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status === 422) {
				// map 422 errors into model
				defer.reject({status: 422, msg: r.data.Entity.ROOT.join(', ')});
			}
			else {
				errSvc.error('unexpected api response', 'user/pwdrequest', r.status, utilSvc.http.safeResponse(r));
			}
		}

		return defer.promise;
	}

	function pwdRequestAnswer(m, url) {

		// params
		if(!!!m || !validSvc.isText(url) || !validSvc.isText(m.Answer.val)) {
			throw new Error('authService.pwdRequestAnswer, url and answer required');
		}

		var defer = $q.defer();

		var apiRequest = {
			Entity: {
				UserName: m.Email.val,
				Question: m.Question.val,
				Answer: m.Answer.val,
				Url: url
			}
		};

		apiService.post('user/pwdrequestanswer', apiRequest, true).then(okPwdRequestAnswer, errPwdRequestAnswer);

		function okPwdRequestAnswer(r) {
			defer.resolve({});
		}

		function errPwdRequestAnswer(r) {
			if(r === null) {
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', 'user/pwdrequestanswer' + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status === 422) {
				// map 422 errors into model
				defer.reject({status: 422, msg: r.data.Entity.ROOT.join(', ')});
			}
			else {
				errSvc.error('unexpected api response', 'user/pwdrequestanswer', r.status, utilSvc.http.safeResponse(r));
			}
		}

		return defer.promise;
	}


	/**
	 *    PASSWORD SAVE
	 *    used in both activate and pwdreset features
	 */

	// PARTNER SSO: Phase 3 Registration UI - 3.3 Submit Email Confirmation (activatesso pwdsave)
	// PARTNER SSO: Phase 3 Registration UI - 3.4 Advance Registration to Partner Redirect
	function pwdSave (model) {

		var defer = $q.defer();

		var apiRequest = {
			Entity: {
				"UserName" : model.Email.val,
				"Password" : model.Pwd.val
			}
		};

		_pendingModel = model;

		apiService.post('user/pwdsave', apiRequest, true).then(okPwdSave, errPwdSave);

		function okPwdSave(r) {

			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.error('Bad 200 api response format', 'user/pwdsave', '', utilSvc.http.safeResponse(r));
			}

			defer.resolve(r.data.Entity);
			_pendingModel = null;

		}

		function errPwdSave(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
            else if(r.status == 409) {
                // okta errors throw 409 partner conflict
                var errMsg = !!r.data && validSvc.isText(r.data.error) ? r.data.error : 'Issue during activation, retry your activation link.';
                defer.reject({status: 409, msg: errMsg});
            }
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapPwdSave422(r, _pendingModel);
				defer.reject(r);
			}
			else {
				_pendingModel = null;
				errSvc.error('unexpected api response', 'user/pwdsave', r.status, utilSvc.http.safeResponse(r));
			}
			_pendingModel = null;
		}

		function mapPwdSave422(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				if(fieldName == 'UserName') {
					m.Email.fail = 'yes';
					m.Email.msg = entity.Fields[i].Rule;
				}
				else if (fieldName == 'Password') {
					m.Pwd.fail = 'yes';
					m.Pwd.msg = entity.Fields[i].Rule;
				}
				else {
					throw new Error('authService.mapPwdSave422, field name not found: ' + fieldName);
				}

			}

			return m;

		}

		return defer.promise;
	}


	/**
	 *    TERMS OF USE
	 */

	function termsGet(isVerity) {

		var defer = $q.defer(),
			purl = !!isVerity ? 'user/verityterms' : 'user/termsget';

		apiService.post(purl, {}).then(okTermsGet, errTermsGet);

		function okTermsGet(r) {

			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.error('Bad 200 api response format', 'user/termsget', '', utilSvc.http.safeResponse(r));
			}

			defer.resolve(r.data.Entity);
		}

		function errTermsGet(r) {
			defer.reject(null);
		}

		return defer.promise;
	}

	function termsAgree(id) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('authService.termsAgree, id required');
		}

		var defer = $q.defer();

		apiService.post('user/termsagree', {Entity:{TermsId:id}}).then(okTermsAgree, errTermsAgree);

		function okTermsAgree(r) {
			defer.resolve({});
		}

		function errTermsAgree(r) {
			defer.reject(null);
		}

		return defer.promise;
	}

	function twoFactor(m) {

		// params
		if(!!!m || !validSvc.isText(m.Action)) {
			throw new Error('authService.twoFactor, model and Action required');
		}
		
		var defer = $q.defer(),
			params = {Action:m.Action};

		switch(m.Action) {
			case 'VALIDATE':
				if(!validSvc.isInteger(m.SecurityCode)) {
					throw new Error('authService.twoFactor, VALIDATE requires Code as integer');
				}
				params.Factor = m.Factor;
				params.SecurityCode = m.SecurityCode;
				params.Remember = !!m.Remember;

				// remove old remember token
				sessionRepo.removeLocalStoreKey('rem340b');
				break;
			case 'ENROLL':
				params.Factor = m.Factor;
				params.Phone = m.Phone;
				break;
			case 'ACTIVATE':
				params.Factor = m.Factor;
				params.SecurityCode = m.SecurityCode;
				params.Phone = m.Phone;
				break;
			case 'SEND':
				// factor
				if(m.Factor != 'email' && m.Factor != 'sms') {
					throw new Error('authService.twoFactor, ' + m.Action + ' requires Factor is email or sms');
				}
				params.Factor = m.Factor;
				break;
			case 'EDIT':
				params.Default = m.Factor;
				params.PhoneEdit = m.PhoneEdit;
				params.Phone = m.Phone;
				break;
			default:
				throw new Error('authSvc.twoFactor, unknown action: ' + m.Action);
		}		

		apiService.post('security/login/twofactor', {Params:params}).then(okTwoFactor, errTwoFactor);

		function okTwoFactor(r) {
			// get remember token
			r = r || {};
			if(!!m.OktaCustomer && m.Action == 'VALIDATE' && m.Remember && validSvc.httpUpsert200Resp(r)) {
				sessionRepo.setLocalStoreKey('rem340b', r.data.Entity.Id);
			}

			defer.resolve({});
		}

		function errTwoFactor(r) {
			var errResp = null;
			if(!!r && r.status === 422) {
				errResp = r;
			}
			else if(!!r) {
				errSvc.warn('Security Code Unknown Error ', r.status, utilSvc.http.safeResponse(r));				
			}
			defer.reject(errResp);
		}

		return defer.promise;
	}

	function newTabRequest(tabKey) {

		var defer = $q.defer();

		// params
		if(!validSvc.isText(tabKey)) {
			throw new Error('authService.newTabRequest, tab key required');
		}

		// check local storage
		if(!sessionRepo.hasLocalStorage()){
			defer.reject({msg:'Browser local storage not available.'});
			return;
		}

		_pendingTabKey = tabKey;
		apiService.post('user/tabrequest', {}).then(okTabRequest, errTabRequest);

		function okTabRequest(r) {
			// bad response
			if(!validSvc.httpGetEntityResp(r) || !validSvc.isText(r.data.Entity.Id)) {
				errSvc.error('Bad 200 api response format', 'authService.okTabRequest', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// token returned, add to local storage by tab id
			if(sessionRepo.setLocalStoreKey(_pendingTabKey, {data: r.data.Entity.Id})) {
				_pendingTabKey = '';
				defer.resolve({});
				return;
			}

			// token not returned or couldn't save it
			defer.reject({msg:'Could not set new tab token to local storage'});
		}

		function errTabRequest(r) {
			if(!!r) {
				defer.reject({msg:'Server rejected new tab request, try again. Server status: ' + r.status});
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	function newTabActivate() {
		// reload User from api using refresh

		var defer = $q.defer();
		apiService.refreshUser(true).then(okTabActivate, errTabActivate);

		function okTabActivate(r) {
			defer.resolve({});
		}

		function errTabActivate(r) {
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 * 	IP VALID
	 */

	function ipValidCheck() {
		// send request to API to validate CE customer IP address

		var defer = $q.defer();
		apiService.post('security/login/ipvalid', {}, true).then(okIP, errIP);

		function okIP(r) {
			if(!!r && !!r.data && !!r.data.Valid) {
				if(!!$rootScope.User) {
					$rootScope.User.IpValid = true;
				}
				defer.resolve(true);
			}
			else {
				errIP(null);
			}
		}

		function errIP(r) {
			defer.reject(null);
		}

		return defer.promise;
	}
	

}
 
/**
 *    NG-SHOW FADE IN/OUT
 */

angular
.module('espui.core.ui')
.animation('.ngshow-fader-anim', ngshowFader);

/* @ngInject */
function ngshowFader() {

    return {

        // before adding the hide class
        beforeAddClass : function(element, className, done) {
            if(className == 'ng-hide') {
                TweenMax.to(element, 0.6, {opacity:0, onComplete: done});
            }
            else {
                done();
            }
        },

        // removed the hide class = show!
        removeClass : function(element, className, done) {
            if(className == 'ng-hide') {
                TweenMax.to(element, 0.6, {opacity:1, onComplete: done});
            }
            else {
                done();
            }
        }

    };

}
 
/**
 *    NG-SHOW FADE IN/OUT
 */

angular
.module('espui.core.ui')
.animation('.ngshow-fader-swap-anim', ngshowFaderSwap);

/* @ngInject */
function ngshowFaderSwap() {

    return {

        // before adding the hide class
        beforeAddClass : function(element, className, done) {
            if(className == 'ng-hide') {
                done();
                //TweenMax.to(element, 0.6, {opacity:0, onComplete: done});
            }
            else {
                done();
            }
        },

        // removed the hide class = show!
        removeClass : function(element, className, done) {
            if(className == 'ng-hide') {
                TweenMax.to(element, 0.6, {opacity:1, onComplete: done});
            }
            else {
                done();
            }
        }

    };

}
 
/**
 *    NG-SHOW SLIDE IN/OUT
 */

angular
.module('espui.core.ui')
.animation('.ngshow-slider-anim', ngshowSlider);

/* @ngInject */
function ngshowSlider() {

	return {

		// before adding the hide class
		beforeAddClass : function(element, className, done) {
			if(className == 'ng-hide') {
				TweenMax.to(element, 0.7, {'max-height':0, onComplete: done});
			}
			else {
				done();
			}
		},

		// removed the hide class = show!
		removeClass : function(element, className, done) {
			if(className == 'ng-hide') {
				TweenMax.set(element, {'max-height':1000});
				TweenMax.from(element, 0.5, {'max-height':0, onComplete: done});
			}
			else {
				done();
			}
		}

	};

}
 
/**
 *    NG-SHOW SLIDE IN/OUT
 */

angular
.module('espui.core.ui')
.animation('.ngshow-slider-swap-anim', ngshowSliderSwap);

/* @ngInject */
function ngshowSliderSwap() {

    return {

        // before adding the hide class
        beforeAddClass : function(element, className, done) {
            if(className == 'ng-hide') {
                TweenMax.set(element, {height:'auto'});
                done();
            }
            else {
                done();
            }
        },

        // removed the hide class = show!
        removeClass : function(element, className, done) {
            if(className == 'ng-hide') {
                TweenMax.set(element, {height:'auto'});
                TweenMax.from(element, 0.7, {height:0, onComplete: done});
            }
            else {
                done();
            }
        }

    };

}
 

dateAsTextFilter.$inject = ['dateFilter', 'utilSvc'];
angular
.module('espui.core.ui')
.filter('filterDatesAsText', dateAsTextFilter);

/* @ngInject */
function dateAsTextFilter(dateFilter, utilSvc) {

	// filter ng-repeat rows with date values filtered as text strings

	return function(rows, filterDates, filterNames, format) {

		/* html example usage: filterDatesAsText:filterDates:filterNames:format
			with data: filterDatesAsText:{filterName1:filterval, filterName2:filterval}:['filterName1','filterName2']:'M/d/yyyy'
				rows = ng-repeat rows
				filterDates = {filterName1:filterval, filterName2:filterval}
				filterNames = ['filterName1','filterName2']
				format = 'M/d/yyyy'
		*/

		var output = [];

		// dates and names must be provided
		if(!!!filterDates || !Array.isArray(filterNames) || filterNames.length < 1 || !utilSvc.str.isText(format)) {
			return rows;
		}

		// get list of valid filters
		var validFilters = getValidFilters(filterDates, filterNames);
		if(validFilters.length < 1) {
			return rows;
		}

		// loop rows
		for(var i = 0; i < rows.length; i++) {

			// apply filters to this row, if it passes add it to output
			if(applyRowFilters(rows[i], validFilters, format)) {
				output.push(rows[i]);
			}

		}

		return output;


		/**
		 *    HELPERS
		 */

		function getValidFilters(dates, names) {

			// iterate filter names, get values out of filterDates object
			/*
				note:
					instead of recursing all filterDate properties using "var prop in filterDates"
					it is much more efficient to pass in a list of names
			*/

			var valid = [],
				name = null,
				val = null;

			for (var i = 0; i < names.length; i++) {

				// valid filter name
				name = names[i];
				if(!!name) {

					// add valid filter value
					val = utilSvc.obj.findChildProp(dates, name);
					if(val !== undefined) {

						// convert to string
						val = utilSvc.str.toText(val);
						if(!!val) {
							valid.push({
								name: name,
								val: val.toLowerCase()
							});
							//console.log('filter added: ' + name + ' with val: ' + val);
						}
					}
				}
			}

			return valid;

		}

		function applyRowFilters(row, filters, format) {

			// apply each filter to this row
			for (var i = 0; i < filters.length; i++) {

				// property found
				var rowVal = utilSvc.obj.findChildProp(row, filters[i].name),
					rowText = '';

				// no row value
				if(!!!rowVal) {
					return false;
				}

				// row value is date
				if(utilSvc.dt.isValid(rowVal)) {
					rowText = dateFilter(rowVal, format);
				}
				else {
					// not a date convert it to a string
					rowText = utilSvc.str.toText(rowVal);
				}

				// find filter text at start of row text (always doing a 'starts with' search)
				if(rowText.indexOf(filters[i].val, 0) !== 0) {
					return false;
				}

			}

			// passed all filters
			return true;

		}

	};

}
 

dateRangeAsTextFilter.$inject = ['dateFilter', 'utilSvc'];
angular
.module('espui.core.ui')
.filter('filterDateRangeAsText', dateRangeAsTextFilter);

/* @ngInject */
function dateRangeAsTextFilter(dateFilter, utilSvc) {

	// filter ng-repeat rows with start / date text input values

	return function(rows, targetName, startDate, endDate) {

		/* html example usage: filterDateRangeAsText:'targetName':startDate:endDate
			where:
				rows = ng-repeat rows
				targetName = 'targetName'
				startDate = startDate
				endDate = endDAte
		*/

		var output = [];

		// parse to dates
		var dtStart = utilSvc.dt.parse(startDate.val),
			dtEnd = utilSvc.dt.parse(endDate.val);

		// params must be valid
		if(!utilSvc.str.isText(targetName) || !dtStart || !dtEnd) {
			return rows;
		}

		// start > end?
		if(utilSvc.dt.greaterThan(dtStart, dtEnd)) {
			return rows;
		}

		// loop rows
		for(var i = 0; i < rows.length; i++) {

			// parse row val to date
			var rowVal = utilSvc.dt.parse(utilSvc.obj.findChildProp(rows[i], targetName));
			if(!!rowVal) {

				// in range?
				if(utilSvc.dt.greaterThan(rowVal, dtStart, true) && utilSvc.dt.lessThan(rowVal, dtEnd, true)) {
					output.push(rows[i]);
				}
			}
		}

		return output;

	};

}
 
decPlaceNumberFormatFilter.$inject = ['numberFilter', 'validSvc'];angular
.module('espui.core.ui')
.filter('decPlaceNumberFormat', decPlaceNumberFormatFilter);

/* @ngInject */
function decPlaceNumberFormatFilter(numberFilter, validSvc) {

	// filter incoming numbers to their specific decimal places with no rounding
	// if no decimals, do not show .000 etc

	return function(val, zeroFmt) {

		/* html example usage:
			1234 | decPlaceNumberFormat returns '1,234'
			1234.00 | decPlaceNumberFormat returns '1,234'
			1234.5999 | decPlaceNumberFormat returns '1,234.5999'
		*/

		/* jshint ignore:start */
		if(!validSvc.isNumber(val) || val == 0) {
			return typeof(zeroFmt) !== 'undefined' ? zeroFmt : '0';
		}
		else if(Math.floor(val) === val) {
			return numberFilter(val);
		}
		else {
			var valComps = val.toString().split(".");
			if(valComps.length < 2) {
				return val.toString()
			}
			return numberFilter(val, valComps[1].length);
		}
		/* jshint ignore:end */

	};

}
 

angular
.module('espui.core.ui')
.filter('filterDropselect', dropselectFilter);

/* @ngInject */
function dropselectFilter() {

	// filter ng-repeat rows based on dropselect array

	return function(rows, propName, vals) {

		/* html example usage: filterDropselect:isAll:vals
			with data: filterDropselect:'RuleCheck':true/false:['DROPSELECTVAL']
				rows = ng-repeat rows
				propName = 'RuleCheck' name of field to check against dropdown values
				isAll = true/false
				vals = array of items selected in the dropdown
				format = 'M/d/yyyy'
		*/

		var output = [];

		// values not ready yet
		if(!Array.isArray(vals) || typeof(propName) !== 'string') {
			return rows;
		}

		// no items checked
		if(vals.length < 1) {
			return output;
		}

		// ALL items checked
		if(vals[0] == 'ALL') {
			return rows;
		}

		// loop rows
		var rowVal = '';
		for(var i = 0; i < rows.length; i++) {

			rowVal = rows[i][propName];
			if(!!rowVal && vals.indexOf(rowVal.toUpperCase()) > -1) {
				output.push(rows[i]);
			}

		}

		return output;

	};

}
 
limitFromFilter.$inject = ['validSvc'];
angular
.module('espui.core.ui')
.filter('limitFrom', limitFromFilter);

/* @ngInject */
function limitFromFilter(validSvc) {

	// filter for ng-repeat to start from a certain index

	return function(items, startFrom) {

		if(validSvc.isNumber(startFrom) && items.length > startFrom) {

			// startFrom is not 0 based, its 1 based
			return items.slice(startFrom - 1);

		}

		return items;

	};

}
 
rangeNumberFilter.$inject = ['validSvc'];
angular
.module('espui.core.ui')
.filter('rangeNumber', rangeNumberFilter);

/* @ngInject */
function rangeNumberFilter(validSvc) {

	// filter for ng-repeat, return rows with a property which is between min to max

	return function(items, propName, min, max) {

		var result = [],
			minClean = parseFloat(min),
			maxClean = parseFloat(max);

		if(!validSvc.isText(propName)) {
			alert('rangeNumberFilter, propName is not valid');
			return result;
		}

		if(Array.isArray(items) && items.length > 0 && validSvc.isNumber(minClean) && validSvc.isNumber(maxClean)) {

			for(var i = 0; i < items.length; i++) {
				if(items[i][propName] >= minClean && items[i][propName] <= maxClean) {
					result.push(items[i]);
				}
			}

		}

		return result;

	};

}
 
truncateFilter.$inject = ['validSvc'];
angular
.module('espui.core.ui')
.filter('truncate', truncateFilter);

/* @ngInject */
function truncateFilter(validSvc) {

	return function(txt,maxLen) {
        // empty
        if(!validSvc.isText(txt)) {
            return '';
        }
        // chop len
        var len = validSvc.isNumber(maxLen) ? maxLen : 30; // using default for CE/PH multiselect
        if(txt.length > len) {
            return txt.substr(0, len) + '...';
        }
        // as is
        return txt;
	};
} 
wholeNumberFloorFormatFilter.$inject = ['numberFilter', 'validSvc'];
angular
.module('espui.core.ui')
.filter('wholeNumberFloorFormat', wholeNumberFloorFormatFilter);

/* @ngInject */
function wholeNumberFloorFormatFilter(numberFilter, validSvc) {

	// filter incoming numbers to whole number without rounding

	return function(val) {

		/* html example usage:
			1234.56 | wholeNumberFloorFormat returns '1234'
		*/

		/* jshint ignore:start */
		if(!validSvc.isNumber(val) || val == 0) {
			return val;
		}
		else {
			return numberFilter(Math.floor(val));
		}
		/* jshint ignore:end */

	};

}
 
zeroNumberFormatFilter.$inject = ['numberFilter', 'validSvc'];
angular
.module('espui.core.ui')
.filter('zeroNumberFormat', zeroNumberFormatFilter);

/* @ngInject */
function zeroNumberFormatFilter(numberFilter, validSvc) {

	// filter incoming number values to either:
	//	non-zero values = return numberFilter(value)
	//	zero values = return format string

	return function(val, format, digits) {

		/* html example usage:
			1234 | zeroNumberFormat:'' returns '1,234'
			0 | zeroNumberFormat:'-' returns '-'
			0 | zeroNumberFormat:'' returns ''
		*/

		/* jshint ignore:start */
		if(!validSvc.isNumber(val) || val == 0) {
			return format;
		}
		else if(validSvc.isNumber(digits)) {
			return numberFilter(val, digits);
		}
		else {
			return numberFilter(val);
		}
		/* jshint ignore:end */

	};

}
 
/**
 *    MSG SERVICE
 *    features use this service to wait for an async user prompt
 *    it communicates (via events) with the layout/MsgBoxController to show UI on the main index.html page
 *
 *    rootScope Events Used:
 *        - msgbox.show event sent to MsgBoxController to show a msg UI
 *        - msgbox.result received from MsgBoxController after user dismisses msg UI
 */

msgSvc.$inject = ['$rootScope', '$q', '$timeout', '$window'];
angular
.module('espui.core.ui')
.factory('msgSvc', msgSvc);


/* @ngInject */
function msgSvc($rootScope, $q, $timeout, $window) {

	/**
	 *    INTERNAL PROPERTIES
	 */

	var _msgs = [],
		_animCheck = null;

	var service = {
		confirm: confirm,
		wait: wait,
		ok: okMsg,
		help: okHelp,
		release: okRelease,
		addHelpLink: addHelpLink,
		okAsync: okMsgAsync,
		appTimeout: appTimeout,
		resultEvent: resultEvent
	};

	// add event hooks to this service
	$rootScope.$on('espui>msgbox.result', resultEvent);
	$rootScope.$on('espui>msgbox.clearall', evtClearAll);
	$rootScope.$on('espui>auth.logout', evtClearAll);

	return service;

	function okMsg (titleTxt, msgTxt, async) {
		// show an ok dialog

		// emit event
		$rootScope.$emit('espui>msgbox.show', {
			msgType: 'ok',
			title: titleTxt,
			msg: msgTxt,
			msgId: '',
			async: async
		});

	}

	function okHelp (titleTxt, folder, flyout) {

		// show help text content in a certain folder

		// emit event
		$rootScope.$emit('espui>msgbox.show', {
			msgType: 'help',
			title: titleTxt,
			msg: '',
			msgId: '',
			folder: folder,
			flyout: !!flyout
		});

	}

	function okRelease (version) {

		// show release notes

		// emit event
		$rootScope.$emit('espui>msgbox.show', {
			msgType: 'release',
			title: '',
			msg: '',
			msgId: '',
			version: version
		});

	}

	function helpLink(folder, title, flyout) {

		if(typeof(folder) !== 'string' || folder.trim() === '') {
			alert('help folder missing');
			return;
		}

		if(typeof(title) !== 'string') {
			title = '';
		}

		// emit event
		$rootScope.$emit('espui>msgbox.show', {
			msgType: 'help',
			title: title,
			msg: '',
			msgId: '',
			folder: folder,
			flyout: true // always show slide out for all users all environments
		});

	}

	function addHelpLink(vm) {
		vm.helpLink = helpLink;
	}

	function appTimeout() {

		// prompt user app is about to timeout
		// NOTE: the message id 'app.session.timeout' is handled differently inside the message box controller

		return okMsgAsync('Session Timeout', 'Your session is about to expire, click OK to continue.', 'app.session.timeout');

	}

	function okMsgAsync(titleTxt, msgTxt, msgId) {

		if(typeof(msgId) !== 'string' || msgId.trim().length < 0) {
			throw new Error('msgSvc.okMsgAsync, message id required');
		}

		var defer = $q.defer();
		var idx = findMsg(msgId);

		// already waiting on this msg
		if(idx > -1) {
			defer.reject(null);
		}
		else {

			// add promise to msgs array
			_msgs.push({
				id: msgId,
				defer: defer
			});

			// emit event
			$rootScope.$emit('espui>msgbox.show', {
				msgType: 'ok',
				title: titleTxt,
				msg: msgTxt,
				msgId: msgId
			});

		}

		return defer.promise;

	}

	function confirm (msgData) {

		// show a confirmation box

		var defer = $q.defer();
		var idx = findMsg(msgData.id);

		// already waiting on this msg
		if(idx > -1) {
			defer.reject(null);
		}
		else {

			// add promise to msgs array
			_msgs.push({
				id: msgData.id,
				defer: defer
			});

			// emit event
			$rootScope.$emit('espui>msgbox.show', {
				msgType: 'confirm',
				msgId: msgData.id,
				title: msgData.title,
				msg: msgData.msg,
				notes: msgData.notes || {},
				buttons: msgData.buttons,
				detail: msgData.detail
			});

		}

		return defer.promise;

	}

	function wait (isWaiting, immediate) {

		// show the waiting spinner

		// emit event
		$rootScope.$emit('espui>msgbox.show', {
			msgType: 'wait',
			wait: !!isWaiting ? 'on' : 'off',
			immediate: !!immediate
		});

	}


	/**
	 *    EVENT HOOKS
	 *    listens for result events from the msgBox Controller UI
	 */

	function resultEvent (event, data) {

		// valid msgbox.result event
		if(!!!data || !!!data.id ) {
			throw 'espui>msgbox.result, must have valid event data with id';
		}

		// are we waiting for this msg id to complete?
		var idx = findMsg(data.id);
		if(idx > -1) {
			_msgs[idx].defer.resolve({
				result: data.result,
				notes: data.notes
			});
			_msgs.splice(idx, 1);
		}

	}

	function evtClearAll(event, data) {

		// error has occurred, dump all pending actions
		for(var i = 0; i < _msgs.length; i++) {
			try {
				_msgs[i].defer.resolve({result: 'CANCEL'});
			}
			catch(err) {
				// do nothing, this is a clean up
			}
		}

		$timeout(function() {
			_msgs = [];
		}, 100);
	}



	/**
	 *    HELPERS
	 */

	function findMsg(id) {

		for(var i = 0; i < _msgs.length; i++) {
			if(_msgs[i].id == id) {
				return i;
			}
		}

		return -1;
	}

}
 
scriptyLazyLoad.$inject = ['$window'];
angular
.module('espui.core.ui')
.directive('scriptyLazyLoad', scriptyLazyLoad);

/* @ngInject */
function scriptyLazyLoad($window) {

	var scripty = {
		restrict: 'A',
		compile: compile
	};

	return scripty;

	function compile(elem, attrs) {

		if(!!elem) {
			var lazyScript = $window.document.createElement("script");
			lazyScript.type = "text/javascript";
			lazyScript.src = attrs.src + '?v=' + $window.verityEspVersion;

			elem.append(lazyScript);
		}

	}

}

 
widChartHost.$inject = ['$compile', 'validSvc'];
angular.module('espui.core.ui')
.directive('widgetChartHost', widChartHost);

/* @ngInject */
function widChartHost($compile, validSvc) {

    var useTemplate = function(uniqueId, chartType) {
        return '<div widget-chart-' + chartType + ' class="chart-widget" unique-id="' + uniqueId + '"></div>';
    };

    var linkFx = function($scope, $elem, $attrs) {
        if(validSvc.isText($scope.uniqueId) && validSvc.isText($scope.chartType) && $scope.chartType != $scope.myChartType) {
            $scope.myChartType = $scope.chartType;
            $elem.html(useTemplate($scope.uniqueId, $scope.myChartType));
            $compile($elem.contents())($scope);
        }
    };

    var widget = {
        restrict: 'E',
        scope: {
            uniqueId: '=',
            chartType: '='
        },
        link: linkFx
    };

    return widget;
}
 
/**
 *    TREND GRAPH
 *    Y axis is linear with full-width horizontal lines
 *    X axis is time scale with two line labels Month over date
 */

widChartLine.$inject = ['utilSvc', 'validSvc'];
angular.module('espui.core.ui')
.directive('widgetChartLine', widChartLine);

/* @ngInject */
function widChartLine(utilSvc, validSvc) {

	ctl.$inject = ['$scope'];
	var widget = {
		restrict: 'A',
		scope: {
			uniqueId: '@'
		},
		controller: ctl,
		link: linkFx
	};

	return widget;


	/* @ngInject */
	function ctl($scope) {

		/**
		 *    INIT
		 */

		init();

		function init() {

			// d3 needs a unique CSS handle to this specific chart
			$scope.uniqueCSS = $scope.uniqueId + 'D3';

			$scope.syncChart = {
				config: null,
				data: [],
				render: ''
			};

		}

		$scope.$on('$destroy', function() {
			// clean up listener on destroy
			_unregisterListener();
		});


		/**
		 *    CHART SYNC EVENT HOOK
		 *    catches sync events thrown by page
		 *    updates $scope.syncChart which is watched by linkFx function
		 */

		var _unregisterListener = $scope.$on('widget.chart.sync', function(event, evtData) {

			// check event id matches this chart
			if(validSvc.isText(evtData.uniqueId)) {
				if($scope.uniqueId === evtData.uniqueId) {

					// build full object from event data (events may not pass all properties)
					var syncUpdate = {
						config: evtData.config || $scope.syncChart.config,
						data: Array.isArray(evtData.data) ? evtData.data : $scope.syncChart.data,
						render: $scope.syncChart.render
					};

					// apply render property?
					if(evtData.render === '' || evtData.render === 'now' || evtData.render === 'animate') {
						syncUpdate.render = evtData.render;
					}

					// replace scope property, this will fire linkFx $watch event
					$scope.syncChart = syncUpdate;

				}
			}

		});

	}


	function linkFx($scope, $elem, $attrs) {

		/**
		 *    syncChart EVENT HOOK
		 *    fires when controller updates $scope.syncChart
		 */

		$scope.$watch('syncChart', d3RenderChart);


		/**
		 *    D3 RENDER
		 */

		var _colorBars = [],
			_chartSize = {},
			_plot = {};

		function d3RenderChart() {

			// clear svg elements if anything is missing
			var sync = $scope.syncChart;
			if((sync.render != 'now' && sync.render != 'animate') || !!!sync.config || sync.data.length < 1) {
				d3.select($elem[0]).selectAll('*').remove();
				return;
			}

			// dataset, add datapoint index for mouse over later
			var dataset = sync.data;
			var idxNum = dataset.length - 1;

			for(var idx = 0; idx < dataset.length; idx++) {
				dataset[idx].idx = idx;
				dataset[idx].idxNum = idxNum;
			}

			// parse and validate chart params
			_colorBars = sync.config.colors;
			var userParams = parseParams(sync);

			// chart size and plot area
			_chartSize = $elem.parent()[0].getBoundingClientRect();
			_plot = calculateChartPlot(_chartSize,
				{ // padding
					top: 25,
					right: 20 + 10, // adding 10 because yAxis text requires extra space, so makes right look squished
					bottom: 25,
					left: 40
				},
				{ // axis
					x: {
						height: 15,
						leftIndent: 5
					},
					y: {
						width: userParams.yAxis.showText ? 30 : 0
					}
				}
			);


			/**
			 *    VALUE MAPPING
			 *    property names to use for data series
			 */

			var xVal = function(d) {
				return d.date;
			};

			var yVal = function(d) {
				return d.val;
			};

			// Y value formatting
			var fmtYvalue = function(d) {
				switch(userParams.yAxis.format) {
					case 'fixed':
						return d3.format(',.2f')(d);
					case 'number':
						return d3.format(',.0f')(d);
					case 'currency':
						if(d >= 0) {
							return '$' + d3.format(',.0f')(d);
						}
						else {
							return '$(' + d3.format(',.0f')(d * -1) + ')';
						}
						break;
					case 'percent':
						return d3.format(',.0f')(d) + '%';
					case 'percent.1':
						return d3.format(',.1f')(d) + '%';

					default:
						throw new Error('widget-chart-line.fmtYvalue, number type unknown: ' + userParams.yAxis.format);
				}
			};


			/**
			 *    SCALE
			 *    convert data min/max values into pixel sizes
			 */

			// X scale (dates)
			var xScale = d3.scaleTime()
				.domain([
					d3.min(dataset, xVal),
					d3.max(dataset, xVal)
				])
				.range([_plot.x.left, _plot.x.right]);

			// Y scale (numbers)
			var yScale = d3.scaleLinear()
				.domain([
					d3.min(dataset, yVal),
					d3.max(dataset, yVal)
				])
				.range([_plot.y.bottom, _plot.y.top])
				.nice();


			/**
			 *    MAP COORDINATES
			 *    convert x/y values into x,y coordinates using X/Y scales from above
			 */

			var xMap = function(d) {
				return xScale(xVal(d));
			};

			var yMap = function(d) {
				return yScale(yVal(d));
			};


			/**
			 *    AXIS
			 *    setup x and y axis
			 */

			// X axis: time scale
			var xAxis = d3.axisBottom(xScale)
				.ticks(userParams.xAxis.interval)
				.tickSize(6)
				.tickFormat(function(d){ return '';}); // not text, adding custom 2 line label below

			// y axis text
			var fmtYaxisText;
			if(userParams.yAxis.showText) {
				fmtYaxisText = fmtYvalue;
			}
			else {
				// don't show any text
				fmtYaxisText = function(d){ return '';};
			}

			var yAxis = d3.axisLeft(yScale)
				.tickSize(-(_plot.y.right - _plot.y.left)) // negative draws to the right, draw from y axis to data.right
				.tickFormat(fmtYaxisText)
				.ticks(8);


			/**
			 *    TREND DATA
			 */

			// calculate trend line
			var trendTotal = 0;
			for(var i = 0; i < dataset.length; i++) {
				trendTotal += dataset[i].val;
				dataset[i].trend = trendTotal / (i + 1);
			}

			// trend line: define
			var trendLine = d3.line()
				.x(function(d) { return xScale(d.date); })
				.y(function(d) { return yScale(d.trend); })
				.curve(d3.curveMonotoneX);


			/**
			 *    VALUE DATA
			 */

			// value line 1: define
			var val1Line = d3.line()
				.x(function(d) { return xScale(d.date); })
				.y(function(d) { return yScale(d.val); })
				.curve(d3.curveMonotoneX);


			/**
			 *    RENDER SVG
			 */

			// clear previous elements
			d3.select($elem[0]).selectAll('*').remove();

			// d3 SVG container
			var svg = d3.select($elem[0])
				.append('svg')
				.attr('width', _chartSize.width)
				.attr('height', _chartSize.height)
				.attr('class', $scope.uniqueCSS)
				.append('g')
					.attr('transform', 'translate(0,0)');


			/**
			 *    RENDER X AXIS
			 */

			// X axis render
			var xAxisRender = svg.append('g')
				.attr('class', 'xaxis')
				.attr('transform', 'translate(' + '0' + ',' + _plot.x.top + ')')
				.call(xAxis);

			// X axis tick label top (Month)
			var xTickLabelTop = function(d) {
				return utilSvc.dt.monthShortText(d);
			};

			// X axis tick label bottom (date)
			var xTickLabelBtm = function(d) {
				return d.getDate().toString();
			};

			// X axis render labels two lines: Month / over date
			xAxisRender
				.selectAll('.tick text')
					.append('tspan')
						.text(xTickLabelTop)
						.attr('x', '0')
						.attr('text-anchor', 'middle')
					.append('tspan')
						.text(xTickLabelBtm)
						.attr('x', '0')
						.attr('dy', _plot.x.height)
						.attr('text-anchor', 'middle');


			/**
			 *    RENDER Y AXIS
			 */

			// Y axis render
			svg.append('g')
				.attr('class', 'yaxis')
				.attr('transform', 'translate(' + _plot.y.left + ',' + '0' + ')')
				.call(yAxis);


			/**
			 *    RENDER TREND LINE
			 */

			// trend line: render
			var trendPath = svg.append('path')
				.attr('class', 'trend-line')
				.attr('d', trendLine(dataset));


			/**
			 *    RENDER VALUE 1 LINE + DOTS
			 */

			// value 1: line
			var vLine1Path = svg.append('path')
				.attr('class', 'data-line')
				.attr('d', val1Line(dataset));

			// value 1: data points
			var val1Points = svg.selectAll('data-point')
				.data(dataset)
				.enter()
				.append('circle')
				.attr('class', 'data-point')
				.attr('cx', function(d) { return xMap(d);})
				.attr('cy', function(d) { return yMap(d);})
				.attr('r', 5)
				.style('opacity', 1)
				.style('opacity', 1)
				.on("mouseenter", function(d, i) {

					// get svg class
					var thisSvg = d3.select('svg.' + $scope.uniqueCSS);

					// get data point mouse is over
					var thisPoint = d3.select(this);

					// move first/last label to fit inside graph
					var cxPos = parseFloat(thisPoint.attr('cx'));
					if(d.idx === 0) {
						// first, move right
						cxPos += 30;
					}
					else if(d.idx === d.idxNum) {
						// last, move left
						cxPos -= 20;
					}

					// remember cyPos
					var cyPos = parseInt(thisPoint.attr('cy')) -10;

					// get label
					var dLabel = thisSvg.select('.data-label');

					// set text child node, position and show it
					dLabel.select('.lbl-text').text(fmtYvalue(yVal(d)));
					dLabel
						.attr('transform', 'translate(' + cxPos.toString() + ',' + cyPos.toString() + ')')
						.style('visibility', 'visible')
						.style('opacity', 0.85);

					// fade in
					dLabel
						.style('opacity', 0)
						.transition()
						.duration(250)
						.ease(d3.easeLinear)
						.style('opacity', 0.85);

				});


			/**
			 *    RENDER FLOATING DATA LABEL
			 */

			var dataLabel = svg.append('g')
				.attr('class', 'data-label')
				.attr('transform', 'translate(0,0)')
				.on("mouseleave", function() {
					d3.select(this)
						.style('visibility', 'hidden');
				});

				// append mouseout rect surface (its invisible, provides larger surface for mouseout event)
				dataLabel.append('rect')
					.attr('x', -userParams.label.width / 2)
					.attr('y', -userParams.label.height / 2)
					.attr('width', userParams.label.width + 10)
					.attr('height', userParams.label.height + 15)
					.style('opacity', 0);

				// append rect label bkg
				dataLabel.append('rect')
					.attr('class', 'lbl-bkg')
					.attr('x', -userParams.label.width / 2)
					.attr('y', -userParams.label.height / 2)
					.attr('rx', 3)
					.attr('ry', 3)
					.attr('width', userParams.label.width)
					.attr('height', userParams.label.height);

				// append text centered inside rect bkg
				dataLabel.append('text')
					.attr('class', 'lbl-text')
					.attr('x', 0)
					.attr('y', 5)
					.attr('text-anchor', 'middle')
					.text('.');


			/**
			 *    ANIMATION
			 */

			if(sync.render == 'animate') {
				// value dots 1: animate > bounce in
				val1Points
					.attr('cy', 0)
					.style('opacity', 0)
					.transition()
					.duration(1000)
					.delay(function(d, i) { return (i * 100) + 150; })
					.ease(d3.easeBounceOut)
					.attr('cx', function(d) { return xScale(d.date); })
					.attr('cy', function(d) { return yScale(d.val); })
					.attr('r', 5)
					.style('opacity', 1);


				// value line: animate > draw left to right
				try {
					var vLine1PathNodes = vLine1Path.node().getTotalLength();
					vLine1Path
						.attr('stroke-dasharray', vLine1PathNodes + ' ' + vLine1PathNodes)
						.attr('stroke-dashoffset', vLine1PathNodes)
						.transition()
						.duration(1000)
						.ease(d3.easeLinear)
						.delay(300)
						.attr('stroke-dashoffset', 0);

				}
				catch(err) {
					// IE FIX: no animation if the node() call throws an error
				}

				// trend line: animate > draw left to right
				try {
					var trendPathNodes = trendPath.node().getTotalLength();
					trendPath
						.attr('stroke-dasharray', trendPathNodes + ' ' + trendPathNodes)
						.attr('stroke-dashoffset', trendPathNodes)
						.transition()
						.duration(1000)
						.ease(d3.easeLinear)
						.delay(500)
						.attr('stroke-dashoffset', 0);
				}
				catch(err) {
					// IE FIX: no animation if the node() call throws an error
				}
			}

		}


		/**
		 *    HELPERS
		 */

		function parseParams(sync) {

			// validate and parse params into chart object

			// render
			if(sync.render != 'now' && sync.render != 'animate') {
				throw new Error('widget-chart-line.render, config.render unknown: ' + sync.render);
			}

			// color bars
			var paramBarColors = sync.config.colors;
			if(!Array.isArray(paramBarColors) || paramBarColors.length < 1) {
				throw new Error('widget-chart-line.render, config.colors array length must be > 0');
			}

			// x axis
			var paramXaxis = sync.config.xAxis || {};
			if(paramXaxis.showText === true && paramXaxis.showText === false) {
				throw new Error('widget-chart-line.render, config.xAxis.showText required');
			}
			var paramXaxisInterval;
			switch(paramXaxis.interval) {
				case 'hour':
					paramXaxisInterval = d3.timeHour;
					break;
				case 'day':
					paramXaxisInterval = d3.timeDay;
					break;
				case 'sunday':
					paramXaxisInterval = d3.timeSunday;
					break;
				case 'monday':
					paramXaxisInterval = d3.timeMonday;
					break;
				case 'tuesday':
					paramXaxisInterval = d3.timeTuesday;
					break;
				case 'wednesday':
					paramXaxisInterval = d3.timeWednesday;
					break;
				case 'thursday':
					paramXaxisInterval = d3.timeThursday;
					break;
				case 'friday':
					paramXaxisInterval = d3.timeFriday;
					break;
				case 'saturday':
					paramXaxisInterval = d3.timeSaturday;
					break;
				case 'week':
					paramXaxisInterval = d3.timeWeek;
					break;
				case 'month':
					paramXaxisInterval = d3.timeMonth;
					break;
				case 'year':
					paramXaxisInterval = d3.timeYear;
					break;
				default:
					throw new Error('widget-chart-line.render, config.xAxis.interval unknown: ' + paramXaxis.interval);
			}

			// y axis
			var paramYaxis = sync.config.yAxis || {};
			if(paramYaxis.format != 'number' && paramYaxis.format != 'currency' && paramYaxis.format != 'percent' && paramYaxis.format != 'percent.1' && paramYaxis.format != 'fixed') {
				throw new Error('widget-chart-line.render, config.yAxis.format unknown: ' + paramYaxis.format);
			}
			if(paramYaxis.showText === true && paramYaxis.showText === false) {
				throw new Error('widget-chart-line.render, config.yAxis.showText required');
			}

			// label params
			var paramLabel = sync.config.label || {};
			if(!validSvc.isNumber(paramLabel.width) || !validSvc.isNumber(paramLabel.height)) {
				throw new Error('widget-chart-line.render, config.label.width/height required');
			}

			return {
				xAxis: {
					showText: paramXaxis.showText,
					interval: paramXaxisInterval
				},
				yAxis: {
					showText: paramYaxis.showText,
					format: paramYaxis.format.toString()
				},
				label: {
					width: paramLabel.width,
					height: paramLabel.height
				}
			};

		}

		function calculateChartPlot(size, pad, axis) {

			// create chart width and height dimensions including x/y axis

			// data plot area
			var plot = {
				data: {
					top: pad.top,
					left: pad.left + axis.y.width + axis.x.leftIndent,
					right: size.width - pad.right,
					bottom: size.height - axis.x.height - pad.bottom
				}
			};

			// X axis plot
			plot.x = {
				height: axis.x.height,
				top: plot.data.bottom,
				left: plot.data.left,
				right: plot.data.right,
				bottom: plot.data.bottom + axis.x.height
			};

			// Y axis plot
			plot.y = {
				top: plot.data.top,
				left: pad.left + axis.y.width,
				right: plot.data.right,
				bottom: plot.data.bottom
			};

			return plot;

		}

	}

}
 
/**
 *    PIE GRAPH CONFIG
 *    no axis
 */

widChartPie.$inject = ['validSvc'];
angular.module('espui.core.ui')
.directive('widgetChartPie', widChartPie);

/* @ngInject */
function widChartPie(validSvc) {

	ctl.$inject = ['$scope'];
	var widget = {
		restrict: 'A',
		scope: {
			uniqueId: '@'
		},
		controller: ctl,
		link: linkFx
	};

	return widget;


	/* @ngInject */
	function ctl($scope) {

		/**
		 *    INIT
		 */

		init();

		function init() {

			$scope.syncChart = {
				config: null,
				data: [],
				render: '',
				uniqueCSS: ''
			};

		}

		$scope.$on('$destroy', function() {
			// clean up listener on destroy
			_unregisterListener();
		});


		/**
		 *    CHART SYNC EVENT HOOK
		 *    catches sync events thrown by page
		 *    updates $scope.syncChart which is watched by linkFx function
		 */

		var _unregisterListener = $scope.$on('widget.chart.sync', function(event, evtData) {

			// check event id matches this chart
			if(validSvc.isText(evtData.uniqueId)) {
				if($scope.uniqueId === evtData.uniqueId) {

					// build full object from event data (events may not pass all properties)
					var syncUpdate = {
						config: evtData.config || $scope.syncChart.config,
						data: Array.isArray(evtData.data) ? evtData.data : $scope.syncChart.data,
						render: $scope.syncChart.render,
						uniqueCSS: $scope.uniqueId + 'D3'
					};

					// apply render property?
					if(evtData.render === '' || evtData.render === 'now' || evtData.render === 'animate') {
						syncUpdate.render = evtData.render;
					}

					// replace scope property, this will fire linkFx $watch event
					$scope.syncChart = syncUpdate;

				}
			}

		});

	}

	function linkFx($scope, $elem, $attrs) {

		/**
		 *    syncChart EVENT HOOK
		 *    fires when controller updates $scope.syncChart
		 */

		$scope.$watch('syncChart', d3RenderChart);


		/**
		 *    D3 RENDER
		 */

		var _pieColors = [],
			_chartSize = {},
			_plot = {},
			_uniqueCSS = 'D3';

		function d3RenderChart() {

			// clear svg elements if anything is missing
			var sync = $scope.syncChart;
			if((sync.render != 'now' && sync.render != 'animate') || !!!sync.config || sync.data.length < 1) {
				d3.select($elem[0]).selectAll('*').remove();
				return;
			}
			var dataset = sync.data;

			// parse and validate chart params
			_pieColors = sync.config.colors;
			var userParams = parseParams(sync);

			// chart size and plot area
			_chartSize = $elem.parent()[0].getBoundingClientRect();
			_plot = calculateChartPlot(_chartSize,
				{ // padding
					top: 25,
					right: 25,
					bottom: 25,
					left: 25
				},
				{ // axis, not used by pie, keeping it to standardize the plot function for all chart types
					x: {
						height: 0,
						leftIndent: 0
					},
					y: {
						width: 0
					}
				}
			);

			// pie specific dimensions
			var radius = Math.min(_chartSize.width, _chartSize.height) / 2;
			var donutWidth = radius * userParams.donutHole.radius;

			// D3 unique handle
			_uniqueCSS = sync.uniqueCSS;

			/**
			 *    VALUES
			 *    identify properties to use in data
			 */

			// value formatting
			var fmtValue = function(d) {
				switch(userParams.valFormat) {
					case 'fixed':
						return d3.format(',.2f')(d);
					case 'number':
						return d3.format(',.0f')(d);
					case 'currency':
						if(d >= 0) {
							return '$' + d3.format(',.0f')(d);
						}
						else {
							return '$(' + d3.format(',.0f')(d * -1) + ')';
						}
						break;
					default:
						throw new Error('widget-chart-pie.fmtValue, number type unknown: ' + userParams.valFormat);
				}
			};


			/**
			 *    PIE CONFIG
			 */

			var arc = d3.arc()
				.innerRadius(donutWidth)
				.outerRadius(radius);

			var pie = d3.pie()
				.startAngle(1.1*Math.PI)
				.endAngle(3.1*Math.PI)
				.value(function(d) { return d.val; })
				.sort(null);


			/**
			 *    RENDER SVG
			 */

			// clear previous elements
			d3.select($elem[0]).selectAll('*').remove();

			// d3 SVG container
			var svg = d3.select($elem[0])
				.append('svg')
				.attr('width', _chartSize.width)
				.attr('height', _chartSize.height)
				.attr('class', _uniqueCSS)
				.append('g')
					.attr('transform', 'translate(' + (_chartSize.width / 2).toString() + ',' + (_chartSize.height / 2).toString() + ')');


			/**
			 *    RENDER PIE
			 */

			// add pie arcs
			var pieRender = svg.selectAll('.arc')
				.data(pie(dataset))
				.enter()
				.append('g')
					.attr('class', 'arc');

			pieRender
				.append('path')
					.style('fill', function(d, i) { return userParams.wedge.colorFn(i); })
					.on("mouseenter", function(d, i) {

						// get label
						var thisSvg = d3.select('svg.' + _uniqueCSS);
						var dLabel = thisSvg.select('.data-label');

						// set text child node, position and show it
						dLabel.select('.lbl-text.ln1').text(d.data.name);
						dLabel.select('.lbl-text.ln2').text(fmtValue(d.data.val));
						dLabel.select('.lbl-text.ln3').text(d.data.percent + '%');

						dLabel
							.style('visibility', 'visible')
							.style('opacity', 1);

						// fade in
						dLabel
							.style('opacity', 0)
							.transition()
							.duration(250)
							.ease(d3.easeLinear)
							.style('opacity', 1);

					})
					.on("mouseleave", function() {

						// get label
						var thisSvg = d3.select('svg.' + _uniqueCSS);
						var dLabel = thisSvg.select('.data-label');

						dLabel.style('visibility', 'hidden');
					});


			/**
			 *    RENDER CENTERED DATA LABEL
			 */

			var dataLabel = svg.append('g')
				.attr('class', 'data-label')
				.attr('transform', 'translate(' + '0' + ',' + '-10' + ')')
				.style('visibility', 'hidden')
				.append('text');

			// text line 1: name
			dataLabel.append('tspan')
				.attr('class', 'lbl-text ln1')
				.attr('text-anchor', 'middle')
				.attr('x', '0')
				.attr('dy', '0')
				.text('.');

			// text line 2: value
			dataLabel.append('tspan')
				.attr('class', 'lbl-text ln2')
				.attr('text-anchor', 'middle')
				.attr('x', '0')
				.attr('dy', '20')
				.text('.');

			// text line 3: percent
			dataLabel.append('tspan')
				.attr('class', 'lbl-text ln3')
				.attr('text-anchor', 'middle')
				.attr('x', '0')
				.attr('dy', '17')
				.text('.');


			/**
			 *    ANIMATION
			 */

			var animTime = sync.render == 'animate' ? 1000 : 100;

			// pie wedges, animate in
			pieRender.selectAll('g.arc path')
				.transition()
					.delay(300)
					.duration(animTime)
					.ease(d3.easeElastic)
					.attrTween("d", tweenPie);

			// animation helper
			function tweenPie(b) {
				var i = d3.interpolate({startAngle: 1.1*Math.PI, endAngle: 1.1*Math.PI}, b);
				return function(t) { return arc(i(t)); };
			}


		}


		/**
		 *    HELPERS
		 */

		function parseParams(sync) {

			// validate and parse params into chart object

			// render
			if(sync.render != 'now' && sync.render != 'animate') {
				throw new Error('widget-chart-pie.render, config.render unknown: ' + sync.render);
			}

			// color bars
			var paramPieColors = sync.config.colors;
			if(!Array.isArray(paramPieColors) || paramPieColors.length < 1) {
				throw new Error('widget-chart-pie.render, config.colors array length must be > 0');
			}

			// value format
			if(sync.config.valFormat != 'number' && sync.config.valFormat != 'currency' && sync.config.valFormat != 'fixed') {
				throw new Error('widget-chart-pie.render, config.valFormat unknown: ' + sync.config.valFormat);
			}

			// donut hole
			if(!validSvc.isNumber(sync.config.donutHoleRadius) || sync.config.donutHoleRadius < 0) {
				throw new Error('widget-chart-pie.render, config.donutHoleRadius must be a number: ' + paramConfig.donutHoleRadius);
			}

			// label params
			var paramLabel = sync.config.label || {};
			if(!validSvc.isNumber(paramLabel.width) || !validSvc.isNumber(paramLabel.height)) {
				throw new Error('widget-chart-pie.render, config.label.width/height required');
			}

			return {
				wedge: {
					colorFn: function (idx) {
						var len = _pieColors.length;
						if(len === 1) {
							return _pieColors[0];
						}
						else if(idx < len) {
							return _pieColors[idx];
						}
						else {
							// idx is > bar colors available
							return _pieColors[Math.floor(idx % len)];
						}
					}
				},
				donutHole: {
					radius: sync.config.donutHoleRadius
				},
				valFormat: sync.config.valFormat,
				label: {
					width: paramLabel.width,
					height: paramLabel.height
				}
			};

		}

		function calculateChartPlot(size, pad, axis) {

			// create chart width and height dimensions including x/y axis

			// data plot area
			var plot = {
				data: {
					top: pad.top,
					left: pad.left + axis.y.width + axis.x.leftIndent,
					right: size.width - pad.right,
					bottom: size.height - axis.x.height - pad.bottom
				}
			};

			// X axis plot
			plot.x = {
				top: plot.data.bottom,
				left: plot.data.left,
				right: plot.data.right,
				bottom: plot.data.bottom + axis.x.height
			};

			// Y axis plot
			plot.y = {
				top: plot.data.top,
				left: pad.left + axis.y.width,
				right: plot.data.right,
				bottom: plot.data.bottom
			};

			return plot;

		}
	}
}
 
/**
 *    TREND GRAPH
 *    Y axis is linear with full-width horizontal lines
 *    X axis is time scale with two line labels Month over date
 */

widChartTimeseries.$inject = ['utilSvc', 'validSvc'];
angular.module('espui.core.ui')
.directive('widgetChartTimeseries', widChartTimeseries);

/* @ngInject */
function widChartTimeseries(utilSvc, validSvc) {

	ctl.$inject = ['$scope'];
	var widget = {
		restrict: 'A',
		scope: {
			uniqueId: '@'
		},
		controller: ctl,
		link: linkFx
	};

	return widget;


	/* @ngInject */
	function ctl($scope) {

		/**
		 *    INIT
		 */

		init();

		function init() {

			// d3 needs a unique CSS handle to this specific chart
			$scope.uniqueCSS = $scope.uniqueId + 'D3';

			$scope.syncChart = {
				config: null,
				data: [],
				render: ''
			};

		}

		$scope.$on('$destroy', function() {
			// clean up listener on destroy
			_unregisterListener();
		});


		/**
		 *    CHART SYNC EVENT HOOK
		 *    catches sync events thrown by page
		 *    updates $scope.syncChart which is watched by linkFx function
		 */

		var _unregisterListener = $scope.$on('widget.chart.sync', function(event, evtData) {
			evtData = evtData || {};

			// exit if event is meant for another widget
			if(validSvc.isText(evtData.uniqueId) && $scope.uniqueId !== evtData.uniqueId) {
				return;
			}

			// build full object from event data (events may not pass all properties)
			var syncUpdate = {
				config: evtData.config || $scope.syncChart.config,
				data: Array.isArray(evtData.data) ? evtData.data : $scope.syncChart.data,
				render: $scope.syncChart.render
			};

			// apply render property?
			if(evtData.render === '' || evtData.render === 'now' || evtData.render === 'animate') {
				syncUpdate.render = evtData.render;
			}

			// replace scope property, this will fire linkFx $watch event
			$scope.syncChart = syncUpdate;

		});

	}


	function linkFx($scope, $elem, $attrs) {

		/**
		 *    syncChart EVENT HOOK
		 *    fires when controller updates $scope.syncChart
		 */

		$scope.$watch('syncChart', d3RenderChart);


		/**
		 *    D3 RENDER
		 */

		var _colorBars = [],
			_chartSize = {},
			_plot = {};

		function d3RenderChart() {

			// clear svg elements if anything is missing
			var sync = $scope.syncChart;
			if((sync.render != 'now' && sync.render != 'animate') || !!!sync.config || sync.data.length < 1) {
				d3.select($elem[0]).selectAll('*').remove();
				return;
			}

			var dataset = sync.data;

			// parse and validate chart params
			_colorBars = sync.config.colors;
			var userParams = parseParams(sync);

			// chart size and plot area
			_chartSize = $elem.parent()[0].getBoundingClientRect();
			_plot = calculateChartPlot(_chartSize,
				{ // padding
					top: 25,
					right: 20 + 10, // adding 10 because yAxis text requires extra space, so makes right look squished
					bottom: 25,
					left: 40
				},
				{ // axis
					x: {
						height: 15,
						leftIndent: 5
					},
					y: {
						width: userParams.yAxis.showText ? 30 : 0
					}
				}
			);


			/**
			 *    VALUE MAPPING
			 *    property names to use for data series
			 */

			var xVal = function(d) {
				return d.name;
			};

			var yVal = function(d) {
				return d.val;
			};

			// Y value formatting
			var fmtYvalue = function(d) {
				switch(userParams.yAxis.format) {
					case 'fixed':
						return d3.format(',.2f')(d);
					case 'number':
					case 'integer':
						return d3.format(',.0f')(d);
					case 'currency':
						if(d >= 0) {
							return '$' + d3.format(',.0f')(d);
						}
						else {
							return '$(' + d3.format(',.0f')(d * -1) + ')';
						}
						break;
					case 'percent':
						return d3.format(',.0f')(d) + '%';
					case 'percent.1':
						return d3.format(',.1f')(d) + '%';

					default:
						throw new Error('widget-chart-timeseries.fmtYvalue, number type unknown: ' + userParams.yAxis.format);
				}
			};


			/**
			 *    SCALE
			 *    convert data min/max values into pixel sizes
			 */

			// X scale (labels)
			var xLabels = userParams.xAxis.labels,
				domainIds = [];
			for(var did = 0; did < xLabels.length; did++) {
				domainIds.push(xLabels[did].id);
			}
			var xScale = d3.scalePoint()
				.domain(domainIds)
				.rangeRound([_plot.x.left, _plot.x.right]);
				//.padding(0.1);

			// Y scale (numbers)
			var yScale = d3.scaleLinear()
				.domain([userParams.yAxis.minVal,userParams.yAxis.maxVal])
				.range([_plot.y.bottom, _plot.y.top])
				.nice();


			/**
			 *    MAP COORDINATES
			 *    convert x/y values into x,y coordinates using X/Y scales from above
			 */

			var xMap = function(d) {
				return xScale(xVal(d));
			};

			var yMap = function(d) {
				return yScale(yVal(d));
			};


			/**
			 *    AXIS
			 *    setup x and y axis
			 */

			// X axis: time scale
			var xAxis = d3.axisBottom(xScale)
				.tickSize(3)
				.tickFormat(function(d){ return '';}); // not text, adding custom 2 line label below

			// y axis text
			var fmtYaxisText;
			if(userParams.yAxis.showText) {
				fmtYaxisText = fmtYvalue;
			}
			else {
				// don't show any text
				fmtYaxisText = function(d){ return '';};
			}

			var yAxis = d3.axisLeft(yScale)
				.tickSize(-(_plot.y.right - _plot.y.left)) // negative draws to the right, draw from y axis to data.right
				.tickFormat(fmtYaxisText)
				.ticks(8);


			/**
			 *    VALUE DATA
			 */

			// value line render: define
			var linePathRender = d3.line()
				.x(function(d) {
					return xScale(d.name); }
				)
				.y(function(d) {
					return yScale(d.val);
				})
				.curve(d3.curveMonotoneX);


			/**
			 *    RENDER SVG
			 */

			// clear previous elements
			d3.select($elem[0]).selectAll('*').remove();

			// d3 SVG container
			var svg = d3.select($elem[0])
				.append('svg')
				.attr('width', _chartSize.width)
				.attr('height', _chartSize.height)
				.attr('class', $scope.uniqueCSS)
				.append('g')
					.attr('transform', 'translate(0,0)');


			/**
			 *    RENDER Y AXIS
			 */

			// Y axis render
			svg.append('g')
				.attr('class', 'yaxis')
				.attr('transform', 'translate(' + _plot.y.left + ',' + '0' + ')')
				.call(yAxis);


			/**
			 *    RENDER X AXIS
			 */

			// X axis render
			var xAxisRender = svg.append('g')
				.attr('class', 'xaxis')
				.attr('transform', 'translate(' + '0' + ',' + _plot.x.top + ')')
				.call(xAxis);

			// X axis tick labels
			var xTickLabelTop = function(d, i) {
				return xLabels[i].tickTextTop;
			};
			var xTickLabelBtm = function(d, i) {
				return xLabels[i].tickTextBtm;
			};

			// X axis render labels two lines: Month / over date
			xAxisRender
				.selectAll('.tick text')
					.append('tspan')
						.text(xTickLabelTop)
						.attr('x', '0')
						.attr('text-anchor', 'middle')
					.append('tspan')
						.text(xTickLabelBtm)
						.attr('x', '0')
						.attr('dy', _plot.x.height)
						.attr('text-anchor', 'middle');


			/**
			 *    RENDER LINES AND DOTS
			 */

			/* jshint ignore:start */
			var linePaths = [];
			var linePoints = [];
			var lineCSS = '';
			for(var ds = 0; ds < dataset.length; ds++) {
				lineCSS = !!dataset[ds].selected ? 'data-line-highlight' : 'data-line';

				linePaths.push(svg.append('path')
					.attr('class', lineCSS)
					.attr('d', linePathRender(dataset[ds].series)));

				if(userParams.useDots) {
					linePoints.push(
						svg.selectAll('data-point')
						.data(dataset[ds].series)
						.enter()
						.append('circle')
						.attr('class', 'data-point')
						.attr('cx', function(d) { return xMap(d);})
						.attr('cy', function(d) { return yMap(d);})
						.attr('r', 5)
						.style('opacity', 1)
						.style('opacity', 1)
					);
				}
			}

			// ANIMATE LINES AND DOTS
			var linePathNodes = 0;
			try {
				if(userParams.useDots) {
					for(var lp = 0; lp < linePaths.length; lp++) {
						linePathNodes = linePaths[lp].node().getTotalLength();
						linePaths[lp]
							.attr('stroke-dasharray', linePathNodes + ' ' + linePathNodes)
							.attr('stroke-dashoffset', linePathNodes)
							.transition()
							.duration(1000)
							.style('stroke',_colorBars[lp])
							.ease(d3.easeLinear)
							.delay(300)
							.attr('stroke-dashoffset', 0);
						linePoints[lp]
							.attr('cy', 0)
							.style('opacity', 0)
							.style('fill',_colorBars[lp])
							.transition()
							.duration(1000)
							.delay(function(d, i) { return (i * 100) + 150; })
							.ease(d3.easeBounceOut)
							.attr('cx', function(d) { return xScale(d.name); })
							.attr('cy', function(d) { return yScale(d.val); })
							.attr('r', 5)
							.style('opacity', 1);
					}
				}
			}
			catch(err) {
				// IE FIX: no animation if the node() call throws an error
			}
			/* jshint ignore:end */
		}


		/**
		 *    HELPERS
		 */

		function parseParams(sync) {

			// validate and parse params into chart object

			// render
			if(sync.render != 'now' && sync.render != 'animate') {
				throw new Error('widget-chart-timeseries.render, config.render unknown: ' + sync.render);
			}

			// color bars
			var paramBarColors = sync.config.colors;
			if(!Array.isArray(paramBarColors) || paramBarColors.length < 1) {
				throw new Error('widget-chart-timeseries.render, config.colors array length must be > 0');
			}

			// x axis
			var paramXaxis = sync.config.xAxis || {};
			if(!!!paramXaxis.showText) {
				throw new Error('widget-chart-timeseries.render, config.xAxis.showText required');
			}
			if(!Array.isArray(paramXaxis.labels) || (!!paramXaxis.showText && paramXaxis.labels.length < 1)) {
				throw new Error('widget-chart-timeseries.render, config.xAxis.showText required');
			}

			// y axis
			var paramYaxis = sync.config.yAxis || {};
			if(paramYaxis.format != 'number' && paramYaxis.format != 'currency' && paramYaxis.format != 'percent' && paramYaxis.format != 'percent.1' && paramYaxis.format != 'fixed' && paramYaxis.format != 'integer') {
				throw new Error('widget-chart-timeseries.render, config.yAxis.format unknown: ' + paramYaxis.format);
			}
			if(!!!paramYaxis.showText) {
				throw new Error('widget-chart-timeseries.render, config.yAxis.showText required');
			}
			if(!validSvc.isNumber(paramYaxis.minVal) || !validSvc.isNumber(paramYaxis.maxVal)) {
				throw new Error('widget-chart-timeseries.render, config.yAxis. min and max val required');
			}
			if(paramYaxis.minVal > paramYaxis.maxVal) {
				throw new Error('widget-chart-timeseries.render, config.yAxis. minVal is greater than maxVal');
			}

			return {
				bar: {
					colorFn: function (idx) {
						var len = _colorBars.length;
						if(len === 1) {
							return _colorBars[0];
						}
						else if(idx < len) {
							return _colorBars[idx];
						}
						else {
							// idx is > bar colors available
							return _colorBars[Math.floor(idx % len)];
						}
					}
				},
				xAxis: {
					showText: paramXaxis.showText,
					labels: paramXaxis.labels
				},
				yAxis: {
					minVal: paramYaxis.minVal,
					maxVal: paramYaxis.maxVal,
					showText: paramYaxis.showText,
					format: paramYaxis.format.toString()
				},
				useDots: !!sync.config.useDots // use dots and animation
			};

		}

		function calculateChartPlot(size, pad, axis) {

			// create chart width and height dimensions including x/y axis

			// data plot area
			var plot = {
				data: {
					top: pad.top,
					left: pad.left + axis.y.width + axis.x.leftIndent,
					right: size.width - pad.right,
					bottom: size.height - axis.x.height - pad.bottom
				}
			};

			// X axis plot
			plot.x = {
				height: axis.x.height,
				top: plot.data.bottom,
				left: plot.data.left,
				right: plot.data.right,
				bottom: plot.data.bottom + axis.x.height
			};

			// Y axis plot
			plot.y = {
				top: plot.data.top,
				left: pad.left + axis.y.width,
				right: plot.data.right,
				bottom: plot.data.bottom
			};

			return plot;

		}

	}

}
 /**
 *    VERTICAL BAR GRAPH CONFIG
 *    Y axis is numeric values
 *    X axis is ordinal entries (single line)
 */

widChartVbar.$inject = ['validSvc'];
angular.module('espui.core.ui')
.directive('widgetChartVbar', widChartVbar);

/* @ngInject */
function widChartVbar(validSvc) {

	ctl.$inject = ['$scope'];
	var widget = {
		restrict: 'A',
		scope: {
			uniqueId: '@'
		},
		controller: ctl,
		link: linkFx
	};

	return widget;

	/* @ngInject */
	function ctl($scope) {

		/**
		 *    INIT
		 */

		init();

		function init() {

			// d3 needs a unique CSS handle to this specific chart
			$scope.uniqueCSS = $scope.uniqueId + 'D3';

			$scope.syncChart = {
				config: null,
				data: [],
				render: ''
			};

		}

		$scope.$on('$destroy', function() {
			// clean up listener on destroy
			_unregisterListener();
		});


		/**
		 *    CHART SYNC EVENT HOOK
		 *    catches sync events thrown by page
		 *    updates $scope.syncChart which is watched by linkFx function
		 */

		var _unregisterListener = $scope.$on('widget.chart.sync', function(event, evtData) {

			// check event id matches this chart
			if(validSvc.isText(evtData.uniqueId)) {
				if($scope.uniqueId === evtData.uniqueId) {

					// build full object from event data (events may not pass all properties)
					var syncUpdate = {
						config: evtData.config || $scope.syncChart.config,
						data: Array.isArray(evtData.data) ? evtData.data : $scope.syncChart.data,
						render: $scope.syncChart.render
					};

					// apply render property?
					if(evtData.render === '' || evtData.render === 'now' || evtData.render === 'animate') {
						syncUpdate.render = evtData.render;
					}

					// replace scope property, this will fire linkFx $watch event
					$scope.syncChart = syncUpdate;

				}
			}

		});

	}

	function linkFx($scope, $elem, $attrs) {

		/**
		 *    syncChart EVENT HOOK
		 *    fires when controller updates $scope.syncChart
		 */

		$scope.$watch('syncChart', d3RenderChart);


		/**
		 *    D3 RENDER
		 */

		var _colorBars = [],
			_chartSize = {},
			_plot = {},
			_lblLines = [];

		function d3RenderChart() {

			// clear svg elements if anything is missing
			var sync = $scope.syncChart;
			if((sync.render != 'now' && sync.render != 'animate') || !!!sync.config || sync.data.length < 1) {
				d3.select($elem[0]).selectAll('*').remove();
				return;
			}
			var dataset = sync.data;

			// parse and validate chart params
			_colorBars = sync.config.colors;
			var userParams = parseParams(sync);

			// chart size and plot area
			_chartSize = $elem.parent()[0].getBoundingClientRect();
			_plot = calculateChartPlot(_chartSize,
				{ // padding
					top: 25,
					right: 20 + 10, // adding 10 because yAxis text requires extra space, so makes right look squished
					bottom: 25,
					left: 40
				},
				{ // axis
					x: {
						height: 15,
						leftIndent: 5
					},
					y: {
						width: userParams.yAxis.showText ? 30 : 0
					}
				}
			);

			_lblLines = userParams.label.lines;


			/**
			 *    VALUE MAPPING
			 *    property names to use for data series
			 */

			var xVal = function(d) {
				return d.name;
			};

			var yVal = function(d) {
				return d.val;
			};


			/**
			 *    SCALE
			 *    convert data min/max values into pixel sizes
			 */

			// parse labels
			var dataLabels = [];
			for(var ix = 0; ix < dataset.length; ix++) {
				dataLabels.push(dataset[ix].name);
			}

			// X scale (labels)
			var xScale = d3.scaleBand()
				.domain(dataLabels)
				.rangeRound([_plot.x.left, _plot.x.right])
				.padding(0.1);

			var xBarWidth = xScale.bandwidth();


			// Y scale (numbers)
			var yScale = d3.scaleLinear()
				.domain([
					0, //d3.min(dataset, yVal),
					d3.max(dataset, yVal)
				])
				.range([_plot.y.bottom, _plot.y.top])
				.nice();


			/**
			 *    PLOT COORDINATES
			 *    convert x/y values into x,y plot coordinates using X/Y scales from above
			 */

			var xPlot = function(d) {
				return xScale(xVal(d));
			};

			var yPlot = function(d) {
				return yScale(yVal(d));
			};


			/**
			 *    AXIS
			 *    setup x and y axis
			 */

			// X axis: formatting
			var xAxis = d3.axisBottom(xScale)
				.tickSize(3)
				.tickFormat(function(d){ return '';}); // not text, adding custom 2 line label below

			// Y axis labels
			var fmtYvalue;

			if(userParams.yAxis.showText) {

				fmtYvalue = function(d) {
					switch(userParams.yAxis.format) {
						case 'fixed':
							return d3.format(',.2f')(d);
						case 'number':
							return d3.format(',.0f')(d);
						case 'currency':
							if(d >= 0) {
								return '$' + d3.format(',.0f')(d);
							}
							else {
								return '$(' + d3.format(',.0f')(d * -1) + ')';
							}
							break;
						default:
							throw new Error('widget-chart-vbar.fmtYvalue, number type unknown: ' + userParams.yAxis.format);
					}
				};
			}
			else {
				// don't show y axis labels
				fmtYvalue = function(d){ return '';};
			}

			// Y axis: formatting
			var yAxis = d3.axisLeft(yScale)
				.tickSize(-(_plot.y.right - _plot.y.left)) // negative draws to the right, draw from y axis to data.right
				.tickFormat(fmtYvalue)
				.ticks(8);


			/**
			 *    RENDER SVG
			 */

			// clear previous elements
			d3.select($elem[0]).selectAll('*').remove();

			// d3 SVG container
			var svg = d3.select($elem[0])
				.append('svg')
				.attr('width', _chartSize.width)
				.attr('height', _chartSize.height)
				.attr('class', $scope.uniqueCSS)
				.append('g')
					.attr('transform', 'translate(0,0)');


			/**
			 *    RENDER Y AXIS
			 */

			// Y axis render
			svg.append('g')
				.attr('class', 'yaxis')
				.attr('transform', 'translate(' + _plot.y.left + ',' + '0' + ')')
				.call(yAxis);


			/**
			 *    RENDER VALUE BARS
			 *    note: render before X-Axis so bars are hidden while they slide up
			 */

			// value 1: data bars
			var val1Bars = svg.selectAll('data-vbar')
				.data(dataset)
				.enter()
				.append("rect")
				.attr('class', 'data-vbar')
				.attr('x', function(d) { return xPlot(d); })
				.attr('y', function(d) { return yPlot(d); })
				.attr('width', xBarWidth)
				.attr('height', function(d) { return _plot.data.bottom - yPlot(d); })
				.style('fill', function(d, i) { return userParams.bar.colorFn(i); });

			// vertical text?
			if(userParams.xAxis.verticalText) {

				// add white bkg to bar
				svg.selectAll('data-vbar')
					.data(dataset)
					.enter()
					.append("rect")
						.attr('x', function(d) { return xPlot(d) + (xBarWidth / 2) - 8; })
						.attr('y', function(d) { return yPlot(d) - 2; })
						.attr('width', 16)
						.attr('height', function(d) {
							var ht = _plot.data.bottom - yPlot(d) - 5;
							if(ht < 1) {
								return 1;
							}
							return ht;
						})
					.style('fill', '#fff')
					.style('opacity', 0.8);

			}


			/**
			 *    RENDER X AXIS
			 */

			// X axis mask (hides value bars as they slide up from bottom under the X axis)
			var xAxisMask = svg.append('rect')
				.attr('class', 'xaxis-mask')
				.attr('x', _plot.x.left)
				.attr('y', _plot.x.top)
				.attr('width', _plot.x.right - _plot.x.left)
				.attr('height', _chartSize.height - _plot.x.top + 1);


			// X axis render
			var xAxisRender = svg.append('g')
				.attr('class', 'xaxis')
				.attr('transform', 'translate(' + '0' + ',' + _plot.x.top + ')')
				.call(xAxis);

			// X axis labels
			if(userParams.xAxis.showText) {

				// vertical text?
				if(userParams.xAxis.verticalText) {

					xAxisRender
						.selectAll('.tick text')
							.attr('transform', 'rotate(-90)') //'translate(' + (_plot.data.right - (userParams.label.width / 2)).toString() + ',' + (_plot.data.top + 20).toString() + ')');
							.append('tspan')
								.text(function(d) { return d; })
								.attr('text-anchor', 'start')
								.attr('y', -4)
								.attr('x', 10);

				// note: to add a border use: stroke="#333" stroke-width="1px"

				}
				else {
					xAxisRender
						.selectAll('.tick text')
							.append('tspan')
								.text(function(d) { return d; })
								.attr('x', '0')
								.attr('text-anchor', 'middle');
				}
			}


			/**
			 *    RENDER FLOATING DATA LABEL
			 */

			var dataLabel = svg.append('g')
				.attr('class', 'data-label')
				.attr('transform', 'translate(' + (_plot.data.right - (userParams.label.width / 2)).toString() + ',' + (_plot.data.top + 20).toString() + ')');

				// append rect label bkg
				dataLabel.append('rect')
					.attr('class', 'lbl-bkg')
					.attr('x', -userParams.label.width / 2)
					.attr('y', -userParams.label.height / 2)
					.attr('rx', 3)
					.attr('ry', 3)
					.attr('width', userParams.label.width)
					.attr('height', userParams.label.height);

			// append text centered inside rect bkg
			var dataLabelText = dataLabel.append('text')
					.attr('class', 'lbl-text')
					.attr('x', (-userParams.label.width / 2) + 10)
					.attr('y', (-userParams.label.height / 2) + 5)
					.attr('text-anchor', 'left')
					.text('');

			// add label lines
			var lblLines = Array.isArray(userParams.label.lines) ? userParams.label.lines : [];
			for(var li = 0; li < lblLines.length; li++) {
				dataLabelText.append('tspan')
					.attr('class', 'lbl-text ln' + (li + 1).toString())
					.attr('text-anchor', 'left')
					.attr('x', ((-userParams.label.width / 2) + 10).toString())
					.attr('dy', '15')
					.text('.');
			}


			/**
			 *    RENDER MOUSE HOVER BARS
			 *    render after label so user moving mouse doesn't blink labelf or cursor
			 */

			// value 1: data bars for mouse hover
			svg.selectAll('data-vbar')
				.data(dataset)
				.enter()
				.append("rect")
				.attr('x', function(d) { return xPlot(d); })
				.attr('y', _plot.data.top + 1)
				.attr('width', xBarWidth)
				.attr('height', _plot.data.bottom - _plot.data.top - 1)
				.style('opacity', 0)
				.on("mouseenter", function(d, i) {

					// get svg class
					var thisSvg = d3.select('svg.' + $scope.uniqueCSS);

					// get label
					var dLabel = thisSvg.select('.data-label');
					var dLabelBkg = dLabel.select('.lbl-bkg');

					// get data point mouse is over
					var thisPoint = d3.select(this);
					var plotPlace = {
						x: parseInt(thisPoint.attr('x')) + (parseInt(thisPoint.attr('width')) / 2),
						y: parseInt(thisPoint.attr('y'))
					};

					// move label y up if too close to x axis
					var bottomOfBar = parseInt(thisPoint.attr('y')) + parseInt(thisPoint.attr('height'));
					if(plotPlace.y + parseInt(dLabelBkg.attr('height')) >= bottomOfBar) {
						plotPlace.y -= ((parseInt(dLabelBkg.attr('height')) / 2) + 5);
					}

					// fill in labels
					for (var lit = 0; lit < _lblLines.length; lit++) {
						dLabel.select('.lbl-text.ln' + (lit + 1).toString()).text(_lblLines[lit].title + ': ' + d[_lblLines[lit].dataProp]);
					}

					// fade in
					dLabel
						.style('visibility', 'visible')
						.style('opacity', 0)
						.transition()
						.duration(250)
						.ease(d3.easeLinear)
						.style('opacity', 0.85);

				})
				.on("mouseleave", function() {
					// get svg class
					var thisSvg = d3.select('svg.' + $scope.uniqueCSS);

					// get label
					var dLabel = thisSvg.select('.data-label');
					dLabel.style('visibility', 'hidden');
				});


			/**
			 *    ANIMATION
			 */

			if(sync.render == 'animate') {

				// value bars: slide up
				val1Bars
					.attr('y', _plot.data.bottom + 1)
					.transition()
						.duration(800)
						.delay(function(d, i) { return (i * 100) + 100; })
						.ease(d3.easeElastic)
						.attr('y', function(d) { return yPlot(d); });
			}

		}


		/**
		 *    HELPERS
		 */

		function parseParams(sync) {

			// validate and parse params into chart object

			// render
			if(sync.render != 'now' && sync.render != 'animate') {
				throw new Error('widget-chart-vbar.render, config.render unknown: ' + sync.render);
			}

			// color bars
			var paramBarColors = sync.config.colors;
			if(!Array.isArray(paramBarColors) || paramBarColors.length < 1) {
				throw new Error('widget-chart-vbar.render, config.colors array length must be > 0');
			}

			// x axis
			var paramXaxis = sync.config.xAxis || {};
			if(paramXaxis.showText !== true && paramXaxis.showText !== false) {
				throw new Error('widget-chart-vbar.render, config.xAxis.showText required');
			}

			// y axis
			var paramYaxis = sync.config.yAxis || {};
			if(paramYaxis.format != 'number' && paramYaxis.format != 'currency' && paramYaxis.format != 'fixed') {
				throw new Error('widget-chart-vbar.render, config.yAxis.format unknown: ' + paramYaxis.format);
			}
			if(paramYaxis.showText !== true && paramYaxis.showText !== false) {
				throw new Error('widget-chart-vbar.render, config.yAxis.showText required');
			}

			// label params
			var paramLabel = sync.config.label || {};
			if(!validSvc.isNumber(paramLabel.width) || !validSvc.isNumber(paramLabel.height) || !Array.isArray(paramLabel.lines)) {
				throw new Error('widget-chart-vbar.render, config.label.width/height/lines required');
			}

			return {
				bar: {
					colorFn: function (idx) {
						var len = _colorBars.length;
						if(len === 1) {
							return _colorBars[0];
						}
						else if(idx < len) {
							return _colorBars[idx];
						}
						else {
							// idx is > bar colors available
							return _colorBars[Math.floor(idx % len)];
						}
					}
				},
				yAxis: {
					showText: paramYaxis.showText,
					format: paramYaxis.format.toString()
				},
				xAxis: {
					showText: paramXaxis.showText,
					verticalText: !!paramXaxis.verticalText
				},
				label: {
					width: paramLabel.width,
					height: paramLabel.height,
					lines: paramLabel.lines
				}
			};

		}

		function calculateChartPlot(size, pad, axis) {

			// create chart width and height dimensions including x/y axis

			// data plot area
			var plot = {
				data: {
					top: pad.top,
					left: pad.left + axis.y.width + axis.x.leftIndent,
					right: size.width - pad.right,
					bottom: size.height - axis.x.height - pad.bottom
				}
			};

			// X axis plot
			plot.x = {
				top: plot.data.bottom,
				left: plot.data.left,
				right: plot.data.right,
				bottom: plot.data.bottom + axis.x.height
			};

			// Y axis plot
			plot.y = {
				top: plot.data.top,
				left: pad.left + axis.y.width,
				right: plot.data.right,
				bottom: plot.data.bottom
			};

			return plot;

		}

	}
}
 
angular
.module('espui.core.ui')
.directive('widgetFieldStatus', widFieldStatus);

// <span widget-field-status watch="vm.model.Email" show-icon="true" show-msg="true" />

/* @ngInject */
function widFieldStatus() {

	ctl.$inject = ['$scope'];
	return {
		restrict: 'A',
		replace: true,
		scope: {
			field: '=',
			showIcon: '@',
			showMsg: '@'
		},
		templateUrl: 'core/ui/widget/field/widget-field-status.tpl.html',
		controller: ctl,
		controllerAs: 'vm'
	};

	/* @ngInject */
	function ctl($scope) {

		var vm = this;

		vm.showIcon = false;
		vm.showMsg = false;


		/**
		 *    INIT
		 */

		init();

		function init() {

			// default show both, only turn off if specified as 'no'
			vm.showIcon = $scope.showIcon == 'no' ? false : true;
			vm.showMsg = $scope.showMsg == 'no' ? false : true;

		}

	}
}

 
widInputDatePick.$inject = ['appConst', 'utilSvc', 'validSvc', 'msgSvc'];
angular
.module('espui.admin')
.directive('widgetInputDatePick', widInputDatePick);

/* @ngInject */
function widInputDatePick(appConst, utilSvc, validSvc, msgSvc) {

	ctl.$inject = ['$scope'];
	return {
		restrict: 'A',
		replace: true,
		scope: {
			uniqueId: '@',
			dtTitle: '@'
		},
		templateUrl: 'core/ui/widget/input/widget-input-date-pick.tpl.html',
		controller: ctl,
		controllerAs: 'vm'
	};

	/* @ngInject */
	function ctl($scope) {

		var vm = this,
			_unregisterListener = null,
			_displayMth = new Date(),
			_setDate = null,
			_endDate = null,
			_minDate = new Date(),
			_maxDate = new Date();

		// props
		vm.isWaiting = false;
		vm.title = '';
		vm.mthTitle = '';
		vm.weeks = [];

		// alt text
		vm.altShow = false;
		vm.altChecked = false;
		vm.altText = '';

		// methods
		vm.mthChange = mthChange;
		vm.dayClick = dayClick;
		vm.altToggle = altToggle;


		/**
		 *    CONTROLLER EVENT HOOKS
		 *    parent controller starts this directive with an event
		 */

		_unregisterListener = $scope.$on('widget.input.date.pick', function(event, evtData) {

			// params
			if(!evtData) {
				alert('widget.input.date.pick, evtData required');
			}

			// event has a unique id?
			if(validSvc.isText(evtData.uniqueId)) {
				if($scope.uniqueId !== evtData.uniqueId) {
					return;
				}
			}

			init(evtData);

		});

		$scope.$on('$destroy', function() {
			_unregisterListener();
		});


		/**
		 *    INIT
		 */

		function init(ctx) {

			// note: init is started by a parent event

			vm.isWaiting = true;
			var dtToday = utilSvc.dt.zeroTime(new Date());

			vm.title = validSvc.isText(ctx.title) ? ctx.title : $scope.dtTitle;

			if(validSvc.isDate(ctx.minDate)) {
				_minDate = utilSvc.dt.zeroTime(new Date(ctx.minDate));
			}
			else {
				// default 340B start date
				_minDate = new Date(1992,10,1,0,0,0);
			}

			if(validSvc.isDate(ctx.maxDate)) {
				_maxDate = utilSvc.dt.zeroTime(new Date(ctx.maxDate));
			}
			else {
				// default 1 year from now
				_maxDate = utilSvc.dt.addMonths(dtToday, 12);
			}

			// alt text
			vm.altShow = validSvc.isText(ctx.altText);
			if(vm.altShow) {
				vm.altText = ctx.altText;
				vm.altChecked = !!ctx.altChecked;
			}

			// build month based on set date or today
			// note: setDate may be null if alt text is being used
			_setDate = validSvc.isDate(ctx.setDate) ? utilSvc.dt.zeroTime(ctx.setDate) : null;
			_endDate = validSvc.isDate(ctx.endDate) ? utilSvc.dt.zeroTime(ctx.endDate) : null;
			if(_setDate !== null) {
				vm.weeks = buildMonth(_setDate);
			}
			else {
				vm.weeks = buildMonth(dtToday);
			}

			vm.isWaiting = false;

		}

		function buildMonth(dtMonth) {

			// rebuild display month day series

			var wks = [];

			_displayMth = utilSvc.dt.monthStart(dtMonth);
			vm.mthTitle = utilSvc.dt.monthShortText(_displayMth).toUpperCase() + ' ' + _displayMth.getFullYear().toString();

			// set month
			var mthStart = _displayMth,
				mthEnd = utilSvc.dt.monthEnd(mthStart);

			var dtStart = mthStart,
				dtEnd = mthEnd;

			// move start date back to Monday of this week
			while(dtStart.getDay() !== 1) {
				dtStart = utilSvc.dt.addDays(dtStart, -1);
			}

			// move end date forward to Sunday of this week
			while(dtEnd.getDay() !== 0) {
				dtEnd = utilSvc.dt.addDays(dtEnd, 1);
			}

			// series
			var i = 0,
				days = [],
				day = {},
				setDateValid = validSvc.isDate(_setDate),
				minDateValid = validSvc.isDate(_minDate),
				maxDateValid = validSvc.isDate(_maxDate);

			while(dtStart < dtEnd) {

				days = [];
				for(i = 0; i < 7; i++) {

					day = {
						is: 'ok',
						dt: dtStart,
						txt: dtStart.getDate().toString()
					};

					if(dtStart < mthStart || dtStart > mthEnd) {
						// outside displayed month
						day.is = 'off';
					}
					else if(setDateValid && dtStart.getTime() === _setDate.getTime()) {
						day.is = 'set';
					}
					else if(minDateValid && dtStart < _minDate) {
						// before minDate
						day.is = 'off';
					}
					else if(maxDateValid && dtStart > _maxDate) {
						// after maxDate
						day.is = 'off';
					}

					days.push(day);

					// advance day
					dtStart = utilSvc.dt.addDays(dtStart, 1);
				}

				wks.push({days: days});
			}

			return wks;

		}

		function mthChange(increment) {

			// advance display month back/fwd, has no affect on set date

			if(vm.isWaiting) {
				return;
			}

			vm.weeks = buildMonth(utilSvc.dt.addMonths(_displayMth, increment));

			vm.isWaiting = false;
		}

		function dayClick(pick) {

			// send date to controller

			if(vm.isWaiting) {
				return;
			}

			// end date adjustment, has to come on or after set date
			_endDate = validSvc.isDate(_endDate) ? _endDate : pick.dt;
			if(utilSvc.dt.diffMilli(pick.dt, _endDate) < 0) {
				// end date is before pick date
				_endDate = pick.dt;
			}

			notifyDatePick(pick.dt, _endDate);

			/* tbd: keep picker open when clicked
			switch(pick.is) {

				case 'set':
					// no action, its already chosen
					break;

				case 'off':
					if(pick.dt < _displayMth) {
						// last month
						if(pick.dt >= _minDate) {
							_setDate = pick.dt;
							notifyDatePick(_setDate);
						}
						mthChange(-1);
					}
					else if(pick.dt > utilSvc.dt.monthEnd(_displayMth)) {
						// next month
						if(pick.dt <= _maxDate) {
							_setDate = pick.dt;
							notifyDatePick(_setDate);
						}
						mthChange(1);
					}
					break;

				case 'ok':
				case 'end':
					_setDate = pick.dt;
					notifyDatePick(_setDate);
					vm.weeks = buildMonth(_setDate);
					break;

				default:
					throw new Error('widInputDatePick.dayClick, unknown day type: ' + pick.is);
			}

			vm.isWaiting = false;
			*/

		}

		function altToggle() {

			if(vm.isWaiting) {
				return;
			}

			vm.altChecked = !vm.altChecked;

			$scope.$emit('widget.input.date.pick.change',{
				uniqueId: $scope.uniqueId,
				altText: vm.altText,
				altChecked: vm.altChecked
			});

		}

		function notifyDatePick(setDate, endDate) {

			$scope.$emit('widget.input.date.pick.change',{
				uniqueId: $scope.uniqueId,
				setDate: setDate,
				endDate: endDate
			});

		}

	}

}
 
widInputDateRange.$inject = ['$timeout', 'appConst', 'utilSvc', 'validSvc'];
angular
.module('espui.core.ui')
.directive('widgetInputDateRange', widInputDateRange);

/* @ngInject */
function widInputDateRange($timeout, appConst, utilSvc, validSvc) {

	ctl.$inject = ['$scope'];
	return {
		restrict: 'A',
		replace: true,
		scope: {
			uniqueId: '@',
			hideErrorText: '@',
			lblText: '@',
			rangeModeList: '=',
			startDate: '=',
			endDate: '=',
			rangeChange: '&'
		},
		templateUrl: 'core/ui/widget/input/widget-input-date-range.tpl.html',
		controller: ctl,
		controllerAs: 'vm'
	};

	/* @ngInject */
	function ctl($scope) {

		var vm = this,
			_regexDate = utilSvc.regex.dateFmt(true), // use 2 digit year "yy" instead of "yyyy"
			_unregisterListener = null,
			_unregisterDtPickListener = null,
			_mouseLeaveDelay = 0;

		// properties
		vm.show = {};
		vm.monthlyMonth = {};
		vm.monthlyYear = {};
		vm.qtrName = {};
		vm.qtrYear = {};
		vm.yearly = {};
		vm.rangeMode = 'MTD';
		vm.hideErrorText = false;

		// methods
		vm.modeChange = modeChange;
		vm.monthlyChange = monthlyChange;
		vm.yearlyChange = yearlyChange;
		vm.qtrChange = qtrChange;
		vm.customDateChange = customDateChange;

		// date pick
		vm.dtPickShowStart = false;
		vm.dtPickShowEnd = false;
		vm.dtPickOpen = dtPickOpen;
		vm.dtPickMouseHover = dtPickMouseHover;


		/**
		 *    CONTROLLER EVENT HOOKS
		 *    parent controller broadcasts mode update events
		 */

		_unregisterListener = $scope.$on('widget.input.date.range.mode', function(event, evtData) {

			// event has a unique id?
			if(validSvc.isText(evtData.uniqueId)) {
				if($scope.uniqueId !== evtData.uniqueId) {
					return;
				}
			}

			// ignore empty mode changes
			if(!validSvc.isText(evtData.mode)) {
				//console.log('Date Range Widget, date mode is empty');
				return;
			}

			$scope.rangeMode = evtData.mode;
			modeChange(!!evtData.keepDates);

			// note: mode change event has possibility to fire two parentUpdates from 1 mode event
			//			added property suppressParentEvent to stop this issue
			//console.log('DT MODE EVT SCOPE DATA: Start ' + $scope.startDate.val + ', End ' + $scope.endDate.val);

		});

		_unregisterDtPickListener = $scope.$on('widget.input.date.pick.change', function(event, evtData) {
			event.stopPropagation();

			// params
			if(!evtData || !validSvc.isText(evtData.uniqueId)) {
				alert('widget.input.date.pick.change, evtData and uniqueId required');
			}

			switch(evtData.uniqueId) {
				case 'StartDate':
					vm.dtPickShowStart = false;
					$scope.startDate.val = evtData.setDate;
					break;
				case 'EndDate':
					vm.dtPickShowEnd = false;
					$scope.endDate.val = evtData.setDate;
					break;
				default:
					alert('widget-input-date-range.change evt, unknown uniqueId: ' + evtData.uniqueId);
			}

			// re-validate both dates
			$scope.startDate = validSvc.propDateValid($scope.startDate);
			$scope.endDate = validSvc.propDateValid($scope.endDate);

			// date range
			if(!$scope.startDate.fail && !$scope.endDate.fail) {
				customDateRange(evtData.uniqueId, $scope.startDate, $scope.endDate);
			}

			//console.log('dtrange pick listener - update parent');
			updateParent();

		});


		$scope.$on('$destroy', function() {
			// clean up listener on destroy
			_unregisterListener();
			_unregisterDtPickListener();
		});


		/**
		 *    INIT
		 */

		init();

		function init() {

			// startDate.min and endDate.max must exist
			if(!!!$scope.startDate || !validSvc.isDate($scope.startDate.min) || !!!$scope.endDate || !validSvc.isDate($scope.endDate.max)) {
				throw new Error('widget-input-date-range.initScopeDates, startDate.min or endDate.max is missing');
			}

			// default label text (if none provided)
			if(!validSvc.isText($scope.lblText)) {
				$scope.lblText = 'Date Range';
			}

			// month droplist
			vm.monthlyMonth = validSvc.newProp(null);
			vm.monthlyMonthList = utilSvc.ng.monthFullDroplist();

			// qtr droplist
			vm.qtrName = validSvc.newProp(null);
			vm.qtrNameList = [
				{label:'Q1 - Jan through Mar', value:1},
				{label:'Q2 - Apr through Jun', value:2},
				{label:'Q3 - Jul through Sep', value:3},
				{label:'Q4 - Oct through Dec', value:4}
			];

			// year droplists
			var years = [];
			for(var i = $scope.startDate.min.getFullYear(); i <= $scope.endDate.max.getFullYear(); i++) {
				years.push({label: i.toString(), value: i});
			}

			vm.monthlyYear = validSvc.newProp(null);
			vm.monthlyYearList = years;
			vm.qtrYear = validSvc.newProp(null);
			vm.qtrYearList = years;

			// drop first year, its not a whole year
			vm.YearlyList = years;
			vm.YearlyList.splice(0, 1);

			// hide err text
			vm.hideErrorText = !!$scope.hideErrorText;

		}


		/**
		 *    MODE CHANGE
		 */

		function modeChange(keepDates) {

			// in all cases hide date pickers
			vm.dtPickShowStart = false;
			vm.dtPickShowEnd = false;

			// ignore null mode events
			if(!validSvc.isText($scope.rangeMode)) {
				return;
			}

			vm.show = showDateControls($scope.rangeMode);
			if(!!keepDates) {
				useExistingDates();
			}
			else {
				resetDateInputs($scope.rangeMode);
			}

			//console.log('dtrange mode change - update parent');
			updateParent();
		}

		function showDateControls(newMode) {

			// show/hide date inputs depending on date range user selects

			var dtShow = {
				startDate: false,
				startDateEnabled: false,
				endDate: false,
				endDateEnabled: false,
				monthlyMonth: false,
				monthlyYear: false,
				qtrName: false,
				qtrYear: false,
				yearly: false
			};

			switch(newMode) {

				case 'NONE':
					return dtShow;

				case 'TODAY':
				case 'YESTERDAY':
				case 'TODAYYESTERDAY':
				case '2DAYS':
				case '3DAYS':
				case '4DAYS':
				case '7DAYS':
				case '2WEEKS':
				case 'LMTD':
				case 'MTD':
				case 'LQTD':
				case 'QTD':
				case 'QTDLAST':
				case 'YTD':
				case 'LYTD':
				case 'LTM':
				case 'LLTM':
					dtShow.startDate = true;
					dtShow.endDate = true;
					return dtShow;

				case 'QTR':
					dtShow.qtrName = true;
					dtShow.qtrYear = true;
					return dtShow;

				case 'MONTHLY':
				case 'MONTHSTART':
				case 'MONTHEND':
					dtShow.monthlyMonth = true;
					dtShow.monthlyYear = true;
					return dtShow;

				case 'YEARLY':
					dtShow.yearly = true;
					return dtShow;

				default:
					// CUSTOM
					if(isCustom(newMode)) {
						dtShow.startDate = true;
						dtShow.startDateEnabled = true;
						dtShow.endDate = true;
						dtShow.endDateEnabled = true;
						return dtShow;
					}
					throw new Error('widget-input-date-range.showDateControls, unknown date mode: ' + newMode);
			}

		}

		function resetDateInputs(newMode) {

			// re-calculate date inputs on date mode change

			var dtToday = utilSvc.dt.zeroTime(new Date());

			if(newMode == 'NONE') {

				$scope.endDate.val = null;
				$scope.startDate.val = null;

			}
			else if(isCustom(newMode)) {

				$scope.endDate.val = dtToday;
				$scope.startDate.val = dtToday;

			}
			else if(newMode == 'MONTHLY') {

				// drop down values
				vm.monthlyMonth = validSvc.newProp(dtToday.getMonth() + 1);
				vm.monthlyYear = validSvc.newProp(dtToday.getFullYear());

				$scope.startDate.val = utilSvc.dt.monthStart(dtToday);
				$scope.endDate.val = dtToday;
			}
			else if(newMode == 'MONTHSTART') {
				// drop down values
				vm.monthlyMonth = validSvc.newProp(dtToday.getMonth() + 1);
				vm.monthlyYear = validSvc.newProp(dtToday.getFullYear());

				// 1st through 15th
				var msStart = utilSvc.dt.monthStart(dtToday),
					msEnd = utilSvc.dt.zeroTime(utilSvc.dt.addDays(msStart, 14));
				$scope.startDate.val = msStart;
				$scope.endDate.val = utilSvc.dt.diffMilli(dtToday, msEnd) > 0 ? dtToday : msEnd; // end date cannot be greater than today
			}
			else if(newMode == 'MONTHEND') {
				// this is a unique case, choosing the current month with date before the 16th causes a brand new MONTHEND reset to fail
				// similar to the keep existing fn logic, this fn will move the month back 1 month so month end dates are valid
				
				var meStart = utilSvc.dt.zeroTime(utilSvc.dt.addDays(utilSvc.dt.monthStart(dtToday), 15)); // 16th
				if(utilSvc.dt.diffMilli(dtToday, meStart) > 0) {
					// 16th > today, adjust back a month
					meStart = utilSvc.dt.zeroTime(new Date(dtToday.getFullYear(), dtToday.getMonth() - 1, 16));
				}

				// drop down values
				vm.monthlyMonth = validSvc.newProp(meStart.getMonth() + 1);
				vm.monthlyYear = validSvc.newProp(meStart.getFullYear());

				// 16th through end of month
				$scope.startDate.val = meStart;
				$scope.endDate.val = utilSvc.dt.monthEnd(meStart);
				if(utilSvc.dt.diffMilli(dtToday, $scope.endDate.val) > 0) {
					$scope.endDate.val = dtToday;
				}
			}
			else if(newMode == 'YESTERDAY') {
				var dtYesterday = utilSvc.dt.zeroTime(utilSvc.dt.addDays(dtToday, -1));
				$scope.endDate.val = dtYesterday;
				$scope.startDate.val = dtYesterday;
			}
			else if(newMode == 'QTDLAST' || newMode == 'QTR') {
				var thisQTD = utilSvc.dt.quarterStart(dtToday);
				$scope.endDate.val = utilSvc.dt.zeroTime(utilSvc.dt.addDays(thisQTD, -1));
				$scope.startDate.val = utilSvc.dt.quarterStart($scope.endDate.val);

				// setup QTR dropdowns
				if(newMode == 'QTR') {
					vm.qtrName = validSvc.newProp(Math.floor($scope.startDate.val.getMonth() / 3) + 1);
					vm.qtrYear = validSvc.newProp($scope.startDate.val.getFullYear());
				}
			}
			else if(newMode == 'LQTD') {
				var thisQuarterStart = utilSvc.dt.quarterStart(dtToday);
				var lastQuarterStart = utilSvc.dt.quarterStart(utilSvc.dt.addDays(thisQuarterStart, -1));
				$scope.startDate.val = utilSvc.dt.quarterStart(lastQuarterStart);

				// get days in this QTD
				var daysThisQuarter = utilSvc.dt.diffDays(thisQuarterStart, dtToday),
					daysTotalLastQuarter = utilSvc.dt.diffDays(lastQuarterStart, thisQuarterStart);
				if(daysThisQuarter < daysTotalLastQuarter) {
					$scope.endDate.val = utilSvc.dt.addDays(lastQuarterStart, daysThisQuarter);
				}
				else {
					// not enough days in last quarter, just use full last quarter
					$scope.endDate.val = utilSvc.dt.addDays(thisQuarterStart, -1);
				}
			}
			else if(newMode == 'LMTD') {
				var thisMthStart = utilSvc.dt.zeroTime(utilSvc.dt.monthStart(dtToday));
				$scope.startDate.val = utilSvc.dt.addMonths(thisMthStart, -1);
				var prevMthEnd = utilSvc.dt.monthEnd($scope.startDate.val);
				if(dtToday.getDate() <= prevMthEnd.getDate()) {
					$scope.endDate.val = utilSvc.dt.addMonths(dtToday, -1);
				}
				else {
					// todays date is > previous month highest day number, just use month end
					$scope.endDate.val = prevMthEnd;
				}
			}
			else if(newMode == 'YEARLY') {
				// drop down values
				vm.yearly = validSvc.newProp(dtToday.getFullYear()-1);
				vm.yearly.current = false;

				$scope.startDate.val = utilSvc.dt.zeroTime(new Date(dtToday.getFullYear()-1,0,1));
				$scope.endDate.val = utilSvc.dt.zeroTime(new Date(dtToday.getFullYear()-1,11,31));
			}
			else if(newMode == 'LYTD') {
				$scope.startDate.val = utilSvc.dt.zeroTime(new Date(dtToday.getFullYear()-1,0,1));
				$scope.endDate.val = utilSvc.dt.zeroTime(new Date(dtToday.getFullYear()-1, dtToday.getMonth(), dtToday.getDate()));
			}
			else if(newMode == 'LTM') {
				$scope.startDate.val = utilSvc.dt.zeroTime(new Date(dtToday.getFullYear() - 1, dtToday.getMonth(), 1));
				var lastMthStart = utilSvc.dt.zeroTime(new Date(dtToday.getFullYear(), dtToday.getMonth() - 1, 1));
				$scope.endDate.val = utilSvc.dt.zeroTime(utilSvc.dt.monthEnd(lastMthStart));
			}
			else if(newMode == 'LLTM') {
				$scope.startDate.val = utilSvc.dt.zeroTime(new Date(dtToday.getFullYear() - 2, dtToday.getMonth(), 1));
				var prevLastMthStart = utilSvc.dt.zeroTime(new Date(dtToday.getFullYear(), dtToday.getMonth() - 1, 1));
				$scope.endDate.val = utilSvc.dt.zeroTime(utilSvc.dt.monthEnd(new Date(prevLastMthStart.getFullYear() - 1, prevLastMthStart.getMonth(), 1)));
			}
			else {

				// all other dates end on today, figure out the start date by mode
				var dtStart = new Date();

				switch(newMode) {

					case 'TODAY':
						dtStart = utilSvc.dt.zeroTime(new Date(dtToday));
						break;

					case 'TODAYYESTERDAY':
						dtStart = utilSvc.dt.zeroTime(utilSvc.dt.addDays(dtToday, -1));
						break;

					case '2DAYS':
						dtStart = utilSvc.dt.zeroTime(utilSvc.dt.addDays(dtToday, -2));
						break;

					case '3DAYS':
						dtStart = utilSvc.dt.zeroTime(utilSvc.dt.addDays(dtToday, -3));
						break;

					case '4DAYS':
						dtStart = utilSvc.dt.zeroTime(utilSvc.dt.addDays(dtToday, -4));
						break;

					case '7DAYS':
						dtStart = utilSvc.dt.zeroTime(utilSvc.dt.addDays(dtToday, -7));
						break;

					case '2WEEKS':
						dtStart = utilSvc.dt.zeroTime(utilSvc.dt.addDays(dtToday, -14));
						break;

					case 'MTD':
						dtStart = utilSvc.dt.zeroTime(utilSvc.dt.monthStart(dtToday));
						break;

					case 'QTD':
						dtStart = utilSvc.dt.zeroTime(utilSvc.dt.quarterStart(dtToday));
						break;

					case 'YTD':
						dtStart = utilSvc.dt.zeroTime(new Date(dtToday.getFullYear(),0,1));
						break;

					default:
						throw new Error('report.rx.ctl.dateChange, unknown date range: ' + newMode);
				}

				// adjust start date to be no earlier minDate
				$scope.startDate.val = utilSvc.dt.diffMilli($scope.startDate.min, dtStart) >= 0 ? dtStart : $scope.startDate.min;
				$scope.endDate.val = dtToday;

			}

			// validate changes
			$scope.startDate = validSvc.propDateValid($scope.startDate);
			$scope.endDate = validSvc.propDateValid($scope.endDate);

		}

		function useExistingDates() {

			// try to change the mode without resetting the date inputs

			var rMode = $scope.rangeMode,
				dtStart = new Date(),
				dtEnd = new Date();

			if(isCustom(rMode)) {

				// CUSTOM, start/end must be date parsable
				dtStart = utilSvc.dt.parse($scope.startDate.val);
				dtEnd = utilSvc.dt.parse($scope.endDate.val);
				if(dtStart === null || dtEnd === null) {
					throw new Error('widget-input-date-range.useExistingDates, start and end date must be valid for mode: ' + rMode);
				}

				// assign parsed date values
				$scope.startDate.val = utilSvc.dt.zeroTime(dtStart);
				$scope.endDate.val = utilSvc.dt.zeroTime(dtEnd);

				// re-do full property validation to update UI
				$scope.startDate = validSvc.propDateValid($scope.startDate);
				$scope.endDate = validSvc.propDateValid($scope.endDate);

				customDateRange('EndDate', $scope.startDate, $scope.endDate);

			}
			else if(rMode == 'MONTHLY' || rMode == 'MONTHSTART' || rMode == 'MONTHEND') {

				var monthlyDate = utilSvc.dt.parse($scope.startDate.val);
				if(monthlyDate === null) {
					throw new Error('widget-input-date-range.useExistingDates, start date is not valid for mode: ' + rMode);
				}
				monthlyDate = utilSvc.dt.zeroTime(monthlyDate);

				// setup monthly dates and validate them
				vm.monthlyYear.val = monthlyDate.getFullYear();
				vm.monthlyMonth.val = monthlyDate.getMonth() + 1;
				monthlyChange('MONTH', true);

			}
			else if(rMode == 'QTR') {

				var qtrDate = utilSvc.dt.parse($scope.startDate.val);
				if(qtrDate === null) {
					throw new Error('widget-input-date-range.useExistingDates, start date is not valid for mode: ' + rMode);
				}
				qtrDate = utilSvc.dt.zeroTime(qtrDate);

				// setup qtr dates and validate them
				vm.qtrName.val = Math.floor(qtrDate.getMonth() / 3) + 1;
				vm.qtrYear.val = qtrDate.getFullYear();
				qtrChange('QTR', true);

			}
			else if(rMode == 'YEARLY') {

				var yDate = utilSvc.dt.parse($scope.startDate.val);
				if(yDate === null) {
					throw new Error('widget-input-date-range.useExistingDates, start date is not valid for mode: ' + rMode);
				}
				yDate = utilSvc.dt.zeroTime(yDate);

				// setup monthly dates and validate them
				vm.yearly.val = yDate.getFullYear();
				yearlyChange(true);

			}
			else {

				// all other modes can be reset as usual
				resetDateInputs(rMode);
			}

		}


		/**
		 *    MONTHLY CHANGE
		 */

		function monthlyChange(chgType, suppressParentEvent) {

			// MONTHLY dropdown changed
			var rMode = $scope.rangeMode,
				dtMonthStart = new Date(vm.monthlyYear.val, vm.monthlyMonth.val - 1, 1, 0, 0, 0),
				dtToday = utilSvc.dt.zeroTime(new Date());

			var dtMonthEnd = utilSvc.dt.monthEnd(dtMonthStart),
				yearVal = dtMonthStart.getFullYear(),
				monthVal = dtMonthStart.getMonth();

			// go back a year if month is in the future
			if(chgType == 'MONTH' && utilSvc.dt.diffMilli(dtToday, dtMonthStart) >= 0) {

				// does year dropdown contain previous year?
				if(validSvc.isText(utilSvc.ng.droplistLabel(vm.monthlyYearList, yearVal - 1))) {

					// can we go back a year and be valid?
					var prevYear = new Date(yearVal - 1, monthVal, 1, 0, 0, 0);
					if(utilSvc.dt.diffMilli($scope.startDate.min, prevYear) >= 0) {
						// move start/end dates to previous year
						dtMonthStart = prevYear;
						dtMonthEnd = utilSvc.dt.monthEnd(prevYear);
						yearVal--;
						vm.monthlyYear.val = yearVal;
					}
				}
			}

			if(rMode == 'MONTHSTART') {
				// change end date to the 15th
				dtMonthEnd = utilSvc.dt.zeroTime(utilSvc.dt.addDays(dtMonthStart, 14));
			}
			else if(rMode == 'MONTHEND') {
				// change start date to the 16th, re-calc end of month off new start
				dtMonthStart = utilSvc.dt.zeroTime(utilSvc.dt.addDays(dtMonthStart, 15));
				dtMonthEnd = utilSvc.dt.zeroTime(utilSvc.dt.monthEnd(dtMonthStart));
			}

			// month end date cannot be greater than today
			if(utilSvc.dt.diffMilli(dtMonthStart, $scope.endDate.max) >= 0 && utilSvc.dt.diffMilli($scope.endDate.max, dtMonthEnd) > 0) {
				dtMonthEnd = utilSvc.dt.zeroTime($scope.endDate.max);
			}

			// update scope dates
			$scope.startDate.val = dtMonthStart;
			$scope.endDate.val = dtMonthEnd;

			// validate
			$scope.startDate = validSvc.propDateValid($scope.startDate);
			$scope.endDate = validSvc.propDateValid($scope.endDate);

			// Year dropdown validation status
			vm.monthlyYear.fail = (yearVal < $scope.startDate.min.getFullYear() || yearVal > $scope.endDate.max.getFullYear());

			// Month dropdown validation status
			if(yearVal == $scope.startDate.min.getFullYear() && utilSvc.dt.diffMilli($scope.startDate.min, dtMonthStart) < 0) {

				// month start before start date minimum
				vm.monthlyMonth.fail = true;
			}
			else if(yearVal == $scope.endDate.max.getFullYear() && utilSvc.dt.diffMilli($scope.endDate.max, dtMonthEnd) > 0) {

				// month end after end date maximum
				vm.monthlyMonth.fail = true;
			}
			else {
				vm.monthlyMonth.fail = false;
			}

			// exit and DO NOT call parent event
			if(!!suppressParentEvent) {
				return;
			}

			//console.log('dtrange monthly change - update parent');
			updateParent();

		}


		/**
		 *    QTR CHANGE
		 */

		function qtrChange(chgType, suppressParentEvent) {

			// QTR dropdown changed

			// qtr start date, qtrName.val is converted to an integer first
			var dtToday = utilSvc.dt.zeroTime(new Date()),
				startMonth = (parseInt(vm.qtrName.val) * 3) - 2;
			var qtrStart = new Date(parseInt(vm.qtrYear.val), startMonth - 1, 1, 0, 0, 0);
			var qtrEnd = utilSvc.dt.quarterStart(utilSvc.dt.addMonths(qtrStart, 4));
			qtrEnd = utilSvc.dt.zeroTime(utilSvc.dt.addDays(qtrEnd, -1));

			// go back a year if quarter end is in the future
			if(chgType == 'QTR' && utilSvc.dt.diffMilli(dtToday, qtrEnd) >= 0) {

				// can we go back a year and be valid?
				var prevYear = new Date(qtrStart.getFullYear() - 1, qtrStart.getMonth(), 1, 0, 0, 0);
				if(utilSvc.dt.diffMilli($scope.startDate.min, prevYear) >= 0) {
					// move start to previous year
					qtrStart = prevYear;
					vm.qtrYear.val = prevYear.getFullYear();
					qtrEnd = utilSvc.dt.quarterStart(utilSvc.dt.addMonths(qtrStart, 4));
					qtrEnd = utilSvc.dt.zeroTime(utilSvc.dt.addDays(qtrEnd, -1));
				}
			}

			// update scope dates
			$scope.startDate.val = qtrStart;
			$scope.endDate.val = qtrEnd;

			// validate
			$scope.startDate = validSvc.propDateValid($scope.startDate);
			$scope.endDate = validSvc.propDateValid($scope.endDate);

			// Year dropdown validation
			vm.qtrYear.fail = (parseInt(vm.qtrYear.val) < $scope.startDate.min.getFullYear() || parseInt(vm.qtrYear.val) > $scope.endDate.max.getFullYear());
			if(vm.qtrYear.fail) {
				vm.qtrName.fail = true;
			}
			else if(utilSvc.dt.diffMilli($scope.startDate.min, qtrStart) < 0) {
				// qtr start before minimum
				vm.qtrName.fail = true;
				if(vm.qtrName.val === 1) {
					vm.qtrYear.fail = true;
				}
			}
			else if(utilSvc.dt.diffMilli($scope.endDate.max, qtrStart) > 0) {
				// qtr end after maximum
				vm.qtrName.fail = true;
				vm.qtrYear.fail = true;
			}
			else if(utilSvc.dt.diffMilli($scope.endDate.max, qtrEnd) > 0) {
				// qtr end after maximum
				vm.qtrName.fail = true;
			}
			else {
				vm.qtrName.fail = false;
			}

			// exit and DO NOT call parent event
			if(!!suppressParentEvent) {
				return;
			}
			
			//console.log('dtrange qtr change - update parent');
			updateParent();

		}


		/**
		 *    YEARLY CHANGE
		 */

		function yearlyChange(suppressParentEvent) {

			$scope.startDate.val = utilSvc.dt.zeroTime(new Date(vm.yearly.val, 0, 1));

			// end date for current year is today's date
			var dtToday = new Date();
			if(vm.yearly.val === dtToday.getFullYear()) {
				$scope.endDate.val = utilSvc.dt.zeroTime(dtToday);
				vm.yearly.current = true;
			}
			else {
				$scope.endDate.val = utilSvc.dt.zeroTime(new Date(vm.yearly.val, 11, 31));
				vm.yearly.current = false;
			}

			// validate
			$scope.startDate = validSvc.propDateValid($scope.startDate);
			$scope.endDate = validSvc.propDateValid($scope.endDate);

			// exit and DO NOT call parent event
			if(!!suppressParentEvent) {
				return;
			}
			
			//console.log('dtrange yearly change - update parent');
			updateParent();

		}


		/**
		 *    CUSTOM DATE CHANGE
		 *    check date model, text format and start/end date day range
		 */

		function customDateChange(dtName, viewText) {

			// exit if not in custom mode
			if(!isCustom($scope.rangeMode)) {
				return;
			}

			// validate specified date
			switch(dtName) {
				case 'EndDate':
					$scope.endDate = customDateValid($scope.endDate, viewText);
					$scope.startDate = validSvc.propDateValid($scope.startDate); // re-validate non-changed date on itself
					break;
				case 'StartDate':
					$scope.startDate = customDateValid($scope.startDate, viewText);
					$scope.endDate = validSvc.propDateValid($scope.endDate); // re-validate non-changed date on itself
					break;
				default:
					throw new Error('widget-input-date-range.customDateChange, date name unknown: ' + dtName);

			}

			// date range
			if(!$scope.startDate.fail && !$scope.endDate.fail) {
				customDateRange(dtName, $scope.startDate, $scope.endDate);
			}

			//console.log('dtrange custom change - update parent');
			updateParent();

		}

		function customDateValid(dt, viewText) {

			// validate text box format
			if(!_regexDate.test(viewText)) {
				dt.fail = true;
				dt.msg = 'format is m/d/yyyy';
				return dt;
			}

			// validate model value
			dt = validSvc.propDateValid(dt);

			// pass
			return dt;

		}

		function customDateRange(dtName, startDate, endDate) {

			// check start/end date range

			// start date after end date
			if(utilSvc.dt.diffMilli(startDate.val, endDate.val) < 0) {

				// end date
				if(dtName == 'EndDate') {
					endDate.fail = true;
					endDate.msg = 'must be after start date';
				}
				else {
					startDate.fail = true;
					startDate.msg = 'must be before end date';
				}
				return;
			}

			// get max date range
			var rangeDays = customDays($scope.rangeMode);

			if(dtName == 'EndDate') {

				// end date changed, is start date too small?

				var rangeStart = utilSvc.dt.addDays(utilSvc.dt.zeroTime(endDate.val), -rangeDays);
				if(utilSvc.dt.diffMilli(utilSvc.dt.zeroTime(startDate.val), rangeStart) > 0) {
					// start date is too small, can we increase it and not go above its max?
					if(utilSvc.dt.diffMilli(rangeStart, utilSvc.dt.zeroTime(startDate.max)) >= 0) {
						startDate.val = rangeStart;
					}
					else {
						startDate.fail = true;
						startDate.msg = 'range is over ' + custDays.toString() + ' days';
					}
				}

			}
			else {

				// start date changed, is end date too big?

				var rangeEnd = utilSvc.dt.addDays(utilSvc.dt.zeroTime(startDate.val), rangeDays);
				if(utilSvc.dt.diffMilli(rangeEnd, utilSvc.dt.zeroTime(endDate.val)) > 0) {
					// end date is too big, can we decrease it and not go below its min?
					if(utilSvc.dt.diffMilli(utilSvc.dt.zeroTime(endDate.min), rangeEnd) >= 0) {
						endDate.val = rangeEnd;
					}
					else {
						endDate.fail = true;
						endDate.msg = 'range is over ' + custDays.toString() + ' days';
					}
				}
			}

		}


		/**
		 *    DATE PICK CALENDAR
		 */

		function dtPickOpen(dtName) {

			// enabled for custom only
			if(!isCustom($scope.rangeMode)) {
				return;
			}

			switch(dtName) {

				case 'StartDate':
					$scope.$broadcast('widget.input.date.pick', {
						uniqueId: 'StartDate',
						setDate: $scope.startDate.val,
						minDate: $scope.startDate.min,
						maxDate: $scope.startDate.max
					});
					$timeout(function(){
						vm.dtPickShowStart = true;
					},100);

					break;

				case 'EndDate':
					$scope.$broadcast('widget.input.date.pick', {
						uniqueId: 'EndDate',
						setDate: $scope.endDate.val,
						minDate: $scope.endDate.min,
						maxDate: $scope.endDate.max
					});
					$timeout(function(){
						vm.dtPickShowEnd = true;
					},100);

					break;

				default:
					alert('widget-input-date-range.dtPickOpen, unknown date name: ' + dtName);
			}

		}

		function dtPickMouseHover(dtName, evt) {

			// delay hiding on mouse leave for 1.5 seconds (in case user's mouse slips off calendar)

			// on enter hide other calendar immediately
			if(evt == 'enter') {
				var otherCalendar = dtName == 'Start' ? 'dtPickShowEnd' : 'dtPickShowStart';
				if(!!vm[otherCalendar]) {
					vm[otherCalendar] = false;
				}
			}

			var thisCalendar = 'dtPickShow' + dtName;
			if(!!vm[thisCalendar]) {

				if(evt == 'leave') {
					// user mouse left, start 2 second delay
					_mouseLeaveDelay = 500;
					$timeout(mouseOutDebounce,500);
				}
				else {
					// user mouse re-entered, stop leave sequence
					_mouseLeaveDelay = 0;
				}
			}
		}

		function mouseOutDebounce() {

			// timer event fires every half second, re-check mouse state

			if((vm.dtPickShowStart || vm.dtPickShowEnd) && _mouseLeaveDelay > 0) {
				_mouseLeaveDelay += 500;

				// over 1.5 seconds
				if(_mouseLeaveDelay > 1500) {
					_mouseLeaveDelay = 0;
					if(vm.dtPickShowStart) {
						vm.dtPickShowStart = false;
					}
					if(vm.dtPickShowEnd) {
						vm.dtPickShowEnd = false;
					}
				}
				else {
					// wait, try again
					$timeout(mouseOutDebounce, 500);
				}
			}

		}


		/**
		 *    UPDATE PARENT
		 *    notify range changed and valid state
		 */

		function updateParent() {

			var isValid = !$scope.startDate.fail && !$scope.endDate.fail;

			// parent using rangeValid ?
			if(!!$scope.rangeValid) {
				$scope.rangeValid = isValid;
			}

			// parent using rangeChange?
			if(!!$scope.rangeChange) {
				$timeout(function(){
					//console.log('dtwidget: updateParent');
					if(validSvc.isText($scope.uniqueId)) {
						$scope.rangeChange({uniqueId: $scope.uniqueId, dtMode: $scope.rangeMode, isValid:isValid});
					}
					else {
						$scope.rangeChange({dtMode: $scope.rangeMode, isValid:isValid});
					}
				},100);
			}

		}


		/**
		 *    HELPERS
		 */

		function isCustom(dtMode) {
			return dtMode.indexOf('CUSTOM') > -1;
		}

		function customDays(dtMode) {
			if(isCustom(dtMode)) {
				return parseInt(dtMode.substr(6, 4));
			}
			return 0;
		}

	}

}
 
widInputDate.$inject = ['$filter', '$timeout', 'utilSvc'];
angular
.module('espui.core.ui')
.directive('widgetInputDate', widInputDate);

/* @ngInject */
function widInputDate($filter, $timeout, utilSvc) {

    var widget = {
        restrict: 'A',
        require:'ngModel',
        scope: {
            name: '@',
            dtChange: '&'
        },
        link: linkFx
    };

    return widget;

    function linkFx($scope, $elem, $attrs, ngModel) {

        var dtVal = null;

        // exit if no model yet
        if(!!!ngModel) {
            return;
        }

        // render model to date format: m/d/yyyy
        // note: render runs after any model change
        ngModel.$render = function() {
            //console.log('render');
            dtVal = utilSvc.dt.parse(ngModel.$viewValue);
            if(dtVal !== null) {
                $elem.val($filter('date')(dtVal, 'M/d/yyyy'));
            } 
            else {
                $elem.val('');
            }

        };

        // parse textbox string into the model
        // note: parse runs after any user change on the input
        ngModel.$parsers.push(function(viewVal) {
            //console.log('parser');

            // fire the change event AFTER this digest cycle
            $timeout(function(){
                $scope.dtChange({name: $scope.name, viewText: viewVal});
            });

            dtVal = utilSvc.dt.parse(ngModel.$viewValue);
            if(dtVal !== null) {
                return new utilSvc.dt.zeroTime(dtVal);
            }
            else {
                return undefined;
            }

        });


        /**
         *    HTML ELEMENT EVENTS
         *    binding to html events or using $scope.watch is not needed
         *    Angular is already watching this element and will call the parsers on any input change

        $elem.on('blur keyup change', function() {
            ngModel.$setViewValue($elem.val());
        });

        */

    }

}

 
widInputFile.$inject = ['$window'];
angular
.module('espui.core.ui')
.directive('widgetInputFile', widInputFile);

/* @ngInject */
function widInputFile($window) {

	var widget = {
		restrict: 'A',
		require:'ngModel',
		scope: {
			isClean: '@'
		},
		link: linkFx
	};

	return widget;

	function resetFileInputs(elem) {

		if(!!elem) {

			// remove all child elements
			if(elem.length > 0 && elem[0].children.length > 0) {
				var childElem = {};
				for(var i = elem[0].children.length - 1; i >= 0; i--) {
					childElem = elem[0].children[i];
					// ie fix
					if(!!childElem.remove) {
						childElem.remove();
					}
					else if(!!childElem.removeNode) {
						childElem.removeNode(true);
					}
				}
			}

			// add new file input element
			var fileInput = $window.document.createElement("input");
			fileInput.type = "file";
			elem.append(fileInput);
		}
	}

	function linkFx($scope, $elem, $attrs, ngModel) {

		// exit if no model yet
		if(!!!ngModel) {
			return;
		}

		// detect model changes
		ngModel.$render = function() {
			//console.log('render');

			// model is empty, remove fileInputs
			if(!!!ngModel.$modelValue || ngModel.$modelValue.length < 1) {
				if($scope.isClean !== 'yes') {
					$scope.isClean = 'yes';
					resetFileInputs($elem);
				}
			}

		};

		$elem.on('change', function() {

			// browser supports file element render
			if(!!$elem && $elem.length > 0 && $elem[0].children.length > 0) {
				$scope.isClean = 'no';

				// browser supports HTML5 File API
				var newFiles = $elem[0].children[0].files;
				if(!!!newFiles || newFiles.length < 1) {
					newFiles = [];
				}

				// emit event for parent controller hook
				$scope.$emit('widget.input.file', {id: $attrs.id, files: newFiles});

			}
		});

	}

}
 
widInputNdcFormat.$inject = ['$timeout', 'utilSvc'];
angular
.module('espui.core.ui')
.directive('widgetInputNdcFormat', widInputNdcFormat);

/* @ngInject */
function widInputNdcFormat($timeout, utilSvc) {

	var widget = {
		restrict: 'A',
		require:'ngModel',
		scope: {
			format: '@',
			ndcChange: '&',
			placeHolder: '@'
		},
		link: linkFx
	};

	return widget;

	function linkFx($scope, $elem, $attrs, ngModel) {

		var rawTxt = '',
			lastTxt = '',
			viewTxt = '',
			viewTxtLen = 0,
			elem = null,
			cursorPos = 0;

		if(!!!ngModel) {
			return;
		}

		// listen for changes
		$elem.on('blur keyup change paste', function(event) {
			if (event.type == 'paste') {
				lastTxt = '';
			}
			$scope.$evalAsync(inputChange);
		});

		$scope.$on('$destroy', function() {
			$elem.off('blur keyup change paste');
		});

		init();
		function init() {
			if(!!$scope.placeHolder) {
				$elem.attr('placeholder', $scope.placeHolder);
			}
			inputChange();
		}

		function inputChange() {

			rawTxt = utilSvc.str.toText(ngModel.$viewValue);

			// NaN is default value, ignore it (NG 1.6.4 fix)
			if(rawTxt == 'NaN') {
				lastTxt = '|NaN|';
				return;
			}

			if(rawTxt !== lastTxt) {

				// modify non-empty text
				if(rawTxt !== '') {

					elem = $elem[0];
					if(!!!elem) {
						return;
					}

					switch($scope.format) {

						case 'nodash':

							// remove '-' character
							viewTxt = rawTxt.replace(/[^0-9]+/g,'');
							viewTxtLen = viewTxt.length;

							// remember last raw view text
							lastTxt = viewTxt;

							// save cursor, modify text
							cursorPos = elem.selectionStart - (rawTxt.length - viewTxt.length); // subtract removed character length
							ngModel.$setViewValue(viewTxt);
							ngModel.$render();

							// adjust cursor
							if(isNaN(cursorPos) || cursorPos < 0) {
								cursorPos = 0;
							}
							else if(cursorPos >= viewTxtLen) {
								cursorPos = viewTxtLen;
							}
							elem.setSelectionRange(cursorPos, cursorPos);
							break;

						default:
							alert('widget-input-ndc-format, unknown format type: ' + $scope.format);
					}
				}
				else {
					lastTxt = '';
				}

				// fire change event AFTER this digest cycle
				if(!!$scope.ndcChange) {
					$timeout(function(){
						$scope.ndcChange();
					},100);
				}
			}
		}

	}

}

 
widMuiNdcAutoSearch.$inject = ['$timeout', 'catalogsRepo', 'validSvc'];
angular
.module('espui.core.ui')
.directive('widgetMuiNdcAutoSearch', widMuiNdcAutoSearch);

/**
 * 
 * ndc auto search
 
	HTML
	<div class="form-field input-txt">
		<div widget-mui-ndc-auto-search unique-id="blah" ndc-model="vm.ndcInput" ndc-auto-search-change="vm.ndcAutoSearchChange()" />
	</div>

	JS CONTROLLER - this widget emits state change event, controller code is:
	var _ndcAutoSearch = $scope.$on('widget.ndc.auto.search', function(event, evtData) {
		event.stopPropagation();

		evtData = evtData || {};
		vm.ndcDesc = '';
		if(evtData.state == 'FOUND') {
			var ndc = evtData.ndc || {};
			vm.ndcDesc = ndc.Description;
		}
	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_ndcAutoSearch) {
			_ndcAutoSearch();
		}
	});


	STATES
		EMPTY
		INVALID
		SEARCH
		FOUND
		NOTFOUND
 */


/* @ngInject */
function widMuiNdcAutoSearch($timeout, catalogsRepo, validSvc) {

	ctl.$inject = ['$scope'];
	return {
		restrict: 'A',
		replace: true,
		scope: {
			uniqueId: '@',
			ndcModel: '=',
		},
		templateUrl: 'core/ui/widget/input/widget-mui-ndc-auto-search.tpl.html',
		controller: ctl,
		controllerAs: 'vm'
	};

	/* @ngInject */
	function ctl($scope) {

		var vm = this,
			_watchNdcModel = null;

		// properties
		vm.ndc = '';
		vm.ndcLast = '';
		vm.state = 'EMPTY';
		vm.stateTxt = '';

		// methods
		vm.ndcInputChange = ndcInputChange;


		/**
		 *    INIT
		 */

		init();

		function init() {
			// tbd...
		}


		/**
		 * 	WATCH PARENT MODEL EVENT
		 */
		_watchNdcModel = $scope.$watch('ndcModel', function() {
			// detect parent changes in ndc model
			//console.log('MUI: ndc model change: ' + $scope.ndcModel + ' with state: ' + vm.state);
			vm.ndc = validSvc.isNumber($scope.ndcModel) ? $scope.ndcModel.toString() : '';
			validateNdc();
		});

		$scope.$on('$destroy', function() {
			if(_watchNdcModel) {
				_watchNdcModel();
			}
		});


		/**
		 *    NDC FORMAT CHILD EVENT
		 */

		function ndcInputChange() {
			// detect changes in ndc format widget child
			// widget-input-ndc-format
			//console.log('MUI AUTO SEARCH: ndc format change: ' + vm.ndc);
			validateNdc();
		}
		
		function validateNdc() {
			// called by parent / child events to validate current ndc
			// if valid do search
			var currentState = vm.state;
			if(!validSvc.isText(vm.ndc)) {
				vm.ndcLast = vm.ndc;
				vm.state = 'EMPTY';
				vm.stateTxt = '';
				if(vm.state != currentState) {
					updateParent(undefined);
				}
			}
			else if(!validSvc.isInteger(vm.ndc)) {
				vm.ndcLast = vm.ndc;				
				vm.state = 'INVALID';
				vm.stateTxt = '11 digit number to search';
				if(vm.state != currentState) {
					updateParent(undefined);
				}
			}
			else if(vm.ndc.length < 11) {
				vm.ndcLast = vm.ndc;				
				vm.state = 'INVALID';
				vm.stateTxt = vm.ndc.length.toString() + ' of 11 digits to search';
				updateParent({ItemCode:vm.ndc});
			}
			else if(vm.ndc != vm.ndcLast) {
				updateParent({ItemCode:vm.ndc});
				if(vm.state != 'SEARCH') {
					vm.ndcLast = vm.ndc;
					vm.state = 'SEARCH';
					vm.stateTxt = 'searching...';
					searchNdc(vm.ndc);
				}
			}
		}


		/**
		 * 	SEARCH NDC
		 */
		function searchNdc(ndc) {
			//console.log('search ndc');
			catalogsRepo.getReferenceNdc(ndc).then(okGet, errGet);

			function okGet(r) {
				if(!!!r || !validSvc.isText(r.Description)) {
					errGet();
					return;
				}
	
				if(vm.state == 'SEARCH') {
					$timeout(function(){
						vm.state = 'FOUND';
						vm.stateTxt = 'found ndc';
						updateParent(r);
					}, 1000);
				}
				//console.log(r);
			}
			function errGet(r) {
				if(vm.state == 'SEARCH') {
					$timeout(function(){
						vm.state = 'NOTFOUND';
						vm.stateTxt = 'not found';
						//console.log(r);
						updateParent({ItemCode:ndc});
					}, 1000);
				}
			}
		}


		/**
		 *    HELPERS
		 */

		function updateParent(ndcItem) {
			// emit event for parent controller
			$timeout(function(){
				$scope.$emit('widget.ndc.auto.search', {
					id: $scope.uniqueId,
					state:vm.state,
					ndc: ndcItem
				});	
			},100);
		}
	}

}
 
widScheduler.$inject = ['$timeout', 'validSvc'];
angular
.module('espui.core.ui')
.directive('widgetScheduler', widScheduler);

/* @ngInject */
function widScheduler($timeout, validSvc) {

	ctl.$inject = ['$scope'];
	return {
		restrict: 'A',
		replace: true,
		scope: {
			title: '@',
			action: '=',
			model: '=',
			category: '@'
		},
		templateUrl: 'core/ui/widget/input/widget-scheduler.tpl.html',
		controller: ctl,
		controllerAs: 'vm'
	};

	/* @ngInject */
	function ctl($scope) {

		var vm = this;
		var _notify = false,
			_modelListener = null;

		// properties
		vm.title = '';
		vm.action = '';
		vm.category = '';

		// radio groups
		vm.radioGroupEnabled = '';
		vm.radioGroupType = '';
		vm.radioGroupMonthOption = '';
		vm.radioGroupAutoEDI = '';
		vm.radioGroupPlaceNow = '';

		// model
		vm.model = {};

		// droplist
		vm.DayOfMonthDroplist = [];
		vm.OccursDroplist = [];
		vm.WeekOfMonthDroplist = [];
		vm.Weekdays = [];

		// methods
		vm.enabledChange = enabledChange;
		vm.scheduleTypeChange = scheduleTypeChange;
		vm.monthOptionChange = monthOptionChange;
		vm.modelChange = modelChange;

		// listen for model change
		_modelListener = $scope.$watchCollection('model', function(m) {
			
			// context
			vm.title = $scope.title;
			vm.action = $scope.action;

			// radio button groups (this widget is not its own form)
			vm.radioGroupEnabled = 'radioEnabled' + vm.title;
			vm.radioGroupType = 'radioType' + vm.title;
			vm.radioGroupMonthOption = 'radioMonthOption' + vm.title;
			vm.radioGroupAutoEDI = 'radioAutoEDI' + vm.title;
			vm.radioGroupPlaceNow = 'radioPlaceNow' + vm.title;
	
			// model
			vm.model = modelVM(m);
			if(m.notify) {
				notifyParent();
			}

			vm.category = $scope.category;

		});

		$scope.$on('$destroy', function() {
			if(!!_modelListener) {
				_modelListener();
			}
		});


		/**
		 *    INIT
		 */

		init();

		function init() {
			initDroplists();
		}

		function initDroplists() {
			vm.DayOfMonthDroplist = [];
			for(var i = 1; i < 29; i++) {
				vm.DayOfMonthDroplist.push({
					label: i.toString(),
					value: i
				});
			}
			vm.WeekOfMonthDroplist = [
				{value:1, label:'First'},
				{value:2, label:'Second'},
				{value:3, label:'Third'},
				{value:4, label:'Fourth'}
			];
			vm.WeekOccursDroplist = [
				{value:1, label:'1'},
				{value:2, label:'2'},
				{value:3, label:'3'},
			];
		}


		/**
		 * 		VIEW MODELS

			Model Data Structure

			MONTH
				MONTH-DAY
					DayOfMonth: 1-28
				MONTH-WEEK
					WeekOfMonth: 1,2,3,4
					Weekdays:1,2,3,4,5,6,7
			WEEK
				Occurs: 1,2,3
				Weekdays: 1,2,3,4,5,6,7
		*/


		function emptyVM(enabled) {
			vm.Weekdays = weekdaysVM([]);
			return {
				Enabled: enabled,
				Type: '',
				MonthOption: '',
				DayOfMonth : validSvc.newProp(0),
				WeekOfMonth : validSvc.newProp(0),
				Occurs : validSvc.newProp(0),
				Weekdays: validSvc.newProp(), // using this for fail only, value is stored in vm.Weekdays controller list
				AutoPlaceSendEDI: 'no',
				fail: enabled == 'off' ? 'no' : 'yes'
			};
		}

		function weekdaysVM(items) {
			items = Array.isArray(items) ? items : [];
			var days = ['', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
			var result = [];
			for(var i = 1; i <= 7; i++) {
				result.push({
					val: i,
					chk: items.indexOf(i) > -1,
					lbl: days[i]
				});
			}
			return result;
		}

		function modelVM(data) {
			data = data || {};
			var enabled = data.Enabled == 'on' ? 'on' : 'off'; // default to off if empty
			var result = emptyVM(enabled);

			// auto order is off
			if(enabled == 'off' && data.Type != 'WEEK' && data.Type != 'MONTH') {
				return result;
			}
			result.Type = data.Type == 'WEEK' ? 'WEEK' : 'MONTH';  // default to MONTH if empty

			// cherry pick values based on type
			switch(result.Type) {

				case 'MONTH':
					result.MonthOption = data.MonthOption == 'MONTH-WEEK' ? data.MonthOption : 'MONTH-DAY'; // default to 'MONTH-DAY' if empty

					switch(result.MonthOption) {
						case 'MONTH-DAY':
							result.DayOfMonth.val = validInteger(data.DayOfMonth, 1, 28) ? parseInt(data.DayOfMonth) : 1;
							break;
						case 'MONTH-WEEK':
							result.WeekOfMonth.val = validInteger(data.WeekOfMonth, 1, 4) ? parseInt(data.WeekOfMonth) : 1;
							vm.Weekdays = weekdaysVM(data.Weekdays);
							break;
						default:
							throw new Error('widget-scheduler.modelVM, unknown month option: ' + result.MonthOption);
					}
					break;

				case 'WEEK':
					result.Occurs.val = validInteger(data.Occurs, 1, 3) ? parseInt(data.Occurs) : 1;
					vm.Weekdays = weekdaysVM(data.Weekdays);
					break;

				default:
					throw new Error('widget-scheduler.modelVM, unknown type: ' + t);
			}

			result.AutoPlaceSendEDI = data.AutoPlaceSendEDI == 'yes' ? 'yes' : 'no';
			result.PlaceNow = data.PlaceNow == 'yes' ? 'yes' : 'no';

			result.fail = modelValid(result) ? 'no' : 'yes';

			return result;
		}

		function parentModelVM(m) {
			// convert validation properties into parent data with fail state
			//console.log('parent model');
			//console.log(m);
			return {
				Enabled: m.Enabled,
				Type: m.Type,
				MonthOption: m.MonthOption,
				DayOfMonth : m.DayOfMonth.val,
				WeekOfMonth : m.WeekOfMonth.val,
				Occurs : m.Occurs.val,
				Weekdays: weekdayVals(vm.Weekdays),
				AutoPlaceSendEDI: m.AutoPlaceSendEDI,
				PlaceNow: m.PlaceNow,
				fail: m.fail
			};
		}


		/**
		 * 	VALIDATION
		 */

		function weekdayVals(items) {
			var result = [];
			for(var i = 0; i < items.length; i++) {
				if(items[i].chk) {
					result.push(items[i].val);
				}
			}
			return result;
		}
		
		function modelValid(m) {
			if(!!!m) {
				return;
			}

			var isValid = true;
			function setFail(isFail) {
				isValid = isValid ? !!!isFail : false;
				return isValid ? 'no' : 'yes';
			}

			// enabled?
			if(m.Enabled == 'no') {
				m.Type = '';
				m.MonthOption = '';
			}

			// month-day
			m.DayOfMonth.fail = 'no';
			if(m.Type == 'MONTH' && m.MonthOption == 'MONTH-DAY') {
				m.DayOfMonth.fail = setFail(!validInteger(m.DayOfMonth.val, 1, 28));
			}

			// month-week
			m.WeekOfMonth.fail = 'no';
			if(m.Type == 'MONTH' && m.MonthOption == 'MONTH-WEEK') {
				m.WeekOfMonth.fail = setFail(!validInteger(m.WeekOfMonth.val, 1, 4));
			}

			// week
			m.Occurs.fail = 'no';
			if(m.Type == 'WEEK') {
				m.Occurs.fail = setFail(!validInteger(m.Occurs.val, 1, 4));
			}

			// weekdays
			m.Weekdays.fail = 'no';
			if(m.MonthOption == 'MONTH-WEEK' || m.Type == 'WEEK') {
				m.Weekdays.fail = setFail(weekdayVals(vm.Weekdays).length < 1);
			}

			return isValid;
		}

		function validInteger(val, min, max) {
			return validSvc.isInteger(parseInt(val)) && val >= min && val <= max;
		}


		/**
		 * 	CHANGE EVENTS
		 */
		
		function enabledChange(enabled) {
			if(enabled == 'on') {
				// re-validate when turning on
				vm.model.Enabled = 'on';
				vm.model.fail = modelValid(vm.model) ? 'no' : 'yes';
			}
			else {
				// keep schedule if valid when turning off
				var mCheck = JSON.parse(JSON.stringify(vm.model)); // de-ref
				if(modelValid(mCheck)) {
					vm.model.fail = 'no';
					vm.model.Enabled = 'off';
				}
				else {
					vm.model = modelVM({Enabled: 'off'});
				}
			}

			notifyParent();
		}

		function scheduleTypeChange(newType) {
			// reset model on Type Change
			vm.model = modelVM({
				Enabled:'on',
				Type:newType
			});
			notifyParent();
		}

		function monthOptionChange(monthOption) {
			vm.model = modelVM({
				Enabled:'on',
				Type: 'MONTH',
				MonthOption: monthOption
			});
			notifyParent();
		}

		function modelChange() {
			//console.log('model change');
			vm.model.fail = modelValid(vm.model) ? 'no' : 'yes';
			notifyParent();
		}

		function notifyParent() {
			// debounce
			if(_notify) {
				return;
			}
			_notify = true;
			$timeout(function() {
				// notify parent to refresh its model (it always flows down to this widget)
				// $scope.$emit('widget.auto.order.update', {
				// 	id: vm.title,
				// 	model: parentModelVM(vm.model)
				// });
				$scope.model = parentModelVM(vm.model);
				_notify = false;
			}, 500);
		}
	}
	
}
 
/**
 *    PAGINATION
 *    used as follows:
 *    <div widget-paging></div>
 *    Outputs paging html:  [|<] Page: [n-2]...[n-1][n][n+1]...[n+2]  [>|]
 *    	[|<] = goto first page
 *    	[n-2]... = previous set
 *    	[n-1][n][n+1] = middle pages around current page
 *    	...[n+2] = next set
 *    	[>|] = goto last page
 */


widPaging.$inject = ['$timeout', 'validSvc'];
angular
.module('espui.core.ui')
.directive('widgetPaging', widPaging);

/* @ngInject */
function widPaging($timeout, validSvc) {

	ctl.$inject = ['$scope'];
	return {
		restrict: 'A',
		replace: true,
		scope: {
			uniqueId: '@',
		},
		templateUrl: 'core/ui/widget/paging/widget-paging.tpl.html',
		controller: ctl,
		controllerAs: 'vm'
	};

	/* @ngInject */
	function ctl($scope) {

		var vm = this;
		var _unregisterListener;

		// nav
		vm.gotoFirst = 0;
		vm.gotoLast = 0;
		vm.setBack = 0;
		vm.setFwd = 0;
		vm.opt1 = 0;
		vm.opt2 = 0;
		vm.opt3 = 0;
		vm.opt4 = 0;
		vm.opt5 = 0;

		vm.pgSize = 0;
		vm.pgSizeNew = '0';
		vm.pgPage = 0;
		vm.pgTotal = 0;
		vm.pgRowCount = 0;

		// filter
		vm.itemCount = -1;
		vm.dataCount = -1;

		vm.pgNumChange = pgNumChange;
		vm.pgSizeChange = pgSizeChange;


		/**
		 *    INIT
		 *

		init();

		function init() {

		}


		/**
		 *    EVENT HOOK
		 *    called by parent page if they want paging
		 */

		_unregisterListener = $scope.$on('widget.paging', function(event, evtData) {

			// reset with no data
			if(!!!evtData) {
				resetPaging();
			}
			else if($scope.uniqueId === evtData.uniqueId || !validSvc.isText($scope.uniqueId)) {

				// id match or id is not being used

				// reset display
				resetPaging();

				// load values
				var size = parseInt(evtData.Size),
					page = parseInt(evtData.Page),
					total = parseInt(evtData.Total),
					rowCount = parseInt(evtData.RowCount),
					itemCount = parseInt(evtData.ItemCount),
					dataCount = parseInt(evtData.DataCount);

				// stop if numbers are invalid
				if(!validSvc.isNumber(size) || !validSvc.isNumber(page) || !validSvc.isNumber(total) || !validSvc.isNumber(rowCount) || !validSvc.isNumber(itemCount) || !validSvc.isNumber(dataCount)) {
					return;
				}

				vm.itemCount = itemCount;
				vm.dataCount = dataCount;

				// items exist for paging
				if(itemCount > 0) {

					vm.pgSize = size;
					vm.pgSizeNew = size.toString();
					vm.pgPage = page;
					vm.pgTotal = total;
					vm.pgRowCount = rowCount;

					// derive page start (in sets of 5)
					var pgStart = 1;
					if(page > 5) {
						pgStart = (Math.floor((page - 1) / 5) * 5) + 1;
					}

					// setup main 5 button options (yes this looks repetitive, trying to avoid an ng-repeat loop, so no array of buttons)
					vm.opt1 = pgStart;
					if(pgStart + 1 <= total) {
						vm.opt2 = pgStart + 1;
					}
					if(pgStart + 2 <= total) {
						vm.opt3 = pgStart + 2;
					}
					if(pgStart + 3 <= total) {
						vm.opt4 = pgStart + 3;
					}
					if(pgStart + 4 <= total) {
						vm.opt5 = pgStart + 4;
					}

					// back
					if(pgStart > 1) {
						vm.setBack = pgStart - 1;

						// goto first
						if(vm.setBack - 5 >= 1) {
							vm.gotoFirst = 1;
						}
					}

					// fwd
					if(pgStart + 5 <= total) {
						vm.setFwd = pgStart + 5;

						// goto last
						if(vm.setFwd + 5 < total) {
							vm.gotoLast = total;
						}
					}

				}

			}

		});

		$scope.$on('$destroy', function() {
			// clean up listener on destroy
			_unregisterListener();
		});


		/**
		 *    RESET
		 */

		function resetPaging() {

			// nav
			vm.gotoFirst = 0;
			vm.gotoLast = 0;
			vm.setBack = 0;
			vm.setFwd = 0;
			vm.opt1 = 0;
			vm.opt2 = 0;
			vm.opt3 = 0;
			vm.opt4 = 0;
			vm.opt5 = 0;

			vm.pgSize = 0;
			vm.pgSizeNew = '0';
			vm.pgPage = 0;
			vm.pgTotal = 0;
			vm.pgRowCount = 0;

			// filter counts
			vm.itemCount = -1;
			vm.dataCount = -1;

		}


		/**
		 *    CHANGE EVENTS
		 */

		function pgNumChange(pg) {
			$scope.$emit('widget.paging.change', {uniqueId: $scope.uniqueId, propName:'Page', value: parseInt(pg)});
		}

		function pgSizeChange() {
			$scope.$emit('widget.paging.change', {uniqueId: $scope.uniqueId, propName:'PageSize', value: parseInt(vm.pgSizeNew)});
		}

	}

}
 
/**
 *    SAVED REPORTS
 *    used as follows:
 *    <div widget-saved-reports></div>
 *
 *    Outputs html for:
 *    	saved reprot href title
 *    	when clicked, shows list of saved reports, ability to add new saved report
 *
 * 	  Events:
 * 	  	listens for: 'widget.savedreports'
 * 	  		reports: controller gives widget saved reports from user prefs
 * 	  		query: sends the current valid query or nothing if query change
 *
 * 	  	fires event: 'widget.savedreports.action'
 * 	  		current - setup query from report name user clicked
 * 	  		add - validate and save current query with new name
 * 	  		remove - remove saved report by id, re-save user prefs
 */


widSavedReports.$inject = ['$timeout', 'validSvc', 'msgSvc'];
angular
.module('espui.core.ui')
.directive('widgetSavedReports', widSavedReports);

/* @ngInject */
function widSavedReports($timeout, validSvc, msgSvc) {

	ctl.$inject = ['$scope'];
	return {
		restrict: 'A',
		replace: true,
		scope: {
			uniqueId: '@',
		},
		templateUrl: 'core/ui/widget/savedreports/widget-saved-reports.tpl.html',
		controller: ctl,
		controllerAs: 'vm'
	};

	/* @ngInject */
	function ctl($scope) {

		var vm = this;
		var _parentListener = null,
			_mouseLeaveDelay = 0,
			_pendingId = '';

		// properties
		vm.title = 'Saved Search';
		vm.query = {
			show: false,
			details: []
		};
		vm.current = '';
		vm.reports = [];

		// list show / hide
		vm.showList = false;
		vm.toggleListView = toggleListView;
		vm.listMouseHover = listMouseHover;

		// rpt crud
		vm.addReport = addReport;
		vm.loadReport = loadReport;
		vm.removeReport = removeReport;


		/**
		 *    INIT
		 *

		init();

		function init() {

		}


		/**
		 *    DESTROY
		 */

		$scope.$on('$destroy', function() {
			if(_parentListener) {
				_parentListener();
			}
			if(_tblViewListener) {
				_tblViewListener();
			}
		});


		/**
		 *    EVENT HOOK: PARENT EVENT
		 */

		var _tblViewListener = $scope.$on('widget.savedreports', function(event, evtData) {

			// reset
			vm.title = 'Saved Search';
			vm.showList = false;
			vm.current = '';

			evtData = evtData || {};
			var action = evtData.action,
				cur = evtData.current,
				q = evtData.query;

			// no data or empty
			if(!validSvc.isText(action) || (action == 'query' && !!!q)) {
				//console.log('sr: empty');
				vm.query = {
					show: false,
					dirty: false,
					details: []
				};
			}
			else if(action == 'query') {
				//console.log('sr: query');
				// query update
				vm.query.show = false;
				vm.query.dirty = true;
				vm.query.details = Array.isArray(q.details) ? q.details : [];
			}
			else if(action == 'reports') {
				//console.log('sr: rpts');
				// reports update
				vm.reports = Array.isArray(evtData.reports) ? evtData.reports : [];
			}

			// current
			if(validSvc.isText(cur)) {
				//console.log('sr action: ' + action + ' current: ' + cur);
				var rpt = getReportById(vm.reports, cur);
				if(!!rpt) {
					vm.current = cur;
					vm.title += ': ' + rpt.name;
				}
			}


		});

		function getReportById(items, id) {

			if(!Array.isArray(items) || !validSvc.isText(id)) {
				return null;
			}

			for(var i = 0; i < items.length; i++) {
				if(items[i].id == id) {
					return items[i];
				}
			}

			return null;
		}


		/**
		 *    TOGGLE REPORT LIST / HOVER EXIT
		 */

		function toggleListView() {

			vm.showList = !vm.showList;

			if(vm.showList) {

				// user has no reports saved, show query if valid
				if(vm.reports.length < 1 && vm.query.details.length > 0) {
					vm.query.show = true;
				}
			}
			else {
				vm.query.show = false;
			}

		}


		/**
		 *    ADD
		 */

		function addReport(action) {

			switch(action) {

				case 'CANCEL':
					vm.query.name = '';
					vm.query.show = false;
					break;

				case 'SHOW':
					if(vm.query.details.length < 1) {
						msgSvc.ok('Cannot Save Search', 'Search is not loaded, finish loading before adding.');
						return;
					}
					vm.query.name = '';
					vm.query.show = true;
					break;

				case 'SAVE':
					// name required, 2 - 30 characters
					var nm = vm.query.name;
					if(!validSvc.isText(nm)) {
						msgSvc.ok('Cannot Add', 'Search name is required.');
						return;
					}
					nm.trim();
					if(nm.length < 2 || nm.length > 30) {
						msgSvc.ok('Cannot Add', 'Search name is 2 to 30 characters.');
						return;
					}

					vm.query.name = '';
					vm.query.show = false;

					$scope.$emit('widget.savedreports.action', {action:'add', name: nm});

					break;

				default:
					alert('widgetSavedReports.addReport, unknown action: ' + action);
			}

		}


		/**
		 *    LOAD / REMOVE
		 */

		function loadReport(id) {
			vm.title = 'Saved Search';
			vm.showList = false;
			vm.current = '';

			_pendingId = id;
			$timeout(function(){
				$scope.$emit('widget.savedreports.action', {action:'current', id: _pendingId});
			}, 200);
		}

		function removeReport(id, name) {

			_pendingId = id;

			msgSvc.confirm({
				id: 'widget.savedreports.remove',
				title: 'Remove Saved Search',
				msg: 'Remove ' + name + '?',
				buttons: [
					{text:'OK', result:'YES', cancel: false},
					{text:'CANCEL', result:'CANCEL', cancel: true}
				]
			}).then(removeConfirm, removeConfirm);

		}

		function removeConfirm(r) {

			if(!!r && r.result == 'YES') {

				// current report is getting deleted?
				if(_pendingId.id == vm.current) {
					vm.title = 'Saved Search';
					vm.current = '';
				}

				vm.showList = false;
				$scope.$emit('widget.savedreports.action', {action:'remove', id: _pendingId, current: vm.current});
			}

		}


		/**
		 *    HELPERS
		 */

		function listMouseHover(evtName) {

			// view list closes on mouse leave event
			// this function delays closing the list in case user's mouse slips off
			if(vm.showList) {

				if(evtName == 'leave') {
					// user mouse left, start delay
					_mouseLeaveDelay = 500;
					$timeout(mouseOutDebounce,500);
				}
				else {
					// user mouse re-entered, stop leave sequence
					_mouseLeaveDelay = 0;
				}
			}
		}

		function mouseOutDebounce() {

			// timer event fires every half second, re-check mouse state

			if(vm.showList && _mouseLeaveDelay > 0) {
				_mouseLeaveDelay += 500;

				// over 1 seconds
				if(_mouseLeaveDelay > 1000) {
					_mouseLeaveDelay = 0;
					vm.showList = false;
					vm.query.show = false;
				}
				else {
					// wait, try again
					$timeout(mouseOutDebounce, 500);
				}
			}
		}

	}

}
 
/**
 *    TABLE TOP CONTROLS
 *    used as follows:
 *    <div widget-table-top-controls unique-id=""></div>
 *
 *    Outputs paging html for:
 *    	table view current and view selector
 *    	filter display
 *
 *    Uses Paging event to build filtering display
 *    Uses Table view event to build views
 *    Throws event when user clicks a table view
 */


widTableTopControls.$inject = ['$timeout', 'validSvc'];
angular
.module('espui.core.ui')
.directive('widgetTableTopControls', widTableTopControls);

/* @ngInject */
function widTableTopControls($timeout, validSvc) {

	ctl.$inject = ['$scope'];
	return {
		restrict: 'A',
		replace: true,
		scope: {
			uniqueId: '@',
		},
		templateUrl: 'core/ui/widget/table/widget-table-top-controls.tpl.html',
		controller: ctl,
		controllerAs: 'vm'
	};

	/* @ngInject */
	function ctl($scope) {

		var vm = this;
		var _pagingListener = null,
			_tblViewListener = null,
			_mouseLeaveDelay = 0,
			_pendingViewId = '';

		// table views
		vm.views = [];
		vm.viewsTitle = '';
		vm.viewListShow = false;
		vm.viewCurrent = '';
		vm.viewsClick = viewsClick;
		vm.viewListMouseHover = viewListMouseHover;

		// filter
		vm.fltCount = -1;
		vm.fltDataItems = -1;


		/**
		 *    INIT
		 *

		init();

		function init() {

		}


		/**
		 *    DESTROY
		 */

		$scope.$on('$destroy', function() {
			// clean up listener on destroy
			if(_pagingListener) {
				_pagingListener();
			}
			if(_tblViewListener) {
				_tblViewListener();
			}
		});


		/**
		 *    EVENT HOOK: TABLE VIEWS
		 */

		_tblViewListener = $scope.$on('widget.tblview', function(event, evtData) {

			// reset
			vm.views = [];
			vm.viewsTitle = '';
			vm.viewListShow = false;
			vm.viewCurrent = '';

			if(!!evtData && ($scope.uniqueId === evtData.uniqueId || !validSvc.isText($scope.uniqueId))) {

				// load views
				var views = Array.isArray(evtData.views) ? evtData.views : [],
					current = validSvc.isText(evtData.current) ? evtData.current : '';
				if(views.length > 0 && current.length > 0) {
					vm.views = views;
					vm.viewCurrent = current;
					vm.viewsTitle = fmtViewTitle(views, current) + ' View';
				}

			}

		});


		/**
		 *    EVENT HOOK: PAGING
		 *    listen in on paging event to update filter
		 */

		_pagingListener = $scope.$on('widget.paging', function(event, evtData) {

			var hasEventId = !!evtData && validSvc.isText(evtData.uniqueId);
			var myIdExists = validSvc.isText($scope.uniqueId);
			var idMatch = myIdExists && hasEventId && $scope.uniqueId == evtData.uniqueId;

			// reset display (events with no id will reset all listeners)
			if(!hasEventId || idMatch) {
				vm.fltCount = -1;
				vm.fltDataItems = -1;
			}

			// add counts (if event and widget have no id, or if both ids match)
			if((!hasEventId && !myIdExists) || idMatch) {

				// load values
				var rowCount = parseInt(evtData.RowCount),
					fltDataItems = parseInt(evtData.DataCount),
					selectCount = parseInt(evtData.SelectCount),
					childName = evtData.ChildName;

				// stop if numbers are invalid
				if(!validSvc.isNumber(rowCount) || !validSvc.isNumber(fltDataItems)) {
					return;
				}

				vm.fltCount = rowCount;
				vm.fltDataItems = fltDataItems;
				vm.selectCount = selectCount;
				vm.childName = childName;
			}

		});


		/**
		 *    TABLE VIEW EVENTS
		 *    piggy back on paging emit events structure
		 */

		function viewsClick(id) {

			_pendingViewId = '';
			_mouseLeaveDelay = 0;
			vm.viewListShow = false;

			// notify parent
			if(validSvc.isText(id) && id != vm.viewCurrent) {
				_pendingViewId = id;

				// wait a second to allow CSS transition
				$timeout(function(){
					if(_pendingViewId == 'edit') {
						$scope.$emit('widget.tblview.editor.change', {uniqueId: $scope.uniqueId, type:'edit'});
					}
					else {
						$scope.$emit('widget.tblview.editor.change', {uniqueId: $scope.uniqueId, type:'load', id: _pendingViewId});
					}
					_pendingViewId = '';
				}, 1200);
			}
		}

		function viewListMouseHover(evtName) {

			// view list closes on mouse leave event
			// this function delays closing the list for 2 seconds in case user's mouse slips off
			if(vm.viewListShow) {

				if(evtName == 'leave') {
					// user mouse left, start 2 second delay
					_mouseLeaveDelay = 500;
					$timeout(mouseOutDebounce,500);
				}
				else {
					// user mouse re-entered, stop leave sequence
					_mouseLeaveDelay = 0;
				}
			}
		}

		function mouseOutDebounce() {

			// timer event fires every half second, re-check mouse state

			if(vm.viewListShow && _mouseLeaveDelay > 0) {
				_mouseLeaveDelay += 500;

				// over 2 seconds
				if(_mouseLeaveDelay > 2000) {
					_mouseLeaveDelay = 0;
					vm.viewListShow = false;
				}
				else {
					// wait, try again
					$timeout(mouseOutDebounce, 500);
				}
			}
		}


		/**
		 *    HELPER
		 */

		function fmtViewTitle(views, id) {
			for(var i = 0; i < views.length; i++) {
				if(views[i].id == id) {
					return views[i].title;
				}
			}
			return '';
		}

	}

}
 
/**
 *    TABLE VIEW EDITOR
 *    used as follows:
 *    <div widget-table-view-editor></div>
 *
 *    Outputs table view editing html:
 *
 *    Uses 'table.view.editor' event to build editing UI
 *    Throws event 'table.view.editor' event when done or click off
 */


widgetTableViewEditor.$inject = ['$timeout', 'prefsRepo', 'sessionRepo', 'utilSvc', 'validSvc', 'msgSvc'];
angular
.module('espui.core.ui')
.directive('widgetTableViewEditor', widgetTableViewEditor);

/* @ngInject */
function widgetTableViewEditor($timeout, prefsRepo, sessionRepo, utilSvc, validSvc, msgSvc) {

	ctl.$inject = ['$scope'];
	return {
		restrict: 'A',
		replace: true,
		scope: {
			uniqueId: '@',
		},
		templateUrl: 'core/ui/widget/table/widget-table-view-editor.tpl.html',
		controller: ctl,
		controllerAs: 'vm'
	};

	/* @ngInject */
	function ctl($scope) {

		var vm = this;
		var _tblViewListener = null,
			_pending = {};

		// inherit
		utilSvc.ctl.addTableViews(vm);

		vm.currentView = '';
		vm.isWaiting = false;
		vm.scroll = false;

		// droplists
		vm.ViewDroplist = [];
		vm.SortByDroplist = [];
		vm.SortByDirDroplist = [];
		vm.PgSizeDroplist = [];

		// models
		vm.tblConfig = {};
		vm.views = [];
		vm.model = {};

		// methods
		vm.changeView = changeView;
		vm.create = create;
		vm.cancel = cancel;
		vm.save = save;
		vm.remove = remove;

		vm.propToggle = propToggle;
		vm.propApplyDefault = propApplyDefault;


		/**
		 *    INIT
		 */

		init();

		function init() {

			vm.PgSizeDroplist = [
				{label:'20', value: 20},
				{label:'50', value: 50},
				{label:'100', value: 100},
				{label:'250', value: 250},
				{label:'500', value: 500},
				{label:'1000', value: 1000}
			];

			vm.SortByDirDroplist = [
				{label:'Ascending', value: 'asc'},
				{label:'Descending', value: 'dsc'}
			];

		}

		/**
		 *    DESTROY
		 */

		$scope.$on('$destroy', function() {
			// clean up listener on destroy
			if(_tblViewListener) {
				_tblViewListener();
			}
		});


		/**
		 *    EVENT HOOK: TABLE VIEWS
		 */

		_tblViewListener = $scope.$on('widget.tblview.editor', function(event, evtData) {

			// reset
			vm.tblConfig = {};
			vm.views = [];

			vm.currentView = '';
			vm.ViewDroplist = [];
			vm.scroll = false;

			vm.model = {};
			vm.SortByDroplist = [];

			if(!!evtData && ($scope.uniqueId === evtData.uniqueId || !validSvc.isText($scope.uniqueId))) {
				vm.scroll = !!evtData.scroll;
				vm.tblConfig = evtData.config;
				var tblView = vm.tblViewInit(vm.tblConfig, sessionRepo.get(vm.tblConfig.storageKey));
				vm.views = tblView.views;

				// load views droplist (skip default)
				vm.ViewDroplist = [];
				for(var i = 1; i < vm.views.length; i++) {
					vm.ViewDroplist.push({label:vm.views[i].title, value: vm.views[i].id});
				}

				// determine which view to load
				if(tblView.current != '1') {
					vm.currentView = tblView.current;
					changeView();
				}
				else if(vm.ViewDroplist.length > 0) {
					vm.currentView = vm.ViewDroplist[0].value;
					changeView();
				}
				else {
					create();
				}
			}

		});

		function loadTableViews(tblConfig) {

			// setup default and saved views from session store

			var tblView = vm.tblViewInit(tblConfig, sessionRepo.get(tblConfig.storageKey));
			var result = tblView.views;

			// load views droplist (skip default)
			vm.ViewDroplist = [];
			for(var i = 1; i < result.length; i++) {
				vm.ViewDroplist.push({label:result[i].title, value: result[i].id});
			}

			return result;

		}


		/**
		 *    VIEW MODELS
		 */

		function tblViewEditVM(tblConfig, views, viewId) {

			// table view editor calls this to create an editable model for a chosen table view

			// params
			if(!!!tblConfig || !validSvc.isText(viewId) || !Array.isArray(views) || views.length < 1) {
				alert('utilSvc.tblViewEditVM, config, views and id required');
				return;
			}

			// find current view
			var viewNow = null;
			for(var i = 0; i < views.length; i++) {
				if(viewId == views[i].id) {
					viewNow = views[i];
					break;
				}
			}
			if(!!!viewNow) {
				throw new Error('utilSvc.tblViewEditVM, view id not found: ' + viewId);
			}

			// model details
			var result = {
				title: validSvc.newProp(viewNow.title),
				pgsize: validSvc.newProp(viewNow.pgsize)
			};
			var sortby = viewNow.sortby;
			if(sortby.indexOf('-') < 0) {
				result.sortby = validSvc.newProp(sortby);
				result.sortbydir = 'asc';
			}
			else {
				result.sortby = validSvc.newProp(sortby.substr(1, 1000));
				result.sortbydir = 'dsc';
			}

			// build editing section/column structure
			var cols = tblConfig.cols,
				colName = '',
				viewCols = viewNow.cols,
				sectionName = '',
				section = null,
				sections = [],
				addCol = {};

			// loop all possible config columns
			for(var c = 0; c < cols.length; c++) {
				colName = cols[c];
				addCol = tblConfig.colKeys[cols[c]];

				// new section?
				if(sectionName != addCol.section) {
					sectionName = addCol.section;
					sections.push({
						name: sectionName,
						title: tblConfig.sections[sectionName].title,
						cols:[]
					});
					section = sections[sections.length - 1];
				}

				// add col (de-referenced)
				section.cols.push({
					name: addCol.name,
					title: addCol.title,
					desc: addCol.desc,
					chk: viewCols.indexOf('|' + colName + '|') > -1 ? 'yes' : 'no',
					edit: addCol.edit === false ? 'no' : 'yes'
				});
			}
			result.sections = sections;

			return result;

		}


		/**
		 *    VIEW CHANGE
		 */

		function changeView() {

			if(vm.isWaiting) {
				return;
			}

			// reset
			vm.action = '';
			vm.model = {};
			vm.SortByDroplist = [];

			// load current view or nothing
			if(validSvc.isText(vm.currentView)) {
				vm.model = tblViewEditVM(vm.tblConfig, vm.views, vm.currentView);
				vm.SortByDroplist = buildSortBy(vm.model);
				vm.action = 'UPDATE';
			}

		}

		function propToggle(prop) {

			if(vm.isWaiting) {
				return;
			}

			// default cannot be changed
			if(vm.currentView == '1') {
				msgSvc.ok('Default View', 'Default view cannot be changed, create a new view.');
				return;
			}

			// cannot edit
			if(prop.edit == 'no') {
				msgSvc.ok('Required Property', 'This property cannot be changed.');
				return;
			}

			prop.chk = prop.chk == 'yes' ? 'no' : 'yes';
			vm.SortByDroplist = buildSortBy(vm.model);

		}

		function propApplyDefault() {

			// replace checked sections and columns with default

			var defaultModel = tblViewEditVM(vm.tblConfig, vm.views, '1');
			vm.model.sections = defaultModel.sections;

			vm.SortByDroplist = buildSortBy(vm.model);

		}


		/**
		 *    CRUD
		 */

		function create() {

			if(vm.isWaiting) {
				return;
			}

			// max views? 3 custom + 1 default
			if(vm.views.length >= 4) {
				msgSvc.ok('Cannot Create', 'Maximum 3 custom views per table.');
				return;
			}

			// setup new as default
			vm.currentView = '1';
			changeView();

			// set back to new
			vm.currentView = '0';
			vm.model.title.val = '';

			vm.action = 'CREATE';

		}

		function closeEditor() {
			$scope.$emit('widget.tblview.editor.change', {uniqueId: $scope.uniqueId, type:'close'});
		}

		function save() {

			if(vm.isWaiting) {
				return;
			}

			// no columns checked
			if(vm.SortByDroplist.length < 1) {
				msgSvc.ok('Columns Required', 'Choose at least 1 column.');
				return;
			}

			// title, required min 2, max 30
			vm.model.title = validText(vm.model.title, 2, 30);

			// sort by, required
			vm.model.sortby = validText(vm.model.sortby, 1, 100);

			if(vm.model.title.fail == 'yes' || vm.model.sortby.fail == 'yes') {
				msgSvc.ok('Cannot Save', 'Check properties');
				return;
			}

			vm.isWaiting = true;

			// re-hydrate saved view structure
			var tblView = vm.tblViewInit(vm.tblConfig, sessionRepo.get(vm.tblConfig.storageKey));
			var savedViews = tblView.views;
			savedViews.splice(0,1); // dump default

			// pack model, find it in saved views or add it
			if(vm.currentView == '0') {
				vm.currentView = Date.now().toString();
			}
			var viewPack = packViewForSave(vm.model, vm.currentView);
			if(vm.action == 'CREATE') {
				savedViews.push(viewPack);
			}
			else {
				for (var i = 0; i < savedViews.length; i++) {
					if(vm.currentView == savedViews[i].id) {
						savedViews[i] = viewPack;
						break;
					}
				}
			}

			_pending = {
				title: vm.model.title.val
			};

			// save format
			var savePrefsFormat = {
				name: vm.tblConfig.storageKey,
				current: vm.currentView,
				views: savedViews
			};

			// save to session
			sessionRepo.set(vm.tblConfig.storageKey, savePrefsFormat);

			// save to db
			prefsRepo.saveTableView(savePrefsFormat).then(okSavePrefs, errSavePrefs);

			function okSavePrefs() {
				vm.isWaiting = false;

				// exit on save
				var txt = vm.action == 'CREATE' ? ' Created' : ' Saved';
				msgSvc.okAsync(_pending.title + txt, '', 'wid.tblview.edit.save').then(closeEditor, closeEditor);
			}

			function errSavePrefs(r) {
				if(!!r) {
					throw new Error('widgetTableViewEditor.savePrefs, unexpected error: ' + utilSvc.http.safeResponse(r));
				}
			}

		}

		function remove() {

			if(vm.isWaiting) {
				return;
			}

			// find view name from dropdown
			var removeName = '';
			for (var i = 0; i < vm.ViewDroplist.length; i++) {
				if(vm.currentView == vm.ViewDroplist[i].value) {
					removeName = vm.ViewDroplist[i].label;
					break;
				}
			}

			// view to remove not found, something is weird, wipe out UI
			if(!validSvc.isText(removeName)) {
				vm.currentView = '';
				changeView();
				return;
			}

			_pending = {
				name: removeName
			};

			msgSvc.confirm({
				id: 'widget.table.view.delete',
				title: 'Remove ' + removeName,
				msg: 'Confirm remove.',
				buttons: [
					{text:'OK', result:'YES', cancel: false},
					{text:'CANCEL', result:'CANCEL', cancel: true}
				]
			}).then(confirmViewRemove, confirmViewRemove);

		}

		function confirmViewRemove(r) {

			// user said no
			if(!!!r || r.result != 'YES') {
				return;
			}
			vm.isWaiting = true;

			// re-hydrate saved view structure
			var tblView = vm.tblViewInit(vm.tblConfig, sessionRepo.get(vm.tblConfig.storageKey));
			var savedViews = tblView.views;
			savedViews.splice(0,1); // dump default

			// find view idx
			var removeIdx = -1;
			for (var i = 0; i < savedViews.length; i++) {
				if(vm.currentView == savedViews[i].id) {
					removeIdx = i;
					break;
				}
			}

			// something is weird, start again
			if(removeIdx < 0) {
				vm.currentView = '';
				changeView();
				return;
			}
			savedViews.splice(removeIdx, 1);

			// save format
			var savePrefsFormat = {
				name: vm.tblConfig.storageKey,
				current: vm.currentView,
				views: savedViews
			};

			// save to session
			sessionRepo.set(vm.tblConfig.storageKey, savePrefsFormat);

			// save to db
			prefsRepo.saveTableView(savePrefsFormat).then(okSavePrefs, errSavePrefs);

			function okSavePrefs() {
				vm.isWaiting = false;

				// choose another non-default view
				vm.views = loadTableViews(vm.tblConfig);
				if(vm.views.length > 1) {
					vm.currentView = vm.views[1].id;
					changeView();
				}
				else {
					create();
				}

				msgSvc.ok(_pending.name + ' Removed');
			}

			function errSavePrefs(r) {
				if(!!r) {
					throw new Error('widgetTableViewEditor.savePrefs, unexpected error: ' + utilSvc.http.safeResponse(r));
				}
			}

		}

		function cancel() {
			closeEditor();
		}


		/**
		 *    HELPERS
		 */

		function buildSortBy(m) {

			// walk model props and build sort by choices

			var result = [];

			// add all checked props
			var cols = [];
			for(var i = 0; i < m.sections.length; i++) {
				cols = m.sections[i].cols;
				for(var ii = 0; ii < cols.length; ii++) {
					if(cols[ii].chk == 'yes') {
						result.push({label: m.sections[i].title + ' - ' + cols[ii].title, value: cols[ii].name});
					}
				}
			}

			return result;
		}

		function packViewForSave(m, viewId) {

			// walk model props and pack into save format

			// add details
			var result = {
				id: viewId,
				title: m.title.val,
				sortby: m.sortby.val,
				pgsize: m.pgsize.val,
				cols: '|'
			};
			if(m.sortbydir == 'dsc') {
				result.sortby = '-' + result.sortby;
			}

			// pack cols
			var cols = [];
			for(var i = 0; i < m.sections.length; i++) {
				cols = m.sections[i].cols;
				for(var ii = 0; ii < cols.length; ii++) {
					if(cols[ii].chk == 'yes') {
						result.cols += cols[ii].name + '|';
					}
				}
			}

			return result;

		}

		function validText(prop, min, max) {

			// required
			if(!validSvc.isText(prop.val)) {
				prop.fail = 'yes';
				prop.msg = 'required';
				return prop;
			}

			// min
			if(prop.val.length < min) {
				prop.fail = 'yes';
				prop.msg = 'minimum ' + min.toString() + ' characters';
				return prop;
			}

			// max
			if(prop.val.length > max) {
				prop.fail = 'yes';
				prop.msg = 'maximum ' + max.toString() + ' characters';
				return prop;
			}

			// success
			prop.fail = 'no';
			prop.msg = '';
			return prop;

		}

	}

}
 
/**
 *    TIME SERIES
 *    used as follows:
 *    <div widget-timeseries unique-id=""></div>
 *
 *    Outputs html for:
 *    	html table with variable number of columns
 *    	time series line chart to match table data
 *
 *    Receives a dataset event from controller to build output
 *    User interaction with table changes chart display
 *    Throws no events back to controller
 */


widTimeseries.$inject = ['$timeout', 'utilSvc', 'validSvc'];
angular
.module('espui.core.ui')
.directive('widgetTimeseries', widTimeseries);

/* @ngInject */
function widTimeseries($timeout, utilSvc, validSvc) {

	ctl.$inject = ['$scope'];
	return {
		restrict: 'A',
		replace: true,
		scope: {
			uniqueId: '@',
		},
		templateUrl: 'core/ui/widget/timeseries/widget-timeseries.tpl.html',
		controller: ctl,
		controllerAs: 'vm'
	};

	/* @ngInject */
	function ctl($scope) {

		var vm = this;
		var _unregisterListener = null,
			_rowHoverPendingId = -1,
			_scrollPortCols = 12;

		// inherit
		utilSvc.ctl.addFiltering(vm);
		utilSvc.ctl.addSorting(vm);

		// cache entities
		vm.table = {};
		vm.chart = {};
		vm.flt = {};

		// table display
		vm.displayCols = {};
		vm.displayRows = {};

		// horizontal scroll viewport
		vm.hScroll = hScroll;
		vm.hScrollPortTitle = {};

		// methods
		vm.filterChange = filterChange;
		vm.tblHoverRow = tblHoverRow;


		/**
		 *    INIT
		 *

		init();

		function init() {

		}


		/**
		 *    CTL EVENT HOOK
		 *    controller sends data to timeseries widget
		 */

		_unregisterListener = $scope.$on('widget.timeseries', function(event, evtData) {
			evtData = evtData || {};

			// unique id match?
			if(validSvc.isText(evtData.uniqueId) && $scope.uniqueId != evtData.uniqueId) {
				return;
			}

			// reset display and state
			resetDisplay();
			vm.table = {
				show: false,
				colHeaders: [],
				rows: []
			};
			vm.chart = {
				show: false
			};
			vm.flt = vm.initFilters({
				PageSize: 1000,
				SortBy: ['title']
			});
			vm.flt.hScrollStart = 1;


			// exit if no data
			if(!!!evtData || !!!evtData.data) {
				return;
			}


			// load data
			var d = evtData.data || {};

			vm.table = {
				interval: d.interval,
				intervalTxt: '',
				show: d.table.show,
				colHeaders: d.table.colHeaders,
				rows: d.table.rows
			};
			vm.chart = d.chart;

			switch(d.interval) {
				case 'WEEK':
					vm.table.intervalTxt = 'Week';
					break;
				case 'MONTH':
					vm.table.intervalTxt = 'Month';
					break;
				case 'QUARTER':
					vm.table.intervalTxt = 'Quarter';
					break;
				default:
					vm.table.intervalTxt = '';
			}

			// controller passes in any viewstate filter
			if(!!d.table.flt) {
				vm.flt = addFilterViewstate(vm.flt, d.table.flt);
			}

			// horizontal scroll port change will draw table / chart
			if(vm.table.show || vm.chart.show) {
				hScroll(0);
			}

		});


		/**
		 *    CHART EVENT HOOK
		 *    mouse hover over line in chart sends row id back to timeseries table
		 *

		_chartListener = $scope.$on('widget.chart.timeseries.action', function(event, evtData) {
			event.stopPropagation();

			tblHoverRow(evtData.rowId);
		});
		*/



		/**
		 *    DESTROY
		 */

		$scope.$on('$destroy', function() {
			if(_unregisterListener) {
				_unregisterListener();
			}
			/*if(_chartListener) {
				_chartListener();
			}
			*/
		});


		/**
		 *    FILTER CHANGE
		 */

		function resetDisplay() {
			vm.displayCols = [];
			vm.displayRows = [];
			vm.chart.data = [];
			$scope.$broadcast('widget.chart.sync', {render:''});
		}

		function buildFilterFromColumns(cols, flt) {

			// filter values are stored in each column

			cols = Array.isArray(cols) ? cols : [];
			var col = {};
			for(var i = 0; i < cols.length; i++) {
				col = cols[i];
				if(typeof(col.flt) !== 'undefined') {
					flt[col.fltType] = flt[col.fltType] || {};
					flt[col.fltType][col.id] = col.flt;
				}
			}

			return flt;
		}

		function addFilterViewstate(flt, vs) {

			// add viewstate properties to existing filter

			vs = vs || {};

			for(var prop in vs) {
				if(vs.hasOwnProperty(prop)) {
					flt[prop] = vs[prop];
				}
			}

			return flt;
		}

		function filterChange(immediate) {

			// used for html property changes
			// includes UI debouncing and UI viewstate updates

			// exit if filter is off
			if(!vm.flt.Ready) {
				return;
			}

			// mark filters dirty
			vm.flt.Dirty = true;

			// already working
			if(vm.flt.Busy) {
				return;
			}
			vm.flt.Busy = true;
			vm.flt.Dirty = false;

			// debounce ui changes
			var delayTime = !!immediate ? 0 : 300;
			$timeout(function() {

				vm.flt = buildFilterFromColumns(vm.displayCols, vm.flt);

				buildScrollPortRows(vm.table.rows, vm.displayCols, vm.flt);

				vm.flt.Busy = false;

				// run again? data changed during filtering
				if(vm.flt.Dirty) {
					filterChange(true);
					return;
				}

				// debounce chart
				$timeout(function() {

					if(!vm.flt.Busy && !vm.flt.Dirty) {

						if(vm.chart.show) {
							var cht = vm.chart;
							$scope.$broadcast('widget.chart.sync', {
								uniqueId: cht.id,
								config: cht.config,
								data: cht.data,
								render: 'now'
							});
						}

						emitFltUpdate();
					}

				},1000);

			}, delayTime);

		}


		/**
		 *    TABLE HOVER ROW
		 */

		function tblHoverRow(id, immediate) {

			// table row hover for mouse in / out events

			// id already pending?
			if(_rowHoverPendingId < 0) {
				$timeout(tblHoverChartUpdate, !!immediate ? 0 : 500);
			}
			_rowHoverPendingId = id;
		}

		function tblHoverChartUpdate() {

			if(_rowHoverPendingId < 0 || _rowHoverPendingId > vm.displayRows.length - 1) {
				_rowHoverPendingId = -1;
				return;
			}

			var items = [],
				i = 0;

			if(vm.table.show) {
				items = vm.displayRows;
				for(i = 0; i < items.length; i++) {
					items[i].selected = i === _rowHoverPendingId;
				}
			}

			if(vm.chart.show) {
				items = vm.chart.data;
				for(i = 0; i < items.length; i++) {
					items[i].selected = i === _rowHoverPendingId;
				}

				$scope.$broadcast('widget.chart.sync', {
					uniqueId: vm.chart.id,
					config: vm.chart.config,
					data: vm.chart.data,
					render: 'now'
				});
			}

			_rowHoverPendingId = -1;

		}


		/**
		 *    TABLE HORIZONTAL SCROLL
		 */

		function calcScrollPort(st, port, colLen) {

			// adjust portwidth
			if(port < _scrollPortCols && colLen > _scrollPortCols) {
				port = _scrollPortCols;
			}
			else if(port > colLen - 1) {
				port = colLen - 1;
			}

			// adjust start
			if(st < 1) {
				st = 1;
			}
			else if(st > colLen - 1) {
				st = colLen - port;
			}

			// don't scroll past last item
			if(st + port - 1 > colLen - 1) {
				st = colLen - port;
			}

			return {
				st: st,
				port: port,
				end: st + port - 1
			};

		}

		function displayColVM(col, flt) {
			return {
				id: col.id,
				mth: col.mth,
				day: col.day,
				title: col.title,
				width: col.width,
				flt: flt[col.fltType][col.id],
				fltType: col.fltType
			};
		}

		function hScroll(inc) {

			// move horizontal viewport left or right

			var colHeaders = vm.table.colHeaders,
				flt = vm.flt;

			// get filter values from columns before h scroll
			if(inc !== 0) {
				flt = vm.resetFilters(flt);
				flt = buildFilterFromColumns(vm.displayCols, flt);
			}

			// re-calc scroll port limits
			var hScroll = calcScrollPort(flt.hScrollStart + inc, _scrollPortCols, colHeaders.length);
			flt.hScrollStart = hScroll.st;

			// viewport display cols
			vm.displayCols = [];
			vm.displayCols.push(displayColVM(colHeaders[0], flt)); // title
			for(var i = hScroll.st; i <= hScroll.end; i++) {
				vm.displayCols.push(displayColVM(colHeaders[i], flt));
			}

			// viewport title
			vm.hScrollPortTitle = {
				start: colHeaders[hScroll.st].title,
				end: colHeaders[hScroll.end].title,
				showPrev: hScroll.st > 1,
				showNext: hScroll.end < colHeaders.length - 1
			};

			// done, fire filter change to draw table
			flt.Ready = true;
			filterChange(true);

		}

		function buildScrollPortRows(dataRows, displayCols, flt) {

			// filter rows
			var fltRows = vm.filterList(dataRows, flt);

			// display table
			var portData = getScrollPortRowData(fltRows, displayCols);
			if(vm.table.show) {
				vm.displayRows = portData.table;
			}

			// chart render updates
			var portDataChart = portData.chart;
			vm.chart.data = portDataChart.data;

			var chartConfig = vm.chart.config;
			chartConfig.xAxis = chartConfig.xAxis || {};
			chartConfig.xAxis.labels = portDataChart.xLabels;
			chartConfig.yAxis = chartConfig.yAxis || {};
			chartConfig.yAxis.minVal = portDataChart.yMin;
			chartConfig.yAxis.maxVal = portDataChart.yMax;

			// disable chart if y values all zero
			var cht = vm.chart;
			if(cht.config.yAxis.minVal === 0 && cht.config.yAxis.maxVal === 0) {
				cht.show = false;
			}

			// disable chart if no data or series only has 1 column
			if(cht.data.length < 1 || cht.data[0].series.length < 2) {
				cht.show = false;
			}

		}


		/**
		 *    TABLE ROWS
		 */

		function getScrollPortRowData(dataRows, cols) {

			// parse h scrollport into table rows / chart data formats
			dataRows = Array.isArray(dataRows) ? dataRows : [];

			var result = {
					table: [],
					chart: {
						yMin: 0,
						yMax: 0,
						xLabels: [],
						data: []
					}
				},
				dataRow = {},
				rowTitle = '',
				rowId = 0,
				tblRow = [],
				chartPoints = [],
				cid = '',
				val = 0,
				yMin = 0,
				yMax = 0,
				isQuarterly = vm.table.interval == 'QUARTER';

			for(var i = 0; i < dataRows.length; i++) {
				dataRow = dataRows[i];
				rowTitle = dataRow.title;
				rowId = i;

				tblRow = {
					id: rowId,
					title: rowTitle,
					selected:false,
					series: []
				};
				chartPoints = [];

				// data for viewport columns
				for(var ii = 1; ii < cols.length; ii++) {
					cid = cols[ii].id;
					val = dataRow[cid];

					tblRow.series.push({
						id: cid,
						val: val,
						txt: dataRow[cid + 'txt']
					});

					chartPoints.push({
						name: cid,
						val: val
					});

					// chart: keep track of Y axis min/max
					if(val < yMin) {
						yMin = val;
					}
					if(val > yMax) {
						yMax = val;
					}

					// build x axis data labels
					if(i === 0) {
						result.chart.xLabels.push({
							id: cid,
							tickTextTop: isQuarterly ? cols[ii].title.substr(0,2) : cols[ii].mth,
							tickTextBtm: isQuarterly ? cols[ii].title.substr(3,4) : cols[ii].day
						});
					}

				}

				result.table.push(tblRow);
				result.chart.data.push({
					id: rowId,
					selected: false,
					series: chartPoints
				});
			}

			result.chart.yMin = yMin;
			result.chart.yMax = yMax;

			return result;
		}


		/**
		 *   PARENT FILTER EVENTS
		 */

		function emitFltUpdate() {

			// build a lighter filter to emit and save

			// use columns only in current hscroll window (vm.displayCols)
			var flt = buildFilterFromColumns(vm.displayCols, {});
			flt.SortBy = vm.flt.SortBy;
			flt.hScrollStart = vm.flt.hScrollStart;

			$scope.$emit('widget.timeseries.action', {action:'flt', flt:flt});
		}

	}

}
 
angular
.module('espui.core.ui')
.directive('widgetIframeLoad', widIframeLoad);

/* @ngInject */
function widIframeLoad() {
	// tbd: iframe load detection

	var widget = {
		restrict: 'A',
		replace: false,
		scope: {
			iframeOnLoad: '&'
		},
		link: linkFx
	};

	return widget;

	function linkFx(scp, elem) {

		elem.on('load', function() {
			scp.$applyAsync(function() {
				if(!!elem && !!elem[0] && !!elem[0].src) {
					scp.iframeOnLoad({ src: elem[0].src });
				}
			});
		});

		scp.$on('$destroy', function() {
			elem.off('load');
		});
	}
} 
widScroll.$inject = ['$window', '$timeout'];
angular
.module('espui.core.ui')
.directive('widgetScroll', widScroll);

/* @ngInject */
function widScroll($window, $timeout) {

	var widget = {
		restrict: 'A',
		replace: false,
		scope: {
			scrollEvent: '&'
		},
		link: linkFx
	};

	return widget;

	function linkFx(scp, elem, attr) {

		var isDebouncing = false;

		angular.element($window).on("scroll", function() {
			if(!!scp.scrollEvent) {
				if(!isDebouncing) {
					isDebouncing = true;
					$timeout(function(){
						scp.scrollEvent({scrollTop: $window.pageYOffset});
						isDebouncing = false;
					}, 500);
				}
			}
			//console.log('scroll top: ' + $window.pageYOffset);
		});

		scp.$on('$destroy', function() {
			angular.element($window).unbind("scroll");
		});

	}

}

 
/**
 *    UTILITY FUNCTIONS
 *    app-wide utility methods
 *
 *    note: there are some duplicated methods in this class from other services
 *    utility cannot depend on other services since most other services depend on utility
 *    (avoiding circular references)
 */

utilSvc.$inject = ['$filter', '$rootScope'];
angular
.module('espui.core')
.factory('utilSvc', utilSvc);

/* @ngInject */
function utilSvc($filter, $rootScope) {

    	var util = {
		str: {
			isText: isText,
			toText: toText,
		},
		num: {
			randomInt: randomInt,
			parse: numParse,
			toDayTextShort: numDayShortText,
			numberFmt: numberFmt
		},
		dt: {
			isValid: dateValid,
			isNull: dateIsNull,
			parse: dateParse,
			zeroTime: dateZeroTime,
			addDays: dateAddDays,
			addMonths: dateAddMonths,
			monthStart: dateMonthStart,
			monthEnd: dateMonthEnd,
			quarterStart: dateQuarterStart,
			utcOffset: dateUtcOffset,
			diffMilli: dateDiffMilli,
			diffSeconds: dateDiffSeconds,
			diffMinutes: dateDiffMinutes,
			diffDays: dateDiffDays,
			greaterThan: dateGreaterThan,
			lessThan: dateLessThan,
			toText: dateToText,
			toTextUTC: dateToTextUTC,
			toTextWithTime: dateToTextWithTime,
			toServerDate: dateServerDate,
			toServerDateExactPSTNoon: dateServerDateExactPSTNoon,
			toServerDateExactUTC: dateServerDateExactUTC,
			toServerString: dateServerString,
			fromServerDateExactPST: dateParseServerDateExactPST,
			fromServerDateExactUTC: dateParseServerDateExactUTC,
			fromServerString: dateParseServerString,
			monthShortText: dateMonthShortText,
			monthFullText: dateMonthFullText,
			dayFullText: dateDayFullText,
			dateModeText: dateModeText,
			dateModeKeepDates: dateModeKeepDates,
			toDateMMDDYYYY: dateMMDDYYYY,
			toBizTime: dateToBizTime,
			setBizTimeOffset: dateSetBizTimeOffset
		},
		array: {
			sortASC: sortAscending,
			sortTextASC: sortTextAscending,
			sortDSC: sortDescending,
			sortTextDSC: sortTextDescending
		},
		ctl: {
			addSorting: addSorting,
			addPaging: addPaging,
			addFiltering: addFiltering,
			addMultiselect: addMultiselect,
			addFlexTop: addFlexTop,
			addTableViews: addTableViews
		},
		http: {
			safeResponse: httpSafeResponse
		},
		paging: {
			addMethods: addPaging,
			getTotalPages: getTotalPages,
			apiResults: apiResultsPaging
		},
		sorting: {
			addMethods: addSorting,
			sortByViewStyle: sortByViewStyle,
			sortByApiStyle: sortByApiStyle
		},
		ng: {
			droplist: ngDroplist,
			droplistNONE: ngDroplistNONE,
			droplistALL: ngDroplistALL,
			droplistAutoselect: ngDroplistAutoselect,
			droplistAutoselectYesNo: ngDroplistAutoselectYesNo,
			droplistLabel: ngDroplistLabel,
			stateFullNamesDroplist: ngStateFullNamesDroplist,
			stateShortNamesDroplist: ngStateShortNamesDroplist,
			monthShortDroplist: ngMonthShortDroplist,
			monthFullDroplist: ngMonthFullDroplist
		},
		css: {
			btnStyle: cssButtonStyle,
			validStyle: cssValidStyle
		},
		json: {
			stringify: jsonStringify,
			stringifyPretty: jsonStringifyPretty,
			parse: jsonParse
		},
		regex: {
			loginPwd: regexPwd,
			dateFmt: regexDateFmt,
			apiDateStringFmt: regexApiDateStringFmt,
			apiDateTimeStringFmt: regexApiDateTimeStringFmt,
			cleanFilename: regexFilename,
			alpha: regexAlpha
		},
		obj: {
			findChildProp: objFindChildProp
		},
		aff: {
			findStatus: affFindStatus,
			findStatusOfCe: affFindStatusOfCE,
			findCe: affFindCe,
			findCeList: affFindCeList,
			findCeCanCreateCpList: affFindCeCanCreateCpList,
			findRx: affFindRx,
			findRxBilling: affFindRxBilling,
			findRxList: affFindRxList,
			findRxModel: affFindRxModel,
			findRxParent: affFindRxParent,
			findRxType: affFindRxType,
			findVen: affFindVen,
			findVenType: affFindVenType,
			findShareGroup: affFindShareGroup,
			findWithVendor: affWithVendor,
			findVerityAdmin: affFindVerityAdmin,
			findProgAdmin: affFindProgAdmin,
			ceList: affCeList,
			rxList: affRxList,
			rxParentList: rxParentList,
			ceDroplist: affCeDroplist,
			ceDroplistLabel: affCeDroplistLabel,
			rxDroplist: affRxDroplist,
			venList: affVenList,
			shareGroupList: affShareGroupList,
			rxModelList: affRxModelList,
			progAdminList: affProgAdminList,
			rxModelsByFeature: affRxModelsByFeature,
			rxShortNameById: rxShortNameById,
			ceNameByIdLookup: ceNameByIdLookup,
			rxShortNameByIdLookup: rxShortNameByIdLookup,
			ceOptions: affCeOptions,
			rxOptions: affRxOptions,
			rxOptionsByTPA: affRxOptionsByTPA,
			rxOptionsByRollup: rxOptionsByRollup,
			venOptions: affVenOptions,
			accumGrpAllOptions: affAccumGrpAllOptions,
			droplistByType: droplistByType,
			tpaDroplist: tpaDroplist
		},
		widget: {
			dateRangeList: widDateRangeList
		},
		user: {
			hasFeature: userHasFeature,
			parseLoginProfile: userParseLoginProfile
		},
		tblview: {
			initViews: tblViewInit
		}
	};

	return util;


	/**
	 *    STRING
	 */

	function isText(testVal) {

		if(!!!testVal || typeof(testVal) !== 'string' || testVal.trim() === '') {
			return false;
		}
		else {
			return true;
		}

	}

	function toText(testVal) {

		if(testVal === null || typeof(testVal) === 'undefined') {
			return '';
		}

		if(typeof(testVal) == 'string') {
			return testVal;
		}

		var result = '';
		try {
			result = testVal.toString();
			return result;
		}
		catch(err) {
			// do nothing
		}

		return '';
	}


	/**
	 *    NUMBER
	 */

	function randomInt(min, max) {
		return Math.floor(Math.random() * (max - min)) + min;
	}

	function numParse(numText) {

		// convert a non-number to a valid number or zero

		// already a number
		if(typeof(numText) === 'number') {
			return numText;
		}

		// convert anything else to a string
		var newText = toText(numText);

		// is negative, leading '-' or enclosed in '()'
		var isNeg = newText.substr(0,1) === '-' || (newText.substr(0,1) === '(' && newText.substr(-1, 1) === ')');

		// regex for numbers and decimal
		var finalText = newText.replace(/[^0-9.]+/g,'');

		// parse to float
		try {
			var newNum  = parseFloat(finalText);
			if(!!!newNum) {
				return 0;
			}
			else {
				return newNum * (isNeg ? -1 : 1);
			}
		}
		catch(err) {
			return 0;
		}

	}


	/**
	 *    DATE
	 *    borrowed a few functions from moment.js
	 *    its overkill to include the whole thing
	 */

	function dateIsNull(dt) {

		// check for both JavaScript and api server null date values

		if(!!!dt || dt === null) {
			return true;
		}

		// server null date string
		if(typeof(dt) === 'string' && (dt === '0001-01-01T00:00:00Z' || dt === '0001-01-01')) {
			return true;
		}

		return false;

	}

	function dateServerDate(dt) {

		var result = dateParse(dt);

		if(!!!result || result === null) {
			return '0001-01-01T00:00:00Z';
		}
		else {
			return result;
		}

	}

	function dateServerDateExactUTC(dtExactString) {

		// convert a user entered string into UTC ISO string with no local offset
		// note: incoming "exact dates" are in a string format "m/d/yyyy", there is no timezone or date object

		var result = '0001-01-01T00:00:00Z'; // api null date is an ISO string

		if(isText(dtExactString)) {

			var dtVals = dtExactString.split('/');
			if(dtVals.length !== 3) {
				return result;
			}

			// create date object, constructor uses now local timezone
			var dt = new Date();

			// reset underlying UTC milliseconds
			// create date in UTC 0
			dt.setTime(Date.UTC(dtVals[2], parseInt(dtVals[0]) - 1, dtVals[1]));

			result = dt.toISOString();
		}

		return result;
	}

	function dateServerDateExactPSTNoon(dtExactString) {

		// convert a user entered string into UTC ISO string with PST noon offset
		// note: incoming "exact dates" are in a string format "m/d/yyyy", there is no timezone or date object

		var result = '0001-01-01T00:00:00Z'; // api null date is an ISO string

		if(isText(dtExactString)) {

			var dtVals = dtExactString.split('/');
			if(dtVals.length !== 3) {
				return result;
			}

			// create date object, constructor uses now local timezone
			var dt = new Date();

			// reset underlying UTC milliseconds
			// create date in UTC 0, then add 8 hours + 12 hours to get to PST noon
			// note: sometimes PST is 7 hours, we are ok to ignore PDT and keep it 8
			dt.setTime(Date.UTC(dtVals[2], parseInt(dtVals[0]) - 1, dtVals[1]) + 72000000);

			result = dt.toISOString();
		}

		return result;
	}

	function dateParseServerDateExactUTC(apiVal) {

		if(!dateIsNull(apiVal) && dateIsISO(apiVal)) {
			var dt = new Date(apiVal);  // create date (using an ISO date string input creates date in correct UTC time, no local offset)
			return (dt.getUTCMonth() + 1).toString() + '/' + dt.getUTCDate().toString() + '/' + dt.getUTCFullYear().toString();
		}

		return '';

	}

	function dateParseServerString(apiVal, regexFmt, addTime) {

		// server date string format is: yyyy-mm-dd, convert to local timezone date object

		// use regex object passed in or create a new one
		// note: regex object creation is expensive, lists may pass in the regex object

		if(!!addTime) {
			regexFmt = typeof(regexFmt) == 'undefined' ? regexApiDateTimeStringFmt() : regexFmt;
		}
		else {
			regexFmt = typeof(regexFmt) == 'undefined' ? regexApiDateStringFmt() : regexFmt;
		}

		if(regexFmt.test(apiVal)) {
			var dtSeg = apiVal.split('-');

			if(!!addTime && dtSeg.length === 6) {
				return new Date(dtSeg[0], dtSeg[1] - 1, dtSeg[2], dtSeg[3], dtSeg[4], dtSeg[5]);
			}
			else if(dtSeg.length === 3) {
				return new Date(dtSeg[0], dtSeg[1] - 1, dtSeg[2]);
			}
		}

		return null;

	}

	function dateServerString(uiDate, delimiter) {

		// convert date object into api string format: mm-dd-yyyy

		if(!dateValid(uiDate)) {
			return '';
		}

		var dtMonth = (uiDate.getMonth() + 1).toString(),
			dtDay = uiDate.getDate().toString();

		if(dtMonth.length < 2) {
			dtMonth = '0' + dtMonth;
		}
		if(dtDay.length < 2) {
			dtDay = '0' + dtDay;
		}

		var dl = '-';
		if (!!delimiter) {
			dl = delimiter;
		}
		if (delimiter == 'NONE') {
			dl = '';
		}
		return uiDate.getFullYear().toString() + dl + dtMonth + dl + dtDay;

	}
	function dateMMDDYYYY(uiDate) {

		// convert date object into api string format: mm/dd/yyyy

		if(!dateValid(uiDate)) {
			return '';
		}

		var dtMonth = (uiDate.getMonth() + 1).toString(),
			dtDay = uiDate.getDate().toString();

		if(dtMonth.length < 2) {
			dtMonth = '0' + dtMonth;
		}
		if(dtDay.length < 2) {
			dtDay = '0' + dtDay;
		}

		return dtMonth + '/' + dtDay + '/'  + uiDate.getFullYear().toString();

	}

	function dateParseServerDateExactPST(apiVal, withTime) {

		var result = '';

		if(!dateIsNull(apiVal) && dateIsISO(apiVal)) {
			var dt = new Date(apiVal);  // create date (using an ISO date string input creates date in correct UTC time, no local offset)
			dt.setTime(dt.getTime() - 28800000); // shift UTC date back to PST date (-8 hours) should result in PST noon

			result = (dt.getUTCMonth() + 1).toString() + '/' + dt.getUTCDate().toString() + '/' + dt.getUTCFullYear().toString();

			if(!!withTime) {
				var hrs = dt.getUTCHours(),
					mins = dt.getUTCMinutes(),
					ampm = ' AM';

				if(hrs > 12) {
					ampm = ' PM';
					hrs = hrs - 12;
				}

				var minsTxt = mins.toString();
				if(mins < 10) {
					minsTxt = '0' + minsTxt;
				}

				result += ' ' + hrs.toString() + ':' + minsTxt + ampm;
			}
		}

		return result;

	}

	function dateIsISO(val) {

		// verifies the value is a string with JSON ISO format and time is zero UTC
		// example: 0001-01-01T00:00:00Z

		if(isText(val)) {
			var rg = regexDateISO();
			return rg.test(val);
		}

		return false;

	}

	function dateObjectValid(dt) {
		// date type (ala angular source code)
		return !!dt && Object.prototype.toString.call(dt) === '[object Date]' && !isNaN(Date.parse(dt));
	}

	function dateValid(dt) {

		// falsy
		if(!!!dt) {
			return false;
		}

		// already a date object
		if(dateObjectValid(dt)) {
			return true;
		}
		
		// try parsing: string or number
		if(typeof(dt) === 'string' || !isNaN(dt)) {

			// server string null date
			if(dateIsNull(dt)) {
				return false;
			}

			try {
				var dtParse = new Date(Date.parse(dt));
				return dateObjectValid(dtParse);
			}
			catch(err) {
				// do nothing, failed
			}
		}

		// failed to convert
		return false;

	}

	function dateParse(dt) {

		// same as isDate above, but returns a valid date object

		// falsy
		if(!!!dt) {
			return null;
		}

		// already a date object
		if(dateObjectValid(dt)) {
			return dt;
		}

		// try parsing: string or number
		if(typeof(dt) === 'string' || !isNaN(dt)) {

			// server string null date
			if(dateIsNull(dt)) {
				return null;
			}

			try {
				var dtParse = new Date(Date.parse(dt));
				if(dateObjectValid(dtParse)) {
					return dtParse;
				}
			}
			catch(err) {
				// do nothing, failed
			}
		}

		// failed to convert
		return null;
	}

	function dateToBizTime(dt) {
		// convert local browser time into server business time

		if(dateIsNull(dt)) {
			return null;
		}
		
		// rootscope offset not used
		var bizOffset = $rootScope.BusinessTimeOffset;
		if(!isNumber(bizOffset) || bizOffset == 0) {
			return dt;
		}
		
		// get date object (dt could be a string)
		var dtObject = dateParse(dt);
		if(!!!dtObject) {
			return null;
		}

		var bizDate = new Date(dtObject.getTime() + bizOffset); // offset milliseconds
		console.log('data dt: ' + dt.toString());
		console.log('browser dt: ' + dtObject.toString());
		console.log('biz dt: ' + bizDate.toString());

		return bizDate;
	}

	function dateSetBizTimeOffset(apiBizTimeSeconds) {
		// server sends seconds UTC offset (PST -28800)
		var apiOffsetMilli = 0;
		if(isInteger(apiBizTimeSeconds)) {
			apiOffsetMilli = apiBizTimeSeconds * -1000; // invert, golang returns offset as negative
		}

		// use offset if its significant (more than +-1 minute)
		var dt = new Date();
		var bizTimeOffset = (dt.getTimezoneOffset() * 60000) - apiOffsetMilli;
		$rootScope.BusinessTimeOffset = Math.abs(bizTimeOffset) > 59000 ? bizTimeOffset : 0;

		var bizDate = dateToBizTime(dt);
		console.log('biz time offset : ' +  $rootScope.BusinessTimeOffset);
		console.log('browser dt: ' + dt.toString());
		console.log('biz dt: ' + bizDate.toString());
	}

	function dateZeroTime(dt) {
		return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate(), 0, 0, 0);
	}

	function dateAddDays(dt, days) {
		return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate() + days, dt.getMinutes(), dt.getSeconds(), dt.getMilliseconds());
	}

	function dateAddMonths(dt, months) {
		return new Date(dt.getFullYear(), dt.getMonth() + months, dt.getDate(), dt.getMinutes(), dt.getSeconds(), dt.getMilliseconds());
	}

	function dateMonthStart(dt) {
		return new Date(dt.getFullYear(), dt.getMonth(), 1, 0, 0, 0);
	}

	function dateMonthEnd(dt) {
		return new Date(dt.getFullYear(), dt.getMonth() + 1, 0, 0, 0, 0);
	}

	function dateQuarterStart(dt) {

		// note: getMonth() returns 0 - 11

		switch(dt.getMonth()) {
			case 0:
			case 1:
			case 2:
				return new Date(dt.getFullYear(), 0, 1, 0, 0, 0);
			case 3:
			case 4:
			case 5:
				return new Date(dt.getFullYear(), 3, 1, 0, 0, 0);
			case 6:
			case 7:
			case 8:
				return new Date(dt.getFullYear(), 6, 1, 0, 0, 0);
			case 9:
			case 10:
			case 11:
				return new Date(dt.getFullYear(), 9, 1, 0, 0, 0);
		}

	}

	function dateUtcOffset(dt) {
		// offset date to account for daylight savings time
		// note: only minutes correctly handles utc offset values, not getTime()
		var offset = new Date(dt);
		offset.setMinutes(dt.getMinutes() - dt.getTimezoneOffset());
		return offset;
	}

	function dateDiffMilli(start, end) {
		return (dateUtcOffset(end) - dateUtcOffset(start));
	}

	function dateDiffSeconds(start, end) {
		return dateDiffMilli(start, end) / 1000; // 1 second
	}

	function dateDiffMinutes(start, end) {
		return dateDiffMilli(start, end) / 60000; // 1 minute
	}

	function dateDiffDays(start, end) {
		return dateDiffMilli(start, end) / 86400000; // 1 day
	}

	function dateGreaterThan(initial, comparison, equal) {
		if(!!!equal) {
			return dateDiffMilli(initial, comparison) > 0;
		}
		else {
			return dateDiffMilli(initial, comparison) >= 0;
		}
	}

	function dateLessThan(initial, comparison, equal) {
		if(!!!equal) {
			return dateDiffMilli(initial, comparison) < 0;
		}
		else {
			return dateDiffMilli(initial, comparison) <= 0;
		}
	}

	function dateToText(dt) {
		// default format is: M/d/yyyy
		var dtValid = dateParse(dt);
		if(!!dtValid) {
			return (dtValid.getMonth() + 1).toString() + '/' + dtValid.getDate().toString() + '/' + dtValid.getFullYear().toString();
		}
		else {
			return '';
		}
	}

	function dateToTextUTC(dt) {
		// default format is: M/d/yyyy
		var dtValid = dateParse(dt);
		if(!!dtValid) {
			return (dtValid.getUTCMonth() + 1).toString() + '/' + dtValid.getUTCDate().toString() + '/' + dtValid.getUTCFullYear().toString();
		}
		else {
			return '';
		}
	}

	function dateToTextWithTime(dt) {
		// default format is: M/d/yyyy
		var dtValid = dateParse(dt);
		if(!!dtValid) {
			var dtTxt = dateToText(dtValid),
				txtHours = dtValid.getHours().toString(),
				txtMins = dtValid.getMinutes().toString(),
				txtSec = dtValid.getSeconds().toString();

			return dtTxt + ' ' +
				(txtHours.length < 2 ? '0' : '') + txtHours + ':' +
				(txtMins.length < 2 ? '0' : '') + txtMins + ':' +
				(txtSec.length < 2 ? '0' : '') + txtSec;
		}
		else {
			return '';
		}
	}

	function dateMonthShortText(dt) {
		if(dateValid(dt)) {
			return ngMonthShortDroplist()[dt.getMonth()].label;
		}
		else {
			return 'invalid';
		}
	}

	function dateMonthFullText(dt) {
		if(dateValid(dt)) {
			return ngMonthFullDroplist()[dt.getMonth()].label;
		}
		else {
			return 'invalid';
		}
	}

	function dateDayFullText(dt) {
		if(dateValid(dt)) {
			switch(dt.getDay()) {
				case 0:
					return 'sunday';
				case 1:
					return 'monday';
				case 2:
					return 'tuesday';
				case 3:
					return 'wednesday';
				case 4:
					return 'thursday';
				case 5:
					return 'friday';
				case 6:
					return 'saturday';
				default:
					throw new Error('utilSvc.dateDayFullText, unknown day of the week: ' + dt.getDay());
			}
		}
		else {
			return 'invalid';
		}
	}

	function numDayShortText(num) {
		switch(num) {
			case 0:
				return 'sun';
			case 1:
				return 'mon';
			case 2:
				return 'tue';
			case 3:
				return 'wed';
			case 4:
				return 'thu';
			case 5:
				return 'fri';
			case 6:
				return 'sat';
			default:
				throw new Error('utilSvc.numDayShortText, unknown day of the week: ' + num);
		}
	}

	function dateModeText(items, dtMode, startDate, endDate) {

		// convert any date control mode and droplist option to text

		switch(dtMode) {
			case 'QTR':
				return displayQuarter(startDate);

			case 'MONTHLY':
				return dateMonthShortText(startDate) + ' ' + startDate.getFullYear().toString();

			case 'MONTHSTART':
				return dateMonthShortText(startDate) + ' 1st - 15th, ' + startDate.getFullYear().toString();

			case 'MONTHEND':
				return dateMonthShortText(startDate) + ' 16th - Month End, ' + startDate.getFullYear().toString();
	
			case 'YEARLY':
				return 'Year: ' + startDate.getFullYear().toString();

			default:
				if(dtMode.indexOf('CUSTOM') > -1) {
					return 'Custom Dates: ' + dateToText(startDate) + ' to ' + dateToText(endDate);
				}
				else {
					for(var i = 0; i < items.length; i++) {
						if(items[i].value == dtMode) {
							return items[i].label;
						}
					}
					return '';
				}
		}

	}

	function displayQuarter(dt) {

		// return Q1, Q2 text from incoming date

		var pdt = dateParse(dt);
		if(pdt == null) {
			return '';
		}

		var qtrNum = Math.floor(pdt.getMonth() / 3) + 1;
		return 'Q' + qtrNum + ' ' + pdt.getFullYear().toString();

	}

	function dateModeKeepDates(dtMode) {

		// determine if specific dates are needed to restore this date mode for elbow grease etc..

		switch(dtMode) {
			case 'TODAY':
			case 'YESTERDAY':
			case 'TODAYYESTERDAY':
			case '2DAYS':
			case '3DAYS':
			case '4DAYS':
			case '7DAYS':
			case '2WEEKS':
			case 'LMTD':
			case 'MTD':
			case 'LQTD':
			case 'QTD':
			case 'QTDLAST':
			case 'YTD':
			case 'LYTD':
			case 'LTM':
			case 'LLTM':
				return false;

			case 'QTR':
			case 'MONTHLY':
			case 'MONTHSTART':
			case 'MONTHEND':
			case 'YEARLY':
				return true;

			default:
				if(dtMode.indexOf('CUSTOM') > -1) {
					return true;
				}
				alert('utilSvc.dateModeKeepDates, unknown date mode: ' + dtMode);
				return false;
		}
	}


	/**
	 *    ARRAY IE SORT FIX
	 */

	function sortIEFIX() {

		// IE sort is phooey, detect a failed descending sort
		var ieSortFix = [1,2];
		ieSortFix.sort(function(a,b) {
			return a < b;
		});

		return ieSortFix[0] === 1;

	}

	function sortTextDescending(items, propName) {
		return sortDescending(items, propName, 'text');
	}

	function sortDescending(items, propName, propType) {

		// params
		if(!Array.isArray(items)) {
			return [];
		}

		// sort by property name
		if(typeof(propName) === 'string' && propName.length > 0) {

			// text sort
			if(propType === 'text') {
				items.sort(function(a,b) {

					// case insensitive
					var aVal = a[propName].toUpperCase(),
						bVal = b[propName].toUpperCase();

					if(aVal > bVal) {
						return -1;
					}
					if(aVal < bVal) {
						return 1;
					}
					return 0;
				});
			}
			else {
				items.sort(function(a,b) {
					var aVal = a[propName],
						bVal = b[propName];

					if(aVal > bVal) {
						return -1;
					}
					if(aVal < bVal) {
						return 1;
					}
					return 0;
				});
			}
		}
		else {
			// value sort
			if(propType === 'text') {
				items.sort(function(a,b) {

					// case insensitive
					var aVal = a.toUpperCase(),
						bVal = b.toUpperCase();

					if(aVal > bVal) {
						return -1;
					}
					if(aVal < bVal) {
						return 1;
					}
					return 0;
				});
			}
			else {
				items.sort(function(a,b) {
					if(a > b) {
						return -1;
					}
					if(a < b) {
						return 1;
					}
					return 0;
				});
			}
		}

		return items;

	}

	function sortTextAscending(items, propName) {
		return sortAscending(items, propName, 'text');
	}

	function sortAscending(items, propName, propType) {

		// params
		if(!Array.isArray(items)) {
			return [];
		}

		// object sort by property
		if(typeof(propName) === 'string' && propName.length > 0) {

			// text sort
			if(propType === 'text') {
				items.sort(function(a,b) {

					// case insensitive
					var aVal = a[propName].toUpperCase(),
						bVal = b[propName].toUpperCase();

					if(aVal < bVal) {
						return -1;
					}
					if(aVal > bVal) {
						return 1;
					}
					return 0;
				});
			}
			else {
				items.sort(function(a,b) {
					var aVal = a[propName],
						bVal = b[propName];

					if(aVal < bVal) {
						return -1;
					}
					if(aVal > bVal) {
						return 1;
					}
					return 0;
				});
			}
		}
		else {
			// value sort
			if(propType === 'text') {
				items.sort(function(a,b) {

					// case insensitive
					var aVal = a.toUpperCase(),
						bVal = b.toUpperCase();

					if(aVal < bVal) {
						return -1;
					}
					if(aVal > bVal) {
						return 1;
					}
					return 0;
				});
			}
			else {
				items.sort(function(a,b) {
					if(a < b) {
						return -1;
					}
					if(a > b) {
						return 1;
					}
					return 0;
				});
			}
		}

		return items;

	}


	/**
	 *    NG ANGULAR HELPERS
	 *    create angular friendly data structures to render in html
	 */

	function ngDroplist(items, lblProp, valProp, addTopItems, addBottomItems) {

		// build a drop down list of items, optionally add top and bottom items

		var droplist = [],
			i = 0;

		// optional top items
		if(Array.isArray(addTopItems)) {
			for(var itop = 0; itop < addTopItems.length; itop++) {
				droplist.push({
					label: addTopItems[itop].label,
					value: addTopItems[itop].value
				});
			}
		}

		// label/value dropdown items
		if(Array.isArray(items)) {

			// 1 time check for label/value prop names
			lblProp = isText(lblProp) ? lblProp : '';
			valProp = isText(valProp) ? valProp : '';

			if(!!!lblProp && !!!valProp) {

				// no label prop, no value prop
				for(i = 0; i < items.length; i++) {
					var lbl = items[i];
					if (lbl == 'PSG'){
						lbl = 'OMNICELL';
					} else if (lbl == 'MORRISDICKSON'){
						lbl = 'CERVEY';
					}else if (lbl == '340BASICS'){
						lbl = 'NUVEM';
					}else if (lbl == 'SENTRY'){
						lbl = 'CRANEWARE';
					}
					var val = items[i];
					droplist.push({
						label: lbl,
						value: val
					});
				}
			}
			else if(!!lblProp && !!valProp) {

				// has label prop, has value prop
				for(i = 0; i < items.length; i++) {
					droplist.push({
						label: items[i][lblProp],
						value: items[i][valProp]
					});
				}
			}
			else if(!!lblProp && !!!valProp) {

				// has label prop, no value prop
				for(i = 0; i < items.length; i++) {
					droplist.push({
						label: items[i][lblProp],
						value: items[i]
					});
				}
			}
			else if(!!!lblProp && !!valProp) {

				// no label prop, has value prop
				for(i = 0; i < items.length; i++) {
					droplist.push({
						label: items[i],
						value: items[i][valProp]
					});
				}
			}
		}

		// optional bottom items
		if(Array.isArray(addBottomItems)) {
			for(var ibot = 0; ibot < addBottomItems.length; ibot++) {
				droplist.push({
					label: addBottomItems[ibot].label,
					value: addBottomItems[ibot].value
				});
			}
		}
		droplist = droplist.sort(function(a,b){
		if (a.value == 'NONE') {
			return -1;
		} else if (b.value == 'NONE'){
			return 1;
		} else if (a.label < b.label){
            return -1;
        } else if (a.label > b.label){
            return 1;
        } else{
            return 0;
        }
        });
		return droplist;

	}

	function ngDroplistAutoselect(droplist, nickname, noTitleItem) {

		// automatically choose a droplist item, return it as a new Property

		var minLen = !!noTitleItem ? 1 : 2,
			newProp = {
				val: 'NONE',
				fail: false,
				msg: ''
			};

		// only 1 option in the droplist, select it
		// note: first item is always the 'NONE' value
		if(droplist.length === minLen) {
			newProp.val = droplist[1].value;
		}
		else if(isText(nickname) && nickname != 'NONE') {

			for(var i = 0; i < droplist.length; i++) {
				if(droplist[i].value == nickname) {
					newProp.val = nickname;
					break;
				}
			}

		}

		// no auto select available, reset to NONE
		return newProp;

	}

	function ngDroplistAutoselectYesNo(droplist, nickname, noTitleItem) {

		// automatically choose a droplist item, fully validate fail as yes or no

		var minLen = !!noTitleItem ? 1 : 2,
			newProp = {
				val: 'NONE',
				fail: 'yes',
				msg: ''
			};

		// only 1 option in the droplist, select it
		// note: first item is always the 'NONE' value
		if(droplist.length === minLen) {
			newProp.val = droplist[1].value;
			newProp.fail = 'no';
		}
		else if(isText(nickname) && nickname != 'NONE') {

			for(var i = 0; i < droplist.length; i++) {
				if(droplist[i].value == nickname) {
					newProp.val = nickname;
					newProp.fail = 'no';
					break;
				}
			}
		}

		return newProp;
	}

	function ngDroplistLabel(droplist, dropVal) {

		// find droplist item by val, return its label text

		// params
		if(!Array.isArray(droplist) || droplist.length < 1) {
			return '';
		}

		for(var i = 0; i < droplist.length; i++) {
			if(droplist[i].value === dropVal) {
				return droplist[i].label;
			}
		}

		return '';
	}

	function ngDroplistNONE() {
		return [{label:'', value:'NONE'}];
	}

	function ngDroplistALL() {
		return [{label:'', value:'ALL'}];
	}


	/**
	 *    SORT BY
	 *    sorting fields have a property name
	 *    note: for descending order, in angualr the field name has a leading '-'
	 */

	function sortName(sortField) {

		// invalid string
		if(!isText(sortField)) {
			return '';
		}
		sortField = sortField.trim();

		// desc
		if(sortField.substr(0,1) == '-') {

			// invalid desc string
			if(sortField.length < 2) {
				return '';
			}
			else {
				return sortField.substr(1);
			}
		}

		// asc
		return sortField;

	}

	function sortOrder(sortField) {

		// determines if a field is sorting by ASC, DSC or is invalid (null)

		var fieldName = sortName(sortField);

		// invalid
		if(!isText(fieldName)) {
			return '';
		}

		// descending
		if(sortField.substr(0,1) == '-') {
			return 'DSC';
		}

		// ascending
		return 'ASC';

	}


	/**
	 *    ADD SORTING
	 *    used by controllers to add list sorting support
	 */

	function addSorting(vm) {
		vm.sortBy = sortBy;
		vm.sortByIcon = sortByIcon;
		vm.sortByViewStyle = sortByViewStyle;
		vm.sortByApiStyle = sortByApiStyle;
	}

	function sortByViewStyle(sortByApiVM) {

		// convert from api sort by into view sort by format

		if(!!sortByApiVM && isText(sortByApiVM.Field) && isText(sortByApiVM.Order)) {
			return sortByApiVM.Order == 'DSC' ? '-' : '' + sortByApiVM.Field;
		}
		else {
			return '';
		}

	}

	function sortByApiStyle(sortByString) {

		// convert from view sort by into api sort by format

		return {
			Field: sortName(sortByString),
			Order: sortOrder(sortByString)
		};

	}

	function sortBy(fieldName, display) {

		// toggle sorting for a ui column
		// if not sorting by this column already, sort ascending by default

		// valid field name
		if(!isText(fieldName)) {
			return;
		}
		var asc = fieldName,
			dsc = '-' + fieldName;

		// get current sort
		var currentSort = '';
		if(Array.isArray(display.SortBy) && display.SortBy.length > 0) {
			currentSort = display.SortBy[0];
		}

		if(currentSort === asc) {
			display.SortBy = [dsc];
		}
		else if(currentSort === dsc) {
			display.SortBy = [asc];
		}
		else {
			// no toggle, just set to asc on first click
			display.SortBy = [asc];
		}
		
		// reset paging to 1 on all column sorts
		//display.Paging.Page = 1;
		
	}

	function sortByIcon(fieldName, SortBy, useBlank) {

		// returns the CSS icon class for the sort state of this field, values can be:
		// 'icon-asc', 'icon-dsc' or '' = not found

		// valid field name
		if(!isText(fieldName) || !Array.isArray(SortBy) || SortBy.length < 1) {
			return '';
		}

		// ascending
		if(SortBy[0] == fieldName) {
			return 'icon-asc';
		}

		// descending
		if(SortBy[0] == '-' + fieldName) {
			return 'icon-dsc';
		}

		// not found
		return !!useBlank ? 'icon-blank' : '';
	}


	/**
	 *    ADD PAGING
	 *    used by controllers to add paging functionality
	 */

	function addPaging(vm) {
		vm.pagingAdvance = pagingAdvance;
		vm.pagingTo = pagingTo;
		vm.pagingPages = pagingPages;
		vm.rowCount = rowCount;
		vm.getTotalPages = getTotalPages;
	}

	function getTotalPages(rows, pageSize) {

		// return ui paging VM with re-calcuated total pages

		if(isNaN(pageSize) || pageSize < 1 || isNaN(rows)) {
			throw 'util.pagingCalculate, pageSize must be > 0 and rows must be a number';
		}

		// calculate total pages
		var total = 1;

		if(rows > pageSize) {
			total = Math.floor(rows / pageSize);
			if(rows % pageSize > 0) {
				total += 1;
			}
		}

		return total;

	}

	function pagingAdvance(move, Paging) {

		// paging move must a number
		if(isNaN(move)) {
			throw 'util.pagingAdvance, move must be a number';
		}

		var newPage = Paging.Page + move;

		// out of range
		if(newPage < 1 || newPage > Paging.Total) {
			return;
		}

		// move is ok
		Paging.Page = newPage;

	}

	function pagingTo(pageNum, Paging) {

		// page num must a number
		if(isNaN(pageNum)) {
			throw 'util.pagingAdvance, move must be a number';
		}

		// same page or out of range
		if(pageNum == Paging.Page || pageNum < 1 || pageNum > Paging.Total) {
			return;
		}

		// new page is ok
		Paging.Page = pageNum;

	}

	function pagingPages(pages) {

		// returns an array for ng-repeat to iterate over

		var items = [];

		if(isNaN(pages) || pages - 1 < 0) {
			return items;
		}

		// create array of pages
		items = new Array(pages);
		for(ipage = 1; ipage < pages; ipage++) {
			items[ipage - 1] = ipage.toString();
		}

		return items;

	}

	function rowCount(pageSize, itemLen) {

		// return the view rows based on item count or page size
		// note: return 0 if both are not available

		if(isNaN(pageSize) && isNaN(itemLen)) {
			return 0;
		}

		if(isNaN(pageSize) || pageSize == itemLen) {
			return itemLen;
		}

		if(isNaN(itemLen)) {
			return pageSize;
		}

		if(itemLen < pageSize) {
			return itemLen;
		}

		return pageSize;

	}


	/**
	 *    ADD FILTERING
	 *    add methods for advanced filters
	 */

	function addFiltering(vm) {
		vm.initFilters = initFilters;
		vm.resetFilters = resetFilters;
		vm.filterList = filterList;
	}

	function initFilters(setup) {

		var result = {
			Ready: false,
			Busy: false,
			Dirty: false,
			Dates: {},
			Numbers: {},
			Text: {},
			Exact: {},
			Count: 0,
			Config: {},
			SortBy: [],
			Page: 1,
			PageSize: 50,
			PageTotal: 1
		};

		// setup props defined
		if(!!setup) {
			for (var propName in setup) {
				if (setup.hasOwnProperty(propName)) {
					result[propName] = setup[propName];
				}
			}
		}

		return result;

	}

	function resetFilters(flt, keepPaging) {
		flt.Ready = false;
		flt.Dirty = false;
		flt.Busy = false;

		if(!!!keepPaging) {
			flt.Page = 1;
			flt.PageTotal = 1;
		}

		return flt;
	}

	function filterList(dataItems, flt, doNotPage) {

		// filter dataItems using incoming filter object
		// note: 	this function has no concept of waiting or debouncing, it will run every time its called immediately
		// 			this is called on init or tab load, see filterChange() for UI debouncing/blocking/isBusy functionality

		flt = flt || {Text:{}};

		// params
		if(!Array.isArray(dataItems)) {
			flt.PageTotal = 1;
			flt.Page = 1;
			flt.Count = 0;
			return [];
		}

		// filter .Text
		var fTxt = flt.Text;
		for (var txtProp in fTxt) {
			if (fTxt.hasOwnProperty(txtProp) && fTxt[txtProp] === '') {
				fTxt[txtProp] = undefined; // zero out blank strings (ngFilter bug)
			}
		}
		var newItems = $filter('filter')(dataItems, flt.Text);

		// filter .Exact
		if(newItems.length > 0) {
			if(!!flt.Exact) {
				var ex = flt.Exact,
					fltObj = {};
				for (var propName in ex) {
					if (ex.hasOwnProperty(propName) && isText(ex[propName])) {

						// using "defineProperty" function to create the search property as an identifier:  obj.propName
						// note: angular filter won't find dynamically added string properties: obj['propName']
						fltObj = {};
						Object.defineProperty(fltObj, propName, {
							value: ex[propName].toString(),
							writable: true,
							enumerable:true,
							configurable: true
						});

						newItems = $filter('filter')(newItems, fltObj, true);
						if(newItems.length < 1) {
							break;
						}
					}
				}
			}
		}

		// filter .Numbers
		var nmName = '';
		var nmVal = 0.0;
		var nmOp = '';
		var nmComparator = function(item) {
			switch(nmOp) {
				case '>':
					return parseFloat(item[nmName]) > nmVal;
				case '<':
					return parseFloat(item[nmName]) < nmVal;
			}
		};

		if(newItems.length > 0) {
			if(!!flt.Numbers) {
				var nums = flt.Numbers,
					fltNum = {},
					numTxt = '',
					simpleFlt = true;

				for (var numPropName in nums) {
					if (nums.hasOwnProperty(numPropName) && isText(nums[numPropName])) {
						numTxt = nums[numPropName].toString();
						simpleFlt = true;

						// has operators
						nmOp = numTxt[0];
						if(nmOp == '>' || nmOp == '<') {

							// nothing yet, don't filter
							if(numTxt.length < 2) {
								continue;
							}

							nmVal = parseFloat(numTxt.substr(1, numTxt.length));
							if(isNumber(nmVal)) {
								simpleFlt = false;
								nmName = numPropName;
								newItems = $filter('filter')(newItems, nmComparator);
							}
						}

						// use simple filter?
						if(simpleFlt) {
							// no operators, use simple filter
							var numFltObj = {};
							Object.defineProperty(numFltObj, numPropName, {
								value: numTxt,
								writable: true,
								enumerable:true,
								configurable: true
							});
							newItems = $filter('filter')(newItems, numFltObj);
						}

						if(newItems.length < 1) {
							break;
						}
					}
				}
			}
		}

		// filter .Dates
		if(newItems.length > 0 && !!flt.Config && Array.isArray(flt.Config.Dates) && flt.Config.Dates.length > 0) {
			newItems = $filter('filterDatesAsText')(newItems, flt.Dates, flt.Config.Dates, flt.Config.DateFmt);
		}

		// sort order
		if(newItems.length > 0) {
			newItems = $filter('orderBy')(newItems, flt.SortBy);
		}
		var filterCount = newItems.length;

		// no paging
		if(!!doNotPage) {
			return newItems;
		}

		// paging
		flt.PageTotal = getTotalPages(newItems.length, flt.PageSize);
		if(isNumber(flt.Page) && flt.Page > 1) {

			// adjust page number on max after filtering
			if(flt.Page > flt.PageTotal) {
				flt.Page = flt.PageTotal;
			}

			// calculate page starting index
			var pageStart = ((flt.Page - 1) * flt.PageSize);
			if(pageStart < 0 || pageStart + 1 > newItems.length) {
				flt.Page = 1;
				pageStart = 0;
			}

			// cut out this page
			newItems = newItems.slice(pageStart, pageStart + flt.PageSize);

		}
		else {
			// reset paging
			flt.Page = 1;

			// show first page of rows
			if(newItems.length > 0 && newItems.length > flt.PageSize) {
				newItems = newItems.slice(0, flt.PageSize);
			}
		}

		// done filtering
		flt.Count = filterCount;

		return newItems;

	}


	/**
	 *    API RESULTS PAGING
	 *    converts api response into ui paging values
	 */

	function apiResultsPaging(paging, uiSize, itemNum, apiMax) {

		// server found too many results
		paging.TooMany = itemNum > apiMax;

		// set number of ui pages
		paging.Size = uiSize;
		if(itemNum > uiSize) {
			paging.Total = Math.floor(itemNum / uiSize);
			if(itemNum % uiSize > 0) {
				paging.Total += 1;
			}
		}

		return paging;

	}



	/**
	 *    HTTP SAFE RESPONSE
	 *    safely build an invalid response object which will most likely serialize to JSON
	 *    used to throw in error messages
	 */

	function httpSafeResponse(r) {

		// response fix
		if(!!!r) {
			return "undefined";
		}

		// status fix
		if(isNaN(r.status) || r.status < 0) {
			r.status = 'undefined';
		}

		// entity fix
		if(!!!r.Entity) {
			r.Entity = 'undefined';
		}
		else if(!Array.isArray(r.Entity)) {
			r.Entity = 'not an array';
		}
		else if(r.Entity.length > 10) {
			r.Entity = r.Entity.slice(0,9); // remove excess items from Entity array
		}

		// paging fix
		if(!!!r.Paging) {
			r.Paging = 'undefined';
		}
		else if(!!!r.Paging) {
			r.Paging.Size = 'undefined';
		}
		else if(isNaN(r.Paging.Size)) {
			r.Paging.Size = 'NaN';
		}

		// attempt to serialize
		var safeResp = '';
		try {
			safeResp = angular.toJson(r);
		}
		catch(err) {
			safeResp = 'cannot serialize response object: ' + err.message;
		}

		return safeResp;

	}


	/**
	 *    ADDRESS: STATES
	 *    used for ng-option dropdown lists
	 */

	function ngStateFullNamesDroplist() {

		return [
			{value:'AL', label:'Alabama'},
			{value:'AK', label:'Alaska'},
			{value:'AZ', label:'Arizona'},
			{value:'AR', label:'Arkansas'},
			{value:'CA', label:'California'},
			{value:'CO', label:'Colorado'},
			{value:'CT', label:'Connecticut'},
			{value:'DE', label:'Delaware'},
			{value:'DC', label:'District Of Columbia'},
			{value:'FL', label:'Florida'},
			{value:'GA', label:'Georgia'},
			{value:'HI', label:'Hawaii'},
			{value:'ID', label:'Idaho'},
			{value:'IL', label:'Illinois'},
			{value:'IN', label:'Indiana'},
			{value:'IA', label:'Iowa'},
			{value:'KS', label:'Kansas'},
			{value:'KY', label:'Kentucky'},
			{value:'LA', label:'Louisiana'},
			{value:'ME', label:'Maine'},
			{value:'MD', label:'Maryland'},
			{value:'MA', label:'Massachusetts'},
			{value:'MI', label:'Michigan'},
			{value:'MN', label:'Minnesota'},
			{value:'MS', label:'Mississippi'},
			{value:'MO', label:'Missouri'},
			{value:'MT', label:'Montana'},
			{value:'NE', label:'Nebraska'},
			{value:'NV', label:'Nevada'},
			{value:'NH', label:'New Hampshire'},
			{value:'NJ', label:'New Jersey'},
			{value:'NM', label:'New Mexico'},
			{value:'NY', label:'New York'},
			{value:'NC', label:'North Carolina'},
			{value:'ND', label:'North Dakota'},
			{value:'OH', label:'Ohio'},
			{value:'OK', label:'Oklahoma'},
			{value:'OR', label:'Oregon'},
			{value:'PA', label:'Pennsylvania'},
			{value:'RI', label:'Rhode Island'},
			{value:'SC', label:'South Carolina'},
			{value:'SD', label:'South Dakota'},
			{value:'TN', label:'Tennessee'},
			{value:'TX', label:'Texas'},
			{value:'UT', label:'Utah'},
			{value:'VT', label:'Vermont'},
			{value:'VA', label:'Virginia'},
			{value:'WA', label:'Washington'},
			{value:'WV', label:'West Virginia'},
			{value:'WI', label:'Wisconsin'},
			{value:'WY', label:'Wyoming'},
			{value:'AS', label:'American Samoa'},
			{value:'GU', label:'Guam'},
			{value:'MP', label:'Northern Mariana Islands'},
			{value:'PR', label:'Puerto Rico'},
			{value:'VI', label:'Virgin Islands'},
			{value:'TT', label:'Trust Territories'},
		];

	}

	function ngStateShortNamesDroplist() {

		return [
			{value:'AL', label:'AL'},
			{value:'AK', label:'AK'},
			{value:'AZ', label:'AZ'},
			{value:'AR', label:'AR'},
			{value:'CA', label:'CA'},
			{value:'CO', label:'CO'},
			{value:'CT', label:'CT'},
			{value:'DE', label:'DE'},
			{value:'DC', label:'DC'},
			{value:'FL', label:'FL'},
			{value:'GA', label:'GA'},
			{value:'HI', label:'HI'},
			{value:'ID', label:'ID'},
			{value:'IL', label:'IL'},
			{value:'IN', label:'IN'},
			{value:'IA', label:'IA'},
			{value:'KS', label:'KS'},
			{value:'KY', label:'KY'},
			{value:'LA', label:'LA'},
			{value:'ME', label:'ME'},
			{value:'MD', label:'MD'},
			{value:'MA', label:'MA'},
			{value:'MI', label:'MI'},
			{value:'MN', label:'MN'},
			{value:'MS', label:'MS'},
			{value:'MO', label:'MO'},
			{value:'MT', label:'MT'},
			{value:'NE', label:'NE'},
			{value:'NV', label:'NV'},
			{value:'NH', label:'NH'},
			{value:'NJ', label:'NJ'},
			{value:'NM', label:'NM'},
			{value:'NY', label:'NY'},
			{value:'NC', label:'NC'},
			{value:'ND', label:'ND'},
			{value:'OH', label:'OH'},
			{value:'OK', label:'OK'},
			{value:'OR', label:'OR'},
			{value:'PA', label:'PA'},
			{value:'RI', label:'RI'},
			{value:'SC', label:'SC'},
			{value:'SD', label:'SD'},
			{value:'TN', label:'TN'},
			{value:'TX', label:'TX'},
			{value:'UT', label:'UT'},
			{value:'VT', label:'VT'},
			{value:'VA', label:'VA'},
			{value:'WA', label:'WA'},
			{value:'WV', label:'WV'},
			{value:'WI', label:'WI'},
			{value:'WY', label:'WY'},
			{value:'AS', label:'AS'},
			{value:'GU', label:'GU'},
			{value:'MP', label:'MP'},
			{value:'PR', label:'PR'},
			{value:'VI', label:'VI'},
			{value:'TT', label:'TT'},
		];

	}


	/**
	 *    MONTH NAMES
	 */

	function ngMonthShortDroplist() {
		return [
			{value: 1, label:'Jan'},
			{value: 2, label:'Feb'},
			{value: 3, label:'Mar'},
			{value: 4, label:'Apr'},
			{value: 5, label:'May'},
			{value: 6, label:'Jun'},
			{value: 7, label:'Jul'},
			{value: 8, label:'Aug'},
			{value: 9, label:'Sep'},
			{value: 10, label:'Oct'},
			{value: 11, label:'Nov'},
			{value: 12, label:'Dec'}
		];
	}

	function ngMonthFullDroplist() {
		return [
			{value: 1, label:'January'},
			{value: 2, label:'February'},
			{value: 3, label:'March'},
			{value: 4, label:'April'},
			{value: 5, label:'May'},
			{value: 6, label:'June'},
			{value: 7, label:'July'},
			{value: 8, label:'August'},
			{value: 9, label:'September'},
			{value: 10, label:'October'},
			{value: 11, label:'November'},
			{value: 12, label:'December'}
		];
	}


	/**
	 *    VENDORS HARDCODED
	 *

	function vendorIdNameDroplist() {
		return [
			{value:"ABCSAFECOR", label: "Amerisource Safecor"},
			{value:"AMERISOURCE", label: "Amerisource Bergen"},
			{value:"CARDINAL", label: "Cardinal"},
			{value:"CARDINALSAFECOR", label: "Cardinal Safecor"},
			{value:"DAKOTADRUG", label: "Dakota Drug"},
			{value:"FFF", label: "FFF Enterprises"},
			{value:"HDSMITH", label: "HD Smith"},
			{value:"MCKESSON", label: "McKesson"},
			{value:"MCKESSONSAFECOR", label: "McKesson Safecor"},
			{value:"MORRISDICKSON", label: "Morris & Dickson"},
			{value:"MPB", label: "McKesson Plasma and Biologics"},
			{value:"NCMUTUAL", label: "NC Mutual"},
			{value:"ROCHESTER", label: "Rochester"},
			{value:"SMITH", label: "Smith Drugs"},
			{value:"VALUE", label: "Value Drug"}
		];
	}

	function vendorIdDroplist() {

		return [
			{value:"ABCSAFECOR", label: "ABCSAFECOR"},
			{value:"AMERISOURCE", label: "AMERISOURCE"},
			{value:"CARDINAL", label: "CARDINAL"},
			{value:"CARDINALSAFECOR", label: "CARDINALSAFECOR"},
			{value:"DAKOTADRUG", label: "DAKOTADRUG"},
			{value:"FFF", label: "FFF"},
			{value:"HDSMITH", label: "HDSMITH"},
			{value:"MCKESSON", label: "MCKESSON"},
			{value:"MCKESSONSAFECOR", label: "MCKESSONSAFECOR"},
			{value:"MORRISDICKSON", label: "MORRISDICKSON"},
			{value:"MPB", label: "MPB"},
			{value:"NCMUTUAL", label: "NCMUTUAL"},
			{value:"NONEDI", label: "NONEDI"},
			{value:"ROCHESTER", label: "ROCHESTER"},
			{value:"SMITH", label: "SMITH"},
			{value:"VALUE", label: "VALUE"}
		];

	}
	*/


	/**
	 *    CSS
	 */

	function cssButtonStyle(btnName) {

		// convert a button name into CSS style class

		switch(btnName) {

			case 'ONBOARDING':
				return 'btn-alt';

			case 'ACTIVE':
				return 'btn-alt';

			case 'INACTIVE':
				return 'btn-cancel';

			case 'CANCEL':
				return 'btn-cancel';

			case 'DELETE':
				return 'btn-delete';

			default:
				return '';

		}
	}

	function cssValidStyle(dirty, valid, fail) {

		// multiple validation status into 1 CSS icon

		if(!!valid && !!!fail) {
			// html rules valid and no server fail
			return 'icon-valid';
		}
		else if(!!dirty && !!!valid) {
			// user changed value and html rules invalid
			return 'icon-invalid';
		}
		else {
			return 'icon-width-0'; // any other case
		}

	}


	/**
	 *  JSON
	 *  uses angular json methods with error handling if 'safe' flag is true
	 */

	function jsonStringify(obj, safe) {

		// allows safe handling of possibly corrupt json objects
		// note: if safe flag is true, will always return a valid json string

		if(!!!safe) {
			return angular.toJson(obj);
		}
		else {
			try {
				return angular.toJson(obj);
			}
			catch(err) {
				return '{}';
			}
		}
	}

	function jsonStringifyPretty(obj, safe, indent) {

		// allows safe handling of possibly corrupt json objects
		// note: if safe flag is true, will always return a valid json string

		indent = isNaN(indent) ? 0 : indent;

		if(!!!safe) {
			return angular.toJson(obj, indent);
		}
		else {
			try {
				return angular.toJson(obj);
			}
			catch(err) {
				return '{}';
			}
		}
	}

	function jsonParse(txt, safe) {

		// allows safe handling of possibly corrupt json objects
		// note: if safe flag is true, will always return a valid json object

		if(!!!safe) {
			return angular.fromJson(txt);
		}
		else {
			try {
				return angular.fromJson(txt);
			}
			catch(err) {
				return {};
			}
		}
	}


	/**
	 *    REGEX
	 */

	function regexLogin() {
		// at least 1 number, 1 lower case, 1 upper case, length 6-12 characters
		return new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,12}$/);
	}

	function regexPwd() {
			// \W at least one symbol
			// [0-9] least one number
			// !\s no spaces
			// A-Z at least one upper
			// a-z at least one lower
		return new RegExp(/^(?=.*\W)(?=.*[0-9])(?!.*\s)(?=.*[A-Z])(?=.*[a-z]).*$/);
	}

	function regexDateFmt(twoDigitYear) {
		if(!!twoDigitYear) {
			// MM/dd/yyyy or M/d/yyyy or two digit year "yy"
			return new RegExp(/^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/\d{2,4}$/);
		}
		else {
			// MM/dd/yyyy or M/d/yyyy
			return new RegExp(/^(0?[1-9]|1[0-2])\/(0?[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/);
		}
	}

	function regexApiDateStringFmt() {
		// yyyy-MM-dd
		return new RegExp(/^(19|20)\d{2}\-(0?[1-9]|1[0-2])\-(0?[1-9]|1\d|2\d|3[01])$/);
	}

	function regexApiDateTimeStringFmt() {
		// yyyy-MM-dd-hh-mm-ss
		return new RegExp(/^(19|20)\d{2}\-(0?[1-9]|1[0-2])\-(0?[1-9]|1\d|2\d|3[01])\-(0?[0-9]|1[0-9]|2[0-3])\-(0?[0-9]|[0-5][0-9])\-(0?[0-9]|[0-5][0-9])$/);
	}

	function regexFilename(nm) {

		// strip all non-file path characters

		var cleanName = toText(nm);

		if(cleanName.length > 0) {
			cleanName = cleanName.replace(/[^A-Za-z0-9_\.\-]+/g,'');

			if(cleanName.length > 250) {
				cleanName = cleanName.slice(-250); // cut from right to keep file extension
			}
		}

		return cleanName;

	}

	function regexAlpha(txt) {

		// strip all non-file path characters

		var result = toText(txt);

		if(result.length > 0) {
			result = result.replace(/[^A-Za-z]+/g,'');
		}

		return result;

	}

	function regexDateISO(txt) {

		// matches the JSON ISO date string without evaluating the time values
		// example 0001-01-01T00:00:00Z

		return new RegExp(/^\d{4}-\d{2}-\d{2}T(.*)[Z]$/);
	}


	/**
	 *    OBJECT
	 */

	function objFindChildProp(obj, path) {

		/* recurse into object properties to get last property value in the path
		// example: use path = "child1.child2" to return the value of child2
		obj: {
			child1: {
				child2: value
			}
		}
		*/

		// path is valid?
		path = toText(path);
		if(!!!path) {
			return undefined;
		}

		// break path into an array of property names
		var props = path.split('.');

		// recurse to last child property
		var propVal = obj;
		for(var i = 0; i < props.length; i++) {
			if(!!propVal.hasOwnProperty(props[i])) {
				propVal = propVal[props[i]];
			}
			else {
				return undefined;
			}
		}

		// return last property value
		return propVal;

	}


	/**
	 *    AFFILIATES
	 *    methods to query the affiliation matrix of all CE/RX/VEN combinations
	 */

	function affFindStatus(items, status) {

		var result = [];
		status = Array.isArray(status) ? status : ['ONBOARDING', 'ACTIVE', 'INACTIVE'];

		for(var i = 0; i < items.length; i++) {
			if(status.indexOf(items[i].AffState) > -1) {
				result.push(items[i]);
			}
		}

		return result;

	}

	function affFindStatusOfCE(items, ceid) {

		var result = 'INACTIVE';

		for(var i = 0; i < items.length; i++) {
			if (items[i].CEID == ceid) {
				return items[i].CEStatus;
			}
		}

		return result;

	}

	function affFindCe(items, ceid) {

		var result = [];

		for(var i = 0; i < items.length; i++) {
			if(items[i].CEID == ceid) {
				result.push(items[i]);
			}
		}

		return result;

	}

	function affFindCeList(items, ceids) {

		var result = [];

		if(!Array.isArray(ceids) || ceids.length < 1) {
			return result;
		}

		for(var i = 0; i < items.length; i++) {
			if(isText(items[i].CEID) && ceids.indexOf(items[i].CEID) > -1) {
				result.push(items[i]);
			}
		}

		return result;

	}

	function affFindCeCanCreateCpList(items) {
		var result = [];

		for(var i = 0; i < items.length; i++) {
			if(items[i].RxBizModel != 'CP' || !!items[i].CeCanCreateCPOrder) {
				result.push(items[i]);
			}
		}
		return result;
	}

	function affFindRx(items, rxid) {

		var result = [];

		for(var i = 0; i < items.length; i++) {
			if(items[i].RXID == rxid) {
				result.push(items[i]);
			}
		}

		return result;

	}

	function affFindRxList(items, rxids) {

		var result = [];

		if(!Array.isArray(rxids) || rxids.length < 1) {
			return result;
		}

		for(var i = 0; i < items.length; i++) {
			if(isText(items[i].RXID) && rxids.indexOf(items[i].RXID) > -1) {
				result.push(items[i]);
			}
		}

		return result;

	}

	function affFindRxParent(items, rxParentId) {
		var result = [];

		if(!isText(rxParentId)) {
			return result;
		}

		for(var i = 0; i < items.length; i++) {
			if(items[i].RxParent == rxParentId) {
				result.push(items[i]);
			}
		}

		return result;
	}

	function affFindTpa(items, tpaid) {

		var result = [];

		for(var i = 0; i < items.length; i++) {
			if(items[i].ProgAdmin == tpaid) {
				result.push(items[i]);
			}
		}

		return result;

	}

	function rxShortNameById(items, rxid) {

		if(!isText(rxid)) {
			return '';
		}

		if(rxid == 'ALL') {
			return 'ALL';
		}

		for(var i = 0; i < items.length; i++) {
			if(items[i].RXID == rxid) {
				return !!items[i].RxShortName ? items[i].RxShortName : '';
			}
		}

		return '';

	}

	function ceNameByIdLookup(ceid) {

		if(!isText(ceid)) {
			return '';
		}

		if(ceid == 'ALL') {
			return 'ALL';
		}

		// if CE lookup doesn't exist then return CEID
		if(!!!$rootScope || !!!$rootScope.User || !!!$rootScope.User.AffCeLookup) {
			return ceid;
		}

		var ceLookup = $rootScope.User.AffCeLookup[ceid];
		if(!!!ceLookup) {
			return ceid;
		}
		
		// found ce lookup object, return property
		return ceLookup.CeDisplayName;
	}

	function rxShortNameByIdLookup(rxid) {

		if(!isText(rxid)) {
			return '';
		}

		if(rxid == 'ALL') {
			return 'ALL';
		}

		// use afflist to find RxShortName
		if(!!!$rootScope || !!!$rootScope.User || !Array.isArray($rootScope.User.AffList) || $rootScope.User.AffList.length < 1) {
			return rxid;
		}

		var rxShortName = rxShortNameById($rootScope.User.AffList, rxid);
		if(!isText(rxShortName)) {
			return rxid;
		}

		return rxShortName;

		// tbd... need to implement RX lookup similar to CE lookup
		// var rxLookup = $rootScope.User.AffRxLookup[rxid];
		// if(!!!rxLookup) {
		// 	return rxid;
		// }

		// if(!!!rxLookup.RxDisplayName) {
		// 	return rxid;
		// }
		
		// // found rx lookup object, return property
		// return rxLookup.RxDisplayName;
	}

	function affFindRxType(items, rxtype) {

		var result = [];
		rxtype = Array.isArray(rxtype) ? rxtype : ['DISPENSING', 'CENTRALFILL', 'ROLLUP'];

		for(var i = 0; i < items.length; i++) {
			if(rxtype.indexOf(items[i].RxType) > -1) {
				result.push(items[i]);
			}
		}

		return result;

	}

	function affFindRxModel(items, rxmodels) {

		var result = [];

		if(!Array.isArray(rxmodels) || rxmodels.length < 1) {
			return [];
		}

		for(var i = 0; i < items.length; i++) {
			if(rxmodels.indexOf(items[i].RxBizModel) > -1) {
				result.push(items[i]);
			}
		}

		return result;

	}

	function affFindRxBilling(items) {
		var result = [];

		for(var i = 0; i < items.length; i++) {
			if(items[i].Billing || items[i].VCentral) {
				result.push(items[i]);
			}
		}
		return result;
	}

	function affFindShareGroup(items, grp) {

		if(!isText(grp)) {
			return [];
		}

		var result = [],
			groups = [],
			ii = 0;

		for(var i = 0; i < items.length; i++) {
			groups = Array.isArray(items[i].AccumAllGroups) ? items[i].AccumAllGroups : [];
			for(ii = 0; ii < groups.length; ii++) {
				if(groups[ii] == grp) {
					result.push(items[i]);
					break;
				}
			}
		}

		return result;
	}

	function affFindVen(items, venid, includeNoEDI) {

		var result = [];

		var acct = null;
		for(var i = 0; i < items.length; i++) {
			for(var ii = 0; ii < items[i].Ordering.length; ii++) {
				if(items[i].Ordering[ii].VENID == venid) {
					if(!!includeNoEDI || !!items[i].Ordering[ii].SupportsEDI) {
						result.push(items[i]);
					}
					break;
				}
			}
		}

		return result;

	}

	function affWithVendor(items, includeNoEDI) {

		var result = [];

		for(var i = 0; i < items.length; i++) {
			if(items[i].Ordering.length > 0) {

				if(!!includeNoEDI) {
					result.push(items[i]);
				}
				else {
					for(var ii = 0; ii < items[i].Ordering.length; ii++) {
						if(!!items[i].Ordering[ii].SupportsEDI) {
							result.push(items[i]);
							break;
						}
					}
				}

			}
		}

		return result;

	}

	function affFindVenType(items, ventype, includeNoEDI) {

		var result = [];
		ventype = Array.isArray(ventype) ? ventype : ['340B'];

		var acct = null;
		for(var i = 0; i < items.length; i++) {
			for(var ii = 0; ii < items[i].Ordering.length; ii++) {
				acct = items[i].Ordering[ii];
				if(ventype.indexOf(acct.Type) > -1) {

					if(!!includeNoEDI || !!acct.SupportsEDI) {
						result.push(items[i]);
						break;
					}
				}
			}
		}

		return result;

	}

	function affFindProgAdmin(items, progAdmin) {

		var result = [];

		for(var i = 0; i < items.length; i++) {
			if(items[i].ProgAdmin == progAdmin) {
				result.push(items[i]);
			}
		}

		return result;

	}

	function affFindVerityAdmin(items) {

		var result = [];

		for(var i = 0; i < items.length; i++) {
			if(isText(items[i].ProgAdmin)) {
				continue;
			}
			result.push(items[i]);
		}

		return result;

	}

	function affRxList(items) {

		var result = [];

		for(var i = 0; i < items.length; i++) {
			if(isText(items[i].RXID) && result.indexOf(items[i].RXID) < 0) {
				result.push(items[i].RXID);
			}
		}

		// sort alpha asc
		result.sort();

		return result;

	}

	function rxParentList(items) {

		var result = [];

		for(var i = 0; i < items.length; i++) {
			if(isText(items[i].RXID) && isText(items[i].RxParent) && result.indexOf(items[i].RxParent) < 0) {
				result.push(items[i].RxParent);
			}
		}

		// sort alpha asc
		result.sort();

		return result;
	}

	function affRxDroplist(items, ceid, useNONE, useALL) {
		// get unique list of pharmacies, return them in droplist format

		var uniqueList = [],
			shortName = '',
			result = [],
			hasCE = isText(ceid);

		// create a sorted list of unique rx short names in dropdown format
		for(var i = 0; i < items.length; i++) {
			if(!hasCE || (hasCE && items[i].CEID == ceid)) {
				shortName = items[i].RxShortName;
				if(isText(shortName) && uniqueList.indexOf(shortName) < 0) {
					uniqueList.push(shortName);
					result.push({"label":shortName,"value":items[i].RXID});
				}
			}
		}
		result = sortTextAscending(result, 'label');

		if(!!useALL) {
			result.unshift({label:'All Pharmacies', value:'ALL'});
		}

		useNONE = useNONE === false ? false : true; // default is true
		if(useNONE) {
			result.unshift({label:'Choose a Pharmacy', value:'NONE'});
		}

		return result;

	}

	function affRxModelList(items, includeNONE) {

		var result = [],
			bizModel = '';

		for(var i = 0; i < items.length; i++) {
			bizModel = isText(items[i].RxBizModel) ? items[i].RxBizModel : 'NONE';

			if(result.indexOf(bizModel) < 0) {
				if(bizModel != 'NONE' || !!includeNONE) {
					result.push(bizModel);
				}
			}
		}

		result.sort();

		return result;

	}

	function affRxModelsByFeature(feature) {

		// convert a feature name into a list of RX business models

		switch(feature) {

			case 'ops.accum':
			case 'invoice.review':
				return ['CP', 'CPSPLIT', 'SPLIT', 'SPLITMATCH'];
			case 'report.remittance':
				return ['CP', 'CPTPA', 'CPSPLIT', 'SPLIT', 'SPLITMATCH'];

			case 'audit':
			case 'ops.ce.npi':
			case 'ops.rx.npi':
			case 'ops.catalogs.aff':
				return ['CPTPA', 'CP', 'CPSPLIT', 'SPLIT', 'SPLITMATCH'];

			case 'ops.datamonitor':
				return ['NONE', 'CPTPA', 'CP', 'CPSPLIT', 'SPLIT', 'SPLITMATCH'];

			case 'ops.transform':
				return ['SPLIT'];

			case 'ops.visits':
			case 'ops.match':
			case 'ops.claims':
			case 'ops.referral':
				return ['CP', 'CPTPA', 'SPLITMATCH'];	

			case 'orders.new.ce': // CE user can only create new splitting orders
			case 'invoice.split':
			case 'ops.splittrans':
				return ['SPLIT', 'SPLITMATCH'];
			case 'invoice.cp':
				return ['CP'];

			case 'orders.list':
			case 'ops.ndclist':
			case 'ops.ndclist.edit':
				return ['CP', 'CPTPA', 'SPLIT', 'SPLITMATCH'];

			case 'invoice.add':
				return ['NONE', 'CP', 'SPLIT', 'SPLITMATCH'];
			case 'ops.pricevalidation':
				return ['NONE', 'CP', 'SPLIT', 'SPLITMATCH'];
			case 'report.ce':
			case 'report.rx':
			case 'report.billing-rx': // Pharmacy Invoice
				return ['CP', 'CPSPLIT'];

			case 'report.cpfin':
				return ['CP', 'CPTPA'];

			case 'report.splitsavings': // 340B Savings
			case 'report.splitfinancial':
				return ['SPLIT', 'SPLITMATCH'];

			case 'report.indigent':
				return ['CP'];

			case 'report.unreplenished':
				return ['CP','SPLIT', 'SPLITMATCH'];
            case 'report.uds':
				return ['CP','CPTPA','SPLITMATCH'];	
			case 'report.claimsubmission':
				return ['CP','CPTPA','SPLITMATCH','SPLIT'];
				
			default:
				throw new Error('utilSvc.affRxFeatureModels, feature name not found: ' + feature);
		}

	}

	function affCeList(items) {

		var result = [];

		for(var i = 0; i < items.length; i++) {
			if(isText(items[i].CEID) && result.indexOf(items[i].CEID) < 0) {
				result.push(items[i].CEID);
			}
		}

		// sort alpha asc
		result.sort();

		return result;

	}

	function affProgAdminList(items) {
		var result = [];

		for(var i = 0; i < items.length; i++) {
			if(isText(items[i].ProgAdmin) && result.indexOf(items[i].ProgAdmin) < 0) {
				result.push(items[i].ProgAdmin);
			}
		}

		// sort alpha asc
		result.sort();

		return result;

	}

	function affCeDroplist(items, rxid, useNONE, useALL, useCeName) {
		// get unique list of covered entitites, return them in droplist format
		
		items = Array.isArray(items) ? items : [];
		var ceList = [],
			result = [];

		// RX specified?
		if(isText(rxid)) {
			ceList = affCeOptions(items, rxid);
		}
		else {
			ceList = affCeList(items);
		}

		// prompt
		useNONE = useNONE === false ? false : true; // default is true
		if(useNONE) {
			result.push({label:'Choose a Facility', value:'NONE'});
		}
		if(!!useALL) {
			result.push({label:'All Facilities', value:'ALL'});
		}

		for(var i = 0; i < ceList.length; i++) {
			result.push({
				label: !!useCeName ? ceNameByIdLookup(ceList[i]) : ceList[i],
				value: ceList[i]
			});
		}

		return result;
	}

	function affCeDroplistLabel(items, rxid, useNONE, useALL, useCeName) {
		// get unique list of covered entitites, return them in droplist format

		var affs = Array.isArray(items) ? items : [];

		var ceList = [],
			ceid = '',
			result = [];

		// RX specified?
		if(isText(rxid)) {
			ceList = affCeOptions(affs, rxid);
		}
		else {
			ceList = affCeList(affs);
		}

		useNONE = useNONE === false ? false : true; // default is true
		if(useNONE) {
			result.push({label:'Choose a Facility', value:'NONE'});
		}

		if(!!useALL) {
			result.push({label:'All Facilities', value:'ALL'});
		}

		var useName = useCeName == 'USE_DISPLAY',
			displayTxt = '';

		for(var i = 0; i < ceList.length; i++) {
			ceid = ceList[i];
			displayTxt = useName ? ceNameByIdLookup(ceid) : ceid;
			result.push({label: displayTxt, lbl: displayTxt, value:ceid, val: ceid});
		}
		return result;
	}

	function affShareGroupList(items) {

		// sorted list of accumulator share groups

		var result = [];

		for(var i = 0; i < items.length; i++) {
			for(var ii = 0; ii < items[i].AccumAllGroups.length; ii++) {
				if(result.indexOf(items[i].AccumAllGroups[ii]) < 0) {
					result.push(items[i].AccumAllGroups[ii]);
				}
			}
		}

		// sort alpha asc
		result.sort();

		return result;

	}

	function affRxOptions(items, ceid) {

		// sorted list of all pharmacies affiliated with this CEID
		return affRxList(affFindCe(items, ceid));
	}

	function affRxOptionsByTPA(items, tpaid) {

		// sorted list of all pharmacies affiliated with this TPAID
		return affRxList(affFindTpa(items, tpaid));
	}

	function rxOptionsByRollup(items, rollup) {

		// sorted list of all pharmacies under same rollup parent
		return affRxList(affFindRxParent(items, rollup));
	}

	function affCeOptions(items, rxid) {

		// sorted list of all covered entities affiliated with this RXID
		return affCeList(affFindRx(items, rxid));
	}

	function affVenOptions(items, ceid, rxid, ventype, includeNoEDI) {

		// sorted list of vendors of 'ventype' with this CE/RX

		var result = [];
		ventype = Array.isArray(ventype) ? ventype : ['340B'];

		var affs = affFindRx(affFindCe(items, ceid), rxid);

		var acct = null;
		for(var i = 0; i < affs.length; i++) {
			for(var ii = 0; ii < affs[i].Ordering.length; ii++) {
				acct = affs[i].Ordering[ii];
				if(ventype.indexOf(acct.Type) > -1 && result.indexOf(acct.VENID) < 0) {
					if(!!includeNoEDI || !!acct.SupportsEDI) {
						result.push(acct.VENID);
					}
				}
			}
		}

		// sort alpha asc
		result.sort();

		return result;

	}

	function affAccumGrpAllOptions(items, includeNoEDI) {
		return affAccumGrpOptions(items,'','','',includeNoEDI, true);
	}

	function affAccumGrpOptions(items, ceid, rxid, venid, includeNoEDI, useAllAffs) {

		// sorted list of account types with this CE/RX/VEN

		var result = [];

		var affs = !!useAllAffs ? items : affFindVen(affFindRx(affFindCe(items, ceid), rxid),venid, includeNoEDI);

		var acct = null;
		for(var i = 0; i < affs.length; i++) {
			for(var ii = 0; ii < affs[i].Ordering.length; ii++) {
				acct = affs[i].Ordering[ii];
				if((!!useAllAffs || acct.VENID == venid) && isText(acct.Type) && result.indexOf(acct.Type) < 0) {
					if(!!includeNoEDI || !!acct.SupportsEDI) {
						result.push(acct.Type);
					}
				}
			}
		}

		// sort alpha asc
		result.sort();

		return result;

	}

	function affVenList(affs, ventype, includeNoEDI) {

		// sorted list of vendors of 'ventype'

		var result = [];
		ventype = Array.isArray(ventype) ? ventype : ['340B'];

		var acct = null;
		for(var i = 0; i < affs.length; i++) {
			for(var ii = 0; ii < affs[i].Ordering.length; ii++) {
				acct = affs[i].Ordering[ii];
				if(ventype.indexOf(acct.Type) > -1 && result.indexOf(acct.VENID) < 0) {
					if(!!includeNoEDI || !!acct.SupportsEDI) {
						result.push(acct.VENID);
					}
				}
			}
		}

		// sort alpha asc
		result.sort();

		return result;

	}

	function droplistByType(affs, propType, limits) {

		// return an ng droplist from affiliations by one of types: CE, RX, VEN, ACCUMGRP

		if(!Array.isArray(affs) || affs.length < 1) {
			return [];
		}

		var affOptions = [],
			affPrompt = [];

		switch(propType) {

			case 'CE':
				affOptions = !!limits ? affCeOptions(affs, limits.RX) : affCeList(affs);
				affPrompt = [{label:'Choose a Facility', value:'NONE'}];
				break;

			case 'RX':
				affOptions = !!limits ? affRxOptions(affs, limits.CE) : affRxList(affs);
				affPrompt = [{label:'Choose a Pharmacy', value:'NONE'}];
				break;

			case 'VEN':
				if(!!limits) {
					limits.ACCUMGRP = Array.isArray(limits.ACCUMGRP) ? limits.ACCUMGRP : ['340B', 'GPO', 'WAC'];
					affOptions = affVenOptions(affs, limits.CE, limits.RX, limits.ACCUMGRP, limits.includeNoEDI);
				}
				else {
					affOptions = affVenList(affs, ['340B', 'GPO', 'WAC']);
				}
				affPrompt = [{label:'Choose a Vendor', value:'NONE'}];
				break;

			case 'ACCUMGRP':
				affOptions = !!limits ? affAccumGrpOptions(affs, limits.CE, limits.RX, limits.VEN, limits.includeNoEDI) : ['340B', 'GPO', 'WAC'];
				affPrompt = [{label:' ', value:'NONE'}];
				break;

			default:
				throw new Error('utilSvc.droplistByType, unknown propType: ' + propType);

		}

		return ngDroplist(affOptions,'','',affPrompt);

	}

	function tpaDroplist(items) {
		items = Array.isArray(items) ? items : [];
		var result = [];

		// create a sorted list of unique rx short names in dropdown format
		for(var i = 0; i < items.length; i++) {
			result.push({label:items[i].Name, value:items[i].Id});
		}
		
		result = sortTextAscending(result, 'label');
		result.unshift({label: 'Choose a Program Admin', value: 'NONE' });
		
		return result;
	}

	/**
	 *    MULTISELECT DROPDOWN
	 *    column filter control which uses a list of checkbox options or has a free-text filter textbox
	 */

	function addMultiselect(vm) {
		vm.multiselectBuild = multiselectBuild;
		vm.multiselectBuildWithLabel = multiselectBuildWithLabel;
		vm.multiselectBuildCE = multiselectBuildCE;
		vm.multiselectBuildRX = multiselectBuildRX;
		vm.multiselectClick = multiselectClick;
		vm.multiselectTitle = multiselectTitle;
		vm.multiselectReturnVisit = multiselectReturnVisit;
		vm.multiselectAllVals = multiselectAllVals;
	}

	function multiselectBuild(items, defaultState) {

		defaultState = defaultState === false ? false : true; // default is true, check explicitly for false

		// don't add ALL if checklist has 1 other item to check
		if(items.length === 2 && items[0] == 'ALL') {
			return [{checked:defaultState, val: items[1], lbl: items[1]}];
		}
		else {
			var result = [];

			for(var i = 0; i < items.length; i++) {
				result.push({checked:defaultState, val: items[i], lbl: items[i]});
			}

			return result;
		}

	}

	function multiselectBuildWithLabel(items, defaultState) {

		defaultState = defaultState === false ? false : true; // default is true, check explicitly for false

		// don't add ALL if checklist has 1 other item to check
		if(items.length === 2 && items[0] == 'ALL') {
			return [{checked:defaultState, val: items[1].val, lbl: items[1].lbl}];
		}
		else {
			var result = [];

			for(var i = 0; i < items.length; i++) {
				result.push({checked:defaultState, val: items[i].val, lbl: items[i].lbl});
			}

			return result;
		}
	}

	function multiselectBuildCE(items, defaultState, affs, useDisplay) {

		defaultState = defaultState === false ? false : true; // default is true, check explicitly for false
		affs = Array.isArray(affs) ? affs : [];

		// 1 item in checklist, remove ALL
		if(items.length === 2 && items[0] == 'ALL') {
			if (useDisplay == "USE_DISPLAY") {
				return [{checked:defaultState, val: items[1], lbl: ceNameByIdLookup(items[1])}];
			} else {
				return [{checked:defaultState, val: items[1], lbl: items[1]}];
			}
		}

		var result = [],
			useCeName = useDisplay == "USE_DISPLAY";

		for(var i = 0; i < items.length; i++) {
			if (useCeName) {
				result.push({checked:defaultState, val: items[i], lbl: ceNameByIdLookup(items[i])});
			} else {
				result.push({checked:defaultState, val: items[i], lbl: items[i]});
			}
		}
		return result;
	}

	function multiselectBuildRX(items, defaultState, affs) {

		defaultState = defaultState === false ? false : true; // default is true, check explicitly for false
		affs = Array.isArray(affs) ? affs : [];

		// don't add ALL if checklist has 1 other item to check
		if(items.length === 2 && items[0] == 'ALL') {
			return [{checked:defaultState, val: items[1], lbl: rxShortNameById(affs, items[1])}];
		}
		else {
			var result = [];
			var hasALL = false;

			for(var i = 0; i < items.length; i++) {
				// Skip ALL option
				if (items[i] == 'ALL') {
					hasALL = true;
					continue;
				}
				result.push({checked:defaultState, val: items[i], lbl: rxShortNameById(affs, items[i])});
			}

			// sort all dropdown all options
			sortTextAscending(result, 'lbl');
			// Leave all at front
			if (!!hasALL) {
				result.unshift({checked:defaultState, val: 'ALL', lbl: 'ALL'});
			}

			return result;
		}

	}

	function multiselectClick(multiselect, val) {

		// OPTIONS item click

		// params
		var checkList = multiselect.list;

		// checklist is empty
		if(checkList.length < 1) {
			multiselect.vals = [];
			return;
		}

		// ALL click?
		var isAll = val == 'ALL',
			isClear = val == '|CLEAR|',
			usingALL = checkList[0].val == 'ALL',
			allStatus = false;

		// toggle ALL to true
		if(isAll && (!usingALL || (usingALL && !checkList[0].checked))) {
			allStatus = true;
		}

		// build filter values from checkbox status of each item
		var vals = [],
			i = usingALL ? 1 : 0;
		for(i; i < checkList.length; i++) {

			if(isClear) {
				checkList[i].checked = false;
			}
			else if(isAll) {
				// set all items based on ALL status
				checkList[i].checked = allStatus;
			}
			else if(checkList[i].val == val) {
				// toggle list item
				checkList[i].checked = !checkList[i].checked;
			}

			if(checkList[i].checked) {
				vals.push(checkList[i].val);
			}

		}

		// if user clicks all options, change to ALL mode
		if(usingALL) {
			if(vals.length === checkList.length - 1) {
				vals = ['ALL'];
				checkList[0].checked = true;
			}
			else {
				checkList[0].checked = false;
			}
		}

		multiselect.vals = vals;

	}

	function multiselectTitle(multiselect, autoSelectTitle) {

		// build title text and dirty shading

		var noneTitle = isText(multiselect.titleNoOptions) ? multiselect.titleNoOptions : 'No Options',
			allTitle = isText(multiselect.titleAllOptions) ? multiselect.titleAllOptions : 'All Options';

		switch(multiselect.focus) {
			case 'OPTIONS':
				if(multiselect.vals.length < 1) {
					multiselect.title = noneTitle;
				}
				else if(multiselect.vals.length === 1 && multiselect.vals[0] == 'ALL') {
					multiselect.title = allTitle;
				}
				else if(multiselect.vals.length === 1 && !!autoSelectTitle) {
					multiselect.title = multiselect.type == 'RX' || multiselect.type == 'MFR' ? multiselectName(multiselect.list, multiselect.vals[0]) : multiselect.vals[0];
				}
				else {
					multiselect.title = multiselect.vals.length.toString() + ' Options';
				}
				multiselect.dirty = (multiselect.vals.length === 1 && multiselect.vals[0] == 'ALL') ? false : true;
				break;
			case 'FIND':
				multiselect.title = 'Find: "' + (isText(multiselect.txtVal) ? multiselect.txtVal : '') + '"';
				multiselect.dirty = true;
				break;
			default:
				throw new Error('multiselectTitleBar, unknown focus: ' + multiselect.focus);
		}

	}

	function multiselectReturnVisit(multiselect, focus, vals, txt) {

		// restore multiselect from saved viewState

		// FIND uses ALL options
		if(focus == 'FIND') {
			vals = ['ALL'];
			txt = isText(txt) ? txt : '';
		}
		else {
			// OPTIONS uses empty text
			focus = 'OPTIONS';
			txt = '';
		}
		multiselect.focus = focus;
		multiselect.vals = [];
		multiselect.txtVal = txt;

		// checklist is empty, exit
		var checkList = multiselect.list;
		if(!Array.isArray(checkList) || checkList.length < 1) {
			multiselect.list = [];
			multiselect.txtVal = '';
			return;
		}

		var isAll = vals.length === 1 && vals[0] == 'ALL',
			usingAll = checkList[0].val == 'ALL',
			isNone = vals.length < 1,
			i = 0;
		if(isAll) {
			multiselect.vals = ['ALL'];
		}
		if(usingAll) {
			i = 1;
			checkList[0].checked = isAll;
		}

		for(i; i < checkList.length; i++) {
			if(isAll) {
				checkList[i].checked = true;
			}
			else if(isNone) {
				checkList[i].checked = false;
			}
			else {
				checkList[i].checked = vals.indexOf(checkList[i].val) > -1;
				if(!isAll && checkList[i].checked) {
					multiselect.vals.push(checkList[i].val);
				}
			}
		}

	}

	function multiselectName(chk, rxid) {

		// get RX Short Name from multi checklist items

		if(!Array.isArray(chk) || chk.length < 1 || !isText(rxid)) {
			return '';
		}

		for(var i = 0; i < chk.length; i++) {
			if(chk[i].val == rxid) {
				return chk[i].lbl;
			}
		}

		return rxid;
	}

	function multiselectAllVals(multiselect) {

		// return current vals, if ALL chosen then create vals from checklist options

		var result = [],
			checkList = multiselect.list,
			vals = multiselect.vals;

		// checklist or vals are empty
		if(checkList.length < 1 || vals.length < 1) {
			return result;
		}

		// vals exist but ALL not chosen
		var isAll = vals[0] == 'ALL';
		if(!isAll) {
			return vals;
		}

		// ALL chosen, create vals from checklist options
		var i = checkList[0].val == 'ALL' ? 1 : 0;  // skip ALL if first checklist option
		for(i; i < checkList.length; i++) {
			result.push(checkList[i].val);
		}

		return result;

	}


	/**
	 *    FLEX QUERY TOP
	 *    note: also supports max-height animation tbd...
	 */

	function addFlexTop(vm) {
		vm.flexInit = flexInit;
		vm.flexToggle = flexToggle;
		vm.flexCollapse = flexCollapse;
	}

	function flexInit() {
		return {
			ready: false,
			pending: false,
			state: 'body',
			showHead: false,
			showBody: true
		};
	}

	function flexToggle(flx, mouseState, queryOk) {

		// toggle between head / body
		// several conditions need to exist to collapse from body down to head
		if(mouseState == 'leave' && !!queryOk) {
			if(flx.state == 'head') {
				flx.pending = false;
			}
			else {
				flx.pending = true;
				flx.state = 'head';
			}
		}
		else {
			flx = flexInit();
		}

		return flx;
	}

	function flexCollapse(flx, forceClose) {

		// after a delay, is everything still ok to collapse?
		if(!!forceClose || (!!flx.pending && flx.state == 'head')) {
			flx.state = 'head';
			flx.showBody = false;
			flx.showHead = true;
			flx.pending = false;
		}

		return flx;
	}


	/**
	 *    USER
	 */

	function userHasFeature(scp, featName) {

		// find feature claim in User features list
		if(scp && scp.User && Array.isArray(scp.User.Features)) {
			var feats = scp.User.Features;
			for(var i = 0; i < feats.length; i++) {
				if(feats[i].Name == featName) {
					return true;
				}
			}
		}

		return false;

	}

	function userParseLoginProfile(usr) {

		// parse for user preferences from login response

		var result = {
			Dashboard: {},
			FilterSwap: {},
			TableViews: [],
			SavedReports: [],
			AdminPrefs: {}
		};

		// profile empty
		if(!!!usr || !Array.isArray(usr.Profile) || usr.Profile.length < 1) {
			return result;
		}

		try {

			var prefs = usr.Profile,
				prefVal = '';

			// loop prefs
			// note: login returns preferences in an array with each pref as stringified json: User.Profile[{Type:'DASHBOARD',Value:'...'}]
			for(var i = 0; i < prefs.length; i++) {

				prefVal = prefs[i].Value;
				if(!isText(prefVal)) {
					continue;
				}

				switch(prefs[i].Type) {

					case 'DASHBOARD':
						// CE, RX, row properties must exist
						var dash = angular.fromJson(prefVal);
						if(!!!dash || typeof(dash.CE) !== 'string' || typeof(dash.RX) !== 'string' || !Array.isArray(dash.rows) || !Array.isArray(dash.rxBizModels)) {
							dash = {};
						}
						result.Dashboard = dash;
						break;

					case 'FILTERSWAP':
						var filterSwap = angular.fromJson(prefVal);
						if(!!filterSwap) {
							result.FilterSwap = filterSwap;
						}
						break;

					case 'TABLEVIEW':
						var tblViews = angular.fromJson(prefVal);
						if(Array.isArray(tblViews)) {
							result.TableViews = tblViews;
						}
						break;

					case 'SAVEDREPORTS':
						var series = angular.fromJson(prefVal);
						if(Array.isArray(series)) {
							result.SavedReports = series;
						}
						break;

					case 'ADMIN':
						var adminPrefs = angular.fromJson(prefVal);
						if(!!adminPrefs) {
							result.AdminPrefs = adminPrefs;
						}
						break;

					default:
						//console.log('utilSvc.userParseLoginProfile, unknown user pref type: ' + prefs[i].Type);
				}
			}
		}
		catch(err) {
			return {
				Dashboard: {},
				FilterSwap: {},
				TableViews: [],
				SavedReports: [],
				AdminPrefs: {}
			};
		}

		return result;

	}


	/**
	 *    TABLE VIEWS
	 */

	function addTableViews(vm) {
		vm.tblViewInit = tblViewInit;
		vm.tblViewReset = tblViewReset;
		vm.tblViewLoad = tblViewLoad;
		vm.tblViewSyncFilter = tblViewSyncFilter;
		vm.tblViewLoadTitlesAndFilters = tblViewLoadTitlesAndFilters;
		vm.tblViewGetColumnFilterValues = tblViewGetColumnFilterValues;
	}

	function tblViewVM() {

		return {
			current: '1', // default
			views: [],
			sections: [],
			show:{},
			sortby: [],
			pgsize: 50
		};

	}

	function tblViewReset(tblView, fullReset) {

		var result = tblViewVM();

		// keep views
		if(!!!fullReset) {
			result.views = tblView.views;
		}

		return result;

	}

	function tblViewInit(tblConfig, tvSaved) {

		// initialize default and saved table views
		// note: uses table config to validate columns are available for this user

		var result = tblViewVM();

		// setup default
		var defaultTable = {
			id: '1',
			title: 'Default',
			sortby: tblConfig.sortby,
			pgsize: tblConfig.pgsize,
			cols:'|'
		};

		// build default view columns (deliminated bar list format)
		var configCols = tblConfig.cols,
			configKeys = tblConfig.colKeys,
			colKey = {},
			i = 0;
		for(i = 0; i < configCols.length; i++) {
			colKey = configKeys[configCols[i]];
			if(colKey.default !== false) {
				defaultTable.cols += colKey.name + '|';
			}
		}
		result.views.push(defaultTable);

		// user has saved views?
		if(!!tvSaved) {

			var views = tvSaved.views,
				viewCols = [],
				viewOk = true;
			for(var v = 0; v < views.length; v++) {
				viewOk = true;
				viewCols = views[v].cols.split('|');

				// check the cols against config allowed cols
				for(var vv = 0; vv < viewCols.length; vv++) {
					if(isText(viewCols[vv]) && !!!configKeys[viewCols[vv]]) {
						// column not allowed, custom view is bad
						viewOk = false;
						break;
					}
				}
				if(viewOk) {
					result.views.push(views[v]);

					// is this view the default?
					if(tvSaved.current == views[v].id) {
						result.current = tvSaved.current;
					}
				}
				else {
					// task: remove this view from saved views
				}
			}
		}

		return result;

	}

	function tblViewFindCurrent(tblView) {

		// return current view reference

		var views = tblView.views;
		if(!isText(tblView.current) || !Array.isArray(views) || views.length < 1) {
			return null;
		}

		for(var i = 0; i < views.length; i++) {
			if(tblView.current == views[i].id) {
				return views[i];
			}
		}

		return null;

	}

	function tblViewLoad(tblConfig, tblView) {

		// features call load to display html table headers and col show/hide, pgsize, sortby

		// params
		if(!!!tblView || !isText(tblView.current) || !Array.isArray(tblView.views) || tblView.views.length < 1) {
			alert('loadTableView, Table views are empty');
			return;
		}

		var views = tblView.views,
			viewNow = tblViewFindCurrent(tblView);

		// use default if not found
		if(!!!viewNow) {
			tblView.current = '1';
			viewNow = views[0];
		}

		// load view details
		tblView.sortby = [viewNow.sortby];
		tblView.pgsize = viewNow.pgsize;

		// load view columns
		tblView.sections = [];
		tblView.show = {};
		var cols = viewNow.cols.split('|'),
			colName = '',
			sections = '|',
			section = '';

		for(var c = 0; c < cols.length; c++) {
			colName = cols[c];
			if(isText(colName) && !!tblConfig.colKeys[colName]) {
				tblView.show[colName] = true;

				// add section to list
				section = tblConfig.colKeys[colName].section;
				if(sections.indexOf('|' + section + '|') < 0) {
					sections += section + '|';

					tblView.sections.push({
						name: section,
						title: tblConfig.sections[section].title,
						cols: 1
					});
				}
				else {
					// section exists, increment column count
					tblView.sections[tblView.sections.length - 1].cols++;
				}
			}
		}

		return tblView;

	}

	function tblViewLoadTitlesAndFilters(tblConfig, tblView, flt) {
		// add title/filter columns to current view

		var result = tblViewLoad(tblConfig, tblView);
		result.cols = [];

		var configCols = tblConfig.cols,
			colKeyName = '',
			colKey = {},
			hasFlt = !!flt,
			fltVal;

		// loop all possible config columns for this table
		for(var i = 0; i < configCols.length; i++) {
			colKeyName = configCols[i];
			colKey = tblConfig.colKeys[colKeyName];
			if(!!colKey) {
				// is this column being shown right now?
				if(!!result.show[colKeyName]) {

					fltVal = undefined;
					if(hasFlt && !!flt[colKey.flt] && typeof(flt[colKey.flt][colKeyName]) !== 'undefined') {
						// column is being filtered on view, get its value
						fltVal = flt[colKey.flt][colKeyName];
					}

					result.cols.push({
						name: colKey.name,
						title: colKey.title,
						width: isText(colKey.colWidth) ? colKey.colWidth : '',
						fltType: colKey.flt,
						flt: fltVal
					});
				}
			}
		}

		return result;
	}

	function tblViewGetColumnFilterValues(cols, flt) {
		// on filter change copy table view filter values into vm.flt

		cols = Array.isArray(cols) ? cols : [];
		flt = flt || {};
		var col = {};
		for(var i = 0; i < cols.length; i++) {
			col = cols[i];
			if(typeof(col.flt) !== 'undefined') {
				flt[col.fltType] = flt[col.fltType] || {};
				flt[col.fltType][col.name] = col.flt;
			}
		}

		return flt;
	}


	function tblViewSyncFilter(tblConfig, tblView, flt, fltKeepPaging) {


		var configCols = tblConfig.cols,
			configKeys = tblConfig.colKeys,
			col = {},
			currentView = tblViewFindCurrent(tblView);
		var viewCols = currentView.cols;

		// remove any property from the filter which the config doesn't support
		var viewColsList = viewCols.split('|');
		var fltTypes = ["Text", "Dates", "Numbers"];
		for (var i = 0; i < viewColsList.length; i++) {
			col = viewColsList[i];
			if (configCols.indexOf(col) < 0) {
				for (var j = 0; j < fltTypes.length; j++) {
					var fltType = fltTypes[j];
					if (!!flt[fltType]) {
						flt[fltType][col] = undefined;
					}
				}
			}
		}
		
		// remove any property from the filter the view isn't using
		for(i = 0; i < configCols.length; i++) {
			col = configCols[i];
			if(viewCols.indexOf('|' + col + '|') < 0) {
				// exists in filter?
				if(!!flt[configKeys[col].flt]) {
					flt[configKeys[col].flt][col] = undefined;
				}
			}
		}

		// sort by: validate existing sort by property exists in new table
		var keepSortBy = false;
		if(!!fltKeepPaging && Array.isArray(flt.SortBy) && flt.SortBy.length == 1 && isText(flt.SortBy[0]) && flt.SortBy[0].length > 1) {
			var fltProp = flt.SortBy[0];
			fltProp = fltProp[0] == '-' ? fltProp.substr(1, fltProp.length -1) : fltProp; // if decending, strip off leading '-'
			if(viewCols.indexOf('|' + fltProp + '|') > -1) {
				keepSortBy = true;
			}
		}
		if(!keepSortBy) {
			flt.SortBy = tblView.sortby;
		}

		// paging: replace flt paging if flt value not valid
		if(!!!fltKeepPaging || !isNumber(flt.PageSize)) {
			flt.PageSize = tblView.pgsize;
		}

		return flt;
	}


	/**
	 *    HELPERS
	 */

	function widDateRangeList(removeOptions) {

		// generate list of date range options
		// note:
		//		see the directive "widget-input-date-range" for the full list as below
		//		an error will be thrown if these ever get out of sync
		var dateOptions = [
			{label:'', value: 'NONE'},
			{label:'Today', value: 'TODAY'},
			{label:'Yesterday', value: 'YESTERDAY'},
			{label:'Today & Yesterday', value: 'TODAYYESTERDAY'},
			{label:'Last 2 Days including Today', value: '2DAYS'},
			{label:'Last 3 Days including Today', value: '3DAYS'},
			{label:'Last 7 Days including Today', value: '7DAYS'},
			{label:'Last 2 Weeks', value: '2WEEKS'},
			{label:'Monthly', value: 'MONTHLY'},
			{label:'Month To Date', value: 'MTD'},
			{label:'Quarterly', value: 'QTR'},
			{label:'Quarter To Date', value: 'QTD'},
			{label:'Last Quarter', value: 'QTDLAST'},
			{label:'Custom Date Range (92 day max)', value: 'CUSTOM92'}
		];

		// remove options (caller can remove some of the date options, feature specific)
		if(Array.isArray(removeOptions)) {
			for(var i = dateOptions.length - 1; i >= 0; i--) {
				if(removeOptions.indexOf(dateOptions[i].value) > -1) {
					dateOptions.splice(i, 1);
				}
			}
		}

		return dateOptions;

	}

	function isNumber(val) {
		return !isNaN(val) && val !== null && val !== '';
	}

	function isInteger(val) {
		return isNumber(val) && parseInt(val) === parseFloat(val);
	}

	function numberFmt(val, zeroFmt, prefix, decPlaces) {
		if (!isNumber(val)) {
			return '';
		}

		// zero
		if (val === 0) {
			return zeroFmt;
		}

		result = prefix + toText($filter('number')(val, decPlaces));
		return result;
	}
}
 
/**
 *    VALIDATION
 *    app-wide validation properties and methods
 */

validSvc.$inject = ['$filter', 'appConst', 'errSvc', 'utilSvc'];
angular
.module('espui.core')
.factory('validSvc', validSvc);

/* @ngInject */
function validSvc($filter, appConst, errSvc, utilSvc) {

	var service = {
		isNull: isNull,
		isText: isText,
		isDate: isDate,
		isNumber: isNumber,
		isInteger: isInteger,
		isJson: isJson,

		isCE: isCE,
		isRX: isRX,
		isVEN: isVEN,
		isEntity: isEntity,
		isTPA: isTPA,

		newProp: newProp,
		newCheckProp: newCheckProp,
		newPropDate: newPropDate,
		newPropDOBDate: newPropDOBDate,
		newPropTodayDate: newPropTodayDate,
		newPropDateExact: newPropDateExact,
		newPropDateNull: newPropDateNull,
		propDateValid: propDateValid,
		datePropRange: datePropRange,
		validPhone: validPhone,
		setResult: setResult,

		httpGetListResp: httpGetListResp,
		httpGetOneResp: httpGetOneResp,
		httpGetEntityResp: httpGetEntityResp,
		httpUpsert200Resp: httpUpsert200Resp,
		httpBulkUpsert200Resp: httpBulkUpsert200Resp,
		httpUpsertErrResp: httpUpsertErrResp,

		authEntity: authEntity,
		authVM: authVM,

		pageSize: pageSize,
		sortByApi: sortByApi,
		sortByUi: sortByUi,

		blobSupported: blobSupported,
		uploadSupported: uploadSupported,

		hasUpperCaseLetter: hasUpperCaseLetter,
		hasLowerCaseLetter: hasLowerCaseLetter,
		hasSymbol: hasSymbol,
		hasNumber: hasNumber,
		hasSpace: hasSpace
	};

	return service;


	/**
	 *    NULL CHECK
	 *    includes undefined and null, but not falsy values like false or -1
	 */

	function isNull(val) {
		return typeof(val) == 'undefined' || val === null;
	}

	function validPhone(prop, notRequired) {
		prop.fail = 'yes';
		prop.msg = 'format expected: "123-456-7890"';

		// not required
		if(!!notRequired && !isText(prop.val)) {
			prop.fail = 'no';
			prop.msg = '';
			return prop;
		}

		// is empty, not 12 chars, no dash at 3 or 7
		if(!isText(prop.val) || prop.val.length != 12 || prop.val.indexOf('-') != 3 || prop.val.lastIndexOf('-') != 7) {
			return prop;
		}

		// strip down to numbers and dash
		prop.val.replace(/[^0-9\-]+/g,'');
		var phoneVals = prop.val.split('-');

		// area code
		if(phoneVals[0].length != 3 || isNaN(phoneVals[0])) {
			prop.msg = 'area code must be numbers';
			return prop;
		}

		// second 3 digits
		if(phoneVals[1].length != 3 || isNaN(phoneVals[1])) {
			prop.msg = 'second 3 digits must be numbers';
			return prop;
		}

		// last 4 digits
		if(phoneVals[2].length != 4 || isNaN(phoneVals[2])) {
			prop.msg = 'last 4 digits must be numbers';
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;
	}


	/**
	 *    PROPERTY
	 *    controllers and repos communicate validation erros using validation properties
	 */

	function newProp(val, fail, msg) {

		// init prop values
		val = !isNull(val) ? val : null;
		msg = !isNull(msg) ? msg : '';
		fail = !!fail;

		return {
			val: val,
			fail: fail,
			msg: msg
		};

	}

	function newCheckProp(val, chk) {
		var p = newProp(val);
		p.chk = !!chk;
		return p;
	}

	function newPropDateExact(val, min, max, fail, msg) {

		// incoming date val is in "exact" text format of mm/dd/yyyy
		// don't modify the incoming value, its already been parsed by a UTC function earlier

		var dt = newPropDate(val, min, max, fail, msg);

		// replace value with exact text passed in
		dt.val = val;

		return dt;

	}

	function newPropDate(val, min, max, fail, msg) {

		// date validation property always has min and max values
		// note: default values are today with no time

		var dtToday = new Date();

		// init with valid date type
		var dt = {
			val: dtToday,
			min: dtToday,
			max: dtToday
		};

		// assign
		dt.val = isDate(val) ? val : utilSvc.dt.zeroTime(dtToday);
		dt.min = isDate(min) ? min : utilSvc.dt.zeroTime(appConst.app.liveDate);
		dt.max = isDate(max) ? max : utilSvc.dt.zeroTime(dtToday);
		dt.fail = typeof(fail) === 'boolean' ? fail : false;
		dt.msg = isText(msg) ? msg : '';

		return dt;

	}

	function newPropDOBDate(val) {
		var dtToday = utilSvc.dt.zeroTime(new Date());
		var dtMin = utilSvc.dt.zeroTime(utilSvc.dt.addDays(new Date(), (-43800))); // 120 years days back from today
		return newPropDate(val, dtMin, dtToday);
	}

	function newPropTodayDate() {

		var dtToday = utilSvc.dt.zeroTime(new Date());
		var dtMin = utilSvc.dt.zeroTime(utilSvc.dt.addDays(new Date(), (-3650))); // 10 years days back from today
		return newPropDate(dtToday, dtMin, dtToday);
	}

	function newPropDateNull(min, max, fail, msg) {

		// allows empty dates for non-required fields (instead of newPropDate which will put in today's date)
		// note: default values are today with no time

		var dt = {
			val: null
		};
		dt.min = isDate(min) ? min : utilSvc.dt.zeroTime(appConst.app.liveDate);
		dt.max = isDate(max) ? max : utilSvc.dt.zeroTime(new Date());
		dt.fail = typeof(fail) === 'boolean' ? fail : false;
		dt.msg = isText(msg) ? msg : '';

		return dt;

	}


	/**
	 *    STRING
	 */

	function isText(testVal) {
		return utilSvc.str.isText(testVal);
	}

	function isJson(txt) {

		// parse string for Json without throwing an error

		try {
			var test = angular.fromJson(txt);
			if(!!test) {
				return true;
			}
		}
		catch(err) {
			// do nothing
		}

		return false;

	}


	/**
	 *    NUMBER
	 */

	function isNumber(val) {
		return !isNaN(val) && val !== null && val !== '';
	}

	function isInteger(val) {
		return isNumber(val) && parseInt(val) === parseFloat(val);
	}


	/**
	 *    DATE
	 */

	function isDate(dt) {
		return utilSvc.dt.isValid(dt);
	}

	function propDateCheck(dt, regex) {

		// check date properties, return name of property which failed validation, or null

		// invalid object
		if(!!!dt) {
			return 'obj';
		}

		// required
		if(!utilSvc.str.isText(utilSvc.str.toText(dt.val))) {
			return 'req';
		}

		// regex
		if(!!regex && !regex.test(dt.val)) {
			return 'regex';
		}

		// val
		var val = utilSvc.dt.parse(dt.val);
		if(val === null) {
			return 'val';
		}

		// min
		var dtMin = utilSvc.dt.parse(dt.min);
		if(dtMin !== null && utilSvc.dt.diffMilli(dtMin, val) < 0) {
			return 'min';
		}

		// max
		var dtMax = utilSvc.dt.parse(dt.max);
		if(dtMax !== null && utilSvc.dt.diffMilli(dtMax, val) > 0) {
			return 'max';
		}

		// pass
		return null;

	}

	function propDateValid(dt, regex) {

		// validate date object, add standard fail msg text

		var testDt = {
			val: 'invalid',
			min: 'invalid',
			max: 'invalid',
			msg: '',
			fail: true
		};

		switch(propDateCheck(dt, regex)) {

			case 'obj':
				dt = newPropDateNull();
				dt.fail = true;
				dt.msg = 'invalid object';
				return dt;

			case 'req':
				dt.fail = true;
				dt.msg = 'is required';
				return dt;

			case 'regex':
				dt.fail = true;
				dt.msg = 'format is m/d/yyyy';
				return dt;

			case 'val':
				dt.fail = true;
				dt.msg = 'invalid date';
				return dt;

			case 'min':
				dt.fail = true;
				dt.msg = 'must be on or after: ' + $filter('date')(dt.min, 'M/d/yyyy');
				return dt;

			case 'max':
				dt.fail = true;
				dt.msg = 'must be on or before: ' + $filter('date')(dt.max, 'M/d/yyyy');
				return dt;

			case null:
				dt.fail = false;
				dt.msg = '';
				return dt;

			default:
				throw new Error('unknown date check value: ' + propDateCheck(dt));

		}

	}

	function datePropRange(start, end, minDayRange, maxDayRange) {

		// validate a date range between two date props

		// invalid range params
		if (minDayRange < 0 || maxDayRange < 0 || minDayRange > maxDayRange) {
			throw 'validSvc.dateRange, day range params must be > 0, min range must be less than max range';
		}

		// invalid date prop objects
		start = dateProp(start);
		end = dateProp(end);
		if(start.fail || end.fail) {
			return false;
		}

		// start prop after end prop
		if(utilSvc.dt.diffMilli(start.val, end.val) < 0) {
			start.fail = true;
			start.msg = 'must be earlier or the same as end date';
			end.fail = true;
			end.msg = 'must be after or the same as start date';
			return false;
		}

		var dayRange = utilSvc.dt.diffDays(start.val, end.val);

		// day range < min range
		if(dayRange < minDayRange) {
			start.fail = true;
			start.msg = 'date range must be at least' + minDayRange.toString() + ' days';
			end.fail = true;
			end.msg = 'date range must be at least' + minDayRange.toString() + ' days';
			return false;
		}

		// day range > max range
		if(dayRange > maxDayRange) {
			start.fail = true;
			start.msg = 'date range must be less than ' + maxRangeDays.toString() + ' days';
			end.fail = true;
			end.msg = 'date range must be less than ' + maxRangeDays.toString() + ' days';
			return false;
		}

		// pass
		return true;

	}

	function setResult(isValid, prop, msgFail, msgPass) {

		// short cut to set property fail result based on a validity test

		if(!!isValid) {
			prop.fail = 'no';
			prop.msg = isText(msgPass) ? msgPass : '';
		}
		else {
			prop.fail = 'yes';
			prop.msg = msgFail;
		}

		return prop;

	}


	/**
	 *    HTTP RESPONSE
	 */

	function httpData(r) {
		// has data
		return !!r && !!r.data;
	}

	function httpStatus(r) {
		// has status
		return !!r && !!r.status && !isNaN(r.status) && r.status >= 0;
	}

	function httpEntity(r) {
		// has data.Entity{}
		return httpData(r) && !!r.data.Entity;
	}

	function httpEntityArray(r) {
		// has data.Entity[]
		return httpData(r) && Array.isArray(r.data.Entity);
	}

	function httpGetPaging(r) {
		// has data.Paging{}
		return httpData(r) && !!r.data.Paging && !isNaN(r.data.Paging.Size) && r.data.Paging.Size >= 0;
	}

	function httpGetListResp(r) {
		// get list has: status, entity and paging
		return httpStatus(r) && httpEntityArray(r) && httpGetPaging(r);
	}

	function httpGetEntityResp(r) {
		// get detail (one item) has status, paging, array of length 1
		return httpStatus(r) && httpEntity(r);
	}

	function httpGetOneResp(r) {
		// get detail (one item) has status, paging, array of length 1
		return httpStatus(r) && ((httpEntityArray(r) && r.data.Entity.length == 1) || httpEntity(r));
	}

	function httpUpsert200Resp(r) {
		// create/update upsert has status, data.Entity.Id
		return httpStatus(r) && httpEntity(r) && isText(r.data.Entity.Id);
	}
	
	function httpBulkUpsert200Resp(r) {
		// create/update upsert has status, data.Entity.Id
		return httpStatus(r) && httpEntity(r);
	}

	function httpUpsertErrResp(r) {
		// create/update error has status (409 or 422), data.Entity.ROOT[] and data.Entity.Fields[]
		if(httpStatus(r)) {
			return r.status == 409 || (r.status == 422 && httpEntity(r) && Array.isArray(r.data.Entity.ROOT) && Array.isArray(r.data.Entity.Fields));
		}

		return false;
	}


	/**
	 *    AUTH VM
	 *    view model structure and values are valid
	 */

	function authVM(auth) {

		if(!!!auth || !!!auth.CE || !isText(auth.CE.val) || !!!auth.RX || !isText(auth.RX.val)) {
			return false;
		}

		return true;

	}


	/**
	 *    AUTH ENTITY
	 *    CE, Pharmacy, Vendor Ids all use the same format
	 *    note: two key words for state are: 'NONE' and 'ALL'
	 */

	function authEntity(ent, noneOk, allOk) {

		// reset
		ent.fail = false;
		ent.msg = '';

		// no valid characters (even empty should be 'NONE')
		if(!isText(ent.val)) {
			ent.fail = true;
			ent.msg = 'invalid string';
		}
		else if(ent.val.toUpperCase() == 'NONE' && !noneOk) {
			// none not allowed
			ent.fail = true;
			ent.msg = 'is required';
		}
		else if(ent.val.toUpperCase() == 'ALL' && !allOk) {
			// all not allowed
			ent.fail = true;
			ent.msg = 'cannot be all';
		}

		// return
		return ent;

	}


	/**
	 *    SORT BY
	 */

	function sortByApi(sortVM) {

		if(!!sortVM && isText(sortVM.Field) && isText(sortVM.Order)) {
			if(sortVM.Order == 'ASC' || sortVM.Order == 'DSC') {
				return true;
			}
		}

		return false;
	}

	function sortByUi(sortTxt) {

		// use utilSvc, convert to API style, check values
		var apiConvert = utilSvc.sorting.sortByApiStyle(sortTxt);
		if(!!apiConvert && isText(apiConvert.Field) && (apiConvert.Order == 'ASC' || apiConvert.Order == 'DSC')) {
			return true;
		}
		else {
			return false;
		}

	}

	/**
	 *    PAGE SIZE
	 */

	function pageSize(val) {

		if(isNaN(val) || val < 1 || val > appConst.app.query.pagingSize) {
			return false;
		}

		return true;
	}


	/**
	 *    ENTTY VALUE CHECK
	 *    CE OR RX OR VEN
	 */

	function isEntity(entity, noneOk, allOk) {

		// has no value
		var checkVal = utilSvc.str.toText(entity);
		if(!isText(checkVal)) {
			return false;
		}
		checkVal = checkVal.toUpperCase();

		// is NONE
		if(checkVal == 'NONE' && !!!noneOk) {
			return false;
		}

		// is ALL
		if(checkVal == 'ALL' && !!!allOk) {
			return false;
		}

		// pass
		return true;

	}

	function isRX(rx, noneOk, allOk) {
		return isEntity(rx, noneOk, allOk);
	}

	function isCE(ce, noneOk, allOk) {
		return isEntity(ce, noneOk, allOk);
	}

	function isTPA(ce, noneOk, allOk) {
		return isEntity(ce, noneOk, allOk);
	}


	function isVEN(ven, noneOk, allOk) {
		return isEntity(ven, noneOk, allOk);
	}


	/**
	 *    WINDOW SUPPORT
	 */

	function blobSupported() {

		// both pdf and Excel file generation depends on the browser supporting window.Blob feature

		if(!!window.Blob) {

			try {
				var testBlob = new window.Blob(['<p>test</p>'], {type: 'text/html'});
				if(!!testBlob) {
					return true;
				}
			}
			catch(err) {
				// do nothing
			}
		}

		return false;
	}

	function uploadSupported() {

		// file upload depends on browser supporting specific window libraries

		if(typeof(window.File) === 'undefined' ||
			typeof(window.FileReader) === 'undefined' ||
			typeof(window.FileList) === 'undefined' ||
			typeof(window.Blob) === 'undefined' ||
			typeof(window.FormData) === 'undefined') {
				return false;
		}

		return true;
	}

	// validating characters
	function hasUpperCaseLetter(val) {
		if(!isText(val)) {
			return false;
		}
		var regex = /[A-Z]/;
		return regex.test(val);
	}
	function hasLowerCaseLetter(val) {
		if(!isText(val)) {
			return false;
		}
		var regex = /[a-z]/;
		return regex.test(val);
	}
	function hasSymbol(val) {
		if(!isText(val)) {
			return false;
		}
		var regex = /[\W]/;
		return regex.test(val);
	}
	function hasNumber(val) {
		if(!isText(val)) {
			return false;
		}
		var regex = /[0-9]/;
		return regex.test(val);
	}
	function hasSpace(val) {
		if(!isText(val)) {
			return false;
		}
		var regex = /[\s]/;
		return regex.test(val);
	}
}
 
/**
 *    VIEW MODELS
 *    app-wide base view model structures
 *    each feature may extend these
 */

vmSvc.$inject = ['appConst', 'utilSvc', 'validSvc'];
angular
.module('espui.core')
.factory('vmSvc', vmSvc);

/* @ngInject */
function vmSvc(appConst, utilSvc, validSvc) {

    var vm = {
        api: {
            paging: apiGetPaging,
            sortBy: apiSortBy
        },
        ui: {
            paging: uiGetPaging
        }
    };

    return vm;

    /**
     *    API GET PARAM VM
     *    most get queries have a list of params
     */

    function apiGetParam(name, val) {
        return {
            Field: name,
            Value: val
        };
    }


    /**
     *    API GET LIST VM
     */

    function apiGetList() {

        return {
            Auth: {
                CE: 'NONE',
                RX: 'NONE'
            },
            Params: [],
            Paging: {
                Size: appConst.pagingSize
            },
            SortBy: {
                Field: '',
                Order: 'ASC'
            }
        };

    }


    /**
     *    API GET DETAIL VM
     */

    function apiGetDetail() {

        return {
            Params: []
        };

    }


    /**
     *    PAGING
     */

    function apiGetPaging() {

        return {
            Size: appConst.app.query.pagingSize, // max records to return
            TooMany: false
        };

    }

    function uiGetPaging() {

        return {
            Page: 1, // current page
            Size: appConst.app.display.pagingSize, // UI max rows to display for ui list
            Total: 1, // total pages
            TooMany: false // too many rows returned from server
        };

    }


    /**
     *    SORT BY
     */

    function apiSortBy(field, order) {
        return {
            Field: validSvc.isText(field) ? field : '',
            Order: order == 'DSC' ? 'DSC' : 'ASC'
        };
    }

}
 
mainCtl.$inject = ['$rootScope', '$scope', '$state', 'validSvc'];
angular
.module('espui.shared')
.controller('MainCtl', mainCtl);


/* @ngInject */
function mainCtl($rootScope, $scope, $state, validSvc) {

	/*jshint validthis: true */
	var vmMain = this;

	// properties
	vmMain.icon = '';
	vmMain.title = '';
	vmMain.bkgHeight = '3rows';
	vmMain.breadcrumb = null;
	vmMain.destroyEvents = [];

	// ui methods
	vmMain.routeToBreadcrumb = routeToBreadcrumb;

	init();

	function init() {

		// load main route info
		var info = $state.current.routeInfo;
		if(!!info) {

			applyRouteInfo({
				title: info.title,
				icon: info.icon,
				bkgHeight: info.bkgHeight,
				breadcrumb: info.breadcrumb,
				destroyEvent: info.destroyEvent
			});

		}

	}


	/**
	 *    FEATURE HOOK
	 *    apply route info for this feature
	 *    note: child features may or may not choose to apply this to main
	 */

	$scope.$on('shared.main.setInfo', function(event, info) {
		event.stopPropagation();

		if(!!info) {
			applyRouteInfo({
				icon: info.icon,
				title: info.title,
				bkgHeight: info.bkgHeight,
				breadcrumb: info.breadcrumb,
				destroyEvent: info.destroyEvent
			});
		}

	});


	/**
	 *    DESTROY HOOK
	 *    when moving from feature to feature the main feature parent is destroyed
	 *    on destroy some features need to clean out their repository data cache
	 */

	$scope.$on('$destroy', function() {
		for(var i = 0; i < vmMain.destroyEvents.length; i++) {
			$rootScope.$emit(vmMain.destroyEvents[i], {});
		}
	});


	/**
	 *    BREADCRUMB ROUTE
	 */

	function routeToBreadcrumb() {

		if(!vmMain.breadcrumb || !validSvc.isText(vmMain.breadcrumb.route)) {
			throw new Error('sharedMainCtl.routeTo, bread crumb route is missing');
		}

		$state.go(vmMain.breadcrumb.route, vmMain.breadcrumb.routeData);

	}


	/**
	 *    HELPERS
	 */

	function applyRouteInfo(routeInfo) {

		// override vmMain properties (if exists)

		// icon
		if(validSvc.isText(routeInfo.icon)) {
			vmMain.icon = routeInfo.icon;
		}

		// title
		if(validSvc.isText(routeInfo.title)) {
			vmMain.title = routeInfo.title;
		}

		// background height (each feature can have a different filter box height)
		if(validSvc.isText(routeInfo.bkgHeight)) {
			vmMain.bkgHeight = routeInfo.bkgHeight;
		}
		else {
			vmMain.bkgHeight = '3rows';
		}

		// breadcrumb - needs .icon + .route + .msg
		vmMain.breadcrumb = parseBreadcrumb(routeInfo.breadcrumb);

		// destroy event
		if(validSvc.isText(routeInfo.destroyEvent)) {
			vmMain.destroyEvents.push(routeInfo.destroyEvent);
		}

	}

	function parseBreadcrumb(crumb) {

		if(!!crumb && validSvc.isText(crumb.icon) && validSvc.isText(crumb.msg) && validSvc.isText(crumb.route)) {

			// has route data?
			var routeData = {};
			if(!!crumb.routeData) {
				routeData = angular.fromJson(angular.toJson(crumb.routeData)); // by val
			}

			return {
				icon: crumb.icon,
				msg: crumb.msg,
				route: crumb.route,
				routeData: routeData
			};
		}
		else {
			return null;
		}
	}

}
 
HomeController.$inject = ['$rootScope', '$scope', '$window', '$anchorScroll', '$timeout', '$state', 'numberFilter', 'chartRepo', 'sessionRepo', 'prefsRepo', 'appConst', 'utilSvc', 'validSvc', 'msgSvc', 'errSvc'];
angular
.module('espui.home')
.controller('HomeController', HomeController);

/* @ngInject */
function HomeController($rootScope, $scope, $window, $anchorScroll, $timeout, $state, numberFilter, chartRepo, sessionRepo, prefsRepo, appConst, utilSvc, validSvc, msgSvc, errSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _waitMgrRunning = false,
		_waitList = [],
		_layoutWidth = 0,
		_chartColors = appConst.app.color.chartBars($window.espuiPrefs.skin),
		_pendingDashboard = null,
		_browserWidthTimer = null,
		_lazyLoad = true;

	// props
	vm.action = '';
	vm.userType = '';
	vm.init = true;
	vm.isImpersonate = false;

	// charts
	vm.chartTemplates = {};
	vm.charts = {};

	// query methods
	vm.queryChange = queryChange;
	vm.querySubmit = querySubmit;
	vm.queryEdit = queryEdit;

	// link to feature
	vm.linkToFeature = linkToFeature;

	// setup
	vm.setupToggle = setupToggle;

	// default CE/RX
	vm.defaultCE = '';
	vm.defaultRX = '';

	// dashboard CE/RX
	vm.dashCE = {};
	vm.dashRX = {};
	vm.dashCeDroplist = [];
	vm.dashRxDroplist = [];
	vm.dashChangeCE = dashChangeCE;
	vm.dashChangeRX = dashChangeRX;
	vm.dashRefresh = dashRefresh;

	// dashboard
	vm.nodashMsg = '';
	vm.layoutRows = [];
	vm.saveDashboard = saveDashboard;
	vm.clearDashboard = clearDashboard;

	// scroll
	vm.scrollEvent = scrollEvent;

	// user review
	vm.userReview = {Items:[], DueDate:null};
	vm.userReviewClick = userReviewClick;


	/**
	 *    DESTROY
	 *    release chartRepo cached data
	 */
	$scope.$on('$destroy', function() {
		reset();
	});

	function reset() {
		if(_browserWidthTimer !== null) {
			$timeout.cancel(_browserWidthTimer);
			_browserWidthTimer = null;
		}
		vm.action = '';
		_waitList = [];
		vm.charts = {};
		vm.chartTemplates = {};
		vm.layoutRows = [];
		chartRepo.reset();
	}


	/**
	 *    INIT
	 */

	init();

	function init() {
		//console.log('HOME INIT');

		vm.init = true;
		vm.isImpersonate = !!$scope.User.Impersonate;

		// dump anything previously running
		reset();

		// scroll to top of page
		$anchorScroll.yOffset = 0;
		$anchorScroll();

		// let page render and scroll, then continue to init
		$timeout(function() {
			vm.init = false;
			initReleaseNotes();
			if(!showReviewUsers($rootScope.User)) {
				initDo();
			}
		}, 300);
	}

	function showReviewUsers() {
		// if user is supervisor, show anyone they need to review

		var usr = $rootScope.User || {};
		if(Array.isArray(usr.UsersToReview) && usr.UsersToReview.length > 0) {
			// already seen this prompt today?
			var userReviewSeen = sessionRepo.getLocalStoreKey('user_review_seen');
			if(!!userReviewSeen && userReviewSeen.dateTxt == utilSvc.dt.toText(new Date())) {
				return false;
			}

			// find OVERDUE
			vm.userReview.isOverdue = false;
			usr.UsersToReview.forEach(function(user) {
				if(user.ReviewStatus == 'OVERDUE') {
					vm.userReview.isOverdue = true;
				}
			});

			// show users to review
			vm.userReview.Items = JSON.parse(JSON.stringify(usr.UsersToReview)); // de-ref
			vm.userReview.DueDate = usr.UsersToReviewDueDate;
			vm.action = 'REVIEW';
			return true;
		}

		return false;
	}

	function userReviewClick(choice) {
		// user clicked on review users prompt

		// hide prompt for today
		sessionRepo.setLocalStoreKey('user_review_seen', {dateTxt: utilSvc.dt.toText(new Date())});

		switch(choice) {
			case 'REVIEW':
				// go to user list to review
				var isVerity = $scope.User.Type == 'VERITY' || $scope.User.Type == 'VERITYSA';
				var reviewRoute = isVerity ? 'admin.user.list-review' : 'admin.user.list-customers-review';
				$state.go(reviewRoute, {}, {reload: reviewRoute});
				break;
			case 'CANCEL':
				// no review, build dashboard
				initDo();
				break;
			default:
				throw new Error('homeCtl.userReviewClick, unknown choice: ' + choice);
		}
	}

	function initDo() {

		// user specific type, affs and rx models
		vm.userType = getChartClaim($scope.User.Features);
		var affs = getAffs();
		var rxModelList = utilSvc.aff.rxModelList(affs);

		// NODASH: user setup does not allow any charts
		if(vm.userType === '' || affs.length < 1 || rxModelList.length < 1) {
			vm.nodashMsg = '';
			vm.action = 'NODASH';
			return;
		}

		// init dashboard
		vm.dashCE = validSvc.newProp('NONE');
		vm.dashRX = validSvc.newProp('NONE');
		vm.dashCeDroplist = utilSvc.aff.ceDroplist(affs);
		vm.dashRxDroplist = utilSvc.ng.droplistNONE();
		
		try {

			// get chart templates available for this user
			vm.chartTemplates = getChartTemplates(vm.userType, rxModelList);
			if(vm.chartTemplates === null) {
				vm.nodashMsg = 'No charts exist for this combination of user type, Facility and Pharmacy';
				vm.action = 'NOCHARTS';
				return;
			}

			// load saved dashboard from scope.User.Dashboard
			var dashboard = loadDashboard(affs, rxModelList, $scope.User.Dashboard, vm.chartTemplates);
			if(!dashboard.valid) {
				vm.action = 'PROMPT';
				return;
			}

			// get CE/RX from dashboard, revalidate them
			vm.dashCE.val = dashboard.CE;			
			vm.dashRX.val = dashboard.RX;
			dashChangeCE();
			if(vm.dashCE.fail == 'yes' || vm.dashRX.fail == 'yes') {
				vm.action = 'PROMPT';
				return;
			}

			// build final dashboard layout with dyanmic queries
			vm.layoutRows = buildFinalLayout(dashboard.rows, affs, vm.chartTemplates);
		}
		catch(err) {
			reset();
			vm.nodashMsg = 'Unexpected dashboard error: ' + err.message;
			vm.action = 'NOCHARTS';
			return;
		}

		_layoutWidth = $window.innerWidth;
		vm.action = 'LAYOUT';

		// pause then load data
		_browserWidthTimer = $timeout(function() {
			waitListManager();
			checkBrowserWidth();
		}, 300);

	}

	function getAffs() {
		var affs = utilSvc.aff.findStatus($scope.User.AffList);
		return utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
	}


	/**
	 *    CHART INIT
	 */

	function getChartClaim(features) {

		// loop features from login
		for(var i = 0; i < features.length; i++) {
			if(features[i].Name == 'widget.verity') {
				return 'VERITY';
			}
			else if(features[i].Name == 'widget.ce') {
				return 'CE';
			}
			else if(features[i].Name == 'widget.rx') {
				return 'RX';
			}

		}

		// no widget features found
		return '';

	}

	function getChartTemplates(uType, rxModelList) {

		// get all chart templates available based on user type and aff rx biz models

		var result = {},
			hasCP = rxModelList.indexOf('CP') > -1,
			hasCPTPA = rxModelList.indexOf('CPTPA') > -1,
			hasSPLIT = rxModelList.indexOf('SPLIT') > -1,
			hasSPLITMATCH = rxModelList.indexOf('SPLITMATCH') > -1;

		// no charts?
		if(!validSvc.isText(uType) || rxModelList.length < 1 || (!hasCP && !hasCPTPA && !hasSPLIT && !hasSPLITMATCH)) {
			return null;
		}

		switch(uType) {

			case 'VERITY':
			case 'CE':

				if(hasCP) {
					result.DISPENSE_FEES = {title: 'Pharmacy Dispense Fees', rxBizModels: ['CP'], props:['CE', 'Weeks'],
						defaults: {affType: '', fixedWidth: 0, Weeks:8, WeeksList:[2,3,4,5,6,7,8,9,10,11,12]}, init: initDispenseFees};
				}

				if(hasCP || hasCPTPA) {
					result.TOP_DRUGS = {title: 'Top Contract Pharmacy NDCs', rxBizModels: ['CP', 'CPTPA'], props:['CE', 'Weeks'],
						defaults: {affType: '', fixedWidth: 0, Weeks:8, WeeksList:[2,3,4,5,6,7,8,9,10,11,12]}, init: initTopDrugs};

					result.CONTRACT_SAVE = {title: 'Contract Pharmacy 340B Savings', rxBizModels: ['CP', 'CPTPA'], props:['CE', 'Weeks'],
						defaults: {affType: '', fixedWidth: 0, Weeks:8, WeeksList:[2,3,4,5,6,7,8,9,10,11,12]}, init: initContractSave};
				}

				if(hasCP || hasCPTPA || hasSPLITMATCH) {
					result.MATCH_ELIG = {title: 'Match Eligibility Ratio', rxBizModels: ['CP', 'CPTPA', 'SPLITMATCH'], props:['CE', 'Weeks'],
						defaults: {affType: '', fixedWidth: 33, Weeks:2, WeeksList:[1,2,3,4]}, init: initMatchElig};
					result.MATCH_VISIT = {title: 'Match to Patient Visit Ratio', rxBizModels: ['CP', 'CPTPA', 'SPLITMATCH'], props:['CE', 'Weeks'],
						defaults: {affType: '', fixedWidth: 0, Weeks:8, WeeksList:[2,3,4,5,6,7,8,9,10,11,12]}, init: initMatchVisit};
				}

				if(hasSPLIT) {
					result.TOP_UNKNOWN = {title: 'Top Unknown Item Codes', rxBizModels: ['SPLIT'], props:['CE', 'RX', 'Weeks'],
						defaults: {affType: 'CERX', fixedWidth: 0, Weeks: 1, WeeksList: [1,2,3,4]}, init: initTopUnknown};
				}

				if(hasSPLIT || hasSPLITMATCH) {
					result.SPLIT_SPEND = {title: 'Split Order Spending', rxBizModels: ['SPLIT', 'SPLITMATCH'], props:['CE', 'RX', 'Weeks'],
						defaults: {affType: 'CERX', fixedWidth: 33, Weeks: 2, WeeksList: [1,2,3,4]}, init: initSplitSpend};
					result.NDC_HIGH_WAC = {title: 'Top Remainder Spend NDCs', rxBizModels: ['SPLIT', 'SPLITMATCH'], props:['CE', 'Weeks'],
						defaults: {affType: '', fixedWidth: 0, Weeks:2, WeeksList:[1,2,3,4]}, init: initNdcHighWac};
					result.WACREM_SPEND = {title: 'Split Order Remainder Spend Percent', rxBizModels: ['SPLIT', 'SPLITMATCH'], props:['CE', 'RX', 'Weeks'],
						defaults: {affType: 'CERX', fixedWidth: 0, Weeks: 8, WeeksList: [2,3,4,5,6,7,8,9,10,11,12]}, init: initWacRemSpend};
				}
				break;

			case 'RX':
				// TBD
				return null;

			default:
				errSvc.warn('unknown user type: ' + uType, 'homeCtl.getChartTemplates');
		}

		return result;

	}


	/**
	 *    LOAD DASHBOARD
	 */

	function dashboardVM(dash) {
		dash = dash || {};
		return {
			CE: validSvc.isCE(dash.CE) ? dash.CE : 'NONE',
			RX: validSvc.isCE(dash.RX) ? dash.RX : 'NONE',
			rxBizModels: Array.isArray(dash.rxBizModels) ? dash.rxBizModels : [],
			rows: Array.isArray(dash.rows) ? dash.rows : [],
			valid: false
		};
	}

	function loadDashboard(affs, rxModelList, savedDash, chartTemplates) {
		// load saved dashbaord, if anything is invalid return empty VM

		var dash = dashboardVM(savedDash);

		// validate dash CE / RX
		var foundCERX = false;
		var ceAffs = utilSvc.aff.findCe(affs, dash.CE);
		if(validSvc.isCE(dash.CE)) {
			if(ceAffs.length > 0 && validSvc.isRX(dash.RX) && utilSvc.aff.findRx(ceAffs, dash.RX).length > 0) {
				foundCERX = true;
			}
		}

		// no CE/RX, rows or biz models
		if(!foundCERX || dash.rows.length < 1 || dash.rxBizModels.length < 1 || dash.rxBizModels.length != rxModelList.length) {
			return dashboardVM();
		}

		// biz models changed?
		rxModelList.sort();
		dash.rxBizModels.sort();
		for(var m = 0; m < rxModelList.length; m++) {
			if(dash.rxBizModels[m] != rxModelList[m]) {
				return dashboardVM();
			}
		}
		
		var rows = dash.rows,
			charts = [],
			chart = null,
			chartTemplate = null;

		for(var i = 0; i < rows.length; i++) {
			charts = Array.isArray(rows[i].charts) ? rows[i].charts : [];

			for(var ii = charts.length - 1; ii >= 0; ii--) {
				chart = charts[ii];

				if(!!chart && validSvc.isText(chart.type)) {
					chartTemplate = chartTemplates[chart.type];
					if(!!!chartTemplate) {
						// dump the dashboard if we hit an unknown template
						console.log('homeCtl.loadDashboard, unknown chart type: ' + chart.type);
						return dashboardVM();
					}

					// validate saved CE/RX, or replace
					chart.query.CE = validSvc.isCE(chart.query.CE) ? chart.query.CE : dash.CE;
					chart.query.RX = validSvc.isRX(chart.query.RX) ? chart.query.RX : dash.RX;
					if(!validChartCERX(chart, affs, chart.query.CE, chart.query.RX)) {
						chart.query.CE = '';
						chart.query.RX = '';
					}
				}
			}
		}

		dash.valid = true;
		return dash;
	}

	function setQueryPropsCERX(chart, affs, ceid, rxid) {

		var chartTemplate = vm.chartTemplates[chart.type];
		var chartDefaults = chartTemplate.defaults || {},
			chartAffs = utilSvc.aff.findRxModel(affs, chartTemplate.rxBizModels);

		// chart is affiliation type CERX or RXCE
		var isCERX = chartDefaults.affType == 'CERX',
			isRXCE = chartDefaults.affType == 'RXCE';

		var props = Array.isArray(chart.query.props) ? chart.query.props : [],
			prop = null;
		for (var i = 0 ; i < props.length; i++) {
			prop = props[i];
			if(prop.type == 'CE') {
				prop.val = ceid;
				if(isRXCE) {
					// CE list depends on RX choice
					prop.list = validSvc.isRX(rxid) ? utilSvc.aff.ceDroplist(chartAffs, rxid) : [];
				}
			}
			else if(prop.type == 'RX') {
				prop.val = rxid;
				if(isCERX) {
					// RX list depends on CE choice
					prop.list = validSvc.isCE(ceid) ? utilSvc.aff.rxDroplist(chartAffs, ceid) : [];
				}
			}
		}

		return props;
	}

	function validChartCERX(chart, affs, ceid, rxid) {

		// get chart config and affs
		var chartTemplate = vm.chartTemplates[chart.type];
		var chartDefaults = chartTemplate.defaults || {},
			chartAffs = utilSvc.aff.findRxModel(affs, chartTemplate.rxBizModels);

		// CE/RX are valid and exist in chart affiliations
		var validCE = validSvc.isCE(ceid) && utilSvc.aff.findCe(chartAffs, ceid).length > 0,
			validRX = validSvc.isRX(rxid) && utilSvc.aff.findRx(chartAffs, rxid).length > 0,
			valid = false;

		// chart is requires CE or RX, or is affiliation type CERX or RXCE
		var hasCE = chartTemplate.props.indexOf('CE') > -1,
			hasRX = chartTemplate.props.indexOf('RX') > -1,
			isCERX = chartDefaults.affType == 'CERX',
			isRXCE = chartDefaults.affType == 'RXCE';

		// test five cases below: CERX, RXCE, CE and RX, CE only, RX only
		
		if(isCERX) {
			// CE RX affiliation
			if(validCE) {
				var ceAffs = utilSvc.aff.findCe(chartAffs, ceid);
				return utilSvc.aff.findRx(ceAffs, rxid).length > 0;
			}
		}
		else if(isRXCE) {
			// RX CE affiliation
			if(validRX) {
				var rxAffs = utilSvc.aff.findRx(chartAffs, rxid);
				return utilSvc.aff.findCe(rxAffs, ceid).length > 0;
			}
		}
		else {
			valid = hasCE ? validCE : true;
			if(valid) {
				valid = hasRX ? validRX : true;
			}
		}

		return valid;
	}


	/**
	 *    DEFAULT DASHBOARD LAYOUTS
	 */

	function defaultDashboardRows(userType, dash) {

		// user has no saved layout, use this default layout by user type
		
		var rows = [],
			ceid = dash.CE,
			rxid = dash.RX,
			hasCP = dash.rxBizModels.indexOf('CP') > -1,
			hasCPTPA = dash.rxBizModels.indexOf('CPTPA') > -1,
			hasSPLIT = dash.rxBizModels.indexOf('SPLIT') > -1,
			hasSPLITMATCH = dash.rxBizModels.indexOf('SPLITMATCH') > -1;

		var hasCPorCPTPA = hasCP || hasCPTPA,
			hasSPLITorSPLITMATCH = hasSPLIT || hasSPLITMATCH;

		switch(userType) {

			case 'VERITY':
			case 'CE':

				if(hasSPLITorSPLITMATCH && !hasCPorCPTPA) {

					// splitting user, no CP

					if(hasSPLIT) {
						// SPLIT: +TOP_UNKNOWN
						rows.push(addDefaultRow(['WACREM_SPEND', 'TOP_UNKNOWN'], ceid, rxid));
						rows.push(addDefaultRow(['NDC_HIGH_WAC', 'SPLIT_SPEND'], ceid, rxid)); // SS PIE
					}
					else {
						// SPLITMATCH: +MATCH_ELIG, +MATCH_VISIT
						rows.push(addDefaultRow(['WACREM_SPEND', 'SPLIT_SPEND'], ceid, rxid)); // SS PIE
						rows.push(addDefaultRow(['NDC_HIGH_WAC'], ceid, rxid));
						rows.push(addDefaultRow(['MATCH_VISIT', 'MATCH_ELIG'], ceid, rxid)); // ME PIE
					}

				}
				else if(hasCPorCPTPA && !hasSPLITorSPLITMATCH) {

					// CP user, no splitting

					rows.push(addDefaultRow(['CONTRACT_SAVE', 'MATCH_VISIT'], ceid, rxid));
					rows.push(addDefaultRow(['MATCH_ELIG', 'TOP_DRUGS'], ceid, rxid)); // ME PIE

					if(hasCP) {
						// CP: +DISPENSE_FEES
						rows.push(addDefaultRow(['DISPENSE_FEES'], ceid, rxid)); // 100% width
					}

				}
				else if(hasCPorCPTPA && hasSPLITorSPLITMATCH) {

					// user has both SPLIT and CP models

					if(hasSPLIT) {
						// SPLIT: +TOP_UNKNOWN
						rows.push(addDefaultRow(['WACREM_SPEND', 'TOP_UNKNOWN'], ceid, rxid));
						rows.push(addDefaultRow(['CONTRACT_SAVE', 'MATCH_VISIT'], ceid, rxid));
						rows.push(addDefaultRow(['NDC_HIGH_WAC', 'SPLIT_SPEND'], ceid, rxid)); // SS PIE
						rows.push(addDefaultRow(['MATCH_ELIG', 'TOP_DRUGS'], ceid, rxid)); // ME PIE
						if(hasCP) {
							// CP: +DISPENSE_FEES
							rows.push(addDefaultRow(['DISPENSE_FEES'], ceid, rxid)); // DISP CP ONLY
						}
					}
					else {
						// SPLITMATCH: +MATCH_ELIG, +MATCH_VISIT
						rows.push(addDefaultRow(['WACREM_SPEND', 'SPLIT_SPEND'], ceid, rxid)); // SS PIE
						rows.push(addDefaultRow(['CONTRACT_SAVE', 'MATCH_VISIT'], ceid, rxid));
						if(hasCP) {
							// CP: +DISPENSE_FEES
							rows.push(addDefaultRow(['NDC_HIGH_WAC', 'TOP_DRUGS'], ceid, rxid));
							rows.push(addDefaultRow(['MATCH_ELIG', 'DISPENSE_FEES'], ceid, rxid)); // ME PIE
						}
						else {
							rows.push(addDefaultRow(['NDC_HIGH_WAC', 'MATCH_ELIG'], ceid, rxid)); // ME PIE
							rows.push(addDefaultRow(['TOP_DRUGS'], ceid, rxid));
						}
					}

				}

				/* Verity: add more charts TBD
				if(isVerity) {
				}
				*/

				break;

			case 'RX':
				/* RX dashboard TBD
				*/

				break;

			default:
				throw new Error('homeCtl.initCharts, unknown chart mode: ' + userType);
		}

		return rows;

	}

	function addDefaultRow(newCharts, ceid, rxid) {

		// create a layout row with default chart values

		var newRow = {charts:[]},
			newChart = null;

		for(var i = 0; i < newCharts.length; i++ ) {

			newChart = {type: newCharts[i], query: {CE: ceid}};

			switch(newCharts[i]) {

				case 'DISPENSE_FEES':
				case 'TOP_DRUGS':
				case 'CONTRACT_SAVE':
				case 'MATCH_VISIT':
					// CE + 8 Weeks
					newChart.query.Weeks = 8;
					break;

				case 'NDC_HIGH_WAC':
					// CE + 2 Weeks
					newChart.query.Weeks = 2;
					break;

				case 'WACREM_SPEND':
					// CE + RX + 8 Weeks
					newChart.query.RX = rxid;
					newChart.query.Weeks = 8;
					break;

				case 'TOP_UNKNOWN':
					// CE + RX + 1 Weeks
					newChart.query.RX = rxid;
					newChart.query.Weeks = 1;
					break;

				case 'SPLIT_SPEND':
					newChart.query.RX = rxid;
					newChart.query.Weeks = 2;
					break;
				case 'MATCH_ELIG':
					// PIE CHART: CE + 2 Weeks
					newChart.query.Weeks = 2;
					break;

				default:
					errSvc.warn('unknown chart type: ' + newCharts[i], 'homeCtl.defaultDashboardRows');
					continue;
			}

			newRow.charts.push(newChart);

		}

		return newRow;

	}

	function buildFinalLayout(dashRows, affs, chartTemplates) {
		// init each chart and add to final layout rows

		dashRows = Array.isArray(dashRows) ? dashRows : [];
		var result = [],
			chartId = '',
			flexWidth = 100,
			savedChart = null,
			chartTemplate = null,
			chartWidth = 0,
			querySpec = null;

		// loop rows
		for(var i = 0; i < dashRows.length; i++) {
			result.push({charts:[]});

			// flexible chart widths
			flexWidth = deriveChartFlexWidth(dashRows[i], chartTemplates);
			if(flexWidth <= 0) {
				errSvc.warn('SavedLayout for chart row: ' + (i + 1).toString() + ' fixedWidth is not compatible with chart count: ' + dashRows[i].charts.length);
				continue;
			}

			// loop charts
			for(var ii = 0; ii < dashRows[i].charts.length; ii++) {

				savedChart = dashRows[i].charts[ii];
				chartTemplate = chartTemplates[savedChart.type];

				// build dynamic query
				querySpec = queryBuilder(
					chartTemplate.props,
					savedChart.query,
					chartTemplate.defaults,
					utilSvc.aff.findRxModel(affs, chartTemplate.rxBizModels));

				// add to controller
				chartId = savedChart.type + '_R' + i.toString() + '_C' + ii.toString();
				chartWidth = chartTemplate.defaults.fixedWidth > 0 ? chartTemplate.defaults.fixedWidth : flexWidth;
				vm.charts[chartId] = chartTemplate.init(savedChart.type, chartTemplate.title, chartId, chartWidth, querySpec);

				// affiliate validation
				if(querySpec.affType == 'CERX') {
					queryChange(chartId, 'CE', true);
				}
				if(querySpec.affType == 'RXCE') {
					queryChange(chartId, 'RX', true);
				}
				updateChartText(chartId);

				// if valid, add to data waitlist
				if(vm.charts[chartId].queryValid(vm.charts[chartId].query)) {

					// load only first two rows on initial page load (lazyLoad = true)
					if(i < 2 || !_lazyLoad) {
						waitListAdd(chartId);
					}
				}

				// add to render layout
				result[i].charts.push(vm.charts[chartId]);

			}
		}

		return result;

	}


	/**
	 *    DASHBOARD SETUP AND CONFIG
	 */

	function setupToggle() {

		// toggle in and out of SETUP mode
		if(vm.action != 'SETUP') {
			vm.action = 'SETUP';
		}
		else {
			init();
		}

	}

	function saveDashboard() {
		if(vm.isWaiting) {
			return;
		}

		// revalidate
		vm.dashCE.fail = validSvc.isCE(vm.dashCE.val) ? 'no' : 'yes';
		vm.dashRX.fail = validSvc.isRX(vm.dashRX.val) ? 'no' : 'yes';
		if(vm.dashCE.fail == 'yes' || vm.dashRX.fail == 'yes') {
			msgSvc.ok('Cannot Save', 'Choose a Facility and Pharmacy');
			return;
		}

		var affs = getAffs();
		var dash = dashboardVM({
			CE: vm.dashCE.val,
			RX: vm.dashRX.val,
			rxBizModels: utilSvc.aff.rxModelList(affs)
		});

		// setup default dashboard rows + layout
		if(vm.action == 'SETUP') {
			var defaultRows = defaultDashboardRows(vm.userType, dash);
			if(defaultRows < 1) {
				vm.nodashMsg = 'No chart options exist for this combination of Facility and Pharmacy';
				vm.action = 'NOCHARTS';
				return;
			}
	
			// build final dash layout with dyanmic queries
			vm.layoutRows = buildFinalLayout(defaultRows, affs, vm.chartTemplates);
			vm.action = 'RESAVE';
		}

		// pack layout into save format
		var rows = vm.layoutRows,
			chart = null,
			query = null;
		for(var i = 0; i < rows.length; i++) {
			dash.rows.push({charts:[]});

			for(var ii = 0; ii < rows[i].charts.length; ii++) {
				chart = rows[i].charts[ii];

				// remove CE/RX defaults before saving
				query = flattenQueryProps(chart.query.props);
				if(query.CE == dash.CE) {
					query.CE = '';
				}
				if(query.RX == dash.RX) {
					query.RX = '';
				}

				dash.rows[i].charts.push({type: chart.type, query: query});
			}
		}

		_pendingDashboard = dash;

		// do not save if impersonating
		if(vm.isImpersonate) {
			msgSvc.ok('Dashboard Emulated', 'Dashboard is shown as emulated but is NOT saved.');
			okSaveDash({});
		}
		else {
			prefsRepo.save('DASHBOARD', angular.toJson(dash)).then(okSaveDash, errSaveDash);
		}

		function okSaveDash(r) {

			// update session and rootScope
			$rootScope.User.Dashboard = _pendingDashboard;
			sessionRepo.set('User', $rootScope.User);

			vm.isWaiting = false;

			// RESAVE triggers a complete restart
			if(vm.action == 'RESAVE') {
				init();
			}
			else {
				msgSvc.ok('Dashboard Saved', 'Settings are saved');
			}

		}

		function errSaveDash(r) {
			vm.isWaiting = false;

			if(r === null) {
				return;
			}

			errSvc.error('Unknown api error during save', 'homeCtl.saveDashboard', r.status, utilSvc.http.safeResponse(r));
		}

	}

	function clearDashboard() {

		// clear dashboard

		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;

		// do not save if impersonating
		if(vm.isImpersonate) {
			msgSvc.ok('Dashboard Emulated', 'Dashboard is cleared as emulated but is NOT saved.');
			okClearDash({});
		}
		else {
			prefsRepo.save('DASHBOARD', '{}').then(okClearDash, errClearDash);
		}

		function okClearDash(r) {
			vm.isWaiting = false;

			// update session and rootScope
			$rootScope.User.Dashboard = {};
			sessionRepo.set('User', $rootScope.User);

			init();

		}

		function errClearDash(r) {
			vm.isWaiting = false;

			if(r === null) {
				return;
			}

			errSvc.error('Unknown api error during save', 'homeCtl.clearDashboard', r.status, utilSvc.http.safeResponse(r));
		}

	}


	/**
	 *    WINDOW EVENTS
	 */

	function scrollEvent(scrollTop) {

		// load charts in row 3+ after user scrolls the window (lazy loading charts)
		//console.log(vm.action + ', scroll top: ' + scrollTop);

		if(vm.init) {
			return;
		}
		// lazy loading is still on
		if(_lazyLoad) {
			console.log('scroll event');
			_lazyLoad = false;

			if(vm.action == 'LAYOUT') {

				var	dashRows = Array.isArray(vm.layoutRows) ? vm.layoutRows : [],
					chartId = '',
					validCharts = false;

				// loop rows
				for(var i = 2; i < dashRows.length; i++) {

					// loop charts
					for(var ii = 0; ii < dashRows[i].charts.length; ii++) {
						chartId = dashRows[i].charts[ii].type + '_R' + i.toString() + '_C' + ii.toString();

						// if valid, add to data waitlist
						if(vm.charts[chartId].queryValid(vm.charts[chartId].query)) {
							validCharts = true;
							waitListAdd(chartId);
						}
					}
				}

				// added valid charts?
				if(validCharts) {
					waitListManager();
				}
			}
		}
	}

	function checkBrowserWidth() {

		// constantly running, notify charts if layout width has changed

		// stop if not in layout mode
		if(vm.action != 'LAYOUT') {
			return;
		}

		// check width if nothing else is running
		if(!vm.isWaiting && ($window.innerWidth < _layoutWidth - 10 || $window.innerWidth > _layoutWidth + 10)) {

			_layoutWidth = $window.innerWidth;

			// notify any rendered charts to redraw (no animation)
			var chart = null;
			for(var i = 0; i < vm.layoutRows.length; i++) {
				for(var ii = 0; ii < vm.layoutRows[i].charts.length; ii++) {

					chart = vm.layoutRows[i].charts[ii];
					if(chart.status == 'DRAW') {
						$scope.$broadcast('widget.chart.sync', {uniqueId: chart.id, render: 'now'});
					}

				}
			}

			// re-check quickly, user might be dragging
			_browserWidthTimer = $timeout(function() {
				checkBrowserWidth();
			}, 1000);

		}
		else {
			_browserWidthTimer = $timeout(function() {
				checkBrowserWidth();
			}, 5000);
		}

	}


	/**
	 *    DASHBOARD CE/RX
	 */

	function dashChangeCE() {
		if(vm.isWaiting) {
			return;
		}

		vm.dashCE.fail = validSvc.isCE(vm.dashCE.val) ? 'no' : 'yes';
		if(vm.dashCE.fail == 'yes') {
			vm.dashRX = validSvc.newProp('NONE');
			vm.dashRxDroplist = utilSvc.ng.droplistNONE();
			return;
		}

		// rx affs
		vm.dashRxDroplist = utilSvc.aff.rxDroplist(getAffs(), vm.dashCE.val);
		vm.dashRX = utilSvc.ng.droplistAutoselectYesNo(vm.dashRxDroplist, vm.dashRX.val);

		dashChangeRX(vm.action == 'LAYOUT');
	}

	function dashChangeRX(doRefresh) {
		if(vm.isWaiting) {
			return;
		}

		vm.dashRX.fail = validSvc.isRX(vm.dashRX.val) ? 'no' : 'yes';
		if(!!doRefresh && vm.dashCE.fail == 'no' && vm.dashRX.fail == 'no') {
			dashRefresh();
		}
	}

	function dashRefresh() {
		console.log('dash refresh, waiting: ' + vm.isWaiting);
		if(vm.isWaiting) {
			return;
		}

		if(vm.dashCE.fail == 'yes' || vm.dashRX.fail == 'yes') {
			msgSvc.ok('Cannot Refresh', 'Facility and Pharmacy required');
			return;
		}
				
		msgSvc.confirm({
			id: 'dash.refresh',
			title: 'Refresh Dashboard',
			msg: 'Apply ' + vm.dashCE.val + ' / ' + utilSvc.ng.droplistLabel(vm.dashRxDroplist, vm.dashRX.val) + ' to all charts?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmDashRefresh, confirmDashRefresh);
	}

	function confirmDashRefresh(r) {
		if(vm.isWaiting || !!!r || r.result != 'YES') {
			return;
		}
	
		var affs = getAffs(),
			rows = vm.layoutRows,
			charts = [],
			chart = null;

		for(var i = 0; i < rows.length; i++) {
			charts = Array.isArray(rows[i].charts) ? rows[i].charts : [];

			for(var ii = charts.length - 1; ii >= 0; ii--) {
				chart = charts[ii];

				// new CE/RX can be applied
				if(validChartCERX(chart, affs, vm.dashCE.val, vm.dashRX.val)) {
					chart.query.props = setQueryPropsCERX(chart, affs, vm.dashCE.val, vm.dashRX.val);

					updateChartText(chart.id);
					queryEdit(chart.id);

					// if valid, re-get data
					if(chart.queryValid(chart.query)) {
						querySubmit(chart.id);
					}					
				}
				else {
					queryEdit(chart.id);
				}
			}
		}
	}


	/**
	 *    USER CHART EVENTS
	 */

	function queryChange(chartId, propType, noTextorValidation) {

		// handle affiliation changes and validate chart query

		var chartEdit = vm.charts[chartId];

		// affiliation prop change requires modifying its dependent, CE-->RX or RX-->CE
		if((chartEdit.query.affType == 'CERX' && propType == 'CE') || (chartEdit.query.affType == 'RXCE' && propType == 'RX')) {

			var props = chartEdit.query.props,
				ceid = '',
				ceIdx = -1,
				rxid = '',
				rxIdx = -1;

			// find CE and RX in props array
			for(var i = 0; i < props.length; i++) {
				if(props[i].type == 'CE') {
					ceid = props[i].val;
					ceIdx = i;
				}
				else if(props[i].type == 'RX') {
					rxid = props[i].val;
					rxIdx = i;
				}
			}
			if(ceIdx < 0 || rxIdx < 0) {
				errSvc.warn('Query change for affiliation did not find query ce and rx props', 'homeCtl.queryChange');
				return;
			}

			var affOptions = [];
			if(propType == 'CE') {

				// ce changed, manipulate rx
				if(validSvc.isCE(ceid)) {
					affOptions = utilSvc.aff.rxOptions(chartEdit.query.affs, ceid);
					props[rxIdx].list = utilSvc.ng.droplist(affOptions);
					if(!validSvc.isRX(rxid) || affOptions.indexOf(rxid) < 0) {
						if(affOptions.length === 1) {
							props[rxIdx].val = affOptions[0];
						}
						else if(validSvc.isRX(vm.defaultRX) && affOptions.indexOf(vm.defaultRX) > -1) {
							props[rxIdx].val = vm.defaultRX;
						}
						else {
							props[rxIdx].val = '';
						}
					}
				}
				else {
					props[rxIdx].list = [];
					props[rxIdx].val = '';
				}
			}
			else if(propType == 'RX') {

				// rx changed, manipulate ce
				if(validSvc.isRX(rxid)) {
					affOptions = utilSvc.aff.ceOptions(chartEdit.query.affs, rxid);
					props[ceIdx].list = utilSvc.ng.droplist(affOptions);
					if(!validSvc.isCE(ceid) || affOptions.indexOf(ceid) < 0) {
						if(affOptions.length === 1) {
							props[ceIdx].val = affOptions[0];
						}
						else if(validSvc.isCE(vm.defaultCE) && affOptions.indexOf(vm.defaultCE) > -1) {
							props[ceIdx].val = vm.defaultCE;
						}
						else {
							props[ceIdx].val = '';
						}
					}
				}
				else {
					props[ceIdx].list = [];
					props[ceIdx].val = '';
				}
			}
		}

		if(!!!noTextorValidation) {
			validChartQuery(chartId);
			updateChartText(chartId);
		}

	}

	function validChartQuery(chartId) {
		return vm.charts[chartId].queryValid(vm.charts[chartId].query);
	}

	function querySubmit(chartId) {

		// user clicked submit button

		if(validChartQuery(chartId)) {
			waitListAdd(chartId, true);

			// clear chart
			$scope.$broadcast('widget.chart.sync', {uniqueId: chartId, render: ''});

		}
		else {
			msgSvc.ok('Cannot Load Chart', 'Check filter values.');
		}

		updateChartText(chartId);

	}

	function queryEdit(chartId) {

		// clear chart
		$scope.$broadcast('widget.chart.sync', {uniqueId: chartId, render: ''});

		vm.charts[chartId].panelMode = '';
		vm.charts[chartId].status = 'EDIT';
	}


	/**
	 *    TOP DRUGS: VBAR CHART
	 *    top NDC drugs with highest savings
	 */

	function initTopDrugs(type, title, id, width, query) {

		// vertical bars
		// y-axis: savings dollars
		// x-axis: ndc drug names
		// note: date range default is 8 weeks

		return {
			id: id,
			type: type,
			status: 'EDIT',
			panelMode: '',
			layoutWidth: width,
			config: {
				chartType: 'VBAR',
				colors: _chartColors,
				yAxis: {
					showText: width >= 33,
					format: 'currency'
				},
				xAxis: {
					showText: true,
					verticalText: true
				},
				label: {
					width: width >= 33 ? 300 : 250,
					height: 60,
					lines: [
						{title: 'Savings', dataProp: 'lblSavings'},
						{title: 'NDC', dataProp: 'lblItemCode'},
						{title: 'Name', dataProp: 'desc'}
					]
				}
			},
			display: {
				title: title,
				footer: '',
				info: [
					'Savings are calculated as the difference between 340B and pharmacy acquisition cost across all contract pharmacy relationships.',
					'Totals do not include fees.'
				],
				footerFmt: footerFmtCeWeeks
			},
			query: query,
			queryValid: queryValidator,
			data: [],
			dataParser: parseTopDrugs
		};

	}

	function parseTopDrugs(chart, data) {

		var series = [],
			seriesMax = data.length < 11 ? data.length : 10,
			desc = '',
			uniqueList = [];

		for(var i = 0; i < seriesMax; i++) {

			desc = shortenTextUnique(uniqueList, data[i].DrugName, 25);

			series.push({
				name: desc,
				val: data[i].TotalSavings,
				lblItemCode: data[i].ItemCode,
				lblSavings: '$' + numberFilter(data[i].TotalSavings, 2).toString(),
				desc: desc
			});
		}

		// render series
		chart.data = series;
		chart.status = 'RENDER';

	}


	/**
	 *    CONTRACT_SAVE: TREND LINE CHART
	 *    340B savings per week trend line
	 */

	function initContractSave(type, title, id, width, query) {

		// trend line
		// y-axis: savings dollars per week
		// x-axis: week dates
		// note: date range default is 8 weeks

		return {
			id: id,
			type: type,
			status: 'EDIT',
			panelMode: '',
			layoutWidth: width,
			config: {
				chartType: 'LINE',
				colors: _chartColors,
				yAxis: {
					showText: width >= 33,
					format: 'currency'
				},
				xAxis: {
					showText: true,
					interval: ''
				},
				label: {
					width: 75,
					height: 30,
					ln1: 'Savings',
					ln2: 'NDC',
					ln3: 'Name'
				}
			},
			display: {
				title: title,
				footer: '',
				info: [
					'Savings are calculated as the difference between 340B and pharmacy acquisition cost across all contract pharmacy relationships.',
					'Totals do not include fees.'
				],
				footerFmt: footerFmtCeWeeks
			},
			query: query,
			queryValid: queryValidator,
			data: [],
			dataParser: parseContractSave
		};

	}

	function parseContractSave(chart, data) {

		// get day of the week, set chart interval
		var dayInterval = utilSvc.dt.dayFullText(utilSvc.dt.zeroTime(new Date(data[0].WeekEnd)));
		chart.config.xAxis.interval = dayInterval;

		// parse into D3 format
		var series = [];
		for(var i = 0; i < data.length; i++) {
			series.push({
				date: utilSvc.dt.zeroTime(new Date(data[i].WeekEnd)),
				val: data[i].SavingsTotal
			});
		}

		// render series
		chart.data = series;
		chart.status = 'RENDER';

	}


	/**
	 *    MATCH_ELIG: PIE CHART
	 *    match eligibility ratio % this week
	 */

	function initMatchElig(type, title, id, width, query) {

		// pie chart
		// name: eligibility type
		// value: number of matches
		// percent: ratio of matches
		// note: date range default is 1 weeks 'This Week'

		return {
			id: id,
			type: type,
			status: 'EDIT',
			panelMode: '',
			layoutWidth: width,
			config: {
				chartType: 'PIE',
				colors: _chartColors,
				valFormat: 'number',
				donutHoleRadius: 0.4,
				label: {
					width: 50,
					height: 30
				}
			},
			display: {
				title: title,
				footer: '',
				info: [
					'Match percentages for eligible and ineligible matches. Matches are ineligible due to Medicaid, Written Date or OPA Start Date properties.'
				],
				footerFmt: footerFmtCeWeeks
			},
			query: query,
			queryValid: queryValidator,
			data: [],
			dataParser: parseMatchElig
		};

	}

	function parseMatchEligStatusFmt(name) {
		switch(name){
			case 'ELIGIBLE':
				return 'Eligible';
			case 'VISIT_PROXIMITY':
				return 'Written Date';
			case 'REASON_CONTRACT_DATE':
				return 'Opa Start Date';
			case 'EXCLUDED_PAYOR':
				return 'Medicaid';
			case 'GOV_MEDICAID':
				return 'Medicaid Gov';
			case 'BLOCKED_SCRIPT':
				return 'Rejected';
			case 'NO_AFFILIATION':
				return 'No Pharmacy';
			case 'PHA_INACTIVE':
				return 'Inactive';
			case 'EPRESCRIBE_NPI':
				return 'ePrescribe';
			default:
				return 'Misc';
		}
	}

	function parseMatchElig(chart, data) {

		// parse into D3 format
		var series = [],
			misc = {
				name: 'Misc',
				val: 0,
				percent: 0
			},
			nameTxt = '';

		for(var i = 0; i < data.length; i++) {

			nameTxt = parseMatchEligStatusFmt(data[i].Status);

			if(nameTxt == 'Misc' || data[i].Percent < 1) {
				misc.val += data[i].Count;
				misc.percent += data[i].Percent;
			}
			else {
				series.push({
					name: nameTxt,
					val: data[i].Count,
					percent: data[i].Percent
				});
			}

		}

		series = utilSvc.array.sortDSC(series, 'percent');

		if(misc.percent > 0) {
			series.push(misc);
		}

		// render series
		chart.data = series;
		chart.status = 'RENDER';

	}


	/**
	 *    MATCH_VISIT: TREND LINE CHART
	 *    match to visit ratio per week trend line
	 */

	function initMatchVisit(type, title, id, width, query) {

		// trend line
		// y-axis: match/visit ratio per week
		// x-axis: week dates
		// note: date range default is 8 weeks

		return {
			id: id,
			type: type,
			status: 'EDIT',
			panelMode: '',
			layoutWidth: width,
			config: {
				chartType: 'LINE',
				colors: _chartColors,
				yAxis: {
					showText: width >= 33,
					format: 'fixed'
				},
				xAxis: {
					showText: true,
					interval: ''
				},
				label: {
					width: 75,
					height: 30,
					ln1: 'Match',
					ln2: 'Visits',
					ln3: ''
				}
			},
			display: {
				title: title,
				footer: '',
				info: [
					'Weekly dispense match to patient visits ratio received.',
					'Match totals include first and all fills.',
					'All affiliated CP/CPTPA/SPLITMATCH pharmacies are included in this calculation'
				],
				footerFmt: footerFmtCeWeeks
			},
			query: query,
			queryValid: queryValidator,
			data: [],
			dataParser: parseMatchVisit
		};

	}

	function parseMatchVisit(chart, data) {

		// get day of the week, set chart interval
		var dayInterval = utilSvc.dt.dayFullText(utilSvc.dt.zeroTime(new Date(data[0].WeekEnd)));
		chart.config.xAxis.interval = dayInterval;

		// parse into D3 format
		var series = [];
		for(var i = 0; i < data.length; i++) {
			series.push({
				date: utilSvc.dt.zeroTime(new Date(data[i].WeekEnd)),
				val: data[i].Ratio
			});
		}

		// render series
		chart.data = series;
		chart.status = 'RENDER';

	}


	/**
	 *    DISPENSE_FEES: TREND LINE CHART
	 *    pharmacy dispense fees per week trend line
	 */

	function initDispenseFees(type, title, id, width, query) {

		// trend line
		// y-axis: dispense fees per week
		// x-axis: week dates
		// note: date range default is 8 weeks

		return {
			id: id,
			type: type,
			status: 'EDIT',
			panelMode: '',
			layoutWidth: width,
			config: {
				chartType: 'LINE',
				colors: _chartColors,
				yAxis: {
					showText: width >= 33,
					format: 'currency'
				},
				xAxis: {
					showText: true,
					interval: ''
				},
				label: {
					width: 75,
					height: 30,
					ln1: '',
					ln2: '',
					ln3: ''
				}
			},
			display: {
				title: title,
				footer: '',
				info: [
					'Pharmacy dispense fees across all affiliations for this covered entity.'
				],
				footerFmt: footerFmtCeWeeks
			},
			query: query,
			queryValid: queryValidator,
			data: [],
			dataParser: parseDispenseFees
		};

	}

	function parseDispenseFees(chart, data) {

		// get day of the week, set chart interval
		var dayInterval = utilSvc.dt.dayFullText(utilSvc.dt.zeroTime(new Date(data[0].WeekEnd)));
		chart.config.xAxis.interval = dayInterval;

		var series = [];
		for(var i = 0; i < data.length; i++) {
			series.push({
				date: utilSvc.dt.zeroTime(new Date(data[i].WeekEnd)),
				val: data[i].Total
			});
		}

		// render series
		chart.data = series;
		chart.status = 'RENDER';

	}


	/**
	 *    SPLIT_SPEND: PIE CHART
	 *    splitting spend percentages % this week
	 */

	function initSplitSpend(type, title, id, width, query) {

		// pie chart
		// name: eligibility type
		// value: number of matches
		// percent: ratio of matches
		// note: date range default is 1 weeks 'This Week'

		return {
			id: id,
			type: type,
			status: 'EDIT',
			panelMode: '',
			layoutWidth: width,
			config: {
				chartType: 'PIE',
				colors: _chartColors,
				valFormat: 'number',
				donutHoleRadius: 0.4,
				label: {
					width: 50,
					height: 30
				}
			},
			display: {
				title: title,
				footer: '',
				info: [
					'Split ordering percentages for spending on 340B, GPO, WAC Optimized and WAC Remainder.'
				],
				footerFmt: footerFmtCeRxWeeks
			},
			query: query,
			queryValid: queryValidator,
			data: [],
			dataParser: parseSplitSpend
		};

	}

	function parseSplitSpend(chart, data) {

		// pie wedge return is a 1 item array
		var d = {};
		if(Array.isArray(data) && data.length === 1) {
			d = data[0];
		}

		// assign wedges
		var wedge340B = {
				name: '340B',
				val: validSvc.isNumber(d.TotalSpend340B) ? d.TotalSpend340B : 0,
				percent: validSvc.isNumber(d.PercentSpend340B) ? d.PercentSpend340B : 0
			},
			wedgeGPO = {
				name: 'GPO',
				val: validSvc.isNumber(d.TotalSpendGPO) ? d.TotalSpendGPO : 0,
				percent: validSvc.isNumber(d.PercentSpendGPO) ? d.PercentSpendGPO : 0
			},
			wedgeWACOP = {
				name: 'WAC Optimized',
				val: validSvc.isNumber(d.TotalOptimalWAC) ? d.TotalOptimalWAC : 0,
				percent: validSvc.isNumber(d.PercentSpendOptimalWAC) ? d.PercentSpendOptimalWAC : 0
			},
			wedgeWACREM = {
				name: 'WAC Remainder',
				val: validSvc.isNumber(d.TotalRemainderWAC) ? d.TotalRemainderWAC : 0,
				percent: validSvc.isNumber(d.PercentSpendRemainderWAC) ? d.PercentSpendRemainderWAC : 0
			},
			wedgeMisc = {
				name: 'Misc',
				val: 0,
				percent: 0
			};

		// no data?
		if((wedge340B.percent + wedgeGPO.percent + wedgeWACOP.percent + wedgeWACREM.percent) <= 0) {
			chart.status = 'EDIT';
			chart.panelMode = 'NODATA';
			chart.data = [];
			waitListRemove(chart.id);
			return;
		}

		// load into series, move small amounts to misc
		var series = [],
			wedges = [wedge340B, wedgeGPO, wedgeWACOP, wedgeWACREM, wedgeMisc];

		for(var i = 0; i < wedges.length; i++) {
			if(wedges[i].percent >= 1) {
				series.push(wedges[i]);
			}
			else if(wedges[i].name == 'Misc' && wedges[i].percent > 0) {
				series.push(wedges[i]);
			}
			else {
				// add to Misc category
				wedgeMisc.val += wedges[i].val;
				wedgeMisc.percent += wedges[i].percent;
			}
		}

		series = utilSvc.array.sortDSC(series, 'percent');

		// render series
		chart.data = series;
		chart.status = 'RENDER';

	}


	/**
	 *    NDC HIGH WAC: VBAR CHART
	 *    top NDC drugs with highest WAC
	 */

	function initNdcHighWac(type, title, id, width, query) {

		// vertical bars
		// y-axis: wac spend dollars
		// x-axis: ndc drug names
		// note: date range default is 2 weeks

		return {
			id: id,
			type: type,
			status: 'EDIT',
			panelMode: '',
			layoutWidth: width,
			config: {
				chartType: 'VBAR',
				colors: _chartColors,
				yAxis: {
					showText: width >= 33,
					format: 'currency'
				},
				xAxis: {
					showText: true,
					verticalText: true
				},
				label: {
					width: width >= 33 ? 300 : 250,
					height: 76,
					lines: [
						{title: 'Remainder Spend', dataProp: 'wacDollarsTxt'},
						{title: 'Percent of Total Remainder Spend', dataProp: 'wacPercentTxt'},
						{title: 'NDC', dataProp: 'itemCodeTxt'},
						{title: 'Name', dataProp: 'desc'}
					]
				}
			},
			display: {
				title: title,
				footer: '',
				info: [
					'NDCs comprising the highest portion of Total Remainder Spend.',
					'Note: Remainder spend percentages are calculated against the Total Remainder Spend after it is adjusted by subtracting Medicaid and Optimized values.'
				],
				footerFmt: footerFmtCeWeeks
			},
			query: query,
			queryValid: queryValidator,
			data: [],
			dataParser: parseNdcHighWac
		};

	}

	function parseNdcHighWac(chart, data) {

		var series = [],
			seriesMax = data.length < 10 ? data.length : 10,
			desc = '',
			uniqueList = [];

		for(var i = 0; i < seriesMax; i++) {

			desc = shortenTextUnique(uniqueList, data[i].DrugName, 25);

			series.push({
				name: desc,
				val: data[i].WacDollars,
				wacDollarsTxt: '$' + numberFilter(data[i].WacDollars, 2).toString(),
				wacPercentTxt: data[i].WacPercent.toString() + '%',
				itemCodeTxt: data[i].ItemCode,
				desc: desc
			});
		}

		// render series
		chart.data = series;
		chart.status = 'RENDER';

	}


	/**
	 *    TOP UNKNOWN
	 *    top NDC drugs with highest unknown transaction counts
	 */

	function initTopUnknown(type, title, id, width, query) {

		// vertical bars
		// y-axis: transaction count
		// x-axis: ndc drug names
		// note: date range default is 1 week

		return {
			id: id,
			type: type,
			status: 'EDIT',
			panelMode: '',
			layoutWidth: width,
			config: {
				chartType: 'VBAR',
				colors: _chartColors,
				yAxis: {
					showText: width >= 33,
					format: 'number'
				},
				xAxis: {
					showText: true,
					verticalText: true
				},
				label: {
					width: width >= 33 ? 300 : 250,
					height: 76,
					lines: [
						{title: 'Transaction Count', dataProp: 'countTxt'},
						{title: 'Percent of Unknown Transactions', dataProp: 'percentTxt'},
						{title: 'NDC', dataProp: 'itemCodeTxt'},
						{title: 'Name', dataProp: 'desc'}
					]
				}
			},
			display: {
				title: title,
				footer: '',
				info: [
					'Unknown item codes with the highest transaction count.'
				],
				footerFmt: footerFmtCeRxWeeks
			},
			link: {
				title: 'Transfer to Mapping Feature...',
				display: 'View detailed unknown list for this pharmacy.',
				route: 'ops.transform',
				routeParams: function(chart) {
					var flatProps = flattenQueryProps(chart.query.props);
					return {
						rxid: flatProps.RX,
						tab: 'UNKNOWN'
					};
				}
			},
			query: query,
			queryValid: queryValidator,
			data: [],
			dataParser: parseTopUnknown
		};

	}

	function parseTopUnknown(chart, data) {

		var series = [],
			seriesMax = data.length < 10 ? data.length : 10,
			desc = '';

		for(var i = 0; i < seriesMax; i++) {

			desc = shortenText(data[i].DrugName, 25);

			series.push({
				name: desc,
				val: data[i].UnknownCount,
				countTxt: numberFilter(data[i].UnknownCount, 0).toString(),
				percentTxt: data[i].UnknownPercent.toString() + '%',
				itemCodeTxt: data[i].ItemCode,
				desc: desc
			});

		}

		// render series
		chart.data = series;
		chart.status = 'RENDER';

	}


	/**
	 *    WACREM_SPEND: TREND LINE CHART
	 *    wac rem % of total spend per week trend line
	 */

	function initWacRemSpend(type, title, id, width, query) {

		// trend line
		// y-axis: wac rem spend %
		// x-axis: week dates
		// note: date range default is 8 weeks

		return {
			id: id,
			type: type,
			status: 'EDIT',
			panelMode: '',
			layoutWidth: width,
			config: {
				chartType: 'LINE',
				colors: _chartColors,
				yAxis: {
					showText: width >= 33,
					format: 'percent'
				},
				xAxis: {
					showText: true,
					interval: ''
				},
				label: {
					width: 75,
					height: 30,
					ln1: 'Remainder Spend',
					ln2: 'Percent',
					ln3: ''
				}
			},
			display: {
				title: title,
				footer: '',
				info: [
					'Total Remainder spend as percentage of Total Split Order spend.',
					'Note: Remainder does not include external orders, Optimized price selection and Medicaid.'
				],
				footerFmt: footerFmtCeRxWeeks
			},
			query: query,
			queryValid: queryValidator,
			data: [],
			dataParser: parseWacRemSpend
		};

	}

	function parseWacRemSpend(chart, data) {

		// get day of the week, set chart interval
		var dayInterval = utilSvc.dt.dayFullText(utilSvc.dt.zeroTime(new Date(data[0].WeekEnd)));
		chart.config.xAxis.interval = dayInterval;

		// parse into D3 format
		var series = [];
		for(var i = 0; i < data.length; i++) {
			series.push({
				date: utilSvc.dt.zeroTime(new Date(data[i].WeekEnd)),
				val: data[i].Percent //WacRemSpend,
			});
		}

		// render series
		chart.data = series;
		chart.status = 'RENDER';

	}


	/**
	 *    LINK TO FEATURE
	 *    user clicks chart to nav to another feature
	 */

	function linkToFeature(chartId) {

		// build next feature route

		var chart = vm.charts[chartId],
			rtParams = {};

		// params
		if(!!!chart.link || !validSvc.isText(chart.link.route) || !!!chart.link.routeParams) {
			throw new Error('homeCtl.linkToFeature, chart link, route and routeParams required');
		}
		rtParams = chart.link.routeParams(chart);

		$state.go(chart.link.route, rtParams, {reload: chart.link.route});

	}


	/**
	 *    WAIT LIST MANAGER
	 *    manages the wait list for loading and rendering all charts
	 *    multiple charts can load / render at the same time
	 */

	function waitListAdd(chartId, runManager) {

		// adds chart to wait list

		if(_waitList.indexOf(chartId) < 0) {
			_waitList.push(chartId);
		}

		vm.charts[chartId].status = 'LOAD';
		vm.charts[chartId].panelMode = 'LOAD';

		if(!!runManager) {
			waitListManager();
		}

	}

	function waitListRemove(chartId) {

		// remove chart from wait list

		var idx = _waitList.indexOf(chartId);
		while(idx > -1) {
			_waitList.splice(idx, 1);
			idx = _waitList.indexOf(chartId);
		}

	}

	function waitListManager() {
		console.log('wait mgr: ' + _waitMgrRunning);
		if(_waitMgrRunning) {
			return;
		}
		_waitMgrRunning = true;

		// no longer in layout mode or nothing to do
		if(vm.action != 'LAYOUT' || _waitList.length < 1) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			_waitList = [];
			_waitMgrRunning = false;
			return;
		}

		if(!vm.isWaiting) {
			vm.isWaiting = true;
			msgSvc.wait(true);
		}

		// get 1st and 2nd charts on the wait list
		var chart1 = vm.charts[_waitList[0]],
			chart2 = _waitList.length > 1 ? vm.charts[_waitList[1]] : null;

		// 1st chart
		if(chart1.status == 'LOAD') {
			getChartData(chart1);
		}
		else if(chart1.status == 'RENDER') {
			renderChart(chart1);
		}

		// 2nd chart can load while first draws
		if(!!chart2 && chart2.status == 'LOAD' && chart1.status == 'DRAW') {
			getChartData(chart2);
		}

		_waitMgrRunning = false;

	}

	function getChartData(chart) {

		chart.status = 'LOADING';

		// wait for loading panel slide down
		$timeout(function() {
			if(vm.action == 'LAYOUT') {
				chartRepo.load(chart.type, chart.id, flattenQueryProps(chart.query.props)).then(okChartLoad, errChartLoad);
			}
		}, 500);

	}

	function renderChart(chart) {

		chart.status = 'DRAW';
		chart.panelMode = '';

		// wait for loading panel slide up
		$timeout(function() {

			if(vm.action == 'LAYOUT') {
				$scope.$broadcast('widget.chart.sync', {
					uniqueId: chart.id,
					config: chart.config,
					data: chart.data,
					render: 'animate'
				});

				// after draw remove chart from wait list
				$timeout(function() {
					if(vm.action == 'LAYOUT') {
						waitListRemove(chart.id);
						waitListManager();
					}
				}, 1000);
			}

		}, 500);

	}

	function okChartLoad(r) {

		// exit, ui is no longer in layout mode
		if(vm.action != 'LAYOUT') {
			return;
		}

		// chart id missing
		var chartId = r.id;
		if(!validSvc.isText(chartId)) {
			alert('homeCtl.okChartLoad, chartRepo response has no chart id');
			waitListManager();
			return;
		}

		// chart status out of sync
		var chart = vm.charts[chartId];
		if(!!!chart || chart.status != 'LOADING') {
			alert('homeCtl.okChartLoad, chartId and status = LOADING required for: ' + chartId);
			waitListRemove(chartId);
			waitListManager();
			return;
		}

		// no data?
		if(!Array.isArray(r.data) || r.data.length < 1) {
			chart.status = 'EDIT';
			chart.panelMode = 'NODATA';
			chart.data = [];
			waitListRemove(chart.id);
			waitListManager();
			return;
		}

		// each chart parses data uniquely
		try {
			chart.dataParser(chart, r.data);
		}
		catch(err) {
			chart.errMsg = 'Data Parsing Error';
			chart.errDetail = chartId + ': ' + err.message;
			chart.status = 'EDIT';
			chart.panelMode = 'ERR';
		}

		// recheck wait list
		waitListManager();

	}

	function errChartLoad(r) {

		if(r === null || vm.action != 'LAYOUT') {
			return;
		}

		if(!!r.err) {
			vm.charts[r.id].errMsg = 'Api Error with Status: ' + r.status;
			vm.charts[r.id].errDetail = utilSvc.http.safeResponse(r);
		}
		else {
			vm.charts[r.id].errMsg = 'Unknown Api Error';
			vm.charts[r.id].errDetail = 'homeCtl.errChartLoad';
		}

		// display error
		vm.charts[r.id].status = 'EDIT';
		vm.charts[r.id].panelMode = 'ERR';

		// recheck wait list
		waitListRemove(r.id);
		waitListManager();

	}

	// RELEASE NOTES
	function initReleaseNotes() {
		// has user seen the current release notes?

		var config = $rootScope.appConfig || {};
		var env = validSvc.isText(config.env) ? config.env : '';

		// already seen
		if(!$rootScope.User.ShowReleaseNote) {
			return {};
		}

		// not in server environments
		if(env != 'prod' && env != 'test' && env != 'qa') {
			return {};
		}

		// get version number from app config
		var releaseVersion = '';
		var uiVersion = validSvc.isText(config.uiVersion) ? config.uiVersion : '';
		var versionParts = uiVersion.split('.'); // version comes as three numbers: Major.Minor.RC
		if(Array.isArray(versionParts) && versionParts.length == 3 && validSvc.isInteger(versionParts[0])) {
			var currentRelease = parseInt(versionParts[0]); // use major integer
			releaseVersion = currentRelease.toString();
		}

		// app config issue
		if(!validSvc.isText(releaseVersion)) {
			return {};
		}

		// show release message
		$rootScope.User.ShowReleaseNote = false;
		msgSvc.release(releaseVersion);
	}

	/**
	 *    HELPERS
	 */

	function queryBuilder(props, savedQuery, defaults, affs) {

		// build dynamic query structure

		var query = {
				canEdit: true,
				props: []
			},
			affType = defaults.affType;

		// has affiliation?
		if(affType == 'CERX' || affType == 'RXCE') {
			query.affType = affType;

			// build minimal aff list array
			query.affs = [];
			for(var i = 0; i < affs.length; i++) {
				query.affs.push({CEID: affs[i].CEID, RXID: affs[i].RXID});
			}

			// set the CE/RX if aff length = 1
			if(query.affs.length === 1) {
				savedQuery.CE = query.affs.CEID;
				savedQuery.RX = query.affs.RXID;
			}
		}

		// build query props
		var prop = {},
			ceIdx = -1,
			rxIdx = -1;

		for (var p = 0; p < props.length; p++) {
			prop = {type: props[p], fail:''};

			switch(prop.type) {

				case 'CE':
					// mark first CE
					if(ceIdx < 0) {
						ceIdx = p;
					}

					prop.list = utilSvc.aff.ceList(affs);

					// derive CE val
					if(prop.list.length === 1) {
						prop.val = prop.list[0];
					}
					else if(validSvc.isCE(savedQuery.CE) && prop.list.indexOf(savedQuery.CE) > -1) {
						prop.val = savedQuery.CE;
					}
					else if(validSvc.isCE(defaults.CE) && prop.list.indexOf(defaults.CE) > -1) {
						prop.val = defaults.CE;
					}
					else {
						prop.val = '';
					}

					// convert to ng droplist
					prop.list = utilSvc.ng.droplist(prop.list);

					break;

				case 'RX':
					// mark first RX
					if(rxIdx < 0) {
						rxIdx = p;
					}

					prop.list = utilSvc.aff.rxList(affs);

					// derive RX val
					if(prop.list.length === 1) {
						prop.val = prop.list[0];
					}
					else if(validSvc.isRX(savedQuery.RX) && prop.list.indexOf(savedQuery.RX) > -1) {
						prop.val = savedQuery.RX;
					}
					else if(validSvc.isRX(defaults.RX) && prop.list.indexOf(defaults.RX) > -1) {
						prop.val = defaults.RX;
					}
					else {
						prop.val = '';
					}

					// convert to ng droplist
					prop.list = utilSvc.ng.droplist(prop.list);

					break;

				case 'Weeks':
					prop.list = defaults.WeeksList;

					// derive Weeks val
					if(prop.list.length === 1) {
						prop.val = prop.list[0];
					}
					else if(validSvc.isInteger(savedQuery.Weeks) && prop.list.indexOf(savedQuery.Weeks) > -1) {
						prop.val = savedQuery.Weeks;
					}
					else if(validSvc.isInteger(defaults.Weeks) && prop.list.indexOf(defaults.Weeks) > -1) {
						prop.val = defaults.Weeks;
					}
					else {
						prop.val = 0;
					}

					// convert to ng droplist
					prop.list = utilSvc.ng.droplist(prop.list);

					break;

				default:
					errSvc.warn('unknown query prop type: ' + prop.type, 'homeCtl.querySetup');
					return false;
			}

			query.props.push(prop);

		}

		// modify affiliation CERX / RXCE queries, secondary list should be empty if values are not set
		if(affType == 'CERX' && (query.props[ceIdx].val === '' || query.props[rxIdx].val === '')) {
			query.props[rxIdx].list = [];
		}
		else if(affType == 'RXCE' && (query.props[ceIdx].val === '' || query.props[rxIdx].val === '')) {
			query.props[ceIdx].list = [];
		}

		return query;

	}

	function queryValidator(query) {

		// generic query validation

		var isValid = true,
			props = query.props,
			prop = null;

		for (var i = 0 ; i < props.length; i++) {
			prop = props[i];

			switch(prop.type) {
				case 'CE':
					prop.fail = validSvc.isCE(prop.val) ? 'no' : 'yes';
					break;
				case 'RX':
					prop.fail = validSvc.isRX(prop.val) ? 'no' : 'yes';
					break;
				case 'Weeks':
					prop.fail = validSvc.isInteger(prop.val) ? 'no' : 'yes';
					break;
				default:
					alert('homeCtl.queryValidator, unknown query prop type: ' + prop.type);
					return false;
			}

			isValid = isValid && prop.fail != 'yes';
		}

		return isValid;

	}

	function flattenQueryProps(props) {

		// convert query.props array into a flat object with properties

		var result = {},
			propType = '';

		for(var i = 0; i < props.length; i++) {
			propType = props[i].type;

			if(propType == 'CE' || propType == 'RX' || propType == 'Weeks') {
				result[propType] = props[i].val;
			}
			else {
				errSvc.warn('Unknown query prop type: ' + propType, 'homeCtl.flattenQueryProps');
			}
		}

		return result;
	}

	function deriveChartFlexWidth(row, chartTemplates) {

		// calculate the maximum chart width allowed given some charts on this row have fixed widths (pie charts)

		var chartCount = row.charts.length;
		if(chartCount < 1) {
			return 0;
		}

		// get fixedWidth of this row
		var rowFixedWidth = 0;
		for(var i = 0; i < row.charts.length; i++) {
			rowFixedWidth += chartTemplates[row.charts[i].type].defaults.fixedWidth;
		}

		if(chartCount === 1) {
			if(rowFixedWidth === 0) {
				return 100;
			}
			else {
				return rowFixedWidth;
			}
		}
		else if(chartCount === 2) {
			if(rowFixedWidth === 0) {
				return 50;
			}
			else if(rowFixedWidth === 33) {
				return 66;
			}
			else if(rowFixedWidth === 66) {
				return 33;
			}
		}
		else if(chartCount === 3) {
			return 33;
		}

		// some combination not supported
		return 0;

	}

	function updateChartText(chartId) {

		// update title and footer display based on chart query values

		var chart = vm.charts[chartId];
		if(!!chart) {
			chart.display.footer = chart.display.footerFmt(chart.query);
		}

	}

	function shortenText(txt, maxLen, noElipse) {

		if(!validSvc.isText(txt) || maxLen <= 0) {
			return '';
		}

		if(txt.length > maxLen) {
			return txt.substr(0, maxLen) + (!!noElipse ? '' : '...');
		}
		else {
			return txt;
		}

	}

	function shortenTextUnique(uniqueList, txt, maxLen, noElipse) {

		var desc = shortenText(txt, maxLen, noElipse);

		// add elipsis or extra '.' to make it unique
		while (uniqueList.indexOf(desc) > -1) {
			desc += desc.indexOf('...') < 0 ? '...' : '.';
		}
		uniqueList.push(desc);

		return desc;
	}

	function footerFmtCeWeeks(query) {

		// convert query with CE+Weeks into chart footer display

		var props = query.props,
			ceTxt = 'None Selected',
			weeksTxt = '';

		for(var i = 0; i < props.length; i++) {
			if(props[i].type == 'CE' && validSvc.isCE(props[i].val)) {
				ceTxt = 'Facility: ' + props[i].val;
			}
			else if(props[i].type == 'Weeks' && props[i].val > 0) {
				weeksTxt = ' - ' + props[i].val.toString() + ' Week Period';
			}
		}

		return ceTxt + weeksTxt;

	}

	function footerFmtCeRxWeeks(query) {

		// convert query with CE + RX + Weeks into chart footer display

		var props = query.props,
			ceTxt = '',
			rxTxt = '',
			weeksTxt = '';

		for(var i = 0; i < props.length; i++) {
			if(props[i].type == 'CE' && validSvc.isCE(props[i].val)) {
				ceTxt = props[i].val;
			}
			else if(props[i].type == 'RX' && validSvc.isRX(props[i].val)) {
				rxTxt = props[i].val;
			}
			else if(props[i].type == 'Weeks' && props[i].val > 0) {
				weeksTxt = ' - ' + props[i].val.toString() + ' Week Period';
			}
		}

		if(ceTxt !== '' && rxTxt !== '') {
			return ceTxt + '/' + rxTxt + weeksTxt;
		}
		else {
			return 'None Selected' + weeksTxt;
		}

	}

}
 
footerController.$inject = ['$rootScope', '$state'];
angular
.module('espui.main')
.controller('FooterController', footerController);

/* @ngInject */
function footerController($rootScope, $state) {

	/*jshint validthis: true */
	var vm = this;

	vm.authValid = false;
	vm.linkTo = linkTo;
	vm.show = true;

	vm.cobrand = $rootScope.cobrand;


	/**
	 *    INIT
	 */

	init();

	function init() {
		console.log('FOOTER INIT: User is valid ' + vm.authValid);

		// hide footer if displaying a login landing page
		var dl = $rootScope.deepLink || {};
		if(!!dl.params && dl.params.reason == 'uilanding') {
			//console.log('FOOTER: UI landing');
			vm.show = false;
		}
	}


	/**
	 *    AUTH EVENTS
	 *    re-initialize on login/logout
	 */

	$rootScope.$on('espui>auth.change', function () {
		vm.authValid = !!$rootScope.User;
	});

	$rootScope.$on('espui>uilanding', function (event, uiLanding) {
		// show footer when landing mode is off
		vm.show = !!!uiLanding.on;
	});

	$rootScope.$on('espui>cobrand', function (event, brand) {
		vm.cobrand = brand;
	});


	/**
	 *    NAV TO FOOTER LINK
	 */

	function linkTo(tabName) {
		$state.go('about.corp', {tab:tabName}, {reload: 'about.corp'});
	}

}
 
headerController.$inject = ['$window', '$rootScope', '$scope', '$state', '$timeout', 'authService', 'sessionRepo', 'prefsRepo', 'validSvc', 'utilSvc', 'msgSvc'];angular.module('espui.main').controller('HeaderController', headerController);

/* @ngInject */
function headerController(
    $window,
    $rootScope,
    $scope,
    $state,
    $timeout,
    authService,
    sessionRepo,
    prefsRepo,
    validSvc,
    utilSvc,
    msgSvc
) {
    /*jshint validthis: true */
    var vm = this;
    var _newTabId = 0;

    // inherit
    utilSvc.ctl.addSorting(vm);

    // properties
    vm.show = true;
    vm.authValid = false;
    vm.isImpersonate = false;

    vm.acctName = 'My Account';
    vm.acctCompany = '';
    vm.menu = {};
    vm.navCollapse = false;
    vm.appVersion = '';
    vm.cobrand = $rootScope.cobrand;
    vm.uType = '';

    // header mode and debug props
    vm.CSSmode = '';
    vm.debug = 'off';
    vm.debugENV = 'local';
    vm.debugItems = [];

    // methods
    vm.logout = logout;
    vm.navClick = navClick;
    vm.myAccount = myAccount;
    vm.myPreferences = myPreferences;

    // alerts
    vm.alertInfo = {};
    vm.toggleAlertList = toggleAlertList;
    vm.alertNotifyToggle = alertNotifyToggle;
    vm.gotoAlert = gotoAlert;
    vm.validAlertUserType = validAlertUserType;

    // user options
    vm.toggleUserOptions = toggleUserOptions;
    vm.showUserOptions = 'no';

    // new tab
    vm.newTab = newTab;

    // help
    vm.showHelp = 'no';
    vm.gotoHelp = gotoHelp;

    /**
     *    INIT
     */

    init();

    function init() {
        //console.log('HEADER INIT');
        initVersionAndDebug($rootScope.verityEspVersion, $rootScope.appConfig);

        // hide header if displaying a login landing page
        var dl = $rootScope.deepLink || {};
        if (!!dl.params && dl.params.reason == 'uilanding') {
            //console.log('HEADER: UI landing');
            vm.show = false;
        } else {
            resetUi();
        }
        //console.log('HEADER show: ' + vm.show);
    }

    function resetUi() {
        vm.authValid = false;
        vm.CSSmode = vm.debug == 'on' ? 'header-' + vm.debugENV : '';
        vm.isImpersonate = false;
        vm.acctName = 'My Account';
        vm.acctCompany = '';

        vm.menu = menuGeneration();
        resetAlerts();
        vm.showUserOptions = 'no';
        vm.showHelp = 'no';
        _newTabId = 0;
    }

    function resetAlerts() {
        vm.alertInfo = {
            ready: false,
            show: 'no',
            TotalFails: '',
            icon: 'icon-alert',
            SortBy: ['MonitorType'],
            notifyPass: 'no',
            notifyFail: 'yes',
            items: [],
        };
    }

    function authChange() {
        initVersionAndDebug($rootScope.verityEspVersion, $rootScope.appConfig);
        //console.log('header: auth change event, start up: ' + !!$rootScope.startUp + ' user: ' + !!$rootScope.User);

        if (!!$rootScope.startUp && !!$rootScope.User) {
            var usr = $rootScope.User;

            vm.authValid = true;
            vm.isImpersonate = !!usr.Impersonate;
            if (vm.isImpersonate) {
                // emulation overrides header debug CSS
                vm.CSSmode = 'header-impersonate';
            }

            var fName = validSvc.isText(usr.Fname) ? usr.Fname.substring(0, 1) : '';
            vm.acctName = fName + '. ' + usr.Lname;
            vm.acctCompany = usr.Company;

            vm.menu = menuGeneration(vm.authValid, $rootScope.User);

            // show help links for VERITY and customers
            vm.showHelp = 'yes';

            // delay alerts and tab management after header html renders
            $timeout(function () {
                manageTabList();
                $timeout(getAlertInfo, 1000);
            }, 1000);
        } else if (vm.authValid) {
            //console.log('header auth change: reset UI');
            resetUi();
        }
    }
    function validAlertUserType() {
        if (vm.uType == 'RX' || vm.uType == 'RXROLLUP') {
            return false;
        }
        return true;
    }

    /**
     *    VERSION / DEBUG DISPLAY
     */

    function initVersionAndDebug(ver, config) {
        // clean up and display version, debug
        // note: one or all of these are not reliable on startup, test all values

        // re-initialize
        vm.appVersion = '';
        vm.debug = 'off';
        vm.debugENV = 'local';
        vm.debugItems = [];

        // version clean up
        if (!validSvc.isText(ver)) {
            ver = '';
        }
        ver = 'v' + ver.toString();

        // config is ready
        if (!!config) {
            // config: api path
            var apiPath = '?';
            if (validSvc.isText(config.apiPath)) {
                apiPath = config.apiPath;
            }

            // config: debug
            if (config.debug == 'on') {
                vm.debug = 'on';
                if (validSvc.isText(config.env)) {
                    vm.debugENV = config.env;
                }
                vm.CSSmode = 'header-' + vm.debugENV;

                // ui webserver
                if (validSvc.isText(config.uiServer)) {
                    vm.appVersion = config.uiServer + ': ' + ver;
                } else {
                    vm.appVersion = ver;
                }

                // user type
                if (!!$rootScope.User && validSvc.isText($rootScope.User.Type)) {
                    vm.debugItems.push('userType: ' + $rootScope.User.Type);
                } else {
                    vm.debugItems.push('userType: ?');
                }

                // ui version
                if (validSvc.isText(config.uiVersion)) {
                    vm.debugItems.push('api minimum ui Version: ' + config.uiVersion);
                } else {
                    vm.debugItems.push('api minimum ui Version: ?');
                }

                // api path
                vm.debugItems.push('api path: ' + apiPath);

                // maint mode
                if (!!config.maint && validSvc.isText(config.maint.mode)) {
                    vm.debugItems.push('maint mode: ' + config.maint.mode);
                } else {
                    vm.debugItems.push('maint mode: ?');
                }

                // shape
                var shapeLoc = validSvc.isText($window.shapeLocation) ? 'local' : 'remote';
                vm.debugItems.push('shape: ' + shapeLoc);

                // exit with enhanced version text and debugging
                return;
            }
        }

        // no additional config is available, just set the version number
        vm.appVersion = ver;
    }

    /**
     *    MENU VM
     *    full list of all menu features
     */
    function menuVM(authValid) {
        // filtering all dev features out of menu

        var mvm = [],
            uType = '',
            verisaveonly = false,
            isDebug = !!$rootScope.debug,
            isLocalDev = vm.debugENV == 'local';

        // set user type (if this is after login)
        if (!!$rootScope.User && typeof $rootScope.User.Type === 'string') {
            uType = $rootScope.User.Type;
            vm.uType = uType;
            if (uType == 'CE') {
                verisaveonly = $rootScope.User.VeriSaveOnly;
            }
        }

        // verity user
        var isVerity = uType == 'VERITY' || uType == 'VERITYSA';

        // user has valid auth
        if (!!authValid) {
            // HOME
            mvm.push({
                title: 'HOME',
                route: 'home',
                navItems: [],
            });

            // ADMIN
            if (isVerity) {
                mvm.push({
                    title: 'ADMIN',
                    navItems: [
                        {
                            title: 'Settings Viewer',
                            feature: 'ops.affs.settings',
                            route: 'admin.settings.main',
                            icon: 'icon-monitor',
                            sprite: 'sprite-monitor',
                            lock: true,
                        },
                        {
                            title: 'Facility',
                            feature: 'admin.ce',
                            route: 'admin.ce.list',
                            icon: 'icon-ce',
                            sprite: 'sprite-ce',
                            lock: true,
                        },
                        {
                            title: 'Pharmacy',
                            feature: 'admin.rx',
                            route: 'admin.rx.list',
                            icon: 'icon-rx',
                            sprite: 'sprite-rx',
                            lock: true,
                        },
                        {
                            title: 'Vendor',
                            feature: 'admin.vendor',
                            route: 'admin2.vendor.list',
                            icon: 'icon-vendor',
                            sprite: 'sprite-vendor',
                            lock: true,
                        },
                        {
                            title: 'User',
                            feature: 'admin.user',
                            route: 'admin.user.list',
                            icon: 'icon-users',
                            sprite: 'sprite-users',
                            lock: true,
                        },
                        {
                            title: 'Groups',
                            feature: 'admin.entitygroup',
                            route: 'admin2.groups.list',
                            icon: 'icon-about-corp',
                            sprite: 'sprite-about-corp',
                            lock: true,
                        },
                        {
                            title: 'Excluded Payor',
                            feature: 'admin.payor',
                            route: 'admin2.payor.list',
                            icon: 'icon-payor',
                            sprite: 'sprite-payor',
                            lock: true,
                        },
                        {
                            title: 'IRA Payor',
                            feature: 'admin.payor',
                            route: 'admin2.ira.list',
                            icon: 'icon-payor',
                            sprite: 'sprite-payor',
                            lock: true,
                        },
                        {
                            title: 'Data Manager',
                            feature: 'admin.datamgr',
                            route: 'admin.datamgr.main',
                            icon: 'icon-datamgr',
                            sprite: 'sprite-maint',
                            lock: true,
                        },
                        {
                            title: 'Provider',
                            feature: 'admin.provider',
                            route: 'admin2.provider.list',
                            icon: 'icon-ops',
                            sprite: 'sprite-ops',
                            lock: true,
                        },
                        {
                            title: 'Manufacturer Restrictions',
                            feature: 'admin.mfrestrict',
                            route: 'admin2.mfrestrict.list',
                            icon: 'icon-warn',
                            sprite: 'sprite-warn',
                            lock: true,
                        },
                        {
                            title: 'Carepath Claims Federation ',
                            feature: 'admin.claimfed',
                            route: 'admin.claimfed.list',
                            icon: 'icon-mapping',
                            sprite: 'sprite-mapping',
                            lock: true,
                        },
                        {
                            title: 'Bulk Edit',
                            feature: 'admin.bulkedit',
                            route: 'admin.bulkedit.list',
                            icon: 'icon-edit',
                            sprite: 'sprite-edit',
                            lock: false,
                        },
                    ],
                });
            }

            // CE ADMIN
            if (uType == 'CE') {
                mvm.push({
                    title: 'ADMIN',
                    navItems: [
                        {
                            title: 'Settings Viewer',
                            feature: 'ops.affs.settings',
                            route: 'admin.settings.main',
                            icon: 'icon-monitor',
                            sprite: 'sprite-monitor',
                            lock: true,
                        },
                        {
                            title: 'User',
                            feature: 'customer.admin.ce',
                            route: 'admin.user.list-customers',
                            icon: 'icon-users',
                            sprite: 'sprite-users',
                            lock: true,
                        },
                        {
                            title: 'NPIs',
                            feature: 'ops.ce.npi',
                            route: 'ops.npi',
                            icon: 'icon-ops',
                            sprite: 'sprite-ops',
                            rxmodels: utilSvc.aff.rxModelsByFeature('ops.ce.npi'),
                            lock: true,
                        },
                        {
                            title: 'Locations',
                            feature: 'ops.ce.locations',
                            route: 'ops.locations',
                            icon: 'icon-ce',
                            sprite: 'sprite-ce',
                            skipExpress: true,
                            lock: true,
                        },
                    ],
                });
            }

            // RX ADMIN
            if (uType == 'RX') {
                mvm.push({
                    title: 'ADMIN',
                    navItems: [
                        {
                            title: 'User',
                            feature: 'customer.admin.rx',
                            route: 'admin.user.list-customers',
                            icon: 'icon-users',
                            sprite: 'sprite-users',
                            lock: true,
                        },
                    ],
                });
            }

            // VERITY OPERATIONS
            if (isVerity) {
                var verityOps = {
                    title: 'OPERATIONS',
                    navItems: [
                        {
                            title: 'Feeds',
                            feature: 'ops.datamonitor',
                            route: 'ops2.feeds.list',
                            icon: 'icon-feeds',
                            sprite: 'sprite-feeds',
                            rxmodels: utilSvc.aff.rxModelsByFeature("ops.datamonitor"),
                            lock: true,
                        },
                        {
                            title: 'Data Monitor',
                            feature: 'monitor',
                            route: 'ops2.datamonitor.list',
                            icon: 'icon-monitor',
                            sprite: 'sprite-monitor',
                            lock: true,
                        },
                        {
                            title: 'Mapping',
                            feature: 'ops.transform',
                            route: 'ops.transform',
                            icon: 'icon-ops-transform',
                            sprite: 'sprite-mapping',
                            rxmodels: utilSvc.aff.rxModelsByFeature('ops.transform'),
                            lock: true,
                        },
                        {
                            title: 'Accumulation',
                            feature: 'ops.accum',
                            route: 'ops.accum',
                            icon: 'icon-ndc-accum',
                            sprite: 'sprite-ndc-accum',
                            params: { noCache: true },
                            rxmodels: utilSvc.aff.rxModelsByFeature('ops.accum'),
                            lock: true,
                        },
                        {
                            title: 'Matching',
                            feature: 'ops.match',
                            route: 'ops.match',
                            icon: 'icon-match',
                            sprite: 'sprite-match',
                            rxmodels: utilSvc.aff.rxModelsByFeature('ops.match'),
                            lock: true,
                        },
                        {
                            title: 'Catalogs',
                            feature: 'ops.catalogs',
                            route: 'ops.catalogs',
                            icon: 'icon-ndc-accum',
                            sprite: 'sprite-ndc-accum',
                            lock: true,
                        },
                        {
                            title: 'NDC List',
                            feature: 'ops.centralndc',
                            route: 'ops.ndclist',
                            icon: 'icon-ndc-accum',
                            sprite: 'sprite-ndc-accum',
                            rxmodels: utilSvc.aff.rxModelsByFeature('ops.ndclist'),
                            lock: true,
                        },
                        {
                            title: 'Split Transactions',
                            feature: 'ops.splittrans',
                            route: 'ops.splittrans',
                            icon: 'icon-orders-split',
                            sprite: 'sprite-orders-split',
                            rxmodels: utilSvc.aff.rxModelsByFeature('ops.splittrans'),
                            lock: true,
                        },
                        {
                            title: 'Encounters',
                            feature: 'ops.visits',
                            route: 'ops.visits',
                            icon: 'icon-ce',
                            sprite: 'sprite-ce',
                            rxmodels: utilSvc.aff.rxModelsByFeature('ops.visits'),
                            lock: true,
                        },
                        {
                            title: 'Claims',
                            feature: 'ops.dispenses',
                            route: 'ops.claims',
                            icon: 'icon-rx',
                            sprite: 'sprite-rx',
                            rxmodels: utilSvc.aff.rxModelsByFeature('ops.claims'),
                            lock: true,
                        },
                        {
                            title: 'Care Card',
                            feature: 'ops.cashcard.member',
                            route: 'ops.cashcard-member',
                            icon: 'icon-cashcard',
                            sprite: 'sprite-rx',
                            cashcard: true,
                            lock: true,
                        },
                        {
                            title: 'Referral Capture',
                            feature: 'ops.referral',
                            route: 'ops.referral',
                            icon: 'icon-ops',
                            sprite: 'sprite-ops',
                            lock: true,
                        },
                        {
                            title: 'Contract Price Validation',
                            feature: 'ops.pricevalidation',
                            route: 'ops.pricevalidation',
                            icon: 'icon-orders-review',
                            sprite: 'sprite-orders-review',
                            rxmodels: utilSvc.aff.rxModelsByFeature('ops.pricevalidation'),
                            lock: true,
                        },
                    ],
                };
                mvm.push(verityOps);
            }

            // CE OPERATIONS
            if (uType == 'CE') {
                if (!!verisaveonly) {
                    mvm.push({
                        title: 'OPERATIONS',
                        navItems: [
                            {
                                title: 'Data Monitor',
                                feature: 'ops.datamonitor',
                                route: 'ops2.datamonitor.list',
                                icon: 'icon-monitor',
                                sprite: 'sprite-monitor',
                                rxmodels: utilSvc.aff.rxModelsByFeature('ops.datamonitor'),
                                skipExpress: true,
                                lock: true,
                            },
                            {
                                title: 'Feeds',
                                feature: 'ops.datamonitor',
                                route: 'ops2.feeds.list',
                                icon: 'icon-feeds',
                                sprite: 'sprite-feeds',
                                rxmodels: utilSvc.aff.rxModelsByFeature('ops.datamonitor'),
                                skipExpress: true,
                                lock: true,
                            },
                            {
                                title: 'Catalogs',
                                feature: 'ops.catalogs.aff',
                                route: 'ops.catalogs.aff',
                                icon: 'icon-ndc-accum',
                                sprite: 'sprite-ndc-accum',
                                rxmodels: utilSvc.aff.rxModelsByFeature('ops.catalogs.aff'),
                                lock: true,
                            },
                            {
                                title: 'NDC List',
                                feature: 'ops.centralndc',
                                route: 'ops.ndclist',
                                icon: 'icon-ndc-accum',
                                sprite: 'sprite-ndc-accum',
                                rxmodels: utilSvc.aff.rxModelsByFeature('ops.ndclist'),
                                lock: true,
                            },
                            {
                                title: 'Contract Price Validation',
                                feature: 'ops.pricevalidation',
                                route: 'ops.pricevalidation',
                                icon: 'icon-orders-review',
                                sprite: 'sprite-orders-review',
                                rxmodels: utilSvc.aff.rxModelsByFeature('ops.pricevalidation'),
                                lock: true,
                            },
                        ],
                    });
                } else {
                    mvm.push({
                        title: 'OPERATIONS',
                        navItems: [
                            {
                                title: 'Data Monitor',
                                feature: 'ops.datamonitor',
                                route: 'ops2.datamonitor.list',
                                icon: 'icon-monitor',
                                sprite: 'sprite-monitor',
                                rxmodels: utilSvc.aff.rxModelsByFeature('ops.datamonitor'),
                                skipExpress: true,
                                lock: true,
                            },
                            {
                                title: 'Feeds',
                                feature: 'ops.datamonitor',
                                route: 'ops2.feeds.list',
                                icon: 'icon-feeds',
                                sprite: 'sprite-feeds',
                                rxmodels: utilSvc.aff.rxModelsByFeature('ops.datamonitor'),
                                skipExpress: true,
                                lock: true,
                            },
                            {
                                title: 'Split Transactions',
                                feature: 'ops.splittrans',
                                route: 'ops.splittrans',
                                icon: 'icon-orders-split',
                                sprite: 'sprite-orders-split',
                                rxmodels: utilSvc.aff.rxModelsByFeature('ops.splittrans'),
                                lock: true,
                            },
                            {
                                title: 'Mapping',
                                feature: 'ops.transform',
                                route: 'ops.transform',
                                icon: 'icon-ops-transform',
                                sprite: 'sprite-mapping',
                                rxmodels: utilSvc.aff.rxModelsByFeature('ops.transform'),
                                lock: true,
                            },
                            {
                                title: 'Accumulation',
                                feature: 'ops.accum',
                                route: 'ops.accum',
                                icon: 'icon-ndc-accum',
                                sprite: 'sprite-ndc-accum',
                                params: { noCache: true },
                                rxmodels: utilSvc.aff.rxModelsByFeature('ops.accum'),
                                lock: true,
                            },
                            {
                                title: 'Matching',
                                feature: 'ops.match',
                                route: 'ops.match',
                                icon: 'icon-match',
                                sprite: 'sprite-match',
                                rxmodels: utilSvc.aff.rxModelsByFeature('ops.match'),
                                lock: true,
                            },
                            {
                                title: 'Catalogs',
                                feature: 'ops.catalogs.aff',
                                route: 'ops.catalogs.aff',
                                icon: 'icon-ndc-accum',
                                sprite: 'sprite-ndc-accum',
                                rxmodels: utilSvc.aff.rxModelsByFeature('ops.catalogs.aff'),
                                lock: true,
                            },
                            {
                                title: 'NDC List',
                                feature: 'ops.centralndc',
                                route: 'ops.ndclist',
                                icon: 'icon-ndc-accum',
                                sprite: 'sprite-ndc-accum',
                                rxmodels: utilSvc.aff.rxModelsByFeature('ops.ndclist'),
                                lock: true,
                            },
                            {
                                title: 'Encounters',
                                feature: 'ops.visits',
                                route: 'ops.visits',
                                icon: 'icon-ce',
                                sprite: 'sprite-ce',
                                rxmodels: utilSvc.aff.rxModelsByFeature('ops.visits'),
                                skipExpress: true,
                                lock: true,
                            },
                            {
                                title: 'Claims',
                                feature: 'ops.dispenses',
                                route: 'ops.claims',
                                icon: 'icon-rx',
                                sprite: 'sprite-rx',
                                rxmodels: utilSvc.aff.rxModelsByFeature('ops.claims'),
                                lock: true,
                            },
                            {
                                title: 'Custom Items',
                                feature: 'report.wacneut',
                                route: 'ops.customitem',
                                icon: 'icon-rx',
                                sprite: 'sprite-rx',
                                skipExpress: true,
                                lock: true,
                            },
                            {
                                title: 'Care Card',
                                feature: 'ops.cashcard.member',
                                route: 'ops.cashcard-member',
                                icon: 'icon-cashcard',
                                sprite: 'sprite-rx',
                                cashcard: true,
                                lock: true,
                            },
                            {
                                title: 'VCentral',
                                feature: 'ops.ce.vcentral',
                                route: 'ops.vcentral',
                                icon: 'icon-rx',
                                sprite: 'sprite-rx',
                                skipExpress: true,
                                lock: true,
                            },
                            {
                                title: 'Referral Capture',
                                feature: 'ops.referral',
                                route: 'ops.referral',
                                icon: 'icon-ops',
                                sprite: 'sprite-ops',
                                lock: true,
                            },
                            {
                                title: 'Contract Price Validation',
                                feature: 'ops.pricevalidation',
                                route: 'ops.pricevalidation',
                                icon: 'icon-orders-review',
                                sprite: 'sprite-orders-review',
                                rxmodels: utilSvc.aff.rxModelsByFeature('ops.pricevalidation'),
                                lock: true,
                            },
                        ],
                    });
                }
            }

            // RX OPERATIONS
            if (uType == 'RX') {
                mvm.push({
                    title: 'OPERATIONS',
                    navItems: [
                        {
                            title: 'Accumulation',
                            feature: 'ops.accum',
                            route: 'ops.accum',
                            icon: 'icon-ndc-accum',
                            sprite: 'sprite-ndc-accum',
                            params: { noCache: true },
                            rxmodels: utilSvc.aff.rxModelsByFeature('ops.accum'),
                            lock: true,
                        },
                        {
                            title: 'Matching',
                            feature: 'ops.match',
                            route: 'ops.match',
                            icon: 'icon-match',
                            sprite: 'sprite-match',
                            rxmodels: utilSvc.aff.rxModelsByFeature('ops.match'),
                            lock: true,
                        },
                        {
                            title: 'Catalogs',
                            feature: 'ops.catalogs.aff',
                            route: 'ops.catalogs.aff',
                            icon: 'icon-ndc-accum',
                            sprite: 'sprite-ndc-accum',
                            rxmodels: utilSvc.aff.rxModelsByFeature('ops.catalogs.aff'),
                            lock: true,
                        },
                        {
                            title: 'Claims',
                            feature: 'ops.dispenses',
                            route: 'ops.claims',
                            icon: 'icon-rx',
                            sprite: 'sprite-rx',
                            rxmodels: utilSvc.aff.rxModelsByFeature('ops.claims'),
                            lock: true,
                        },
                        {
                            title: 'NDC List',
                            feature: 'ops.centralndc',
                            route: 'ops.ndclist',
                            icon: 'icon-ndc-accum',
                            sprite: 'sprite-ndc-accum',
                            rxmodels: utilSvc.aff.rxModelsByFeature('ops.ndclist'),
                            lock: true,
                        },
                        {
                            title: 'Care Card',
                            feature: 'ops.cashcard.member',
                            route: 'ops.cashcard-member',
                            icon: 'icon-cashcard',
                            sprite: 'sprite-rx',
                            cashcard: true,
                            lock: true,
                        },
                        {
                            title: 'Contract Price Validation',
                            feature: 'ops.pricevalidation',
                            route: 'ops.pricevalidation',
                            icon: 'icon-orders-review',
                            sprite: 'sprite-orders-review',
                            rxmodels: utilSvc.aff.rxModelsByFeature('ops.pricevalidation'),
                            lock: true,
                        },
                    ],
                });
            }

            // ORDER
            if (uType == 'CE') {
                if (!!verisaveonly) {
                    mvm.push({
                        title: 'ORDER',
                        navItems: [
                            {
                                title: 'List',
                                feature: 'orders',
                                route: 'orders.list',
                                icon: 'icon-list',
                                sprite: 'sprite-list',
                                rxmodels: utilSvc.aff.rxModelsByFeature('orders.list'),
                                lock: true,
                            },
                            {
                                title: 'New Split Order',
                                feature: 'orders.edit',
                                route: 'orders.newsplit',
                                icon: 'icon-orders-split',
                                rxmodels: utilSvc.aff.rxModelsByFeature('orders.new.ce'),
                                sprite: 'sprite-orders-split',
                                lock: true,
                            },
                            {
                                title: 'Split Order Invoices',
                                feature: 'invoice',
                                route: 'invoice2.split.list',
                                icon: 'icon-orders-split',
                                sprite: 'sprite-orders-split',
                                rxmodels: utilSvc.aff.rxModelsByFeature('invoice.split'),
                                lock: true,
                            },
                            {
                                title: 'Invoice Review',
                                feature: 'invoice.review',
                                route: 'invoice.review',
                                icon: 'icon-invoice-review',
                                sprite: 'sprite-invoice-review',
                                rxmodels: utilSvc.aff.rxModelsByFeature('invoice.review'),
                                lock: true,
                            },
                            {
                                title: 'Add Invoice',
                                feature: 'invoice.add',
                                route: 'invoice.add',
                                icon: 'icon-upload',
                                sprite: 'sprite-upload',
                                rxmodels: utilSvc.aff.rxModelsByFeature('invoice.add'),
                                lock: true,
                            },
                        ],
                    });
                } else {
                    mvm.push({
                        title: 'ORDER',
                        navItems: [
                            {
                                title: 'New',
                                feature: 'orders.edit',
                                route: 'orders.new',
                                icon: 'icon-orders',
                                sprite: 'sprite-orders',
                                lock: true,
                            },
                            {
                                title: 'List',
                                feature: 'orders',
                                route: 'orders.list',
                                icon: 'icon-list',
                                sprite: 'sprite-list',
                                rxmodels: utilSvc.aff.rxModelsByFeature('orders.list'),
                                lock: true,
                            },
                            {
                                title: 'New Split Order',
                                feature: 'orders.edit',
                                route: 'orders.newsplit',
                                icon: 'icon-orders-split',
                                rxmodels: utilSvc.aff.rxModelsByFeature('orders.new.ce'),
                                sprite: 'sprite-orders-split',
                                lock: true,
                            },
                            {
                                title: 'Split Order Invoices',
                                feature: 'invoice',
                                route: 'invoice2.split.list',
                                icon: 'icon-orders-split',
                                sprite: 'sprite-orders-split',
                                rxmodels: utilSvc.aff.rxModelsByFeature('invoice.split'),
                                lock: true,
                            },
                            {
                                title: 'CP Order Invoices',
                                feature: 'invoice',
                                route: 'invoice2.cp.list',
                                icon: 'icon-ce',
                                sprite: 'sprite-ce',
                                lock: true,
                            },
                            {
                                title: 'Invoice Review',
                                feature: 'invoice.review',
                                route: 'invoice.review',
                                icon: 'icon-invoice-review',
                                sprite: 'sprite-invoice-review',
                                rxmodels: utilSvc.aff.rxModelsByFeature('invoice.review'),
                                lock: true,
                            },
                            {
                                title: 'Add Invoice',
                                feature: 'invoice.add',
                                route: 'invoice.add',
                                icon: 'icon-upload',
                                sprite: 'sprite-upload',
                                rxmodels: utilSvc.aff.rxModelsByFeature('invoice.add'),
                                lock: true,
                            },
                        ],
                    });
                }
            } else if (uType == 'RX') {
                mvm.push({
                    title: 'ORDER',
                    navItems: [
                        {
                            title: 'New',
                            feature: 'orders.edit',
                            route: 'orders.new',
                            icon: 'icon-orders',
                            sprite: 'sprite-orders',
                            lock: true,
                        },
                        {
                            title: 'List',
                            feature: 'orders',
                            route: 'orders.list',
                            icon: 'icon-list',
                            sprite: 'sprite-list',
                            rxmodels: utilSvc.aff.rxModelsByFeature('orders.list'),
                            lock: true,
                        },
                        {
                            title: 'Split Order Invoices',
                            feature: 'invoice',
                            route: 'invoice2.split.list',
                            icon: 'icon-orders-split',
                            sprite: 'sprite-orders-split',
                            rxmodels: utilSvc.aff.rxModelsByFeature('invoice.split'),
                            lock: true,
                        },
                        {
                            title: 'Invoice Review',
                            feature: 'invoice.review',
                            route: 'invoice.review',
                            icon: 'icon-invoice-review',
                            sprite: 'sprite-invoice-review',
                            lock: true,
                        },
                        {
                            title: 'Add Invoice',
                            feature: 'invoice.add',
                            route: 'invoice.add',
                            icon: 'icon-upload',
                            sprite: 'sprite-upload',
                            rxmodels: utilSvc.aff.rxModelsByFeature('invoice.add'),
                            lock: true,
                        },
                    ],
                });
            } else {
                mvm.push({
                    title: 'ORDER',
                    navItems: [
                        {
                            title: 'New',
                            feature: 'orders.edit',
                            route: 'orders.new',
                            icon: 'icon-orders',
                            sprite: 'sprite-orders',
                            lock: true,
                        },
                        {
                            title: 'List',
                            feature: 'orders',
                            route: 'orders.list',
                            icon: 'icon-list',
                            sprite: 'sprite-list',
                            rxmodels: utilSvc.aff.rxModelsByFeature('orders.list'),
                            lock: true,
                        },
                        {
                            title: 'New Split Order',
                            feature: 'orders.edit',
                            route: 'orders.newsplit',
                            icon: 'icon-orders-split',
                            sprite: 'sprite-orders-split',
                            lock: true,
                        },
                        {
                            title: 'Split Order Invoices',
                            feature: 'invoice',
                            route: 'invoice2.split.list',
                            icon: 'icon-orders-split',
                            sprite: 'sprite-orders-split',
                            rxmodels: utilSvc.aff.rxModelsByFeature('invoice.split'),
                            lock: true,
                        },
                        {
                            title: 'CP Order Invoices',
                            feature: 'invoice',
                            route: 'invoice2.cp.list',
                            icon: 'icon-ce',
                            sprite: 'sprite-ce',
                            lock: true,
                        },
                        {
                            title: 'Invoice Review',
                            feature: 'invoice.review',
                            route: 'invoice.review',
                            icon: 'icon-invoice-review',
                            sprite: 'sprite-invoice-review',
                            lock: true,
                        },
                        {
                            title: 'Add Invoice',
                            feature: 'invoice.add',
                            route: 'invoice.add',
                            icon: 'icon-upload',
                            sprite: 'sprite-upload',
                            rxmodels: utilSvc.aff.rxModelsByFeature('invoice.add'),
                            lock: true,
                        },
                    ],
                });
            }

            // REPORT
            if (isVerity) {
                mvm.push({
                    title: 'REPORT',
                    navItems: [
                        {
                            title: 'RX Contract Pharmacy',
                            feature: 'report.rx',
                            route: 'report.rx',
                            icon: 'icon-rx',
                            sprite: 'sprite-rx',
                            rxmodels: utilSvc.aff.rxModelsByFeature('report.rx'),
                            lock: true,
                        },
                        {
                            title: 'CP Financial',
                            feature: 'report.ce',
                            route: 'report.cpfin',
                            icon: 'icon-ce',
                            sprite: 'sprite-ce',
                            rxmodels: utilSvc.aff.rxModelsByFeature('report.cpfin'),
                            lock: true,
                        },
                        {
                            title: 'Pharmacy Invoice',
                            feature: 'report.rxbilling',
                            route: 'report.billing-rx',
                            icon: 'icon-rx',
                            sprite: 'sprite-rx',
                            rxmodels: utilSvc.aff.rxModelsByFeature('report.billing-rx'),
                            lock: true,
                        },
                        {
                            title: '340B Savings',
                            feature: 'report.splitsavings',
                            route: 'report.splitsavings',
                            icon: 'icon-money',
                            sprite: 'sprite-money',
                            rxmodels: utilSvc.aff.rxModelsByFeature('report.splitsavings'),
                            lock: true,
                        },
                        {
                            title: 'Facility Financial',
                            feature: 'report.splitfinancial',
                            route: 'report.splitfinancial',
                            icon: 'icon-money',
                            sprite: 'sprite-orders-split',
                            rxmodels: utilSvc.aff.rxModelsByFeature('report.splitfinancial'),
                            lock: true,
                        },
                        {
                            title: 'Audit',
                            feature: 'audit',
                            route: 'report.audit',
                            icon: 'icon-monitor',
                            sprite: 'sprite-orders-review',
                            lock: true,
                        },
                        {
                            title: 'Referral NPI',
                            feature: 'report.findnpis',
                            route: 'report.findnpis',
                            icon: 'icon-ops',
                            sprite: 'sprite-ops',
                            lock: true,
                        },
                        {
                            title: 'Indigent Claims',
                            feature: 'report.indigent',
                            route: 'report.indigent',
                            icon: 'icon-users',
                            sprite: 'sprite-users',
                            rxmodels: utilSvc.aff.rxModelsByFeature('report.indigent'),
                            lock: true,
                        },
                        {
                            title: 'WAC Neutralizer',
                            feature: 'report.wacneut',
                            route: 'report.wacneut',
                            icon: 'glyphicon-adjust',
                            sprite: 'sprite-invoice-review',
                            wacneut: true,
                            lock: true,
                        },
                        {
                            title: 'Uninvoiced Items',
                            feature: 'report.unreplenished',
                            route: 'report.unreplenished',
                            icon: 'icon-orders-backlog',
                            sprite: 'sprite-orders-backlog',
                            rxmodels: utilSvc.aff.rxModelsByFeature('report.unreplenished'),
                            skipExpress: true,
                            lock: true,
                        },
                        {
                            title: 'UDS Reporting',
                            feature: 'report.uds',
                            route: 'report.uds',
                            icon: 'icon-history',
                            sprite: 'sprite-history',
                            rxmodels: utilSvc.aff.rxModelsByFeature('report.uds'),
                            lock: true,
                        },
                        {
                            title: 'Remittance Payments',
                            feature: 'report.remittance',
                            route: 'report.remittance',
                            icon: 'icon-history',
                            sprite: 'sprite-history',
                            lock: true,
                        },
                        {
                            title: 'Claims Submission',
                            feature: 'report.claimsub',
                            route: 'report.claimsubmission',
                            icon: 'icon-history',
                            sprite: 'sprite-history',
                            rxmodels: utilSvc.aff.rxModelsByFeature('report.claimsubmission'),
                            lock: true,
                        },
                    ],
                });
            } else {
                if (!!verisaveonly) {
                    mvm.push({
                        title: 'REPORT',
                        navItems: [
                            {
                                title: 'Savings',
                                feature: 'report.splitsavings',
                                route: 'report.splitsavings',
                                icon: 'icon-money',
                                sprite: 'sprite-money',
                                rxmodels: utilSvc.aff.rxModelsByFeature('report.splitsavings'),
                                lock: true,
                            },
                        ],
                    });
                } else {
                    mvm.push({
                        title: 'REPORT',
                        navItems: [
                            {
                                title: 'Contract Pharmacy',
                                feature: 'report.rx',
                                route: 'report.rx',
                                icon: 'icon-rx',
                                sprite: 'sprite-rx',
                                rxmodels: utilSvc.aff.rxModelsByFeature('report.rx'),
                                lock: true,
                            },
                            {
                                title: 'CP Financial',
                                feature: 'report.ce',
                                route: 'report.cpfin',
                                icon: 'icon-ce',
                                sprite: 'sprite-ce',
                                rxmodels: utilSvc.aff.rxModelsByFeature('report.cpfin'),
                                lock: true,
                            },
                            {
                                title: 'Pharmacy Invoice',
                                feature: 'report.rxbilling',
                                route: 'report.billing-rx',
                                icon: 'icon-rx',
                                sprite: 'sprite-rx',
                                rxmodels: utilSvc.aff.rxModelsByFeature('report.billing-rx'),
                                lock: true,
                            },
                            {
                                title: '340B Savings',
                                feature: 'report.splitsavings',
                                route: 'report.splitsavings',
                                icon: 'icon-money',
                                sprite: 'sprite-money',
                                rxmodels: utilSvc.aff.rxModelsByFeature('report.splitsavings'),
                                lock: true,
                            },
                            {
                                title: 'Indigent Claims',
                                feature: 'report.indigent',
                                route: 'report.indigent',
                                icon: 'icon-users',
                                sprite: 'sprite-users',
                                rxmodels: utilSvc.aff.rxModelsByFeature('report.indigent'),
                                skipExpress: true,
                                lock: true,
                            },
                            {
                                title: 'Audit',
                                feature: 'audit',
                                route: 'report.audit',
                                icon: 'icon-monitor',
                                sprite: 'sprite-orders-review',
                                rxmodels: utilSvc.aff.rxModelsByFeature('audit'),
                                lock: true,
                            },
                            {
                                title: 'WAC Neutralizer',
                                feature: 'report.wacneut',
                                route: 'report.wacneut',
                                icon: 'glyphicon-adjust',
                                sprite: 'sprite-invoice-review',
                                wacneut: true,
                                lock: true,
                            },
                            {
                                title: 'Uninvoiced Items',
                                feature: 'report.unreplenished',
                                route: 'report.unreplenished',
                                icon: 'icon-orders-backlog',
                                sprite: 'sprite-orders-backlog',
                                rxmodels: utilSvc.aff.rxModelsByFeature('report.unreplenished'),
                                skipExpress: true,
                                lock: true,
                            },
                            {
                                title: 'UDS Reporting',
                                feature: 'report.uds',
                                route: 'report.uds',
                                icon: 'icon-history',
                                sprite: 'sprite-history',
                                rxmodels: utilSvc.aff.rxModelsByFeature('report.uds'),
                                lock: true,
                            },
                            {
                                title: 'Remittance Payments',
                                feature: 'report.remittance',
                                route: 'report.remittance',
                                icon: 'icon-history',
                                sprite: 'sprite-history',
                                lock: true,
                            },
                            {
                                title: 'Claims Submission',
                                feature: 'report.claimsub',
                                route: 'report.claimsubmission',
                                icon: 'icon-history',
                                sprite: 'sprite-history',
                                rxmodels: utilSvc.aff.rxModelsByFeature('report.claimsubmission'),
                                lock: true,
                            },
                        ],
                    });
                }
            }
        }

        // INSIGHTS
        mvm.push({
            title: 'INSIGHTS',
            navItems: [
                {
                    title: 'Facility Reports',
                    feature: 'report.bi',
                    route: 'bi.facility',
                    icon: 'icon-money',
                    sprite: 'sprite-money',
                    lock: true,
                },
                {
                    title: 'KPI Reports',
                    feature: 'report.bi.kpi',
                    route: 'bi.kpi',
                    icon: 'icon-guage',
                    sprite: 'sprite-guage',
                    lock: true,
                },
            ],
        });

        // ABOUT
        var aboutNavItems = [
            {
                title: 'Contact Us',
                feature: 'about.corp',
                route: 'about.corp',
                icon: 'icon-about-contact',
                sprite: 'sprite-about-contact',
                params: { tab: 'CONTACT' },
            },
            {
                title: 'About Verity',
                feature: 'about.corp',
                route: 'about.corp',
                icon: 'icon-about-corp',
                sprite: 'sprite-about-corp',
                params: { tab: 'ABOUT' },
            },
        ];

        // user is logged in
        if (!!authValid) {
            aboutNavItems.push({
                title: 'Terms Of Use',
                feature: 'about.corp',
                route: 'about.corp',
                icon: 'icon-about-corp',
                sprite: 'sprite-vendor',
                params: { tab: 'TERMS' },
            });

            if (isDebug && (isVerity || isLocalDev)) {
                aboutNavItems.push({
                    title: 'Poster',
                    feature: 'about.software',
                    route: 'about.poster',
                    icon: 'icon-settings',
                    sprite: 'sprite-settings',
                });
                aboutNavItems.push({
                    title: 'Style',
                    feature: 'about.style',
                    route: 'about.style',
                    icon: 'icon-style',
                    sprite: 'sprite-settings',
                });
            }
        }

        mvm.push({
            title: 'ABOUT',
            navItems: aboutNavItems,
        });

        return mvm;
    }

    /**
     *    MENU GENERATION
     *    on auth change events re-generate the menu sections
     */

    function menuGeneration(authValid, usr) {
        // user menu rights sent from server

        var menu = menuVM(!!authValid),
            section = null,
            items = null,
            hasItems = false,
            lockSection = true,
            featureName = '',
            hasFeature = false,
            rxBizModels = [],
            hasCashCard = false,
            hasWacNeut = false,
            hasCdc = false;

        var i = 0,
            ii = 0,
            iii = 0,
            iiii = 0;

        usr = usr || {};
        var features = Array.isArray(usr.Features) ? usr.Features : [],
            affs = Array.isArray(usr.AffList) ? usr.AffList : [];
        var isExpress = vm.cobrand == 'express';

        // get list of biz models found in the affs list
        if (affs.length > 0) {
            rxBizModels = utilSvc.aff.rxModelList(affs, true);

            // feature checks
            for (i = 0; i < affs.length; i++) {
                if (!hasCashCard && !!affs[i].CECashCard) {
                    hasCashCard = true;
                }
                if (!hasWacNeut && !!affs[i].AffWacNeut) {
                    hasWacNeut = true;
                }
                if (!hasCdc && !!affs[i].RxCDC) {
                    hasCdc = true;
                }
                if (hasCashCard && hasWacNeut && hasCdc) {
                    // all features found, exit
                    break;
                }
            }
        }

        // debug biz models found
        if (vm.debug == 'on') {
            vm.debugItems.push('Biz Models: ' + rxBizModels.join(', '));
        }

        // loop menu sections
        // note: looping backwards so we can remove locked items on the fly
        for (i = menu.length - 1; i >= 0; i--) {
            // lock section by default
            lockSection = true;

            // loop menu items
            items = menu[i].navItems;
            hasItems = items.length > 0;
            for (ii = items.length - 1; ii >= 0; ii--) {
                // locked nav item?
                if (!!items[ii].lock) {
                    // find this feature in user features list
                    hasFeature = false;
                    featureName = items[ii].feature;
                    for (iii = 0; iii < features.length; iii++) {
                        if (featureName === features[iii].Name) {
                            hasFeature = true;

                            // rx models
                            if (Array.isArray(items[ii].rxmodels)) {
                                hasFeature = false;
                                for (iiii = 0; iiii < items[ii].rxmodels.length; iiii++) {
                                    if (rxBizModels.indexOf(items[ii].rxmodels[iiii]) > -1) {
                                        hasFeature = true;
                                        break;
                                    }
                                }
                            }

                            // care card
                            if (hasFeature && !!items[ii].cashcard) {
                                hasFeature = hasCashCard;
                            }

                            // wac neutrilizer
                            if (hasFeature && !!items[ii].wacneut) {
                                hasFeature = hasWacNeut || hasCdc;
                            }

                            // express cobrand
                            if (hasFeature && isExpress) {
                                hasFeature = !!!items[ii].skipExpress;
                            }

                            break;
                        }
                    }

                    // found feature?
                    if (hasFeature) {
                        // found, keep it in the menu, unlock the section
                        lockSection = false;
                    } else {
                        // user doesn't have menu rights for this nav item, remove it
                        items.splice(ii, 1);
                    }
                } else {
                    // nav item is not locked, include section
                    lockSection = false;
                }
            }

            // section is still locked after parsing all its items? remove it
            if (lockSection && hasItems) {
                menu.splice(i, 1);
            }
        }

        return menu;
    }

    /**
     *    MENU NAV CLICK
     */

    function navClick(navItem) {
        // not all nav items or section headers have a route
        if (!!!navItem || !validSvc.isText(navItem.route)) {
            return;
        }

        closeRightNavItems();

        var params = navItem.params || {},
            options = navItem.options || { reload: navItem.route, inherit: false };

        $state.go(navItem.route, params, options);

        // collapse the nav after click
        vm.navCollapse = true;
        $timeout(function () {
            vm.navCollapse = false;
        }, 1000);
    }

    function closeRightNavItems() {
        vm.showUserOptions = 'no';
        if (!!vm.alertInfo) {
            vm.alertInfo.show = 'no';
        }
    }

    /**
     *    USER ACCOUNT
     */

    function myAccount() {
        closeRightNavItems();
        $state.go('admin.user.myaccount', {}, { reload: 'admin.user.myaccount' });
    }

    function myPreferences() {
        closeRightNavItems();
        vm.showUserOptions = 'no';
        $state.go('admin.user.mypreferences', {}, { reload: 'admin.user.mypreferences' });
    }

    function logout() {
        closeRightNavItems();
        authService.logout().then(logoutDone, logoutDone);

        function logoutDone(r) {
            // do nothing
        }
    }

    /**
     *    ALERTS
     */

    function alertVM(r) {
        return {
            icon: 'icon-empty',
            MonitorType: r.MonitorType,
            PassChange: 'no',
            PassCountOld: 0,
            PassCount: validSvc.isInteger(r.Pass) ? r.Pass : 0,
            FailChange: 'no',
            FailCountOld: 0,
            FailCount: validSvc.isInteger(r.Fail) ? r.Fail : 0,
            Changed: validSvc.isDate(r.Changed) ? r.Changed : null,
            LastChecked: validSvc.isDate(r.LastChecked) ? r.LastChecked : null,
        };
    }

    function buildOldAlertsMap(oldItems) {
        var result = {},
            item = {};

        for (var i = 0; i < oldItems.length; i++) {
            item = oldItems[i];

            result[item.MonitorType] = {
                PassCount: item.PassCount,
                FailCount: item.FailCount,
                Changed: item.Changed,
                LastChecked: item.LastChecked,
            };
        }

        return result;
    }

    function getAlertInfo() {
        if (!validAlertUserType()) {
            return;
        }

        vm.alertInfo.ready = false;
        prefsRepo.getAlertInfo().then(okAlertInfo, errAlertInfo);

        function okAlertInfo(data) {
            var r = data.List,
                i = 0,
                ai = vm.alertInfo;

            // reset pong poll

            // build map of old monitors for quick lookup
            var hasOldAlerts = false,
                oldAlerts = {};
            if (ai.items !== undefined && ai.items.length > 0) {
                hasOldAlerts = true;
                oldAlerts = buildOldAlertsMap(ai.items);
            }

            // load latest alert items
            ai.items = [];
            var userNotify = false,
                foundFail = false,
                alert = {},
                oldAlert = {};

            for (i = 0; i < r.length; i++) {
                alert = alertVM(r[i]);

                // compare against previous alerts
                if (hasOldAlerts && !!oldAlerts[alert.MonitorType]) {
                    //console.log('alerts: compare to old alerts');
                    oldAlert = oldAlerts[alert.MonitorType];

                    // counts changed
                    if (alert.PassCount !== oldAlert.PassCount) {
                        alert.PassChange = 'yes';
                        alert.PassCountOld = oldAlert.PassCount;
                    }
                    if (alert.FailCount > 0 && alert.FailCount !== oldAlert.FailCount) {
                        alert.FailChange = 'yes';
                        alert.FailCountOld = oldAlert.FailCount;
                        foundFail = true;
                    }
                } else {
                    alert.PassChange = alert.PassCount > 0 ? 'yes' : 'no';
                    alert.FailChange = alert.FailCount > 0 ? 'yes' : 'no';
                }

                // alert item icon (set this regardless if user has notify set)
                if (alert.FailCount > 0) {
                    alert.icon = 'icon-alert-fail';
                } else if (alert.PassCount > 0) {
                    alert.icon = 'icon-alert-pass';
                }

                // this alert triggered user notify
                if (
                    !userNotify &&
                    ((ai.notifyPass == 'yes' && alert.PassChange == 'yes') ||
                        (ai.notifyFail == 'yes' && alert.FailChange == 'yes'))
                ) {
                    userNotify = true;
                    //console.log('alert: notify user pass/fail: ' + alert.PassChange + '/' + alert.FailChange);
                }
                var add = false;
                if (ai.notifyFail == 'yes' && alert.FailCount > 0) {
                    add = true;
                }
                if (ai.notifyPass == 'yes' && alert.PassCount > 0 && alert.FailCount === 0) {
                    add = true;
                }
                //console.log("Alert changed value is ",alert.Changed);
                //console.log("Alert changed value is ",alert.LastChecked);
                //console.log("Alert type is ",alert.MonitorType);

                if (add) {
                    ai.items.push(alert);
                }
            }

            ai.icon = 'icon-alert';
            if (data.TotalFail > 0) {
                ai.icon = 'icon-alert-fail';
                ai.TotalFail = data.TotalFail.toString();
            } else {
                ai.icon = 'icon-alert-pass';
                ai.TotalFail = '';
            }
            // set menu icon
            // if(userNotify) {
            // 	ai.icon = foundFail ? 'icon-alert-fail' : 'icon-alert-pass';
            // }
            // else {
            // }

            ai.ready = true;
        }

        function errAlertInfo(r) {
            // silent fail, alerts should not affect app state
            if (!!r) {
                //console.log(utilSvc.http.safeResponse(r));
            }
        }
    }

    function toggleAlertList() {
        vm.showUserOptions = 'no';
        var ai = vm.alertInfo;

        // hide if not ready or invalid user type
        if (!ai.ready || !validAlertUserType()) {
            ai.show = 'no';
            return;
        }

        if (ai.show == 'yes') {
            // toggle off
            ai.show = 'no';
        } else {
            // toggle on
            getAlertInfo();
            ai.show = 'yes';
        }
    }

    function alertNotifyToggle(propName) {
        var ai = vm.alertInfo;
        var alTargetVal = ai[propName];

        // toggle target to new val
        ai[propName] = alTargetVal == 'yes' ? 'no' : 'yes';
        getAlertInfo();
    }

    function gotoAlert(item) {
        if (!vm.alertInfo.ready) {
            return;
        }
        vm.alertInfo.ready = false;

        // Both CE and VERITY alerts deep-link into the merged React Data Monitor page.
        $state.go(
            'ops2.datamonitor.list',
            { MonitorType: item.MonitorType },
            { reload: 'ops2.datamonitor.list' }
        );

        // give monitor a couple seconds to load after click
        $timeout(function () {
            vm.alertInfo.ready = true;
        }, 2000);
    }

    /**
     * 	USER OPTIONS
     */

    function toggleUserOptions() {
        vm.showUserOptions = vm.showUserOptions != 'yes' ? 'yes' : 'no';
        if (vm.showUserOptions == 'yes') {
            vm.alertInfo.show = 'no';
        }
    }

    /**
     * 	NEW TAB
     */

    function newTab() {
        var tabs = sessionRepo.getLocalStoreKey('tabs');
        var tablist = !!tabs && Array.isArray(tabs.list) ? tabs.list : [];

        // new tab is already pending?
        if (_newTabId > 0) {
            for (var i = 0; i < tablist.length; i++) {
                if (tablist[i].id == 't' + _newTabId) {
                    // found pending tab id, ready for another new tab
                    _newTabId = 0;
                }
            }

            // new tab still loading, wait 20 seconds max
            if (_newTabId > 0 && Date.now() - _newTabId < 20000) {
                msgSvc.ok('Cannot Load Tab', 'Another new tab is currently loading');
                return;
            }
        }

        // check number of tabs already used
        if (tablist.length >= 5) {
            msgSvc.ok('Cannot Load Tab', 'Only 5 active tabs allowed');
            return;
        }

        vm.showUserOptions = 'no';
        _newTabId = Date.now();

        // auth service will request token from api, store it by tab key in local storage
        var tabIdKey = 't' + _newTabId.toString();
        authService.newTabRequest(tabIdKey).then(okTab, errTab);

        function okTab(r) {
            // build second tab url
            var port = $window.location.port;
            if (!!port && !isNaN(port)) {
                port = ':' + port.toString();
            } else {
                port = '';
            }

            var newTabUrl = urlPrefix() + '/#/newtab/t' + _newTabId.toString();
            $window.open(newTabUrl, '_blank');
        }

        function errTab(r) {
            if (!!r && validSvc.isText(r.msg)) {
                msgSvc.ok('Cannot Create Tab', r.msg);
            }
            _newTabId = 0;
        }
    }

    function gotoHelp(feature) {
        // open new tab with help content (need to set cookie for help content auth)
        var cook = 'content340b=' + sessionRepo.get('token');
        cook += ';max-age=' + (3600 * 4).toString(); // 4 hours max
        cook += ';secure';
        cook += ';path=/content';
        document.cookie = cook;

        // delay to set cookie first, then pop help
        setTimeout(function () {
            var contentFolder =
                vm.uType == 'VERITY' || vm.uType == 'VERITYSA' ? '/content/verity/' : '/content/customer/';
            var helpUrl = urlPrefix() + contentFolder + '?ts=' + Date.now().toString(); // leave off index.html on purpose
            $window.open(helpUrl, '_blank');
        }, 300);
    }

    function urlPrefix() {
        // build second tab url
        var port = $window.location.port;
        if (!!port && !isNaN(port)) {
            port = ':' + port.toString();
        } else {
            port = '';
        }
        return $window.location.protocol + '//' + $window.location.hostname + port;
    }

    /**
     *    AUTH EVENTS
     *    re-initialize user state on login/logout
     */

    $rootScope.$on('espui>auth.change', function (event, data) {
        //console.log('header: auth change');
        authChange();
    });

    $rootScope.$on('espui>user.profile.change', function (event, data) {
        // logged in user updated their profile
        var lname = validSvc.isText($rootScope.User.Lname) ? $rootScope.User.Lname.substring(0, 1) : '';
        vm.acctName = $rootScope.User.Fname + ' ' + lname;
    });

    $rootScope.$on('espui>uilanding', function (event, uiLanding) {
        // show header when landing mode is off
        vm.show = !!!uiLanding.on;
    });

    $rootScope.$on('espui>cobrand', function (event, brand) {
        vm.cobrand = brand;
    });

    $rootScope.$on('espui>pong', function (event, data) {
        //console.log('HEADER PONG');
        // app just finished successful pong, re-get alert status
        if (vm.show && vm.authValid) {
            getAlertInfo();
        } else {
            vm.showUserOptions = 'no';
            resetAlerts();
        }

        // update tab timestamps on each successful pong
        $timeout(manageTabList, 3000);
    });

    function manageTabList() {
        // stop managing if my tab is not active
        if (!!!$rootScope.startUp || !!!$rootScope.User) {
            return;
        }

        var tabs = sessionRepo.getLocalStoreKey('tabs'),
            dtNow = new Date(),
            myTabId = $rootScope.tabId;

        // tabs never created yet
        if (!!!tabs) {
            if (sessionRepo.hasLocalStorage()) {
                sessionRepo.setLocalStoreKey('tabs', {
                    lock: null,
                    list: [{ id: myTabId, pongTime: dtNow }],
                });
            }
            return;
        }

        // another tab is managing tabs, try later
        if (!!tabs && validSvc.isDate(tabs.lock) && utilSvc.dt.diffMinutes(new Date(tabs.lock), dtNow) < 1) {
            $timeout(manageTabList, 3000);
            return;
        }

        // manage tab list
        tabs.lock = dtNow;
        sessionRepo.setLocalStoreKey('tabs', tabs);

        var tabList = tabs.list,
            foundMyId = false;
        for (var i = tabList.length - 1; i >= 0; i--) {
            // found my tab id
            if (tabList[i].id == myTabId) {
                // already in the list?
                if (foundMyId) {
                    tabList.splice(i, 1);
                } else {
                    foundMyId = true;
                    tabList[i].pongTime = dtNow;
                }
            } else if (utilSvc.dt.diffMinutes(new Date(tabList[i].pongTime), dtNow) > 5) {
                // tab not active, remove it, any other tab should have ponged by now
                tabList.splice(i, 1);
            }
        }

        // didn't find my tab, put it in
        if (!foundMyId) {
            if (tabList.length >= 5) {
                tabs.lock = null;
                sessionRepo.setLocalStoreKey('tabs', tabs);
                $rootScope.$emit('espui>auth.tabmax');
            }
            tabList.push({ id: myTabId, pongTime: dtNow });
        }

        // release lock and save
        tabs.lock = null;
        tabs.list = tabList;
        sessionRepo.setLocalStoreKey('tabs', tabs);
    }
} 
msgBoxCtl.$inject = ['$window', '$rootScope', '$state', '$timeout', '$sce', 'validSvc', 'sessionRepo'];
angular
.module('espui.main')
.controller('MsgBoxController', msgBoxCtl);

/* @ngInject */
function msgBoxCtl($window, $rootScope, $state, $timeout, $sce, validSvc, sessionRepo) {

	/*jshint validthis: true */
	var vm = this;
	var _waitStartTimestamp = 0,
		_waitTimeoutId = null,
		_waitTimeout = 60000,
		_flyinFilepath = '';


	/**
	 *    PUBLIC PROPS
	 */

	vm.isWaiting = false; // exposes this prop for unit tests

	vm.minWaitTime = 1000; // expose this publically for unit tests
	vm.visible = false;
	vm.msgType = '';
	vm.msgId = '';
	vm.showDetail = false;

	vm.waitTop = '0px';
	vm.waitMsg = 'Loading...';

	// model
	vm.display = {};

	// methods
	vm.clicked = clicked;

	// inline help
	vm.iframeOnLoad = iframeOnLoad;

	// help center
	vm.goToHelpCenter = goToHelpCenter;


	/**
	 *    VISIBILITY
	 *    set visibility on this scope and parent scope
	 */

	function setVisibility(isVisible) {
		vm.visible = isVisible;
		$rootScope.vmAppShowMsgbox = isVisible;
	}


	/**
	 *    INIT
	 */

	init();

	function init() {
		//console.log('MSGBOX INIT');
		resetUi();
	}


	/**
	 *    CLICKED
	 *    user dismissed the message box by clicking a button or clicking the background
	 */

	function clicked(result) {

		if(vm.msgType == 'error.unexpected') {

			// reload app on all unexpected errors
			resetUi();
			$state.go('startup', {}, {reload:'startup', inherit:false});
			return;
		}
		else if(vm.msgType == 'release' && result == 'OPEN') {
			openReleaseNote(vm.display.version);
		}
		else if(vm.msgType == 'wait') {

			// user cannot dismiss wait ui
			return;
		}
		else if(result == 'COPY') {
			textToClipboard(vm.display.detail);
			alert("Copied to clipboard");
			return;
		}
		else if(vm.msgType == 'help-flyout') {
			// user clicked off help flyout, slide out then reset
			flyoutOff();
			return;
		}
		else if(!!vm.msgId) {

			// get user notes
			var notes = '';
			if(!!vm.display.notes && typeof(vm.display.notes.out) === 'string') {
				notes = vm.display.notes.out;
			}

			// emit result event if msg has id
			$rootScope.$emit('espui>msgbox.result', {id: vm.msgId, result: result, notes: notes});
		}

		// convert to waiting UI if still waiting
		// note: its possible to be showing a non-wait msg type and wait is set to true
		if(vm.isWaiting) {
			vm.isWaiting = false; // flip to false to force a full wait ui start up
			waitOn(true);
			return;
		}
		else {
			// hide msgbox
			resetUi();
		}

	}

	function flyoutOff() {
		// slide out then reset
		vm.display.flyshow = false;
		$timeout(function() {
			resetUi();
		}, 300);
	}


	/**
	 *    EVENT HOOK > MSGBOX
	 *    listen for message box request events
	 */

	$rootScope.$on('espui>msgbox.show', function (event, data) {

		// setup ui properties depending on msg type
		// note: last message wins, previous is cleared

		// valid msgbox event
		if(!!!data || !validSvc.isText(data.msgType)) {
			throw new Error('msgBox.HookMsgEvent, msgType missing');
		}

		// stop if an error is already displayed
		if(isErrorMsg(vm.msgType)) {
			return;
		}

		// msgbox type
		if(data.msgType == 'wait') {
			waitUi(data);
		}
		else if(data.msgType == 'confirm') {
			confirmUi(data.msgId, data.msg, data.buttons, data);
		}
		else if(data.msgType == 'info') {
			infoUi(data.msg, data);
		}
		else if(data.msgType == 'ok') {
			okUi(data.msgId, data.msg, data);
		}
		else if(data.msgType == 'help') {
			okHelp(data.title, data.folder);
		}
		else if(data.msgType == 'release') {
			okRelease(data.version);
		}
		else {
			// unknown type
			resetUi();
			throw new Error('msgBox.HookMsgEvent, msgType unknown: ' + data.msgType);
		}


	});


	/**
	 *    MSGBOX UI DISPLAY
	 *    methods used to setup different types of message boxes
	 */

	function resetWait() {

		vm.waitMsg = 'Loading...';
		_waitStartTimestamp = 0;
		vm.isWaiting = false;

		if(_waitTimeoutId !== null) {
			try {
				$timeout.cancel(_waitTimeoutId);
			}
			catch(err) {
				// do nothing, just clearing the timeout
			}
			_waitTimeoutId = null;
		}
	}

	function resetUi() {
		//console.log('MSGBOX RESET');
		setVisibility(false);

		vm.display = {};
		vm.msgType = '';
		vm.msgId = '';
		vm.showDetail = false;

		resetWait();

	}

	function okUi(msgId, msg, data) {

		// info must have either a title or message
		if(!validSvc.isText(msg) && !validSvc.isText(data.title)) {
			throw new Error('msgBox.okUi, must have either a title or a msg');
		}
		msg = validSvc.isText(msg) ? msg : '';
		msgId = validSvc.isText(msgId) ? msgId : '';
		data.title = validSvc.isText(data.title) ? data.title : '';

		resetUi();

		vm.msgType = msgId == 'app.session.timeout' ? 'timeout' : 'ok';
		vm.msgId = msgId;
		vm.display = {
			title: data.title,
			msg: msg,
			detail: '',
			async: !!data.async,
			buttons: [{text:'OK', result:'OK', cancel: false}]
		};

		setVisibility(true);

	}

	function okHelp(title, folder) {

		// must have title and message
		if(!validSvc.isText(title) || !validSvc.isText(folder)) {
			alert('msgBox.okHelp, must have title and folder');
		}

		resetUi();

		// QA check
		var config = $rootScope.appConfig || {};
		var env = validSvc.isText(config.env) ? config.env : '';
		var flyoutEnv = (env == 'local' || env == 'dev' || env == 'qa');

        // flyout for everyone
        var fileName = inlineHelpFileNameExceptions(folder) + '.html'; // inline help converts folders into html files
        _flyinFilepath = getInlineHelpFolder($rootScope.User.Type) + cacheBreak(fileName);
        vm.msgType = 'help-flyout';
        vm.display = {
            path: undefined,
            flyshow: false,
            fadeIn: false
        };
        console.log('help url: ' + _flyinFilepath);
        setContentCookie();

        // wait for cookie set, then display
        $timeout(function(){
            setVisibility(true);
            // slide in before loading content
            $timeout(function() {
                vm.display.flyshow = true;
                $timeout(function() {
                    // load iframe content after smooth slide in
                    vm.display.path = $sce.trustAsResourceUrl(_flyinFilepath);
                }, 500);
            },300);
        }, 300);
	}

	function goToHelpCenter() {
		// verify we are still in help-flyout mode
		if(vm.msgType != 'help-flyout' || !vm.display.flyshow) {
			return;
		}

		flyoutOff();

		// open help center in new tab
		var helpCenterUrl = getFlareFolder($rootScope.User.Type) + cacheBreak(''); // leave off index.html on purpose
		$window.open(helpCenterUrl, '_blank');
	}

	function iframeOnLoad(src) {
		// called when iframe content is loaded
		
		// verify we are still in help-flyout mode
		if(vm.msgType != 'help-flyout' || !vm.display.flyshow || !!vm.display.fadeIn) {
			return;
		}

		// if src is valid fade in iframe
		console.log('msgBox.iframeOnLoad, src: ' + src);
		if(validSvc.isText(src)) {
			vm.display.fadeIn = true;
		}
	}

	function inlineHelpFileNameExceptions(fileName) {
		// special cases for inline help file names
		// translate from i340b into flare file names
		switch(fileName) {
			case 'admin-users-permissions':
				return 'admin-users-permissions-v';
			case 'admin-users-permissions-facility':
				return 'admin-users-permissions-c';
			default:
				return fileName;
		}
	}

	function cacheBreak(file) {
		return file + '?v=' + Date.now().toString();
	}

	function setContentCookie() {
		// open new tab with help content (need to set cookie for help content auth)
		var cook = "content340b=" + sessionRepo.get("token");
		cook += ";max-age=" + (3600 * 4).toString(); // 4 hours max
		cook += ";secure";
		cook += ";path=/content";
		document.cookie = cook;
	}

	function getFlareFolder(userType) {
		switch(userType) {
			case 'VERITYSA':
			case 'VERITY':
				return urlPrefix() + '/content/verity/';
			case 'CE':
			case 'RX':
				return urlPrefix() + '/content/customer/';
			default:
				throw new Error('msgBox.getFlareFolder, unknown user type: ' + uType);
		}
	}

	function getInlineHelpFolder(userType) {
		switch(userType) {
			case 'VERITYSA':
			case 'VERITY':
				return getFlareFolder(userType) + 'inlinehelp/Content/F_inlinehelp/';
			case 'CE':
			case 'RX':
				return getFlareFolder(userType) + 'inlinehelp/' + userType.toLowerCase() + '/Content/F_inlinehelp/';
			default:
				throw new Error('msgBox.getFlareFolder, unknown user type: ' + uType);
		}
	}

	function getAssetsFolder() {
		// build assets folder url
		return urlPrefix() + '/assets/';
	}

	function okRelease(version) {

		// must have version
		if(!validSvc.isText(version)) {
			alert('msgBox.okRelease, must have version');
		}

		resetUi();

		vm.msgType = 'release';
		vm.display = {
			version: version
		};

		setVisibility(true);
	}

	function openReleaseNote(version) {
		setContentCookie();

		// delay to set cookie first, then pop content tab
		setTimeout(function() {
			var contentUrl = getFlareFolder($rootScope.User.Type) + 'Content/C-Resources/ReleaseNotes/' + cacheBreak('RN_Sprint' + version + '.html');
			$window.open(contentUrl, '_blank');
		}, 300);
	}

	function urlPrefix() {
		// build second tab url
		var port = $window.location.port;
		if(!!port && !isNaN(port)) {
			port = ':' + port.toString();
		}
		else {
			port = '';
		}
		return $window.location.protocol + '//' + $window.location.hostname + port;
	}


	function infoUi(msg, data) {

		// info must have a message
		if(!validSvc.isText(msg)) {
			throw new Error('msgBox.infoUi, must have msg text');
		}

		resetUi();

		vm.msgType = 'info';
		vm.msgId = '';
		vm.display = {
			title: validSvc.isText(data.title) ? data.title.toUpperCase() : 'INFO',
			msg: msg,
			detail: isVerityViewer($rootScope.User) ? data.detail : '',
			buttons: Array.isArray(data.buttons) ? data.buttons : [{text:'OK', result:'OK', cancel: false}]
		};

		setVisibility(true);

	}

	function confirmUi(msgId, msg, buttons, data) {

		// confirmations must have an id, msg and buttons
		if(!validSvc.isText(msgId) || !validSvc.isText(msg) || !Array.isArray(buttons) || buttons.length < 1) {
			throw new Error('msgBox.confirmUi, confirm msg must have an id, msg text and buttons');
		}

		resetUi();

		vm.msgType = 'confirm';
		vm.msgId = msgId;
		vm.display = {
			title: validSvc.isText(data.title) ? data.title.toUpperCase() : 'CONFIRM',
			msg: msg,
			detail: data.detail || '',
			notes: data.notes || {},
			buttons: buttons
		};

		setVisibility(true);

	}

	function waitUi(data) {

		// shows or hides wait gif

		data = data || {};

		// wait on or off
		if(data.wait == 'on') {

			if(vm.msgType === '') {
				waitOn(!!data.immediate);
			}
			else if(!vm.isWaiting) {
				// show wait spinner while other message is displayed
				_waitStartTimestamp = Date.now();
				vm.isWaiting = true;
				waitOff();
			}

		}
		else if(data.wait == 'off') {
			vm.isWaiting = false;
		}
		else {
			throw new Error('msgBox.waitUi, data.wait must be on or off, unknown: ' + data.wait);
		}

	}

	function waitOn(immediate) {

		// already waiting? extend wait timeout
		if(vm.isWaiting) {
			_waitStartTimestamp = Date.now();
			return;
		}

		// middle of viewport height (min 100px)
		var y = $window.innerHeight;
		if(validSvc.isNumber(y)) {
			y = (y / 2) - 150;
			if(y < 100) {
				y = 100;
			}
		}
		else {
			y = 100;
		}
		vm.waitTop = y.toString() + 'px';

		// switch ui to wait status
		resetUi();
		vm.msgType = 'wait';
		vm.isWaiting = true;

		// show immediately or debounce half second
		var debounceTime = !!immediate ? 0 : 500;
		$timeout(function() {

			// exit if waiting already done
			if(!vm.isWaiting) {
				resetWait();
				return;
			}

			// show and animate
			_waitStartTimestamp = Date.now();
			setVisibility(true);
			// task: green sock animation

			// start recursive waitOff
			waitOff();

		}, debounceTime);

	}

	function waitOff() {

		// calls itself until not waiting or max time elapsed

		var elapsed = Date.now() - _waitStartTimestamp;

		if(!vm.isWaiting && elapsed < 600) {
			// wait too short

			// pause for at least 1 second to avoid flicker
			_waitTimeoutId = $timeout(function() {
				waitOff();
			}, 1100 - elapsed);

		}
		else if(!vm.isWaiting || elapsed >= _waitTimeout) {
			// wait is over or exceeded max time

			// ui is still in wait mode? complete reset
			if(vm.msgType == 'wait') {
				resetUi();
			}
			else {
				// ui is in different mode, just kill the wait settings
				resetWait();
			}
		}
		else {
			if(elapsed > 600) {
				setVisibility(true);
			}

			// wait again
			$timeout(function() {
				waitOff();
			}, 800);

		}

	}


	/**
	 *    EVENT HOOK > LOGOUT (user logged out or app timed out on 401)
	 */
	$rootScope.$on('espui>auth.logout', function(event, data) {
		resetUi();
	});


	/**
	 *    EVENT HOOK > ERROR EVENTS
	 *    default error handler and errSvc emit this event
	 *    note: all feature errors use errSvc methods: info, warn, unexpected
	 */
	$rootScope.$on('espui>error', function(event, data) {

		// build error VM if totally missing
		data = data || {};

		// load err object
		var errData = errVM(
			data.msgType,
			data.msg,
			data.stack,
			data.status,
			data.detail,
			data.line
		);

		// clear all msgSvc pending messages
		$rootScope.$emit('espui>msgbox.clearall', {});

		errorUi(errData);

	});


	/**
	 *    ERROR MESSAGE DISPLAY
	 *    controls error display properties
	 */

	function errorUi(err) {

		resetUi();

		// clean up connection errors
		if(err.status === 0 || err.status === '0' ||
			err.status === -1 || err.status === '-1' ||
			err.status === 502 || err.status === '502') {
			err.status = 'NETWORK';
			err.msg = 'Network Connection Issue';
			err.msgType = 'error.unexpected';
		}

        // Verity gets extra debug info
        var stackInfo = '',
            lineInfo = '',
            detailInfo = '';
        if(isVerityViewer($rootScope.User)) {
            stackInfo = err.stack;
            lineInfo = err.line;
            detailInfo = err.detail;
        }

		vm.msgType = err.msgType;
		vm.msgId = '';
		vm.display = {
			msgType: err.msgType,
			msg: err.msg,
			stack: stackInfo,
			status: err.status,
			detail: detailInfo,
			line: lineInfo,
			title: errTitleUi(err.msgType),
			buttons: [{text:'OK', result:'OK', cancel: false}]
		};

		setVisibility(true);

	}

	function errTitleUi(msgType) {
		if(msgType === 'error.unexpected') {
			return 'UNEXPECTED ERROR';
		}
		else if(msgType === 'error.warn') {
			return 'NOTIFY';
		}
		else if(msgType === 'error.info') {
			return 'INFO';
		}
	}


	/**
	 *    APP-WIDE ERROR VIEW MODEL
	 *    all error and message services use this format
	 *    note: errors are injected before any service, this has to be repeated inside every factory or provider which uses it
	 */

	function errVM(msgType, msg, stack, status, detail, line) {
		return {
			msgType: isErrorMsg(msgType) ? msgType : 'error.unexpected',
			msg: msg || 'unknown',
			stack: !!stack ? stack.toString() : $window.location.toString() + '-- stack: none',
			status: !!status || !isNaN(status) ? status.toString() : '',
			detail: detail || '',
			line: line || ''
		};
	}

	function isErrorMsg(msgType) {

		// helper to see if a msg type is an error
		return msgType === 'error.unexpected' || msgType === 'error.warn' || msgType === 'error.info';

	}

	function textToClipboard (text) {
		var dummy = document.createElement("textarea");
		document.body.appendChild(dummy);
		dummy.value = text;
		dummy.select();
		document.execCommand("copy");
		document.body.removeChild(dummy);
	}

    function isVerityViewer(usr) {
        return !!usr && (!!usr.Impersonate || usr.Type === 'VERITYSA' || usr.Type === 'VERITY');
    }

}
 
loginController.$inject = ['$window', '$rootScope', '$scope', '$state', '$timeout', '$sce', 'authService', 'userRepo', 'sessionRepo', 'utilSvc', 'validSvc', 'errSvc', 'msgSvc'];angular
.module('espui.login')
.controller('LoginController', loginController);

/* @ngInject */
function loginController($window, $rootScope, $scope, $state, $timeout, $sce, authService, userRepo, sessionRepo, utilSvc, validSvc, errSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _isNewUser = false,
		_devEnv = false,
		_isOktaReturn = false;

	// inherit
	msgSvc.addHelpLink(vm);

	var MFA_VALIDATE = 'VALIDATE';
	var MFA_ACTIVATE = 'ACTIVATE';
	var MFA_ENROLL = 'ENROLL';
	var MFA_EDIT = 'EDIT';
	var MFA_SEND = 'SEND';

	var MFA_EMAIL = 'email';
	var MFA_PHONE = 'sms';

	// properties
	vm.isWaiting = false;
	vm.action = '';

	// display
	vm.loginTitle = '';
	vm.loginMsg = '';
	vm.loginIcon = ''; // ie fix for ng-class blow up
	vm.showDismiss = false;
	vm.dismissOK = dismissOK;

	vm.model = {};

	// methods
	vm.submit = submit;
	vm.pwdUpdate = pwdUpdate;
	vm.onChangePwdText = onChangePwdText;

	// terms
	vm.termsText = '';
	vm.termsId = '';
	vm.termsAgree = termsAgree;

	// forgot pwd
	vm.pwdForgot = pwdForgot;
	vm.pwdRequest = pwdRequest;

	// security q/a
	vm.saveQA = saveQA;

	// ui landing, cobranding
	vm.uiLanding = false;
	vm.cobrand = $rootScope.cobrand;
	vm.cobrandCSS = cobrandCSS;

	// gui animation bars
	vm.guiBars = [];
	var _guiCurrent = 0;
	vm.guiBarAdvance = guiBarAdvance;

	// mfa
	vm.mfa = {};
	vm.mfaTryCode = mfaTryCode;
	vm.mfaSend = mfaSend;
	vm.mfaEdit = mfaEdit;
	vm.mfaEditCancel = mfaEditCancel;

	// mfa enroll phone
	vm.mfaEnrollPhoneToggle = mfaEnrollPhoneToggle;
	vm.mfaEnrollPhoneSubmit = mfaEnrollPhoneSubmit;
	vm.mfaPhoneTabNext = mfaPhoneTabNext;

    // partner sso
    vm.partner = {};
    vm.partnerShowLink = partnerShowLink;
    vm.partnerStartSSO = partnerStartSSO;
	

	/**
	 *    INIT
	 */

	init();

	function init() {
		//console.log('LOGIN INIT');
		vm.isWaiting = false;

		// maintenance check
		var maintMode = $rootScope.appConfig.maint.mode;
		if(maintMode == 'on') {
			$state.go('startup',{},{reload:'startup'});
			return;
		}

		// environment
		var env = $rootScope.appConfig.env;
		_devEnv = env == 'local';
		vm.model = loginVM();

		// login reason from route
		vm.action = validSvc.isText($state.params.reason) ? $state.params.reason : '';

		// ui landing / co-brand saved in deep link on start up
        // DEPRECATED during krogersso work
		// var dl = $rootScope.deepLink || {};
		// if(!!dl.params) {
		// 	// if(dl.params.reason == 'uilanding') {
		// 	// 	// note: ui landing will override cobranding, see cobrandCSS
		// 	// 	vm.uiLanding = true;
		// 	// 	vm.action = 'loginland';
		// 	// }
		// }

		// gui bars
		if(vm.action != 'loginland') {
			_guiCurrent = 1;
			vm.guiBars = loadGuiBars();
			// bar movement tbd...
			// $timeout(function(){
			// 	guiBarAdvance();
			// }, 2000);
		}

		// no specific action (regular login)
		if(vm.action === '') {

			// if User already exists clean up any previous session, pong timers and menus before showing login
			if(!!$rootScope.User) {
				$rootScope.$emit('espui>auth.logout', {reason:'login_cleanup'});
			}
			vm.action = 'login';
		}

		updateDisplay(vm.action);

		// blocked, add specific support id prefix
		if(vm.action == 'block') {
			vm.loginMsg = 'Support Id: ' + $state.params.token;
		}

		// maintenance message
		if(maintMode == 'warn') {
			vm.loginIcon = 'icon-maint';
			vm.loginTitle = 'Website Maintenance Scheduled';
			vm.loginMsg = $rootScope.appConfig.maint[maintMode];
		}
		// activate or pwd reset?
		var params = $state.params || {};
		// PARTNER SSO: Phase 3 Registration UI - 3.1 Detect activatesso Route
		if(vm.action == 'activate' || vm.action == 'activatesso' || vm.action == 'pwdreset' || vm.action == 'newtab') {
			_isNewUser = vm.action == 'activate' || vm.action == 'activatesso';
			checkToken(params.token);
			return;
		}            

        // okta return handling for workforce or partner sso user
        handleOktaReturn(vm.action == 'okta-return', params.token);
	}

    // PARTNER SSO: Phase 4 Login UI - 4.7 Okta Return Success
    // PARTNER SSO: Phase 4 Login UI - 4.8 Okta Return Workforce Error
    // PARTNER SSO: Phase 4 Login UI - 4.9 Okta Return Partner Error
    function handleOktaReturn(isOktaReturn, returnData) {
        // derive workforce or partner sso pass or fail
        returnData = returnData || {};
        var isWorkforce = !!sessionRepo.getLocalStoreKey('verity_login');

        if(!isOktaReturn) {
            // verity users here by accident, send to workforce login
            if(isWorkforce) {
                $state.go('verity.login',{},{reload:'verity.login'});
            }
            return;
        }

        // okta success: continue login checks
        if(validSvc.isText(returnData.s)) {
            _isOktaReturn = true;
            sessionRepo.set('token', returnData.s);
            okLogin();
            return;
        }

        // okta error: workforce
        if(isWorkforce) {
            if(validSvc.isText(returnData.error)) {
                // salvage error msg
                sessionRepo.set('okta-return', {error:returnData.error});
            }
            $state.go('verity.login',{},{reload:'verity.login'});
            return;
        }

        // okta error: partner sso, show in login page
        vm.action = 'login';
        updateDisplay(vm.action);

        if(login422PartnerErr(returnData.error)) {
            // well formed partner PARTNER-ERR response
            return;
        }

        // unexpected, show generic error
        vm.partner = {
            fail: 'yes',
            msg: validSvc.isText(returnData.error) ? returnData.error : 'Partner Account Error',
            info: []
        };
        msgSvc.ok('Cannot Sign In', 'Partner Account Error');
    }


	/**
	 *    VIEW MODELS
	 */

	function loginVM() {

		var model = {
			Email: validSvc.newProp(''),
			Pwd: validSvc.newProp(''),
			PwdConfirm: validSvc.newProp('')
		};

		// pre-fill in dev mode
		if(_devEnv) {
			model.Email.val = 'dev@verity340b.com';
			model.Pwd.val = 'Devination340b!';
		}

		return model;
	}

	function forgotVM() {

		return {
			Email: validSvc.newProp(''),
			Question: validSvc.newProp(''),
			Answer: validSvc.newProp('')
		};

	}


	/**
	 *    LOGIN
	 */

	function loginComplete() {

		// clear model and throw event to load home page
		vm.model = {};
		$rootScope.$emit('espui>auth.login', {});

	}

	function onChangePwdText() {
		// check pwd strength as user types
		if(vm.action != 'pwdactivate' && vm.action != 'pwdupdate' && vm.action != 'pwdresetemail') {
			return;
		}
		var mp = vm.model.Pwd;
		var pwd = validSvc.isText(mp.val) ? mp.val : '';
		mp.hasLength = pwd.length >= 8 && pwd.length <= 30;
		mp.hasUpper = validSvc.hasUpperCaseLetter(pwd);
		mp.hasLower = validSvc.hasLowerCaseLetter(pwd);
		mp.hasNumber = validSvc.hasNumber(pwd);
		mp.hasSymbol = validSvc.hasSymbol(pwd);
		mp.hasSpace = validSvc.hasSpace(pwd);
		mp.notAllowed = notAllowedCharacters(pwd).substring(0,5); // show only 5
	}

	function validatePwd(val, testComplexity) {

		var valid = true,
			pwd = validSvc.isText(val) ? val : '';
		
		// length
		valid = pwd.length >= 8 && pwd.length <= 30;

		if(valid && !!testComplexity) {
			// upper and lower case letters
			// at least one symbol, at least one number
			// no spaces
			var regexComplex = utilSvc.regex.loginPwd();
			valid = regexComplex.test(pwd);
		}

		return valid;
	}

	function notAllowedCharacters(val) {
		// loop all characters looking for not allowed
		if(!validSvc.isText(val) || val.length < 1) {
			return '';
		}

		var result = '',
			c = '';
		for(var i = 0; i < val.length; i++) {
			c = val[i];
			if(!validSvc.hasUpperCaseLetter(c) && !validSvc.hasLowerCaseLetter(c) &&
				!validSvc.hasNumber(c) && !validSvc.hasSymbol(c) && !validSvc.hasSpace(c)) {
				result += c;
				if(result.length > 4) {
					break; // stop at 5
				}
			}
		}
		return result;
	}

    function validateEmail(model) {
        model.Email = validSvc.setResult(validSvc.isText(model.Email.val), model.Email, 'required, email format: name@domain.com');
        if(model.Email.fail == 'no') {
            model.Email.val = model.Email.val.toLowerCase();
        }
        return model;
    }

    // PARTNER SSO: Phase 3 Registration UI - 3.2 Email-only validation for activatesso
	// PARTNER SSO: Phase 4 Login UI - 4.1 User Name Prompt (login + activatesso skip pwd)
	function validCreds(model, isNewPassword) {

		// validate pwd and confirmation
		var pwd = model.Pwd.val,
			conf = model.PwdConfirm.val;

		// email - always required
        model = validateEmail(model);

        // login step 1 and activate sso do not use pwd
        if(vm.action == 'login' || vm.action == 'activatesso' || vm.action == 'partneractivate') {
            model.Pwd = validSvc.newProp('');
            model.PwdConfirm = validSvc.newProp('');
            return model.Email.fail != 'yes';
        }

		// pwd - required, length check
		if(!validatePwd(pwd, isNewPassword)) {
			model.Pwd.fail = 'yes';
			model.PwdConfirm = validSvc.newProp('');

			pwd = validSvc.isText(pwd) ? pwd.trim() : '';
			if(pwd.length < 1) {
				model.Pwd.msg = 'required';
			}
			else if(isNewPassword) {
				var mp = model.Pwd;
				mp.msg = 'Password Strength Issue';
				mp.hasLength = pwd.length >= 8 && pwd.length <= 30;
				mp.hasUpper = validSvc.hasUpperCaseLetter(pwd);
				mp.hasLower = validSvc.hasLowerCaseLetter(pwd);
				mp.hasNumber = validSvc.hasNumber(pwd);
				mp.hasSymbol = validSvc.hasSymbol(pwd);
				mp.hasSpace = validSvc.hasSpace(pwd);
				mp.notAllowed = notAllowedCharacters(pwd).substring(0,5); // show only 5
			}
		}
		else {
			model.Pwd.fail = 'no';

			// confirm must match pwd
			if((vm.action == 'pwdactivate' || vm.action == 'pwdupdate' || vm.action == 'pwdresetemail')) {
				model.PwdConfirm = validSvc.setResult(pwd === conf, model.PwdConfirm, 'Confirmation must match password');
				if(model.PwdConfirm.fail == 'yes') {
					model.Pwd.msg = model.PwdConfirm.msg;
				}
			}
			else {
				model.PwdConfirm = validSvc.newProp('');
			}
		}

		return	model.Email.fail != 'yes' &&
			model.Pwd.fail != 'yes' &&
			model.PwdConfirm.fail != 'yes';

	}

	function submit() {

		if(vm.isWaiting) {
			return;
		}

		// submit is fired for all ui states, redirect submit as appropriate
		switch(vm.action) {

            case 'login-sso':
                // ignore auto-submit for partner sso
                break;
			case 'login':
            case 'login-pwd':
			case 'loginland':
				goLogin();
				break;

			case 'pwdforgot':
			case 'pwdanswer':
				pwdRequest();
				break;
			case 'getanswer':
				saveQA();
				break;
			case 'mfa':
				if(vm.mfa.Action == MFA_VALIDATE) {
					mfaTryCode(MFA_VALIDATE);
				}
				else if(vm.mfa.Action == MFA_EDIT && vm.mfa.PhoneEdit == MFA_ACTIVATE) {
					mfaTryCode(MFA_ACTIVATE);
				}

				break;
			default:
				// in all other cases this is a password save, transfer to pwdUpdate
				pwdUpdate();
		}

	}

	// PARTNER SSO: Phase 4 Login UI - 4.1 User Name Prompt (sends email to security/login)
	function goLogin() {

		if(!validCreds(vm.model)) {
			msgSvc.ok('Sign In', 'Cannot continue, please check properties.');
			return;
		}

		vm.isWaiting = true;
		vm.mfa = mfaVM();
        vm.partner = {};

		authService.login(vm.model.Email.val, vm.model.Pwd.val).then(okLogin, errLogin);
	}

	function okLogin(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		// okta bypass pwd and mfa
		if(_isOktaReturn) {
			//console.log('OKTA: check IP');
			if(checkIpValid()) {
				//console.log('OKTA: check User');
				if(checkOktaUser()) {
					//console.log('OKTA: check TOU');
					checkTerms();
				}
			}
		}
		else {
			// api sets TwoFactor during login
			// note: this function is called by other functions in this controller, r may be undefined
			if(!!r && r.TwoFactor) {
				vm.mfa = mfaVM({
					Action: MFA_VALIDATE,
					OktaCustomer: r.OktaCustomer,
					Phone: validSvc.isText(r.OktaMfaPhone) ? r.OktaMfaPhone : '',
					Factor: r.OktaDefaultFactor == MFA_PHONE ? MFA_PHONE : MFA_EMAIL,
				});
			}

			if(checkIpValid()) {
				if(checkPasswordExpired()) {
					if(checkTwoFactor()) {
						checkTerms();
					}
				}
			}
		}
	}

	// PARTNER SSO: Phase 4 Login UI - 4.1 User Name Prompt (422 routing to step1 handler)
	function errLogin(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

        // step 1 - username 422 handler
        if(vm.action == 'login' && loginStep1Handler(r)) {
            // note: this will advance the display
            return;
        }

        // general existing login error output for all users
		// reset pwd only, keep login for convenience
		vm.model.Pwd.val = '';
		vm.model.Pwd.fail = 'yes';
		vm.model.Pwd.msg = '8 to 30 upper and lower case letters with a number and symbol';

		vm.model.Email.fail = 'yes';
		vm.model.Email.msg = 'required email format: name@domain.com';

		// locked out?
		if(!!r && r.status === 423) {
			vm.action = 'locked';
			updateDisplay(vm.action);
		}
		else if(!!r && r.status === 403) {
			vm.action = 'block';
			updateDisplay(vm.action);
		}
		else {
			vm.action = 'login';
			updateDisplay(vm.action);
			vm.loginTitle = 'Sign In Failed, Please Try Again';

			// 422: api returned a fail msg
			if(!!r && r.status === 422) {
				msgSvc.ok('Cannot Sign In', r.data.Entity.ROOT.join(', '));
			}
		}

	}

    // PARTNER SSO: Phase 4 Login UI - 4.2 Standard User NEXT
    // PARTNER SSO: Phase 4 Login UI - 4.3 PARTNER-OK Advance
    // PARTNER SSO: Phase 4 Login UI - 4.4 PARTNER-ERR Display
    function loginStep1Handler(r) {
        // step 1: ui sends just the Email to validate user name
        // api: returns a 422 for UI to decide next step
        if(!!!r || r.status != 422 || !r.data || !r.data.Entity ||
            !Array.isArray(r.data.Entity.Fields) || r.data.Entity.Fields.length < 1) {
            return false;
        }
        var fields = r.data.Entity.Fields;

        // handle PARTNER-OK, PARTNER-ERR
        if(login422PartnerOk(fields)) {
            return true;
        }
        if(login422PartnerErr(fields)) {
            return true;
        }

        // handle standard users, advance to password entry
        if(login422StandardUserOk(fields)) {
            return true;
        }

        // standard user or unexpected, try to get UserName issues
        var userNameErr = fields.find(function(f){
            return f.Name == 'UserName';
        });
        if(userNameErr) {
            // get ROOT message
            var rootMsg = !!r.data.Entity.ROOT && Array.isArray(r.data.Entity.ROOT) && r.data.Entity.ROOT.length > 0 ? r.data.Entity.ROOT.join(', ') : '';
            if(!validSvc.isText(rootMsg)) {
                rootMsg = 'not recognized';
            }

            vm.model.Email.fail = 'yes';
            vm.model.Email.msg = validSvc.isText(userNameErr.Rule) ? userNameErr.Rule : rootMsg;
            msgSvc.ok('Cannot Sign In', 'Account ' + vm.model.Email.msg);

            return true;
        }

        // unexpected, fallback to default err handling
        return false;
    }

    // PARTNER SSO: Phase 4 Login UI - 4.2 Standard User NEXT
    function login422StandardUserOk(fields) {
        // on successful user name for standard user advance to password entry
        var userOk = fields.find(function(f){
            return f.Name == 'Password' && f.Rule == 'NEXT'; // API returns explicit intent to advance to password entry
        });
        if(!!userOk) {
            // dev user pre-fill
            if(_devEnv && vm.model.Email.val == 'dev@verity340b.com') {
                vm.model.Pwd.val = 'Devination340b!';
            }
            vm.action = 'login-pwd';
            updateDisplay(vm.action);
            return true;
        }
        return false;
    }

    // PARTNER SSO: Phase 4 Login UI - 4.3 PARTNER-OK Advance (shared parser)
    // PARTNER SSO: Phase 3 Registration UI - 3.1 Advance Registration to Partner Redirect (shared parser)
    function parsePartnerResponse(partnerResp) {
        // API returns a string with PartnerId|PartnerName, split and validate

        var partnerId = '',
            partnerName = '';

        // split up response string
        if(validSvc.isText(partnerResp)) {
            var parts = partnerResp.split('|');
            partnerId = parts.length == 2 ? parts[0] : '';
            partnerName = parts.length == 2 ? parts[1] : '';
        }
            
        // api issue
        if(!validSvc.isText(partnerId) && !validSvc.isText(partnerName)) {
            msgSvc.ok('Partner Sign In', 'PARTNER-OK needs both a valid partner ID and name.');
            return undefined;
        }

        // success
        return {
            Id: partnerId,
            Name: partnerName
        };
    }

    // PARTNER SSO: Phase 4 Login UI - 4.3 PARTNER-OK Advance
    function login422PartnerOk(fields) {
        // on successful user name + partner config check API returns Name=PARTNER-OK
        // Rule contains: PartnerId|PartnerName for use in login flow
        var partnerOk = fields.find(function(f){
            return f.Name == 'PARTNER-OK';
        });
        if(!!partnerOk) {
            var partnerResp = parsePartnerResponse(partnerOk.Rule);
            if(!partnerResp) {
                // unexpected, let generic code handle this
                return false;
            }

            // success, ready to redirect user
            vm.partner = {
                fail: 'no',
                Id: partnerResp.Id,
                Name: partnerResp.Name
            };

            vm.action = 'login-sso';
            updateDisplay(vm.action);

            return true;
        }
        return false;
    }

    // PARTNER SSO: Phase 4 Login UI - 4.4 PARTNER-ERR Display
    // PARTNER SSO: Phase 4 Login UI - 4.9 Okta Return Partner Error (reused parser)
    function login422PartnerErr(fields) {
        // on failed user name + partner config check API returns Name=PARTNER-ERR
        // Rule contains: message to user
        // additional PARTNER-INFO will be returned for partner tech support etc

        if(!Array.isArray(fields) || fields.length < 1) {
            return false;
        }

        var partnerErr,
            errInfo = [];
        for(var i = 0; i < fields.length; i++) {
            if(!partnerErr && fields[i].Name == 'PARTNER-ERR') {
                partnerErr = fields[i];
            }
            else if(errInfo.length < 1 && fields[i].Name == 'PARTNER-INFO') {
                // api packs a JSON stringified array into info Rule property
                try {
                    var info = JSON.parse(fields[i].Rule);
                    if(Array.isArray(info)) {
                        errInfo = info;
                    }
                }
                catch(e) {
                    // ignore JSON parse errors
                }
            }
            if(!!partnerErr && errInfo.length > 0) {
                break;
            }
        }

        if(!!partnerErr) {
            // partner error, show message, add any additional info
            vm.partner = {
                fail: 'yes',
                msg: validSvc.isText(partnerErr.Rule) ? partnerErr.Rule : 'Partner Account Error',
                info: errInfo
            };

            msgSvc.ok('Cannot Sign In', 'Partner Account Error');
            return true;
        }
        return false;
    }


	/**
	 *    TOKEN CHECK
	 *    used for both Activate and Pwd Reset
	 */

	// PARTNER SSO: Phase 3 Registration UI - 3.1 Detect activatesso Route (token validation)
	function checkToken(token) {
		vm.isWaiting = true;

		authService.checkToken(vm.action, token).then(okToken, errToken);

		function okToken(r) {
            r = r || {};
            vm.partner = {};
			//console.log('LOGIN: OK TOKEN');
			vm.isWaiting = false;

			// new tab is good, refresh User and complete login to home page
			if(vm.action == 'newtab') {
				authService.newTabActivate().then(loginComplete, newTabFail);
			}

			if(vm.action == 'activate') {
				// advance to pwd activate
				vm.action = 'pwdactivate';
			}
			// PARTNER SSO: Phase 3 Registration UI - 3.1 Parse partner CoBrand
			else if(vm.action == 'activatesso') {
                vm.action = 'partneractivate';
                vm.partner = parsePartnerCoBrand(r.cobrand);
                r.cobrand = ''; // clear partner sso cobrand
			}
			else if(vm.action == 'pwdreset') {
				// advance to pwd reset email entry
				vm.action = 'pwdresetemail';
			}

			vm.model = loginVM();
			vm.model.Email.val = '';
			vm.model.Pwd.val = '';

			updateDisplay(vm.action);

			// cobrand returned from token check
			if(!vm.uiLanding) {
				vm.cobrand = r.cobrand;
			}

			// validate IP after token check
			if(vm.action != 'newtab') {
				checkIpValid(true);
			}
		}

		function errToken(r) {
			//console.log('LOGIN: ERR TOKEN');
			vm.isWaiting = false;

			// failed new tab, do a full log out
			if(vm.action == 'newtab') {
				newTabFail();
				return;
			}
			
			if(vm.action == 'activate' || vm.action == 'activatesso') {
				vm.action = 'tokenbad';
			}
			else if(vm.action == 'pwdreset') {
				vm.action = 'pwdtokenbad';
			}
			
			updateDisplay(vm.action);
		}
		
	}

    // PARTNER SSO: Phase 3 Registration UI - 3.1 Parse partner CoBrand from token response
    function parsePartnerCoBrand(cobrand) {
        // on activate sso, api provides partner cobrand information
        var result = {
            fail: 'no',
            Id: '',
            Name: ''
        };
        if(validSvc.isText(cobrand)) {
            var partner = parsePartnerResponse(cobrand);
            if(!!partner) {
                result.Id = partner.Id;
                result.Name = partner.Name;
            }
        }
        return result;
    }


	function newTabFail() {
		authService.logout().then(logoutDone, logoutDone);
		function logoutDone(r) {
			// do nothing
		}
	}

	/**
	 *    PWD UDATE
	 *    used during activation and pwd reset
	 */

	function pwdUpdate() {

		if(vm.isWaiting) {
			return;
		}

		if(!validCreds(vm.model, true)) {
			msgSvc.ok('Sign In', 'Cannot continue, please check properties.');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true, true);

        // PARTNER SSO: Phase 3 Registration UI - 3.3 Submit Email Confirmation (PARTNER sentinel)
        // handle activate sso api response specifically
        if(vm.action == 'partneractivate') {
            // de-ref the model, we DO NOT want to mess with the model validation
            var ssoPostModel = {
				Email : validSvc.newProp(vm.model.Email.val),
                Pwd: validSvc.newProp(vm.partner.Id)
            };
            authService.pwdSave(ssoPostModel).then(okActivateSSO, errPwdUpdate);
        }
        else {
            authService.pwdSave(vm.model).then(okPwdUpdate, errPwdUpdate);
        }

		function okPwdUpdate() {
			// pwd accepted, full login
			vm.action = 'login';
			updateDisplay(vm.action);

			authService.login(vm.model.Email.val, vm.model.Pwd.val).then(okLogin, errLogin);

		}

		function errPwdUpdate(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r === null) {
				// already handled
                return;
			}
            r = r || {};
			if(r.status === 423) {
				vm.action = 'locked';
				vm.loginTitle = setLoginTitle(vm.action);
			}
			else if(r.status === 422) {
				vm.model = r.model;
				vm.model.PwdConfirm = validSvc.newProp('');
				msgSvc.ok('Cannot Save', 'Check values and retry.');
			}
            else if(r.status === 409 && vm.action == 'partneractivate') {
                // Okta errors return as config conflicts
                msgSvc.ok('Cannot Activate', r.msg);
            }
			else {
				errSvc.error('Unknown error occurred', 'loginCtl.errPwdUpdate', r.status, utilSvc.http.safeResponse(r));
			}
		}

		// PARTNER SSO: Phase 3 Registration UI - 3.4 Handle pwdsave Success
		// PARTNER SSO: Phase 3 Registration UI - 3.1 Advance Registration to Partner Redirect
		function okActivateSSO(r) {
            // api activated account, proceed to partner redirect prompt

            vm.isWaiting = false;
            msgSvc.wait(false);

			// sso partner user is now active, partner id and name sent back in response
            r = r || {};
            var partnerResp = parsePartnerResponse(r);
            if(!partnerResp) {
                msgSvc.ok('Partner Activation Issue', 'Please try to login again');
                vm.action = 'login';
                updateDisplay(vm.action);
                return;
            }

            // success, prompt user to redirect to partner site
            vm.partner = {
                fail: 'no',
                Id: partnerResp.Id,
                Name: partnerResp.Name
            };
            vm.action = 'login-sso';
			updateDisplay(vm.action);
		}
	}


	/**
	 *    PASSWORD
	 */

	function checkPasswordExpired() {
		var pwdDays = $rootScope.User.PwdDaysToExpire;
		if(pwdDays > 15) {
			// ok
			return true;
		}
		else if(pwdDays > 0) {
			// notify user their password is about to expire
			msgSvc.confirm({
				id: 'login.passwordchange.',
				title: "Password expiration notice",
				msg: 'Note: password is about to expire in '+ pwdDays + ' days. Change Password?',
				buttons: [
					{text:'CHANGE PASSWORD', result:'YES', cancel: false},
					{text:'CONTINUE', result:'CANCEL', cancel: true}
				]
			}).then(confirmPwdChange, confirmPwdChange);
		}
		else {
			// pwd is expired
			msgSvc.ok('Password Expired', 'Please update your password.');
			vm.action = 'pwdupdate';
			var em = vm.model.Email.val; // remember email
			vm.model = loginVM();
			vm.model.Email.val = em;
			vm.model.Pwd.val = '';

			updateDisplay(vm.action);
		}

		return false;
	}

	function confirmPwdChange(r){
		if (!!r && r.result == 'YES'){
			vm.action = 'pwdupdate';
			var em = vm.model.Email.val; // remember email
			vm.model = loginVM();
			vm.model.Email.val = em;
			vm.model.Pwd.val = '';
			updateDisplay(vm.action);
		}
		else if(checkTwoFactor()) {
			checkTerms();
		}
	}

	function pwdForgot() {

		// user forgot pwd, prompt for email

		if(vm.isWaiting) {
			return;
		}

		var em = vm.model.Email.val;
		vm.model = forgotVM();
		vm.model.Email.val = em;

		vm.action = 'pwdforgot';
		updateDisplay(vm.action);

	}

	function pwdRequest() {

		// this funciton is called for both email and Security Question steps

		if(vm.isWaiting) {
			return;
		}

		// email, required
		vm.model.Email = validSvc.setResult(validSvc.isText(vm.model.Email.val), vm.model.Email, 'required');
		if(vm.model.Email.fail == 'yes') {
			msgSvc.ok('Cannot Continue', 'You must enter an email to reset the password.');
			return;
		}
		else {
			vm.model.Email.val = vm.model.Email.val.toLowerCase();
		}

		// answer, required on step 2
		if(vm.action == 'pwdanswer') {
			vm.model.Answer = validSvc.setResult(validSvc.isText(vm.model.Answer.val), vm.model.Answer, 'required');
			if(vm.model.Answer.fail == 'yes') {
				msgSvc.ok('Cannot Continue', 'You must enter a security answer to reset the password.');
				return;
			}
		}

		vm.isWaiting = true;

		if(vm.action == 'pwdforgot') {
			authService.pwdRequestEmail(vm.model.Email.val).then(okPwdRequestEmail, errPwdRequest);
		}
		else {
			var pwdResetLink = buildAppUrl() + '/#/pwdreset/';
			authService.pwdRequestAnswer(vm.model, pwdResetLink).then(okPwdRequestAnswer, errPwdRequest);
		}

		function okPwdRequestEmail(r) {
			vm.isWaiting = false;
			vm.model.Email.fail = '';

			// user has security question?
			if(validSvc.isText(r.Question)) {
				vm.model.Question.val = r.Question;
				vm.action = 'pwdanswer';
				updateDisplay(vm.action);
			}
			else {
				vm.action = 'resetnotavailable';
				updateDisplay(vm.action);
			}
		}

		function okPwdRequestAnswer(r) {
			vm.isWaiting = false;

			vm.model.Email = validSvc.newProp('');
			vm.model.Answer = validSvc.newProp('');

			vm.action = 'pwdrequested';
			updateDisplay(vm.action);
		}

		function errPwdRequest(r) {
			vm.isWaiting = false;

			if(!!r && r.status === 422) {

				if(vm.action == 'pwdforgot') {
					vm.model.Email.fail = 'yes';
					var msg = !!r && validSvc.isText(r.msg) ? r.msg : 'Re-check your entry and try again.';
					msgSvc.ok('Password Reset Not Available', msg);
				}
				else {
					vm.model.Answer.fail = 'yes';
					vm.model.Answer.msg = r.msg;
				}
			}
		}

	}


	/**
	 *    TWO FACTOR (MFA)
	 * 	  ACTIONS: VALIDATE / SEND / EDIT
	 */

	function checkTwoFactor() {
		// is two factor required? this is sent back from server on login
		
		if(!!!$rootScope.User.TwoFactor) {
			return true;
		}

		// display
		vm.action = 'mfa';
		updateDisplay(vm.action);
		
		// initial state is VALIDATE
		mfaValidate();
	}

	function mfaVM(data) {
		data = data || {};
		return {
			Action: validSvc.isText(data.Action) ? data.Action : MFA_VALIDATE,
			SecurityCode: '',
			Factor: data.Factor == MFA_PHONE ? MFA_PHONE : MFA_EMAIL, // default to email
			Remember: !!data.Remember, // set to true to remember Mfa code
			Resend: new Date(), //Okta rate limiter is 1 call per 30 seconds
			OktaCustomer: !!data.OktaCustomer, // sent from server

			Phone: validSvc.isText(data.Phone) ? data.Phone : '', // sent from server, will be empty if they have no SMS
			PhoneEdit: validSvc.isText(data.PhoneEdit) ? data.PhoneEdit : '', // used to enroll phone for sms
			PhoneEditArea: '',
			PhoneEditPrefix: '',
			PhoneEditSuffix: ''
		};
	}

	function mfaValidate(action) {
		// display code entry for user with options
		var tf = vm.mfa;
		tf.Action = validSvc.isText(action) ? action : MFA_VALIDATE; // action could also be ACTIVATE
		tf.SecurityCode = '';
		tf.Remember = false;
		tf.PhoneEdit = '';

		// start resend code timer
		vm.mfa.Resend = new Date();

		setMfaInputFocus(MFA_VALIDATE);
	}

	function mfaTryCode(action) {
		// send validation code to api for validation

		if(vm.isWaiting) {
			return;
		}

		if (action != MFA_VALIDATE && action != MFA_ACTIVATE) {
			msgSvc.ok('Cannot Try MFA', 'Unknown MFA action: ' + action);
			return;
		}

		// valid code
		var sc = vm.mfa.SecurityCode;
		if(!validSvc.isText(sc) || !validSvc.isInteger(sc) || sc.length !== 6) {
			msgSvc.ok('Invalid Code', 'Security code must be 6 numbers only');
			return;
		}

		vm.isWaiting = true;
		var request = {
			Action: action,
			Factor: vm.mfa.Factor,
			SecurityCode: sc,
			Phone: vm.mfa.Phone,
			Remember: !!vm.mfa.Remember,
			OktaCustomer: !!vm.mfa.OktaCustomer
		};

		postMfa(request);
	}

	function mfaSendLimitOk() {
		var msg = 'A new code cannot be sent';
		if(utilSvc.dt.isValid(vm.mfa.Resend)) {
			var sec = parseInt(utilSvc.dt.diffSeconds(vm.mfa.Resend, new Date()));
			if(sec >= 30) {
				return true;
			}
			sec = 30 - sec;
			msg = sec + ' seconds remaining before sending a new code.';
		}
		msgSvc.ok('Cannot Send', msg);
		return false;
	}

	function mfaSend(factor) {
		// re-send code or send to an alternate factor if its available

		if(vm.isWaiting) {
			return;
		}

		// still waiting for 30 second minimum
		if(!mfaSendLimitOk()) {
			return;
		}

		vm.isWaiting = true;
		var request = {
			Action: MFA_SEND,
			Factor: factor == MFA_PHONE ? MFA_PHONE : MFA_EMAIL
		};
		vm.mfa.Factor = factor;

		postMfa(request);
	}

	function mfaEnrollPhoneToggle() {
		// user indicated they want to setup phone after login

		if(vm.isWaiting) {
			return;
		}
		vm.mfa.PhoneEdit = vm.mfa.PhoneEdit == MFA_ENROLL ? '' : MFA_ENROLL;
	}

	function mfaEdit(phoneEdit) {
		// show user Factor Edit view to choose default delivery and edit phone
		vm.loginTitle = 'Mobile Phone';
		vm.loginMsg = 'Enroll your mobile phone number to receive security code.';
		vm.mfa.Action = MFA_EDIT;
		mfaPhoneReset(phoneEdit);
	}

	function mfaTogglePhoneEdit() {
		vm.mfa.PhoneEdit = vm.mfa.PhoneEdit == '' ? MFA_ENROLL : '';
		if(vm.mfa.PhoneEdit == '') {
			mfaPhoneReset('');
		}
	}
	
	function mfaPhoneReset(phoneEdit) {
		vm.mfa.PhoneEdit = phoneEdit;
		vm.mfa.PhoneEditArea = '';
		vm.mfa.PhoneEditPrefix = '';
		vm.mfa.PhoneEditSuffix = '';
	}

	function mfaPhoneTabNext(editing, nextId) {
		var val = '';
		if(editing == 'area') {
			val = vm.mfa.PhoneEditArea;
		}
		else if(editing == 'prefix') {
			val = vm.mfa.PhoneEditPrefix;
		}

		// check val, next id
		if(!validSvc.isText(val) || val.length != 3 || !validSvc.isText(nextId)) {
			return;
		}

		var elem = document.getElementById(nextId);
		if(!!elem) {
			elem.focus();
			elem.setSelectionRange(0,9999);
		}
	}

	function setMfaInputFocus(action) {
		$timeout(function() {
			// set focus on mfa input box, pre-select text
			try {
				var elem = document.getElementById('LoginTwoFactorCodeInput' + action);
				if(!!elem) {
					elem.focus();
					elem.setSelectionRange(0,9999);
				}
			}
			catch(err) {
				// do nothing
			}
		},300);
	}

	function mfaEnrollPhoneSubmit() {
		// setup new phone for user
		if(vm.isWaiting) {
			return;
		}

		var area = vm.mfa.PhoneEditArea,
			prefix = vm.mfa.PhoneEditPrefix,
			suffix = vm.mfa.PhoneEditSuffix;

		// validate phone
		var phoneErr = validPhone(area, prefix, suffix);
		if(phoneErr.length > 0) {
			msgSvc.ok('Cannot Save', 'Phone ' + phoneErr);
			return;
		}

		postMfa({
			Action: MFA_ENROLL,
			Factor: MFA_PHONE,
			Phone: area + prefix + suffix
		});
	}

	function validPhone(areaCode, pref, suf) {
		var result = '';
		if(!validSvc.isText(areaCode) || !validSvc.isInteger(areaCode) || areaCode.length !== 3) {
			result += 'Area Code must be 3 numbers';
		}		
		if(!validSvc.isText(pref) || !validSvc.isInteger(pref) || pref.length !== 3) {
			result += result.length > 0 ? ', ' : '';
			result += 'Prefix must be 3 numbers';
		}		
		if(!validSvc.isText(suf) || !validSvc.isInteger(suf) || suf.length !== 4) {
			result += result.length > 0 ? ', ' : '';
			result += 'Suffix must be 4 numbers';
		}
		return result;
	}

	function mfaEditCancel() {
		if(vm.isWaiting) {
			return;
		}
		// exit editing, restart TwoFactor process
		if(checkTwoFactor()) {
			checkTerms();
		}
	}

	// shared api POST handler for VALIDATE / SEND / EDIT
	function postMfa(request) {
		var tfAction = request.Action;
		vm.isWaiting = true;
		msgSvc.wait(true, true);
		authService.twoFactor(request).then(okPostMfa, errMfa);

		function okPostMfa() {
			vm.isWaiting = false;
			msgSvc.wait();
			var tf = vm.mfa;

			switch(tfAction) {
				case MFA_VALIDATE:
					$rootScope.User.TwoFactor = false;
					// user wants to add phone?
					if(tf.PhoneEdit == MFA_ENROLL) {
						mfaEdit(MFA_ENROLL);
					}
					else {
						// advance login past mfa
						checkTerms();
					}
					break;

				case MFA_ENROLL:
					// user needs to enter a code to activate phone
					var phone = request.Phone;
					phone = validSvc.isText(phone) && phone.length > 4 ?
						phone.substr(phone.length - 4) : '';

					tf.Factor = MFA_PHONE;
					tf.SecurityCode = '';
					tf.Phone = phone;
					tf.PhoneEdit = MFA_ACTIVATE;
					tf.Resend = new Date();
					setMfaInputFocus(MFA_ACTIVATE);
					break;

				case MFA_ACTIVATE:
					msgSvc.okAsync('Mobile Phone Activated','', 'login.mfa.activate').then(checkTerms, checkTerms);
					break;
	
				case MFA_SEND:
					var sentFactor = request.Factor == MFA_PHONE ? 'Mobile Phone' : 'Email';
					tf.SecurityCode = '';
					vm.mfa.Resend = new Date();
					msgSvc.ok('Security Code Sent', 'Check your ' + sentFactor + ' in a few seconds.');
					break;

				case MFA_EDIT:
					// default changed
					msgSvc.okAsync('Default Saved', 'Your default code delivery is ' + request.Factor + editPhoneText);
					break;
				default:
					throw new Error('loginCtl.okPostMfa, unknown action: ' + tfAction);
			}
		}

		function errMfa(r) {
			vm.isWaiting = false;
			msgSvc.wait();
			if(!!!r) {
				return;
			}

			switch(tfAction) {
				case MFA_VALIDATE:
					msgSvc.ok('Security Code Invalid', 'Re-check the code and retry, code is invalid.');
					mfaValidate();
					break;

				case MFA_SEND:
					// tbd... specific api error
					msgSvc.ok('Security Code Send Error', 'Could not send code, please try again.');
					break;

				case MFA_ENROLL:
					msgSvc.ok('Phone Not Saved', 'Re-check the phone number and retry.');
					break;

				case MFA_ACTIVATE:
					msgSvc.ok('Security Code Invalid', 'Re-check the code and retry, code is invalid.');
					break;
	
				case MFA_EDIT:
					// get error string
					// var fields = r.data.Entity.Fields,
					// 	errTxt = '';
					// for(var i = 0; i < fields.length; i++) {
					// 	errTxt += fields[i].Name + ': ' + fields[i].Rule;
					// }
					// msgSvc.ok('Cannot Save', 'The following errors occured ' + errTxt);
					var editErr = !!r ? ', error: ' + utilSvc.http.safeResponse(r) : '';
					msgSvc.ok('Cannot Save', 're-try editing' + editErr);
					break;
				default:
					throw new Error('loginCtl.errMfa, unknown action: ' + tfAction);
			}
		}
	}


	/**
	 *    TERMS OF USE
	 */

	function checkTerms() {

		// after pwd entry, check user terms are ok

		if(!!$rootScope.User.Tou) {
			// tou good
			
			// okta doesn't use security question
			if(_isOktaReturn) {
				//console.log('OKTA: tou done, login complete');
				loginComplete();
			}
			else {
				// check for security QA
				checkSecurityQA();
			}
			
		}
		else {
			//console.log('LOGIN: get terms');
			// always show Verity tou screen first
			vm.action = 'vtou';
			updateDisplay(vm.action);

			// get Verity terms text from api
			authService.termsGet(true).then(okTermsText, errTermsText);
		}
	}

	function okTermsText(r) {
		//console.log('LOGIN: get terms OK');
		vm.isWaiting = false;

		// customer CE/RX users may not have extra terms
		if(vm.action == 'ctou' && !validSvc.isText(r.Content)) {
			termsAgree();
			return;
		}

		// test html content, only <p and <h tags supported
		var regexTags = /(<)(?!\/)(?![ph])(?![PH])/;
		if(regexTags.test(r.Content)) {
			throw new Error('loginCtl.okTermsText, untrusted html tag found');
		}

		vm.termsText = $sce.trustAsHtml(r.Content);
		vm.termsId = r.TermsId;
	}

	function errTermsText() {
		//console.log('LOGIN: get terms ERR');
		vm.isWaiting = false;
		// do nothing, handled in authService
	}

	function termsAgree() {

		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;

		var isVerity = $rootScope.User.Type == 'VERITY' || $rootScope.User.Type == 'VERITYSA';

		// verity user is done after vtou, CE/RX users are done after vtou and ctou
		if(isVerity || vm.action == 'ctou') {
			authService.termsAgree(vm.termsId).then(okTerms, errTerms);
		}
		else {
			// non-Verity user agreed on vtou, advance them to client tou check, get their CE/RX terms
			vm.action = 'ctou';
			updateDisplay(vm.action);
			vm.loginTitle = $rootScope.User.Company + ' Terms of Use';

			authService.termsGet(false).then(okTermsText, errTermsText);
		}

		function okTerms() {
			vm.isWaiting = false;
			$rootScope.User.Tou = true;

			// okta user doesn't use MFA
			if(_isOktaReturn) {
				loginComplete();
			}
			else {
				// tou good, check security question
				checkSecurityQA();
			}
		}

		function errTerms(r) {
			vm.isWaiting = false;

			// go back to login
			vm.action = '';
			init();
		}

	}


	/**
	 *    SECURITY QUESTION
	 */

	function checkSecurityQA() {

		// after tou, check if user has a security question/answer saved

		if(!!$rootScope.User.ChallengeSet) {
			loginComplete();
			return;
		}


		var em = vm.model.Email.val;
		vm.model = forgotVM();
		vm.model.Email.val = em;

		vm.action = 'getanswer';
		updateDisplay(vm.action);


		function errGetQuestion() {
			vm.isWaiting = false;
			if(!!r) {
				errSvc.error('Unknown security question error', 'loginCtl.errGetQuestion', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}

	function saveQA() {

		if(vm.isWaiting) {
			return;
		}

		vm.model.Question = validText(vm.model.Question, 4, 50);
		vm.model.Answer = validText(vm.model.Answer, 4, 50);

		if(vm.model.Question.fail == 'yes' || vm.model.Answer.fail == 'yes') {
			msgSvc.ok('Cannot Save', 'All fields must be valid.');
			return;
		}

		vm.isWaiting = true;
		userRepo.saveSecurityQA(vm.model).then(okSaveQA, errSaveQA);

	}

	function okSaveQA(r) {
		vm.isWaiting = false;

		msgSvc.okAsync(
			'Account Saved',
			'Remember your Security Question: ' + vm.model.Question.val + '? Answer: ' + vm.model.Answer.val,
			'login-qa-saved'
			).then(loginComplete, loginComplete);
	}

	function errSaveQA(r) {
		vm.isWaiting = false;

		if(r == null) {
			return;
		}
		else if (!!r && r.status == 422) {
			// validation
			vm.model = r.model;
			msgSvc.ok('Cannot Save', 'Server reported invalid properties');
		}
		else {
			errSvc.error('Unknown security save response', 'loginCtl.errSaveQA', r.status, utilSvc.http.safeResponse(r));
		}

	}


	/**
	 *    IP VALID
	 * 	  some CE customers want their IP checked after login
	 */

	function checkIpValid(silent) {
		// check user IP origin, silent does an IP check without changing the dispaly
		// note: used by checkToken during a new user activation or pwd reset

		if(!!$rootScope.User && !!$rootScope.User.IpValid) {
			return true;
		}

		// IP check hasn't occurred yet, send request to API to validate
		if(!!!silent) {
			vm.action = 'ipvalidcheck';
			updateDisplay(vm.action);
		}

		authService.ipValidCheck().then(okIP, errIP);

		function okIP() {
			// IP check success, re-start login logic
			if(vm.action == 'ipvalidcheck') {

				// okta needs to load user
				if(_isOktaReturn) {
					checkOktaUser();
				}
				else {
					okLogin();
				}
			}
		}

		function errIP() {
			// IP check failed, notify user
			vm.action = 'ipinvalid';
			updateDisplay(vm.action);

			// clean up User and session
			if(!!$rootScope.User) {
				$rootScope.$emit('espui>auth.logout', {reason:'login_cleanup'});
			}
		}
	}


	/**
	 * 	CHECK OKTA USER
	 *  get User context after okta session return
	 */

	function checkOktaUser() {
		if(!!$rootScope.User) {
			return true;
		}

		//console.log('OKTA: get User refresh');
		authService.loginOkta().then(okUser, errUser);

		function okUser(r) {
			//console.log('OKTA: got User refresh');
			// return to login process
			okLogin();
		}

		function errUser(r) {
			// reset the app if okta token failed
			//console.log('OKTA: authSvc.oktaLogin failed');
			$state.go('startup', {}, { reload: 'startup' });
		}
	}

	/**
	 *    DISMISS / CANCEL
	 */

	function dismissOK() {
        if(vm.isWaiting) {
            return;
        }

        switch(vm.action) {
            case 'login-pwd':
            case 'login-sso':
                // reset back to login step 1
                vm.partner = {};
                vm.action = 'login';
                updateDisplay(vm.action);
                break;
            default:
                // reset feature back to login generic state
                $state.go('startup', {}, { reload: 'startup' });
        }
	}


    /**
     *      PARTNER SSO
     */

    // PARTNER SSO: Phase 4 Login UI - 4.4 PARTNER-ERR Display (open support link)
    function partnerShowLink(url) {
        // partner included a link to show their user for support
        window.open(url, '_blank');
    }

    // PARTNER SSO: Phase 4 Login UI - 4.5 Start Partner SSO
    function partnerStartSSO() {
        // check for webcrypto support
        var winCrypt = window.crypto;
        if(!!!winCrypt || typeof winCrypt.randomUUID == 'undefined') {
            var ugent = !!window.navigator ? window.navigator.userAgent : '';
            errSvc.warn(
                'Cannot Login. Your browser is not supported, please upgrade to a modern browser.',
                'loginCtl.partnerStartSSO',
                '',
                'User Agent: ' + ugent
            );
            return;
        }

        // unique request cookie with partner id
        var id1 = winCrypt.randomUUID();
        var cook = 'okta340b=PARTNER|' + id1.toString() + '|' + vm.partner.Id;
        cook += ';max-age=' + (60 * 5).toString(); // 5 mins
        cook += ';samesite=none';
        cook += ';secure';
        cook += ';path=/api/okta';
        document.cookie = cook;

        // build api url
        var port = window.location.port;
        if(validSvc.isInteger(port)) {
            port = ':' + port;
        } else {
            port = '';
        }
        var apiUrl = window.location.protocol + '//' + window.location.hostname + port + '/api/okta/login';

        // delay to set cookie and send to api
        vm.isWaiting = true;
        $timeout(function() {
            window.location.replace(apiUrl);
        }, 1000);
    }

	/**
	 * 		GUI BARS
	 */

	function loadGuiBars() {
		return [
			{name:'green-down', pos:'bar-pos1'},
			{name:'orange-up', pos:'bar-pos2'},
			{name:'purple-up', pos:'bar-pos3'},
			{name:'blue-up', pos:'bar-pos4'},
			{name:'green-down', pos:'bar-pos5'},
			{name:'blue-down', pos:'bar-pos6'},
			{name:'orange-up', pos:'bar-pos7'},
			{name:'purple-up', pos:'bar-pos8'},
			{name:'blue-up', pos:'bar-pos9'},
			{name:'orange-down', pos:'bar-pos10'},
			{name:'purple-down', pos:'bar-pos11'},
			{name:'blue-down', pos:'bar-pos12'},
			{name:'green-up', pos:'bar-pos13'},
			{name:'orange-up', pos:'bar-pos14'}
		];
	}

	function guiBarAdvance() {

		// increment last bar position
		_guiCurrent++;
		if(_guiCurrent > vm.guiBars.length + 1) {
			_guiCurrent = 1;
		}

		var barPos = _guiCurrent,
			barItem = {};

		// loop bars changing position class
		for(var i =0; i < vm.guiBars.length; i++) {
			barItem = vm.guiBars[i];
			barItem.pos = 'bar-pos' + barPos.toString();

			barPos++;
			if(barPos > vm.guiBars.length + 1) { // invisible position is +1 on bar length
				barPos = 1;
			}
		}

	}


	/**
	 *    HELPERS
	 */

	function updateDisplay(action) {

		vm.showDismiss = false;

		switch(action) {
			case 'login':
            case 'login-pwd':
            case 'login-sso':
				vm.loginTitle = 'Sign In';
				vm.loginMsg = ' ';
				vm.loginIcon = 'icon-security';
				break;
			case 'loginland':
			case 'okta-return':
				vm.loginTitle = ' ';
				vm.loginMsg = ' ';
				vm.loginIcon = '';
				break;
			case 'locked':
				vm.loginTitle = 'Too Many Login Attempts';
				vm.loginMsg = 'Account has been temporarily locked. Try again in 20 minutes or contact your Verity administrator.';
				vm.loginIcon = 'icon-remove';
				vm.showDismiss = true;
				break;
			case 'block':
				vm.loginTitle = 'Login Issue';
				vm.loginMsg = ''; // custom for block
				vm.loginIcon = 'icon-err-warn';
				vm.showDismiss = true;
				break;	
			case 'timeout':
				vm.loginTitle = 'Session Timeout';
				vm.loginMsg = 'Session expired due to inactivity.';
				vm.loginIcon = 'icon-clock';
				vm.showDismiss = true;
				break;
			case 'activate':
            case 'activatesso':
				vm.loginTitle = 'Account Activation';
				vm.loginMsg = 'Checking activation token...';
				vm.loginIcon = 'icon-users';
				break;
			case 'tokenbad':
				vm.loginTitle = 'Activation Expired';
				vm.loginMsg = 'Activation link is expired or invalid, please contact your administrator to send another email.';
				vm.loginIcon = 'icon-remove';
				vm.showDismiss = true;
				break;
			case 'pwdactivate':
				vm.loginTitle = 'Account Activation';
				vm.loginMsg = 'Enter your email and create a password. Password strength requires letters, numbers, a symbol and no spaces.';
				vm.loginIcon = 'icon-users';
				break;
            case 'partneractivate':
                vm.loginTitle = 'Account Activation';
                var partnerMsg = validSvc.isText(vm.partner.Name) ? vm.partner.Name + ' ' : '';
                vm.loginMsg = 'Welcome ' + partnerMsg + 'please enter your email to continue.';
                vm.loginIcon = 'icon-users';
                break;
			case 'pwdupdate':
				vm.loginTitle = 'Password Update';
				vm.loginMsg = 'Choose a new password. Password strength requires letters, a number, a symbol and no spaces.';
				vm.loginIcon = 'icon-security';
				break;
			case 'mfa':
				vm.loginTitle = 'Security Code';
				vm.loginMsg = 'Enter your security code.';
				vm.loginIcon = 'icon-security';
				break;
			case 'pwdforgot':
				vm.loginTitle = 'Forgot Password';
				vm.loginMsg = 'Enter your email to request a password reset. If you forgot your email please call a Verity administrator.';
				vm.loginIcon = 'icon-msg-confirm';
				break;
			case 'pwdanswer':
				vm.loginTitle = 'Security Question';
				vm.loginMsg = 'Answer the following security question to request a password reset. If you forgot your security answer please call a Verity administrator.';
				vm.loginIcon = 'icon-security';
				break;
			case 'resetnotavailable':
				vm.loginTitle = 'Password Reset Not Available';
				vm.loginMsg = 'This user account is not setup for automatic password reset. Call your Verity administrator.';
				vm.loginIcon = 'icon-security';
				vm.showDismiss = true;
				break;
			case 'pwdrequested':
				vm.loginTitle = 'Password Reset Sent';
				vm.loginMsg = 'Check your email.';
				vm.loginIcon = 'glyphicon-send';
				vm.showDismiss = true;
				break;
			case 'pwdresetemail':
				vm.loginTitle = 'Password Reset';
				vm.loginMsg = 'Re-enter your email and choose a new password. Password strength requires letters, a number, a symbol and no spaces.';
				vm.loginIcon = 'icon-security';
				break;
			case 'pwdreset':
				vm.loginTitle = 'Password Reset';
				vm.loginMsg = 'Checking reset token...';
				vm.loginIcon = 'icon-security';
				break;
			case 'pwdtokenbad':
				vm.loginTitle = 'Password Reset';
				vm.loginMsg = 'Password reset link is expired or invalid, please contact your administrator to send another email.';
				vm.loginIcon = 'icon-security';
				vm.showDismiss = true;
				break;
			case 'vtou':
				vm.loginTitle = 'Verity Terms of Use & Privacy Policy';
				vm.loginMsg = 'Read the following Terms of Use & Privacy Policy. By clicking Continue you agree to be bound by these TERMS OF USE and PRIVACY POLICY.';
				vm.loginIcon = 'icon-about-corp';
				break;
			case 'ctou':
				vm.loginTitle = ' ';
				vm.loginMsg = 'Read the following Terms of Use. By clicking Continue you agree to be bound by these TERMS OF USE.';
				vm.loginIcon = 'icon-about-corp';
				break;
			case 'getanswer':
				vm.loginTitle = 'Security Question Setup';
				vm.loginMsg = 'Create a security question and answer to help recover your account in case of a forgotten password.';
				vm.loginIcon = 'icon-security';
				break;
			case 'tabmax':
				vm.loginTitle = 'Tab Maximum';
				vm.loginMsg = 'Cannot load tab, maximum 5 browser tabs allowed';
				vm.loginIcon = 'icon-security';
				break;
			case 'ipvalidcheck':
				vm.loginTitle = 'IP Security Check';
				vm.loginMsg = 'Checking IP address...';
				vm.loginIcon = 'icon-security';
				break;
			case 'ipinvalid':
				vm.loginTitle = 'IP Security Check';
				vm.loginMsg = 'IP Address Not Allowed, contact your administrator';
				vm.loginIcon = 'icon-security';
				vm.showDismiss = true;
				break;	
			default:
				vm.loginTitle = ' ';
				vm.loginMsg = ' ';
				vm.loginIcon = '';
		}

	}

	function buildAppUrl() {

		// derive current port
		var port = $window.location.port;
		if(!!port && !isNaN(port)) {
			port = ':' + port.toString();
		}
		else {
			port = '';
		}

		return $window.location.protocol + '//' + $window.location.hostname + port;

	}

	function validText(prop, min, max) {

		// required
		if(!validSvc.isText(prop.val)) {
			prop.fail = 'yes';
			prop.msg = 'required';
			return prop;
		}

		// min
		if(prop.val.length < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum ' + min.toString() + ' characters';
			return prop;
		}

		// max
		if(prop.val.length > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum ' + max.toString() + ' characters';
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;

	}

	function cobrandCSS() {
		if(vm.uiLanding) {
			return 'login-landing';
		}
		else {
			return !!vm.cobrand ? 'cobrand-' + vm.cobrand : '';
		}
	}

}
 
StartUpController.$inject = ['$window', '$rootScope', '$timeout', 'apiService', 'sessionRepo', 'validSvc'];
angular
.module('espui.main')
.controller('StartUpController', StartUpController);

/* @ngInject */
function StartUpController($window, $rootScope, $timeout, apiService, sessionRepo, validSvc) {

	/*jshint validthis: true */
	var vm = this,
		_configUrl = '';

	vm.isWaiting = true;
	vm.startMode = ' ';
	vm.startTitle = ' ';
	vm.startMsg = ' ';

	vm.startUp = startUp;

	vm.cobrand = $rootScope.cobrand;
	vm.cobrandCSS = cobrandCSS;


	/**
	 *    INIT
	 */

	init();

	function init() {
		console.log('START UP INIT');

		vm.isWaiting = true;
		switchMode('CONNECT', 'Connecting to Verity Server...', ' ', '');

		// ui landing / co-brand saved in deep link on start up
		var dl = $rootScope.deepLink || {};
		if(!!dl.params) {
			//console.log('STARTUP: deep link: ' + dl.params);
			if(dl.params.reason == 'uilanding') {
				// ui landing page has no cobranding
				vm.cobrand = '';
			}
		}

		// build api url, get config Json
		_configUrl = buildConfigUrl();
		apiService.getConfig(_configUrl).then(okJson, errJson);

		function okJson(r) {

			vm.isWaiting = false;

			// maint mode?
			if(r.maint.mode == 'on') {
				$timeout(function() {
					switchMode('MAINT', 'Website Maintenance In-Process', r.maint.on, '');
				}, 1000);
				return;
			}

			// version check (api sends back the latest version so the ui can refresh itself)
			if(versionUpgrade($window.verityEspVersion, r.uiVersion)) {
				return;
			}

			// api path (if debugging a replacement path might be in the config json)
			if(validSvc.isText(r.apiReplacePath)) {
				r.apiPath = r.apiReplacePath;
			}
			else {
				// build path relative to this domain
				r.apiPath = buildAppUrl() + '/api/';
			}

			// set config and dev mode
			$rootScope.appConfig = r;
			$rootScope.debug = r.debug === 'on';

			// api log
			var env = validSvc.isText(r.env) ? r.env : '';
			$rootScope.apiLog = $rootScope.debug && env == 'local';

			// start up is done
			$rootScope.startUp = true;
			$rootScope.startUpTimestamp = new Date();
			if($rootScope.debug) {
				$rootScope.$emit('espui>startup', {});
			}
			else {

				// pause UI to avoid flicker
				$timeout(function() {
					$rootScope.$emit('espui>startup', {});
				}, 1700);

			}

		}

		function errJson(r) {

			vm.isWaiting = false;

			// remove session token if start up fails
			$rootScope.$emit('espui>auth.logout', {reason:'startup'});

			r = r || {status: -1, message: 'unknown'};
			if(r.message === '{}') {
				r.message = '';
			}

			// use specific network banner
			if(r.status === -1 || r.status === 0) {
				$timeout(function() {
					switchMode('ERROR', 'Network Connection Issue', 'Url: ' + _configUrl, r.message);
				}, 1000);
			}
			else {
				$timeout(function() {
					switchMode('ERROR', 'Start Up Issue', 'Url: ' + _configUrl, r.message);
				}, 1000);
			}

		}

	}

	function startUp() {
		// clicked by user to re-check if app is back online
		if(vm.isWaiting) {
			return;
		}

		init();
	}


	/**
	 *    VERSION UPGRADE
	 */

	function versionUpgrade(uiVersion, apiVersion) {

		// check ui version is >= api version
		// note: where possible, use session store instead of messing up the query string

		// api didn't send a version
		if(!validSvc.isText(apiVersion)) {
			return false;
		}

		// version is current
		if(!needsUpgrade(uiVersion, apiVersion)) {
			return false;
		}

		// query string version
		var queryString = $window.location.search;
		var urlHasVersion = false;
		if(validSvc.isText(queryString) && queryString.indexOf('ver=' + apiVersion) > -1) {
			urlHasVersion = true;
		}

		// stop trying if query string upgrade failed
		if(urlHasVersion) {
			//console.log('app upgrade, query string failed. ui version: ' + uiVersion + ' api version: ' + apiVersion + ' url version: ' + queryString);
			return false;
		}

		// use query string upgrade if session store is not available
		if(!sessionRepo.hasStore()) {
			// use query string
			//console.log('app upgrade, trying query string... ui version: ' + uiVersion + ' api version: ' + apiVersion);
			$window.location.href = '/?ver=' + apiVersion;
			return true;
		}

		// upgrade with session store
		var savedUpgrade = sessionRepo.get('upgrade');
		if(!!savedUpgrade && savedUpgrade.version !== apiVersion) {
			// upgrade with root only, no query string
			console.log('APP UPGRADE, trying session... ui version: ' + uiVersion + ' api version: ' + apiVersion);
			sessionRepo.set('upgrade', {version: apiVersion});
			$window.location.href = '/';
			return true;
		}

		// session upgrade didn't work, try query string
		console.log('APP UPGRADE, session failed, trying query string... ui version: ' + uiVersion + ' api version: ' + apiVersion);
		sessionRepo.set('upgrade', '');
		$window.location.href = '/?ver=' + apiVersion;
		return true;

	}

	function needsUpgrade(uiVersion, apiVersion) {

		// parse and then compare ui/api versions

		var trySource = '',
			uiVer,
			apiVer;

		try {

			trySource = 'UIVERSION: ';
			uiVer = parseAppVersion(uiVersion);

			trySource = 'APIVERSION: ';
			apiVer = parseAppVersion(apiVersion);

		}
		catch(err) {
			throw new Error(trySource + err.description);
		}

		// needs upgrade?
		if(uiVer.major < apiVer.major) {
			// major version old
			return true;
		}
		else if(uiVer.major === apiVer.major && uiVer.minor < apiVer.minor) {
			// major version same, minor old
			return true;
		}
		else if(uiVer.major === apiVer.major && uiVer.minor === apiVer.minor && uiVer.patch < apiVer.patch) {
			// major, minor same, patch old
			return true;
		}
		else {
			return false;
		}

	}

	function parseAppVersion(v) {

		// missing
		if(!validSvc.isText(v)) {
			throw new Error('startup.parseAppVersion, version missing');
		}

		var ver = {
				major: 0,
				minor: 0,
				patch: 0
			},
			errMsg = '';

		try {

			// 3 segments expected
			var vParts = v.split('.');
			if(!Array.isArray(vParts) || vParts.length < 3) {
				errMsg = 'startup.parseAppVersion, api appConfig.version format expected: major.minor.patch, received: ' + v;
			}

			ver.major = parseInt(vParts[0]);
			ver.minor = parseInt(vParts[1]);
			ver.patch = parseInt(vParts[2]);

			// all segments numeric
			if(isNaN(ver.major) || isNaN(ver.minor) || isNaN(ver.patch)) {
				errMsg = 'startup.parseAppVersion, api appConfig.version segments must be numeric, expected: n.n.n, received: ' + v;
			}

		}
		catch(err) {
			errMsg = 'startup.parseAppVersion, unknown error occured: ' + err.description;
		}

		// error?
		if(errMsg !== '') {
			throw new Error(errMsg);
		}

		return ver;

	}


	/**
	 *    HELPER
	 */

	function buildAppUrl() {

		// derive current port
		var port = $window.location.port;
		if(!!port && !isNaN(port)) {
			port = ':' + port.toString();
		}
		else {
			port = '';
		}

		return $window.location.protocol + '//' + $window.location.hostname + port;

	}

	function buildConfigUrl() {
		return buildAppUrl() + '/appConfig.json?ts=' + Date.now().toString();
	}

	function switchMode(newMode, title, msg, errMsg) {

		switch(newMode) {

			case 'CONNECT':
			case 'ERROR':
			case 'MAINT':
			case 'IEOLD':
				vm.startMode = newMode;
				vm.startTitle = title;
				vm.startMsg = msg;
				vm.startErrMsg = errMsg || '';
				break;

			default:
				throw new Error('startup.ctl.switchMode, mode unknown: ' + newMode);

		}
	}

	function cobrandCSS() {
		return !!vm.cobrand ? 'cobrand-' + vm.cobrand : '';
	}

}
 
accumDetailCtl.$inject = ['$window', '$scope', '$rootScope', '$state', '$timeout', '$filter', 'accumRepo', 'sessionRepo', 'catalogsRepo', 'reportRepo', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc', 'appConst'];angular
.module('espui.ops')
.controller('AccumDetailCtl', accumDetailCtl);


/* @ngInject */
function accumDetailCtl($window, $scope, $rootScope, $state, $timeout, $filter, accumRepo, sessionRepo, catalogsRepo, reportRepo, validSvc, errSvc, utilSvc, msgSvc, appConst) {

	/*jshint validthis: true */
	var vm = this,
		_routeInfo = null,
		_pendingExcelFilename = '',
		_returnVisit = false;

	// inherit sorting and paging features
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.isWaiting = false;
	vm.action = '';
	vm.detailReady = '';
	vm.init = true;
	
	// query
	vm.query = {};
	vm.dateRangeChange = dateRangeChange;
	vm.querySubmit = querySubmit;

	// tabs
	vm.activeTab = '';
	vm.tabChange = tabChange;

	// models
	vm.display = {};

	// adjustments
	vm.adjust = {};
	vm.adjustToggle = adjustToggle;
	vm.adjustChangedQty = adjustChangedQty;
	vm.adjustSave = adjustSave;
	vm.expireReserve = expireReserve;

	// excel
	vm.getExcel = getExcel;

	// nav to another feature
	vm.navToFeature = navToFeature;

	// popup
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;
	vm.popupSearch = popupSearch;

	// purchase history
	vm.inventory = {};
	vm.inventory.filterChange = purchasefilterChange;
	vm.getPurchaseHistoryExcel = getPurchaseHistoryExcel;

	// async reports
	vm.asyncReports = {};
	vm.toggleAsyncReports = toggleAsyncReports;	

	/**
	 *    PAGING EVENT FOR PURCHASES
	 */

	var _pagingEventListener = $scope.$on('widget.paging.change', function (event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if (!vm.inventory.flt.Ready || !Array.isArray(vm.inventory.tbl.Items) || vm.inventory.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.inventory.flt[evtData.propName] = parseInt(evtData.value);
		purchasefilterChange(true);

	});

	$scope.$on('$destroy', function() {
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
	});

	
	/**
	 *    INIT
	 */

	init();

	function init() {

		vm.init = true;

		var ctx = angular.fromJson(angular.toJson($state.params || {}));
		_routeInfo = angular.fromJson(angular.toJson($state.current.routeInfo));
		var deeplinked = false;

		var vs = null;
		if(!!ctx.breadcrumb) {
			// router params passed a breadcrumb
			
			vs = sessionRepo.get('vs-accum-detail-breadcrumb');
			if(!!vs) {
				// if bread crumb already exists in viewstate, use that one instead
				_returnVisit = true;
				ctx = {
					Id: vs.Id,
					CE: vs.CE,
					RX: vs.RX,
					ShareGroup: vs.ShareGroup,
					CanEdit: vs.CanEdit,
					DateRangeMode: vs.DateRangeMode,
					StartDate: vs.StartDate,
					EndDate: vs.EndDate
				};

				// reset viewstate breadcrumb
				sessionRepo.clearKey('vs-accum-detail-breadcrumb');
			}
			else {
				// use breadcrumb sent in route params
				$rootScope.$emit('espui>route.reset', {route: $state.current.name});
				_routeInfo.breadcrumb = ctx.breadcrumb;
				deeplinked = true;
			}
		}

		// return date range
		if(!_returnVisit) {
			vs = sessionRepo.get('vs-accum-detail');
			if(!!vs) {
				_returnVisit = true;
				ctx.DateRangeMode = vs.DateRangeMode;
				ctx.StartDate = vs.StartDate;
				ctx.EndDate = vs.EndDate;
			}
		}

		// route params
		if(!validSvc.isCE(ctx.CE) || !validSvc.isRX(ctx.RX) || !validSvc.isText(ctx.Id)) {
			throw new Error('accumDetail.init, CE, RX, or Id is missing');
		}

		// copy route info, modify breadcrumb for return nav to list ui
		if (!deeplinked) {
			_routeInfo.breadcrumb.routeData = {
				CE: ctx.CE,
				RX: ctx.RX,
				ShareGroup: ctx.ShareGroup
			};
		}
		$scope.$emit('shared.main.setInfo', _routeInfo);

		initQuery(ctx);
		vm.activeTab = 'RECENT';

		vm.asyncReports = initAsyncReports();

		// fire date control event after widget scope is setup
		$timeout(function() {
			$scope.$broadcast('widget.input.date.range.mode', {mode: vm.query.DateRangeMode, keepDates: _returnVisit});
		},100);

	}

	function initQuery(ctx) {

		vm.query = accumRepo.detailQueryVM(ctx);

		var dtToday = new Date(),
		dtAppStart = utilSvc.dt.zeroTime(appConst.app.liveDate),
		customRangeDays = parseInt(utilSvc.dt.diffDays(dtAppStart, dtToday));

		// date range
		vm.query.DateRangeList = [
			{label:'', value: 'NONE'},
			{label:'Today', value: 'TODAY'},
			{label:'Yesterday', value: 'YESTERDAY'},
			{label:'Today & Yesterday', value: 'TODAYYESTERDAY'},
			{label:'Last 2 Days including Today', value: '2DAYS'},
			{label:'Last 3 Days including Today', value: '3DAYS'},
			{label:'Last 7 Days including Today', value: '7DAYS'},
			{label:'Last 2 Weeks', value: '2WEEKS'},
			{label:'Monthly', value: 'MONTHLY'},
			{label:'Month To Date', value: 'MTD'},
			{label:'Quarterly', value: 'QTR'},
			{label:'Quarter To Date', value: 'QTD'},
			{label:'Last Quarter', value: 'QTDLAST'},
			{label:'Last 12 Months', value: 'LTM'},
			{label:'Yearly', value: 'YEARLY'},
			{label:'Year To Date', value: 'YTD'},
			{label:'Custom Date Range', value: 'CUSTOM' + customRangeDays.toString()}
		];

		// user has adjust claim
		vm.query.canAdjust = false;
		if(vm.query.CanEdit) {
			vm.query.canAdjust = utilSvc.user.hasFeature($scope, 'ops.accum.adjust');
		}
		vm.query.canRelease = utilSvc.user.hasFeature($scope, 'ops.accum.release');

		// user has deep link feature claims
		vm.query.canNavToMapping = false; utilSvc.user.hasFeature($scope, 'ops.transform');
		vm.query.canNavToOrderDetail = utilSvc.user.hasFeature($scope, 'orders');
		vm.query.canNavToInvoiceDetail = false;
		vm.query.canEditSplit = false;
	}


	/**
	 *    VIEW MODELS
	 */

	function displayAddDetail(details, detailsTxt, title, txt) {
		// add new detail line to Details array and search text
		details.push(title + ' ' + txt);
		detailsTxt.push(txt);
	}

	function displayVM(data) {

		// add display properties, modify model for ui display

		data = data || {};
		vm.query.RxBizModel = data.RxBizModel;

		// Ability to adjust is overridden if ProgramAdmin is not verity
		if (validSvc.isText(data.ProgramAdmin)) {
			vm.query.canAdjust = false;
		}
		var trans = Array.isArray(data.Transactions) ? data.Transactions : [],
			t = null,
			details = [],
			detailsTxt = [],
			links = [],
			isRxSplit = vm.query.RxBizModel == 'SPLIT',
			isRxCPSPLITMATCH = vm.query.RxBizModel == 'CP' || vm.query.RxBizModel == 'SPLITMATCH',
			subText = null;

		// combine properties into one details column
		for(var i = 0; i < trans.length; i++) {
			t = trans[i];
			details = [];
			detailsTxt = [];
			t.links = [];

			// biz time!
			t.DetailItemDate = utilSvc.dt.toBizTime(t.DetailItemDate);
			t.TransTime = utilSvc.dt.toBizTime(t.TransTime);

			// add invoice # or order #
			if((t.TransType == 'INVOICE') && validSvc.isText(t.InvoiceNumber)) {
				displayAddDetail(details, detailsTxt, 'Invoice #:', t.InvoiceNumber);
				if(validSvc.isText(t.OrderNumber)) {
					displayAddDetail(details, detailsTxt, 'Order #:', t.OrderNumber);
				}
				if(validSvc.isText(t.NdcOptimized)) {
					if (data.AccumType == 'OWN') {
						displayAddDetail(details, detailsTxt, 'Own Use Alternate backing for:', t.NdcOptimized);
					} else if(!!t.InnerOuterPacks) {
						displayAddDetail(details, detailsTxt, 'Outer NDC backing for:', t.NdcOptimized);
					} else {
						displayAddDetail(details, detailsTxt, 'NDC Optimizer backing for:', t.NdcOptimized);
					}
				}
				if(!!t.ManualInvoice) {
					displayAddDetail(details, detailsTxt, '', 'Manual');
				}
				if(vm.query.canNavToInvoiceDetail) {
					t.links.push(t.InvoiceNumber);
				}
			} else if(t.TransType == 'TRUEUP' && validSvc.isText(t.InvoiceNumber)) {
				displayAddDetail(details, detailsTxt, 'Invoice #:', t.InvoiceNumber);
				displayAddDetail(details, detailsTxt, 'User:', t.User);
			} else if(t.TransType == 'ONORDER' && validSvc.isText(t.OrderNumber) && validSvc.isText(t.OrderId)) {
				displayAddDetail(details, detailsTxt, 'Order #:', t.OrderNumber);
				if(validSvc.isText(t.NdcOptimized)) {
					if (data.AccumType == 'OWN') {
						displayAddDetail(details, detailsTxt, 'Own Use Alternate reserved for:', t.NdcOptimized);
					} else if(!!t.InnerOuterPacks) {
						displayAddDetail(details, detailsTxt, 'Outer NDC reserved for:', t.NdcOptimized);
					} else {
						displayAddDetail(details, detailsTxt, 'NDC Optimizer reserved for:', t.NdcOptimized);
					}
				}
				if(vm.query.canNavToOrderDetail) {
					t.links.push(t.OrderNumber);
				}
			}
			else if(t.TransType == 'DISPENSE') {

				// add SPLIT subtext line
				subText = {
					title: '',
					txt: ''
				};
				if(isRxSplit) {
					if(validSvc.isText(t.TransactionUniqueId)) {
						displayAddDetail(details, detailsTxt, 'Unique Id:', t.TransactionUniqueId);
					}
					if(validSvc.isText(t.TransactionItemCode)) {
						subText.title = 'Code: ' + t.TransactionItemCode;
						subText.txt = t.TransactionItemCode;
					}
					if(validSvc.isText(t.TransactionMultiplier)) {
						subText.title += (!!subText.title ? ', ' : '') + 'Multiplier: ' + t.TransactionMultiplier;
						subText.txt += '|' + t.TransactionMultiplier;
					}
					if(!!subText.title) {
						details.push(subText.title);
						detailsTxt.push(subText.txt);
					}
				}

				// add CP or SPLITMATCH subtext line
				if(isRxCPSPLITMATCH) {
					if(validSvc.isText(t.RxNumber)) {
						displayAddDetail(details, detailsTxt, 'Rx #:', t.RxNumber);
					}
					if(validSvc.isNumber(parseInt(t.FillNumber))) {
						displayAddDetail(details, detailsTxt, 'Fill #:', t.FillNumber.toString());
					}
				}
			}
			else if (t.TransType == 'REVERSAL' || t.TransType == 'NEGTRANS') {
				t.IsReversal = true;
				var count = '0';
				if(validSvc.isNumber(parseInt(t.ReversedTransCount))) {
					count = t.ReversedTransCount.toString();
				}
				var reverseCountTitle = 'Transactions Reversed: ';
				if (t.TransType == 'NEGTRANS') {
					t.TransType = 'DISPENSE';
					reverseCountTitle = 'Negative Transactions: ';
					if(!validSvc.isText(t.Notes)) {
						t.Notes = "Negative transactions...";
						t.NoteLink = true;
					}
				}
				else {
					t.TransType = 'FILE REVERSAL';
					if(!validSvc.isText(t.Notes)) {
						t.Notes = "Reversed transactions...";
						t.NoteLink = true;
					}
				}
				displayAddDetail(details, detailsTxt, reverseCountTitle, count);

				if (Array.isArray(t.ReversalFiles)) {
					displayAddDetail(details, detailsTxt, 'Files: ', t.ReversalFiles.join(", "));
				}
			}
			else if(t.TransType == 'EXPIRE') {
				if(validSvc.isText(t.RxNumber)) {
					displayAddDetail(details, detailsTxt, 'Rx #:', t.RxNumber);
				}
				if(validSvc.isNumber(parseInt(t.FillNumber))) {
					displayAddDetail(details, detailsTxt, 'Fill #:', t.FillNumber.toString());
				}
			}
			else if(t.TransType == 'ADJUSTMENT') {

				var adjType = t.AdjustmentType;

				if(adjType == 'TRANSFER') {
					displayAddDetail(details, detailsTxt, '', 'NDC Transfer');
					if(validSvc.isText(t.AdjustTransferNdc)) {
						displayAddDetail(details, detailsTxt, 'Other NDC:', t.AdjustTransferNdc);
					}
				}
				else if(adjType == 'TRANSFORM') {
					displayAddDetail(details, detailsTxt, '', 'Mapping');
					if(!!t.AdjustMappingChange) {
						t.links.push({
							subType: 'TRANSFORM',
							mapChange: t.AdjustMappingChange
						});
					}
				}
				else if(validSvc.isText(adjType) && adjType.length > 0) {
					var lowTxt = adjType.toLowerCase();
					displayAddDetail(details, detailsTxt, '', adjType[0] + lowTxt.substr(1, lowTxt.length));
				}
                else {
                    // missing adjustment type
                    displayAddDetail(details, detailsTxt, '', 'Adjustment');
                }

				// add user for any adj type
				if(validSvc.isText(t.User)) {
					displayAddDetail(details, detailsTxt, 'User:', t.User);
				}
			}

			// add Detail property to Transaction list item
			t.Details = details;
			t.DetailsTxt = detailsTxt.join('|');

		}
		data.Transactions = trans;

		data.Paging = {
			Page: 1,
			Size: $scope.tblPagingSize,
			Total: vm.getTotalPages(data.Transactions.length, $scope.tblPagingSize)
		};

		data.filterTxt = {};
		data.filterDates = {};
		data.SortBy = ['-TransTime'];

		return data;

	}

	function dateRangeChange(dtMode, isValid) {

		vm.detailReady = '';
		vm.query.DateRangeMode = dtMode;
		vm.query.DateRangeValid = isValid;

		vm.query.bigdate = false;
		if((dtMode == 'YEARLY' || dtMode == 'YTD' || dtMode == 'LTM' || dateRangeIsCustom(dtMode)) && isValid) {
			vm.query.bigdate = utilSvc.dt.diffDays(vm.query.StartDate.val, vm.query.EndDate.val) > 92;
		}

		// on first response from date widget call querySubmit()
		if(vm.init && !!!vm.query.bigdate) {
			querySubmit();
			vm.init = false;
		}

	}

	function querySubmit() {

		// request query valid
		if(!vm.query.DateRangeValid) {
			if(!vm.init) {
				msgSvc.ok('Search', 'Check date filter values');
			}
			vm.detailReady = '';
			return;
		}

		// exit if waiting
		if(vm.isWaiting) {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);
		vm.detailReady = '';

		accumRepo.getDetail(vm.query).then(okDetail, errDetail);

		function okDetail(r) {

			// remember display filter values
			var displayInfo = angular.toJson({
				filterTxt: vm.display.filterTxt,
				filterDates: vm.display.filterDates,
				SortBy: vm.display.SortBy
			});

			vm.display = displayVM(r);

			// pre-load adjustment model
			vm.adjust = accumRepo.adjustVM(r.Id, r.AccumTotalQty);

			// re-load display filters
			displayInfo = angular.fromJson(displayInfo);
			vm.display.filterTxt = displayInfo.filterTxt;
			vm.display.filterDates = displayInfo.filterDates;
			vm.display.SortBy = displayInfo.SortBy;

			// put Type + NDC in view title
			if(!vm.init) {
				_routeInfo.title = 'Accumulator ' + vm.display.AccumType + ': ' + vm.display.ItemCode;
				$scope.$emit('shared.main.setInfo', _routeInfo);
			}

			// show link to Mapping feature?
			vm.query.canNavToMapping = r.RxBizModel == 'SPLIT' && utilSvc.user.hasFeature($scope, 'ops.transform');

			// simplify html logic for adjustments
			vm.query.canEditSplit = (vm.query.RxBizModel == 'SPLIT' || vm.query.RxBizModel == 'SPLITMATCH') && (!!vm.display.OptimizerEnabled || !!vm.query.isVerity);

			if(_returnVisit) {
				_returnVisit = false;
				$timeout(submitDone, 500); // firefox needs a slight delay to render table properly
			}
			else {
				submitDone();
			}

		}

		function submitDone() {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.detailReady = 'yes';

			// remember the date
			var q = vm.query;
			sessionRepo.set('vs-accum-detail', {
				DateRangeMode: q.DateRangeMode,
				StartDate: q.StartDate.val,
				EndDate: q.EndDate.val
			});

		}

		function errDetail(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r !== null) {
				r = r || {};
				errSvc.warn('Accum Detail Get Error for: ' + vm.query.Id, 'accumDetailCtl.getDetail.errDetail', r.status, utilSvc.http.safeResponse(r));
			}
			$state.go('ops.accum', {}, {reload:'ops.accum'});
		}

	}

	function querySubmitInventory() {
		if(vm.isWaiting) {
			return;
		}

		// reset inventory tab for new query
		vm.inventory.tbl = {};
		vm.inventory.flt = vm.initFilters({
			Config: {
				Dates: ['CreatedDate', 'ModifiedDate', 'InvoiceDate'],
				DateFmt: 'M/d/yyyy'
			},
			Exact: {ObjectState:''},
			SortBy: ['CreatedDate']
		});
		$scope.$broadcast('widget.paging', {uniqueId: 'INVENTORY'});
		
		var query = {
			CE: vm.query.CE, 
			RX: vm.query.RX, 
			NDC: vm.display.ItemCode
		};

		vm.isWaiting = true;
		msgSvc.wait(true);

		accumRepo.getPurchaseList(query).then(okList, errList);

		function okList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.inventory.tbl = displayPurchaseVM(r.Items, r.TooMany);
			vm.inventory.tbl.Items = vm.filterList(vm.inventory.tbl.DataItems, vm.inventory.flt);

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: 'INVENTORY',
				Size: vm.inventory.flt.PageSize,
				Page: vm.inventory.flt.Page,
				Total: vm.inventory.flt.PageTotal,
				RowCount: vm.inventory.flt.Count,
				ItemCount: vm.inventory.tbl.Items.length,
				DataCount: vm.inventory.tbl.DataItems.length
			});

			vm.inventory.flt.Ready = true;
		}

		function errList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r !== null) {
				r = r || {};
				errSvc.warn('Inventory List Get Error for: ' + query.NDC, 'accumDetailCtl.getDetail.errDetail', r.status, utilSvc.http.safeResponse(r));
			}
			$state.go('ops.accum', {}, {reload:'ops.accum'});
		}

	}


	/**
	 *    ADJUSTMENTS
	 */

	function adjustReset() {
		vm.adjust.NdcFail = "";
		vm.adjust.AdjustQty = validSvc.newProp();
		vm.adjust.Note = validSvc.newProp('');
		vm.adjust.NewQty = vm.adjust.CurrentQty;
	}

	function adjustToggle(action) {

		if(vm.isWaiting) {
			return;
		}

		vm.popup = {};
		adjustReset();

		switch(action) {
			case 'ADJUST':
				vm.action = 'ADJUST';
				break;
			case 'TRANS':
				catalogSearch();
				break;
			default:
				vm.action = '';
				tabChange('RECENT');
		}
	}

	function tabChange(newTab) {
		// added tabs instead of header links
		vm.activeTab = newTab;

		switch(newTab) {
			case 'RECENT':
				// returning to tab, no refresh needed
				break;
			case 'INVENTORY':
				querySubmitInventory();
				break;
			default:
				msgSvc.ok('accumDetail.tabChange, unknown tab: ' + newTab);
		}
	}

	function validAdjustQty(hardFail) {

		// qty, required must be +- 1 million
		var qty = utilSvc.num.parse(vm.adjust.AdjustQty.val);
		if(!validSvc.isNumber(qty) || qty === 0 || qty < -1000000000 || qty > 1000000000) {
			vm.adjust.AdjustQty.fail = hardFail ? 'yes' : '';
			vm.adjust.AdjustQty.msg = 'required, number between -1,000,000,000 and 1,000,000,000';
		}
		else if(vm.action == 'TRANS' && qty <= 0) {
			vm.adjust.AdjustQty.fail = hardFail ? 'yes' : '';
			vm.adjust.AdjustQty.msg = 'transfer must be greater than zero';
		}
		else {
			vm.adjust.AdjustQty.fail = '';
		}

	}

	function adjustChangedQty() {

		// user changed adjust qty, update total

		validAdjustQty();
		if(vm.adjust.AdjustQty.fail == 'yes') {
			vm.adjust.NewQty = '';
		}
		else {
			var adjVal = utilSvc.num.parse(vm.adjust.AdjustQty.val);
			if(adjVal === 0) {
				vm.adjust.NewQty = '';
			}
			else {
				if(vm.action == 'TRANS') {
					adjVal *= -1;
				}
				vm.adjust.NewQty = utilSvc.str.toText($filter('number')(adjVal + utilSvc.num.parse(vm.adjust.CurrentQty), 4));
			}
		}

	}

	function adjustSave() {

		if(vm.isWaiting) {
			return;
		}

		// transfer ndc, required
		if(vm.action == 'TRANS' && !validSvc.isText(vm.adjust.NdcTo.NDC)) {
			vm.adjust.NdcFail = 'yes';
			vm.adjust.NdcMsg = 'Ndc is required';
		}
		else {
			vm.adjust.NdcFail = '';
		}

		// qty, required must be +- 1 million
		validAdjustQty(true);

		// note, required 2- 250 chars
		var note = vm.adjust.Note.val;
		if(!validSvc.isText(note) || note.length < 2 || note.length > 250) {
			vm.adjust.Note.fail = 'yes';
			vm.adjust.Note.msg = 'required, 2 to 250 characters';
		}
		else {
			vm.adjust.Note.fail = '';
		}

		if(vm.adjust.AdjustQty.fail == 'yes' || vm.adjust.Note.fail == 'yes' || vm.adjust.NdcFail == 'yes') {
			msgSvc.ok('Cannot Save', 'Please check values');
			return;
		}

		var adjustQty = utilSvc.str.toText($filter('number')(utilSvc.num.parse(vm.adjust.AdjustQty.val), 4)),
			msgTxt = vm.action == 'ADJUST' ? 'adjustment' : 'transfer';

		msgSvc.confirm({
			id: 'admin.ops.accum.adjust',
			title: 'Adjust Accumulator',
			msg: 'Confirm ' + adjustQty + ' quantity ' + msgTxt + ' with new total: ' + vm.adjust.NewQty + ' ?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmAdjustSave, confirmAdjustSave);

		function confirmAdjustSave(r) {
			// user said yes
			if(!!r && r.result == 'YES') {
				vm.isWaiting = true;
				msgSvc.wait(true);

				// truncate value to 4 decimals
				vm.adjust.AdjustQty.val = utilSvc.str.toText($filter('number')(utilSvc.num.parse(vm.adjust.AdjustQty.val), 4));

				accumRepo.adjustSave(vm.action, vm.adjust).then(okAdjustSave, errAdjustSave);
			}
		}

		function okAdjustSave(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			msgSvc.ok('Adjustment Complete', 'Please note, there may be a brief delay before the display is updated. Refresh your Accumulator view to see the updated total.');
			adjustToggle();

		}

		function errAdjustSave(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!!r || r === null) {
				// already handled
				$state.go('ops.accum', {}, {reload:'ops.accum'});
			}
			else if(r.status === 409) {
				// conflict
				errSvc.info('Could not save, database conflict. Verify and try again.');
			}
			else if (r.status === 422) {
				// validation
				vm.adjust = r.model;
			}
			else {
				errSvc.error('Unexpected api error', 'accumDetail.errAdjustSave', r.status, utilSvc.http.safeResponse(r));
				$state.go('ops.accum', {}, {reload:'ops.accum'});
			}

		}

	}


	/**
	 *    REVERSALS - SPLIT DISPENSES
	 */

	function getReversalTransactions(atrans) {

		// standardized as popup type, see openPopup(REVERSALS), closePopup
		msgSvc.wait(true);
		vm.isWaiting = true;

		accumRepo.getReversalTransactions(atrans.TransId).then(okGetReversals, errGetReversals);

		function okGetReversals(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(!!vm.popup && vm.activeTab == 'RECENT') {
				vm.popup.Transactions = Array.isArray(r) ? r : [];
				vm.popup.maxHeight = vm.popup.Transactions.length <= 5;
				vm.popup.ready = true;
			}
		}

		function errGetReversals(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(r != null) {
				errSvc.warn('Unknown get response', 'accumDetail.getReversalTransactions', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	/**
	 *    NAV TO FEATURE
	 */

	function navToFeature(navType, navData) {

		// nav to Mapping, Order Details or Invoice Details features

		if(vm.isWaiting) {
			return;
		}

		// save context so user can return via breadcrumb link
		var q = vm.query;
		sessionRepo.set('vs-accum-detail-breadcrumb', {
			Id: q.Id,
			CE: q.CE,
			RX: q.RX,
			ShareGroup: q.ShareGroup,
			CanEdit: q.CanEdit,
			DateRangeMode: q.DateRangeMode,
			StartDate: q.StartDate.val,
			EndDate: q.EndDate.val
		});

		var breadcrumb = {
			icon: 'sprite-ndc-accum',
			route: 'ops.accum-detail',
			routeData: {breadcrumb: true},
			msg: 'Return to Accumulation Detail for NDC: ' + vm.display.ItemCode
		};

		switch(navType) {

			case 'MAPPING':
				$state.go('ops.transform', {rxid:vm.query.RX, tab:'TRANSFORM', ndc: vm.display.ItemCode, transid: navData}, {reload: 'ops.transform'});
				break;

			case 'ONORDER':
				$state.go('orders.detail-route', {id: navData.OrderId, breadcrumb: breadcrumb}, {reload: 'orders.detail-route'});
				break;

			case 'INVOICE':
				// tbd: $state.go('invoice.split-detail', {id: id, rxid: vm.query.RX.val}, {reload: 'invoice.split-detail'});
				break;

			default:
				alert('accumDetailCtl.navToFeature, unknown navType: ' + navType);
		}

	}


	/**
	 *    POPUP
	 *    used for NDC catalog search and Mapping trans detail
	 */

	function cleanUpMapChange(hist) {

		// clean up map change history arrays before bind

		hist = hist || {};

		hist.Changes = Array.isArray(hist.Changes) ? hist.Changes : [];

		var items = Array.isArray(hist.Adjustments) ? hist.Adjustments : [];
		for(var i = 0; i < items.length; i++) {
			items[i].AccumulatorAdjustments = Array.isArray(items[i].AccumulatorAdjustments) ? items[i].AccumulatorAdjustments : [];
		}
		hist.Adjustments = items;

		return hist;

	}

	function openPopup(evt, popType, item) {

		if(vm.isWaiting) {
			return;
		}
		var offsetY = 0;

		switch(popType) {

			case 'NDC':
				vm.popup = {
					ready: false,
					type: popType,
					title: 'NDC Catalog Search',
					NDC: validSvc.newProp(vm.adjust.NdcFrom.NDC),
					Desc: validSvc.newProp(),
					Items: [],
					SortBy: 'NDC',
					Paging: {
						Size: 50
					}
				};
				break;

			case 'ADJMAP':
				vm.popup = {
					ready: false,
					type: popType,
					title: 'Mapping Change Log',
					hist: cleanUpMapChange(item)
				};
				offsetY = -100;
				break;

			case 'REVERSALS':
				if(!!!item || !validSvc.isText(item.TransId)) {
					msgSvc.ok('', 'No split transactions.');
					return;
				}
				if (!!!item.IsReversal) {
					return;
				}

				var revType = !!!item.ManualReversal ? 'Negative' : 'Reversal';
				vm.popup = {
					ready: false,
					type: popType,
					title: revType + ' Transactions',
					reversalType: revType,
					maxHeight: true,
					Transactions: []
				};
				offsetY = -100;
				break;
				
			default:
				alert('accumDetailCtl.openPopup, popType unknown: ' + popType);
		}

		// loop html element parents looking for popup container top
		var elem = evt.target,
			scrollTopFound = false;
		while(!!elem) {
			if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
				break;
			}

			// scroll container found, reduce offset if this container is scrolled
			if(!scrollTopFound && !!elem.className && elem.className.indexOf('table-fixed-header-scroll') > -1) {
				scrollTopFound = true;
				offsetY -=  Math.floor(elem.scrollTop);
			}

			// add offset, get next element
			offsetY += elem.offsetTop;
			elem = elem.offsetParent;
		}
		elem = null;

		// offset popup vertical
		var popElem = document.getElementById('accumDetailPopupContent');
		if(!!popElem) {
			popElem.style.top = offsetY.toString() + 'px';
		}

		// load and show popup
		if(popType == 'REVERSALS') {
			getReversalTransactions(item);
		}
		else {
			// wait for digest cycle
			$timeout(function() {
				vm.popup.ready = true;
			}, 100);
		}

	}

	function popupQueryValid() {

		var resultText = '';

		var ndc = vm.popup.NDC.val,
			desc = vm.popup.Desc.val;

		// ndc or desc is required
		if(!validSvc.isText(ndc) && !validSvc.isText(desc)) {
			vm.popup.NDC.fail = 'yes';
			vm.popup.Desc.fail = 'yes';
			resultText = (resultText.length > 0 ? ', ' : '') + 'NDC or Description search text is required';
		}

		// ndc, optional 3 to 13 characters
		if(validSvc.isText(ndc) && (ndc.length < 3 || ndc.length > 13)) {
			vm.popup.NDC.fail = 'yes';
			resultText = (resultText.length > 0 ? ', ' : '') + 'NDC must be 3 to 13 characters';
		}
		else {
			vm.popup.NDC.fail = 'no';
		}

		// description, optional 3 to 50 characters
		if(validSvc.isText(desc) && (desc.length < 3 || desc.length > 50)) {
			vm.popup.Desc.fail = 'yes';
			resultText = (resultText.length > 0 ? ', ' : '') + 'Description must be 3 to 50 characters';
		}
		else {
			vm.popup.Desc.fail = 'no';
		}

		return resultText;
	}

	function popupSearch(showMsg) {

		// search query valid
		var result = popupQueryValid();
		if(result !== '') {
			if(showMsg) {
				msgSvc.ok('NDC Search', 'Check filter properties. ' + result);
			}
			return;
		}

		// exit if waiting
		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true);

		vm.popup.Items = [];

		// send api request
		catalogsRepo.search(vm.popup).then(okSearch, errCatSearch);

		function okSearch(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.popup.Items = Array.isArray(r.Items) ? r.Items : [];
			vm.popup.Paging = {
				Page: 1,
				Size: $scope.tblPagingSize,
				Total: vm.getTotalPages(vm.popup.Items.length, $scope.tblPagingSize),
				TooMany: r.TooMany
			};

			// none found
			if(vm.popup.Items.length < 1) {
				msgSvc.ok('NDC Catalog Search', 'None found');
			}
		}
	}

	function catalogSearch() {

		// find the current accumulator's NDC in Medispan before showing transfer quantity UI

		vm.isWaiting = true;
		msgSvc.wait(true);

		// get catalog details of the current ndc
		catalogsRepo.search({
			NDC: {val: vm.display.ItemCode},
			Desc: {val:''}
		}).then(okNdcToSearch, errCatSearch);

		function okNdcToSearch(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!!r) {
				return;
			}

			// ndc not found
			if(!Array.isArray(r.Items)) {
				msgSvc.ok('Cannot Find Ndc', 'Current NDC: ' + vm.display.ItemCode + ' not found in Medispan, transfer not possible.');
				return;
			}

			// too many found
			if(r.Items.length > 1) {
				msgSvc.ok('Multiple Ndc Found', 'Current NDC: ' + vm.display.ItemCode + ' has multiple Medispan entries, transfer not possible.');
				return;
			}

			// load up values
			vm.adjust.NdcFrom = accumRepo.adjustNdcVM(r.Items[0]);
			vm.action = 'TRANS';
		}
	}

	function errCatSearch(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		if(!!r) {
			errSvc.warn('Unknown get response', 'accumDetailCtl.errCatSearch', r.status, utilSvc.http.safeResponse(r));
		}
	}

	function purchasefilterChange(immediate) {
		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if (!vm.inventory.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.inventory.flt.Dirty = true;

		// already working
		if (vm.inventory.flt.Busy) {
			return;
		}
		vm.inventory.flt.Busy = true;
		vm.inventory.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function () {
			vm.inventory.tbl.Items = vm.filterList(vm.inventory.tbl.DataItems, vm.inventory.flt);
			vm.inventory.flt.Busy = false;

			// run again? data changed during filtering
			if (vm.inventory.flt.Dirty) {
				purchasefilterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: 'INVENTORY',
				Size: vm.inventory.flt.PageSize,
				Page: vm.inventory.flt.Page,
				Total: vm.inventory.flt.PageTotal,
				RowCount: vm.inventory.flt.Count,
				ItemCount: vm.inventory.tbl.Items.length,
				DataCount: vm.inventory.tbl.DataItems.length
			});

		}, delayTime);
	}

	function closePopup(item) {

		if(!!!vm.popup || !validSvc.isText(vm.popup.type)) {
			return;
		}

		if(vm.popup.type == 'NDC') {
			// assign item found
			vm.adjust.NdcTo = !!item ? accumRepo.adjustNdcVM(item) : accumRepo.adjustNdcVM();
			if (!!vm.adjust.NdcTo.NDC) {
				vm.adjust.NdcFail = "";
			}
		}
		vm.popup = {};
	}


	/**
	 *    EXCEL
	 *    get file from server
	 */

	function getExcel() {

		// already working?
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		if (!!vm.query.bigdate) {
			createAsyncExcel();
			return;
		}

		var rxName = utilSvc.aff.rxShortNameById($scope.User.AffList, vm.query.RX);
		_pendingExcelFilename = 'Verity-' + vm.query.CE + '-' + rxName + '-Accumulation-Detail.xlsx';
		accumRepo.getDetailExcel(vm.query, _pendingExcelFilename).then(okServerExcel, errServerExcel);

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Create Excel Error', 'accumListCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}

	function createAsyncExcel() {
		var apiQuery = {
			Context: {
				CEID: [vm.query.CE],
				RXID: [vm.query.RX],
				VENID: [],	
			},
			Params: {
				AccumId: vm.query.Id,
				ReportType: 'ACCUM_DETAILS',
				StartDate: vm.query.StartDate.val,
				EndDate: vm.query.EndDate.val,
			}
		};

		vm.popup = {};
		vm.isWaiting = true;
		msgSvc.wait(true);
		reportRepo.createAsyncFile(apiQuery).then(okServerExcel, errServerExcel);

		/**
		 *    EXCEL HELPERS
		 */

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			
			msgSvc.ok('Excel File Requested', 'Check the "Saved Files" link at top right to retrieve this Excel Workbook.');
		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if (!!r) {
				errSvc.warn('Create Excel Error', 'accum.ServerExcel', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function expireReserve(item) {
		if(vm.isWaiting) {
			return;
		}
		
		msgSvc.confirm({
			id: 'ops.accum.releasereserve',
			title: 'RELEASE ON ORDER QTY',
			msg:  "Release reservation quantity?",
			notes: {
				prompt: 'optional change notes',
				maxlength: 100,
				out: ''
			},
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);


		function userConfirm(r) {
			if(!!r && r.result == 'YES') {
				msgSvc.wait(true);
				vm.isWaiting = true;

				accumRepo.releaseReserve(item.LinkId, r.notes).then(okRelease, errRelease);
			}
			
			function okRelease(r) {
				msgSvc.wait(false);
				vm.isWaiting = false;
				msgSvc.ok('ON ORDER QTY released', 'Refresh your Accumulator view to see the updated status');
			}
	
			function errRelease(r) {
				msgSvc.wait(false);
				vm.isWaiting = false;
				if(!!r) {
					errSvc.warn('Release Failed', 'accumDetail.expireReserve', r.status, utilSvc.http.safeResponse(r));
				}
			}
		}
	}

	/**
	 *    DISPLAY VIEW MODEL FOR PURCHASE
	 */

	 function displayPurchaseVM(dataItems, tooMany) {

		dataItems = Array.isArray(dataItems) ? dataItems : [];
		var item = {},
		items = [];
		
		// add uniqueId
		for (var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.uniqueId = i;

			item.CreatedDate = item.CrDt;
			item.ModifiedDate = item.ModDt;
			item.InvoiceNumber = item.InvNumber;
			item.InvoiceDate = validSvc.isDate(item.InvDt) ? item.InvDt : null;
			item.Imported = (!!item.Imported ? "YES" : "NO");

			items.push(item);
		}

		return {
			DataItems: items,
			Items: [], // loaded by filterChange()
			TooMany: !!tooMany
		};
   }

	function getPurchaseHistoryExcel() {

		// already working?
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		var rxName = utilSvc.aff.rxShortNameById($scope.User.AffList, vm.query.RX);
		_pendingExcelFilename = 'Verity-' + vm.query.CE + '-' + rxName + '-Inventory-Detail.xlsx';
		accumRepo.getPurchaseExcel(vm.query, vm.display.ItemCode, _pendingExcelFilename).then(okServerExcel, errServerExcel);

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Create Excel Error', 'accumListCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}

	function dateRangeIsCustom(dtMode) {
		return dtMode.indexOf('CUSTOM') > -1;
	}


	function initAsyncReports() {
		return {
			title: 'Accumulation Details - Saved Files',
			show: 'no'
		};
	}

	function toggleAsyncReports() {
		if(vm.isWaiting) {
			return;
		}
		vm.asyncReports.show = vm.asyncReports.show == 'yes' ? 'no' : 'yes';
		if(vm.asyncReports.show == 'yes') {
			$state.go('ops.accum-detail.async-reports', {
				rptType: 'ACCUM_DETAILS',
				query: null
			}, {reload: 'ops.accum-detail.async-reports'});
		}
	}
}
 
accumListCtl.$inject = ['$window', '$state', '$scope', '$timeout', 'accumRepo', 'lookupRepo', 'reportRepo', 'sessionRepo', 'prefsRepo', 'msgSvc', 'utilSvc', 'validSvc', 'errSvc'];
angular
.module('espui.ops')
.controller('AccumListCtl', accumListCtl);


/* @ngInject */
function accumListCtl($window, $state, $scope, $timeout, accumRepo, lookupRepo, reportRepo, sessionRepo, prefsRepo, msgSvc, utilSvc, validSvc, errSvc) {

	/*jshint validthis: true */
	var vm = this;
	var	_pendingExcelFilename = '',
		_isReturnNav = false,
		_featureName = '',
		_pendingShowHide = null,
		_pagingEventListener = null,
		_tblViewEventListener = null,
		_mouseLeaveDelay = {};


	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addTableViews(vm);
	utilSvc.ctl.addMultiselect(vm);
	utilSvc.ctl.addFlexTop(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.ExcludeDecimals = true;

	// droplists
	vm.ShareGroupDroplist = [];
	vm.RxDroplist = [];
	vm.CeDroplist = [];
	vm.VenDroplist = [];
	vm.HiddenDroplist = [];
	vm.HistoryVenDroplist = [];
	vm.ProgAdminDroplist = [];
	vm.SearchByDroplist = [];
	vm.RollupDroplist = [];

	// multiselect
	vm.SearchByMulti = {};
	vm.RxBizModelMulti = {};
	vm.multiToggle = multiToggle;
	vm.multiHover = multiHover;
	vm.multiClick = multiClick;
	
	// query
	vm.query = {};
	vm.queryOptions = [];
	vm.queryChangeSearchType = queryChangeSearchType;
	vm.queryChangeSearchBy = queryChangeSearchBy;
	vm.queryChangeProgAdmin = queryChangeProgAdmin;
	vm.queryChangeSearchOptions = queryChangeSearchOptions;
	vm.queryChangeShareGroup = queryChangeShareGroup;
	vm.queryChangeRxRollup = queryChangeRxRollup;
	vm.queryChangeCE = queryChangeCE;
	vm.queryChangeRX = queryChangeRX;
	vm.queryChangeVEN = queryChangeVEN;
	vm.queryChangeAffs = queryChangeAffs;
	vm.querySubmit = querySubmit;

	// tbl and filters
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;
	vm.updateViewState = updateViewState;

	// methods
	vm.rowClick = rowClick;
	vm.getDetail = getDetail;
	vm.getExcel = getExcel;
	vm.createExcel = createExcel;

	// popup
	vm.popup = {};
	vm.fltPop = {};
	vm.filterChangePopup = filterChangePopup;
	vm.closePopup = closePopup;

	// import
	vm.showImport = false;
	vm.showImportHistory = false;
	vm.showImportAdjust = false;
	vm.importType = '';
	vm.importTypeDroplist = [];
	vm.importFile = null;
	vm.importVENID = validSvc.newProp('NONE');
	vm.importErrors = [];
	vm.importToggle = importToggle;
	vm.importSend = importSend;
	vm.importErrorsToCsv = importErrorsToCsv;

	// Purchase History
	vm.resetPurchaseHistory = resetPurchaseHistory;

	// show / hide
	vm.showHideOptions = showHideOptions;

	// table view
	vm.tblViewConfig = {};
	vm.tblView = {};

	// flex top
	vm.flex = {};
	vm.flexTopExpand = flexTopExpand;


	// async reports
	vm.asyncReports = {};
	vm.toggleAsyncReports = toggleAsyncReports;	

	// popup
	vm.openPopup = openPopup;

	/**
	 *   EVENTS
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});

	_tblViewEventListener = $scope.$on('widget.tblview.editor.change', function(event, evtData) {
		event.stopPropagation();

		switch(evtData.type) {

			case 'edit':
				openPopup('TBLVIEW');
				break;

			case 'close':
				closePopup();
				break;

			case 'load':
				// load specific view requested
				vm.tblView.current = evtData.id;
				$timeout(function() {
					tblViewReload(vm.query, true);

					// update user preference (delay the network call)
					$timeout(function() {
						if(vm.action == 'AFFLIST') {
							var tblConfig = vm.tblViewConfig[vm.action];
							if(!!tblConfig && !!vm.tblView && validSvc.isText(vm.tblView.current)) {
								prefsRepo.setCurrentTableView(tblConfig.storageKey, vm.tblView.current).then(okCurrentTableView, errCurrentTableView);
							}
						}
					}, 2000);
				}, 300);
				break;

			default:
				throw new Error('accunListCtl.widget.tblview.editor.change, unknown event type: ' + evtData.type);
		}

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
		if(!!_tblViewEventListener) {
			_tblViewEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		_featureName = $state.current.name;

		vm.init = true;
		vm.action = '';
		vm.flex = vm.flexInit();
		vm.asyncReports = initAsyncReports();

		vm.tblViewConfig = tblViewConfigSetup($scope.User.Type, tblViewSchemaVM());

		vm.query = initQueryAndDroplists($scope.User);
		vm.flt = initViewStateAndFilter(vm.query);

		// fire change events
		queryChangeSearchType();

		vm.init = false;

		// ASYNC: get rollup droplist after first render so we don't hang up router
		$timeout(initRollups, 300);	
	}

	function getAffs(showInactive) {
		var affStatus = ['ONBOARDING', 'ACTIVE'];
		if(!!showInactive) {
			affStatus.push('INACTIVE');
		}
		var affs = utilSvc.aff.findStatus($scope.User.AffList, affStatus);
		return utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));
	}

	function newCheckProp(val) {
		var prop = validSvc.newProp(val);
		prop.chk = false;
		return prop;
	}

	function initQueryAndDroplists(usr) {

		var isVerity = usr.Type == 'VERITYSA' || usr.Type == 'VERITY';
		var query = {
			isVerity: isVerity,
			showInactiveAffs: 'no',
			CE: validSvc.newProp(validSvc.isCE(usr.CE) ? usr.CE : 'NONE'),
			RX: validSvc.newProp(validSvc.isRX(usr.RX) ? usr.RX : 'NONE'),
			VEN: validSvc.newProp('NONE'),
			RxRollup: validSvc.newProp('NONE'),
			SearchType: 'AFF',
			SearchBy: validSvc.newProp('SHAREGROUP'),
			SearchOptions: validSvc.newProp(),
			ShareGroup: newCheckProp('NONE'),
			ShowHidden: 'no',
			PopupId: '',
			hasShareGroups: false,
			hasIndigent: false,
			hasCP: false,
			hasCPTPA: false,
			hasSPLIT: false,
			hasSPLITMATCH: false,
			PriceCatalog: validSvc.newProp(),
			RxBizModel: newCheckProp(),
			ProgAdmin: validSvc.newProp('NONE'),
			SearchByMulti: validSvc.newProp(),
			slvSections: {} // search results set this
		};
		query.RxBizModel.vals = [];
		query.SearchByMulti.vals = [];
		query.SearchByMulti.title = '';
		query.SearchOptions.show = 'no';
	
		var affs = getAffs(false); // keep at false, group options should NOT use INACTIVE affiliations

		// GROUP: SearchBy
		var searchBy = [
			{label:'Facilities', value:'CE'},
			{label:'Pharmacies', value:'RX'}
		];
		if(isVerity || usr.Type == 'RX') {
			searchBy.push({label:'Program Admin', value:'PROGADMIN'});
		}
		searchBy.push({label:'Share Group', value:'SHAREGROUP'});
		vm.SearchByDroplist = searchBy;

		// GROUP: SearchBy ShareGroup
		query.hasShareGroups = false;
		var grps = utilSvc.aff.shareGroupList(affs);
		if(grps.length > 0) {
			vm.ShareGroupDroplist = utilSvc.ng.droplist(
				grps,
				'',
				'',
				[{label:'Choose a Group', value:'NONE'}]);
			query.hasShareGroups = true;
		}
		
		// GROUP: SearchBy ProgAdmin
		vm.ProgAdminDroplist = utilSvc.ng.droplist(utilSvc.aff.progAdminList(affs), '', '', [{label:'Choose a Program Admin', value:'NONE'}]);

		// GROUP: SearchBy CE or RX
		// note: this is setup after SearchBy is chosen
		vm.SearchByMulti = {
			type: '', // will be set to CE or RX
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: '',
			vals: [],
			list: [],
			flt: ''
		};

		// GROUP: query option Rx Business Model
		// note: models depend on ProgAdmin / Group / CE / RX affiliations chosen
		vm.RxBizModelMulti = {
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Business Model',
			vals: [],
			list: [],
			flt: ''
		};

		// GROUP: query option checkmarks
		vm.queryOptions = [
			{name:'NegativeAccum', title:'Negative Accumulators', chk:false},
			{name:'MissingCatalog', title:'Missing Catalog Item', chk:false},
			{name:'NegativeAvail', title:'Negative Available', chk:false},
			{name:'Profitable', title:'Profitable', chk:false}, // depends on CP biz model
			{name:'AlwaysSplit', title:'Always Split', chk:false},
			{name:'NeverSplit', title:'Never Split', chk:false},
			{name:'GlobalBlock', title:'Global Block List', chk:false},
			{name:'CeBlock', title:'CE Block List', chk:false},
			{name:'VendorBlock', title:'Vendor Block List', chk:false}
		];
		
		vm.HiddenDroplist = [
			{label: 'ALL', value: ''},
			{label: 'NO', value: 'NO'},
			{label: 'YES', value: 'YES'}
		];

		return query;
	}

	function initFilter() {
		// used by both aff and group tables

		return vm.initFilters({
			Text: {
				HiddenTxt: ''
			},
			Config: {
				Dates: ['First', 'Last', 'LastInvoice', 'LastOrder','OldestDispense'],
				DateFmt: 'M/d/yyyy'
			},
			SortBy: ['ItemCode']
		});
	}

	function initViewStateAndFilter(q) {

		var flt = initFilter();

		// get veiwstate
		_isReturnNav = false;
		var vs = sessionRepo.get('vs-accum-list');
		if(!!vs) {
			var vsq = vs.query;
			vm.ExcludeDecimals = vs.ExcludeDecimals;
			switch(vsq.SearchType) {
				case 'AFF':
					q.SearchType = 'AFF';
					q.ShowHidden = vsq.ShowHidden;
					q.showInactiveAffs = vsq.showInactiveAffs;
					q.CE.val = vsq.CE;
					q.RX.val = vsq.RX;
					q.VEN.val = vsq.VEN;
					_isReturnNav = true;
					break;

				case 'GROUP':
					q.SearchType = 'GROUP';
					q.SearchBy.val = vsq.SearchBy;
					q.ShareGroup.val = vsq.ShareGroup;
					q.ProgAdmin.val = vsq.ProgAdmin;
					q.RxRollup.val = vsq.RxRollup;

					var sb = vsq.SearchBy;
					if(sb == 'CE' || sb == 'RX') {
						q.SearchByMulti.vals = vsq.SearchByMulti;
						vm.SearchByMulti.type = sb;
					}

					// slv search options
					var bizModels = vsq.RxBizModel;
					if(Array.isArray(bizModels) && bizModels.length > 0) {
						q.RxBizModel.chk = true;
						q.RxBizModel.vals = bizModels;
					}
					var options = vsq.QueryOptions,
						opt = {};
					for(var i = 0; i < vm.queryOptions.length; i++) {
						opt = vm.queryOptions[i];
						if(options.indexOf(opt.name) > -1) {
							opt.chk = true;
						}
					}

					q.PopupId = vsq.PopupId;
					q.ItemCode = vsq.ItemCode;
					if(!!vs.fltPop) {
						vm.fltPop = vm.resetFilters(vs.fltPop, true);
					}

					_isReturnNav = true;
					break;

				default:
					msgSvc.ok('ViewState not available, unknown search type: ' + vsq.SearchType);
					return;
			}

			flt = vm.resetFilters(vs.flt, true);
		}
		
		return flt;
	}

	function initRollups() {
		// ASYNC loading of ROLLUP OPTIONS after UI has rendered so router is not hung up waiting for init
		var rollups = findAffRollupParents(getAffs());
		if(rollups.length < 1) {
			initFinalize();
			return;
		}

		lookupRepo.RxInfo(rollups).then(okLookupRx, errInitLoad);

		function okLookupRx(items) {

			// save rollup affs array
			var rollupAffs = [];
			items = Array.isArray(items) ? items : [];
			if(items.length > 0) {
				for(var i = 0; i < items.length; i++) {
					rollupAffs.push({
						RXID:items[i].NickName,
						RxName: items[i].Name,
						RxShortName: items[i].ShortName
					});
				}

				vm.RollupDroplist = utilSvc.aff.rxDroplist(rollupAffs);
				vm.query.UserHasRxRollup = true;
				vm.SearchByDroplist.push({label:'Rollup', value:'RXROLLUP'});
			}

			initFinalize();
		}
	}

	function findAffRollupParents(affs) {
		// get ROLLUP parents from affiliations

		var parentId = '',
			result = [];
		for(var i = 0; i < affs.length; i++) {
			parentId = affs[i].RxParent;
			if(validSvc.isText(parentId) && result.indexOf(parentId) < 0) {
				result.push(parentId);
			}
		}
		return result;
	}

	function errInitLoad(r) {
		vm.RollupDroplist = utilSvc.ng.droplistNONE();
		vm.query.RxRollup = validSvc.newProp('NONE');
		vm.query.UserHasRxRollup = false;

		if(!!r) {
			errSvc.warn('accumListCtl.errInitLoad, issue loading TPA and ROLLUP details', r.status, utilSvc.http.safeResponse(r));
		}
	}

	function initFinalize() {
		// all ASYNC loads complete, enable UI
		
		// reset query state
		queryChangeSearchType();

		// check return view
		var isValid = validQueryOptions(vm.query);
		if(isValid && _isReturnNav) {
			querySubmit();
		}
	}

	/**
	 *    DISPLAY VIEW MODEL
	 */

	function affListVM(dataItems, tooMany) {

		// AFF list view model

		dataItems = Array.isArray(dataItems) ? dataItems : [];

		var item = {},
			detailTxt = '';

		vm.query.hasIndigent = false;

		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.First = validSvc.isDate(item.First) ? item.First : null;
			item.Last = validSvc.isDate(item.Last) ? item.Last : null;
			item.OldestDispense = validSvc.isDate(item.OldestDispense) ? item.OldestDispense : null;
			item.LastOrder = validSvc.isDate(item.LastOrder) ? item.LastOrder : null;
			item.LastInvoice = validSvc.isDate(item.LastInvoice) ? item.LastInvoice : null;
			if (Array.isArray(item.VendorBlockList)) {
				item.VendorBlockList = item.VendorBlockList.join(',');
			}

			item.Price = item.Price < 0 ? null : item.Price; // set negative (null) price to null
			if(item.RxBizModel == 'CP') {
				if(item.AccumType == 'IND') {
					vm.query.hasIndigent = true;
					item.ProfitMargin = 'n/a';
				}
			}

			// details
			detailTxt = '';
			item.showDetail = false;
			item.Detail = Array.isArray(item.Detail) ? item.Detail : [];
			item.hasDetail = item.Detail.length > 0 ? 'yes' : 'no';

			// build detail search text
			for(var ii = 0; ii < item.Detail.length; ii++) {
				detailTxt += item.Detail[ii] + '|';
			}
			item.DetailTxt = detailTxt;

			item.HiddenTxt = !!item.Hidden ? 'YES' : 'NO';
		}

		return {
			Items: [],
			DataItems: dataItems
		};

	}

	function slvVM(q, dataItems) {
		var affs = getAffs(false);
		// GROUP: single line view
		dataItems = Array.isArray(dataItems) ? dataItems : [];

		// reset SLV table sections (all hidden, show only if data values are found)
		q.slvSections = {
			_340B: false,
			_GPO: false,
			_WAC: false,
			_OWN: false,
			_IND: false
		};

		var result = [],
			ceList = [],
			rxList = [],
			item = {},
			accumTypes = ['340B', 'GPO', 'WAC', 'OWN', 'IND'],
			ii = 0;
		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.uniqueId = i.toString();
			item.Id = item.ItemCode;
			ceList = utilSvc.aff.findCeList(affs, [item.CEID]);
			rxList = utilSvc.aff.findRxList(ceList, [item.Pharmacy]);
			if (rxList.length > 0 ) {
				item.ShowDetailLink = true;
			}

			// flatten accum info values directly on item (no sub-objects)
			for(ii = 0; ii < accumTypes.length; ii++) {
				item = assignAccumInfo(item, accumTypes[ii]);
			}
			result.push(item);
		}

		return {
			Items: [],
			DataItems: result
		};

		// helper: assign object value to item property
		function assignProp(item, propName, val) {
			item[propName] = val;
			return item;
		}

		// helper: validate date from server before assignment
		function assignPropDate(item, propName, val) {
			return assignProp(item, propName, validSvc.isDate(val) ? val : null);
		}

		// helper: convert an AccumInfo sub-object into flattened item properties
		function assignAccumInfo(item, accumType) {

			var accumName = 'AccumInfo' + accumType,
				accumInfo = null,
				slvSectionName = '_' + accumType;
			var hasValues = !!q.slvSections[slvSectionName];

			if(!!item[accumName]) {
				accumInfo = item[accumName];
				if(!hasValues && accumInfo.AccumId != '') {
					hasValues = true;
				}
				
				accumInfo.Price  = accumInfo.Price >= 0 ? accumInfo.Price : null;
				// flatten props directly onto each item
				item = assignProp(item, 'Id' + accumType, accumInfo.AccumId);
				item = assignProp(item, 'ItemUnits' + accumType, accumInfo.ItemUnits);
				item = assignProp(item, 'AccumTotal' + accumType, accumInfo.AccumTotal);
				item = assignProp(item, 'Price' + accumType, accumInfo.Price);
				item = assignProp(item, 'AvgDispSize' + accumType, accumInfo.AvgDispSize);
				item = assignPropDate(item, 'LastDispense' + accumType, accumInfo.LastDispense);
				item = assignPropDate(item, 'FirstDispense' + accumType, accumInfo.FirstDispense);
				item = assignPropDate(item, 'OldestDispense' + accumType, accumInfo.OldestDispense);
				item = assignPropDate(item, 'LastOrder' + accumType, accumInfo.LastOrder);
				item = assignProp(item, 'LastOrderQty' + accumType, accumInfo.LastOrderQty);
				item = assignPropDate(item, 'LastInvoice' + accumType, accumInfo.LastInvoice);
				item = assignProp(item, 'LastInvoiceQty' + accumType, accumInfo.LastInvoiceQty);
				
				// drop object we aren't using it now
				item[accumName] = null;
			}

			if(hasValues) {
				q.slvSections[slvSectionName] = true;
			}

			return item;
		}
	}


	/**
	 *    QUERY CHANGE EVENTS
	 *    SearchType --> AFF --> CE --> RX --> VEN
	 *    SearchType --> GROUP --> SearchBy --> SearchOptions				
	 * 								SHAREGROUP
	 * 								PROGADMIN
	 * 								CE or RX Multiselect
	 */

	function queryChange() {
		if(!vm.init) {
			vm.action = '';
			vm.tbl = {
				Items: [],
				DataItems: []
			};
			vm.popup = {Items:[]};
			vm.flt = vm.resetFilters(vm.flt);
			vm.fltPop = vm.resetFilters(vm.fltPop);
			vm.flex = vm.flexInit();
			$scope.$broadcast('widget.paging');

			// slv dynamic sections
			vm.query.slvSections = {};
		}
	}

	function queryChangeSearchType() {
		queryChange();

		// reset filter on search type change
		if(!vm.init && !_isReturnNav) {
			vm.flt = initFilter();
		}

		switch(vm.query.SearchType) {
			case 'AFF':
				vm.CeDroplist = utilSvc.aff.ceDroplist(getAffs(vm.query.showInactiveAffs == 'yes'));
				vm.query.CE = utilSvc.ng.droplistAutoselect(vm.CeDroplist, vm.query.CE.val);
				queryChangeCE();
				break;
			case 'GROUP':
				queryChangeSearchBy();
				break;
			default:
				throw new Error('accumList.queryChangeSearchType, SearchType unknown: ' + vm.query.SearchType);
		}
	}

	function queryChangeSearchBy() {
		var sb = vm.query.SearchBy.val,
			q = vm.query;

		switch(sb) {
			case 'SHAREGROUP':
				q.ShareGroup = utilSvc.ng.droplistAutoselect(vm.ShareGroupDroplist, q.ShareGroup.val);
				queryChangeShareGroup();
				break;
			case 'RXROLLUP':
				if (vm.RollupDroplist.length > 0) {
					q.RxRollup = utilSvc.ng.droplistAutoselect(vm.RollupDroplist, q.RxRollup.val);
					queryChangeRxRollup();	
				}
				break;
			case 'PROGADMIN':
				q.ProgAdmin = utilSvc.ng.droplistAutoselect(vm.ProgAdminDroplist, q.ProgAdmin.val);
				queryChangeProgAdmin();
				break;
			case 'CE':
			case 'RX':
				// setup multiselect
				var affs = getAffs(false), // keep at false, GROUP types do not use INACTIVE
					sbMulti = vm.SearchByMulti,
					options = sb == 'CE' ? utilSvc.aff.ceList(affs) : utilSvc.aff.rxList(affs),
					title = sb == 'CE' ? 'Facility' : 'Pharmacy';

				sbMulti.titleNoOptions = 'Choose a ' + title;
				sbMulti.list = sb == 'CE' ? vm.multiselectBuild(options, false) : vm.multiselectBuildRX(options, false, affs);

				// return visit
				if(sb == sbMulti.type && q.SearchByMulti.vals.length > 0) {
					vm.multiselectReturnVisit(sbMulti, '', q.SearchByMulti.vals);
				}
				else {
					sbMulti.type = sb;
					sbMulti.vals = [];
				}

				multiClick('SearchByMulti');
				break;
			default:
				throw new Error('accumList.queryChangeSearchBy, unknown SearchBy: ' + sb);
		}
	}

	function rebuildRxBizModels(multi, affs) {
		// models depend on choice of ShareGroup, ProgAdmin, CE, RX
		multi.list = [];
		multi.vals = [];
		
		var rxModels = utilSvc.aff.rxModelList(affs);
		if(rxModels.length > 0) {
			rxModels.unshift('ALL');
			multi.list = vm.multiselectBuild(rxModels, false);
	
			// keep vals on return visit
			var queryVals = vm.query.RxBizModel.vals;
			if(vm.query.RxBizModel.chk && queryVals.length > 0) {
				vm.multiselectReturnVisit(multi, '', queryVals);
			}
		}
		vm.multiselectTitle(multi, true);

		return multi;
	}

	function queryChangeShareGroup() {
		queryChange();

		var isValid = validSvc.isEntity(vm.query.ShareGroup.val);
		vm.query.ShareGroup.fail = isValid ? 'no' : 'yes';
		vm.query.SearchOptions.show = isValid ? 'yes' : 'no';
		
		// rebuild Rx Biz Model options
		if(isValid) {
			var affs = utilSvc.aff.findShareGroup(getAffs(false), vm.query.ShareGroup.val); // keep at false, GROUP options do not use INACTIVE affs
			vm.RxBizModelMulti = rebuildRxBizModels(vm.RxBizModelMulti, affs);

			queryChangeSearchOptions();
		}
	}

	function queryChangeProgAdmin() {
		queryChange();

		var isValid = validSvc.isEntity(vm.query.ProgAdmin.val);
		vm.query.ProgAdmin.fail = isValid ? 'no' : 'yes';
		vm.query.SearchOptions.show = isValid ? 'yes' : 'no';
		
		// rebuild Rx Biz Model options
		if(isValid) {
			var affs = utilSvc.aff.findProgAdmin(getAffs(false), vm.query.ProgAdmin.val); // keep at false, GROUP options do not use INACTIVE affs
			vm.RxBizModelMulti = rebuildRxBizModels(vm.RxBizModelMulti, affs);

			queryChangeSearchOptions();
		}
	}

	function queryChangeRxRollup() {
		queryChange();

		var isValid = validSvc.isEntity(vm.query.RxRollup.val);
		vm.query.RxRollup.fail = isValid ? 'no' : 'yes';
		vm.query.SearchOptions.show = isValid ? 'yes' : 'no';
		
		// rebuild Rx Biz Model options
		if(isValid) {
			var affs = getAffs(false);
			vm.RxBizModelMulti = rebuildRxBizModels(vm.RxBizModelMulti, affs);

			queryChangeSearchOptions();
		}
	}

	function queryChangeVEN() {
		queryChange();

		// vendor is optional do not validate it
		vm.query.VEN.fail = 'no';
	}

	function queryChangeSearchOptions() {
		queryChange();

		var isValid = validQueryOptions(vm.query);
		vm.query.SearchOptions.fail = isValid ? 'no' : 'yes';
		vm.query.SearchOptions.msg = isValid ? '' : 'Choose at least 1';

	}

	function flexTopExpand() {
		// user opened search query, reset list display, show search expanded
		queryChange();
	}

	function queryChangeAffs() {
		if(vm.isWaiting) {
			return;
		}
		
		vm.query.showInactiveAffs = vm.query.showInactiveAffs == 'yes' ? 'no' : 'yes';

		// re-run start up sequence
		queryChangeSearchType();
	}

	function queryChangeCE() {
		queryChange();

		// valid CE
		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';
		if(vm.query.CE.fail == 'yes') {
			vm.RxDroplist = utilSvc.ng.droplistNONE();
			vm.VenDroplist = utilSvc.ng.droplistNONE();
			vm.query.RX = validSvc.newProp('NONE');
			vm.query.VEN = validSvc.newProp('NONE');
			return;
		}

		// RX options
		var affs = getAffs(vm.query.showInactiveAffs == 'yes');
		vm.RxDroplist = utilSvc.aff.rxDroplist(affs, vm.query.CE.val);
		vm.query.RX = utilSvc.ng.droplistAutoselect(vm.RxDroplist, vm.query.RX.val);

		queryChangeRX();
	}

	function queryChangeRX() {
		queryChange();

		// RX biz model reset
		vm.query.hasCP = false;
		vm.query.hasCPTPA = false;
		vm.query.hasSPLIT = false;
		vm.query.hasSPLITMATCH = false;

		// price vendor reset
		vm.VenDroplist = utilSvc.ng.droplistNONE();
		
		// valid RX
		vm.query.RX.fail = validSvc.isRX(vm.query.RX.val) ? 'no' : 'yes';
		if(vm.query.RX.fail == 'yes') {
			vm.query.VEN = validSvc.newProp('NONE');
			return;
		}

		var affs = utilSvc.aff.findRx(getAffs(vm.query.showInactiveAffs == 'yes'), vm.query.RX.val);
		affs = utilSvc.aff.findCe(affs, vm.query.CE.val);

		// biz model flags
		var rxModelList = utilSvc.aff.rxModelList(affs);
		vm.query.hasCP = rxModelList.indexOf('CP') > -1;
		vm.query.hasCPTPA = rxModelList.indexOf('CPTPA') > -1;
		vm.query.hasSPLIT = rxModelList.indexOf('SPLIT') > -1;
		vm.query.hasSPLITMATCH = rxModelList.indexOf('SPLITMATCH') > -1;

		// import buttons based on affiliations and query settings
		showImportButtons(affs, vm.query);

		// reset vendor options
		var venOptions = utilSvc.aff.venOptions(affs, vm.query.CE.val, vm.query.RX.val, ['340B','GPO','WAC','IND'], true);
		vm.VenDroplist = utilSvc.ng.droplist(venOptions, '', '', [{label:'Choose a Vendor', value:'NONE'}]);
		vm.query.VEN = _isReturnNav ? utilSvc.ng.droplistAutoselect(vm.VenDroplist, vm.query.VEN.val) : validSvc.newProp('NONE');
		queryChangeVEN();
	}

	function showImportButtons(affs, q) {

		vm.showImport = false;
		vm.showImportAdjust = false;
		vm.showImportHistory = false;

		if(q.isVerity) {

			// adjustment upload
			if(q.hasCP || q.hasSPLIT || q.hasSPLITMATCH) {
				vm.showImportAdjust = true;
			}
			
			// migration upload
			if(affs.length > 0 && affs[0].AffState == 'ONBOARDING' && (q.hasCP || q.hasSPLIT || q.hasSPLITMATCH)) {
				vm.showImport = true;
			}
			
			// purchase history upload, vendor accounts exist
			if(q.hasSPLIT || q.hasSPLITMATCH) {
				var venList = utilSvc.aff.venList(affs, ['340B','GPO','WAC','IND'], true);
				if(venList.length > 0) {
					vm.showImportHistory = true;
				}
			}
		}
	}

	function validQueryOptions(q) {
		var checked = false,
			options = vm.queryOptions,
			option = {};

		if(q.RxBizModel.chk) {
			checked = true;
			q.RxBizModel.vals = vm.multiselectAllVals(vm.RxBizModelMulti);
			q.RxBizModel.fail = q.RxBizModel.vals.length > 0 ? 'no' : 'yes';
		}
		else {
			q.RxBizModel.vals = [];
			q.RxBizModel.fail = '';
		}

		// add query options to query
		q.options = {};
		for(var i = 0; i < options.length; i++) {
			option = options[i];
			if(option.chk) {
				q.options[option.name] = true;
				checked = true;
			}
		}

		return q.RxBizModel.fail != 'yes';
	}

	function queryValid(q) {

		// validate query data before calling api
		switch(q.SearchType) {
			case 'AFF':
				q.CE.fail = validSvc.isCE(q.CE.val) ? 'no' : 'yes';
				q.RX.fail = validSvc.isRX(q.RX.val) ? 'no' : 'yes';
				// note: VEN is optional, do not validate it
				return q.CE.fail == 'no' &&
					q.RX.fail == 'no';

			case 'GROUP':
				var sb = q.SearchBy.val,
					isValid = false;
				switch(sb) {
					case 'SHAREGROUP':
						q.ShareGroup.fail = validSvc.isEntity(q.ShareGroup.val) ? 'no' : 'yes';
						isValid = q.ShareGroup.fail == 'no';
						break;
					case 'RXROLLUP':
						q.RxRollup.fail = validSvc.isEntity(q.RxRollup.val) ? 'no' : 'yes';
						isValid = q.RxRollup.fail == 'no';
						break;
					case 'PROGADMIN':
						q.ProgAdmin.fail = validSvc.isEntity(q.ProgAdmin.val) ? 'no' : 'yes';
						isValid = q.ProgAdmin.fail == 'no';
						break;
					case 'CE':
					case 'RX':
						q.SearchByMulti.vals = vm.multiselectAllVals(vm.SearchByMulti);
						q.SearchByMulti.fail = vm.SearchByMulti.vals.length > 0 ? 'no' : 'yes';
						isValid = q.SearchByMulti.fail == 'no';
						break;
					default:
						throw new Error('accumList.queryValid, unknown SearchBy: ' + sb);
				}

				// RxBizModel valid and at least 1 option selected
				var optionsValid = validQueryOptions(q);

				return isValid && optionsValid;

			default:
				throw new Error('accumListCtl.queryValid, unknown SearchType: ' + q.SearchType);
		}

	}

	function querySubmit() {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		if(!queryValid(vm.query)) {
			if(!vm.init) {
				msgSvc.ok('Search', 'Check filter properties');
			}
			return;
		}

		// close query drawer on return nav (avoids blinking)
		if(_isReturnNav) {
			vm.query.title = queryTitle(vm.query);
			vm.flex = vm.flexCollapse(vm.flex, true);
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		switch(vm.query.SearchType) {
			case 'AFF':
				accumRepo.getAffList(vm.query).then(okGetList, errGetList);
				break;
			case 'GROUP':
				// NEW: single line ndc summary request
				accumRepo.getGroupListSLV('NDC', vm.query).then(okGetGroupSLV, errGetList);
				break;
			default:
				throw new Error('accumList.querySubmit, unknown search type: ' + vm.query.SearchType);
		}

		function okGetList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// query good, save viewstate
			saveViewState(vm.query, vm.flt);
			
			vm.tbl = affListVM(r.Items, r.TooMany);
			vm.flt.Ready = true;

			// force top collapse after good query
			vm.query.title = queryTitle(vm.query);
			vm.flex = vm.flexCollapse(vm.flex, true);
			
			tblViewReload(vm.query, false, true); // keep paging if possible
			_isReturnNav = false;
		}

		function okGetGroupSLV(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			
			// loads table and adds dynamic slv sections to query
			vm.tbl = slvVM(vm.query, r.Items, r.TooMany);
			vm.flt.Ready = true;

			// force top collapse after good query
			vm.query.title = queryTitle(vm.query);
			vm.flex = vm.flexCollapse(vm.flex, true);
			
			tblViewReload(vm.query, false, true); // keep paging if possible
		}

		function errGetList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.error('Unknown get response', 'accumListCtl.errGetList', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function queryTitle(q) {
		// build query drawer title (this query is now valid)
		
		switch(q.SearchType) {
			case 'AFF':
				return 'Affiliation: ' + q.CE.val + ' / ' + utilSvc.ng.droplistLabel(vm.RxDroplist, q.RX.val);

			case 'GROUP':
				var title = 'Summary by ',
					sb = q.SearchBy.val;
				switch(sb) {
					case 'SHAREGROUP':
						return title + ' Share Group: ' + q.ShareGroup.val;
					case 'RXROLLUP':
						return title + ' Rx Rollup: ' + q.RxRollup.val;	
					case 'PROGADMIN':
						return title + ' Program Admin: ' + utilSvc.ng.droplistLabel(vm.ProgAdminDroplist, q.ProgAdmin.val);
					case 'CE':
						title += 'Facility: ';
						var vals = vm.SearchByMulti.vals;
						title += vals.length < 6 ? vals.join(', ') : vm.SearchByMulti.title;
						return title;
					case 'RX':
						// use short names
						title += 'Pharmacy: ';
						var rxvals = vm.SearchByMulti.vals,
							shortNames = [];
						for(var i = 0; i < rxvals.length; i++) {
							shortNames.push(utilSvc.aff.rxShortNameById($scope.User.AffList, rxvals[i]));
						}
						title += shortNames.length < 6 ? shortNames.join(', ') : vm.SearchByMulti.title;
						return title;
					default:
						throw new Error('accumList.queryTitle, unknown SearchBy: ' + sb);
				}
				break;
			default:
				throw new Error('accumListCtl.queryTitle, unknown SearchType: ' + q.SearchType);
		}
	}

	function querySlvExcelTitle(q) {
		// build excel file title
		var title = 'Verity-',
			sb = q.SearchBy.val;
		switch(sb) {
			case 'SHAREGROUP':
				return title + 'ShareGroup-' + q.ShareGroup.val;
			case 'RXROLLUP':
				return title + 'RxRollUp-' + q.RxRollup.val;
			case 'PROGADMIN':
				return title + 'ProgramAdmin-: ' + utilSvc.ng.droplistLabel(vm.ProgAdminDroplist, q.ProgAdmin.val);
			case 'CE':
			case 'RX':
				title += sb == 'CE' ? 'CoveredEntity-': 'Pharmacy-';
				var vals = vm.SearchByMulti.vals;
				title += vals.length < 4 ? vals.join('-') : vm.SearchByMulti.title;
				return title;
			default:
				throw new Error('accumList.querySlvExcelTitle, unknown SearchBy: ' + sb);
		}
	}


	/**
	 * 		MULTISELECT
	 */
	function getShareGroupInfo(sharegroup) {
		lookupRepo.ShareGroupAffList(sharegroup).then(okShareGroupLookup, errShareGroupLookup);

		function okShareGroupLookup(r) {
			var affs = r;
			var items = [];
			for (var ii = 0; ii < affs.length; ii++) {
				var aff = affs[ii];
				var newItem = {
					uniqueId: ii.toString(),
					CEID: aff.CEID,
					CeName: aff.CeName,
					RXID: aff.RXID,
					RxName: aff.RxName,
				};
				items.push(newItem);
			}
			vm.popup.Items = items;
		}

		function errShareGroupLookup(r) {
			// not worth throwing error
			// if(!!r) {
			// 	throw new Error('accumList.getShareGroupInfo, unkown api error: ' + utilSvc.http.safeResponse(r));
			// }
		}	
	}

	/**
	 * 		MULTISELECT
	 */

	function multiClick(id, val) {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		var multi = {},
			propName = '';
		switch(id) {
			case 'SearchByMulti':
				multi = vm.SearchByMulti;
				propName = 'SearchByMulti';
				break;
			case 'RxBizModelMulti':
				multi = vm.RxBizModelMulti;
				propName = 'RxBizModel';
				break;
			default:
				throw new Error('accumList.multiClick, multiselect: ' + propName);
		}

		if(validSvc.isText(val)) {
			vm.multiselectClick(multi, val);
		}
		vm.multiselectTitle(multi, true);

		var queryProp = vm.query[propName];
		queryProp.vals = vm.multiselectAllVals(multi);
		queryProp.fail = queryProp.vals.length > 0 ? 'no' : 'yes';

		if(propName == 'SearchByMulti') {
			
			// adjust biz models for queryOptions
			if(queryProp.fail == 'no') {
				var affs = getAffs(false); // keep at false, GROUP options do not use INACTIVE affs
				switch(multi.type) {
					case 'CE':
						affs = utilSvc.aff.findCeList(affs, queryProp.vals);
						break;
					case 'RX':
						affs = utilSvc.aff.findRxList(affs, queryProp.vals);
						break;
					default:
						throw new Error('accumList.multiClick, multi.type unknown: ' + multi.type);
				}
	
				// reset RxBizModels
				vm.RxBizModelMulti = rebuildRxBizModels(vm.RxBizModelMulti, affs);
				
				// Profitability is CP only
				var bizModels = utilSvc.aff.rxModelList(affs);
				vm.query.hasCP = bizModels.indexOf('CP') > -1;
			}

			// show/hide and re-validate search options
			vm.query.SearchOptions.show = queryProp.fail == 'no' ? 'yes' : 'no';
			queryChangeSearchOptions();
		}
		else if(id == 'RxBizModelMulti' && queryProp.fail == 'no') {
			// check search option if biz model chosen
			queryProp.chk = true;
		}
	}

	function multiToggle(evt, id) {
		switch(id) {
			case 'SearchByMulti':
				multiselectToggle(evt, vm.SearchByMulti, id);
				break;
			case 'RxBizModelMulti':
				multiselectToggle(evt, vm.RxBizModelMulti, id);
				break;
			default:
				throw new Error('accumList.multiToggle, unknown multi id: ' + id);
		}
	}

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if(vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		multiselect.flt = '';

		// don't bother with width if hiding
		if(multiselect.show) {
			multiselect.show = false;
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;

	}

	function multiHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}


	/**
	 *    ROW CLICK
	 *    main list click handler
	 */

	function rowClick(evt, item) {

		var act = vm.action;

		// AFFLIST row click?
		if(act == 'AFFLIST') {
			var elem = evt.target;

			// loop up to find td column parent
			while(!!elem) {

				if(!!elem.className) {
					// details column?
					if(elem.className.indexOf('indlist-details-col') > -1) {
						act += '-DETAILS';
						break;
					}
					else if(elem.className.indexOf('indlist-showhide-col') > -1) {
						act += '-SHOWHIDE';
						break;
					}
				}

				// exit if we found the <td> parent
				if(!!elem.nodeName && elem.nodeName.toUpperCase() == 'TD') {
					break;
				}

				elem = elem.parentNode;
			}
			elem = null;
		}

		switch(act) {
			case 'AFFLIST':
				getDetail(item);
				break;
			case 'AFFLIST-DETAILS':
			case 'SLV':
				openPopup(act, evt, item);
				break;
			case 'AFFLIST-SHOWHIDE':
				showHideItem(item);
				break;
			default:
				throw new Error('accumListCtl.rowClick, action unknown: ' + act);
		}

	}


	/**
	 *    GET DETAIL
	 */

	function getDetail(item, accumType) {

		if(vm.isWaiting) {
			return;
		}

		var itemId = '';
		if(vm.action == 'SLV') {
			// get id of accum type user clicked
			var idProp = 'Id' + accumType;
			itemId = item[idProp];
		}
		else {
			itemId = item.Id;
		}

		if(!!!item || !validSvc.isText(itemId)) {
			throw new Error('accumListCtl.getDetail, missing id');
		}

		// choose which CE/RX to use
		var ceid = '',
			rxid = '',
			canEdit = vm.query.isVerity || $scope.User.Type == 'CE';
		switch(vm.query.SearchType) {
			case 'AFF':
				ceid = vm.query.CE.val;
				rxid = vm.query.RX.val;
				break;
			case 'GROUP':
				ceid = item.CEID;
				rxid = item.RXID;
				// user has access to this CEID directly?
				if(canEdit) {
					var affs = utilSvc.aff.findCe(getAffs(false), item.CEID); // keep at false, GROUP options do not use INACTIVE affs
					canEdit = affs.length > 0;
				}
				break;
			default:
				throw new Error('accumListCtl.getDetail, unknown SearchType: ' + vm.query.SearchType);
		}

		$state.go('ops.accum-detail', {Id:itemId, CE: ceid, RX: rxid, ShareGroup: vm.query.ShareGroup.val, CanEdit: canEdit}, {reload: 'ops.accum-detail'});

	}


	/**
	 *    POPUP
	 */

	function openPopup(popType, evt, item, returnNav) {

		if(vm.isWaiting) {
			return;
		}

		var popWidth = '60%',
			popContentId = 'accumListPopupContent',
			offsetY = 50,
			findClickedRow = false;
					
		switch(popType) {

			case 'TBLVIEW':
				offsetY = 0;
		
				vm.popup = {
					type: popType,
					title: (vm.action == 'AFFLIST' ? 'Individual' : 'Group') + ' Table View Editor',
					Items: [],
					ready: false
				};
				$scope.$broadcast('widget.tblview.editor', {config: vm.tblViewConfig[vm.action]});
				break;

			case 'SLV':
				popWidth = '95%';
				popContentId+= 'SLV';

				// return nav automatically opens popup at last item
				if(_isReturnNav) {
					
					// exit if popup id was lost
					if(!validSvc.isText(vm.query.PopupId)) {
						_isReturnNav = false;
						return;
					}

					// find item last popped up
					var listItems = vm.tbl.Items;
					for(var i = 0; i < listItems.length; i++) {
						if(listItems[i].Id == vm.query.PopupId) {
							item = listItems[i];
							break;
						}
					}

					// exit if didn't find it (something may have happened in the back end, fail silent)
					if(!!!item) {
						_isReturnNav = false;
						return;
					}
				}
				else {
					findClickedRow = true;
				}

				// remember popup state
				vm.query.PopupId = item.Id;
				vm.query.ItemCode = item.ItemCode;
				saveViewState(vm.query, vm.flt);

				// setup popup filter
				if(_isReturnNav && !!vm.fltPop) {
					vm.fltPop = vm.resetFilters(vm.fltPop, true);
				}
				else {
					vm.fltPop = vm.initFilters({
						SortBy: ['CEID']
					});
				}
		
				vm.popup = {
					type: popType,
					ready: false,
					action: '',
					title: 'Accumulators for: ' + item.ItemCode + ' - ' + item.VenLabel,
					maxHeight: true,
					ItemCode: item.ItemCode,
					VenLabel: item.VenLabel,
					GPI: item.GPI,
					VenGenericDesc: item.VenGenericDesc,
					DataItems:[],
					Items: [] // loaded by tblView Reload
				};
				break;
			
			case 'AFFLIST-DETAILS':
				// details column was clicked
				findClickedRow = true;

				vm.query.PopupId = '';
				vm.popup = {
					type: popType,
					ready: false,
					title: item.AccumType + ' ' + item.ItemCode + ' - ' + item.VenLabel,
					maxHeight: true,
					AccumType: item.AccumType,
					ItemCode: item.ItemCode,
					VenLabel: !!item.VenLabel ? item.VenLabel : 'Description Not Found',
					DetailItems: item.Detail
				};
				break;

			case 'GRP-MEMBER':
				getShareGroupInfo(vm.query.ShareGroup.val);
				vm.popup = {
					type: popType,
					title: vm.query.ShareGroup.val + ' Share Group Members',
					ready: false,
					Items: [],
					flt: {},
					SortBy: ['CEID'],
				};
				break;
			
			default:
				throw new Error('accumList.openPopup, unknown poptype: ' + popType);
		}

		// find row clicked offset
		if(findClickedRow && !!evt) {
			offsetY = getClickedRowOffset(evt);
		}

		// move popup to clicked row
		var popup = document.getElementById(popContentId);
		if(!!popup) {
			popup.style.top = offsetY.toString() + 'px';
			popup.style.width = popWidth;
		}

		// wait for digest before showing
		$timeout(function() {
			vm.popup.ready = true;
			// SLV popup needs a data call
			if(vm.action == 'SLV' && popType != 'GRP-MEMBER') {
				getSlvAccumData();
			}
			else {
				_isReturnNav = false;
			}
		}, 200);

	}

	function getClickedRowOffset(evt) {
		var offsetY = -150;

		// loop html element parents looking for popup container top
		// note: this is a scrollable table, reduce offset by amount the table is scrolled
		var elem = evt.target,
			scrollTopFound = false;
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
				break;
			}

			// scroll container found, reduce offset if this container is scrolled
			if(!scrollTopFound && !!elem.className && elem.className.indexOf('table-fixed-header-scroll') > -1) {
				scrollTopFound = true;
				offsetY -=  Math.floor(elem.scrollTop);
			}

			// add offset, get next element
			offsetY += elem.offsetTop;
			elem = elem.offsetParent;
		}
		elem = null;

		return offsetY;
	}

	function closePopup() {
		var popType = vm.popup.type;
		vm.popup = {Items:[]};
		vm.query.PopupId = '';

		if(popType == 'TBLVIEW') {
			tblViewReload(vm.query, false, true); // re-init views, keep paging if possible
		}

		saveViewState(vm.query, vm.flt);
	}

	function getSlvAccumData() {
		// get SLV_ACCUM popup rows
		vm.isWaiting = true;
		msgSvc.wait(true);

		accumRepo.getGroupListSLV('ACCUM', vm.query).then(okGetSlvAccum, errGetSlvAccum);

		function okGetSlvAccum(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// re-use SLV VM, derives SLV sections from data
			var query = {};
			var tbl = slvVM(query, r.Items, r.TooMany);
			vm.popup.DataItems = tbl.DataItems;
			vm.popup.slvSections = query.slvSections;
			vm.fltPop.Ready = true;

			// build tblView structure into popup
			var tblType = 'SLV_ACCUM';
			vm.popup.tblView = vm.tblViewInit(vm.tblViewConfig[tblType]);
			
			// reduce tblConfig based on search results
			var tblConfig = tblViewConfigSetup($scope.User.Type, tblViewSchemaVM(tblType), query);
			tblConfig = tblConfig[tblType];

			// add column titles and filters
			vm.popup.tblView = vm.tblViewLoadTitlesAndFilters(tblConfig, vm.popup.tblView, vm.fltPop);

			vm.popup.action = 'LIST';
			vm.fltPop = vm.tblViewSyncFilter(tblConfig, vm.popup.tblView, vm.fltPop, _isReturnNav);
			
			filterChangePopup(true);
		}

		function errGetSlvAccum(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.error('Unknown get response', 'accumListCtl.errGetSlvAccum', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	/**
	 *    IMPORT FILE EVENT HOOK
	 *    used to update file list to import
	 *    note:
	 *          directive widget-input-file throws event: 'widget.input.file'
	 *          event object: {id:'id of element', files:[] array of files if browser supports HTML5 File Api}
	 */

	$scope.$on('widget.input.file', function(event, importInfo) {
		event.stopPropagation();

		if(!!importInfo && !!importInfo.files && importInfo.files.length > 0) {
			vm.importFile = importInfo.files;
		}
		else {
			vm.importFile = null;
		}

	});


	/**
	 *    SHARED IMPORT FILE
	 *    used by both tabs
	 */

	function importValidFile(newFile) {

		// required
		if(!!!newFile) {
			return 'no file selected';
		}

		// file size > 0 bytes, < 10 megabytes
		if(!validSvc.isNumber(newFile.size) || newFile.size < 1 || newFile.size > 10000000) {
			return 'file size must be 2 bytes to 10 megabytes';
		}

		// file name must be .csv
		var fName = newFile.name;
		if(!validSvc.isText(fName)) {
			return 'file has no name';
		}

		fName.trim();
		if (fName.length < 5 || (fName.substr(fName.length - 4, 4).toLowerCase() !== '.csv' && fName.substr(fName.length - 4, 4).toLowerCase() !== '.txt')) {
			return 'file name: [' + fName + '] must end with ".csv" or ".txt"';
		}

		return 'ok';

	}

	function importToggle(state) {

		if(vm.isWaiting) {
			return;
		}

		// reset state on toggle
		vm.importType = '';
		vm.importTypeDroplist = [];
		vm.importErrors = [];
		vm.importFile = null;
		vm.importVENID = validSvc.newProp('NONE');

		if(state == 'ON') {

			// TOGGLE ON

			// check upload browser support
			if(!validSvc.uploadSupported()) {
				msgSvc.ok('File Upload Not Supported', 'File Upload uses HTML5 FormData upload, your browser does not support it. Please upgrade to use file upload.');
				return;
			}

			// build import options based on user permissions

			if(vm.showImportAdjust) {
				vm.importTypeDroplist.push({label: 'Adjustment', value: 'ADJUST'});
			}

			if(vm.showImport) {
				vm.importTypeDroplist.push({label: 'Migration', value: 'MIGRATE'});
			}

			if(vm.showImportHistory) {

				var affs = utilSvc.aff.findRx(getAffs(vm.query.showInactiveAffs == 'yes'), vm.query.RX.val);
				affs = utilSvc.aff.findCe(affs, vm.query.CE.val);

				if(affs.length > 0) {
					vm.importTypeDroplist.push({label: 'Purchase History', value: 'PURCHASE'});
					vm.HistoryVenDroplist = utilSvc.ng.droplist(
						utilSvc.aff.venList(affs, ['340B','GPO','WAC','IND'], true),
						'',
						'',
						[{label:'Choose a Vendor', value: 'NONE'}]
					);
				}
			}

			// auto select import type
			if(vm.importTypeDroplist.length === 1) {
				vm.importType = vm.importTypeDroplist[0].value;
			}

			vm.action = 'IMPORT';

		}
		else {
			// TOGGLE OFF
			vm.action = '';
			querySubmit();
		}

	}

	function importSend() {

		// import CSV file

		if(vm.isWaiting) {
			return;
		}

		// upload type chosen
		var impTitle = '';
		switch(vm.importType) {

			case 'MIGRATE':
				impTitle = 'Migration';
				break;

			case 'ADJUST':
				impTitle = 'Adjustment';
				break;

			case 'PURCHASE':
				impTitle = 'Purchase History';

				// requires vendor
				vm.importVENID.fail = validSvc.isVEN(vm.importVENID.val) ? 'no' : 'yes';
				if(vm.importVENID.fail == 'yes') {
					msgSvc.ok('Cannot Import', 'Vendor Required');
					return;
				}
				break;

			default:
				msgSvc.ok('Cannot Import', 'Choose Import Type');
				return;
		}

		// 1 file selected
		if(!!!vm.importFile || vm.importFile.length !== 1) {
			msgSvc.ok(impTitle + ' Import', 'Please choose 1 file to upload.');
			return;
		}

		var fileFail = importValidFile(vm.importFile[0]);
		if(fileFail != 'ok') {
			vm.importFile = null;
			msgSvc.ok(impTitle + ' File Error', 'File error: ' + fileFail);
			return;
		}

		var confMsg = 'Import ' + impTitle + ' file for affiliation ' + vm.query.CE.val + '/' + vm.query.RX.val + '?';
		if(vm.importType == 'PURCHASE') {
			confMsg += ' WARNING: This will ERASE previously imported purchase history.';
		}
		confMsg += ' This action cannot be reversed.';

		msgSvc.confirm({
			id: 'accum.upload',
			title: impTitle + ' File Import',
			msg: confMsg,
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirmImport, userConfirmImport);

	}

	function userConfirmImport(r) {
		// user said yes
		if(!!r && r.result == 'YES') {

			vm.isWaiting = true;
			msgSvc.wait(true);

			var nt = ''; // notes not used, tbd: validSvc.isText(r.notes) ? r.notes : '';
			accumRepo.importFile(vm.importType, vm.query.CE.val, vm.query.RX.val, vm.importVENID.val, nt, vm.importFile[0]).then(okMigImport, errMigImport);
		}

		function okMigImport(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			msgSvc.okAsync('File Imported', 'Import success for affiliation ' + vm.query.CE.val + '/' + vm.query.RX.val, 'accum.import.ok').then(importToggle, importToggle);
		}

		function errMigImport(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r === null) {
				// already handled
			}
			else if(!!r && r.status === 409) {
				// conflict
				errSvc.warn('Could not Import, database conflict. Verify and try again.', 'accumListCtl.errMigImport', 409, utilSvc.http.safeResponse(r));
			}
			else if(!!r && r.status === 422) {
				// import has special error text
				vm.importErrors = r.importErrors;
				msgSvc.ok('Import Errors', 'Some line items were not imported due to errors.');
			}
			else {
				errSvc.error('Unknown Api error', 'accumListCtl.errMigImport', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}

	function importErrorsToCsv() {

		// save errors to CSV file

		var errs = vm.importErrors,
			lines = [],
			nameTxt = '',
			ruleTxt = '';

		// comma delimited
		for(var i = 0; i < errs.length; i++) {
			nameTxt = validSvc.isText(errs[i].Name) ? errs[i].Name : '';
			ruleTxt = validSvc.isText(errs[i].Rule) ? errs[i].Rule : '';

			// remove content commas so CSV will split properly
			lines.push(nameTxt.replace(/,+/g,'') + ',' + ruleTxt.replace(/,+/g,'') + '\r\n');
		}

		if(lines.length > 0) {

			try {
				var csvBlob = new Blob(lines, {type: "text/plain;charset=utf-8"});
				var dtTodayTxt = utilSvc.dt.toTextWithTime(new Date());
				dtTodayTxt = dtTodayTxt.replace(/(\/|:| )+/g,'-'); // replace slash, colon and spaces with a dash

				var rxName = utilSvc.aff.rxShortNameById($scope.User.AffList, vm.query.RX.val);
				$window.saveAs(csvBlob, utilSvc.regex.cleanFilename(rxName + '-Import-File-Errors-' + dtTodayTxt + '.csv'));
			}
			catch(err) {
				throw(err);
			}
		}

	}

	/**
	 *    RESET PURCHASE HISTORY
	 */

	function resetPurchaseHistory() {

		// drop all v340b purchase history and rebuild starting from imported historicals

		if(vm.isWaiting) {
			return;
		}

		msgSvc.confirm({
			id: 'ops.accum.resetpurchhist',
			title: 'Reset Purchase History',
			msg: 'All V340B purchase history will be dropped and rebuilt from historical imports',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirmResetPurchaseHistory, userConfirmResetPurchaseHistory);
	}

	function userConfirmResetPurchaseHistory(r) {
		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;
			msgSvc.wait(true);

			accumRepo.resetPurchaseHistory(vm.query.CE.val, vm.query.RX.val).then(okReset, errReset);
		}

		function okReset(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
		}

		function errReset(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.error('Unexpected error', 'accumCtl.showhide', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	/**
	 *    SHOW / HIDE ACCUM ITEM
	 */

	function showHideOptions() {

		// toggle the column display for hidden items

		if(vm.isWaiting) {
			return;
		}

		if(vm.query.ShowHidden == 'no') {

			msgSvc.confirm({
				id: 'ops.accum.showhide.all',
				title: 'Show Hidden Items',
				msg: 'Accumulators can be removed from search results by hiding them. A hidden item can be re-shown at any time.',
				buttons: [
					{text:'OK', result:'YES', cancel: false},
					{text:'CANCEL', result:'CANCEL', cancel: true}
				]
			}).then(userConfirmShowHideOptions, userConfirmShowHideOptions);

		}
		else {
			msgSvc.okAsync('Remove Hidden Items', 'All hidden accumulator items will not be shown in search results.', 'accum.showhide.return').then(returnToHidden, returnToHidden);
		}

	}

	function returnToHidden() {
		vm.query.ShowHidden = 'no';
		vm.flt.Text.HiddenTxt = '';
		querySubmit();
	}

	function userConfirmShowHideOptions(r) {
		if(!!r && r.result == 'YES') {
			vm.query.ShowHidden = 'yes';
			vm.flt.Text.HiddenTxt = '';
			querySubmit();
		}
	}

	function showHideItem(item) {

		if(vm.isWaiting) {
			return;
		}

		var txt = !!item.Hidden ? 'Show' : 'Hide';
		_pendingShowHide = {
			id: item.Id,
			hide: !!!item.Hidden
		};

		msgSvc.confirm({
			id: 'ops.accum.showhide',
			title: txt + ' Accumulator ',
			msg: txt + ' accumulator for NDC: ' + item.ItemCode + ', Type: ' + item.AccumType + '?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirmShowHide, userConfirmShowHide);

	}

	function userConfirmShowHide(r) {

		// user said yes
		if(!!r && r.result == 'YES') {
			accumRepo.showHideItem(_pendingShowHide.id, _pendingShowHide.hide).then(okShowHide, errShowHide);
		}

		function okShowHide(r) {

			// find item in list and flip state
			var items = vm.tbl.Items;
			for(var i = 0; i < items.length; i++) {
				if(items[i].Id == _pendingShowHide.id) {
					items[i].Hidden = _pendingShowHide.hide;
					items[i].HiddenTxt = _pendingShowHide.hide ? 'YES' : 'NO';
					break;
				}
			}

		}

		function errShowHide(r) {
			if(!!r) {
				errSvc.error('Unexpected error', 'accumCtl.showhide', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}



	/**
	 *    GLOBAL GREASE COLUMN FILTERS
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {
			// filter values are stored inside table view columns
			vm.flt = vm.tblViewGetColumnFilterValues(vm.tblView.cols, vm.flt);

			vm.tbl.DataItems = Array.isArray(vm.tbl.DataItems) ? vm.tbl.DataItems : [];
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: vm.action,
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					saveViewState(vm.query, vm.flt);
				}
			},1000);

		}, delayTime);

	}

	function filterChangePopup(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!!!vm.fltPop || !vm.fltPop.Ready) {
			return;
		}

		// mark filters dirty
		vm.fltPop.Dirty = true;

		// already working
		if(vm.fltPop.Busy) {
			return;
		}
		vm.fltPop.Busy = true;
		vm.fltPop.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {
			if(!!!vm.popup || !!!vm.fltPop) {
				return;
			}
			// filter values are stored inside table view columns
			vm.fltPop = vm.tblViewGetColumnFilterValues(vm.popup.tblView.cols, vm.fltPop);

			vm.popup.DataItems = Array.isArray(vm.popup.DataItems) ? vm.popup.DataItems : [];
			vm.popup.Items = vm.filterList(vm.popup.DataItems, vm.fltPop);
			vm.fltPop.Busy = false;

			// run again? data changed during filtering
			if(vm.fltPop.Dirty) {
				filterChangePopup(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: 'SLV_ACCUM',
				Size: vm.fltPop.PageSize,
				Page: vm.fltPop.Page,
				Total: vm.fltPop.PageTotal,
				RowCount: vm.fltPop.Count,
				ItemCount: vm.popup.Items.length,
				DataCount: vm.popup.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty && !!vm.fltPop && !vm.fltPop.Busy && !vm.fltPop.Dirty) {
					saveViewState(vm.query, vm.flt);
				}
			},1000);

		}, delayTime);

	}

	/**
	 *    TABLEVIEW
	 */

	function okCurrentTableView() {

		// update session
		if(vm.action == 'AFFLIST' || vm.action == 'SLV') {

			var tblConfig = vm.tblViewConfig[vm.action];
			var tvSaved = sessionRepo.get(tblConfig.storageKey);

			if(!!tvSaved && !!vm.tblView && validSvc.isText(vm.tblView.current)) {
				tvSaved.current = vm.tblView.current;
				sessionRepo.set(tblConfig.storageKey, tvSaved);
			}
		}
	}

	function errCurrentTableView() {
		// do nothing
	}

	function tblViewReload(query, skipInitViews, fltKeepPaging) {

		var tblType = '';
		switch(query.SearchType) {
			case 'AFF':
				tblType = 'AFFLIST';
				break;
			case 'GROUP':
				tblType = 'SLV';
				break;
			default:
				throw new Error('accumList.tblViewReload,unknown search type: ' + query.SearchType);
		}

		// init tblView with full view config
		if(!!!skipInitViews || !!!vm.tblView) {
			vm.tblView = vm.tblViewInit(vm.tblViewConfig[tblType], sessionRepo.get(vm.tblViewConfig[tblType].storageKey));
		}

		// reduce tblConfig based on search results
		var tblConfig = tblViewConfigSetup($scope.User.Type, tblViewSchemaVM(tblType), query);
		tblConfig = tblConfig[tblType];

		// add column titles and filters
		vm.tblView = vm.tblViewLoadTitlesAndFilters(tblConfig, vm.tblView, vm.flt);

		// update table and header
		vm.action = tblType;
		$scope.$broadcast('widget.tblview', {
			uniqueId: tblType,
			current: query.SearchType == 'AFF' ? vm.tblView.current : '', // slv tables have no custom views
			views: query.SearchType == 'AFF' ? vm.tblView.views : [] // slv tables have no custom views
		});

		if(!!vm.flt) {
			// remove any filter properties not shown in current table view
			vm.flt = vm.tblViewSyncFilter(tblConfig, vm.tblView, vm.flt, fltKeepPaging);
			filterChange(true);

			// show popup on return nav
			if(_isReturnNav && query.SearchType == 'GROUP') {
				$timeout(function() {
					openPopup(tblType);
				},300);
			}
		}

		// cancel return visit if not a group return
		if(query.SearchType != 'GROUP') {
			_isReturnNav = false;
		}
	}

	function tblViewReloadPopup() {
		// used only for SLV_ACCUM popup table view

		var tblType = 'SLV_ACCUM';

		// init all columns
		vm.popup.tblView = vm.tblViewInit(vm.tblViewConfig[tblType]);
		
		// reduce tblConfig based on search results
		var tblConfig = tblViewConfigSetup($scope.User.Type, tblViewSchemaVM(tblType), vm.popup);
		tblConfig = tblConfig[tblType];

		// add column titles and filters
		vm.popup.tblView = vm.tblViewLoadTitlesAndFilters(tblConfig, vm.popup.tblView, vm.fltPop);

		// update table and header
		vm.popup.action = 'LIST';

		if(!!vm.fltPop) {
			// remove any filter properties not shown in current table view
			vm.fltPop = vm.tblViewSyncFilter(tblConfig, vm.popup.tblView, vm.fltPop);
			filterChangePopup(true);
		}
	}

	function tblViewSchemaMetaData(keyName, listName) {

		var schema = {
			storageKey: keyName,
			name: listName,
			sortby: listName == 'SLV_ACCUM' ? 'CEID' : 'ItemCode',
			pgsize: 50,
			cols: []
		};

		// slv sections are dynamic
		if(listName == 'SLV' || listName == 'SLV_ACCUM') {
			// adding "_" best practice not to define obj properties starting with a number
			schema.sections = {
				Total: {title: 'Total'},
				_340B: {title: '340B'},
				_GPO: {title: 'GPO'},
				_WAC: {title: 'WAC'},
				_OWN: {title: 'OWN'},
				_IND: {title: 'IND'}
			};
			if(listName == 'SLV') {
				schema.sections.DrugInfo = {title: 'Drug Information'};
			}
			else {
				schema.sections.Aff = {title: 'Affiliation'};
			}
		}
		else {
			// AFFLIST
			schema.sections = {
				DrugInfo: {title: 'Drug Information'},
				AccumInfo: {title:  'Accumulator Info'},
				Usage: {title: 'Usage'}
			};
		}

		return schema;
	}

	function tblViewSchemaAssignColumns(listName, cols) {

		// conditionally build a column list, if listname is defined it must match
		// note: de-referencing array on purpose

		var result = [],
			col = {},
			isSLV = listName == 'SLV';

		for(var i = 0; i < cols.length; i++) {
			col = cols[i];
			
			// only exact or ALL will work for all list types
			if(col.listname == listName || col.listname == 'ALL') {
				result.push(col);
			}
			else if(!isSLV && !validSvc.isText(col.listname)) {
				// no list name specified only works for AFFLIST
				result.push(col);
			}
		}

		return result;
	}

	function tblViewSchemaAddSLV(colSchema, slvAccum) {

		// add-in dynamic sections (all must be in the schema)
		var slvSections = ['340B', 'GPO', 'WAC', 'OWN', 'IND'];
		for(var i = 0; i < slvSections.length; i++) {
			colSchema.push({section:'_' + slvSections[i],	flt:'Numbers',	name:'AccumTotal' + slvSections[i], title:'Qty', listname: 'SLV', slvSection: true, desc: slvSections[i] + ' accumulation amount in orderable units'});
			colSchema.push({section:'_' + slvSections[i],	flt:'Numbers',	name:'ItemUnits' + slvSections[i], title:'Order Units', listname: 'SLV', slvSection: true, desc: slvSections[i] + ' orderable wholesale units'});

			// add Price for SLV_ACCUM
			if(!!slvAccum) {
				colSchema.push({section:'_' + slvSections[i],	flt:'Numbers',	name:'Price' + slvSections[i], title:'Price', listname: 'SLV', slvSection: true, desc: slvSections[i] + ' Purchase Price'});
			}
		}
		// totals
		colSchema.push({section:'Total',	flt:'Numbers',	name:'TotalQty', title:'Qty', listname: 'SLV', desc:'Total accumulation amount in orderable units'});
		colSchema.push({section:'Total',	flt:'Numbers',	name:'TotalItemUnits', title:'Order Units', listname: 'SLV', desc:'Total orderable wholesale units'});		
		colSchema.push({section:'Total',	flt:'Numbers',	name:'MaxReplenishable', title:'Max Replenishable', listname: 'SLV', desc:'NDC Optimizer total neutral inventory purchase history in order units'});		

		return colSchema;
	}

	function tblViewSchemaVM(listName) {

		// column listing for original AFFLIST
		// note SLV and SLV_ACCUM are also added but are not editable

		var colSchema = [
			{section:'DrugInfo', 	flt:'Text',		edit: false, name:'ItemCode', title:'NDC', listname: 'ALL', desc:'National Drug Code'},
			{section:'DrugInfo', 	flt:'Text',		name:'VenLabel', title:'Item Description', listname: 'ALL', desc:'Vendor drug description'},
			{section:'DrugInfo', 	flt:'Text',		default: false, name:'Manufacturer', title:'Item Manufacturer', listname: 'ALL', desc:'Manufacturer of drug'},
			{section:'DrugInfo', 	flt:'Text',		name:'GPI', title:'GPI', listname: 'ALL', desc:'Generic Product Identifier'},
			{section:'DrugInfo', 	flt:'Text',		default: false, name:'VenGenericDesc', listname: 'ALL', title:'Generic Description', desc:'Vendor generic description'},
			{section:'DrugInfo',	flt:'Text',		name:'WholesaleUnits', title:'Wholesale Units', listname: 'ALL', desc:'Calculated as package size * case pack size'},
			{section:'DrugInfo',	flt:'Text',		default: false, name:'PkgDescrFull', title:'Pkg Desc', listname: 'ALL', desc:'Full Package Description'},
			{section:'DrugInfo',	flt:'Text',		default: false, name:'PackageSize', title:'Pkg Size', listname: 'ALL', desc:'Pkg Size'},
			{section:'DrugInfo',	flt:'Text',		default: false, name:'CaseSize', title:'Case Size', listname: 'ALL', desc:'Case Size'},
			{section:'DrugInfo',	flt:'Text',		default: false, name:'DosageFormFull', title:'Dose Form', listname: 'ALL', desc:'Dose Form'},
			{section:'DrugInfo',	flt:'Text',		name:'DrugType', title:'Drug Type', rxmodels: ['CP'], desc:'Brand, Generic or Assay drug types'},
			{section:'DrugInfo',	flt:'Text',		default: false, name:'DrugSchedule', title:'Drug Schedule', listname: 'ALL', desc:'Drug Schedule'},
			{section:'DrugInfo',	flt:'Numbers',	name:'Price', title:'Price', rxmodels: ['CP', 'SPLIT', 'SPLITMATCH'], utypes:['CE','VERITY','VERITYSA'], indigent: true, desc:'Purchase Price'},
			{section:'DrugInfo',	flt:'Numbers',	name:'WacPrice', title: 'WAC Price', listname: 'AFFLIST', rxmodels: ['CP', 'SPLIT', 'SPLITMATCH'], utypes:['CE','VERITY','VERITYSA'], desc:'Wholesale Price'},
			{section:'AccumInfo',	flt:'Text',		edit: false, name:'AccumType', title:'Type', desc:'Accumulator type'},
			{section:'AccumInfo',	flt:'Text',		name:'Profitable', title:'Profit', rxmodels: ['CP'], desc:'Orders placed are estimated as profitable to the CE'},
			{section:'AccumInfo',	flt:'Text',		name:'ProfitMargin', title:'Profit Margin', rxmodels: ['CP'], utypes:['CE','VERITY','VERITYSA'], desc:'Estimate profit margin value of of an orderable unit'},
			{section:'AccumInfo',	flt:'Numbers',	name:'TotalValue', title:'Total Value', rxmodels: ['CP'], utypes:['CE','VERITY','VERITYSA'], desc:'Profit Margin x Order Units'},			
			{section:'AccumInfo',	flt:'Numbers',	edit: false, name:'AccumTotalQty', title:'Total Qty', desc:'Total accumulation amount in orderable units'},
			{section:'AccumInfo',	flt:'Numbers',	name:'ItemUnits', title:'Order Units', desc:'Total orderable wholesale units'},
			{section:'AccumInfo',	flt:'Numbers',	default: false, name:'OnOrderUnits', title:'On Order', desc:'Total wholesale units in placed orders'},
			{section:'AccumInfo',	flt:'Numbers',	default: false, name:'OnHoldUnits', title:'On Hold', desc:'Total wholesale units in orders created but not placed'},
			{section:'AccumInfo',	flt:'Numbers', default: false, name:'MaxReplenishable', title:'Max Replenishable',rxmodels: ['SPLIT', 'SPLITMATCH'], desc:'NDC Optimizer total neutral inventory purchase history in order units'},
			{section:'AccumInfo',	flt:'Numbers', default: false, name:'Available', title:'Available', rxmodels: ['SPLIT', 'SPLITMATCH'],desc:'NDC Optimizer available neutral inventory purchase history in order units'},
			{section:'AccumInfo',	flt:'Numbers',	name:'SurplusUnits', title:'Surplus Units', rxmodels: ['CP'], desc:'Total orderable units placed into surplus'},
			{section:'AccumInfo',	flt:'Numbers',	name:'AvgDispSize340B', title:'Avg Disp Size', listname: 'AFFLIST', desc:'Average dispense size of all dispenses received for the NDC'},

			{section:'Usage',		flt:'Dates',	name:'First', title:'First Used', desc:'Date of first dispense'},
			{section:'Usage',		flt:'Dates',	name:'Last', title:'Last Used', desc:'Date of last dispense'},
			{section:'Usage',		flt:'Dates',	default: false, name:'OldestDispense', title:'Oldest Dispense', desc:'Fill Date of Oldest Dispense'},
			{section:'Usage',		flt:'Dates',	default: false, name:'LastOrder', title:'Last Ordered', desc:'Date of purchase'},
			{section:'Usage',		flt:'Dates',	default: false, name:'LastOrderQty', title:'Last Ordered Qty', desc:'Last Ordered Qty on the Date Of purchase'},
			{section:'Usage',		flt:'Dates',	default: false, name:'LastInvoice', title:'Last Invoiced', desc:'Date of invoice'},
			{section:'Usage',		flt:'Dates',	default: false, name:'LastInvoiceQty', title:'Last Invoiced Qty', desc:'Last Invoiced Qty Date of invoice'},
			{section:'Usage',		flt:'Text',	    default: false, name:'InGlobalBlockList', title:'Global Block List', desc:'NDC included in global block list'},
			{section:'Usage',		flt:'Text',	    default: false, name:'InCEBlockList', title:'CE Block List', desc:'NDC included in covered entity block list'},
			{section:'Usage',		flt:'Text',	    default: false, name:'VendorBlockList', title:'Vendor Block List', desc:'NDC included in affiliation block list'},
			{section:'Usage',		flt:'Text',		name:'Detail', title:'Detail', listname: 'AFFLIST', desc:'Additional information about the accumulator'},
			{section:'Usage',		flt:'Text',		edit: false, name:'Hidden', listname: 'AFFLIST', title:'Hidden', desc:'Accumulator was selected to be hidden from default view'}
		];
		var colSchemaSlvAccum = [
			{section:'Aff', 		flt:'Text',		edit: false, name:'CEID', title:'CEID', listname: 'SLV', desc:''},
			{section:'Aff', 		flt:'Text',		edit: false, name:'RxShortName', title:'Pharmacy', listname: 'SLV', desc:''},
			{section:'Aff', 		flt:'Text',		edit: false, name:'RxBizModel', title:'Model', listname: 'SLV', desc:''}
		];

		var result = {};

		// specific table requested
		if(validSvc.isText(listName)) {
			result[listName] = tblViewSchemaMetaData('tv-ops-accum-' + listName.toLowerCase(), listName);

			// assign columns
			switch(listName) {
				case 'SLV':
					result[listName].cols = tblViewSchemaAssignColumns('SLV', tblViewSchemaAddSLV(colSchema));
					break;
				case 'SLV_ACCUM':
					result[listName].cols = tblViewSchemaAssignColumns('SLV', tblViewSchemaAddSLV(colSchemaSlvAccum, true)); // use SLV designator
					break;
				case 'AFFLIST':
					result[listName].cols = tblViewSchemaAssignColumns(listName, colSchema);
					break;
				default:
					throw new Error('accumList.tblViewSchemaVM, listname unknown: ' + listName);
			}
			return result;
		}

		// return all tables
		result = {
			AFFLIST: tblViewSchemaMetaData('tv-ops-accum-indlist', 'AFFLIST'),
			SLV: tblViewSchemaMetaData('tv-ops-accum-slv_ndc', 'SLV'),
			SLV_ACCUM: tblViewSchemaMetaData('tv-ops-accum-slv_ndc', 'SLV_ACCUM')
		};
		result['AFFLIST'].cols = tblViewSchemaAssignColumns('AFFLIST', colSchema);
		result['SLV'].cols = tblViewSchemaAssignColumns('SLV', tblViewSchemaAddSLV(colSchema));
		result['SLV_ACCUM'].cols = tblViewSchemaAssignColumns('SLV', tblViewSchemaAddSLV(colSchemaSlvAccum, true)); // use SLV designator
		
		return result;
	}

	function tblViewConfigSetup(uType, tblSchema, query) {

		// convert generic view schema into user specific table configs
		// note: accum feature has three table types, hence multiple tables to iterate

		var result = {},
			cols = [],
			col = {},
			colKeys = {},
			colAllowed = [],
			queryCheck = !!query,
			rxModels = [];

		// business models found in query affiliations
		if(queryCheck) {
			if(query.hasCP) {
				rxModels.push('CP');
			}
			if(query.hasSPLIT) {
				rxModels.push('SPLIT');
			}
			if(query.hasSPLITMATCH) {
				rxModels.push('SPLITMATCH');
			}
		}

		for(var prop in tblSchema) {
			if(tblSchema.hasOwnProperty(prop)) {
				cols = tblSchema[prop].cols;
				colKeys = {};
				colAllowed = [];

				for(var i = 0; i < cols.length; i++) {
					col = cols[i];

					// user check
					if(!!col.utypes && col.utypes.indexOf(uType) < 0) {
						continue;
					}

					// dynamic query results check
					if(queryCheck) {

						// slv dynamic columns
						if(prop == 'SLV' || prop == 'SLV_ACCUM') {
							
							// skip columns in sections which have no data (loaded on query after submit)
							if(!!col.slvSection && !!!query.slvSections[col.section]) {
								continue;
							}
						}
						else {
							// rx model check
							if(Array.isArray(col.rxmodels)) {
								var foundModel = false;
								for(var ii = 0; ii < rxModels.length; ii++) {
									if(col.rxmodels.indexOf(rxModels[ii]) > -1) {
										foundModel = true;
										break;
									}
								}
								if(!foundModel) {
	
									// indigent check
									if(!!col.indigent && !!query.hasIndigent) {
										// (if column has this true, still include col even if no biz models found)
									}
									else {
										continue;
									}
								}
							}
	
							// hidden column state
							if(col.name == 'Hidden' && query.ShowHidden != 'yes') {
								continue;
							}
						}
					}

					// keep column
					colAllowed.push(col.name);
					colKeys[col.name] = col;
				}

				// update columns for this table
				tblSchema[prop].cols = colAllowed;
				tblSchema[prop].colKeys = colKeys;

				// add to result (which may have more than 1 table in config)
				result[prop] = tblSchema[prop];
			}
		}

		return result;

	}


	/**
	 *    EXCEL
	 *    get file from server
	 */

	function getExcel(slvType) {

		// already working?
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		// individual or group excel?
		var xlType = '';

		switch(vm.action) {
			case 'AFFLIST':
				var rxName = utilSvc.aff.rxShortNameById($scope.User.AffList, vm.query.RX.val);
				_pendingExcelFilename = 'Verity-' + vm.query.CE.val + '-' + rxName + '-Accumulation.xlsx';
				xlType = 'AFF';
				break;
			case 'SLV':
				xlType = slvType;
				_pendingExcelFilename = querySlvExcelTitle(vm.query);
				if(slvType == 'SLV-NDC') {
					_pendingExcelFilename += '-Accumulation.xlsx';
				}
				else {
					_pendingExcelFilename += '-' + vm.popup.ItemCode + '-Accumulation.xlsx';
				}
				break;
			default:
				throw new Error('accumListCtl.getExcel, unknown action type to generate Excel: ' + vm.action);
		}	

		accumRepo.getExcel(vm.query, xlType, _pendingExcelFilename).then(okServerExcel, errServerExcel);
	}

	function okServerExcel(binaryData) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		// convert binary stream to blob and save
		try {
			var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
			$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
		}
		catch(err) {
			throw(err);
		}

	}

	function errServerExcel(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		if(r !== null) {
			r = r || {};
			errSvc.warn('Create Excel Error', 'accumListCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
		}

	}

	function createExcel(slvType) {
		var apiQuery = accumRepo.slvQueryRequest(slvType, vm.query);
		apiQuery.Params.ReportType = 'ACCUM_SLV_DETAILS';

		vm.popup = {};
		vm.isWaiting = true;
		msgSvc.wait(true);
		reportRepo.createAsyncFile(apiQuery).then(okServerExcel, errServerExcel);

		/**
		 *    EXCEL HELPERS
		 */

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			
			msgSvc.ok('Excel File Requested', 'Check the "Saved Files" link at top right to retrieve this Excel Workbook.');
		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if (!!r) {
				errSvc.warn('Create Excel Error', 'accum.ServerExcel', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	/**
	 *    ASYNC REPORTS
	 */

	function initAsyncReports() {
		return {
			title: 'Accumulation NDC Summary Details - Saved Files',
			show: 'no'
		};
	}

	function toggleAsyncReports() {
		if(vm.isWaiting) {
			return;
		}
		vm.asyncReports.show = vm.asyncReports.show == 'yes' ? 'no' : 'yes';
		if(vm.asyncReports.show == 'yes') {
			$state.go('ops.accum.async-reports', {
				rptType: 'ACCUM_SLV_DETAILS',
				query: null
			}, {reload: 'ops.accum.async-reports'});
		}
	}

	/**
	 *    HELPERS
	 */

	function saveViewState(query, flt) {

		var hasBizModel = query.RxBizModel && query.RxBizModel.chk;

		// pack up query options array
		var queryOptions = [],
			opt = {};
		if(vm.action == 'SLV' && Array.isArray(vm.queryOptions)) {
			for(var i = 0; i < vm.queryOptions.length; i++) {
				opt = vm.queryOptions[i];
				if(opt.chk) {
					queryOptions.push(opt.name);
				}
			}
		}

		sessionRepo.set('vs-accum-list', {
			query: {
				SearchType: query.SearchType,
				SearchBy: query.SearchBy.val,
				CE: query.CE.val,
				RX: query.RX.val,
				VEN: query.VEN.val,
				ShareGroup: query.ShareGroup.val,
				ProgAdmin: query.ProgAdmin.val,
				RxRollup: query.RxRollup.val,
				SearchByMulti: query.SearchByMulti.vals,
				ShowHidden: query.ShowHidden,
				showInactiveAffs: query.showInactiveAffs,
				PopupId: query.PopupId,
				ItemCode: query.ItemCode,
				RxBizModel: hasBizModel ? query.RxBizModel.vals : [],
				QueryOptions: queryOptions
			},
			flt: flt,
			fltPop: !!vm.fltPop ? vm.fltPop : null,
			ExcludeDecimals: vm.ExcludeDecimals
		});
	}

	function updateViewState() {
		saveViewState(vm.query, vm.flt);
	}

}
 
accumRepo.$inject = ['$window', '$rootScope', '$q', 'apiService', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc'];
angular
.module('espui.ops')
.factory('accumRepo', accumRepo);


/* @ngInject */
function accumRepo($window, $rootScope, $q, apiService, errSvc, eventSvc, utilSvc, validSvc) {

	// private
	var _currentPurl = '',
		_pendingQuery = {},
		_modelPending = {};

	// service definition
	var service = {
		detailQueryVM: detailQueryVM,

		getAffList: getAffList,
		getGroupList: getGroupList,
		getGroupListSLV: getGroupListSLV, // single line view for NDC and affiliations
		getDetail: getDetail,
		getExcel: getExcel,
		getDetailExcel: getDetailExcel,

		getPurchaseList: getPurchaseList,
		getPurchaseExcel: getPurchaseExcel,
		releaseReserve:releaseReserve,

		adjustVM: adjustVM,
		adjustNdcVM: adjustNdcVM,
		adjustSave: adjustSave,

		purge: purge,
		importFile: importFile,

		resetPurchaseHistory : resetPurchaseHistory, 

		getReversalTransactions: getReversalTransactions,

		slvQueryRequest: slvQueryRequest,
		showHideItem: showHideItem,

	};

	return service;


	/**
	 *    VIEW MODELS
	 */

	function detailQueryVM(ctx) {

		var q = {
			isVerity: $rootScope.User.Type == 'VERITYSA' || $rootScope.User.Type == 'VERITY',
			CE: ctx.CE,
			RX: ctx.RX,
			Id: ctx.Id,
			DateRangeValid: false,
			DateRangeMode: 'TODAY',
			StartDate: validSvc.newPropDateNull(),
			EndDate: validSvc.newPropDateNull(),
			CanEdit: !!ctx.CanEdit,
			ShareGroup: ctx.ShareGroup,
			RxBizModel: ''
		};

		if(validSvc.isText(ctx.DateRangeMode) && validSvc.isDate(ctx.StartDate) && validSvc.isDate(ctx.EndDate)) {
			q.DateRangeValid = true;
			q.DateRangeMode = ctx.DateRangeMode;
			q.StartDate.val = new Date(ctx.StartDate);
			q.EndDate.val = new Date(ctx.EndDate);
		}

		return q;

	}

	function adjustNdcVM(data) {

		data = data || {};

		return {
			NDC: validSvc.isText(data.NDC) ? data.NDC : '',
			Description: validSvc.isText(data.Description) ? data.Description : '',
			DrugType: validSvc.isText(data.DrugType) ? data.DrugType : '',
			DrugFormCode: validSvc.isText(data.DrugFormCode) ? data.DrugFormCode : '',
			PkgSz: validSvc.isNumber(data.PkgSz) ? data.PkgSz : '',
			CaseSz: validSvc.isNumber(data.CaseSz) ? data.CaseSz : '',
			WholesaleUnits: validSvc.isNumber(data.WholesaleUnits) ? data.WholesaleUnits : ''
		};

	}

	function adjustVM(id, qty) {

		return {
			isVerity: $rootScope.User.Type == 'VERITYSA' || $rootScope.User.Type == 'VERITY',
			AccumId: id,
			CurrentQty: parseFloat(qty),
			AdjustQty: validSvc.newProp(),
			NewQty: 0,
			Note: validSvc.newProp(''),
			NdcFrom: adjustNdcVM(),
			NdcTo: adjustNdcVM(),
			NdcFail: '',
			NdcMsg: ''
		};

	}


	/**
	 *    GET LIST
	 */

	function getGroupList(query) {

		// params
		if(!validSvc.isEntity(query.ShareGroup.val)) {
			throw new Error('accumRepo.getGroupList, ShareGroup is required');
		}

		return getList('ops/accum/group/list', query);

	}

	function getAffList(query) {

		// params
		if(!validSvc.isRX(query.RX.val) || !validSvc.isCE(query.CE.val)) {
			throw new Error('accumRepo.getAffList, RX/CE are required');
		}

		return getList('ops/accum/list', query);

	}

	function getList(purl, query) {

		// shared getList by AFF and GROUP search types

		_currentPurl = purl;
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {
				GROUP: [query.ShareGroup.val],
				CEID: query.CE.val == 'NONE' ? [] : [query.CE.val],
				RXID: query.RX.val == 'NONE' ? [] : [query.RX.val],
				VENID: query.VEN.val == 'NONE' ? [] : [query.VEN.val],
			},
			Params: {
				ShowHidden: query.ShowHidden == 'yes'
			},
			Paging: {
				Page: 1,
				Size: 20000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('ItemCode')]
		};

		// save query, call api
		_pendingQuery = {
			CE: query.CE.val,
			RX: query.RX.val,
			VEN: query.VEN.val
		};
		apiService.post(_currentPurl, apiReqest).then(okGetList, errGetList);

		function okGetList(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update CE and Rx user choice
			eventSvc.rootEmit('context.change', {
				CE: _pendingQuery.CE,
				RX: _pendingQuery.RX,
				VEN: _pendingQuery.VEN
			});

			defer.resolve({
				Items: r.data.Entity,
				TooMany: r.data.Paging.Size > 20000
			});

		}

		function errGetList(r) {
			if(r !== null) {
				r = r || {status: ''};
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 * 		GET SINGLE LINE VIEW (SLV)
	 * 		keep existing GroupList call intact for now (POC mode)
	 * 		both ndc/summary and ndc/affilations use this
	 */

	function slvQueryRequest(slvType, query) {
		// SearchBy options
		var sbOptions = ['SHAREGROUP', 'PROGADMIN', 'CE', 'RX', 'RXROLLUP'],
			sb = query.SearchBy.val,
			queryOptions = query.options;
		if(!validSvc.isText(sb) || sbOptions.indexOf(sb) < 0 || !!!queryOptions) {
			throw new Error('accumRepo.slvQueryRequest, unknown SearchBy: ' + sb);
		}

		// single line view type
		if(slvType != 'NDC' && slvType != 'ACCUM' || (slvType == 'ACCUM' && !validSvc.isText(query.ItemCode))) {
			throw new Error('accumRepo.slvQueryRequest, list type must be SLV or ACCUM with valid ItemCode, ' + slvType);
		}

		var rxList = [];
		if (sb == 'RX') {
			rxList = query.SearchByMulti.vals;
		} else if (sb == 'RXROLLUP') {
			rxList = [query.RxRollup.val];
		}

		// api request
		return {
			Context: {
				CEID: sb == 'CE' ? query.SearchByMulti.vals : [],
				RXID: rxList,
				GROUP: sb == 'SHAREGROUP' ? [query.ShareGroup.val] : []
			},
			Params: {
				ItemCode: slvType == 'ACCUM' ? query.ItemCode : '',
				ProgAdmin: sb == 'PROGADMIN' ? query.ProgAdmin.val : '',
				RxBizModel: query.RxBizModel.chk ? query.RxBizModel.vals : [],
				NegativeAccum: !!queryOptions.NegativeAccum,
				MissingCatalog: !!queryOptions.MissingCatalog,
				NegativeAvail: !!queryOptions.NegativeAvail,
				Profitable: !!queryOptions.Profitable,
				AlwaysSplit: !!queryOptions.AlwaysSplit,
				NeverSplit: !!queryOptions.NeverSplit,
				GlobalBlock: !!queryOptions.GlobalBlock,
				CeBlock: !!queryOptions.CeBlock,
				VendorBlock: !!queryOptions.VendorBlock
			}
		};

	}

	function getGroupListSLV(slvType, query) {

		// add paging for list requests
		var apiRequest = slvQueryRequest(slvType, query);
		apiRequest.Paging = {
			Page: 1,
			Size: 20000
		};
		apiRequest.SortBy = [utilSvc.sorting.sortByApiStyle('ItemCode')];

		_currentPurl = slvType == 'NDC' ? 'ops/accum/ndc/summary' : 'ops/accum/ndc/affiliations';
		var defer = $q.defer();
		
		apiService.post(_currentPurl, apiRequest).then(okGetSLV, errGetSLV);

		function okGetSLV(r) {
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({
				Items: r.data.Entity,
				TooMany: r.data.Paging.Size > 20000
			});
		}

		function errGetSLV(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 *    GET DETAIL
	 */

	function getDetail(query) {

		// params
		if(!!!query || !validSvc.isText(query.Id)) {
			throw new Error('accumRepo.getDetail, id required');
		}

		_currentPurl = 'ops/accum/get';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {},
			Params: {
				Id: query.Id,
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val
			}
		};

		// call api
		apiService.post(_currentPurl, apiReqest).then(okGetDetail, errGetDetail);

		function okGetDetail(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errGetDetail(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    GET PURCHASE HISTORY
	 */

	 function getPurchaseList(query) {

		// params
		if(!!!query || !validSvc.isText(query.CE)) {
			throw new Error('accumRepo.getPurchaseHistoryList, CE required');
		}

		if(!!!query || !validSvc.isText(query.RX)) {
			throw new Error('accumRepo.getPurchaseHistoryList, RX required');
		}

		if(!!!query || !validSvc.isText(query.NDC)) {
			throw new Error('accumRepo.getPurchaseHistoryList, NDC required');
		}

		_currentPurl = 'ops/accum/purchase/list';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {
				CEID: [query.CE],
				RXID: [query.RX]
			},
			Params: {
				ItemCode: query.NDC
			}
		};

		// call api
		apiService.post(_currentPurl, apiReqest).then(okGetList, errGetList);

		function okGetList(r) {
			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({
				Items: r.data.Entity,
				TooMany: r.data.Paging.Size > 20000
			});

		}

		function errGetList(r) {
			if(r !== null) {
				r = r || {status: ''};
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	/**
	 *    ADJUSTMENT
	 */

	function adjustSave(action, model) {

		// params
		if(action != 'ADJUST' && action != 'TRANS') {
			throw new Error('accumRepo.adjustSave, action unknown: ' + action);
		}

		var adjVal = utilSvc.num.parse(model.AdjustQty.val);
		if(!validSvc.isText(model.AccumId) || !validSvc.isNumber(adjVal)) {
			throw new Error('accumRepo.adjustSave, params id and quantity required');
		}

		_currentPurl = action == 'ADJUST' ? 'ops/accum/adjust' : 'ops/accum/transfer';
		_modelPending = model;
		var defer = $q.defer();

		var apiRequest = {
			Entity: {
				Params: {
					AccumId: model.AccumId,
					Quantity: adjVal,
					Note: model.Note.val,
					TransferNDC: model.NdcTo.NDC
				}
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okAdjust, errAdjust);

		function okAdjust(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errAdjust(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
				return;
			}

			r = r || r;
			if(r.status === 409) {
				defer.reject(r);
			}
			else if(r.status === 422) {
				// map 422 errors into model
				r.model = mapAdjustErrorsToModel(r, _modelPending);
				defer.reject(r);
			}
			else {
				throw new Error('errAdjust, unexpected error result', _currentPurl, r.status, utilSvc.http.safeResponse(r));
			}

		}

		function mapAdjustErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				switch(fieldName) {
					case 'Quantity':
						m.AdjustQty.fail = 'yes';
						m.AdjustQty.msg = entity.Fields[i].Rule;
						break;
					case 'Notes':
						m.Notes.fail = 'yes';
						m.Notes.msg = entity.Fields[i].Rule;
						break;
					case 'Item Code':
						m.NdcFail = 'yes';
						m.NdcFail.msg = entity.Fields[i].Rule;
						break;
					default:
						throw new Error('accumRepo.mapAdjustErrorsToModel, unknown 422 fieldname: ' + fieldName);
				}

			}

			return m;

		}

		return defer.promise;

	}


	/**
	 *    PURGE
	 */

	function purge(ceid, rxid) {

		// params
		if(!validSvc.isCE(ceid) || !validSvc.isCE(rxid)) {
			throw new Error('accumRepo.purge, ceid and rxid are required');
		}

		_currentPurl = 'ops/purge/transactions';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid],
				RXID: [rxid]
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okPurge, errPurge);

		function okPurge(r) {
			defer.resolve({});
		}

		function errPurge(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else {
				throw new Error('accumRepo.errPurge, unexpected error result');
			}

		}

		return defer.promise;

	}


	/**
	 *    IMPORT FILE
	 */

	function importFile(impType, ceid, rxid, venid, notes, impFile) {

		// params
		if(!validSvc.isRX(rxid) || !validSvc.isCE(ceid) || !!!impFile) {
			throw new Error('accumRepo.migImport rxid and file are required for RX: ' + rxid);
		}

		// check for FormData object support
		if(!!!$window.FormData) {
			throw new Error('accumRepo.migImport, browser does not support HTML FormData object');
		}

		var defer = $q.defer();
		var fd = new FormData();

		// clean up notes text for upload (regex keeps only A-Z,a-z, 0-9 + space)
		if(validSvc.isText(notes)) {
			notes = utilSvc.regex.cleanFilename(notes);
		}

		switch(impType) {
			case 'ADJUST':
				_currentPurl = 'ops/accum/upload/adjust';
				fd.append('context', angular.toJson({CEID:ceid,RXID:rxid,notes:notes}));
				break;
			case 'MIGRATE':
				_currentPurl = 'ops/accum/upload/migration';
				fd.append('context', angular.toJson({CEID:ceid,RXID:rxid}));
				break;
			case 'PURCHASE':
				_currentPurl = 'ops/accum/upload/purchase';
				fd.append('context', angular.toJson({CEID:ceid,RXID:rxid, VENID:venid}));
				break;
		}

		// create multi-part form data
		fd.append('file', impFile);

		apiService.postFile(_currentPurl, fd, false).then(okMigImport, errMigImport);

		function okMigImport(r) {

			// bad upsert response format
			if(!!!r || !!!r.data) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});

		}

		function errMigImport(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!!!r || !validSvc.isNumber(r.status) || !!!r.data) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				r.importErrors = mapApiImportErrors(r.data.Entity);
				defer.reject(r);
			}
			else {
				errSvc.error('Unexpected error', _currentPurl, r.status, utilSvc.http.safeResponse(r));
			}

		}

		function mapApiImportErrors(entity) {

			// map server 422 fields onto import error text lines

			var importErrors = [];

			// purchase upload has different format
			if(_currentPurl == 'ops/accum/upload/purchase') {
				if(Array.isArray(entity.RecordErrors) && entity.RecordErrors.length > 0) {
					var items = entity.RecordErrors;
					for(var i = 0; i < items.length; i++){
						importErrors.push({
							Name: items[i].Line.toString(),
							Rule: items[i].Error + ', Raw Data: ' + items[i].RawData
						});
					}
				}
			}
			else {

				if(Array.isArray(entity.Fields) && entity.Fields.length > 0) {
					importErrors = entity.Fields;
				}
				else if(entity.ROOT.length > 0) {
					importErrors = [{Name: 'File Error', Rule: entity.ROOT.join(',')}];
				}
			}

			if(importErrors.length < 1) {
				throw new Error('accumRepo.422FileImport, Api returned no errors to display');
			}

			return importErrors;

		}

		return defer.promise;

	}


	/**
	 *    SHOW / HIDE ACCUMULATOR
	 */

	function showHideItem(id, hidden) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('accumRepo.showHideItem, id required');
		}

		_currentPurl = 'ops/accum/hide';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Entity: {
				Id: id,
				Hide: !!hidden
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okShowHide, errShowHide);

		function okShowHide(r) {
			defer.resolve({});
		}

		function errShowHide(r) {

			if(!!r) {
				errSvc.warn('Not able to show / hide accumulator', _currentPurl, r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);

		}

		return defer.promise;

	}
	//release accum reserve onder quantity
	function releaseReserve(id, note) {
		_currentPurl = 'ops/accum/releasereserve';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Params : {
				Id : id, 
				Note: note
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okReleaseQty, errReleaseQty);

		function okReleaseQty(r) {
			defer.resolve({});
		}

		function errReleaseQty(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else {
				throw new Error('accumRepo.okReleaseQty, unexpected error result');
			}

		}

		return defer.promise;


	}


	/**
	 *    RESET PURCHASE HISTORY
	 */

	function resetPurchaseHistory(ceid, rxid) {

		// params
		if(!validSvc.isCE(ceid) || !validSvc.isCE(rxid)) {
			throw new Error('accumRepo.resetpurchasehistory, ceid and rxid are required');
		}
		
		_currentPurl = 'ops/accum/resetpurchasehistory';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid],
				RXID: [rxid]
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okResetPurchaseHistory, errResetPurchaseHistory);

		function okResetPurchaseHistory(r) {
			defer.resolve({});
		}

		function errResetPurchaseHistory(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else {
				throw new Error('accumRepo.errResetPurchaseHistory, unexpected error result');
			}

		}

		return defer.promise;


	}


	/**
	 *    GET EXCEL
	 *    file created on api server, expecting a binary file stream instead of JSON
	 */

	function getExcel(query, accumType, filename) {

		var purl = '';
		var apiRequest = {
			Context: {
				GROUP: [query.ShareGroup.val],
				CEID: query.CE.val == 'NONE' ? [] : [query.CE.val],
				RXID: query.RX.val == 'NONE' ? [] : [query.RX.val],
				VENID: query.VEN.val == 'NONE' ? [] : [query.VEN.val]
			},
			Params: {
				Filename: filename
			}
		};

		switch (accumType) {
			case 'AFF':
				purl = 'ops/accum/excel';
				if(!validSvc.isRX(query.RX.val) || !validSvc.isCE(query.CE.val)) {
					throw new Error('accumRepo.getExcel, AFF RX/CE ids required');
				}
				break;

			case 'GROUP':
				purl = 'ops/accum/group/excel';
				if(!validSvc.isText(query.ShareGroup.val)) {
					throw new Error('accumRepo.getExcel, GROUP: ShareGroup required');
				}
				break;

			case 'SLV-NDC':
			case 'SLV-ACCUM':
				purl = accumType == 'SLV-NDC' ? 'ops/accum/ndc/summary/excel' : 'ops/accum/ndc/affiliations/excel';
				
				// use SLV query to build Excel request
				var slvType = accumType == 'SLV-NDC' ? 'NDC' : 'ACCUM';
				apiRequest = slvQueryRequest(slvType, query);
				apiRequest.Params.Filename = filename;
				break;

			default:
				throw new Error('accumRepo.getExcel, unknown excel type: ' + accumType);
		}

		return getExcelHandler(purl, apiRequest);
	}

	function getDetailExcel(query, filename) {

		// params
		if(!validSvc.isRX(query.RX) || !validSvc.isCE(query.CE) || !validSvc.isText(filename)) {
			throw new Error('accumRepo.getDetailExcel, RX/CE ids and filename are required');
		}

		return getExcelHandler('ops/accum/detail/excel', {
			Context: {
				CEID: [query.CE],
				RXID: [query.RX]
			},
			Params: {
				Id: query.Id,
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				Filename: filename
			}
		});

	}

	function getPurchaseExcel(query, itemcode, filename) {

		// params
		if(!validSvc.isRX(query.RX) || !validSvc.isCE(query.CE) || !validSvc.isText(filename)) {
			throw new Error('accumRepo.getPurchaseExcel, RX/CE ids and filename are required');
		}

		return getExcelHandler('ops/accum/purchase/excel', {
			Context: {
				CEID: [query.CE],
				RXID: [query.RX]
			},
			Params: {
				ItemCode: itemcode
			}
		});

	}

	function getExcelHandler(purl, apiRequest) {

		_currentPurl = purl;
		var defer = $q.defer();

		// call api
		apiService.postGetBinary(_currentPurl, apiRequest).then(okGetExcel, errGetExcel);

		function okGetExcel(r) {
			defer.resolve(r.data);
		}

		function errGetExcel(r) {
			if(r !== null) {
				r = r || {};
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	/**
	 *    GET REVERSAL TRANSACTIONS
	 */

	function getReversalTransactions(reversalId) {

		// params
		if(!!!reversalId || !validSvc.isText(reversalId)) {
			throw new Error('accumRepo.getReversalTransactions, id required');
		}

		_currentPurl = 'ops/accum/detail/splittrans';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Params: {
				Id: reversalId,
			}
		};

		// call api
		apiService.post(_currentPurl, apiReqest).then(okGetReversals, errGetReversals);

		function okGetReversals(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errGetReversals(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}
}
 
cashcardRepo.$inject = ['$rootScope', '$q', 'apiService', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc'];
angular
.module('espui.ops')
.factory('cashcardRepo', cashcardRepo);


/* @ngInject */
function cashcardRepo($rootScope, $q, apiService, errSvc, eventSvc, utilSvc, validSvc) {

	// private
	var _currentPurl = '',
		_pendingQuery = {},
		_modelPending = {};

	// service definition
	var service = {
		queryVM: queryVM,
		queryProp: queryProp,
		modelVM: modelVM,

		getList: getList,
		getClaims: getClaims,
		getDetail: getDetail,

		create: create,
		update: update,

		fileUpload: fileUpload,
		getExcel: getExcel

	};

	return service;


	/**
	 *    MODELS
	 */

	function queryVM() {

		return {
			CE: validSvc.newProp($rootScope.User.CE)
		};

	}

	function queryProp(propName, propVal) {

		// centralize date validation, controller uses this too
		var dtVal = null;
		var dtMinElig = new Date(1992, 10, 1, 0, 0, 0),
			dtMaxElig = utilSvc.dt.zeroTime(utilSvc.dt.addDays(new Date(), 365)); // start date can be 1 year in future

		switch(propName) {

			case 'DateOfBirth':
				var dtMinDOB = utilSvc.dt.zeroTime(utilSvc.dt.addDays(new Date(), -43800)), // 120 years old max
					dtMaxDOB = utilSvc.dt.zeroTime(new Date());

				// convert from api string format
				dtVal = utilSvc.dt.fromServerString(propVal);
				return validSvc.isDate(dtVal) ? validSvc.newPropDate(dtVal, dtMinDOB, dtMaxDOB) : validSvc.newPropDateNull(dtMinDOB, dtMaxDOB);

			case 'EligStartDate':
				return validSvc.isDate(propVal) ? validSvc.newPropDate(new Date(propVal), dtMinElig, dtMaxElig) : validSvc.newPropTodayDate();
			case 'EligEndDate':
				return validSvc.isDate(propVal) ? validSvc.newPropDate(new Date(propVal), dtMinElig, dtMaxElig) : validSvc.newPropDateNull(dtMinElig, dtMaxElig);

			case 'ClaimStartDate':
			case 'ClaimEndDate':
				return validSvc.isDate(propVal) ? validSvc.newPropDate(new Date(propVal)) : validSvc.newPropDateNull();

			default:
				return validSvc.newProp(propVal);
		}
	}

	function modelVM(data) {

		data = data || {};

		var dtDOB = queryProp('DateOfBirth', null),
			dtDOBval = utilSvc.dt.fromServerString(data.DateOfBirth);

		return {
			Id: validSvc.isText(data.Id) ? data.Id : '',
			CE: validSvc.isText(data.CE) ? data.CE : 'NONE',
			RX: validSvc.isText(data.RX) ? data.RX : 'NONE',

			MemberId: validSvc.newProp(validSvc.isText(data.MemberId) ? data.MemberId : ''),
			FirstName: validSvc.newProp(validSvc.isText(data.FirstName) ? data.FirstName : ''),
			LastName: validSvc.newProp(validSvc.isText(data.LastName) ? data.LastName : ''),
			DateOfBirth: validSvc.isDate(dtDOBval) ? validSvc.newPropDate(dtDOBval, dtDOB.min, dtDOB.max) : validSvc.newPropDateNull(dtDOB.min, dtDOB.max),
			Gender: validSvc.isText(data.Gender) ? data.Gender : '',

			BenefitsLevel: validSvc.newProp(validSvc.isInteger(data.BenefitsLevel) ? data.BenefitsLevel : 0),
			EligStartDate: queryProp('EligStartDate', data.EligStartDate),
			EligEndDate: queryProp('EligEndDate', data.EligEndDate),

			Active: !!data.Active ? 'YES' : 'NO',
			Expiring: !!data.Expiring ? 'YES' : 'NO',
			Recent: data.Recent,

			LastSentToPBM: validSvc.isDate(data.LastSentToPBM) ? data.LastSentToPBM : null,
			ModDt: validSvc.isDate(data.ModDt) ? data.ModDt : null,
			ModBy: validSvc.isText(data.ModBy) ? data.ModBy : '',

			CeExpDays: 0 // filled in by lookupCE later
		};

	}


	/**
	 *    GET
	 */

	function parseQueryParams(q) {

		// add search options
		var listParams = [],
			endDt = new Date();

		if(q.MemberId.chk) {
			listParams.push({Field: 'MemberId', DataType:'string', Value: q.MemberId.val, Op:'eqi'});
		}
		if(q.LastName.chk) {
			listParams.push({Field: 'LastName', DataType:'string', Value: q.LastName.val.toUpperCase(), Op:'eqi'});
		}
		if(q.DateOfBirth.chk) {
			endDt = utilSvc.dt.addDays(utilSvc.dt.zeroTime(new Date(q.DateOfBirth.val)), 1);
			listParams.push({Field: 'DateOfBirth', DataType:'date', Value: q.DateOfBirth.val, Op:'gte'});
			listParams.push({Field: 'DateOfBirth', DataType:'date', Value: endDt, Op:'lt'});
		}
		if(q.Active.chk) {
			listParams.push({Field: 'Active', DataType:'bool', Value: q.Active.val == 'YES', Op:'eq'});
			if(q.Active.val == 'YES' && q.Expiring.chk) {
				listParams.push({Field: 'Expiring', DataType:'bool', Value: true, Op:'eq'});
			}
		}

		return listParams;

	}

	function buildMembersApiRequest(query) {
		return {
			Context: {
				CEID: [query.CE.val]
			},
			Params: parseQueryParams(query),
			Paging: {
				Page: 1,
				Size: 20000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('LastName')]
		};
	}

	function getList(query) {

		// params
		if(!validSvc.isCE(query.CE.val)) {
			throw new Error('cashcardRepo.getList, CE id is required');
		}

		var defer = $q.defer();
		_currentPurl = 'ops/cashcard/member/list';

		var apiRequest = buildMembersApiRequest(query);

		_pendingQuery = {
			CE: query.CE.val
		};

		apiService.post(_currentPurl, apiRequest).then(okGetList, errGetList);

		function okGetList(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update CE and Rx user choice
			eventSvc.rootEmit('context.change', {
				CE: _pendingQuery.CE
			});

			defer.resolve({
				Items: r.data.Entity,
				TooMany: r.data.Entity.length > 20000
			});

		}

		function errGetList(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function buildClaimsApiRequest(query) {

		var stat = [];
		if(query.StatusChk) {
			if(query.StatusMATCHED) {
				stat.push('MATCHED');
			}
			if(query.StatusUNMATCHED) {
				stat.push('UNMATCHED');
			}
			if(query.StatusREVERSED) {
				stat.push('REVERSED');
			}
		}

		return {
			Context: {
				CEID: [query.CE.val],
				RXID: query.RX.val == 'ALL' ? [] : [query.RX.val]
			},
			Params: {
				Status: stat,
				ClaimDateStart: query.ClaimStartDate.val,
				ClaimDateEnd: query.ClaimEndDate.val
			},
			Paging: {
				Page: 1,
				Size: 20000
			}
		};

	}

	function getClaims(query) {

		// params
		if(!validSvc.isCE(query.CE.val)) {
			throw new Error('cashcardRepo.getClaims, CE id is required');
		}

		var defer = $q.defer();
		_currentPurl = 'ops/cashcard/claims/list';

		var apiRequest = buildClaimsApiRequest(query);

		_pendingQuery = {
			CE: query.CE.val
		};

		apiService.post(_currentPurl, apiRequest).then(okGetClaims, errGetClaims);

		function okGetClaims(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update CE and Rx user choice
			eventSvc.rootEmit('context.change', {
				CE: _pendingQuery.CE
			});

			defer.resolve({
				Items: r.data.Entity,
				TooMany: r.data.Entity.length > 20000
			});

		}

		function errGetClaims(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function getDetail(id) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('cashcardRepo.getDetail, id is required');
		}

		_currentPurl = 'ops/cashcard/member/get';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Entity: {
				Params: {
					Id: id
				}
			}
		};

		// call api
		apiService.post(_currentPurl, apiReqest).then(okGetDetail, errGetDetail);

		function okGetDetail(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(modelVM(r.data.Entity));

		}

		function errGetDetail(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    CREATE / UPDATE
	 */

	function create(model) {
		return upsert('ops/cashcard/member/create', model);
	}

	function update(model) {
		return upsert('ops/cashcard/member/update', model);
	}

	function upsert(purl, model) {

		_currentPurl = purl;
		_modelPending = model;
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [model.CE]
			},
			Entity: {
				Id: model.Id,
				MemberId: model.MemberId.val,
				FirstName: model.FirstName.val,
				LastName: model.LastName.val,
				DateOfBirth: utilSvc.dt.toServerString(model.DateOfBirth.val),
				Gender: model.Gender,

				EligStartDate: model.EligStartDate.val,
				EligEndDate: model.EligEndDate.val,
				BenefitsLevel: parseInt(model.BenefitsLevel.val)
			}
		};

		apiService.post(_currentPurl, apiRequest).then(upsertOk, upsertErr);

		function upsertOk(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function upsertErr(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapApiErrorsToModel(r, _modelPending);
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);
				if(fieldObj === undefined) {
					throw new Error('cashcardRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
				}

				// set failed state
				fieldObj.fail = 'yes';
				fieldObj.msg = entity.Fields[i].Rule;

			}

			return m;

		}


		return defer.promise;
	}


	/**
	 *    FILE UPLOAD
	 */

	function fileUpload(ceid, importFile) {

		// params
		if(!validSvc.isCE(ceid) || !!!importFile) {
			throw new Error('cashcardRepo.fileUpload, required: CE and import file.');
		}

		_currentPurl = 'ops/cashcard/member/import';
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [ceid]
			}
		};

		// create multi-part form data
		var fd = new FormData();
		fd.append('context', angular.toJson(apiRequest)); // stringify JSON into one "context" property
		fd.append('file', importFile);

		apiService.postFile(_currentPurl, fd, false).then(okFileImport, errFileImport);

		function okFileImport(r) {

			// bad upsert response format
			if(!!!r || !!!r.data || !!!r.data.Entity) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			var ent = r.data.Entity;

			// has errors? 200 return may have errors
			if(Array.isArray(ent.RecordErrors) && ent.RecordErrors.length > 0) {
				r.status = 422;
				errFileImport(r);
			}
			else {
				defer.resolve({
					status: 200,
					counts: mapApiFileProcessCounts(ent),
					importErrors: []
				});
			}

		}

		function errFileImport(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!!!r || !validSvc.isNumber(r.status) || !!!r.data) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status === 422) {
				defer.reject({
					status: 422,
					counts: mapApiFileProcessCounts(r.data.Entity),
					importErrors: mapApiImportErrors(r.data.Entity)
				});
			}
			else {
				errSvc.error('Unexpected error', _currentPurl + 'cashcardRepo.errFileImport', r.status, utilSvc.http.safeResponse(r));
			}

		}

		function mapApiFileProcessCounts(ent) {
			return {
				Processed: ent.ProcessedCount,
				Received: ent.ReceivedCount,
				Error: ent.ErrorCount,
				Duplicate: ent.DuplicateCount
			};
		}

		function mapApiImportErrors(entity) {

			// map server 422 fields onto import error text lines

			if(Array.isArray(entity.RecordErrors) && entity.RecordErrors.length > 0) {
				return entity.RecordErrors;
			}
			else if(entity.ROOT.length > 0) {
				return [{Name: 'File Error', Rule: entity.ROOT.join(',')}];
			}
			else {
				throw new Error('cashcardRepo.422FileImport, Api returned no errors to display');
			}
		}

		return defer.promise;

	}


	/**
	 * 	EXCEL
	 */

	function getExcel(tabName, query, filename) {

		// params
		if(!validSvc.isCE(query.CE.val) || !validSvc.isText(filename)) {
			throw new Error('cashcardRepo.getExcel, ceid and filename are required');
		}

		var apiRequest = {};
		switch(tabName) {
			case 'MEMBERS':
				_currentPurl = 'ops/cashcard/member/excel';
				apiRequest = buildMembersApiRequest(query);
				break;

			case 'CLAIMS':
				_currentPurl = 'ops/cashcard/claims/excel';
				apiRequest = buildClaimsApiRequest(query);
				break;

			default:
				throw new Error('cashcardRepo.getExcel, unknown tab: ' + tabName);
		}

		var defer = $q.defer();

		// call api
		apiService.postGetBinary(_currentPurl, apiRequest).then(okGetExcel, errGetExcel);

		function okGetExcel(r) {
			defer.resolve(r.data);
		}

		function errGetExcel(r) {
			if(r !== null) {
				r = r || {};
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


}
 
cashCardMemberEditCtl.$inject = ['$scope', '$state', '$timeout', 'cashcardRepo', 'lookupRepo', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc'];
angular
.module('espui.ops')
.controller('CashCardMemberEditCtl', cashCardMemberEditCtl);


/* @ngInject */
function cashCardMemberEditCtl($scope, $state, $timeout, cashcardRepo, lookupRepo, validSvc, errSvc, utilSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _datePickListener = null;

	// properties
	vm.isWaiting = false;
	vm.action = '';
	vm.canEdit = false;

	// inherit
	msgSvc.addHelpLink(vm);

	// droplists
	vm.BenefitLevelDroplist = [];

	vm.model = {};

	// methods
	vm.save = save;

	// date pick
	vm.dtPickShow = {};
	vm.dtPickOpen = dtPickOpen;


	/**
	 *    DATE PICKER
	 *    EVENT HOOK, DESTROY AND TOGGLE
	 */

	_datePickListener = $scope.$on('widget.input.date.pick.change', function(event, evtData) {
		event.stopPropagation();

		// params
		if(!evtData || !validSvc.isText(evtData.uniqueId)) {
			alert('memberListCtl.datePickEvt, evtData and uniqueId required');
			return;
		}
		var id = evtData.uniqueId;

		if(id!= 'DateOfBirth' && id != 'EligStartDate' && id != 'EligEndDate') {
			alert('memberListCtl.datePickEvt, uniqueId unknown: ' + id);
			return;
		}

		vm.dtPickShow[id] = false;
		vm.model[id].val = evtData.setDate;

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_datePickListener) {
			_datePickListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		// edit rights
		vm.canEdit = utilSvc.user.hasFeature($scope, 'ops.cashcard.member.edit');

		// date picker
		vm.dtPickShow = {
			pending: '',
			DateOfBirth: false,
			EligStartDate: false,
			EligEndDate: false
		};

		// params
		if(!!!$state.params || !validSvc.isCE($state.params.CE)) {
			throw new Error('memberEditCtl.init, CE param is missing');
		}

		switch($state.current.name) {

			case 'ops.cashcard-member-create':
				vm.action = 'CREATE';
				vm.model = cashcardRepo.modelVM();
				vm.model.CE = $state.params.CE;
				lookupCE(vm.model.CE);
				break;

			case 'ops.cashcard-member-edit':
				vm.action = 'UPDATE';
				getDetail($state.params.Id);
				break;

			default:
				throw new Error('cashCardMemberEditCtl.Init, state unknown: ' + $state.current.name);
		}

	}


	/**
	 *    GET DETAIL
	 */

	function getDetail(id) {

		// valid param
		if(!validSvc.isText(id)) {
			throw new Error('cashCardMemberEditCtl.getDetail, id is missing');
		}

		cashcardRepo.getDetail(id).then(okGetDetail, errGetDetail);

		function okGetDetail(r) {
			vm.model = r;
			if (vm.model.Recent===true) {
				vm.canEdit=true;
			}else{
				vm.canEdit=false;
			}
			lookupCE(vm.model.CE);
		}

		function errGetDetail(r) {
			if(!!r) {
				errSvc.warn('Vendor Id not found', 'cashCardMemberEditCtl.getDetail.err', r.status, utilSvc.http.safeResponse(r));
				$state.go('ops.cashcard-member');
			}
		}

	}

	function lookupCE(ceid) {
		// ASYNC: get benefit levels for this CE
		$timeout(function() {
			lookupRepo.CeInfo([ceid]).then(okLookupCe, errLookupCe);
		}, 500);
	}

	function okLookupCe(items) {

		if(!Array.isArray(items) || items.length !== 1 || !!!items[0].CashCard) {
			alert('memberEditCtl.LookupCE, lookup did not find CE: ' + vm.model.CE);
			return;
		}
		var cc = items[0].CashCard;
		var levels = cc.BenefitLevels;
		if(!Array.isArray(levels)) {
			return;
		}

		// expiration days
		if(validSvc.isInteger(cc.MembershipExpirationDays)) {
			vm.model.CeExpDays = cc.MembershipExpirationDays;
		}

		// benefit levels droplist
		vm.BenefitLevelDroplist = [];
		for(var i = 0; i < levels.length; i++) {
			vm.BenefitLevelDroplist.push({label:levels[i].Description, value:levels[i].Level});
		}

	}

	function errLookupCe(r) {
		if(!!r) {
			errSvc.warn('Error looking up ce display properties', 'memberEditCtl.lookupCeBenefits', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    CHANGE EVENTS
	 */

	function dtPickOpen(dtName) {

		if(dtName != 'DateOfBirth' && dtName != 'EligStartDate' && dtName != 'EligEndDate') {
			alert('memberListCtl.dtPickOpen, date pick name unknown: ' + dtName);
			return;
		}
		var dt = vm.model[dtName];
		vm.dtPickShow.pending = dtName;

		$scope.$broadcast('widget.input.date.pick', {
			uniqueId: dtName,
			setDate: dt.val,
			minDate: dt.min,
			maxDate: dt.max
		});

		$timeout(function(){
			if(validSvc.isText(vm.dtPickShow.pending)) {
				vm.dtPickShow[vm.dtPickShow.pending] = true;
			}
		},100);
	}


	/**
	 *    SUBMIT: ACCOUNT
	 */

	function validAccount() {

		var m = vm.model;

		// MemberId, FirstName, LastName - required
		m.MemberId = validText(m.MemberId, 2, 50);
		m.FirstName = validText(m.FirstName, 2, 50);
		m.LastName = validText(m.LastName, 2, 50);

		// DOB, required
		var dtDOB = validSvc.propDateValid(m.DateOfBirth);
		m.DateOfBirth.fail = !!dtDOB.fail ? 'yes' : 'no';
		m.DateOfBirth.msg = !!dtDOB.fail ? dtDOB.msg : '';

		// elig start date, required
		var dtStart = validSvc.propDateValid(m.EligStartDate);
		m.EligStartDate.fail = !!dtStart.fail ? 'yes' : 'no';
		m.EligStartDate.msg = !!dtStart.fail ? dtStart.msg : '';

		// elig end date, required
		var dtEnd = validSvc.propDateValid(m.EligEndDate);
		m.EligEndDate.fail = !!dtEnd.fail ? 'yes' : 'no';
		m.EligEndDate.msg = !!dtEnd.fail ? dtEnd.msg : '';

		// end after start
		if(m.EligStartDate.fail == 'no' && m.EligEndDate.fail == 'no' && utilSvc.dt.diffMilli(m.EligStartDate.val, m.EligEndDate.val) <= 0) {
			m.EligEndDate.fail = 'yes';
			m.EligEndDate.msg = 'must be after start date';
		}

		// benifit level, required
		if(!validSvc.isInteger(m.BenefitsLevel.val)) {
			m.BenefitsLevel.fail = 'yes';
			m.BenefitsLevel.msg = 'required';
		}

		// result
		return m.MemberId.fail != 'yes' &&
			m.FirstName.fail != 'yes' &&
			m.LastName.fail != 'yes' &&
			m.DateOfBirth.fail != 'yes' &&
			m.Gender.fail != 'yes' &&
			m.EligStartDate.fail != 'yes' &&
			m.EligEndDate.fail != 'yes' &&
			m.BenefitsLevel.fail != 'yes';

	}

	function save() {

		if(vm.isWaiting || !vm.canEdit) {
			return;
		}

		// validate
		if(!validAccount()) {
			msgSvc.ok('Cannot Save', 'All fields must be valid.');
			return;
		}
		vm.isWaiting = true;

		// create or update
		if(vm.action == 'CREATE') {
			cashcardRepo.create(vm.model).then(okUpsert, errUpsert);
		}
		else {
			cashcardRepo.update(vm.model).then(okUpsert, errUpsert);
		}

	}

	function okUpsert(r) {

		vm.isWaiting = false;

		// after CREATE, route to edit view
		if(vm.action == 'CREATE') {
			vm.model.Id = r.Id;
			msgSvc.okAsync('Member Created','','ops.cashcard.member.create').then(navToEdit, navToEdit);
		}
		else {
			msgSvc.okAsync('Member Saved','','ops.cashcard.member.save').then(reloadDetail, reloadDetail);
		}

	}

	function navToEdit() {
		$state.go('ops.cashcard-member-edit', {CE: vm.model.CE, Id: vm.model.Id}, {reload: 'ops.cashcard-member-edit'});
	}

	function reloadDetail() {
		//getDetail(vm.model.Id);
	}

	function errUpsert(r) {

		vm.isWaiting = false;

		if(!!!r || r === null) {
			// already handled
			$state.go('ops.cashcard-member', {}, {reload: 'ops.cashcard-member'});
		}
		else if(r.status === 409) {
			// conflict
			msgSvc.ok('Cannot Save', 'Could not create or save, already exists in the database. Verify and try again (409).');
		}
		else if (r.status === 422) {
			// validation
			vm.model = r.model;
		}
		else {
			errSvc.error('Unexpected api error', 'cashCardMemberEditCtl.errUpsert', r.status, utilSvc.http.safeResponse(r));
		}

	}


	/**
	 *    HELPERS
	 */

	function validText(prop, min, max) {

		// required
		if(!validSvc.isText(prop.val)) {
			prop.fail = 'yes';
			prop.msg = 'required';
			return prop;
		}

		// min
		if(prop.val.length < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum ' + min.toString() + ' characters';
			return prop;
		}

		// max
		if(prop.val.length > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum ' + max.toString() + ' characters';
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;

	}

}
 
cashCardMemberListCtl.$inject = ['$window', '$state', '$scope', '$timeout', 'cashcardRepo', 'lookupRepo', 'sessionRepo', 'msgSvc', 'utilSvc', 'validSvc', 'errSvc'];
angular
.module('espui.ops')
.controller('CashCardMemberListCtl', cashCardMemberListCtl);


/* @ngInject */
function cashCardMemberListCtl($window, $state, $scope, $timeout, cashcardRepo, lookupRepo, sessionRepo, msgSvc, utilSvc, validSvc, errSvc) {

	/*jshint validthis: true */
	var vm = this,
		_featureName = '',
		_pagingEventListener = null,
		_datePickListener = null,
		_returnVisit = false,
		_benefitLevelMap = null,
		_fileImportListener = null,
		_pendingExcelFilename = '',
		_affs = [],
		_tabFilters = {},
		_claimTabInit = false;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addFlexTop(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.canEdit = false;
	vm.hasFullProps = false;
	vm.showClaimTab = false;

	// droplists
	vm.CeDroplist = [];
	vm.RxDroplist = [];
	vm.BenefitLevelDroplist = [];

	// query
	vm.query = {};
	vm.queryChange = queryChange;
	vm.queryChangeCE = queryChangeCE;
	vm.dateRangeChange = dateRangeChange;
	vm.querySubmit = querySubmit;

	// table, filters
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;

	// flex top
	vm.flex = {};
	vm.flexTopExpand = flexTopExpand;
	vm.flexTopClaimTitle = flexTopClaimTitle;

	// date pick
	vm.dtPickShow = {};
	vm.dtPickOpen = dtPickOpen;

	// edit
	vm.create = create;
	vm.getDetail = getDetail;
	vm.getExcel = getExcel;

	// import file
	vm.canImport = false;
	vm.importFiles = [];
	vm.importErrors = [];
	vm.importCounts = {};
	vm.importToggle = importToggle;
	vm.importFile = importFile;

	// tabs
	vm.activeTab = '';
	vm.tabChange = tabChange;


	/**
	 *    IMPORT FILE EVENT HOOK
	 *    used to update file list to import
	 *    note:
	 *          directive widget-input-file throws event: 'widget.input.file'
	 *          event object: {id:'id of element', files:[] array of files if browser supports HTML5 File Api}
	 */

	function listenForFileImport() {

		if(!!!_fileImportListener) {

			_fileImportListener = $scope.$on('widget.input.file', function(event, importInfo) {
				event.stopPropagation();

				if(!!importInfo && !!importInfo.files && importInfo.files.length > 0) {
					vm.importFiles = importInfo.files;
				}
				else {
					vm.importFiles = [];
				}

			});
		}

	}


	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});

	/**
	 *    DATE PICKER
	 *    EVENT HOOK, DESTROY AND TOGGLE
	 */

	_datePickListener = $scope.$on('widget.input.date.pick.change', function(event, evtData) {
		event.stopPropagation();

		// params
		if(!evtData || !validSvc.isText(evtData.uniqueId)) {
			alert('memberListCtl.datePickEvt, evtData and uniqueId required');
			return;
		}
		var id = evtData.uniqueId;

		if(id!= 'DateOfBirth') {
			alert('memberListCtl.datePickEvt, uniqueId unknown: ' + id);
			return;
		}

		vm.dtPickShow[id] = false;
		vm.query[id].val = evtData.setDate;

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
		if(!!_datePickListener) {
			_datePickListener();
		}
		if(!!_fileImportListener) {
			_fileImportListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		_featureName = $state.current.name;

		// user specific claims
		vm.hasFullProps = $scope.User.Type == 'VERITYSA' || $scope.User.Type == 'VERITY' || $scope.User.Type == 'CE';
		vm.canEdit = utilSvc.user.hasFeature($scope, 'ops.cashcard.member.edit');
		vm.showClaimTab = utilSvc.user.hasFeature($scope, 'ops.cashcard.claims');

		vm.init = true;
		vm.flex = vm.flexInit();

		_affs = initCashCardAffs($scope.User.AffList);
		vm.activeTab = initQueryAndFilters();
		tabChange(vm.activeTab);

		vm.init = false;

	}

	function initCashCardAffs(affList) {

		// create affs with care card
		var result = [],
			affs = utilSvc.aff.findStatus(affList),
			aff = {};

		for(var i = 0; i < affs.length; i++) {
			aff = affs[i];
			if(!!aff.CECashCard) {
				result.push({
					CEID: aff.CEID,
					RXID: aff.RXID,
					RxShortName: aff.RxShortName
				});
			}
		}

		return result;

	}

	function initTabFilters() {
		return {
			MEMBERS: vm.initFilters({
				Exact: {
					BenefitsLevel: ''
				},
				Config: {
					Dates: ['DateOfBirth', 'EligStartDate', 'EligEndDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['MemberId']
			}),
			CLAIMS: vm.initFilters({
				Exact: {},
				Config: {
					Dates: ['ServiceDate','RxWrittenDate'],
					DateFmt: 'M/d/yyyy'
				},
				HideSection: {
					Tot: false,
					Cost: false,
					Pat: true
				},
				SortBy: ['ServiceDate']
			})
		};
	}

	function initQueryAndFilters() {

		var tabResult = 'MEMBERS'; // default tab

		// get date min/max from repo
		var DOBProp = cashcardRepo.queryProp('DateOfBirth'),
			ClaimProp = cashcardRepo.queryProp('ClaimStartDate'); // start and end have same min/max

		// init query, setup CE
		vm.query = cashcardRepo.queryVM();
		vm.CeDroplist = utilSvc.aff.ceDroplist(_affs);
		vm.query.CE = utilSvc.ng.droplistAutoselect(vm.CeDroplist, vm.query.CE.val);
		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';
		vm.BenefitLevelDroplist = utilSvc.ng.droplistALL();

		vm.query.RX = validSvc.newProp('ALL');
		vm.RxDroplist = utilSvc.ng.droplistALL();

		// default claim date
		vm.query.ClaimDateRangeMode = 'MTD';
		vm.query.ClaimStartDate = validSvc.newPropDateNull(ClaimProp.min, ClaimProp.max);
		vm.query.ClaimEndDate = validSvc.newPropDateNull(ClaimProp.min, ClaimProp.max);
		vm.query.ClaimDateValid = false;

		// claim date max 30 days
		vm.query.ClaimDateRangeList = utilSvc.widget.dateRangeList(['QTD','QTR','QTDLAST','CUSTOM92']);
		vm.query.ClaimDateRangeList.push({label: 'Custom Date Range (30 day max)', value: 'CUSTOM30'});

		// add status options
		vm.query.StatusChk = false;
		vm.query.StatusMATCHED = false;
		vm.query.StatusUNMATCHED = false;
		vm.query.StatusREVERSED = false;

		// viewstate
		var vs = sessionRepo.get('vs-ops-cashcardmember', {CE:vm.query.CE.val}),
			vsq = null;
		if(!!vs) {
			_returnVisit = true;
			tabResult = vs.activeTab;
			_tabFilters = vs.flt;

			vsq = vs.query;
			if(validSvc.isRX(vsq.RX)) {
				vm.query.RX = validSvc.newProp(vsq);
			}

			if(validSvc.isText(vsq.ClaimDateRangeMode)) {
				vm.query.ClaimDateRangeMode = vsq.ClaimDateRangeMode;
				vm.query.ClaimStartDate = validSvc.newPropDate(new Date(vsq.ClaimStartDate), ClaimProp.min, ClaimProp.max);
				vm.query.ClaimEndDate = validSvc.newPropDate(new Date(vsq.ClaimEndDate), ClaimProp.min, ClaimProp.max);
				vm.query.ClaimDateValid = true;
			}

			if(!!vsq.StatusChk) {
				vm.query.StatusChk = true;
				vm.query.StatusMATCHED = !!vsq.StatusMATCHED;
				vm.query.StatusUNMATCHED = !!vsq.StatusUNMATCHED;
				vm.query.StatusREVERSED = !!vsq.StatusREVERSED;
			}
		}
		else {
			_tabFilters = initTabFilters();
		}

		// add search options to query (using viewstate if available)
		vm.query = addSearchOptions(vm.query, vsq, [
			{name:'MemberId', type: 'newProp', val:''},
			{name:'LastName', type: 'newProp', val:''},
			{name:'DateOfBirth', type: 'newPropDate', min:DOBProp.min, max:DOBProp.max, val:null},
			{name:'BenefitsLevel', type: 'newProp', val:''},
			{name:'Active', type: 'newProp', val:''},
			{name:'Expiring', type: 'newProp', val:''}
		]);

		return tabResult;

	}

	function addSearchOptions(q, vsq, props) {

		// add optional search criteria, use viewstate if available

		var addProp = {},
			propName = '',
			propNameChk = '',
			useVs = !!vsq,
			hasVsProp = false;

		for(var i = 0; i < props.length; i++) {
			addProp = props[i];
			propName = addProp.name;

			propNameChk = propName + 'Chk';
			hasVsProp = useVs && !!vsq[propName] && !!vsq[propNameChk];

			switch(addProp.type) {

				case 'newProp':
					q[propName] = validSvc.newProp(hasVsProp ? vsq[propName] : addProp.val);
					break;

				case 'newPropDate':
					if((hasVsProp && validSvc.isDate(vsq[propName])) || validSvc.isDate(addProp.val)) {
						q[propName] = validSvc.newPropDate(hasVsProp ? vsq[propName] : addProp.val, addProp.min, addProp.max);
					}
					else {
						q[propName] = validSvc.newPropDateNull(addProp.min, addProp.max);
					}
					break;

				default:
					alert('memberList.addSearchOptions, unknown viewstate prop type: ' + addProp.type);
			}
			q[propName].chk = hasVsProp;

		}

		return q;
	}


	/**
	 *    VIEW MODELS
	 */

	function membersVM(dataItems, tooMany) {

		dataItems = Array.isArray(dataItems) ? dataItems : [];

		var item = {},
			lvlNumber = '',
			regexApiDateFmt = utilSvc.regex.apiDateStringFmt();

		// add uniqueId
		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.uniqueId = 'm' + i.toString();

			item.DateOfBirth = utilSvc.dt.fromServerString(item.DateOfBirth, regexApiDateFmt);

			item.EligStartDate = validSvc.isDate(item.EligStartDate) ? item.EligStartDate : null;
			item.EligEndDate = validSvc.isDate(item.EligEndDate) ? item.EligEndDate : null;
			item.LastSentToPBM = validSvc.isDate(item.LastSentToPBM) ? item.LastSentToPBM : null;

			if(validSvc.isNumber(item.BenefitsLevel)) {
				// add desc to level
				lvlNumber = item.BenefitsLevel.toString();
				if(validSvc.isText(_benefitLevelMap[lvlNumber])) {
					item.BenefitsLevel = lvlNumber;
					item.BenefitsLevelTxt = lvlNumber + ': ' + _benefitLevelMap[lvlNumber];
				}
			}

			item.Active = !!item.Active ? 'YES' : 'NO';
			item.Expiring = !!item.Expiring ? 'YES' : 'NO';
		}

		return {
			DataItems: dataItems,
			Items: [], // loaded by filterChange()
			TooMany: !!tooMany
		};

	}

	function claimsVM(dataItems, tooMany) {

		dataItems = Array.isArray(dataItems) ? dataItems : [];

		var item = {};

		// add uniqueId
		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.uniqueId = 'c' + i.toString();

			item.Matched = !!item.Matched ? 'YES' : 'NO';
		}

		return {
			DataItems: dataItems,
			Items: [], // loaded by filterChange()
			TooMany: !!tooMany
		};

	}


	/**
	 * 	CE BENEFIT LOOKUP
	 */

	function okLookupCe(items) {

		// reset droplist
		vm.BenefitLevelDroplist = utilSvc.ng.droplistALL();
		_benefitLevelMap = {};

		// CE has levels
		var levels = [];
		if(Array.isArray(items) && !!items[0].CashCard && Array.isArray(items[0].CashCard.BenefitLevels)) {
			levels = items[0].CashCard.BenefitLevels;
		}
		if(levels.length > 0) {
			var lvlNumber = '';
			for(var i = 0; i < levels.length; i++) {
				lvlNumber = levels[i].Level.toString();
				_benefitLevelMap[lvlNumber] = levels[i].Description;
				vm.BenefitLevelDroplist.push({label:lvlNumber + ': ' + levels[i].Description, value:lvlNumber});
			}
		}

		// vm.flt level still valid
		var benLevel = vm.flt.Exact.BenefitsLevel;
		if(validSvc.isText(benLevel) && levels.indexOf(benLevel) < 0) {
			vm.flt.Exact.BenefitsLevel = '';
		}

		// finish query submit
		cashcardRepo.getList(vm.query).then(okQuerySubmit, errQuerySubmit);

	}

	function errLookupCe(r) {
		if(!!r) {
			errSvc.warn('Error looking up ce display properties', 'memberListCtl.lookupCeBenefits', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    TAB AND QUERY CHANGE EVENTS
	 */

	function queryChange() {
		if(!vm.init) {
			vm.action = '';
			vm.tbl = {};
			vm.flt = vm.resetFilters(vm.flt);
			vm.flex = vm.flexInit();

			vm.importFiles = [];
			vm.importErrors = [];
			vm.importCounts = {};

			$scope.$broadcast('widget.paging');
		}
	}

	function tabChange(newTab) {

		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.activeTab = newTab;
		vm.flt = vm.resetFilters(_tabFilters[newTab]);

		// init CLAIMS tab before finishing tab load
		if(newTab == 'CLAIMS' && !_claimTabInit) {
			$timeout(function() {
				$scope.$broadcast('widget.input.date.range.mode', {uniqueId:'CLAIMS', mode: vm.query.ClaimDateRangeMode, keepDates: vm.query.ClaimDateValid});
			},200);
			return;
		}

		queryChangeCE(true);
		if(_returnVisit) {
			querySubmit();
		}
		else {
			// re-validate query on tab change
			queryValid(newTab, vm.query);
		}

	}

	function queryChangeCE(keepBenefitLevels) {
		queryChange();

		var q = vm.query;
		q.CE.fail = validSvc.isCE(q.CE.val) ? 'no' : 'yes';

		// reset CE benefit levels
		if(q.CE.fail == 'yes' || (q.CE.fail == 'no' && !!!keepBenefitLevels)) {
			_benefitLevelMap = null;
			// note: do not reset benefit droplist or the table filter will be lost on a return visit
		}

		// CLAIMS tab: RX Droplist
		if(vm.activeTab == 'CLAIMS') {
			if(q.CE.fail == 'no') {
				vm.RxDroplist = utilSvc.aff.rxDroplist(_affs, q.CE.val, false, true);
				q.RX = utilSvc.ng.droplistAutoselect(vm.RxDroplist, q.RX.val);
				q.RX.fail = validSvc.isRX(q.RX.val, false, true) ? 'no' : 'yes';
				if(q.RX.fail == 'yes') {
					q.RX = validSvc.newProp('ALL');
				}
			}
			else {
				q.RX = validSvc.newProp('ALL');
				vm.RxDroplist = utilSvc.ng.droplistALL;
			}
		}

	}

	function dateRangeChange(dtMode, isValid) {

		if(vm.init || vm.activeTab != 'CLAIMS') {
			return;
		}

		vm.query.ClaimDateRangeMode = dtMode;
		vm.query.ClaimDateValid = isValid;

		if(_claimTabInit) {
			queryChange();
		}
		else {
			// init is done, return to tabChange
			_claimTabInit = true;
			tabChange(vm.activeTab);
		}

	}

	function flexTopExpand() {

		// user opened search query, reset list display, show search expanded
		queryChange();

	}

	function flexTopClaimTitle() {

		var ceid = vm.query.CE.val,
			rxid = vm.query.RX.val;

		if(!validSvc.isCE(ceid) || !validSvc.isRX(rxid, false, true)) {
			return '';
		}

		if(rxid == 'ALL') {
			return ceid + ' / All Pharmacies';
		}
		else {
			return ceid + ' / ' + utilSvc.ng.droplistLabel(vm.RxDroplist, vm.query.RX.val);
		}
	}

	function dtPickOpen(dtName) {

		if(dtName != 'DateOfBirth') {
			alert('memberListCtl.dtPickOpen, date pick name unknown: ' + dtName);
			return;
		}
		var dt = vm.query[dtName];
		vm.dtPickShow.pending = dtName;

		$scope.$broadcast('widget.input.date.pick', {
			uniqueId: dtName,
			setDate: dt.val,
			minDate: dt.min,
			maxDate: dt.max
		});

		$timeout(function(){
			if(validSvc.isText(vm.dtPickShow.pending)) {
				vm.dtPickShow[vm.dtPickShow.pending] = true;
			}
		},100);
	}

	function queryValid(tab, q) {

		// validate query data before calling api

		// reset fail state for both tabs
		q.MemberId.fail = '';
		q.LastName.fail = '';
		q.DateOfBirth.fail = '';
		q.Active.fail = '';
		q.Expiring.fail = '';
		var claimDateOk = true;

		// search options
		q.SearchOptionsRequired = validSvc.newProp();

		switch(tab) {

			case 'MEMBERS':

				// Member Id
				if(q.MemberId.chk) {
					q.MemberId = validText(q.MemberId, 2, 50);
				}

				// Last Name
				if(q.LastName.chk) {
					q.LastName = validText(q.LastName, 2, 50);
				}

				// DOB
				if(q.DateOfBirth.chk) {
					var dtCheck = validSvc.propDateValid(q.DateOfBirth);
					q.DateOfBirth.fail = dtCheck.fail ? 'yes' : 'no';
					q.DateOfBirth.msg = dtCheck.msg;
				}

				if(vm.hasFullProps) {

					// Active
					if(q.Active.chk) {
						q.Active.fail = validSvc.isText(q.Active.val) ? 'no' : 'yes';
						q.Active.msg = q.Active.fail == 'yes' ? 'choose yes or no' : '';
					}

					if(!q.Active.chk || q.Active.val != 'YES') {
						// turn off Expiring based on Active state
						q.Expiring.chk = false;
					}

					// at least one option must be selected
					if(!q.MemberId.chk && !q.LastName.chk && !q.DateOfBirth.chk && !q.Active.chk) {
						q.SearchOptionsRequired.fail = 'yes';
						q.SearchOptionsRequired.msg = 'Choose at least one search option';
					}

				}
				else {

					// member id or last name + DateOfBirth required
					if(!q.MemberId.chk || (q.MemberId.chk && q.MemberId.fail == 'yes')) {
						if(!q.LastName.chk || q.LastName.fail == 'yes' || !q.DateOfBirth.chk || q.DateOfBirth.fail == 'yes') {
							q.SearchOptionsRequired.fail = 'yes';
							q.SearchOptionsRequired.msg = 'Choose either Member Id or both Last Name and Date of Birth';
						}
					}
				}
				break;

			case 'CLAIMS':

				claimDateOk = q.ClaimDateValid;

				// ignore status if no options chosen
				if(q.StatusChk && !q.StatusMATCHED && !q.StatusUNMATCHED && !q.StatusREVERSED) {
					q.StatusChk = false;
				}

				break;

			default:
				alert('memberListCtl.queryValid, unknown tab: ' + tab);
		}

		return q.CE.fail != 'yes' &&
			q.MemberId.fail != 'yes' &&
			q.LastName.fail != 'yes' &&
			q.DateOfBirth.fail != 'yes' &&
			q.Active.fail != 'yes' &&
			claimDateOk &&
			q.SearchOptionsRequired.fail != 'yes';

	}

	function querySubmit() {

		// query valid
		if(!queryValid(vm.activeTab, vm.query)) {
			if(!vm.init && !_returnVisit) {
				msgSvc.ok('Search', 'Check filter properties');
			}
			queryChange();
			_returnVisit = false;
			return;
		}
		_returnVisit = false;

		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true);
		queryChange();

		switch(vm.activeTab) {

			case 'MEMBERS':
				// get CE benefit levels before submit
				if(!!!_benefitLevelMap) {
					lookupRepo.CeInfo([vm.query.CE.val]).then(okLookupCe, errLookupCe);
				}
				else {
					cashcardRepo.getList(vm.query).then(okQuerySubmit, errQuerySubmit);
				}
				break;

			case 'CLAIMS':
				cashcardRepo.getClaims(vm.query).then(okQuerySubmit, errQuerySubmit);
				break;

			default:
				alert('memberListCtl.querySubmit, unknown tab: ' + vm.activeTab);
		}
	}

	function okQuerySubmit(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		saveViewState(vm.query, vm.flt);

		// force top collapse after good query
		vm.flex = vm.flexCollapse(vm.flex, true);

		// load data
		vm.tbl = vm.activeTab == 'MEMBERS' ? membersVM(r.Items, r.TooMany) : claimsVM(r.Items, r.TooMany);
		vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);

		// update paging ui
		$scope.$broadcast('widget.paging', {
			uniqueId: vm.activeTab,
			Size: vm.flt.PageSize,
			Page: vm.flt.Page,
			Total: vm.flt.PageTotal,
			RowCount: vm.flt.Count,
			ItemCount: vm.tbl.Items.length,
			DataCount: vm.tbl.DataItems.length
		});

		vm.action = 'LIST';
		vm.flt.Ready = true;

	}

	function errQuerySubmit(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		if(!!r) {
			errSvc.warn('Unknown get response', 'cashCardMemberListCtl.errQuerySubmit', r.status, utilSvc.http.safeResponse(r));
		}

	}


	/**
	 *    GLOBAL GREASE COLUMN FILTERS
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: vm.activeTab,
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					//console.log('filter change save viewstate');
					saveViewState(vm.query, vm.flt);
				}
			},1000);

		}, delayTime);

	}


	/**
	 *    CREATE AND EDIT
	 */

	function create() {

		if(vm.isWaiting || !vm.canEdit) {
			return;
		}

		$state.go('ops.cashcard-member-create', {CE:vm.query.CE.val}, {reload: 'ops.cashcard-member-create'});
	}

	function getDetail(id) {

		if(vm.isWaiting) {
			return;
		}

		$state.go('ops.cashcard-member-edit', {Id: id, CE:vm.query.CE.val}, {reload: 'ops.cashcard-member-edit'});

	}


	/**
	 *    FILE IMPORT
	 */

	function importToggle() {

		if(vm.isWaiting) {
			return;
		}

		if(vm.action == 'IMPORT') {
			// toggle off, back to list
			querySubmit();
			return;
		}
		else {
			// toggle on, reset view

			vm.tbl = {};
			vm.flt = vm.resetFilters(vm.flt);

			vm.importFiles = [];
			vm.importErrors = [];
			vm.importCounts = {};

			if(!validSvc.uploadSupported()) {
				msgSvc.ok('File Upload Not Supported', 'File Upload uses HTML5 FormData upload, your browser does not support it. Please upgrade to use file upload.');
				querySubmit();
				return;
			}

			vm.action = 'IMPORT';
			listenForFileImport();
		}

	}

	function importValidFile(newFile) {

		// required
		if(!!!newFile) {
			return 'no file selected';
		}

		// file size > 0 bytes, < 10 megabytes
		if(!validSvc.isNumber(newFile.size) || newFile.size < 1 || newFile.size > 10000000) {
			return 'file size must be 2 bytes to 10 megabytes';
		}

		// file name must be .csv
		var fName = newFile.name;
		if(!validSvc.isText(fName) || fName.length < 5 || (fName.substr(fName.length - 4, 4).toLowerCase() !== '.csv' && fName.substr(fName.length - 4, 4).toLowerCase() !== '.txt')) {
			return 'file name must end with extension ".csv" or ".txt"';
		}

		return 'ok';

	}

	function importValid() {

		// files selected
		if(!!!vm.importFiles || vm.importFiles.length !== 1) {
			msgSvc.ok('File Import', 'Please choose 1 file to upload.');
			return false;
		}

		// validate file
		var fileFail = importValidFile(vm.importFiles[0]);
		if(fileFail != 'ok') {
			msgSvc.ok('File Import', 'Selected file error: ' + fileFail);
			return false;
		}

		return true;

	}

	function importFile() {

		if(vm.isWaiting) {
			return;
		}

		if(!importValid()) {
			return;
		}

		msgSvc.confirm({
			id: 'ops.cashcard.import',
			title: 'Upload Care Card Members File',
			msg: 'New members will be added, existing members are skipped.',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmFileImport, confirmFileImport);

	}

	function confirmFileImport(r) {

		// user cancelled
		if(!!!r || r.result != 'YES') {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);
		vm.importErrors = [];
		vm.importCounts = {};

		cashcardRepo.fileUpload(vm.query.CE.val, vm.importFiles[0]).then(okFileImport, errFileImport);

		function okFileImport(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(r.counts.Processed > 0) {
				msgSvc.ok('File Import Success', 'Total ' + r.counts.Processed + ' members imported, ' + r.counts.Duplicate + ' duplicate members found.');
			}
			else {
				msgSvc.ok('File Import Complete', 'No members added, ' + r.counts.Duplicate + ' duplicate members found.');
			}

			// toggle off
			importToggle();
		}

		function errFileImport(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(r === null) {
				return;
			}
			else if (r.status === 422) {
				vm.importErrors = r.importErrors;
				vm.importCounts = r.counts;
				if(r.counts.Processed > 0) {
					msgSvc.ok('File Import With Errors', r.counts.Processed + ' imported, ' + r.importErrors.length + ' errors');
				}
				else {
					msgSvc.ok('File Import Failed', 'No line items were imported, there are: ' + r.importErrors.length + ' line item errors');
				}
			}
			else {
				errSvc.error('Unexpected api error', 'memberListCtl.errFileImport', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    EXCEL
	 *    get file from server
	 */

	function getExcel() {

		// already working?
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		switch(vm.activeTab) {
			case 'MEMBERS':
				_pendingExcelFilename = 'Verity-' + vm.query.CE.val + '-CareCard-Members.xlsx';
				break;

			case 'CLAIMS':
				var rxName = vm.query.RX.val == 'ALL' ? 'AllPharmacies' : utilSvc.aff.rxShortNameById(_affs, vm.query.RX.val);
				_pendingExcelFilename = 'Verity-' + vm.query.CE.val + '-' + rxName + '-CareCard-Claims.xlsx';
				break;

			default:
				throw new Error('membersListCtl.getExcel, unknown tab: ' + vm.activeTab);
		}

		cashcardRepo.getExcel(vm.activeTab, vm.query, _pendingExcelFilename).then(okServerExcel, errServerExcel);

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r !== null) {
				errSvc.warn('Create Excel Error', 'claimsListCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    HELPERS
	 */

	function validText(prop, min, max) {

		// required
		if(!validSvc.isText(prop.val)) {
			prop.fail = 'yes';
			prop.msg = 'required';
			return prop;
		}

		// min
		if(prop.val.length < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum ' + min.toString() + ' characters';
			return prop;
		}

		// max
		if(prop.val.length > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum ' + max.toString() + ' characters';
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;

	}

	function saveViewState(query, flt) {

		_tabFilters[vm.activeTab] = flt;

		// search options
		var searchOptions = [
			{name:'MemberId', type: 'newProp'},
			{name:'LastName', type: 'newProp'},
			{name:'DateOfBirth', type: 'newPropDate'},
			{name:'BenefitsLevel', type: 'newProp'},
			{name:'Active', type: 'newProp'},
			{name:'Expiring', type: 'newProp'}
		];

		var vs = {
			ctx: {
				CE: query.CE.val,
				RX: query.RX.val
			},
			activeTab: vm.activeTab,
			query: packSearchOptionsForViewState(query, searchOptions),
			flt: _tabFilters
		};

		// add claim status
		if(query.StatusChk) {
			vs.query.StatusChk = true;
			vs.query.StatusMATCHED = !!query.StatusMATCHED;
			vs.query.StatusUNMATCHED = !!query.StatusUNMATCHED;
			vs.query.StatusREVERSED = !!query.StatusREVERSED;
		}

		// add claim date if valid
		if(query.ClaimDateValid) {
			vs.query.ClaimDateRangeMode = query.ClaimDateRangeMode;
			vs.query.ClaimStartDate = query.ClaimStartDate.val;
			vs.query.ClaimEndDate = query.ClaimEndDate.val;
		}

		sessionRepo.set('vs-ops-cashcardmember', vs);

	}

	function packSearchOptionsForViewState(q, props) {

		// convert query options into viewstate properties

		var result = {},
			propName = '',
			propNameChk = '';

		for(var i = 0; i < props.length; i++) {
			propName = props[i].name;
			propNameChk = propName + 'Chk';

			if(!!q[propName].chk) {

				switch(props[i].type) {
					case 'prop':
						result[propName] = q[propName];
						break;
					case 'newProp':
					case 'newPropDate':
						result[propName] = q[propName].val;
						break;
					default:
						alert('memberList.packSearchOptionsForViewState, unknown query prop type: ' + props[i].type);
				}
				result[propNameChk] = true;
			}
		}

		return result;
	}


}
 
catalogsListCtl.$inject = ['$window', '$state', '$scope', '$timeout', 'reportRepo', 'catalogsRepo', 'lookupRepo', 'msgSvc', 'utilSvc', 'validSvc', 'errSvc'];
angular
.module('espui.ops')
.controller('CatalogsListCtl', catalogsListCtl);


/* @ngInject */
function catalogsListCtl($window, $state, $scope, $timeout, reportRepo, catalogsRepo, lookupRepo, msgSvc, utilSvc, validSvc, errSvc) {

	/*jshint validthis: true */
	var vm = this,
		_mouseLeaveDelay = {},
		_verisaveonly = false,
		_rollupInfo = {};

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addMultiselect(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.viewState = {};

	// catalog search
	vm.fltRefSearch = {};
	vm.query = {};
	vm.VenEditDroplist = [];
	vm.refSearch = refSearch;

	// models
	vm.display = {};
	vm.model = {};

	// filters
	vm.filterExactChange = filterExactChange;

	// tabs
	vm.activeTab = '';
	vm.tabChange = tabChange;

	// edit a list item, redirects to either Create or Update
	vm.listItemEdit = listItemEdit;
	vm.assayItemEdit = assayItemEdit;
	vm.specialtyItemEdit = specialtyItemEdit;
	vm.ManufacturersDropList = [];

	// override model Create/Update
	vm.ovrCreate = ovrCreate;
	vm.ovrUpdate = ovrUpdate;
	vm.editCancel = editCancel;
	vm.editSave = editSave;
	vm.exportNdcExcel = exportNdcExcel;
	vm.createAffAsyncExcel = createAffAsyncExcel;

	// no EDI
	var _noEdiLoaded = false,
		_primaryEdiProp = 'CE',
		_fileImportListener = null,
		_noEdiAffs = [];

	// no EDI search
	vm.noEdiQuery = {};
	vm.primaryDroplist = [];
	vm.secondaryDroplist = [];
	vm.VenDroplist = [];
	vm.AccumGrpDroplist = [];
	vm.queryChangePrimary = queryChangePrimary;
	vm.queryChangeSecondary = queryChangeSecondary;
	vm.queryChangeVendor = queryChangeVendor;
	vm.queryChangeManu = queryChangeManu;
	vm.queryChangeAccounts = queryChangeAccounts;

	vm.noEdiQuerySwap = noEdiQuerySwap;
	vm.noEdiSearch = noEdiSearch;
	vm.multiselectFocus = multiselectFocus;

	// no EDI display
	vm.displayNoEdi = {};
	vm.noEdiViewState = {
		SortBy: ['ItemCode'],
		FilterTxt: {},
		FilterDates: {}
	};

	// no EDI import
	vm.noEdiImportFiles = [];
	vm.noEdiImportErrors = [];
	vm.noEdiImportCounts = {};
	vm.noEdiImportToggle = noEdiImportToggle;
	vm.noEdiImportFile = noEdiImportFile;

	// no EDI catalog clone
	vm.catClone = {};
	vm.toggleCatClone = toggleCatClone;
	vm.catCloneChange = catCloneChange;
	vm.catCloneSubmit = catCloneSubmit;

	// aff search
	var _affSearchLoaded = false,
		_affPrimaryProp = 'CE',
		_affSearchAffs = [];

	// aff search query
	vm.affQuery = {};
	vm.affPrimaryDroplist = [];
	vm.affSecondaryDroplist = [];
	vm.affVenDroplist = [];
	vm.affQueryChangePrimary = affQueryChangePrimary;
	vm.affQueryChangeSecondary = affQueryChangeSecondary;
	vm.affQueryChangeVendor = affQueryChangeVendor;
	vm.affQuerySwap = affQuerySwap;
	vm.affQueryChangePharmacyOnly = affQueryChangePharmacyOnly;
	vm.affQueryToggleShowPharmacyOnly = affQueryToggleShowPharmacyOnly;
	vm.affSearch = affSearch;

	vm.manufacturers = [];
	vm.accts = [];
	vm.ManuMultiSelect=[];
	vm.popup = {};

	// aff search display
	vm.affDisplay = {Items:[]};
	vm.affViewState = {
		SortBy: ['ItemCode'],
		FilterTxt: {},
		FilterDates: {}
	};

	// clear catalog
	vm.catClear = {};
	vm.toggleCatClear = toggleCatClear;
	vm.catClearChange = catClearChange;
	vm.catClearSubmit = catClearSubmit;
	vm.closePopup = closePopup;

	// multiselect
	vm.multiselectAccToggle = multiselectAccToggle;
	vm.multiselectManuToggle = multiselectManuToggle;
	vm.multiselectMouseHover = multiselectMouseHover;

	// async reports
	vm.asyncReports = {};
	vm.toggleAsyncReports = toggleAsyncReports;

	/**
	 *    IMPORT FILE EVENT HOOK
	 *    used to update file list to import
	 *    note:
	 *          directive widget-input-file throws event: 'widget.input.file'
	 *          event object: {id:'id of element', files:[] array of files if browser supports HTML5 File Api}
	 */

	function listenForFileImport() {

		if(!!!_fileImportListener) {

			_fileImportListener = $scope.$on('widget.input.file', function(event, importInfo) {
				event.stopPropagation();

				if(!!importInfo && !!importInfo.files && importInfo.files.length > 0) {
					vm.noEdiImportFiles = importInfo.files;
				}
				else {
					vm.noEdiImportFiles = [];
				}

			});
		}

	}

	$scope.$on('$destroy', function() {
		if(!!_fileImportListener) {
			_fileImportListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		vm.init = true;
		_verisaveonly = $scope.User.VeriSaveOnly;
		
		initStateAndDroplists($scope.User.Type);
		tabChange(vm.viewState.activeTab);
		vm.init = false;

		// ASYNC
		$timeout(initMfg, 2000);
	}
	
	function initStateAndDroplists(uType) {

		vm.viewState = {
			isVeritySA: uType == 'VERITYSA',
			isVerity: uType == 'VERITY' || uType == 'VERITYSA',
			isUserCEorRX: uType == 'CE' || uType == 'RX',
			isUserRX: uType == 'RX',
			NDC: '',
			Desc: '',
			FilterTxt: {},
			FilterExact: {
				Status: 'ALL'
			},
			SortBy: ['NDC']
		};
		vm.viewState.activeTab = vm.viewState.isUserCEorRX ? 'AFFSEARCH' : 'OVERRIDE';

		// reference search query
		vm.query = {
			SearchType: 'NDC',
			NDC: validSvc.newProp(''),
			GPI: validSvc.newProp(''),
			Desc: validSvc.newProp(''),
			Manufacturer:validSvc.newProp(''),
		};
		vm.fltRefSearch = {
			FilterTxt: {},
			SortBy: ['NDC']
		};

		vm.VenEditDroplist = []; // loaded on edit click
				
		var accts = ['ALL','340B','IND','GPO','OWN','WAC'];
		if (!!_verisaveonly) {
			accts = ['ALL','GPO','OWN','WAC'];
		}
		vm.AccountMultiSelect = {
			type : '',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			vals :[],
			titleNoOptions: 'Choose Account',
			list: vm.multiselectBuild(accts, false),
			flt: ''
		};
		vm.multiselectTitle(vm.AccountMultiSelect, true);

		vm.ManuMultiSelect = {
			type : '',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'Choose a Manufacturer',
			vals :[],
			titleNoOptions: 'Choose a Manufacturer',
			list: [], // loaded asyc
			flt: ''
		};
	}
	
	function initMfg() {
		toggleWait(true);
		catalogsRepo.manufacturers().then(okMfg, errMfg);
		
		function okMfg(r) {
			toggleWait();

			var items= Array.isArray(r.Items) ? r.Items : [],
				labelId = '';
			for(var i=0; i < items.length; i++) {
				labelId = items[i].LabelerId;
				vm.ManuMultiSelect.list.push({
					checked: false,
					lbl: items[i].Name +  " ["+ labelId + "]",
					val: labelId
				});
			 }
		}

		function errMfg(r) {
			toggleWait();
			if(!!r) {
				errSvc.warn('Cannot get Mfg from database', 'catalogsList.errMfg', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function loadVendorDroplist() {
		// already loaded
		if(vm.isWaiting || vm.VenEditDroplist.length > 0) {
			return;
		}
		toggleWait(true);

		lookupRepo.VendorList().then(okVendors, errVendors);
		
		function okVendors(r) {
			toggleWait();

			var vendors = [],
				ven = {};

			// only display ACTIVE, WHOLESALER, EDI
			for(var i = 0; i < r.length; i++) {
				ven = r[i];
				if(!!ven.SupportsEDI && ven.Status == 'ACTIVE' && ven.Type == 'WHOLESALER') {
					vendors.push(ven);
				}
			}
			vendors = utilSvc.array.sortASC(vendors, 'Name');
			vm.VenEditDroplist = utilSvc.ng.droplist(vendors, 'Name', 'Id', [{label:'Choose a Vendor', value:'NONE'}]);
		}

		function errVendors(r) {
			toggleWait();
			if(!!r) {
				errSvc.warn('Cannot load Vendors from database', 'catalogsList.errVendors', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function multiselectAccToggle(evt, id) {
		multiselectToggle(evt, vm.AccountMultiSelect, id);
	}

	function multiselectManuToggle(evt, id) {
		multiselectToggle(evt, vm.ManuMultiSelect, id);
	}

	function multiselectToggle(evt, multiselect, id) {
		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if(vm.isWaiting) {
			return;
		}

		// don't bother with width if hiding
		if(multiselect.show) {
			multiselect.show = false;
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;
	}

	function queryChangeManu(val) {
		if(!vm.init) {
			vm.popup = {};
			vm.action = '';
			vm.tbl = {};
		}
		vm.multiselectClick(vm.ManuMultiSelect, val);
		vm.multiselectTitle(vm.ManuMultiSelect, true);
		vm.manufacturers = vm.ManuMultiSelect.vals;
	}

	function queryChangeAccounts(val) {
		if(!vm.init) {
			vm.popup = {};
			vm.action = '';
			vm.tbl = {};
		}
		vm.multiselectClick(vm.AccountMultiSelect, val);
		vm.multiselectTitle(vm.AccountMultiSelect, true);
		vm.accts = multiselectQueryVals(vm.AccountMultiSelect);
	}
	
	function multiselectFocus(multiselect, focusOn) {

		// change filter focus between "Options" checkboxes or "Find..." textbox

		multiselect.focus = focusOn;

		// reset ng-repeat filter for find text
		if(focusOn == 'FIND') {
			multiselect.txtVal = validSvc.isText(multiselect.txtEdit) ? multiselect.txtEdit : '';
		}
		else {
			multiselect.txtVal = '';
		}
		// reset Option checkboxes to ALL
		vm.multiselectTitle(multiselect);
	}

	function getAffs(nonEdiVendors) {

		var affs = utilSvc.aff.findStatus($scope.User.AffList);
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
		affs = utilSvc.aff.findWithVendor(affs, !!nonEdiVendors);

		return JSON.parse(JSON.stringify(affs)); // always de-ref off main affs scope
	}

	function noEdiGetAffs() {

		// cache affs on tab loading
		if(!_noEdiLoaded && _noEdiAffs.length > 0) {
			return _noEdiAffs;
		}
		_noEdiAffs = [];

		var result = [],
			foundNoEdi = false,
			affs = getAffs(true);

		// remove EDI vendors
		for(var i = 0; i < affs.length; i++) {
			foundNoEdi = false;
			for(var ii = affs[i].Ordering.length - 1; ii >= 0; ii--) {
				if(!!affs[i].Ordering[ii].SupportsEDI) {
					affs[i].Ordering.splice(ii, 1);
				}
				else {
					foundNoEdi = true;
				}
			}

			// this is a non-EDI vendor, add to results
			if(foundNoEdi) {
				result.push(affs[i]);
			}
		}

		// cache on tab loading
		if(!_noEdiLoaded) {
			_noEdiAffs = result;
		}

		return result;

	}

	function initNoEdi() {

		// setup query primary / secondary
		vm.secondaryDroplist = utilSvc.ng.droplistNONE();
		vm.VenDroplist = utilSvc.ng.droplistNONE();
		vm.AccumGrpDroplist = utilSvc.ng.droplistNONE();


		// get primary entries
		var affs = noEdiGetAffs();
		if(_primaryEdiProp == 'CE') {
			vm.primaryDroplist = utilSvc.aff.ceDroplist(affs);
		}
		else {
			vm.primaryDroplist = utilSvc.aff.rxDroplist(affs);
		}

		vm.noEdiQuery = {
			primary: utilSvc.ng.droplistAutoselect(vm.primaryDroplist, $scope.User[_primaryEdiProp]),
			primaryLabel: _primaryEdiProp == 'CE' ? 'Facility' : 'Pharmacy',
			secondary: _primaryEdiProp == 'CE' ? validSvc.newProp($scope.User.RX) : validSvc.newProp($scope.User.CE),
			secondaryLabel: _primaryEdiProp == 'CE' ? 'Pharmacy' : 'Facility',
			Vendor: validSvc.newProp('NONE'),
			AccumGrp: validSvc.newProp('NONE')
		};

		queryChangePrimary();

	}

	function exportNdcExcel() {
		// already working?
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true);
		vm.query.Manufacturer= vm.manufacturers;

			// send api request
		catalogsRepo.exportExcel(vm.query).then(okServerExcel, errServerExcel);

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename("Drug Reference Export.xlsx"));
			}
			catch(err) {
				throw(err);
			}
		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r !== null) {
				errSvc.warn('Create Excel Error', 'claimsListCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}
	}

	function affSearchAffs() {

		// cache affs on tab loading
		if(!_affSearchLoaded && _affSearchAffs.length > 0) {
			return _affSearchAffs;
		}
		_affSearchAffs = [];

		var affs = utilSvc.aff.findStatus($scope.User.AffList);
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
		affs = utilSvc.aff.findWithVendor(affs, true);

		// fyi... this has NEVER worked, the API has stopped sending back ROLLUP aff records if an aff has an RxParent
		// solution is to add ROLLUP types off RxParent property on affiliations
		if (!!vm.affQuery.showPharmacyOnly) {
			// get rollups to add in
			_rollupInfo = {};
			var addRollups = [],
				parentId = '',
				rollInfo = {};
			affs.forEach(function(aff) {
				// aff has Rollup Parent
				if(validSvc.isText(aff.RxParent)) {
					parentId = aff.RxParent;

					// new parent found
					if(!!!_rollupInfo[parentId]) {
						// create a proper ROLLUP aff record
						addRollups.push({
							RXID: parentId,
							RxShortName: parentId, 
							RxType: 'ROLLUP'
						});
						_rollupInfo[parentId] = {
							rxids: [aff.RXID]
						};
					}
					
					// create a list of all RXIDS which belong to this parent
					rollInfo = _rollupInfo[parentId];
					if(rollInfo.rxids.indexOf(aff.RXID) < 0) {
						rollInfo.rxids.push(aff.RXID);
					}
				}
			});
			
			if(addRollups.length > 0) {
				affs = affs.concat(addRollups);
			}
		}

		// cache on tab loading
		if(!_affSearchLoaded) {
			_affSearchAffs = affs;
		}

		return affs;

	}

	function initAffSearch() {

		vm.affViewState = {
			ItemCode: '',
			Desc: '',
			VenItemNum: '',
			FilterTxt: {},
			SortBy: ['ItemCode']
		};

		// setup query primary / secondary

		vm.affSecondaryDroplist = utilSvc.ng.droplistNONE();
		vm.affVenDroplist = utilSvc.ng.droplistALL();

		// get primary entries
		var affs = affSearchAffs();
		if(_affPrimaryProp == 'CE') {
			vm.affPrimaryDroplist = utilSvc.aff.ceDroplist(affs);
		}
		else {
			vm.affPrimaryDroplist = utilSvc.aff.rxDroplist(affs);
		}

		var celbl = !!_verisaveonly ? 'Entity' : 'Facility';

		vm.affQuery = {
			primary: utilSvc.ng.droplistAutoselect(vm.affPrimaryDroplist, $scope.User[_affPrimaryProp]),
			primaryLabel: _affPrimaryProp == 'CE' ? celbl : 'Pharmacy',
			secondary: _affPrimaryProp == 'CE' ? validSvc.newProp($scope.User.RX) : validSvc.newProp($scope.User.CE),
			secondaryLabel: _affPrimaryProp == 'CE' ? 'Pharmacy' : 'Facility',
			Vendor: validSvc.newProp('ALL'),
			ItemCode: validSvc.newProp(''),
			Desc: validSvc.newProp(''),
			VenItemNum: validSvc.newProp(''),
			ExcludeStale: 'no',
			ExcludeUnknown: 'no',
		};

		affQueryChangePrimary();

	}


	/**
	 *    EXCEL
	 *    get file from server
	 */

	 function createAffAsyncExcel() {
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if (!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		// validate
		if(!affQueryValid(vm.affQuery)) {
			msgSvc.ok('Cannot Export', 'Check filter settings');
			return;
		}
		// search text valid
		var result = affQueryTextValid(vm.affQuery);
		if(result !== '') {
			msgSvc.ok('Search', 'Check filter properties. ' + result);
			return;
		}

		var venid = vm.affQuery.Vendor.val == 'ALL' ? [] : [vm.affQuery.Vendor.val];
		var apiQuery = {
			Context: {
				CEID: [_affPrimaryProp == 'CE' ? vm.affQuery.primary.val : vm.affQuery.secondary.val],
				RXID: [_affPrimaryProp == 'RX' ? vm.affQuery.primary.val : vm.affQuery.secondary.val],
				VENID: venid,	
			},
			Params: {
				ReportType: 'CATALOG_AFFILIATES',
				Manufacturer: vm.manufacturers,
				Account: vm.accts,
				ItemCode: vm.affQuery.ItemCode.val,
				Desc: vm.affQuery.Desc.val,
				VenItemNum: vm.affQuery.VenItemNum.val,
				ExcludeUnknown: vm.affQuery.ExcludeUnknown == 'yes',
				ExcludeStale: vm.affQuery.ExcludeStale == 'yes',	
			}
		};

		if (vm.affQuery.showPharmacyOnly) {
			apiQuery.Context.CEID = [];
			apiQuery.Context.VENID = [];
		}

		vm.popup = {};
		vm.isWaiting = true;
		msgSvc.wait(true);
		reportRepo.createAsyncFile(apiQuery).then(okServerExcel, errServerExcel);

		/**
		 *    EXCEL HELPERS
		 */

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			
			msgSvc.ok('Excel File Requested', 'Check the "Saved Files" link at top right to retrieve this Excel Workbook.');
		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if (!!r) {
				errSvc.warn('Create Excel Error', 'catalog.ServerExcel', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	
	/**
	 *    DISPLAY VIEW MODELS
	 */

	function typeFmt(dataType) {
		switch(dataType) {
			case 'REF':
			case 'REFERENCE':
				return 'REFERENCE';
			case 'NEW':
			case 'ADDED':
				return 'ADDED';
			case 'OVR':
			case 'OVERRIDE':
				return 'OVERRIDE';
			case 'OP':
				return 'OP';
			default:
				throw new Error('catalogsCtl.typeFmt, record type unknown: ' + dataType);
		}
	}

	function bgFmt(dataBG) {
		switch(dataBG) {
			case 'B':
			case 'BRAND':
				return 'BRAND';
			case 'G':
			case 'GENERIC':
				return 'GENERIC';
			default:
				return "";
				
		}
	}

	function catalogItemVM(data) {

		data = data || {};

		return {
			Id: data.Id,
			Type: typeFmt(data.Type),
			ObjectState: data.ObjectState,
			Vendor: data.Vendor == 'MEDISPAN' ? '' : data.Vendor,
			NDC: data.NDC,
			ItemCode: data.ItemCode,
			ReplaceItemCode: data.ReplaceItemCode,
			GPI: data.GPI,
			Description: data.Description,
			ReplaceItemCodeDescription: data.ReplaceItemCodeDescription,
			Manufacturer: !! data.Manufacturer ? data.Manufacturer: data.ManufacturerLabeler,
			ReplaceItemCodeManufacturer: data.ReplaceItemCodeManufacturer,
			PkgSz: data.PkgSz,
			CaseSz: data.CaseSz,
			BrandGeneric: bgFmt(data.BrandGeneric),
			DrugType: data.DrugType,
			DrugEnfAdmCd: validSvc.isNumber(data.DrugEnfAdmCd) ? data.DrugEnfAdmCd : 0,
			IsAssay: data.IsAssay ? 'YES' : 'NO',
			IsSpecialty: data.IsSpecialty ? 'YES' : 'NO',
			Price: data.Price,
			hasOverrides: !!data.hasOverrides ? 'YES' : 'NO',
			Vendors: Array.isArray(data.Vendors) ? data.Vendors : [],
			VendorsTxt: validSvc.isText(data.VendorsTxt) ? data.VendorsTxt : '',
		};

	}

	function displayVM(dataItems, tooMany) {

		// convert data model into display properties

		dataItems = Array.isArray(dataItems) ? dataItems : [];
		var allItems = [],
			isSearch = vm.activeTab == 'REFSEARCH';

		for(var i = 0; i < dataItems.length; i++) {

			// search overrides
			if(isSearch && Array.isArray(dataItems[i].Overrides) && dataItems[i].Overrides.length > 0) {
				dataItems[i].hasOverrides = true;
				dataItems[i].Vendors = [];
				dataItems[i].VendorsTxt = '';
				for(var ii = 0; ii < dataItems[i].Overrides.length; ii++) {
					dataItems[i].Vendors.push({
						id: dataItems[i].Overrides[ii].Id,
						name: dataItems[i].Overrides[ii].Vendor
					});
					dataItems[i].VendorsTxt += '|' + dataItems[i].Overrides[ii].Vendor;
				}
			}

			allItems.push(catalogItemVM(dataItems[i]));

		}

		return {
			Items: allItems,
			Paging: {
				Page: 1,
				Size: $scope.tblPagingSize,
				Total: vm.getTotalPages(allItems.length, $scope.tblPagingSize),
				TooMany: tooMany
			}
		};

	}

	function displayNoEdiVM(items, tooMany) {

		// convert data model into display properties

		items = Array.isArray(items) ? items : [];
		//for(var i = 0; i < items.length; i++) {
		//	items[i].EffectiveDate = validSvc.isDate(items[i].EffectiveDate) ? items[i].EffectiveDate : '';
		//}

		return {
			Items: items,
			Paging: {
				Page: 1,
				Size: $scope.tblPagingSize,
				Total: vm.getTotalPages(items.length, $scope.tblPagingSize),
				TooMany: tooMany
			}
		};

	}

	function affDisplayVM(items, tooMany) {

		// convert data model into display properties

		items = Array.isArray(items) ? items : [];
		for(var i = 0; i < items.length; i++) {
			items[i].Description = validSvc.isText(items[i].Description) ? items[i].Description : 'Catalog description not provided';
			items[i].Stale = items[i].Stale ? 'Yes' : 'No';
			items[i].DropShip = items[i].DropShip ? 'Yes' : 'No';
			items[i].LastChanged = validSvc.isDate(items[i].LastChanged) ? items[i].LastChanged : '';
			items[i].LastReceived = validSvc.isDate(items[i].LastReceived) ? items[i].LastReceived : '';
		}

		return {
			showPriceCol: vm.viewState.isUserRX ? vm.affQuery.showPharmacyOnly : true, // RX User: show price if pharmacy only
			Items: items,
			Paging: {
				Page: 1,
				Size: $scope.tblPagingSize,
				Total: vm.getTotalPages(items.length, $scope.tblPagingSize),
				TooMany: tooMany
			}
		};
	}


	/**
	 *    TAB CHANGE
	 */

	function tabChange(tab) {

		if(vm.isWaiting) {
			return;
		}

		vm.action = '';
		vm.display = {};
		vm.displayNoEdi = {};
		vm.affDisplay = {Items:[]};

		vm.catClone = {};
		vm.catClear = {};

		vm.activeTab = tab;

		switch (tab) {
			case 'OVERRIDE':
				getList();
				break;
			case 'REFSEARCH':
				refSearch(false);
				break;
			case 'NOEDI':
				if (!_noEdiLoaded) {
					_noEdiAffs = [];
					initNoEdi();
					_noEdiLoaded = true;
				}
				break;
			case 'AFFSEARCH':
				if (!_affSearchLoaded) {
					_affSearchAffs = [];
					initAffSearch();
					_affSearchLoaded = true;
				}
				vm.asyncReports = initAsyncReports();
				break;

			default:
				throw new Error('catalogsCtl.tabChange, unknown tab: ' + tab);
		}

	}


	/**
	 *    EXACT FILTER CHANGE
	 *    note: needed when values need to be filtered exactly by ng-repeat
	 */

	function filterExactChange(propName) {

		// exact filters require an undefined value to show all ng-repeat rows

		// prop name doesn't exist?
		var propVal = vm.viewState.FilterExact[propName];
		if(typeof(propVal) === 'undefined') {
			throw new Error('payorListCtl.filterExactChange, unknown propName: ' + propName);
		}

		// update NG property
		vm.viewState.FilterExact[propName + 'NG'] = propVal != 'ALL' ? propVal : undefined;

	}


	/**
	 *    GET LIST
	 *    list of overrides for this pharmacy
	 */

	function getList() {

		// exit if waiting
		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true);

		vm.action = '';

		// send api request
		catalogsRepo.getList().then(okGetList, errGetList);

		function okGetList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.display = displayVM(r.Items, r.TooMany);
			vm.action = 'LIST';

		}

		function errGetList(r) {

			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r !== null) {
				errSvc.error('Unknown get response', 'catalogsListCtl.errGetList', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    REFSEARCH (Medi-Span items search)
	 */

	function queryValid(q) {

		var resultText = '';

		switch(q.SearchType) {

			case 'NDC':

				var ndc = q.NDC.val,
					desc = q.Desc.val;
					var manu = q.Manufacturer;

				// ndc or desc is required
				if(!validSvc.isText(ndc) && !validSvc.isText(desc) && manu.length===0){
					q.NDC.fail = 'yes';
					q.Desc.fail = 'yes';
					resultText = (resultText.length > 0 ? ', ' : '') + 'NDC , Description or Manufacturer is required';
				}

				// ndc, optional 3 to 13 characters
				q.NDC.fail = 'no';
				if(validSvc.isText(ndc)) {
					ndc = ndc.toString().trim();
					ndc = ndc.replace(/[^0-9]+/g,'');
					q.NDC.val = ndc;

					if(ndc.length < 3 || ndc.length > 11 || !validSvc.isInteger(parseInt(ndc))) {
						q.NDC.fail = 'yes';
						resultText = (resultText.length > 0 ? ', ' : '') + 'NDC must be 3 to 11 numbers';
					}
				}

				// description, optional 3 to 50 characters
				q.Desc.fail = 'no';
				if(validSvc.isText(desc) && (desc.length < 3 || desc.length > 50)) {
					q.Desc.fail = 'yes';
					resultText = (resultText.length > 0 ? ', ' : '') + 'Description must be 3 to 50 characters';
				}
				q.Manufacturer.fail="no";
				break;

			case 'GPI':
				q.GPI.fail = 'no';
				if(!validSvc.isText(q.GPI.val) || q.GPI.val.lenth < 14) {
					q.GPI.fail = 'yes';
					resultText = 'GPI 14 characters required';
				}
				break;

			default:
				resultText = 'Choose a Search Type';

		}


		return resultText;
	}

	function refSearch(showMsg) {
		closePopup();
		if(vm.isWaiting) {
			return;
		}
		
		vm.query.Manufacturer = vm.manufacturers;
		var result = queryValid(vm.query);
		// search query valid
		if(result !== '') {
			if(showMsg) {
				msgSvc.ok('Search', 'Check filter properties. ' + result);
			}
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true);


		vm.action = '';

		// send api request
		catalogsRepo.search(vm.query).then(okSearch, errSearch);

		function okSearch(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.display = displayVM(r.Items, r.TooMany);
			vm.action = 'LIST';

		}

		function errSearch(r) {

			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r !== null) {
				errSvc.warn('Unknown get response', 'catalogsListCtl.errGetList', r.status, utilSvc.http.safeResponse(r));
			}

			$state.go('ops.catalogs', {}, {reload:'ops.catalogs'});
		}

	}


	/**
	 *    EDITING
	 */

	function listItemEdit(item) {

		// list item clicks get re-directed to Update or Create functions
		// note: all lists use this generic function

		// only VeritySA can edit list items
		if(!vm.viewState.isVeritySA) {
			return;
		}

		if(vm.activeTab == 'REFSEARCH' || item.Type == 'REFERENCE') {
			if(item.DrugType == 'ASSAY') {
				msgSvc.ok('Cannot Override', 'Assay drug type cannot be overriden');
				return;
			}
			ovrCreate(item);
		}
		else if(item.Type == 'OVERRIDE' || item.Type == 'ADDED') {
			ovrUpdate(item.Id);
		}
		else {
			throw new Error('catalogsListCtl.listItemEdit, unknown item type: ' + item.Type);
		}

	}

	function ovrUpdate(id) {

		if(vm.isWaiting) {
			return;
		}
		vm.action = '';

		if(!validSvc.isText(id)) {
			throw new Error('catalogsListCtl.ovrUpdate, missing id');
		}

		// get override details
		catalogsRepo.getOverride(id).then(okGetOverride, errGetOverride);

		function okGetOverride(r) {

			// save ui state
			vm.viewState.activeTab = vm.activeTab;

			vm.model = catalogsRepo.modelVM(r);
			vm.action = 'UPDATE';

			// ASYNC
			loadVendorDroplist();
		}

		function errGetOverride(r) {
			if(r !== null) {
				errSvc.warn('Unknown get response', 'catalogsListCtl.errGetOverride', r.status, utilSvc.http.safeResponse(r));
			}

			$state.go('ops.catalogs', {}, {reload:'ops.catalogs'});

		}

	}

	function ovrCreate(item) {

		if(vm.isWaiting) {
			return;
		}

		item = item || {hasOverrides: 'NO', Vendors: []};

		// save ui state
		vm.viewState.activeTab = vm.activeTab;

		vm.model = catalogsRepo.modelVM(item);

		// add overrides info
		vm.model.hasOverrides = item.hasOverrides;
		vm.model.Vendors = item.Vendors;

		vm.action = 'CREATE';

		// ASYNC
		loadVendorDroplist();
	}

	function editCancel() {
		tabChange(vm.activeTab);
	}

	function modelValid() {

		// validate catalogs

		// reset ROOT
		vm.model.ROOT = {};

		// can't fail a bool
		// vm.model.IsAssay.fail = 'no';

		// ObjectState, required, ACTIVE/INACTIVE
		if(vm.model.ObjectState.val != 'ACTIVE' && vm.model.ObjectState.val != 'INACTIVE') {
			vm.model.ObjectState.fail = 'yes';
			vm.model.ObjectState.msg = 'required';
		}
		else {
			vm.model.ObjectState.fail = 'no';
		}

		// vendor, required
		if(!validSvc.isVEN(vm.model.Vendor.val)) {
			vm.model.Vendor.fail = 'yes';
			vm.model.Vendor.msg = 'required';
		}
		else {
			vm.model.Vendor.fail = '';
		}

		// NDC, required
		if(!validSvc.isText(vm.model.NDC.val) || vm.model.NDC.val.length > 15) {
			vm.model.NDC.fail = 'yes';
			vm.model.NDC.msg = 'required, maximum 15 characters';
		}
		else {
			vm.model.NDC.fail = 'no';
		}

		// Description, optional 3 to 150 characters
		if(validSvc.isText(vm.model.Description.val) && (vm.model.Description.val.length < 3 || vm.model.Description.val.length > 150)) {
			vm.model.Description.fail = 'yes';
			vm.model.Description.msg = 'optional, must be 3 to 150 characters';
		}
		else {
			vm.model.Description.fail = 'no';
		}

		// package size, required number
		if(!validSvc.isNumber(vm.model.PkgSz.val) || parseFloat(vm.model.PkgSz.val) <= 0) {
			vm.model.PkgSz.fail = 'yes';
			vm.model.PkgSz.msg = 'required, number greater than 0';
		}
		else {
			vm.model.PkgSz.fail = 'no';
		}

		// case size, required
		if(!validSvc.isNumber(vm.model.CaseSz.val) || parseFloat(vm.model.CaseSz.val) <= 0) {
			vm.model.CaseSz.fail = 'yes';
			vm.model.CaseSz.msg = 'required, number greater than 0';
		}
		else {
			vm.model.CaseSz.fail = 'no';
		}

		// brand/generic required, 'BRAND' or 'GENERIC'
		if(vm.model.BrandGeneric.val != 'BRAND' && vm.model.BrandGeneric.val != 'GENERIC') {
			vm.model.BrandGeneric.fail = 'yes';
			vm.model.BrandGeneric.msg = 'required';
		}
		else {
			vm.model.BrandGeneric.fail = 'no';
		}

		// DEA code, required number
		if(!validSvc.isInteger(vm.model.DrugEnfAdmCd.val) || parseFloat(vm.model.DrugEnfAdmCd.val) < 0) {
			vm.model.DrugEnfAdmCd.fail = 'yes';
			vm.model.DrugEnfAdmCd.msg = 'required, number greater than 0';
		}
		else {
			vm.model.DrugEnfAdmCd.fail = 'no';
		}

		// price, required, number
		if(!validSvc.isNumber(vm.model.Price.val) || parseFloat(vm.model.Price.val) <= 0) {
			vm.model.Price.fail = 'yes';
			vm.model.Price.msg = 'required, number greater than 0';
		}
		else {
			vm.model.Price.fail = 'no';
		}

		return vm.model.ObjectState.fail != 'yes' &&
			vm.model.Vendor.fail != 'yes' &&
			vm.model.NDC.fail != 'yes' &&
			vm.model.Description.fail != 'yes' &&
			vm.model.PkgSz.fail != 'yes' &&
			vm.model.CaseSz.fail != 'yes' &&
			vm.model.BrandGeneric.fail != 'yes' &&
			vm.model.DrugEnfAdmCd.fail != 'yes' &&
			vm.model.Price.fail != 'yes';

	}

	function modelPackageMappingValid() {
		// Inner NDC, required
		if (!validSvc.isText(vm.model.NDC.val) || vm.model.NDC.val.length > 15) {
			vm.model.NDC.fail = 'yes';
			vm.model.NDC.msg = 'required, maximum 15 characters';
		}
		else {
			vm.model.NDC.fail = 'no';
		}
		// Outer NDC, required
		if (!validSvc.isText(vm.model.OuterNDC.val) || vm.model.OuterNDC.val.length > 15) {
			vm.model.OuterNDC.fail = 'yes';
			vm.model.OuterNDC.msg = 'required, maximum 15 characters';
		}
		else {
			vm.model.OuterNDC.fail = 'no';
		}
		return vm.model.NDC.fail != 'yes' &&
			vm.model.OuterNDC.fail != 'yes';
	}

	function assayItemEdit(item) {
		
		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;

		msgSvc.confirm({
			id: 'ops.catalogs',
			title: 'Assay Update',
			msg: 'Change Assay value to ' + (item.IsAssay == 'YES' ? 'NO' : 'YES'),
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(okayAssaySave, okayAssaySave);

		function okayAssaySave(r) {
			if (r.result != 'YES') {
				vm.isWaiting = false;
				return;
			}
			vm.model = item;
			catalogsRepo.updateAssay(vm.model).then(okSave, errSave);
			function okSave(r) {
				vm.isWaiting = false;
				tabChange(vm.activeTab);
			}

			function errSave(r) {
				vm.isWaiting = false;

				if(r == null) {
					// already handled
					$state.go('ops.catalogs', {}, {reload: 'ops.catalogs'});
				}
				else if(r.status == 409) {
					// conflict
					msgSvc.ok('Could Not Save', 'Could not update assay value.');
				}
				else {
					errSvc.error('Unknown assay save error response', 'catalogsCtl.errSave', r.status, utilSvc.http.safeResponse(r));
					$state.go('ops.catalogs', {}, {reload: 'ops.catalogs'});
				}

			}
		}

	}

	function specialtyItemEdit(item) {
		
		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;

		msgSvc.confirm({
			id: 'ops.catalogs',
			title: 'Specialty Update',
			msg: 'Change Specialty value to ' + (item.IsSpecialty == 'YES' ? 'NO' : 'YES'),
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(okaySpecialtySave, okaySpecialtySave);

		function okaySpecialtySave(r) {
			if (r.result != 'YES') {
				vm.isWaiting = false;
				return;
			}
			vm.model = item;
			catalogsRepo.updateSpecialty(vm.model).then(okSave, errSave);
			function okSave(r) {
				vm.isWaiting = false;
				tabChange(vm.activeTab);
			}

			function errSave(r) {
				vm.isWaiting = false;

				if(r == null) {
					// already handled
					$state.go('ops.catalogs', {}, {reload: 'ops.catalogs'});
				}
				else if(r.status == 409) {
					// conflict
					msgSvc.ok('Could Not Save', 'Could not update specialty value.');
				}
				else {
					errSvc.error('Unknown specialty save error response', 'catalogsCtl.errSave', r.status, utilSvc.http.safeResponse(r));
					$state.go('ops.catalogs', {}, {reload: 'ops.catalogs'});
				}

			}
		}

	}

	function editSave() {

		if(vm.isWaiting) {
			return;
		}

		if(!modelValid()) {
			msgSvc.ok('Save', 'Check data values');
			return;
		}

		vm.isWaiting = true;

		// create or update
		if(vm.action == 'CREATE') {
			catalogsRepo.create(vm.model).then(okSave, errSave);
		}
		else {
			catalogsRepo.update(vm.model).then(okSave, errSave);
		}

		function okSave(r) {
			vm.isWaiting = false;
			msgSvc.ok('Override Saved', 'Override Saved');
			tabChange(vm.activeTab);
		}

		function errSave(r) {

			vm.isWaiting = false;

			if(r == null) {
				// already handled
				$state.go('ops.catalogs', {}, {reload: 'ops.catalogs'});
			}
			else if(r.status == 409) {
				// conflict
				msgSvc.ok('Could Not Save', 'May already exist in the database. Verify and try again.');
			}
			else if (r.status == 422) {
				// validation
				vm.model = r.model;
			}
			else {
				errSvc.error('Unknown add / update error response', 'catalogsCtl.errSave', r.status, utilSvc.http.safeResponse(r));
				$state.go('ops.catalogs', {}, {reload: 'ops.catalogs'});
			}

		}

	}


	/**
	 *    NO EDI CHANGE EVENTS
	 */

	function queryChange(changed) {

		vm.action = '';

		switch(changed) {

			case 'PRIMARY':
				vm.secondaryDroplist = utilSvc.ng.droplistNONE();
				vm.VenDroplist = utilSvc.ng.droplistNONE();
				break;

			case 'SECONDARY':
				vm.VenDroplist = utilSvc.ng.droplistNONE();
				break;

			case 'VENDOR':
			case 'ACCUMGRP':
				// no dependents
				break;

			default:
				throw new Error('catalogListCtl.queryChange, unknown changed type: ' + changed);
		}

	}

	function queryChangePrimary() {

		queryChange('PRIMARY');

		vm.noEdiQuery.primary.fail = validSvc.isEntity(vm.noEdiQuery.primary.val) ? 'no' : 'yes';
		if(vm.noEdiQuery.primary.fail == 'yes') {
			vm.noEdiQuery.secondary = validSvc.newProp('NONE');
			return;
		}

		// secondary options
		if(_primaryEdiProp == 'CE') {
			vm.secondaryDroplist = utilSvc.aff.rxDroplist(noEdiGetAffs(), vm.noEdiQuery.primary.val);
		}
		else {
			vm.secondaryDroplist = utilSvc.aff.ceDroplist(noEdiGetAffs(), vm.noEdiQuery.primary.val);
		}
		vm.noEdiQuery.secondary = utilSvc.ng.droplistAutoselect(vm.secondaryDroplist, vm.noEdiQuery.secondary.val);

		queryChangeSecondary();

	}

	function queryChangeSecondary() {

		queryChange('SECONDARY');

		vm.noEdiQuery.secondary.fail = validSvc.isEntity(vm.noEdiQuery.secondary.val) ? 'no' : 'yes';
		if(vm.noEdiQuery.secondary.fail == 'yes') {
			vm.noEdiQuery.Vendor = validSvc.newProp('NONE');
			return;
		}

		// vendor options
		var limits = {
			CE: _primaryEdiProp == 'CE' ? vm.noEdiQuery.primary.val : vm.noEdiQuery.secondary.val,
			RX: _primaryEdiProp == 'RX' ? vm.noEdiQuery.primary.val : vm.noEdiQuery.secondary.val,
			ACCUMGRP: ['340B', 'GPO', 'WAC'],
			includeNoEDI: true
		};
		vm.VenDroplist = utilSvc.aff.droplistByType(noEdiGetAffs(), 'VEN', limits);
		vm.noEdiQuery.Vendor = utilSvc.ng.droplistAutoselect(vm.VenDroplist, vm.noEdiQuery.Vendor.val);

		queryChangeVendor();

	}

	function queryChangeVendor() {

		queryChange('VENDOR');

		vm.noEdiQuery.Vendor.fail = validSvc.isEntity(vm.noEdiQuery.Vendor.val) ? 'no' : 'yes';
		if(vm.noEdiQuery.Vendor.fail == 'yes') {
			return;
		}

	}

	function noEdiQuerySwap() {
		_primaryEdiProp = _primaryEdiProp == 'CE' ? 'RX' : 'CE';
		_noEdiLoaded = false;
		initNoEdi();
		_noEdiLoaded = true;
	}


	/**
	 *    NO EDI SEARCH
	 */

	function noEdiQueryValid(nQuery) {

		nQuery.primary.fail = validSvc.isEntity(nQuery.primary.val) ? 'no' : 'yes';
		nQuery.secondary.fail = validSvc.isEntity(nQuery.secondary.val) ? 'no' : 'yes';
		nQuery.Vendor.fail = validSvc.isEntity(nQuery.Vendor.val) ? 'no' : 'yes';

		return nQuery.primary.fail != 'yes' && nQuery.secondary.fail != 'yes' && nQuery.Vendor.fail != 'yes';

	}

	function noEdiSearch() {

		// exit if waiting
		if(vm.isWaiting) {
			return;
		}

		if(!noEdiQueryValid(vm.noEdiQuery)) {
			msgSvc.ok('Search', 'Check search values');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		vm.action = '';

		// send api request
		var apiQuery = {
			CE: _primaryEdiProp == 'CE' ? vm.noEdiQuery.primary.val : vm.noEdiQuery.secondary.val,
			RX: _primaryEdiProp == 'RX' ? vm.noEdiQuery.primary.val : vm.noEdiQuery.secondary.val,
			VEN: vm.noEdiQuery.Vendor.val
		};

		catalogsRepo.getNoEdiList(apiQuery).then(okGetNoEdiList, errGetNoEdiList);

		function okGetNoEdiList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.displayNoEdi = displayNoEdiVM(r.Items, r.TooMany);
			vm.action = 'LIST';

		}

		function errGetNoEdiList(r) {

			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r !== null) {
				errSvc.error('Unknown get response', 'catalogsListCtl.errGetNoEdiList', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    NO EDI CLONE CATALOG
	 */

	function toggleCatClone() {

		if(vm.isWaiting) {
			return;
		}

		if(vm.action == 'CATCLONE') {
			// toggle off
			vm.catClone = {};
			vm.action = 'LIST';
			return;
		}

		var q = vm.noEdiQuery,
			priCE = _primaryEdiProp == 'CE',
			priRX = _primaryEdiProp == 'RX';

		vm.catClone = {
			PriLabel: priCE ? 'Facility' : 'Pharmacy',
			SecLabel: priRX ? 'Facility' : 'Pharmacy',
			fromPri: priCE ? q.primary.val : utilSvc.ng.droplistLabel(vm.primaryDroplist, q.primary.val),
			fromSec: priRX ? q.secondary.val : utilSvc.ng.droplistLabel(vm.secondaryDroplist, q.secondary.val),
			fromCE: priCE ? q.primary.val : q.secondary.val,
			fromRX: _primaryEdiProp == 'RX' ? q.primary.val : q.secondary.val,
			fromVEN: q.Vendor.val,
			fromAccumGrp: [],
			Pri: validSvc.newProp('NONE'),
			PriDroplist: utilSvc.ng.droplistNONE(),
			Sec: validSvc.newProp('NONE'),
			SecDroplist: utilSvc.ng.droplistNONE(),
			Ven: validSvc.newProp('NONE'),
			VenDroplist: utilSvc.ng.droplistNONE(),
			AccumGrp: validSvc.newProp('NONE'),
			AccumGrpDroplist: utilSvc.ng.droplistNONE()
		};

		// remove same vendor from aff options
		var affs = noEdiGetAffs(),
			aff = {},
			ceid = vm.catClone.fromCE,
			rxid = vm.catClone.fromRX,
			ven = vm.catClone.fromVEN,
			fromAccumGrp = [];

		for(var i = affs.length - 1; i >= 0; i--) {
			aff = affs[i];

			if(aff.CEID == ceid && aff.RXID == rxid) {
				aff.Ordering = Array.isArray(aff.Ordering) ? aff.Ordering : [];

				for(var ii = aff.Ordering.length - 1; ii >= 0; ii--) {
					if(aff.Ordering[ii].VENID == ven) {

						// remember which accounts this vendor has
						if(fromAccumGrp.indexOf(aff.Ordering[ii].Type) < 0) {
							fromAccumGrp.push(aff.Ordering[ii].Type);
						}

						aff.Ordering.splice(ii, 1);
					}
				}

				if(aff.Ordering.length < 1) {
					affs.splice(i, 1);
				}
			}
		}
		vm.catClone.affs = affs;
		fromAccumGrp.sort();
		vm.catClone.fromAccumGrp = fromAccumGrp;

		// assign to primary
		if(_primaryEdiProp == 'CE') {
			vm.catClone.PriDroplist = utilSvc.aff.ceDroplist(affs);
		}
		else {
			vm.catClone.PriDroplist = utilSvc.aff.rxDroplist(affs);
		}
		vm.catClone.Pri = utilSvc.ng.droplistAutoselect(vm.catClone.PriDroplist, q.primary.val);

		catCloneChange('PRI');

		vm.action = 'CATCLONE';

	}

	function catCloneChange(prop) {

		if(vm.isWaiting || !validSvc.isText(prop)) {
			return;
		}

		var cat = vm.catClone,
			priCE = _primaryEdiProp == 'CE',
			secCE = _primaryEdiProp == 'RX';

		switch(prop) {

			case 'PRI':
				cat.Sec = validSvc.newProp('NONE');
				cat.Ven = validSvc.newProp('NONE');
				cat.AccumGrp = validSvc.newProp('NONE');
				cat.SecDroplist = utilSvc.ng.droplistNONE();
				cat.VenDroplist = utilSvc.ng.droplistNONE();
				cat.AccumGrpDroplist = utilSvc.ng.droplistNONE();

				cat.Pri.fail = validSvc.isEntity(cat.Pri.val) ? 'no' : 'yes';
				if(cat.Pri.fail == 'no') {
					// sec options
					if(priCE) {
						cat.SecDroplist = utilSvc.aff.rxDroplist(cat.affs, cat.Pri.val);
					}
					else {
						cat.SecDroplist = utilSvc.aff.ceDroplist(cat.affs, cat.Pri.val);
					}
				}
				break;

			case 'SEC':
				cat.Ven = validSvc.newProp('NONE');
				cat.AccumGrp = validSvc.newProp('NONE');
				cat.VenDroplist = utilSvc.ng.droplistNONE();
				cat.AccumGrpDroplist = utilSvc.ng.droplistNONE();

				cat.Sec.fail = validSvc.isEntity(cat.Sec.val) ? 'no' : 'yes';
				if(cat.Sec.fail == 'no') {
					// vendor options
					var limits = {
						CE: priCE ? cat.Pri.val : cat.Sec.val,
						RX: secCE ? cat.Pri.val : cat.Sec.val,
						ACCUMGRP: cat.fromAccumGrp,
						includeNoEDI: true
					};
					cat.VenDroplist = utilSvc.aff.droplistByType(cat.affs, 'VEN', limits);
				}
				break;

			case 'VEN':
				cat.AccumGrp = validSvc.newProp('NONE');
				cat.AccumGrpDroplist = utilSvc.ng.droplistNONE();

				cat.Ven.fail = validSvc.isEntity(cat.Ven.val) ? 'no' : 'yes';
				if(cat.Ven.fail == 'no') {
					// accum grp options
					var aglimits = {
						CE: priCE ? cat.Pri.val : cat.Sec.val,
						RX: secCE ? cat.Pri.val : cat.Sec.val,
						VEN: cat.Ven.val,
						ACCUMGRP: cat.fromAccumGrp,
						includeNoEDI: true
					};
					cat.AccumGrpDroplist = utilSvc.aff.droplistByType(cat.affs, 'ACCUMGRP', aglimits);
				}
				break;

			case 'ACCUMGRP':
				cat.AccumGrp.fail = validSvc.isEntity(cat.AccumGrp.val) ? 'no' : 'yes';
				break;

			default:
				msgSvc.ok('Error', 'catalogsList.catCloneChange, unknown prop: ' + prop);
		}
	}

	function catCloneValid(m) {

		m.Pri.fail = validSvc.isEntity(m.Pri.val) ? 'no' : 'yes';
		m.Sec.fail = validSvc.isEntity(m.Sec.val) ? 'no' : 'yes';
		m.Ven.fail = validSvc.isEntity(m.Ven.val) ? 'no' : 'yes';
		m.AccumGrp.fail = validSvc.isEntity(m.AccumGrp.val) ? 'no' : 'yes';

		return m.Pri.fail != 'yes' &&
			m.Sec.fail != 'yes' &&
			m.Ven.fail != 'yes' &&
			m.AccumGrp.fail != 'yes';
	}

	function catCloneSubmit() {

		if(vm.isWaiting) {
			return;
		}

		if(!catCloneValid(vm.catClone)) {
			msgSvc.ok('Cannot Clone Catalog', 'Check settings');
			return;
		}

		var cat = vm.catClone,
			q = vm.noEdiQuery,
			priCE = _primaryEdiProp == 'CE',
			priRX = _primaryEdiProp == 'RX';

		var toPri = priCE ? cat.Pri.val : utilSvc.ng.droplistLabel(cat.PriDroplist, cat.Pri.val),
			toSec = priRX ? q.Sec.val : utilSvc.ng.droplistLabel(cat.SecDroplist, cat.Sec.val);

		var cloneTxt = 'Clone ' + cat.AccumGrp.val + '-' + cat.fromVEN + ' from ';
		cloneTxt += cat.fromPri + ' / ' + cat.fromSec + ' to ' + toPri + ' / ' + toSec;
		cloneTxt += ' with Vendor: ' + cat.AccumGrp.val + '-' + cat.Ven.val;
		cloneTxt += '. Existing catalog will be replaced.';

		// prompt user
		msgSvc.confirm({
			id: 'ops.catalog.clone.prompt',
			title: 'Clone Catalog',
			msg: cloneTxt,
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'NO', cancel: true}
			]
		}).then(confirmCatClone, confirmCatClone);
	}

	function confirmCatClone(r) {

		if(!!!r || r.result != 'YES') {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		var cat = vm.catClone,
			ceProp = _primaryEdiProp == 'CE' ? 'Pri' : 'Sec';

		var req = {
			cloneFrom: {
				CE: cat.fromCE,
				RX: cat.fromRX,
				VEN: cat.fromVEN
			},
			cloneTo: {
				CE: cat[ceProp].val,
				RX: ceProp == 'Pri' ? cat.Sec.val : cat.Pri.val,
				VEN: cat.Ven.val,
				AccumGrp: cat.AccumGrp.val
			}
		};

		catalogsRepo.clone(req.cloneFrom, req.cloneTo).then(okCloneCat, errCloneCat);

		function okCloneCat(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			msgSvc.ok('Clone Complete', vm.catClone.Pri.val + ' / ' + vm.catClone.Sec.val + ' now has the same catalog.');
		}

		function errCloneCat(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(r !== null) {
				errSvc.warn('Not able to clone catalog.', 'catalogsList.catalogClone', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    CLEAR CATALOG
	 */

	function toggleCatClear() {

		if(vm.isWaiting) {
			return;
		}

		if(vm.activeTab == 'CATCLEAR') {
			// toggle off
			vm.catClear = {};
			init();
			return;
		}

		vm.catClear = {
			CE: validSvc.newProp('NONE'),
			CeDroplist: utilSvc.aff.ceDroplist(getAffs(true)),
			RX: validSvc.newProp('NONE'),
			RxDroplist: utilSvc.ng.droplistNONE(),
			VEN: validSvc.newProp('NONE'),
			VenDroplist: utilSvc.ng.droplistNONE(),
			AccumGrp: validSvc.newProp('NONE'),
			AccumGrpDroplist: utilSvc.ng.droplistNONE()
		};

		vm.activeTab = 'CATCLEAR';

	}

	function catClearChange(prop) {

		if(vm.isWaiting || !validSvc.isText(prop)) {
			return;
		}

		var cat = vm.catClear;

		switch(prop) {

			case 'CE':
				cat.RX = validSvc.newProp('NONE');
				cat.VEN = validSvc.newProp('NONE');
				cat.AccumGrp = validSvc.newProp('NONE');
				cat.RxDroplist = utilSvc.ng.droplistNONE();
				cat.VenDroplist = utilSvc.ng.droplistNONE();
				cat.AccumGrpDroplist = utilSvc.ng.droplistNONE();

				cat.CE.fail = validSvc.isCE(cat.CE.val) ? 'no' : 'yes';
				if(cat.CE.fail == 'no') {
					cat.RxDroplist = utilSvc.aff.rxDroplist(getAffs(true), cat.CE.val);
				}
				break;

			case 'RX':
				cat.VEN = validSvc.newProp('NONE');
				cat.AccumGrp = validSvc.newProp('NONE');
				cat.VenDroplist = utilSvc.ng.droplistNONE();
				cat.AccumGrpDroplist = utilSvc.ng.droplistNONE();

				cat.RX.fail = validSvc.isRX(cat.RX.val) ? 'no' : 'yes';
				if(cat.RX.fail == 'no') {
					// vendor options
					var limits = {
						CE: cat.CE.val,
						RX: cat.RX.val,
						//ACCUMGRP: cat.fromAccumGrp,
						includeNoEDI: true
					};
					cat.VenDroplist = utilSvc.aff.droplistByType(getAffs(true), 'VEN', limits);
				}
				break;

			case 'VEN':
				cat.AccumGrp = validSvc.newProp('NONE');
				cat.AccumGrpDroplist = utilSvc.ng.droplistNONE();

				cat.VEN.fail = validSvc.isEntity(cat.VEN.val) ? 'no' : 'yes';
				if(cat.VEN.fail == 'no') {
					// accum grp options
					var aglimits = {
						CE: cat.CE.val,
						RX: cat.RX.val,
						VEN: cat.VEN.val,
						//ACCUMGRP: cat.fromAccumGrp,
						includeNoEDI: true
					};
					cat.AccumGrpDroplist = utilSvc.aff.droplistByType(getAffs(true), 'ACCUMGRP', aglimits);
				}
				break;

			case 'ACCUMGRP':
				cat.AccumGrp.fail = validSvc.isEntity(cat.AccumGrp.val) ? 'no' : 'yes';
				break;

			default:
				msgSvc.ok('Error', 'catalogsList.catClearChange, unknown prop: ' + prop);
		}
	}

	function catClearValid(m) {

		m.CE.fail = validSvc.isEntity(m.CE.val) ? 'no' : 'yes';
		m.RX.fail = validSvc.isEntity(m.RX.val) ? 'no' : 'yes';
		m.VEN.fail = validSvc.isEntity(m.VEN.val) ? 'no' : 'yes';
		m.AccumGrp.fail = validSvc.isEntity(m.AccumGrp.val) ? 'no' : 'yes';

		return m.CE.fail != 'yes' &&
			m.RX.fail != 'yes' &&
			m.VEN.fail != 'yes' &&
			m.AccumGrp.fail != 'yes';
	}

	function catClearSubmit() {

		if(vm.isWaiting) {
			return;
		}

		if(!catClearValid(vm.catClear)) {
			msgSvc.ok('Cannot Clear Catalog', 'Check settings');
			return;
		}

		var cat = vm.catClear,
			rxLabel = utilSvc.ng.droplistLabel(cat.RxDroplist, cat.RX.val);

		var clearTxt = 'Clear ' + cat.AccumGrp.val + '-' + cat.VEN.val + ' on affiliation ';
		clearTxt += cat.CE.val + ' / ' + cat.RX.val + '?';

		// prompt user
		msgSvc.confirm({
			id: 'ops.catalog.clear.prompt',
			title: 'Clear Catalog',
			msg: clearTxt,
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'NO', cancel: true}
			]
		}).then(confirmCatClear, confirmCatClear);
	}

	function confirmCatClear(r) {

		if(!!!r || r.result != 'YES') {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		catalogsRepo.clear(vm.catClear).then(okCatClear, errCatClear);

		function okCatClear(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			var cat = vm.catClear;
			var okTxt = cat.AccumGrp.val + '-' + cat.VEN.val + ' on affiliation ';
				okTxt += cat.CE.val + ' / ' + cat.RX.val;

			msgSvc.ok('Catalog Clear Complete', okTxt);
		}

		function errCatClear(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(r !== null) {
				errSvc.warn('Not able to clear catalog.', 'catalogsList.catalogClear', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    NO EDI IMPORT
	 */

	function noEdiImportToggle() {

		vm.noEdiImportFiles = [];
		vm.noEdiImportErrors = [];
		vm.noEdiImportCounts = {};

		if(vm.action == 'IMPORT') {
			vm.action = 'LIST';
		}
		else {

			// check for File API and FormData upload browser support
			if(typeof($window.File) === 'undefined' ||
				typeof($window.FileReader) === 'undefined' ||
				typeof($window.FileList) === 'undefined' ||
				typeof($window.Blob) === 'undefined' ||
				typeof($window.FormData) === 'undefined') {
				msgSvc.ok('File Upload Not Supported', 'File Upload uses HTML5 FormData upload, your browser does not support it. Please upgrade to use file upload.');
				return;
			}

			// accum grp options
			vm.noEdiQuery.AccumGrp = validSvc.newProp('NONE');
			var limits = {
				CE: _primaryEdiProp == 'CE' ? vm.noEdiQuery.primary.val : vm.noEdiQuery.secondary.val,
				RX: _primaryEdiProp == 'RX' ? vm.noEdiQuery.primary.val : vm.noEdiQuery.secondary.val,
				VEN: vm.noEdiQuery.Vendor.val,
				includeNoEDI: true
			};
			vm.AccumGrpDroplist = utilSvc.aff.droplistByType(noEdiGetAffs(), 'ACCUMGRP', limits);

			listenForFileImport();
			vm.action = 'IMPORT';
		}

	}

	function importValidFile(newFile) {

		// required
		if(!!!newFile) {
			return 'no file selected';
		}

		// file size > 0 bytes, < 10 megabytes
		if(!validSvc.isNumber(newFile.size) || newFile.size < 1 || newFile.size > 10000000) {
			return 'file size must be 2 bytes to 10 megabytes';
		}

		// file name must be .csv
		var fName = newFile.name;
		if(!validSvc.isText(fName) || fName.length < 5 || (fName.substr(fName.length - 4, 4).toLowerCase() !== '.csv' && fName.substr(fName.length - 4, 4).toLowerCase() !== '.txt')) {
			return 'file name must end with extension ".csv" or ".txt"';
		}

		return 'ok';

	}

	function noEdiImportValid() {

		// files selected
		if(!!!vm.noEdiImportFiles || vm.noEdiImportFiles.length !== 1) {
			msgSvc.ok('File Import', 'Please choose 1 file to upload.');
			return false;
		}

		// validate file
		var fileFail = importValidFile(vm.noEdiImportFiles[0]);
		if(fileFail != 'ok') {
			msgSvc.ok('File Import', 'Selected file error: ' + fileFail);
			return false;
		}

		// accum group
		vm.noEdiQuery.AccumGrp.fail = validSvc.isEntity(vm.noEdiQuery.AccumGrp.val) ? 'no' : 'yes';
		if(vm.noEdiQuery.AccumGrp.fail == 'yes') {
			msgSvc.ok('File Import', 'Please choose a Price Type');
			return false;
		}

		return true;

	}

	function noEdiImportFile() {

		if(vm.isWaiting) {
			return;
		}

		if(!noEdiImportValid()) {
			return;
		}

		if(vm.displayNoEdi.Items.length > 0) {
			msgSvc.confirm({
				id: 'ops.cat.edi.import.confirm',
				title: 'Import ' + vm.noEdiQuery.AccumGrp.val + ' Catalog',
				msg: 'Warning: the previous catalog will be replaced, this is not reversable.',
				buttons: [
					{text:'OK', result:'YES', cancel: false},
					{text:'CANCEL', result:'CANCEL', cancel: true}
				]
			}).then(confirmEdiImport, confirmEdiImport);
		}
		else {
			confirmEdiImport({result:'YES'});
		}
	}

	function confirmEdiImport(r) {

		// user cancelled
		if(!!!r || r.result != 'YES') {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);
		vm.noEdiImportErrors = [];
		vm.noEdiImportCounts = {};

		var apiQuery = {
			CE: _primaryEdiProp == 'CE' ? vm.noEdiQuery.primary.val : vm.noEdiQuery.secondary.val,
			RX: _primaryEdiProp == 'RX' ? vm.noEdiQuery.primary.val : vm.noEdiQuery.secondary.val,
			VEN: vm.noEdiQuery.Vendor.val,
			ACCUMGRP: vm.noEdiQuery.AccumGrp.val
		};

		catalogsRepo.noEdiFileImport(apiQuery, vm.noEdiImportFiles[0]).then(okFileImport, errFileImport);

		function okFileImport(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;
			msgSvc.okAsync('File Import Success', 'Total ' + r.ProcessedCount + ' items imported.', 'ops.cat.noedi.import').then(noEdiSearch, noEdiSearch);
		}

		function errFileImport(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(r === null) {
				return;
			}
			else if (r.status === 422) {
				vm.noEdiImportErrors = r.importErrors;
				vm.noEdiImportCounts = r.counts;
				if(r.counts.Processed > 0) {
					msgSvc.ok('File Import With Errors', r.counts.Processed + ' imported, ' + r.importErrors.length + ' errors');
				}
				else {
					msgSvc.ok('File Import Failed', 'No line items were imported, there are: ' + r.importErrors.length + ' line item errors');
				}
			}
			else {
				errSvc.error('Unexpected api error', 'catalogListCtl.errFileImport', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    AFF SEARCH EVENTS
	 */

	function affQueryChange(changed) {

		vm.action = '';

		switch(changed) {

			case 'PRIMARY':
				vm.affSecondaryDroplist = utilSvc.ng.droplistNONE();
				vm.affVenDroplist = utilSvc.ng.droplistALL();
				break;

			case 'SECONDARY':
				vm.affVenDroplist = utilSvc.ng.droplistALL();
				break;

			case 'VENDOR':
			case 'ACCUMGRP':
				// no dependents
				break;

			default:
				throw new Error('catalogListCtl.affQueryChange, unknown changed type: ' + changed);
		}

	}

	function affQueryChangePrimary() {

		affQueryChange('PRIMARY');

		vm.affQuery.primary.fail = validSvc.isEntity(vm.affQuery.primary.val) ? 'no' : 'yes';
		if(vm.affQuery.primary.fail == 'yes') {
			vm.affQuery.secondary = validSvc.newProp('NONE');
			return;
		}

		// secondary options
		if(_affPrimaryProp == 'CE') {
			vm.affSecondaryDroplist = utilSvc.aff.rxDroplist(affSearchAffs(), vm.affQuery.primary.val);
		}
		else {
			vm.affSecondaryDroplist = utilSvc.aff.ceDroplist(affSearchAffs(), vm.affQuery.primary.val);
		}
		vm.affQuery.secondary = utilSvc.ng.droplistAutoselect(vm.affSecondaryDroplist, vm.affQuery.secondary.val);

		affQueryChangeSecondary();

	}

	function affQueryChangeSecondary() {

		affQueryChange('SECONDARY');

		vm.affQuery.secondary.fail = validSvc.isEntity(vm.affQuery.secondary.val) ? 'no' : 'yes';
		if(vm.affQuery.secondary.fail == 'yes') {
			vm.affQuery.Vendor = validSvc.newProp('ALL');
			return;
		}

		// vendor options
		var limits = {
			CE: _affPrimaryProp == 'CE' ? vm.affQuery.primary.val : vm.affQuery.secondary.val,
			RX: _affPrimaryProp == 'RX' ? vm.affQuery.primary.val : vm.affQuery.secondary.val,
			ACCUMGRP: ['340B', 'GPO', 'WAC','OWN'],
			includeNoEDI: true
		};
		vm.affVenDroplist = utilSvc.aff.droplistByType(affSearchAffs(), 'VEN', limits);
		vm.affVenDroplist[0] = {label: 'All Vendors', value: 'ALL'};

		vm.affQuery.Vendor = utilSvc.ng.droplistAutoselect(vm.affVenDroplist, vm.affQuery.Vendor.val);
		if(vm.affQuery.Vendor.val == 'NONE') {
			vm.affQuery.Vendor.val = 'ALL';
		}

		affQueryChangeVendor();

	}

	function affQueryChangeVendor() {

		affQueryChange('VENDOR');

		vm.affQuery.Vendor.fail = validSvc.isEntity(vm.affQuery.Vendor.val, false, true) ? 'no' : 'yes';
		if(vm.affQuery.Vendor.fail == 'yes') {
			return;
		}

	}

	function affQueryChangePharmacyOnly() {
		var affs = affSearchAffs();
		vm.affPrimaryDroplist = utilSvc.aff.rxDroplist(affs);
		vm.affQuery.primary = utilSvc.ng.droplistAutoselect(vm.affPrimaryDroplist, $scope.User[_affPrimaryProp]);
	}

	function affQueryToggleShowPharmacyOnly() {
		if(vm.isWaiting) {
			return;
		}
		vm.affQuery.showPharmacyOnly=!!!vm.affQuery.showPharmacyOnly;

		// re-run aff search (this will pickup any missing rollups)
		_affSearchAffs = [];
		affQueryChangePharmacyOnly();
	}

	function affQuerySwap() {
		_affPrimaryProp = _affPrimaryProp == 'CE' ? 'RX' : 'CE';
		vm.affPrimaryProp = _affPrimaryProp;
		_affSearchLoaded = false;
		initAffSearch();
		_affSearchLoaded = true;
	}


	/**
	 *    AFF SEARCH
	 */

	function affQueryValid(aQuery) {

		aQuery.primary.fail = validSvc.isEntity(aQuery.primary.val) ? 'no' : 'yes';
		aQuery.secondary.fail = validSvc.isEntity(aQuery.secondary.val) ? 'no' : 'yes';
		aQuery.Vendor.fail = validSvc.isEntity(aQuery.Vendor.val, false, true) ? 'no' : 'yes';

		return aQuery.primary.fail != 'yes' && (!!aQuery.showPharmacyOnly || (aQuery.secondary.fail != 'yes' && aQuery.Vendor.fail != 'yes'));

	}

	function affQueryTextValid(q) {

		var resultText = '';

		var ndc = q.ItemCode.val,
			desc = q.Desc.val,
			venum = q.VenItemNum.val;

		// ndc, optional 5 to 13 characters
		q.ItemCode.fail = 'no';
		if(validSvc.isText(ndc)) {
			ndc = ndc.toString().trim();
			ndc = ndc.replace(/[^0-9]+/g,'');
			q.ItemCode.val = ndc;

			if(ndc.length < 5 || ndc.length > 11 || !validSvc.isInteger(parseInt(ndc))) {
				q.ItemCode.fail = 'yes';
				resultText = (resultText.length > 0 ? ', ' : '') + 'NDC must be 3 to 11 numbers';
			}
		}

		// desc, optional 5 to 30 characters
		q.Desc.fail = 'no';
		if(validSvc.isText(desc) && (desc.length < 3 || desc.length > 50)) {
			q.Desc.fail = 'yes';
			resultText = (resultText.length > 0 ? ', ' : '') + 'Description must be 3 to 50 characters';
		}

		// venum, optional 5 to 30 characters
		q.VenItemNum.fail = 'no';
		if(validSvc.isText(venum) && (venum.length < 5 || venum.length > 30)) {
			q.VenItemNum.fail = 'yes';
			resultText = (resultText.length > 0 ? ', ' : '') + 'Vendor Item # must be 5 to 30 characters';
		}

		return resultText;
	}

	function affSearch() {

		// exit if waiting
		if(vm.isWaiting) {
			return;
		}

		// dropdowns valid
		if(!affQueryValid(vm.affQuery)) {
			msgSvc.ok('Search', 'Check search values');
			return;
		}

		// search text valid
		var result = affQueryTextValid(vm.affQuery);
		if(result !== '') {
			msgSvc.ok('Search', 'Check filter properties. ' + result);
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		vm.action = '';

		// send api request
		var apiQuery = {
			CE: _affPrimaryProp == 'CE' ? vm.affQuery.primary.val : vm.affQuery.secondary.val,
			RX: _affPrimaryProp == 'RX' ? vm.affQuery.primary.val : vm.affQuery.secondary.val,
			VEN: vm.affQuery.Vendor.val,
			ItemCode: vm.affQuery.ItemCode.val,
			Desc: vm.affQuery.Desc.val,
			VenItemNum: vm.affQuery.VenItemNum.val,
			Manufacturer: vm.manufacturers,
			Account: vm.accts,
			ExcludeUnknown: vm.affQuery.ExcludeUnknown == 'yes',
			ExcludeStale: vm.affQuery.ExcludeStale == 'yes',	
		};

		if (vm.affQuery.showPharmacyOnly) {
			apiQuery.CE = '';
			apiQuery.VEN = '';
		}

		catalogsRepo.affSearch(apiQuery).then(okAffSearch, errAffSearch);

		function okAffSearch(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.affDisplay = affDisplayVM(r.Items, r.TooMany);
			vm.action = 'LIST';

		}

		function errAffSearch(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.error('Unknown get response', 'catalogsListCtl.errAffSearch', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}

	function initAsyncReports() {
		return {
			title: 'Catalog Affiliates - Saved Files',
			show: 'no'
		};
	}

	function toggleAsyncReports() {
		if(vm.isWaiting) {
			return;
		}
		vm.asyncReports.show = vm.asyncReports.show == 'yes' ? 'no' : 'yes';
		if(vm.asyncReports.show == 'yes') {
			$state.go('ops.catalogs.async-reports', {
				rptType: 'CATALOG_AFFILIATES',
				query: null
			}, {reload: 'ops.catalogs.async-reports'});
		}
	}

	function closePopup() {
		vm.ManuMultiSelect.show=false;
		vm.popup = {};
	}


	function multiselectQueryVals(multiselect) {

		// unpack the vals multiselect into a list of entities to query

		var checklist = multiselect.list,
			vals = multiselect.vals;

		if(vals.length < 1) {
			return [];
		}
		else if(vals.length === 1 && vals[0] == 'ALL') {
			// using ALL checkbox, return all values except ALL checkbox
			var result = [],
				i = checklist[0].val == 'ALL' ? 1 : 0;
			for(i; i < checklist.length; i++) {
				result.push(checklist[i].val);
			}
			return result;
		}
		else {
			return vals;
		}
	}


	/**
	 *    HELPERS
	 */

	function multiselectMouseHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 2 seconds
					if(mouseLeave > 2000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}
	
	function toggleWait(isOn) {
		vm.isWaiting = !!isOn;
		msgSvc.wait(!!isOn);
	}
}
 
catalogsRepo.$inject = ['$rootScope', '$q', 'apiService', 'errSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
.module('espui.ops')
.factory('catalogsRepo', catalogsRepo);


/* @ngInject */
function catalogsRepo($rootScope, $q, apiService, errSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _currentPurl = '',
		_apiPaging = vmSvc.api.paging(),
		_pendingQuery,
		_modelPending,
		_listViewState = null;

	// service definition
	var service = {

		modelVM: modelVM,
		getList: getList,
		search: search,
		getReferenceNdc: getReferenceNdc,
		manufacturers: manufacturers,
		getOverride: getOverride,
		create: create,
		update: update,
		updateAssay : updateAssay,
		updateSpecialty : updateSpecialty,
		clone: clone,
		clear: clear,
		exportExcel:exportExcel,
		getAffSrchExcel : getAffSrchExcel,

		// no edi
		getNoEdiList: getNoEdiList,
		noEdiFileImport: noEdiFileImport,

		// aff search
		affSearch: affSearch

	};

	return service;


	/**
	 *    VIEW MODELS
	 */

	function bgFmt(dataBG) {

		// always convert incoming BrandGeneric to BRAND/GENERIC text

		// default
		if(!validSvc.isText(dataBG)) {
			dataBG = 'BRAND';
		}

		switch(dataBG) {
			case 'B':
			case 'BRAND':
				return 'BRAND';
			case 'G':
			case 'GENERIC':
				return 'GENERIC';
			default:
				throw new Error('catalogsCtl.bgFmt, value unknown: ' + dataBG);
		}
	}

	function modelVM(data) {

		data = data || {};

		return {
			Id: data.Id,
			Type: validSvc.isText(data.Type) ? data.Type : 'NEW',
			ObjectState: validSvc.newProp(validSvc.isText(data.ObjectState) ? data.ObjectState : 'ACTIVE'),
			Vendor: validSvc.newProp(validSvc.isVEN(data.Vendor) ? data.Vendor : 'NONE'),
			NDC: data.ItemCode ? validSvc.newProp(validSvc.isText(data.ItemCode) ? data.ItemCode : '') : validSvc.newProp(validSvc.isText(data.NDC) ? data.NDC : ''),
			OuterNDC: validSvc.newProp(validSvc.isText(data.ReplaceItemCode) ? data.ReplaceItemCode : ''),
			Description: validSvc.newProp(validSvc.isText(data.Description) ? data.Description : ''),
			Manufacturer: validSvc.newProp(validSvc.isText(data.Manufacturer) ? data.Manufacturer : ''),
			PkgSz: validSvc.newProp(validSvc.isNumber(data.PkgSz) ? data.PkgSz : null),
			CaseSz: validSvc.newProp(validSvc.isNumber(data.CaseSz) ? data.CaseSz : null),
			BrandGeneric: validSvc.newProp(bgFmt(data.BrandGeneric)),
			IsAssay: validSvc.newProp(data.IsAssay ? 'YES' : 'NO'),
			IsSpecialty: validSvc.newProp(data.IsSpecialty ? 'YES' : 'NO'),
			DrugEnfAdmCd: validSvc.newProp(validSvc.isNumber(data.DrugEnfAdmCd) ? data.DrugEnfAdmCd : 0),
			Price: validSvc.newProp(validSvc.isNumber(data.Price) ? data.Price : null)
		};

	}


	/**
	 *    GET
	 */

	function getReferenceNdc(ndc) {
		// params
		if(!validSvc.isText(ndc)) {
			throw new Error('catalogsRepo.get, ndc required');
		}

		_currentPurl = 'common/ndc/reference/get';
		var defer = $q.defer();

		var apiRequest = {
			Params: {
				NDC: ndc
			}
		};

		_pendingQuery = {NDC: ndc};
		apiService.post(_currentPurl, apiRequest).then(okRefNdc, errRefNdc);

		function okRefNdc(r) {
			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + ' repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// empty?
			if(r.data.Entity.ItemCode != _pendingQuery.NDC) {
				errRefNdc(null);
				return;
			}
			
			defer.resolve(r.data.Entity);
		}

		function errRefNdc(r) {
			defer.reject(null);
		}

		return defer.promise;
	}


	function getList(venid) {

		_currentPurl = 'ops/catalogs/overrides/list';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {},
			Paging: {
				Page: 1,
				Size: 10000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('NDC')]
		};

		apiService.post(_currentPurl, apiReqest).then(okGetList, errGetList);

		function okGetList(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({
				Items: r.data.Entity,
				TooMany: r.data.Paging.Size > 10000
			});

		}

		function errGetList(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	
	function manufacturers() {
		_currentPurl = 'common/ndc/manufacturers';
		var defer = $q.defer();

		apiService.post(_currentPurl, {}).then(okSearch, errSearch);


		function okSearch(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			var items = Array.isArray(r.data.Entity) ? r.data.Entity : [];

			defer.resolve({
				Items: items,
				TooMany: items.length > 10000
			});

		}

		function errSearch(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}
		return defer.promise;
	}
	/**
	 *    SEARCH CATALOG
	 */

	 function exportExcel(query) {
		var searchType = validSvc.isText(query.SearchType) ? query.SearchType : 'NDC';
		_currentPurl = 'common/ndc/manufacturers/excel';
		var defer = $q.defer();

		var apiRequest = {
			Params: {
				SearchType: searchType,
				GPI: searchType == 'GPI' ? query.GPI.val : '',
				NDC: searchType == 'NDC' ? query.NDC.val : '',
				Description: searchType == 'NDC' ? query.Desc.val : '',
				Manufacturer: query.Manufacturer,
			},
			Paging: {
				Page: 1,
				Size: 10000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle(searchType)]
		};
		// call api
		apiService.postGetBinary(_currentPurl, apiRequest).then(okGetExcel, errGetExcel);

		function okGetExcel(r) {
			defer.resolve(r.data);
		}

		function errGetExcel(r) {
			if(r !== null) {
				r = r || {};
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}
	function getAffSrchExcel(query,filename) {
		// params
		if(!!!query || !validSvc.isText(filename)) {
			throw new Error('catalogsrepo.getAffSrchExcel, query and filename required');
		}

		var defer = $q.defer();
		_currentPurl = 'ops/catalogs/aff/excel';
		var venList = query.VEN == 'ALL' ? [] : [query.VEN];
		var apiRequest = {
			Context: {
				CEID: [query.CE],
				RXID: [query.RX],
				VENID: venList
			},
			Params: {
				ItemCode: query.ItemCode,
				Desc: query.Desc,
				VenItemNum: query.VenItemNum
			},
			Paging: {
				Page: 1,
				Size: 10000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('ItemCode')]
		};
		apiService.postGetBinary(_currentPurl, apiRequest).then(okAffExcel, errAffExcel);

		function okAffExcel(r) {
			defer.resolve(r.data);
		}

		function errAffExcel(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}
		return defer.promise;		
	}


	function search(query) {
		var searchType = validSvc.isText(query.SearchType) ? query.SearchType : 'NDC';
		_currentPurl = 'common/ndc/search';
		var defer = $q.defer();

		// create api request

		var apiReqest = {
			Params: {
				SearchType: searchType,
				GPI: searchType == 'GPI' ? query.GPI.val : '',
				NDC: searchType == 'NDC' ? query.NDC.val : '',
				Description: searchType == 'NDC' ? query.Desc.val : '',
				Manufacturer: searchType == 'NDC' ? query.Manufacturer:[] 
			},
			Paging: {
				Page: 1,
				Size: 10000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle(searchType)]
		};

		apiService.post(_currentPurl, apiReqest).then(okSearch, errSearch);


		function okSearch(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			var items = Array.isArray(r.data.Entity) ? r.data.Entity : [];

			defer.resolve({
				Items: items,
				TooMany: items.length > 10000
			});

		}

		function errSearch(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    GET OVERRIDE
	 */

	function getOverride(id) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('catalogsRepo.getOverride, id required');
		}

		_currentPurl = 'ops/catalogs/overrides/get';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {},
			Params: {
				Id: id
			}
		};

		// call api
		apiService.post(_currentPurl, apiReqest).then(okGetDetail, errGetDetail);

		function okGetDetail(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errGetDetail(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    CREATE / UPDATE
	 */

	function create(model) {
		return upsert('ops/catalogs/overrides/new', model);
	}

	function update(model) {
		return upsert('ops/catalogs/overrides/save', model);
	}

	function upsert(purl, model) {

		_currentPurl = purl;
		_modelPending = model;
		var defer = $q.defer();

		var apiRequest = {
			Entity: {
				Id: model.Id,
				ObjectState: model.ObjectState.val,
				Vendor: model.Vendor.val,
				NDC: model.NDC.val,
				Description: model.Description.val,
				Manufacturer: model.Manufacturer.val,
				PkgSz: model.PkgSz.val,
				CaseSz: model.CaseSz.val,
				IsAssay: model.IsAssay.val == 'YES' ? true : false,
				IsSpecialty: model.IsSpecialty.val == 'YES' ? true : false,
				BrandGeneric: model.BrandGeneric.val == 'BRAND' ? 'B' : 'G', // reduce to 'B' or 'G'
				DrugEnfAdmCd: parseInt(model.DrugEnfAdmCd.val),
				Price: model.Price.val,
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(upsertOk, upsertErr);

		function upsertOk(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function upsertErr(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapApiErrorsToModel(r, _modelPending);
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);
				if(fieldObj === undefined) {
					throw new Error('catalogsRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
				}

				// set failed state
				fieldObj.fail = 'yes';
				fieldObj.msg = entity.Fields[i].Rule;

			}

			return m;

		}


		return defer.promise;
	}


	function updateAssay(model) {
		_currentPurl = "ops/catalogs/overrides/updateassay";
		_modelPending = model;
		var defer = $q.defer();

		var apiRequest = {
			Entity: {
				Id: model.Id,
				NDC: model.NDC,
				IsAssay: model.IsAssay == 'YES' ? false : true,
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(upsertOk, upsertErr);

		function upsertOk(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function upsertErr(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapApiErrorsToModel(r, _modelPending);
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);
				if(fieldObj === undefined) {
					throw new Error('catalogsRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
				}

				// set failed state
				fieldObj.fail = 'yes';
				fieldObj.msg = entity.Fields[i].Rule;

			}

			return m;

		}


		return defer.promise;
	}

	function updateSpecialty(model) {
		_currentPurl = "ops/catalogs/overrides/updatespecialty";
		_modelPending = model;
		var defer = $q.defer();

		var apiRequest = {
			Entity: {
				Id: model.Id,
				NDC: model.NDC,
				IsSpecialty: model.IsSpecialty == 'YES' ? false : true,
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(upsertOk, upsertErr);

		function upsertOk(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function upsertErr(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapApiErrorsToModel(r, _modelPending);
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);
				if(fieldObj === undefined) {
					throw new Error('catalogsRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
				}

				// set failed state
				fieldObj.fail = 'yes';
				fieldObj.msg = entity.Fields[i].Rule;

			}

			return m;

		}


		return defer.promise;
	}

	/**
	 *    GET NO EDI LIST
	 */

	function getNoEdiList(query) {

		_currentPurl = 'ops/catalogs/affmanual/list';
		var defer = $q.defer();

		// params
		if(!validSvc.isCE(query.CE) || !validSvc.isRX(query.RX) || !validSvc.isEntity(query.VEN)) {
			errSvc.warn('CE,RX,VEN required', _currentPurl + '/repo', '', query);
			defer.reject(null);
			return;
		}

		$rootScope.$emit('espui>context.change', {CE: query.CE, RX: query.RX});

		// create api request
		var apiReqest = {
			Context: {
				CEID: [query.CE],
				RXID: [query.RX],
				VENID: [query.VEN]
			},
			Paging: {
				Page: 1,
				Size: 10000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('EffectiveDate')]
		};

		apiService.post(_currentPurl, apiReqest).then(okGetNoEdiList, errGetNoEdiList);

		function okGetNoEdiList(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({
				Items: r.data.Entity,
				TooMany: r.data.Paging.Size > 10000
			});

		}

		function errGetNoEdiList(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    NO EDI FILE IMPORT
	 */

	function noEdiFileImport(query, importFile) {

		// params
		if(!validSvc.isCE(query.CE) || !validSvc.isRX(query.RX) || !validSvc.isVEN(query.VEN) || !validSvc.isText(query.ACCUMGRP) || !!!importFile) {
			throw new Error('catalogsRep.noEdiFileImport, required: CE/RX/VEN/ACCUMGRP and import file for: ' + query.CE + '/' + query.RX);
		}

		_currentPurl = 'ops/catalogs/affmanual/import';
		var defer = $q.defer();

		var apiRequest = {
			CEID: query.CE,
			RXID: query.RX,
			VENID: query.VEN,
			ACCUMGRP: query.ACCUMGRP
		};

		// create multi-part form data
		var fd = new FormData();
		fd.append('context', angular.toJson(apiRequest)); // stringify JSON into one "context" property
		fd.append('file', importFile);

		apiService.postFile(_currentPurl, fd, false).then(okFileImport, errFileImport);

		function okFileImport(r) {

			// bad upsert response format
			if(!!!r || !!!r.data || !!!r.data.Entity) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errFileImport(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!!!r || !validSvc.isNumber(r.status) || !!!r.data) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status === 422) {
				r.importErrors = mapApiImportErrors(r.data.Entity);
				r.counts = {
					Processed: r.data.Entity.ProcessedCount,
					Received: r.data.Entity.ReceivedCount,
					Error: r.data.Entity.ErrorCount,
					Duplicate: r.data.Entity.DuplicateCount
				};
				defer.reject(r);
			}
			else {
				errSvc.error('Unexpected error', _currentPurl + 'transformRepo.errFileImport', r.status, utilSvc.http.safeResponse(r));
			}

		}

		function mapApiImportErrors(entity) {

			// map server 422 fields onto import error text lines

			if(Array.isArray(entity.RecordErrors) && entity.RecordErrors.length > 0) {
				return entity.RecordErrors;
			}
			else if(entity.ROOT.length > 0) {
				return [{Name: 'File Error', Rule: entity.ROOT.join(',')}];
			}
			else {
				throw new Error('catalogsRepo.422FileImport, Api returned no errors to display');
			}
		}

		return defer.promise;

	}


	/**
	 *    AFF SEARCH
	 */

	function affSearch(query) {

		_currentPurl = 'ops/catalogs/aff/search';
		var defer = $q.defer();

		// params
		if(!validSvc.isRX(query.RX)) {
			errSvc.warn('RX required', _currentPurl + '/repo', '', query);
			defer.reject(null);
			return;
		}

		$rootScope.$emit('espui>context.change', {CE: query.CE, RX: query.RX});

		// create api request
		var venList = query.VEN == 'ALL' ? [] : [query.VEN];
		var apiReqest = {
			Context: {
				CEID: [query.CE],
				RXID: [query.RX],
				VENID: venList
			},
			Params: {
				ItemCode: query.ItemCode,
				Desc: query.Desc,
				VenItemNum: query.VenItemNum,
				Account: query.Account,
				Manufacturer: query.Manufacturer,
				ExcludeUnknown: query.ExcludeUnknown,
				ExcludeStale: query.ExcludeStale,
			},
			Paging: {
				Page: 1,
				Size: 10000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('ItemCode')]
		};
		
		apiService.post(_currentPurl, apiReqest).then(okAffSearch, errAffSearch);

		function okAffSearch(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({
				Items: r.data.Entity,
				TooMany: r.data.Paging.Size > 2000
			});

		}

		function errAffSearch(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    CLONE CATALOG
	 */

	function clone(cloneFrom, cloneTo) {

		_currentPurl = 'ops/catalogs/affmanual/clone';
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [cloneFrom.CE],
				RXID: [cloneFrom.RX],
				VENID: [cloneFrom.VEN]
			},
			Params : {
				ACCUMGRP : cloneTo.AccumGrp,
				TO_CEID: cloneTo.CE,
				TO_RXID: cloneTo.RX,
				TO_VENID: cloneTo.VEN
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okClone, errClone);

		function okClone(r) {
			defer.resolve({});
		}

		function errClone(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				errSvc.error('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}

		}

		return defer.promise;
	}


	/**
	 *    CLEAR CATALOG
	 */

	function clear(q) {

		_currentPurl = 'ops/catalogs/clear';
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [q.CE.val],
				RXID: [q.RX.val],
				VENID: [q.VEN.val]
			},
			Params : {
				ACCUMGRP: q.AccumGrp.val
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okClear, errClear);

		function okClear(r) {
			defer.resolve({});
		}

		function errClear(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				errSvc.error('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}

		}

		return defer.promise;
	}

}
 
claimsDetailCtl.$inject = ['$state', '$scope', '$timeout', 'prefsRepo', 'sessionRepo', 'claimsRepo', 'utilSvc', 'errSvc', 'msgSvc', 'validSvc'];
angular
	.module('espui.ops')
	.controller('ClaimsDetailCtl', claimsDetailCtl);


/* @ngInject */
function claimsDetailCtl($state, $scope, $timeout, prefsRepo, sessionRepo, claimsRepo, utilSvc, errSvc, msgSvc, validSvc) {

	/*jshint validthis: true */
	var vm = this;

	// private props
	var _pagingEventListener = null,
		_tblViewEventListener = null;

	// inherit sorting and paging features
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addTableViews(vm);
	msgSvc.addHelpLink(vm);

	// tbl and filters
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.context = {};

	// popup
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;

	// table view
	vm.tblViewConfig = {};
	vm.tblView = {};

	// models
	vm.display = {};

	/**
	 *    EVENTS
	*/

	_pagingEventListener = $scope.$on('widget.paging.change', function (event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if (!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);
	});

	_tblViewEventListener = $scope.$on('widget.tblview.editor.change', function (event, evtData) {
		event.stopPropagation();

		switch (evtData.type) {

			case 'edit':
				openPopup(null, 'TBLVIEW');
				break;

			case 'close':
				closePopup();
				break;

			case 'load':
				// load specific view requested
				vm.tblView.current = evtData.id;
				$timeout(function () {
					tblViewReload(vm.query, true);
					// update user preference (delay the network call)
					$timeout(function () {
						if (vm.action == 'LIST' && !!vm.tblView && validSvc.isText(vm.tblView.current)) {
							prefsRepo.setCurrentTableView(vm.tblViewConfig.storageKey, vm.tblView.current).then(okCurrentTableView, errCurrentTableView);
						}
					}, 2000);
				}, 300);
				break;

			default:
				throw new Error('widget.tblview.editor.change, unknown event type: ' + evtData.type);
		}

	});

	$scope.$on('$destroy', function () {
		// clean up listener on destroy
		if (!!_pagingEventListener) {
			_pagingEventListener();
		}
		if (!!_tblViewEventListener) {
			_tblViewEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// get params
		var params = $state.params;
		if (!!!params || !validSvc.isText(params.id) || !!!params.claim) {
			throw new Error('claimsDetailCtl.init, missing params on route: ' + $state.current.name);
		}
		vm.query = {id: params.id};
		vm.claim = params.claim;
		vm.isVerity = $scope.User.Type == 'VERITY' || $scope.User.Type == 'VERITYSA';

		// table view
		vm.flt = vm.initFilters({
			Config: {
				Dates: ['RxWrittenDate', 'ServiceDate'],
				DateFmt: 'M/d/yyyy'
			},
			SortBy: ['ServiceDate']
		});

		vm.tblViewConfig = tblViewConfigSetup(tblViewSchemaVM());

		// load claim
		getClaimsDetail(params.id);
	}

	/**
	 *    GET LIST
	 */

	function getClaimsDetail(id) {

		vm.isWaiting = true;
		msgSvc.wait(true);
		claimsRepo.getDetail(id).then(okList, errList);

		function okList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.tbl = displayVM(r.Items, r.TooMany);
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.action = 'LIST';
			
			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: 'CLAIMSDETAIL',
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			tblViewReload(vm.query, false, true); // keep paging if possible
			vm.flt.Ready = true;
			vm.action = 'LIST';
		}

		function errList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if (!!r) {
				errSvc.warn('unknown error getting data', 'claims.getDetail', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}

	/**
	 *    VIEW MODEL
	 */

	function displayVM(dataItems, tooMany) {
		dataItems = Array.isArray(dataItems) ? dataItems : [];

		// clean up incoming data
		var item = {};
		for (var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			if (!!!vm.isVerity) {
				item.FilePath = '';
			}
			item.uniqueId = i.toString();
		}

		return {
			Items: [],
			DataItems: dataItems,
			TooMany: !!tooMany
		};
	}


	/**
 	 *  POPUP
 	 * 	used for TBLVIEW
 	 */

	function openPopup(item, popType, evt) {
		// multi-use popup, all popups re-use: vm.popup / openPopup / closePopup

		if (vm.isWaiting) {
			return;
		}

		switch (popType) {
			case 'LOG':
				popLog(item, evt);
				break;
			case 'TBLVIEW':
				popTblView(vm.activeTab);
				break;
			default:
				throw new Error('priceList.openPopup, unknown pop type: ' + popType);
		}
	}

	function popTblView(tabName) {
		vm.popup = {
			type: 'TBLVIEW',
			title: 'Table View Editor',
			ready: false
		};

		$scope.$broadcast('widget.tblview.editor', {
			uniqueId: 'CLAIMSDETAIL',
			scroll: true,
			config: vm.tblViewConfig
		});

		$timeout(function () {
			vm.popup.ready = true;
		}, 200);
	}

	function popLog(item, evt) {
		if (!!!item || !!!evt || !Array.isArray(item.ChangeLog)) {
			throw new Error('priceListCtl.openPopup popLog, item, click and log required');
		}

		vm.popup = {
			type: 'LOG',
			title: 'Activity Log',
			Items: item.ChangeLog,
			ready: false
		};

		// loop html element parents looking for popup container top
		// note: this is a scrollable table, reduce offset by amount the table is scrolled
		var elem = evt.target,
			scrollTopFound = false,
			offsetY = 30;
		while (!!elem) {

			// top element found
			if (!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
				break;
			}

			// scroll container found, reduce offset if this container is scrolled
			if (!scrollTopFound && !!elem.className && elem.className.indexOf('table-fixed-header-scroll') > -1) {
				scrollTopFound = true;
				offsetY -= Math.floor(elem.scrollTop);
			}

			// add offset, get next element
			offsetY += elem.offsetTop;
			elem = elem.offsetParent;
		}
		elem = null;

		// move popup to clicked row
		var popContent = document.getElementById('pricePopupContentLOG');
		if (!!popContent) {
			popContent.style.top = offsetY.toString() + 'px';
		}

		$timeout(function () {
			vm.popup.ready = true;
		}, 200);
	}

	function closePopup() {
		var popType = vm.popup.type;
		vm.popup = {};

		// refresh list view coming back from detail view
		if (popType == 'DETAIL') {
			querySubmit();
		}
		else if (popType == 'TBLVIEW') {
			tblViewReload(vm.query, false, true); // re-init views, keep paging if possible
		}
	}

	/**
	 * 		TABLE VIEW
	 */

	function okCurrentTableView() {
		if (vm.action != 'LIST') {
			return;
		}

		var tvSaved = sessionRepo.get(vm.tblViewConfig.storageKey);
		if (!!tvSaved && !!vm.tblView && validSvc.isText(vm.tblView.current)) {
			tvSaved.current = vm.tblView.current;
			sessionRepo.set(vm.tblViewConfig.storageKey, tvSaved);
		}
	}

	function errCurrentTableView() {
		// do nothing
	}

	function tblViewReload(query, skipInitViews, fltKeepPaging) {

		if (!!!query) {
			return;
		}

		// init tblView with full view config
		if (!!!skipInitViews || !!!vm.tblView) {
			vm.tblView = vm.tblViewInit(vm.tblViewConfig, sessionRepo.get(vm.tblViewConfig.storageKey));
		}

		// reduce tblConfig based on query
		var tblConfig = tblViewConfigSetup(tblViewSchemaVM());

		// add column titles and filters
		vm.tblView = vm.tblViewLoadTitlesAndFilters(tblConfig, vm.tblView, vm.flt);

		// update table view bar
		$scope.$broadcast('widget.tblview', {
			uniqueId: 'CLAIMSDETAIL',
			current: vm.tblView.current,
			views: vm.tblView.views
		});

		if (!!vm.flt) {
			// remove any filter properties not shown in current table view
			vm.flt = vm.tblViewSyncFilter(tblConfig, vm.tblView, vm.flt, fltKeepPaging);
			filterChange(true);
		}
	}

	function tblViewSchemaVM() {
		// feature defined tables with all columns

		return {
			storageKey: 'tv-ops-claims-detail',
			name: 'LIST',
			sortby: '-ServiceDate',
			pgsize: 50,
			sections: {
				Trans: { title: 'Transaction' },
				Drug: { title: 'Drug Info' },
				Claim: { title: 'Claim' },
				Patient: { title: 'Patient' },
				Financials: { title: 'Claim Financials' },
				Codes: { title: 'Claim Codes' },
				Details: { title: 'Details' },
			},
			cols: [
				{ section: 'Trans', flt: 'Text', edit: false, name: 'TransactionType', colWidth: "35px", title: 'Transaction Type', desc: 'Claim Billing Transaction Type' },
				{ section: 'Trans', flt: 'Dates', edit: false, name: 'CreateDate', colWidth: "45px", title: 'Create Date', desc: 'Claim imported date' },

				{ section: 'Drug', flt: 'Text', edit: false, name: 'ItemCode', colWidth: "45px", title: 'NDC', desc: 'NDC' },
				{ section: 'Drug', flt: 'Text', edit: false, name: 'Description', colWidth: "45px", title: 'Description', desc: 'Description' },
				{ section: 'Drug', flt: 'Text', edit: false, name: 'DrugType', colWidth: "45px", title: 'Drug Type', desc: 'Drug Type' },

				{ section: 'Claim', flt: 'Text', default: false, name: 'OpaId', colWidth: "45px", title: 'OPA ID', desc: 'OPA ID' },
				{ section: 'Claim', flt: 'Text', name: 'ProviderNPI', colWidth: "45px", title: 'Provider NPI', desc: 'Provider NPI' },
				{ section: 'Claim', flt: 'Text', name: 'ProviderName', colWidth: "45px", title: 'Provider Name', desc: 'Provider Name' },
				{ section: 'Claim', flt: 'Text', name: 'RxNumber', colWidth: "45px", title: 'Rx #', desc: 'Rx Number' },
				{ section: 'Claim', flt: 'Dates', name: 'RxWrittenDate', colWidth: "45px", title: 'Written Date', desc: 'Rx written date' },
				{ section: 'Claim', flt: 'Dates', name: 'ServiceDate', colWidth: "45px", title: 'Filled Date', desc: 'Service date' },
				{ section: 'Claim', flt: 'Numbers', name: 'FillNum', colWidth: "45px", title: 'Fill #', desc: 'Fill #' },
				{ section: 'Claim', flt: 'Numbers', name: 'Quantity', colWidth: "45px", title: 'Quantity', desc: 'Quantity' },
				{ section: 'Claim', flt: 'Numbers', default: false, name: 'SupDays', colWidth: "45px", title: 'Sup Days', desc: 'Sup Days' },
				{ section: 'Claim', flt: 'Dates', default: false, name: 'ProcessDate', colWidth: "45px", title: 'Process Date', desc: 'Process Date' },

				{ section: 'Patient', flt: 'Text', default: false, name: 'PatientLN', colWidth: "45px", title: 'Patient Last Name', desc: 'Patient Last Name' },
				{ section: 'Patient', flt: 'Text', default: false, name: 'PatientFN', colWidth: "45px", title: 'Patient First Name', desc: 'Patient First Name' },
				{ section: 'Patient', flt: 'Dates', default: false, name: 'DateOfBirth', colWidth: "45px", title: 'DOB', desc: 'Date Of Birth' },
				{ section: 'Patient', flt: 'Text', default: false, name: 'BinPcnFormatted', colWidth: "45px", title: 'Payor Details', desc: 'BIN, PCN, GRP' },

				{ section: 'Financials', flt: 'Numbers', default: false, name: 'PatientPaid', colWidth: "45px", title: 'Patient Paid', desc: 'Patient Paid' },
				{ section: 'Financials', flt: 'Numbers', default: false, name: 'TotalPaid', colWidth: "45px", title: 'Total Paid', desc: 'Total Paid' },
				{ section: 'Financials', flt: 'Numbers', default: false, name: 'IngredientCostSubmitted', colWidth: "45px", title: 'Ingr Cost Sub', desc: 'Ingredient Cost Submitted' },
				{ section: 'Financials', flt: 'Numbers', default: false, name: 'IngredientCostPaid', colWidth: "45px", title: 'Ingr Cost Pd', desc: 'Ingredient Cost Paid' },
				{ section: 'Financials', flt: 'Numbers', default: false, name: 'CustomaryCharge', colWidth: "45px", title: 'U&C', desc: 'Usual and Customary Charge' },

				{ section: 'Codes', flt: 'Text', default: false, name: 'SubmissionClarificationCode', colWidth: "45px", title: 'Sub Code', desc: 'Submission Clarification Code' },
				{ section: 'Codes', flt: 'Text', default: false, name: 'SubmissionClarificationCount', colWidth: "45px", title: 'Sub Code Ct', desc: 'Submission Code Count' },
				{ section: 'Codes', flt: 'Text', default: false, name: 'BasisOfCost340BCode', colWidth: "45px", title: 'Basis Cost', desc: 'Basis of Cost Determine' },
				{ section: 'Codes', flt: 'Text', default: false, name: 'BasisOfReimbursementDetermination', colWidth: "45px", title: 'Basis Reimb', desc: 'Basis of Reimbursement' },

				{ section: 'Details', flt: 'Text', default: false, name: 'FilePath', colWidth: "45px", title: 'File name', desc: 'File name' },
			]
		};
	}

	function tblViewConfigSetup(tblSchema) {
		// placeholder to convert generic view schema into user specific table configs

		var result = {},
			cols = tblSchema.cols,
			col = {},
			colKeys = {},
			colAllowed = [];

		for (var i = 0; i < cols.length; i++) {
			col = cols[i];

			// tbd... logic to drop columns based on user type, query, biz models, etc

			// keep column
			colAllowed.push(col.name);
			colKeys[col.name] = col;
		}

		// update columns for this table
		tblSchema.cols = colAllowed;
		tblSchema.colKeys = colKeys;

		return tblSchema;
	}


	/**
	 *    FILTER CHANGE
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if (!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if (vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function () {

			// filter values are stored inside table view columns
			vm.flt = vm.tblViewGetColumnFilterValues(vm.tblView.cols, vm.flt);

			vm.tbl.DataItems = Array.isArray(vm.tbl.DataItems) ? vm.tbl.DataItems : [];
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if (vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			$scope.$broadcast('widget.paging', {
				uniqueId: 'CLAIMSDETAIL',
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});
		}, delayTime);
	}
}
 
claimsListCtl.$inject = ['$window', '$state', '$scope', '$timeout', 'claimsRepo', 'locationsRepo', 'lookupRepo', 'sessionRepo', 'prefsRepo', 'rxRepo', 'reportRepo', 'msgSvc', 'utilSvc', 'validSvc', 'errSvc'];
angular
	.module('espui.ops')
	.controller('ClaimsListCtl', claimsListCtl);

/* @ngInject */
function claimsListCtl($window, $state, $scope, $timeout,claimsRepo, locationsRepo, lookupRepo, sessionRepo, prefsRepo, rxRepo, reportRepo, msgSvc, utilSvc, validSvc, errSvc) {

	/*jshint validthis: true */
	var vm = this,
		_routeInfo = null,
		_pendingExcelFilename = '',
		_featureName = '',
		_pagingEventListener = null,
		_datePickListener = null,
		_affs = [],
		_tblViewEventListener = null,
		_pickVisitEventListener = null;

	// ESI 
	var _isESI = false,
		_esiOpaIdMap = {}; // esi only: map an OPA ID to a list of covered entities for matching

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addTableViews(vm);
	utilSvc.ctl.addFlexTop(vm);

	// flex top
	vm.flex = {};
	vm.flexTopExpand = flexTopExpand;	

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.userCanViewPHI = false;
	vm.userCanMatch = false;
	vm.userType = $scope.User.Type;

	// claim query droplists
	vm.RxDroplist = [];
	vm.CeSavingsDroplist = [];
	vm.VenSavingsDroplist = [];

	// claims list query
	vm.query = {};
	vm.queryChangeRX = queryChangeRX;
	vm.queryChangeAccumType = queryChangeAccumType;
	vm.queryChangeSavingsCE = queryChangeSavingsCE;
	vm.queryChangeSavingsVEN = queryChangeSavingsVEN;
	vm.queryChangeIncludeMatched = queryChangeIncludeMatched;
	vm.queryChangeIncludeSavings = queryChangeIncludeSavings;
	vm.queryChangeReviewed = queryChangeReviewed;
	vm.queryChangeRxOptions = queryChangeRxOptions;
	vm.dateRangeChange = dateRangeChange;
	vm.querySubmit = querySubmit;
	
	// claim list and excel
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;
	vm.getExcel = getExcel;
	
	// match popup
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;
	
	// match model and methods
	vm.match = {};
	vm.MatchCeDroplist = [];
	vm.MatchLocationDroplist = [];
	vm.dtPickShow = {};
	vm.dtPickOpen = dtPickOpen;
	vm.modelChangeMatchCE = modelChangeMatchCE;
	vm.modelChangeMatchLOC = modelChangeMatchLOC;
	vm.createMatch = createMatch;

	// table view
	vm.tblViewConfig = {};
	vm.tblView = {};
	vm.popupTblView = {};
	vm.openPopupTblView = openPopupTblView;
	vm.closePopupTblView = closePopupTblView;

	// claim detail popup
	vm.popupClaimDetail = {};
	vm.openPopupDetail = openPopupDetail;
	vm.closePopupDetail = closePopupDetail;

	// claim bulk match
	vm.popupClaimBulkMatch = {};
	vm.openPopupBulkApprove = openPopupBulkApprove;
	vm.closePopupBulkApprove = closePopupBulkApprove;
	vm.confirmBulkMatch = confirmBulkMatch;

	// async
	vm.asyncReports = initAsyncReports();
	vm.toggleAsyncReports = toggleAsyncReports;	
	vm.createAffAsyncExcel = createAffAsyncExcel;

	// bulk matching
	vm.bulkMatchList = [];
	vm.bulkCreateMatchToggleList = bulkCreateMatchToggleList;
	vm.bulkCreateMatchToggleItem = bulkCreateMatchToggleItem;
	vm.bulkCreateMatchSubmit = bulkCreateMatchSubmit;

	// review
	vm.reviewClaim = reviewClaim;

	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function (event, evtData) {
		event.stopPropagation();

		// ignore non-claims table events
		if(evtData.uniqueId != 'CLAIMS') {
			return;
		}

		// exit if table is gone
		if (vm.action != 'LIST' || !vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);
	});

	/**
	 *    SEND TO TPA
	 */

	function bulkCreateMatchToggleList(action) {
		if (vm.isWaiting) {
			return;
		}

		var dataItems = Array.isArray(vm.tbl.Items) ? vm.tbl.Items : [];
		var filteredMap = {};
		if (action == 'ALL') {
			// select all filtered items without paging
			var flt = JSON.parse(JSON.stringify(vm.flt)); // de-ref deep copy
			flt.PageSize = 10000000;
			var filteredItems = vm.filterList(dataItems, flt);

			// build map
			filteredItems.forEach(function (item) {
				if (item.State == 'NEW' || item.State == 'MANUAL') {
					filteredMap[item.uniqueId] = true;
				}
			});
		}

		var checked = action == 'ALL';
		vm.bulkMatchList = [];

		// set data items and rebuild cloneTo items
		dataItems.forEach(function (item) {
			item.checked = checked;
			if (checked && !!filteredMap[item.uniqueId]) {
				vm.bulkMatchList.push(matchVM(item));
			}
		});
	}

	function bulkCreateMatchToggleItem(item, event) {
		if (!!event) {
			event.stopPropagation();
		}

		if (vm.isWaiting || !item) {
			return;
		}

		// find and toggle item
		var listItem = vm.tbl.Items.find(function (l) {
			return l.uniqueId == item.uniqueId;
		});
		listItem.checked = !!!item.checked;

		// modify cloneTo list
		if (listItem.checked) {
			// add item
			vm.bulkMatchList.push(matchVM(item));
		}
		else {
			// remove item
			vm.bulkMatchList = vm.bulkMatchList.filter(function (senditem) {
				return senditem.uniqueId != item.uniqueId;
			});
		}
	}

	function matchVM(item) {
		return {
			uniqueId: item.uniqueId,
			Id: item.Id,
		};
	}

	function bulkCreateMatchSubmit() {
		if (vm.isWaiting) {
			return;
		}

		msgSvc.confirm({
			id: 'ops.claims.bulk.match.confirm',
			title: vm.popup.title,
			msg: 'Confirm bulk match(es) selected.',
			notes: {
				prompt: 'optional notes',
				maxlength: 150,
				out: ''
			},
			buttons: [
				{ text: 'OK', result: 'YES', cancel: false },
				{ text: 'CANCEL', result: 'CANCEL', cancel: true }
			]
		}).then(userConfirmedMatch, userConfirmedMatch);


		function userConfirmedMatch(r) {
			vm.isWaiting = false;

			// user said yes
			if (!!r && r.result === 'YES') {
				wait(true);
				var notes = validSvc.isText(r.notes) ? r.notes : '';

				vm.isWaiting = true;
				var matches = [];
				for (var i = 0; i < vm.bulkMatchList.length; i++) {
					matches.push(vm.bulkMatchList[i].Id);
				}
				claimsRepo.bulkCreateMatch(matches, '', notes).then(okCreateMatch, errCreateMatch);
			}
		}
	}

	function okCreateMatch(r) {
		wait(false);
		closePopup();

		msgSvc.ok('Bulk Match Created');


		querySubmit();
	}

	function errCreateMatch(r) {
		wait(false);

		if (!!r) {
			if (r.status === 409) {
				msgSvc.ok('Cannot Create Match', 'Refreshing list due to api conflict 409 error');
				closePopup();
				querySubmit();
			}
			else if (r.status === 422) {
				vm.match = r.model;
				msgSvc.ok('Cannot Create Match', 'Check property values');
			}
			else {
				// unknown error
				errSvc.warn('Unknown error during Bulk Create Match', 'claimsListCtl.BulkCreateMatch', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	/**
	 *    DATE PICKER EVENT
	 */

	_datePickListener = $scope.$on('widget.input.date.pick.change', function (event, evtData) {
		event.stopPropagation();

		// params
		if (!!!evtData || !!!vm.query || !!!vm.popup || !!!vm.match || !validSvc.isText(evtData.uniqueId)) {
			alert('claimsListCtl.datePickEvt, evtData and uniqueId required');
			return;
		}
		var id = evtData.uniqueId;
		if (id != 'EncounterDate' && id != 'EncounterDateOfBirth' && id!= 'PatientDateOfBirth') {
			alert('claimsListCtl.datePickEvt, uniqueId unknown: ' + id);
			return;
		}

		vm.dtPickShow[id] = false;
		if (id == 'PatientDateOfBirth') {
			vm.query[id].val = evtData.setDate;	
		} else {
			vm.match[id].val = evtData.setDate;	
		}
		
	});


	/**
	 *    TABLE VIEW EVENT
	 */

	_tblViewEventListener = $scope.$on('widget.tblview.editor.change', function(event, evtData) {
		event.stopPropagation();

		switch(evtData.type) {

			case 'edit':
				openPopupTblView();
				break;

			case 'close':
				closePopupTblView();
				break;

			case 'load':
				// load specific view requested
				vm.tblView.current = evtData.id;
				$timeout(function() {
					tblViewReload(true);

					// update user preference (delay the network call)
					$timeout(function() {
						if(vm.tblViewConfig && !!vm.tblView && validSvc.isText(vm.tblView.current)) {
							prefsRepo.setCurrentTableView(vm.tblViewConfig.storageKey, vm.tblView.current).then(okCurrentTableView, errCurrentTableView);
						}
					}, 2000);
				}, 300);
				break;

			default:
				throw new Error('widget.tblview.editor.change, unknown event type: ' + evtData.type);
		}

	});


	/**
	 *    	VISIT PICK EVENT
	 * 		event sent by visit feature when user picks a visit (Encounter) to match
	 */

	 _pickVisitEventListener = $scope.$on('ops.claims.visit-pick', function (event, evtData) {
		event.stopPropagation();

		// popup is gone already
		if(vm.isWaiting || !vm.popup.ready || vm.popup.type != 'SEARCH' ||
			!!!vm.match || vm.match.type != 'SEARCH' || !!!evtData) {
			return;
		}

		// load params into model
		var visit = evtData;
		vm.match.CE.val = visit.CE;
		vm.match.EncounterId = visit.Id;

		createMatch();
	});


	$scope.$on('$destroy', function () {
		// clean up listener on destroy
		if (!!_pagingEventListener) {
			_pagingEventListener();
		}
		if (!!_datePickListener) {
			_datePickListener();
		}
		if(!!_tblViewEventListener) {
			_tblViewEventListener();
		}
		if(!!_pickVisitEventListener) {
			_pickVisitEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		_featureName = $state.current.name;

		vm.init = true;
		vm.action = '';
		vm.userCanViewPHI = utilSvc.user.hasFeature($scope, 'ops.dispenses.phi');
		vm.userCanMatch = utilSvc.user.hasFeature($scope, 'ops.dispenses.match');
		vm.userCanBulkMatch = utilSvc.user.hasFeature($scope, 'ops.dispenses.bulk.matches');
		vm.flex = vm.flexInit();

		// setup tableview
		vm.tblViewConfig = tblViewConfigSetup(tblViewSchemaVM(vm.userCanViewPHI));

		// load query defaults and viewstate
		vm.dtPickShow = initDatePicker();
		initQueryAndFilters();

		// ASYNC: get more info to setup user specific affs
		loadAffInfo();
	}

	function initQueryAndFilters() {
		// note: view state depricated per Georgia

		vm.query = claimsRepo.queryVM();

		// query date range (max 30 days)
		vm.query.DateRangeValid = false;
		vm.query.DateRangeMode = 'MTD';
		vm.query.DateRangeList = utilSvc.widget.dateRangeList(['QTD', 'QTR', 'QTDLAST', 'CUSTOM92']);
		vm.query.DateRangeList.push({ label: 'Custom Date Range (30 day max)', value: 'CUSTOM30' });

		vm.flt = vm.initFilters({
			Config: {
				Dates: ['RxWrittenDate', 'ServiceDate'],
				DateFmt: 'M/d/yyyy'
			},
			SortBy: ['ServiceDate']
		});
	}
	
	function loadAffInfo() {
		wait(true);
		
		_affs = getAffs(vm.query.isVerity);
		if(_affs.length < 1) {
			// user has no valid affs
			noPharmaciesExit();
			return;
		}

		if (vm.query.isCeUser) {
			// CE user needs affiliation level lookups
			lookupRepo.AffInfo(utilSvc.aff.ceList(_affs), utilSvc.aff.rxList(_affs)).then(okAffLookup, errLoadAffInfo);
		}
		else {
			// for all other users only extra CE info is needed to get the CeOwnUseProgram property
			lookupRepo.CeInfo(utilSvc.aff.ceList(_affs)).then(okCeLookup, errLoadAffInfo);
		}
		
		function okAffLookup(r) {
			wait(false);

			_affs = buildCeUserAffs(_affs, r);
			if(_affs.length < 1) {
				// user has no viewable affs
				noPharmaciesExit();
				return;
			}

			initFinalize();
		}

		function noPharmaciesExit(affs) {
			// cannot continue, show user message and go to home page
			msgSvc.okAsync('Pharmacies Not Available', 'None of your affiliations allow Claim Viewing functionality. Contact your Verity administrator.', 'ops.claims.norx').then(goHome, goHome);
		}
		
		function okCeLookup(r) {
			wait(false);
			_affs = buildUserAffs(_affs, r);

			// add non-affiliated pharmacies to affs array
			// note rx list api call is SLOW
			if(vm.query.isVerity && vm.query.RxOptions == 'all') {
				rxRepo.getList().then(okRxList, errLoadAffInfo);
			}
			else {
				initFinalize();
			}
		}

		function okRxList(r) {
			wait(false);
			r = r || {};
			_affs = addPharmaciesToAffs(_affs, r.data);
			initFinalize();
		}
		
		function errLoadAffInfo(r) {
			wait(false);
			if(!!r) {
				errSvc.error('Cannot get Claim query options', 'ops.claims.list.errLoadAffInfo', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function buildCeUserAffs(affs, affInfoList) {
		// CE user affiliation list with extra details for ESI, match permissions, OWN accounts, CeOwnUseProgram, OwnedPharmacy, etc
		console.log('build CE user affs');
		_isESI = false;

		var result = [],  // affiliations which will create pharmacy droplist
			affInfo = {},
			permInfo = {},
			addAff = {};

		// loop affilition lookups
		affInfoList = Array.isArray(affInfoList) ? affInfoList : [];
		for (var i = 0; i < affInfoList.length; i++) {
			affInfo = affInfoList[i];

			// has view permissions
			permInfo = parsePermissions(affInfo.FeatureClaims);
			if(permInfo.canView) {

				// get aff entry in global affs (need the full aff for droplists, etc)
				addAff = findAff(affs, affInfo.CEID, affInfo.RXID);
				if(!!!addAff) {
					// this is expected
					// aff lookup returns ALL affiliations for an RX and CE, including INACTIVE / ONBOARDING
					console.log('Claims feature cannot find affilation for: ' + affInfo.RXID + '/' + affInfo.CE);
					continue;
				}

				// ESI
				addAff.ESI = !!affInfo.ExpressScriptsCustomer;
				if(!_isESI && addAff.ESI) {
					// flag CE user as ESI if ANY affiliation they can view is ESI
					_isESI = true;
				}

				// match permission
				addAff.canMatch = permInfo.canMatch;

				// Own Use Program
				addAff.OwnUseProgram = !!affInfo.CeOwnUseProgram;

				// OwnedPharmacy (In-House pharmacy is NOT the same as Own Use Program above)
				addAff.OwnedPharmacy = !!affInfo.CeOwnedPharmacy;

				result.push(addAff);
			}
		}

		return result;
	}

	function parsePermissions(permissions) {
		permissions = Array.isArray(permissions) ? permissions : [];

		var result = {
				canView: false,
				canMatch: false
			},
			perm = {},
			canView = false,
			canMatch = false;

		for (var i = 0; i < permissions.length; i++) {
			perm = permissions[i];
			if (!!perm.Allow) {

				// view permission for CE user
				if(perm.Claim == 'ops.dispenses' && perm.UserType == 'CE') {
					result.canView = true;
				}
				else if(perm.Claim == 'ops.dispenses.match') {
					// match permission (not user specific)
					result.canMatch = true;
				}

				// exit permissions loop if both found
				if(result.canView && result.canMatch) {
					return result;
				}
			}
		}

		// double check match needs view
		if(result.canMatch && !result.canView) {
			result.canMatch = false;
		}

		return result;
	}

	function buildUserAffs(affs, ceInfoList) {
		// build affs for non-CE users
		console.log('build non-CE user affs');

		var result = [],
			aff = {},
			i = 0,
			ceInfo = {},
			ownUseMap = {};

		// create map for own use
		ceInfoList = Array.isArray(ceInfoList) ? ceInfoList : [];
		for (i = 0; i < ceInfoList.length; i++) {
			ceInfo = ceInfoList[i];
			if(!!ceInfo.OwnUseProgram) {
				ownUseMap[ceInfo.NickName] = true;
			}
		}

		// de-reference global affs list to modify it
		result = JSON.parse(JSON.stringify(affs));
		for(i = 0; i < result.length; i++) {
			aff = result[i];
			aff.OwnUseProgram = !!ownUseMap[aff.CEID];
		}

		return result;
	}

	function addPharmaciesToAffs(affs, pharms) {
		// add unaffiliated pharmacies to _affs which drives RX dropdown
		// note, because there is no CEID on these pharmacy options all the other
		// dependent features like Pricing, OwnUse, etc will not be enabled on purpose
		pharms = Array.isArray(pharms) ? pharms : [];
		var featureModels = utilSvc.aff.rxModelsByFeature(_featureName);
		if(!Array.isArray(featureModels)) {
			featureModels = [];
		}

		var rxList = utilSvc.aff.rxList(affs),
			p = {},
			rxShortName = '';

		for (var i = 0; i < pharms.length; i++) {
			p = pharms[i];

			// not in current affs, DISPENSING, status good, feature models
			if(rxList.indexOf(p.Id) < 0 && typeOk(p.Type) && statusOk(p.ObjectState) && modelsOk(p.BusinessModels, featureModels)) {
				rxShortName = validSvc.isText(p.ShortName) ? p.ShortName : p.Id;
				affs.push({
					CEID: '',
					RXID: p.Id,
					RxShortName: rxShortName,
					AffState: p.ObjectState,
					RxType: p.Type,
					Ordering:[]
				});
			}
		}

		return affs;

		// helpers
		function typeOk(pType) {
			return pType == 'DISPENSING';
		}

		function statusOk(stat) {
			switch(stat) {
				case 'ACTIVE':
				case 'INACTIVE':
				case 'ONBOARDING':
					return true;
			}
			return false;
		}

		function modelsOk(models, featureModels) {
			models = Array.isArray(models) ? models : [];
			for(var i = 0; i < featureModels.length; i++) {
				if(models.indexOf(featureModels[i]) > -1) {
					return true;
				}
			}
			return false;
		}
	}

	function goHome() {
		$state.go('home');
	}

	function initFinalize() {
		console.log('init final');

		// RX options
		vm.RxDroplist = utilSvc.aff.rxDroplist(_affs);
		vm.query.RX = utilSvc.ng.droplistAutoselect(vm.RxDroplist, vm.query.RX.val);
		queryChangeRX();

		// fire date control sync event after html render
		$timeout(function () {
			$scope.$broadcast('widget.input.date.range.mode', { mode: vm.query.DateRangeMode, keepDates: false});
		}, 200);

		$timeout(function () {
			var ctx = angular.fromJson(angular.toJson($state.params || {}));
			if(!!ctx.dispid) {
				vm.query.RX.val = ctx.rx;
				vm.query.RX.fail = 'no';
				vm.query.DispId = ctx.dispid;
				querySubmit();
			}
		}, 500);
	}

	function getAffs(isVerity) {
		var affStatus = !!isVerity ? ['ACTIVE', 'INACTIVE', 'ONBOARDING'] : ['ACTIVE'];
		var affs = utilSvc.aff.findStatus($scope.User.AffList, affStatus);
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
		return utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));
	}

	function initDatePicker() {
		return {
			pending: '',
			EncounterDate: false,
			EncounterDateOfBirth: false,
			PatientDateOfBirth: false,
		};
	}


	/**
	 *    VIEW MODELS
	 */

	function claimListVM(dataItems, tooMany) {
		
		var item = {},
			canViewPHI = vm.userCanViewPHI,
			fName = '',
			canMatch = vm.query.canMatch == 'yes',
			regexApiDateFmt = utilSvc.regex.apiDateStringFmt();
		
		dataItems = Array.isArray(dataItems) ? dataItems : [];
		for (var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.uniqueId = i;

			// trim patient fname
			fName = validSvc.isText(item.PatientFN) ? item.PatientFN : '';
			item.PatientFN = fName;
			item.PatientFnTxt = fName.length > 6 ? fName.substr(0, 6) + '...' : fName;

			item.PrescriberName = validSvc.isText(item.PrescriberName) ? item.PrescriberName : 'n/a';
			item.DateOfBirth = canViewPHI ? utilSvc.dt.fromServerString(item.DateOfBirth, regexApiDateFmt) : null;

			// match this claim? CE user only
			item.canMatch = false;
			if (canMatch && (item.State == 'NEW' || item.State == 'MANUAL') && validSvc.isText(item.PrescriberIdent) && validSvc.isText(item.ItemCode)) {
				item.canMatch = true;
			}

			// change log
			item.Reviewed = !!item.Reviewed ? 'YES' : 'NO';
			item.ChangeLog = parseChangeLog(item.ChangeLog);
			item.hasLog = item.ChangeLog.length > 0;
			item.LastActivity = item.hasLog ? item.ChangeLog[0].Activity : '';
			item.IRA = !!item.IRAClaim ? 'YES' : 'NO';
			item.Rebate = !!item.MRebateClaim ? 'YES' : 'NO';	
		}

		return {
			DataItems: dataItems,
			Items: [], // loaded by filterChange()
			TooMany: !!tooMany
		};
	}

	function parseChangeLog(items) {
		if(!Array.isArray(items)) {
			return [];
		}

		var item = null;
		for(var i = 0; i < items.length; i++) {
			item = items[i];
			item.Activity = item.Status;
		}

		return items.reverse();
	}


	/**
	 * 		QUERY CHANGE
	 */

	 function queryChange() {
		if (!vm.init) {
			vm.action = '';
			vm.tbl = {};
			vm.flt = vm.resetFilters(vm.flt);
			vm.match = {};
			vm.popup = {};
			vm.popupTblView = {};
			vm.popupClaimDetail = {};
			vm.dtPickShow = initDatePicker();
			vm.flex = vm.flexInit();
			$scope.$broadcast('widget.paging', {uniqueId:'CLAIMS'});
		}
	}

	function queryChangeRX() {
		queryChange();
		vm.query.RX.fail = validSvc.isRX(vm.query.RX.val) ? 'no' : 'yes';

		if(vm.query.RX.fail == 'no') {
			// CE PHI user Only: at least 1 affiliation with match permission
			vm.query.canMatch = 'no';
			if(vm.query.isCeUser && vm.userCanViewPHI && vm.userCanMatch) {
				vm.query.canMatch = getAffsWithMatch(_affs, vm.query.RX.val).length > 0 ? 'yes' : 'no';
				if(vm.userCanBulkMatch) {
					vm.query.canBulkMatch = getAffsWithMatch(_affs, vm.query.RX.val).length > 0 ? 'yes' : 'no';
				}
			}

			// AccumType dependent (show if RX is affiliated to a CE with an OwnUseProgram)
			vm.query.showAccumType = hasOwnUseProgram(_affs, vm.query.RX.val) ? 'yes' : 'no';
			vm.query.AccumType = 'ALL';
			queryChangeAccumType();
		}
	}

	function queryChangeAccumType() {
		queryChange();

		// Price Savings dependent (show if 340B vendor account is available)
		vm.query.showSavings = 'no';
		vm.query.IncludeSavings = 'no';
		if(vm.query.AccumType != 'OWN') {
			if(getAffsWith340B(_affs, vm.query.RX.val).length > 0) {
				vm.query.showSavings = 'yes';
			}
		}
	}

	function queryChangeIncludeSavings() {
		queryChange();
	
		// CE Savings dependent
		vm.query.SavingsCE = validSvc.newProp('NONE');
		if(vm.query.IncludeSavings == 'yes') {
			var affsWith340B = getAffsWith340B(_affs, vm.query.RX.val);
			vm.CeSavingsDroplist = utilSvc.aff.ceDroplist(affsWith340B);
			vm.query.SavingsCE = utilSvc.ng.droplistAutoselectYesNo(vm.CeSavingsDroplist);
		}
		queryChangeSavingsCE();
	}

	function queryChangeSavingsCE() {
		queryChange();

		vm.query.SavingsCE.fail = validSvc.isCE(vm.query.SavingsCE.val) ? 'no' : 'yes';

		// Savings Vendor dependent
		vm.query.SavingsVEN = validSvc.newProp('NONE');
		if(vm.query.SavingsCE.fail == 'no') {
			var affsWith340B = getAffsWith340B(_affs, vm.query.RX.val, vm.query.SavingsCE.val);
			var venList = utilSvc.aff.venList(affsWith340B, ['340B'], true);
			vm.VenSavingsDroplist = utilSvc.ng.droplist(venList,'','',[{label:'Choose A Vendor',value:'NONE'}]);
			vm.query.SavingsVEN = utilSvc.ng.droplistAutoselectYesNo(vm.VenSavingsDroplist);
		}
		queryChangeSavingsVEN();
	}

	function queryChangeReviewed() {
		queryChange();
	}

	function queryChangeSavingsVEN() {
		queryChange();
		vm.query.SavingsVEN.fail = validSvc.isCE(vm.query.SavingsVEN.val) ? 'no' : 'yes';
	}

	function dateRangeChange(dtMode, isValid) {
		queryChange();
		vm.init = false;

		vm.query.DateRangeMode = dtMode;
		vm.query.DateRangeValid = isValid;
	}
	
	function queryChangeIncludeMatched() {
		queryChange();
	}

	function queryChangeRxOptions() {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		// toggle rx options if current value is not null (property change misfire)
		if(validSvc.isText(vm.query.RxOptions)) {
			vm.query.RxOptions = vm.query.RxOptions == 'affs' ? 'all' : 'affs';
			loadAffInfo();
		}
	}


	/**
	 * 	CLAIM LIST
	 */

	function queryValid(q) {
		q.RX.fail = validSvc.isRX(q.RX.val) ? 'no' : 'yes';

		// check Savings
		var savingsOK = true;
		if(q.showSavings == 'yes' && q.IncludeSavings == 'yes') {
			savingsOK = q.SavingsCE.fail == 'no' && q.SavingsVEN.fail == 'no';
		}

		q.RxNumber.fail = '';
		if(q.RxNumber.chk) {
			var rxnumb = q.RxNumber.val;
			if(!validSvc.isText(rxnumb) || rxnumb.length < 1) {
				q.RxNumber.fail = 'yes';
				q.RxNumber.msg = 'must be at least 1 character';
			}
		}

		q.ItemCode.fail = '';
		if(q.ItemCode.chk) {
			// ndc format check
			var ndcTest = ndcCleanUp(q.ItemCode.val, false);
			if(ndcTest.fail) {
				q.ItemCode.fail = 'yes';
				q.ItemCode.msg = ndcTest.msg;
			}
			else {
				q.ItemCode.val = ndcTest.val;
			}
		}

		q.NPI.fail = '';
		if (q.NPI.chk) {
			if (!validSvc.isText(q.NPI.val) || q.NPI.val.length < 3 || q.NPI.val.length > 15) {
				q.NPI.fail = 'yes';
				q.NPI.msg = 'NPI must be 3 to 15 characters';	
			}
		}

		q.PatientLN.fail = '';
		if(q.PatientLN.chk) {
			var lname = q.PatientLN.val;
			if(!validSvc.isText(lname) || lname.length < 1) {
				q.PatientLN.fail = 'yes';
				q.PatientLN.msg = 'must be at least 1 character';
			}
		}

		q.PatientDateOfBirth.fail = '';
		if(q.PatientDateOfBirth.chk) {
			q.PatientDateOfBirth = validSvc.propDateValid(q.PatientDateOfBirth);
			q.PatientDateOfBirth.fail = !!q.PatientDateOfBirth.fail ? 'yes' : 'no';	
		}

		q.Reviewed.fail = '';
		if(q.Reviewed.chk) {
			q.Reviewed.fail = !!!q.Reviewed.val ? 'yes' : 'no';
			vm.query.Reviewed.msg = 'required, choose Yes or No';
		}

		return q.RX.fail != 'yes' &&
			q.RxNumber.fail != 'yes' &&
			q.ItemCode.fail != 'yes' &&
			q.NPI.fail != 'yes' &&
			q.PatientLN.fail != 'yes' &&
			q.PatientDateOfBirth.fail != 'yes' &&
			q.Reviewed.fail != 'yes' &&
			savingsOK &&
			!!q.DateRangeValid;
	}

	function querySubmit() {

		if (!queryValid(vm.query)) {
			if (!vm.init) {
				msgSvc.ok('Search', 'Check filter properties');
			}
			return;
		}

		var affs = utilSvc.aff.findRxList($scope.User.AffList, [vm.query.RX.val]);
		affs = utilSvc.aff.findRxModel(affs, ['SPLITMATCH']);
		vm.hasSplitMatch =  !!affs && affs.length > 0;

		if (vm.isWaiting) {
			return;
		}
		wait(true);
		queryChange();
		vm.query.title = 'Pharmacy: ' + vm.query.RX.val;

		claimsRepo.getList(vm.query).then(okClaimList, errClaimList);

		function okClaimList(r) {
			wait(false);

			_esiOpaIdMap = esiBuildOpaIdMap(r.MatchOptions);

			vm.tbl = claimListVM(r.Disp.Items, r.Disp.TooMany);
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: 'CLAIMS',
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			vm.flt.Ready = true;
			vm.action = 'LIST';

			tblViewReload(false, true);
			vm.flex = vm.flexCollapse(vm.flex, true);
		}

		function errClaimList(r) {
			wait(false);
			if (!!r) {
				errSvc.error('Unknown get response', 'claimsListCtl.errQuerySubmit', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function esiBuildOpaIdMap(items) {
		// ESI map of OPA Ids and their CEs to match

		var result = {},
			item = {};

		items = Array.isArray(items) ? items : [];
		for (var i = 0; i < items.length; i++) {
			item = items[i];
			if (validSvc.isText(item.OPAID) && Array.isArray(item.CES)) {
				item.CES.sort();
				result[item.OPAID] = item.CES;
			}
		}
		return result;
	}

	function filterChange(immediate) {
		if (!vm.flt.Ready) {
			return;
		}
		vm.flt.Dirty = true;
		if (vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function () {

			// filter values are stored inside table view columns
			vm.flt = vm.tblViewGetColumnFilterValues(vm.tblView.cols, vm.flt);

			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if (vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: 'CLAIMS',
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

		}, delayTime);
	}
	

	/**
	 *    POPUP
	 */

	function closePopup() {
		vm.popup = {};
		vm.match = {};
	}

	function openPopup(evt, item, popType) {
		if(vm.isWaiting) {
			return;
		}
		evt.stopPropagation();

		// capture click event and item details
		vm.popup = {
			type: '',
			ready: false,
			action: '',
			item: item,
			offsetY: popupFixedTopOffset(evt.target, 20) // find position of fixed header
		};

		if (!!popType) {
			showPopup(popType);
			return;
		}

		if(_isESI) {
			// check this OPAID has Facilities to match
			if(!validSvc.isText(item.OpaId) || !!!_esiOpaIdMap[item.OpaId]) {
				vm.popup = {};
				msgSvc.ok('Cannot Match', 'There are no Facility options for OPAID: ' + item.OpaId);
				return;
			}
			showPopup('ESI-MATCH');
		}
		else {
			// prompt user if they want to match by CREATE or SEARCH
			msgSvc.confirm({
				id: 'ops.claims.match.type',
				title: 'Match Type',
				msg: 'Match Claim Options',
				buttons: [
					{ text: 'CREATE ENCOUNTER', result: 'CREATE', cancel: false },
					{ text: 'SEARCH', result: 'SEARCH', cancel: false },
					{ text: 'CANCEL', result: 'CANCEL', cancel: true }
				]
			}).then(popupMatchTypeConfirm, popupMatchTypeConfirm);
		}
	}

	function popupMatchTypeConfirm(r) {
		// non-ESI users can choose to create an Encounter or Search for one
		if (!!!r || r.result == 'CANCEL') {
			vm.popup = {};
		}

		if(r.result == 'CREATE') {
			showPopup('CREATE');			
		}
		else if(r.result == 'SEARCH') {
			showPopup('SEARCH');
		}
	}

	function popupFixedTopOffset(elem, offsetY) {
		// get top of fixed header relative to popup top

		// loop html element parents looking for popup container top
		// note: this is a scrollable table, reduce offset by amount the table is scrolled
		var scrollTopFound = false;
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
				break;
			}

			offsetY += elem.offsetTop - elem.scrollTop;

			elem = elem.offsetParent;
		}
		elem = null;

		return offsetY;
	}

	function showPopup(matchType) {
		vm.popup.type = matchType;
		var popWidth = '50%';

		// setup match model
		vm.match = matchModelVM(vm.popup.item, matchType);

		switch(matchType) {
			case 'LOG':
				vm.popup = {
					type: 'LOG',
					title: 'Log for Claim Rx# ' + vm.popup.item.RxNumber + ' Fill ' + vm.popup.item.FillNumber,
					ready: false,
					Id: vm.popup.item.Id,
					FillNumber: vm.popup.item.FillNumber,
					ChangeLog: vm.popup.item.ChangeLog,
					offsetY: vm.popup.offsetY
				};
				break;

			case 'ESI-MATCH':
				vm.popup.title = 'Create Match';
				vm.popup.CePrompt = 'OPAID Match Options';
	
				// OPA ID derived CE droplist (choose only ACTIVE CE's)
				var esiActiveAffs = utilSvc.aff.findRx(_affs, vm.query.RX.val);
				esiActiveAffs = utilSvc.aff.findCeList(esiActiveAffs, _esiOpaIdMap[vm.popup.item.OpaId]);
				vm.MatchCeDroplist = utilSvc.aff.ceDroplist(esiActiveAffs);
				break;
	
			case 'CREATE':
				vm.popup.title = 'Create Encounter';
				vm.popup.CePrompt = ''; // placeholder
				var matchAffs = getAffsWithMatch(_affs, vm.query.RX.val);
				vm.MatchCeDroplist = utilSvc.aff.ceDroplist(matchAffs);
				break;
			
			case 'SEARCH':
				popWidth = '95%';
				vm.popup.title = 'Encounter Search';
				// ASYNC: open visits feature route inside popup
				$timeout(function(){
					var visitMatchAffs = getAffsWithMatch(_affs, vm.query.RX.val);
					$state.go('ops.claims.visit-search', {MatchAffs: visitMatchAffs, DateOfBirth: vm.match.EncounterDateOfBirth.val, LastName: vm.match.PatientLN}, {inherit: true, reload: 'ops.claims.visit-search'});
				}, 500);
				break;
		}

		// move popup top over scroll header
		var popup = document.getElementById('claimsListPopupContent');
		if (!!popup) {
			popup.style.top = vm.popup.offsetY.toString() + 'px';
			popup.style.width = popWidth;
			if (matchType == 'LOG') {
				popup.style.minHeight = '0';
			} else {
				popup.style.minHeight = '400px';
			}
		}

		// wait for digest before showing
		$timeout(function () {
			vm.popup.ready = true;
		}, 100);
	}


	/**
	 * 	MATCH MODEL AND EVENTS
	 */

	function matchModelVM(item, matchType) {

		var model = {
			Id: item.Id,
			type: matchType,
			EncounterId: ''
		};

		// read only
		model.FillNumber = item.FillNumber;
		model.RxNumber = item.RxNumber;
		model.PrescriberIdent = item.PrescriberIdent;
		model.PrescriberName = item.PrescriberName;
		model.PatientFN = item.PatientFN;
		model.PatientLN = item.PatientLN;
		model.DateOfBirth = item.DateOfBirth;

		// required
		model.CE = validSvc.newProp('NONE');
		model.EncounterDate = validSvc.newPropDate(new Date(item.RxWrittenDate));
		model.EncounterNum = matchType == 'ESI-MATCH' ? validSvc.newProp('NONE') : validSvc.newProp('');

		// used by CREATE and SEARCH
		model.MRN = validSvc.newProp('');
		model.Location = validSvc.newProp('');

		// CREATE has more edit props
		model.EncounterPatientFN = validSvc.newProp(item.PatientFN);
		model.EncounterPatientLN = validSvc.newProp(item.PatientLN);
		model.EncounterDateOfBirth = validSvc.newPropDOBDate(new Date(item.DateOfBirth));
		
		return model;
	}

	function validMatch(m) {

		// CE always required
		m.CE.fail = validSvc.isCE(m.CE.val) ? 'no' : 'yes';
		var result = m.CE.fail != 'yes';

		if(m.type == 'SEARCH') {
			// check for Id passed by visit feature
			return result && validSvc.isText(m.EncounterId); 
		}

		// ESI-MATCH / CREATE required props
		m.EncounterDate = validSvc.propDateValid(m.EncounterDate);
		m.EncounterDate.fail = !!m.EncounterDate.fail ? 'yes' : 'no';
		m.EncounterNum = validText(m.EncounterNum, 2, 50);
		result = result &&
			m.EncounterDate.fail != 'yes' &&
			m.EncounterNum.fail != 'yes';

		if(m.type == 'ESI-MATCH') {
			// nothing else required
			return result;
		}

		if(m.type == 'CREATE') {
			// CREATE has more props to validate
			m.EncounterPatientFN = validText(m.EncounterPatientFN, 2, 50);
			m.EncounterPatientLN = validText(m.EncounterPatientLN, 1, 50);
			m.EncounterDateOfBirth = validSvc.propDateValid(m.EncounterDateOfBirth);
			m.EncounterDateOfBirth.fail = !!m.EncounterDateOfBirth.fail ? 'yes' : 'no';
			m.Location = validLocation(m.LocEnabled == 'yes', m.LocEligible == 'yes', m.Location.val, vm.MatchLocationDroplist);

			return result &&
				m.EncounterPatientFN.fail != 'yes' &&
				m.EncounterPatientLN.fail != 'yes' &&
				m.EncounterDateOfBirth.fail != 'yes' &&
				m.Location.fail != 'yes';
		}

		alert('claimsList.validMatch, unknown match type: ' + m.type);
		return false;
	}
	
	function validLocation(filteringOn, listIsEligible, val, ineligibleItems) {

		var result = validSvc.newProp('');

		// filtering locations is off, don't validate
		if(!filteringOn) {
			result.fail = 'no';
			return result;
		}
		result.val = val;

		// Eligible Locations, droplist choice is required
		if (listIsEligible) {
			result.fail = result.val != 'NONE' ? 'no' : 'yes';
			return result;
		}

		// InEligible locations, enter free text location (required if filtering is ON)
		result = validText(result, 2, 50);
		
		// exsits in ineligible list? (droplist is being used to hold ineligible items but user does not see this list)
		if(result.fail == 'no') {
			result.val = result.val.toUpperCase().trim();
			if(findInDroplist(ineligibleItems, result.val)) {
				result.fail = 'yes';
				result.msg = 'location is ineligible';
			}
		}

		return result;
	}

	function modelChangeMatchCE() {
		vm.match.CE.fail = validSvc.isCE(vm.match.CE.val) ? 'no' : 'yes';

		// ESI user CE does not have locations
		if(vm.match.type == 'ESI-MATCH') {
			return;
		}

		// reset locations
		vm.match.Location = validSvc.newProp('');
		vm.match.LocEnabled = 'no';
		vm.match.LocEligible = 'no';

		// load locations for this CE (after dropdown render)
		if(vm.match.CE.fail == 'no') {
			$timeout(function() {
				loadCeLocations(vm.match.CE.val);
			}, 200);
		}
	}

	function modelChangeMatchLOC() {
		// used for droplist Location editing
		if(vm.match.LocEnabled == 'yes') {

			// droplist editing
			if(vm.match.LocEnabled == 'yes') {
				vm.match.Location.fail = validSvc.isVEN(vm.match.Location.val) ? 'no' : 'yes';
				return;
			}
		}

		// default is to reset it
		vm.match.Location.fail = '';
	}

	function loadCeLocations(ceid) {
		locationsRepo.getList(ceid).then(okGetLoc, errGetLoc);

		function okGetLoc(r) {
			r = r || {};
			vm.match.LocEnabled = !!r.Enabled ? 'yes' : 'no';
			vm.match.LocEligible = !!r.Eligible ? 'yes' : 'no';

			// show location editing
			if(vm.match.LocEnabled == 'yes') {
				vm.MatchLocationDroplist = buildDroplistLOC(r.Locations);

				// use droplist
				if(vm.match.LocEligible == 'yes') {
					vm.match.Location = validSvc.newProp('NONE');
				}
				else {
					// use textbox
					vm.match.Location = validSvc.newProp('');
				}
			}
		}
	
		function errGetLoc(r) {
			if (!!r) {
				errSvc.warn('Error looking up match ce locations', 'claimsListCtl.loadCeLocations', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}


	/**
	 *    CREATE MATCH
	 */

	function createMatch() {
		if (vm.isWaiting) {
			return;
		}

		// validate
		if (!validMatch(vm.match)) {
			msgSvc.ok('Cannot Save', 'All fields must be valid.');
			return;
		}
		vm.isWaiting = true; // note this also blocks Visits feature from sending more Visit picks

		// ESI-MATCH has no confirmation
		if(vm.match.type == 'ESI-MATCH') {
			userConfirmedMatch({result:'YES'});
			return;
		}
		
		// CREATE / SEARCH needs confirm with notes
		msgSvc.confirm({
			id: 'ops.claims.match.confirm',
			title: vm.popup.title,
			msg: 'Confirm Match',
			notes: {
				prompt: 'optional notes',
				maxlength: 150,
				out: ''
			},
			buttons: [
				{ text: 'OK', result: 'YES', cancel: false },
				{ text: 'CANCEL', result: 'CANCEL', cancel: true }
			]
		}).then(userConfirmedMatch, userConfirmedMatch);
	}

	function userConfirmedMatch(r) {
		vm.isWaiting = false;

		// user said yes
		if (!!r && r.result === 'YES') {
			wait(true);
			var notes = validSvc.isText(r.notes) ? r.notes : '';
			
			claimsRepo.createMatch(vm.query.RX.val, vm.match, notes).then(okCreateMatch, errCreateMatch);
		}

		function okCreateMatch(r) {
			wait(false);
			closePopup();

			if (r.FoundOtherFills) {
				msgSvc.ok('Match Created', 'Other fills for this RX number were found and matched.');
			}
			else {
				msgSvc.ok('Match Created', 'No other fills found to match for this RX number.');
			}

			querySubmit();
		}

		function errCreateMatch(r) {
			wait(false);

			if(!!r) {
				if (r.status === 409) {
					msgSvc.ok('Cannot Create Match', 'Refreshing list due to api conflict 409 error');
					closePopup();
					querySubmit();
				}
				else if (r.status === 422) {
					vm.match = r.model;
					msgSvc.ok('Cannot Create Match', 'Check property values');
				}
				else {
					// unknown error
					errSvc.warn('Unknown error during Create Match', 'claimsListCtl.CreateMatch', r.status, utilSvc.http.safeResponse(r));
				}
			}
		}
	}

	/**
 	 *    REVIEW CLAIM
 	 */

	function reviewClaim(event, item) {
		event.stopPropagation();

		if (!!vm.query.isVerity) {
			msgSvc.ok("WARNING", "Verity users are not permitted to mark claims as Reviewed.");
			return;
		}

		var reviewTxt = item.Reviewed == 'YES' ? 'Unreview' : 'Review';
		msgSvc.confirm({
			id: 'ops.claims.review',
			title: reviewTxt + ' Claim',
			msg: 'Confirm ' + reviewTxt + ' Claim?',
			notes: {
				prompt: 'optional change notes',
				maxlength: 100,
				out: ''
			},
			buttons: [
				{ text: 'OK', result: 'YES', cancel: false },
				{ text: 'CANCEL', result: 'CANCEL', cancel: true }
			]
		}).then(userConfirm, userConfirm);

		function userConfirm(r) {
			if (!!r && r.result == 'YES') {
				msgSvc.wait(true);
				vm.isWaiting = true;
				claimsRepo.reviewClaim(item.Id, item.Reviewed == 'NO', r.notes).then(okReview, errReview);
			}

			function okReview(r) {
				msgSvc.wait(false);
				vm.isWaiting = false;
				querySubmit();
			}

			function errReview(r) {
				msgSvc.wait(false);
				vm.isWaiting = false;
				if (!!r) {
					errSvc.warn('Review claim failed', 'ops.claim.review', r.status, utilSvc.http.safeResponse(r));
				}
			}
		}
	}

	/**
	 * 		TABLE VIEW
	 */

	 function tblViewSchemaVM(canViewPHI) {

		var result = {
			title: 'Claims',
			storageKey: 'tv-ops-claims',
			name: 'CLAIMS',
			sortby: 'ServiceDate',
			pgsize: 50,
			sections: {
				Stat: {title:'Status'},
				Drug: {title: 'Drug Info'},
				Claim: {title:  'Claim'},
				Sav: {title:  'Estimated Savings'},
				Pat: {title: 'Patient'}
			},
			cols: [
				{section:'Stat', 		flt:'Text',		edit: false, name:'LastActivity', colWidth:"40px", title:'Activity', desc:'Last Activity, view activity log and comments.'},
				{section:'Stat',		flt:'Text',		name:'Reviewed', title:'Reviewed', desc:'Match review status'},
				{section:'Stat', 		flt:'Text',		edit: false, name:'State', title:'Status', desc:'Status of Claim'},

				{section:'Drug',		flt:'Text',		name:'ItemCode', title:'NDC', desc:'NDC'},
				{section:'Drug',		flt:'Text',		name:'ItemName', title:'Vendor Item Name', desc:'Vendor Item Description'},
				{section:'Drug',		flt:'Text',		name:'DrugType', title:'Drug Type', desc:'Drug type'},
				{section:'Drug',		flt:'Numbers',	default: false, name:'IRA', title:'IRA', desc:'IRA Claims'},
				{section:'Drug',		flt:'Numbers',	default: false, name:'Rebate', title:'Rebate', desc:'Manufacturer Rebate NDC'},

				{section:'Claim', 		flt:'Text',		name:'OpaId', title:'Opa Id', desc:'Opa Id'},
				{section:'Claim', 		flt:'Text',		name:'PrescriberIdent', title:'Provider NPI', desc:'Provider NPI'},
				{section:'Claim', 		flt:'Text',		name:'PrescriberName', title:'Provider Name', desc:'Provider Name'},
				{section:'Claim', 		flt:'Text',		name:'RxNumber', title:'Rx Number', desc:'Rx Number'},
				{section:'Claim', 		flt:'Dates',	name:'RxWrittenDate', title:'Written', desc:'Written'},
				{section:'Claim', 		flt:'Dates',	name:'ServiceDate', title:'Filled', desc:'Filled'},
				{section:'Claim', 		flt:'Numbers',	name:'FillNumber', title:'Fill #', desc:'Fill #'},
				{section:'Claim', 		flt:'Numbers',	name:'Quantity', title:'Qty', desc:'Qty'},

				{section:'Sav', 		flt:'Numbers', 	default:false,	name:'PharmacyPrice', title:'Pharmacy Price', desc:'Pharmacy Price'},
				{section:'Sav', 		flt:'Numbers',	default:false,	name:'CEPrice', title:'CE Price', desc:'Facility Price'},
				{section:'Sav', 		flt:'Numbers',	default:false,	name:'DispenseFee', title:'Dispense Fee', desc:'Dispense Fee'},
				{section:'Sav', 		flt:'Numbers',	default:false,	name:'OrderFee', title:'Order Fee', desc:'Order Fee'},
				{section:'Sav', 		flt:'Numbers',	default:false,	name:'ReferralFee', title:'Referral Fee', desc:'Referral Fee'},
				{section:'Sav', 		flt:'Numbers',	default:false,	name:'Savings', title:'Savings', desc:'Estimated Savings'},

				{section:'Pat', 		flt:'Text',		name:'PatientLN', title:'Last', desc:'Patient Last Name'},
				{section:'Pat', 		flt:'Text',		name:'PatientFnTxt', title:'First', desc:'Patient First Name'},
			]
		};

		if(canViewPHI) {
			result.cols.push({section:'Pat', flt:'Dates', name:'DateOfBirth', title:'DOB', desc:'Patient DOB'});
		}

		return result;
	}

	function tblViewConfigSetup(tblSchema) {
		// config setup converts all column schema into config columns / keys

		var cols = tblSchema.cols,
			col = {},
			colKeys = {},
			colAllowed = [];

		for(var i = 0; i < cols.length; i++) {
			col = cols[i];

			// tbd... logic to remove conditional columns based on user type, etc

			// keep column
			colAllowed.push(col.name);
			colKeys[col.name] = col;
		}

		// update columns for this table
		tblSchema.cols = colAllowed;
		tblSchema.colKeys = colKeys;

		return tblSchema;
	}

	function okCurrentTableView() {
		// update session
		var tvSaved = sessionRepo.get(vm.tblViewConfig.storageKey);
		if(!!tvSaved && !!vm.tblView && validSvc.isText(vm.tblView.current)) {
			tvSaved.current = vm.tblView.current;
			sessionRepo.set(vm.tblViewConfig.storageKey, tvSaved);
		}
	}

	function errCurrentTableView() {
		// do nothing
	}

	function tblViewReload(skipInitViews, fltKeepPaging) {

		// init tblView with full view config
		if(!!!skipInitViews || !!!vm.tblView) {
			vm.tblView = vm.tblViewInit(vm.tblViewConfig, sessionRepo.get(vm.tblViewConfig.storageKey));
		}
		
		// add column titles and filters
		vm.tblView = vm.tblViewLoadTitlesAndFilters(vm.tblViewConfig, vm.tblView, vm.flt);
		
		// update table view bar
		$scope.$broadcast('widget.tblview', {
			uniqueId: 'CLAIMS',
			current: vm.tblView.current,
			views: vm.tblView.views
		});

		if(!!vm.flt) {
			// remove any filter properties not shown in current table view
			vm.flt = vm.tblViewSyncFilter(vm.tblViewConfig, vm.tblView, vm.flt, fltKeepPaging);
			filterChange(true);
		}
	}

	function openPopupTblView() {
		if(vm.isWaiting) {
			return;
		}

		vm.popupTblView = {
			title: 'Claims Table View Editor',
			ready: false
		};

		$scope.$broadcast('widget.tblview.editor', {
			uniqueId: 'CLAIMS',
			config: vm.tblViewConfig
		});

		// wait for digest before showing
		$timeout(function() {
			vm.popupTblView.ready = true;
		}, 200);		
	}

	function closePopupTblView() {
		vm.popupTblView = {};
		// wait a render cycle
		$timeout(function() {
			tblViewReload(false, true); // re-init views, keep paging if possible
		}, 300);
	}

	// CLAIM DETAIL POPUP
	function openPopupDetail(claim) {
		if(vm.isWaiting || !!!claim || !validSvc.isText(claim.Id)) {
			return;
		}

		vm.popupClaimDetail = {
			title: 'Claim Detail',
			ready: true
		};

		$timeout(function() {
			$state.go('ops.claims.detail', {id : claim.Id, claim: claim}, {reload: 'ops.claims.detail'});
		},200);

	}

	function closePopupDetail() {
		vm.popupClaimDetail = {};
	}

	// CLAIM BULK APPROVE POPUP
	function openPopupBulkApprove() {
		vm.popupClaimBulkMatch = {
			title: vm.query.RX.val + ' Bulk Match Approval',
			ready: true
		};

		var matchAffs = getAffsWithMatch(_affs, vm.query.RX.val);
		vm.MatchCeDroplist = utilSvc.aff.ceDroplist(matchAffs);
		vm.query.CE = utilSvc.ng.droplistAutoselect(vm.MatchCeDroplist, vm.query.CE.val);
	}

	function closePopupBulkApprove() {
		vm.popupClaimBulkMatch = {};
	}

	function confirmBulkMatch() {
		if (vm.isWaiting) {
			return;
		}
		var matches = [];
		for (var i = 0; i < vm.bulkMatchList.length; i++) {
			matches.push(vm.bulkMatchList[i].Id);
		}
		var cename = vm.query.CE.val == 'NONE' ? '' : vm.query.CE.val;
		claimsRepo.bulkCreateMatch(matches, cename, vm.query.Notes).then(okCreateMatch, errCreateMatch);
	}


	/**
	 *    EXCEL
	 *    get file from server
	 */

	function getExcel() {

		// already working?
		if (vm.isWaiting) {
			return;
		}

		// blob support?
		if (!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		var rxName = utilSvc.aff.rxShortNameById($scope.User.AffList, vm.query.RX.val);
		_pendingExcelFilename = 'Verity-' + rxName + '-Claims.xlsx';

		wait(true);
		claimsRepo.getExcel(vm.query, _pendingExcelFilename).then(okServerExcel, errServerExcel);

		function okServerExcel(binaryData) {
			wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch (err) {
				throw (err);
			}
		}

		function errServerExcel(r) {
			wait(false);
			if (!!r) {
				errSvc.warn('Create Excel Error', 'claimsListCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    ASYNC
	 */

	function initAsyncReports() {
		return {
			title: 'Claims Details - Saved Files',
			show: 'no'
		};
	}

	function toggleAsyncReports() {
		if(vm.isWaiting) {
			return;
		}
		vm.asyncReports.show = vm.asyncReports.show == 'yes' ? 'no' : 'yes';
		if(vm.asyncReports.show == 'yes') {
			$state.go('ops.claims.async-reports', {
				rptType: 'CLAIM_DETAILS',
				query: null
			}, {reload: 'ops.claims.async-reports'});
		}
	}

	function createAffAsyncExcel() {
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if (!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		var apiQuery = claimsRepo.listExcelQuery(vm.query);
		apiQuery.Params.ReportType = 'CLAIM_DETAILS';
		
		vm.popup = {};
		vm.isWaiting = true;
		msgSvc.wait(true);
		reportRepo.createAsyncFile(apiQuery).then(okServerExcel, errServerExcel);

		/**
		 *    EXCEL HELPERS
		 */

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			
			msgSvc.ok('Excel File Requested', 'Check the "Saved Files" link at top right to retrieve this Excel Workbook.');
		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if (!!r) {
				errSvc.warn('Create Excel Error', 'catalog.ServerExcel', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}
	
	/**
	 *    HELPERS
	 */

	function dtPickOpen(dtName) {

		if (dtName != 'EncounterDate' && dtName != 'EncounterDateOfBirth' && dtName != 'PatientDateOfBirth') {
			alert('claimsListCtl.dtPickOpen, date pick name unknown: ' + dtName);
			return;
		}
		var dt = vm.match[dtName];
		vm.dtPickShow.pending = dtName;
		if (dtName == 'PatientDateOfBirth') {
			dt = vm.query[dtName];
		}

		$scope.$broadcast('widget.input.date.pick', {
			uniqueId: dtName,
			setDate: dt.val,
			minDate: dt.min,
			maxDate: dt.max
		});

		$timeout(function () {
			if (validSvc.isText(vm.dtPickShow.pending)) {
				vm.dtPickShow[vm.dtPickShow.pending] = true;
			}
		}, 100);
	}

	function validText(prop, min, max) {

		// required
		if (!validSvc.isText(prop.val)) {
			prop.fail = 'yes';
			prop.msg = 'required';
			return prop;
		}

		// min
		if (prop.val.length < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum ' + min.toString() + ' characters';
			return prop;
		}

		// max
		if (prop.val.length > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum ' + max.toString() + ' characters';
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;
	}

	function wait(isOn) {
		vm.isWaiting = !!isOn;
		msgSvc.wait(!!isOn);
	}

	function findAff(affs, ceid, rxid) {
		// helper to find a specific global affiliation and pass it back de-referenced
		var findAff = utilSvc.aff.findRx(affs, rxid);
		findAff = utilSvc.aff.findCe(findAff, ceid);
		if(findAff.length == 1) {
			return JSON.parse(JSON.stringify(findAff[0])); // de-reference global affs
		}
		return null;
	}

	function hasOwnUseProgram(affs, rxid) {
		// does this rxid have an afiliation to a CE with an OwnUseProgram?
		var items = utilSvc.aff.findRx(affs, rxid);
		for(var i = 0; i < items.length; i++) {
			if(items[i].OwnUseProgram) {
				return true;
			}
		}
		return false;
	}

	function getAffsWithMatch(affs, rxid) {
		// this pharmacy has an affilation with match permission
		var result = [],
			items = utilSvc.aff.findRx(affs, rxid);
		for(var i = 0; i < items.length; i++) {
			if(items[i].canMatch) {
				result.push(items[i]);
			}
		}
		return result;
	}

	function getAffsWith340B(affs, rxid, ceid) {
		var result = utilSvc.aff.findRx(affs, rxid);
		if(validSvc.isCE(ceid)) {
			result = utilSvc.aff.findCe(result, ceid);
		}
		return utilSvc.aff.findVenType(result, ['340B'],true);
	}

	function findInDroplist(droplist, findVal) {
		for(var i = 0; i < droplist.length; i++) {
			if(droplist[i].value == findVal) {
				return true;
			}
		}
		return false;
	}

	function buildDroplistLOC(items) {
		items = Array.isArray(items) ? items : [];

		var result = [];
		for (var i = 0; i < items.length; i++) {
			result.push(items[i].LocationId.toUpperCase());
		}

		return utilSvc.ng.droplist(result,'','',[{label:'Choose Location', value:'NONE'}]);
	}

	function flexTopExpand() {
		// user opened search query, reset list display, show search expanded
		vm.query.DispId = '';
		queryChange();
	}

	function ndcCleanUp(val, skipEmpty) {

		var zeroPad = "00000000000",
			ndcTest = '';

		// must be text
		if(!!!skipEmpty && !validSvc.isText(val)) {
			return validSvc.newProp(val, true, 'required');
		}

		// remove all non-numeric characters
		ndcTest = val.toString().trim();
		ndcTest = ndcTest.replace(/[^0-9]+/g,'');

		// empty
		if(ndcTest.length < 1) {
			if(!!skipEmpty) {
				return validSvc.newProp('', false, '');
			}
			else {
				return validSvc.newProp(ndcTest, true, 'empty');
			}
		}

		// max len
		if(ndcTest.length > 11) {
			return validSvc.newProp(ndcTest, true, 'max 11 characters');
		}

		// integer
		var intVal = parseInt(ndcTest);
		if(!validSvc.isInteger(intVal)) {
			return validSvc.newProp(ndcTest, true, 'must be an integer');
		}

		// all zeros
		if(intVal <= 0) {
			return validSvc.newProp(ndcTest, true, 'cannot be zero');
		}

		// pad zeros if needed, pass
		ndcTest = zeroPad.substr(0, 11 - ndcTest.length) + ndcTest;
		return validSvc.newProp(ndcTest, false, '');
	}

}
 
claimsRepo.$inject = ['$rootScope', '$q', 'apiService', 'apiErrors', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc', 'msgSvc'];
angular
.module('espui.ops')
.factory('claimsRepo', claimsRepo);


/* @ngInject */
function claimsRepo($rootScope, $q, apiService, apiErrors, errSvc, eventSvc, utilSvc, validSvc, msgSvc) {

	// private
	var _currentPurl = '',
		_pendingQuery = {},
		_pendingModel = {};

	// service definition
	var service = {
		queryVM: queryVM,

		getList: getList,
		getExcel: getExcel,
		getDetail: getDetail,
		reviewClaim: reviewClaim,

		createMatch: createMatch,
		bulkCreateMatch: bulkCreateMatch,

		listExcelQuery: listExcelQuery,

	};

	return service;


	/**
	 *    QUERY
	 */

	function queryVM() {

		return {
			isCeUser: $rootScope.User.Type == 'CE',
			isVerity: $rootScope.User.Type == 'VERITY' || $rootScope.User.Type == 'VERITYSA',
			RX: validSvc.newProp($rootScope.User.RX),
			RxOptions: 'affs',
			AccumType: 'ALL',
			IncludeMatched: 'no',
			IncludeSavings: 'no',
			SavingsCE: validSvc.newProp('NONE'),
			SavingsVEN: validSvc.newProp('NONE'),
			RxNumber: validSvc.newProp(),
			ItemCode: validSvc.newProp(),
			NPI: validSvc.newProp(),
			PatientLN: validSvc.newProp(),
			PatientDateOfBirth: validSvc.newPropDOBDate(),
			StartDate: validSvc.newPropDateNull(),
			EndDate: validSvc.newPropDateNull(),
			Notes: '',
			Reviewed: validSvc.newProp(),
			CE: validSvc.newProp(),
		};

	}

	/**
	 * 	GET LIST / EXCEL
	 */

	function listExcelQuery(q) {
		// list and excel use same query logic
		var params = {
			AccumType: q.showAccumType == 'yes' ? q.AccumType : 'ALL',
			EstimatePricing: q.IncludeSavings == 'yes',
			ReturnMatched: q.IncludeMatched == 'yes',
			StartDate: q.StartDate.val,
			EndDate: q.EndDate.val
		};

		// params
		if(!validSvc.isRX(q.RX.val)) {
			throw new Error('claimsRepo.listExcelQuery, RX id is required');
		}

		// savings params
		var includeSavings = q.showSavings == 'yes' && q.IncludeSavings == 'yes';
		if(includeSavings && (!validSvc.isCE(q.SavingsCE.val) || !validSvc.isVEN(q.SavingsVEN.val))) {
			throw new Error('claimsRepo.listExcelQuery, CE and VEN required for Estimated Savings');
		}

		if (q.RxNumber.chk) {
			params.RxNumber = q.RxNumber.val;
		}

		if (q.ItemCode.chk) {
			params.ItemCode = q.ItemCode.val;
		}

		if (q.NPI.chk) {
			params.NPI = q.NPI.val;
		}

		if (q.PatientLN.chk) {
			params.PatientLN = q.PatientLN.val;
		}

		if (q.PatientDateOfBirth.chk) {
			params.DateOfBirth = q.PatientDateOfBirth.val;
		}

		if (!!q.DispId) {
			params.DispId = q.DispId;
			params.StartDate = null;
		}

		if (!!q.Reviewed.chk) {
			params.Reviewed = q.Reviewed.val;
		}

		return {
			Context: {
				RXID: [q.RX.val],
				CEID: includeSavings ? [q.SavingsCE.val] : [],
				VENID: includeSavings ? [q.SavingsVEN.val] : []
			},
			Params: params,
			Paging:{}
		};
	}

	function getList(query) {

		_currentPurl = 'ops/dispense/list';
		var defer = $q.defer();

		// create api request
		var apiRequest = listExcelQuery(query);
		apiRequest.Paging = {
			Page: 1,
			Size: 20000
		};
		apiRequest.SortBy = [utilSvc.sorting.sortByApiStyle('RxWrittenDate')];

		// save list query
		_pendingQuery = {
			RX: query.RX.val
		};

		apiService.post(_currentPurl, apiRequest).then(okGetList, errGetList);

		function okGetList(r) {

			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update RX and Rx user choice
			eventSvc.rootEmit('context.change', {
				RX: _pendingQuery.RX
			});

			var ent = r.data.Entity;
			ent.Dispenses = Array.isArray(ent.Dispenses) ? ent.Dispenses : [];
			ent.MatchCEs = Array.isArray(ent.MatchCEs) ? ent.MatchCEs : [];

			defer.resolve({
				Disp: {
					Items: ent.Dispenses,
					TooMany: ent.Dispenses.length > 20000
				},
				MatchOptions: ent.MatchCEs
			});

		}

		function errGetList(r) {
			if(r !== null) {
				if (r.status === 422) {
					// validation
					msgSvc.ok('Validation Error', r.data.Entity.ROOT[0]);
				}else{
					errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				}
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function getExcel(query, filename) {

		_currentPurl = 'ops/dispense/excel';
		var defer = $q.defer();

		// create api request
		var apiRequest = listExcelQuery(query);
		apiRequest.Params.Filename = filename;
		apiRequest.SortBy = [utilSvc.sorting.sortByApiStyle('ServerExcel')];

		apiService.postGetBinary(_currentPurl, apiRequest).then(okGetExcel, errGetExcel);

		function okGetExcel(r) {
			defer.resolve(r.data);
		}

		function errGetExcel(r) {
			if(r !== null) {
				r = r || {};
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	/**
	 * 	GET DETAIL
	 */
	
	function getDetail(id) {
		_currentPurl = 'ops/dispense/detail';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Params: {
				Id: id
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okGetList, errGetList);

		function okGetList(r) {

			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({
				Items: r.data.Entity,
				TooMany: r.data.Entity.length > 20000
			});
		}

		function errGetList(r) {
			if(r !== null) {
				if (r.status === 422) {
					// validation
					msgSvc.ok('Validation Error', r.data.Entity.ROOT[0]);
				}else{
					errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				}
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	/** 
	 *  CLAIM REVIEW
	 */

	function reviewClaim(id, review, notes) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('claimRepo.reviewClaim, id missing');
		}

		// create api request
		var apiRequest = {
			Context: {
			},
			Params: {
				Id: id,
				Reviewed: review,
				Notes: notes,
			}
		};


		_currentPurl = 'ops/dispense/review';
		var _deferEdit = $q.defer();

		// call api
		apiService.post(_currentPurl, apiRequest).then(okReviewAction, errReviewAction);

		function okReviewAction(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				_deferEdit.reject(null);
				return;
			}
	
			r = r || {};
			r.data = r.data || {};
			_deferEdit.resolve(r.data);
	
		}

		function errReviewAction(r) {
			if(r === null) {
				_deferEdit.reject(null);
			}
			else if(!!r && r.status === 409) {
				_deferEdit.reject(r);
			}
			else {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
		}

		return _deferEdit.promise;
	}

	/**
	 *    CREATE MATCH
	 */

	function createMatchRequest(rxid, model, notes) {

		var apiRequest = {
			Context: {
				RXID: [rxid],
				CEID: [model.CE.val]
			},
			Params: {
				Type: model.type,
				Id: model.Id,
				NPI: model.PrescriberIdent,
				Notes: notes
			}
		};
		
		switch(model.type) {
			case 'ESI-MATCH':
				// date and num needed
				apiRequest.Params.EncounterDate = utilSvc.dt.toServerString(model.EncounterDate.val);
				apiRequest.Params.EncounterNum = model.EncounterNum.val;
				break;
			case 'SEARCH':
				// visit id picked from visits search
				apiRequest.Params.EncounterId = model.EncounterId;
				break;
			case 'CREATE':
				apiRequest.Params.EncounterDate = utilSvc.dt.toServerString(model.EncounterDate.val);
				apiRequest.Params.EncounterNum = model.EncounterNum.val;

				// CREATE requires more Encounter props
				apiRequest.Params.FirstName = validSvc.isText(model.EncounterPatientFN.val) ? model.EncounterPatientFN.val : '';
				apiRequest.Params.LastName = validSvc.isText(model.EncounterPatientLN.val) ? model.EncounterPatientLN.val : '';
				apiRequest.Params.DateOfBirth = utilSvc.dt.toServerString(model.EncounterDateOfBirth.val);
				apiRequest.Params.MRN = model.MRN.val;
				apiRequest.Params.Location = model.Location.val;
				break;
			default:
				throw new Error('claimsRepo.createMatchRequest, unknown match type: ' + model.type);
		}

		return apiRequest;
	}

	function createMatch(rxid, model, notes) {
		// used for all three Claim match types: ESI-MATCH, CREATE, SEARCH

		if(!validSvc.isRX(rxid) || !!!model) {
			throw new Error('claimsRepo.createMatch, RX and model required');
		}

		var defer = $q.defer();
		_pendingModel = model;

		_currentPurl = 'ops/dispense/creatematch';
		var apiRequest = createMatchRequest(rxid, model, notes);

		apiService.post(_currentPurl, apiRequest).then(okCreateMatch, errCreateMatch);

		function okCreateMatch(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({FoundOtherFills: r.data.Entity.FoundOtherFills});

		}

		function errCreateMatch(r) {

			if(r === null) {
				defer.reject(null);
			}
			else if(!!r && r.status === 409) {
				defer.reject(r);
			}
			else if(!!r && r.status === 422) {
				r.model = mapApiErrorsToModel(r, _pendingModel);
				defer.reject(r);
			}
			else {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);
				if(fieldObj === undefined) {
					throw new Error('claimsRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
				}

				// set failed state
				fieldObj.fail = 'yes';
				fieldObj.msg = entity.Fields[i].Rule;

			}

			return m;

		}

		return defer.promise;
	}

	function bulkCreateMatch(ids, ce, notes) {
		if(!Array.isArray(ids)) {
			throw new Error('claimsRepo.createMatch, ids are required');
		}

		var defer = $q.defer();

		_currentPurl = 'ops/dispense/bulkcreatematches';
		var apiRequest = {
			Params: {
				Ids: ids,
				CE: ce,
				Notes: notes
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okCreateMatch, errCreateMatch);

		function okCreateMatch(r) {

			// bad upsert response format
			if(!validSvc.httpBulkUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errCreateMatch(r) {
			if(r === null) {
				defer.reject(null);
			}
			else if(!!r && r.status === 409) {
				defer.reject(r);
			}
			else if(!!r && r.status === 422) {
				defer.reject(r);
			}
			else {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
		}

		return defer.promise;
	}
}
 /**
 *    Custom Item CONTROLLER
 *    shared across CE admin and CE user features
 */

WacNeutCustomItemCtl.$inject = ['$window', '$scope', '$state', '$timeout', 'customItemRepo', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc'];
angular
	.module('espui.ops')
	.controller('WacNeutCustomItemCtl', WacNeutCustomItemCtl);


/* @ngInject */
function WacNeutCustomItemCtl($window, $scope, $state, $timeout, customItemRepo, validSvc, errSvc, utilSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this,
		_viewErrRoute = '',
		_pendingExcelFilename = '',
		_filter = {},
		_regexDate = utilSvc.regex.dateFmt(),
		_pagingEventListener = null;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	msgSvc.addHelpLink(vm);

	
	// properties
	vm.init = false;
	vm.action = '';
	vm.isWaiting = false;
	vm.numberFmt = utilSvc.num.numberFmt;

	// query
	vm.CeDroplist = [];
	vm.queryChangeRX = queryChangeRX;

	// models
	vm.context = {};
	vm.tblItems = [];
	vm.found = {};
	vm.model = {};

	// filter and tabs
	vm.flt = {};
	vm.activeTab = '';
	vm.filterChange = filterChange;

	// custom item editing
	vm.submitModel = submitModel;
	vm.deleteItem = deleteItem;

	// popup
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;

	// excel
	vm.getExcel = getExcel;
	


	/**
	 *    EVENT HOOKS
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tblItems) || vm.tblItems.length < 1) {
			return;
		}

		filterChange(vm.flt, vm.tblItems, true);
	});

	/**
	 *    DESTROY
	 */

	$scope.$on('$destroy', function() {
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {
		vm.init = true;

		// route properties
		var params = $state.params || {};
		var paramRXID = params.RX;
		_viewErrRoute = params.ViewErrRoute;

		// start filter
		_filter = vm.initFilters({
				Config: {
					Dates: ['StartDate', 'EndDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['ItemCode']
			});
		vm.flt = vm.resetFilters(_filter);
		vm.flt.Ready = true;

		// set view type and title
		var stateName = $state.current.name;
		switch (stateName) {
			case 'ops.customitem':
				_viewErrRoute = 'home';
				$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
				vm.RxDroplist = getCdcRxList($scope.User.AffList);
				break;
			case 'admin.rx.edit.customitem':
				_viewErrRoute = 'admin.rx.list';
				// admin route must have CE param
				if(!validSvc.isRX(paramRXID)) {
					throw new Error('WacNeutCustomItemCtl.init, param.RX required');
				}
				break;
			default:
				throw new Error('WacNeutCustomItemCtl.init, unknown route: ' + stateName);
		}

		initQueryAndFilters(paramRXID);
		queryChangeRX();

	}

	function getCdcRxList(affs) {
		var cdcs = [],
			affItem = {},
			rxid = '';
		
		// find CDC pharmacies
		for(var i = 0; i < affs.length; i++) {
			affItem = affs[i];
			if(affItem.RxCDC) {
				rxid = affItem.RXID;
			}
			else if(validSvc.isText(affItem.CdcPharmacy)) {
				rxid = affItem.CdcPharmacy;
			}
			else {
				rxid = '';
			}
			if(!!rxid && cdcs.indexOf(rxid) < 0) {
				cdcs.push(rxid);
			}
		}

		// none found, let user know
		if(cdcs.length < 1) {
			msgSvc.ok('Custom NDCs', 'No CDC pharmacies found');
			vm.action = 'RX_NOT_FOUND';
			return [];
		}
		cdcs.sort();

		return utilSvc.ng.droplist(cdcs, '', '', [{label:'Choose a Pharmacy', value:'NONE'}]);
	}

	function initQueryAndFilters(rxid) {
		vm.context = customItemRepo.contextVM(rxid);
		if (!!!rxid) {
			vm.context.RX = utilSvc.ng.droplistAutoselect(vm.RxDroplist, vm.context.RX);
		}
	}

	function modelVM(item) {
		if (!!item) {
			// clean up change log null arrays
			var chgItems = Array.isArray(item.ChangeLog) ? item.ChangeLog : [];
			for (var i = 0; i < chgItems.length; i++) {
				chgItems[i].ChangedProperties = Array.isArray(chgItems[i].ChangedProperties) ? chgItems[i].ChangedProperties : [];
			}
			return {
				ItemCode: validSvc.newProp(item.ItemCode),
				Description: validSvc.newProp(item.Description),
				Price: validSvc.newProp(item.Price),
				PkgSize: validSvc.newProp(item.PkgSize),
				Active: item.Active === 'ACTIVE' ? 'yes' : 'no',
				ChangeLog: chgItems
			};
		} else {
			return {
				ItemCode: validSvc.newProp(''),
				Description: validSvc.newProp(''),
				Price: validSvc.newProp(0),
				PkgSize: validSvc.newProp(),
				Active: 'yes',
			};
		}
	}


	/**
	 *    QUERY CHANGE
	 */

	function queryChange() {

		if(!vm.init) {
			vm.action = '';
			vm.activeTab = '';
			closePopup();

			vm.tblItems = [];
			vm.found = {};
			vm.model = {};

			$scope.$broadcast('widget.paging');
		}
	}

	function queryChangeRX() {

		queryChange();

		vm.context.RX.fail = validSvc.isCE(vm.context.RX.val) ? 'no' : 'yes';
		if(vm.context.RX.fail == 'no') {
			getList();
		}

	}

	/**
	 *    GET LISTS FOR ndc AND FOUND
	 */

	function getList() {

		if(vm.isWaiting) {
			return;
		}
		vm.init = false;
		queryChange();

		vm.isWaiting = true;
		msgSvc.wait(true);

		// TODO: Use get Lists
		customItemRepo.getList(vm.context.RX.val).then(okGetList, errGetList);

		function okGetList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.tblItems = displayVM(r);
			vm.action = 'LIST';
		}

		function errGetList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Not able to get ndc.', 'WacNeutCustomItemCtl.errNdcList', r.status, utilSvc.http.safeResponse(r));
			}

			$state.go(_viewErrRoute, {}, { reload: _viewErrRoute });
		}

	}

	function displayVM(items) {
		items = Array.isArray(items) ? items : [];

		var item = {};
		for (var i = 0; i < items.length; i++) {
			item = items[i];
			item.ItemCode = item.ItemCode.toUpperCase();
			item.Description = item.Description;
			item.Price = item.Price;
			item.PkgSize = item.PkgSize;
			item.Active = item.Active ? "ACTIVE" : "INACTIVE";
		}

		return items;
	}


	/**
	 *    FILTER CHANGE
	 */

	function filterChange(immediate) {
		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {
			vm.tblItems = vm.filterList(vm.tblItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tblItems.length,
			});

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					_filter = vm.flt;
				}
			},1000);

		}, delayTime);

		vm.flt.Ready = true;
	}

	function validateItemCode(prop) {

		//  - required, 2 to 40 characters
		prop = validText(prop, 11, 11);
		if(prop.fail == 'no') {
			prop.val = prop.val.toUpperCase();

			// alphanumeric, or spaces allowed
			var regexAcctId = /[^0-9]/;
			prop.fail = regexAcctId.test(prop.val) ? 'yes' : 'no';
			if(prop.fail == 'yes') {
				prop.msg = 'numeric only';
			}
		} else {
			prop.msg = 'must be 11 digits';
		}

		return prop;
	}


	/**
	 *    SUBMIT
	 */

	function validCustomItem(m) {
		// LocationId - required, 11 characters, alphanumeric
		m.ItemCode = validateItemCode(m.ItemCode);
		if(m.ItemCode.fail == 'no') {
			m.ItemCode.val = m.ItemCode.val.toUpperCase();
		}

		// Description - optional, to 60 characters
		if(validSvc.isText(m.Description.val) && m.Description.val.length > 0 && m.Description.val.length <= 60) {
			m.Description.val = m.Description.val.trim();
			m.Description = validText(m.Description, 0, 60);
		}else {
			m.Description.fail = 'yes';
			m.Description.msg = 'required, up to 60 char';
		}

		// Price - bigger than 0
		if(m.Price.val !== undefined && m.Price.val >= 0) {
			m.Price.fail = '';
		} else {
			m.Price.fail = 'yes';
			m.Price.msg = 'must be greater than 0';
		}

		// Package Size - bigger than 0
		if(m.PkgSize.val !== undefined && m.PkgSize.val > 0) {
			m.PkgSize.fail = '';
		} else {
			m.PkgSize.fail = 'yes';
			m.PkgSize.msg = 'must be greater than 0';
		}

		return m.ItemCode.fail != 'yes' &&
			m.Description.fail != 'yes' &&
			m.Price.fail != 'yes' &&
			m.PkgSize.fail != 'yes';

	}

	function submitModel() {

		if(vm.isWaiting) {
			return;
		}

		if(!validCustomItem(vm.model)) {
			msgSvc.ok('Cannot Save', 'Check property values.');
			return;
		}

		vm.isWaiting = true;

		// create or update
		if(vm.popup.type == 'CREATE') {
			customItemRepo.add(vm.context.RX.val, vm.model).then(okSubmit, errSubmit);
		}
		else {
			customItemRepo.update(vm.context.RX.val, vm.model).then(okSubmit, errSubmit);
		}

		function okSubmit(entity) {
			vm.isWaiting = false;

			var detailMsg = vm.popup.type == 'UPDATE' ? 'Updated' : 'Added';
			msgSvc.ok('Custom item Saved', 'Custom Item ' + detailMsg);

			getList();
		}

		function errSubmit(r) {
			vm.isWaiting = false;

			if(r == null) {
				// already handled
				closePopup();
			}
			else if(r.status == 409) {
				// conflict
				msgSvc.ok('Cannot Save', 'May already exist in the database. Verify and try again.');
			}
			else if(r.status == 422) {
				// validation
				msgSvc.ok('Cannot Save', 'Verify all field values.');
				vm.model = r.model;
			}
			else {
				errSvc.warn('Unknown add / update error response', 'WacNeutCustomItemCtl.errSubmit', r.status, utilSvc.http.safeResponse(r));
			}

		}
	}

	function deleteItem() {
		if(vm.isWaiting) {
			return;
		}

		msgSvc.confirm({
			id: 'ndc.delete',
			title: 'Delete custom item: ' + vm.model.ItemCode.val,
			msg: 'Confirm delete custom item, this action cannot be reversed.',
			buttons: [
				{ text: 'OK', result: 'YES', cancel: false },
				{ text: 'CANCEL', result: 'CANCEL', cancel: true }
			]
		}).then(confirmDel, confirmDel);

	}

	function confirmDel(r) {

		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;
			customItemRepo.removeItem(vm.context.RX.val, vm.model).then(okDel, errDel);
		}

		function okDel(r) {
			vm.isWaiting = false;
			msgSvc.ok(vm.model.ItemCode.val + ' Deleted');

			getList();
		}

		function errDel(r) {
			vm.isWaiting = false;

			if (!!r) {
				errSvc.warn("" + r.data.Entity.ROOT, 'WacNeutCustomItemCtl.ndcDelete', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}

	/**
	 *    POPUP
	 */

	function openPopup(evt, item, popType) {

		// shared handler to open editing and import popups

		if(vm.isWaiting) {
			return;
		}

		vm.popup = {
			type: popType,
			showLog: false,
			ready: false
		};

		switch(popType) {

			case 'CREATE':
				vm.model = modelVM();
				vm.popup.title = "Add Custom Item";
				break;

			case 'UPDATE':
				vm.model = modelVM(item);
				vm.popup.title = "Edit Custom Item";
				break;

			default:
				throw new Error('WacNeutCustomItemCtl.openPopup, unknown popType: ' + popType);
		}

		// wait for digest before showing
		$timeout(function() {
			vm.popup.ready = true;
		}, 100);
	}

	function closePopup() {
		vm.popup = {};
		vm.model = {};
	}

	/**
	 *    EXCEL
	 *    get file from server
	 */

	function getExcel() {

		// already working?
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		_pendingExcelFilename = vm.context.RX.val + '-Custom Items.xlsx';
		customItemRepo.getExcel(vm.context.RX.val, _pendingExcelFilename).then(okServerExcel, errServerExcel);

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Create Excel Error', 'payorList.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}
	}

	/**
	 *    HELPERS
	 */

	function validText(prop, min, max) {

		// required
		if(!validSvc.isText(prop.val)) {
			prop.fail = 'yes';
			prop.msg = 'required';
			return prop;
		}

		// min
		if(prop.val.length < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum ' + min.toString() + ' characters';
			return prop;
		}

		// max
		if(prop.val.length > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum ' + max.toString() + ' characters';
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;

	}

}
 
customItemRepo.$inject = ['$rootScope', '$q', 'apiService', 'apiErrors', 'appConst', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
	.module('espui.ops')
	.factory('customItemRepo', customItemRepo);


/* @ngInject */
function customItemRepo($rootScope, $q, apiService, apiErrors, appConst, errSvc, eventSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _currentPurl = '',
		_apiPaging = vmSvc.api.paging(),
		_pending = {};

	// service definition
	var service = {
		contextVM: contextVM,

		getList: getList,

		update: update,
		add: add,
		removeItem: removeItem,

		getExcel: getExcel

	};

	return service;


	/**
	 *    VIEW MODELS
	 */

	function contextVM(rxid) {
		var affs = utilSvc.aff.findStatus($rootScope.User.AffList),
			uType = $rootScope.User.Type;

		return {
			isCE: uType == 'CE',
			isVerity: uType == 'VERITYSA' || uType == 'VERITY',
			RX: validSvc.newProp(validSvc.isRX(rxid) ? rxid : $rootScope.User.RX),
			RxList: utilSvc.aff.rxList(affs)
		};

	}


	/**
	 *    GET LIST
	 */

	function getList(rxid) {

		// params
		if (!validSvc.isText(rxid)) {
			throw new Error('customItemRepo.getList, rxid is missing: ' + rxid);
		}

		_currentPurl = 'ops/rx/customndc/list';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				RXID: [rxid]
			}
		};

		// save RX choice
		_pending = { RX: rxid };

		apiService.post(_currentPurl, apiRequest).then(okGetList, errGetList);

		function okGetList(r) {

			if (!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update user RX choice
			eventSvc.rootEmit('context.change', {
				RX: _pending.RX,
			});

			defer.resolve(r.data.Entity);

		}

		function errGetList(r) {
			if (r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	/**
	 *    CREATE / UPDATE / DELETE
	 */

	function add(rxid, model) {
		return upsert('ops/rx/customndc/add', rxid, model);
	}

	function update(rxid, model) {
		return upsert('ops/rx/customndc/update', rxid, model);
	}

	function removeItem(rxid, model) {
		return upsert('ops/rx/customndc/remove', rxid, model);
	}

	function upsert(purl, rxid, model) {

		_currentPurl = purl;
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				RXID: [rxid]
			},
			Entity: {
				ItemCode: model.ItemCode.val.toUpperCase(),
				Description: model.Description.val,
				Price: model.Price.val,
				PkgSize: model.PkgSize.val,
				Active: model.Active == 'yes',
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(upsertOk, upsertErr);

		function upsertOk(r) {
			// bad upsert response format
			if (!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function upsertErr(r) {
			
			if (r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if (!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if (r.status == 409 || r.status == 422) {
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

		}

		return defer.promise;
	}

	/**
	 *    EXCEL
	 */

	function getExcel(rxid, filename) {

		// params
		if (!validSvc.isRX(rxid) || !validSvc.isText(filename)) {
			throw new Error('customItemRepo.getExcel, rxid and filename are required');
		}

		_currentPurl = 'ops/rx/customndc/excel';
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				RXID: [rxid]
			}
		};

		// call api
		apiService.postGetBinary(_currentPurl, apiRequest).then(okGetExcel, errGetExcel);

		function okGetExcel(r) {
			defer.resolve(r.data);
		}

		function errGetExcel(r) {
			if (r !== null) {
				r = r || {};
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

}
 
feedsRepo.$inject = ['$rootScope', '$q', 'apiService', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc'];
angular
.module('espui.ops')
.factory('feedsRepo', feedsRepo);


/* @ngInject */
function feedsRepo($rootScope, $q, apiService, errSvc, eventSvc, utilSvc, validSvc) {

	// private
	var _currentPurl = '';

	// service definition
	var service = {
		queryVM: queryVM,
		getList: getList,
		getDetail: getDetail,
		reverseFile: reverseFile,
		processFile: processFile,
		archiveFile: archiveFile,
		reloadFile: reloadFile
	};

	return service;


	/**
	 *    QUERY
	 */

	function queryVM() {

		return {
			CE: validSvc.newProp(validSvc.isCE($rootScope.User.CE) ? $rootScope.User.CE : 'ALL'),
			RX: validSvc.newProp(validSvc.isRX($rootScope.User.RX) ? $rootScope.User.RX : 'ALL'),
			MonitorType: 'ALL',
			FeedType: validSvc.newProp('ALL'),
			Status: validSvc.newProp('ALL'),
			StartDate: validSvc.newPropDateNull(),
			EndDate: validSvc.newPropDateNull(),
			Source: validSvc.newProp('ALL')
		};

	}


	/**
	 *    DETAIL MODEL
	 */

	function detailVM(data) {

		data = data || {};

		// fix api arrays
		data.Records = Array.isArray(data.Records) ? data.Records : [];

		return data;

	}


	/**
	 *    GET LIST
	 */

	function getList(query, userMode) {
		_currentPurl = userMode == 'VERITY' ? 'ops/feeds/list' : 'ops/datamonitor/activity/list';
		var defer = $q.defer();

		// create api request
		var apiCE = [],
			apiRX = [],
			apiFeedType = [],
			apiStatus = [],
			apiSource=[];

		switch(userMode) {

			case 'VERITY':
				if(query.CE.vals.length > 0) {
					apiCE = query.CE.vals;
				}
				if(query.RX.vals.length > 0) {
					apiRX = query.RX.vals;
				}
				if(query.FeedType.vals.length > 0) {
					apiFeedType = query.FeedType.vals;
				}
				if(query.Status.vals.length > 0) {
					apiStatus = query.Status.vals;
				}
				if(query.Source.vals.length>0) {
					apiSource = query.Source.vals;
				}
				break;

			case 'CE':
			case 'CDC':
				if(query.CE.val != 'ALL') {
					apiCE = [query.CE.val];
				}
				if(query.FeedType.val != 'ALL') {
					apiFeedType = [query.FeedType.val];
				}
				break;

			default:
				throw new Error('feedsRepo.getList, unknown user mode: ' + userMode);
		}

		var apiReqest = {
			Context: {
				CEID: apiCE,
				RXID: apiRX
			},
			Params: {
				FeedType: apiFeedType,
				ObjectState: apiStatus,
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				Source: apiSource
			},
			Paging: {
				Page: 1,
				Size: 20000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('-ImportDate')]
		};

		// update CE user choice
		if(userMode == 'CE' && validSvc.isCE(query.CE.val)) {
			eventSvc.rootEmit('context.change', {CE: query.CE.val});
		}

		apiService.post(_currentPurl, apiReqest).then(okGetList, errGetList);

		function okGetList(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			var items = r.data.Entity;
			var tooMany = items.length > 20000;
			if(tooMany) {
				items.splice(20001, items.length);
			}

			defer.resolve({
				Items: items,
				TooMany: tooMany
			});

		}

		function errGetList(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    GET DETAIL
	 */

	function getDetail(id, isUserMode) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('feeds.repo.getDetail, id is required');
		}

		var defer = $q.defer();
		_currentPurl = !!isUserMode ? 'ops/datamonitor/activity/get' : 'ops/feeds/get';

		// create api request
		var apiRequest = {
			Params: {
				Id: id
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okGetDetail, errGetDetail);

		function okGetDetail(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(detailVM(r.data.Entity));

		}

		function errGetDetail(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	/**
	 *    REVERSE
	 */

	function reverseFile(params) {

		// params
		if(!!!params || !validSvc.isText(params.id)) {
			throw new Error('feeds.repo.reverseFile, id is required');
		}

		_currentPurl = 'ops/splittrans/reversefile';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Params: {
				Id: params.id,
				ResetFileHash: params.resetFileHash,
				ResetRecordHash: params.resetRecordHash,
				Notes: params.notes
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okReverseFile, errReverseFile);

		function okReverseFile(r) {
			defer.resolve({});
		}

		function errReverseFile(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    PROCESS SKIPPED FILE
	 */

	function processFile(id) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('feeds.repo.processFile, id is required');
		}

		_currentPurl = 'ops/feeds/processfile';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Entity: {
				Params: {
					Id: id
				}
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okReverseFile, errReverseFile);

		function okReverseFile(r) {
			defer.resolve({});
		}

		function errReverseFile(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    ARCHIVE SKIPPED FILE
	 */

	function archiveFile(id) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('feeds.repo.archiveFile, id is required');
		}

		_currentPurl = 'ops/feeds/archivefile';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Entity: {
				Params: {
					Id: id
				}
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okArchiveFile, errArchiveFile);

		function okArchiveFile(r) {
			defer.resolve({});
		}

		function errArchiveFile(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	/**
	 *    MOVE FILE FOR RELOAD
	 */

	function reloadFile(id) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('feeds.repo.reloadFile, id is required');
		}

		_currentPurl = 'ops/feeds/reset';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Entity: {
				Params: {
					Id: id
				}
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okReloadFile, errReloadFile);

		function okReloadFile(r) {
			defer.resolve({});
		}

		function errReloadFile(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

}
 
feedsDetailCtl.$inject = ['$state', '$scope', 'feedsRepo', 'visitsRepo', 'appConst', 'utilSvc', 'validSvc', 'errSvc', 'msgSvc'];
angular
.module('espui.ops')
.controller('FeedsDetailCtl', feedsDetailCtl);


/* @ngInject */
function feedsDetailCtl($state, $scope, feedsRepo, visitsRepo, appConst, utilSvc, validSvc, errSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this,
		_endUserMode = false;

	// inherit sorting and paging features
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);

	// view models
	vm.display = {};

	// view properties
	vm.isWaiting = false;
	vm.FeedId = '';

	// pharm / ce list
	vm.showEntityList = false;
	vm.rxList = [];
	vm.rxListFilter = '';
	vm.ceList = [];
	vm.ceListFilter = '';

	// controls
	vm.reverseFile = reverseFile;
	vm.processFile = processFile;
	vm.archiveFile = archiveFile;
	vm.reloadFile = reloadFile;


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		_endUserMode = $scope.User.Type != 'VERITY' && $scope.User.Type != 'VERITYSA';

		// get feed details
		vm.isWaiting = true;
		vm.FeedId = $state.params.Id;
		getDetail();

	}


	/**
	 *    DISPLAY VIEW MODEL
	 *    built from empty or repo result data
	 */

	function displayVM(repoData) {

		// build the display view model (from empty or from repo data)
		repoData = repoData || {};
		repoData.Records = Array.isArray(repoData.Records) ? repoData.Records : [];

		// parse multiple pharmacies
		repoData.showRxList = false;
		repoData.rxList = [];
		var pharms = Array.isArray(repoData.Pharmacy) ? repoData.Pharmacy : [];

		if(pharms.length < 1) {
			repoData.Pharmacy = 'unknown';
		}
		else if(pharms.length === 1) {
			repoData.Pharmacy = pharms[0];
		}
		else {
			repoData.Pharmacy = 'MULTIPLE (' + pharms.length.toString() + ')';
			pharms.sort();
			repoData.rxList = pharms;
		}

		// parse multiple ces
		repoData.showCeList = false;
		repoData.ceList = [];
		var ces = Array.isArray(repoData.CoveredEntity) ? repoData.CoveredEntity : [];

		if(ces.length < 1) {
			repoData.CoveredEntity = 'unknown';
		}
		else if(ces.length === 1) {
			repoData.CoveredEntity = ces[0];
			repoData.ceList.push(ces[0].toString());
		}
		else {
			repoData.CoveredEntity = 'MULTIPLE (' + ces.length.toString() + ')';
			ces.sort();
			repoData.ceList = ces;
		}

		repoData.SortBy = ['ImportDate'];
		repoData.Paging = {
			Page: 1,
			Size: appConst.app.display.pagingSize,
			Total: vm.getTotalPages(repoData.Records.length, appConst.app.display.pagingSize)
		};

		// process file option
		repoData.showSkippedButtons = repoData.ObjectState == 'SKIPPED';

		// reverse file option
		repoData.showReverseButton = false;
		if(!repoData.showSkippedButtons && $scope.User.Type == 'VERITYSA' && repoData.ObjectState != 'REVERSED' && repoData.ObjectState != 'QUEUED') {
			var feedType = repoData.FeedType;
			if(feedType == 'SPLITTRANS' || feedType == 'PATIENTVISITS' || feedType == 'EPRESCRIBE') {
				repoData.showReverseButton = true;
			}
		}

		// move file for reload option
		repoData.showReloadButton = false;
		if(!repoData.showSkippedButtons && !repoData.showReverseButton && $scope.User.Type == 'VERITYSA' && repoData.RecordsProcessed < 1 && (repoData.ObjectState == 'WARNING' || repoData.ObjectState == 'ERROR' || repoData.ObjectState == 'PROCESSED')) {
			repoData.showReloadButton = true;
		}

		return repoData;

	}


	/**
	 *    GET DETAIL
	 */

	function getDetail() {

		vm.isWaiting = true;

		feedsRepo.getDetail(vm.FeedId, _endUserMode).then(ok, err);

		function ok(r) {
			vm.display = displayVM(r);
			vm.isWaiting = false;
		}

		function err(r) {
			vm.isWaiting = false;
			if(!!r) {
				errSvc.error('Feed Id not found', 'feeds.detail.getDetail.err', r.status, vm.FeedId + ': ' + utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    REVERSE
	 */

	function reverseFile(unlockForReload) {

		// Reverse this file

		if(vm.isWaiting) {
			return;
		}

		switch(vm.display.FeedType) {

			case 'SPLITTRANS':

				// unlock file hash to allow user file reload
				vm.display.unlockForReload = !!unlockForReload;

				msgSvc.confirm({
					id: 'ops.feeds.splittrans.reverse',
					title: 'Reverse File',
					msg: 'Reverse all transactions in this file?',
					notes: {
						prompt: 'optional notes',
						maxlength: 100
					},
					buttons: [
						{text:'OK', result:'YES', cancel: false},
						{text:'CANCEL', result:'CANCEL', cancel: true}
					]
				}).then(userConfirm, userConfirm);
				break;

			case 'PATIENTVISITS':
			case 'EPRESCRIBE':

				if(vm.display.ceList.length < 1) {
					msgSvc.ok('File Reverse Not Allowed', 'At least 1 CEID must be known to reverse a PATIENTVISITS or EPRESCRIBE file.');
					return;
				}

				// unlock file hash to allow user file reload
				vm.display.unlockForReload = !!unlockForReload;

				var revTitle = vm.display.FeedType == 'PATIENTVISITS' ? 'Patient Visits' : 'Eprescribe';
				msgSvc.confirm({
					id: 'ops.feeds.visits.reverse',
					title: 'Reverse ' + revTitle + ' File',
					msg: 'Confirm reverse of Encounter File?',
					notes: {
						prompt: 'optional notes',
						maxlength: 100
					},
					buttons: [
						{text:'OK', result:'YES', cancel: false},
						{text:'CANCEL', result:'CANCEL', cancel: true}
					]
				}).then(userConfirm, userConfirm);
				break;

			default:
				alert('feedsDetailCtl.reverseFile, reverse FeedType unknown: ' + vm.display.FeedType);
		}

	}

	function userConfirm(r) {

		// async delegate handler for OK to delete message box

		// user said yes
		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;
			msgSvc.wait(true);

			var nt = validSvc.isText(r.notes) ? r.notes : '';

			switch(vm.display.FeedType) {

				case 'SPLITTRANS':
					feedsRepo.reverseFile({
						id: vm.display.Id,
						resetFileHash: !!vm.display.unlockForReload,
						resetRecordHash: !!vm.display.unlockForReload,
						notes: nt
					}).then(okReverse, errReverse);
					break;

				case 'PATIENTVISITS':
				case 'EPRESCRIBE':

					visitsRepo.reverseVisitMulti({
						CE: vm.display.ceList[0],
						type: 'FILE',
						val: vm.display.Id,
						useDate: false,
						resetFileHash: !!vm.display.unlockForReload,
						resetRecordHash: !!vm.display.unlockForReload
					}, nt).then(okReverse, errReverse);
					break;

				default:
					alert('feedsDetailCtl.reverseFile, reverse FeedType unknown: ' + vm.display.FeedType);
			}
		}

		function okReverse(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			msgSvc.okAsync('File Reverse Success', 'File reversal record has been created, it will be processed shortly.', 'ops.feeds-detail.okreverse').then(getDetail, getDetail);
		}

		function errReverse(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			if(!!r) {
				errSvc.error('Unexpected error', 'feedsCtl.reverse', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    PROCESS SKIPPED FILE
	 */

	function processFile() {

		if(vm.isWaiting) {
			return;
		}

		msgSvc.confirm({
			id: 'ops.feeds.processfile',
			title: 'Process File',
			msg: 'Process this skippped file?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirmProcFile, userConfirmProcFile);

	}

	function userConfirmProcFile(r) {

		// user said yes
		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;
			msgSvc.wait(true);

			feedsRepo.processFile(vm.display.Id).then(okProcFile, errProcFile);
		}

		function okProcFile(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			msgSvc.okAsync('File Processing', 'File is no longer in SKIPPED status, it will be processed shortly.', 'ops.feeds.processfile').then(getDetail, getDetail);
		}

		function errProcFile(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			if(!!r) {
				errSvc.error('Unexpected error', 'feedsCtl.processFile', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    ARCHIVE SKIPPED FILE
	 */

	function archiveFile() {

		if(vm.isWaiting) {
			return;
		}

		msgSvc.confirm({
			id: 'ops.feeds.archivefile',
			title: 'Archive File',
			msg: 'Archive this skippped file?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirmArchiveFile, userConfirmArchiveFile);

	}

	function userConfirmArchiveFile(r) {

		// user said yes
		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;
			msgSvc.wait(true);

			feedsRepo.archiveFile(vm.display.Id).then(okArchiveFile, errArchiveFile);
		}

		function okArchiveFile(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			msgSvc.okAsync('File Ready for Archive', 'File is no longer in SKIPPED status, it will be archived shortly.', 'ops.feeds.archivefile').then(getDetail, getDetail);
		}

		function errArchiveFile(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			if(!!r) {
				errSvc.error('Unexpected error', 'feedsCtl.archiveFile', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    RELOAD FILE
	 */

	function reloadFile() {

		if(vm.isWaiting) {
			return;
		}

		msgSvc.confirm({
			id: 'ops.feeds.reloadfile',
			title: 'Move File for Reload',
			msg: 'Move this feed file back the import folder for reload?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirmReloadFile, userConfirmReloadFile);

	}

	function userConfirmReloadFile(r) {

		// user said yes
		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;
			msgSvc.wait(true);

			feedsRepo.reloadFile(vm.display.Id).then(okReloadFile, errReloadFile);
		}

		function okReloadFile(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			msgSvc.okAsync('File Moved for Reload', 'File has been moved back to import folder for reload', 'ops.feeds.reloadfile').then(getDetail, getDetail);
		}

		function errReloadFile(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			if(!!r) {
				errSvc.error('Unexpected error', 'feedsCtl.reloadFile', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}

}
 
locationsRepo.$inject = ['$rootScope', '$q', 'apiService', 'apiErrors', 'appConst', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
.module('espui.ops')
.factory('locationsRepo', locationsRepo);


/* @ngInject */
function locationsRepo($rootScope, $q, apiService, apiErrors, appConst, errSvc, eventSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _currentPurl = '',
		_apiPaging = vmSvc.api.paging(),
		_pending = {};

	// service definition
	var service = {
		contextVM: contextVM,

		getList: getList,
		getDetail: getDetail,

		updateConfig : updateConfig,
		update : update,
		create : create,
		deleteLoc : deleteLoc, 

		uploadFile: uploadFile,
		bulkSave: bulkSave,

		getExcel: getExcel

	};

	return service;


	/**
	 *    VIEW MODELS
	 */

	function contextVM(ceid) {

		// ce affs
		var affs = utilSvc.aff.findStatus($rootScope.User.AffList),
			uType = $rootScope.User.Type;

		return {
			isCE: uType == 'CE',
			isVerity: uType == 'VERITYSA' || uType == 'VERITY',
			CE: validSvc.newProp(validSvc.isCE(ceid) ? ceid : $rootScope.User.CE),
			CeList: utilSvc.aff.ceList(affs)
		};

	}


	/**
	 *    GET LIST / DETAIL
	 */

	function getList(ceid) {

		// params
		if(!validSvc.isText(ceid)) {
			throw new Error('locationsRepo.getList, ceid is missing: '+ceid);
		}

		_currentPurl = 'ops/ce/location/list';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid]
			}
		};
		// save CE user choice
		_pending = {CE: ceid};

		apiService.post(_currentPurl, apiRequest).then(okGetList, errGetList);

		function okGetList(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update user CE choice
			eventSvc.rootEmit('context.change', {
				CE: _pending.CE,
				RX: $rootScope.User.RX
			});

			defer.resolve(r.data.Entity);

		}

		function errGetList(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	function getDetail(ceid, id) {

		// params
		if(!validSvc.isCE(ceid) || !validSvc.isText(id)) {
			throw new Error('locationsRepo.getDetail, ceid and id required');
		}

		_currentPurl = 'ops/ce/location/get';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid]
			},
			Params: {
				Id: id
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okGetDetail, errGetDetail);

		function okGetDetail(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// translate LocationId to Id
			r.data.Entity.Id = validSvc.isText(r.data.Entity.LocationId) ? r.data.Entity.LocationId.toUpperCase() : '';
			defer.resolve(r.data.Entity);

		}

		function errGetDetail(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    CREATE / UPDATE / DELETE
	 */

	function create(ceid, model) {
		return upsert('ops/ce/location/add', ceid, model);
	}

	function update(ceid, model) {
		return upsert('ops/ce/location/save', ceid, model);
	}

	function deleteLoc(ceid, model) {
		return upsert('ops/ce/location/delete', ceid, model);
	}

	function upsert(purl, ceid, model) {

		_currentPurl = purl;
		_pending = model;
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [ceid]
			},
			Entity: {
				LocationId: model.Id.val.toUpperCase(),
				Description: model.Description.val,
				MedicaidAccount: model.MedicaidAccount.val,
				StartDate: utilSvc.dt.toServerDateExactPSTNoon(model.StartDate.val),
				EndDate: utilSvc.dt.toServerDateExactPSTNoon(model.EndDate.val),
				ForMatching: model.ForMatching == 'yes',
				ForSplitTrans: model.ForSplitTrans == 'yes'
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(upsertOk, upsertErr);

		function upsertOk(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function upsertErr(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapApiErrorsToModel(r, _pending);
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// translate LocationId into Id
				if(fieldName == 'LocationId') {
					fieldName = 'Id';
				}

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);
				if(fieldObj === undefined) {
					throw new Error('locationsRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
				}

				// set failed state
				fieldObj.fail = 'yes';
				fieldObj.msg = entity.Fields[i].Rule;

			}

			return m;

		}

		return defer.promise;
	}

	function updateConfig(ceid, enabled, eligible)  {

		// params
		if(!validSvc.isText(ceid.val)) {
			throw new Error('locations.updateConfig, id is missing');
		}
		// set purl
		_currentPurl = 'ops/ce/location/enable';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {CEID : [ceid.val]},
			Entity: {
				Params: {
					Enabled: enabled,
					Eligible: eligible
				}
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okStat, errStat);

		function okStat(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function errStat(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else {
				throw new Error('locationsRepo.errStat, unexpected error result');
			}

		}


		return defer.promise;

	}


	function uploadFile(ceid, importFile) {

		// params
		if(!validSvc.isCE(ceid) || !!!importFile) {
			throw new Error('locationsRepo.uploadFile, required: CE and import file');
		}

		_currentPurl = 'ops/ce/location/import';
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [ceid]
			}
		};

		// create multi-part form data
		var fd = new FormData();
		fd.append('context', angular.toJson(apiRequest)); // stringify JSON into one "context" property
		fd.append('file', importFile);

		apiService.postFile(_currentPurl, fd, false).then(okFileImport, errFileImport);

		function okFileImport(r) {

			// bad upsert response format
			if(!!!r || !!!r.data || !!!r.data.Entity) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			var ent = r.data.Entity,
				result = mapApiFileProcessCounts({}, ent);

			// has errors? 200 return may have errors
			if(Array.isArray(ent.RecordErrors) && ent.RecordErrors.length > 0) {
				r.status = 422;
				errFileImport(r);
			}
			else {
				result.status = 200;
				defer.resolve(result);
			}

		}

		function errFileImport(r) {

			if(r === null) {
				defer.reject(null);
			}
			else if(!!!r || !validSvc.isNumber(r.status) || !!!r.data) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status === 422 && !!r.data.Entity) {
				var ent = r.data.Entity;
				r = mapApiFileProcessCounts(r, ent);
				r.RecordErrors = mapApiRecordErrors(ent);
				defer.reject(r);
			}
			else {
				errSvc.error('Unexpected error', _currentPurl + 'locationsRepo.errFileImport', r.status, utilSvc.http.safeResponse(r));
			}

		}

		function mapApiFileProcessCounts(r, ent) {

			r.Processed = ent.ProcessedCount;
			r.Received = ent.ReceivedCount;
			r.Error = ent.ErrorCount;
			r.Duplicate = ent.DuplicateCount;

			return r;
		}

		function mapApiRecordErrors(entity) {

			// map server 422 fields onto import error text lines

			if(Array.isArray(entity.RecordErrors) && entity.RecordErrors.length > 0) {
				return entity.RecordErrors;
			}
			else if(entity.ROOT.length > 0) {
				return [{Name: 'File Error', Rule: entity.ROOT.join(',')}];
			}
			else {
				throw new Error('locationsRepo.422FileImport, Api returned no errors to display');
			}
		}

		return defer.promise;

	}


	/**
	 *    BULK SAVE
	 */

	function bulkSave(ceid, forMatching, forSplitTrans) {

		// params
		if(!validSvc.isText(ceid) || !validSvc.isText(forMatching) || !validSvc.isText(forSplitTrans)) {
			throw new Error('locations.bulkSave, ceid, both options required');
		}
		// set purl
		_currentPurl = 'ops/ce/location/bulksave';
		var defer = $q.defer();

		if(forMatching == 'none') {
			forMatching = 'na';
		}
		if(forSplitTrans == 'none') {
			forSplitTrans = 'na';
		}

		// create api request
		var apiReqest = {
			Context: {CEID : [ceid]},
			Params: {
				ForMatching: forMatching.toUpperCase(),
				ForSplitTrans: forSplitTrans.toUpperCase()
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okBulkSave, errBulkSave);

		function okBulkSave(r) {

			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errBulkSave(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else {
				defer.reject(r);
			}

		}

		return defer.promise;

	}


	/**
	 *    EXCEL
	 */

	function getExcel(ceid, filename) {

		// params
		if(!validSvc.isCE(ceid) || !validSvc.isText(filename)) {
			throw new Error('locationsRepo.getExcel, ceid and filename are required');
		}

		_currentPurl = 'ops/ce/location/excel';
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [ceid]
			}
		};

		// call api
		apiService.postGetBinary(_currentPurl, apiRequest).then(okGetExcel, errGetExcel);

		function okGetExcel(r) {
			defer.resolve(r.data);
		}

		function errGetExcel(r) {
			if(r !== null) {
				r = r || {};
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

}
 
/**
 *    LOCATIONS CONTROLLER
 *    shared across CE admin and CE user features
 */

locationsCtl.$inject = ['$window', '$scope', '$state', '$timeout', 'locationsRepo', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc'];
angular
	.module('espui.ops')
	.controller('LocationsCtl', locationsCtl);


/* @ngInject */
function locationsCtl($window, $scope, $state, $timeout, locationsRepo, validSvc, errSvc, utilSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this,
		_viewErrRoute = '',
		_pendingExcelFilename = '',
		_tabFilters = {},
		_regexDate = utilSvc.regex.dateFmt(),
		_pagingEventListener = null,
		_fileImportListener = null;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = false;
	vm.action = '';
	vm.isWaiting = false;

	// query
	vm.CeDroplist = [];
	vm.queryChangeCE = queryChangeCE;

	// models
	vm.context = {};
	vm.locations = {};
	vm.found = {};
	vm.model = {};

	// filter and tabs
	vm.flt = {};
	vm.activeTab = '';
	vm.tabChange = tabChange;
	vm.filterChange = filterChange;

	// option display
	vm.options = {};
	vm.optionsTitle = optionsTitle;
	vm.optionEligTitle = optionEligTitle;

	// option editing
	vm.optionEdit = {};
	vm.optionEditToggle = optionEditToggle;
	vm.optionSave = optionSave;

	// location editing
	vm.getDetail = getDetail;
	vm.submitModel = submitModel;
	vm.deleteLocation = deleteLocation;

	// popup
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;

	// file import
	vm.importSelectedFiles = [];
	vm.importErrors = [];
	vm.importCsvSend = importCsvSend;

	vm.bulkSave = bulkSave;

	// excel
	vm.getExcel = getExcel;


	/**
	 *    EVENT HOOKS
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		var items = vm.activeTab == 'LOC' ? vm.locations.Items : vm.found.Items;
		if(!vm.flt.Ready || !Array.isArray(items) || items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);

		// re-render table by filtering it again
		if(vm.activeTab == 'LOC') {
			filterChange(vm.flt, vm.locations, true);
		}
		else {
			filterChange(vm.flt, vm.found, true);
		}

	});

	_fileImportListener = $scope.$on('widget.input.file', function(event, importInfo) {
		event.stopPropagation();

		if(!!importInfo && !!importInfo.files && importInfo.files.length > 0) {
			vm.importSelectedFiles = importInfo.files;
		}
		else {
			vm.importSelectedFiles = [];
		}

	});


	/**
	 *    DESTROY
	 */

	$scope.$on('$destroy', function() {
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
		if(!!_fileImportListener) {
			_fileImportListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		vm.init = true;

		// route properties
		var params = $state.params || {};
		var paramCEID = params.CE;
		_viewErrRoute = params.ViewErrRoute;

		// set view type and title
		var stateName = $state.current.name;
		switch (stateName) {

			case 'ops.locations':
				_viewErrRoute = 'home';
				$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
				break;

			case 'admin.ce.edit.locations':
				_viewErrRoute = 'admin.ce.list';

				// admin route must have CE param
				if(!validSvc.isCE(paramCEID)) {
					throw new Error('locationsCtl.init, param.CE required');
				}

				break;
			default:
				throw new Error('locationsCtl.init, unknown route: ' + stateName);
		}

		initQueryAndFilters(paramCEID);
		queryChangeCE();

	}

	function initQueryAndFilters(ceid) {

		vm.context = locationsRepo.contextVM(ceid);
		vm.context.canEdit = utilSvc.user.hasFeature($scope, 'ops.locations.edit') || vm.context.isVerity;

		_tabFilters = {
			LOC: vm.initFilters({
				Config: {
					Dates: ['StartDate', 'EndDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['Id']
			}),
			FOUND: vm.initFilters({
				SortBy: ['-LastWeek']
			})
		};

		// CE drop list
		vm.CeDroplist = utilSvc.ng.droplist(vm.context.CeList, '', '', [{ label: 'Choose a Facility', value: 'NONE' }]);

	}


	/**
	 *    VIEWMODELS
	 */

	function locationsVM(items) {

		// configured locations

		items = Array.isArray(items) ? items : [];

		var item = {};
		for (var i = 0; i < items.length; i++) {
			item = items[i];

			item.Id = item.LocationId.toUpperCase();
			item.StartDate = validSvc.isDate(item.StartDate) ? item.StartDate : null;
			item.EndDate = validSvc.isDate(item.EndDate) ? item.EndDate : null;

			item.ForMatching = !!item.ForMatching ? 'YES' : 'NO';
			item.ForSplitTrans = !!item.ForSplitTrans ? 'YES' : 'NO';
		}

		return {
			DataItems: items,
			Items: []
		};

	}

	function foundVM(items) {

		// locations found in feeds

		items = Array.isArray(items) ? items : [];

		var item = {},
			idProp = {};

		for (var i = 0; i < items.length; i++) {
			item = items[i];

			item.Id = validSvc.isText(item.LocationId) ? item.LocationId.toUpperCase() : '';
			item.Status = !!item.Configured ? 'ADDED' : 'FOUND';

			idProp = validateLocationId({val: item.Id});
			if(idProp.fail == 'yes') {
				item.Status = 'INVALID';
				item.StatusTxt = idProp.msg;
			}
		}

		return {
			DataItems: items,
			Items: []
		};

	}

	function modelVM(item) {

		item = item || {};

		// opa date min/max (340B started Nov 1992)
		var dateMin = new Date(1992, 10, 1, 0, 0, 0),
			dateMax = utilSvc.dt.zeroTime(utilSvc.dt.addDays(new Date(), 365));

		// clean up change log null arrays
		var chgItems = Array.isArray(item.ChangeLog) ? item.ChangeLog : [];
		for(var i = 0; i < chgItems.length; i++) {
			chgItems[i].ChangedProperties = Array.isArray(chgItems[i].ChangedProperties) ? chgItems[i].ChangedProperties : [];
		}

		return {
			Id: validSvc.newProp(validSvc.isText(item.Id) ? item.Id : ''),
			Description: validSvc.newProp(item.Description),
			MedicaidAccount: validSvc.newProp(item.MedicaidAccount),
			StartDate: validSvc.newPropDateExact(utilSvc.dt.fromServerDateExactUTC(item.StartDate), dateMin, dateMax),
			EndDate: validSvc.newPropDateExact(utilSvc.dt.fromServerDateExactUTC(item.EndDate), dateMin, dateMax),
			ForMatching: !!item.ForMatching ? 'yes' : 'no',
			ForSplitTrans: !!item.ForSplitTrans ? 'yes' : 'no',
			ChangeLog: chgItems
		};

	}


	/**
	 *    QUERY CHANGE
	 */

	function queryChange() {

		if(!vm.init) {
			vm.action = '';
			vm.activeTab = '';
			closePopup();

			vm.options = {};
			vm.locations = {};
			vm.found = {};
			vm.model = {};

			$scope.$broadcast('widget.paging');
		}
	}

	function queryChangeCE() {

		queryChange();

		vm.context.CE.fail = validSvc.isCE(vm.context.CE.val) ? 'no' : 'yes';
		if(vm.context.CE.fail == 'no') {
			getList();
		}

	}

	function tabChange(newTab) {

		vm.activeTab = newTab;
		vm.flt = vm.resetFilters(_tabFilters[newTab]);

		switch(newTab) {

			case 'LOC':
				vm.locations.Items = vm.filterList(vm.locations.DataItems, vm.flt);
				vm.found.Items = [];
				break;

			case 'FOUND':
				vm.found.Items = vm.filterList(vm.found.DataItems, vm.flt);
				vm.locations.Items = [];
				break;

			default:
				throw new Error('LocationsCtl.tabChange, unknown tab: ' + newTab);
		}

		$scope.$broadcast('widget.paging', {
			uniqueId: newTab,
			Size: vm.flt.PageSize,
			Page: vm.flt.Page,
			Total: vm.flt.PageTotal,
			RowCount: vm.flt.Count,
			ItemCount: newTab == 'LOC' ? vm.locations.Items.length : vm.found.Items.length,
			DataCount: newTab == 'LOC' ? vm.locations.DataItems.length : vm.found.DataItems.length
		});

		vm.flt.Ready = true;
		vm.action = 'LIST';

	}


	/**
	 *    GET LISTS FOR LOCATIONS AND FOUND
	 */

	function getList() {

		if(vm.isWaiting) {
			return;
		}
		vm.init = false;
		queryChange();

		vm.isWaiting = true;
		msgSvc.wait(true);

		locationsRepo.getList(vm.context.CE.val).then(okGetList, errGetList);

		function okGetList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.options = {
				On: !!r.Enabled ? 'ON' : 'OFF',
				Elig: !!r.Eligible ? 'yes' : 'no'
			};

			vm.locations = locationsVM(r.Locations);
			vm.found = foundVM(r.Statistics);

			// load default tab
			tabChange('LOC');

		}

		function errGetList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Not able to get locations.', 'locationsCtl.errLocationsList', r.status, utilSvc.http.safeResponse(r));
			}

			$state.go(_viewErrRoute, {}, { reload: _viewErrRoute });
		}

	}


	/**
	 *    FILTER CHANGE
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			switch(vm.activeTab) {
				case 'LOC':
					vm.locations.Items = vm.filterList(vm.locations.DataItems, vm.flt);
					break;
				case 'FOUND':
					vm.found.Items = vm.filterList(vm.found.DataItems, vm.flt);
					break;
				default:
					return;
			}
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			$scope.$broadcast('widget.paging', {
				uniqueId: vm.activeTab,
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.activeTab == 'LOC' ? vm.locations.Items.length : vm.found.Items.length,
				DataCount: vm.activeTab == 'LOC' ? vm.locations.DataItems.length : vm.found.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					_tabFilters[vm.activeTab] = vm.flt;
				}
			},1000);

		}, delayTime);

	}


	/**
	 *    OPTION EDITING
	 */

	function optionEditToggle(showEdit) {

		if(vm.isWaiting) {
			return;
		}

		// copy values to edit control so user change doesn't affect them until confirmed by api
		vm.optionEdit = {
			show: showEdit,
			On: !!showEdit ? vm.options.On : '',
			Elig: !!showEdit ? vm.options.Elig : ''
		};

	}

	function optionSave() {

		// change filtering saves both eligible and enabled list state

		msgSvc.confirm({
			id: 'locations.enabled',
			title: 'Save Location Options',
			msg: 'Confirm ' + optionsTitle(vm.optionEdit),
			buttons: [
				{ text: 'OK', result: 'YES', cancel: false },
				{ text: 'CANCEL', result: 'CANCEL', cancel: true }
			]
		}).then(confirmOptionSave, confirmOptionSave);

	}

	function confirmOptionSave(r) {

		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;
			locationsRepo.updateConfig(vm.context.CE, vm.optionEdit.On == 'ON', vm.optionEdit.Elig == 'yes').then(okOptionSave, errOptionSave);
		}

		function okOptionSave(r) {
			vm.isWaiting = false;
			optionEditToggle(false);

			msgSvc.ok('Options Saved');
			getList();
		}

		function errOptionSave(r) {
			vm.isWaiting = false;

			if(!!!r || r == null) {
				// already handled
				$state.go(_viewErrRoute, {}, { reload: _viewErrRoute });
			}
			else if(r.status == 409) {
				// conflict
				errSvc.info('Could not save options. Try again.', 'locationsCtl.errOptionSave', r.status, utilSvc.http.safeResponse(r));
				_pendingStatus = '';
			}
			else {
				errSvc.error('Unknown option save error', 'locationsCtl.errOptionSave', r.status, utilSvc.http.safeResponse(r));
			}

		}
	}


	/**
	 *    LOCATION CREATE / ADD / EDIT
	 */

	function getDetail(id) {

		if(vm.isWaiting) {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		locationsRepo.getDetail(vm.context.CE.val, id).then(okGetDetail, errGetDetail);

		function okGetDetail(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.model = modelVM(r);
			vm.popup.ready = true;

		}

		function errGetDetail(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Not able to get location.', 'locationsCtl.errGetDetail', r.status, utilSvc.http.safeResponse(r));
			}

			$state.go(_viewErrRoute, {}, { reload: _viewErrRoute });

		}

	}

	function validateLocationId(prop) {

		// LocationId - required, 2 to 50 characters
		prop = validText(prop, 2, 50);
		if(prop.fail == 'no') {
			prop.val = prop.val.toUpperCase();

			// alphanumeric, or spaces allowed
			var regexAcctId = /[^A-Z0-9\ \-_]/;
			prop.fail = regexAcctId.test(prop.val) ? 'yes' : 'no';
			if(prop.fail == 'yes') {
				prop.msg = 'must contain alpha-numeric, spaces, dash or underscore only';
			}
		}

		return prop;
	}


	/**
	 *    SUBMIT
	 */

	function validLocation(m) {

		// start date, required format must be m/d/yyyy
		m.StartDate = validSvc.propDateValid(m.StartDate, _regexDate);
		m.StartDate.fail = !!m.StartDate.fail ? 'yes' : 'no';

		// end date (optional), format must be m/d/yyyy
		if(validSvc.isText(m.EndDate.val)) {
			m.EndDate = validSvc.propDateValid(m.EndDate, _regexDate);
			m.EndDate.fail = !!m.EndDate.fail ? 'yes' : 'no';

			// end > start
			if(m.EndDate.fail == 'no' && utilSvc.dt.diffMilli(new Date(m.StartDate.val), new Date(m.EndDate.val)) <= 0) {
				m.EndDate.fail = 'yes';
				m.EndDate.msg = 'must be greater than start date';
			}
		}
		else {
			m.EndDate.val = '';
			m.EndDate.fail = '';
		}

		// LocationId - required, 2 to 40 characters, alphanumeric
		m.Id = validateLocationId(m.Id);
		if(m.Id.fail == 'no') {
			m.Id.val = m.Id.val.toUpperCase();
		}

		// Description - optional, to 100 characters
		if(validSvc.isText(m.Description.val)) {
			m.Description.val = m.Description.val.trim();
			m.Description = validText(m.Description, 0, 100);
		}
		else {
			m.Description.fail = '';
		}

		// MedicaidAccount - optional, 2 to 20 characters
		if(validSvc.isText(m.MedicaidAccount.val)) {
			m.MedicaidAccount.val = m.MedicaidAccount.val.trim();
			m.MedicaidAccount = validText(m.MedicaidAccount, 2, 20);
		}
		else {
			m.MedicaidAccount.fail = '';
		}

		return m.Id.fail != 'yes' &&
			m.Description.fail != 'yes' &&
			m.MedicaidAccount.fail != 'yes' &&
			m.StartDate.fail != 'yes' &&
			m.EndDate.fail != 'yes';

	}

	function submitModel() {

		if(vm.isWaiting) {
			return;
		}

		// validate
		if(!validLocation(vm.model)) {
			msgSvc.ok('Cannot Save', 'Check property values.');
			return;
		}
		vm.isWaiting = true;

		// note: editing is done in the popup, use popup type as the action

		// create or update
		if(vm.popup.type == 'ADD' || vm.popup.type == 'CREATE') {
			locationsRepo.create(vm.context.CE.val, vm.model).then(okSubmit, errSubmit);
		}
		else {
			locationsRepo.update(vm.context.CE.val, vm.model).then(okSubmit, errSubmit);
		}

		function okSubmit(entity) {
			vm.isWaiting = false;

			var detailMsg = vm.popup.type == 'UPDATE' ? 'Updated' : 'Added';
			msgSvc.ok('Location Saved', 'Location ' + detailMsg);

			getList();
		}

		function errSubmit(r) {
			vm.isWaiting = false;

			if(r == null) {
				// already handled
				closePopup();
			}
			else if(r.status == 409) {
				// conflict
				msgSvc.ok('Cannot Save', 'May already exist in the database. Verify and try again.');
			}
			else if(r.status == 422) {
				// validation
				msgSvc.ok('Cannot Save', 'Verify all field values.');
				vm.model = r.model;
			}
			else {
				errSvc.error('Unknown add / update error response', 'payorEditCtl.errSubmit', r.status, utilSvc.http.safeResponse(r));
			}

		}
	}

	function deleteLocation() {

		if(vm.isWaiting) {
			return;
		}

		msgSvc.confirm({
			id: 'location.delete',
			title: 'Delete Location: ' + vm.model.Id.val,
			msg: 'Confirm delete Location, this action cannot be reversed.',
			buttons: [
				{ text: 'OK', result: 'YES', cancel: false },
				{ text: 'CANCEL', result: 'CANCEL', cancel: true }
			]
		}).then(confirmDel, confirmDel);

	}

	function confirmDel(r) {

		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;
			locationsRepo.deleteLoc(vm.context.CE.val, vm.model).then(okDel, errDel);
		}

		function okDel(r) {
			vm.isWaiting = false;
			msgSvc.ok(vm.model.Id.val + ' Deleted');

			getList();
		}

		function errDel(r) {
			vm.isWaiting = false;

			if (!!r) {
				errSvc.error('Unknown delete error response', 'locationCtl.locationDelete', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}

	/**
	 *    POPUP
	 */

	function popTitle(popType, eligTxt) {

		switch(popType) {
			case 'CREATE':
				return 'Create ' + eligTxt + ' Location';
			case 'ADD':
				return 'Add Found to ' + eligTxt + ' Locations';
			case 'UPDATE':
				return 'Update ' + eligTxt + ' Location';
			case 'IMPORT':
				return 'Import ' + eligTxt + ' Locations';
			case 'BULKSAVE':
				return 'Bulk Save All ' + eligTxt + ' Locations';
			default:
				return '';
		}
	}

	function openPopup(evt, item, popType) {

		// shared handler to open editing and import popups

		if(vm.isWaiting) {
			return;
		}

		vm.popup = {
			type: popType,
			title: popTitle(popType, optionEligTitle(vm.options)),
			showLog: false,
			ready: false
		};

		switch(popType) {

			case 'CREATE':
				vm.model = modelVM();
				break;

			case 'ADD':
				vm.model = modelVM({Id: item.Id});
				break;

			case 'UPDATE':
				vm.model = {};
				getDetail(item.Id); // ASYNC
				break;

			case 'IMPORT':
				vm.importErrors = [];
				vm.importSelectedFiles = [];

				// check for File API and FormData upload browser support
				if(!validSvc.uploadSupported()) {
					msgSvc.ok('File Upload Not Supported', 'File Upload uses HTML5 FormData upload, your browser does not support it. Please upgrade to use file upload.');
					return;
				}
				break;

			case 'BULKSAVE':
				var mCount = 0,
					sCount = 0,
					locItems = vm.locations.DataItems;
				for(var i = 0; i < locItems.length; i++) {
					if(locItems[i].ForMatching == 'YES') {
						mCount++;
					}
					if(locItems[i].ForSplitTrans == 'YES') {
						sCount++;
					}
				}
				vm.popup.ForMatching = 'none';
				vm.popup.ForSplitTrans = 'none';
				vm.popup.ForMatchingCount = mCount;
				vm.popup.ForSplitTransCount = sCount;
				break;

			default:
				throw new Error('locationsCtl.openPopup, unknown popType: ' + popType);
		}

		var offsetY = 0;
		if(popType == 'IMPORT' || popType == 'CREATE' || popType == 'BULKSAVE') {
			// fix import at top
			offsetY = 50;
		}
		else {
			// loop html element parents to calculate top offset
			offsetY = -200;
			var elem = evt.target;
			while(!!elem) {

				// top element found
				if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
					break;
				}

				// add offset, get next element
				offsetY += elem.offsetTop;
				elem = elem.offsetParent;
			}
			elem = null;
		}

		// move popup to clicked row
		var popup = document.getElementById('ceLocationPopupContent');
		if(!!popup) {
			popup.style.top = offsetY.toString() + 'px';
		}

		// wait for digest before showing
		$timeout(function() {
			vm.popup.ready = true;
		}, 100);

	}

	function closePopup() {
		vm.popup = {};
		vm.model = {};
		vm.importErrors = [];
		vm.importSelectedFiles = [];
	}


	/**
	 *    LOCATION IMPORT
	 */

	function importValidFile(newFile) {

		// required
		if(!!!newFile) {
			return 'no file selected';
		}

		// file size > 0 bytes, < 10 megabytes
		if(!validSvc.isNumber(newFile.size) || newFile.size < 1 || newFile.size > 10000000) {
			return 'file size must be 2 bytes to 10 megabytes';
		}

		// file name must be .csv
		var fName = newFile.name;
		if(!validSvc.isText(fName) || fName.length < 5 || (fName.substr(fName.length - 4, 4).toLowerCase() !== '.csv' && fName.substr(fName.length - 4, 4).toLowerCase() !== '.txt')) {
			return 'file name must end with extension ".csv" or ".txt"';
		}

		return 'ok';

	}

	function importCsvSend() {

		// import CSV file

		if(vm.isWaiting) {
			return;
		}

		// files selected
		if(!!!vm.importSelectedFiles || vm.importSelectedFiles.length !== 1) {
			msgSvc.ok('File Import', 'Please choose 1 file to upload.');
			return;
		}

		// validate file
		var fileFail = importValidFile(vm.importSelectedFiles[0]);
		if(fileFail != 'ok') {
			msgSvc.ok('File Import', 'Selected file error: ' + fileFail);
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		locationsRepo.uploadFile(vm.context.CE.val, vm.importSelectedFiles[0]).then(okFileImport, errFileImport);

		function okFileImport(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;
			msgSvc.okAsync('Import Complete', r.Processed + ' Locations Processed', 'ops.location.import').then(getList, getList);
		}

		function errFileImport(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(r === null) {
				return;
			}
			else if (r.status === 422) {
				vm.importErrors = r;
				msgSvc.ok('Import Errors', 'Please see line errors during import');
			}
			else {
				errSvc.error('Unexpected api error', 'ops.location.import', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    BULK SAVE
	 */

	function bulkSave() {

		// save all locations with new properties

		if(vm.isWaiting) {
			return;
		}

		if(vm.popup.ForMatching == 'none' && vm.popup.ForSplitTrans == 'none') {
			msgSvc.ok('Cannot Save', 'Select at least 1 bulk property to modify');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		locationsRepo.bulkSave(vm.context.CE.val, vm.popup.ForMatching, vm.popup.ForSplitTrans).then(okBulkSave, errBulkSave);

		function okBulkSave(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			var txt = '';
			if(vm.popup.ForMatching != 'none') {
				txt = vm.popup.ForMatching == 'no' ? 'NOT ' : '';
				txt += 'used for Matching';
			}
			if(vm.popup.ForSplitTrans != 'none') {
				txt += txt.length > 0 ? ' and ' : '';
				txt += vm.popup.ForSplitTrans == 'no' ? 'NOT ' : '';
				txt += 'used for Split Billing';
			}

			msgSvc.okAsync('Bulk Save Complete', 'All locations are ' + txt + '.', 'ops.location.bulksave').then(getList, getList);
		}

		function errBulkSave(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(!!r) {
				errSvc.warn('Unexpected api error', 'ops.location.bulksave', r.status, utilSvc.http.safeResponse(r));
				getList();
			}

		}

	}


	/**
	 *    EXCEL
	 *    get file from server
	 */

	function getExcel() {

		// already working?
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		_pendingExcelFilename = vm.context.CE.val + '-Locations.xlsx';
		locationsRepo.getExcel(vm.context.CE.val, _pendingExcelFilename).then(okServerExcel, errServerExcel);

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Create Excel Error', 'payorList.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}
	}


	/**
	 *    HELPERS
	 */

	function validText(prop, min, max) {

		// required
		if(!validSvc.isText(prop.val)) {
			prop.fail = 'yes';
			prop.msg = 'required';
			return prop;
		}

		// min
		if(prop.val.length < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum ' + min.toString() + ' characters';
			return prop;
		}

		// max
		if(prop.val.length > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum ' + max.toString() + ' characters';
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;

	}

	function findById(items, id) {
		for (var i = 0; i < items.length; i++) {
			if(items[i].Id == id) {
				return i;
			}
		}
		return -1;
	}

	function optionsTitle(opt) {
		return '340B Filtering is: ' + opt.On + ', Locations are: ' + optionEligTitle(opt);
	}

	function optionEligTitle(opt) {
		opt = opt || vm.options;
		return opt.Elig == 'yes' ? 'Eligible' : 'Ineligible';
	}

}
 
matchRepo.$inject = ['$rootScope', '$q', 'apiService', 'apiErrors', 'appConst', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
.module('espui.ops')
.factory('matchRepo', matchRepo);


/* @ngInject */
function matchRepo($rootScope, $q, apiService, apiErrors, appConst, errSvc, eventSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _currentPurl = '',
		_apiPaging = vmSvc.api.paging(),
		_pendingQuery,
		_deferEdit = null;

	// service definition
	var service = {
		contextVM: contextVM,
		getList: getList,
		getSuspect: getSuspect,
		getExcel: getExcel,
		getSentMatch: getSentMatch,

		visitAccept: visitAccept,
		visitReject: visitReject,
		visitRejectAll: visitRejectAll,

		rejectScript: rejectScript,
		unmatchScript: unmatchScript,
		eligOverride: eligOverride,
		undoHistory: undoHistory,

		evalCreate: evalCreate,
		evalUpdate: evalUpdate,
		rematchCreate: rematchCreate,

		bulkStats: bulkStats,
		bulkProcess: bulkProcess,
		bulkProcessUpload: bulkProcessUpload,

		getStatsSummary: matchStats,
		getStatsExcelCompare: getStatsExcelCompare,

		sendToTPA: sendToTPA,
		reviewMatch: reviewMatch,
		reviewSuspect: reviewSuspect,

		buildQueryParams: parseQueryParams,

		createAsyncJob: createAsyncJob,
	};

	return service;

	/**
	 *    CONTEXT
	 */

	function contextVM() {

		var uType = $rootScope.User.Type;

		return {
			uType: uType,
			isDebug: !!$rootScope.debug,
			isVerity: uType == 'VERITYSA' || uType == 'VERITY',
			isRx: uType == 'RX' || uType == 'RXROLLUP',
            isCe: uType == 'CE',
		};

	}
	
	/**
	 *    DETAIL MODEL
	 */

	function detailVM(data) {

		data = data || {};

		// fix api arrays
		var items = Array.isArray(data.SuspectVisits) ? data.SuspectVisits : [],
			item = {};
		for(var i = 0; i < items.length; i++) {
			item = items[i];
			item.uniqueId = i;

			// fix provider dupes and build search text
			var fixP = fixProviders(item.PrescriberNPI, item.PrescriberName);
			item.Prescribers = fixP.Providers;
			item.PrescriberTxt = fixP.SearchTxt;
		}

		return data;

	}

	function fixProviders(npis, names) {

		var noDupes = [],
			result = {
				Providers: [],
				SearchTxt: ''
			};

		npis = Array.isArray(npis) ? npis : [];
		names = Array.isArray(names) ? names : [];

		// should be same length
		if(npis.length != names.length) {
			return result;
		}

		var npi = '';
		for(var i = 0; i < npis.length; i++) {
			npi = npis[i].toString();
			if(noDupes.indexOf(npi) < 0) {
				noDupes.push(npi);
				result.Providers.push({
					NPI: npi,
					Name: names[i]
				});
				result.SearchTxt += '|' + npi + '|' + names[i];
			}
		}

		return result;
	}


	/**
	 *    GET LIST
	 */

	function parseQueryParams(tabName, q) {

		if(tabName != 'MATCH' && tabName != 'SUSPECT' && tabName != 'BULK') {
			return {
				StartDate: q.StartDate.val,
				EndDate: q.EndDate.val,
				DateProperty: q.DateType
			};
		}

		// MATCH and BULK have dynamic properties
		var listParams = [];
		var eligParams = "";
		if(q.DateRangeChk) {
			var dtType = '';
			switch(q.DateType) {
				case 'SERVICE':
					dtType = 'ServiceDate';
					break;
				case 'MATCH':
					dtType = 'MatchedDate';
					break;
				case 'RXWRITTEN':
					dtType = 'RxWrittenDate';
					break;
				default:
					throw new Error('matchRepo.parseQueryParams, DateType unknown: ' + q.DateType);
			}
			var endDt = utilSvc.dt.addDays(utilSvc.dt.zeroTime(new Date(q.EndDate.val)), 1);
			listParams.push({Field: dtType, DataType:'date', Value: q.StartDate.val, Op:'gte'});
			listParams.push({Field: dtType, DataType:'date', Value: endDt, Op:'lt'});
		}
		if(q.EncounterNumber.chk) {
			listParams.push({Field: 'EncounterNumber', DataType:'string', Value: q.EncounterNumber.val, Op:'eq'});
		}
		if(q.RxNumber.chk) {
			listParams.push({Field: 'RxNumber', DataType:'string', Value: q.RxNumber.val, Op:'eq'});
		}
		if(q.ItemCode.chk) {
			listParams.push({Field: 'ItemCode', DataType:'string', Value: q.ItemCode.val, Op:'eq'});
		}
		if(q.PrescriberIdent.chk) {
			listParams.push({Field: 'PrescriberIdent', DataType:'string', Value: q.PrescriberIdent.val, Op:'eq'});
		}

		if(q.SuspectType.chk) {
			listParams.push({Field: 'SuspectType', DataType:'string', Value: q.SuspectType.val, Op:'eq'});
		}
		if(q.DrugType.chk) {
			listParams.push({Field: 'DrugType', DataType:'string', Value: q.DrugType.val == 'BRAND' ? 'B' : 'G', Op:'eq'});
		}
		if(q.TotalAmountPaid.chk) {
			listParams.push({Field: 'TotalAmountPaid', DataType:'number', Value: parseFloat(q.TotalAmountPaid.val), Op:'gte'});
		}

		if(q.PatientLN.chk) {
			listParams.push({Field: 'PatientLN', DataType:'string', Value: q.PatientLN.val.toUpperCase(), Op:'eqi'});
		}
		if(q.Location.chk) {
			listParams.push({Field: 'Location', DataType:'string', Value: q.Location.val.toUpperCase(), Op:'eq'});
		}
		var elig = q.Eligible;
		if(elig.chk && validSvc.isText(elig.val)) {
			if(tabName == 'SUSPECT') {
				if(elig.val == 'yes') {
					listParams.push({Field: 'Eligible', DataType:'bool', Value: true, Op: 'eq'});
				} else if (elig.reason == 'INELIGIBLE'){
					listParams.push({Field: 'Eligible', DataType:'bool', Value: false, Op: 'eq'});
				} else {
					eligParams = elig.reason.split('-');
					if(eligParams.length === 2) {
						listParams.push({Field: 'StateReason', DataType:'string', Value: eligParams[1], Op: 'eq'});
					}
				}
			} else {
				// Ineligible is more complicated
				if(elig.val == 'yes') {
					listParams.push({Field: 'State', DataType:'string', Value: [
							'ELIGIBLEREVIEW',
							'ELIGIBLE',
							'RECONCILED',
							'ACCUMULATED',
							'ALLOCATED'
					], Op:'in'});
				}
				else if(elig.reason == 'REVERSED' || elig.reason == 'UNMATCHED' || elig.reason == 'INELIGIBLE') {
					listParams.push({Field: 'State', DataType:'string', Value: elig.reason, Op: 'eq'});
				}
				else if(validSvc.isText(elig.reason)) {

					// any other elig state uses both state + reason
					eligParams = elig.reason.split('-');
					if(eligParams.length === 2) {
						listParams.push({Field: 'State', DataType:'string', Value: eligParams[0], Op: 'eq'});
						listParams.push({Field: 'StateReason', DataType:'string', Value: eligParams[1], Op: 'eq'});
					}
				}
			}

			if (elig.overrideOK) {
				// can override
				listParams.push({Field: 'CanOverride', DataType:'bool', Value: !!elig.overrideOK, Op:'eq'});
			}

			// override history
			if(!!elig.overrideHist) {
				listParams.push({Field: 'EligHistory', DataType:'bool', Value: !!elig.overrideHist, Op:'eq'});
				if(validSvc.isText(elig.overrideReason) && elig.overrideReason != 'ALL') {
					listParams.push({Field: 'EligOverrideReason', DataType:'string', Value: elig.overrideReason, Op: 'eq'});
				}
			}

			// block history
			if(!!elig.blockhistory) {
				listParams.push({Field: 'BlockHistory', DataType:'bool', Value: true, Op:'eq'});
			}
			if(q.Allocation.chk) {
				listParams.push({Field: 'Allocation', DataType:'string', Value: q.Allocation.val, Op:'in'});
			}
		}
		if(q.MatchType.chk) {
			if (!!q.MatchType.val) {
				listParams.push({Field: 'MatchType', DataType:'string', Value: q.MatchType.val, Op:'eq'});
			}
		}
		if(q.CashCard.chk) {
			listParams.push({Field: 'CashCard', DataType:'bool', Value: q.CashCard.val == 'yes', Op:'eq'});
		}
		if(q.Referral.chk) {
			listParams.push({Field: 'Referral', DataType:'bool', Value: q.Referral.val == 'yes', Op:'eq'});
		}
		if(q.Orderable.chk) {
			listParams.push({Field: 'Orderable', DataType:'bool', Value: q.Orderable.val == 'yes', Op:'eq'});
		}
		if(q.EstimatePricing.chk) {
			listParams.push({Field: 'EstimatePricing', DataType:'bool', Value: q.EstimatePricing.val == 'yes', Op:'eq'});
		}
		if(q.RestrictedManufacturer.chk) {
			listParams.push({Field: 'RestrictedManufacturer', DataType:'string', Value: q.RestrictedManufacturer.val, Op:'in'});
		}
		if(q.IRA.chk) {
			listParams.push({Field: 'IRA', DataType:'bool', Value: q.IRA.val == 'yes', Op:'eq'});
		}
		if(q.Rebate.chk) {
			listParams.push({Field: 'Rebate', DataType:'bool', Value: q.Rebate.val == 'yes', Op:'eq'});
		}
		return listParams;

	}

	function getList(tabName, query) {

		var defer = $q.defer();
		var ceVals = [],
			rxVals = [],
			tpaVals = [];

		switch(tabName) {
			case 'MATCH':
				if (query.SearchType == 'TPA') {
					tpaVals = [query.Primary.val];
				} else if(query.SearchType == 'RXROLLUP') {
					ceVals = [];
				} else {					
					ceVals = query.primeProp == 'CE' ? [query.Primary.val] : query.Secondary.val;
				}
				rxVals = query.primeProp == 'RX' ? [query.Primary.val] : query.Secondary.val;
				_currentPurl = 'ops/match/list';
				break;
			case 'SUSPECT':
				ceVals = query.primeProp == 'CE' ? [query.Primary.val] : query.Secondary.val;
				rxVals = query.primeProp == 'RX' ? [query.Primary.val] : query.Secondary.val;
				_currentPurl = 'ops/match/suspect/list';
				break;

			case 'EVAL':
			case 'REMATCH':
				ceVals.push(query.CE.val);
				_currentPurl = tabName == 'EVAL' ? 'ops/match/rematch/list' : 'ops/match/rematchdispenses/list';
				break;
			default:
				throw new Error('matchRepo.getList, tabName unknown: ' + tabName);
		}

		var apiRequest = {
			Context: {
				CEID: ceVals,
				RXID: rxVals,
				TPAID: tpaVals
			},
			Params: parseQueryParams(tabName, query),
			Paging: {
				Page: 1,
				Size: 20000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('tbd')]
		};

		_pendingQuery = {
			tabName: tabName
		};

		apiService.post(_currentPurl, apiRequest).then(okGetList, errGetList);

		function okGetList(r) {

			var ent = r.data.Entity,
				badResp = false;

			// match resp has diff return
			if(_pendingQuery.tabName == 'MATCH') {
				ent = ent || {};

				if(validSvc.httpGetEntityResp(r)) {
					ent.Matches = Array.isArray(ent.Matches) ? ent.Matches : [];
					defer.resolve({
						Items: ent.Matches,
						Config: ent.Settings,
						TooMany: ent.Matches.length > 20000
					});
				}
				else {
					badResp = true;
				}

			}
			else {
				ent = Array.isArray(ent) ? ent : [];

				if(validSvc.httpGetListResp(r)) {
					defer.resolve({
						Items: ent,
						TooMany: ent.length > 20000
					});
				}
				else {
					badResp = true;
				}
			}

			if(badResp) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}

		}

		function errGetList(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    GET DETAIL
	 */

	function getSuspect(ceid, rxid, suspectType, dispid) {

		// params
		if(!validSvc.isCE(ceid) || !validSvc.isRX(rxid) || !validSvc.isText(dispid) || !validSvc.isText(suspectType)) {
			throw new Error('match.repo.getSuspect, CE, RX, DispId and SuspectType are required');
		}

		_currentPurl = 'ops/match/suspect/get';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid],
				RXID: [rxid]
			},
			Params: {
				DispId: dispid,
				SuspectType: suspectType
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okGetDetail, errGetDetail);

		function okGetDetail(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(detailVM(r.data.Entity));

		}

		function errGetDetail(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    SUSPECT ACCEPT / REJECT
	 */

	function visitReject(id, notes) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('matchRepo.visitReject, id missing');
		}

		// create api request
		var apiRequest = {
			Entity: {
				Params: {
					Id: id
				}
			}
		};

		return acceptRejectHandler('ops/match/suspect/reject', apiRequest);

	}

	function visitAccept(ceid, id, notes, replaceVisitId, override) {
		// params
		if(!validSvc.isText(id)) {
			throw new Error('matchRepo.visitAccept, id missing');
		}

		// create api request
		var apiRequest = {
			Context : {
						CEID : [ceid]
			},
			Entity: {
     				Params: {
					Id: id,
					Notes: notes,
					ReplaceVisitId: replaceVisitId,
					Override: !!override
				}
			}
		};

		return acceptRejectHandler('ops/match/suspect/accept', apiRequest);

	}

	function visitRejectAll(ctx) {

		// params
		if(!validSvc.isCE(ctx.CE) || !validSvc.isRX(ctx.RX) || !validSvc.isText(ctx.Id) || !validSvc.isText(ctx.SuspectType)) {
			throw new Error('match.repo.visitRejectAll, CE, RX, DispId and SuspectType are required');
		}

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ctx.CE],
				RXID: [ctx.RX]
			},
			Entity: {
				Params: {
					Id: ctx.Id,
					SuspectType: ctx.SuspectType
				}
			}
		};

		return acceptRejectHandler('ops/match/suspect/rejectall', apiRequest);

	}

	function referStatus(id, notes) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('matchRepo.referralStatus, id missing');
		}
 
		var apiRequest = {
			Entity: {
				Params: {
					Id: id,
					Notes: notes
				}
			}
		};
 
		return acceptRejectHandler('ops/referrals/status', apiRequest);
	} 

	function acceptRejectHandler(purl, apiRequest) {

		_currentPurl = purl;
		_deferEdit = $q.defer();

		// call api
		apiService.post(_currentPurl, apiRequest).then(okMatchAction, errMatchAction);

		return _deferEdit.promise;

	}


	/**
	 *    MATCH ACCEPT / REJECT / UNMATCH
	 */

	function rejectScript(id, rejectType, fillNum, notes) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('matchRepo.rejectScript, id missing');
		}

		var rtype = '';

		switch(rejectType) {
			case 'rejectscript':
				rtype = 'ALL';
				break;
			case 'rejectfill':
				rtype = 'FILLNUM';
				break;
			case 'rejectfillone':
				rtype = 'SINGLE';
				break;
			default:
				rtype = 'ALL';
		}

		// create api request
		var apiRequest = {
			Entity: {
				Id: id
			},
			Params: {
				Notes: notes,
				Type: rtype,
				FillNumber: parseInt(fillNum)
			}
		};

		return matchEdit('ops/match/reject', apiRequest);

	}

	function unmatchScript(id, rejectType, notes) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('matchRepo.unmatchScript, id missing');
		}

		var utype = '';

		switch(rejectType) {
			case 'unmatchscriptmanual':
				utype = 'MANUAL';
				break;
			case 'unmatchscriptsystem':
				utype = 'SYSTEM';
				break;
		}

		// create api request
		var apiRequest = {
			Params: {
				Id: id,
				Notes: notes,
				Type: utype,
			}
		};

		return matchEdit('ops/match/unmatch', apiRequest);

	}


	function matchEdit(purl, apiRequest) {

		_currentPurl = purl;
		_deferEdit = $q.defer();

		// call api
		apiService.post(_currentPurl, apiRequest).then(okMatchAction, errMatchAction);

		return _deferEdit.promise;

	}


	/**
	 *    MATCH ELIGIBILITY OVERRIDE
	 */

	function eligOverride(id, notes) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('matchRepo.eligOverride, id missing');
		}

		_currentPurl = 'ops/match/eligoverride';
		_deferEdit = $q.defer();

		// create api request
		var apiRequest = {
			Entity: {
				Id: id
			},
			Params: {
				Notes: notes
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okMatchAction, errMatchAction);

		return _deferEdit.promise;

	}


	/**
	 *    UNDO HISTORY
	 */

	function undoHistory(id, rtype, fillNum, notes) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('matchRepo.undoHistory, id missing');
		}

		_currentPurl = 'ops/match/undoreject';
		_deferEdit = $q.defer();

		// create api request
		var apiRequest = {
			Entity: {
				Id: id,
			},
			Params: {
				Type: rtype,
				FillNumber: parseInt(fillNum),
				Notes: notes
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okMatchAction, errMatchAction);

		return _deferEdit.promise;

	}


	/**
	 *    SHARED HANDLERS
	 */

	function okMatchAction(r) {

		// bad upsert response format
		if(!validSvc.httpUpsert200Resp(r)) {
			errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
			_deferEdit.reject(null);
			return;
		}

		r = r || {};
		r.data = r.data || {};
		_deferEdit.resolve(r.data);

	}

	function errMatchAction(r) {
		if(r === null) {
			_deferEdit.reject(null);
		}
		else if(!!r && r.status === 422) {
			var ent = r.data.Entity;
			if(!!ent && Array.isArray(ent.ROOT)) {
				r.invalidReason = ent.ROOT.join(', ');

				// is this a visit replacement?
				r.ReplaceVisitId = '';
				var flds = Array.isArray(ent.Fields) ? ent.Fields : [];
				for (var i = 0; i < flds.length; i++) {
					if(flds[i].Name == 'ReplaceVisitId') {
						r.ReplaceVisitId = flds[i].Rule;
						break;
					}
				}

				_deferEdit.reject(r);
			}
			else {
				throw new Error('matchRepo 422: ' + _currentPurl + 'api 422 ROOT array error text is required');
			}
		}
		else if(!!r && r.status === 409) {
			_deferEdit.reject(r);
		}
		else {
			errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    MATCH BULK PROCESS
	 */

	function bulkStats(query, action) {
		return bulkAction(query, action, false, '');
	}

	function bulkProcess(query, action, notes) {
		return bulkAction(query, action, true, notes);
	}

	function bulkAction(query, action, confirmed, notes) {

		// handles both stats and bulk processing calls to api

		// convert primary / secondary into CE / RX for query
		var ceVals = query.primeProp == 'CE' ? [query.Primary.val] : query.Secondary.val,
			rxVals = query.primeProp == 'RX' ? [query.Primary.val] : query.Secondary.val;

		// params
		if(ceVals.length < 1 || rxVals.length < 1 || !validSvc.isText(action)) {
			throw new Error('matchRepo.bulkAction, CE, RX and action required');
		}

		var defer = $q.defer();
		var bulkType = action == 'SUSPECTREJECTBULK' ? 'SUSPECT' : 'BULK';
		_currentPurl = bulkType == 'SUSPECT' ? 'ops/match/suspect/rejectbulk' : 'ops/match/bulkaction';

		// create api request
		var apiRequest = {
			Context: {
				CEID: ceVals,
				RXID: rxVals
			},
			Params: {
				Query: parseQueryParams(bulkType, query),
				Action: action == 'block' ? 'REJECT' : 'ACCEPT', // api uses accept/reject
				Notes: notes,
				Confirmed: !!confirmed
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okBulkAction, errBulkAction);

		function okBulkAction(r) {

			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errBulkAction(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    BULK UPLOAD FOR MATCH REVIEW
	 */

	function bulkProcessUpload(uploadType, ceid, importFile) {
		// params
		if(!validSvc.isText(uploadType) || !validSvc.isCE(ceid) || !!!importFile) {
			throw new Error('matchRepo.bulkProcessUpload, required: uploadType, CE and import file');
		}

		_currentPurl = 'ops/match/bulkaction/upload';
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [ceid],
			},
            Params: {
                UploadType: uploadType
            }
		};

		// create multi-part form data
		var fd = new FormData();
		fd.append('context', angular.toJson(apiRequest)); // stringify JSON into one "context" property
		fd.append('file', importFile);

		apiService.postFile(_currentPurl, fd, false, true).then(okFileImport, errFileImport);

		function okFileImport(r) {

			// bad upsert response format
			if(!!!r || !!!r.data || !!!r.data.Entity) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			var ent = r.data.Entity,
				result = mapApiFileProcessCounts({}, ent);

			// has errors? 200 return may have errors
			if(Array.isArray(ent.RecordErrors) && ent.RecordErrors.length > 0) {
				result.status = 422;
				result.RecordErrors = mapApiRecordErrors(r.data.Entity);
				defer.reject(result);
			}
			else {
				result.status = 200;
				defer.resolve(result);
			}

		}

		function errFileImport(r) {

			if(r === null) {
				defer.reject(null);
			}
			else if(!!!r || !validSvc.isNumber(r.status) || !!!r.data) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status === 422 && !!r.data.Entity) {
				var ent = r.data.Entity;
				r = mapApiFileProcessCounts(r, ent);
				r.RecordErrors = mapApiRecordErrors(ent);
				defer.reject(r);
			}	
      		else if(r.status === 409 && r.timeout) {
				defer.reject(r);
			}
	    	else {
				errSvc.error('Unexpected error', _currentPurl + 'matchRepo.errFileImport', r.status, utilSvc.http.safeResponse(r));
			}

		}

		function mapApiFileProcessCounts(r, ent) {

			r.Processed = ent.ProcessedCount;
			r.Received = ent.ReceivedCount;
			r.Error = ent.ErrorCount;
			r.Duplicate = ent.DuplicateCount;

			return r;
		}

		function mapApiRecordErrors(entity) {

			// map server 422 fields onto import error text lines

			if(Array.isArray(entity.RecordErrors) && entity.RecordErrors.length > 0) {
				return entity.RecordErrors;
			}
			else if(entity.ROOT.length > 0) {
				return [{Name: 'File Error', Rule: entity.ROOT.join(',')}];
			}
			else {
				throw new Error('matchRepo.422FileImport, Api returned no errors to display');
			}
		}

		return defer.promise;

	}


	/**
	 *    EVAL
	 */

	function evalCreate(query, notes, dryRun) {

		// params
		if(query.RX.vals.length < 1 || !validSvc.isCE(query.CE.val)) {
			throw new Error('matchRepo.evalCreate, RX/CE ids are required');
		}

		_currentPurl = 'ops/match/rematch/create';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [query.CE.val],
				RXID: query.RX.vals
			},
			Params: {
				// Send date in UTC, backend will ignore the locale anyway
				StartDate: new Date(utilSvc.dt.toServerString(query.StartDate.val)),
				EndDate: new Date(utilSvc.dt.toServerString(query.EndDate.val)),
				ExcludeAllocatedMatches: !!query.ExcludeAllocatedMatches,
				IncludeFacilitySentMatches: !!query.IncludeFacilitySentMatches,
				EvaluateType: query.Evaluate == 'OWNUSE' ? 'OWN' : query.Evaluate,
				DateProperty: query.DateType,
				DryRun: !!dryRun,
				Notes: notes
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okEvalCreate, errEvalCreate);

		function okEvalCreate(r) {

			// entity returned (ignoring async JobId for now)
			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});

		}

		function errEvalCreate(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function evalUpdate(id, status) {
		_currentPurl = 'ops/match/rematch/status';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Params: {
				Id: id,
				Status: status,
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okEvalUpdate, errEvalUpdate);

		function okEvalUpdate(r) {
			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});

		}

		function errEvalUpdate(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	/**
	 *    REMATCH
	 */

	function rematchCreate(query, notes) {

		// params
		if(!validSvc.isCE(query.Primary.val)) {
			throw new Error('matchRepo.rematchCreate, ceid required');
		}

		_currentPurl = 'ops/match/rematchdispenses/create';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [query.Primary.val],
				RXID: query.Secondary.val
			},
			Params: {
				StartDate: query.StartDate.val,
				Notes: notes
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okEvalCreate, errEvalCreate);

		function okEvalCreate(r) {

			// entity returned (ignoring async JobId for now)
			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});

		}

		function errEvalCreate(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 * 		STATS
	 */

	 function matchStats(query, isCompare) {

		var defer = $q.defer();
		_currentPurl = 'reports/matchstats/summary';

		var apiRequest = {
			Context: {
				CEID: query.primeProp == 'CE' ? [query.Primary.val] : query.Secondary.val,
				RXID: query.primeProp == 'RX' ? [query.Primary.val] : query.Secondary.val
			},
			Params: {
				StartDate: !!isCompare ? query.CompareStartDate.val : query.StartDate.val,
				EndDate: !!isCompare ? query.CompareEndDate.val : query.EndDate.val,
				AccGrps: []
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('none')]
		};

		apiService.post(_currentPurl, apiRequest).then(okStats, errStats);

		function okStats(r) {

			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + ' repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);			
		}

		function errStats(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 * 	SENT MATCH
	 */

	function buildSentMatchQuery(query) {
		var apiRequest = {
			Context: {
				CEID: [],
				RXID: []
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				ExternalType: query.ExternalType,
				RxNumber: validSvc.isText(query.RxNumber.val) ? query.RxNumber.val : ''
			},
			Paging: {
				Size: 20000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('ExtractDate')]
		};

		// params
		switch(query.ExternalType) {
			case 'TPA':
				if(!validSvc.isCE(query.CE.val) || !validSvc.isRX(query.RX.val)) {
					throw new Error('matchRepo.buildSentMatchQuery, TPA CE and RX required');
				}
				apiRequest.Context.CEID = [query.CE.val];
				apiRequest.Context.RXID = [query.RX.val];
				break;
			case 'STATEFFS':
				if(query.CE.vals.length < 1) {
					throw new Error('matchRepo.buildSentMatchQuery, STATEFFS CE required');
				}
				apiRequest.Context.CEID = query.CE.vals;
				break;
			default:
				throw new Error('matchRepo.buildSentMatchQuery, ExternalType unknown: ' + query.ExternalType);
		}

		return apiRequest;
	}

	function getSentMatch(query) {

		var apiRequest = buildSentMatchQuery(query);

		var defer = $q.defer();
		_currentPurl = 'reports/tpa/sentmatches';

		apiService.post(_currentPurl, apiRequest).then(okSentMatch, errSentMatch);

		function okSentMatch(r) {
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({
				Items: r.data.Entity,
				TooMany: r.data.Entity.length > 20000
			});
		}

		function errSentMatch(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/** 
	 *  GET STATS SUMMARY COMPARISON EXCEL
	 */
	
	function getStatsExcelCompare(query, filename) {

		// params
		if((query.Primary.val.length < 1 || query.Secondary.val.length < 1) || !validSvc.isText(filename)) {
			throw new Error('matchRepo.getStatsExcelCompare: CE id is needed and filename is required');
		}

		var defer = $q.defer();
		_currentPurl = 'reports/matchstats/compare/excel';

		var apiRequest = {
			Context: {
				// convert primary / secondary into CE / RX for query
				CEID: query.primeProp == 'CE' ? [query.Primary.val] : query.Secondary.val,
				RXID: query.primeProp == 'RX' ? [query.Primary.val] : query.Secondary.val
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				CompareStartDate: query.CompareStartDate.val,
				CompareEndDate: query.CompareEndDate.val,
				AccGrps: []
			}
		};

		apiService.postGetBinary(_currentPurl, apiRequest).then(okGetExcel, errGetExcel);

		function okGetExcel(r) {
			defer.resolve(r.data);
		}

		function errGetExcel(r) {
			if(r !== null) {
				r = r || {};
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	function getExcel(tabName, query, filename) {

		var apiRequest = {},
			ceVals = [],
			rxVals = [], 
			tpaVals = [];

		// convert primary / secondary into CE / RX / TPA for query
		if (query.SearchType == 'TPA') {
			tpaVals = [query.Primary.val];
			rxVals = query.Secondary.val;
		} 
		else if(query.SearchType == 'RXROLLUP') {
			ceVals = [];
			rxVals = query.Secondary.val;
		}
		else if(tabName == 'SENTMATCH') {
			apiRequest = buildSentMatchQuery(query);
		}
		else {
			ceVals = query.primeProp == 'CE' ? [query.Primary.val] : query.Secondary.val;
			rxVals = query.primeProp == 'RX' ? [query.Primary.val] : query.Secondary.val;
		}

		var defer = $q.defer();

		// sent match has its own query
		if(tabName != 'SENTMATCH') {
			apiRequest = {
				Context: {
					CEID: ceVals,
					RXID: rxVals,
					TPAID: tpaVals
				},
				Params: parseQueryParams(tabName, query)
			};
		}

		switch(tabName) {
			case 'MATCH':
			case 'SUSPECT':
				_currentPurl = tabName == 'MATCH' ? 'ops/match/excel' : 'ops/match/suspect/excel';
				break;
			case 'SENTMATCH':
				_currentPurl = 'reports/tpa/sentmatches/excel';
				break;
			case 'STATS':
				_currentPurl = 'reports/matchstats/excel';
				apiRequest.Params.AccGrps = [];
				break;
			default:
				throw new Error('matchRepo.getExcel, tabName unknown: ' + tabName);
		}

		apiService.postGetBinary(_currentPurl, apiRequest).then(okGetExcel, errGetExcel);

		function okGetExcel(r) {
			defer.resolve(r.data);
		}

		function errGetExcel(r) {
			if(r !== null) {
				r = r || {};
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	/** 
	 *  FORCE SENT MATCH TO TPA
	 */

	function sendToTPA(matches) {		
		var defer = $q.defer();
		_currentPurl = 'ops/match/sendtotpa';

		var apiRequest = {
			Context: {
			},
			Params: {
				Matches: matches,
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okSentTPA, errSentTPA);

		function okSentTPA(r) {

			// bad upsert response format
			if(!validSvc.httpBulkUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errSentTPA(r) {
			defer.reject(handleErrResult(r, _currentPurl, parse422FirstField));
		}

		return defer.promise;
	}

	/** 
	 *  MATCH REVIEW
	 */

	function reviewMatch(id, review, notes) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('matchRepo.reviewMatch, id missing');
		}

		// create api request
		var apiRequest = {
			Context: {
			},
			Params: {
				Id: id,
				Reviewed: review,
				Notes: notes,
			}
		};

		return matchEdit('ops/match/review', apiRequest);

	}

	/** 
	 *  SUSPECT REVIEW
	 */

	function reviewSuspect(id, review, notes) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('matchRepo.reviewSuspect, id missing');
		}

		// create api request
		var apiRequest = {
			Context: {
			},
			Params: {
				Id: id,
				Reviewed: review,
				Notes: notes,
			}
		};

		return matchEdit('ops/match/suspect/review', apiRequest);

	}

	function rxApiFormat(val) {
		// send ALL as empty array
		if(val == 'ALL') {
			return [];
		}
		else {
			return [val];
		}
	}


	/**
	 *    CREATE ASYNC JOB
	 *    creates a new async job; resolves with job entity
	 */
	function createAsyncJob(asyncRequest) {

		if (!!!asyncRequest) {
			throw new Error('matchRepo.createAsyncJob, async request required');
		}

		_currentPurl = asyncRequest.Params.JobType === 'SUSPECT_EXPORT' ? 'ops/match/suspect/export/create' : 'ops/match/export/create';
		var defer = $q.defer();

		apiService.post(_currentPurl, asyncRequest).then(okCreateAsyncJob, errCreateAsyncJob);

		function okCreateAsyncJob(r) {

			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errCreateAsyncJob(r) {
			if(!!!r) {
				defer.reject(null);
			}
			else if(r.status != 422) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				defer.reject(r);
			}
		}

		return defer.promise;
	}
}
 
matchListCtl.$inject = ['$window', '$state', '$scope', '$timeout', '$filter', '$q', 'matchRepo', 'prefsRepo', 'vendorRepo', 'msgSvc', 'sessionRepo', 'reportRepo', 'lookupRepo', 'opsAsyncRepo', 'appConst', 'utilSvc', 'validSvc', 'errSvc'];
angular
.module('espui.ops')
.controller('MatchListCtl', matchListCtl);


/* @ngInject */
function matchListCtl($window, $state, $scope, $timeout, $filter, $q, matchRepo, prefsRepo, vendorRepo, msgSvc, sessionRepo, reportRepo, lookupRepo, opsAsyncRepo, appConst, utilSvc, validSvc, errSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _pendingExcelFilename = '',
		_featureName = '',
		_pendingEdit = null,
		_datePickListener = null,
		_pagingEventListener = null,
		_tblViewEventListener = null,
		_fileImportListener = null,
		_tabInfo = {},
		_autoSubmit = false,
		_mouseLeaveDelay = [],
		_tpaOptions = [],
		_rxModelList = [],
		_tsEventListener = null,
		_checkForRollups = false,
		_ceLookup = {},
		_affLookup = [],
		_affsAllowFacilitySentMatches = [],
		_excelJobId = null,
		_excelPollTimer = null,
		_excelPollStartTime = null,
		_asyncJobsRefreshTimer = null;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addFlexTop(vm);
	utilSvc.ctl.addTableViews(vm);
	utilSvc.ctl.addMultiselect(vm);
	msgSvc.addHelpLink(vm);

	// html display helpers
	vm.displayQuarter = displayQuarter;
	vm.displayQuarterMonths = displayQuarterMonths;

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.showSuspectsTab = false;
	vm.matchConfig = {};
	vm.showSentMatchTab = false;
	vm.sentMatchRollupAffs = [];

	// droplists
	vm.RxDroplist = [];
	vm.CeDroplist = [];
	vm.CeEvalDroplist = [];
	vm.DateTypeDroplist = [];
	vm.EvalDateTypeDroplist = [];
	vm.EvalStatusDroplist = [];
	vm.EligibleDroplist = [];
	vm.EligOverrideReasonDroplist = [];
	vm.RollupDroplist = [];

	// query
	vm.query = {};
	vm.queryChangeSearchType = queryChangeSearchType;
	vm.queryChangeCE = queryChangeCE;
	vm.queryChangeRX = queryChangeRX;
	vm.queryChangeDateType = queryChangeDateType;
	vm.dateRangeChange = dateRangeChange;
	vm.queryChangeEligible = queryChangeEligible;
	vm.queryChangeAllocation = queryChangeAllocation;
	vm.queryChangeMatchType = queryChangeMatchType;
	vm.queryChangeCashCard = queryChangeCashCard;
	vm.queryChangeReferral = queryChangeReferral;
	vm.queryChangeOrderable = queryChangeOrderable;
	vm.queryChangeEstimatePricing = queryChangeEstimatePricing;
	vm.queryChangeRestrictedManufacturer = queryChangeRestrictedManufacturer;
	vm.queryChangeIRA = queryChangeIRA;
	vm.queryChangeRebate = queryChangeRebate;
	vm.querySubmit = querySubmit;
	vm.queryChangeAffs = queryChangeAffs;
	vm.queryChangeTpaSearchType = queryChangeTpaSearchType;
	vm.queryChangeExternalType = queryChangeExternalType;
	vm.showInactiveAffs = 'no';

	// tabs
	vm.activeTab = '';
	vm.tabChange = tabChange;

	// methods
	vm.rowClick = rowClick;
	vm.filterChange = filterChange;
	vm.getExcel = getExcel;
	vm.rejectScript = rejectScript;
	vm.unmatchScript = unmatchScript;
	vm.eligOverride = eligOverride;
	vm.undoHistory = undoHistory;

	// popup
	vm.popup = {};
	vm.closePopup = closePopup;
	vm.openPopup = openPopup;

	// new display: filters, table
	vm.flt = {};
	vm.tbl = {};

	// eval create
	vm.evalHasOWNUSE = false;
	vm.evalHasGPO = false;
	vm.evalCreateToggle = evalCreateToggle;
	vm.evalChangeTarget = evalChangeTarget;
	vm.evalCreate = evalCreate;
	vm.evalUpdateStatus = evalUpdateStatus;
	vm.dtPickShow = {};
	vm.dtPickOpen = dtPickOpen;
	vm.affsIncludeFacilitySentMatches = false;

	// rematch
	vm.rematchCreate = rematchCreate;
	vm.LookBackYearsDroplist = [];

	// review
	vm.reviewMatch = reviewMatch;
	vm.reviewSuspect = reviewSuspect;

	// unmatch
	vm.unmatchLink = unmatchLink;

	// send to tpa
	vm.sentToTPAList = [];
	vm.sendToTPAToggleList = sendToTPAToggleList;
	vm.sendToTPAToggleItem = sendToTPAToggleItem;
	vm.sendToTPASelectionSubmit = sendToTPASelectionSubmit;

	// flex top
	vm.flex = {};
	vm.flexTopExpand = flexTopExpand;

	// bulk processing
	vm.bulkProcess = bulkProcess;
	vm.suspectRejectBulk = suspectRejectBulk;

	// table view
	vm.tblViewConfig = {};
	vm.tblView = {};

	// file import
	vm.importSelectedFiles = [];
	vm.importErrors = [];
	vm.importCsvSend = importCsvSend;
    vm.showMatchEligUpload = showMatchEligUpload;
    vm.showMatchPrequalUpload = showMatchPrequalUpload;

	// filter swap + secondary multi select
	vm.PrimaryDroplist = [];
	vm.SecondaryMulti = {};
	vm.ManufacturerMulti = {};
	vm.AllocationMulti = {};
	vm.EvalRxMulti = {};
	vm.queryChangePrimary = queryChangePrimary;
	vm.filterSwap = filterSwap;
	vm.multiToggle = multiToggle;
	vm.multiHover = multiHover;
	vm.multiClick = multiClick;
	vm.multiClickSentMatch = multiClickSentMatch;

	// match stats
	vm.stats = {};

	// match stats compare
	vm.compare = {Data:{}};
	vm.compareDateRangeList = [];
	vm.compareToggle = compareToggle;
	vm.compareLoadData = compareLoadData;

	// match stats time series
	vm.ts = {};
	vm.tsMetricDroplist = [];
	vm.tsToggle = tsToggle;
	vm.tsChangeMetric = tsChangeMetric;
	vm.tsChangeInterval = tsChangeInterval;
	vm.tsChangeType = tsChangeType;

	// CE selector
	vm.CeMulti = {};
	vm.filterChangeCeMulti = filterChangeCeMulti;

	// async
	vm.asyncReports = initAsyncReports();
	vm.toggleAsyncReports = toggleAsyncReports;
	vm.createReEvalAsyncExcel = createReEvalAsyncExcel;

	// async jobs (Match/Suspect Excel files)
	vm.asyncJobs = initAsyncJobs();
	vm.toggleAsyncJobs = toggleAsyncJobs;
	vm.asyncJobsRefresh = asyncJobsRefresh;
	vm.asyncJobsFilterChange = asyncJobsFilterChange;
	vm.asyncJobsDownload = asyncJobsDownload;

	/**
	 *    EVENT HOOKS
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// Handle ASYNC_JOBS paging separately
		if(evtData.uniqueId === 'ASYNC_JOBS') {
			if(!vm.asyncJobs.flt.Ready || !Array.isArray(vm.asyncJobs.tbl.Items)) {
				return;
			}
			vm.asyncJobs.flt[evtData.propName] = parseInt(evtData.value);
			asyncJobsFilterChange();
			return;
		}

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);

		// re-render table by filtering it again
		filterChange(true);

	});

	_datePickListener = $scope.$on('widget.input.date.pick.change', function(event, evtData) {
		event.stopPropagation();

		// params
		if(!evtData || !validSvc.isText(evtData.uniqueId)) {
			alert('reportAuditCtl.datePickEvt, evtData and uniqueId required');
			return;
		}

		var id = evtData.uniqueId,
			dtProp = '';

		switch(id) {
			case 'evalStartDate':
			case 'newRematchStartDate':
				dtProp = 'StartDate';
				break;
			case 'evalEndDate':
				dtProp = 'EndDate';
				break;
			default:
				alert('reportAuditCtl.dtPickListener, uniqueId unknown: ' + id);
				return;
		}

		vm.dtPickShow[id] = false;
		vm.query[dtProp].val = evtData.setDate;

		// set StartDate max <= EndDate
		if(id == 'evalEndDate') {
			vm.query.StartDate.max = evtData.setDate;
		}

	});

	_tblViewEventListener = $scope.$on('widget.tblview.editor.change', function(event, evtData) {
		event.stopPropagation();

		switch(evtData.type) {

			case 'edit':
				openPopup(null, null, 'TBLVIEW');
				break;

			case 'close':
				closePopup();
				break;

			case 'load':
				// load specific view requested
				vm.tblView.current = evtData.id;
				$timeout(function() {
					tblViewReload(vm.activeTab, vm.query, true);

					// update user preference (delay the network call)
					$timeout(function() {
						if(vm.activeTab == 'MATCH' || vm.activeTab == 'SUSPECT') {
							var tblConfig = vm.tblViewConfig[vm.activeTab];
							if(!!tblConfig && !!vm.tblView && validSvc.isText(vm.tblView.current)) {
								prefsRepo.setCurrentTableView(tblConfig.storageKey, vm.tblView.current).then(okCurrentTableView, errCurrentTableView);
							}
						}
					}, 2000);
				}, 300);
				break;

			default:
				throw new Error('widget.tblview.editor.change, unknown event type: ' + evtData.type);
		}

	});

	_fileImportListener = $scope.$on('widget.input.file', function(event, importInfo) {
		event.stopPropagation();

		if(!!importInfo && !!importInfo.files && importInfo.files.length > 0) {
			vm.importSelectedFiles = importInfo.files;
		}
		else {
			vm.importSelectedFiles = [];
		}

	});

	_tsEventListener = $scope.$on('widget.timeseries.action', function(event, evtData) {
		event.stopPropagation();

		// exit if timeseries or filter is already gone
		if(vm.reportTab != 'MATCH' || vm.action != 'TIMESERIES') {
			return;
		}

		var d = evtData || {};

		// filter changed
		if(d.action == 'flt' && !!d.flt) {
			vm.ts.dirty = true;

			// store table filter by interval
			var fltKey = vm.ts.type + vm.ts.interval;
			vm.ts.prefs.flt[fltKey] = d.flt;
		}
	});

	function okCurrentTableView() {

		// update session
		if(vm.activeTab == 'MATCH' || vm.activeTab == 'SUSPECT') {

			var tblConfig = vm.tblViewConfig[vm.activeTab];
			var tvSaved = sessionRepo.get(tblConfig.storageKey);

			if(!!tvSaved && !!vm.tblView && validSvc.isText(vm.tblView.current)) {
				tvSaved.current = vm.tblView.current;
				sessionRepo.set(tblConfig.storageKey, tvSaved);
			}

		}

	}

	function errCurrentTableView() {
		// do nothing
	}

	function tblViewReload(tabName, query, skipInitViews, fltKeepPaging) {

		if((tabName != 'MATCH' && tabName != 'SUSPECT') || !!!query) {
			return;
		}

		// init tblView with full view config
		if(!!!skipInitViews || !!!vm.tblView) {
			vm.tblView = vm.tblViewInit(vm.tblViewConfig[tabName], sessionRepo.get(vm.tblViewConfig[tabName].storageKey));
		}
		
		// reduce tblConfig based on query
		var tblConfig = tblViewConfigSetup($scope.User.Type, _rxModelList, tblViewSchemaVM(), vm.query);
		tblConfig = tblConfig[tabName];

		// add column titles and filters
		vm.tblView = vm.tblViewLoadTitlesAndFilters(tblConfig, vm.tblView, vm.flt);
		
		// update table view bar
		$scope.$broadcast('widget.tblview', {
			uniqueId: 'MATCH_SUSPECT', // tabs share same tblview widget
			current: vm.tblView.current,
			views: vm.tblView.views
		});

		if(!!vm.flt) {
			// remove any filter properties not shown in current table view
			vm.flt = vm.tblViewSyncFilter(tblConfig, vm.tblView, vm.flt, fltKeepPaging);
			filterChange(true);
		}
	}


	/**
	 *    DESTROY
	 */

	$scope.$on('$destroy', function() {
		if(!!_datePickListener) {
			_datePickListener();
		}
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
		if(!!_tblViewEventListener) {
			_tblViewEventListener();
		}
		if(!!_fileImportListener) {
			_fileImportListener();
		}
		if(!!_tsEventListener) {
			_tsEventListener();
		}
		if(!!_excelPollTimer) {
			$timeout.cancel(_excelPollTimer);
			_excelPollTimer = null;
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		_featureName = $state.current.name;

		vm.init = true;
		vm.flex = vm.flexInit();
		vm.showSuspectsTab = $scope.cobrand != 'express';
		vm.context = matchRepo.contextVM();

		initDroplists();
		var ceid = validSvc.isCE($scope.User.CE) ? $scope.User.CE : 'NONE';
		_tabInfo = initTabInfo(ceid);
		vm.query = initQuery($scope.User);

		_rxModelList = utilSvc.aff.rxModelList(getAffs(false));
		vm.showSentMatchTab = _rxModelList.indexOf('CPTPA') > -1;
		vm.tblViewConfig = tblViewConfigSetup($scope.User.Type, _rxModelList, tblViewSchemaVM());

		// ASYNC: > initRollup > initTPA > initFinish
		initRollupDropList();
	}

	function initTpaOptions() {
		vm.isWaiting = true;
		msgSvc.wait(true);

		_tpaOptions = [];
		vendorRepo.getTPAList().then(okGetTpa, errGetTpa);

		function okGetTpa(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			r = Array.isArray(r) ? r : [];
			// de-ref array
			_tpaOptions = JSON.parse(JSON.stringify(r));

			initCeLookup();
		}

		function errGetTpa(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if (!!r) {
				errSvc.error('matchListCtl.initTpaOptions, unknown api error', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function initCeLookup() {
		// ASYNC: UI only uses Referral CEs
		_ceLookup = {};

		var affs = utilSvc.aff.findStatus($scope.User.AffList);
		affs = utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));
		var ceList = utilSvc.aff.ceList(affs);
		vm.isWaiting = true;

		if(ceList.length < 1) {
			noCeList();
			return;
		}

		lookupRepo.CeInfo(ceList).then(okCeLookup, errCeLookup);

		function okCeLookup(items) {

			// none found, keep waiting on
			if(!Array.isArray(items) || items.length < 1) {
				noCeList();
				return;
			}
		
			// create ce list
			var item = null;
			for(var i = 0; i < items.length; i++) {
				item = items[i];
				_ceLookup[item.NickName] = {
					Id: item.NickName,
					Name: validSvc.isText(item.Name) ? item.Name : '',
					OpaId: validSvc.isText(item.OpaIdent) ? item.OpaIdent : '',
					OwnUseProgram: item.OwnUseProgram,
					State: item.USState
				};
			}
			
			// continue init
			initAffLookups();
		}

		function noCeList() {
            toggleWait();
			msgSvc.ok('No Facilities', 'No covered entities found.');
		}
	
		function errCeLookup(r) {
			vm.isWaiting = false;
			if(!!r) {
				errSvc.warn('Error looking up ce display properties', 'matchList.initCeLookup', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

    function initAffLookups() {
        // init for both MATCH and EVAL
        var affs = utilSvc.aff.findStatus($scope.User.AffList, ['ONBOARDING', 'ACTIVE', 'INACTIVE']);
		affs = utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));

        var ceList = utilSvc.aff.ceList(affs),
		    rxList = utilSvc.aff.rxList(affs);

        // force spinner
		vm.isWaiting = true;
		msgSvc.wait(true,true);

        _affLookup = [];
		lookupRepo.AffInfo(ceList, rxList).then(okAffLookup, errAffLookup);

		function okAffLookup(r) {
            toggleWait();
			_affLookup = Array.isArray(r) ? r : [];
            initFinish();
		}

		function errAffLookup(r) {
            toggleWait();
			msgSvc.ok('No Affiliation Info', 'Error looking up affiliation info');
		}
	}



	function initFinish() {
		// runs after rollup / tpa options are downloaded to finish feature setup
		vm.activeTab = initViewState('MATCH');
		tabChange(vm.activeTab);
	}

	function getActiveAffs(ceIsActive) {
		var affs = utilSvc.aff.findStatus($scope.User.AffList, ['ACTIVE']);
		affs = utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));

		if(!!ceIsActive) {
			// aff and CE must be active
			var result = [];
			affs.forEach(function(aff) {
				if(aff.CEStatus == 'ACTIVE') {
					result.push(aff);
				}
			});
			return result;
		}
		else {
			return affs;
		}
	}

	function getAffs(showInactive) {
		var affs = utilSvc.aff.findStatus($scope.User.AffList);
		affs = utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));

		if (vm.activeTab != 'MATCH' && vm.activeTab != 'STATS' && vm.activeTab != 'SENTMATCH') {
			affs = utilSvc.aff.findVerityAdmin(affs);
		}

		if (vm.activeTab == 'MATCH' || vm.activeTab == 'SUSPECT') {
			var affStatus = ['ONBOARDING', 'ACTIVE'];
			if(!!showInactive) {
				affStatus.push('INACTIVE');
			}
			affs = utilSvc.aff.findStatus(affs, affStatus);
		}

		if (vm.activeTab == 'EVALNEW') {
			affs = utilSvc.aff.findStatus(affs, ['ACTIVE']);
		}

		if(vm.activeTab == 'SENTMATCH') {
			affs = utilSvc.aff.findRxModel(affs, ['CP', 'CPTPA', 'SPLITMATCH']);
			affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
		}

		return affs;
	}

	function initMultiselectVM(type) {
		// multi column view
		return {
			init: true,
			type: type,
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: '',
			singleValue: false,
			vals: [],
			list: [],
			filtered: [],
			flt: {
				val:'',
				lbl:'',
				lbl2:''
			},
			displayName: {
				val: '',
				lbl: '',
				lbl2: ''
			},
			fail: ''
		};
	}

	function initDroplists() {

		vm.EvalStatusDroplist = utilSvc.ng.droplist(
			['DONE','ERROR','NEW','RUNNING',"PAUSED","INTERRUPTED","CANCELLED"],
			'',
			'',
			[{label:'All',value:''}]
		);
		vm.MatchTypeDroplist = utilSvc.ng.droplist(
			['SYSTEM', 'SUSPECT', 'MANUAL'],
			'',
			'',
			[{label:'All',value:''}]
		);
		vm.DateTypeDroplist = [
			{label: 'Filled Date', value: 'SERVICE'},
			{label: 'Matched Date', value: 'MATCH'},
			{label: 'Written Date', value: 'RXWRITTEN'}
		];
		vm.EvalDateTypeDroplist = utilSvc.ng.droplist(
			['Filled', 'Matched', 'Written'],
			'',
			'',
			[{label:'All',value:''}]
		);

		vm.EligibleDroplist = [
			{label: 'All Reasons', value: 'INELIGIBLE'},
			{label: 'CONTRACT DATE', value:'INELIGIBLE-REASON_CONTRACT_DATE'},
			{label: 'ERX NPI', value:'INELIGIBLE-EPRESCRIBE_NPI'},
			{label: 'EXCLUDED PAYOR CE', value:'INELIGIBLE-CE_EXCLUDED_PAYOR'},
			{label: 'EXCLUDED PAYOR NDC', value:'INELIGIBLE-EXCLUDED_PAYOR_NDC'},
			{label: 'GOV MEDICAID', value:'INELIGIBLE-GOV_MEDICAID'},
			{label: 'INVALID MATCH', value:'UNMATCHED-INVALID_MATCH'},
			{label: 'IN REVIEW', value:'INELIGIBLE-INREVIEW'},
			{label: 'ERX PREFERRED', value:'UNMATCHED-ERX_PREFERRED'},
			{label: 'VHUB TPA', value:'UNMATCHED-VHUB_TPA'},
			{label: 'LOCATION', value:'INELIGIBLE-PATIENT_LOCATION'},
			{label: 'MCO MEDICAID', value:'INELIGIBLE-EXCLUDED_PAYOR'},
			{label: 'NO MODIFIER', value: 'INELIGIBLE-NO_MODIFIER'},
			{label: 'NPI BLOCKED', value:'INELIGIBLE-NPI_REVIEW_BLOCK'},
			{label: 'NPI FLOATING', value:'INELIGIBLE-NPI_REVIEW_FLOAT'},
			{label: 'NPI PROXIMITY', value:'INELIGIBLE-NPI_PROXIMITY'},
			{label: 'NPI REFERRAL', value:'INELIGIBLE-NPI_REVIEW_REFERRAL'},
			{label: 'OPA DATE', value:'INELIGIBLE-CE_OPA_STARTDATE'},
			{label: 'REMATCHED', value:'UNMATCHED-WEAKMATCH'},
			{label: 'REVERSED', value:'REVERSED'},
			{label: 'TPA REJECTED', value:'INELIGIBLE-TPA_REJECTED'},
			{label: 'UNMATCHED', value:'UNMATCHED'},
			{label: 'VISIT PROXIMITY', value:'INELIGIBLE-VISIT_PROXIMITY'},
			{label: 'BLOCKED SCRIPT', value:'INELIGIBLE-BLOCKED_SCRIPT'},
			{label: 'VISIT REVERSED', value:'UNMATCHED-INVALID_VISIT'},
			{label: 'DISP CHANGE', value:'UNMATCHED-DISP_CHANGE'},
			{label: 'ACCT CHANGE', value:'UNMATCHED-DISP_TYPE_CHANGE'},
			{label: 'MFR RESTRICT', value:'INELIGIBLE-MFR_RESTRICT'},
			{label: 'MFR AGED', value:'INELIGIBLE-MFR_AGED'},
			{label: 'NPI PERIOD', value:'UNMATCHED-NPIPERIOD'},
			{label: 'NPI INACTIVE', value:'UNMATCHED-NPIINACTIVE'},
			{label: 'CLAIM VALUE', value: 'INELIGIBLE-CLAIMVALUE'},
			{label: 'RXNUMBER', value:'UNMATCHED-RXNUMBER'},
			{label: 'MANUAL UNMATCH', value:'UNMATCHED-MANUALMATCH'},
		];

		vm.EligOverrideReasonDroplist = [
			{label: 'All Overrides', value: 'ALL'},
			{label: 'EXCLUDED PAYOR CE', value:'CE_EXCLUDED_PAYOR'},
			{label: 'EXCLUDED PAYOR NDC', value:'EXCLUDED_PAYOR_NDC'},
			{label: 'IN REVIEW', value:'INREVIEW'},
			{label: 'LOCATION', value:'PATIENT_LOCATION'},
			{label: 'MCO MEDICAID', value:'EXCLUDED_PAYOR'},
			{label: 'NPI BLOCKED', value:'NPI_REVIEW_BLOCK'},
			{label: 'NPI FLOATING', value:'NPI_REVIEW_FLOAT'},
			{label: 'NPI PROXIMITY', value:'NPI_PROXIMITY'},
			{label: 'NPI REFERRAL', value:'NPI_REVIEW_REFERRAL'},
			{label: 'VISIT PROXIMITY', value:'VISIT_PROXIMITY'},
			{label: 'MFR RESTRICT', value:'MFR_RESTRICT'},
			{label: 'MFR AGED', value:'MFR_AGED'},
		];

		vm.CeDroplist = utilSvc.aff.ceDroplist(getAffs(vm.showInactiveAffs == 'yes'));
		vm.CeEvalDroplist = utilSvc.aff.ceDroplist(getActiveAffs(true));

		// filter swap primary, secondary
		vm.PrimaryDroplist = [];
		vm.SecondaryMulti = {
			type: 'RX',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: '',
			vals: [],
			list: [],
			flt: ''
		};

		vm.EvalRxMulti = {
			type: 'RX',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: '',
			vals: [],
			list: [],
			flt: ''
		};

		vm.CeMulti = initMultiselectVM('CE');

		var manuItems = [{lbl:'All', val : 'ALL'}];
		var items = $scope.User.ManufacturerExclusionList;
		for(var i=0; i<items.length; i++) {
			var name = items[i].Name +  " ["+ items[i].LabelerId + "]";
			manuItems.push({checked:false, lbl:name, val:items[i].LabelerId});
		}
		vm.ManufacturerMulti = {
			type: 'MFR',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose Manufacturer',
			vals: [],
			list: manuItems,
			flt: ''
		};

		var allocs = [
			{lbl:'ALL', val : 'ALL'},
			{lbl:'UNALLOCATED', val : 'UNALLOCATED'},
			{lbl:'PARTIAL', val : 'PARTIAL'},
			{lbl:'FULL', val : 'FULL'},
			{lbl:'EXPIRED', val : 'EXPIRED'},
		];

		vm.AllocationMulti = {
			type: 'ALLOC',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose Allocation',
			vals: [],
			list: allocs,
			flt: ''
		};

		// match stats compare date list
		vm.compareDateRangeList = [
			{label:'Last Month To Date', value:'LMTD'},
			{label:'Monthly', value:'MONTHLY'},
			{label:'Last Quarter To Date', value:'LQTD'},
			{label:'Last Year To Date', value:'LYTD'},
			{label:'Previous Last 12 Months', value:'LLTM'}
		];

		// new rematch lookback options
		vm.LookBackYearsDroplist = utilSvc.ng.droplist(['1', '2', '3', '4', '5']);
	}

	function initQuery(usr) {

		var ceid = validSvc.isCE(usr.CE) ? usr.CE : 'NONE';
		var q = {
			isVerity: usr.Type == 'VERITYSA' || usr.Type == 'VERITY',
			isCE: usr.Type == 'CE',
			SearchType: 'AFF',
			CE: validSvc.newProp(ceid),
			RX: validSvc.newProp('ALL'),
			primeProp: 'CE',
			Primary: validSvc.newProp(ceid), // CE is default primary prop
			Secondary: validSvc.newProp(), // secondary is only used for validation, lookat SecondaryMulti for values
			DateType: 'SERVICE',
			StartDate: validSvc.newPropDateNull(),
			EndDate: validSvc.newPropDateNull(),
			DateRangeMode: 'MTD',
			DateRangeList: utilSvc.widget.dateRangeList([]),
			DateRangeValid: false,
			DateRangeChk: false,
			EncounterNumber: validSvc.newProp(),
			RxNumber: validSvc.newProp(),
			ItemCode: validSvc.newProp(),
			PrescriberIdent: validSvc.newProp(),
			SuspectType: validSvc.newProp(),
			DrugType: validSvc.newProp(),
			TotalAmountPaid: validSvc.newProp(),
			PatientLN: validSvc.newProp(),
			Location: validSvc.newProp(),
			Eligible: validSvc.newProp(),
			Allocation: validSvc.newProp(),
			MatchType: validSvc.newProp(),
			RestrictedManufacturer: validSvc.newProp(),
			CashCard: validSvc.newProp(),
			ExternalType: 'TPA'
		};
		q.CE.vals = [];

		// user has edit rights
		q.canEdit = utilSvc.user.hasFeature($scope, 'ops.match.edit');
		q.canRematch = utilSvc.user.hasFeature($scope, 'ops.match.rematch');
		q.canRejectSuspects = utilSvc.user.hasFeature($scope, 'ops.match.suspect.rejectbulk');
        q.userCanBulkMatch = utilSvc.user.hasFeature($scope, 'ops.dispenses.bulk.matches');

		// add dynamic search check marks
		q.EncounterNumber.chk = false;
		q.RxNumber.chk = false;
		q.ItemCode.chk = false;
		q.PrescriberIdent.chk = false;
		q.SuspectType.chk = false;
		q.DrugType.chk = false;
		q.TotalAmountPaid.chk = false;
		q.PatientLN.chk = false;
		q.Location.chk = false;
		q.MatchType.chk = false;
		q.RestrictedManufacturer.chk = false;
		q.CashCard.chk = false;

		q.Eligible.chk = false;
		q.Eligible.title = '';
		q.Eligible.reason = '';
		q.Eligible.overrideOK = false;
		q.Eligible.overrideHist = false;
		q.Eligible.overrideReason = 'ALL';
		q.Eligible.blockhistory = false;
		q.Allocation.chk = false;

		// add stats comparison properties
		q.CompareStartDate = validSvc.newPropDateNull();
		q.CompareEndDate = validSvc.newPropDateNull();

		return q;
	}

	function initViewState(defaultTab) {
		_autoSubmit = false;

		var vs = sessionRepo.get('vs-ops-match-list');
		if(!!vs) {
			_autoSubmit = vs.activeTab == 'SUSPECT'; // auto submit only for SUSPECT tab

			// load saved state, tabChange will load up tab details
			defaultTab = vs.activeTab;
			_tabInfo = vs.tabInfo;

			// remember inactive affs setting
			if(defaultTab == 'MATCH' || defaultTab == 'SUSPECT') {
				vm.showInactiveAffs = vs.showInactiveAffs;
			}
		}

		return defaultTab;

	}

	function initRollupDropList() {
		vm.RollupDroplist = utilSvc.ng.droplistNONE();
		var rollups = findAffRollupParents($scope.User.AffList);
		
		if(rollups.length > 0) {
			// ASYNC: load ROLLUPS, get short names from server
			loadRollupDisplay(rollups);
		} else {
			// ASYNC: LOAD TPA
			initTpaOptions();
		}
	}

	function findAffRollupParents(affs) {
		// get ROLLUP parents from affiliations
		var parentId = '',
			result = [];
		for(var i = 0; i < affs.length; i++) {
			parentId = affs[i].RxParent;
			if(validSvc.isText(parentId) && result.indexOf(parentId) < 0) {
				result.push(parentId);
			}
		}
		return result;
	}

	function loadRollupDisplay(rollups) {

		// ASYNC routine to get RX short names

		lookupRepo.RxInfo(rollups).then(okLookupRx, errLookupRx);

		function okLookupRx(items) {

			// save rollup affs array
			var rollupAffs = [];
			items = Array.isArray(items) ? items : [];
			items.forEach(function(item){
				rollupAffs.push({
					RXID:item.NickName,
					RxShortName: validSvc.isText(item.ShortName) ? item.ShortName : item.NickName
				});
			});

			vm.RollupDroplist = utilSvc.aff.rxDroplist(rollupAffs);
			vm.RollupDroplist[0].label = 'Choose a Rollup Pharmacy';

			// ASYNC: LOAD TPA
			initTpaOptions();
		}

		function errLookupRx(r) {
			if(!!r) {
				errSvc.error('Error loading rollup display properties', 'ctlBillingRx.loadRollupDisplay', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}

	function tblViewSchemaVM(tabName) {

		// feature defined tables with all columns

		var result = {

			MATCH: {
				storageKey: 'tv-ops-match-match',
				name: 'MATCH',
				sortby: 'ServiceDate',
				pgsize: 50,
				sections: {
					Match: {title:'Match'},
					DrugInfo: {title: 'Drug Info'},
					Disp: {title:  'Dispense'},
					EstimatedPricing: {title:  'Estimated Pricing'},
					Enc: {title: 'Encounter'},
					Loc: {title: 'Location'},
					Pat: {title: 'Patient'}
				},
				cols: [
					{section:'Match', 		flt:'Text',		edit: false, name:'LastActivity', colWidth:"40px", title:'Activity', desc:'Last Activity, view activity log and comments.'},
					{section:'Match',		flt:'Text',		name:'Reviewed', title:'Reviewed', desc:'Match review status'},
					{section:'Match', 		flt:'Text',		edit: false, name:'Pharmacy', title:'Pharmacy', desc:'Name of the dispensing Contract Pharmacy'},
					{section:'Match', 		flt:'Text',		edit: false, name:'CoveredEntity', title:'Facility', desc:'Name of the dispensing Facility'},
					{section:'Match', 		flt:'Text',		name:'MatchType', title:'Match Type', desc:'The origin of match'},
					{section:'Match', 		flt:'Text',		default: false, name:'AccumType', title:'Accum Type', desc:'The accumulator origin of match'},
					{section:'Match',		flt:'Text',		name:'EligibleTxt', title:'Eligible', desc:'Accumulation eligibility of match'},
					{section:'Match',		flt:'Text',		name:'Reason', title:'Reason', desc:'If not blank, reason match is not eligible'},
					{section:'Match',		flt:'Dates',	default:false, name:'MatchedDate', title:'Date', desc:'Date of encounter and dispense match'},
					{section:'Match',		flt:'Text',		name:'Usage', title:'Usage', desc:'Editing options for match eligibility and usage'},
					{section:'Match',		flt:'Text',		default:false, name:'SentToTPA', title:'Sent to TPA', desc:'If yes, matched dispenses has been sent to TPA'},
					{section:'Match',		flt:'Text',		default:false, name:'SentToMedicaid', title:'Sent to Medicaid', desc:'If yes, matched dispenses has been sent to Medicaid'},
					{section:'Match',		flt:'Text',		default:false, name:'Referral', title:'Referral', desc:'Match is a referral claim.'},
					{section:'DrugInfo',	flt:'Text',		name:'ItemCode', title:'NDC', desc:'National Drug Code'},
					{section:'DrugInfo',	flt:'Text',		name:'ItemName', title:'Vendor Item Name', desc:'Vendor drug description'},
					{section:'DrugInfo',	flt:'Text',		default:false, name:'Manufacturer', title:'Manufacturer', desc:'Manufacturer'},
					{section:'DrugInfo',	flt:'Text',		default:false, name:'WholesaleUnits', title:'Wholesale Units', desc:'Calculated as package size * case pack size'},
					{section:'DrugInfo',	flt:'Text',		default: false, name:'DrugType', title:'Drug Type', desc:'Brand, Generic or Assay drug types'},
					{section:'DrugInfo',	flt:'Numbers',	default: false, name:'WACPrice', title:'WAC Price', desc:'MediSpan WAC price'},
					{section:'DrugInfo',	flt:'Numbers',	default: false, name:'IRA', title:'IRA', desc:'IRA Claims'},
					{section:'DrugInfo',	flt:'Numbers',	default: false, name:'MRebateClaim', title:'Rebate', desc:'Manufacturer Rebate NDC'},
					{section:'Disp',		flt:'Text',		name:'PrescriberIdent', title:'Provider NPI', desc:'Prescriber'},
					{section:'Disp',		flt:'Text',		name:'PrescriberName', title:'Provider Name', desc:'Prescriber Name'},
					{section:'Disp',		flt:'Text',		default: false, name:'Erx', title:'E Prescribe', desc:'Encounter is an electronic prescription'},
					{section:'Disp',		flt:'Text',		default: false, name:'CashCard', title:'Care Card', desc:'Encounter is care card patient'},
					{section:'Disp',		flt:'Text',		name:'RxNumber', title:'Rx Number', desc:'Pharmacy prescription number'},
					{section:'Disp',		flt:'Dates',	name:'RxWrittenDate', title:'Written', desc:'Date prescription was written'},
					{section:'Disp',		flt:'Dates',	name:'ServiceDate', title:'Filled', desc:'Date prescription was filled (service date)'},
					{section:'Disp',		flt:'Numbers',	name:'FillNumber', title:'Fill #', desc:'Prescription fill number'},
					{section:'Disp',		flt:'Numbers',	name:'DispQuantity', title:'Qty', desc:'Drug quantity dispensed'},
					{section:'Disp',		flt:'Numbers',	default: false, name:'AllocQuantity', title:'Allocated Qty', desc:'Drug quantity used for backing'},
					{section:'Disp',		flt:'Numbers',	default: false, name:'TotalAmountPaid', title:'Total Paid', desc:'Total customer payment'},
					{section:'Disp',		flt:'Text',		default:false, name:'BinPcnTxt', title:'BIN PCN', desc:'Payor BIN, PCN and GROUP'},
					{section:'Disp',		flt:'Text',		default:false, name:'Chid', title:'CHID', desc:'Cardholder ID'},
					{section:'Disp',		flt:'Text',		default: false, name:'Medicaid', title:'Medicaid', desc:'Medicaid covered transaction'},
					{section:'EstimatedPricing',		flt:'Numbers',	default: false, name:'PharmacyPrice', title:'Pharmacy Price', desc:'Pharmacy Price'},
					{section:'EstimatedPricing',		flt:'Numbers',	default: false, name:'CEPrice', title:'CE Price', desc:'CE Price'},
					{section:'EstimatedPricing',		flt:'Numbers',	default: false, name:'DispenseFee', title:'Dispense Fee', desc:'Dispense Fee'},
					{section:'EstimatedPricing',		flt:'Numbers',	default: false, name:'OrderFee', title:'Order Fee', desc:'Order Fee'},
					{section:'EstimatedPricing',		flt:'Numbers',	default: false, name:'ReferralFee', title:'Referral Fee', desc:'Referral Fee'},
					{section:'EstimatedPricing',		flt:'Numbers',	default: false, name:'Savings', title:'Savings', desc:'Savings'},
					{section:'EstimatedPricing',		flt:'Numbers',	default: false, name:'Vendor', title:'Vendor', desc:'Vendor'},
					{section:'Enc',			flt:'Numbers',	name:'EncounterNumber', title:'Number', desc:'Patient visit record number'},
					{section:'Enc',			flt:'Dates',	name:'EncounterDate', title:'Date', desc:'Patient visit date'},
					{section:'Enc',			flt:'Text',	    default:false, name:'EncounterPrescriberNPI', title:'Encounter Provider NPI', desc:'Patient visit prescriber NPI'},
					{section:'Enc',			flt:'Text',		default:false, name:'MRN', title:'MRN', desc:'Medical Record Number'},
					{section:'Loc',			flt:'Text',		default:false, name:'EncounterLocation', title:'Location', desc:'Patient visit facility location'},
					{section:'Pat',			flt:'Text',		default:false, name:'PatientLN', title:'Last', desc:'Patient Last Name'},
					{section:'Pat',			flt:'Text',		default:false, name:'PatientFN', title:'First', desc:'Patient First Name'}
				]
			},
			SUSPECT: {
				storageKey: 'tv-ops-match-suspect',
				name: 'SUSPECT',
				sortby: 'ServiceDate',
				pgsize: 50,
				sections: {
					Suspect: {title:'Suspect'},
					DrugInfo: {title: 'Drug Info'},
					Pres: {title:  'Prescriber'},
					Disp: {title:  'Dispense'},
					EstimatedPricing: {title:  'Estimated Pricing'},
					Pat: {title: 'Patient'}
				},
				cols: [
					{section:'Suspect', 	flt:'Text',		edit: false, name:'LastActivity', colWidth:"40px", title:'Activity', desc:'Last Activity, view activity log and comments.'},
					{section:'Suspect',		flt:'Text',		name:'Reviewed', title:'Reviewed', desc:'Suspect review status'},
					{section:'Suspect',		flt:'Text',		edit: false, name:'Pharmacy', title:'Pharmacy', desc:'Name of the dispensing Contract Pharmacy'},
					{section:'Suspect', 	flt:'Text',		edit: false, name:'CoveredEntity', title:'Facility', desc:'Name of the dispensing Facility'},
					{section:'Suspect', 	flt:'Text',		name:'SuspectType', title:'Type', desc:'Type of suspect'},
					{section:'Suspect',		flt:'Text',		name:'EligibleTxt', title:'Eligible', desc:'Accumulation eligibility of match'},
					{section:'Suspect',		flt:'Text',		name:'Reason', title:'Reason', desc:'If not blank, reason match is not eligible'},
					{section:'Suspect',		flt:'Text',		name:'OverrideTxt', title:'Can Override', desc:'Indicates if suspect can be overridden to eligible'},
					{section:'Suspect',		flt:'Text',		default:false, name:'HasOwnUseMatch', title:'Own Use Matched', desc:'Indicates if an Own Use Match exists for the claim'},
					{section:'Suspect',		flt:'Dates',	default:false, name:'MatchedDate', title:'Date', desc:'Date of encounter and dispense match'},
					{section:'DrugInfo',	flt:'Text',		default: false, name:'ItemCode', title:'NDC', desc:'National Drug Code'},
					{section:'DrugInfo',	flt:'Text',		default: false, name:'ItemName', title:'Vendor Item Name', desc:'Vendor drug description'},
					{section:'DrugInfo',	flt:'Text',		default: false, name:'Manufacturer', title:'Manufacturer', desc:'Manufacturer'},
					{section:'DrugInfo',	flt:'Text',		default: false, name:'WholesaleUnits', title:'Wholesale Units', desc:'Calculated as package size * case pack size'},
					{section:'DrugInfo',	flt:'Text',		default: false, name:'DrugType', title:'Drug Type', desc:'Brand, Generic or Assay drug types'},
					{section:'DrugInfo',	flt:'Numbers',	default: false, name:'WACPrice', title:'WAC Price', desc:'MediSpan WAC price'},
					{section:'DrugInfo',	flt:'Numbers',	default: false, name:'IRA', title:'IRA', desc:'IRA Claims'},
					{section:'DrugInfo',	flt:'Numbers',	default: false, name:'MRebateClaim', title:'Rebate', desc:'Manufacturer Rebate NDC'},
					{section:'Pres',		flt:'Text',		name:'PrescriberIdent', title:'Provider NPI', desc:'Prescriber NPI'},
					{section:'Pres',		flt:'Text',		name:'PrescriberName', title:'Provider Name', desc:'Prescriber Name'},
					{section:'Disp',		flt:'Text',		default: false, name:'Erx', title:'E Prescribe', desc:'Encounter is an electronic prescription'},
					{section:'Disp',		flt:'Text',		default: false, name:'CashCard', title:'Care Card', desc:'Encounter is care card patient'},
					{section:'Disp',		flt:'Text',		name:'RxNumber', title:'Rx Number', desc:'Pharmacy prescription number'},
					{section:'Disp',		flt:'Dates',	name:'RxWrittenDate', title:'Written', desc:'Date prescription was written'},
					{section:'Disp',		flt:'Dates',	name:'ServiceDate', title:'Filled', desc:'Date prescription was filled (service date)'},
					{section:'Disp',		flt:'Numbers',	name:'FillNumber', title:'Fill #', desc:'Prescription fill number'},
					{section:'Disp',		flt:'Numbers',	name:'DispQuantity', title:'Qty', desc:'Drug quantity dispensed'},
					{section:'Disp',		flt:'Numbers',	name:'TotalAmountPaid', title:'Total Paid', desc:'Total customer payment'},
					{section:'Disp',		flt:'Text',		default:false, name:'BinPcnTxt', title:'BIN PCN', desc:'Payor BIN, PCN and GROUP'},
					{section:'Disp',		flt:'Txt',	default:false, name:'Medicaid', title:'Medicaid', desc:'Medicaid covered transaction'},
					{section:'EstimatedPricing',		flt:'Numbers',	default: false, name:'PharmacyPrice', title:'Pharmacy Price', desc:'Pharmacy Price'},
					{section:'EstimatedPricing',		flt:'Numbers',	default: false, name:'CEPrice', title:'CE Price', desc:'CE Price'},
					{section:'EstimatedPricing',		flt:'Numbers',	default: false, name:'DispenseFee', title:'Dispense Fee', desc:'Dispense Fee'},
					{section:'EstimatedPricing',		flt:'Numbers',	default: false, name:'OrderFee', title:'Order Fee', desc:'Order Fee'},
					{section:'EstimatedPricing',		flt:'Numbers',	default: false, name:'ReferralFee', title:'Referral Fee', desc:'Referral Fee'},
					{section:'EstimatedPricing',		flt:'Numbers',	default: false, name:'Savings', title:'Savings', desc:'Savings'},
					{section:'EstimatedPricing',		flt:'Numbers',	default: false, name:'Vendor', title:'Vendor', desc:'Vendor'},
					{section:'Pat',			flt:'Text',		default:false, name:'PatientLN', title:'Last', desc:'Patient Last Name'},
					{section:'Pat',			flt:'Text',		default:false, name:'PatientFN', title:'First', desc:'Patient First Name'}
				]
			}
		};

		if(validSvc.isText(tabName)) {
			return result[tabName];
		}
		else {
			return result;
		}
	}

	function tblViewConfigSetup(uType, rxModels, tblSchema, query) {

		// convert generic view schema into user specific table configs
		// note: match feature has multiple tabs, hence multiple tables to iterate

		var result = {},
			cols = [],
			col = {},
			colKeys = {},
			colAllowed = [],
			queryCheck = !!query,
			showCE = false,
			showRX = false;

		// check query values? (only after list search)
		if(queryCheck) {
			if(query.SearchType == 'TPA') {
				showCE = true;
				showRX = true;
			}
			else if(query.primeProp == 'CE') {
				showRX = true;
			}
			else if(query.primeProp == 'RX') {
				showCE = true;
			}
			else {
				// something off with query, don't query check
				queryCheck = false;
			}
		}
		else {
			showCE = true;
			showRX = true;
		}

		for(var prop in tblSchema) {
			if(tblSchema.hasOwnProperty(prop)) {
				cols = tblSchema[prop].cols;
				colKeys = {};
				colAllowed = [];

				for(var i = 0; i < cols.length; i++) {
					col = cols[i];

					// user check
					if(!!col.utypes && col.utypes.indexOf('|' + uType + '|') < 0) {
						continue;
					}

					// rx model check
					if(!!col.rxmodels) {
						var foundModel = false;
						for(var ii = 0; ii < rxModels.length; ii++) {
							if(col.rxmodels.indexOf('|' + rxModels[ii] + '|') > -1) {
								foundModel = true;
								break;
							}
						}
						if(!foundModel) {
							continue;
						}
					}

					// check query values after list search
					if(queryCheck) {
						if(!showCE && col.name == 'CoveredEntity') {
							continue;
						}
						if(!showRX && col.name == 'Pharmacy') {
							continue;
						}
					}

					// keep column
					colAllowed.push(col.name);
					colKeys[col.name] = col;
				}

				// update columns for this table
				tblSchema[prop].cols = colAllowed;
				tblSchema[prop].colKeys = colKeys;

				// add to result (which may have more than 1 table in config)
				result[prop] = tblSchema[prop];
			}
		}

		return result;

	}

	function dynaQueryProps(ceid) {

		// note: props are shared for MATCH/SUSPECT and must exist on both for html bind to work

		return {
			SearchType: 'AFF',
			primeProp: 'CE',
			Primary: ceid,
			Secondary: [],

			DateType: 'SERVICE',
			DateRangeMode: 'MTD',
			DateRangeChk: true,
			StartDate: validSvc.newPropDateNull(),
			EndDate: validSvc.newPropDateNull(),

			EncounterNumberChk: false,
			EncounterNumber: '',
			RxNumberChk: false,
			RxNumber: '',
			ItemCodeChk: false,
			ItemCode: '',

			PrescriberIdentChk: false,
			PrescriberIdent: '',

			SuspectTypeChk: false,
			SuspectType: '',
			DrugTypeChk: false,
			DrugType: '',
			TotalPaidAmountChk: false,
			TotalPaidAmount: '',

			PatientLNChk: false,
			PatientLN: '',
			LocationChk: false,
			Location: '',

			EligibleChk: false,
			Eligible: '',
			EligibleReason: '',
			EligibleOverrideOK: false,
			EligibleOverrideHist: false,
			EligibleOverrideReason: 'ALL',
			BlockHistory: false,

			MatchTypeChk: false,
			MatchType: '',

			RestrictedManufacturer: [],
			RestrictedManufacturerChk: false,

			CashCardChk: false,
			CashCard: '',

			ReferralChk: false,
			Referral: '',

			OrderableChk: false,
			Orderable: '',

			EstimatePricingChk: false,
			EstimatePricing: '',
			
			IRAChk: false,
			IRA: '',

			RebateChk: false,
			Rebate: ''
		};
	}

	function initTabInfo(ceid) {

		return {
			MATCH: {
				query: dynaQueryProps(ceid),
				flt: vm.initFilters({
					Config: {
						Dates: ['MatchedDate','RxWrittenDate', 'ServiceDate', 'EncounterDate'],
						DateFmt: 'M/d/yyyy'
					},
					SortBy: ['ServiceDate']
				})
			},
			SUSPECT: {
				query: dynaQueryProps(ceid),
				flt: vm.initFilters({
					Config: {
						Dates: ['MatchedDate', 'RxWrittenDate', 'ServiceDate'],
						DateFmt: 'M/d/yyyy'
					},
					SortBy: ['ServiceDate']
				})
			},
			STATS: {
				query: dynaQueryProps(ceid)
			},
			EVAL: {
				query: {
					CE: ceid,
					DateType: 'SERVICE',
					DateRangeMode: 'MTD',
					StartDate: validSvc.newPropDateNull(),
					EndDate: validSvc.newPropDateNull()
				},
				flt: vm.initFilters({
					Config: {
						Dates: ['StartFrom', 'CreateDate'],
						DateFmt: 'M/d/yyyy'
					},
					Exact: {
						StatusTxt: '',
						DateType: ''
					},
					SortBy: ['-CreateDate']
				})
			},
			REMATCH: {
				query: {
					CE: ceid,
					DateType: 'SERVICE',
					DateRangeMode: 'MTD',
					StartDate: validSvc.newPropDateNull(),
					EndDate: validSvc.newPropDateNull()
				},
				flt: vm.initFilters({
					Config: {
						Dates: ['CreateDate'],
						DateFmt: 'M/d/yyyy'
					},
					Exact: {
						StatusTxt: '',
						DateType: ''
					},
					SortBy: ['-CreateDate']
				})
			},
			REMATCHNEW: {
				query: {
					SearchType: 'AFF',
					primeProp: 'CE',
					Primary: ceid,
					Secondary: ['ALL'] // multi select
				}
			},
			SENTMATCH: {
				query: {
					CE: ceid,
					RX: '',
					SearchType: 'AFF',
					RxNumber: '',
					DateRangeMode: 'MTD',
					StartDate: validSvc.newPropDateNull(),
					EndDate: validSvc.newPropDateNull()
				},
				flt: vm.initFilters({
					Config: {
						Dates: ['ExtractDate','DispFillDate'],
						DateFmt: 'M/d/yyyy'
					},
					SortBy: ['ExtractDate']
				})
			}
		};
	}


	/**
	 *    VIEW MODELS
	 */

	function displayVM(dataItems, tooMany) {

		// convert data model into display properties

		dataItems = Array.isArray(dataItems) ? dataItems : [];

		var item = null,
			tabIsMatch = vm.activeTab == 'MATCH',
			ii = 0;
		var tabIsMatchOrSuspect = tabIsMatch || vm.activeTab == 'SUSPECT';

		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];

			item.uniqueId = i.toString();

			// ePrescribe (pack RxNumber and eRx into RxNumberTxt)
			item.RxNumberTxt = validSvc.isText(item.RxNumber) ? item.RxNumber.toString() : '';
			if(!!item.Eprescribe) {
				item.RxNumberTxt = 'eRX' + item.RxNumberTxt;
			}

			// shorten patient name
			var pname = item.PatientFN;
			if(validSvc.isText(pname) && pname.length > 6) {
				item.PatientFN = pname.substr(0,6) + '...';
			}

			// Item editable is both user permission and affiliation is VerityAdmin
			item.CanEdit = vm.query.canEdit;
			if (validSvc.isText(item.ProgramAdmin) && item.MatchType != 'MANUAL') {
				item.CanEdit = false;
			}
			item.IsTPA = item.MatchType === 'SYSTEM - TPA';

			if(tabIsMatchOrSuspect) {
				item.EligibleTxt = item.Eligible == 'YES' ? 'YES' : 'NO';
				item.HasOwnUseMatch = !!item.HasOwnUseMatch ? 'YES' : 'NO';

				// user friendly State Reasons
				item.StateReasons = Array.isArray(item.StateReasons) ? item.StateReasons : [];
				for(ii = 0; ii < item.StateReasons.length; ii++) {
					item.StateReasons[ii] = userFriendlyReasonText(item.State, item.StateReasons[ii]);
				}

				if(item.StateReasons.length === 1) {
					item.Reason = item.StateReasons[0];
				}
				else if(item.StateReasons.length > 1) {
					item.Reason = 'MULTIPLE';
				}
				else {
					item.Reason = '';
				}
				
				item.Eprescribe = !!item.Eprescribe;
				item.Erx = !!item.Eprescribe ? 'YES' : 'NO';
				item.CashCard = !!item.CashCard ? 'YES' : 'NO';

				item.EligOverride = !!item.EligOverride;
				item.OverrideTxt = item.EligOverride ? 'YES' : 'NO';

				item.hasDetail = false;
				item.Overrides = Array.isArray(item.Overrides) ? item.Overrides : [];
				item.BlockHistory = Array.isArray(item.BlockHistory) ? item.BlockHistory : [];

				if(validSvc.isText(item.BinPcnString)) {
					item.BinPcnTxt = item.BinPcnString.replace(/\b\]\[+/g,', ');  // swap "][" for ", "
					item.BinPcnTxt = item.BinPcnTxt.replace(/[\[\]]+/g,''); // drop all other hard brackets
				}
				else {
					item.BinPcnTxt = '';
				}
				item.Medicaid = !!item.Medicaid ? 'YES' : 'NO';

			}

			if(tabIsMatchOrSuspect) {
				item.Reviewed = !!item.Reviewed ? 'YES' : 'NO';
				item.ChangeLog = parseChangeLog(item.ChangeLog);
				item.hasLog = item.ChangeLog.length > 0;
				item.LastActivity = item.hasLog ? item.ChangeLog[0].Activity : '';
			}

			if(tabIsMatch) {
				item.BlockOverride = !!item.BlockOverride;
				// user friendly override reasons
				for(ii = 0; ii < item.Overrides.length; ii++) {
					if(validSvc.isText(item.Overrides[ii].OveriddenReason)) {
						item.Overrides[ii].OveriddenReason = userFriendlyReasonText('INELIGIBLE', item.Overrides[ii].OveriddenReason);
					}
				}

				// details indicator
				if(item.StateReasons.length > 0 || item.Overrides.length > 0 || item.BlockHistory.length > 0) {
					item.hasDetail = true;
				}

				// usage filter
				item.Usage = '';
				if(item.CanEdit) {
					if(item.Eligible == 'YES') {
						item.Usage += '|reject';
					}
					if(item.EligOverride) {
						item.Usage += '|override';
					}
					if(item.BlockOverride) {
						item.Usage += '|undo';
					}
				}

				
			}

		}

		return {
			Items: [],
			DataItems: dataItems,
			TooMany: tooMany
		};

	}

	function parseChangeLog(items) {
		if(!Array.isArray(items)) {
			return [];
		}

		var item = null;
		for(var i = 0; i < items.length; i++) {
			item = items[i];
			item.Activity = item.Status;
		}

		return items.reverse();
	}

	function matchConfigVM(data) {

		data = data || {};
		var ce = data.CE || {},
			affs = [],
			aff = {};

		data.Affil = Array.isArray(data.Affil) ? data.Affil : [];
		for(var i = 0; i < data.Affil.length; i++) {
			aff = data.Affil[i];

			affs.push({
				CEID: aff.CEID,
				RXID: aff.RXID,
				RxShortName: utilSvc.ng.droplistLabel(vm.RxDroplist, aff.RXID),
				EligibleDaysPreDispense: validSvc.isNumber(aff.EligibleDaysPreDispense) ? aff.EligibleDaysPreDispense : 0,
				EligibleDaysPostDispense: validSvc.isNumber(aff.EligibleDaysPostDispense) ? aff.EligibleDaysPostDispense : 0,
				MedicaidFFSCarveIn: !!aff.MedicaidFFSCarveIn ? 'YES' : 'NO',
				MedicaidMCOCarveIn: !!aff.MedicaidMCOCarveIn ? 'YES' : 'NO',
				ValidateMedicaidClaims: !!aff.ValidateMedicaidClaims ? 'YES' : 'NO',
				ProfitableOnly: !!aff.ProfitableOnly ? 'YES' : 'NO',
				GenericOrderable: !!aff.GenericOrderable ? 'YES' : 'NO',
				CIIOrderable: !!aff.CIIOrderable ? 'YES' : 'NO',
				NpiEnforceProximity: !!aff.NpiEnforceProximity ? 'YES' : 'NO',
				NpiMaxFullProximity: validSvc.isNumber(aff.NpiMaxFullProximity) ? aff.NpiMaxFullProximity : 0,
				NpiMaxPartProximity: validSvc.isNumber(aff.NpiMaxPartProximity) ? aff.NpiMaxPartProximity : 0
			});
		}

		return {
			NpiEnforceProximity: !!ce.NpiEnforceProximity ? 'YES' : 'NO',
			NpiMaxFullProximity: validSvc.isNumber(ce.NpiMaxFullProximity) ? ce.NpiMaxFullProximity : 0,
			NpiMaxPartProximity: validSvc.isNumber(ce.NpiMaxPartProximity) ? ce.NpiMaxPartProximity : 0,
			Affs: affs
		};

	}

	function userFriendlyReasonText(apiState, apiStateReason) {

		// convert api state + reason into user friendly text
		if(validSvc.isText(apiStateReason)) {
			apiStateReason = apiStateReasonDisplayTxt(apiStateReason);
		}
		
		switch(apiState) {

			case 'REVERSED':
				return apiState;

			case 'UNMATCHED':
				if(validSvc.isText(apiStateReason)) {
					return utilSvc.ng.droplistLabel(vm.EligibleDroplist, 'UNMATCHED-' + apiStateReason);
				}
				return 'UNMATCHED';

			case 'INELIGIBLE':
				if(validSvc.isText(apiStateReason)) {
					var eligTxt = utilSvc.ng.droplistLabel(vm.EligibleDroplist, 'INELIGIBLE-' + apiStateReason);
					if(validSvc.isText(eligTxt)) {
						return eligTxt;
					}
					return apiStateReason; // show state reason if it is not a searchable state reason
				}
				return ''; // hide INELIGIBLE state with no state reason
			default:
				return '';
		}

	}

	function apiStateReasonDisplayTxt(apiStateReason) {

		switch(apiStateReason) {
			case 'IRA_RESTRICT':
				return 'IRA RESTRICT';
			case 'MFR_REBATE':
				return 'MFR REBATE';
			case 'IRA_NO_PROFIT':
				return 'IRA NO PROFIT';
			default:
				return apiStateReason;
		}

	}

	function dateTypeDisplayTxt(dtType) {

		switch(dtType) {
			case 'MATCH':
				return 'Matched';
			case 'SERVICE':
				return 'Filled';
			case 'RXWRITTEN':
				return 'Written';
			default:
				return '';
		}

	}

	function evalRematchVM(isEval, dataItems, tooMany) {

		dataItems = Array.isArray(dataItems) ? dataItems : [];

		var item = {},
			statTxt = '',
			progNow = 0,
			progTotal = 0;

		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.uniqueId = i.toString();
			item.CreateDate = validSvc.isDate(item.CreateDate) ? item.CreateDate : null;

			if(isEval) {
				item.DateType = dateTypeDisplayTxt(item.DateProperty);
				item.StartFrom = validSvc.isDate(item.StartFrom) ? item.StartFrom : null;
				item.DryRunTxt = !!item.DryRun ? 'YES' : 'NO';
				
				// re-match has Affils in Affils property
				item.Affils = Array.isArray(item.Affils) ? item.Affils : [];
			}
			else {
				// eval has Affils in Pharmacies property
				item.Affils = Array.isArray(item.Pharmacies) ? item.Pharmacies : [];
			}
			item.AffilsTxt = item.Affils.length > 0 ? item.Affils.join(', ') : 'All Affiliations';	

			// add completion %
			statTxt = item.State;
			var progressTxt = '';
			if(statTxt != 'DONE' && statTxt != 'ERROR') {
				if(validSvc.isInteger(item.EstimatedToProcess) && validSvc.isInteger(item.TotalProcessed)) {
					progNow = parseInt(item.TotalProcessed);
					progTotal = parseInt(item.EstimatedToProcess);
					if(progNow < 1) {
						progressTxt += ' (0%)';
					}
					else if(progTotal > 0) {
						if(progTotal > progNow) {
							progNow = Math.round((progNow / progTotal)*100);
							progressTxt += ' (' + progNow.toString() + '%)';
						}
						else {
							progressTxt += ' (100%)';
						}
					}
				}
			}
			item.StatusTxt = statTxt;
			item.ProgressTxt = progressTxt;
		}

		return {
			Items: [],
			DataItems: dataItems,
			TooMany: tooMany
		};

	}

	function matchStatsVM(data) {
		data = data || {};

		return {
			// dispense stats
			Dispenses: numberFmt(data.Dispenses, '0','', 0),
			NewEligibleDispenses: numberFmt(data.NewEligibleDispenses, '0','', 0),
			DispensesNotMatched: numberFmt(data.DispensesNotMatched, '0', '-', 0),
			NewMatchedDispenses: numberFmt(data.NewMatchedDispenses, '0','', 0),
	
			// match stats
			AcceptedSuspects: numberFmtNoPrefix(data.AcceptedSuspects, '0', 0),
			ProviderFiltered: numberFmt(data.ProviderFiltered, '0','-', 0),
			MedicaidFiltered: numberFmt(data.MedicaidFiltered, '0','-', 0),
			VisitProximityFiltered: numberFmt(data.VisitProximityFiltered, '0','-', 0),
			NpiProximityFiltered: numberFmt(data.NpiProximityFiltered, '0','-', 0),
			BlockedScriptFiltered: numberFmt(data.BlockedScriptFiltered, '0','-', 0),
			ErxNpiFiltered: numberFmt(data.ErxNpiFiltered, '0','-', 0),
			LocationFiltered: numberFmt(data.LocationFiltered, '0','-', 0),
			MiscFiltered: numberFmt(data.MiscFiltered, '0','-', 0),
			ReversedMatches: numberFmt(data.ReversedMatches, '0','-', 0),
	
			// match ratios
			MatchedRatio: numberFmtNoPrefix(data.MatchedRatio, '0', 0),
			EligibleDispensesRatio: numberFmtNoPrefix(data.EligibleDispensesRatio, '0', 0),
			EligibleMatchesRatio: numberFmtNoPrefix(data.EligibleMatchesRatio, '0', 0)
		};	
	}


	/**
	 * 	 SENT MATCH
	 */

	function sentMatchVM(items) {

		items = Array.isArray(items) ? items : [];
		var item = {},
			show = {
				RecordID: false,
				MedicaidID: false,
				PharmacyNPI: false,
				ProviderNPI: false,
				ClaimIndicatory: false,
				Reason: false,
				State: false,
				colCount: 0,
			};
			
		for(var i = 0; i < items.length; i++) {
			item = items[i];
			item.uniqueId = i.toString();

			if(validSvc.isText(item.ExtractFileName)) {
				item.ExtractFileNameTxt = item.ExtractFileName.substr(0, 10) + '...';
			}

			// optional columns
			item.State = validSvc.isText(item.MedicaidState) ? item.MedicaidState : '';
			show = showOptionalColumns(show, item);
		}
		show.colCount = showOptionalColCount(show);

		return {
			Items: [],
			DataItems: items,
			show: show,
		};

		// HELPERS
		function showOptionalColumns(show, item) {
			// find each optional column and set show property if not set
			for(var prop in show) {
				if(show.hasOwnProperty(prop) && !show[prop]) {
					show[prop] = validSvc.isText(item[prop]);
				}
			}
			return show;
		}

		function showOptionalColCount(show) {
			// count the number of optional columns to show
			var count = 0;
			for(var prop in show) {
				if(show.hasOwnProperty(prop) && show[prop]) {
					count++;
				}
			}
			return count;
		}
	}

	function getSentMatchRollups() {
		var affs = getAffs(),
			aff = {},
			rxParents = [],
			ceRollupOptions = [];

		// loop affs looking for a rollup parent
		vm.sentMatchRollupAffs = [];
		for(var i = 0; i < affs.length; i++) {
			aff = affs[i];
			if(validSvc.isText(aff.RxParent)) {

				// add to query list
				if(rxParents.indexOf(aff.RxParent) < 0) {
					rxParents.push(aff.RxParent);
				}

				// add unique CE / rollup aff options
				if(ceRollupOptions.indexOf(aff.CEID + aff.RxParent) < 0) {
					ceRollupOptions.push(aff.CEID + aff.RxParent);

					vm.sentMatchRollupAffs.push({
						CEID: aff.CEID,
						RXID: aff.RxParent,
						RxShortName: '' // shortname filled in after lookup
					});
				}
			}
		}

		// nothing to look up
		if(rxParents.length < 1) {
			_checkForRollups = true;
			tabChange('SENTMATCH');
			return false;
		}

		// found TPA rollup parents, get their short names
		vm.isWaiting = true;
		lookupRepo.RxInfo(rxParents).then(okLookupRx, errLookupRx);
	}

	function okLookupRx(items) {
		vm.isWaiting = false;
		items = Array.isArray(items) ? items : [];

		var roptions = vm.sentMatchRollupAffs,
			rxid = '',
			ii = 0;

		// replace RX short name with rollup short name
		for(var i = 0; i < roptions.length; i++) {
			rxid = roptions[i].RXID;
			for(ii = 0; ii < items.length; ii++) {
				if(rxid == items[ii].NickName) {
					roptions[i].RxShortName = items[ii].ShortName;
				}
			}
		}

		_checkForRollups = true;
		tabChange('SENTMATCH');
	}

	function errLookupRx(r) {
		vm.isWaiting = false;
		if(!!r) {
			errSvc.warn('Error loading rollup display properties', 'matchList.getSentMatchRollups', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    TAB CHANGE
	 */

	function dynaQueryPropLoad(vsq, propName, propDefault) {

		// load query from tab info saved query

		var result = validSvc.newProp(propDefault);

		var chkName = propName + 'Chk';
		result.chk = !!vsq[chkName];
		if(result.chk) {
			result.val = vsq[propName];
		}

		return result;

	}

	function loadTabInfo(tabName, q) {

		// on tab change replace query properties saved for this tab

		var vsq = _tabInfo[tabName].query;

		q.DateType = vsq.DateType;
		q.DateTypeTxt = dateTypeDisplayTxt(q.DateType);
		q.DateRangeMode = vsq.DateRangeMode;
		q.DateRangeValid = true;
		q.StartDate.val = new Date(vsq.StartDate);
		q.EndDate.val = new Date(vsq.EndDate);
		q.ExternalType = '';

		switch(tabName) {

			case 'EVAL':
			case 'REMATCH':
				q.CE = validSvc.newProp(vsq.CE);
				break;

			case 'SENTMATCH':
				q.CE = validSvc.newProp(vsq.CE);
				q.CE.vals = [];
				q.RX = validSvc.newProp('NONE');
				q.SearchType = 'AFF'; // AFF or ROLLUP
				q.ExternalType = 'TPA'; // TPA or STATEFFS
				q.RxNumber = validSvc.newProp('');
				break;
	
			case 'REMATCHNEW':
				q.SearchType = vsq.SearchType;
				q.primeProp = vsq.primeProp;
				q.Primary = validSvc.newProp(q.CE.val);
				q.Secondary = validSvc.newProp();
				q.Secondary.val = vsq.Secondary; // multi select

				// start date default is 1 year ago
				var dt = new Date();
				var dtLastYear = new Date(dt.getFullYear() - 1, dt.getMonth(), dt.getDate(), 0, 0, 0);
				var dtMin = new Date(dt.getFullYear() - 5, dt.getMonth(), dt.getDate(), 0, 0, 0);
				q.StartDate = validSvc.newPropDate(dtLastYear, dtMin);
				q.EndDate = validSvc.newPropDate(); // always today
				break;

			case 'MATCH':
			case 'SUSPECT':
				q.SearchType = vsq.SearchType;
				q.primeProp = vsq.primeProp;
				q.Primary = validSvc.newProp(vsq.Primary);
				q.Primary.title = utilSvc.ng.droplistLabel(vm.PrimaryDroplist, vsq.Primary);
				q.Secondary = validSvc.newProp();
				q.Secondary.val = vsq.Secondary; // multi select
				q.DateRangeChk = !!vsq.DateRangeChk;

				// dyna query options
				q.EncounterNumber = dynaQueryPropLoad(vsq, 'EncounterNumber', '');
				q.RxNumber = dynaQueryPropLoad(vsq, 'RxNumber', '');
				q.ItemCode = dynaQueryPropLoad(vsq, 'ItemCode', '');
				q.PrescriberIdent = dynaQueryPropLoad(vsq, 'PrescriberIdent', '');
				q.SuspectType = dynaQueryPropLoad(vsq, 'SuspectType', '');
				q.DrugType = dynaQueryPropLoad(vsq, 'DrugType', '');
				q.TotalAmountPaid = dynaQueryPropLoad(vsq, 'TotalAmountPaid', '');
				q.PatientLN = dynaQueryPropLoad(vsq, 'PatientLN', '');
				q.Location = dynaQueryPropLoad(vsq, 'Location', '');
				q.MatchType = dynaQueryPropLoad(vsq, 'MatchType', '');
				q.CashCard = dynaQueryPropLoad(vsq, 'CashCard', '');
				q.Referral = dynaQueryPropLoad(vsq, 'Referral', '');
				q.Orderable = dynaQueryPropLoad(vsq, 'Orderable', '');
				q.EstimatePricing = dynaQueryPropLoad(vsq, 'EstimatePricing', '');
				q.RestrictedManufacturer = dynaQueryPropLoad(vsq, 'RestrictedManufacturer', '');
				q.IRA = dynaQueryPropLoad(vsq, 'IRA', '');
				q.Rebate = dynaQueryPropLoad(vsq, 'Rebate', '');
				if (q.RestrictedManufacturer.val.length > 0) {
					vm.multiselectReturnVisit(vm.ManufacturerMulti, '', q.RestrictedManufacturer.val);
					vm.multiselectTitle(vm.ManufacturerMulti, true);
				} else {
					queryChangeRestrictedManufacturer('ALL');
				}

				var elig = dynaQueryPropLoad(vsq, 'Eligible', '');
				elig.reason = elig.chk ? vsq.EligibleReason : '';
				elig.overrideOK = elig.chk ? !!vsq.EligibleOverrideOK : false;
				elig.overrideHist = elig.chk ? !!vsq.EligibleOverrideHist : false;
				elig.overrideReason = elig.chk ? vsq.EligibleOverrideReason : 'ALL';
				elig.blockhistory = elig.chk ? !!vsq.EligibleBlockHistory : false;
				elig.title = elig.chk ? buildEligibleTitle(tabName, true, elig) : '';
				q.Eligible = elig;
				q.Allocation = dynaQueryPropLoad(vsq, 'Allocation', '');
				if (q.Allocation.val.length > 0) {
					vm.multiselectReturnVisit(vm.AllocationMulti, '', q.Allocation.val);
					vm.multiselectTitle(vm.AllocationMulti, true);
				} else {
					queryChangeAllocation('ALL');
				}
				break;

			case 'STATS':
				q.SearchType = vsq.SearchType;
				q.primeProp = vsq.primeProp;
				q.Primary = validSvc.newProp(vsq.Primary);
				q.Primary.title = utilSvc.ng.droplistLabel(vm.PrimaryDroplist, vsq.Primary);
				q.Secondary = validSvc.newProp();
				q.Secondary.val = vsq.Secondary;

				q.DateRangeChk = true; // always show date range, there is no check
				break;
		
			default:
				msgSvc.ok('matchListCtl.loadTabInfo', 'unknown tab name: ' + tabName);
		}

		return q;
	}

	function tabChange(newTab) {

		if(vm.isWaiting) {
			return;
		}

		queryChange();
		vm.activeTab = newTab;

		var q = vm.query;

		switch(newTab) {

			case 'EVALNEW':
				// edit tabs using CE/RX, no tables or widget for date range
				var dtToday = utilSvc.dt.zeroTime(new Date());
				q.EndDate = validSvc.newPropDateNull();
				q.EndDate.val = dtToday;
				q.StartDate = validSvc.newPropDateNull();
				q.StartDate.val = utilSvc.dt.zeroTime(utilSvc.dt.addDays(dtToday, -30));
				q.Evaluate = '340B';
				q.ExcludeAllocatedMatches = true;

				if(vm.query.CE.fail == 'yes') {
					msgSvc.ok('Cannot Re-Evaluate', 'Choose a valid Facility');
					tabChange('EVAL');
					return;
				}

				// build eval options (aff lookup has already been done on init)
                evalBuildPharmacyOptions(vm.query.Evaluate);
				break;

			case 'SENTMATCH':
				// get rollups once on first tab click
				if(!_checkForRollups) {
					getSentMatchRollups();
					return;
				}
				q = loadTabInfo(newTab, q);
				vm.flt = vm.resetFilters(_tabInfo[newTab].flt);
				
				queryChangeTpaSearchType();

				// initialize date range widget
				$timeout(function() {
					$scope.$broadcast('widget.input.date.range.mode', {
						uniqueId: 'SENTMATCH',
						mode: q.DateRangeMode,
						keepDates: false});
				},300);
				break;

			case 'REMATCHNEW':
				// save REMATCH CE
				_tabInfo['REMATCH'].query.CE = vm.query.CE.val;

				// using AFF: primary / secondary multi
				q = loadTabInfo(newTab, q);
				applyPrimarySecondaryMulti(q.SearchType, q.primeProp, q.Primary.val, q.Secondary.val);
				break;

			case 'EVAL':
			case 'REMATCH':
				// list tabs using CE only, no RX or dates
				q = loadTabInfo(newTab, q);
				vm.flt = vm.resetFilters(_tabInfo[newTab].flt);

				queryChangeCE();
				break;

			case 'MATCH':
			case 'SUSPECT':
			case 'STATS':
				if(newTab != 'STATS') {
					vm.flt = vm.resetFilters(_tabInfo[newTab].flt, true); // remember paging from tab info
				}
				q = loadTabInfo(newTab, q);
				applyPrimarySecondaryMulti(q.SearchType, q.primeProp, q.Primary.val, q.Secondary.val); // this loads either AFF or TPA

				// initialize date range widget
				$timeout(function() {
					$scope.$broadcast('widget.input.date.range.mode', {
						uniqueId: newTab == 'STATS' ? 'STATS' : 'MATCH-SUSPECT',
						mode: q.DateRangeMode,
						keepDates: true});
				},300);
				break;
	
			default:
				msgSvc.ok('matchListCtl.tabChange', 'unknown tab name: ' + newTab);

		}

	}


	/**
	 *    QUERY CHANGE EVENTS
	 */

	function queryChange(refresh) {

		if(!vm.init) {

			vm.action = '';
			vm.popup = {};
			vm.matchConfig = {};
			vm.stats = {};
			vm.compare = {Data:{}};

			vm.tbl = {};
			vm.flt = vm.resetFilters(vm.flt);
			if (!!!refresh) {
				vm.flex = vm.flexInit();
			}
			$scope.$broadcast('widget.paging');

			vm.dtPickShow = {
				pending: '',
				EndDate: false,
				StartDate: false
			};

		}
	}

	function queryChangeSearchType() {
		if(vm.isWaiting || vm.context.isCe) { // ignore CE user clicks (they always use AFF)
			return;
		}
		queryChange();

		// verify UI has correct state
		var st = vm.query.SearchType;
		if(st != 'AFF' && st != 'TPA' && st != 'RXROLLUP') {
			throw new Error('matchListCtl.queryChangeSearchType, unknonw search type ' + st);
		}

		// changing the search type causes primary/secondary reset
		applyPrimarySecondaryMulti(vm.query.SearchType, vm.query.primeProp, 'NONE', 'NONE');
		
		// remember user choice BEFORE search button is clicked
		saveViewState(vm.activeTab, vm.query);
	}

	function queryChangeTpaSearchType() {
		// only used for SENTMATCH when ExternalType is TPA
		if(vm.isWaiting || vm.activeTab != 'SENTMATCH' || vm.query.ExternalType != 'TPA') {
			return;
		}
		queryChange();

		var q = vm.query;
		var st = q.SearchType;
		if(st != 'AFF' && st != 'ROLLUP') {
			throw new Error('matchListCtl.queryChangeTpaSearchType, unknonw search type ' + st);
		}

		// AFF or ROLLUP has different CE/RX options
		var affs = st == 'AFF' ? getAffs() : vm.sentMatchRollupAffs;

		// verify CE exists in new list
		var ceExists = utilSvc.aff.findCe(affs, q.CE.val).length > 0;
		var ceid = ceExists ? q.CE.val : '';

		vm.CeMulti = ceMultiBuildForSentMatch(vm.CeMulti, affs, q.ExternalType, ceid);
		q.CE = sentMatchMultiToCeProp(vm.CeMulti, q);

		queryChangeCE();
	}

	function queryChangePrimary() {

		// used by MATCH and SUSPECT tabs
		// note: queryChangeSecondary is handled as MultiClick in helpers

		queryChange();

		var q = vm.query;
		q.Primary.fail = validSvc.isEntity(vm.query.Primary.val) ? 'no' : 'yes';
		q.Primary.title = q.Primary.fail == 'no' ? utilSvc.ng.droplistLabel(vm.PrimaryDroplist, q.Primary.val) : '';

		// default secondary to ALL
		vm.SecondaryMulti.vals = ['ALL'];
		vm.SecondaryMulti = multiselectRebuildSecondary(q.SearchType, q.Primary.val, vm.SecondaryMulti, getAffs(vm.showInactiveAffs == 'yes'), true);
		q.Secondary.fail = vm.SecondaryMulti.vals.length < 1 ? 'yes' : 'no';

		// CE Secondary - 3 Column View
		if(q.SearchType == 'AFF' && vm.SecondaryMulti.type == 'CE') {
			vm.CeMulti = ceMultiRebuildFromSecondary(vm.CeMulti, vm.SecondaryMulti);
		}
	}

	function buildNewEvalAffs(evalTarget) {
		// setup OWNUSE and GPO options
		// return affil options specfic to the eval target
		vm.evalHasOWNUSE = false;
		vm.evalHasGPO = false;

		var ceid = vm.query.CE.val;
		var result = [],
			addAff = false;

		// use aff lookup for this CE
		_affLookup.forEach(function(aff) {
            // specifically state ACTIVE, the aff lookup will include INACTIVE for another Match search feature
			if(aff.ObjectState == 'ACTIVE' && aff.CEID == ceid) {
				addAff = false;
				if (aff.EnableMatchByFile && aff.IncludeDispenseBasedEligibility) {
					_affsAllowFacilitySentMatches.push(aff.RXID);
				}

				if(evalTarget == '340B') {
					// all affils for 340B
					addAff = true;
				}
				if (!!aff.CeOwnUseProgram && !!aff.AffilOwnUseMatching) {
					vm.evalHasOWNUSE = true;
					if(!addAff) {
						addAff = evalTarget == 'OWNUSE';
					}
				}
				if (!!aff.EnableGPOMatching) {
					vm.evalHasGPO = true;
					if(!addAff) {
						addAff = evalTarget == 'GPO';
					}
				}

				if(addAff) {
					result.push(aff);
				}
			}
		});

		return result;
	}

    function showMatchEligUpload() {
        return vm.activeTab == 'MATCH' &&
            vm.query.canEdit &&
            vm.query.SearchType == 'AFF' &&
            vm.query.primeProp == 'CE' &&
            vm.query.Primary.fail != 'yes';
    }

    function showMatchPrequalUpload() {
        if(!vm.query.userCanBulkMatch) {
            return false;
        }
        if(!showMatchEligUpload()) {
            return false;
        }

        // find CE affs which have EnableMatchByFile
        var ceid = vm.query.Primary.val,
            showInactive = vm.showInactiveAffs == 'yes',
            aff = {};
        for(var i = 0; i < _affLookup.length; i++) {
            aff = _affLookup[i];
            if(aff.CEID != ceid) {
                continue;
            }
            if(!showInactive && aff.ObjectState == 'INACTIVE') {
                continue;
            }
            if(aff.EnableMatchByFile) {
                return true;
            }
        }
        return false;
    }

	function buildEvalNewRxMulti(evalTarget) {
		// init Eval RX multi
		vm.EvalRxMulti.list = [];
		vm.EvalRxMulti.vals = [];
		vm.multiselectTitle(vm.EvalRxMulti);

		vm.query.ExcludeAllocatedMatches = evalTarget == '340B';

		// eval CE -> RX
		if(vm.query.CE.fail == 'yes') {
			return;
		}

		var affs = buildNewEvalAffs(evalTarget);

		// RX options, convert ngdroplist into a multi
		var rxDroplist = utilSvc.aff.rxDroplist(affs, vm.query.CE.val, false, true);
		vm.EvalRxMulti.list = ngDroplistToMultiChecklist(rxDroplist);

		return vm.EvalRxMulti;
	}

	function queryChangeCE() {

		queryChange();

		// valid CE
		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';

		if(vm.activeTab == 'EVAL' && vm.query.CE.fail == 'no') {
			// save last known good EVAL CE
			_tabInfo['EVAL'].query.CE = vm.query.CE.val;
		}
		else if(vm.activeTab == 'SENTMATCH') {
			
			// ExternalType TPA has RX options
			// sent match CE -> RX or ROLLUP
			if(vm.query.ExternalType == 'TPA') {
				if(vm.query.CE.fail == 'yes') {
					vm.RxDroplist = utilSvc.ng.droplistNONE();
					vm.query.RX = validSvc.newProp('NONE');
					return;
				}
				switch(vm.query.SearchType) {
					case 'AFF':
						vm.RxDroplist = utilSvc.aff.rxDroplist(getAffs(), vm.query.CE.val);
						break;
					case 'ROLLUP':
						vm.RxDroplist = utilSvc.aff.rxDroplist(vm.sentMatchRollupAffs, vm.query.CE.val);
						break;
					default:
						throw new Error('matchList.queryChangeCE, unknown SENTMATCH SearchType: ' + vm.query.SearchType);
				}
				vm.query.RX = utilSvc.ng.droplistAutoselect(vm.RxDroplist, vm.query.RX.val);

				queryChangeRX();
			}
		}
	}

	function queryChangeRX() {
		queryChange();
		vm.query.RX.fail = validSvc.isRX(vm.query.RX.val, false, true) ? 'no' : 'yes';

		// change NONE to ALL as default
		if(vm.activeTab == 'EVALNEW' && vm.query.RX.fail == 'yes' && vm.query.RX.val == 'NONE') {
			vm.query.RX = validSvc.newProp('ALL');
		}
	}

	function queryChangeAffs() {
		if(vm.isWaiting) {
			return;
		}

		// toggle 
		vm.showInactiveAffs = vm.showInactiveAffs == 'yes' ? 'no' : 'yes';

		applyPrimarySecondaryMulti(vm.query.SearchType, vm.query.primeProp, vm.query.Primary.val, vm.query.Secondary.val);
		queryChangeCE();
		queryChangeRX();

	}
	
	function queryChangeRestrictedManufacturer(val) {
		queryChange();
		vm.multiselectClick(vm.ManufacturerMulti, val);
		vm.multiselectTitle(vm.ManufacturerMulti, true);
		vm.query.RestrictedManufacturer.val = multiselectQueryVals(vm.ManufacturerMulti);
		vm.query.RestrictedManufacturer.msg = "";
		vm.query.RestrictedManufacturer.fail = "no";
	}

	function queryChangeExternalType() {
		if(vm.isWaiting) {
			return;
		}
		queryChange();
		
		// TPA has RX options, send to SentMatch event
		var q = vm.query;
		if(q.ExternalType == 'TPA') {
			q.SearchType = 'AFF';
			queryChangeTpaSearchType();
		}
		else {
			vm.CeMulti = ceMultiBuildForSentMatch(vm.CeMulti, getAffs(), q.ExternalType, q.CE.val);
			q.CE = sentMatchMultiToCeProp(vm.CeMulti, q);
			q.RX = validSvc.newProp('NONE');
			q.RX.fail = 'no';
		}
	}

	function dateRangeChange(uniqueId, dtMode, isValid) {
		// EVAL and REMATCH ignore this event
		if(vm.activeTab == 'EVAL' || vm.activeTab == 'EVALNEW' || vm.activeTab == 'REMATCH' || vm.activeTab == 'REMATCHNEW') {
			return;
		}

		// match stats comparison event
		if(uniqueId == 'compareDates') {
			vm.compare.DateRangeMode = dtMode;
			vm.compare.DateRangeValid = isValid;

			// user must choose before query
			if(dtMode == 'QTR' || dtMode == 'YEARLY') {
				vm.action = 'COMPAREQUERY';
			}

			// when summary compare loads it fires this mode change, do query on this event
			if(vm.action != 'COMPAREQUERY') {
				compareLoadData();
			}			
		}
		else {
			queryChange();

			vm.query.DateRangeMode = dtMode;
			vm.query.DateRangeValid = isValid;
		
			if(_autoSubmit) {
				querySubmit();
			}
	
			vm.init = false;	
		}
	}

	function queryChangeDateType() {
		queryChange();
		vm.query.DateTypeTxt = dateTypeDisplayTxt(vm.query.DateType);
	}

	function buildEligibleTitle(tabName, eligChk, eligObj) {

		if(!!!eligChk || !!!eligObj || !validSvc.isText(eligObj.val)) {
			return '';
		}

		var title = eligObj.val == 'yes' ? 'YES' : 'NO';
		if(title == 'NO' && tabName == 'MATCH') {
			title = utilSvc.ng.droplistLabel(vm.EligibleDroplist, eligObj.reason);
		}

		if(eligObj.overrideHist) {
			title += ', Override History';
			if(validSvc.isText(eligObj.overrideReason)) {
				title += ' for: ' + utilSvc.ng.droplistLabel(vm.EligOverrideReasonDroplist, eligObj.overrideReason);
			}
		}

		if(eligObj.overrideOK) {
			title += ', Can Override';
		}

		if(eligObj.blockhistory) {
			title += ', Block History';
		}

		return title;

	}

	function queryChangeEligible(chgType) {
		queryChange();

		var elig = vm.query.Eligible;
		elig.fail = '';

		switch(chgType) {
			case 'yes':
				elig.val = 'yes';
				elig.reason = '';
				elig.overrideOK = false;
				elig.overrideHist = false;
				elig.overrideReason = 'ALL';  // reset back to ALL
				break;
			case 'no':
				elig.val = 'no';
				elig.reason = 'INELIGIBLE';
				elig.overrideOK = false;
				elig.overrideHist = false;
				elig.overrideReason = 'ALL';  // reset back to ALL
				break;
			case 'reason':
				break;
			case 'overrideOK':
				elig.overrideOK = !elig.overrideOK;
				elig.overrideReason = 'ALL';  // reset back to ALL
				break;
			case 'overrideHist':
				elig.overrideHist = !elig.overrideHist;
				break;
			case 'ovrerride-reason':
				break;
			case 'blockhistory':
				elig.blockhistory = !elig.blockhistory;
				break;
			default:
				alert('queryChangeEligible, unknown change type: ' + chgType);
		}

		elig.title = buildEligibleTitle(vm.activeTab, elig.chk, elig);

	}

	function queryChangeAllocation(val) {
		queryChange();
		vm.multiselectClick(vm.AllocationMulti, val);
		vm.multiselectTitle(vm.AllocationMulti, true);
		vm.query.Allocation.val = multiselectQueryVals(vm.AllocationMulti);
		vm.query.Allocation.msg = "";
		vm.query.Allocation.fail = "no";
	}

	function queryChangeMatchType() {
		queryChange();
	}

	function queryChangeCashCard() {
		vm.query.CashCard.chk = !vm.query.CashCard.chk;
		vm.query.CashCard.val = 'yes';
	}

	function queryChangeReferral() {
		vm.query.Referral.chk = !vm.query.Referral.chk;
		vm.query.Referral.val = 'yes';
	}

	function queryChangeOrderable() {
		vm.query.Orderable.chk = !vm.query.Orderable.chk;
		vm.query.Orderable.val = 'yes';
	}

	function queryChangeEstimatePricing() {
		vm.query.EstimatePricing.chk = !vm.query.EstimatePricing.chk;
		vm.query.EstimatePricing.val = 'yes';
	}

	function queryChangeIRA() {
		vm.query.IRA.chk = !vm.query.IRA.chk;
		vm.query.IRA.val = 'yes';
	}

	function queryChangeRebate() {
		vm.query.Rebate.chk = !vm.query.Rebate.chk;
		vm.query.Rebate.val = 'yes';
	}

	function queryValidEvalDates(q) {

		// EVALNEW date range is 365 days
		// validate date controls directly, doesn't use the date range events

		// start date, required, 365 days from today
		var startDT = validSvc.propDateValid(q.StartDate);
		q.StartDate.fail = !!startDT.fail ? 'yes' : '';
		q.StartDate.msg = !!startDT.fail ? startDT.msg : '';
		if(startDT.fail == 'yes') {
			return false;
		}

		// start date must be <= end date
		if(utilSvc.dt.diffMilli(q.EndDate.val, q.StartDate.val) > 0) {
			q.StartDate.fail = 'yes';
			q.StartDate.msg = 'must be on or before End Date';
			return false;
		}

		return true;

	}

	function flexTopExpand() {

		// user opened search query, reset list display, show search expanded

		if(vm.flt.Busy) {
			msgSvc.ok('Busy', 'List is still filtering, please wait.');
			return;
		}

		if(validSvc.isEntity(vm.query.Primary.val)) {
			vm.query.Primary.title = utilSvc.ng.droplistLabel(vm.PrimaryDroplist, vm.query.Primary.val);
		}
		queryChange();

	}


	/**
	 *    QUERY SUBMIT
	 */

	function dynaQueryValidate(q) {

		q.EncounterNumber.fail = '';
		if(q.EncounterNumber.chk) {
			var enumb = q.EncounterNumber.val;
			if(!validSvc.isText(enumb) || enumb.length < 1) {
				q.EncounterNumber.fail = 'yes';
				q.EncounterNumber.msg = 'must be at least 1 character';
			}
		}

		q.RxNumber.fail = '';
		if(q.RxNumber.chk) {
			var rxnumb = q.RxNumber.val;
			if(!validSvc.isText(rxnumb) || rxnumb.length < 1) {
				q.RxNumber.fail = 'yes';
				q.RxNumber.msg = 'must be at least 1 character';
			}
		}

		q.ItemCode.fail = '';
		if(q.ItemCode.chk) {
			// ndc format check
			var ndcTest = ndcCleanUp(q.ItemCode.val, false);
			if(ndcTest.fail) {
				q.ItemCode.fail = 'yes';
				q.ItemCode.msg = ndcTest.msg;
			}
			else {
				q.ItemCode.val = ndcTest.val;
			}
		}

		q.PrescriberIdent.fail = '';
		if(q.PrescriberIdent.chk) {
			var npi = q.PrescriberIdent.val;
			if(!validSvc.isInteger(npi) || npi.toString().length != 10) {
				q.PrescriberIdent.fail = 'yes';
				q.PrescriberIdent.msg = 'must be a non-decimal number 10 digits';
			}
		}

		q.SuspectType.fail = '';
		if(q.SuspectType.chk) {
			if(!validSvc.isText(q.SuspectType.val)) {
				q.SuspectType.fail = 'yes';
				q.SuspectType.msg = 'required, choose NPI or PATIENT';
			}
		}
		q.DrugType.fail = '';
		if(q.DrugType.chk) {
			if(!validSvc.isText(q.DrugType.val)) {
				q.DrugType.fail = 'yes';
				q.DrugType.msg = 'required, choose BRAND or GENERIC';
			}
		}
		q.TotalAmountPaid.fail = '';
		if(q.TotalAmountPaid.chk) {
			var tp = parseFloat(q.TotalAmountPaid.val);
			if(!validSvc.isNumber(tp) || tp <= 0 || tp > 1000000) {
				q.TotalAmountPaid.fail = 'yes';
				q.TotalAmountPaid.msg = 'must be a number greater than zero, less than 1 million';
			}
		}

		q.PatientLN.fail = '';
		if(q.PatientLN.chk) {
			var lname = q.PatientLN.val;
			if(!validSvc.isText(lname) || lname.length < 1) {
				q.PatientLN.fail = 'yes';
				q.PatientLN.msg = 'must be at least 1 character';
			}
		}
		q.Location.fail = '';
		if(q.Location.chk) {
			var loc = q.Location.val;
			if(!validSvc.isText(loc) || loc.length < 1) {
				q.Location.fail = 'yes';
				q.Location.msg = 'must be at least 1 character';
			}
			else {
				q.Location.val = q.Location.val.toUpperCase();
			}
		}

		q.Eligible.fail = '';
		if(q.Eligible.chk) {
			if(!validSvc.isText(q.Eligible.val)) {
				q.Eligible.fail = 'yes';
				q.Eligible.msg = 'required, choose Yes or No';
			}
			else if(q.Eligible.val == 'yes') {
				q.Eligible.reason = '';
			}
			else if(q.Eligible.val == 'no' && q.Eligible.reason === '') {
				q.Eligible.reason = 'INELIGIBLE';
			}
			if(vm.activeTab == 'MATCH' && q.Allocation.chk) {
				if(!Array.isArray(q.Allocation.val) || q.Allocation.val.length < 1) {
					q.Allocation.fail = 'yes';
					q.Allocation.msg = 'required, select an allocation option';
				}
			}
		}

		// q.MatchType.fail = '';
		// if(q.MatchType.chk) {
		// 	if(!validSvc.isText(q.MatchType.val)) {
		// 		q.MatchType.fail = 'yes';
		// 		q.MatchType.msg = 'required, select a match type';
		// 	}
		// }

		if(q.RestrictedManufacturer.chk) {
			if(!Array.isArray(q.RestrictedManufacturer.val) || q.RestrictedManufacturer.val.length < 1) {
				q.RestrictedManufacturer.fail = 'yes';
				q.RestrictedManufacturer.msg = 'required, select a manufacturer';
			}
		}
		// at least one option must be selected
		q.SearchOptionsRequired = validSvc.newProp();
		if(!q.DateRangeChk && !q.EncounterNumber.chk && !q.RxNumber.chk && !q.ItemCode.chk && !q.PrescriberIdent.chk &&
			!q.SuspectType.chk && !q.DrugType.chk && !q.TotalAmountPaid.chk &&
			!q.PatientLN.chk && !q.Location.chk && !q.Eligible.chk && !q.MatchType.chk && !q.RestrictedManufacturer.chk) {
			q.SearchOptionsRequired.fail = 'yes';
			q.SearchOptionsRequired.msg = 'Choose at least one search option';
		}

		return q;

	}

	function queryValid(tabName, q) {
		var maxDayRange;

		// validate query data before calling api

		switch(tabName) {
			case 'EVAL':
			case 'REMATCH':
				q.CE.fail = validSvc.isCE(q.CE.val) ? 'no' : 'yes';
				return q.CE.fail == 'no';

			case 'REMATCHNEW':
				q.Primary.fail = validSvc.isCE(q.Primary.val) ? 'no' : 'yes';
				q.Secondary.val = multiselectQueryVals(vm.SecondaryMulti);
				q.Secondary.fail = q.Secondary.val.length < 1 ? 'yes' : 'no';
				var startDT = validSvc.propDateValid(q.StartDate);
				q.StartDate.fail = startDT.fail;
				q.StartDate.msg = !!startDT.fail ? startDT.msg : '';

				return q.Primary.fail != 'yes' &&
					q.Secondary.fail != 'yes' &&
					!q.StartDate.fail;

			case 'EVALNEW':
				q.CE.fail = validSvc.isCE(q.CE.val) ? 'no' : 'yes';
				q.RX.vals = multiselectQueryVals(vm.EvalRxMulti);
				q.RX.fail = q.RX.vals.length > 0 ? 'no' : 'yes';
				q.DateRangeValid = queryValidEvalDates(q);
				var dayRange = utilSvc.dt.diffDays(q.StartDate.val, q.EndDate.val);
				maxDayRange = 1460;
				if(dayRange > maxDayRange) {
					q.StartDate.fail = 'yes';
					q.StartDate.msg = 'date range must be less than ' + maxDayRange.toString() + ' days';
					q.DateRangeValid = false;
				} else {
					q.StartDate.fail = false;
					q.StartDate.msg = '';
				}
				return q.CE.fail == 'no' && q.RX.fail == 'no' && !!q.DateRangeValid;

			case 'SENTMATCH':
				// rx number used for both TPA and STATEFFS
				var rxNum = vm.query.RxNumber.val;
				vm.query.RxNumber.fail = validSvc.isText(rxNum) && rxNum.length > 50 ? 'yes' : 'no';

				var extType = vm.query.ExternalType;
				if(extType == 'TPA') {
					q.CE.fail = validSvc.isCE(q.CE.val) ? 'no' : 'yes';
					q.RX.fail = validSvc.isRX(q.RX.val) ? 'no' : 'yes';
				}
				else if(extType == 'STATEFFS') {
					q.CE.vals = multiselectQueryVals(vm.CeMulti);
					q.CE.fail = q.CE.vals.length < 1 ? 'yes' : 'no';
					q.RX.fail = 'no';
				}
				else {
					throw new Error('matchListCtl.queryValid, unknown SENTMATCH ExternalType: ' + extType);
				}
				return q.CE.fail == 'no' && q.RX.fail == 'no' && q.RxNumber.fail == 'no' && !!q.DateRangeValid;
			case 'MATCH':
			case 'SUSPECT':
				q.Primary.fail = validSvc.isEntity(q.Primary.val) ? 'no' : 'yes';
				q.Secondary.fail = q.Secondary.val.length < 1 ? 'yes' : 'no';
				
				var dateOk = !!q.DateRangeValid;
				if(!q.DateRangeChk) {
					dateOk = true;  // force to true if not being used for query
				}

				q = dynaQueryValidate(q);

				return q.Primary.fail != 'yes' &&
					q.Secondary.fail != 'yes' &&
					q.EncounterNumber.fail != 'yes' &&
					q.RxNumber.fail != 'yes' &&
					q.ItemCode.fail != 'yes' &&
					q.PrescriberIdent.fail != 'yes' &&
					q.SuspectType.fail != 'yes' &&
					q.DrugType.fail != 'yes' &&
					q.TotalAmountPaid.fail != 'yes' &&
					q.PatientLN.fail != 'yes' &&
					q.Location.fail != 'yes' &&
					q.Eligible.fail != 'yes' &&
					q.Allocation.fail != 'yes' &&
					q.MatchType.fail != 'yes' &&
					q.RestrictedManufacturer.fail != 'yes' &&
					q.SearchOptionsRequired.fail != 'yes' &&
					dateOk;

			case 'STATS':
				q.Primary.fail = validSvc.isEntity(q.Primary.val) ? 'no' : 'yes';
				q.Secondary.fail = q.Secondary.val.length < 1 ? 'yes' : 'no';

				return q.Primary.fail != 'yes' &&
					q.Secondary.fail != 'yes' &&
					!!q.DateRangeValid;

			default:
				alert('matchListCtl.queryValid, unknown tab name: ' + tabName);
				return false;
		}

	}

	function querySubmit(refresh) {

		if(vm.isWaiting) {
			return;
		}
		queryChange(refresh);

		// stop query blink for SUSPECT tab return visit
		if(_autoSubmit && vm.activeTab == 'SUSPECT') {
			vm.flex = vm.flexCollapse(vm.flex, true);
		}
		_autoSubmit = false;

		// pack up secondary multiselect props
		if(vm.activeTab == 'MATCH' || vm.activeTab == 'SUSPECT' || vm.activeTab == 'STATS') {
			vm.query.Secondary.val = multiselectQueryVals(vm.SecondaryMulti);
		}

		// request query valid
		if(!queryValid(vm.activeTab, vm.query)) {
			queryChange();
			if(!vm.init) {
				msgSvc.ok('Search', 'Check filter properties');
			}
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true, true);

		switch(vm.activeTab) {
			case 'STATS':
				matchRepo.getStatsSummary(vm.query).then(okMatchStats, errMatchStats);
				break;
			case 'SENTMATCH':
				matchRepo.getSentMatch(vm.query).then(okGetList, errGetList);
				break;
			default:
				matchRepo.getList(vm.activeTab, vm.query).then(okGetList, errGetList);
		}

		function okGetList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			var hasTableId = '',
				useViewState = false;

			switch(vm.activeTab) {

				case 'EVAL':
					useViewState = true;
					hasTableId = vm.activeTab;
					// Add additional conversion for eval to take the UTC server date back to browser date
					for(var i = 0; i < r.Items.length; i++) {
						r.Items[i].StartFrom = new Date(utilSvc.dt.fromServerDateExactUTC(r.Items[i].StartFrom));
					}
					vm.tbl = evalRematchVM(vm.activeTab == 'EVAL', r.Items, r.TooMany);
					break;
				case 'SENTMATCH':
					hasTableId = vm.activeTab;
					vm.tbl = sentMatchVM(r.Items);
					break;
				case 'REMATCH':
					useViewState = true;
					hasTableId = vm.activeTab;
					vm.tbl = evalRematchVM(vm.activeTab == 'EVAL', r.Items, r.TooMany);
					break;

				case 'MATCH':
				case 'SUSPECT':
					useViewState = true;
					hasTableId = 'MATCH_SUSPECT';
					vm.tbl = displayVM(r.Items, r.TooMany);

					// force top collapse after good query
					vm.flex = vm.flexCollapse(vm.flex, true);

					// MATCH search returns aff config
					if(vm.activeTab == 'MATCH') {
						vm.matchConfig = matchConfigVM(r.Config);
					}

					tblViewReload(vm.activeTab, vm.query, false, true); // keep paging if possible
					break;
			}

			if(useViewState) {
				saveViewState(vm.activeTab, vm.query);
			}

			if(validSvc.isText(hasTableId)) {
				vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
				$scope.$broadcast('widget.paging', {
					uniqueId: hasTableId,
					Size: vm.flt.PageSize,
					Page: vm.flt.Page,
					Total: vm.flt.PageTotal,
					RowCount: vm.flt.Count,
					ItemCount: vm.tbl.Items.length,
					DataCount: vm.tbl.DataItems.length
				});
			}

			vm.flt.Ready = true;
			vm.action = 'LIST';

		}

		function errGetList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.error('Unknown get response', 'matchListCtl.errGetList', r.status, utilSvc.http.safeResponse(r));
			}
		}

		function okMatchStats(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.stats = matchStatsVM(r);
			vm.action = 'LIST';

			saveViewState(vm.activeTab, vm.query);

			// show comparison prompt?
			vm.compare.prompt = false;
			switch(vm.query.DateRangeMode) {
				case 'MONTHLY':
					vm.compare.prompt = true;
					vm.compare.title = 'Compare With Previous Month';
					break;
				case 'MTD':
					vm.compare.prompt = true;
					vm.compare.title = 'Compare With Previous Month To Date';
					break;
				case 'QTD':
					vm.compare.prompt = true;
					vm.compare.title = 'Compare With Previous Quarter To Date';
					break;
				case 'QTDLAST':
				case 'QTR':
					vm.compare.prompt = true;
					vm.compare.title = 'Compare With Another Quarter';
					break;
				case 'YTD':
					vm.compare.prompt = true;
					vm.compare.title = 'Compare With Previous Year To Date';
					break;
				case 'LTM':
					vm.compare.prompt = true;
					vm.compare.title = 'Compare With Previous Last 12 Months';
					break;
				case 'YEARLY':
					vm.compare.prompt = true;
					vm.compare.title = 'Compare With Another Year';
					break;
			}
		}

		function errMatchStats(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.error('Unknown api response', 'matchListCtl.errMatchStats', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    ROW CLICK
	 *    main list click handler
	 */

	function rowClick(evt, item) {

		switch(vm.activeTab) {
			case 'SUSPECT':
				getSuspect(item);
				break;
			case 'MATCH':
				// do nothing, only Eligible column is clickable
				break;
			default:
				throw new Error('matchListCtl.rowClick, action unknown: ' + vm.activeTab);
		}

	}


	/**
	 *    POPUP
	 */

	function parseBlockHistory(items) {
		items = Array.isArray(items) ? items : [];
		
		var result = [],
			histItem = [],
			editTxt = '';

		// reverse array order to descending (last change shown first)
		for(var i = items.length - 1; i >= 0; i--) {
			histItem = items[i];

			// build edit txt
			editTxt = '';
			switch(histItem.Type) {
				case 'ALL':
					editTxt = 'Reject Script';
					break;
				case 'FILLNUM':
					editTxt = 'Block Script at Fill #' + histItem.FillNumber;
					break;
				case 'SINGLE':
					editTxt = 'Reject Fill - Single Fill Only';
					break;
				default:
					editTxt = 'UNKNOWN';
					alert('matchListCtl.popup, undo history type unknown: ' + histItem.Type);
					break;
			}

			if(!!!histItem.Blocked) {
				editTxt = 'Undone: ' + editTxt;
			}

			result.push({
				ModDate: histItem.ModDate,
				EditTxt: editTxt,
				User: histItem.User,
				Notes: histItem.Note,
				FillNumber: histItem.FillNumber,
				canUndo: i == 0, // undo latest item only
				type: histItem.Type
			});
		}
		return result;
	}

	function openPopup(evt, item, popupType) {

		// shared handler to open both Match Reject and Eligibility Override popups

		if(vm.isWaiting) {
			return;
		}

		var popWidth = '80%';

		var popupContentId = (vm.activeTab == 'MATCH' || vm.activeTab == 'SUSPECT') ? 'matchListPopupContent' : 'matchEvalPopupContent';

		switch(popupType) {
			
			case 'REJECT':
				vm.popup = {
					type: 'REJECT',
					title: 'Match Reject',
					ready: false,
					Id: item.Id,
					FillNumber: item.FillNumber,
					Pharmacy: item.Pharmacy,
					DispensingPh: item.DispensingPh,
					RxNumber: item.RxNumber,
					MatchedDate: item.MatchedDate,
					RxWrittenDate: item.RxWrittenDate
				};
				break;
		
			case 'LOG':
				vm.popup = {
					type: 'LOG',
					title: 'Log for Match Rx# ' + item.RxNumber + ' Fill ' + item.FillNumber,
					ready: false,
					Id: item.Id,
					FillNumber: item.FillNumber,
					ChangeLog: item.ChangeLog
				};
				break;

			case 'UNMATCH':
				vm.popup = {
					type: 'UNMATCH',
					title: 'Unmatch Claim Rx# ' + item.RxNumber + ' All Fills',
					ready: false,
					Id: item.Id,
					FillNumber: item.FillNumber,
					Pharmacy: item.Pharmacy,
					DispensingPh: item.DispensingPh,
					RxNumber: item.RxNumber,
					MatchedDate: item.MatchedDate,
					RxWrittenDate: item.RxWrittenDate,
					CanAffManualMatch: item.CanAffManualMatch,
					Allocated: item.AllocQuantity > 0 || item.State == 'RECONCILED' || item.State == 'ALLOCATED',
				};
				break;

			case 'OVERRIDE':
				vm.popup = {
					type: 'OVERRIDE',
					title: 'Eligibility Override',
					ready: false,
					Id: item.Id,
					ItemCode: item.ItemCode,
					FillNumber: item.FillNumber,
					Pharmacy: item.Pharmacy,
					DispensingPh: item.DispensingPh,
					RxNumber: item.RxNumber,
					MatchedDate: item.MatchedDate,
					RxWrittenDate: item.RxWrittenDate,
					StateReasons: item.StateReasons.join(',')
				};
				break;

			case 'UNDO':
				vm.popup = {
					type: 'UNDO',
					title: 'Undo Blocked Script',
					ready: false,
					Id: item.Id,
					FillNumber: item.FillNumber,
					Pharmacy: item.Pharmacy,
					DispensingPh: item.DispensingPh,
					RxNumber: item.RxNumber,
					MatchedDate: item.MatchedDate,
					RxWrittenDate: item.RxWrittenDate,
					UndoHistory: parseBlockHistory(item.BlockHistory)
				};
				break;

			case 'DETAIL':
				vm.popup = {
					type: 'DETAIL',
					title: vm.activeTab == 'MATCH' ? 'Matched' : 'Suspect' + ' Dispense Details',
					ready: false,
					Id: item.Id,
					FillNumber: item.FillNumber,
					Pharmacy: item.Pharmacy,
					DispensingPh: item.DispensingPh,
					RxNumber: item.RxNumber,
					MatchedDate: item.MatchedDate,
					RxWrittenDate: item.RxWrittenDate,
					UndoHistory: parseBlockHistory(item.BlockHistory),
					StateReasons: item.StateReasons,
					Overrides: item.Overrides,
					UnmatchedBy: item.UnmatchedBy,
					UnmatchedDate: item.UnmatchedDate,
					State: item.State,
				};
				break;

			case 'MATCHCONFIG':
				// note: most of popup content is on vm.matchConfig
				popWidth = '40%';
				vm.popup = {
					type: 'MATCHCONFIG',
					title: 'Eligibility and Ordering Rules',
					ready: false
				};
				break;

			case 'EVAL':
				if(item.State != 'DONE' && item.State != 'ERROR' && item.State != "PAUSED") {
					msgSvc.ok('Processing', 'Summary data will be available once Status is DONE or ERROR.');
					return;
				}
				vm.popup = {
					Id: item.Id,
					type: 'EVAL',
					title: vm.query.CE.val,
					ready: false,
					Affils: item.Affils,
					AffilsTxt: item.AffilsTxt,
					ExcludeAllocatedMatches: item.ExcludeAllocatedMatches,
					IncludeFacilitySentMatches: item.IncludeFacilitySentMatches,
					PausedAtDate: item.PausedAtDate,
					EvaluateOwnUseOnly: item.EvaluateOwnUseOnly,
					DateType: item.DateType,
					StartFrom: item.StartFrom,
					CreateDate: item.CreateDate,
					Notes: item.Notes,
					CreatedBy: item.CreatedBy,
					TotalProcessed: item.TotalProcessed,
					ProcessingTime: item.ProcessingTime,
					ResultsNewEligible: item.ResultsNewEligible,
					ResultsNewIneligible: item.ResultsNewIneligible,
					ResultsNumBackingReversed: item.ResultsNumBackingReversed,
					ResultsNewMatches: item.ResultsNewMatches,
					ResultsErrorCount: item.ResultsErrorCount,
					DryRun: item.DryRun
				};
				break;

			case 'REMATCH':
				if(item.State != 'DONE' && item.State != 'ERROR') {
					msgSvc.ok('Processing', 'Summary data will be available once Status is DONE or ERROR.');
					return;
				}
				vm.popup = {
					type: 'REMATCH',
					title: vm.query.CE.val,
					ready: false,
					AffilsTxt: item.AffilsTxt,
					DateType: item.DateType,
					CreateDate: item.CreateDate,
					Notes: item.Notes,
					CreatedBy: item.CreatedBy,
					TotalProcessed: item.TotalProcessed,
					ProcessingTime: item.ProcessingTime,
					ResultsNewEligible: item.ResultsNewEligible,
					ResultsNewIneligible: item.ResultsNewIneligible,
					ResultsNewMatches: item.ResultsNewMatches,
					ResultsErrorCount: item.ResultsErrorCount
				};
				break;

			case 'BULK':
                // VERITY only

                // at least 1 record should be in table
                if(vm.tbl.DataItems.length < 1) {
                    msgSvc.ok('No Records', 'No records to process.');
                    return;
                }

                vm.popup = {
                    type: 'BULK',
                    title: 'Eligibility Bulk Processing',
                    action: 'prompt',
                    DateRangeChk: !!vm.query.DateRangeChk,
                    EncounterNumberChk: !!vm.query.EncounterNumber.chk,
                    ItemCodeChk: !!vm.query.ItemCode.chk,
                    PrescriberIdentChk: !!vm.query.PrescriberIdent.chk,
                    PatientLNChk: !!vm.query.PatientLN.chk,
                    LocationChk: !!vm.query.Location.chk,
                    EligibleChk: !!vm.query.Eligible.chk,
                    MatchTypeChk: !!vm.query.MatchType.chk,
                    ready: false
                };
                break;

			case 'BULKFILE_ELIGIBILITY':
            case 'BULKFILE_PREQUALIFIED':
                vm.importErrors = [];
                vm.importSelectedFiles = [];

                // search type AFF and CE first only supported
                if(vm.query.SearchType != 'AFF' || vm.query.primeProp != 'CE') {
                    msgSvc.ok('Cannot Upload', 'Select an affiliation Facility First, filter swap not allowed');
                    return;
                }

                // must have valid CE (this is from the Multi)
                var ceVals = multiselectQueryVals(vm.CeMulti);
                if(vm.query.Primary.fail == 'yes' || ceVals.length < 1) {
                    msgSvc.ok('Cannot Upload', 'Select a Facility before uploading.');
                    return;
                }

                // check for File API and FormData upload browser support
                if(!validSvc.uploadSupported()) {
                    msgSvc.ok('File Upload Not Supported', 'File Upload uses HTML5 FormData upload, your browser does not support it. Please upgrade to use file upload.');
                    return;
                }

                var isEligibility = popupType == 'BULKFILE_ELIGIBILITY';
                popupType = 'BULKUPLOAD';

                vm.popup = {
                    type: popupType,
                    uploadType: isEligibility ? 'ELIGIBILITY' : 'PREQUALIFIED',
                    title: isEligibility ? 'Eligibility Bulk File Upload' : 'Prequalified Bulk File Upload',
                    subTitle: isEligibility ?
                        'Eligibility bulk processing attempts to modify the eligibility status of multiple matches.' :
                        'Prequalified bulk file creates matches without associated encounters.',
                    action: 'prompt',
                    ready: false
                };
				break;

			case 'SUSPECTREJECTBULK':
				// no records
				if(vm.tbl.DataItems.length < 1) {
					msgSvc.ok('No Records', 'No records to process.');
					return;
				}

				popWidth = '40%';

				var propCount = 0;
				popupContentId = 'matchListPopupContent';

				var pop = {
					type: popupType,
					title: 'Reject All Suspects',
					queryOK: 'no',
					ready: false
				};

				if(!!!vm.query.DateRangeChk) {
					// date required, stop parsing search criteria
				}
				else {
					// find date + 1 other prop
					propCount++;
					pop.DateRangeChk = true;

					if(!!vm.query.EncounterNumber.chk) {
						propCount++;
						pop.EncounterNumberChk = true;
					}
					if(!!vm.query.ItemCode.chk) {
						propCount++;
						pop.ItemCodeChk = true;
					}
					if(!!vm.query.PrescriberIdent.chk) {
						propCount++;
						pop.PrescriberIdentChk = true;
					}
					if(!!vm.query.SuspectType.chk) {
						propCount++;
						pop.SuspectTypeChk = true;
					}
					if(!!vm.query.DrugType.chk) {
						propCount++;
						pop.DrugTypeChk = true;
					}
					if(!!vm.query.TotalAmountPaid.chk) {
						propCount++;
						pop.TotalAmountPaidChk = true;
					}
					if(!!vm.query.PrescriberIdent.chk) {
						propCount++;
						pop.PrescriberIdentChk = true;
					}
					if(!!vm.query.PatientLN.chk) {
						propCount++;
						pop.PatientLNChk = true;
					}
					if(!!vm.query.Location.chk) {
						propCount++;
						pop.LocationChk = true;
					}
					if(!!vm.query.Eligible.chk) {
						propCount++;
						pop.EligibleChk = true;
					}
					if(!!vm.query.MatchType.chk) {
						propCount++;
						pop.MatchTypeChk = true;
					}
					if(!!vm.query.CashCard.chk) {
						propCount++;
						pop.CashCardChk = true;
					}
				}

				if(propCount > 1) {
					pop.queryOK = 'yes';
				}

				vm.popup = pop;

				break;

			case 'TBLVIEW':
                popWidth = '40%';
				vm.popup = {
					type: 'TBLVIEW',
					title: tabToTitle(vm.activeTab) + ' Table View Editor',
					ready: false
				};
				$scope.$broadcast('widget.tblview.editor', {
					uniqueId: 'MATCH_SUSPECT',
					config: vm.tblViewConfig[vm.activeTab]
				});
				break;

			case 'EXCEL':
				popWidth = '40%';
				vm.popup = {
					type: 'EXCEL',
					title: 'Generating Excel File',
					ready: false
				};
				break;

			default:
				throw new Error('matchListCtl.openPopup, unknown popupType: ' + popupType);
		}

		var offsetY = 0,
			scrollTopFound = false;
		switch(popupType) {
			case 'TBLVIEW':
			case 'EXCEL':
				// do nothing, keep offset at 0
				break;
			case 'BULK':
			case 'BULKFILE':
			case 'BULKUPLOAD':
			case 'SUSPECTREJECTBULK':
			case 'MATCHCONFIG':
				offsetY = 50;
				break;
			default:
				// loop html element parents to calculate top offset
				offsetY = -130;
				var elem = !!evt ? evt.target : null;
				while(!!elem) {

					// top element found
					if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
						break;
					}

					// scroll container found, reduce offset if this container is scrolled
					if(!scrollTopFound && !!elem.className && elem.className.indexOf('table-fixed-header-scroll') > -1) {
						scrollTopFound = true;
						offsetY -=  Math.floor(elem.scrollTop);
					}

					// add offset, get next element
					offsetY += elem.offsetTop;
					elem = elem.offsetParent;
				}
				elem = null;
		}

		// adjust popup size and location
		var popup = document.getElementById(popupContentId);
		if(!!popup) {
			popup.style.top = offsetY.toString() + 'px';
			popup.style.width = popWidth;
		}

		// wait for digest before showing
		$timeout(function() {
			vm.popup.ready = true;
		}, 200);

	}

	function closePopup() {
		var popType = vm.popup.type;
		vm.popup = {};
		vm.importErrors = [];
		vm.importSelectedFiles = [];

		// cancel Excel polling if user closes popup early
		if(popType == 'EXCEL') {
			if(_excelPollTimer) {
				clearTimeout(_excelPollTimer);
				_excelPollTimer = null;
			}
			_excelJobId = null;
			return;
		}

		// reset search criteria on MATCH popup close (bulk processing may have altered it)
		if(vm.activeTab == 'MATCH' || vm.activeTab == 'SUSPECT') {
			if(popType == 'TBLVIEW') {
				tblViewReload(vm.activeTab, vm.query, false, true); // re-init views, keep paging if possible
			}
			else if(popType == 'BULK' || popType == 'BULKUPLOAD') {
				tabChange('MATCH');
			}
		}
	}


	/**
	 *    SUSPECT DETAIL
	 */

	function getSuspect(item) {

		// send list of visible table rows to suspect detail view

		if(vm.isWaiting) {
			return;
		}
		vm.flt.Ready = false;

		if(!!!item || !validSvc.isText(item.uniqueId)) {
			throw new Error('matchListCtl.getSuspect, item.uniqueId required');
		}
		var clickedId = item.uniqueId;

		// build a 1 page list of suspect items
		// note: using 1,000,000 as page size so all items are returned and not reduced by the flt.PageSize
		var pgSize = vm.flt.PageSize;
		vm.flt.PageSize = 1000000;
		var newItems = vm.filterList(vm.tbl.DataItems, vm.flt);
		vm.flt.PageSize = pgSize;

		// build compact list to pass
		var idx = -1,
			passItems = [];
		for(var i = 0; i < newItems.length; i++) {
			passItems.push({
				CEID: newItems[i].CoveredEntity,
				RXID: newItems[i].Pharmacy,
				DispId: newItems[i].DispId,
				SuspectType: newItems[i].SuspectType
			});
			if(newItems[i].uniqueId == clickedId) {
				// found id of item clicked
				idx = i;
			}
		}
		if(idx < 0) {
			throw new Error('matchListCtl.getSuspect, id not found in list filtered items: ' + clickedId);
		}

		// save view state
		saveViewState(vm.activeTab, vm.query);

		$state.go('ops.match-suspect', {Items: passItems, Idx: idx}, {reload: 'ops.match-suspect'});

	}


	/**
	 *    ASYNC
	 */

	function initAsyncReports() {
		return {
			title: 'Re-Evaluation - Saved Files',
			show: 'no'
		};
	}

	function toggleAsyncReports() {
		if(vm.isWaiting) {
			return;
		}
		vm.asyncReports.show = vm.asyncReports.show == 'yes' ? 'no' : 'yes';
		if(vm.asyncReports.show == 'yes') {
			$state.go('ops.match.async-reports', {
				rptType: 'RE_EVAL',
				query: null
			}, {reload: 'ops.match.async-reports'});
		}
	}

	function createReEvalAsyncExcel() {
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if (!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		var apiQuery = {
			Context: {
				CEID: [vm.query.CE.val],
				RXID: vm.popup.Affils,
			},
			Params: {
				MatchId: vm.popup.Id,
				StartDate: vm.popup.StartFrom,
				EndDate: vm.popup.CreateDate	
			},
			Paging:{}
		};
		apiQuery.Params.ReportType = 'RE_EVAL';
		
		vm.popup = {};
		vm.isWaiting = true;
		msgSvc.wait(true);
		reportRepo.createAsyncFile(apiQuery).then(okServerExcel, errServerExcel);

		/**
		 *    EXCEL HELPERS
		 */

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			
			msgSvc.ok('Excel File Requested', 'Check the "Saved Files" link at top right to retrieve this Excel Workbook.');
		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if (!!r) {
				errSvc.warn('Create Excel Error', 'catalog.ServerExcel', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	/**
	 *    ASYNC JOBS (Match/Suspect Excel files via ops/async endpoints)
	 */

	function initAsyncJobs() {
		return {
			title: 'Match List - Saved Files',
			show: 'no',
			action: 'LIST',
			flt: {
				Ready: false,
				SortBy: { name: 'requestedDate', dir: 'desc' },
				Page: 1,
				PageSize: 20,
				PageCount: 1,
				Count: 0,
				Text: {
					status: '',
					fileName: ''
				}
			},
			tbl: {
				DataItems: [],
				Items: []
			}
		};
	}

	function toggleAsyncJobs() {
		if(vm.isWaiting) {
			return;
		}
		vm.asyncJobs.show = vm.asyncJobs.show == 'yes' ? 'no' : 'yes';
		vm.asyncJobs.title = 'Match / Suspect - Saved Files';
		if(vm.asyncJobs.show == 'yes') {
			asyncJobsRefresh();
		} else {
			if(_asyncJobsRefreshTimer) {
				$timeout.cancel(_asyncJobsRefreshTimer);
				_asyncJobsRefreshTimer = null;
			}
		}
	}

	function asyncJobsRefresh() {
		var matchPromise = opsAsyncRepo.list({ JobType: 'MATCH_EXPORT' });
		var suspectPromise = opsAsyncRepo.list({ JobType: 'SUSPECT_EXPORT' });

		$q.all([matchPromise, suspectPromise]).then(function(results) {
			var matchItems = Array.isArray(results[0]) ? results[0] : [];
			var suspectItems = Array.isArray(results[1]) ? results[1] : [];
			var allItems = matchItems.concat(suspectItems);

			vm.asyncJobs.tbl.DataItems = allItems.map(function(item) {
				var attrs = item.attrs || {};
				return {
					jobId: item.jobId,
					status: item.status,
					fileName: attrs.fileName || (item.jobType === 'SUSPECT_EXPORT' ? 'Suspect List Export' : 'Match List Export'),
					requestedDate: item.requestedDate ? new Date(item.requestedDate) : null,
					expirationDate: item.expirationDate ? new Date(item.expirationDate) : null
				};
			});
			vm.asyncJobs.flt.Ready = true;
			asyncJobsFilterChange();
		}, function() {
			vm.asyncJobs.tbl.DataItems = [];
			vm.asyncJobs.tbl.Items = [];
			vm.asyncJobs.flt.Ready = true;
		});
	}

	function asyncJobsFilterChange() {
		var flt = vm.asyncJobs.flt;
		var items = vm.asyncJobs.tbl.DataItems;

		// Filter
		if(flt.Text.status) {
			items = items.filter(function(item) {
				return item.status && item.status.toLowerCase().indexOf(flt.Text.status.toLowerCase()) > -1;
			});
		}
		if(flt.Text.fileName) {
			items = items.filter(function(item) {
				return item.fileName && item.fileName.toLowerCase().indexOf(flt.Text.fileName.toLowerCase()) > -1;
			});
		}

		// Sort
		var sortName = flt.SortBy.name;
		var sortDir = flt.SortBy.dir === 'asc' ? 1 : -1;
		items = items.slice().sort(function(a, b) {
			var valA = a[sortName];
			var valB = b[sortName];
			if(valA == null) { return 1; }
			if(valB == null) { return -1; }
			if(valA < valB) { return -1 * sortDir; }
			if(valA > valB) { return 1 * sortDir; }
			return 0;
		});

		flt.Count = items.length;
		flt.PageCount = Math.ceil(flt.Count / flt.PageSize) || 1;

		// Reset to page 1 if current page is out of range
		if(flt.Page > flt.PageCount) {
			flt.Page = 1;
		}

		// Paging
		var startIdx = (flt.Page - 1) * flt.PageSize;
		var endIdx = startIdx + flt.PageSize;
		vm.asyncJobs.tbl.Items = items.slice(startIdx, endIdx);

		// Broadcast paging update to widget
		$scope.$broadcast('widget.paging', {
			uniqueId: 'ASYNC_JOBS',
			Size: flt.PageSize,
			Page: flt.Page,
			Total: flt.PageCount,
			RowCount: flt.Count,
			ItemCount: vm.asyncJobs.tbl.Items.length,
			DataCount: vm.asyncJobs.tbl.DataItems.length
		});
	}

	function asyncJobsSortBy(colName) {
		var flt = vm.asyncJobs.flt;
		if(flt.SortBy.name === colName) {
			flt.SortBy.dir = flt.SortBy.dir === 'asc' ? 'desc' : 'asc';
		} else {
			flt.SortBy.name = colName;
			flt.SortBy.dir = 'asc';
		}
		asyncJobsFilterChange();
	}
	vm.asyncJobsSortBy = asyncJobsSortBy;

	function asyncJobsSortByIcon(colName) {
		var sortBy = vm.asyncJobs.flt.SortBy;
		if(sortBy.name !== colName) {
			return '';
		}
		return sortBy.dir === 'asc' ? 'icon-sort-asc' : 'icon-sort-desc';
	}
	vm.asyncJobsSortByIcon = asyncJobsSortByIcon;

	function asyncJobsDownload(item) {
		if(!item || !item.jobId) {
			return;
		}
		var filename = (item.fileName || 'MatchList').replace(/\.xlsx$/i, '');
		opsAsyncRepo.get(item.jobId, filename).then(function() {
		// file saved by repo
		}, function(r) {
			if(!!r) {
				errSvc.warn('Download Error', 'matchListCtl.asyncJobsDownload', r.status || '', '');
			}
		});
	}

	function asyncJobsPageChange(newPage) {
		vm.asyncJobs.flt.Page = newPage;
		asyncJobsFilterChange();
	}
	vm.asyncJobsPageChange = asyncJobsPageChange;

	/**
	 *    FILTER: CHANGE
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			// update paging ui
			var pagingId = vm.activeTab;

			// match or suspect table
			if(pagingId == 'MATCH' || pagingId == 'SUSPECT') {
				pagingId = 'MATCH_SUSPECT'; // shared paging widget

				// filter values are stored inside table view columns
				vm.flt = vm.tblViewGetColumnFilterValues(vm.tblView.cols, vm.flt);
			}

			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}


			$scope.$broadcast('widget.paging', {
				uniqueId: pagingId,
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					saveViewState(vm.activeTab, vm.query);
				}
			},1000);

		}, delayTime);

	}

	function filterChangeCeMulti() {
		// CeMulti dropdown filtering always immediate
		var multi = vm.CeMulti;

		// list empty
		multi.list = Array.isArray(multi.list) ? multi.list : [];
		if(multi.list.length < 1) {
			multi.filtered = [];
			return;
		}

		// filter empty
		var flt = multi.flt || {};
		var fltVal = validSvc.isText(flt.val) ? flt.val.toLowerCase() : undefined,
			fltLbl = validSvc.isText(flt.lbl) ? flt.lbl.toLowerCase() : undefined,
			fltLbl2 = validSvc.isText(flt.lbl2) ? flt.lbl2.toLowerCase() : undefined;
		if(!validSvc.isText(fltVal + fltLbl + fltLbl2)) {
			multi.filtered = multi.list;
			return;
		}

		multi.filtered = [];
		multi.list.forEach(function(item){
			if(!!!fltVal || item.val.toLowerCase().indexOf(fltVal) > -1) {
				if(!!!fltLbl || item.lbl.toLowerCase().indexOf(fltLbl) > -1) {
					if(!!!fltLbl2 || item.lbl2.toLowerCase().indexOf(fltLbl2) > -1) {
						multi.filtered.push(item);
					}
				}
			}
		});
	}


	/**
	 *    POPUP ACTIONS: REJECT MATCH, OVERRIDE ELIGIBILITY, BULK PROCESS
	 */

	function rejectScript(rejectType, id, RxNumber, fillNum) {

		// user chose to reject the script of this match list item

		if(vm.isWaiting) {
			return;
		}

		switch(rejectType) {

			case 'ALL':
				_pendingEdit = {
					action: 'rejectscript',
					msgId: 'ops.match.rejectscript',
					id: id,
					fillNum: fillNum,
					title: 'Confirm Reject Script',
					msg: 'Reject Rx: ' + RxNumber + ' script and all its fill dispenses?'
				};
				break;

			case 'FILLFORWARD':
				_pendingEdit = {
					action: 'rejectfill',
					msgId: 'ops.match.rejectfill',
					id: id,
					fillNum: fillNum,
					title: 'Block Fills',
					msg: 'Block Fills starting at fill #: ' + fillNum + ' for Rx: ' + RxNumber + ' ?'
				};
				break;
			case 'SINGLE':
				_pendingEdit = {
					action: 'rejectfillone',
					msgId: 'ops.match.rejectfill',
					id: id,
					fillNum: fillNum,
					title: 'Block Fill',
					msg: 'Block Fill #: ' + fillNum + ' for Rx: ' + RxNumber + ' ?'
				};
				break;
			default:
				throw new Error('matchListCtl.rejectScript, unknown reject type: ' + rejectType);
		}

		promptUser();

	}

	function unmatchScript(unmatchType, id, RxNumber, fillNum) {

		// user chose to reject the script of this match list item

		if(vm.isWaiting) {
			return;
		}

		var msgwarning = '';

		if (!!vm.popup.Allocated) {
			msgwarning = 'WARNING: This dispense is currently allocated. Unmatching the dispense may affect invoices and/or accumulators.';
		}

		switch(unmatchType) {

			case 'MANUAL':
				_pendingEdit = {
					action: 'unmatchscriptmanual',
					msgId: 'ops.match.unmatchfill',
					id: id,
					title: 'Confirm Unmatch',
					msg: 'Unmatch Rx# ' + RxNumber + ' All Fills and then rematch manually. ' + msgwarning
				};
				break;

			case 'SYSTEM':
				_pendingEdit = {
					action: 'unmatchscriptsystem',
					msgId: 'ops.match.unmatchfill',
					id: id,
					title: 'Confirm Unmatch',
					msg: 'Unmatch Rx# ' + RxNumber + ' All Fills and then rematch systematically. ' + msgwarning
				};
				break;
			default:
				throw new Error('matchListCtl.unmatchScript, unknown unmatch type: ' + unmatchType);
		}

		promptUser();

	}

	function eligOverride(id, RxNumber, ndc) {

		// user chose to override eligibility of this match list item

		if(vm.isWaiting) {
			return;
		}

		_pendingEdit = {
			action: 'eligoverride',
			msgId: 'ops.match.eligoverride',
			id: id,
			title: 'Confirm Override',
			msg: 'Override matched dispense with Rx: ' + RxNumber + ', NDC: ' + ndc + '?'
		};

		promptUser();

	}

	function undoHistory(id, fillnum, type, title) {

		// user is undoing a match reject or fill block from their edit history

		if(vm.isWaiting) {
			return;
		}

		_pendingEdit = {
			action: 'undohistory',
			msgId: 'ops.match.undohistory',
			id: id,
			title: 'Confirm Undo',
			type: type,
			fillNum: fillnum,
			msg: 'Undo ' + title + '?'
		};

		if (type == 'SINGLE'){
			_pendingEdit.msgsuccess = 'Blocking has been undone for Fill #' + fillnum + ' only.';
		}

		promptUser();

	}

	function suspectRejectBulk() {

		// user is rejecting all suspects in list

		if(vm.isWaiting) {
			return;
		}

		_pendingEdit = {
			action: 'suspectrejectbulk',
			msgId: 'ops.match.suspectrejectbulk',
			title: 'Suspect Reject All',
			msg: 'Reject all suspect matches? Please confirm, action cannot be reversed.'
		};

		promptUser();

	}

	function bulkProcess(action) {

		// user is starting a bulk accept or reject

		if(vm.isWaiting) {
			return;
		}

		// at least one chosen
		if(!vm.popup.DateRangeChk &&
			!vm.popup.EncounterNumberChk &&
			!vm.popup.ItemCodeChk &&
			!vm.popup.PrescriberIdentChk &&
			!vm.popup.PatientLNChk &&
			!vm.popup.LocationChk &&
			!vm.popup.EligibleChk &&
			!vm.popup.MatchTypeChk) {
			msgSvc.ok('Bulk Processing', 'Choose at least one search criteria.');
			return;
		}

		// apply checkmarks to search criteria
		// note: its ok to change the main query, global grease will restore it after bulk is done
		vm.query.DateRangeChk = vm.popup.DateRangeChk;
		vm.query.EncounterNumber.chk = vm.popup.EncounterNumberChk;
		vm.query.ItemCode.chk = vm.popup.ItemCodeChk;
		vm.query.PrescriberIdent.chk = vm.popup.PrescriberIdentChk;
		vm.query.PatientLN.chk = vm.popup.PatientLNChk;
		vm.query.Location.chk = vm.popup.LocationChk;
		vm.query.Eligible.chk = vm.popup.EligibleChk;
		vm.query.MatchType.chk = vm.popup.MatchTypeChk;

		var actionTxt = action == 'block' ? 'Block' : 'Unblock And Override';

		if(vm.popup.action == 'prompt') {
			// user needs to see stats first
			vm.popup.action = action;
			vm.popup.title = actionTxt.toUpperCase() + ' Matches';
			matchRepo.bulkStats(vm.query, action).then(okBulkStats, errBulk);
		}
		else {

			// user has seen stats, prompt them with confirm
			_pendingEdit = {
				action: 'bulk',
				msgId: 'ops.match.bulk.' + action,
				title: actionTxt.toUpperCase() + ' Matches',
				msg: 'Confirm bulk process to ' + actionTxt + ' matches?'
			};

			promptUser();
		}

	}

	function okBulkStats(r) {
		vm.isWaiting = false;

		// re-show popup with bulk stats
		vm.popup.QueryTotal = r.QueryTotal;
		vm.popup.Updated = r.Updated;
		vm.popup.SkippedSame = r.SkippedSame;
		vm.popup.SkippedUnable = r.SkippedUnable;
	}


	/**
	 *    SHARED ACCEPT/REJECT/UNMATCH HANDLERS
	 */

	function promptUser() {

		var conf = {
			id: _pendingEdit.msgId,
			title: _pendingEdit.title,
			msg: _pendingEdit.msg,
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		};

		if(_pendingEdit.action != 'suspectrejectbulk' && _pendingEdit.action != 'unmatchscriptmanual' && _pendingEdit.action != 'unmatchscriptsystem' && _pendingEdit.action != 'evalupdate') {
			conf.notes = {
				prompt: 'optional notes',
				maxlength: 150,
				out: ''
			};
		}

		msgSvc.confirm(conf).then(userConfirm, userConfirm);

	}

	function userConfirm(r) {
		// async delegate handler for OK to delete message box

		// user said yes
		if(!!r && r.result == 'YES') {

			vm.isWaiting = true;
			var notes = validSvc.isText(r.notes) ? r.notes : '';

			switch(_pendingEdit.action) {
				case 'rejectscript':
				case 'rejectfill':
				case 'rejectfillone':
					matchRepo.rejectScript(_pendingEdit.id, _pendingEdit.action, _pendingEdit.fillNum, notes).then(okMatchEdit, errMatchEdit);
					break;
				case 'unmatchscriptmanual':
				case 'unmatchscriptsystem':
					matchRepo.unmatchScript(_pendingEdit.id, _pendingEdit.action, notes).then(okMatchEdit, errMatchEdit);
					break;
				case 'eligoverride':
					matchRepo.eligOverride(_pendingEdit.id, notes).then(okMatchEdit, errMatchEdit);
					break;
				case 'undohistory':
					matchRepo.undoHistory(_pendingEdit.id, _pendingEdit.type, _pendingEdit.fillNum, notes).then(okMatchEdit, errMatchEdit);
					break;
				case 'evalcreate':
					matchRepo.evalCreate(vm.query, notes, false).then(okEvalCreate, errEvalCreate);
					break;
				case 'evalupdate':
					matchRepo.evalUpdate(_pendingEdit.id, _pendingEdit.status).then(okEvalUpdate, errEvalUpdate);
					break;
				case 'evaldryrun':
					matchRepo.evalCreate(vm.query, notes, true).then(okEvalCreate, errEvalCreate);
					break;
				case 'rematchcreate':
					matchRepo.rematchCreate(vm.query, notes, false).then(okRematchCreate, errRematchCreate);
					break;
				case 'bulk':
					vm.query.Secondary.val = multiselectQueryVals(vm.SecondaryMulti);
					matchRepo.bulkProcess(vm.query, vm.popup.action, notes).then(okBulkAction, errBulk);
					break;
				case 'suspectrejectbulk':
					vm.query.Secondary.val = multiselectQueryVals(vm.SecondaryMulti);
					matchRepo.bulkProcess(vm.query, 'SUSPECTREJECTBULK', notes).then(okSuspectRejectAction, errBulk);
					break;
				default:
					throw new Error('matchListCtl.userConfirm, unknown pending edit action: ' + _pendingEdit.action);
			}

		}
		else {
			_pendingEdit = null;
		}

	}

	function okMatchEdit(r) {
		vm.isWaiting = false;

		var msg = '';
		switch(_pendingEdit.action) {
			case 'rejectscript':
				msg = 'Script Reject process started. Script status will be updated shortly, refresh your browser to see new status.';
				break;
			case 'rejectfill':
				msg = 'Fills are now blocked';
				break;
			case 'rejectfillone':
				msg = 'Fill is now blocked';
				break;
			case 'eligoverride':
				msg = 'Override Complete';
				// fill stats
				if(!!r && !!r.Entity) {
					if(validSvc.isInteger(r.Entity.FillsEvaluated) && r.Entity.FillsEvaluated > 0) {
						msg += ". Additional Fills Evaluated: " + r.Entity.FillsEvaluated;
						if(validSvc.isInteger(r.Entity.EligibleFills) && r.Entity.EligibleFills > 0) {
							msg += ", Eligible: " + r.Entity.EligibleFills;
						}
						if(validSvc.isInteger(r.Entity.IneligibleFills) && r.Entity.IneligibleFills > 0) {
							msg += ", Not Eligible: " + r.Entity.IneligibleFills;
						}
						if(validSvc.isInteger(r.Entity.FillsSkipped) && r.Entity.FillsSkipped > 0) {
							msg += ", Skipped: " + r.Entity.FillsSkipped;
						}
					}
				}
				break;
			case 'undohistory':
				msg = !!_pendingEdit.msgsuccess ? _pendingEdit.msgsuccess : 'Blocking has been undone.';
				break;
		}

		// async ok msg
		msgSvc.okAsync(_pendingEdit.title, msg, 'ops.match.editdone').then(querySubmit, querySubmit);
		_pendingEdit = null;
		closePopup();

	}

	function errMatchEdit(r) {
		vm.isWaiting = false;

		if(!!r && r.status === 422) {
			msgSvc.ok(errMatchEditTxt(_pendingEdit.action) + ' Error', r.invalidReason);
		}
		else if(!!r && r.status === 409) {
			msgSvc.ok(errMatchEditTxt(_pendingEdit.action) + ' 409 Conflict', 'Server data is invalid or reserved, refresh this page and try again.');
		}
		else if(!!r) {
			errSvc.error('Unknown error during accept / reject', 'matchListCtl.errMatchEdit', r.status, utilSvc.http.safeResponse(r));
		}

	}

	function okBulkAction(r) {
		vm.isWaiting = false;

		var msg = 'Bulk processing request started, some items may be processed shortly.';

		// async ok msg
		msgSvc.okAsync(_pendingEdit.title.toUpperCase(), msg, 'ops.match.bulkdone').then(bulkProcessDone, bulkProcessDone);
		_pendingEdit = null;
		closePopup();
	}

	function okSuspectRejectAction(r) {
		vm.isWaiting = false;

		var countMsg = utilSvc.str.toText($filter('number')(utilSvc.num.parse(r.Id), 0));
		closePopup();
		msgSvc.okAsync(_pendingEdit.title.toUpperCase(), 'Reject all complete, ' + countMsg + ' suspects rejected. Refreshing search to view results.', 'ops.match.bulkrejectdone').then(bulkSuspectRejectDone, bulkSuspectRejectDone);
		_pendingEdit = null;
	}

	function bulkProcessDone() {
		tabChange('MATCH');
	}

	function bulkSuspectRejectDone() {
		tabChange('SUSPECT');
	}

	function errBulk(r) {
		// shared bulk process err handler
		vm.isWaiting = false;

		if(!!r) {
			errSvc.error('Unknown error during eligibility processing', 'matchListCtl.errBulk', r.status, utilSvc.http.safeResponse(r));
		}

	}

	function errMatchEditTxt(pendingAction) {
		switch(pendingAction) {
			case 'rejectscript':
				return 'Reject Script';
			case 'rejectfill':
				return 'Block Script';
			case 'eligoverride':
				return 'Eligibilty';
			case 'undohistory':
				return 'Undo History';
			default:
				return '';
		}
	}


	/**
	 *    EVAL
	 */

	function evalCreateToggle() {

		if(vm.isWaiting) {
			return;
		}

		if(vm.activeTab == 'EVALNEW') {
			// toggle off
			tabChange('EVAL');
		}
		else {
			// toggle on
			vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';
			if(vm.query.CE.fail == 'yes') {
				msgSvc.ok('Cannot Re-Evaluate', 'Please choose a Facility');
				return;
			}
			tabChange('EVALNEW');
		}

	}

	function evalChangeTarget(newTarget) {
		if(vm.isWaiting) {
			return;
		}
		vm.query.Evaluate = newTarget;
		evalBuildPharmacyOptions(newTarget);
	}

	function evalBuildPharmacyOptions(newTarget) {
		vm.query.RX = validSvc.newProp('ALL');
		vm.query.RX.vals = [];
		vm.query.RX.fail = 'yes';

		vm.EvalRxMulti = buildEvalNewRxMulti(newTarget);
		
		// EvalRxMulti auto select 1 pharmacy
		var rxList = vm.EvalRxMulti.list;
		if(rxList.length == 2) {
			rxList[1].checked = true;
			vm.EvalRxMulti.vals = [rxList[1].val];
			vm.query.RX.val = rxList[1].val;
			for (var i = 0; i < _affsAllowFacilitySentMatches.length; i++) {
				if (_affsAllowFacilitySentMatches[i] == vm.query.RX.val) {
					vm.affsIncludeFacilitySentMatches = true;
					break;
				}
			}
		}
		else {
			// check ALL by default
			rxList[0].checked = true;
			vm.EvalRxMulti.vals = ['ALL'];
			vm.query.RX = validSvc.newProp('ALL');
		}
		vm.multiselectTitle(vm.EvalRxMulti, true);

		queryChangeRX();
	}

	function evalCreate(runType) {

		// eval query valid
		if(!queryValid(vm.activeTab, vm.query)) {
			if(!vm.init) {
				msgSvc.ok('Cannot Create', 'Check properties');
			}
			return;
		}

		// exit if waiting
		if(vm.isWaiting) {
			return;
		}

		// test run or real thing?
		switch(runType) {
			case 'TESTRUN':
				_pendingEdit = {
					action: 'evaldryrun',
					msgId: 'ops.match.evaldryrun',
					title: 'Test Run for ' + vm.query.CE.val + ' Re-Evaluation',
					msg: 'Test run will make no changes. Results will be returned as if re-matching and eligibility operations were run.'
				};
				break;
			case 'EVAL':
				_pendingEdit = {
					action: 'evalcreate',
					msgId: 'ops.match.evalcreate',
					title: 'Confirm ' + vm.query.CE.val + ' Re-Evaluation',
					msg: 'This operation will perform intensive re-matching and eligibility operations. This action CANNOT be reversed.'
				};
				break;
			default:
				throw new Error('matchListCtl.evalCreate, runType unknown: ' + runType);
		}

		promptUser();

	}

	function okEvalCreate(r) {
		vm.isWaiting = false;

		msgSvc.ok('Re-Evaluation Started', 'Click REFRESH button to update percent complete. Once done, click to see re-evaluation results.');
		_autoSubmit = true;
		tabChange('EVAL');

	}

	function errEvalCreate(r) {
		vm.isWaiting = false;
		if(!!r) {
			errSvc.error('Unknown eval create response', 'matchListCtl.errEvalCreate', r.status, utilSvc.http.safeResponse(r));
		}
	}

	function evalUpdateStatus(event, action, item) {
		event.stopPropagation();
		var newstatus = '';
		if(action == 'PAUSE') {
			newstatus = 'PAUSED';
		} else if(action == 'RESUME') {
			newstatus = 'INTERRUPTED';
		} else if(action == 'CANCEL') {
			newstatus = 'CANCELLED';
		} else {
			throw new Error('matchListCtl.evalUpdateStatus, unknown action: ' + action);
		}
		_pendingEdit = {
			id: item.Id,
			action: 'evalupdate',
			status: newstatus,
			msgId: 'ops.match.evalupdate',
			title: 'Confirm ' + action + ' Re-Evaluation Job',
			msg: 'This operation will change re-matching and eligibility operations status. This action CANNOT be reversed.'
		};
		promptUser();
	}

	function okEvalUpdate(r) {
		vm.isWaiting = false;

		msgSvc.ok('Re-Evaluation Job Updated');
		vm.querySubmit();
	}

	function errEvalUpdate(r) {
		vm.isWaiting = false;
		if(!!r) {
			errSvc.error('Unknown eval update response', 'matchListCtl.errEvalUpdate', r.status, utilSvc.http.safeResponse(r));
		}
	}

	/**
	 *    REMATCH
	 */

	 function rematchCreate() {

		// eval query valid
		if(!queryValid(vm.activeTab, vm.query)) {
			if(!vm.init) {
				msgSvc.ok('Cannot Create', 'Check properties');
			}
			return;
		}

		// exit if waiting
		if(vm.isWaiting) {
			return;
		}

		_pendingEdit = {
			action: 'rematchcreate',
			msgId: 'ops.match.rematchcreate',
			title: 'Confirm ' + vm.query.CE.val + ' Re-Match Dispenses',
			msg: 'This operation will perform intensive re-matching and eligibility operations. This action CANNOT be reversed.'
		};

		promptUser();

	}

	function okRematchCreate(r) {
		vm.isWaiting = false;

		msgSvc.ok('Re-Match Started', 'Click REFRESH button to update percent complete. Once done, click to see re-evaluation results.');
		_autoSubmit = true;
		tabChange('REMATCH');

	}

	function errRematchCreate(r) {
		vm.isWaiting = false;
		if(!!r) {
			errSvc.error('Unknown re-match create response', 'matchListCtl.errRematchCreate', r.status, utilSvc.http.safeResponse(r));
		}
	}

	/**
	 *    REVIEW MATCH
	 */

	function reviewMatch(item) {
		if (!!vm.query.isVerity) {
			msgSvc.ok("WARNING", "Verity users are not permitted to mark matches as Reviewed.");
			return;	
		}
		if (!!!vm.query.canEdit) {
			msgSvc.ok("WARNING", "User is not permitted to mark matches as Reviewed. Please contact your Verity Account Manager to enable the necessary permission.");
			return;	
		}
		var reviewTxt = item.Reviewed == 'YES' ? 'Unreview' : 'Review';
		msgSvc.confirm({
			id: 'ops.match.review',
			title: reviewTxt + ' Matched Dispense',
			msg:  'Confirm ' + reviewTxt + ' Matched Dispense?',
			notes: {
				prompt: 'optional change notes',
				maxlength: 100,
				out: ''
			},
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

		function userConfirm(r) {
			if(!!r && r.result == 'YES') {
				msgSvc.wait(true);
				vm.isWaiting = true;
				matchRepo.reviewMatch(item.Id, item.Reviewed == 'NO', r.notes).then(okReview, errReview);
			}
			
			function okReview(r) {
				msgSvc.wait(false);
				vm.isWaiting = false;
				querySubmit();
			}
	
			function errReview(r) {
				msgSvc.wait(false);
				vm.isWaiting = false;
				if(!!r) {
					errSvc.warn('Review match failed', 'ops.match.review', r.status, utilSvc.http.safeResponse(r));
				}
			}
		}
	}

	/**
	 *    REVIEW SUSPECT
	 */

	function reviewSuspect(item) {
		if (!!vm.query.isVerity) {
			msgSvc.ok("WARNING", "Verity users are not permitted to mark suspects as Reviewed.");
			return;	
		}
		if (!!!vm.query.canEdit) {
			msgSvc.ok("WARNING", "User is not permitted to mark suspects as Reviewed. Please contact your Verity Account Manager to enable the necessary permission.");
			return;	
		}
		var reviewTxt = item.Reviewed == 'YES' ? 'Unreview' : 'Review';
		msgSvc.confirm({
			id: 'ops.match.suspect.review',
			title: reviewTxt + ' Suspect Dispense',
			msg:  'Confirm ' + reviewTxt + ' Suspect Dispense?',
			notes: {
				prompt: 'optional change notes',
				maxlength: 100,
				out: ''
			},
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

		function userConfirm(r) {
			if(!!r && r.result == 'YES') {
				msgSvc.wait(true);
				vm.isWaiting = true;
				matchRepo.reviewSuspect(item.Id, item.Reviewed == 'NO', r.notes).then(okReview, errReview);
			}
			
			function okReview(r) {
				msgSvc.wait(false);
				vm.isWaiting = false;
				querySubmit();
			}
	
			function errReview(r) {
				msgSvc.wait(false);
				vm.isWaiting = false;
				if(!!r) {
					errSvc.warn('Review suspect failed', 'ops.match.suspect.review', r.status, utilSvc.http.safeResponse(r));
				}
			}
		}
	}

	/**
	 *    UNMATCH
	 */

	function unmatchLink(item) {
		$state.go('ops.claims', {dispid: item.DispId, rx: item.PharmacyNick}, {reload: 'ops.claims'});
	}
	/**
	 *    SEND TO TPA
	 */

	function sendToTPAToggleList(action) {
		if(vm.isWaiting) {
			return;
		}

		var dataItems = Array.isArray(vm.tbl.Items) ? vm.tbl.Items : [];
		var filteredMap = {};
		if(action == 'ALL') {
			// select all filtered items without paging
			var flt = JSON.parse(JSON.stringify(vm.flt)); // de-ref deep copy
			flt.PageSize = 10000000;
			var filteredItems = vm.filterList(dataItems, flt);
			
			// max 20 item
			if(filteredItems.length > 20) {
				msgSvc.ok('Cannot Select', 'Maximum 20 matches selections allowed');
				return;
			}

			// build map
			filteredItems.forEach(function(item) {
				filteredMap[item.uniqueId] = true;
			});
		}

		var checked = action == 'ALL';
		vm.sentToTPAList = [];

		// set data items and rebuild cloneTo items
		dataItems.forEach(function(item) {
			item.checked = checked;
			if(checked && !!filteredMap[item.uniqueId] && item.CanForceSend) {
				vm.sentToTPAList.push(sendToVM(item));
			}
		});
	}

	function sendToTPAToggleItem(item) {
		if(vm.isWaiting || !item) {
			return;
		}

		// max 20 clone targets for CE scope
		if(vm.sentToTPAList.length > 20) {
			msgSvc.ok('Cannot Select', 'Maximum 20 matches selections allowed');
			return;
		}
		
		// find and toggle item
		var listItem = vm.tbl.Items.find(function(l){
			return l.uniqueId == item.uniqueId;
		});
		listItem.checked = !!!item.checked;

		// modify cloneTo list
		if(listItem.checked) {
			// add item
			vm.sentToTPAList.push(sendToVM(item));
		}
		else {
			// remove item
			vm.sentToTPAList = vm.sentToTPAList.filter(function(senditem){
				return senditem.uniqueId != item.uniqueId;
			});
		}
	}


	function sendToVM(item) {
		return {
			uniqueId: item.uniqueId,
			Id: item.Id,
		};
	}

	function sendToTPASelectionSubmit() {
		if(vm.isWaiting) {
			return;
		}

		msgSvc.confirm({
			id: 'ops.match.senttotpa',
			title: 'FORCE SEND TO TPA',
			msg: 'Click \'OK\' to proceed sending the selected matches to TPA',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmSendTPA, confirmSendTPA);

		function confirmSendTPA(r) {
			// user said yes to proceed
			if(!!r && r.result == 'YES') {	
				vm.isWaiting = true;
				var matches = [];
				for(var i=0; i<vm.sentToTPAList.length;i++) {
					matches.push(vm.sentToTPAList[i].Id);
				}
				matchRepo.sendToTPA(matches).then(okSend, errSend);
			}
		}

		function okSend() {
			vm.isWaiting = false;
			msgSvc.ok('Matches will be included in the next file to TPA');	
		}
	
		function errSend() {
			vm.isWaiting = false;
			errSvc.info('Could not force matches to be included');
		}
	}

	/**
	 *    DATE PICKER
	 */

	function dtPickOpen(dtName) {

		var dtProp = '';
		switch(dtName) {
			case 'evalStartDate':
			case 'newRematchStartDate':
				dtProp = 'StartDate';
				break;
			case 'evalEndDate':
				dtProp = 'EndDate';
				break;
			default:
				alert('reportAuditCtl.dtPickOpen, date pick name unknown: ' + dtName);
				return;
		}

		var dt = vm.query[dtProp];
		vm.dtPickShow.pending = dtName;

		$scope.$broadcast('widget.input.date.pick', {
			uniqueId: dtName,
			setDate: dt.val,
			minDate: dt.min,
			maxDate: dt.max
		});

		$timeout(function(){
			if(validSvc.isText(vm.dtPickShow.pending)) {
				vm.dtPickShow[vm.dtPickShow.pending] = true;
			}
		},100);

	}


	/**
	 *    MATCH REVIEW IMPORT
	 */

	function importValidFile(newFile) {

		// required
		if(!!!newFile) {
			return 'no file selected';
		}

		// file size > 0 bytes, < 10 megabytes
		if(!validSvc.isNumber(newFile.size) || newFile.size < 1 || newFile.size > 10000000) {
			return 'file size must be 2 bytes to 10 megabytes';
		}

		// file name must be .csv
		var fName = newFile.name;
		if(!validSvc.isText(fName) || fName.length < 5 || (fName.substr(fName.length - 4, 4).toLowerCase() !== '.csv' && fName.substr(fName.length - 4, 4).toLowerCase() !== '.txt')) {
			return 'file name must end with extension ".csv" or ".txt"';
		}

		return 'ok';

	}

	function importCsvSend() {

		// import CSV file

		if(vm.isWaiting) {
			return;
		}

		// files selected
		if(!!!vm.importSelectedFiles || vm.importSelectedFiles.length !== 1) {
			msgSvc.ok('File Import', 'Please choose 1 file to upload.');
			return;
		}

		// validate file
		var fileFail = importValidFile(vm.importSelectedFiles[0]);
		if(fileFail != 'ok') {
			msgSvc.ok('File Import', 'Selected file error: ' + fileFail);
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		// UI constrains bulk upload to 1 afiliation
		var ceVal = vm.query.primeProp == 'CE' ? vm.query.Primary.val : vm.SecondaryMulti.vals[0];

		matchRepo.bulkProcessUpload(vm.popup.uploadType, ceVal, vm.importSelectedFiles[0]).then(okFileImport, errFileImport);

		function okFileImport(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;
            var msgTxt = vm.popup.uploadType == 'ELIGIBILITY' ?
                'Match Eligibility Requested' :
                'Pre-Qualified Match Requested';
			msgSvc.okAsync(msgTxt, r.Processed + ' Lines Imported. Matches Bulk processing request started, some items may be processed shortly.', 'ops.match.bulkimport').then(closePopup, closePopup);
		}

		function errFileImport(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(r === null) {
				return;
			}
			else if (r.status == 422) {
				vm.importErrors = r;
				msgSvc.ok('Import Errors', 'Please see line errors during import.\nAdditionally, Matches Bulk processing request started, some items may be processed shortly.');
			}
			else if (r.status == 409 && r.timeout) {
				msgSvc.ok('Import in Progress', 'The importer is still processing your data.  Please check the Feeds list for status once it is finished.');
			}
			else {
				errSvc.error('Unexpected api error for: ' + vm.popup.uploadType, 'ops.match.bulkimport', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    FILTER SWAP
	 */

	function filterSwap() {

		if(vm.isWaiting || (vm.activeTab != 'MATCH' && vm.activeTab != 'SUSPECT')) {
			return;
		}

		queryChange();

		var swapProp = vm.query.primeProp == 'CE' ? 'RX' : 'CE',
			newPrimeVal = 'NONE',
			newSecVals = ['ALL'];

		// swap only if 1 affiliation is chosen, only use secondary val if its not ALL or a ROLLUP
		var secVal = vm.SecondaryMulti.vals.length === 1 ? vm.SecondaryMulti.vals[0] : '';
		if(validSvc.isEntity(vm.query.Primary.val) && validSvc.isText(secVal) && secVal != 'ALL' && secVal.indexOf('|ROLLUP') < 0) {
			newPrimeVal = secVal;
			newSecVals = [vm.query.Primary.val];
		}

		// clear hidden list filter for dynamic columns Pharmacy/CoveredEntity
		// note: it won't be shown and could constrain the list result
		if(swapProp == 'CE') {
			_tabInfo['MATCH'].flt.Text.CoveredEntity = '';
			_tabInfo['SUSPECT'].flt.Text.CoveredEntity = '';
		}
		else {
			_tabInfo['MATCH'].flt.Text.Pharmacy = '';
			_tabInfo['SUSPECT'].flt.Text.Pharmacy = '';
		}

		applyPrimarySecondaryMulti(vm.query.SearchType, swapProp, newPrimeVal, newSecVals);
	}


	/**
	 *    EXCEL
	 *    get file from server
	 */

	function toggleWait(isOn) {
		vm.isWaiting = !!isOn;
		msgSvc.wait(!!isOn);
	}

	function getExcel() {

		// already working?
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		var tab = vm.activeTab,
			q = vm.query,
			prefix = 'Verity-',
			primaryNameClean = utilSvc.regex.cleanFilename(utilSvc.ng.droplistLabel(vm.PrimaryDroplist, vm.query.Primary.val));

		// load up query data
		q.CE.vals = multiselectQueryVals(vm.CeMulti);
		q.Secondary.val = multiselectQueryVals(vm.SecondaryMulti);

		switch(tab) {
			case 'STATS':
				// stats tab has more Excel logic
				getStatsExcel(prefix + primaryNameClean, q);
				return;
			case 'SENTMATCH':
				getSentMatchExcel(tab, q);
				return;
			case 'MATCH':
			case 'SUSPECT':
				getMatchSuspectExcel(tab, prefix + primaryNameClean, q);
				break;
			default:
				throw new Error('matchListCtl.getExcel, unknown active tab: ' + tab);
		}
	}

	function getMatchSuspectExcel(tab, prefix, q) {
		// match/suspect need table rows
		if(vm.tbl.DataItems.length < 1) {
			msgSvc.ok('No Records', 'No records to save for Excel.');
			return;
		}
		var fileName = prefix + (tab == 'SUSPECT' ? '-Suspect-Match.xlsx' : '-Match.xlsx');
		getMatchRepoExcel(tab, q, fileName);
	}

	function getSentMatchExcel(tab, q) {
		// sent match has its own file name format
		var ceid = q.CE.val,
			prefix = 'Verity-SENTMATCH-',
			dateSuffix = '-' + utilSvc.dt.monthShortText(q.StartDate.val) + q.StartDate.val.getFullYear().toString() + '.xlsx',
			fileName = '';

		switch(q.ExternalType) {
			case 'TPA':
				prefix +=  'TPA-';
				fileName = prefix + ceid + dateSuffix;
				break;
			case 'STATEFFS':
				prefix += 'StateMedicaid-';
				fileName = prefix + q.CE.vals[0] + dateSuffix;
				break;
			default:
				throw new Error('matchListCtl.getSentMatchExcel, unknown external type: ' + q.ExternalType);
		}

		// Sent match uses its own sync binary endpoint (reports/tpa/sentmatches/excel),
		// not the async suspect/match export path.
		toggleWait(true);
		_pendingExcelFilename = utilSvc.regex.cleanFilename(fileName);
		matchRepo.getExcel(tab, q, _pendingExcelFilename).then(okServerExcel, errServerExcel);
	}

	function getStatsExcel(prefix, q) {
		// continues on from getExcel, moving this logic so getExcel is less complex

		var fileName = prefix + '-Match-Statistics';

		switch(vm.action) {
			case 'LIST':
				getMatchRepoExcel(vm.activeTab, q, fileName + '.xlsx');
				break;
			case 'COMPARE':
				toggleWait(true);
				_pendingExcelFilename = fileName + '-Comparison.xlsx';
				matchRepo.getStatsExcelCompare(vm.query, _pendingExcelFilename).then(okServerExcel, errServerExcel);
				break;
			case 'TIMESERIES':
				toggleWait(true);
				_pendingExcelFilename = fileName + '-Timeseries.xlsx';
				var ts = vm.ts;
				vm.query.tsxl = {
					type: ts.type,
					subtype: ts.subtype,
					metric: ts.metric,
					interval: ts.interval
				};
				reportRepo.destroyRX();
				reportRepo.destroyCE();
				$timeout(function() {
					// small delay for digest cycle to delete repo memory
					reportRepo.serverExcel('MATCH-TIMESERIES', vm.query, _pendingExcelFilename).then(okServerExcel, errServerExcel);
				}, 300);
				break;
			default:
				msgSvc.ok('Cannot Create Statistics Excel', 'Unknown action: ' + vm.action);
		}
	}

	function getMatchRepoExcel(tab, q, fileName) {
		_pendingExcelFilename = utilSvc.regex.cleanFilename(fileName);
		_excelJobId = null;

		// Build async request for ops/async/create
		var ceVals = [], rxVals = [], tpaVals = [];
		if (q.SearchType == 'TPA') {
			tpaVals = [q.Primary.val];
			rxVals = q.Secondary.val;
		} else if (q.SearchType == 'RXROLLUP') {
			rxVals = q.Secondary.val;
		} else {
			ceVals = q.primeProp == 'CE' ? [q.Primary.val] : q.Secondary.val;
			rxVals = q.primeProp == 'RX' ? [q.Primary.val] : q.Secondary.val;
		}

		var asyncRequest = {
			Context: { CEID: ceVals, RXID: rxVals, TPAID: tpaVals },
			Params: {
				JobType: tab == 'MATCH' ? 'MATCH_EXPORT' : 'SUSPECT_EXPORT',
				Query: matchRepo.buildQueryParams(tab, q)
			}
		};

		// Open popup with loading spinner
		openPopup(null, null, 'EXCEL');

		matchRepo.createAsyncJob(asyncRequest).then(function(entity) {
			if (!entity || !entity.jobId) {
				errSvc.warn('Create Excel Error', 'matchListCtl.getMatchRepoExcel', 'No job Id returned', '');
				closePopup();
				return;
			}
			_excelJobId = entity.jobId;
			_excelPollStartTime = Date.now();
			_pollMatchExcelJob();
		}, errServerExcel);
	}

	function _pollMatchExcelJob() {
		if (!_excelJobId) { 
			return; 
		}
		
		// Check if popup was closed (user chose not to wait)
		if (vm.popup.type !== 'EXCEL') {
			_excelJobId = null;
			_excelPollStartTime = null;
			return;
		}

		// Check if polling has exceeded 20 seconds
		if (_excelPollStartTime && (Date.now() - _excelPollStartTime) > 20000) {
			_excelJobId = null;
			_excelPollStartTime = null;
			// Only show message if popup is still open (user did not close it)
			if (vm.popup.type === 'EXCEL') {
				$scope.$apply(function() {
					closePopup();
					msgSvc.ok('Large File Request', 'This request is taking longer than expected. The file will be available in the "Saved Files" link once it is complete.');
				});
			}
			return;
		}

		opsAsyncRepo.status(_excelJobId).then(function(entity) {
			switch (entity.status) {
				case 'COMPLETE':
					var readyId = _excelJobId;
					_excelJobId = null;
					_excelPollStartTime = null;
					var excelName = (_pendingExcelFilename || 'export').replace(/\.xlsx$/i, '');
					opsAsyncRepo.get(readyId, excelName).then(function() {
						closePopup();
					}, errServerExcel);
					break;
				case 'FAILED':
					_excelJobId = null;
					_excelPollStartTime = null;
					errServerExcel(null);
					break;
				default: // INPROGRESS, PENDING
					_excelPollTimer = setTimeout(_pollMatchExcelJob, 3000);
					break;
			}
		}, errServerExcel);
	}

	function okServerExcel(binaryData) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		// convert binary stream to blob and save
		try {
			var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
			$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
		}
		catch(err) {
			throw(err);
		}
	}

	function errServerExcel(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);
		closePopup();

		if(!!r) {
			errSvc.warn('Create Excel Error', 'matchListCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
		}
	}

	
	/**
	 *    MULTISELECT HELPERS
	 */

	function applyPrimarySecondaryMulti(searchType, primeProp, primeVal, secVals) {

		// setup primary / secondary multiselect based on incoming values

		var q = vm.query,
			affs = getAffs(vm.showInactiveAffs == 'yes');
		secVals = Array.isArray(secVals) ? secVals : [];
		
		// search type determines primary prop logic
		if(searchType == 'TPA') {
			vm.PrimaryDroplist = utilSvc.aff.tpaDroplist(_tpaOptions);
			primeProp = 'CE'; // TPA is primary, force secondary to RX
			q.primeProp = 'CE';
		} else if(searchType == 'RXROLLUP') {
			vm.PrimaryDroplist = vm.RollupDroplist;
			primeProp = 'RXROLLUP';
			q.primeProp = 'RXROLLUP';
		} else if(searchType == 'AFF') {
			primeProp = primeProp == 'CE' || primeProp == 'RX' ? primeProp : 'CE'; // default prime prop to CE for AFF
			vm.PrimaryDroplist = primeProp == 'CE' ? utilSvc.aff.ceDroplist(affs) : utilSvc.aff.rxDroplist(affs);

			// tbd... use a ROLLUP in primary on filter swap
			// match: Verity adds rollups for RX primary
			// if(vm.query.isVerity && vm.activeTab == 'MATCH' && primeProp == 'RX') {
			// 	vm.PrimaryDroplist = ngRxDroplistWithRollups(getAffsWithRollups(affs,searchType,primeProp), true);
			// }
		}
		else {
			vm.PrimaryDroplist = primeProp == 'CE' ? utilSvc.aff.ceDroplist(affs) : utilSvc.aff.rxDroplist(affs);
		}
			
		// primary
		q.primeProp = primeProp;
		q.Primary = utilSvc.ng.droplistAutoselect(vm.PrimaryDroplist, primeVal);
		q.Primary.fail = q.Primary.val == 'NONE' ? 'yes' : 'no';
		q.Primary.name = searchLabel(searchType, primeProp);
		q.Primary.title = q.Primary.fail == 'no' ? utilSvc.ng.droplistLabel(vm.PrimaryDroplist, q.Primary.val) : '';

		// CE Primary - 3 Column View
		if(searchType == 'AFF' && primeProp == 'CE') {
			vm.CeMulti = ceMultiBuildForPrimary(vm.CeMulti, affs, primeVal);
		}

		// secondary (Prog Admin can never be secondary, its only CE/RX)
		var secName = primeProp == 'RX' ? 'Facility' : 'Pharmacy';
		vm.SecondaryMulti.type = primeProp == 'CE' ? 'RX' : 'CE';
		vm.SecondaryMulti.name = secName;
		vm.SecondaryMulti.titleNoOptions = 'Choose a ' + secName;

		// secondary data
		vm.SecondaryMulti.vals = q.Primary.fail == 'no' ? secVals : [];
		vm.SecondaryMulti = multiselectRebuildSecondary(searchType, q.Primary.val, vm.SecondaryMulti, affs, true);
		q.Secondary.fail = vm.SecondaryMulti.vals.length < 1 ? 'yes' : 'no';

		// CE Secondary - 3 Column View
		if(searchType == 'AFF' && primeProp == 'RX') {
			vm.CeMulti = ceMultiRebuildFromSecondary(vm.CeMulti, vm.SecondaryMulti);
		}

	}

	function ceMultiSetup(ceMulti, type, vals, singleValue) {
		ceMulti.type = type;
		ceMulti.singleValue = !!singleValue;

		ceMulti.vals = Array.isArray(vals) ? vals : [];
		ceMulti.list = [];
		ceMulti.filtered = [];
		
		ceMulti.displayName = {
			val: 'CEID',
			lbl: 'Facility Name',
			lbl2: type == 'CE' || type == 'TPA' ? 'Opa ID' : 'State'
		};
		ceMulti.flt = {
			val:'',
			lbl:'',
			lbl2:''
		};
		return ceMulti;
	}

	function ceMultiBuildForPrimary(ceMulti, affs, primeVal) {
		ceMulti = ceMultiSetup(ceMulti, 'CE', primeVal == 'NONE' ? [] : [primeVal], true);
		
		// build custom multi list
		var ceList = utilSvc.aff.ceList(affs),
			ce = {};
		for(var i = 0; i < ceList.length; i++) {
			ce = _ceLookup[ceList[i]];
			if(!!ce) {
				ceMulti.list.push({
					checked: primeVal == ce.Id,
					val: ce.Id,
					lbl: ce.Name,
					lbl2: ce.OpaId
				});
			}
		}
		ceMulti.filtered = ceMulti.list;
		vm.multiselectTitle(ceMulti, true);

		return ceMulti;
	}

	function ceMultiRebuildFromSecondary(ceMulti, secMulti) {
		ceMulti = ceMultiSetup(ceMulti, 'CE', [].concat(secMulti.vals), false);

		// build custom multi list from secondary multi list
		var items = secMulti.list,
			ce = {};
		for(var i = 0; i < items.length; i++) {
			if(i == 0 && items[i].val == 'ALL') {
				ceMulti.list.push({
					checked: items[i].checked,
					val: 'ALL',
					lbl: 'ALL',
					lbl2: 'ALL'
				});
			}
			else {
				ce = _ceLookup[items[i].val];
				if(!!ce) {
					ceMulti.list.push({
						checked: items[i].checked,
						val: ce.Id,
						lbl: ce.Name,
						lbl2: ce.OpaId
					});
				}
			}
		}
		ceMulti.filtered = ceMulti.list;
		vm.multiselectTitle(ceMulti, true);

		return ceMulti;
	}

	function ceMultiBuildForSentMatch(ceMulti, affs, extType, ceid) {
		var isTPA = extType == 'TPA';
		ceid = validSvc.isCE(ceid) ? ceid : '';
		
		// TPA ce options are single value, STATE are multiple
		ceMulti = ceMultiSetup(ceMulti, extType, !!ceid ? [ceid] : [], isTPA);
		
		// build custom multi list
		var ceList = utilSvc.aff.ceList(affs),
			ce = {},
			checked = false,
			checkCount = 0;
		for(var i = 0; i < ceList.length; i++) {
			ce = _ceLookup[ceList[i]];
			if(!!ce) {
				checked = ceid == ce.Id;
				if(checked) {
					checkCount++;
				}
				ceMulti.list.push({
					checked: checked,
					val: ce.Id,
					lbl: ce.Name,
					lbl2: isTPA ? ce.OpaId : ce.State
				});
			}
		}

		// STATEFFS is multiple selection
		if(!isTPA && ceMulti.list.length > 1) {
			var allChecked = checkCount == ceMulti.list.length;
			ceMulti.list.unshift({
				checked: allChecked,
				val: 'ALL',
				lbl: 'ALL',
				lbl2: ''
			});
			if(allChecked) {
				ceMulti.vals = [];
				vm.multiClick(ceMulti, 'ALL');
			}
		}

		ceMulti.filtered = ceMulti.list;
		vm.multiselectTitle(ceMulti, true);

		return ceMulti;
	}

	function getAffsWithRollups(affs, searchType, primeProp, primeVal) {
		// add a rollup aff entry for every RxParent found on an aff

		affs = Array.isArray(affs) ? JSON.parse(JSON.stringify(affs)) : [];
		vm.RollupDroplist = Array.isArray(vm.RollupDroplist) ? vm.RollupDroplist : [];

		// limit affs by search type and primary property
		if((searchType == 'TPA' || searchType == 'AFF') && validSvc.isText(primeProp) && validSvc.isEntity(primeVal)) {
			if(searchType == 'AFF') {
				primeProp = primeProp == 'RX' ? 'RX' : 'CE'; // default to CE
				affs = primeProp == 'CE' ? utilSvc.aff.findCe(affs, primeVal) : utilSvc.aff.findRx(affs, primeVal);
			}
			else {
				affs = utilSvc.aff.findProgAdmin(affs, primeVal);
			}
		}
		
		var uniqueRollups = [],
			result = [],
			rxParentId = '',
			parentLabel = '';

		affs.forEach(function(aff){
			aff.RxShortName = validSvc.isText(aff.RxShortName) ? aff.RxShortName : aff.RXID;
			result.push(aff);
	
			// aff has Parent?
			rxParentId = aff.RxParent;
			if(validSvc.isText(rxParentId) && uniqueRollups.indexOf(rxParentId) < 0) {

				// get rollup label
				parentLabel = utilSvc.ng.droplistLabel(vm.RollupDroplist, rxParentId);
				if(validSvc.isText(parentLabel)) {

					// add rollup to affs
					uniqueRollups.push(rxParentId);
					result.push({
						CEID: '',
						RXID: rxParentId,
						RxShortName: parentLabel,
						RxType: 'ROLLUP'
					});
				}
			}
		});

		return result;
	}

	function ngRxDroplistWithRollups(affs, addPrompt) {
		// convert affs into droplist value/lable format with rollups (adding |ROLLUP to end of RXID)
		affs = Array.isArray(affs) ? affs : [];

		var uniqueRx = [],
			result = [],
			rxid = '';

		affs.forEach(function(aff){
			if(uniqueRx.indexOf(aff.RXID) < 0) {
				uniqueRx.push(aff.RXID);

				// add ROLLUP type to rxid so its not lost, this is stripped off in multiselectVals later
				rxid = aff.RxType == 'ROLLUP' ? aff.RXID + '|ROLLUP' : aff.RXID;
				result.push({
					value: rxid,
					label: validSvc.isText(aff.RxShortName) ? aff.RxShortName : aff.RXID
				});
			}
		});

		result = utilSvc.array.sortTextASC(result,'label');

		if(!!addPrompt) {
			result.unshift({value:'NONE', label:'Choose a Pharmacy'});
		}
		
		return result;
	}

	function ngDroplistToMultiChecklist(ngList, usingALL) {
		// change droplist value/label format into multiselect val/lbl/checked format

		ngList = Array.isArray(ngList) ? ngList : [];

		var result = usingALL ? [{lbl:'ALL', val:'ALL', checked:false}] : [];

		// build multi check list from ng dropdown
		ngList.forEach(function(item){
			result.push({lbl: item.label,val: item.value,checked:false});
		});
		
		return result;
	}

	function multiselectRebuildSecondary(searchType, primaryVal, secondary, affs, usingALL) {

		// rebuild secondary multiselect based on primary value

		usingALL = !!usingALL;

		// primary not valid
		if(!validSvc.isEntity(primaryVal)) {
			secondary.list = [];
			secondary.vals = [];
			vm.multiselectTitle(secondary, true);
			return secondary;
		}

		var secList = [],
			ngListWithRollups = [],
			useRollupsInList = vm.query.isVerity && vm.activeTab == 'MATCH' && (searchType == 'TPA' || searchType == 'AFF') && secondary.type == 'RX';

		// TPA RX or AFF RX - add rollups
		if(useRollupsInList) {
			ngListWithRollups = ngRxDroplistWithRollups(getAffsWithRollups(affs, searchType, 'CE', primaryVal));
			ngListWithRollups.forEach(function(item){
				secList.push(item.value);
			});
		}
		// tbd... ROLLUP IS PRIMARY
		// else if(useRollupsInList && secondary.type == 'CE' && primaryVal.indexOf('|ROLLUP') > -1) {
		// 	// this is a rollup primary, find affs with this Rx Parent
		// 	var rollupId = primaryVal.substr(0, primaryVal.indexOf('|ROLLUP'));
		// 	secList = utilSvc.aff.ceList(utilSvc.aff.findRxParent(affs, rollupId));
		// }
		else if (searchType == 'TPA') {
			secList = utilSvc.aff.rxOptionsByTPA(affs, primaryVal);
		} 
		else if(searchType == 'RXROLLUP') {
			secList = utilSvc.aff.rxOptionsByRollup(affs, primaryVal);
		}
		else {
			secList = secondary.type == 'RX' ? utilSvc.aff.rxOptions(affs, primaryVal) : utilSvc.aff.ceOptions(affs, primaryVal);
		}
		
		// adjust vals, they need to be in list options
		var vals = secondary.vals,
			newVals = [];

		if(vals.length === 1 && vals[0] == 'ALL') {
			newVals = ['ALL'];
			usingALL = true;
		}
		else {
			// add new val only if it exists in new secList
			for(var i = 0; i < vals.length; i++) {
				if(secList.indexOf(vals[i]) > -1) {
					newVals.push(vals[i]);
				}
			}
		}
		if(usingALL && secList.length > 1) {
			secList.unshift('ALL');
		}

		// build multi checklist
		if(secondary.type == 'RX') {
			secondary.list = useRollupsInList ? ngDroplistToMultiChecklist(ngListWithRollups, usingALL && secList.length > 1) : vm.multiselectBuildRX(secList, false, affs);
		}
		else {
			secondary.list = vm.multiselectBuild(secList, false);
		}

		// assign vals
		if((!usingALL && secList.length === newVals.length) || (usingALL && ((newVals.length > 0 && newVals[0] == 'ALL') || secList.length - 1 === newVals.length))) {
			// all vals are checked
			secondary.vals = [];
			vm.multiselectClick(secondary, 'ALL');
		}
		else {
			vm.multiselectReturnVisit(secondary, '', newVals);
		}

		// set secondary title
		vm.multiselectTitle(secondary, true);

		return secondary;

	}

	function multiselectQueryVals(multiselect) {

		// unpack the vals multiselect into a list of entities to query

		var checklist = multiselect.list,
			vals = multiselect.vals,
			result = [];

		if(vals.length < 1) {
			return [];
		}
		else if(vals.length === 1 && vals[0] == 'ALL') {
			// using ALL checkbox, return all values except ALL checkbox
			var i = checklist[0].val == 'ALL' ? 1 : 0;
			for(i; i < checklist.length; i++) {
				result.push(checklist[i].val);
			}
		}
		else {
			result = JSON.parse(JSON.stringify(vals)); // de-ref
		}

		// this is NOT a secondary multiselect with ROLLUPS
		var st = vm.query.SearchType,
			primaryVal = vm.query.Primary.val;
		if(vm.activeTab != 'MATCH' || multiselect.type != 'RX' || (st != 'TPA' && st != 'AFF') || !validSvc.isText(primaryVal) || !valsHaveRollup(result)) {
			return result;
		}

		// expand vals with ROLLUPS into pharmacies
		return valsWithRollups(result, st, primaryVal, multiselect);
	}

	function valsHaveRollup(vals) {
		vals = Array.isArray(vals) ? vals : [];
		for(var i = 0; i < vals.length; i++) {
			if(vals[i].indexOf('|ROLLUP')) {
				return true;
			}
		}
		return false;
	}

	function valsWithRollups(vals, st, primeVal, multiselect) {
		// expand vals with ROLLUPS into pharmacies

		var affs = getAffs(vm.showInactiveAffs == 'yes');
		affs = st == 'AFF' ? utilSvc.aff.findCe(affs, primeVal) : utilSvc.aff.findProgAdmin(affs, primeVal);
		
		// loop RX vals, expand rollups
		var subIdx = -1,
			childrenRX = [],
			result = [];
		vals.forEach(function(rxid){
			subIdx = rxid.indexOf('|ROLLUP');

			// not a rollup, must be unique val
			if(subIdx < 0) {
				if(result.indexOf(rxid) < 0) {
					result.push(rxid);
				}
			}
			else {
				// get list of rxids from affs with this RxParent
				childrenRX = utilSvc.aff.rxList(utilSvc.aff.findRxParent(affs, rxid.substr(0,subIdx)));
				childrenRX.forEach(function(childRXID){
					if(result.indexOf(childRXID) < 0) {
						result.push(childRXID);
					}
				});
			}
		});

		return result;
	}

	function multiClick(propName, val) {
		// only secondary is Multi, primary is singular droplist
		queryChange();

		var multiPropName = propName + 'Multi';
		var multi = vm[multiPropName];

		// MATCH / SUSPECT CeMulti
		if(multiPropName == 'CeMulti') {
			if(vm.SecondaryMulti.type == 'RX') {
				// CeMulti is Primary single selection
				vm.multiselectReturnVisit(multi, '', [val]);
				vm.multiselectTitle(multi, true);
				multi.show = false;
				var primary = vm.query.Primary;
				primary.fail = 'no';
				primary.val = val;
				queryChangePrimary();
			}
			else {
				// CeMulti is Secondary multi-select
				vm.multiselectClick(multi, val);
				vm.multiselectTitle(multi, true);
				vm.SecondaryMulti.vals = [].concat(multi.vals); // de-ref
				vm.query.Secondary.fail = multi.vals.length < 1 ? 'yes' : 'no';
			}
		}
		else if(multiPropName == 'EvalRxMulti') {
			vm.multiselectClick(multi, val);
			vm.multiselectTitle(multi, true);
			vm.query.RX.fail = multi.vals.length < 1 ? 'yes' : 'no';
			vm.affsIncludeFacilitySentMatches = false;
			vm.query.IncludeFacilitySentMatches = false;
			var rx = multiselectQueryVals(vm.EvalRxMulti);
			for (var j = 0; j < rx.length; j++) {
				for (var i = 0; i < _affsAllowFacilitySentMatches.length; i++) {
					if (_affsAllowFacilitySentMatches[i] == rx[j]) {
						vm.affsIncludeFacilitySentMatches = true;
						break;
					}
				}
				if (vm.affsIncludeFacilitySentMatches) {
					break;
				}
			}
		}
		else {
			// all other multiselects are secondary
			vm.multiselectClick(multi, val);
			vm.multiselectTitle(multi, true);
			vm.query.Secondary.fail = multi.vals.length < 1 ? 'yes' : 'no';
		}
	}

	function multiClickSentMatch(val) {
		if(vm.isWaiting || vm.activeTab != 'SENTMATCH') {
			return;
		}
		queryChange();

		var multi = vm.CeMulti,
			q = vm.query,
			isTPA = q.ExternalType == 'TPA';

		if(isTPA) {
			vm.multiselectReturnVisit(multi, '', [val]);
			vm.multiselectTitle(multi, true);
			multi.show = false;
			q.CE = sentMatchMultiToCeProp(multi, q);
			queryChangeCE();
		}
		else {
			vm.multiselectClick(multi, val);
			vm.multiselectTitle(multi, true);
			q.CE = sentMatchMultiToCeProp(multi, q);
		}
	}

	function sentMatchMultiToCeProp(multi, q) {
		switch(q.ExternalType) {
			case 'TPA':
				q.CE.val = multi.vals.length > 0 ? multi.vals[0] : '';
				q.CE.fail = !!q.CE.val ? 'no' : 'yes';
				break;
			case 'STATEFFS':
				q.CE.vals = multiselectQueryVals(multi);
				q.CE.fail = q.CE.vals.length < 1 ? 'yes' : 'no';
				break;
			default:
				throw new Error('sentMatchMultiToCeProp: unknown ExternalType: ' + q.ExternalType);
		}

		return q.CE;
	}

	function multiToggle(evt, propName, elemId) {

		// show / hide multiselect list

		var multi = vm[propName];
		multi.flt = propName == 'CeMulti' ? {} : '';

		// hide multi list
		if(multi.show) {
			multi.show = false;
			return;
		}

		// re-load CeMulti filtered
		if(propName == 'CeMulti') {
			multi.filtered = multi.list;
		}

		// show with minimum width
		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(elemId + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		elemId += vm.activeTab == 'SENTMATCH' ? 'SentMatch' : ''; // SENTMATCH ceMulti has different element id
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(elemId);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multi.show = true;

		// set focus on CeMulti filter
		if(propName == 'CeMulti' && multi.list.length > 1) {
			$timeout(function(){
				try {
					var inputElem = document.getElementById(elemId + 'Find');
					if(!!inputElem) {
						inputElem.focus();
						inputElem.setSelectionRange(0,9999);
					}
					inputElem = null;
				}
				catch(err) {
					// do nothing
				}
			},300);
		}
	}

	function multiHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}


	/**
	 *    MATCH STATS COMPARISON
	 */

	function compareToggle() {
		// turn compare display on/off

		if(vm.action == 'COMPAREQUERY' || vm.action == 'COMPARE') {
			// toggle off
			vm.compare.Data = {};
			vm.action = 'LIST';
		}
		else {
			// toggle on
			vm.compare.DateRangeValid = false;

			// setup Compare dates based on query mode
			var compareKeepDates = false;
			switch(vm.query.DateRangeMode) {

				case 'MONTHLY':
					// default to previous month from query
					vm.compare.DateRangeMode = 'MONTHLY';
					compareKeepDates = true;
					vm.query.CompareStartDate.val = utilSvc.dt.addMonths(utilSvc.dt.monthStart(vm.query.StartDate.val), -1);
					vm.query.CompareEndDate.val = utilSvc.dt.monthEnd(vm.query.CompareStartDate.val);
					break;

				case 'MTD':
					vm.compare.DateRangeMode = 'LMTD';
					break;

				case 'QTD':
					vm.compare.DateRangeMode = 'LQTD';
					break;

				case 'QTDLAST':
				case 'QTR':
					vm.compare.DateRangeMode = 'QTR';
					break;

				case 'YTD':
					vm.compare.DateRangeMode = 'LYTD';
					break;

				case 'LTM':
					vm.compare.DateRangeMode = 'LLTM';
					break;

				case 'YEARLY':
					vm.compare.DateRangeMode = 'YEARLY';
					break;

				default:
					alert('reportCtl.compareToggle, unsupported query date mode for comparison: ' + vm.query.DateRangeMode);
					return;
			}

			$timeout(function() {
				// note: date mode change event will advance UI to action = COMPARE
				$scope.$broadcast('widget.input.date.range.mode', {uniqueId: 'compareDates', mode: vm.compare.DateRangeMode, keepDates: compareKeepDates});
			}, 100);

		}
	}

	function compareLoadData() {

		if(vm.isWaiting) {
			return;
		}

		// dates are valid?
		if(!vm.compare.DateRangeValid) {
			msgSvc.ok('Summary Compare', 'Check date values.');
			vm.action = 'COMPAREQUERY';
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true, true);

		matchRepo.getStatsSummary(vm.query, true).then(okCompData, errCompData);

		function okCompData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.compare.Data = matchStatsVM(r);
			vm.action = 'COMPARE';
		}

		function errCompData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Error loading match stats compare', 'matchListCtl.compareLoadData', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}


	/**
	 * 	MATCH STATS TIMESERIES
	 */

	function timeseriesVM() {

		var defaultType = 'AGGREGATE',
			defaultInterval = 'MONTH';

		return {
			dirty: false,
			type: '',
			subtype: '',
			action: 'LOAD',
			metric: '',
			interval: '',
			prefs: {
				type: defaultType,
				subtype: 'DISP',
				metric: 'Dispenses',
				interval: defaultInterval,
				flt: {}
			},
			colHeaders: [],
			data: []
		};
	}

	function initTimeSeriesDroplist() {
		return [
			// disp stats
			{value:'Dispenses', label:'Dispense - Evaluated', fmt: 'integer', subtype: 'DISP'},
			{value:'DispensesNotMatched', label:'Dispense - Not Matched', fmt: 'integer', subtype: 'DISP'},
			{value:'NewMatchedDispenses', label:'Match - New Matches', fmt: 'integer', subtype: 'DISP'},
			{value:'NewEligibleDispenses', label:'Match - New Eligible Dispenses', fmt: 'integer', subtype: 'DISP'},

			// match stats
			{value:'AcceptedSuspects', label:'Match - New Matches Accepted from Suspect', fmt: 'integer', subtype: 'DISP'},
			{value:'ProviderFiltered', label:'Match - Date Not Eligible', fmt: 'integer', subtype: 'DISP'},
			{value:'MedicaidFiltered', label:'Match - Medicaid Not Eligible', fmt: 'integer', subtype: 'DISP'},
			{value:'VisitProximityFiltered', label:'Match - Written Date Not Eligible', fmt: 'integer', subtype: 'DISP'},
			{value:'NpiProximityFiltered', label:'Match - NPI Written Date Not Eligible', fmt: 'integer', subtype: 'DISP'},
			{value:'BlockedScriptFiltered', label:'Match - Reject Script Not Eligible', fmt: 'integer', subtype: 'DISP'},
			{value:'ErxNpiFiltered', label:'Match - ePrescribe NPI Not Eligible', fmt: 'integer', subtype: 'DISP'},
			{value:'LocationFiltered', label:'Match - Patient Location Not Eligible', fmt: 'integer', subtype: 'DISP'},
			{value:'MiscFiltered', label:'Match - Misc Not Eligible', fmt: 'integer', subtype: 'DISP'},
			{value:'ReversedMatches', label:'Match - Reversed Matches', fmt: 'integer', subtype: 'DISP'},

			// match ratios
			{value:'MatchedRatio', label:'Ratio - Matched Dispenses', fmt: 'integer', subtype: 'DISP'},
			{value:'EligibleDispensesRatio', label:'Ratio - Eligible Dispenses', fmt: 'integer', subtype: 'DISP'},
			{value:'EligibleMatchesRatio', label:'Ratio - Eligible Matches', fmt: 'integer', subtype: 'DISP'}
		];
	}

	function tsReset() {

		var ts = vm.ts;

		// save prefs if dirty
		if(!!ts.dirty && !!ts.prefs) {
			sessionRepo.set('ts-match-stats', ts.prefs);
		}

		ts.dirty = false;
		ts.action = '';
		ts.colHeaders = [];
		ts.data = [];

		$scope.$broadcast('widget.timeseries');
	}

	function tsToggle() {

		// toggle time series display on/off

		if(vm.action == 'TIMESERIES') {
			tsReset();
			vm.action = 'LIST';
		}
		else {
			// toggle on
			vm.tsMetricDroplist = initTimeSeriesDroplist();
			vm.ts = timeseriesVM();

			// get timeseries viewstate
			var vs = sessionRepo.get('ts-match-stats');
			if(!!vs) {
				vm.ts.prefs = vs;
			}

			// move pref properties for easier html bind
			var prefs = vm.ts.prefs;
			vm.ts.type = prefs.type;
			vm.ts.subtype = prefs.subtype;
			vm.ts.interval = prefs.interval;
			vm.ts.metric = prefs.metric;

			vm.action = 'TIMESERIES';

			$timeout(function() {
				tsLoadData();
			}, 200);

		}
	}

	function tsQueryVM(q, secondary) {
		return {
			CE: {vals: [q.Primary.val]},
			RX: {vals: multiselectQueryVals(secondary)},
			StartDate: {val: q.StartDate.val},
			EndDate: {val: q.EndDate.val}
		};
	}

	function tsLoadData() {

		if(vm.isWaiting) {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true, true);

		var tsQuery = tsQueryVM(vm.query, vm.SecondaryMulti);
		reportRepo.getTimeseries('MATCH', vm.ts, tsQuery).then(okTsData, errTsData);

		function okTsData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.ts = tsParseData(r, vm.ts);
			if(vm.ts.action != 'NODATA') {

				switch(vm.ts.type) {
					case 'AGGREGATE':
						tsLoadAggregate();
						break;
					case 'METRIC':
						tsChangeMetric();
						break;
					default:
						alert('matchListCtl.tsLoadData, uknown timeseries type: ' + vm.ts.type);
						tsReset();
						vm.action = 'LIST';
				}
			}

		}

		function errTsData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Error loading contract time series for  ' + _tsReportType, 'report.loadTimeSeries', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}

	function tsGetMetricInfo(metric) {

		// find metric formats (they are overloaded into droplist array)

		var items = vm.tsMetricDroplist;
		for(var i = 0; i < items.length; i++) {
			if(items[i].value == metric) {
				return items[i];
			}
		}

		alert('matchListCtl.tsGetMetricInfo, metric: ' + metric + ' not found for report type: ' + _tsReportType);
		return {};

	}

	function tsGetColumnHeaders(series, isQuarterly) {

		// pre-build column config (once per data load)

		var cols = [],
			dtSeg = [],
			mth = 0,
			day = 0,
			colTitle = '',
			months = utilSvc.ng.monthShortDroplist();

		// 1st column is always title
		cols.push({
			id: 'title',
			title: 'Affiliation',
			width: '120px',
			sort: true,
			flt: undefined,
			fltType: 'Text'
		});

		// loop series to pre-format column labels
		series = Array.isArray(series) ? series : [];
		for(var i = 0; i < series.length; i++) {

			// get fmt from "yyyy-mm-dd" to "MMM dd"
			dtSeg = series[i].Date.split('-');
			mth = parseInt(dtSeg[1]) - 1; // month list is zero based
			mth = months[mth].label;
			day = parseInt(dtSeg[2]);
			day = day.toString();

			if(isQuarterly) {
				colTitle = displayQuarter(new Date(dtSeg[0], dtSeg[1] - 1, 0));
			}
			else {
				colTitle = mth + ' ' + day;
			}

			cols.push({
				id: 'id' + dtSeg.join('_'),
				mth: mth,
				day: day,
				title: colTitle,
				width: '40px',
				sort: true,
				flt: undefined,
				fltType: 'Numbers'
			});
		}

		return cols;

	}

	function tsParseData(data, ts) {

		// parse api data into timeseries cached VM
		// cached VM holds pre-calculated columns / filters, etc

		ts.action = '';
		ts.colHeaders = [];
		ts.data = [];

		// no data
		var affs = Array.isArray(data) ? data : [];
		if(affs.length < 1 || !Array.isArray(affs[0].Series) || affs[0].Series.length < 1) {
			ts.action = 'NODATA';
			return ts;
		}

		var aff = {},
			dataRow ={},
			affSeries = [];

		ts.colHeaders = tsGetColumnHeaders(affs[0].Series, ts.interval == 'QUARTER');

		// parse api data into timeseries pre-format
		var isFIN = ts.subtype == 'FIN';

		for(var i = 0; i < affs.length; i++) {
			aff = affs[i];

			dataRow = {
				id: i,
				title: aff.CEID + ' / ' + aff.Pharmacy,
				series: []
			};

			// loop series, convert api summary data into VM
			affSeries = Array.isArray(aff.Series) ? aff.Series : [];
			for(var ii = 0; ii < affSeries.length; ii++) {
				if(isFIN) {
					dataRow.series.push(affSeries[ii].Summary);
				}
				else {
					// dispense stats
					dataRow.series.push(affSeries[ii].Stats);
				}
			}

			ts.data.push(dataRow);
		}

		return ts;

	}

	function tsChangeType() {

		// switch the timeseries display type

		if(vm.isWaiting || vm.action != 'TIMESERIES') {
			return;
		}

		// switch type
		vm.ts.dirty = true;
		vm.ts.prefs.type = vm.ts.type;
		vm.ts.prefs.subtype = vm.ts.subtype;

		// reset all data, load again
		tsReset();
		$timeout(function() {
			tsLoadData();
		}, 200);

	}

	function tsChangeInterval() {

		// switch the timeseries time interval
		// note: requires another data pull

		if(vm.isWaiting || vm.action != 'TIMESERIES') {
			return;
		}

		// switch interval
		vm.ts.dirty = true;
		vm.ts.prefs.interval = vm.ts.interval;
		tsReset();

		vm.ts.action = 'LOAD';

		$timeout(function() {
			tsLoadData();
		}, 200);

	}

	function tsChangeMetric() {

		// switch the timeseries metric, re-gen widget data

		if(vm.isWaiting || vm.action != 'TIMESERIES') {
			return;
		}

		var ts = vm.ts;

		// metric titles
		var colHeaders = vm.ts.colHeaders;
		colHeaders[0].title = 'Affiliation';

		// switch metric
		ts.dirty = true;
		ts.prefs.metric = ts.metric;
		var metricProp = ts.metric;

		// get details of this metric
		var metricInfo = tsGetMetricInfo(ts.metric);
		var metricFmt = metricInfo.fmt,
			metricSubtype = metricInfo.subtype;

		// requires new data if metric is from another sub-type
		var subtypeSame = ts.subtype == metricSubtype;
		ts.subtype = metricSubtype;
		if(!subtypeSame) {
			tsLoadData();
			return;
		}

		// refresh widget table rows / chart series
		var widgetRows = [],
			dataRows = ts.data,
			row = {},
			dataSeries = [],
			metricVal = 0,
			cid = '';

		// create data rows for this metric
		// note: rows are objects so angular can use filter/sort
		for(var i = 0; i < dataRows.length; i++) {

			row = {
				id: dataRows[i].id,
				title: dataRows[i].title,
				selected: false
			};

			dataSeries = dataRows[i].series;
			for(var ii = 0; ii < dataSeries.length; ii++) {
				cid = colHeaders[ii+1].id;

				// metric value
				metricVal = dataSeries[ii][metricProp];
				if(typeof(metricVal) === 'undefined') {
					metricVal = 0;
				}
				row[cid] = metricVal;

				// metric format in text
				row[cid + 'txt'] = tsFormatMetricValue(metricVal, metricFmt);
			}

			widgetRows.push(row);
		}

		ts.action = 'SHOW';

		// notify widget to render
		var fltKey = ts.type + ts.interval;
		$scope.$broadcast('widget.timeseries', {
			data: {
				uniqueId: 'match-series',
				interval: ts.interval,
				table: {
					show: true,
					colHeaders: colHeaders,
					rows: widgetRows,
					flt: ts.prefs.flt[fltKey]
				},
				chart: {
					show: true,
					id: 'match-series-chart',
					config: {
						colors: appConst.app.color.chartBars($window.espuiPrefs.skin),
						xAxis: {
							showText: true
						},
						yAxis: {
							showText: true,
							format: metricFmt
						}
					}
				}
			}
		});

	}

	function tsFormatMetricValue(val, fmt) {

		// convert metric number into final text

		switch(fmt) {
			case 'currency':
				return  numberFmt(val, '0', '$', 2);
			case 'number':
				return numberFmt(val, '0', '', 2);
			case 'integer':
				return numberFmt(val, '0', '', 0);
			default:
				alert('metric format unknown: ' + fmt);
				return val;
		}
	}

	function tsLoadAggregate() {

		// derive timeseries widget dataset for aggregate totals
		// note: aggregate means total of all affiliations per property for each time period

		if(vm.isWaiting || vm.action != 'TIMESERIES' || vm.ts.type != 'AGGREGATE') {
			return;
		}

		var ts = vm.ts,
			tsSubtype = vm.ts.subtype;

		// aggregate titles
		var colHeaders = vm.ts.colHeaders;
		colHeaders[0].title = 'Line Item';

		ts.dirty = true;

		// refresh widget table rows / chart series
		var props = [],
			prop = {},
			propName = '',
			propVal = 0,
			widgetRows = [],
			row = {},
			dataSeries = [],
			cid = '';

		// check aggregate should have only 1 row
		if(ts.data.length !== 1) {
			alert('matchListCtl.tsLoadAggregate, data rows should be length 1 only');
			tsReset();
			vm.action = 'LIST';
			return;
		}
		dataSeries = ts.data[0].series;
		props = vm.tsMetricDroplist;

		// create widget info iterating selectable properties from drop down
		// note: rows are objects so angular can use filter/sort
		for(var i = 0; i < props.length; i++) {
			prop = props[i];

			// agg props have a sub-type, render props with the same sub-type chosen by user
			if(prop.subtype == tsSubtype) {
				propName = prop.value; // value in droplist is the viewmodel property name
				row = {
					id: propName,
					title: prop.label,
					selected: false
				};

				for(var ii = 0; ii < dataSeries.length; ii++) {
					cid = colHeaders[ii+1].id;

					// prop value
					propVal = dataSeries[ii][propName];
					if(typeof(propVal) === 'undefined') {
						propVal = 0;
					}
					row[cid] = propVal;

					// prop val format in text
					row[cid + 'txt'] = tsFormatMetricValue(propVal, prop.fmt);
				}

				widgetRows.push(row);
			}
		}

		ts.action = 'SHOW';

		// notify widget to render
		var fltKey = ts.type + ts.interval;
		$scope.$broadcast('widget.timeseries', {
			data: {
				uniqueId: 'match-series',
				interval: vm.ts.interval,
				table: {
					show: true,
					colHeaders: colHeaders,
					rows: widgetRows,
					flt: ts.prefs.flt[fltKey]
				},
				chart: {
					show: true,
					id: 'match-series-chart',
					config: {
						colors: appConst.app.color.chartBars($window.espuiPrefs.skin),
						xAxis: {
							showText: true
						},
						yAxis: {
							showText: true,
							format: 'number'
						}
					}
				}
			}
		});

	}


	/**
	 *    HELPERS
	 */

	function saveViewState(tab, query) {

		// update dates
		_tabInfo[tab] = {
			query: {
				DateType: query.DateType,
				DateRangeMode: query.DateRangeMode,
				DateRangeChk: !!query.DateRangeChk,
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val
			},
			flt: vm.flt
		};

		// remember major tab queries only
		if(tab == 'MATCH' || tab == 'SUSPECT' || tab == 'STATS') {
			var tabQuery = _tabInfo[tab].query;

			tabQuery.SearchType = query.SearchType;
			tabQuery.primeProp = query.primeProp;
			tabQuery.Primary = query.Primary.val;
			tabQuery.Secondary = multiselectQueryVals(vm.SecondaryMulti);

			// STATS only uses primary / secondary
			if(tab == 'STATS') {
				_tabInfo[tab].query = tabQuery;
			}
			else {
				// match/suspect use dyna props and sync their primary / secondary
				tabQuery = saveDynaQueryToViewState(query, tabQuery);
				_tabInfo[tab].query = tabQuery;

				var syncTab = tab == 'MATCH' ? 'SUSPECT' : 'MATCH';
				if(query.SearchType == 'AFF' && _tabInfo[syncTab].query.SearchType == 'AFF') {
					_tabInfo[syncTab].query.primeProp = tabQuery.primeProp;
					_tabInfo[syncTab].query.Primary = tabQuery.Primary;

					// Verity can use ROLLUPS in secondary, do not sync match to suspect secondary
					if(!query.isVerity || syncTab != 'SUSPECT') {
						_tabInfo[syncTab].query.Secondary = tabQuery.Secondary;
					}
				}
			}
		}
		else if(tab == 'EVAL') {
			_tabInfo[tab].query = {
				CE: query.CE.val
			};
		}

		var isMatchOrSuspect = tab == 'MATCH' || tab == 'SUSPECT';
		sessionRepo.set('vs-ops-match-list', {
			activeTab: tab,
			tabInfo: _tabInfo,
			showInactiveAffs: isMatchOrSuspect ? vm.showInactiveAffs : 'no'
		});

	}

	function saveDynaQueryToViewState(query, tabQuery) {

		// add all conditional dyna query properties to viewstate

		if(query.EncounterNumber.chk) {
			tabQuery.EncounterNumber = query.EncounterNumber.val;
			tabQuery.EncounterNumberChk = true;
		}
		if(query.RxNumber.chk) {
			tabQuery.RxNumber = query.RxNumber.val;
			tabQuery.RxNumberChk = true;
		}
		if(query.ItemCode.chk) {
			tabQuery.ItemCode = query.ItemCode.val;
			tabQuery.ItemCodeChk = true;
		}

		if(query.PrescriberIdent.chk) {
			tabQuery.PrescriberIdent = query.PrescriberIdent.val;
			tabQuery.PrescriberIdentChk = true;
		}
		if(query.SuspectType.chk) {
			tabQuery.SuspectType = query.SuspectType.val;
			tabQuery.SuspectTypeChk = true;
		}
		if(query.DrugType.chk) {
			tabQuery.DrugType = query.DrugType.val;
			tabQuery.DrugTypeChk = true;
		}
		if(query.TotalAmountPaid.chk) {
			tabQuery.TotalAmountPaid = query.TotalAmountPaid.val;
			tabQuery.TotalAmountPaidChk = true;
		}

		if(query.PatientLN.chk) {
			tabQuery.PatientLN = query.PatientLN.val;
			tabQuery.PatientLNChk = true;
		}
		if(query.Location.chk && validSvc.isText(query.Location.val)) {
			tabQuery.Location = query.Location.val.toUpperCase();
			tabQuery.LocationChk = true;
		}
		if(query.Eligible.chk) {
			tabQuery.Eligible = query.Eligible.val;
			tabQuery.EligibleReason = query.Eligible.reason;
			tabQuery.EligibleOverrideOK = query.Eligible.overrideOK;
			tabQuery.EligibleOverrideHist = query.Eligible.overrideHist;
			tabQuery.EligibleOverrideReason = query.Eligible.overrideReason;
			tabQuery.EligibleBlockHistory = query.Eligible.blockhistory;
			tabQuery.EligibleChk = true;
			if(query.Allocation.chk) {
				tabQuery.Allocation = query.Allocation.val;
				tabQuery.AllocationChk = true;
			} 
		} else {
			query.Allocation.chk = false;
		}
		if(query.MatchType.chk) {
			tabQuery.MatchType = query.MatchType.val;
			tabQuery.MatchTypeChk = true;
		}
		if(query.CashCard.chk) {
			tabQuery.CashCard = query.CashCard.val;
			tabQuery.CashCardChk = true;
		}
		if(query.Referral.chk) {
			tabQuery.Referral = query.Referral.val;
			tabQuery.ReferralChk = true;
		}
		if(query.Orderable.chk) {
			tabQuery.Orderable = query.Orderable.val;
			tabQuery.OrderableChk = true;
		}
		if(query.EstimatePricing.chk) {
			tabQuery.EstimatePricing = query.EstimatePricing.val;
			tabQuery.EstimatePricingChk = true;
		}
		if(query.RestrictedManufacturer.chk) {
			tabQuery.RestrictedManufacturer = query.RestrictedManufacturer.val;
			tabQuery.RestrictedManufacturerChk = true;
		}
		if(query.IRA.chk) {
			tabQuery.IRA = query.IRA.val;
			tabQuery.IRAChk = true;
		}
		if(query.Rebate.chk) {
			tabQuery.Rebate = query.Rebate.val;
			tabQuery.RebateChk = true;
		}

		return tabQuery;
	}

	function tabToTitle(tabName) {
		switch(tabName) {
			case 'MATCH':
				return 'Matched';
			case 'SUSPECT':
				return 'Suspects';
			default:
				return '';
		}
	}

	function ndcCleanUp(val, skipEmpty) {

		var zeroPad = "00000000000",
			ndcTest = '';

		// must be text
		if(!!!skipEmpty && !validSvc.isText(val)) {
			return validSvc.newProp(val, true, 'required');
		}

		// remove all non-numeric characters
		ndcTest = val.toString().trim();
		ndcTest = ndcTest.replace(/[^0-9]+/g,'');

		// empty
		if(ndcTest.length < 1) {
			if(!!skipEmpty) {
				return validSvc.newProp('', false, '');
			}
			else {
				return validSvc.newProp(ndcTest, true, 'empty');
			}
		}

		// max len
		if(ndcTest.length > 11) {
			return validSvc.newProp(ndcTest, true, 'max 11 characters');
		}

		// integer
		var intVal = parseInt(ndcTest);
		if(!validSvc.isInteger(intVal)) {
			return validSvc.newProp(ndcTest, true, 'must be an integer');
		}

		// all zeros
		if(intVal <= 0) {
			return validSvc.newProp(ndcTest, true, 'cannot be zero');
		}

		// pad zeros if needed, pass
		ndcTest = zeroPad.substr(0, 11 - ndcTest.length) + ndcTest;
		return validSvc.newProp(ndcTest, false, '');
	}

	function numberFmt(val, zeroFmt, prefix, decPlaces) {

		// helper to format incoming number data

		// nan
		if(!validSvc.isNumber(val)) {
			return '';
		}

		// zero
		if(val === 0) {
			return zeroFmt;
		}

		return prefix + utilSvc.str.toText($filter('number')(val, decPlaces));
	}

	function numberFmtNoPrefix(val, zeroFmt, decPlaces) {

		// api controls the sign

		// nan
		if(!validSvc.isNumber(val)) {
			return '';
		}

		// prefix is only controled by value
		if(val < 0) {
			return numberFmt(Math.abs(val), zeroFmt,'-', decPlaces); // neg
		}
		else {
			return numberFmt(val, zeroFmt,'', decPlaces); // pos, no sign
		}
	}

	function displayQuarter(dt) {

		// return Q1, Q2 text from incoming date

		if(!validSvc.isDate(dt)) {
			return '';
		}

		var qtrNum = Math.floor(dt.getMonth() / 3) + 1;
		return 'Q' + qtrNum + ' ' + dt.getFullYear().toString();

	}

	function displayQuarterMonths(dtStart, dtEnd, useUpperCase) {

		// return 'MMM through MMM' text for this quarter

		if(!validSvc.isDate(dtStart) || !validSvc.isDate(dtEnd)) {
			return '';
		}

		if(!!useUpperCase) {
			return utilSvc.dt.monthShortText(dtStart).toUpperCase() + ' through ' + utilSvc.dt.monthShortText(dtEnd).toUpperCase();
		}
		else {
			return utilSvc.dt.monthShortText(dtStart) + ' through ' + utilSvc.dt.monthShortText(dtEnd);
		}

	}

	function searchLabel(searchType, primeProp) {
		if(searchType == 'TPA') {
			return 'Program Admin';
		}
		else if(primeProp == 'RXROLLUP') {
			return 'Pharmacy Rollup';
		}
		else if(primeProp == 'CE') {
			return 'Facility';
		}
		else if(primeProp == 'RX') {
			return 'Pharmacy';
		}  
		return ''; // leave this to catch missing query state
	}

}
 
matchSuspectCtl.$inject = ['$scope', '$state', '$timeout', '$filter', 'matchRepo', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc', 'appConst'];
angular
.module('espui.ops')
.controller('MatchSuspectCtl', matchSuspectCtl);


/* @ngInject */
function matchSuspectCtl($scope, $state, $timeout, $filter, matchRepo, validSvc, errSvc, utilSvc, msgSvc, appConst) {

	/*jshint validthis: true */
	var vm = this,
		_pendingEdit = {};

	// inherit sorting and paging features
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);

	// properties
	vm.isWaiting = false;
	vm.action = '';

	// models
	vm.context = {};
	vm.model = {};

	// next/back buttons
	vm.btnFWD = false;
	vm.btnBack = false;
	vm.goNext = goNext;

	// accept / reject
	vm.visitAccept = visitAccept;
	vm.visitReject = visitReject;
	vm.visitRejectAll = visitRejectAll;

	// eligible droplist reference
	vm.EligibleDroplist = [];

	// GPI popup
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;


	/**
	 *    INIT
	 */

	init();

	function init() {

		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		// set context
		var ctx = $state.params;
		if(!!!ctx || !Array.isArray(ctx.Items) || ctx.Items.length < 1 || !validSvc.isNumber(ctx.Idx)) {
			throw new Error('match.repo.getSuspect, CE, Items and Idx are required');
		}
		vm.context = ctx;

		// user has edit rights
		vm.context.canEdit = utilSvc.user.hasFeature($scope, 'ops.match.edit');

		// reference list for user friendly names
		vm.EligibleDroplist = [
			{label: 'All Reasons', value: 'INELIGIBLE'},
			{label: 'CONTRACT DATE', value:'INELIGIBLE-REASON_CONTRACT_DATE'},
			{label: 'ERX NPI', value:'INELIGIBLE-EPRESCRIBE_NPI'},
			{label: 'EXCLUDED PAYOR NDC', value:'INELIGIBLE-EXCLUDED_PAYOR_NDC'},
			{label: 'GOV MEDICAID', value:'INELIGIBLE-GOV_MEDICAID'},
			{label: 'INVALID MATCH', value:'UNMATCHED-INVALID_MATCH'},
			{label: 'IN REVIEW', value:'INELIGIBLE-INREVIEW'},
			{label: 'LOCATION', value:'INELIGIBLE-PATIENT_LOCATION'},
			{label: 'MCO MEDICAID', value:'INELIGIBLE-EXCLUDED_PAYOR'},
			{label: 'NPI BLOCKED', value:'INELIGIBLE-NPI_REVIEW_BLOCK'},
			{label: 'NPI FLOATING', value:'INELIGIBLE-NPI_REVIEW_FLOAT'},
			{label: 'NPI PROXIMITY', value:'INELIGIBLE-NPI_PROXIMITY'},
			{label: 'NPI REFERRAL', value:'INELIGIBLE-NPI_REVIEW_REFERRAL'},
			{label: 'OPA DATE', value:'INELIGIBLE-CE_OPA_STARTDATE'},
			{label: 'REMATCHED', value:'UNMATCHED-WEAKMATCH'},
			{label: 'REVERSED', value:'REVERSED'},
			{label: 'TPA REJECTED', value:'INELIGIBLE-TPA_REJECTED'},
			{label: 'UNMATCHED', value:'UNMATCHED'},
			{label: 'VISIT PROXIMITY', value:'INELIGIBLE-VISIT_PROXIMITY'},
			{label: 'VISIT REVERSED', value:'UNMATCHED-INVALID_VISIT'},
			{label: 'MFR RESTRICT', value:'INELIGIBLE-MFR_RESTRICT'},
			{label: 'MFR AGED', value:'INELIGIBLE-MFR_AGED'},
			{label: 'NPI PERIOD', value:'UNMATCHED-NPIPERIOD'},
			{label: 'NPI INACTIVE', value:'UNMATCHED-NPIINACTIVE'},
		];


		vm.action = '';
		getSuspect(ctx);

	}


	/**
	 *    DISPLAY VIEW MODELS
	 */

	function claimVM(data) {

		data = data || {};

		data.EligibleTxt = data.Eligible == 'YES' ? 'YES' : 'NO';
		data.OverrideTxt = !!data.EligOverride ? 'YES' : 'NO';

		// state reason txt
		data.StateReasons = Array.isArray(data.StateReasons) ? data.StateReasons : [];
		if(data.StateReasons.length === 1) {
			data.ReasonTxt = userFriendlyReasonText(data.State, data.StateReasons[0]);
		}
		else if(data.StateReasons.length > 1) {
			data.ReasonTxt = 'MULTIPLE';
		}
		else {
			data.ReasonTxt = '';
		}

		data.PatientDOB = utilSvc.dt.fromServerString(data.PatientDOB);

		return data;
	}

	function displayVM(data) {

		data = claimVM(data);

		// suspects list
		var items = Array.isArray(data.SuspectVisits) ? data.SuspectVisits : [],
			item = {};

		for(var i = 0; i < items.length; i++) {
			item = items[i];
			item.EligibleTxt = item.Eligible == 'YES' ? 'YES' : 'NO';

			// user friendly State Reason
			item.StateReasons = Array.isArray(item.StateReasons) ? item.StateReasons : [];
			for(var ii = 0; ii < item.StateReasons.length; ii++) {
				item.StateReasons[ii] = userFriendlyReasonText(item.State, item.StateReasons[ii]);
			}
			item.ReasonTxt = item.StateReasons.join(', ');

			// GPI NDC list
			item.GPI = validSvc.isText(item.GPI) ? item.GPI : '';
			item.ReferenceItems = Array.isArray(item.ReferenceItems) ? item.ReferenceItems : [];

			item.Erx = !!item.Eprescribe ? 'YES' : 'NO';
			item.OverrideTxt = !!item.EligOverride ? 'YES' : 'NO';
		}
		data.SuspectVisits = items;

		data.Paging = {
			Page: 1,
			Size: $scope.tblPagingSize,
			Total: vm.getTotalPages(items.length, $scope.tblPagingSize)
		};

		data.SortBy = ['-EncounterDate'];

		return data;

	}


	/**
	 *    GET DETAIL
	 */

	function getSuspect(ctx) {

		vm.isWaiting = true;
		msgSvc.wait(true);
		vm.action = '';

		// each item can have a different CEID/RXID
		ctx.CE = ctx.Items[ctx.Idx].CEID;
		ctx.RX = ctx.Items[ctx.Idx].RXID;
		ctx.RxShortName = utilSvc.aff.rxShortNameById($scope.User.AffList, ctx.RX);

		matchRepo.getSuspect(
			ctx.CE,
			ctx.RX,
			ctx.Items[ctx.Idx].SuspectType,
			ctx.Items[ctx.Idx].DispId
		).then(okSuspect, errSuspect);

		function okSuspect(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.model = displayVM(r);

			// fwd/back buttons
			vm.btnFWD = vm.context.Idx + 1 < vm.context.Items.length;
			vm.btnBack = vm.context.Idx > 0;

			// suspects exist?
			if(vm.model.SuspectVisits.length > 0) {
				vm.action = 'DETAIL';
			}
			else {
				msgSvc.ok('No Suspects', 'No suspects exist for this RX number. Accepting another fill may have cleared all suspects for this RX number.');
			}
		}

		function errSuspect(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Suspect Match Get Error for: ' + vm.context.CE, 'matchSuspectCtl.getSuspect.errSuspect', r.status, utilSvc.http.safeResponse(r));
			}
			$state.go('ops.match', {}, {reload: 'ops.match'});
		}

	}


	/**
	 *    BACK / FWD
	 */

	function goNext(increment) {

		if(vm.isWaiting) {
			return;
		}
		vm.popup = {};

		// increment idx
		vm.context.Idx += increment;

		getSuspect(vm.context);

	}


	/**
	 *    ACCEPT/REJECT
	 */

	function visitAccept(item) {
  
		if(vm.isWaiting) {
			return;
		}

		if(!!!item || !validSvc.isText(item.SuspectId)) {
			throw new Error('matchSuspectCtl.visitAccept, SuspectId required');
		}

		// override and accept
		if(item.OverrideTxt == 'YES') {
			_pendingEdit = {
				action: 'accept-override',
				id: item.SuspectId,
        		ceid: item.CEID,
				ReplaceVisitId: '',
				Override: false,
				title: 'Confirm Accept And Override',
				msg: 'Accept and override reasons: ' + item.ReasonTxt + '?'
			};
		}
		else {
			_pendingEdit = {
				action: 'accept',
				id: item.SuspectId,
				ReplaceVisitId: '',
				Override: false,
				title: 'Confirm Accept',
				msg: 'Accept encounter dated: ' + $filter('date')(item.EncounterDate, 'M/d/yyyy') + '?'
			};

		}

		promptUser();

	}

	function visitReject(item) {

		if(vm.isWaiting) {
			return;
		}

		if(!!!item || !validSvc.isText(item.SuspectId)) {
			throw new Error('matchSuspectCtl.visitReject, SuspectId required');
		}

		_pendingEdit = {
			action: 'reject',
			id: item.SuspectId,
			title: 'Confirm Reject',
			msg: 'Reject encounter dated: ' + $filter('date')(item.EncounterDate, 'M/d/yyyy') + '?'
		};

		promptUser();

	}

	function visitRejectAll() {

		if(vm.isWaiting) {
			return;
		}

		if(vm.context.Idx < 0 || vm.context.Items.length < 1 || vm.context.Idx > vm.context.Items.length - 1) {
			throw new Error('matchSuspectCtl.visitRejectAll, context.Items required to get SuspectType and DispId');
		}

		_pendingEdit = {
			action: 'rejectall',
			title: 'Confirm Reject All',
			msg: 'Reject all encounters?'
		};

		promptUser();

	}


	/**
	 *    SHARED ACCEPT/REJECT HANDLERS
	 */

	function promptUser() {

		var notes = null;

		// accept prompts for a note
		if(_pendingEdit.action == 'accept' || _pendingEdit.action == 'accept-override') {
			notes =  {
				prompt: 'optional notes',
				maxlength: 150,
				out: ''
			};
		}

		// customize buttons for accept override scenario
		var btns = [
			{text:'CANCEL', result:'CANCEL', cancel: true}
		];

		if(_pendingEdit.action == 'accept-override') {
			btns.unshift({text:'ACCEPT AND OVERRIDE', result:'OVERRIDE', cancel: false});
		}
		else {
			btns.unshift({text:'OK', result:'YES', cancel: false});
		}

		msgSvc.confirm({
			id: 'ops.suspect.acceptreject',
			title: _pendingEdit.title,
			msg: _pendingEdit.msg,
			notes: notes,
			buttons: btns
		}).then(userConfirm, userConfirm);

	}

	function userConfirm(r) {

		// async delegate handler for OK to delete message box

		// build context
		var ctx = {};

		// user said yes
		if(!!r && r.result === 'YES' || r.result==='OVERRIDE') {
			vm.isWaiting = true;
			msgSvc.wait(true);

			switch(_pendingEdit.action) {

				case 'accept':
				case 'accept-replacevisit':
				case 'accept-override':
					matchRepo.visitAccept(vm.context.CE, _pendingEdit.id, validSvc.isText(r.notes) ? r.notes : '', _pendingEdit.ReplaceVisitId, r.result == 'OVERRIDE').then(okHandler, errHandler);
					break;

				case 'reject':
					matchRepo.visitReject(_pendingEdit.id, validSvc.isText(r.notes) ? r.notes : '').then(okHandler, errHandler);
					break;

				case 'rejectall':
					matchRepo.visitRejectAll({
						CE: vm.context.CE,
						RX: vm.context.RX,
						SuspectType: vm.context.Items[vm.context.Idx].SuspectType,
						Id: vm.context.Items[vm.context.Idx].DispId,
						Notes: validSvc.isText(r.notes) ? r.notes : ''
					}).then(okHandler, errHandler);
					break;

				default:
					throw new Error('matchSuspectCtl.userConfirm, unknown pending edit action: ' + _pendingEdit.action);
			}

		}
		else {
			_pendingEdit = null;
		}

	}

	function okHandler(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		var msg = '';
		switch(_pendingEdit.action) {
			case 'rejectall':
				msg = 'All Encounters Rejected';
				break;
			case 'accept':
				msg = 'Encounter Accepted';
				break;
			case 'accept-replacevisit':
				msg = 'Encounter Replaced';
				break;
			case 'accept-override':
				msg = 'Encounter Accepted and Overridden to Eligible';
				break;
			case 'reject':
				msg = 'Encounter Rejected';
				break;
		}

		// show user confirmation message
		msgSvc.okAsync(_pendingEdit.title, msg, 'ops.suspect.acceptreject.done').then(acceptrejectCleanUp, acceptrejectCleanUp);

	}

	function errHandler(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		if(!!!r) {
			// already handled
		}
		else if(r.status === 422) {

			// visit replacement?
			if(validSvc.isText(r.ReplaceVisitId)) {
				_pendingEdit.action = 'accept-replacevisit';
				_pendingEdit.ReplaceVisitId = r.ReplaceVisitId;
				_pendingEdit.title = 'Confirm Visit Replacement';
				_pendingEdit.msg = 'Another visit has already been accepted for this RX number. Confirm this visit suspect will be replaced.';
				promptUser();
				return;
			}

			// unknown 422 error
			msgSvc.ok(_pendingEdit.action.toUpperCase() + ' ERROR', r.invalidReason);
		}
		else {
			// unknown error
			errSvc.warn('Unknown error during accept / reject', 'matchSuspectCtl.' + _pendingEdit.action, r.status, utilSvc.http.safeResponse(r));
			$state.go('ops.match', {}, {reload: 'ops.match'});
		}

	}

	function acceptrejectCleanUp() {

		// remove suspect, advance to next if it exists

		if(_pendingEdit.action == 'rejectall' ||
			_pendingEdit.action == 'accept' ||
			_pendingEdit.action == 'accept-replacevisit' ||
			_pendingEdit.action == 'accept-override' ||
			(_pendingEdit.action == 'reject' && vm.model.SuspectVisits.length == 1)) {

			// remove from suspect
			vm.context.Items.splice(vm.context.Idx, 1);

			// no other suspects?
			if(vm.context.Items.length < 1) {
				$state.go('ops.match', {}, {reload: 'ops.match'});
				return;
			}

			// adjust idx if it exceeds upper bounds
			if(vm.context.Items.length - 1 < vm.context.Idx) {
				vm.context.Idx = vm.context.Items.length - 1;
			}

			_pendingEdit = null;
			getSuspect(vm.context);

		}
		else if(_pendingEdit.action == 'reject') {

			// only 1 encounter rejected, remove it
			var visits = vm.model.SuspectVisits,
				foundVisit = true;

			for(var i = 0; i < visits.length; i++) {
				if(visits[i].SuspectId == _pendingEdit.id) {
					visits.splice(i, 1);
					foundVisit = true;
				}
			}

			if(!foundVisit) {
				throw new Error('matchSuspectCtl.acceptrejectCleanUp, action reject did not find visit id: ' + _pendingEdit.id);
			}

			_pendingEdit = null;

		}
		else {
			throw new Error('matchSuspectCtl.acceptrejectCleanUp, unknown action state: ' + _pendingEdit.action);
		}

	}

	/**
	 *    POPUP
	 */

	function openPopup(evt, item) {

		if(vm.isWaiting) {
			return;
		}

		vm.popup = {
			ready: false,
			GPI: item.GPI,
			GpiRefItems: item.ReferenceItems
		};

		// loop html element parents to calculate top offset
		var offsetY = -50,
			elem = evt.target;
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
				break;
			}

			// add offset, get next element
			offsetY += elem.offsetTop;
			elem = elem.offsetParent;
		}
		elem = null;

		// move popup to clicked row
		var popup = document.getElementById('matchSuspectPopupContent');
		if(!!popup) {
			popup.style.top = offsetY.toString() + 'px';
		}

		// wait for digest before showing
		$timeout(function() {
			vm.popup.ready = true;
		}, 100);

	}

	function closePopup() {
		vm.popup = {};
	}


	/**
	 *    HELPERS
	 */

	function userFriendlyReasonText(apiState, apiStateReason) {

		// convert api state + reason into user friendly text
		if(validSvc.isText(apiStateReason)) {
			apiStateReason = apiStateReasonDisplayTxt(apiStateReason);
		}
		
		switch(apiState) {

			case 'REVERSED':
				return apiState;

			case 'UNMATCHED':
				if(validSvc.isText(apiStateReason)) {
					return utilSvc.ng.droplistLabel(vm.EligibleDroplist, 'UNMATCHED-' + apiStateReason);
				}
				return 'UNMATCHED';

			case 'INELIGIBLE':
				if(validSvc.isText(apiStateReason)) {
					var eligTxt = utilSvc.ng.droplistLabel(vm.EligibleDroplist, 'INELIGIBLE-' + apiStateReason);
					if(validSvc.isText(eligTxt)) {
						return eligTxt;
					}
					return apiStateReason; // show state reason if it is not a searchable state reason
				}
				return ''; // hide INELIGIBLE state with no state reason

			default:
				return '';
		}

	}


	function apiStateReasonDisplayTxt(apiStateReason) {

		switch(apiStateReason) {
			case 'IRA_RESTRICT':
				return 'IRA RESTRICT';
			case 'MFR_REBATE':
				return 'MFR REBATE';
			case 'IRA_NO_PROFIT':
				return 'IRA NO PROFIT';
			default:
				return apiStateReason;
		}

	}

}
 
ndcMainEditCtl.$inject = ['$window', '$scope', '$state', '$timeout', 'ndcRepo', 'lookupRepo', 'utilSvc', 'validSvc', 'msgSvc', 'errSvc'];angular
.module('espui.ops')
.controller('NdcMainEditCtl', ndcMainEditCtl);

/* @ngInject */
function ndcMainEditCtl($window, $scope, $state, $timeout, ndcRepo, lookupRepo,  utilSvc, validSvc, msgSvc, errSvc) {

	// private props
	var _featureName = '',
		_pagingEventListener = null,
		_fileImportListener = null,
		_ndcAutoSearch = null,
		_affsWithInfo = [],
		_globalItems = [],
		_globalNdcMap = null,
		_cloneToAccounts = [],
		_cloneToPharmacy = [];
	var vm = this;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addTableViews(vm);

	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.context = {};
	vm.StatusDroplist = [];
	vm.AccountTypeDroplist = [];
	
	// tbl and filters
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;
			
	// editing (all editing done inside popup)
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;
	vm.rowClick = rowClick;
	vm.save = save;
	vm.toggleStatus = toggleStatus;

	// return to parent
	vm.exit = exit;

	// table view
	vm.tblViewConfig = {};
	vm.tblView = {};

	// ndc and alt ndc auto search
	vm.ndcInput = undefined;
	vm.ndcDesc = {};
	vm.altNdcInput = undefined;
	vm.altNdcDesc = {};

	// excel / file import
	vm.getExcel = getExcel;
	vm.importSelectedFiles =[];
	vm.importFile = importFile;
	// Add year options for Global IRA upload
	vm.importYearOptions = [2026, 2027, 2028, 2029];

	// clone
	vm.cloneToggleItem = cloneToggleItem;
	vm.cloneToggleList = cloneToggleList;
	vm.cloneStart = cloneStart;
	vm.cloneStop = cloneStop;


	/**
	 *    EVENTS
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// used by list and clone to list
		if(evtData.uniqueId == 'NDC_CLONE') {
			// exit if popup is gone
			if(!!!vm.popup || vm.popup.type != 'CLONE' || !vm.popup.flt.Ready || !Array.isArray(vm.popup.Items) || vm.popup.Items.length < 1) {
				return;
			}
			vm.popup.flt[evtData.propName] = parseInt(evtData.value);
		}
		else {
			// exit if table is gone
			if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
				return;
			}
			vm.flt[evtData.propName] = parseInt(evtData.value);
		}
		filterChange(true);
	});

	_ndcAutoSearch = $scope.$on('widget.ndc.auto.search', function(event, evtData) {
		event.stopPropagation();
		evtData = evtData || {};
		var ndc = evtData.ndc || {};

		// update model
		if(!!vm.popup && (vm.popup.action == 'ADD' || vm.popup.action == 'UPDATE')) {

			var propName = evtData.id,
				ndcDesc = evtData.state == 'FOUND' ? ndc.Description : '';
			switch (propName) {
				case 'ItemCode':
					vm.ndcDesc = {
						status: evtData.state,
						desc: ndcDesc
					};
					break;
				case 'AltItemCode':
					vm.altNdcDesc = {
						status: evtData.state,
						desc: ndcDesc
					};
					break;
				default:
					throw new Error('ndcEdit.auto.search.event, unknown ndc widget id: ' + propName);
			}

			// update property
			vm.popup[propName].val = ndc.ItemCode;
			var fltVal = typeof(ndc.ItemCode) === 'undefined' ? '' : ndc.ItemCode; // set filter to '', not undefined
			setTableFilter(propName, fltVal);
			filterChange(true);
		}
	});

	_fileImportListener = $scope.$on('widget.input.file', function(event, importInfo) {
		event.stopPropagation();

		if(!!importInfo && !!importInfo.files && importInfo.files.length > 0) {
			vm.importSelectedFiles = importInfo.files;
		}
		else {
			vm.importSelectedFiles = [];
		}
	});

	$scope.$on('$destroy', function() {
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
		if(!!_ndcAutoSearch) {
			_ndcAutoSearch();
		}
		if(!!_fileImportListener) {
			_fileImportListener();
		}
		if(!!vm && !!vm.tbl) {
			vm.tbl = listVM();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {
		_featureName = $state.current.name;
		_affsWithInfo = [];

		vm.init = true;

		// params
		var params = $state.params || {};

		
		// setup context / filter / tblview columns based on list type
		vm.context = initContextAndTableView($scope.User, params);

		// setup table view (this is done once, there are no saved multiple views)
		vm.tblViewConfig = tblViewConfigVM(vm.context.tblOptions);
		vm.tblView = vm.tblViewInit(vm.tblViewConfig);
		vm.tblView = vm.tblViewLoadTitlesAndFilters(vm.tblViewConfig, vm.tblView);

		// default status to ACTIVE'
		var statusOptions = ['ACTIVE', 'INACTIVE'];
		if(vm.context.tblOptions.useGlobalColumn) {
			statusOptions.push('GLOBAL');
		}
		vm.StatusDroplist = utilSvc.ng.droplist(statusOptions,'','',[{label:'ALL', value:''}]);
		setTableFilter('ObjectState', 'ACTIVE');

		// reporting properties droplists for Global Exclusion
		if(vm.context.editReportingProps) {
			vm.ReportingPlatformDroplist = utilSvc.ng.droplist(['ESP', 'Truzo'],'','',[{label:'', value:''}]);
			vm.ReportTypeDroplist = utilSvc.ng.droplist(['Pharmacy', 'Medical', 'Both'],'','',[{label:'', value:''}]);
		}

		vm.flt = initFilter(vm.context.tblOptions);

		getList();
	}

	function initContextAndTableView(usr, params) {
		// all variable query, table and editing is set in this function

		var isVerity = usr.Type == 'VERITY' || usr.Type == 'VERITYSA';
		var isVeritySA = usr.Type == 'VERITYSA',
			isCeUser = usr.Type == 'CE';

		var title = '',
			hasCE = validSvc.isCE(params.CE),
			hasRX = validSvc.isRX(params.RX),
			hasVEN = validSvc.isVEN(params.VEN),
			editGPI = false,
			editAltItemCode = false,
			editMargin = false,
			editDispenseFee = false,
			editCeilingPrice = false,
			ndcInactivePairsOk = false,
			cloneToRX = false,
			cloneToVEN = false,
			editAutoIneligibleDays = false,
			editReportingProps = false;
		
		// dynamic table columns are controlled by these options
		var tblOptions = { 
			ndcSectionTitle: 'NDC',
			ItemCodeTitle: 'NDC',
			GPITitle: 'GPI',
			DescriptionTitle: 'Item Description',
			ManufacturerTitle: 'Manufacturer',
			hasMedispanTxt: false,
			useGlobalColumn: false,
			useCreatedByColumn:true,
			altSectionTitle: '',
			altColumns: []
		};

		// edit permission
		var hasEditClaim = utilSvc.user.hasFeature($scope, 'ops.centralndc.edit');
		var canEdit = hasEditClaim;
		if(canEdit && isCeUser && !!!params.CeVerityPrimary) {
			// ce user cannot edit non-Verity Primary CEs
			canEdit = false;
		}

		var canAdd = canEdit,
			canStatus = canEdit,
			canImport = canEdit,
			canExcel = true,
			canClone = false,
			listScope = '';

		// main switch statement to handle all dynamic columns, properties by ndc list type
		switch(params.ListKey) {
			case 'GLOBAL_EXCLUSION':
				listScope = 'GLOBAL';
				title = 'Global Exclusion List';
				canAdd = isVeritySA;
				canStatus = isVeritySA;
				canImport = isVeritySA;
				editAutoIneligibleDays = true;
				editReportingProps = true;
				tblOptions.useCreatedByColumn = isVerity;
				tblOptions.altSectionTitle = 'PROPERTIES';
				tblOptions.altColumns.push({flt:'Text', name:'AutoIneligibleDays', colWidth:'45px', title:'Auto Ineligible Days', desc:''});
				tblOptions.altColumns.push({flt:'Text', name:'ReportingPlatform', colWidth:'50px', title:'Reporting Platform', desc:''});
				tblOptions.altColumns.push({flt:'Text', name:'ReportType', colWidth:'50px', title:'Report Type', desc:''});
				break;
			case 'GLOBAL_OUTER_PACK':
				listScope = 'GLOBAL';	
				title = 'Global Inner/Outer Pack';
				tblOptions.ndcSectionTitle = 'INNER PACK';
				tblOptions.useCreatedByColumn = isVerity;
				canImport = false;
				canAdd = isVeritySA;
				canStatus = isVeritySA;
				canImport = isVeritySA;

				// outer pack ndc columns
				editAltItemCode = true;
				ndcInactivePairsOk = true; // primary ndc can appear more than once if dupe is inactive
				tblOptions.altSectionTitle = 'OUTER PACK';
				tblOptions.altColumns.push({flt:'Text', name:'AltItemCode', colWidth:'45px', title:'NDC', desc:''});
				tblOptions.altColumns.push({flt:'Text', name:'AltDesc', colWidth:'80px', title:'Item Description', desc:''});
				tblOptions.altColumns.push({flt:'Text', name:'AltMfg', colWidth:'60px', title:'Manufacturer', desc:''});
				break;
			case 'AFF_OUTER_PACK':
				listScope = 'AFF';
				title = params.CE + ' / ' + params.RX + ' - Affiliation Inner/Outer Pack';
				tblOptions.ndcSectionTitle = 'INNER PACK';
				tblOptions.useGlobalColumn = true;
				canAdd = false;
				canImport = false;
				canClone = canEdit;
				cloneToRX = true;
				editAltItemCode = true; // need this to save model, there is no editing UI but repo uses this setting

				// outer pack ndc columns
				tblOptions.altSectionTitle = 'OUTER PACK';
				tblOptions.altColumns.push({flt:'Text', name:'AltItemCode', colWidth:'45px', title:'NDC', desc:''});
				tblOptions.altColumns.push({flt:'Text', name:'AltDesc', colWidth:'80px', title:'Item Description', desc:''});
				tblOptions.altColumns.push({flt:'Text', name:'AltMfg', colWidth:'60px', title:'Manufacturer', desc:''});
				break;
			case 'GLOBAL_IRA':
				listScope = 'GLOBAL';
				title = 'Global IRA';
				canAdd = false;
				canStatus = false;
				canImport = isVeritySA;

				// contract year column
				tblOptions.altSectionTitle = 'Contract Year';
				tblOptions.altColumns.push({flt:'Text', name:'MFPYearText', colWidth:'45px', title:'Year', desc:''});
				break;
			case 'AFF_IRA':
				listScope = 'AFF';
				title = params.CE + ' / ' + params.RX + ' - Affiliation IRA Opt-Out';
				tblOptions.useGlobalColumn = true;
				canAdd = false;
				canImport = false;
				canClone = canEdit;
				cloneToRX = true;

				// contract year column
				tblOptions.altSectionTitle = 'Contract Year';
				tblOptions.altColumns.push({flt:'Text', name:'MFPYearText', colWidth:'45px', title:'Year', desc:''});
				break;
			case 'GLOBAL_REB':
				listScope = 'GLOBAL';
				title = 'Global Manufacturer Rebate';
				canAdd = isVeritySA;
				canStatus = isVeritySA;
				canImport = isVeritySA;
				break;
			case 'AFF_REB':
				listScope = 'AFF';
				title = params.CE + ' / ' + params.RX + ' - Affiliation Manufacturer Rebate Opt-In';
				tblOptions.useGlobalColumn = true;
				canAdd = false;
				canImport = false;
				canClone = canEdit;
				cloneToRX = true;
				break;
			case 'NON_340B':
				listScope = 'CE';
				// ce required
				if(!hasCE) {
					throw new Error('ndcEdit.initContext, ce required for list type: ' + params.ListKey);
				}
				title = params.CE + ' - Non 340B Drugs';
				canClone = canEdit;
				break;
			case 'CE_PRICE':
				listScope = 'CE';
				// ce required
				if(!hasCE) {
					throw new Error('ndcEdit.initContext, ce required for list type: ' + params.ListKey);
				}
				title = params.CE + ' - 340B Ceiling Price';
				canClone = canEdit;
				editCeilingPrice = canEdit;
				break;
			case 'OWNUSE_ALT':
				listScope = 'AFF';
				// ce required
				if(!hasCE) {
					throw new Error('ndcEdit.initContext, ce required for list type: ' + params.ListKey);
				}
				title = params.CE + ' / ' + params.RX + ' - Affiliation Own Use Alternate Drugs';
				canImport = false;
				canClone = canEdit;
				cloneToRX = true;
				editGPI = false;
				editAltItemCode = true;
				ndcInactivePairsOk = true; // primary ndc can appear more than once if dupe is inactive
				tblOptions.altSectionTitle = 'ALTERNATE';
				tblOptions.altColumns.push({flt:'Text', name:'AltItemCode', colWidth:'45px', title:'NDC', desc:''});
				tblOptions.altColumns.push({flt:'Text', name:'AltDesc', colWidth:'80px', title:'Item Description', desc:''});
				break;
			case '340B_ALT':
				listScope = 'AFF';
				if(!hasCE) {
					throw new Error('ndcEdit.initContext, ce required for list type: ' + params.ListKey);
				}
				title = params.CE + ' / ' + params.RX + ' - Affiliation 340B Alternate Drugs';
				canImport = false;
				canClone = canEdit;
				cloneToRX = true;
				editGPI = false;
				editAltItemCode = true;
				ndcInactivePairsOk = true; // allow inactive pairs; backend only enforces one ACTIVE pair per original NDC
				tblOptions.altSectionTitle = 'ALTERNATE';
				tblOptions.altColumns.push({flt:'Text', name:'AltItemCode', colWidth:'45px', title:'NDC', desc:''});
				tblOptions.altColumns.push({flt:'Text', name:'AltDesc', colWidth:'80px', title:'Item Description', desc:''});
				break;
			case 'AFF_ORDER_EXCLUSION':
				listScope = 'AFF';
				title = params.CE + ' / ' + params.RX + ' - Affiliation Order Exclusion Drugs';
				canClone = canEdit;
				cloneToRX = true;
				break;
			case 'RX_ORDER_EXCLUSION':
				listScope = 'RX';
				title = params.RX + ' - Pharmacy Order Exclusion Drugs';
				canEdit = hasEditClaim;
				canAdd = canEdit;
				canStatus = canEdit;
				canImport = canEdit;
				canClone = canEdit;
				cloneToRX = true;
				break;
			case 'VERISAVE_NEVER_SWITCH_FROM':
				listScope = 'AFF';
				title = params.CE + ' / ' + params.RX + ' - Affiliation Verisave Never Switch From';
				canClone = canEdit;
				cloneToRX = true;
				break;
			case 'VERISAVE_NEVER_SWITCH_FROM_RX':
				listScope = 'RX';
				title = params.RX + ' - Pharmacy Verisave Never Switch From';
				canEdit = hasEditClaim; // RX scope lists do not depend on Verity is Primary
				canAdd = canEdit;
				canStatus = canEdit;
				canImport = canEdit;			
				canClone = canEdit;
				cloneToRX = true;
				break;
			case 'VERISAVE_NEVER_SWITCH_TO':
				listScope = 'AFF';
				title = params.CE + '/' + params.RX + ' - Affiliation Verisave Never Switch To';
				canClone = canEdit;
				cloneToRX = true;
				break;
			case 'VERISAVE_NEVER_SWITCH_TO_RX':
				listScope = 'RX';
				title = params.RX + ' - Pharmacy Verisave Never Switch To';
				canEdit = hasEditClaim; // RX scope lists do not depend on Verity is Primary
				canAdd = canEdit;
				canStatus = canEdit;
				canImport = canEdit;			
				canClone = canEdit;
				cloneToRX = true;
				break;
			case 'VERISAVE_PREF':
				listScope = 'AFF';
				title = params.CE + '/' + params.RX + ' - Affiliation Verisave Preferred';
				canClone = canEdit;
				cloneToRX = true;
				editMargin = true;
				vm.AccountTypeDroplist = initAccountTypeDroplist(params.ListKey);
				break;	
			case 'VERISAVE_PREF_RX':
				listScope = 'RX';
				title = params.RX + ' - Pharmacy Verisave Preferred';
				canEdit = hasEditClaim; // RX scope lists do not depend on Verity is Primary
				canAdd = canEdit;
				canStatus = canEdit;
				canImport = canEdit;			
				canClone = canEdit;
				cloneToRX = true;
				editMargin = true;
				vm.AccountTypeDroplist = initAccountTypeDroplist(params.ListKey);
				break;
			case 'MATCH_REVIEW_INCLUSION':
				listScope = 'AFF';
				title = params.CE + '/' + params.RX + ' - Affiliation Match Review Inclusion';
				canClone = canEdit;
				cloneToRX = true;
				break;
			case 'MATCH_EXCLUSION':
				listScope = 'AFF';
				title = params.CE + '/' + params.RX + ' - Affiliation Match Exclusion';
				canClone = canEdit;
				cloneToRX = true;
				break;	
			case 'DISPENSE_FEE':
				listScope = 'AFF';
				title = params.CE + '/' + params.RX + ' - Affiliation Dispense Fee';
				cloneToRX = true;
				editDispenseFee = true;
				// editing is Verity only
				canAdd = canEdit && isVerity;
				canStatus = canEdit && isVerity;
				canImport = canEdit && isVerity;
				canClone = canEdit && isVerity;
				break;
			case 'ALWAYS_SPLIT':
			case 'NEVER_SPLIT':
				listScope = 'OA';
				title = params.ListKey == 'ALWAYS_SPLIT' ? 'Vendor Account Always' : 'Vendor Account Never';
				title = params.CE + '/' + params.RX + '/' + params.VenTitle + ' - ' + title + ' Split';
				canClone = canEdit;
				cloneToRX = true;
				cloneToVEN = true;
				break;
			case 'ALWAYS_ORDER':
			case 'NEVER_ORDER':
				listScope = 'OA';
				title = params.ListKey == 'ALWAYS_ORDER' ? 'Vendor Account Always' : 'Vendor Account Never';
				title = params.CE + '/' + params.RX + '/' + params.VenTitle + ' - ' + title + ' Order';
				canClone = canEdit && isVerity;
				canAdd = canEdit && isVerity;
				canStatus = canEdit && isVerity;
				canImport = canEdit && isVerity;
				cloneToRX = true;
				cloneToVEN = true;
				break;
			case 'ISP_ORDER':
				listScope = 'ISP';
				title = params.ListKey == 'ISP order';
				title = params.CE + '/' + params.RX + '/' + params.VenTitle + ' - ' + title;
				canClone = canEdit && isVerity;
				canAdd = canEdit && isVerity;
				canStatus = canEdit && isVerity;
				canImport = canEdit && isVerity;
				cloneToRX = true;
				cloneToVEN = true;
				break;
			case 'NDC_OPTIMIZER_NDC_EXCLUSION':
				listScope = 'RX';
				title = params.RX + ' - NDC Optimizer NDC Exclusion';
				canEdit = hasEditClaim;
				canAdd = canEdit;
				canStatus = canEdit;
				canImport = canEdit;			
				canClone = canEdit;
				cloneToRX = true;
				break;
			case 'NDC_OPTIMIZER_GPI_EXCLUSION':
				listScope = 'RX';
				title = params.RX + ' - NDC Optimizer GPI Exclusion';
				tblOptions.ndcSectionTitle = 'GPI';
				canEdit = hasEditClaim;
				canAdd = canEdit;
				canStatus = canEdit;
				canImport = canEdit;
				canClone = canEdit;
				cloneToRX = true;
				editGPI = true;
				break;
			case 'NDC_OPTIMIZER_GPI_INCLUSION':
				listScope = 'RX';
				title = params.RX + ' - NDC Optimizer GPI Inclusion';
				tblOptions.ndcSectionTitle = 'GPI';
				canEdit = hasEditClaim;
				canAdd = canEdit;
				canStatus = canEdit;
				canImport = canEdit;
				canClone = canEdit;
				cloneToRX = true;
				editGPI = true;
				break;
			case 'CENTRAL_FILL':
				listScope = 'RX';
				title = params.RX + ' - Central Fill NDC List';
				canEdit = hasEditClaim;
				canAdd = canEdit;
				canStatus = canEdit;
				canImport = canEdit;
				break;
			case 'GENERIC_RX':
				listScope = 'RX';
				title = params.RX + ' - GENERIC NDC List';
				canEdit = hasEditClaim;
				canAdd = canEdit;
				canStatus = canEdit;
				break;
			case 'SPECIALTY_RX':
				listScope = 'RX';
				title = params.RX + ' - Specialty NDC List';
				canEdit = hasEditClaim;
				canAdd = canEdit;
				canStatus = canEdit;
				break;
			case 'TPA_EXCLUSION':
				listScope = 'RX';
				title = params.RX + ' - TPA Exclusion NDC List';
				canEdit = hasEditClaim;
				canAdd = canEdit;
				canStatus = canEdit;
				break;
			default:
				throw new Error('ndcEdit.initContextAndTableView, unknown list key: ' + params.ListKey); 
		}
		
		return {
			isDirty: false,
			isVerity: isVerity,
			isCeUser: isCeUser,
			title: title,
			key: params.ListKey,
			listScope: listScope,
			EntityId: params.EntityId,
			CE: hasCE? params.CE : '',
			RX: hasRX? params.RX : '',
			VEN: hasVEN? params.VEN : '',
			VenTitle: params.VenTitle,
			editGPI: editGPI,
			editMargin: editMargin,
			editAltItemCode: editAltItemCode,
			editDispenseFee: editDispenseFee,
			ndcInactivePairsOk: ndcInactivePairsOk,
			cloneToRX: cloneToRX,
			cloneToVEN: cloneToVEN,
			tblOptions: tblOptions,
			canAdd: canAdd,
			canStatus: canStatus,
			canImport: canImport,
			canExcel: canExcel,
			canClone: canClone,
			canEdit: canStatus,
			editAutoIneligibleDays: editAutoIneligibleDays,
			editCeilingPrice: editCeilingPrice,
			editReportingProps: editReportingProps
		};
	}

	function initAccountTypeDroplist(listType) {
		var result = [];
		switch(listType) {
			case 'VERISAVE_PREF':
			case 'VERISAVE_PREF_RX':
				// this will always look for ACTIVE only, vm.context isn't set yet
				result = utilSvc.aff.accumGrpAllOptions(getAffs(), true);
				return utilSvc.ng.droplist(result,'','',[{value:'ALL', label:'ALL'}]);
			default:
				throw new Error('ndcEdit.initAccountType, unknown: ' + listType);
		}
	}

	function initFilter(options) {
		// options param not used yet
		// note: this would be used to add a date to config, columns are already dynamic
		return vm.initFilters({
			Exact: {
				ObjectState: 'ACTIVE'
			},
			Config: {
				Dates: ['DateCreated'],
				DateFmt: 'M/d/yyyy'
			},
			SortBy: ['ItemCode']
		});
	}

	function getAffs() {
		var affStatus = vm.context.isVerity ? ['ACTIVE', 'ONBOARDING'] : ['ACTIVE'];
		var affs = utilSvc.aff.findStatus($scope.User.AffList, affStatus);
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
		return utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));
	}

	/**
	 *    VIEW MODEL
	 */

	function listVM(dataItems, tooMany) {
		dataItems = Array.isArray(dataItems) ? dataItems : [];
		
		// comparing with global items?
		if(!!_globalNdcMap) {
			_globalItems.forEach(function(g){g.Found = false;}); // reset Added prop
		}

		var item = {},
			changeItem = {},
			changedProps = [],
			itemValue = 0;

		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.uniqueId = i.toString();
			itemValue = validSvc.isNumber(item.Value) ? item.Value : 0;

			// alt properties
			item.AltItemCode = item.ReplaceItemCode;
			item.AltDesc = item.ReplaceItemCodeDescription;
			item.AltMfg = item.ReplaceItemCodeManufacturer;

			// dollar margin
			item.Margin = itemValue;
			if(vm.context.key == 'VERISAVE_PREF' || vm.context.key == 'VERISAVE_PREF_RX') {
				item.ValueMeaning = validSvc.isText(item.ValueMeaning) ? item.ValueMeaning : 'DOLLAR';
				if(item.ValueMeaning == 'PERCENT') {
					item.AccountType = validSvc.isText(item.AccountType) ? item.AccountType : 'ALL';
				}
				else {
					item.AccountType = '';
				}
			}

			// ce price ceiling
			if(vm.context.key == 'CE_PRICE') {
				item.CeilingPrice = itemValue;
			}

			// use global
			if(!!_globalNdcMap) {
				var gx = _globalNdcMap[item.ItemCode];
				if(gx >= 0) {
					// found global
					_globalItems[gx].Found = true;
					item.UseGlobal = 'ADDED';
				}
			}

			// IRA
			if(vm.context.key == 'GLOBAL_IRA' || vm.context.key == 'AFF_IRA') {
				var isGlobalIRA = vm.context.key == 'GLOBAL_IRA',
					iraItems = [],
					priceTxt = '';
				item.MFPYear = Array.isArray(item.MFPYear) ? item.MFPYear : [];
				item.MFPYearText = '';
				for(var ii = 0; ii < item.MFPYear.length; ii++) {
					var year = item.MFPYear[ii];
					priceTxt = isGlobalIRA && !!year.Price ? ' - $' + year.Price : ''; // only show price for global IRA
					iraItems.push(year.Year + priceTxt);
				}
				item.MFPYearText = iraItems.join(', ');
			}

			// change log formatting, unique ids
			item.ChangeLog = Array.isArray(item.ChangeLog) ? item.ChangeLog : [];
			item.hasLog = item.ChangeLog.length > 0;
			item.ChangeLog.forEach(function(c, cx){
				c.uniqueId = 'Id' + cx.toString();
				c.ChangedProperties = Array.isArray(c.ChangedProperties) ? c.ChangedProperties : [];
				c.ChangedProperties.forEach(function(p,px){
					p.uniqueId = 'Id' + px.toString();
				});
			});
		}

		// append active global items not found
		if(!!_globalNdcMap) {
			var notFoundItems = _globalItems.filter(function(g){
				return !!!g.Found && g.GlobalState == 'ACTIVE';
			});
			dataItems = dataItems.concat(notFoundItems);
		}

		return {
			Items: [],
			DataItems: dataItems,
			TooMany: !!tooMany
		};
	}


	/**
	 * 		LIST
	 */

	function getAffGlobalContext(affCtx) {
		switch(affCtx.key) {
			case 'AFF_OUTER_PACK':
				return initContextAndTableView($scope.User, {ListKey:'GLOBAL_OUTER_PACK', EntityId:'GL'});
			case 'AFF_REB':
				return initContextAndTableView($scope.User, {ListKey:'GLOBAL_REB', EntityId:'GL'});
			case 'AFF_IRA':
				return initContextAndTableView($scope.User, {ListKey:'GLOBAL_IRA', EntityId:'GL'});
			default:
				throw new Error('ndcEdit.getAffGlobalContext, unknown key: ' + affCtx.key);
		}
	}

	function getList() {
		if(vm.isWaiting) {
			return;
		}

		// display doc list
		vm.tbl = listVM();
		vm.flt.Ready = false;
		vm.action = '';
		vm.flt = vm.resetFilters(vm.flt);
		$scope.$broadcast('widget.paging', {uniqueId: 'NDC_EDIT'});
		
		toggleWait(true);

		// an aff list using globals needs to get the global items first
		var getGlobal = false;
		if(vm.context.tblOptions.useGlobalColumn && _globalItems.length < 1) {
			getGlobal = true;
			_globalNdcMap = null;

			// get global context for list search
			var globalCtx = getAffGlobalContext(vm.context);
			ndcRepo.getList(globalCtx).then(okList, errList);
		}
		else {
			ndcRepo.getList(vm.context).then(okList, errList);
		}
		
		function loadGlobalValues(items) {

			// load items to merge with aff items
			var globalList = listVM(items);
			_globalItems = globalList.DataItems;
			_globalItems = _globalItems.filter(function(g){
				return validSvc.isText(g.ItemCode);
			});

			// make ndc map of globals, zero out global editing properties
			_globalNdcMap = {};
			_globalItems.forEach(function(g, idx) {
				g.GlobalState = g.ObjectState;
				g.ObjectState = 'GLOBAL';
				g.uniqueId = 'g' + idx.toString();
				g.DateCreated = undefined;
				g.CreatedBy = undefined;
				g.ChangeLog = [];
				g.hasLog = false;
				_globalNdcMap[g.ItemCode] = idx;
			});
		}
		
		function okList(r) {
			toggleWait();

			// aff list got globals, load and call again
			if(getGlobal) {
				getGlobal = false;
				loadGlobalValues(r.Items);

				// globals are loaded, get aff scope items
				ndcRepo.getList(vm.context).then(okList, errList);
				return;
			}

			vm.tbl = listVM(r.Items, r.TooMany);
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			$scope.$broadcast('widget.paging', {
				uniqueId: 'NDC_EDIT',
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});
			
			vm.flt = vm.tblViewSyncFilter(vm.tblViewConfig, vm.tblView, vm.flt, true);
			vm.flt.Ready = true;
			vm.action = 'LIST';
		}

		function errList(r) {
			toggleWait();
			if(!!r) {
				errSvc.warn('Get NDC List Error for: ' + vm.context.title, 'ndcEdit.errList', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}


	/**
	 *    FILTER CHANGE
	 */

	function filterChange(immediate) {
		// used by both ndc list and clone to list
		var flt = !!vm.popup && vm.popup.type == 'CLONE' ? vm.popup.flt : vm.flt;

		// exit if filter is off
		if(!flt.Ready) {
			return;
		}

		// mark filters dirty
		flt.Dirty = true;

		// already working
		if(flt.Busy) {
			return;
		}
		flt.Busy = true;
		flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {
			var flt, isClone = false;
			if(!!vm.popup && vm.popup.type == 'CLONE') {
				isClone = true;
				flt = vm.popup.flt;
				vm.popup.DataItems = Array.isArray(vm.popup.DataItems) ? vm.popup.DataItems : [];
				vm.popup.Items = vm.filterList(vm.popup.DataItems, flt);
			}
			else {
				flt = vm.tblViewGetColumnFilterValues(vm.tblView.cols, vm.flt);
				vm.tbl.DataItems = Array.isArray(vm.tbl.DataItems) ? vm.tbl.DataItems : [];
				vm.tbl.Items = vm.filterList(vm.tbl.DataItems, flt);
			}
			flt.Busy = false;

			// run again? data changed during filtering
			if(flt.Dirty) {
				filterChange(true);
				return;
			}

			$scope.$broadcast('widget.paging', {
				uniqueId: isClone ? 'NDC_CLONE' : 'NDC_EDIT',
				Size: flt.PageSize,
				Page: flt.Page,
				Total: flt.PageTotal,
				RowCount: flt.Count,
				ItemCount: isClone ? vm.popup.Items.length : vm.tbl.Items.length,
				DataCount: isClone ? vm.popup.DataItems.length : vm.tbl.DataItems.length
			});

			if(isClone) {
				vm.popup.flt = flt;
			}
			else {
				vm.flt = flt;
			}

		}, delayTime);
	}


	/**
	 * 		TABLE VIEW
	 * 		using table view for custom columns, not for multiple saved views
	 */

	function tblViewConfigVM(options) {
		// build table view depending on list type

		var cols = [],
			result = {
				sortby: 'ItemCode',
				pgsize: 50,
				sections: {
					Stat: {title:'Status'},
					Ndc: {title:options.ndcSectionTitle},
					Fees: {title:'Fees'},
					Use: {title:'Usage'}
				},
				cols: []
			};

		// status - required
		cols.push({section:'Stat', 		flt:'Exact',	name:'ObjectState', colWidth:"40px", title:'Status', desc:''});

		// ndc columns - required with variable title text
		switch(vm.context.key) {
			case 'NDC_OPTIMIZER_GPI_EXCLUSION':
			case 'NDC_OPTIMIZER_GPI_INCLUSION':
				cols.push({section:'Ndc', 		flt:'Text',		name:'ItemCode', colWidth:"45px", title:options.GPITitle, desc:''});
				break;
			default:
				cols.push({section:'Ndc', 		flt:'Text',		name:'ItemCode', colWidth:"45px", title:options.ItemCodeTitle, desc:''});
				cols.push({section:'Ndc', 		flt:'Text',		name:'GPI', colWidth:"45px", title:'GPI', desc:''});
				cols.push({section:'Ndc', 		flt:'Text',		name:'Description', colWidth:"80px", title:options.DescriptionTitle, desc:''});
				cols.push({section:'Ndc', 		flt:'Text',		name:'Manufacturer', colWidth:"80px", title:options.ManufacturerTitle, desc:''});
				// not an error
		}

		// ndc columns (optional)
		if(!!options.InMedispanTxt) {
			cols.push({section:'Ndc', 		flt:'Text',		name:'InMedispanTxt', colWidth:"35px", title:'MediSpan Item', desc:''});
		}

		switch(vm.context.key) {
			case 'VERISAVE_PREF':
			case 'VERISAVE_PREF_RX':
				// ndc columns - required with variable title text
				cols.push({section:'Ndc', 		flt:'Text',		name:'Margin', colWidth:"45px", title:'Margin', desc:''});
				cols.push({section:'Ndc', 		flt:'Text',		name:'AccountType', colWidth:"45px", title:'Account', desc:''});
				break;
			case 'DISPENSE_FEE':
				// ndc columns - required with variable title text
				cols.push({ section: 'Fees', flt: 'Text', name: 'Margin', colWidth: "45px", title: 'Amount', desc: '' });
				cols.push({ section: 'Fees', flt: 'Text', name: 'VariablePercentage', colWidth: "45px", title: 'Variable %', desc: '' });
				cols.push({ section: 'Fees', flt: 'Text', name: 'MinDispFee', colWidth: "45px", title: 'Min', desc: '' });
				cols.push({ section: 'Fees', flt: 'Text', name: 'MaxDispFee', colWidth: "45px", title: 'Max', desc: '' });
				break;
			case 'CE_PRICE':
				// ndc columns - add price ceiling
				cols.push({section:'Ndc', 		flt:'Numbers',		name:'CeilingPrice', colWidth:"45px", title:'Ceiling Price', desc:''});
				break;
			default:
					// not an error, these are additive
		}

		// alt columns (optional)
		if(options.altColumns.length > 0) {
			result.sections.Alt = {title: options.altSectionTitle};
			var altOpt = null;
			for(var a = 0; a < options.altColumns.length; a++) {
				altOpt = options.altColumns[a];
				cols.push({section:'Alt', 		flt:altOpt.flt,		name:altOpt.name, colWidth:altOpt.colWidth, title:altOpt.title, desc:''});
			}
		}

		// usage - required
		if(options.useGlobalColumn) {
			cols.push({section:'Use', 		flt:'Text',		name:'UseGlobal', colWidth:"45px", title:'Add Global', desc:''});
		}
		cols.push({section:'Use', 		flt:'Dates',		name:'DateCreated', colWidth:"45px", title:'Date Added', desc:''});
		if(options.useCreatedByColumn) {
			cols.push({section:'Use', 		flt:'Text',		name:'CreatedBy', colWidth:"60px", title:'Added By', desc:''});
		}
		cols.push({section:'Use', 		flt:'Text',		name:'ChangeLog', colWidth:"50px", title:'Log', desc:''});
		
		// re-assign schema col array items into colKey map
		var col = {},
			colNames = [],
			colKeys = [];
		for(var i = 0; i < cols.length; i++) {
			col = cols[i];
			colNames.push(col.name);
			colKeys[col.name] = col;
		}

		// add to config object
		result.cols = colNames;
		result.colKeys = colKeys;

		return result;
	}


	/**
	 * 	POPUP
	 * 	used for: EDIT / LOG / UPLOAD
	 */

	function rowClick(item, evt) {
		// row click is Edit Ndc, Activity Log, or ADD Global

		var elem = evt.target,
			className = '',
			hasItem = !!item,
			itemIsGlobal = !!hasItem && item.ObjectState == 'GLOBAL';

		// loop up to find td column parent
		while(!!elem) {

			if(hasItem && !!elem.className) {
				className = elem.className;
				if(!!item.hasLog && className.indexOf('click-log') > -1) {
					// log link clicked
					elem = null;
					openPopup('LOG', item, evt);
					return;
				}
				else if(itemIsGlobal && className.indexOf('ndc-global-add') > -1) {
					// ADD global button clicked
					elem = null;
					addGlobalNdc(item);
					return;
				}
			}

			// href was not clicked, open edit
			if(!!elem.nodeName && elem.nodeName.toUpperCase() == 'TD') {
				// global items cannot be edited
				if(itemIsGlobal) {
					msgSvc.ok('Cannot Edit', 'Global items cannot be edited.');
					return;
				}
				elem = null;
				if(vm.context.canEdit) {
					openPopup('EDIT',item);
				}
				return;
			}

			elem = elem.parentNode;
		}
		elem = null;
	}

	function openPopup(popType, item, evt) {
		// multi-use popup, all popups re-use: vm.popup / openPopup / closePopup

		if(vm.isWaiting) {
			return;
		}

		switch(popType) {
			case 'EDIT':
				popEdit(item, evt);
				break;
			case 'LOG':
				popLog(item, evt);
				break;
			case 'UPLOAD':
				popUpload();
				break;
			case 'CLONE':
				popClone();
				break;
			default:
				throw new Error('ndcEdit.openPopup, unknown pop type: ' + popType);
		}
	}

  function defaultOverZero(val) {
    val = validSvc.isNumber(val) && val > 0 ? val : '';
    return validSvc.newProp(val);
  }
	
  function popEdit(item, evt) {
		// new or update NDC
		var action = !!item ? 'UPDATE' : 'ADD';
		item = item || {};

		// clear auto-search
		clearNdcAutoSearch();

		// optional update properties
		var hasUpdates = false,
			acctType = '',
		   	valueMeaning = '';

		// margin editing settings
		if(!!vm.context.editMargin) {
			hasUpdates = action == 'UPDATE';
			acctType = action == 'UPDATE' ? item.AccountType : 'ALL';
			valueMeaning = action == 'UPDATE' ? item.ValueMeaning : 'DOLLAR';
		}

		// ceiling price editing settings
		if(!!vm.context.editCeilingPrice) {
			valueMeaning = 'DOLLAR';
			hasUpdates = action == 'UPDATE';
		}

		if(!!vm.context.editDispenseFee) {
			hasUpdates = action == 'UPDATE';
		}

		if(!!vm.context.editAutoIneligibleDays) {
			hasUpdates = action == 'UPDATE';
		}

		if(!!vm.context.editReportingProps) {
			hasUpdates = action == 'UPDATE';
		}

		if(!vm.context.editGPI) {
			hasUpdates = action == 'UPDATE';
		}

		var lbl = vm.context.editGPI ? 'GPI' : 'NDC';

		vm.popup = {
			type: 'EDIT',
			currentItemCodeFlt: getTableFilterVal('ItemCode'),
			action: action,
			title: action == 'UPDATE' ? 'Edit ' + lbl +': ' + item.ItemCode : 'ADD ' + lbl,
			ObjectState: item.ObjectState == 'INACTIVE' ? 'INACTIVE' : 'ACTIVE', // default to ACTIVE for new ndc
			ItemCode: validSvc.isText(item.ItemCode) ? validSvc.newProp(item.ItemCode) : validSvc.newProp(''),
			AltItemCode: validSvc.isText(item.AltItemCode) ? validSvc.newProp(item.AltItemCode) : validSvc.newProp(''),
			GPI: validSvc.isText(item.GPI) ? validSvc.newProp(item.GPI) : validSvc.newProp(''),
			Desc: validSvc.isText(item.Desc) ? validSvc.newProp(item.Desc) : validSvc.newProp(''),
			Margin: validSvc.newProp(item.Margin),
			ValueMeaning: valueMeaning,
			CeilingPrice: defaultOverZero(item.CeilingPrice),
			VariablePercentage : defaultOverZero(item.VariablePercentage),
			MinDispFee: defaultOverZero(item.MinDispFee),
			MaxDispFee: defaultOverZero(item.MaxDispFee),
			AccountType: acctType,
			AutoIneligibleDays : validSvc.newProp(item.AutoIneligibleDays),
			ReportingPlatform: validSvc.isText(item.ReportingPlatform) ? item.ReportingPlatform : '',
			ReportType: validSvc.isText(item.ReportType) ? item.ReportType : '',
			hasUpdates: hasUpdates,
			show: false
		};

		// edit at vertical location of row
		movePopupContentToRowY(evt, 0, 'ndcEditPopupContentEDIT');

		$timeout(function() {
			vm.popup.show = true;
		}, 200);
	}

	function popLog(item, evt) {
		if(!!!item || !!!evt || !Array.isArray(item.ChangeLog)) {
			throw new Error('referralListCtl.openPopup popLog, item, click and log required');
		}

		// add unique ids to each line
		var showModBy = !!vm.context.tblOptions.useCreatedByColumn;
		item.ChangeLog.forEach(function(l, idx){
			l.uniqueId = idx.toString();
			l.showModBy = showModBy;
			l.ChangedProperties = Array.isArray(l.ChangedProperties) ? l.ChangedProperties : [];
			l.ChangedProperties.forEach(function(p,idx){
				p.uniqueId = idx.toString();
			});
		});

		vm.popup = {
			type: 'LOG',
			title: 'NDC ' + item.ItemCode + ' Activity Log',
			LogItems: item.ChangeLog,
			ready: false
		};

		// show log at row clicked
		movePopupContentToRowY(evt, 20, 'ndcEditPopupContentLOG');

		$timeout(function() {
			vm.popup.show = true;
		}, 200);
	}

	function popUpload() {
		vm.importSelectedFiles = [];
		vm.popup = {
			type: 'UPLOAD',
			action: 'GET_FILE',
			title: vm.context.title + ' File Upload',
			helpText: uploadHelpText(vm.context.key),
			errors: [],
			show: false
		};

		// show upload at top
		movePopupContentToRowY(null, 0, 'ndcEditPopupContentUPLOAD','65%');

		$timeout(function() {
			vm.popup.show = true;
		}, 200);
	}

	function uploadHelpText(listType) {
		var lbl = vm.context.editGPI ? 'GPI' : 'NDC';

		var result = [
			lbl + ' text file should have a header line followed by 1 line per ' + lbl + ' code.',
			'Each line must end with an ASCII LF (line feed character)'
		];

		if(lbl == 'NDC') {
			result.push('Required Column headers:');
			result.push('NDC,AutoIneligibleDays,ReportingPlatform,ReportType');
		}

		// different upload help per list type
		switch(listType) {
			case 'VERISAVE_PREF':
			case 'VERISAVE_PREF_RX':
				result.push(' ');
				result.push('File header Line is text: "NDC, Amount, Margin Type, Account"');
				result.push('Each line requires 3 fields: a valid 11-digit NDC (no formatting), Amount (decimal up to two places) and Margin Type (DOLLAR or PERCENT).');
				result.push('Optional: if Margin Type is PERCENT, Account can be specified such as: 340B, GPO, WAC. % will applied to total split if not provided.');
				result.push('DOLLAR example data line: 54838001150,20.56,DOLLAR');
				result.push('PERCENT example data line: 54838001150,5.25,PERCENT,GPO');
				break;
			case 'DISPENSE_FEE':
				result.push(' ');
				result.push('File header Line is text: "NDC, Fee, Variable %, Minimum Fee, Maximum Fee"');
				result.push('Each line requires 2 fields: a valid 11-digit NDC (no formatting) and Fee or Variable % (decimal up to two places).');
				result.push('Example data line: 54838001150,20.56');
				result.push('Example data line: 54838001150,50,15,200,2000');
				break;
			case 'CE_PRICE':
				result.push(' ');
				result.push('File header Line is text: "NDC, Price"');
				result.push('Each line requires 2 fields: a valid 11-digit NDC (no formatting) and Price.');
				result.push('Example data line: 54838001150,20.56');
				break;
			default:
				// use default result
		}
		return result;
	}

	function hasActiveItem(items) {
		if(!Array.isArray(items) || items.length < 1) {
			return false;
		}
		for(var i = 0; i < items.length; i++) {
			if(items[i].ObjectState == 'ACTIVE') {
				return true;
			}
		}
		return false;
	}

	function popClone() {

		var fromCE = vm.context.CE,
			fromRX = vm.context.RX,
			fromAcctId = vm.context.EntityId,
			listType = vm.context.key,
			useCE = true,
			useRx = vm.context.cloneToRX,
			useVEN = vm.context.cloneToVEN,
			affs = [];

		// need at least 1 active to clone
		if(!hasActiveItem(vm.tbl.Items)) {
			msgSvc.ok('Cannot Clone', 'At least 1 ACTIVE item needed to Clone');
			return;
		}

		// set affs specific to list type
		switch(listType) {
			case 'NON_340B':
			case 'CE_PRICE':
				affs = getAffs();
				break;
			case 'AFF_ORDER_EXCLUSION':
				affs = utilSvc.aff.findRxModel(getAffs(), ['CP', 'CPTPA']);
				break;
			case 'MATCH_EXCLUSION':
				affs = utilSvc.aff.findRxModel(getAffs(), ['CP', 'CPTPA','SPLITMATCH']);
				break;
			case 'AFF_OUTER_PACK':
			case 'VERISAVE_NEVER_SWITCH_FROM':
			case 'VERISAVE_NEVER_SWITCH_TO':
			case 'VERISAVE_PREF':
			case 'MATCH_REVIEW_INCLUSION':
			case 'DISPENSE_FEE':
			case 'OWNUSE_ALT':
			case '340B_ALT':
			case 'AFF_REB':
			case 'AFF_IRA':
				// all these lists need more aff info
				// ASYNC note: undefined is returned if an api call is happening, popup will be re-called after lookup returns
				affs = getAffsWithInfo(listType);
				if(!Array.isArray(affs)) {
					return;
				}
				break;
			case 'RX_ORDER_EXCLUSION':
			case 'VERISAVE_NEVER_SWITCH_FROM_RX':
			case 'VERISAVE_NEVER_SWITCH_TO_RX':
			case 'VERISAVE_PREF_RX':
			case 'NDC_OPTIMIZER_NDC_EXCLUSION':
			case 'NDC_OPTIMIZER_GPI_EXCLUSION':
			case 'NDC_OPTIMIZER_GPI_INCLUSION':
				// ASYNC: need clone to pharmacy list
				if(_cloneToPharmacy.length < 1) {
					asyncCloneToPharmacyLookup(listType);
					return;
				}
				affs = _cloneToPharmacy;
				useCE = false;
				break;
			case 'ALWAYS_SPLIT':
			case 'NEVER_SPLIT':
			case 'ALWAYS_ORDER':
			case 'NEVER_ORDER':
			case 'ISP_ORDER':
				// ASYNC: need clone to accounts list
				if(_cloneToAccounts.length < 1) {
					asyncCloneToAccountsLookup(listType, vm.context.EntityId);
					return;
				}
				affs = _cloneToAccounts;
				break;
			default:
				throw new Error('ndcEdit.popClone, unknown listType: ' + listType);
		}
		
		// build list options
		var aff = {},
			items = [],
			newItem = {},
			ceSelf = false,
			rxSelf = false,
			venSelf = false,
			ceUnique = [],
			ceUniqueCheck = useCE && !useVEN && !useRx;
		for(var i = 0; i < affs.length; i++) {
			aff = affs[i];

			// do not clone to self (this covers CE match, RX match, VEN match)
			ceSelf = useCE ? aff.CEID == fromCE : true;
			rxSelf = ceSelf && useRx && aff.RXID == fromRX;
			venSelf = ceSelf && rxSelf && useVEN && aff.AcctId == fromAcctId;
			if ((ceSelf && !useRx && !useVEN) || (rxSelf && !useVEN) || venSelf) {
				continue;
			}

			// ce unique check
			if(ceUniqueCheck) {
				if(ceUnique.indexOf(aff.CEID) > -1) {
					continue;
				}
				ceUnique.push(aff.CEID);
			}

			// create new list item
			newItem = {
				uniqueId: i.toString(),
				checked: false
			};

			// add ce props
			if(useCE) {
				newItem.CEID = aff.CEID;
				newItem.CeName = utilSvc.aff.ceNameByIdLookup(aff.CEID);
			}

			// add rx properties
			if(useRx) {
				newItem.RXID = aff.RXID;
				newItem.RxName = aff.RxShortName;
				newItem.RxBizModel = aff.RxBizModel;
				newItem.Admin = aff.ProgAdmin == '' ? 'Verity' : aff.ProgAdmin;
				newItem.Status = aff.AffState;
			}

			// add vendor acct props
			if(useVEN) {
				newItem.AcctId = aff.AcctId;
				newItem.Vendor = aff.Vendor;
				newItem.AcctType = aff.AcctType;
			}
			
			items.push(newItem);
		}
		if (items.length < 1) {
			msgSvc.ok('Cannot Clone', 'No Affiliation available to clone to');
			return;
		}

		vm.popup = {
			type: 'CLONE',
			action: 'SELECT',
			cloneFromTitle: cloneFromTitle(),
			fromCE: fromCE,
			useCE: useCE,
			useRX: useRx,  // select pharmacy with CE
			useVEN: useVEN,
			Items: [],
			DataItems: items, // selector items
			flt: vm.initFilters({SortBy: ['CEID']}),
			cloneTo: [], // 1 or many clone destinations
			cloneBatchIdx: -1, // current clone item
			cloneCancel: false, // batch was cancelled
			show: false
		};

		// show clone at top
		var popWidth = useRx ? '95%' : '55%';
		movePopupContentToRowY(null, 0, 'ndcEditPopupContentCLONE', popWidth);

		$timeout(function () {
			vm.popup.show = true;
			$timeout(function() {
				vm.popup.flt.Ready = true;
				filterChange(true);
			},300);
		}, 300);

		// helper
		function cloneFromTitle() {
			var title = 'Clone From ',
				rxName = useRx ? utilSvc.aff.rxShortNameByIdLookup(fromRX) : '';
			if(useVEN) {
				return title + 'Order Account: ' + fromCE + ' / ' + rxName + ' / ' + vm.context.VenTitle;
			}
			else if(useRx) {
				if(useCE) {
					return title + 'Affiliation: ' + fromCE + ' / ' + rxName;
				}
				else {
					return title + 'Pharmacy: ' + rxName;
				}
			}
			else if(useCE) {
				return title + 'Facility: ' + utilSvc.aff.ceNameByIdLookup(fromCE);
			}
		}
	}

	function getAffsWithInfo(listType) {
		// use aff lookup to filter affs
		var affs = [],
			isVerisave = false,
			isAffOuterPack = false,
			isMatchReview = false,
			isDispFee = false,
			isOwn = false,
			isREB = false,
			isIRA = false,
			is340BAlt = false;

		switch(listType) {
			case 'AFF_OUTER_PACK':
				isAffOuterPack = true;
				affs = utilSvc.aff.findRxModel(getAffs(), ['CP']);
				break;
			case 'VERISAVE_NEVER_SWITCH_FROM':
			case 'VERISAVE_NEVER_SWITCH_TO':
			case 'VERISAVE_PREF':
				isVerisave = true;
				affs = utilSvc.aff.findRxModel(getAffs(), ['SPLIT', 'SPLITMATCH']);
				break;
			case 'MATCH_REVIEW_INCLUSION':
				isMatchReview = true;
				affs = utilSvc.aff.findRxModel(getAffs(), ['CP', 'CPTPA','SPLITMATCH']);
				break;
			case 'DISPENSE_FEE':
				isDispFee = true;
				affs = utilSvc.aff.findRxModel(getAffs(), ['CP', 'CPTPA']);
				break;
			case 'OWNUSE_ALT':
				isOwn = true;
				affs = utilSvc.aff.findRxModel(getAffs(), ['CP','SPLITMATCH']);

				// narrow clone down to this aff's biz model
				var myAff = utilSvc.aff.findRx(utilSvc.aff.findCe(affs,vm.context.CE),vm.context.RX);
				if(myAff.length !== 1) {
					throw new Error('ndcEdit.getAffsWithInfo, Affiliation Own Use Alternate, Cannot find its own affiliation');
				}
				affs = utilSvc.aff.findRxModel(affs, [myAff[0].RxBizModel]);
				break;
			case '340B_ALT':
				is340BAlt = true;
				affs = utilSvc.aff.findRxModel(getAffs(), ['CP', 'SPLITMATCH']);
				break;
			case 'AFF_REB':
				isREB = true;
				affs = utilSvc.aff.findRxModel(getAffs(), ['CP', 'CPTPA', 'SPLITMATCH']);
				break;
			case 'AFF_IRA':
				isIRA = true;
				affs = utilSvc.aff.findRxModel(getAffs(), ['CP', 'CPTPA', 'SPLITMATCH']);
				break;
			default:
				throw new Error('ndcEdit.getAffsWithInfo, unknown type: ' + listType);	
		}

		// ASYNC: exit and do aff lookup
		if(_affsWithInfo.length < 1) {
			asyncAffLookup(affs);
			return undefined;
		}
		
		// create map
		var result = [],
			affMap = {};
		_affsWithInfo.forEach(function(affInfo) {
			if(isAffOuterPack) {
				affMap[affInfo.CEID + affInfo.RXID] = !!affInfo.UseInnerOuterPacks;
			}
			else if(isVerisave) {
				affMap[affInfo.CEID + affInfo.RXID] = !!affInfo.UseBestCost;
			}
			else if(isMatchReview) {
				affMap[affInfo.CEID + affInfo.RXID] = !!affInfo.CeMatchReview && !!affInfo.UseCeMatchReviewNdcList;
			}
			else if(isDispFee) {
				affMap[affInfo.CEID + affInfo.RXID] = !!affInfo.UseAffDispenseFeeList;
			}
			else if(isOwn) {
				affMap[affInfo.CEID + affInfo.RXID] = !!affInfo.CeOwnUseProgram;
			}
			else if(isREB) {
				affMap[affInfo.CEID + affInfo.RXID] = !!affInfo.MRebateOptIn && !!affInfo.MRebateOptInSome;
			}
			else if(isIRA) {
				affMap[affInfo.CEID + affInfo.RXID] = !!affInfo.IRAOptOut && !!affInfo.IRAOptOutSome;
			}
			else if(is340BAlt) {
				affMap[affInfo.CEID + affInfo.RXID] = !!affInfo.AllowAlt340BNDC;
			}
		});

		result = affs.filter(function(aff) {
			return !!affMap[aff.CEID + aff.RXID];
		});
		return result;
	}

	function movePopupContentToRowY(evt, offsetY, contentId, popWidth) {
		// loop html element parents looking for popup container top
		// note: this is a scrollable table, reduce offset by amount the table is scrolled

		// find offset if event is passed in
		if(!!evt) {
			var elem = evt.target,
				scrollTopFound = false;
			while(!!elem) {

				// top element found
				if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
					break;
				}

				// scroll container found, reduce offset if this container is scrolled
				if(!scrollTopFound && !!elem.className && elem.className.indexOf('table-fixed-header-scroll') > -1) {
					scrollTopFound = true;
					offsetY -=  Math.floor(elem.scrollTop);
				}

				// add offset, get next element
				offsetY += elem.offsetTop;
				elem = elem.offsetParent;
			}
			elem = null;
		}

		// move popup to clicked row
		var popContent = document.getElementById(contentId);
		if(!!popContent) {
			popContent.style.top = offsetY.toString() + 'px';
			if(!!popWidth) {
				popContent.style.width = popWidth;
			}
		}
	}

	function asyncAffLookup(affs) {
		// ASYNC: used by popClone to get more affiliation info, will re-start popClone once lookup is done
		_affsWithInfo = [];
		if(!Array.isArray(affs) || affs.length < 1) {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true,true); // second true forces spinner immediately
		$timeout(function(){
			lookupRepo.AffInfo(utilSvc.aff.ceList(affs), utilSvc.aff.rxList(affs)).then(okAffLookup, errAffLookup);
		},500);

		function okAffLookup(r) {
			toggleWait();
			if(Array.isArray(r) && r.length > 0) {
				_affsWithInfo = r;
				popClone();
			}
			else {
				msgSvc.ok('Cannot Clone', 'No affiliation info is available');
			}
		}

		function errAffLookup(r) {
			toggleWait();
			if(!!r) {
				throw new Error('ndcEdit.errAffLookup, unkown api error: ' + utilSvc.http.safeResponse(r));
			}
		}	
	}

	function asyncCloneToAccountsLookup() {
		// ASYNC: used by popClone to get clone to list for accounts
		_cloneToAccounts = [];
		vm.isWaiting = true;
		msgSvc.wait(true,true); // second true forces spinner immediately

		$timeout(function(){
			ndcRepo.getCloneToAccounts(vm.context).then(okGetCloneToAccts, errGetCloneToAccts);
		},500);

		function okGetCloneToAccts(r) {
			toggleWait();
			if(Array.isArray(r.Items) && r.Items.length > 0) {
				_cloneToAccounts = r.Items;
				popClone();
			}
			else {
				msgSvc.ok('Cannot Clone', 'No order accounts are available');
			}
		}

		function errGetCloneToAccts(r) {
			toggleWait();
			if(!!r) {
				throw new Error('ndcEdit.errGetCloneToAccts, unkown api error: ' + utilSvc.http.safeResponse(r));
			}
		}	
	}

	function asyncCloneToPharmacyLookup(listType) {
		// ASYNC: used by popClone to get clone to list for accounts
		var lookupRxAffs = [],
			lookupRxList = [],
			isVerisave = false;
		switch(listType) {
			case 'VERISAVE_NEVER_SWITCH_FROM_RX':
			case 'VERISAVE_NEVER_SWITCH_TO_RX':
			case 'VERISAVE_PREF_RX':
				isVerisave = true;
				lookupRxAffs = utilSvc.aff.findRxModel(getAffs(), ['SPLIT', 'SPLITMATCH']);
				lookupRxList = utilSvc.aff.rxList(lookupRxAffs);
				break;
			case 'RX_ORDER_EXCLUSION':
				// CP pharmacy or Dispensing Rollup Pharmacy
				var oeAffStatus = vm.context.isVerity ? ['ACTIVE', 'ONBOARDING'] : ['ACTIVE'];
				var oeAffs = utilSvc.aff.findStatus($scope.User.AffList, oeAffStatus);
				oeAffs = utilSvc.aff.findRxModel(oeAffs, utilSvc.aff.rxModelsByFeature(_featureName));
				var oeCpAffs = utilSvc.aff.findRxModel(utilSvc.aff.findRxType(oeAffs, ['DISPENSING', 'CENTRALFILL']), ['CP']);
				var oeRollupAffs = utilSvc.aff.findRxType(oeAffs, ['ROLLUP']);
				lookupRxAffs = oeCpAffs.concat(oeRollupAffs);
				lookupRxList = utilSvc.aff.rxList(lookupRxAffs);
				break;
			case 'NDC_OPTIMIZER_NDC_EXCLUSION':
			case 'NDC_OPTIMIZER_GPI_EXCLUSION':
			case 'NDC_OPTIMIZER_GPI_INCLUSION':
				lookupRxAffs = utilSvc.aff.findRxModel(getAffs(), ['SPLIT', 'SPLITMATCH']);
				lookupRxList = utilSvc.aff.rxList(lookupRxAffs);
				break;
			default:
				throw new Error('ndcEdit.asyncCloneToPharmacyLookup, unknown list type: ' + listType);
		}
		
		_cloneToPharmacy = [];
		vm.isWaiting = true;
		msgSvc.wait(true,true); // second true forces spinner immediately

		$timeout(function(){
			lookupRepo.RxInfo(lookupRxList).then(okRxLookup, errRxLookup);
		},500);

		function okRxLookup(r) {
			toggleWait();
			var items = Array.isArray(r) ? r : [],
				rxids = [],
				aff = {};
			items.forEach(function(rx){
				if(isVerisave && !!rx.SeqUseBestCost && rxids.indexOf(rx.NickName) < 0) {
					aff = utilSvc.aff.findRx(lookupRxAffs, rx.NickName)[0];
					_cloneToPharmacy.push(aff);
				}
				switch (listType) {
					case 'RX_ORDER_EXCLUSION':
						if(rxids.indexOf(rx.NickName) < 0) {
							aff = utilSvc.aff.findRx(lookupRxAffs, rx.NickName)[0];
							_cloneToPharmacy.push(aff);
						}
						break;
					case 'NDC_OPTIMIZER_NDC_EXCLUSION':
						if(!!rx.Governor && !!rx.GenericGrouping && rxids.indexOf(rx.NickName) < 0) {
							aff = utilSvc.aff.findRx(lookupRxAffs, rx.NickName)[0];
							_cloneToPharmacy.push(aff);
						}
						break;
					case 'NDC_OPTIMIZER_GPI_EXCLUSION':
						if(!!rx.Governor && !!rx.GenericGrouping && rx.GpiConstraints == 'GPIEXCLUDE' && rxids.indexOf(rx.NickName) < 0) {
							aff = utilSvc.aff.findRx(lookupRxAffs, rx.NickName)[0];
							_cloneToPharmacy.push(aff);
						}
						break;
					case 'NDC_OPTIMIZER_GPI_INCLUSION':
						if(!!rx.Governor && !!rx.GenericGrouping && rx.GpiConstraints == 'GPIINCLUDE' && rxids.indexOf(rx.NickName) < 0) {
							aff = utilSvc.aff.findRx(lookupRxAffs, rx.NickName)[0];
							_cloneToPharmacy.push(aff);
						}
						break;
				}

				rxids.push(rx);
			});
			if(_cloneToPharmacy.length > 0) {
				popClone();
			}
			else {
				msgSvc.ok('Cannot Clone', 'No pharmacies are available');
			}
		}

		function errRxLookup(r) {
			toggleWait();
			if(!!r) {
				throw new Error('ndcEdit.asyncCloneToPharmacyLookup, unkown api error: ' + utilSvc.http.safeResponse(r));
			}
		}	
	}

	function closePopup() {
		var popType = vm.popup.type;
		vm.popup = {};

		// refresh list view coming back from edit view
		switch(popType) {
			case 'EDIT':
				clearNdcAutoSearch(true);
				filterChange(true);

				$timeout(function(){
					vm.ndcInput = '';
					vm.altNdcInput = '';
					getList();
				},500);
				break;
			case 'UPLOAD':
			case 'CLONE':
				getList();
		}
	}

	function validateDecimal(prop, required) {
		prop.fail = '';
		if (required) {
			prop.fail = validSvc.isNumber(prop.val) ? 'no' : 'yes';
			prop.msg = prop.fail == 'yes' ? 'required' : '';
			if(prop.fail == 'yes') {
				msgSvc.ok('Cannot Save', 'Number is required.');
				return false;
			}
		}
		// Only allow 2 decimal places for dispense fee
		var propVal = prop.val;
		if(propVal != null && validSvc.isText(propVal) && propVal.indexOf('.') > -1) {
			if (propVal.length - propVal.lastIndexOf('.') > 3) {
				// max 2 decimal place
				prop.fail = 'yes';
				prop.msg = 'maximum 2 decimal.';
				return false;
			}
		} 
		return true;
	}

	/**
	 * 		ADD / UPDATE
	 */

	function save() {
		if(vm.isWaiting || !!!vm.popup) {
			return;
		}

		var m = vm.popup,
			isAdd = vm.popup.action == 'ADD',
			valueMeaning = '',
			acctType = '';

		// item code (ndc or GPI)
		m.ItemCode = ndcCleanUp(m.ItemCode.val, false, vm.context.editGPI ? 14 : 11); // GPI is 14 digits
		if(m.ItemCode.fail == 'yes') {
			msgSvc.ok('Cannot Save', (vm.context.editGPI ? 'GPI: ' : 'Item Code: ') + m.ItemCode.msg);
			return;
		}
		
		// ndc already exists?
		if(isAdd && ndcExists(m.ItemCode.val, vm.tbl.DataItems, 'ItemCode', vm.context.ndcInactivePairsOk)) {
			msgSvc.ok('Cannot Save', 'Item Code already exists');
			return;
		}
		
		// alternate ndc used
		if(vm.context.editAltItemCode) {
			m.AltItemCode = ndcCleanUp(m.AltItemCode.val, false, 11);
			if(m.AltItemCode.fail == 'yes') {
				msgSvc.ok('Cannot Save', 'Alternate Item Code: ' + m.AltItemCode.msg);
				return;
			}
			var altNdc = m.AltItemCode.val;

			// ndc cannot match alt
			if(m.ItemCode.val == altNdc) {
				msgSvc.ok('Cannot Save', 'Item Code is the same as Alternate');
				return;
			}
			
			if(isAdd) {
				// ndc cannot be an alt in another pair
				if(ndcExists(m.ItemCode.val, vm.tbl.DataItems, 'AltItemCode', vm.context.ndcInactivePairsOk)) {
					msgSvc.ok('Cannot Save', 'Item Code is already being used as an Alternate');
					return;
				}
	
				// alt cannot be an ndc primary in another pair
				if(ndcExists(altNdc, vm.tbl.DataItems, 'ItemCode', vm.context.ndcInactivePairsOk)) {
					msgSvc.ok('Cannot Save', 'Alternate Item Code is already being used as a Primary NDC');
					return;
				}			
			}
		}
		
		// dollar margin
		m.Margin.fail = '';
		if(vm.context.editMargin) {
			m.Margin.fail = validSvc.isNumber(m.Margin.val) ? 'no' : 'yes';
			m.Margin.msg = m.Margin.fail == 'yes' ? 'required' : '';
			if(m.Margin.fail == 'yes') {
				msgSvc.ok('Cannot Save', 'Dollar Amount number is required.');
				return;
			}

			// value meaning is used by Margin to hold its type
			valueMeaning = m.ValueMeaning;
			switch(valueMeaning) {
				case 'DOLLAR':
					// nothing else needed
					break;
				case 'PERCENT':
					acctType = m.AccountType == 'ALL' ? '' : m.AccountType;
					break;
				default:
					msgSvc.ok('Cannot Save', 'Margin type is required.');
			}
		}

		if(vm.context.editDispenseFee) {
			var dispFeesOk = validateDecimal(m.Margin, true) &&
				validateDecimal(m.MinDispFee, false) && 
				validateDecimal(m.MaxDispFee, false) &&
				validateDecimal(m.VariablePercentage, false);
			
			if (!dispFeesOk) {
				msgSvc.ok('Cannot Save', 'Check Fee Properties');
				return;
			}

			if (m.MinDispFee != null && (parseFloat(m.MinDispFee.val) > parseFloat(m.MaxDispFee.val))) {
				m.MinDispFee.fail = 'yes';
				m.MinDispFee.msg = 'invalid min fee';
				msgSvc.ok('Cannot Save', 'minimum fee must be smaller than maximum fee');
				return false;
			}
		}

		if(vm.context.editCeilingPrice) {
			if(!validateDecimal(m.CeilingPrice, true)) {
				msgSvc.ok('Cannot Save', 'Check ceiling price property.');
				return;
			}
		}

		// global exclusion list autoIneligibleDays 
		m.AutoIneligibleDays.fail = 'no';
		m.AutoIneligibleDays.msg = '';
		//No need to validate AutoIneligibleDays if it is nil as it is not a mandatory field
		if(vm.context.editAutoIneligibleDays && !!m.AutoIneligibleDays.val) {
			if(!validSvc.isNumber(m.AutoIneligibleDays.val) ||
			(m.AutoIneligibleDays.val < 1 || m.AutoIneligibleDays.val > 365)){
				m.AutoIneligibleDays.fail = 'yes';
				m.AutoIneligibleDays.msg = 'Auto Ineligible days should be between 1 and 365.';
				msgSvc.ok('Cannot Save', 'Auto Ineligible days should be between 1 and 365.');
				return;
			}
		}
		var minDispFee = m.MinDispFee.val == null || m.MinDispFee.val == "" ? 0 : m.MinDispFee.val;
		var maxDispFee = m.MaxDispFee.val == null || m.MaxDispFee.val == "" ? 0 : m.MaxDispFee.val;
		var variablePercentage = m.VariablePercentage.val == null || m.VariablePercentage.val == "" ? 0 : m.VariablePercentage.val;

		var saveModel = {
			ItemCode: m.ItemCode.val,
			AltItemCode: m.AltItemCode.val,
			GPI: m.GPI.val,
			Margin: m.Margin.val,
			CeilingPrice: m.CeilingPrice.val,
			VariablePercentage: variablePercentage,
			MinDispFee: minDispFee,
      		MaxDispFee: maxDispFee,
			ValueMeaning: valueMeaning,
			AccountType: acctType,
			AutoIneligibleDays: m.AutoIneligibleDays.val,
			ReportingPlatform: m.ReportingPlatform,
			ReportType: m.ReportType
		};

		toggleWait(true);
		ndcRepo.save(vm.context, saveModel).then(okSave, errSave);

		function okSave(r) {
			toggleWait();
			setDirty();

			// close popup on update
			if(vm.popup.action != 'ADD') {
				closePopup();
				return;
			}

			// clear editing so user can add another
			clearNdcAutoSearch(true);
			vm.popup.GPI = validSvc.newProp();
			vm.popup.Margin = validSvc.newProp();
			vm.popup.CeilingPrice = validSvc.newProp();
			vm.popup.VariablePercentage = validSvc.newProp();
			vm.popup.MinDispFee = validSvc.newProp();
			vm.popup.MaxDispFee = validSvc.newProp();
			vm.popup.AutoIneligibleDays = validSvc.newProp();
			vm.popup.ReportingPlatform = '';
			vm.popup.ReportType = '';
			filterChange(true);
			var lbl = vm.context.editGPI ? 'GPI' : 'NDC';
			msgSvc.ok(lbl + ' SAVED');

			$timeout(function() {
				vm.ndcInput = '';
				vm.altNdcInput = '';
				getList();
			}, 500);
		}

		function errSave(r) {
			toggleWait();
			if(!!r && (r.status == 422 || r.status == 409)) {
				msgSvc.ok('Cannot Save', r.msg);
			}
		}
	}

	function addGlobalNdc(item) {
		// add a global ndc to the affiliation list for the same type

		if(vm.isWaiting) {
			return;
		}

		// must have ndc
		if(!!!item || !validSvc.isText(item.ItemCode)) {
			throw new Error('ndcEdit.addGlobalNdc, NDC required');
		}

		var saveModel = {
			ItemCode: item.ItemCode
		};

		switch(item.Type) {
			case 'OP':
				if(!validSvc.isText(item.AltItemCode)) {
					throw new Error('ndcEdit.addGlobalNdc, AltItemCode required');
				}
				saveModel.AltItemCode = item.AltItemCode;
				break;
			case 'REB':
			case 'IRA':
				// no extra validation needed
				break;
			default:
				throw new Error('ndcEdit.addGlobalNdc, unknown item type: ' + item.type);
		}

		toggleWait(true);
		ndcRepo.save(vm.context, saveModel).then(okAddGlobal, errAddGlobal);

		function okAddGlobal(r) {
			toggleWait();
			setDirty();

			// clear editing so user can add another
			filterChange(true);

			var msg = '';
			switch(item.Type) {
				case 'OP':
					msg = 'Now using global Outer Pack';
					break;
				case 'REB':
					msg = 'Now using global Rebate on affiliation';
					break;
				case 'IRA':
					msg = 'Now opted-out on affiliation';
					break;
				default:
					throw new Error('ndcEdit.addGlobalNdc, unknown item type: ' + item.type);
			}
			msgSvc.ok('GLOBAL ITEM ADDED', msg);

			$timeout(function() {
				getList();
			}, 500);
		}

		function errAddGlobal(r) {
			toggleWait();
			if(!!r && (r.status == 422 || r.status == 409)) {
				msgSvc.ok('Cannot Save', r.msg);
			}
		}
	}

	function ndcExists(ndc, items, propName, ignoreInactive) {
		items = Array.isArray(items) ? items : [];
		var item = {};
		for(var i = 0; i < items.length; i++) {
			item = items[i];
			if(!!ignoreInactive && item.ObjectState == 'INACTIVE') {
				continue;
			}
			if(ndc == item[propName]) {
				return true;
			}
		}
		return false;
	}

	function toggleStatus() {
		if(vm.isWaiting || !!!vm.popup || vm.popup.action != 'UPDATE') {
			return;
		}

		var m = vm.popup;
		m.ObjectState = m.ObjectState == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
		
		toggleWait(true);
		ndcRepo.updateStatus(vm.context, m.ItemCode.val, m.AltItemCode.val, m.ObjectState).then(okStatus, errStatus);	

		function okStatus(r) {
			toggleWait();
			setDirty();
			msgSvc.ok('STATUS CHANGED TO ' + vm.popup.ObjectState);
			closePopup();
		}

		function errStatus(r) {
			toggleWait();
			if(!!r && (r.status == 409 || r.status == 422)) {
				msgSvc.ok('Cannot Change Status', r.msg);
			}
		}
	}


	/**
	 * 		CLONE
	 */
	function cloneToVM(item) {
		return {
			uniqueId: item.uniqueId,
			CEID: item.CEID,
			RXID: item.RXID,
			Vendor:item.Vendor,
			AcctType:item.AcctType,
			AcctId: item.AcctId
		};
	}
	function cloneToggleList(action) {
		if(vm.isWaiting || !!!vm.popup || vm.popup.type != 'CLONE') {
			return;
		}

		var dataItems = Array.isArray(vm.popup.DataItems) ? vm.popup.DataItems : [];
		var filteredMap = {};
		if(action == 'ALL') {
			// select all filtered items without paging
			var flt = JSON.parse(JSON.stringify(vm.popup.flt)); // de-ref deep copy
			flt.PageSize = 10000000;
			var filteredItems = vm.filterList(dataItems, flt);

			// max 20 clone targets for CE scope
			if(filteredItems.length > 20 && vm.context.listScope == 'CE') {
				msgSvc.ok('Cannot Select', 'Maximum 20 Facility selections allowed');
				return;
			}

			// build map
			filteredItems.forEach(function(item) {
				filteredMap[item.uniqueId] = true;
			});
		}

		var checked = action == 'ALL';
		vm.popup.cloneTo = [];

		// set data items and rebuild cloneTo items
		dataItems.forEach(function(item) {
			item.checked = checked;
			if(checked && !!filteredMap[item.uniqueId]) {
				vm.popup.cloneTo.push(cloneToVM(item));
			}
		});
	}

	function cloneToggleItem(item) {
		if(vm.isWaiting || !!!vm.popup || vm.popup.type != 'CLONE' || !item) {
			return;
		}

		// max 20 clone targets for CE scope
		if(vm.popup.cloneTo.length >= 20 && !!!item.checked && vm.context.listScope == 'CE') {
			msgSvc.ok('Cannot Select', 'Maximum 20 Facility selections allowed');
			return;
		}
		
		// find and toggle item
		var listItem = vm.popup.DataItems.find(function(l){
			return l.uniqueId == item.uniqueId;
		});
		listItem.checked = !!!item.checked;

		// modify cloneTo list
		if(listItem.checked) {
			// add item
			vm.popup.cloneTo.push(cloneToVM(item));
		}
		else {
			// remove item
			vm.popup.cloneTo = vm.popup.cloneTo.filter(function(clone){
				return clone.uniqueId != item.uniqueId;
			});
		}
	}

	function cloneStart() {
		if(vm.isWaiting || !!!vm.popup || vm.popup.type != 'CLONE' || vm.popup.action == 'BATCH') {
			return;
		}

		var cloneToLen = Array.isArray(vm.popup.cloneTo) ? vm.popup.cloneTo.length : 0;
		if (cloneToLen < 1) {
			msgSvc.ok('Cannot Clone', 'Choose at least one item to Clone To');
			return;
		}

		var lbl = vm.context.editGPI ? 'GPI' : 'NDC';

		// start clone batch confirm
		msgSvc.confirm({
			id: 'ops.ndcedit.confirm.clone',
			title: 'CONFIRM ' + lbl + ' CLONE TO ' + cloneToLen + ' ACCOUNTS',
			msg: 'Warning: once cloned, the current list of ACTIVE ' + lbl + ' records will be replaced by the contents of this list. All other NDCs not included in this list will be changed to INACTIVE.',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(msgConfirm, msgConfirm);

		function msgConfirm(r) {
			// user said yes
			if (!!r && r.result == 'YES') {
				vm.isWaiting = true;
				vm.popup.action = 'BATCH';
				nextClone();
			}
		}
	}

	function nextClone() {
		if(!!!vm.popup || vm.popup.type != 'CLONE' || vm.popup.action != 'BATCH') {
			return;
		}

		// get first incomplete
		var cloneItems = vm.popup.cloneTo,
			nextCloneIdx = -1;
		for(var i = 0; i < cloneItems.length; i++) {
			if(!!!cloneItems[i].done && !!!cloneItems[i].errMsg) {
				nextCloneIdx = i;
				break;
			}
		}

		// batch cancelled by user
		if(nextCloneIdx > -1 && vm.popup.action == 'BATCH' && vm.popup.cloneCancel) {
			vm.isWaiting = false;
			msgSvc.ok('Clone Cancelled', 'See results for errors');
			return;
		}

		// batch done?
		if(nextCloneIdx < 0) {
			vm.isWaiting = false;
			vm.popup.action = 'DONE';
			msgSvc.ok('Clone Complete', 'See results for errors');
			return;
		}
		vm.isWaiting = true;

		// set current clone
		vm.popup.cloneBatchIdx = nextCloneIdx;
		var cloneTo = cloneItems[nextCloneIdx];
		ndcRepo.clone(vm.context, cloneTo.CEID, cloneTo.RXID, cloneTo.AcctId).then(okClone, errClone);
	}

	function okClone(r) {
		setDirty();
		if(!!vm.popup && Array.isArray(vm.popup.cloneTo) && vm.popup.cloneBatchIdx < vm.popup.cloneTo.length) {
			vm.popup.cloneTo[vm.popup.cloneBatchIdx].done = true;
		}
		$timeout(function(){
			nextClone();
		},200);
	}

	function errClone(r) {
		
		// exit
		if(!!!r) {
			closePopup();
			return;
		}

		// log error try next clone
		if(r.status == 409 || r.status == 422) {
			var cloneIdx = vm.popup.cloneBatchIdx;
			vm.popup.cloneTo[cloneIdx].err = true;
			vm.popup.cloneTo[cloneIdx].errMsg = !!r.timeout ? 'clone still running on server (timeout)' : r.msg;
			nextClone();
			return;
		}

		// unknown issue
		toggleWait();
		msgSvc.ok('Clone Stopped', 'Major unrecoverable clone error: ' + utilSvc.http.safeResponse(r));
	}

	function cloneStop() {
		if(!!!vm.popup || vm.popup.type != 'CLONE' || vm.popup.action != 'BATCH') {
			return;
		}

		vm.popup.cloneCancel = true;
	}


	/**
	 * 		EXCEL / FILE IMPORT
	 */

	function getExcel() {
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}
		toggleWait(true);
		ndcRepo.getExcel(vm.context).then(okExcel, errExcel);

		function okExcel(binaryData) {
			toggleWait();

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(vm.context.title + " Export.xlsx"));
			}
			catch(err) {
				throw(err);
			}
		}

		function errExcel(r) {
			toggleWait();

			if(r !== null) {
				errSvc.warn('Create Excel Error', 'ndcEdit.errExcel', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}
	
	function importValidFile(newFile) {
		// required
		if(!!!newFile) {
			return 'no file selected';
		}

		// file size > 0 bytes, < 10 megabytes
		if(!validSvc.isNumber(newFile.size) || newFile.size < 1 || newFile.size > 10000000) {
			return 'file size must be 2 bytes to 10 megabytes';
		}

		// file name must be .csv
		var fName = newFile.name;
		if(!validSvc.isText(fName) || fName.length < 5 || (fName.substr(fName.length - 4, 4).toLowerCase() !== '.csv' && fName.substr(fName.length - 4, 4).toLowerCase() !== '.txt')) {
			return 'file name must end with extension ".csv" or ".txt"';
		}

		return 'ok';
	}

	function importFile() {
		if ((vm.context.key == 'GLOBAL_IRA') && !vm.importYear) {
			msgSvc.ok('Year Required', 'Please select a year before uploading.');
			return;
		}
		if(vm.isWaiting) {
			return;
		}

		// files selected
		if(!!!vm.importSelectedFiles || vm.importSelectedFiles.length !== 1) {
			msgSvc.ok('File Import', 'Please choose 1 file to upload.');
			return;
		}

		// validate file
		var fileFail = importValidFile(vm.importSelectedFiles[0]);
		if(fileFail != 'ok') {
			msgSvc.ok('File Import', 'Selected file error: ' + fileFail);
			return;
		}

		msgSvc.confirm({
			id: 'ndc.edit.import',
			title: 'Confirm NDC Import',
			msg: 'Warning: once uploaded, the current list of ACTIVE NDC records will be replaced by the contents of this file.  All other NDCs not included in this file will be changed to INACTIVE.',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmImportCsv, confirmImportCsv);

	}

	function confirmImportCsv(r) {

		if(!!r && r.result == 'YES') {
			toggleWait(true);
			if (!!vm.importYear) {
				vm.context.importYear = vm.importYear;
			}
			ndcRepo.importFile(vm.context, vm.importSelectedFiles[0]).then(okFileImport, errFileImport);
		}

		function okFileImport(r) {
			toggleWait();
			setDirty();
			handleImportResult(r);
		}

		function errFileImport(r) {
			toggleWait();
            if (!!r && r.status == 409) {
				msgSvc.ok("Cannot Import ",r.data.error);
			}
			else if (!!r && r.status == 422) {
				handleImportResult(r);
			}
			else if(!!r) {
				errSvc.error('Unexpected api error', 'ndc.edit.errFileImport', r.status, utilSvc.http.safeResponse(r));
			}
		}

		function handleImportResult(r) {
			var ProcessedCount = validSvc.isInteger(r.ProcessedCount) ? r.ProcessedCount : 0,
				ReceivedCount = validSvc.isInteger(r.ReceivedCount) ? r.ReceivedCount : 0;
								
			// show results in popup
			vm.popup.action = 'IMPORT_RESULT';
			vm.popup.ProcessedCount = ProcessedCount;
			vm.popup.ReceivedCount = ReceivedCount;
			vm.popup.ErrorCount = validSvc.isInteger(r.ErrorCount) ? r.ErrorCount : 0;
			vm.popup.DuplicateCount = validSvc.isInteger(r.DuplicateCount) ? r.DuplicateCount : 0;
			vm.popup.errors = Array.isArray(r.RecordErrors) ? r.RecordErrors : [];
			
			// all imports processed
			if(r.status == 200 && ProcessedCount == ReceivedCount) {
				msgSvc.okAsync('NDC List Replaced', ProcessedCount + ' Items Imported', 'ndc.edit.imported');
				closePopup();
				return;
			}
			else if(r.status == 422) {
				// has Fields?
				var fieldErrors = '',
					ent = r.data.Entity;
				if(Array.isArray(ent.Fields) && ent.Fields.length > 0) {
					fieldErrors = ', field errors: ' + ent.Fields.join(', ');
				}
				msgSvc.ok('Cannot Import File', 'Please fix data errors before uploading file' + fieldErrors);
			}
		}
	}


	/**
	 * 		HELPERS
	*/

	function setDirty() {
		vm.context.isDirty = true;
		$scope.$emit('ops.ndcedit.status', {
			dirty: true,
			exit: false
		});
	}

	function exit() {
		// message parent to close host popup (and possible refresh its lists)
		$scope.$emit('ops.ndcedit.status', {
			dirty: !!vm.context.isDirty,
			exit: true
		});
	}

	function toggleWait(isOn) {
		vm.isWaiting = !!isOn;
		msgSvc.wait(!!isOn);
	}

	function setTableFilter(colName, fltVal) {
		var cols = vm.tblView.cols,
			col = {};
		for(var i = 0; i < cols.length; i++) {
			col = cols[i];
			if(col.name == colName) {
				col.flt = fltVal;
				return;
			}
		}
	}

	function getTableFilterVal(colName) {
		var cols = vm.tblView.cols,
			col = {};
		for(var i = 0; i < cols.length; i++) {
			col = cols[i];
			if(col.name == colName) {
				return col.flt;
			}
		}
		return undefined;
	}

	function ndcCleanUp(val, skipEmpty, len) {

		var zeroPad = "00000000000",
			ndcTest = '';

		function failProp(val,msg) {
			return {
				val: val,
				msg: msg,
				fail:'yes'
			};
		}

		// must be text
		if(!!!skipEmpty && !validSvc.isText(val)) {
			return failProp(val, 'required');
		}

		// remove all non-numeric characters
		ndcTest = val.toString().trim();
		ndcTest = ndcTest.replace(/[^0-9]+/g,'');

		// empty
		if(ndcTest.length < 1) {
			return !!skipEmpty ? validSvc.newProp('') : failProp('', 'empty');
		}

		// max len
		if(ndcTest.length != len) {
			return failProp(ndcTest, len.toString() + ' characters required');
		}

		// integer
		if(!validSvc.isInteger(parseInt(ndcTest))) {
			return failProp(ndcTest, 'must be an integer');
		}

		// pad zeros if needed, pass
		// no pad ndcTest = zeroPad.substr(0, 11 - ndcTest.length) + ndcTest;
		
		return validSvc.newProp(ndcTest, false, '');
	}

	function clearNdcAutoSearch(clearTableFilter) {
		// clear both ndc and alternat ndc (undefined is used on purpose to reset widget)
		vm.ndcInput = undefined;
		vm.ndcDesc = {};
		vm.altNdcInput = undefined;
		vm.altNdcDesc = {};	
		if(!!clearTableFilter) {
			setTableFilter('ItemCode', '');
			setTableFilter('AltItemCode', '');
		}
	}
}
 
ndcListCtl.$inject = ['$state', '$scope', '$timeout', 'ndcRepo', 'lookupRepo', 'sessionRepo', 'msgSvc', 'utilSvc', 'validSvc', 'errSvc'];
angular
.module('espui.ops')
.controller('NdcListCtl', ndcListCtl);


/* @ngInject */
function ndcListCtl($state, $scope, $timeout, ndcRepo, lookupRepo, sessionRepo, msgSvc, utilSvc, validSvc, errSvc) {

	/*jshint validthis: true */
	var vm = this,
		_featureName = '',
		_ndcEditListener = false,
		_ceLookupDone = false,
		_mouseLeaveDelay = {};

	// inherit
	utilSvc.ctl.addFlexTop(vm);
	utilSvc.ctl.addMultiselect(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.isVeriSaveOnly = false;

	// query multiselect
	vm.CeMulti = {};
	vm.RxMulti = {};
	vm.VenMulti = {};
	vm.multiClick = multiClick;
	vm.multiToggle = multiToggle;
	vm.multiHover = multiHover;

	// query
	vm.query = {};
	vm.queryChange = queryChange;
	vm.queryChangeSearchType = queryChangeSearchType;
	vm.queryChangeCE = queryChangeCE;
	vm.queryChangeRX = queryChangeRX;
	vm.queryChangeVEN = queryChangeVEN;
	vm.querySubmit = querySubmit;

	// lists
	vm.global = {};
	vm.ce = {};
	vm.rx = {};

	// methods
	vm.toggleSection = toggleSection;

	// flex top
	vm.flex = {};
	vm.flexTopExpand = flexTopExpand;

	// popup
	vm.popup = {};
	vm.closePopup = closePopup;
	vm.openPopup = openPopup;
	

	/**
	 *    EVENTS
	 */
		
	_ndcEditListener = $scope.$on('ops.ndcedit.status', function(event, evtData) {
		event.stopPropagation();
		if(!!vm.popup && !!evtData) {
			vm.popup.dirty = !!evtData.dirty;
			if(!!evtData.exit) {
				$timeout(closePopup, 300);
			}
		}
	});
	

	/**
	 *    DESTROY
	 */

	$scope.$on('$destroy', function() {
		if(_ndcEditListener) {
			_ndcEditListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		_featureName = $state.current.name;

		vm.isVeriSaveOnly = !!$scope.User.VeriSaveOnly;

		vm.init = true;
		vm.flex = vm.flexInit();

		initListDisplay();
		vm.query = initQueryAndViewstate($scope.User);
		queryChangeSearchType();

		vm.init = false;
	}

	function initListDisplay() {
		vm.global = listDisplayVM();
		vm.ce = listDisplayVM();
		vm.rx = listDisplayVM();
		vm.aff = listDisplayVM();
		vm.ven = listDisplayVM();
	}

	function getAffs() {
		var affStatus = vm.query.isVerity ? ['ACTIVE', 'ONBOARDING'] : ['ACTIVE'];
		var affs = utilSvc.aff.findStatus($scope.User.AffList, affStatus);
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
		return utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));
	}

	function initQueryAndViewstate(usr) {

		var q = {
			isVerity: usr.Type == 'VERITY' || usr.Type == 'VERITYSA',
			SearchType: vm.isVeriSaveOnly ? 'CE' : 'GLOBAL',
			CE: validSvc.newProp(usr.CE),
			RX: validSvc.newProp(usr.RX),
			VEN: validSvc.newProp('NONE'),
			NDC: newCheckProp(''),
			CeOwnUseProgram: false,
			CeVerityPrimary: false
		};

		var vs = sessionRepo.get('vs-ops-centralndc-list');
		if(!!vs) {
			q.SearchType = vs.SearchType;
			q.CE.val = vs.CE;
			q.RX.val = vs.RX;
			q.VEN.val = vs.VEN;
			q.CeOwnUseProgram = vs.CeOwnUseProgram;
			q.CeVerityPrimary = vs.CeVerityPrimary;
		}

		// multiselects
		var ceList = utilSvc.aff.ceList(getAffs());
		vm.CeMulti = {
			type: 'CE',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'Choose a Facility',
			titleNoOptions: 'Choose a Facility',
			vals: [],
			list: vm.multiselectBuild(ceList),
			flt: ''
		};
		vm.RxMulti = {
			type: 'RX',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'Choose a Pharmacy',
			titleNoOptions: 'Choose a Pharmacy',
			vals: [],
			list: [], // search type or query change will set the list
			flt: ''
		};
		vm.VenMulti = {
			type: 'VEN',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'Choose an Account',
			titleNoOptions: 'Choose an Account',
			vals: [],
			list: [], // query change will set the list
			flt: ''
		};
		
		return q;
	}

	function newCheckProp(val) {
		var prop = validSvc.newProp(val);
		prop.chk = false;
		return prop;
	}



	/**
	 *    VIEW MODEL
	 */

	function listDisplayVM(dataItems) {
		dataItems = Array.isArray(dataItems) ? dataItems : [];
		var items = [],
			isVSO = vm.isVeriSaveOnly;

		// verisave only does not support Non 340b option
		for(var i = 0; i < dataItems.length; i++) {
			if(!isVSO || (isVSO && dataItems[i].key != 'NON_340B')) {
				items.push(dataItems[i]);
			}
		}

		return {
			expand: items.length > 0,
			items: items
		};
	}


	/**
	 *    QUERY CHANGE
	 */

	function queryChange() {
		if(!vm.init && !vm.isWaiting) {
			initListDisplay();
			vm.action = '';
			vm.flex = vm.flexInit();
			closePopup();
		}
	}

	function queryChangeSearchType() {
		queryChange();
		
		var q = vm.query;
		switch(q.SearchType) {
			case 'GLOBAL':
				vm.CeMulti.vals = [];
				resetMulti(vm.RxMulti);
				resetMulti(vm.VenMulti);
				break;
			case 'RX':
				vm.CeMulti.vals = [];
				resetMulti(vm.VenMulti);
				resetMulti(vm.RxMulti);
				var rxList = utilSvc.aff.rxList($scope.User.AffList);
				vm.RxMulti.list = vm.multiselectBuild(rxList, false);
				queryChangeRX(q.RX.val);
				break;
			case 'CE':
			case 'AFF':
			case 'VEN':
				queryChangeCE(q.CE.val);
				break;
			default:
				throw new Error('ndcMain.qcSearchType, unknown search type: ' + q.SearchType);
		}
	}

	function queryChangeCE(ceid) {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		// reset dependents
		resetMulti(vm.RxMulti);
		resetMulti(vm.VenMulti);

		// reset CE lookup properties on CE change
		_ceLookupDone = false;
		var q = vm.query;
		q.CeOwnUseProgram = false;
		q.CeVerityPrimary = false;

		q.CE = validSvc.newProp(ceid);
		q.CE.fail = validSvc.isCE(q.CE.val) ? 'no' : 'yes';
		vm.CeMulti.title = q.CE.fail == 'yes' ? vm.CeMulti.titleNoOptions : q.CE.val;
		if(q.CE.fail == 'yes') {
			q.RX = validSvc.newProp('NONE');
			return;
		}

		// RX options
		if(q.SearchType == 'AFF' || q.SearchType == 'VEN') {
			var affs = utilSvc.aff.findCe(getAffs(), q.CE.val);
			var rxList = utilSvc.aff.rxList(affs);
			vm.RxMulti.list = vm.multiselectBuildRX(rxList, false, affs);

			// if list only has 1 item or viewstate is found use value, otherwise reset to NONE
			queryChangeRX(rxList.length == 1 ? rxList[0] : rxList.indexOf(q.RX.val) > -1 ? q.RX.val : 'NONE');
		}
	}

	function queryChangeRX(rxid) {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		// reset dependents
		resetMulti(vm.VenMulti);

		var q = vm.query;
		q.RX = validSvc.newProp(rxid);
		q.RX.fail = validSvc.isRX(q.RX.val) ? 'no' : 'yes';
		vm.RxMulti.title = q.RX.fail == 'yes' ? vm.RxMulti.titleNoOptions : utilSvc.aff.rxShortNameByIdLookup(q.RX.val);
		if(q.RX.fail == 'yes') {
			q.VEN = validSvc.newProp('NONE');
			return;
		}

		// get vendor accounts
		if(vm.query.SearchType == 'VEN') {
			getVendorAccounts(vm.query.CE.val, vm.query.RX.val);
		}
	}

	function queryChangeVEN(venid) {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		var q = vm.query;
		q.VEN = validSvc.newProp(venid);
		vm.VenMulti.title = vm.VenMulti.titleNoOptions;
		q.VEN.fail = validSvc.isVEN(q.VEN.val) ? 'no' : 'yes';
		if(q.VEN.fail == 'yes') {
			return;
		}

		// get title from id
		var venList = vm.VenMulti.list;
		for(var i = 0; i < venList.length; i++) {
			if(venList[i].val == venid) {
				vm.VenMulti.title = venList[i].lbl;
				q.VEN.title = venList[i].lbl;
			}
		}
	}


	/**
	 *    TOGGLE NDC LIST SECTIONS
	 */

	function toggleSection(listType) {
		if(vm.isWaiting) {
			return;
		}

		var lt = listType.toLowerCase();
		vm[lt].expand = !vm[lt].expand;
	}


	/**
	 *    GET LIST COUNTS
	 */

	function queryValid(q) {
		switch(q.SearchType) {
			case 'GLOBAL':
				return true;
			case 'CE':
				q.CE.fail = validSvc.isCE(q.CE.val) ? 'no' : 'yes';
				return q.CE.fail == 'no';
			case 'RX':
				q.RX.fail = validSvc.isRX(q.RX.val) ? 'no' : 'yes';
				return q.RX.fail == 'no';
			case 'AFF':
				q.CE.fail = validSvc.isCE(q.CE.val) ? 'no' : 'yes';
				q.RX.fail = validSvc.isRX(q.RX.val) ? 'no' : 'yes';
				return q.CE.fail == 'no' && q.RX.fail == 'no';
			case 'VEN':
				q.CE.fail = validSvc.isCE(q.CE.val) ? 'no' : 'yes';
				q.RX.fail = validSvc.isRX(q.RX.val) ? 'no' : 'yes';
				q.VEN.fail = validSvc.isVEN(q.VEN.val) ? 'no' : 'yes';
				return q.CE.fail == 'no' && q.RX.fail == 'no' && q.VEN.fail == 'no';
			default:
				throw new Error('ndcMain.queryValid, unknown search type: ' + q.SearchType);
		}

		// tbd... search options
		// if(q.VEN.chk) {
		// 	q.VEN.fail = validSvc.isVEN(q.VEN.val) ? 'no' : 'yes';
		// }
		// else {
		// 	q.VEN.fail = 'no';
		// }

		// q.NDC.fail = q.NDC.chk ? 'yes' : 'no';
		// if(q.NDC.chk && validSvc.isText(q.NDC.val)) {
		// 	q.NDC.fail = q.NDC.val.length == 11 ? 'no' : 'yes';
		// }
	}

	function querySubmit() {
		if(!queryValid(vm.query)) {
			msgSvc.ok('Cannot Search', 'Check parameters');
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true);

		// lookup extra CE properties before submit
		if(vm.query.SearchType != 'GLOBAL' && vm.query.SearchType != 'RX' && validSvc.isCE(vm.query.CE.val) && !_ceLookupDone) {
			lookupCE(vm.query.CE.val);
			return;
		}

		ndcRepo.getListCounts(vm.query).then(okListCounts, errListCounts);

		function okListCounts(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			saveViewState(vm.query);

			var st = vm.query.SearchType.toLowerCase();
			vm[st] = listDisplayVM(r.items);
			vm.query.EntityId = r.EntityId;

			if(vm[st].items.length < 1) {
				msgSvc.ok('Lists Not Available', 'No NDC lists are available for this search.');
			}

			// force top collapse after good query
			vm.flex = vm.flexCollapse(vm.flex, true);

			vm.action = 'LIST';
		}
	}

	function errListCounts(r) {
		msgSvc.wait(false);
		vm.isWaiting = false;

		if(!!r) {
			errSvc.error('Unknown list count error', 'ndcListCtl.errListCounts', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 * 		CE LOOKUP
	 */

	function lookupCE(ceid) {
		// ASYNC: get ce properties before running count query
		lookupRepo.CeInfo([ceid]).then(okLookupCe, errLookupCe);
	}

	function okLookupCe(items) {
		if(!Array.isArray(items) || items.length !== 1) {
			alert('opsNdcMain.LookupCE, lookup did not find CE: ' + ceid);
			return;
		}

		// load lookup props on query
		var ceInfo = items[0];
		_ceLookupDone = true;
		vm.query.CeOwnUseProgram = !!ceInfo.OwnUseProgram;
		vm.query.CeVerityPrimary = !!ceInfo.IsVerityPrimary;

		// finish submit
		querySubmit();
	}

	function errLookupCe(r) {
		if(!!r) {
			errSvc.warn('Error looking up ce display properties', 'ndcMain.lookupCe', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 * 		GET VENDOR ACCOUNTS
	 */
	function getVendorAccounts(ceid, rxid) {
		// ASYNC: get vendor accounts for this CE/RX
		toggleWait(true);
		ndcRepo.getOrderAcctList(ceid, rxid).then(okGetVenAccts, errGetVenAccts);

		function okGetVenAccts(items) {
			toggleWait();
			if(!Array.isArray(items) || items.length < 1) {
				msgSvc.ok('No Vendors Found', 'No vendor accounts exist for this affiliation');
				return;
			}

			resetMulti(vm.VenMulti);
			var multiList = [],
				venId = validSvc.isVEN(vm.query.VEN.val) ? vm.query.VEN.val : '',
				foundId = 'NONE';
			items.forEach(function(ven) {
				var objst = ven.ObjectState == 'ACTIVE' ? '' : (' (' + ven.ObjectState + ')');
				multiList.push({checked:false, lbl:ven.Vendor + ': ' + ven.AccumulatorType + objst, val:ven.Id});
				if(!!venId && foundId == 'NONE' && venId == ven.Id) {
					foundId = ven.Id;
				}
			});
			vm.VenMulti.list = utilSvc.array.sortTextASC(multiList, 'lbl');

			// auto-select if list has 1 option
			if(foundId == 'NONE' && multiList.length == 1) {
				foundId = multiList[0].val;
			}

			queryChangeVEN(foundId);
		}
	
		function errGetVenAccts(r) {
			toggleWait();
			if(!!r) {
				errSvc.warn('Error looking up ce display properties', 'ndcMain.lookupCe', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 * 		NDC EDITING POPUP
	 */

	function openPopup(listKey) {
		if(vm.isWaiting) {
			return;
		}

		// always / never order cannot both have active ndcs
		if(!validAlwaysNeverOrderQty(listKey)) {
			return;
		}

		// main controls popup, content in popup is done in ndc.edit.html
		vm.popup = {
			key: listKey,
			show: true,
			dirty: false
		};

		$timeout(function(){
			var q = vm.query;
			$state.go('ops.ndclist.edit', {
				ListKey: listKey, 
				CE:q.CE.val, 
				RX:q.RX.val, 
				VEN:q.VEN.val, 
				VenTitle:q.VEN.title, 
				EntityId: q.EntityId,
				CeVerityPrimary:q.CeVerityPrimary
			}, {reload: 'ops.ndclist.edit'});
		}, 500);
	}

	function validAlwaysNeverOrderQty(listKey) {
		if(listKey != 'ALWAYS_ORDER' && listKey != 'NEVER_ORDER') {
			return true;
		}

		// find both list totals
		var alwaysCount = 0,
			neverCount = 0;
		vm.ven.items.forEach(function(item){
			if(item.key == 'ALWAYS_ORDER') {
				alwaysCount = item.count;					
			}
			else if(item.key == 'NEVER_ORDER') {
				neverCount = item.count;					
			}
		});

		// If both list have items already, allow edit so user can get rid of one of the list
		if (alwaysCount > 0 && neverCount > 0) {
			return true;
		}

		// if the other list has active items, block list access
		var blockAccess = false,
			listTitle = '',
			otherTitle = '';
		if (listKey == 'ALWAYS_ORDER' && neverCount > 0) {
			blockAccess = true;
			listTitle = 'Always';
			otherTitle = 'Never';
		}
		else if(listKey == 'NEVER_ORDER' && alwaysCount > 0) {
			blockAccess = true;
			listTitle = 'Never';
			otherTitle = 'Always';
		}
		if(blockAccess) {
			var errTxt = listTitle + ' Order list cannot be accessed when ' +
				otherTitle + ' Order has ACTIVE Items. Set all ' + otherTitle + ' Order items' +
				' to INACTIVE to use the ' + listTitle + ' Order list.';
			msgSvc.ok('Cannot Access List', errTxt);
			return false;
		}

		return true;
	}

	function closePopup() {
		if(!!!vm.popup) {
			return;
		}
		var isDirty = vm.popup.dirty;
		vm.popup = {};

		// requery totals if something changed on popup
		if(!!isDirty) {
			queryChange();
			querySubmit();
		}
	}

	// VIEWSTATE
	function saveViewState(q) {
		sessionRepo.set('vs-ops-centralndc-list', {
			SearchType: q.SearchType,
			CE: q.CE.val,
			RX: q.RX.val,
			VEN: q.VEN.val,
			CeOwnUseProgram: !!q.CeOwnUseProgram,
			CeVerityPrimary: !!q.CeVerityPrimary
		});
	}
	

	/**
	 * 		MULTISELECT
	 */

	function multiClick(propName, val) {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		switch(propName) {
			case 'CeMulti':
				queryChangeCE(val);
				break;
			case 'RxMulti':
				queryChangeRX(val);
				break;
			case 'VenMulti':
				queryChangeVEN(val);
				break;
			default:
				throw new Error('ndcList.multiClick, unknown propName: ' + propName);
		}

		// by-passing all multiselect events and vals
		// this is a simple droplist
		_mouseLeaveDelay[propName] = 0;
		vm[propName].show = false;
	}

    function multiToggle(evt, id) {
		var multi = vm[id];
		multiselectToggle(evt, multi, 'ndcList' + id);
	}

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if(vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		//multiselect.flt = '';

		// don't bother with width if hiding
		if(multiselect.show) {
			multiselect.show = false;
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;

		// set focus on filter
		if(multiselect.list.length > 10) {
			$timeout(function(){
				try {
					var inputElem = document.getElementById(id + 'Find');
					if(!!inputElem) {
						inputElem.focus();
						inputElem.setSelectionRange(0,9999);
					}
					inputElem = null;
				}
				catch(err) {
					// do nothing
				}
			},300);
		}

	}

	function multiHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 750) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}

	function resetMulti(multi) {
		multi.vals = [];
		multi.list = [];
		multi.title = multi.titleNoOptions;
		multi.filter = '';
	}

	
	/**
	 *    HELPERS
	*/

	function flexTopExpand() {
		// user opened search query, reset list display, show search expanded
		queryChange();
	}

	function toggleWait(isOn) {
		vm.isWaiting = !!isOn;
		msgSvc.wait(!!isOn);
	}

}
 
npiRepo.$inject = ['$rootScope', '$q', 'apiService', 'apiErrors', 'appConst', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
.module('espui.ops')
.factory('npiRepo', npiRepo);


/* @ngInject */
function npiRepo($rootScope, $q, apiService, apiErrors, appConst, errSvc, eventSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _currentPurl = '',
		_apiPaging = vmSvc.api.paging(),
		_modelPending = {};

	// service definition
	var service = {
		getList: getList,
		getDetails: getDetails,

		// npi
		editModelVM: editModelVM,
		add: add,
		reviewSave: reviewSave,
		reviewDelete: reviewDelete,
		toggleLock: toggleLock,

		toggleStatus: toggleStatus,
		// period
		addPeriod: addPeriod,
		updatePeriod: updatePeriod,

		setAllStarts: setAllStarts,
		getExcel: getExcel,

		fileUpload: fileUpload,
		purge: purge

	};

	return service;


	/**
	 *    VIEW MODELS
	 */

	function deriveReviewType(item) {

		if(!validSvc.isText(item.Type)) {
			// this should not happen, if Referral is true, just use generic REVIEW
			return 'REVIEW';
		}

		switch(item.Type) {
			case 'FLT':
			case 'FLOATING':
				return 'FLOATING';
			case 'REF':
			case 'REFERRAL':
				return 'REFERRAL';
			case 'BLK':
			case 'BLOCKED':
				return 'BLOCKED';
			default:
				// use type as is
				return item.Type;
		}

	}

	function apiReviewType(type) {

		switch(type) {
			case 'FLT':
			case 'FLOATING':
				return 'FLT';
			case 'REF':
			case 'REFERRAL':
				return 'REF';
			case 'BLK':
			case 'BLOCKED':
				return 'BLK';
			default:
				alert('npiRepo.apiReviewType, unknown type: ' + type);
				return '';
		}

	}

	function savedNpiVM(item) {

		// converts an api saved npi into a read version

		item = item || {};

		item.Npi = validSvc.isText(item.Npi) ? item.Npi : '';
		item.Name = validSvc.isText(item.Name) ? item.Name : '';
		item.ProcessDate = validSvc.isDate(item.ProcessDate) ? item.ProcessDate : null;
		item.Periods = Array.isArray(item.Periods) ? item.Periods : [];
		item.ChangeHistory = Array.isArray(item.ChangeHistory) ? item.ChangeHistory : [];

		// combine Locked and referral NPIs into one list
		if(!!item.Referral) {
			item.Type = deriveReviewType(item);
			// item.Status = 'ACTIVE';
			item.Status = item.State;
			item.StartDate = item.ProcessDate;
			item.EndDate = null;
			item.Resident = 'n/a';
			item.Exclusive = 'n/a';
		}
		else {
			item.Type = !!item.Locked ? 'LOCKED' : 'STANDARD';

			// derive effective period and use its properties
			item.Status = item.State;
			var effectivePeriod = {};
			switch(item.Status) {
				case 'NEW':
				case 'ACTIVE':
				case 'INACTIVE':
					effectivePeriod = item.Periods[item.Periods.length - 1];
					break;
				case 'MODIFIED-ACTIVE':
				case 'MODIFIED-INACTIVE':
					effectivePeriod = item.Periods[item.Periods.length - 2];
					break;
				default:
					alert('npiRepo.savedNpiVM, unknown Status: ' + item.Status);
			}

			// load effective settings for display
			item.StartDate = validSvc.isDate(effectivePeriod.StartDate) ? effectivePeriod.StartDate : null;
			item.EndDate = validSvc.isDate(effectivePeriod.EndDate) ? effectivePeriod.EndDate : null;
			item.Resident = !!effectivePeriod.Resident ? 'YES' : 'NO';
			item.Exclusive = !!effectivePeriod.Exclusive ? 'YES' : 'NO';
		}

		item.isReviewType = item.Type == 'REFERRAL' || item.Type == 'FLOATING' || item.Type == 'BLOCKED';

		return item;

	}

	function editModelVM(data) {
		// switch from saved VM to Editing VM
		// NOTE: for validation both the Effective and Modified future period are loaded into the VM
		// Eff prefix = Effective period
		// Mod prefix = Modified future period

		data = data || {};

		var dtMin;
		var m = {
			Status: validSvc.isText(data.Status) ? data.Status : 'NEW',
			StatusTxt: validSvc.isText(data.Status) ? data.Status : 'NEW',
			Type: validSvc.isText(data.Type) ? data.Type : '',
			Npi: validSvc.newProp(validSvc.isText(data.Npi) ? data.Npi : ''),
			Name: validSvc.newProp(validSvc.isText(data.Name) ? data.Name : ''),
			isModified: false,
			EditStartDate: {},
			EditEndDate: {},
			Periods: Array.isArray(data.Periods) ? data.Periods : [],
			ChangeHistory: Array.isArray(data.ChangeHistory) ? data.ChangeHistory : []
		};
		m.isReviewType = m.Type == 'REFERRAL' || m.Type == 'FLOATING' || m.Type == 'BLOCKED';
		
		// clean up Periods array properties
		var p = {};
		for(var i = 0; i < m.Periods.length; i++) {
			p = m.Periods[i];
			p.EndDate = validSvc.isDate(p.EndDate) ? p.EndDate : 'ongoing';
			p.Resident = !!p.Resident ? 'YES' : 'NO';
			p.Exclusive = !!p.Exclusive ? 'YES' : 'NO';
		}

		// load Effective and Modified Periods
		if(m.Periods.length < 1) {
			m = periodEditVM('Eff', m); // blank
			m.EditStartDate = m.EffStartDate;
			m.EditEndDate = m.EffEndDate;
		}
		else if(m.Status == 'MODIFIED-ACTIVE' || m.Status == 'MODIFIED-INACTIVE') {
			m.StatusTxt = m.Status == 'MODIFIED-ACTIVE' ? 'ACTIVE' : 'INACTIVE'; // simplify for user
			m = periodEditVM('Eff', m, m.Periods[m.Periods.length - 2]); // second last is in-effect

			m.isModified = true;
			dtMin = utilSvc.dt.zeroTime(new Date(m.Periods[m.Periods.length - 2].EndDate)); // last period date type
			dtMin = utilSvc.dt.zeroTime(utilSvc.dt.addDays(dtMin, 1)); // add 1 day to previous period end
			m = periodEditVM('Mod', m, m.Periods[m.Periods.length - 1], dtMin); // last is pending modified period
			m.EditStartDate = m.ModStartDate;
			m.EditEndDate = m.ModEndDate;
		}
		else {
			// use end date of last period if it exists
			if(m.Periods.length > 1) {
				dtMin = utilSvc.dt.zeroTime(new Date(m.Periods[m.Periods.length - 2].EndDate)); // last period date type
				dtMin = utilSvc.dt.zeroTime(utilSvc.dt.addDays(dtMin, 1)); // add 1 day to previous period end
			}
			m = periodEditVM('Eff', m, m.Periods[m.Periods.length - 1], dtMin); // last is default for active/in-active/previously saved new
			m.EditStartDate = m.EffStartDate;
			m.EditEndDate = m.EffEndDate;
		}

		return m;

	}

	function periodEditVM(prefix, m, period, dtMin) {
		// jskdjfljwiejfisjdfkjsdf
		// convert an empty or existing period into editing properties

		period = period || {};

		var dtToday = utilSvc.dt.zeroTime(new Date());
		var dtTmr = utilSvc.dt.zeroTime(utilSvc.dt.addDays(dtToday, 1)),
			dtMax = utilSvc.dt.zeroTime(utilSvc.dt.addDays(dtToday, 365));

		// minimum is previous period end or 100 years back (can be as old as a person)
		dtMin = validSvc.isDate(dtMin) ? dtMin : utilSvc.dt.zeroTime(utilSvc.dt.addDays(dtToday, -36500));

		var startDate = validSvc.isDate(period.StartDate) ? validSvc.newPropDate(utilSvc.dt.zeroTime(new Date(period.StartDate)), dtMin, dtMax) : validSvc.newPropDate(dtToday, dtMin, dtMax),
			endDate = validSvc.isDate(period.EndDate) ? validSvc.newPropDate(utilSvc.dt.zeroTime(new Date(period.EndDate)), dtMin, dtMax) : validSvc.newPropDateNull();

		// EndDate min/max setup
		if(endDate.val === null) {
			endDate.min = dtMin;
			endDate.max = dtMax;
		}

		// assign to model prefix (need these values saved while editing)
		m[prefix + 'Id'] = validSvc.isText(period.Id) ? period.Id : '';
		m[prefix + 'Resident'] = period.Resident == 'YES' ? 'YES' : 'NO'; // default is no
		m[prefix + 'Exclusive'] = period.Exclusive == 'YES' ? 'YES' : 'NO'; // default is no
		m[prefix + 'StartDate'] = startDate;
		m[prefix + 'EndDate'] = endDate;

		return m;

	}


	/**
	 *    GET LIST
	 */

	function getList(ceid) {

		// params
		if(!validSvc.isCE(ceid)) {
			throw new Error('npiRepo.getList, ceid is missing: ' + ceid);
		}

		_currentPurl = 'ops/ce/npi/list';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid]
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('Npi')]
		};

		// update user CE choice
		eventSvc.rootEmit('context.change', {
			CE: ceid
		});

		// call api
		apiService.post(_currentPurl, apiRequest).then(getOk, getErr);

		function getOk(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// clean up list return
			var items = Array.isArray(r.data.Entity) ? r.data.Entity : [];
			for(var i = 0; i < items.length; i++) {
				items[i] = savedNpiVM(items[i]);
			}

			defer.resolve(items);

		}

		function getErr(r) {

			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);

		}

		return defer.promise;

	}


	/**
	 *    GET EXCEL
	 *    file created on api server, expecting a binary file stream instead of JSON
	 */

	function getExcel(entityType, targetEntity, filename) {
			var ctx = {};
			var _currentPurl;
	
			// params
			switch(entityType) {
				case 'CE':
					if(!validSvc.isCE(targetEntity) || !validSvc.isText(filename)) {
						throw new Error('npiRepo.getExcel, ceid and filename are required');
					}
					_currentPurl = 'ops/ce/npi/excel';
					ctx.CEID = [targetEntity];
					break;
				case 'RX':
					if(!validSvc.isRX(targetEntity) || !validSvc.isText(filename)) {
						throw new Error('npiRepo.getExcel, rxid and filename are required');
					}
					_currentPurl = 'ops/rx/npi/excel';
					ctx.RXID = [targetEntity];
					break;
				default:
					throw new Error('npiRepo.upsert, unknown endpoint purl: ' + purl);
			}
	
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: ctx,
			Params: {
				Filename: filename
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('ServerExcel')]
		};

		// call api
		apiService.postGetBinary(_currentPurl, apiReqest).then(okGetExcel, errGetExcel);

		function okGetExcel(r) {
			defer.resolve(r.data);
		}

		function errGetExcel(r) {
			if(r !== null) {
				r = r || {};
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	/**
	 *    GET DETAILS
	 */

	function getDetails(ceid, npi, isReviewType) {

		// params
		if(!validSvc.isCE(ceid) || !validSvc.isText(npi)) {
			throw new Error('npiRepo.getDetails, ceid, npi required');
		}

		_currentPurl = isReviewType ? 'ops/ce/npi/review/details' : 'ops/ce/npi/details';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid]
			},
			Entity: {
				Npi: npi
			}
		};

		apiService.post(_currentPurl, apiRequest).then(getOk, getErr);

		function getOk(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(savedNpiVM(r.data.Entity));
		}

		function getErr(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    CREATE / UPDATE
	 */

	function add(ceid, model) {
		return upsert('add', ceid, model);
	}

	function addPeriod(ceid, model) {
		return upsert('period/add', ceid, model, true);
	}

	function updatePeriod(ceid, model, saveModified, confirmUnMatch) {
		return upsert('period/update', ceid, model, !!saveModified, !!confirmUnMatch);
	}

	function reviewSave(ceid, model) {
		return upsert('review/save', ceid, model);
	}

	function reviewDelete(ceid, model) {
		return upsert('review/delete', ceid, model);
	}

	function upsert(purl, ceid, model, saveModified, confirmUnMatch) {

		// params
		if(!validSvc.isCE(ceid)) {
			throw new Error('npiRepo.upsert, ceid required');
		}

		_currentPurl = 'ops/ce/npi/' + purl;
		_modelPending = model;
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [ceid]
			}
		};

		// npi / period enpoints use diff viewmodel structures
		switch(purl) {
			case 'add':
				apiRequest.Entity = {
					Npi: model.Npi.val,
					Period: {
						Resident: model.EffResident == 'YES',
						Exclusive: model.EffExclusive == 'YES',
						StartDate: utilSvc.dt.toServerDate(model.EditStartDate.val),
						EndDate: utilSvc.dt.toServerDate(model.EditEndDate.val)
					}
				};
				break;
			case 'period/add':
			case 'period/update':
				apiRequest.Entity = {
					Confirm: !!model.isConfirmation,
					Unmatch: !!confirmUnMatch,
					Npi: model.Npi.val,
					Period: {
						Id: saveModified ? model.ModId : model.EffId,
						Resident: saveModified ? model.ModResident == 'YES' : model.EffResident == 'YES',
						Exclusive: saveModified ? model.ModExclusive == 'YES' : model.EffExclusive == 'YES',
						StartDate: utilSvc.dt.toServerDate(model.EditStartDate.val),
						EndDate: utilSvc.dt.toServerDate(model.EditEndDate.val)
					}
				};
				break;
			case 'review/save':
			case 'review/delete':
				apiRequest.Entity = {
					Npi: model.Npi.val,
					Type: apiReviewType(model.Type),
					// Active:  (model.Status == 'ACTIVE')
				};
				break;
			default:
				throw new Error('npiRepo.upsert, unknown endpoint purl: ' + purl);
		}

		// call api
		apiService.post(_currentPurl, apiRequest).then(upsertOk, upsertErr);

		function upsertOk(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function upsertErr(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapApiErrorsToModel(r, _modelPending);
				defer.reject(r);
			}
			else {
				throw new Error('addErr, unexpected error result');
			}

		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// 422 User Confirmation needed
			m.isConfirmation = m.ROOT.msg == 'CONFIRMATION';

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				if(m.isConfirmation) {
					// confirmation properties get added to model "as is"
					m[fieldName] = entity.Fields[i].Rule;
				}
				else {
					// parse model for property name
					fieldObj = utilSvc.obj.findChildProp(m, fieldName);
					if(fieldObj === undefined) {
						throw new Error('npiRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
					}
					// set failed state
					fieldObj.fail = 'yes';
					fieldObj.msg = entity.Fields[i].Rule;
				}
			}

			return m;

		}


		return defer.promise;
	}


	/**
	 *    BACKDATE
	 */

	function setAllStarts(ceid, startDate)  {

		// params
		if(!validSvc.isText(ceid.val)) {
			throw new Error('npiRepo.setAllStarts, id is missing');
		}
		// set purl
		_currentPurl = 'ops/ce/npi/setall';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {CEID : [ceid.val]},
			Entity: {
				StartDate: utilSvc.dt.toServerDate(startDate.val)
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okStarts, errStarts);

		function okStarts(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function errStarts(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status === 422) {
				r.msg = r.data.Entity.ROOT.join(', ');
				defer.reject(r);
			}
			else {
				errSvc.error('Unexpected error', 'npi.errStarts', r.status, utilSvc.http.safeResponse(r));
			}

		}


		return defer.promise;

	}


	/**
	 * 	LOCKING
	 * 	toggle NPI property "Locked" (between NPI types STANDARD / LOCKING on UI display)
	 */

	 function toggleLock(ceid, npi, locked)  {

		// params
		if(!validSvc.isText(ceid) || !validSvc.isText(npi)) {
			throw new Error('npiRepo.toggleLock, ceid and npi required');
		}
		// set purl
		_currentPurl = 'ops/ce/npi/locking';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {CEID : [ceid]},
			Entity: {
				Npi: npi,
				Locked: locked
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okLock, errLock);

		function okLock(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + ' repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function errLock(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + ' repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				errSvc.error('Unexpected error', 'npi.errLock', r.status, utilSvc.http.safeResponse(r));
			}
		}

		return defer.promise;
	}

	/**
	 * 	ACTIVATE
	 * 	toggle NPI property "ACTIVE" (between NPI types REFERRAL / FLOATING/BLOCKED on UI display)
	 */

	 function toggleStatus(ceid, npi)  {
		// params
		if(!validSvc.isText(ceid) || !validSvc.isText(npi)) {
			throw new Error('npiRepo.toggleStatus, ceid and npi required');
		}
		// set purl
		_currentPurl = 'ops/ce/npi/review/togglestatus';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {
				CEID : [ceid]
			},
			Entity: {
				Npi: npi
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okActive, errActive);

		function okActive(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + ' repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function errActive(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + ' repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				errSvc.error('Unexpected error', 'npi.errActive', r.status, utilSvc.http.safeResponse(r));
			}
		}

		return defer.promise;
	}

	/**
	 *    FILE UPLOAD
	 */

	function fileUpload(entityType, targetEntity, filetype, importFile) {
		var apiRequest = {};

		// params
		switch(entityType) {
			case 'CE':
				if(!validSvc.isCE(targetEntity) || !!!importFile) {
					throw new Error('npiRepo.npiFileUpload, required: CE and import file.');
				}
				_currentPurl = 'ops/ce/npi/import';
				apiRequest = {
					CEID: targetEntity,
					FileType: filetype
				};
				break;
			case 'RX':
				if(!validSvc.isRX(targetEntity) || !!!importFile) {
					throw new Error('npiRepo.npiFileUpload, required: RX and import file.');
				}
				_currentPurl = 'ops/rx/npi/import';
				apiRequest = {
					RXID: targetEntity,
					FileType: filetype
				};
				break;
			default:
				throw new Error('npiRepo.upsert, unknown endpoint purl: ' + purl);
		}




		var defer = $q.defer();



		// create multi-part form data
		var fd = new FormData();
		fd.append('context', angular.toJson(apiRequest)); // stringify JSON into one "context" property
		fd.append('file', importFile);

		apiService.postFile(_currentPurl, fd, false).then(okFileImport, errFileImport);

		function okFileImport(r) {

			// bad upsert response format
			if(!!!r || !!!r.data || !!!r.data.Entity) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errFileImport(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!!!r || !validSvc.isNumber(r.status) || !!!r.data) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status === 422) {
				r.importErrors = mapApiImportErrors(r.data.Entity);
				r.counts = {
					Processed: r.data.Entity.ProcessedCount,
					Received: r.data.Entity.ReceivedCount,
					Error: r.data.Entity.ErrorCount,
					Duplicate: r.data.Entity.DuplicateCount
				};
				defer.reject(r);
			}
			else {
				errSvc.error('Unexpected error', _currentPurl + 'npiRepo.errFileImport', r.status, utilSvc.http.safeResponse(r));
			}

		}

		function mapApiImportErrors(entity) {

			// map server 422 fields onto import error text lines

			if(Array.isArray(entity.RecordErrors) && entity.RecordErrors.length > 0) {
				return entity.RecordErrors;
			}
			else if(entity.ROOT.length > 0) {
				return [{Name: 'File Error', Rule: entity.ROOT.join(',')}];
			}
			else {
				throw new Error('npiRepo.422FileImport, Api returned no errors to display');
			}
		}

		return defer.promise;

	}


	/**
	 *    PURGE
	 */

	function purge(ceid) {

		// params
		if(!validSvc.isCE(ceid)) {
			throw new Error('npiRepo.purge, ceid required');
		}

		_currentPurl = 'ops/ce/npi/purge';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid]
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okPurge, errPurge);

		function okPurge(r) {
			defer.resolve({});
		}

		function errPurge(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status === 422) {
				r.msg = r.data.Entity.ROOT.join(', ');
				defer.reject(r);
			}
			else {
				throw new Error('npiRepo.errPurge, unexpected error result');
			}

		}

		return defer.promise;

	}

}
 
/**
 *    NPI CONTROLLER
 *    shared across CE admin and CE user features
 */

npiCtl.$inject = ['$window', '$scope', '$state', '$timeout', 'npiRepo', 'lookupRepo', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc'];
angular
.module('espui.ops')
.controller('NpiCtl', npiCtl);


/* @ngInject */
function npiCtl($window, $scope, $state, $timeout, npiRepo, lookupRepo, validSvc, errSvc, utilSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _viewErrRoute = '',
		_pendingExcelFilename = '',
		_pendingEdit = {},
		_datePickListener = null,
		_fileImportListener = null,
		_ceInfo = null;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.action = '';
	vm.isWaiting = false;
	vm.viewType = '';
	vm.CeDroplist = [];
	vm.NpiTypeDroplist = [];
	vm.NpiTypeEditDroplist = [];
	vm.NpiStatusDroplist = [];

	// list filters
	vm.flt = {};
	vm.fltStatusUserChoice = 'ALL';
	vm.fltChangeStatus = fltChangeStatus;
	vm.fltTypeUserChoice = 'ALL';
	vm.fltChangeType = fltChangeType;

	// models
	vm.context = {};
	vm.display = {};
	vm.model = {};
	vm.backdate = {};

	// query
	vm.queryChangeCE = queryChangeCE;

	// npi
	vm.getList = getList;
	vm.addNpi = addNpi;
	vm.editNpi = editNpi;
	vm.saveNpi = saveNpi;
	vm.deleteNpi = deleteNpi;
	vm.cancelEdit = cancelEdit;
	vm.getExcel = getExcel;

	// period
	vm.addPeriod = addPeriod;
	vm.cancelAddPeriod = cancelAddPeriod;

	// backdate
	vm.canBackdate = false;
	vm.prepareBackdate = prepareBackdate;
	vm.backdateAll = backdateAll;

	// date pick
	vm.dtPickShow = {};
	vm.dtPickOpen = dtPickOpen;

	// import file
	vm.canEdit = false;
	vm.importFileType = "STANDARD";
	vm.importFiles = [];
	vm.importErrors = [];
	vm.importCounts = {};
	vm.importToggle = importToggle;
	vm.importFile = importFile;

	// locking
	vm.toggleLock = toggleLock;
	vm.toggleStatus = toggleStatus;


	/**
	 *    IMPORT FILE EVENT HOOK
	 *    used to update file list to import
	 *    note:
	 *          directive widget-input-file throws event: 'widget.input.file'
	 *          event object: {id:'id of element', files:[] array of files if browser supports HTML5 File Api}
	 */

	function listenForFileImport() {

		if(!!!_fileImportListener) {

			_fileImportListener = $scope.$on('widget.input.file', function(event, importInfo) {
				event.stopPropagation();

				if(!!importInfo && !!importInfo.files && importInfo.files.length > 0) {
					vm.importFiles = importInfo.files;
				}
				else {
					vm.importFiles = [];
				}

			});
		}

	}


	/**
	 *    DATE PICKER EVENT HOOK
	 */

	_datePickListener = $scope.$on('widget.input.date.pick.change', function(event, evtData) {
		event.stopPropagation();

		// params
		if(!evtData || !validSvc.isText(evtData.uniqueId)) {
			return;
		}

		var id = evtData.uniqueId;
		if(id != 'NpiEditStartDate' && id != 'NpiEditEndDate') {
			return;
		}
		id = id.substr(3,id.length);

		vm.dtPickShow[id] = false;

		// EndDate "ongoing" was clicked?
		if(id == 'EditEndDate' && evtData.altText == 'ongoing') {
			if(!!evtData.altChecked) {
				vm.model.EditEndDate.val = null;
			}
			else {
				vm.model.EditEndDate.val = vm.model.EditEndDate.min;
			}
		}
		else {
			vm.model[id].val = evtData.setDate;
		}

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_datePickListener) {
			_datePickListener();
		}
		if(!!_fileImportListener) {
			_fileImportListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// params
		var params = $state.params || {};

		var stateName = $state.current.name;
		switch(stateName) {

			case 'ops.npi':

				// main title
				$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

				vm.viewType = 'CEUSER';
				_viewErrRoute = 'home';
				params.CE = validSvc.isCE($scope.User.CE) ? $scope.User.CE : 'NONE';  // use global CE state
				break;

			case 'admin.ce.edit.npi':
				vm.viewType = 'CEADMIN';
				_viewErrRoute = 'admin.ce.list';

				// admin route must have CE param
				if(!validSvc.isCE(params.CE)) {
					throw new Error('npiCtl.init, CE ADMIN ID missing');
				}
				break;

			default:
				throw new Error('npiCtl.init, unknown route: ' + stateName);
		}

		vm.context = initContext(params.CE, $scope.User.Type);
		getList();

	}

	function getAffs() {
		return utilSvc.aff.findStatus($scope.User.AffList);
	}

	function initContext(ceid, uType) {

		var isVerity = uType == 'VERITY' || uType == 'VERITYSA';
		vm.canEdit = isVerity || (uType == 'CE' && utilSvc.user.hasFeature($scope, 'ops.ce.npi.edit'));
		vm.canBackdate = isVerity;

		// date picker
		vm.dtPickShow = {
			pending: '',
			EditStartDate: false,
			EditEndDate: false
		};

		// npi list Type / Status
		vm.flt = {
			Type: undefined,
			StatusTxt: undefined
		};

		// express types limited
		if($scope.cobrand == 'express') {
			vm.NpiTypeDroplist = [
				{value:'ALL', label:'ALL'},
				{value:'LOCKED', label:'LOCKED'},
				{value:'STANDARD', label:'STANDARD'}
			];
		}
		else {
			vm.NpiTypeDroplist = [
				{value:'ALL', label:'ALL'},
				{value:'BLOCKED', label:'BLOCKED'},
				{value:'FLOATING', label:'FLOATING'},
				{value:'LOCKED', label:'LOCKED'},
				{value:'REFERRAL', label:'REFERRAL'},
				{value:'STANDARD', label:'STANDARD'}
			];
		}

		vm.NpiStatusDroplist = [
			{value:'ALL', label:'ALL'},
			{value:'ACTIVE', label:'ACTIVE'},
			{value:'INACTIVE', label:'INACTIVE'},
			{value:'MODIFIED', label:'MODIFIED'},
			{value:'NEW', label:'NEW'}
		];

		// ce droplist
		vm.CeDroplist = utilSvc.aff.ceDroplist(getAffs());
		var ceProp = validSvc.newProp(ceid);
		if(vm.viewType == 'CEUSER') {
			ceProp = utilSvc.ng.droplistAutoselect(vm.CeDroplist, ceid);
		}

		return {
			CE: ceProp,
			CeStatus: '',
			HasReferrals: false
		};

	}


	/**
	 *    VIEW MODELS
	 */

	function displayVM(items) {
		items = Array.isArray(items) ? items : [];

		var result = [],
			item = {};

		for (var i = 0; i < items.length; i++) {
			item = items[i];
			item.uniqueId = i;

			// clean up status for list display
			if(item.Status == 'MODIFIED-ACTIVE' || item.Status == 'MODIFIED-INACTIVE') {
				item.StatusTxt = 'MODIFIED';
			}
			else {
				item.StatusTxt = item.Status;
			}

			item.Referral = !!item.Referral;
			item.isReviewType = item.Referral || item.Type == 'REFERRAL' || item.Type == 'FLOATING' || item.Type == 'BLOCKED';

			// no dates for review types
			if(item.isReviewType) {
				item.StartDate = 'n/a';
				item.EndDate = 'n/a';
			}
			else {
				// use "ongoing" for no end date
				item.EndDate = validSvc.isDate(item.EndDate) ? item.EndDate : 'ongoing';
			}

			// express users do not see referral types
			if(!item.Referral || (item.Referral && $scope.cobrand != 'express')) {
				result.push(item);
			}
		}

		var pgTotal = 1;
		if(result.length > 0) {
			pgTotal = vm.getTotalPages(result.length, $scope.tblPagingSize);
		}

		return {
			Items: result,
			SortBy: ['Npi'],
			Paging: {
				Page: 1,
				Size: $scope.tblPagingSize,
				Total: pgTotal
			}
		};

	}


	/**
	 *    FILTER CHANGE
	 */

	function fltChangeStatus() {
		// using exact filter on Status, reset filter to null if ALL option chosen
		if(vm.fltStatusUserChoice == 'ALL') {
			vm.flt.StatusTxt = undefined;
		}
		else {
			vm.flt.StatusTxt = vm.fltStatusUserChoice;
		}
	}

	function fltChangeType() {
		// using exact filter on Type, reset filter to null if ALL option chosen
		if(vm.fltTypeUserChoice == 'ALL') {
			vm.flt.Type = undefined;
		} else {
			vm.flt.Type = vm.fltTypeUserChoice;
		}
	}

	/**
	 *    QUERY CHANGE
	 */

	function queryChange() {
		vm.action = '';
		vm.display = displayVM();
		vm.model = {};

		vm.importFiles = [];
		vm.importErrors = [];
		vm.importCounts = {};
	}

	function queryChangeCE() {

		queryChange();
		if(vm.viewType == 'CEUSER') {
			getList();
		}

	}

	function queryValid(ctx) {
		ctx.CE.fail = validSvc.isCE(ctx.CE.val) ? 'no' : 'yes';
		return ctx.CE.fail != 'yes';
	}


	/**
	 *    LIST
	 */

	function getList() {

		queryChange();
		if(vm.isWaiting) {
			return;
		}

		if(!queryValid(vm.context)) {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		npiRepo.getList(vm.context.CE.val).then(okNpiList, errNpiList);

		function okNpiList(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			vm.display = displayVM(r);
			vm.action = 'LIST';

			// build ce info map?
			if(_ceInfo === null || vm.viewType == 'CEADMIN') {
				var ceList = [];
				if(vm.viewType == 'CEADMIN') {
					ceList.push(vm.context.CE.val);
				}
				else {
					ceList = utilSvc.aff.ceList(getAffs());
				}

				lookupRepo.CeInfo(ceList).then(okCeLookup, errCeLookup);
			}

		}

		function errNpiList(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(!!r) {
				errSvc.warn('Not able to get npi list.', 'npiCtl.errNpiList', r.status, utilSvc.http.safeResponse(r));
			}

			$state.go(_viewErrRoute, {}, {reload: _viewErrRoute});

		}

	}

	function okCeLookup(items) {

		if(!Array.isArray(items) || items.length < 1) {
			msgSvc.ok('CE Lookup Not Found', 'npiCtl.LookupCE, lookup did not find any CE info');
			return;
		}

		// build CE info map
		_ceInfo = {};
		for(var i = 0; i < items.length; i++) {
			_ceInfo[items[i].NickName] = {
				Status: items[i].Status,
				HasReferrals: !!items[i].EnableReferralNPIs,
				HasRefSuspectMatching: !!items[i].HasRefSuspectMatching
			};
		}

	}

	function errCeLookup(r) {
		if(!!r) {
			errSvc.warn('Error looking up ce display properties', 'npiCtl.lookupCe', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    ADD / EDIT
	 */

	function addNpi() {

		// user clicked ADD button to create a new npi

		if(vm.isWaiting) {
			return;
		}

		vm.model = npiRepo.editModelVM();

		// setup context
		vm.context.CeStatus = _ceInfo[vm.context.CE.val].Status;
		vm.context.HasReferrals = _ceInfo[vm.context.CE.val].HasReferrals;

		vm.NpiTypeEditDroplist = [];

		// express cannot use these types
		if($scope.cobrand != 'express') {

			var dropList = ['BLOCKED', 'FLOATING'];
			if(vm.context.HasReferrals) {
				dropList.push('REFERRAL');
			}

			vm.NpiTypeEditDroplist = utilSvc.ng.droplist(dropList);
		}

		vm.NpiTypeEditDroplist.push({label:'STANDARD (LOCKED)',value:'LOCKED'});

		vm.action = 'ADD';

	}

	function editNpi(item) {
		if (!vm.canEdit) {
			return;
		}

		// user clicked existing row to edit payor
		
		if(vm.isWaiting) {
			return;
		}

		// setup context
		vm.context.CeStatus = _ceInfo[vm.context.CE.val].Status;
		vm.context.HasReferrals = _ceInfo[vm.context.CE.val].HasReferrals;

		vm.model = {};
		vm.isWaiting = true;
		msgSvc.wait(true);

		npiRepo.getDetails(vm.context.CE.val, item.Npi, !!item.isReviewType).then(okGetDetails, errGetDetails);

		function okGetDetails(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			vm.model = npiRepo.editModelVM(r);			

			// setup edit types
			switch(vm.model.Type) {
				case 'STANDARD':
				case 'LOCKED':
					vm.NpiTypeEditDroplist = utilSvc.ng.droplist([
						'LOCKED',
						'STANDARD'
					]);
					break;
				case 'REFERRAL':
				case 'FLOATING':
				case 'BLOCKED':
					vm.NpiTypeEditDroplist = utilSvc.ng.droplist([
						'BLOCKED',
						'FLOATING',
						'REFERRAL'
					]);
					break;
				default:
					alert('npiCtl.editNpi, unknown npi type: ' + vm.model.Type);
			}

			vm.action = 'EDIT';
		}

		function errGetDetails(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(!!r) {
				errSvc.warn('Not able to get npi details.', 'npiCtl.errGetDetails', r.status, utilSvc.http.safeResponse(r));
			}

			$state.go(_viewErrRoute, {}, { reload: _viewErrRoute });

		}

	}

	function cancelEdit() {

		if(vm.isWaiting) {
			return;
		}

		vm.model = {};
		getList();

	}


	/**
	 *    VALIDATION
	 */

	function validateNpiId(npiId) {
		var error = 'must be 10 digits';
		var value = '';
		// Npi - required 10 digit number
		if(validSvc.isText(npiId)) {
			var validatedIdProp = validSvc.newProp(npiId.trim());
			if (validatedIdProp.val.length == 10) {
				error = 'must be numeric';
				var regexAcctId = /[^0-9 ]/;
				if(!regexAcctId.test(validatedIdProp.val)) {
					error = '';
					value = validatedIdProp.val;
				}
			}
		}
		return {
			Value : value,
			Error : error
		};
	}

	function validNpi(m) {

		var onboard = vm.context.CeStatus == 'ONBOARDING',
			stat = m.Status;

		// Npi - require 10-digit numeric only
		if(vm.action == 'ADD') {
			var validatedId = validateNpiId(m.Npi.val);
			if (validatedId.Error !== '') {
				m.Npi.fail = 'yes';
				m.Npi.msg = validatedId.Error;
			} else {
				m.Npi.val = validatedId.Value;
				m.Npi.fail = 'no';
			}
		}

		// npi type
		if(m.Type == 'LOCKED' || m.Type == 'STANDARD') {
			var startDate = m.EditStartDate,
				endDate = m.EditEndDate, 
			 	dtToday = utilSvc.dt.zeroTime(new Date());
			var dtMax = utilSvc.dt.addDays(dtToday, 1460);
			m.EditEndDate.max = dtMax;

			// Start date.. Always required
			startDate = validSvc.propDateValid(startDate);
			startDate.fail = startDate.fail ? 'yes' : 'no';

			// End date (optional) ..
			var endIsDate = validSvc.isDate(endDate.val);
			if (endIsDate) {
				endDate = validSvc.propDateValid(endDate);
				endDate.fail = endDate.fail ? 'yes' : 'no';
			}
			else {
				// ongoing
				endDate.val = null;
				endDate.fail = 'no';
			}

			// If end date exists, validate its' relationship to Start
			if(endIsDate && endDate.fail == 'no' && startDate.fail == 'no') {
				if(!utilSvc.dt.greaterThan(new Date(startDate.val), new Date(endDate.val))) {
					endDate.fail = 'yes';
					endDate.msg = 'must be greater than start date';
				}
			}

			// future date range Start Date must be on or after Effective EndDate
			if(m.isModified && startDate.fail == 'no' && endDate.fail == 'no' && validSvc.isDate(m.EffEndDate.val)) {
				if(!utilSvc.dt.greaterThan(m.EffEndDate.val, startDate.val)) {
					startDate.fail = 'yes';
					startDate.msg = 'must be greater than In-Effect EndDate';
				}
			}
		}

		return m.Npi.fail != 'yes' && m.EditStartDate.fail != 'yes' && m.EditEndDate.fail != 'yes';

	}


	/**
	 *    SAVE NPI
	 *    note: used by both NPI effective and future date ranges
	 */

	function saveNpi(saveType) {
		if(vm.isWaiting) {
			return;
		}

		// validate
		if (!validNpi(vm.model)) {
			msgSvc.ok('Cannot Save', 'Check property values.');
			return;
		}

		//CE does not support REFERRAL NPIs
		if(vm.model.Type == 'REFERRAL' && !vm.context.HasReferrals) {
			msgSvc.ok('Cannot Save', 'Facility does not support editing Referral NPIs, contact your Verity administrator.');
			return;
		}

		msgSvc.wait(true);
		vm.isWaiting = true;

		_pendingEdit = {
			saveType: saveType,
			saveMsg: saveType + ' NPI',
			npi: vm.model.Npi.val,
			isReview: vm.model.Type == 'REFERRAL' || vm.model.Type == 'FLOATING' || vm.model.Type == 'BLOCKED'
		};
		if(saveType == 'MODIFIED') {
			_pendingEdit.saveMsg = 'Future Date Range';
		}

		// review NPI
		if(_pendingEdit.isReview) {
			npiRepo.reviewSave(vm.context.CE.val, vm.model).then(okSubmit, errSubmit);
		}
		else {
			// standard NPI has periods
			if(saveType == 'ADD') {
				// new npi
				npiRepo.add(vm.context.CE.val, vm.model).then(okSubmit, errSubmit);
			}
			else if(vm.model.Status == 'MODIFIED-NEW') {
				// new period
				npiRepo.addPeriod(vm.context.CE.val, vm.model).then(okSubmit, errSubmit);
			}
			else {
				// update previously saved period (could be In-Effect or Modified future period we are saving)
				npiRepo.updatePeriod(vm.context.CE.val, vm.model, saveType == 'MODIFIED').then(okSubmit, errSubmit);
			}
		}
	}

	function okSubmit(r) {
		msgSvc.wait(false);
		vm.isWaiting = false;
		msgSvc.ok(_pendingEdit.saveMsg, _pendingEdit.npi + ' Saved');

		if(vm.action == 'ADD' || _pendingEdit.isReview) {
			getList();
		}
		else {
			editNpi({Npi: vm.model.Npi.val});
		}
	}

	function errSubmit(r) {
		msgSvc.wait(false);
		vm.isWaiting = false;

		if (!!!r) {
			return;
		}
		else if(r.status == 409) {
			// conflict
			msgSvc.ok('Could Not Save', 'May already exist in the database. Verify and try again.');
		}
		else if(r.status == 422) {
			// validation
			vm.model = r.model;
			
			// confirm gain/loss of eligibility with user before committing NPI save
			if(!!r.model.isConfirmation) {
				msgSvc.confirm({
					id: 'npi.update.confirm',
					title: 'Confirm Date Change',
					msg: 'Changing dates could result in ' + r.model.MatchesLost + ' Matches Lost, ' + r.model.EligibleLost + ' of these matches are Eligible. Continue?',
					buttons: [
						{ text: 'YES - UNMATCH', result: 'YES_UNMATCH', cancel: false },
						{ text: 'YES - KEEP MATCHES', result: 'YES', cancel: false },
						{ text: 'NO', result: 'CANCEL', cancel: true }
					]
				}).then(confirmSubmit, confirmSubmit);
			}
			else {
				msgSvc.ok('Could Not Save', 'Check property values.');
			}
		}
		else {
			errSvc.error('Unknown add / update error response', 'npiCtl.errSubmit', r.status, utilSvc.http.safeResponse(r));
		}

	}

	function confirmSubmit(r) {
		if(!!r && (r.result == 'YES' || r.result == 'YES_UNMATCH')) {
			vm.isWaiting = true;
			npiRepo.updatePeriod(vm.context.CE.val, vm.model, _pendingEdit.saveType == 'MODIFIED', r.result == 'YES_UNMATCH').then(okSubmit, errSubmit);
		}
		else {
			msgSvc.ok('Cannot Save', 'NPI not saved, eligibility changes must be confirmed.');
			vm.model.isConfirmation = false;
		}
	}


	/**
	 * 	DELETE NPI
	 */
	function deleteNpi() {

		if(vm.isWaiting) {
			return;
		}

		// CE does not support REFERRAL NPIs
		if(vm.model.Type == 'REFERRAL' && !vm.context.HasReferrals) {
			msgSvc.ok('Cannot Delete', 'Facility does not support editing Referral NPIs, contact your Verity administrator.');
			return;
		}

		msgSvc.confirm({
			id: 'npi.delete',
			title: 'Delete ' + vm.model.Type + ' NPI: ' + vm.model.Npi.val,
			msg: 'Confirm delete NPI, this action cannot be reversed.',
			buttons: [
				{ text: 'OK', result: 'YES', cancel: false },
				{ text: 'CANCEL', result: 'CANCEL', cancel: true }
			]
		}).then(confirmDel, confirmDel);

	}

	function confirmDel(r) {

		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;
			npiRepo.reviewDelete(vm.context.CE.val, vm.model).then(okDel, errDel);
		}

		function okDel(r) {
			vm.isWaiting = false;
			msgSvc.ok(vm.model.Npi.val + ' Deleted');

			getList();
		}

		function errDel(r) {
			vm.isWaiting = false;

			if (!!r) {
				errSvc.error('Unknown delete error response', 'npiCtl.npiDelete', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    PERIOD
	 */

	function addPeriod() {
		if(vm.isWaiting) {
			return;
		}

		var m = vm.model;

		// current period must have a valid end date before continuing (this includes checking for ongoing which will be null)
		var lastPeriod = m.Periods[m.Periods.length - 1],
			lastPeriodEndDate = validSvc.isDate(lastPeriod.EndDate) ? utilSvc.dt.zeroTime(new Date(lastPeriod.EndDate)) : null;
		if(!validSvc.isDate(m.EffEndDate.val) || !validSvc.isDate(lastPeriodEndDate)) {
			msgSvc.ok('Cannot Add Date Range', 'End Date must be saved before adding a future date range.');
			return;
		}

		var dtToday = utilSvc.dt.zeroTime(new Date()),
			dtMin = utilSvc.dt.addDays(lastPeriodEndDate,1);  // min start date is day after last period

		// start date defaults to today, BUT in the rare case previous period ends in the future, start is 1 day after that period end date
		var startDate = utilSvc.dt.zeroTime(new Date());
		if(utilSvc.dt.greaterThan(dtToday, lastPeriodEndDate)) {
			startDate = dtMin;
		}
		else {
			startDate = dtToday;
		}
		var dtMax = utilSvc.dt.addDays(dtToday, 1460);

		// setup model
		m.EditStartDate = validSvc.newPropDate(startDate, dtMin, dtMax);
		m.EditEndDate = validSvc.newPropDateNull();
		m.EditEndDate.min = startDate;
		m.EditEndDate.max = dtMax;
		m.ModExclusive = m.EffExclusive;
		m.ModResident = m.EffResident;

		// switch to modified status
		m.Status = 'MODIFIED-NEW';
		m.isModified = true;
	}

	function cancelAddPeriod() {

		if(vm.isWaiting) {
			return;
		}

		// reset this whole editing session
		editNpi({Npi: vm.model.Npi.val});
	}


	/**
	 *    BACKDATE
	 */

	function prepareBackdate() {

		var dateMin = new Date(1992, 10, 1, 0, 0, 0),
			dateMax = utilSvc.dt.zeroTime(utilSvc.dt.addDays(new Date(), 365));

		vm.backdate.StartDate = validSvc.newPropDate(null, dateMin, dateMax);
		vm.action = "BACKDATE";

	}

	function backdateAll() {

		// already waiting?
		if (vm.isWaiting) {
			return;
		}
		// Validate non-zero StartDate
		vm.backdate.StartDate = validSvc.propDateValid(vm.backdate.StartDate);
		if (vm.backdate.StartDate.fail) {
			vm.backdate.StartDate.fail = 'yes';
			return;
		}
		else {
			vm.backdate.StartDate.fail = 'no';
		}
		// Ok, confirm with user
		msgSvc.confirm({
			id: 'npi.backdate',
			title: 'Set Start Dates',
			msg: 'Are you sure you want to set all start dates to ' + utilSvc.dt.toText(vm.backdate.StartDate.val) + '? This action cannot be undone.',
			buttons: [
				{ text: 'OK', result: 'YES', cancel: false },
				{ text: 'CANCEL', result: 'CANCEL', cancel: true }
			]
		}).then(confirmBackdate, confirmBackdate);
	}

	function confirmBackdate(r) {

		// user said yes to backdating
		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;
			msgSvc.wait(true);

			npiRepo.setAllStarts(vm.context.CE, vm.backdate.StartDate).then(okBackdate, errBackdate);
		}

		function okBackdate(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			getList();
		}

		function errBackdate(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!!r || r == null) {
				// already handled
				$state.go(_viewErrRoute, {}, { reload: _viewErrRoute });
			}
			else if(r.status === 422) {
				msgSvc.ok('Cannot Backdate', r.msg);
			}
			else {
				errSvc.error('Unknown backdate start dates error', 'npiCtl.errBackdate', r.status, utilSvc.http.safeResponse(r));
			}

		}
	}


	/**
	 *    FILE IMPORT
	 */

	function importToggle() {

		if(vm.isWaiting) {
			return;
		}

		if(vm.action == 'IMPORT') {
			// toggle off, back to list
			getList();
			return;
		}
		else {
			// toggle on, reset view

			queryChange();

			// check for File API and FormData upload browser support
			if(!validSvc.uploadSupported()) {
				msgSvc.ok('File Upload Not Supported', 'File Upload uses HTML5 FormData upload, your browser does not support it. Please upgrade to use file upload.');
				return;
			}

			vm.action = 'IMPORT';
			listenForFileImport();
		}

	}

	function importValidFile(newFile) {

		// required
		if(!!!newFile) {
			return 'no file selected';
		}

		// file size > 0 bytes, < 10 megabytes
		if(!validSvc.isNumber(newFile.size) || newFile.size < 1 || newFile.size > 10000000) {
			return 'file size must be 2 bytes to 10 megabytes';
		}

		// file name must be .csv
		var fName = newFile.name;
		if(!validSvc.isText(fName) || fName.length < 5 || (fName.substr(fName.length - 4, 4).toLowerCase() !== '.csv' && fName.substr(fName.length - 4, 4).toLowerCase() !== '.txt')) {
			return 'file name must end with extension ".csv" or ".txt"';
		}

		return 'ok';

	}

	function importValid() {

		// files selected
		if(!!!vm.importFiles || vm.importFiles.length !== 1) {
			msgSvc.ok('File Import', 'Please choose 1 file to upload.');
			return false;
		}

		// validate file
		var fileFail = importValidFile(vm.importFiles[0]);
		if(fileFail != 'ok') {
			msgSvc.ok('File Import', 'Selected file error: ' + fileFail);
			return false;
		}

		return true;

	}

	function importFile() {

		if(vm.isWaiting) {
			return;
		}

		if(!importValid()) {
			return;
		}

		var msgTxt = vm.importFileType == 'STANDARD' ? 
			'Warning: once uploaded, all STANDARD NPI records will be replaced by the contents in this file. Note, LOCKED NPIs will stay the same, file uploads do not affect them.' :
			'Warning: Once Uploaded, all REVIEW NPI records will be replaced by the contents in this file.';

		msgSvc.confirm({
			id: 'ops.ce.npi.import',
			title: 'Upload NPI File',
			msg: msgTxt,
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmFileImport, confirmFileImport);

	}

	function confirmFileImport(r) {

		// user cancelled
		if(!!!r || r.result != 'YES') {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);
		vm.importErrors = [];
		vm.importCounts = {};

		npiRepo.fileUpload('CE',vm.context.CE.val, vm.importFileType, vm.importFiles[0]).then(okFileImport, errFileImport);

		function okFileImport(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;
			msgSvc.ok('File Import Success', 'Total ' + r.ProcessedCount + ' npi records imported.');

			// toggle off
			importToggle();
		}

		function errFileImport(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(r === null) {
				return;
			}
			else if (r.status === 422) {
				vm.importErrors = r.importErrors;
				vm.importCounts = r.counts;
				if(r.counts.Processed > 0) {
					msgSvc.ok('File Import With Errors', r.counts.Processed + ' imported, ' + r.importErrors.length + ' errors');
				}
				else {
					msgSvc.ok('File Import Failed', 'No line items were imported, there are: ' + r.importErrors.length + ' line item errors');
				}
			}
			else {
				errSvc.error('Unexpected api error', 'npiCtl.errFileImport', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}

	
	/**
	 * 	LOCKING
	 */

	function toggleLock() {

		if(vm.isWaiting) {
			return;
		}

		// only STANDARD OR LOCKED support lock btn
		if(vm.model.Type != 'LOCKED' && vm.model.Type !== 'STANDARD') {
			msgSvc.ok('Cannot Toggle Locking', 'Only LOCKED or STANDARD types can use locking.');
			return;
		}
		var isLocked = vm.model.Type == 'LOCKED';

		var title = isLocked ? 'Unlock' : 'Lock',
			msg = isLocked ? 'Confirm Unlock. Note: un-locking NPI will allow file processing to override manual settings' : 'Confirm Lock. Note: locking NPI will not allow file processing to override these manual settings.';

		msgSvc.confirm({
			id: 'npi.locking',
			title: title + ' ' + vm.model.Type + ' NPI: ' + vm.model.Npi.val,
			msg: msg,
			buttons: [
				{ text: 'OK', result: 'YES', cancel: false },
				{ text: 'CANCEL', result: 'CANCEL', cancel: true }
			]
		}).then(confirmLock, confirmLock);

	}

	function confirmLock(r) {

		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;
			npiRepo.toggleLock(vm.context.CE.val, vm.model.Npi.val, vm.model.Type == 'STANDARD').then(okLock, errLock);
		}

		function okLock(r) {
			vm.isWaiting = false;
			editNpi({Npi: vm.model.Npi.val});
		}

		function errLock(r) {
			vm.isWaiting = false;
			if (!!r) {
				errSvc.error('Unknown lock error response', 'npiCtl.toggleLock', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

/**
	 * 	STATUS
	 */

 function toggleStatus() {

	if(vm.isWaiting) {
		return;
	}

	if(!vm.model.isReviewType) {
		msgSvc.ok('Cannot Change Status', 'Only BLOCKED or FLOATING or REFERRAL types can use locking.');
		return;
	}
	var status = vm.model.Status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';

	msgSvc.confirm({
		id: 'npi.active',
		title: 'CONFIRM ' + status + ' STATUS',
		msg: vm.model.Type + ' NPI: ' + vm.model.Npi.val,
		buttons: [
			{ text: 'OK', result: 'YES', cancel: false },
			{ text: 'CANCEL', result: 'CANCEL', cancel: true }
		]
	}).then(confirmStatus, confirmStatus);

}

function confirmStatus(r) {
	if(!!r && r.result == 'YES') {
		vm.isWaiting = true;
		npiRepo.toggleStatus(vm.context.CE.val, vm.model.Npi.val).then(okStatus, errStatus);
	}

	function okStatus(r) {
		vm.isWaiting = false;
		editNpi({Npi: vm.model.Npi.val, isReviewType : true});
	}

	function errStatus(r) {
		vm.isWaiting = false;
		if (!!r) {
			errSvc.error('Unknown lock error response', 'npiCtl.toggleStatus', r.status, utilSvc.http.safeResponse(r));
		}
	}
}
	/**
	 *    EXCEL
	 */

	function getExcel() {

		// already working?
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		_pendingExcelFilename = 'Verity-' + vm.context.CE.val + '-NPI.xlsx';
		npiRepo.getExcel('CE',vm.context.CE.val, _pendingExcelFilename).then(okServerExcel, errServerExcel);

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Create Excel Error', 'accumListCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    DATE PICKER
	 */

	function dtPickOpen(dtName) {

		if(dtName != 'EditStartDate' && dtName != 'EditEndDate') {
			alert('npiCtl.dtPickOpen, date pick name unknown: ' + dtName);
			return;
		}

		var dt = vm.model[dtName];
		vm.dtPickShow.pending = dtName;

		var altText = '',
			altChecked = false,
			setDate = utilSvc.dt.zeroTime(new Date(dt.val));

		// EndDate, setup ongoing settings
		if(dtName == 'EditEndDate') {
			altText = 'ongoing';
			if(!validSvc.isDate(dt.val)) {
				altChecked = true;
				var dtToday = utilSvc.dt.zeroTime(new Date());
				setDate = utilSvc.dt.greaterThan(dt.min, dtToday) ? dtToday : dt.min; // use today's date for "ongoing" calendar picker location instead of min
			}
		}

		$scope.$broadcast('widget.input.date.pick', {
			uniqueId: 'Npi' + dtName,
			setDate: setDate,
			minDate: dt.min,
			maxDate: dt.max,
			altText: altText,
			altChecked: altChecked
		});

		$timeout(function(){
			if(validSvc.isText(vm.dtPickShow.pending)) {
				vm.dtPickShow[vm.dtPickShow.pending] = true;
			}
		},100);
	}

}

 
priceRepo.$inject = ['$q', '$rootScope', 'apiService', 'errSvc', 'utilSvc', 'validSvc'];
angular
	.module('espui.ops')
	.factory('priceRepo', priceRepo);


/* @ngInject */
function priceRepo($q, $rootScope, apiService, errSvc, utilSvc, validSvc) {

	var _currentPurl = '';

	// service definition
	var service = {
		getList: getList,
		getSummary: getSummary,
		getExcel: getExcel,
		updateStatus: updateStatus,
	};

	return service;


	/**
	 *    VIEW MODEL
	 */


	/**
	 *   LIST
	 */

	function parseQueryParams(q, isExcel) {
		var params = {
			DateType: 'InvoiceDate',
			StartDate: q.StartDate.val,
			EndDate: q.EndDate.val
		};

		if (q.Vendor.vals.length > 0) {
			params.Vendor = q.Vendor.vals;
		}

		if (q.Account.vals.length > 0) {
			params.Account = q.Account.vals;
		}
		if (q.Status.chk) {
			params.Status = q.Status.vals;
			if(q.StatusReason.chk) {
				params.StatusReason = q.StatusReason.vals;
			}
		}
		if (q.DrugType.chk) {
			params.DrugType = q.DrugType.vals;
		}
		if (q.ItemCode.chk) {
			params.ItemCode = q.ItemCode.val;
		}
		if (q.MinimumDollarDiscrepancy.chk) {
			params.UseMinimumDollarDiscrepancy = true;
			params.MinimumDollarDiscrepancy = q.MinimumDollarDiscrepancy.val;
		}
		if (q.MinimumPercentDiscrepancy.chk) {
			params.UseMinimumPercentDiscrepancy = true;
			params.MinimumPercentDiscrepancy = q.MinimumPercentDiscrepancy.val;
		}
		if (q.InvNumber.chk) {
			params.InvNumber = q.InvNumber.val.toUpperCase();
		}

		// add excel specific list of line item ids
		if (!!isExcel && Array.isArray(q.LineItemIds) && q.LineItemIds.length > 0) {
			params.LineItemIds = q.LineItemIds;
		}

		return params;
	}

	function buildQuery(query) {
		if (!!!query) {
			throw new Error('priceRepo.buildQuery, query required');
		}

		return {
			Context: {
				CEID: query.CE.vals,
				RXID: query.RX.vals,
			},
			Params: parseQueryParams(query, false)
		};
	}	

	function getList(query) {
		_currentPurl = 'ops/pricevalidation/list';
		var defer = $q.defer();
		var apiRequest = buildQuery(query);

		// add list request props
		apiRequest.Paging = {
			Page: 1,
			Size: 20000
		};
		apiRequest.SortBy = [utilSvc.sorting.sortByApiStyle('TotalVariance')];

		apiService.post(_currentPurl, apiRequest).then(okGetList, errGetList);

		function okGetList(r) {
			if (!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				defer.resolve({
					Items: r.data.Entity,
					TooMany: r.data.Entity.length > 20000
				});
			}
		}

		function errGetList(r) {
			defer.reject(r);
		}

		return defer.promise;
	}

	function getSummary(query) {
		_currentPurl = 'ops/pricevalidation/summary';
		var defer = $q.defer();
		var apiRequest = buildQuery(query);

		// MOCK
		apiService.post(_currentPurl, apiRequest).then(okGetSummary, errGetSummary);
		//okGetSummary(mockDashboardData());

		function mockTrendData() {
			var trend = [],
			dtNow = new Date();
		
			var dt = new Date(),
				year = '',
				mth = 0,
				mthTxt = '',
				day = 0,
				dayTxt = '';
			var magnitudes = [0,89,45,67,78,45,30,20,5],
				magI = 0;
					
			for(var i = 0; i < 8; i++) {
				dt = utilSvc.dt.addDays(dtNow, (i * -7));
				year = dt.getFullYear().toString();
				mth = dt.getMonth() + 1;
				mthTxt = mth < 10 ? '0' + mth.toString() : mth.toString();
				day = dt.getDate();
				dayTxt = day < 10 ? '0' + day.toString() : day.toString();
				magI = i + 1;
				trend.push({
					Date:year + '-' + mthTxt + '-' + dayTxt, // same format as timeseries
					Credited: {
						Count: magI * 100 * magnitudes[magI],
						Amount: magI * 1000 * magnitudes[magI]
					},
					NotCredited: {
						Count: magI * 50 * magnitudes[magI],
						Amount: magI * 500 * magnitudes[magI]
					},
					Other: {
						Count: magI * 25 * magnitudes[magI],
						Amount: magI * 250 * magnitudes[magI]
					}
				});
			}
			return utilSvc.array.sortTextASC(trend, 'Date');
		}

		function mockDashboardData() {
			return {
				status:200,
				data: {
					Entity: {
						Activity: {
							Total: {
								Count: 161,
								Amount: 44531
							},
							New: {
								Count: 132,
								Amount: 34987
							},
							Pending: {
								Count: 3,
								Amount: 123
							},
							Complete: {
								Count: 26,
								Amount: 9420
							},
							CompleteStats:[
								{Reason:'Credited', Count:17, Amount:8},
								{Reason:'Not Credited', Count:3, Amount:1},
								{Reason:'Alt Contract', Count:1, Amount:0},
								{Reason:'Expired', Count:1, Amount:0},
								{Reason:'Blocked', Count:1, Amount:0},
								{Reason:'Negative Value', Count:1, Amount:50},
								{Reason:'Offset', Count:1, Amount:30},
								{Reason:'Other', Count:1, Amount:5},
							],
						},
						TopNdc: {
							New: [
								{Name:'new ndc 1', Amount:2},
								{Name:'new ndc 2', Amount:1},
								{Name:'new ndc 3', Amount:1},
								{Name:'new ndc 4', Amount:0},
								{Name:'new ndc 5', Amount:0},
							],
							Pending:[
								{Name:'pending ndc 1', Amount:2},
								{Name:'pending ndc 2', Amount:1},
								{Name:'pending ndc 3', Amount:1},
								{Name:'pending ndc 4', Amount:5},
								{Name:'pending ndc 5', Amount:2},
							],
							Complete:[
								{Name:'closed ndc 1', Amount:2},
								{Name:'closed ndc 2', Amount:1},
								{Name:'closed ndc 3', Amount:1},
								{Name:'closed ndc 4', Amount:5},
								{Name:'closed ndc 5', Amount:2},
							]
						},
						// Trend: mockTrendData()
					}
				}
			};	
		}

		function okGetSummary(r) {
			if (!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				// use Closed instead of Complete, UI is all based on Closed naming
				var act = r.data.Entity.Activity || {};
				act.Closed = act.Complete || {};
				act.ClosedStats = Array.isArray(act.CompleteStats) ? act.CompleteStats : [];

				var topNdc = r.data.Entity.TopNdc || {};
				topNdc.Closed = topNdc.Complete || {};

				var trend = r.data.Entity.Trend || [];
				trend.forEach(function(t){
					t.New = t.New || {};
					t.Pending = t.Pending || {};
					t.Closed = t.Complete || {};
				});

				defer.resolve({
					Activity: act,
					TopNdc: topNdc,
					Trend: trend
				});
			}
		}

		function errGetSummary(r) {
			defer.reject(r);
		}

		return defer.promise;
	}


	function updateStatus(ids, newStatus, reason, note) {
		_currentPurl = 'ops/pricevalidation/status';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Params: {
				Ids: ids,
				Status: newStatus,
				Reason: reason,
				Note: note
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okRefStatus, errRefStatus);

		function okRefStatus(r) {

			// entity returned (ignoring async JobId for now)
			if (!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errRefStatus(r) {
			var result = null;
			if (is409(r)) {
				r.msg = r.data.error;
				result = r;
			}
			else if (!!r) {
				errSvc.warn('Api request failed', _currentPurl + ' repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(result);
		}

		function is409(r) {
			return !!r && r.status == 409 && !!r.data && validSvc.isText(r.data.error);
		}

		return defer.promise;
	}

	/**
	 *    GET EXCEL
	 *    file created on api server, expecting a binary file stream instead of JSON
	 */

	function getExcel(tabName, query, filename) {

		// params
		if (!!!query || !validSvc.isText(filename)) {
			throw new Error('referralRepo.getExcel, query and filename required');
		}

		// tbd.. switch for excel types
		switch (tabName) {
			case 'NDC':
				_currentPurl = 'ops/pricevalidation/list/excel';
				break;
			default:
				throw new Error('priceRepo.getExcel, unknown list name: ' + listName);
		}

		var defer = $q.defer();
		var apiRequest = {
			Context: {
				CEID: query.CE.vals,
				RXID: query.RX.vals,
			},
			Params: parseQueryParams(query, true) // true for excel
		};
		apiRequest.Params.Filename = filename;


		apiService.postGetBinary(_currentPurl, apiRequest).then(okGetExcel, errGetExcel);

		function okGetExcel(r) {
			defer.resolve(r.data);
		}

		function errGetExcel(r) {
			if (r !== null) {
				r = r || {};
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

} 
priceDetailCtl.$inject = ['$scope', '$state', '$timeout', '$filter', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc'];
angular
.module('espui.ops')
.controller('PriceDetailCtl', priceDetailCtl);


/* @ngInject */
function priceDetailCtl($scope, $state, $timeout, $filter, validSvc, errSvc, utilSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this,
		_pendingEdit = {},
		_docViewListener = null;

	// inherit sorting and paging features
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);

	// properties
	vm.isWaiting = false;
	vm.action = '';

	// models
	vm.context = {};
	vm.invoices = {};
	vm.invoice = {};

	// next/back buttons
	vm.btnFWD = false;
	vm.btnBack = false;
	vm.goNext = goNext;

	// tabs
	vm.activeTab = '';
	vm.tabChange = tabChange;

	// row selector
	vm.toggleItem = toggleItem;
	vm.toggleList = toggleList;
	
	/**
	 * 		EVENTS
	 */


	/**
	 *    INIT
	 */

	init();

	function init() {
		vm.context = initContext($state.params, $scope.User);
		tabChange('INVOICE');
	}

	function initContext(params, usr) {
		var ctx = params || {};

		if(!!!ctx || !Array.isArray(ctx.Items) || ctx.Items.length < 1 || !validSvc.isInteger(ctx.Idx) || ctx.Idx < 0 || ctx.Idx > ctx.Items.length - 1) {
			throw new Error('priceDetail, Price Items and current index required');
		}

		var isVerity = usr.Type == 'VERITY' || usr.Type == 'VERITYSA',
			hasEdit = utilSvc.user.hasFeature($scope, 'ops.pricevalidation.edit');

		console.log('hasEdit', hasEdit);

		vm.context = {
			isVerity: isVerity,
			CE: '',
			RX: '',
			hasEdit: hasEdit,
			Items: JSON.parse(JSON.stringify(ctx.Items)),
			Idx: ctx.Idx,
			IdxTitle: ''
		};

		return setContext(ctx.Idx);
	}

	function setContext(idx) {
		var ctx = vm.context,
			items = vm.context.Items;

		if(!validSvc.isInteger(idx) || idx < 0 || idx > items.length - 1) {
			throw new Error('referralDetail.setContext, idx is not valid: ' + idx);
		}
		ctx.Idx = idx;
		ctx.IdxTitle = (idx + 1).toString() + ' of ' + items.length.toString();

		var item = items[idx];
		ctx.CE = item.CEID;
		ctx.RX = item.RXID;
		ctx.DispId = item.DispId;
		ctx.RxShortName = utilSvc.aff.rxShortNameById($scope.User.AffList, ctx.RX);

		// fwd/back buttons
		vm.btnFWD = idx + 1 < items.length;
		vm.btnBack = idx > 0;

		return ctx;
	}

	function toggleList(item) {
		var dataItems = Array.isArray(vm.popup.DataItems) ? vm.popup.DataItems : [];
		var filteredMap = {};
		if(action == 'ALL') {
			// select all filtered items without paging
			var flt = JSON.parse(JSON.stringify(vm.popup.flt)); // de-ref deep copy
			flt.PageSize = 10000000;
			var filteredItems = vm.filterList(dataItems, flt);

			// max 20 clone targets for CE scope
			if(filteredItems.length > 20 && vm.context.listScope == 'CE') {
				msgSvc.ok('Cannot Select', 'Maximum 20 Facility selections allowed');
				return;
			}

			// build map
			filteredItems.forEach(function(item) {
				filteredMap[item.uniqueId] = true;
			});
		}

		var checked = action == 'ALL';
		vm.popup.cloneTo = [];

		// set data items and rebuild cloneTo items
		dataItems.forEach(function(item) {
			item.checked = checked;
			if(checked && !!filteredMap[item.uniqueId]) {
				vm.popup.cloneTo.push(cloneToVM(item));
			}
		});
	}

	function toggleItem(item) {
		item.checked = !!!item.checked;
	}

	/**
	 *    GET DETAIL
	 */

	function getDetail() {
		vm.action = 'LIST';
		vm.invoices = vm.context.Items;
		vm.header = vm.invoices[vm.context.Idx];
		vm.invoice = invoiceVM(vm.invoices[vm.context.Idx].Items);
		vm.header.Status = 'NEW';
		var completeCnt = 0,
		    item = {};
		// aggregate status
		for(var i = 0; i < vm.invoice.Items.length; i++) {
			item = vm.invoice.Items[i];
			if (item.Status == 'PENDING') {
				vm.header.Status = 'PENDING';
			}
			if (item.Status == 'COMPLETE') {
				vm.header.Status = 'PENDING';
				completeCnt += 1;
			}
		}
		if (completeCnt == vm.invoice.Items.length) {
			vm.header.Status = 'COMPLETE';
		}
		console.log('vm.header, vm.invoice', vm.header, vm.invoice);
	}

	function invoiceVM(invoices) {
		// feed re-uses properties from vm.match, only need the feed array parsed

		var items = Array.isArray(invoices) ? invoices : [],
			item = {};

		for(var i = 0; i < items.length; i++) {
			item = items[i];
			item.OrderDate = item.PoDt;
			item.InvoiceDate = item.InvDt;
			item.Status = item.PriceValidStatus;
			item.StatusReason = item.PriceValidStatusReason;
			item.uniqueId = item.Id + '_' + item.LineNumber;
		}

		return {
			Items: items,
			Paging: {
				Page: 1,
				Size: $scope.tblPagingSize,
				Total: vm.getTotalPages(items.length, $scope.tblPagingSize)
			},
			SortBy: ['-InvoiceDate']
		};
	}


	/**
	 * 	  REFERRAL CHANGE TAB
	 */

	function tabChange(newTab) {
		if(vm.isWaiting) {
			return;
		}
		vm.action = '';
		vm.activeTab = newTab;
		switch(newTab) {
			case 'INVOICE':
				getDetail();
				break;
			default:
				throw new Error('referralDetail.tabChange, unknown tab: ' + newTab);
		}
	}

	/**
	 *    MATCH: BACK / FWD
	 */

	function goNext(increment) {

		if(vm.isWaiting) {
			return;
		}
		//vm.popup = {};

		// avoid index errors
		var idx = vm.context.Idx + increment;
		if(idx < 0) {
			idx = 0;
		}
		else if(idx > vm.context.Items.length - 1) {
			idx = vm.context.Items.length - 1;
		}

		vm.context = setContext(idx);
		tabChange('INVOICE');
	}

	function toggleWait(isOn) {
		vm.isWaiting = !!isOn;
		msgSvc.wait(!!isOn);
	}

}
 
priceCtl.$inject = ['$scope', '$state', '$timeout', '$window', 'sessionRepo', 'priceRepo', 'prefsRepo', 'lookupRepo', 'appConst', 'utilSvc', 'validSvc', 'msgSvc', 'errSvc'];angular
	.module('espui.ops')
	.controller('PriceListCtl', priceCtl);

/* @ngInject */
function priceCtl($scope, $state, $timeout, $window, sessionRepo, priceRepo, prefsRepo, lookupRepo, appConst, utilSvc, validSvc, msgSvc, errSvc) {

	// private props
	var _featureName = '',
		_pagingEventListener = null,
		_returnVisit = false,
		_mouseLeaveDelay = {},
		_tblViewEventListener = null,
		_statusList = ['NEW', 'PENDING', 'COMPLETE'],
		_drugTypeList = ['Assay', 'Specialty', 'Brand', 'Generic'],
		_accountList = ['340B', 'IND', 'GPO', 'OWN', 'WAC'],
		_pendingExcelFilename = '',
		_priceCeList = [],
		_pendingUpdate = {};
	var vm = this;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addMultiselect(vm);
	utilSvc.ctl.addFlexTop(vm);
	utilSvc.ctl.addTableViews(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.context = {};

	// droplists
	vm.DateRangeList = [];
	vm.StatusReasonDroplist = [];

	// query
	vm.query = {};
	vm.queryChange = queryChange;
	vm.querySubmit = querySubmit;
	vm.dateRangeChange = dateRangeChange;
	vm.queryToggleStatusOption = queryToggleStatusOption;

	// tbl and filters
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;

	// multiselect
	vm.CeMultiselect = {};
	vm.RxMultiselect = {};
	vm.StatusMultiselect = {};
	vm.StatusReasonMulti = {};
	vm.DrugTypeMultiselect = {};
	vm.StatusDroplist = {};
	vm.multiClick = multiClick;
	vm.multiToggle = multiToggle;
	vm.multiHover = multiHover;

	// flex top
	vm.flex = {};
	vm.flexTopExpand = flexTopExpand;

	// popup
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;
	vm.rowClick = rowClick;

	// table view
	vm.tblViewConfig = {};
	vm.tblView = {};

	// tabs
	vm.activeTab = '';
	vm.tabChange = tabChange;

	// excel
	vm.getExcel = getExcel;

	// summary
	vm.summary = {};
	vm.sumDashboardToggle = sumDashboardToggle;
	vm.sumChartActivity = {};
	vm.sumChartClosed = {};
	vm.sumChartTrend = {};

	// edit
	vm.hasEditMode = false;
    vm.edit = editVM();
    vm.flyout = flyoutVM();
	vm.flyoutChangeStatus = flyoutChangeStatus;
    vm.editCancel = editCancel;
	vm.editToggleAll = editToggleAll;
	vm.editToggle = editToggle;
	vm.editSubmit = editSubmit;


	/**
	 *    EVENTS
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function (event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if (!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});

	_tblViewEventListener = $scope.$on('widget.tblview.editor.change', function (event, evtData) {
		event.stopPropagation();

		switch (evtData.type) {

			case 'edit':
				openPopup(null, 'TBLVIEW');
				break;

			case 'close':
				closePopup();
				break;

			case 'load':
				// load specific view requested
				vm.tblView.current = evtData.id;
				$timeout(function () {
					tblViewReload(vm.query, true);

					// update user preference (delay the network call)
					$timeout(function () {
						if (vm.action == 'LIST' && !!vm.tblView && validSvc.isText(vm.tblView.current)) {
							prefsRepo.setCurrentTableView(vm.tblViewConfig.storageKey, vm.tblView.current).then(okCurrentTableView, errCurrentTableView);
						}
					}, 2000);
				}, 300);
				break;

			default:
				throw new Error('widget.tblview.editor.change, unknown event type: ' + evtData.type);
		}

	});

	$scope.$on('$destroy', function () {
		// clean up listener on destroy
		if (!!_pagingEventListener) {
			_pagingEventListener();
		}
		if (!!_tblViewEventListener) {
			_tblViewEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {
		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		_featureName = $state.current.name;
		vm.init = true;

		// context
		vm.hasEditMode = utilSvc.user.hasFeature($scope, 'ops.pricevalidation.edit');

		resetCharts();
		vm.flex = vm.flexInit();
		vm.tblViewConfig = tblViewConfigSetup(tblViewSchemaFlyoutVM());
		initDroplists();
		vm.query = initQueryFilterViewState();

		// ASYNC: get CPV CEs
		lookupPriceValidationCeList();
	}

	function getAffs() {
		var affs = utilSvc.aff.findStatus($scope.User.AffList, ['ONBOARDING', 'ACTIVE']);
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
		affs = utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));
		
		// limit affs to Referral CEs once they are loaded
		affs = utilSvc.aff.findCeList(affs, _priceCeList);

		return affs;
	}

	function initDroplists() {

		vm.StatusDroplist = [
			{ label: 'NEW', value: 'NEW' },
			{ label: 'PENDING', value: 'PENDING' },
			{ label: 'COMPLETE', value: 'COMPLETE' },
		];

		var statusReasons = [
			{ label: 'Choose Outcome', value: 'NONE' },
			{ label: 'CR - PRICE/ACCOUNT', value: 'CREDITEDPRICE' },
			{ label: 'CR - CONTRACT', value: 'CREDITEDCONTRACT' },
			{ label: 'CR - RETURNED', value: 'CREDITEDRETURNED' },
			{ label: 'NOT CREDITED', value: 'NOTCREDITED' },
			{ label: 'BACK ORDER', value: 'BACKORDER' },
			{ label: 'INVOICE TOO OLD', value: 'EXPIRED' },
			{ label: 'MINIMAL/NEGATIVE VALUE', value: 'NEGATIVE_VALUE' },
			{ label: 'OTHER', value: 'OTHER' },
        ];
		vm.StatusReasonDroplist = deRef(statusReasons);

		vm.DateRangeList = utilSvc.widget.dateRangeList(['CUSTOM92']);
		vm.DateRangeList.push({ label: 'Last 12 Months', value: 'LTM' });
		vm.DateRangeList.push({ label: 'Yearly', value: 'YEARLY' });
		vm.DateRangeList.push({ label: 'Year To Date', value: 'YTD' });
		vm.DateRangeList.push({label:'Custom Date Range (92 day max)', value: 'CUSTOM92'});

		// CE multiselect
		var ceList = utilSvc.aff.ceList(getAffs());
		vm.CeMultiselect = {
			type: 'CE',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Facility',
			vals: [],
			list: vm.multiselectBuild(ceList, false),
			flt: ''
		};

		// RX multiselect
		vm.RxMultiselect = {
			type: 'RX',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Pharmacy',
			vals: [],
			list: [],
			flt: ''
		};

		// Vendor multiselect
		vm.VendorMultiselect = {
			type: 'Vendor',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Vendor',
			vals: [],
			list: [],
			flt: ''
		};

		// Account multiselect
		var accountMultiList = deRef(_accountList);
		accountMultiList.unshift('ALL');
		vm.AccMultiselect = {
			type: 'STATUS',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'All Options',
			vals: ['ALL'],
			list: vm.multiselectBuild(accountMultiList),
			flt: ''
		};

		// Status multiselect
		var statusMultiList = deRef(_statusList);
		statusMultiList.unshift('ALL');
		vm.StatusMultiselect = {
			type: 'STATUS',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'All Options',
			vals: ['ALL'],
			list: vm.multiselectBuild(statusMultiList),
			flt: ''
		};

		vm.StatusReasonMulti = {
			type: 'STATUS_REASON',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'All Options',
			vals: ['ALL'],
			list: buildStatusReasonMultiList(statusReasons),
			flt: ''
		};

		var drugTypeMultiList = deRef(_drugTypeList);
		drugTypeMultiList.unshift('ALL');
		vm.DrugTypeMultiselect = {
			type: 'DRUG',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'All Options',
			vals: ['ALL'],
			list: vm.multiselectBuild(drugTypeMultiList),
			flt: ''
		};
	}

	function deRef(list) {
		// use JSON instead of slice() for a deep copy
		return JSON.parse(JSON.stringify(list));
	}

	function buildStatusReasonMultiList(items) {
		items = Array.isArray(items) ? items : [];
		if(items.len < 1) {
			return [];
		}

		// skip first item NONE
		var result = [];
		for(var i = 1; i < items.length; i++) {
			result.push({
				lbl: items[i].label,
				val: items[i].value,
				checked: true
			});
		}

		// sort by lbl
		result = utilSvc.array.sortASC(result, 'lbl');

		// add ALL option
		result.unshift({
			lbl: 'ALL',
			val: 'ALL',
			checked: true
		});

		return result;
	}

	function newCheckProp(val, chk) {
		var p = validSvc.newProp(val);
		p.chk = !!chk;
		return p;
	}

	function initQueryFilterViewState() {
		var q = {
			Sync: 'ON',
			CE: validSvc.newProp(),
			RX: validSvc.newProp(),
			Vendor: validSvc.newProp(),
			DateType: 'INVOICE',
			DateRangeMode: 'MTD',
			StartDate: validSvc.newPropDateNull(),
			EndDate: validSvc.newPropDateNull(),
			DateRangeValid: false,

			// search options
			ItemCode: newCheckProp(''),
			MinimumDollarDiscrepancy: newCheckProp(),
			MinimumPercentDiscrepancy: newCheckProp(),
			Account: validSvc.newProp(),
			Status: newCheckProp('ALL'),
			StatusReason: newCheckProp('ALL'),
			DrugType: newCheckProp('ALL'),
			InvNumber: newCheckProp(''),
		};

		vm.flt = initFlt();

		// viewstate
		_returnVisit = false;
		var vs = sessionRepo.get('vs-ops-price-list');
		if (!!vs) {
			_returnVisit = true;
			vm.activeTab = vs.activeTab;
			vm.flt = vm.resetFilters(vs.flt);
			q = reloadQueryFromViewState(vs.query);
		}
		else {
			vm.activeTab = 'SUMMARY';
			q.CE.vals = [];
			q.RX.vals = [];
			q.Vendor.vals = ['ALL'];
			q.Account.vals = ['ALL'];
			q.Status.vals = ['ALL'];
			q.StatusReason.vals = ['ALL'];
			q.DrugType.vals = ['ALL'];

			queryValid(q);
			vm.multiselectTitle(vm.CeMultiselect, true);
		}

		return q;
	}

	function initFlt() {
		return vm.initFilters({
			Config: {
				Dates: ['WrittenDate', 'ServiceDate'],
				DateFmt: 'M/d/yyyy'
			},
			SortBy: ['-TotalVariance']
		});
	}

	function lookupPriceValidationCeList() {
		// ASYNC: UI only uses Referral CEs
		_priceCeList = [];
		var affs = utilSvc.aff.findStatus($scope.User.AffList, ['ONBOARDING', 'ACTIVE']);
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
		affs = utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));
		var ceList = utilSvc.aff.ceList(affs);
		vm.isWaiting = true;

		if(ceList.length < 1) {
			noCeList();
			return;
		}

		lookupRepo.CeInfo(ceList).then(okCeLookup, errCeLookup);

		function okCeLookup(items) {

			// none found, keep waiting on
			if(!Array.isArray(items) || items.length < 1) {
				noCeList();
				return;
			}
			vm.isWaiting = false;
		
			// create ce list
			var item = null;
			for(var i = 0; i < items.length; i++) {
				item = items[i];
				if(!!item.EnablePriceValidation) {
					_priceCeList.push(item.NickName);
				}
			}
			
			// setup CE Multiselect
			_priceCeList.sort();
			vm.CeMultiselect.list = vm.multiselectBuild(_priceCeList, false);

			// continue init
			initFinalize();
		}

		function noCeList() {
			msgSvc.ok('No Facilities', 'No covered entities with option "Enable Price Validation" were found.');
		}
	
		function errCeLookup(r) {
			vm.isWaiting = false;
			if(!!r) {
				errSvc.warn('Error looking up ce display properties', 'priceList.lookupPriceValidationCeList', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function initFinalize() {
		// runs after CE lookup
		initDroplists();
		vm.query = initQueryFilterViewState();
		// fire date control event after widget scope is setup
		$timeout(function () {
			$scope.$broadcast('widget.input.date.range.mode', {mode: vm.query.DateRangeMode, keepDates: true });
		}, 200);		
	}


	/**
	 *    VIEW MODEL
	 */

	function summaryVM(data) {
		if(!!!data) {
			return {
				Activity:{},
				TopNdc: {},
				Trend:{}
			};
		}

		// ACTIVITY
		var act = data.Activity || {};
		act.View = 'DASH';
		act.Title = 'Show Data Table';
		act.DataSource = 'COUNT';
		act.DataSourceTitle = 'Invoice Count, Total';

		act.ClosedStats = Array.isArray(act.ClosedStats) ? act.ClosedStats : [];
		act.ClosedStats = adjustPercentTo100(act.ClosedStats, act.Closed.Count, 'Count', 'CountPercent');
		act.ClosedStats = adjustPercentTo100(act.ClosedStats, act.Closed.Amount, 'Amount', 'AmountPercent');
		
		// titles and colors
		act.New.Title = 'NEW';
		act.New.color = 'gray';
		act.Pending.Title = 'PENDING';
		act.Pending.color = 'primaryDark';
		act.Closed.Title = 'CLOSED';
		act.Closed.color = 'primary';
		
		// put values into one list, adjust percents to always total 100
		act.Items = [act.New, act.Pending, act.Closed];
		act.Items = adjustPercentTo100(act.Items, act.Total.Count, 'Count', 'CountPercent');
		act.Items = adjustPercentTo100(act.Items, act.Total.Amount, 'Amount', 'AmountPercent');

		// TOP NDCs
		var topNdc = data.TopNdc || {};
		topNdc.View = 'DASH';
		
		// build data into one list of top ndc items
		var topNdcItems = [];

		// NEW (default)
		var topNdcStats = parseTopNdcItems(topNdc.New, 'NEW');
		var adjustItems = adjustPercentTo100(topNdcStats.items, topNdcStats.totalAmount, 'Amount', 'AmountPercent');
		topNdcItems = topNdcItems.concat(adjustItems);
		topNdc.NEW = {Amount:topNdcStats.totalAmount};
		topNdc.TitleAmount = topNdc.NEW.Amount;
		topNdc.DataSource = 'NEW';

		// PENDING
		topNdcStats = parseTopNdcItems(topNdc.Pending, 'PENDING');
		adjustItems = adjustPercentTo100(topNdcStats.items, topNdcStats.totalAmount, 'Amount', 'AmountPercent');
		topNdcItems = topNdcItems.concat(adjustItems);
		topNdc.PENDING = {Amount:topNdcStats.totalAmount};

		// CLOSED
		topNdcStats = parseTopNdcItems(topNdc.Closed, 'CLOSED');
		adjustItems = adjustPercentTo100(topNdcStats.items, topNdcStats.totalAmount, 'Amount', 'AmountPercent');
		topNdcItems = topNdcItems.concat(adjustItems);
		topNdc.CLOSED = {Amount:topNdcStats.totalAmount};

		topNdc.Items = utilSvc.array.sortDSC(topNdcItems, 'AmountPercent');

		// TREND
		var trendItems = Array.isArray(data.Trend) ? data.Trend : [];
		var trend = {
			DataSource: 'COUNT',
			DataSourceTitle: 'Closed Invoice Count - ' + trendItems.length + ' Week Trend',
			Items: trendItems
		};

		return {
			Activity: act,
			TopNdc: topNdc,
			Trend: trend
		};
	}

	function adjustPercentTo100(items, divisor, valueProp, percentProp) {
		var total = 0,
			val = 0,
			largest = 0,
			idx = -1,
			item = {},
			useDivisor = numberOverZero(divisor);

		for(var i = 0; i < items.length; i++) {
			item = items[i];

			// convert value into percent
			val = item[valueProp];
			val = numberOverZero(val) && useDivisor ? parseInt((val / divisor)*100) : 0;
			item[percentProp] = val;

			// track total and largest percent
			total += val;
			if(val > largest) {
				largest = val;
				idx = i;
			}
		}

		// adjust largest item if count is not 100
		var tweak = 100 - total;
		if(total > 0 && tweak != 0 && idx > -1) {
			items[idx][percentProp] += tweak;
		}

		return items;
	}

	function numberOverZero(val) {
		return validSvc.isNumber(val) && val > 0;
	}

	function parseTopNdcItems(items, option) {
		items = Array.isArray(items) ? items : [];
		var result = {
			items:[],
			totalAmount:0
		};
		
		items.forEach(function(item){
			item.Option = option;
			result.items.push(item);
			result.totalAmount += item.Amount;
		});

		return result;
	}

	function mainListVM(dataItems, tooMany) {
		// main list items have summary info with child Invoices
		dataItems = Array.isArray(dataItems) ? dataItems : [];

		var mainItem = {},
			allComplete = false,
			hasPending = false,
			invoices = [],
			inv = {},
			combinedReason = '',
			reasonMatch = false;

		for (var i = 0; i < dataItems.length; i++) {
			mainItem = dataItems[i];
			console.log('main item', mainItem);
			mainItem.uniqueId = 'm' + mainItem.Id; // use letter prefix for JS maps
			invoices = Array.isArray(mainItem.Items) ? mainItem.Items : [];
			mainItem.Acct = mainItem.AccumulatorGroup;

			// if main item has 1 invoice, promote invoice details
			mainItem.Count = invoices.length;
			if(mainItem.Count == 1) {
				inv = invoices[0];
				mainItem.OrdDate = validSvc.isDate(inv.PoDt) ? inv.PoDt : null;
				mainItem.OrdNum = inv.PoName;
				mainItem.InvDate = validSvc.isDate(inv.InvDt) ? inv.InvDt : null;
				mainItem.InvNum = inv.InvNumber;
			}

			// setup status
			combinedReason = '';
			reasonMatch = false;

			// parse invoice children
			mainItem.ChangeLog = [];
			allComplete = true; // assume all complete
			hasPending = false;
			for(var ii = 0; ii < invoices.length; ii++) {
				inv = invoices[ii];
				inv.uniqueId = 'i' + inv.Id; // use letter prefix for JS maps
				inv.edit = true;

				inv.OrderDate = validSvc.isDate(inv.PoDt) ? inv.PoDt : null;
				inv.InvoiceDate = validSvc.isDate(inv.InvDt) ? inv.InvDt : null;

				// derive single or multiple status
				inv.Status = inv.PriceValidStatus;
				inv.StatusReason = inv.Status == 'COMPLETE' ? inv.PriceValidStatusReason : '';
				switch(inv.Status) {
					case 'PENDING':
						allComplete = false;
						hasPending = true;
						break;
					case 'COMPLETE':
						if(allComplete) {
							if(combinedReason == '') {
								combinedReason = inv.StatusReason;
								reasonMatch = true;
							}
							else if(combinedReason != inv.StatusReason) {
								reasonMatch = false;
							}
						}
						break;
					default:
						allComplete = false;
				}

				// change log
				if(Array.isArray(inv.ChangeLog) && inv.ChangeLog.length > 0) {
					for(var iii = 0; iii < inv.ChangeLog.length; iii++) {
						mainItem.ChangeLog.push(parseLogEntry(inv.ChangeLog[iii]));
					}
				}
			}
			mainItem.Invoices = invoices;
			mainItem.Status = allComplete ? 'COMPLETE' : hasPending ? 'PENDING' : 'NEW';
			mainItem.StatusReason = allComplete ? (reasonMatch ? combinedReason : 'MULTIPLE') : '';
		}

		return {
			Items: [],
			DataItems: dataItems,
			TooMany: !!tooMany
		};
	}

	function parseLogEntry(log) {
		// returns a change log entry for the edit flyout
		var result = {
			Activity: '',
			Status: '',
			ModBy: log.ModBy,
			ModDt: validSvc.isDate(log.ModDt) ? log.ModDt : null,
			Notes: log.Note
		};

		// parse for activity
		var changed = Array.isArray(log.ChangedProperties) ? log.ChangedProperties : [];
		if (changed.length < 1)	{
			result.Activity = 'Notes';
			return result;
		}

		var activity = '';
		changed.forEach(function(chg) {
			switch (chg.Name) {
				case 'State':
					// add status change first always
					result.Activity = 'Status Change';
					result.Status = chg.Changed;
					break;
				default:
				 	// unknown
					if(activity.length > 0) {
						activity += ', ';
					}
					activity += 'Changed ' + chg.Name;
					break;
			}
		});

		// add unknown activity?
		if(activity.length > 0) {
			if(result.Activity.length > 0) {
				result.Activity += ', ';
			}
			result.Activity += activity;
		}

		return result;
	}

	/**
	 * 	QUERY
	 */

	function queryChange() {
		if (!vm.init) {
			vm.action = '';
			vm.summary = {};
			vm.tbl = {};
			vm.edit = editVM();
			vm.flyout = flyoutVM();
			vm.flt = vm.resetFilters(vm.flt);
			vm.flex = vm.flexInit();
			vm.popup = {};
			$scope.$broadcast('widget.paging');
			resetCharts(true);
		}
	}

	function queryToggleStatusOption() {
		if(vm.isWaiting) {
			return;
		}
		queryChange();
		var q = vm.query;

		if (q.Status.chk) {
			// toggle status off turns off status reason
			q.Status.chk = false;
			q.StatusReason.chk = false;
		}
		else {
			// toggle on, check status reason
			q.Status.chk = true;
			q.StatusReason.chk = queryOkForStatusReason(q.Status);
			if(q.StatusReason.chk) {
				q.StatusReason.vals = multiselectQueryVals(vm.StatusReasonMulti);
				q.StatusReason.fail = q.StatusReason.vals.length > 0 ? 'no' : 'yes';
				vm.multiselectTitle(vm.StatusReasonMulti, true);
			}
		}

		// reset status reason if not checked
		if(!q.StatusReason.chk) {
			q.StatusReason = newCheckProp('ALL');
			q.StatusReason.vals = ['ALL'];
			vm.StatusReasonMulti.vals = ['ALL'];
			vm.multiselectTitle(vm.StatusReasonMulti, true);
		}
	}

	function dateRangeChange(dtMode, isValid) {
		queryChange();

		vm.query.DateRangeMode = dtMode;
		vm.query.DateRangeValid = isValid;

		if (_returnVisit) {
			_returnVisit = false;
			querySubmit();
		}
		vm.init = false;
	}

	function multiClick(propName, val) {
		if (vm.isWaiting) {
			return;
		}
		queryChange();

		var multi = {};
		switch (propName) {
			case 'CE':
				multi = vm.CeMultiselect;
				break;
			case 'RX':
				multi = vm.RxMultiselect;
				break;
			case 'Vendor':
				multi = vm.VendorMultiselect;
				break;
			case 'Account':
				multi = vm.AccMultiselect;
				break;
			case 'Status':
				multi = vm.StatusMultiselect;
				break;
			case 'StatusReason':
				multi = vm.StatusReasonMulti;
				break;
			case 'DrugType':
				multi = vm.DrugTypeMultiselect;
				break;
			default:
				throw new Error('priceList.multiClick, unknown propName: ' + propName);
		}
		vm.multiselectClick(multi, val);
		vm.multiselectTitle(multi, true);

		var queryProp = vm.query[propName];
		queryProp.vals = multiselectQueryVals(multi);
		queryProp.fail = queryProp.vals.length > 0 ? 'no' : 'yes';
		if (queryProp.fail == 'yes') {
			return;
		}

		var affs = [];
		// CE click rebuilds RX options, default to ALL
		if (propName == 'CE') {
			affs = utilSvc.aff.findCeList(getAffs(), queryProp.vals);
			var rxList = utilSvc.aff.rxList(affs);
			rxList.unshift('ALL');
			vm.RxMultiselect.list = vm.multiselectBuild(rxList, false);
			multiClick('RX', 'ALL');
		}
		else if (propName == 'RX') {
			affs = utilSvc.aff.findCeList(getAffs(), vm.query.CE.vals);
			affs = utilSvc.aff.findRxList(affs, queryProp.vals);
			var vendorlist = utilSvc.aff.venList(affs, _accountList, true);
			vendorlist.unshift('ALL');
			vm.VendorMultiselect.list = vm.multiselectBuild(vendorlist, false);
			multiClick('Vendor', 'ALL');
		}
		else if (propName == 'Status') {
			// status must contain ALL or COMPLETE to use StatusReason
			var statReason = vm.query.StatusReason;
			statReason.chk = queryOkForStatusReason(queryProp);
			if(statReason.chk) {
				// toggle status reason on, check if it has values
				statReason.vals = multiselectQueryVals(vm.StatusReasonMulti);
				statReason.fail = statReason.vals.length > 0 ? 'no' : 'yes';
				vm.multiselectTitle(vm.StatusReasonMulti, true);
			}
		}
	}

	function queryOkForStatusReason(statusProp) {
		var vals = Array.isArray(statusProp.vals) ? statusProp.vals : [];
		return statusProp.chk && vals.length > 0 && (vals[0] === 'ALL' || vals.indexOf('COMPLETE') >= 0);
	}

	function flexTopExpand() {
		// user opened search query, reset list display, show search expanded
		queryChange();
	}

	function reloadQueryFromViewState(q) {

		// CE multi
		vm.multiselectReturnVisit(vm.CeMultiselect, '', q.CE.vals);
		vm.multiselectTitle(vm.CeMultiselect, true);
		q.CE.fail = vm.CeMultiselect.vals.length < 1 ? 'yes' : 'no';

		// RX multi
		var ceVals = multiAllChecked(vm.CeMultiselect) ? multiselectQueryVals(vm.CeMultiselect) : vm.CeMultiselect.vals;
		var ceAffs = utilSvc.aff.findCeList(getAffs(), ceVals);
		var rxList = utilSvc.aff.rxList(ceAffs);
		rxList.unshift('ALL');
		vm.RxMultiselect.list = vm.multiselectBuild(rxList, false);
		vm.multiselectReturnVisit(vm.RxMultiselect, '', q.RX.vals);
		vm.multiselectTitle(vm.RxMultiselect, true);
		q.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';

		// Vendor multi
		var rxAffs = utilSvc.aff.findRxList(ceAffs, rxList);
		var vendorlist = utilSvc.aff.venList(rxAffs, _accountList, true);
		vendorlist.unshift('ALL');
		vm.VendorMultiselect.list = vm.multiselectBuild(vendorlist, false);
		vm.multiselectReturnVisit(vm.VendorMultiselect, '', q.Vendor.vals);
		vm.multiselectTitle(vm.VendorMultiselect, true);
		q.Vendor.fail = vm.VendorMultiselect.vals.length < 1 ? 'yes' : 'no';

		// Account multi
		vm.multiselectReturnVisit(vm.AccMultiselect, '', q.Account.vals);
		vm.multiselectTitle(vm.AccMultiselect, true);
		
		// Status multi
		vm.multiselectReturnVisit(vm.StatusMultiselect, '', q.Status.vals);
		vm.multiselectTitle(vm.StatusMultiselect, true);
		q.Status.fail = vm.StatusMultiselect.vals.length < 1 ? 'yes' : 'no';

		// Status Reason multi
		if(queryOkForStatusReason(q.Status)) {
			vm.multiselectReturnVisit(vm.StatusReasonMulti, '', q.StatusReason.vals);
			vm.multiselectTitle(vm.StatusReasonMulti, true);
			q.StatusReason.vals = multiselectQueryVals(vm.StatusReasonMulti);
			q.StatusReason.fail = q.StatusReason.vals.length < 1 ? 'yes' : 'no';
		}

		// Drug Type multi
		vm.multiselectReturnVisit(vm.DrugTypeMultiselect, '', q.Status.vals);
		vm.multiselectTitle(vm.DrugTypeMultiselect, true);
		q.DrugType.fail = vm.DrugTypeMultiselect.vals.length < 1 ? 'yes' : 'no';
		
		// dates need to be re-hydrated from session storage (browser bug re-hydrates them as UTC string, not Date object)
		q.StartDate = validSvc.newPropDate(new Date(q.StartDate.val), new Date(q.StartDate.min), new Date(q.StartDate.max));
		q.EndDate = validSvc.newPropDate(new Date(q.EndDate.val), new Date(q.EndDate.min), new Date(q.EndDate.max));

		return q;
	}

	function tabChange(newTab) {
		if (vm.isWaiting) {
			return;
		}
		queryChange();

		switch (newTab) {
			case 'SUMMARY':
			case 'NDC':
				break;
			default:
				msgSvc.ok('priceListCtl.tabChange', 'unknown tab name: ' + newTab);
		}

		vm.activeTab = newTab;
		querySubmit();
	}


	/**
	 *    FILTER CHANGE
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if (!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if (vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function () {

			// filter values are stored inside table view columns
			if (vm.activeTab == 'NDC') {
				vm.flt = vm.tblViewGetColumnFilterValues(vm.tblView.cols, vm.flt);
			}

			vm.tbl.DataItems = Array.isArray(vm.tbl.DataItems) ? vm.tbl.DataItems : [];
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if (vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			$scope.$broadcast('widget.paging', {
				uniqueId: vm.activeTab,
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			// check if edit items are affected
			if (vm.activeTab == 'NDC' && vm.hasEditMode) {
				filterChangeEditItems();
			}

			// debounce viewstate save, want to minimize these
			$timeout(function () {
				if (!vm.flt.Busy && !vm.flt.Dirty) {
					saveViewState(vm.activeTab, vm.query, vm.flt);
				}
			}, 1000);

		}, delayTime);

	}


	/**
	 *    QUERY SUBMIT
	 */

	function queryValid(q) {

		// trying a validation collector to avoid re-listing all properties
		var isValid = true,
			failTxt = '';

		function setFail(failState) {
			if (isValid) {
				isValid = !!!failState;
			}
			return !!failState ? 'yes' : 'no';
		}

		q.CE.vals = multiselectQueryVals(vm.CeMultiselect);
		q.CE.fail = setFail(q.CE.vals.length < 1);
		q.RX.vals = multiselectQueryVals(vm.RxMultiselect);
		q.RX.fail = setFail(q.RX.vals.length < 1);
		q.Vendor.vals = multiselectQueryVals(vm.VendorMultiselect);
		q.Account.vals = multiselectQueryVals(vm.AccMultiselect);

		q.Status.fail = '';
		if (q.Status.chk) {
			q.Status.vals = multiselectQueryVals(vm.StatusMultiselect);
			q.Status.fail = setFail(q.Status.vals.length < 1);
		}

		q.StatusReason.fail = '';
		if (queryOkForStatusReason(q.Status)) {
			q.StatusReason.chk = true; // always checked if Status is ok
			q.StatusReason.vals = multiselectQueryVals(vm.StatusReasonMulti);
			q.StatusReason.fail = setFail(q.StatusReason.vals.length < 1);
		}
		else {
			q.StatusReason = newCheckProp();
			q.StatusReason.vals = ['ALL'];
			vm.StatusReasonMulti.vals = ['ALL'];
		}

		q.DrugType.vals = deRef(_drugTypeList);
		q.DrugType.fail = '';
		if (q.DrugType.chk) {
			q.DrugType.vals = multiselectQueryVals(vm.DrugTypeMultiselect);
			q.DrugType.fail = setFail(q.DrugType.vals.length < 1);
		}

		q.ItemCode.fail = '';
		if (q.ItemCode.chk) {

			// ndc format check
			var ndcTest = ndcCleanUp(q.ItemCode.val, false);
			q.ItemCode.val = ndcTest.val;
			failTxt = setFail(ndcTest.fail);
			q.ItemCode.fail = failTxt;
			q.ItemCode.msg = failTxt == 'yes' ? ndcTest.msg : '';
		}

		q.MinimumDollarDiscrepancy.fail = '';
		if(q.MinimumDollarDiscrepancy.chk) {
			var mdd = parseFloat(q.MinimumDollarDiscrepancy.val);
			var mddOk = validSvc.isNumber(mdd);
			failTxt = setFail(!mddOk);
			q.MinimumDollarDiscrepancy.fail = failTxt;
			q.MinimumDollarDiscrepancy.msg = failTxt == 'yes' ? 'not a number' : '';
		}

		q.MinimumPercentDiscrepancy.fail = '';
		if(q.MinimumPercentDiscrepancy.chk) {
			var mpd = parseFloat(q.MinimumPercentDiscrepancy.val);
			var mpdOk = validSvc.isNumber(mpd) && mpd > -100 && mpd < 100;
			failTxt = setFail(!mpdOk);
			q.MinimumPercentDiscrepancy.fail = failTxt;
			q.MinimumPercentDiscrepancy.msg = failTxt == 'yes' ? 'number greater than -100, less than 100' : '';
		}

		q.InvNumber.fail = '';
		if (q.InvNumber.chk) {
			q.InvNumber.fail = setFail(!validSvc.isText(q.InvNumber.val));
		}

		// always reset invoice ids, its used by excel only
		q.LineItemIds = [];

		return isValid;
	}

	function querySubmit() {
		if(vm.isWaiting) {
			return;
		}

		// validate
		if (!queryValid(vm.query)) {
			if (!vm.init) {
				msgSvc.ok('Search', 'Check filter settings');
			}
			return;
		}
		queryChange();
		toggleWait(true);

		vm.query.title = queryTitle();

		switch(vm.activeTab) {
			case 'SUMMARY':
				priceRepo.getSummary(vm.query).then(okGetSummary, errSubmit);
				break;
			case 'NDC':
				priceRepo.getList(vm.query).then(okGetList, errSubmit);
				break;
			default:
				throw new Error('priceListCtl.querySubmit, unknown tab: ' + vm.activeTab);
		}

	}

	function okGetList(r) {
		toggleWait();

		// query was good, save viewstate
		saveViewState(vm.activeTab, vm.query, vm.flt);
		vm.tbl = mainListVM(r.Items, r.TooMany);

		// no data
		if(vm.tbl.DataItems.length < 1) {
			noDataFound();
			return;
		}

		vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);

		// update paging ui
		$scope.$broadcast('widget.paging', {
			uniqueId: vm.activeTab,
			Size: vm.flt.PageSize,
			Page: vm.flt.Page,
			Total: vm.flt.PageTotal,
			RowCount: vm.flt.Count,
			ItemCount: vm.tbl.Items.length,
			DataCount: vm.tbl.DataItems.length
		});

		tblViewReload(vm.query, false, true); // keep paging if possible
		vm.flt.Ready = true;

		// slight pause to render collapsed query first
		vm.flex = vm.flexCollapse(vm.flex, true);
		vm.action = 'LIST';
	}

	function okGetSummary(r) {
		toggleWait();

		// query was good, save viewstate
		saveViewState(vm.activeTab, vm.query, vm.flt);

		vm.summary = summaryVM(r);

		// no data?
		if(vm.summary.Activity.Total.Count < 1) {
			noDataFound();
			return;
		}

		vm.sumChartActivity = chartActivityVM(vm.summary.Activity);
		vm.sumChartClosed = chartClosedVM(vm.summary.Activity);
		vm.sumChartTrend = chartTrendVM(vm.summary.Trend);

		// slight pause to render collapsed query first
		vm.flex = vm.flexCollapse(vm.flex, true);

		$timeout(function(){
			vm.action = 'LIST';
			renderSummaryCharts();
		},300);
	}

	function noDataFound() {
		msgSvc.ok('No Invoices Found', 'Adjust search settings.');
		flexTopExpand();
	}
	
	function renderSummaryCharts() {
		// render summary chart
		if(vm.activeTab != 'SUMMARY') {
			return;
		}
		
		// left donut: overall activity
		if(vm.sumChartActivity.data.length > 0) {
			$timeout(function() {
				var act = vm.sumChartActivity;
				if(act.data.length > 0) {
					act.status = 'DRAW';
					$scope.$broadcast('widget.chart.sync', {
						uniqueId: act.id,
						config: act.config,
						data: act.data,
						render: 'animate'
					});
				}
			},300);
		}
		
		// right donut: closed activity
		if(vm.sumChartClosed.data.length > 0) {
			$timeout(function() {
				var closed = vm.sumChartClosed;
				if(closed.data.length > 0) {
					closed.status = 'DRAW';
					$scope.$broadcast('widget.chart.sync', {
						uniqueId: closed.id,
						config: closed.config,
						data: closed.data,
						render: 'animate'
					});
				}
			},300);
		}

		// bottom right activity trend
		if(vm.sumChartTrend.data.length > 0) {
			$timeout(function() {
				var trend = vm.sumChartTrend;
				if(trend.data.length > 0) {
					trend.status = 'DRAW';
					$scope.$broadcast('widget.chart.sync', {
						uniqueId: trend.id,
						config: trend.config,
						data: trend.data,
						render: 'animate'
					});
				}
			},300);
		}

	}

	function errSubmit(r) {
		toggleWait();
		if (!!r && r.status == 422) {
			if (!!r.data && !!r.data.Entity && !!r.data.Entity.ROOT) {
				if(r.data.Entity.ROOT.length > 0) {
					msgSvc.ok('Cannot search', r.data.Entity.ROOT[0]);
				}
			}
		}
	}

	/**
	 * 	ROW CLICK
	 *  used for status click or main ndc item click
	 */

	function rowClick(evt, item) {
		// handle main list click event for links or toggle editing

		if(vm.isWaiting) {
			return;
		}

		// loop up to find td column parent
		var elem = evt.target;
		while (!!elem) {
			if(!!elem.className && elem.className.indexOf('cpv-status-col') > -1) {
				// usability - if the flyout is already open, assume this is a main item toggle
				if(!!vm.flyout && !!vm.flyout.show) {
					elem = null;
					editToggleMainItem(item);
				}
				else {
					// status click = show log
					openPopup(item, 'NDC-LOG');
				}
				break;
			}
			else if (!!elem.nodeName && elem.nodeName.toUpperCase() == 'TD') {
				// row click = toggle main edit
				elem = null;
				editToggleMainItem(item);
				break;
			}
			elem = elem.parentNode;
		}
		elem = null;
	}

	/**
	 * 	POPUP
	 * 	used for NDC LOG and TBLVIEW
	 */

	function openPopup(item, popType) {
		if (vm.isWaiting) {
			return;
		}

		switch(popType) {
			case 'NDC-LOG':
				popLog(item);
				break;
			case 'TBLVIEW':
				popTblView(vm.activeTab);
				break;
			default:
				throw new Error('priceList.openPopup, unknown pop type: ' + popType);
		}

		$timeout(function () {
			if(!!vm.popup) {
				vm.popup.ready = true;
			}
		}, 200);
	}

	function popLog(item) {
		vm.popup = {
			type: 'NDC-LOG',
			title: 'Change Log for ' + item.ItemCode,
			Items: item.ChangeLog,
			ready: false
		};

	}

	function popTblView(tabName) {
		vm.popup = {
			type: 'TBLVIEW',
			title: 'Table View Editor',
			ready: false
		};

		$scope.$broadcast('widget.tblview.editor', {
			uniqueId: tabName,
			config: vm.tblViewConfig
		});
	}

	function closePopup() {
		var popType = vm.popup.type;
		vm.popup = {};
		if (popType == 'TBLVIEW') {
			tblViewReload(vm.query, false, true); // re-init views, keep paging if possible
		}
	}


	/**
	 * 		TABLE VIEW
	 */

	function okCurrentTableView() {
		if (vm.action != 'LIST') {
			return;
		}

		var tvSaved = sessionRepo.get(vm.tblViewConfig.storageKey);
		if (!!tvSaved && !!vm.tblView && validSvc.isText(vm.tblView.current)) {
			tvSaved.current = vm.tblView.current;
			sessionRepo.set(vm.tblViewConfig.storageKey, tvSaved);
		}
	}

	function errCurrentTableView() {
		// do nothing
	}

	function tblViewReload(query, skipInitViews, fltKeepPaging) {

		if (!!!query) {
			return;
		}

		// init tblView with full view config
		if (!!!skipInitViews || !!!vm.tblView) {
			vm.tblView = vm.tblViewInit(vm.tblViewConfig, sessionRepo.get(vm.tblViewConfig.storageKey));
		}

		// reduce tblConfig based on query
		var tblConfig = tblViewConfigSetup(tblViewSchemaFlyoutVM());

		// add column titles and filters
		vm.tblView = vm.tblViewLoadTitlesAndFilters(tblConfig, vm.tblView, vm.flt);

		// update table view bar
		$scope.$broadcast('widget.tblview', {
			uniqueId: vm.activeTab,
			current: vm.tblView.current,
			views: vm.tblView.views
		});

		if (!!vm.flt) {
			// remove any filter properties not shown in current table view
			vm.flt = vm.tblViewSyncFilter(tblConfig, vm.tblView, vm.flt, fltKeepPaging);
			filterChange(true);
		}
	}

	function tblViewSchemaFlyoutVM() {
		var tblVM = {
			storageKey: 'tv-ops-price-list-flyout',
			name: 'LIST-FLYOUT',
			sortby: '-TotalVariance',
			pgsize: 50,
			sections: {
				Use: { title: 'Usage' },
				Aff: { title: 'Affiliation' },
				Drug: {title: 'Drug Info'},
				Ord: {title: 'Order'},
				Inv: {title: 'Invoice'},
				Price: { title: 'Price Variance' },
			}
		};

		var cols = [];
		cols = cols.concat([

			{ section: 'Use', flt: 'Text', edit: false, name: 'Status', colWidth: "35px", title: 'Status', desc: 'Status' },
			{ section: 'Use', flt: 'Text', edit: false, name: 'StatusReason', colWidth: "50px", title: 'Outcome', desc: 'Complete Outcome' },

			{ section: 'Aff', flt: 'Text', edit: false, name: 'CEID', colWidth: "45px", title: 'Facility', desc: 'Facility' },
			{ section: 'Aff', flt: 'Text', edit: false, name: 'RXID', colWidth: "45px", title: 'PHID', desc: 'Pharmacy Id' },
			{ section: 'Aff', flt: 'Text', default: false, name: 'RxShortName', colWidth: "45px", title: 'Name', desc: 'Pharmacy Name' },

			{ section: 'Drug', flt: 'Text', edit: false, name: 'Vendor', colWidth: "45px", title: 'Vendor', desc: 'Vendor' },
			{ section: 'Drug', flt: 'Text', name: 'ItemCode', colWidth: "50px", title: 'NDC', desc: 'National Drug Code' },
			{ section: 'Drug', flt: 'Text', name: 'VendItemNum', colWidth: "45px", title: 'Vendor Item Number', desc: 'Vendor number' },
			{ section: 'Drug', flt: 'Text', name: 'VendItemName', colWidth: "60px", title: 'Vendor Item Name', desc: 'Vendor drug description' },
			{ section: 'Drug', flt: 'Text', default: false, name: 'Manufacturer', colWidth: "45px", title: 'Manufacturer', desc: 'Manufacturer' },

			{ section: 'Ord', flt: 'Text', edit: false, name: 'Acct', colWidth: "45px", title: 'Account', desc: 'Account Type' },
			{ section: 'Ord', flt: 'Text', edit: false, name: 'OrdDate', colWidth: "45px", title: 'Date', desc: 'Order Date ' },
			{ section: 'Ord', flt: 'Text', edit: false, name: 'OrdNum', colWidth: "45px", title: 'Number', desc: 'Order PO' },

			{ section: 'Inv', flt: 'Text', edit: false, name: 'InvDate', colWidth: "45px", title: 'Date', desc: 'Invoice Date' },
			{ section: 'Inv', flt: 'Text', edit: false, name: 'InvNum', colWidth: "45px", title: 'Number', desc: 'Invoice Number' },

			{ section: 'Price', flt: 'Numbers', edit: false, name: 'TotalVariance', colWidth: "45px", title: 'Total $', desc: 'Total $ Variance' },
			{ section: 'Price', flt: 'Numbers', edit: false, name: 'PercentVariance', colWidth: "45px", title: 'Total %', desc: 'Total % Variance' },
		]);

		tblVM.cols = cols;

		return tblVM;
	}

	function tblViewConfigSetup(tblSchema) {
		// placeholder to convert generic view schema into user specific table configs

		var result = {},
			cols = tblSchema.cols,
			col = {},
			colKeys = {},
			colAllowed = [];

		for (var i = 0; i < cols.length; i++) {
			col = cols[i];

			// tbd... logic to drop columns based on user type, query, biz models, etc

			// keep column
			colAllowed.push(col.name);
			colKeys[col.name] = col;
		}

		// update columns for this table
		tblSchema.cols = colAllowed;
		tblSchema.colKeys = colKeys;

		return tblSchema;
	}


	/**
	 *  	FLYOUT EDITING
	 */

	function flyoutChangeStatus() {
		// status or status reason change
		if(vm.isWaiting) {
			return;
		}

		var m = vm.flyout.model;
		if(m.Status.val == 'COMPLETE') {
			m.StatusReason.fail = m.StatusReason.val == 'NONE' ? 'yes' : 'no';
		}
		else {
			m.StatusReason = validSvc.newProp('');
		}
	}

	function editToggle(type, item) {
		// toggle main or flyout item edit state
		if(vm.isWaiting) {
			return;
		}

		switch(type) {
			case 'MAIN':
				editToggleMainItem(item);
				break;
			case 'FLYOUT':
				if(vm.hasEditMode) {
					if(item.Status == 'COMPLETE') {
						msgSvc.ok('Cannot edit', 'Cannot change completed items');
						return;
					}
					vm.flyout.map = updateEditMap(vm.flyout.map, item);
				}
				break;
			default:
				throw new Error('priceListCtl.editToggle, unknown type: ' + type);
		}
	}

	function updateEditMap(map, item) {
		// adjust map of items selected

		var uniqueId = item.uniqueId, // key for the map
			Id = item.Id; // actual real Id value

		if(!!!vm.hasEditMode) {
			// view only user cannot multi-edit
			map = {};
			map[uniqueId] = Id;
		}
		else {
			map[uniqueId] = map[uniqueId] == Id ? undefined : Id;
		}

		console.log('map result is: ' + !!map[uniqueId]);
		return map;
	}


	/**
	 * 		SUMMARY
	 */

	function sumDashboardToggle(toggleType) {
		if(vm.isWaiting || vm.activeTab != 'SUMMARY' || !vm.summary) {
			return;
		}

		var act = vm.summary.Activity,
			topNdc = vm.summary.TopNdc,
			trend = vm.summary.Trend;

		switch(toggleType) {
			case 'ACT-COUNT':
				act.DataSource = 'COUNT';
				act.DataSourceTitle = 'Invoice Activity, Total';
				trend.DataSource = 'COUNT';
				trend.DataSourceTitle = 'Closed Invoice Count - ' + trend.Items.length + ' Week Trend';	
				// update charts
				vm.sumChartActivity = chartActivityVM(act);
				vm.sumChartClosed = chartClosedVM(act);
				vm.sumChartTrend = chartTrendVM(trend);
				renderSummaryCharts();		
				break;
			case 'ACT-AMOUNT':
				act.DataSource = 'AMOUNT';
				act.DataSourceTitle = 'Invoice Dollars, Total';
				trend.DataSource = 'AMOUNT';
				trend.DataSourceTitle = 'Closed Invoice Dollars - ' + trend.Items.length + ' Week Trend';
				// update charts
				vm.sumChartActivity = chartActivityVM(act);
				vm.sumChartClosed = chartClosedVM(act);
				vm.sumChartTrend = chartTrendVM(trend);
				renderSummaryCharts();		
				break;	
			case 'ACT-VIEW':
				act.View = act.View == 'DASH' ? 'TABLE' : 'DASH';
				act.Title = act.View == 'DASH' ? 'Show Data Table' : 'Close Data Table';
				break;
			case 'NDC-NEW':
				topNdc.DataSource = 'NEW';
				topNdc.TitleAmount = topNdc.NEW.Amount;
				break;
			case 'NDC-PENDING':
				topNdc.DataSource = 'PENDING';
				topNdc.TitleAmount = topNdc.PENDING.Amount;
				break;
			case 'NDC-CLOSED':
				topNdc.DataSource = 'CLOSED';
				topNdc.TitleAmount = topNdc.CLOSED.Amount;
				break;			
			default:
				throw new Error('priceListCtl.sumDashboardToggle, unknown dashboard type');
		}
	}

	/**
	 *  	SUMMARY CHART
	 */

	function resetCharts(resetUI) {
		// reset SVG?
		if(!!resetUI && vm.sumChartActivity.status == 'DRAW') {
			$scope.$broadcast('widget.chart.sync', {uniqueId: vm.sumChartActivity.id, render: ''});
		}
		vm.sumChartActivity = initChart();
		
		if(!!resetUI && vm.sumChartClosed.status == 'DRAW') {
			$scope.$broadcast('widget.chart.sync', {uniqueId: vm.sumChartClosed.id, render: ''});
		}
		vm.sumChartClosed = initChart();

		if(!!resetUI && vm.sumChartTrend.status == 'DRAW') {
			$scope.$broadcast('widget.chart.sync', {uniqueId: vm.sumChartTrend.id, render: ''});
		}
		vm.sumChartTrend = initChartTrend();
	}

	function initChart(id, title) {
		// minimum pie chart config
		// note: this is a slimmed down from full home page widgets
		return {
			id: id,
			status: '',
			config: {
				chartType: 'PIE',
				colors: [],
				valFormat: 'number',
				donutHoleRadius: 0.4,
				label: {
					width: 50,
					height: 30
				}
			},
			text: {
				title: title
			},
			data: [],
			legend: []
		};
	}

	function chartActivityVM(act) {
		// pie chart, parse data into pie chart format

		var chart = initChart('ACTIVITY', 'Activity'),
			chartColors = appConst.app.color.chart,
			data = [],
			legend = [],
			dataItems = Array.isArray(act.Items) ? act.Items : [],
			useCount = act.DataSource == 'COUNT';
		var chartTotal = useCount ? act.Total.Count : act.Total.Amount;

		// no data?
		if(dataItems.length < 1 || !numberOverZero(chartTotal)) {
			return chart;
		}
		
		var wedge = {};
		dataItems.forEach(function(item) {
			wedge = {
				name: item.Title,
				val: useCount ? item.Count : item.Amount,
				percent: useCount ? item.CountPercent : item.AmountPercent,
				color: chartColors[item.color]
			};

			// add to pie chart if >0%
			if(wedge.percent > 0) {
				data.push(wedge);
			}	
	
			// add to legend if >0 count
			if(wedge.val > 0) {
				legend.push(JSON.parse(JSON.stringify(wedge))); // de-ref
			}
		});

		// no data?
		if(data.length < 1) {
			return chart;
		}

		// sort and assign to chart
		chart.data = utilSvc.array.sortDSC(data, 'percent');
		chart.legend = utilSvc.array.sortDSC(legend, 'percent');
		
		// apply wedge colors to chart colors
		chart.config.colors = [];
		for(var c = 0; c < chart.data.length; c++) {
			chart.config.colors.push(chart.data[c].color);
		}

		return chart;
	}

	function nextIdx(len, idx) {
		idx++;
		return idx < len ? idx : 0;
	}

	function chartClosedVM(act) {
		// pie chart, parse data into pie chart format

		var chart = initChart('CLOSED', 'Closed'),
			chartColors = appConst.app.color.chartBars($window.espuiPrefs.skin),
			data = [],
			legend = [],
			dataItems = Array.isArray(act.ClosedStats) ? act.ClosedStats : [],
			useCount = act.DataSource == 'COUNT';
		var chartTotal = useCount ? act.Total.Count : act.Total.Amount;

		// no data?
		if(dataItems.length < 1 || !numberOverZero(chartTotal)) {
			return chart;
		}
		
		var wedge = {},
			wedgeOther = {
				name: 'Other',
				val: 0,
				percent: 0,
				color: ''
			},
			percent = 0,
			val = 0,
			percentTotal = 0,
			item = {},
			colorIdx = -1;

		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];

			val = useCount ? item.Count : item.Amount;
			percent = useCount ? item.CountPercent : item.AmountPercent;

			// use Other?
			if(percentTotal >= 95 || percent <= 1 || i > 7) {
				wedgeOther.percent += percent;
				wedgeOther.val += val;
			}
			else {
				percentTotal += percent;

				colorIdx = nextIdx(chartColors.length, colorIdx);

				wedge = {
					name: item.Reason,
					val: val,
					percent: percent,
					color: chartColors[colorIdx]
				};
	
				// add to pie chart if >0%
				if(wedge.percent > 0) {
					data.push(wedge);
				}

				// add to legend if >0 count
				if(wedge.val > 0) {
					if(wedge.percent < 1) {
						wedge.color = 'transparent';
					}
					legend.push(JSON.parse(JSON.stringify(wedge))); // de-ref
				}
			}
		}

		// add Other
		if(wedgeOther.percent > 0) {
			colorIdx = nextIdx(chartColors.length, colorIdx);
			wedgeOther.color = chartColors[colorIdx];
			data.push(wedgeOther);
			legend.push(JSON.parse(JSON.stringify(wedgeOther))); // de-ref
		}

		// no data?
		if(data.length < 1) {
			return chart;
		}

		// sort and assign to chart
		chart.data = utilSvc.array.sortDSC(data, 'percent');
		chart.legend = utilSvc.array.sortDSC(legend, 'percent');

		// apply wedge colors to chart colors
		chart.config.colors = [];
		for(var c = 0; c < chart.data.length; c++) {
			chart.config.colors.push(chart.data[c].color);
		}
		
		return chart;
	}

	function initChartTrend() {
		// minimum trend chart config
		// always three lines with same colors
		var chartColors = appConst.app.color.chart;

		return {
			id:'cpv-act-trend',
			render: '',
			config: {
				colors: [
					chartColors['primary'],
					chartColors['primaryDark'],
					chartColors['gray']
				],
				xAxis: {
					showText: true,
					labels:[]
				},
				yAxis: {
					showText: true,
					format: 'number',
					minVal: 0,
					maxVal: 0
				},
				useDots:true
			},
			legend:[
				{name:'NEW', color:'gray'},
				{name:'PENDING', color:'primaryDark'},
				{name:'CLOSED', color:'primary'}
			],
			data:[]
		};
	}

	function chartTrendVM(trend) {
		// pie chart, parse data into pie chart format

		var chart = initChartTrend(),
			dataItems = Array.isArray(trend.Items) ? trend.Items : [],
			useCount = trend.DataSource == 'COUNT';

		// no data?
		if(dataItems.length < 1) {
			return chart;
		}
		
		function getVal(prop) {
			return useCount ? prop.Count : prop.Amount;
		}

		var item = {},
			uniqueId = '',
			xLabels = [],
			monthNames = utilSvc.ng.monthShortDroplist(),
			dtSeg = [],
			mth = '',
			day = '',
			creditedSeries = [],
			notCreditSeries = [],
			otherSeries = [];

		// convert {Date, New, Pending, Closed} items into:
		// 1 line for new, 1 line for Pending, 1 line for Closed
		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			uniqueId = 'p' + i.toString();

			// build x axis label from "yyyy-mm-dd" api format
			dtSeg = item.Date.split('-');
			mth = parseInt(dtSeg[1]) - 1; // month list is zero based
			day = parseInt(dtSeg[2]);
			xLabels.push({
				id: uniqueId,
				tickTextTop: monthNames[mth].label,
				tickTextBtm: day.toString()
			});

			// build line series
			creditedSeries.push({name: uniqueId, val: getVal(item.Credited)});
			notCreditSeries.push({name: uniqueId, val: getVal(item.NotCredited)});
			otherSeries.push({name: uniqueId, val: getVal(item.Other)});
		}

		// no data?
		if(xLabels.length < 1) {
			return chart;
		}
		chart.config.xAxis.labels = xLabels;

		// assign three lines to data series
		chart.data = [
			{
				id:0,
				selected: false,
				series: creditedSeries
			},
			{
				id:1,
				selected: false,
				series: notCreditSeries
			},
			{
				id:2,
				selected: false,
				series: otherSeries
			},
		];

		// get Ymax of all values in any series
		var yMax = 0;
		chart.data.forEach(function(d){
			d.series.forEach(function(s){
				if(s.val > yMax) {
					yMax = s.val;
				}
			});
		});
		chart.config.yAxis.maxVal = yMax;
		
		return chart;
	}
	

	/**
	 * 		EXCEL
	 */

	function getIds(items) {
		items = Array.isArray(items) ? items : [];
		var ids = [];
		items.forEach(function(item) {
			ids.push(item.Id);
		});
		return ids;
	}

	function getExcel(isFlyoutItems) {
		if(vm.isWaiting || vm.action != 'LIST') {
			return;
		}
		// validate
		if(!queryValid(vm.query)) {
			if(!vm.init) {
				msgSvc.ok('Search', 'Check filter settings');
			}
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		// get Items or Edit Items from flyout
		_pendingExcelFilename = 'Verity-' + vm.CeMultiselect.title;
		var noData = false;
		if(!!isFlyoutItems) {
			_pendingExcelFilename += '-Contract-Price-Edit-Items';
			vm.query.LineItemIds = getIds(vm.flyout.Items);
			if(vm.query.LineItemIds.length < 1) {
				noData = true;
			}
		}	
		else {
			_pendingExcelFilename += '-Contract-Price-Validation-List';
			if(vm.tbl.DataItems.length < 1) {
				noData = true;
			}
		}

		// nothing to save
		if(noData) {
			msgSvc.ok('No Records', 'Nothing to save for Excel.');
			return;
		}
	
		toggleWait(true);
		priceRepo.getExcel(vm.activeTab, vm.query, _pendingExcelFilename).then(okServerExcel, errServerExcel);
	}

	function okServerExcel(binaryData) {
		toggleWait();

		// convert binary stream to blob and save
		try {
			var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
			$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
		}
		catch(err) {
			throw(err);
		}
	}

	function errServerExcel(r) {
		toggleWait();

		if(!!r) {
			errSvc.warn('Create Excel Error', 'matchListCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
		}
	}

	/**
	 *    MULTISELECT HELPERS
	 */

	function multiToggle(evt, id) {
		switch (id) {
			case 'priceListCeMulti':
				multiselectToggle(evt, vm.CeMultiselect, id);
				break;
			case 'priceListRxMulti':
				multiselectToggle(evt, vm.RxMultiselect, id);
				break;
			case 'priceListVendorMulti':
				multiselectToggle(evt, vm.VendorMultiselect, id);
				break;
			case 'priceListStatusMulti':
				multiselectToggle(evt, vm.StatusMultiselect, id);
				break;
			case 'priceListStatusReasonMulti':
				multiselectToggle(evt, vm.StatusReasonMulti, id);
				break;
			case 'priceListDrugTypeMulti':
				multiselectToggle(evt, vm.DrugTypeMultiselect, id);
				break;
			case 'priceListAccMulti':
				multiselectToggle(evt, vm.AccMultiselect, id);
				break;
			default:
				throw new Error('priceList.multiToggle, unknown multi id: ' + id);
		}
	}

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if (vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		multiselect.flt = '';

		// don't bother with width if hiding
		if (multiselect.show) {
			multiselect.show = false;
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while (!!elem) {

			// top element found
			if (!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if (minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if (!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;

	}

	function multiHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if (!!multiselect.show) {

			if (evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce, 500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for (var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if (multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if (mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if (!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if (debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}

	function multiselectQueryVals(multiselect) {

		// unpack the vals multiselect into a list of entities to query

		var checklist = multiselect.list,
			vals = multiselect.vals;

		if (vals.length < 1) {
			return [];
		}
		else if (vals.length === 1 && vals[0] == 'ALL') {
			// using ALL checkbox, return all values except ALL checkbox
			var result = [],
				i = checklist[0].val == 'ALL' ? 1 : 0;
			for (i; i < checklist.length; i++) {
				result.push(checklist[i].val);
			}
			return result;
		}
		else {
			return vals;
		}
	}

	/**
	 *  EDIT MAIN items (user clicks a main list item)
	 *  FLYOUT items (each invoice of the main item is added to the flyout items)
	 */

	function editVM() {
		return {
			selectAll:false,
			map:{},
			multi:false
		};
	}

	function flyoutVM(isOn) {
		return {
			show: !!isOn,
			map:{},
			model: {
				Status: validSvc.newProp(''),
				StatusReason: validSvc.newProp(''),
				Notes: ''
			},
			flt:{},
			SortBy:['ItemCode'],
			Items:[],
			allComplete: false,
		};
	}

	function editCancel() {
		vm.edit = editVM();
		vm.flyout = flyoutVM();
	}

	function editToggleAll() {
		// toggle all filtered items
		if(vm.isWaiting) {
			return;
		}

		// on to off
		if(!!vm.edit.selectAll) {
			editCancel();
			return;
		}

		// update edit map
		vm.edit = editVM();
		vm.edit.selectAll = true;
		vm.edit.map = buildEditMap(vm.tbl.Items);
		vm.edit.multi = vm.tbl.Items.length > 1;

		// update the flyout
		var editItems = getEditItems(vm.tbl.Items, vm.edit.map);
		vm.flyout = refreshFlyout(editItems);
	}

	function buildEditMap(items) {
		var map = {};
		if(!Array.isArray(items)){
			return {};
		}
		items.forEach(function(item){
			map[item.uniqueId] = item.Id;
		});
		return map;
	}

	function getEditIds(map) {
		// parse object map for array of editing Ids
		var items = [];
		for(var prop in map) {
			if(map.hasOwnProperty(prop) && !!map[prop]) {
				items.push(map[prop]); // add Id to list
			}
		}
		return items;
	}

	function flyoutItemVM(inv, isChecked) {
		// flyout item view model
		return {
			uniqueId: inv.uniqueId,
			Id: inv.Id,
			edit: inv.Status == 'COMPLETE' ? false : isChecked,
			Status: inv.Status,
			StatusReason: inv.StatusReason,
			ItemCode: inv.ItemCode,
			Acct: inv.AccumulatorGroup,
			OrdDate: inv.PoDt,
			OrdNum: inv.PoName,
			InvDate: inv.InvDt,
			InvNum: inv.InvNumber,
			TotalVariance: inv.TotalVariance,
			PercentVariance: inv.PercentVariance
		};
	}

	function getEditItems(mainItems, map) {
		// return full items if they match our map
		var result = [];
		if(!Array.isArray(mainItems) || !!!map) {
			return result;
		}

		mainItems.forEach(function(item){
			if(!!map[item.uniqueId]) {
				result.push(item);
			}
		});

		return result;
	}

	function filterChangeEditItems() {
		// resolve any filtering affects on the edit items

		// not in edit mode, nothing to do
		if(!vm.hasEditMode || vm.tbl.Items.length < 1) {
			editCancel();
			return;
		}

		// nothing selected
		var editIds = getEditIds(vm.edit.map);
		if(editIds.length < 1) {
			editCancel();
			return;
		}

		// count number of items still found in map
		var newMap = {},
			mapCount = 0,
			map = vm.edit.map;
		vm.tbl.Items.forEach(function(item) {
			if(map[item.uniqueId]) {
				newMap[item.uniqueId] = map[item.uniqueId];
				mapCount++;
			}
		});
		
		// all items still in map, no need to refresh flyout
		if(mapCount == editIds.length) {
			return;
		}

		// everything is gone
		if(mapCount < 1) {
			editCancel();
			return;
		}

		// use new map
		vm.edit.map = newMap;
		vm.edit.multi = mapCount > 1;

		// update the flyout
		var editItems = getEditItems(vm.tbl.Items, vm.edit.map);
		vm.flyout = refreshFlyout(editItems);
	}

	function editToggleMainItem(item) {
		// toggle main list item, show flyout and setup flyout model

		// refresh main list edit state
		vm.edit.map = updateEditMap(vm.edit.map, item);

		var editIds = getEditIds(vm.edit.map);
		vm.edit.selectAll = editIds.length < vm.tbl.Items.length;
		if(editIds.length < 1) {
			editCancel();
			return;
		}
		vm.edit.multi = editIds.length > 1;

		// update the flyout
		var editItems = getEditItems(vm.tbl.Items, vm.edit.map);
		vm.flyout = refreshFlyout(editItems);
	}

	function refreshFlyout(editItems) {
		// nothing to edit, close flyout
		if(editItems.length < 1) {
			return flyoutVM();
		}

		// remember previous flyout map
		var oldFlyoutMap = !!vm.flyout.map ? JSON.parse(JSON.stringify(vm.flyout.map)) : {}, // de-ref
			isChecked = false,
			allComplete = true,
			hasPending = false,
			combinedReason = '',
			invReason = '',
			reasonMatch = true;

		// tbd: do not reset the flyout back to empty VM() to keep the filters or sort?

		// reset flyout display (keep filters and sort)
		vm.flyout.show = true;
		vm.flyout.Items = [];
		vm.flyout.map = {};
		editItems.forEach(function(editItem) {
			// add each child invoice to flyout as separate item
			// note: this is a flat list of items, not grouped by parent
			editItem.Invoices.forEach(function(inv) {

				// derive checked state
				if(inv.Status == 'COMPLETE') {
					isChecked = false; // cannot edit completed items
				}
				else if(oldFlyoutMap.hasOwnProperty(inv.uniqueId) && !!!oldFlyoutMap[inv.uniqueId]) {
					isChecked = false; // user unchecked this item previously
				}
				else {
					isChecked = true; // default state
				}

				vm.flyout.Items.push(flyoutItemVM(inv, isChecked));
				vm.flyout.map[inv.uniqueId] = isChecked ? inv.Id : undefined; // add to map if checked

				switch(inv.Status) {
					case 'PENDING':
						allComplete = false;
						hasPending = true;
						break;
					case 'COMPLETE':
						if(allComplete) {
							// check if the StatusReason is the same for all COMPLETE items
							invReason = validSvc.isText(inv.StatusReason) ? inv.StatusReason : 'NEW';
							if(combinedReason == '') {
								combinedReason = invReason;
								reasonMatch = true;
							}
							else if(combinedReason != invReason) {
								reasonMatch = false;
							}
						}
						break;
					default:
						allComplete = false;
						break;
				}
			});
		});

		// adjust status / reason
		var combinedStatus = allComplete ? 'COMPLETE' : hasPending ? 'PENDING' : 'NEW';
		combinedReason = allComplete && reasonMatch ? combinedReason : 'NONE';
		vm.flyout.model.Status = validSvc.newProp(combinedStatus);
		vm.flyout.model.StatusReason = validSvc.newProp(combinedReason); // reset reason if all are not the same

		// do not show flyout editing if all items are complete
		vm.flyout.allComplete = allComplete;

		return vm.flyout;
	}

	function editSubmit() {
		if(vm.isWaiting) {
			return;
		}

		// model ok?
		if(vm.flyout.model.StatusReason.fail == 'yes') {
			msgSvc.ok('Cannot Save', 'Check properties');
			return;
		}

		// get flyout items edited
		var flyoutItems = getEditItems(vm.flyout.Items, vm.flyout.map);
		if(flyoutItems.length < 1) {
			msgSvc.ok('Cannot Save', 'No items selected for edit');
			return;
		}

		// derive changed items
		// either status or status reason have changed
		var m = vm.flyout.model;
		var changed = [],
			status = m.Status.val,
			statusReason = m.StatusReason.val,
			notes = validSvc.isText(m.Notes) ? m.Notes : '',
			isComplete = status == 'COMPLETE';

		flyoutItems.forEach(function(item) {
			if(item.Status != 'COMPLETE' && item.Status != status) {
				// this assumes you can move from:
				// NEW to PENDING
				// NEW to COMPLETE
				// PENDING back to NEW
				// PENDING to COMPLETE
				changed.push(item.Id);
			}
		});

		// no change
		if(changed.length < 1) {
			var chgTxt = 'All chosen items already have Status: ' + status + ' or cannot be changed back to: ' + status;
			if(isComplete) {
				chgTxt +=  ' with Outcome: ' + statusReason;
			}
			msgSvc.ok('No Changes', chgTxt);
			return;
		}

		// ok to update, save pending update
		_pendingUpdate = {
			changed: changed,
			status: status,
			statusReason: statusReason,
			notes: notes
		};

		// complete status needs confirmation
		if(isComplete) {
			msgSvc.confirm({
				id: 'cpv.confirm.update',
				title: 'Complete Status',
				msg: 'Confirm Complete status for ' + changed.length + ' items? This is not reversible.',
				buttons: [
					{text:'OK', result:'YES', cancel: false},
					{text:'CANCEL', result:'CANCEL', cancel: true}
				]
			}).then(confirmUpdate, confirmUpdate);
		}
		else {
			// no confirmation needed
			confirmUpdate({result:'YES'});
		}
	}

	function confirmUpdate(r) {
		if(!!r && r.result == 'YES') {
			toggleWait(true);
			priceRepo.updateStatus(_pendingUpdate.changed, _pendingUpdate.status, _pendingUpdate.statusReason, _pendingUpdate.notes).then(okUpdate, errUpdate);
			_pendingUpdate = {};
		}

		function okUpdate(r) {
			toggleWait();
			querySubmit();
		}

		function errUpdate(r) {
			toggleWait();
			if(!!r) {
				errSvc.warn('CPV Cannot Save', 'priceListCtl.editSubmit', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	//	HELPERS
	function toggleWait(isOn) {
		vm.isWaiting = !!isOn;
		msgSvc.wait(!!isOn);
	}

	function ndcCleanUp(val, skipEmpty) {

		var zeroPad = "00000000000",
			ndcTest = '';

		// must be text
		if (!!!skipEmpty && !validSvc.isText(val)) {
			return validSvc.newProp(val, true, 'required');
		}

		// remove all non-numeric characters
		ndcTest = val.toString().trim();
		ndcTest = ndcTest.replace(/[^0-9]+/g, '');

		// empty
		if (ndcTest.length < 1) {
			if (!!skipEmpty) {
				return validSvc.newProp('', false, '');
			}
			else {
				return validSvc.newProp(ndcTest, true, 'empty');
			}
		}

		// max len
		if (ndcTest.length > 11) {
			return validSvc.newProp(ndcTest, true, 'max 11 characters');
		}

		// integer
		var intVal = parseInt(ndcTest);
		if (!validSvc.isInteger(intVal)) {
			return validSvc.newProp(ndcTest, true, 'must be an integer');
		}

		// all zeros
		if (intVal <= 0) {
			return validSvc.newProp(ndcTest, true, 'cannot be zero');
		}

		// pad zeros if needed, pass
		ndcTest = zeroPad.substr(0, 11 - ndcTest.length) + ndcTest;
		return validSvc.newProp(ndcTest, false, '');
	}

	function queryTitle() {
		// helper to generate query title when flextop closed

		var title = '';

		// CE/RX titles to handle ALL value or NONE
		var ceTitle = vm.CeMultiselect.title;
		var rxTitle = vm.RxMultiselect.title;
		if (vm.CeMultiselect.vals.length > 1) {
			ceTitle = 'Facility: ' + ceTitle;
		}
		else if (vm.CeMultiselect.vals[0] == 'ALL') {
			ceTitle = 'All Facilities';
		}
		if (vm.RxMultiselect.vals.length > 1) {
			rxTitle = 'Pharmacy: ' + rxTitle;
		}
		else if (vm.RxMultiselect.vals[0] == 'ALL') {
			rxTitle = 'All Pharmacies';
		}

		return ceTitle + ' / ' + rxTitle;
	}

	function multiAllChecked(multi) {
		var checklist = multi.list;
		return checklist.length > 0 && checklist[0].val == 'ALL' && checklist[0].checked;
	}

	function multiOptionSaveViewStateVals(propName, q) {
		// property is optional, if not checked, don't use vals
		var prop = q[propName];
		if(!prop.chk) {
			return ['ALL'];
		}

		// get multiselect
		var multi = null;
		switch(propName) {
			case 'Status':
				multi = vm.StatusMultiselect;
				break;
			case 'StatusReason':
				multi = vm.StatusReasonMulti;
				break;
			case 'DrugType':
				multi = vm.DrugTypeMultiselect;
				break;
			default:
				throw new Error('priceListCtl.multiOptionSaveViewStateVals, cannot find multiselect for: ' + propName);
		}

		// is already ALL
		if(multiAllChecked(multi)) {
			return ['ALL'];
		}

		// use vals
		return prop.vals;
	}

	function saveViewState(tab, query, flt) {
		if (tab == '' || !!!query || !!!flt) {
			return;
		}

		// required multi vals
		query.RX.vals = multiAllChecked(vm.RxMultiselect) ? ['ALL'] : query.RX.vals;
		query.Vendor.vals = multiAllChecked(vm.VendorMultiselect) ? ['ALL'] : query.Vendor.vals;
		query.Account.vals = multiAllChecked(vm.AccMultiselect) ? ['ALL'] : query.Account.vals;

		// search options
		query.Status.vals = multiOptionSaveViewStateVals('Status', query);
		query.StatusReason.vals = multiOptionSaveViewStateVals('StatusReason', query);
		query.DrugType.vals = multiOptionSaveViewStateVals('DrugType', query);
		query.InvNumber.val = query.InvNumber.chk && validSvc.isText(query.InvNumber.val) ? query.InvNumber.val : '';

		sessionRepo.set('vs-ops-price-list', {
			activeTab: tab,
			flt: flt,
			query: query
		});
	}

}
 
referralRepo.$inject = ['$q', '$rootScope', 'apiService', 'errSvc', 'utilSvc', 'validSvc'];
angular
    .module('espui.ops')
    .factory('referralRepo', referralRepo);


/* @ngInject */
function referralRepo($q, $rootScope, apiService, errSvc, utilSvc, validSvc) {

	var _currentPurl = '',
		_modelPending = {};

    // service definition
    var service = {
        getList: getList,
		getDetail: getDetail,
		getDetailDocs: getDetailDocs,
		findProvider: findProvider,
		sendFax: sendFax,

		updateStatus: updateStatus,
		visitAddRemove: visitAddRemove,
		docLink: docLink,
		docSaveDetail: docSaveDetail,

		getExcel: getExcel,
		getPDF: getPDF
    };

    return service;


    /**
	 *    VIEW MODEL
	 */

	function referralVM(r) {
		r = r || {};
		var match = r.Match || {};
		
		// visit suspect picked
		var suspects = Array.isArray(match.SuspectVisits) ? match.SuspectVisits : [],
			suspectFound = false,
			item;
		if(validSvc.isText(r.SuspectPicked)) {
			// find in suspects
			for(var i = 0; i < suspects.length; i++) {
				if(r.SuspectPicked == suspects[i].SuspectId) {
					suspectFound = true;
					break;
				}
			}
		}
		match.SuspectVisits = suspects;
		for(var ii = 0; ii < match.SuspectVisits.length; ii++) {
			item = match.SuspectVisits[ii];
			item.uniqueId = ii;
			// fix provider dupes and build search text
			var fixP = fixProviders(item.PrescriberNPI, item.PrescriberName);
			item.Prescribers = fixP.Providers;
			item.PrescriberTxt = fixP.SearchTxt;
		}

		// referral suspect picked
		var feedSuspects = Array.isArray(r.ReferralFeeds) ? r.ReferralFeeds : [],
			feedFound = false;
		if(validSvc.isText(r.FeedPicked)) {
			// find in feed suspects
			for(var f = 0; f < feedSuspects.length; f++) {
				if(r.FeedPicked == feedSuspects[f].Id) {
					feedFound = true;
					break;
				}
			}
		}
		
		return {
			referral: {
				Status: validSvc.isText(r.ReferralStatus) ? r.ReferralStatus : 'NEW',
				SuspectPicked: !!suspectFound ? r.SuspectPicked : '',
				FeedPicked: !!feedFound ? r.FeedPicked : '',
				Faxable: r.Faxable,
				Countdown: r.Countdown,
				HasOwnUseMatch: r.HasOwnUseMatch
			},
			match: match,
			feedSuspects: feedSuspects,
			linkedDocs: Array.isArray(r.LinkedDocs) ? r.LinkedDocs : [],
			canEdit: r.CanEdit,
		};
	}

	function fixProviders(npis, names) {

		var noDupes = [],
			result = {
				Providers: [],
				SearchTxt: ''
			};

		npis = Array.isArray(npis) ? npis : [];
		names = Array.isArray(names) ? names : [];

		// should be same length
		if(npis.length != names.length) {
			return result;
		}

		var npi = '';
		for(var i = 0; i < npis.length; i++) {
			npi = npis[i].toString();
			if(noDupes.indexOf(npi) < 0) {
				noDupes.push(npi);
				result.Providers.push({
					NPI: npi,
					Name: names[i]
				});
				result.SearchTxt += '|' + npi + '|' + names[i];
			}
		}

		return result;
	}


    /**
     *   LIST
     */

     function parseQueryParams(tabName, q) {
		var params = {};
		if(q.DateRangeChk) {
			var dtType = '';
			switch(q.DateType) {
				case 'SERVICE':
					dtType = 'ServiceDate';
					break;
				case 'MATCH':
					dtType = 'MatchedDate';
					break;
				case 'RXWRITTEN':
					dtType = 'RxWrittenDate';
					break;
				case 'RECEIVED':
					dtType = 'ReceivedDate';
					break;
				default:
					throw new Error('matchRepo.parseQueryParams, DateType unknown: ' + q.DateType);
			}
			params.DateType = dtType;
			params.StartDate = q.StartDate.val;
			params.EndDate = q.EndDate.val;
		}

		if(tabName == 'REF' || tabName == 'SUMMARY') {
			params.Status = q.Status.vals;
		}
		if(tabName == 'DOC' && q.Activity.chk) {
			params.Activity = q.Activity.vals;
		}
		if(q.ItemCode.chk) {
			params.ItemCode = q.ItemCode.val;
		}
		if(q.Fax.chk) {
			params.FaxNumber = q.Fax.val.replace(/[^0-9]/g, ''); // convert to digits for api
		}
		if(q.PrescriberIdent.chk) {
			params.PrescriberIdent = q.PrescriberIdent.val;
		}
		if(q.PatientLN.chk) {
			params.PatientLN = q.PatientLN.val.toUpperCase();
		}
		if(q.PatientDOB.chk) {
			params.DateOfBirth = utilSvc.dt.toServerString(q.PatientDOB.val);
		}
		if(q.Eligible.chk) {
			params.Eligible = q.Eligible.val;
		}
    	if(q.Actionable.chk) {
			params.Actionable = true;
		}
		if(q.DrugType.chk) {
			params.DrugType = q.DrugType.val == 'BRAND' ? 'B' : 'G';
		}
		if(q.Orderable.chk) {
			params.Orderable = true;
		}
		if(q.MinimumSavings.chk) {
			params.MinimumSavings = parseFloat(q.MinimumSavings.val);
		}
		return params;
	}

	function getList(tabName, query) {

		// params
		if(!validSvc.isText(tabName) || !!!query) {
			throw new Error('refRepo.getList, tab and query required');
		}

		switch(tabName) {
			case 'SUMMARY':
				_currentPurl = 'ops/referrals/summary';
				break;
			case 'REF':
				_currentPurl = 'ops/referrals/list';
				break;
			case 'DOC':
				_currentPurl = 'ops/referrals/doc/list';
				break;
			default:
				throw new Error('refRepo.getList, unknown tab name: ' + tabName);
		}
		
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: query.CE.vals,
				RXID: query.RX.vals,
			},
			Params: parseQueryParams(tabName, query),
			Paging: {
				Page: 1,
				Size: 20000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('tbd')]
		};

		apiService.post(_currentPurl, apiRequest).then(okGetList, errGetList);

		function okGetList(r) {

			// bad "Get List" response format
			if(tabName != "SUMMARY" && !validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}
			
			defer.resolve({
				Items: r.data.Entity,
				TooMany: r.data.Entity.length > 20000
			});
		}

		function errGetList(r) {
			defer.reject(r);
		}
		
		return defer.promise;
	}

	function findProvider(ceList, rxList, npi, lastName) {
		// params
		if(!Array.isArray(ceList) || !Array.isArray(rxList) || (!validSvc.isText(npi) && !validSvc.isText(lastName))) {
			throw new Error('refRepo.findProvider, ce/rx lists and one of npi/last name required');
		}

		_currentPurl = 'ops/referrals/prescriber/find';
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: ceList,
				RXID: rxList,
			},
			Params: {
				Npi: npi,
				LastName: lastName
			},
			Paging: {
				Page: 1,
				Size: 2000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('tbd')]
		};

		apiService.post(_currentPurl, apiRequest).then(okProv, errGetList);

		function okProv(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}
			
			var items = Array.isArray(r.data.Entity) ? r.data.Entity : [];
			defer.resolve(items);
		}

		function errGetList(r) {
			defer.reject(r);
		}
		
		return defer.promise;
	}


	/**
	 *    GET REFERRAL DETAIL
	 */

	function getDetail(ctx) {

		// params
		if(!validContext(ctx)) {
			throw new Error('referralRepo.getDetail, id required');
		}

		_currentPurl = 'ops/referrals/detail';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {
				CEID: [ctx.CE],
				RXID: [ctx.RX]
			},
			Params: {
				DispId: ctx.DispId
			}
		};

		// call api
		apiService.post(_currentPurl, apiReqest).then(okDetail, errDetail);


		function okDetail(r) {

			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.error('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				return;
			}

			defer.resolve(referralVM(r.data.Entity));
		}

		function errDetail(r) {
			var result = null;
			if(is409(r)) {
				r.msg = r.data.error;
				result = r;
			}
			else if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + ' repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(result);
		}

		function is409(r) {
			return !!r && r.status == 409 && !!r.data && validSvc.isText(r.data.error);
		}

		return defer.promise;
	}

	function getDetailDocs(action, ctx) {

		// params
		if(!!!ctx) {
			throw new Error('refRepo.getDetailDocs, context required');
		}

		switch(action) {
			case 'FIND':
				_currentPurl = 'ops/referrals/detail/doc/find';
				break;
			case 'LINKED':
				_currentPurl = 'ops/referrals/detail/doc/list';
				break;
			default:
				throw new Error('referralRepo.getDetailDocs, unknown action: ' + action);
		}
		
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [ctx.CE],
				RXID: [ctx.RX],
			},
			Params: {
				DispId: ctx.DispId
			},
			Paging: {
				Page: 1,
				Size: 20000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('tbd')]
		};

		apiService.post(_currentPurl, apiRequest).then(okDetailDocs, errDetailDocs);

		function okDetailDocs(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}
			
			defer.resolve(r.data.Entity);
		}

		function errDetailDocs(r) {
			defer.reject(r);
		}
		
		return defer.promise;
	}


	/**
	 * 	VISIT ADD / REMOVE
	 */

	function visitAddRemove(action, ctx, visitId, notes) {

		// params
		if(!validContext(ctx) || !validSvc.isText(visitId)) {
			throw new Error('referralRepo.visitAccept, ce, rx, disp id, visit id required');
		}

		switch(action) {
			case 'ADD':
				_currentPurl = 'ops/referrals/detail/visitadd';
				break;
			case 'REMOVE':
				_currentPurl = 'ops/referrals/detail/visitremove';
				break;
			case 'FEED-ADD':
				_currentPurl = 'ops/referrals/detail/feedadd';
				break;
			case 'FEED-REMOVE':
				_currentPurl = 'ops/referrals/detail/feedremove';
				break;	
			default:
				throw new Error('referralRepo.visitAddRemove, unknown action: ' + action);
		}
		
		var defer = $q.defer();
		var apiReqest = {
			Context: {
				CEID: [ctx.CE],
				RXID: [ctx.RX]
			},
			Params: {
				DispId: ctx.DispId,
				VisitId: visitId,
				Notes: notes
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okVisit, errVisit);

		function okVisit(r) {
			defer.resolve({});
		}

		function errVisit(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 * 		REFERRAL STATUS
	 */

	function updateStatus(ctx, newStatus, notes) {

		// params
		if(!validContext(ctx) || !validSvc.isText(newStatus)) {
			throw new Error('referralRepo.updateStatus, ceid, rxid, disp id, status required');
		}

		_currentPurl = 'ops/referrals/detail/status';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ctx.CE],
				RXID: [ctx.RX]
			},
			Params: {
				DispId: ctx.DispId,
				Status: newStatus,
				Notes: notes
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okRefStatus, errRefStatus);

		function okRefStatus(r) {

			// entity returned (ignoring async JobId for now)
			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errRefStatus(r) {
			var result = null;
			if(is409(r)) {
				r.msg = r.data.error;
				result = r;
			}
			else if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + ' repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(result);
		}
		
		function is409(r) {
			return !!r && r.status == 409 && !!r.data && validSvc.isText(r.data.error);
		}

		return defer.promise;
	}


	/**
	 * 	DOC LINK / UNLINK
	 */

	function docLink(action, ctx, docId) {

		// params
		if(!validContext(ctx) || !validSvc.isText(docId)) {
			throw new Error('referralRepo.docLink, ce, rx, disp id, doc id required');
		}

		switch(action) {
			case 'LINK':
				_currentPurl = 'ops/referrals/detail/doc/link';
				break;
			case 'UNLINK':
				_currentPurl = 'ops/referrals/detail/doc/unlink';
				break;
			default:
				throw new Error('referralRepo.docLink, unknown action: ' + action);
		}
		
		var defer = $q.defer();
		var apiReqest = {
			Context: {
				CEID: [ctx.CE],
				RXID: [ctx.RX]
			},
			Params: {
				DispId: ctx.DispId,
				DocId: docId
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okLink, errLink);

		function okLink(r) {
			defer.resolve({});
		}

		function errLink(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 * 		DOC SAVE DETAIL
	 */

	function docSaveDetail(model, notes) {

		// params
		if(!!!model || !validSvc.isText(model.id)) {
			throw new Error('referralRepo.docSaveDetail, model and doc id required');
		}
		
		_currentPurl = 'ops/referrals/doc/edit';
		_modelPending = model;

		var defer = $q.defer();
		var apiRequest = {
			Params: {
				DocId: model.id,
				ReferredNPI: model.ReferredNPI.val,
				CE: model.CE.val,
				PatientFN: model.PatientFN.val,
				PatientLN: model.PatientLN.val,
				DateOfBirth: validSvc.isDate(model.PatientDOB.val) ? utilSvc.dt.toServerString(model.PatientDOB.val) : '',
				Notes: notes
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okSaveDoc, errSaveDoc);

		function okSaveDoc(r) {
			defer.resolve({});
		}

		function errSaveDoc(r) {
			if(!!r && r.status == 422) {
				r.model = mapApiErrorsToModel(r, _modelPending);
			}
			defer.reject(r);
		}

		function mapApiErrorsToModel(r, m) {
			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {
				fieldName = entity.Fields[i].Name;

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);
				if(fieldObj === undefined) {
					throw new Error('referralRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
				}

				// set failed state
				fieldObj.fail = 'yes';
				fieldObj.msg = entity.Fields[i].Rule;
			}
			return m;
		}

		return defer.promise;
	}
	

	/**
	 *    GET EXCEL
	 *    file created on api server, expecting a binary file stream instead of JSON
	 */

	function getExcel(tabName, query, filename) {

		// params
		if(!!!query || !validSvc.isText(filename)) {
			throw new Error('referralRepo.getExcel, query and filename required');
		}

		// tbd.. switch for excel types
		switch(tabName) {
			case 'REF':
				_currentPurl = 'ops/referrals/list/excel';
				break;
			default:
				throw new Error('referralRepo.getExcel, unknown list name: ' + listName);
		}

		var defer = $q.defer();
		var apiRequest = {
			Context: {
				CEID: query.CE.vals,
				RXID: query.RX.vals,
			},
			Params: parseQueryParams(tabName, query)
		};
		apiRequest.Params.Filename = filename;


		apiService.postGetBinary(_currentPurl, apiRequest).then(okGetExcel, errGetExcel);

		function okGetExcel(r) {
			defer.resolve(r.data);
		}

		function errGetExcel(r) {
			if(r !== null) {
				r = r || {};
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 *    GET PDF
	 *    expecting a binary file stream
	 */

	function getPDF(id) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('referralRepo.getPDF, id required');
		}

		_currentPurl = 'ops/referrals/doc/pdf';
		var defer = $q.defer();

		var apiRequest = {
			Params: {
				Id: id
			}
		};

		apiService.postGetBinary(_currentPurl, apiRequest).then(okPDF, errPDF);

		function okPDF(r) {
			defer.resolve(r.data);
		}

		function errPDF(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	/**
	 *    SEND MANUAL FAX
	 */

	function sendFax(ctx) {

		// params
		if(!validContext(ctx)) {
			throw new Error('referralRepo.sendFax, id required');
		}

		_currentPurl = 'ops/referrals/manual/fax';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {
				CEID: [ctx.CE],
				RXID: [ctx.RX]
			},
			Params: {
				DispId: ctx.DispId
			}
		};

		// call api
		apiService.post(_currentPurl, apiReqest).then(okSend, errSend);


		function okSend(r) {

			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.error('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				return;
			}

			defer.resolve();
		}

		function errSend(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + ' repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}
	
	/**
	 * 	HELPERS
	 */

	function validContext(ctx) {
		return !!ctx && validSvc.isCE(ctx.CE) && validSvc.isRX(ctx.RX) && validSvc.isText(ctx.DispId);
	}
}
 
referralDetailCtl.$inject = ['$scope', '$state', '$timeout', '$filter', 'referralRepo', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc'];
angular
.module('espui.ops')
.controller('ReferralDetailCtl', referralDetailCtl);


/* @ngInject */
function referralDetailCtl($scope, $state, $timeout, $filter, referralRepo, validSvc, errSvc, utilSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this,
		_pendingEdit = {},
		_docViewListener = null;

	// inherit sorting and paging features
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);

	// properties
	vm.isWaiting = false;
	vm.action = '';

	// models
	vm.context = {};
	vm.referral = {};
	vm.match = {};
	vm.feed = {};

	// next/back buttons
	vm.btnFWD = false;
	vm.btnBack = false;
	vm.goNext = goNext;

	// add / remove
	vm.visitAdd = visitAdd;
	vm.visitRemove = visitRemove;
	vm.feedAdd = feedAdd;
	vm.feedRemove = feedRemove;

	// eligible droplist reference
	vm.EligibleDroplist = [];

	// popup tbd...
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;

	// referral status
	vm.referStatus = referStatus;

	// tabs
	vm.activeTab = '';
	vm.tabChange = tabChange;

	// fax
	vm.sendFax = sendFax;

	/**
	 * 		EVENTS
	 */

	_docViewListener = $scope.$on('ops.referral.tab.refresh', function(event, evtData) {
		event.stopPropagation();

		// params
		evtData = evtData || {};

		var id = evtData.uniqueId,
			tab = evtData.tab;
		
		// event source
		if(!validSvc.isText(id) || (id != 'CLAIM' && id != 'DOC')) {
			throw new Error('ops.referral.docs, id source unknown: ' + id);
		}

		// ignore if this isn't for claim
		if(id != 'CLAIM') {
			return;
		}
		
		// tab
		if(!validSvc.isText(tab) || (tab != 'LINKED' && tab != 'FIND')) {
			throw new Error('ops.referral.docs, tab name unknown: ' + tab);
		}

		tabChange(tab);
	});

	$scope.$on('$destroy', function() {
		if(!!_docViewListener) {
			_docViewListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {
		vm.context = initContext($state.params, $scope.User);
		initDroplists();
		tabChange('SUSPECT');
	}

	function initContext(params, usr) {
		var ctx = params || {};

		if(!!!ctx || !Array.isArray(ctx.Items) || ctx.Items.length < 1 || !validSvc.isInteger(ctx.Idx) || ctx.Idx < 0 || ctx.Idx > ctx.Items.length - 1) {
			throw new Error('referralDetail, Referral Items and current index required');
		}

		var isVerity = usr.Type == 'VERITY' || usr.Type == 'VERITYSA',
			hasPHI = utilSvc.user.hasFeature($scope, 'ops.referral.phi'),
			hasEdit = utilSvc.user.hasFeature($scope, 'ops.referral.edit');
				
		vm.context = {
			isVerity: isVerity,
			canFindDocs: isVerity && hasPHI,
			hasPHI: hasPHI,
			hasEdit: hasEdit,
			CE: '',
			RX: '',
			DispId: '',
			Items: JSON.parse(JSON.stringify(ctx.Items)),
			Idx: ctx.Idx,
			IdxTitle: ''
		};

		return setContext(ctx.Idx);
	}

	function setContext(idx) {
		var ctx = vm.context,
			items = vm.context.Items;

		if(!validSvc.isInteger(idx) || idx < 0 || idx > items.length - 1) {
			throw new Error('referralDetail.setContext, idx is not valid: ' + idx);
		}
		ctx.Idx = idx;
		ctx.IdxTitle = 'Claim ' + (idx + 1).toString() + ' of ' + items.length.toString();

		var item = items[idx];
		ctx.CE = item.CEID;
		ctx.RX = item.RXID;
		ctx.DispId = item.DispId;
		ctx.RxShortName = utilSvc.aff.rxShortNameById($scope.User.AffList, ctx.RX);

		// fwd/back buttons
		vm.btnFWD = idx + 1 < items.length;
		vm.btnBack = idx > 0;

		return ctx;
	}
	
	function initDroplists() {
		// reference list for user friendly names
		vm.EligibleDroplist = [
			{label: 'All Reasons', value: 'INELIGIBLE'},
			{label: 'CONTRACT DATE', value:'INELIGIBLE-REASON_CONTRACT_DATE'},
			{label: 'ERX NPI', value:'INELIGIBLE-EPRESCRIBE_NPI'},
			{label: 'EXCLUDED PAYOR NDC', value:'INELIGIBLE-EXCLUDED_PAYOR_NDC'},
			{label: 'GOV MEDICAID', value:'INELIGIBLE-GOV_MEDICAID'},
			{label: 'INVALID MATCH', value:'UNMATCHED-INVALID_MATCH'},
			{label: 'IN REVIEW', value:'INELIGIBLE-INREVIEW'},
			{label: 'LOCATION', value:'INELIGIBLE-PATIENT_LOCATION'},
			{label: 'MCO MEDICAID', value:'INELIGIBLE-EXCLUDED_PAYOR'},
			{label: 'NPI BLOCKED', value:'INELIGIBLE-NPI_REVIEW_BLOCK'},
			{label: 'NPI FLOATING', value:'INELIGIBLE-NPI_REVIEW_FLOAT'},
			{label: 'NPI PROXIMITY', value:'INELIGIBLE-NPI_PROXIMITY'},
			{label: 'NPI REFERRAL', value:'INELIGIBLE-NPI_REVIEW_REFERRAL'},
			{label: 'OPA DATE', value:'INELIGIBLE-CE_OPA_STARTDATE'},
			{label: 'REMATCHED', value:'UNMATCHED-WEAKMATCH'},
			{label: 'REVERSED', value:'REVERSED'},
			{label: 'TPA REJECTED', value:'INELIGIBLE-TPA_REJECTED'},
			{label: 'UNMATCHED', value:'UNMATCHED'},
			{label: 'VISIT PROXIMITY', value:'INELIGIBLE-VISIT_PROXIMITY'},
			{label: 'VISIT REVERSED', value:'UNMATCHED-INVALID_VISIT'},
			{label: 'MFR RESTRICT', value:'INELIGIBLE-MFR_RESTRICT'},
			{label: 'MFR AGED', value:'INELIGIBLE-MFR_AGED'},
			{label: 'NPI PERIOD', value:'UNMATCHED-NPIPERIOD'},
			{label: 'NPI INACTIVE', value:'UNMATCHED-NPIINACTIVE'},
		];
	}


	/**
	 *    VIEW MODELS
	 */

	function matchVM(data) {

		data = data || {};

		data.EligibleTxt = data.Eligible == 'YES' ? 'YES' : 'NO';
		data.ActionableTxt = data.Actionable == 'YES' ? 'YES' : 'NO';
		data.OverrideTxt = !!data.EligOverride ? 'YES' : 'NO';

		// state reason txt
		data.StateReasons = Array.isArray(data.StateReasons) ? data.StateReasons : [];
		if(data.StateReasons.length === 1) {
			data.ReasonTxt = userFriendlyReasonText(data.State, data.StateReasons[0]);
		}
		else if(data.StateReasons.length > 1) {
			data.ReasonTxt = 'MULTIPLE';
		}
		else {
			data.ReasonTxt = '';
		}

		data.PatientDOB = utilSvc.dt.fromServerString(data.PatientDOB);
		data.ReferralStatus = validSvc.isText(data.ReferralStatus) ? data.ReferralStatus : 'NEW';

		// suspects list
		var items = Array.isArray(data.SuspectVisits) ? data.SuspectVisits : [],
			item = {};

		for(var i = 0; i < items.length; i++) {
			item = items[i];
			item.EligibleTxt = item.Eligible == 'YES' ? 'YES' : 'NO';
			item.ActionableTxt = item.Actionable == 'YES' ? 'YES' : 'NO';

			// user friendly State Reason
			item.StateReasons = Array.isArray(item.StateReasons) ? item.StateReasons : [];
			for(var ii = 0; ii < item.StateReasons.length; ii++) {
				item.StateReasons[ii] = userFriendlyReasonText(item.State, item.StateReasons[ii]);
			}
			item.ReasonTxt = item.StateReasons.join(', ');

			// GPI NDC list
			item.GPI = validSvc.isText(item.GPI) ? item.GPI : '';
			item.ReferenceItems = Array.isArray(item.ReferenceItems) ? item.ReferenceItems : [];

			item.Erx = !!item.Eprescribe ? 'YES' : 'NO';
			item.OverrideTxt = !!item.EligOverride ? 'YES' : 'NO';
		}
		data.SuspectVisits = items;

		data.Paging = {
			Page: 1,
			Size: $scope.tblPagingSize,
			Total: vm.getTotalPages(items.length, $scope.tblPagingSize)
		};

		data.SortBy = ['-EncounterDate'];

		return data;
	}

	function feedVM(suspects) {

		// feed re-uses properties from vm.match, only need the feed array parsed

		var items = Array.isArray(suspects) ? suspects : [],
			item = {};

		for(var i = 0; i < items.length; i++) {
			item = items[i];
			//Id: 			 
			//Diagnosis: "1002131113"
			//MRN:  "40098034"
			//PatientDOB: 
			//PatientFN: "Princess"
			//PatientLN: "Leia"
			//ReferralId: "5432154321"
			//ReferredNPI: "9876543210"
			//ReferredNPIName: 	""
			//ReferringLocation: "EARTH"
			//ReferringNPIName: "Dr Smarty"
			//Specialty: "RADIOLOGY"		
		}

		return {
			Items: items,
			Paging: {
				Page: 1,
				Size: $scope.tblPagingSize,
				Total: vm.getTotalPages(items.length, $scope.tblPagingSize)
			},
			SortBy: ['-ReferralDate']
		};
	}


	/**
	 *    GET DETAIL
	 */

	function getDetail() {
		if(vm.isWaiting) {
			return;
		}
		vm.action = '';
		toggleWait(true);

		// clear arrays
		vm.match.SuspectVisits = [];
		vm.feed.Items = [];

		referralRepo.getDetail(vm.context).then(okDetail, errDetail);

		function okDetail(r) {
			toggleWait();
			vm.referral = r.referral;
			vm.match = matchVM(r.match);
			vm.feed = feedVM(r.feedSuspects);
			if (vm.context.isVerity) {
				vm.context.hasEdit = vm.context.hasEdit && r.canEdit;
			}
			vm.action = 'LIST';
		}

		function errDetail(r) {
			toggleWait();
			if(!!r) {
				if(r.status == 409 && validSvc.isText(r.msg)) {
					msgSvc.ok('Claim Cannot Be Modified', r.msg);
				}
				else {
					errSvc.warn('Claim Get Error for: ' + vm.context.CE, 'referralDetailCtl.getDetail', r.status, utilSvc.http.safeResponse(r));
				}
			}
			$state.go('ops.referral', {}, {reload: 'ops.referral'});
		}

	}

	/**
	 *    DOCUMENTS
	 */

	function getDocs() {
		if(vm.isWaiting) {
			return;
		}
		vm.action = '';
		toggleWait(true);

		switch(vm.activeTab) {
			case 'FIND':
				referralRepo.getDetailDocs(vm.activeTab, vm.context).then(okGetDocs, errGetDocs);
				break;
			case 'LINKED':
				// linked docs are part of detail (call this again to get latest docs)
				referralRepo.getDetail(vm.context).then(okGetDocs, errGetDocs);
				break;
			default:
				throw new Error('referralDetail.getDocs, unknown tab name: ' + vm.activeTab);
		}

		function okGetDocs(r) {
			toggleWait();
			vm.action = 'LIST';
			$state.go('ops.referral.detail.docs', {
				Type: vm.activeTab,
				CE: vm.context.CE,
				RX: vm.context.RX,
				DispId: vm.context.DispId,
				Docs: vm.activeTab == 'FIND' ? r : r.linkedDocs
			}, {reload: 'ops.referral.detail.docs'});
		}

		function errGetDocs(r) {
			toggleWait();
			if(!!r) {
				errSvc.warn('Find Documents Tab Not available', 'referralDetailCtl.errFindDocs', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}


	/**
	 * 	  REFERRAL CHANGE TAB
	 */

	function tabChange(newTab) {
		if(vm.isWaiting) {
			return;
		}
		vm.action = '';
		vm.activeTab = newTab;
		switch(newTab) {
			case 'SUSPECT':
			case 'FEED':
				getDetail();
				break;
			case 'FIND':
			case 'LINKED':
				getDocs();
				break;
			default:
				throw new Error('referralDetail.tabChange, unknown tab: ' + newTab);
		}
	}

	/**
	 *    MATCH: BACK / FWD
	 */

	function goNext(increment) {

		if(vm.isWaiting) {
			return;
		}
		//vm.popup = {};

		// avoid index errors
		var idx = vm.context.Idx + increment;
		if(idx < 0) {
			idx = 0;
		}
		else if(idx > vm.context.Items.length - 1) {
			idx = vm.context.Items.length - 1;
		}

		vm.context = setContext(idx);
		tabChange('SUSPECT');
	}


	/**
	 *    MATCH: ADD / REMOVE VISIT
	 */

	function visitAdd(item) {
		if(vm.isWaiting) {
			return;
		}

		if(!!!item || !validSvc.isText(item.SuspectId)) {
			throw new Error('referralDetailCtl.visitAdd, SuspectId required');
		}

		// override and accept
		if(item.OverrideTxt == 'YES') {
			_pendingEdit = {
				action: 'accept-override',
				visitId: item.SuspectId,
				ReplaceVisitId: '',
				Override: false,
				title: 'Confirm Accept And Override',
				msg: 'Accept and override reasons: ' + item.ReasonTxt + '?'
			};
		}
		else {
			_pendingEdit = {
				action: 'accept',
				visitId: item.SuspectId,
				ReplaceVisitId: '',
				Override: false,
				title: 'Confirm Accept',
				msg: 'Accept encounter dated: ' + $filter('date')(item.EncounterDate, 'M/d/yyyy') + '?'
			};
		}

		promptUser();
	}

	function visitRemove() {
		if(vm.isWaiting) {
			return;
		}

		if(!validSvc.isText(vm.referral.SuspectPicked)) {
			throw new Error('referralDetailCtl.visitRemove, SuspectPicked required');
		}

		_pendingEdit = {
			action: 'visit-remove',
			visitId: vm.referral.SuspectPicked,
			title: 'Confirm Remove Encounter',
			msg: 'Removing the Suspect Encounter will provide another suspects list to choose from.'
		};

		promptUser();
	}


	/**
	 * 		FEED ACCEPT/REJECT REFERRAL SUSPECT
	 */

	function feedAdd(item) {
		if(vm.isWaiting) {
			return;
		}

		if(!!!item || !validSvc.isText(item.Id)) {
			throw new Error('referralDetailCtl.feedAdd, Id required');
		}

		_pendingEdit = {
			action: 'feed-accept',
			visitId: item.Id,
			title: 'Confirm Accept',
			msg: 'Accept referral feed dated: ' + $filter('date')(item.ReferralDate, 'M/d/yyyy') + '?'
		};

		promptUser();
	}

	function feedRemove() {
		if(vm.isWaiting) {
			return;
		}

		if(!validSvc.isText(vm.referral.FeedPicked)) {
			throw new Error('referralDetailCtl.feedRemove, FeedPicked required');
		}

		_pendingEdit = {
			action: 'feed-remove',
			visitId: vm.referral.FeedPicked,
			title: 'Confirm Remove Feed Referral',
			msg: 'Removing the Suspect Feed Referral will display other suspect feeds to choose.'
		};

		promptUser();
	}


	/**
	 *    SHARED ACCEPT/REJECT HANDLERS
	 */

	function promptUser() {

		var noteIsOptional = _pendingEdit.action == 'accept' || _pendingEdit.action == 'accept-override';
		var notes =  {
			prompt: noteIsOptional ? 'optional note' : 'required note',
			maxlength: 100,
			out: ''
		};

		// customize buttons for accept override scenario
		var btns = [
			{text:'CANCEL', result:'CANCEL', cancel: true}
		];

		if(_pendingEdit.action == 'accept-override') {
			btns.unshift({text:'ACCEPT AND OVERRIDE', result:'OVERRIDE', cancel: false});
		}
		else {
			btns.unshift({text:'OK', result:'YES', cancel: false});
		}

		msgSvc.confirm({
			id: 'ops.referral.accept',
			title: _pendingEdit.title,
			msg: _pendingEdit.msg,
			notes: notes,
			buttons: btns
		}).then(userConfirm, userConfirm);
	}

	function userConfirm(r) {
		// async delegate handler for OK to delete message box

		// user said yes
		if(!!r && r.result === 'YES' || r.result==='OVERRIDE') {

			// note required
			var noteIsOptional = _pendingEdit.action == 'accept' || _pendingEdit.action == 'accept-override';
			if(!noteIsOptional && !validSvc.isText(r.notes)) {
				msgSvc.ok('Note Required', 'Cannot continue without a note.');
				return;
			}
			toggleWait(true);

			switch(_pendingEdit.action) {

				case 'accept':
				case 'accept-replacevisit':
				case 'accept-override':
				case 'visit-remove':
					referralRepo.visitAddRemove(
						_pendingEdit.action == 'visit-remove' ? 'REMOVE' : 'ADD',
						vm.context,
						_pendingEdit.visitId,
						r.notes).then(okHandler, errHandler);
					break;
				case 'feed-accept':
				case 'feed-remove':
						referralRepo.visitAddRemove(
							_pendingEdit.action == 'feed-remove' ? 'FEED-REMOVE' : 'FEED-ADD',
							vm.context,
							_pendingEdit.visitId,
							r.notes).then(okHandler, errHandler);
						break;
		
				case 'status':
					referralRepo.updateStatus(vm.context, _pendingEdit.newStatus, r.notes).then(okHandler, errHandler);
					break;

				default:
					throw new Error('referralDetailCtl.userConfirm, unknown pending edit action: ' + _pendingEdit.action);
			}
		}
		else {
			_pendingEdit = null;
		}

	}

	function okHandler(r) {
		toggleWait();

		var msg = '';
		switch(_pendingEdit.action) {
			case 'accept':
				msg = 'Encounter Accepted';
				break;
			case 'feed-accept':
				msg = 'Referral Feed Accepted';
				break;
			case 'accept-replacevisit':
				msg = 'Encounter Replaced';
				break;
			case 'accept-override':
				msg = 'Encounter Accepted and Overridden to Eligible';
				break;
			case 'visit-remove':
				msg = 'Encounter Removed';
				break;
			case 'feed-remove':
				msg = 'Referral Feed Removed';
				break;
			case 'status':
				msg = 'Referral Status Saved';
				break;
		}

		// show user confirmation message
		msgSvc.okAsync(_pendingEdit.title, msg, 'ops.referral.done').then(editCleanUp, editCleanUp);
	}

	function errHandler(r) {
		toggleWait();

		if(!!!r) {
			// already handled
		}
		else if(r.status === 422) {

			// visit replacement?
			if(validSvc.isText(r.ReplaceVisitId)) {
				_pendingEdit.action = 'accept-replacevisit';
				_pendingEdit.ReplaceVisitId = r.ReplaceVisitId;
				_pendingEdit.title = 'Confirm Visit Replacement';
				_pendingEdit.msg = 'Another visit has already been accepted for this RX number. Confirm this visit suspect will be replaced.';
				promptUser();
				return;
			}

			// unknown 422 error
			msgSvc.ok(_pendingEdit.action.toUpperCase() + ' ERROR', r.invalidReason);
		} else if(r.status === 409) {
			// conflict
			msgSvc.ok('Claim Cannot Be Modified', r.msg);
		}
		else {
			// unknown error
			errSvc.warn('Unknown error during referral edit', 'referralDetailCtl.' + _pendingEdit.action, r.status, utilSvc.http.safeResponse(r));
			$state.go('ops.referral', {}, {reload: 'ops.referral'});
		}

	}

	function editCleanUp() {
		// reload current, do not advance automatically
		_pendingEdit = null;
		tabChange(vm.activeTab);
	}


	/**
	 *    POPUP
	 */

	function openPopup(evt, item) {
		// tbd... no popup needed yet
		if(vm.isWaiting) {
			return;
		}
		/*
		vm.popup = {
			ready: false,
			GPI: item.GPI,
			GpiRefItems: item.ReferenceItems
		};

		// loop html element parents to calculate top offset
		var offsetY = -50,
			elem = evt.target;
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
				break;
			}

			// add offset, get next element
			offsetY += elem.offsetTop;
			elem = elem.offsetParent;
		}
		elem = null;

		// move popup to clicked row
		var popup = document.getElementById('matchSuspectPopupContent');
		if(!!popup) {
			popup.style.top = offsetY.toString() + 'px';
		}

		// wait for digest before showing
		$timeout(function() {
			vm.popup.ready = true;
		}, 100);
		*/
	}

	function closePopup() {
		vm.popup = {};
	}


	/**
	 * 		REFERRAL STATUS
	 */

	function referStatus(newStatus) {
		if(vm.isWaiting) {
			return;
		}

		switch(newStatus) {
			case 'PENDING':
				if(vm.referral.Status != 'NEW') {
					msgSvc.ok('Cannot Save Status', 'Referral status must be NEW to set PENDING.');
					return;
				}
				break;
			case 'REJECTED':
				if(vm.referral.Status != 'NEW' && vm.referral.Status != 'PENDING') {
					msgSvc.ok('Cannot Reject Claim', 'Referral status must be NEW or PENDING to REJECT.');
					return;
				}
				break;
			case 'COMPLETE':
				if(!validSvc.isText(vm.referral.SuspectPicked)) {
					msgSvc.ok('Cannot Complete Claim', 'Please choose a Suspect Visit before setting COMPLETE.');
					return;
				}
				break;
			default:
				msgSvc.ok('Cannot Save Status', 'New Status unknown: ' + newStatus);
				return;
		}

		_pendingEdit = {
			action: 'status',
			newStatus: newStatus,
			title: 'Confirm Status',
			msg: 'Change Referral Status from ' + vm.referral.Status + ' to ' + newStatus + '?'
		};

		promptUser();
	}

	function sendFax() {
		vm.isWaiting = true;

		msgSvc.confirm({
			id: 'ops.referral.sendfax',
			title: 'Send Fax',
			msg: 'Confirm sending fax to provider.',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmSending, confirmSending);
	}

	function confirmSending(r) {
		// user said yes to delete vendor
		if(!!r && r.result == 'YES') {
			referralRepo.sendFax(vm.context).then(okSendFax, errSendFax);
		}
		else {
			vm.isWaiting = false;
		}

		function okSendFax() {
			vm.isWaiting = false;
			getDetail();
			msgSvc.ok('Fax sent');
		}

		function errSendFax(r) {
			console.log(r);
			vm.isWaiting = false;

			if(r !== null) {
				errSvc.warn('Not able to send fax.', 'referralDetailCtl.sendfax', r.status, utilSvc.http.safeResponse(r));
				$state.go('ops.referral', {}, {reload: 'ops.referral'});
			}

		}
	}


	/**
	 *    HELPERS
	 */

	function userFriendlyReasonText(apiState, apiStateReason) {

		// convert api state + reason into user friendly text

		switch(apiState) {

			case 'REVERSED':
				return apiState;

			case 'UNMATCHED':
				if(validSvc.isText(apiStateReason)) {
					return utilSvc.ng.droplistLabel(vm.EligibleDroplist, 'UNMATCHED-' + apiStateReason);
				}
				return 'UNMATCHED';

			case 'INELIGIBLE':
				if(validSvc.isText(apiStateReason)) {
					var eligTxt = utilSvc.ng.droplistLabel(vm.EligibleDroplist, 'INELIGIBLE-' + apiStateReason);
					if(validSvc.isText(eligTxt)) {
						return eligTxt;
					}
					return apiStateReason; // show state reason if it is not a searchable state reason
				}
				return ''; // hide INELIGIBLE state with no state reason

			default:
				return '';
		}
	}

	function toggleWait(isOn) {
		vm.isWaiting = !!isOn;
		msgSvc.wait(!!isOn);
	}

}
 
referralDocsCtl.$inject = ['$scope', '$state', '$timeout', '$filter', 'sessionRepo', 'referralRepo', 'utilSvc', 'validSvc', 'msgSvc', 'errSvc'];angular
.module('espui.ops')
.controller('ReferralDocsCtl', referralDocsCtl);

/* @ngInject */
function referralDocsCtl($scope, $state, $timeout, $filter, sessionRepo, referralRepo, utilSvc, validSvc, msgSvc, errSvc) {

	// private props
	var _featureName = '',
		_pagingEventListener = null,
		_pendingEdit = {},
		_datePickListener = null,
		_referralCeList = [];
	var vm = this;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);

	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.context = {};
	
	// tbl and filters
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;
		
	// doc list, linking and editing
	vm.toggleDocDrawer = toggleDocDrawer;
	vm.docLink = docLink;
	vm.model = {};
	vm.toggleDocEdit = toggleDocEdit;
	vm.docSaveDetail = docSaveDetail;
	vm.findProvider = findProvider;
	vm.pickProvider = pickProvider;

	// date pick
	vm.dtPickShow = {};
	vm.dtPickOpen = dtPickOpen;

	// droplist
	vm.refCEDropList = [];

	// edit popup (tbd for prescriber name search, pop this up to show list of prescribers found)
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;


	/**
	 *    EVENTS
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);
	});

	_datePickListener = $scope.$on('widget.input.date.pick.change', function(event, evtData) {
		event.stopPropagation();

		// params
		if(!evtData || !validSvc.isText(evtData.uniqueId)) {
			msgSvc.ok('Date Pick Error', 'refDoc.datePickEvt, evtData and uniqueId required');
			return;
		}

		switch(evtData.uniqueId) {
			case 'refDocPatientDOB':
				vm.dtPickShow.PatientDOB = false;
				vm.model.PatientDOB.val = evtData.setDate;
				break;
			default:
				// ignore other date picker events
				break;
		}
	});


	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
		if(!!_datePickListener) {
			_datePickListener();
		}
		docViewCleanUp();
	});


	/**
	 *    INIT
	 */

	init();

	function init() {
		_featureName = $state.current.name;

		vm.init = true;

		// params
		var isDetail = false,
			params = $state.params || {};
		switch(_featureName) {
			case 'ops.referral.detail.docs':
				isDetail = true;
				break;
			case 'ops.referral.docs':
				break;
			default:
				throw new Error('referralDocs.init, unknown feature name: ' + _featureName);
		}

		vm.context = initContext(isDetail, params);
		vm.flt = initFilter();

		vm.dtPickShow = {
			pending: '',
			PatientDOB: false
		};

		_referralCeList = Array.isArray(params.ReferralCE) ? params.ReferralCE : [];
		vm.refCEDropList = utilSvc.ng.droplist(_referralCeList, '', '', [{label:'Choose a Facility', value:'NONE'}]);
		loadDocList(params.Docs);
	}

	function initContext(isDetail, params) {
		// user role, permisions across all tabs

		// detail view needs claim params
		if(isDetail && (!validSvc.isCE(params.CE) || !validSvc.isCE(params.RX) || !validSvc.isText(params.DispId) || !validSvc.isText(params.Type))) {
			throw new Error('referralDocs.init, CE, RX and DispId required');
		}

		var isVerity = $scope.User.Type == 'VERITY' || $scope.User.Type == 'VERITYSA',
			hasPHI = utilSvc.user.hasFeature($scope, 'ops.referral.phi'),
			hasEdit = utilSvc.user.hasFeature($scope, 'ops.referral.edit');

		// var ceList = Array.isArray(params.CeList) ? params.CeList : [],
		// 	rxList = Array.isArray(params.RxList) ? params.RxList : [];
		
		return {
			isVerity: isVerity,
			canFindDocs: isVerity && hasPHI,
			hasPHI: hasPHI,
			hasEdit: isVerity && hasEdit,
			isDetail: isDetail,
			tab: params.Type,
			CE: params.CE,
			RX: params.RX,
			DispId: params.DispId
		};
	}

	function initFilter(ctx) {

		// check viewstate
		var vs = sessionRepo.get('vs-ops-referral-docs');
		if(!!vs && !!vs.query) {
			var vsq = vs.query;
			if(vsq.CE == ctx.CE && vsq.RX == ctx.CE && vsq.DispId == ctx.DispId) {
				return vm.resetFilters(vsq.flt);
			}
		}
		
		// default
		return vm.initFilters({
			Config: {
				Dates: ['ReceivedDate'],
				DateFmt: 'M/d/yyyy'
			},
			SortBy: ['-ReceivedDate']
		});
	}


	/**
	 * 		LOAD DOC LIST
	 */

	function loadDocList(items) {

		// display doc list
		vm.tbl = docListVM(items);
		vm.flt.Ready = true;		
		vm.action = 'LIST';
		$timeout(filterChange, 300);
	}


	/**
	 *    VIEW MODEL
	 */

	function docListVM(dataItems, tooMany) {
		dataItems = Array.isArray(dataItems) ? dataItems : [];
		
		var item = {},
			dtVal = new Date(),
			isFindDocs = vm.context.tab == 'FIND';
		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.uniqueId = i.toString();
			item.Fax = parsePhone(item.FaxNumber);

			// add metadata tags
			item.tags = [];
			if(validSvc.isText(item.ReferredNPI)) {
				item.tags.push({name: 'Prescriber NPI', type: 'ce', val:item.ReferredNPI});
			}
			if(validSvc.isText(item.CE)) {
				item.tags.push({name: 'Facility', type: 'ce', val:item.CE});
			}
			if(validSvc.isText(item.PatientLN)) {
				item.tags.push({name: 'Last Name', type: 'patient', val:item.PatientLN});
			}
			if(validSvc.isText(item.PatientFN)) {
				item.tags.push({name: 'First Name', type: 'patient', val:item.PatientFN});
			}

			// DOB sent in string format "yyyy-mm-dd"
			dtVal = null;
			if(validSvc.isText(item.DateOfBirth)) {
				dtVal = utilSvc.dt.fromServerString(item.DateOfBirth);
				if(validSvc.isDate(dtVal)) {
					item.tags.push({name:'DOB', type: 'patient', val:$filter('date')(dtVal, 'M/d/yyyy')});
				}
			}
			item.PatientDOB = dtVal; // use PatientDOB to stay consistent

			// matched properties during find
			if(isFindDocs && Array.isArray(item.Matched) && item.Matched.length > 0) {
				item.Matched = item.Matched.join(", ");
			}
			else {
				item.Matched = '';
			}
		}

		return {
			Items: [],
			DataItems: dataItems,
			TooMany: !!tooMany
		};
	}


	/**
	 *    FILTER CHANGE
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {
						
			vm.tbl.DataItems = Array.isArray(vm.tbl.DataItems) ? vm.tbl.DataItems : [];
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			$scope.$broadcast('widget.paging', {
				uniqueId: 'DOC',
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

		}, delayTime);

	}


	/**
	 * 	POPUP
	 */

	function openPopup(evt, popType, item) {
		if(vm.isWaiting) {
			return;
		}

		switch(popType) {
			case 'FIND_NPI':
				// use model
				if(!!!vm.model || !!!evt) {
					throw new Error('referralListCtl.openPopup find npi: evt, model required');
				}
				vm.popup = {
					type: 'FIND_NPI',
					action: 'QUERY',
					ready: false,
					title: 'Provider Search',
					Npi: validSvc.newProp(), // leave empty for now, tbd... vm.model.ReferredNPI.val),
					LastName: validSvc.newProp()
				};
				break;		
			default:
				throw new Error('refferalDoc.openPopup, unknown pop type: ' + popType);
		}

		// loop html element parents looking for popup container top
		// note: this is a scrollable table, reduce offset by amount the table is scrolled
		var elem = evt.target,
			scrollTopFound = false,
			offsetY = -100;
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
				break;
			}

			// scroll container found, reduce offset if this container is scrolled
			if(!scrollTopFound && !!elem.className && elem.className.indexOf('table-fixed-header-scroll') > -1) {
				scrollTopFound = true;
				offsetY -=  Math.floor(elem.scrollTop);
			}

			// add offset, get next element
			offsetY += elem.offsetTop;
			elem = elem.offsetParent;
		}
		elem = null;

		// move popup to clicked row
		var contentElemId = 'referralDocPopupContent' + popType;
		var popContent = document.getElementById(contentElemId);
		if(!!popContent) {
			popContent.style.top = offsetY.toString() + 'px';
		}

		$timeout(function() {
			vm.popup.ready = true;
		}, 200);
	}

	function closePopup() {
		vm.popup = {};
	}


	/**
	 * 	DOCUMENTS
	 */

	function cleanPdfObjects(elem) {
		// clean up PDF Blob and PDF embedded object

		if(!!elem) {
			try {
				// clear pdf blob memory
				var pdfURL = elem.dataset.pdf_url;
				if(validSvc.isText(pdfURL)) {
					URL.revokeObjectURL(pdfURL);
					elem.dataset.pdf_url = '';
				}
				pdfURL = '';
	
				// clear pdf obj
				var elemOld = document.getElementById('refDocViewerObj');
				if(!!elemOld) {
					elem.removeChild(elemOld);
				}
				elemOld = null;
			}
			catch(err) {
				console.log('cleanPdfObject err: ' + err.message);
			}
		}
	}

	function docViewCleanUp() {
		// remove old pdf object
		var viewer = document.getElementById('refDocViewer');
		if(!!viewer) {
			cleanPdfObjects(viewer);
		}
		viewer = null;
	}

	function toggleDocDrawer(item, viewBinary) {
		if(vm.isWaiting) {
			return;
		}

		// drawer is open
		if(!!item.expand) {

			// close drawer if this isn't a doc view click
			if(!!!viewBinary) {
				item.action = '';
				vm.model = {};
				docViewCleanUp();
				item.expand = false;
			}
		}
		else {
			// drawer is closed
			item.action = 'VIEW';
			item.expand = true;
		}

		// load binary file
		if(!!viewBinary) {
			if(!!!item || !validSvc.isText(item.Id)) {
				throw new Error('referralDoc.toggleDocDrawer, item Id required to load binary');
			}
			toggleWait(true);
			referralRepo.getPDF(item.Id).then(okPDF, errPDF);
		}

		function okPDF(binaryData) {
			toggleWait();

			// convert binary stream and attach it to embed
			var pdfBlob, pdfUrl, 
				viewer = document.getElementById('refDocViewer');

			if(!!viewer) {
				// remove old blob / element
				cleanPdfObjects(viewer);

				try {
					// setup Blob and URL address
					pdfBlob = new Blob([binaryData],{type:'application/pdf'});
					pdfUrl = URL.createObjectURL(pdfBlob);
					viewer.dataset.pdf_url = pdfUrl;
	
					// new element
					var elem = document.createElement("object");
					elem.id = 'refDocViewerObj';
					elem.type = 'application/pdf';
					elem.width = '100%';
					elem.height = '100%';
					elem.data = pdfUrl + '#zoom=85';
					elem.data += '&toolbar=1'; // everyone gets toolbar

					viewer.appendChild(elem);
					elem = null;
				}
				catch(err) {
					msgSvc.ok('Cannot View PDF', err.message);
				}
				finally {
					pdfBlob = null;
					pdfUrl = null;
				}
				viewer = null;
			}
		}

		function errPDF(r) {
			toggleWait();

			if(!!r) {
				errSvc.warn('Get PDF Error', 'referralList.errPDF', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function docLink(item) {
		if(vm.isWaiting) {
			return;
		}

		// toggle off
		if(!!!item || !validSvc.isText(item.Id)) {
			throw new Error('referralDoc.docLink, item and Id required');
		}

		// LINK or UNLINK based on this document tab
		_pendingEdit = {
			action: vm.context.tab == 'FIND' ? 'LINK' : 'UNLINK'
		};

		toggleWait(true);
		referralRepo.docLink(_pendingEdit.action, vm.context, item.Id).then(okDocLink, errDocLink);

		function okDocLink(r) {
			toggleWait();

			var title = 'Document ',
				msgTxt = '';
				
			switch(_pendingEdit.action) {
				case 'LINK':
					title += 'Linked';
					msgTxt = 'Document moved to Linked Documents tab.';
					break;
				case 'UNLINK':
					title += 'Un-Linked';
					msgTxt = 'See Find Documents tab for available documents to link.';
					break;
				default:
					throw new Error('referralDocs.okDocLink, unknown action: ' + _pendingEdit.action);
			}
			msgSvc.ok(title, msgTxt);
			notifyParentRefresh();			
		}

		function errDocLink(r) {
			toggleWait();

			if(!!r) {
				errSvc.warn('Get PDF Error', 'referralList.errDocLink', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}


	/**
	 * 		EDITING
	 */

	function loadPatientDOB(val) {
		// reset date editing state, conditionally load value
		var dtToday = new Date();
		var dtDOBmin =  utilSvc.dt.zeroTime(new Date(dtToday.getFullYear() - 120, dtToday.getMonth(), 1)); // -120 years
		var dobProp = validSvc.newPropDateNull(dtDOBmin, dtToday);

		if(validSvc.isDate(val)) {
			dobProp.val = new Date(val);
		}
		return dobProp;
	}

	function modelVM(doc) {

		return {
			id: doc.Id,
			ReferredNPI: validSvc.newProp(doc.ReferredNPI),
			CE: validSvc.newProp(doc.CE),
			PatientDOB: loadPatientDOB(doc.PatientDOB),
			PatientLN: validSvc.newProp(doc.PatientLN),
			PatientFN: validSvc.newProp(doc.PatientFN)
		};
	}

	function toggleDocEdit(item) {
		if(vm.isWaiting) {
			return;
		}

		// tbd.. close NPI search popup

		// reset patient DOB picker
		vm.dtPickShow = {
			pending: '',
			PatientDOB: false
		};

		// already editing
		if(item.action == 'EDIT') {
			item.action = 'VIEW';
			vm.model = {};
			return;
		}

		// another doc is already editing
		if(validSvc.isText(vm.model.id)) {
			msgSvc.ok('Cannot Edit', 'Another document is already editing');
			return;
		}

		if(!!!item || !validSvc.isText(item.Id)) {
			throw new Error('referralDoc.toggleDocEdit, item and Id required');
		}

		vm.model = modelVM(item);
		item.action = 'EDIT';
	}

	function validNpi(prop, minLen, maxLen) {
		prop.fail = '';
		if(validSvc.isText(prop.val)) {
			var npi = prop.val;
			var npiOk = validSvc.isInteger(npi) && npi.length >= minLen && npi.length <= maxLen;
			prop.fail = npiOk ? 'no' : 'yes';
		}
		return prop;
	}

	function docValid(m) {
		// properties are optional, user can empty out a value

		// NPI
		m.ReferredNPI = validNpi(m.ReferredNPI, 10, 10);

		// patient name
		m.PatientFN = validName(m.PatientFN, 1, 50);
		m.PatientLN = validName(m.PatientLN, 1, 100);

		// DOB
		m.PatientDOB.fail = '';
		if(validSvc.isDate(m.PatientDOB.val)) {
			m.PatientDOB = validSvc.propDateValid(m.PatientDOB);
			m.PatientDOB.fail = m.PatientDOB.fail ? 'yes' : 'no';
		}

		if(m.CE.val == 'NONE') {
			m.CE.msg = 'Facility required';
			m.CE.fail = 'yes';
		} else {
			m.CE.msg = '';
			m.CE.fail = '';
		}

		return m.ReferredNPI.fail != 'yes' &&
			m.PatientLN.fail != 'yes' &&
			m.PatientFN.fail != 'yes' &&
			m.CE.fail != 'yes' &&
			m.PatientDOB.fail != 'yes';
	}

	function docSaveDetail() {
		if(vm.isWaiting) {
			return;
		}

		if(!docValid(vm.model)) {
			msgSvc.ok('Cannot Save', 'Check properties');
			return;
		}

		// removing confirmation and notes per Julie
		toggleWait(true);
		referralRepo.docSaveDetail(vm.model, '').then(okSaveDoc, errSaveDoc);

		// msgSvc.confirm({
		// 	id: 'ops.referral.doc-save',
		// 	title: 'Confirm Save',
		// 	msg: 'Save document details.',
		// 	notes: {
		// 		prompt: 'required note',
		// 		maxlength: 100,
		// 		out: ''
		// 	},
		// 	buttons: [
		// 		{text:'OK', result:'YES', cancel: false},
		// 		{text:'CANCEL', result:'CANCEL', cancel: true}	
		// 	]
		// }).then(userConfirm, userConfirm);
	}

	function userConfirm(r) {
		// user said yes
		if(!!r && r.result === 'YES') {
			// note required
			if(!validSvc.isText(r.notes)) {
				msgSvc.ok('Note Required', 'Cannot continue without a note.');
				return;
			}

			toggleWait(true);
			referralRepo.docSaveDetail(vm.model, r.notes).then(okSaveDoc, errSaveDoc);
		}
	}	

	function okSaveDoc(r) {
		toggleWait();
		msgSvc.ok('Details Saved');
		notifyParentRefresh();
	}

	function errSaveDoc(r) {
		toggleWait();

		if(!!r) {
			if (r.status === 422) {
				vm.match = r.model;
				msgSvc.ok('Cannot Save', 'Check property values');
			}
			else {
				// unknown error
				errSvc.warn('Unknown error during document save', 'referralDocs.errSaveDoc', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}


	/**
	 * 		FIND PROVIDER
	 */

	function providerListVM(items) {
		return {
			DataItems: items,
			Items: items
		};
	}

	function findProvider() {
		// used by FIND_NPI popup

		if(vm.isWaiting || !!!vm.popup || (vm.popup.action != 'QUERY' && vm.popup.action != 'LIST')) {
			return;
		}
		var pop = vm.popup;
		pop.action = 'QUERY';
		pop.Items = [];

		// either Npi or LastName required
		var hasNpi = validSvc.isText(pop.Npi.val),
			hasLN = validSvc.isText(pop.LastName.val);
		if(!hasLN && !hasNpi) {
			msgSvc.ok('Cannot Search', 'Enter NPI or Last Name to search');
			return;
		}
		if(hasNpi && hasLN) {
			msgSvc.ok('Cannot Search', 'Enter NPI or Last Name, both cannot be searched at the same time');
			return;
		}

		// validate if entered
		pop.Npi = hasNpi ? validNpi(pop.Npi, 3, 10) : validSvc.newProp();
		if(hasLN) {
			pop.LastName.fail = pop.LastName.val.length < 3 ? 'yes' : 'no';
		}
		else {
			pop.LastName = validSvc.newProp();
		}
		if(pop.Npi.fail == 'yes' || pop.LastName.fail == 'yes') {
			msgSvc.ok('Cannot Search', 'Check search properties');
			return;
		}

		toggleWait(true);
		referralRepo.findProvider(vm.context.CE, vm.context.RX, pop.Npi.val, pop.LastName.val).then(okFindProv, errFindProv);

		function okFindProv(r) {
			toggleWait();			
			if(!!!vm.popup || vm.popup.action != 'QUERY') {
				return;
			}
			
			vm.popup.Items = r;
			vm.popup.action = 'LIST';
		}
			
		function errFindProv(r) {
			toggleWait();
			if(!!r) {
				errSvc.error('Unknown api error', 'referral.findNpi', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function pickProvider(item) {
		// used by FIND_NPI popup to choose a provider NPI
		if(vm.isWaiting || !!!vm.popup || vm.popup.action != 'LIST' || !!!vm.model) {
			return;
		}

		// params
		if(!!!item || !validSvc.isText(item.PrescriberNPI)) {
			throw new Error('referDoc.pickProvider, PrescriberNPI required');
		}

		vm.model.ReferredNPI.val = item.PrescriberNPI;
		closePopup();
	}


	/**
	 *    DATE PICKER
	 */
	function dtPickOpen(dtName) {

		if (dtName != 'PatientDOB') {
			alert('refDoc.dtPickOpen, name unknown: ' + dtName);
			return;
		}

		var dt = vm.model[dtName];
		vm.dtPickShow.pending = dtName;

		$scope.$broadcast('widget.input.date.pick', {
			uniqueId: 'refDoc' + dtName,
			setDate: dt.val,
			minDate: dt.min,
			maxDate: dt.max
		});

		$timeout(function () {
			if (validSvc.isText(vm.dtPickShow.pending)) {
				vm.dtPickShow[vm.dtPickShow.pending] = true;
			}
		}, 100);
	}


	/**
	 * 		HELPERS
	 */

	function toggleWait(isOn) {
		vm.isWaiting = !!isOn;
		msgSvc.wait(!!isOn);
	}

	function saveViewState(ctx, flt) {
		sessionRepo.set('vs-ops-referral-docs', {
			ctx: ctx,
			flt: flt
		});
	}

	function parsePhone(val) {
		if(!validSvc.isText(val)) {
			return '';
		}

		// get string with only numbers
		val = val.toString().replace(/\D/g, '');
	
		// convert val to phone format "123-456-7890"
		// note: build number starting with area code first, this supports < 10 digit numbers
		var result = '';
		if(val.length >= 3) {
			result = '(' + val.substring(0, 3);
		}
		if(val.length > 3) {
			result += ') ' + val.substring(3, 6);
		}
		if(val.length > 6) {
			result += '-' + val.substring(6, 10);
		}

		return result;
	}

	function notifyParentRefresh() {
		// notify parent for a refresh
		$scope.$emit('ops.referral.tab.refresh', {
			uniqueId: vm.context.isDetail ? 'CLAIM' : 'DOC',
			tab: vm.context.tab
		});
	}

	function validName(prop, minLen, maxLen) {
		var nameAllowed = /[^A-Z\-\'\ ]/;

		prop.fail = 'no';
		prop.msg = '';

		if(validSvc.isText(prop.val)) {
			var name = prop.val;

			// check len
			if(name.length < minLen || name.length > maxLen) {
				prop.msg = 'must be 3 to 20 characters';
				prop.fail = 'yes';
				return prop;
			}

			// upper-case and limit characters
			prop.val = name.toUpperCase();
			if(nameAllowed.test(prop.val)) {
				prop.msg = 'only letters, dash, space or apostrophe';
				prop.fail = 'yes';
			}
			else {
				prop.msg = '';
			}
		}

		return prop;
	}

}
 
referralCtl.$inject = ['$scope', '$state', '$timeout', '$window', 'sessionRepo', 'referralRepo', 'lookupRepo', 'prefsRepo', 'appConst', 'utilSvc', 'validSvc', 'msgSvc', 'errSvc'];angular
.module('espui.ops')
.controller('ReferralListCtl', referralCtl);

/* @ngInject */
function referralCtl($scope, $state, $timeout, $window, sessionRepo, referralRepo, lookupRepo, prefsRepo, appConst, utilSvc, validSvc, msgSvc, errSvc) {

	// private props
	var _featureName = '',
		_pagingEventListener = null,
		_datePickListener = null,
		_docViewListener = null,
		_returnVisit = false,
		_mouseLeaveDelay = {},
		_tblViewEventListener = null,
		_pendingExcelFilename = '',
		_tabInfo = {},
		_statusList = ['NEW', 'PENDING', 'REJECTED', 'COMPLETE'],
		_activityList = ['NEW', 'DOC-EDIT', 'LINK'],
		_referralCeList = [];
	var vm = this;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addMultiselect(vm);
	utilSvc.ctl.addFlexTop(vm);
	utilSvc.ctl.addTableViews(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.context = {};

	// droplists
	vm.DateTypeDroplist = [];
	vm.DateRangeList = [];

	// query
	vm.query = {};
	vm.queryChange = queryChange;
	vm.queryChangeDateType = queryChangeDateType;
	vm.querySubmit = querySubmit;
	vm.dateRangeChange = dateRangeChange;
	vm.querySyncToggle = querySyncToggle;
	vm.queryChangeAffs = queryChangeAffs;
	vm.showInactiveAffs = 'no';

	// date pick
	vm.dtPickShow = {};
	vm.dtPickOpen = dtPickOpen;	
	
	// tbl and filters
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;
	
	// multiselect
	vm.CeMultiselect = {};
	vm.RxMultiselect = {};
	vm.StatusMultiselect = {};
	vm.ActivityMultiselect = {};
	vm.multiClick = multiClick;
	vm.multiToggle = multiToggle;
	vm.multiHover = multiHover;

	// flex top
	vm.flex = {};
	vm.flexTopExpand = flexTopExpand;

	// suspects popup
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;
	vm.rowClick = rowClick;

	// table view
	vm.tblViewConfig = {};
	vm.tblView = {};

	// excel
	vm.getExcel = getExcel;

	// tabs
	vm.activeTab = '';	
	vm.tabChange = tabChange;

	// charts
	vm.chartSummary = {};

    vm.showActionable = false;


	/**
	 *    EVENTS
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});

	_tblViewEventListener = $scope.$on('widget.tblview.editor.change', function(event, evtData) {
		event.stopPropagation();

		if(vm.activeTab != 'REF') {
			return;
		}

		switch(evtData.type) {

			case 'edit':
				openPopup(null, 'TBLVIEW');
				break;

			case 'close':
				closePopup();
				break;

			case 'load':
				// load specific view requested
				vm.tblView.current = evtData.id;
				$timeout(function() {
					tblViewReload(vm.query, true);

					// update user preference (delay the network call)
					$timeout(function() {
						if(vm.action == 'LIST' && !!vm.tblView && validSvc.isText(vm.tblView.current)) {
							prefsRepo.setCurrentTableView(vm.tblViewConfig.storageKey, vm.tblView.current).then(okCurrentTableView, errCurrentTableView);
						}
					}, 2000);
				}, 300);
				break;

			default:
				throw new Error('widget.tblview.editor.change, unknown event type: ' + evtData.type);
		}

	});

	_datePickListener = $scope.$on('widget.input.date.pick.change', function(event, evtData) {
		event.stopPropagation();

		// params
		if(!evtData || !validSvc.isText(evtData.uniqueId)) {
			msgSvc.ok('Date Pick Error', 'refList.datePickEvt, evtData and uniqueId required');
			return;
		}
		var id = evtData.uniqueId;

		vm.dtPickShow[id] = false;
		vm.query[id].val = evtData.setDate;
	});

	_docViewListener = $scope.$on('ops.referral.tab.refresh', function(event, evtData) {
		event.stopPropagation();

		// params
		evtData = evtData || {};

		var id = evtData.uniqueId,
			tab = evtData.tab;
		
		// event source
		if(!validSvc.isText(id) || (id != 'CLAIM' && id != 'DOC')) {
			throw new Error('ops.referral.docs, id source unknown: ' + id);
		}

		// ignore if this isn't for DOC
		if(id != 'DOC') {
			return;
		}		
		docTabRefresh();
	});


	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
		if(!!_tblViewEventListener) {
			_tblViewEventListener();
		}
		if(!!_datePickListener) {
			_datePickListener();
		}
		if(!!_docViewListener) {
			_docViewListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {
		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		_featureName = $state.current.name;

		vm.init = true;
		vm.flex = vm.flexInit();
		vm.tblViewConfig = tblViewConfigSetup(tblViewSchemaVM());
		resetChart();
		initDroplists();

		var usr = $scope.User;
		vm.context = initContext(usr);
    	vm.showActionable = vm.context.isVerity; // always show actionable filter for verity users
		
    	_tabInfo = initTabInfo(usr);
		
		// setup bare minimum query before async call (date widget needs this)
		vm.query = _tabInfo['SUMMARY'].query;

		// ASYNC: get referral CEs
		lookupReferralCeList();
	}

	function getAffs(showInactive) {
		var affStatus = ['ONBOARDING', 'ACTIVE'];
		if(!!showInactive) {
			affStatus.push('INACTIVE');
		}
		var affs = utilSvc.aff.findStatus($scope.User.AffList, affStatus);
		affs = utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));
		
		// limit affs to Referral CEs once they are loaded
		if(_referralCeList.length > 0) {
			affs = utilSvc.aff.findCeList(affs, _referralCeList);
		}

		return affs;
	}

	function initDroplists() {

		vm.DateTypeDroplist = [
			{label: 'Filled Date', value: 'SERVICE'},
			{label: 'Matched Date', value: 'MATCH'},
			{label: 'Written Date', value: 'RXWRITTEN'}
		];
		vm.DateRangeList = utilSvc.widget.dateRangeList([]);

		vm.dtPickShow = {
			pending: '',
			PatientDOB: false
		};

		vm.EligibleDroplist = [
			{label: 'All Reasons', value: 'INELIGIBLE'},
			{label: 'CONTRACT DATE', value:'INELIGIBLE-REASON_CONTRACT_DATE'},
			{label: 'ERX NPI', value:'INELIGIBLE-EPRESCRIBE_NPI'},
			{label: 'EXCLUDED PAYOR CE', value:'INELIGIBLE-CE_EXCLUDED_PAYOR'},
			{label: 'EXCLUDED PAYOR NDC', value:'INELIGIBLE-EXCLUDED_PAYOR_NDC'},
			{label: 'GOV MEDICAID', value:'INELIGIBLE-GOV_MEDICAID'},
			{label: 'INVALID MATCH', value:'UNMATCHED-INVALID_MATCH'},
			{label: 'IN REVIEW', value:'INELIGIBLE-INREVIEW'},
			{label: 'ERX PREFERRED', value:'UNMATCHED-ERX_PREFERRED'},
			{label: 'VHUB TPA', value:'UNMATCHED-VHUB_TPA'},
			{label: 'LOCATION', value:'INELIGIBLE-PATIENT_LOCATION'},
			{label: 'MCO MEDICAID', value:'INELIGIBLE-EXCLUDED_PAYOR'},
			{label: 'NO MODIFIER', value: 'INELIGIBLE-NO_MODIFIER'},
			{label: 'NPI BLOCKED', value:'INELIGIBLE-NPI_REVIEW_BLOCK'},
			{label: 'NPI FLOATING', value:'INELIGIBLE-NPI_REVIEW_FLOAT'},
			{label: 'NPI PROXIMITY', value:'INELIGIBLE-NPI_PROXIMITY'},
			{label: 'NPI REFERRAL', value:'INELIGIBLE-NPI_REVIEW_REFERRAL'},
			{label: 'OPA DATE', value:'INELIGIBLE-CE_OPA_STARTDATE'},
			{label: 'REMATCHED', value:'UNMATCHED-WEAKMATCH'},
			{label: 'REVERSED', value:'REVERSED'},
			{label: 'TPA REJECTED', value:'INELIGIBLE-TPA_REJECTED'},
			{label: 'UNMATCHED', value:'UNMATCHED'},
			{label: 'VISIT PROXIMITY', value:'INELIGIBLE-VISIT_PROXIMITY'},
			{label: 'BLOCKED SCRIPT', value:'INELIGIBLE-BLOCKED_SCRIPT'},
			{label: 'VISIT REVERSED', value:'UNMATCHED-INVALID_VISIT'},
			{label: 'DISP CHANGE', value:'UNMATCHED-DISP_CHANGE'},
			{label: 'ACCT CHANGE', value:'UNMATCHED-DISP_TYPE_CHANGE'},
			{label: 'MFR RESTRICT', value:'INELIGIBLE-MFR_RESTRICT'},
			{label: 'MFR AGED', value:'INELIGIBLE-MFR_AGED'},
			{label: 'NPI PERIOD', value:'UNMATCHED-NPIPERIOD'},
			{label: 'NPI INACTIVE', value:'UNMATCHED-NPIINACTIVE'},
			{label: 'RXNUMBER', value:'UNMATCHED-RXNUMBER'},
		];

		// CE multiselect
		vm.CeMultiselect = {
			type: 'CE',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Facility',
			vals: [],
			list: [], // built by CE list lookup on init
			flt: ''
		};

		// RX multiselect
		vm.RxMultiselect = {
			type: 'RX',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Pharmacy',
			vals: [],
			list: [],
			flt: ''
		};

		// Status multiselect
		var statusMultiList = _statusList.slice();
		statusMultiList.unshift('ALL');
		vm.StatusMultiselect = {
			type: 'STATUS',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'All Options',
			vals: ['ALL'],
			list: vm.multiselectBuild(statusMultiList),
			flt: ''
		};

		// Doc activity multiselect
		var activityMultiList = _activityList.slice();
		activityMultiList.unshift('ALL');
		vm.ActivityMultiselect = {
			type: 'ACTIVITY',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'All Options',
			vals: ['ALL'],
			list: vm.multiselectBuild(activityMultiList),
			flt: ''
		};
	}

	function newCheckProp(val, chk) {
		var p = validSvc.newProp(val);
		p.chk = !!chk;
		return p;
	}

	function newCheckPropDateNull(min, max) {
		var p = validSvc.newPropDateNull(min, max);
		p.chk = false;
		return p;
	}

	function loadPatientDOB(prop) {
		var dtToday = new Date();
		var dtDOBmin =  utilSvc.dt.zeroTime(new Date(dtToday.getFullYear() - 120, dtToday.getMonth(), 1)); // -120 years
		var dobProp = newCheckPropDateNull(dtDOBmin, dtToday);

		if(!!prop && validSvc.isDate(prop.val) && prop.chk) {
			dobProp.val = new Date(prop.val);
			dobProp.chk = true;
		}
		return dobProp;
	}

	function initContext(usr) {

		var isVerity = usr.Type == 'VERITY' || usr.Type == 'VERITYSA',
			hasPHI = utilSvc.user.hasFeature($scope, 'ops.referral.phi');
				
		return {
			isVerity: isVerity,
			canUseDocs: isVerity && hasPHI,
			hasPHI: hasPHI
		};
	}

	function initQuery(ceVals, dtType, dtSuffix) {
		var q = {
			Sync: 'ON',
			CE: validSvc.newProp(),
			RX: validSvc.newProp(),
			DateType: dtType,
			DateTypeTxt: dateTypeDisplayTxt(dtType, dtSuffix),
			DateRangeMode: 'MTD',
			StartDate: validSvc.newPropDateNull(),
			EndDate: validSvc.newPropDateNull(),
			DateRangeValid: false,
			DateRangeChk: true,

			// search options
			Status: newCheckProp('ALL'),
			Activity: newCheckProp('ALL'),
			ItemCode: newCheckProp(''),
			PrescriberIdent: newCheckProp(''),
			DrugType: newCheckProp(''),
			PatientLN: newCheckProp(''),
			Eligible: newCheckProp(''),
			Actionable: newCheckProp(''),
			Orderable: newCheckProp(''),
			MinimumSavings: newCheckProp(''),
			Fax: newCheckProp(''),
			PatientDOB: loadPatientDOB()
		};

		// add multiselect vals
		q.CE.vals = ceVals;
		q.RX.vals = ['ALL'];
		q.Status.vals = ['ALL'];
		q.Activity.vals = ['ALL'];
		return q;
	}

	function initTabInfo(usr) {
		var ceVals = validSvc.isCE(usr.CE) ? [usr.CE] : [];

		return {
			SUMMARY: {
				query: initQuery(ceVals, 'MATCH', ' Date'),
				flt: {}
			},
			REF: {
				query: initQuery(ceVals, 'SERVICE'),
				flt: vm.initFilters({
					Config: {
						Dates: ['WrittenDate','ServiceDate'],
						DateFmt: 'M/d/yyyy'
					},
					SortBy: ['-ServiceDate']
				})
			},
			DOC: {
				query: initQuery(['ALL'], 'RECEIVED', ' Date'),
				flt: vm.initFilters({
					Config: {
						Dates: ['ReceivedDate'],
						DateFmt: 'M/d/yyyy'
					},
					SortBy: ['-ReceivedDate']
				})
			}
		};
	}

	function initViewState(defaultTab) {
		_returnVisit = false;

		var vs = sessionRepo.get('vs-ops-referral-list');
		if(!!vs) {
			_returnVisit = true;

			// load saved state, tabChange will load up tab details
			defaultTab = vs.activeTab;
			_tabInfo = vs.tabInfo;
		}

		return defaultTab;
	}

	function lookupReferralCeList() {
		// ASYNC: UI only uses Referral CEs
		_referralCeList = [];
		var ceList = utilSvc.aff.ceList(getAffs(true));
		vm.isWaiting = true;

		if(ceList.length < 1) {
			noCeList();
			return;
		}

		lookupRepo.CeInfo(ceList).then(okCeLookup, errCeLookup);

		function okCeLookup(items) {

			// none found, keep waiting on
			if(!Array.isArray(items) || items.length < 1) {
				noCeList();
				return;
			}
			vm.isWaiting = false;
		
			// create ce list
			var item = null;
			for(var i = 0; i < items.length; i++) {
				item = items[i];
				if(!!item.EnableReferralNPIs) {
					if (!!item.EnableActionableFilter) {
						vm.showActionable = true;
					}
					_referralCeList.push(item.NickName);
				}
			}
			
			// setup CE Multiselect
			_referralCeList.sort();
			vm.CeMultiselect.list = vm.multiselectBuild(_referralCeList, false);

			// continue init
			initFinalize();
		}

		function noCeList() {
			msgSvc.ok('No Facilities', 'No covered entities with option "Enable Referral NPIs" were found.');
		}
	
		function errCeLookup(r) {
			vm.isWaiting = false;
			if(!!r) {
				errSvc.warn('Error looking up ce display properties', 'referralList.lookupReferralCeList', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function initFinalize() {
		// runs after CE lookup
		vm.activeTab = initViewState('REF');
		tabChange(vm.activeTab);
	}
	

	/**
	 *    VIEW MODEL
	 */

	function referralsVM(dataItems, tooMany) {
		dataItems = Array.isArray(dataItems) ? dataItems : [];

		// clean up incoming data
		var item = {};
		var ii = 0;
		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.uniqueId = i.toString();

			// ePrescribe (pack RxNumber and eRx into RxNumberTxt)
			item.RxNumberTxt = validSvc.isText(item.RxNumber) ? item.RxNumber.toString() : '';
			if(!!item.Eprescribe) {
				item.RxNumberTxt = 'eRX' + item.RxNumberTxt;
			}

			// shorten patient name
			var pname = item.PatientFN;
			if(validSvc.isText(pname) && pname.length > 6) {
				item.PatientFN = pname.substr(0,6) + '...';
			}

			item.Medicaid = !!item.Medicaid ? 'YES' : 'NO';
			item.Eprescribe = !!item.Eprescribe;
			item.Erx = !!item.Eprescribe ? 'YES' : 'NO';
			item.CashCard = !!item.CashCard ? 'YES' : 'NO';

			item.EligOverride = !!item.EligOverride;
			item.OverrideTxt = item.EligOverride ? 'YES' : 'NO';
			
			if(validSvc.isText(item.BinPcnString)) {
				item.BinPcnTxt = item.BinPcnString.replace(/\b\]\[+/g,', ');  // swap "][" for ", "
				item.BinPcnTxt = item.BinPcnTxt.replace(/[\[\]]+/g,''); // drop all other hard brackets
			}
			else {
				item.BinPcnTxt = '';
			}

			// user friendly State Reasons
			item.StateReasons = Array.isArray(item.StateReasons) ? item.StateReasons : [];
			for(ii = 0; ii < item.StateReasons.length; ii++) {
				item.StateReasons[ii] = userFriendlyReasonText(item.State, item.StateReasons[ii]);
			}

			if(item.StateReasons.length === 1) {
				item.Reason = item.StateReasons[0];
			}
			else if(item.StateReasons.length > 1) {
				item.Reason = 'MULTIPLE';
			}
			else {
				item.Reason = '';
			}

			// change log
			item.ChangeLog = parseChangeLog(item.ChangeLog);
			item.hasLog = item.ChangeLog.length > 0;
			item.LastActivity = item.hasLog ? item.ChangeLog[0].Activity : '';
		}

		return {
			Items: [],
			DataItems: dataItems,
			TooMany: !!tooMany
		};
	}

	function parseChangeLog(items) {
		if(!Array.isArray(items)) {
			return [];
		}

		var item = null,
			faxTxt = '';
		for(var i = 0; i < items.length; i++) {
			item = items[i];

			// convert CONST soup into 1 property
			switch(item.Function) {
				case 'FEEDSELECT':
					item.Activity = item.Status == 'FEEDADD' ? 'FEED-ADD' : 'FEED-REMOVE';
					break;
				case 'VISITSELECT':
					item.Activity = item.Status == 'VISITADD' ? 'VISIT-ADD' : 'VISIT-REMOVE';
					break;
				case 'DOCUMENT':
					item.Activity = item.Status == 'LINK' ? 'DOC-ADD' : 'DOC-REMOVE';
					break;
				case 'STATECHANGE':
					item.Activity = validSvc.isText(item.Status) ? item.Status.toUpperCase() : '';
					break;
				case 'FAX':
					faxTxt = 'FAX-';
					switch(item.Status) {
						case 'SENT':
							faxTxt += 'SENT';
							break;
						case 'DELIVERED':
							faxTxt += 'ACK';
							break;
						case 'ERROR':
							faxTxt += 'ERROR';
							break;
					}
					item.Activity = faxTxt;
					break;
			}
		}

		return items.reverse();
	}

	function summaryVM(dataItems) {
		function totalsVM(count, savings) {
			return {
				Count:count,
				Savings:savings,
				Percent:0
			};
		}
		var result = {
			NEW: totalsVM(0,0),
			PENDING: totalsVM(0,0),
			COMPLETE: totalsVM(0,0),
			REJECTED: totalsVM(0,0)
		};

		// get status counts
		result.NEW = dataItems.New;
		result.PENDING = dataItems.Pending;
		result.COMPLETE = dataItems.Complete;
		result.REJECTED = dataItems.Rejected;

		// sub-total, total
		result.InProgress = totalsVM(result.NEW.Count + result.PENDING.Count, result.NEW.Savings + result.PENDING.Savings);
		result.Resolved = totalsVM(result.COMPLETE.Count + result.REJECTED.Count, result.COMPLETE.Savings + result.REJECTED.Savings);
		result.Total = totalsVM(result.InProgress.Count + result.Resolved.Count, result.InProgress.Savings + result.Resolved.Savings);

		// percent of total
		function totalPercent(count, total) {
			return Math.round((count / total) * 100);
		}
		if(result.Total.Count > 0) {
			var total = result.Total.Count;
			result.NEW.Percent = totalPercent(result.NEW.Count, total);
			result.PENDING.Percent = totalPercent(result.PENDING.Count, total);
			result.COMPLETE.Percent = totalPercent(result.COMPLETE.Count, total);
			result.REJECTED.Percent = totalPercent(result.REJECTED.Count, total);			
			result.InProgress.Percent = totalPercent(result.InProgress.Count, total);
			result.Resolved.Percent = totalPercent(result.Resolved.Count, total);
		}

		return result;
	}


	/**
	 * 	QUERY
	 */

	function queryChange() {
		if(!vm.init) {
			vm.action = '';
			vm.tbl = {};
			vm.flt = vm.resetFilters(vm.flt);
			vm.flex = vm.flexInit();
			vm.popup = {};
			$scope.$broadcast('widget.paging');
			resetChart(true);

			vm.dtPickShow = {
				pending: '',
				PatientDOB: false
			};
		}
	}

	function queryChangeDateType() {
		queryChange();
		var dtSuffix = vm.activeTab != 'REF' ? ' Date' : '';
		vm.query.DateTypeTxt = dateTypeDisplayTxt(vm.query.DateType, dtSuffix);
	}

	function queryChangeAffs() {
		if(vm.isWaiting) {
			return;
		}
		vm.showInactiveAffs = vm.showInactiveAffs == 'yes' ? 'no' : 'yes';
		multiClick('CE', '|CLEAR|');
		multiClick('RX', '|CLEAR|');
		$timeout(function() {
			vm.query = tabLoadQuery('REF');
		}, 200);
		// fire date control event after widget scope is setup
		$timeout(function() {
			$scope.$broadcast('widget.input.date.range.mode', {uniqueId: vm.activeTab, mode: vm.query.DateRangeMode, keepDates: true});
		}, 500);
	}

	function dateRangeChange(uniqueId, dtMode, isValid) {
		if(uniqueId != vm.activeTab) {
			return;
		}

		queryChange();
		
		vm.query.DateRangeMode = dtMode;
		vm.query.DateRangeValid = isValid;
		
		if(_returnVisit) {
			_returnVisit = false;
			querySubmit();
		}
		vm.init = false;
	}

	function querySyncToggle() {
		if(vm.isWaiting) {
			return;
		}
		vm.query.Sync = vm.query.Sync == 'ON' ? 'OFF' : 'ON';
	}

	function multiClick(propName, val) {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		var multi = {};
		switch(propName) {
			case 'CE':
				multi = vm.CeMultiselect;
				break;
			case 'RX':
				multi = vm.RxMultiselect;
				break;
			case 'Status':
				multi = vm.StatusMultiselect;
				break;
			case 'Activity':
				multi = vm.ActivityMultiselect;
				break;
			default:
				throw new Error('refList.multiClick, unknown propName: ' + propName);
		}
		vm.multiselectClick(multi, val);
		vm.multiselectTitle(multi, true);

		var queryProp = vm.query[propName];
		queryProp.vals = multiselectQueryVals(multi);
		queryProp.fail = queryProp.vals.length > 0 ? 'no' : 'yes';
		if(queryProp.fail == 'yes') {
			return;
		}

		// CE click rebuilds RX options, default to ALL
		if(propName == 'CE') {
			var affs = utilSvc.aff.findCeList(getAffs(vm.showInactiveAffs == 'yes'), queryProp.vals);
			var rxList = utilSvc.aff.rxList(affs);


			rxList.unshift('ALL');
			vm.RxMultiselect.list = vm.multiselectBuild(rxList, false);
			multiClick('RX', 'ALL');

			// copy CE/RX vals to other tabs
			syncQueryToTabs(vm.activeTab, vm.query);
		}
	}

	function flexTopExpand() {
		// user opened search query, reset list display, show search expanded
		queryChange();
	}

	function multiAdjustAllOptions(useALL, multi) {
		if(useALL && multi.list[0].val !== 'ALL') {
			multi.list.unshift({checked:false, val: 'ALL', lbl: 'ALL'});
		}
		else if(!useALL && multi.list[0].val == 'ALL') {
			multi.list.splice(0,1);
		}
		return multi;
	}

	function tabLoadQuery(newTab) {

		var q =  _tabInfo[newTab].query;

		// CE multi
		vm.CeMultiselect = multiAdjustAllOptions(newTab == 'DOC', vm.CeMultiselect);
		vm.multiselectReturnVisit(vm.CeMultiselect, '', q.CE.vals);
		vm.multiselectTitle(vm.CeMultiselect, true);
		q.CE.fail = vm.CeMultiselect.vals.length < 1 ? 'yes' : 'no';
		
		// RX multi
		var ceVals = multiAllChecked(vm.CeMultiselect) ?  multiselectQueryVals(vm.CeMultiselect) : vm.CeMultiselect.vals;
		var ceAffs = utilSvc.aff.findCeList(getAffs(vm.showInactiveAffs == 'yes'), ceVals);
		var rxList = utilSvc.aff.rxList(ceAffs);
		rxList.unshift('ALL');
		vm.RxMultiselect.list = vm.multiselectBuild(rxList, false);
		vm.multiselectReturnVisit(vm.RxMultiselect, '', q.RX.vals);
		vm.multiselectTitle(vm.RxMultiselect, true);
		q.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';

		// Status multi
		vm.multiselectReturnVisit(vm.StatusMultiselect, '', q.Status.vals);
		vm.multiselectTitle(vm.StatusMultiselect, true);
		q.Status.fail = vm.StatusMultiselect.vals.length < 1 ? 'yes' : 'no';

		// Activity multi
		vm.multiselectReturnVisit(vm.ActivityMultiselect, '', q.Activity.vals);
		vm.multiselectTitle(vm.ActivityMultiselect, true);
		q.Activity.fail = vm.ActivityMultiselect.vals.length < 1 ? 'yes' : 'no';

		// dates need to be re-hydrated from session storage (browser bug re-hydrates them as UTC string, not Date object)
		q.StartDate = validSvc.newPropDate(new Date(q.StartDate.val), new Date(q.StartDate.min), new Date(q.StartDate.max));
		q.EndDate = validSvc.newPropDate(new Date(q.EndDate.val), new Date(q.EndDate.min), new Date(q.EndDate.max));
		q.PatientDOB = loadPatientDOB(q.PatientDOB);

		return q;
	}

	function tabChange(newTab) {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		// all tabs work the same, use this switch for future
		switch(newTab) {
			case 'SUMMARY':
				break;
			case 'REF':
				break;
			case 'DOC':
				break;
			default:
				msgSvc.ok('refListCtl.tabChange', 'unknown tab name: ' + newTab);
		}

		vm.query = tabLoadQuery(newTab);
		vm.flt = vm.resetFilters(_tabInfo[newTab].flt);

		vm.activeTab = newTab;

		// fire date control event after widget scope is setup
		$timeout(function() {
			$scope.$broadcast('widget.input.date.range.mode', {uniqueId: vm.activeTab, mode: vm.query.DateRangeMode, keepDates: true});
		}, 200);				
	}


	/**
	 *    FILTER CHANGE
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {
			
			// filter values are stored inside table view columns
			if(vm.activeTab == 'REF') {
				vm.flt = vm.tblViewGetColumnFilterValues(vm.tblView.cols, vm.flt);
			}
			
			vm.tbl.DataItems = Array.isArray(vm.tbl.DataItems) ? vm.tbl.DataItems : [];
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			$scope.$broadcast('widget.paging', {
				uniqueId: vm.activeTab,
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					saveViewState(vm.activeTab, vm.query, vm.flt);
				}
			},1000);

		}, delayTime);

	}


	/**
	 *    QUERY SUBMIT
	 */

	function queryValid(tabName, q) {

		// trying a validation collector to avoid re-listing all properties
		var isValid = true,
			failTxt = '',
			optionChecked = false;

		function setFail(failState) {
			optionChecked = true;
			if(isValid) {
				isValid = !!!failState;
			}
			return !!failState ? 'yes' : 'no';
		}

		q.CE.vals = multiselectQueryVals(vm.CeMultiselect);
		q.CE.fail = setFail(q.CE.vals.length < 1);
		if (tabName == 'DOC' && multiAllChecked(vm.CeMultiselect)) {
			q.CE.vals = [];
		}
		q.RX.vals = multiselectQueryVals(vm.RxMultiselect);
		q.RX.fail = setFail(q.RX.vals.length < 1);
		optionChecked = false; // reset back to false after CE/RX

		// date is first search option
		if(q.DateRangeChk) {
			setFail(!q.DateRangeValid); // throw away value, not needed
		}

		q.Status.vals = _statusList.slice();
		q.Status.fail = '';
		if(tabName == 'REF' && q.Status.chk) {
			q.Status.vals = multiselectQueryVals(vm.StatusMultiselect);
			q.Status.fail = setFail(q.Status.vals.length < 1);
		}

		if(tabName == 'DOC' && q.Activity.chk) {
			q.Activity.vals = multiselectQueryVals(vm.ActivityMultiselect);
			q.Activity.fail = setFail(q.Activity.vals.length < 1);
		}

		// summary tab has no search options
		if(tabName == 'SUMMARY') {
			return isValid;
		}
		
		q.ItemCode.fail = '';
		if(q.ItemCode.chk) {

			// ndc format check
			var ndcTest = ndcCleanUp(q.ItemCode.val, false);
			q.ItemCode.val = ndcTest.val;
			failTxt = setFail(ndcTest.fail);
			q.ItemCode.fail = failTxt;
			q.ItemCode.msg = failTxt == 'yes' ? ndcTest.msg : '';
		}

		q.DrugType.fail = '';
		if(q.DrugType.chk) {
			failTxt = setFail(!validSvc.isText(q.DrugType.val));
			q.DrugType.fail = failTxt; 
			q.DrugType.msg = failTxt == 'yes' ? 'required, choose BRAND or GENERIC' : '';
		}

		q.Eligible.fail = '';
		if(q.Eligible.chk) {
			failTxt = setFail(!validSvc.isText(q.Eligible.val));
			q.Eligible.fail = failTxt;
			q.Eligible.msg = failTxt == 'yes' ? 'required, choose Yes or No' : '';
		}
  
		q.MinimumSavings.fail = '';
		if(q.MinimumSavings.chk) {
			var ms = parseFloat(q.MinimumSavings.val);
			var msOk = validSvc.isNumber(ms) && ms > 0 && ms <= 2500;
			failTxt = setFail(!msOk);
			q.MinimumSavings.fail = failTxt;
			q.MinimumSavings.msg = failTxt == 'yes' ? 'number greater than zero, less than 2500' : '';
		}
		
		q.PrescriberIdent.fail = '';
		if(q.PrescriberIdent.chk) {
			var npi = q.PrescriberIdent.val;
			var npiOk = validSvc.isText(npi) && validSvc.isInteger(npi) && npi.length == 10;
			failTxt = setFail(!npiOk);
			q.PrescriberIdent.fail = failTxt;
			q.PrescriberIdent.msg = failTxt == 'yes' ? 'must be a non-decimal number 10 digits' : '';
		}

		q.PatientLN.fail = '';
		if(q.PatientLN.chk) {
			var lname = q.PatientLN.val;
			var lnOk = validSvc.isText(lname) && lname.length > 0 && lname.length < 30;
			failTxt = setFail(!lnOk);
			q.PatientLN.fail = failTxt;
			q.PatientLN.msg = failTxt == 'yes' ? 'must be at least 1 character' : '';
		}

		q.PatientDOB.fail = '';
		if(q.PatientDOB.chk) {
			q.PatientDOB = validSvc.propDateValid(q.PatientDOB);
			q.PatientDOB.fail = setFail(q.PatientDOB.fail);
		}

		q.Fax.fail = '';
		if(q.Fax.chk) {
			q.Fax = validPhone(q.Fax);
			setFail(q.Fax.fail == 'yes');
		}

		// at least one option must be selected
		q.SearchOptionsRequired = validSvc.newProp();
		if(!optionChecked) {
			q.SearchOptionsRequired.fail = setFail(true);
			q.SearchOptionsRequired.msg = 'Choose at least one search option';
		}

		return isValid;
	}

	function docTabRefresh() {
		// called only when query is already valid
		if(vm.isWaiting || vm.activeTab != 'DOC') {
			return;
		}

		// reset tab if query is no longer valid
		if(!queryValid(vm.activeTab, vm.query)) {
			tabChange('DOC');
			return;
		}

		toggleWait(true);
		referralRepo.getList(vm.activeTab, vm.query).then(okSubmit, errSubmit);
	}

	function querySubmit() {
		if(vm.isWaiting || !validSvc.isText(vm.activeTab)) {
			return;
		}

		// validate
		if(!queryValid(vm.activeTab, vm.query)) {
			if(!vm.init) {
				msgSvc.ok('Search', 'Check filter settings');
			}
			return;
		}
		queryChange();
		toggleWait(true);

		vm.query.title = queryTitle();

		referralRepo.getList(vm.activeTab, vm.query).then(okSubmit, errSubmit);
	}
		
	function okSubmit(r) {
		toggleWait();			

		// query was good, save viewstate
		saveViewState(vm.activeTab, vm.query, vm.flt);

		switch(vm.activeTab) {
			case 'SUMMARY':
				vm.summary = summaryVM(r.Items);
				vm.chartSummary = chartSummaryVM(vm.summary);
				break;
			case 'REF':
				vm.tbl = referralsVM(r.Items, r.TooMany);
				vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);

				// update paging ui
				$scope.$broadcast('widget.paging', {
					uniqueId: vm.activeTab,
					Size: vm.flt.PageSize,
					Page: vm.flt.Page,
					Total: vm.flt.PageTotal,
					RowCount: vm.flt.Count,
					ItemCount: vm.tbl.Items.length,
					DataCount: vm.tbl.DataItems.length
				});

				tblViewReload(vm.query, false, true); // keep paging if possible
				vm.flt.Ready = true;
				break;

			case 'DOC':
				var ceVals = multiselectQueryVals(vm.CeMultiselect),
					rxVals = multiselectQueryVals(vm.RxMultiselect);
				$state.go('ops.referral.docs', {Docs: r.Items, CE:ceVals, RX:rxVals, ReferralCE: _referralCeList}, {reload: 'ops.referral.docs'});
				break;
			default:
				msgSvc.ok('refList.querySubmit, unknown tab: ' + vm.activeTab);
		}

		// slight pause to render collapsed query first
		vm.flex = vm.flexCollapse(vm.flex, true);
		$timeout(function(){
			vm.action = 'LIST';
			renderSummaryChart();
		},300);
	}
	
	function renderSummaryChart() {
		// render summary chart
		if(vm.activeTab == 'SUMMARY' && vm.chartSummary.data.length > 0) {
			$timeout(function() {
				var chart = vm.chartSummary;
				if(chart.data.length > 0) {
					chart.status = 'DRAW';
					$scope.$broadcast('widget.chart.sync', {
						uniqueId: chart.id,
						config: chart.config,
						data: chart.data,
						render: 'animate'
					});
				}
			},300);
		}
	}

	function errSubmit(r) {
		toggleWait();
		if(!!r) {
			errSvc.error('Unknown api error on tab: ' + vm.activeTab, 'referral.errSearch', r.status, utilSvc.http.safeResponse(r));
		}
	}
	

	/**
	 * 	POPUP
	 * 	used for both DETAIL and TBLVIEW
	 */

	function rowClick(item, evt) {
		// row click is Claim Detail or Activity Log click

		var elem = evt.target,
			className = '';

		// loop up to find td column parent
		while(!!elem) {

			if(!!elem.className) {
				// subscribe?
				className = elem.className;
				if(className.indexOf('click-last-activity') > -1) {
					elem = null;
					openPopup(item, 'LOG', evt);
					return;
				}
			}

			// td has no class, open detail
			if(!!elem.nodeName && elem.nodeName.toUpperCase() == 'TD') {
				elem = null;
				openPopup(item, 'DETAIL');
				return;
			}

			elem = elem.parentNode;
		}
		elem = null;
		
	}

	function openPopup(item, popType, evt) {
		// multi-use popup, all popups re-use: vm.popup / openPopup / closePopup

		if(vm.isWaiting) {
			return;
		}

		switch(popType) {
			case 'DETAIL':
				popDetail(item);
				break;
			case 'TBLVIEW':
				popTblView(vm.activeTab);
				break;
			case 'LOG':
				popLog(item, evt);
				break;
			default:
				throw new Error('refferalList.openPopup, unknown pop type: ' + popType);
		}
	}

	function popDetail(item) {
		// send list of visible table rows to suspect detail view

		if(!!!item || !validSvc.isText(item.uniqueId)) {
			throw new Error('referralListCtl.openPopup, item.uniqueId required');
		}

		vm.popup = {
			type: 'DETAIL',
			title: 'Referral Detail',
			ready: false
		};

		// build a 1 page list of suspect items
		vm.flt.Ready = false;
		var clickedId = item.uniqueId;

		// note: using 1,000,000 as page size so all items are returned and not reduced by the flt.PageSize
		var pgSize = vm.flt.PageSize;
		vm.flt.PageSize = 1000000;
		var newItems = vm.filterList(vm.tbl.DataItems, vm.flt);
		vm.flt.PageSize = pgSize;

		// build compact list to pass
		var idx = -1,
			passItems = [];
		for(var i = 0; i < newItems.length; i++) {
			passItems.push({
				CEID: newItems[i].CE,
				RXID: newItems[i].Pharmacy,
				DispId: newItems[i].DispId,
				SuspectType: 'REF'
			});
			if(newItems[i].uniqueId == clickedId) {
				// found id of item clicked
				idx = i;
			}
		}
		if(idx < 0) {
			throw new Error('referralListCtl.openPopup, suspect id not found in list filtered items: ' + clickedId);
		}

		$timeout(function() {
			vm.popup.ready = true;
			$state.go('ops.referral.detail', {Items: passItems, Idx: idx}, {reload: 'ops.referral.detail'});
		}, 200);
	}

	function popTblView(tabName) {
		vm.popup = {
			type: 'TBLVIEW',
			title: 'Table View Editor',
			ready: false
		};

		$scope.$broadcast('widget.tblview.editor', {
			uniqueId: tabName,
			config: vm.tblViewConfig
		});

		$timeout(function() {
			vm.popup.ready = true;
		}, 200);
	}

	function popLog(item, evt) {
		if(!!!item || !!!evt || !Array.isArray(item.ChangeLog)) {
			throw new Error('referralListCtl.openPopup popLog, item, click and log required');
		}

		vm.popup = {
			type: 'LOG',
			title: 'Activity Log',
			Items: item.ChangeLog,
			ready: false
		};

		// loop html element parents looking for popup container top
		// note: this is a scrollable table, reduce offset by amount the table is scrolled
		var elem = evt.target,
			scrollTopFound = false,
			offsetY = 30;
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
				break;
			}

			// scroll container found, reduce offset if this container is scrolled
			if(!scrollTopFound && !!elem.className && elem.className.indexOf('table-fixed-header-scroll') > -1) {
				scrollTopFound = true;
				offsetY -=  Math.floor(elem.scrollTop);
			}

			// add offset, get next element
			offsetY += elem.offsetTop;
			elem = elem.offsetParent;
		}
		elem = null;

		// move popup to clicked row
		var popContent = document.getElementById('referralPopupContentLOG');
		if(!!popContent) {
			popContent.style.top = offsetY.toString() + 'px';
		}

		$timeout(function() {
			vm.popup.ready = true;
		}, 200);
	}

	function closePopup() {
		var popType = vm.popup.type;
		vm.popup = {};

		// refresh list view coming back from detail view
		if(popType == 'DETAIL') {
			querySubmit();
		}
		else if(popType == 'TBLVIEW') {
			tblViewReload(vm.query, false, true); // re-init views, keep paging if possible
		}
	}


	/**
	 * 		TABLE VIEW
	 */

	function okCurrentTableView() {
		if(vm.action != 'LIST') {
			return;
		}

		var tvSaved = sessionRepo.get(vm.tblViewConfig.storageKey);
		if(!!tvSaved && !!vm.tblView && validSvc.isText(vm.tblView.current)) {
			tvSaved.current = vm.tblView.current;
			sessionRepo.set(vm.tblViewConfig.storageKey, tvSaved);
		}
	}

	function errCurrentTableView() {
		// do nothing
	}

	function tblViewReload(query, skipInitViews, fltKeepPaging) {

		if(!!!query) {
			return;
		}

		// init tblView with full view config
		if(!!!skipInitViews || !!!vm.tblView) {
			vm.tblView = vm.tblViewInit(vm.tblViewConfig, sessionRepo.get(vm.tblViewConfig.storageKey));
		}
		
		// reduce tblConfig based on query
		var tblConfig = tblViewConfigSetup(tblViewSchemaVM());

		// add column titles and filters
		vm.tblView = vm.tblViewLoadTitlesAndFilters(tblConfig, vm.tblView, vm.flt);
		
		// update table view bar
		$scope.$broadcast('widget.tblview', {
			uniqueId: vm.activeTab,
			current: vm.tblView.current,
			views: vm.tblView.views
		});

		if(!!vm.flt) {
			// remove any filter properties not shown in current table view
			vm.flt = vm.tblViewSyncFilter(tblConfig, vm.tblView, vm.flt, fltKeepPaging);
			filterChange(true);
		}
	}

	function tblViewSchemaVM() {
		// feature defined tables with all columns

		return {
			storageKey: 'tv-ops-referral-list',
			name: 'LIST',
			sortby: '-ServiceDate',
			pgsize: 50,
			sections: {
				Stat: {title:'Usage'},
				Suspect: {title:'Suspect'},
				DrugInfo: {title: 'Drug Info'},
				Pres: {title:  'Prescriber'},
				Disp: {title:  'Dispense'},
				EstPrice: {title:  'Est Pricing'},
				Pat: {title: 'Patient'}
			},
			cols: [
				{section:'Stat', 		flt:'Text',		edit: false, name:'LastActivity', colWidth:"40px", title:'Activity', desc:'Last Activity, view activity log and comments.'},
				{section:'Stat', 		flt:'Text',		edit: false, name:'ReferralStatus', colWidth:"40px", title:'Status', desc:'Referral Status'},
				{section:'Stat', 		flt:'Text',		default: false,  name:'FaxStatus', colWidth:"40px", title:'Fax Status', desc:'Fax Delivery Status'},
				
				{section:'Suspect', 	flt:'Text',		edit: false, name:'CE', colWidth:"45px", title:'CE', desc:'Dispensing Facility'},
				{section:'Suspect',		flt:'Text',		edit: false, name:'Pharmacy', colWidth:"45px", title:'Pharmacy', desc:'Dispensing Contract Pharmacy'},
				{section:'Suspect',		flt:'Text',		name:'Eligible', colWidth:"45px", title:'Eligible', desc:'Accumulation eligibility of match'},
				{section:'Suspect',		flt:'Text',		name:'Reason', colWidth:"50px", title:'Reason', desc:'If not blank, reason match is not eligible'},
				{section:'Suspect',		flt:'Text',		default:false, name:'OverrideTxt', colWidth:"25px", title:'Can Override', desc:'Indicates if suspect can be overridden to eligible'},
				//{section:'Suspect',		flt:'Dates',	default:false, name:'MatchedDate', colWidth:"40px", title:'Date', desc:'Date of encounter and dispense match'},

				{section:'DrugInfo',	flt:'Text',		name:'ItemCode', colWidth:"45px", title:'NDC', desc:'National Drug Code'},
				{section:'DrugInfo',	flt:'Text',		name:'VendorItemName', colWidth:"60px", title:'Vendor Item Name', desc:'Vendor drug description'},
				{section:'DrugInfo',	flt:'Text',		default: false, name:'Manufacturer', colWidth:"40px", title:'Manufacturer', desc:'Manufacturer'},
				{section:'DrugInfo',	flt:'Text',		default: false, name:'WholesaleUnits', colWidth:"30px", title:'Wholesale Units', desc:'Calculated as package size * case pack size'},
				{section:'DrugInfo',	flt:'Text',		default: false, name:'DrugType', colWidth:"30px", title:'Drug Type', desc:'Brand, Generic or Assay drug types'},
				//{section:'DrugInfo',	flt:'Numbers',	default: false, name:'WACPrice', colWidth:"30px", title:'WAC Price', desc:'MediSpan WAC price'},					

				{section:'Pres',		flt:'Text',		name:'ProviderNPI', colWidth:"45px", title:'NPI', desc:'Prescriber NPI'},
				{section:'Pres',		flt:'Text',		name:'ProviderName', colWidth:"50px", title:'Name', desc:'Prescriber Name'},
				{section:'Pres',		flt:'Text',		name:'ProviderTaxonomy', colWidth:"50px", title:'Taxonomy', desc:'Taxonomy'},
				
				{section:'Disp',		flt:'Text',		name:'RxNumberTxt', colWidth:"40px", title:'Rx #', desc:'Pharmacy Rx number'},
				{section:'Disp',		flt:'Dates',	name:'WrittenDate', colWidth:"45px", title:'Written', desc:'Date Rx was written'},
				{section:'Disp',		flt:'Dates',	name:'ServiceDate', colWidth:"45px", title:'Filled', desc:'Date Rx was filled (service date)'},
				{section:'Disp',		flt:'Numbers',	name:'FillNumber', colWidth:"25px", title:'Fill #', desc:'Rx fill number'},
				{section:'Disp',		flt:'Numbers',	name:'Quantity', colWidth:"40px", title:'Qty', desc:'Drug quantity dispensed'},
				{section:'Disp',		flt:'Text',		default:false, name:'BinPcnTxt', colWidth:"30px", title:'BIN PCN', desc:'Payor BIN, PCN and GROUP'},
				{section:'Disp',		flt:'Txt',		default:false, name:'Medicaid', colWidth:"30px", title:'Medicaid', desc:'Medicaid covered transaction'},
				{section:'Disp',		flt:'Numbers',	default:false, name:'TotalAmountPaid', colWidth:"40px", title:'Total Paid', desc:'Total customer payment'},
				{section:'Disp',		flt:'Text',		default: false, name:'Erx', colWidth:"25px", title:'eRx', desc:'Encounter is an electronic prescription'},
				{section:'Disp',		flt:'Text',		default: false, name:'CashCard', colWidth:"25px", title:'Care Card', desc:'Encounter is care card patient'},
				
				{section:'EstPrice',	flt:'Numbers',	default: false, name:'PharmacyPrice', colWidth:"40px", title:'Pharmacy Price', desc:'Pharmacy Price'},
				{section:'EstPrice',	flt:'Numbers',	default: false, name:'CEPrice', colWidth:"40px", title:'CE Price', desc:'CE Price'},
				{section:'EstPrice',	flt:'Numbers',	default: false, name:'DispenseFee', colWidth:"40px", title:'Dispense Fee', desc:'Dispense Fee'},
				{section:'EstPrice',	flt:'Numbers',	default: false, name:'OrderFee', colWidth:"40px", title:'Order Fee', desc:'Order Fee'},
				{section:'EstPrice',	flt:'Numbers',	default: false, name:'ReferralFee', colWidth:"40px", title:'Referral Fee', desc:'Referral Fee'},
				{section:'EstPrice',	flt:'Numbers',	name:'Savings', colWidth:"40px", title:'Savings', desc:'Savings'},
				{section:'EstPrice',	flt:'Numbers',	default: false, name:'Vendor', colWidth:"50px", title:'Vendor', desc:'Vendor'},
				
				{section:'Pat',			flt:'Text',		default:false, name:'PatientLN', colWidth:"40px", title:'Last', desc:'Patient Last Name'},
				{section:'Pat',			flt:'Text',		default:false, name:'PatientFN', colWidth:"40px", title:'First', desc:'Patient First Name'}
			]
		};
	}

	function tblViewConfigSetup(tblSchema) {
		// placeholder to convert generic view schema into user specific table configs

		var result = {},
			cols = tblSchema.cols,
			col = {},
			colKeys = {},
			colAllowed = [];

		for(var i = 0; i < cols.length; i++) {
			col = cols[i];

			// tbd... logic to drop columns based on user type, query, biz models, etc

			// keep column
			colAllowed.push(col.name);
			colKeys[col.name] = col;
		}

		// update columns for this table
		tblSchema.cols = colAllowed;
		tblSchema.colKeys = colKeys;
		
		return tblSchema;
	}


	/**
	 *    DATE PICKER
	 */
	function dtPickOpen(dtName) {

		if (dtName != 'PatientDOB') {
			alert('refList.dtPickOpen, name unknown: ' + dtName);
			return;
		}

		var dt = vm.query[dtName];
		vm.dtPickShow.pending = dtName;

		$scope.$broadcast('widget.input.date.pick', {
			uniqueId: dtName,
			setDate: dt.val,
			minDate: dt.min,
			maxDate: dt.max
		});

		$timeout(function () {
			if (validSvc.isText(vm.dtPickShow.pending)) {
				vm.dtPickShow[vm.dtPickShow.pending] = true;
			}
		}, 100);
	}


	/**
	 *  	SUMMARY CHART
	 */

	function resetChart(resetUI) {
		// reset SVG?
		if(!!resetUI && vm.chartSummary.status == 'DRAW') {
			$scope.$broadcast('widget.chart.sync', {uniqueId: vm.chartSummary.id, render: ''});
		}

		vm.chartSummary = initChart();
	}

	function initChart() {
		// minimum pie chart config
		// note: this is a slimmed down from full home page widgets
		return {
			id: 'SUMMARY',
			status: '',
			config: {
				chartType: 'PIE',
				colors: [],
				valFormat: 'number',
				donutHoleRadius: 0.4,
				label: {
					width: 50,
					height: 30
				}
			},
			text: {
				title: 'Activity'
			},
			data: [],
			legend: []
		};
	}

	function chartSummaryVM(sum) {
		// pie chart, parse data into pie chart format
		
		var colors = appConst.app.color.chart;
		var chart = initChart(),
			data = [],
			legend = [],
			wedgeConfig = [
				{name:'NEW', color:colors.gray}, 
				{name:'PENDING', color: colors.primaryDark}, 
				{name:'COMPLETE', color: colors.primary}, 
				{name:'REJECTED', color: colors.charcoal}
			];

		// no data?
		if(!!!sum) {
			return chart;
		}

		// helper to get pie wedge values from summary totals
		function getWedge(wedge) {
			var result = {
				name: wedge.name,
				val: 0,
				percent: 0,
				color: wedge.color
			};

			var val = 0,
				propName = wedge.name;
			if(!!sum[propName]) {
				// get count
				val = parseInt(sum[propName].Count);
				if(val > 0) {
					result.val = val;
				}
				// get percent
				val = parseInt(sum[propName].Percent);
				if(val > 0) {
					result.percent = val;
				}
			}
			return result;
		}
		
		// load pie wedges
		var wedge = {},
			totalPercent = 0;
		for(var i = 0; i < wedgeConfig.length; i++) {
			wedge = getWedge(wedgeConfig[i]);

			// add to pie chart if >0%
			if(wedge.percent > 0) {
				data.push(wedge);
				totalPercent += wedge.percent;
			}

			// add to legend if >0 count
			if(wedge.val > 0) {
				if(wedge.percent < 1) {
					wedge.color = 'transparent';
				}
				legend.push(JSON.parse(JSON.stringify(wedge))); // de-reference data and legend have same reference
			}
		}

		// no data?
		if(data.length < 1 || totalPercent <= 0) {
			return chart;
		}

		// sort and assign to chart
		chart.data = utilSvc.array.sortDSC(data, 'percent');
		chart.legend = utilSvc.array.sortDSC(legend, 'percent');
		
		// apply wedge colors to chart colors
		chart.config.colors = [];
		for(var c = 0; c < chart.data.length; c++) {
			chart.config.colors.push(chart.data[c].color);
		}

		// tweak percent totals to 100%
		var tweak = 100 - totalPercent;
		if(tweak !== 0) {
			// adjust biggest pie wedge (if all other pie wedges are less than zero)
			var biggestPie = chart.data[0].percent;
			if(biggestPie != totalPercent) {
				chart.data[0].percent += tweak;
				chart.legend[0].percent += tweak;
			}
		}

		return chart;
	}


	/**
	 * 		EXCEL
	 */

	function getExcel() {
		if(vm.isWaiting || vm.action != 'LIST') {
			return;
		}
		// validate
		if(!queryValid(vm.activeTab, vm.query)) {
			if(!vm.init) {
				msgSvc.ok('Search', 'Check filter settings');
			}
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		// match/suspect need table rows
		if(vm.tbl.DataItems.length < 1) {
			msgSvc.ok('No Records', 'Nothing to save for Excel.');
			return;
		}

		var ceTitle = vm.CeMultiselect.title;
		_pendingExcelFilename = 'Verity-' + ceTitle + '-Referral-List'; // tbd add CE/RX to file name + utilSvc.regex.cleanFilename(utilSvc.ng.droplistLabel(vm.PrimaryDroplist, vm.query.Primary.val));
	
		toggleWait(true);
		referralRepo.getExcel(vm.activeTab, vm.query, _pendingExcelFilename).then(okServerExcel, errServerExcel);
	}

	function okServerExcel(binaryData) {
		toggleWait();

		// convert binary stream to blob and save
		try {
			var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
			$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
		}
		catch(err) {
			throw(err);
		}
	}

	function errServerExcel(r) {
		toggleWait();

		if(!!r) {
			errSvc.warn('Create Excel Error', 'matchListCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    MULTISELECT HELPERS
	 */

    function multiToggle(evt, id) {
		switch(id) {
			case 'refListCeMulti':
				multiselectToggle(evt, vm.CeMultiselect, id);
				break;
			case 'refListRxMulti':
				multiselectToggle(evt, vm.RxMultiselect, id);
				break;
			case 'refListStatusMulti':
				multiselectToggle(evt, vm.StatusMultiselect, id);
				break;
			case 'refListActivityMulti':
				multiselectToggle(evt, vm.ActivityMultiselect, id);
				break;
			default:
				throw new Error('refList.multiToggle, unknown multi id: ' + id);
		}
	}

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if(vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		multiselect.flt = '';

		// don't bother with width if hiding
		if(multiselect.show) {
			multiselect.show = false;
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;

	}

	function multiHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}

	function multiselectQueryVals(multiselect) {

		// unpack the vals multiselect into a list of entities to query

		var checklist = multiselect.list,
			vals = multiselect.vals;

		if(vals.length < 1) {
			return [];
		}
		else if(vals.length === 1 && vals[0] == 'ALL') {
			// using ALL checkbox, return all values except ALL checkbox
			var result = [],
				i = checklist[0].val == 'ALL' ? 1 : 0;
			for(i; i < checklist.length; i++) {
				result.push(checklist[i].val);
			}
			return result;
		}
		else {
			return vals;
		}
	}

	//	HELPERS
	function toggleWait(isOn) {
		vm.isWaiting = !!isOn;
		msgSvc.wait(!!isOn);
	}

	function ndcCleanUp(val, skipEmpty) {

		var zeroPad = "00000000000",
			ndcTest = '';

		// must be text
		if(!!!skipEmpty && !validSvc.isText(val)) {
			return validSvc.newProp(val, true, 'required');
		}

		// remove all non-numeric characters
		ndcTest = val.toString().trim();
		ndcTest = ndcTest.replace(/[^0-9]+/g,'');

		// empty
		if(ndcTest.length < 1) {
			if(!!skipEmpty) {
				return validSvc.newProp('', false, '');
			}
			else {
				return validSvc.newProp(ndcTest, true, 'empty');
			}
		}

		// max len
		if(ndcTest.length > 11) {
			return validSvc.newProp(ndcTest, true, 'max 11 characters');
		}

		// integer
		var intVal = parseInt(ndcTest);
		if(!validSvc.isInteger(intVal)) {
			return validSvc.newProp(ndcTest, true, 'must be an integer');
		}

		// all zeros
		if(intVal <= 0) {
			return validSvc.newProp(ndcTest, true, 'cannot be zero');
		}

		// pad zeros if needed, pass
		ndcTest = zeroPad.substr(0, 11 - ndcTest.length) + ndcTest;
		return validSvc.newProp(ndcTest, false, '');
	}

	function queryTitle() {
		// helper to generate query title when flextop closed
		
		var title = '';

		// CE/RX titles to handle ALL value or NONE
		var ceTitle = vm.CeMultiselect.title;
		var rxTitle = vm.RxMultiselect.title;
		if(vm.CeMultiselect.vals.length > 1) {
			ceTitle = 'Facility: ' + ceTitle;
		}
		else if(vm.CeMultiselect.vals[0] == 'ALL') {
			ceTitle = 'All Facilities'; 
		}
		if(vm.RxMultiselect.vals.length > 1) {
			rxTitle = 'Pharmacy: ' + rxTitle;
		}
		else if(vm.RxMultiselect.vals[0] == 'ALL') {
			rxTitle = 'All Pharmacies'; 
		}
		
		return ceTitle + ' / ' + rxTitle;
	}

	function userFriendlyReasonText(apiState, apiStateReason) {

		// convert api state + reason into user friendly text

		switch(apiState) {

			case 'REVERSED':
				return apiState;

			case 'UNMATCHED':
				if(validSvc.isText(apiStateReason)) {
					return utilSvc.ng.droplistLabel(vm.EligibleDroplist, 'UNMATCHED-' + apiStateReason);
				}
				return 'UNMATCHED';

			case 'INELIGIBLE':
				if(validSvc.isText(apiStateReason)) {
					var eligTxt = utilSvc.ng.droplistLabel(vm.EligibleDroplist, 'INELIGIBLE-' + apiStateReason);
					if(validSvc.isText(eligTxt)) {
						return eligTxt;
					}
					return apiStateReason; // show state reason if it is not a searchable state reason
				}
				return ''; // hide INELIGIBLE state with no state reason

			default:
				return '';
		}
	}

	function dateTypeDisplayTxt(dtType, addSuffix) {
		var txt = '';
		switch(dtType) {
			case 'MATCH':
				txt = 'Matched';
				break;
			case 'SERVICE':
				txt = 'Filled';
				break;
			case 'RXWRITTEN':
				txt = 'Written';
				break;
			case 'RECEIVED':
				txt = 'Received';
				break;
			default:
				return '';
		}

		if(!!addSuffix) {
			txt += ' Date';
		}

		return txt;
	}

	function syncQueryToTabs(tabName, q) {
		// copy CE/RX to other tabs
		if(!vm.init && q.CE.fail == 'no' && q.RX.fail == 'no' && q.Sync == 'ON') {
			// do not sync if CE is set to All Options
			if(multiAllChecked(vm.CeMultiselect)) {
				return;
			}
			for(var prop in _tabInfo) {
				if(_tabInfo.hasOwnProperty(prop) && prop != tabName) {
					var tabQuery = _tabInfo[prop].query;
					if(tabQuery.Sync == 'ON') {
						tabQuery.CE.vals = q.CE.vals;
						tabQuery.RX.vals = q.RX.vals;
					}
				}
			}
		}
	}

	function multiAllChecked(multi) {
		var checklist = multi.list;
		return checklist.length > 0 && checklist[0].val == 'ALL' && checklist[0].checked;
	}

	function saveViewState(tab, query, flt) {
		if(vm.activeTab != tab || !!!query || !!!flt) {
			return;
		}

		// update current tab
		_tabInfo[tab].query = query;
		_tabInfo[tab].flt = flt;

		// store Multi with ALL values
		var tabQuery = _tabInfo[tab].query;
		tabQuery.CE.vals = multiAllChecked(vm.CeMultiselect) ? ['ALL'] : tabQuery.CE.vals;
		tabQuery.RX.vals = multiAllChecked(vm.RxMultiselect) ? ['ALL'] : tabQuery.RX.vals;
		tabQuery.Status.vals = multiAllChecked(vm.StatusMultiselect) ? ['ALL'] : tabQuery.Status.vals;
		tabQuery.Activity.vals = multiAllChecked(vm.ActivityMultiselect) ? ['ALL'] : tabQuery.Activity.vals;

		syncQueryToTabs(tab, query);

		sessionRepo.set('vs-ops-referral-list', {
			activeTab: tab,
			tabInfo: _tabInfo
		});
	}

	function validPhone(prop, notRequired) {
		prop.fail = 'yes';
		prop.msg = 'format expected: "123-456-7890"';

		// not required
		if(!!notRequired && !validSvc.isText(prop.val)) {
			prop.fail = 'no';
			prop.msg = '';
			return prop;
		}

		// is empty, not 12 chars, no dash at 3 or 7
		if(!validSvc.isText(prop.val) || prop.val.length != 12 || prop.val.indexOf('-') != 3 || prop.val.lastIndexOf('-') != 7) {
			return prop;
		}

		// strip down to numbers and dash
		prop.val.replace(/[^0-9\-]+/g,'');
		var phoneVals = prop.val.split('-');

		// area code
		if(phoneVals[0].length != 3 || isNaN(phoneVals[0])) {
			prop.msg = 'area code must be numbers';
			return prop;
		}

		// second 3 digits
		if(phoneVals[1].length != 3 || isNaN(phoneVals[1])) {
			prop.msg = 'second 3 digits must be numbers';
			return prop;
		}

		// last 4 digits
		if(phoneVals[2].length != 4 || isNaN(phoneVals[2])) {
			prop.msg = 'last 4 digits must be numbers';
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;
	}

	function parsePhone(val) {
		if(!validSvc.isText(val)) {
			return '';
		}

		// get string with only numbers
		val = val.toString().replace(/\D/g, '');
	
		// convert val to phone format "123-456-7890"
		// note: build number starting with area code first, this supports < 10 digit numbers
		var result = '';
		if(val.length >= 3) {
			result = val.substring(0, 3);
		}
		if(val.length > 3) {
			result += '-' + val.substring(3, 6);
		}
		if(val.length > 6) {
			result += '-' + val.substring(6, 10);
		}

		return result;
	}

}
 
splittransRepo.$inject = ['$rootScope', '$q', 'apiService', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
.module('espui.ops')
.factory('splittransRepo', splittransRepo);


/* @ngInject */
function splittransRepo($rootScope, $q, apiService, errSvc, eventSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _currentPurl = '',
		_apiPaging = vmSvc.api.paging(),
		_pendingQuery,
		_listViewState = null;

	// service definition
	var service = {
		queryVM: queryVM,

		getList: getList,
		getExcel: getExcel,

		adtResolveStatus: adtResolveStatus,

		transactionReject: transactionReject

	};

	return service;


	/**
	 *    QUERY
	 */

	function queryVM() {

		return {
			CE: validSvc.newProp($rootScope.User.CE),
			RX: validSvc.newProp($rootScope.User.RX),
			AccumGrp: 'ALL',
			StartDate: validSvc.newPropDateNull(),
			EndDate: validSvc.newPropDateNull(),
			ReturnMatch: 'no'
		};

	}


	/**
	 *    GET LIST
	 */

	function validAccumGrp(acct) {
		if(acct === 'ALL' || acct === '340B' || acct === 'GPO' || acct === 'WAC') {
			return true;
		}
		else {
			return false;
		}
	}

	function getList(tab, query) {

		// params
		if(!validSvc.isCE(query.CE.val) || (tab != 'TRANS' && tab != 'REVIEW')) {
			throw new Error('splittransRepo.getList, CE required, tab must be TRANS or REVIEW');
		}

		_currentPurl = tab == 'TRANS' ? 'ops/splittrans/list' : 'ops/splittrans/review';
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [query.CE.val],
				RXID: []
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val
			},
			Paging: {
				Page: 1,
				Size: 20000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('-TransDate')]
		};

		// TRANS has extra props
		if(tab == 'TRANS') {
			apiRequest.Context.RXID.push(query.RX.val);
			apiRequest.Params.ReturnMatched = query.ReturnMatch == 'yes';
			apiRequest.Params.AccumGrp = query.AccumGrp == 'ALL' ? '' : query.AccumGrp;
		}

		// save list query
		_pendingQuery = {
			CE: query.CE.val,
			RX: query.RX.val
		};

		apiService.post(_currentPurl, apiRequest).then(okGetList, errGetList);

		function okGetList(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update CE and Rx user choice
			eventSvc.rootEmit('context.change', {
				CE: _pendingQuery.CE,
				RX: _pendingQuery.RX
			});

			defer.resolve({
				Items: r.data.Entity,
				TooMany: r.data.Paging.Size > 20000
			});

		}

		function errGetList(r) {
			if(r !== null) {
				r = r || {status: ''};
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 * 	ADT RESOLVE STATUS
	 */

	function adtResolveStatus(ceid, id, status, note) {

		// params
		if(!validSvc.isCE(ceid) || !validSvc.isText(id) || !validSvc.isText(status)) {
			throw new Error('splittransRepo.adtResolveStatus, ceid / id / status required');
		}

		var defer = $q.defer();
		_currentPurl = 'ops/splittrans/updatepatientstatus';

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid]
			},
			Entity: {
				Params: {
					Id: id,
					AccumGrp: status == 'OUTPATIENT' ? '340B' : 'GPO',
					Note: note
				}
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okAdtResolve, errAdtResolve);

		function okAdtResolve(r) {

			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errAdtResolve(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status === 422) {

				r.msg = 'unkown api error';

				var rdat = r.data;
				if(!!rdat && !!rdat.Entity && Array.isArray(rdat.Entity.ROOT) && rdat.Entity.ROOT.length > 0) {
					r.msg = rdat.Entity.ROOT.join(', ');
				}

				defer.reject(r);
			}
			else {
				throw new Error('splittransRepo.errAdtResolve, ' + utilSvc.http.safeResponse(r));
			}
		}

		return defer.promise;

	}


	/**
	 *    GET EXCEL
	 *    file created on api server, expecting a binary file stream instead of JSON
	 */

	function getExcel(query, filename) {

		// params
		if(!validSvc.isRX(query.RX.val) || !validSvc.isCE(query.CE.val) || !validAccumGrp(query.AccumGrp) || !validSvc.isText(filename)) {
			throw new Error('splittransRepo.getExcel, RX/CE, AccumGrp and filename are required');
		}

		_currentPurl = 'ops/splittrans/excel';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {
				CEID: [query.CE.val],
				RXID: [query.RX.val]
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				AccumGrp: query.AccumGrp,
				Filename: filename
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('ServerExcel')]
		};

		// call api
		apiService.postGetBinary(_currentPurl, apiReqest).then(okGetExcel, errGetExcel);

		function okGetExcel(r) {
			defer.resolve(r.data);
		}

		function errGetExcel(r) {
			if(r !== null) {
				r = r || {};
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}
	/*
	* REJECT TRANSACTION
	*/
	function transactionReject(id, notes) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('splitRepo.transactionReject, id missing');
		}

		// create api request
		var apiRequest = {
			Params: {
				Id: id,
				Notes: notes
			}
		};

		var defer = $q.defer();
		_currentPurl = 'ops/splittrans/reject';

		// call api
		apiService.post(_currentPurl, apiRequest).then(okResolve, errResolve);

		function okResolve(r) {

			// bad "Get One" response format
			if (!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errResolve(r) {
			if (r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	
	}
}
 
splitTransListCtl.$inject = ['$window', '$state', '$scope', '$timeout', '$filter', 'splittransRepo', 'lookupRepo', 'sessionRepo', 'msgSvc', 'utilSvc', 'validSvc', 'errSvc'];
angular
.module('espui.ops')
.controller('SplitTransListCtl', splitTransListCtl);


/* @ngInject */
function splitTransListCtl($window, $state, $scope, $timeout, $filter, splittransRepo, lookupRepo, sessionRepo, msgSvc, utilSvc, validSvc, errSvc) {

	/*jshint validthis: true */
	var vm = this,
		_pendingExcelFilename = '',
		_featureName = '',
		_pagingEventListener = null,
		_returnVisit = false,
		_tabFilters = {},
		_reviewCeList = [];

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addFlexTop(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.canEdit = false;

	// CE/RXVEN droplists
	vm.CeDroplist = [];
	vm.RxDroplist = [];
	vm.AccumGrpDroplist = [];

	// query
	vm.query = {};
	vm.queryChangeRX = queryChangeRX;
	vm.queryChangeCE = queryChangeCE;
	vm.dateRangeChange = dateRangeChange;
	vm.queryChangeReturnMatch = queryChangeReturnMatch;
	vm.querySubmit = querySubmit;

	// table, filters
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;

	// tabs
	vm.activeTab = '';
	vm.tabChange = tabChange;

	// popup
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;
	vm.adtSetStatus = adtSetStatus;

	// REJECT
	vm.transactionReject = transactionReject;

	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		_featureName = $state.current.name;
		vm.canEdit = utilSvc.user.hasFeature($scope, 'ops.splittrans.edit');

		vm.init = true;

		vm.query = initQueryAndDroplists();
		vm.activeTab = initTabsAndFilters(vm.query);
		vm.flt = vm.resetFilters(_tabFilters[vm.activeTab]);

		// build list of all CE with Adt validation
		$timeout(function() {
			lookupRepo.CeInfo(utilSvc.aff.ceList(getAffs())).then(okLookup, errLookup);
		}, 100);

	}

	function okLookup(r) {

		// create list of CEs with validated status

		_reviewCeList = [];
		var item = {};
		for(var i = 0; i < r.length; i++) {
			item = r[i];
			if(!!item.AdtConfigStatus && !!item.AdtConfigStatus.ValidateSplitTrans) {
				_reviewCeList.push(item.NickName);
			}
		}

		queryChangeCE();
	}

	function errLookup(r) {
		if(!!r) {
			throw new Error('splitTransListCtl.errLookup, CE lookup failed, cannot load Split Trans feature');
		}
	}

	function getAffs() {
		var affs = utilSvc.aff.findStatus($scope.User.AffList);
		return utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));
	}

	function initTabFilters() {
		return {
			'TRANS': vm.initFilters({
				Config: {
					Dates: ['TransDate'],
					DateFmt: 'M/d/yyyy h:mm a'
				},
				SortBy: ['-TransDate']
			}),
			'REVIEW': vm.initFilters({
				Config: {
					Dates: ['TransDate'],
					DateFmt: 'M/d/yyyy h:mm a'
				},
				SortBy: ['-TransDate']
			})
		};
	}

	function initQueryAndDroplists() {

		var q = splittransRepo.queryVM();

		// date range (only monthly or less)
		// add CUSTOM30 (its not in the default list)
		q.DateRangeValid = false;
		q.DateRangeList = utilSvc.widget.dateRangeList(['QTD','QTR','QTDLAST','CUSTOM92']);
		q.DateRangeList.push({label: 'Custom Date Range (30 day max)', value: 'CUSTOM30'});
		q.DateRangeMode = 'MTD';

		// CE auto-select
		vm.CeDroplist = utilSvc.aff.ceDroplist(getAffs());
		q.CE = utilSvc.ng.droplistAutoselect(vm.CeDroplist, q.CE.val);

		// AccumGrp options (always the same for splitting)
		vm.AccumGrpDroplist = utilSvc.ng.droplist(['ALL', '340B', 'GPO', 'WAC'], '', '');

		return q;
	}

	function initTabsAndFilters(q) {

		var tabResult = 'TRANS';

		var vs = sessionRepo.get('vs-ops-splittrans', {CE:vm.query.CE.val});
		if(!!vs) {

			_returnVisit = true;
			tabResult = vs.activeTab;

			// query
			var vsq = vs.query;
			q.RX = validSvc.newProp(vsq.RX);
			q.AccumGrp = vsq.AccumGrp;
			q.StartDate.val = new Date(vsq.StartDate);
			q.EndDate.val = new Date(vsq.EndDate);
			q.DateRangeMode = vsq.DateRangeMode;
			q.DateRangeValid = true;
			q.ReturnMatch = vsq.ReturnMatch;

			// filters
			_tabFilters = vs.flt;
		}
		else {
			_tabFilters = initTabFilters();
		}

		return tabResult;

	}


	/**
	 *    DISPLAY VIEW MODEL
	 */

	function displayVM(dataItems, tooMany) {

		// convert data model into display properties

		var items = Array.isArray(dataItems) ? dataItems : [],
			item = {},
			isReviewEdit = vm.activeTab == 'REVIEW' && vm.canEdit;

		for(var i = 0; i < items.length; i++) {
			item = items[i];

			// biz time!
			item.TransDate = utilSvc.dt.toBizTime(item.TransDate);

			// review editing
			if(isReviewEdit && (item.AdtValidation == 'ADT_NOTFOUND' || item.AdtValidation == 'ADT_CONFLICT')) {
				item.canReview = true;
			}
		}

		return {
			DataItems: items,
			Items: [], // loaded by filterChange()
			TooMany: !!tooMany
		};

	}


	/**
	 *    QUERY CHANGE EVENTS
	 */

	function queryChange() {
		if(!vm.init) {
			vm.action = '';
			vm.popup = {};
			vm.tbl = {};
			vm.flt = vm.resetFilters(vm.flt);
			$scope.$broadcast('widget.paging');
		}
	}

	function tabChange(newTab) {

		if(vm.isWaiting) {
			return;
		}

		queryChange();
		vm.activeTab = newTab;

		vm.flt = vm.resetFilters(_tabFilters[newTab]);

		if(vm.init) {
			$timeout(function() {
				$scope.$broadcast('widget.input.date.range.mode', {mode: vm.query.DateRangeMode, keepDates: _returnVisit});
			},200);
		}
	}

	function queryChangeCE() {

		queryChange();
		vm.RxDroplist = utilSvc.ng.droplistNONE();

		// valid CE
		var q = vm.query;
		q.hasReview = false;
		q.CE.fail = validSvc.isCE(q.CE.val) ? 'no' : 'yes';
		if(q.CE.fail == 'yes') {
			q.RX = validSvc.newProp('NONE');
			q.AccumGrp = 'ALL';
			return;
		}
		q.hasReview = _reviewCeList.indexOf(q.CE.val) > -1;

		// RX options
		vm.RxDroplist = utilSvc.aff.rxDroplist(getAffs(), q.CE.val);
		q.RX = utilSvc.ng.droplistAutoselect(vm.RxDroplist, q.RX.val);
		queryChangeRX();

		tabChange(vm.activeTab);
	}

	function queryChangeRX() {

		queryChange();

		vm.query.RX.fail = validSvc.isRX(vm.query.RX.val) ? 'no' : 'yes';
		if(vm.query.RX.fail == 'yes') {
			vm.query.AccumGrp = 'ALL';
		}

	}

	function dateRangeChange(dtMode, isValid) {

		queryChange();
		vm.init = false;

		vm.query.DateRangeMode = dtMode;
		vm.query.DateRangeValid = isValid;

		if(_returnVisit) {
			_returnVisit = false;
			querySubmit();
		}

	}

	function queryChangeReturnMatch() {
		queryChange();
	}

	function queryValid() {

		// validate query data before calling api

		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';

		if(vm.activeTab == 'TRANS') {
			vm.query.RX.fail = validSvc.isRX(vm.query.RX.val) ? 'no' : 'yes';
		}

		return vm.query.CE.fail == 'no' && vm.query.RX.fail != 'yes' && !!vm.query.DateRangeValid;

	}

	function querySubmit() {

		// request query valid
		if(!queryValid()) {
			if(!vm.init) {
				msgSvc.ok('Search', 'Check filter properties');
			}
			return;
		}

		// exit if waiting
		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true);
		queryChange();

		splittransRepo.getList(vm.activeTab, vm.query).then(okGetList, errGetList);

		function okGetList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// query was good, save viewstate
			saveViewState(vm.activeTab, vm.query, vm.flt);

			vm.tbl = displayVM(r.Items, r.TooMany);
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			vm.flt.Ready = true;
			vm.action = 'LIST';

		}

		function errGetList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Unknown get response', 'splitTransListCtl.errGetList', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    GLOBAL GREASE COLUMN FILTERS
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					//console.log('filter change save viewstate');
					saveViewState(vm.activeTab, vm.query, vm.flt);
				}
			},1000);

		}, delayTime);

	}


	/**
	 *    POPUP
	 */

	function closePopup() {
		vm.popup = {};
	}	

	function openPopup(evt, item, popType) {

		if (vm.isWaiting) {
			return;
		}

		var popTitle = '';
		var popupContentId = 'stListPopupContent';
		switch (popType) {
			case 'ADT':
				popTitle = 'ADT Patient Status ';
				popTitle += item.AdtValidation == 'ADT_NOTFOUND' ? 'Not Found' : 'Conflict';

				vm.popup = {
					ready: false,
					id: item.Id,
					title: popTitle,
					TranAccumGrp: item.AccumGrp,
					TranStatus: item.AccumGrp == '340B' ? 'OUTPATIENT' : 'INPATIENT',
					InverseAccumGrp: item.AccumGrp == '340B' ? 'GPO' : '340B',
					InverseStatus: item.AccumGrp == '340B' ? 'INPATIENT' : 'OUTPATIENT',
					UserChoice: '',
					type: popType
				};
				break;
			case 'REJECT':
				popTitle = 'Transaction Rejection';
				if (!!item.Rejected) {
					popTitle = 'Rejected Transaction';
				}
				popupContentId = 'rejectPopupContent';
				vm.popup = {
					ready: false,
					id: item.Id,
					title: popTitle,
					RejectionBy: item.RejectionBy,
					RejectionDate: item.RejectionDate,
					RejectionNotes: item.RejectionNotes,
					type: popType
				};
				break;
			default:
				alert('unknown popup type: ' + popType);
		}
		
		// loop html elements back to top of table
		var elem = evt.target,
			offsetY = -100;
		while (!!elem) {

			// top element found
			if (!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
				break;
			}

			// add offset, get next element
			offsetY += elem.offsetTop;
			elem = elem.offsetParent;
		}
		elem = null;

		// move popup to clicked row
		var popup = document.getElementById(popupContentId);
		if (!!popup) {
			popup.style.top = offsetY.toString() + 'px';
		}

		// wait for digest before showing
		$timeout(function () {
			vm.popup.ready = true;
		}, 100);

	}

	function adtSetStatus() {

		if(vm.isWaiting) {
			return;
		}

		var pop = vm.popup;

		switch(pop.UserChoice) {
			case 'TRAN':
				pop.pending = {
					title: 'Keep Transaction Patient Status',
					stat: pop.TranStatus,
					group: pop.TranAccumGrp,
					msg: 'Keep ' + pop.TranStatus + '(' + pop.TranAccumGrp + ') Status'
				};
				break;
			case 'INVERSE':
				pop.pending = {
					title: 'Change Patient Status',
					stat: pop.InverseStatus,
					group: pop.InverseAccumGrp,
					msg: 'Change to ' + pop.InverseStatus + '(' + pop.InverseAccumGrp + ') Status'
				};
				break;
			default:
				msgSvc.ok('Choose a Status Option');
				return;
		}

		msgSvc.confirm({
			id: 'splittrans.review.adt',
			title: pop.pending.title,
			msg: pop.pending.msg + '?',
			notes: {
				prompt: 'optional notes',
				maxlength: 100
			},
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(setStatusConfirm, setStatusConfirm);

	}

	function setStatusConfirm(r) {

		// user said yes
		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;
			var nt = validSvc.isText(r.notes) ? r.notes : '';
			splittransRepo.adtResolveStatus(vm.query.CE.val, vm.popup.id, vm.popup.pending.stat, nt).then(okStatus, errStatus);
		}

	}

	function okStatus(r) {
		vm.isWaiting = false;
		querySubmit();
	}

	function errStatus(r) {
		vm.isWaiting = false;

		if(!!!r) {
			// already handled
		}
		else if(r.status == 422) {
			msgSvc.ok('Cannot Change Status', r.msg);
		}
		else {
			errSvc.error('Unknown status change error', 'splittransListCtl.errStatus', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 * REJECT
	 */
	function transactionReject(item) {

		if(vm.isWaiting) {
			return;
		}

		msgSvc.confirm({
			id: item.Id,
			title: 'REJECT TRANSACTION',
			msg: 'Do you want to reject this transaction? Any accumulations will be reversed and cannot be undone',
			notes: {
				prompt: 'optional notes',
				maxlength: 100
			},
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(transactionRejectConfirm, transactionRejectConfirm);

		function transactionRejectConfirm(r) {

			// user said yes
			if (!!r && r.result == 'YES') {
				vm.isWaiting = true;
				var nt = validSvc.isText(r.notes) ? r.notes : '';
				splittransRepo.transactionReject(item.Id, nt).then(okStatus, errStatus);
			}

		}

		function okStatus(r) {
			vm.isWaiting = false;
			querySubmit();
		}

		function errStatus(r) {
			vm.isWaiting = false;

			if (!!!r) {
				// already handled
			}
			else if (r.status == 422) {
				msgSvc.ok('Could not reject transaction', r.msg);
			}
			else {
				errSvc.error('Unknown status change error', 'splittransListCtl.errStatus', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}
	/**
	 *    EXCEL
	 *    get file from server
	 */

	function getExcel() {

		// already working?
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		var rxName = utilSvc.aff.rxShortNameById($scope.User.AffList, vm.query.RX.val);
		_pendingExcelFilename = 'Verity-' + vm.query.CE.val + '-' + rxName + '-Split-Trans.xlsx';
		splittransRepo.getExcel(vm.query, _pendingExcelFilename).then(okServerExcel, errServerExcel);

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r !== null) {
				r = r || {};
				errSvc.warn('Create Excel Error', 'splitTransListCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    HELPERS
	 */

	function saveViewState(tab, query, flt) {

		_tabFilters[tab] = flt;

		sessionRepo.set('vs-ops-splittrans', {
			activeTab: tab,
			ctx: {
				CE: query.CE.val
			},
			query: {
				RX: query.RX.val,
				AccumGrp: vm.query.AccumGrp,
				DateRangeMode: query.DateRangeMode,
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				ReturnMatch: vm.query.ReturnMatch
			},
			flt: _tabFilters
		});

	}

}
 
transformRepo.$inject = ['$rootScope', '$q', '$window', 'apiService', 'apiErrors', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
.module('espui.ops')
.factory('transformRepo', transformRepo);


/* @ngInject */
function transformRepo($rootScope, $q, $window, apiService, apiErrors, errSvc, eventSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _currentPurl = '',
		_apiPaging = vmSvc.api.paging(),
		_pending = {},
		_pendingNdc = {};

	// service definition
	var service = {
		contextVM: contextVM,

		// queries
		getList: getList,
		getUnknownList: getUnknownList,
		getIgnoredList: getIgnoredList,
		getNoMapList: getNoMapList,

		// intervals
		itvAdd: itvAdd,
		itvUpdateXrefs: itvUpdateXrefs,
		itvUpdateDates: itvUpdateDates,

		// transforms
		tfmGet: tfmGet,
		tfmGetByDeepLink: tfmGetByDeepLink,
		tfmAdd: tfmAdd,
		tfmUpdate: tfmUpdate,
		tfmRemove: tfmRemove,
		tfmImport: tfmImport,
		tfmConvertToCompound: tfmConvertToCompound,
		tfmStatusToggle: tfmStatusToggle,

		// unknowns
		ukGetDetail: ukGetDetail,
		igGetDetail: igGetDetail,
		ignoreCode: ignoreCode,
		igUpdate: igUpdate,

		// excel export
		excelAllTabs: excelAllTabs,
		migImport: migImport

	};

	return service;


	/**
	 *    VIEW MODELS
	 */

	function contextVM() {

		var uType = $rootScope.User.Type;

		var dtToday = utilSvc.dt.zeroTime(new Date()),
			dtMin = utilSvc.dt.zeroTime(utilSvc.dt.addDays(new Date(), (-3650))); // 10 years days back from today

		return {
			userType: uType,
			isVerityUser: uType == 'VERITYSA' || uType == 'VERITY',
			isDebug: $rootScope.debug,
			RX: validSvc.newProp(validSvc.isRX($rootScope.User.RX) ? $rootScope.User.RX : 'NONE'),
			StartDate: validSvc.newPropDate(dtMin, dtMin, dtToday),
			EndDate: validSvc.newPropDate(dtToday, dtMin, dtToday),
			InBound: validSvc.newProp(''),
			CrossRef: validSvc.newProp(''),
			claimCreate: false,
			claimUpdate: false,
			claimConvertUnknown: false,
			claimConvertIgnore: false,
			claimImport: false,
			groupEdit: 'no'
		};

	}

	function modelVM(data) {

		data = Array.isArray(data) ? data : [];

		/*
		for(var i = 0; i < data.length; i++) {

			// fix name
			if(!validSvc.isText(data[i].Name)) {
				data[i].Name = '';
			}

			// fix server null dates
			if(utilSvc.dt.isNull(data[i].StartDate)) {
				data[i].StartDate = null;
			}
			if(utilSvc.dt.isNull(data[i].EndDate)) {
				data[i].EndDate = null;
			}
			if(utilSvc.dt.isNull(data[i].ProcessDate)) {
				data[i].ProcessDate = null;
			}

			// reformat resident status
			data[i].Resident = !!data[i].Resident ? 'YES' : 'NO';

		}
		*/

		return data;

	}


	/**
	 *    API REQUEST VIEW MODEL
	 *    translate from ui to api request format
	 */

	function apiRequestVM(rxid, tfmModel, itvModel, groupConfirmed, group) {

		// params
		if(!validSvc.isRX(rxid) || !!!tfmModel || !!!itvModel) {
			throw new Error('transformRepo.apiRequestVM, rxid or tfm model or itv model is missing for RX: ' + rxid);
		}

		var apiRequest = {
			Context: {
				RXID: [rxid]
			},
			Entity: {
				Params: {
					PreviousStatus: tfmModel.PreviousStatus == 'IGNORED' ? 'IGNORE' : tfmModel.PreviousStatus,
					// either the single adjustment is confiremd or the list pharmacies affected by the change is confirmed
					Confirmed: tfmModel.Confirmed || groupConfirmed,
					TransformId: tfmModel.Id,
					TransformType: tfmModel.TransformType == 'IGNORED' ? 'IGNORE' : tfmModel.TransformType,
					ItemCodeType: validSvc.isText(tfmModel.ItemCodeType) ? tfmModel.ItemCodeType : '',
					ItemCode: tfmModel.ItemCode.val,
					Desc: tfmModel.Description.val,
					IntervalId: itvModel.Id,
					StartDate: utilSvc.dt.toServerDate(itvModel.StartDate.val),
					EndDate: utilSvc.dt.toServerDate(itvModel.EndDate.val),
					Transforms: [],
					Group: group == 'yes'
				}
			}
		};

		// unwrap outbound transforms
		var tfms = [];
		for (var i = 0; i < itvModel.Transforms.length; i++) {
			tfms.push({
				NDC: itvModel.Transforms[i].NDC.val,
				Multiplier: itvModel.Transforms[i].Multiplier.val
			});
		}
		apiRequest.Entity.Params.Transforms = tfms;

		// inteval edits include a user entered change note
		// put this note in the transform Description property (override)
		if(validSvc.isText(itvModel.ChangeNotes)) {
			apiRequest.Entity.Params.Desc = itvModel.ChangeNotes;
		}

		return apiRequest;

	}


	/**
	 *    GET LIST
	 */

	function getList(rxid) {
		// get list of TRANSFORM/COMPOUND types
		return sharedGetList('ops/transform/list', rxid, {});
	}

	function getUnknownList(rxid) {
		return sharedGetList('ops/transform/unknown/list', rxid, {});
	}

	function getIgnoredList(rxid) {
		return sharedGetList('ops/transform/ignore/list', rxid, {});
	}

	function sharedGetList(purl, rxid, params) {

		// params
		if(!validSvc.isRX(rxid) || !!!params) {
			throw new Error('transformRepo.sharedGetList, rxid is missing: ' + rxid);
		}

		var defer = $q.defer();
		_currentPurl = purl;

		// create api request
		var apiRequest = {
			Context: {
				RXID: [rxid]
			},
			Entity: {
				Params: params
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('ItemCode')]
		};

		// save RX user choice
		_pending = {RX: rxid};

		apiService.post(_currentPurl, apiRequest).then(okGetList, errGetList);

		function okGetList(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update user CE choice
			eventSvc.rootEmit('context.change', {
				CE: $rootScope.User.CE,
				RX: _pending.RX
			});

			// return transform list
			defer.resolve(r.data.Entity);

		}

		function errGetList(r) {

			if(r !== null) {
				r = r || {};
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);

		}

		return defer.promise;

	}


	/**
	 *    NO MAP
	 */

	function getNoMapList(rxid, dtStart, dtEnd) {

		// params
		if(!validSvc.isRX(rxid)) {
			throw new Error('transformRepo.getNoMapList, rxid is missing: ' + rxid);
		}

		var defer = $q.defer();
		_currentPurl = 'ops/transform/unmapped/list';

		// create api request
		var apiRequest = {
			Context: {
				RXID: [rxid]
			},
			Entity: {
				Params: {
					StartDate: dtStart,
					EndDate: dtEnd
				}
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('NDC')]
		};

		// save RX user choice
		_pending = {RX: rxid};

		apiService.post(_currentPurl, apiRequest).then(okNoMapList, errNoMapList);

		function okNoMapList(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update user CE choice
			eventSvc.rootEmit('context.change', {
				RX: _pending.RX
			});

			defer.resolve(r.data.Entity);

		}

		function errNoMapList(r) {

			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);

		}

		return defer.promise;

	}


	/**
	 *    GET TRANSFORM BY TRANSFORM ID
	 */

	function tfmGetByDeepLink(rxid, ndc, transid) {

		// 1. get mapping list first
		// 2. search for ndc or transid in list results
		// 3. get transform by Id

		if(!validSvc.isText(rxid) || !validSvc.isText(ndc)) {
			throw new Error('tfmRepo.tfmGetByTransId, rxid or ndc is missing');
		}

		_pendingNdc = {
			rxid: rxid,
		};

		var defer = $q.defer();

		sharedGetList('ops/transform/list', rxid, {}).then(okGetTfmByTransId, errGetTfmByTransId);

		function okGetTfmByTransId(r) {

			// find transform in list
			var items = Array.isArray(r) ? r : [],
				foundId = null;
			for (var i = 0; i < items.length; i++) {
				// if transform id exists, match with transform id
				if (!!transid) {
					if (transid == items[i].Id) {
						foundId = items[i].Id;
					}
				} else {
					if (ndc == items[i].ItemCode) {
						foundId = items[i].Id;
					}
				}
			}

			// not found
			if(foundId === null) {
				defer.resolve(null);
				return;
			}

			// get transform details
			sharedGet('ops/transform/get', _pendingNdc.rxid, {TransformId: foundId}).then(okGetTfmNdc, errGetTfmByTransId);

		}

		function okGetTfmNdc(r) {
			defer.resolve(r);
		}

		function errGetTfmByTransId(r) {

			if(r !== null) {
				r = r || {};
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);

		}

		return defer.promise;

	}

	function tfmGet(rxid, tfmId) {

		if(!validSvc.isText(tfmId)) {
			throw new Error('tfmRepo.tfmGet, transform id is missing');
		}

		return sharedGet('ops/transform/get', rxid, {TransformId: tfmId});
	}

	function ukGetDetail(rxid, ukId) {

		if(!validSvc.isText(ukId)) {
			throw new Error('tfmRepo.ukGetDetail, unknown id is missing');
		}

		return sharedGet('ops/transform/unknown/get', rxid, {ItemCode: ukId});
	}

	function igGetDetail(rxid, igId) {

		if(!validSvc.isText(igId)) {
			throw new Error('tfmRepo.igGetDetail, ignore id is missing');
		}

		return sharedGet('ops/transform/ignore/get', rxid, {ItemCode: igId});
	}

	function sharedGet(purl, rxid, params) {

		if(!validSvc.isRX(rxid) || !!!params) {
			throw new Error('transformRepo.sharedGet, rxid and params obj are required for rxid: ' + rxid);
		}

		_currentPurl = purl;
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				RXID: [rxid]
			},
			Entity: {
				Params: params
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okSharedGet, errSharedGet);

		function okSharedGet(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return model
			defer.resolve(r.data.Entity);

		}

		function errSharedGet(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    INTERVAL CHANGES
	 */

	function itvAdd(rxid, tfmId, confirmed, group) {
		// remove transform
		return apiSharedCallById('ops/transform/interval/create', {
			Context: {
				RXID: [rxid]
			},
			Entity: {
				Params: {
					TransformId: tfmId,
					Confirmed: confirmed,
					Group: group == 'yes'
				}
			},
		}, confirmed, group);
	}

	function itvRemove(rxid, itvId, confirmed, group) {
		return apiSharedCallById('ops/transform/interval/remove', {
			Context: {
				RXID: [rxid]
			},
			Params: {
				Id: itvId
			}
		}, confirmed, group);
	}

	function itvUpdateXrefs(rxid, tfmModel, itvModel, confirmed, group) {

		_pending = {
			tfmModel: tfmModel,
			itvModel: itvModel
		};
		return apiSharedCall('ops/transform/interval/update/data', apiRequestVM(rxid, tfmModel, itvModel, confirmed, group), confirmed, group);
	}

	function itvUpdateDates(rxid, tfmModel, itvModel, confirmed, group) {
		_pending = {
			tfmModel: tfmModel,
			itvModel: itvModel
		};
		return apiSharedCall('ops/transform/interval/update/dates', apiRequestVM(rxid, tfmModel, itvModel, confirmed, group), confirmed, group);
	}


	/**
	 *    TRANSFORM CHANGES
	 */

	function tfmAdd(rxid, tfmModel, itvModel, confirmed, group) {
		_pending = {
			tfmModel: tfmModel,
			itvModel: itvModel
		};
		return apiSharedCall('ops/transform/add', apiRequestVM(rxid, tfmModel, itvModel, confirmed, group), confirmed, group);
	}

	function tfmUpdate(rxid, tfmModel, confirmed, group) {
		// Desc property is only thing updated in a transform update
		var itvModel = {
			StartDate: validSvc.newProp(new Date()),
			EndDate: validSvc.newProp(new Date()),
			Transforms: []
		};

		_pending = {
			tfmModel: tfmModel,
			itvModel: itvModel
		};
		return apiSharedCall('ops/transform/update', apiRequestVM(rxid, tfmModel, itvModel, confirmed, group), confirmed, group);
	}

	function tfmRemove(rxid, id, confirmed, group) {

		// remove transform
		return apiSharedCallById('ops/transform/remove', {
			Context: {
				RXID: [rxid],
			},
			Entity: {
				Params: {
					TransformId: id,
					Confirmed: confirmed,
					Group: group == 'yes'
				}
			}
		}, confirmed, group);
	}

	function tfmStatusToggle(onoff, rxid, id, confirmed, group) {
		// set database property called "Disabled" to true/false
		// note: UI uses "Active"
		var purl = onoff == 'TFM-ACTIVE-OFF' ? 'ops/transform/disable' : 'ops/transform/enable';
		return apiSharedCallById(purl, {
			Context: {
				RXID: [rxid],
			},
			Entity: {
				Params: {
					TransformId: id,
					Confirmed: confirmed,
					Group: group == 'yes'
				}
			}
		}, confirmed, group);
	}

	function tfmConvertToCompound(rxid, id, confirmed, group) {

		return apiSharedCallById('ops/transform/convert2compound', {
			Context: {
				RXID: [rxid],
			},
			Entity: {
				Params: {
					TransformId: id,
					Confirmed: confirmed,
					Group: group == 'yes'
				}
			}
		}, confirmed, group);
	}


	/**
	 *    ALT: UNKNOWN / IGNORE
	 */

	function ignoreCode(rxid, itemCode, notes, confirmed, group) {

		// params
		if(!validSvc.isRX(rxid) || !validSvc.isText(itemCode)) {
			throw new Error('transformRepo.ignoreCode, rxid or item code are missing for RX: ' + rxid);
		}

		return apiSharedCall('ops/transform/unknown/convert', {
			Context: {
				RXID: [rxid]
			},
			Entity: {
				Params: {
					ItemCode: itemCode,
					Desc: notes,
					Confirmed: confirmed,
					Group: group == 'yes'
				}
			}
		}, confirmed, group);

	}

	function igUpdate(rxid, model) {

		// params
		if(!validSvc.isRX(rxid) || !validSvc.isText(model.Id)) {
			throw new Error('transformRepo.ignoreCode, rxid, id required for RX: ' + rxid);
		}

		return apiSharedCall('ops/transform/ignore/update', {
			Context: {
				RXID: [rxid]
			},
			Entity: {
				Id: model.Id,
				Description: model.Description.val
			}
		});

	}


	/**
	 *    SHARED API CALL
	 *    used by all methods
	 */

	function apiSharedCall(purl, apiRequest, confirmed, group) {

		var defer = $q.defer();
		_currentPurl = purl;

		// call api
		apiService.post(_currentPurl, apiRequest).then(okApiShared, errApiShared);

		function okApiShared(r) {
			if (!confirmed && group == 'yes') {
				if (!validSvc.httpGetListResp(r)) {
					errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				}
				defer.resolve(r.data.Entity);
			} else {
				// bad upsert response format
				if (!validSvc.httpUpsert200Resp(r)) {
					errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
					defer.reject(null);
					return;
				}
				// return entity id
				defer.resolve({ Id: r.data.Entity.Id });
			}
		}

		function errApiShared(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {

				if(Array.isArray(r.data.Entity.ROOT) && r.data.Entity.ROOT.length > 0 && r.data.Entity.ROOT[0] === 'ADJUSTMENTS') {
					// adjustments
					r.adj = r.data.Entity.Data;
				}
				else if(_currentPurl == 'ops/transform/unknown/convert' || _currentPurl == 'ops/transform/ignore/update') {
					// ALT requests get simple 422 message response
					r.msg = buildSimple422Message(r.data.Entity);
				}
				else {
					// data issues, map 422 errors into model
					r.models = mapApiErrorsToModels(r.data.Entity, _pending);
				}

				defer.reject(r);

			}
			else {
				errSvc.error('Unexpected error', _currentPurl + 'transformRepo.errApiShared', r.status, utilSvc.http.safeResponse(r));
			}

		}

		return defer.promise;
	}

	function apiSharedCallById(purl, apiRequest, confirmed, group) {

		var defer = $q.defer();
		_currentPurl = purl;

		apiService.post(_currentPurl, apiRequest).then(okApiSharedId, errApiSharedId);

		function okApiSharedId(r) {
			if (!confirmed && group == 'yes') {
				if (!validSvc.httpGetListResp(r)) {
					errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				}
				defer.resolve(r.data.Entity);
			} else {
				if (!validSvc.httpUpsert200Resp(r)) {
					errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
					defer.reject(null);
					return;
				}
				defer.resolve({Id: r.data.Entity.Id});
			}
		}

		function errApiSharedId(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status === 409) {
				defer.reject(r);
			}
			else if(r.status === 422) {
				r.msg = buildSimple422Message(r.data.Entity);
				defer.reject(r);
			}
			else {
				errSvc.error('Unexpected error', _currentPurl + 'transformRepo.errApiShared', r.status, utilSvc.http.safeResponse(r));
			}

		}

		return defer.promise;
	}


	/**
	 *    422 PARSING
	 */

	function buildSimple422Message(entity) {

		var result = '';

		if(Array.isArray(entity.ROOT) && entity.ROOT.length > 0) {
			result += entity.ROOT.join(', ');
		}

		if(Array.isArray(entity.Fields)) {
			for(var i = 0; i < entity.Fields.length; i++) {
				result += result.length > 0 ? ', ' : '';
				result += entity.Fields[i].Name + ': ' + entity.Fields[i].Rule;
			}
		}

		return result;

	}

	function mapApiErrorsToModels(entity, m) {

		// map server 422 field names to view model

		// root errors
		if(entity.ROOT.length > 0) {
			m.tfmModel.ROOT = {
				fail: 'yes',
				msg: entity.ROOT.join(', ')
			};
		}

		// field errors
		var fieldName = '',
			foundNDC = false,
			tfmNDC = validSvc.isText(m.tfmModel.ItemCode.val) ? m.tfmModel.ItemCode.val : '',
			itvNDC = '';

		for(var i = 0; i < entity.Fields.length; i++) {

			fieldName = entity.Fields[i].Name;

			// check transform props first
			if(fieldName == 'ItemCode') {
				m.tfmModel.ItemCode.fail = 'yes';
				m.tfmModel.ItemCode.msg = entity.Fields[i].Rule;
			}
			else if(fieldName == 'StartDate') {
				m.itvModel.StartDate.fail = 'yes';
				m.itvModel.StartDate.msg = entity.Fields[i].Rule;
			}
			else if(fieldName == 'EndDate') {
				m.itvModel.EndDate.fail = 'yes';
				m.itvModel.EndDate.msg = entity.Fields[i].Rule;
			}
			else if(fieldName == 'Desc') {
				m.tfmModel.Description.fail = 'yes';
				m.tfmModel.Description.msg = entity.Fields[i].Rule;
			}
			else if(fieldName == 'CrossRef') {
				// ItemCode was derrived to be a CDM with at least 1 empty CrossRef
				var tfms = m.itvModel.Transforms;
				for(var c = 0; c < tfms.length; c++) {
					if(!validSvc.isText(tfms[c].NDC.val)) {
						tfms[c].NDC.fail = 'yes';
						tfms[c].NDC.msg = 'valid NDC required for CDM';
					}
				}
			}
			else {

				// check transforms to find ndc
				foundNDC = false;
				for(var ii = 0; ii < m.itvModel.Transforms.length; ii++) {
					itvNDC = validSvc.isText(m.itvModel.Transforms[ii].NDC.val) ? m.itvModel.Transforms[ii].NDC.val : '';
					if(itvNDC == fieldName) {
						m.itvModel.Transforms[ii].NDC.fail = 'yes';
						m.itvModel.Transforms[ii].NDC.msg = entity.Fields[i].Rule;
						foundNDC = true;
						break;
					}
					else if(itvNDC.length === 0 && tfmNDC.length > 0 && tfmNDC == fieldName) {
						// this NDC is referencing itself (model will be empty string), ItemCode also has an error
						//m.tfmModel.ItemCode.fail = 'yes';
						//m.tfmModel.ItemCode.msg = entity.Fields[i].Rule;
						foundNDC = true;
						break;
					}
				}

				// not found
				if(!foundNDC) {
					throw new Error('transformRepo.mapCompoundApiErrorsToModel, ' + _currentPurl + '/ unknown 422 FieldName: ' + fieldName);
				}
			}

		}

		return m;

	}


	/**
	 *    IMPORT CSV FILE
	 */

	function tfmImport(rxid, tfmType, importFile, override, group) {

		// params
		if(!validSvc.isRX(rxid) || !!!importFile) {
			throw new Error('transformRepo.tfmImport ' + tfmType + '/ rxid or file are missing for RX: ' + rxid);
		}

		// check for FormData object support
		if(!!!$window.FormData) {
			throw new Error('transformRepo.tfmImport ' + tfmType + ' browser does not support HTML FormData object');
		}

		var defer = $q.defer();

		// assign purl
		switch(tfmType) {
			case 'TRANSFORM':
				_currentPurl = 'ops/transform/import/transforms'; //'ops/transform/import/updowntest';
				break;
			case 'COMPOUND':
				_currentPurl = 'ops/transform/import/compounds';
				break;
			case 'IGNORED':
				_currentPurl = 'ops/transform/import/ignored';
				break;
			default:
				throw new Error('transformRepo.tfmImport, unknown transform type: ' + tfmType);
		}

		// create multi-part form data
		var fd = new FormData();
		fd.append('context', angular.toJson({
			Context:{
				RXID:[rxid]
			},
			Params: {
				Override: override == 'yes',
				Group: group == 'yes'
			}
		}));
		fd.append('file', importFile);

		// call api
		_pending = {
			TransformType: tfmType,
			fileName: importFile.name
		};
		apiService.postFile(_currentPurl, fd, false).then(okTfmImport, errTfmImport);

		function okTfmImport(r) {

			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}
			var ent = r.data.Entity;
			var err = Array.isArray(ent.RecordErrors) ? ent.RecordErrors : [];

			// processed with errors?
			if(err.length > 0) {
				r.status = 422;
				r.importErrors = err;
				defer.reject(r);
				return;
			}
			else {
				defer.resolve({
					Processed: ent.ProcessedCount,
					Received: ent.Received
				});
			}

		}

		function errTfmImport(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!!!r || !validSvc.isNumber(r.status) || !!!r.data) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else {
				errSvc.error('Unexpected error', _currentPurl + 'transformRepo.errTfmImport', r.status, utilSvc.http.safeResponse(r));
			}

		}

		return defer.promise;

	}


	/**
	 *    IMPORT MIGRATION FILES
	 *    three files are required
	 */

	function migImport(rxid, migFiles) {

		// params
		if(!validSvc.isRX(rxid) || !!!migFiles) {
			throw new Error('transformRepo.migImport rxid or files are missing for RX: ' + rxid);
		}

		// check for FormData object support
		if(!!!$window.FormData) {
			throw new Error('transformRepo.migImport browser does not support HTML FormData object');
		}

		var defer = $q.defer();
		_currentPurl = 'ops/transform/import/migration';

		// create multi-part form data
		var fd = new FormData();
		fd.append('context', angular.toJson({"RXID": rxid}));
		if(!!migFiles.mult && migFiles.mult.length > 0) {
			fd.append('multiplier', migFiles.mult[0]);
		}
		if(!!migFiles.xref && migFiles.xref.length > 0) {
			fd.append('crossref', migFiles.xref[0]);
		}
		if(!!migFiles.comp && migFiles.comp.length > 0) {
			fd.append('compound', migFiles.comp[0]);
		}

		// call api
		_pending = {
			RX: rxid
		};
		apiService.postFile(_currentPurl, fd, false).then(okMigImport, errMigImport);

		function okMigImport(r) {

			// bad upsert response format
			if(!!!r || !!!r.data) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});

		}

		function errMigImport(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!!!r || !validSvc.isNumber(r.status) || !!!r.data) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 422) {
				r.importErrors = mapApiMigImportErrors(r.data.Entity, _pending.RX);
				defer.reject(r);
			}
			else {
				errSvc.error('Unexpected error', _currentPurl, r.status, utilSvc.http.safeResponse(r));
			}

		}

		function mapApiMigImportErrors(entity, rxid) {

			// map server 422 fields onto import error text lines

			if(Array.isArray(entity.Fields) && entity.Fields.length > 0) {
				return entity.Fields;
			}
			else if(entity.ROOT.length > 0) {
				return [{Name: 'File Error', Rule: entity.ROOT.join(',')}];
			}
			else {
				throw new Error(rxid + ': transformRepo.422MigFileImport, Api returned no errors to display');
			}

		}


		return defer.promise;

	}


	/**
	 *    EXCEL: EXPORT ALL TABS
	 *    file created on api server, expecting a binary file stream instead of JSON
	 */

	function excelAllTabs(query, filename, isGroupReport) {

		// params
		if(!validSvc.isRX(query.RX) || !validSvc.isText(filename)) {
			throw new Error('tfmRepo.excelAllTabs, rxid and filename required');
		}

		var defer = $q.defer();
		_currentPurl = isGroupReport ? 'ops/transform/export/groupexcel' : 'ops/transform/export/affilexcel';

		// create api request
		var apiReqest = {
			Context: {
				RXID: [query.RX]
			},
			Params: {
				StartDate: query.StartDate,
				EndDate: query.EndDate,
				Filename: filename
			}
		};

		// call api
		apiService.postGetBinary(_currentPurl, apiReqest).then(okExcelAllTabs, errExcelAllTabs);

		function okExcelAllTabs(r) {
			defer.resolve(r.data);
		}

		function errExcelAllTabs(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

}
 
/**
 *    TRANSFORM CONTROLLER
 */

transformCtl.$inject = ['$rootScope', '$scope', '$state', '$timeout', '$filter', '$window', 'appConst', 'transformRepo', 'catalogsRepo', 'groupsRepo', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc'];
angular
.module('espui.ops')
.controller('TransformCtl', transformCtl);


/* @ngInject */
function transformCtl($rootScope, $scope, $state, $timeout, $filter, $window, appConst, transformRepo, catalogsRepo, groupsRepo, validSvc, errSvc, utilSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _filterReady = false,
		_filterDirty = false,
		_filtering = false,
		_pendingEdit = null,
		_startTab = '',
		_tfmDirty = false,
		_regexDate = utilSvc.regex.dateFmt(),
		_featureName = '',
		_deepLinkNdc = '',
		_deepLinkTransId = '';

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.isWaiting = false;
	vm.action = '';
	vm.showAdminButtons = false;

	// context
	vm.context = {};
	vm.RxDroplist = [];
	vm.contextChange = contextChange;
	vm.dateRangeChange = dateRangeChange;
	vm.contextSubmit = contextSubmit;

	// tabs
	vm.showTabBar = false;
	vm.activeTab = '';
	vm.tabUiName = tabUiName;
	vm.tabCrossRef = {};
	vm.tabCompound = {};
	vm.tabALT = {}; // used by both UKNOWN and IGNORED tabs
	vm.tabNoMap = {};
	vm.tabChange = tabChange;

	// tab filters
	vm.filterChange = filterChange;
	vm.ItemCodeTypeDroplist = [];

	// transform and interval models
	vm.tfmModel = {};
	vm.itvModel = {};

	// edit mode transitions
	vm.tfmAddSetup = tfmAddSetup;
	vm.tfmEdit = tfmEdit;
	vm.tfmEditCancel = tfmEditCancel;
	vm.tfmEditRefresh = tfmEditRefresh;
	vm.itvClick = itvClick;

	// transform parent edits (used by all tabs including UNKNOWN and IGNORED)
	vm.tfmAdd = tfmAdd;
	vm.tfmUpdate = tfmUpdate;
	vm.tfmRemove = tfmRemove;
	vm.tfmConvertToCompound = tfmConvertToCompound;
	vm.tfmStatusToggle = tfmStatusToggle;

	// interval edits
	vm.itvAdd = itvAdd; // xref
	vm.itvRemove = itvRemove;
	vm.itvRemoveXref = itvRemoveXref;
	vm.itvAddXref = itvAddXref;
	vm.itvUpdateXrefs = itvUpdateXrefs;
	vm.itvUpdateDates = itvUpdateDates;

	// user confirmation adjustments
	vm.showEditAdjustments = false;
	vm.editAdjustments = [];
	vm.adjCancel = adjCancel;
	vm.adjApprove = adjApprove;

	// file import
	vm.importConfig = {};
	vm.importSelectedFiles = null;
	vm.importMigFiles = {mult: null, xref: null,comp: null};
	vm.importErrors = [];
	vm.importCsvToggle = importCsvToggle;
	vm.importCsvSend = importCsvSend;
	vm.importErrorsToCsv = importErrorsToCsv;

	// file export
	vm.excelAllTabs = excelAllTabs;

	// alt = unknowns and ignores, they share the same viewmodel and html
	vm.altGetDetail = altGetDetail;
	vm.altDetailExit = altDetailExit;
	vm.altConvertTo = altConvertTo;
	vm.ignoredUpdate = ignoredUpdate;

	// ndc search popup
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;
	vm.popupSearch = popupSearch;

	// tab cross-linking
	vm.linkToTfmEdit = linkToTfmEdit;
	vm.linkToUnknownDetail = linkToUnknownDetail;

	// group members
	vm.grpMembers = [];
	vm.grpMembersShow = false;


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		_featureName = $state.current.name;

		vm.showTabBar = false;
		vm.activeTab = '';

		displayVM();
		vm.context = transformRepo.contextVM();

		// NO MAP: date default:
		vm.context.DateRangeValid = false;
		vm.context.DateRangeList = utilSvc.widget.dateRangeList(['CUSTOM92']);
		vm.context.DateRangeList.push({label: 'Last 12 Months', value: 'LTM'});
		vm.context.DateRangeList.push({label: 'Yearly', value: 'YEARLY'});
		vm.context.DateRangeList.push({label: 'Year To Date', value: 'YTD'});
		var dtToday = new Date(),
			dtAppStart = utilSvc.dt.zeroTime(appConst.app.liveDate),
			customRangeDays = parseInt(utilSvc.dt.diffDays(dtAppStart, dtToday));
		vm.context.StartDate.min = dtAppStart;
		vm.context.EndDate.min = dtAppStart;
		vm.context.DateRangeList.push({ label: 'Custom Date Range', value: 'CUSTOM' + customRangeDays.toString() });
		vm.context.DateRangeMode = '7DAYS';

		// claim rights
		vm.context.allowEdit = vm.context.isVerityUser || vm.context.userType == 'CE'; // basic editing, verity or CE users
		if(vm.context.allowEdit) {
			vm.context.claimCreate = utilSvc.user.hasFeature($scope, 'ops.transform.create');
			vm.context.claimUpdate = utilSvc.user.hasFeature($scope, 'ops.transform.update');
			vm.context.claimConvertUnknown = utilSvc.user.hasFeature($scope, 'ops.transform.convert.unknown');
			vm.context.claimConvertIgnore = utilSvc.user.hasFeature($scope, 'ops.transform.convert.ignore');
			vm.context.claimImport = utilSvc.user.hasFeature($scope, 'ops.transform.import');
			vm.context.claimImportOverride = utilSvc.user.hasFeature($scope, 'ops.transform.import.override');
			vm.context.claimGroup = utilSvc.user.hasFeature($scope, 'ops.transform.group');
		}

		// code type droplist
		vm.ItemCodeTypeDroplist = [
			{label:'ALL', value:''},
			{label:'CDM', value:'CDM'},
			{label:'NDC', value:'NDC'}
		];

		// rx droplist
		var affs = utilSvc.aff.findRxType($scope.User.AffList, ['DISPENSING', 'CENTRALFILL']);
		affs = utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));
		vm.RxDroplist = utilSvc.aff.rxDroplist(affs);

		// deep link?
		var isDeepLink = false,
			linkParams = $state.params || {};
		if(validSvc.isRX(linkParams.rxid) && validSvc.isText(linkParams.tab)) {
			isDeepLink = true;

			// set RX context to deep link
			vm.context.RX.val = linkParams.rxid;
			_startTab = linkParams.tab;

			// deep link has ndc?
			if(validSvc.isText($state.params.ndc)) {
				_deepLinkNdc = $state.params.ndc.toString();
				_deepLinkTransId = $state.params.transid;
			}

		}
		else {
			_startTab = 'TRANSFORM';
		}

		// auto select
		vm.context.RX = utilSvc.ng.droplistAutoselect(vm.RxDroplist, vm.context.RX.val);
		vm.context.RX.fail = validSvc.isRX(vm.context.RX.val) ? 'no' : 'yes';

		// admin button
		vm.showAdminButtons = vm.context.RX.fail == 'no' && vm.context.isVerityUser && vm.context.isDebug;

		// deep links load immediately after page render
		if(isDeepLink) {

			// clear deep link from app state cache
			// note: the next time user navigates to Mapping it won't deep link to this NDC again if cache is cleared
			$rootScope.$emit('espui>route.reset', {route: 'ops.transform'});

			$timeout(function() {

				// re-check RX before loading deep link data
				if(!validSvc.isRX(vm.context.RX.val)) {
					return;
				}

				// ndc deep link?
				if(validSvc.isText(_deepLinkNdc)) {
					loadDeepLinkNdc(_deepLinkNdc, _deepLinkTransId);
				}
				else {
					contextSubmit(_startTab);
				}
			}, 200);
		}

		// no map, setup date control
		$timeout(function() {
			$scope.$broadcast('widget.input.date.range.mode', {mode: vm.context.DateRangeMode, keepDates: false});
		}, 1000);

	}

	function loadDeepLinkNdc(ndc, transid) {

		// accum detail links to mapping detail directly
		// note: deep link ndc is only supported from Accum Detail

		// add bread crumb back to Accum Detail
		var routeInfo = angular.fromJson(angular.toJson($state.current.routeInfo));
		routeInfo.breadcrumb = {
			icon: 'sprite-ndc-accum',
			route: 'ops.accum-detail',
			routeData: {breadcrumb: true},
			msg: 'Return to Accumulation Detail for NDC: ' + ndc
		};
		$scope.$emit('shared.main.setInfo', routeInfo);

		vm.activeTab = _startTab;
		vm.showTabBar = true;

		tfmGetByTransId(ndc, transid);

	}


	/**
	 *    DISPLAY VIEW MODELS
	 */

	function displayVM(dataItems) {

		// split transform list items into two tabs: crossref or compound

		dataItems = Array.isArray(dataItems) ? dataItems : [];

		var crossRefItems = [],
			compoundItems = [];

		for(var i = 0; i < dataItems.length; i++) {

			switch(dataItems[i].TransformType) {

				case 'TRANSFORM':
					crossRefItems.push(tfmDisplayVM(dataItems[i]));
					break;

				case 'COMPOUND':
					compoundItems.push(tfmDisplayVM(dataItems[i]));
					break;

				default:
					throw new Error('transformCtl.displayVM, unknown transform type: ' + dataItems[i].TransformType);
			}
		}

		// reset editing models
		vm.tfmModel = {};
		vm.itvModel = {};

		// reset edit adjustments
		vm.showEditAdjustments = false;
		vm.editAdjustments = [];

		// xref tab list (TRANSFORM type)
		vm.tabCrossRef = {
			DataItems: crossRefItems,
			Items: [], // items will be loaded by filterChange() method
			SortBy: ['ItemCode'],
			FilterTxt: {
				ItemCodeType: '',
				ItemCodeTxt: '',
				MultTxt: '',
				NDCTxt: ''
			},
			FilterDates: {
				StartDate: '',
				EndDate: ''
			},
			FilterDatesConfig: ['StartDate', 'EndDate'],
			Paging: {
				Page: 1,
				Size: appConst.app.display.pagingSize,
				Total: vm.getTotalPages(crossRefItems.length, appConst.app.display.pagingSize)
			}
		};

		// compound tab list
		vm.tabCompound = {
			addItem: {},
			DataItems: compoundItems,
			Items: [], // items will be loaded by filterChange() method
			SortBy: ['ItemCode'],
			FilterTxt: {
				ItemCodeType: '',
				ItemCodeTxt: '',
				MultTxt: '',
				NDCTxt: ''
			},
			FilterDates: {
				StartDate: '',
				EndDate: ''
			},
			FilterDatesConfig: ['StartDate', 'EndDate'],
			Paging: {
				Page: 1,
				Size: appConst.app.display.pagingSize,
				Total: vm.getTotalPages(compoundItems.length, appConst.app.display.pagingSize)
			}
		};

	}

	function tfmDisplayVM(dataItem) {

		// transform display properties

		if(!!!dataItem || !validSvc.isText(dataItem.TransformType)) {
			throw new Error('transformCtl.tfmDisplayVM, dataItem.TransformType is always required');
		}

		var tfm = {
			Id: validSvc.isText(dataItem.Id) ? dataItem.Id : '',
			TransformType: dataItem.TransformType,
			ActiveTxt: !!dataItem.Disabled ? 'NO' : 'YES',
			ItemCodeType: validSvc.isText(dataItem.ItemCodeType) ? dataItem.ItemCodeType : 'CDM',
			ItemCode: validSvc.isText(dataItem.ItemCode) ? dataItem.ItemCode : '',
			Description: validSvc.isText(dataItem.Description) ? dataItem.Description : '',
			StartDate: 'ongoing',
			EndDate: 'ongoing',
			Multiplier: 1, // for xref list display
			NDC: '', // for xref list display
			MultTxt: '', // for column filters
			NDCTxt: '', // for column filters
			Intervals:  Array.isArray(dataItem.Intervals) ? dataItem.Intervals : [],
			RefItemName: validSvc.isText(dataItem.RefItemName) ? dataItem.RefItemName : '',
			DrugFormCode: dataItem.DrugFormCode,
			PackageSize: dataItem.PackageSize,
			CaseSize: dataItem.CaseSize,
			WholesaleUnits: dataItem.WholesaleUnits,
			OutboundDrugFormCode: '',
			OutboundPackageSize: '',
			OutboundCaseSize: '',
			OutboundWholesaleUnits: '',
			ChangesPending: dataItem.ChangesPending
		};
		tfm.ItemCodeTxt = tfm.ItemCode + '|' + tfm.Description;

		var current = {},
			xrefs = [],
			multCheck = 1,
			ndcCheck = '',
			multItems = [],
			ndcItems = [],
			displayDates = false,
			lastInterval = true;

		// loop intervals, build column filters
		for(var i = 0; i < tfm.Intervals.length; i++) {
			current = tfm.Intervals[i];

			// fix null server dates
			current.StartDate = validSvc.isDate(current.StartDate) ? $filter('date')(current.StartDate, 'M/d/yyyy') : 'ongoing';
			current.EndDate = validSvc.isDate(current.EndDate) ? $filter('date')(current.EndDate, 'M/d/yyyy') : 'ongoing';

			// UNKNOWN interval?
			if(validSvc.isNumber(current.UnknownCount) && current.UnknownCount > 0) {
				// don't process Transforms or History
				current.Id = 'UNKNOWN' + i.toString();
				current.Transforms = [];
				current.ChangeHistory = [];
			}
			else {
				current.UnknownCount = 0;

				// mark the last interval (its the first index in the array which isn't unknown)
				if(lastInterval) {
					lastInterval = false;
					current.isLastInterval = true;
				}
				else {
					current.isLastInterval = false;
				}

				// use dates from Interval[0] for list display
				if(!displayDates) {
					displayDates = true;
					tfm.StartDate = current.StartDate;
					tfm.EndDate = current.EndDate;
				}

				// loop xrefs
				xrefs = current.Transforms;
				for(var t = 0; t < xrefs.length; t++) {

					multCheck = validSvc.isNumber(xrefs[t].Multiplier) ? xrefs[t].Multiplier : 1.0;

					// ndc
					ndcCheck = '';
					if(validSvc.isText(xrefs[t].NDC)) {
						ndcCheck = xrefs[t].NDC;
					}

					// TRANSFORM specific
					if(tfm.TransformType == 'TRANSFORM') {

						// ndc inbound == ndc outbound? its referencing itself, remove it
						if(ndcCheck == tfm.ItemCode) {
							xrefs[t].NDC = '';
							ndcCheck = '';
						}

						// list display uses Interval[0]xref[0] values
						if(i === 0 && t === 0) {
							tfm.Multiplier = multCheck;
							tfm.NDC = ndcCheck;
							tfm.Desc = xrefs[t].Desc;
							tfm.OutboundDrugFormCode = xrefs[t].DrugFormCode;
							tfm.OutboundPackageSize = xrefs[t].PackageSize;
							tfm.OutboundCaseSize = xrefs[t].CaseSize;
							tfm.OutboundWholesaleUnits = xrefs[t].WholesaleUnits;
						}
					}

					// build column filter text
					if(multItems.indexOf(multCheck) < 0) {
						multItems.push(multCheck);
					}
					if(ndcCheck.length > 0 && ndcItems.indexOf(ndcCheck) < 0) {
						ndcItems.push(ndcCheck);
						ndcItems.push(xrefs[t].Desc);
					}

				}
			}

		}

		// mark the first interval (last item in array that is not an unknown)
		if(tfm.Intervals.length > 0) {
			if(tfm.Intervals[tfm.Intervals.length - 1].UnknownCount === 0) {
				// last array item isn't an unknown
				tfm.Intervals[tfm.Intervals.length - 1].isFirstInterval = true;
			}
			else {
				// use second last array item
				tfm.Intervals[tfm.Intervals.length - 2].isFirstInterval = true;
			}
		}

		// merge column filter txt
		tfm.MultTxt = multItems.join('|');
		tfm.NDCTxt = ndcItems.join('|');

		return tfm;

	}

	function altVM(dataItems, sortBy) {

		// used by both UKNOWN and IGNORED types

		dataItems = Array.isArray(dataItems) ? dataItems : [];

		var items = [],
			desc = [];

		// parse alt data into display list
		for(var i = 0; i < dataItems.length; i++) {

			// parse ItemCode and Description into one column
			desc = [];
			desc.push(dataItems[i].ItemCode);
			if(validSvc.isText(dataItems[i].Description)) {
				desc.push(dataItems[i].Description);
			}

			// add to list
			items.push({
				Id: validSvc.isText(dataItems[i].TransformId) ? dataItems[i].TransformId : '',
				Status: dataItems[i].ObjectState,
				ItemCode: dataItems[i].ItemCode,
				Desc: desc,
				DescTxt: desc.join('|'),
				Total: dataItems[i].Total,
				DispenseFirst: validSvc.isDate(dataItems[i].DispenseFirst) ? dataItems[i].DispenseFirst : null,
				DispenseLast: validSvc.isDate(dataItems[i].DispenseLast) ? dataItems[i].DispenseLast : null
			});
		}

		sortBy = Array.isArray(sortBy) ? sortBy : ['ItemCode'];

		return {
			Items: items,
			SortBy: sortBy,
			FilterTxt: {
				ItemCode: '',
				DescTxt: '',
				Total: ''
			},
			FilterDates: {
				DispenseFirst: '',
				DispenseLast: ''
			},
			Paging: {
				Page: 1,
				Size: appConst.app.display.pagingSize,
				Total: vm.getTotalPages(items.length, appConst.app.display.pagingSize)
			}
		};

	}

	function noMapVM(dataItems) {

		dataItems = Array.isArray(dataItems) ? dataItems : [];
		var item = {};

		for(var i = 0 ; i < dataItems.length; i++) {
			item = dataItems[i];
			item.Description = validSvc.isText(item.Description) ? item.Description : '';
			item.FirstSeen = validSvc.isDate(item.FirstSeen) ? item.FirstSeen : null;
			item.NDCTxt = item.NDC + '|' + item.Description;
		}

		return {
			DataItems: dataItems,
			Items: [], // items will be loaded by filterChange() method
			SortBy: ['NDC'],
			FilterTxt: {
				NDCTxt: '',
				PackageSize: '',
				CaseSize: '',
				WholesaleUnits: ''
			},
			FilterDates: {
				FirstSeen: ''
			},
			FilterDatesConfig: ['FirstSeen'],
			AddNdc: '',
			Paging: {
				Page: 1,
				Size: appConst.app.display.pagingSize,
				Total: vm.getTotalPages(dataItems.length, appConst.app.display.pagingSize)
			}
		};

	}


	/**
	 *    EDIT VIEW MODELS
	 */

	function tfmEditVM(dataItem) {

		// transform validation properties

		// input must be a tfmDisplayVM, null not allowed
		if(!!!dataItem || !Array.isArray(dataItem.Intervals)) {
			throw new Error('transformCtl.tfmEditVM, dataItem.Intervals array required');
		}

		return {
			PreviousStatus: validSvc.isText(dataItem.PreviousStatus) ? dataItem.PreviousStatus : '',
			Confirmed: false,
			Id: dataItem.Id,
			ActiveTxt: dataItem.ActiveTxt,
			TransformType: dataItem.TransformType,
			ItemCodeType: dataItem.ItemCodeType,
			ItemCode: validSvc.newProp(dataItem.ItemCode),
			Description: validSvc.newProp(dataItem.Description),
			Intervals: angular.fromJson(angular.toJson(dataItem.Intervals)),
			RefItemName: validSvc.isText(dataItem.RefItemName) ? dataItem.RefItemName : '',
			DrugFormCode: dataItem.DrugFormCode,
			PackageSize: dataItem.PackageSize,
			CaseSize: dataItem.CaseSize,
			WholesaleUnits: dataItem.WholesaleUnits,
			ChangesPending: dataItem.ChangesPending
		};

	}

	function itvEditVM(itv) {

		// interval validation properties

		// id required
		if(!validSvc.isText(itv.Id)) {
			throw new Error('transformCtl.itvEditVM, Id is required');
		}

		// xrefs
		var tfms = [],
			ndcProp = null;
		for(var x = 0; x < itv.Transforms.length; x++) {

			// validate NDC
			ndcProp = validSvc.newProp(validSvc.isText(itv.Transforms[x].NDC) ? itv.Transforms[x].NDC : '');
			ndcProp.fail = !!!ndcProp.val ? 'yes' : 'no';

			// xref is optional for Single maps, its not a fail
			if(vm.activeTab == 'TRANSFORM' && !!!ndcProp.val && ndcProp.fail == 'yes') {
				ndcProp.fail = '';
			}

			tfms.push({
				NDC: ndcProp,
				Multiplier: validSvc.newProp(validSvc.isNumber(itv.Transforms[x].Multiplier) ? itv.Transforms[x].Multiplier : 1.0),
				Desc: itv.Transforms[x].Desc,
				DrugFormCode: itv.Transforms[x].DrugFormCode,
				PackageSize: itv.Transforms[x].PackageSize,
				CaseSize: itv.Transforms[x].CaseSize,
				WholesaleUnits: itv.Transforms[x].WholesaleUnits
			});
		}

		// dates, need min/max values for non-null dates
		var dtWindow = 1000; // about 2.5 years +-
		var dtStart = null,
			dtEnd = null,
			dtEarliest = utilSvc.dt.zeroTime(utilSvc.dt.addDays(new Date(), -dtWindow)),
			dtLatest = utilSvc.dt.zeroTime(utilSvc.dt.addDays(new Date(), +dtWindow));

		// start dt
		if(validSvc.isDate(itv.StartDate)) {
			dtStart = validSvc.newPropDate($filter('date')(itv.StartDate, 'M/d/yyyy'), dtEarliest, dtLatest); // val/min/max
		}
		else {
			dtStart = validSvc.newPropDateNull(dtEarliest, dtLatest); // min/max
			dtStart.val = 'ongoing';
		}

		// end dt
		if(validSvc.isDate(itv.EndDate)) {
			dtEnd = validSvc.newPropDate($filter('date')(itv.EndDate, 'M/d/yyyy'), dtEarliest, dtLatest); // val/min/max
		}
		else {
			dtEnd = validSvc.newPropDateNull(dtEarliest, dtLatest); // min/max
			dtEnd.val = 'ongoing';
		}

		// clean up change history (Adjustments and AccumulatorAdjustments arrays are coming back null)
		var hist = Array.isArray(itv.ChangeHistory) ? itv.ChangeHistory : [],
			histItem = null;
		for(var i = 0; i < hist.length; i++) {
			histItem = hist[i];
			histItem.Changes = Array.isArray(histItem.Changes) ? histItem.Changes : [];
			histItem.Adjustments = Array.isArray(histItem.Adjustments) ? histItem.Adjustments : [];
			for(var ii = 0; ii < histItem.Adjustments.length; ii++) {
				histItem.Adjustments[ii].AccumulatorAdjustments = Array.isArray(histItem.Adjustments[ii].AccumulatorAdjustments) ? histItem.Adjustments[ii].AccumulatorAdjustments : [];
			}
		}

		return {
			Id: itv.Id,
			isFirstInterval: !!itv.isFirstInterval,
			isLastInterval: !!itv.isLastInterval,
			StartDate: dtStart,
			EndDate: dtEnd,
			UnknownCount: validSvc.isNumber(itv.UnknownCount) ? itv.UnknownCount : 0,
			Transforms: tfms,
			ChangeHistory: hist
		};

	}

	function altDetailVM(data) {

		// used by both UKNOWN and IGNORED types

		data = data || {};

		// clean up disp item data
		var dispItems = Array.isArray(data.Dispenses) ? data.Dispenses : [],
			item = {};
		for(var i = 0; i < dispItems.length; i++) {
			item = dispItems[i];
			item.DispenseDate = utilSvc.dt.toBizTime(item.DispenseDate);
			item.Detail = validSvc.isText(item.Detail) ? item.Detail : 'no details available';
		}

		return {
			Id: validSvc.isText(data.TransformId) ? data.TransformId : '',
			ItemCode: data.ItemCode,
			Status: data.ObjectState,
			Title: tabUiName(vm.activeTab),
			Total: validSvc.isNumber(data.Total) ? data.Total : null,
			DispenseFirst: utilSvc.dt.toBizTime(data.DispenseFirst),
			DispenseLast: utilSvc.dt.toBizTime(data.DispenseLast),
			Description: validSvc.newProp(validSvc.isText(data.Description) ? data.Description : ''), // ignores now have "notes" saved in Desc

			TransformType: validSvc.isText(data.TransformType) ? data.TransformType : '',
			TransformId: validSvc.isText(data.TransformId) ? data.TransformId : '',
			TransformStartDate: validSvc.isDate(data.TransformStartDate) ? $filter('date')(data.TransformStartDate, 'M/d/yyyy') : 'ongoing',
			TransformEndDate: validSvc.isDate(data.TransformEndDate) ? $filter('date')(data.TransformEndDate, 'M/d/yyyy') : 'ongoing',

			Items: dispItems,
			SortBy: ['-DispenseDate'],
			FilterTxt: {
				AccType: '',
				ItemDesc: '',
				Quantity: '',
				Detail: ''
			},
			FilterDates: {
				DispenseDate: ''
			},
			Paging: {
				Page: 1,
				Size: appConst.app.display.pagingSize,
				Total: vm.getTotalPages(dispItems.length, appConst.app.display.pagingSize)
			}
		};

	}


	/**
	 *    CONTEXT: CHANGE
	 */

	function contextChange() {

		// user changed value before hitting the LOAD button

		// reset any in-progress editing
		if(!vm.isWaiting) {
			_pendingEdit = null;
		}

		vm.context.RX.fail = validSvc.isRX(vm.context.RX.val) ? 'no' : 'yes';

		vm.action = '';
		vm.activeTab = '';
		vm.showTabBar = false;
		displayVM();
		vm.tabALT = altVM();
		vm.tabNoMap = noMapVM();
		vm.popup = {};
		vm.grpMembersShow = false;

		// admin button
		vm.showAdminButtons = vm.context.RX.fail == 'no' && vm.context.isVerityUser && vm.context.isDebug;

	}

	function dateRangeChange(dtMode, isValid) {
		// no map date control
		vm.context.DateRangeMode = dtMode;
		vm.context.DateRangeValid = isValid;
	}


	/**
	 *    CONTEXT: SUBMIT
	 */

	function contextSubmit(tabName) {

		// already working or importing
		if(vm.isWaiting) {
			return;
		}
		vm.popup = {};

		// validate RX
		vm.context.RX.fail = validSvc.isRX(vm.context.RX.val) ? 'no' : 'yes';
		if(vm.context.RX.fail == 'yes') {
			msgSvc.ok('Mapping Search', 'Complete filter settings.');
			return;
		}

		// default tab is TRANSFORM
		if(!validSvc.isText(tabName) || tabName == 'MIGRATION') {
			tabName = 'TRANSFORM';
		}

		_filterReady = false;
		_filtering = false;
		vm.action = '';
		vm.activeTab = '';
		vm.grpMembersShow = false;

		// validate NOMAP dates
		if(tabName == 'NOMAP' && !vm.context.DateRangeValid) {
			msgSvc.ok('Dates Required', 'Check date values');
			vm.activeTab = 'NOMAP';
			vm.showTabBar = true;
			return;
		}

		// save tab focus
		switch(tabName) {
			case 'TRANSFORM':
			case 'COMPOUND':
			case 'UNKNOWN':
			case 'IGNORED':
			case 'NOMAP':
				_startTab = tabName;
				break;
			default:
				throw new Error('transformCtl.contextSubmit, tabName unknown: ' + tabName);
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		if(tabName == 'UNKNOWN') {
			// clear other tabs, get list data
			displayVM();
			transformRepo.getUnknownList(vm.context.RX.val).then(okGetList, errGetList);
		}
		else if(tabName == 'IGNORED') {
			// clear other tabs, get list data
			displayVM();
			transformRepo.getIgnoredList(vm.context.RX.val).then(okGetList, errGetList);
		}
		else if(tabName == 'NOMAP') {
			// clear other tabs, get list data
			displayVM();
			var startDate = vm.context.StartDate.val;
			var endDate = vm.context.EndDate.val;
			if (!!!vm.useDateQuery) {
				startDate = utilSvc.dt.zeroTime(appConst.app.liveDate);
				endDate = new Date();
			}
			transformRepo.getNoMapList(vm.context.RX.val, startDate, endDate).then(okGetList, errGetList);
		}
		else {
			// clear other tabs, get list data
			vm.tabALT = altVM();
			transformRepo.getList(vm.context.RX.val).then(okGetList, errGetList);
		}

		// avoid checking group members every tab click
		if(vm.grpMembers.length < 1) {
			groupsRepo.memberListGet(vm.context.RX.val, "MAPPING").then(okGetGroupMembers, errGetGroupMembers);
		}

		function okGetList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			var startFlt = false;
			if(_startTab == 'UNKNOWN') {
				vm.tabALT = altVM(r, ['-Total']);
				vm.tabALT.Title = 'Unknown';
			}
			else if(_startTab == 'IGNORED') {
				vm.tabALT = altVM(r);
				vm.tabALT.Title = 'Ignored';
			}
			else if(_startTab == 'NOMAP') {
				vm.tabNoMap = noMapVM(r);
				startFlt = true;
			}
			else {
				displayVM(r);
				startFlt = true;
			}

			if(startFlt) {
				// show tab and run filtering on next digest cycle
				$timeout(function() {
					_filterReady = true;
					filterChange(true);
				});
			}

			// show tab bar
			vm.activeTab = _startTab;
			vm.showTabBar = true;
			vm.action = 'LIST';

			// display ok message after pending edits
			if(!!_pendingEdit) {
				msgSvc.ok(_pendingEdit.title, _pendingEdit.okMsg, _pendingEdit.async);
				_pendingEdit = null;
			}

		}

		function errGetList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r !== null) {
				r = r || {};
				errSvc.warn(_startTab + ' Error loading list', 'transformCtl.errGetList', r.status, utilSvc.http.safeResponse(r));
			}

			_pendingEdit = null;
			$state.go(_featureName, {rxid: null, tab: ''}, {reload: _featureName});
		}
	}

	// MAPPING GROUP MEMBERS
	function okGetGroupMembers(r) {
		vm.grpMembers = Array.isArray(r) ? r : [];
	}

	function errGetGroupMembers(r) {
		vm.grpMembers = [];
	}


	/**
	 *    TAB: CHANGE
	 */

	function tabChange(tabName) {

		if(vm.isWaiting) {
			return;
		}

		// clear any partial edits
		vm.tfmModel = {};
		vm.itvModel = {};
		vm.showEditAdjustments = false;
		vm.editAdjustments = [];
		_pendingEdit = null;
		vm.popup = {};
		vm.grpMembersShow = false;

		// reload list every tab click
		contextSubmit(tabName);

	}


	/**
	 *    FILTER: CHANGE
	 */

	function filterChange(immediate, pageNumber) {

		if(!_filterReady) {
			return;
		}

		// mark filters dirty
		_filterDirty = true;

		// filtering in-progress
		if(_filtering) {
			return;
		}
		_filtering = true;
		_filterDirty = false;

		// debounce input
		var delayTime = !!immediate ? 0 : 350;
		$timeout(function() {

			var newItems = [],
				newPaging = {
					Page: 1,
					Size: 0,
					Total: 0,
					TooMany: 0
				};

			var targetFlt = {};
			switch(vm.activeTab) {
				case 'TRANSFORM':
					targetFlt = vm.tabCrossRef;
					break;
				case 'COMPOUND':
					targetFlt = vm.tabCompound;
					break;
				case 'NOMAP':
					targetFlt = vm.tabNoMap;
					break;
				default:
					throw new Error('transformCtl.filterChange, active tab unknown: ' + vm.activeTab);
			}

			// text, date filters
			newItems = $filter('filter')(targetFlt.DataItems, targetFlt.FilterTxt);
			if(newItems.length > 0) {
				newItems = $filter('filterDatesAsText')(newItems, targetFlt.FilterDates, targetFlt.FilterDatesConfig, 'M/d/yyyy');
			}

			// sort, paging
			if(newItems.length > 0) {
				newItems = $filter('orderBy')(newItems, targetFlt.SortBy);
			}
			newPaging.Page = targetFlt.Paging.Page;
			newPaging.Size = targetFlt.Paging.Size;

			// apply current page filter to newItems array
			newPaging.Total = vm.getTotalPages(newItems.length, newPaging.Size);
			if(validSvc.isNumber(pageNumber) && pageNumber > 1) {

				// adjust page number on max after filtering
				if(pageNumber > newPaging.Total) {
					pageNumber = newPaging.Total;
				}

				// calculate page starting index
				var pageStart = ((pageNumber - 1) * newPaging.Size) - 1;
				if(pageStart + 1 > newItems.length) {
					newPaging.Page = 1;
					pageStart = 0;
				}

				// cut out this page
				newItems = newItems.slice(pageStart, newPaging.Size);

			}
			else {
				// reset paging
				newPaging.Page = 1;

				// show first page of rows
				if(newItems.length > 0 && newItems.length > newPaging.Size) {
					newItems = newItems.slice(0, newPaging.Size);
				}
			}

			// done filtering
			targetFlt.Items = newItems;
			targetFlt.Paging = newPaging;
			_filtering = false;

			// run again? data changed during filtering
			if(_filterDirty) {
				filterChange(true);
			}

		}, delayTime);

	}


	/**
	 *    ADD / EDIT MODE TRANSITIONS
	 */

	function tfmAddSetup(newType) {

		// entering ADD mode
		// note: used by all tabs including UNKNOWN and IGNORED

		if(vm.isWaiting) {
			return;
		}

		// pre-fill new item with tab data
		var tabData = {};
		switch(vm.activeTab) {

			case 'TRANSFORM':
				tabData = vm.tabCrossRef.FilterTxt;
				break;

			case 'COMPOUND':
				tabData = vm.tabCompound.FilterTxt;
				break;

			case 'UNKNOWN':
			case 'IGNORED':
				if(vm.activeTab == 'IGNORED' && newType == 'IGNORED') {
					// new IGNORED, no data preloaded
					tabData = {};
				}
				else {
					// convert from alt detail
					tabData = {
						PreviousStatus: vm.activeTab,
						ItemCode: vm.altDetail.ItemCode,
						Description: '',
						MultTxt: 1.0,
						NDCTxt: ''
					};
					if(Array.isArray(vm.altDetail.Items) && vm.altDetail.Items.length > 0) {
						tabData.Description = vm.altDetail.Items[0].ItemDesc;
					}
				}
				break;

			case 'NOMAP':
				// pre-populate with NDC
				tabData = {
					PreviousStatus: vm.activeTab,
					ItemCode: vm.tabNoMap.AddNdc,
					Description: '',
					MultTxt: 1.0,
					NDCTxt: ''
				};
				break;

			default:
				throw new Error('transformCtl.tfmAddSetup, tab name unknown: ' + vm.activeTab);
		}

		vm.tfmModel = tfmEditVM({
			Id: 'NEW',
			PreviousStatus: tabData.PreviousStatus,
			TransformType: newType,
			ItemCode: tabData.ItemCode,
			Description: tabData.Description,
			ActiveTxt: 'YES',
			Intervals: [{
				Id: 'NEW',
				StartDate: 'ongoing',
				EndDate: 'ongoing',
				Transforms: [
					{
						Multiplier: tabData.MultTxt,
						NDC: tabData.NDCTxt
					}
				]
			}]
		});

		// select Intervals[0]
		itvClick(vm.tfmModel);

		_pendingEdit = null;
		_tfmDirty = false;
		_filterReady = false;

		vm.action = 'ADD';

	}

	function tfmEdit(item) {

		// entering UPDATE mode

		if(vm.isWaiting) {
			return;
		}

		// check for other edits in progress
		if(vm.action !== 'LIST') {
			msgSvc.ok(vm.action + ' In Progress', 'Please finish your current edits.');
			return;
		}

		_pendingEdit = null;
		_tfmDirty = false;
		_filterReady = false;

		// re-get item
		tfmGet(item.Id);

	}

	function tfmEditCancel() {

		// used by both ADD and UPDATE actions
		// note: used by all tabs including UNKNOWN and IGNORED

		if(vm.isWaiting) {
			return;
		}
		var priorTransformType = vm.tfmModel.TransformType;
		vm.tfmModel = {};
		vm.itvModel = {};
		vm.showEditAdjustments = false;
		vm.editAdjustments = [];
		vm.popup = {};
		vm.grpMembersShow = false;

		_pendingEdit = null;

		// re-submit context if dirty
		if(_tfmDirty) {
			contextSubmit(vm.activeTab);
		}
		else {

			switch(vm.activeTab) {

				case 'TRANSFORM':
				case 'COMPOUND':
				case 'NOMAP':
					_filterReady = true;
					vm.action = 'LIST';
					break;

				case 'UNKNOWN':
					altGetDetail(vm.altDetail.ItemCode);
					break;

				case 'IGNORED':
					if(priorTransformType == 'IGNORED') {
						// new ignored
						_filterReady = true;
						vm.action = 'LIST';
					}
					else {
						altGetDetail(vm.altDetail.ItemCode);
					}
					break;

				default:
					throw new Error('tfmCtl.tfmEditCancel, unknown activeTab: ' + vm.activeTab);
			}
		}

	}

	// Used by asynchronous updates 
	function tfmEditRefresh() {
		tfmGet(vm.tfmModel.Id, '');
		msgSvc.ok("Page Refreshed", "");
	}

	/**
	 *    INTERVAL EDIT MODE
	 */

	function itvClick(tfm, id) {

		// called by user and in code to load an interval for editing
		vm.grpMembersShow = false;
		if(vm.isWaiting || vm.showEditAdjustments) {
			return;
		}

		// find interval by id (id is optional)
		var editIdx = -1;
		if(validSvc.isText(id)) {
			for(var i = 0; i < tfm.Intervals.length; i++) {
				tfm.Intervals[i].isActive = false;

				if(tfm.Intervals[i].Id == id) {
					editIdx = i;
				}

			}
		}

		// not found? use Interval 0
		if(editIdx < 0) {
			if(tfm.Intervals.length > 0) {
				editIdx = 0;
			}
			else {
				throw new Error('transformCtl.itvClick, no intervals exist, id not found: ' + id);
			}
		}

		// set active
		var itv = tfm.Intervals[editIdx];
		itv.isActive = true;

		// remove any inbound NDC transforms referencing themself in the outbound NDC
		for(var t = 0; t < itv.Transforms.length; t++) {
			if(itv.ItemCode == itv.Transforms[t].NDC) {
				itv.Transforms[t].NDC = '';
			}
		}

		// load edit interval
		vm.itvModel = itvEditVM(itv);

	}


	/**
	 *    TRANSFORM GET
	 */

	function tfmGet(tfmId) {

		// note: doesn't check for isWaiting, user cannot access this method

		// params
		if(!validSvc.isText(tfmId)) {
			throw new Error('transformCtl.tfmGet, tfmId is missing');
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		transformRepo.tfmGet(vm.context.RX.val, tfmId).then(okTfmGet, errHandler);
	}

	function tfmGetByTransId(ndc, transid) {

		// note: doesn't check for isWaiting, user cannot access this method

		// params
		if(!validSvc.isText(ndc)) {
			throw new Error('transformCtl.tfmGetByTransId, ndc is missing');
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		transformRepo.tfmGetByDeepLink(vm.context.RX.val, ndc, transid).then(okTfmGetByDeepLink, errHandler);
	}

	function okTfmGetByDeepLink(r) {

		// set dirty flag so view is reset after exiting this deep link ndc
		_tfmDirty = true;
		okTfmGet(r);
	}

	function okTfmGet(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		// transform not found
		if(r === null) {
			var msgTxt = 'Transform may have been modified by another user';
			if(validSvc.isText(_deepLinkNdc)) {
				msgTxt = 'NDC: ' + _deepLinkNdc + ' does not have a mapping.';
			}
			msgSvc.ok('Mapping Not Found', msgTxt);
			tabChange(vm.activeTab);
			return;
		}

		// load tfm and first interval
		vm.tfmModel = tfmEditVM(tfmDisplayVM(r));
		itvClick(vm.tfmModel);

		// TFM-ADD, ask user if they want to modify the newly added start date
		if(!!_pendingEdit && _pendingEdit.action == 'TFM-ADD' && (vm.activeTab == 'TRANSFORM' || vm.activeTab == 'COMPOUND' || vm.activeTab == 'NOMAP')) {
			vm.action = 'DATEPROMPT';
			_pendingEdit = null;
		}
		else {
			vm.action = 'UPDATE';

			// display ok message after pending edits
			if(!!_pendingEdit) {
				msgSvc.ok(_pendingEdit.title, _pendingEdit.okMsg, _pendingEdit.async);
				_pendingEdit = null;
			}
		}

	}


	/**
	 *    TRANSFORM ADD / UPDATE / REMOVE / VALIDATION
	 */

	function tfmAdd() {

		if(vm.isWaiting) {
			return;
		}

		// must have at least 1 outbound
		if(vm.itvModel.Transforms.length < 1) {
			msgSvc.ok('Missing Items', 'Must have at least 1 Outbound item.');
			return;
		}

		// validate transform (no date validation needed for new tfm)
		if(!tfmPropsValid(vm.action, vm.tfmModel)) {
			msgSvc.ok('Data Issues', 'Check your data values before saving.');
			return;
		}

		// validate interval (don't validate an ignored interval, its a CDM with no NDC xref on purpose)
		if(vm.tfmModel.TransformType !== 'IGNORED' && !itvPropsValid(vm.action, vm.tfmModel, vm.itvModel)) {
			msgSvc.ok('Data Issues', 'Check your data values before saving.');
			return;
		}

		_pendingEdit = {
			action: 'TFM-ADD',
			title: 'Add ' + tabUiName(vm.tfmModel.TransformType),
			okMsg: vm.tfmModel.ItemCode.val + ' added'
		};

		// confirmation depends on activeTab
		if(vm.activeTab == 'TRANSFORM' || vm.activeTab == 'COMPOUND' || vm.tfmModel.TransformType == 'IGNORED') {

			msgSvc.confirm({
				id: 'ops.transform.add',
				title: 'Add ' + tabUiName(vm.activeTab),
				msg: 'Add Item Code ' + vm.tfmModel.ItemCode.val + '?',
				buttons: [
					{text:'OK', result:'YES', cancel: false},
					{text:'CANCEL', result:'CANCEL', cancel: true}
				]
			}).then(userConfirm, userConfirm);

		}
		else if(vm.tfmModel.TransformType == 'IGNORED') {

			msgSvc.confirm({
				id: 'ops.transform.add',
				title: 'Add ' + tabUiName(vm.activeTab),
				msg: 'Add Item Code ' + vm.tfmModel.ItemCode.val + '?',
				notes: {
					prompt: 'optional notes',
					maxlength: 100,
					out: ''
				},
				buttons: [
					{text:'OK', result:'YES', cancel: false},
					{text:'CANCEL', result:'CANCEL', cancel: true}
				]
			}).then(userConfirm, userConfirm);

		}
		else if(vm.activeTab == 'IGNORED') {

			msgSvc.confirm({
				id: 'ops.transform.add.convert',
				title: 'Convert ' + tabUiName(vm.activeTab),
				msg: 'Convert ' + vm.tfmModel.ItemCode.val + ' to ' + tabUiName(vm.tfmModel.TransformType) + '?',
				buttons: [
					{text:'OK', result:'YES', cancel: false},
					{text:'CANCEL', result:'CANCEL', cancel: true}
				]
			}).then(userConfirm, userConfirm);

		}
		else if(vm.activeTab == 'UNKNOWN') {

			msgSvc.confirm({
				id: 'ops.transform.add.convert',
				title: 'Convert ' + tabUiName(vm.activeTab),
				msg: 'Convert ' + vm.tfmModel.ItemCode.val + ' to ' + tabUiName(vm.tfmModel.TransformType) + '?',
				buttons: [
					{text:'OK', result:'YES', cancel: false},
					{text:'CANCEL', result:'CANCEL', cancel: true}
				]
			}).then(userConfirm, userConfirm);

		}
		else if(vm.activeTab == 'NOMAP') {

			msgSvc.confirm({
				id: 'ops.transform.add.nomap',
				title: 'Add ' + tabUiName(vm.activeTab),
				msg: 'Add ' + vm.tfmModel.ItemCode.val + ' as Single Map?',
				buttons: [
					{text:'OK', result:'YES', cancel: false},
					{text:'CANCEL', result:'CANCEL', cancel: true}
				]
			}).then(userConfirm, userConfirm);

		}
		else {
			throw new Error('tfmCtl.tfmAdd, unknown activeTab: ' + vm.activeTab);
		}

	}

	function tfmConvertToCompound() {

		if(vm.isWaiting) {
			return;
		}

		var tabTitle = tabUiName(vm.activeTab);

		_pendingEdit = {
			action: 'TFM-CONVERT',
			title: 'Convert ' + tabTitle,
			okMsg: vm.tfmModel.ItemCode.val + ' converted to compound' + (vm.context.groupEdit == 'yes' ? ' for the entire mapping group' : '')
		};

		// confim message box
		msgSvc.confirm({
			id: 'ops.transform.convert',
			title: 'Convert ' + tabTitle + ' to Compound',
			msg: 'Confirm conversion to compound for Item Code: ' + vm.tfmModel.ItemCode.val + 
			(vm.context.groupEdit == 'yes' ? ' for the entire mapping group' : '') + '?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

	}

	function tfmUpdate() {

		// only Description property is updated on a transform update
		// note: only TRANSFORM and COMPOUND use this function

		if(vm.isWaiting) {
			return;
		}

		var tfm = vm.tfmModel;

		// id needed
		if(!validSvc.isText(tfm.Id)) {
			throw new Error('tfmCtl.tfmUpdate, id required to update');
		}

		// description - optional, 3 to 250 chars
		if(validSvc.isText(tfm.Description.val)) {
			tfm.Description = validText(tfm.Description, 3, 250);
		}
		else {
			tfm.Description.fail = '';
			tfm.Description.msg = '';
		}

		if(tfm.Description.fail == 'yes') {
			msgSvc.ok('Update', 'Description must be 3 to 250 characters.');
			return;
		}

		_pendingEdit = {
			action: 'TFM-UPDATE',
			title: 'Update Description',
			okMsg: 'Description updated' + (vm.context.groupEdit == 'yes' ? ' for the entire mapping group' : '')
		};

		msgSvc.confirm({
			id: 'ops.transform.update',
			title: 'Update Description',
			msg: 'Change description to: ' + tfm.Description.val +
			(vm.context.groupEdit == 'yes' ? ' for the entire mapping group' : '') + '?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

	}

	function tfmStatusToggle() {

		// toggles tfm.Active between OFF / ON
		// note: api stores the inverse in a property called "Disabled"

		if(vm.isWaiting) {
			return;
		}

		var tabTitle = tabUiName(vm.activeTab);

		// prompt oppposite of current state
		var toggleTo = vm.tfmModel.ActiveTxt == 'YES' ? 'OFF' : 'ON';
		var prefixTxt = toggleTo == 'OFF' ? 'De' : 'Re';

		_pendingEdit = {
			action: 'TFM-ACTIVE-' + toggleTo,
			title: prefixTxt + '-activate ' + tabTitle,
			okMsg: vm.tfmModel.ItemCode.val + ' ' + prefixTxt.toLowerCase() + '-activated' +
			(vm.context.groupEdit == 'yes' ? ' for the mapping group ' : '') 
		};

		// confim message box
		msgSvc.confirm({
			id: 'ops.transform.' + toggleTo,
			title: prefixTxt + '-activate ' + tabTitle,
			msg: 'Confirm ' + prefixTxt + '-activate for Item Code: ' +  vm.tfmModel.ItemCode.val + 
			(vm.context.groupEdit == 'yes' ? ' for the entire mapping group' : '') + '?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

	}

	function tfmRemove() {

		if(vm.isWaiting) {
			return;
		}

		var tabTitle = tabUiName(vm.activeTab);

		_pendingEdit = {
			action: 'TFM-REMOVE',
			title: 'Remove ' + tabTitle,
			okMsg: vm.tfmModel.ItemCode.val + ' removed' + (vm.context.groupEdit == 'yes' ? ' for the entire mapping group' : '')
		};

		// confim message box
		msgSvc.confirm({
			id: 'ops.transform.remove',
			title: 'Remove ' + tabTitle,
			msg: 'Confirm remove for Item Code: ' + vm.tfmModel.ItemCode.val + 
			(vm.context.groupEdit == 'yes' ? ' for the entire mapping group' : '') + '?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

	}

	function tfmPropsValid(action, tfm) {

		// valid transform properties

		var errFnName = 'transformCtl.tfmPropsValid';

		// TransformType - always required
		if(tfm.TransformType !='TRANSFORM' && tfm.TransformType != 'COMPOUND' && tfm.TransformType != 'IGNORED') {
			throw new Error(errFnName + ', TransformType unknown: ' + tfm.TransformType);
		}

		// ItemCode is required
		if(!validSvc.isText(tfm.ItemCode.val)) {
			tfm.ItemCode.fail = 'yes';
			tfm.ItemCode.msg = 'required';
		}
		else {
			tfm.ItemCode.fail = '';
			tfm.ItemCode.msg = '';
		}

		// description - optional, 3 to 250 chars
		if(validSvc.isText(tfm.Description.val)) {
			tfm.Description = validText(tfm.Description, 3, 250);
		}
		else {
			tfm.Description.fail = '';
			tfm.Description.msg = '';
		}

		// must have at least 1 interval
		if(!Array.isArray(tfm.Intervals) || tfm.Intervals.length < 1) {
			throw new Error(errFnName + ', transform must have at least 1 Interval');
		}

		return tfm.ItemCode.fail != 'yes' && tfm.Description.fail != 'yes';

	}

	function tfmGroupConfirm(list) {
		// confim message box
		var msg = {
			id: 'ops.transform.group',
			title: 'Confirm Group Edit',
			msg: 'This edit will be applied to the entire mapping group' + (list.length > 0 ? (' except the following ' + list.length + ' pharmacies') : ''),
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'Copy to clipboard', result: 'COPY', cancel: false, hide: list.length <= 0},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			],			
			detail: list.join(',')
		};
		
		msgSvc.confirm(msg).then(userGroupConfirm, userGroupConfirm);

	}

	/**
	 *    INTERVALS CRUD / VALIDATION
	 */

	function itvAdd() {

		if(vm.isWaiting) {
			return;
		}

		// current interval is already created for tomorrow?
		var dtCurrentStart = validSvc.isDate(vm.tfmModel.Intervals[0].StartDate) ? $filter('date')(vm.tfmModel.Intervals[0].StartDate, 'M/d/yyyy') : 'ongoing',
			tmr = utilSvc.dt.zeroTime(new Date());
		tmr = $filter('date')(utilSvc.dt.addDays(tmr, 1), 'M/d/yyyy');
		if(dtCurrentStart == tmr) {
			msgSvc.ok('Date Range - Not Added', 'Most recent Date Range already exists starting tomorrow');
			return;
		}

		// get last interval, check if its EndDate is not "ongoing"
		for(var i = 0; i < vm.tfmModel.Intervals.length; i++) {
			if(!!vm.tfmModel.Intervals[i].isLastInterval) {
				if(vm.tfmModel.Intervals[i].EndDate != 'ongoing') {
					msgSvc.ok('Date Range - Not Added', 'Most recent Date Range must have an ongoing End Date.');
					return;
				}
			}
		}

		_pendingEdit = {
			action: 'ITV-ADD',
			title: 'Add Date Range',
			okMsg: vm.tfmModel.ItemCode.val + ' new Date Range added' + (vm.context.groupEdit == 'yes' ? ' for the entire mapping group' : '')
		};

		// confim message box
		msgSvc.confirm({
			id: 'ops.transform.interval.add',
			title: 'Add Date Range',
			msg: 'Add new date range for for Item Code: ' + vm.tfmModel.ItemCode.val + 
			(vm.context.groupEdit == 'yes' ? ' for the entire mapping group' : '') + '?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

	}

	function itvAddXref() {

		vm.itvModel.Transforms.push({
			NDC: validSvc.newProp(''),
			Multiplier: validSvc.newProp(1.0)
		});

	}

	function itvRemoveXref(idx) {
		vm.itvModel.Transforms.splice(idx, 1);
	}

	function itvUpdateXrefs() {

		// update Transforms NDC/Multiplier array items

		if(vm.isWaiting) {
			return;
		}

		// must have at least 1 transform
		if(vm.itvModel.Transforms.length < 1) {
			msgSvc.ok('Missing Items', 'Must have at least 1 Outbound item.');
			return;
		}

		// validate properties
		if(!itvPropsValid(vm.action, vm.tfmModel, vm.itvModel)) {
			msgSvc.ok('Data Issues', 'Check your data values before saving.');
			return;
		}

		// tab title
		var tabTitle = tabUiName(vm.activeTab);

		_pendingEdit = {
			action: 'ITV-UPDATE-DATA',
			title: 'Update ' + tabTitle,
			async: vm.context.groupEdit == 'yes',
			okMsg: vm.tfmModel.ItemCode.val + ' ' + tabTitle + (vm.context.groupEdit == 'yes' ? ' for the entire mapping group' : '') + ' updated'
		};

		msgSvc.confirm({
			id: 'ops.transform.itv.update.data',
			title: 'Update Map',
			msg: 'Update ' + tabTitle + 
			(vm.context.groupEdit == 'yes' ? ' for the entire mapping group' : '') + '?',
			notes: {
				prompt: 'optional change notes',
				maxlength: 100,
				out: ''
			},
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

	}

	function itvUpdateDates() {

		// update interval date range

		if(vm.isWaiting) {
			return;
		}

		// validate
		if(!itvDatesValid(vm.itvModel, true)) {
			msgSvc.ok('Data Issues', 'Check your date values before saving.');
			return;
		}

		// find server dates for this interval (not being edited by the user)
		var itv = null,
			itvIndex = -1;
		for(var i = 0; i < vm.tfmModel.Intervals.length; i++) {
			if(vm.tfmModel.Intervals[i].Id == vm.itvModel.Id) {
				itvIndex = i;
				break;
			}
		}

		// not found
		if(itvIndex < 0) {
			throw new Error('transformCtl.itvUpdateDates, interval not found by id: ' + vm.itvModel.Id);
		}
		itv = vm.tfmModel.Intervals[itvIndex];

		var dtStart = validSvc.isDate(itv.StartDate) ? $filter('date')(itv.StartDate, 'M/d/yyyy') : 'ongoing',
			dtEnd = validSvc.isDate(itv.EndDate) ? $filter('date')(itv.EndDate, 'M/d/yyyy') : 'ongoing',
			dtItvStart = validSvc.isDate(vm.itvModel.StartDate.val) ? $filter('date')(vm.itvModel.StartDate.val, 'M/d/yyyy') : 'ongoing',
			dtItvEnd = validSvc.isDate(vm.itvModel.EndDate.val) ? $filter('date')(vm.itvModel.EndDate.val, 'M/d/yyyy') : 'ongoing';

		// dates are the same?
		if(dtStart == dtItvStart && dtEnd == dtItvEnd) {
			msgSvc.ok('Date Range - No Change', 'Dates are the same');
			return;
		}

		// end cannot be before start
		if(dtItvStart != 'ongoing' && dtItvEnd != 'ongoing' && utilSvc.dt.diffMilli(new Date(dtItvStart), new Date(dtItvEnd)) < 0) {
			vm.itvModel.EndDate.fail = 'yes';
			vm.itvModel.EndDate.msg = 'must be on or after Start Date';
			msgSvc.ok('Date Range', 'End Date must be on or after Start Date.');
			return;
		}

		_pendingEdit = {
			action: 'ITV-UPDATE-DATES',
			title: 'Adjust Date Range',
			async: vm.context.groupEdit == 'yes',
			okMsg: vm.tfmModel.ItemCode.val + ' Date Range updated' + (vm.context.groupEdit == 'yes' ? ' for the entire mapping group' : '')
		};

		msgSvc.confirm({
			id: 'ops.transform.itv.update.dates',
			title: 'Adjust Date Range',
			msg: 'Change Date Range from: ' + dtStart + ' - ' + dtEnd + ', to: ' + dtItvStart + ' - ' + dtItvEnd + 
			(vm.context.groupEdit == 'yes' ? ' and intervals in the entire mapping group' : '') + '?',
			notes: {
				prompt: 'optional change notes',
				maxlength: 100,
				out: ''
			},
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

	}

	function itvRemove() {

		if(vm.isWaiting) {
			return;
		}

		// find interval dates (not being edited by the user)
		var itv = null;
		for(var i = 0; i < vm.tfmModel.Intervals.length; i++) {
			if(vm.tfmModel.Intervals[i].Id == vm.itvModel.Id) {
				itv = vm.tfmModel.Intervals[i].Id;
			}
		}

		// not found
		if(!!!itv) {
			throw new Error('transformCtl.itvRemove, interval not found by id: ' + vm.itvModel.Id);
		}

		var dtStart = validSvc.isDate(itv.StartDate) ? $filter('date')(itv.StartDate, 'M/d/yyyy') : 'ongoing',
			dtEnd = validSvc.isDate(itv.EndDate) ? $filter('date')(itv.EndDate, 'M/d/yyyy') : 'ongoing';

		// cannot remove all intervals
		if(vm.tfmModel.Intervals.length < 2) {
			msgSvc.ok('Remove Date Range', 'Cannot remove, at least 1 Date Range is required');
			return;
		}

		_pendingEdit = {
			action: 'ITV-REMOVE',
			title: 'Remove Date Range',
			okMsg: vm.tfmModel.ItemCode.val + ' Date Range removed'
		};

		msgSvc.confirm({
			id: 'ops.transform.itv.remove',
			title: 'Remove Date Range',
			msg: 'Remove Date Range: ' + dtStart + ' - ' + dtEnd + '?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

	}

	function itvPropsValid(action, tfm, itv) {

		// valid interval properties

		var xref = null,
			multValid = true,
			ndcValid = true,
			mTxt = '';

		for (var i = 0; i < itv.Transforms.length; i++) {
			xref = itv.Transforms[i];
			mTxt = xref.Multiplier.val.toString();

			// multiplier - required, cannot be <= 0 or > 1,000,000
			if(!validSvc.isNumber(xref.Multiplier.val) || xref.Multiplier.val <= 0 || xref.Multiplier.val > 1000000) {
				xref.Multiplier.fail = 'yes';
				xref.Multiplier.msg = 'required number between 0 and 1,000,000';
				multValid = false;
			}
			else if(mTxt.indexOf('.') && (mTxt.length - mTxt.lastIndexOf('.') > 5)) {
				// max 4 significant digits
				xref.Multiplier.fail = 'yes';
				xref.Multiplier.msg = 'maximum 4 decimal place accuracy allowed';
				multValid = false;
			}
			else {
				xref.Multiplier.fail = 'no';
				xref.Multiplier.msg = '';
			}

			// ndc - optional for NDC type, required for CDM type
			if(tfm.TransformType == 'COMPOUND' || validSvc.isText(xref.NDC.val)) {

				// NDC format
				var newNDC = ndcCleanUp(xref.NDC.val);
				if(newNDC.fail) {
					xref.NDC.fail = 'yes';
					xref.NDC.msg = newNDC.msg;
					ndcValid = false;
				}
				else {
					xref.NDC = validSvc.newProp(newNDC.val);
					xref.NDC.fail = xref.NDC.fail ? 'yes' : 'no';
				}

			}
			else {
				xref.NDC.fail = '';
				xref.NDC.msg = '';
			}

		}

		// result
		return  multValid && ndcValid;

	}

	function itvDatesValid(itv, nullOk) {

		itv.StartDate = dateValid(itv.StartDate, nullOk);
		itv.EndDate = dateValid(itv.EndDate, nullOk);

		return itv.StartDate.fail != 'yes' && itv.EndDate.fail != 'yes';

	}


	/**
	 *    ADJUSTMENTS USER CONFIRM
	 */

	function adjCancel() {

		vm.showEditAdjustments = false;
		vm.editAdjustments = [];

		_pendingEdit = null;

	}

	function adjApprove() {

		// user approved adjustments
		// note: only adjustments will set this to true
		vm.showEditAdjustments = false;
		vm.editAdjustments = [];

		runPendingEdit(true, vm.itvModel.ChangeNotes, false);
	}


	/**
	 *    ALT DETAIL
	 *    detail methods shared by UNKNOWN and IGNORED types
	 */

	function altGetDetail(itemCode) {

		if(vm.isWaiting) {
			return;
		}

		_pendingEdit = null;
		_tfmDirty = false;
		_filterReady = false;

		vm.isWaiting = true;
		msgSvc.wait(true);

		// api get detail
		switch(vm.activeTab) {
			case 'UNKNOWN':
				// note: ItemCode is the id for UNKNOWN get
				transformRepo.ukGetDetail(vm.context.RX.val, itemCode).then(okGetAlt, errHandler);
				break;
			case 'IGNORED':
				transformRepo.igGetDetail(vm.context.RX.val, itemCode).then(okGetAlt, errHandler);
				break;
			default:
				throw new Error('tfmCtl.altGetDetail, unknown active tab: ' + vm.activeTab);
		}

		function okGetAlt(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.altDetail = altDetailVM(r);
			vm.action = 'UPDATE';

		}

	}

	function altDetailExit() {

		if(vm.isWaiting) {
			return;
		}

		vm.altDetail = {};
		_pendingEdit = null;

		// always refresh list
		contextSubmit(vm.activeTab);

	}


	/**
	 *    ALT CONVERT
	 *    shared by UNKNOWN and IGNORED views
	 */

	function altConvertTo(newType) {

		// move UNKNOWN or IGNORED item to another tab

		if(vm.isWaiting) {
			return;
		}

		switch(newType) {

			case 'TRANSFORM':
			case 'COMPOUND':
				tfmAddSetup(newType);
				break;

			case 'IGNORED':

				_pendingEdit = {
					action: 'ALT-IGNORED',
					title: 'Ignore Code',
					okMsg: vm.altDetail.ItemCode + ' ignored'
				};

				msgSvc.confirm({
					id: 'ops.transform.alt.ignore',
					title: 'Ignore Code ' + vm.altDetail.ItemCode,
					msg: 'Ignore unknown item code?',
					notes: {
						prompt: 'optional notes',
						maxlength: 100,
						out: ''
					},
					buttons: [
						{text:'OK', result:'YES', cancel: false},
						{text:'CANCEL', result:'CANCEL', cancel: true}
					]
				}).then(userConfirm, userConfirm);
				break;

			default:
				throw new Error('tfmCtl.altConvertTo, unknown type: ' + newType);

		}

	}


	/**
	 *    ALT TO TFM EDIT
	 *    switch from UNKNOWN to TfmEdit view
	 */

	function linkToTfmEdit(tfmType, tfmId) {

		// this UNKNOWN ItemCode also has a SINGLE or COMPOUND map defined, switch to the tfmEdit view for this item code

		if(vm.isWaiting) {
			return;
		}

		if(!validSvc.isText(tfmType) || !validSvc.isText(tfmId)) {
			throw new Error('tfmCtl.linkToTfmEdit, alt detail required Type and Id');
		}

		// setup viewstate to "fake" we are coming from the LIST
		displayVM();
		vm.tabALT = altVM();
		vm.action = 'LIST';
		vm.activeTab = tfmType;

		tfmEdit({Id:tfmId});

	}


	/**
	 *    ALT BACK TO UNKNOWN DETAIL
	 *    go from Single/Compound edit view back to alt Unknown details view
	 */

	function linkToUnknownDetail(itemCode) {

		if(vm.isWaiting) {
			return;
		}

		if(!validSvc.isText(itemCode)) {
			throw new Error('tfmCtl.linkToUnknownDetail, item code required');
		}

		// setup viewstate to "fake" we are coming from the LIST
		displayVM();
		vm.tabALT = altVM();
		vm.action = 'LIST';
		vm.activeTab = 'UNKNOWN';

		altGetDetail(itemCode);

	}


	/**
	 *    ALT UPDATE
	 */

	function ignoredUpdate() {

		// similar to tfmUpdate
		// note: Description holds the notes for an IGNORED alt item

		if(vm.isWaiting) {
			return;
		}

		var alt = vm.altDetail;

		// item code needed
		if(!validSvc.isText(alt.Id)) {
			throw new Error('tfmCtl.ignoredUpdate, id required to update');
		}

		// description - optional, 3 to 250 chars
		if(validSvc.isText(alt.Description.val)) {
			alt.Description = validText(alt.Description, 3, 250);
		}
		else {
			alt.Description.fail = '';
			alt.Description.msg = '';
		}

		if(alt.Description.fail == 'yes') {
			msgSvc.ok('Update', 'Notes must be 3 to 250 characters.');
			return;
		}

		_pendingEdit = {
			action: 'IGNORED-UPDATE',
			title: 'Update Notes',
			okMsg: 'Notes updated'
		};

		msgSvc.confirm({
			id: 'ops.alt.update',
			title: 'Update Notes',
			msg: 'Change notes to: ' + alt.Description.val + '?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

	}


	/**
	 *    SHARED EDIT HANDLERS
	 *    handles all edit requests: add/update/remove
	 */

	function userConfirm(r) {

		// async delegate handler for OK to delete message box

		// user said yes
		if(!!r && r.result == 'YES') {

			// use false, only adjustments view will set to true
			runPendingEdit(false, r.notes, false);

		}
		else {
			_pendingEdit = null;
		}

	}

	function userGroupConfirm(r) {
		// user said yes
		if(!!r && r.result == 'YES') {
			// group confirm is set to true
			runPendingEdit(false, vm.itvModel.ChangeNotes, true);
		}
		else {
			_pendingEdit = null;
			vm.isWaiting = false;
			msgSvc.wait(false);	
		}

	}

	function runPendingEdit(userConfirmed, notes, groupConfirmed) {

		// run edit action after user confirmation or adjustments confirmation

		vm.isWaiting = true;
		msgSvc.wait(true);

		// set model edit properties
		vm.tfmModel.Confirmed = userConfirmed;
		vm.tfmModel.isDirty = true;
		_tfmDirty = true;

		// add user change notes to interval model
		notes = validSvc.isText(notes) ? notes : '';
		vm.itvModel.ChangeNotes = notes;

		var successHandler =  vm.context.groupEdit == 'yes' && !groupConfirmed ? groupConfirmHandler : okHandler;

		switch(_pendingEdit.action) {

			case 'TFM-ADD':
				transformRepo.tfmAdd(vm.context.RX.val, vm.tfmModel, vm.itvModel, groupConfirmed, vm.context.groupEdit).then(successHandler, errHandler);
				break;
			case 'TFM-UPDATE':
				transformRepo.tfmUpdate(vm.context.RX.val, vm.tfmModel, groupConfirmed, vm.context.groupEdit).then(successHandler, errHandler);
				break;
			case 'TFM-REMOVE':
				transformRepo.tfmRemove(vm.context.RX.val, vm.tfmModel.Id, groupConfirmed, vm.context.groupEdit).then(successHandler, errHandler);
				break;
			case 'TFM-ACTIVE-OFF':
			case 'TFM-ACTIVE-ON':
			transformRepo.tfmStatusToggle(_pendingEdit.action, vm.context.RX.val, vm.tfmModel.Id, groupConfirmed, vm.context.groupEdit).then(successHandler, errHandler);
				break;
			case 'TFM-CONVERT':
				transformRepo.tfmConvertToCompound(vm.context.RX.val, vm.tfmModel.Id, groupConfirmed, vm.context.groupEdit).then(successHandler, errHandler);
				break;

			case 'ITV-ADD':
				transformRepo.itvAdd(vm.context.RX.val, vm.tfmModel.Id, groupConfirmed, vm.context.groupEdit).then(successHandler, errHandler);
				break;

			case 'ITV-REMOVE':
				alert('tbd: interval remove');
				//transformRepo.itvRemove(vm.context.RX.val, vm.itvModel.Id).then(okHandler, errHandler);
				break;

			case 'ITV-UPDATE-DATA':
				transformRepo.itvUpdateXrefs(vm.context.RX.val, vm.tfmModel, vm.itvModel, groupConfirmed, vm.context.groupEdit).then(successHandler, errHandler);
				break;

			case 'ITV-UPDATE-DATES':
				transformRepo.itvUpdateDates(vm.context.RX.val, vm.tfmModel, vm.itvModel, groupConfirmed, vm.context.groupEdit).then(successHandler, errHandler);
				break;

			case 'ALT-IGNORED':
				transformRepo.ignoreCode(vm.context.RX.val, vm.altDetail.ItemCode, notes, groupConfirmed, vm.context.groupEdit).then(successHandler, errHandler);
				break;

			case 'IGNORED-UPDATE':
				transformRepo.igUpdate(vm.context.RX.val, vm.altDetail).then(okHandler, errHandler);
				break;

			case 'XREF-IMPORT':
			case 'CMP-IMPORT':
			case 'IGNORED-IMPORT':
				transformRepo.tfmImport(vm.context.RX.val, vm.activeTab, vm.importSelectedFiles[0], vm.importConfig.override, vm.context.groupEdit).then(okHandler, errHandler);
				break;

			case 'MIGRATION':
				transformRepo.migImport(vm.context.RX.val, vm.importMigFiles).then(okHandler, errHandler);
				break;

			default:
				throw new Error('transformCtl.runPendingEdit, unknown pending edit: ' + _pendingEdit.action);
		}

	}

	function groupConfirmHandler(list) {
		// confirm result of group request test run 
		vm.isWaiting = true;
		msgSvc.wait(true);

		switch(_pendingEdit.action) {
			case 'TFM-ADD':
			case 'TFM-UPDATE':
			case 'TFM-REMOVE':
			case 'TFM-CONVERT':
			case 'TFM-ACTIVE-OFF':
			case 'TFM-ACTIVE-ON':
			case 'ITV-UPDATE-DATA':
			case 'ITV-UPDATE-DATES':
			case 'ITV-ADD':
			case 'ALT-IGNORED':
				tfmGroupConfirm(list);
				break;
			default:
				throw new Error('transformCtl.groupConfirm, unknown pending edit: ' + _pendingEdit.action);
		}

	}

	function okHandler(r) {

		vm.isWaiting = false;
		msgSvc.wait(false);

		switch(_pendingEdit.action) {

			case 'TFM-ADD':
				if(vm.activeTab == 'TRANSFORM' || vm.activeTab == 'COMPOUND' || vm.activeTab == 'NOMAP') {
					// re-get TFM
					tfmGet(r.Id, '');
				}
				else {
					// back to LIST MODE
					contextSubmit(vm.activeTab);
				}
				break;

			case 'TFM-REMOVE':
			case 'TFM-ACTIVE-OFF':
			case 'TFM-ACTIVE-ON':
			case 'ALT-IGNORED':
			case 'XREF-IMPORT':
			case 'CMP-IMPORT':
			case 'IGNORED-IMPORT':
				// back to LIST MODE
				contextSubmit(vm.activeTab);
				break;

			case 'TFM-CONVERT':
				vm.activeTab = 'COMPOUND';
				tfmGet(vm.tfmModel.Id, '');
				break;

			case 'TFM-UPDATE':
			case 'ITV-ADD':
				// re-get transform, default interval
				tfmGet(vm.tfmModel.Id, '');
				break;

			case 'IGNORED-UPDATE':
				// re-get last item
				altGetDetail(vm.altDetail.ItemCode);
				break;

			case 'ITV-UPDATE-DATA':
			case 'ITV-UPDATE-DATES':
				// re-get transform, specific interval
				tfmGet(vm.tfmModel.Id, vm.itvModel.Id);
				break;

			case 'MIGRATION':
				importCsvToggle('MIGRATION');
				contextSubmit('TRANSFORM');
				break;

			default:
				throw new Error('transformCtl.okHandler, pending edit on tab: ' + vm.activeTab + ' is unknown: ' + _pendingEdit.action);
		}

	}

	function errHandle422(pending, r) {

		switch(pending.action) {

			case 'XREF-IMPORT':
			case 'CMP-IMPORT':
			case 'IGNORED-IMPORT':
				// import has special error text
				vm.importErrors = r.importErrors;
				msgSvc.ok(tabUiName(vm.activeTab) + ' Import Errors', 'Some line items were not imported due to errors.');
				break;

			case 'MIGRATION':
				// import has special error text
				vm.importErrors = r.importErrors;

				// migration has three files, split output into file types
				var errs = vm.importErrors,
					errOutput = [],
					splitErrName = [];
				for(var i = 0; i < errs.length; i++) {
					if(validSvc.isText(errs[i].Name)) {

						splitErrName = errs[i].Name.split('|');
						if(splitErrName.length === 2 && splitErrName[0].length > 0) {
							errOutput.push({
								FileType: splitErrName[0].toUpperCase(),
								Name: splitErrName[1],
								Rule: errs[i].Rule
							});
						}
					}
				}

				vm.importErrors = errOutput;
				msgSvc.ok(tabUiName(vm.activeTab) + ' Import Errors', 'Some line items were not imported due to errors.');
				break;

			case 'TFM-REMOVE':
			case 'TFM-ACTIVE-OFF':
			case 'TFM-ACTIVE-ON':
			case 'TFM-CONVERT':
			case 'ITV-ADD':
			case 'ITV-REMOVE':
				msgSvc.ok('Cannot ' + pending.title, 'Api Error: ' + r.msg);
				break;

			case 'ALT-IGNORED':
			case 'IGNORED-UPDATE':
				msgSvc.ok('Cannot ' + pending.title, r.msg);
				break;

			default:
				if(!!r.models) {
					vm.tfmModel = r.models.tfmModel;
					vm.itvModel = r.models.itvModel;
					msgSvc.ok('Data Invalid', 'Server encountered data errors, please re-check your data');
				}
				else {
					errSvc.error(vm.activeTab + '.' + pending.action + ': Unknown Api 422 format error', 'transformCtl.errHandler' + vm.action, r.status, utilSvc.http.safeResponse(r));
				}
				break;
		}

	}

	function errHandler(r) {

		vm.isWaiting = false;
		msgSvc.wait(false);

		if(r === null) {
			_pendingEdit = null;
			return;
		}
		else if(r.status === 409) {
			// conflict
			switch(_pendingEdit.action) {
				case 'ITV-UPDATE-DATA':
				case 'ITV-UPDATE-DATES':
					tfmGet(vm.tfmModel.Id, '');
					errSvc.warn('There is a pending change on this mapping, refresh and try again', r.status, utilSvc.http.safeResponse(r));
					break;
				default:
					errSvc.warn('Could not Save, already exists in the database. Verify and try again.', 'transformCtl.errHandler.' + _pendingEdit, 409, utilSvc.http.safeResponse(r));
			}
		}
		else if(r.status == 422) {

			if(!!r.adj) {
				vm.showEditAdjustments = true;
				vm.editAdjustments = r.adj;
				return;
			}

			errHandle422(_pendingEdit, r);
		}
		else {
			errSvc.error(vm.activeTab + '.' + _pendingEdit.action + ': Unknown Api error', 'transformCtl.errHandler' + vm.action, r.status, utilSvc.http.safeResponse(r));
		}

		_pendingEdit = null;

	}


	/**
	 *    POPUP
	 *    used for NDC catalog search
	 */

	function openPopup(evt, propName, propIdx) {

		if(vm.isWaiting) {
			return;
		}

		// get ndc/desc text from property
		var ndc = '',
			desc = '';

		switch(propName) {

			case 'ItemCode':
				ndc = vm.tfmModel.ItemCode.val;
				break;

			case 'Description':
				desc = validSvc.isText(vm.tfmModel.Description.val) ? vm.tfmModel.Description.val.toString() : '';
				break;

			case 'Xref':
				ndc = vm.itvModel.Transforms[propIdx].NDC.val;
				break;

			default:
				throw new Error('tfmCtl.openPopup, property name unknown: ' + propName);
		}

		// limit description
		if(desc.length > 50) {
			desc = desc.substr(0,50);
		}

		vm.popup = {
			title: 'NDC Catalog Search',
			ready: false,
			propName: propName,
			propIdx: propIdx,
			NDC: validSvc.newProp(ndc),
			Desc: validSvc.newProp(desc),
			Items: [],
			SortBy: 'NDC',
			Paging: {
				Size: 50
			}
		};

		// remember the clicked vertical location
		var elem = evt.target,
			offsetY = 0, // pop over
			hitRow = false;

		// loop html elements back to top of table
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
				break;
			}

			// add offset, get next element
			offsetY += elem.offsetTop;
			elem = elem.offsetParent;
		}
		elem = null;

		// move popup to clicked row
		var popup = document.getElementById('tablePopupContent');
		if(!!popup) {
			popup.style.top = offsetY.toString() + 'px';
		}

		// wait for digest before showing
		$timeout(function() {
			vm.popup.ready = true;
		}, 100);

	}

	function popupQueryValid() {

		var resultText = '';

		var ndc = vm.popup.NDC.val,
			desc = vm.popup.Desc.val;

		// ndc or desc is required
		if(!validSvc.isText(ndc) && !validSvc.isText(desc)) {
			vm.popup.NDC.fail = 'yes';
			vm.popup.Desc.fail = 'yes';
			resultText = (resultText.length > 0 ? ', ' : '') + 'NDC or Description search text is required';
		}

		// ndc, optional 3 to 13 characters
		if(validSvc.isText(ndc) && (ndc.length < 3 || ndc.length > 13)) {
			vm.popup.NDC.fail = 'yes';
			resultText = (resultText.length > 0 ? ', ' : '') + 'NDC must be 3 to 13 characters';
		}
		else {
			vm.popup.NDC.fail = 'no';
		}

		// description, optional 3 to 50 characters
		if(validSvc.isText(desc) && (desc.length < 3 || desc.length > 50)) {
			vm.popup.Desc.fail = 'yes';
			resultText = (resultText.length > 0 ? ', ' : '') + 'Description must be 3 to 50 characters';
		}
		else {
			vm.popup.Desc.fail = 'no';
		}

		return resultText;
	}

	function popupSearch(showMsg) {

		// search query valid
		var result = popupQueryValid();
		if(result !== '') {
			if(showMsg) {
				msgSvc.ok('NDC Search', 'Check filter properties. ' + result);
			}
			return;
		}

		// exit if waiting
		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true);

		vm.popup.Items = [];

		// send api request
		catalogsRepo.search(vm.popup).then(okSearch, errSearch);

		function okSearch(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.popup.Items = Array.isArray(r.Items) ? r.Items : [];
			vm.popup.Paging = {
				Page: 1,
				Size: appConst.app.display.pagingSize,
				Total: vm.getTotalPages(vm.popup.Items.length, appConst.app.display.pagingSize),
				TooMany: r.TooMany
			};

			// none found
			if(vm.popup.Items.length < 1) {
				msgSvc.ok('NDC Catalog Search', 'None found');
			}

		}

		function errSearch(r) {

			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r !== null) {
				errSvc.warn('Unknown get response', 'tfmCtl.errPopupSearch', r.status, utilSvc.http.safeResponse(r));
			}

			$state.go(_featureName, {rxid: null, tab: ''}, {reload:_featureName});
		}

	}

	function closePopup(item) {

		// user cancelled
		if(!item) {
			vm.popup = {};
			return;
		}

		// put values into item which launched the popup
		switch(vm.popup.propName) {

			case 'ItemCode':
			case 'Description':
				vm.tfmModel.ItemCode = validSvc.newProp(item.NDC);
				vm.tfmModel.ItemCode.fail = 'no';
				vm.tfmModel.Description = validSvc.newProp(item.Description);
				vm.tfmModel.Description.fail = 'no';
				vm.tfmModel.RefItemName = item.Description;
				vm.tfmModel.DrugFormCode = item.DrugFormCode;
				vm.tfmModel.PackageSize = item.PkgSz;
				vm.tfmModel.CaseSize = item.CaseSz;
				vm.tfmModel.WholesaleUnits = item.WholesaleUnits;
				break;

			case 'Xref':
				vm.itvModel.Transforms[vm.popup.propIdx].NDC = validSvc.newProp(item.NDC);
				vm.itvModel.Transforms[vm.popup.propIdx].NDC.fail = 'no';
				vm.itvModel.Transforms[vm.popup.propIdx].Desc = item.Description;
				vm.itvModel.Transforms[vm.popup.propIdx].DrugFormCode = item.DrugFormCode;
				vm.itvModel.Transforms[vm.popup.propIdx].PackageSize = item.PkgSz;
				vm.itvModel.Transforms[vm.popup.propIdx].CaseSize = item.CaseSz;
				vm.itvModel.Transforms[vm.popup.propIdx].WholesaleUnits = item.WholesaleUnits;
				break;

			default:
				throw new Error('tfmCtl.closePopup, property name unknown: ' + propName);
		}

		vm.popup = {};

	}


	/**
	 *    IMPORT FILE EVENT HOOK
	 *    used to update file list to import
	 *    note:
	 *          directive widget-input-file throws event: 'widget.input.file'
	 *          event object: {id:'id of element', files:[] array of files if browser supports HTML5 File Api}
	 */

	$scope.$on('widget.input.file', function(event, importInfo) {
		event.stopPropagation();

		if(!!importInfo && !!importInfo.files && importInfo.files.length > 0) {
			if(vm.activeTab == 'MIGRATION') {
				switch(importInfo.id) {
					case 'migImportMult':
						vm.importMigFiles.mult = importInfo.files;
						break;
					case 'migImportXref':
						vm.importMigFiles.xref = importInfo.files;
						break;
					case 'migImportComp':
						vm.importMigFiles.comp = importInfo.files;
						break;
					default:
						throw new Error('tfmCtl.widget.inputfile, MIGRATION unknown widget id: ' + importInfo.id);
				}
			}
			else {
				vm.importSelectedFiles = importInfo.files;
			}
		}
		else {
			vm.importSelectedFiles = null;
			vm.importMigFiles = {mult: null, xref: null, comp: null};
		}

	});


	/**
	 *    SHARED IMPORT FILE
	 *    used by both tabs
	 */

	function importValidFile(newFile) {

		// required
		if(!!!newFile) {
			return 'no file selected';
		}

		// file size > 0 bytes, < 10 megabytes
		if(!validSvc.isNumber(newFile.size) || newFile.size < 1 || newFile.size > 10000000) {
			return 'file size must be 2 bytes to 10 megabytes';
		}

		// file name must be .csv
		var fName = newFile.name;
		if(!validSvc.isText(fName)) {
			return 'file has no name';
		}

		fName.trim();
		if (fName.length < 5 || (fName.substr(fName.length - 4, 4).toLowerCase() !== '.csv' && fName.substr(fName.length - 4, 4).toLowerCase() !== '.txt')) {
			return 'file name: [' + fName + '] must end with ".csv" or ".txt"';
		}

		return 'ok';

	}

	function importCsvToggle(importType) {

		if(vm.isWaiting) {
			return;
		}

		// reset state on toggle
		vm.importConfig = {};
		vm.importErrors = [];
		vm.importSelectedFiles = null;
		vm.importMigFiles = {mult: null, xref: null, comp: null};

		if((vm.action == 'IMPORT' && importType != 'MIGRATION') || vm.activeTab == 'MIGRATION') {

			// TOGGLE OFF

			if(vm.activeTab == 'MIGRATION') {
				vm.activeTab = '';
				contextSubmit('TRANSFORM');
			}
			else {
				// single / compound, return to parent list view
				vm.action = 'LIST';
			}

		}
		else {

			// TOGGLE ON

			// check for other edit states
			if(importType != 'MIGRATION' && vm.action != 'LIST') {
				msgSvc.ok('Edit In Progress', vm.action + ' editing is already in progress. Please finish before trying to import files.');
				return;
			}

			if(!validSvc.uploadSupported()) {
				msgSvc.ok('File Upload Not Supported', 'File Upload uses HTML5 FormData upload, your browser does not support it. Please upgrade to use file upload.');
				return;
			}

			// special hidden migration UI tab bar and tab
			if(importType == 'MIGRATION') {
				vm.action = '';
				vm.showTabBar = false;
				vm.activeTab = 'MIGRATION';
			}
			else {
				vm.importConfig = loadImportConfig(vm.activeTab);
				vm.action = 'IMPORT';
			}

		}

	}

	function loadImportConfig(tabName) {
		switch(tabName) {
			case 'TRANSFORM':
				return {
					title: 'Single Item File Upload',
					subtitle: 'Uploaded items will be added or replace existing items.',
					helpTitle: 'Mapping Single Upload',
					helpLink: 'ops-mapping-single-upload',
					override: 'no'
				};
			case 'COMPOUND':
				return {
					title: 'Compound File Upload',
					subtitle: 'Uploaded compounds will be added or replace existing compounds.',
					helpTitle: 'Mapping Compound Upload',
					helpLink: 'ops-mapping-compound-upload',
					override: 'no'
				};
			case 'IGNORED':
				return {
					title: 'Ignored File Upload',
					subtitle: 'Uploaded ignored CDMs will be added or replace existing ignored items.',
					helpTitle: 'Mapping Ignored Upload',
					helpLink: 'ops-mapping-ignored-upload'
				};
			default:
				alert('unknown import tab: ' + tabName);
				return {};
		}
	}

	function importCsvSend() {

		// import CSV file

		if(vm.isWaiting) {
			return;
		}

		// migration?
		if(vm.activeTab == 'MIGRATION') {

			var multFile = vm.importMigFiles.mult;
			var xrefFile = vm.importMigFiles.xref;
			var compFile = vm.importMigFiles.comp;

			// at least 1 file required
			var multOk = !!multFile && multFile.length === 1;
			var xrefOk = !!xrefFile && xrefFile.length === 1;
			var compOk = !!compFile && compFile.length === 1;
			if(!multOk && !xrefOk && !compOk) {
				msgSvc.ok('MIGRATION IMPORT', 'Please choose at least 1 file to import.');
				return;
			}

			// file format validation
			var fmtErrors = [],
				errMsg = '',
				filesSent = [];

			if(multOk) {
				errMsg = importValidFile(multFile[0]);
				multOk = errMsg == 'ok';
				if(multOk) {
					filesSent.push('MULTIPLIER');
				}
				else {
					vm.importMigFiles.mult = null;
					fmtErrors.push('Multiplier: ' + errMsg);
				}
			}
			else {
				multOk = true;
			}

			if(xrefOk) {
				errMsg = importValidFile(xrefFile[0]);
				xrefOk = errMsg == 'ok';
				if(xrefOk) {
					filesSent.push('CROSSREF');
				}
				else {
					vm.importMigFiles.xref = null;
					fmtErrors.push('Cross Reference: ' + errMsg);
				}
			}
			else {
				xrefOk = true;
			}

			if(compOk) {
				errMsg = importValidFile(compFile[0]);
				compOk = errMsg == 'ok';
				if(compOk) {
					filesSent.push('COMPOUND');
				}
				else {
					vm.importMigFiles.comp = null;
					fmtErrors.push('Compound: ' + errMsg);
				}
			}
			else {
				compOk = true;
			}

			if(!multOk || !xrefOk || !compOk) {
				msgSvc.ok('File Validation Errors', fmtErrors.join(', '));
				// msg has been shown to the user, exit
				return;
			}

			_pendingEdit = {
				action: 'MIGRATION',
				files: filesSent,
				title: 'Migration File Import Success',
				okMsg: 'Migration files imported with no errors'
			};

			msgSvc.confirm({
				id: 'ops.transform.migration',
				title: 'Migration File Import',
				msg: 'Import files for ' + vm.context.RX.val + '? Note: this will delete all existing Single and Compound Maps.',
				buttons: [
					{text:'OK', result:'YES', cancel: false},
					{text:'CANCEL', result:'CANCEL', cancel: true}
				]
			}).then(userConfirm, userConfirm);

		}
		else {

			// SINGLE or COMPOUND UPLOAD
			
			// 1 file selected
			if(!!!vm.importSelectedFiles || vm.importSelectedFiles.length !== 1) {
				msgSvc.ok('Please choose 1 file to upload.');
				return;
			}

			var fileFail = importValidFile(vm.importSelectedFiles[0]);
			if(fileFail != 'ok') {
				msgSvc.ok(vm.activeTab + ' UPLOAD', 'Selected file error: ' + fileFail);
				return;
			}

			var importAction = '';
			switch(vm.activeTab) {
				case 'TRANSFORM':
					importAction = 'XREF-IMPORT';
					break;
				case 'COMPOUND':
					importAction = 'CMP-IMPORT';
					break;
				case 'IGNORED':
					importAction = 'IGNORED-IMPORT';
					break;
				default:
					alert('unknown import tab: ' + vm.activeTab);
					return;
			}

			_pendingEdit = {
				action: importAction,
				override: vm.importConfig.override,
				title: tabUiName(vm.activeTab) + ' File Import',
				okMsg: vm.importSelectedFiles[0].name + ' file imported' + (vm.context.groupEdit == 'yes' ? ' for the entire mapping group' : ''),
			};

			var impMsg = 'Import ' + vm.activeTab + ' for ' + (vm.context.groupEdit =='yes' ? 'all pharmacies in the group' : vm.context.RX.val) + '?';
			if(vm.importConfig.override == 'yes') {
				impMsg += ' All intervals will be overridden.';
			}

			msgSvc.confirm({
				id: 'ops.transform.' + _pendingEdit.action.toLowerCase(),
				title: _pendingEdit.title,
				msg: impMsg,
				buttons: [
					{text:'OK', result:'YES', cancel: false},
					{text:'CANCEL', result:'CANCEL', cancel: true}
				]
			}).then(userConfirm, userConfirm);

		}

	}

	function importErrorsToCsv() {

		// save errors to CSV file

		var errs = vm.importErrors,
			lines = [],
			nameTxt = '',
			ruleTxt = '';

		// comma delimited
		for(var i = 0; i < errs.length; i++) {
			nameTxt = validSvc.isText(errs[i].Name) ? errs[i].Name : '';
			ruleTxt = validSvc.isText(errs[i].Rule) ? errs[i].Rule : '';

			// remove content commas so CSV will split properly
			lines.push(errs[i].FileType + ',' + nameTxt.replace(/,+/g,'') + ',' + ruleTxt.replace(/,+/g,'') + '\r\n');
		}

		if(lines.length > 0) {

			try {
				var csvBlob = new Blob(lines, {type: "text/plain;charset=utf-8"});
				var dtTodayTxt = utilSvc.dt.toTextWithTime(new Date());
				dtTodayTxt = dtTodayTxt.replace(/(\/|:| )+/g,'-'); // replace slash, colon and spaces with a dash

				var rxName = utilSvc.aff.rxShortNameById($scope.User.AffList, vm.context.RX.val);
				$window.saveAs(csvBlob, utilSvc.regex.cleanFilename(rxName + '-Migration-File-Errors-' + dtTodayTxt + '.csv'));
			}
			catch(err) {
				throw(err);
			}
		}

	}


	/**
	 *    EXCEL EXPORT
	 */

	function excelAllTabs(isGroupReport) {

		// already working?
		if(vm.isWaiting) {
			return;
		}

		// stop edit in process
		if(vm.action !== '' && vm.action != 'LIST') {
			msgSvc.ok(vm.action + ' In Progress', 'Please finish editing before exporting.');
			return;
		}

		// check NOMAP date range
		if(!vm.context.DateRangeValid) {
			msgSvc.ok('Cannot Export', 'Unmapped tab date range must be valid.');
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		// format filename
		var dtNow = new Date();

		var rxName = utilSvc.aff.rxShortNameById($scope.User.AffList, vm.context.RX.val);

		var reportName;
		if (isGroupReport) {
			reportName = "Mapping-Group";
		} else {
			reportName = "Mapping";
		}
		var filename = 'Verity-' + rxName + '-' + reportName + '-' + utilSvc.dt.monthShortText(dtNow) + dtNow.getFullYear().toString() + '.xlsx';

		_pendingEdit = {
			action: 'EXPORTEXCEL',
			filename: filename
		};

		var xlRequest = {
			RX: vm.context.RX.val,
			StartDate: vm.context.StartDate.val,
			EndDate: vm.context.EndDate.val
		};

		transformRepo.excelAllTabs(xlRequest, filename, isGroupReport).then(okExcelAllTabs, errExcelAllTabs);

		function okExcelAllTabs(binaryData) {

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingEdit.filename));
			}
			catch(err) {
				throw(err);
			}

			vm.isWaiting = false;
			msgSvc.wait(false);
			_pendingEdit = null;

		}

		function errExcelAllTabs(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			_pendingEdit = null;

			if(!!r) {
				errSvc.warn('Create Excel Error', 'tfmCtl.errExcelAllTabs', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    HELPERS
	 */

	function indexOfItemId(items, id) {

		if(!!!id) {
			return -1;
		}

		for(var i = 0; i < items.length; i++) {
			if(items[i].Id == id) {
				return i;
			}
		}

		return -1;
	}

	function validText(prop, min, max) {

		// required
		if(!validSvc.isText(prop.val)) {
			prop.fail = 'yes';
			prop.msg = 'required';
			return prop;
		}

		// min
		if(prop.val.length < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum ' + min.toString() + ' characters';
			return prop;
		}

		// max
		if(prop.val.length > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum ' + max.toString() + ' characters';
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;

	}

	function ndcCleanUp(val, skipEmpty) {

		var zeroPad = "00000000000",
			ndcTest = '';

		// must be text
		if(!!!skipEmpty && !validSvc.isText(val)) {
			return validSvc.newProp(val, true, 'required');
		}

		// remove all non-numeric characters
		ndcTest = val.toString().trim();
		ndcTest = ndcTest.replace(/[^0-9]+/g,'');

		// empty
		if(ndcTest.length < 1) {
			if(!!skipEmpty) {
				return validSvc.newProp('', false, '');
			}
			else {
				return validSvc.newProp(ndcTest, true, 'must be numbers');
			}
		}

		// max len
		if(ndcTest.length > 11) {
			return validSvc.newProp(ndcTest, true, 'max 11 characters');
		}

		// integer
		if(!validSvc.isInteger(parseInt(ndcTest))) {
			return validSvc.newProp(ndcTest, true, 'must be an integer');
		}

		// pad zeros if needed, pass
		ndcTest = zeroPad.substr(0, 11 - ndcTest.length) + ndcTest;
		return validSvc.newProp(ndcTest, false, '');

	}

	function ndcListToTextarea(items) {

		var result = "";

		for(var i = 0; i < items.length; i++) {
			if(items[i].fail) {
				result += items[i].val + "<< " + items[i].msg + "\n";
			}
			else {
				result += items[i].val + "\n";
			}
		}

		return result;

	}

	function dateValid(dt, nullOk) {

		// validate dates, skip nulls
		// note: requires min/max properties

		// null ok?
		if(!!nullOk && (dt.val === null || dt.val == 'ongoing' || dt.val === '')) {
			dt.fail = 'no';
			dt.msg = '';
			return dt;
		}

		// format
		var dtFmt = validSvc.isDate(dt.val) ? $filter('date')(dt.val, 'M/d/yyyy') : '';
		if(!_regexDate.test(dtFmt)) {
			dt.fail = 'yes';
			dt.msg = 'format is m/d/yyyy';
			return dt;
		}

		// value / min / max
		dt = validSvc.propDateValid(dt);
		if(dt.fail) {
			dt.fail = 'yes';
			return dt;
		}

		// pass
		dt.fail = 'no';
		dt.msg = '';
		return dt;

	}

	function tabUiName(tab) {

		switch(tab) {

			case 'TRANSFORM':
				return 'Single Map';

			case 'COMPOUND':
				return 'Compound Map';

			case 'UNKNOWN':
				return 'Unknown';

			case 'IGNORED':
				return 'Ignored';

			case 'MIGRATION':
				return 'Migration';

			case 'NOMAP':
				return 'Unmapped';

			default:
				throw new Error('tfmCtl.tabUiName, unknown activeTab: ' + tab);
		}

	}

	function activeTabName() {
		// note: angular needs this no parameter function called from inside html statements {{}}
		return tabUiName(vm.activeTab);
	}

}
 
vcentralRepo.$inject = ['$rootScope', '$q', 'apiService', 'apiErrors', 'appConst', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
	.module('espui.ops')
	.factory('vcentralRepo', vcentralRepo);


/* @ngInject */
function vcentralRepo($rootScope, $q, apiService, apiErrors, appConst, errSvc, eventSvc, utilSvc, validSvc, vmSvc) {

	var _currentPurl = '';

	// service definition
	var service = {
		modelVM: modelVM,
		getCredential: getCredential,
		updateCredential: updateCredential,
	};
	return service;

	function modelVM(data) {
		data = data || {};
		return {
			UserName: validSvc.isText(data.UserName) ? data.UserName : validSvc.newProp(data.UserName),
			Password: validSvc.isText(data.Password) ? data.Password : validSvc.newProp(data.Password),
			PwdConfirm: validSvc.isText(data.PwdConfirm) ? data.PwdConfirm : validSvc.newProp(data.PwdConfirm),
			CE: !!data.CE ? validSvc.newProp(data.CE) : validSvc.newProp()
		};
	}

	function getCredential(ceid) {
		// params
		if (!validSvc.isCE(ceid)) {
			throw new Error('op.ce.vcentral, ceid is required');
		}

		_currentPurl = 'ops/ce/vcentral/get';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid]
			}
		};

		apiService.post(_currentPurl, apiRequest).then(getOk, getErr);
		function getOk(r) {
			// bad "Get One" response format
			if (!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}
			// return model
			defer.resolve(r.data.Entity);
		}

		function getErr(r) {
			if (r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}
		return defer.promise;
	}

	function updateCredential(ceid, model) {
		// params
		if (!validSvc.isCE(ceid)) {
			throw new Error('op.ce.vcentral, ceid is required');
		}

		_currentPurl = 'ops/ce/vcentral/update';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid]
			},
			Entity: {
				UserName: model.UserName.val,
				Password: model.Password.val,
			}
		};

		apiService.post(_currentPurl, apiRequest).then(getOk, getErr);
		function getOk(r) {
			// bad "Get One" response format
			if (!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}
			// return model
			defer.resolve(r.data.Entity);
		}

		function getErr(r) {
			if (r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}
		return defer.promise;
	}
}
 
/**
 *    NPI CONTROLLER
 *    shared across CE admin and CE user features
 */

vcentralCtl.$inject = ['$window', '$scope', '$rootScope', '$state', '$timeout', 'validSvc', 'errSvc', 'vcentralRepo', 'utilSvc', 'msgSvc'];
angular
	.module('espui.ops')
	.controller('VCentralCtl', vcentralCtl);


/* @ngInject */
function vcentralCtl($window, $scope, $rootScope, $state, $timeout, validSvc, errSvc, vcentralRepo, utilSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _viewErrRoute = '';

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.action = '';
	vm.isWaiting = false;

	// account
	vm.model = {};
	vm.updateCredential = updateCredential;

	/**
	 *    INIT
	 */

	init();

	function init() {
		// params
		var params = $state.params || {};
		_viewErrRoute = params.ViewErrRoute;
		var model = {};

		// set view type and title
		var stateName = $state.current.name;
		switch (stateName) {
			case 'ops.vcentral':
				_viewErrRoute = 'home';
				$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
				model.CE = $rootScope.User.CE;
				vm.isCE = true;
				break;
			case 'admin.ce.edit.vcentral':
				_viewErrRoute = 'admin.ce.list';

				// admin route must have CE param
				if (!validSvc.isCE(params.CE)) {
					throw new Error('vcentralCtl.init, CE ADMIN ID missing');
				}
				model.CE = params.CE;
				break;
			default:
				throw new Error('vcentralCtl.init, unknown route: ' + stateName);
		}
		vm.model = vcentralRepo.modelVM(model);
		getCredential();
	}

	function getCredential() {
		vcentralRepo.getCredential(vm.model.CE.val).then(okResponse, errResponse);
		function okResponse(data) {
			vm.model.UserName.val = data.UserName;
		}
		function errResponse(r) {
			if (!!r) {
				errSvc.warn('espui.ops.vcentral get credential unknown error ', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function updateCredential() {
		// re-evaluate input
		vm.model.Password.msg = '';
		vm.model.PwdConfirm.msg = '';
		vm.model.Password.fail = '';
		vm.model.PwdConfirm.fail = '';
		
		if (!!!vm.model.Password.val) {
			vm.model.Password.val = '';
			vm.model.PwdConfirm.val = '';
			vm.model.Password.fail = 'yes';
			vm.model.Password.msg = 'password cannot be empty';
			msgSvc.ok('Cannot Save', 'Password cannot be empty');
			return;
		}

		if (vm.model.Password.val != vm.model.PwdConfirm.val) {
			vm.model.Password.val = '';
			vm.model.PwdConfirm.val = '';
			vm.model.PwdConfirm.fail = 'yes';
			vm.model.PwdConfirm.msg = 'confirmation must match password';
			msgSvc.ok('Cannot Save', 'Password entries must match');
			return;
		}

		vm.model.Password.fail = 'no';
		vm.model.PwdConfirm.fail = 'no';

		vcentralRepo.updateCredential(vm.model.CE.val, vm.model).then(okResponse, errResponse);
		function okResponse(data) {
			msgSvc.ok('Account saved');
		}
		function errResponse(r) {
			if (!!r) {
				errSvc.warn('espui.ops.vcentral get credential unknown error ', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}
}

 
visitsRepo.$inject = ['$rootScope', '$q', 'apiService', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
.module('espui.ops')
.factory('visitsRepo', visitsRepo);


/* @ngInject */
function visitsRepo($rootScope, $q, apiService, errSvc, eventSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _currentPurl = '',
		_apiPaging = vmSvc.api.paging(),
		_pendingQuery,
		_pendingModel = {},
		_deferReverse = {};

	// service definition
	var service = {
		queryVM: queryVM,

		getList: getList,
		getExcel: getExcel,

		reverseVisit: reverseVisit,
		reverseVisitMulti: reverseVisitMulti,
		revFileUpload: revFileUpload,

		CeBenefitsAndLocations: CeBenefitsAndLocations,
		create: create
	};

	return service;


	/**
	 *    QUERY
	 */

	function queryVM() {

		return {
			CE: validSvc.newProp($rootScope.User.CE),
			RX: validSvc.newProp($rootScope.User.RX),
			StartDate: validSvc.newPropDateNull(),
			EndDate: validSvc.newPropDateNull(),
			SearchType: validSvc.newProp('LIST'),
			DateOfBirth: validSvc.newPropDOBDate(new Date()),
		};

	}


	/**
	 *    NPI AND PATIENT LIST
	 */

	function parseQueryParams(q) {

		switch(q.SearchType.val) {

			case 'LIST':
				// add search options
				var listParams = [];
				if(q.DateRangeChk) {
					var endDt = utilSvc.dt.addDays(utilSvc.dt.zeroTime(new Date(q.EndDate.val)), 1);
					listParams.push({Field: 'EncounterDate', DataType:'date', Value: q.StartDate.val, Op:'gte'});
					listParams.push({Field: 'EncounterDate', DataType:'date', Value: endDt, Op:'lt'});
				}
				if(q.EncounterNum.chk) {
					listParams.push({Field: 'EncounterNum', DataType:'string', Value: q.EncounterNum.val, Op:'eq'});
				}
				if(q.MRN.chk) {
					listParams.push({Field: 'MRN', DataType:'string', Value: q.MRN.val, Op:'eq'});
				}
				if(q.LastName.chk) {
					listParams.push({Field: 'LastName', DataType:'string', Value: q.LastName.val.toUpperCase(), Op:'eq'});
				}
				if(q.Location.chk) {
					listParams.push({Field: 'Location', DataType:'string', Value: q.Location.val.toUpperCase(), Op:'eq'});
				}
				if(q.DateOfBirth.chk) {
					listParams.push({Field: 'DateOfBirth', DataType:'date', Value: utilSvc.dt.zeroTime(new Date(q.DateOfBirth.val)), Op:'gte'});
					listParams.push({Field: 'DateOfBirth', DataType:'date', Value: utilSvc.dt.addDays(utilSvc.dt.zeroTime(new Date(q.DateOfBirth.val)), 1), Op:'lt'});
				}
				if(q.NPI.chk) {
					listParams.push({Field: 'NPI', DataType:'string', Value: q.NPI.val, Op:'eq'});
				}

				return listParams;

			case 'NPI':
				return {
					StartDate: q.StartDate.val,
					EndDate: q.EndDate.val
				};

			default:
				throw new Error('visitsRepo.getList, search type unknown: ' + q.SearchType.val);
		}

	}

	function getList(query) {
		// params
		if(!validSvc.isCE(query.CE.val)) {
			throw new Error('visitsRepo.getList, CE id is required');
		}

		var defer = $q.defer();
		_currentPurl = query.SearchType.val == 'LIST' ? 'ops/visits/list' : 'ops/visits/npi/list';

		var apiRequest = {
			Context: {
				CEID: [query.CE.val]
			},
			Params: parseQueryParams(query),
			Paging: {
				Page: 1,
				Size: 20000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('NPI')]
		};

		_pendingQuery = {
			CE: query.CE.val
		};

		apiService.post(_currentPurl, apiRequest).then(okGetList, errGetList);

		function okGetList(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update CE and Rx user choice
			eventSvc.rootEmit('context.change', {
				CE: _pendingQuery.CE
			});

			defer.resolve({
				Items: r.data.Entity,
				TooMany: r.data.Entity.length > 20000
			});

		}

		function errGetList(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    VISIT REVERSAL
	 */

	function reverseVisit(ceid, encounterId, notes) {

		// reverse one visit by encounter number

		_currentPurl = 'ops/visits/reverse';
		_deferReverse = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [ceid]
			},
			Entity: {
				Params: {
					Type: 'ENCNUM',
					Notes: notes,
					Value: encounterId,
					EncDate: false
				}
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okReverse, errReverse);

		return _deferReverse.promise;
	}

	function reverseVisitMulti(query, notes) {

		// reverse multiple visits using api query structure
		// supports api types:
		//"ENCNUM"
		//"NPI"
		//"ENCDATE"
		//"FILE"
		//"LOCATION"

		_currentPurl = 'ops/visits/reverse';
		_deferReverse = $q.defer();


		var apiRequest = {
			Context: {
				CEID: [query.CE]
			},
			Entity: {
				Params: {
					Type: query.type,
					Notes: notes,
					Value: query.val,
					EncDate: query.useDate,
					ResetFileHash: !!query.resetFileHash,
					ResetRecordHash: !!query.resetRecordHash
				}
			}
		};

		// api date included
		if(query.useDate) {
			var endDt = utilSvc.dt.addDays(utilSvc.dt.zeroTime(new Date(query.EndDate)), 1); // query is < end date, add 1 day to end date
			apiRequest.Entity.Params.StartDate = query.StartDate;
			apiRequest.Entity.Params.EndDate = endDt;
		}

		apiService.post(_currentPurl, apiRequest).then(okReverse, errReverse);

		return _deferReverse.promise;

	}

	function okReverse(r) {
		_deferReverse.resolve({});
	}

	function errReverse(r) {

		if(r === null) {
			// already handled upstream
			_deferReverse.reject(null);
		}
		else if(!validSvc.httpUpsertErrResp(r)) {
			// bad error response format
			errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			_deferReverse.reject(null);
		}
		else {
			errSvc.error('Unexpected api error', 'visitsRepo.errReverse', r.status, utilSvc.http.safeResponse(r));
		}

	}


	/**
	 *    REVERSAL FILE UPLOAD
	 */

	function revFileUpload(query, importFile) {

		// params
		if(!validSvc.isCE(query.CE) || !!!importFile) {
			throw new Error('visitsRepo.revEdiFileImport, required: CE and import file.');
		}

		_currentPurl = 'ops/visits/reverse/upload';
		var defer = $q.defer();

		var apiRequest = {
			CEID: query.CE
		};

		// create multi-part form data
		var fd = new FormData();
		fd.append('context', angular.toJson(apiRequest)); // stringify JSON into one "context" property
		fd.append('file', importFile);

		apiService.postFile(_currentPurl, fd, false).then(okFileImport, errFileImport);

		function okFileImport(r) {

			// bad upsert response format
			if(!!!r || !!!r.data || !!!r.data.Entity) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errFileImport(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!!!r || !validSvc.isNumber(r.status) || !!!r.data) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status === 422) {
				r.importErrors = mapApiImportErrors(r.data.Entity);
				r.counts = {
					Processed: r.data.Entity.ProcessedCount,
					Received: r.data.Entity.ReceivedCount,
					Error: r.data.Entity.ErrorCount,
					Duplicate: r.data.Entity.DuplicateCount
				};
				defer.reject(r);
			}
			else {
				errSvc.error('Unexpected error', _currentPurl + 'transformRepo.errFileImport', r.status, utilSvc.http.safeResponse(r));
			}

		}

		function mapApiImportErrors(entity) {

			// map server 422 fields onto import error text lines

			if(Array.isArray(entity.RecordErrors) && entity.RecordErrors.length > 0) {
				return entity.RecordErrors;
			}
			else if(entity.ROOT.length > 0) {
				return [{Name: 'File Error', Rule: entity.ROOT.join(',')}];
			}
			else {
				throw new Error('visitsRepo.422FileImport, Api returned no errors to display');
			}
		}

		return defer.promise;

	}


	/**
	 *    CE BENEFITS AND LOCATIONS
	 */

	function CeBenefitsAndLocations(ceid, getLocations) {

		// params
		if(!validSvc.isCE(ceid)) {
			throw new Error('visitsRepo.CeBenefitsAndLocations, ceid required');
		}

		_currentPurl = 'ops/lookup/cedisplay';
		_pendingQuery = {
			getLocations: !!getLocations,
			Context: {
				CEID: [ceid]
			}
		};
		var defer = $q.defer();

		apiService.post(_currentPurl, _pendingQuery).then(okLookup, errLookup);

		function okLookup(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// parse for CashCard benefit levels
			var ce = r.data.Entity,
				isCashCard = false,
				isPubKeyPHIExists = false,
				isAuditPHIEnabled = false,
				levels = [];
			if(Array.isArray(ce) && ce.length > 0) {
				if(!!ce[0].CashCard) {
					isCashCard = !!ce[0].CashCard.Participant;

					if(isCashCard && Array.isArray(ce[0].CashCard.BenefitLevels)) {
						levels = ce[0].CashCard.BenefitLevels;
					}
				}
				isPubKeyPHIExists = ce[0].ExistsPubKeyPHI;
				isAuditPHIEnabled = ce[0].EnableAuditPHI;
			}

			_pendingModel = {
				CashCard: isCashCard,
				CashCardLevels: levels,
				ExistsPubKeyPHI: isPubKeyPHIExists,
				EnableAuditPHI: isAuditPHIEnabled,
			};

			// now get locations
			if(_pendingQuery.getLocations) {
				_currentPurl = 'ops/ce/location/list';
				apiService.post(_currentPurl, _pendingQuery).then(okLocations, errLookup);
			}
			else {
				defer.resolve(_pendingModel);
			}

		}

		function okLocations(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			var ce = r.data.Entity,
				loc = [];

			_pendingModel.LocEnabled = !!ce.Enabled;
			_pendingModel.LocEligible = !!ce.Eligible;
			_pendingModel.Locations = Array.isArray(ce.Locations) ? ce.Locations : [];

			defer.resolve(_pendingModel);
		}

		function errLookup(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	function create(model) {
		return upsert('ops/visits/create', model);
	}

	function update(model) {
		return upsert('ops/vistis/update', model);
	}

	function upsert(purl, model) {

		_currentPurl = purl;
		_pendingModel = model;
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [model.CE]
			},
			Entity: {
				Location: validSvc.isText(model.Location.val) ? model.Location.val.toUpperCase() : '',
				EncounterDate: model.EncounterDate.val,
				EncounterNum: model.EncounterNum.val,
				NPI: [model.NPI.val],
				MRN: model.MRN.val,
				FirstName: model.FirstName.val,
				MiddleName: model.MiddleName.val,
				LastName: model.LastName.val,
				DateOfBirth: model.DateOfBirth.val,
				Gender: model.Gender,

				CashCardId: model.CashCardId.val,
				CashCardBenefitsLevel: parseInt(model.CashCardBenefitsLevel)
			}
		};

		apiService.post(_currentPurl, apiRequest).then(upsertOk, upsertErr);

		function upsertOk(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function upsertErr(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapApiErrorsToModel(r, _pendingModel);
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);
				if(fieldObj === undefined) {
					throw new Error('cashcardRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
				}

				// set failed state
				fieldObj.fail = 'yes';
				fieldObj.msg = entity.Fields[i].Rule;

			}

			return m;

		}


		return defer.promise;
	}


	/**
	 *    EXCEL
	 */

	function getExcel(query, filename) {

		// params
		if(!validSvc.isCE(query.CE.val) || !validSvc.isText(filename)) {
			throw new Error('visitsRepo.getExcel, ce id and filename are required');
		}

		var apiRequest = {
			Context: {
				CEID: [query.CE.val]
			},
			Params: parseQueryParams(query),
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('ServerExcel')]
		};
		apiRequest.Params.Filename = filename;

		_currentPurl = query.SearchType.val == 'LIST' ? 'ops/visits/excel' : 'ops/visits/npi/excel';
		var defer = $q.defer();

		// call api
		apiService.postGetBinary(_currentPurl, apiRequest).then(okGetExcel, errGetExcel);

		function okGetExcel(r) {
			defer.resolve(r.data);
		}

		function errGetExcel(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

}
 
visitsEditCtl.$inject = ['$scope', '$state', '$timeout', 'visitsRepo', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc'];
angular
.module('espui.ops')
.controller('VisitsEditCtl', visitsEditCtl);


/* @ngInject */
function visitsEditCtl($scope, $state, $timeout, visitsRepo, validSvc, errSvc, utilSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _datePickListener = null;

	// inherit
	msgSvc.addHelpLink(vm);

	// properties
	vm.isWaiting = false;

	// droplists
	vm.LocationDroplist = [];
	vm.CashCardLevelDroplist = [];

	vm.model = {};

	// methods
	vm.submit = submit;

	// date pick
	vm.dtPickShow = {};
	vm.dtPickOpen = dtPickOpen;


	/**
	 *    DATE PICKER
	 *    EVENT HOOK, DESTROY AND TOGGLE
	 */

	_datePickListener = $scope.$on('widget.input.date.pick.change', function(event, evtData) {
		event.stopPropagation();

		// params
		if(!evtData || !validSvc.isText(evtData.uniqueId)) {
			alert('visitEditCtl.datePickEvt, evtData and uniqueId required');
			return;
		}
		var id = evtData.uniqueId;

		if(id!= 'DateOfBirth' && id != 'EncounterDate') {
			alert('visitEditCtl.datePickEvt, uniqueId unknown: ' + id);
			return;
		}

		vm.dtPickShow[id] = false;
		vm.model[id].val = evtData.setDate;

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_datePickListener) {
			_datePickListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// params
		if(!validSvc.isCE($state.params.CE)) {
			throw new Error('visitsEditCtl.init, CE required');
		}

		// date picker
		vm.dtPickShow = {
			pending: '',
			DateOfBirth: false,
			EncounterDate: false
		};

		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		vm.model = modelVM($state.params.CE);

		// get CE locations and cash card levels
		lookupCE(vm.model.CE);

	}


	/**
	 *    VIEWMODEL
	 */

	function modelVM(ceid) {

		var dtToday = utilSvc.dt.zeroTime(new Date());
		var dtMin = utilSvc.dt.zeroTime(utilSvc.dt.addDays(dtToday, - (365* 2))),
			dtMinDOB = utilSvc.dt.zeroTime(utilSvc.dt.addDays(new Date(), -43800)); // 120 years old max

		return {
			CE: ceid,

			Location: validSvc.newProp(),
			EncounterDate: validSvc.newPropDateNull(dtMin, dtToday),
			EncounterNum: validSvc.newProp(''),

			NPI: validSvc.newProp(''),
			MRN: validSvc.newProp(''),
			FirstName: validSvc.newProp(''),
			MiddleName: validSvc.newProp(''),
			LastName: validSvc.newProp(''),
			DateOfBirth: validSvc.newPropDateNull(dtMinDOB, dtToday),
			Gender: '',

			CashCard: false,
			CashCardId: validSvc.newProp(''),
			CashCardBenefitsLevel: 0
		};
	}


	/**
	 *    LOOKUP CE PROPERTIES
	 */

	function lookupCE(ceid) {
		// ASYNC: get locations and benefit levels for this CE
		$timeout(function() {
			visitsRepo.CeBenefitsAndLocations(ceid, true).then(okLookupCe, errLookupCe);
		}, 500);
	}

	function okLookupCe(r) {

		var i = 0;

		vm.model.LocEnabled = r.LocEnabled;
		vm.model.LocEligible = r.LocEligible;

		// locations list
		vm.LocationDroplist = [];
		if(vm.model.LocEnabled) {
			var loc = r.Locations,
				locId = '';
			for(i = 0; i < loc.length; i++) {
				locId = loc[i].LocationId.toUpperCase();
				vm.LocationDroplist.push({label:locId, value:locId});
			}
		}

		// benefit levels droplist
		vm.CashCardLevelDroplist = [];
		vm.model.CashCard = r.CashCard;
		if(r.CashCard) {
			vm.CashCardLevelDroplist.push({label:'None', value:0});
			var levels = r.CashCardLevels;
			for(i = 0; i < levels.length; i++) {
				vm.CashCardLevelDroplist.push({label:levels[i].Description, value:levels[i].Level});
			}
		}

	}

	function errLookupCe(r) {
		if(!!r) {
			errSvc.warn('Error looking up ce display properties', 'memberEditCtl.lookupCeBenefits', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    DATE PICKER
	 */

	function dtPickOpen(dtName) {

		if(dtName != 'DateOfBirth' && dtName != 'EncounterDate') {
			alert('visitsEditCtl.dtPickOpen, date pick name unknown: ' + dtName);
			return;
		}
		var dt = vm.model[dtName];
		vm.dtPickShow.pending = dtName;

		$scope.$broadcast('widget.input.date.pick', {
			uniqueId: dtName,
			setDate: dt.val,
			minDate: dt.min,
			maxDate: dt.max
		});

		$timeout(function(){
			if(validSvc.isText(vm.dtPickShow.pending)) {
				vm.dtPickShow[vm.dtPickShow.pending] = true;
			}
		},100);
	}


	/**
	 *    SUBMIT: ACCOUNT
	 */

	function validAccount(m) {

		// validate for both create and update

		// encounter
		m.EncounterDate = validSvc.propDateValid(m.EncounterDate);
		m.EncounterDate.fail = !!m.EncounterDate.fail ? 'yes' : 'no';
		m.EncounterNum = validText(m.EncounterNum, 2, 50);
		m.NPI = validText(m.NPI, 10, 15);
		if(m.NPI.fail == 'no' && !validSvc.isInteger(parseInt(m.NPI.val))) {
			m.NPI.fail = 'yes';
			m.NPI.msg = 'must be a 10 - 15 digit number';
		}

		// location can't be on not allowed list
		if(m.LocEnabled && !m.LocEligible && validSvc.isText(m.Location.val)) {
			m.Location.fail = '';

			var loc = vm.LocationDroplist,
				locTxt = m.Location.val.toUpperCase().trim();

			for(var i = 0; i < loc.length; i++) {
				if(locTxt == loc[i].value) {
					// not allowed
					m.Location.fail = 'yes';
					m.Location.msg = locTxt + ' location is not allowed';
					break;
				}
			}

			m.Location.val = locTxt;
		}
		else {
			m.Location.fail = '';
		}

		// patient
		m.FirstName = validText(m.FirstName, 2, 50);
		m.LastName = validText(m.LastName, 2, 50);
		if (validSvc.isText(m.MiddleName.val)) {
			m.MiddleName = validText(m.MiddleName, 1, 50);
		}
		else{
			m.MiddleName.fail='';
		}

		m.DateOfBirth = validSvc.propDateValid(m.DateOfBirth);
		m.DateOfBirth.fail = !!m.DateOfBirth.fail ? 'yes' : 'no';

		// cash card
		if(m.CashCard) {
			m.CashCardId = validText(m.CashCardId, 2, 50);
		}
		else {
			m.CashCardId = validSvc.newProp('');
		}


		return m.EncounterDate.fail != 'yes' &&
			m.EncounterNum.fail != 'yes' &&
			m.Location.fail != 'yes' &&
			m.NPI.fail != 'yes' &&
			m.FirstName.fail != 'yes' &&
			m.MiddleName.fail != 'yes' &&
			m.LastName.fail != 'yes' &&
			m.DateOfBirth.fail != 'yes' &&
			m.CashCardId.fail != 'yes';

	}

	function submit() {

		if(vm.isWaiting) {
			return;
		}

		// validate
		if(!validAccount(vm.model)) {
			msgSvc.ok('Cannot Save', 'All fields must be valid.');
			return false;
		}

		vm.isWaiting = true;
		visitsRepo.create(vm.model).then(okUpsert, errUpsert);

	}

	function okUpsert(r) {
		vm.isWaiting = false;

		msgSvc.ok('Encounter ' + vm.model.EncounterNum.val + ' created.');
		$state.go('ops.visits', {}, {reload: 'ops.visits'});

	}

	function errUpsert(r) {
		vm.isWaiting = false;

		if(!!!r || r === null) {
			// already handled
		}
		else if (r.status === 422) {
			// validation
			vm.model = r.model;
			msgSvc.ok('Cannot Save', 'All fields must be valid.');
		}
		else {
			errSvc.error('Unexpected api error', 'visitsEditCtl.errUpsert', r.status, utilSvc.http.safeResponse(r));
		}

	}


	/**
	 *    HELPERS
	 */

	function validText(prop, min, max) {

		// required
		if(!validSvc.isText(prop.val)) {
			prop.fail = 'yes';
			prop.msg = 'required';
			return prop;
		}

		// min
		if(prop.val.length < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum ' + min.toString() + ' characters';
			return prop;
		}

		// max
		if(prop.val.length > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum ' + max.toString() + ' characters';
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;

	}

}
 
visitsListCtl.$inject = ['$window', '$state', '$scope', '$timeout', '$filter', 'visitsRepo', 'sessionRepo', 'msgSvc', 'utilSvc', 'validSvc', 'errSvc'];
angular
.module('espui.ops')
.controller('VisitsListCtl', visitsListCtl);


/* @ngInject */
function visitsListCtl($window, $state, $scope, $timeout, $filter, visitsRepo, sessionRepo, msgSvc, utilSvc, validSvc, errSvc) {

	/*jshint validthis: true */
	var vm = this,
		_pendingExcelFilename = '',
		_pendingReverse = {},
		_featureName = '',
		_datePickListener = null,
		_pagingEventListener = null,
		_fileImportListener = null,
		_returnVisit = false,
		_cashCardLevels = {};

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addFlexTop(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.isVerity = false;
	vm.canReverse = false;
	vm.canReverseUpload = false;
	vm.canCreateVisit = false;
	vm.canUseList = false;
	vm.hasCashCard = false;
	vm.hasLocations = false;
	vm.hasPHI = false;

	// droplists
	vm.CeDroplist = [];
	vm.SearchTypeDroplist = [];
	vm.VisitsStatusDroplist = [];

	// query
	vm.query = {};
	vm.queryChange = queryChange;
	vm.queryChangeCE = queryChangeCE;
	vm.queryChangeSearchType = queryChangeSearchType;
	vm.dateRangeChange = dateRangeChange;
	vm.querySubmit = querySubmit;

	// table, filters
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;

	vm.getExcel = getExcel;

	// flex top
	vm.flex = {};
	vm.flexTopExpand = flexTopExpand;

	// methods
	vm.visitReverse = visitReverse;
	vm.visitReverseMulti = visitReverseMulti;
	vm.visitCreate = visitCreate;

	// popup
	vm.popup = {};
	vm.closePopup = closePopup;
	vm.openPopup = openPopup;

	// reversal file import popup
	vm.revImportFiles = [];
	vm.revImportErrors = [];
	vm.revImportCounts = {};
	vm.revPopupUpload = revPopupUpload;
	vm.revImportFile = revImportFile;

	// date picker
	vm.dtPickShow = {};
	vm.dtPickOpen = dtPickOpen;

	// claim match
	vm.claimMatch = false;
	vm.claimMatchAffs = [];
	vm.claimMatchDateOfBirth = {};
	vm.claimMatchLastName = "";
	vm.pickVisitForClaimMatch = pickVisitForClaimMatch;


	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});


	/**
	 *    IMPORT FILE EVENT HOOK
	 *    used to update file list to import
	 *    note:
	 *          directive widget-input-file throws event: 'widget.input.file'
	 *          event object: {id:'id of element', files:[] array of files if browser supports HTML5 File Api}
	 */

	function listenForFileImport() {

		if(!!!_fileImportListener) {

			_fileImportListener = $scope.$on('widget.input.file', function(event, importInfo) {
				event.stopPropagation();

				if(!!importInfo && !!importInfo.files && importInfo.files.length > 0) {
					vm.revImportFiles = importInfo.files;
				}
				else {
					vm.revImportFiles = [];
				}

			});
		}

	}

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
		if(!!_fileImportListener) {
			_fileImportListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		_featureName = $state.current.name;

		// CLaims feature opened Visits search
		if(!!$state.params && Array.isArray($state.params.MatchAffs)) {
			vm.claimMatch = _featureName == 'ops.claims.visit-search';
			vm.claimMatchAffs = JSON.parse(JSON.stringify($state.params.MatchAffs));
			vm.claimMatchDateOfBirth = $state.params.DateOfBirth;
			vm.claimMatchLastName = $state.params.LastName;
		}

		// user specific claims
		vm.isVerity = $scope.User.Type == 'VERITYSA' || $scope.User.Type == 'VERITY';
		vm.canUseList = vm.isVerity || $scope.User.Type == 'CE';
		vm.hasPHI = utilSvc.user.hasFeature($scope, 'ops.visits.phi');

		if(!vm.claimMatch) {
			vm.canReverse = utilSvc.user.hasFeature($scope, 'ops.visits.reverse');
			vm.canReverseUpload = utilSvc.user.hasFeature($scope, 'ops.visits.reverse.upload');
			vm.canCreateVisit = utilSvc.user.hasFeature($scope, 'ops.visits.create');
		}

		vm.init = true;
		vm.flex = vm.flexInit();

		// load query, if this is a return visit try submit
		_returnVisit = initQueryAndFilters();
		queryChangeCE();

		// fire date control sync event after html render
		$timeout(function() {
			$scope.$broadcast('widget.input.date.range.mode', {mode: vm.query.DateRangeMode, keepDates: true});
		},100);

	}

	function initFilterBySearchType(st) {

		switch(st) {
			case 'LIST':
				return vm.initFilters({
					Config: {
						Dates: ['EncounterDate', 'DateOfBirth'],
						DateFmt: 'M/d/yyyy'
					},
					Exact: {ObjectState:''},
					SortBy: ['EncounterDate']
				});
			case 'NPI':
				return vm.initFilters({
					SortBy: ['NPI']
				});
			default:
				throw new Error('visitListCtl.initFilterBySearchType, unknown search type: ' + st);
		}

	}

	function initQueryAndFilters() {

		var returnVisit = false,
			defaultView = vm.canUseList ? 'LIST' : 'NPI';

		vm.query = visitsRepo.queryVM();
		var flt = initFilterBySearchType(defaultView);

		// date default
		vm.query.DateRangeChk = true;
		vm.query.DateRangeValid = false;
		vm.query.DateRangeList = utilSvc.widget.dateRangeList([]);
		vm.query.DateRangeMode = 'MTD';

		vm.VisitsStatusDroplist = utilSvc.ng.droplist(
			['NEW','REVERSED'],
			'',
			'',
			[{label:'ALL', value:''}]);

		// search type
		vm.query.SearchType.val = defaultView;
		vm.SearchTypeDroplist = [];
		if(vm.canUseList) {
			vm.SearchTypeDroplist.push({label:'Visit List', value:'LIST'});
		}
		vm.SearchTypeDroplist.push({label:'Unique NPI', value:'NPI'});
		vm.query.SearchType.title = '';

		// search options
		vm.query.EncounterNum = validSvc.newProp();
		vm.query.EncounterNum.chk = false;
		vm.query.MRN = validSvc.newProp();
		vm.query.MRN.chk = false;
		vm.query.LastName = validSvc.newProp();
		vm.query.LastName.chk = false;
		vm.query.Location = validSvc.newProp();
		vm.query.Location.chk = false;
		vm.query.NPI = validSvc.newProp();
		vm.query.NPI.chk = false;
		vm.query.DateOfBirth = validSvc.newPropDOBDate();
		vm.query.DateOfBirth.chk = false;

		// last list query is cached in the Repo, try to get it
		var vs = sessionRepo.get('vs-ops-visits', {CE:vm.query.CE.val});
		if(!!vs && !vm.claimMatch) {

			returnVisit = true;

			// query
			vm.query.StartDate.val = new Date(vs.query.StartDate);
			vm.query.EndDate.val = new Date(vs.query.EndDate);
			vm.query.DateRangeMode = vs.query.DateRangeMode;
			vm.query.DateRangeChk = !!vs.query.DateRangeChk;
			vm.query.DateRangeValid = true;
			vm.query.SearchType.val = vs.query.SearchType;
			vm.query.SearchType.title = utilSvc.ng.droplistLabel(vm.SearchTypeDroplist, vs.query.SearchType);

			// search options
			if(vs.query.EncounterNumChk) {
				vm.query.EncounterNum = validSvc.newProp(vs.query.EncounterNum);
				vm.query.EncounterNum.chk = true;
			}
			if(vs.query.LastNameChk) {
				vm.query.LastName = validSvc.newProp(vs.query.LastName);
				vm.query.LastName.chk = true;
			}
			if(vs.query.LocationChk) {
				vm.query.Location = validSvc.newProp(vs.query.Location);
				vm.query.Location.chk = true;
			}
			if(vs.query.NPIChk) {
				vm.query.NPI = validSvc.newProp(vs.query.NPI);
				vm.query.NPI.chk = true;
			}
			if(vs.query.MRNChk) {
				vm.query.MRN = validSvc.newProp(vs.query.MRN);
				vm.query.MRN.chk = true;
			}

			// filters
			flt = vm.resetFilters(vs.flt, true);
		}
		vm.flt = flt;

		var affs = [];
		if(vm.claimMatch) {
			affs = vm.claimMatchAffs;
			vm.query.DateOfBirth = validSvc.newPropDOBDate(new Date(vm.claimMatchDateOfBirth));
			vm.query.LastName = validSvc.newProp(vm.claimMatchLastName);
		}
		else {
			affs = utilSvc.aff.findStatus($scope.User.AffList);
			affs = utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));
		}

		// CE options
		vm.CeDroplist = utilSvc.aff.ceDroplist(affs);
		vm.query.CE = utilSvc.ng.droplistAutoselect(vm.CeDroplist, vm.query.CE.val);

		return returnVisit;

	}


	/**
	 *    DISPLAY VIEW MODEL
	 */

	function displayVM(dataItems, tooMany) {

		dataItems = Array.isArray(dataItems) ? dataItems : [];

		var isList = vm.query.SearchType.val == 'LIST',
			hasLocations = false,
			item = {},
			hasCashCard = vm.hasCashCard;

		// add uniqueId
		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.uniqueId = i;

			if(isList) {
				// setup eRx number text
				item.Eprescribe = !!item.Eprescribe;
				item.EncounterNumTxt = item.Eprescribe ? 'eRx' + item.EncounterNum : item.EncounterNum;

				if(hasCashCard) {
					item.CashCardLevel = cashCardLevelDesc(item.CashCardBenefitsLevel.toString());
				}

				item.Location = validSvc.isText(item.Location) ? item.Location.toUpperCase() : '';
				if(!hasLocations && item.Location.length > 0) {
					hasLocations = true;
				}
			}
		}

		vm.hasLocations = hasLocations;

		return {
			DataItems: dataItems,
			Items: [], // loaded by filterChange()
			TooMany: !!tooMany
		};

	}

	function cashCardLevelDesc(lvl) {
		if(typeof(_cashCardLevels[lvl]) !== 'undefined') {
			return _cashCardLevels[lvl];
		}
		else {
			return '';
		}
	}


	/**
	 *    QUERY CHANGE EVENTS
	 */

	function queryChange() {
		if(!vm.init) {
			vm.popup = {};
			vm.action = '';
			vm.tbl = {
                DataItems:[],
                Items:[]
            };
			vm.flt = vm.resetFilters(vm.flt);
			vm.flex = vm.flexInit();
			$scope.$broadcast('widget.paging');
		}
	}

	function queryChangeCE() {

		queryChange();

		// valid CE
		vm.hasLocations = false;
		vm.hasCashCard = false;
		_cashCardLevels = {};

		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';
		if(vm.query.CE.fail == 'yes') {
			return;
		}

		lookupCE(vm.query.CE.val);
		queryChangeSearchType();

	}

	/**
	 *    LOOKUP CE PROPERTIES
	 */

	function lookupCE(ceid) {
		// ASYNC: get cash card status for this CE
		$timeout(function() {
			visitsRepo.CeBenefitsAndLocations(ceid).then(okLookupCe, errLookupCe);
		}, 500);
	}

	function okLookupCe(r) {
		vm.hasCashCard = !!r.CashCard;
		if(vm.hasCashCard && Array.isArray(r.CashCardLevels)) {
			var levels = r.CashCardLevels,
				lvlNumber = '';
			_cashCardLevels = {'0': 'None'};
			for(var i = 0; i < levels.length; i++) {
				lvlNumber = levels[i].Level.toString();
				_cashCardLevels[lvlNumber] = levels[i].Description;
			}
		}
	}

	function errLookupCe(r) {
		if(!!r) {
			errSvc.warn('Error looking up ce display properties', 'visitsListCtl.lookupCe', r.status, utilSvc.http.safeResponse(r));
		}
	}

	function queryChangeSearchType() {

		queryChange();
		vm.query.SearchType.title = utilSvc.ng.droplistLabel(vm.SearchTypeDroplist, vm.query.SearchType.val);

		// force on for NPI
		if(vm.query.SearchType.val == 'NPI') {
			vm.query.DateRangeChk = true;
		}

		// reset filters
		if(!_returnVisit) {
			vm.flt = initFilterBySearchType(vm.query.SearchType.val);
		}

	}

	function dateRangeChange(dtMode, isValid) {

		queryChange();
		vm.init = false;

		vm.query.DateRangeMode = dtMode;
		vm.query.DateRangeValid = isValid;

		if(_returnVisit) {
			querySubmit();
		}
		_returnVisit = false;

	}

	function flexTopExpand() {

		// user opened search query, reset list display, show search expanded
		queryChange();

	}

	function queryValid() {

		// validate query data before calling api

		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';
		var dateOk = !!vm.query.DateRangeValid;

		vm.query.SearchOptionsRequired = validSvc.newProp();

		if(vm.query.SearchType.val == 'NPI') {
			return vm.query.CE.fail == 'no' && dateOk;
		}
		else {
			// LIST dynamic query validation

			// date range not used, force to true
			if(!vm.query.DateRangeChk) {
				dateOk = true;
			}

			vm.query.EncounterNum.fail = '';
			if(vm.query.EncounterNum.chk) {
				var encNum = vm.query.EncounterNum.val;
				if(!validSvc.isText(encNum) || encNum.length < 1) {
					vm.query.EncounterNum.fail = 'yes';
					vm.query.EncounterNum.msg = 'must be at least 1 character';
				}
			}
			vm.query.MRN.fail = '';
			if(vm.query.MRN.chk) {
				var mrn = vm.query.MRN.val;
				if(!validSvc.isText(mrn) || mrn.length < 1) {
					vm.query.MRN.fail = 'yes';
					vm.query.MRN.msg = 'must be at least 1 character';
				}
			}
			vm.query.NPI.fail = '';
			if(vm.query.NPI.chk) {
				var npi = vm.query.NPI.val;
				if(!validSvc.isInteger(npi) || npi.toString().length != 10) {
					vm.query.NPI.fail = 'yes';
					vm.query.NPI.msg = 'must be a non-decimal number 10 digits';
				}
			}

			vm.query.DateOfBirth.fail = '';
			if(vm.query.DateOfBirth.chk) {
				vm.query.DateOfBirth = validSvc.propDateValid(vm.query.DateOfBirth);
				if(!!vm.query.DateOfBirth.fail) {
					vm.query.DateOfBirth.fail = 'yes';
					vm.query.DateOfBirth.msg = 'must be within 120 years';
				}
			}

			vm.query.LastName.fail = '';
			if(vm.query.LastName.chk) {
				var lname = vm.query.LastName.val;
				if(!validSvc.isText(lname) || lname.length < 1) {
					vm.query.LastName.fail = 'yes';
					vm.query.LastName.msg = 'must be at least 1 character';
				}
			}

			vm.query.Location.fail = '';
			if(vm.query.Location.chk) {
				var loc = vm.query.Location.val;
				if(!validSvc.isText(loc) || loc.length < 1) {
					vm.query.Location.fail = 'yes';
					vm.query.Location.msg = 'must be at least 1 character';
				}
				else {
					vm.query.Location.val = vm.query.Location.val.toUpperCase();
				}
			}

			// at least one option must be selected
			if(!vm.query.DateRangeChk && !vm.query.EncounterNum.chk && !vm.query.MRN.chk && !vm.query.NPI.chk && !vm.query.LastName.chk && !vm.query.Location.chk) {
				vm.query.SearchOptionsRequired.fail = 'yes';
				vm.query.SearchOptionsRequired.msg = 'Choose at least one search option';
			}

			return vm.query.CE.fail != 'yes' &&
				vm.query.EncounterNum.fail != 'yes' &&
				vm.query.MRN.fail != 'yes' &&
				vm.query.NPI.fail != 'yes' &&
				vm.query.DateOfBirth.fail != 'yes' &&
				vm.query.LastName.fail != 'yes' &&
				vm.query.Location.fail != 'yes' &&
				vm.query.SearchOptionsRequired.fail != 'yes' &&
				dateOk;
		}

	}

	function querySubmit() {

		// request query valid
		if(!queryValid()) {
			if(!vm.init) {
				queryChange();
				msgSvc.ok('Search', 'Check filter properties');
			}
			return;
		}

		// exit if waiting
		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true);
		queryChange();

		visitsRepo.getList(vm.query).then(okQuerySubmit, errQuerySubmit);

		function okQuerySubmit(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// query was good, save viewstate
			saveViewState(vm.query, vm.flt);

			vm.tbl = displayVM(r.Items, r.TooMany);
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);

			vm.action = vm.query.SearchType.val;

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: vm.action,
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			if(!vm.hasCashCard) {
				vm.flt.Text.CashCardId = undefined;
				vm.flt.Text.CashCardLevel = undefined;
			}

			vm.flt.Ready = true;

			// force top collapse after good query
			vm.flex = vm.flexCollapse(vm.flex, true);

		}

		function errQuerySubmit(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Unknown get response', 'visitsListCtl.errQuerySubmit', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    GLOBAL GREASE COLUMN FILTERS
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

            vm.tbl.DataItems = Array.isArray(vm.tbl.DataItems) ? vm.tbl.DataItems : [];
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: vm.action,
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					//console.log('filter change save viewstate');
					saveViewState(vm.query, vm.flt);
				}
			},1000);

		}, delayTime);

	}


	/**
	 *    REVERSALS
	 */

	function visitReverse(item) {

		if(vm.isWaiting) {
			return;
		}

		_pendingReverse = {
			type: 'visit',
			id: item.EncounterNum,
			title: 'Reverse Encounter Number: ' + item.EncounterNum
		};

		msgSvc.confirm({
			id: 'ops.visits.reverse.enc',
			title: 'Reverse Single Encounter',
			msg: 'Confirm reverse of Encounter Number: ' + item.EncounterNum + '?',
			notes: {
				prompt: 'optional notes',
				maxlength: 100
			},
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmReverse, confirmReverse);

	}

	function visitReverseMulti() {

		// reverse multiple visits

		var dtChk = vm.popup.DateRangeChk,
			encChk = vm.popup.EncounterNumChk,
			npiChk = vm.popup.NPIChk,
			locChk = vm.popup.LocationChk;

		// at least one must be selected
		if(!dtChk && !encChk && !npiChk && !locChk) {
			msgSvc.ok('No Options', 'Please choose at least one option other than Patient Last Name to limit reversals.');
			return;
		}

		// only 1 of encounter, npi, location can be selected
		if((encChk && npiChk) || (encChk && locChk) || (npiChk && locChk)) {
			msgSvc.ok('1 Option Allowed', 'Please choose only one of Encounter Number, NPI or Location to limit reversals.');
			return;
		}

		_pendingReverse = {
			type: 'multi',
			query: {},
			title: ''
		};

		// build reversal query
		var q = {
			CE: vm.query.CE.val,
			type: '',
			val: '',
			useDate: false,
			StartDate: null,
			EndDate: null
		};

		// has date?
		var dtTxt = '';
		if(dtChk) {
			q.useDate = true;
			q.StartDate = vm.query.StartDate.val;
			q.EndDate = vm.query.EndDate.val;
			dtTxt = 'date range ' + $filter('date')(vm.query.StartDate.val, 'M/d/yyyy') + ' through ' + $filter('date')(vm.query.EndDate.val, 'M/d/yyyy');
		}

		// derive type
		var msgTxt = 'Reverse multiple encounters using ';
		if(encChk) {
			q.type = 'ENCNUM';
			q.val = vm.query.EncounterNum.val;
			msgTxt += 'Encounter Number: ' + q.val;
		}
		else if(npiChk) {
			q.type = 'NPI';
			q.val = vm.query.NPI.val;
			msgTxt += 'NPI: ' + q.val;
		}
		else if(locChk && validSvc.isText(vm.query.Location.val)) {
			q.type = 'LOCATION';
			q.val =  vm.query.Location.val.toUpperCase();
			msgTxt += 'Location: ' + q.val;
		}
		else if(q.useDate) {
			q.type = 'ENCDATE';
		}
		else {
			msgSvc.ok('Error: Reversal Type Unknown', 'Reversal must be Encounter Num, NPI or Date Range only');
			return;
		}

		// munge text
		if(q.type == 'ENCDATE') {
			msgTxt += dtTxt;
		}
		else if(q.useDate) {
			msgTxt += ' within ' + dtTxt;
		}

		_pendingReverse.title = msgTxt;
		_pendingReverse.query = q;

		msgSvc.confirm({
			id: 'ops.visits.reverse.multi',
			title: 'Reverse Multiple Encounters',
			msg: msgTxt + '?',
			notes: {
				prompt: 'optional notes',
				maxlength: 100
			},
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmReverse, confirmReverse);

	}

	function confirmReverse(r) {
		// user said yes
		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;
			msgSvc.wait(true);

			var nt = validSvc.isText(r.notes) ? r.notes : '';

			switch(_pendingReverse.type) {
				case 'visit':
					visitsRepo.reverseVisit(vm.query.CE.val, _pendingReverse.id, nt).then(okReverse, errReverse);
					break;
				case 'multi':
					visitsRepo.reverseVisitMulti(_pendingReverse.query, nt).then(okReverse, errReverse);
					break;
				default:
					throw new Error('visitsListCtl.confirmReverse, unknown type: ' + _pendingReverse.type);
			}
		}
	}

	function okReverse(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);
		vm.popup = {};

		msgSvc.okAsync('Reversal Success', _pendingReverse.title, 'visits.reversal.ok').then(function(){
			querySubmit();
		});
	}

	function errReverse(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);
		vm.popup = {};

		if(!!r) {
			errSvc.warn('Unknown api response', 'visitsListCtl.errReverse', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    POPUP
	 */

	function openPopup(evt) {

		if(vm.isWaiting) {
			return;
		}

		// Last Name multi-reversals not supported
		if(!vm.query.DateRangeChk && !vm.query.EncounterNum.chk && !vm.query.NPI.chk && !vm.query.Location.chk) {
			msgSvc.ok('Multiple Reversal Not Allowed', 'At least one of Date Range, Encounter Number, NPI or Location must be chosen.');
			return;
		}

		vm.popup = {
			ready: false,
			DateRangeChk: !!vm.query.DateRangeChk,
			EncounterNumChk: !!vm.query.EncounterNum.chk,
			NPIChk: !!vm.query.NPI.chk,
			LocationChk: !!vm.query.Location.chk
		};

		// wait for digest before showing
		$timeout(function() {
			vm.popup.ready = true;
		}, 100);

	}

	function closePopup() {
		vm.popup = {};

		// clear reversal file upload props
		vm.revImportFiles = [];
		vm.revImportErrors = [];
		vm.revImportCounts = {};

	}


	/**
	 *    UPLOAD REVERSAL FILE
	 */

	function revPopupUpload() {

		if(vm.isWaiting) {
			return;
		}

		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';
		if(vm.query.CE.fail == 'yes') {
			return;
		}

		// reset view
		queryChange();
		vm.revImportFiles = [];
		vm.revImportErrors = [];
		vm.revImportCounts = {};

		// check for File API and FormData upload browser support
		if(typeof($window.File) === 'undefined' ||
			typeof($window.FileReader) === 'undefined' ||
			typeof($window.FileList) === 'undefined' ||
			typeof($window.Blob) === 'undefined' ||
			typeof($window.FormData) === 'undefined') {
			msgSvc.ok('File Upload Not Supported', 'File Upload uses HTML5 FormData upload, your browser does not support it. Please upgrade to use file upload.');
			return;
		}

		vm.action = 'REVUPLOAD';
		vm.popup = {
			ready: false
		};

		// wait for digest before showing
		$timeout(function() {
			listenForFileImport();
			vm.popup.ready = true;
		}, 100);

	}

	function importValidFile(newFile) {

		// required
		if(!!!newFile) {
			return 'no file selected';
		}

		// file size > 0 bytes, < 10 megabytes
		if(!validSvc.isNumber(newFile.size) || newFile.size < 1 || newFile.size > 10000000) {
			return 'file size must be 2 bytes to 10 megabytes';
		}

		// file name must be .csv
		var fName = newFile.name;
		if(!validSvc.isText(fName) || fName.length < 5 || (fName.substr(fName.length - 4, 4).toLowerCase() !== '.csv' && fName.substr(fName.length - 4, 4).toLowerCase() !== '.txt')) {
			return 'file name must end with extension ".csv" or ".txt"';
		}

		return 'ok';

	}

	function revImportValid() {

		// files selected
		if(!!!vm.revImportFiles || vm.revImportFiles.length !== 1) {
			msgSvc.ok('File Import', 'Please choose 1 file to upload.');
			return false;
		}

		// validate file
		var fileFail = importValidFile(vm.revImportFiles[0]);
		if(fileFail != 'ok') {
			msgSvc.ok('File Import', 'Selected file error: ' + fileFail);
			return false;
		}

		return true;

	}

	function revImportFile() {

		if(vm.isWaiting) {
			return;
		}

		if(!revImportValid()) {
			return;
		}

		msgSvc.confirm({
			id: 'ops.visits.reversal.upload',
			title: 'Reverse ' + vm.query.CE.val + 'Visits',
			msg: 'Warning: once uploaded, all visits in this file will be reversed. There is no way to un-reverse visits later without sending another FTP file.',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmReversalImport, confirmReversalImport);

	}

	function confirmReversalImport(r) {

		// user cancelled
		if(!!!r || r.result != 'YES') {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);
		vm.revImportErrors = [];
		vm.revImportCounts = {};

		visitsRepo.revFileUpload({CE:vm.query.CE.val}, vm.revImportFiles[0]).then(okFileImport, errFileImport);

		function okFileImport(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;
			msgSvc.ok('File Import Success', 'Total ' + r.ProcessedCount + ' reversals imported.');
			closePopup();
		}

		function errFileImport(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(r === null) {
				return;
			}
			else if (r.status === 422) {
				vm.revImportErrors = r.importErrors;
				vm.revImportCounts = r.counts;
				if(r.counts.Processed > 0) {
					msgSvc.ok('File Import With Errors', r.counts.Processed + ' imported, ' + r.importErrors.length + ' errors');
				}
				else {
					msgSvc.ok('File Import Failed', 'No line items were imported, there are: ' + r.importErrors.length + ' line item errors');
				}
			}
			else {
				errSvc.error('Unexpected api error', 'visitsListCtl.errFileImport', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    CREATE VISIT
	 */

	function visitCreate() {

		if(vm.isWaiting) {
			return;
		}

		$state.go('ops.visits-create', {CE:vm.query.CE.val}, {reload:'ops.visits-create'});

	}


	/**
	 * 	CLAIM MATCH
	 */

	function pickVisitForClaimMatch(item) {
		/*
			Claims feature shows the Visits feature inside a popup
			Visits feature searches for visits and user picks a Visit
			send this visit back to Claims feature parent with emit on $scope
			Claim is parent scope so will get this event
		*/

		if(vm.isWaiting || !!!item) {
			return;
		}

		$scope.$emit('ops.claims.visit-pick', {
			CE: vm.query.CE.val,
			Id: item.Id
		});

		// reset UI? choosing not to do this, popup will close this out later
		// $timeout(function(){
		// 	queryChange();
		// }, 200);
	}


	/**
	 *    EXCEL
	 *    get file from server
	 */

	function getExcel() {

		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		switch(vm.query.SearchType.val) {
			case 'NPI':
				_pendingExcelFilename = 'Verity-' + vm.query.CE.val + '-EncounterNPI.xlsx';
				break;
			case 'LIST':
				_pendingExcelFilename = 'Verity-' + vm.query.CE.val + '-Encounters.xlsx';
				break;
			default:
				throw new Error('vistsListCtl.getExcel, unknown search type: ' + vm.query.SearchType.val);
		}

		visitsRepo.getExcel(vm.query, _pendingExcelFilename).then(okServerExcel, errServerExcel);

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Create Excel Error', 'visitsListCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    HELPERS
	 */

	function saveViewState(query, flt) {

		if(vm.claimMatch) {
			return;
		}

		var vs = {
			ctx: {
				CE: query.CE.val
			},
			query: {
				DateRangeChk: !!query.DateRangeChk,
				DateRangeMode: query.DateRangeMode,
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				SearchType: query.SearchType.val
			},
			flt: flt
		};

		// search options (date range is used above)
		if(query.EncounterNum.chk) {
			vs.query.EncounterNum = query.EncounterNum.val;
			vs.query.EncounterNumChk = true;
		}
		if(query.MRN.chk) {
			vs.query.MRN = query.MRN.val;
			vs.query.MRNChk = true;
		}
		if(query.LastName.chk) {
			vs.query.LastName = query.LastName.val;
			vs.query.LastNameChk = true;
		}
		if(query.Location.chk && validSvc.isText(query.Location.val)) {
			vs.query.Location = query.Location.val.toUpperCase();
			vs.query.LocationChk = true;
		}
		if(query.NPI.chk) {
			vs.query.NPI = query.NPI.val;
			vs.query.NPIChk = true;
		}

		sessionRepo.set('vs-ops-visits', vs);

	}

	/**
	 *    DATE PICKER
	 *    EVENT HOOK, DESTROY AND TOGGLE
	 */

	 _datePickListener = $scope.$on('widget.input.date.pick.change', function (event, evtData) {
		event.stopPropagation();
		// params
		if (!evtData || !validSvc.isText(evtData.uniqueId)) {
			alert('claimsListCtl.datePickEvt, evtData and uniqueId required');
			return;
		}
		var id = evtData.uniqueId;
		vm.dtPickShow[id] = false;
		vm.query[id].val = evtData.setDate;
	});

	 function dtPickOpen(dtName) {
		var dt = vm.query[dtName];
		vm.dtPickShow.pending = dtName;

		$scope.$broadcast('widget.input.date.pick', {
			uniqueId: dtName,
			setDate: dt.val,
			minDate: dt.min,
			maxDate: dt.max
		});

		$timeout(function () {
			if (validSvc.isText(vm.dtPickShow.pending)) {
				vm.dtPickShow[vm.dtPickShow.pending] = true;
			}
		}, 100);
	}
}
 
/**
 *    AFFILIATES CONTROLLER
 *    shared across admin features
 */

affDetailCtl.$inject = ['$scope', '$state', '$q', '$timeout', 'ceRepo', 'affRepo', 'affOptionsRepo', 'rxRepo', 'vendorRepo', 'groupsRepo', 'lookupRepo', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc', 'appConst'];
angular
.module('espui.admin')
.controller('AffsDetailCtl', affDetailCtl);


/* @ngInject */
function affDetailCtl($scope, $state, $q, $timeout, ceRepo, affRepo, affOptionsRepo, rxRepo, vendorRepo, groupsRepo, lookupRepo, validSvc, errSvc, utilSvc, msgSvc, appConst) {

	/*jshint validthis: true */
	var vm = this,
		_viewErrRoute = '',
		_pendingStatus = '',
		_pendingCloneToRX = '',
		_pendingVendor = null,
		_otherAffOwnUseEnableMatchingCE = '',
		_validMsg = '',
		_regexDate = utilSvc.regex.dateFmt(),
		_datePickListener = null,
		_vendorEventListener = null,
		_ndcListListener = null,
		_mouseLeaveDelay = {};

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addMultiselect(vm);

	// properties
	vm.action = '';
	vm.isWaiting = false;
	vm.viewType = '';
	vm.getDetail = false;
	vm.expandAcct = false;

	// models
	vm.context = {};
	vm.model = {};

	// aff editing
	vm.canEdit = false;
	vm.canCreate = false;
	vm.newAff = newAff;
	vm.getAff = getAff;
	vm.exitToList = exitToList;

	// account info section
	vm.acctCancel = acctCancel;
	vm.acctSubmit = acctSubmit;
	vm.statusChange = statusChange;
	vm.inHouseCEConfig = inHouseCEConfig;
	vm.btnStatusChange = {};
	vm.SplitDroplist = [];
	vm.RxDroplist = [];
	vm.RxBizModelDroplist = [];
	vm.PricingModelDroplist = [];

	vm.rxSelect = rxSelect;
	vm.changeRX = changeRX;
	vm.changeAffBizModel = changeAffBizModel;

	// vendor list
	vm.vendors = [];
	vm.vendorNew = {};
	vm.vendorCreate = vendorCreate;

	// accum share groups
	vm.AccumShareGroupsEdit = {};
	vm.AccumSplitGroupsEdit = {};
	vm.accumGroupsAdd = accumGroupsAdd;
	vm.accumGroupsRemove = accumGroupsRemove;

	// vendor list from database
	vm.vendorDbList = [];

	// manufacturer opt-in list
	vm.GlobalExclusionManufacturerList = [];
	vm.addManufacturerOptInItem = addManufacturerOptInItem;
	vm.removeManufacturerOptInItem = removeManufacturerOptInItem;
	vm.saveManufacturerOptInList = saveManufacturerOptInList;

	// date pick
	vm.dtPickShow = {};
	vm.dtPickOpen = dtPickOpen;

	// popup
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;

	// clone aff
	vm.cloneAFF = cloneAFF;

	// wac neut
	vm.CdcDroplist = [];
	vm.wacNeutMappingAddItem = wacNeutMappingAddItem;
	vm.wacNeutMappingRemoveItem = wacNeutMappingRemoveItem;

	// aff feature claims
	vm.changeFeatureClaim = changeFeatureClaim;

	// Program Admin
	vm.TpaDroplist = [];
	var TPAOptions = [];

	// GPO Reference Account
	vm.gpoRefCEDroplist = [];
	vm.gpoRefPHDroplist = [];
	vm.gpoRefVendorDroplist = [];

	vm.gpoRefChangeCE = gpoRefChangeCE;
	vm.gpoRefChangePH = gpoRefChangePH;
	vm.gpoRefChangeVendor = gpoRefChangeVendor;

	// alternate splitting vendors
	vm.VenMulti = {};
    // federate 850s to CE vendors
	vm.Fed850VenMulti = {};
	vm.multiClick = multiClick;
	vm.multiToggle = multiToggle;
	vm.multiHover = multiHover;


	/**
	 *    DATE PICKER
	 *    EVENT HOOK, DESTROY AND TOGGLE
	 */

	 _datePickListener = $scope.$on('widget.input.date.pick.change', function (event, evtData) {
		event.stopPropagation();

		// params
		if (!evtData || !validSvc.isText(evtData.uniqueId)) {
			alert('affListCtl.datePickEvt, evtData and uniqueId required');
			return;
		}
		var id = evtData.uniqueId;

		if (id != 'ManufacturerOptInDate') {
			alert('affListCtl.datePickEvt, uniqueId unknown: ' + id);
			return;
		}

		vm.dtPickShow[id] = false;
		vm.popup[id].val = evtData.setDate;

	});

	/**
	 *    INIT
	 */

	init();

	function init() {

		// route properties
		var params = $state.params || {};
		var vt = params.ViewType;
		if(vt != 'CE-CREATE' && vt != 'CE-UPDATE' && vt != 'RX-UPDATE') {
			throw new Error('affListCtl.init, params.ViewType unknown: ' + params.ViewType);
		}
		vt = {
			type: vt.split('-')[0],
			action: vt.split('-')[1]
		};

		vm.viewType = vt.type;
		vm.getDetail = vt.action == 'UPDATE';
		_viewErrRoute = 'admin.' + vt.type.toLowerCase() + '.list';

		// context
		vm.context = {
			isVerity: $scope.User.Type == 'VERITY' || $scope.User.Type == 'VERITYSA',
			uType: $scope.User.Type,
			isDebug: !!$scope.debug,
			CE: params.CE,
			RX: validSvc.isRX(params.RX) ? params.RX : 'NONE'
		};

		// validate params
		if(!validSvc.isCE(vm.context.CE)) {
			throw new Error('affDetailCtl.init, CE required');
		}
		if(vm.getDetail && vm.context.RX == 'NONE') {
			throw new Error('affDetailCtl.init, ' + params.ViewType + ' requires a valid RXID');
		}

		// status buttons
		vm.btnStatusChange = {
			show: false,
			ONBOARDING: false,
			ACTIVE: false,
			INACTIVE: false,
			DELETED: false
		};

		vm.CdcDroplist = [{label:'Choose a Pharmacy', value: 'NONE'}];
		vm.PricingModelDroplist = utilSvc.ng.droplist([
			'CustomPriceList',
			'Reimbursement',
			'WACFloat',
			'WACMinus'
		]);

		vendorRepo.getTPAList().then(okResponse, errResponse);

		function okResponse(r) {
			for (var i = 0; i < r.length; i++) {
				TPAOptions.push(r[i]);
			}
			vm.TpaDroplist = utilSvc.aff.tpaDroplist(TPAOptions);
		}

		function errResponse(r) {
			if (!!r) {
				errSvc.warn('matchListCtl.TPA list unknown error ', r.status, utilSvc.http.safeResponse(r));
			}
		}

		// set editing rights
		vm.canCreate = vm.viewType == 'CE';
		vm.canEdit = vm.viewType == 'CE' || vm.viewType == 'RX';

		vm.GlobalExclusionManufacturerList = $scope.User.ManufacturerExclusionList;
		for (var i = 0; i < vm.GlobalExclusionManufacturerList.length; i++) {
			vm.GlobalExclusionManufacturerList[i].NameWithLabelerId = vm.GlobalExclusionManufacturerList[i].Name + '(' + vm.GlobalExclusionManufacturerList[i].LabelerId + ')';
		}

		// alt split vendors
		vm.VenMulti = {
			type: 'VEN',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'Choose a Vendor',
			titleNoOptions: 'Choose a Vendor',
			vals: [],
			list: [], // aff get will set the list
			flt: ''
		};

		// federate 850s to CE vendors - filter to current affiliation only
		var currentAff = utilSvc.aff.findRx(utilSvc.aff.findCe($scope.User.AffList, vm.context.CE), vm.context.RX);
		var venList = utilSvc.aff.venList(currentAff, ['340B', 'GPO', 'WAC', 'WACMED', 'OWNUSE', 'IND']);
		vm.Fed850VenMulti = {
			type: 'VEN',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'Choose a Vendor',
			titleNoOptions: 'Choose a Vendor',
			vals: [],
			list: vm.multiselectBuild(venList,false),
			flt: ''
		};

		// CREATE or UPDATE?
		if(vm.getDetail) {
			getAff(vm.context.CE, vm.context.RX);
		}
		else {
			newAff(vm.context);
		}

	}

	/**
	 *    VENDOR WIDGET EVENT
	 */

	_vendorEventListener = $scope.$on('widget.aff.vendor', function(event, evtData) {
		event.stopPropagation();

		// event listener for vendor widget changes

		// params
		evtData = evtData || {};
		var errTxt = '';

		if(!validSvc.isText(evtData.uniqueId)) {
			errTxt = 'requires unique id';
		}

		switch(evtData.action) {
			case 'CANCEL':
				break;

			case 'CREATE':
			case 'UPDATE':
			case 'DELETE':
				if(!validSvc.isText(evtData.Vendor) || !validSvc.isText(evtData.AccumType)) {
					errTxt = 'Vendor and AccumType required';
				}
				break;

			case 'CLONENDC':
				if(!validSvc.isText(evtData.Vendor) || !validSvc.isText(evtData.AccumType) || !validSvc.isText(evtData.AcctId)) {
					errTxt = 'Vendor, AccumType, AcctId required';
				}
				if(evtData.listType != 'AlwaysSplit' && evtData.listType != 'NeverSplit' && evtData.listType != 'OrderExcls' && evtData.listType != 'OrderPref') {
					errTxt = 'clone list type unknown: ' + evtData.listType;
				}
				break;

			default:
				errTxt = 'event action unknown: ' + evtData.action;
		}

		if(!!errTxt) {
			throw new Error('affDetailCtl.widget.aff.vendor ', errTxt);
		}

		// process event
		vendorEvent(evtData);

	});

	_ndcListListener = $scope.$on('widget.ops.ndc.list.count', function(event, evtData) {
		event.stopPropagation();

		// event listener for ndc list widget changes

		// params
		evtData = evtData || {};
		if(!validSvc.isText(evtData.ListType) || !validSvc.isNumber(evtData.ItemsCount)) {
			throw new Error('widget.aff.vendor, ndc list event requires ListType, ItemsCount');
		}

		// update count
		switch(evtData.ListType) {
			case 'MATCHREVIEWNDCLIST':
				vm.model.MatchReviewNdcListCount = evtData.ItemsCount;
				break;
			case '340BALTDRUGS':
				vm.model.Alt340BNdcListCount = evtData.ItemsCount;
				break;
			default:
				throw new Error('widget.aff, ndc list event has unknown list type: ' + evtData.ListType);
		}

	});

	$scope.$on('$destroy', function() {
		_vendorEventListener();
		_ndcListListener();
	});

	function getCE() {
		vm.isWaiting = true;
		msgSvc.wait(true);

		ceRepo.getDetail(vm.context.CE).then(okGetCE, errGetCE);

		function okGetCE(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;
      
      		// add CdcType  
      		vm.context.CdcType = r.CdcType.val;
			// add CE details to context
			vm.context.CeCashCard = r.CashCard;
			vm.context.CeExpressScriptsCustomer = r.ExpressScriptsCustomer;
			vm.context.CeProgAdminNotVerity = r.IsVerityPrimary == 'no';

			//show/hide HRSA section
			vm.ceIsHrsaRegistered = r.IsHrsaRegistered;
			vm.ceIsOwnUseEnabled = r.CeOwnUseProgram == 'yes';

			// show/hide multiple sections for VERISAVE
			vm.ProductType = r.ProductType;

			// GPO prohibited ??
			vm.ceIsGPOProhibited = false;

			var opaType = r.OpaType.val;
			if(opaType == 'DSH' || opaType == 'CAN' || opaType == 'PED') {
				vm.ceIsGPOProhibited = true;
			}
	
			if (vm.action == 'CREATE') {
				// set aff cash card to yes if CE is on
				if (vm.context.CeCashCard == 'yes') {
					vm.model.CashCardParticipant = 'yes';
				}

				// get pharmacy list to rebuild for VHUB if prog admin NOT VERITY
				if (vm.context.CeProgAdminNotVerity) {
					vm.isWaiting = true;
					msgSvc.wait(true);
					rxRepo.getList().then(okRxList, errRxList);
				}

				var disable340BMatching = vm.ceIsHrsaRegistered == 'no';
				var ownUseEnableMatching = vm.ceIsHrsaRegistered == 'no';
				vm.model = affRepo.modelVM({CEID: vm.context.CE, Disable340BMatching: disable340BMatching, OwnUseEnableMatching: ownUseEnableMatching, ProductType: vm.ProductType });
			}
			else {
				// get Vendor accounts on UPDATE
				getVendorList();

				vm.model = buildFederate850ToCEList(vm.model);
			}

			// Setup Rx affiliation after CE call
			setupRxAffiliates(vm.action).then(okAffs, errAffs);
		}

		function errGetCE(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if (r !== null) {
				errSvc.warn('Not able to get CE ' + ceid);
				$state.go(_viewErrRoute, {}, { reload: _viewErrRoute });
			}

		}

		function okAffs(r) {
			vm.isWaiting = false;

			vm.RxDroplist = r.affs;

			vm.SplitDroplist = [
				{ label: 'No Sequence', value: 'NONE' },
				{ label: '340B', value: '340B' },
				{ label: '340B WACMED', value: '340B WAC' },
				{ label: '340B GPO', value: '340B GPO' },
				{ label: '340B GPO WACMED', value: '340B GPO WAC' },
				{ label: 'WACMED 340B', value: 'WAC 340B' },
				{ label: 'WACMED 340B GPO', value: 'WAC 340B GPO' }
			];

			// load vendors
			vm.vendorDbList = [];
			var i = 0;
			for (i = 0; i < r.vendorDbList.length; i++) {
				if (r.vendorDbList[i].ObjectState == 'ACTIVE' && r.vendorDbList[i].Type != 'DRUGDB') {
					vm.vendorDbList.push(r.vendorDbList[i].Id);
				}
			}
			vm.vendorDbList.sort();

			// build CDC droplist
			var affs = $scope.User.AffList,
				pdcAffs = [];
			for (i = 0; i < affs.length; i++) {
				if (!!affs[i].RxCDC) {
					pdcAffs.push(affs[i]);
				}
			}
			vm.CdcDroplist = utilSvc.aff.rxDroplist(pdcAffs);

			// expand sections
			if (!vm.expandAcct) {
				vm.expandAcct = r.action == 'CREATE';
			}

			// reset get detail route flag after first update
			vm.getDetail = false;

			// CREATE or UPDATE UI
			refreshStatusButtons(r.action, vm.model.ObjectState);
		}

		function errAffs(r) {
			vm.isWaiting = false;
			if (r !== null) {
				errSvc.warn('Login refresh failed during CE edit for: ' + vm.context.CE + '/' + vm.context.RX, 'affDetailCtl.errLoginRefresh', r.status, utilSvc.http.safeResponse(r));
				$state.go(_viewErrRoute, {}, { reload: _viewErrRoute });
			}

		}
	}

	function okRxList(r) {
		msgSvc.wait(false);
		vm.isWaiting = false;

		// remove all pharmacies which are not VHUB from droplist

		var	vhubItems = [],
			i = 0;

		// build vhub rxid list
		r = Array.isArray(r.data) ? r.data : [];
		for(i = 0; i < r.length; i++) {
			if(!!r[i].VHub && !!r[i].VHub.Enabled) {
				vhubItems.push(r[i].Id);
			}
		}

		// remove non vhub from droplist
		var rxItems = vm.RxDroplist;
		for(i = rxItems.length - 1; i > 0; i--) {
			if(vhubItems.indexOf(rxItems[i].value) < 0) {
				rxItems.splice(i, 1);
			}
		}

	}

	function errRxList(r) {
		msgSvc.wait(false);
		vm.isWaiting = false;

		if(!!r) {
			errSvc.warn('Not able to get RX info');
			$state.go(_viewErrRoute, {}, {reload: _viewErrRoute});
		}
	}

	function getRx() {
		vm.isWaiting = true;
		msgSvc.wait(true);

		if ( vm.context.RX == "NONE" ) {
			return;
		}

		rxRepo.getDetail(vm.context.RX).then(okRxDetail, errRxDetail);

		function okRxDetail(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			vm.model.RxFederatesClaims = r.FederateRawClaims.val == 'yes';
		}

		function errRxDetail(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if (!!r) {
				errSvc.error('Unexpected api error', 'affDetailCtl.errRxDetail', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function getAffs() {
		var affs = utilSvc.aff.findStatus($scope.User.AffList, ['ONBOARDING', 'ACTIVE']);
		var rxAffs = utilSvc.aff.findRxList(affs, [vm.context.RX]);
		var other = [];
		for(var i = 0; i < rxAffs.length; i++) {
			if(rxAffs[i].CEID != vm.context.CE) {
				other.push(rxAffs[i]);
			}
		}
		if (other.length > 0) {
			vm.isWaiting = true;
			msgSvc.wait(true);	
			lookupRepo.AffInfo(utilSvc.aff.ceList(other), [vm.context.RX]).then(okLookUpAffInfo, errLookUpAffInfo);
		}
	}

	function okLookUpAffInfo(affs) {
		msgSvc.wait(false);
		vm.isWaiting = false;
		for(var i = 0; i < affs.length; i++) {
			if (!!affs[i].OwnUseEnableMatching) {
				_otherAffOwnUseEnableMatchingCE = affs[i].CEID;
				break;
			}
		}
		console.log('okLookUpAffInfo', affs, _otherAffOwnUseEnableMatchingCE);
	}

	function errLookUpAffInfo(r) {
		if(!!r) {
			throw new Error('affDetailCtl.errLookUpAffInfo, unkown api error');
		}
	}


	/**
	 *    CREATE / UPDATE
	 */

	// CE GROUP MEMBERS
	function okGetGroupMembers(r) {
		setupGPOReferenceCEDroplist(r);
	}

	function errGetGroupMembers(r) {
		setupGPOReferenceCEDroplist([vm.context.CE]);
	}

	function setupGPOReferenceCEDroplist(items) {
		var affPrompt = [{label:'Choose a Facility', value:'NONE'}];
		vm.gpoRefCEDroplist = utilSvc.ng.droplist(items,'','',affPrompt);
		vm.model.GPOReferenceCE = utilSvc.ng.droplistAutoselect(vm.gpoRefCEDroplist, vm.model.GPOReferenceCE.val);

		gpoRefChangeCE();
	}

	function newAff(ctx) {
		vm.isWaiting = true;

		// only CE can create a new affiliation
		if(!validSvc.isCE(ctx.CE)) {
			throw new Error('affDetailCtl.newAff, ceid is required to create a new affiliate');
		}
		vm.RxBizModelDroplist = [{label: 'None', value: 'NONE'}];

		// NOTE: this is ASYNC, nothing can go below it
		setupUpdateUI('CREATE');

	}

	function getAff(ceid, rxid) {

		vm.isWaiting = true;
		msgSvc.wait(true);

		vm.action = '';
		vm.model = {};
		vm.AccumShareGroupsEdit = {};
		vm.AccumSplitGroupsEdit = {};

		vm.context.CE = ceid;
		vm.context.RX = rxid;

		affRepo.getDetail(ceid, rxid).then(okAffDetail, errAffDetail);

		function okAffDetail(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			vm.model = r;
			vm.model.OrigClaimFederationStart = vm.model.ClaimFederationStart.val;

			vm.model.RxBizModels.sort();
			vm.RxBizModelDroplist = [{label: 'None', value: 'NONE'}];
			for(var i = 0; i < vm.model.RxBizModels.length; i++) {
				vm.RxBizModelDroplist.push({label: affilBizModelText(vm.model.RxBizModels[i]), value: vm.model.RxBizModels[i]});
			}

			// add aff status to context for vendor widgets
			vm.context.AffStatus = r.ObjectState;
			vm.context.RxSequentialSplit= r.RxSequentialSplit;
			vm.context.RXParentID = r.RXParentID;

			// load group members
			if(vm.gpoRefCEDroplist.length < 1) {
				groupsRepo.memberListGet(vm.context.CE, "CE").then(okGetGroupMembers, errGetGroupMembers);
			}

			// NOTE: this is ASYNC, nothing can go below it
			setupUpdateUI('UPDATE');

		}

		function errAffDetail(r) {

			msgSvc.wait(false);
			vm.isWaiting = false;

			if(r !== null) {
				errSvc.warn('Not able to get affiliation for CE/RX: ' + vm.context.CE + '/' + vm.context.RX, 'affDetailCtl.errAffDetail', r.status, utilSvc.http.safeResponse(r));
				$state.go(_viewErrRoute, {}, {reload: _viewErrRoute});
			}

		}

	}


	/**
	 *    SETUP UPDATE UI
	 *    used by CREATE and UPDATE ui actions
	 */

	function setupRxAffiliates(action) {

		// **** NOTE: this function is ASYNC
		// get all server data needed for aff editing

		var defer = $q.defer();
		affRepo.getInitData().then(okInitData, errInitData);

		function okInitData(r) {

			switch(action) {

				case 'UPDATE':
					// show only linked pharmacy disabled (cannot change a pharmacy after creation)
					defer.resolve({
						action: action,
						affs: [{label: vm.context.RX, value: vm.context.RX}],
						vendorDbList: r.vendors
					});
					break;

				case 'CREATE':
					var rxModels = [];
					if (vm.ProductType == 'VERISAVE') {
						rxModels = ['SPLIT','SPLITMATCH'];
					}
					var rxList = newAffiliationOptions(vm.context.CE, $scope.User.AffList, rxModels);
					defer.resolve({
						action: action,
						affs: utilSvc.ng.droplist(rxList, '', '', [{label:'Choose a Pharmacy Affiliate', value:'NONE'}]),
						vendorDbList: r.vendors
					});
					break;

				default:
					throw new Error('affDetailCtl.setupRxAffiliates, action unknown: ' + action);

			}

		}

		function errInitData(r) {
			defer.reject(r);
		}

		return defer.promise;

	}

	function newAffiliationOptions(ceid, userAffs, rxModels) {

		// parse for valid pharmacies to affiliate with this CE

		// rx type
		var affs = utilSvc.aff.findRxType(userAffs, ['DISPENSING', 'CENTRALFILL']);

		// limit by business model?
		if(Array.isArray(rxModels) && rxModels.length > 0) {
			affs = utilSvc.aff.findRxModel(affs, rxModels);
		}

		// strip out existing pharmacy affiliates of this CE
		var existingAffs = utilSvc.aff.findCe(affs, ceid);
		existingAffs = utilSvc.aff.rxList(existingAffs);
		var newAffs = [];
		for(var i = 0; i < affs.length; i++) {
			if(existingAffs.indexOf(affs[i].RXID) < 0) {
				newAffs.push(affs[i]);
			}
		}

		return utilSvc.aff.rxList(newAffs);

	}

	function setupUpdateUI(action) {

		// setup ui for editing, add ui functionality to data model if needed
		
		// CE properties needed for aff editing (both CREATE and UPDATE), get it first
		vm.action = action;
		getCE();
		getRx();
		getAffs();
	}

	function refreshStatusButtons(action, affStatus) {

		// called after get and status updates

		vm.btnStatusChange = {
			show: false,
			ONBOARDING: false,
			ACTIVE: false,
			INACTIVE: false,
			DELETED: false
		};

		// exit if in create mode (status changes not shown)
		if(action == 'CREATE' || !validSvc.isText(affStatus)) {
			return;
		}

		var saUser = vm.context.uType == 'VERITYSA',
			isDebug = vm.context.isDebug;

		switch(affStatus) {

			case 'QUEUED':
				vm.btnStatusChange.ONBOARDING = true;
				break;

			case 'ONBOARDING':
				vm.btnStatusChange.ACTIVE = true;
				vm.btnStatusChange.DELETED = saUser;
				break;

			case 'ACTIVE':
				vm.btnStatusChange.ONBOARDING = isDebug;
				vm.btnStatusChange.INACTIVE = true;
				break;

			case 'INACTIVE':
				vm.btnStatusChange.ACTIVE = true;
				vm.btnStatusChange.DELETED = saUser;
				break;

			case 'DELETED':
				//vm.btnStatusChange.INACTIVE = saUser;
				break;
				
			case 'CREATE':
				break;

			default:
				throw new Error('affDetailCtl.refreshStatusButtons, aff status unknown: ' + affStatus);

		}

		// show if at least one button is displayed
		vm.btnStatusChange.show = vm.btnStatusChange.ONBOARDING || vm.btnStatusChange.ACTIVE || vm.btnStatusChange.INACTIVE || vm.btnStatusChange.DELETED;

	}


	/**
	 *    CHANGE EVENTS
	 */

	function rxSelect(rxid) {

		_pendingCloneToRX = rxid;

		if(!!!vm.popup || !validSvc.isRX(rxid)) {
			closePopup();
		}

        if(vm.popup.type == 'RXSELECTOR') {
            vm.model.RX = utilSvc.ng.droplistAutoselect(vm.RxDroplist, rxid);
            changeRX();
        }
        else {
			cloneAFF(rxid);
        }
		closePopup();
	}

	function changeRX() {

		// angular null bug
		if(vm.model.RX.val === null) {
			return;
		}

		// reset biz model
		vm.RxBizModelDroplist = [{label: 'None', value: 'NONE'}];
		vm.model.AffilBizModel = validSvc.newProp('NONE');
		vm.model.RxBizModels = [];

		vm.model.RX.fail = validSvc.isRX(vm.model.RX.val) ? '' : 'yes';
		if(vm.model.RX.fail == 'yes') {
			vm.model.RX.msg = 'required';
		}
		else {
			// get rx models
			rxRepo.getDetail(vm.model.RX.val).then(okRxDetail, errRxDetail);
		}

	}

	function okRxDetail(r) {

		// build rx biz model choices
		var rxModels = Array.isArray(r.RxBizModels) ? r.RxBizModels : [];
		rxModels.sort();
		vm.model.RxBizModels = rxModels;

		for(var i = 0; i < rxModels.length; i++) {
			vm.RxBizModelDroplist.push({label: affilBizModelText(rxModels[i]), value: rxModels[i]});
		}

		// auto-select model?
		if(rxModels.length === 1) {
			vm.model.AffilBizModel.val = rxModels[0];
		}

		// apply Billing from chosen RX to this affiliation
		vm.model = applyRxBilling(vm.model, r);

	}

	function applyRxBilling(m, rxm) {

		// set enabled state
		var billOn = rxm.BillEnabled == 'yes';
		m.RxBillEnabled = billOn ? 'yes' : 'no';
		m.BillEnabled = billOn ? 'yes' : 'no';

		// rx parent
		m.RxBillOverride = billOn ? rxm.BillOverride : 'no';
		m.RxBillFrequency = billOn ? rxm.BillFrequency.val : '';
		m.RxBillExport = billOn ? rxm.BillExport : 'no';
		m.RxBillExportDetailedRollup = billOn ? rxm.BillExportDetailedRollup : 'no';
		m.RxBillExportFees = billOn ? rxm.BillExportFees : 'no';
		m.RxBillExportDrugCost = billOn ? rxm.BillExportDrugCost : 'no';

		// affiliation
		m.BillOverride = 'no';  // always set back to no
		m.BillExport = m.RxBillExport;
		m.BillExportFees = m.RxBillExportFees;
		m.BillExportDrugCost = m.RxBillExportDrugCost;

		return m;

	}

	function errRxDetail(r) {
		if(!!r) {
			errSvc.error('Unexpected api error', 'affDetailCtl.errRxDetail', r.status, utilSvc.http.safeResponse(r));
		}
	}

	function changeAffBizModel() {

		// angular null bug
		if(vm.model.AffilBizModel.val === null) {
			return;
		}

		// warn user biz model change is a big deal
		if(vm.action == 'UPDATE' && vm.vendors.length > 0 && vm.model.AffilBizModel.val != vm.model.AffilBizModelClean) {
			msgSvc.ok('Model Change Warning', 'Changing model from ' + vm.model.AffilBizModelClean + ' to ' + vm.model.AffilBizModel.val + ' will cause all ACTIVE Vendor Accounts to be set INACTIVE, some Vendor settings will be reset.');
		}

	}

	function changeFeatureClaim(claimName) {

		var claimVal = vm.model[claimName];

		// ignore view check if the ce is not ESI and does not own the pharmacy
		if(vm.context.CeExpressScriptsCustomer == 'no' && vm.model.RollupCeUserCanViewClaims == 'no' && vm.model.CeOwnedPharmacy == 'no' && claimName == 'UserCanViewClaims') {
			msgSvc.ok('Cannot Set View Claims Option', 'View Pharmacy Claims requires the Facility to be an Express Scripts customer or the Pharmacy is in-house owned by the Facility or the Pharmacy is in a Rollup with CE User Claims Access.');
			return;
		}

		// ignore match check if view claims is no
		if(vm.model.UserCanViewClaims == 'no' && claimName == 'UserCanMatchClaims') {
			msgSvc.ok('Cannot Set Option', 'Match Pharmacy Claims requires View Pharmacy Claims to be checked first');
			return;
		}

		vm.model[claimName] = claimVal == 'no' ? 'yes' : 'no';

		// match is dependent on view
		if(claimName == 'UserCanViewClaims' && vm.model.UserCanViewClaims == 'no') {
			vm.model.UserCanMatchClaims = 'no';
		}

	}


	/**
	 *    EXIT TO LIST VIEW
	 */

	function exitToList() {

		// tbd: check in-progress work before switching back to list

		vm.action = '';
		vm.model = affRepo.modelVM({ProductType: vm.ProductType});

		if(vm.viewType == 'CE') {

			$state.go('admin.ce.edit.affs', {
				ViewType: 'CE',
				CE: vm.context.CE,
				RX: 'NONE'
			}, {reload: 'admin.ce.edit.affs'});

		}
		else {

			$state.go('admin.rx.edit.affs', {
				ViewType: 'RX',
				CE: vm.context.CE,
				RX: vm.context.RX
			}, {reload: 'admin.rx.edit.affs'});

		}

	}


	/**
	 *    ACCOUNT: CANCEL
	 */

	function acctCancel() {

		switch(vm.action) {

			case 'CREATE':
				// exit back to list view
				exitToList();
				break;

			case 'UPDATE':
				// potentially too much data changed, return to list
				exitToList();
				break;

			default:
				throw new Error('affDetailCtl.acctCancel, unknown action: ' + vm.action);

		}

	}


	/**
	 *    ACCOUNT INFO: SUBMIT
	 */

	function acctValid() {
		_validMsg = '';

		// validate for both create and update

		var m = vm.model;

		// pharmacy
		if(!validSvc.isRX(m.RX.val)) {
			m.RX.fail = 'yes';
			m.RX.msg = 'required';
			return;
		}
		else {
			m.RX.fail = 'no';
			m.RX.msg = '';
		}

		if (m.CEAffilIsExternal == 'no') {
			m.ProgramAdmin = validSvc.newProp('');
		} 
		else {
			m.ProgramAdmin = validText(m.ProgramAdmin, 2, 200); // something must be selected
		}

		// hrsa contract date - required
		if(!!m.ContractDate.val || vm.ceIsHrsaRegistered == 'yes') {
			m.ContractDate = validSvc.propDateValid(m.ContractDate, _regexDate);
			m.ContractDate.fail = !!m.ContractDate.fail ? 'yes' : 'no';
		}
		// hrsa termination date - optional, validate if not empty
		if(!!m.ContractTerminationDate.val) {
			m.ContractTerminationDate = validSvc.propDateValid(m.ContractTerminationDate, _regexDate);
			if(m.ContractTerminationDate.fail) {
				m.ContractTerminationDate.fail = 'yes';
			}
			else {
				m.ContractTerminationDate.fail = 'no';
			}
		}
		else {
			m.ContractTerminationDate.fail = '';
		}

		// hrsa contract/term dates - relationship
		if(m.ContractTerminationDate.fail == 'no') {

			// contract date must exist, be less than termination date
			if(m.ContractDate.fail != 'no') {
				m.ContractDate.fail = 'yes';
				m.ContractDate.msg = 'required if termination date entered';
			}
			else if(!utilSvc.dt.greaterThan(new Date(m.ContractDate.val), new Date(m.ContractTerminationDate.val))) {
				m.ContractTerminationDate.fail = 'yes';
				m.ContractTerminationDate.msg = 'must be greater than effective date';
			}
		}

		// hrsa term reason - optional
		if(validSvc.isText(m.TerminationCause.val)) {
			m.TerminationCause = validText(m.TerminationCause, 2, 200);
		}
		else {
			m.TerminationCause.fail = '';
		}

		// affil name - optional
		if(validSvc.isText(m.AffilName.val)) {
			m.AffilName = validText(m.AffilName, 2, 50);
		}
		else {
			m.AffilName.fail = '';
		}

		// hrsa term reason - required if term date entered
		if(m.ContractTerminationDate.fail == 'no' && m.TerminationCause.fail !== 'no') {
			m.TerminationCause.fail = 'yes';
			m.TerminationCause.msg = 'required if termination date entered';
		}

		// Claim Federation Start
		if (!!m.ClaimFederationStart.val && m.RxFederatesClaims && m.CEAffilIsExternal == 'yes') {
			m.ClaimFederationStart = validSvc.propDateValid(m.ClaimFederationStart, _regexDate);
			m.ClaimFederationStart.fail = !!m.ClaimFederationStart.fail ? 'yes' : 'no';
		}
		
		// PRICING
		if(vm.ProductType == 'V340B' && m.RxPricingModelScope != 'PHARMACY' && (m.RxPricingModelScope != 'BOTH' || m.PricingModelOverride == 'yes')) {
			// pricing model - required
			if(!validSvc.isText(m.PricingModel.val)) {
				m.PricingModel.fail = 'yes';
				m.PricingModel.msg = 'required';
			}
			else {
				m.PricingModel.fail = '';
			}

			// pricing rate, required for WACMinus
			if(m.PricingModel.val == 'WACMinus') {
				m.PricingRate = validCurrency(m.PricingRate, 0.00, 500);
			}
			else if(m.PricingModel.val == 'Reimbursement') {
				m.PricingRate = validCurrency(m.PricingRate, 0.00, 99);
			}
			else {
				m.PricingRate.fail = '';
				m.PricingRate.val = 0.0;
			}
		}
		else {
			m.PricingModelOverride = 'no';
			m.PricingModel = validSvc.newProp('');
			m.PricingRate = validSvc.newProp(0.0);
		}

		// Minimum claim value for CP
		m.MinClaimValue = validCurrency(m.MinClaimValue, 0.00, 9999);

		// monthly fee for any aff biz model type
		m.FeeVerityMonthly = validCurrency(m.FeeVerityMonthly, 0.00, 9999);

		// all properties below are aff biz model dependent
		var affilBizModel = m.AffilBizModel.val;
		if(affilBizModel != 'NONE' && m.RxBizModels.indexOf(affilBizModel) < 0) {
			m.AffilBizModel.fail = 'yes';
			m.AffilBizModel.msg = affilBizModel + ' not supported by pharmacy';
			return;
		}

		// MATCHING - afiil models: CP, SPLITMATCH, CPTPA
		m.MatchingFail = false;
		m.MatchingMsg = '';
		if(vm.ProductType == 'V340B' && (affilBizModel == 'CP' || affilBizModel == 'SPLITMATCH' || affilBizModel == 'CPTPA')) {
			// choose at least one matching
			if(vm.model.VCentralEnabled == 'no' && vm.ProductType == 'V340B') {
				if(m.Enable340BMatching == 'no' && m.EnableGPOMatching.val == 'no' && ((m.EnableOwnUseMatching == 'no' && vm.ceIsOwnUseEnabled) || !vm.ceIsOwnUseEnabled)) {
					m.MatchingFail = true;
					m.MatchingMsg = 'choose at least one matching';
				}
			}

			// OWN Matching
			if(!!vm.ceIsOwnUseEnabled && vm.model.EnableOwnUseMatching == 'yes') {
				// match elig days before - required, min 0, max 30
				var delayOwn = m.OwnUseAccumulationDelay.val,
					ownAccumDelayOk = validSvc.isNumber(delayOwn) && delayOwn >= 0 && delayOwn <= 30;
				m.OwnUseAccumulationDelay.fail = ownAccumDelayOk ? 'no' : 'yes';
				m.OwnUseAccumulationDelay.msg = ownAccumDelayOk ? '' : 'number 0 to 30';

				// check if Own Use Matching is enabled for another affiliation
				if (!!_otherAffOwnUseEnableMatchingCE) {
					 _validMsg = 'Affiliation ' + _otherAffOwnUseEnableMatchingCE + '/' + vm.context.RX  + ' has Own Use Matching enabled for this Pharmacy. Only one Facility Affiliation can have Own Use Matching enabled per Pharmacy.';
					return false;
				}
			} else {
				m.OwnUseAccumulationDelay = validSvc.newProp(0);
			}

			// GPO Matching
			if((affilBizModel != 'SPLITMATCH' && affilBizModel != 'CP') || (affilBizModel == 'CP' && m.CeOwnedPharmacy != 'yes')) {
				m.EnableGPOMatching = validSvc.newProp('no');
				m.EnableMatchByFile = validSvc.newProp('no');
				m.IncludeDispenseBasedEligibility = validSvc.newProp('no');
			}

			// GPO match delay
			if(m.Enable340BMatching == 'yes' && m.EnableGPOMatching.val == 'yes') {
				// match elig days before - required, min 0, max 30
				var delay = m.GPOMatchDelay.val,
					gpoMatchOk = validSvc.isNumber(delay) && delay >= 0 && delay <= 30;
				m.GPOMatchDelay.fail = gpoMatchOk ? 'no' : 'yes';
				m.GPOMatchDelay.msg = gpoMatchOk ? '' : 'number 0 to 30';
			} else {
				m.GPOMatchDelay = validSvc.newProp(0);
			}

			// match elig days before - required, min 0, max 365
			var eligDays = m.VisitEligDaysBefore.val;
			if(!validSvc.isNumber(eligDays) || eligDays < 0 || eligDays > 1095) {
				m.VisitEligDaysBefore.fail = 'yes';
				m.VisitEligDaysBefore.msg = 'number 0 to 1095';
			}
			else {
				m.VisitEligDaysBefore.fail = 'no';
				m.VisitEligDaysBefore.msg = '';
			}

			// match elig days after - required, min 0, max 30
			eligDays = m.VisitEligDaysAfter.val;
			if(!validSvc.isNumber(eligDays) || eligDays < 0 || eligDays > 30) {
				m.VisitEligDaysAfter.fail = 'yes';
				m.VisitEligDaysAfter.msg = 'number 0 to 30';
			}
			else {
				m.VisitEligDaysAfter.fail = 'no';
				m.VisitEligDaysAfter.msg = '';
			}

			if(m.DispenseExpiration.Enabled == 'yes') {
				var expDays = m.DispenseExpiration.MaxDispenseAge;
				if(!validSvc.isNumber(expDays) || expDays < 1 || expDays > 730) {
					m.DispenseExpiration.fail = 'yes';
					m.DispenseExpiration.msg = 'Dispense Expiration must be a number between 1 and 730';
				}
				else {
					m.DispenseExpiration.fail = 'no';
					m.DispenseExpiration.msg = '';
				}
			}

		}
		else {
			// wrong biz model, set defaults
			m.VisitEligDaysBefore.fail = '';
			m.VisitEligDaysAfter.fail = '';
			m.CeMatchReview = 'no';
			m.ValidateClaimsModifier = validSvc.newProp('no');
			m.GPOMatchDelay = validSvc.newProp(0);
			m.OwnUseAccumulationDelay = validSvc.newProp(0);
		}

		// FEES AND GENERICS - afiil models: CP, CPTPA
		if(affilBizModel == 'CP' || affilBizModel == 'CPTPA') {

			// fees
			m.FeeEligibility = validCurrency(m.FeeEligibility, 0.00, 9999);
			m.FeeOrder = validCurrency(m.FeeOrder, 0.00, 9999);
			m.FeeOrderPercent = validCurrency(m.FeeOrderPercent, 0.0, 100.0);
			m.FeeBrand = validCurrency(m.FeeBrand, 0.00, 9999);
			m.FeeBrandPercent = validCurrency(m.FeeBrandPercent, 0.0, 100.0);

			// validate variable min/max amount if % is > 0 and checkbox is checked
			if(m.FeeOrderPercent.val > 0 && m.FeeOrderPercentMinAmtChk) {
				m.FeeOrderPercentMinAmt = validCurrency(m.FeeOrderPercentMinAmt, 1.0, 1000);
			}
			else {
				m.FeeOrderPercentMinAmt = validSvc.newProp(0);
				m.FeeOrderPercentMinAmtChk = false;
			}

			if(m.FeeOrderPercent.val > 0 && m.FeeOrderPercentMaxAmtChk) {
				m.FeeOrderPercentMaxAmt = validCurrency(m.FeeOrderPercentMaxAmt, 0.0, 9999);
			}
			else {
				m.FeeOrderPercentMaxAmt = validSvc.newProp(0);
				m.FeeOrderPercentMaxAmtChk = false;
			}

			if(m.FeeBrandPercent.val > 0 && m.FeeBrandPercentMinAmtChk) {
				m.FeeBrandPercentMinAmt = validCurrency(m.FeeBrandPercentMinAmt, 1.0, 1000);
			}
			else {
				m.FeeBrandPercentMinAmt = validSvc.newProp(0);
				m.FeeBrandPercentMinAmtChk = false;
			}

			if(m.FeeBrandPercent.val > 0 && m.FeeBrandPercentMaxAmtChk) {
				m.FeeBrandPercentMaxAmt = validCurrency(m.FeeBrandPercentMaxAmt, 0.0, 9999);
			}
			else {
				m.FeeBrandPercentMaxAmt = validSvc.newProp(0);
				m.FeeBrandPercentMaxAmtChk = false;
			}

			m.FeeGeneric = validCurrency(m.FeeGeneric, 0.00, 9999);
			m.FeeGenericPercent = validCurrency(m.FeeGenericPercent, 0.0, 100.0);

			// validate variable min/max amount if % is > 0 and checkbox is checked
			if(m.FeeGenericPercent.val > 0 && m.FeeGenericPercentMinAmtChk) {
				m.FeeGenericPercentMinAmt = validCurrency(m.FeeGenericPercentMinAmt, 1.0, 1000);
			}
			else {
				m.FeeGenericPercentMinAmt = validSvc.newProp(0);
				m.FeeGenericPercentMinAmtChk = false;
			}
			if(m.FeeGenericPercent.val > 0 && m.FeeGenericPercentMaxAmtChk) {
				m.FeeGenericPercentMaxAmt = validCurrency(m.FeeGenericPercentMaxAmt, 0.0, 9999);
			}
			else {
				m.FeeGenericPercentMaxAmt = validSvc.newProp(0);
				m.FeeGenericPercentMaxAmtChk = false;
			}

			m.FeeSpecialtyOrder = validCurrency(m.FeeSpecialtyOrder, 0.00, 9999);
			m.FeeSpecialtyOrderPercent = validCurrency(m.FeeSpecialtyOrderPercent, 0.0, 100.0);
			m.FeeSpecialtyBrand = validCurrency(m.FeeSpecialtyBrand, 0.00, 9999);
			m.FeeSpecialtyBrandPercent = validCurrency(m.FeeSpecialtyBrandPercent, 0.0, 100.0);
			// validate variable max/min amount if % is > 0 and checkbox is checked
			if(m.FeeSpecialtyOrderPercent.val > 0 && m.FeeSpecialtyOrderPercentMinAmtChk) {
				m.FeeSpecialtyOrderPercentMinAmt = validCurrency(m.FeeSpecialtyOrderPercentMinAmt, 1.0, 1000);
			}
			else {
				m.FeeSpecialtyOrderPercentMinAmt = validSvc.newProp(0);
				m.FeeSpecialtyOrderPercentMinAmtChk = false;
			}
			if(m.FeeSpecialtyOrderPercent.val > 0 && m.FeeSpecialtyOrderPercentMaxAmtChk) {
				m.FeeSpecialtyOrderPercentMaxAmt = validCurrency(m.FeeSpecialtyOrderPercentMaxAmt, 0.0, 9999);
			}
			else {
				m.FeeSpecialtyOrderPercentMaxAmt = validSvc.newProp(0);
				m.FeeSpecialtyOrderPercentMaxAmtChk = false;
			}

			if(m.FeeSpecialtyBrandPercent.val > 0 && m.FeeSpecialtyBrandPercentMinAmtChk) {
				m.FeeSpecialtyBrandPercentMinAmt = validCurrency(m.FeeSpecialtyBrandPercentMinAmt, 1.0, 1000);
			}
			else {
				m.FeeSpecialtyBrandPercentMinAmt = validSvc.newProp(0);
				m.FeeSpecialtyBrandPercentMinAmtChk = false;
			}
			if(m.FeeSpecialtyBrandPercent.val > 0 && m.FeeSpecialtyBrandPercentMaxAmtChk) {
				m.FeeSpecialtyBrandPercentMaxAmt = validCurrency(m.FeeSpecialtyBrandPercentMaxAmt, 0.0, 9999);
			}
			else {
				m.FeeSpecialtyBrandPercentMaxAmt = validSvc.newProp(0);
				m.FeeSpecialtyBrandPercentMaxAmtChk = false;
			}
			m.FeeSpecialtyGeneric = validCurrency(m.FeeSpecialtyGeneric, 0.00, 9999);
			m.FeeSpecialtyGenericPercent = validCurrency(m.FeeSpecialtyGenericPercent, 0.0, 100.0);

			// validate variable max/min amount if % is > 0 and checkbox is checked
			if(m.FeeSpecialtyGenericPercent.val > 0 && m.FeeSpecialtyGenericPercentMinAmtChk) {
				m.FeeSpecialtyGenericPercentMinAmt = validCurrency(m.FeeSpecialtyGenericPercentMinAmt, 1.0, 1000);
			}
			else {
				m.FeeSpecialtyGenericPercentMinAmt = validSvc.newProp(0);
				m.FeeSpecialtyGenericPercentMinAmtChk = false;
			}
			if(m.FeeSpecialtyGenericPercent.val > 0 && m.FeeSpecialtyGenericPercentMaxAmtChk) {
				m.FeeSpecialtyGenericPercentMaxAmt = validCurrency(m.FeeSpecialtyGenericPercentMaxAmt, 0.0, 9999);
			}
			else {
				m.FeeSpecialtyGenericPercentMaxAmt = validSvc.newProp(0);
				m.FeeSpecialtyGenericPercentMaxAmtChk = false;
			}

			m.FeeAssayOrder = validCurrency(m.FeeAssayOrder, 0.00, 9999);
			m.FeeAssayDispense = validCurrency(m.FeeAssayDispense, 0.00, 9999);

			// Tiered fee max by supply days
			if (m.FeeSupplyDaysCapped == 'yes') {
				m.FeeSupplyDaysFirstMax = validCurrency(m.FeeSupplyDaysFirstMax, 0.0, 9999);
				m.FeeSupplyDaysSecondMax = validCurrency(m.FeeSupplyDaysSecondMax, 0.0, 9999);
				m.FeeSupplyDaysLastMax = validCurrency(m.FeeSupplyDaysLastMax, 0.0, 9999);
				if (m.FeeSupplyDaysFirstDay.val < 0 || m.FeeSupplyDaysFirstDay.val > 365) {
					m.FeeSupplyDaysFirstDay.fail = 'yes';
					m.FeeSupplyDaysFirstDay.msg = 'number 0 to 365';
				} else {
					m.FeeSupplyDaysFirstDay.fail = 'no';
					m.FeeSupplyDaysFirstDay.msg = '';
				}
				if (m.FeeSupplyDaysSecondDay.val < m.FeeSupplyDaysFirstDay.val || m.FeeSupplyDaysSecondDay.val > 365) {
					m.FeeSupplyDaysSecondDay.fail = 'yes';
					m.FeeSupplyDaysSecondDay.msg = 'number ' + m.FeeSupplyDaysFirstDay.val + ' to 365';
				} else {
					m.FeeSupplyDaysSecondDay.fail = 'no';
					m.FeeSupplyDaysSecondDay.msg = '';
				}
				// zero out brand and generic min/max values
				m.FeeBrandPercentMinAmt = validSvc.newProp(0);
				m.FeeBrandPercentMinAmtChk = false;
				m.FeeBrandPercentMaxAmt = validSvc.newProp(0);
				m.FeeBrandPercentMaxAmtChk = false;
				
				m.FeeGenericPercentMinAmt = validSvc.newProp(0);
				m.FeeGenericPercentMinAmtChk = false;
				m.FeeGenericPercentMaxAmt = validSvc.newProp(0);
				m.FeeGenericPercentMaxAmtChk = false;
			} else {
				m.FeeSupplyDaysFirstMax = validSvc.newProp(0);
				m.FeeSupplyDaysSecondMax = validSvc.newProp(0);
				m.FeeSupplyDaysLastMax = validSvc.newProp(0);
				m.FeeSupplyDaysFirstDay = validSvc.newProp(0);
				m.FeeSupplyDaysSecondDay = validSvc.newProp(0);
			}
			// generic yes/no - required
			m.GenericOrderable.fail = validSvc.isText(m.GenericOrderable.val) ? '' : 'yes';
			// generic effective date - not required
			m.GenericEffectiveDate.fail = '';
			if(m.GenericOrderable.val == 'yes' && affilBizModel == 'CPTPA') {
				if (!!m.GenericEffectiveDate.val) {
					m.GenericEffectiveDate = validSvc.propDateValid(m.GenericEffectiveDate, _regexDate);
				}
				m.GenericEffectiveDate.fail = !!m.GenericEffectiveDate.fail ? 'yes' : 'no';
			}
		}
		else {
			m.FeeEligibility.fail = '';
			m.FeeOrder.fail = '';
			m.FeeOrderPercent.fail = '';
			m.FeeOrderPercentMinAmt.fail = '';
			m.FeeOrderPercentMaxAmt.fail = '';
			m.FeeBrand.fail = '';
			m.FeeGeneric.fail = '';
			m.FeeSpecialtyOrder.fail = '';
			m.FeeSpecialtyOrderPercent.fail = '';
			m.FeeSpecialtyOrderPercentMinAmt.fail = '';
			m.FeeSpecialtyOrderPercentMaxAmt.fail = '';
			m.FeeSpecialtyBrand.fail = '';
			m.FeeSpecialtyBrandPercent.fail = '';
			m.FeeSpecialtyBrandPercentMinAmt.fail = '';
			m.FeeSpecialtyBrandPercentMaxAmt.fail = '';
			m.FeeSpecialtyGeneric.fail = '';
			m.FeeSpecialtyGenericPercent.fail = '';
			m.FeeSpecialtyGenericPercentMinAmt.fail = '';
			m.FeeSpecialtyGenericPercentMaxAmt.fail = '';
			m.FeeBrandPercent.fail = '';
			m.FeeBrandPercentMinAmt.fail = '';
			m.FeeBrandPercentMaxAmt.fail = '';
			m.FeeGenericPercent.fail = '';
			m.FeeGenericPercentMinAmt.fail = '';
			m.FeeGenericPercentMaxAmt.fail = '';
			m.GenericOrderable.fail = '';
			m.FeeAssayOrder.fail = '';
			m.FeeAssayDispense.fail = '';
			m.FeeSupplyDaysFirstMax.fail = '';
			m.FeeSupplyDaysSecondMax.fail = '';
			m.FeeSupplyDaysLastMax.fail = '';
			m.FeeSupplyDaysFirstDay.fail = '';
			m.FeeSupplyDaysSecondDay.fail = '';
		}

		// VERISAVE FEES - SPLITMATCH / SPLIT
		m.FeeVerisaveFlat.fail = '';
		m.FeeVerisaveOrderPercent.fail = '';
		m.FeeVerisaveOrderPercentMinAmt.fail = '';
		m.FeeVerisaveOrderPercentMaxAmt.fail = '';
		if(affilBizModel == 'SPLITMATCH' || affilBizModel == 'SPLIT') {
			switch(m.FeeVerisaveModel) {
				case 'FLAT':
					m.FeeVerisaveFlat = validCurrency(m.FeeVerisaveFlat, 0, 999999);
					break;
				case 'PERCENTAGESAVINGS':
					m.FeeVerisaveOrderPercent = validCurrency(m.FeeVerisaveOrderPercent, 0.0, 100.0);
					if(m.FeeVerisaveOrderPercent.val > 0) {
						// min amt is required if percent is > 0
						if(m.FeeVerisaveOrderPercentMinAmt.chk) {
							m.FeeVerisaveOrderPercentMinAmt = validCurrency(m.FeeVerisaveOrderPercentMinAmt, 1.0, 999999);
						}
						else {
							m.FeeVerisaveOrderPercentMinAmt = validSvc.newProp(0);
							m.FeeVerisaveOrderPercentMinAmtChk = false;
						}
						// max amt is required if percent is > 0
						if(m.FeeVerisaveOrderPercentMaxAmt.chk) {
							m.FeeVerisaveOrderPercentMaxAmt = validCurrency(m.FeeVerisaveOrderPercentMaxAmt, 1.0, 999999);
						}
						else {
							m.FeeVerisaveOrderPercentMaxAmt = validSvc.newProp(0);
							m.FeeVerisaveOrderPercentMaxAmtChk = false;
						}
					}
					break;
				default:
					m.FeeVerisaveFlat = validSvc.newProp(0);
					m.FeeVerisaveOrderPercent = validSvc.newProp(0);
					m.FeeVerisaveOrderPercentMinAmt = validSvc.newProp(0);
					m.FeeVerisaveOrderPercentMaxAmt = validSvc.newProp(0);
					break;
			}
		}

		// Validate claims
		m.ValidateClaimsModifier.fail = '';
		if(m.ValidateClaimsModifier.val == 'yes') {
			if(m.Require340BSubClarifyMod == 'no' && m.Require340BBasisCostMod == 'no') {
				m.ValidateClaimsModifier.fail = 'yes';
				m.ValidateClaimsModifier.msg = 'choose at least 1 validation modifier';
			}
		}
		 else {
		 	m.Require340BSubClarifyMod = 'no';
			m.Require340BBasisCostMod = 'no'; 
		 }

		// cash card fee
		if(m.CashCardParticipant == 'yes') {
			m.FeeCashCard = validCurrency(m.FeeCashCard, 0.00, 9999);
		}
		else {
			m.FeeCashCard = validSvc.newProp(0);
		}

		// Medicaid defaults if not being used
		if(affilBizModel != 'CP' && affilBizModel != 'SPLITMATCH' && affilBizModel != 'CPTPA') {
			m.MedicaidFFSCarveIn = 'no';
			m.MedicaidMCOCarveIn = 'no';
		}

		m.RequireFFSCode.fail = '';
		m.RequireFFSCode.msg = '';
		if(m.Require340BBasisCostFFS == 'yes' && !!!m.RequireFFSCode08 && !!!m.RequireFFSCode05) {
			m.RequireFFSCode.fail = 'yes';
			m.RequireFFSCode.msg = 'requires at least one code to be selected';
		}

		m.RequireMCOCode.fail = '';
		m.RequireMCOCode.msg = '';
		if(m.Require340BBasisCostMCO == 'yes' && !!!m.RequireMCOCode08 && !!!m.RequireMCOCode05) {
			m.RequireMCOCode.fail = 'yes';
			m.RequireMCOCode.msg = 'requires at least one code to be selected';
		}

		// SPLITTING - affil models: SPLIT, SPLITMATCH
		var shareGroupsOk = true,
			splitGroupsOk = true;

		if(affilBizModel == 'SPLIT' || affilBizModel == 'SPLITMATCH') {
			// splitting sequence can be any value, no validation

			// accum share groups
			var shareList = m.AccumShareGroups,
				splitList = m.AccumSplitGroups,
				g = 0;

			// valid share groups
			for(g = 0; g < shareList.length; g++) {
				shareList[g] = validText(shareList[g], 2, 40);
				if(shareGroupsOk && shareList[g].fail == 'yes') {
					shareGroupsOk = false;
				}
			}

			// valid split groups
			for(g = 0; g < splitList.length; g++) {
				splitList[g] = validText(splitList[g], 2, 40);
				if(splitGroupsOk && splitList[g].fail == 'yes') {
					splitGroupsOk = false;
				}
			}

			// valid 855 PO acks
			if(m.Combine855s == 'yes') {
				var tm = parseInt(m.Timeout855s.val);
				if(!validSvc.isInteger(tm) || tm < 1 || tm > 10000) {
					m.Timeout855s.fail = 'yes';
					m.Timeout855s.msg = 'number 1 to 10000';
				}
				else {
					m.Timeout855s.fail = '';
				}
			}
			else {
				m.Timeout855s = validSvc.newProp(0);
			}

			var at = 0;
			// pre-split orders
			if(m.PreSplitRequired == 'yes') {
				at = parseInt(m.PreSplitTimeout.val);
				if(!validSvc.isInteger(at) || at < 15 || at > 240) { // 4 hours in mins
					m.PreSplitTimeout.fail = 'yes';
					m.PreSplitTimeout.msg = 'number 15 to 240';
				}
				else {
					m.PreSplitTimeout.fail = '';
				}
			}
			else {
				m.PreSplitTimeout = validSvc.newProp(60);
				m.PreSplitTimeoutAction = 'SPLIT';
			}
			// approvals
			if(m.ApprovalRequired == 'yes') {
				at = parseInt(m.ApprovalTimeout.val);
				if(!validSvc.isInteger(at) || at < 30 || at > 1440) { // 24 hours in mins
					m.ApprovalTimeout.fail = 'yes';
					m.ApprovalTimeout.msg = 'number 30 to 1,440';
				}
				else {
					m.ApprovalTimeout.fail = '';
				}
			}
			else {
				m.ApprovalTimeout = validSvc.newProp(60);
				m.ApprovalTimeoutAction = 'PLACE';
			}

			// alt split vendors
			m.AltVendorList.fail = '';
			if(m.AllowAltVendorSplit == 'yes') {
				m.AltVendorList.vals = multiVals(vm.VenMulti);
				m.AltVendorList.fail = m.AltVendorList.vals.length < 1 ? 'yes' : 'no';
			}
			else {
				m.AltVendorList.vals = [];
			}

			//federate 850s to CE vendors
			m.Federate850sToCEVendorList.fail = '';
			if(m.AllowFederate850sToCE == 'yes') {
				m.Federate850sToCEVendorList.vals = multiVals(vm.Fed850VenMulti); 
				m.Federate850sToCEVendorList.fail = m.Federate850sToCEVendorList.vals.length < 1 ? 'yes' : 'no';
			}
			else {
				m.Federate850sToCEVendorList.vals = [];
			}
		}
		else {
			m.SplittingSequence = validSvc.newProp('NONE');
		}

		// Splitting: reset GPO prohibited split unknowns based on OpaType
		var opaType = m.CeOpaType;
		if(opaType != 'DSH' && opaType != 'CAN' && opaType != 'PED') {
			m.SplitUnknownToWAC = 'no';
		}
    
		// wac neut
		if(m.WacNeutEnabled == 'yes') {
			// validate external mappings array
			var wnMappings = m.WacNeutExternalMappings,
			    wnMappingsValid = true,
                isSwisslog = vm.context.CdcType == 'SWISSLOG';
            if(isSwisslog) {
                m.CostCenter = validSvc.newProp(''); // reset cost center if switching cdc type
                if(wnMappings.length < 1) {
        		    wnMappingsValid = false;
     		    }
                else {
                    for(var wn = 0; wn < wnMappings.length; wn++) {
                        var wnItem = wnMappings[wn];
                        wnItem.fail = '';
                        wnItem.msg = '';

                        // External Facility Id - required, 1-50 chars
                        wnItem.ExternalFacilityId = validText(wnItem.ExternalFacilityId, 1, 50);
                        if(wnItem.ExternalFacilityId.fail == 'yes') {
                            wnItem.fail = 'yes';
                            wnMappingsValid = false;
                        }

                        // External Pharmacy Id - required, 1-50 chars
                        wnItem.ExternalPharmacyId = validText(wnItem.ExternalPharmacyId, 1, 50);
                        if(wnItem.ExternalPharmacyId.fail == 'yes') {
                            wnItem.fail = 'yes';
                            wnMappingsValid = false;
                        }

                        // Cost Center Id - required, 1-50 chars
                        wnItem.CostCenterId = validText(wnItem.CostCenterId, 1, 50);
                        if(wnItem.CostCenterId.fail == 'yes') {
                            wnItem.fail = 'yes';
                            wnMappingsValid = false;
                        }
                    }
                }
            }
            else {
        		wnMappings = []; // reset mappings if switching cdc type
				m.CostCenter = validText(m.CostCenter, 2, 50);
      		}
			m.WacNeutExternalMappingsValid = wnMappingsValid;

			m.CdcPharmacy.fail = m.CdcPharmacy.val == 'NONE' ? 'yes' : 'no';
			if(m.CdcPharmacy.fail == 'yes') {
				m.CdcPharmacy.msg = 'required';
			}
		}
		else {
			m.CostCenter = validSvc.newProp('');
			m.WacNeutExternalMappings = [];
			m.WacNeutExternalMappingsValid = true;
			m.CdcPharmacy = validSvc.newProp('NONE');
		}

		// pharmacy claims access
		if(affilBizModel == 'CP' || affilBizModel == 'SPLITMATCH' || affilBizModel == 'CPTPA') {
			if(m.UserCanViewClaims == 'no') {
				m.UserCanMatchClaims = 'no';
			}
			if(m.UserCanCreateOrders == 'no') {
				m.UserCanCreateOrders = 'no';
			}
		}
		else {
			m.UserCanViewClaims = 'no';
			m.UserCanMatchClaims = 'no';
		}

		// GPO Reference Price
		if((affilBizModel == 'SPLIT' || affilBizModel == 'SPLITMATCH') && m.UseGPOReference == 'yes') {
			if (m.GPOReferenceCE.val == 'NONE') {
				m.GPOReferenceCE.fail = 'yes';
				m.GPOReferenceCE.msg = 'required';
			}
			if (m.GPOReferencePH.val == 'NONE') {
				m.GPOReferencePH.fail = 'yes';
				m.GPOReferencePH.msg = 'required';
			}
			if (m.GPOReferenceVendor.val == 'NONE') {
				m.GPOReferenceVendor.fail = 'yes';
				m.GPOReferenceVendor.msg = 'required';
			}
		}
		else {
			m.UseGPOReference = 'no';
			m.GPOReferenceCE = validSvc.newProp('NONE');
			m.GPOReferencePH = validSvc.newProp('NONE');
			m.GPOReferenceVendor = validSvc.newProp('NONE');
		}
		
		if (vm.ProductType == 'VERISAVE') {
			return m.RX.fail != 'yes' &&
			m.AffilName.fail != 'yes' &&
			m.AltVendorList.fail != 'yes' &&
			shareGroupsOk && splitGroupsOk;
		}

		m.Federate850sToCEVendorList.fail = '';
		if ( m.AllowFederate850sToCE != "yes"){
			m.Federate850sToCEVendorList.vals = [];
		}else{
			m.Federate850sToCEVendorList.vals = multiVals(vm.Fed850VenMulti);
			m.Federate850sToCEVendorList.fail = m.Federate850sToCEVendorList.vals.length < 1 ? 'yes' : 'no';
		}

		// result
		return  m.RX.fail != 'yes' &&
				m.ProgramAdmin.fail != 'yes' &&
				m.ContractDate.fail != 'yes' &&
				m.ContractTerminationDate.fail != 'yes' &&
				m.TerminationCause.fail != 'yes' &&
				m.AffilName.fail != 'yes' &&
				m.VisitEligDaysBefore.fail != 'yes' &&
				m.VisitEligDaysAfter.fail != 'yes' &&
				m.DispenseExpiration.fail != 'yes' &&
				m.FeeVerityMonthly.fail != 'yes' &&
				m.FeeEligibility.fail != 'yes' &&
				m.FeeOrder.fail != 'yes' &&
				m.FeeOrderPercent.fail != 'yes' &&
				m.FeeOrderPercentMinAmt.fail != 'yes' &&
				m.FeeOrderPercentMaxAmt.fail != 'yes' &&
				m.FeeVerisaveFlat.fail != 'yes' &&
				m.FeeVerisaveOrderPercent.fail != 'yes' &&
				m.FeeVerisaveOrderPercentMinAmt.fail != 'yes' &&
				m.FeeVerisaveOrderPercentMaxAmt.fail != 'yes' &&		
				m.FeeCashCard.fail != 'yes' &&
				m.FeeBrand.fail != 'yes' &&
				m.FeeGeneric.fail != 'yes' &&
				m.FeeBrandPercent.fail != 'yes' &&
				m.FeeBrandPercentMinAmt.fail != 'yes' &&
				m.FeeBrandPercentMaxAmt.fail != 'yes' &&
				m.FeeGenericPercent.fail != 'yes' &&
				m.FeeGenericPercentMinAmt.fail != 'yes' &&
				m.FeeGenericPercentMaxAmt.fail != 'yes' &&
				m.GenericOrderable.fail != 'yes' &&
				m.GenericEffectiveDate.fail != 'yes' &&
				m.FeeSpecialtyOrder.fail != 'yes' &&
				m.FeeSpecialtyOrderPercent.fail != 'yes' &&
				m.FeeSpecialtyOrderPercentMinAmt.fail != 'yes' &&
				m.FeeSpecialtyOrderPercentMaxAmt.fail != 'yes' &&
				m.FeeSpecialtyBrand.fail != 'yes' &&
				m.FeeSpecialtyBrandPercent.fail != 'yes' &&
				m.FeeSpecialtyBrandPercentMinAmt.fail != 'yes' &&
				m.FeeSpecialtyBrandPercentMaxAmt.fail != 'yes' &&
				m.FeeSpecialtyGenericPercent.fail != 'yes' &&
				m.FeeSpecialtyGenericPercentMinAmt.fail != 'yes' &&
				m.FeeSpecialtyGenericPercentMaxAmt.fail != 'yes' &&
				m.FeeSpecialtyGeneric.fail != 'yes' &&
				m.FeeAssayOrder.fail != 'yes' &&
				m.FeeAssayDispense.fail != 'yes' &&
				m.FeeSupplyDaysFirstMax.fail != 'yes' &&
				m.FeeSupplyDaysFirstDay.fail != 'yes' &&
				m.FeeSupplyDaysSecondMax.fail != 'yes' &&
				m.FeeSupplyDaysSecondDay.fail != 'yes' &&
				m.FeeSupplyDaysLastMax.fail != 'yes' &&
				m.Timeout855s.fail != 'yes' &&
				m.PreSplitTimeout.fail != 'yes' &&
				m.ApprovalTimeout.fail != 'yes' &&
				m.CostCenter.fail != 'yes' &&
				m.WacNeutExternalMappingsValid &&
				m.CdcPharmacy.fail != 'yes' &&
				m.ValidateClaimsModifier.fail != 'yes' &&
				m.GPOReferenceCE.fail != 'yes' &&
				m.GPOReferencePH.fail != 'yes' &&
				m.GPOReferenceVendor.fail != 'yes' &&
				m.OwnUseAccumulationDelay.fail != 'yes' &&
				m.GPOMatchDelay.fail != 'yes' &&
				m.ClaimFederationStart.fail != 'yes' &&
				m.AltVendorList.fail != 'yes' &&
				m.Federate850sToCEVendorList.fail != 'yes' &&
				m.RequireFFSCode.fail != 'yes' &&
				m.RequireMCOCode.fail != 'yes' &&
				shareGroupsOk && splitGroupsOk && !m.MatchingFail;
	}

	function acctSubmit() {

		if(vm.isWaiting) {
			return;
		}

		// validate
		if(!acctValid()) {
			var msg = 'All fields must be valid.';
			if (_validMsg != '') {
				msg = _validMsg;
			}
			msgSvc.ok('Cannot Save Affiliate', msg);
			return false;
		}

		if(vm.action == 'CREATE') {
			vm.isWaiting = true;
			affRepo.create(vm.model).then(okUpsert, errUpsert);
		}
		else if(vm.action == 'UPDATE' && vm.vendors.length > 0 && vm.model.AffilBizModel.val != vm.model.AffilBizModelClean) {

			// biz model confirmation, all vendor accounts will be affected

			msgSvc.confirm({
				id: 'affiliation.acct.confirm',
				title: 'Change Business Model',
				msg: 'Confirm new business model: ' + vm.model.AffilBizModel.val + '. Warning: all ACTIVE Vendor Accounts will be set to INACTIVE, re-verify their settings after this change.',
				buttons: [
					{text:'SAVE', result:'YES', cancel: false},
					{text:'CANCEL', result:'CANCEL', cancel: true}
				]
			}).then(confirmAcctSave, confirmAcctSave);

		}
		else {
			vm.isWaiting = true;
			affRepo.update(vm.model).then(okUpsert, errUpsert);
		}

	}

	function confirmAcctSave(r) {
		// user said yes to delete vendor
		if(!!r && r.result == 'YES') {	
			vm.isWaiting = true;
			affRepo.update(vm.model).then(okUpsert, errUpsert);
		}
	}

	function okUpsert(r) {
		vm.isWaiting = false;
		vm.unsavedInnerOuter = false;
		vm.changedInnerOuter = false;
		msgSvc.ok(vm.model.RX.val + ' Affiliation', vm.action == 'CREATE' ? 'Created' : 'Updated');
		getAff(vm.model.CE, vm.model.RX.val);

	}

	function errUpsert(r) {

		vm.isWaiting = false;

		if(!!!r || r === null) {
			// already handled
			$state.go(_viewErrRoute, {}, {reload: _viewErrRoute});
		}
		else if(r.status === 409) {
			// conflict
			errSvc.info('Could not create or save, already exists in the database. Verify and try again.');
		}
		else if (r.status === 422) {
			// validation
			vm.model = r.model;
			msgSvc.ok('Cannot Save', 'Invalid data values.');
		}
		else {
			errSvc.error('Unexpected api error', 'affDetailCtl.errUpsert', r.status, utilSvc.http.safeResponse(r));
		}

	}


	/**
	 *    STATUS BUTTON CHANGE
	 */

	function statusChange(newStatus) {

		// already waiting?
		if(vm.isWaiting) {
			return;
		}

		// biz model invalid
		if(newStatus == 'ACTIVE' && vm.model.AffilBizModel.val != 'NONE' && vm.model.RxBizModels.indexOf(vm.model.AffilBizModel.val) < 0) {
			vm.model.AffilBizModel.fail = 'yes';
			vm.model.AffilBizModel.msg = 'not supported';
			msgSvc.ok('Cannot Set ACTIVE', 'Current business model is no longer supported by the pharmacy');
			return;
		}

		// Claim Federation Start.. Check if value is dirty
		if (newStatus == 'ACTIVE' &&  !!vm.model.ClaimFederationStart.val && vm.model.RxFederatesClaims && vm.model.CEAffilIsExternal == 'yes') {
			var current = vm.model.ClaimFederationStart.val;
			var orig =  vm.model.OrigClaimFederationStart;
			if ( current != orig)  {
				vm.model.ClaimFederationStart.fail = 'yes';
				msgSvc.ok('Cannot Set ACTIVE', ' Claim Federation Start Date has been changed. Affiliation must be SAVED in order to proceed.');
				return;
			}
		}
		
		vm.isWaiting = true;
		_pendingStatus = newStatus;

		switch(newStatus) {

			case 'ACTIVE':
				// check if vendors exist before allowing ACTIVE status
				affOptionsRepo.getVendorList(vm.context.CE, vm.context.RX).then(okActiveStatusVendorCheck, errVendorLoad);
				break;

			case 'DELETED':
				// confirm user wants to set deleted status
				msgSvc.confirm({
					id: 'affiliation.acct.status',
					title: 'Delete Affiliation',
					msg: 'Confirm affiliation status change to DELETED? This is not reversable.',
					buttons: [
						{text:'OK', result:'YES', cancel: false},
						{text:'CANCEL', result:'CANCEL', cancel: true}
					]
				}).then(confirmAffDeletedStatus, confirmAffDeletedStatus);
				break;

			default:
				// apply status immediately for any others
				affRepo.statusChange(vm.context.CE, vm.context.RX, newStatus).then(okStatus, errStatus);
		}
	}

	function okActiveStatusVendorCheck(r) {

		// CE/RX must both be active
		if(vm.model.RXStatus != 'ACTIVE' || vm.model.CEStatus != 'ACTIVE') {
			vm.isWaiting = false;
			msgSvc.ok('ACTIVE Status Issue', 'Both Facility and Pharmacy must be ACTIVE. Facility is ' + vm.model.CEStatus + ', RX is ' + vm.model.RXStatus);
			return;
		}

		// no vendors? remind them there are no vendors
		if(!Array.isArray(r) || r.length < 1) {
			msgSvc.okAsync('ACTIVE With No Vendors', 'Reminder: affiliation is being set ACTIVE with no vendor accounts. Add one if needed.', 'aff.active.status.reminder').then(activeStatusUpdate, activeStatusUpdate);
		}
		else {
			activeStatusUpdate();
		}

	}

	function activeStatusUpdate() {
		affRepo.statusChange(vm.context.CE, vm.context.RX, _pendingStatus).then(okStatus, errStatus);
	}

	function confirmAffDeletedStatus(r) {

		// user said yes to set DELETED status
		if(!!r && r.result == 'YES') {
			affRepo.statusChange(vm.context.CE, vm.context.RX, _pendingStatus).then(okStatus, errStatus);
		}
		else {
			vm.isWaiting = false;
		}
	}

	function okStatus(r) {

		vm.isWaiting = false;

		// id
		if(!!!r || !validSvc.isText(r.Id)) {
			throw new Error('affDetailCtl.okStatus, missing id');
		}

		vm.getDetail = true;
		getAff(vm.context.CE, vm.context.RX);

	}

	function errStatus(r) {

		vm.isWaiting = false;

		if(!!!r || r == null) {
			// already handled
			$state.go(_viewErrRoute, {}, {reload: _viewErrRoute});
		}
		else if(r.status == 409) {
			// conflict
			errSvc.info('Could not update status to: ' + _pendingStatus + '. Try again.', 'affDetailCtl.errStatus', r.status, utilSvc.http.safeResponse(r));
			_pendingStatus = '';
		}
		else {
			errSvc.error('Unknown status change error', 'affDetailCtl.errStatus', r.status, utilSvc.http.safeResponse(r));
		}

	}

	function inHouseCEConfig() {
		vm.model.UserCanViewClaims = vm.context.CeExpressScriptsCustomer == 'yes' ? vm.model.UserCanViewClaims : 'no';
		vm.model.UserCanMatchClaims = vm.context.CeExpressScriptsCustomer == 'yes' ? vm.model.UserCanMatchClaims : 'no';
	}

	/**
	 *    VENDOR
	 */


	function autoOrderVM(config) {
		// build vendor auto order data structure, widget will convert to validation properties later
		config = config || {};
        var schedule = config.OrderSchedule || {};

        return {
			Enabled: !!config.AutoOrdering ? 'on' : 'off',
            Type: validSvc.isText(schedule.Type) ? schedule.Type : '',
			MonthOption: validSvc.isText(schedule.MonthOption) ? schedule.MonthOption : '',
			DayOfMonth : validSvc.isNumber(schedule.DayOfMonth) ? parseInt(schedule.DayOfMonth) : 0,
			WeekOfMonth : validSvc.isNumber(schedule.WeekOfMonth) ? parseInt(schedule.WeekOfMonth) : 0,
			Occurs : validSvc.isNumber(schedule.Occurs) ? parseInt(schedule.Occurs) : 0,
            Weekdays: Array.isArray(schedule.Days) ? schedule.Days : [],
			AutoPlaceSendEDI: !!config.AutoPlaceSendEDI ? 'yes' : 'no',
			PlaceNow: !!config.PlaceNow ? 'yes' : 'no',
			fail: ''
        };
    }

	function vendorVM(ctx, vendor, action, affilBizModel) {

		var v = vendor || {};
		// context
		v.uType = ctx.uType;
		v.CE = ctx.CE;
		v.RX = ctx.RX;
		v.RxBizModel = affilBizModel;
		v.AffStatus = ctx.AffStatus;
		v.RxSequentialSplit = ctx.RxSequentialSplit;
		v.RXParentID = ctx.RXParentID;

		// model
		v.Id = validSvc.isText(v.Id) ? v.Id : '';
		v.ProductType = vm.ProductType;
		v.ObjectState = validSvc.newProp(validSvc.isText(v.ObjectState) ? v.ObjectState : 'ACTIVE');
		v.Vendor = validSvc.newProp(validSvc.isText(v.Vendor) ? v.Vendor : '');
		v.AccumulatorType = validSvc.newProp(validSvc.isText(v.AccumulatorType) ? v.AccumulatorType : '');
		v.PricingModel = validSvc.newProp(validSvc.isText(v.PricingModel) ? v.PricingModel : 'WACMinus');
		v.PricingRate = validSvc.newProp(validSvc.isNumber(v.PricingRate) ? parseFloat(v.PricingRate) : 0.00);

		// auto order
		v.StandardAutoOrder = autoOrderVM(v.StandardAutoOrderConfig);
		v.SpecialtyAutoOrder = autoOrderVM(v.SpecialtyAutoOrderConfig);
		v.DropShipAutoOrder = autoOrderVM(v.DropShipAutoOrderConfig);

		v.SendOrdersForReview = validSvc.newProp(!!v.SendOrdersForReview && v.Vendor.val != 'MCKESSON' ? 'yes' : 'no');

		v.SendOrderstoExtParty = validSvc.newProp(!!v.SendOrderstoExtParty  ? 'yes' : 'no');
		v.ExtPartyFolder = validSvc.newProp(validSvc.isText(v.ExtPartyFolder) ? v.ExtPartyFolder : '');
		v.VendorAccount = validSvc.newProp(validSvc.isText(v.VendorAccount) ? v.VendorAccount : '');
		v.AccountAlias = validSvc.newProp(validSvc.isText(v.AccountAlias) ? v.AccountAlias : '');
		v.SenderId = validSvc.newProp(validSvc.isText(v.SenderId) ? v.SenderId : '');
		v.ReceiverId = validSvc.newProp(validSvc.isText(v.ReceiverId) ? v.ReceiverId : '');

		v.OrderExclsCount = validSvc.isNumber(v.OrderExclsCount) ? v.OrderExclsCount : 0;
		v.OrderPrefCount = validSvc.isNumber(v.OrderPrefCount) ? v.OrderPrefCount : 0;
		v.AlwaysSplitCount = validSvc.isNumber(v.AlwaysSplitCount) ? v.AlwaysSplitCount : 0;
		v.NeverSplitCount = validSvc.isNumber(v.NeverSplitCount) ? v.NeverSplitCount : 0;
		v.ExcludeOrderSuffixOutbound = validSvc.newProp(!!v.ExcludeOrderSuffixOutbound ? 'yes' : 'no');

		v.NdcFilter = validSvc.newProp('NONE');
		if(v.OrderExclsCount > 0) {
			v.NdcFilter.val = 'OE';
		}	
		else if(v.OrderPrefCount > 0) {
			v.NdcFilter.val = 'OI';
		}	

		v.ReservationExpiration = validSvc.newProp(validSvc.isNumber(v.ReservationExpiration) ? v.ReservationExpiration : 7);
		v.ReleaseOnOrderEDI855 = validSvc.newProp(!!v.ReleaseOnOrderEDI855  ? 'yes' : 'no');
		v.OnOrderReleaseAckCodeExclusionList = !!v.OnOrderReleaseAckCodeExclusionList ? v.OnOrderReleaseAckCodeExclusionList : [];
		v.VendorOrderConfig = validSvc.isText(v.VendorOrderConfig) ? v.VendorOrderConfig : 'Default';

		// Drop ship
		v.DropShip = v.DropShip || {};
		v.DropShipParent = v.DropShipParent || {};
		
		v.ExcludeDropShip= v.DropShip.DropShipOrderable === false ? 'yes' : 'no';
		v.DropShipCanOverride = !!v.DropShip.CanOverride ? 'yes' : 'no';
		v.DropShipOverridden = !!v.DropShip.Overridden ? 'yes' : 'no';
		v.DropShipExclude= v.DropShip.DropShipOrderable === false ? 'yes' : 'no';
		v.DropShipParentCanOverride = !!v.DropShipParent.CanOverride ? 'yes' : 'no';
		v.DropShipParentOverridden = v.DropShipParent.Overridden;
		v.DropShipParentExclude= v.DropShipParent.DropShipOrderable === false ? 'YES' : 'NO';

		// Alt accounts 
		v.AllowDirectReplenish = validSvc.newProp(!!v.AllowDirectReplenish  ? 'yes' : 'no');

		// Virtual Replenishment
		v.CreditReplenishment = validSvc.newProp(!!v.CreditReplenishment ? 'yes' : 'no');
		v.UseISPSuffix = validSvc.newProp(!!v.UseISPSuffix ? 'yes' : 'no');

		// UPDATE properties must exist
		if(action == 'UPDATE' && (v.Vendor.val === '' || v.AccumulatorType.val === '' || v.VendorAccount.val === '')) {
			throw new Error('affDetailCtl.vendorVM, UPDATE vendor: Vendor/AccumulatorType/VendorAccount required');
		}

		// view properties
		v.title = action == 'CREATE' ? 'New Ordering Account' : v.Vendor.val + '-' + v.AccumulatorType.val + ', Acct # ' + v.VendorAccount.val;
		v.VendorStatus = action == 'CREATE' ? 'CREATE' : v.ObjectState.val;
		v.uniqueId = action == 'CREATE' ? 'CREATE' : v.Vendor.val + '|' + v.AccumulatorType.val;

		v.action = action;
		v.expand = false;
		v.dirty = false;
		v.show = action != 'CREATE';

		v.viewErrRoute = _viewErrRoute;

		return v;

	}

	function getVendorList() {

		// get vendors from database
		vm.isWaiting = true;
		msgSvc.wait(true);

		vm.vendors = [];
		vm.vendorNew = {};

		affOptionsRepo.getVendorList(vm.context.CE, vm.context.RX).then(okVendorLoad, errVendorLoad);

		function okVendorLoad(r) {

			msgSvc.wait(false);
			vm.isWaiting = false;

			// re-build alternate split vendors from current vendors
			var uniqueAltVendors = [],
				acct = {},
				venId = '';
			for(var i = 0; i < r.length; i++) {
				acct = r[i];
				vm.vendors.push(vendorVM(vm.context, acct, 'UPDATE', vm.model.AffilBizModel.val));

				// build alt vendors list
				venId = acct.Vendor.val;
				if(acct.ObjectState.val == 'ACTIVE' && uniqueAltVendors.indexOf(venId) < 0) {
					uniqueAltVendors.push(venId);
				}
			}

			// sort vendors
			vm.vendors = utilSvc.array.sortASC(vm.vendors, 'uniqueId');
			
			// setup new vendor
			vm.vendorNew = vendorVM(vm.context, null, 'CREATE', vm.model.AffilBizModel.val);
			
			// build alt vendor multi list options
			uniqueAltVendors.sort();
			vm.VenMulti.list = vm.multiselectBuild(uniqueAltVendors, false);

			// add saved data vals
			vm.VenMulti.vals = [];
			var savedAltVendors = vm.model.AllowAltVendorSplit == 'yes' ? vm.model.AltVendorList.vals : [];
			vm.multiselectReturnVisit(vm.VenMulti, '', savedAltVendors);
			vm.multiselectTitle(vm.VenMulti);

			// update alt vendor model
			vm.model.AltVendorList.vals = multiVals(vm.VenMulti);

			// rebuild federate 850 vendor list from active EDI-enabled vendors
			var fed850Aff = utilSvc.aff.findRx(utilSvc.aff.findCe($scope.User.AffList, vm.context.CE), vm.context.RX);
			var fed850VenList = utilSvc.aff.venList(fed850Aff, ['340B', 'GPO', 'WAC', 'WACMED', 'OWNUSE', 'IND']);
			vm.Fed850VenMulti.list = vm.multiselectBuild(fed850VenList, false);

			// restore checked state for saved federate 850s vendors
			vm.model = buildFederate850ToCEList(vm.model);
		}

	}

	function buildFederate850ToCEList(m) {
	
		if( m.AllowFederate850sToCE != 'yes'){
			m.Federate850sToCEVendorList.vals = [];
			return m;
		}

		//add saved federate 850s to CE vendors
		vm.multiselectReturnVisit(vm.Fed850VenMulti, '', m.Federate850sToCEVendorList.vals);	
		vm.multiselectTitle(vm.Fed850VenMulti);

		// update federate 850s to CE vendors
		m.Federate850sToCEVendorList.vals = multiVals(vm.Fed850VenMulti);
		return m;
	}

	function refreshVendor(action, ceid, rxid, venid, accumType) {

		// refresh a specific vendor only
		// note: this is a backup if another vendor in the list was already being edited

		_pendingVendor = {
			action: action,
			CE: ceid,
			RX: rxid,
			VEN: venid,
			AccumType: accumType
		};

		affOptionsRepo.getVendor(ceid, rxid, venid, accumType).then(okRefreshVendor, errVendorLoad);

		function okRefreshVendor(r) {

			if(!!!r) {
				throw new Error('affDetailCtl.refreshVendor, vendor not found: ' + _pendingVendor.CE + '/' + _pendingVendor.RX + '/' + _pendingVendor.VEN + '/' + _pendingVendor.AccumType);
			}

			var title = _pendingVendor.VEN + '-' + _pendingVendor.AccumType;

			switch(_pendingVendor.action) {

				case 'CREATE':
					// add to end of vendors array, reset new vendor model
					vm.vendors.push(vendorVM(vm.context, r, 'UPDATE', vm.model.AffilBizModel.val));
					vm.vendorNew = vendorVM(vm.context, null, 'CREATE', vm.model.AffilBizModel.val);
					msgSvc.ok('Vendor Account Created', title);
					break;

				case 'UPDATE':
				case 'CANCEL':
					var venIdx = -1,
						venId = _pendingVendor.VEN + '|' + _pendingVendor.AccumType;

					// find vendor to update
					for(var i = 0; i < vm.vendors.length; i++) {
						if(vm.vendors[i].uniqueId == venId) {
							venIdx = i;
							break;
						}
					}
					if(venIdx < 0) {
						throw new Error('affDetailCtl.refreshVendor, vendor not found in array with id: ' + venId);
					}

					vm.vendors[venIdx] = vendorVM(vm.context, r, 'UPDATE', vm.model.AffilBizModel.val);
					if(_pendingVendor.action != 'CANCEL') {
						msgSvc.ok('Vendor Saved', title);
					}
					break;

				default:
					throw new Error('affDetailCtl.evt, _pendingVendor.action unknown: ' + _pendingVendor.action);
			}
		}
	}

	function errVendorLoad(r) {

		// used by several Vendor get methods

		msgSvc.wait(false);
		vm.isWaiting = false;

		if(r !== null) {
			errSvc.warn('Not able to get affiliation vendor accounts.', 'affDetailCtl.errVendorLoad', r.status, utilSvc.http.safeResponse(r));
			$state.go(_viewErrRoute, {}, {reload: _viewErrRoute});
		}

	}

	function vendorCreate() {
		if(vm.isWaiting) {
			return;
		}
		vm.vendorNew.show = true;
	}

	function vendorEvent(evtData) {

		// event handler for vendor widgets

		var id = evtData.uniqueId,
			action = evtData.action,
			vendor = evtData.Vendor,
			accumType = evtData.AccumType;

		switch(action) {

			case 'DELETE':
				vendorDelete(vendor, accumType);
				break;

			case 'CANCEL':
				if(id == 'CREATE') {
					vm.vendorNew = vendorVM(vm.context, null, 'CREATE', vm.model.AffilBizModel.val);
				}
				else {
					refreshVendor('CANCEL', vm.context.CE, vm.context.RX, vendor, accumType);
				}
				break;

			case 'CLONENDC':
				openPopup(null, 'CLONENDC', {
					id: id,
					vendor: vendor,
					accumType: accumType,
					acctId: evtData.AcctId,
					listType: evtData.listType
				});
				break;

			case 'CREATE':
			case 'UPDATE':
				var refreshVendors = false;

				// on update: refresh all vendors if no other vendor was touched
				if(action == 'UPDATE') {
					refreshVendors = true;
					var ven = {};
					for(var i = 0; i < vm.vendors.length; i++) {
						ven = vm.vendors[i];
						if(ven.uniqueId != id && (ven.dirty || ven.expand)) {
							// this vendor has been touched
							refreshVendors = false;
							break;
						}
					}
				}

				if(refreshVendors) {
					// full vendor reload
					getVendorList();
				}
				else {
					// in-place update (not preferrable)
					refreshVendor(action, vm.context.CE, vm.context.RX, vendor, accumType);
				}
				break;

			default:
				 throw new Error('affDetailCtl.vendorEvent, unknown event type: ' + action);
		}


	}

	function vendorDelete(vendor, accumType) {

		// confirm delete, then call repo, refresh vendor list

		_pendingVendor = {
			vendor: vendor,
			accumType: accumType
		};

		vm.isWaiting = true;

		msgSvc.confirm({
			id: 'affiliation.vendor.delete',
			title: 'Delete ' + vendor + '-' + accumType,
			msg: 'Confirm vendor account delete? This is not reversable.',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmVendorDelete, confirmVendorDelete);

	}

	function confirmVendorDelete(r) {

		// user said yes to delete vendor
		if(!!r && r.result == 'YES') {
			affRepo.vendorDelete(vm.context.CE, vm.context.RX, _pendingVendor.vendor, _pendingVendor.accumType).then(okDeleteVendor, errDeleteVendor);
		}
		else {
			vm.isWaiting = false;
			_pendingVendor = null;
		}

		function okDeleteVendor() {
			vm.isWaiting = false;
			getVendorList();
			msgSvc.ok('Vendor Delete', _pendingVendor.vendor + '-' + _pendingVendor.accumType + ' deleted.');
		}

		function errDeleteVendor() {
			vm.isWaiting = false;

			if(r !== null) {
				errSvc.warn('Not able to delete vendor.', 'affDetailCtl.errDeleteVendor', r.status, utilSvc.http.safeResponse(r));
				$state.go(_viewErrRoute, {}, {reload: _viewErrRoute});
			}

		}

	}


	/**
	 *    ACCUM GROUPS
	 */

	function accumGroupsAdd(listName) {

		// valid list name
		if(listName !== 'Share' && listName !== 'Split') {
			throw new Error('affDetailCtl.accumGroupsAdd, unknown list name: ' + listName);
		}

		// get edit values
		var target = vm['Accum' + listName + 'GroupsEdit'];

		// validate group name (2 to 40 characters)
		var groupValid = validSvc.newProp(target.val);
		groupValid = validText(groupValid, 2, 40);
		if(groupValid.fail == 'yes') {
			msgSvc.ok('Accumulator ' + listName + ' Groups', groupValid.msg);
			return;
		}
		groupValid.val = groupValid.val.toUpperCase();

		// unique group name?
		var existingList = vm.model['Accum' + listName + 'Groups'];
		for(var i = 0; i < existingList.length; i++) {
			if(existingList[i].val == groupValid.val) {
				msgSvc.ok('Accumulator ' + listName + ' Groups', groupValid.val + ' already added');
				return;
			}
		}

		// success, add it, re-sort props
		target.val = '';
		target.showAllGroups = false;
		existingList.push(validSvc.newProp(groupValid.val));
		existingList = utilSvc.array.sortASC(existingList);

		// update all groups if not already in the list
		if(vm.model.AccumAllGroups.indexOf(groupValid.val) < 0) {
			vm.model.AccumAllGroups.push(groupValid.val);
			vm.model.AccumAllGroups.sort();
		}

	}

	function accumGroupsRemove(listName, removeVal) {

		// valid list name
		if(listName !== 'Share' && listName !== 'Split') {
			throw new Error('affDetailCtl.accumGroupsAdd, unknown list name: ' + listName);
		}

		// get target list
		var target = vm.model['Accum' + listName + 'Groups'];

		// find this item by val
		var foundIdx = -1;
		for(var i = 0; i < target.length; i++) {
			if(target[i].val == removeVal) {
				foundIdx = i;
				break;
			}
		}
		if(foundIdx < 0) {
			throw new Error('affDetailCtl.accumGroupsRemove, could not find group name: ' + removeVal);
		}

		// remove item
		target.splice(foundIdx, 1);

	}


	/**
	 * 	RX SELECTOR
	 */

    function loadRxSelector(rxList) {
        
		msgSvc.wait(true);
        lookupRepo.RxInfo(rxList).then(okRxInfo, errRxInfo);

		function okRxInfo(r) {
			msgSvc.wait(false);
			if(!!!vm.popup) {
				return;
			}

			var items = [],
				item = {};
			for(var i=0; i < r.length; i++) {
				item = r[i];
				items.push({
					RXID: item.NickName,
					Name: item.Name,
					NCPDP: item.NCPDP,
					NPI: item.NPI
				});
			}

			// setup the popup filter
			if(vm.popup.type == 'RXSELECTOR' && validSvc.isRX(vm.model.RX.val)) {
				vm.popup.flt.RXID = vm.model.RX.val;
			} 

			vm.popup.Items = items;
			vm.popup.ready = true;
		}

		function errRxInfo(r) {
			msgSvc.wait(false);
			if(!!r) {
				msgSvc.ok('Pharmacy Lookup Error', 'affDetail.loadRxSelector api lookup error: ' + utilSvc.http.safeResponse(r));
				closePopup();
			}
		}

	}

	/**
	 *    POPUP
	 */

	function openPopup(evt, popType, item) {
		if(vm.isWaiting) {
			return;
		}

		vm.popup = {
			type: popType,
			ready: false,
			title: '',
			CE: vm.context.CE,
			RX: vm.context.RX,
			Scope:vm.context.Scope
		};

		var pop = vm.popup,
			offsetY = 0,
			elem = {},
			popupParentClass = '',
			popupContent = null,
			rxid = '';

		function setupNDCListPopup(evt, title, popType, popupId) {
			var pop = vm.popup;
			pop.isVerity = vm.uType == 'VERITY' || vm.uType == 'VERITYSA';
			pop.ListType = popType;
			pop.CE = vm.context.CE;
			pop.RX = vm.context.RX;
			pop.Scope = "AF";
			pop.Entity = vm.model.Id;
			pop.uniqueId = popType;
			pop.Id = vm.model.Id;
			pop.title = title;
			popupParentClass = 'table-popup-top';
			elem = evt.target;
			offsetY = -50;

			// loop html element parents looking for popup container top
			elem = evt.target;
			while (!!elem) {

				// top element found
				if (!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
					break;
				}

				// add offset, get next element
				offsetY += elem.offsetTop;
				elem = elem.offsetParent;
			}
			elem = null;

			// move popup to clicked row
			popupContent = document.getElementById(popupId);
			if (!!popupContent) {
				popupContent.style.top = offsetY.toString() + 'px';
			}
		}

		var rxList = [],
			i = 0;
		switch(popType) {
			case 'RXSELECTOR':
				pop.title = 'Select Pharmacy Affiliate';
				pop.Items = [];
				pop.flt = {};
				pop.SortBy = ['RXID'];
				rxid = '';

				// for popup RXSELECTOR, build select items off RxDroplist values
				for(var v=0; v < vm.RxDroplist.length; v++) {
					rxid = vm.RxDroplist[v].value;
					if(validSvc.isRX(rxid) && rxList.indexOf(rxid) < 0) {
						rxList.push(rxid);
					}
				}
				if(rxList.length < 1) {
					msgSvc.ok('No Pharmacies', 'No pharmacies to select for CE: ' + vm.context.CE);
					return;
				}

				loadRxSelector(rxList);
				break;
	
			case 'CLONE':
				pop.title = 'Clone Affiliation: ' + vm.context.CE + ' / ' + vm.context.RX;
				pop.Items = [];
				pop.flt = {};
				pop.SortBy = ['RXID'];
				pop.CloneToRX = validSvc.newProp('NONE');

				// get pharmacies which have the same business model as this affiliation
				rxList = newAffiliationOptions(vm.context.CE, $scope.User.AffList, [vm.model.AffilBizModel.val]);

				// exit if there are no Pharmacies
				if(rxList.length < 1) {
					msgSvc.ok('Clone Affiliation', 'There are no pharmacies available with business model: ' + vm.model.AffilBizModel.val);
					return;
				}
				loadRxSelector(rxList);
				break;
				
			case 'MANUFACTUREROPTINLIST':
				pop.title = 'Manufacturer Opt-In List: ' + vm.context.CE + ' / ' + vm.context.RX;
				pop.flt = {ftlTxt:"", fltDate:""};
                pop.SortBy = ['Name'];
				// get manufacturer dropdown
				pop.MFRExclusionDropList = utilSvc.ng.droplist(vm.GlobalExclusionManufacturerList, 'NameWithLabelerId', 'LabelerId');
				pop.MFRId = validSvc.newProp('NONE');
				pop.ManufacturerOptInDate = validSvc.newPropDate();
				pop.ManufacturerOptInList = []; 
				var items = vm.model.ManufacturerOptInList;
				for(i = 0; i < items.length; i++) {
					pop.ManufacturerOptInList.push(items[i]);
				}
				offsetY = -50;
				// loop html element parents looking for popup container top
				elem = evt.target;
				while(!!elem) {

					// top element found
					if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
						break;
					}

					// add offset, get next element
					offsetY += elem.offsetTop;
					elem = elem.offsetParent;
				}
				elem = null;
				// move popup to clicked row
				popupContent = document.getElementById('popupContent-MANUFACTUREROPTINLIST');
				if (!!popupContent) {
					popupContent.style.top = offsetY.toString() + 'px';
				}
				break;
			case 'GRP-MEMBER':
				getShareGroupInfo(item);
				elem = evt.target;
				vm.popup = {
					type: popType,
					title: item + ' Share Group Members',
					ready: false,
					Items: [],
					flt: {},
					SortBy: ['CEID'],
				};
				break;
			default:
				throw new Error('affDetailCtl.openPopup, pop type unknown: ' + popType);
		}

		// offset popup to element clicked
		if(popType == 'CLONENDC' || popType == 'RXSELECTOR' || popType == 'GRP-MEMBER') {
			while(!!elem) {
				// top element found
				if(!!elem.className && elem.className.indexOf(popupParentClass) > -1) {
					break;
				}
				// add offset, get next element
				offsetY += elem.offsetTop;
				elem = elem.offsetParent;
			}
			elem = null;

			// move popup top to offset
			var popContent = document.getElementById('popupContent-' + popType);
			if(!!popContent) {
				popContent.style.top = offsetY.toString() + 'px';
			}
		}

		// wait for digest before showing
		$timeout(function() {
			if(!!!vm.popup || vm.popup.type == 'RXSELECTOR') { // rx selector is running its own ASYNC lookup
				return;
			}
			vm.popup.ready = true;
		}, 300);
	}


	function closePopup() {
		function okAffDetail(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;
			vm.model = r;
		}

		vm.popup = {};
	}


	/**
	 *    CLONE
	 */

	function cloneAFF(rxid) {
		// prompt user
		msgSvc.confirm({
			id: 'rx.clone.prompt',
			title: 'Confirm Clone ' + vm.context.CE + ' / ' + vm.context.RX + '?',
			msg: 'Properties and vendors will be copied to Pharmacy: ' + rxid,
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'NO', cancel: true}
			]
		}).then(confirmClone, confirmClone);
	}

	function confirmClone(r) {
		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;
			affRepo.cloneToRX(vm.context.CE, vm.context.RX, _pendingCloneToRX).then(okClone, errClone);
		}
		else {
			closePopup();
		}
	}

	function okClone(r) {
		vm.isWaiting = false;

		msgSvc.ok('Affiliation Cloned', 'Note, Affiliation and Vendor accounts are INACTIVE. Complete specific account details to make each ACTIVE.');
		getAff(vm.context.CE, _pendingCloneToRX);

		closePopup();
	}

	function errClone(r) {
		vm.isWaiting = false;
		closePopup();

		if(!!r) {
			errSvc.error('Unexpected api error', 'affDetailCtl.errClone', r.status, utilSvc.http.safeResponse(r));
		}
		else {
			// already handled
			$state.go(_viewErrRoute, {}, {reload: _viewErrRoute});
		}
	}

	/**
	 *    DATE PICKER
	 */
	function dtPickOpen(dtName) {

		if (dtName != 'ManufacturerOptInDate') {
			alert('affDetailCtl.dtPickOpen, date pick name unknown: ' + dtName);
			return;
		}
		var dt = vm.popup[dtName];
		vm.dtPickShow.pending = dtName;

		$scope.$broadcast('widget.input.date.pick', {
			uniqueId: dtName,
			setDate: dt.val,
			minDate: dt.min,
			maxDate: dt.max
		});

		$timeout(function () {
			if (validSvc.isText(vm.dtPickShow.pending)) {
				vm.dtPickShow[vm.dtPickShow.pending] = true;
			}
		}, 100);
	}

	/**
	 *   Manufacturer
	 * 
	 */
	function addManufacturerOptInItem() {
		var name = findManufacturerNameByLabelerId(vm.popup.MFRId.val);
		if (!!!name){
			msgSvc.ok('Please select a manufacturer');
			return;
		}
		var item = {
			Name: name,
			LabelerId: vm.popup.MFRId.val,
		};
		if (!!vm.popup.ManufacturerOptInDate.chk) {
			item["StartDate"] = vm.popup.ManufacturerOptInDate.val;
		}
		var index = findItemInManufacturerOptInList(item);
		if (index > -1) {
			msgSvc.ok('Manufacturer is already in list');
			return;
		}
		vm.popup.ManufacturerOptInList.push(
			item
		);
	}

	// Find the real manufacturer name rather than display name
	function findManufacturerNameByLabelerId(id) {
		var items = vm.GlobalExclusionManufacturerList;
		for(var i = 0; i < items.length; i++) {
			if(items[i].LabelerId === id) {
				return items[i].Name;
			}
		}
		return "";
	}

	function removeManufacturerOptInItem(item) {
		var items = vm.popup.ManufacturerOptInList;
		var index = findItemInManufacturerOptInList(item);
		if (index > -1) {
			items = items.splice(index, 1);
		}
	}

	function saveManufacturerOptInList() {
		msgSvc.confirm({
			id: 'affiliation.acct.mfrupdate',
			title: 'RE-EVALUATE MATCHES',
			msg: 'Would you like to re-evaluate matches for this Affiliation?',
			buttons: [
				{text:'RE-EVALUATE', result:"YES", cancel: false},
				{text:'NO RE-EVALUATE', result:"CANCEL", cancel: true}
			]
		}).then(confirmManufacturerOptInSave, confirmManufacturerOptInSave);
	}

	function confirmManufacturerOptInSave(result) {
		vm.isWaiting = true;
		vm.model.ManufacturerOptInList = vm.popup.ManufacturerOptInList;
		affRepo.mfrUpdate(vm.model, result.result == "YES").then(okUpsertMFRList, errUpsertMFRList);
		function okUpsertMFRList(r) {
			vm.isWaiting = false;
			if (result.result == "YES") {
				msgSvc.ok("Re-evaluation process started for fill date back to 6/1/2020 with allocated matches excluded");
			} else {
				msgSvc.ok("List Saved");
			}
		}
		function errUpsertMFRList(r) {
			vm.isWaiting = false;
			if (r.status == 409) {
				msgSvc.ok("There is a pending re-evaluation job for this affiliation, please try it later");
			} else {
				msgSvc.ok("Cannot Save");
			}
		}
	}

	function findItemInManufacturerOptInList(item) {
		var index = -1;
		var items = vm.popup.ManufacturerOptInList;
		for(var i = 0; i < items.length; i++) {
			if(items[i].LabelerId === item.LabelerId) {
				index = i;
				break;
			}
		}
		return index;
	}

	/**
	 * 		MULTISELECT
	 */

	function getShareGroupInfo(sharegroup) {
		lookupRepo.ShareGroupAffList(sharegroup).then(okShareGroupLookup, errShareGroupLookup);

		function okShareGroupLookup(r) {
			var affs = r;
			var items = [];
			for (var ii = 0; ii < affs.length; ii++) {
				var aff = affs[ii];
				var newItem = {
					uniqueId: ii.toString(),
					CEID: aff.CEID,
					CeName: aff.CeName,
					RXID: aff.RXID,
					RxName: aff.RxName,
				};
				items.push(newItem);
			}
			vm.popup.Items = items;
		}

		function errShareGroupLookup(r) {
			// not worth throwing error
		}
	}

	/**
	 * 		MULTISELECT
	 */

	function changeAltVendorList(val) {
		if(vm.isWaiting) {
			return;
		}

		vm.multiselectClick(vm.VenMulti, val);
		vm.multiselectTitle(vm.VenMulti, true);

		var prop = vm.model.AltVendorList;
		prop.vals = multiVals(vm.VenMulti);
		prop.fail = prop.vals.length < 1 ? 'yes' : 'no';
	}

	function changeFederate850VendorList(val) {
		if(vm.isWaiting) {
			return;
		}

		vm.multiselectClick(vm.Fed850VenMulti, val);
		vm.multiselectTitle(vm.Fed850VenMulti, true);

		var prop = vm.model.Federate850sToCEVendorList;
		prop.vals = multiVals(vm.Fed850VenMulti);
		prop.fail = prop.vals.length < 1 ? 'yes' : 'no';
	}

	function multiClick(propName, val) {

		switch(propName) {
			case 'VenMulti':
				changeAltVendorList(val);
				break;
			case 'Fed850VenMulti':
				changeFederate850VendorList(val);
				break;
			default:
				throw new Error('ndcList.multiClick, unknown propName: ' + propName);
		}

	}

    function multiToggle(evt, id) {
		var multi = vm[id];
		multiselectToggle(evt, multi, id);
	}

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if(vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		//multiselect.flt = '';

		// don't bother with width if hiding
		if(multiselect.show) {
			multiselect.show = false;
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;

		// set focus on filter
		if(multiselect.list.length > 10) {
			$timeout(function(){
				try {
					var inputElem = document.getElementById(id + 'Find');
					if(!!inputElem) {
						inputElem.focus();
						inputElem.setSelectionRange(0,9999);
					}
					inputElem = null;
				}
				catch(err) {
					// do nothing
				}
			},300);
		}

	}

	function multiHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 750) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}

	function multiVals(multi) {
		// unpack the vals multi into a list of entities to query

		// init process may have an invalid / empty list
		if(!!!multi || !Array.isArray(multi.list) || multi.list.length < 1 || !Array.isArray(multi.vals) || multi.vals.length < 1) {
			return [];
		}

		var checklist = multi.list,
			vals = multi.vals;
		var isALL = vals.length == 1 && vals[0] == 'ALL';

		var result = [],
			i = checklist[0].val == 'ALL' ? 1 : 0,
			item = {};
		for(i; i < checklist.length; i++) {
			item = checklist[i];
			if(isALL || !!item.checked) {
				result.push(checklist[i].val);
			}
		}

		return result;
	}


	/**
	 *    HELPERS
	 */

	function validText(prop, min, max) {

		// required
		if(!validSvc.isText(prop.val)) {
			prop.fail = 'yes';
			prop.msg = 'required';
			return prop;
		}

		// min
		if(prop.val.length < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum ' + min.toString() + ' characters';
			return prop;
		}

		// max
		if(prop.val.length > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum ' + max.toString() + ' characters';
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;
	}

	function validCurrency(prop, min, max) {

		// parse into float
		var floatVal;
		try {
			floatVal = parseFloat(prop.val);
		}
		catch(err) {
			// do nothing
		}

		// not a number
		if(!validSvc.isNumber(floatVal)) {
			prop.fail = 'yes';
			prop.msg = 'must be a number';
			return prop;
		}

		// min
		if(floatVal < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum: ' + min;
			return prop;
		}

		// max
		if(floatVal > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum: ' + max;
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';

		return prop;

	}

	function resetValidationState() {

		// reset validation state on all model properties
		// note: use this after an update to hide validation icons

		for (var prop in vm.model) {
			if(vm.model.hasOwnProperty(prop)) {
				if(vm.model[prop].fail !== '') {
					vm.model[prop].fail = '';
				}
			}
		}

	}

	function affilBizModelText(bizModel) {

		if(!validSvc.isText(bizModel)) {
			return '';
		}

		switch(bizModel) {
			case 'NONE':
				return 'None';
			case 'CP':
				return 'Contract Pharmacy (CP)';
			case 'CPTPA':
				return 'Contract Pharmacy with TPA (CPTPA)';
			case 'CPSPLIT':
				return 'Contract Pharmacy with Splitting (CPSPLIT)';
			case 'SPLIT':
				return 'Splitting Pharmacy (SPLIT)';
			case 'SPLITMATCH':
				return 'Splitting Pharmacy with Matching (SPLITMATCH)';
			default:
				throw new Error('affDetailCtl.affilBizModelText, unknown affilBizModel: ' + bizModel);
		}
	}

	function ndcListText(ndcListType) {

		switch(ndcListType) {

			case 'AlwaysSplit':
			case 'AW':
				return 'Always Split';

			case 'NeverSplit':
			case 'NV':
				return 'Never Split';

			case 'OrderExcls':
			case 'OE':
				return 'Never Order';

			case 'OrderPref':
			case 'OI':
				return 'Always Order';

			case '340BALTDRUGS':
			case 'TA':
				return '340B Alternate Drugs';

			default:
				throw new Error('affDetailCtl.ndcListText, unknown list type: ' + ndcListType);
		}

	}

		/**
	 *    CHANGE EVENTS
	 */

		function gpoRefChange(changed) {
				switch(changed) {
	
					case 'CE':
						vm.gpoRefPHDroplist = utilSvc.ng.droplistNONE();
						vm.gpoRefVendorDroplist = utilSvc.ng.droplistNONE();
						break;
	
					case 'PH':
						vm.gpoRefVendorDroplist = utilSvc.ng.droplistNONE();
						break;
	
					case 'VENDOR':
						// no dependents
						break;
	
					default:
						throw new Error('invManualCtl.queryChange, unknown changed type: ' + changed);
				}
		}

		
	// GPO Reference Account handlers
	function gpoRefChangeCE() {

		gpoRefChange('CE');

		vm.model.GPOReferenceCE.fail = validSvc.isEntity(vm.model.GPOReferenceCE.val) ? 'no' : 'yes';
		if(vm.model.GPOReferenceCE.fail == 'yes') {
			vm.model.GPOReferencePH = validSvc.newProp('NONE');
			return;
		}

		// populate pharmacies
		vm.gpoRefPHDroplist = utilSvc.aff.rxDroplist($scope.User.AffList, vm.model.GPOReferenceCE.val);
		vm.model.GPOReferencePH = utilSvc.ng.droplistAutoselect(vm.gpoRefPHDroplist, vm.model.GPOReferencePH.val);

		gpoRefChangePH();
	}

	function gpoRefChangePH() {
			gpoRefChange('PH');
	
			vm.model.GPOReferencePH.fail = validSvc.isEntity(vm.model.GPOReferencePH.val) ? 'no' : 'yes';
			if(vm.model.GPOReferencePH.fail == 'yes') {
				vm.model.GPOReferenceVendor = validSvc.newProp('NONE');
				return;
			}
	
			// vendor options
			var limits = {
				CE:  vm.model.GPOReferenceCE.val,
				RX:  vm.model.GPOReferencePH.val,
				ACCUMGRP: ['GPO'],
				includeNoEDI: true
			};
			vm.gpoRefVendorDroplist = utilSvc.aff.droplistByType($scope.User.AffList, 'VEN', limits);
			vm.model.GPOReferenceVendor = utilSvc.ng.droplistAutoselect(vm.gpoRefVendorDroplist, vm.model.GPOReferenceVendor.val);
	}

	function gpoRefChangeVendor() {
		vm.model.GPOReferenceVendor.fail = validSvc.isEntity(vm.model.GPOReferenceVendor.val) ? 'no' : 'yes';
		if(vm.model.GPOReferenceVendor.fail == 'yes') {
			return;
		}

	}

	/**
	 *    WAC NEUT EXTERNAL MAPPINGS
	 */

	function wacNeutMappingAddItem() {
		if(vm.isWaiting) {
			return;
		}
		vm.model.WacNeutExternalMappings.push(affRepo.wacNeutExternalMappingItemVM());
	}

	function wacNeutMappingRemoveItem(item) {
		if(vm.isWaiting || !item || !validSvc.isText(item.Id)) {
			return;
		}
		var mappings = vm.model.WacNeutExternalMappings,
			id = item.Id;
		for(var i = mappings.length - 1; i >= 0; i--) {
			if(mappings[i].Id == id) {
				mappings.splice(i, 1);
			}
		}
	}
}
 
/**
 *    AFFILIATES LIST CTL
 *    injected into CE and RX edit views
 */

affListCtl.$inject = ['$scope', '$state', 'affRepo', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc', 'appConst'];
angular
.module('espui.admin')
.controller('AffsListCtl', affListCtl);


/* @ngInject */
function affListCtl($scope, $state, affRepo, validSvc, errSvc, utilSvc, msgSvc, appConst) {

	/*jshint validthis: true */
	var vm = this,
		_viewErrRoute = '';

	// add sorting and paging features
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);

	// properties
	vm.action = '';
	vm.isWaiting = false;
	vm.viewType = '';

	// models
	vm.context = {};
	vm.display = {};

	// status filter on LIST view
	vm.statusFilter = undefined;
	vm.statusFilterUser = 'ALL';
	vm.statusFilterChange = statusFilterChange;

	// aff editing
	vm.canCreate = false;
	vm.newAff = newAff;
	vm.getAff = getAff;


	/**
	 *    INIT
	 */

	init();

	function init() {

		// route properties
		var params = $state.params || {};
		if(params.ViewType != 'CE' && params.ViewType != 'RX') {
			throw new Error('affListCtl.init, params.ViewType required');
		}

		vm.viewType = params.ViewType;
		vm.context = initContext(vm.viewType, params);

		// set editing rights
		vm.canCreate = vm.viewType == 'CE';

		listAffs();

	}

	function initContext(viewType, params) {

		_viewErrRoute = 'admin.' + viewType.toLowerCase() + '.list';

		// validate view type has data
		if(viewType == 'CE' && !validSvc.isCE(params.CE)) {
			throw new Error('affListCtl.init, CE view type needs valid CE');
		}
		else if(viewType == 'RX' && !validSvc.isRX(params.RX)) {
			throw new Error('affListCtl.init, RX view type needs valid RX');
		}

		return {
			uType: $scope.User.Type,
			CE: viewType == 'CE' ? params.CE : 'NONE',
			RX: viewType == 'RX' ? params.RX : 'NONE'
		};

	}


	/**
	 *    VIEW MODELS
	 */

	function affListVM(data) {

		// list affiliations for this CE

		// reset aff status
		vm.statusFilterUser = 'ALL';
		vm.statusFilter = undefined;

		// loop affiliations
		var affs = Array.isArray(data) ? data : [];
		var orderAcct = null;
		for (var i = 0; i < affs.length; i++) {

			// setup ordering accounts
			affs[i].OrderType340B = [];
			affs[i].OrderTypeGPO = [];
			affs[i].OrderTypeWAC = [];
			affs[i].OrderTypeIND = [];
			affs[i].OrderTypeOWN = [];

			for(var ii = 0; ii < affs[i].Ordering.length; ii++) {
				orderAcct = affs[i].Ordering[ii];
				switch(orderAcct.Type) {
					case '340B':
						if(affs[i].OrderType340B.indexOf(orderAcct.VENID) < 0) {
							affs[i].OrderType340B.push(orderAcct.VENID);
						}
						break;
					case 'GPO':
						if(affs[i].OrderTypeGPO.indexOf(orderAcct.VENID) < 0) {
							affs[i].OrderTypeGPO.push(orderAcct.VENID);
						}
						break;
					case 'WAC':
						if(affs[i].OrderTypeWAC.indexOf(orderAcct.VENID) < 0) {
							affs[i].OrderTypeWAC.push(orderAcct.VENID);
						}
						break;
					case 'IND':
						if(affs[i].OrderTypeIND.indexOf(orderAcct.VENID) < 0) {
							affs[i].OrderTypeIND.push(orderAcct.VENID);
						}
						break;

					case 'OWN':
						if(affs[i].OrderTypeOWN.indexOf(orderAcct.VENID) < 0) {
							affs[i].OrderTypeOWN.push(orderAcct.VENID);
						}
						break;
					default:
						throw new Error('affListCtl.affListVM, vendor acct type unknown: ' + orderAcct.Type);
				}
			}
			affs[i].OrderType340B.sort();
			affs[i].OrderTypeGPO.sort();
			affs[i].OrderTypeWAC.sort();
			affs[i].OrderTypeIND.sort();
			affs[i].OrderTypeOWN.sort();
		}

		var sortBy = vm.viewType == 'CE' ? ['RXID'] : ['CEID'];

		return {
			Items: affs,
			SortBy: sortBy,
			Paging: {
				Page: 1,
				Size: affs.length,
				Total: 1
			}
		};

	}


	/**
	 *    LIST AFFS
	 */

	function listAffs() {

		// refresh affiliations returned at login

		vm.action = '';
		vm.display = affListVM();

		vm.isWaiting = true;
		msgSvc.wait(true);

		affRepo.getList(vm.context.CE, vm.context.RX).then(okListAffs, errListAffs);

		function okListAffs(r) {

			msgSvc.wait(false);
			vm.isWaiting = false;

			vm.display = affListVM(r);
			vm.action = 'LIST';

		}

		function errListAffs(r) {

			msgSvc.wait(false);
			vm.isWaiting = false;

			if(r !== null) {
				errSvc.warn('Not able to get affiliation list.', 'affListCtl.errListAffs', r.status, utilSvc.http.safeResponse(r));
				$state.go(_viewErrRoute, {}, {reload: _viewErrRoute});
			}

		}

	}


	/**
	 *    LIST FILTER: STATUS
	 */

	function statusFilterChange() {

		// status dropdown value needs to be converted to undefined
		// note: status has an exact match filter, it won't show any status if the user selects "All"

		if(vm.statusFilterUser === 'ALL') {
			vm.statusFilter = undefined;
		}
		else {
			vm.statusFilter = vm.statusFilterUser;
		}

	}


	/**
	 *    CREATE AFF
	 */

	function newAff() {

		// user clicked new button

		if(vm.isWaiting) {
			return;
		}

		// only CE can create a new affiliation
		if(!validSvc.isCE(vm.context.CE)) {
			throw new Error('affListCtl.newAff, ceid is required to create a new affiliate');
		}

		$state.go('admin.ce.edit.affs-detail', {
			ViewType: 'CE-CREATE',
			CE: vm.context.CE,
			RX: 'NONE',
		}, {reload: 'admin.ce.edit.affs-detail'});

	}


	/**
	 *    GET
	 */

	function getAff(ceid, rxid) {

		// user clicked an affiliate, load edit view

		if(vm.isWaiting) {
			return;
		}

		if(vm.viewType == 'CE') {

			$state.go('admin.ce.edit.affs-detail', {
				ViewType: 'CE-UPDATE',
				CE: ceid,
				RX: rxid,
			}, {reload: 'admin.ce.edit.affs-detail'});

		}
		else {

			$state.go('admin.rx.edit.affs-detail', {
				ViewType: 'RX-UPDATE',
				CE: ceid,
				RX: rxid,
			}, {reload: 'admin.rx.edit.affs-detail'});

		}

	}

}
 
affRepo.$inject = ['$q', 'apiService', 'errSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
.module('espui.admin')
.factory('affRepo', affRepo);


/* @ngInject */
function affRepo($q, apiService, errSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _currentPurl = '',
		_apiPaging = vmSvc.api.paging(),
		_query = {},
		_modelPending = {},
		_vendorPending = {};

	// service definition
	var service = {
		modelVM: modelVM,
		getInitData: getInitData,

		// queries
		getList: getList,
		getDetail: getDetail,

		// aff editing
		create: create,
		update: update,
		statusChange: statusChange,

		// vendor editing
		vendorCreate: vendorCreate,
		vendorUpdate: vendorUpdate,
		vendorDelete: vendorDelete,

		// manufacturer restriction list
		mfrUpdate: mfrUpdate,

		// aff clone
		cloneToRX: cloneToRX,

		// wac neut external mappings
		wacNeutExternalMappingItemVM: wacNeutExternalMappingItemVM

	};

	return service;


	/**
	 *    WAC NEUT EXTERNAL MAPPINGS HELPERS
	 */

	function wacNeutExternalMappingItemVM(item) {
		item = item || {};
		return {
			Id: validSvc.isText(item.Id) ? item.Id : Date.now().toString(),
			ExternalFacilityId: validSvc.newProp(validSvc.isText(item.ExternalFacilityId) ? item.ExternalFacilityId : ''),
			ExternalPharmacyId: validSvc.newProp(validSvc.isText(item.ExternalPharmacyId) ? item.ExternalPharmacyId : ''),
			CostCenterId: validSvc.newProp(validSvc.isText(item.CostCenterId) ? item.CostCenterId : ''),
			fail: '',
			msg: ''
		};
	}

	function wacNeutExternalMappingsVM(data) {
		var result = [],
            item = {};
        data = Array.isArray(data) ? data : [];
        for (var i = 0; i < data.length; i++) {
            item = data[i];
            item.Id = validSvc.isText(item.Id) ? item.Id : Date.now().toString() + '_' + i.toString();
            result.push(wacNeutExternalMappingItemVM(item));
        }
		return result;
	}

	function wacNeutExternalMappingsAPI(mappings) {
		var result = [];
		if (Array.isArray(mappings)) {
			for (var i = 0; i < mappings.length; i++) {
				result.push({
					ExternalFacilityId: mappings[i].ExternalFacilityId.val,
					ExternalPharmacyId: mappings[i].ExternalPharmacyId.val,
					CostCenterId: mappings[i].CostCenterId.val
				});
			}
		}
		return result;
	}


	/**
	 *    VIEW MODEL
	 */

	function modelVM(data) {
		// set defaults
		data = data || {};

		// date ranges
		var dtToday = utilSvc.dt.zeroTime(new Date()),
			dtHrsaMin = utilSvc.dt.zeroTime(new Date(1992, 10, 1)), // min is Nov 1992
			dtHrsaMax = utilSvc.dt.zeroTime(utilSvc.dt.addDays(new Date(), 365)); // max is + 1 year

		// convert accum groups into edit models
		var shareList = [],
			splitList = [],
			i = 0;

		// system-wide accum groups
		data.AccumAllGroups = Array.isArray(data.AccumAllGroups) ? data.AccumAllGroups : [];
		data.AccumAllGroups.sort();

		// share
		data.AccumShareGroups = Array.isArray(data.AccumShareGroups) ? data.AccumShareGroups : [];
		data.AccumShareGroups.sort();
		for(i = 0; i < data.AccumShareGroups.length; i++) {
			shareList.push(validSvc.newProp(data.AccumShareGroups[i]));
		}

		// split
		data.AccumSplitGroups = Array.isArray(data.AccumSplitGroups) ? data.AccumSplitGroups : [];
		data.AccumSplitGroups.sort();
		for(i = 0; i < data.AccumSplitGroups.length; i++) {
			splitList.push(validSvc.newProp(data.AccumSplitGroups[i]));
		}


		// price select is bool true
		var priceSelectWAC = typeof(data.PriceSelectWAC) === 'undefined' ? true : !!data.PriceSelectWAC;

		// RX biz model (always remove NONE)
		var rxModels = Array.isArray(data.RxBizModels) ? data.RxBizModels : [];
		rxModels.sort();
		var noneIdx = rxModels.indexOf('NONE');
		if(noneIdx > -1) {
			rxModels.splice(noneIdx, 1);
		}

		// aff biz model (reset to NONE if RX doesn't support it)
		var bizModel = validSvc.isText(data.AffilBizModel) ? data.AffilBizModel : 'NONE';
		if(bizModel != 'NONE' && rxModels.indexOf(bizModel) < 0) {
			bizModel = 'NONE';
		}

		var tmout = parseInt(data.Timeout855s);
		if(!validSvc.isInteger(tmout) || tmout < 1) {
			tmout = 60;
		}
		var wacAdjustPercent = parseInt(data.AutoAdjustWACPercent);

		var pretmout = parseInt(data.PreSplitTimeout);
		
		if(!validSvc.isInteger(pretmout) || pretmout < 15) {
			pretmout = 15;
		}

		var apptmout = parseInt(data.ApprovalTimeout);
		
		if(!validSvc.isInteger(apptmout) || apptmout < 30) {
			apptmout = 30;
		}

		// RX parent pricing
		data.RxPricing = data.RxPricing || {};
		var rxPriceOverride = !!data.RxPricing.CanOverride;

		// aff pricing
		data.Pricing = data.Pricing || {};
		var affPriceOverride = rxPriceOverride && !!data.Pricing.Overridden;

		// reset values if not enabled or overridden
		if( !affPriceOverride ) {
			data.Pricing.Model = data.RxPricing.Model;
			data.Pricing.Rate = data.RxPricing.Rate;
			if ( !rxPriceOverride ) {
				data.Pricing.Model = '';
				data.Pricing.Rate = 0.0;
			}
		}

		// RX parent billing
		var rxBillExists = !!data.RxBilling;
		data.RxBilling = data.RxBilling || {};
		var rxBillEnabled = !!data.RxBilling.Enabled,
			rxBillOverride = !!data.RxBilling.CanOverride;

		// aff billing
		var affBillExists = !!data.Billing;
		data.Billing = data.Billing || {Enabled: rxBillEnabled};
		var affBillEnabled = rxBillEnabled && !!data.Billing.Enabled,
			affBillOverride = rxBillOverride && !!data.Billing.Overridden;

		// reset values if not enabled or overridden
		if(!rxBillEnabled || !affBillEnabled || !rxBillOverride || !affBillOverride) {
			data.Billing.Export = false;
			data.Billing.ExportFees = false;
			data.Billing.ExportDrugCost = false;
		}
		else if(!affBillExists && rxBillEnabled) {
			// billing doesn't exist, if RX billing is enabled, copy its settings to affiliation
			data.Billing.Export = !!data.RxBilling.Export;
			data.Billing.ExportFees = !!data.RxBilling.ExportFees;
			data.Billing.ExportDrugCost = !!data.RxBilling.ExportDrugCost;
		}

		// cash card fee
		if(!!data.CashCardParticipant) {
			data.FeeCashCard = validSvc.isNumber(data.FeeCashCard) ? parseFloat(data.FeeCashCard) : 0.00;
		}
		else {
			data.FeeCashCard = 0.00;
		}

		var mfrList = [];
		data.ManufacturerOptInList = !!data.ManufacturerOptInList ? data.ManufacturerOptInList : [];
		for(i = 0; i < data.ManufacturerOptInList.length; i++) {
			mfrList.push(data.ManufacturerOptInList[i]);
			mfrList[i].StartDate = utilSvc.dt.isNull(mfrList[i].StartDate) ? null : mfrList[i].StartDate;
			if (mfrList[i].StartDate != null) {
				mfrList[i].StartDate = new Date(utilSvc.dt.fromServerDateExactUTC(mfrList[i].StartDate));
			}
		}
		
		// product type lock properties
		if(data.ProductType == 'VERISAVE') {
			data.UseBestCost = true;
		}

		// alt split vendors, array model property needs a 'vals'
		var hasAltSplitVendors = !!data.AllowAltVendorSplit && Array.isArray(data.AltVendorList) && data.AltVendorList.length > 0;
		var propAltVendorList = validSvc.newProp('');
		propAltVendorList.vals = hasAltSplitVendors ? data.AltVendorList : [];

		// federate 850s to CE vendors, array model property needs a 'vals'
		var hasFederate850sToCEVendors = !!data.AllowFederate850sToCE && Array.isArray(data.Federate850sToCEVendorList) && data.Federate850sToCEVendorList.length > 0;
		var propFederate850sToCEVendorList = validSvc.newProp('');
		propFederate850sToCEVendorList.vals = hasFederate850sToCEVendors ? data.Federate850sToCEVendorList : [];

		// verisave fee model
		var vsModelIsFlat = data.FeeVerisaveModel == 'FLAT',
			vsModelIsPercent = data.FeeVerisaveModel == 'PERCENTAGESAVINGS';

		var m = {
			Id : data.Id,
			CE: validSvc.isCE(data.CEID) ? data.CEID : 'CEID',
			CeOpaType: validSvc.isText(data.CEOpaType) ? data.CEOpaType : '',
			RX: validSvc.newProp(validSvc.isRX(data.RXID) ? data.RXID : 'NONE'),
			RxType: validSvc.isText(data.RxType) ? data.RxType : '',
			CeOwnedPharmacy: !!data.CeOwnedPharmacy ? 'yes' : 'no',
			ProgramAdmin: validSvc.newProp(validSvc.isText(data.ProgramAdmin) ? data.ProgramAdmin : ''),
			CEAffilIsExternal: validSvc.isText(data.ProgramAdmin) ? 'yes' : 'no',

			RxBizModels: rxModels,
			AffilName: validSvc.newProp(validSvc.isText(data.AffilName) ? data.AffilName : ''),
			AffilBizModel: validSvc.newProp(bizModel),
			AffilBizModelClean: bizModel,

			CEStatus: validSvc.isText(data.CEStatus) ? data.CEStatus : '',
			RXStatus: validSvc.isText(data.RXStatus) ? data.RXStatus : '',
			RXCentralFillPharmacy: validSvc.isText(data.RXCentralFillPharmacy) ? data.RXCentralFillPharmacy : '',
			ObjectState: validSvc.isText(data.ObjectState) ? data.ObjectState : 'CREATE',

			ContractDate: validSvc.newPropDateExact(utilSvc.dt.fromServerDateExactPST(data.ContractDate), dtHrsaMin, dtHrsaMax),
			ContractTerminationDate: validSvc.newPropDateExact(utilSvc.dt.fromServerDateExactPST(data.ContractTerminationDate), dtHrsaMin, dtHrsaMax),
			TerminationCause: validSvc.newProp(validSvc.isText(data.TerminationCause) ? data.TerminationCause : ''),

			// Own Use
			Enable340BMatching: !!data.Disable340BMatching ? 'no' : 'yes',
			EnableOwnUseMatching: !!data.OwnUseEnableMatching ? 'yes' : 'no',
			// GPO Matching
			EnableGPOMatching: !!!data.EnableGPOMatching || !!!data.EnableGPOMatching.fail ? validSvc.newProp(!!data.EnableGPOMatching ? 'yes' : 'no') : data.EnableGPOMatching,
			OwnUseAccumulationDelay: validSvc.newProp(validSvc.isNumber(data.OwnUseAccumulationDelay) ? parseInt(data.OwnUseAccumulationDelay) : 7),
			GPOMatchDelay: validSvc.newProp(validSvc.isNumber(data.GPOMatchDelay) ? parseInt(data.GPOMatchDelay) : 7),
			RxPricingOverride: rxPriceOverride ? 'yes' : 'no',
			RxPricingModel: data.RxPricing.Model,
			RxPricingRate: validSvc.isNumber(data.RxPricing.Rate) ? parseFloat(data.RxPricing.Rate) : 0.00,
			// Match by file
			EnableMatchByFile: !!!data.EnableMatchByFile || !!!data.EnableMatchByFile.fail ? validSvc.newProp(!!data.EnableMatchByFile ? 'yes' : 'no') : data.EnableMatchByFile,
			IncludeDispenseBasedEligibility: !!!data.IncludeDispenseBasedEligibility || !!!data.IncludeDispenseBasedEligibility.fail ? validSvc.newProp(!!data.IncludeDispenseBasedEligibility ? 'yes' : 'no') : data.IncludeDispenseBasedEligibility,

			// Claim Federation
			ClaimFederationStart: validSvc.newPropDateExact(utilSvc.dt.fromServerDateExactPST(data.ClaimFederationStart), dtHrsaMin, dtHrsaMax),

			PricingOverride: affPriceOverride ? 'yes' : 'no',
			PricingModel: validSvc.newProp(validSvc.isText(data.Pricing.Model) ? data.Pricing.Model : ''),
			PricingRate: validSvc.newProp(validSvc.isNumber(data.Pricing.Rate) ? parseFloat(data.Pricing.Rate) : 0.00),

			RxBillEnabled: rxBillEnabled ? 'yes' : 'no',
			RxBillOverride: rxBillOverride ? 'yes' : 'no',
			RxBillFrequency: data.RxBilling.Frequency,
			RxBillExport: !!data.RxBilling.Export ? 'yes' : 'no',
			RxBillExportDetailedRollup: !!data.RxBilling.ExportDetailedRollup ? 'yes' : 'no',
			RxBillExportFees: !!data.RxBilling.ExportFees ? 'yes' : 'no',
			RxBillExportDrugCost: !!data.RxBilling.ExportDrugCost ? 'yes' : 'no',
			VCentralEnabled: !!data.VCentral && !!data.VCentral.Enabled ? 'yes' : 'no',
			RxSequentialSplit:data.RxSequentialSplit,
			ReferencePriceProxy : data.ReferencePriceProxy === false ? 'no' : 'yes',

			BillEnabled: affBillEnabled ? 'yes' : 'no',
			BillOverride: affBillOverride ? 'yes' : 'no',
			BillExport: !!data.Billing.Export ? 'yes' : 'no',
			BillExportFees: !!data.Billing.ExportFees ? 'yes' : 'no',
			BillExportDrugCost: !!data.Billing.ExportDrugCost ? 'yes' : 'no',

			ExportAccumsForVendorEnabled: !!(data.ExportAccumsForVendor && data.ExportAccumsForVendor.Enabled) ? 'yes' : 'no',  // default to no
			ExportAccumsForTrulla: !!(data.ExportAccumsForVendor && data.ExportAccumsForVendor.EnabledForTrulla),  // default to no
			ExportAccumsForCencora: !!(data.ExportAccumsForVendor && data.ExportAccumsForVendor.EnabledForCencora),  // default to no
			ExportAccumsForVendorHasCencora: !!data.HasCencora,

			VisitEligDaysBefore: validSvc.newProp(validSvc.isNumber(data.VisitEligDaysBefore) ? parseInt(data.VisitEligDaysBefore) : 365),
			VisitEligDaysAfter: validSvc.newProp(validSvc.isNumber(data.VisitEligDaysAfter) ? parseInt(data.VisitEligDaysAfter) : 0),

			CeMatchReview: !!data.CeMatchReview ? 'yes' : 'no',
			UseCeMatchReviewNdcList: !!data.UseCeMatchReviewNdcList ? 'yes' : 'no',
			MatchReviewNdcListCount : data.MatchReviewNdcListCount,

			ValidateClaimsModifier: validSvc.newProp(!!data.ValidateClaimsModifier ? 'yes' : 'no'),
			Require340BSubClarifyMod: !!data.Require340BSubClarifyMod ? 'yes' : 'no',
			Require340BBasisCostMod: !!data.Require340BBasisCostMod ? 'yes' : 'no',

			ProfitableOnly: data.ProfitableOnly === false ? 'no' : 'yes', // default is yes
			DispenseFeeModel: validSvc.isText(data.DispenseFeeModel) ? data.DispenseFeeModel : 'ORDERQUANTITY',
			DispenseFeeValueType: validSvc.isText(data.DispenseFeeValueType) ? data.DispenseFeeValueType : 'REIMBURSEMENT',
      		NdcListFeesEnabled: data.NdcListFeesEnabled,

			OrderFeeModel: validSvc.isText(data.OrderFeeModel) ? data.OrderFeeModel : 'ORDERQUANTITY',

			MinClaimValue: validSvc.newProp(validSvc.isNumber(data.MinClaimValue) ? parseFloat(data.MinClaimValue) : 0.00),

			FeeVerityMonthly: validSvc.newProp(validSvc.isNumber(data.FeeVerityMonthly) ? parseFloat(data.FeeVerityMonthly) : 0.00),
			FeeEligibility: validSvc.newProp(validSvc.isNumber(data.FeeEligibility) ? parseFloat(data.FeeEligibility) : 0.00),
			FeeOrder: validSvc.newProp(validSvc.isNumber(data.FeeOrder) ? parseFloat(data.FeeOrder) : 0.00),
			FeeOrderPercent: validSvc.newProp(validSvc.isNumber(data.FeeOrderPercent) ? parseFloat(data.FeeOrderPercent) : 0.00),
			FeeOrderPercentMinAmt: validSvc.newProp(validSvc.isNumber(data.FeeOrderPercentMinAmt) ? parseFloat(data.FeeOrderPercentMinAmt) : 0.00),
			FeeOrderPercentMinAmtChk: false,
			FeeOrderPercentMaxAmt: validSvc.newProp(validSvc.isNumber(data.FeeOrderPercentMaxAmt) ? parseFloat(data.FeeOrderPercentMaxAmt) : 0.00),
			FeeOrderPercentMaxAmtChk: false,
			FeeVerisaveModel: vsModelIsFlat || vsModelIsPercent ? data.FeeVerisaveModel : '',
			FeeVerisaveFlat: validSvc.newProp(vsModelIsFlat && validSvc.isNumber(data.FeeVerisaveFlat) ? parseFloat(data.FeeVerisaveFlat) : 0.00),
			FeeVerisaveOrderPercent: validSvc.newProp(vsModelIsPercent && validSvc.isNumber(data.FeeVerisaveOrderPercent) ? parseFloat(data.FeeVerisaveOrderPercent) : 0.00),
			FeeVerisaveOrderPercentMinAmt: validSvc.newProp(vsModelIsPercent && validSvc.isNumber(data.FeeVerisaveOrderPercentMinAmt) ? parseFloat(data.FeeVerisaveOrderPercentMinAmt) : 0.00),
			FeeVerisaveOrderPercentMaxAmt: validSvc.newProp(vsModelIsPercent && validSvc.isNumber(data.FeeVerisaveOrderPercentMaxAmt) ? parseFloat(data.FeeVerisaveOrderPercentMaxAmt) : 0.00),
			FeeBrand: validSvc.newProp(validSvc.isNumber(data.FeeBrand) ? parseFloat(data.FeeBrand) : 0.00),
			FeeBrandPercent: validSvc.newProp(validSvc.isNumber(data.FeeBrandPercent) ? parseFloat(data.FeeBrandPercent) : 0.00),
			FeeBrandPercentMinAmt: validSvc.newProp(validSvc.isNumber(data.FeeBrandPercentMinAmt) ? parseFloat(data.FeeBrandPercentMinAmt) : 0.00),
			FeeBrandPercentMinAmtChk: false,
			FeeBrandPercentMaxAmt: validSvc.newProp(validSvc.isNumber(data.FeeBrandPercentMaxAmt) ? parseFloat(data.FeeBrandPercentMaxAmt) : 0.00),
			FeeBrandPercentMaxAmtChk: false,
			FeeGeneric: validSvc.newProp(validSvc.isNumber(data.FeeGeneric) ? parseFloat(data.FeeGeneric) : 0.00),
			FeeGenericPercent: validSvc.newProp(validSvc.isNumber(data.FeeGenericPercent) ? parseFloat(data.FeeGenericPercent) : 0.00),
			FeeGenericPercentMinAmt: validSvc.newProp(validSvc.isNumber(data.FeeGenericPercentMinAmt) ? parseFloat(data.FeeGenericPercentMinAmt) : 0.00),
			FeeGenericPercentMinAmtChk: false,
			FeeGenericPercentMaxAmt: validSvc.newProp(validSvc.isNumber(data.FeeGenericPercentMaxAmt) ? parseFloat(data.FeeGenericPercentMaxAmt) : 0.00),
			FeeGenericPercentMaxAmtChk: false,
			FeeSupplyDaysCapped: data.FeeSupplyDaysCapped === false ? 'no' : 'yes', // default is yes
			FeeSupplyDaysFirstMax: validSvc.newProp(validSvc.isNumber(data.FeeSupplyDaysFirstMax) ? parseFloat(data.FeeSupplyDaysFirstMax) : 0.00),
			FeeSupplyDaysFirstDay: validSvc.newProp(validSvc.isNumber(data.FeeSupplyDaysFirstDay) ? parseInt(data.FeeSupplyDaysFirstDay) : 0),
			FeeSupplyDaysSecondMax: validSvc.newProp(validSvc.isNumber(data.FeeSupplyDaysSecondMax) ? parseFloat(data.FeeSupplyDaysSecondMax) : 0.00),
			FeeSupplyDaysSecondDay: validSvc.newProp(validSvc.isNumber(data.FeeSupplyDaysSecondDay) ? parseInt(data.FeeSupplyDaysSecondDay) : 0),
			FeeSupplyDaysLastMax: validSvc.newProp(validSvc.isNumber(data.FeeSupplyDaysLastMax) ? parseFloat(data.FeeSupplyDaysLastMax) : 0.00),

			GenericOrderable: validSvc.newProp(!!data.GenericOrderable ? 'yes' : 'no'),
			GenericEffectiveDate: validSvc.newPropDateExact(utilSvc.dt.fromServerDateExactPST(data.GenericEffectiveDate), dtHrsaMin, dtHrsaMax),

			CIIOrderable: !!data.CIIOrderable ? 'yes' : 'no',

			MedicaidFFSCarveIn: !!data.MedicaidFFSCarveIn ? 'yes' : 'no',
			MedicaidMCOCarveIn: !!data.MedicaidMCOCarveIn ? 'yes' : 'no',
			ValidateMedicaidClaims: validSvc.newProp(!!data.ValidateMedicaidClaims ? 'yes' : 'no'),

			Require340BSubClarifyFFS: !!data.Require340BSubClarifyFFS ? 'yes' : 'no',
			Require340BBasisCostFFS: !!data.Require340BBasisCostFFS ? 'yes' : 'no',
			Require340BBasisCostFFSCodes: !!data.Require340BBasisCostFFSCodes ? data.Require340BBasisCostFFSCodes: [], 
			RequireFFSCode: validSvc.newProp(),

			Require340BSubClarifyMCO: !!data.Require340BSubClarifyMCO ? 'yes' : 'no',
			Require340BBasisCostMCO: !!data.Require340BBasisCostMCO ? 'yes' : 'no',
			Require340BBasisCostMCOCodes: !!data.Require340BBasisCostMCOCodes ? data.Require340BBasisCostMCOCodes: [],
			RequireMCOCode: validSvc.newProp(),

			//IRA
			IRAOptOut : !!data.IRAOptOut ? 'yes' : 'no',
			IRAOptOutSome : !!data.IRAOptOutSome ? 'yes' : 'no',
			MRebateOptIn: !!data.MRebateOptIn ? 'yes': 'no',
			MRebateOptInSome: !!data.MRebateOptInSome ? 'yes': 'no',
			MRebateAutoOrder: !!data.MRebateAutoOrder ? 'yes': 'no',

			// Formula Restrictions
			BestCostPckSizeSubstitution: !!data.BestCostPckSizeSubstitution ? 'yes' : 'no',
			BestCostPckFormSubstitution: !!data.BestCostPckFormSubstitution ? 'yes' : 'no',
			VerisavePreferredCount: validSvc.isNumber(data.VerisavePreferredCount) ? data.VerisavePreferredCount : 0,
			VerisaveNeverSwitchToCount: validSvc.isNumber(data.VerisaveNeverSwitchToCount) ? data.VerisaveNeverSwitchToCount : 0,

			FeeSpecialtyOrderFeeModel: validSvc.isText(data.FeeSpecialtyOrderFeeModel) ? data.FeeSpecialtyOrderFeeModel : 'ORDERQUANTITY',
			FeeSpecialtyDispenseFeeModel: validSvc.isText(data.FeeSpecialtyDispenseFeeModel) ? data.FeeSpecialtyDispenseFeeModel : 'ORDERQUANTITY',
			FeeSpecialtyDispenseFeeValueType: validSvc.isText(data.FeeSpecialtyDispenseFeeValueType) ? data.FeeSpecialtyDispenseFeeValueType : 'REIMBURSEMENT',

			FeeSpecialtyRx: validSvc.isText(data.FeeSpecialtyRx) ? data.FeeSpecialtyRx : '',
			FeeSpecialtyBrand: validSvc.newProp(validSvc.isNumber(data.FeeSpecialtyBrand) ? parseFloat(data.FeeSpecialtyBrand) : 0.00),
			FeeSpecialtyBrandPercent: validSvc.newProp(validSvc.isNumber(data.FeeSpecialtyBrandPercent) ? parseFloat(data.FeeSpecialtyBrandPercent) : 0.00),
			FeeSpecialtyBrandPercentMinAmt: validSvc.newProp(validSvc.isNumber(data.FeeSpecialtyBrandPercentMinAmt) ? parseFloat(data.FeeSpecialtyBrandPercentMinAmt) : 0.00),
			FeeSpecialtyBrandPercentMinAmtChk: false,
			FeeSpecialtyBrandPercentMaxAmt: validSvc.newProp(validSvc.isNumber(data.FeeSpecialtyBrandPercentMaxAmt) ? parseFloat(data.FeeSpecialtyBrandPercentMaxAmt) : 0.00),
			FeeSpecialtyBrandPercentMaxAmtChk: false,
			FeeSpecialtyOrder: validSvc.newProp(validSvc.isNumber(data.FeeSpecialtyOrder) ? parseFloat(data.FeeSpecialtyOrder) : 0.00),
			FeeSpecialtyOrderPercent: validSvc.newProp(validSvc.isNumber(data.FeeSpecialtyOrderPercent) ? parseFloat(data.FeeSpecialtyOrderPercent) : 0.00),
			FeeSpecialtyOrderPercentMinAmt: validSvc.newProp(validSvc.isNumber(data.FeeSpecialtyOrderPercentMinAmt) ? parseFloat(data.FeeSpecialtyOrderPercentMinAmt) : 0.00),
			FeeSpecialtyOrderPercentMinAmtChk: false,
			FeeSpecialtyOrderPercentMaxAmt: validSvc.newProp(validSvc.isNumber(data.FeeSpecialtyOrderPercentMaxAmt) ? parseFloat(data.FeeSpecialtyOrderPercentMaxAmt) : 0.00),
			FeeSpecialtyOrderPercentMaxAmtChk: false,
			FeeSpecialtyGeneric: validSvc.newProp(validSvc.isNumber(data.FeeSpecialtyGeneric) ? parseFloat(data.FeeSpecialtyGeneric) : 0.00),
			FeeSpecialtyGenericPercent: validSvc.newProp(validSvc.isNumber(data.FeeSpecialtyGenericPercent) ? parseFloat(data.FeeSpecialtyGenericPercent) : 0.00),
			FeeSpecialtyGenericPercentMinAmt: validSvc.newProp(validSvc.isNumber(data.FeeSpecialtyGenericPercentMinAmt) ? parseFloat(data.FeeSpecialtyGenericPercentMinAmt) : 0.00),
			FeeSpecialtyGenericPercentMinAmtChk: false,
			FeeSpecialtyGenericPercentMaxAmt: validSvc.newProp(validSvc.isNumber(data.FeeSpecialtyGenericPercentMaxAmt) ? parseFloat(data.FeeSpecialtyGenericPercentMaxAmt) : 0.00),
			FeeSpecialtyGenericPercentMaxAmtChk: false,

			FeeAssayOrder: validSvc.newProp(validSvc.isNumber(data.FeeAssayOrder) ? parseFloat(data.FeeAssayOrder) : 0.00),
			FeeAssayOrderModel: !!data.FeeAssayOrderModel ? data.FeeAssayOrderModel : "UNIT",
			FeeAssayDispense: validSvc.newProp(validSvc.isNumber(data.FeeAssayDispense) ? parseFloat(data.FeeAssayDispense) : 0.00),
			FeeAssayDispenseModel: !!data.FeeAssayDispenseModel ? data.FeeAssayDispenseModel : "UNIT",

			SplittingSequence: validSvc.newProp(validSvc.isText(data.SplittingSequence) ? data.SplittingSequence : 'NONE'),

			UseGlobalNDCExcludeList  : data.UseGlobalNDCExcludeList === false ? 'no' : 'yes', //default  is yes
			UseManufacturerOptInList  : !!data.UseManufacturerOptInList ? 'yes' : 'no',
			ManufacturerOptInList: !!data.ManufacturerOptInList ? mfrList : [],
			UseInnerOuterPacks : !!data.UseInnerOuterPacks ? 'yes' : 'no',
			AllowAlt340BNDC: !!data.AllowAlt340BNDC ? 'yes': 'no',
			ForceCreditInvoicesToReview: !!data.ForceCreditInvoicesToReview ? 'yes' : 'no',
			AutoRejectZeroDollarInvoices: !!data.AutoRejectZeroDollarInvoices ? 'yes' : 'no',
			ReviewUnknownPO: data.ReviewUnknownPO === false ? 'no' : 'yes', // default is yes
			ReviewUnknownCreditPO: data.ReviewUnknownCreditPO === false ? 'no' : 'yes', // default is yes
			CreditAny: !!data.CreditAny ? 'yes' : 'no',
			AssayUsesAssayUnits : !! data.AssayUsesAssayUnits ? 'yes' : 'no',
			AmerisourceAssayIUEnabled : !! data.AmerisourceAssayIUEnabled ? 'yes' : 'no',
			PriceSelectWAC: priceSelectWAC ? 'yes' : 'no',
			PriceSelWACEqualGPO: !!data.PriceSelWACEqualGPO ? 'yes' : 'no',
			AutoAdjustWAC: !!data.AutoAdjustWAC? 'yes' : 'no',
			AutoAdjustWACPercent: validSvc.newProp(wacAdjustPercent),
			Federate810s: !!data.Federate810s ? 'yes' : 'no',
			UseBestCost: !!data.UseBestCost ? 'yes' : 'no',
			VerisaveUseATP: !!data.VerisaveUseATP ? 'yes' : 'no',
			ReviewSubstitute: !!data.ReviewSubstitute ? 'yes' : 'no',
			BestCostAllowGeneric: !!data.BestCostAllowGeneric ? 'yes' : 'no',
			BestCostAllowGforB: !!data.BestCostAllowGforB ? 'yes' : 'no',
			BestCostAllowBforG: !!data.BestCostAllowBforG ? 'yes' : 'no',
			AllowBulkItemForUnitDose: !!data.AllowBulkItemForUnitDose ? 'yes' : 'no',
			AllowUnitDoseForBulkItem: !!data.AllowUnitDoseForBulkItem ? 'yes' : 'no',
			// BestCostAllowGeneric: !!data.BestCostAllowGeneric ? 'yes' : 'no',

			DecrementGPOAccums: !!data.DecrementRemainderAccums ? 'yes' : 'no',

			CashCardParticipant: !!data.CashCardParticipant ? 'yes' :'no',
			RxCashCard: !!data.PharmacyPrivateCashCard ? 'yes' : 'no',
			FeeCashCard: validSvc.newProp(data.FeeCashCard),
			AccumAllGroups: data.AccumAllGroups,
			AccumShareGroups: shareList,
			AccumSplitGroups: splitList,

			Combine855s: !!data.Combine855s ? 'yes' : 'no',
			Timeout855s: validSvc.newProp(tmout),


			PreSplitRequired: !!data.PreSplitRequired ? 'yes' : 'no',
			PreSplitTimeout: validSvc.newProp(pretmout),
			PreSplitTimeoutAction: data.PreSplitTimeoutAction == 'CANCEL' ? 'CANCEL' : 'SPLIT',
			PreSplitDisableVerisave: data.PreSplitDisableVerisave,

			ApprovalRequired: !!data.ApprovalRequired ? 'yes' : 'no',
			ApprovalRequiredAllOrders: !!data.ApprovalRequiredAllOrders ? 'yes' : 'no',
			ApprovalTimeout: validSvc.newProp(apptmout),
			ApprovalTimeoutAction: data.ApprovalTimeoutAction == 'CANCEL' ? 'CANCEL' : 'PLACE',

			UseGPOReference: !!data.UseGPOReference ? 'yes' : 'no',
			GPOReferenceCE: validSvc.newProp(validSvc.isCE(data.GPOReferenceCE) ? data.GPOReferenceCE : 'NONE'),
			GPOReferencePH: validSvc.newProp(validSvc.isRX(data.GPOReferencePH) ? data.GPOReferencePH : 'NONE'),
			GPOReferenceVendor: validSvc.newProp(validSvc.isVEN(data.GPOReferenceVendor) ? data.GPOReferenceVendor : 'NONE'),

			SplitUnknownToWAC: !!data.SplitUnknownToWAC ? 'yes' : 'no',
			DisableSplitTrans: !!data.DisableSplitTrans ? 'yes' : 'no',  // default to yes, tbd...
			StrictTransReversals: !!data.StrictTransReversals ? 'yes' : 'no',  // default to yes, tbd...
			AllowAltVendorSplit: hasAltSplitVendors ? 'yes' : 'no',
			AltVendorList: propAltVendorList,
			AllowFederate850sToCE: hasFederate850sToCEVendors ? 'yes' : 'no',
			Federate850sToCEVendorList: propFederate850sToCEVendorList,
			Federated850sToCEFileExtensionX12 : !!data.Federated850sToCEFileExtensionX12 ? 'yes' : 'no',
			WacNeutEnabled: !!data.WacNeutEnabled ? 'yes' : 'no',
			CostCenter: validSvc.newProp(validSvc.isText(data.CostCenter) ? data.CostCenter : ''),
			WacNeutExternalMappings: wacNeutExternalMappingsVM(data.WacNeutExternalMappings),
			CdcPharmacy: validSvc.newProp(validSvc.isText(data.CdcPharmacy) ? data.CdcPharmacy : 'NONE'),

			CreatedBy: validSvc.isText(data.CreatedBy) ? data.CreatedBy : '',
			CreatedOn: validSvc.isDate(data.CreatedOn) ? data.CreatedOn : dtToday,
			EditTimestamp: validSvc.isText(data.ModifiedOn) ? data.ModifiedOn : utilSvc.dt.toServerDate(null),
			ReplaceNdcListCount : data.ReplaceNdcListCount,
			RollupCeUserCanViewClaims: !!data.RollupCeUserCanViewClaims ? 'yes' : 'no'
		};

		data.DispenseExpiration = data.DispenseExpiration || {};
		m.DispenseExpiration = data.DispenseExpiration;
		m.DispenseExpiration.CanOverride = !!data.DispenseExpiration.CanOverride ? 'yes' : 'no';
		m.DispenseExpiration.Overridden = !!data.DispenseExpiration.Overridden ? 'yes' : 'no';
		m.DispenseExpiration.Enabled = !!data.DispenseExpiration.Enabled ? 'yes' : 'no';
		m.DispenseExpiration.ParentsAllowOverride = !!data.DispenseExpiration.ParentsAllowOverride ? 'yes' : 'no';
		m.DispenseExpiration.ParentEnabled = !!data.DispenseExpiration.ParentEnabled ? 'yes' : 'no';
		m.DispenseExpiration.OverrideParent = !!data.DispenseExpiration.OverrideParent ? 'yes' : 'no';
		
		//Accumulation properties

		data.AccumDelay = data.AccumDelay || {};
		m.AccumDelay = data.AccumDelay;
		m.AccumDelay.CanOverride = !!data.AccumDelay.CanOverride ? 'yes' : 'no';
		m.Accumulate = data.Accumulate === false ? 'no' : 'yes';
		m.AccumDelay.Delay = validSvc.newProp(validSvc.isNumber(data.AccumDelay.Delay) ? data.AccumDelay.Delay : 0);
		m.AccumDelay.Overridden = !!data.AccumDelay.Overridden ? 'yes' : 'no';

		//parent
		m.RXParentID = data.RXParentID;
		data.AccumDelayParent = data.AccumDelayParent || {};
		m.AccumDelayParent = data.AccumDelayParent;
		m.AccumDelayParent.CanOverride = !!data.AccumDelayParent.CanOverride ? 'yes' : 'no';
		m.AccumDelayParent.Overridden = data.AccumDelayParent.Overridden;
		m.AccumDelayParent.Delay = validSvc.newProp(validSvc.isNumber(data.AccumDelayParent.Delay) ? data.AccumDelayParent.Delay : 0);

		// adjust variable fee min/max checkbox, value
		if(m.FeeOrderPercent.val > 0 && m.FeeOrderPercentMinAmt.val > 0) {
			m.FeeOrderPercentMinAmtChk = true;
		}
		else {
			m.FeeOrderPercentMinAmt.val = 0;
		}
		if(m.FeeOrderPercent.val > 0 && m.FeeOrderPercentMaxAmt.val > 0) {
			m.FeeOrderPercentMaxAmtChk = true;
		}
		else {
			m.FeeOrderPercentMaxAmt.val = 0;
		}
		if(m.FeeBrandPercent.val > 0 && m.FeeBrandPercentMinAmt.val > 0) {
			m.FeeBrandPercentMinAmtChk = true;
		}
		else {
			m.FeeBrandPercentMinAmt.val = 0;
		}
		if(m.FeeBrandPercent.val > 0 && m.FeeBrandPercentMaxAmt.val > 0) {
			m.FeeBrandPercentMaxAmtChk = true;
		}
		else {
			m.FeeBrandPercentMaxAmt.val = 0;
		}
		if(m.FeeSpecialtyOrderPercent.val > 0 && m.FeeSpecialtyOrderPercentMinAmt.val > 0) {
			m.FeeSpecialtyOrderPercentMinAmtChk = true;
		}
		else {
			m.FeeSpecialtyOrderPercentMinAmt.val = 0;
		}
		if(m.FeeSpecialtyOrderPercent.val > 0 && m.FeeSpecialtyOrderPercentMaxAmt.val > 0) {
			m.FeeSpecialtyOrderPercentMaxAmtChk = true;
		}
		else {
			m.FeeSpecialtyOrderPercentMaxAmt.val = 0;
		}
		if(m.FeeSpecialtyBrandPercent.val > 0 && m.FeeSpecialtyBrandPercentMinAmt.val > 0) {
			m.FeeSpecialtyBrandPercentMinAmtChk = true;
		}
		else {
			m.FeeSpecialtyBrandPercentMinAmt.val = 0;
		}
		if(m.FeeSpecialtyBrandPercent.val > 0 && m.FeeSpecialtyBrandPercentMaxAmt.val > 0) {
			m.FeeSpecialtyBrandPercentMaxAmtChk = true;
		}
		else {
			m.FeeSpecialtyBrandPercentMaxAmt.val = 0;
		}
		if(m.FeeGenericPercent.val > 0 && m.FeeGenericPercentMinAmt.val > 0) {
			m.FeeGenericPercentMinAmtChk = true;
		}
		else {
			m.FeeGenericPercentMinAmt.val = 0;
		}
		if(m.FeeGenericPercent.val > 0 && m.FeeGenericPercentMaxAmt.val > 0) {
			m.FeeGenericPercentMaxAmtChk = true;
		}
		else {
			m.FeeGenericPercentMaxAmt.val = 0;
		}
		if(m.FeeSpecialtyGenericPercent.val > 0 && m.FeeSpecialtyGenericPercentMinAmt.val > 0) {
			m.FeeSpecialtyGenericPercentMinAmtChk = true;
		}
		else {
			m.FeeSpecialtyGenericPercentMinAmt.val = 0;
		}
		if(m.FeeSpecialtyGenericPercent.val > 0 && m.FeeSpecialtyGenericPercentMaxAmt.val > 0) {
			m.FeeSpecialtyGenericPercentMaxAmtChk = true;
		}
		else {
			m.FeeSpecialtyGenericPercentMaxAmt.val = 0;
		}
		// console.log('Enabled for Vendor: ', m.ExportAccumsForVendorEnabled);
		// console.log('Enabled for Cencora: ', m.ExportAccumsForCencora);
		// console.log('Enabled for Trulla: ', m.ExportAccumsForTrulla);
		// // console.log('ExportAccumsForTrullaChk: ', m.ExportAccumsForTrullaChk);
		// // console.log('ExportAccumsForCencoraChk: ', m.ExportAccumsForCencoraChk);
		// verisave percent fee checkmarks
		if(vsModelIsPercent) {
			m.FeeVerisaveOrderPercentMinAmt.chk = m.FeeVerisaveOrderPercent.val > 0 && m.FeeVerisaveOrderPercentMinAmt.val > 0;
			if(!m.FeeVerisaveOrderPercentMinAmt.chk) {
				m.FeeVerisaveOrderPercentMinAmt.val = 0;
			}
			m.FeeVerisaveOrderPercentMaxAmt.chk = m.FeeVerisaveOrderPercent.val > 0 && m.FeeVerisaveOrderPercentMaxAmt.val > 0;
			if(!m.FeeVerisaveOrderPercentMaxAmt.chk) {
				m.FeeVerisaveOrderPercentMaxAmt.val = 0;
			}	
		}

		// add flattened feature claims
		var featClaims = Array.isArray(data.FeatureClaims) ? data.FeatureClaims : [];
		m.UserCanAddInvoice = 'no';
		m.UserCanViewClaims = 'no';
		m.UserCanMatchClaims = 'no';
		m.UserCanCreateOrders = 'no';
		for(var f = 0; f < featClaims.length; f++) {
			switch(featClaims[f].Claim) {
				case 'invoice.add':
					m.UserCanAddInvoice = !!featClaims[f].Allow ? 'yes' : 'no';
					break;
				case 'ops.dispenses':
					m.UserCanViewClaims = !!featClaims[f].Allow ? 'yes' : 'no';
					break;
				case 'ops.dispenses.match':
					m.UserCanMatchClaims = !!featClaims[f].Allow ? 'yes' : 'no';
					break;
				case 'orders.cp':
					m.UserCanCreateOrders = !!featClaims[f].Allow ? 'yes' : 'no';
					break;
			}
		}
		if(m.UserCanViewClaims == 'no') {
			m.UserCanMatchClaims = 'no'; // dependent on View Claims
		}

		var code = '';
		for (i = 0; i < m.Require340BBasisCostFFSCodes.length; i++) {
			code = m.Require340BBasisCostFFSCodes[i];
			m['RequireFFSCode' + code] = true;
		}

		for (i = 0; i < m.Require340BBasisCostMCOCodes.length; i++) {
			code = m.Require340BBasisCostMCOCodes[i];
			m['RequireMCOCode' + code] = true;
		}

		return m;

	}


	/**
	 *    GET INIT DATA
	 */

	function getInitData() {

		// gather all server data for affiliaiton editing

		var defer = $q.defer();
		_currentPurl = 'affrefresh';
		apiService.refreshUser().then(okInitData, errInitData);

		function okInitData(r) {
			_currentPurl = 'admin/vendor/list';
			apiService.post(_currentPurl, {}).then(okGetVendorDrop, errInitData);
		}

		function okGetVendorDrop(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + '/repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({
				vendors: Array.isArray(r.data.Entity) ? r.data.Entity : []
			});

		}

		function errInitData(r) {
			if(r !== null) {
				errSvc.warn('Affiliations request failed', _currentPurl + '/affRepo.getInitData', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    AFFILIATION SILENT REFRESH
	 *    after affiliate create / updates or status, refresh the user's affiliations in session
	 */

	function refreshUserSilent() {

		// refresh login affs silent
		// note: don't care about the response, just doing a refresh for other features

		apiService.refreshUser().then(okUserRefreshSilent, errUserRefreshSilent);

		function okUserRefreshSilent(r) {
			// do nothing
		}

		function errUserRefreshSilent(r) {
			if(r !== null) {
				errSvc.warn('Affiliations refresh failed', 'affRepo.errUserRefreshSilent', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    GET LIST
	 */

	function getList(ceid, rxid) {

		// params
		if(!validSvc.isCE(ceid) && !validSvc.isRX(rxid)) {
			throw new Error('affRepo.getList, ceid and rxid are missing');
		}

		// strip off 'NONE' values if empty
		var ceidCheck = validSvc.isCE(ceid) ? ceid : '',
			rxidCheck = validSvc.isRX(rxid) ? rxid : '';

		_currentPurl = 'admin/affiliation/list';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceidCheck],
				RXID: [rxidCheck]
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('Id')]
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(getOk, getErr);

		function getOk(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return query and data
			defer.resolve(r.data.Entity);

		}

		function getErr(r) {

			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);

		}

		return defer.promise;

	}


	/**
	 *    GET DETAIL
	 */

	function getDetail(ceid, rxid) {

		// params
		if(!validSvc.isCE(ceid) || !validSvc.isRX(rxid)) {
			throw new Error('affRepo.getDetail, ceid or rxid are missing');
		}

		_currentPurl = 'admin/affiliation/get';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid],
				RXID: [rxid]
			}
		};

		apiService.post(_currentPurl, apiRequest).then(getDetailOk, getDetailErr);

		function getDetailOk(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return data
			defer.resolve(modelVM(r.data.Entity));
		}

		function getDetailErr(r) {
			if(r != null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    CREATE / UPDATE
	 */

	function create(model) {
		return upsert('admin/affiliation/save', model);
	}

	function update(model) {
		return upsert('admin/affiliation/save', model);
	}

	function upsert(purl, model) {

		_currentPurl = purl;
		_modelPending = model;
		var defer = $q.defer();

		var i = 0,
			shareList = [],
			splitList = [];

		for(i = 0; i < model.AccumShareGroups.length; i++) {
			shareList.push(model.AccumShareGroups[i].val);
		}
		for(i = 0; i < model.AccumSplitGroups.length; i++) {
			splitList.push(model.AccumSplitGroups[i].val);
		}

		// dispense expiration
		var dispExp = model.DispenseExpiration;
		var maxDispAge = parseInt(dispExp.MaxDispenseAge);

		// build feature claims array
		var featClaims = [];
		if(model.UserCanAddInvoice == 'yes') {
			featClaims.push({Claim:'invoice.add', UserType:'RX', Allow:true});
		}
		if(model.UserCanViewClaims == 'yes') {
			featClaims.push({Claim:'ops.dispenses', UserType:'CE', Allow: true});
			if(model.UserCanMatchClaims == 'yes') {
				featClaims.push({Claim:'ops.dispenses.match', UserType:'CE', Allow: true});
			}
		}
		if(model.UserCanCreateOrders == 'yes') {
			featClaims.push({Claim:'orders.cp', UserType:'CE', Allow: true});
		}

		//To reset values on Update
		if (model.OrderFeeModel == "ORDERQUANTITY") {
			model.FeeOrderPercent.val = 0;
			model.FeeOrderPercentMaxAmt.val = 0;
			model.FeeOrderPercentMinAmt.val = 0;
		}
		if (model.FeeSpecialtyOrderFeeModel == "ORDERQUANTITY") {
			model.FeeSpecialtyOrderPercent.val = 0;
			model.FeeSpecialtyOrderPercentMinAmt.val= 0;
			model.FeeSpecialtyOrderPercentMaxAmt.val = 0;
		}
		var mfrList = [];
		for(i = 0; i < model.ManufacturerOptInList.length; i++) {
			mfrList.push({
				LabelerId: model.ManufacturerOptInList[i].LabelerId,
				Name: model.ManufacturerOptInList[i].Name,
				StartDate: model.ManufacturerOptInList[i].StartDate,
			});
			if (model.ManufacturerOptInList[i].StartDate != null) {
				mfrList[i].StartDate = new Date(utilSvc.dt.toServerString(mfrList[i].StartDate));
			}
		}

		// alt split vendors
		var hasAltSplitVendors = model.AllowAltVendorSplit == 'yes' && model.AltVendorList.vals.length > 0;

		// federate 850s to CE vendors
		var hasFederate850sToCEVendors = model.AllowFederate850sToCE == 'yes' && model.Federate850sToCEVendorList.vals.length > 0;


		// verisave fee model
		var vsModelIsFlat = model.FeeVerisaveModel == 'FLAT',
			vsModelIsPercent = model.FeeVerisaveModel == 'PERCENTAGESAVINGS';


		// convert FFS/MCO code selections to arrays
		model.Require340BBasisCostFFSCodes = [];
		if (!!model.RequireFFSCode08) {
			model.Require340BBasisCostFFSCodes.push('08');
		}

		if (!!model.RequireFFSCode05) {
			model.Require340BBasisCostFFSCodes.push('05');
		}

		model.Require340BBasisCostMCOCodes = [];
		if (!!model.RequireMCOCode08) {
			model.Require340BBasisCostMCOCodes.push('08');
		}

		if (!!model.RequireMCOCode05) {
			model.Require340BBasisCostMCOCodes.push('05');
		}

		// console.log("model.ExportAccumsForVendorEnabled: ", model.ExportAccumsForVendorEnabled);
		// console.log("model.ExportAccumsForTrulla ", model.ExportAccumsForTrulla);
		// console.log("model.ExportAccumsForCencora: ", model.ExportAccumsForCencora);
		var apiRequest = {
			Context: {
				CEID: [model.CE],
				RXID: [model.RX.val]
			},
			Entity: {
				AffilBizModel: model.AffilBizModel.val,
				AffilName: model.AffilName.val,
				CeOwnedPharmacy: model.CeOwnedPharmacy == 'yes',
				ProgramAdmin: model.ProgramAdmin.val,

				ContractDate: utilSvc.dt.toServerDateExactPSTNoon(model.ContractDate.val),
				ContractTerminationDate: utilSvc.dt.toServerDateExactPSTNoon(model.ContractTerminationDate.val),
				TerminationCause: model.TerminationCause.val,

				// Own Use
				Disable340BMatching: model.Enable340BMatching == 'no',
				OwnUseEnableMatching: model.EnableOwnUseMatching == 'yes',
				// GPO Matching
				EnableGPOMatching: model.EnableGPOMatching.val == 'yes',
				OwnUseAccumulationDelay: parseInt(model.OwnUseAccumulationDelay.val),
				GPOMatchDelay: parseInt(model.GPOMatchDelay.val),
				// Match by file
				EnableMatchByFile: model.EnableMatchByFile.val == 'yes',
				IncludeDispenseBasedEligibility: model.IncludeDispenseBasedEligibility.val == 'yes',

				// GPO remainder accums
				DecrementRemainderAccums: model.DecrementGPOAccums == 'yes',
				// Claim Federation
				ClaimFederationStart: utilSvc.dt.toServerDateExactPSTNoon(model.ClaimFederationStart.val),

				Pricing: {
					Enabled: model.PricingEnabled == 'yes',
					Overridden: model.PricingOverride == 'yes',
					Model: model.PricingModel.val,
					Rate: parseFloat(model.PricingRate.val)
				},

				Billing: {
					Enabled: model.BillEnabled == 'yes',
					Overridden: model.BillOverride == 'yes',
					Export: model.BillExport == 'yes',
					ExportFees: model.BillExportFees == 'yes',
					ExportDrugCost: model.BillExportDrugCost == 'yes'
				},
				ExportAccumsForVendor: {
					Enabled: model.ExportAccumsForVendorEnabled == 'yes',
					EnabledForTrulla : model.ExportAccumsForTrulla,
					EnabledForCencora : model.ExportAccumsForCencora,
				},
				VisitEligDaysBefore: parseInt(model.VisitEligDaysBefore.val),
				VisitEligDaysAfter: parseInt(model.VisitEligDaysAfter.val),

				DispenseExpiration: {
					MaxDispenseAge: maxDispAge,
					Enabled: dispExp.Enabled == 'yes' && maxDispAge > 0,
					CanOverride: dispExp.CanOverride == 'yes',  
					OverrideParent: dispExp.OverrideParent == 'yes',  
					ParentsAllowOverride: dispExp.ParentsAllowOverride == 'yes',
					ParentEnabled: dispExp.ParentEnabled == 'yes'
				},

				CeMatchReview: model.CeMatchReview == 'yes',
				UseCeMatchReviewNdcList: model.UseCeMatchReviewNdcList == 'yes',

				ValidateClaimsModifier: model.ValidateClaimsModifier.val == 'yes',
				Require340BSubClarifyMod: model.Require340BSubClarifyMod == 'yes',
				Require340BBasisCostMod: model.Require340BBasisCostMod == 'yes',

				ProfitableOnly: model.ProfitableOnly == 'yes',
				DispenseFeeModel: model.DispenseFeeModel,
				DispenseFeeValueType: model.DispenseFeeValueType,
       			NdcListFeesEnabled: model.NdcListFeesEnabled,

				OrderFeeModel: model.OrderFeeModel,

				MinClaimValue: parseFloat(model.MinClaimValue.val),

				FeeVerityMonthly: parseFloat(model.FeeVerityMonthly.val),
				FeeEligibility: parseFloat(model.FeeEligibility.val),
				FeeBrand: parseFloat(model.FeeBrand.val),
				FeeBrandPercent: parseFloat(model.FeeBrandPercent.val),
				FeeBrandPercentMinAmt: parseFloat(model.FeeBrandPercentMinAmt.val),
				FeeBrandPercentMaxAmt: parseFloat(model.FeeBrandPercentMaxAmt.val),
				FeeOrder: parseFloat(model.FeeOrder.val),
				FeeOrderPercent: parseFloat(model.FeeOrderPercent.val),
				FeeOrderPercentMinAmt: parseFloat(model.FeeOrderPercentMinAmt.val),
				FeeOrderPercentMaxAmt: parseFloat(model.FeeOrderPercentMaxAmt.val),

				FeeVerisaveModel: vsModelIsFlat || vsModelIsPercent ? model.FeeVerisaveModel : '',
				FeeVerisaveFlat: vsModelIsFlat ? parseFloat(model.FeeVerisaveFlat.val) : 0,
				FeeVerisaveOrderPercent: vsModelIsPercent ? parseFloat(model.FeeVerisaveOrderPercent.val) : 0,
				FeeVerisaveOrderPercentMinAmt: vsModelIsPercent && model.FeeVerisaveOrderPercent.val > 0 ? parseFloat(model.FeeVerisaveOrderPercentMinAmt.val) : 0,
				FeeVerisaveOrderPercentMaxAmt: vsModelIsPercent && model.FeeVerisaveOrderPercent.val > 0 ? parseFloat(model.FeeVerisaveOrderPercentMaxAmt.val) : 0,
	
				FeeGeneric: parseFloat(model.FeeGeneric.val),
				FeeGenericPercent: parseFloat(model.FeeGenericPercent.val),
				FeeGenericPercentMinAmt: parseFloat(model.FeeGenericPercentMinAmt.val),
				FeeGenericPercentMaxAmt: parseFloat(model.FeeGenericPercentMaxAmt.val),
				FeeSupplyDaysCapped: model.FeeSupplyDaysCapped == 'yes',
				FeeSupplyDaysFirstMax: parseFloat(model.FeeSupplyDaysFirstMax.val),
				FeeSupplyDaysFirstDay: parseInt(model.FeeSupplyDaysFirstDay.val),
				FeeSupplyDaysSecondMax: parseFloat(model.FeeSupplyDaysSecondMax.val),
				FeeSupplyDaysSecondDay: parseInt(model.FeeSupplyDaysSecondDay.val),
				FeeSupplyDaysLastMax: parseFloat(model.FeeSupplyDaysLastMax.val),

				GenericOrderable: model.GenericOrderable.val == 'yes',
				GenericEffectiveDate: utilSvc.dt.toServerDateExactPSTNoon(model.GenericEffectiveDate.val),
				CIIOrderable: model.CIIOrderable == 'yes',

				MedicaidFFSCarveIn: model.MedicaidFFSCarveIn == 'yes',
				MedicaidMCOCarveIn: model.MedicaidMCOCarveIn == 'yes',
				ValidateMedicaidClaims: model.ValidateMedicaidClaims.val == 'yes',
				Require340BSubClarifyFFS: model.Require340BSubClarifyFFS == 'yes',
				Require340BBasisCostFFS: model.Require340BBasisCostFFS == 'yes',
				Require340BBasisCostFFSCodes: model.Require340BBasisCostFFSCodes,
				Require340BSubClarifyMCO: model.Require340BSubClarifyMCO == 'yes',
				Require340BBasisCostMCO: model.Require340BBasisCostMCO == 'yes',
				Require340BBasisCostMCOCodes: model.Require340BBasisCostMCOCodes,

				//IRA
				IRAOptOut : model.IRAOptOut == 'yes',
				IRAOptOutSome : model.IRAOptOutSome == 'yes',
				MRebateOptIn: model.MRebateOptIn == 'yes',
				MRebateOptInSome: model.MRebateOptInSome == 'yes',
				MRebateAutoOrder: model.MRebateAutoOrder == 'yes',
				//Fees
				FeeSpecialtyOrderFeeModel: model.FeeSpecialtyOrderFeeModel,
				FeeSpecialtyDispenseFeeModel: model.FeeSpecialtyDispenseFeeModel,
				FeeSpecialtyDispenseFeeValueType: model.FeeSpecialtyDispenseFeeValueType,

				FeeSpecialtyBrand: parseFloat(model.FeeSpecialtyBrand.val),
				FeeSpecialtyBrandPercent: parseFloat(model.FeeSpecialtyBrandPercent.val),
				FeeSpecialtyBrandPercentMinAmt: parseFloat(model.FeeSpecialtyBrandPercentMinAmt.val),
				FeeSpecialtyBrandPercentMaxAmt: parseFloat(model.FeeSpecialtyBrandPercentMaxAmt.val),
				FeeSpecialtyOrder: parseFloat(model.FeeSpecialtyOrder.val),
				FeeSpecialtyOrderPercent: parseFloat(model.FeeSpecialtyOrderPercent.val),
				FeeSpecialtyOrderPercentMinAmt: parseFloat(model.FeeSpecialtyOrderPercentMinAmt.val),
				FeeSpecialtyOrderPercentMaxAmt: parseFloat(model.FeeSpecialtyOrderPercentMaxAmt.val),
				FeeSpecialtyGeneric: parseFloat(model.FeeSpecialtyGeneric.val),
				FeeSpecialtyGenericPercent: parseFloat(model.FeeSpecialtyGenericPercent.val),
				FeeSpecialtyGenericPercentMinAmt: parseFloat(model.FeeSpecialtyGenericPercentMinAmt.val),
				FeeSpecialtyGenericPercentMaxAmt: parseFloat(model.FeeSpecialtyGenericPercentMaxAmt.val),

				FeeAssayOrder: parseFloat(model.FeeAssayOrder.val),
				FeeAssayOrderModel: model.FeeAssayOrderModel,
				FeeAssayDispense: parseFloat(model.FeeAssayDispense.val),
				FeeAssayDispenseModel: model.FeeAssayDispenseModel,

				SplittingSequence: model.SplittingSequence.val != 'NONE' ? model.SplittingSequence.val : '',

				ForceCreditInvoicesToReview: model.ForceCreditInvoicesToReview == 'yes',
				AutoRejectZeroDollarInvoices: model.AutoRejectZeroDollarInvoices == 'yes',
				ReviewUnknownPO: model.ReviewUnknownPO == 'yes',
				ReviewUnknownCreditPO: model.ReviewUnknownCreditPO == 'yes',
				CreditAny: model.CreditAny == 'yes',
				AssayUsesAssayUnits: model.AssayUsesAssayUnits == 'yes',
				AmerisourceAssayIUEnabled: model.AmerisourceAssayIUEnabled == 'yes',
				PriceSelectWAC: model.PriceSelectWAC == 'yes',
				PriceSelWACEqualGPO: model.PriceSelWACEqualGPO == 'yes',
				Federate810s: model.Federate810s == 'yes',
				UseBestCost: model.UseBestCost == 'yes',
				VerisaveUseATP: model.VerisaveUseATP == 'yes',
				ReviewSubstitute: model.ReviewSubstitute == 'yes',
				BestCostAllowGeneric: model.BestCostAllowGeneric == 'yes',
				BestCostAllowGforB: model.BestCostAllowGforB == 'yes',
				BestCostAllowBforG: model.BestCostAllowBforG == 'yes',	
				BestCostPckSizeSubstitution: model.BestCostPckSizeSubstitution == 'yes',
				BestCostPckFormSubstitution: model.BestCostPckFormSubstitution == 'yes',
				AllowBulkItemForUnitDose: model.AllowBulkItemForUnitDose == 'yes',
				AllowUnitDoseForBulkItem: model.AllowUnitDoseForBulkItem == 'yes',
				// BestCostAllowGeneric: !!data.BestCostAllowGeneric ? 'yes' : 'no',

				AccumShareGroups: shareList,
				AccumSplitGroups: splitList,

				AccumDelay : { 
					Overridden : model.AccumDelay.Overridden =='yes',
					CanOverride: model.AccumDelay.CanOverride =='yes',
					Delay: parseInt(model.AccumDelay.Delay.val),
				},

				Combine855s: model.Combine855s == 'yes',
				Timeout855s: parseInt(model.Timeout855s.val),

				PreSplitRequired: model.PreSplitRequired == 'yes',
				PreSplitTimeout: parseInt(model.PreSplitTimeout.val),
				PreSplitTimeoutAction: model.PreSplitTimeoutAction,
				PreSplitDisableVerisave: !!model.PreSplitDisableVerisave,
				ApprovalRequired: model.ApprovalRequired == 'yes',
				ApprovalRequiredAllOrders: model.ApprovalRequiredAllOrders == 'yes',
				ApprovalTimeout: parseInt(model.ApprovalTimeout.val),
				ApprovalTimeoutAction: model.ApprovalTimeoutAction,

				SplitUnknownToWAC: model.SplitUnknownToWAC == 'yes',
				DisableSplitTrans: model.DisableSplitTrans == 'yes',
				StrictTransReversals: model.StrictTransReversals == 'yes',
			    AutoAdjustWAC: model.AutoAdjustWAC=='yes',
			    AutoAdjustWACPercent: parseInt(model.AutoAdjustWACPercent.val),
				AllowAltVendorSplit: hasAltSplitVendors,
				AltVendorList: hasAltSplitVendors ? model.AltVendorList.vals : [],
				AllowFederate850sToCE: hasFederate850sToCEVendors,
				Federate850sToCEVendorList: hasFederate850sToCEVendors ? model.Federate850sToCEVendorList.vals : [],
				Federated850sToCEFileExtensionX12 : model.Federated850sToCEFileExtensionX12 == 'yes',
				ReferencePriceProxy : model.ReferencePriceProxy == 'yes',
				CashCardParticipant: model.CashCardParticipant =='yes',
				UseGlobalNDCExcludeList: model.UseGlobalNDCExcludeList =='yes',
				UseManufacturerOptInList: model.UseManufacturerOptInList == 'yes',
				ManufacturerOptInList: mfrList,
				UseInnerOuterPacks: model.UseInnerOuterPacks =='yes',
				AllowAlt340BNDC: model.AllowAlt340BNDC == 'yes',
				FeeCashCard: parseFloat(model.FeeCashCard.val),

				WacNeutEnabled: model.WacNeutEnabled == 'yes',
				CostCenter: model.CostCenter.val, 
				WacNeutExternalMappings: wacNeutExternalMappingsAPI(model.WacNeutExternalMappings),
				CdcPharmacy: model.CdcPharmacy.val == 'NONE' ? '' : model.CdcPharmacy.val,

				UseGPOReference: model.UseGPOReference == 'yes',
				GPOReferenceCE: model.GPOReferenceCE.val == 'NONE' ? '' : model.GPOReferenceCE.val,
				GPOReferencePH: model.GPOReferencePH.val == 'NONE' ? '' : model.GPOReferencePH.val,
				GPOReferenceVendor: model.GPOReferenceVendor.val == 'NONE' ? '' : model.GPOReferenceVendor.val,

				FeatureClaims: featClaims,

				EditTimestamp: model.EditTimestamp
			}
		};

		// call api
		// console.log("~~~~~apiRequest~~~~~");	
		// console.log("m.ExportAccumsForVendor.Enabled: ", apiRequest.Entity.ExportAccumsForVendor.Enabled);
		// console.log("m.EnabledForTrulla: ", apiRequest.Entity.ExportAccumsForVendor.EnabledForTrulla);
		// console.log("m.EnabledForCencora: ", apiRequest.Entity.ExportAccumsForVendor.EnabledForCencora);
		apiService.post(_currentPurl, apiRequest).then(upsertOk, upsertErr);

		function upsertOk(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function upsertErr(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapApiErrorsToModel(r, _modelPending);
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				if(fieldName.indexOf('GROUP_') === 0) {

					// accum groups list property, strip pre-fix
					fieldName = fieldName.substr(6);

					var shareList = m.AccumShareGroups,
						splitList = m.AccumSplitGroups,
						foundGrp = false,
						ii = 0;

					// look in share groups
					for(ii = 0; ii < shareList.length; ii++) {
						if(shareList[ii].val == fieldName) {
							shareList[ii].fail = 'yes';
							shareList[ii].msg = entity.Fields[i].Rule;
							foundGrp = true;
						}
					}

					// look in split groups
					for(ii = 0; ii < splitList.length; ii++) {
						if(splitList[ii].val == fieldName) {
							splitList[ii].fail = 'yes';
							splitList[ii].msg = entity.Fields[i].Rule;
							foundGrp = true;
						}
					}

					if(!foundGrp) {
						throw new Error('affRepo.mapApiErrorsToModel, api 422 group name not found: GROUP_' + fieldName);
					}

				}
				else {

					// parse model for property name
					fieldObj = utilSvc.obj.findChildProp(m, fieldName);
					if(fieldObj === undefined) {
						throw new Error('affRepo.mapApiErrorsToModel, api 422 account field name not found: ' + fieldName, _currentPurl, 422);
					}

					// set failed state
					fieldObj.fail = 'yes';
					fieldObj.msg = entity.Fields[i].Rule;
				}

			}

			return m;

		}

		return defer.promise;
	}


	/**
	 *    STATUS CHANGE
	 */

	function statusChange(ceid, rxid, status) {

		// params
		if(!validSvc.isCE(ceid) || !validSvc.isRX(rxid)) {
			throw new Error('affRepo.statusChange, ceid or rxid is missing');
		}

		// set purl
		switch(status) {

			case 'ONBOARDING':
				_currentPurl = 'admin/affiliation/status/onboarding';
				break;
			case 'ACTIVE':
				_currentPurl = 'admin/affiliation/status/active';
				break;
			case 'INACTIVE':
				_currentPurl = 'admin/affiliation/status/inactive';
				break;

			case 'DELETED':
				_currentPurl = 'admin/affiliation/status/deleted';
				break;

			default:
				throw new Error('affRepo.statusChange, status unknown: ' + status);
		}

		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {
				CEID: [ceid],
				RXID: [rxid]
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okStat, errStat);

		function okStat(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update affiliations
			refreshUserSilent();

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function errStat(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else {
				throw new Error('affRepo.errStat, unexpected error result');
			}

		}

		return defer.promise;

	}

	/**
	 *    UPDATE MAUFACTURER RESTRICTION LIST
	 */

	 function mfrUpdate(model, reeval) {
		_currentPurl = 'admin/affiliation/manufacturer/save';
		_modelPending = model;
		var defer = $q.defer();

		var mfrList = [];
		for(var i = 0; i < model.ManufacturerOptInList.length; i++) {
			mfrList.push({
				LabelerId: model.ManufacturerOptInList[i].LabelerId,
				Name: model.ManufacturerOptInList[i].Name,
				StartDate: model.ManufacturerOptInList[i].StartDate,
			});
			if (model.ManufacturerOptInList[i].StartDate != null) {
				mfrList[i].StartDate = new Date(utilSvc.dt.toServerString(mfrList[i].StartDate));
			}
		}

		var apiRequest = {
			Context: {
				CEID: [model.CE],
				RXID: [model.RX.val]
			},
			Entity: {
				ManufacturerOptInList: mfrList,
				ReEval: reeval,
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(upsertOk, upsertErr);

		function upsertOk(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function upsertErr(r) {
			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapApiErrorsToModel(r, _modelPending);
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

		}

		function mapApiErrorsToModel(r, m) {
			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				if(fieldName.indexOf('GROUP_') === 0) {

					// accum groups list property, strip pre-fix
					fieldName = fieldName.substr(6);

					var shareList = m.AccumShareGroups,
						splitList = m.AccumSplitGroups,
						foundGrp = false,
						ii = 0;

					// look in share groups
					for(ii = 0; ii < shareList.length; ii++) {
						if(shareList[ii].val == fieldName) {
							shareList[ii].fail = 'yes';
							shareList[ii].msg = entity.Fields[i].Rule;
							foundGrp = true;
						}
					}

					// look in split groups
					for(ii = 0; ii < splitList.length; ii++) {
						if(splitList[ii].val == fieldName) {
							splitList[ii].fail = 'yes';
							splitList[ii].msg = entity.Fields[i].Rule;
							foundGrp = true;
						}
					}

					if(!foundGrp) {
						throw new Error('affRepo.mapApiErrorsToModel, api 422 group name not found: GROUP_' + fieldName);
					}

				}
				else {

					// parse model for property name
					fieldObj = utilSvc.obj.findChildProp(m, fieldName);
					if(fieldObj === undefined) {
						throw new Error('affRepo.mapApiErrorsToModel, api 422 account field name not found: ' + fieldName, _currentPurl, 422);
					}

					// set failed state
					fieldObj.fail = 'yes';
					fieldObj.msg = entity.Fields[i].Rule;
				}

			}

			return m;

		}

		return defer.promise;
	}


	/**
	 *    VENDOR LIST, VENDOR GET
	 *    note: vendor get functions are provided by the affOptionsRepo (getVendorList, getVendor)
	 */


	/**
	 *    VENDOR: CREATE / UPDATE
	 */

	function vendorCreate(context, model) {
		return vendorUpsert('admin/affiliation/orderaccount/save', context, model, true);
	}

	function vendorUpdate(context, model) {
		return vendorUpsert('admin/affiliation/orderaccount/save', context, model);
	}

	function autoOrderConfigAPI(model) {
		return {
			AutoOrdering: model.Enabled == 'on',
			OrderSchedule: {
				Type: model.Type,
				MonthOption: model.MonthOption,
				DayOfMonth: model.DayOfMonth,
				WeekOfMonth: model.WeekOfMonth,
				Occurs: model.Occurs,
				Days: model.Weekdays
			},
			AutoPlaceSendEDI: model.AutoPlaceSendEDI == 'yes',
			PlaceNow: model.PlaceNow == 'yes'
		};
	}

	function vendorUpsert(purl, context, model, isCreate) {
		
		_currentPurl = purl;
		_vendorPending = model;
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [context.CE],
				RXID: [context.RX]
			},
			Params: {
				Create: !!isCreate
			},
			Entity: {
				Id: model.Id,
				ObjectState: model.ObjectState.val,
				Vendor: model.Vendor.val,
				AccumulatorType: model.AccumulatorType.val,

				StandardAutoOrderConfig: autoOrderConfigAPI(model.StandardAutoOrder),
				SpecialtyAutoOrderConfig: autoOrderConfigAPI(model.SpecialtyAutoOrder),
				DropShipAutoOrderConfig: autoOrderConfigAPI(model.DropShipAutoOrder),

				DropShip : { 
					Overridden : model.DropShipOverridden =='yes',
					CanOverride: model.DropShipCanOverride =='yes',
					DropShipOrderable: model.DropShipExclude =='no',
				},
				
				SendOrdersForReview: model.SendOrdersForReview.val == 'yes',
				
				SendOrderstoExtParty: model.SendOrderstoExtParty.val == 'yes',
				ReleaseOnOrderEDI855: model.ReleaseOnOrderEDI855.val == 'yes',
				OnOrderReleaseAckCodeExclusionList: !!model.OnOrderReleaseAckCodeExclusionList ? model.OnOrderReleaseAckCodeExclusionList : [],
				ExtPartyFolder: model.ExtPartyFolder.val,

				VendorAccount: model.VendorAccount.val,
				AccountAlias: model.AccountAlias.val,
				SenderId: model.SenderId.val,
				ReceiverId: model.ReceiverId.val,

				ReservationExpiration: parseInt(model.ReservationExpiration.val),
				VendorOrderConfig: model.VendorOrderConfig,

				ExcludeOrderSuffixOutbound: model.ExcludeOrderSuffixOutbound.val == 'yes',

				AllowDirectReplenish: model.AllowDirectReplenish.val == 'yes',
				CreditReplenishment: model.CreditReplenishment.val == 'yes',
				UseISPSuffix: model.UseISPSuffix.val == 'yes',
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okVendorUpsert, errVendorUpsert);

		function okVendorUpsert(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update affiliations
			refreshUserSilent();

			// task: return entity id
			defer.resolve({});
		}

		function errVendorUpsert(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				r.model = mapApiErrorsToModel(r, _vendorPending);
				defer.reject(r);
			}
			else {
				throw new Error('errVendorUpsert, unexpected error result');
			}

		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);
				if(fieldObj === undefined) {
					throw new Error('affRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
				}

				// set failed state
				fieldObj.fail = 'yes';
				fieldObj.msg = entity.Fields[i].Rule;

			}

			return m;

		}

		return defer.promise;
	}


	/**
	 *    VENDOR DELETE
	 */

	function vendorDelete(ceid, rxid, vendor, accumType) {

		// params
		if(!validSvc.isCE(ceid) || !validSvc.isRX(rxid) || !validSvc.isText(vendor) || !validSvc.isText(accumType)) {
			throw new Error('affRepo.vendorDelete, ceid / rxid / vendor and accumType are required');
		}

		_currentPurl = 'admin/affiliation/orderaccount/delete';
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [ceid],
				RXID: [rxid]
			},
			Params: {
				Vendor: vendor,
				AccumulatorType: accumType
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okVendorDelete, errVendorDelete);

		function okVendorDelete(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update affiliations
			refreshUserSilent();

			// task: return entity id
			defer.resolve({});
		}

		function errVendorDelete(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				errSvc.error('Api request failed with unknown error', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}

		}

		return defer.promise;

	}


	/**
	 *    VENDOR PRIORITY
	 */

	function vendorPriority(context, model, SplittingSequence) {

		_currentPurl = 'admin/affiliation/splitsequence/save';
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [context.CE],
				RXID: [context.RX]
			},
			Entity: {
				Params: {
					SplittingSequence: SplittingSequence
				}
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okVendorPri, errVendorPri);

		function okVendorPri(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// task: return entity id
			defer.resolve({});
		}

		function errVendorPri(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				throw new Error('errVendorPri, unexpected error result');
			}

		}

		return defer.promise;
	}


	/**
	 *    CLONE AFFILIATION
	 */

	function cloneToRX(ceid, rxid, cloneToRX) {

		// params
		if(!validSvc.isCE(ceid) || !validSvc.isRX(rxid) || !validSvc.isRX(cloneToRX)) {
			throw new Error('affRepo.cloneToRX, ceid / rxid / clone to rxid required');
		}

		_currentPurl = 'admin/affiliation/clone';
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [ceid],
				RXID: [rxid]
			},
			Params: {
				CloneToRX: cloneToRX
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okClone, errClone);

		function okClone(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errClone(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				throw new Error('errClone, unexpected error result');
			}

		}

		return defer.promise;
	}
}
 
widAffVendor.$inject = ['$state', '$timeout', 'affRepo', 'vendorRepo', 'utilSvc', 'validSvc', 'msgSvc'];
angular
.module('espui.admin')
.directive('widgetAffVendor', widAffVendor);

/* @ngInject */
function widAffVendor($state, $timeout, affRepo, vendorRepo, utilSvc, validSvc, msgSvc) {

	ctl.$inject = ['$scope'];
	return {
		restrict: 'A',
		replace: true,
		scope: {
			vendorCtx: '=',
			vendorList: '='
		},
		templateUrl: 'html/admin/affiliates/widget/widget-aff-vendor.html?v=' + window.verityEspVersion,
		controller: ctl,
		controllerAs: 'vm'
	};

	/* @ngInject */
	function ctl($scope) {

		var vm = this,
			_ndcListListener = null,
			_loaded = false;

		// props
		vm.model = {};
		vm.action = '';
		vm.canEdit = true;
		vm.uType = '';

		// droplist
		vm.VenIdDroplist = [];
		vm.OrderTypeDroplist = [];
		vm.NicknameDroplist = [];

		// methods
		vm.toggleExpand = toggleExpand;
		vm.cancelEdit = cancelEdit;
		vm.submit = submit;
		vm.isDirty = isDirty;
		vm.deleteVendor = deleteVendor;

		// ndc popup
		vm.popup = {};
		vm.closePopup = closePopup;
		vm.openPopup = openPopup;

		// ndc filter
		vm.changeNdcFlt = changeNdcFlt;
		
		// ndc clone
		vm.ndcClone = ndcClone;
		
		// auto order
		vm.StandardAutoOrder = {};
		vm.SpecialtyAutoOrder = {};
		vm.DropShipAutoOrder = {};

		// Ack Code
		vm.NewAckCode = '';
		vm.AckCodeAdd = AckCodeAdd;
		vm.AckCodeRemove = AckCodeRemove;

		// credit replenishment vendors
		vm.creditReplenishVendors = [];
		vm.doesVendorCreditReplenish = doesVendorCreditReplenish;


		/**
		 *    INIT
		 */

		init();

		function init() {
			vm.OrderTypeDroplist = [
				{value:"340B", label: "340B"},
				{value:"IND", label: "IND"},
				{value:"GPO", label: "GPO"},
				{value:"WAC", label: "WAC"},
				{value:"OWN", label: "OWNUSE"},
			];
		}


		/**
		 *    EVENTS
		 */

		_ndcListListener = $scope.$on('widget.ops.ndc.list.count', function(event, evtData) {
			event.stopPropagation();

			// event listener for ndc list widget changes

			// params
			evtData = evtData || {};
			if(!validSvc.isText(evtData.ListType) || !validSvc.isNumber(evtData.ItemsCount)) {
				throw new Error('widget.aff.vendor, ndc list event requires ListType, ItemsCount');
			}

			// update count
			switch(evtData.ListType) {
				case 'AlwaysSplit':
					vm.model.AlwaysSplitCount = evtData.ItemsCount;
					break;
				case 'NeverSplit':
					vm.model.NeverSplitCount = evtData.ItemsCount;
					break;
				case 'OrderExcls':
					vm.model.OrderExclsCount = evtData.ItemsCount;
					break;
				case 'OrderPref':
					vm.model.OrderPrefCount = evtData.ItemsCount;
					break;
				default:
					throw new Error('widget.aff.vendor, ndc list event has unknown list type: ' + evtData.ListType);
			}

		});

		$scope.$on('$destroy', function() {
			if(!!_ndcListListener) {
				_ndcListListener();
			}
		});


		/**
		 *    EXPAND/COLLAPSE
		 */

		function toggleExpand() {

			if(vm.isWaiting) {
				return;
			}

			// load context on first expand
			if(!!!$scope.vendorCtx.expand && !_loaded) {
				vm.uType = $scope.vendorCtx.uType;
				vm.model = $scope.vendorCtx;
				vm.action = vm.model.action.toString();

				// auto order, load model into controller vm scope (de-referenced)
				vm.StandardAutoOrder = JSON.parse(JSON.stringify(vm.model.StandardAutoOrder || {}));
				vm.SpecialtyAutoOrder = JSON.parse(JSON.stringify(vm.model.SpecialtyAutoOrder || {}));
				vm.DropShipAutoOrder = JSON.parse(JSON.stringify(vm.model.DropShipAutoOrder || {}));
				
				// vendor dropdown, if update load just chosen vendor only
				$scope.vendorList = Array.isArray($scope.vendorList) ? $scope.vendorList : [];
				var items = vm.action == 'UPDATE' ? [vm.model.Vendor.val] : $scope.vendorList;
				vm.VenIdDroplist = utilSvc.ng.droplist(items);

				// Credit Replenishment vendors
				vendorRepo.getList(true).then(vrOkResponse, vrErrResponse);

				$scope.vendorCtx.expand = true;
			}
			else {
				// toggle
				$scope.vendorCtx.expand = !!!$scope.vendorCtx.expand;
			}
			function vrOkResponse(r) {
				for (var i = 0; i < r.length; i++) {
					vm.creditReplenishVendors.push(r[i].Id);
				}
			}
			function vrErrResponse(r) {
				if (!!r) {
					errSvc.warn('vendorRepo.getLit unknown error ', r.status, utilSvc.http.safeResponse(r));
				}
			}
		}


		/**
		 *    IS DIRTY
		 */

		function isDirty() {
			$scope.vendorCtx.dirty = true;

			// a little hacky.. but... 
			if (vm.model.CreditReplenishment.val === 'yes') {
				vm.model.SendOrdersForReview.val = 'no';
			}
		}


		/**
		 *    SUBMIT
		 */

		function vendorValid() {

			// validate for both create and update
			var ven = vm.model;
			
			// status - required
			if(ven.ObjectState.val != 'ACTIVE' && ven.ObjectState.val != 'INACTIVE') {
				ven.ObjectState.fail = 'yes';
				ven.ObjectState.msg = 'required';
			}
			else {
				ven.ObjectState.fail = '';
			}

			// order type - required
			if(!validSvc.isText(ven.AccumulatorType.val) || ven.AccumulatorType.val == 'NONE') {
				ven.AccumulatorType.fail = 'yes';
				ven.AccumulatorType.msg = 'required';
			}
			else {
				ven.AccumulatorType.fail = '';
			}

			// vendor
			if(!validSvc.isVEN(ven.Vendor.val)) {
				ven.Vendor.fail = 'yes';
				ven.Vendor.msg = 'required';
			}
			else {
				ven.Vendor.fail = 'no';

				// mark for review is not available for MCKESSON vendor
				if(ven.Vendor.val == 'MCKESSON' || ven.Vendor.val =='MCKESSONSAFECOR' ||  ven.Vendor.val =='MCKESSONHCP') {
					ven.SendOrdersForReview.val = 'no';
				}
				// AMERISOURCE order processing (zero out any other vendor)
				if(ven.Vendor.val == 'AMERISOURCE' || ven.Vendor.val=='ABCSAFECOR') {
					ven.VendorOrderConfig = 'ABCOrder';
				}
				else {
					ven.VendorOrderConfig = '';
				}
			}

			// text properties - required
			ven.VendorAccount = validText(ven.VendorAccount, 5, 40);
			ven.AccountAlias = validText(ven.AccountAlias, 1, 40);
			ven.SenderId = validText(ven.SenderId, 1, 30);
			ven.ReceiverId = validText(ven.ReceiverId, 1, 30);

			// upper case sender/receiver
			if(validSvc.isText(ven.SenderId.val)) {
				ven.SenderId.val = ven.SenderId.val.toUpperCase();
			}
			if(validSvc.isText(ven.ReceiverId.val)) {
				ven.ReceiverId.val = ven.ReceiverId.val.toUpperCase();
			}

			// reservation expires, required
			var resExp = parseInt(ven.ReservationExpiration.val);
			if(!validSvc.isInteger(resExp) || resExp < 1 || resExp > 180) {
				ven.ReservationExpiration.fail = 'yes';
				ven.ReservationExpiration.msg = 'number 1 to 180';
			}
			else {
				ven.ReservationExpiration.val = resExp;
				ven.ReservationExpiration.fail = '';
			}
	
			// ndc filter
			if($scope.vendorCtx.RxBizModel == 'SPLIT') {
				ven.NdcFilter = validSvc.newProp('NONE');
			}
			else if(vm.action == 'UPDATE' && $scope.vendorCtx.RxBizModel == 'CP') {
				// move auto-order from vm to model (de-ref)
				ven.StandardAutoOrder = JSON.parse(JSON.stringify(vm.StandardAutoOrder));
				ven.SpecialtyAutoOrder = JSON.parse(JSON.stringify(vm.SpecialtyAutoOrder));
				ven.DropShipAutoOrder = JSON.parse(JSON.stringify(vm.DropShipAutoOrder));

				// validate NDC if any auto ordering is enabled
				// task: not sure this is correct??? why is NDC filtering only used for auto orders?
				var msgTxt;
				ven.NdcFilter.fail = '';
				if(ven.StandardAutoOrder.Enabled == 'on' || ven.SpecialtyAutoOrder.Enabled == 'on' || ven.DropShipAutoOrder.Enabled == 'on') {
					msgTxt = ndcFltValid(ven.NdcFilter.val, ven, true);
					if(!!msgTxt) {
						ven.NdcFilter.fail = 'yes';
						ven.NdcFilter.msg = msgTxt;
					}
				}
			}
			// ExtPartyFolder
			if (ven.SendOrderstoExtParty.val == 'yes') {
				ven.ExtPartyFolder = validText(ven.ExtPartyFolder, 3, 30);
				if(ven.ExtPartyFolder.fail == 'no') {
					ven.ExtPartyFolder.val = ven.ExtPartyFolder.val.toUpperCase();
					var regexFolderName  = /[^A-Z0-9]/;
					if(regexFolderName.test(ven.ExtPartyFolder.val)) {
						ven.ExtPartyFolder.fail = 'yes';
						ven.ExtPartyFolder.msg = 'must be 3 to 30 letters and numbers only';
					}
				}
			}
			// result
			return ven.ObjectState.fail != 'yes' &&
				ven.AccumulatorType.fail != 'yes' &&
				ven.Vendor.fail != 'yes' &&
				ven.VendorAccount.fail != 'yes' &&
				ven.AccountAlias.fail != 'yes' &&
				ven.SenderId.fail != 'yes' &&
				ven.ReceiverId.fail != 'yes' &&
				ven.ReservationExpiration.fail != 'yes' &&
				ven.StandardAutoOrder.fail != 'yes' &&
				ven.SpecialtyAutoOrder.fail != 'yes' &&
				ven.DropShipAutoOrder.fail != 'yes' &&
				ven.NdcFilter.fail != 'yes' &&
				ven.ExtPartyFolder.fail != 'yes';
		}

		function cancelEdit() {

			if(vm.isWaiting) {
				return;
			}

			// notify parent to reset this vendor
			$scope.$emit('widget.aff.vendor', {
				action: 'CANCEL',
				uniqueId: $scope.vendorCtx.uniqueId,
				Vendor: $scope.vendorCtx.Vendor.val,
				AccumType: $scope.vendorCtx.AccumulatorType.val
			});

		}

		function submit() {

			if(vm.isWaiting) {
				return;
			}

			// validate
			if(!vendorValid()) {
				msgSvc.ok('Cannot Save', 'All fields must be valid.');
				return;
			}
			vm.isWaiting = true;

			// create or update
			if(vm.action == 'CREATE') {
				affRepo.vendorCreate($scope.vendorCtx, vm.model).then(okVenUpsert, errVenUpsert);
			}
			else {
				affRepo.vendorUpdate($scope.vendorCtx, vm.model).then(okVenUpsert, errVenUpsert);
			}

		}

		function okVenUpsert(r) {
			vm.isWaiting = false;

			msgSvc.okAsync(
				vm.model.Vendor.val + '-' + vm.model.AccumulatorType.val,
				vm.action == 'CREATE' ? 'Vendor Account Created' : 'Vendor Account Saved',
				'widget.aff.vendor.upsert').then(notifyParent, notifyParent);
		}

		function notifyParent() {

			// notify parent to refresh its vendor list view
			$scope.$emit('widget.aff.vendor', {
				action: vm.action,
				uniqueId: vm.model.Vendor.val + '|' + vm.model.AccumulatorType.val,
				Vendor: vm.model.Vendor.val,
				AccumType: vm.model.AccumulatorType.val
			});

		}

		function errVenUpsert(r) {

			vm.isWaiting = false;

			if(!!!r || r === null) {
				// already handled
				$state.go($scope.vendorCtx.viewErrRoute, {}, {reload: $scope.vendorCtx.viewErrRoute});
			}
			else if(r.status === 409) {
				// conflict
				msgSvc.ok('Server Cannot Save', 'This vendor and account already exists in the database. Verify and try again.');
			}
			else if (r.status === 422) {
				// validation
				msgSvc.ok('Server Cannot Save', 'All fields must be valid.');
				vm.model = r.model;
			}
			else {
				errSvc.error('Unexpected api error', 'affDetailCtl.errVenUpsert', r.status, utilSvc.http.safeResponse(r));
				$state.go($scope.vendorCtx.viewErrRoute, {}, {reload: $scope.vendorCtx.viewErrRoute});
			}

		}


		/**
		 *    NDC POPUP
		 */

		function openPopup(evt, listType) {
			if(vm.isWaiting) {
				return;
			}

			var ctx = $scope.vendorCtx;
			var venid = ctx.Vendor.val,
				accumType = ctx.AccumulatorType.val;

			vm.popup = {
				ready: false,
				isVerity: vm.uType == 'VERITY' || vm.uType == 'VERITYSA',
				Id: ctx.Id,
				uniqueId: ctx.uniqueId,
				title: venid + '-' + accumType + ' ' + ndcListText(listType),
				CE: ctx.CE,
				RX: ctx.RX,
				Scope: "OA",
				Entity: ctx.Id,
				Vendor: venid,
				AccumType: accumType,
				ListType: listType
			};

			var offsetY = -50;

			// loop html element parents looking for popup container top
			var elem = evt.target;
			while(!!elem) {

				// top element found
				if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
					break;
				}

				// add offset, get next element
				offsetY += elem.offsetTop;
				elem = elem.offsetParent;
			}
			elem = null;

			// move popup to clicked row
			var popup = document.getElementById('popupContent-' + venid + '-' + accumType);
			if(!!popup) {
				popup.style.top = offsetY.toString() + 'px';
			}

			// wait for digest before showing
			$timeout(function() {
				vm.popup.ready = true;
				$scope.$broadcast('widget.ops.ndc.list', {uniqueId: vm.popup.uniqueId, action: 'INIT'});
			}, 100);

		}

		function closePopup() {
			vm.popup = {};
		}


		/**
		 *    DELETE VENDOR ACCT
		 */

		function deleteVendor() {

			if(vm.isWaiting) {
				return;
			}

			// notify parent to delete this vendor
			$scope.$emit('widget.aff.vendor', {
				action: 'DELETE',
				uniqueId: $scope.vendorCtx.uniqueId,
				Vendor: $scope.vendorCtx.Vendor.val,
				AccumType: $scope.vendorCtx.AccumulatorType.val
			});

		}


		/**
		 *    NDC
		 */

		function ndcFltValid(fltType, m, checkCounts) {

			var result = '';

			switch(fltType) {
				case 'NONE':
					//if(m.AutoOrder == 'yes' && m.AutoOrderPrimary == 'no') {
					//	result = 'Prefer NDC must be chosen for auto order non-primary account.';
					//}
					if(m.OrderPrefCount > 0) {
						result = 'Always Order list must be empty.';
					}
					else if(m.OrderExclsCount > 0) {
						result = 'Never Order list must be empty.';
					}
					break;
				case 'OE':
					//if(m.AutoOrder == 'yes' && m.AutoOrderPrimary == 'no') {
					//	result = 'Prefer NDC must be chosen for auto order non-primary account.';
					//}
					if(m.OrderPrefCount > 0) {
						result = 'Always Order list must be empty.';
					}
					else if(!!checkCounts && m.OrderExclsCount < 1) {
						result = 'Never Order list must have items.';
					}
					break;
				case 'OI':
					if(m.OrderExclsCount > 0) {
						result = 'Never Order list must be empty.';
					}
					else if(!!checkCounts && m.OrderPrefCount < 1) {
						result = 'Always Order list must have items.';
					}
					break;
				default:
					throw new Error('affDetailCtl.changeNdcFilter, unknown list type: ' + fltType);
			}

			return result;

		}

		function changeNdcFlt(fltType) {

			var msgTxt = ndcFltValid(fltType, vm.model, false);
			if(!!msgTxt) {
				vm.model.NdcFilter.val = '';
				vm.model.NdcFilter.fail = 'yes';
				vm.model.NdcFilter.msg = 'required';
				msgSvc.ok('Cannot Change', msgTxt);
			}
			else {
				vm.model.NdcFilter = validSvc.newProp(fltType);
			}

		}

		function ndcClone(listType) {

			if(vm.isWaiting) {
				return;
			}

			if(listType != 'AlwaysSplit' && listType != 'NeverSplit' && listType != 'OrderExcls' && listType != 'OrderPref') {
				msgSvc.ok('Cannot Clone', 'Unknown ndc list type: ' + listType);
			}

			// notify parent to delete this vendor
			$scope.$emit('widget.aff.vendor', {
				action: 'CLONENDC',
				listType: listType,
				AcctId: $scope.vendorCtx.Id,
				uniqueId: $scope.vendorCtx.uniqueId,
				Vendor: $scope.vendorCtx.Vendor.val,
				AccumType: $scope.vendorCtx.AccumulatorType.val
			});

		}

		/**
		 *    ACK-CODE
		 */


		function AckCodeAdd(code) {
			var regexShortName = /[^A-Za-z0-9]/;
			if(code.length < 2 || regexShortName.test(code)) {
				msgSvc.ok('Cannot Add', 'Ack Code has to be two-character alpha-numeric code.');
				return;
			}
			var codeList = vm.model.OnOrderReleaseAckCodeExclusionList;
			for(var i = codeList.length - 1; i >= 0; i--) {
				if(codeList[i] == code) {
					msgSvc.ok('Cannot Add', 'Ack Code already in the list.');
					return;	
				}
			}
			vm.model.OnOrderReleaseAckCodeExclusionList.push(code);
		}

		function AckCodeRemove(code) {
			if(vm.isWaiting) {
				return;
			}
	
			// find ndc to remove
			var codeList = vm.model.OnOrderReleaseAckCodeExclusionList;
			for(var i = codeList.length - 1; i >= 0; i--) {
				if(codeList[i] == code) {
					codeList.splice(i, 1);
				}
			}
		}

		/**
		 *    HELPERS
		 */

		function ndcListText(ndcListType) {

			switch(ndcListType) {

				case 'AlwaysSplit':
				case 'AW':
					return 'Always Split';

				case 'NeverSplit':
				case 'NV':
					return 'Never Split';

				case 'OrderExcls':
				case 'OE':
					return 'Never Order';

				case 'OrderPref':
				case 'OI':
					return 'Always Order';
				case "OE":
				case "AFFORDEREXCLUSION":
					return "Order Exclusion";


				default:
					throw new Error('affDetailCtl.ndcListText, unknown list type: ' + ndcListType);
			}

		}

		function validText(prop, min, max) {

			// required
			if(!validSvc.isText(prop.val)) {
				prop.fail = 'yes';
				prop.msg = 'required';
				return prop;
			}

			// min
			if(prop.val.length < min) {
				prop.fail = 'yes';
				prop.msg = 'minimum ' + min.toString() + ' characters';
				return prop;
			}

			// max
			if(prop.val.length > max) {
				prop.fail = 'yes';
				prop.msg = 'maximum ' + max.toString() + ' characters';
				return prop;
			}

			// success
			prop.fail = 'no';
			prop.msg = '';
			return prop;

		}


		function doesVendorCreditReplenish(vendor) {
			for (var i = 0; i < vm.creditReplenishVendors.length; i++) {
				if (vm.creditReplenishVendors[i] == vendor) {
					return true;
				}
			}
			return false;
		}
	}
}
 
adminBulkEditCtl.$inject = ['$state', '$scope', '$timeout', '$window', 'bulkEditRepo', 'rxRepo', 'utilSvc', 'validSvc', 'msgSvc', 'errSvc'];angular
.module('espui.admin')
.controller('AdminBulkEditCtl', adminBulkEditCtl);

/* @ngInject */
function adminBulkEditCtl($state, $scope, $timeout, $window, bulkEditRepo, rxRepo, utilSvc, validSvc, msgSvc, errSvc) {

	var _pagingEventListener = null,
		_mouseLeaveDelay = {},
		_pendingExcelFilename = '',
		_rxListCache = null;

	var vm = this;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addMultiselect(vm);
	utilSvc.ctl.addTableViews(vm);
	utilSvc.ctl.addFlexTop(vm);
	msgSvc.addHelpLink(vm);

	// props
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.canCreate = false;

	// list display
	vm.flt = {};
	vm.tbl = {};
	vm.tblView = {};
	vm.tblViewConfig = {};
	vm.filterChange = filterChange;

	// droplists
	vm.BulkTypeDroplist = [];

	// multiselects
	vm.CeMulti = {};
	vm.RxMulti = {};
	vm.VenMulti = {};
	vm.ProgAdminMulti = {};
	vm.multiToggle = multiToggle;
	vm.multiHover = multiHover;
	vm.multiClick = multiClick;

	// create / search / excel
	vm.toggleCreate = toggleCreate;
	vm.query = {};
	vm.queryChangeBulkType = queryChangeBulkType;
	vm.queryChangeSearchType = queryChangeSearchType;
	vm.findBulkTargets = findBulkTargets;
	vm.getExcel = getExcel;

	// auto-order extra properties
	vm.queryChangeAutoOrder = queryChangeAutoOrder;
	vm.queryChangeAutoOrderCategory = queryChangeAutoOrderCategory;
	vm.queryChangeAutoOrderSchedule = queryChangeAutoOrderSchedule;
	vm.AutoOrderSchedule = {};
	vm.AutoOrderScheduleAction = 'UPDATE'; // need this as a reference for the widget

	// order-limit extra properties
	vm.queryChangeOrderLimit = queryChangeOrderLimit;

	// flex top
	vm.flex = {};
	vm.flexTopExpand = flexTopExpand;
	
	// search list
	vm.fltSearch = {};
	vm.tblSearch = {};
	vm.tblViewSearch = {};
	vm.tblViewSearchConfig = {};
	vm.filterChangeSearch = filterChangeSearch;

	// edit results popup
	vm.popup = {};
	vm.closePopup = closePopup;
	
	// submit
	vm.editToggle = editToggle;
	vm.runEdit = runEdit;


	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// params
		if (!!!evtData || !validSvc.isText(evtData.uniqueId)) {
			alert('bulkeditCtl.pagingEventListener, evtData and uniqueId required');
			return;
		}
		
		switch(evtData.uniqueId) {
			case 'BULKEDIT_LIST':
				if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
					return;
				}
		
				// adjust Page or PageSize property
				vm.flt[evtData.propName] = parseInt(evtData.value);
				filterChange(true);
				break;
			case 'BULKEDIT_SEARCH':
				if(!vm.fltSearch.Ready || !Array.isArray(vm.tblSearch.Items) || vm.tblSearch.Items.length < 1) {
					return;
				}

				// adjust Page or PageSize property
				vm.fltSearch[evtData.propName] = parseInt(evtData.value);
				filterChangeSearch(true);
				break;
			default:
				throw new Error('bulkeditCtl.pagingEventListener, paging table id: ' + evtData.id);
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {
		vm.init = true;
		vm.action = '';
		vm.canCreate = utilSvc.user.hasFeature($scope, 'admin.bulkedit.run');
		
		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		vm.flex = vm.flexInit();
		initDroplists();
		initTblViewsAndFilters();
		vm.query = initQuery(vm.canCreate);

		getList();
		vm.init = false;
	}

	function initDroplists() {
		vm.BulkTypeDroplist = [
			{value:'NONE', label:'Choose a Bulk Type'},
			{value:'AUTO_ORDER', label:'Auto Order Config'},
			{value:'AUTO_ORDER_CANCEL', label:'Auto Order Cancel'},
			{value:'ORDER_LIMIT', label:'Daily Order Limit'}
		];

		vm.CeMulti = {
			type: 'CE',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'Choose a Facility',
			titleNoOptions: 'Choose a Facility',
			vals: [],
			list: [],
			flt: ''
		};

		vm.RxMulti = {
			type: 'RX',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'Choose a Pharmacy',
			titleNoOptions: 'Choose a Pharmacy',
			vals: [],
			list: [],
			flt: '',
			fltId: '',
			fltName: '',
			fltDivision: '',
			fltStoreNumber: '',
			fltNPI: ''
		};

		vm.VenMulti = {
			type: 'VEN',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'Choose a Vendor',
			titleNoOptions: 'Choose a Vendor',
			vals: [],
			list: [],
			flt: ''
		};
	
		vm.ProgAdminMulti = {
			type: 'PROGADMIN',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'Choose a Program Admin',
			titleNoOptions: 'Choose a Program Admin',
			vals: [],
			list: [],
			flt: ''
		};
	}

	function initQuery(bulkType) {
		var q = {
			BulkType: validSvc.isText(bulkType) ? {val:bulkType, fail:'no'} : validSvc.newProp('NONE'),
			BulkTitle: '',

			// search type
			SearchType: '',
			SearchTitle: '',
			Primary: 'CE',
			showSearchBy: false,
			hasSearchTypeAFF: false,
			hasSearchTypeRX: false,
			hasSearchTypeProgAdmin: false,
			hasSearchTypeVENDOR: false,

			// multi selects
			CE: newMultiValsProp(),
			RX: newMultiValsProp(),
			VEN: newMultiValsProp(),
			ProgAdmin: newMultiValsProp(),
			showCeMulti: false,
			showRxMulti: false,
			showVenMulti: false,
			showProgAdminMulti: false,

			// search options
			showSearchOptions: false,
			showSearchOption1: false,
			SearchOption1: newCheckProp(''),
			SearchOption2: newCheckProp(''),

			// auto-order specific
			AutoOrderStatus: validSvc.newProp(''),
			AutoOrderCategory: initAutoOrderCategory(),
			AutoOrderSchedule: {
				Enabled: 'off'
			},

			// order-limit specific
			OrderLimitConfig: initOrderLimitConfig(),

			showSearchList: false
		};

		return q;
	}

	function initAutoOrderCategory() {
		return {
			title: '',
			fail: '',
			STANDARD: 'no',
			SPECIALTY: 'no',
			DROPSHIP: 'no'
		};
	}

	function initOrderLimitConfig() {
		return {
			fail: 'yes',
			DailyTotalPackageLimit: { val: '', fail: '', msg: '' },
			DailyNDCPackageLimit: { val: '', fail: '', msg: '' },
			DailyRefrigeratedPackageLimit: { val: '', fail: '', msg: '' }
		};
	}

	function bulkTitle(q) {
		if(!validSvc.isText(q.BulkType.val) || q.BulkType.fail != 'no') {
			return '';
		}

		switch(q.BulkType.val) {
			case 'AUTO_ORDER':
				var aoStat = validSvc.isText(q.AutoOrderStatus.val) ? q.AutoOrderStatus.val.toUpperCase() : '';
				return 'AUTO ORDER CONFIG ' + aoStat;
			case 'AUTO_ORDER_CANCEL':
				return 'AUTO ORDER CANCEL';
			case 'ORDER_LIMIT':
				return 'DAILY ORDER LIMITS';
			default:
				return '';
		}
	}

	function initTblViewsAndFilters() {
		// list view (doesn't change)
		vm.flt = vm.initFilters({
			Config: {
				Dates: ['CreatedDate'],
				DateFmt: 'M/d/yyyy'
			},
			SortBy: ['-CreatedDate']
		});
		vm.tblViewConfig = tblViewConfigListVM();
		vm.tblView = vm.tblViewInit(vm.tblViewConfig);
		vm.tblView = vm.tblViewLoadTitlesAndFilters(vm.tblViewConfig, vm.tblView);

		// search view will change depending on bulk / search type
		// below is only for init
		initTblViewSearchAndFilter();		
	}

	function initTblViewSearchAndFilter(bulkType, searchType) {
		vm.tblViewSearchConfig = tblViewConfigSearchVM(bulkType, searchType);
		vm.fltSearch = vm.initFilters({
			SortBy: [vm.tblViewSearchConfig.sortBy]
		});
		vm.tblViewSearch = vm.tblViewInit(vm.tblViewSearchConfig);
		vm.tblViewSearch = vm.tblViewLoadTitlesAndFilters(vm.tblViewSearchConfig, vm.tblViewSearch);
	}

	function newCheckProp(val) {
		var result = validSvc.newProp(val);
		result.chk = 'no';
		return result;
	}

	function newMultiValsProp(vals) {
		vals = Array.isArray(vals) ? vals : [];
		var result = validSvc.newProp('');
		result.vals = vals;
		return result;
	}


	/**
	 *    VIEW MODEL
	 */

	function listVM(repoData) {
		var items = Array.isArray(repoData) ? repoData : [];

		var item = {},
			ii = 0,
			t = {},
			tText = '',
			targetsLen = 0,
			dText = '',
			stats = {};
		for(var i = 0; i < items.length; i++) {
			item = items[i];
			item.CreatedDate = validSvc.isDate(item.CreatedDate) ? item.CreatedDate : null;

			// outcome numbers are in EditStats
			stats = item.EditStats || {};
			item.ReceivedCount = validSvc.isInteger(stats.ReceivedCount) && stats.ReceivedCount > 0 ? stats.ReceivedCount : 0;
			item.ProcessedCount = validSvc.isInteger(stats.ProcessedCount) && stats.ProcessedCount > 0 ? stats.ProcessedCount : 0;
			item.InvalidCount = validSvc.isInteger(stats.InvalidCount) && stats.InvalidCount > 0 ? stats.InvalidCount : 0;
			item.ErrorCount = validSvc.isInteger(stats.ErrorCount) && stats.ErrorCount > 0 ? stats.ErrorCount : 0;
			item.TotalIssues = item.InvalidCount + item.ErrorCount;

			item.ErrorResult = validSvc.isText(stats.ErrorResult) ? stats.ErrorResult : '';
			if(!item.ErrorResult && item.TotalIssues > 0) {
				item.ErrorResult = 'Error Found';
			}
			item.ErrorShow = false;
			item.hasErrors = !!item.ErrorResult;
			
			// details array output
			item.Details = [];
			switch(item.BulkType) {
				case 'AUTO_ORDER':
                case 'AUTO_ORDER_CANCEL':
					// targets array output (specific to bulk type)
					// tbd... VENID, PROGADMIN, etc
					var apiTargets = Array.isArray(item.Targets) ? JSON.parse(JSON.stringify(item.Targets)) : []; // de-ref
					
					// set title 10 or more
					tText = 'VENDOR ACCOUNTS (';
					tText += (apiTargets.length > 10 ? '10+' : apiTargets.length) + ')';
					item.Targets = [tText];

					// only display top 10 returned, not more
					targetsLen = apiTargets.length > 10 ? 10 : apiTargets.length;
					for(ii = 0; ii < targetsLen; ii++) {
						t = apiTargets[ii];
						item.Targets.push(t.CEID + ' / ' + t.RXID + ' / ' + t.VENID + ' / ' + t.AccumGroup);
					}
					item.TargetsTxt = item.Targets.join('|');

					if(item.Config && item.Config.AutoOrder) {
						var aoConfig = item.Config.AutoOrder;

                        if(item.BulkType === 'AUTO_ORDER') {
                            dText = !!aoConfig.TurnOn ? 'ON' : 'OFF';
                            item.Details.push('Turn ' + dText);
                            item.Details.push('Category: ' + getAutoOrderCategoriesTxt(aoConfig.Category));
                            if(aoConfig.TurnOn) {
                                dText = getAutoOrderScheduleTxt(aoConfig.DefaultConfig);
                                if(!!dText) {
                                    item.Details.push('New Schedule: ' + dText);
                                    dText = aoConfig.DefaultConfig.PlaceNow ? 'Yes' : 'No';
                                    item.Details.push('Place Immediately: ' + dText);								
                                }
                                else {
                                    item.Details.push('Schedule: No Change');
                                }
                            }
                        }
                        else {
                            item.Details.push('Cancel Auto Order');
                            item.Details.push('Category: ' + getAutoOrderCategoriesTxt(aoConfig.Category));
                        }
					}
					else {
						item.Details.push('Error: AutoOrder Config not found');
					}
					break;
				case 'ORDER_LIMIT':
					// targets array output for pharmacies
					var apiTargetsOL = Array.isArray(item.Targets) ? JSON.parse(JSON.stringify(item.Targets)) : []; // de-ref
					
					// set title 10 or more
					tText = 'PHARMACIES (';
					tText += (apiTargetsOL.length > 10 ? '10+' : apiTargetsOL.length) + ')';
					item.Targets = [tText];

					// only display top 10 returned, not more
					targetsLen = apiTargetsOL.length > 10 ? 10 : apiTargetsOL.length;
					for(ii = 0; ii < targetsLen; ii++) {
						t = apiTargetsOL[ii];
						item.Targets.push(t.RXID + ' / ' + t.RxShortName);
					}
					item.TargetsTxt = item.Targets.join('|');

					if(item.Config && item.Config.OrderLimit) {
						var olConfig = item.Config.OrderLimit;
						item.Details.push('Daily Total Package Limit: ' + (olConfig.DailyTotalPackageLimit !== null ? olConfig.DailyTotalPackageLimit : 'N/A'));
						item.Details.push('Daily NDC Package Limit: ' + (olConfig.DailyNDCPackageLimit !== null ? olConfig.DailyNDCPackageLimit : 'N/A'));
						item.Details.push('Daily Refrigerated Package Limit: ' + (olConfig.DailyRefrigeratedPackageLimit !== null ? olConfig.DailyRefrigeratedPackageLimit : 'N/A'));
					}
					else {
						item.Details.push('Error: OrderLimit Config not found');
					}
					break;
				default:
					item.Details.push('Error: unknown bulk type: ' + item.BulkType);
			}
			item.DetailsTxt = item.Details.join('|');
		}

		return {
			Items: [],
			DataItems: items
		};
	}

	function getAutoOrderCategoriesTxt(cat) {
		var result = [];
		if(!!cat.Standard) {
			result.push('Standard');
		}
		if(!!cat.Specialty) {
			result.push('Specialty');
		}
		if(!!cat.Dropship) {
			result.push('Dropship');
		}
		return result.join(', ');
	}

	function getAutoOrderScheduleTxt(config) {
		var noSchedule = '';
		if (!!!config || !config.AutoOrdering || !config.OrderSchedule ) {
			return noSchedule;
		}
		var sched = config.OrderSchedule;
	
		// Helper: converts an array of integers to a comma-separated string of day names
		var daysOfWeekTxt = function(daysOfWeek) {
			if (!Array.isArray(daysOfWeek) || daysOfWeek.length === 0) {
				return '';
			}

			var dayNames = ['', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
			var days = [];
			daysOfWeek.forEach(function(d) {
				if (d >= 0 && d <= 7) {
					days.push(dayNames[d]);
				}
			});

			return days.join(', ');
		};
	
		// Helper: converts a number to a string with an ordinal suffix (1st, 2nd, 3rd, 4th)
		var dayWithSuffixTxt = function(day) {
			if (!validSvc.isInteger(day) || day <= 0 || day > 31) {
				return day; // Return the number as-is for invalid days
			}

			var suffix = 'th';
			if (day % 10 === 1 && day % 100 !== 11) {
				suffix = 'st';
			} else if (day % 10 === 2 && day % 100 !== 12) {
				suffix = 'nd';
			} else if (day % 10 === 3 && day % 100 !== 13) {
				suffix = 'rd';
			}

			return day + suffix;
		};
	
		switch (sched.Type) {
			case 'WEEK':
				return 'Every ' + sched.Occurs + ' weeks on ' + daysOfWeekTxt(sched.Days);
			
			case 'MONTH':
				if (sched.MonthOption === 'MONTH-DAY') {
					return dayWithSuffixTxt(sched.DayOfMonth) + ' of each Month';
				} else if (sched.MonthOption === 'MONTH-WEEK') {
					return dayWithSuffixTxt(sched.WeekOfMonth) + ' Week of Month on ' + daysOfWeekTxt(sched.Days);
				}
				return noSchedule;

			default:
				return noSchedule;
		}
	}

	function tblSearchVM(repoData) {
		var items = Array.isArray(repoData) ? repoData : [];

		var item = {};
		for(var i = 0; i < items.length; i++) {
			item = items[i];
			item.uniqueId = 'se' + i.toString();
			item.edit = true;
			item.Details = Array.isArray(item.Details) ? item.Details : [];
			if(item.Details.length > 0) {
				item.DetailsTxt = item.Details.join('|');
			}
		}

		return {
			DataItems: items,
			Items: vm.filterList(items, vm.fltSearch),
			EditAll: true,
			EditCount: items.length
		};		
	}


	/**
	 *    GET LIST
	 */

	function getList() {

		if(vm.isWaiting) {
			return;
		}
		vm.action = '';
		toggleWait(true);

		bulkEditRepo.getList().then(okGetList, errGetList);

		function okGetList(r) {
			toggleWait();

			vm.tbl = listVM(r);
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: 'BULKEDIT_LIST',
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});
			
			vm.flt = vm.tblViewSyncFilter(vm.tblViewConfig, vm.tblView, vm.flt, true);
			vm.flt.Ready = true;
			vm.action = 'LIST';
		}

		function errGetList(r) {
			toggleWait();

			if(!!r) {
				errSvc.warn('unknown API error', 'adminBulkEditCtl.getList', r.status, utilSvc.http.safeResponse(r));
				init();
			}
		}
	}


	/**
	 * 	BULK EDIT REQUEST
	 */

	function toggleCreate() {
		if(vm.isWaiting) {
			return;
		}

		vm.query = initQuery();
		vm.flex = vm.flexInit();
		vm.popup = {};

		if(vm.action == 'LIST') {
			// turn on CREATE
			vm.action = 'CREATE';
			queryChangeBulkType();
		}
		else {
			getList();
		}
	}

	/**
	 *    CHANGE EVENT5
	 */

	function queryChangeBulkType() {
		if(vm.isWaiting) {
			return;
		}

		vm.query = initQuery(vm.query.BulkType.val);
		var q = vm.query;

		switch(q.BulkType.val) {
			case 'AUTO_ORDER':
            case 'AUTO_ORDER_CANCEL':
				q.BulkType.fail = 'no';
				q.AutoOrderStatus = validSvc.newProp('');
				q.AutoOrderCategory = initAutoOrderCategory();
				queryChangeAutoOrder();
				break;
			case 'ORDER_LIMIT':
				// order-limit requires limit values
				q.BulkType.fail = 'no';
				q.OrderLimitConfig = initOrderLimitConfig();
				queryChangeOrderLimit();
				break;
			default:
				q.BulkType.fail = 'yes';
		}
	}

	function queryChangeAutoOrder() {
		if(vm.isWaiting) {
			return;
		}

		var q = vm.query;
		var stat = q.AutoOrderStatus;
		stat.fail = stat.val != 'on' && stat.val != 'off' ? 'yes' : 'no'; 
		if(stat.fail == 'yes') {
			return;
		}

		queryChangeAutoOrderCategory();
	}

	function validAutoOrderCategory(prop) {
		prop.title = '';
		prop.fail = 'yes';

		var cats = [];
		if(prop.STANDARD == 'yes') {
			cats.push('STANDARD');
		}
		if(prop.SPECIALTY == 'yes') {
			cats.push('SPECIALTY');
		}
		if(prop.DROPSHIP == 'yes') {
			cats.push('DROPSHIP');
		}

		if(cats.length < 1) {
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.title = 'Order Category: ' + cats.join(', ');
		return prop;
	}


	function queryChangeAutoOrderCategory(catName) {
        // used for both auto order and auto order cancel

		if(vm.isWaiting) {
			return;
		}
		var q = vm.query;
		var cat = q.AutoOrderCategory;

		// toggle if cat name provided
		if(!!catName) {
			cat[catName] = cat[catName] == 'yes' ? 'no' : 'yes';
		}

		// validate
		cat = validAutoOrderCategory(cat);
		if(cat.fail == 'yes') {
			return;
		}

        switch(q.BulkType.val) {
            case 'AUTO_ORDER':
                queryChangeAutoOrderSchedule(q.AutoOrderSchedule.Enabled);
                break;
            case 'AUTO_ORDER_CANCEL':
                q.BulkTitle = bulkTitle(q);
                setupSearchBy();
                break;
            default:
                throw new Error('bulkEditCtl.queryChangeAutoOrderCategory, unknown bulk type: ' + q.BulkType.val);
        }

	}

	function queryChangeAutoOrderSchedule(status) {
		// toggle auto order schedule
		if(vm.isWaiting) {
			return;
		}

		var q = vm.query;
		q.AutoOrderSchedule.Enabled = status;
		vm.AutoOrderSchedule = status == 'off' ? {Enabled:'off'} : {Enabled:'on', notify:true}; // notify widget to seutp model and notify us
		
		q.BulkTitle = bulkTitle(q);
		setupSearchBy();
	}

	function queryChangeOrderLimit() {
		// order limit values will be validated on submit
		if(vm.isWaiting) {
			return;
		}

		var q = vm.query;
		q.BulkTitle = bulkTitle(q);
		setupSearchBy();
	}
	
	/**
	 * 	SEARCH BY
	*/
	
	function setupSearchBy() {
		// bulk-edit properties are complete, show search by options

		var q = vm.query;		
		switch(q.BulkType.val) {
			case 'AUTO_ORDER':
            case 'AUTO_ORDER_CANCEL':
				// auto-order supports Aff, RX and Prog Admin Search
				q.SearchType = 'AFF';
				q.hasSearchTypeAFF = true;
				q.hasSearchTypeRX = true;
				q.hasSearchTypeProgAdmin = true;
				q.hasSearchTypeVENDOR = q.BulkType.val == 'AUTO_ORDER_CANCEL';
				break;
			case 'ORDER_LIMIT':
				// order-limit only supports RX Search
				q.SearchType = 'RX';
				q.hasSearchTypeAFF = false;
				q.hasSearchTypeRX = true;
				q.hasSearchTypeProgAdmin = false;
				q.hasSearchTypeVENDOR = false;
				break;
			default:
				throw new Error('bulkeditCtl.setupSearchBy, unknown bulk type: ' + q.BulkType.val);
		}

		q.showSearchBy = true;
		queryChangeSearchType();
	}

	function queryChangeSearchType() {
		if(vm.isWaiting) {
			return;
		}
		vm.action = 'CREATE';

		var q = vm.query;
		q = resetSearchByProps(q);

		switch(q.SearchType) {
			case 'AFF':
				q.SearchTitle = searchByTitle(q.SearchType);
				vm.CeMulti = setupCeMulti(vm.CeMulti);
				q.CE.fail = vm.CeMulti.vals.length > 0 ? 'no' : 'yes';
				q.showCeMulti = true;
				break;
			case 'RX':
				q.SearchTitle = searchByTitle(q.SearchType);
				vm.RxMulti = setupRxMulti(vm.RxMulti);
				q.RX.fail = vm.RxMulti.vals.length > 0 ? 'no' : 'yes';
				q.showRxMulti = true;
				break;
			case 'PROGADMIN':
				q.SearchTitle = searchByTitle(q.SearchType);
				vm.ProgAdminMulti = setupProgAdminMulti(vm.ProgAdminMulti);
				q.ProgAdmin.fail = vm.ProgAdminMulti.vals.length > 0 ? 'no' : 'yes';
				q.showProgAdminMulti = true;
				break;
			case 'VENDOR':
				q.SearchTitle = searchByTitle(q.SearchType);
				vm.VenMulti = setupVenMulti(vm.VenMulti);
				q.VEN.fail = vm.VenMulti.vals.length > 0 ? 'no' : 'yes';
				q.showVenMulti = true;
				break;
			default:
				throw new Error('bulkeditList.queryChangeSearchType, unknown: ' + q.SearchType);
		}
	}

	function searchByTitle(searchBy) {
		switch(searchBy) {
			case 'AFF':
				return 'FIND AFFILIATIONS';
			case 'RX':
				return 'FIND PHARMACIES';
			case 'PROGADMIN':
				return 'FIND PROGRAM ADMINS';
			case 'VENDOR':
				return 'FIND VENDORS';
			default:
				return '';
		}
	}

	function flexTitle(q) {
		var title = 'Bulk Type: ';
		switch(q.BulkType.val) {
			case 'AUTO_ORDER':
				title += 'Auto Order Config - ALL ' + q.AutoOrderStatus.val.toUpperCase();
				return title;
			case 'AUTO_ORDER_CANCEL':
				title += 'Auto Order Cancel';
				return title;
			case 'ORDER_LIMIT':
				title += 'Daily Order Limit';
				return title;
			default:
				return '';
		}
	}

	function flexTopExpand() {
		if(vm.isWaiting) {
			return;
		}

		vm.action = 'CREATE';
		vm.flex = vm.flexInit();
	}

	function getAffs() {

		// active only
		var affs = utilSvc.aff.findStatus($scope.User.AffList, ['ACTIVE']);

		switch(vm.query.BulkType.val) {
			case 'AUTO_ORDER':
				return utilSvc.aff.findRxModel(affs, ['CP']);
			case 'AUTO_ORDER_CANCEL':
				return utilSvc.aff.findVenType(utilSvc.aff.findRxModel(affs, ['CP']), ['340B']);
			case 'ORDER_LIMIT':
				// order-limit applies to CP business model pharmacies, include ONBOARDING
				var olAffs = utilSvc.aff.findStatus($scope.User.AffList, ['ACTIVE', 'ONBOARDING']);
				return utilSvc.aff.findRxModel(olAffs, ['CP']);
			default:
				throw new Error('bulkeditCtl.setupSearchBy, unknown bulk type: ' + q.BulkType.val);
		}


	}

	function setupCeMulti(multi, rxList) {
		var affs = getAffs();

		// limit affs to rx list
		if(Array.isArray(rxList) && rxList.length > 0) {
			affs = utilSvc.aff.findRxList(getAffs(), rxList);
		}

		multi.vals = [];
		multi.list = vm.multiselectBuild(utilSvc.aff.ceList(affs), false);

		// auto-select
		if(multi.list.length == 1 && multi.list[0].val != 'ALL') {
			vm.multiselectClick(multi, multi.list[0].val);
		}
		vm.multiselectTitle(multi, true);	

		return multi;
	}

	function setupRxMulti(multi, ceList) {
		var affs = getAffs();

		// limit affs to ce list
		if(Array.isArray(ceList) && ceList.length > 0) {
			affs = utilSvc.aff.findCeList(getAffs(), ceList);
		}

		multi.vals = [];
		// clear filters
		multi.fltId = '';
		multi.fltName = '';
		multi.fltDivision = '';
		multi.fltStoreNumber = '';
		multi.fltNPI = '';
		
		// For ORDER_LIMIT, load full pharmacy data; otherwise use affiliation data
		if(vm.query.BulkType.val == 'ORDER_LIMIT') {
			loadRxListForMulti(multi, affs);
		} else {
			// build basic list from affiliations
			multi.list = buildRxMultiListFromAffs(affs);
			// auto-select
			if(multi.list.length == 1 && multi.list[0].val != 'ALL') {
				vm.multiselectClick(multi, multi.list[0].val);
			}
			vm.multiselectTitle(multi, true);
		}
		
		return multi;
	}

	function loadRxListForMulti(multi, affs) {
		// Load pharmacy data from rxRepo for extended columns
		
		// Use cache if available
		if(_rxListCache !== null) {
			multi.list = buildRxMultiListFromRxData(_rxListCache, affs);
			if(multi.list.length == 1 && multi.list[0].val != 'ALL') {
				vm.multiselectClick(multi, multi.list[0].val);
			}
			vm.multiselectTitle(multi, true);
			return;
		}
		
		vm.isWaiting = true;
		msgSvc.wait(true);
		
		rxRepo.getList().then(okRxList, errRxList);
		
		function okRxList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			
			_rxListCache = Array.isArray(r.data) ? r.data : [];
			multi.list = buildRxMultiListFromRxData(_rxListCache, affs);
			
			// auto-select
			if(multi.list.length == 1 && multi.list[0].val != 'ALL') {
				vm.multiselectClick(multi, multi.list[0].val);
			}
			vm.multiselectTitle(multi, true);
		}
		
		function errRxList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			if(!!r) {
				errSvc.warn('Error loading pharmacy list', 'bulkEditCtl.loadRxListForMulti', r.status, utilSvc.http.safeResponse(r));
			}
			// Fallback to affiliation-based list
			multi.list = buildRxMultiListFromAffs(affs);
			vm.multiselectTitle(multi, true);
		}
	}

	function buildRxMultiListFromRxData(rxData, affs) {
		// Build a checklist with extended pharmacy data from rxRepo
		var result = [],
			allowedRxIds = {},
			aff, rx;
		
		// Build set of allowed RXIDs from affiliations (CP business model only)
		for(var i = 0; i < affs.length; i++) {
			aff = affs[i];
			if(aff.RXID && aff.RxBizModel == 'CP') {
				allowedRxIds[aff.RXID] = true;
			}
		}
		
		// Build list from rxData filtered by allowed RXIDs
		for(var j = 0; j < rxData.length; j++) {
			rx = rxData[j];
			if(!rx.Id || !allowedRxIds[rx.Id]) {
				continue;
			}
			// Only include active/onboarding pharmacies
			if(rx.ObjectState != 'ACTIVE' && rx.ObjectState != 'ONBOARDING') {
				continue;
			}
			// Only include DISPENSING or CENTRALFILL pharmacy types
			if(rx.Type != 'DISPENSING' && rx.Type != 'CENTRALFILL') {
				continue;
			}
			result.push({
				checked: false,
				val: rx.Id,
				lbl: validSvc.isText(rx.Name) ? rx.Name : rx.Id,
				division: validSvc.isText(rx.DivisionCode) ? rx.DivisionCode : '',
				storeNumber: validSvc.isText(rx.StoreNumber) ? rx.StoreNumber : '',
				npi: validSvc.isText(rx.NPI) ? rx.NPI : ''
			});
		}
		
		// sort by PHID
		result.sort(function(a, b) {
			return a.val.localeCompare(b.val);
		});
		
		return result;
	}

	function buildRxMultiListFromAffs(affs) {
		// Build a checklist with basic pharmacy data from affiliations
		// Filtered for ORDER_LIMIT: CP business model, DISPENSING or CENTRALFILL type
		var result = [],
			seen = {},
			aff;
		
		for(var i = 0; i < affs.length; i++) {
			aff = affs[i];
			if(!aff.RXID || seen[aff.RXID]) {
				continue;
			}
			// Only include CP business model
			if(aff.RxBizModel != 'CP') {
				continue;
			}
			// Only include DISPENSING or CENTRALFILL pharmacy types
			if(aff.RxType != 'DISPENSING' && aff.RxType != 'CENTRALFILL') {
				continue;
			}
			seen[aff.RXID] = true;
			result.push({
				checked: false,
				val: aff.RXID,
				lbl: validSvc.isText(aff.RxShortName) ? aff.RxShortName : aff.RXID,
				division: '',
				storeNumber: '',
				npi: ''
			});
		}
		
		// sort by label
		result.sort(function(a, b) {
			return a.lbl.localeCompare(b.lbl);
		});
		
		return result;
	}

	function setupProgAdminMulti(multi) {
		var affs = getAffs();

		multi.vals = [];
		multi.list = vm.multiselectBuild(utilSvc.aff.progAdminList(affs), false);

		// auto-select
		if(multi.list.length == 1 && multi.list[0].val != 'ALL') {
			vm.multiselectClick(multi, multi.list[0].val);
		}
		vm.multiselectTitle(multi, true);
		
		return multi;
	}

	function setupVenMulti(multi) {
		var affs = getAffs();

		multi.vals = [];
		multi.list = vm.multiselectBuild(utilSvc.aff.venList(affs, ['340B']), false);

		// auto-select
		if(multi.list.length == 1 && multi.list[0].val != 'ALL') {
			vm.multiselectClick(multi, multi.list[0].val);
		}
		vm.multiselectTitle(multi, true);

		return multi;
	}

	function resetSearchByProps(q) {
		q.SearchTitle = '';

		// reset filter swap
		q.Primary = 'CE';

		q.CE = newMultiValsProp();
		q.showCeMulti = false;
		vm.CeMulti.vals = [];
		vm.CeMulti.list = [];
		
		q.RX = newMultiValsProp();
		q.showRxMulti = false;
		vm.RxMulti.vals = [];
		vm.RxMulti.list = [];
		vm.RxMulti.fltId = '';
		vm.RxMulti.fltName = '';
		vm.RxMulti.fltDivision = '';
		vm.RxMulti.fltStoreNumber = '';
		vm.RxMulti.fltNPI = '';
		
		q.VEN = newMultiValsProp();
		q.showVenMulti = false;
		vm.VenMulti.vals = [];
		vm.VenMulti.list = [];
		
		q.ProgAdmin = newMultiValsProp();
		q.showProgAdminMulti = false;
		vm.ProgAdminMulti.vals = [];
		vm.ProgAdminMulti.list = [];
		
		return q;
	}

	function validSearchBy(q) {

		// reset query
		q.CE = newMultiValsProp();
		q.RX = newMultiValsProp();
		q.VEN = newMultiValsProp();
		q.ProgAdmin = newMultiValsProp();

		switch(q.SearchType) {
			case 'AFF':
				q.CE.vals = multiGetVals(vm.CeMulti);
				q.CE.fail = q.CE.vals.length > 0 ? 'no' : 'yes';
				q.RX.vals = multiGetVals(vm.RxMulti);
				q.RX.fail = q.RX.vals.length > 0 ? 'no' : 'yes';
				break;
			case 'RX':
				q.RX.vals = multiGetVals(vm.RxMulti);
				q.RX.fail = q.RX.vals.length > 0 ? 'no' : 'yes';
				break;
			case 'PROGADMIN':
				q.ProgAdmin.vals = multiGetVals(vm.ProgAdminMulti);
				q.ProgAdmin.fail = q.ProgAdmin.vals.length > 0 ? 'no' : 'yes';
				break;
			case 'VENDOR':
				q.VEN.vals = multiGetVals(vm.VenMulti);
				q.VEN.fail = q.VEN.vals.length > 0 ? 'no' : 'yes';
				break;
			default:
				throw new Error('bulkeditList.validSearchBy, unknown search by: ' + q.SearchType);
		}

		return q.CE.fail != 'yes' &&
			q.RX.fail != 'yes' &&
			q.VEN.fail != 'yes' &&
			q.ProgAdmin.fail != 'yes';
	}

	function validFindBulk(q) {
		switch(q.BulkType.val) {
			case 'AUTO_ORDER':
				var aoStat = q.AutoOrderStatus;
				aoStat.fail = aoStat.val != 'on' && aoStat.val != 'off' ? 'yes' : 'no';
				q.AutoOrderCategory = validAutoOrderCategory(q.AutoOrderCategory);

				// check schedule
				var schedOk = false;
				if(aoStat.val == 'off' || q.AutoOrderSchedule.Enabled == 'off') {
					q.AutoOrderSchedule = {Enabled:'off'};
					vm.AutoOrderSchedule = {};
					schedOk = true;
				}
				else {
					schedOk = vm.AutoOrderSchedule.fail == 'no';
					if(schedOk) {
						q.AutoOrderSchedule = JSON.parse(JSON.stringify(vm.AutoOrderSchedule)); // de-ref
					}
				}
				
				return aoStat.fail == 'no' &&
					q.AutoOrderCategory.fail == 'no' &&
					schedOk &&
					validSearchBy(q);
            
            case 'AUTO_ORDER_CANCEL':
                q.AutoOrderCategory = validAutoOrderCategory(q.AutoOrderCategory);
                return q.AutoOrderCategory.fail == 'no' && validSearchBy(q);

			case 'ORDER_LIMIT':
				var cfg = q.OrderLimitConfig;
				
				// package limits - non-negative integers, empty string treated as 0
				var dailyTotalPackageLimit = cfg.DailyTotalPackageLimit.val === '' ? 0 : parseInt(cfg.DailyTotalPackageLimit.val, 10);
				if(!validSvc.isInteger(dailyTotalPackageLimit) || dailyTotalPackageLimit < 0) {
					cfg.DailyTotalPackageLimit.fail = 'yes';
					cfg.DailyTotalPackageLimit.msg = 'required integer 0 or greater';
				}
				else {
					cfg.DailyTotalPackageLimit.val = dailyTotalPackageLimit;
					cfg.DailyTotalPackageLimit.fail = 'no';
					cfg.DailyTotalPackageLimit.msg = '';
				}

				var dailyNdcPackageLimit = cfg.DailyNDCPackageLimit.val === '' ? 0 : parseInt(cfg.DailyNDCPackageLimit.val, 10);
				if(!validSvc.isInteger(dailyNdcPackageLimit) || dailyNdcPackageLimit < 0) {
					cfg.DailyNDCPackageLimit.fail = 'yes';
					cfg.DailyNDCPackageLimit.msg = 'required integer 0 or greater';
				}
				else {
					cfg.DailyNDCPackageLimit.val = dailyNdcPackageLimit;
					cfg.DailyNDCPackageLimit.fail = 'no';
					cfg.DailyNDCPackageLimit.msg = '';
				}

				var dailyRefrigeratedPackageLimit = cfg.DailyRefrigeratedPackageLimit.val === '' ? 0 : parseInt(cfg.DailyRefrigeratedPackageLimit.val, 10);
				if(!validSvc.isInteger(dailyRefrigeratedPackageLimit) || dailyRefrigeratedPackageLimit < 0) {
					cfg.DailyRefrigeratedPackageLimit.fail = 'yes';
					cfg.DailyRefrigeratedPackageLimit.msg = 'required integer 0 or greater';
				}
				else {
					cfg.DailyRefrigeratedPackageLimit.val = dailyRefrigeratedPackageLimit;
					cfg.DailyRefrigeratedPackageLimit.fail = 'no';
					cfg.DailyRefrigeratedPackageLimit.msg = '';
				}
				
				// all fields must be valid (no errors)
				var hasErrors = cfg.DailyTotalPackageLimit.fail == 'yes' || 
					cfg.DailyNDCPackageLimit.fail == 'yes' || 
					cfg.DailyRefrigeratedPackageLimit.fail == 'yes';
				
				cfg.fail = hasErrors ? 'yes' : 'no';
				
				return cfg.fail == 'no' && validSearchBy(q);
			default:
				throw new Error('bulkEditCtl.validFindBulk, unknown bulk type: ' + q.BulkType.val);
		}
	}

	function findBulkTargets() {
		if(vm.isWaiting) {
			return;
		}
		vm.popup = {};

		var q = vm.query;
		if(!validFindBulk(q)) {
			msgSvc.ok('Cannot Search', 'Check Search By properties');
			return;
		}
		toggleWait(true);

		bulkEditRepo.findTargets(q).then(okTargets, errTargets);

		function okTargets(r) {
			toggleWait();

			// setup table view
			initTblViewSearchAndFilter(q.BulkType.val, q.SearchType);

			vm.tblSearch = tblSearchVM(r);

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: 'BULKEDIT_SEARCH',
				Size: vm.fltSearch.PageSize,
				Page: vm.fltSearch.Page,
				Total: vm.fltSearch.PageTotal,
				RowCount: vm.fltSearch.Count,
				ItemCount: vm.tblSearch.Items.length,
				DataCount: vm.tblSearch.DataItems.length
			});

			vm.flex = vm.flexCollapse(vm.flex, true);
			vm.flex.title = flexTitle(vm.query);

			vm.fltSearch = vm.tblViewSyncFilter(vm.tblViewSearchConfig, vm.tblViewSearch, vm.fltSearch, true);
			vm.fltSearch.Ready = true;

			vm.action = 'SEARCH';
		}

		function errTargets(r) {
			toggleWait();
			if(!!r) {
				errSvc.warn('unknown API error', 'adminBulkEditCtl.getTargets', r.status, utilSvc.http.safeResponse(r));
				init();
			}
		}
	}


	/**
	 *    RUN EDIT
	 */

	function editToggle(id) {
		if(vm.isWaiting || vm.action != 'SEARCH') {
			return;
		}

		var toggleAll = !validSvc.isText(id),
			editAll = false;
		if(toggleAll) {
			editAll = !vm.tblSearch.EditAll;
		}

		var editCount = 0,
			filteredItems = vm.filterList(vm.tblSearch.DataItems, vm.fltSearch, true),
			filteredIds = {};

		// create a map of all filtered items
		filteredItems.forEach(function(item) {
			filteredIds[item.uniqueId] = true;
		});

		vm.tblSearch.DataItems.forEach(function(item){
			if(filteredIds[item.uniqueId]) {
				if(toggleAll) {
					item.edit = editAll;
				}
				else if(item.uniqueId == id) {
					item.edit = !item.edit;
				}
				editCount += item.edit ? 1 : 0;
			}
			else {
				item.edit = false;
			}
		});

		vm.tblSearch.EditAll = editCount == filteredItems.length;
		vm.tblSearch.EditCount = editCount;
	}

	function runEdit() {
		if(vm.isWaiting || vm.action != 'SEARCH') {
			return;
		}
		vm.popup = {};

		var items = vm.tblSearch.DataItems,
			targets = [];
		items.forEach(function(item) {
			if(item.edit) {
				targets.push(item);
			}
		});

		if(targets.length < 1) {
			msgSvc.ok('Cannot Edit', 'Choose at least 1 item to edit.');
			return;
		}

		// confirm
		msgSvc.confirm({
			id: 'admin.bulkedit.confirm',
			title: vm.query.BulkTitle,
			msg: 'Apply Edit to ' + targets.length + ' items?',
			notes: {
				prompt: 'optional notes',
				maxlength: 100,
				out: ''
			},
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

		function userConfirm(r) {
			if(vm.isWaiting || !!!r || r.result != 'YES') {
				return;
			}
			toggleWait(true);
	
			r.notes = validSvc.isText(r.notes) ? r.notes : '';
			bulkEditRepo.runEdit(vm.query, targets, r.notes).then(okRunEdit, errRunEdit);
		}
	}


	function okRunEdit(r) {
		toggleWait();

		r = r || {};
		r.status = 200;
		parseEditResult(r);
	}

	function errRunEdit(r) {
		toggleWait();
		if(!!r) {
			if(r.status == 409) {
				msgSvc.ok('Cannot Bulk Edit', r.msg);
				toggleCreate();
			}
			else if(r.status == 422) {
				parseEditResult(r);
			}
			else {
				errSvc.warn('Unexpected api error', 'bulkedit.errRunEdit', r.status, utilSvc.http.safeResponse(r));
				toggleCreate();
			}
		}
	}

	function parseEditResult(r) {
		// get the stats
		r = r || {};
		var stats = r.EditStats || {};
		var received = validSvc.isInteger(stats.ReceivedCount) && stats.ReceivedCount > 0 ? stats.ReceivedCount : 0,
			processed = validSvc.isInteger(stats.ProcessedCount) && stats.ProcessedCount > 0 ? stats.ProcessedCount : 0,
			invalid = validSvc.isInteger(stats.InvalidCount) && stats.InvalidCount > 0 ? stats.InvalidCount : 0,
			errorCount = validSvc.isInteger(stats.ErrorCount) && stats.ErrorCount > 0 ? stats.ErrorCount : 0,
			errorResult = validSvc.isText(stats.ErrorResult) ? stats.ErrorResult : '';
		var invalidErrors = Array.isArray(r.InvalidErrors) ? r.InvalidErrors : [];

		var success = r.status == 200 &&
			processed == received &&
			invalid + errorCount + invalidErrors.length == 0 &&
			!errorResult;
									
		// all targets processed
		if(success) {
			msgSvc.ok(vm.query.BulkTitle + ' COMPLETE', processed + ' Edited Targets');
			toggleCreate();
			return;
		}

		// setup the edit result popup
		vm.popup = {
			show: true,
			action: 'EDIT_RESULT',
			title: 'Bulk Edit: ' + vm.query.BulkTitle,
			processed: processed,
			received: received,
			invalid: invalid,
			errorCount: errorCount,
			errorResult: errorResult,
			invalidErrors: invalidErrors
		};

		msgSvc.ok(vm.query.BulkTitle + ' WITH ERRORS', 'Invalid or error results found');
	}


	/**
	 * 		POPUP
	 */

	function closePopup() {
		// return to list view
		toggleCreate();
	}


	/**
	 * 	FILTER CHANGE
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {
			
			// filter values are stored inside table view columns
			vm.flt = vm.tblViewGetColumnFilterValues(vm.tblView.cols, vm.flt);
			
			vm.tbl.DataItems = Array.isArray(vm.tbl.DataItems) ? vm.tbl.DataItems : [];
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			$scope.$broadcast('widget.paging', {
				uniqueId: 'BULKEDIT_LIST',
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

		}, delayTime);
	}

	function filterChangeSearch(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.fltSearch.Ready) {
			return;
		}

		// mark filters dirty
		vm.fltSearch.Dirty = true;

		// already working
		if(vm.fltSearch.Busy) {
			return;
		}
		vm.fltSearch.Busy = true;
		vm.fltSearch.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {
			
			// filter values are stored inside table view columns
			vm.fltSearch = vm.tblViewGetColumnFilterValues(vm.tblViewSearch.cols, vm.fltSearch);
			
			vm.tblSearch.DataItems = Array.isArray(vm.tblSearch.DataItems) ? vm.tblSearch.DataItems : [];

			var editCount = 0,
				filteredItems = vm.filterList(vm.tblSearch.DataItems, vm.fltSearch, true),
				filteredIds = {};

			// create a map of all filtered items
			filteredItems.forEach(function(item) {
				filteredIds[item.uniqueId] = true;
			});

			// turn off edit for anything not in the filtered list
			vm.tblSearch.DataItems.forEach(function(item){
				if(filteredIds[item.uniqueId]) {
					if(item.edit) {
						editCount++;
					}
				}
				else {
					item.edit = false;
				}
			});
			vm.tblSearch.EditAll = editCount == filteredItems.length;
			vm.tblSearch.EditCount = editCount;

			vm.tblSearch.Items = vm.filterList(vm.tblSearch.DataItems, vm.fltSearch);
			vm.fltSearch.Busy = false;

			// run again? data changed during filtering
			if(vm.fltSearch.Dirty) {
				filterChange(true);
				return;
			}

			$scope.$broadcast('widget.paging', {
				uniqueId: 'BULKEDIT_SEARCH',
				Size: vm.fltSearch.PageSize,
				Page: vm.fltSearch.Page,
				Total: vm.fltSearch.PageTotal,
				RowCount: vm.fltSearch.Count,
				ItemCount: vm.tblSearch.Items.length,
				DataCount: vm.tblSearch.DataItems.length
			});

		}, delayTime);
	}


	/**
	 * 	TABLE VIEW
	 */

	function tblViewConfigListVM() {
		// feature defined tables with all columns

		var result = {
				name: 'LIST',
				sortby: '-CreatedDate',
				pgsize: 50,
				sections: {
					Use: {title:'Usage'},
					Tar: {title: 'Apply To'},
					Det: {title: 'Details'},
					Out: {title: 'Outcome'},
					Req: {title: 'Request'}
				}
			},
			cols = [
				{section:'Use', 		flt:'Text',		name:'Status', colWidth:"30px", title:'Status', desc:''},
				{section:'Use', 		flt:'Text',		name:'BulkType', colWidth:"40px", title:'Edit Type', desc:''},

				{section:'Tar', 		flt:'Text',		name:'TargetsTxt', colWidth:"100px", title:'Entity', desc:''},
				{section:'Det', 		flt:'Text',		name:'DetailsTxt', colWidth:"100px", title:'Change', desc:''},

				{section:'Out', 		flt:'Numbers',	name:'ReceivedCount', colWidth:"30px", title:'Received', desc:''},
				{section:'Out', 		flt:'Numbers',	name:'ProcessedCount', colWidth:"30px", title:'Processed', desc:''},
				{section:'Out', 		flt:'Numbers',	name:'ErrorCount', colWidth:"30px", title:'Errors', desc:''},

				{section:'Req', 		flt:'Dates',	name:'CreatedDate', colWidth:"40px", title:'Date', desc:''},
				{section:'Req', 		flt:'Text',		name:'CreatedBy', colWidth:"40px", title:'Created By', desc:''},
				{section:'Req', 		flt:'Text',		name:'Notes', colWidth:"50px", title:'Notes', desc:''}
			];
	
		return addConfigToSchema(result, cols);
	}

	function tblViewConfigSearchVM(bulkType, searchType) {
		// feature defined tables with all columns

		var result = {
				name: 'CREATE',
				sortby: '',
				pgsize: 50,
				sections: {
					Edit: {title:'Edit'},
					Ent: {title:'Entity'},
					Det: {title: 'More Information'}
				}
			},
			cols = [];

		// column options by bulk type and search
		var useCE = false,
			useRXID = false,
			useRX = false,
			useDivision = false,
			useStoreNumber = false,
			useVEN = false,
			useProgAdmin = false,
			useAccumGrp = false,
			useAcctNum = false,
			useDetails = false;
		switch(bulkType) {
			case 'AUTO_ORDER':
				useCE = true;
				useRX = true;
				useVEN = true;
				useProgAdmin = searchType == 'PROGADMIN';
				useAccumGrp = true;
				useAcctNum = true;
				useDetails = true;
				break;
			case 'AUTO_ORDER_CANCEL':
				useCE = true;
				useRX = true;
				useVEN = true;
				useProgAdmin = searchType == 'PROGADMIN';
				useAccumGrp = true;
				useAcctNum = true;
				useDetails = true;
				break;
			case 'ORDER_LIMIT':
				useRXID = true;
				useRX = true;
				useDivision = true;
				useStoreNumber = true;
				useDetails = true;
				break;
			default:
				// nothing is ok
		}

		// ENTITY COLUMNS
		if(useCE) {
			cols.push({
				section:'Ent', 	flt:'Text',		name:'CEID', colWidth:"40px", title:'Facility', desc:''
			});
		}
		if(useProgAdmin) {
			cols.push({
				section:'Ent', 	flt:'Text',		name:'TPAID', colWidth:"35px", title:'Program Admin', desc:''
			});
		}
		if(useRXID) {
			cols.push({
				section:'Ent', 	flt:'Text',		name:'RXID', colWidth:"40px", title:'Pharmacy ID', desc:''
			});
		}
		if(useRX) {
			cols.push({
				section:'Ent', 	flt:'Text',		name:'RxShortName', colWidth:"40px", title:'Pharmacy', desc:''
			});
		}
		if(useDivision) {
			cols.push({
				section:'Ent', 	flt:'Text',		name:'Division', colWidth:"30px", title:'Division', desc:''
			});
		}
		if(useStoreNumber) {
			cols.push({
				section:'Ent', 	flt:'Text',		name:'StoreNumber', colWidth:"30px", title:'Store #', desc:''
			});
		}
		if(useVEN) {
			cols.push({
				section:'Ent', 	flt:'Text',		name:'VENID', colWidth:"40px", title:'Vendor', desc:''
			});
		}

		// MORE INFO COLUMNS
		if(useAccumGrp) {
			cols.push({
				section:'Det', 	flt:'Text',		name:'AccumGroup', colWidth:"30px", title:'Accum Group', desc:''
			});
		}
		if(useAcctNum) {
			cols.push({
				section:'Det', 	flt:'Text',		name:'AcctNum', colWidth:"35px", title:'Acct #', desc:''
			});
		}
		if(useDetails) {
			cols.push({
				section:'Det', 	flt:'Text',		name:'DetailsTxt', colWidth:"45px", title:'Details', desc:''
			});
		}

		// sort by is first column
		if(cols.length > 0) {
			result.sortby = cols[0].name;
		}
	
		return addConfigToSchema(result, cols);
	}

	function addConfigToSchema(schema, cols) {
		// re-assign schema col array items into colKey map
		var col = {},
			colNames = [],
			colKeys = [];
		for(var i = 0; i < cols.length; i++) {
			col = cols[i];
			colNames.push(col.name);
			colKeys[col.name] = col;
		}

		// add to config object
		schema.cols = colNames;
		schema.colKeys = colKeys;

		return schema;
	}


	/**
	 *    EXCEL
	 *    file created on api server, expecting a binary file stream instead of JSON
	 */

	function getExcel(item) {
		if(!!!item || vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}
		toggleWait(true);

		// build filename
		var dtTxt = utilSvc.dt.toText(item.CreatedDate);
		dtTxt = dtTxt.replace(/\//g, '-');

        var bulkType = '';
        switch(item.BulkType) {
            case 'AUTO_ORDER':
                bulkType = 'AutoOrderConfig';
                break;
            case 'AUTO_ORDER_CANCEL':
                bulkType = 'AutoOrderCancel';
                break;
            case 'ORDER_LIMIT':
                bulkType = 'OrderLimit';
                break;
            default:
                bulkType = item.BulkType;
        }
		_pendingExcelFilename = 'Verity-BulkEdit-' + bulkType + '-' + dtTxt + '.xlsx';
		bulkEditRepo.getExcel(item.Id, _pendingExcelFilename).then(okServerExcel, errServerExcel);

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Create Excel Error', 'bulkEditList.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}


	/**
	 * 		MULTISELECT
	 */

	/**
	 * Filter RxMulti list based on current filter values
	 */
	function filterRxMultiList(multi) {
		var list = multi.list || [];
		return list.filter(function(item) {
			var matchId = !multi.fltId || (item.val && item.val.toLowerCase().indexOf(multi.fltId.toLowerCase()) > -1);
			var matchName = !multi.fltName || (item.lbl && item.lbl.toLowerCase().indexOf(multi.fltName.toLowerCase()) > -1);
			var matchDivision = !multi.fltDivision || (item.division && item.division.toLowerCase().indexOf(multi.fltDivision.toLowerCase()) > -1);
			var matchStoreNumber = !multi.fltStoreNumber || (item.storeNumber && item.storeNumber.toLowerCase().indexOf(multi.fltStoreNumber.toLowerCase()) > -1);
			var matchNPI = !multi.fltNPI || (item.npi && item.npi.toLowerCase().indexOf(multi.fltNPI.toLowerCase()) > -1);
			return matchId && matchName && matchDivision && matchStoreNumber && matchNPI;
		});
	}

	function multiClick(propName, val) {
		if(vm.isWaiting) {
			return;
		}
		vm.action = 'CREATE';

		var multi = vm[propName];

		// Handle select all visible (filtered) items
		if(val == '|SELECT_ALL|' && propName == 'RxMulti') {
			var filtered = filterRxMultiList(multi);
			filtered.forEach(function(item) {
				item.checked = true;
			});
			multi.vals = filtered.map(function(item) { return item.val; });
		}
		else {
			vm.multiselectClick(multi, val);
		}
		vm.multiselectTitle(multi, true);

		var q = vm.query;
		switch(propName) {
			case 'CeMulti':
				q.CE.fail = vm.CeMulti.vals.length > 0 ? 'no' : 'yes';
				if(vm.query.SearchType == 'AFF' && vm.query.Primary == 'CE') {
					// CE primary builds RX dependent
					q.showRxMulti = false;
					q.RX = newMultiValsProp();
					if(q.CE.fail == 'no') {
						vm.RxMulti = setupRxMulti(vm.RxMulti, multiGetVals(vm.CeMulti));
						q.showRxMulti = true;
					}
					q.RX.fail = vm.RxMulti.vals.length < 1 ? 'yes' : 'no';
				}
				break;
			case 'RxMulti':
				q.RX.fail = vm.RxMulti.vals.length > 0 ? 'no' : 'yes';
				if(vm.query.SearchType == 'AFF' && vm.query.Primary == 'RX') {
					// RX primary builds CE dependent
					q.showCeMulti = false;
					q.CE = newMultiValsProp();
					if(q.RX.fail == 'no') {
						vm.CeMulti = setupCeMulti(vm.CeMulti, multiGetVals(vm.RxMulti));
						q.showCeMulti = true;
					}
					q.CE.fail = vm.CeMulti.vals.length < 1 ? 'yes' : 'no';
				}
				break;
			case 'ProgAdminMulti':
				q.ProgAdmin.fail = vm.ProgAdminMulti.vals.length > 0 ? 'no' : 'yes';
				break;
			case 'VenMulti':
				q.VEN.fail = vm.VenMulti.vals.length > 0 ? 'no' : 'yes';
				break;
			default:
				throw new Error('ndcList.multiClick, unknown propName: ' + propName);
		}
	}

    function multiToggle(evt, id) {
		if(vm.isWaiting) {
			return;
		}
		vm.action = 'CREATE';

		var multi = vm[id],
			elemId = id == 'CeMulti' && vm.query.Primary == 'RX' ? id + 'Sec' : id; // CE secondary
		multiselectToggle(evt, multi, 'beCreate' + elemId);
	}

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if(vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		multiselect.flt = '';

		// don't bother with width if hiding
		if(multiselect.show) {
			multiselect.show = false;
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					console.log(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		var elemId = id == 'CeMulti' && vm.query.Primary == 'RX' ? id + 'Sec' : id; // CE secondary
		elem = document.getElementById(elemId);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;
	}

	function multiHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}

	function multiGetVals(multi) {
		// unpack the list into vals (support ALL)

		var result = [],
			checklist = multi.list,
			chk = {};

		var i = checklist.length > 0 && checklist[0].val == 'ALL' ? 1 : 0; // skip ALL checklist item

		for(i; i < checklist.length; i++) {
			chk = checklist[i];
			if(chk.checked) {
				result.push(chk.val);
			}
		}

		return result;
	}


	/**
	 * 	HELPERS
	 */

	function validIntegerProp(prop, min, max) {

		// parse into float
		var floatVal;
		try {
			floatVal = parseFloat(prop.val);
		}
		catch(err) {
			// do nothing
		}

		// not a number
		if(!validSvc.isInteger(floatVal)) {
			prop.fail = 'yes';
			prop.msg = 'must be an integer';
			return prop;
		}

		// min
		if(floatVal < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum: ' + min;
			return prop;
		}

		// max
		if(floatVal > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum: ' + max;
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';

		return prop;

	}

	function toggleWait(isOn) {
		vm.isWaiting = !!isOn;
		msgSvc.wait(!!isOn);
	}

}

 
bulkEditRepo.$inject = ['$rootScope', '$q', 'apiService', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
.module('espui.admin')
.factory('bulkEditRepo', bulkEditRepo);


/* @ngInject */
function bulkEditRepo($rootScope, $q, apiService, errSvc, eventSvc, utilSvc, validSvc, vmSvc) {

	var _currentPurl = '';

	// service definition
	var service = {
		getList: getList,
		findTargets: findTargets,
		runEdit: runEdit,
		getExcel: getExcel
	};

	return service;

	/**
	 * 	LIST
	 */

	function getList() {
		_currentPurl = 'admin/bulkedit/list';
		var defer = $q.defer();
		
		apiService.post(_currentPurl, {}).then(okGetList, errGetList);

		function okGetList(r) {
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errGetList(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 * 	TARGETS and RUN EDIT
	 * 	they share the same apiRequest JSON
	 */

	function bulkApiRequest(q) {
		var bt = q.BulkType.val;
		var request = {
			Context:{},
			Params:{
				BulkType: bt,
				SearchBy: q.SearchType,
				Config:{} // properties specific to bulk type
			}
		};

		// add config by bulk type
		var config = request.Params.Config;
		switch(bt) {
			case 'AUTO_ORDER':
            case 'AUTO_ORDER_CANCEL':
				config.AutoOrder = {
					Category: {
						Standard: q.AutoOrderCategory.STANDARD == 'yes',
						Specialty: q.AutoOrderCategory.SPECIALTY == 'yes',
						Dropship: q.AutoOrderCategory.DROPSHIP == 'yes'
					}
                };
                if(bt == 'AUTO_ORDER') {
                    config.AutoOrder.TurnOn = q.AutoOrderStatus.val == 'on';
                    config.AutoOrder.DefaultConfig = autoOrderConfigAPI(q.AutoOrderSchedule);
                }
				break;
			case 'ORDER_LIMIT':
				// No config needed for targets lookup
				break;
			default:
				throw new Error('bulkEditRepo.buildTargetsQuery, unknown bulk type: ' + bt);
		}

		// search by
		switch(q.SearchType) {
			case 'AFF':
				request.Context.CEID = q.CE.vals;
				request.Context.RXID = q.RX.vals;
				break;
			case 'RX':
				request.Context.RXID = q.RX.vals;
				break;
			case 'PROGADMIN':
				request.Context.TPAID = q.ProgAdmin.vals;
				break;
            case 'VENDOR':
                request.Context.VENID = q.VEN.vals;
                break;                
			default:
				throw new Error('bulkEditRepo.buildTargetsQuery, unknown search type: ' + q.SearchType);	
		}

		return request;
	}

	function findTargets(q) {
		_currentPurl = 'admin/bulkedit/targets';
		var defer = $q.defer();

		var apiRequest = bulkApiRequest(q);
		apiService.post(_currentPurl, apiRequest).then(okTargets, errTargets);


		function okTargets(r) {
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errTargets(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	function runEdit(q, targets, notes) {

		_currentPurl = 'admin/bulkedit/run';
		var defer = $q.defer();

		var apiRequest = bulkApiRequest(q);
		apiRequest.Params.Targets = targets;
		apiRequest.Params.Notes = notes;

		// Add ORDER_LIMIT config for run (not needed for targets)
		if(q.BulkType.val == 'ORDER_LIMIT') {
			apiRequest.Params.Config.OrderLimit = {
				DailyTotalPackageLimit: q.OrderLimitConfig.DailyTotalPackageLimit.val,
				DailyNDCPackageLimit: q.OrderLimitConfig.DailyNDCPackageLimit.val,
				DailyRefrigeratedPackageLimit: q.OrderLimitConfig.DailyRefrigeratedPackageLimit.val
			};
		}

		// call api
		apiService.post(_currentPurl, apiRequest).then(okRunEdit, errRunEdit);

		function okRunEdit(r) {
			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + ' repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errRunEdit(r) {
			if(!!r && r.status == 409 && !!r.data && validSvc.isText(r.data.error)) {
				r.msg = r.data.error;
				defer.reject(r);
			}
			else if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + ' repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 * 	EXCEL
	 */

	function getExcel(id, filename) {
		// params
		if(!validSvc.isText(id) || !validSvc.isText(filename)) {
			throw new Error('bulkeditRepo.getExcel, id and filename required');
		}

		var apiRequest = {
			Entity: {
				Id: id
			}
		};
		
		_currentPurl =  'admin/bulkedit/excel';
		var defer = $q.defer();

		apiService.postGetBinary(_currentPurl, apiRequest).then(okExcel, errExcel);
		
		function okExcel(r) {
			defer.resolve(r.data);
		}

		function errExcel(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	// HELPERS
	function autoOrderConfigAPI(model) {
		return {
			AutoOrdering: model.Enabled == 'on',
			OrderSchedule: {
				Type: model.Type,
				MonthOption: model.MonthOption,
				DayOfMonth: model.DayOfMonth,
				WeekOfMonth: model.WeekOfMonth,
				Occurs: model.Occurs,
				Days: model.Weekdays
			},
			AutoPlaceSendEDI: model.AutoPlaceSendEDI == 'yes',
			PlaceNow: model.PlaceNow == 'yes'
		};
	}
}
 
adtEditCtl.$inject = ['$scope', '$state', 'ceRepo', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc'];
angular
.module('espui.admin.ce')
.controller('AdtEditCtl', adtEditCtl);


/* @ngInject */
function adtEditCtl($scope, $state, ceRepo, validSvc, errSvc, utilSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this,
		_currentCE = '',
		_maps = [],
		_pendingEdit = null;

	// properties
	vm.isWaiting = false;
	vm.action = '';
	vm.canEdit = false;

	// droplists
	vm.StatusEventsDroplist = [];
	vm.VisitEventsDroplist = [];
	vm.StatMapToDroplist = [];

	// models
	vm.sani = {};
	vm.map = {};
	vm.visit = {};

	// popup
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;

	// open / close
	vm.ocToggle = ocToggle;

	// methods
	vm.statusToggle = statusToggle;

	// event editing
	vm.eventTitleClick = eventTitleClick;
	vm.eventAdd = eventAdd;
	vm.eventEditCancel = eventEditCancel;
	vm.eventSave = eventSave;
	vm.eventDelete = eventDelete;

	// sani
	vm.saniSave = saniSave;
	vm.saniEditCancel = saniEditCancel;
	vm.saniRepAdd = saniRepAdd;
	vm.saniRepDelete = saniRepDelete;

	// status conversions
	vm.statConvertAdd = statConvertAdd;
	vm.statConvertDelete = statConvertDelete;
	vm.statConvertsSave = statConvertsSave;
	vm.statConvertsCancel = statConvertsCancel;


	/**
	 *    INIT
	 */

	init();

	function init() {

		// params
		if(!validSvc.isText($state.params.CE)) {
			throw new Error('adtEditCtl.init, CEID required');
		}
		_currentCE = $state.params.CE;

		// editing?
		vm.canEdit = utilSvc.user.hasFeature($scope, 'admin.ce.adt');

		vm.StatMapToDroplist = utilSvc.ng.droplist(['INPATIENT', 'OUTPATIENT']);

		getAdtConfig();

	}


	/**
	 *    VIEW MODELS
	 */

	function saniVM(data) {

		var san = data || {};
		var sanReps = Array.isArray(san.Replace) ? san.Replace : [];

		return {
			expand: false,
			dirty: false,
			action: 'LIST',
			Delimiter: data.Delimiter,
			Replace: sanReps
		};

	}

	function statVM(data, maps) {

		// build status UI from adt mappings

		data = data || {};

		// build add event droplists
		var adtEvents = adtEventListVM('STAT', maps);
		vm.StatusEventsDroplist = adtEvents.Droplist;

		return {
			expand: false,
			dirtyConvert: false,
			action: 'LIST',
			model: {}, // filled by evt title click event
			Enabled: data.Enabled,
			ValidTrans: data.ValidTrans,
			EventList: adtEvents.EventList,
			Converts: data.Converts
		};

	}

	function visitVM(data, maps) {

		// build visit UI from adt mappings

		data = data || {};

		// build add event droplists
		var adtEvents = adtEventListVM('VISIT', maps);
		vm.VisitEventsDroplist = adtEvents.Droplist;

		return {
			expand: false,
			action: 'LIST',
			model: {}, // filled by evt title click event
			Enabled: data.Enabled,
			EventList: adtEvents.EventList
		};

	}


	/**
	 * ADT EVENTS
	 */

	function adtEventListVM(feat, maps) {

		if(feat != 'STAT' && feat != 'VISIT') {
			alert('adtEditCtl.adtAddEventDroplist, unknown feature: ' + feat);
			return;
		}

		var mapFeatureKey = adtMapFeatureKey(feat),
			uniqueEvents = [],
			eventList = [],
			map = {},
			i = 0;

		// unique list of event types
		for(i = 0; i < maps.length; i++) {
			map = maps[i];
			if(map.Feature == mapFeatureKey && uniqueEvents.indexOf(map.EventType) < 0) {
				uniqueEvents.push(map.EventType);
			}
		}
		uniqueEvents.sort();

		// build event titles list
		for(i = 0; i < uniqueEvents.length; i++) {
			eventList.push({
				Id: uniqueEvents[i],
				Desc: adtDescFromEventType(uniqueEvents[i]),
				hasFocus: false
			});
		}

		var result = {
			EventList: eventList,
			Droplist: [{label:'Choose an Event Type', value: 'NONE'}]
		};

		// build add event droplist
		var addEvents = adtEventTypes();
		for(i = 0; i < addEvents.length; i++) {
			if(uniqueEvents.indexOf(addEvents[i]) < 0) {
				result.Droplist.push({label: addEvents[i] + ' - ' + adtDescFromEventType(addEvents[i]), value: addEvents[i]});
			}
		}

		return result;

	}

	function adtEventVM(feat, evtId, maps) {

		if(feat != 'STAT' && feat != 'VISIT') {
			alert('adtEditCtl.adtEventVM, unknown feature: ' + feat);
			return;
		}

		var result = {};

		if(feat == 'STAT') {
			result = {
				dirty: false,
				Id: evtId,
				MessageType: validSvc.newProp(''),
				MRN: validSvc.newProp(''),
				StatusDate: validSvc.newProp(''),
				PatientStatus: validSvc.newProp(''),
				FirstName: validSvc.newProp(''),
				LastName: validSvc.newProp('')
			};
		}
		else {
			result = {
				dirty: false,
				Id: evtId,
				MessageType: validSvc.newProp(''),
				VisitNumber: validSvc.newProp(''),
				VisitNumberEF: validSvc.newProp(''),
				VisitDate: validSvc.newProp(''),
				VisitDateEF: validSvc.newProp(''),
				FirstName: validSvc.newProp(''),
				FirstNameEF: validSvc.newProp(''),
				LastName: validSvc.newProp(''),
				LastNameEF: validSvc.newProp(''),
				DateOfBirth: validSvc.newProp(''),
				DateOfBirthEF: validSvc.newProp(''),
				PatientAcct: validSvc.newProp(''),
				BenefitLevel: validSvc.newProp('')
			};
		}

		// find values in maps array
		var map = {},
			mapFeatureKey = adtMapFeatureKey(feat),
			fieldName = '';
		for(var i = 0; i < maps.length; i++) {
			map = maps[i];
			if(map.Feature == mapFeatureKey && map.EventType == evtId) {
				fieldName = map.FieldName;
				if(!!result[fieldName]) {
					result[fieldName].val = validSvc.isText(map.Field) ? map.Field : '';

					if(feat == 'VISIT' && fieldName != 'MessageType' && fieldName != 'PatientAcct' && fieldName != 'BenefitLevel') {
						fieldName += 'EF';
						result[fieldName].val = validSvc.isText(map.EventField) ? map.EventField : '';
					}
				}
			}
		}

		return result;

	}


	/**
	 *    GET DETAIL
	 */

	function getAdtConfig() {

		ceRepo.getAdtConfig(_currentCE).then(okGetConfig, errGetConfig);

		function okGetConfig(r) {

			_maps = r.Maps;
			vm.sani = saniVM(r.Sani);
			vm.stat = statVM(r.Status, _maps);
			vm.visit = visitVM(r.Visit, _maps);

			ocTitles();

			// restore UI state after editing
			if(_pendingEdit) {

				switch(_pendingEdit.feat) {

					case 'SANI':
						vm.sani.expand = true;
						break;

					case 'STAT':
					case 'VISIT':
						var featObj = _pendingEdit.feat == 'STAT' ? vm.stat : vm.visit;
						featObj.expand = true;

						if((_pendingEdit.type == 'FEATSTATUS' || _pendingEdit.type == 'EVENTSAVE') && validSvc.isText(_pendingEdit.evtId)) {
							eventTitleClick(_pendingEdit.feat, _pendingEdit.evtId);
						}
						else if(vm.stat.EventList.length > 0) {
							eventTitleClick(_pendingEdit.feat, vm.stat.EventList[0].Id);
						}
						break;

					default:
						alert('adtEditCtl.getAdtConfig, unknown pending feature: ' + _pendingEdit.feat);
				}
				_pendingEdit = null;
			}

		}

		function errGetConfig(r) {
			if(r !== null) {
				errSvc.warn('Facility Id not found: ' + _currentCE, 'adtEditCtl.getAdtConfig.err', r.status, utilSvc.http.safeResponse(r));
			}
			$state.go('admin.ce.list');
		}

	}


	/**
	 *    OPEN CLOSE
	 */

	function ocTitles() {

		// sani title
		vm.sani.title = 'Sanitizer';
		if(vm.sani.Replace.length > 0) {
			vm.sani.title += ' - ' + vm.sani.Replace.length.toString() + ' Replacements Configured';
		}

		// status title
		vm.stat.title = 'Patient Status';
		if(vm.stat.EventList.length > 0) {
			vm.stat.title += ' - ' + vm.stat.EventList.length.toString() + ' Events Configured';
		}

		// visits title
		vm.visit.title = 'Patient Visits';
		if(vm.visit.EventList.length > 0) {
			vm.visit.title += ' - ' + vm.visit.EventList.length.toString() + ' Events Configured';
		}

	}

	function toggleDirty(feat, ocState) {

		// check if another toggle section is dirty

		var result = false,
			errTitle = '';

		if(ocState) {
			if(feat != 'STAT' && !!vm.stat && !!vm.stat.model && (!!vm.stat.model.dirty || vm.stat.dirtyConvert)) {
				errTitle = 'Patient Status';
				result = true;
			}
			else if(feat != 'SANI' && !!vm.sani && vm.sani.dirty) {
				errTitle = 'Sanitizer';
				result = true;
			}
			else if(feat != 'VISIT' && !!vm.visit && !!vm.visit.model && !!vm.visit.model.dirty) {
				errTitle = 'Patient Visit';
				result = true;
			}
		}

		if(result) {
			msgSvc.ok(errTitle + ' Edit In Progress', 'Please save or cancel ' + errTitle + ' changes before opening another section.');
		}

		return result;
	}

	function ocToggle(feat) {

		var ocState = false;

		switch(feat) {

			case 'STAT':
			case 'VISIT':
				var featObj = feat == 'STAT' ? vm.stat : vm.visit;
				ocState = !featObj.expand;

				// exit if other section is dirty
				if(toggleDirty(feat, ocState)) {
					return;
				}

				vm.popup = {};
				vm.sani.expand = false;
				vm.stat.expand = false;
				vm.visit.expand = false;
				featObj.expand = ocState;

				if(featObj.expand) {

					// title already clicked?
					if(featObj.action == 'EDIT' && modelIsEditing(featObj.model)) {
						return;
					}
					else if(featObj.EventList.length > 0) {
						// click first one
						eventTitleClick(feat, featObj.EventList[0].Id);
					}
				}
				break;

			case 'SANI':

				ocState = !vm.sani.expand;

				// exit if other section is dirty
				if(toggleDirty(feat, ocState)) {
					return;
				}

				vm.stat.expand = false;
				vm.visit.expand = false;
				vm.sani.expand = ocState;
				break;

			default:
				alert('adtEditCtl.ocToggle, unknown toggle type: ' + feat);
				getAdtConfig();
		}

	}


	/**
	 *    SANITIZER
	 */

	function saniRepValid(rep) {

		rep = rep || {};
		rep.fail = 'no';

		// validate From
		var edt = validText(validSvc.newProp(rep.From), 2, 20);
		if(edt.fail == 'yes') {
			rep.msg = 'From: ' + edt.msg;
			rep.fail = 'yes';
		}

		// validate To
		edt = validText(validSvc.newProp(rep.To), 2, 20);
		if(edt.fail == 'yes') {
			rep.msg += rep.fail == 'yes' ? ', To: ' : 'To: ';
			rep.msg += edt.msg;
			rep.fail = 'yes';
		}

		return rep;

	}

	function saniValid(s) {

		if(validSvc.isText(s.Delimiter.val)) {
			s.Delimiter = validText(s.Delimiter, 2, 20);
		}
		else {
			s.Delimiter.fail = '';
		}

		var reps = s.Replace,
			rep = {},
			edt = {},
			uniqueRepFrom = [],
			repOk = true;

		for(var i = 0; i < reps.length; i++) {
			rep = reps[i];
			rep = saniRepValid(rep);
			if(rep.fail == 'yes') {
				repOk = false;
			}

			// From should be unique
			if(validSvc.isText(rep.From)) {
				if(uniqueRepFrom.indexOf(rep.From) < 0) {
					uniqueRepFrom.push(rep.From);
				}
				else {
					rep.fail = 'yes';
					rep.msg = 'From: already used';
					repOk = false;
				}
			}
		}

		return s.Delimiter.fail != 'yes' && repOk;
	}

	function saniSave() {

		if(vm.isWaiting) {
			return;
		}

		if(!saniValid(vm.sani)) {
			msgSvc.ok('Cannot Save', 'Check properties');
			return;
		}

		_pendingEdit = {
			type: 'SANI',
			feat: 'SANI'
		};

		saveAdt();
	}

	function saniEditCancel() {

		if(vm.isWaiting) {
			return;
		}

		vm.sani.dirty = false;
		getAdtConfig();
	}

	function saniRepAdd() {

		if(vm.isWaiting) {
			return;
		}

		vm.sani.Replace.push({
			From: '',
			To: '',
			fail: '',
			msg: ''
		});

		vm.sani.dirty = true;

	}

	function saniRepDelete(repFrom) {

		var reps = vm.sani.Replace;
		for(var i = reps.length - 1; i >= 0; i--) {
			if(reps[i].From == repFrom) {
				reps.splice(i, 1);
				vm.sani.dirty = true;
			}
		}
	}


	/**
	 * 	STATUS CONVERSIONS
	 */

	function statConvertAdd() {

		if(vm.isWaiting) {
			return;
		}

		vm.stat.Converts.push({
			From: '',
			To: '',
			fail: '',
			msg: ''
		});

		vm.stat.dirtyConvert = true;

	}

	function statConvertDelete(from) {

		var items = vm.stat.Converts;
		for(var i = items.length - 1; i >= 0; i--) {
			if(items[i].From == from) {
				items.splice(i, 1);
				vm.stat.dirtyConvert = true;
			}
		}
	}

	function statConvertValid(item) {

		item = item || {};
		item.fail = 'no';

		// validate From
		var edt = validText(validSvc.newProp(item.From), 1, 20);
		if(edt.fail == 'yes') {
			item.msg = 'From: ' + edt.msg;
			item.fail = 'yes';
		}

		// validate To (dropdown value, not free text)
		if(!validSvc.isText(item.To)) {
			item.msg += item.fail == 'yes' ? ', To: ' : 'To: ';
			item.msg += 'required';
			item.fail = 'yes';
		}

		return item;

	}

	function statConvertsValid(items) {

		items = Array.isArray(items) ? items : [];

		var item = {},
			uniqueConvertFrom = [],
			result = true,
			hasIN = false,
			hasOUT = false;

		for(var i = 0; i < items.length; i++) {
			item = items[i];
			item = statConvertValid(item);
			if(item.fail == 'yes') {
				result = false;
			}

			// From should be unique
			if(validSvc.isText(item.From)) {
				if(uniqueConvertFrom.indexOf(item.From) < 0) {
					uniqueConvertFrom.push(item.From);
				}
				else {
					item.fail = 'yes';
					item.msg = 'From: already used';
					result = false;
				}
			}

			if(item.fail == 'no') {
				if(!hasIN && item.To == 'INPATIENT') {
					hasIN = true;
				}
				if(!hasOUT && item.To == 'OUTPATIENT') {
					hasOUT = true;
				}
			}
		}

		if(!result) {
			return 'Check Code Conversion values';
		}
		else if (result && items.length > 0 && (!hasIN || !hasOUT)) {
			// To must have at least 1 IN and OUT
			return 'Conversion values must have at least 1 INPATIENT and 1 OUTPATIENT defined.';
		}
		else {
			return null;
		}

	}

	function statConvertsSave() {

		if(vm.isWaiting) {
			return;
		}

		// event model is dirty?
		if(!!vm.stat.model && !!vm.stat.model.dirty) {
			msgSvc.ok('Cannot Save', 'ADT Event editing in progress above, save events before saving conversions.');
			return;
		}

		var errConvertValid = statConvertsValid(vm.stat.Converts);
		if(validSvc.isText(errConvertValid)) {
			msgSvc.ok('Cannot Save', errConvertValid);
			return;
		}

		// re-validate and save ADT events JIC
		eventSave('STAT', 'STATCONVERT');

	}

	function statConvertsCancel() {

		if(vm.isWaiting) {
			return;
		}

		// event model is dirty?
		if(!!vm.stat.model && !!vm.stat.model.dirty) {
			msgSvc.ok('Cannot Cancel', 'ADT Event editing in progress above, save events before saving conversions.');
			return;
		}

		getAdtConfig();

	}


	/**
	 *    ADT EVENT LIST / SAVE
	 */

	function eventTitleClick(feat, evtId) {

		// parse mappings and load edit model when event title is clicked

		if(vm.isWaiting) {
			return;
		}

		if(feat != 'STAT' && feat != 'VISIT') {
			alert('adtEditCtl.eventTitleClick, unknown feature: ' + feat);
			return;
		}

		var featObj = feat == 'STAT' ? vm.stat : vm.visit,
			eventList = feat == 'STAT' ? vm.stat.EventList : vm.visit.EventList;

		if(modelIsEditing(featObj.model)) {
			msgSvc.ok('Edit In Progress', 'Save current event before changing to another event.');
			return;
		}

		// set focus on title clicked
		var idx = setFocusById(eventList, evtId);
		if(idx < 0) {
			alert('adtEditCtl.eventTitleClick, event list title not found: ' + feat + '/' + evtId);
			getAdtConfig();
			return;
		}

		// load event id from maps
		featObj.model = adtEventVM(feat, evtId, _maps);
		featObj.action = 'EDIT';

	}

	function eventAdd(feat, evtId) {

		if(vm.isWaiting) {
			return;
		}

		if(feat != 'STAT' && feat != 'VISIT') {
			alert('adtEditCtl.eventAdd, unknown feature: ' + feat);
			return;
		}

		if(evtId == 'NONE') {
			msgSvc.ok('Cannot Add', 'Please choose an event type');
			return;
		}

		var featObj = feat == 'STAT' ? vm.stat : vm.visit;
		featObj.EventList.push({
			Id: evtId,
			Desc: adtDescFromEventType(evtId),
			hasFocus: false
		});

		// refresh add droplist
		if(feat == 'STAT') {
			vm.StatusEventsDroplist = buildAdtAddDroplist(featObj.EventList);
		}
		else {
			vm.VisitEventsDroplist = buildAdtAddDroplist(featObj.EventList);
		}

		// clone
		if(validSvc.isText(vm.popup.cloneFromId)) {

			// get cloned event data from maps
			featObj.model = adtEventVM(feat, vm.popup.cloneFromId, _maps);
			featObj.model.Id = evtId;
			featObj.model.dirty = true;
			featObj.action = 'EDIT';

			var idx = setFocusById(featObj.EventList, evtId);
			if(idx < 0) {
				alert('adtEditCtl.eventAddClone, event list title not found: ' + feat + '/' + evtId);
				getAdtConfig();
				return;
			}

			msgSvc.ok(evtId + ' Event Created From ' + vm.popup.cloneFromId, 'Save changes to keep the cloned data.');
		}
		else {
			eventTitleClick(feat, evtId);
		}

		vm.popup = {};

	}

	function eventEditCancel(feat) {

		if(vm.isWaiting) {
			return;
		}

		if(feat != 'STAT' && feat != 'VISIT') {
			alert('adtEditCtl.eventEditCancel, unknown feature: ' + feat);
			return;
		}

		var featObj = feat == 'STAT' ? vm.stat : vm.visit;

		// enable a reload
		featObj.model.dirty = false;

		// reload from mappings array
		eventTitleClick(feat, featObj.model.Id);
		msgSvc.ok('Changes Discarded', featObj.model.Id + ' values returned to last saved');

	}

	function validStatEvent(m) {

		// required
		m.MessageType = validText(m.MessageType, 5, 20);
		m.MRN = validText(m.MRN, 5, 20);
		m.StatusDate = validText(m.StatusDate, 5, 20);
		m.PatientStatus = validText(m.PatientStatus, 5, 20);
		m.FirstName = validText(m.FirstName, 5, 20);
		m.LastName = validText(m.LastName, 5, 20);

		return m.MessageType.fail != 'yes' &&
			m.MRN.fail != 'yes' &&
			m.StatusDate.fail != 'yes' &&
			m.PatientStatus.fail != 'yes' &&
			m.FirstName.fail != 'yes' &&
			m.LastName.fail != 'yes';
	}

	function validVisitEvent(m) {

		// required
		m.MessageType = validText(m.MessageType, 5, 20);
		m.VisitNumber = validText(m.VisitNumber, 5, 20);
		m.VisitDate = validText(m.VisitDate, 5, 20);
		m.FirstName = validText(m.FirstName, 5, 20);
		m.LastName = validText(m.LastName, 5, 20);
		m.DateOfBirth = validText(m.DateOfBirth, 5, 20);

		// patient acct is optional
		if(validSvc.isText(m.PatientAcct.val)) {
			m.PatientAcct = validText(m.PatientAcct, 1, 30);
		}
		else {
			m.PatientAcct.fail = '';
		}

		// benefit level is optional
		if(validSvc.isText(m.BenefitLevel.val)) {
			m.BenefitLevel = validText(m.BenefitLevel, 1, 30);
		}
		else {
			m.BenefitLevel.fail = '';
		}

		return m.MessageType.fail != 'yes' &&
			m.VisitNumber.fail != 'yes' &&
			m.VisitDate.fail != 'yes' &&
			m.FirstName.fail != 'yes' &&
			m.LastName.fail != 'yes' &&
			m.DateOfBirth.fail != 'yes' &&
			m.PatientAcct.fail != 'yes' &&
			m.BenefitLevel.fail != 'yes';

	}

	function mapAddEventVM(feat, evtId, fld, val, ef) {

		return {
			Feature: feat,
			EventType: evtId,
			FieldName: fld,
			Field: val,
			EventField: validSvc.isText(ef) ? ef : '',
			fail: '',
			msg: ''
		};

	}

	function eventSave(feat, editType) {

		if(vm.isWaiting) {
			return;
		}

		if(feat != 'STAT' && feat != 'VISIT') {
			alert('adtEditCtl.eventSave, unknown feature: ' + feat);
			return;
		}

		var validModel = feat == 'STAT' ? validStatEvent(vm.stat.model) : validVisitEvent(vm.visit.model);
		if(!validModel) {
			msgSvc.ok('Cannot Save', 'Check property values');
			return;
		}

		if(feat == 'STAT' && vm.stat.dirtyConvert) {
			var errConvertValid = statConvertsValid(vm.stat.Converts);
			if(!!validSvc.isText(errConvertValid)) {
				msgSvc.ok('Cannot Save', errConvertValid);
				return;
			}
		}

		var featObj = feat == 'STAT' ? vm.stat : vm.visit,
			mapFeatureKey = adtMapFeatureKey(feat),
			m = featObj.model;

		var map = {},
			evtId = m.Id,
			evtField = m.MessageType.val;

		// remove event values from maps
		for(var i = _maps.length - 1; i >= 0; i--) {
			map = _maps[i];
			if(map.Feature == mapFeatureKey && map.EventType == evtId) {
				_maps.splice(i, 1);
			}
		}

		// add event to maps
		if(feat == 'STAT') {
			_maps.push(mapAddEventVM(mapFeatureKey, evtId, 'MessageType', evtField, evtField));
			_maps.push(mapAddEventVM(mapFeatureKey, evtId, 'MRN', m.MRN.val, evtField));
			_maps.push(mapAddEventVM(mapFeatureKey, evtId, 'StatusDate', m.StatusDate.val, evtField));
			_maps.push(mapAddEventVM(mapFeatureKey, evtId, 'PatientStatus', m.PatientStatus.val, evtField));
			_maps.push(mapAddEventVM(mapFeatureKey, evtId, 'FirstName', m.FirstName.val, evtField));
			_maps.push(mapAddEventVM(mapFeatureKey, evtId, 'LastName', m.LastName.val, evtField));
		}
		else {
			_maps.push(mapAddEventVM(mapFeatureKey, evtId, 'MessageType', evtField, evtField));
			_maps.push(mapAddEventVM(mapFeatureKey, evtId, 'VisitNumber', m.VisitNumber.val, evtField)); // EF fields tbd... validSvc.isText(m.VisitNumberEF.val) ? m.VisitNumberEF.val : evtField));
			_maps.push(mapAddEventVM(mapFeatureKey, evtId, 'VisitDate', m.VisitDate.val, evtField)); // EF fields tbd... validSvc.isText(m.VisitDateEF.val) ? m.VisitDateEF.val : evtField));
			_maps.push(mapAddEventVM(mapFeatureKey, evtId, 'FirstName', m.FirstName.val, evtField)); // EF fields tbd... validSvc.isText(m.FirstNameEF.val) ? m.FirstNameEF.val : evtField));
			_maps.push(mapAddEventVM(mapFeatureKey, evtId, 'LastName', m.LastName.val, evtField)); // EF fields tbd... validSvc.isText(m.LastNameEF.val) ? m.LastNameEF.val : evtField));
			_maps.push(mapAddEventVM(mapFeatureKey, evtId, 'DateOfBirth', m.DateOfBirth.val, evtField)); // EF fields tbd... validSvc.isText(m.DateOfBirthEF.val) ? m.DateOfBirthEF.val : evtField));

			if(validSvc.isText(m.PatientAcct.val)) {
				_maps.push(mapAddEventVM(mapFeatureKey, evtId, 'PatientAcct', m.PatientAcct.val, evtField));
			}

			if(validSvc.isText(m.BenefitLevel.val)) {
				_maps.push(mapAddEventVM(mapFeatureKey, evtId, 'BenefitLevel', m.BenefitLevel.val, evtField));
			}
		}

		_pendingEdit = {
			type: editType,
			feat: feat,
			evtId: evtId,
			titleTxt: mapFeatureKey
		};

		saveAdt();

	}

	function eventDelete(feat, evtId) {

		if(vm.isWaiting) {
			return;
		}

		if(feat != 'STAT' && feat != 'VISIT') {
			alert('adtEditCtl.eventSave, unknown feature: ' + feat);
			return;
		}

		_pendingEdit = {
			type: 'EVENTDELETE',
			feat: feat,
			evtId: evtId,
			titleTxt: adtMapFeatureKey(feat)
		};

		msgSvc.confirm({
			id: 'ce.adt.event.delete',
			title: 'Delete ' + _pendingEdit.titleTxt + ' event ' + evtId,
			msg: 'Confirm delete, this is not reversable.',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(eventDeleteConfirm, eventDeleteConfirm);

	}

	function eventDeleteConfirm(r) {

		if(!!r && r.result == 'YES') {

			var map = {},
				mapFeatureKey = adtMapFeatureKey(_pendingEdit.feat),
				evtId = _pendingEdit.evtId;

			// remove event from maps array
			for(var i = _maps.length - 1; i >= 0; i--) {
				map = _maps[i];
				if(map.Feature == mapFeatureKey && map.EventType == evtId) {
					_maps.splice(i, 1);
				}
			}

			saveAdt();
		}
	}

	function statusToggle(feat) {

		if(vm.isWaiting) {
			return;
		}

		var featObj = {},
			featTitleTxt = '',
			isValidTrans = false;

		switch(feat) {

			case 'STAT':
				featObj = vm.stat;
				featTitleTxt = 'Patient Status';
				break;

			case 'VALIDTRANS':
				isValidTrans = true;
				feat = 'STAT'; // change to use parent feature
				featObj = vm.stat;
				featTitleTxt = 'Validate Split Transactions';
				break;

			case 'VISIT':
				featObj = vm.visit;
				featTitleTxt = 'Patient Visit Status';
				break;

			default:
				alert('adtEditCtl.eventSave, unknown feature: ' + feat);
				return;
		}

		// event is being edited?
		var evtId = '';
		if(featObj.action == 'EDIT') {

			// dirty
			if(modelIsEditing(featObj.model)) {
				msgSvc.ok('Edit In Progress', 'Save current event before adjusting status.');
				return;
			}

			// set the feature id
			if(featObj.model && validSvc.isText(featObj.model.Id) && mapExists(adtMapFeatureKey(feat), featObj.model.Id)) {
				evtId = featObj.model.Id;
			}

		}

		// update model
		if(isValidTrans) {
			featObj.ValidTrans = featObj.ValidTrans == 'yes' ? 'no' : 'yes';
		}
		else {
			featObj.Enabled = featObj.Enabled == 'yes' ? 'no' : 'yes';
		}

		_pendingEdit = {
			type: 'FEATSTATUS',
			feat: feat,
			evtId: evtId,
			titleTxt: featTitleTxt
		};

		saveAdt();

	}

	function saveAdt() {

		vm.isWaiting = true;
		ceRepo.saveAdtConfig(_currentCE, _maps, vm.sani, vm.stat, vm.visit).then(okSaveAdt, errSaveAdt);

	}

	function okSaveAdt() {
		vm.isWaiting = false;

		var titleTxt = 'ADT Config Saved',
			msgTxt = '';

		if(_pendingEdit) {
			switch(_pendingEdit.type) {

				case 'SANI':
					titleTxt = 'Sanitizer Saved';
					break;

				case 'STATCONVERT':
					titleTxt = 'Patient Status Conversions Saved';
					break;

				case 'FEATSTATUS':
					titleTxt = _pendingEdit.titleTxt + ' Saved';
					break;

				case 'EVENTSAVE':
					titleTxt = _pendingEdit.titleTxt + ' Event ' + _pendingEdit.evtId + ' Saved';
					break;

				case 'EVENTDELETE':
					titleTxt = _pendingEdit.titleTxt + ' Event ' + _pendingEdit.evtId + ' Deleted';
					break;
			}
		}

		msgSvc.ok(titleTxt, msgTxt);
		getAdtConfig();

	}

	function errSaveAdt(r) {
		vm.isWaiting = false;

		if(!!!r) {
			// already handled
		}
		else if(r.status === 422) {
			msgSvc.ok('Cannot Save', 'Check property values');
			// task: assign model based on pending type
		}
		else {
			errSvc.error('Unexpected api error', 'adtEditCtl.errSaveAdt', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    POPUP
	 */

	function buildAdtAddDroplist(el) {

		// get events already added
		var evtAdded = [],
			i = 0;
		for(i = 0; i < el.length; i++) {
			evtAdded.push(el[i].Id);
		}

		// all events
		var result = [{label:'Choose an Event Type', value: 'NONE'}],
			addEvents = adtEventTypes();

		// add if doesn't exist already
		for(i = 0; i < addEvents.length; i++) {
			if(evtAdded.indexOf(addEvents[i]) < 0) {
				result.push({label: addEvents[i] + ' - ' + adtDescFromEventType(addEvents[i]), value: addEvents[i]});
			}
		}

		return result;
	}

	function openPopup(evt, feat, cloneFromId) {

		// shared handler to open editing and import popups

		if(vm.isWaiting) {
			return;
		}

		if(feat != 'STAT' && feat != 'VISIT') {
			alert('adtEditCtl.openPopup, unknown feature: ' + feat);
			return;
		}

		// check if already editing and dirty
		var featObj = feat == 'STAT' ? vm.stat : vm.visit;
		if(modelIsEditing(featObj.model)) {
			msgSvc.ok('Edit In Progress', 'Save current event before adding a new one.');
			return;
		}
		featObj.action = 'ADDEVENT';

		vm.popup = {
			EventId: 'NONE',
			type: feat,
			title: '',
			ready: false,
			cloneFromId: ''
		};

		// clone?
		if(validSvc.isText(cloneFromId)) {
			vm.popup.cloneFromId = cloneFromId;
			vm.popup.title = 'Clone From ' + cloneFromId + ' To New ';
			vm.popup.title += feat == 'STAT' ? 'Status Event' : 'Visit Event';
		}
		else {
			vm.popup.title = feat == 'STAT' ? 'Add New Status Event' : 'Add New Visit Event';
		}

		vm.popup.ready = true;

	}

	function closePopup(feat) {

		if(feat != 'STAT' && feat != 'VISIT') {
			alert('adtEditCtl.closePopup, unknown feature: ' + feat);
			return;
		}

		var featObj = feat == 'STAT' ? vm.stat : vm.visit;

		// toggle off
		featObj.action = !!featObj.model ? 'EDIT' : 'LIST';
		if(featObj.action == 'LIST' && featObj.EventList.length > 0) {
			// click first one
			eventTitleClick(feat, featObj.EventList[0].Id);
		}

		vm.popup = {};
	}


	/**
	 *    HELPERS
	 */

	function validText(prop, min, max) {

		// required
		if(!validSvc.isText(prop.val)) {
			prop.fail = 'yes';
			prop.msg = 'required';
			return prop;
		}

		// min
		if(prop.val.length < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum ' + min.toString() + ' characters';
			return prop;
		}

		// max
		if(prop.val.length > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum ' + max.toString() + ' characters';
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;

	}

	function findById(items, id) {
		for(var i = 0; i < items.length; i++ ) {
			if(items[i].Id == id) {
				return i;
			}
		}
		return -1;
	}

	function mapExists(featureKey, evtId) {
		for(var i = 0; i < _maps.length; i++ ) {
			if(_maps[i].Feature == featureKey && _maps[i].EventType == evtId) {
				return true;
			}
		}
		return false;
	}

	function setFocusById(items, id) {
		var result = -1;
		for(var i = 0; i < items.length; i++ ) {
			if(items[i].Id == id) {
				result = i;
				items[i].hasFocus = true;
			}
			else {
				items[i].hasFocus = false;
			}
		}
		return result;
	}

	function adtEventTypes() {
		return [
			'A01',
			'A02',
			'A03',
			'A04',
			'A05',
			'A06',
			'A07',
			'A08',
			'A09',
			'A10',
			'A11',
			'A12',
			'A13',
			'A14',
			'A15',
			'A16',
			'A17',
			'A18',
			'A19',
			'A20',
			'A21',
			'A22',
			'A23',
			'A24',
			'A25',
			'A26',
			'A27',
			'A28',
			'A29',
			'A30',
			'A31',
			'A32',
			'A33',
			'A34',
			'A35',
			'A36',
			'A37',
			'A38',
			'A39',
			'A40',
			'A41',
			'A42',
			'A43',
			'A44',
			'A45',
			'A46',
			'A47',
			'A48',
			'A49',
			'A50',
			'A51'
		];

	}

	function adtDescFromEventType(et) {
		switch(et) {
			case 'A01':
				return 'Admit/visit notification';
			case 'A02':
				return 'Transfer a patient';
			case 'A03':
				return 'Discharge/end visit';
			case 'A04':
				return 'Register a patient';
			case 'A05':
				return 'Pre-admit a patient';
			case 'A06':
				return 'Change an outpatient to an inpatient';
			case 'A07':
				return 'Change an inpatient to an outpatient';
			case 'A08':
				return 'Update patient information';
			case 'A09':
				return 'Patient departing - tracking';
			case 'A10':
				return 'Patient arriving - tracking';
			case 'A11':
				return 'Cancel admit/visit notification';
			case 'A12':
				return 'Cancel transfer';
			case 'A13':
				return 'Cancel discharge/end visit';
			case 'A14':
				return 'Pending admit';
			case 'A15':
				return 'Pending transfer';
			case 'A16':
				return 'Pending discharge';
			case 'A17':
				return 'Swap patients';
			case 'A18':
				return 'Merge patient information';
			case 'A19':
				return 'QRY/ADR - Patient query';
			case 'A20':
				return 'Bed status update';
			case 'A21':
				return 'Patient goes on a “leave of absence”';
			case 'A22':
				return 'Patient returns from a “leave of absence”';
			case 'A23':
				return 'Delete a patient record';
			case 'A24':
				return 'Link patient information';
			case 'A25':
				return 'Cancel pending discharge';
			case 'A26':
				return 'Cancel pending transfer';
			case 'A27':
				return 'Cancel pending admit';
			case 'A28':
				return 'Add person information';
			case 'A29':
				return 'Delete person information';
			case 'A30':
				return 'Merge person information';
			case 'A31':
				return 'Update person information';
			case 'A32':
				return 'Cancel patient arriving - tracking';
			case 'A33':
				return 'Cancel patient departing - tracking';
			case 'A34':
				return 'Merge patient information - patient I';
			case 'A35':
				return 'Merge patient information - account only';
			case 'A36':
				return 'Merge patient information - patient ID and account number';
			case 'A37':
				return 'Unlink patient information';
			case 'A38':
				return 'Cancel pre-admit';
			case 'A39':
				return 'Merge person - patient ID';
			case 'A40':
				return 'Merge patient - patient identifier list';
			case 'A41':
				return 'Merge account - patient account num';
			case 'A42':
				return 'Merge visit - visit number';
			case 'A43':
				return 'Move patient information - patient identifier list';
			case 'A44':
				return 'Move account information - patient account number';
			case 'A45':
				return 'Move visit information - visit number';
			case 'A46':
				return 'Change patient ID';
			case 'A47':
				return 'Change patient identifier list';
			case 'A48':
				return 'Change alternate patient ID';
			case 'A49':
				return 'Change patient account number';
			case 'A50':
				return 'Change visit number';
			case 'A51':
				return 'Change alternate visit ID';
			default:
				return '';
		}
	}

	function adtMapFeatureKey(feat) {
		switch(feat) {
			case 'STAT':
				return 'Status';
			case 'VISIT':
				return 'Visits';
			default:
				return '';
		}
	}

	function modelIsEditing(m) {
		return !!m && validSvc.isText(m.Id) && !!m.dirty;
	}

}
 
ceEditCtl.$inject = ['$scope', '$state', '$timeout', 'ceRepo', 'vendorRepo', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc'];
angular
.module('espui.admin.ce')
.controller('CeEditCtl', ceEditCtl);


/* @ngInject */
function ceEditCtl($scope, $state, $timeout, ceRepo, vendorRepo, validSvc, errSvc, utilSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this,
		_currentCE = '',
		_pendingStatus = '',
		_regexDate = utilSvc.regex.dateFmt(),
		_pendingPbmVendor = '';


	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	msgSvc.addHelpLink(vm);

	// add CSS support
	vm.cssBtnStyle = utilSvc.css.btnStyle;
	vm.cssValidStyle = utilSvc.css.validStyle;

	// properties
	vm.isWaiting = false;
	vm.action = '';
	vm.stateDroplist = [];
	vm.ErxMatchCharsDroplist = [];

	// models
	vm.context = {};
	vm.model = {};
	vm.pendingData = {};

	// tabs
	vm.activeTab = '';
	vm.tabChange = tabChange;

	// status buttons
	vm.btnStatusChange = {};
	vm.statusChange = statusChange;

	// CE edit events, methods
	vm.submitAcct = submitAcct;

	// medicaid / excluded payors ('MM', 'O' and 'U' types stored in one list)
	vm.medpayor = {Items:[]};

	// tab: Medicaid for 'MM' and 'O' tables / editing
	vm.medpayorFlt = {};
	vm.medpayorSave = medpayorSave;
	vm.medpayorChangeToOverride = medpayorChangeToOverride;
	vm.medpayorChangeToDefault = medpayorChangeToDefault;

	// tab: Custom Payors for 'U' tables / editing
	vm.userPayorAction = 'LIST';
	vm.userPayor = {};
	vm.userPayorFlt = {};
	vm.userPayorAdd = userPayorAdd;
	vm.userPayorEdit = userPayorEdit;
	vm.userPayorSave = userPayorSave;
	vm.userPayorRemove = userPayorRemove;

	// custom payor NDC list editing
	vm.userPayorNdcListNew = '';
	vm.userPayorNdcListAdd = userPayorNdcListAdd;
	vm.userPayorNdcListRemove = userPayorNdcListRemove;

	// own use payors
	vm.ownPayor = {Items:[]};
	vm.ownPayorFlt = {};
	vm.ownPayorAddEdit = ownPayorAddEdit;
	vm.ownPayorSave = ownPayorSave;
	vm.ownPayorStatusToggle = ownPayorStatusToggle;
	vm.ownPayorToggleWildCard = ownPayorToggleWildCard;

	// popup
	vm.popup = {};
	vm.togglePopup = togglePopup;
	vm.confirmDataChange = confirmDataChange;

	// cash card
	vm.PbmVendors = [];
	vm.PbmVendorDroplist = [];
	vm.changeCashCard = changeCashCard;
	vm.changeCashCardPBM = changeCashCardPBM;
	vm.cashAdtMapAdd = cashAdtMapAdd;
	vm.cashAdtMapDelete = cashAdtMapDelete;

	// address
	vm.AddressStateDroplist = [];

	// alternate account ordering
	vm.DirectReplenishVendorDroplist = [];

	// data exports
	vm.DataExportsSchedule = {};
	vm.longerExport = longerExport;
	vm.showHistoricalDates = false;
	vm.historicalStartDate = validSvc.newPropDateNull();
	vm.historicalEndDate = validSvc.newPropDateNull();
	vm.historicalDateRangeList = utilSvc.widget.dateRangeList(['NONE', 'CUSTOM92']);
	vm.historicalDateRangeList.push({label:'Custom Date Range (730 day max)', value:'CUSTOM730'});
	vm.historicalDateRangeMode = 'MTD';
	vm.historicalDatesValid = false;
	vm.historicalDateError = '';
	vm.historicalExportQueued = false;
	vm.historicalDateRangeChange = historicalDateRangeChange;
	vm.confirmHistoricalExport = confirmHistoricalExport;
	vm.cancelHistoricalExport = cancelHistoricalExport;

	// Direct Replenish
	vm.toggleDirectReplenish = toggleDirectReplenish;
	vm.firstDRToggle = true;
	
	/**
	 *    INIT
	 */

	function initDirectReplenishVendors() {

		// get vendors from database

		vm.DirectReplenishVendorDroplist = [];
		vendorRepo.getList().then(okVenList, errVenList);

		function okVenList(r) {

			var items = Array.isArray(r) ? r : [],
			venList = [];

			// vendors must be: ACTIVE, SupportEDI and not a DRUGDB
			for(var i = 0; i < items.length; i++) {
				if(items[i].ObjectState == 'ACTIVE' && !!items[i].SupportsEDI && items[i].Type != 'DRUGDB') {
					venList.push(items[i].Id);
				}
			}
			venList.sort();

			vm.DirectReplenishVendorDroplist = utilSvc.ng.droplist(venList);
			vm.DirectReplenishVendorDroplist.unshift({label:'Choose a Vendor', value:'NONE'});

		}

		function errVenList(r) {
			if(!!r) {
				errSvc.warn('unknown error getting vendor list', 'vendor.getList', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}

	init();

	function init() {

		// default tab
		vm.activeTab = 'ACCOUNT';

		// user context
		vm.context = ceRepo.contextVM();

		// status buttons
		vm.btnStatusChange = {
			show: false,
			ONBOARDING: false,
			ACTIVE: false,
			INACTIVE: false,
			DELETED: false
		};

		vm.ErxMatchCharsDroplist = utilSvc.ng.droplist([6,8,10,12,14]);
		vm.AddressStateDroplist = utilSvc.ng.stateFullNamesDroplist();
		vm.AddressStateDroplist.unshift({value:'NONE', label:' '});

		// vendors for alternate account
		$timeout(function(){
			initDirectReplenishVendors();			
		},300);

		// create or edit
		if($state.current.name == 'admin.ce.edit') {
			var routeInfo = $state.current.routeInfo;
			$scope.$emit('shared.main.setInfo', {
				icon: routeInfo.icon,
				title: 'Update Facility: ' + $state.params.CE,
				bkgHeight: routeInfo.bkgHeight,
				breadcrumb: routeInfo.breadcrumb,
			});
			vm.action = 'UPDATE';
			getDetail($state.params.CE);
		}
		else if($state.current.name == 'admin.ce.create') {
			$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
			vm.action = 'CREATE';
			vm.model = ceRepo.modelVM();
			vm.DataExportsSchedule = JSON.parse(JSON.stringify(vm.model.DataExportsSchedule || {})); // de-ref
		}
		else {
			throw new Error('ceEditCtl.Init, state unknown: ' + $state.current.name);
		}

	}


	/**
	 *    GET DETAIL
	 */

	function getDetail(id) {

		// valid param
		if(!validSvc.isText(id)) {
			throw new Error('ceEditCl.getDetail, id is missing');
		}
		_currentCE = id;

		ceRepo.getDetail(_currentCE).then(ok, err);

		function ok(r) {
			vm.model = r;
			vm.DataExportsSchedule = JSON.parse(JSON.stringify(vm.model.DataExportsSchedule || {})); // de-ref
			refreshStatusButtons(vm.model.Type.val, vm.model.ObjectState);

			// load PBM Vendors?
			if(vm.model.CashCard == 'yes') {
				_pendingPbmVendor = vm.model.CashCardPBM.val;
				loadPbmVendors();
			}

			initConfirmRequiredFields();
		}

		function err(r) {
			if(r !== null) {
				errSvc.warn('Facility Id not found: ' + _currentCE, 'ceEditCtl.getDetail.err', r.status, utilSvc.http.safeResponse(r));
			}
			$state.go('admin.ce.list');
		}

	}


	/**
	 *    SUBMIT: ACCOUNT
	 */

	function resetValidationState() {

		// reset validation state on all model properties
		// note: use this after an update to hide validation icons

		var m = vm.model;

		m.Id.fail = '';
		m.CpAcctId.fail = '';
		m.SplitAcctId.fail = '';
		m.Name.fail = '';
		m.NPI.fail = '';
		m.OpaId.fail = '';
		m.OpaType.fail = '';
		m.OpaStartDate.fail='';
		m.ExternalEntityId.fail = '';
		m.NpiMaxFullProximity.fail = '';
		m.NpiMaxPartProximity.fail = '';
		m.CashCardExpires.fail = '';
		m.CeOwnUsePatientClaimsLastFill.fail = '';
		m.CashCardPBM.fail = '';
		m.CashCardPlanId.fail = '';
		m.CashCardAdtDefault.fail = '';
		m.EncryptionPublicKey.fail = '';
		m.DirectReplenishVendor.fail = '';
		m.DirectReplenishAccountNum.fail = '';
		m.OwnUseProgramStartDate.fail = '';
		m.DataExportsScheduleErr = '';
    	m.CdcType.fail = '';
	}

	function cashMapValid(mp, uniqueMaps) {

		mp = mp || {};
		mp.fail = 'no';

		// validate From
		var edt = validText(validSvc.newProp(mp.From), 1, 30);

		// already used?
		if(edt.fail == 'no') {
			if(uniqueMaps.indexOf(mp.From) > -1) {
				edt.fail = 'yes';
				edt.msg = mp.From + ' already used';
			}
			else {
				uniqueMaps.push(mp.From);
			}
		}

		if(edt.fail == 'yes') {
			mp.msg = 'From: ' + edt.msg;
			mp.fail = 'yes';
		}

		// validate To
		if(mp.To === 0) {
			mp.msg += mp.fail == 'yes' ? ', To: ' : 'To: ';
			mp.msg += 'required';
			mp.fail = 'yes';
		}

		return mp;

	}

	function validAccount() {

		// validate for both create and update

		var m = vm.model;

		if(vm.action == 'CREATE') {

			// Nickname - required on create, alphanumeric
			m.Id = validText(m.Id, 3, 30);
			if(m.Id.fail == 'no') {
				m.Id.val = m.Id.val.toUpperCase();
				var regexId  = /[^A-Z0-9]/;
				if(regexId.test(m.Id.val)) {
					m.Id.fail = 'yes';
					m.Id.msg = 'must be 3 to 30 letters and numbers only';
				}
			}
		}

		// Accounting Id - required for ACTIVE status, optional otherwise, alphanumeric
		if(validSvc.isText(m.CpAcctId.val)) {
			m.CpAcctId = validAcctNumber(m.CpAcctId.val);
		}
		else if(m.ObjectState == 'ACTIVE' && m.ProductType == 'V340B' ) {
			m.CpAcctId.fail = 'yes';
			m.CpAcctId.msg = 'required for ACTIVE status';
		}
		else {
			m.CpAcctId.fail = '';
		}

		if(validSvc.isText(m.SplitAcctId.val)) {
			m.SplitAcctId = validAcctNumber(m.SplitAcctId.val);
		}
		else {
			m.SplitAcctId.fail = '';
		}

		// Name - required
		m.Name = validText(m.Name, 2, 100);

		// NPI - optional, integer
		if(validSvc.isText(m.NPI.val)) {
			m.NPI = validText(m.NPI, 10, 15);
			if(m.NPI.fail == 'no' && !validSvc.isInteger(parseInt(m.NPI.val))) {
				m.NPI.fail = 'yes';
				m.NPI.msg = 'must be a 10 - 15 digit number';
			}
		}
		else {
			m.NPI.fail = '';
		}

		if (m.IsHrsaRegistered == 'yes') {
			// OpaId - required
			m.OpaId = validText(m.OpaId, 2, 30);

			// OpaType - required
			m.OpaType = validText(m.OpaType, 2, 20);

			// Opa start date
			m.OpaStartDate= validSvc.propDateValid(m.OpaStartDate, _regexDate);
			m.OpaStartDate.fail = !!m.OpaStartDate.fail ? 'yes' : 'no';
		} else {
			m.OpaId.fail = false;
			m.OpaType.fail = false;
			m.OpaStartDate.fail = false;
			if(m.ProductType == 'VERISAVE' && !validSvc.isText(m.ExternalEntityId.val)) {
				// empty is ok for VERISAVE, not required
				m.ExternalEntityId = validSvc.newProp('');
				m.ExternalEntityId.fail = '';
			}
			else {
				m.ExternalEntityId = validText(m.ExternalEntityId, 1, 50);
			}
		}

		// address, validate if any are not empty
		var addressOk = true;
		if(m.AddressState.val != 'NONE' || validSvc.isText(m.AddressLine1.val + m.AddressLine2.val + m.AddressCity.val + m.AddressZip.val)) {
			m.AddressState.fail = m.AddressState.val == 'NONE' ? 'yes' : 'no';
			m.AddressLine1 = validText(m.AddressLine1, 2, 50);

			// line 2 is optional
			if(validSvc.isText(m.AddressLine2.val)) {
				m.AddressLine2 = validText(m.AddressLine2, 2, 50);
			}
			else {
				m.AddressLine2.fail = 'no';
				m.AddressLine2.msg = '';
			}
			m.AddressCity = validText(m.AddressCity, 2, 50);
			m.AddressZip = validZip(m.AddressZip);

			addressOk = m.AddressLine1.fail != 'yes' &&
				m.AddressLine2.fail != 'yes' &&
				m.AddressCity.fail != 'yes' &&
				m.AddressState.fail != 'yes' &&
				m.AddressZip.fail != 'yes';
		}

		// non-Verity prog admin forces eRX and NPI Prox to default values
		if(m.IsVerityPrimary != 'yes') {
			m.ErxMatchChars = validSvc.newProp(0);
			m.ErxValidateNPI = validSvc.newProp('no');
			m.ErxValidateGPI = validSvc.newProp('yes');
			m.ErxMatchIneligibleOnly = validSvc.newProp('no');
			m.EnableErxLookback = validSvc.newProp('no');
			m.NpiEnforceProximity = 'no';
			m.EnableReferralNPIs = 'no';
			m.EnableRefSuspectMatching = 'no';
			m.EnableRefAutoFaxing = 'no';

			// // esi portal and IsVerityPrimary must be in sync
			// if(m.ExpressScriptsCustomer == 'yes') {
			// 	m.IsVerityPrimary.fail = 'yes';
			// 	m.IsVerityPrimary.msg = 'must be VERITY if Express Scripts customer';
			// }

		}
		if(m.EnableReferralNPIs == 'yes') {
			// program start date
			m.ReferralStartDate = validSvc.propDateValid(m.ReferralStartDate, _regexDate);
			m.ReferralStartDate.fail = !!m.ReferralStartDate.fail ? 'yes' : 'no';

			m.FeeReferral = validCurrency(m.FeeReferral, 0.00, 9999);
			m.FeeReferralPercent = validCurrency(m.FeeReferralPercent, 0.0, 100.0);
			m.ReferralMinimumSavings = validCurrency(m.ReferralMinimumSavings, 0.0, 2500.0);
      m.FaxNumber =  validSvc.validPhone(m.FaxNumber, true);

			var refLimit = validSvc.isInteger(m.ReferralLookbackLimit.val) ? parseInt(m.ReferralLookbackLimit.val) : 0;
			if(refLimit < 0 || refLimit > 3650 ) {
				m.ReferralLookbackLimit.fail = 'yes';
				m.ReferralLookbackLimit.msg = 'number between 0 and 3650';
			}
			else {
				m.ReferralLookbackLimit.fail = 'no';
				m.ReferralLookbackLimit.msg = '';
			}

			if (vm.model.ReferralModel.val == 'H') {
				m.FeeReferralPro = validCurrency(m.FeeReferralPro, 0.00, 9999);
				m.FeeReferralProPercent = validCurrency(m.FeeReferralProPercent, 0.0, 100.0);
				if(!validSvc.isInteger(m.ReferralEditDelay.val) || m.ReferralEditDelay.val < 0 || m.ReferralEditDelay.val > 90) {
					m.ReferralEditDelay.fail = 'yes';
					m.ReferralEditDelay.msg = 'number between 0 and 90';
				} else {
					m.ReferralEditDelay.fail = 'no';
					m.ReferralEditDelay.msg = '';
				}
			} else {
				m.FeeReferralPro.fail = 'no';
				m.FeeReferralPro.msg = '';
				m.FeeReferralProPercent.fail = 'no';
				m.FeeReferralProPercent.msg = '';
				m.ReferralEditDelay.fail = 'no';
				m.ReferralEditDelay.msg = '';
			}
			// user need to pick a referral model
			if(m.ReferralModel.val == '') {
				m.ReferralModel.fail = 'yes';
				m.ReferralModel.msg = 'required';
			} else {
				m.ReferralModel.fail = 'no';
				m.ReferralModel.msg = '';
			}
		} else {
			m.EnableRefSuspectMatching = 'no';
			m.EnableRefAutoFaxing = 'no';
			m.FeeReferral.fail = 'no';
			m.FeeReferralPercent.fail = 'no';
			m.ReferralModel.fail = 'no';
		}
		// NPI proximity - required if true
		if(m.NpiEnforceProximity == 'yes') {

			var proxCheck = parseInt(m.NpiMaxFullProximity.val);
			if(!validSvc.isInteger(proxCheck) || proxCheck < 0 || proxCheck > 730) {
				m.NpiMaxFullProximity.fail = 'yes';
				m.NpiMaxFullProximity.msg = 'number between 0 and 365';
			}
			else {
				m.NpiMaxFullProximity.fail = 'no';
				m.NpiMaxFullProximity.msg = '';
			}

			proxCheck = parseInt(m.NpiMaxPartProximity.val);
			if(!validSvc.isInteger(proxCheck) || proxCheck < 0 || proxCheck > 365) {
				m.NpiMaxPartProximity.fail = 'yes';
				m.NpiMaxPartProximity.msg = 'number between 0 and 365';
			}
			else {
				m.NpiMaxPartProximity.fail = 'no';
				m.NpiMaxPartProximity.msg = '';
			}
		}
		else {
			m.NpiMaxFullProximity = validSvc.newProp(0);
			m.NpiMaxPartProximity = validSvc.newProp(0);
		}

		// Cash Card - required if true
		var cashCardAdtMapsOk = true;
		if(m.CashCard == 'yes') {

			var ccExpires = parseInt(m.CashCardExpires.val);
			if(!validSvc.isInteger(ccExpires) || ccExpires < 1 || ccExpires > 730) {
				m.CashCardExpires.fail = 'yes';
				m.CashCardExpires.msg = 'number between 1 and 730';
			}
			else {
				m.CashCardExpires.fail = 'no';
				m.CashCardExpires.msg = '';
			}

			m.CashCardPBM.fail = m.CashCardPBM.val == 'NONE' ? 'yes' : 'no';
			m.CashCardPBM.msg = 'required';

			m.CashCardPlanId = validText(m.CashCardPlanId, 2, 8);
			if(m.CashCardPlanId.fail == 'no') {
				m.CashCardPlanId.msg = 'must be 2 to 8 numbers only';
				var regexPlanId = /[^0-9]/;
				m.CashCardPlanId.fail = regexPlanId.test(m.CashCardPlanId.val) ? 'yes' : 'no';
			}

			// auto reg means no benefit levels and ADT
			if(m.CashCardAutoReg == 'yes') {
				m.CashCardAdtDefault = validSvc.newProp(0);
				m.CashCardAdtMaps = [];
			}
			else {

				// adt
				var maps = m.CashCardAdtMaps,
					map = {};

				if(m.CashCardAdtDefault.val === 0 && maps.length > 0) {
					m.CashCardAdtDefault.fail = 'yes';
					m.CashCardAdtDefault.msg = 'required if level maps specified';
				}
				else {
					m.CashCardAdtDefault.fail = '';
				}

				var uniqueMaps = [];
				for(var i = 0; i < maps.length; i++) {
					map = maps[i];
					map = cashMapValid(map, uniqueMaps);
					if(map.fail == 'yes') {
						cashCardAdtMapsOk = false;
					}
				}

			}

		}
		else {
			m.CashCardAutoReg = 'no';
			m.CashCardExpires = validSvc.newProp(0);
			m.CashCardPBM = validSvc.newProp('NONE');
			m.CashCardPlanId = validSvc.newProp('');
			m.CashCardAdtDefault = validSvc.newProp(0);
			m.CashCardAdtMaps = [];
		}

		if (m.CeOwnUseProgram == 'yes' && m.OwnUseProgramStartDate.val != '') {
			m.OwnUseProgramStartDate = validSvc.propDateValid(m.OwnUseProgramStartDate, _regexDate);
			m.OwnUseProgramStartDate.fail = !!m.OwnUseProgramStartDate.fail ? 'yes' : 'no';
		} else {
			m.OwnUseProgramStartDate.fail = '';
		}

		if (m.CeOwnUseProgram == 'yes' && m.CeOwnUsePatientClaims == 'yes' && m.CeOwnUsePatientClaimsFillOption == 'UNTIL') {
			var lastFillCheck = parseInt(m.CeOwnUsePatientClaimsLastFill.val);
			if(!validSvc.isInteger(lastFillCheck) || lastFillCheck < 0 || lastFillCheck > 99) {
				m.CeOwnUsePatientClaimsLastFill.fail = 'yes';
				m.CeOwnUsePatientClaimsLastFill.msg = 'number between 0 and 99';
			} else {
				m.CeOwnUsePatientClaimsLastFill.fail = '';
			}
		} else {
			m.CeOwnUsePatientClaimsLastFill.fail = '';
		}

		var priceValidationOk = true;
		
		if (m.EnableContractPriceValidation == 'yes') {
			m.PriceContractVariableFeePercentage = validCurrency(m.PriceContractVariableFeePercentage, 0.0, 100.0);
			m.PriceContractMonthlyFee = validCurrency(m.PriceContractMonthlyFee, 0, 10000000);
			m.PriceContractFlatFee = validCurrency(m.PriceContractFlatFee, 0, 10000000);
			if(m.PriceContractEnableMinFeeAmount) {
				m.PriceContractMinFeeAmount = validCurrency(m.PriceContractMinFeeAmount, 0, 10000);
			} else {
				m.PriceContractMinFeeAmount = validSvc.newProp(0);
			}
			if(m.PriceContractEnableMaxFeeAmount) {
				m.PriceContractMaxFeeAmount = validCurrency(m.PriceContractMaxFeeAmount, 0, 10000);
			} else {
				m.PriceContractMaxFeeAmount = validSvc.newProp(0);
			}
			priceValidationOk = 
				m.PriceContractVariableFeePercentage.fail == 'no' &&
				m.PriceContractMonthlyFee.fail == 'no' && 
				m.PriceContractFlatFee.fail == 'no' && 
				(!m.PriceContractEnableMinFeeAmount || m.PriceContractMinFeeAmount.fail == 'no') &&
				(!m.PriceContractEnableMaxFeeAmount || m.PriceContractMaxFeeAmount.fail == 'no');
		} else {
			m.PriceContractValidationModel = 'ESSENTIAL';
			m.PriceContractAutoCloseNegative = 'no';
			m.PriceContractFeeModel = 'FLAT';
			m.PriceContractMonthlyFee = validSvc.newProp(0);
			m.PriceContractFlatFee = validSvc.newProp(0);
			m.PriceContractVariableFeePercentage = validSvc.newProp(0);
			m.PriceContractFlatFee = validSvc.newProp(0);
			m.PriceContractMinFeeAmount = validSvc.newProp(0);
			m.PriceContractMaxFeeAmount = validSvc.newProp(0);
			m.PriceContractEnableMinFeeAmount = false;
			m.PriceContractEnableMaxFeeAmount = false;
		}

		// security key unlocks Audit PHI and Data Exports
		m.DataExportsScheduleErr = ''; // clear API err before next API call
		if(validSvc.isText(m.EncryptionPublicKey.val)) {
			m.DataExportsAccum = m.DataExportsEnabled == 'yes' && m.DataExportsAccum == 'yes' ? 'yes' : 'no';
			m.DataExportsCPInvoices = m.DataExportsEnabled == 'yes' && m.DataExportsCPInvoices == 'yes' ? 'yes' : 'no';
			m.DataExportsMatches = m.DataExportsEnabled == 'yes' && m.DataExportsMatches == 'yes' ? 'yes' : 'no';
			m.DataExportsMatchesPHI = m.DataExportsMatches == 'yes' && m.DataExportsMatchesPHI == 'yes' ? 'yes' : 'no';
			m.DataExportsSuspects = m.DataExportsEnabled == 'yes' && m.DataExportsSuspects == 'yes' ? 'yes' : 'no';
			m.DataExportsSuspectsPHI = m.DataExportsSuspects == 'yes' && m.DataExportsSuspectsPHI == 'yes' ? 'yes' : 'no';
			m.DataExportsClaimsBacking = m.DataExportsEnabled == 'yes' && m.DataExportsClaimsBacking == 'yes' ? 'yes' : 'no';
			m.DataExportsClaimsBackingPHI = m.DataExportsClaimsBacking == 'yes' && m.DataExportsClaimsBackingPHI == 'yes' ? 'yes' : 'no';
			m.DataExportsSMClaimsBacking = m.DataExportsEnabled == 'yes' && m.DataExportsSMClaimsBacking == 'yes' ? 'yes' : 'no';
			m.DataExportsSMClaimsBackingPHI = m.DataExportsSMClaimsBacking == 'yes' && m.DataExportsSMClaimsBackingPHI == 'yes' ? 'yes' : 'no';
			m.DataExportsSMClaimsUnMatched = m.DataExportsEnabled == 'yes' && m.DataExportsSMClaimsUnMatched == 'yes' ? 'yes' : 'no';
			m.DataExportsSMClaimsUnMatchedPHI = m.DataExportsSMClaimsUnMatched == 'yes' && m.DataExportsSMClaimsUnMatchedPHI == 'yes' ? 'yes' : 'no';
			m.DataExportsSBAccumDispenses = m.DataExportsEnabled == 'yes' && m.DataExportsSBAccumDispenses == 'yes' ? 'yes' : 'no';
			m.DataExportsSBAccumDispensesPHI = m.DataExportsSBAccumDispenses == 'yes' && m.DataExportsSBAccumDispensesPHI == 'yes' ? 'yes' : 'no';
			m.DataExportsSBMedical = m.DataExportsEnabled == 'yes' && m.DataExportsSBMedical == 'yes' ? 'yes' : 'no';
			m.DataExportsSBMedicalPHI = m.DataExportsSBMedical == 'yes' && m.DataExportsSBMedicalPHI == 'yes' ? 'yes' : 'no';
			m.DataExportsAudit = m.DataExportsEnabled == 'yes' && m.DataExportsAudit == 'yes' ? 'yes' : 'no';
			m.DataExportsSchedule = JSON.parse(JSON.stringify(vm.DataExportsSchedule || {})); // de-ref
		}
		else {
			m.EnableAuditPHI = 'no';
			m.DataExportsEnabled = 'no';
			m.DataExportsAccum = 'no';
			m.DataExportsCPInvoices = 'no';
			m.DataExportsMatches = 'no';
			m.DataExportsMatchesPHI = 'no';
			m.DataExportsSuspects = 'no';
			m.DataExportsSuspectsPHI = 'no';
			m.DataExportsClaimsBacking = 'no';
			m.DataExportsClaimsBackingPHI = 'no';
			m.DataExportsSMClaimsBacking = 'no';
			m.DataExportsSMClaimsBackingPHI = 'no';
			m.DataExportsSMClaimsUnMatched = 'no';
			m.DataExportsSMClaimsUnMatchedPHI = 'no';
			m.DataExportsSBAccumDispenses = 'no';
			m.DataExportsSBAccumDispensesPHI = 'no';
			m.DataExportsSBMedical = 'no';
			m.DataExportsSBMedicalPHI = 'no';
			m.DataExportsAudit = 'no';
			m.DataExportsSchedule = {};
		}

		// direct replenish
		if(m.AllowDirectReplenish == 'yes') {
			if (m.DirectReplenishNewOrders == 'yes') {
				m.DirectReplenishVendor.fail = validSvc.isVEN(m.DirectReplenishVendor.val) ? 'no' : 'yes';
				m.DirectReplenishAccountNum = validAcctNumber(m.DirectReplenishAccountNum.val);
			}
		}
		else {
			m.AllowDirectReplenish = 'no';
			m.DirectReplenishNewOrders = 'no';
			m.DirectReplenishVendor = validSvc.newProp('NONE');
			m.DirectReplenishAccountNum = validSvc.newProp('');
		}

		if (m.ProductType == 'VERISAVE') {
			return m.Id.fail != 'yes' &&
				m.CpAcctId.fail != 'yes' &&
				m.SplitAcctId.fail != 'yes' && 
				m.Name.fail != 'yes' &&
				m.NPI.fail != 'yes' &&
				m.ExternalEntityId.fail != 'yes' &&
				addressOk;
		}

		return m.ProductType != '' &&
			m.Id.fail != 'yes' &&
			m.CpAcctId.fail != 'yes' &&
			m.SplitAcctId.fail != 'yes' && 
			m.PbmId.fail != 'yes' &&
			m.Name.fail != 'yes' &&
			m.NPI.fail != 'yes' &&
			m.OpaId.fail != 'yes' &&
			m.OpaType.fail != 'yes' &&
			m.OpaStartDate.fail != 'yes' &&
			m.ExternalEntityId.fail != 'yes' &&
			m.NpiMaxFullProximity.fail != 'yes' &&
			m.NpiMaxPartProximity.fail != 'yes' &&
			m.CashCardExpires.fail != 'yes' &&
			m.CashCardPBM.fail != 'yes' &&
			m.CashCardPlanId.fail != 'yes' &&
			m.CashCardAdtDefault.fail != 'yes' &&
			m.ReferralModel.fail != 'yes' &&
			m.ReferralStartDate.fail != 'yes' &&
			m.ReferralMinimumSavings.fail != 'yes' &&
			m.FaxNumber.fail != 'yes' &&
			m.FeeReferral.fail != 'yes' &&
			m.FeeReferralPercent.fail != 'yes' &&
			m.FeeReferralPro.fail != 'yes' &&
			m.FeeReferralProPercent.fail != 'yes' &&
			m.ReferralEditDelay.fail != 'yes' &&
			m.ReferralLookbackLimit.fail != 'yes' &&
			m.DirectReplenishVendor.fail != 'yes' &&
			m.DirectReplenishAccountNum.fail != 'yes' &&
			m.DataExportsSchedule.fail != 'yes' &&
			m.CeOwnUsePatientClaimsLastFill.fail != 'yes' &&
			m.OwnUseProgramStartDate.fail != 'yes' &&
			m.CdcType.fail != 'yes' &&
			cashCardAdtMapsOk &&
			priceValidationOk && 
			addressOk;

	}

	function validAcctNumber(val) {
		var prop = validText({val:val}, 3, 20);
		if(prop.fail == 'no') {
			var regexprop = /[^A-Z0-9\-]/,
				cleanprop = prop.val.toString().toUpperCase();
			if(regexprop.test(cleanprop)) {
				prop.fail = 'yes';
				prop.msg = 'must be 3 to 20 letters and numbers only';
			}
			else {
				prop.fail = '';
			}
		}

		return prop;
	}

	function submitAcct() {

		if(vm.isWaiting) {
			return;
		}

		// validate
		if(!validAccount()) {
			msgSvc.ok('Cannot Save', 'All fields must be valid.');
			return false;
		}
		vm.isWaiting = true;

		// create or update
		if(vm.action == 'CREATE') {
			ceRepo.createAcct(vm.model).then(okUpsert, errUpsert);
		}
		else {
			ceRepo.updateAcct(vm.model).then(okUpsert, errUpsert);
		}

	}

	function okUpsert(r) {

		vm.isWaiting = false;

		// after CREATE, route to edit view
		if(vm.action == 'CREATE') {
			msgSvc.ok(r.Id, 'Created');
			$state.go('admin.ce.edit', {CE: r.Id}, {reload: 'admin.ce.edit'});
		}
		else {
			// hide validation icons on successful update
			resetValidationState();
			msgSvc.ok(r.Id, 'Saved');
		}

	}

	function errUpsert(r) {

		vm.isWaiting = false;

		if(!!!r || r === null) {
			// already handled
			$state.go('admin.ce.list', {}, {reload: 'admin.ce.list'});
		}
		else if(r.status === 409) {
			// conflict
			errSvc.info('Could not create or save, already exists in the database. Verify and try again.', 'CE Save', r.status);
		}
		else if (r.status === 422) {
			msgSvc.ok('Cannot Save', 'All fields must be valid');
			vm.model = r.model;
		}
		else {
			errSvc.error('Unexpected api error', 'ceEditCtl.errUpsert', r.status, utilSvc.http.safeResponse(r));
		}

	}


	/**
	 *    STATUS BUTTON CHANGE
	 */

	function statusChange(newStatus) {

		// already waiting?
		if(vm.isWaiting) {
			return;
		}
		_pendingStatus = newStatus;

		switch(_pendingStatus) {

			case 'DELETED':
				// confirm user wants to set deleted status
				msgSvc.confirm({
					id: 'ce.acct.status',
					title: 'Delete Facility',
					msg: 'Confirm status change to DELETED? This is not reversable.',
					buttons: [
						{text:'OK', result:'YES', cancel: false},
						{text:'CANCEL', result:'CANCEL', cancel: true}
					]
				}).then(confirmStatusChange, confirmStatusChange);
				break;

			case 'INACTIVE':
				// confirm user wants to set inactive (which will make all its affiliations inactive)
				msgSvc.confirm({
					id: 'ce.acct.status',
					title: 'InActive Facility',
					msg: 'Confirm status change to INACTIVE? This will make ALL its affiliations INACTIVE.',
					buttons: [
						{text:'OK', result:'YES', cancel: false},
						{text:'CANCEL', result:'CANCEL', cancel: true}
					]
				}).then(confirmStatusChange, confirmStatusChange);
				break;

			case 'ACTIVE':
				// try to save properties before changing status
				ceRepo.updateAcct(vm.model).then(statusPreSave, errUpsert);
				break;

			default:
				// no confirm needed
				confirmStatusChange({result:'YES'});
		}

	}

	function statusPreSave(r) {
		// bridge function from model save to status change

		// CpAcctId required for ACTIVE status
		if(_pendingStatus == 'ACTIVE' && vm.model.ProductType == 'V340B') {
			if (!validSvc.isText(vm.model.CpAcctId.val)) {
				vm.model.CpAcctId.fail = 'yes';
				vm.model.CpAcctId.msg = 'required for ACTIVE status';
				msgSvc.ok('Cannot Change Status', 'Verity Intacct accounting id is required for ACTIVE status');
				return;
			}
		}

		confirmStatusChange({result:'YES'});
	}

	function confirmStatusChange(r) {

		// user said yes to set DELETED status
		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;
			ceRepo.statusChange(vm.model.Id.val, _pendingStatus).then(okStatus, errStatus);
		}

		function okStatus(r) {
			vm.isWaiting = false;

			// id
			if(!!!r || !validSvc.isText(r.Id)) {
				throw new Error('ceEditCtl.okStatus, missing id');
			}

			$state.go('admin.ce.edit', {CE: r.Id}, {reload: 'admin.ce.edit'});

		}

		function errStatus(r) {
			vm.isWaiting = false;

			if(!!!r || r == null) {
				// already handled
				$state.go('admin.ce.list');
			}
			else if(r.status == 409) {
				// conflict
				errSvc.info('Could not update status to: ' + _pendingStatus + '. Try again.', 'ceEditCtl.errStatus', r.status, utilSvc.http.safeResponse(r));
				_pendingStatus = '';
			}
			else {
				errSvc.error('Unknown status change error', 'ceEditCtl.errStatus', r.status, utilSvc.http.safeResponse(r));
			}

		}
	}

	function refreshStatusButtons(ceType, ceStatus) {

		// called after get and status updates

		vm.btnStatusChange = {
			show: false,
			ONBOARDING: false,
			ACTIVE: false,
			INACTIVE: false,
			DELETED: false
		};

		// exit if in create mode (status changes not allowed)
		if(vm.action == 'CREATE' || ceType == 'ROLLUP') {
			return;
		}

		var saUser = vm.context.uType == 'VERITYSA';

		switch(ceStatus) {

			case 'ONBOARDING':
				vm.btnStatusChange.ACTIVE = true;
				vm.btnStatusChange.DELETED = saUser;
				break;

			case 'ACTIVE':
				vm.btnStatusChange.INACTIVE = true;
				break;

			case 'INACTIVE':
				vm.btnStatusChange.ACTIVE = true;
				vm.btnStatusChange.DELETED = saUser;
				break;

			case 'DELETED':
				vm.btnStatusChange.INACTIVE = saUser;
				break;

			default:
				throw new Error('ceEditCtl.refreshStatusButtons, ce status unknown: ' + ceStatus);

		}

		// show if at least one button is displayed
		vm.btnStatusChange.show = vm.btnStatusChange.ONBOARDING || vm.btnStatusChange.ACTIVE || vm.btnStatusChange.INACTIVE || vm.btnStatusChange.DELETED;

	}

	function confirmDataChange(modelFieldName) {

		if(vm.isWaiting) {
			return;
		}

		if ($state.current.name == 'admin.ce.create') {
			updateModel();
			return;
		}

		msgSvc.confirm({
			id: 'ce.sensitveData.confirm',
			title: 'Warning',
			msg: 'Changing this data field may cause integration with external partners to stop working. \nThese integrations include Verity Intacct Accounting, Medicaid Reporting, 340B TPAs, and Verity Care Card. \n\nAre you sure you want to make these changes?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmDataChange, confirmDataChange);

		function confirmDataChange(r) {
			// user said yes
			if(!!r && r.result == 'YES') {	
				updateModel();
			} else {
				vm.pendingData[modelFieldName] = vm.model[modelFieldName].val;
			}
		}

		function updateModel() {
			vm.model[modelFieldName].val = vm.pendingData[modelFieldName];
		}
	}

	function initConfirmRequiredFields() {
		var confirmFields = ['CpAcctId','SplitAcctId','NPI','ExternalEntityId','OpaId','OpaType'];
		for(var i =0; i < confirmFields.length; i++) {
			vm.pendingData[confirmFields[i]] = vm.model[confirmFields[i]].val;
		}
	}


	function toggleDirectReplenish(userChoice) {

		if( vm.isWaiting ) {
			return;
		}
	
		if(userChoice == 'yes') {
			if (!!vm.firstDRToggle) {
				vm.model.DirectReplenishNewOrders = 'yes';
				vm.firstDRToggle = false;
			}
		}
	}
	
	/**
	 *    MEDICAID
	 */

	function medPayorItemVM(item) {

		// clean up properties, add list filter Txt props
		item.BIN = validSvc.isText(item.BIN) ? item.BIN : '';
		item.BINTxt = item.BIN;
		item.PCN = validSvc.isText(item.PCN) ? item.PCN : '';
		item.PCNTxt = item.PCN;
		item.GroupNumber = validSvc.isText(item.GroupNumber) ? item.GroupNumber : '';
		item.GroupNumberTxt = item.GroupNumber;
		item.Name = validSvc.isText(item.Name) ? item.Name : '';
		item.NameTxt = item.Name;

		// U types have NDC list properties
		var ndcList = Array.isArray(item.NDCList) ? item.NDCList : [],
			ndcTxt = '';
		if(item.MedType == 'U') {

			item.BIN = validSvc.newProp(item.BIN);
			item.PCN = validSvc.newProp(item.PCN);
			item.GroupNumber = validSvc.newProp(item.GroupNumber);
			item.Name = validSvc.newProp(item.Name);

			for(var ii = 0; ii < ndcList.length; ii++) {
				ndcTxt += '|' + ndcList[ii];
				ndcList[ii] = validSvc.newProp(ndcList[ii]);
			}
		}
		item.NdcList = ndcList;
		item.NdcTxt = ndcTxt;
		item.NdcUseList = ndcList.length > 0 ? 'yes' : 'no';
		item.showNdcList = false;

		item.hasError = false;
		item.hasErrorTxt = '';
		item.hide = false;

		return item;
	}

	function medPayorVM(data) {

		// main viewmodel of medicaid
		// note: this function only processes O and U med types into Items list, MM types are added later in defaultsVM

		data = data || {};
		var items = Array.isArray(data.Items) ? data.Items : [],
			item = {},
			uniqueId = Date.now();

		for(var i = 0; i < items.length; i++) {
			item = items[i];
			uniqueId++;
			item.uniqueId = uniqueId;

			item = medPayorItemVM(item);
		}

		return {
			Dirty: false,
			MMTypeCount: 0,
			OTypeCount: 0,
			UTypeCount: 0,
			Items: items
		};

	}

	function defaultsVM(defaults, mpItems) {

		// process MM defaults against the mpItems 'O' overrides for this CE

		defaults = Array.isArray(defaults) ? defaults : [];

		// build overides lookup list
		var overrides = [];
		for(var i = 0; i < mpItems.length; i++) {
			if(mpItems[i].MedType == 'O') {
				overrides.push(mpItems[i].Id);
			}
		}

		// add defaults to mpItems if no 'O' override is found
		var df = {},
			uniqueId = Date.now(),
			dfList = [];
		for(var d = 0; d < defaults.length; d++) {
			dfList.push(defaults[d].Id);
			if(overrides.indexOf(defaults[d].Id) < 0) {
				// not found, add to medpayor Items
				uniqueId++;
				defaults[d].uniqueId = uniqueId;
				mpItems.push(medPayorItemVM(defaults[d]));
			}
		}

		// hide 'O' types if they are not returned in defaults list
		for(var o = 0; o < mpItems.length; o++) {
			if(mpItems[o].MedType == 'O') {
				if(dfList.indexOf(mpItems[o].Id) < 0) {
					mpItems[o].hide = true;
				}
			}
		}

		return mpItems;

	}

	function userPayorAddVM() {

		// build new item with unique timestamp id
		return {
			Id: Date.now().toString(),
			MedType: 'U',
			BIN: validSvc.newProp(''),
			PCN: validSvc.newProp(''),
			GroupNumber: validSvc.newProp(''),
			Name: validSvc.newProp(''),
			NdcList: [],
			NdcTxt: '',
			NdcUseList: 'no',
			hasError: false,
			hasErrorTxt: '',
			showNdcList: false
		};

	}

	function userPayorEditVM(m) {

		var ndcList = [];
		for(var i = 0; i < m.NdcList.length; i++) {
			ndcList.push(validSvc.newProp(m.NdcList[i].val));
		}

		return {
			Id: m.Id,
			MedType: 'U',
			BIN: validSvc.newProp(m.BIN.val),
			PCN: validSvc.newProp(m.PCN.val),
			GroupNumber: validSvc.newProp(m.GroupNumber.val),
			Name: validSvc.newProp(m.Name.val),
			NdcList: ndcList,
			NdcUseList: ndcList.length > 0 ? 'yes' : 'no',
			hasError: !!m.hasError,
			hasErrorTxt: m.hasErrorTxt
		};

	}

	function ownPayorListVM(items) {
		items = Array.isArray(items) ? items : [];

		// loop list items
		var item = {},
			uniqueId = 0;
		for(var i = 0; i < items.length; i++) {
			item = items[i];
			uniqueId++;
			item.uniqueId = uniqueId;
			item.PcnWildCard = !!item.PcnWildCard;
			item.PCN = item.PcnWildCard ? '' : item.PCN;
			item.GroupNumberWildCard = !!item.GroupNumberWildCard;
			item.GroupNumber = item.GroupNumberWildCard ? '' : item.GroupNumber;
		}

		return {
			action: '',
			Items: items
		};
	}

	function ownPayorModelVM(ownPayor, data) {
		// add model properties on the vm.ownPayor object
		ownPayor.action = !!data ? 'UPDATE' : 'ADD';
		data = data || {};

		var pcnVal = validSvc.isText(data.PCN) ? data.PCN : '',
			grpVal = validSvc.isText(data.GroupNumber) ? data.GroupNumber : '';

		ownPayor.Id = validSvc.isText(data.Id) ? data.Id : '';
		ownPayor.Status = data.Status == 'INACTIVE' ? 'INACTIVE' : 'ACTIVE'; // default to ACTIVE for new payor
		ownPayor.BIN = validSvc.isText(data.BIN) ? validSvc.newProp(data.BIN) : validSvc.newProp('');
		ownPayor.PcnWildCard = !!data.PcnWildCard || ownPayor.action == 'ADD' ? 'yes' : 'no'; // default to yes on add
		ownPayor.PCN = ownPayor.PcnWildCard == 'no' ? validSvc.newProp(pcnVal) : validSvc.newProp('');
		ownPayor.GroupNumberWildCard = !!data.GroupNumberWildCard || ownPayor.action == 'ADD' ? 'yes' : 'no'; // default to yes on add
		ownPayor.GroupNumber = ownPayor.GroupNumberWildCard == 'no' ? validSvc.newProp(grpVal) : validSvc.newProp('');
		ownPayor.Desc = validSvc.isText(data.Desc) ? validSvc.newProp(data.Desc) : validSvc.newProp('');

		return ownPayor;
	}

	function tabChange(newTab) {

		if(vm.isWaiting) {
			return;
		}

		// clean up MEDICAID/PAYORS tab if going/leaving from it
		if(newTab == 'PAYORS' || vm.activeTab == 'PAYORS' || newTab == 'MEDICAID' || vm.activeTab == 'MEDICAID') {
			resetMedPayorTabs();
		}
		// Copy/Paste! clean up LOCATIONS tab if going/leaving from it
		if(newTab == 'LOCATIONS' || vm.activeTab == 'LOCATIONS') {
			vm.locationsAction = 'LIST';
			vm.locations = {};
		}

		vm.activeTab = newTab;

		switch(newTab) {

			case 'ACCOUNT':
				// no action needed
				break;

			case 'PAYORS':
			case 'MEDICAID':
				setupMedPayor();
				break;

			case 'OWN-PAYORS':
				setupOwnUsePayors();
				break;

			case 'LOCATIONS':
				// show ops locations ui-view in CE mode
				vm.activeTab = 'LOCATIONS';
				$state.go('admin.ce.edit.locations', {
					CE: vm.model.Id.val
				}, {inherit: true});
				break;

			case 'NPI':
				// show ops npi ui-view in CE mode
				vm.activeTab = 'NPI';
				$state.go('admin.ce.edit.npi', {CE: vm.model.Id.val}, {inherit: true, reload: 'admin.ce.edit.npi'});
				break;

			case 'ADT':
				// show adt ui-view in CE mode
				vm.activeTab = 'ADT';
				$state.go('admin.ce.edit.adt', {CE: vm.model.Id.val}, {inherit: true});
				break;

			case 'AFF':
				// show affiliates ui-view in CE mode
				$state.go('admin.ce.edit.affs', {
					ViewType: 'CE',
					ViewErrRoute: 'admin.ce.list',
					CE: vm.model.Id.val
				}, {inherit: true});
				break;
			case 'VCENTRAL':
				// show adt ui-view in CE mode
				vm.activeTab = 'VCENTRAL';
				$state.go('admin.ce.edit.vcentral', {CE: vm.model.Id.val}, {inherit: true});
				break;
			default:
				throw new Error('ceEditCtl.tabChange, unknown tab: ' + newTab);
		}

	}


	/**
	 *    MEDPAYOR
	 */

	function resetMedPayorTabs() {
		vm.medpayor = medPayorVM();
		vm.medpayorFlt = {
			SortBy: ['BIN']
		};
		vm.popup = {};
		vm.userPayorAction = 'LIST';
		vm.userPayor = {};
		vm.userPayorFlt = {};
	}


	/**
	 *    SETUP MEDPAYOR
	 *    used by both MEDICAID AND PAYORS tabs
	 */

	function setupMedPayor() {

		// setup requires two endpoint calls:
		// 1. repo.getMedPayor: get this CE's managed medicaid (list on/off, 'O' overrides, 'U' custom user added) types
		// 2. repo.getPayors: gets the central Verity stored defaults 'MM'

		if(vm.isWaiting) {
			return;
		}

		resetMedPayorTabs();

		vm.isWaiting = true;
		msgSvc.wait(true);

		// 1. get O and U types
		ceRepo.getMedPayor(_currentCE).then(okGetMedPayor, errMedPayor);

		function okGetMedPayor(r) {
			vm.medpayor = medPayorVM(r);

			// 2. get Verity MM type payors
			if(vm.activeTab == 'MEDICAID') {
				ceRepo.getPayors().then(okGetPayorDefaultsList, errMedPayor);
			}
			else {
				vm.isWaiting = false;
				msgSvc.wait(false);
				refreshMedPayorCounts(vm.medpayor);
			}
		}

	}

	function okGetPayorDefaultsList(payors) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		vm.medpayor.Items = defaultsVM(payors, vm.medpayor.Items);
		refreshMedPayorCounts(vm.medpayor);

	}

	function errMedPayor(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		if(!!r) {
			errSvc.warn('Unknown error', 'ceEditCtl.getMedPayor', r.status, utilSvc.http.safeResponse(r));
			$state.go('admin.ce.list');
		}
	}

	function refreshMedPayorCounts(medp) {

		// loop medpayor.Items and count MM,O,U types

		var items = medp.Items,
			mType = '',
			MM = 0,
			O = 0,
			U = 0;

		for(var i = 0; i < items.length; i++) {
			mType = items[i].MedType;
			if(mType == 'MM') {
				MM++;
			}
			else if(mType == 'O') {
				if(!!!items[i].hide) {
					O++;
				}
			}
			else if(mType == 'U') {
				U++;
			}
			else {
				alert('getMedPayorCounts, unknown MedType: ' + mType);
				tabChange('ACCOUNT');
				break;
			}
		}

		medp.MMTypeCount = MM;
		medp.OTypeCount = O;
		medp.UTypeCount = U;

	}


	/**
	 *    MEDPAYOR LIST EDITS
	 */

	function medpayorChangeToOverride(item) {

		// move default item to overrides list

		if(vm.isWaiting) {
			return;
		}

		item.MedType = 'O';
		item.uniqueId = 'O' + Date.now().toString();
		vm.medpayor.Dirty = true;
		refreshMedPayorCounts(vm.medpayor);

	}

	function medpayorChangeToDefault(item) {

		// remove default item to overrides list

		if(vm.isWaiting) {
			return;
		}

		item.MedType = 'MM';
		item.uniqueId = 'MM' + Date.now().toString();
		vm.medpayor.Dirty = true;
		refreshMedPayorCounts(vm.medpayor);

	}


	/**
	 *    MEDPAYOR POPUP
	 *    used for overrides list (doens't need any dynamic height offset code)
	 */

	function togglePopup(popType) {

		if(vm.isWaiting) {
			return;
		}

		if(vm.popup.ready) {
			// off
			vm.popup = {};
			return;
		}

		switch(popType) {

			case 'MEDPAYOR':
				vm.popup = {
					type: popType,
					ready: true
				};
				break;

			default:
				msgSvc.ok('Unknown popup type', 'ceEditCtl.togglePopup ' + popType);
		}

	}

	function medpayorSave() {
		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;

		excludedPayorSave();
	}


	/**
	 *    MEDICAID AND USER PAYOR SAVE
	 *    model has both Medicaid and Custom Excluded Payors tabs
	 */

	function excludedPayorSave() {

		ceRepo.saveMedPayor(_currentCE, vm.medpayor).then(okExPayorSave, errExPayorSave);

		function okExPayorSave(r) {
			vm.isWaiting = false;
			vm.medpayor.Dirty = false;

			if(vm.activeTab == 'MEDICAID') {
				msgSvc.ok(_currentCE, 'Medicaid Saved');
			}
			else {
				vm.userPayorAction = 'LIST';
				msgSvc.ok(_currentCE, 'Custom Payor List Updated');
			}

			setupMedPayor();

		}

		function errExPayorSave(r) {
			vm.isWaiting = false;

			if(r === null) {
				// already handled
			}
			else if(vm.activeTab == 'PAYORS' && r.status === 422) {

				// parse err items into Items list
				var items = r.model.Items,
					idx = -1;
				for(var i = 0; i < items.length; i++) {

					// find payor in list
					idx = findById(vm.medpayor.Items, items[i].Id);
					if(idx < 0) {
						alert('Could not find ceRepo 422 Id in controller vm.medpayor.Items: ' + items[i].Id);
						break;
					}

					// apply error to item
					vm.medpayor.Items[idx].hasError = items[i].hasError;
					vm.medpayor.Items[idx].hasErrorTxt = items[i].hasErrorTxt;
					if(items[i].MedType == 'U') {
						vm.medpayor.Items[idx].NdcList = items[i].NdcList;
					}

					// update userPayor edit UI
					if((vm.userPayorAction == 'ADD' || vm.userPayorAction == 'UPDATE') && items[i].Id == vm.userPayor.Id) {
						vm.userPayor.hasError = true;
						vm.userPayor.hasErrorTxt = vm.medpayor.Items[idx].hasErrorTxt;
						vm.userPayor.NdcList = vm.medpayor.Items[idx].NdcList;
					}
				}

				msgSvc.ok('Cannot Save', 'Server found errors during save.');

			}
			else {
				errSvc.error('Unexpected api error', 'ceEditCtl.errUpsert', r.status, utilSvc.http.safeResponse(r));
			}

		}
	}


	/**
	 *    CUSTOM USER PAYOR
	 */

	function userPayorAdd() {

		// user clicked ADD button to create a new custom payor

		if(vm.isWaiting) {
			return;
		}

		vm.userPayor = userPayorAddVM();
		vm.userPayorNdcListNew = '';
		vm.userPayorAction = 'ADD';

	}

	function userPayorEdit(item) {

		// user clicked existing row to edit payor

		if(vm.isWaiting) {
			return;
		}

		vm.userPayor = userPayorEditVM(item);
		vm.userPayorNdcListNew = '';
		vm.userPayorAction = 'UPDATE';

	}

	function validPropText(prop, minLen, maxLen, required) {
		if(validSvc.isText(prop.val)) {
			prop.val = prop.val.trim();
			prop = validText(prop, minLen, maxLen);
			if(prop.fail == 'no') {
				prop.val.toUpperCase();
			}
		}
		else {
			prop.fail = !!required ? 'yes' : 'no';
			prop.msg = prop.fail == 'yes' ? 'required' : '';
		}
		return prop;
	}

	function validPropInteger(prop, minLen, maxLen, required) {
		prop = validPropText(prop, minLen, maxLen, true);
		if(prop.fail == 'no' && !validSvc.isInteger(prop.val)) {
			prop.fail = 'yes';
			prop.msg = 'numbers only';
		}
		return prop;
	}
	
	function validUserPayor(addItem) {

		// BIN - required, integer len = 6
		addItem.BIN = validPropInteger(addItem.BIN, 6, 6, true);

		// PCN - optional, 2 to 20 characters
		addItem.PCN = validPropText(addItem.PCN, 2, 20, false);

		// GroupNumber - optional, 2 to 20 characters
		addItem.GroupNumber = validPropText(addItem.GroupNumber, 2, 20, false);

		// Name - required, 2 to 40 characters
		addItem.Name = validText(addItem.Name, 2, 40);

		// ndc list
		var ndcOK = true,
			ndcTest = {};

		// list option is off
		if(addItem.NdcUseList == 'no') {
			addItem.NdcList = [];
		}

		// list empty
		if(addItem.NdcList.length < 1) {
			addItem.NdcUseList = 'no';
		}
		else {

			// re-validate ndc list
			for(var n = 0; n < addItem.NdcList.length; n++) {
				ndcTest = ndcCleanUp(addItem.NdcList[n].val, false);
				if(ndcTest.fail) {
					ndcOK = false;
					ndcTest.fail = 'yes';
				}
				else {
					ndcTest.fail = 'no';
				}
				addItem.NdcList[n] = ndcTest;
			}
		}

		// payor is unique?
		var medItem = null,
			alreadyExists = false;
		for(var i = 0; i < vm.medpayor.Items.length; i++ ) {
			if(vm.medpayor.Items[i].MedType == 'U') {
				medItem = vm.medpayor.Items[i];
				if(medItem.Id !== addItem.Id) {
					if(medItem.BIN.val == addItem.BIN.val &&
						medItem.PCN.val == addItem.PCN.val &&
						medItem.GroupNumber.val == addItem.GroupNumber.val &&
						medItem.Name.val == addItem.Name.val) {
							alreadyExists = true;
					}
				}
			}
		}
		addItem.hasErrorTxt = !!alreadyExists ? 'Payor already exists with these values' : '';

		if(addItem.BIN.fail != 'yes' && addItem.PCN.fail != 'yes' && addItem.GroupNumber.fail != 'yes' &&
			addItem.Name.fail != 'yes' && ndcOK && !alreadyExists) {
			addItem.hasError = false;
			return true; // valid
		}
		else {
			addItem.hasError = true;
			return false; // invalid
		}

	}

	function userPayorSave() {

		if(vm.isWaiting) {
			return;
		}

		// validate
		if(!validUserPayor(vm.userPayor)) {
			msgSvc.ok('Cannot Save', 'Check property values.');
			return;
		}


		// find payor in list (even for a new Payor it may already be there due to a 422 error return)
		var idx = findById(vm.medpayor.Items, vm.userPayor.Id);

		if(idx > -1) {
			vm.medpayor.Items[idx] = userPayorEditVM(vm.userPayor);
		}
		else if(vm.userPayorAction == 'ADD') {
			vm.medpayor.Items.push(userPayorEditVM(vm.userPayor));
		}
		else {
			alert('ceEditCtl.userPayorSave, payorId was not found in the medpayor list: ' + vm.userPayor.Id);
			tabChange('PAYORS');
			return;
		}

		vm.isWaiting = true;
		excludedPayorSave();

	}

	function userPayorRemove() {

		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;

		// find payor in list
		var idx = findById(vm.medpayor.Items, vm.userPayor.Id);
		if(idx < 0) {
			throw new Error('ceEditCtl.userPayorRemove, payorId was not found in the medpayor list: ' + vm.userPayor.Id);
		}

		msgSvc.confirm({
			id: 'ce.userpayor.remove',
			title: 'Remove Custom Payor',
			msg: 'Confirm remove custom payor with BIN: ' + vm.userPayor.BIN.val + ', PCN: ' + vm.userPayor.PCN.val + ', GRPNUM: ' + vm.userPayor.GroupNumber.val + '?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmUserPayorRemove, confirmUserPayorRemove);
	}

	function confirmUserPayorRemove(r) {
		vm.isWaiting = false;

		// user said yes to set DELETED status
		if(!!r && r.result == 'YES') {

			// find payor in list
			var idx = findById(vm.medpayor.Items, vm.userPayor.Id);
			if(idx > -1) {
				vm.medpayor.Items.splice(idx, 1);

				vm.isWaiting = true;
				excludedPayorSave();
			}

		}

	}


	/**
	 *    USER PAYOR NDC LIST EDITS
	 */

	function userPayorNdcListAdd() {

		// ndc format check
		var ndcTest = ndcCleanUp(vm.userPayorNdcListNew, false);
		if(ndcTest.fail) {
			msgSvc.ok('Cannot Add NDC', ndcTest.msg);
			return;
		}
		ndcTest = ndcTest.val;

		// unique
		var items = vm.userPayor.NdcList;
		for(var i = 0; i < items.length; i++) {
			if(ndcTest == items[i].val) {
				msgSvc.ok('Cannot Add NDC', ndcTest + ' already exists in this list');
				return;
			}
		}

		vm.userPayor.NdcList.push(validSvc.newProp(ndcTest));
		vm.userPayor.NdcList = utilSvc.array.sortASC(vm.userPayor.NdcList, 'val');
		vm.userPayorNdcListNew = '';

	}

	function userPayorNdcListRemove(ndc) {

		var idx = -1;
		for(var i = 0; i < vm.userPayor.NdcList.length; i++) {
			if(vm.userPayor.NdcList[i].val == ndc) {
				idx = i;
				break;
			}
		}
		if(idx < 0) {
			alert('NDC not found in Custom Payor NDC list: ' + ndc);
			return;
		}

		vm.userPayor.NdcList.splice(idx, 1);

	}


	/**
	 * 		OWN USE PAYORS
	 * 		note: similar list / edit as userPayors but not involved in the medPayor lists or medType so split this off
	 */

	function setupOwnUsePayors() {
		if(vm.isWaiting) {
			return;
		}

		vm.ownPayor = ownPayorListVM();
		vm.ownPayorFlt = {
			Text: {},
			SortBy: ['BIN']
		};

		vm.isWaiting = true;
		msgSvc.wait(true);

		ceRepo.getOwnUsePayors(_currentCE).then(okOwnPayorList, errOwnPayorList);

		function okOwnPayorList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.ownPayor = ownPayorListVM(r);
			vm.ownPayor.action = 'LIST';
		}

		function errOwnPayorList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
	
			if(!!r) {
				errSvc.warn('Unknown api error', 'ceEditCtl.getOwnUsePayors', r.status, utilSvc.http.safeResponse(r));
				$state.go('admin.ce.list');
			}
		}
	}

	function ownPayorAddEdit(item) {
		// called by UI to add or edit own use payor

		if(vm.isWaiting) {
			return;
		}

		// replace model properties directly on ownPayor object
		_pendingStatus = '';
		vm.ownPayor = ownPayorModelVM(vm.ownPayor, item);
	}

	function ownPayorValid(m) {
		// BIN - required, integer len = 6
		m.BIN = validPropInteger(m.BIN, 6, 6, true);

		// PCN - any, blank or specific value 2 to 20 characters
		m.PCN.fail = 'no';
		if(m.PcnWildCard == 'yes' || !validSvc.isText(m.PCN.val)) {
			m.PCN = validSvc.newProp('');
		}
		else {
			// specific value must be 2 to 20 characters
			m.PCN = validPropText(m.PCN, 2, 20, true);
		}

		// GroupNumber - any, blank or specific value 2 to 20 characters
		m.GroupNumber.fail = 'no';
		if(m.GroupNumberWildCard == 'yes' || !validSvc.isText(m.GroupNumber.val)) {
			m.GroupNumber = validSvc.newProp('');
		}
		else {
			// specific value must be 1 to 20 characters
			m.GroupNumber = validPropText(m.GroupNumber, 1, 20, true);
		}

		// Desc - optional, 2 to 40 characters
		m.Desc = validPropText(m.Desc, 2, 40, false);

		return m.BIN.fail != 'yes' &&
			m.PCN.fail != 'yes' &&
			m.GroupNumber.fail != 'yes' &&
			m.Desc.fail != 'yes';
	}

	function ownPayorUnique(ownPayor) {
		// check user is adding a unique combination
		// note: own use payors do not require a description
		var items = ownPayor.Items,
			isUpdate = ownPayor.action == 'UPDATE',		
			id = ownPayor.action == 'UPDATE' && validSvc.isText(ownPayor.Id) ? ownPayor.Id : '',		
			bin = ownPayor.BIN.val,
			pcnWildCard = ownPayor.PcnWildCard == 'yes',
			pcn = ownPayor.PCN.val,
			grpWildCard = ownPayor.GroupNumberWildCard == 'yes',
			grp = ownPayor.GroupNumber.val;

		var findPayor = items.find(function(payor) {
			return (isUpdate ? payor.Id != id : true) && // if updating, don't find yourself
				payor.BIN == bin &&
				payor.PcnWildCard == pcnWildCard &&
				payor.PCN == pcn &&
				payor.GroupNumberWildCard == grpWildCard &&
				payor.GroupNumber == grp;
		});

		return !findPayor;
	}

	function ownPayorSave() {
		if(vm.isWaiting || (vm.ownPayor.action != 'ADD' && vm.ownPayor.action != 'UPDATE')) {
			return;
		}

		// validate properties and unique
		if(!ownPayorValid(vm.ownPayor)) {
			msgSvc.ok('Cannot Save', 'Check property values');
			return;
		}
		if(!ownPayorUnique(vm.ownPayor)) {
			msgSvc.ok('Cannot Save', 'The same BIN / PCN / Group Number already exists');
			return;
		}

		// is this a status change?
		if(validSvc.isText(_pendingStatus)) {
			vm.ownPayor.Status = _pendingStatus;
		}

		vm.isWaiting = true;
		ceRepo.saveOwnUsePayor(_currentCE, vm.ownPayor).then(okOwnPayorSave, errOwnPayorSave);

		function okOwnPayorSave(r) {
			vm.isWaiting = false;

			// status change?
			if(validSvc.isText(_pendingStatus)) {
				// stay in edit screen
				msgSvc.ok('Status Changed to ' + _pendingStatus);
				_pendingStatus = '';
			}
			else {
				// go back to list
				tabChange('OWN-PAYORS');
			}
		}

		function errOwnPayorSave(r) {
			vm.isWaiting = false;
			_pendingStatus = '';

			if(!!r) {
				var handle422 = false;
				if(r.status == 422) {
					msgSvc.ok('Cannot Save', utilSvc.http.safeResponse(r));
				}
				else {
					errSvc.error('Unexpected api error', 'ceEditCtl.errOwnPayorSave', r.status, utilSvc.http.safeResponse(r));
				}
				tabChange('OWN-PAYORS');
			}
		}
	}

	function ownPayorToggleWildCard(propName) {
		if(vm.isWaiting) {
			return;
		}

		switch(propName) {
			case 'PCN':
				vm.ownPayor.PcnWildCard = vm.ownPayor.PcnWildCard == 'yes' ? 'no' : 'yes';
				vm.ownPayor.PCN = validSvc.newProp('');
				break;
			case 'GRP':
				vm.ownPayor.GroupNumberWildCard = vm.ownPayor.GroupNumberWildCard == 'yes' ? 'no' : 'yes';
				vm.ownPayor.GroupNumber = validSvc.newProp('');
				break;
			default:
				throw new Error('ceEdit.ownPayorToggleWildCard, unknown prop name: ' + propName);
		}
	}

	function ownPayorStatusToggle() {
		if(vm.isWaiting || vm.ownPayor.action != 'UPDATE') {
			return;
		}

		// confirm with user
		var newStatus = vm.ownPayor.Status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
		msgSvc.confirm({
			id: 'ce.ownpayor.status',
			title: 'Own Use Payor Status',
			msg: 'Confirm status change to ' + newStatus + '?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmOwnStatusChange, confirmOwnStatusChange);
	}

	function confirmOwnStatusChange(r) {
		if(!!r && r.result == 'YES') {
			// toggle status and re-save
			_pendingStatus = vm.ownPayor.Status == 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
			ownPayorSave();
		}
	}


	/**
	 *    PBM
	 */

	function loadPbmVendors() {

		vm.PbmVendors = [];
		vm.PbmVendorDroplist = [{label:'Choose a Vendor', value: 'NONE'}];
		vendorRepo.getList().then(okPbmList, errPbmList);

		function okPbmList(r) {

			r = Array.isArray(r) ? r : [];
			for(var i = 0; i < r.length; i++) {
				if(r[i].Type == 'PBM') {
					vm.PbmVendors.push(r[i]);
					vm.PbmVendorDroplist.push({label: r[i].Name, value: r[i].Id});
				}
			}

			// re-apply PBM
			if(validSvc.isText(_pendingPbmVendor)) {
				vm.model.CashCardPBM = utilSvc.ng.droplistAutoselect(vm.PbmVendorDroplist, _pendingPbmVendor);
			}

			// set max benefit level
			if(vm.model.CashCardPBM.val != 'NONE') {
				changeCashCardPBM();
			}
		}

		function errPbmList(r) {
			if(!!r) {
				errSvc.warn('CeEditCtl.Vendor list unknown error ' + _currentCE, 'ceEditCtl.loadPbmVendors', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    CARE CARD
	 */

	function changeCashCard(isOn) {

		vm.model.CashCardPBM = validSvc.newProp('NONE');

		if(isOn == 'yes') {
			_pendingPbmVendor = '';
			vm.model.CashCardExpires = validSvc.newProp(365);
			loadPbmVendors();
		}
		else {
			vm.model.CashCardExpires = validSvc.newProp(0);
		}
	}

	function changeCashCardPBM() {

		// each PBM has a different max benefit level

		vm.model.CashCardLevelMax = 0;

		if(vm.model.CashCardPBM.val != 'NONE') {

			// find this PBM
			var pbm = vm.model.CashCardPBM.val,
				pbms = vm.PbmVendors;
			for(var i = 0; i < pbms.length; i++) {
				if(pbms[i].Id == pbm && pbms[i].CashCard && validSvc.isInteger(pbms[i].CashCard.MaxBenefitLevel)) {
					vm.model.CashCardLevelMax = pbms[i].CashCard.MaxBenefitLevel;
				}
			}

			// setup editing display based on max
			var ccLen = vm.model.CashCardLevelMax,
				dbLen = vm.model.CashCardLevels.length,
				editLevels = [],
				editLevelNum = 0;

			for(var c = 0; c < ccLen; c++) {
				if(c < dbLen) {
					editLevels.push(vm.model.CashCardLevels[c]);
				}
				else {
					// add empty edit rows
					editLevels.push({
						Level: c + 1,
						Description: 'Level ' + (c + 1).toString(),
						fail: '',
						msg: ''
					});
				}
			}

			vm.model.CashCardLevels = editLevels;
		}

	}

	function cashAdtMapAdd() {

		if(vm.isWaiting) {
			return;
		}

		// max?
		if(vm.model.CashCardAdtMaps.length >= 12) {
			msgSvc.ok('Cannot Add Map', 'Maximum 12 maps allowed.');
			return;
		}

		vm.model.CashCardAdtMaps.push({
			From: '',
			To: 0,
			fail: '',
			msg: ''
		});

	}

	function cashAdtMapDelete(mapFrom) {

		if(vm.isWaiting) {
			return;
		}

		var maps = vm.model.CashCardAdtMaps;
		for(var i = maps.length - 1; i >= 0; i--) {
			if(maps[i].From == mapFrom) {
				maps.splice(i, 1);
			}
		}
	}

	function longerExport() {
		// Toggle the date picker panel
		vm.showHistoricalDates = !vm.showHistoricalDates;
		if (vm.showHistoricalDates) {
			vm.historicalStartDate = validSvc.newPropDateNull();
			vm.historicalEndDate = validSvc.newPropDateNull();
			vm.historicalDateRangeMode = 'MTD';
			vm.historicalDatesValid = false;
			vm.historicalDateError = '';
			vm.historicalExportQueued = false;
			$timeout(function(){
				$scope.$broadcast('widget.input.date.range.mode', {mode: 'MTD', keepDates: false});
			}, 100);
		}
	}

	function historicalDateRangeChange(dtMode, isValid) {
		vm.historicalDateRangeMode = dtMode;
		vm.historicalDatesValid = isValid;
		vm.historicalDateError = '';

		if (isValid && vm.historicalStartDate.val && vm.historicalEndDate.val) {
			var start = new Date(vm.historicalStartDate.val);
			var end = new Date(vm.historicalEndDate.val);

			// Max range: 730 days
			var maxEnd = new Date(start);
			maxEnd.setDate(maxEnd.getDate() + 730);
			if (end > maxEnd) {
				vm.historicalDatesValid = false;
				vm.historicalDateError = 'Date range cannot exceed 730 days.';
				return;
			}

			// End date cannot be in the future
			var today = new Date();
			today.setHours(23, 59, 59, 999);
			if (end > today) {
				vm.historicalDatesValid = false;
				vm.historicalDateError = 'End date cannot be in the future.';
				return;
			}
		}
	}

	function confirmHistoricalExport() {
		if (!vm.historicalDatesValid) { return; }

		var start = new Date(vm.historicalStartDate.val);
		var end = new Date(vm.historicalEndDate.val);

		msgSvc.confirm({
			id: 'ce.longerExport.confirm',
			title: 'Confirm Historical Export',
			msg: 'This will queue a one-time historical export from ' +
				(start.getMonth() + 1) + '/' + start.getDate() + '/' + start.getFullYear() +
				' to ' +
				(end.getMonth() + 1) + '/' + end.getDate() + '/' + end.getFullYear() +
				'. Continue?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'Cancel', result:'CANCEL', cancel: true}
			]
		}).then(function(r) {
			if (!!r && r.result == 'YES') {
				vm.model.DataExportsLastLongerExport = utilSvc.dt.zeroTime(new Date());
				vm.model.DataExportsNextExtractIsHistorical = true;
				vm.model.DataExportsHistoricalStartDate = (start.getMonth() + 1) + '/' + start.getDate() + '/' + start.getFullYear();
				vm.model.DataExportsHistoricalEndDate = (end.getMonth() + 1) + '/' + end.getDate() + '/' + end.getFullYear();
				vm.historicalExportQueued = true;
				submitAcct();
			}
		});
	}

	function cancelHistoricalExport() {
		vm.showHistoricalDates = false;
		vm.historicalStartDate = validSvc.newPropDateNull();
		vm.historicalEndDate = validSvc.newPropDateNull();
		vm.historicalDateRangeMode = 'MTD';
		vm.historicalDatesValid = false;
		vm.historicalDateError = '';
		vm.historicalExportQueued = false;
	}

	/**
	 *    HELPERS
	 */

	function validText(prop, min, max) {

		// required
		if(!validSvc.isText(prop.val)) {
			prop.fail = 'yes';
			prop.msg = 'required';
			return prop;
		}

		// min
		if(prop.val.length < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum ' + min.toString() + ' characters';
			return prop;
		}

		// max
		if(prop.val.length > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum ' + max.toString() + ' characters';
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;

	}

	function ndcCleanUp(val, skipEmpty) {

		var zeroPad = "00000000000",
			ndcTest = '';

		// must be text
		if(!!!skipEmpty && !validSvc.isText(val)) {
			return validSvc.newProp(val, true, 'required');
		}

		// remove all non-numeric characters
		ndcTest = val.toString().trim();
		ndcTest = ndcTest.replace(/[^0-9]+/g,'');

		// empty
		if(ndcTest.length < 1) {
			if(!!skipEmpty) {
				return validSvc.newProp('', false, '');
			}
			else {
				return validSvc.newProp(ndcTest, true, 'empty');
			}
		}

		// max len
		if(ndcTest.length > 11) {
			return validSvc.newProp(ndcTest, true, 'max 11 characters');
		}

		// integer
		var intVal = parseInt(ndcTest);
		if(!validSvc.isInteger(intVal)) {
			return validSvc.newProp(ndcTest, true, 'must be an integer');
		}

		// all zeros
		if(intVal <= 0) {
			return validSvc.newProp(ndcTest, true, 'cannot be zero');
		}

		// pad zeros if needed, pass
		ndcTest = zeroPad.substr(0, 11 - ndcTest.length) + ndcTest;
		return validSvc.newProp(ndcTest, false, '');

	}

	function findById(items, id) {
		for(var i = 0; i < items.length; i++ ) {
			if(items[i].Id == id) {
				return i;
			}
		}
		return -1;
	}

	function validCurrency(prop, min, max) {

		// parse into float
		var floatVal;
		try {
			floatVal = parseFloat(prop.val);
		}
		catch(err) {
			// do nothing
		}

		// not a number
		if(!validSvc.isNumber(floatVal)) {
			prop.fail = 'yes';
			prop.msg = 'must be a number';
			return prop;
		}

		// min
		if(floatVal < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum: ' + min;
			return prop;
		}

		// max
		if(floatVal > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum: ' + max;
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';

		return prop;

	}

	function validZip(prop) {
		prop.fail = 'yes';
		prop.msg = '5 or 10 numbers with format: "12345-1234"';

		// is empty
		if(!validSvc.isText(prop.val)) {
			return prop;
		}

		// strip down to numbers and dash
		prop.val.replace(/[^0-9\-]+/g,'');

		// no dash, check length 5
		if(prop.val.indexOf('-') < 0) {
			if(prop.val.length != 5) {
				return prop;
			}
		}
		else {
			// has dash, check format "12345-1234"
			var zipVals = prop.val.split('-');
			if(zipVals.length != 2 || zipVals[0].length != 5 || zipVals[1].length != 4) {
				return prop;
			}
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;
	}
}
 
ceListCtl.$inject = ['$state', '$rootScope', '$scope', '$filter', '$timeout', 'ceRepo', 'prefsRepo', 'sessionRepo', 'validSvc', 'utilSvc', 'errSvc', 'msgSvc'];
angular
.module('espui.admin.ce')
.controller('CeListCtl', ceListCtl);


/* @ngInject */
function ceListCtl($state, $rootScope, $scope, $filter, $timeout, ceRepo, prefsRepo, sessionRepo, validSvc, utilSvc, errSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _pagingEventListener = null,
		_mouseLeaveDelay = [],
		_RxAffsCeList = [],
		_CeFavsDirty = false;


	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addMultiselect(vm);
	utilSvc.ctl.addFiltering(vm);

	// properties
	vm.init = false;
	vm.isWaiting = false;

	// droplists
	vm.OpaTypeDroplist = [];
	vm.StatusDroplist = [];

	// tbl and filters
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;

	// methods
	vm.create = create;
	vm.edit = edit;

	// adv filters
	vm.advFilter = {};
	vm.advFilterToggle = advFilterToggle;
	vm.advFilterPropToggle = advFilterPropToggle;

	// adv filter multiselect
	vm.CeFavMulti = {};
	vm.CeMulti = {};
	vm.RxAffMulti = {};

	vm.RxBizMultiselect = {};
	vm.ProgAdminMulti = {};
	vm.multiToggle = multiToggle;
	vm.multiHover = multiHover;
	vm.multiClick = multiClick;
	vm.multiCeFavToggle = multiCeFavToggle;


	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		vm.init = true;

		initFiltersAndDroplists();
		vm.flt = applyViewstate(vm.flt);

		// has npi filter (this is possible if viewstate already has this, we are returning to this screen)
		var hasNpiFilter = vm.flt.Exact.advNpiList == 'yes';
		getList(hasNpiFilter);

	}

	function initFiltersAndDroplists() {

		// table filter setup
		vm.flt = vm.initFilters({
			Exact: {
				OpaType: '',
				ObjectState: '',
				advCashCard: '',
				advCDC: '',
				advFeedsOff: '',
				advNpiProx: '',
				advLocFlt: '',
				advCustPayor: '',
				advMedPayor: '',
				advNpiList: ''
			},
			SortBy: ['Id']
		});

		vm.OpaTypeDroplist = [
			{value:'', label: 'All'},
			{value:'BL', label: 'Black Lung Clinics Program'},
			{value:'PED', label: 'Childrens Hospital'},
			{value:'HM', label: 'Comprehensive Hemophilia Treatment Center'},
			{value:'CH', label: 'Consolidated Health Center Program'},
			{value:'CAH', label: 'Critical Access Hospital'},
			{value:'DSH', label: 'Disproportionate Share Hospital'},
			{value:'FP', label: 'Family Planning (Title X only)'},
			{value:'FQHCLA', label: 'Federally Qualified Health Center Look-Alike'},
			{value:'CAN', label: 'Free Standing Cancer Hospital'},
			{value:'HO', label: 'Health Care for the Homeless Program'},
			{value:'MH', label: 'Migrant Health Program'},
			{value:'NH', label: 'Native Hawaiian Health Care Program'},
			{value:'PH', label: 'Public Housing Primary Care Program'},
			{value:'RRC', label: 'Rural Referral Center'},
			{value:'RWI', label: 'Ryan White Part A'},
			{value:'RWII', label: 'Ryan White Part B'},
			{value:'RWIID', label: 'Ryan White Part B ADAP Direct Purchase'},
			{value:'RWIIR', label: 'Ryan White Part B ADAP Rebate Option'},
			{value:'HV', label: 'Ryan White Part C'},
			{value:'RW4', label: 'Ryan White Part D'},
			{value:'SPNS', label: 'Ryan White Part F'},
			{value:'340S', label: 'School Based Program (Healthy Schools, Healthy Communities)'},
			{value:'STD', label: 'Sexually Transmitted Diseases'},
			{value:'SCH', label: 'Sole Community Hospital'},
			{value:'FQHC638', label: 'Tribal Contract/Compact with IHS (P.L. 93-638)'},
			{value:'TB', label: 'Tuberculosis'},
			{value:'UI', label: 'Urban Indian'}
		];

		vm.StatusDroplist = utilSvc.ng.droplist([
			'ONBOARDING',
			'ACTIVE',
			'INACTIVE',
			'DELETED'
			],
			'',
			'',
			[{value:'', label: 'ALL'}]
		);

		var affs = $scope.User.AffList;
		var ceList = utilSvc.aff.ceList(affs),
			rxList = utilSvc.aff.rxList(affs);

		// multiselect advanced filter: favorites
		vm.CeFavMulti = {
			type: 'ADV',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Not Filtered',
			vals: [],
			list: vm.multiselectBuild(ceList, false),
			flt: '',
			favsOn: 'no'
		};
		vm.CeFavMulti = applyCeFavs(vm.CeFavMulti);

		// multiselect advanced filter: CE
		vm.CeMulti = {
			type: 'ADV',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Not Filtered',
			vals: [],
			list: vm.multiselectBuild(ceList, false),
			flt: ''
		};
		vm.multiselectTitle(vm.CeMulti);

		// multiselect advanced filter: RX affiliate
		rxList.unshift('ALL');
		vm.RxAffMulti = {
			type: 'ADV',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Not Filtered',
			titleAllOptions: 'Any Affilliate',
			vals: [],
			list: vm.multiselectBuildRX(rxList, false, $scope.User.AffList),
			flt: ''
		};
		multiPreTitle(vm.RxAffMulti);

		// multiselect advanced filter: program admin
		vm.ProgAdminMulti = {
			type: 'ADV',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Not Filtered',
			titleAllOptions: 'Any Program Admin',
			vals: [],
			list: []
		};

		// advanced filter display
		vm.advFilter = {
			expand: false,
			titles: []
		};

	}

	function applyViewstate(flt) {

		// feature session
		var vs = sessionRepo.get('vs-admin-ce-list');
		if(!!vs) {

			flt = vm.resetFilters(vs.flt, true);

			// adv filter CE
			multiReturnWithTitle(vm.CeMulti, vs.multi.CE);

			// adv RX Aff filter (rebuild RX list if used)
			multiReturnWithTitle(vm.RxAffMulti, vs.multi.RxAff);
			if(vm.RxAffMulti.vals.length > 0) {
				var rxAffs = utilSvc.aff.findRxList($scope.User.AffList, vm.multiselectAllVals(vm.RxAffMulti));
				_RxAffsCeList = utilSvc.aff.ceList(rxAffs);
			}

			// adv filter: don't rebuild this one yet, wait for get list parse
			vm.ProgAdminMulti.vals = vs.multi.ProgAdmin;

			// adv filter
			// tbd... multiReturnWithTitle(vm.RxBizMultiselect, vs.multi.RxBiz);

		}

		return flt;

	}

	function multiReturnWithTitle(multi, vals) {

		// rebuild and set title
		vm.multiselectReturnVisit(multi, '', vals);
		multiPreTitle(multi, true);
	}


	/**
	 *    DISPLAY VIEW MODEL
	 *    built from empty or repo result data
	 */

	function displayVM(repoData) {

		var items = Array.isArray(repoData) ? repoData : [],
			item = {},
			progAdmins = [],
			progAdmin = '',
			cdcCeList = getCdcCeList();

		for(var i = 0; i < items.length; i++) {
			item = items[i];

			// adv filter: prog admin
			if(validSvc.isText(item.ProgramAdmin)) {
				progAdmin = item.ProgramAdmin.toUpperCase();
				item.advProgAdmin = progAdmin;

				if(progAdmins.indexOf(progAdmin) < 0) {
					progAdmins.push(progAdmin);
				}
			}

			// adv filter: cash card
			if(!!item.CashCard && !!item.CashCard.Participant) {
				item.advCashCard = 'yes';
			}

			// adv filter: CDC
			if(cdcCeList.indexOf(item.Id) > -1) {
				item.advCDC = 'yes';
			}

			// adv filter: feeds off
			if(!!item.DisableErx || !!item.DisableVisits) {
				item.advFeedsOff = 'yes';
			}

			// adv filter: npi proximity
			if(!!item.NpiEnforceProximity) {
				item.advNpiProx = 'yes';
			}

			// adv filter: location filtering
			if(!!item.LocationFiltering) {
				item.advLocFlt = 'yes';
			}

			// adv filter: custom payors
			if(!!item.CustomPayors) {
				item.advCustPayor = 'yes';
			}

			// adv filter: medicaid payor overrides
			if(!!item.MedicaidPayors) {
				item.advMedPayor = 'yes';
			}

			// adv filter: NPI list
			if(!!item.NpiList) {
				item.advNpiList = 'yes';
			}

		}

		// adv filter multiselect list
		vm.ProgAdminMulti.list = buildAdvFilterList(progAdmins, vm.ProgAdminMulti.titleAllOptions);
		multiReturnWithTitle(vm.ProgAdminMulti, vm.ProgAdminMulti.vals);

		// update adv filter titles
		vm.advFilter.titles = advFilterTitleRefresh();

		return {
			Items: [],
			DataItems: items
		};

	}

	function buildAdvFilterList(options, noneTitle) {

		// customize adv filter multiselect list

		if(options.length < 1) {
			return [];
		}

		options.sort();
		options.unshift('ALL');
		var result = vm.multiselectBuild(options, false);
		if(result[0].val == 'ALL') {
			result[0].lbl = noneTitle;
		}

		return result;

	}


	/**
	 *    GLOBAL GREASE COLUMN FILTERS
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			vm.tbl.Items = preFilterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					saveViewState(vm.flt);
				}
			},1000);

		}, delayTime);

	}

	function preFilterList(dataItems, flt) {

		// filter dataItems using incoming filter object
		// note: 	this function has no concept of waiting or debouncing, it will run every time its called immediately
		// 			this is called on init or tab load, see filterChange() for UI debouncing/blocking/isBusy functionality

		var newItems = dataItems;

		// filter by rx biz model multiselect (OPTIONS only)
		/* note: this is a ridiculous 3 level deep filter loop due to each row having an array of rx biz models
		if(dataItems.length > 0 && !!vm.RxBizMultiselect.dirty) {
			var rxBizResult = [],
				rxBizItems = Array.isArray(vm.RxBizMultiselect.vals) ? vm.RxBizMultiselect.vals : [];
			if(rxBizItems.length > 0) {

				// specific items checked, look in each row's biz models
				if(rxBizItems[0] != 'ALL') {
					var rowMatch = true,
						rowModels = [];

					// loop table items
					for(var i = 0; i < newItems.length; i++) {
						rowModels = newItems[i].BusinessModels;
						rowMatch = false;

						// loop checked models
						for(var ii = 0; ii < rxBizItems.length; ii++) {

							// loop row models
							for (var iii = 0; iii < rowModels.length; iii++) {
								if(rowModels[iii] == rxBizItems[ii]) {
									rowMatch = true;
									break;
								}
							}
							if(rowMatch) {
								break;
							}
						}

						// 1 checked model found in row models
						if(rowMatch) {
							rxBizResult.push(newItems[i]);
						}
					}

					newItems = rxBizResult;
				}
			}
			else {
				// no options selected
				newItems = [];
			}
		}*/

		// CE
		if(newItems.length > 0) {
			var ceVals = vm.CeFavMulti.favsOn == 'yes' ? vm.CeFavMulti.vals : vm.CeMulti.vals;
			if(ceVals.length > 0) {
				newItems = $filter('filterDropselect')(newItems, 'Id', ceVals);
			}
		}

		// advanced filter: RX affiliate
		if(newItems.length > 0 && vm.RxAffMulti.vals.length > 0) {
			newItems = $filter('filterDropselect')(newItems, 'Id', _RxAffsCeList);
		}

		// advanced filter: Prog Admin
		if(newItems.length > 0 && vm.ProgAdminMulti.vals.length > 0) {
			newItems = $filter('filterDropselect')(newItems, 'advProgAdmin', vm.multiselectAllVals(vm.ProgAdminMulti));
		}

		// call inherited filter (always call this to calculate paging properties)
		return vm.filterList(newItems, flt);

	}


	/**
	 *    GET LIST
	 */

	function getList(findNpiListEntities) {

		vm.isWaiting = true;
		msgSvc.wait(true, true);

		ceRepo.getList(!!findNpiListEntities).then(okList, errList);  // npi query is slower

		function okList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.tbl = displayVM(r.data);
			vm.tbl.Items = preFilterList(vm.tbl.DataItems, vm.flt);

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			vm.init = false;
			vm.flt.Ready = true;
		}

		function errList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('unknown error getting data', 'ce.getList.err', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    CREATE / EDIT
	 */

	function create() {
		$state.go('admin.ce.create', {}, {reload:'admin.ce.create'});
	}

	function edit(id) {
		$state.go('admin.ce.edit', {CE: id}, {reload:'admin.ce.edit'});
	}


	/**
	 *    ADVANCED FILTERS
	 */

	function advFilterToggle() {
		vm.advFilter.expand = !!!vm.advFilter.expand;
	}

	function advFilterPropToggle(id, runTableFilter) {

		// toggle property state, this will clear multiselects

		if(vm.isWaiting) {
			return;
		}

		switch(id) {

			case 'advCeFav':
				// turn off favorites, do not clear them
				vm.CeFavMulti.favsOn = 'no';
				if(!_CeFavsDirty) {
					_CeFavsDirty = true;
					$timeout(saveCeFavs, 3000);
				}
				break;

			case 'advCe':
				vm.multiselectClick(vm.CeMulti, '|CLEAR|');
				vm.multiselectTitle(vm.CeMulti, true);
				break;

			case 'advRxAff':
				vm.multiselectClick(vm.RxAffMulti, '|CLEAR|');
				multiPreTitle(vm.RxAffMulti, true);
				break;

			case 'advProgAdmin':
				vm.multiselectClick(vm.ProgAdminMulti, '|CLEAR|');
				vm.multiselectTitle(vm.ProgAdminMulti, true);
				break;

			case 'advCashCard':
				vm.flt.Exact.advCashCard = vm.flt.Exact.advCashCard == 'yes' ? '' : 'yes';
				break;

			case 'advCDC':
				vm.flt.Exact.advCDC = vm.flt.Exact.advCDC == 'yes' ? '' : 'yes';
				break;

			case 'advFeedsOff':
				vm.flt.Exact.advFeedsOff = vm.flt.Exact.advFeedsOff == 'yes' ? '' : 'yes';
				break;

			case 'advNpiProx':
				vm.flt.Exact.advNpiProx = vm.flt.Exact.advNpiProx == 'yes' ? '' : 'yes';
				break;

			case 'advLocFlt':
				vm.flt.Exact.advLocFlt = vm.flt.Exact.advLocFlt == 'yes' ? '' : 'yes';
				break;

			case 'advCustPayor':
				vm.flt.Exact.advCustPayor = vm.flt.Exact.advCustPayor == 'yes' ? '' : 'yes';
				break;

			case 'advMedPayor':
				vm.flt.Exact.advMedPayor = vm.flt.Exact.advMedPayor == 'yes' ? '' : 'yes';
				break;

			case 'advNpiList':
				vm.flt.Exact.advNpiList = vm.flt.Exact.advNpiList == 'yes' ? '' : 'yes';
				if(vm.flt.Exact.advNpiList == 'yes') {
					getList(true);
				}
				break;

			default:
				alert('ceListCtl.advFilterPropToggle, unknown filter id: ' + id);
				return;
		}

		vm.advFilter.titles = advFilterTitleRefresh();

		if(!!runTableFilter) {
			filterChange();
		}

	}

	function advFilterTitleRefresh() {

		// refresh advanced filter titles

		var result = [];

		if(vm.CeFavMulti.favsOn == 'yes') {
			if(vm.CeFavMulti.vals.length > 0) {
				result.push({
					id: 'advCeFav',
					title: 'Facility Favorites',
					txt: vm.CeFavMulti.vals[0] == 'ALL' ? vm.CeFavMulti.titleAllOptions : vm.CeFavMulti.title
				});
			}
		}
		else if(vm.CeMulti.vals.length > 0) {
			result.push({
				id: 'advCe',
				title: 'Facility',
				txt: vm.CeMulti.vals[0] == 'ALL' ? vm.CeMulti.titleAllOptions : vm.CeMulti.title
			});
		}

		if(vm.RxAffMulti.vals.length > 0) {
			result.push({
				id: 'advRxAff',
				title: 'Pharmacy Affiliates',
				txt: vm.RxAffMulti.title
			});
		}

		if(vm.ProgAdminMulti.vals.length > 0) {
			result.push({
				id: 'advProgAdmin',
				title: 'Program Admin',
				txt: vm.ProgAdminMulti.vals[0] == 'ALL' ? vm.ProgAdminMulti.titleAllOptions : vm.multiselectAllVals(vm.ProgAdminMulti).join(', ')
			});
		}

		var fltExact = vm.flt.Exact;

		if(fltExact.advCDC == 'yes') {
			result.push({
				id: 'advCDC',
				title: 'CDC Pharmacy',
				txt: ''
			});
		}

		if(fltExact.advFeedsOff == 'yes') {
			result.push({
				id: 'advFeedsOff',
				title: 'Feeds Off',
				txt: ''
			});
		}

		if(fltExact.advCashCard == 'yes') {
			result.push({
				id: 'advCashCard',
				title: 'Care Card',
				txt: ''
			});
		}

		if(fltExact.advNpiProx == 'yes') {
			result.push({
				id: 'advNpiProx',
				title: 'NPI Proximity',
				txt: ''
			});
		}

		if(fltExact.advLocFlt == 'yes') {
			result.push({
				id: 'advLocFlt',
				title: 'Location Filtering',
				txt: ''
			});
		}

		if(fltExact.advCustPayor == 'yes') {
			result.push({
				id: 'advCustPayor',
				title: 'Custom Excluded Payors',
				txt: ''
			});
		}

		if(fltExact.advMedPayor == 'yes') {
			result.push({
				id: 'advMedPayor',
				title: 'Medicaid Payor Overrides',
				txt: ''
			});
		}

		if(fltExact.advNpiList == 'yes') {
			result.push({
				id: 'advNpiList',
				title: 'NPI List',
				txt: ''
			});
		}

		return result;
	}


	/**
	 *    MULTISELECT
	 */

	function multiPreTitle(multi, autoSelectTitle) {

		// RX affiliates use short names, use this function if needed

		if(!!multi && multi === vm.RxAffMulti && multi.vals.length === 1 && multi.vals[0] != 'ALL') {
			multi.title = utilSvc.aff.rxShortNameById($scope.User.AffList, multi.vals[0]);
		}
		else {
			vm.multiselectTitle(multi, autoSelectTitle);
		}

	}

	function multiClick(propName, val) {

		var multi = vm[propName];
		vm.multiselectClick(multi, val);
		multiPreTitle(multi, true);

		if(multi.type == 'ADV') {

			if(propName == 'CeFavMulti' && !_CeFavsDirty) {
				_CeFavsDirty = true;
				$timeout(saveCeFavs, 3000);
			}
			else if(propName == 'RxAffMulti') {

				// RX affiliate, rebuild CE list
				var rxAffs = utilSvc.aff.findRxList($scope.User.AffList, vm.multiselectAllVals(multi));
				_RxAffsCeList = utilSvc.aff.ceList(rxAffs);
			}

			vm.advFilter.titles = advFilterTitleRefresh();
		}

		filterChange();
	}

	function multiToggle(evt, propName, elemId) {

		// show / hide multiselect list

		var multi = vm[propName];
		multi.flt = '';

		// hide multi list
		if(multi.show) {
			multi.show = false;
			return;
		}

		// show with minimum width
		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(elemId + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(elemId);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multi.show = true;

	}

	function multiHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}

	function multiCeFavToggle() {

		// switch CE filtering between favorites and the default CE checklist

		vm.CeFavMulti.favsOn = vm.CeFavMulti.favsOn == 'yes' ? 'no' : 'yes';
		vm.advFilter.titles = advFilterTitleRefresh();

		if(!_CeFavsDirty) {
			_CeFavsDirty = true;
			$timeout(saveCeFavs, 3000);
		}

		filterChange(true);

	}


	/**
	 *    HELPERS
	 */

	function applyCeFavs(multi) {

		// CE favs stored in AdminPrefs, not in session
		var CeFavs = $rootScope.User.AdminPrefs.CeFavs || {on:'no',vals: []};
		multi.favsOn = CeFavs.on;

		var favs = Array.isArray(CeFavs.vals) ? CeFavs.vals : [];
		multiReturnWithTitle(multi, favs);

		return multi;
	}

	function saveCeFavs() {

		if(!_CeFavsDirty) {
			return;
		}
		_CeFavsDirty = false;

		// different from last save?
		var savedCeFavs = $rootScope.User.AdminPrefs.CeFavs || {on:'no',vals: []},
			multiFavs = vm.CeFavMulti.vals.concat([]); // de-reference;

		// ALL is saved as no favorites
		if(multiFavs.length > 0 && multiFavs[0] == 'ALL') {
			multiFavs = [];
		}

		// multi different than saved?
		if(vm.CeFavMulti.favsOn != savedCeFavs.on || savedCeFavs.vals.join('|') != multiFavs.join('|')) {

			// update session and db
			$rootScope.User.AdminPrefs.CeFavs = {
				on: vm.CeFavMulti.favsOn,
				vals: multiFavs
			};
			sessionRepo.set('User', $rootScope.User);

			prefsRepo.save('ADMIN', angular.toJson($rootScope.User.AdminPrefs)).then(okSavePref, errSavePref);
		}

	}

	function okSavePref(r) {
		// no action
	}

	function errSavePref(r) {
		if(!!r) {
			errSvc.warn('Unknown api error saving AdminPrefs', 'celistCtl.saveCeFavs', r.status, utilSvc.http.safeResponse(r));
		}
	}

	function saveViewState(flt) {

		sessionRepo.set('vs-admin-ce-list', {
			flt: flt,
			multi: {
				CE: vm.CeMulti.vals,
				RxBiz: vm.RxBizMultiselect.vals,
				RxAff: vm.RxAffMulti.vals,
				ProgAdmin: vm.ProgAdminMulti.vals
			}
		});

	}

	function getCdcCeList() {

		// find affs with a pharmacy which is a CDC

		var result = [],
			affs = $scope.User.AffList;

		for(var i = 0; i < affs.length; i++) {

			// pharmacy is a CDC
			if(!!affs[i].RxCDC && validSvc.isText(affs[i].CEID) && result.indexOf(affs[i].CEID) < 0) {
				result.push(affs[i].CEID);
			}
		}

		return result;
	}


}
 
ceRepo.$inject = ['$rootScope', '$q', 'apiService', 'apiErrors', 'appConst', 'errSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
.module('espui.admin.ce')
.factory('ceRepo', ceRepo);

/* @ngInject */
function ceRepo($rootScope, $q, apiService, apiErrors, appConst, errSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _currentPurl = '',
		_apiPaging = vmSvc.api.paging(),
		_modelPending = null;

	// service definition
	var service = {
		modelVM: modelVM,
		contextVM: contextVM,
		contextRefreshVM: contextRefreshVM,

		// CE
		getList: getList,
		getDetail: getDetail,
		createAcct: createAcct,
		updateAcct: updateAcct,
		statusChange: statusChange,

		// medicaid / payors
		getPayors: getPayors,
		getMedPayor: getMedPayor,
		saveMedPayor: saveMedPayor,
		getOwnUsePayors: getOwnUsePayors,
		saveOwnUsePayor: saveOwnUsePayor,

		// adt
		getAdtConfig: getAdtConfig,
		saveAdtConfig: saveAdtConfig
	};

	return service;


	/**
	 *    CONTEXT
	 */

	function contextVM() {

		var uType = $rootScope.User.Type;

		return {
			uType: uType,
			isVerity: uType == 'VERITYSA' || uType == 'VERITY',
			isVeritySA: uType == 'VERITYSA'
		};

	}

	function contextRefreshVM() {

		// called by ce.update
		// all admin features refresh the affs before edits

		var defer = $q.defer();
		apiService.refreshUser().then(okUserRefresh, errUserRefresh);

		function okUserRefresh(r) {
			defer.resolve(contextVM());
		}

		function errUserRefresh(r) {
			if(r !== null) {
				errSvc.warn('Affiliations request failed', 'ceRepo.contextRefreshVM', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    USER SILENT REFRESH
	 *    after CE create / updates or status, refresh the user's affiliations in session
	 */

	function refreshUserSilent() {

		// refresh login affs silent
		// note: don't care about the response, just doing a refresh for other features

		apiService.refreshUser().then(okAffRefreshSilent, errAffRefreshSilent);

		function okAffRefreshSilent(r) {
			// do nothing
		}

		function errAffRefreshSilent(r) {
			if(r !== null) {
				errSvc.warn('Affiliations refresh failed', 'ceRepo.errAffRefreshSilent', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    GET LIST
	 */

	function getList(findNpiListEntities) {

		_currentPurl = 'admin/ce/list';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('Id')]
		};

		// user has NPI list filter set
		if(!!findNpiListEntities) {
			apiRequest.Params = {
				NpiList: true
			};
		}

		// call api
		apiService.post(_currentPurl, apiRequest).then(getOk, getErr);

		function getOk(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return query and data
			defer.resolve({
				query: {
					Paging: utilSvc.paging.apiResults(vmSvc.api.paging(), _apiPaging.Size, r.data.Entity.length, _apiPaging.Size)
				},
				data: r.data.Entity
			});

		}

		function getErr(r) {

			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);

		}

		return defer.promise;

	}


	/**
	 *    GET DETAIL
	 */

	function getDetail(id) {

		if(!validSvc.isText(id)) {
			throw new Error('ce.repo.getDetail, id is missing');
		}

		_currentPurl = 'admin/ce/get';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Entity: {
				Params: {
					Id: id
				}
			}
		};

		apiService.post(_currentPurl, apiReqest).then(getOk, getErr);

		function getOk(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return model
			defer.resolve(modelVM(r.data.Entity));

		}

		function getErr(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    EDIT MODEL
	 */

	function modelVM(data) {

		var i = 0;

		// create new structure if doesn't exist
		data = data || {};
		data.CashCard = data.CashCard || {};
		
		// cash card levels
		var ccLevels = [],
			dbLevels = Array.isArray(data.CashCard.BenefitLevels) ? data.CashCard.BenefitLevels : [];
		for(i = 0; i < dbLevels.length; i++) {
			ccLevels.push({
				Level: dbLevels[i].Level,
				Description: dbLevels[i].Description,
				fail: '',
				msg: ''
			});
		}

		// cash card adt mappings
		data.CashCard.AdtConfig = data.CashCard.AdtConfig || {};
		var ccMaps = Array.isArray(data.CashCard.AdtConfig.Maps) ? data.CashCard.AdtConfig.Maps : [];
		for(i = 0; i < ccMaps.length; i++) {
			ccMaps[i].To = validSvc.isText(ccMaps[i].To) ? parseInt(ccMaps[i].To) : 0;
			ccMaps[i].fail = '';
			ccMaps[i].msg = '';
		}

		// opa date min/max (340B started Nov 1992)
		var dtOpaMin = new Date(1992, 10, 1, 0, 0, 0),
			dtOpaMax = utilSvc.dt.zeroTime(utilSvc.dt.addDays(new Date(), 365));

		var dtOwnMin = utilSvc.dt.zeroTime(utilSvc.dt.addDays(new Date(), -10*365)),
			dtOwnMax = new Date();

		var dtRefMin = new Date(1992, 10, 1, 0, 0, 0),
			dtRefMax = new Date();

		// address
		var address = data.Address || {};

		// data exports
		var dx = !!data.DataExports && !!data.DataExports.Enabled ? data.DataExports : {};

		// price validation
		var pv = !!data.PriceValidationConfig && !!data.PriceValidationConfig.Enabled ? data.PriceValidationConfig : {};

		var m = {
			Id: validSvc.newProp(validSvc.isText(data.Id) ? data.Id : ''),
			ProductType: !!data.ProductType ? data.ProductType : '',
			ExpressScriptsCustomer: !!data.ExpressScriptsCustomer ? 'yes' : 'no',
			IsVerityPrimary: data.IsVerityPrimary === false ? 'no' : 'yes', // default to yes
			IsHrsaRegistered: data.IsHrsaRegistered === false ? 'no' : 'yes', // default to yes
			CeOwnUseProgram: !!data.OwnUseProgram ? 'yes' : 'no',
			CePreferredAccumulationAccount: validSvc.isText(data.PreferredAccumGroup) ? data.PreferredAccumGroup : 'OWN',
			OwnUseProgramStartDate: validSvc.newPropDateExact(utilSvc.dt.fromServerDateExactPST(data.OwnUseProgramStartDate), dtOwnMin, dtOwnMax),
			CeOwnUsePatientClaims: data.OwnUsePatientClaims ? 'yes' : 'no',
			CeOwnUsePatientClaimsFillOption: validSvc.isText(data.OwnUsePatientClaimsFillOption) ? data.OwnUsePatientClaimsFillOption : 'ALL',
			CeOwnUsePatientClaimsLastFill: validSvc.newProp(validSvc.isNumber(data.OwnUsePatientClaimsLastFill) ? data.OwnUsePatientClaimsLastFill : 0),
			IncludeControlled : !!data.ExcludeControlled ? 'no' : 'yes',
			OwnUseExcludeMedicaid: !!data.OwnUseExcludeMedicaid ? 'yes' : 'no',

			CpAcctId: validSvc.newProp(validSvc.isText(data.CpAcctId) ? data.CpAcctId : ''),
			SplitAcctId: validSvc.newProp(validSvc.isText(data.SplitAcctId) ? data.SplitAcctId : ''),
			Type: validSvc.newProp(validSvc.isText(data.Type) ? data.Type : 'DEFAULT'),
			ObjectState: validSvc.isText(data.ObjectState) ? data.ObjectState : 'ONBOARDING',
			Name: validSvc.newProp(validSvc.isText(data.Name) ? data.Name : ''),
			NPI: validSvc.newProp(validSvc.isText(data.NPI) ? data.NPI : ''),
      		CdcType: validSvc.newProp(validSvc.isText(data.CdcType) ? data.CdcType : 'NONE'),

			OpaId: validSvc.newProp(validSvc.isText(data.OpaId) ? data.OpaId : ''),
			OpaType: validSvc.newProp(validSvc.isText(data.OpaType) ? data.OpaType : ''),
			OpaStartDate: validSvc.newPropDateExact(utilSvc.dt.fromServerDateExactPST(data.OpaStartDate), dtOpaMin, dtOpaMax),
			ExternalEntityId: validSvc.newProp(validSvc.isText(data.ExternalEntityId) ? data.ExternalEntityId : ''),
			NpiEnforceProximity: !!data.NpiEnforceProximity ? 'yes' : 'no',
			NpiMaxFullProximity: validSvc.newProp(validSvc.isNumber(data.NpiMaxFullProximity) ? data.NpiMaxFullProximity : 0),
			NpiMaxPartProximity: validSvc.newProp(validSvc.isNumber(data.NpiMaxPartProximity) ? data.NpiMaxPartProximity : 0),
			EnableReferralNPIs: !!data.EnableReferralNPIs ? 'yes' : 'no',
			EnableRefSuspectMatching: !!data.EnableRefSuspectMatching ? 'yes' : 'no',
			ReferralModel: validSvc.newProp(validSvc.isText(data.ReferralModel) ? data.ReferralModel : ''),
			ReferralStartDate: validSvc.newPropDateExact(utilSvc.dt.fromServerDateExactPST(data.ReferralStartDate), dtRefMin, dtRefMax),
			EnableRefAutoFaxing: !!data.EnableRefAutoFaxing ? 'yes' : 'no',
			FeeReferral: validSvc.newProp(validSvc.isNumber(data.FeeReferral) ? parseFloat(data.FeeReferral) : 0.00),
			FeeReferralPercent: validSvc.newProp(validSvc.isNumber(data.FeeReferralPercent) ? parseFloat(data.FeeReferralPercent) : 0.00),	
			FeeReferralPro: validSvc.newProp(validSvc.isNumber(data.FeeReferralPro) ? parseFloat(data.FeeReferralPro) : 0.00),
			FeeReferralProPercent: validSvc.newProp(validSvc.isNumber(data.FeeReferralProPercent) ? parseFloat(data.FeeReferralProPercent) : 0.00),
			ReferralEditDelay: validSvc.newProp(validSvc.isNumber(data.ReferralEditDelay) ? data.ReferralEditDelay : 0),
			ReferralMinimumSavings: validSvc.newProp(validSvc.isNumber(data.ReferralMinimumSavings) ? data.ReferralMinimumSavings : 0),
			ReferralLookbackLimit: validSvc.newProp(validSvc.isNumber(data.ReferralLookbackLimit) ? data.ReferralLookbackLimit : 0),
			FaxNumber: validSvc.newProp(validSvc.isText(data.FaxNumber) ? data.FaxNumber : ""),
			FNameMatch: !!!data.DisableFNSuspect ? 'yes' : 'no',

			ErxValidateGPI: validSvc.newProp(!!data.ErxSkipGPIMatch ? 'no' : 'yes'),
			ErxMatchChars: validSvc.newProp(validSvc.isNumber(data.ErxMatchChars) ? data.ErxMatchChars : 6),
			ErxValidateNPI: validSvc.newProp(!!data.ErxValidateNPI ? 'yes' : 'no'),
			ErxMatchIneligibleOnly : validSvc.newProp(!!data.ErxMatchIneligibleOnly ? 'yes' : 'no'),
			EnableErxLookback: validSvc.newProp(!!data.EnableErxLookback ? 'yes' : 'no'),

			RollupParent: validSvc.isText(data.RollupParent) ? data.RollupParent : '',
			RollupCeList: Array.isArray(data.RollupCeList) ? data.RollupCeList : [],

			OperateAsNonGPOProhibited: !!data.OperateAsNonGPOProhibited ? 'yes' : 'no',
			RequireWACPurchase: !!data.RequireWACPurchase ? 'yes' : 'no',

			DisableVisits: !!data.DisableVisits ? 'yes' : 'no',
			DisableErx: !!data.DisableErx ? 'yes' : 'no',
			DisableAdtProcessing: data.DisableAdtProcessing === false ? 'no' : 'yes', // default to disabled
			EnableReferral : !!data.EnableReferral ? 'yes' : 'no',

			CashCard: !!data.CashCard.Participant ? 'yes' : 'no',
			CashCardAutoReg: !!data.CashCard.AutoRegister ? 'yes' : 'no',
			CashCardExpires: validSvc.newProp(validSvc.isNumber(data.CashCard.MembershipExpirationDays) ? data.CashCard.MembershipExpirationDays : 365),
			CashCardPBM: validSvc.newProp(validSvc.isText(data.CashCard.PBM) ? data.CashCard.PBM : 'NONE'),
			CashCardPlanId: validSvc.newProp(validSvc.isText(data.CashCard.PlanId) ? data.CashCard.PlanId : ''),
			PbmId: validSvc.newProp(validSvc.isText(data.PbmId) ? data.PbmId : ''),
			CashCardLevels: ccLevels,
			CashCardLevelMax: 0, // ctl will load this based on PBM
			CashCardAdtDefault: validSvc.newProp(validSvc.isText(data.CashCard.AdtConfig.Default) ? parseInt(data.CashCard.AdtConfig.Default) : 0),
			CashCardAdtMaps: ccMaps,

			CreatedBy: validSvc.isText(data.CreatedBy) ? data.CreatedBy : '',
			CreatedOn: validSvc.isDate(data.CreatedOn) ? data.CreatedOn : null,
			ModifiedBy: validSvc.isText(data.ModifiedBy) ? data.ModifiedBy : '',
			ModifiedOn: validSvc.isDate(data.CreatedOn) ? data.CreatedOn : null,

			VCentralEnabled: !!data.VCentralEnabled ? 'yes' : 'no',

			// security
			EncryptionPublicKey: validSvc.newProp(validSvc.isText(data.KeyStr) ? data.KeyStr : ''),

			// audit
			EnableAuditPHI: !!data.EnableAuditPHI ? 'yes': 'no',

			// data exports
			DataExportsEnabled: !!dx.Enabled ? 'yes' : 'no',
			DataExportsAccum: !!dx.Enabled && !!dx.Accum ? 'yes' : 'no',
			DataExportsCPInvoices: !!dx.Enabled && !!dx.CPInvoices ? 'yes' : 'no',
			DataExportsMatches: !!dx.Enabled && !!dx.Matches ? 'yes' : 'no',
			DataExportsMatchesPHI: !!dx.Enabled && !!dx.Matches && !!dx.MatchesPHI ? 'yes' : 'no',
			DataExportsSuspects: !!dx.Enabled && !!dx.Suspects ? 'yes' : 'no',
			DataExportsSuspectsPHI: !!dx.Enabled && !!dx.Suspects && !!dx.SuspectsPHI ? 'yes' : 'no',
			DataExportsClaimsBacking: !!dx.Enabled && !!dx.ClaimsBacking ? 'yes' : 'no',
			DataExportsClaimsBackingPHI: !!dx.Enabled && !!dx.ClaimsBacking && !!dx.ClaimsBackingPHI ? 'yes' : 'no',
			DataExportsSMClaimsBacking: !!dx.Enabled && !!dx.SMClaimsBacking ? 'yes' : 'no',
			DataExportsSMClaimsBackingPHI: !!dx.Enabled && !!dx.SMClaimsBacking && !!dx.SMClaimsBackingPHI ? 'yes' : 'no',
			DataExportsSMClaimsUnMatched: !!dx.Enabled && !!dx.SMClaimsUnMatched ? 'yes' : 'no',
			DataExportsSMClaimsUnMatchedPHI: !!dx.Enabled && !!dx.SMClaimsUnMatched && !!dx.SMClaimsUnMatchedPHI ? 'yes' : 'no',
			DataExportsSBAccumDispenses: !!dx.Enabled && !!dx.SBAccumDispenses ? 'yes' : 'no',
			DataExportsSBAccumDispensesPHI: !!dx.Enabled && !!dx.SBAccumDispenses && !!dx.SBAccumDispensesPHI ? 'yes' : 'no',
			DataExportsSBMedical: !!dx.Enabled && !!dx.SBMedical ? 'yes' : 'no',
			DataExportsSBMedicalPHI: !!dx.Enabled && !!dx.SBMedical && !!dx.SBMedicalPHI ? 'yes' : 'no',
			DataExportsAudit: !!dx.Enabled && dx.Audit ? 'yes' : 'no',
			DataExportsSchedule: !!dx.Enabled ? schedulerVM(dx.Schedule) : schedulerVM(),
			DataExportsScheduleErr: '',
			DataExportsLastLongerExport: validSvc.isDate(dx.LongerExport) ? dx.LongerExport : null,
			DataExportsNextExtractIsHistorical: dx.NextExtractIsHistorical,

			// address
			AddressLine1: validSvc.newProp(validSvc.isText(address.Line1) ? address.Line1 : ''),
			AddressLine2: validSvc.newProp(validSvc.isText(address.Line2) ? address.Line2 : ''),
			AddressCity: validSvc.newProp(validSvc.isText(address.City) ? address.City : ''),
			AddressState: validSvc.newProp(validSvc.isText(address.State) ? address.State : 'NONE'),
			AddressZip: validSvc.newProp(validSvc.isText(address.Zip) ? address.Zip : ''),

			AllowDirectReplenish : !!data.AllowDirectReplenish  ? 'yes' : 'no',
			DirectReplenishNewOrders : !!data.DirectReplenishNewOrders  ? 'yes' : 'no',
			DirectReplenishVendor : validSvc.newProp(!!data.AllowDirectReplenish ? data.DirectReplenishVendor : 'NONE'),
			DirectReplenishAccountNum : validSvc.newProp(!!data.AllowDirectReplenish ? data.DirectReplenishAccountNum : ''),
			AllowAltAccum : !!data.AllowAltAccum  ? 'yes' : 'no',
			CreateUniquePoName : !!data.CreateUniquePoName ? 'yes' : 'no',
			MatchByFillDate: !!data.MatchByFillDate ? 'yes' : 'no',
			PatientOnlyMatching: !!data.PatientOnlyMatching ? 'yes' : 'no',
			SkipCareCardCreation: !!data.SkipCareCardCreation ? 'yes' : 'no',

			// Price Validation
			EnableContractPriceValidation : !!pv.Enabled ? 'yes' : 'no',
			PriceContractValidationModel : validSvc.isText(pv.ValidationModel) ? pv.ValidationModel : 'ESSENTIAL',
			PriceContractAutoCloseNegative:  !!pv.AutoCloseNegative ? 'yes' : 'no',
			PriceContractMonthlyFee : validSvc.newProp(validSvc.isNumber(pv.MonthlyFee) ? pv.MonthlyFee : 0),
			PriceContractFlatFee : validSvc.newProp(validSvc.isNumber(pv.FlatFee) ? pv.FlatFee : 0),
			PriceContractVariableFeePercentage : validSvc.newProp(validSvc.isNumber(pv.FeePercentage) ? pv.FeePercentage : 0),
			PriceContractFeeModel : validSvc.isText(pv.FeeModel) ? pv.FeeModel : 'FLAT',
			PriceContractEnableMinFeeAmount : !!pv.EnableMinFeeAmount,
			PriceContractMinFeeAmount : validSvc.newProp(!!pv.MinFeeAmount ? pv.MinFeeAmount : 0),
			PriceContractEnableMaxFeeAmount : !!pv.EnableMaxFeeAmount,
			PriceContractMaxFeeAmount : validSvc.newProp(!!pv.MaxFeeAmount ? pv.MaxFeeAmount : 0)
		};
		return m;

	}


	/**
	 *    EDIT METHODS
	 */

	function createAcct(model) {
		return upsert('admin/ce/create', model);
	}

	function updateAcct(model) {
		return upsert('admin/ce/update', model);
	}

	function schedulerVM(schedule) {
		// build vendor auto order data structure, widget will convert to validation properties later
		schedule = schedule || {};

        return {
			Enabled: 'on', // used for UI widget auto-ordering, always on, no effect on CE schedule
            Type: validSvc.isText(schedule.Type) ? schedule.Type : 'MONTH',
			MonthOption: validSvc.isText(schedule.MonthOption) ? schedule.MonthOption : 'MONTH-DAY',
			DayOfMonth : validSvc.isNumber(schedule.DayOfMonth) ? parseInt(schedule.DayOfMonth) : 1,
			WeekOfMonth : validSvc.isNumber(schedule.WeekOfMonth) ? parseInt(schedule.WeekOfMonth) : 0,
			Occurs : validSvc.isNumber(schedule.Occurs) ? parseInt(schedule.Occurs) : 0,
            Weekdays: Array.isArray(schedule.Days) ? schedule.Days : [],
			fail: ''
        };
    }

	function schedulerAPI(model) {
		return {
			Type: model.Type,
			MonthOption: model.MonthOption,
			DayOfMonth: model.DayOfMonth,
			WeekOfMonth: model.WeekOfMonth,
			Occurs: model.Occurs,
			Days: model.Weekdays
		};
	}

	function upsert(purl, model, fakeOk) {

		_currentPurl = purl;
		_modelPending = model;
		var defer = $q.defer();

		// cash card
		var cashCardOn = model.CashCard == 'yes',
			apiMaps = [];
		for(var i = 0; i < model.CashCardAdtMaps.length; i++) {
			model.CashCardAdtMaps[i].fail = '';
			apiMaps.push({
				From: model.CashCardAdtMaps[i].From,
				To: model.CashCardAdtMaps[i].To.toString()
			});
		}

		if (model.IsHrsaRegistered != 'yes') {
			model.OpaId = {};
			model.OpaType = {};
			model.OpaStartDate = {};
		}

		// data exports
		var dxEnabled = model.DataExportsEnabled == 'yes',
			dxAccum = model.DataExportsAccum == 'yes',
			dxCPInvoices = model.DataExportsCPInvoices == 'yes',
			dxMatches = model.DataExportsMatches == 'yes',
			dxMatchesPHI = model.DataExportsMatchesPHI == 'yes',
			dxSuspects = model.DataExportsSuspects == 'yes',
			dxSuspectsPHI = model.DataExportsSuspectsPHI == 'yes',
			dxClaimsBacking = model.DataExportsClaimsBacking == 'yes',
			dxClaimsBackingPHI = model.DataExportsClaimsBackingPHI == 'yes',
			dxSMClaimsBacking = model.DataExportsSMClaimsBacking == 'yes',
			dxSMClaimsBackingPHI = model.DataExportsSMClaimsBackingPHI == 'yes',
			dxSMClaimsUnMatched = model.DataExportsSMClaimsUnMatched == 'yes',
			dxSMClaimsUnMatchedPHI = model.DataExportsSMClaimsUnMatchedPHI == 'yes',
			dxSBAccumDispenses = model.DataExportsSBAccumDispenses == 'yes',
			dxSBAccumDispensesPHI = model.DataExportsSBAccumDispensesPHI == 'yes',
			dxSBMedical = model.DataExportsSBMedical == 'yes',
			dxSBMedicalPHI = model.DataExportsSBMedicalPHI == 'yes',
			dxAudit = model.DataExportsAudit == 'yes';

		var apiRequest = {
			Entity: {
				Id: model.Id.val,
				IsVerityPrimary: model.IsVerityPrimary == 'yes',
				IsHrsaRegistered: model.IsHrsaRegistered == 'yes',
				OwnUseProgram: model.CeOwnUseProgram == 'yes',
				PreferredAccumGroup: model.CePreferredAccumulationAccount,
				OwnUseProgramStartDate: utilSvc.dt.toServerDateExactPSTNoon(model.OwnUseProgramStartDate.val),
				OwnUsePatientClaims: model.CeOwnUsePatientClaims == 'yes',
				OwnUsePatientClaimsFillOption: model.CeOwnUsePatientClaimsFillOption,
				OwnUsePatientClaimsLastFill: parseInt(model.CeOwnUsePatientClaimsLastFill.val),
				ExcludeControlled : model.IncludeControlled == 'no',
				OwnUseExcludeMedicaid: model.OwnUseExcludeMedicaid == 'yes',
				CoBrand: model.ExpressScriptsCustomer == 'yes' ? 'express' : '', // cobrand v1 is express or nothing
				ExpressScriptsCustomer: model.ExpressScriptsCustomer == 'yes',
				ProductType: model.ProductType,
				CpAcctId: model.CpAcctId.val,
				SplitAcctId : model.SplitAcctId.val,
				PbmId: model.PbmId.val,
				Type: model.Type.val,
				Name: model.Name.val,
				NPI: model.NPI.val,
        		CdcType: model.CdcType.val,

				OpaId: model.OpaId.val,
				OpaType: model.OpaType.val,
				OpaStartDate: utilSvc.dt.toServerDateExactPSTNoon(model.OpaStartDate.val),
				ExternalEntityId: model.ExternalEntityId.val,
				ErxSkipGPIMatch: model.ErxValidateGPI.val == 'no',
				ErxMatchChars: parseInt(model.ErxMatchChars.val),
				ErxValidateNPI: model.ErxValidateNPI.val == 'yes',
				ErxMatchIneligibleOnly: model.ErxMatchIneligibleOnly.val == 'yes',
				EnableErxLookback: model.EnableErxLookback.val == 'yes',

				NpiEnforceProximity: model.NpiEnforceProximity == 'yes',
				EnableReferralNPIs: model.EnableReferralNPIs == 'yes',
				EnableRefSuspectMatching: model.EnableRefSuspectMatching == 'yes',
				ReferralModel: model.ReferralModel.val,
				ReferralStartDate: utilSvc.dt.toServerDateExactPSTNoon(model.ReferralStartDate.val),
				EnableRefAutoFaxing: model.EnableRefAutoFaxing == 'yes',
				FeeReferral: parseFloat(model.FeeReferral.val),
				FeeReferralPercent: parseFloat(model.FeeReferralPercent.val),
				FeeReferralPro: parseFloat(model.FeeReferralPro.val),
				FeeReferralProPercent: parseFloat(model.FeeReferralProPercent.val),
				ReferralEditDelay: parseInt(model.ReferralEditDelay.val),
				ReferralMinimumSavings: parseInt(model.ReferralMinimumSavings.val),
				ReferralLookbackLimit: parseInt(model.ReferralLookbackLimit.val),
				FaxNumber: model.FaxNumber.val,
				DisableFNSuspect: model.FNameMatch == 'no',
				NpiMaxFullProximity: parseInt(model.NpiMaxFullProximity.val),
				NpiMaxPartProximity: parseInt(model.NpiMaxPartProximity.val),
				MatchByFillDate: model.MatchByFillDate == 'yes',
				PatientOnlyMatching: model.PatientOnlyMatching == 'yes',
				SkipCareCardCreation: model.SkipCareCardCreation == 'yes',

				OperateAsNonGPOProhibited: model.OperateAsNonGPOProhibited == 'yes', 
				RequireWACPurchase: model.RequireWACPurchase == 'yes', 
				
				DisableVisits: model.DisableVisits == 'yes',
				DisableErx: model.DisableErx == 'yes',
				DisableAdtProcessing: model.DisableAdtProcessing == 'yes', 
				EnableReferral: model.EnableReferral == 'yes',

				CashCard: {
					Participant: cashCardOn,
					AutoRegister: model.CashCardAutoReg == 'yes',
					MembershipExpirationDays: cashCardOn ? parseInt(model.CashCardExpires.val) : 0,
					PBM: cashCardOn ? model.CashCardPBM.val : '',
					PlanId: cashCardOn ? model.CashCardPlanId.val : '',
					BenefitLevels: cashCardOn ? model.CashCardLevels : [],
					AdtConfig: {
						Default: model.CashCardAdtDefault.val === 0 ? '' : model.CashCardAdtDefault.val.toString(),
						Maps: apiMaps
					}
				},

				// security
				KeyStr : model.EncryptionPublicKey.val,

				// audit
				EnableAuditPHI: model.EnableAuditPHI == 'yes',

				// data exports
				DataExports: {
					Enabled: dxEnabled,
					Accum: dxEnabled && dxAccum,
					CPInvoices: dxEnabled && dxCPInvoices,
					Matches: dxEnabled && dxMatches,
					MatchesPHI: dxEnabled && dxMatches && dxMatchesPHI,
					Suspects: dxEnabled && dxSuspects,
					SuspectsPHI: dxEnabled && dxSuspects && dxSuspectsPHI,
					ClaimsBacking: dxEnabled && dxClaimsBacking,
					ClaimsBackingPHI: dxEnabled && dxClaimsBacking && dxClaimsBackingPHI,
					SMClaimsBacking: dxEnabled && dxSMClaimsBacking,
					SMClaimsBackingPHI: dxEnabled && dxSMClaimsBacking && dxSMClaimsBackingPHI,
					SMClaimsUnMatched: dxEnabled && dxSMClaimsUnMatched,
					SMClaimsUnMatchedPHI: dxEnabled && dxSMClaimsUnMatched && dxSMClaimsUnMatchedPHI,
					SBAccumDispenses: dxEnabled && dxSBAccumDispenses,
					SBAccumDispensesPHI: dxEnabled && dxSBAccumDispenses && dxSBAccumDispensesPHI,
					SBMedical: dxEnabled && dxSBMedical,
					SBMedicalPHI: dxEnabled && dxSBMedical && dxSBMedicalPHI,
					Audit: dxEnabled && dxAudit,
					Schedule: dxEnabled ? schedulerAPI(model.DataExportsSchedule) : {},
					LongerExport: model.DataExportsLastLongerExport,
					NextExtractIsHistorical : model.DataExportsNextExtractIsHistorical,
					HistoricalStartDate: model.DataExportsNextExtractIsHistorical ? utilSvc.dt.toServerDateExactPSTNoon(model.DataExportsHistoricalStartDate) : null,
					HistoricalEndDate: model.DataExportsNextExtractIsHistorical ? utilSvc.dt.toServerDateExactPSTNoon(model.DataExportsHistoricalEndDate) : null,
				},		

				PriceValidationConfig : {	
					Enabled : model.EnableContractPriceValidation == 'yes',
					ValidationModel : model.PriceContractValidationModel,
					AutoCloseNegative: model.PriceContractAutoCloseNegative == 'yes',
					MonthlyFee : model.PriceContractMonthlyFee.val,
					FlatFee : model.PriceContractFlatFee.val,
					FeePercentage : model.PriceContractVariableFeePercentage.val,
					FeeModel : model.PriceContractFeeModel,
					EnableMinFeeAmount : model.PriceContractEnableMinFeeAmount, 	
					MinFeeAmount : model.PriceContractMinFeeAmount.val,
					EnableMaxFeeAmount : model.PriceContractEnableMaxFeeAmount, 	
					MaxFeeAmount : model.PriceContractMaxFeeAmount.val,
				},

				Address: {
					Line1: model.AddressLine1.val,
					Line2: model.AddressLine2.val,
					City: model.AddressCity.val,
					State: model.AddressState.val == 'NONE' ? '' : model.AddressState.val,
					Zip: model.AddressZip.val
				},

				AllowDirectReplenish : model.AllowDirectReplenish == 'yes',
				DirectReplenishNewOrders : model.DirectReplenishNewOrders == 'yes',
				DirectReplenishVendor : model.AllowDirectReplenish == 'yes' ? model.DirectReplenishVendor.val : '',
				DirectReplenishAccountNum : model.AllowDirectReplenish == 'yes' ? model.DirectReplenishAccountNum.val : '',
				AllowAltAccum : model.AllowAltAccum == 'yes',
				CreateUniquePoName : model.CreateUniquePoName == 'yes'
			}
		};
		// call api
		apiService.post(_currentPurl, apiRequest).then(upsertOk, upsertErr);

		function upsertOk(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update affiliations
			refreshUserSilent();

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function upsertErr(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapApiErrorsToModel(r, _modelPending);
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// data exports schedule properties have 1 err flag
				if(fieldName == 'DataExportsSchedule') {
					m.DataExportsScheduleErr = entity.Fields[i].Rule;
					continue;
				}

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);
				if(fieldObj === undefined) {
					throw new Error('ceRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
				}

				// set failed state
				fieldObj.fail = 'yes';
				fieldObj.msg = entity.Fields[i].Rule;

			}

			return m;

		}


		return defer.promise;
	}


	/**
	 *    STATUS CHANGE
	 */

	function statusChange(id, status) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('ceRepo.statusChange, id is missing');
		}

		// set purl
		switch(status) {

			case 'ACTIVE':
				_currentPurl = 'admin/ce/status/active';
				break;
			case 'INACTIVE':
				_currentPurl = 'admin/ce/status/inactive';
				break;
			case 'DELETED':
				_currentPurl = 'admin/ce/status/deleted';
				break;

			default:
				throw new Error('ceRepo.statusChange, status unknown: ' + status);
		}

		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {},
			Entity: {
				Params: {
					Id: id
				}
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okStat, errStat);

		function okStat(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update affiliations
			refreshUserSilent();

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function errStat(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else {
				throw new Error('ceRepo.errStat, unexpected error result');
			}

		}


		return defer.promise;

	}


	/**
	 *    GET MEDPAYOR
	 */

	function getMedPayor(ceid) {

		if(!validSvc.isText(ceid)) {
			throw new Error('ceRepo.getMedPayor, ceid is missing');
		}

		_currentPurl = 'admin/ce/medpayor/get';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid]
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okMedPayor, errMedPayor);

		function okMedPayor(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return med payor model
			var mp = r.data.Entity;
			defer.resolve({
				Items: Array.isArray(mp.Items) ? mp.Items : []
			});

		}

		function errMedPayor(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    MEDICAID PAYORS LIST
	 */

	function getPayors() {

		_currentPurl = 'admin/medpayor/list';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('Id')]
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okGetPayors, errGetPayors);

		function okGetPayors(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// only need MM items, payors is returned with M and MM items
			var mmItems = [];
			for (var i = 0; i < r.data.Entity.length; i++) {
				if(r.data.Entity[i].MedType == 'MM') {
					mmItems.push(r.data.Entity[i]);
				}
			}

			defer.resolve(mmItems);

		}

		function errGetPayors(r) {

			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);

		}

		return defer.promise;

	}


	/**
	 *    OWN USE PAYORS
	 */

	function getOwnUsePayors(ceid) {

		// params
		if(!validSvc.isCE(ceid)) {
			throw new Error('ceRepo.getOwnUsePayors, ceid required');
		}

		_currentPurl = 'admin/ce/ownusepayor/list';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid]
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('Id')]
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okGetOwnPayors, errGetOwnPayors);

		function okGetOwnPayors(r) {
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errGetOwnPayors(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	function saveOwnUsePayor(ceid, model) {

		// params
		if(!validSvc.isText(ceid) || !!!model) {
			throw new Error('ceRepo.saveOwnUsePayor, ceid and model required');
		}

		_currentPurl = 'admin/ce/ownusepayor/save';
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [ceid]
			},
			Entity: {
				Id: model.Id,
				Status: model.Status,
				BIN: model.BIN.val,
				PcnWildCard: model.PcnWildCard == 'yes',
				PCN: model.PcnWildCard == 'no' ? model.PCN.val : '',
				GroupNumberWildCard: model.GroupNumberWildCard == 'yes',
				GroupNumber: model.GroupNumberWildCard == 'no' ? model.GroupNumber.val : '',
				Desc: model.Desc.val
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okOwnPayorSave, errOwnPayorSave);

		function okOwnPayorSave(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function errOwnPayorSave(r) {
			if(!!r) {
				errSvc.error('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 *    SAVE MEDPAYOR
	 */

	function saveMedPayor(ceid, model) {

		if(!validSvc.isText(ceid) || !!!model) {
			throw new Error('ceRepo.saveMedPayor, ceid and medpayor required');
		}

		_currentPurl = 'admin/ce/medpayor/save';
		_modelPending = model;

		var defer = $q.defer();
		var item = {},
			saveItems = [],
			ndcList = [],
			bin = '',
			pcn = '',
			grpnum = '',
			desc = '';

		// parse items for api save
		for(var i = 0; i < model.Items.length; i++) {
			item = model.Items[i];

			if(item.MedType == 'U' || item.MedType == 'O') {
				item.hasError = false;
				item.hasErrorTxt = '';
				bin = item.BINTxt;
				pcn = item.PCNTxt;
				grpnum = item.GroupNumberTxt;
				desc = item.NameTxt;
				ndcList = [];

				if(item.MedType == 'U') {
					bin = item.BIN.val;
					pcn = item.PCN.val;
					grpnum = item.GroupNumber.val;
					desc = item.Name.val;

					for(var ii = 0; ii < item.NdcList.length; ii++) {
						ndcList.push(item.NdcList[ii].val);
					}
				}

				saveItems.push({
					Id: item.Id,
					MedType: item.MedType,
					BIN: bin,
					PCN: pcn,
					GroupNumber: grpnum,
					Name: desc,
					NDCList: ndcList
				});
			}
		}

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid]
			},
			Entity: {
				Items: saveItems
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okSaveMedPayor, errSaveMedPayor);

		function okSaveMedPayor(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function errSaveMedPayor(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 422) {
				defer.reject({
					status: 422,
					model: mapApiMedPayorErrorsToModel(r, _modelPending)
				});
			}
			else {
				errSvc.error('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}

		}

		function mapApiMedPayorErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity,
				items = m.Items;

			// field errors
			var rowId = '',
				ndcErr = false,
				fieldName = '',
				foundProp = false;

			for(var i = 0; i < entity.Fields.length; i++) {

				foundProp = false;
				ndcErr = false;
				rowId = entity.Fields[i].Name;

				// ndc errors (they are an array property of MedType = 'U' objects)
				if(rowId.substr(0,5) == 'UNDC_') {
					var splitId = rowId.split('_');
					if(splitId.length < 3) {
						alert('Custom Payor 422 Map, unrecognized 422 format: ' + rowId);
						continue;
					}
					rowId = splitId[1];
					fieldName = splitId[2];
					ndcErr = true;
				}

				// find the medpayor object by id
				for(var ii = 0; ii < items.length; ii++) {

					if(items[ii].Id == rowId) {

						if(ndcErr) {

							// find the failed NDC
							for(var iii = 0; iii < items[ii].NdcList.length; iii++) {
								if(items[ii].NdcList[iii].val == fieldName) {
									items[ii].NdcList[iii].fail = 'yes';
									items[ii].NdcList[iii].msg = entity.Fields[i].Rule;

									items[ii].hasError = true;
									items[ii].hasErrorTxt = 'NDC list item is invalid';
									foundProp = true;
								}
							}
						}
						else {

							// mark the payor which failed, not the property
							items[ii].hasError = true;
							items[ii].hasErrorTxt = entity.Fields[i].Rule;
							foundProp = true;
						}

						break;
					}

				}

				// couldn't find a property matching this 422 name
				if(!foundProp) {
					alert('ceRepo.mapMedPayorApiErrorsToModel, cannot find Id for 422 field: ' + entity.Fields[i].Name);
				}

			}

			return m;

		}

		return defer.promise;
	}


	/**
	 *    ADT
	 */

	function adtModelVM(data) {

		var adt = data || {},
			i = 0;

		// maps, add validation props
		var adtMaps = Array.isArray(adt.Mappings) ? adt.Mappings : [];
		for(i = 0; i < adtMaps.length; i++) {
			adtMaps[i].fail = '';
			adtMaps[i].msg = '';
		}

		// sanitizer, add validation props
		adt.Sanitizer = adt.Sanitizer || {};
		var sanList = Array.isArray(adt.Sanitizer.Replace) ? adt.Sanitizer.Replace : [];
		for(i = 0; i < sanList.length; i++) {
			sanList[i].fail = '';
			sanList[i].msg = '';
		}

		// patient status
		adt.Status = adt.Status || {};

		// patient visits
		adt.Visits = adt.Visits || {};

		return {
			Maps: adtMaps,
			Sani: {
				Delimiter: validSvc.newProp(validSvc.isText(adt.Sanitizer.Delimiter) ? adt.Sanitizer.Delimiter : 'MSH|'),
				Replace: sanList
			},
			Status: {
				Enabled: !!adt.Status.Enabled ? 'yes' : 'no',
				ValidTrans: !!adt.Status.ValidateSplitTrans ? 'yes' : 'no',
				Converts: Array.isArray(adt.Status.Maps) ? adt.Status.Maps : []
			},
			Visit: {
				Enabled: !!adt.Visits.Enabled ? 'yes' : 'no'
			}
		};

	}

	function getAdtConfig(ceid) {

		if(!validSvc.isText(ceid)) {
			throw new Error('ce.repo.getAdtConfig, ceid is missing');
		}

		_currentPurl = 'admin/ce/adt/get';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid]
			}
		};

		apiService.post(_currentPurl, apiRequest).then(getAdtOk, getAdtErr);

		function getAdtOk(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return model
			defer.resolve(adtModelVM(r.data.Entity));

		}

		function getAdtErr(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function saveAdtConfig(ceid, maps, sani, stat, visit) {

		if(!validSvc.isText(ceid) || !!!sani || !!!stat || !!!visit) {
			throw new Error('ceRepo.saveAdtConfig, ceid, sani, stat, visit required');
		}

		var defer = $q.defer();
		_currentPurl = 'admin/ce/adt/save';

		// reset validation
		var i = 0;
		for(i = 0; i < maps.length; i++) {
			maps[i].fail = '';
		}
		for(i = 0; i < sani.Replace.length; i++) {
			sani.Replace[i].fail = '';
		}
		for(i = 0; i < stat.Converts.length; i++) {
			stat.Converts[i].fail = '';
		}

		var apiRequest = {
			Context: {
				CEID: [ceid]
			},
			Entity: {
				Mappings: maps,
				Sanitizer: {
					Delimiter: sani.Delimiter.val,
					Replace: sani.Replace
				},
				Status: {
					Enabled: stat.Enabled == 'yes',
					ValidateSplitTrans: stat.ValidTrans == 'yes',
					Maps: stat.Converts
				},
				Visits: {
					Enabled: visit.Enabled == 'yes'
				}
			}
		};

		_modelPending = {
			Maps: maps,
			Sani: sani
		};

		apiService.post(_currentPurl, apiRequest).then(okSaveAdt, errSaveAdt);

		function okSaveAdt(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve({});
		}

		function errSaveAdt(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!!r && r.status === 422) {
				defer.reject({
					status: 422,
					model: mapAdtErrorsToModel(r, _modelPending)
				});
			}
			else {
				errSvc.error('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}

		}

		function mapAdtErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var i = 0,
				ii = 0,
				foundProp = false;

			// mapping errors
			var errMaps = Array.isArray(r.Mappings) ? r.Mappings : [],
				errMap = {},
				maps = m.Maps,
				map = {};
			for(i = 0; i < errMaps.length; i++) {
				errMap = errMaps[i];
				foundProp = false;

				// find in model maps
				for(ii = 0; ii < maps.length; ii++) {
					map = maps[ii];
					if(errMap.Feature == map.Feature && errMap.EventType == map.EventType && errMap.FieldName == map.FieldName) {
						foundProp = true;
						map[errMap.ErrorField].fail = 'yes';
						map[errMap.ErrorField].msg = errMap.Rule;
					}
				}

				// couldn't find a property matching this 422 name
				if(!foundProp) {
					alert('ceRepo.mapAdtErrorsToModel, cannot find mapping for 422 record: ' + errMap.toString());
				}
			}

			// sani errors
			r.Sanitizer = r.Sanitizer || {};
			var errSaniReps = Array.isArray(r.Sanitizer.Replace) ? r.Sanitizer.Replace : [],
				errSaniRep = {},
				saniReps = m.Sani,
				saniRep = {};
			for(i = 0; i < errSaniReps.length; i++) {
				errSaniRep = errSaniReps[i];
				foundProp = false;

				// find in model reps
				for(ii = 0; ii < saniReps.length; ii++) {
					saniRep = saniReps[ii];
					if(saniRep.From == errSaniRep.FieldName) {
						foundProp = true;
						saniRep.fail = 'yes';
						saniRep.msg = errSaniRep.Rule;
					}
				}

				// couldn't find a property matching this 422 name
				if(!foundProp) {
					alert('ceRepo.mapAdtErrorsToModel, cannot find mapping for 422 record: ' + errSaniRep.FieldName.toString());
				}
			}

			return m;

		}

		return defer.promise;
	}

}
 
claimFedListCtl.$inject = ['$window', '$state', '$rootScope', '$scope', '$timeout', 'claimfedRepo', 'sessionRepo', 'utilSvc', 'validSvc', 'msgSvc'];angular
.module('espui.admin.claimfed')
.controller('ClaimFedListCtl', claimFedListCtl);

/* @ngInject */
function claimFedListCtl($window, $state, $rootScope, $scope, $timeout, claimfedRepo, sessionRepo, utilSvc, validSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _pagingEventListener = null,
		_returnVisit = false;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addMultiselect(vm);
	utilSvc.ctl.addFlexTop(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.context = {};

	// edit
	vm.flyout = {};
	vm.edit = {};
	vm.editItem = editItem;
	vm.editOff = editOff;
	vm.editSubmit = editSubmit;
	vm.editDestinationType = editDestinationType;

	// table
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;

	// droplists
	vm.ProgAdminDroplist = [];

	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		vm.init = true;
		vm.context = initContext($scope);
		initDroplists();
		vm.edit = editVM();

		vm.flt = initFilter();
		getList();

	}

	function getAffs(showInactive) {
		var affStatus = ['ONBOARDING', 'ACTIVE'];
		if(!!showInactive) {
			affStatus.push('INACTIVE');
		}
		return utilSvc.aff.findStatus($scope.User.AffList, affStatus);
	}

	function initContext(scp) {
		return {
			isVeritySA: scp.User.Type == 'VERITYSA',
			canEdit: false
		};
	}

	function initFilter(ctx) {
        
		var flt = vm.initFilters({
			Exact: {
				DestinationType: ''
			},
		});

		var vs = sessionRepo.get('vs-admin-claimfed-list');
        if(!!vs) {
			_returnVisit = true;
            flt = vm.resetFilters(vs.flt);
        }

		return flt;
	}

	function initDroplists() {
		var affs = getAffs(false);

		// ProgAdmin
		vm.ProgAdminDroplist = utilSvc.ng.droplist(utilSvc.aff.progAdminList(affs), '', '', [{label:'Choose a Program Admin', value:'NONE'}]);
	}

	/**
	 *    VIEW MODELS
	 */

	function listVM(dataItems, tooMany) {
		dataItems = Array.isArray(dataItems) ? dataItems : [];
		var uniqueId = 0;
		
		dataItems.forEach(function(item){
			uniqueId++;
			item.uniqueId = 'm' + uniqueId.toString();
		});

		return {
			show: false,
			Items: [],
			DataItems: dataItems,
			TooMany: tooMany
		};
	}

	function multipleLabel(noneTxt, len, valText) {
		if(len < 1) {
			return noneTxt;
		}
		else if(len < 6) {
			return valText;
		}
		else {
			return 'MULTIPLE (' + len + ')';
		}
	}

	/**
	 *    FILTER
	 */

	function filterChange(immediate) {
		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					saveViewState(vm.flt, vm.search);
				}
			},1000);

		}, delayTime);
	}


	/**
	 *    GET LIST
	 */

	function getList() {
		if(vm.isWaiting) {
			return;
		}
		
		if(!vm.init) {
			vm.action = '';
			vm.tbl = {};
			vm.flt = vm.resetFilters(vm.flt);
		}
		vm.init = false;
		_returnVisit = false;

		toggleWait(true);
		claimfedRepo.getList().then(okList, errList);

		function okList(r) {
			toggleWait();
			saveViewState(vm.flt);

			vm.tbl = listVM(r, false);
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			vm.tbl.show = true;
			vm.flt.Ready = true;
			vm.action = 'LIST';
		}

		function errList(r) {
			toggleWait();
			if(!!r) {
				// unknown
				errSvc.warn('unknown error getting data', 'admin.claimfed.getList', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	// FLYOUT
	function flyToggle(isOn) {
		vm.flyout.show = !!isOn;
	}

	function editItem(item) {
		vm.edit = editVM(item);
		if (!!item) {
			vm.edit.title = 'Edit Mapping for ' + item.PharmacyName;
			vm.edit.action = 'UPDATE';
		} else {
			vm.edit.title = 'New Mapping';
			vm.edit.action = 'ADD';
		}

		// default destination based on type
		editDestinationType();	
		
		// show flyout if not displayed yet
		if(!vm.flyout.show) {
			flyToggle(true);
		}
	}

	// EDITING
	function editVM(item) {
		return claimfedRepo.modelVM(item);
	}

	function editOff() {
		vm.edit = editVM();
		flyToggle();
	}

	function editValid(m) {
		m.PharmacyName = validText(m.PharmacyName, 2, 100);

		m.PharmacyNPI.fail = 'no';
		if (!validSvc.isInteger(parseInt(m.PharmacyNPI.val))) {
			m.PharmacyNPI.fail = 'yes';
			m.PharmacyNPI.msg = 'must be a 10 - 15 digit number';
		} else {
			m.PharmacyNPI = validText(m.PharmacyNPI, 10, 15);
		}

		m.Destination.fail = 'no';
		if (m.DestinationType == 'CE') {
			m.Destination = validText(m.Destination, 2, 100);
		}

		m.EncryptionPublicKey.fail = 'no';

		return m.PharmacyName.fail != 'yes' &&
			m.PharmacyNPI.fail != 'yes' && 
			m.Destination.fail != 'yes';
	}

	function editDestinationType(changeType) {
		if (!!changeType) {
			vm.edit.Destination.val = '';
		}

		if (vm.edit.DestinationType == 'TPA') {
			vm.edit.Destination = utilSvc.ng.droplistAutoselect(vm.ProgAdminDroplist, vm.edit.Destination.val);
		}
	}

	function editSubmit(action) {
		if(vm.isWaiting) {
			return;
		}

		if(action != 'REMOVE' && !editValid(vm.edit)) {
			msgSvc.ok('Cannot Save', 'Check properties');
			return;
		}
		
		if (!!!action) {
			action = vm.edit.action;
		}

		confirmEdit(action, {result:'YES'});
	}

	function confirmEdit(action, r) {
		if(!!!r || r.result != 'YES') {
			return;
		}

		toggleWait(true);
		claimfedRepo.save(action, vm.edit).then(okEdit, errEdit);

		function okEdit(r) {
			toggleWait();

			msgSvc.ok('Claim Federation Saved');
			editOff();
			getList();
		}

		function errEdit(r) {
			toggleWait();

			if(!!!r) {
				return;
			}
			else if(r.status == 409) {
				msgSvc.ok('Cannot Save', 'Please check your settings and try again');
				editOff();
				getList();
			}
			else if(r.status == 422) {
				vm.edit.model = r.model;
				msgSvc.ok('Cannot Save', 'Please check properties');
			}
		}
	}
	
	//	HELPERS
	function saveViewState(flt) {
		sessionRepo.set('vs-admin-claimfed-list', {
			flt: flt
		});
	}

	function toggleWait(isOn) {
		vm.isWaiting = !!isOn;
		msgSvc.wait(!!isOn);
	}

	function isALL(vals) {
		return vals.length == 1 && vals[0] == 'ALL';
	}

	/**
	 *    HELPERS
	 */

	function validText(prop, min, max) {

		// required
		if(!validSvc.isText(prop.val)) {
			prop.fail = 'yes';
			prop.msg = 'required';
			return prop;
		}

		// min
		if(prop.val.length < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum ' + min.toString() + ' characters';
			return prop;
		}

		// max
		if(prop.val.length > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum ' + max.toString() + ' characters';
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;
	}

}
 
claimfedRepo.$inject = ['$rootScope', '$q', 'apiService', 'sessionRepo', 'errSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
.module('espui.admin.claimfed')
.factory('claimfedRepo', claimfedRepo);


/* @ngInject */
function claimfedRepo($rootScope, $q, apiService, sessionRepo, errSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _currentPurl = '',
		_modelPending = null,
		_apiPaging = vmSvc.api.paging();

	// service definition
	var service = {
		modelVM: modelVM,

		// read
		getList: getList,

		// write
		save: save
	};

	return service;


	/**
	 *    MODEL
	 */

	function modelVM(data) {
		data = data || {};

		var m = {
			Id: validSvc.isText(data.Id) ? data.Id : '',
			PharmacyName: validSvc.newProp(validSvc.isText(data.PharmacyName) ? data.PharmacyName : ''),
            PharmacyNPI: validSvc.newProp(validSvc.isText(data.PharmacyNPI) ? data.PharmacyNPI : ''),
			DestinationType: !!data.DestinationType ? data.DestinationType : 'CE',
            Destination: validSvc.newProp(validSvc.isText(data.Destination) ? data.Destination : ''),
			EncryptionPublicKey: validSvc.newProp(validSvc.isText(data.EncryptionPublicKey) ? data.EncryptionPublicKey : ''),
		};

		return m;
	}


	/**
	 *    GET LIST
	 */

	function getList() {
		_currentPurl = 'admin/claimfed/list';
		var defer = $q.defer();

		var request = {
			Params:{
				Status: '' // get all status
			}
		};

		apiService.post(_currentPurl, request).then(okGetList, errGetList);

		function okGetList(r) {
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errGetList(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 * 	  UPDATE
	 */

	function save(action, m) {

		// simple params check to catch UI issues
		if(!!!m) {
			throw new Error('claimfedRepo.save, model required');
		}

		var defer = $q.defer();

		_modelPending = m;

		var apiRequest = {
			Params: {
				PharmacyName: m.PharmacyName.val,
				PharmacyNPI: m.PharmacyNPI.val,
				DestinationType: m.DestinationType,
				Destination: m.Destination.val,
				EncryptionPublicKey: m.EncryptionPublicKey.val,
			}
		};

		if (action == 'ADD') {
			_currentPurl = 'admin/claimfed/add';
		} else if (action == 'UPDATE') {
			_currentPurl = 'admin/claimfed/update';
			apiRequest.Params.Id = m.Id;
		} else if (action == 'REMOVE') {
			_currentPurl = 'admin/claimfed/remove';
			apiRequest.Params.Id = m.Id;
		}

		apiService.post(_currentPurl, apiRequest).then(okSave, errSave);

		function okSave(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
			_modelPending = null;
		}

		function errSave(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapApiErrorsToModel(r, _modelPending);
				defer.reject(r);
			}
			else {
				_modelPending = null;
				errSvc.error('Api request unexpected error', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			_modelPending = null;
		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: true,
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldObj,
				fieldName = '';

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);

				// property not found on model
				if(fieldObj === undefined) {
					throw new Error('claimfedRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName);
				}

				// set failed state
				fieldObj.fail = 'yes';
				fieldObj.msg = entity.Fields[i].Rule;
			}

			return m;
		}


		return defer.promise;

	}
}
 
datamgrRepo.$inject = ['$rootScope', '$q', 'apiService', 'errSvc', 'utilSvc', 'validSvc'];
angular
.module('espui.admin.ce')
.factory('datamgrRepo', datamgrRepo);


/* @ngInject */
function datamgrRepo($rootScope, $q, apiService, errSvc, utilSvc, validSvc) {

	// private
	var _currentPurl = '',
		_modelPending = null;

	// service definition
	var service = {
		queryVM: queryVM,
		purge: purge
	};

	return service;


	/**
	 *    QUERY VM
	 */

	function queryVM(refresh) {

		// optional affiliation refresh before return

		var defer = $q.defer();
		if(!!refresh) {
			apiService.refreshUser().then(okUserRefresh, errUserRefresh);
		}
		else {
			okUserRefresh();
		}

		function okUserRefresh(r) {
			var usr = $rootScope.User;
			defer.resolve({
				PurgeType: validSvc.newProp('NONE'),
				PurgeEntity: validSvc.newProp(),
				CE: validSvc.newProp(validSvc.isCE(usr.CE) ? usr.CE : 'NONE'),
				RX: validSvc.newProp(validSvc.isRX(usr.RX) ? usr.RX : 'NONE'),
				RxShortName: ''
			});
		}

		function errUserRefresh(r) {
			if(r !== null) {
				errSvc.warn('Affiliations request failed', 'datamgrRepo.contextRefreshVM', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    PURGE
	 */

	function purge(ptype, ceid, rxid) {

		// params
		if(!validSvc.isText(ptype)) {
			throw new Error('datamgrRepo.purge, ptype required');
		}

		var _currentPurl = 'admin/datamgr/purge/';

		switch(ptype) {

			case 'NPI':
				_currentPurl += 'npi';
				ceid = [ceid];
				rxid = [];
				break;

			case 'DISPENSES':
				_currentPurl += 'disp';
				ceid = [];
				rxid = [rxid];
				break;

			case 'ACCUM':
			case 'TRANSFORM':
				_currentPurl += ptype.toLowerCase();
				ceid = [ceid];
				rxid = [rxid];
				break;

			case 'VISITS':
				_currentPurl += ptype.toLowerCase();
				ceid = [ceid];
				rxid = [];
				break;

			case 'MATCHEDDISPENSES':
				_currentPurl += 'match';
				ceid = [ceid];
				rxid = [rxid];
				break;

			default:
				throw new Error('datamgrRepo.purge, unknown: ' + ptype);
		}

		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: ceid,
				RXID: rxid
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okPurge, errPurge);

		function okPurge(r) {

			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errPurge(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status === 422 || r.status === 409) {
				var rt = r.data.Entity.ROOT;
				r.msg = rt.length > 0 ? rt.join(', ') : 'Unknown Error';
				defer.reject(r);
			}
			else {
				throw new Error('datamgrRepo.errStat, unexpected error result');
			}

		}

		return defer.promise;

	}	
}
 
datamgrCtl.$inject = ['$state', '$rootScope', '$scope', 'ceRepo', 'rxRepo', 'datamgrRepo', 'sessionRepo', 'msgSvc', 'utilSvc', 'validSvc', 'errSvc'];
angular
.module('espui.admin.datamgr')
.controller('DatamgrCtl', datamgrCtl);


/* @ngInject */
function datamgrCtl($state, $rootScope, $scope, ceRepo, rxRepo, datamgrRepo, sessionRepo, msgSvc, utilSvc, validSvc, errSvc) {

	/*jshint validthis: true */
	var vm = this;
	var	_pendingPurge = {},
		_ceList = [],
		_rxList = [];

	// inherit
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.initTasks = [];
	vm.isWaiting = false;
	vm.uType = "";

	// droplists
	vm.PurgeTypeDroplist = [];
	vm.CeDroplist = [];
	vm.RxDroplist = [];

	// query
	vm.query = {};
	vm.queryChangePurgeType = queryChangePurgeType;
	vm.queryChangeCE = queryChangeCE;
	vm.queryChangeRX = queryChangeRX;

	// purge models
	vm.purge = [];
	vm.purgeHistory = [];

	// methods
	vm.submitPurge = submitPurge;
	vm.navToFeedDetail = navToFeedDetail;

	// popup
	vm.popup = {};
	vm.closePopup = closePopup;
	vm.openPopup = openPopup;


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		vm.init = true;
		vm.uType = $scope.User.Type;

		vm.PurgeTypeDroplist = initPurgeTypes($scope);

		// user has at least 1 purge type, build task list based on types
		if(vm.PurgeTypeDroplist.length > 1) {

			// NPI requires ce list
			var rx = utilSvc.ng.droplistAutoselect(vm.PurgeTypeDroplist, 'NPI');
			if(rx.val == 'NPI') {
				vm.initTasks.push('celist');
			}

			// dispenses requires rx list
			rx = utilSvc.ng.droplistAutoselect(vm.PurgeTypeDroplist, 'DISPENSES');
			if(rx.val == 'DISPENSES') {
				vm.initTasks.push('rxlist');
			}

			vm.initTasks.push('query');

			// run ASYNC init tasks
			initTaskManager();

		}

	}

	function initTaskManager() {

		// ASYNC task runner

		if(vm.initTasks.length > 0) {

			var nextTask = vm.initTasks[0];
			vm.initTasks.splice(0, 1);

			switch(nextTask) {
				case 'celist':
					initCeList();
					break;
				case 'rxlist':
					initRxList();
					break;
				case 'query':
					// ASYNC, setup query after affiliation refresh
					initQueryAndViewState();
					break;
				default:
					throw new Error('datamgrCtl.initTaskManager, unknown task name: ' + nextTask);
			}
		}

	}

	function getAffs(ptype) {

		var affs = utilSvc.aff.findStatus($scope.User.AffList, ['ONBOARDING', 'INACTIVE']);

		switch(ptype) {

			// NPI uses ce list, not affs
			// DISPENSES uses rx list, not affs

			case 'ACCUM':
			case 'TRANSFORM':
				return utilSvc.aff.findRxModel(affs, ['SPLIT']);

			case 'VISITS':
			case 'MATCHEDDISPENSES':
				return utilSvc.aff.findRxModel(affs, ['CP', 'SPLITMATCH']);

			default:
				throw new Error('datamgr.getAffs, unknown purge type: ' + ptype);
		}

		return affs;

	}


	/**
	 *    VIEW MODELS
	 */

	function affPurgeVM(aff) {
		return {
			id: '',
			started: null,
			CEID: aff.CEID,
			RXID: aff.RXID,
			RxShortName: aff.RxShortName,
			RxBizModel: aff.RxBizModel,
			AffState: aff.AffState,
			canPurge: false
		};
	}

	function affPurgeListVM(ptype, affs, hist) {

		var result = [],
			aff = {},
			isSplit = false,
			isCpMatch = false;

		switch(ptype) {

			// NPI uses ce list, not affs
			// DISPENSES uses rx list, not affs

			case 'ACCUM':
			case 'TRANSFORM':
				isSplit = true;
				break;

			case 'VISITS':
			case 'MATCHEDDISPENSES':
				isCpMatch = true;
				break;

			default:
				throw new Error('datamgr.getAffs, unknown purge type: ' + ptype);
		}

		for(var i = 0; i < affs.length; i++) {
			aff = affPurgeVM(affs[i]);

			if(ptype == 'VISITS' && (aff.RxBizModel != 'CP' && aff.RxBizModel != 'SPLITMATCH')) {
				// VISITS: ignore affiliations with other business models
			}
			else {
				if(aff.AffState == 'ONBOARDING' || aff.AffState == 'INACTIVE') {
					if(isSplit && aff.RxBizModel == 'SPLIT') {
						aff.canPurge = true;
					}
					else if(isCpMatch && (aff.RxBizModel == 'CP' || aff.RxBizModel == 'SPLITMATCH')) {
						aff.canPurge = true;
					}
				}

				aff = addPurgeHistory(ptype, aff, hist);
				result.push(aff);
			}

		}

		return result;

	}

	function initPurgeTypes(scp) {

		var result = [{label:'Choose a Purge Type', value:'NONE'}];

		if(!!scp.debug) {
			if(utilSvc.user.hasFeature(scp, 'admin.datamgr.purge.disp')) {
				result.push({label:purgeTitle('DISPENSES'), value: 'DISPENSES'});
			}
			if(utilSvc.user.hasFeature(scp, 'admin.datamgr.purge.match')) {
				result.push({label:purgeTitle('MATCHEDDISPENSES'), value: 'MATCHEDDISPENSES'});
			}
			if(utilSvc.user.hasFeature(scp, 'admin.datamgr.purge.npi')) {
				result.push({label:purgeTitle('NPI'), value: 'NPI'});
			}
			if(utilSvc.user.hasFeature(scp, 'admin.datamgr.purge.visits')) {
				result.push({label:purgeTitle('VISITS'), value: 'VISITS'});
			}
			if(utilSvc.user.hasFeature(scp, 'admin.datamgr.purge.accum')) {
				result.push({label:purgeTitle('ACCUM'), value: 'ACCUM'});
			}
			if(utilSvc.user.hasFeature(scp, 'admin.datamgr.purge.transform')) {
				result.push({label:purgeTitle('TRANSFORM'), value: 'TRANSFORM'});
			}
		}
		else {
			if(utilSvc.user.hasFeature(scp, 'admin.datamgr.purge.npi')) {
				result.push({label:purgeTitle('NPI'), value: 'NPI'});
			}
		}

		return result;

	}

	function initRxList() {

		// DISPENSES requires pharmacy to be ONBOARDING or INACTIVE

		_rxList = [];
		rxRepo.getList().then(okRxList, errRxList);

		function okRxList(r) {

			r = Array.isArray(r.data) ? r.data : [];

			var rxItem = {},
				ds = '';
			for(var i = 0; i < r.length; i++) {
				rxItem = r[i];
				if(rxItem.ObjectState == 'ONBOARDING' || rxItem.ObjectState == 'INACTIVE') {
					ds = validSvc.isText(rxItem.DataSwitch) ? rxItem.DataSwitch.toUpperCase() : 'NONE';
					if(ds != 'RELAY' && ds != 'EMDEON' && ds != 'NONE') {
						_rxList.push({label:rxItem.ShortName, value:rxItem.Id});
					}
				}
			}
			_rxList = utilSvc.array.sortASC(_rxList, 'label');

			initTaskManager();
		}

		function errRxList(r) {
			if(!!r) {
				errSvc.warn('unknown error getting data', 'datamgrCtl.initRxList', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function initCeList() {

		// NPI requires CE has ProgAdmin VERITY

		_ceList = [];
		ceRepo.getList().then(okCeList, errCeList);

		function okCeList(r) {
			r = Array.isArray(r.data) ? r.data : [];

			var ceitem = {};
			for(var i = 0; i < r.length; i++) {
				ceitem = r[i];
				if(ceitem.IsVerityPrimary) {
					var display = $rootScope.User.AdminPrefs.ListDisplay == 'USE_DISPLAY' ? ceitem.Name : ceitem.Id;
					display = display ? display : ceitem.Id;
					_ceList.push({label:display, value:ceitem.Id});
				}
			}
			_ceList = utilSvc.array.sortASC(_ceList, 'label');

			initTaskManager();
		}

		function errCeList(r) {
			if(!!r) {
				errSvc.warn('unknown error getting data', 'datamgrCtl.initCeList', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function initQueryAndViewState() {

		vm.query = datamgrRepo.queryVM(true).then(okQuery, errQuery);

		function okQuery(r) {
			vm.query = r;

			// get veiwstate
			var vs = sessionRepo.get('vs-admin-datamgr');
			if(!!vs) {
				vm.query.PurgeType.val = vs.query.PurgeType;
				vm.query.CE.val = vs.query.CE;
				vm.query.RX.val = vs.query.RX;

				if(Array.isArray(vs.history)) {
					vm.purgeHistory = vs.history;
				}
			}

			queryChangePurgeType();
			vm.init = false;
		}

		function errQuery(r) {
			if(!!r) {
				errSvc.error('Unexpected error on query init', 'datamgrCtl.queryVM', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    QUERY CHANGE
	 */

	function queryChange() {

		if(!vm.init) {
			vm.action = '';
			vm.popup = {};

			vm.purge = [];
			_pendingPurge = {};
			if(!!vm.query) {
				vm.query.PurgeEntity = validSvc.newProp('');
			}
		}
	}

	function queryChangePurgeType() {

		if(vm.isWaiting) {
			return;
		}

		queryChange();

		var ptype = vm.query.PurgeType.val;
		vm.query.PurgeType.fail = validSvc.isText(ptype) && ptype != 'NONE' ? 'no' : 'yes';
		if(vm.query.PurgeType.fail == 'yes') {
			vm.CeDroplist = utilSvc.ng.droplistNONE();
			vm.RxDroplist = utilSvc.ng.droplistNONE();
			return;
		}

		var statusText = 'exist with status ONBOARDING / INACTIVE',
			bizModelCpMatch = 'Business Model CP or SPLITMATCH',
			bizModelSplit = 'Business Model SPLIT';

		switch(ptype) {

			case 'NPI':
				// uses ce list only
				vm.RxDroplist = utilSvc.ng.droplistNONE();
				vm.query.RX = validSvc.newProp('NONE');
				vm.CeDroplist = utilSvc.aff.ceDroplist([]);

				if(_ceList.length < 1) {
					// no ce available
					vm.query.CE = validSvc.newProp('NONE');
					vm.query.CE.fail = 'yes';
					vm.query.PurgeEntity = {
						val: '',
						fail: 'yes',
						msg: 'No Facilities exist with Program Admin of VERITY'
					};
				}
				else {
					vm.CeDroplist = vm.CeDroplist.concat(_ceList);
					vm.query.CE = utilSvc.ng.droplistAutoselect(vm.CeDroplist, vm.query.CE.val);
					queryChangeCE();
				}
				break;

			case 'DISPENSES':
				// uses rx list only
				vm.CeDroplist = utilSvc.ng.droplistNONE();
				vm.query.CE = validSvc.newProp('NONE');
				vm.RxDroplist = utilSvc.aff.rxDroplist([]);

				if(_rxList.length < 1) {
					// no rx available
					vm.query.RX = validSvc.newProp('NONE');
					vm.query.RX.fail = 'yes';
					vm.query.PurgeEntity = {
						val: '',
						fail: 'yes',
						msg: 'No Pharmacies ' + statusText + ' without data switch of: Emdeon, Relay or Empty'
					};
				}
				else {
					vm.RxDroplist = vm.RxDroplist.concat(_rxList);
					vm.query.RX = utilSvc.ng.droplistAutoselect(vm.RxDroplist, vm.query.RX.val);
					queryChangeRX();
				}
				break;

			case 'VISITS':
				// ce is primary
				vm.RxDroplist = utilSvc.ng.droplistNONE();
				vm.query.RX = validSvc.newProp('NONE');
				vm.CeDroplist = utilSvc.aff.ceDroplist(getAffs(ptype));

				if(vm.CeDroplist.length < 2) {
					// no ce available
					vm.query.CE = validSvc.newProp('NONE');
					vm.query.CE.fail = 'yes';
					vm.query.PurgeEntity = {
						val: '',
						fail: 'yes',
						msg: 'No Affiliations ' + statusText + ' with ' + bizModelCpMatch
					};
				}
				else {
					vm.query.CE = utilSvc.ng.droplistAutoselect(vm.CeDroplist, vm.query.CE.val);
					queryChangeCE();
				}
				break;

			case 'MATCHEDDISPENSES':
			case 'ACCUM':
			case 'TRANSFORM':
				// rx is primary
				vm.CeDroplist = utilSvc.ng.droplistNONE();
				vm.query.CE = validSvc.newProp('NONE');
				vm.RxDroplist = utilSvc.aff.rxDroplist(getAffs(ptype));

				if(vm.RxDroplist.length < 2) {
					// no rx available
					vm.query.RX = validSvc.newProp('NONE');
					vm.query.RX.fail = 'yes';
					vm.query.PurgeEntity = {
						val: '',
						fail: 'yes',
						msg: 'No Affiliations ' + statusText + ' with ' + (ptype == 'MATCHEDDISPENSES' ? bizModelCpMatch : bizModelSplit)
					};
				}
				else {
					vm.query.RX = utilSvc.ng.droplistAutoselect(vm.RxDroplist, vm.query.RX.val);
					queryChangeRX();
				}
				break;

			default:
				throw new Error('datamgr.changePurgeType, unknown purge type: ' + ptype);
		}

	}

	function queryChangeCE() {

		if(vm.isWaiting) {
			return;
		}

		queryChange();

		// valid CE
		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';
		if(vm.query.CE.fail == 'yes') {
			return;
		}

		var ptype = vm.query.PurgeType.val,
			affs = [];

		switch(ptype) {

			case 'NPI':
				// no action, purge button shown
				vm.purge = [];
				break;

			case 'VISITS':
				// ce is primary, setup CP SPLITMATCH purge list
				affs = utilSvc.aff.findCe($scope.User.AffList, vm.query.CE.val);
				vm.purge = affPurgeListVM(ptype, affs, []); // no purge history for affiliations

				// visits purge requires ALL CP Match affiliations to be purgable
				var allAffsOk = true;
				for(var i = 0; i < vm.purge.length; i++) {
					if(!vm.purge[i].canPurge) {
						allAffsOk = false;
						break;
					}
				}

				// inform user purge not possible
				if(!allAffsOk || vm.purge.length < 1) {
					vm.query.PurgeEntity.fail = 'yes';
					vm.query.PurgeEntity.msg = 'Purge not allowed';
					msgSvc.ok('Cannot Purge Visits', vm.query.CE.val + ' needs all CP SPLITMATCH affiliations with status ONBOARDING or INACTIVE');
				}
				break;

			default:
				throw new Error('datamgr.changePurgeType, unknown purge type: ' + ptype.val);
		}

	}

	function queryChangeRX() {

		if(vm.isWaiting) {
			return;
		}

		queryChange();

		// valid RX
		vm.query.RX.fail = validSvc.isRX(vm.query.RX.val) ? 'no' : 'yes';
		if(vm.query.RX.fail == 'yes') {
			return;
		}
		vm.query.RxShortName = utilSvc.ng.droplistLabel(vm.RxDroplist, vm.query.RX.val);

		var ptype = vm.query.PurgeType.val,
			affs = [];

		switch(ptype) {

			case 'ACCUM':
			case 'MATCHEDDISPENSES':
			case 'TRANSFORM':
				// rx is primary, setup CE
				affs = utilSvc.aff.findRx($scope.User.AffList, vm.query.RX.val);
				vm.purge = affPurgeListVM(ptype, affs, vm.purgeHistory);
				break;

			case 'DISPENSES':
				// do nothing, only needs RX
				break;

			default:
				throw new Error('datamgr.changePurgeType, unknown purge type: ' + ptype.val);
		}

	}


	/**
	 *    PURGE
	 */

	function submitPurge(ceid, rxid) {

		if(vm.isWaiting) {
			return;
		}
		closePopup();

		var ptype = vm.query.PurgeType.val,
			rxname = utilSvc.aff.rxShortNameById($scope.User.AffList, rxid);

		_pendingPurge = {
			id: '',
			started: null,
			ptype: ptype,
			CEID: ceid,
			RXID: rxid,
			RxShortName: rxname
		};

		msgSvc.confirm({
			id: 'admin.datamgr.purge',
			title: 'Purge ' + purgeTitle(ptype),
			msg: 'Purge for ' + purgeConfirmEntity(ptype, ceid, rxname) + '? Please confirm this action is permanent and cannot be undone.',
			buttons: [
				{text:'PURGE', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

	}

	function userConfirm(r) {

		// user said yes
		if(!!r && r.result == 'YES') {
			datamgrRepo.purge(_pendingPurge.ptype, _pendingPurge.CEID, _pendingPurge.RXID).then(okPurge, errPurge);
		}

		function okPurge(r) {
			_pendingPurge.id = r.Id;
			_pendingPurge.started = new Date();
			vm.purgeHistory.push(_pendingPurge);
			saveViewState(vm.query, vm.purgeHistory);

			msgSvc.ok('Purge ' + purgeTitle(_pendingPurge.ptype), purgeTitle(_pendingPurge.ptype) + ' purge started, check details in Feeds Feature.');
			_pendingPurge = {};
		}

		function errPurge(r) {
			if(r === null) {
				// already handled
			}
			else if(!!r && (r.status === 422 || r.status === 409)) {
				msgSvc.ok('Cannot Purge', r.msg);
			}
			else {
				errSvc.error('Unexpected error', 'datamgrCtl.purge', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    NAV TO FEEDS
	 */

	function navToFeedDetail(id) {

		if(vm.isWaiting) {
			return;
		}

		if(!validSvc.isText(id)) {
			throw new Error('datamgrCtl.getDetail, missing id');
		}

		_pendingPurge = {id: id};

		msgSvc.confirm({
			id: 'admin.datamgr.navtofeeds',
			title: 'Navigate To Feeds',
			msg: 'Leave Data Manager and view purge details in Feeds feature?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userLeaveConfirm, userLeaveConfirm);

	}

	function userLeaveConfirm(r) {

		// user said yes
		if(!!r && r.result == 'YES') {
			saveViewState(vm.query, vm.purgeHistory);
			$state.go('ops.feeds-detail', {Id:_pendingPurge.id}, {reload: 'ops.feeds-detail'});
		}
	}


	/**
	 *    POPUP
	 */

	function openPopup(evt, item) {

		if(vm.isWaiting) {
			return;
		}


		vm.popup = {
			ready: true,
			id: item.id,
			title: 'Purge Detail'
		};

		// note: more properties added after api calls
		// see below, datafeed calls repo to get config values

		// remember the clicked vertical location
		var elem = evt.target,
			offsetY = -100, // pop over
			hitRow = false;

		// loop html elements back to top of table
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
				break;
			}

			// add offset, get next element
			offsetY += elem.offsetTop;
			elem = elem.offsetParent;
		}
		elem = null;

		// move popup to clicked row
		var popup = document.getElementById('tablePopupContentPURGE');
		if(!!popup) {
			popup.style.top = offsetY.toString() + 'px';
		}

		var detailRoute = 'admin.datamgr.main.feeds-detail';
		$state.go(detailRoute, {Id: item.id}, {reload: detailRoute});

	}

	function closePopup() {
		vm.popup = {};
	}


	/**
	 *    HELPERS
	 */

	function saveViewState(query, hist) {

		sessionRepo.set('vs-admin-datamgr', {
			query: {
				PurgeType: query.PurgeType.val,
				CE: query.CE.val,
				RX: query.RX.val
			},
			history: hist
		});

	}

	function purgeTitle(ptype) {

		switch(ptype) {
			case 'NPI':
				return 'CP / Split Match - NPI List';

			case 'DISPENSES':
				return 'CP / Split Match - Dispenses';

			case 'VISITS':
				return 'CP / Split Match - Patient Visits';

			case 'ACCUM':
				return 'Split Billing - Accumulation';

			case 'MATCHEDDISPENSES':
				return 'CP / Split Match - Matches and Accumulation';

			case 'TRANSFORM':
				return 'Split Billing - Mapping and Accumulation';

			default:
				throw new Error('datamgr.purgeTitle, unknown purge type: ' + ptype);
		}
	}

	function purgeConfirmEntity(ptype, cename, rxname) {

		switch(ptype) {
			case 'NPI':
			case 'VISITS':
				return cename;

			case 'DISPENSES':
				return rxname;

			case 'ACCUM':
			case 'MATCHEDDISPENSES':
			case 'TRANSFORM':
				return rxname + ' - ' + cename;

			default:
				throw new Error('datamgr.purgeTitle, unknown purge type: ' + ptype);
		}
	}

	function addPurgeHistory(ptype, aff, hist) {

		// try to find this aff in previous purges this session

		if(hist.length < 1) {
			return aff;
		}

		var histItem = {};
		for(var i = 0; i < hist.length; i++) {
			histItem = hist[i];
			if(ptype == histItem.ptype && aff.CEID == histItem.CEID && aff.RXID == histItem.RXID) {
				aff.id = histItem.id;
				aff.started = histItem.started;
				break;
			}
		}

		return aff;
	}

}
 
groupsRepo.$inject = ['$rootScope', '$q', 'apiService', 'apiErrors', 'appConst', 'errSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
.module('espui.admin.groups')
.factory('groupsRepo', groupsRepo);


/* @ngInject */
function groupsRepo($rootScope, $q, apiService, apiErrors, appConst, errSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _currentPurl = '',
		_apiPaging = vmSvc.api.paging(),
		_modelPending = null,
		_listViewState = null;

	// service definition
	var service = {

		viewStateSave: viewStateSave,
		viewStateReload: viewStateReload,

		modelVM: modelVM,
		getList: getList,
		getVenList: getVenList,
		getDetail: getDetail,

		create: create,
		update: update,

		memberListEdit: memberListEdit,
		memberListGet: memberListGet

	};

	return service;


	/**
	 *    VIEW MODELS
	 */

	function modelVM(data) {

		data = data || {};

		return {
			Id: validSvc.isText(data.Id) ? data.Id : '',
			Name: validSvc.newProp(validSvc.isText(data.Name) ? data.Name : ''),
			Type: validSvc.newProp(validSvc.isText(data.Type) ? data.Type : 'CE'),
			ObjectState: validSvc.isText(data.ObjectState) ? data.ObjectState : 'ACTIVE',
			Entities: Array.isArray(data.Entities) ? data.Entities : [],
			ContractFulfillment: data.ContractFulfillment ? 'yes' : 'no',
			ContractType: validSvc.isText(data.ContractType) ? data.ContractType : 'TOTAL',
			Threshold: Array.isArray(data.Threshold) ? data.Threshold : []
		};

	}


	/**
	 *    LIST FILTERS
	 *    list view saves filter state in repo
	 */

	function viewStateSave(viewState) {

		// save viewstate properties by value
		_listViewState = angular.toJson(viewState);

	}

	function viewStateReload() {

		// exit if nothing saved for this list type or query has changed
		if(!!!_listViewState) {
			return null;
		}

		// re-hydrate
		return angular.fromJson(_listViewState);

	}


	/**
	 *    GET LIST
	 */

	function getList() {

		_currentPurl = 'admin/entitygroup/list';
		var defer = $q.defer();

		var apiRequest = {
			Context: {},
			Entity: {},
			Paging: {
				Page: 1,
				Size: 2000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('Name')]
		};

		apiService.post(_currentPurl, apiRequest).then(okList, errList);

		function okList(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errList(r) {

			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function getVenList() {

		var defer = $q.defer();
		_currentPurl = 'admin/vendor/list';
		apiService.post(_currentPurl, {}).then(okGetVendorDrop, errInitData);

		function okGetVendorDrop(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + '/repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({
				vendors: Array.isArray(r.data.Entity) ? r.data.Entity : []
			});

		}

		function errInitData(r) {
			if(r !== null) {
				errSvc.warn('Affiliations request failed', _currentPurl + '/affRepo.getInitData', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}
		return defer.promise;
	}


	/**
	 *    GET DETAIL
	 */

	function getDetail(id) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('groupsRepo.getDetail, id is required');
		}

		_currentPurl = 'admin/entitygroup/get';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Entity: {
				Params: {
					Id: id
				}
			}
		};

		// call api
		apiService.post(_currentPurl, apiReqest).then(okGetDetail, errGetDetail);

		function okGetDetail(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(modelVM(r.data.Entity));

		}

		function errGetDetail(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    CREATE / UPDATE
	 */

	function create(model) {
		return upsert('admin/entitygroup/create', model);
	}

	function update(model) {
		return upsert('admin/entitygroup/update', model);
	}

	function upsert(purl, model) {

		_currentPurl = purl;
		_modelPending = model;
		var defer = $q.defer();

		var apiRequest = {
			Entity: {
				Id: model.Id,
				Name: model.Name.val,
				Type: model.Type.val,
				ObjectState: model.ObjectState,
				ContractFulfillment: model.ContractFulfillment === 'yes',
				ContractType: model.ContractType,
				Threshold: model.Threshold
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(upsertOk, upsertErr);

		function upsertOk(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function upsertErr(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapApiErrorsToModel(r, _modelPending);
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);
				if(fieldObj === undefined) {
					throw new Error('groupsRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
				}

				// set failed state
				fieldObj.fail = 'yes';
				fieldObj.msg = entity.Fields[i].Rule;

			}

			return m;

		}


		return defer.promise;
	}


	/**
	 *    GROUP MEMBERS
	 */

	function memberListEdit(groupId, action, member) {

		// params
		if(!validSvc.isText(groupId) || !validSvc.isText(action) || !validSvc.isEntity(member)) {
			throw new Error('rxRepo.memberListEdit, groupId, action, member id required');
		}

		switch(action) {
			case 'add':
				_currentPurl = 'admin/entitygroup/member/add';
				break;
			case 'remove':
				_currentPurl = 'admin/entitygroup/member/remove';
				break;
			default:
				throw new Error('groupsRepo.memberListEdit, unknown edit action: ' + action);
		}

		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {},
			Entity: {
				Params: {
					Id: groupId,
					MemberId: member
				}
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okMemberListEdit, errMemberListEdit);

		function okMemberListEdit(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function errMemberListEdit(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!!r && r.status === 422) {
				defer.reject(r);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				throw new Error('rxRepo.errMemberListEdit, unexpected error result');
			}

		}

		return defer.promise;

	}

	/**
	 *    OTHER GROUP MEMBERS GET
	 */

	function memberListGet(memberId, groupType) {
		// params
		if(!validSvc.isText(memberId) || !validSvc.isText(groupType)) {
			throw new Error('rxRepo.memberListGet, memberId and groupType required');
		}

		var defer = $q.defer();

		_currentPurl = 'admin/entitygroup/member/other';

		// create api request
		var apiReqest = {
			Context: {},
			Entity: {
				Params: {
					MemberId: memberId,
					GroupType: groupType
				}
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okMemberListGet, errMemberListGet);

		function okMemberListGet(r) {

			// bad upsert response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function errMemberListGet(r) {
			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!!r && (r.status === 404 || r.status === 422)) {
				defer.reject(r);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				throw new Error('rxRepo.errMemberListGet, unexpected error result');
			}

		}

		return defer.promise;

	}
}
 
groupsEditCtl.$inject = ['$rootScope', '$scope', '$state', '$filter', 'groupsRepo', 'catalogsRepo', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc', 'appConst'];
angular
	.module('espui.admin.groups')
	.controller('GroupsEditCtl', groupsEditCtl);


/* @ngInject */
function groupsEditCtl($rootScope, $scope, $state, $filter, groupsRepo, catalogsRepo, validSvc, errSvc, utilSvc, msgSvc, appConst) {

	/*jshint validthis: true */
	var vm = this;
	var _pendingMember = null,
		_savedType = '';

	// properties
	vm.isWaiting = false;
	vm.action = '';
	vm.isVeritySA = false;
	vm.typeDroplist = [];
	vm.vendorDropList = [];

	vm.model = {};

	// methods
	vm.submitAcct = submitAcct;
	vm.changeModelType = changeModelType;

	// member props
	vm.grpMembers = [];
	vm.addMembersDroplist = [];
	vm.addMemberId = '';

	// member add/remove
	vm.grpMemberAdd = grpMemberAdd;
	vm.grpMemberRemove = grpMemberRemove;

	// contract fulfillment parameters
	vm.contractListEdit = {};
	vm.addContractListItem = addContractListItem;
	vm.contractVendor = validSvc.newProp();
	vm.contractTimePeriod = validSvc.newProp();
	vm.changeContractType = changeContractType;
	vm.removeContractListItem = removeContractListItem;
	vm.numberFmt = numberFmt;

	/**
	 *    INIT
	 */

	init();

	function init() {
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		vm.model = groupsRepo.modelVM();

		vm.typeDroplist = [
			{ label: 'Facility', value: 'CE' },
			{ label: 'Mapping', value: 'MAPPING' },
			{ label: 'Pharmacy', value: 'PHARMACY' },
			{ label: 'IDN', value: 'IDN' }
		];

		vm.isVeritySA = $scope.User.Type == 'VERITYSA';

		switch ($state.current.name) {

			case 'admin.groups.edit':
				vm.action = 'UPDATE';
				getDetail($state.params.Id);
				break;

			case 'admin.groups.create':
				vm.action = 'CREATE';
				break;

			default:
				throw new Error('groupsEditCtl.Init, state unknown: ' + $state.current.name);
		}

	}

	/**
	 *    GET DETAIL
	 */

	function getDetail(id) {

		// valid param
		if (!validSvc.isText(id)) {
			throw new Error('groupsEditCtl.getDetail, id is missing');
		}

		groupsRepo.getDetail(id).then(okGetDetail, errGetDetail);

		function okGetDetail(r) {
			vm.model = r;
			_savedType = vm.model.Type.val;

			// build sorted members list
			vm.grpMembers = [];
			for (var i = 0; i < r.Entities.length; i++) {
				vm.grpMembers.push(r.Entities[i]);
			}
			vm.grpMembers.sort();

			vm.addMembersDroplist = buildAddMembersList(vm.grpMembers, vm.model.Type.val);

		}

		function errGetDetail(r) {
			if (!!r) {
				errSvc.warn('Group Id not found', 'groupsEditCtl.getDetail.err', r.status, utilSvc.http.safeResponse(r));
			}
			$state.go('admin.groups.list');
		}

		groupsRepo.getVenList().then(okGetVenList, errGetVenList);

		function okGetVenList(r) {
			var venNames = [];
			for (var i = 0; i < r.vendors.length; i++) {
				if (r.vendors[i].Type === 'WHOLESALER') {
					venNames.push(r.vendors[i].Name);
				}
			}
			venNames.sort();
			vm.vendorDropList = utilSvc.ng.droplist(venNames);
		}

		function errGetVenList(r) {
			if (!!r) {
				errSvc.warn('Cannot get vendor list', 'groupsEditCtl.getVenList.err', r.status, utilSvc.http.safeResponse(r));
			}
			$state.go('admin.groups.list');
		}
	}


	/**
	 *    CHANGE EVENTS
	 */

	function buildAddMembersList(members, memType) {

		// build list of potential new group members

		var affs = utilSvc.aff.findStatus($scope.User.AffList),
			result = [];

		switch (memType) {

			case 'CE':
				result =  utilSvc.aff.ceDroplistLabel(affs,null,true,false,$rootScope.User.AdminPrefs.ListDisplay);
				break;

			case 'PHARMACY':
				affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
				result =  utilSvc.aff.rxDroplist(affs);
				break;

			case 'MAPPING':
				affs = utilSvc.aff.findStatus(affs, ['ONBOARDING', 'ACTIVE']);
				result =  utilSvc.aff.rxDroplist(affs);
				break;
			case 'IDN':
				result =  utilSvc.aff.ceDroplist(affs);
				break;

			default:
				errSvc.warn('unknown memType: ' + memType, 'groupsEditCtl.buildAddMembersList');
				break;
		}

		return result;

	}

	function changeModelType() {

		// user changed the model type

		if (vm.model.Type.val === null) {
			return;
		}

		if (vm.action == 'UPDATE' && vm.grpMembers.length > 0 && vm.model.Type.val != _savedType) {
			msgSvc.ok('Cannot Change Type', 'Remove all group members before changing type.');
			vm.model.Type = validSvc.newProp(_savedType);
			return;
		}

		// refresh add member UI
		vm.addMemberId = '';
		vm.addMembersDroplist = buildAddMembersList([], vm.model.Type.val);

	}

	function changeContractType() {
		vm.model.Threshold = [];
		resetContractListItemQuery();
	}

	function addContractListItem() {
		if (!!!contractListItemValidation()) {
			return;
		}

		function okSearch(r) {
			if (r.Items.length > 0) {
				vm.model.Threshold.push({
					NDC: vm.contractListEdit.NDC,
					Vendor: vm.contractListEdit.Vendor,
					TimePeriod: vm.contractListEdit.TimePeriod,
					Description: r.Items[0].Description,
					Value: vm.contractListEdit.Value
				});
				resetContractListItemQuery();
			} else {
				msgSvc.ok('NDC is not valid');
			}
		}

		function errSearch() {
			msgSvc.ok('NDC is not valid');
		}

		if (vm.model.ContractType === 'LIST') {
			var query = {
				NDC: validSvc.newProp(vm.contractListEdit.NDC),
				Desc: validSvc.newProp(),
				Manufacturer: []
			};
			catalogsRepo.search(query).then(okSearch, errSearch);
		} else {
			vm.model.Threshold.push({
				Vendor: vm.contractListEdit.Vendor,
				TimePeriod: vm.contractListEdit.TimePeriod,
				Value: vm.contractListEdit.Value
			});
			resetContractListItemQuery();
		}
	}

	function resetContractListItemQuery() {
		vm.contractListEdit = {
			Vendor: "",
			TimePeriod: "",
			Value: "",
			show: true
		};
	}

	function removeContractListItem(obj) {
		// find this item by val
		var foundIdx = -1;
		for (var i = 0; i < vm.model.Threshold.length; i++) {
			if (vm.model.ContractType === 'LIST') {
				if (vm.model.Threshold[i].NDC == obj.NDC) {
					foundIdx = i;
					break;
				}
			} else {
				if (vm.model.Threshold[i].Vendor == obj.Vendor) {
					foundIdx = i;
					break;
				}
			}
		}
		if (foundIdx < 0) {
			throw new Error('groupsEditCtl.removeContractListItem, cannot find the item needs to be removed' + obj);
		}
		vm.model.Threshold.splice(foundIdx, 1);
	}

	function contractListItemValidation() {
		if (!!!vm.contractListEdit.Vendor) {
			msgSvc.ok('Please select a vendor');
			return false;
		}
		if (!!!vm.contractListEdit.TimePeriod) {
			msgSvc.ok('Please select a time period');
			return false;
		}
		if (!!!vm.contractListEdit.Value) {
			msgSvc.ok('Please enter a value');
			return false;
		}
		var found = false;
		if (vm.model.ContractType === 'TOTAL') {
			if (vm.contractListEdit.Value > 100 || vm.contractListEdit.Value < 0) {
				msgSvc.ok('percentage value is not valid');
				return false;
			}
			for (var i = 0; i < vm.model.Threshold.length; i++) {
				if (vm.model.Threshold[i].Vendor === vm.contractListEdit.Vendor) {
					found = true;
				}
			}
			if (found) {
				msgSvc.ok("Same vendor cannot be selected twice for contract type 'TOTAL'");
				return false;
			}
		} else {
			if (!!!vm.contractListEdit.NDC) {
				msgSvc.ok('Please enter a NDC');
				return false;
			}
			for (var j = 0; j < vm.model.Threshold.length; j++) {
				if (vm.model.Threshold[j].NDC === vm.contractListEdit.NDC) {
					found = true;
				}
			}
			if (found) {
				msgSvc.ok("Same NDC cannot be entered twice for contract type 'LIST'");
				return false;
			}
		}
		return true;
	}

	/**
	 *    SUBMIT: ACCOUNT
	 */

	function resetValidationState() {

		// reset validation state on all model properties
		// note: use this after an update to hide validation icons

		vm.model.Name.fail = '';
		vm.model.Type.fail = '';
	}

	function validAccount() {

		// validate for both create and update

		// Name - required
		vm.model.Name = validText(vm.model.Name, 3, 50);

		// Type - cannot be changed if group has members
		if (vm.action == 'UPDATE' && vm.grpMembers.length > 0 && vm.model.Type.val != _savedType) {
			vm.model.Type.fail = 'yes';
			vm.model.Type.msg = 'remove group members before changing type';
		}
		else {
			vm.model.Type.fail = 'no';
		}

		// result
		return vm.model.Name.fail != 'yes' && vm.model.Type.fail != 'yes';

	}

	function submitAcct() {

		if (vm.isWaiting) {
			return;
		}

		// validate
		if (!validAccount()) {
			msgSvc.ok('Cannot Save', 'All fields must be valid.');
			return false;
		}

		vm.isWaiting = true;

		// create or update
		if (vm.action == 'CREATE') {
			groupsRepo.create(vm.model).then(okUpsert, errUpsert);
		}
		else {
			groupsRepo.update(vm.model).then(okUpsert, errUpsert);
		}

	}

	function okUpsert(r) {

		vm.isWaiting = false;

		// after CREATE, route to edit view
		if (vm.action == 'CREATE') {
			msgSvc.ok(vm.model.Name.val, 'Created');
			$state.go('admin.groups.edit', { Id: r.Id }, { reload: 'admin.groups.edit' });
		}
		else {
			resetValidationState();
			_savedType = vm.model.Type.val;
			msgSvc.ok(vm.model.Name.val, 'Saved');
		}

	}

	function errUpsert(r) {

		vm.isWaiting = false;

		if (!!!r || r === null) {
			// already handled
			$state.go('admin.groups.list', {}, { reload: 'admin.groups.list' });
		}
		else if (r.status === 409) {
			// conflict
			msgSvc.ok('Cannot Save', 'Could not create or save, already exists in the database. Verify and try again (409).');
		}
		else if (r.status === 422) {
			// validation
			vm.model = r.model;
		}
		else {
			errSvc.error('Unexpected api error', 'groupsEditCtl.errUpsert', r.status, utilSvc.http.safeResponse(r));
			$state.go('admin.groups.list', {}, { reload: 'admin.groups.list' });
		}

	}


	/**
	 *    MEMBERS: ADD/REMOVE
	 */

	function grpMemberAdd() {

		if (vm.isWaiting) {
			return;
		}

		// validate
		if (!validSvc.isEntity(vm.addMemberId)) {
			msgSvc.ok('Cannot Add', 'Choose a Member to Add');
			return;
		}

		promptMemberAction('add', vm.addMemberId);

	}

	function grpMemberRemove(id) {

		if (vm.isWaiting) {
			return;
		}

		// validate
		if (!validSvc.isEntity(id)) {
			msgSvc.ok('Cannot Remove', 'Choose a Member to Remove');
			return;
		}

		promptMemberAction('remove', id);

	}

	function promptMemberAction(action, entityId) {

		_pendingMember = {
			action: action,
			member: entityId
		};

		var title = action == 'add' ? 'Add ' : 'Remove ';

		msgSvc.confirm({
			id: 'groups.member.action',
			title: title + entityId,
			msg: 'Confirm ' + title + entityId + '?',
			buttons: [
				{ text: 'OK', result: 'YES', cancel: false },
				{ text: 'CANCEL', result: 'CANCEL', cancel: true }
			]
		}).then(confirmMemberAction, confirmMemberAction);

	}

	function confirmMemberAction(r) {

		// user said yes
		if (!!r && r.result == 'YES' && !vm.isWaiting) {
			vm.isWaiting = true;
			groupsRepo.memberListEdit(vm.model.Id, _pendingMember.action, _pendingMember.member).then(okMemberListEdit, errMemberListEdit);
		}
	}

	function okMemberListEdit(r) {
		vm.isWaiting = false;

		switch (_pendingMember.action) {

			case 'add':

				// add to model
				vm.grpMembers.push(_pendingMember.member);
				vm.grpMembers.sort();
				break;

			case 'remove':

				// remove from model
				var idx = vm.grpMembers.indexOf(_pendingMember.member);
				if (idx < 0) {
					throw new Error('groupsEditCtl.okMemberListEdit, remove member id not found: ' + _pendingMember.member);
				}
				vm.grpMembers.splice(idx, 1);
				break;

			default:
				throw new Error('groupsEditCtl.okMemberListEdit, pending action unknown: ' + _pendingMember.action);
		}

		// refresh add member UI
		vm.addMemberId = '';
		vm.addMembersDroplist = buildAddMembersList(vm.grpMembers, vm.model.Type.val);

	}

	function errMemberListEdit(r) {
		vm.isWaiting = false;

		if (!!!r) {
			// do nothing
		}
		else if (!!r && r.status === 422 && _pendingMember.action == 'add') {
			msgSvc.ok('Cannot Add ' + vm.addMemberId, r.data.Entity.ROOT.join(', '));
		}
		else {
			errSvc.warn('Unknown Member error', 'groupsEditCtl.errMemberListEdit', _pendingMember.action + _pendingMember.member, r.status, utilSvc.http.safeResponse(r));
			$state.go('admin.groups.list', {}, { reload: 'admin.groups.list' });
		}

	}


	/**
	 *    HELPERS
	 */

	function validText(prop, min, max) {

		// required
		if (!validSvc.isText(prop.val)) {
			prop.fail = 'yes';
			prop.msg = 'required';
			return prop;
		}

		// min
		if (prop.val.length < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum ' + min.toString() + ' characters';
			return prop;
		}

		// max
		if (prop.val.length > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum ' + max.toString() + ' characters';
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;

	}

	function numberFmt(val, zeroFmt, prefix, decPlaces) {
		if (!validSvc.isNumber(val)) {
			return '';
		}

		// zero
		if (val === 0) {
			return zeroFmt;
		}

		return prefix + utilSvc.str.toText($filter('number')(val, decPlaces));
	}
}
 
groupsListCtl.$inject = ['$state', '$rootScope', '$scope', 'groupsRepo', 'appConst', 'utilSvc', 'errSvc', 'msgSvc'];
angular
.module('espui.admin.groups')
.controller('GroupsListCtl', groupsListCtl);


/* @ngInject */
function groupsListCtl($state, $rootScope, $scope, groupsRepo, appConst, utilSvc, errSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this;

	// inherit sorting and paging features
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);

	// properties
	vm.isWaiting = false;
	vm.viewState = {};

	// models
	vm.display = {};

	// methods
	vm.groupsCreate = groupsCreate;
	vm.groupsEdit = groupsEdit;

	// filters
	vm.filterExactChange = filterExactChange;


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		// remember last viewState
		vm.viewState = groupsRepo.viewStateReload();
		if(!!!vm.viewState) {
			vm.viewState = {
				FilterTxt: {},
				FilterExact: {
					ObjectState: 'ALL'
				},
				SortBy: ['Name']
			};
		}

		getList();

	}


	/**
	 *    DISPLAY VIEW MODEL
	 */

	function displayVM(repoData) {

		var items = Array.isArray(repoData) ? repoData : [];

		// create searchable MemberTxt
		var mem = [];
		for(var i = 0; i < items.length; i++) {


			if (items[i].EntityNames && $rootScope.User.AdminPrefs.ListDisplay == 'USE_DISPLAY') {
				mem = Array.isArray(items[i].EntityNames) ? items[i].EntityNames : [];
			} else {
				mem = Array.isArray(items[i].Entities) ? items[i].Entities : [];
			}
			mem.sort();
			items[i].MemberTxt = mem.join(', ');
		}

		return {
			Items: items,
			Paging: {
				Page: 1,
				Size: appConst.app.display.pagingSize,
				Total: vm.getTotalPages(items.length, appConst.app.display.pagingSize)
			}
		};

	}


	/**
	 *    EXACT FILTER CHANGE
	 *    note: needed when values need to be filtered exactly by ng-repeat
	 */

	function filterExactChange(propName) {

		// exact filters require an undefined value to show all ng-repeat rows

		// prop name doesn't exist?
		var propVal = vm.viewState.FilterExact[propName];
		if(typeof(propVal) === 'undefined') {
			throw new Error('groupsListCtl.filterExactChange, unknown propName: ' + propName);
		}

		// update NG property
		vm.viewState.FilterExact[propName + 'NG'] = propVal != 'ALL' ? propVal : undefined;

	}


	/**
	 *    GET LIST
	 */

	function getList() {

		vm.isWaiting = true;
		msgSvc.wait(true);
		groupsRepo.getList().then(okList, errList);

		function okList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			vm.display = displayVM(r);
			vm.display.SortBy = vm.viewState.SortBy;
		}

		function errList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('unknown error getting data', 'groups.getList', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    CREATE AND EDIT
	 */

	function groupsCreate() {
		vm.viewState.SortBy = vm.display.SortBy;
		groupsRepo.viewStateSave(vm.viewState);
		$state.go('admin.groups.create', {}, {reload: 'admin.groups.create'});
	}

	function groupsEdit(id) {
		vm.viewState.SortBy = vm.display.SortBy;
		groupsRepo.viewStateSave(vm.viewState);
		$state.go('admin.groups.edit', {Id: id}, {reload:'admin.groups.edit'});
	}

}
 
rxRepo.$inject = ['$rootScope', '$q', 'apiService', 'apiErrors', 'appConst', 'errSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
.module('espui.admin.rx')
.factory('rxRepo', rxRepo);

/* @ngInject */
function rxRepo($rootScope, $q, apiService, apiErrors, appConst, errSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _currentPurl = '',
		_apiPaging = vmSvc.api.paging(),
		_modelPending = null;

	// service definition
	var service = {
		modelVM: modelVM,
		contextVM: contextVM,

		// read
		getList: getList,
		getDetail: getDetail,

		// edit
		createAcct: createAcct,
		updateAcct: updateAcct,
		statusChange: statusChange,

		// central fill
		cfMemberAdd: cfMemberAdd,
		cfMemberRemove: cfMemberRemove,

		// rollup members
		ruMemberAdd: ruMemberAdd,
		ruMemberRemove: ruMemberRemove,
	};

	return service;


	/**
	 *    CONTEXT
	 */

	function contextVM() {

		var uType = $rootScope.User.Type;

		return {
			uType: uType,
			isDebug: !!$rootScope.debug,
			isVerity: uType == 'VERITYSA' || uType == 'VERITY'
		};

	}


	/**
	 *    AFFILIATION SILENT REFRESH
	 *    after RX create / updates or status, refresh the user's affiliations in session
	 */

	function refreshUserSilent() {

		// refresh login affs silent
		// note: don't care about the response, just doing a refresh for other features

		apiService.refreshUser().then(okUserRefreshSilent, errUserRefreshSilent);

		function okUserRefreshSilent(r) {
			// do nothing
		}

		function errUserRefreshSilent(r) {
			if(r !== null) {
				errSvc.warn('Affiliations refresh failed', 'rxRepo.errUserRefreshSilent', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}

	/**
	 *    GET LIST
	 */

	function getList(query) {

		_currentPurl = 'admin/rx/list';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {},
			Params: parseQueryParams(query),
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('Id')]
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(getOk, getErr);

		function getOk(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return query and data
			defer.resolve({
				query: {
					Paging: utilSvc.paging.apiResults(vmSvc.api.paging(), _apiPaging.Size, r.data.Entity.length, _apiPaging.Size)
				},
				data: r.data.Entity
			});

		}

		function getErr(r) {

			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);

		}

		return defer.promise;

	}

	function parseQueryParams(q) {
		var params = {};
		if(!!!q) {
			return params;
		}
		
		if (!!q.CE) {
			params.CE = q.CE.vals;
		}
		if (!!q.RX) {
			params.RX = q.RX.vals;
		}
		if (!!q.RollupParent) {
			params.RollupParent = q.RollupParent.vals;
		}
		if (!!q.CentralFill) {
			params.CentralFill = q.CentralFill.vals;
		}
		if (!!q.PriceModel) {
			params.PriceModel = q.PriceModel.vals;
		}
		if (!!q.BusinessModels) {
			params.BusinessModels = q.BusinessModels.vals;
		}
		if (!!q.PharmacyType) {
			params.PharmacyType = q.PharmacyType.vals;
		}
		if (!!q.DataSwitch) {
			params.DataSwitch = q.DataSwitch.vals;
		}
		if (!!q.TPA) {
			params.TPA = q.TPA.vals;
		}
		if (!!q.NPI.chk) {
			params.NPI = q.NPI.val;
		}
		if (!!q.NCPDP.chk) {
			params.NCPDP = q.NCPDP.val;
		}
		if (!!q.DisplayName.chk) {
			params.DisplayName = q.DisplayName.val;
		}
		if (!!q.FullName.chk) {
			params.FullName = q.FullName.val;
		}
		if (q.CDC == 'yes') {
			params.CDC = true;
		}
		if (q.Vhub == 'yes') {
			params.Vhub = true;
		}
		if (q.SequentialSplit == 'yes') {
			params.SequentialSplit = true;
		}
		if (q.NDCOptimizer == 'yes') {
			params.NDCOptimizer = true;
		}
		if (q.BillingEnabled == 'yes') {
			params.BillingEnabled = true;
			if(q.ExportInvoice == 'yes') {
				params.ExportInvoice = true;
			}
		}
		return params;
	}


	/**
	 *    GET DETAIL
	 */

	function getDetail(id) {

		if(!validSvc.isText(id)) {
			throw new Error('rx.repo.getDetail, id is missing');
		}

		_currentPurl = 'admin/rx/get';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Entity: {
				Params: {
					Id: id
				}
			}
		};

		apiService.post(_currentPurl, apiReqest).then(getOk, getErr);

		function getOk(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return model
			defer.resolve(modelVM(r.data.Entity));

		}

		function getErr(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    EDIT MODEL
	 */

	function modelVM(data) {

		// create new structure if doesn't exist
		data = data || {};
		var i = 0;

		var rxType = validSvc.isText(data.Type) ? data.Type : 'DISPENSING';

		// look back default is 180
		var lookBack = validSvc.isNumber(data.ExtractNpisVisitLookback) ? data.ExtractNpisVisitLookback : 180;
		if(lookBack < 1) {
			lookBack = 180;
		}

		var nickname = validSvc.isText(data.Id) ? data.Id : '';

		var gpiGovList = Array.isArray(data.GovernedGPIs) ? data.GovernedGPIs : [];
		for(var g = 0; g < gpiGovList.length; g++) {
			gpiGovList[g] = validSvc.newProp(gpiGovList[g]);
		}

		// business models, always remove NONE
		var bizModels = Array.isArray(data.BusinessModels) ? data.BusinessModels : [];
		var noneIdx = bizModels.indexOf('NONE');
		if(noneIdx >= 0) {
			bizModels.splice(noneIdx, 1);
		}
		bizModels.sort();

		// sequential CE list
		var seqCeList = Array.isArray(data.SeqCEs) ? data.SeqCEs : [];
		for(var sq = 0; sq < seqCeList.length; sq++) {
			seqCeList[sq] = validSvc.newProp(seqCeList[sq]);
		}

		// sequential Account list
		var seqAltAccountsList = Array.isArray(data.SeqAltVendorAccounts) ? data.SeqAltVendorAccounts : [];
		
		// seq timeout default
		var seqTmo = parseInt(data.SeqTimeout855s);
		if(!!data.SeqCombine855s && (isNaN(seqTmo) || seqTmo <= 0)) {
			seqTmo = 60;
		}

		var pretmout = parseInt(data.SeqPreSplitTimeout);
		if(!validSvc.isInteger(pretmout) || pretmout < 30) {
			pretmout = 30;
		}

		var apptmout = parseInt(data.SeqApprovalTimeout);
		if(!validSvc.isInteger(apptmout) || apptmout < 30) {
			apptmout = 30;
		}

		// billing
		data.Billing = data.Billing || {};
		var billPayTpaList = Array.isArray(data.Billing.PayTpaDirectList) ? data.Billing.PayTpaDirectList : [];

		// rx rollup pricing
		data.RollupPricing = data.RollupPricing || {};
		var rollupPricingCanOverride = !!data.RollupPricing.CanOverride;

		// rx pricing
		data.Pricing = data.Pricing || {};
		var pricingOverridden = !!data.Pricing.Overridden,
			pricingCanOverride = !!data.Pricing.CanOverride;

		// tpa
		var tpaRollup = data.TpaRollup || {},
			tpaConfig = data.TpaConfig || {};

		// disp pool
		var dispPoolLoad = !!data.DispensePoolLoad;
		var vcentralFileLoad = !!data.VCentralFileLoad;
		var rawClaimsLoad = !!data.ImportRawClaims;
		var federateClaims = !!data.FederateRawClaims;
		var useTpaNPIListForRawClaimsExport = !!data.UseTpaNPIListForRawClaimsExport;

		// rollup parent properties
		if(validSvc.isText(data.RollupParent)) {

			// pricing
			pricingOverridden = rollupPricingCanOverride && !!data.Pricing.Overridden;
			pricingCanOverride = rollupPricingCanOverride && !!data.Pricing.CanOverride;

			if(!pricingOverridden) {
				data.Pricing.Model =  data.RollupPricing.Model;
				data.Pricing.Rate = data.RollupPricing.Rate;

				if(!rollupPricingCanOverride) {
					data.Pricing.Model = '';
					data.Pricing.Rate = 0.0;
				}
			}

			// tpa, use rollup parent properties
			tpaConfig = tpaRollup;

			// disp pool setting overridden from parent
			dispPoolLoad = !!data.RollupDispensePoolLoad;
			vcentralFileLoad = !!data.RollupVCentralFileLoad;
			rawClaimsLoad = !!data.RollupImportRawClaims;
			federateClaims = !!data.RollupFederateRawClaims;
			useTpaNPIListForRawClaimsExport = !!data.RollupUseTpaNPIListForRawClaimsExport;
		}
		else {
			data.RollupParent = '';
		}

		// tpa extracts NDC list
		var tpaNdc = Array.isArray(tpaConfig.ExtractExcludeNDCs) ? tpaConfig.ExtractExcludeNDCs : [],
			extracts = [];
		for(i = 0; i < tpaNdc.length; i++) {
			extracts.push(validSvc.newProp(tpaNdc[i]));
		}

		// setup VHub, VCentral and faux property SeqSplitStatus
		data.VHub = data.VHub || {};
		data.VCentral = data.VCentral || {};
		var vhub = !!data.VHub.Enabled,
			vcentral = !!data.VCentral.Enabled,
			seqSplitStatus = !!data.SequentialSplitting ? 'on' : 'off';
		if(rxType == 'ROLLUP') {
			seqSplitStatus = 'off';
		}

		// wac neut
		data.WacNeut = data.WacNeut || {};
		data.CdcEnabled = !!data.CDC;
		var wacNeutNdcList = Array.isArray(data.WacNeut.NDCFeeList) ? data.WacNeut.NDCFeeList : [];
		if(!!data.CdcEnabled && wacNeutNdcList.length > 0) {

			// add validation properties
			for(var wn = 0; wn < wacNeutNdcList.length; wn++) {
				wacNeutNdcList[wn].fail = '';
				wacNeutNdcList[wn].msg = '';
			}
		}

		// PCC private care card
		data.PCC = data.PCC || {};
		var pccSavedItems = [];
		if(!!data.PCC.Enabled && Array.isArray(data.PCC.Items)) {
			var pccItems = data.PCC.Items;
			var	pccItem = {},
				dtNow = Date.now();
			dtNow = dtNow.toString();
			for(i = 0; i < pccItems.length; i++) {
				pccItem = pccItems[i];
				pccSavedItems.push({
					Id: dtNow + i.toString(),
					BIN: validSvc.newProp(pccItem.BIN),
					PCN: validSvc.newProp(pccItem.PCN),
					GroupNumber: validSvc.newProp(pccItem.GroupNumber),
					fail: '',
					msg: ''
				});
			}
		}
		// Drop ship
		data.DropShip = data.DropShip || {};
		data.DropShipParent = data.DropShipParent || {};

		// address
		var address = data.Address || {};


		// data exports
		var dx = !!data.DataExports && !!data.DataExports.Enabled ? data.DataExports : {};
		
		// verisave fee model
		var vsModelIsFlat = data.FeeVerisaveModel == 'FLAT',
			vsModelIsPercent = data.FeeVerisaveModel == 'PERCENTAGESAVINGS';

		var m = {
			Clone: false,
			ClonedFrom: '',
			Id: validSvc.newProp(nickname),
			AcctId: validSvc.newProp(validSvc.isText(data.AcctId) ? data.AcctId : ''),
			DivisionCode: validSvc.newProp(validSvc.isText(data.DivisionCode) ? data.DivisionCode : ''),
			StoreNumber: validSvc.newProp(validSvc.isText(data.StoreNumber) ? data.StoreNumber : ''),
			DailyTotalPackageLimit: validSvc.newProp(validSvc.isInteger(parseInt(data.DailyTotalPackageLimit, 10)) ? parseInt(data.DailyTotalPackageLimit, 10) : 0),
			DailyNDCPackageLimit: validSvc.newProp(validSvc.isInteger(parseInt(data.DailyNDCPackageLimit, 10)) ? parseInt(data.DailyNDCPackageLimit, 10) : 0),
			DailyRefrigeratedPackageLimit: validSvc.newProp(validSvc.isInteger(parseInt(data.DailyRefrigeratedPackageLimit, 10)) ? parseInt(data.DailyRefrigeratedPackageLimit, 10) : 0),

			BusinessModels: validSvc.newProp(''), // used for 422 only, models are split into "hasModel" properties below
			RxBizModels: bizModels, // used by affiliation code to look up what rx models are supported
			hasCP: bizModels.indexOf('CP') > -1,
			hasCPTPA: bizModels.indexOf('CPTPA') > -1,
			hasSPLIT: bizModels.indexOf('SPLIT') > -1,
			hasSPLITMATCH: bizModels.indexOf('SPLITMATCH') > -1,

			TpaProgAdmin: validSvc.newProp(validSvc.isText(tpaConfig.ProgAdmin) ? tpaConfig.ProgAdmin : ''),
			TpaPriceModel: validSvc.newProp(validSvc.isText(tpaConfig.PriceModel) ? tpaConfig.PriceModel : ''),
			TpaPriceRate: validSvc.newProp(validSvc.isNumber(tpaConfig.PriceRate) ? tpaConfig.PriceRate : 0),
			TpaExtractDispenses: !!tpaConfig.ExtractDispenses ? 'yes' : 'no',

			UseGlobalNDCExcludeList: tpaConfig.UseGlobalNDCExcludeList ===false ? 'no': 'yes',
			TpaExtractDelay: validSvc.newProp(validSvc.isNumber(tpaConfig.ExtractDelay) ? tpaConfig.ExtractDelay : 0),
			TpaExtractExcludeNdc: validSvc.newProp(),
			TpaExtractExcludeNdcList: extracts,

			Type: validSvc.newProp(rxType),
			ObjectState: validSvc.isText(data.ObjectState) ? data.ObjectState : 'ONBOARDING',
			Name: validSvc.newProp(validSvc.isText(data.Name) ? data.Name : ''),
			ShortName: validSvc.newProp(validSvc.isText(data.ShortName) ? data.ShortName : nickname),

			NPI: validSvc.newProp(validSvc.isText(data.NPI) ? data.NPI : ''),
			NCPDP: validSvc.newProp(validSvc.isText(data.NCPDP) ? data.NCPDP : ''),

			DispensePoolLoad: dispPoolLoad ? 'yes' : 'no',
			VCentralFileLoad: vcentralFileLoad ? 'yes': 'no',
			VHubEnabled: vhub ? 'yes' : 'no',
			VCentralEnabled: vcentral ? 'yes' : 'no',
			VCentralPharmacyId: !!data.VCentral ? validSvc.newProp(data.VCentral.PharmacyId):validSvc.newProp(),

			RollupPricingCanOverride: rollupPricingCanOverride ? 'yes' : 'no',
			RollupPricingModel: validSvc.newProp(validSvc.isText(data.RollupPricing.Model) ? data.RollupPricing.Model : ''),
			RollupPricingRate: validSvc.newProp(validSvc.isNumber(data.RollupPricing.Rate) ? data.RollupPricing.Rate : 0.0),

			PricingEnabled: bizModels.indexOf('CP') > -1 ? 'yes' : 'no',
			PricingOverridden: pricingOverridden ? 'yes' : 'no',
			PricingCanOverride: pricingCanOverride ? 'yes' : 'no',
			PricingModel: validSvc.newProp(validSvc.isText(data.Pricing.Model) ? data.Pricing.Model : ''),
			PricingRate: validSvc.newProp(validSvc.isNumber(data.Pricing.Rate) ? data.Pricing.Rate : 0.0),
			ReferencePriceProxy: !!data.ReferencePriceProxy ? 'yes' : 'no',

			BillEnabled: !!data.Billing.Enabled ? 'yes' : 'no',
			BillOverride: !!data.Billing.CanOverride ? 'yes' : 'no',
			BillFrequency: validSvc.newProp(validSvc.isText(data.Billing.Frequency) ? data.Billing.Frequency : ''),
			BillExport: !!data.Billing.Export ? 'yes' : 'no',
			BillExportDetailedRollup: !!data.Billing.ExportDetailedRollup ? 'yes' : 'no',
			BillExportFees: !!data.Billing.ExportFees ? 'yes' : 'no',
			BillExportDrugCost: !!data.Billing.ExportDrugCost ? 'yes' : 'no',
			BillPayTpaDirect: validSvc.newProp(billPayTpaList.length > 0 ? 'yes' : 'no'),
			BillPayTpaDirectList: billPayTpaList,

			DataSwitch: validSvc.newProp(validSvc.isText(data.DataSwitch) ? data.DataSwitch.toUpperCase() : 'NONE'),

			Accumulate: data.Accumulate === false ? 'no' : 'yes', // default is true if undefined
			AccumulationDelay: validSvc.newProp(validSvc.isNumber(data.AccumulationDelay) ? data.AccumulationDelay : 0),
			DelayByMatchDate: !!data.DelayByMatchDate ? 'yes' :'no',
			ExcludeDropShip: data.DropShip.DropShipOrderable === false ? 'yes' : 'no',

			DropShipCanOverride: !!data.DropShip.CanOverride ? 'yes' : 'no',
			DropShipOverridden: !!data.DropShip.Overridden ? 'yes' : 'no',
			DropShipExclude: data.DropShip.DropShipOrderable === false ? 'yes' : 'no',
			DropShipParentCanOverride: !!data.DropShipParent.CanOverride ? 'yes' : 'no',
			DropShipParentExclude: data.DropShipParent.DropShipOrderable === false ? 'YES' : 'NO',

			ExtractNpis: !!data.ExtractNpis ? 'yes' : 'no',
			ExtractNpisVisitLookback: validSvc.newProp(lookBack),
			MergeRollupsNpis: !!data.MergeNpis ? 'yes' : 'no',
			MergeNpiInto: validSvc.newProp(validSvc.isText(data.MergeNpiInto) ? data.MergeNpiInto.toUpperCase() : 'NONE'),

			SharedFormularyProvider: !!data.SharedFormularyProvider ? 'yes' : 'no',
			CustomPriceVendor: validSvc.newProp(validSvc.isText(data.CustomPriceVendor) ? data.CustomPriceVendor : 'NONE'),
			CustomPriceVendorAccountNumber: validSvc.newProp(validSvc.isText(data.CustomPriceVendorAccountNumber) ? data.CustomPriceVendorAccountNumber : ''),
			CustomPriceAccumGrp: validSvc.newProp(validSvc.isText(data.CustomPriceAccumGrp) ? data.CustomPriceAccumGrp : ''),
			CustomPriceVendorOrderConfig: validSvc.isText(data.CustomPriceVendorOrderConfig) ? data.CustomPriceVendorOrderConfig : '',

			Governor: !!data.Governor ? 'yes' : 'no',
			GenericGrouping: !!data.GenericGrouping ? 'yes' : 'no',
			GovernedGPIs: gpiGovList,
			GpiConstraints : validSvc.isText(data.GpiConstraints) ? data.GpiConstraints : 'ALL',

			SeqSplitStatus: seqSplitStatus,
			SeqUseCEOrder: !!data.SeqUseCEOrder,
			SeqCEs: seqCeList,
			SeqAllowAltVendorSplit: !!data.SeqAllowAltVendorSplit ? 'yes' : 'no',
			SeqAltVendorAccounts: seqAltAccountsList,
			SeqSendForReview: !!data.SeqSendForReview ? 'yes' : 'no',
			SeqPriceSelectWAC: !!data.SeqPriceSelectWAC ? 'yes' : 'no',
			SeqPriceSelWACEqualGPO: !!data.SeqPriceSelWACEqualGPO ? 'yes' : 'no',
			SeqUseBestCost: !!data.SeqUseBestCost ? 'yes' : 'no',
			SeqBestCostAllowGeneric: !!data.SeqBestCostAllowGeneric ? 'yes' : 'no',
			SeqAllowBulkItemForUnitDose: !!data.SeqAllowBulkItemForUnitDose ? 'yes' : 'no',
			SeqAllowUnitDoseForBulkItem: !!data.SeqAllowUnitDoseForBulkItem ? 'yes' : 'no',
			SeqVerisaveUseATP: !!data.SeqVerisaveUseATP ? 'yes' : 'no',

			// address
			AddressLine1: validSvc.newProp(validSvc.isText(address.Line1) ? address.Line1 : ''),
			AddressLine2: validSvc.newProp(validSvc.isText(address.Line2) ? address.Line2 : ''),
			AddressCity: validSvc.newProp(validSvc.isText(address.City) ? address.City : ''),
			AddressState: validSvc.newProp(validSvc.isText(address.State) ? address.State : 'NONE'),
			AddressZip: validSvc.newProp(validSvc.isText(address.Zip) ? address.Zip : ''),

			// Formula Restrictions
			SeqBestCostPckSizeSubstitution: !!data.SeqBestCostPckSizeSubstitution ? 'yes' : 'no',
			SeqBestCostPckFormSubstitution: !!data.SeqBestCostPckFormSubstitution ? 'yes' : 'no',
			SeqBestCostAllowBforG: !!data.SeqBestCostAllowBforG ? 'yes': 'no',
			SeqBestCostAllowGforB: !!data.SeqBestCostAllowGforB ? 'yes': 'no',
			SeqVerisaveExcludeCount: validSvc.isNumber(data.SeqVerisaveExcludeCount) ? data.SeqVerisaveExcludeCount : 0,
			SeqVerisaveNeverSwitchToCount: validSvc.isNumber(data.SeqVerisaveNeverSwitchToCount) ? data.SeqVerisaveNeverSwitchToCount : 0,
			SeqVerisavePreferredCount: validSvc.isNumber(data.SeqVerisavePreferredCount) ? data.SeqVerisavePreferredCount : 0,
			NdcOptimizerExcludeCount : validSvc.isNumber(data.NdcOptimizerExcludeCount) ? data.NdcOptimizerExcludeCount : 0,

			SeqCombine855s: !!data.SeqCombine855s ? 'yes' : 'no',
			SeqTimeout855s: validSvc.newProp(seqTmo),
			SeqPreSplitRequired: !!data.SeqPreSplitRequired ? 'yes' : 'no',
			SeqPreSplitTimeout: validSvc.newProp(pretmout),
			SeqPreSplitTimeoutAction: data.SeqPreSplitTimeoutAction == 'CANCEL' ? 'CANCEL' : 'SPLIT',
			SeqPreSplitDisableVerisave: !!data.SeqPreSplitDisableVerisave,
			SeqApprovalRequired: !!data.SeqApprovalRequired ? 'yes' : 'no',
			SeqApprovalRequiredAllOrders: !!data.SeqApprovalRequiredAllOrders ? 'yes' : 'no',
			SeqApprovalTimeout: validSvc.newProp(apptmout),
			SeqApprovalTimeoutAction: data.SeqApprovalTimeoutAction == 'CANCEL' ? 'CANCEL' : 'PLACE',
			SeqRemoveOrderSuffix : !!data.SeqRemoveOrderSuffix ? 'yes' : 'no',

			DispFullAllocOnly: !!data.DispFullAllocOnly ? 'yes' : 'no', // default is false if undefined

			CentralFillPharmacy: validSvc.isText(data.CentralFillPharmacy) ? data.CentralFillPharmacy : '',
			CentralFillRxList: Array.isArray(data.CentralFillRxList) ? data.CentralFillRxList : [],
			CentralFillNdcList: Array.isArray(data.CentralFillNdcList) ? data.CentralFillNdcList : [],

			VenAff: Array.isArray(data.VenAff) ? data.VenAff : [],
			CeAff: Array.isArray(data.CeAff) ? data.CeAff : [],

			RollupParent: validSvc.isText(data.RollupParent) ? data.RollupParent : '',
			RollupRxList: Array.isArray(data.RollupRxList) ? data.RollupRxList.sort() : [],

			SpecialtyNdcListCount: validSvc.isInteger(data.SpecialtyNdcListCount) ? parseInt(data.SpecialtyNdcListCount) : 0,

			CostCenter: validSvc.newProp(validSvc.isText(data.CostCenter) ? data.CostCenter : ''),
			CdcEnabled: validSvc.newProp(!!data.CdcEnabled ? 'yes' : 'no'),
			WacNeutFeeModel: validSvc.newProp(validSvc.isText(data.WacNeut.FeeModel) ? data.WacNeut.FeeModel : 'TRANS'),
			WacNeutFee: validSvc.newProp(validSvc.isNumber(data.WacNeut.Fee) ? data.WacNeut.Fee : 0),
			WacNeutNdcFeeModel: validSvc.newProp(validSvc.isText(data.WacNeut.NdcFeeModel) ? data.WacNeut.NdcFeeModel : 'TRANS'),
			WacNeutNdcFeeList: wacNeutNdcList,

			SendOrderstoExtParty: !!data.SendOrderstoExtParty ? 'yes' : 'no',
			SeqExtPartyFolder: validSvc.newProp(validSvc.isText(data.SeqExtPartyFolder) ? data.SeqExtPartyFolder : ''),

			Federate850s: !!data.AllowFederate850sToCE ? 'yes' : 'no',
			Federate850sCEID: validSvc.isText(data.Federate850sCEID) ? data.Federate850sCEID : '',
			Federate850sFileExtX12: !!data.Federated850sToCEFileExtensionX12 ? 'yes' : 'no',
			Federate850sFail: '',

			PCC: validSvc.newProp(!!data.PCC.Enabled ? 'yes' : 'no'),
			PCCItems: pccSavedItems,
			ExportOrders: !!data.ExportOrders ? 'yes' : 'no',
			ExportManualOrders: !!data.ExportManualOrders ? 'yes' : 'no',
			ExportInvoice: !!data.ExportInvoice ? 'yes' : 'no',

			CeUserCanViewClaims: !!data.CeUserCanViewClaims ? 'yes' : 'no',
			MaskReimbursement: !!data.MaskReimbursement ? 'yes' : 'no',

			CreatedBy: validSvc.isText(data.CreatedBy) ? data.CreatedBy : '',
			CreatedOn: validSvc.isDate(data.CreatedOn) ? data.CreatedOn : null,
			ModifiedBy: validSvc.isText(data.ModifiedBy) ? data.ModifiedBy : '',
			ModifiedOn: validSvc.isDate(data.CreatedOn) ? data.CreatedOn : null,
			UseGenericList: !!data.UseGenericList ? 'yes' : 'no',
			UseSpecialtyList: !!data.UseSpecialtyList ? 'yes' : 'no',
			OrderInsiteOrdering: !!data.OrderInsiteOrdering ? 'yes' : 'no',
			ExportClaimsUsedForBackOrders: !!data.ExportClaimsUsedForBackOrders ? 'yes' : 'no',
			SharedAccums: !!data.SharedAccums ? 'yes' : 'no',
			AllowAltAccum: !!data.AllowAltAccum ? 'yes' : 'no',
			FederateRawClaims: validSvc.newProp(!!federateClaims ? 'yes' : 'no'),
			ImportRawClaims: validSvc.newProp(!!rawClaimsLoad ? 'yes' : 'no'),
			UseTpaNPIListForRawClaimsExport: validSvc.newProp(!!useTpaNPIListForRawClaimsExport ? 'yes' : 'no'),
			ExtractRealTimeBacking: !!data.ExtractRealTimeBacking ? 'yes' : 'no',

			// data exports
			EncryptionPublicKey: validSvc.newProp(validSvc.isText(data.KeyStr) ? data.KeyStr : ''),
			DataExportsEnabled: !!dx.Enabled ? 'yes' : 'no',
			DataExportsAccum: !!dx.Enabled && !!dx.Accum ? 'yes' : 'no',
			DataExportsMatches: !!dx.Enabled && !!dx.Matches ? 'yes' : 'no',
			DataExportsMatchesPHI: !!dx.Enabled && !!dx.Matches && !!dx.MatchesPHI ? 'yes' : 'no',
			DataExportsSchedule: !!dx.Enabled ? schedulerVM(dx.Schedule) : schedulerVM(),
			DataExportsScheduleErr: '',

			// verisave fees
			FeeVerisaveModel: vsModelIsFlat || vsModelIsPercent ? data.FeeVerisaveModel : '',
			FeeVerisaveFlat: validSvc.newProp(vsModelIsFlat && validSvc.isNumber(data.FeeVerisaveFlat) ? parseFloat(data.FeeVerisaveFlat) : 0.00),
			FeeVerisaveOrderPercent: validSvc.newProp(vsModelIsPercent && validSvc.isNumber(data.FeeVerisaveOrderPercent) ? parseFloat(data.FeeVerisaveOrderPercent) : 0.00),
			FeeVerisaveOrderPercentMinAmt: validSvc.newProp(vsModelIsPercent && validSvc.isNumber(data.FeeVerisaveOrderPercentMinAmt) ? parseFloat(data.FeeVerisaveOrderPercentMinAmt) : 0.00),
			FeeVerisaveOrderPercentMaxAmt: validSvc.newProp(vsModelIsPercent && validSvc.isNumber(data.FeeVerisaveOrderPercentMaxAmt) ? parseFloat(data.FeeVerisaveOrderPercentMaxAmt) : 0.00),
		};
		
		// dispense expiration
		var dispExp = data.DispenseExpiration || {};
		dispExp.CanOverride = !!dispExp.CanOverride ? 'yes' : 'no';
		dispExp.Overridden = !!dispExp.Overridden ? 'yes' : 'no';
		dispExp.Enabled = !!dispExp.Enabled ? 'yes' : 'no';
		dispExp.ParentsAllowOverride = !!dispExp.ParentsAllowOverride ? 'yes' : 'no';
		dispExp.ParentEnabled = !!dispExp.ParentEnabled ? 'yes' : 'no';
		dispExp.OverrideParent = !!dispExp.OverrideParent ? 'yes' : 'no';
		m.DispenseExpiration = dispExp;

		data.AccumDelay = data.AccumDelay || {};
		data.AccumDelayParent = data.AccumDelayParent || {};
		m.AccumDelay = data.AccumDelay;
		m.AccumDelay.CanOverride = !!data.AccumDelay.CanOverride ? 'yes' : 'no';
		m.AccumDelay.Delay = validSvc.newProp(validSvc.isNumber(data.AccumDelay.Delay) ? data.AccumDelay.Delay : 0);
		m.AccumDelay.Overridden = !!data.AccumDelay.Overridden ? 'yes' : 'no';
		//parent
		m.AccumDelayParent = data.AccumDelayParent;
		m.AccumDelayParent.CanOverride = !!data.AccumDelayParent.CanOverride ? 'yes' : 'no';
		m.AccumDelayParent.Delay = validSvc.newProp(validSvc.isNumber(data.AccumDelayParent.Delay) ? data.AccumDelayParent.Delay : 0);
		// set AMERISOURCE default if empty
		if(m.CustomPriceVendor.val == 'AMERISOURCE') {
			m.CustomPriceVendorOrderConfig = 'ABCOrder';
		}

		// verisave percent fee checkmarks
		if(vsModelIsPercent) {
			m.FeeVerisaveOrderPercentMinAmt.chk = m.FeeVerisaveOrderPercent.val > 0 && m.FeeVerisaveOrderPercentMinAmt.val > 0;
			if(!m.FeeVerisaveOrderPercentMinAmt.chk) {
				m.FeeVerisaveOrderPercentMinAmt.val = 0;
			}
			m.FeeVerisaveOrderPercentMaxAmt.chk = m.FeeVerisaveOrderPercent.val > 0 && m.FeeVerisaveOrderPercentMaxAmt.val > 0;
			if(!m.FeeVerisaveOrderPercentMaxAmt.chk) {
				m.FeeVerisaveOrderPercentMaxAmt.val = 0;
			}	
		}

		return m;

	}

	function schedulerVM(schedule) {
		// build data export schedule structure, widget will convert to validation properties later
		schedule = schedule || {};

        return {
			Enabled: 'on', // used for UI widget data exports
            Type: validSvc.isText(schedule.Type) ? schedule.Type : 'MONTH',
			MonthOption: validSvc.isText(schedule.MonthOption) ? schedule.MonthOption : 'MONTH-DAY',
			DayOfMonth : validSvc.isNumber(schedule.DayOfMonth) ? parseInt(schedule.DayOfMonth) : 1,
			WeekOfMonth : validSvc.isNumber(schedule.WeekOfMonth) ? parseInt(schedule.WeekOfMonth) : 0,
			Occurs : validSvc.isNumber(schedule.Occurs) ? parseInt(schedule.Occurs) : 0,
            Weekdays: Array.isArray(schedule.Days) ? schedule.Days : [],
			fail: ''
        };
    }

	function dataExportAPI(model) {

		// data exports
		var dxEnabled = model.DataExportsEnabled == 'yes',
			dxAccum = model.DataExportsAccum == 'yes',
			dxMatches = model.DataExportsMatches == 'yes',
			dxMatchesPHI = model.DataExportsMatchesPHI == 'yes';

		return {
			Enabled: dxEnabled,
			Accum: dxEnabled && dxAccum,
			Matches: dxEnabled && dxMatches,
			MatchesPHI: dxEnabled && dxMatches && dxMatchesPHI,
			Schedule: dxEnabled ? schedulerAPI(model.DataExportsSchedule) : {}
		};
	}

	function schedulerAPI(model) {
		return {
			Type: model.Type,
			MonthOption: model.MonthOption,
			DayOfMonth: model.DayOfMonth,
			WeekOfMonth: model.WeekOfMonth,
			Occurs: model.Occurs,
			Days: model.Weekdays
		};
	}


	/**
	 *    EDIT METHODS
	 */

	function createAcct(model) {
		return upsert('admin/rx/create', model);
	}

	function updateAcct(model) {
		return upsert('admin/rx/update', model);
	}

	function saveAddress(model) {
		return upsert('admin/rx/address', model);
	}

	function upsert(purl, model) {

		_currentPurl = purl;
		_modelPending = model;
		var defer = $q.defer();
		var i = 0;

		// tpa extracts NDC list
		var tpaNdc = Array.isArray(model.TpaExtractExcludeNdcList) ? model.TpaExtractExcludeNdcList : [],
			extracts = [];
		for(i = 0; i < tpaNdc.length; i++) {
			extracts.push(tpaNdc[i].val);
		}

		// look back sent as 0 if false
		var lookBack = model.ExtractNpis == 'yes' ? parseInt(model.ExtractNpisVisitLookback.val) : 0;

		// gpi list
		var gpiGovList = [];
		for(var g = 0; g < model.GovernedGPIs.length; g++) {
			gpiGovList.push(model.GovernedGPIs[g].val);
		}

		var bizModels = ['NONE'];  // always add NONE
		if(!!model.hasCP) {
			bizModels.push('CP');
		}
		if(!!model.hasCPTPA) {
			bizModels.push('CPTPA');
		}
		if(!!model.hasSPLIT) {
			bizModels.push('SPLIT');
		}
		if(!!model.hasSPLITMATCH) {
			bizModels.push('SPLITMATCH');
		}

		// seq ce list
		var seqCeList = [];
		for(var sq = 0; sq < model.SeqCEs.length; sq++) {
			seqCeList.push(model.SeqCEs[sq].val);
		}

		// seq accounts list
		var seqAltAccountsList = [];
		for(var aa = 0; aa < model.SeqAltVendorAccounts.length; aa++) {
			seqAltAccountsList.push(model.SeqAltVendorAccounts[aa]);
		}
		
		var cloneFromId = !!model.Clone ? model.ClonedFrom : '';

		// wac neut fee list
		var wacNeutNdcList = Array.isArray(model.WacNeutNdcFeeList) ? model.WacNeutNdcFeeList : [];
		for(var wn = 0; wn < wacNeutNdcList.length; wn++) {
			wacNeutNdcList[wn].Fee = parseFloat(wacNeutNdcList[wn].Fee);
		}

		// reset validation on PCC items
		var pccItems = [],
			savePccItems = [],
			pccItem = {};
		model.PCC.fail = '';
		model.PCC.msg = '';
		if(model.PCC.val == 'yes') {
			pccItems = model.PCCItems;
			for(i = 0; i < pccItems.length; i++) {
				pccItem = pccItems[i];
				pccItem.fail = '';
				pccItem.msg = '';
				pccItem.BIN.fail = '';
				pccItem.PCN.fail = '';
				pccItem.GroupNumber.fail = '';

				savePccItems.push({
					Id: pccItem.Id,
					BIN: pccItem.BIN.val,
					PCN: pccItem.PCN.val,
					GroupNumber: pccItem.GroupNumber.val
				});
			}
		}

		// dispense expiration
		var dispExp = model.DispenseExpiration;
		var maxDispAge = parseInt(dispExp.MaxDispenseAge);

		var isRollup = model.Type.val == 'ROLLUP';
		var isRollupVHUB = isRollup && model.VHubEnabled == 'yes';

		// verisave fee model
		var vsModelIsFlat = model.FeeVerisaveModel == 'FLAT',
			vsModelIsPercent = model.FeeVerisaveModel == 'PERCENTAGESAVINGS';
	
		var apiRequest = {
			Entity: {
				ClonedFrom: cloneFromId,
				Id: model.Id.val,
				AcctId: model.AcctId.val,
				DivisionCode: model.DivisionCode.val,
				StoreNumber: model.StoreNumber.val,
				DailyTotalPackageLimit: parseInt(model.DailyTotalPackageLimit.val, 10),
				DailyNDCPackageLimit: parseInt(model.DailyNDCPackageLimit.val, 10),
				DailyRefrigeratedPackageLimit: parseInt(model.DailyRefrigeratedPackageLimit.val, 10),
				BusinessModels: bizModels,
				Type: model.Type.val,

				TpaConfig: {
					ProgAdmin: model.TpaProgAdmin.val,
					PriceModel: model.TpaPriceModel.val,
					PriceRate: parseFloat(model.TpaPriceRate.val),
					ExtractDispenses: model.TpaExtractDispenses == 'yes',
					UseGlobalNDCExcludeList: model.UseGlobalNDCExcludeList == 'yes',
					ExtractDelay: parseFloat(model.TpaExtractDelay.val),
					ExtractExcludeNDCs: extracts,
				},

				Name: model.Name.val,
				BillAddTitle: model.Name.val,
				ShortName: model.ShortName.val,
				NPI: model.NPI.val,
				NCPDP: model.NCPDP.val,

				Pricing: {
					CanOverride: model.PricingCanOverride == 'yes',
					Overridden: model.PricingOverridden == 'yes',
					Model: model.PricingModel.val,
					Rate: parseFloat(model.PricingRate.val)
				},

				Billing: {
					Enabled: model.BillEnabled == 'yes',
					CanOverride: model.BillOverride == 'yes',
					Frequency: model.BillFrequency.val,
					Export: model.BillExport == 'yes',
					ExportDetailedRollup: model.BillExportDetailedRollup == 'yes',
					ExportFees: model.BillExportFees == 'yes',
					ExportDrugCost: model.BillExportDrugCost == 'yes',
					PayTpaDirectList: isRollupVHUB && model.BillPayTpaDirect.val == 'yes' ? model.BillPayTpaDirectList : []		
				},

				DispenseExpiration: {
					Enabled: dispExp.Enabled == 'yes' && maxDispAge > 0,
					OverrideParent : dispExp.OverrideParent == 'yes',
					CanOverride: dispExp.CanOverride == 'yes',
					MaxDispenseAge: maxDispAge
				},

				DispensePoolLoad: model.DispensePoolLoad == 'yes',
				VCentralFileLoad: model.VCentralFileLoad == 'yes',
				VHub: {
					Enabled: model.VHubEnabled == 'yes',
				},

				VCentral: {
					Enabled: model.VCentralEnabled == 'yes',
					PharmacyId: model.VCentralPharmacyId.val
				},

				Accumulate: model.Accumulate == 'yes',
				DelayByMatchDate: model.DelayByMatchDate == 'yes',
				AccumulationDelay: parseInt(model.AccumulationDelay.val),
				AccumDelay : { 
					Overridden : model.AccumDelay.Overridden =='yes',
					CanOverride: model.AccumDelay.CanOverride =='yes',
					Delay: parseInt(model.AccumDelay.Delay.val),
				},
				
				DropShip : { 
					Overridden : model.DropShipOverridden =='yes',
					CanOverride: model.DropShipCanOverride =='yes',
					DropShipOrderable: model.DropShipExclude =='no',
				},

				Address: {
					Line1: model.AddressLine1.val,
					Line2: model.AddressLine2.val,
					City: model.AddressCity.val,
					State: model.AddressState.val == 'NONE' ? '' : model.AddressState.val,
					Zip: model.AddressZip.val
				},
				
				ExtractNpis: model.ExtractNpis == 'yes',
				ExtractNpisVisitLookback: lookBack,
				MergeNpis: model.MergeRollupsNpis == 'yes',
				MergeNpiInto: model.MergeNpiInto.val != 'NONE' ? model.MergeNpiInto.val : '',

				SharedFormularyProvider: model.SharedFormularyProvider == 'yes',

				CustomPriceVendor: model.CustomPriceVendor.val != 'NONE' ? model.CustomPriceVendor.val : '',
				CustomPriceVendorAccountNumber: model.CustomPriceVendorAccountNumber.val,
				CustomPriceAccumGrp: model.CustomPriceAccumGrp.val,
				CustomPriceVendorOrderConfig: model.CustomPriceVendorOrderConfig,

				Governor: model.Governor == 'yes',
				GenericGrouping: model.Governor == 'yes' && model.GenericGrouping == 'yes', // governor must be true
				GovernedGPIs: gpiGovList,
				GpiConstraints: model.GpiConstraints,
				ReferencePriceProxy: model.ReferencePriceProxy == 'yes',

				SequentialSplitting: model.SeqSplitStatus == 'on',
				SeqUseCEOrder: !!model.SeqUseCEOrder,
				SeqCEs: seqCeList,
				SeqAllowAltVendorSplit: model.SeqAllowAltVendorSplit == 'yes',
				SeqAltVendorAccounts: seqAltAccountsList,
				SeqSendForReview: model.SeqSendForReview == 'yes',
				SeqPriceSelectWAC: model.SeqPriceSelectWAC == 'yes',
				SeqPriceSelWACEqualGPO: model.SeqPriceSelWACEqualGPO == 'yes',
				SeqUseBestCost: model.SeqUseBestCost == 'yes',
				SeqBestCostAllowGeneric: model.SeqBestCostAllowGeneric == 'yes',
				SeqBestCostPckSizeSubstitution: model.SeqBestCostPckSizeSubstitution == 'yes',
				SeqBestCostPckFormSubstitution: model.SeqBestCostPckFormSubstitution == 'yes',
				SeqBestCostAllowBforG: model.SeqBestCostAllowBforG == 'yes',
				SeqBestCostAllowGforB: model.SeqBestCostAllowGforB == 'yes',
				SeqAllowBulkItemForUnitDose: model.SeqAllowBulkItemForUnitDose == 'yes',
				SeqAllowUnitDoseForBulkItem: model.SeqAllowUnitDoseForBulkItem == 'yes',
				SeqVerisaveUseATP: model.SeqVerisaveUseATP == 'yes',

				SeqCombine855s: model.SeqCombine855s == 'yes',
				SeqTimeout855s: parseInt(model.SeqTimeout855s.val),
				SeqPreSplitRequired: model.SeqPreSplitRequired == 'yes',
				SeqPreSplitTimeout: parseInt(model.SeqPreSplitTimeout.val),
				SeqPreSplitTimeoutAction: model.SeqPreSplitTimeoutAction,
				SeqPreSplitDisableVerisave: !! model.SeqPreSplitDisableVerisave,
				SeqApprovalRequired: model.SeqApprovalRequired == 'yes',
				SeqApprovalRequiredAllOrders: model.SeqApprovalRequiredAllOrders == 'yes',
				SeqApprovalTimeout: parseInt(model.SeqApprovalTimeout.val),
				SeqApprovalTimeoutAction: model.SeqApprovalTimeoutAction,
				SeqRemoveOrderSuffix: model.SeqRemoveOrderSuffix =='yes',


				FilterMedicaid: false,
				ExportOrders: model.ExportOrders=='yes',
				ExportManualOrders: model.ExportManualOrders=='yes',
				ExportInvoice: model.ExportInvoice == 'yes',

				DispFullAllocOnly: model.DispFullAllocOnly == 'yes',

				CostCenter: model.CostCenter.val,
				CDC: model.CdcEnabled.val == 'yes',
				WacNeut: {
					FeeModel: model.WacNeutFeeModel.val,
					Fee: parseFloat(model.WacNeutFee.val),
					NdcFeeModel: model.WacNeutNdcFeeModel.val,
					NDCFeeList: wacNeutNdcList
				},
				
				SendOrderstoExtParty: model.SendOrderstoExtParty == 'yes',
				SeqExtPartyFolder: model.SeqExtPartyFolder.val,

				AllowFederate850sToCE: model.Federate850s == 'yes',
				Federate850sCEID: validSvc.isText(model.Federate850sCEID) ? model.Federate850sCEID : '',
				Federated850sToCEFileExtensionX12: model.Federate850sFileExtX12 == 'yes',

				PCC: {
					Enabled: model.PCC.val == 'yes',
					Items: savePccItems
				},
				CeUserCanViewClaims: model.CeUserCanViewClaims == 'yes',
				MaskReimbursement: model.MaskReimbursement == 'yes',
				OrderInsiteOrdering: model.OrderInsiteOrdering == 'yes',
				UseGenericList: model.UseGenericList == 'yes',
				UseSpecialtyList: model.UseSpecialtyList == 'yes',
				ExportClaimsUsedForBackOrders: model.ExportClaimsUsedForBackOrders == 'yes',
				SharedAccums: model.SharedAccums == 'yes',
				AllowAltAccum: isRollup && model.hasCP && model.AllowAltAccum == 'yes',
				ImportRawClaims: model.ImportRawClaims.val == 'yes',
				FederateRawClaims: model.FederateRawClaims.val == 'yes',
				UseTpaNPIListForRawClaimsExport: model.UseTpaNPIListForRawClaimsExport.val == 'yes',
				ExtractRealTimeBacking: model.ExtractRealTimeBacking == 'yes',

				// data exports
				KeyStr: validSvc.isText(model.EncryptionPublicKey.val) ? model.EncryptionPublicKey.val : '',
				DataExports: dataExportAPI(model),

				FeeVerisaveModel: vsModelIsFlat || vsModelIsPercent ? model.FeeVerisaveModel : '',
				FeeVerisaveFlat: vsModelIsFlat ? parseFloat(model.FeeVerisaveFlat.val) : 0,
				FeeVerisaveOrderPercent: vsModelIsPercent ? parseFloat(model.FeeVerisaveOrderPercent.val) : 0,
				FeeVerisaveOrderPercentMinAmt: vsModelIsPercent && model.FeeVerisaveOrderPercent.val > 0 ? parseFloat(model.FeeVerisaveOrderPercentMinAmt.val) : 0,
				FeeVerisaveOrderPercentMaxAmt: vsModelIsPercent && model.FeeVerisaveOrderPercent.val > 0 ? parseFloat(model.FeeVerisaveOrderPercentMaxAmt.val) : 0
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(upsertOk, upsertErr);


		function upsertOk(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update affiliations
			refreshUserSilent();

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function upsertErr(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapApiErrorsToModel(r, _modelPending);
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				if(fieldName.substr(0,4) == 'GPI_') {

					// GPI list error
					fieldName = fieldName.toUpperCase();

					// find this gpi the model
					var gpiList = m.GovernedGPIs,
						foundGpi = false;

					// loop, prefix "GPI_" is added
					for(var g = 0; g < gpiList.length; g++) {
						if('GPI_' + gpiList[g].val.toUpperCase() == fieldName) {
							gpiList[g].fail = 'yes';
							gpiList[g].msg = entity.Fields[i].Rule;
							foundGpi = true;
						}
					}

					if(!foundGpi) {
						throw new Error('rxRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
					}

				}
				else if(fieldName.substr(0,4) == 'SEQ_') {

					// sequential CE list error

					// find this ce
					var seqCeList = m.SeqCEs,
						foundSeqCE = false;

					// loop, prefix "SEQ_" is added
					for(var sq = 0; sq < seqCeList.length; sq++) {
						if('SEQ_' + seqCeList[sq].val.toUpperCase() == fieldName.toUpperCase()) {
							seqCeList[sq].fail = 'yes';
							seqCeList[sq].msg = entity.Fields[i].Rule;
							foundSeqCE = true;
							break;
						}
					}

					if(!foundSeqCE) {
						throw new Error('rxRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
					}

				}
				else if(fieldName.substr(0,14) == 'WN_NDCFEELIST_') {

					// wac neut ndc list error

					// find this ndc
					var wnList = model.WacNeutNdcFeeList,
						foundWN = false;

					for(var wn = 0; wn < wnList.length; wn++) {
						if('WN_NDCFEELIST_' + wnList[wn].NDC.toUpperCase() == fieldName.toUpperCase()) {
							wnList[wn].fail = 'yes';
							wnList[wn].msg = entity.Fields[i].Rule;
							model.CdcEnabled.fail = 'yes';
							model.CdcEnabled.msg = 'Ndc list has errors';
							foundWN = true;
							break;
						}
					}

					if(!foundWN) {
						throw new Error('rxRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
					}

				}
				else if(fieldName.substr(0,7) == 'TPANDC_') {

					// tpa extract ndc

					var ndcList = m.TpaExtractExcludeNdcList,
						foundNdc = false;

					// find failed ndc
					for(var ii = 0; ii < ndcList.length; ii++) {
						if('TPANDC_' + ndcList[ii].val == fieldName) {
							ndcList[ii].fail = 'yes';
							ndcList[ii].msg = entity.Fields[i].Rule;
							foundNdc = true;
						}
					}

					if(foundNdc) {
						// set extract parent failed state
						m.TpaExtractExcludeNdc.fail = 'yes';
						m.TpaExtractExcludeNdc.msg = 'invalid NDCs';
					}
					else {
						throw new Error('rxRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
					}
				}
				else if(fieldName.substr(0,4) == 'PCC_') {
					m.PCC.fail = 'yes';
					m.PCC.msg = 'check items for errors';

					// find failed PCC item
					var errSeg = fieldName.split('_');
					if(errSeg.length !== 3) {
						throw new Error('rxRepo.mapApiErrorsToModel, api 422 field PCC field needs three segments PCC_id_FieldName: ' + fieldName, _currentPurl, 422);
					}

					var pccId = errSeg[1],
						pccProp = errSeg[2],
						pccItems = model.PCCItems,
						pccItem = {},
						pccFound = false;

					for(var p = 0; p < pccItems.length; p++) {
						pccItem = pccItems[p];
						if(pccItem.Id == pccId) {
							pccItem[pccProp].fail = 'yes';
							pccItem[pccProp].msg = entity.Fields[i].Rule;
							pccFound = true;
						}
					}

					if(!pccFound) {
						throw new Error('rxRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
					}

				}
				else {

					// parse model for property name
					fieldObj = utilSvc.obj.findChildProp(m, fieldName);
					if(fieldObj === undefined) {
						throw new Error('rxRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
					}
					else {
						// set failed state
						fieldObj.fail = 'yes';
						fieldObj.msg = entity.Fields[i].Rule;
					}
				}

			}

			return m;

		}


		return defer.promise;
	}

	/**
	 *    STATUS CHANGE
	 */

	function statusChange(id, status) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('rxRepo.statusChange, id is missing');
		}

		// set purl
		switch(status) {

			case 'ONBOARDING':
				_currentPurl = 'admin/rx/status/onboarding';
				break;
			case 'ACTIVE':
				_currentPurl = 'admin/rx/status/active';
				break;
			case 'INACTIVE':
				_currentPurl = 'admin/rx/status/inactive';
				break;
			case 'DELETED':
				_currentPurl = 'admin/rx/status/deleted';
				break;

			default:
				throw new Error('rxRepo.statusChange, status unknown: ' + status);
		}

		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {},
			Entity: {
				Params: {
					Id: id
				}
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okStat, errStat);

		function okStat(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update affiliations
			refreshUserSilent();

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function errStat(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else {
				throw new Error('rxRepo.errStat, unexpected error result');
			}

		}


		return defer.promise;

	}


	/**
	 *    CENTRAL FILL MEMBERS
	 */

	function cfMemberAdd(rxid, member) {
		return cfMemberUpdate('admin/rx/centralfill/rxadd', rxid, member);
	}

	function cfMemberRemove(rxid, member) {
		return cfMemberUpdate('admin/rx/centralfill/rxremove', rxid, member);
	}

	function cfMemberUpdate(purl, rxid, member) {

		// params
		if(!validSvc.isRX(rxid) || !validSvc.isRX(member)) {
			throw new Error('rxRepo.cfMemberUpdate, rxid is missing or member id is missing');
		}

		_currentPurl = purl;
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {},
			Entity: {
				Params: {
					Id: rxid,
					MemberId: member
				}
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okCfMember, errCfMember);

		function okCfMember(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function errCfMember(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				throw new Error('rxRepo.errCfMember, unexpected error result');
			}

		}

		return defer.promise;

	}


	/**
	 *    ROLLUP MEMBERS
	 */

	function ruMemberAdd(rxid, member) {
		return ruMemberUpdate('admin/rx/rollup/rxadd', rxid, member);
	}

	function ruMemberRemove(rxid, member) {
		return ruMemberUpdate('admin/rx/rollup/rxremove', rxid, member);
	}

	function ruMemberUpdate(purl, rxid, member) {

		// params
		if(!validSvc.isRX(rxid) || !validSvc.isRX(member)) {
			throw new Error('rxRepo.ruMemberUpdate, rxid is missing or member id is missing');
		}

		_currentPurl = purl;
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {},
			Entity: {
				Params: {
					Id: rxid,
					MemberId: member
				}
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okRuMember, errRuMember);

		function okRuMember(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function errRuMember(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				throw new Error('rxRepo.errRuMember, unexpected error result');
			}

		}

		return defer.promise;

	}

}
 
rxEditCtl.$inject = ['$window', '$scope', '$state', '$timeout', 'rxRepo', 'npiRepo', 'vendorRepo', 'lookupRepo', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc'];
angular
.module('espui.admin.rx')
.controller('RxEditCtl', rxEditCtl);


/* @ngInject */
function rxEditCtl($window, $scope, $state, $timeout, rxRepo, npiRepo, vendorRepo, lookupRepo, validSvc, errSvc, utilSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _currentRX = '',
		_pendingStatus = '',
		_pendingNdcUpdate = {},
		_pendingMember = '',
		_previousNdcFilterText = '',
		_pagingEventListener = null,
		_ndcListListener = null,
		_genericListListener = null,
		_fileImportListener = null,
		_gpiListListener = null,
		_mouseLeaveDelay = {};

	// add CSS support
	vm.cssBtnStyle = utilSvc.css.btnStyle;
	vm.cssValidStyle = utilSvc.css.validStyle;

	// inherit sorting and paging features
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addMultiselect(vm);
	utilSvc.ctl.addFiltering(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.isWaiting = false;
	vm.action = '';
	vm.stateDroplist = [];
	vm.BaseVendorDroplist = [];
	vm.VendorDroplist = [];
	vm.BillFreqDroplist = [];
	vm.PricingModelDroplist = [];

	// models
	vm.context = {};
	vm.model = {};

	// tabs
	vm.activeTab = '';
	vm.tabChange = tabChange;
	vm.showTabCentralFill = false;
	vm.showTabRollup = false;
	vm.showTabAffs = false;

	// popup
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;

	// edit changes
	vm.btnStatusChange = {};
	vm.statusChange = statusChange;
	vm.rxTypeClick = rxTypeClick;
	vm.toggleVHub = toggleVHub;
	vm.toggleVCentral = toggleVCentral;

	// RX edit methods
	vm.submitAcct = submitAcct;

	// central fill: data and display
	vm.cfTabReady = false;

	// central fill: members
	vm.cfNewMemberDroplist = [];
	vm.cfNewMember = '';
	vm.cfMembersById = {};
	vm.cfMembersTbl = {};
	vm.cfMemberListTbl = {};
	vm.cfMemberListFlt = {};
	vm.cfMemberPicker = {};
	vm.cfMemberAdd = cfMemberAdd;
	vm.cfMemberAddSelected = cfMemberAddSelected;
	vm.cfMemberRemove = cfMemberRemove;
	vm.cfMemberToggle = cfMemberToggle;
	vm.cfMemberToggleAll = cfMemberToggleAll;
	vm.cfMemberSelectedCount = cfMemberSelectedCount;
	vm.cfMemberListFilterChange = cfMemberListFilterChange;

	// rollup members
	vm.ruTabReady = false;
	vm.ruNewMemberDroplist = [];
	vm.ruNewMember = '';
	vm.ruMemberAdd = ruMemberAdd;
	vm.ruMemberRemove = ruMemberRemove;

	vm.AddressStateDroplist = [];


	// ndc extract
	vm.extractNdcAdd = extractNdcAdd;
	vm.extractNdcRemove = extractNdcRemove;

	// GPI Governor
	vm.gpiGovNew = '';
	vm.gpiGovAdd = gpiGovAdd;
	vm.gpiGovRemove = gpiGovRemove;
	vm.gpiConstraintSelect = gpiConstraintSelect;
	vm.gpiGroupSelect = gpiGroupSelect;
	vm.purchaseHistorySelect = purchaseHistorySelect;

	// multiple biz models
	vm.bizModelsEdit = false;
	vm.bizModelsChecked = {};
	vm.bizModelsEditToggle = bizModelsEditToggle;
	vm.bizModelsCheck = bizModelsCheck;
	vm.bizModelsApply = bizModelsApply;
	vm.addModelsClick = addModelsClick;

	// Custom/Wholesale account
	vm.wholesaleAcctDroplist = [];
	vm.customPriceVendorChange = customPriceVendorChange;

	vm.resetVendorDroplists = resetVendorDroplists;

	// sequential splitting
	vm.seqSplitEdit = {};
	vm.seqSplitStatusChange = seqSplitStatusChange;
	vm.seqSplitAdd = seqCEsAdd;
	vm.seqSplitRemove = seqCEsRemove;
	vm.seqSplitPriority = seqCEsPriority;
	vm.seqSplitCombine855s = seqSplitCombine855s;
	vm.seqSplitEditAccounts = {};
	vm.seqSplitAddAccount = seqAltAccountAdd;
	vm.seqSplitRemoveAccount = seqAltAccountRemove;
	vm.seqSplitAccountsVendorDroplist = [];

	// clone
	vm.cloneRX = cloneRX;

	// wacneut
	vm.wacNeutEdit = {};
	vm.wacNeutSave = wacNeutSave;
	vm.wacNeutRemove = wacNeutRemove;

	// PCC
	vm.pccAddItem = pccAddItem;
	vm.pccRemoveItem = pccRemoveItem;

	//npi
	vm.toggleNpiImport = toggleNpiImport;
	vm.canImport = false;
	vm.importFiles = [];
	vm.importErrors = [];
	vm.importCounts = {};
	vm.importFile = importFile;
	vm.getNpiExcel = getNpiExcel;
	vm.RollupDroplist = [];

	vm.GpiConstraints = {};

	// ce user claim access
	vm.toggleCeUserCanViewClaims = toggleCeUserCanViewClaims;

	// ROLLUP pay tpa direct
	vm.TpaDirectMulti = {};
	vm.multiClick = multiClick;
	vm.multiToggle = multiToggle;
	vm.multiHover = multiHover;

	// Federate claims
	vm.toggleImportRawClaims = toggleImportRawClaims;

	// Use TPA NPI list for claims federation
	vm.toggleFederateRawClaims = toggleFederateRawClaims;

	// Federate 850s to CE
	vm.federate850sCeidDroplist = [];
	vm.toggleFederate850s = toggleFederate850s;

	// data exports
	vm.DataExportsSchedule = {};

	/**
	 *  EVENT LISTENERS
	 */

	_ndcListListener = $scope.$on('widget.ops.ndc.list.count', function(event, evtData) {
		event.stopPropagation();

		// event listener for ndc list widget changes

		// params
		evtData = evtData || {};
		if(!validSvc.isText(evtData.ListType) || !validSvc.isNumber(evtData.ItemsCount)) {
			throw new Error('rxEditCtl, ndc list event requires ListType, ItemsCount');
		}

		// update count
		switch(evtData.ListType) {
			case 'NDCOPTEXCLUDELIST':
				vm.model.NdcOptimizerExcludeCount = evtData.ItemsCount;
				break;
			default:
				throw new Error('rxEditCtl, ndc list event has unknown list type: ' + evtData.ListType);
		}

	});

	_gpiListListener = $scope.$on('widget.ops.gpi.list.count', function(event, evtData) {
		event.stopPropagation();

		// event listener for ndc list widget changes

		// params
		evtData = evtData || {};
		if(!validSvc.isText(evtData.ListType) || !validSvc.isNumber(evtData.ItemsCount)) {
			throw new Error('rxEditCtl, ndc list event requires ListType, ItemsCount');
		}

		// update count
		switch(evtData.ListType) {
			case 'GPIINCLUDE':
				vm.model.NdcOptimizerGpiCount = evtData.ItemsCount;
				break;
			case 'GPIEXCLUDE':
				vm.model.NdcOptimizerGpiCount = evtData.ItemsCount;
				break;
			default:
				throw new Error('rxEditCtl, gpi list event has unknown list type: ' + evtData.ListType);
		}

	});

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		if(!evtData || evtData.uniqueId != 'RX_EDIT_CF_MEMBERS') {
			return;
		}

		if(!vm.cfMemberListFlt.Ready) {
			return;
		}

		vm.cfMemberListFlt[evtData.propName] = parseInt(evtData.value, 10);
		cfMemberListFilterChange(true);

	});

	/**
	 *    INIT
	 */

	init();

	function init() {

		// default tab
		vm.activeTab = 'ACCOUNT';

		// user context
		vm.context = rxRepo.contextVM();

		// billing frequency
		vm.BillFreqDroplist = utilSvc.ng.droplist([
			'BIMONTHLY',
			'MONTHLY'
		]);

		// status buttons
		vm.btnStatusChange = {
			show: false,
			ONBOARDING: false,
			ACTIVE: false,
			INACTIVE: false,
			DELETED: false
		};

		vm.PricingModelDroplist = utilSvc.ng.droplist([
			'CustomPriceList',
			'Reimbursement',
			'WACFloat',
			'WACMinus'
		]);

		vm.AddressStateDroplist = utilSvc.ng.stateFullNamesDroplist();
		vm.AddressStateDroplist.unshift({value:'NONE', label:' '});
		//rollup drop list init
		initRollupDropList();

		// sequential splitting
		vm.wholesaleAcctDroplist = utilSvc.ng.droplist([
			'GPO',
			'WAC'
		]);

		// wac neut
		vm.wacNeutEdit = wacNeutNdcVM();

		// ROLLUP pay tpa direct
		vm.TpaDirectMulti = {
			type: 'TPA',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'Choose a TPA',
			titleNoOptions: 'Choose a TPA',
			titleAllOptions: 'All TPAs',
			vals: [],
			list: [], // built after get detail
			flt: ''
		};

		switch($state.current.name) {

			case 'admin.rx.edit':
			case 'admin.rx.edit.affs':
				var routeInfo = $state.current.routeInfo;
				$scope.$emit('shared.main.setInfo', {
					icon: routeInfo.icon,
					title: 'Update Pharmacy: ' + $state.params.RX,
					bkgHeight: routeInfo.bkgHeight,
					breadcrumb: routeInfo.breadcrumb,
				});
		
				vm.action = 'UPDATE';
				getDetail($state.params.RX);
				break;

			case 'admin.rx.create':
				$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

				vm.action = 'CREATE';
				vm.model = rxRepo.modelVM();
				vm.DataExportsSchedule = JSON.parse(JSON.stringify(vm.model.DataExportsSchedule || {})); // de-ref

				vm.bizModelsChecked = setBizModelsCheckboxUI(vm.model);
				vm.bizModelsChecked.addModels = 'yes';
				vm.bizModelsEdit = true;

				// get vendors after a render cycle
				$timeout(function(){
					initVendorList();
				},300);
				break;

			default:
				throw new Error('rxEditCtl.Init, state unknown: ' + $state.current.name);
		}

	}

	function initRollupDropList() {

		vm.RollupDroplist = utilSvc.ng.droplistNONE();

		var rollups = utilSvc.aff.findRxType($scope.User.AffList, ['ROLLUP']);
		if(rollups.length > 0) {
			// ASYNC: load ROLLUPS, get short names from server
			loadRollupDisplay(utilSvc.aff.rxList(rollups));
		}
	}

	function initVendorList() {

		// get vendors from database

		vm.BaseVendorDroplist = [];
		vendorRepo.getList().then(okVenList, errVenList);

		function okVenList(r) {

			var items = Array.isArray(r) ? r : [],
			venList = [];

			// vendors must be: ACTIVE, SupportEDI and not a DRUGDB
			for(var i = 0; i < items.length; i++) {
				if(items[i].ObjectState == 'ACTIVE' && !!items[i].SupportsEDI && items[i].Type != 'DRUGDB') {
					venList.push(items[i].Id);
				}
			}
			venList.sort();

			vm.BaseVendorDroplist = utilSvc.ng.droplist(venList);
			vm.BaseVendorDroplist.unshift({label:'NONE', value:'NONE'});

			resetVendorDroplists();
			// droplist dependenecy here
			vm.seqSplitEditAccounts = seqSplitAccountsVM();

		}

		function errVenList(r) {
			if(!!r) {
				errSvc.warn('unknown error getting vendor list', 'vendor.getList', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    UI CHANGE EVENTS
	 */

	function tabChange(newTab) {

		if(vm.isWaiting) {
			return;
		}

		vm.activeTab = newTab;

		switch(newTab) {

			case 'ACCOUNT':
				// update tpa pay direct choices (ROLLUP member choices can change options)
				if(vm.action == 'UPDATE' && vm.model.Type.val == 'ROLLUP') {
					loadPayTpaDirect(vm.model);
				}
				break;

			case 'CENTRALFILL':
				cfTabClick();
				break;

			case 'ROLLUP':
				ruTabClick();
				break;

			case 'AFF':
				$state.go('admin.rx.edit.affs', {
					ViewType: 'RX',
					ViewErrRoute: 'admin.rx.list',
					RX: vm.model.Id.val
				}, {inherit: true});
				break;
				
			case 'NDC':
				$state.go('admin.rx.edit.customitem', {
					ViewType: 'RX',
					ViewErrRoute: 'admin.rx.list',
					RX: vm.model.Id.val
				}, {inherit: true});
				break;

			default:
				throw new Error('rxEditCtl.tabChange, unknown tab name: ' + newTab);
		}

	}

	function rxTypeClick() {

		// rx type change can influence dependent property values

	}

	function toggleVHub(userChoice) {

		if(vm.isWaiting || !!vm.model.RollupParent) {
			return;
		}

		if(userChoice == 'yes') {
			msgSvc.confirm({
				id: 'rx.vhub.enable',
				title: 'Enable VHub',
				msg: 'Enabling VHub will lock down Billing and other features. Also, all settings for affiliations (and rollup members) will be overwritten',
				buttons: [
					{text:'OK', result:'YES', cancel: false},
					{text:'CANCEL', result:'NO', cancel: true}
				]
			}).then(confirmVHubEnable, confirmVHubEnable);
		}
		else {
			vm.model.VHubEnabled = 'no';
			vm.model.FederateRawClaims.val = 'no';
			vm.model.ImportRawClaims.val = 'no';
			vm.model.UseTpaNPIListForRawClaimsExport.val = 'no';
		}

	}

	function confirmVHubEnable(r) {

		var m = vm.model;

		// user enabled VHub
		if(!!r && r.result == 'YES') {

			m.BillEnabled = 'yes';
			m.BillOverride = 'no';
			m.BillExport = 'yes';
			m.BillExportFees = 'yes';
			m.BillExportDrugCost = 'yes';
			m.BillExportDetailedRollup = 'yes';
			m.PricingEnabled = 'no';
			m.PricingCanOverride = 'no';
			m.VCentralEnabled = 'no';
			m.BillPayTpaDirect.val = 'no';
			m.BillPayTpaDirectList = [];

			m.VHubEnabled = 'yes';
		}
		else {
			m.VHubEnabled = 'no';
		}
	}

	/**
	 *    VCENTRAL
	 */

	function toggleVCentral(userChoice) {
		if(vm.isWaiting || !!vm.model.RollupParent) {
			return;
		}

		if(userChoice == 'yes') {
			msgSvc.confirm({
				id: 'rx.vcentral.enable',
				title: 'Enable VCentral',
				msg: 'Enabling VCentral will lock down Billing and other features. Also, all settings for affiliations (and rollup members) will be overwritten',
				buttons: [
					{text:'OK', result:'YES', cancel: false},
					{text:'CANCEL', result:'NO', cancel: true}
				]
			}).then(confirmVCentralEnable, confirmVCentralEnable);
		}
		else {
			vm.model.VCentralEnabled = 'no';
		}

	}

	function confirmVCentralEnable(r) {

		var m = vm.model;

		// user enabled VHub
		if(!!r && r.result == 'YES') {
			m.BillEnabled = 'no';
			m.BillOverride = 'no';
			m.CdcEnabled.val = 'no';
			m.VHubEnabled = 'no';

			// Data options
			vm.model.Accumulate = 'no';
			vm.model.ExtractNpis = 'no';
			vm.model.MergeRollupsNpis = 'no';
			vm.model.MergeNpiInto.val = 'NONE';
			vm.model.DispFullAllocOnly = 'no';
			vm.model.SharedFormularyProvider = 'no';

			m.VCentralEnabled = 'yes';
		}
		else {
			m.VCentralEnabled = 'no';
		}
	}

	/** 
	 *    Federate Claims
	 */
	function toggleImportRawClaims(userChoice) {

		if(vm.isWaiting || !!vm.model.RollupParent) {
			return;
		}

		if(userChoice == 'no') {
			vm.model.FederateRawClaims.val = 'no';
			vm.model.UseTpaNPIListForRawClaimsExport.val = 'no';
		}

	}

	/** 
	*    Use TPA NPI list for claims federation
	*/
	function toggleFederateRawClaims(userChoice) {

		if(vm.isWaiting || !!vm.model.RollupParent) {
			return;
		}

		if(userChoice == 'no') {
			vm.model.UseTpaNPIListForRawClaimsExport.val = 'no';
		}

	}

	/**
	 *    Federate 850s to CE
	 */
	function toggleFederate850s(userChoice) {

		if(vm.isWaiting) {
			return;
		}

		vm.model.Federate850s = userChoice;
		if(userChoice == 'no') {
			vm.model.Federate850sFileExtX12 = 'no';
		}

	}

	function initFederate850sCeidDroplist() {
		var affs = utilSvc.aff.findRx($scope.User.AffList, vm.model.Id.val);
		affs = utilSvc.aff.findStatus(affs);
		var ceIds = utilSvc.aff.ceList(affs);
		vm.federate850sCeidDroplist = utilSvc.ng.droplist(ceIds);
	}

	/**
	 *    GET DETAIL
	 */

	function getDetail(id) {

		// valid param
		if(!validSvc.isText(id)) {
			throw new Error('rxEditCl.getDetail, id is missing');
		}
		_currentRX = id;

		rxRepo.getDetail(_currentRX).then(okDetail, errDetail);

		function okDetail(r) {
			vm.model = r;

			vm.bizModelsChecked = setBizModelsCheckboxUI(vm.model);

			vm.model.NdcOptimizerGpiCount = vm.model.GovernedGPIs.length;

			vm.savedGovernor = vm.model.Governor;
			vm.savedGenericGrouping = vm.model.GenericGrouping;
			vm.savedGpiConstraints = vm.model.GpiConstraints;

			vm.DataExportsSchedule = JSON.parse(JSON.stringify(vm.model.DataExportsSchedule || {})); // de-ref

			// update display
			refreshStatusButtons(vm.model.Type.val, vm.model.ObjectState);

			// show tabs
			if(vm.model.ObjectState != 'QUEUED') {
				var isRollup = vm.model.Type.val == 'ROLLUP';
				vm.showTabRollup = isRollup;
				vm.showTabAffs = !isRollup;
				vm.showTabCentralFill = vm.model.Type.val == 'CENTRALFILL';

				vm.seqSplitEdit = seqSplitVM();
				initFederate850sCeidDroplist();
				if(vm.model.SeqSplitStatus == 'off') {
					resetSeqSplitProps(vm.model);
				}

				// get pay direct tpas from rollup member affils
				if(isRollup) {
					loadPayTpaDirect(vm.model);
				}

				// get vendors after a render cycle
				$timeout(function(){
					initVendorList();
				},300);
			}

		}

		function errDetail(r) {
			if(r !== null) {
				errSvc.warn('Pharmacy Id not found: ' + _currentRX, 'rxEditCtl.getDetail.err', r.status, utilSvc.http.safeResponse(r));
			}
			$state.go('admin.rx.list', {}, {reload:'admin.rx.list'});
		}

	}

	function loadPayTpaDirect(m) {
		// ROLLUP pharmacy billing option, tpa list is from rollup member affils.ProgAdmin
		var multi = vm.TpaDirectMulti;
		multi.list = [];
		multi.vals = [];

		var isOn = m.BillPayTpaDirect.val == 'yes',
			hasTpas = false,
			verifiedTpaVals = [];
		if(m.RollupRxList.length > 0) {
			// get ProgAdmin off RX member ACTIVE affiliations
			var affs = utilSvc.aff.findRxList($scope.User.AffList, m.RollupRxList);
			affs = utilSvc.aff.findStatus(affs, ['ACTIVE']);
			var tpaDirectList = utilSvc.aff.progAdminList(affs);
			
			// build options if affils have at least 1 ProgAdmin
			hasTpas = tpaDirectList.length > 0;
			if(hasTpas) {
				tpaDirectList.unshift('ALL');
				multi.list = vm.multiselectBuild(tpaDirectList, false);
				
				var defaultVal = ''; // empty will choose all values if model as all posibilities
				if(isOn) {
					// update from model
					vm.multiselectReturnVisit(multi,'',m.BillPayTpaDirectList);
					verifiedTpaVals = vm.multiselectAllVals(multi);
				}
				else {
					// default value can be ALL or the only option, build will drop the ALL list option if there is only 1 option
					var usingALL = multi.list[0] == 'ALL';
					defaultVal = !usingALL && multi.list.length == 1 ? multi.list[0] : 'ALL'; 
				}
				vm.multiselectClick(multi, defaultVal);
				vm.multiselectTitle(multi, true);
			}
		}

		// update model after TPAs are verified against affiliations
		m.BillPayTpaDirectList = verifiedTpaVals;
		m.BillPayTpaDirect = validSvc.newProp(isOn && hasTpas ? 'yes' : 'no');
	}


	/**
	*    POPUP
	*/

	function openPopup(evt, popType, ndcClone) {
		var popup;
		if (vm.isWaiting) {
			return;
		}

		vm.popup = {
			type: popType,
			ready: false,
			title: '',
			RX: vm.model.Id.val,
			Scope: ''
		};

		var pop = vm.popup,
			offsetY = 0,
			elem = {},
			popupParentClass = '';

		switch (popType) {
			case 'GPIINCLUDE':
			case 'GPIEXCLUDE':
			case 'NDCOPTEXCLUDELIST':
				pop.isVerity = vm.uType == 'VERITY' || vm.uType == 'VERITYSA';
				pop.ListType = popType;
				pop.CE = vm.context.CE;
				pop.RX =  vm.model.Id.val;
				pop.Scope = "RX";
				pop.Entity = vm.model.Id.val;
				pop.uniqueId = popType;
				pop.Id = vm.model.Id.val;
				pop.title = '';
				if (popType=='NDCOPTEXCLUDELIST') {
					pop.title = 'NDC Optimizer Exclude List';
				}
				if (popType=='GPIINCLUDE') {
					pop.title = 'NDC Optimizer GPI Include List';
				}
				if (popType=='GPIEXCLUDE') {
					pop.title = 'NDC Optimizer GPI Exclude List';
				}
				popupParentClass = 'table-popup-top';
				elem = evt.target;
				offsetY = -50;

				// loop html element parents looking for popup container top
				elem = evt.target;
				while (!!elem) {

					// top element found
					if (!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
						break;
					}

					// add offset, get next element
					offsetY += elem.offsetTop;
					elem = elem.offsetParent;
				}
				elem = null;


				var popupid = 'idFormulaList';
				if (vm.popup.type == 'GPIINCLUDE' || vm.popup.type == 'GPIEXCLUDE') {
					popupid = 'idGpiList';
				}

				// move popup to clicked row
				popup = document.getElementById(popupid);
				if (!!popup) {
					popup.style.top = offsetY.toString() + 'px';
				}


				// loop html element parents looking for popup container top
				break;
			default:
				throw new Error('affDetailCtl.openPopup, pop type unknown: ' + popType);
		}

		// wait for digest before showing
		$timeout(function () {
			vm.popup.ready = true;
			if (vm.popup.type == 'NDCOPTEXCLUDELIST') {
				$scope.$broadcast('widget.ops.ndc.list', { uniqueId: vm.popup.uniqueId, action: 'INIT' });
			} else if (vm.popup.type == 'GPIINCLUDE' || vm.popup.type == 'GPIEXCLUDE') {
				$scope.$broadcast('widget.ops.gpi.list', { uniqueId: vm.popup.uniqueId, action: 'INIT' });
			}
		}, 100);
	}

	function closePopup() {
		vm.popup = {};
	}

	/**
	 *    SUBMIT: ACCOUNT
	 */

	function resetValidationState() {

		// reset validation state on all model properties
		// note: use this after an update to hide validation icons

		var m = vm.model;

		m.Id.fail = '';
		m.AcctId.fail = '';
		m.DivisionCode.fail = '';
		m.StoreNumber.fail = '';
		m.DailyTotalPackageLimit.fail = '';
		m.DailyNDCPackageLimit.fail = '';
		m.DailyRefrigeratedPackageLimit.fail = '';
		m.BusinessModels.fail = '';
		m.Type.fail = '';
		m.Name.fail = '';
		m.ShortName.fail = '';
		m.NPI.fail = '';
		m.NCPDP.fail = '';

		m.PricingModel.fail = '';
		m.PricingRate.fail = '';

		m.TpaProgAdmin.fail = '';
		m.TpaPriceRate.fail = '';
		m.TpaExtractDelay.fail = '';
		m.TpaExtractExcludeNdc.fail = '';

		m.AccumulationDelay.fail = '';
		m.ExtractNpisVisitLookback.fail = '';
		m.MergeNpiInto.fail = '';

		m.CustomPriceVendor.fail = '';
		m.CustomPriceVendorAccountNumber.fail = '';
		m.CustomPriceAccumGrp.fail = '';

		m.BillFrequency.fail = '';

		m.CostCenter.fail = '';
		m.CdcEnabled.fail = '';
		m.WacNeutFee.fail = '';

		m.PCC.fail = '';

		m.DispenseExpiration.fail = '';

		vm.unsavedGpiConstraints = false;
		vm.unsavedGpiGrouping = false;
		vm.unsavedPurchaseHistory = false;
		vm.savedGovernor = vm.model.Governor;
		vm.savedGenericGrouping = vm.model.GenericGrouping;
		vm.savedGpiConstraints = vm.model.GpiConstraints;

		m.DataExportsScheduleErr = '';

	}

	function validAccount() {

		// validate for both create and update

		var m = vm.model;

		if(vm.action == 'CREATE' || vm.model.Clone) {

			// Nickname - required on create, alphanumeric
			m.Id = validText(m.Id, 3, 30);
			if(m.Id.fail == 'no') {
				m.Id.val = m.Id.val.toUpperCase();
				var regexId  = /[^A-Z0-9]/;
				if(regexId.test(m.Id.val)) {
					m.Id.fail = 'yes';
					m.Id.msg = 'must be 3 to 30 letters and numbers only';
				}
			}

			// ShortName uses Nickname if blank
			if(m.Id.fail != 'yes' && !validSvc.isText(m.ShortName.val)) {
				m.ShortName = validSvc.newProp(m.Id.val);
			}

		}

		// Accounting Id - required for ACTIVE status, optional otherwise, alphanumeric
		if(validSvc.isText(m.AcctId.val)) {
			m.AcctId = validText(m.AcctId, 3, 20);
			if(m.AcctId.fail == 'no') {
				var regexAcctId = /[^A-Z0-9\-]/,
					cleanAcctId = m.AcctId.val.toString().toUpperCase();
				if(regexAcctId.test(cleanAcctId)) {
					m.AcctId.fail = 'yes';
					m.AcctId.msg = 'must be 3 to 20 letters and numbers only';
				}
				else {
					m.AcctId.fail = '';
				}
			}
		}
		else if(m.ObjectState == 'ACTIVE') {
			m.AcctId.fail = 'yes';
			m.AcctId.msg = 'required for ACTIVE status';
		}
		else {
			m.AcctId.fail = '';
		}

		// division and store are optional text fields
		if(validSvc.isText(m.DivisionCode.val)) {
			m.DivisionCode = validText(m.DivisionCode, 1, 50);
		}
		else {
			m.DivisionCode.fail = '';
			m.DivisionCode.msg = '';
		}

		if(validSvc.isText(m.StoreNumber.val)) {
			m.StoreNumber = validText(m.StoreNumber, 1, 50);
		}
		else {
			m.StoreNumber.fail = '';
			m.StoreNumber.msg = '';
		}

		// package limits are required, non-negative integers
		var dailyTotalPackageLimit = parseInt(m.DailyTotalPackageLimit.val, 10);
		if(!validSvc.isInteger(dailyTotalPackageLimit) || dailyTotalPackageLimit < 0) {
			m.DailyTotalPackageLimit.fail = 'yes';
			m.DailyTotalPackageLimit.msg = 'required integer 0 or greater';
		}
		else {
			m.DailyTotalPackageLimit.val = dailyTotalPackageLimit;
			m.DailyTotalPackageLimit.fail = 'no';
			m.DailyTotalPackageLimit.msg = '';
		}

		var dailyNdcPackageLimit = parseInt(m.DailyNDCPackageLimit.val, 10);
		if(!validSvc.isInteger(dailyNdcPackageLimit) || dailyNdcPackageLimit < 0) {
			m.DailyNDCPackageLimit.fail = 'yes';
			m.DailyNDCPackageLimit.msg = 'required integer 0 or greater';
		}
		else {
			m.DailyNDCPackageLimit.val = dailyNdcPackageLimit;
			m.DailyNDCPackageLimit.fail = 'no';
			m.DailyNDCPackageLimit.msg = '';
		}

		var dailyRefrigeratedPackageLimit = parseInt(m.DailyRefrigeratedPackageLimit.val, 10);
		if(!validSvc.isInteger(dailyRefrigeratedPackageLimit) || dailyRefrigeratedPackageLimit < 0) {
			m.DailyRefrigeratedPackageLimit.fail = 'yes';
			m.DailyRefrigeratedPackageLimit.msg = 'required integer 0 or greater';
		}
		else {
			m.DailyRefrigeratedPackageLimit.val = dailyRefrigeratedPackageLimit;
			m.DailyRefrigeratedPackageLimit.fail = 'no';
			m.DailyRefrigeratedPackageLimit.msg = '';
		}

		// Type - required
		m.Type = validText(m.Type, 2, 20);
		if(m.Type.fail == 'yes') {
			return false;
		}
		var rxType = m.Type.val;

		// Business Models, revalidate on save
		var bizModsArray = bizModelsToArray(m);
		if(bizModsArray.length > 0 && !bizModelsValid(bizModsArray)) {
			bizModelsEditToggle('on');
			return false;
		}

		// ROLLUP type can only have 1 model
		if(rxType == 'ROLLUP') {
			if(bizModsArray.length !== 1) {
				m.Type.fail = 'yes';
				m.Type.msg = 'ROLLUP must have 1 business model';
				return false;
			}

			// cdc must be off for ROLLUP
			if(m.CdcEnabled.val == 'yes') {
				m.Type.fail = 'yes';
				m.Type.msg = 'ROLLUP cannot be a CDC';
				return false;
			}
		}

		// SPLITMATCH - only DISPENSING type allowed
		if(!!m.hasSPLITMATCH && rxType != 'DISPENSING') {
			m.Type.fail = 'yes';
			m.Type.msg = 'Central Fill type is not supported with SPLITMATCH';
			return;
		}

		// address, validate if any are not empty
		var addressOk = true;
		if(m.AddressState.val != 'NONE' || validSvc.isText(m.AddressLine1.val + m.AddressLine2.val + m.AddressCity.val + m.AddressZip.val)) {
			m.AddressState.fail = m.AddressState.val == 'NONE' ? 'yes' : 'no';
			m.AddressLine1 = validText(m.AddressLine1, 2, 50);

			// line 2 is optional
			if(validSvc.isText(m.AddressLine2.val)) {
				m.AddressLine2 = validText(m.AddressLine2, 2, 50);
			}
			else {
				m.AddressLine2.fail = 'no';
				m.AddressLine2.msg = '';
			}
			m.AddressCity = validText(m.AddressCity, 2, 50);
			m.AddressZip = validZip(m.AddressZip);

			addressOk = m.AddressLine1.fail != 'yes' &&
				m.AddressLine2.fail != 'yes' &&
				m.AddressCity.fail != 'yes' &&
				m.AddressState.fail != 'yes' &&
				m.AddressZip.fail != 'yes';
		}

		// Name - required
		m.Name = validText(m.Name, 2, 100);

		// ShortName - required (allow alphanumeric, dash, underscore, period,apostrophe, space)
		m.ShortName = validText(m.ShortName, 2, 40);
		if(m.ShortName.fail == 'no') {
			var regexShortName = /[^A-Za-z0-9\-\_\.\'\ ]/;
			if(regexShortName.test(m.ShortName.val.toString())) {
				m.ShortName.fail = 'yes';
				m.ShortName.msg = 'must be 2 to 40 letters, numbers, dash, underscore, period, apostrophe or spaces';
			}
			else {
				m.ShortName.fail = '';
			}
		}

		// BILLING, use for ROLLUP or Pharmacy not in a rollup
		if(!validSvc.isText(m.RollupParent)) {

			// enabled
			if(m.BillEnabled == 'yes') {
				m.BillFrequency.fail = '';
				m.BillPayTpaDirect.fail = '';
				m.BillPayTpaDirectList = [];
				if((rxType == 'ROLLUP' || m.VHubEnabled == 'yes' || m.VCentralEnabled == 'yes') && !validSvc.isText(m.BillFrequency.val)) {
					m.BillFrequency.fail = 'yes';
					m.BillFrequency.msg = 'required';
				}
				else if(vm.action == 'UPDATE' && rxType == 'ROLLUP' && m.VHubEnabled == 'yes' && m.BillPayTpaDirect.val == 'yes') {
					// validate tpa direct
					m.BillPayTpaDirectList = vm.multiselectAllVals(vm.TpaDirectMulti);
					m.BillPayTpaDirect.fail = m.BillPayTpaDirectList.length < 1 ? 'yes' : 'no';
				}
			}
			else {
				m.BillOverride = 'no';
				m.BillFrequency = validSvc.newProp('');
				m.BillExport = 'no';
				m.BillPayTpaDirect = validSvc.newProp('no');
				m.BillPayTpaDirectList = [];
			}

			// export
			if(m.BillExport == 'yes') {
				m.BillExportDetailedRollup = rxType == 'ROLLUP' ? m.BillExportDetailedRollup : 'no'; // only used by ROLLUP
			}
			else {
				m.BillExportDetailedRollup = 'no';
				m.BillExportFees = 'no';
				m.BillExportDrugCost = 'no';
			}

			// override, n/a for a ROLLUP
			m.BillOverride = rxType == 'ROLLUP' ? 'no' : m.BillOverride;

		}

		// DISPENSING or CENTRALFILL only
		if(rxType == 'DISPENSING' || rxType == 'CENTRALFILL') {

			// NPI - required for non-SPLIT, optional for SPLIT, integer
			if(!!!m.hasSPLIT || validSvc.isText(m.NPI.val)) {
				m.NPI = validText(m.NPI, 10, 15);
				if(m.NPI.fail == 'no' && !validSvc.isInteger(parseInt(m.NPI.val))) {
					m.NPI.fail = 'yes';
					m.NPI.msg = 'must be a 10 - 15 digit number';
				}
			}
			else {
				m.NPI.fail = '';
			}

			// NCPDP - optional, integer
			if(validSvc.isText(m.NCPDP.val)) {
				m.NCPDP = validText(m.NCPDP, 6, 7);
				if(m.NCPDP.fail == 'no' && !validSvc.isInteger(parseInt(m.NCPDP.val))) {
					m.NCPDP.fail = 'yes';
					m.NCPDP.msg = 'must be a 6-7 digit number';
				}
			}
			else {
				m.NCPDP.fail = '';
			}

		}
		else if(rxType == 'ROLLUP') {
			m.NPI.fail = '';
			m.NCPDP.fail = '';
		}
		else {
			throw new Error('rxEditCtl.validAccount, unknown rx type: ' + rxType);
		}

		// PRICING
		if(m.PricingEnabled == 'no') {
			// pricing not used
			m.PricingCanOverride = 'no';
			m.PricingOverridden = 'no';
			m.PricingModel = validSvc.newProp('');
			m.PricingRate = validSvc.newProp(0.0);
		}
		else if(m.PricingEnabled == 'yes' && validSvc.isText(m.RollupParent) && (m.RollupPricingCanOverride == 'no' || m.PricingOverridden == 'no')) {
			// pricing controlled by rollup parent
			m.PricingOverridden = 'no';
			m.PricingModel = validSvc.newProp('');
			m.PricingRate = validSvc.newProp(0.0);
		}
		else {
			// CP regular pharmacy, ROLLUP or rollup child with override must have pricing validated

			// pricing model - required
			if(!validSvc.isText(m.PricingModel.val)) {
				m.PricingModel.fail = 'yes';
				m.PricingModel.msg = 'required';
			}
			else {
				m.PricingModel.fail = '';
			}

			// pricing rate, required for WACMinus
			if(m.PricingModel.val == 'WACMinus') {
				m.PricingRate = validCurrency(m.PricingRate, 0.00, 500);
			}
			else if(m.PricingModel.val == 'Reimbursement') {
				m.PricingRate = validCurrency(m.PricingRate, 0.00, 99);
			}
			else {
				m.PricingRate.fail = '';
				m.PricingRate.val = 0.0;
			}
		}

		// DATA OPTION: Accumulate, required
		if(m.Accumulate != 'no' && m.Accumulate != 'yes') {
			throw new Error('rxEditCtl.validAccount, Accumulate must be yes or no');
		}

		// DATA OPTION: AccumulateDelay, required, integer >=0 <=30
		if(m.Accumulate == 'yes') {
			var accumDelay = m.AccumulationDelay.val;
			if(!validSvc.isInteger(accumDelay) || accumDelay < 0 || accumDelay > 30) {
				m.AccumulationDelay.fail = 'yes';
				m.AccumulationDelay.msg = 'required number between 0 and 30';
			}
			else {
				m.AccumulationDelay.fail = '';
			}
		}
		else {
			// reset delay to zero if Accumulate is off 'no'
			m.AccumulationDelay = validSvc.newProp(0);
		}

		// DATA OPTION: ExtractNpis, required
		if(m.ExtractNpis != 'no' && m.ExtractNpis != 'yes') {
			throw new Error('rxEditCtl.validAccount, ExtractNpis must be yes or no');
		}

		// DATA OPTION: ExtractNpisVisitLookback, required, integer >=0 <=30
		if(m.ExtractNpis == 'yes') {
			var npiLookback = m.ExtractNpisVisitLookback.val;
			if(!validSvc.isInteger(npiLookback) || npiLookback < 1 || npiLookback > 365) {
				m.ExtractNpisVisitLookback.fail = 'yes';
				m.ExtractNpisVisitLookback.msg = 'required number between 1 and 365';
			}
			else {
				m.ExtractNpisVisitLookback.fail = '';
			}
		}
		else {
			m.ExtractNpisVisitLookback = validSvc.newProp(180); // default is 180 days
			m.MergeRollupsNpis = 'no';
			m.MergeNpiInto.val = 'NONE';
		}


		if(m.MergeRollupsNpis == 'yes' && m.MergeNpiInto.val == 'NONE') {
			m.MergeNpiInto.fail = 'yes';
			m.MergeNpiInto.msg = 'Required when Merge Rollup NPIs is selected';
		} else {
			m.MergeNpiInto.fail = '';
		}

		// DATA OPTION: Sequential Splitting
		var seqSplitValidate = m.SeqSplitStatus == 'on';

		// seq split sub-prop: SeqCombine855s
		if(seqSplitValidate && m.SeqCombine855s == 'yes') {
			var tm = parseInt(m.SeqTimeout855s.val);
			if(!validSvc.isInteger(tm) || tm < 1 || tm > 10000) {
				m.SeqTimeout855s.fail = 'yes';
				m.SeqTimeout855s.msg = 'number 1 to 10000';
			}
			else {
				m.SeqTimeout855s.fail = '';
			}
		}
		else if(m.SeqSplitStatus == 'off') {
			m.SeqTimeout855s = validSvc.newProp(0);
		}
		var at = 0;
		if (m.SeqPreSplitRequired == 'yes') {
			at = parseInt(m.SeqPreSplitTimeout.val);
			if(!validSvc.isInteger(at) || at < 15 || at > 240) { // 4 hours in mins
				m.SeqPreSplitTimeout.fail = 'yes';
				m.SeqPreSplitTimeout.msg = 'number 15 to 240';
			}
			else {
				m.SeqPreSplitTimeout.fail = '';
			}
		}
		else {
			m.SeqPreSplitTimeout = validSvc.newProp(60);
			m.SeqPreSplitTimeoutAction = 'SPLIT';
		}
		// seq split sub-prop: SeqApprovalRequired
		if(seqSplitValidate && m.SeqApprovalRequired == 'yes') {
			at = parseInt(m.SeqApprovalTimeout.val);
			if(!validSvc.isInteger(at) || at < 30 || at > 1440) { // 24 hours in mins
				m.SeqApprovalTimeout.fail = 'yes';
				m.SeqApprovalTimeout.msg = 'number 30 to 1,440';
			}
			else {
				m.SeqApprovalTimeout.fail = '';
			}
		}
		else {
			m.SeqApprovalTimeout = validSvc.newProp(60);
			m.SeqApprovalTimeoutAction = 'PLACE';
		}
		// DATA OPTION: Custom Price Vendor (also used by seq split)
		if(m.hasCP || m.hasSPLIT || m.hasSPLITMATCH) {

			// reset Custom Vendor if a ROLLUP without Shared formulary
			if(rxType == 'ROLLUP' && m.SharedFormularyProvider == 'no') {
				// reset if ROLLUP SharedFormulary = no
				m.CustomPriceVendor = validSvc.newProp('NONE');
			}

			// Vendor dependent properties
			if(m.CustomPriceVendor.val == 'NONE') {
				m.CustomPriceVendorAccountNumber = validSvc.newProp('');
				m.CustomPriceAccumGrp = validSvc.newProp('');
				m.CustomPriceVendorOrderConfig = '';

				// splitting requires a vendor
				m.CustomPriceVendor.fail = seqSplitValidate ? 'yes' : 'no';
				if(m.CustomPriceVendor.fail) {
					m.CustomPriceVendor.msg = 'required';
				}

			}
			else {
				m.CustomPriceVendor.fail = 'no';

				// acct #
				m.CustomPriceVendorAccountNumber = validText(m.CustomPriceVendorAccountNumber, 5, 40);

				// splitting requires accum grp
				m.CustomPriceAccumGrp.fail = seqSplitValidate && !validSvc.isText(m.CustomPriceAccumGrp.val) ? 'yes' : 'no';
				if(m.CustomPriceAccumGrp.fail) {
					m.CustomPriceAccumGrp.msg = 'required';
				}

				// splitting, force SendForReview to 'no' if MCKESSON vendor is chosen
				if(m.CustomPriceVendor.val == 'MCKESSON' || m.CustomPriceVendor.val =='MCKESSONSAFECOR' || m.CustomPriceVendor.val == 'MCKESSONHCP') {
					m.SeqSendForReview = 'no';
				}

				// AMERISOURCE
				if(m.CustomPriceVendor.val == 'AMERISOURCE') {
					m.CustomPriceVendorOrderConfig = 'ABCOrder';
				}
				else {
					m.CustomPriceVendorOrderConfig = '';
				}

			}

			// seq split requires Ce list
			if(seqSplitValidate) {
				vm.seqSplitEdit.fail = m.SeqCEs.length < 1 ? 'yes' : '';
			}
		}
		else {

			// reset Custom Price props
			m.CustomPriceVendor = validSvc.newProp('NONE');
			m.CustomPriceVendorAccountNumber = validSvc.newProp('');
			m.CustomPriceAccumGrp = validSvc.newProp('');
			m.CustomPriceVendorOrderConfig = '';

		}

		// data exports
		var useDataExports = false;
		m.DataExportsScheduleErr = '';
		if(rxType == 'ROLLUP' && m.hasCP && validSvc.isText(m.EncryptionPublicKey.val)) {
			useDataExports = true;
			m.DataExportsAccum = m.DataExportsEnabled == 'yes' && m.DataExportsAccum == 'yes' ? 'yes' : 'no';
			m.DataExportsMatches = m.DataExportsEnabled == 'yes' && m.DataExportsMatches == 'yes' ? 'yes' : 'no';
			m.DataExportsMatchesPHI = m.DataExportsMatches == 'yes' && m.DataExportsMatchesPHI == 'yes' ? 'yes' : 'no';
			m.DataExportsSchedule = JSON.parse(JSON.stringify(vm.DataExportsSchedule || {})); // de-ref
		}
		if(!useDataExports) {
			m.EncryptionPublicKey = validSvc.newProp('');
			m.EnableAuditPHI = 'no';
			m.DataExportsEnabled = 'no';
			m.DataExportsAccum = 'no';
			m.DataExportsMatches = 'no';
			m.DataExportsMatchesPHI = 'no';
			m.DataExportsClaimsBacking = 'no';
			m.DataExportsClaimsBackingPHI = 'no';
			m.DataExportsSMClaimsBacking = 'no';
			m.DataExportsSMClaimsBackingPHI = 'no';
			m.DataExportsAudit = 'no';
			m.DataExportsSchedule = {};
		}

		// TPA
		if(m.hasCPTPA && rxType == 'ROLLUP') {

			// prog admin - required
			if(!validSvc.isText(m.TpaProgAdmin.val)) {
				m.TpaProgAdmin.fail = 'yes';
				m.TpaProgAdmin.msg = 'required for TPA';
			}
			else {
				m.TpaProgAdmin.fail = '';
			}

			// price model, required
			if(!validSvc.isText(m.TpaPriceModel.val)) {
				m.TpaPriceModel.fail = 'yes';
				m.TpaPriceModel.msg = 'required';
			}
			else {
				// price rate may be required
				if(m.TpaPriceModel.val == 'REFPRICE' || m.TpaPriceModel.val == 'REIMBURSE') {
					m.TpaPriceRate = validNumber(m.TpaPriceRate, 0, 99);
				}
				else {
					m.TpaPriceRate = validSvc.newProp(0);
				}
			}

			// extract, delay may be required
			if(m.TpaExtractDispenses == 'yes') {
				m.TpaExtractDelay = validNumber(m.TpaExtractDelay, 0, 30);
			}
			else {
				// reset delay and ndc list
				m.TpaExtractDelay = validSvc.newProp(0);
				m.TpaExtractExcludeNdcList = [];
			}
			m.TpaExtractExcludeNdc = validSvc.newProp('');  // reset edit state during validation

		}
		else {
			m.TpaProgAdmin = validSvc.newProp('');
			m.TpaPriceModel = validSvc.newProp('');
			m.TpaPriceRate = validSvc.newProp(0);

			m.TpaExtractDispenses = 'no';
			m.TpaExtractDelay = validSvc.newProp(0);
			m.TpaExtractExcludeNdc = validSvc.newProp('');
			m.TpaExtractExcludeNdcList = [];
		}

		// DATA OPTION: Governor (turn off sub-features if anything above is off)
		if(m.Type.val == 'ROLLUP' || (!!!m.hasSPLIT && !!!m.hasSPLITMATCH)) {
			m.Governor = 'no';
		}
		if(m.Governor == 'no') {
			m.GenericGrouping = 'no';
		}
		if(m.GenericGrouping == 'no' || m.GpiConstraints == 'ALL') {
			m.GovernedGPIs = [];
		}

		// CDC / WAC NEUT
		if(m.CdcEnabled.val == 'yes') {
			m.CostCenter = validText(m.CostCenter, 2, 50);
			m.WacNeutFee = validCurrency(m.WacNeutFee, 0, 9999);

			var wnItems = m.WacNeutNdcFeeList,
				wnItem = {},
				wnFee = {};

			for(var wn = 0; wn < wnItems.length; wn++) {
				wnItem = wnItems[wn];

				if(!validSvc.isText(wnItem.NDC)) {
					wnItem.fail = 'yes';
					wnItem.msg = 'Ndc required';
				}
				else {
					wnFee = validCurrency({val:wnItem.Fee}, 0, 9999);
					if(wnFee.fail != 'no') {
						wnItem.fail = 'yes';
						wnItem.msg = 'Fee must be 0 to 9,999';
					}
				}

				if(wnItem.fail == 'yes') {
					m.CdcEnabled.fail = 'yes';
					m.CdcEnabled.msg = 'Ndc list errors';
				}
			}
		}
		else {
			m.CdcEnabled = validSvc.newProp('no');
			m.CostCenter = validSvc.newProp('');
			m.WacNeutFeeModel = validSvc.newProp('TRANS');
			m.WacNeutFee = validSvc.newProp(0);
			m.WacNeutNdcFeeModel = validSvc.newProp('TRANS');
			m.WacNeutNdcFeeList = [];
		}

		// PCC
		if(rxType != 'ROLLUP' && m.PCC.val == 'yes') {

			var pccItems = m.PCCItems,
				pccValid = true;

			if(pccItems.length < 1) {
				m.PCC.fail = 'yes';
				m.PCC.msg = '1 or more Dispense Payor Items required';
			}
			else {
				m.PCC.fail = 'no';
				m.PCC.msg = '';

				var pccItem = {},
					bin = '',
					pcn = '',
					grp = '',
					pccCombo = '',
					pccUnique = [];

				// validate each BIN/PCN/GRP set in the list
				for(var p = 0; p < pccItems.length; p++) {
					pccItem = pccItems[p];

					// BIN - required, 6 integers
					bin = pccItem.BIN.val;
					if(!validSvc.isText(bin) || !validSvc.isInteger(bin) || bin.toString().length != 6) {
						pccItem.BIN.fail = 'yes';
						pccItem.BIN.msg = 'required, 6 digit number';
						pccValid = false;
					}
					else {
						pccItem.BIN.fail = '';
					}

					// PCN - optional, 2 to 20 characters
					pcn = pccItem.PCN.val;
					if(validSvc.isText(pcn)) {
						pcn.trim();
						if(pcn.length < 2 || pcn.length > 20) {
							pccItem.PCN.fail = 'yes';
							pccItem.PCN.msg = 'optional, 2 to 20 characters';
							pccValid = false;
						}
						else {
							pccItem.PCN.fail = '';
						}
					}
					else {
						pccItem.PCN.fail = '';
					}

					// GroupNumber - optional, 2 to 20 characters
					grp = pccItem.GroupNumber.val;
					if(validSvc.isText(grp)) {
						grp.trim();
						if(grp.length < 2 || grp.length > 20) {
							pccItem.GroupNumber.fail = 'yes';
							pccItem.GroupNumber.msg = 'optional, 2 to 20 characters';
							pccValid = false;
						}
						else {
							pccItem.GroupNumber.fail = '';
						}
					}
					else {
						pccItem.GroupNumber.fail = '';
					}

					// combo is unique
					if(pccValid) {
						pccCombo = bin + '|' + pcn + '|' + grp;
						if(pccUnique.indexOf(pccCombo) < 0) {
							pccUnique.push(pccCombo);
						}
						else {
							pccValid = false;
							pccItem.BIN.fail = 'yes';
							pccItem.BIN.msg = '/PCN/GRP must be unique, already exists in list';
						}
					}
				}

				if(!pccValid) {
					m.PCC.fail = 'yes';
					m.PCC.msg = 'All items must be valid';
				}
			}
		}
		else {
			m.PCC = validSvc.newProp('no');
			m.PCCItems = [];
		}

		//DispenseExpiration
		if(m.DispenseExpiration.Enabled == 'yes') {
			var expDays = m.DispenseExpiration.MaxDispenseAge;
			if(!validSvc.isNumber(expDays) || expDays < 1 || expDays > 730) {
				m.DispenseExpiration.fail = 'yes';
				m.DispenseExpiration.msg = 'Dispense Expiration must be a number between 1 and 730';
			}
			else {
				m.DispenseExpiration.fail = 'no';
				m.DispenseExpiration.msg = '';
			}
		}

		// ce user claim access
		if(rxType != 'ROLLUP') {
			m.CeUserCanViewClaims = 'no';
		}

		// SeqExtPartyFolder
		if (m.SendOrderstoExtParty == 'yes') {
			m.SeqExtPartyFolder = validText(m.SeqExtPartyFolder, 3, 30);
			if(m.SeqExtPartyFolder.fail == 'no') {
				m.SeqExtPartyFolder.val = m.SeqExtPartyFolder.val.toUpperCase();
				var regexFolderName  = /[^A-Z0-9]/;
				if(regexFolderName.test(m.SeqExtPartyFolder.val)) {
					m.SeqExtPartyFolder.fail = 'yes';
					m.SeqExtPartyFolder.msg = 'must be 3 to 30 letters and numbers only';
				}
			}

		}

		// Claims Federation
		if(m.FederateRawClaims.val == 'yes' && m.ImportRawClaims.val == 'no') {
			m.FederateRawClaims.fail = 'yes';
			m.FederateRawClaims.msg = 'Federate Claims requires RAW CLAIMS importing to be enabled';
		}
		else {
			m.FederateRawClaims.fail = 'no';
			m.FederateRawClaims.msg = '';
		}

		// Use TPA NPI list for Claims Federation
		if(m.UseTpaNPIListForRawClaimsExport.val == 'yes' && m.FederateRawClaims.val == 'no') {
			m.UseTpaNPIListForRawClaimsExport.fail = 'yes';
			m.UseTpaNPIListForRawClaimsExport.msg = 'Use TPA NPI list requires FEDERATE CLAIMS to be enabled';
		}
		else {
			m.UseTpaNPIListForRawClaimsExport.fail = 'no';
			m.UseTpaNPIListForRawClaimsExport.msg = '';
		}

		// Federate 850s to CE
		m.Federate850sFail = '';
		if(m.SeqSplitStatus == 'on' && m.Federate850s == 'yes') {
			if(!validSvc.isText(m.Federate850sCEID) || m.Federate850sCEID == 'NONE') {
				m.Federate850sFail = 'A Facility CEID must be selected when Federate 850s to CE is enabled';
			}
		}

		// verisave fees
		m.FeeVerisaveFlat.fail = '';
		m.FeeVerisaveOrderPercent.fail = '';
		m.FeeVerisaveOrderPercentMinAmt.fail = '';
		m.FeeVerisaveOrderPercentMaxAmt.fail = '';
		if(vm.action == 'UPDATE' && rxType == 'DISPENSING' && (m.hasSPLIT || m.hasSPLITMATCH)) {
			switch(m.FeeVerisaveModel) {
				case 'FLAT':
					m.FeeVerisaveFlat = validCurrency(m.FeeVerisaveFlat, 0, 999999);
					break;
				case 'PERCENTAGESAVINGS':
					m.FeeVerisaveOrderPercent = validCurrency(m.FeeVerisaveOrderPercent, 0.0, 100.0);
					if(m.FeeVerisaveOrderPercent.val > 0) {
						// min amt is required if percent is > 0
						if(m.FeeVerisaveOrderPercentMinAmt.chk) {
							m.FeeVerisaveOrderPercentMinAmt = validCurrency(m.FeeVerisaveOrderPercentMinAmt, 1.0, 999999);
						}
						else {
							m.FeeVerisaveOrderPercentMinAmt = validSvc.newProp(0);
							m.FeeVerisaveOrderPercentMinAmtChk = false;
						}
						// max amt is required if percent is > 0
						if(m.FeeVerisaveOrderPercentMaxAmt.chk) {
							m.FeeVerisaveOrderPercentMaxAmt = validCurrency(m.FeeVerisaveOrderPercentMaxAmt, 1.0, 999999);
						}
						else {
							m.FeeVerisaveOrderPercentMaxAmt = validSvc.newProp(0);
							m.FeeVerisaveOrderPercentMaxAmtChk = false;
						}
					}
					break;
				default:
					m.FeeVerisaveFlat = validSvc.newProp(0);
					m.FeeVerisaveOrderPercent = validSvc.newProp(0);
					m.FeeVerisaveOrderPercentMinAmt = validSvc.newProp(0);
					m.FeeVerisaveOrderPercentMaxAmt = validSvc.newProp(0);
					break;
			}
		}
	
		// result
		return m.Id.fail != 'yes' &&
			m.AcctId.fail != 'yes' &&
			m.DivisionCode.fail != 'yes' &&
			m.StoreNumber.fail != 'yes' &&
			m.DailyTotalPackageLimit.fail != 'yes' &&
			m.DailyNDCPackageLimit.fail != 'yes' &&
			m.DailyRefrigeratedPackageLimit.fail != 'yes' &&
			m.BusinessModels.fail != 'yes' &&
			m.TpaProgAdmin.fail != 'yes' &&
			m.TpaPriceRate.fail != 'yes' &&
			m.TpaExtractDelay.fail != 'yes' &&
			m.Type.fail != 'yes' &&
			m.Name.fail != 'yes' &&
			m.ShortName.fail != 'yes' &&
			m.DispenseExpiration.fail != 'yes' &&
			m.NPI.fail != 'yes' &&
			m.NCPDP.fail != 'yes' &&
			m.PricingModel.fail != 'yes' &&
			m.PricingRate.fail != 'yes' &&
			m.BillFrequency.fail != 'yes' &&
			m.AccumulationDelay.fail != 'yes' &&
			m.CustomPriceVendor.fail != 'yes' &&
			m.CustomPriceVendorAccountNumber.fail != 'yes' &&
			m.CustomPriceAccumGrp.fail != 'yes' &&
			vm.seqSplitEdit.fail != 'yes' &&
			m.SeqPreSplitTimeout.fail != 'yes' &&
			m.SeqTimeout855s.fail != 'yes' &&
			m.ExtractNpisVisitLookback.fail != 'yes' &&
			m.MergeNpiInto.fail != 'yes' &&
			m.CostCenter.fail != 'yes' &&
			m.CdcEnabled.fail != 'yes' &&
			m.WacNeutFee.fail != 'yes' &&
			m.SeqApprovalTimeout.fail != 'yes' &&
			m.PCC.fail != 'yes' &&
			m.SeqExtPartyFolder.fail != 'yes' &&
			m.BillPayTpaDirect.fail != 'yes' && 
			m.FederateRawClaims.fail != 'yes' &&
			m.UseTpaNPIListForRawClaimsExport.fail != 'yes' &&
			m.Federate850sFail == '' &&
			m.DataExportsSchedule.fail != 'yes' &&
			m.FeeVerisaveFlat.fail != 'yes' &&
			m.FeeVerisaveOrderPercent.fail != 'yes' &&
			m.FeeVerisaveOrderPercentMinAmt.fail != 'yes' &&
			m.FeeVerisaveOrderPercentMaxAmt.fail != 'yes' &&
			addressOk;
	}

	function validZip(prop) {
		prop.fail = 'yes';
		prop.msg = '5 or 10 numbers with format: "12345-1234"';

		// is empty
		if(!validSvc.isText(prop.val)) {
			return prop;
		}

		// strip down to numbers and dash
		prop.val.replace(/[^0-9\-]+/g,'');

		// no dash, check length 5
		if(prop.val.indexOf('-') < 0) {
			if(prop.val.length != 5) {
				return prop;
			}
		}
		else {
			// has dash, check format "12345-1234"
			var zipVals = prop.val.split('-');
			if(zipVals.length != 2 || zipVals[0].length != 5 || zipVals[1].length != 4) {
				return prop;
			}
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;
	}


	function submitAcct() {

		if(vm.isWaiting) {
			return;
		}

		// cache the TPA info
		var tpaConfig = {};
		tpaConfig.TpaProgAdmin = JSON.parse(JSON.stringify(vm.model.TpaProgAdmin));
		tpaConfig.TpaPriceModel = JSON.parse(JSON.stringify(vm.model.TpaPriceModel));
		tpaConfig.TpaPriceRate = JSON.parse(JSON.stringify(vm.model.TpaPriceRate));

		tpaConfig.TpaExtractDispenses = JSON.parse(JSON.stringify(vm.model.TpaExtractDispenses));
		tpaConfig.UseGlobalNDCExcludeList= JSON.parse(JSON.stringify(vm.model.UseGlobalNDCExcludeList));
		tpaConfig.TpaExtractDelay = JSON.parse(JSON.stringify(vm.model.TpaExtractDelay));
		tpaConfig.TpaExtractExcludeNdc = JSON.parse(JSON.stringify(vm.model.TpaExtractExcludeNdc));
		tpaConfig.TpaExtractExcludeNdcList = JSON.parse(JSON.stringify(vm.model.TpaExtractExcludeNdcList));

		// validate
		if(!validAccount()) {
			msgSvc.ok('Cannot Save', 'All fields must be valid.');
			return false;
		}

		vm.isWaiting = true;

		// create or update
		if(vm.action == 'CREATE' || vm.model.Clone) {
			rxRepo.createAcct(vm.model).then(okUpsert, errUpsert);
		}
		else {
			rxRepo.updateAcct(vm.model).then(okUpsert, errUpsert);
		}

		// restore the tpa info in case rx has a rollup parent
		if(!!vm.model.RollupParent) {
			vm.model.TpaProgAdmin = tpaConfig.TpaProgAdmin;
			vm.model.TpaPriceModel = tpaConfig.TpaPriceModel;
			vm.model.TpaPriceRate = tpaConfig.TpaPriceRate;
	
			vm.model.TpaExtractDispenses = tpaConfig.TpaExtractDispenses;
			vm.model.UseGlobalNDCExcludeList = tpaConfig.UseGlobalNDCExcludeList;
			vm.model.TpaExtractDelay = tpaConfig.TpaExtractDelay;
			vm.model.TpaExtractExcludeNdc = tpaConfig.TpaExtractExcludeNdc;
			vm.model.TpaExtractExcludeNdcList = tpaConfig.TpaExtractExcludeNdcList;
		}
	}

	function okUpsert(r) {

		// account and address tabs share this OK outcome

		vm.isWaiting = false;

		msgSvc.ok(r.Id, 'Saved');

		// after CREATE, route to edit view
		if(vm.action == 'CREATE' || vm.model.Clone) {
			$state.go('admin.rx.edit', {RX: r.Id}, {reload: 'admin.rx.edit'});
		}
		else {

			// hide validation icons on successful update
			resetValidationState();

			// reset rollup view state
			vm.ruTabReady = false;

		}

	}

	function errUpsert(r) {

		// account and address tabs share this ERR outcome

		vm.isWaiting = false;

		if(r === null) {
			// already handled
		}
		else if(r.status === 409) {
			// conflict
			errSvc.info('Could not create or save, already exists in the database. Verify and try again.');
		}
		else if (r.status === 422) {
			// validation
			vm.model = r.model;

			if(vm.model.BusinessModels.fail == 'yes') {
				bizModelsEditToggle('on');
			}
			msgSvc.ok('Cannot Save', 'Server found invalid data, please fix and try again.');
		}
		else {
			errSvc.error('Unexpected api error', 'rxEditCtl.errUpsert', r.status, utilSvc.http.safeResponse(r));
		}

	}


	/**
	 *    STATUS CHANGE
	 */

	function statusChange(newStatus) {

		// already waiting?
		if(vm.isWaiting) {
			return;
		}

		// rollup has members?
		if(vm.model.Type.val == 'ROLLUP' && vm.model.RollupRxList.length > 0 && (newStatus == 'DELETED' || newStatus == 'INACTIVE')) {
			msgSvc.ok('Cannot Set Status ' + newStatus, 'Remove all Rollup members before changing status.');
			return;
		}

		// central fill has members?
		if(vm.model.Type.val == 'CENTRALFILL' && vm.model.CentralFillRxList.length > 0 && (newStatus == 'DELETED' || newStatus == 'INACTIVE')) {
			msgSvc.ok('Cannot Set Status ' + newStatus, 'Remove all Central Fill members before changing status.');
			return;
		}

		// ACTIVE status: rollup parent / billing model are correlated?
		if(newStatus == 'ACTIVE' && (vm.model.Type.val == 'DISPENSING' || vm.model.Type.val == 'CENTRALFILL')) {

			// validate as active
			var currentStatus = vm.model.ObjectState;
			vm.model.ObjectState = 'ACTIVE';
			if(!validAccount()) {
				vm.model.ObjectState = currentStatus;
				msgSvc.ok('Cannot Set Status ACTIVE', 'Properties are not valid, fix and save before setting status');
				return;
			}
			vm.model.ObjectState = currentStatus;
		}

		_pendingStatus = newStatus;

		switch(_pendingStatus) {

			case 'DELETED':
				// confirm user wants to set deleted status
				msgSvc.confirm({
					id: 'rx.acct.status',
					title: 'Delete Pharmacy',
					msg: 'Confirm status change to DELETED? This is not reversable.',
					buttons: [
						{text:'OK', result:'YES', cancel: false},
						{text:'CANCEL', result:'CANCEL', cancel: true}
					]
				}).then(confirmStatusChange, confirmStatusChange);
				break;

			case 'INACTIVE':
				// confirm user wants to set inactive (which will make all its affiliations inactive)
				msgSvc.confirm({
					id: 'rx.acct.status',
					title: 'InActive Pharmacy',
					msg: 'Confirm status change to INACTIVE? This will also set ALL affiliations to INACTIVE.',
					buttons: [
						{text:'OK', result:'YES', cancel: false},
						{text:'CANCEL', result:'CANCEL', cancel: true}
					]
				}).then(confirmStatusChange, confirmStatusChange);
				break;

			case 'ONBOARDING':
				var onbMsg = 'Confirm status change to ONBOARDING?';
				if(vm.model.ObjectState == 'ACTIVE') {
					onbMsg += ' This will also set ALL affiliations to ONBOARDING.';
				}

				// confirm user wants to set ONBOARDING (which will affect its affiliations)
				msgSvc.confirm({
					id: 'rx.acct.status',
					title: 'OnBoarding Pharmacy',
					msg: onbMsg,
					buttons: [
						{text:'OK', result:'YES', cancel: false},
						{text:'CANCEL', result:'CANCEL', cancel: true}
					]
				}).then(confirmStatusChange, confirmStatusChange);
				break;

			case 'ACTIVE':
				// try to save properties before changing status
				rxRepo.updateAcct(vm.model).then(statusPreSave, errUpsert);
				break;

			default:
				// no confirm needed
				confirmStatusChange({result:'YES'});
		}

	}

	function statusPreSave(r) {
		// bridge function from model save to status change

		// AcctId required for ACTIVE status
		if(_pendingStatus == 'ACTIVE' && !validSvc.isText(vm.model.AcctId.val)) {
			vm.model.AcctId.fail = 'yes';
			vm.model.AcctId.msg = 'required for ACTIVE status';
			msgSvc.ok('Cannot Change Status', 'Verity Intacct accounting id is required for ACTIVE status');
			return;
		}

		confirmStatusChange({result:'YES'});
	}

	function confirmStatusChange(r) {

		// user said yes to set status
		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;
			rxRepo.statusChange(vm.model.Id.val, _pendingStatus).then(okStatus, errStatus);
		}

		function okStatus(r) {

			vm.isWaiting = false;

			// id
			if(!!!r || !validSvc.isText(r.Id)) {
				throw new Error('rxEditCtl.okStatus, missing id');
			}

			$state.go('admin.rx.edit', {RX: r.Id}, {reload: 'admin.rx.edit'});

		}

		function errStatus(r) {

			vm.isWaiting = false;

			if(!!!r || r == null) {
				// already handled
				$state.go('admin.rx.list', {}, {reload:'admin.rx.list'});
			}
			else if(r.status == 409) {
				// conflict
				errSvc.info('Could not update status to: ' + _pendingStatus + '. Try again.', 'rxEditCtl.errStatus', r.status, utilSvc.http.safeResponse(r));
				_pendingStatus = '';
			}
			else {
				errSvc.error('Unknown status change error', 'rxEditCtl.errStatus', r.status, utilSvc.http.safeResponse(r));
			}

		}
	}

	function refreshStatusButtons(rxType, rxStatus) {

		// called after get and status updates

		vm.btnStatusChange = {
			show: false,
			ONBOARDING: false,
			ACTIVE: false,
			INACTIVE: false,
			DELETED: false
		};

		// exit if in create mode (status changes not allowed)
		if(vm.action == 'CREATE') {
			return;
		}

		var saUser = vm.context.uType == 'VERITYSA',
			isDebug = vm.context.isDebug;

		switch(rxStatus) {

			case 'QUEUED':
				vm.btnStatusChange.ONBOARDING = true;
				break;

			case 'ONBOARDING':
				vm.btnStatusChange.ACTIVE = true;
				vm.btnStatusChange.DELETED = saUser;
				break;

			case 'ACTIVE':
				vm.btnStatusChange.ONBOARDING = isDebug;
				vm.btnStatusChange.INACTIVE = true;
				break;

			case 'INACTIVE':
				vm.btnStatusChange.ACTIVE = true;
				vm.btnStatusChange.DELETED = saUser;
				break;

			case 'DELETED':
				vm.btnStatusChange.INACTIVE = saUser;
				break;

			default:
				throw new Error('rxEditCtl.refreshStatusButtons, rx status unknown: ' + rxStatus);

		}

		// show if at least one button is displayed
		vm.btnStatusChange.show = vm.btnStatusChange.ONBOARDING || vm.btnStatusChange.ACTIVE || vm.btnStatusChange.INACTIVE || vm.btnStatusChange.DELETED;

	}

	// CE user claim access for ROLLUP
	function toggleCeUserCanViewClaims() {
		vm.model.CeUserCanViewClaims = vm.model.CeUserCanViewClaims == 'no' ? 'yes' : 'no';
	}


	/**
	 *    CENTRAL FILL
	 */

	function cfTabClick() {

		// get rx list on first click
		if(!vm.cfTabReady) {
			vm.isWaiting = true;
			msgSvc.wait(true);

			rxRepo.getList().then(okList, errList);
		}

		function okList(r) {

			msgSvc.wait(false);
			vm.isWaiting = false;

			r.data = Array.isArray(r.data) ? r.data : [];

			// build available members table
			var newMembers = [];
			for(var i = 0; i < r.data.length; i++) {

				// must be status ACTIVE or ONBOARDING
				if(r.data[i].ObjectState == 'ACTIVE' || r.data[i].ObjectState == 'ONBOARDING') {

					// must be type DISPENSING and cannot have another Central Fill parent
					if(r.data[i].Type == 'DISPENSING' && !validSvc.isText(r.data[i].CentralFillPharmacy)) {

						// not already a Member
						if(vm.model.CentralFillRxList.indexOf(r.data[i].Id) < 0) {
							newMembers.push({
								Id: r.data[i].Id,
								PharmacyName: validSvc.isText(r.data[i].Name) ? r.data[i].Name : '',
								DivisionCode: validSvc.isText(r.data[i].DivisionCode) ? r.data[i].DivisionCode : '',
								StoreNumber: validSvc.isText(r.data[i].StoreNumber) ? r.data[i].StoreNumber : '',
								NPI: validSvc.isText(r.data[i].NPI) ? r.data[i].NPI : '',
								NCPDP: validSvc.isText(r.data[i].NCPDP) ? r.data[i].NCPDP : '',
								SearchText: [
									r.data[i].Id,
									r.data[i].Name,
									r.data[i].DivisionCode,
									r.data[i].StoreNumber,
									r.data[i].NPI,
									r.data[i].NCPDP
								].join(' ').toLowerCase(),
								checked: false,
								uniqueId: 'CFM_' + r.data[i].Id
							});
						}
					}
				}
			}
			newMembers.sort(function(a, b) {
				return a.Id.localeCompare(b.Id);
			});

			vm.cfMembersTbl = {
				DataItems: newMembers
			};
			vm.cfMembersById = cfMembersIndexById(r.data);
			vm.cfMemberListFlt = vm.initFilters({
				Text: {
					Id: '',
					PharmacyName: '',
					DivisionCode: '',
					StoreNumber: '',
					NPI: '',
					NCPDP: ''
				},
				SortBy: ['Id']
			});
			vm.cfMemberPicker = {
				show: false,
				flt: {
					Id: '',
					PharmacyName: '',
					DivisionCode: '',
					StoreNumber: '',
					NPI: '',
					NCPDP: ''
				}
			};
			cfMemberListBuild();

			// setup display items
			vm.cfTabReady = true;

		}

		function errList(r) {

			msgSvc.wait(false);
			vm.isWaiting = false;

			if(r === null) {
				// upstream is displaying a message already
				return;
			}
			else {
				// unknown
				r = r || {};
				errSvc.warn('Not able to get Central Fill pharmacy list.', 'rxEditCtl.cfTabClick.errList', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}

	/**
	 *    CENTRAL FILL MEMBERS
	 */

	function cfMemberAdd(rxid) {

		if(vm.isWaiting) {
			return;
		}

		// validate
		if(!validSvc.isRX(rxid)) {
			errSvc.info('Choose a Member to Add');
			return;
		}

		vm.isWaiting = true;
		_pendingMember = {
			action: 'add',
			rxid: rxid
		};

		rxRepo.cfMemberAdd(_currentRX, rxid).then(okCfMember, errCfMember);

	}

	function cfMemberAddSelected() {

		if(vm.isWaiting) {
			return;
		}

		var items = Array.isArray(vm.cfMembersTbl.DataItems) ? vm.cfMembersTbl.DataItems : [],
			selectedIds = [];

		for(var i = 0; i < items.length; i++) {
			if(!!items[i].checked && validSvc.isRX(items[i].Id)) {
				selectedIds.push(items[i].Id);
			}
		}

		if(selectedIds.length < 1) {
			errSvc.info('Choose one or more Members to Add');
			return;
		}

		cfMemberAddQueue(selectedIds, 0);

	}

	function cfMemberAddQueue(ids, idx) {

		if(idx >= ids.length) {
			return;
		}

		var rxid = ids[idx];

		vm.isWaiting = true;
		_pendingMember = {
			action: 'add',
			rxid: rxid
		};

		rxRepo.cfMemberAdd(_currentRX, rxid).then(function(r) {
			okCfMember(r);
			cfMemberAddQueue(ids, idx + 1);
		}, function(r) {
			errCfMember(r);
			cfMemberAddQueue(ids, idx + 1);
		});

	}

	function cfMemberRemove(rxid) {

		if(vm.isWaiting) {
			return;
		}

		// validate
		if(!validSvc.isRX(rxid)) {
			throw new Error('rxEditCtl.cfMemberRemove, rxid is not valid: ' + rxid);
		}

		vm.isWaiting = true;
		_pendingMember = {
			action: 'remove',
			rxid: rxid
		};

		rxRepo.cfMemberRemove(_currentRX, rxid).then(okCfMember, errCfMember);

	}

	function okCfMember(r) {

		vm.isWaiting = false;

		switch(_pendingMember.action) {

			case 'add':

				// add to model
				vm.model.CentralFillRxList.push(_pendingMember.rxid);
				vm.model.CentralFillRxList.sort();

				// remove from available member table
				for(var iremove = 0; iremove < vm.cfMembersTbl.DataItems.length; iremove++) {
					if(vm.cfMembersTbl.DataItems[iremove].Id == _pendingMember.rxid) {
						vm.cfMembersTbl.DataItems.splice(iremove, 1);
						break;
					}
				}

				vm.cfMemberPicker.show = false;
				cfMemberListBuild();
				break;

			case 'remove':

				// remove from model
				var idx = vm.model.CentralFillRxList.indexOf(_pendingMember.rxid);
				if(idx < 0) {
					throw new Error('rxEditCtl.okCfMember, rxid [' + _pendingMember.rxid + '] not found in array: vm.model.CentralFillRxList');
				}
				vm.model.CentralFillRxList.splice(idx, 1);

				// add back to available member table
				var exists = false;
				for(var iadd = 0; iadd < vm.cfMembersTbl.DataItems.length; iadd++) {
					if(vm.cfMembersTbl.DataItems[iadd].Id == _pendingMember.rxid) {
						exists = true;
						break;
					}
				}
				if(!exists) {
					var src = vm.cfMembersById[_pendingMember.rxid] || {};
					vm.cfMembersTbl.DataItems.push({
						Id: _pendingMember.rxid,
						PharmacyName: validSvc.isText(src.PharmacyName) ? src.PharmacyName : '',
						DivisionCode: validSvc.isText(src.DivisionCode) ? src.DivisionCode : '',
						StoreNumber: validSvc.isText(src.StoreNumber) ? src.StoreNumber : '',
						NPI: validSvc.isText(src.NPI) ? src.NPI : '',
						NCPDP: validSvc.isText(src.NCPDP) ? src.NCPDP : '',
						SearchText: [
							_pendingMember.rxid,
							src.PharmacyName,
							src.DivisionCode,
							src.StoreNumber,
							src.NPI,
							src.NCPDP
						].join(' ').toLowerCase(),
						checked: false,
						uniqueId: 'CFM_' + _pendingMember.rxid
					});
					vm.cfMembersTbl.DataItems.sort(function(a, b) {
						return a.Id.localeCompare(b.Id);
					});
				}

				vm.cfMemberPicker.show = false;
				cfMemberListBuild();
				break;

			default:
				throw new Error('rxEditCtl.okCfMember, pending action unknown: ' + _pendingMember.action);
		}

	}

	function errCfMember(r) {

		vm.isWaiting = false;

		if(!!r) {
			errSvc.error('Unknown Member error', 'rxEditCtl.' + _pendingMember.action, r.status, utilSvc.http.safeResponse(r));
		}

	}

	function cfMemberToggle(item) {

		if(!item) {
			return;
		}

		item.checked = !!!item.checked;

	}

	function cfMemberToggleAll(checked) {

		var items = Array.isArray(vm.cfMembersTbl.DataItems) ? vm.cfMembersTbl.DataItems : [];
		for(var i = 0; i < items.length; i++) {
			items[i].checked = !!checked;
		}

	}

	function cfMemberSelectedCount() {

		var items = Array.isArray(vm.cfMembersTbl.DataItems) ? vm.cfMembersTbl.DataItems : [],
			count = 0;

		for(var i = 0; i < items.length; i++) {
			if(!!items[i].checked) {
				count++;
			}
		}

		return count;

	}

	function cfMembersIndexById(items) {

		var indexById = {},
			item = {};

		items = Array.isArray(items) ? items : [];
		for(var i = 0; i < items.length; i++) {
			item = items[i] || {};
			if(validSvc.isText(item.Id)) {
				indexById[item.Id] = {
					Id: item.Id,
					PharmacyName: validSvc.isText(item.Name) ? item.Name : '',
					DivisionCode: validSvc.isText(item.DivisionCode) ? item.DivisionCode : '',
					StoreNumber: validSvc.isText(item.StoreNumber) ? item.StoreNumber : '',
					NPI: validSvc.isText(item.NPI) ? item.NPI : '',
					NCPDP: validSvc.isText(item.NCPDP) ? item.NCPDP : ''
				};
			}
		}

		return indexById;

	}

	function cfMemberRowVM(rxid) {

		var src = vm.cfMembersById[rxid] || {};
		return {
			uniqueId: 'CFM_LIST_' + rxid,
			Id: rxid,
			PharmacyName: validSvc.isText(src.PharmacyName) ? src.PharmacyName : '',
			DivisionCode: validSvc.isText(src.DivisionCode) ? src.DivisionCode : '',
			StoreNumber: validSvc.isText(src.StoreNumber) ? src.StoreNumber : '',
			NPI: validSvc.isText(src.NPI) ? src.NPI : '',
			NCPDP: validSvc.isText(src.NCPDP) ? src.NCPDP : ''
		};

	}

	function cfMemberListBuild() {

		var ids = Array.isArray(vm.model.CentralFillRxList) ? vm.model.CentralFillRxList : [],
			rows = [];

		for(var i = 0; i < ids.length; i++) {
			if(validSvc.isText(ids[i])) {
				rows.push(cfMemberRowVM(ids[i]));
			}
		}

		vm.cfMemberListTbl = {
			DataItems: rows,
			Items: []
		};

		if(!vm.cfMemberListFlt.Ready) {
			vm.cfMemberListFlt.Ready = true;
		}

		cfMemberListFilterChange(true);

	}

	function cfMemberListFilterChange(immediate) {

		if(!vm.cfMemberListFlt.Ready) {
			return;
		}

		vm.cfMemberListFlt.Dirty = true;
		if(vm.cfMemberListFlt.Busy) {
			return;
		}

		vm.cfMemberListFlt.Busy = true;
		vm.cfMemberListFlt.Dirty = false;

		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			vm.cfMemberListTbl.Items = vm.filterList(vm.cfMemberListTbl.DataItems, vm.cfMemberListFlt);
			vm.cfMemberListFlt.Busy = false;

			if(vm.cfMemberListFlt.Dirty) {
				cfMemberListFilterChange(true);
				return;
			}

			$scope.$broadcast('widget.paging', {
				uniqueId: 'RX_EDIT_CF_MEMBERS',
				Size: vm.cfMemberListFlt.PageSize,
				Page: vm.cfMemberListFlt.Page,
				Total: vm.cfMemberListFlt.PageTotal,
				RowCount: vm.cfMemberListFlt.Count,
				ItemCount: vm.cfMemberListTbl.Items.length,
				DataCount: vm.cfMemberListTbl.DataItems.length
			});

		}, delayTime);

	}



	/**
	 *    ROLLUP MEMBERS
	 */

	function ruTabClick() {

		// get rx list on first click
		if(!vm.ruTabReady) {
			vm.isWaiting = true;
			msgSvc.wait(true);

			rxRepo.getList().then(okList, errList);
		}

		function okList(r) {

			msgSvc.wait(false);
			vm.isWaiting = false;

			r.data = Array.isArray(r.data) ? r.data : [];

			// build rx members droplist
			vm.ruNewMember = 'NONE';
			var newMembers = [],
				addMember = null,
				rollupParentBizModels = bizModelsToArray(vm.model),
				rxModels = [],
				sameModels = false;

			for(var i = 0; i < r.data.length; i++) {
				addMember = r.data[i];

				// must be status ACTIVE or ONBOARDING
				if(addMember.ObjectState == 'ACTIVE' || addMember.ObjectState == 'ONBOARDING') {

					// must be type DISPENSING or CENTRALFILL and cannot have another ROLLUP parent
					if((addMember.Type == 'DISPENSING' || addMember.Type == 'CENTRALFILL') && !validSvc.isText(addMember.RollupParent)) {

						// not already a Member
						if(vm.model.RollupRxList.indexOf(addMember.Id) < 0) {

							// must have matching business models
							rxModels = bizModelsToArray(addMember);
							sameModels = true;
							for(var ii = 0; ii < rxModels.length; ii++) {
								if(rollupParentBizModels.indexOf(rxModels[ii]) < 0) {
									sameModels = false;
									break;
								}
							}

							if(sameModels) {
								newMembers.push(addMember.Id);
							}
						}
					}
				}
			}
			newMembers.sort();
			vm.ruNewMemberDroplist = utilSvc.ng.droplist(newMembers,'','',[{label:'Add Pharmacy Member', value:'NONE'}]);

			vm.ruTabReady = true;

		}

		function errList(r) {

			msgSvc.wait(false);
			vm.isWaiting = false;

			if(r === null) {
				// upstream is displaying a message already
				return;
			}
			else {
				// unknown
				r = r || {};
				errSvc.warn('Not able to get Rollup pharmacy list.', 'rxEditCtl.ruTabClick.errList', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	function ruMemberAdd(rxid) {

		if(vm.isWaiting) {
			return;
		}

		// validate
		if(!validSvc.isRX(rxid)) {
			errSvc.info('Choose a Member to Add');
			return;
		}

		vm.isWaiting = true;
		_pendingMember = {
			action: 'add',
			rxid: rxid
		};

		rxRepo.ruMemberAdd(_currentRX, rxid).then(okRuMember, errRuMember);

	}

	function ruMemberRemove(rxid) {

		if(vm.isWaiting) {
			return;
		}

		// validate
		if(!validSvc.isRX(rxid)) {
			throw new Error('rxEditCtl.ruMemberRemove, rxid is not valid: ' + rxid);
		}

		vm.isWaiting = true;
		_pendingMember = {
			action: 'remove',
			rxid: rxid
		};

		rxRepo.ruMemberRemove(_currentRX, rxid).then(okRuMember, errRuMember);

	}

	function okRuMember(r) {

		vm.isWaiting = false;

		switch(_pendingMember.action) {

			case 'add':

				// add to model
				vm.model.RollupRxList.push(_pendingMember.rxid);
				vm.model.RollupRxList.sort();

				// remove from dropdown
				for(var iremove = 0; iremove < vm.ruNewMemberDroplist.length; iremove++) {
					if(vm.ruNewMemberDroplist[iremove].value == _pendingMember.rxid) {
						vm.ruNewMemberDroplist.splice(iremove, 1);
						break;
					}
				}

				vm.ruNewMember = 'NONE';
				break;

			case 'remove':

				// remove from model
				var idx = vm.model.RollupRxList.indexOf(_pendingMember.rxid);
				if(idx < 0) {
					throw new Error('rxEditCtl.okRuMember, rxid [' + rxid + '] not found in array: vm.model.RollupRxList');
				}
				vm.model.RollupRxList.splice(idx, 1);

				// add to dropdown
				var newDroplist = [_pendingMember.rxid];
				for(var iadd = 0; iadd < vm.ruNewMemberDroplist.length; iadd++) {
					newDroplist.push(vm.ruNewMemberDroplist[iadd].value);
				}
				newDroplist.splice(newDroplist.indexOf('NONE'), 1);
				newDroplist.sort();
				vm.ruNewMemberDroplist = utilSvc.ng.droplist(newDroplist,'','',[{label:'Add Pharmacy Member', value:'NONE'}]);

				vm.ruNewMember = 'NONE';
				break;

			default:
				throw new Error('rxEditCtl.okRuMember, pending action unknown: ' + _pendingMember.action);
		}

	}

	function errRuMember(r) {

		vm.isWaiting = false;

		if(!!r) {
			errSvc.error('Unknown Member error', 'rxEditCtl.errRuMember' + _pendingMember.action, r.status, utilSvc.http.safeResponse(r));
		}

	}

	function loadRollupDisplay(rollups) {

		// ASYNC routine to get RX short names

		lookupRepo.RxInfo(rollups).then(okLookupRx, errLookupRx);

		function okLookupRx(items) {

			// save rollup affs array
			var rollupAffs = [];
			items = Array.isArray(items) ? items : [];
			for(var i = 0; i < items.length; i++) {
				if(_currentRX != items[i].NickName) {
					rollupAffs.push({
						RXID:items[i].NickName,
						RxName: items[i].Name,
						RxShortName: items[i].ShortName
					});
				}
			}

			vm.RollupDroplist = utilSvc.aff.rxDroplist(rollupAffs);
			vm.RollupDroplist[0].label = 'Choose a Rollup Pharmacy';

		}

		function errLookupRx(r) {
			if(!!r) {
				errSvc.warn('Error loading rollup display properties', 'ctlBillingRx.loadRollupDisplay', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    TPA EXTRACT NDCS
	 */

	function extractNdcAdd() {

		if(vm.isWaiting) {
			return;
		}

		// clean up ndc
		var ndcClean = ndcCleanUp(vm.model.TpaExtractExcludeNdc.val);
		vm.model.TpaExtractExcludeNdc.val = ndcClean.val;

		// valid?
		if(ndcClean.fail) {
			msgSvc.ok('Cannot Add NDC Extract', ndcClean.msg);
			return;
		}
		var ndcVal = vm.model.TpaExtractExcludeNdc.val;

		// already in list?
		var ndcList = vm.model.TpaExtractExcludeNdcList;
		for(var i = 0; i < ndcList.length; i++) {
			if(ndcList[i].val == ndcVal) {
				msgSvc.ok('Cannot Add NDC Extract', ndcVal + ' already added');
				return;
			}
		}

		// add to list
		vm.model.TpaExtractExcludeNdcList = addToExtractNdcs(ndcVal);
		vm.model.TpaExtractExcludeNdc.val = '';

	}

	function extractNdcRemove(ndc) {

		if(vm.isWaiting) {
			return;
		}

		// find ndc to remove
		var ndcList = vm.model.TpaExtractExcludeNdcList;
		for(var i = ndcList.length - 1; i >= 0; i--) {
			if(ndcList[i].val == ndc) {
				ndcList.splice(i, 1);
			}
		}

	}


	/**
	 *    GPI GOVERNOR LIST
	 */

	function gpiGovAdd() {

		var gpiTest = validSvc.newProp(vm.gpiGovNew);
		gpiTest = validText(gpiTest, 14, 14);
		if(gpiTest.fail == 'yes') {
			msgSvc.ok('Cannot Add GPI', gpiTest.msg);
			return;
		}

		vm.model.GovernedGPIs.push(gpiTest);
		vm.model.GovernedGPIs = utilSvc.array.sortASC(vm.model.GovernedGPIs, 'val');
		vm.gpiGovNew = '';

	}

	function gpiGovRemove(gpi) {

		var idx = -1;
		for(var i = 0; i < vm.model.GovernedGPIs.length; i++) {
			if(vm.model.GovernedGPIs[i].val == gpi) {
				idx = i;
				break;
			}
		}
		if(idx < 0) {
			alert('GPI not found in GovernedGPIs list: ' + gpi);
			return;
		}

		vm.model.GovernedGPIs.splice(idx, 1);

	}

	function gpiConstraintSelect() {
		if(vm.model.GpiConstraints != vm.savedGpiConstraints) {
			vm.unsavedGpiConstraints = true;
		} else {
			vm.unsavedGpiConstraints = false;
		}
	}

	function gpiGroupSelect() {
		if(vm.model.GenericGrouping != vm.savedGenericGrouping) {
			vm.unsavedGpiGrouping = true;
		} else {
			vm.unsavedGpiGrouping = false;
		}
	}

	function purchaseHistorySelect() {
		if(vm.model.Governor != vm.savedGovernor) {
			vm.unsavedPurchaseHistory = true;
		} else {
			vm.unsavedPurchaseHistory = false;
		}
	}


	/**
	 *    BIZ MODELS EDITING
	 */

	function addModelsClick(addModels) {

		if(vm.isWaiting) {
			return;
		}

		if(addModels == 'no') {
			// remove all models
			vm.bizModelsEdit = false;
			vm.model.BusinessModels.fail = 'no';
			vm.bizModelsChecked = setBizModelsCheckboxUI(null);
			bizModelsApply(true);
		}
		else if(addModels == 'yes') {
			vm.bizModelsEdit = true;
			vm.bizModelsChecked = setBizModelsCheckboxUI(vm.model);
			vm.bizModelsChecked.addModels = 'yes';
		}

	}

	function bizModelsEditToggle(editState) {

		// show / hide model editing UI

		vm.bizModelsEdit = editState == 'on';
		vm.bizModelsChecked = setBizModelsCheckboxUI(vm.model);

	}

	function bizModelsCheck(addModel) {

		// UI checked event: validate last checked item is ok

		// check means change to edit mode
		vm.bizModelsEdit = true;

		var rxModels = bizModelsCheckboxesToArray(vm.bizModelsChecked),
			rxModel = '',
			errTxt = '';

		// toggle off checkbox
		if(!!vm.bizModelsChecked[addModel]) {
			vm.bizModelsChecked[addModel] = false;
			return;
		}

		if(rxModels.length > 1) {
			// too many
			errTxt = 'Maximum 2 models can be applied';
		}
		else if(vm.model.Type.val == 'ROLLUP' && rxModels.length === 1) {
			errTxt = 'ROLLUP type must have 1 business model';
		}
		else if(vm.model.Type.val == 'ROLLUP' && (addModel == 'SPLIT' || addModel == 'SPLITMATCH')) {
			errTxt = 'ROLLUP type supports CP or CPTPA business models only';
		}
		else if(vm.model.CdcEnabled.val == 'yes' && addModel != 'SPLIT' && addModel != 'SPLITMATCH') {
			errTxt = 'CDC is enabled, only SPLIT or SPLITMATCH models can be chosen';
		}
		else if(rxModels.length === 1) {

			// adding > 1, check combination of models
			rxModels.push(addModel);

			if(!bizModelsValidCombo(rxModels)) {
				errTxt = rxModels[0] + ' cannot combine with ' + addModel;
			}

		}

		if(errTxt.length > 0) {
			msgSvc.ok('Cannot Apply Model', errTxt);
		}
		else {
			// ok to apply
			vm.bizModelsChecked[addModel] = true;
		}

	}

	function bizModelsValidCombo(rxModels) {

		// validates which models are compatible

		if(rxModels.length < 1) {
			return false;
		}
		else if(rxModels.length === 1) {
			return true;
		}
		else if(rxModels.length > 2) {
			return false;
		}
		else {

			var rxModel = rxModels[0];
			switch(rxModel) {

				case 'CP':
					// CP and SPLITMATCH are ok together
					if(rxModels[1] == 'SPLITMATCH') {
						return true;
					}
					break;

				case 'SPLITMATCH':
					// CP + SPLITMATCH, SPLIT + SPLITMATCH are ok together
					if(rxModels[1] == 'CP' || rxModels[1] == 'SPLIT') {
						return true;
					}
					break;

				case 'CPTPA':
					// CPTPA cannot be combined with anything
					break;

				case 'SPLIT':
					// SPLIT + SPLITMATCH are ok together
					if(rxModels[1] == 'SPLITMATCH') {
						return true;
					}
					break;

				default:
					throw new Error('rxEditCtl.bizModelsValidCombo, unknown model: ' + rxModel);
			}

			return false;

		}

	}

	function bizModelsValid(rxModels) {

		// save validation verifies the model to save is valid

		var m = vm.model;

		if(rxModels.length < 1) {
			m.BusinessModels.fail = 'yes';
			m.BusinessModels.msg = 'At least 1 business model is required';
			return false;
		}

		// too many
		if(rxModels.length > 2) {
			m.BusinessModels.fail = 'yes';
			m.BusinessModels.msg = 'Maximum 2 models can be applied';
			return false;
		}

		// rollup issues
		if(m.Type.val == 'ROLLUP') {
			if(rxModels.length !== 1) {
				m.BusinessModels.fail = 'yes';
				m.BusinessModels.msg = 'ROLLUP type can only have 1 business model';
				return false;
			}
			else if(m.hasSPLIT || m.hasSPLITMATCH) {
				m.BusinessModels.fail = 'yes';
				m.BusinessModels.msg = 'ROLLUP type can only use a CP or CPTPA business model';
				return false;
			}
		}

		// compatible
		if(!bizModelsValidCombo(rxModels)) {
			m.BusinessModels.fail = 'yes';
			m.BusinessModels.msg = 'Business Models are not compatible with each other';
			return false;
		}

		var uiModels = {
			CP: rxModels.indexOf('CP') > -1,
			CPTPA: rxModels.indexOf('CPTPA') > -1,
			SPLIT: rxModels.indexOf('SPLIT') > -1,
			SPLITMATCH: rxModels.indexOf('SPLITMATCH') > -1
		};

		// CDC / WACNEUT
		if(m.CdcEnabled.val == 'yes' && (uiModels.CP || uiModels.CPTPA)) {
			m.CdcEnabled.fail = 'yes';
			m.CdcEnabled.msg = 'Compatible with SPLIT and SPLITMATCH models only';
			m.BusinessModels.fail = 'yes';
			m.BusinessModels.msg = 'CDC compatible with SPLIT and SPLITMATCH models only';
			return false;
		}

		// changed since last save?
		if(vm.action == 'UPDATE') {

			if(m.hasCP != uiModels.CP ||
				m.hasCPTPA != uiModels.CPTPA ||
				m.hasSPLIT != uiModels.SPLIT ||
				m.hasSPLITMATCH != uiModels.SPLITMATCH) {

				// can't change models if ROLLUP parent with members, or child of ROLLUP

				// rollup parent
				if(m.Type.val == 'ROLLUP' && m.RollupRxList.length > 0) {
					m.BusinessModels.fail = 'yes';
					m.BusinessModels.msg = 'Cannot change business models, this Rollup has members';
					return false;
				}

				// rollup member
				if((m.Type.val == 'DISPENSING' || m.Type.val == 'CENTRALFILL') && validSvc.isText(m.RollupParent)) {
					m.BusinessModels.fail = 'yes';
					m.BusinessModels.msg = 'Cannot change business models, this pharmacy is a member of Rollup: ' + m.RollupParent;
					return false;
				}

			}

		}

		m.BusinessModels.fail = 'no';
		return true;

	}

	function bizModelsApply(skipValidation) {

		if(!!!skipValidation) {
			var rxEditModels = bizModelsCheckboxesToArray(vm.bizModelsChecked);
			if(!bizModelsValid(rxEditModels)) {
				msgSvc.ok('Cannot Apply', 'Check error text for more information');
				return;
			}
		}

		// apply ui checkboxes to model
		var m = vm.model;
		m.hasCP = !!vm.bizModelsChecked.CP;
		m.hasCPTPA = !!vm.bizModelsChecked.CPTPA;
		m.hasSPLIT = !!vm.bizModelsChecked.SPLIT;
		m.hasSPLITMATCH = !!vm.bizModelsChecked.SPLITMATCH;

		m = bizModelsChanged(m);
		vm.bizModelsEdit = false;

		if(vm.action == 'UPDATE') {
			msgSvc.ok('Models Changed', 'Save pharmacy to apply model changes');
		}

	}

	function bizModelsChanged(m) {

		// BizModel affects other properties

		if(vm.action != 'CREATE') {
			return m;
		}

		// accum delay adjustment
		if(m.Accumulate == 'yes') {
			if(!!m.hasSPLIT && (!validSvc.isInteger(m.AccumulationDelay.val) || m.AccumulationDelay.val === 14)) {
				// note: the default is already set to 0, this is only needed in the case a user chooses CP/CPTPA and then switches it back to  SPLIT/SPLITMATCH
				m.AccumulationDelay = validSvc.newProp(0);
			}
			else if((!!m.hasCP || !!m.hasCPTPA || !!m.hasSPLITMATCH) && (!validSvc.isInteger(m.AccumulationDelay.val) || m.AccumulationDelay.val < 1)) {
				m.AccumulationDelay = validSvc.newProp(14);
			}
		}

		// turn on Billing if user chooses CP biz model
		if(m.hasCP && m.BillEnabled == 'no') {
			m.BillEnabled = 'yes';
			m.BillExport = 'yes';
			m.BillExportFees = 'yes';
			m.BillExportDrugCost = 'yes';
		}

		// CP - toggle Pricing (per Georgia only CP has pricing)
		m.PricingEnabled = m.hasCP ? 'yes' : 'no';

		return m;

	}


	/**
	 *    BIZ MODELS UI CHECKBOXES
	 *    parse to/from UI checkbox biz models display
	 */

	function setBizModelsCheckboxUI(model) {

		model = model || {};

		var result = {
			CP: !!model.hasCP,
			CPTPA: !!model.hasCPTPA,
			SPLIT: !!model.hasSPLIT,
			SPLITMATCH: !!model.hasSPLITMATCH
		};
		result.addModels = (result.CP || result.CPTPA || result.SPLIT || result.SPLITMATCH) ? 'yes' : 'no';

		return result;

	}

	function bizModelsCheckboxesToArray(checked) {

		// convert ui checkboxes into an array of models

		var rxModels = [];

		if(!!checked.CP) {
			rxModels.push('CP');
		}
		if(!!checked.CPTPA) {
			rxModels.push('CPTPA');
		}
		if(!!checked.SPLIT) {
			rxModels.push('SPLIT');
		}
		if(!!checked.SPLITMATCH) {
			rxModels.push('SPLITMATCH');
		}

		return rxModels;
	}


	/**
	 *    BIZ MODELS ARRAY
	 *    parse model "hasModel" properties to/from an array
	 */

	function bizModelsToArray(m) {

		// convert data model "has" properties into an array of models

		var rxModels = [];

		if(!!m.hasCP) {
			rxModels.push('CP');
		}
		if(!!m.hasCPTPA) {
			rxModels.push('CPTPA');
		}
		if(!!m.hasSPLIT) {
			rxModels.push('SPLIT');
		}
		if(!!m.hasSPLITMATCH) {
			rxModels.push('SPLITMATCH');
		}

		return rxModels;
	}

	function bizModelsToText(m) {

		var result = [];

		if(!!m.hasCP) {
			result.push('Contract Pharmacy (CP)');
		}
		if(!!m.hasCPTPA) {
			result.push('Contract Pharmacy with TPA (CPTPA)');
		}
		if(!!m.hasSPLIT) {
			result.push('Splitting Pharmacy (SPLIT)');
		}
		if(!!m.hasSPLITMATCH) {
			result.push('Splitting Pharmacy with Matching (SPLITMATCH)');
		}

		return result.join(', ');

	}


	/**
	 *    SEQUENTIAL SPLITTING
	 */

	function seqSplitVM() {

		// ce affs
		var affs = utilSvc.aff.findRx($scope.User.AffList, vm.model.Id.val),
			affIdx = -1;
		affs = utilSvc.aff.findStatus(affs);
		affs = utilSvc.aff.ceList(affs);

		// remove any CEs already in model
		var ceList = vm.model.SeqCEs;
		for (var i = 0; i < ceList.length; i++) {
			affIdx = affs.indexOf(ceList[i].val);
			if(affIdx > -1) {
				affs.splice(affIdx, 1);
			}
		}

		return {
			show: false,
			addItem: '',
			droplist: utilSvc.ng.droplist(affs),
			fail: ''
		};

	}

	function seqSplitStatusChange(userChoice) {

		if(vm.isWaiting) {
			return;
		}

		vm.model.SeqSplitStatus = userChoice;
		if(userChoice == 'off') {
			resetSeqSplitProps(vm.model);
		}

	}

	function seqCEsAdd() {

		if(vm.isWaiting) {
			return;
		}

		if(!validSvc.isText(vm.seqSplitEdit.addItem)) {
			msgSvc.ok('Cannot Add', 'Please choose a Facility to add.');
			return;
		}

		// find idx of this CE in the list
		var idx = -1,
			ceList = vm.seqSplitEdit.droplist,
			ceNew = vm.seqSplitEdit.addItem;
		for(var i = 0; i < ceList.length; i++) {
			if(ceList[i].value == ceNew) {
				idx = i;
				break;
			}
		}
		if(idx < 0) {
			throw new Error('rxEditCtl.seqCEsAdd, cannot find CE in list: ' + ceNew);
		}

		// add to list, remove from droplist
		vm.model.SeqCEs.push(validSvc.newProp(ceNew));
		vm.seqSplitEdit.droplist.splice(idx, 1);
		vm.seqSplitEdit.addItem = '';

	}

	function seqCEsRemove(ceRemove) {

		if(vm.isWaiting) {
			return;
		}

		// find idx of this CE in the list
		var idx = -1,
			ceList = vm.model.SeqCEs;

		for(var i = 0; i < ceList.length; i++) {
			if(ceList[i].val == ceRemove) {
				idx = i;
				break;
			}
		}
		if(idx < 0) {
			throw new Error('rxEditCtl.seqCEsRemove, cannot find CE in list: ' + ceRemove);
		}

		// remove from model
		vm.model.SeqCEs.splice(idx, 1);

		// add back to droplist options
		ceList = vm.seqSplitEdit.droplist;
		var newDroplist = [];
		for(var rm = 0; rm < ceList.length; rm++) {
			newDroplist.push(ceList[rm].value);
		}
		newDroplist.push(ceRemove);
		newDroplist.sort();

		vm.seqSplitEdit.droplist = utilSvc.ng.droplist(newDroplist);

	}

	function seqCEsPriority(ceMove, upDown) {

		if(vm.isWaiting) {
			return;
		}

		// find idx of this CE in the list
		var idx = -1,
			ceList = vm.model.SeqCEs;

		for(var i = 0; i < ceList.length; i++) {
			if(ceList[i].val == ceMove) {
				idx = i;
				break;
			}
		}
		if(idx < 0) {
			throw new Error('rxEditCtl.seqCEsRemove, cannot find CE in list: ' + ceRemove);
		}

		// at top or bottom already
		if(idx + upDown < 0 || idx + upDown >= vm.model.SeqCEs.length) {
			return;
		}

		// swap
		var swapTo = angular.toJson(vm.model.SeqCEs[idx + upDown]);
		vm.model.SeqCEs[idx + upDown] = vm.model.SeqCEs[idx];
		vm.model.SeqCEs[idx] = angular.fromJson(swapTo);

	}

	function seqSplitCombine855s(combine) {

		// user is going from no to yes, set the default value
		if(combine == 'yes' && vm.model.SeqTimeout855s.val <= 0) {
			vm.model.SeqTimeout855s = validSvc.newProp(60);
		}

		vm.model.SeqCombine855s = combine;

	}

	function resetVendorDroplists() {
		var seqDroplistToUse = [],
			customListToUse = [],
			altAccounts = vm.model.SeqAltVendorAccounts,
			baseList = vm.BaseVendorDroplist;
		
		// now build vendors from base removing any vendor in use

		for (var i = 0; i < baseList.length; i++){
			// check wholesale account as well
			if (baseList[i].value == vm.model.CustomPriceVendor.val) {
				customListToUse.push(baseList[i]);
				continue;
			}
			var alreadyGotOne = false;
			for(var j = 0; j < altAccounts.length; j++) {
				if(altAccounts[j].Vendor == baseList[i].value) {
					alreadyGotOne = true;
					break;
				}
			}
			if (alreadyGotOne) {
				continue;
			}
			
			customListToUse.push(baseList[i]);
			if(baseList[i].value == 'NONE') {
				continue;
			}
			seqDroplistToUse.push(baseList[i]);
		}
		vm.VendorDroplist = customListToUse;
		vm.seqSplitAccountsVendorDroplist = seqDroplistToUse;
	}


	function seqSplitAccountsVM() {

		return {
			show: false,
			addVendor: '',
			addAccount: '',
			fail: ''
		};

	}

	function seqAltAccountAdd() {

		if(vm.isWaiting) {
			return;
		}

		if(!validSvc.isText(vm.seqSplitEditAccounts.addVendor)) {
			msgSvc.ok('Cannot Add', 'Please choose a Vendor to add.');
			return;
		}

		if(!validSvc.isText(vm.seqSplitEditAccounts.addAccount)) {
			msgSvc.ok('Cannot Add', 'Please provide an account number.');
			return;
		}

		// add to list, remove from droplist
		vm.model.SeqAltVendorAccounts.push({Vendor:vm.seqSplitEditAccounts.addVendor, VendorAccount:vm.seqSplitEditAccounts.addAccount});
		resetVendorDroplists();
	}

	function seqAltAccountRemove(altAccount) {

		if(vm.isWaiting) {
			return;
		}

		var newAccounts = [],
			vmList = vm.model.SeqAltVendorAccounts;

		for(var j = 0; j < vmList.length; j++) {
			if(vmList[j].Vendor == altAccount.Vendor) {
				continue;
			}
			newAccounts.push(vmList[j]);
		}

		vm.model.SeqAltVendorAccounts = newAccounts;
		resetVendorDroplists();
	}

	function customPriceVendorChange() {

		if(vm.isWaiting) {
			return;
		}
		resetVendorDroplists();

		// var newAccounts = [],
		// 	vmList = vm.model.SeqAltVendorAccounts;

		// for(var j = 0; j < vmList.length; j++) {
		// 	if(vmList[j].Vendor == altAccount.Vendor) {
		// 		continue;
		// 	}
		// 	newAccounts.push(vmList[j]);
		// }

		// vm.model.SeqAltVendorAccounts = newAccounts;
		// vm.seqSplitEditAccounts = seqSplitAccountsVM();
		// vm.seqSplitEditAccounts.show = true;
	}

	/**
	 *    CLONE
	 */

	function cloneRX() {

		// copy settings of this pharmacy into a new pharmacy

		if(vm.isWaiting) {
			return;
		}

		// prompt user
		msgSvc.confirm({
			id: 'rx.clone.prompt',
			title: 'Clone ' + vm.model.Id.val + '?',
			msg: 'Properties will be copied to a new Pharmacy. VHUB, Sequential Splitting and affiliaitons will be reset.',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'NO', cancel: true}
			]
		}).then(confirmClone, confirmClone);
	}

	function confirmClone(r) {
		if(!!r && r.result == 'YES') {
			var m = vm.model;

			m.Clone = true;
			m.ClonedFrom = m.Id.val;

			vm.showTabCentralFill = false;
			vm.showTabRollup = false;
			vm.showTabAffs = false;

			m.ObjectState = 'ONBOARDING';
			vm.btnStatusChange.show = false;

			m.Id = validSvc.newProp('');
			m.AcctId = validSvc.newProp('');
			m.Name = validSvc.newProp('');
			m.ShortName = validSvc.newProp('');
			m.NPI = validSvc.newProp('');
			m.NCPDP = validSvc.newProp('');

			m.CentralFillPharmacy = '';
			m.RollupParent = '';

			// turn off VHUB, VCentral and Seq Split
			m.VHubEnabled = 'no';
			m.VCentralEnabled = 'no';
			m.SeqSplitStatus = 'off';
			resetSeqSplitProps(m);

			validAccount();

			msgSvc.ok('Properties Copied', 'Enter Name and Identification specifics and click CLONE button.');
		}
	}


	/**
	 *    WAC NEUT
	 */

	function wacNeutNdcVM() {
		return {
			NDC: '',
			Fee: 0.00,
			fail: '',
			msg: ''
		};
	}

	function validWacNeutNdc(item, feeList, isAdd) {

		var result = wacNeutNdcVM();
		result.idx = -1;

		// clean up ndc
		var ndcClean = ndcCleanUp(item.NDC);
		result.NDC = ndcClean.val;

		// valid?
		if(ndcClean.fail) {
			msgSvc.ok('Cannot Add NDC', ndcClean.msg);
			return null;
		}
		var validFee = validCurrency(validSvc.newProp(item.Fee), 0, 9999);
		if(validFee.fail == 'yes') {
			msgSvc.ok('Cannot Add NDC Fee', 'Must be 0 to 9,999');
			return null;
		}
		result.Fee = item.Fee;

		// already in list?
		for(var i = 0; i < feeList.length; i++) {
			if(feeList[i].NDC == result.NDC) {
				if(isAdd) {
					msgSvc.ok('Cannot Add NDC', result.NDC + ' already added');
					return null;
				}
				else {
					// on update we should find it
					result.idx = i;
				}
			}
		}

		return result;
	}

	function wacNeutSave(item, isAdd) {

		if(vm.isWaiting) {
			return;
		}

		var cleanItem = validWacNeutNdc(item, vm.model.WacNeutNdcFeeList, !!isAdd);
		if(!!cleanItem) {

			if(!!isAdd) {
				vm.model.WacNeutNdcFeeList.push(cleanItem);
				vm.wacNeutEdit = wacNeutNdcVM();
			}
			else {
				var updateItem = vm.model.WacNeutNdcFeeList[cleanItem.idx];
				updateItem.Fee = cleanItem.Fee;
				updateItem.fail = '';

				// reset validation state of parent
				vm.model.CdcEnabled = validSvc.newProp('yes');
			}
		}

	}

	function wacNeutRemove(ndc) {

		if(vm.isWaiting) {
			return;
		}

		// find ndc to remove
		var ndcList = vm.model.WacNeutNdcFeeList;
		for(var i = ndcList.length - 1; i >= 0; i--) {
			if(ndcList[i].NDC == ndc) {
				ndcList.splice(i, 1);

				// reset validation state of parent
				vm.model.CdcEnabled = validSvc.newProp('yes');

				break;
			}
		}

	}


	/**
	 *    PCC
	 */

	function pccItemVM() {
		var dtNow = Date.now();
		return {
			Id: dtNow.toString(),
			BIN: validSvc.newProp(),
			PCN: validSvc.newProp(),
			GroupNumber: validSvc.newProp(),
			fail: '',
			msg: ''
		};
	}

	function pccAddItem() {

		if(vm.isWaiting) {
			return;
		}

		vm.model.PCCItems.push(pccItemVM());

	}

	function pccRemoveItem(item) {

		if(vm.isWaiting || !!!item || !validSvc.isText(item.Id)) {
			return;
		}

		var pccItems = vm.model.PCCItems,
			id = item.Id;
		for(var i = pccItems.length - 1; i >= 0; i--) {
			if(pccItems[i].Id == id) {
				pccItems.splice(i, 1);
			}
		}

	}

	/**
	 *    EXCEL
	 */

	 function getNpiExcel() {

		// already working?
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		var _pendingExcelFilename = 'Verity-' + vm.model.Id.val + '-NPI.csv';
		npiRepo.getExcel('RX',vm.model.Id.val, _pendingExcelFilename).then(okServerExcel, errServerExcel);

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Create Excel Error', 'accumListCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}

	/**
	 *    FILE IMPORT
	 */

	 function toggleNpiImport() {

		if(vm.isWaiting) {
			return;
		}

		if(vm.action == 'IMPORT') {
			// toggle off, back to list
			vm.action = 'UPDATE';
			vm.activeTab = 'ACCOUNT';
			return;
		}
		else {
			// toggle on, reset view

			/*
			queryChange();

			// check for File API and FormData upload browser support
			if(!validSvc.uploadSupported()) {
				msgSvc.ok('File Upload Not Supported', 'File Upload uses HTML5 FormData upload, your browser does not support it. Please upgrade to use file upload.');
				return;
			}
			*/
			vm.action = 'IMPORT';
			vm.activeTab = 'IMPORT';
			listenForFileImport();
		}

	}


	function importValidFile(newFile) {

		// required
		if(!!!newFile) {
			return 'no file selected';
		}

		// file size > 0 bytes, < 10 megabytes
		if(!validSvc.isNumber(newFile.size) || newFile.size < 1 || newFile.size > 50000000) {
			return 'file size must be 2 bytes to 50 megabytes';
		}

		// file name must be .csv
		var fName = newFile.name;
		if(!validSvc.isText(fName) || fName.length < 5 || (fName.substr(fName.length - 4, 4).toLowerCase() !== '.csv' && fName.substr(fName.length - 4, 4).toLowerCase() !== '.txt')) {
			return 'file name must end with extension ".csv" or ".txt"';
		}

		return 'ok';

	}

	function importValid() {

		// files selected
		if(!!!vm.importFiles || vm.importFiles.length !== 1) {
			msgSvc.ok('File Import', 'Please choose 1 file to upload.');
			return false;
		}

		// validate file
		var fileFail = importValidFile(vm.importFiles[0]);
		if(fileFail != 'ok') {
			msgSvc.ok('File Import', 'Selected file error: ' + fileFail);
			return false;
		}

		return true;

	}

	function importFile() {

		if(vm.isWaiting) {
			return;
		}

		if(!importValid()) {
			return;
		}

		msgSvc.confirm({
			id: 'ops.rx.npi.import',
			title: 'Upload Rollup NPI File',
			msg: 'Warning: New NPI records on the list will be added, existing will be updated.',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmFileImport, confirmFileImport);

	}

	function confirmFileImport(r) {

		// user cancelled
		if(!!!r || r.result != 'YES') {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);
		vm.importErrors = [];
		vm.importCounts = {};

		npiRepo.fileUpload('RX',vm.model.Id.val, '', vm.importFiles[0]).then(okFileImport, errFileImport);

		function okFileImport(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;
			msgSvc.ok('File Import Success', 'Total ' + r.ProcessedCount + ' npi records imported.');

			// toggle off
			toggleNpiImport();
		}

		function errFileImport(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(r === null) {
				return;
			}
			else if (r.status === 422) {
				vm.importErrors = r.importErrors;
				vm.importCounts = r.counts;
				if(r.counts.Processed > 0) {
					msgSvc.ok('File Import With Errors', r.counts.Processed + ' imported, ' + r.importErrors.length + ' errors');
				}
				else {
					msgSvc.ok('File Import Failed', 'No line items were imported, there are: ' + r.importErrors.length + ' line item errors');
				}
			}
			else {
				errSvc.error('Unexpected api error', 'npiCtl.errFileImport', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    IMPORT FILE EVENT HOOK
	 *    used to update file list to import
	 *    note:
	 *          directive widget-input-file throws event: 'widget.input.file'
	 *          event object: {id:'id of element', files:[] array of files if browser supports HTML5 File Api}
	 */

	function listenForFileImport() {

		if(!!!_fileImportListener) {

			_fileImportListener = $scope.$on('widget.input.file', function(event, importInfo) {
				event.stopPropagation();

				if(!!importInfo && !!importInfo.files && importInfo.files.length > 0) {
					vm.importFiles = importInfo.files;
				}
				else {
					vm.importFiles = [];
				}

			});
		}

	}

	$scope.$on('$destroy', function() {
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}

		// clean up listener on destroy
		if(!!_fileImportListener) {
			_fileImportListener();
		}
	});


	/**
	 *    HELPERS
	 */

	function validText(prop, min, max) {

		// required
		if(!validSvc.isText(prop.val)) {
			prop.fail = 'yes';
			prop.msg = 'required';
			return prop;
		}

		// min
		if(prop.val.length < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum ' + min.toString() + ' characters';
			return prop;
		}

		// max
		if(prop.val.length > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum ' + max.toString() + ' characters';
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;

	}

	function validNumber(prop, min, max) {

		// parse into float
		var floatVal;
		try {
			floatVal = parseFloat(prop.val);
		}
		catch(err) {
			// do nothing
		}

		// not a number
		if(!validSvc.isNumber(floatVal)) {
			prop.fail = 'yes';
			prop.msg = 'must be a number';
			return prop;
		}

		// min
		if(floatVal < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum: ' + min;
			return prop;
		}

		// max
		if(floatVal > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum: ' + max;
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';

		return prop;

	}

	function ndcCleanUp(val, skipEmpty) {

		var zeroPad = "00000000000",
			ndcTest = '';

		// must be text
		if(!!!skipEmpty && !validSvc.isText(val)) {
			return validSvc.newProp(val, true, 'required');
		}

		// remove all non-numeric characters
		ndcTest = val.toString().trim();
		ndcTest = ndcTest.replace(/[^0-9]+/g,'');

		// empty
		if(ndcTest.length < 1) {
			if(!!skipEmpty) {
				return validSvc.newProp('', false, '');
			}
			else {
				return validSvc.newProp(ndcTest, true, 'empty');
			}
		}

		// max len
		if(ndcTest.length > 11) {
			return validSvc.newProp(ndcTest, true, 'max 11 characters');
		}

		// integer
		var intVal = parseInt(ndcTest);
		if(!validSvc.isInteger(intVal)) {
			return validSvc.newProp(ndcTest, true, 'must be an integer');
		}

		// all zeros
		if(intVal <= 0) {
			return validSvc.newProp(ndcTest, true, 'cannot be zero');
		}

		// pad zeros if needed, pass
		ndcTest = zeroPad.substr(0, 11 - ndcTest.length) + ndcTest;
		return validSvc.newProp(ndcTest, false, '');

	}

	function ndcListToTextarea(items) {

		var result = "";

		for(var i = 0; i < items.length; i++) {
			if(items[i].fail) {
				result += items[i].val + "<< " + items[i].msg + "\n";
			}
			else {
				result += items[i].val + "\n";
			}
		}

		return result;

	}

	function addToExtractNdcs(ndc) {

		var ndcList = vm.model.TpaExtractExcludeNdcList,
			sortList = [],
			result = [];

		// build list to sort
		for(var i = 0; i < ndcList.length; i++) {
			sortList.push(ndcList[i].val);
		}

		sortList.push(ndc);
		sortList.sort();

		// re-create object array
		for(var s = 0; s < sortList.length; s++) {
			result.push(validSvc.newProp(sortList[s]));
		}

		return result;

	}

	function validCurrency(prop, min, max) {

		// parse into float
		var floatVal;
		try {
			floatVal = parseFloat(prop.val);
		}
		catch(err) {
			// do nothing
		}

		// not a number
		if(!validSvc.isNumber(floatVal)) {
			prop.fail = 'yes';
			prop.msg = 'must be a number';
			return prop;
		}

		// min
		if(floatVal < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum: ' + min;
			return prop;
		}

		// max
		if(floatVal > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum: ' + max;
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';

		return prop;

	}

	function resetSeqSplitProps(m) {

		// UI is turning off Sequential Split, reset all sub-properties
		m.SeqUseCEOrder = false;
		m.SeqCEs = [];
		m.SeqSendForReview = 'no';
		m.SeqCombine855s = 'no';
		m.SeqPriceSelectWAC = 'no';
		m.SeqPriceSelWACEqualGPO = 'no';
		m.SeqTimeout855s = validSvc.newProp(0);
		m.SeqApprovalRequired = 'no';
		m.SeqApprovalRequiredAllOrders = 'no';
		m.SeqApprovalTimeout = validSvc.newProp(60);
		m.SeqApprovalTimeoutAction = 'PLACE';
		m.SeqUseBestCost = 'no';
		m.Federate850s = 'no';
		m.Federate850sCEID = '';
		m.Federate850sFileExtX12 = 'no';

		vm.seqSplitEdit = seqSplitVM();
		vm.seqSplitEditAccounts = seqSplitAccountsVM();

		resetVendorDroplists();
	}


	/**
	 *    MULTISELECT HELPERS
	 */

	function multiClick(id, val) {
		var multi = {};
		switch(id) {
			case 'TpaDirectMulti':
				multi = vm.TpaDirectMulti;
				vm.multiselectClick(multi, val);
				vm.model.BillPayTpaDirect.fail = multi.vals.length < 1 ? 'yes' : 'no';
				break;
			default:
				throw new Error('rxEdit.multiClick, unknown multi id: ' + id);
		}
		vm.multiselectTitle(multi, true);
	}

    function multiToggle(evt, id) {
		// future support for another multi
		switch(id) {
			case 'TpaDirectMulti':
				multiselectToggle(evt, vm.TpaDirectMulti, 'rxEdit' + id);
				break;
			case 'CfMemberPicker':
				multiselectToggle(evt, vm.cfMemberPicker, 'rxEditCfMemberPicker');
				break;
			default:
				throw new Error('rxEdit.multiToggle, unknown multi id: ' + id);
		}
	}

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if(vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		if(typeof multiselect.flt === 'string') {
			multiselect.flt = '';
		}
		else if(!!multiselect.flt && typeof multiselect.flt === 'object') {
			Object.keys(multiselect.flt).forEach(function(key) {
				multiselect.flt[key] = '';
			});
		}

		// don't bother with width if hiding
		if(multiselect.show) {
			multiselect.show = false;
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;

	}

	function multiHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}
}
 
rxListCtl.$inject = ['$state', '$rootScope', '$scope', '$filter', '$timeout', 'rxRepo', 'sessionRepo', 'prefsRepo', 'lookupRepo', 'validSvc', 'utilSvc', 'errSvc', 'msgSvc'];
angular
.module('espui.admin.rx')
.controller('RxListCtl', rxListCtl);


/* @ngInject */
function rxListCtl($state, $rootScope, $scope, $filter, $timeout, rxRepo, sessionRepo, prefsRepo, lookupRepo, validSvc, utilSvc, errSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _pagingEventListener = null,
		_mouseLeaveDelay = [],
		_returnVisit = false,
		_RxDirtyFavs = false;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addMultiselect(vm);
	utilSvc.ctl.addFlexTop(vm);
	utilSvc.ctl.addFiltering(vm);

	// properties
	vm.init = false;

	// droplists
	vm.StatusDroplist = [];

	// multiselect
	vm.RxBizMultiselect = {};
	vm.RxBizMultiselectClick = RxBizMultiselectClick;
	
	// tbl and column filters
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;

	// methods
	vm.create = create;
	vm.edit = edit;

	// adv filter multiselect
	vm.RxMulti = {};
	vm.CeMulti = {};
	vm.RollupMulti = {};
	vm.CentralFillMulti = {};
	vm.TpaPartnerMulti = {};
	vm.PriceModelMulti = {};
	vm.BusinessModelsMulti = {};
	vm.PharmacyTypeMulti = {};
	vm.DataSwitchMulti = {};
	vm.multiToggle = multiToggle;
	vm.multiHover = multiHover;
	vm.multiClick = multiClick;

	// query
	vm.query = {};
	vm.queryChange = queryChange;
	vm.querySubmit = querySubmit;

	// checkbox
	vm.checkboxToggle = checkboxToggle;

	// flex
	vm.flexTopExpand = flexTopExpand;

	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		vm.init = true;
		vm.flex = vm.flexInit();
		vm.query = queryVM();

		initFiltersAndDroplists();
		vm.init = false;
		msgSvc.wait(true);
		$timeout(initAsyncLoader, 1000);
	}

	function initFiltersAndDroplists() {

		// table filter setup
		vm.flt = vm.initFilters({
			Exact: {
				ObjectState: '',
				advCDC: '',
				advVHUB: '',
				advSeqSplit: '',
				advOptimizer: '',
				advBill: '',
				advBillExport: ''
			},
			SortBy: ['ShortName']
		});

		vm.StatusDroplist = utilSvc.ng.droplist([
			'ONBOARDING',
			'ACTIVE',
			'INACTIVE',
			'DELETED'
			],
			'',
			'',
			[{value:'', label: 'ALL'}]
		);

		// multiselect: RxBizModels
		vm.RxBizMultiselect = {
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'All Options',
			vals: ['ALL'],
			list: vm.multiselectBuild([
				'ALL',
				'CP',
				'CPTPA',
				'SPLIT',
				'SPLITMATCH'
			])
		};

		// multiselect advanced filter: RX
		vm.RxMulti = {
			type: 'RX',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Not Filtered',
			vals: [],
			list: [],
			flt: ''
		};

		// multiselect advanced filter: CE
		vm.CeMulti = {
			type: 'CE',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Not Filtered',
			titleAllOptions: 'Any Affilliate',
			vals: [],
			list: [],
			flt: ''
		};

		// multiselect advanced filter: rollup parent
		vm.RollupMulti = {
			type: 'ADV',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Not Filtered',
			titleAllOptions: 'Any Rollup',
			vals: [],
			list: []
		};

		// multiselect advanced filter: central fill parent
		vm.CentralFillMulti = {
			type: 'ADV',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Not Filtered',
			titleAllOptions: 'Any Central Fill',
			vals: [],
			list: []
		};

		// multiselect advanced filter: tpa partner
		vm.TpaPartnerMulti = {
			type: 'ADV',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Not Filtered',
			titleAllOptions: 'Any TPA Partner',
			vals: [],
			list: []
		};

		// multiselect advanced filter: price model
		vm.PriceModelMulti = {
			type: 'ADV',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Not Filtered',
			titleAllOptions: 'Any Price Model',
			vals: [],
			list: []
		};

		// multiselect advanced filter: business models
		vm.BusinessModelsMulti = {
			type: 'ADV',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Not Filtered',
			titleAllOptions: 'Any Business Model',
			vals: [],
			list: []
		};

		// multiselect advanced filter: pharmacy type
		vm.PharmacyTypeMulti = {
			type: 'ADV',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Not Filtered',
			titleAllOptions: 'Any Pharmacy Type',
			vals: [],
			list: []
		};

		// multiselect advanced filter: data switch
		vm.DataSwitchMulti = {
			type: 'ADV',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Not Filtered',
			titleAllOptions: 'Any Data Switch',
			vals: [],
			list: []
		};

		var affs = getAffs();
		var ceList = utilSvc.aff.ceList(affs);
		vm.CeMulti.list = vm.multiselectBuild(ceList, false);
		var rxList = utilSvc.aff.rxList($scope.User.AffList);
		vm.RxMulti.list = vm.multiselectBuild(rxList, false);
		var rollupList = utilSvc.aff.findRxType($scope.User.AffList, ['ROLLUP']);
		rollupList = utilSvc.aff.rxList(rollupList);
		vm.RollupMulti.list = vm.multiselectBuild(rollupList, false);
		var centralList = utilSvc.aff.findRxType(affs, ['CENTRALFILL']);
		centralList = utilSvc.aff.rxList(centralList);
		vm.CentralFillMulti.list = vm.multiselectBuild(centralList, false);
		var tpas = ['340BDIRECT', 'CAPTURERX', 'MACROHELIX', 'PSG', 'SUNRX','HUDSONHEADWATERS'];
		vm.TpaPartnerMulti.list = vm.multiselectBuild(tpas, false);
		var pricingList = ['WACMinus','WACFloat','CustomPriceList','Reimbursement'];
		vm.PriceModelMulti.list = vm.multiselectBuild(pricingList, false);
		var bizModels = ['CP','CPTPA','SPLIT','SPLITMATCH'];
		vm.BusinessModelsMulti.list = vm.multiselectBuild(bizModels, false);
		var phType = ['DISPENSING', 'CENTRALFILL', 'ROLLUP'];
		vm.PharmacyTypeMulti.list = vm.multiselectBuild(phType, false);
	
		vm.multiselectTitle(vm.CeMulti);
		vm.multiselectTitle(vm.RxMulti);
		vm.multiselectTitle(vm.RollupMulti);
		vm.multiselectTitle(vm.CentralFillMulti);
		vm.multiselectTitle(vm.TpaPartnerMulti);
		vm.multiselectTitle(vm.PriceModelMulti);
		vm.multiselectTitle(vm.BusinessModelsMulti);
		vm.multiselectTitle(vm.PharmacyTypeMulti);
	}

	function initAsyncLoader() {
		// ASYNC loading
		loadRollupDisplay();
	}

	function loadRollupDisplay() {
		// ASYNC routine to get RX short names

		lookupRepo.DataSwitchList().then(okLookupDS, errInitLoad);

		function okLookupDS(items) {
			vm.DataSwitchMulti.list = vm.multiselectBuild(items, false);	
			vm.multiselectTitle(vm.DataSwitchMulti);
			finalizeInit();
		}
	}

	function errInitLoad(r) {
		if (!!r) {
			errSvc.warn('rxListCtl.errInitLoad, issue loading Data Switch details', r.status, utilSvc.http.safeResponse(r));
		}
	}

	function finalizeInit() {
		// all ASYNC loads complete, enable UI
		vm.isWaiting = false;
		vm.init = false;
		var vs = sessionRepo.get('vs-admin-rx-list');
		if(!!vs) {
			_returnVisit = true;
			vm.flt = vm.resetFilters(vs.flt);
			vm.query = vs.query;
			
			// Reload Multi Select
			reloadQuery();
		}
		if(_returnVisit) {
			_returnVisit = false;
			querySubmit();
		} else {
			msgSvc.wait(false);
		}
	}

	function reloadQuery() {
		var q = vm.query;
		
		// Multi select
		vm.multiselectReturnVisit(vm.CeMulti, '', q.CE.vals);
		vm.multiselectTitle(vm.CeMulti, true);
		q.CE.fail = vm.CeMulti.vals.length < 1 ? 'yes' : 'no';

		vm.multiselectReturnVisit(vm.RxMulti, '', q.RX.vals);
		vm.multiselectTitle(vm.RxMulti, true);
		q.RX.fail = vm.RxMulti.vals.length < 1 ? 'yes' : 'no';
		
		vm.multiselectReturnVisit(vm.RollupMulti, '', q.RollupParent.vals);
		vm.multiselectTitle(vm.RollupMulti, true);
		q.RollupParent.fail = vm.RollupMulti.vals.length < 1 ? 'yes' : 'no';

		vm.multiselectReturnVisit(vm.CentralFillMulti, '', q.CentralFill.vals);
		vm.multiselectTitle(vm.CentralFillMulti, true);
		q.CentralFill.fail = vm.CentralFillMulti.vals.length < 1 ? 'yes' : 'no';

		vm.multiselectReturnVisit(vm.TpaPartnerMulti, '', q.TPA.vals);
		vm.multiselectTitle(vm.TpaPartnerMulti, true);
		q.TPA.fail = vm.TpaPartnerMulti.vals.length < 1 ? 'yes' : 'no';

		vm.multiselectReturnVisit(vm.PriceModelMulti, '', q.PriceModel.vals);
		vm.multiselectTitle(vm.PriceModelMulti, true);
		q.PriceModel.fail = vm.PriceModelMulti.vals.length < 1 ? 'yes' : 'no';

		vm.multiselectReturnVisit(vm.BusinessModelsMulti, '', q.BusinessModels.vals);
		vm.multiselectTitle(vm.BusinessModelsMulti, true);
		q.BusinessModels.fail = vm.BusinessModelsMulti.vals.length < 1 ? 'yes' : 'no';

		vm.multiselectReturnVisit(vm.PharmacyTypeMulti, '', q.PharmacyType.vals);
		vm.multiselectTitle(vm.PharmacyTypeMulti, true);
		q.PharmacyType.fail = vm.PharmacyTypeMulti.vals.length < 1 ? 'yes' : 'no';

		vm.multiselectReturnVisit(vm.DataSwitchMulti, '', q.DataSwitch.vals);
		vm.multiselectTitle(vm.DataSwitchMulti, true);
		q.DataSwitch.fail = vm.DataSwitchMulti.vals.length < 1 ? 'yes' : 'no';
	}

	function getAffs() {
		var affStatus = ['ONBOARDING', 'ACTIVE', 'INACTIVE'];
		var affs = utilSvc.aff.findStatus($scope.User.AffList, affStatus);

		return affs;
	}


	/**
	 *    DISPLAY VIEW MODEL
	 *    built from empty or repo result data
	 */

	function displayVM(repoData) {

		var items = Array.isArray(repoData) ? repoData : [],
			item = {},
			rxModels = [],
			favs = [],
			favsMap = {},
			shortName = '',
			cleanShort = '';

		for(var i = 0; i < items.length; i++) {
			item = items[i];

			// rx favorites
			shortName = validSvc.isText(item.ShortName) ? item.ShortName : item.Id;
			cleanShort = shortName.replace(/[^A-Za-z0-9]+/g,'');

			favs.push(shortName);
			favsMap[cleanShort] = item.Id;

			// models: display NONE if no models, remove NONE if another model is specified
			rxModels = Array.isArray(item.BusinessModels) ? item.BusinessModels : ['NONE'];
			if(rxModels.length > 1 && rxModels.indexOf('NONE') > -1) {
				rxModels.splice(rxModels.indexOf('NONE'), 1);
			}
			item.BusinessModels = rxModels;
			item.BusinessModelTxt = rxModels.join(', ');
		}

		return {
			Items: [],
			DataItems: items
		};

	}


	/**
	 *    GLOBAL GREASE COLUMN FILTERS
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			vm.tbl.DataItems = Array.isArray(vm.tbl.DataItems) ? vm.tbl.DataItems : [];
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					saveViewState(vm.flt);
				}
			},1000);

		}, delayTime);

	}

	/**
	 * 	QUERY
	 */

	 function queryValid(q) {

		// trying a validation collector to avoid re-listing all properties
		var isValid = true,
			failTxt = '';

		function setFail(failState) {
			if(isValid) {
				isValid = !!!failState;
			}
			return !!failState ? 'yes' : 'no';
		}

		q.NPI.fail = '';
		if(q.NPI.chk) {
			failTxt = setFail(q.NPI.val.length < 3 || q.NPI.val.length > 15);
			q.NPI.fail = failTxt;
			q.NPI.msg = failTxt == 'yes' ? 'NPI must be 3 to 15 characters' : '';
		}

		q.NCPDP.fail = '';
		if(q.NCPDP.chk) {
			failTxt = setFail(q.NCPDP.val.length < 4 || q.NCPDP.val.length > 10);
			q.NCPDP.fail = failTxt;
			q.NCPDP.msg = failTxt == 'yes' ? 'NCPDP must be 4 to 10 characters' : '';
		}

		q.CE.vals = multiselectQueryVals(vm.CeMulti);
		q.RX.vals = multiselectQueryVals(vm.RxMulti);
		q.RollupParent.vals = multiselectQueryVals(vm.RollupMulti);
		q.CentralFill.vals = multiselectQueryVals(vm.CentralFillMulti);
		q.TPA.vals = multiselectQueryVals(vm.TpaPartnerMulti);
		q.PriceModel.vals = multiselectQueryVals(vm.PriceModelMulti);
		q.BusinessModels.vals = multiselectQueryVals(vm.BusinessModelsMulti);
		q.PharmacyType.vals = multiselectQueryVals(vm.PharmacyTypeMulti);
		q.DataSwitch.vals = multiselectQueryVals(vm.DataSwitchMulti);

		return isValid;
	}

	function queryChange() {
		if (!vm.init) {
			vm.action = '';
			vm.tbl = {};
			vm.flt = vm.resetFilters(vm.flt);
			vm.flex = vm.flexInit();
			vm.popup = {};
			$scope.$broadcast('widget.paging');
		}
	}

	function querySubmit() {
		if(vm.isWaiting) {
			return;
		}

		// validate
		if(!queryValid(vm.query)) {
			msgSvc.ok('Search', 'Check filter settings');
			return;
		}
		queryChange();
		toggleWait(true);
		getList();
	}

	/**
	 *    RX MULTISELECT
	 */

	 function RxBizMultiselectClick(val) {
		vm.multiselectClick(vm.RxBizMultiselect, val);
		vm.multiselectTitle(vm.RxBizMultiselect);
		filterChange();
	}

	
	/**
	 *    GET LIST
	 */

	function getList() {
		msgSvc.wait(true, true);
		rxRepo.getList(vm.query).then(okList, errList);

		function okList(r) {
			toggleWait();
			// create table data items (also parses advanced filters)
			vm.tbl = displayVM(r.data);

			// save viewstate
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			saveViewState(vm.flt);

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			vm.flt.Ready = true;
			vm.action = 'LIST';
			vm.flex = vm.flexCollapse(vm.flex, true);
		}

		function errList(r) {
			toggleWait();
			if(!!r) {
				errSvc.warn('unknown error getting data', 'rx.getList.err', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    CREATE / EDIT
	 */

	function create() {
		$state.go('admin.rx.create');
	}

	function edit(id) {
		$state.go('admin.rx.edit', {RX: id});
	}

	/**
	 *    MULTISELECT
	 */

	function multiClick(propName, val) {
		if(vm.isWaiting) {
			return;
		}
		queryChange();
		var multi = {};
		switch(propName) {
			case 'CE':
				multi = vm.CeMulti;
				break;
			case 'RX':
				multi = vm.RxMulti;
				break;
			case 'Rollup':
				multi = vm.RollupMulti;
				break;
			case 'CentralFill':
				multi = vm.CentralFillMulti;
				break;
			case 'TpaPartner':
				multi = vm.TpaPartnerMulti;
				break;
			case 'PriceModel':
				multi = vm.PriceModelMulti;
				break;
			case 'BusinessModels':
				multi = vm.BusinessModelsMulti;
				break;
			case 'PharmacyType':
				multi = vm.PharmacyTypeMulti;
				break;
			case 'DataSwitch':
				multi = vm.DataSwitchMulti;
				break;
			default:
				throw new Error('rxList.multiClick, unknown propName: ' + propName);
		}
		vm.multiselectClick(multi, val);
		vm.multiselectTitle(multi, true);
	}

	function okSavePref(r) {
		// no action
	}

	function errSavePref(r) {
		if(!!r) {
			errSvc.warn('Unknown api error saving AdminPrefs', 'rxlistCtl.saveRxFavs', r.status, utilSvc.http.safeResponse(r));
		}
	}


	function multiToggle(evt, id) {
		switch(id) {
			case 'rxListCeMulti':
				multiselectToggle(evt, vm.CeMulti, id);
				break;
			case 'rxListRxMulti':
				multiselectToggle(evt, vm.RxMulti, id);
				break;
			case 'rxListRollupMulti':
				multiselectToggle(evt, vm.RollupMulti, id);
				break;
			case 'rxListCentralFillMulti':
				multiselectToggle(evt, vm.CentralFillMulti, id);
				break;
			case 'rxListTpaPartnerMulti':
				multiselectToggle(evt, vm.TpaPartnerMulti, id);
				break;
			case 'rxListPriceModelMulti':
				multiselectToggle(evt, vm.PriceModelMulti, id);
				break;
			case 'rxListBusinessModelsMulti':
				multiselectToggle(evt, vm.BusinessModelsMulti, id);
				break;
			case 'rxListPharmacyTypeMulti':
				multiselectToggle(evt, vm.PharmacyTypeMulti, id);
				break;
			case 'rxListDataSwitchMulti':
				multiselectToggle(evt, vm.DataSwitchMulti, id);
				break; 
		}
	}

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if(vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		multiselect.flt = '';

		// don't bother with width if hiding
		if(multiselect.show) {
			multiselect.show = false;
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;

	}

	function multiHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {
			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}

	/**
	 *    CHECKBOX
	 */

	function checkboxToggle(prop) {
		vm.query[prop] = vm.query[prop] == 'yes' ? 'no' : 'yes';
		queryChange();
	}

	/**
	 * 	FLEX TOP
	 */

	function flexTopExpand() {
		// user opened search query, reset list display, show search expanded
		if (vm.init || vm.isWaiting) {
			return;
		}
		queryChange(true);
	}

	/**
	 *    HELPERS
	 */

	 function saveViewState(flt) {
		var state = {
			flt: flt,
			query: vm.query
		};
		sessionRepo.set('vs-admin-rx-list', state);
	}

	function toggleWait(isOn) {
		vm.isWaiting = !!isOn;
		msgSvc.wait(!!isOn);
	}

	function queryVM() {
		return {
			CE: validSvc.newProp(),
			RX: validSvc.newProp(),
			RollupParent: validSvc.newProp(),
			CentralFill: validSvc.newProp(),
			TPA: validSvc.newProp(),
			PriceModel: validSvc.newProp(),
			BusinessModels: validSvc.newProp(),
			PharmacyType: validSvc.newProp(),
			DataSwitch: validSvc.newProp(),
			NPI: validSvc.newCheckProp(''),
			NCPDP: validSvc.newCheckProp(''),
			DisplayName: validSvc.newCheckProp(''),
			FullName: validSvc.newCheckProp(''),
			CDC: 'no',
			Vhub: 'no',
			SequentialSplit: 'no',
			NDCOptimizer: 'no',
			BillingEnabled: 'no',
			ExportInvoice: 'no',
			AdvSearch: false,
		};
	}

	function multiselectQueryVals(multiselect) {
		// unpack the vals multiselect into a list of entities to query

		var checklist = multiselect.list,
			vals = multiselect.vals;

		if(vals.length < 1) {
			return [];
		}
		else if(vals.length === 1 && vals[0] == 'ALL') {
			// using ALL checkbox, return all values except ALL checkbox
			var result = [],
				i = checklist[0].val == 'ALL' ? 1 : 0;
			for(i; i < checklist.length; i++) {
				result.push(checklist[i].val);
			}
			return result;
		}
		else {
			return vals;
		}
	}
}
 
adminSettingsCtl.$inject = ['$state', '$scope', '$rootScope', '$timeout', '$window', 'affOptionsRepo', 'sessionRepo', 'msgSvc', 'utilSvc', 'validSvc', 'errSvc'];
angular
.module('espui.admin.settings')
.controller('AdminSettingsCtl', adminSettingsCtl);


/* @ngInject */
function adminSettingsCtl($state, $scope, $rootScope, $timeout, $window, affOptionsRepo, sessionRepo, msgSvc, utilSvc, validSvc, errSvc) {

	/*jshint validthis: true */
	var vm = this,
		_featureName = '',
		_primaryProp = '',
		_searchList = [],
		_returnVisit = false,
		_mouseLeaveDelay = [],
		_fileImportListener = null;

	// inherit
	utilSvc.ctl.addMultiselect(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';

	// droplists
	vm.primaryDroplist = [];
	vm.secondaryDroplist = [];

	// query
	vm.query = {};
	vm.queryChangeViewType = queryChangeViewType;
	vm.queryChangePrimary = queryChangePrimary;
	vm.queryChangeSecondary = queryChangeSecondary;
	vm.queryChangeTabChk = queryChangeTabChk;
	vm.querySubmit = querySubmit;
	vm.filterSwap = filterSwap;

	// tabs
	vm.activeTab = '';
	vm.tabChange = tabChange;

	// models
	vm.display = {};

	// multiselect
	vm.PrimaryMulti = {};
	vm.SecondaryMulti = {};
	vm.MonitorTypeMulti = {};
	vm.multiToggle = multiToggle;
	vm.multiHover = multiHover;
	vm.multiClick = multiClick;

	// file import / export
	vm.canExportImport = false;
	vm.exportFile = exportFile;
	vm.jsonImportFiles = [];
	vm.jsonImport = jsonImport;


	/**
	 *    IMPORT FILE EVENT HOOK
	 *    used to update file list to import
	 *    note:
	 *          directive widget-input-file throws event: 'widget.input.file'
	 *          event object: {id:'id of element', files:[] array of files if browser supports HTML5 File Api}
	 */

	function listenForFileImport() {

		if(!!!_fileImportListener) {

			_fileImportListener = $scope.$on('widget.input.file', function(event, importInfo) {
				event.stopPropagation();

				if(!!importInfo && !!importInfo.files && importInfo.files.length > 0) {
					vm.jsonImportFiles = importInfo.files;
				}
				else {
					vm.jsonImportFiles = [];
				}

			});
		}

	}

	$scope.$on('$destroy', function() {
		if(!!_fileImportListener) {
			_fileImportListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		_featureName = $state.current.name;

		vm.init = true;

		vm.canExportImport = utilSvc.user.hasFeature($scope, 'admin.settings.migrate');
		_returnVisit = initQueryAndViewstate($scope.User);

		initDroplists();
		queryChangeViewType('TABS');

		vm.init = false;

	}

	function getAffs() {
		return utilSvc.aff.findRxType($scope.User.AffList, ['DISPENSING', 'CENTRALFILL']);
	}

	function initQueryAndViewstate(usr) {

		// setup query, load viewstate
		_primaryProp = 'CE';  // defaults to CE

		vm.query = {
			isVerity: usr.Type == 'VERITY' || usr.Type == 'VERITYSA',
			userType: usr.Type,
			primary: validSvc.newProp(),
			secondary: validSvc.newProp(),
			ViewType: 'TABS',
			chkCE: 'no',
			chkRX: 'no',
			chkAffInfo: 'no',
			chkAffVendors: 'no'
		};

		return false;

		// get viewstate
		// var vs = sessionRepo.get('vs-admin-settings');
		// if(!!vs) {
		// 	vm.activeTab = vs.activeTab;
		// 	_primaryProp = vs.primaryProp;
		// 	vm.query.primary.val = vs.primary;
		// 	vm.query.secondary.val = vs.secondary;

		// 	return true;
		// }
		// else {
		// 	return false;
		// }

	}

	function initDroplists() {

		// TABS droplists
		vm.secondaryDroplist = utilSvc.ng.droplistNONE();

		var lbl = '';
		if(_primaryProp == 'RX') {
			lbl ='Pharmacy';
			vm.query.secondary.label = 'Facility';
			vm.primaryDroplist = utilSvc.aff.rxDroplist(getAffs());
		}
		else {
			lbl = 'Facility';
			vm.query.secondary.label = 'Pharmacy';
			vm.primaryDroplist = utilSvc.aff.ceDroplistLabel(getAffs(),null,true,false,$rootScope.User.AdminPrefs.ListDisplay);
		}
		vm.query.primary = utilSvc.ng.droplistAutoselect(vm.primaryDroplist, vm.query.primary.val);
		vm.query.primary.label = lbl;

		// EXPORT droplists
		vm.PrimaryMulti = {
			type: '',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: '',
			vals: [],
			list: [],
			flt: ''
		};

		// multi: secondary
		vm.SecondaryMulti = {
			type: '',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: '',
			vals: [],
			list: [],
			flt: ''
		};

	}


	/**
	 *    VIEW MODELS
	 */

	function displayVM(repoData) {

		repoData = repoData || {};
		var result = {
			CE: repoData.CE,
			RX: repoData.Pharmacy,
			Aff: repoData.Affiliation
		};
		result.Aff.ContractTerminationDate = utilSvc.dt.isNull(result.Aff.ContractTerminationDate) ? null : result.Aff.ContractTerminationDate;

		// add titles to vendor list
		var venList = Array.isArray(result.Aff.OrderingAccounts) ? result.Aff.OrderingAccounts : [],
			ven = {};
		for(var i = 0; i < venList.length; i++) {
			ven = venList[i];
			ven.title = ven.Vendor + '-' + ven.AccumulatorType + ', Acct # ' + ven.VendorAccount;
		}
		result.Aff.Vendors = venList;

		return result;
	}


	/**
	 *    TAB CHANGE
	 */

	function tabChange(newTab) {

		if(vm.isWaiting) {
			return;
		}

		vm.activeTab = newTab;
	}


	/**
	 *    QUERY CHANGE
	 */

	function queryChange() {
		if(!vm.init) {
			vm.activeTab = '';
			vm.action = '';
			vm.display = {};
		}
	}

	function queryChangeTabChk(excelTabName) {

		queryChange();

		var propName = 'chk' + excelTabName;
		vm.query[propName] = vm.query[propName] == 'yes' ? 'no' : 'yes';
	}

	function queryChangeViewType(viewType) {

		queryChange();

		switch(viewType) {

			case 'TABS':
				queryChangePrimary();
				break;

			case 'EXCEL':
			case 'JSON':
				applyPrimarySecondaryMulti(_primaryProp, [], []);
				vm.query.chkPrimary = 'yes';
				vm.query.chkSecondary = 'no';
				vm.query.chkAffInfo = 'no';
				vm.query.chkAffVendors = 'no';
				vm.query.IncludeLocations = false;
				vm.query.IncludeNPIs = false;
				vm.query.IncludeMedicaid = false;
				vm.query.IncludePayors = false;
				vm.query.IncludeADT = false;
				break;

			case 'JSONIMPORT':
				// check for File API and FormData upload browser support
				if(typeof($window.File) === 'undefined' ||
					typeof($window.FileReader) === 'undefined' ||
					typeof($window.FileList) === 'undefined' ||
					typeof($window.Blob) === 'undefined' ||
					typeof($window.FormData) === 'undefined') {
					msgSvc.ok('File Upload Not Supported', 'File Upload uses HTML5 FormData upload, your browser does not support it. Please upgrade to use file upload.');
					return;
				}

				vm.jsonImportFiles = [];
				listenForFileImport();
				vm.action = 'SHOW';

				break;

			default:
				msgSvc.ok('Unknown View Type', viewType);
				vm.query.ViewType = 'TABS';
		}
	}

	function queryChangePrimary() {

		queryChange();

		vm.secondaryDroplist = utilSvc.ng.droplistNONE();
		vm.query.primary.fail = validSvc.isEntity(vm.query.primary.val) ? 'no' : 'yes';
		if(vm.query.primary.fail == 'yes') {
			vm.query.secondary.val = 'NONE';
			return;
		}

		// secondary options
		if(_primaryProp == 'CE') {
			vm.secondaryDroplist = utilSvc.aff.rxDroplist(getAffs(), vm.query.primary.val);
		}
		else {
			vm.secondaryDroplist = utilSvc.aff.ceDroplistLabel(getAffs(), vm.query.primary.val,true,false,$rootScope.User.AdminPrefs.ListDisplay);
		}

		var lbl = vm.query.secondary.label;
		vm.query.secondary = utilSvc.ng.droplistAutoselect(vm.secondaryDroplist, vm.query.secondary.val);
		vm.query.secondary.label = lbl;

		queryChangeSecondary();

	}


	function queryChangeSecondary() {

		queryChange();

		vm.query.secondary.fail = validSvc.isEntity(vm.query.secondary.val) ? 'no' : 'yes';
		if(vm.query.secondary.fail == 'yes') {
			vm.query.secondary.val = 'NONE';
			return;
		}

	}


	/**
	 *    SUBMIT
	 */

	function querySubmit() {

		if(vm.isWaiting) {
			return;
		}

		queryChange();

		vm.query.primary.fail = validSvc.isEntity(vm.query.primary.val) ? 'no' : 'yes';
		vm.query.secondary.fail = validSvc.isEntity(vm.query.secondary.val) ? 'no' : 'yes';
		if(vm.query.primary.fail == 'yes' || vm.query.secondary.fail == 'yes') {
			if(!vm.init) {
				msgSvc.ok('Search', 'Check settings');
			}
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		var x = filterSwapToCERX(vm.query);
		affOptionsRepo.getAdminSettings(x.CE, x.RX).then(okGet, errGet);

		function okGet(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// query was good, save viewstate
			//saveViewState(vm.activeTab, _primaryProp, vm.query);

			vm.display = displayVM(r);

			vm.activeTab = 'CE';
			vm.action = 'SHOW';

		}

		function errGet(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.error('unknown error getting data', 'adminSettingsCtl.querySubmit', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    FILTER SWAP
	 */

	function filterSwap() {

		if(vm.isWaiting) {
			return;
		}

		_primaryProp = _primaryProp == 'CE' ? 'RX' : 'CE';

		if(vm.query.ViewType == 'TABS') {
			var pVal = vm.query.primary.val;

			vm.query.primary = validSvc.newProp(vm.query.secondary.val);
			vm.query.secondary = validSvc.newProp(pVal);

			initDroplists();
			queryChangePrimary();
		}
		else {
			applyPrimarySecondaryMulti(_primaryProp, [], []);
		}

	}


	/**
	 *    EXPORT
	 */

	function exportFile() {

		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		// validate
		var q = vm.query;
		q.primary.fail = vm.PrimaryMulti.vals.length < 1 ? 'yes' : 'no';
		if(q.primary.fail == 'yes') {
			return;
		}

		// limit number of entities to export for json
		if(q.ViewType == 'JSON' && vm.PrimaryMulti.vals.length > 20) {
			msgSvc.ok('Cannot Export', 'Maximum 20 ' + vm.PrimaryMulti.name + ' can be chosen for JSON export');
			return;
		}

		// remove secondary tabs if not in use
		if(vm.SecondaryMulti.vals.length < 1) {
			q.chkSecondary = 'no';
			q.chkAffInfo = 'no';
			q.chkAffVendors = 'no';
		}

		// at least 1 check box
		if(q.chkPrimary == 'no' && q.chkSecondary == 'no' && q.chkAffInfo == 'no' && q.chkAffVendors == 'no') {
			msgSvc.ok('Cannot Export', 'Choose at least 1 option to export');
			return;
		}

		// pack up CE and RX values
		q.chkCE = _primaryProp == 'CE' ? q.chkPrimary : q.chkSecondary;
		q.CeVals = _primaryProp == 'CE' ? multiselectQueryVals(vm.PrimaryMulti) : multiselectQueryVals(vm.SecondaryMulti);
		q.chkRX = _primaryProp == 'RX' ? q.chkPrimary : q.chkSecondary;
		q.RxVals = _primaryProp == 'RX' ? multiselectQueryVals(vm.PrimaryMulti) : multiselectQueryVals(vm.SecondaryMulti);

		vm.isWaiting = true;
		msgSvc.wait(true);

		var exportName = q.ViewType == 'EXCEL' ? 'Verity-Admin-Settings.xlsx' : 'Verity-Admin-Settings.json';

		affOptionsRepo.exportAdminSettings(vm.query, exportName).then(okFileExport, errFileExport);

		function okFileExport(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				if(vm.query.ViewType == 'EXCEL') {
					var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
					$window.saveAs(excelBlob, utilSvc.regex.cleanFilename('Verity-Admin-Settings.xlsx'));
				}
				else {
					var jsonBlob = new Blob([binaryData],{type:'application/json'});
					$window.saveAs(jsonBlob, utilSvc.regex.cleanFilename('Verity-Admin-Settings.json'));
				}
			}
			catch(err) {
				throw(err);
			}

		}

		function errFileExport(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r !== null) {
				errSvc.warn('Create Export file Error', 'adminSettingsCtl.errFileExport', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    JSON IMPORT
	 */

	function importValidFile(newFile) {

		// required
		if(!!!newFile) {
			return 'no file selected';
		}

		// file size > 0 bytes, < 10 megabytes
		if(!validSvc.isNumber(newFile.size) || newFile.size < 1 || newFile.size > 100000000) {
			return 'file size must be 2 bytes to 100 megabytes';
		}

		// file name must be .json
		var fName = newFile.name;
		if(!validSvc.isText(fName) || fName.length < 6 || fName.substr(fName.length - 5, 5).toLowerCase() !== '.json') {
			return 'file name must end with extension ".json"';
		}

		return 'ok';

	}

	function jsonImportValid() {

		// files selected
		if(!!!vm.jsonImportFiles || vm.jsonImportFiles.length !== 1) {
			msgSvc.ok('File Import', 'Please choose 1 file to upload.');
			return false;
		}

		// validate file
		var fileFail = importValidFile(vm.jsonImportFiles[0]);
		if(fileFail != 'ok') {
			msgSvc.ok('File Import', 'Selected file error: ' + fileFail);
			return false;
		}

		return true;

	}

	function jsonImport() {

		if(vm.isWaiting) {
			return;
		}

		if(!jsonImportValid()) {
			return;
		}

		msgSvc.confirm({
			id: 'admin.set.jsonimport',
			title: 'Json Import',
			msg: 'Warning: this action cannot be reversed, please verify the Json file name is correct.',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmJsonImport, confirmJsonImport);
	}

	function confirmJsonImport(r) {

		// user cancelled
		if(!!!r || r.result != 'YES') {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		affOptionsRepo.importAdminSettings(vm.jsonImportFiles[0]).then(okFileImport, errFileImport);

		function okFileImport(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;
			msgSvc.ok('File Import Success', 'Facility, Pharmacy and affiliation settings can take 1 or 2 minutes to update. Refresh your browser to see new settings.');
		}

		function errFileImport(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(r === null) {
				return;
			}
			else {
				errSvc.warn('Unexpected api error', 'affOptionsRepo.errFileImport', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    MULTISELECT HELPERS
	 */

	function applyPrimarySecondaryMulti(primeProp, ceVals, rxVals) {

		// setup primary / secondary multiselects based on incoming values

		_primaryProp = primeProp;

		var primeName = primeProp == 'CE' ? 'Facility' : 'Pharmacy',
			secName = primeProp == 'RX' ? 'Facility' : 'Pharmacy',
			affs = getAffs();

		// primary labels
		vm.PrimaryMulti.type = primeProp;
		vm.PrimaryMulti.name = primeName;
		vm.PrimaryMulti.titleNoOptions = 'Choose a ' + primeName;

		// primary data
		var primeVals = primeProp == 'CE' ? ceVals : rxVals,
			primeList = primeProp == 'CE' ? utilSvc.aff.ceDroplistLabel(affs,null,true,false,$rootScope.User.AdminPrefs.ListDisplay) : utilSvc.aff.rxList(affs);
		vm.PrimaryMulti.list = primeProp == 'CE' ? vm.multiselectBuildWithLabel(primeList) : vm.multiselectBuildRX(primeList, false, affs);
		vm.multiselectReturnVisit(vm.PrimaryMulti, '', primeVals);
		vm.multiselectTitle(vm.PrimaryMulti, true);
		vm.query.primary.fail = vm.PrimaryMulti.vals.length < 1 ? 'yes' : 'no';

		// secondary labels
		vm.SecondaryMulti.type = primeProp == 'CE' ? 'RX' : 'CE';
		vm.SecondaryMulti.name = secName;
		vm.SecondaryMulti.titleNoOptions = 'Choose a ' + secName;

		// secondary data
		vm.SecondaryMulti.vals = primeProp == 'CE' ? rxVals: ceVals;
		vm.SecondaryMulti = multiselectRebuildSecondary(vm.PrimaryMulti, vm.SecondaryMulti, affs, true);
		vm.query.secondary.fail = vm.SecondaryMulti.vals.length < 1 ? 'yes' : 'no';

	}

	function multiselectRebuildSecondary(primary, secondary, affs, usingALL) {

		// rebuild secondary multiselect based on values in primary multiselect

		usingALL = !!usingALL;

		if(primary.vals.length < 1) {
			secondary.list = [];
			secondary.vals = [];
		}
		else {
			var primeAllVals = vm.multiselectAllVals(primary);
			affs = primary.type == 'CE' ? utilSvc.aff.findCeList(affs, primeAllVals) : utilSvc.aff.findRxList(affs, primeAllVals);

			var secList = primary.type == 'CE' ? utilSvc.aff.rxList(affs) : utilSvc.aff.ceList(affs),
			vals = secondary.vals,
			newVals = [];

			if(vals.length === 1 && vals[0] == 'ALL') {
				newVals = ['ALL'];
				usingALL = true;
			}
			else {
				// add new val only if it exists in new secList
				for(var i = 0; i < vals.length; i++) {
					if(secList.indexOf(vals[i]) > -1) {
						newVals.push(vals[i]);
					}
				}
			}

			// assign new check list
			if(usingALL && secList.length > 1) {
				secList.unshift('ALL');
			}
			if(secondary.type == 'RX') {
				secondary.list = vm.multiselectBuildRX(secList, false, affs);
			}
			else {
				secondary.list = vm.multiselectBuildCE(secList, false, affs, $rootScope.User.AdminPrefs.ListDisplay);
			}

			// assign vals
			if((!usingALL && secList.length === newVals.length) || (usingALL && ((newVals.length > 0 && newVals[0] == 'ALL') || secList.length - 1 === newVals.length))) {
				// all vals are checked
				secondary.vals = [];
				vm.multiselectClick(secondary, 'ALL');
			}
			else {
				vm.multiselectReturnVisit(secondary, '', newVals);
			}
		}

		// set RX title
		vm.multiselectTitle(secondary, true);

		return secondary;

	}

	function multiselectQueryVals(multiselect) {

		// unpack the vals multiselect into a list of entities to query

		var checklist = multiselect.list,
			vals = multiselect.vals;

		if(vals.length < 1) {
			return [];
		}
		else if(vals.length === 1 && vals[0] == 'ALL') {
			// using ALL checkbox, return all values except ALL checkbox
			var result = [],
				i = checklist[0].val == 'ALL' ? 1 : 0;
			for(i; i < checklist.length; i++) {
				result.push(checklist[i].val);
			}
			return result;
		}
		else {
			return vals;
		}
	}

	function multiClick(propName, val) {

		queryChange();

		var multiPropName = propName + 'Multi';
		var multi = vm[multiPropName];

		vm.multiselectClick(multi, val);
		vm.multiselectTitle(multi, true);

		// primary changed, rebuild secondary
		if(_primaryProp == multi.type) {

			// validation
			var queryPropName = propName.toLowerCase();
			vm.query[queryPropName].fail = multi.vals.length < 1 ? 'yes' : 'no';

			vm.SecondaryMulti = multiselectRebuildSecondary(vm.PrimaryMulti, vm.SecondaryMulti, getAffs(), true);
			vm.query.secondary.fail = 'no';

			// do not automatically select 1 secondary
			if(vm.SecondaryMulti.list.length < 3) {
				vm.multiClick('Secondary', '|CLEAR|');
			}
		}

	}

	function multiToggle(evt, propName, elemId) {

		// show / hide multiselect list

		var multi = vm[propName];
		multi.flt = '';

		// hide multi list
		if(multi.show) {
			multi.show = false;
			return;
		}

		// show with minimum width
		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(elemId + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(elemId);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multi.show = true;

	}

	function multiHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}


	/**
	 *    HELPERS
	 */

	function filterSwapToCERX(query) {
		return {
			CE: _primaryProp == 'CE' ? vm.query.primary.val : vm.query.secondary.val,
			RX: _primaryProp == 'RX' ? vm.query.primary.val : vm.query.secondary.val
		};
	}

	function saveViewState(tb, primeProp, query) {

		sessionRepo.set('vs-admin-settings', {
			activeTab: tb,
			primaryProp: primeProp,
			primary: query.primary.val,
			secondary: query.secondary.val
		});

	}

}
 
usrRepo.$inject = ['$rootScope', '$q', 'apiService', 'sessionRepo', 'errSvc', 'utilSvc', 'validSvc', 'vmSvc'];angular
.module('espui.admin.user')
.factory('userRepo', usrRepo);


/* @ngInject */
function usrRepo($rootScope, $q, apiService, sessionRepo, errSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _currentPurl = '',
		_modelPending = null,
		_apiPaging = vmSvc.api.paging();

	// service definition
	var service = {
		contextVM: contextVM,
		contextRefreshVM: contextRefreshVM,
		modelVM: modelVM,
		oktaProfileVM: oktaProfileVM,

		// user read
		getList: getList,
		getBadLogins: getBadLogins,
		getUser: getUser,
		getExcel: getExcel,
		getEntityGroups: getEntityGroups,

		// user write
		create: create,
		update: update,
		statusChange: statusChange,

		// user profile
		getProfile: getProfile,
		saveProfile: saveProfile,
		savePreferences: savePreferences,

		// send tokens
		sendActivate: sendActivate,
		sendPwdReset: sendPwdReset,

		// entity policy
		getPolicy: getPolicy,
		savePolicy: savePolicy,

		// security QA
		getSecurityQA: getSecurityQA,
		saveSecurityQA: saveSecurityQA,

		// impersonate
		impersonate: impersonate,

		// claims
		getClaims: getClaims,
		saveClaim: saveClaim,
		saveReviews: saveReviews,

		// okta customer
		getOktaCustomer: getOktaCustomer,
		oktaStatusChange: oktaStatusChange,

		// user review settings
		editUserReviewConfig: editUserReviewConfig,
		getUserReviewConfig: getUserReviewConfig

	};

	return service;


	/**
	 *    CONTEXT VIEW MODEL
	 */

	function contextVM() {

		var usr = $rootScope.User;
		var uType = usr.Type;

		// RX User: link to Pharmacies which have (Type DISPENSING or CENTRALFILL) and (BizModel all except CPTPA)
		var rxAffs = utilSvc.aff.findRxType(usr.AffList, ['DISPENSING', 'CENTRALFILL']);
		rxAffs = utilSvc.aff.findRxModel(rxAffs, ['CP', 'CPSPLIT', 'SPLIT', 'SPLITMATCH']);

		return {
			isVeritySA: uType == 'VERITYSA', // add on top for ease of use
			isVerity: isDriverVerity(usr), // add on top for ease of use
			IsAuthorizer: driverIsAuthorizer(usr, $rootScope),
			isPROD: !!$rootScope.appConfig ? $rootScope.appConfig.env == 'prod' : false,
			driver: {
				type: uType,
				UserName: usr.UserName,
				isVerity: isDriverVerity(usr),
				IsVhub: !!usr.IsVhub,
				IsAuthorizer: driverIsAuthorizer(usr, $rootScope),
				CE: usr.CE,
				RX: usr.RX,
			},
			CEList: utilSvc.aff.ceList(usr.AffList),
			RXList: utilSvc.aff.rxList(rxAffs),
			EntityGroups: []
		};

	}

	function isDriverVerity(usr) {
		return usr.Type == 'VERITYSA' || usr.Type == 'VERITY';
	}

	function driverIsAuthorizer(usr, scp) {
		switch(usr.Type) {
			case 'CE':
				return !!usr.IsAuthorizer && utilSvc.user.hasFeature(scp, 'customer.admin.ce');
			case 'RX':
				return !!usr.IsAuthorizer && utilSvc.user.hasFeature(scp, 'customer.admin.rx');
			default:
				return false;
		}
	}

	function contextRefreshVM() {

		// called by user.update or user.profile
		// all admin features refresh the affs before edits

		var defer = $q.defer();
		apiService.refreshUser().then(okAffRefresh, errAffRefresh);

		function okAffRefresh(r) {
			defer.resolve(contextVM());
		}

		function errAffRefresh(r) {
			if(r !== null) {
				errSvc.warn('User affiliations request failed', 'userRepo.contextRefreshVM', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	function getEntityGroups(grpType) {
		if(grpType != 'CE' && grpType != 'PHARMACY') {
			throw new Error('userRepo.getEntityGroups, grpType must be CE / PHARMACY');
		}

		var defer = $q.defer();
		_currentPurl = 'admin/entitygroup/list';

		var apiRequest = {
			Type: grpType
		};
		apiService.post(_currentPurl, apiRequest).then(okGroups, errGroups);

		function okGroups(r) {
			// api null array fix
			if(!!r && !!r.data) {
				r.data.Entity = Array.isArray(r.data.Entity) ? r.data.Entity : [];
			}

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl, r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errGroups(r) {
			if(r !== null) {
				errSvc.warn('User Entity groups request failed', _currentPurl, r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 *    USER MODELS
	 */

	function modelVM(data) {

		data = data || {};

		var m = {
			ROOT: validSvc.newProp(null),
			Id: validSvc.isText(data.Id) ? data.Id : null,
			ObjectState: validSvc.isText(data.ObjectState) ? data.ObjectState : 'NEW',
			UserType: validSvc.isText(data.UserType) ? validSvc.newProp(data.UserType) : validSvc.newProp('NONE'),
			EmailValid: !!data.EmailValid,
			UserName: validSvc.isText(data.UserName) ? validSvc.newProp(data.UserName) : validSvc.newProp(null),
			Password: validSvc.newProp(null),
			PwdConfirm: validSvc.newProp(''),
			FirstName: validSvc.isText(data.FirstName) ? validSvc.newProp(data.FirstName) : validSvc.newProp(null),
			LastName: validSvc.isText(data.LastName) ? validSvc.newProp(data.LastName) : validSvc.newProp(null),
			CE: validSvc.newProp('NONE'),
			CEList: [],
			RX: validSvc.newProp('NONE'),
			RXList: [],
			RestrictType: validSvc.isText(data.RestrictBy) ? data.RestrictBy : 'NONE',
			AFFList: data.RestrictBy == 'AFF' ? data.AFFList : [],
			CanAccessCP : data.RestrictBy == 'MODEL' && !!data.CanAccessCP,
			CanAccessCPTPA : data.RestrictBy == 'MODEL' && !!data.CanAccessCPTPA,
			CanAccessSPLIT : data.RestrictBy == 'MODEL' && !!data.CanAccessSPLIT,
			CanAccessSPLITMATCH : data.RestrictBy == 'MODEL' && !!data.CanAccessSPLITMATCH,
			Okta: !!data.Okta,
			OktaCustomer: !!data.OktaCustomer ? 'yes' : 'no',
			OktaMigration: !!data.OktaMigration ? 'yes' : 'no',
			OktaMfaDisabled: !!data.OktaMfaDisabled ? 'yes' : 'no',
			OktaMfaPhone: validSvc.isText(data.OktaMfaPhone) ? data.OktaMfaPhone : '',
			OktaDefaultFactor: data.OktaDefaultFactor,
			IsDemo: !!data.IsDemo,
			IsVhub : !!data.IsVhub,
			IsAuthorizer: !!data.IsAuthorizer ? 'yes' : 'no',
			AuthAttested: !!data.IsAuthorizer,
			AuthEntities: newValsProp(!!data.IsAuthorizer ? data.AuthEntities : []),
			MySupervisor: validSvc.isText(data.MySupervisor) ? data.MySupervisor : 'NONE',
			ReviewStatus: data.ReviewStatus,
			ReviewDate: validSvc.isDate(data.ReviewDate) ? data.ReviewDate : null,
			ReviewBy: validSvc.isText(data.ReviewBy) ? data.ReviewBy : ''
		};

		// helpers for user type
		m.ValidUserType = m.UserType.val != 'NONE' ? m.UserType.val : '';
		m.UserTypeDataKey = m.ValidUserType;
		
		// CE/RX dependents
		switch(m.ValidUserType) {
			case 'CE':
				var ceItems = Array.isArray(data.CEList) ? data.CEList : [];
				m.CE.val =  ceItems.length > 0 ? ceItems[0] : 'NONE'; // first in list is primary CE
				m.CEList = ceItems.length > 1 ? ceItems.slice(1) : [];
				m.CEList.sort();
				m.UserTypeDataKey += '|' + m.CE.val + '|' + m.CEList.join('|');
				break;
			case 'RX':
			case 'ROLLUP':
				var rxItems = Array.isArray(data.RXList) ? data.RXList : [];
				m.RX.val =  rxItems.length > 0 ? rxItems[0] : 'NONE'; // first in list is primary RX
				if(m.ValidUserType == 'RX' && rxItems.length > 1) {
					m.RXList = rxItems.slice(1);
				}
				else {
					m.RXList = [];
				}
				m.RXList.sort();
				m.UserTypeDataKey += '|' + m.RX.val + '|' + m.RXList.join('|');
				break;
		}
		m.RestrictDependsOnKey = m.UserTypeDataKey;
		m.SuperAuthDependsOnKey = m.UserTypeDataKey;

        // partner sso user
        // with a valid PartnerId, JwtClaim and UserId
        data.OktaPartner = data.OktaPartner || {};
        var isPartnerSSO = isOktaPartner(data.OktaCustomer, data.OktaPartner);
        m.OktaPartnerId = isPartnerSSO ? data.OktaPartner.PartnerId : '';
        m.OktaPartnerJwtClaim = isPartnerSSO ? data.OktaPartner.JwtClaim : '';
        m.OktaPartnerUserId = validSvc.newProp(isPartnerSSO ? data.OktaPartner.UserId : '');
        
        // OktaPartner cannot be changed after CREATE, lock on PartnerId
        m.OktaPartnerDependsOnKey = isPartnerSSO ? m.OktaPartnerId : '';
        var ssoChoice = !!m.Id ? 'no' : '';
        m.OktaPartnerEnabled = isPartnerSSO ? {} : null; // virtual property for UI
        m.OktaPartner = isPartnerSSO ? 'yes' : ssoChoice;
        m.OktaPartnerError = '';

		return m;

	}

    function isOktaPartner(isCustomer, oktaPartner) {
        return isCustomer && !!oktaPartner &&
            validSvc.isText(oktaPartner.PartnerId) &&
            validSvc.isText(oktaPartner.JwtClaim) &&
            validSvc.isText(oktaPartner.UserId);
    }

	function newValsProp(vals) {
		var newProp = validSvc.newProp();
		newProp.vals = Array.isArray(vals) ? vals : [];
		return newProp;
	}

	function profileVM(data) {

		data = data || {};

		return {
			Id: data.Id,
			UserType: data.UserType,
			UserName: data.UserName,
			Password: validSvc.newProp(''),
			PwdConfirm: validSvc.newProp(''),
			ChallengeQuestion: validSvc.isText(data.ChallengeQuestion) ? validSvc.newProp(data.ChallengeQuestion) : validSvc.newProp(''),
			ChallengeAnswer: validSvc.isText(data.ChallengeAnswer) ? validSvc.newProp(data.ChallengeAnswer) : validSvc.newProp(''),
			FirstName: validSvc.isText(data.FirstName) ? validSvc.newProp(data.FirstName) : validSvc.newProp(''),
			LastName: validSvc.isText(data.LastName) ? validSvc.newProp(data.LastName) : validSvc.newProp(''),
			CEList: Array.isArray(data.CEList) ? data.CEList : [],
			RXList: Array.isArray(data.RXList) ? data.RXList : [],
			IsDemo: data.IsDemo,
      		IsVhub: data.IsVhub
		};

	}

	function oktaProfileVM() {
		var usr = $rootScope.User;
		return {
			UserType: usr.Type,
			UserName: usr.UserName,
			Password: validSvc.newProp(''),
			PwdConfirm: validSvc.newProp(''),
			ChallengeQuestion: validSvc.newProp(''),
			ChallengeAnswer: validSvc.newProp(''),
			FirstName: validSvc.newProp(usr.Fname), 
			LastName: validSvc.newProp(usr.Lname),
			CEList: utilSvc.aff.ceList($rootScope.User.AffList),
			RXList: utilSvc.aff.rxList($rootScope.User.AffList),
			Okta: true
		};
	}


	/**
	 *    GET LIST
	 */

	function requestUserList(q) {
		// derive user types
		var userTypes = [];
		function addType(ut, hasType) {
			if(hasType) {
				userTypes.push(ut);
			}
		}
		addType('VERITY', q.VERITY);
		addType('VERITYSA', q.VERITYSA);
		addType('CE', q.CEchk);
		addType('RX', q.RXchk);

		// create api request
		return {
			Context: {
				CEID: q.CE,
				RXID: q.RX
			},
			Params: {
				Status: q.Status,
				UserType: userTypes,
				RxSearchType: q.RxSearchType,
				Okta: q.Okta,
				IsVhub: q.IsVhub,
				Demo: q.Demo,
				Supervisors: q.Supervisors,
				ReviewStatus: q.ReviewStatus,
				IsAuthorizer: q.IsAuthorizer
			}
		};
	}

	function requestCustomerList(q) {
		// customer request is minimal, only CE or RX

		var userTypes = [];
		if(q.CEchk) {
			userTypes.push('CE');
		}
		else if(q.RXchk) {
			userTypes.push('RX');
		}
		else {
			throw new Error('userRepo.requestForCustomerList, CE or RX required');
		}

		// create api request
		return {
			Context: {
				CEID: [],
				RXID: []
			},
			Params: {
				Status: q.Status,
				UserType: userTypes,
				ReviewStatus: q.ReviewStatus
			}
		};
	}

	function getList(q) {
		var driverIsVerity = isDriverVerity($rootScope.User);

		_currentPurl = driverIsVerity ? 'user/list' : 'customer/user/list';
		var request = driverIsVerity ? requestUserList(q) : requestCustomerList(q);
		request.Paging = _apiPaging;
		request.SortBy = [utilSvc.sorting.sortByApiStyle('LastName')];
		
		var defer = $q.defer();
		apiService.post(_currentPurl, request).then(okGetList, errGetList);

		function okGetList(r) {
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errGetList(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 *    GET BAD LOGINS
	 */

	function getBadLogins(query) {

		_currentPurl = 'user/badlogins';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val
			},
			Paging: {
				Page: 1,
				Size: 20000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('-TotalAttempts')]
		};

		// call api
		apiService.post(_currentPurl, apiReqest).then(okGetBadLogins, errGetBadLogins);

		function okGetBadLogins(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errGetBadLogins(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    GET USER
	 *    used by user update
	 */

	function getUser(id) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('userRepo.getUser, id required');
		}

		_currentPurl = isDriverVerity($rootScope.User) ? 'user/get' : 'customer/user/get';

		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Entity: {
				Id: id
			}
		};

		// call api
		apiService.post(_currentPurl, apiReqest).then(getOk, getErr);

		function getOk(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return data
			defer.resolve(modelVM(r.data.Entity));

		}

		function getErr(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}
	

	/**
	 *    UPSERT USER
	 */

	function create(model) {

		// simple params check to catch UI issues
		if(!!!model ||
			(!validSvc.isText(model.ValidUserType)) ||
			!validSvc.isText(model.UserName.val) ||
			!validSvc.isText(model.FirstName.val) ||
			!validSvc.isText(model.LastName.val)) {

			throw new Error('userRepo.create, model params missing' + utilSvc.json.stringify(model, true));
		}

		// upsert!
		return upsert('user/create', model);

	}

	function update(model) {

		// simple params check to catch UI issues
		if(!!!model ||
			!validSvc.isText(model.Id) ||
			(!validSvc.isText(model.ValidUserType)) ||
			!validSvc.isText(model.UserName.val) ||
			!validSvc.isText(model.FirstName.val) ||
			!validSvc.isText(model.LastName.val)) {

			throw new Error('userRepo.update, model params missing' + utilSvc.json.stringify(model, true));
		}

		// upsert!
		var updatePurl = isDriverVerity($rootScope.User) ? 'user/update' : 'customer/user/save';
		return upsert(updatePurl, model);

	}

	function upsert(purl, model) {

		var defer = $q.defer();

		_currentPurl = purl;
		_modelPending = model;

		// celist/rxlist are different by UserType, for CE/RX user type parse multiple choice checklists
		var uType = model.ValidUserType,
			celist = [],
			rxlist = [];

		switch(uType) {
			case 'VERITYSA':
			case 'VERITY':
				celist = ['ALL'];
				rxlist = ['ALL'];
				break;
			case 'RXROLLUP':
				celist = ['NONE'];
				rxlist = [model.RX.val];
				break;
			case 'CE':
				celist = JSON.parse(JSON.stringify(model.CEList)); // de-ref
				celist.unshift(model.CE.val); // primary always at top of CE list
				break;
			case 'RX':
				rxlist = JSON.parse(JSON.stringify(model.RXList)); // de-ref
				rxlist.unshift(model.RX.val); // primary always at top of RX list
				celist = ['NONE'];
				break;
			default:
				throw new Error('userRepo.upsert, user type unknown: ' + uType);
		}

		// create api request
		var apiReqest = {
			Context: {},
			Entity: {
				Id: model.Id,
				UserType: uType,
				CEList: celist,
				RXList: rxlist,
				RestrictBy: model.RestrictType,
				AFFList: model.AFFList,
				CanAccessCP: model.CanAccessCP,
				CanAccessCPTPA: model.CanAccessCPTPA,
				CanAccessSPLIT: model.CanAccessSPLIT,
				CanAccessSPLITMATCH: model.CanAccessSPLITMATCH,
				UserName: model.UserName.val,
				Password: model.Password.val,
				FirstName: model.FirstName.val,
				LastName: model.LastName.val,
				Okta: !!model.Okta,
				OktaCustomer: model.OktaCustomer == 'yes' || model.OktaCustomer == 'start',
				OktaMigration: model.OktaMigration == 'yes' || model.OktaMigration == 'start',
				OktaMfaDisabled: model.OktaMfaDisabled == 'yes',
				IsDemo: !!model.IsDemo,
				IsVhub : !!model.IsVhub,
				IsAuthorizer: model.IsAuthorizer == 'yes',
				AuthEntities: model.IsAuthorizer == 'yes' ? model.AuthEntities.vals : [],
				MySupervisor: model.MySupervisor != 'NONE' ? model.MySupervisor : ''
			}
		};

        // partner sso (de-flatten OktaPartner properties into expected api structure)
        if(model.OktaPartner == 'yes') {
            _modelPending.OktaPartnerError = ''; // handle all partner sso errors with a general handler
            apiReqest.Entity.OktaCustomer = true; // partner sso forces OktaCustomer immediately
            apiReqest.Entity.OktaPartner = {
                PartnerId: model.OktaPartnerId,
                JwtClaim: model.OktaPartnerJwtClaim,
                UserId: model.OktaPartnerUserId.val
            };
        }

		apiService.post(_currentPurl, apiReqest).then(upsertOk, upsertErr);

		function upsertOk(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
			_modelPending = null;
		}

		function upsertErr(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapApiErrorsToModel(r, _modelPending);
				defer.reject(r);
			}
			else {
				_modelPending = null;
				throw new Error('userRepo.upsertErr, unexpected error result on purl: ' + _currentPurl);
			}
			_modelPending = null;

		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: true,
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldObj,
				fieldName = '';

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// switch CEList and RXList into CE and RX
				if(fieldName == 'CEList') {
					fieldName = 'CE';
				}
				else if(fieldName == 'RXList') {
					fieldName = 'RX';
				}
				else if(fieldName == 'IsDemo') {
					continue;
				}
                else if(fieldName == 'PartnerId' || fieldName == 'JwtClaim' || fieldName == 'UserId') {
                    // asssign all partner sso errors to general handler
                    m.OktaPartnerError = entity.Fields[i].Rule;
                    continue;
                }

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);

				// property not found on model
				if(fieldObj === undefined) {
					throw new Error('userRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName);
				}

				// set failed state
				fieldObj.fail = 'yes';
				fieldObj.msg = entity.Fields[i].Rule;

			}

			return m;

		}


		return defer.promise;

	}

	/**
	 *    STATUS CHANGE
	 */

	function statusChange(id, status) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('userRepo.statusChange, id is missing');
		}
		var isVerity = isDriverVerity($rootScope.User);

		// set purl
		switch(status) {

			case 'ACTIVE':
				_currentPurl = isVerity ? 'user/status/active' : 'customer/user/status/active';
				break;
			case 'SUSPENDED':
				_currentPurl = isVerity ? 'user/status/suspend' : 'customer/user/status/suspend';
				break;
			case 'DELETED':
				_currentPurl = isVerity ? 'user/status/delete' : 'customer/user/status/delete';
				break;

			default:
				throw new Error('userRepo.statusChange, status unknown: ' + status);
		}

		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Context: {},
			Entity: {
				Params: {
					Id: id
				}
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okStat, errStat);

		function okStat(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function errStat(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else {
				throw new Error('userRepo.errStat, unexpected error result');
			}

		}


		return defer.promise;

	}


	/**
	 *    OKTA CUSTOMER
	 */

	function getOktaCustomer(userName) {

		// params
		if(!validSvc.isText(userName)) {
			throw new Error('userRepo.getOktaCustomer, userName required');
		}

		// choose full user or profile api endpoint
		_currentPurl = 'okta/customer/get';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Params: {
				UserName: userName
			}
		};

		// call api
		apiService.post(_currentPurl, apiReqest).then(getOk, getErr);

		function getOk(r) {
			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function getErr(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}
	
	function oktaStatusChange(id, status) {

		if(!validSvc.isText(id) || (status != 'REPAIR' && status != 'FORCE_REPAIR')) {
			throw new Error('userRepo.oktaStatusChange, id and REPAIR status required');
		}

		_currentPurl = 'okta/customer/status';
		var defer = $q.defer();
		var apiReqest = {
			Entity: {
				Id: id,
				Status: status
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okOktaStat, errOktaStat);

		function okOktaStat(r) {
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}
			defer.resolve({});
		}

		function errOktaStat(r) {
			if(!!r) {
				errSvc.warn('Api request failed with unexpected error', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 *    SEND ACTIVATION
	 */

	function sendActivate(id, urlRoot) {

		// params
		if(!validSvc.isText(id) || !validSvc.isText(urlRoot)) {
			throw new Error('userRepo.sendActivate, id is required');
		}

		var defer = $q.defer();
		_currentPurl = 'user/sendactivate';

		var apiRequest = {
			Entity: {
				Id: id,
				Url: urlRoot
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okSendActivate, errSendActivate);

		function okSendActivate(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errSendActivate(r) {

			if(!!r) {
				errSvc.error('Unexpected api error', _currentPurl, r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);

		}

		return defer.promise;

	}


	/**
	 *    SEND PASSWORD RESET
	 */

	function sendPwdReset(id, urlRoot) {

		// params
		if(!validSvc.isText(id) || !validSvc.isText(urlRoot)) {
			throw new Error('userRepo.sendPwdReset, id is required');
		}

		var defer = $q.defer();
		_currentPurl = 'user/pwdresetsend';

		var apiRequest = {
			Entity: {
				Id: id,
				Url: urlRoot
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okSendPwdReset, errSendPwdReset);

		function okSendPwdReset(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errSendPwdReset(r) {

			if(!!r) {
				errSvc.error('Unexpected api error', _currentPurl, r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);

		}

		return defer.promise;

	}


	/**
	 *    POLICY
	 *    get and save the terms/policy for a CE or RX
	 */

	function getPolicy(query) {

		_currentPurl = 'user/entitymanage/get';
		var defer = $q.defer();

		var apiRequest = {
			Entity: {
				Name: query.EntityId.val,
				Type: query.EntityType
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okGetPolicy, errGetPolicy);

		function okGetPolicy(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// use 422 props for IP Allow List
			var ipItems = Array.isArray(r.data.Entity.IpAllowList) ? r.data.Entity.IpAllowList : [];
			for(var i = 0; i < ipItems.length; i++) {
				ipItems[i] = {
					Id: i.toString(),
					Start: ipItems[i].Start,
					End: ipItems[i].End,
					fail: 'no',
					msg: ''
				};
			}

			defer.resolve(r.data.Entity);

		}

		function errGetPolicy(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function savePolicy(query, model) {

		_currentPurl = 'user/entitymanage/save';
		var defer = $q.defer();

		var termsChange = model.TermsChanged == 'yes';
		var terms = termsChange ? model.Terms.val : '';

		var ipItems = [];
		for(var i = 0; i < model.IpAllowList.length; i++) {
			model.IpAllowList[i].fail = 'no';
			ipItems.push({
				Start: model.IpAllowList[i].Start,
				End: model.IpAllowList[i].End
			});
		}

		var apiRequest = {
			Entity: {
				Name: query.EntityId.val,
				Type: query.EntityType,
				Terms: terms,
				TermsChanged: termsChange,
				PwdDaysToExpire: parseInt(model.PwdDaysToExpire.val),
				TwoFactorAuth: model.TwoFactorAuth == 'yes',
				OktaMigration: !!model.OktaMigration,
				TwoFactorAuthDuration: 5,
				ReusePwdLimit: parseInt(model.ReusePwdLimit.val),
				SuspendAfterDays: parseInt(model.SuspendAfterDays.val),
				IpAllowList: ipItems
			}
		};

		_modelPending = model;
		apiService.post(_currentPurl, apiRequest).then(okSavePolicy, errSavePolicy);

		function okSavePolicy(r) {

			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errSavePolicy(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!!r & r.status === 422) {
				r.model = mapPolicy422ToModel(r, _modelPending);
				defer.reject(r);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				throw new Error('userRepo.errSavePolicy, unexpected error result on purl: ' + _currentPurl);
			}
		}

		function mapPolicy422ToModel(r, m) {

			// map server 422 fields onto model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: true,
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldObj,
				fieldName = '';

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// ip allow list property
				if(fieldName.substr(0, 12) == 'IPALLOWLIST_') {
					var idxSuffix = parseInt(fieldName.substr(12, fieldName.length - 12));
					m.IpAllowList[idxSuffix].fail = 'yes';
					m.IpAllowList[idxSuffix].msg = entity.Fields[i].Rule;
				}
				else {

					// using different model names from api view model
					if(fieldName == 'Id' || fieldName == 'Type') {
						fieldName = 'Entity' + fieldName;
					}

					// parse model for property name
					fieldObj = utilSvc.obj.findChildProp(m, fieldName);

					// property not found on model
					if(fieldObj === undefined) {
						throw new Error('userRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName);
					}

					// set failed state
					fieldObj.fail = 'yes';
					fieldObj.msg = entity.Fields[i].Rule;

				}

			}

			return m;

		}

		return defer.promise;

	}


	/**
	 *    USER PROFILE
	 */

	function getProfile(pwd) {

		// params
		if(!validSvc.isText(pwd)) {
			throw new Error('userRepo.getProfile, password required');
		}

		_currentPurl = 'user/myaccount/get';
		var defer = $q.defer();

		var apiRequest = {
			Entity: {
				Password: pwd
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okGetProfile, errGetProfile);

		function okGetProfile(r) {

			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(profileVM(r.data.Entity));

		}

		function errGetProfile(r) {

			if(r === null) {
				// do nothing
			}
			else if(!!r && r.status === 422) {
				defer.reject({status:422});
			}
			else {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function savePreferences(model) {

		// simple params check to catch UI issues
		if(!!!model || !validSvc.isText(model.Id)) {
			throw new Error('userRepo.savePreferences, id required');
		}

		var defer = $q.defer();
		_currentPurl = 'user/mypreferences/save';
		_modelPending = model;

		var apiRequest = {
			Entity: {
				Id: model.Id,
				//cedisplay: model.cedisplay
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okSavePreferences, errSavePreferences);

		function okSavePreferences(r) {

			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// emit to header/footer
			$rootScope.$emit('espui>user.profile.change', {});

			defer.resolve({});
		}

		function errSavePreferences(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapProfileErrorsToModel(r, _modelPending);
				defer.reject(r);
			}
			else {
				throw new Error('userRepo.errSavePreferences, unexpected error result on purl: ' + _currentPurl);
			}
		}


	
		function mapProfileErrorsToModel(r, m) {

			// map server 422 fields onto model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: true,
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldObj,
				fieldName = '';

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);
				if(fieldObj === undefined) {
					throw new Error('userRepo.mapProfileErrorsToModel, api 422 field name not found: ' + fieldName);
				}

				// set failed state
				fieldObj.fail = 'yes';
				fieldObj.msg = entity.Fields[i].Rule;

			}

			return m;

		}

		return defer.promise;
	}	


	function saveProfile(model) {

		// simple params check to catch UI issues
		if(!!!model || !validSvc.isText(model.Id)) {
			throw new Error('userRepo.saveProfile, id required');
		}

		var defer = $q.defer();
		_currentPurl = 'user/myaccount/save';
		_modelPending = model;

		var apiRequest = {
			Entity: {
				Id: model.Id,
				Password: model.Password.val,
				FirstName: model.FirstName.val,
				LastName: model.LastName.val,
				ChallengeQuestion: model.ChallengeQuestion.val,
				ChallengeAnswer: model.ChallengeAnswer.val
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okSaveProfile, errSaveProfile);

		function okSaveProfile(r) {

			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update session
			var sUser = sessionRepo.get('User');
			if(!!sUser) {
				sUser.Fname = model.FirstName.val;
				sUser.Lname = model.LastName.val;
				sessionRepo.set('User', sUser);
			}

			// update rootScope
			$rootScope.User.Fname = model.FirstName.val;
			$rootScope.User.Lname = model.LastName.val;

			// emit to header/footer
			$rootScope.$emit('espui>user.profile.change', {});

			defer.resolve({});
		}

		function errSaveProfile(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapProfileErrorsToModel(r, _modelPending);
				defer.reject(r);
			}
			else {
				throw new Error('userRepo.errSaveProfile, unexpected error result on purl: ' + _currentPurl);
			}

		}

		function mapProfileErrorsToModel(r, m) {

			// map server 422 fields onto model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: true,
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldObj,
				fieldName = '';

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);
				if(fieldObj === undefined) {
					throw new Error('userRepo.mapProfileErrorsToModel, api 422 field name not found: ' + fieldName);
				}

				// set failed state
				fieldObj.fail = 'yes';
				fieldObj.msg = entity.Fields[i].Rule;

			}

			return m;

		}

		return defer.promise;

	}


	/**
	 *    SECURITY QA
	 */

	function getSecurityQA() {

		_currentPurl = 'user/myaccount/challengeget';
		var defer = $q.defer();

		apiService.post(_currentPurl, {}).then(okGetSecurityQA, errGetSecurityQA);

		function okGetSecurityQA(r) {

			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({Question: r.data.Entity.Question});

		}

		function errGetSecurityQA(r) {

			if(!!r) {
				errSvc.error('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function saveSecurityQA(model) {

		// simple params check to catch UI issues
		if(!!!model || !validSvc.isText(model.Question.val) || !validSvc.isText(model.Answer.val)) {
			throw new Error('userRepo.saveSecurityQA, question, answer required');
		}

		var defer = $q.defer();
		_currentPurl = 'user/myaccount/challengesave';
		_modelPending = model;

		var apiRequest = {
			Entity: {
				ChallengeQuestion: model.Question.val,
				ChallengeAnswer: model.Answer.val
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okSaveQA, errSaveQA);

		function okSaveQA(r) {

			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errSaveQA(r) {

			if(r === null) {
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapSecurityQA422(r, _modelPending);
				defer.reject(r);
			}
			else {
				throw new Error('userRepo.errSaveQA, unexpected error result on purl: ' + _currentPurl);
			}

		}

		function mapSecurityQA422(r, m) {

			// map server 422 fields onto model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: true,
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				if (fieldName == 'ChallengeQuestion') {
					m.Question.fail = 'yes';
					m.Question.msg = entity.Fields[i].Rule;
				}
				else if (fieldName == 'ChallengeAnswer') {
					m.Answer.fail = 'yes';
					m.Answer.msg = entity.Fields[i].Rule;
				}
				else {
					throw new Error('userRepo.mapSecurityQA422, field name not found: ' + fieldName);
				}

			}

			return m;

		}

		return defer.promise;

	}


	/**
	 *    IMPERSONATE
	 */

	function impersonate(id) {

		if(!validSvc.isText(id)) {
			throw new Error('userRepo.impersonate, id required');
		}

		var defer = $q.defer();
		_currentPurl = 'user/impersonate';

		var apiRequest = {
			Params: {
				Id: id
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okImp, errImp);

		function okImp(r) {
			// user on server switched, reload UI User
			_currentPurl = 'security/login/refresh';
			apiService.refreshUser().then(okUserRefresh, errImp);
		}

		function okUserRefresh() {

			// notify header/footer
			$rootScope.$emit('espui>auth.change', {});
			defer.resolve({});
		}

		function errImp(r) {

			// this is a big deal, erase the token
			sessionRepo.clear();

			if(!!r) {
				errSvc.error('Api request failed with unknown error response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
			}

			defer.reject(null);

		}

		return defer.promise;

	}


	/**
	 *    CLAIMS
	 * 		note uncomment claimsCache code to see which claims are being toggled
	 */

	function getClaims(id) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('userRepo.getClaims, id required');
		}

		var isVerity = isDriverVerity($rootScope.User);
		_currentPurl = isVerity ? 'user/perms/get' : 'customer/user/perms/get';

		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Entity: {
				Id: id
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okGetClaims, errGetClaims);

		function okGetClaims(r) {

			// bad response format
			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			var claims = Array.isArray(r.data.Entity) ? r.data.Entity : [];
			defer.resolve(claims);

		}

		function errGetClaims(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function saveClaim(userId, claimId, allow) {

		// params
		if(!validSvc.isText(userId) || !validSvc.isText(claimId)) {
			throw new Error('userRepo.saveClaim, user id and claim id required');
		}

		// choose full user or profile api endpoint
		_currentPurl = isDriverVerity($rootScope.User) ? 'user/perms/save' : 'customer/user/perms/save';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Entity: {
				Id: userId,
				ClaimId: claimId,
				Allow: allow
			}
		};

		// call api
		apiService.post(_currentPurl, apiReqest).then(okSaveClaims, errSaveClaims);

		function okSaveClaims(r) {

			// bad response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errSaveClaims(r) {
			var err = null;
			if(!!r) {
				if(r.status == 409 && validSvc.isText(r.data.error)) {
					r.msg = r.data.error;
					err = r;
				}
				else {
					errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				}
			}
			defer.reject(err);
		}

		return defer.promise;

	}

	function saveReviews(ids) {

		// params
		if(!Array.isArray(ids) || ids.length < 1) {
			throw new Error('userRepo.saveReviews, user ids required');
		}

		_currentPurl = isDriverVerity($rootScope.User) ? 'user/review/save' : 'customer/user/review/save';
		var defer = $q.defer();

		var apiRequest = {
			Entity: {
				Ids: ids
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okSaveReview, errSaveReview);

		function okSaveReview(r) {

			// bad response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errSaveReview(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + ' repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	function getReviewParam(param) {
		switch(param) {
			case 'SUPER':
				return 'internal';
			case 'AUTH':
				return 'external';
			default:
				throw new Error('userRepo.getReviewParam, invalid action: ' + param);
		}
	}
	
	function editUserReviewConfig(userType, resetReviewers, setEnabled) {
		_currentPurl = 'user/review/config/edit';
		var defer = $q.defer();

		var apiReqest = {
			Params: {
				ReviewType: getReviewParam(userType),
				ResetReviewers: resetReviewers,
				SetEnabled: setEnabled
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okUserReviewClear, errUserReviewClear);

		function okUserReviewClear(r) {

			// bad response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errUserReviewClear(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + ' repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	function getUserReviewConfig(param) {

		_currentPurl = 'user/review/config/get';

		var defer = $q.defer();

		var apiReqest = {
			Params: {
				ReviewType: getReviewParam(param)
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okUserReviewSchedule, errUserReviewSchedule);

		function okUserReviewSchedule(r) {

			// bad response format
			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + ' repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errUserReviewSchedule(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + ' repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 *    EXCEL
	 *    file created on api server, expecting a binary file stream instead of JSON
	 */

	function getExcel(q) {
		var driverIsVerity = isDriverVerity($rootScope.User);
		_currentPurl = driverIsVerity ? 'user/list/excel' : 'customer/user/list/excel';

		var request = driverIsVerity ? requestUserList(q) : requestCustomerList(q);
		var defer = $q.defer();

		apiService.postGetBinary(_currentPurl, request).then(okExcel, errExcel);
		
		function okExcel(r) {
			defer.resolve(r.data);
		}

		function errExcel(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}
}
 
userSectionClaims.$inject = ['validSvc'];
angular
.module('espui.admin.user')
.factory('userSectionClaims', userSectionClaims);


/* @ngInject */
function userSectionClaims(validSvc) {

	// service definition
	var service = {
		sectionsVM: sectionsVM,
		findClaimById: findClaimById,
		filterSections: filterSections,
		toggleSection: toggleSection,
		getReviewSections: getReviewSections
	};

	/**
	 * 	 VIEW MODELS
	 */

	function sectionsVM(apiSections, allOpen) {
		// add ui properties to the api claim sections

		apiSections = Array.isArray(apiSections) ? apiSections : [];
		var sections = [],
			section = {},
			claims = [];
		
		for(var i = 0; i < apiSections.length; i++) {
			section = apiSections[i];
			section.uniqueId = 's' + (i + 1);
			section.open = !!allOpen;
			section.show = true;

			// ensure claims is an array
			claims = Array.isArray(section.Permissions) ? section.Permissions : [];
			if(claims.length > 0) {
				claims.forEach(function(claim) {
					claim.id = claim.ClaimId;
					claim.status = claim.Allow ? 'on' : 'off'; // status used for icon and waiting state
					claim.show = true;
				});
				section.claims = claims;
				sections.push(section);
			}
		}
		return {
			allOpen: !!allOpen,
			flt: '',
			items: sections,
		};
	}

	function getReviewSections(claimSections) {
		// create an array of section titles with total claims on
		var result = [],
			claimCount = 0;
		claimSections.forEach(function(section) {
			claimCount = 0;
			section.claims.forEach(function(claim) {
				if(claim.status == 'on') {
					claimCount++;
				}
			});
			if(claimCount > 0) {
				result.push({
					Name: section.Name,
					count: claimCount,
					checked: false
				});
			}
		});

		return result;
	}


	/**
	 * 	  FIND AND FILTER
	 */

	function findClaimById(claimSectionItems, sectionId, claimId) {
		var section = {};
		for(var i = 0; i < claimSectionItems.length; i++) {
			section = claimSectionItems[i];
			if(section.uniqueId == sectionId) {
				for(var ii = 0; ii < section.claims.length; ii++) {
					if(section.claims[ii].id == claimId) {
						return section.claims[ii];
					}
				}
				break;
			}
		}
		return null;
	}

	function filterSections(claimSections) {

		// filter is reset (close all sections and show all claims)
		var resetFlt = false;
		if(!validSvc.isText(claimSections.flt)) {
			resetFlt = true;
			claimSections.flt = '';
		}

		// find section.Name and claim.Name which contains the filter text
		var sections = claimSections.items,
			flt = claimSections.flt.toLowerCase(),
			sectionsOpen = 0;
		sections.forEach(function(section) {
			// found in section name
			section.show = resetFlt || section.Name.toLowerCase().indexOf(flt) >= 0;

			section.claims.forEach(function(claim) {
				if(resetFlt || section.show) {
					claim.show = true;
				}
				else {
					// found in claim name
					claim.show = claim.Name.toLowerCase().indexOf(flt) >= 0;
					if(claim.show) {
						section.show = true;
					}
				}
			});
			section.open = !resetFlt && section.show;
			if(section.open) {
				sectionsOpen++;
			}
		});

		claimSections.allOpen = sectionsOpen == sections.length;

		return claimSections;
	}

	/**
	 * 		TOGGLE
	 */

	function toggleSection(claimSections, sectionId) {
		// function which toggles the open state of a claim section

		// toggle all sections if id empty
		var allOpen = !validSvc.isText(sectionId);
		if(allOpen) {
			claimSections.allOpen = !claimSections.allOpen;
		}

		// use for loop and break on found claim
		var sections = claimSections.items,
		 section = {};
			
		for(var i = 0; i < sections.length; i++) {
			section = sections[i];
			if(allOpen) {
				section.open = claimSections.allOpen;
			}
			else if(section.uniqueId == sectionId) {
				section.open = !section.open;
				break;
			}
		}

		return claimSections;
	}
	
	return service;
}
 
userSectionLogon.$inject = ['validSvc'];
angular
.module('espui.admin.user')
.factory('userSectionLogon', userSectionLogon);


/* @ngInject */
function userSectionLogon(validSvc) {

	// service definition
	var service = {
		validate: validate,
		isValid: isValid,
	};

	function validate(ctx, action, m) {
		// email (user name)
        var hasUserName = validSvc.isText(m.UserName.val);
        m.UserName.val = hasUserName ? m.UserName.val.toLowerCase().trim() : '';
		m.UserName = validSvc.setResult(hasUserName, m.UserName, 'required');

		// password: run validation if showing pwd and its dirty
		if(ctx.usePwd && (action == 'CREATE' || (action != 'CREATE' && validSvc.isText(m.Password.val)))) {

			// pwd required
			var pwd = validSvc.isText(m.Password.val) ? m.Password.val : '';
			m.Password = validSvc.setResult(!!pwd && pwd.length >= 8 && pwd.length <= 30, m.Password, '8 to 30 upper and lower case letters, numbers, and special characters');
			if(m.Password.fail == 'no') {
				// pwd confirm required, must match pwd
				var pwdConfirm = validSvc.isText(m.PwdConfirm.val) ? m.PwdConfirm.val : '';
				if(!!pwdConfirm) {
					m.PwdConfirm = validSvc.setResult(pwd == m.PwdConfirm.val, m.PwdConfirm, 'must match password');
				}
				else {
					m.PwdConfirm = validSvc.setResult(false, m.PwdConfirm, 'required');
				}
			}
		}
		else {
			m.Password.fail = '';
			m.PwdConfirm.fail = '';
		}

		// first / last name
		m.FirstName = validSvc.setResult(validSvc.isText(m.FirstName.val), m.FirstName, 'required');
		m.LastName = validSvc.setResult(validSvc.isText(m.LastName.val), m.LastName, 'required');

		return isValid(m);
	}

	function isValid(m) {
		return m.UserName.fail != 'yes' &&
			m.Password.fail != 'yes' &&
			m.PwdConfirm.fail != 'yes' &&
			m.FirstName.fail != 'yes' &&
			m.LastName.fail != 'yes';
	}

	return service;
}
 
userSectionRestrict.$inject = ['validSvc', 'utilSvc'];
angular
.module('espui.admin.user')
.factory('userSectionRestrict', userSectionRestrict);


/* @ngInject */
function userSectionRestrict(validSvc, utilSvc) {

	// service definition
	var service = {
		setProperties: setProperties,
		setType: setType,
		validate: validate,
		canHaveAffList: canHaveAffList,
		buildAffChecklist: buildAffChecklist,
		toggleAffChecklist: toggleAffChecklist,
		checkAffChecklistItem: checkAffChecklistItem,
		setAffRestrictions: setAffRestrictions,
		reset: reset
	};

	function resetModels(m) {
		m.CanAccessCP = false;
		m.CanAccessCPTPA = false;
		m.CanAccessSPLIT = false;
		m.CanAccessSPLITMATCH = false;
	}

	function reset(m) {
		m.RestrictType = 'NONE';
		resetModels(m);
		m.AFFList = [];
	}

	function setType(m, type) {
		// update the data key restriction depends on
		m.RestrictDependsOnKey = m.UserTypeDataKey;

		switch(type) {
			case 'NONE':
				reset(m);
				break;
			case 'MODEL':
				m.AFFList = [];
				break;
			case 'AFF':
				resetModels(m);
				break;
			default:
				throw new Error('userSectionRestrict: invalid RestrictType: ' + type);
		}
	}

	function userTypeSupported(m) {
		// user type changed (restrictions are not valid)
		if(m.RestrictDependsOnKey != m.UserTypeDataKey) {
			return false;
		}

		// only CE user for now
		return m.ValidUserType == 'CE' && m.CE.fail == 'no';
	}

	function canHaveAffList(m) {
		return userTypeSupported(m) && m.RestrictType == 'AFF';
	}

	function setProperties(m) {
		// CE user only
		if(!userTypeSupported(m)) {
			m.RestrictType = 'NONE';
		}

		setType(m, m.RestrictType);
	}

	function buildAffChecklist(m, affs, affChecklist) {
		// build checklist of affs, if checked the user has access
		// note: restricted affs empty means all affs are available
		// if restricted affs are set, then only those affs are available

		var findCeList = validSvc.isCE(m.CE.val) ? [m.CE.val] : [],
			groupMembers = Array.isArray(m.CEList) ? m.CEList : [],
			restrictedAffs = Array.isArray(m.AFFList) ? JSON.parse(JSON.stringify(m.AFFList)) : []; // de-ref
		m.AFFList = []; // reset model
			 
		// add group members, get affs
		findCeList = findCeList.concat(groupMembers);
		var checklist = utilSvc.aff.findCeList(affs, findCeList);
		if(checklist.length < 1) {
			return affChecklist;
		}

		// build restricted map
		var restrictedMap = {};
		restrictedAffs.forEach(function(aff) {
			restrictedMap[aff.CEID + '|' + aff.RXID] = true;
		});
		
		// loop checklist, set checked to true by default unless 
		var checkCount = 0,
			aff = {};
		for(var i = 0; i < checklist.length; i++) {
			aff = checklist[i];
			aff.checked = restrictedMap[aff.CEID + '|' + aff.RXID];
			if(aff.checked) {
				m.AFFList.push({CEID: aff.CEID, RXID: aff.RXID});
				checkCount += 1;
			}
		}

		affChecklist.checkCount = checkCount;
		affChecklist.Items = checklist;
		
		return affChecklist;
	}

	function toggleAffChecklist(m, affChecklist) {
		// toggle the checklist based on the check count value
		
		// toggle resets the model
		m.AFFList = [];

		// no checklist
		if(!Array.isArray(affChecklist.Items)) {
			affChecklist.checkCount = 0;
			return affChecklist;
		}

		// toggle the entire checklist
		var isChecked = affChecklist.Items.length != affChecklist.checkCount;

		// update checked state
		affChecklist.Items.forEach(function(aff) {
			aff.checked = isChecked;
			if(isChecked) {
				m.AFFList.push({CEID: aff.CEID, RXID: aff.RXID});
			}
		});
		affChecklist.checkCount = isChecked ? affChecklist.Items.length : 0;

		return affChecklist;
	}

	function checkAffChecklistItem(m, affChecklist, ceid, rxid) {

		// check resets model
		m.AFFList = [];
		
		// no checklist
		if(!Array.isArray(affChecklist.Items)) {
			affChecklist.checkCount = 0;
			return affChecklist;
		}

		// update checklist items
		var checkCount = 0;
		affChecklist.Items.forEach(function(aff) {
			if(aff.CEID == ceid && aff.RXID == rxid) {
				// found checked item, reverse checked state
				aff.checked = !aff.checked;
			}
			if(aff.checked) {
				checkCount++;
				// update model
				m.AFFList.push({CEID: aff.CEID, RXID: aff.RXID});
			}
		});
		affChecklist.checkCount = checkCount;
		return affChecklist;
	}

	function setAffRestrictions(m, checklist) {
		// set the model based on the checklist

		m.AFFList = [];

		// check model
		if(!canHaveAffList(m) || !Array.isArray(checklist) || checklist.length < 1) {
			return;
		}

		// loop the checklist
		if(checklist && checklist.Items) {
			checklist.Items.forEach(function(aff) {
				if(aff.checked) {
					m.AFFList.push({CEID: aff.CEID, RXID: aff.RXID});
				}
			});
		}
	}

	function validate(m) {
		var utValid = userTypeSupported(m); // settings must match user type
		switch(m.RestrictType) {
			case 'NONE':
				return true;
			case 'MODEL':
				return utValid && (m.CanAccessCP || m.CanAccessCPTPA ||
					m.CanAccessSPLIT || m.CanAccessSPLITMATCH);
			case 'AFF':
				return utValid && Array.isArray(m.AFFList) && m.AFFList.length > 0;
			default:
				throw new Error('userSectionRestrict.validate, unknown restrict type: ' + m.RestrictType);
		}
	}

	return service;
}
 
userSectionsUtil.$inject = ['validSvc', 'utilSvc'];
angular
.module('espui.admin.user')
.factory('userSectionsUtil', userSectionsUtil);


/* @ngInject */
function userSectionsUtil(validSvc, utilSvc) {

	// section title constants
	var LOGON_TITLE = 'Account',
		USER_TYPE_TITLE = 'User Type',
		RESTRICT_TITLE = 'Restrict Access',
		SUPER_AUTH_TITLE = 'User Management',
		OKTA_WORK_TITLE = 'Okta Workforce',
		OKTA_CUST_TITLE = 'Okta Customer';

	// service definition
	var service = {
		sectionVM: sectionVM,
		allSectionsVM: allSectionsVM,
		setTitles: setTitles,
		setVisible: setVisible,
		closeDependents: closeDependents,
	};


	/**
	 * 	VIEW MODELS
	 */

	function sectionVM(name, title, status, show) {
		// account section model
		return {
			name: name,
			title: validSvc.isText(title) ? title : '',
			status: validSvc.isText(status) ? status : 'closed',
			show: !!show
		};
	}

	function allSectionsVM() {
		// editing sections for open/close and validation status
		return {
			LOGON: sectionVM('LOGON'),
			USER_TYPE: sectionVM('USER_TYPE'),
			RESTRICT: sectionVM('RESTRICT'),
			SUPER_AUTH: sectionVM('SUPER_AUTH'),
			OKTA_WORK: sectionVM('OKTA_WORK'),
			OKTA_CUST: sectionVM('OKTA_CUST')
		};
	}

	/**
	 * 		RENDER VISIBILITY AND TITLES
	 */

	function affRestrictTitle(restrictType) {
		var result = RESTRICT_TITLE;
		switch(restrictType) {
			case 'MODEL':
				result += ' - Business Model';
				break;
			case 'AFF':
				result += ' - Affiliation';
				break;
		}
		return result;
	}

	function superAuthTitle(isAuth, supervisor) {
		var result = SUPER_AUTH_TITLE;
		if(isAuth) {
			result += ' - Authorizer';
		}
		else if(validSvc.isText(supervisor) && supervisor != 'NONE') {
			result += ' - Has Supervisor';
		}
		return result;
	}

	function oktaCustomerTitle(m) {
		var result = OKTA_CUST_TITLE;

        if(!!m.OktaPartnerEnabled) {
            result += ' - ' + m.OktaPartnerEnabled.Name + ' SSO';
        }
		else if(m.OktaCustomer == 'yes') {
            if(!validSvc.isText(m.OktaCustomerStatus)) {
                return result;
            }
            else if(m.OktaCustomerStatus == 'NONE') {
                result += ' - Not Found';
            }
            else {
                result += ' - ' + m.OktaCustomerStatus;
            }
		}
		else if(m.OktaMigration == 'yes') {
			result += ' - Migration In-Process';
		}
		return result;
	}

	function userTypeTitle(m) {
		var result = USER_TYPE_TITLE,
			ut = m.ValidUserType;

		// add user type
		if(!!ut) {
			result += ' - ' + ut;

			if(ut == 'VERITY' && m.IsDemo) {
				result += ' DEMO';
			}
			else if(ut == 'CE' && validSvc.isCE(m.CE.val)) {
				result += ': ' +  utilSvc.aff.ceNameByIdLookup(m.CE.val);
			}
			else if(ut == 'RX' && validSvc.isRX(m.RX.val)) {
				result += ': ' + utilSvc.aff.rxShortNameByIdLookup(m.RX.val);
			}
		}

		return result;
	}

	function setTitles(action, m, sections) {
		// render all section titles
		sections.LOGON.title = LOGON_TITLE;
		if(action == 'UPDATE') {
			sections.LOGON.title += ' - ' + m.ObjectState;
		}

		sections.USER_TYPE.title = userTypeTitle(m);

		sections.RESTRICT.title = affRestrictTitle(m.RestrictType);
		sections.SUPER_AUTH.title = superAuthTitle(m.IsAuthorizer == 'yes', m.MySupervisor);

		sections.OKTA_WORK.title = OKTA_WORK_TITLE;
		sections.OKTA_CUST.title = oktaCustomerTitle(m);

		return sections;
	}

	function ceRxUserValid(m) {
		// check both props on the model
		switch(m.ValidUserType) {
			case 'CE':
				return m.CE.fail == 'no';
			case 'RX':
			case 'RXROLLUP':
				return m.RX.fail == 'no';
			default:
				return false;
		}
	}

	function setVisible(action, m, logonSectionValid, sections) {
		// render all show/hide conditions
		var userType = m.ValidUserType;
		var isVerity = userType == 'VERITY' || userType == 'VERITYSA';
		var userValid = isVerity || ceRxUserValid(m);

		sections.LOGON.show = true;

		sections.USER_TYPE.show = action == 'UPDATE';
		if(action == 'CREATE' && (logonSectionValid || userValid)) {
			// show user type if logon is valid or this is a new Verity user (DEMO only)
			sections.USER_TYPE.show = true;
		}

		// dependent sections
		sections.RESTRICT.show = false;
		sections.SUPER_AUTH.show = false;
		sections.OKTA_WORK.show = false;
		sections.OKTA_CUST.show = false;

		// user type / entity must be valid to show dependents
		if(logonSectionValid && userValid) {
			sections.RESTRICT.show = userType == 'CE'; // CE only
			sections.SUPER_AUTH.show = true;
			sections.OKTA_WORK.show = !!m.Okta && isVerity;
			sections.OKTA_CUST.show = showOktaCust(m, userType, action);
		}
		
		return sections;
	}

    function showOktaCust(m, userType, action) {
        if((userType != 'CE' && userType != 'RX')) {
            return false;
        }
        // partner sso can show during create
        if((userType == 'CE' || userType == 'RX') && !!m.OktaPartnerEnabled) {
            return true;
        }
        // update case
        if(action == 'UPDATE') {
            return true;
        }
        return false;
    }

	function closeDependents(sections, dependents) {
		if(!Array.isArray(dependents)) {
			return;
		}
		var section = {};
		dependents.forEach(function(d) {
			section = sections[d];
			if(!!section && section.show && section.status == 'open') {
				section.status = 'closed';
			}
		});

		return sections;
	}

	return service;
}
 
userSectionUserType.$inject = ['validSvc'];angular
.module('espui.admin.user')
.factory('userSectionUserType', userSectionUserType);


/* @ngInject */
function userSectionUserType(validSvc) {

	var _userTypeOptions = {};

	// service definition
	var service = {
		initOptions: initOptions,
		buildNgDroplist: buildNgDroplist,
		setProperties: setProperties,
		setType: setType,
		setCeRx: setCeRx,
		setGroupMembers: setGroupMembers,
		validType: validType,
		validate: validate,
		isValid: isValid,
		reset: reset
	};

	function initOptions(ctx, action, m) {
		// driver Type determines which user options are available
		var options = {};
		
		if(action == 'CREATE') {
			if(ctx.canEditDemoUser) {
				options.VERITYDEMO = true;
			}
			options.CE = true;
			options.RX = true;
		}
		else {
			// UPDATE
			var uType = m.ValidUserType;

			if(uType == 'VERITY' && !!m.IsDemo) {
				options.VERITYDEMO = true;
			}
			else if(uType == 'VERITY' || uType == 'VERITYSA') {
				options.VERITYSA = true;
				options.VERITY = true;
			}
			else if(uType == 'RXROLLUP') {
				options.RXROLLUP = true;
			}
			else {
				options.CE = true;
				options.RX = true;
			}
		}

		// cache
		_userTypeOptions = options;
		return options;
	}

	function buildNgDroplist() {
		// driver Type determines which user's they can edit
		
		var droplist = [{label:'Choose a User Type', value:'NONE'}];

		if(_userTypeOptions.VERITYSA) {
			droplist.push({label:'Verity System Admin (VERITYSA)', value:'VERITYSA'});
		}
		if(_userTypeOptions.VERITY) {
			droplist.push({
				label: 'Verity (VERITY)',
				value:'VERITY'
			});
		}
		if(_userTypeOptions.VERITYDEMO) {
			droplist.push({
				label: 'Verity Demo User (VERITY)',
				value:'VERITY',
				isDemo: true
			});
		}
		if(_userTypeOptions.CE) {
			droplist.push({label:'Facility (CE)', value:'CE'});
		}
		if(_userTypeOptions.RX) {
			droplist.push({label:'Pharmacy (RX)', value:'RX'});
		}
		if(_userTypeOptions.RXROLLUP) {
			droplist.push({label:'Pharmacy (RXROLLUP)', value:'RXROLLUP'});
		}

		return droplist;
	}

	function validType(m) {
		var uType = m.UserType.val;

		var ok  = false;
		if(validSvc.isEntity(uType) && (!!_userTypeOptions[uType] || (!!_userTypeOptions.VERITYDEMO && m.IsDemo))) {
			ok = true;
		}
		m.UserType.val = ok ? uType : 'NONE';
		m.UserType.fail = ok ? 'no' : 'yes';
		m.UserType.msg = ok ? '' : 'required';

		// helper for other sections
		m.ValidUserType = ok ? m.UserType.val : '';

		return ok;
	}

	function setType(m, isDemo) {
		// set and validate user type

		// set demo if provided
		m.IsDemo = typeof(isDemo) !== 'undefined' && isDemo ? isDemo : m.IsDemo;		
		setProperties(m);

		return m;
	}

	function setProperties(m) {
		validType(m);
		var userType = m.ValidUserType;
		m.UserTypeDataKey = userType;

		// setup secondary properties
		switch(userType) {
			case 'VERITY':
			case 'VERITYSA':
				clearBoth(m);
				return true;
			case 'CE':
				m.CE.fail = validSvc.isCE(m.CE.val) ? 'no' : 'yes';
				if(m.CE.fail == 'yes') {
					clearCE(m);
				}
				clearRX(m);
				m.UserTypeDataKey += getDataKey(m.CE.val, m.CEList);
				return m.CE.fail == 'no';
			case 'RX':
			case 'RXROLLUP':
				m.RX.fail = validSvc.isRX(m.RX.val) ? 'no' : 'yes';
				if(m.RX.fail == 'yes') {
					clearRX(m);
				}
				clearCE(m);
				m.UserTypeDataKey += getDataKey(m.RX.val, m.RXList);
				return m.RX.fail == 'no';
			default:
				clearBoth(m);
				return false;
		}

		function clearCE(m) {
			m.CE = validSvc.newProp('NONE');
			m.CEList = [];
		}
		function clearRX(m) {
			m.RX = validSvc.newProp('NONE');
			m.RXList = [];
		}
		function clearBoth(m) {
			clearCE(m);
			clearRX(m);
		}
		function getDataKey(id, groupList) {
			// user type | entity id | group1 | group2 | ...
			groupList.sort();
			return '|' + id + '|' + groupList.join('|');
		}
	}

	function setCeRx(m, val) {
		var failState = 'yes';
		switch(m.ValidUserType) {
			case 'CE':
				m.CE.val = val;
				m.CE.fail = validSvc.isCE(m.CE.val) ? 'no' : 'yes';
				failState = m.CE.fail;
				m.CEList = [];
				break;
			case 'RX':
			case 'RXROLLUP':
				m.RX.val = val;
				m.RX.fail = validSvc.isRX(m.RX.val) ? 'no' : 'yes';
				failState = m.RX.fail;
				m.RXList = [];
				break;
			default:
				// only set entity if userType is CE or RX
		}
		setProperties(m);

		return failState;
	}

	function setGroupMembers(m, members) {
		switch(m.ValidUserType) {
			case 'CE':
				m.CEList = members;
				break;
			case 'RX':
			case 'RXROLLUP':
				m.RXList = members;
				break;
			default:
				// only set members if userType is CE or RX
		}
		setProperties(m);
	}

	function validate(m) {
		return setProperties(m);
	}

	function isValid(m) {
		return m.UserType.fail != 'yes' &&
			m.CE.fail != 'yes' &&
			m.RX.fail != 'yes';
	}

	function reset(m) {
		m.UserType = validSvc.newProp('NONE');
		setProperties(m);
	}

	return service;
}
 
/**
 *    USER TYPE NOTES
 *
 *    "user" is the account being edited
 *    "driver" is the person logged in driving the display
 *
 *    ACTIONS
 *    create: driver is creating a new user
 *    update: driver is editing another user (or in the special SA case their own account)
 *    profile: driver is editing themself
 *		
 *    REACT NOTES
 *    Angular uses change events to update both the model and components
 *    This revised code breaks this into model first, then display
 *    Section toggle loads visible selectors, it does not re-validate over and over again
 * 
 *   1. get data
 *   2. finalize context and model
 * 	 3. set up sections for show/hide, open/closed
 *   4. on section open load selectors
 */

userEditCtl.$inject = ['$window', '$rootScope', '$scope', '$state', '$timeout', 'userRepo', 'sessionRepo', 'userSectionUserType', 'userSectionLogon', 'userSectionClaims', 'userSectionsUtil', 'userSectionRestrict', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc'];
angular
.module('espui.admin.user')
.controller('UserEditCtl', userEditCtl);

/* @ngInject */
function userEditCtl($window, $rootScope, $scope, $state, $timeout, userRepo, sessionRepo, userSectionUserType, userSectionLogon, userSectionClaims, userSectionsUtil, userSectionRestrict, validSvc, errSvc, utilSvc, msgSvc) {


	/*jshint validthis: true */
	var vm = this,
		_pendingStatus = '',
		_pendingSave = null,
		_entityGroups = {type:'', items: []},
		_superAuth = {type:'', items: []},
		_mouseLeaveDelay = [],
		_debounceLogonInputs = false,
        _oktaPartners = [];

	// inherit
	vm.cssBtnStyle = utilSvc.css.btnStyle;
	vm.cssValidStyle = utilSvc.css.validStyle;
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addMultiselect(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.isWaiting = false;
	vm.action = '';
	vm.context = {};
	vm.init = true;

	// routing
	vm.paramsUserId = '';
	vm.exitRoute = '';

	// multiselect
	vm.multiToggle = multiToggle;
	vm.multiHover = multiHover;
	vm.multiClick = multiClick;
	vm.multiFilter = multiFilter;

	// account model and sections
	vm.model = {};
	vm.acctSubmit = acctSubmit;
	vm.acctSections = userSectionsUtil.allSectionsVM();
	vm.acctSectionToggle = acctSectionToggle;

	// LOGON: section
	vm.btnStatus = {};
	vm.sendActivate = sendActivate;
	vm.sendPwdReset = sendPwdReset;
	vm.impersonate = impersonate;
	vm.statusChange = statusChange;
	vm.changeLogonSection = changeLogonSection;
	
	// USER_TYPE: section
	vm.rxrollCanEdit = false;
	vm.userTypeDroplist = [];
	vm.cerxMulti = {};
	vm.groupMulti = {};
	vm.clickUserType = clickUserType;
	vm.toggleVHUB = toggleVHUB;
	vm.changeUserTypeSection = changeUserTypeSection;

	// RESTRICT: section
	vm.affChecklist = {};
	vm.affChecklistClick = affChecklistClick;
	vm.changeRestrict = changeRestrict;

	// SUPERAUTH: section
	vm.canEditIsAuthorizer = false;
	vm.canEditMySupervisor = false;
	vm.superMulti = {};
	vm.changeSuperAuth = changeSuperAuth;

	// OKTA_CUSTOMER: section
	vm.oktaCustomer = {};
	vm.getOktaCustomer = getOktaCustomer;
	vm.oktaRepair = oktaRepair;
    vm.changeOktaPartnerOptIn = changeOktaPartnerOptIn;
	
	// permissions
	vm.claimSections = userSectionClaims.sectionsVM();
	vm.claimSectionToggle = claimSectionToggle;
	vm.claimToggle = claimToggle;
	vm.filterClaimSections = filterClaimSections;
	vm.claimReview = {};
	vm.claimReviewToggle = claimReviewToggle;
	vm.claimReviewSave = claimReviewSave;

	// help link
	vm.helpLinkClick = helpLinkClick;


	/**
	 *    INIT
	 */

	init();

	function init() {
		var routeInfo = JSON.parse(JSON.stringify($state.current.routeInfo)); // de-ref
		
		// user check
		var isVerity = $rootScope.User.Type == 'VERITY' || $rootScope.User.Type == 'VERITYSA',
			IsAuthorizer = $rootScope.User.IsAuthorizer;

		// determine exit route
		var isReview = $state.params && $state.params.IsReview;
		if(isVerity) {
			// only Verity sees review links
			routeInfo.breadcrumb.msg = isReview ? 'Return to User Review' : 'Return to User Admin';
			vm.exitRoute = isReview ? 'admin.user.list-review' : 'admin.user.list';
		}
		else {
			vm.exitRoute = 'admin.user.list-customers';
		}

		// adjust breadcrumb and set title
		routeInfo.breadcrumb.route = vm.exitRoute;
		$scope.$emit('shared.main.setInfo', routeInfo);

		// setup for modes: CREATE / UPDATE / PROFILE
		switch($state.current.name) {
			case 'admin.user.create':
				// CREATE user check
				if(!isVerity) {
					msgSvc.ok('Cannot Create User', 'Only Verity Employees can create users');
					$state.go(vm.exitRoute);
					return;
				}				
				vm.action = 'CREATE';
				break;
			case 'admin.user.update':
				// UPDATE user check
				if(!isVerity && !IsAuthorizer) {
					msgSvc.ok('Cannot Update User', 'Only Verity Employees or Authorizers can update users');
					$state.go(vm.exitRoute);
					return;
				}
				vm.action = 'UPDATE';
				vm.paramsUserId = $state.params.Id;
				break;
			default:
				throw new Error('userEditCtl.Init, state unknown: ' + $state.current.name);
		}

		initSelectors();
		initContext();
	}

	/**
	 *   SELECTORS AND VIEW MODELS
	 */

	function initMultiselectVM() {
		// multi column view
		return {
			init: true,
			type: '',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: '',
			singleValue: false,
			vals: [],
			list: [],
			filtered: [],
			flt: {
				val:'',
				lbl:'',
				lbl2:''
			},
			displayName: {
				val: '',
				lbl: '',
				lbl2: ''
			},
			fail: ''
		};
	}

	function affRestrictChecklistVM() {
		return {
			init: true,
			CEID: undefined,
			RXID: undefined,
			RxModel: undefined,
			Status: undefined,
			checkCount: 0,
			Items: [],
			SortBy: ['CEID']
		};
	}

	function initUserTypeSelectors() {
		vm.userTypeDroplist = utilSvc.ng.droplistNONE();
		vm.cerxMulti = initMultiselectVM();
		vm.groupMulti = initMultiselectVM();
		vm.superMulti = initMultiselectVM();
	}

	function initRestrictSelectors() {
		vm.affChecklist = affRestrictChecklistVM();
	}

	function initSuperAuthSelectors() {
		vm.superMulti = initMultiselectVM();
	}

	function initOktaSelectors() {
        // tbd: get this from the api
        _oktaPartners = [
            {Id: 'CAREPATH', Name: 'CarePathRx', DefaultJwtClaim: 'email', CEID: ['CAREPATHSSOCE'], RXID:['CAREPATHSSORX']},
            {Id: 'KROGER', Name: 'Kroger Inc.', DefaultJwtClaim: 'email', CEID: ['KROGERSSOCE'], RXID:['KROGERSSORX']}
        ];
	}

	function initSelectors() {
		// Angular needs this for valid item arrays, it tries to render hidden arrays
		initUserTypeSelectors();
		initRestrictSelectors();
		initSuperAuthSelectors();
        initOktaSelectors();
	}


	/**
	 * 		CONTEXT
	 */

	function contextVM(r) {
		// pre-load context before getting the model
		r = r || {};

		var ctx = r;
		ctx.driver = r.driver || {};
		ctx.driverSA = r.driver.type == 'VERITYSA';

		// okta ENV and demo user
		var env = $rootScope.appConfig.env;
		ctx.env = env;
		ctx.canEditDemoUser = ctx.driverSA && (env == 'qa' || env == 'local' || env == 'dev');

        // okta testing
        ctx.canTestOkta = ctx.driver.isVerity && (env == 'qa' || env == 'local' || env == 'dev');

		// claims review
		ctx.canClaimReview = false; // see refreshContext() below, need the model

		return ctx;
	}

	function initContext() {
		userRepo.contextRefreshVM(vm.action).then(okCTX, errCTX);

		function okCTX(r) {
			vm.context = contextVM(r);
			if(vm.action == 'CREATE') {
				initDisplay(vm.context, vm.action, userRepo.modelVM());
				vm.init = false;
			}
			else {
				// get user by id
				getUser(vm.paramsUserId);
			}
		}

		function errCTX(r) {

			// exit if context error
			if(r !== null) {
				errSvc.warn('Cannot load setup data for User editing', 'userEditCtl.initContext.errCTX', r.status, utilSvc.http.safeResponse(r));
			}
			$state.go(vm.exitRoute);
		}
	}

	function refreshContext(ctx, action, m) {
		// assign rights and edit options, needs the model
		var ut = m.ValidUserType;

		// logon
		ctx.usePwd = usePwd(m, ctx);

		// super auth
		ctx.canEditIsAuthorizer = ctx.IsAuthorizer || ctx.isVerity;
		ctx.canEditMySupervisor = ctx.IsVeritySA || (ut == 'VERITY' && ctx.isVerity);

		// claims review
		ctx.canClaimReview = canClaimReviewCtx(ctx, action, m);

		return ctx;
	}

	function canClaimReviewCtx(ctx, action, m) {
		// can driver review this user's permissions

		if(action != 'UPDATE') {
			// no review on create
			return false;
		}

		var ut = m.ValidUserType,
			driverUserName = ctx.driver.UserName;
		switch(ctx.driver.type) {
			case 'VERITYSA':
				return true; // SA can review anyone
			case 'VERITY':
				// VERITY can review customers or their own users
				return ut == 'CE' || ut == 'RX' || driverUserName == m.MySupervisor;
			case 'CE':
			case 'RX':
				// CE or RX authorizer can review their own type
				return ctx.IsAuthorizer && ut == ctx.driver.type;
		}

		return false;
	}

	function refreshModel(ctx, action, m, runValidation) {
		m.editTitle = action == 'CREATE' ? 'New User' : (m.FirstName.val + ' ' + m.LastName.val);
		setPwdModel(ctx, m);
		if(!!runValidation) {
			validate_LOGON(ctx, action, m);
		}

		userSectionUserType.initOptions(ctx, action, m);
		userSectionUserType.setProperties(m);
		if(!!runValidation) {
			validate_USER_TYPE(m);
		}

		userSectionRestrict.setProperties(m);
		if(!!runValidation) {
			validate_RESTRICT(m);
		}

		refreshModel_SUPER_AUTH(m);
		if(!!runValidation) {
			validate_SUPER_AUTH(m);
		}

        refreshModel_OKTA_CUST(m);
		if(!!runValidation) {
			validate_OKTA_CUST(m);
		}

		return m;
	}

	function refreshModelAndValidate(ctx, action, m) {
		return refreshModel(ctx, action, m, true);
	}

	function refreshModel_SUPER_AUTH(m) {
		// dependents must be valid
		if(!userSectionLogon.isValid(m) || !userSectionUserType.isValid(m) || m.UserTypeDataKey != m.SuperAuthDependsOnKey) {
			m.MySupervisor = 'NONE';
			m.IsAuthorizer = 'no';
			m.AuthEntities = newValsProp([]);
			m.AuthAttested = false;
			return;
		}

		// reset auth entities if needed
		var isAuthorizer = m.IsAuthorizer == 'yes';
		m.AuthEntities = newValsProp(isAuthorizer ? m.AuthEntities.vals : [], isAuthorizer);
	}

    function oktaPartnerReset(m) {
        m.OktaPartnerEnabled = null;
        m.OktaPartner = '';
        m.OktaPartnerId = '';
        m.OktaPartnerJwtClaim = '';
        m.OktaPartnerUserId = validSvc.newProp('');
        return m;
    }

    function oktaPartnerFind(m) {
        // find an sso partner by primary entity or entity group membership
        var ut = m.ValidUserType;
        if(ut != 'CE' && ut != 'RX') {
            return null;
        }
        var result = null;

        var isCE = ut == 'CE',
            primaryId = isCE ? m.CE.val : m.RX.val,
            entityList = isCE ? m.CEList : m.RXList,
            idProp = isCE ? 'CEID' : 'RXID',
            groupProp = isCE ? 'CEGROUP' : 'RXGROUP',
            groupType = isCE ? 'CE' : 'PHARMACY';

        if(!validSvc.isText(primaryId)) {
            return null;
        }

        // aff list used for RxParent logic
        var rxParentId = '';
        if(!isCE) {
            var rxAffs = utilSvc.aff.findRx($rootScope.User.AffList, primaryId);
            rxParentId = rxAffs.length > 0 ? rxAffs[0].RxParent : '';
        }

        var affs = isCE ? [] : utilSvc.aff.findStatus($rootScope.User.AffList);
        var affList = isCE ? [] : utilSvc.aff.rxList(affs);

        for(var i = 0; i < _oktaPartners.length; i++) {
            var partner = _oktaPartners[i];

            // direct match: primary entity is in the partner's entity list
            if(Array.isArray(partner[idProp]) && partner[idProp].indexOf(primaryId) !== -1) {
                // add id source to result
                result = JSON.parse(JSON.stringify(partner)); // de-ref
                result.SourceName = isCE ? "Facility: " : "Pharmacy: ";
                result.SourceName += primaryId;
                return result;
            }

            // match on RxParent if possible
            if(!isCE && validSvc.isText(rxParentId) && Array.isArray(partner[idProp]) && partner[idProp].indexOf(rxParentId) !== -1) {
                // add id source to result
                result = JSON.parse(JSON.stringify(partner)); // de-ref
                result.SourceName = "Pharmacy In Rollup: ";
                result.SourceName += rxParentId;
                return result;
            }

            // group match: check if partner's group ids overlap with the user's entity group membership
            // tbd: add this after parter lookup from api is working
            /*
            if(!Array.isArray(partner[groupProp]) || partner[groupProp].length === 0) {
                continue;
            }
            if(_entityGroups.type != groupType || !Array.isArray(_entityGroups.items)) {
                continue;
            }

            var userEntities = Array.isArray(entityList) ? entityList.slice() : [];
            if(userEntities.indexOf(primaryId) < 0) {
                userEntities.push(primaryId);
            }

            for(var g = 0; g < _entityGroups.items.length; g++) {
                var group = _entityGroups.items[g];
                if(group.Type != groupType || group.ObjectState != 'ACTIVE') {
                    continue;
                }
                if(partner[groupProp].indexOf(group.Id) < 0 || !Array.isArray(group.Entities)) {
                    continue;
                }

                // check if any of the user's entities belong to this partner group
                for(var e = 0; e < userEntities.length; e++) {
                    if(group.Entities.indexOf(userEntities[e]) !== -1) {
                        // add id source to result
                        result = JSON.parse(JSON.stringify(partner)); // de-ref
                        result.SourceName = isCE ? "Facility Group: " : "Pharmacy Group: ";
                        result.SourceName += group.Name;
                        return result;
                    }
                }
            }
            */
        }

        return null;
    }

	function refreshModel_OKTA_CUST(m) {
		// CE or RX user could be an SSO Partner
		// OktaPartner states: '' = prompt user, 'yes' = opted in, 'no' = explicitly opted out

        var isCreate = vm.action == 'CREATE';

        // invalid pre-conditions
		if(!userSectionLogon.isValid(m) || !userSectionUserType.isValid(m)) {
            if(isCreate) {
			    m = oktaPartnerReset(m);
            }
            else if(m.OktaPartner == 'yes') {
                m.OktaPartnerError = 'User type changes caused Okta Partner to be unavailable for: ' + m.OktaPartnerId;
            }
			return;
		}

        // user doesn't have an sso option?
        var partner = oktaPartnerFind(m);
        if(!!!partner) {
            if(isCreate) {
			    m = oktaPartnerReset(m);
            }
            else if(m.OktaPartner == 'yes') {
                m.OktaPartnerError = 'User entity changes caused Okta Partner to be unavailable for: ' + m.OktaPartnerId;
            }
            return;
        }

        // partner is available
        m.OktaPartnerEnabled = partner;

        // exit if not in create mode, partner is already set and valid
        if(!isCreate) {
            if(m.OktaPartner == 'yes' && m.OktaPartnerId != partner.Id) {
                m.OktaPartnerError = 'Available OktaPartner has changed to ' + partner.Name + ' from ' + m.OktaPartnerId;
            }
            else {
                m.OktaPartnerError = '';
            }
            return;
        }

        // user opt-out (explicit choice)
        if(m.OktaPartner == 'no') {
            m.OktaPartnerId = '';
            m.OktaPartnerJwtClaim = '';
            m.OktaPartnerUserId = validSvc.newProp('');
            return;
        }

        // default if partner found or user has made explicit opt-in
        if(m.OktaPartner == '' || m.OktaPartner == 'yes') {
            m.OktaPartner = 'yes';
            m.OktaPartnerId = partner.Id;
            m.OktaPartnerJwtClaim = partner.DefaultJwtClaim;
            m.OktaPartnerUserId = validSvc.newProp(m.UserName.val);
        }
	}

	function initDisplay(ctx, action, data) {
		// finalize display properties after all context / data has been received

		// params
		if(!!!ctx || !!!data) {
			throw new Error('userEditCtl.initDisplay, missing context or model');
		}

		vm.model = data;
		var m = vm.model;

		// finalize ctx and model
		ctx = refreshContext(ctx, action, m);
		m = refreshModel(ctx, action, m);

		// CREATE: open logon
		if(action == 'CREATE') {
			toggle_LOGON();
		}

		// render
		renderSections(ctx, action, m);
	}

	function usePwd(m, ctx) {
		var use = false;

		// show: demo user
		if(ctx.canEditDemoUser && !!m.IsDemo) {
			use = true;
		}

		// on first switch to on, clear the password
		if(use && !ctx.usePwd) {
			vm.model.Password = validSvc.newProp('');
			vm.model.PwdConfirm = validSvc.newProp('');
		}
		else if(!use) {
			// use dummy password
			vm.model.Password = validSvc.newProp('Placeholder123!');
			vm.model.PwdConfirm = validSvc.newProp('Placeholder123!');
		}

		return use;
	}

	function setPwdModel(ctx, m) {
		if(!ctx.usePwd) {
			m.Password = validSvc.newProp('Placeholder123!');
			m.PwdConfirm = validSvc.newProp('Placeholder123!');
		}
	}


	/**
	 *    LOGON: status buttons
	 */

	function refreshStatusButtons(userStatus) {

		// refresh status button show/edit states based on User.ObjectState

		var result = {
			show: false,
			ACTIVE: false,
			SUSPENDED: false,
			DELETED: false
		};

		// no status buttons on CREATE
		if(vm.action == 'CREATE') {
			return result;
		}

		switch(userStatus) {

			case 'NEW':
				result.DELETED = true; // per Georgia open this up
				break;

			case 'LOCKED':
			case 'PWDRESET':
				result.ACTIVE = true;
				result.SUSPENDED = true;
				break;

			case 'ACTIVE':
				result.SUSPENDED = true;
				break;

			case 'SUSPENDED':
				result.ACTIVE = true;
				result.DELETED = true; // per Georgia open this up
				break;

			case 'DELETED':
				result.SUSPENDED = true; // per Georgia open this up
				break;

			default:
				throw new Error('userEditCtl.refreshStatusButtons, user status unknown: ' + userStatus);

		}

		// show section if at least one button is enabled
		result.show = result.ACTIVE || result.SUSPENDED || result.DELETED;

		return result;

	}

	function buildCeRxMulti(m) {
		// build a list of CE or RX options for the user
		// note: do no revalidate the model, just set the selector as model provided
		var multi = initMultiselectVM(),
			ut = m.ValidUserType;

		// CE / RX only
		if(ut != 'CE' && ut != 'RX') {
			return multi;
		}
		var isCE = ut == 'CE';

		multi.singleValue = true; // choose 1 CE or RX
		multi.type = ut;
		multi.label = isCE ? 'Facility' : 'Pharmacy';
		multi.titleNoOptions = isCE ? 'Choose a Facility' : 'Choose a Pharmacy';
		multi.displayName = {
			val: isCE ? 'CEID' : 'RXID',
			lbl: isCE ? 'Facility Name' : 'Pharmacy Name',
			lbl2: '' // no third column
		};

		// build multi-column list of CE's or RX's
		var affs = utilSvc.aff.findStatus($rootScope.User.AffList);
		var items = isCE ? utilSvc.aff.ceList(affs) : utilSvc.aff.rxList(affs);
		items.forEach(function(id) {
			multi.list.push({
				val: id,
				lbl: isCE ? utilSvc.aff.ceNameByIdLookup(id) : utilSvc.aff.rxShortNameByIdLookup(id),
				lbl2: '', // tbd...
				checked: false
			});
		});
		multi.filtered = multi.list;

		// setup display state
		vm.multiselectClick(multi, isCE ? m.CE.val : m.RX.val);
		vm.multiselectTitle(multi, true);
		multi.fail = multi.vals.length < 1 ? 'yes' : 'no';

		return multi;
	}

	function buildGroupMulti(m) {
		// check cache for entity groups, load as CE or RX options if possible
		var multi = initMultiselectVM(),
			ut = m.ValidUserType;

		// CE / RX only
		if(ut != 'CE' && ut != 'RX') {
			return multi;
		}

		// need valid CE or RX
		if((ut == 'CE' && m.CE.fail == 'yes') || (ut == 'RX' && m.RX.fail == 'yes')) {
			return multi;
		}

		// check cache
		var groupType = ut == 'CE' ? 'CE' : 'PHARMACY';
		if(_entityGroups.type != groupType || _entityGroups.items.length < 1) {
			getEntityGroupsData(groupType, 'groupMulti');
			return multi;
		}

		var isCE = ut == 'CE';
		var id = isCE ? m.CE.val : m.RX.val;

		multi.type = ut;
		multi.label = 'Group Members';
		multi.titleNoOptions = 'Choose a Group Member';
		multi.displayName = {
			val: isCE ? 'CEID' : 'RXID',
			lbl: isCE ? 'Facility Name' : 'Pharmacy Name',
			lbl2: '' // no third column
		};

		var savedVals = isCE ? m.CEList : m.RXList;
		multi.list = loadGroupsMultiFromCache(id, savedVals, _entityGroups.type, _entityGroups.items);				
		vm.multiselectReturnVisit(multi, '', savedVals);
		multi = useMultiALL(multi);
		multi.filtered = multi.list;

		// setup display state
		vm.multiselectTitle(multi, true);
		multi.fail = 'no'; // ALL or none is valid

		return multi;
	}

	function useMultiALL(multi) {
		// modify multiselect to handle ALL vals option

		var listLen = multi.list.length,
			valsLen = multi.vals.length;

		// no lists or no ALL
		if(valsLen < 1 || listLen < 1 || multi.list[0].val != 'ALL') {
			return multi;
		}

		// ALL is already selected
		if(valsLen == 1 && multi.vals[0] == 'ALL') {
			return multi;
		}

		// re-check all items
		if(valsLen == listLen - 1) {
			multi.vals = [];
			vm.multiselectClick(multi, 'ALL');
			return multi;
		}

		return multi;
	}

	function getEntityGroupsData(groupType, caller) {
		vm.isWaiting = true;
		msgSvc.wait(true);
		userRepo.getEntityGroups(groupType).then(okGroups, errGroups);

		function okGroups(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// cache lookup
			var items = Array.isArray(r) ? r : [];
			_entityGroups = {
				type: groupType,
				items: items
			};

			switch(caller) {
				case 'groupMulti':
					vm.groupMulti = buildGroupMulti(vm.model);
					break;
				case 'superMulti':
					vm.superMulti = buildSuperMulti(vm.context, vm.action, vm.model);
					break;
				default:
					throw new Error('userEditCtl.getEntityGroupsData, unknown caller: ' + caller);
			}
		}

		function errGroups(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			errSvc.warn('Cannot load entity group list', 'userEditCtl.loadLookupForMulti', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    CHANGE EVENTS
	 */

	function refreshAndValidateSections() {
		var m = vm.model,
			ctx = vm.context,
			action = vm.action;

		// refresh and validate all sections
		m = refreshModelAndValidate(ctx, action, m);
		ctx = refreshContext(ctx, action, m);
		renderSections(ctx, action, m);
	}

	function changeLogonSection() {
		if(vm.isWaiting || !modelUserTypeExists(vm.model)) {
			return;
		}

		// debounce typing, the username can affect the user type choices
		if(!_debounceLogonInputs) {
			_debounceLogonInputs = true;

			$timeout(function() {
				var m = vm.model;
				_debounceLogonInputs = false;
				validate_LOGON(vm.context, vm.action, m);

				// CREATE: update other sections if UserType is already valid
				if(vm.action == 'CREATE' && (userSectionLogon.isValid(m) || !!m.ValidUserType)) {
					changeUserTypeSection();
				}	
			}, 700);
		}
	}

	function modelUserTypeExists(m) {
		return !!m && !!m.UserType && m.UserType.val !== null;
	}

	function isVerity(uType) {
		return uType === 'VERITY' || uType === 'VERITYSA';
	}

	function clickUserType() {
		// user changed type in the droplist
		if(vm.isWaiting || !modelUserTypeExists(vm.model)) {
			return;
		}
		var m = vm.model,
			ut = m.UserType.val;

		// check for VERITY DEMO
		var isDemo = m.IsDemo;
		if(ut == 'VERITY') {
			vm.userTypeDroplist.forEach(function(item) {
				if(item.value == 'VERITY') {
					isDemo = item.isDemo;
				}
			});
		}
		var prevType = m.ValidUserType;
		m = userSectionUserType.setType(m, isDemo);

		// keep SuperAuth data key in sync when switching between VERITY and VERITYSA
        // note: this allows us to keep the supervisor during user type switching
		if(isVerity(prevType) && isVerity(m.ValidUserType)) {
			m.SuperAuthDependsOnKey = m.UserTypeDataKey;
		}

		vm.context = refreshContext(vm.context, vm.action, m);
		changeUserTypeSection();
	}

	function toggleVHUB() {
		if(vm.isWaiting || !vm.context.isVerity) {
			return;
		}
		vm.model.IsVhub = !vm.model.IsVhub;
	}

	function changeUserTypeSection() {
		refreshAndValidateSections();

		// update section display
		display_USER_TYPE();

		// close any dependent sections which are not in fail state
		vm.acctSections = userSectionsUtil.closeDependents(vm.acctSections, ['RESTRICT', 'SUPER_AUTH']);
	}


	/**
	 * 
	 *    RESTRICT - MODEL AND AFF CHECKLIST
	 */

	function changeRestrict() {
		// restriction display

		if(vm.isWaiting) {
			return;
		}

		// set model, rebuild aff checklist if needed
		var m = vm.model;
		userSectionRestrict.setProperties(m);		
		vm.affChecklist = buildRestrictAffList(m);

		validate_RESTRICT(m);
		renderTitles(vm.action, m);
	}

	function buildRestrictAffList(m) {
		var affChecklist = affRestrictChecklistVM();

		if(!userSectionRestrict.canHaveAffList(m)) {
			return affChecklist;
		}

		return userSectionRestrict.buildAffChecklist(m, $scope.User.AffList, affChecklist);
	}

	function affChecklistClick(ceid, rxid) {
		// set checked state of affs in checklist
		if(vm.isWaiting) {
			return;
		}

		var m = vm.model;

		if(ceid == 'ALL' && rxid == 'ALL') {
			// toggle all
			vm.affChecklist = userSectionRestrict.toggleAffChecklist(m, vm.affChecklist);
		}
		else {
			// toggle single item
			vm.affChecklist = userSectionRestrict.checkAffChecklistItem(m, vm.affChecklist, ceid, rxid);
		}
		validate_RESTRICT(m);
	}


	/**
	 *    GET USER
	 *    used by both 'update' route
	 */

	function getUser(id) {

		// valid param
		if(!validSvc.isText(id)) {
			throw new Error('userEditCtl.getUser, id is missing');
		}
		toggleWait(true);
		vm.oktaCustomer = {profile: {}};

		userRepo.getUser(id).then(ok, err);

		function ok(r) {
			toggleWait();
			initDisplay(vm.context, vm.action, r);
			getClaims(vm.paramsUserId);
			getOktaCustomer();
		}
		function err(r) {
			toggleWait();
			if(!!r) {
				throw new Error('userEditCtl.getUser.err, unknown error getting user id: ' + id);
			}
		}
	}

	/**
	 *    OKTA CUSTOMER / PARTNER SSO
	 */

	function getOktaCustomer() {
		// only for customers, do not run this for local dev
        // tbd: put this back! vm.context.env == 'local' ||
		if (!vm.context.isVerity || (vm.model.ValidUserType != 'CE' && vm.model.ValidUserType != 'RX')) {
			return;
		}

		// valid param
		if(!validSvc.isText(vm.model.UserName.val)) {
			throw new Error('userEditCtl.getOktaCustomer, model.UserName is missing');
		}

		vm.isWaiting = true;
		vm.oktaCustomer = {profile: {}};
		userRepo.getOktaCustomer(vm.model.UserName.val).then(ok, err);

		function ok(r) {
			vm.isWaiting = false;
			vm.oktaCustomer = r;
            vm.oktaCustomer.profile = r.profile || {};
            vm.oktaCustomer.status = validSvc.isText(r.id) ? r.status.toUpperCase() : 'NONE';
            vm.model.OktaCustomerStatus = vm.oktaCustomer.status;
			vm.oktaCustomer.loaded = true;
            
            // update Okta section title
            renderTitles(vm.action, vm.model);

            // REPAIR: forced a full password reset (user could not be repaired without re-loaded Okta account)
            if(_pendingStatus == 'REPAIR' && vm.model.ObjectState == 'PWDRESET') {
                _pendingStatus = '';
                sendPwdReset();
            }
		}
		function err(r) {
			vm.isWaiting = false;
			vm.oktaCustomer.status = 'NONE';
			vm.oktaCustomer.loaded = true;
			if(!!r) {
                errSvc.warn('Okta Customer Error', 'userEdit.getOktaCustomer', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function oktaRepair() {
		if(vm.isWaiting || (vm.model.OktaCustomer == 'no' && vm.model.OktaMigration == 'no')) {
			return;
		}

        // confirm repair action
        msgSvc.confirm({
            id: 'admin.user.create',
            title: 'Confirm Okta Repair',
            msg: 'Repair Okta account for: ' + vm.model.UserName.val + '? ' + 'Warning: this will attempt to fix common issues with the Okta account, this will reset the user password and MFA options.',
            buttons: [
                {text:'OK', result:'YES', cancel: false},
                {text:'CANCEL', result:'CANCEL', cancel: true}
            ]
        }).then(oktaRepairConfirm, oktaRepairConfirm);
	}

	function oktaRepairConfirm(r) {
		if(!!!r || r != 'YES') {
            return;
		}
		vm.isWaiting = true;
        _pendingStatus = '';

        // note: FORCE_REPAIR is available if we want to force any fixes before account replacement
		userRepo.oktaStatusChange(vm.model.Id, 'REPAIR').then(okOktaRepair, errOktaRepair);

		function okOktaRepair(r) {
			vm.isWaiting = false;
            if(vm.model.OktaCustomer == 'yes' && vm.model.OktaPartner != 'yes') {
                _pendingStatus = 'REPAIR'; // set to detect password reset after getUser (partner sso users do not use pwd reset, they don't have pwds)
            }
            else {
                msgSvc.ok('Okta Repair Complete', 'Refreshing user...');
            }
            getUser(vm.paramsUserId);
		}

		function errOktaRepair(r) {
			vm.isWaiting = false;
		}
	}
	
	/**
	 *    USER ACCOUNT SECTIONS
	 *    used to open/close sections of the user account
	 */

	function renderTitles(action, m) {
		// set titles for all sections
		vm.acctSections = userSectionsUtil.setTitles(action, m, vm.acctSections);
	}

	function renderSections(ctx, action, m) {
		vm.acctSections = userSectionsUtil.setVisible(action, m, userSectionLogon.isValid(m), vm.acctSections);
		vm.acctSections = userSectionsUtil.setTitles(action, m, vm.acctSections);

		// re-display open sections
		for(var prop in vm.acctSections) {
			if(vm.acctSections.hasOwnProperty(prop)) {
				redisplayOpenSection(prop);
			}
		}
	}

	function redisplayOpenSection(sectionName) {
		var section = vm.acctSections[sectionName];
		if(!!section && section.status != 'closed') {
			switch(sectionName) {
				case 'LOGON':
					display_LOGON();
					break;
				case 'USER_TYPE':
					display_USER_TYPE();
					break;
				case 'RESTRICT':
					display_RESTRICT();
					break;
				case 'SUPER_AUTH':
					display_SUPER_AUTH();
					break;
				case 'OKTA_CUST':
					display_OKTA_CUST();
					break;
			}
		}
	}

	function acctSectionToggle(sectionName) {
		// section can be open / closed / fail status
		// toggle account section
		if(vm.isWaiting) {
			return;
		}

		// no section means reset
		if(!validSvc.isText(sectionName)) {
			vm.acctSections = userSectionsUtil.allSectionsVM();
			return;
		}

		// unknown
		var section = vm.acctSections[sectionName];
		if(section === undefined) {
			throw new Error('userEdit.acctSectionToggle, unknown section: ' + sectionName);
		}

		switch(section.status) {
			case 'open':
			case 'closed':
				toggleSection(section);
				break;
			case 'fail':
				msgSvc.ok('Cannot Close', 'Please correct errors in this section.');
				break;
			default:
				throw new Error('userEdit.acctSectionToggle, unknown section status: ' + section.status);
		}
	}

	function toggleSection(section) {
		switch(section.name) {
			case 'LOGON':
				toggle_LOGON();
				break;
			case 'USER_TYPE':
				toggle_USER_TYPE();
				break;
			case 'RESTRICT':
				toggle_RESTRICT();
				break;
			case 'SUPER_AUTH':
				toggle_SUPER_AUTH();
				break;
			case 'OKTA_WORK':
				toggle_OKTA_WORK();
				break;
			case 'OKTA_CUST':
				toggle_OKTA_CUST();
				break;
			default:
				throw new Error('userEdit.acctSectionToggle.openSection, unknown section: ' + section.name);
		}
	}

	function toggle_LOGON() {
		var section = vm.acctSections.LOGON;
		section.init = false; // logon has no setup

		// close and exit
		if(section.status == 'open') {
			// logon has no tear down
			section.status = 'closed';
			return;
		}
		section.status = 'open';

		display_LOGON();
	}

	function display_LOGON() {
		var ctx = vm.context,
			action = vm.action,
			m = vm.model;
		vm.btnStatus = refreshStatusButtons(m.ObjectState);
		validate_LOGON(ctx, action, m);
	}

	function toggle_USER_TYPE() {
		var section = vm.acctSections.USER_TYPE;
		
		// close and exit
		if(section.status == 'open') {
			section.status = 'closed';
			return;
		}

		// open
		section.status = 'open';
		display_USER_TYPE();
	}

	function display_USER_TYPE() {
		var m = vm.model;
		vm.userTypeDroplist = userSectionUserType.buildNgDroplist();
		vm.cerxMulti = buildCeRxMulti(m);

		// don't rebuild an open multiselect
		if(!vm.groupMulti.show) {
			vm.groupMulti = buildGroupMulti(m);
		}

		validate_USER_TYPE(m);
	}

	function toggle_RESTRICT() {
		var section = vm.acctSections.RESTRICT;
		
		// close and exit
		if(section.status == 'open') {
			section.status = 'closed';
			return;
		}
		section.status = 'open';

		display_RESTRICT();
	}

	function display_RESTRICT() {
		var m = vm.model;
		vm.affChecklist = buildRestrictAffList(m);
		validate_RESTRICT(m);
	}

	function toggle_SUPER_AUTH(m) {
		var section = vm.acctSections.SUPER_AUTH;

		// close and exit
		if(section.status == 'open') {
			section.status = 'closed';
			return;
		}
		
		// open: re-build selectors off model
		section.status = 'open';
		display_SUPER_AUTH();
	}

	function display_SUPER_AUTH() {
		var m = vm.model;

		// don't rebuild an open multiselect
		if(!vm.superMulti.show) {
			vm.superMulti = buildSuperMulti(vm.context, vm.action, m);
		}
		validate_SUPER_AUTH(m);
		renderTitles(vm.action, m);
	}

	function toggle_OKTA_WORK() {
		var section = vm.acctSections.OKTA_WORK;
		// toggle, there is no setup
		section.status = section.status == 'open' ? 'closed' : 'open';
	}

	function toggle_OKTA_CUST() {
		var section = vm.acctSections.OKTA_CUST;
		// close and exit
		if(section.status == 'open') {
			section.status = 'closed';
			return;
		}
		
		// open: re-build selectors off model
		section.status = 'open';
		display_OKTA_CUST(vm.model);
    }

	function display_OKTA_CUST() {
		var m = vm.model;
		validate_OKTA_CUST(m);
		renderTitles(vm.action, m);
	}

    function changeOktaPartnerOptIn() {
        if(vm.isWaiting) {
            return;
        }
        var m = vm.model;
        refreshModel(vm.context, vm.action, m);
        display_OKTA_CUST(m);
    }

	function changeSuperAuth() {
		// change event for super auth
		if(vm.isWaiting) {
			return;
		}

		// update data key on super auth change
		var m = vm.model;
		m.SuperAuthDependsOnKey = m.UserTypeDataKey;
		
		// reset attestation
		if(m.AuthAttested && m.IsAuthorizer != 'yes') {
			m.AuthAttested = false;
		}

		refreshModel(vm.context, vm.action, m);
		display_SUPER_AUTH();
	}

	function buildSuperMulti(ctx, action, m) {
		// check cache for entity groups, load as CE or RX options if possible
		var multi = initMultiselectVM();

		// user logon and user type must me valid
		if(!validate_LOGON(ctx, action, m) || !validate_USER_TYPE(m)) {
			return multi;
		}
		var ut = m.ValidUserType;
		switch(ut) {
			case 'VERITY':
			case 'VERITYSA':
				// load supervisors
				multi.type = 'SUPER';
				multi.singleValue = true; // choose 1 supervisor
				multi.titleNoOptions = 'Choose a Supervisor';
				multi.label = "Employee's Supervisor";
				multi.displayName = {
					val: 'Email',
					lbl: 'Name',
					lbl2: 'User Type'
				};
				break;
			case 'CE':
			case 'RX':
				// load authorizers
				multi.type = ut == 'CE' ? 'AUTH-CE' : 'AUTH-RX';
				multi.singleValue = false; // choose multiple entities to authorize
				multi.titleNoOptions = ut == 'CE' ? 'Choose a Facility' : 'Choose a Pharmacy';
				multi.label = ut == 'CE' ? ' Facilities' : ' Pharmacies';
				multi.displayName = {
					val: ut == 'CE' ? 'CEID' : 'RXID',
					lbl: ut == 'CE' ? 'Facility Name' : 'Pharmacy Name',
					lbl2: '' // no third column
				};
				break;
			default:
				return multi;
		}

		// VERITY: supervisor
		// a list of other Verity users who can be the user's supervisor
		if(multi.type == 'SUPER') {
			// check cache
			if(_superAuth.type != multi.type || _superAuth.items.length < 1) {
				getUserListData('SUPER');
				return multi;
			}

			var userName = m.UserName.val,
				mySupervisor = m.MySupervisor,
				foundSupervisor = false,
				fname = '';
			_superAuth.items.forEach(function(usr){
				if(usr.UserName != userName && !usr.IsDemo) {
					if(!foundSupervisor) {
						foundSupervisor = usr.UserName == mySupervisor;
					}
					fname = validSvc.isText(usr.FirstName) && usr.FirstName.length > 20 ? usr.FirstName.substring(0) : usr.FirstName;
					multi.list.push({
						val: usr.UserName,
						lbl: fname + ' ' + usr.LastName,
						lbl2: usr.UserType,
						checked: usr.UserName == mySupervisor
					});
				}
			});
			multi.list = utilSvc.array.sortTextASC(multi.list, 'lbl');
			multi.list.unshift({val:'NONE', lbl:'No Supervisor', lbl2:'', checked: !foundSupervisor});
			multi.vals = foundSupervisor ? [mySupervisor] : [];
			multi.fail = 'no'; // optional
		}
		else {
			// user is not an authorizer
			if(m.IsAuthorizer == 'no') {
				return multi;
			}

			// CE / RX: authorizer
			// a list of other CEs or Pharmacies in this user's CEList or RXList
			// auth entities are stored in AuthEntities property
			var isCE = ut == 'CE';
			var groupType = isCE ? 'CE' : 'PHARMACY';
		
			// check cache
			if(_entityGroups.type != groupType || _entityGroups.items.length < 1) {
				getEntityGroupsData(groupType, 'superMulti');
				return multi;
			}

			var id = isCE ? m.CE.val : m.RX.val,
				savedGroupMembers = isCE ? m.CEList : m.RXList,
				savedAuthEntities = Array.isArray(m.AuthEntities.vals) ? m.AuthEntities.vals : [],
				checkCount = 0;

			// add user's own entity to the list
			multi.list.push({
				val: id,
				lbl: isCE ? utilSvc.aff.ceNameByIdLookup(id) : utilSvc.aff.rxShortNameByIdLookup(id),
				lbl2: '',
				checked: savedAuthEntities.indexOf(id) >= 0
			});
			if(multi.list[0].checked) {
				checkCount++;
				multi.vals = [id];
			}
			
			// add all possible group members to the list
			var groupList = loadGroupsMultiFromCache(id, savedGroupMembers, _entityGroups.type, _entityGroups.items);
			var idx = groupList.length > 0 && groupList[0].val == 'ALL' ? 1 : 0,
				mem = {};
			for(var i = idx; i < groupList.length; i++) {
				mem = groupList[i];
				// has to be a saved group member to be used as an auth entity
				if(mem.checked) {
					// checked if in the saved auth entities
					mem.checked = savedAuthEntities.indexOf(mem.val) > -1;
					if(mem.checked) {
						checkCount++;
						multi.vals.push(mem.val);
					}
					multi.list.push(mem);
				}
			}

			if(multi.list.length > 1) {
				multi.list.unshift({val:'ALL', lbl:'ALL', lbl2:'', checked: false});
				multi = useMultiALL(multi);
			}

			multi.fail = checkCount > 0 ? 'no' : 'yes'; // at least 1 required
		}
		
		multi.filtered = multi.list;

		// setup display state
		multiClickTitle(multi);

		return multi;
	}


	/**
	 * 		SECTION VALIDATION
	 */

	function setSectionValidationResult(section, isValid) {
		// set section status
		if(!isValid) {
			section.status = 'fail';
		}
		else if(section.status == 'fail') {
			// valid: reset to open
			section.status = 'open';
		}
	}

	function validate_LOGON(ctx, action, m) {
		var section = vm.acctSections.LOGON;

		var isValid = userSectionLogon.validate(ctx, action, m);
		setSectionValidationResult(section, isValid);
		
		return isValid;
	}

	function validate_USER_TYPE(m) {
		var section = vm.acctSections.USER_TYPE;

		var isValid = userSectionUserType.validate(m);
		setSectionValidationResult(section, isValid);

		return isValid;
	}

	function validate_RESTRICT(m) {
		var section = vm.acctSections.RESTRICT;

		var isValid = userSectionRestrict.validate(m);
		setSectionValidationResult(section, isValid);
		
		return isValid;
	}

	function validate_SUPER_AUTH(m) {
		var section = vm.acctSections.SUPER_AUTH;

		var isValid = false,
			ut = m.ValidUserType;

		switch(ut) {
			case 'VERITY':
			case 'VERITYSA':
				// supervisor is optional
				isValid = true;
				break;
			case 'CE':
			case 'RX':
			case 'ROLLUP':
				// auth entities required if user is an authorizer
				if(m.IsAuthorizer == 'yes') {
					m.AuthEntities.fail = m.AuthEntities.vals.length < 1 ? 'yes' : 'no';
					m.AuthEntities.msg = m.AuthEntities.fail == 'yes' ? 'required' : '';
				}
				isValid = m.IsAuthorizer == 'yes' ? m.AuthEntities.fail == 'no' : true;
				break;
			default:
				// unknown
				isValid = false;
		}
		setSectionValidationResult(section, isValid);
		
		return isValid;
	}

    function validate_OKTA_CUST(m) {
        // validate Okta Partner SSO fields if enabled
        var isValid = true,
            isCreate = vm.action == 'CREATE';

        // check for user changes which invalidated Okta Partner
        if(!isCreate && m.OktaPartner == 'yes' && validSvc.isText(m.OktaPartnerError)) {
            isValid = false;
        }
        else {
            m.OktaPartnerError = '';
        }

        if(isValid && m.OktaPartner == 'yes') {
            switch(m.OktaPartnerJwtClaim) {
                case 'email':
                    // if claim is 'email' (default) this it must match UserName property
                    m.OktaPartnerUserId.fail = m.OktaPartnerUserId.val != m.UserName.val ? 'yes' : 'no';
                    m.OktaPartnerUserId.msg = m.OktaPartnerUserId.fail == 'yes' ? 'must match Logon Email' : '';
                    break;
                default:
                    msgSvc.ok('User Edit Validate', 'Unknown OktaPartnerJwtClaim: ' + m.OktaPartnerJwtClaim);
                    return false;
            }
            isValid = m.OktaPartnerUserId.fail == 'no';
        }
        setSectionValidationResult(vm.acctSections.OKTA_CUST, isValid);
        return isValid;
    }

	function acctValid(ctx, action, m) {
		// sections are internally self validating
		m.ROOT = {}; // reset form 422 errors
		var validLogon = validate_LOGON(ctx, action, m);
		var validUserType = validate_USER_TYPE(m);
		var validRestrict = validate_RESTRICT(m);
		var validSuperAuth = validate_SUPER_AUTH(m);
        var validOktaCust = validate_OKTA_CUST(m);

		return validLogon && validUserType && validRestrict && validSuperAuth && validOktaCust;
	}

    function createConfirmText(m) {
        var result = 'IMPORTANT: ';
        if(m.IsDemo) {
            result += 'DEMO user is created as active with no email sent.';
        }
        else if(!!m.OktaPartnerEnabled && m.OktaPartner == 'no') {
            result += 'Okta Partner SSO is NOT enabled, user will be required to use a Verity login.';
        }
        else {
            result += 'clicking Ok will immediately send an activation email to this account.';
        }
        return result;
    }

	function acctSubmit() {

		if(vm.isWaiting || vm.model.ValidUserType == 'RXROLLUP') {
			return;
		}

		if(!acctValid(vm.context, vm.action, vm.model)) {
			msgSvc.ok('Cannot Save', 'All fields must be valid.');
			return;
		}
		vm.isWaiting = true;

		if(vm.action == 'CREATE') {
			var confirmTxt = createConfirmText(vm.model);
			msgSvc.confirm({
				id: 'admin.user.create',
				title: 'Confirm Create User',
				msg: 'Create user account: ' + vm.model.UserName.val + '? ' + confirmTxt,
				buttons: [
					{text:'OK', result:'YES', cancel: false},
					{text:'CANCEL', result:'CANCEL', cancel: true}
				]
			}).then(acctSubmitConfirm, acctSubmitConfirm);
		}
		else {
			// no confirm on update
			acctSubmitConfirm({result: 'YES'});
		}

	}

	function acctSubmitConfirm(r) {

		if(!!!r || r.result != 'YES') {
			vm.isWaiting = false;
			return;
		}

		// authorizer attestation
		var promptAttest = false;
		if(vm.context.IsAuthorizer) {
			if(vm.model.IsAuthorizer == 'yes' && !vm.model.AuthAttested) {
				promptAttest = true;
			}
		}
		if(promptAttest) {
			var userName = vm.model.FirstName.val + ' ' + vm.model.LastName.val;
			msgSvc.confirm({
				id: 'admin.user.create.attest',
				title: 'Authorizer Attestation',
				msg: 'I attest that ' + userName + ' is an authorized user for our organization and has the authority to manage our organization users',
				buttons: [
					{text:'OK', result:'YES', cancel: false},
					{text:'CANCEL', result:'CANCEL', cancel: true}
				]
			}).then(acctSubmitFinal, acctSubmitFinal);
		}
		else {
			acctSubmitFinal({result: 'YES'});
		}
	}

	function acctSubmitFinal(r) {
		if(!!!r || r.result != 'YES') {
			vm.isWaiting = false;
			return;
		}

		_pendingSave = vm.model;

		switch(vm.action) {
			case 'CREATE':
				msgSvc.wait(true, true);
				userRepo.create(vm.model).then(okAcctUpsert, errAcctUpsert);
				break;
			case 'UPDATE':
				msgSvc.wait(true, true);
				userRepo.update(vm.model).then(okAcctUpsert, errAcctUpsert);
				break;
			default:
				throw new Error('userEditCtl.acctSubmit, vm.action unknown: ' + vm.action);
		}
	}

	function okAcctUpsert(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		if(!!!r || !validSvc.isText(r.Id)) {
			throw new Error('userEditCtl.okAcctUpsert, api response missing id');
		}

		// UPDATE: exit
		if(vm.action == 'UPDATE') {
			msgSvc.ok(vm.model.FirstName.val + ' ' + vm.model.LastName.val, 'Saved');
			return;
		}

		// CREATE: Demo user (don't send them an email)
		if(vm.model.IsDemo) {
			msgSvc.ok('DEMO User Created');
			$state.go('admin.user.update', {Id: r.Id, breadcrumb:'admin.user.list'}, {reload: 'admin.user.update'});
			return;
		}
		
		// CREATE
		vm.model.Id = r.Id;
		sendActivate();
	}

	function errAcctUpsert(r) {
		vm.isWaiting = false;

		if(!!!r || r == null) {
			// already handled
			$state.go(vm.exitRoute);
		}
		else if(r.status == 409) {
			// conflict
			errSvc.info('Could not create or save, may already exist in the database. Verify and try again.', 'userEdit.errAcctUpsert', r.status);
		}
		else if (r.status == 422) {
			// validation
			vm.model = r.model;

			// add pwd confirmation to model
			vm.model.PwdConfirm = validSvc.newProp('');
			msgSvc.ok('Cannot Save', 'Check properties');
		}
		else {
			errSvc.error('Unknown add / update error response', 'userEdit.errAcctUpsert', r.status, utilSvc.http.safeResponse(r));
			$state.go(vm.exitRoute);
		}

	}


	/**
	 *    STATUS CHANGE
	 */

	function statusChange(newStatus) {

		// already waiting?
		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;

		_pendingStatus = newStatus;
		userRepo.statusChange(vm.model.Id, newStatus).then(okStatus, errStatus);

	}

	function okStatus(r) {
		vm.isWaiting = false;

		// id
		if(!!!r || !validSvc.isText(r.Id)) {
			throw new Error('userEditCtl.okStatus, missing id');
		}

        // Okta Customer to ACTIVE is a REPAIR
        if(_pendingStatus == 'ACTIVE' && vm.model.OktaCustomer == 'yes' && vm.model.OktaPartner != 'yes') {
            _pendingStatus = 'REPAIR'; // set to detect password reset after getUser (partner sso users do not use pwd reset, they don't have pwds)
        }
        else {
            _pendingStatus = '';
        }

		init();
	}

	function errStatus(r) {
		vm.isWaiting = false;
		_pendingStatus = '';

		if(!!!r || r == null) {
			// already handled
			$state.go(vm.exitRoute);
		}
		else if(r.status == 409) {
			// conflict
			errSvc.info('Could not update status. Verify and try again.', 'userEdit.errStatus', r.status, utilSvc.http.safeResponse(r));
		}
		else {
			errSvc.error('Unknown status change error', 'userEdit.errStatus', r.status, utilSvc.http.safeResponse(r));
			$state.go(vm.exitRoute);
		}

	}


	/**
	 *    ACTIVATE
	 */

	function sendActivate() {

		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;

        // partner sso check
        var m = vm.model;
        var activateKey = m.OktaPartner == 'yes' ? 'activatesso/' : 'activate/';
		var activateLink = buildAppUrl() + '/#/' + activateKey;

		userRepo.sendActivate(m.Id, activateLink).then(okActivate, errActivate);

	}

	function okActivate(r) {
		vm.isWaiting = false;

		if(vm.action == 'CREATE') {
			msgSvc.okAsync('User Created', 'User has been sent an activation email', 'admin.user.created').then(currentUserRefresh,currentUserRefresh);
		}
		else {
			msgSvc.ok('Activate Sent', 'User has been sent an activation email');
		}
	}

	function currentUserRefresh() {
		$state.go('admin.user.update', {Id: vm.model.Id, breadcrumb:'admin.user.list'}, {reload: 'admin.user.update'});
	}

	function errActivate(r) {
		vm.isWaiting = false;
		if(!!r) {
			errSvc.error('Unknown send activate error', 'userEdit.errActivate', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    PWD RESET
	 */

	function sendPwdReset() {

		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;

		var pwdResetLink = buildAppUrl() + '/#/pwdreset/';
		userRepo.sendPwdReset(vm.model.Id, pwdResetLink).then(okPwdReset, errPwdReset);

	}

	function okPwdReset(r) {
		vm.isWaiting = false;
		msgSvc.ok('Password Reset Sent', 'User has been sent a password reset email');
	}

	function errPwdReset(r) {
		vm.isWaiting = false;
		if(!!r) {
			errSvc.error('Unknown send pwd reset error', 'userEdit.errPwdReset', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    IMPERSONATE
	 */

	function impersonate() {
		if(vm.isWaiting) {
			return;
		}

		// emulation not allowed with multiple tabs open
		var tabs = sessionRepo.getLocalStoreKey('tabs');
		var tabList = !!tabs && Array.isArray(tabs.list) ? tabs.list : [];

		// refresh, find the tab id
		var foundMyTab = false,
			myTabId = $rootScope.tabId;
		for(var i = 0; i < tabList.length; i++) {
			if(tabList[i].id == myTabId) {
				foundMyTab = true;
				break;
			}
		}
		var otherTabCount = foundMyTab ? tabList.length - 1 : tabList.length;
		if(otherTabCount > 0) {
			msgSvc.ok('Cannot Emulate', 'Multiple tabs are open or have been opened in the last 5 minutes. Log out to reset your tab count if needed.');
			return;
		}

		msgSvc.confirm({
			id: 'admin.user.imp',
			title: 'Confirm User Emulate',
			msg: 'Emulate ' + vm.model.ValidUserType + ' user: ' + vm.model.UserName.val + '? IMPORTANT: your Verity account will be linked to all editing while emulating, be careful what you do under this account.',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(impConfirm, impConfirm);

	}

	function impConfirm(r) {
		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;
			userRepo.impersonate(vm.model.Id).then(okImp, errImp);
		}
	}

	function okImp(r) {
		vm.isWaiting = false;
		// user switched
		msgSvc.okAsync('Emulation Mode Started', 'Log Out to end the session. On next Sign In your account will be restored.', 'user.edit.imp.ok').then(navToHome, navToHome);
	}

	function errImp(r) {
		vm.isWaiting = false;

		if(!!r) {
			errSvc.error('Unknown impersonate error response', 'userEdit.errImp', r.status, utilSvc.http.safeResponse(r));
		}
	}

	function navToHome() {
		// user is done, leave this feature
		$state.go('home',{},{reload: 'home'});
	}


	/**
	 *    CLAIMS
	 */

	function getClaims(userId) {

		// valid param
		if(!validSvc.isText(userId)) {
			throw new Error('userEditCtl.getClaims, user id is missing');
		}

		vm.isWaiting = true;
		userRepo.getClaims(userId).then(okGetClaims, errGetClaims);

		function okGetClaims(r) {
			vm.isWaiting = false;
			vm.claimSections = userSectionClaims.sectionsVM(r, !!vm.claimSections.allOpen);

			vm.claimReview = {
				By: vm.model.ReviewBy,
				Date: vm.model.ReviewDate,
				Status: vm.model.ReviewStatus,
				flyout: false,
				reviewSections: []
			};

			vm.init = false;
		}
		function errGetClaims(r) {
			vm.isWaiting = false;
			if(!!r) {
				throw new Error('userEditCtl.getClaims, unknown error getting user id: ' + id);
			}
		}
	}

	function saveClaim() {
		// save 1 claim at a time

		vm.isWaiting = true;
		userRepo.saveClaim(vm.paramsUserId, _pendingSave.claimId, _pendingSave.allow).then(okSaveClaim, errSaveClaim);

		function okSaveClaim(r) {
			vm.isWaiting = false;
			setPendingClaim(_pendingSave, false);
		}
		function errSaveClaim(r) {
			vm.isWaiting = false;
			setPendingClaim(_pendingSave, true);
			if(!!r) {
				// claim error message
				if(r.status == 409 && validSvc.isText(r.msg)) {
					msgSvc.ok('Cannot Save', r.msg);
				}
				else {
					errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				}
			}
		}
		
		function setPendingClaim(saveClaim, isError) {
			// apply pending save to vm.claimSections.items
			if(!!saveClaim) {
				var claim = userSectionClaims.findClaimById(vm.claimSections.items, saveClaim.sectionId, saveClaim.claimId);
				if(!!!claim) {
					throw new Error('userEdit.setPendingClaim, permission not found: ' + saveClaim.claimId);
				}

				saveClaim.allow = !!isError ? !saveClaim.allow : saveClaim.allow; // reverse on error
				claim.Allow = saveClaim.allow;
				claim.status = saveClaim.allow ? 'on' : 'off';
			}
			_pendingSave = null;
		}
	}

	function claimToggle(sectionId, claimId) {
		// function which toggles the status of a claim and saves it
		if(vm.isWaiting || !validSvc.isText(sectionId) || !validSvc.isText(claimId)) {
			return;
		}

		// VHUB user cannot edit claims
		if(vm.context.driver.IsVhub) {
			msgSvc.ok('Cannot Edit', 'VHUB authorizers cannot change permissions.');
			return;
		}

		var claim = userSectionClaims.findClaimById(vm.claimSections.items, sectionId, claimId);
		if(!!!claim || claim.status == 'wait') {
			throw new Error('userEdit.claimSectionToggle, permission key not found: ' + claimId);
		}

		var changeTo = !!!claim.Allow;
		claim.status = 'wait';

		// setup for save
		vm.isWaiting = true;
		_pendingSave = {
			sectionId: sectionId,
			claimId: claimId,
			allow: changeTo
		};

		$timeout(function() {
			saveClaim(); // uses _pendingSave from above
		}, 800);
	}

	function claimSectionToggle(sectionId) {
		// function which toggles the open state of a claim section
		if(vm.isWaiting) {
			return;
		}

		vm.claimSections = userSectionClaims.toggleSection(vm.claimSections, sectionId);
	}

	function filterClaimSections() {
		if(vm.isWaiting) {
			return;
		}

		vm.claimSections = userSectionClaims.filterSections(vm.claimSections);
	}


	/**
	 * 	 CLAIM REVIEW
	 */

	function claimReviewClose(slideDelay) {
		vm.claimReview.flyout = false;

		// wait for slide out before clearing sections
		if(!!slideDelay) {
			$timeout(function() {
				vm.claimReview.reviewSections = [];
			}, 1000);
		}
		else {
			vm.claimReview.reviewSections = [];
		}
	}

	function claimReviewToggle() {
		// function which toggles the open state of the claim review flyout
		if(vm.isWaiting) {
			return;
		}

		if(vm.claimReview.flyout) {
			claimReviewClose(true);
			return;
		}

		// update review counts and flyout
		vm.claimReview.reviewSections = userSectionClaims.getReviewSections(vm.claimSections.items);
		vm.claimReview.flyout = true;
	}

	function claimReviewSave() {
		// function which saves the claim review
		if(vm.isWaiting) {
			return;
		}

		vm.isWaiting = true;
		userRepo.saveReviews([vm.paramsUserId]).then(okReview, errReview);

		function okReview(r) {
			vm.isWaiting = false;
			msgSvc.ok('Permission Review Saved', 'For: ' + vm.model.FirstName.val + ' ' + vm.model.LastName.val);
			claimReviewClose();
			getUser(vm.paramsUserId);
		}
		function errReview(r) {
			vm.isWaiting = false;
			if(!!r) {
				throw new Error('userEdit.claimReviewSave, unknown error saving permission review for user id: ' + vm.paramsUserId);
			}
		}

	}


	/**
	 *  VERITY SUPER_AUTH
	 */

	function getUserListData(type) {
		var queryForVerity = {
			Status: ['ACTIVE'],
			VERITY: type == 'SUPER',
			VERITYSA: type == 'SUPER',
			CE: [],
			CEchk: type == 'AUTH-CE',
			RX: [],
			RXchk: type == 'AUTH-RX'
		};

		toggleWait(true);
		userRepo.getList(queryForVerity).then(okList, errList);

		function okList(r) {
			toggleWait();

			_superAuth = {
				type: type,
				items: Array.isArray(r) ? r : []
			};

			if(_superAuth.items.length < 1) {
				msgSvc.ok('No Users Found', 'No users found for type: ' + type);
				return;
			}

			display_SUPER_AUTH();
		}

		function errList(r) {
			if(!!r) {
				msgSvc.ok('User List Error', 'Could not get the Verity user list: ' + r);
			}
		}
	}

	function helpLinkClick() {
		var title = 'User Permissions';
		switch(vm.model.ValidUserType) {
			case 'VERITY':
			case 'VERITYSA':
				vm.helpLink('admin-users-permissions', title, true);
				break;
			case 'CE':
				vm.helpLink('admin-users-permissions-facility', title, true);
				break;
			case 'RX':
				vm.helpLink('admin-users-permissions-rx', title, true);
				break;
			default:
				msgSvc.ok('Cannot Open Help', 'Choose a Valid User Type');
		}
	}


	/**
	 * 		MULTISELECT
	 */

	function multiClick(propName, val) {
		// user edit multiclick

		var multi = vm[propName];
		if(multi == null || !Array.isArray(multi.list)) {
			return;
		}

		// update multi vals
		if(multi.singleValue) {
			vm.multiselectReturnVisit(multi, '', [val]);
		}
		else {
			vm.multiselectClick(multi,val);
		}

		// adjust dependents
		var m = vm.model,
			failState = 'no';
		switch(propName) {
			case 'cerxMulti':
				failState = userSectionUserType.setCeRx(m, val);
				changeUserTypeSection();
				break;
			case 'groupMulti':
				userSectionUserType.setGroupMembers(m, vm.multiselectAllVals(multi));
				changeUserTypeSection();
				break;
			case 'superMulti':
				if(multi.type == 'SUPER') {
					m.MySupervisor = val;
				}
				else {
					m.AuthEntities.vals = vm.multiselectAllVals(multi);			
				}
				changeSuperAuth();
				break;
			default:
				throw new Error('userEditCtl.multiClick, unknown multiselect: ' + propName);
		}
			
		// update multi title
		multiClickTitle(multi);
		multi.fail = failState;
		if(multi.singleValue) {
			multi.show = false;
		}
	}

	function multiClickTitle(multi) {
		var useStandardTitle = true;
		switch(multi.type) {
			case 'SUPER':
				// supervisor needs both name and email
				if(multi.vals.length > 0) {
					var userName = multi.vals[0];
					multi.list.forEach(function(item){
						if(item.val == userName) {
							multi.title = userName + ' - ' + item.lbl;
							useStandardTitle = false;
						}
					});
				}
				break;
			default:
				// use standard title
				break;
		}

		if(useStandardTitle) {
			vm.multiselectTitle(multi, true);
		}
	}

	function multiToggle(evt, propName, elemId) {
		// show / hide 3 column multi

		var multi = vm[propName];
		multi.flt = {};

		// hide multi list
		if(multi.show) {
			multi.show = false;
			return;
		}

		// reset filtered
		multi.filtered = multi.list;

		// show with minimum width
		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(elemId + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(elemId);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multi.show = true;

		// set focus on CeMulti filter
		$timeout(function(){
			try {
				var inputElem = document.getElementById(elemId + 'Find');
				if(!!inputElem) {
					inputElem.focus();
					inputElem.setSelectionRange(0,9999);
				}
				inputElem = null;
			}
			catch(err) {
				// do nothing
			}
		},300);
	}

	function multiHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}

	function multiFilter(multiName) {
		var multi = null;
		switch(multiName) {
			case 'cerxMulti':
				multi = vm.cerxMulti;
				break;
			case 'groupMulti':
				multi = vm.groupMulti;
				break;
			case 'superMulti':
				multi = vm.superMulti;
				break;
			default:
				throw new Error('userEditCtl.multiFilter, unknown multiName: ' + multiName);
		}

		// list empty
		multi.list = Array.isArray(multi.list) ? multi.list : [];
		if(multi.list.length < 1) {
			multi.filtered = [];
			return;
		}

		// filter empty
		var flt = multi.flt || {};
		var fltVal = validSvc.isText(flt.val) ? flt.val.toLowerCase() : undefined,
			fltLbl = validSvc.isText(flt.lbl) ? flt.lbl.toLowerCase() : undefined,
			fltLbl2 = validSvc.isText(flt.lbl2) ? flt.lbl2.toLowerCase() : undefined;
		if(!validSvc.isText(fltVal + fltLbl + fltLbl2)) {
			multi.filtered = multi.list;
			return;
		}

		multi.filtered = [];
		multi.list.forEach(function(item){
			if(!!!fltVal || item.val.toLowerCase().indexOf(fltVal) > -1) {
				if(!!!fltLbl || item.lbl.toLowerCase().indexOf(fltLbl) > -1) {
					if(!!!fltLbl2 || item.lbl2.toLowerCase().indexOf(fltLbl2) > -1) {
						multi.filtered.push(item);
					}
				}
			}
		});
	}
	

	/**
	 *    HELPERS
	 */

	function toggleWait(isOn) {
		vm.isWaiting = !!isOn;
		msgSvc.wait(!!isOn, true);
	}

	function loadGroupsMultiFromCache(id, savedItems, grpType, allGroups) {
		// build CE or RX group member checklist

		var result = [];

		if(!validSvc.isEntity(id) || !Array.isArray(allGroups) || allGroups.length < 1) {
			return result;
		}

		// loop all groups in the system
		var checked = false,
			checkCount = 0,
			group = {};
		for(var i = 0; i < allGroups.length; i++) {
			group = allGroups[i];
			if(group.Type == grpType && group.ObjectState == 'ACTIVE' && Array.isArray(group.Entities) && group.Entities.indexOf(id) > -1) {

				var members = group.Entities,
					memId = '';

				// add group members
				for(var ii = 0; ii < members.length; ii++) {
					memId = members[ii];
					if(validSvc.isText(memId) && memId != id) {

						// loop existing checked items to see if its already checked
						checked = savedItems.indexOf(memId) > -1;
						if(checked) {
							checkCount++;
						}
						result.push({
							val: memId,
							lbl: ii < group.EntityNames.length ? group.EntityNames[ii] : memId,
							checked: checked
						});
					}
				}
				break;
			}
		}

		// add ALL check option
		if(result.length > 1) {
			result = utilSvc.array.sortTextASC(result, 'lbl');
			result.unshift({
				val: 'ALL',
				lbl: 'ALL',
				checked: result.length == checkCount
			});
		}

		return result;

	}

	function buildAppUrl() {

		// derive current port
		var port = $window.location.port;
		if(!!port && !isNaN(port)) {
			port = ':' + port.toString();
		}
		else {
			port = '';
		}

		return $window.location.protocol + '//' + $window.location.hostname + port;

	}

	function newValsProp(vals, validate) {
		vals = Array.isArray(vals) ? vals : [];
		var newProp = validSvc.newProp();
		newProp.vals = vals;
		if(!!validate) {
			newProp.fail = vals.length < 1 ? 'yes' : 'no';
			newProp.msg = newProp.fail == 'yes' ? 'required' : '';
		}
		return newProp;
	}

}
 
userListCtl.$inject = ['$window', '$state', '$rootScope', '$scope', '$timeout', '$filter', 'userRepo', 'sessionRepo', 'utilSvc', 'validSvc', 'msgSvc'];angular
.module('espui.admin.user')
.controller('UserListCtl', userListCtl);

/* @ngInject */
function userListCtl($window, $state, $rootScope, $scope, $timeout, $filter, userRepo, sessionRepo, utilSvc, validSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _pagingEventListener = null,
		_returnVisit = false,
		_getListRequest = {},
		_mouseLeaveDelay = {},
		_statusOptions = [],
		_entityGroups = {type:'', items:[]},
		_affs = [],
		_rollupParentMap = {},
		_pendingReview = {};

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addMultiselect(vm);
	utilSvc.ctl.addFlexTop(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.StatusOptions = [];

	// model
	vm.context = {};
	vm.display = {};

	// query
	vm.query = {};
	vm.dateRangeChange = dateRangeChange;
	vm.queryBadLogins = queryBadLogins;

	// methods
	vm.rowClick = rowClick;
	vm.create = create;
	vm.edit = edit;

	// tabs
	vm.activeTab = '';
	vm.tabChange = tabChange;

	// droplist
	vm.ceDroplist = [];
	vm.ceGroupDroplist = [];
	vm.rxDroplist = [];
	vm.rxGroupDroplist = [];
	
	// terms
	vm.termsTypeDroplist = [];
	vm.terms = {};
	vm.queryChangeTermsType = queryChangeTermsType;
	vm.queryChangeTermsId = queryChangeTermsId;
	vm.termsGet = termsGet;
	vm.termsSave = termsSave;

	// global grease: filters, table
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;

	// ip allow list
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;
	vm.ipAllowSave = ipAllowSave;
	vm.ipAllowRemove = ipAllowRemove;

	// user list search
	vm.action = '';
	vm.search = {};
	vm.CeMulti = {};
	vm.RxMulti = {};
	vm.RxRollupMulti = {};
	vm.SuperMulti = {};

	vm.multiClick = multiClick;
	vm.multiToggle = multiToggle;
	vm.multiHover = multiHover;

	// flex top
	vm.flex = {};
	vm.flexTopExpand = flexTopExpand;

	// list search methods
	vm.searchChange = searchChange;
	vm.searchChkProp = searchChkProp;
	vm.searchChkStatus = searchChkStatus;
	vm.searchChkUserType = searchChkUserType;
	vm.searchSubmit = searchSubmit;
	vm.getExcel = getExcel;
	vm.searchChkReviewStatus = searchChkReviewStatus;

	// user review
	vm.review = {};
	vm.reviewToggle = reviewToggle;
	vm.reviewToggleUser = reviewToggleUser;
	vm.reviewSave = reviewSave;


	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// catch route info
		var routeInfo = JSON.parse(JSON.stringify($state.current.routeInfo)); // de-ref

		vm.init = true;
		initContextAndQuery($state.current.name);

		// main title		
		if(vm.context.isVerity && vm.context.isUserReview) {
			routeInfo.title = 'User Review';
		}
		$scope.$emit('shared.main.setInfo', routeInfo);

		// customer authorizer route check
		if(vm.isCeDriver || vm.isRxDriver) {
			if(!isCustomerListRoute($state.current.name)) {
				$state.go('admin.user.list-customers',{}, {reload: true});
				return;
			}
		}

		// user list search is default
		vm.flex = vm.flexInit();
		vm.search = initSearchAndViewState(vm.context, $rootScope.User);
		tabChange('USERS');
		vm.init = false;
	}

	function isCustomerListRoute(stateName) {
		return stateName == 'admin.user.list-customers' || stateName == 'admin.user.list-customers-review';
	}

	function isReviewRoute(stateName) {
		return stateName == 'admin.user.list-review' || stateName == 'admin.user.list-customers-review';
	}

	function initContextAndQuery(stateName) {
		vm.context = userRepo.contextVM();

		var driver = vm.context.driver;
		// customer authorizer
		if(driver.IsAuthorizer) {
			vm.isCeDriver = driver.type == 'CE';
			vm.isRxDriver = driver.type == 'RX';
		}

		// is user review route
		vm.context.isUserReview = isReviewRoute(stateName);

		// add UI options
		vm.context.driver.canCreate = driver.isVerity;

		// build query with date range
		vm.query = {
			EntityId: validSvc.newProp($scope.User.CE),
			EntityType: 'CE',
			DateRangeMode: 'YESTERDAY',
			DateRangeValid: false,
			DateRangeList: utilSvc.widget.dateRangeList([]),
			StartDate: validSvc.newPropDateNull(),
			EndDate: validSvc.newPropDateNull()
		};

		_statusOptions = [
			'ALL',
			'NEW',
			'ACTIVE',
			'LOCKED',
			'PWDRESET',
			'SUSPENDED',
		];
		if(driver.type == 'VERITYSA' || driver.type == 'VERITY') {
			_statusOptions.push('DELETED');
		}
		vm.StatusOptions = buildStatusNgDroplist(_statusOptions);
	}

	function buildStatusNgDroplist(items) {
		// build droplist without re-sorting items
		var result = [];
		items.forEach(function(item){
			result.push({label: item, value: item == 'ALL' ? '' : item});
		});
		return result;
	}

	function getAffs() {
		if(_affs.length < 1) {
			var affs = JSON.parse(JSON.stringify($scope.User.AffList)); // de-ref

			// build map of ROLLUP parent names
			_rollupParentMap = {};
			var rxParents = utilSvc.aff.findRxType(affs, ['ROLLUP']);
			rxParents.forEach(function(p) {
				if(!!!_rollupParentMap[p.RXID]) {
					_rollupParentMap[p.RXID] = validSvc.isText(p.RxShortName) ? p.RxShortName : p.RXID;
				}
			});

			// constrain saved affs to non-ROLLUP affs
			_affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
		}
		return _affs;
	}

	function initSearchAndViewState(ctx, usr) {
        
		vm.flt = vm.initFilters({
			Exact: {
				ObjectState: ''
			},
            Config: {
                Dates: ['LastLogin'],
                DateFmt: 'M/d/yyyy h:mm:ss a'
            },
            SortBy: ['LastName']
        });

		// user review ignores viewstate
		var vs = ctx.isUserReview ? undefined : sessionRepo.get('vs-admin-user-list'),
			vss = {};
        if(!!vs) {
			vss = vs.search;
			_returnVisit = true;
            vm.flt = vm.resetFilters(vs.flt);
        }

		// setup default search or returning values
		var search = {
			Status: !!vs ? vss.Status : statusVM(_statusOptions, ['ACTIVE']),
			StatusTitle: '',
			VERITY: !!vs && vss.VERITY,
			VERITYSA: !!vs && vss.VERITYSA,
			CE: newChkPropWithVals(!!vs ? vss.CE.vals : ['ALL'], !!vs ? vss.CE.chk : false),
			RX: newChkPropWithVals(!!vs ? vss.RX.vals : ['ALL'], !!vs ? vss.RX.chk : false),
			RxTitle: '',
			RxRollup: newPropWithVals(!!vs ? vss.RxRollup.vals : ['ALL']),
			Okta: !!vs && vss.Okta,
			IsVhub: !!vs && vss.IsVhub,
			Demo: !!vs && vss.Demo,
			ReviewStatus: !!vs ? vss.ReviewStatus : reviewStatusVM(true),
			Supervisors: newChkPropWithVals(!!vs ? vss.Supervisors.vals : [], !!vs ? vss.Supervisors.chk : false),
			IsAuthorizer: !!vs && vss.IsAuthorizer,
		};
		
		// CE
		var affs = getAffs();
		var ceList = utilSvc.aff.ceList(affs);
		ceList.unshift('ALL');
		vm.CeMulti = {
			type: 'CE',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'All Options',
			titleNoOptions: 'Choose a Facility',
			titleAllOptions: 'All Facility Options',
			vals: ['ALL'],
			list: vm.multiselectBuild(ceList),
			flt: ''
		};
		if(!!vs) {
			vm.multiselectReturnVisit(vm.CeMulti, '', search.CE.vals);
		}
		search.CE.vals = vm.multiselectAllVals(vm.CeMulti);
		search.CE.fail = search.CE.vals.length < 1 ? 'yes' : 'no';
		vm.multiselectTitle(vm.CeMulti,true);

		// ROLLUP
		vm.RxRollupMulti = {
			type: 'ROLLUP',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'All Rollup Options',
			titleNoOptions: 'Choose a Rollup Pharmacy',
			titleAllOptions: 'All Rollup Options',
			vals: ['ALL'],
			list: buildRollupMultiChecklist(affs),
			flt: ''
		};

		// no parents
		var hasRxParents = vm.RxRollupMulti.list.length > 0;
		if(!hasRxParents) {
			search.RxRollup.vals = ['ALL']; // default
		}
		else if(!!vs && !isALL(search.RxRollup.vals)) {
			// apply search vals (which could be viewstate)
			vm.multiselectReturnVisit(vm.RxRollupMulti, '', search.RxRollup.vals);
		}
		search.RxRollup.vals = vm.multiselectAllVals(vm.RxRollupMulti);
		search.RxRollup.fail = search.RxRollup.vals.length < 1 ? 'yes' : 'no';
		rxRollupMultiTitle(vm.RxRollupMulti);
		
		// RX Multi depends on rollup choice after viewstate
		vm.RxMulti = {
			type: 'RX',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'Pharmacy',
			titleNoOptions: 'Choose a Pharmacy Option',
			titleAllOptions: 'All Pharmacy Options',
			vals: ['ALL'],
			list: [], // build below conditional on rollup choice
			flt: ''
		};

		// adjust RX search vals and multiselect list based on rollup
		var useRxViewState = !!vs && !isALL(search.RX.vals);
		adjustRxMulti(search, useRxViewState);

		// adjust search query for user review
		if(ctx.isUserReview) {
			_returnVisit = true;
			search = adjustSearchForUserReview(search, usr);
		}
		else if(!!!vs && (vm.isCeDriver || vm.isRxDriver)) {
			// adjust first search for customer authorizer
			_returnVisit = true;
			search = adjustSearchForAuthorizer(search, usr);
		}

		// VERITY SUPERVISORS
		vm.SuperMulti = {
			type: 'SUPER',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'Choose a Supervisor',
			titleNoOptions: 'Choose a Supervisor',
			vals: search.Supervisors.vals,
			list: [], // will be loaded later on first show
			flt: ''
		};
		vm.multiselectTitle(vm.SuperMulti,true);

		return search;
	}

	function buildRollupMultiChecklist(affs) {
		// get parents off affs instead of using ROLLUP type
		// default is ALL

		affs = Array.isArray(affs) ? affs : [];
		var result = [],
			parentList = utilSvc.aff.rxParentList(affs),
			shortName = '';

		// no parents
		if(parentList.length < 1) {
			return result;
		}

		// load list with short names
		parentList.forEach(function(rxid) {
			shortName = !!_rollupParentMap[rxid] ? _rollupParentMap[rxid] : rxid;
			result.push({
				val: rxid,
				lbl: shortName,
				checked: true
			});
		});

		// sort and add ALL option
		result = utilSvc.array.sortTextASC(result, 'lbl');
		result.unshift({
			val: 'ALL',
			lbl: 'ALL',
			checked: true
		});

		return result;
	}

	function adjustSearchForUserReview(search, usr) {
		switch(usr.Type) {
			case 'VERITY':
			case 'VERITYSA':
				search.VERITY = true;
				search.VERITYSA = usr.Type == 'VERITYSA';

				// add driver as supervisor to look for
				search.Supervisors = newChkPropWithVals([usr.UserName], true);
				break;
			case 'CE':
			case 'RX':
				search[usr.Type].chk = true;
				break;
			default:
				throw new Error('userListCtl.adjustSearchForUserReview, unknown user type: ' + usr.Type);
		}
		
		// find all user statuses except ALL and DELETED
		var userStatusForReview = [];
		_statusOptions.forEach(function(item) {
			if(item != 'ALL' && item != 'DELETED') {
				userStatusForReview.push(item);
			}
		});
		search.Status = statusVM(_statusOptions, userStatusForReview);

		// find only PENDING and OVERDUE review status
		var rs = reviewStatusVM(false);
		rs.PENDING = true;
		rs.OVERDUE = true;
		rs.vals = reviewStatusToArray(rs);
		search.ReviewStatus = rs;

		return search;
	}

	function adjustSearchForAuthorizer(search, usr) {
		search[usr.Type].chk = true;

		// find all user statuses except ALL and DELETED
		var userStatusForReview = [];
		_statusOptions.forEach(function(item) {
			if(item != 'ALL' && item != 'DELETED') {
				userStatusForReview.push(item);
			}
		});
		search.Status = statusVM(_statusOptions, userStatusForReview);

		return search;
	}

	function statusVM(options, defaults) {
		defaults = Array.isArray(defaults) ? defaults : ['ACTIVE'];
		var result = [],
			opt = '';
			
		for(var i = 0; i < options.length; i++) {
			opt = options[i];
			result.push({label: opt,value: defaults.indexOf(opt) > -1});
		}

		return result;
	}


	/**
	 *    VIEW MODELS
	 */

	function userListVM(dataItems, tooMany) {
		dataItems = Array.isArray(dataItems) ? dataItems : [];

		var driverName = $scope.User.UserName,
			item = {},
			result = [],
			ceList = [],
			rxList = [],
			useDisplayName = $rootScope.User.AdminPrefs.ListDisplay == 'USE_DISPLAY';

		for(var i = dataItems.length - 1; i >= 0; i--) {
			item = dataItems[i];

			// don't load driver's account in list
			if(driverName == item.UserName) {
				continue;
			}

			item.uniqueId = i.toString();
			item.Okta = (!!item.Okta || !!item.OktaCustomer) ? 'YES' : 'NO';

            item.OktaPartnerTxt = !!item.OktaPartner && validSvc.isText(item.OktaPartner.PartnerId) ? item.OktaPartner.PartnerId : '';
			item.Migrate = !!item.OktaMigration ? 'YES' : 'NO';
			item.IsVhub = !!item.IsVhub ? 'YES' : 'NO';
			item.Demo = !!item.IsDemo ? 'YES' : 'NO';
			item.LastLogin = utilSvc.dt.toBizTime(item.LastLogin);

			if(item.UserType == 'VERITYSA' || item.UserType == 'VERITY') {
				item.CEListTxt = 'ALL';
				item.RXListTxt = 'ALL';
				item.IsAuthorizer = ''; // no authorizer for Verity users
				item.expandCeList = true;
				item.expandRxList = true;
			}
			else {
				// CE User
				item.CENameList = Array.isArray(item.CENameList) ? item.CENameList : [];
				item.CEList = Array.isArray(item.CEList) ? item.CEList : [];
				ceList = useDisplayName ? item.CENameList : item.CEList;
				item.CETxt = ceList.length > 0 ? ceList[0] : '';
				item.CEListTxt = ceList.join(', ');
				item.expandCeList = ceList.length <= 3;
				item.expandCePrompt = ceList.length <= 3 ? '' : 'Show All (' + ceList.length + ')';

				// RX User
				item.RXNameList = Array.isArray(item.RXNameList) ? item.RXNameList : [];
				item.RXList = Array.isArray(item.RXList) ? item.RXList : [];
				rxList = useDisplayName ? item.RXNameList : item.RXList;
				item.RXTxt = rxList.length > 0 ? rxList[0] : '';
				item.RXListTxt = rxList.join(', ');
				item.expandRxList = rxList.length <= 3;
				item.expandRxPrompt = rxList.length <= 3 ? '' : 'Show All (' + rxList.length + ')';

				item.IsAuthorizer = !!item.IsAuthorizer ? 'YES' : 'NO';
			}

			result.push(item);
		}

		return {
			Items: [],
			DataItems: result,
			TooMany: tooMany
		};

	}

	function badLoginsVM(dataItems) {

		var isLoaded = true;
		if(!Array.isArray(dataItems)) {
			isLoaded = false;
			dataItems = [];
		}

		return {
			Items: dataItems,
			isLoaded: isLoaded,
			SortBy: ['-TotalAttempts'],
			Paging: {
				Page: 1,
				Size: dataItems.length,
				Total: 1
			},
			TooMany: dataItems.length > 20000
		};

	}

	function termsVM(data) {

		data = data || {};
		data.IpAllowList = Array.isArray(data.IpAllowList) ? data.IpAllowList : [];

		var pwdDays = 0;
		if(validSvc.isInteger(data.PwdDaysToExpire)) {
			pwdDays = parseInt(data.PwdDaysToExpire);
		}
		if (pwdDays===0){
			pwdDays= 90;
		}

		var pwdReuse = 0;
		if(validSvc.isInteger(data.ReusePwdLimit)) {
			pwdReuse = parseInt(data.ReusePwdLimit);
		}

		return {
			show: true,
			Terms: validSvc.newProp(validSvc.isText(data.Terms) ? data.Terms : ''),
			TermsChanged: 'no',
			ExpirePwd: pwdDays > 0 ? 'yes' : 'no',
			PwdDaysToExpire: validSvc.newProp(pwdDays),
			TwoFactorAuth: !!data.TwoFactorAuth ? 'yes' : 'no',
			UniquePwd: pwdReuse > 0 ? 'yes' : 'no',
			ReusePwdLimit: validSvc.newProp(pwdReuse),
			SuspendAfterDays: validSvc.newProp(validSvc.isInteger(data.SuspendAfterDays) ? data.SuspendAfterDays : 90),
			IpAllow: data.IpAllowList.length > 0 ? 'yes' : 'no',
			IpAllowList: data.IpAllowList
		};

	}


	/**
	 *    CHANGE EVENTS
	 */

	function tabChange(tabName) {

		if(vm.isWaiting) {
			return;
		}

		vm.activeTab = tabName;
		vm.popup = {};
		vm.terms = {};
		vm.display = badLoginsVM();

		switch(tabName) {
			case 'USERS':
				if(_returnVisit) {
					_returnVisit = false;
					searchSubmit();
				}
				break;
			case 'BADLOGINS':
				// fire date control for this tab
				$scope.$broadcast('widget.input.date.range.mode', {mode: vm.query.DateRangeMode, keepDates: true});
				break;
			case 'TERMS':
				initTerms();
				break;
			case 'TEST':
				if(!vm.context.isPROD) {
					$state.go('admin.user.list.testing', {}, {inherit: true});
				}
				break;
			default:
				throw new Error('userListCtl.tabChange, unknown tab name: ' + tabName);
		}

	}

	function dateRangeChange(dtMode, isValid) {
		vm.query.DateRangeMode = dtMode;
		vm.query.DateRangeValid = isValid;

		if(vm.activeTab == 'BADLOGINS') {
			vm.display = badLoginsVM();
		}
	}


	/**
	 *    ELBOW GREASE FILTERS AND CHANGE EVENTS
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			vm.tbl.DataItems = Array.isArray(vm.tbl.DataItems) ? vm.tbl.DataItems : [];
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					//console.log('filter change save viewstate');
					saveViewState(vm.flt, vm.search);
				}
			},1000);

		}, delayTime);

	}


	/**
	 *    GET LIST
	 */

	function searchChange() {
		if(!vm.init) {
			vm.action = '';
			vm.tbl = userListVM();
			vm.flt = vm.resetFilters(vm.flt);
			vm.flex = vm.flexInit();
			vm.context.isUserReview = false;
		}
	}

	function searchChkStatus(statusItem) {
		if(vm.isWaiting) {
			return;
		}

		var isALL = statusItem.label == 'ALL';
		var allValue = isALL && !!!statusItem.value;
		
		if(!isALL) {
			statusItem.value = !!!statusItem.value;
		}
		
		var checkSum = 0;
		vm.search.Status.forEach(function(stat){
			// on ALL click set all to the all value
			if(isALL) {
				stat.value = allValue;
			}
			else if(stat.label != 'ALL') {
				// add up all non-ALL checks
				checkSum = stat.value ? checkSum + 1 : checkSum;
			}
		});

		// toggle ALL checkmark if all others are all checked or one is not checked
		if(!isALL) {
			vm.search.Status[0].value = checkSum == vm.search.Status.length - 1;
		}

		// reset table filter if any status is changed
		vm.flt.Text.ObjectState = '';
	}

	function searchChkUserType(userType) {
		if(vm.isWaiting) {
			return;
		}

		var s = vm.search;
		switch(userType) {
			case 'VERITYSA':
			case 'VERITY':
				s[userType] = !!!s[userType];
				break;
			case 'CE':
			case 'RX':
				s[userType].chk = !!!s[userType].chk;
				break;
			default:
				throw new Error('userList.ChkUserType unknown type: ' + userType);
		}
	}

	function searchChkProp(propName) {
		if(vm.isWaiting) {
			return;
		}

		var s = vm.search;
		switch(propName) {
			case 'Okta':
			case 'Demo':
			case 'IsVhub':
			case 'IsAuthorizer':
				s[propName] = !!!s[propName];
				break;
			default:
				throw new Error('userList.ChkProp unknown: ' + propName);
		}
	}

	function searchChkReviewStatus(status) {
		if(vm.isWaiting) {
			return;
		}

		var rs = vm.search.ReviewStatus;
		switch(status) {
			case 'ALL':
				var toggleAll = !rs.ALL;
				rs = reviewStatusVM(toggleAll);
				break;
			case 'REVIEWED':
			case 'PENDING':
			case 'OVERDUE':
				rs[status] = !rs[status];
				rs.ALL = reviewStatusAllChecked(rs);
				rs.vals = reviewStatusToArray(rs);
				break;
			default:
				throw new Error('userList.ChkReviewStatus unknown status: ' + status);
		}
		vm.search.ReviewStatus = rs;
	}

	function reviewStatusVM(status) {
		var result = {
			ALL: status,
			REVIEWED: status,
			PENDING: status,
			OVERDUE: status,
		};
		result.vals = reviewStatusToArray(result);
		return result;
	}

	function reviewStatusToArray(revStatus) {
		var result = [];
		if(revStatus.ALL) {
			return []; // ALL means no review constraint
		}

		if(revStatus.REVIEWED) {
			result.push('REVIEWED');
		}
		if(revStatus.PENDING) {
			result.push('PENDING');
		}
		if(revStatus.OVERDUE) {
			result.push('OVERDUE');
		}

		return result;
	}

	function reviewStatusAllChecked(rs) {
		return rs.REVIEWED && rs.PENDING && rs.OVERDUE;
	}

	function isAuthorizer() {
		return vm.isCeDriver || vm.isRxDriver;
	}

	function searchValid(s) {
		var statVals = packStatus(s.Status); // remove ALL and list them out
		s.StatusTitle = s.Status[0].value ? 'ALL' : statVals.join(',  ');
		if(statVals.length < 1) {
			return 'Choose at least 1 status';
		}

		// at least 1 user type chosen
		if(!(s.VERITY || s.VERITYSA || s.CE.chk || s.RX.chk)) {
			return 'Choose at least 1 user type';
		}

		// authorizer doesn't validate CE/RX options
		if(isAuthorizer()) {
			return '';
		}

		// CE User options
		s.CE.vals = vm.multiselectAllVals(vm.CeMulti);
		s.CE.fail = s.CE.chk && s.CE.vals.length < 1 ? 'yes' : 'no';

		// RX User options will be Pharmacies or Rollup Members depending on RxRollup choice
		s.RX.vals = vm.multiselectAllVals(vm.RxMulti);
		s.RX.fail = s.RX.chk && s.RX.vals.length < 1 ? 'yes' : 'no';
		s.RxTitle = '';
		s.RxRollup.vals = vm.multiselectAllVals(vm.RxRollupMulti);
		s.RxRollup.fail = s.RX.chk && s.RxRollup.vals.length < 1 ? 'yes' : 'no';

		if(s.CE.fail == 'yes' || s.RX.fail == 'yes' || s.RxRollup.fail == 'yes') {
			return 'Check properties';
		}

		return ''; // no error == success
	}

	function searchSubmit() {
		if(vm.isWaiting) {
			return;
		}
		searchChange();

		// validate
		var errResult = searchValid(vm.search);
		if(!!errResult) {
			if(!vm.init) {
				msgSvc.ok('Cannot Search', errResult);
			}
			return;
		}

		var s = vm.search;

		// RX values can be from Pharmacies or Rollup Members
		var rxVals = [],
			rxSearchType = '';
		if(!isAuthorizer()) {
			s.RxTitle = '';
			if(s.RX.chk) {
				rxVals = vm.multiselectAllVals(vm.RxMulti);
				var rollALL = isALL(vm.RxRollupMulti.vals);
				rxSearchType = rollALL ? 'IND' : 'MEMBER';
				if(!rollALL) {
					s.RxTitle = vm.RxRollupMulti.title + ' - ';
				}
				s.RxTitle += vm.RxMulti.title;
			}
		}

		// save list request to use for Excel later
		_getListRequest = {
			Status: packStatus(s.Status),
			VERITY: !!s.VERITY,
			VERITYSA: !!s.VERITYSA,
			CE: isALL(vm.CeMulti.vals) ? [] : s.CE.vals,
			CEchk: s.CE.chk,
			RX: rxVals,
			RXchk: s.RX.chk,
			RxSearchType: rxSearchType,
			RxRollup: [], // always empty, members of a rollup are added to rxVals
			Okta: s.Okta,
			IsVhub: s.IsVhub,
			Demo: s.Demo,
			Supervisors: s.Supervisors.chk && s.Supervisors.vals.length > 0 ? s.Supervisors.vals : [],
			ReviewStatus: s.ReviewStatus.vals,
			IsAuthorizer: s.IsAuthorizer
		};

		vm.search.showColSupervisor = !!s.VERITY || !!s.VERITYSA;
		vm.search.showColAuthorizer = s.CE.chk || s.RX.chk;

		toggleWait(true);
		userRepo.getList(_getListRequest).then(okList, errList);

		function okList(r) {
			toggleWait();
			saveViewState(vm.flt,vm.search);

			vm.tbl = userListVM(r, false);
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});
			vm.flex = vm.flexCollapse(vm.flex, true);
			vm.flt.Ready = true;
			vm.action = 'LIST';
		}

		function errList(r) {
			toggleWait();
			if(!!r) {
				// unknown
				errSvc.warn('unknown error getting data', 'admin.user.searchSubmit', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}


	/**
	 *    BAD LOGINS
	 */

	function queryBadLogins() {

		if(vm.isWaiting) {
			return;
		}

		// validate dates
		if(!vm.query.DateRangeValid) {
			msgSvc.ok('Refresh', 'Check date properties');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		vm.display = badLoginsVM();

		// send api request
		userRepo.getBadLogins(vm.query).then(okBadLogins, errBadLogins);

		function okBadLogins(r) {

			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.display = badLoginsVM(r);

		}

		function errBadLogins(r) {

			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r === null) {
				// upstream is displaying a message already
			}
			else {
				// unknown
				errSvc.warn('unknown error getting data', 'admin.user.badLogins', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    TERMS GET
	 */

	function initTerms() {

		vm.terms = {};

		if(vm.ceDroplist.length < 1 && vm.rxDroplist.length < 1) {
			vm.isWaiting = true;
			userRepo.contextRefreshVM().then(okRefreshGroups, errRefreshGroups);
		}
		else {
			// user returning to this tab, refresh if query valid
			termsGet();
		}

	}

	function okRefreshGroups(r) {
		vm.isWaiting = false;

		var affs = utilSvc.aff.findStatus($scope.User.AffList);
		vm.ceDroplist = utilSvc.aff.ceDroplist(affs);
		vm.rxDroplist = utilSvc.aff.rxDroplist(affs);
		vm.ceGroupDroplist = [];
		vm.rxGroupDroplist = [];

		if(vm.context.driver.isVerity) {

			// verity user gets access to Verity, CE group, RX group
			vm.termsTypeDroplist = [
				{value: 'VERITY', label: 'Verity'},
				{value: 'CE', label: 'Facility'},
				{value: 'CEGROUP', label: 'Facility Group'},
				{value: 'RX', label: 'Pharmacy'},
				{value: 'RXGROUP', label: 'Pharmacy Group'}
			];
		}
		else {
			// CE admin only gets CE/RX
			vm.termsTypeDroplist = [
				{value: 'CE', label: 'Facility'},
				{value: 'RX', label: 'Pharmacy'}
			];
		}

		// autoselect entity id
		queryChangeTermsType();

	}

	function errRefreshGroups(r) {
		vm.isWaiting = false;

		if(!!r) {
			throw new Error('userListCtl.errRefreshGroups, unknown error: ' + utilSvc.http.safeResponse(r));
		}
	}

	function queryChangeTermsType() {

		// user changed the query, hide editing
		vm.terms = {};
		vm.popup = {};

		vm.ceGroupDroplist = utilSvc.ng.droplistNONE();
		vm.rxGroupDroplist = utilSvc.ng.droplistNONE();

		// auto select
		switch(vm.query.EntityType) {
			case 'CE':
				vm.query.EntityId = utilSvc.ng.droplistAutoselect(vm.ceDroplist, $scope.User.CE);
				break;
			case 'RX':
				vm.query.EntityId = utilSvc.ng.droplistAutoselect(vm.rxDroplist, $scope.User.RX);
				break;
			case 'CEGROUP':
			case 'RXGROUP':
				vm.query.EntityId = validSvc.newProp('NONE');
				loadEntityGroups(vm.query.EntityType == 'CEGROUP' ? 'CE' : 'PHARMACY');
				break;
			case 'VERITY':
				vm.query.EntityId = validSvc.newProp('VERITY');
				break;
			default:
				throw new Error('userListCtl.termsQueryChange, unknown entity type: ' + vm.query.EntityType);
		}

		vm.query.EntityId.fail = vm.query.EntityId.val == 'NONE' ? 'yes' : 'no';

	}

	function loadEntityGroups(groupType) {
		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true);

		// already loaded?
		if(_entityGroups.type == groupType) {
			okGetEntityGroups(_entityGroups.items);
		}
		else {
			// send api request
			userRepo.getEntityGroups(groupType).then(okGetEntityGroups, errGetEntityGroups);
		}

		function okGetEntityGroups(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// load in groups
			var items = Array.isArray(r) ? r : [],
				droplist = [];

			// cache for later
			_entityGroups = {
				type: groupType,
				items: items
			};

			// load items
			items.forEach(function(item) {
				droplist.push({label: item.Name, value: item.Id});
			});

			switch(groupType) {
				case 'CE':
					droplist.unshift({label:'Choose a Facility Group', value:'NONE'});
					vm.ceGroupDroplist = droplist;
					break;
				case 'PHARMACY':
					droplist.unshift({label:'Choose a Pharmacy Group', value:'NONE'});
					vm.rxGroupDroplist = droplist;
					break;
				default:
					throw new Error('userListCtl.loadEntityGroups, unknown group type: ' + groupType);
			}

			queryChangeTermsId();
		}

		function errGetEntityGroups(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('unknown error getting' + groupType, 'userListCtl.errGetEntityGroups', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function queryChangeTermsId() {
		vm.terms = {};
		vm.popup = {};

		vm.query.EntityId.fail = vm.query.EntityId.val == 'NONE' ? 'yes' : 'no';
	}

	function termsGet() {

		if(vm.isWaiting) {
			return;
		}

		vm.terms = {};
		vm.popup = {};

		// validate
		if(vm.query.EntityId.val == 'NONE') {
			vm.query.EntityId.fail = 'yes';
			msgSvc.ok('Policy Search', 'Check properties');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		// send api request
		userRepo.getPolicy(vm.query).then(okGetTerms, errGetTerms);

		function okGetTerms(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.terms = termsVM(r);
			vm.terms.EntityId = vm.query.EntityId.val;
			vm.terms.EntityType = vm.query.EntityType;
		}

		function errGetTerms(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('unknown error getting terms data', 'userListCtl.errGetTerms', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    TERMS SAVE
	 */

	function termsModelValid(model) {

		// terms - optional
		if(model.TermsChanged == 'yes') {
			var termsTxt = model.Terms.val;

			if(termsTxt.toString() === '') {
				// empty is ok
				model.Terms.val = '';
				model.Terms.fail = 'no';
			}
			else if(!validSvc.isText(termsTxt) || termsTxt.length < 100 || termsTxt.length > 100000) {
				model.Terms.fail = 'yes';
				model.Terms.msg = 'terms text must be between 100 to 100,000 characters';
			}
			else {

				// test html content, only <p> and <h> tags supported
				var regexTags = /(<)(?!\/)(?![ph])(?![PH])/;
				if(regexTags.test(model.Terms.val)) {
					model.Terms.fail = 'yes';
					model.Terms.msg = 'untrusted html tag, only "<p>" and "<h>" tags are supported';
				}
				else {
					model.Terms.fail = 'no';
				}
			}
		}
		else {
			model.Terms.fail = 'no';
		}

		// expire pwd - optional
		var pwdDays = parseInt(model.PwdDaysToExpire.val);
		if(!validSvc.isInteger(pwdDays) || pwdDays < 7 || pwdDays > 365) {
			model.PwdDaysToExpire.fail = 'yes';
			model.PwdDaysToExpire.msg = 'integer between 7 to 365';
		}
		else {
			model.PwdDaysToExpire.fail = 'no';
		}

		// reuse pwd - optional
		model.ReusePwdLimit.fail = 'no';
		if(model.UniquePwd == 'yes') {
			var pwdReuse = parseInt(model.ReusePwdLimit.val);
			if(!validSvc.isInteger(pwdReuse) || pwdReuse < 1 || pwdReuse > 12) {
				model.ReusePwdLimit.fail = 'yes';
				model.ReusePwdLimit.msg = 'integer between 1 to 12';
			}
		}
		else {
			model.ReusePwdLimit = validSvc.newProp(0);
		}

		// suspend - required
		var susDays = parseInt(model.SuspendAfterDays.val);
		if(!validSvc.isInteger(susDays) || susDays < 7 || susDays > 90) {
			model.SuspendAfterDays.fail = 'yes';
			model.SuspendAfterDays.msg = 'required, integer between 7 to 90';
		}
		else {
			model.SuspendAfterDays.fail = 'no';
		}


		// ip allow list, empty if UI prop set to no
		if(vm.terms.IpAllow == 'no') {
			vm.terms.IpAllowList = [];
		}

		return model.Terms.fail != 'yes' &&
			model.PwdDaysToExpire.fail != 'yes' &&
			model.SuspendAfterDays.fail != 'yes';
	}

	function termsSave() {

		if(vm.isWaiting) {
			return;
		}
		vm.popup = {};

		// validate query
		if(vm.query.EntityId.val == 'NONE') {
			vm.query.EntityId.fail = 'yes';
			msgSvc.ok('Policy Search', 'Check properties');
			return;
		}

		// validate model
		if(!termsModelValid(vm.terms)) {
			msgSvc.ok('Cannot Save', 'Check properties');
			return;
		}

		vm.isWaiting = true;

		// send api request
		userRepo.savePolicy(vm.query, vm.terms).then(okSaveTerms, errSaveTerms);

		function okSaveTerms(r) {
			vm.isWaiting = false;

			msgSvc.ok(vm.query.EntityType + ' Saved', 'Policy and Terms are saved');
			vm.terms = {};

		}

		function errSaveTerms(r) {
			vm.isWaiting = false;

			if(r === null) {
				// do nothing
			}
			else if(!!r && r.status === 422) {
				vm.terms = r.model;
				msgSvc.ok('Cannot Save', 'Server found invalid data');
			}
			else if(!!r) {
				errSvc.error('Unknown api response', 'userListCtl.errSaveTerms', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    IP ALLOW LIST POPUP
	 */

	function openPopup(evt, item) {

		if(vm.isWaiting) {
			return;
		}

		var id = '',
			action = 'ADD',
			Start = ['','','',''],
			End = ['','','',''];

		// edit item
		if(!!item) {
			id = item.Id;
			action = 'UPDATE';
			Start = item.Start.split('.');
			End = item.End.split('.');
		}

		vm.popup = {
			ready: false,
			action: action,
			title: action + ' IP Address Range',
			id: id,
			Start1: Start[0],
			Start2: Start[1],
			Start3: Start[2],
			Start4: Start[3],
			StartFail: '',
			StartMsg: '',
			End1: End[0],
			End2: End[1],
			End3: End[2],
			End4: End[3],
			EndFail: '',
			EndMsg: ''
		};

		// remember the clicked vertical location
		var elem = evt.target,
			offsetY = -100, // pop over
			hitRow = false;

		// loop html elements back to top of table
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
				break;
			}

			// add offset, get next element
			offsetY += elem.offsetTop;
			elem = elem.offsetParent;
		}
		elem = null;

		// move popup to clicked row
		var popup = document.getElementById('ipAllowListPopupContent');
		if(!!popup) {
			popup.style.top = offsetY.toString() + 'px';
		}

		// wait for digest before showing
		$timeout(function() {
			vm.popup.ready = true;
		}, 100);

	}

	function validIP(pop) {

		var startInt = -1,
			endInt = -1;

		pop.StartFail = 'no';
		pop.EndFail = 'no';

		for(var i = 1; i < 5; i++) {
			try {
				startInt = parseInt(pop['Start' + i.toString()]);
				endInt = parseInt(pop['End' + i.toString()]);
			}
			catch(err) {
				// do nothing
			}

			if(!validSvc.isNumber(startInt) || startInt < 0 || startInt > 255) {
				pop.StartFail = 'yes';
			}
			if(!validSvc.isNumber(endInt) || endInt < 0 || endInt > 255) {
				pop.EndFail = 'yes';
			}
		}

		return pop.StartFail == 'no' && pop.EndFail == 'no';

	}

	function ipAllowSave(item) {

		if(vm.isWaiting) {
			return;
		}

		if(!validIP(vm.popup)) {
			msgSvc.ok('Cannot Save', 'Check ip values');
			return;
		}

		var startTxt = parseInt(vm.popup.Start1).toString() + '.' + parseInt(vm.popup.Start2).toString() + '.' + parseInt(vm.popup.Start3).toString() + '.' + parseInt(vm.popup.Start4).toString(),
			endTxt = parseInt(vm.popup.End1).toString() + '.' + parseInt(vm.popup.End2).toString() + '.' + parseInt(vm.popup.End3).toString() + '.' + parseInt(vm.popup.End4).toString();

		if(vm.popup.action == 'ADD') {
			vm.terms.IpAllowList.push({
				Id: vm.terms.IpAllowList.length,
				Start: startTxt,
				End: endTxt,
				fail: '',
				msg: ''
			});
		}
		else {
			vm.terms.IpAllowList[vm.popup.id] = {
				Id: vm.popup.id,
				Start: startTxt,
				End: endTxt,
				fail: '',
				msg: ''
			};
		}

		vm.popup = {};

	}

	function ipAllowRemove(lineItem) {

		if(vm.isWaiting) {
			return;
		}

		vm.terms.IpAllowList.splice(parseInt(lineItem.Id), 1);

		// re-index list
		for(var i = 0; i < vm.terms.IpAllowList.length; i++) {
			vm.terms.IpAllowList[i].Id = i.toString();
		}

	}

	function closePopup(item) {
		vm.popup = {};
	}


	/**
	 * 	ROW CLICK
	 *  used for multiple expand or user edit
	 */

	function rowClick(evt, item) {
		// handle main list click event for links or toggle editing
		if(vm.isWaiting) {
			return;
		}

		// loop up to find td column parent
		var elem = evt.target;
		while (!!elem) {
			if(!!elem.className && elem.className.indexOf('user-item-multiple-ce') > -1) {
				item.expandCeList = true;
				break;
			}
			else if(!!elem.className && elem.className.indexOf('user-item-multiple-rx') > -1) {
				item.expandRxList = true;
				break;
			}
			else if (!!elem.nodeName && elem.nodeName.toUpperCase() == 'TD') {
				// row click = edit user
				elem = null;
				edit(item.Id);
				break;
			}
			elem = elem.parentNode;
		}
		elem = null;
	}


	/**
	 *    CREATE / EDIT
	 */

	function create() {
		$state.go('admin.user.create', {IsReview: vm.context.isUserReview}, {reload: 'admin.user.create'});
	}

	function edit(id) {
		$state.go('admin.user.update', {Id: id, IsReview: vm.context.isVerity && vm.context.isUserReview}, {reload: 'admin.user.update'});
	}


	/**
	 * 		USER REVIEW
	 */

	function reviewClose(slideDelay) {
		vm.review.flyout = false;

		// wait for slide out before clearing sections
		if(!!slideDelay) {
			$timeout(function() {
				vm.review.users = [];
			}, 1000);
		}
		else {
			vm.review.users = [];
		}
	}

	function reviewToggle() {
		// function which toggles the open state of the user review flyout
		if(vm.isWaiting) {
			return;
		}

		if(vm.review.flyout) {
			reviewClose(true);
			return;
		}

		// get users to review
		var users = getUsersToReview(vm.tbl.DataItems);
		if(users.length < 1) {
			msgSvc.ok('Cannot Review', 'There are no users of status PENDING or OVERDUE available for review.');
			return;
		}

		// update review counts and flyout
		vm.review.users = users;
		vm.review.allChecked = true;
		vm.review.flyout = true;
	}

	function reviewToggleUser(id) {
		// function which toggles the checked state of a user in the review list
		if(vm.isWaiting) {
			return;
		}

		// ALL toggle
		var isALL = id == 'ALL';
		if(isALL) {
			vm.review.allChecked = !vm.review.allChecked;
		}

		var users = vm.review.users,
			checkCount = 0;

		users.forEach(function(user) {
			if(isALL) {
				user.checked = vm.review.allChecked;
			}
			else if(user.id == id) {
				user.checked = !user.checked;
			}
			if(user.checked) {
				checkCount++;
			}
		});
		vm.review.allChecked = checkCount == users.length;
	}

	function getUsersToReview(dataItems) {
		dataItems = Array.isArray(dataItems) ? dataItems : [];
		var users = [];
		
		dataItems.forEach(function(item) {
			if(item.ReviewStatus === 'PENDING' || item.ReviewStatus === 'OVERDUE') {
				users.push({
					checked: true,
					id: item.Id,
					name: item.FirstName + ' ' + item.LastName + ' - ' + item.UserName
				});
			}
		});
		users = utilSvc.array.sortTextASC(users, 'name');

		return users;
	}

	function reviewSave() {
		// function which saves the claim review
		if(vm.isWaiting) {
			return;
		}

		// get checked users
		var users = vm.review.users,
			ids = [];
		users.forEach(function(user) {
			if(user.checked) {
				ids.push(user.id);
			}
		});
		if(ids.length < 1) {
			msgSvc.ok('Cannot Save', 'No users selected for review.');
			return;
		}

		_pendingReview = {
			users: ids
		};

		vm.isWaiting = true;
		userRepo.saveReviews(ids).then(okReview, errReview);

		function okReview(r) {
			vm.isWaiting = false;

			var msg = _pendingReview.users.length > 1 ? 'User Reviews ' : 'User Review ';
			_pendingReview = {};
			msgSvc.ok(msg + 'Saved');
			
			reviewClose();
			searchSubmit();
		}
		function errReview(r) {
			vm.isWaiting = false;
			if(!!r) {
				throw new Error('userEdit.reviewSave, unknown error for user review');
			}
		}

	}


	function getUserListData() {
		// called by the first SuperMulti show click
		var queryForVerity = {
			Status: ['ACTIVE'],
			VERITY: true,
			VERITYSA: true
		};
		vm.SuperMulti.list = [];

		toggleWait(true);
		userRepo.getList(queryForVerity).then(okList, errList);

		function okList(r) {
			toggleWait();

			r = Array.isArray(r) ? r : [];
			if(r.length < 1) {
				msgSvc.ok('No Users Found', 'Users needed for Supervisor search option');
				return;
			}

			// build multiselect list
			var multi = vm.SuperMulti,
				fname = '';
			r.forEach(function(usr) {
				fname = validSvc.isText(usr.FirstName) ? usr.FirstName.substring(0) : ' ';
				multi.list.push({
					val: usr.UserName,
					lbl: fname + ' ' + usr.LastName + ' (' + usr.UserName + ')',
					checked: false
				});
			});
			multi.list = utilSvc.array.sortTextASC(multi.list, 'lbl');

			vm.multiselectReturnVisit(multi, '', multi.vals);
			vm.multiselectTitle(multi,true);
			multi.fail = 'no'; // optional
			multi.show = true; // show multiselect
			vm.SuperMulti = multi;
		}

		function errList(r) {
			if(!!r) {
				msgSvc.ok('User List Error', 'Could not get the Verity user list: ' + r);
			}
		}
	}


	/**
	 * 		MULTISELECT
	 */

	function multiClick(propName, val) {
		if(vm.isWaiting) {
			return;
		}
		searchChange();

		var multi = vm[propName];
		vm.multiselectClick(multi, val);

		var searchProp = '';
		switch(propName) {
			case 'CeMulti':
				searchProp = 'CE';
				vm.search.CE.chk = true;
				vm.multiselectTitle(multi, true);
				break;
			case 'RxMulti':
				searchProp = 'RX';
				vm.search.RX.chk = true;
				rxMultiTitle(vm.RxMulti, isALL(vm.RxRollupMulti.vals));
				break;
			case 'RxRollupMulti':
				searchProp = 'RxRollup';
				vm.search.RX.chk = true; // RX Rollup uses RX chk
				rxRollupMultiTitle(multi);
				break;
			case 'SuperMulti':
				searchProp = 'Supervisors';
				vm.search.Supervisors.chk = multi.vals.length > 0;
				vm.multiselectTitle(multi, true);
				break;
			default:
				throw new Error('userList.multiClick, unknown propName: ' + propName);
		}

		var prop = vm.search[searchProp];
		prop.vals = vm.multiselectAllVals(multi);
		prop.fail = prop.vals.length < 1 ? 'yes' : 'no';

		// for RxMulti depends on RxRollup options
		if(searchProp == 'RxRollup') {
			adjustRxMulti(vm.search);
		}
	}

	function adjustRxMulti(search, useViewState) {
		// reset rollup members if Rollup parents change

		var oldSearchVals = ['ALL'],
			parentMulti = vm.RxRollupMulti,
			multi = vm.RxMulti;
		var parentFAIL = search.RxRollup.fail == 'yes',
			parentALL = isALL(parentMulti.vals),
			parentVals = vm.multiselectAllVals(parentMulti);

		// use viewstate search values?
		if(!!useViewState) {
			// parent is ok and RX has specific values
			if(!parentFAIL && search.RX.vals.length > 0 && !isALL(search.RX.vals)) {
				oldSearchVals = JSON.parse(JSON.stringify(search.RX.vals)); // de-ref
			}
		}

		// reset RX multi-select
		multi.list = [];
		multi.vals = ['ALL'];
		multi.title = parentALL ?  'All Pharmacy Options' : 'All Rollup Member Options';
		search.RX.vals = ['ALL'];
		search.RX.fail = 'no';

		// no parents or parent failed, reset back to ALL
		if(parentFAIL || parentVals.length < 1) {
			return;
		}

		// rebuild RX based on RxRollup values
		var affs = getAffs(),
			affParentId = '',
			noDupesMap = {},

		// use parent map lookup for speed
		rxRollupMap = {};
		parentVals.forEach(function(val) {
			rxRollupMap[val] = true;
		});

		affs.forEach(function(aff){
			affParentId = validSvc.isText(aff.RxParent) ? aff.RxParent : '';

			// parent is ALL or this aff has a chosen rollup parent
			if(parentALL || rxRollupMap[affParentId]) {
				if(!!!noDupesMap[aff.RXID]) {
					noDupesMap[aff.RXID] = true;
					multi.list.push({
						val: aff.RXID,
						lbl: validSvc.isText(aff.RxShortName) ? aff.RxShortName : aff.RXID,
						checked: true
					});
				}
			}
		});

		// sort and add ALL option
		multi.list = utilSvc.array.sortTextASC(multi.list, 'lbl');
		multi.list.unshift({
			val: 'ALL',
			lbl: 'ALL',
			checked: true
		});

		// apply search values
		vm.multiselectReturnVisit(vm.RxMulti, '', oldSearchVals);
		search.RX.vals = vm.multiselectAllVals(multi);
		search.RX.fail = search.RX.vals.length < 1 ? 'yes' : 'no';
		rxMultiTitle(vm.RxMulti, parentALL);
	}

	function rxRollupMultiTitle(multi) {
		var vals = Array.isArray(multi.vals) ? multi.vals : [];
		if(vals.length < 1) {
			multi.title = multi.titleNoOptions;
		}
		else if(isALL(vals)) {
			multi.title = multi.titleAllOptions;
		}
		else if (vals.length == 1) {
			multi.title = _rollupParentMap[vals[0]];
		}
		else {
			multi.title = vals.length + ' Rollup Options';
		}
	}

	function rxMultiTitle(multi, allRxRollups) {
		var vals = Array.isArray(multi.vals) ? multi.vals : [],
			titleSuffix = allRxRollups ? 'Pharmacy Options' : 'Rollup Member Options';

		if(vals.length < 1) {
			multi.title = multi.titleNoOptions;
		}
		else if(isALL(vals)) {
			multi.titleAllOptions = 'All ' + titleSuffix;
			multi.title = multi.titleAllOptions;
		}
		else if (vals.length == 1) {
			vm.multiselectTitle(multi, true);
		}
		else {
			// multiple options, show count
			multi.title = vals.length + ' ' + titleSuffix;
		}
	}

	function flexTopExpand() {
		// user opened search query, reset list display, show search expanded
		searchChange();
	}

    function multiToggle(evt, id) {
		var multi = vm[id];
		multiselectToggle(evt, multi, 'userList' + id);
	}

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if(vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		multiselect.flt = '';

		// don't bother with width if hiding
		if(multiselect.show) {
			multiselect.show = false;
			return;
		}

		// pre-load supervisors on first show
		if(id == 'userListSuperMulti' && multiselect.list.length < 1) {
			getUserListData();
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;

	}

	function multiHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}

	
	// 	EXCEL
	function getExcel() {
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}
		toggleWait(true);
		userRepo.getExcel(_getListRequest).then(okExcel, errExcel);

		function okExcel(binaryData) {
			toggleWait();

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename("Verity-User-List-Export.xlsx"));
			}
			catch(err) {
				throw(err);
			}
		}

		function errExcel(r) {
			toggleWait();

			if(r !== null) {
				errSvc.warn('Create Excel Error', 'userList.errExcel', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}
	
	//	HELPERS
	function saveViewState(flt, search) {
		var rxChecked = !!search.RX.chk;
		var rxVals = rxChecked && !isALL(vm.RxMulti.vals) ? search.RX.vals : ['ALL'],
			rxRollupVals = rxChecked && !isALL(vm.RxRollupMulti.vals) ? search.RxRollup.vals : ['ALL'];
		sessionRepo.set('vs-admin-user-list', {
			flt: flt,
			search: {
				Status: search.Status,
				VERITY: !!search.VERITY,
				VERITYSA: !!search.VERITYSA,
				CE: { vals:isALL(vm.CeMulti.vals) || !search.CE.chk ? ['ALL'] : search.CE.vals,chk:search.CE.chk},
				RX: {vals: rxVals, chk:rxChecked},
				RxRollup: {vals: rxRollupVals, chk:rxChecked},
				Okta: !!search.Okta,
				IsVhub: !!search.IsVhub,
				Demo: !!search.Demo,
				Supervisors: search.Supervisors,
				ReviewStatus: search.ReviewStatus,
				IsAuthorizer: search.IsAuthorizer,
			}
		});
	}

	function toggleWait(isOn) {
		vm.isWaiting = !!isOn;
		msgSvc.wait(!!isOn);
	}

	function newChkPropWithVals(vals, chk) {
		var p = validSvc.newProp();
		p.vals = vals;
		p.chk = !!chk;
		return p;
	}

	function newPropWithVals(vals) {
		var p = validSvc.newProp();
		p.vals = vals;
		return p;
	}

	function isALL(vals) {
		return vals.length == 1 && vals[0] == 'ALL';
	}

	function packStatus(stats) {
		var result = [],
			isALL = !!stats[0].value;
		for(var i = 1; i < stats.length; i++) {
			if(isALL || stats[i].value) {
				result.push(stats[i].label);
			}
		}
		return result;
	}
}
 
userPreferencesCtl.$inject = ['$scope', '$rootScope', '$state', 'prefsRepo', 'sessionRepo', 'errSvc', 'utilSvc', 'msgSvc'];
angular
.module('espui.admin.user')
.controller('UserPreferencesCtl', userPreferencesCtl);

/* @ngInject */
function userPreferencesCtl($scope, $rootScope, $state, prefsRepo, sessionRepo, errSvc, utilSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this;

	// properties
	vm.isWaiting = false;
	vm.action = '';
	vm.entityList = [];

	// models
	vm.context = {};
	vm.model = {};

	// methods
	vm.savePreferences = savePreferences;
	vm.exitPreferences = exitPreferences;

	/**
	 *    INIT
	 */

	init();

	function init() {

		// main UI
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		vm.model = {};
		vm.model.ListDisplay = $rootScope.User.AdminPrefs.ListDisplay == 'USE_DISPLAY' ? 'USE_DISPLAY' : 'USE_ID';
	}

	function exitPreferences() {

		if(vm.isWaiting) {
			return;
		}

		$state.go('home');
	}

    function savePreferences() {

		// already waiting?
		if(vm.isWaiting) {
			return;
		}

		vm.isWaiting = true;

        // update session and db
        $rootScope.User.AdminPrefs.ListDisplay = vm.model.ListDisplay;
        sessionRepo.set('User', $rootScope.User);

        prefsRepo.save('ADMIN', angular.toJson($rootScope.User.AdminPrefs)).then(okSavePreferences, errSavePreferences);
	}

	function okSavePreferences(r) {
		vm.isWaiting = false;
		msgSvc.okAsync('Prefences Saved', 'These changes will be saved to your account', 'preferences.saved').then(exitPreferences, exitPreferences);
	}

	function errSavePreferences(r) {
		vm.isWaiting = false;

		if(r == null) {
			return;
		}
		else if (!!r && r.status == 422) {
			// validation
			vm.model = r.model;
			msgSvc.ok('Cannot Save', 'Server reported invalid properties');
		}
		else {
			errSvc.error('Unknown preferences save response', 'userPreferences.errSavePreferences', r.status, utilSvc.http.safeResponse(r));
		}
	}
}

 
userProfileCtl.$inject = ['$scope', '$state', 'userRepo', 'sessionRepo', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc'];
angular
.module('espui.admin.user')
.controller('UserProfileCtl', userProfileCtl);

/* @ngInject */
function userProfileCtl($scope, $state, userRepo, sessionRepo, validSvc, errSvc, utilSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _pwd = '',
		_isOkta = false;

	// properties
	vm.isWaiting = false;
	vm.action = '';
	vm.showPwd = false;
	vm.entityList = [];

	// models
	vm.context = {};
	vm.model = {};

	// methods
	vm.unlock = unlock;
	vm.saveProfile = saveProfile;
	vm.exitProfile = exitProfile;

	/**
	 *    INIT
	 */

	init();

	function init() {

		// main UI
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		vm.model = {
			OldPassword: validSvc.newProp('')
		};

		// okta user doesn't re-validate password
		if(sessionRepo.getLocalStoreKey('verity_login')) {
			_isOkta = true;
			unlock();
		}
		else {
			vm.action = 'UNLOCK';
		}
	}

	function exitProfile() {

		if(vm.isWaiting) {
			return;
		}

		$state.go('home');
	}


	/**
	 *    UNLOCK PROFILE
	 */

	function unlock() {
		if(vm.isWaiting) {
			return;
		}

		// pwd ok
		if(!_isOkta) {
			if(!validSvc.isText(vm.model.OldPassword.val) || vm.model.OldPassword.val.length < 8) {
				vm.model.OldPassword.fail = 'yes';
				msgSvc.ok('Cannot Load Profile', 'Password is required to load profile.');
				return;
			}
			else {
				vm.model.OldPassword.fail = '';
			}
		}

		// refresh CE/RX affiliation lists (http request)
		userRepo.contextRefreshVM().then(okContext, errProfile);
	}

	function okContext(r) {
		vm.context = r;

		// get profile data
		if(_isOkta) {
			okProfile(userRepo.oktaProfileVM());
		}
		else {
			userRepo.getProfile(vm.model.OldPassword.val).then(okProfile, errProfile);
		}
	}

	function okProfile(r) {
		vm.isWaiting = false;

		// remember old password after get (its used to refresh page later)
		var oldPwd = vm.model.OldPassword.val;
		vm.model = r;
		vm.model.OldPassword = validSvc.newProp(oldPwd);

		vm.entityList = [];
		var affs = utilSvc.aff.findStatus($scope.User.AffList),
			dropNames = [];

		// setup list of entities user has access to
		switch(vm.model.UserType) {

			case 'VERITY':
			case 'VERITYSA':
				vm.entityList = ['All Facilities', 'All Pharmacies', 'All Rollup Pharmacies'];
				break;

			case 'CE':
				dropNames = utilSvc.aff.ceDroplist(affs);
				break;

			case 'RX':
				// remove rollups
				affs = utilSvc.aff.findRxType($scope.User.AffList, ['DISPENSING', 'CENTRALFILL']);
				dropNames = utilSvc.aff.rxDroplist(affs);
				break;

			case 'RXROLLUP':
				// get rollups
				affs = utilSvc.aff.findRxType($scope.User.AffList, ['ROLLUP']);
				dropNames = utilSvc.aff.rxDroplist(affs);
				break;

			default:
				throw new Error('userProfileCtl.okProfile, unknown user type: ' + userType);
		}

		// non-Verity, convert dropNames into a single entity list
		if(dropNames.length > 1) {
			for(var i = 1; i < dropNames.length; i++) {
				vm.entityList.push(dropNames[i].label);
			}
		}

		vm.action = 'PROFILE';
		vm.showPwd = false;

	}

	function errProfile(r) {
		vm.isWaiting = false;

		if(!!r) {
			if(r.status === 422) {
				// user pwd is wrong
				vm.model.OldPassword.fail = 'yes';
				msgSvc.ok('Cannot Load Profile', 'Password must be correct view account.');
			}
			else {
				errSvc.error('Unknown error, cannot load user profile data', 'userProfileCtl.unlock', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    SAVE PROFILE
	 */

	function saveProfileValid() {

		// first / last name
		vm.model.FirstName = validSvc.setResult(validSvc.isText(vm.model.FirstName.val), vm.model.FirstName, 'required');
		vm.model.LastName = validSvc.setResult(validSvc.isText(vm.model.LastName.val), vm.model.LastName, 'required');

		// password
		if(vm.showPwd) {

			// pwd - required
			vm.model.Password = validSvc.setResult(validSvc.isText(vm.model.Password.val), vm.model.Password, 'required');

			// confirm - must match pwd
			if(vm.model.Password.fail == 'no' && vm.model.Password.val != vm.model.PwdConfirm.val) {
				vm.model.Password.fail = 'yes';
				vm.model.Password.msg = 'Confirmation must match password';
			}
			else {
				vm.model.PwdConfirm = validSvc.newProp('');
			}

		}
		else {
			vm.model.Password = validSvc.newProp('');
			vm.model.PwdConfirm.fail = validSvc.newProp('');
		}

		// challenge Q/A
		vm.model.ChallengeQuestion = validText(vm.model.ChallengeQuestion, 4, 50);
		vm.model.ChallengeAnswer = validText(vm.model.ChallengeAnswer, 4, 50);
		if(vm.model.ChallengeAnswer.fail == 'yes') {
			vm.model.ChallengeAnswer.msg += '. Answer must be re-entered on every save (to help remember it for later).';
		}
		else {
			vm.model.ChallengeAnswer.val = vm.model.ChallengeAnswer.val.toLowerCase();
		}

		return vm.model.FirstName.fail != 'yes' &&
			vm.model.LastName.fail != 'yes' &&
			vm.model.Password.fail != 'yes' &&
			vm.model.PwdConfirm.fail != 'yes' &&
			vm.model.ChallengeQuestion.fail != 'yes' &&
			vm.model.ChallengeAnswer.fail != 'yes';

	}

	function saveProfile() {

		// already waiting?
		if(vm.isWaiting) {
			return;
		}

		// valid model
		if(!saveProfileValid()) {
			msgSvc.ok('Cannot Save', 'All fields must be valid.');
			return;
		}
		vm.isWaiting = true;

		userRepo.saveProfile(vm.model).then(okSaveProfile, errSaveProfile);

	}

	function okSaveProfile(r) {
		vm.isWaiting = false;
		msgSvc.okAsync('Account Saved', 'Remember your Security Question: ' + vm.model.ChallengeQuestion.val + '? Answer: ' + vm.model.ChallengeAnswer.val, 'profile.saved').then(exitProfile, exitProfile);
	}

	function errSaveProfile(r) {
		vm.isWaiting = false;

		if(r == null) {
			return;
		}
		else if (!!r && r.status == 422) {
			// validation
			vm.model = r.model;
			msgSvc.ok('Cannot Save', 'Server reported invalid properties');
		}
		else {
			errSvc.error('Unknown profile save response', 'userEdit.errSaveProfile', r.status, utilSvc.http.safeResponse(r));
		}

	}


	/**
	 *    HELPERS
	 */

	function validText(prop, min, max) {

		// required
		if(!validSvc.isText(prop.val)) {
			prop.fail = 'yes';
			prop.msg = 'required';
			return prop;
		}

		// min
		if(prop.val.length < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum ' + min.toString() + ' characters';
			return prop;
		}

		// max
		if(prop.val.length > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum ' + max.toString() + ' characters';
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;

	}

}

 
userTestCtl.$inject = ['$scope', '$state', 'userRepo', 'utilSvc', 'msgSvc'];angular
.module('espui.admin.user')
.controller('UserTestCtl', userTestCtl);

/* @ngInject */
function userTestCtl($scope, $state, userRepo, utilSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _pending = {};

	// properties
	vm.context = {};
	vm.isWaiting = false;
	vm.config = {};

	// methods
	vm.resetReviewers = resetReviewers;
	vm.toggleEnable = toggleEnable;
	vm.getConfig = getConfig;


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		vm.context = userRepo.contextVM();
	}

	/**
	 * 	EDIT CONFIG
	 * 	RESET all supervisors or authorizers
	 * 	action: 'RESET' | 'RESET'
	 * 
	 *  ENABLE toggles the config state (which stops email reminders and user status changes)
	 *  action: 'ON' | 'OFF'
	 */

	function resetReviewers(userType) {
		if(vm.isWaiting) {
			return;
		}
		userPrompt(userType, 'RESET');
	}

	function toggleEnable(userType, action) {
		if(vm.isWaiting) {
			return;
		}
		userPrompt(userType, action);
	}

	function userPrompt(userType, action) {
		var userTitle = userType == 'SUPER' ? 'Supervisor' : 'Authorizer';
		switch(action) {
			case 'RESET':
				_pending = {
					userType: userType,
					action: action,
					title: 'Clear ' + userTitle + 's',
					msg: 'Confirm remove all ' + userTitle + ' settings? This cannot be undone.'
				};
				break;
			case 'ON':
			case 'OFF':
				var enableTxt = action == 'ON' ? 'Enable' : 'Disable';
				_pending = {
					userType: userType,
					action: action,
					title: enableTxt + ' ' + userTitle + 's',
					msg: 'Confirm ' + enableTxt.toLowerCase() + ' ' + userTitle + ' notifications and status updates?'
				};
				break;
			default:
				throw new Error('userTest.confirm, unknown action: ' + action);
		}

		// show confirm dialog
		msgSvc.confirm({
			id: 'user.test.confirm',
			title: _pending.title,
			msg: _pending.msg,
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);
	}

	function userConfirm(r) {
		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;

			// reset reviewers
			if(_pending.action == 'RESET') {
				userRepo.editUserReviewConfig(_pending.userType, true, '').then(okAction, errAction);
			}
			else if(_pending.action == 'ON' || _pending.action == 'OFF') {
				var setEnabled = _pending.action == 'ON' ? 'true' : 'false';
				userRepo.editUserReviewConfig(_pending.userType, false, setEnabled).then(okAction, errAction);
			}
			else {
				throw new Error('userTest.userConfirm, unknown action: ' + _pending.action);
			}
		}

		function okAction() {
			vm.isWaiting = false;
			msgSvc.ok(_pending.title + ' Complete');

			// refresh
			getConfig(_pending.userType);
		}

		function errAction(r) {
			vm.isWaiting = false;
			if (!!r) {
				errSvc.warn(_pending.title + ' Error', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}


	/**
	 * 	GET CONFIG
	 * 	get current schedule for Verity Supervisors or Customer Authorizers
	 * 	action: 'SUPER' | 'AUTH'
	 */

	function configVM(data) {
		data = data || {};
		var config = !!data.Config ? data.Config : {};
		config.DueDate = data.DueDate;
		config.ready = true;

		return config;
	}

	function getConfig(action) {
		if(vm.isWaiting) {
			return;
		}

		switch(action) {
			case 'SUPER':
				_pending = {
					action: action,
					title: 'Get Supervisor Schedule'
				};
				break;
			case 'AUTH':
				_pending = {
					action: action,
					title: 'Get Authorizer Schedule'
				};
				break;
			default:
				throw new Error('userTest.getConfig, unknown action: ' + action);
		}

		vm.config = {};
		vm.isWaiting = true;

		userRepo.getUserReviewConfig(action).then(okGetSchedule, errGetSchedule);

		function okGetSchedule(r) {
			vm.isWaiting = false;
			r = r || {};
			vm.config = configVM(r);
			console.log('ENABLED: ' + vm.config.Enabled);
		}

		function errGetSchedule(r) {
			vm.isWaiting = false;
			if (!!r) {
				errSvc.warn(_pending.title + ' Error', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}
}
 
vendorRepo.$inject = ['$rootScope', '$q', 'apiService', 'apiErrors', 'appConst', 'errSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
.module('espui.admin.vendor')
.factory('vendorRepo', vendorRepo);


/* @ngInject */
function vendorRepo($rootScope, $q, apiService, apiErrors, appConst, errSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _currentPurl = '',
		_apiPaging = vmSvc.api.paging(),
		_modelPending = null,
		_listViewState = null;

	// service definition
	var service = {
		contextVM: contextVM,

		viewStateSave: viewStateSave,
		viewStateReload: viewStateReload,

		modelVM: modelVM,
		getList: getList,
		getTPAList: getTPAList,
		getDetail: getDetail,

		create: create,
		update: update

	};

	return service;


	/**
	 *    VIEW MODELS
	 */

	function modelVM(data) {

		data = data || {};
		data.CashCard = data.CashCard || {};

		var m = {
			Id: validSvc.newProp(validSvc.isText(data.Id) ? data.Id : ''),
			Name: validSvc.newProp(validSvc.isText(data.Name) ? data.Name : ''),
			Type: validSvc.newProp(validSvc.isText(data.Type) ? data.Type : 'WHOLESALER'),
			ObjectState: validSvc.isText(data.ObjectState) ? data.ObjectState : 'ACTIVE',
			SupportsEDI: validSvc.newProp(!!data.SupportsEDI ? 'yes' : 'no'),
			SenderId: validSvc.newProp(validSvc.isText(data.SenderId) ? data.SenderId : ''),
			ReceiverId: validSvc.newProp(validSvc.isText(data.ReceiverId) ? data.ReceiverId : ''),
			ShortPONames: !!data.ShortPONames ? 'yes' : 'no',
			CSOSSplit: !!data.CSOSSplit ? 'yes' : 'no',
			ProxyVendor: validSvc.newProp(validSvc.isText(data.ProxyVendor) ? data.ProxyVendor : ''),
			CSOSReceiverId: validSvc.newProp(validSvc.isText(data.CSOSReceiverId) ? data.CSOSReceiverId : ''),
			CashCardInterval: validSvc.isInteger(data.CashCard.IncrementalExtractInterval) ? data.CashCard.IncrementalExtractInterval : 15, // default is 15
			CashCardBINs: [],
			ExcludedVINs: [],
			CashCardMaxLevel: validSvc.isInteger(data.CashCard.MaxBenefitLevel) ? data.CashCard.MaxBenefitLevel : 10, // default is 10
			CreditReplenish: !!data.CreditReplenish ? 'yes' : 'no',
			CreditReplenishId: validSvc.newProp(validSvc.isText(data.CreditReplenishId) ? data.CreditReplenishId : ''),
			// security
			EncryptionPublicKey: validSvc.newProp(validSvc.isText(data.KeyStr) ? data.KeyStr : ''),
			Pharmacies: Array.isArray(data.Pharmacies) ? data.Pharmacies : []
		};

		// create array of validate bins
		var bins = Array.isArray(data.CashCard.BIN) ? data.CashCard.BIN : [];
		for(var i = 0; i < bins.length; i++) {
			m.CashCardBINs.push(validSvc.newProp(bins[i]));
		}

		var vins = Array.isArray(data.ExcludedVINs) ? data.ExcludedVINs : [];
		for(var j = 0; j < vins.length; j++) {
			m.ExcludedVINs.push(validSvc.newProp(vins[j]));
		}

		return m;
	}


	/**
	 *    LIST FILTERS
	 *    list view saves filter state in repo
	 */

	function viewStateSave(viewState) {

		// save viewstate properties by value
		_listViewState = angular.toJson(viewState);

	}

	function viewStateReload() {

		// exit if nothing saved for this list type or query has changed
		if(!!!_listViewState) {
			return null;
		}

		// re-hydrate
		return angular.fromJson(_listViewState);

	}


	/**
	 *    GET LIST
	 */

	function getList(onlyCreditReplenish) {

		_currentPurl = 'admin/vendor/list';
		var defer = $q.defer();

		var apiRequest = {
			Context: {},
			Entity: {},
			Params : {OnlyCreditReplenishment: !!onlyCreditReplenish},
			Paging: {
				Page: 1,
				Size: 2000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('Id')]
		};
		apiService.post(_currentPurl, apiRequest).then(okList, errList);

		function okList(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errList(r) {

			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function getTPAList() {

		_currentPurl = 'admin/vendor/tpa/list';
		var defer = $q.defer();

		var apiRequest = {
			Context: {},
			Entity: {},
			Paging: {
				Page: 1,
				Size: 2000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('Name')]
		};

		apiService.post(_currentPurl, apiRequest).then(okList, errList);

		function okList(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			var result = utilSvc.array.sortASC(r.data.Entity, 'Name');
			defer.resolve(result);

		}

		function errList(r) {

			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    GET DETAIL
	 */

	function getDetail(id, type) {

		// params
		if(!validSvc.isText(id) && !validSvc.isText(type)) {
			throw new Error('vendorRepo.getDetail, id and type are required');
		}

		_currentPurl = 'admin/vendor/get';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Entity: {
				Params: {
					Id: id
				}
			}
		};

		if (type == 'TPA') {
			apiReqest.Context = {
				TPAID: [id]
			};
		} else {
			apiReqest.Context = {
				VENID: [id]
			};
		}

		// call api
		apiService.post(_currentPurl, apiReqest).then(okGetDetail, errGetDetail);

		function okGetDetail(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(modelVM(r.data.Entity));

		}

		function errGetDetail(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    CREATE / UPDATE
	 */

	function create(model) {
		return upsert('admin/vendor/create', model);
	}

	function update(model) {
		return upsert('admin/vendor/update', model);
	}

	function upsert(purl, model) {

		_currentPurl = purl;
		_modelPending = model;
		var defer = $q.defer();

		var apiRequest = {
			Entity: {
				Id: model.Id.val,
				Name: model.Name.val,
				Type: model.Type.val,
				ObjectState: model.ObjectState,
				SupportsEDI: model.SupportsEDI.val == 'yes',
				SenderId: model.SenderId.val,
				ReceiverId: model.ReceiverId.val,
				ShortPONames: model.ShortPONames == 'yes',
				CSOSSplit: model.CSOSSplit == 'yes',
				ProxyVendor : model.ProxyVendor.val,
				CSOSReceiverId: model.CSOSReceiverId.val,
				CashCard: {},
				ExcludedVINs: [],
				CreditReplenish: model.CreditReplenish == 'yes',
				CreditReplenishId: model.CreditReplenishId.val,
				// security
				KeyStr : model.EncryptionPublicKey.val,
			}
		};

		// if (type == 'TPA') {
		// 	apiReqest.Entity.Type = 'TPA';
		// }

		// add cash card?
		var i = 0;
		if(model.Type.val == 'PBM') {
			var cc = apiRequest.Entity.CashCard;
			cc.IncrementalExtractInterval = model.CashCardInterval;
			cc.MaxBenefitLevel = model.CashCardMaxLevel;

			// create array of bins from validate properties
			var bins = model.CashCardBINs;
			cc.BIN = [];
			for(i = 0; i < bins.length; i++) {
				cc.BIN.push(bins[i].val);
			}
		}

		if(model.Type.val == 'WHOLESALER') {
			// create array of vins from validate properties
			var vins = model.ExcludedVINs;
			for(i = 0; i < vins.length; i++) {
				apiRequest.Entity.ExcludedVINs.push(vins[i].val);
			}
		}

		// call api
		apiService.post(_currentPurl, apiRequest).then(upsertOk, upsertErr);

		function upsertOk(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function upsertErr(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapApiErrorsToModel(r, _modelPending);
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);
				if(fieldObj === undefined) {
					throw new Error('vendorRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
				}

				// set failed state
				fieldObj.fail = 'yes';
				fieldObj.msg = entity.Fields[i].Rule;

			}

			return m;

		}

		return defer.promise;
	}
	
	/**
	 *    CONTEXT
	 */
		function contextVM() {

		var uType = $rootScope.User.Type;

		return {
			uType: uType,
			isVerity: uType == 'VERITYSA' || uType == 'VERITY',
			isVeritySA: uType == 'VERITYSA'
		};

	}
}
 
ordersRepo.$inject = ['$rootScope', '$q', 'apiService', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
.module('espui.orders')
.factory('ordersRepo', ordersRepo);


/* @ngInject */
function ordersRepo($rootScope, $q, apiService, errSvc, eventSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _currentPurl = '',
		_apiPaging = vmSvc.api.paging(),
		_pendingGetSplit = null,
		_orderPending = null;

	// service definition
	var service = {
		queryVM: queryVM,

		// contract orders
		getAvailableItems: getAvailableItems, // available items = accumulated + backlog
		getOrderDetail: getOrderDetail,
		getOrderList: getOrderList,

		// new split
		getNewSplitAvailable: getNewSplitAvailable,

		// order
		orderCreate: orderCreate,
		orderCreateSplit: orderCreateSplit,
		orderUpdate: orderUpdate,
		orderStatus: orderStatus,
		orderPlace: orderPlace,

		// surplus
		surplusAdd: surplusAdd,
		surplusRemove: surplusRemove,
		surplusAddAll: surplusAddAll,
		surplusRemoveAll: surplusRemoveAll,
		surplusChange: surplusChange,

		// pre-split order
		getPreSplitOrderDetail: getPreSplitOrderDetail,
		orderPreSplitUpdate: orderPreSplitUpdate,
		orderPreSplitAdd: orderPreSplitAdd,
		//verisaveList: verisaveList,
		optimizePreSplit: optimizePreSplit,

		// split order detail
		getSplitOrder: getSplitOrder,
		getSplitLog: getSplitLog,
		splitLineItemUpdate: splitLineItemUpdate,
		removeNonPriceSelect: removeNonPriceSelect,

		// excel
		getOrderExcel: getOrderExcel,
		getOrderListExcel: getOrderListExcel

	};

	return service;


	/**
	 *    QUERY VIEW MODEL
	 */

	function queryVM() {

		return {
			UserType: $rootScope.User.Type,
			CE: validSvc.newProp($rootScope.User.CE),
			RX: validSvc.newProp($rootScope.User.RX),
			VEN: validSvc.newProp('NONE'),
			AcctType: validSvc.newProp('NONE'),
			NdcFilter: 'yes',
			RxBizModels: [],
			RxSplit: false,
			RxShortName: '',
			StartDate: validSvc.newPropDateNull(),
			EndDate: validSvc.newPropDateNull(),
			Paging: vmSvc.ui.paging()
		};

	}


	/**
	 *    GET AVAILABLE
	 *    data used by Accumulated and Backlog tabs
	 */

	function getAvailableItems(query) {

		// params
		if(!validQueryEntities(query)) {
			throw new Error('order.repo.getAvailable, RX/CE/VEN ids are required');
		}

		_currentPurl = 'order/available';
		var defer = $q.defer();

		// update CE and Rx user choice
		eventSvc.rootEmit('context.change', {
			CE: query.CE.val,
			RX: query.RX.val
		});

		// SPLIT business model support
		var acctType = '';
		if(!!query.AcctType) {
			acctType = query.AcctType.val;
		}

		// CP order category filter, default is empty (no filter)
		var ordCat = '';
		if(!!query.OrderCategory && query.RxCP) {
			switch(query.OrderCategory.val) {
				case 'STANDARD':
					if(query.OrderCategory.chk == 'no') {
						// user does NOT want any dropship or specialty items
						ordCat = 'STANDARD';
					}
					break;
				case 'DROPSHIP':
				case 'SPECIALTY':
				case 'ASSAY':
					ordCat = query.OrderCategory.val;
					break;
				default:
					throw new Error('ordersRepo.getAvailableItems, unknown order category: ' + query.OrderCategory.val);
			}
		}

		// direct replenish
		var directRep = query.hasDirectRep && query.DirectRep.chk == 'yes';

		// create api request
		var apiReqest = {
			Context: {
				CEID: [query.CE.val],
				RXID: [query.RX.val],
				VENID: [query.VEN.val]
			},
			Params: {
				AccumGrp: acctType,
				NdcFilter: query.NdcFilter == 'yes',
				OrderCategory: ordCat,
				DodPharmaType: query.isDOD ? query.DodPharmaType : '',
				DodBillingType: query.isDOD ? query.DodBillingType : '',
				DirectReplenish: directRep,
				IsISP: query.IsISP == 'yes',
				CeKeep: directRep && query.DirectRep.val == 'KEEP',
				SkipProfit: directRep ? query.DirectRepProfit == 'no' : false,
				AccumRXID: query.AccumRXID != 'NONE' ? query.AccumRXID : ''
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('ItemCode')]
		};

		// call api
		apiService.post(_currentPurl, apiReqest).then(getOk, getErr);


		function getOk(r) {

			// api fix: null array
			if(!!r && !!r.data && !Array.isArray(r.data.Entity)) {
				r.data.Entity = [];
			}

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// loop items, add extra properties
			var items = r.data.Entity;
			for(var i = 0; i < items.length; i++) {

				// order qty (user entered)
				items[i].UserUnits = 0;

				// validation fields
				items[i].fail = false;
				items[i].msg = '';

			}

			defer.resolve({
				Items: items,
				TooMany: r.data.Paging.Size > _apiPaging.Size
			});

		}

		function getErr(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    GET ORDER LIST
	 */

	function orderListApiRequest(query) {
		var ceid = [],
			rxid = [],
			progAdmin = '';

		switch(query.SearchType) {
			case 'IND':
				ceid = query.CE.val == 'ALL' ? [] : [query.CE.val];
				rxid = query.RX.val == 'ALL' ? [] : [query.RX.val];
				// params check
				if(ceid.length < 1 && rxid.length < 1 && query.UserType != 'RX') {
					throw new Error('ordersRepo.orderListApiRequest, IND search requires CE or RX');
				}
				break;
			case 'ROLLUP':
				rxid = [query.RxRollup.val];
				// params check
				if(!validSvc.isRX(query.RxRollup.val)) {
					throw new Error('ordersRepo.orderListApiRequest, ROLLUP search requires RxRollup');
				}
				break;
			case 'PROGADMIN':
				progAdmin = query.ProgramAdmin.val;
				rxid = query.ProgramAdmin.rxids;
				// params check
				if(query.ProgramAdmin.val == 'NONE') {
					throw new Error('ordersRepo.orderListApiRequest, PROGADMIN search requires ProgramAdmin');
				}
				break;
			default:
				throw new Error('ordersRepo.orderListApiRequest, unknown search type: ' + query.SearchType);
		}

		// search options
		var ordCategory = query.OrderCategory.chk ? query.OrderCategory.val : '';

		// create api request
		return {
			Context: {
				CEID: ceid,
				RXID: rxid
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				OrderCategory: ordCategory,
				DirectReplenish: query.DirectReplenish,
				ProgAdmin: progAdmin
			}
		};
	}

	function getOrderList(query) {


		var defer = $q.defer();
		_currentPurl = 'order/list';

		// create api request
		var apiRequest = orderListApiRequest(query);
		apiRequest.Paging = _apiPaging;
		apiRequest.SortBy = [utilSvc.sorting.sortByApiStyle('-CreatedOn')];

		// update CE and Rx user choice
		eventSvc.rootEmit('context.change', {
			CE: apiRequest.Context.CEID.length > 1 ? apiRequest.Context.CEID[0] : '',
			RX: apiRequest.Context.RXID.length > 1 ? apiRequest.Context.RXID[0] : ''
		});
		
		// call api
		apiService.post(_currentPurl, apiRequest).then(getOrderListOk, getOrderListErr);

		function getOrderListOk(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({
				data: r.data.Entity,
				TooMany: r.data.Entity.length > _apiPaging.Size
			});

		}

		function getOrderListErr(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    GET ORDER DETAIL
	 */

	function getOrderDetail(id) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('order.repo.getOrderDetail, id is missing: ' + id);
		}

		_currentPurl = 'order/get';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Entity: {
				Context: {},
				Params: {
					Id: id
				}
			}
		};

		// call api
		apiService.post(_currentPurl, apiReqest).then(getOk, getErr);


		function getOk(r) {
			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + ' repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}
			var ent = r.data.Entity;

			// loop order items, add extra properties
			var items = Array.isArray(ent.Items) ? ent.Items : [],
				item = {};
			for(var i = 0; i < items.length; i++) {
				item = items[i];
				// order qty (user entered)
				item.UserUnits = item.ItemUnits;
				item.fail = false;
				item.msg = '';
			}
			ent.Items = items;

			defer.resolve(ent);
		}

		function getErr(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	/**
	 *    GET NEW SPLIT ORDER AVAILABLE CATALOG
	 */
	function getNewSplitAvailable(query) {
		_currentPurl = 'order/presplit/available';
		var defer = $q.defer();

		// update CE and Rx user choice
		eventSvc.rootEmit('context.change', {
			CE: query.CE.val,
			RX: query.RX.val,
			VEN: query.VEN.val,
		});

		var ce = query.CE.val != 'NONE' ? query.CE.val : null;

		// create api request
		var apiReqest = {
			Context: {
				CEID: [ce],
				RXID: [query.RX.val],
				VENID: [query.VEN.val]
			},
			Params: {
				ItemCode: query.ItemCode.val,
				Desc: query.Desc.val,
				VenItemNum: query.VenItemNum.val,
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('ItemCode')]
		};

		// call api
		apiService.post(_currentPurl, apiReqest).then(getOk, getErr);
		function getOk(r) {

			if (!!r && !!r.data && !Array.isArray(r.data.Entity)) {
				r.data.Entity = [];
			}

			// bad "Get List" response format
			if (!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// loop items, add extra properties
			var items = r.data.Entity;
			for (var i = 0; i < items.length; i++) {
				// validation fields
				items[i].fail = false;
				items[i].msg = '';
			}

			defer.resolve({
				Items: items,
				TooMany: r.data.Paging.Size > _apiPaging.Size
			});

		}

		function getErr(r) {
			if (r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 *    Pre-Split Order
	 */

	 function getPreSplitOrderDetail(id) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('order.repo.getPreSplitOrderDetail, id is missing: ' + id);
		}

		_currentPurl = 'order/presplit/get';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Entity: {
				Context: {},
				Params: {
					Id: id
				}
			}
		};

		// call api
		apiService.post(_currentPurl, apiReqest).then(getOk, getErr);


		function getOk(r) {

			// api fix: null items array
			if(!!r && !!r.data && !!r.Entity && !Array.isArray(r.data.Entity.Items)) {
				r.data.Entity.Items = [];
			}
			if (r.data.Entity.Items===null) {
				r.data.Entity.Items = [];
			}

			// bad response format
			if(!!!r || isNaN(r.status) || !!!r.data || !!!r.data.Entity) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// loop order items, add extra properties
			var items = r.data.Entity.Items;
			for(var i = 0; i < items.length; i++) {
				// order qty (user entered)
				items[i].UserUnits = items[i].OrderUnits;
				items[i].fail = false;
				items[i].msg = '';

			}
			r.data.Entity.Items = items;

			defer.resolve(r.data.Entity);

		}

		function getErr(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function orderPreSplitUpdate(order) {
		// params
		if(!Array.isArray(order.Items) || !validSvc.isText(order.Id)) {
			throw new Error('order.repo.update, order id or items are missing for order Id: ' + id);
		}

		// upsert
		return upsert('order/presplit/save', {
			Id: order.Id,
			AcctType: order.AcctType,
			Context: {},
			Items: order.Items
		});
	}

	function orderPreSplitAdd(order, item) {
		// params
		if(!validSvc.isText(order.Id)) {
			throw new Error('order.repo.update, order id is missing');
		}
		_currentPurl = 'order/presplit/add';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Entity: {
				Context: {},
				Params: {
					Id: order.Id,
				},
				Items: [item],
			}
		};

		// call api
		apiService.post('order/presplit/add', apiRequest).then(upsertOk, upsertErr);

		function upsertOk(r) {
			defer.resolve(r.data.Entity);
		}

		function upsertErr(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + '/repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	/**
	 *    GET SPLIT ORDERS
	 */

	function getSplitOrder(id) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('order.repo.getSplitOrder, id is missing: ' + id);
		}

		_currentPurl = 'order/getsplit';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Entity: {
				Context: {},
				Params: {
					Id: id
				}
			}
		};
		_pendingGetSplit = apiReqest;

		// call api
		apiService.post(_currentPurl, apiReqest).then(getOk, getErr);


		function getOk(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function getErr(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function getSplitLog(id) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('order.repo.getSplitLog, id is missing: ' + id);
		}

		_currentPurl = 'order/getsplitlog';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Entity: {
				LineId: id
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okGetLog, errGetLog);

		function okGetLog(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errGetLog(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    UPSERT ORDER
	 */

	function orderCreate(query, uiItems) {

		// params
		if(!validQueryEntities(query)) {
			throw new Error('order.repo.orderCreate, RX/CE/VEN ids are required');
		}

		// CP order category, default is "STANDARD" (logic is slightly different from get available items on purpose)
		var ordCat = 'STANDARD',
			accumSearchAll = false;
		if(!!query.OrderCategory && query.RxCP) {
			switch(query.OrderCategory.val) {
				case 'STANDARD':
					accumSearchAll = query.OrderCategory.chk == 'yes';
					break;
				case 'DROPSHIP':
				case 'SPECIALTY':
				case 'ASSAY':
					ordCat = query.OrderCategory.val;
					break;
				default:
					throw new Error('ordersRepo.getAvailableItems, unknown order category: ' + query.OrderCategory.val);
			}
		}

		// upsert!
		return upsert('order/create', {
			Context: {
				CEID: [query.CE.val],
				RXID: [query.RX.val],
				VENID: [query.VEN.val]
			},
			Id: '',
			AcctType: query.AcctType.val,
			Category: ordCat,
			AccumSearchAll: accumSearchAll,
			DodPharmaType: !!query.isDOD ? query.DodPharmaType : '',
			DodBillingType: !!query.isDOD ? query.DodBillingType : '',
			IsISP: query.IsISP == 'yes',
			DirectReplenish: query.hasDirectRep && query.DirectRep.chk == 'yes',
			CeKeep: query.DirectRep.val,
			DirectRepProfit: query.DirectRepProfit,
			AccumRXID: query.AccumRXID != 'NONE' ? query.AccumRXID : '',
			Items: uiItems
		});
	}

	function orderCreateSplit(query) {
		// params
		if(!validQueryEntities(query)) {
			throw new Error('order.repo.orderCreate, RX/CE/VEN ids are required');
		}

		// create split api request
		var apiReqest = {
			Context: {
				CEID: [query.CE.val],
				RXID: [query.RX.val],
				VENID: [query.VEN.val]
			},
			Entity: {
				Params: {
					PoName: query.PoName.val,
					SeqSplit: query.SeqSplit
				},
			}
		};
		
		apiService.post('order/createsplit', apiReqest).then(upsertOk, upsertErr);
		var defer = $q.defer();

		function upsertOk(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function upsertErr(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.query = mapApiErrorsToQuery(r, query);
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

		}

		function mapApiErrorsToQuery(r, q) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// field errors
			var fieldId = '';
			for(var i = 0; i < entity.Fields.length; i++) {
				fieldId = entity.Fields[i].Name;
				// set failed state
				q[fieldId].fail = 'yes';
				q[fieldId].msg = entity.Fields[i].Rule;

			}

			return q;

		}

		return defer.promise;
	}

	function orderPlace(order) {
		return orderUpdate(order, true);
	}

	function orderUpdate(order, isPlaceOrder) {

		// params
		if(!validOrderEntities(order)) {
			throw new Error('order.repo.orderUpdate, RX/CE/VEN ids are required');
		}

		// params
		if(!Array.isArray(order.Items) || !validSvc.isText(order.Id)) {
			throw new Error('order.repo.update, order id or items are missing for order Id: ' + id);
		}

		// upsert!
		return upsert('order/update', {
			Context: {
				CEID: [order.CEID],
				RXID: [order.RXID],
				VENID: [order.VENID],
			},
			isPlaceOrder: !!isPlaceOrder,
			Id: order.Id,
			AcctType: order.AcctType,
			SendEDI: !!order.SendEDI,
			Category: order.Category,
			AccumSearchAll: !!order.AccumSearchAll,
			DodPharmaType: !!order.isDOD ? order.DodPharmaType : '',
			DodBillingType: !!order.isDOD ? order.DodBillingType : '',
			DirectReplenish: order.DirectReplenish,
			ReferencePO: order.ReferencePO,
			CeKeep: order.CeKeep,
			DirectRepProfit: order.DirectRepProfit,
			AccumRXID: order.AccumRXID,
			Items: order.Items
		});

	}

	function itemsValid(orderCat, uiItems) {

		// validate all items on create or update

		var orderItems = [],
			errItem = false,
			qty = 0,
			isAssayOrder = orderCat == 'ASSAY',
			item = {},
			orderItem = {};

		// loop items
		for(var i = 0; i < uiItems.length; i++) {
			item = uiItems[i];

			// user entered order qty
			qty = item.UserUnits;

			// must be integer
			if(!validSvc.isInteger(qty)) {
				item.fail = true;
				item.msg = "must be integer";
				errItem = true;
				continue;
			}
			// must be less than available
			if(qty > item.ItemUnits) {
				item.fail = true;
				item.msg = "must be less than Accumulated";
				errItem = true;
				continue;
			}
			qty = parseInt(qty);

			// add to order items
			orderItem = {
				Id: item.Id,
				State: item.State, // Remove, Add or Modify
				AccumulatorId: item.AccumulatorId,
				ItemCode: item.ItemCode,
				ItemUnits: qty,
				OrderUnits: qty,
				UserUnits: qty,
				UserUnitsEdit: qty,
				VenDrugCode: item.VenDrugCode,
				VenLabel: item.VenLabel,
				CaseUnits: item.CaseUnits,
				Uom: item.Uom,
				DodPharmaType : item.DodPharmaType,
				DodUnitSale : item.DodUnitSale,
				WholesaleUnits: item.WholesaleUnits,
				Replaced: item.Replaced,
				InnerPackItemCode: item.InnerPackItemCode,
				NoVerisaveSwap: !!item.NoVerisaveSwap,
				NoMultiVendorSwap: !!item.NoMultiVendorSwap,
				Optimize: item.Optimize || {},
				Notes: item.Notes
			};

			// add ASSAY properties if needed
			if(isAssayOrder) {
				orderItem.AssayUnits = item.AssayUnits;
				orderItem.LotExpiration = validSvc.isDate(item.LotExpiration) ? new Date(item.LotExpiration) : null;
				orderItem.LotNumber = item.LotNumber;
			}

			orderItems.push(orderItem);
		}

		// result
		return {
			fail: errItem || orderItems.length === 0,
			uiItems: uiItems,
			orderItems: orderItems
		};

	}

	function upsert(purl, order) {

		_currentPurl = purl;
		var defer = $q.defer();

		// derive order category
		var orderCat = validSvc.isText(order.Category) ? order.Category : 'STANDARD'; // default is always STANDARD

		// re-validate before sending to api
		var validResult = itemsValid(orderCat, order.Items);
		if(validResult.fail) {
			order.Items = validResult.uiItems;
			defer.reject({
				status: 422,
				order: order
			});
		}
		else {
			order.Items = validResult.orderItems;
			_orderPending = order;

			// direct replenish
			var directRep = !!order.DirectReplenish;

			// create api request
			var apiRequest = {
				Context: order.Context,
				Entity: {
					Params: {
						Id: order.Id,
						AccumGrp: order.AcctType,
						Category: orderCat,
						AccumSearchAll: !!order.AccumSearchAll,
						DodPharmaType: validSvc.isText(order.DodPharmaType) ? order.DodPharmaType : '',
						DodBillingType: validSvc.isText(order.DodBillingType) ? order.DodBillingType : '',
						IsISP: order.IsISP,
						DirectReplenish: directRep,
						ReferencePO: order.ReferencePO,
						CeKeep: directRep && order.CeKeep == 'KEEP', // default is false
						SkipProfit: directRep && order.DirectRepProfit == 'no', // default is false
						AccumRXID: order.AccumRXID
					},
					Items: order.Items
				}
			};

			// adding EDI send option (only on PLACE order save)
			// note: this is so confusing! property should be "SendEDI" all the way to api
			if(!!order.isPlaceOrder) {
				apiRequest.Entity.Params.DontSendEDI = !!!order.SendEDI;
			}

			apiService.post(_currentPurl, apiRequest).then(upsertOk, upsertErr);
		}

		function upsertOk(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function upsertErr(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.order = mapApiErrorsToOrderModel(r, _orderPending);
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

		}

		function mapApiErrorsToOrderModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: true,
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldId = '';
			for(var i = 0; i < entity.Fields.length; i++) {

				fieldId = entity.Fields[i].Name;

				// find item by ndc
				var idx = find422ItembyId(fieldId, m.Items);
				if(idx === -1) {
					throw new Error('order.repo.mapApiErrorsToOrderModel, api 422 field id was not found in pending order items with id: ' + fieldId);
				}

				// set failed state
				m.Items[idx].fail = true;
				m.Items[idx].msg = entity.Fields[i].Rule;

			}

			return m;

		}


		return defer.promise;

	}


	/**
	 *    STATUS CHANGE
	 */

	function orderStatus(id, status, order) {
		// order id
		if(!validSvc.isText(id) || (status !== 'CANCEL' && status !== 'PLACE' && status !== 'SPLIT')) {
			throw new Error('order.repo.orderStatus, id is missing');
		}

		// set purl
		switch(status) {
			case 'CANCEL':
				_currentPurl = 'order/cancel';
				break;
			case 'PLACE':
				_currentPurl = 'order/place';
				break;
			case 'SPLIT':
				_currentPurl = 'order/presplit/queue';
				break;
			default:
				throw new Error('order.repo.orderStatus, status unknown: ' + status);
		}

		var defer = $q.defer();
		
		var apiReqest = {
			Context: {},
			Entity: {
				Id: id,
			}
		};

		if (order !==undefined){
			apiReqest.Entity= order;
		}
		apiService.post(_currentPurl, apiReqest).then(okStat, errStat);
		function okStat(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function errStat(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(status == 'PLACE' && r.status == 422) {
				// get failed ndcs from 422 Fields
				r.msg = orderPlace422Msg(r);
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

			function orderPlace422Msg(r) {
				var msg = '';
				if(!!r.data && !!r.data.Entity && Array.isArray(r.data.Entity.Fields) && r.data.Entity.Fields.length > 0) {
					// fields exist, build message
					var fields = r.data.Entity.Fields,
						f = {};
					for(var i = 0; i < fields.length; i++) {
						f = fields[i];
						msg += i > 0 ? ', ' : 'Placed items are invalid: ';
						msg += 'NDC: ' + f.Name + ' ' + f.Rule;
					}
				}
				return msg;
			}

		}


		return defer.promise;


	}


	/**
	 *    SURPLUS ITEM
	 *    add / remove one item between accum and backlog
	 */

	function surplusAdd(uiItem) {

		// valid
		if(!surplusItemValid(uiItem)) {
			throw new Error('orders.repo.surplusAdd, uiItem failed validation', utilSvc.json.stringify(uiItem, true));
		}

		return surplusChange('order/surplus/add', [{
			ItemCode: uiItem.ItemCode,
			SurplusUnits: uiItem.SurplusUnits,
			AccumulatorId: uiItem.AccumulatorId
		}]);

	}

	function surplusRemove(uiItem) {

		// valid
		if(!surplusItemValid(uiItem)) {
			throw new Error('orders.repo.surplusRemove, uiItem failed validation', utilSvc.json.stringify(uiItem, true));
		}

		return surplusChange('order/surplus/remove', [{
			ItemCode: uiItem.ItemCode,
			SurplusUnits: uiItem.SurplusUnits,
			AccumulatorId: uiItem.AccumulatorId
		}]);

	}

	function surplusItemValid(uiItem, qty) {

		// validate: ItemCode, CEID, RXID, AccumulatorId, SurplusUnits
		if(!validSvc.isText(uiItem.ItemCode) || !validSvc.isText(uiItem.AccumulatorId) || !validSvc.isInteger(uiItem.SurplusUnits)) {
			return false;
		}
		else {
			return true;
		}

	}

	function surplusChange(purl, surplusItems) {

		_currentPurl = purl;
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Entity: {
				Items: surplusItems
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okSurplus, errSurplus);

		function okSurplus(r) {
			defer.resolve({});
		}

		function errSurplus(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409 || r.status == 422) {
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

		}

		return defer.promise;

	}


	/**
	 *    SURPLUS ALL ITEMS
	 *    add / remove all items between accum and backlog
	 */

	function surplusAddAll(ceid, rxid) {
		return surplusChangeAll('order/surplus/addall', ceid, rxid);
	}

	function surplusRemoveAll(ceid, rxid) {
		return surplusChangeAll('order/surplus/removeall', ceid, rxid);
	}

	function surplusChangeAll(purl, ceid, rxid) {

		_currentPurl = purl;
		var defer = $q.defer();

		// params
		if(!validSvc.isCE(ceid) || !validSvc.isRX(rxid)) {
			throw new Error('orders.repo.surplushChangeAll, ceid and rxid are required');
		}

		// create api request
		var apiReqest = {
			Context: {
				CEID: [ceid],
				RXID: [rxid]
			}
		};

		apiService.post(_currentPurl, apiReqest).then(okSurplusAll, errSurplusAll);

		function okSurplusAll(r) {
			defer.resolve({});
		}

		function errSurplusAll(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409 || r.status == 422) {
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result', utilSvc.http.safeResponse(r));
			}

		}

		return defer.promise;

	}


	/**
	 * 	  SPLIT DETAIL EDITS
	 */

	function splitLineItemUpdate(id, qty) {

		// validate
		if(!validSvc.isText(id) || !validSvc.isInteger(qty)) {
			errSvc.error('ordersRepo.splitLineItemUpdate, line item and ids required');
			return;
		}

		_currentPurl = 'order/lineitemupdate';
		var defer = $q.defer();
		var apiRequest = {
			Entity: {
				LineId: id,
				ItemUnits: qty
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okLineUpdate, errLineUpdate);

		function okLineUpdate(r) {
			defer.resolve({});
		}

		function errLineUpdate(r) {
			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(r.status == 409 || r.status == 422) {
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}
		}

		return defer.promise;
	}

	function removeNonPriceSelect(orderId) {

		// validate
		if(!validSvc.isText(orderId)) {
			errSvc.error('ordersRepo.removeNonPriceSelect id required');
			return;
		}

		_currentPurl = 'order/nonpriceselect';
		var defer = $q.defer();
		var apiRequest = {
			Params: {
				OrderId: orderId
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okPriceSelect, errPriceSelect);

		function okPriceSelect(r) {
			defer.resolve({});
		}

		function errPriceSelect(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

		}

		return defer.promise;

	}


	/**
	 * 		VERISAVE - replaced by OPTIMIZE, keep this JIC
	 *

	function verisaveList(orderId) {

		// params
		if(!validSvc.isText(orderId)) {
			throw new Error('order.repo.verisaveList, order id required');
		}

		_currentPurl = 'order/simsplit';
		var defer = $q.defer();

		var apiRequest = {
			Params: {
				Id: orderId
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('ItemCode')]
		};
		apiService.post(_currentPurl, apiRequest).then(okVerisave, errVerisave);

		function okVerisave(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + ' repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			var items = Array.isArray(r.data.Entity.Items) ? r.data.Entity.Items : [];
			defer.resolve(items);
		}

		function errVerisave(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + ' repo', '', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}
	*/

	function optimizePreSplit(orderId, overrides) {
		overrides = Array.isArray(overrides) ? overrides : [];

		// params
		if(!validSvc.isText(orderId)) {
			throw new Error('order.repo.optimize, order id required');
		}

		_currentPurl = 'order/presplit/optimize';
		var defer = $q.defer();

		/* KEEP this mock its super handy for multi-optimization reconcile
		var mock = {
			status:200,
			data: {
				Paging: {
					Size:1
				},
				Entity: [
					{
						"Id": "1",
						"ItemCode": "1",
						"VenDrugCode": "3284403",
						"VenLabel": "HYDROC B AC 10 325 UD MALL100@",
						"Vendor": "MCKESSON",
						"ItemUnits": 1,
						"PreOptCost": 36.45,
						"TopAlts": [
							{
								"ItemCode": "50268040215",
								"VenDrugCode": "3269032",
								"VenLabel": "HYDROcodone-Acetaminophen 10-325 MG TABS",
								"ItemUnits": 2,
								"Vendor": "MCKESSON",
								"Saving": 4.18
							}
						]
					}
				]
			}
		};
		if(overrides.length < 1) {
			mock.data.Entity.push({
				"Id": "2",
				"ItemCode": "2",
				"VenDrugCode": "3284403",
				"VenLabel": "HYDROC B AC 10 325 UD MALL100@",
				"Vendor": "MCKESSON",
				"ItemUnits": 1,
				"PreOptCost": 36.45,
				"TopAlts": [
					{
						"ItemCode": "50268040215",
						"VenDrugCode": "3269032",
						"VenLabel": "HYDROcodone-Acetaminophen 10-325 MG TABS",
						"ItemUnits": 2,
						"Vendor": "MCKESSON",
						"Saving": 4.18
					}
				]
			});
		}
		okOptimize(mock);
		*/		

		var apiRequest = {
			Params: {
				Id: orderId,
				Overrides: overrides
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('ItemCode')]
		};
		apiService.post(_currentPurl, apiRequest).then(okOptimize, errOptimize);
		
		function okOptimize(r) {
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + ' repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}
			defer.resolve(r.data.Entity);
		}

		function errOptimize(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + ' repo', '', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 *    GET ORDER EXCEL
	 */

	function getOrderExcel(id, filename) {

		// params
		if(!validSvc.isText(id) || !validSvc.isText(filename)) {
			throw new Error('orderRepo.getOrderExcel, id,filename required');
		}

		_currentPurl = 'order/excel';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Entity: {
				Context: {},
				Params: {
					Id: id,
					Filename: filename
				}
			}
		};

		// call api
		apiService.postGetBinary(_currentPurl, apiRequest).then(okGetExcel, errGetExcel);

		function okGetExcel(r) {
			defer.resolve(r.data);
		}

		function errGetExcel(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + '/repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function getOrderListExcel(query) {

		var apiRequest = orderListApiRequest(query);

		_currentPurl = 'order/list/excel';
		var defer = $q.defer();

		apiService.postGetBinary(_currentPurl, apiRequest).then(okGetExcel, errGetExcel);

		function okGetExcel(r) {
			defer.resolve(r.data);
		}

		function errGetExcel(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}



	/**
	 *    HELPERS
	 */

	function find422ItembyId(id, items) {
		for(var i = 0; i < items.length; i++) {
			if(items[i].Id === id) {
				return i;
			}
		}
		return -1;
	}

	function validQueryEntities(query) {
		// short hand to check query has all three RX,CE,VEN entities
		return validSvc.isRX(query.RX.val) && validSvc.isCE(query.CE.val) && validSvc.isVEN(query.VEN.val);
	}

	function validOrderEntities(order) {
		// short hand to check order has all three RX,CE,VEN entities
		return validSvc.isRX(order.RXID) && validSvc.isCE(order.CEID) && validSvc.isVEN(order.VENID);
	}

}
 
ordersDetailRouteCtl.$inject = ['$window', '$state', '$rootScope', '$scope', '$timeout', 'ordersRepo', 'prefsRepo', 'sessionRepo', 'msgSvc', 'utilSvc', 'validSvc', 'errSvc'];
angular
.module('espui.orders')
.controller('OrdersDetailRoute', ordersDetailRouteCtl);


/* @ngInject */
function ordersDetailRouteCtl($window, $state, $rootScope, $scope, $timeout, ordersRepo, prefsRepo, sessionRepo, msgSvc, utilSvc, validSvc, errSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _routeOrder = {};


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		// params
		var p = $state.params;
		if(!!!p || !validSvc.isText(p.id)) {
			throw new Error('orderDetailRouteCtl.init, missing params.id or params.fromFeature on route: ' + $state.current.name);
		}

		_routeOrder = {
			id: p.id,
			breadcrumb: !!p.breadcrumb ? p.breadcrumb : null
		};

		getOrderDetail(_routeOrder.id);

	}

	function getOrderDetail(id) {

		// send api request
		ordersRepo.getOrderDetail(id).then(okOrder, errOrder);

		function okOrder(r) {

			// figure out order type from response, route to the correct order detail controller

			if(r.Id == _routeOrder.id) {

				var routePurl = '',
					routeParams = {
						id: r.Id,
						breadcrumb: _routeOrder.breadcrumb
					};

				if(r.OrderType == 'SPLIT' || validSvc.isText(r.ParentId)) {
					// split order parent or child of split order
					routeParams.parentId = validSvc.isText(r.ParentId) ? r.ParentId : null;
					routePurl = 'orders.splitdetail';
				}
				else {
					routePurl = 'orders.view';
				}

				$state.go(routePurl, routeParams, {reload: routePurl});
			}

		}

		function errOrder(r) {

			if(!!r) {
				errSvc.warn('Unknown order id ' + _routeOrder.id + ' from feature: ' + _routeOrder.from, 'ordersDetailRouteCtl.errOrder', r.status, utilSvc.http.safeResponse(r));
				routeNavTo('LIST', '', true);
			}

		}

	}


}

 
ordersListCtl.$inject = ['$state', '$rootScope', '$scope', '$window', '$timeout', '$filter', 'ordersRepo', 'prefsRepo', 'sessionRepo', 'lookupRepo', 'validSvc', 'utilSvc', 'errSvc', 'msgSvc'];
angular
.module('espui.orders')
.controller('OrdersListCtl', ordersListCtl);


/* @ngInject */
function ordersListCtl($state, $rootScope, $scope, $window, $timeout, $filter, ordersRepo, prefsRepo, sessionRepo, lookupRepo, validSvc, utilSvc, errSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this,
		_featureName = '',
		_primaryProp = 'CE',
		_pagingEventListener = null,
		_pendingExcelFilename = '',
		_isRxUser = false,
		_returnVisit = false;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	msgSvc.addHelpLink(vm);
	utilSvc.ctl.addFlexTop(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.showAutoOrders = false;
	vm.showReview = false;
	vm.action = '';
	vm.isVerityUser = 'no';

	// CE/RX droplists
	vm.primaryDroplist = [];
	vm.secondaryDroplist = [];

	// more droplists
	vm.RollupDroplist = [];
	vm.ProgAdminDroplist = [];	
	vm.OrderCategoryDroplist = [];

	// query
	vm.query = {};
	vm.queryChangePrimary = queryChangePrimary;
	vm.queryChangeSecondary = queryChangeSecondary;
	vm.dateRangeChange = dateRangeChange;
	vm.queryChangeSearchType = queryChangeSearchType;
	vm.queryChangeProgAdmin = queryChangeProgAdmin;
	vm.queryChangeRollup = queryChangeRollup;
	vm.querySubmit = querySubmit;
	vm.queryFilterSwap = queryFilterSwap;

	// view methods
	vm.getDetail = getDetail;
	vm.getExcel = getExcel;

	// global grease: filters, table
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;

	// flex top
	vm.flex = {};
	vm.flexTopExpand = flexTopExpand;


	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {
		vm.init = true;

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		_featureName = $state.current.name;

		// user options and preferences
		initUserOptions($rootScope.User);

		vm.flex = vm.flexInit();
		_returnVisit = initQueryAndFilters();
		initDroplists();

		// close query top on return visit
		if(_returnVisit) {
			vm.query.title = queryTitle(vm.query);
			vm.flex = vm.flexCollapse(vm.flex, true);
		}
		
		// ASYNC: get rollup droplist after first render so we don't hang up router
		$timeout(initRollups, 300);		
	}

	function getAffs() {
		// feature route drives aff list

		var affs = utilSvc.aff.findStatus($scope.User.AffList);
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
		affs = utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));

		return affs;
	}

	function initUserOptions(user) {

		// defaults
		_isRxUser = false;
		vm.isVerityUser = 'no';
		_primaryProp = 'CE';

		// functionality by user type
		switch(user.Type) {
			case 'RX':
			case 'RXROLLUP':
				// RX users get more features
				_isRxUser = true;
				break;
			case 'VERITY':
			case 'VERITYSA':
				vm.isVerityUser = 'yes';
				break;
		}

		// CE/RX filter swap preference
		if(!!user.FilterSwap) {
			var ceRxPref = user.FilterSwap.OrderNew;
			if(ceRxPref == 'CE' || ceRxPref == 'RX') {
				_primaryProp = ceRxPref;
			}
		}
	}

	function initQueryAndFilters() {

		// setup query, load viewstate

		var returnVisit = false,
			query = ordersRepo.queryVM();

		// search type, rx rollup and prog admin
		query.UserHasRxRollup = false;
		query.SearchType = 'IND';
		query.RxRollup = validSvc.newProp('NONE');
		query.ProgramAdmin = validSvc.newProp('NONE');
		query.OrderCategory = validSvc.newProp('STANDARD');
		query.OrderCategory.chk = false;
		query.DirectReplenish = false;

		// RX user can have primary property = ALL
		if(_isRxUser) {
			if(_primaryProp == 'CE' && !validSvc.isCE(query.CE.val)) {
				query.CE.val = 'ALL';
				if(!validSvc.isRX(query.RX.val, false, true)) {
					query.RX.val = 'ALL';
				}
			}
			else if(_primaryProp == 'RX' && !validSvc.isRX(query.RX.val)) {
				query.RX.val = 'ALL';
				if(!validSvc.isCE(query.CE.val, false, true)) {
					query.CE.val = 'ALL';
				}
			}
		}

		// date range
		query.DateRangeValid = false;
		query.DateRangeMode = 'MTD';

		// setup filters
		var flt = vm.initFilters({
			Checked: {
				AutoOrdered: false,
				Place: false,
				Ack: false,
				Invoice: false,
				Cancel: false
			},
			Config: {
				Dates: ['CreatedOn','PlaceDate','AckDate','InvoiceDate','CancelDate'],
				DateFmt: 'M/d/yyyy h:mma'
			},
			SortBy: ['-CreatedOn']
		});

		// get viewstate
		var vs = sessionRepo.get('vs-orders-list');
		if(!!vs && vs.query.PrimaryProp == _primaryProp) {
			returnVisit = true;

			switch(vs.query.SearchType) {
				case 'IND':
					query.CE = validSvc.newProp(vs.query.CE);
					query.RX = validSvc.newProp(vs.query.RX);
					break;
				case 'ROLLUP':
					query.RxRollup = validSvc.newProp(vs.query.RxRollup);
					break;
				case 'PROGADMIN':
					query.ProgramAdmin = validSvc.newProp(vs.query.ProgramAdmin);
					break;
				default:
					throw new Error('orderListCtl.initQueryandFilters, unknown search type: ' + vs.query.SearchType);
			}
			query.SearchType = vs.query.SearchType;
			
			// date
			query.StartDate.val = utilSvc.dt.zeroTime(new Date(vs.query.StartDate));
			query.EndDate.val = utilSvc.dt.zeroTime(new Date(vs.query.EndDate));
			query.DateRangeMode = vs.query.DateRangeMode;
			
			// optional
			if(validSvc.isText(vs.query.OrderCategory)) {
				query.OrderCategory.val = vs.query.OrderCategory;
				query.OrderCategory.chk = true;
			}

			// filter
			flt = vm.resetFilters(vs.flt, true);
		}
		else {
			// get rid of old viewstate
			sessionRepo.clearKey('vs-orders-list');
		}

		// assign
		vm.query = query;
		vm.flt = flt;

		return returnVisit;
	}

	function initDroplists() {

		// setup primary / secondary query values

		var affs = getAffs();
		vm.secondaryDroplist = utilSvc.ng.droplistALL();

		if(_primaryProp == 'RX') {

			// primary is RX
			vm.primaryDroplist = _isRxUser ? utilSvc.aff.rxDroplist(affs,'',false,true) : utilSvc.aff.rxDroplist(affs); // RX user gets ALL primary
			vm.query.primary = vm.query.RX.val == 'ALL' ? validSvc.newProp('ALL') : utilSvc.ng.droplistAutoselect(vm.primaryDroplist, vm.query.RX.val);
			vm.query.primaryLabel = 'Pharmacy';

			vm.query.secondary = validSvc.newProp(vm.query.CE.val);
			vm.query.secondaryLabel = 'Facility';
		}
		else {

			// primary is CE
			vm.primaryDroplist = _isRxUser ? utilSvc.aff.ceDroplist(affs,'',false,true) : utilSvc.aff.ceDroplist(affs); // RX user gets ALL primary
			vm.query.primary = vm.query.CE.val == 'ALL' ? validSvc.newProp('ALL') : utilSvc.ng.droplistAutoselect(vm.primaryDroplist, vm.query.CE.val);
			vm.query.primaryLabel = 'Facility';

			vm.query.secondary = validSvc.newProp(vm.query.RX.val);
			vm.query.secondaryLabel = 'Pharmacy';
		}

		// RX user primary can be ALL
		if(_isRxUser && vm.query.primary.val == 'NONE') {
			vm.query.primary.val = 'ALL';
			if(vm.query.secondary.val == 'NONE') {
				vm.query.secondary.val = 'ALL';
			}
		}

		// build Prog Admin list from user's affiliation list, this ensures they do not get access to a Prog Admin on an affiliation they do not have access to
		if(vm.isVerityUser == 'yes') {
			vm.ProgAdminDroplist = utilSvc.ng.droplist(utilSvc.aff.progAdminList(affs), '', '', [{label:'Choose a Program Admin', value:'NONE'}]);
		}
		else {
			vm.ProgAdminDroplist = utilSvc.ng.droplistNONE();
		}

		vm.OrderCategoryDroplist = [
			{label: 'Standard', value: 'STANDARD'},
			{label: 'Drop-ship', value: 'DROPSHIP'},
			{label: 'Specialty', value: 'SPECIALTY'}
			// tbd... {label: 'Assay', value: 'ASSAY'},
		];

		// note: Rollup droplist values will load ASYNC
		// see initRollups()
		vm.RollupDroplist = utilSvc.ng.droplistNONE();
	}

	function initRollups() {
		// ASYNC loading of ROLLUP OPTIONS after UI has rendered so router is not hung up waiting for init

		var rollups = findAffRollupParents(getAffs());
		if(rollups.length < 1) {
			rollupReturnExists([], 'NONE');
			initFinalize();
			return;
		}

		lookupRepo.RxInfo(rollups).then(okLookupRx, errInitLoad);

		function okLookupRx(items) {

			// save rollup affs array
			var rollupAffs = [];
			items = Array.isArray(items) ? items : [];
			if(items.length > 0) {
				for(var i = 0; i < items.length; i++) {
					rollupAffs.push({
						RXID:items[i].NickName,
						RxName: items[i].Name,
						RxShortName: items[i].ShortName
					});
				}

				vm.RollupDroplist = utilSvc.aff.rxDroplist(rollupAffs);
				vm.query.UserHasRxRollup = true;
			}
			
			rollupReturnExists(rollupAffs, vm.query.RxRollup.val);
			initFinalize();
		}
	}

	function findAffRollupParents(affs) {
		// get ROLLUP parents from affiliations

		var parentId = '',
			result = [];
		for(var i = 0; i < affs.length; i++) {
			parentId = affs[i].RxParent;
			if(validSvc.isText(parentId) && result.indexOf(parentId) < 0) {
				result.push(parentId);
			}
		}
		return result;
	}

	function rollupReturnExists(affs, rollupId) {
		// on ROLLUP return visit, check rollup exists in droplist options
		if(vm.query.SearchType == 'ROLLUP' && _returnVisit && utilSvc.aff.findRx(affs, rollupId).length < 1) {
			_returnVisit = false;
			vm.query.RxRollup.val = 'NONE';
		}
	}

	function errInitLoad(r) {
		vm.RollupDroplist = utilSvc.ng.droplistNONE();
		vm.query.RxRollup = validSvc.newProp('NONE');
		vm.query.UserHasRxRollup = false;

		if(!!r) {
			errSvc.warn('uninvoicedItemsCtl.errInitLoad, issue loading TPA and ROLLUP details', r.status, utilSvc.http.safeResponse(r));
		}
	}

	function initFinalize() {
		// all ASYNC loads complete, enable UI
		
		// reset query state
		queryChangeSearchType(vm.query.SearchType);
		
		// fire date control event after widget scope is setup
		$timeout(function() {
			adjustDateOptions(vm.query.CE.val, vm.query.RX.val, vm.query.DateRangeMode);
		}, 300);
	}


	/**
	 *    VIEW MODEL
	 */

	function displayVM(repoData, tooMany) {

		// build the display view model (from empty or from repo data)
		var items = Array.isArray(repoData) ? repoData : [];

		vm.showAutoOrders = false;
		vm.showReview = false;

		// entity title
		var entityTitle = 'Vendor',
			usingALL = vm.query.secondary.val == 'ALL',
			entityVal = 'VEN',
			item = {};

		switch(vm.query.SearchType) {
			case 'IND':
				if(usingALL) {
					entityVal = _primaryProp == 'RX' ? 'CE/VEN' : 'RX/VEN';
					entityTitle = _primaryProp == 'RX' ? 'CEID / Vendor' : 'Pharmacy / Vendor';
				}
				break;
			case 'ROLLUP':
			case 'PROGADMIN':
				entityVal = 'CE/VEN';
				entityTitle = 'CEID / Vendor';
				break;
			default:
				entityVal = 'VEN';
				entityTitle = 'Vendor';
		}

		// clean up incoming data
		for(var i = 0; i < items.length; i++) {
			item = items[i];
			item.uniqueId = i;

			// nullify golang "zero" dates
			item.PlaceDate = validSvc.isDate(item.PlaceDate) ? item.PlaceDate : null;
			item.AckDate = validSvc.isDate(item.AckDate) ? item.AckDate : null;
			item.InvoiceDate = validSvc.isDate(item.InvoiceDate) ? item.InvoiceDate : null;
			item.CancelDate = validSvc.isDate(item.CancelDate) ? item.CancelDate : null;
			item.OrderCategory = orderCategoryTitle(item.Category);
			item.IsISP = item.IsISP ? 'YES' : 'NO';
			
			item.DirectReplenish = item.DirectReplenish ? 'YES' : 'NO';
			if (item.OrderType == 'SPLIT' || item.OrderType == 'MANUAL SPLIT' || validSvc.isText(item.ParentId)) {
				item.OrderCategory = "N/A";
			}

			item.OrderType = (!!item.Manual ? 'MANUAL ':'') + item.OrderType;

			// auto orders
			if(!vm.showAutoOrders && !!item.AutoOrdered) {
				vm.showAutoOrders = true;
			}

			// approvals
			item.Review = item.ObjectState == 'REVIEW' || item.ObjectState == 'PRESPLIT';
			if(!vm.showReview && item.Review) {
				vm.showReview = true;
			}

			// build the EntityTxt
			switch(entityVal) {
				case 'VEN':
					item.EntityTxt = item.VENID;
					break;
				case 'CE/VEN':
					item.EntityTxt = item.CEID + ': ' + item.VENID;
					break;
				case 'RX/VEN':
					item.EntityTxt = item.RxShortName + ': ' + item.VENID;
					break;
			}
		}

		return {
			Items: [],
			DataItems: items,
			TooMany: !!tooMany,
			EntityTitle: entityTitle
		};

	}


	/**
	 *    CUSTOM COLUMN FILTER: checked orders
	 */

	function checkedFilters(orderItem) {

		// ng-repeat filter, used inside check each order item against date checkboxes

		if(!orderItem.PlaceDate && vm.flt.Checked.Place) {
			return false;
		}
		if(!orderItem.AckDate && vm.flt.Checked.Ack) {
			return false;
		}
		if(!orderItem.InvoiceDate && vm.flt.Checked.Invoice) {
			return false;
		}
		if(!orderItem.CancelDate && vm.flt.Checked.Cancel) {
			return false;
		}

		// hide all manual orders if auto order checkbox is checked
		if(vm.showAutoOrders && vm.flt.Checked.AutoOrdered && !orderItem.AutoOrdered) {
			return false;
		}

		// hide all orders if not in REVIEW state
		if(vm.showReview && vm.flt.Checked.Review && !orderItem.Review) {
			return false;
		}

		return true;

	}


	/**
	 *    FILTER
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			vm.tbl.Items = filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					saveViewState(vm.query, vm.flt);
				}
			},1000);

		}, delayTime);

	}

	function filterList(dataItems, flt) {

		// filter dataItems using incoming filter object
		// note: 	this function has no concept of waiting or debouncing, it will run every time its called immediately
		// 			this is called on init or tab load, see filterChange() for UI debouncing/blocking/isBusy functionality

		var newItems = [];

		// custom checkbox filters
		if(!!dataItems && dataItems.length > 0) {
			newItems = $filter('filter')(dataItems, checkedFilters);
		}

		// call inherited filter (always call this, it also modifies the vm.flt paging properties)
		return vm.filterList(newItems, flt);

	}


	/**
	 *    QUERY FILTER SWAP
	 */

	function queryFilterSwap() {

		if(vm.isWaiting) {
			return;
		}

		// toggle the primary / secondary query fields
		$rootScope.User.CE = _primaryProp == 'CE' ? vm.query.primary.val : vm.query.secondary.val;
		$rootScope.User.RX = _primaryProp == 'RX' ? vm.query.primary.val : vm.query.secondary.val;
		_primaryProp = _primaryProp == 'CE' ? 'RX' : 'CE';

		// update rootscope and session
		$rootScope.User.FilterSwap.OrderNew = _primaryProp;
		sessionRepo.set('User', $rootScope.User);

		// clear state
		queryChange();
		sessionRepo.clearKey('vs-orders-list');
		init();

		// save user pref to db
		$timeout(function() {
			prefsRepo.save('FILTERSWAP', angular.toJson($rootScope.User.FilterSwap)).then(okSavePref, errSavePref);
		}, 2000);
	}

	function okSavePref(r) {
		// no action
	}

	function errSavePref(r) {
		if(!!r) {
			errSvc.warn('Unknown api error during filter swap preference save', 'orderListCtl.filterSwap', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    QUERY CHANGE
	 */

	function queryChange(keepSearchOptions) {
		if(!vm.init) {
			vm.action = '';
			vm.tbl = {
				Items: [],
				DataItems: []
			};			
			vm.flt = vm.resetFilters(vm.flt);
			vm.flex = vm.flexInit();
			$scope.$broadcast('widget.paging');

			//reset search options
			if(!!!keepSearchOptions) {
				vm.query.title = '';
				vm.query.OrderCategory = validSvc.newProp('STANDARD');
				vm.query.OrderCategory.chk = false;
			}
		}
	}

	function queryChangeSearchType(searchType) {
		if(vm.isWaiting) {
			return;
		}

		vm.query.SearchType = searchType;

		switch(searchType) {
			case 'IND':
				vm.query.RxRollup.fail = '';
				vm.query.ProgramAdmin.fail = '';
				queryChangePrimary();
				break;
			case 'ROLLUP':
				vm.query.primary.fail = '';
				vm.query.secondary.fail = '';
				vm.query.ProgramAdmin.fail = '';
				queryChangeRollup();
				break;
			case 'PROGADMIN':
				vm.query.primary.fail = '';
				vm.query.secondary.fail = '';
				vm.query.RxRollup.fail = '';
				queryChangeProgAdmin();
				break;
			default:
				throw new Error('orderListCtl.queryChangeSearchType, unknown type: ' + searchType);
		}
	}

	function queryChangePrimary() {
		// IND search type has primary / secondary selectors

		queryChange();

		vm.query.primary.fail = validSvc.isEntity(vm.query.primary.val, false, _isRxUser) ? 'no' : 'yes'; // RX user can have ALL primary
		if(vm.query.primary.fail == 'yes') {
			return;
		}

		var affs = getAffs();

		// primary is RX?
		if(_primaryProp == 'RX') {
			vm.query.RX = validSvc.newProp(vm.query.primary.val);

			// limit affs to this RX
			if(vm.query.RX.val != 'ALL') {
				affs = utilSvc.aff.findRx(affs, vm.query.primary.val);
			}

			// CE options
			vm.secondaryDroplist = utilSvc.aff.ceDroplist(affs, '', false, true); // ALL option
			vm.query.secondary = vm.query.secondary.val == 'ALL' ? validSvc.newProp('ALL') : utilSvc.ng.droplistAutoselect(vm.secondaryDroplist, vm.query.secondary.val);
			if(vm.query.secondary.val == 'NONE') {
				vm.query.secondary.val = 'ALL';
			}

			vm.query.CE = validSvc.newProp(vm.query.secondary.val);
		}
		else {

			// primary is CE
			vm.query.CE = validSvc.newProp(vm.query.primary.val);

			// limit affs to this CE
			if(vm.query.CE.val != 'ALL') {
				affs = utilSvc.aff.findCe(affs, vm.query.primary.val);
			}

			// RX options
			vm.secondaryDroplist = utilSvc.aff.rxDroplist(affs, '', false, true); // ALL option
			vm.query.secondary = vm.query.secondary.val == 'ALL' ? validSvc.newProp('ALL') : utilSvc.ng.droplistAutoselect(vm.secondaryDroplist, vm.query.secondary.val);
			if(vm.query.secondary.val == 'NONE') {
				vm.query.secondary.val = 'ALL';
			}

			vm.query.RX = validSvc.newProp(vm.query.secondary.val);
		}

		queryChangeSecondary();
	}

	function queryChangeSecondary() {
		// IND search type has primary / secondary selectors

		queryChange();

		vm.query.secondary.fail = validSvc.isEntity(vm.query.secondary.val, false, true) ? 'no' : 'yes';
		if(vm.query.secondary.fail == 'yes') {
			return;
		}	

		if(_primaryProp == 'CE') {
			// secondary is RX
			vm.query.RX = validSvc.newProp(vm.query.secondary.val, false, true);
		}
		else {
			// secondary is CE
			vm.query.CE = validSvc.newProp(vm.query.secondary.val, false, true);
		}

		var affs = getAffs();
		if (vm.query.CE.val != 'ALL') {
			affs = utilSvc.aff.findCe(affs, vm.query.CE.val);
		}
		if (vm.query.RX.val != 'ALL') {
			affs = utilSvc.aff.findRx(affs, vm.query.RX.val);
		}
		var rxBizModels = utilSvc.aff.rxModelList(affs);
		vm.query.isCP  = rxBizModels.indexOf('CP') > -1;

		// RX User ALL/ALL check, this constrains date options
		if(!vm.init) {
			adjustDateOptions(vm.query.CE.val, vm.query.RX.val, vm.query.DateRangeMode);
		}
	}

	function adjustDateOptions(ceid, rxid, dtMode) {

		// adjust date options on date range widget
		vm.query.DateRangeList = adjustDateRangeList(vm.query.CE.val, vm.query.RX.val);
		vm.query.DateRangeMode = adjustDateRangeMode(ceid, rxid, dtMode);

		// send mode to date range widget
		$timeout(function() {
			$scope.$broadcast('widget.input.date.range.mode', {mode: vm.query.DateRangeMode, keepDates: true});
		}, 200);
	}

	function dateOptionsNotAllowedForALLALL() {

		// query for CE = ALL and RX = ALL cannot use all date modes

		return [
			'QTD',
			'QTR',
			'QTDLAST',
			'CUSTOM92'
		];
	}

	function adjustDateRangeMode(ceid, rxid, dtMode) {

		var result = dtMode;

		if(ceid == 'ALL' && rxid == 'ALL') {
			var notAllowed = dateOptionsNotAllowedForALLALL();
			if(notAllowed.indexOf(vm.query.DateRangeMode) > -1) {
				result = 'MTD'; // set back to default
			}
		}
		else if(dtMode == 'CUSTOM30') {
			result = 'CUSTOM92';
		}

		return result;
	}

	function adjustDateRangeList(ceid, rxid) {
		var result = [];

		if(ceid == 'ALL' && rxid == 'ALL') {
			result = utilSvc.widget.dateRangeList(dateOptionsNotAllowedForALLALL());
			result.push({label:'Custom Date Range (30 day max)', value: 'CUSTOM30'});
		}
		else {
			result = utilSvc.widget.dateRangeList([]);
		}

		return result;
	}

	function dateRangeChange(dtMode, isValid) {
		queryChange();

		vm.query.DateRangeMode = dtMode;
		vm.query.DateRangeValid = isValid;

		// try query
		if(_returnVisit) {
			_returnVisit = false;
			querySubmit();
		}
		vm.init = false;
	}

	function queryChangeRollup() {
		// ROLLUP search type
		if(vm.isWaiting) {
			return;
		}
		queryChange();
		vm.query.RxRollup.fail = validSvc.isRX(vm.query.RxRollup.val) ? 'no' : 'yes';
	}

	function queryChangeProgAdmin() {
		// PROGADMIN: search type
		if(vm.isWaiting) {
			return;
		}
		queryChange();
		vm.query.ProgramAdmin.fail = vm.query.ProgramAdmin.val == 'NONE' ? 'yes' : 'no';
	}

	/**
	 *    QUERY SUBMIT
	 */

	function queryValid(query) {

		var ceRxOK = true,
			rollupOK = true,
			progAdminOK = true;
		switch(query.SearchType) {
			case 'IND':
				// re-evaluate CE/RX
				if(_primaryProp == 'CE') {
					query.CE.fail = validSvc.isCE(query.CE.val, false, _isRxUser) ? 'no' : 'yes';
					query.RX.fail = validSvc.isRX(query.RX.val, false, true) ? 'no' : 'yes';
				}
				else {
					query.RX.fail = validSvc.isRX(query.RX.val, false, _isRxUser) ? 'no' : 'yes';
					query.CE.fail = validSvc.isCE(query.CE.val, false, true) ? 'no' : 'yes';
				}
				ceRxOK = query.CE.fail == 'no' && query.RX.fail == 'no';
				break;
			case 'ROLLUP':
				rollupOK = validSvc.isRX(vm.query.RxRollup.val);
				vm.query.RxRollup.fail = rollupOK ? 'no' : 'yes';
				break;
			case 'PROGADMIN':
				progAdminOK = vm.query.ProgramAdmin.val != 'NONE';
				vm.query.ProgramAdmin.fail = progAdminOK ? 'no' : 'yes';
				if(progAdminOK) {
					// populate RXIDs for this ProgAdmin
					var affs = getAffs();
					affs = utilSvc.aff.findProgAdmin(affs, vm.query.ProgramAdmin.val);
					var rxList = utilSvc.aff.rxList(affs);
					if(rxList.length > 0) {
						vm.query.ProgramAdmin.rxids = rxList;
					}
					else {
						vm.query.ProgramAdmin.fail = 'yes';
						console.log('Program admin has no pharmacies in user affiliations');
					}
				}
				break;
			default:
				throw new Error('orderListCtl.queryValid, unknown search type: ' + query.SearchType);
		}

		// optional
		// OrderCategory every value is valid

		return ceRxOK && rollupOK && progAdminOK && query.DateRangeValid;
	}

	function querySubmit() {

		if(vm.isWaiting) {
			return;
		}
		queryChange(true);

		if(!queryValid(vm.query)) {
			if(!vm.init) {
				msgSvc.ok('Cannot Search', 'Check search properties');
			}
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		// search options: only send checked fields
		// tbd...
		
		ordersRepo.getOrderList(vm.query).then(okOrderList, errOrderList);

		function okOrderList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// query was good, save viewstate
			saveViewState(vm.query, vm.flt);

			vm.tbl = displayVM(r.data, r.TooMany);
			vm.tbl.Items = filterList(vm.tbl.DataItems, vm.flt);

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			vm.flt.Ready = true;
			vm.action = 'LIST';

			// force top collapse after good query
			vm.query.title = queryTitle(vm.query);
			vm.flex = vm.flexCollapse(vm.flex, true);
		}

		function errOrderList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('unknown error getting data', 'order.getList', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}


	/**
	 *    GET DETAIL
	 */

	function getDetail(order) {

		// split order type or child of split order
		if((order.OrderType == 'SPLIT' || order.OrderType == 'MANUAL SPLIT' || validSvc.isText(order.ParentId)) && 
		order.ObjectState != 'PRESPLIT' && order.ObjectState != 'QUEUED' && order.ObjectState != 'CANCELLED') {
			var parentId = validSvc.isText(order.ParentId) ? order.ParentId : null;
			$state.go('orders.splitdetail', {id: order.Id, parentId: parentId}, {reload: 'orders.splitdetail'});
		}
		else {
			// edit action depends on current order state
			switch(order.ObjectState) {
				case 'EDIT':
					if(utilSvc.user.hasFeature($scope, 'orders.edit')) {
						$state.go('orders.edit', {id: order.Id}, {reload: 'orders.edit'});
					}
					else {
						$state.go('orders.view', {id: order.Id}, {reload: 'orders.view'});
					}
					break;				
				case 'PRESPLIT':
					if(utilSvc.user.hasFeature($scope, 'orders.edit')) {
						$state.go('orders.presplit', {id: order.Id}, {reload: 'orders.presplit'});
					}
					else {
						$state.go('orders.view', {id: order.Id}, {reload: 'orders.view'});
					}
					break;
				case 'QUEUED':
					$state.go('orders.view', {id: order.Id}, {reload: 'orders.view'});
					break;
				case 'CANCELLED':
					$state.go('orders.cancel', {id: order.Id}, {reload: 'orders.cancel'});
					break;
				case 'PLACED':
					$state.go('orders.place', {id: order.Id}, {reload: 'orders.place'});
					break;
				default:
					throw new Error('orderListCtl.getDetail, unknown order status: ' + order.ObjectState);
			}

		}

	}


	/**
	 *    EXCEL
	 */

	function getExcel() {

		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		var q = vm.query;
		_pendingExcelFilename = 'Verity-' + queryFilename(q) + '-OrderList.xlsx';
		ordersRepo.getOrderListExcel(vm.query, _pendingExcelFilename).then(okServerExcel, errServerExcel);

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Create Excel Error', 'ordersListCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 * 	FLEX TOP
	 */

	function flexTopExpand() {
		// user opened search query, reset list display, show search expanded
		if(vm.init || vm.isWaiting) {
			return;
		}
		queryChange(true);
	}


	/**
	 *    HELPERS
	 */

	function queryTitle(q) {
		// helper to generate query title when flextop closed
		
		switch(q.SearchType) {
			case 'IND':
				// CE/RX titles to handle ALL value or NONE
				var ceTitle = q.CE.val == 'ALL' ? 'All Facilities' : q.CE.val,
					rxTitle = q.RX.val == 'ALL' ? 'All Pharmacies' : q.RX.val;
				if(_primaryProp == 'CE') {
					return ceTitle + ' / ' + rxTitle;
				}
				else {
					return rxTitle + ' / ' + ceTitle;
				}
				break;
			case 'ROLLUP':
				return 'Rollup: ' + utilSvc.ng.droplistLabel(vm.RollupDroplist, q.RxRollup.val);
			case 'PROGADMIN':
				return 'Program Admin: ' + utilSvc.ng.droplistLabel(vm.ProgAdminDroplist, q.ProgramAdmin.val);
			default:
				throw new Error('orderListCtl.queryTitle, unknown Search Type: ' + q.SearchType);
		}
	}

	function queryFilename(q) {
		// helper to generate query filename for Excel
		var result = '';
		switch(q.SearchType) {
			case 'IND':
				result = _primaryProp == 'CE' ? q.CE.val : q.RX.val;
				var secondaryVal = _primaryProp == 'CE' ? q.RX.val : q.CE.val;
				if(secondaryVal != 'ALL') {
					result += '-' + secondaryVal;
				}
				return result;
			case 'ROLLUP':
				return utilSvc.ng.droplistLabel(vm.RollupDroplist, q.RxRollup.val);
			case 'PROGADMIN':
				return utilSvc.ng.droplistLabel(vm.ProgAdminDroplist, q.ProgramAdmin.val);
			default:
				throw new Error('orderListCtl.queryFilename, unknown Search Type: ' + q.SearchType);
		}
	}

	function saveViewState(query, flt) {
		if(!!!query || !!!flt) {
			return;
		}

		var q = {
			PrimaryProp: _primaryProp,
			SearchType: query.SearchType,
			DateRangeMode: query.DateRangeMode,
			StartDate: query.StartDate.val,
			EndDate: query.EndDate.val
		};

		switch(query.SearchType) {
			case 'IND':
				q.CE = query.CE.val;
				q.RX = query.RX.val;
				break;
			case 'ROLLUP':
				q.RxRollup = query.RxRollup.val;
				break;
			case 'PROGADMIN':
				q.ProgramAdmin = query.ProgramAdmin.val;
				break;
			default:
				throw new Error('orderListCtl.saveViewState, unknown type: ' + query.SearchType);
		}

		// optional property
		if(query.OrderCategory.chk) {
			q.OrderCategory = query.OrderCategory.val;
		}

		sessionRepo.set('vs-orders-list', {
			query: q,
			flt: flt
		});
	}

	function orderCategoryTitle(orderCat) {
		switch(orderCat) {
			case 'STANDARD':
				return 'Standard';
			case 'DROPSHIP':
				return 'Drop-ship';
			case 'SPECIALTY':
				return 'Specialty';
			case 'ASSAY':
				return 'Assay';
			default:
				return 'Standard';				
		}
	}
}
 
ordersNewCtl.$inject = ['$window', '$state', '$rootScope', '$scope', '$timeout', 'ordersRepo', 'prefsRepo', 'sessionRepo', 'lookupRepo', 'msgSvc', 'utilSvc', 'validSvc', 'errSvc'];
angular
.module('espui.orders')
.controller('OrdersNewCtl', ordersNewCtl);


/* @ngInject */
function ordersNewCtl($window, $state, $rootScope, $scope, $timeout, ordersRepo, prefsRepo, sessionRepo, lookupRepo, msgSvc, utilSvc, validSvc, errSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _onOrderQty = [],
		_pendingOrder = {},
		_pendingExcelFilename = '',
		_primaryProp = 'CE',
		_pagingEventListener = null,
		_refreshPagingSize = null,
		_ceOwnUseAffs = [],
		_pendingOverrideIdx = -1;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.isSEQ = false;
	vm.isVeriSaveOnly = false;

	// droplists
	vm.primaryDroplist = [];
	vm.secondaryDroplist = [];
	vm.VenDroplist = [];
	vm.AcctTypeDroplist = [];
	vm.OrderCategoryDroplist = [];
	vm.DodPharmaDroplist = [];
	vm.DodBillingDroplist = [];
	vm.DirectRepShipToDroplist = [];
	vm.AccumRxDroplist = [];

	// query
	vm.query = {};
	vm.queryChangePrimary = queryChangePrimary;
	vm.queryChangeSecondary = queryChangeSecondary;
	vm.queryChangeVEN = queryChangeVEN;
	vm.queryChangeAcctType = queryChangeAcctType;
	vm.queryChangeNdcFilter = queryChangeNdcFilter;
	vm.queryChangeOrderCategory = queryChangeOrderCategory;
	vm.queryChangeDOD = queryChangeDOD;
	vm.queryChangeDirectRep = queryChangeDirectRep;
	vm.queryChangeDirectRepShipTo = queryChangeDirectRepShipTo;
	vm.queryChangeDirectRepProfit = queryChangeDirectRepProfit;
	vm.queryChangeISP = queryChangeISP;
	vm.queryChangeAccumRx = queryChangeAccumRx;

	// query filter swap
	vm.queryFilterSwap = queryFilterSwap;

	// tabs
	vm.activeTab = '';
	vm.order = {};
	vm.accum = {};
	vm.tabChange = tabChange;

	// order repo
	vm.getAvailableItems = getAvailableItems;
	vm.orderCreate = orderCreate;
	vm.orderUpdate = orderUpdate;

	// order status
	vm.orderCancel = orderCancel;
	vm.orderPlace = orderPlace;
	vm.orderSubmitSplit = orderSubmitSplit;

	// accum order and cart tab
	vm.orderEditQty = orderEditQty;
	vm.orderAddItem = orderAddItem;
	vm.orderRemoveItem = orderRemoveItem;
	vm.orderAddAll = orderAddAll;
	vm.orderRemoveAll = orderRemoveAll;
	vm.cartEditQty = cartEditQty;

	// surplus
	vm.surplusAddQty = surplusAddQty;
	vm.surplusRemoveQty = surplusRemoveQty;
	vm.surplusAddAll = surplusAddAll;
	vm.surplusRemoveAll = surplusRemoveAll;

	// check filters
	vm.chkHasSurplus = false;
	vm.chkHasAccum = true;
	vm.chkFilterToggle = chkFilterToggle;
	vm.chkFilters = chkFilters;

	// cart animation
	vm.addToCart = {
		items: [],
		show: false,
		run: false,
		txt: ''
	};

	// catalog (all inherited vm functionality should be inherited by controller not a sub-object, removed it as redundant)
	vm.catalog = {};
	vm.catalogSearch = catalogSearch;
	vm.catalogFilterChange = catalogFilterChange;

	// excel
	vm.getExcel = getExcel;

	// popup
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.savePopup = savePopup;
	vm.closePopup = closePopup;

	// help text
	vm.helpLinkClick = helpLinkClick;

	// presplit
	vm.presplitToggleItem = presplitToggleItem;
	vm.presplitAddItem = presplitAddItem;
	vm.presplitRemoveItem = presplitRemoveItem;
	vm.presplitChangeAllItems = presplitChangeAllItems;

	// verisave / multi vendor
	vm.optimizeEdit = optimizeEdit;
	vm.optimizeApplyToOrder = optimizeApplyToOrder;

	// add invoice
	vm.canAddInvoice = false;
	vm.everInvoiced = false;

	// assay
	vm.assay = {};
	vm.assayEdit = assayEdit;
	vm.assayAddToCart = assayAddToCart;
	vm.assayRemoveFromCart = assayRemoveFromCart;

	vm.navToFeature = navToFeature;

	/**
	 * 	EVENTS
	 * 	note this was added just for pre-split but could be for any table by checking evtData.id
	 * 	moved it up to controller level
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function (event, evtData) {
		event.stopPropagation();
		if (!!vm.popup.ready) {
			// exit if table is gone
			if (!vm.catalog.flt.Ready || !Array.isArray(vm.catalog.tbl.Items) || vm.catalog.tbl.Items.length < 1) {
				return;
			}

			// adjust Page or PageSize property
			vm.catalog.flt[evtData.propName] = parseInt(evtData.value);
			catalogFilterChange(true);
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		vm.init = true;

		// set action from route
		switch($state.current.name) {
			case 'orders.new':
				vm.action = 'CREATE';
				break;
			case 'orders.edit':
				vm.action = 'UPDATE';
				break;
			case 'orders.presplit':
				vm.action = 'PRESPLIT';
				break;
			case 'orders.place':
			case 'orders.cancel':
			case 'orders.view':
				vm.action = 'HISTORY';
				break;

			default:
				throw new Error('ordersNewCtl.init, unknown router state: ' + $state.current.name);
		}

		vm.isVeriSaveOnly = !!$scope.User.VeriSaveOnly;

		vm.query = initQuery();
		initTabs();

		initFilterSwap(vm.query);
		
		// CREATE
		if(vm.action == 'CREATE') {

			// main title
			$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
			
			// ASYNC: get own use property from all ces
			initCeOwnUse(getAffs());
		}
		else {

			var params = $state.params;

			// get order id
			if(!!!params || !validSvc.isText(params.id)) {
				throw new Error('orderNewCtl.init, missing params.id on route: ' + $state.current.name);
			}

			$state.current.routeInfo = $state.current.routeInfo || {};
			var routeInfo = angular.fromJson(angular.toJson($state.current.routeInfo));

			// breadcrumb link?
			if(!!params.breadcrumb) {

				// clear breadcrumb from app state cache
				$rootScope.$emit('espui>route.reset', {route: $state.current.name});

				routeInfo.breadcrumb = params.breadcrumb;
			}

			// main title
			$scope.$emit('shared.main.setInfo', routeInfo);

			// load order
			getOrderDetail($state.params.id);

		}

		vm.init = false;

	}

	function getAffs() {

		// user type drives aff list

		var accts = [],
			bizModels = [];
		switch(vm.query.UserType) {

			case 'VERITY':
			case 'VERITYSA':
				accts = ['340B', 'GPO', 'WAC', 'IND', 'OWN'];
				bizModels = ['CP', 'SPLIT', 'SPLITMATCH'];
				break;
			case 'CE':
				accts = ['340B', 'GPO', 'WAC', 'IND', 'OWN'];
				bizModels = ['CP', 'SPLIT', 'SPLITMATCH']; // CE can create CP orders only if they have permission
				break;
			default:
				accts = ['340B', 'IND','OWN'];
				bizModels = ['CP'];
				break;
		}

		// ordering affiliates
		var affs = utilSvc.aff.findStatus($scope.User.AffList, ['ACTIVE']);
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
		affs = utilSvc.aff.findRxModel(affs, bizModels);
		affs = utilSvc.aff.findVenType(affs, accts, true);
		if(vm.query.UserType == 'CE' && vm.action == 'CREATE') {
			affs = utilSvc.aff.findCeCanCreateCpList(affs);
		}

		// exit if user can't see any pharmacy
		if (!Array.isArray(affs) || affs.length < 1) {
			msgSvc.okAsync('Pharmacies Not Available', 'None of your affiliations allow order creation. Contact your Verity administrator.', 'orderNewCtl.getAffs').then(goHome, goHome);
			return [];
		}

		function goHome() {
			$state.go('home');
		}

		return affs;
	}

	function initQuery() {
		var q = ordersRepo.queryVM();

		// add order category to query
		q.RxCP = false;
		vm.OrderCategoryDroplist = [
			{label: 'Standard', value: 'STANDARD'},
			{label: 'Drop-ship', value: 'DROPSHIP'},
			{label: 'Specialty', value: 'SPECIALTY'},
			{label: 'Assay', value: 'ASSAY'}
		];
		q.OrderCategory = validSvc.newProp('STANDARD');
		q.OrderCategory.chk = 'no';

		// add DOD to query
		q.isDOD = false;
		vm.DodPharmaDroplist = [
			{label: 'Brand/Generic', value: 'BG'},
			{label: 'Specialty', value: 'DODSPECIALTY'}
		];
		vm.DodBillingDroplist = [
			{label: 'Billable', value: 'BILL'},
			{label: 'Credit Balance', value: 'CREDIT'}
		];
		q.DodPharmaType = 'BG'; // no valdation prop needed
		q.DodBillingType = 'BILL'; // no valdation prop needed

		// direct replenish
		vm.DirectRepShipToDroplist = [
			{label: 'Choose a Destination', value: 'NONE'},
			{label: 'Ship To Pharmacy', value: 'SHIP'},
			{label: 'Keep At Facility', value: 'KEEP'}
		];
		q.hasDirectRep = false; // affiliation supports direct replenish
		q.usingDirectRep = false; // query and order is using direct replenish
		q.DirectRep = newCheckProp('NONE');
		q.DirectRepProfit = 'yes';

		// ISP
		q.IsISP = 'no';

		// accumulating pharmacy (aff lookup sets this to true)
		q.useAccumRx = false;
		q.AccumRXID = 'NONE';

		return q;
	}

	function initTabs() {
		vm.order = orderVM();
		vm.accum = accumVM();
		vm.assay = assayVM();
		closePopup(false);
	}

	function initFilterSwap(query) {

		// transfer ceid/rxid from query into filter swap primary/secondary format

		// get saved user pref
		_primaryProp = $rootScope.User.FilterSwap.OrderNew;
		if(_primaryProp != 'RX' && _primaryProp != 'CE') {
			_primaryProp = 'CE'; // default
		}

		query.primaryLabel = _primaryProp == 'RX' ? 'Pharmacy' : 'Facility';
		query.primary = validSvc.newProp(_primaryProp == 'RX' ? query.RX.val : query.CE.val);
		query.primaryName = '';
		vm.primaryDroplist = utilSvc.ng.droplistNONE();

		query.secondaryLabel = _primaryProp == 'RX' ? 'Facility' : 'Pharmacy';
		query.secondary = validSvc.newProp(_primaryProp == 'RX' ? query.CE.val : query.RX.val);
		query.secondaryName = '';
		vm.secondaryDroplist = utilSvc.ng.droplistNONE();
	}

	function initPrimaryDroplist(query) {
		// CREATE uses query droplists, setup Primary droplist

		if(_primaryProp == 'RX') {
			vm.primaryDroplist = utilSvc.aff.rxDroplist(getAffs());
		}
		else {
			vm.primaryDroplist = utilSvc.aff.ceDroplist(getAffs());
		}
		query.primary = utilSvc.ng.droplistAutoselect(vm.primaryDroplist, query.primary.val);
	}

	function initCeOwnUse(affs) {
		_ceOwnUseAffs = [];

		var ceList = utilSvc.aff.ceList(affs);
		if (ceList.length > 0) {
			lookupRepo.CeInfo(ceList).then(okCeLookup, errCeLookup);
		}
		else {
			// no CEs found
			initFinalize();
		}

		function okCeLookup(r) {
			var items = Array.isArray(r) ? r : [],
				ownUseAffs = [],
				ii = 0,
				ceid = '',
				rxid = '';
			
			// loop CEs
			for (var i=0; i<items.length; i++) {
				if(items[i].OwnUseProgram) {
					ownUseAffs = utilSvc.aff.findCe(affs,items[i].NickName);

					// loop ce affils
					if(ownUseAffs.length > 0) {
						for(ii = 0; ii < ownUseAffs.length; ii++) {
							ceid = ownUseAffs[ii].CEID;
							rxid = ownUseAffs[ii].RXID;

							// does this aff have an OWN vendor
							if(utilSvc.aff.venOptions(ownUseAffs, ceid, rxid, ['OWN'], true).length > 0) {
								_ceOwnUseAffs.push({CEID:ceid, RXID:rxid});
							}
						}
					}
				}
			}

			initFinalize();
		}

		function errCeLookup(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;
			if(!!r) {
				errSvc.error('Unknown ce own use response', 'orders.new.ctl.celookup', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function affLookup(ceid, rxid, rollup) {
		// used to get accumulating pharmacy info
		lookupRepo.AffInfo([ceid],[rxid]).then(okAffLook, errAffLook);

		function okAffLook(r) {
			if(!Array.isArray(r) || r.length != 1) {
				errAffLook({status:200, error:'Affiliation lookup returned invalid array', response:r});
				return;
			}

			vm.query.ReviewSubstitute = r[0].ReviewSubstitute;
			if (!validSvc.isText(rollup)) { // adding this to not process rollups below
				return;
			}
			// both CE and RX allow alt accumulation
			if(r[0].CeAltAccum && r[0].RxAltAccum) {
				var affs = utilSvc.aff.findStatus(utilSvc.aff.findCe($scope.User.AffList,ceid),['ACTIVE']); // active affiliation to ceid
				affs = utilSvc.aff.findRxParent(affs, rollup); // has same rollup parent
				// remove self from options
				var affOptions = [];
				affs.forEach(function(aff){
					if(aff.RXID != rxid) {
						affOptions.push(aff);
					}
				});
				if(affOptions.length > 0) {
					vm.query.useAccumRx = true;
					vm.AccumRxDroplist = utilSvc.aff.rxDroplist(affOptions);
					vm.AccumRxDroplist[0].label = utilSvc.aff.rxShortNameByIdLookup(rxid); // NONE is order pharmacy
				}
			}
		}

		function errAffLook(r) {
			if(!!r) {
				errSvc.error('Unknown ce own use response', 'orders.new.ctl.celookup', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function initFinalize() {
		// all ASYNC loads complete, enable UI
		vm.isWaiting = false;
		msgSvc.wait(false);
		vm.init = false;
		initPrimaryDroplist(vm.query);
		queryChangePrimary();
	}


	/**
	 *    DISPLAY VIEW MODELS
	 */

	function orderVM(data) {

		// order tab
		// note: this is only called once after get order detail for UPDATE and HISTORY orders

		data = data || {};
		_onOrderQty = [];
		var hasCII = false,
			hasSpecialty = false,
			item = {};
		vm.canAddInvoice = false;
		vm.everInvoiced = false;

		// derive order category
		var orderCat = validSvc.isText(data.Category) ? data.Category : 'STANDARD';
		var accumSearchAll = orderCat == 'STANDARD' ? !!data.AccumSearchAll : false;

		// setup order items
		var items = Array.isArray(data.Items) ? data.Items : [],
			isPreSplit = vm.action == 'PRESPLIT',
			isAssayOrder = orderCat == 'ASSAY',
			dtNowId = Date.now().toString(),
			ii = 0,
			logItem = {};

		// presplit counts
		var NoVerisaveCount = 0,
			NoMultiVendorCount = 0,
			hasOptimize = false;

		for(var i = 0; i < items.length; i++) {
			item = items[i];
			item.uniqueId = 'OID' + dtNowId + '-' + i.toString();

			// If order is pre-split, validation done
			if(isPreSplit) {
				hasOptimize = false;

				NoVerisaveCount += item.NoVerisaveSwap ? 1 : 0;
				NoMultiVendorCount += item.NoMultiVendorSwap ? 1 : 0;
				item.UserUnitsEdit = item.UserUnits;

				// build hover text
				var vsTitle = item.NoVerisaveSwap ? 'NO VERISAVE' : 'VERISAVE',
					mvTitle = item.NoMultiVendorSwap ? 'NO MULTI VENDOR' : 'MULTI VENDOR',
					optimize = item.Optimize || {};

				// user chose specific Verisave optimizations
				if(!item.NoVerisaveSwap && validSvc.isText(optimize.ItemCode)) {
					hasOptimize = true;
					vsTitle += ' Optimized to NDC: ' + optimize.ItemCode;
					if(validSvc.isText(optimize.VenDrugCode)) {
						vsTitle += ' VIN: ' + optimize.VenDrugCode;
					}
				}

				// user chose a specific Multi Vendor
				if(!item.NoMultiVendorSwap && validSvc.isText(optimize.Vendor)) {
					hasOptimize = true;
					mvTitle += ' Optimized to Vendor: ' + optimize.Vendor;
				}

				item.VerisaveTitle = vsTitle;
				item.MultiVendorTitle = mvTitle;
				item.Optimize = hasOptimize ? optimize : undefined;
			}
			else if(isAssayOrder) {
				item.AssayUnits = validSvc.isInteger(item.AssayUnits) ? parseInt(item.AssayUnits) : 0;
				item.AssayQty = validSvc.isInteger(item.ItemUnits) ? parseInt(item.ItemUnits) : 0;
				item.AssayTotalUnits = item.AssayUnits * item.AssayQty;
	
				item.LotExpiration = validSvc.isDate(item.LotExpiration) ? utilSvc.dt.toText(new Date(item.LotExpiration)) : null;
			}
			else {
				// save OnOrder qty before editing starts
				var orderQty = item.ItemUnits;
				if(vm.action != 'HISTORY') {
					_onOrderQty.push({
						ItemCode: item.ItemCode,
						ItemUnits: orderQty
					});
				}
	
				// zero out new accumulation, by default: order all order qty
				item.ItemUnits = 0;
				item.UserUnits = orderQty;
				item.UserUnitsEdit = orderQty;
				if(item.InvoicedUnits < item.UserUnits) {
					vm.canAddInvoice = true;
				}
				if (item.InvoicedUnits > 0) {
					vm.everInvoiced = true;
				}
					
				// no remainder qty
				// note: we won't get a remainder until getAvailable() adds extra accum and surplus
				item.RemainderUnits = 0;
	
				if(!hasCII && !!item.CII) {
					hasCII = true;
				}
				if(!hasSpecialty && !!item.IsSpecialty) {
					hasSpecialty = true;
				}
			}

			item.ChangeLog = Array.isArray(item.ChangeLog) ? item.ChangeLog : [];
			if(isPreSplit) {
				// fix old vs new log format
				for(ii = 0; ii < item.ChangeLog.length; ii++) {
					logItem = item.ChangeLog[ii];
					logItem.ChangeType = validSvc.isText(logItem.ChangeType) ? logItem.ChangeType : 'OLD'; // mark as OLD if empty
				}
			}
		}

		// derive DOD
		var ceid = validSvc.isText(data.CEID) ? data.CEID : 'NONE';
		var isDOD = ceid == 'DODUSA',
			dodPharma = '',
			dodBilling = '';
		if(isDOD) {
			dodPharma = validSvc.isText(data.DodPharmaType) ? data.DodPharmaType : '';
			dodBilling = validSvc.isText(data.DodBillingType) ? data.DodBillingType : '';
		}

		// derive direct replenish
		var isDirectRep = !!data.DirectReplenish;
		var drCeKeep = isDirectRep && !!data.CeKeep ? 'KEEP' : 'SHIP', // default ship to pharmacy
			drProfit = isDirectRep && !!data.SkipProfit ? 'no' : 'yes'; // default use profitability
		var drTitle = drCeKeep == 'SHIP' ? 'Ship To Pharmacy' : 'Keep At Facility';
		drTitle+= ', Use Profitability: ' + drProfit.toUpperCase();
    
		// has CP biz model
		var hasCP = false;
		if (validSvc.isCE(data.CEID) && validSvc.isRX(data.RXID)) {
			var cpAffs = utilSvc.aff.findRx(utilSvc.aff.findCe($rootScope.User.AffList, data.CEID), data.RXID);
			cpAffs = utilSvc.aff.findRxModel(cpAffs, ['CP', 'SPLITMATCH']);
      // some amazing unique string
			hasCP = cpAffs.length > 0;
		}

		return {
      		hasCP : hasCP,
			isAlt: true,
			hasCII: hasCII,
			hasSpecialty: hasSpecialty,
			Items: items,
			Id: validSvc.isText(data.Id) ? data.Id : null,
			CEID: ceid,
			RXID: validSvc.isText(data.RXID) ? data.RXID : 'NONE',
			RxShortName: validSvc.isText(data.RxShortName) ? data.RxShortName : '',
			VENID: validSvc.isText(data.VENID) ? data.VENID : 'NONE',
			AcctType: validSvc.isText(data.AccumGrp) ? data.AccumGrp : '340B',
			Name: validSvc.isText(data.Name) ? data.Name : '',
			Date: validSvc.isDate(data.Date) ? data.Date : '',
			CreatedBy: validSvc.isText(data.CreatedBy) ? data.CreatedBy : '',
			CreatedOn: validSvc.isDate(data.CreatedOn) ? data.CreatedOn : '',
			CancelBy: validSvc.isText(data.CancelBy) ? data.CancelBy : '',
			CancelDate: validSvc.isDate(data.CancelDate) ? data.CancelDate : '',
			ObjectState: validSvc.isText(data.ObjectState) ? data.ObjectState : 'CREATE',
			AutoOrdered: !!data.AutoOrdered,
			SequentialSplit: !!data.SequentialSplit,
			ChangeLog: Array.isArray(data.ChangeLog) ? data.ChangeLog: [],
			UseBestCost: !!data.BestCost,
			UseMultiVendor: !!data.MultiVendor,
			NoVerisaveSwap: NoVerisaveCount > items.length / 2 ? false : true, // verisave all items toggle is opposite of count
			NoMultiVendorSwap: NoMultiVendorCount > items.length / 2 ? false : true, // multivendor all items toggle is opposite of count
			IsSpecialty : !!data.IsSpecialty,
			IsDropShip : !!data.IsDropShip,
			IsISP : !!data.IsISP ? 'YES' : 'NO',
			Category: orderCat,
			CategoryTitle: orderCategoryTitle(orderCat, accumSearchAll),
			AccumSearchAll: accumSearchAll,
			isDOD: isDOD,
			DodPharmaType: dodPharma,
			DodPharmaTitle: isDOD ? utilSvc.ng.droplistLabel(vm.DodPharmaDroplist, dodPharma) : '', // get title from dropdown label
			DodBillingType: dodBilling,
			DodBillingTitle: isDOD ? utilSvc.ng.droplistLabel(vm.DodBillingDroplist, dodBilling) : '', // get title from dropdown label
			DirectReplenish: isDirectRep,
			CeKeep: drCeKeep,
			DirectRepProfit: drProfit,
			DirectRepTitle: drTitle,
			Manual: !!data.Manual,
			ReferencePO: data.ReferencePO,
			AccumRXID: data.AccumRXID,
			AccumRxName: validSvc.isText(data.AccumRXID) ? utilSvc.aff.rxShortNameByIdLookup(data.AccumRXID) : '',
			SortBy: ['ItemCode'],
			Paging: {
				Page: 1,
				Size: $scope.tblPagingSize,
				Total: vm.getTotalPages(items.length, $scope.tblPagingSize),
				TooMany: false
			}
		};

	}

	function accumVM(items) {

		// accumulated tab

		items = Array.isArray(items) ? items : [];

		// parse into accum items
		var accumItems = [],
			accumRow = {},
			hasRef = false,
			usingDirectRep = vm.query.usingDirectRep;
		for(var i = 0; i < items.length; i++) {
			accumRow = items[i];

			// add OnOrder qty (if any)
			var savedQty = onOrderQty(accumRow.ItemCode);
			accumRow.ItemUnits += savedQty;

			// has accumulation
			if(accumRow.ItemUnits > 0) {
				accumRow.OrderAddQty = accumRow.ItemUnits;
				accumRow.BacklogAddQty = accumRow.ItemUnits;
			}

			// has surplus
			if(accumRow.SurplusUnits > 0) {
				accumRow.BacklogRemoveQty = accumRow.SurplusUnits;
			}

			// must have accum or surplus
			if(accumRow.ItemUnits + accumRow.SurplusUnits <= 0) {
				throw new Error('orderNewBCtl.accumVM, no accum or surplus for ndc: ' + accumRow.ItemCode);
			}

			// has 340B ref price
			if(!hasRef && accumRow.RefPrice > 0) {
				hasRef = true;
			}

			// direct replenishment
			if(usingDirectRep) {
				accumRow.CEBlocked = !!accumRow.CEBlocked ? 'YES' : 'NO';
				accumRow.VendorBlocked = !!accumRow.VendorBlocked ? 'YES' : 'NO';
			}

			accumItems.push(accumRow);
		}

		return {
			hasRefPrice: hasRef,
			Items: accumItems,
			SortBy: ['ItemCode'],
			Paging: {
				Page: 1,
				Size: $scope.tblPagingSize,
				Total: vm.getTotalPages(items.length, $scope.tblPagingSize),
				TooMany: false
			}
		};

	}

	function assayVM() {
		// vm.assay is used to display both tabs: ASSAY and ASSAY_ORDER
		// see assayDisplayVM() to see display of ASSAY accum tab and ASSAY_ORDER cart tab

		return {
			totalAssayQty: 0,
			totalAssayUnits: 0,
			Items: [],
			SortBy: ['ItemCode'],
			Paging: {
				Page: 1,
				Size: 0,
				Total: 0
			}
		};
	}

	function ndcCartInfo(ndc) {
		var result = {
			count: 0,
			qty: 0,
			totalUnits: 0,
			isDirty: false
		};
		var items = Array.isArray(vm.order.Items) ? vm.order.Items : [],
			item = {};
		for(var i = 0; i < items.length; i++) {
			item = items[i];
			if(item.ItemCode == ndc) {
				result.count++;
				result.qty = item.AssayQty;
				result.totalUnits = result.totalUnits + (item.AssayQty * item.AssayUnits);
				if(!result.isDirty && item.isDirty) {
					result.isDirty = true;
				}
			}
		}
		return result;
	}

	function ndcAssayAccum(ndc) {
		var items = Array.isArray(vm.accum.Items) ? vm.accum.Items : [],
			item = {};
		for(var i = 0; i < items.length; i++) {
			item = items[i];
			if(item.ItemCode == ndc) {
				return item.ItemUnits;
			}
		}
		return 0;
	}

	function assayDisplayVM(assay, tabName) {
		// display ASSAY accum items or ASSAY_ORDER cart items

		// reset assay display
		assay.Items = [];
		assay.totalAssayQty = 0;
		assay.totalAssayUnits = 0;
		assay.showRemoveBtn = tabName == 'ASSAY_ORDER' && vm.action != 'HISTORY';

		var items = tabName == 'ASSAY' ? vm.accum.Items : vm.order.Items;
		items = Array.isArray(items) ? items : [];

		var item = {},
			dtNowId = Date.now().toString();
		for(var i = 0; i < items.length; i++) {
			item = items[i];

			if(tabName == 'ASSAY') {
				// ASSAY is accum view
				item.uniqueId = 'AID' + dtNowId + '-' + i.toString();  // unique accum id

				// default accum items to 0 (user must fill it in)
				item.AssayQty = 0;
				item.AssayUnits = 0;
				item.AssayTotalUnits = 0;
				item.LotExpiration = '';
				
				var ndcOnOrder = ndcCartInfo(item.ItemCode);
				item.AssayInCart = ndcOnOrder.count;
				item.AssayRemainder = item.ItemUnits;
				item.VenDrugCode = '';

				assay.totalAssayQty += ndcOnOrder.qty;
				assay.totalAssayUnits += ndcOnOrder.totalUnits;
			}
			else {
				// ASSAY_ORDER is cart view
				item.AssayRemainder = ndcAssayAccum(item.ItemCode);

				assay.totalAssayQty += item.AssayQty;
				assay.totalAssayUnits += item.AssayTotalUnits;
			}

			assay.Items.push(item);
		}

		// re-calc paging
		assay.Paging = {
			Page: 1,
			Size: $scope.tblPagingSize,
			Total: vm.getTotalPages(assay.Items.length, $scope.tblPagingSize)
		};

		return assay;
	}


	/**
	 *    QUERY FILTER SWAP
	 */

	function queryFilterSwap() {

		if(vm.isWaiting) {
			return;
		}

		// remember ce/rx before swap
		var x = filterSwapToCERX(vm.query);

		// swap, update scope and session
		_primaryProp = _primaryProp == 'CE' ? 'RX' : 'CE';
		$rootScope.User.FilterSwap.OrderNew = _primaryProp;
		sessionRepo.set('User', $rootScope.User);

		// reset view and query
		initTabs();
		vm.query.CE = validSvc.newProp(x.CE);
		vm.query.RX = validSvc.newProp(x.RX);
		initFilterSwap(vm.query);

		initPrimaryDroplist(vm.query);
		queryChangePrimary();

		$timeout(function() {
			// save user pref to db (run this after get available items runs)
			prefsRepo.save('FILTERSWAP', angular.toJson($rootScope.User.FilterSwap)).then(okSavePref, errSavePref);
		}, 300);

	}

	function okSavePref(r) {
		// no action
	}

	function errSavePref(r) {
		if(!!r) {
			errSvc.warn('Unknown api error during filter swap preference save', 'orderNewCtl.filterSwap', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    QUERY CHANGE EVENTS
	 */

	function queryChange() {

		if(!vm.init) {
			initTabs();
			vm.activeTab = '';
			vm.addToCart.items = []; // stop in-progress animations
		}

	}

	function queryChangePrimary() {

		queryChange();
		vm.secondaryDroplist = utilSvc.ng.droplistNONE();
		vm.VenDroplist = utilSvc.ng.droplistNONE();
		vm.AcctTypeDroplist = utilSvc.ng.droplistNONE();

		// testing: vm.query.primary.val = 'ORD_DR_CE';
		vm.query.primary.fail = validSvc.isEntity(vm.query.primary.val) ? 'no' : 'yes';
		if(vm.query.primary.fail == 'yes') {
			vm.secondary = validSvc.newProp('NONE');
			vm.query.VEN = validSvc.newProp('NONE');
			vm.query.AcctType = validSvc.newProp('NONE');
			resetOrderCategory();
			resetDOD();
			resetDirectRep();
			return;
		}

		var affs = getAffs();

		// primary is RX?
		if(_primaryProp == 'RX') {
			vm.query.RX = validSvc.newProp(vm.query.primary.val);

			// limit affs to this RX
			affs = utilSvc.aff.findRx(affs, vm.query.primary.val);

			// get RX business models
			vm.query.RxBizModels = utilSvc.aff.rxModelList(affs);
			var accts = ['340B','IND'];
			vm.query.RxSplit = false;
			if(vm.query.RxBizModels.indexOf('SPLIT') > -1 || vm.query.RxBizModels.indexOf('SPLITMATCH') > -1) {
				vm.query.RxSplit = true;
				accts.push('GPO');
				accts.push('WAC');
			}

			if(utilSvc.aff.findRx(_ceOwnUseAffs, vm.query.RX.val).length > 0) {
				accts.push('OWN');
			}	

			// limit CE options by RX biz model + vendor accounts
			affs = utilSvc.aff.findVenType(affs, accts, true);

			// CE options
			vm.secondaryDroplist = utilSvc.aff.ceDroplist(affs);
		}
		else {
			vm.query.CE = validSvc.newProp(vm.query.primary.val);

			// RX options
			vm.secondaryDroplist = utilSvc.aff.rxDroplist(affs, vm.query.primary.val);
		}

		vm.query.secondary = utilSvc.ng.droplistAutoselect(vm.secondaryDroplist, vm.query.secondary.val);
		queryChangeSecondary();

	}

	function queryChangeSecondary() {

		queryChange();
		vm.VenDroplist = utilSvc.ng.droplistNONE();
		vm.AcctTypeDroplist = utilSvc.ng.droplistNONE();
		resetOrderCategory();
		resetDOD();
		resetDirectRep();

		vm.query.secondary.fail = validSvc.isEntity(vm.query.secondary.val) ? 'no' : 'yes';
		if(vm.query.secondary.fail == 'yes') {
			vm.query.VEN = validSvc.newProp('NONE');
			vm.query.AcctType = validSvc.newProp('NONE');
			return;
		}

		var affs = getAffs(),
			accts = ['340B','IND'];

		// limit affs to this CE/RX
		var x = filterSwapToCERX(vm.query);
		affs = utilSvc.aff.findCe(affs, x.CE);
		affs = utilSvc.aff.findRx(affs, x.RX);

		// secondary is RX, get RX business models
		if(_primaryProp == 'CE') {
			vm.query.RX = validSvc.newProp(vm.query.secondary.val);

			vm.query.RxSplit = false;
			vm.query.RxBizModels = utilSvc.aff.rxModelList(affs);
			if(vm.query.RxBizModels.indexOf('SPLIT') > -1 || vm.query.RxBizModels.indexOf('SPLITMATCH') > -1) {
				vm.query.RxSplit = true;
			}
		}
		else {
			vm.query.CE = validSvc.newProp(vm.query.secondary.val);
		}

		// include splitting accounts?
		if(vm.query.RxSplit) {
			accts.push('GPO');
			accts.push('WAC');
		}

		if(utilSvc.aff.findCe(_ceOwnUseAffs, vm.query.CE.val).length > 0) {
			accts.push('OWN');
		}

		// VENDOR options
		x = filterSwapToCERX(vm.query);
		vm.VenDroplist = utilSvc.ng.droplist(
			utilSvc.aff.venOptions(affs, x.CE, x.RX, accts, true),
			'',
			'',
			[{label:'Choose a Vendor', value:'NONE'}]);
		vm.query.VEN = utilSvc.ng.droplistAutoselect(vm.VenDroplist, vm.query.VEN.val);

		queryChangeVEN();
	}

	function lookupUseAccumRx(aff) {
		// useAccuRx depends on CE and RX both allowing Alt Accum and RX is a ROLLUP member
    $timeout(function(){
      affLookup(vm.query.CE.val, vm.query.RX.val, aff.RxParent);
    },1000);
	}

	function queryChangeVEN() {

		queryChange('VENDOR');
		vm.AcctTypeDroplist = utilSvc.ng.droplistNONE();
		resetOrderCategory();
		resetDOD();
		resetDirectRep();

		vm.query.VEN.fail = validSvc.isVEN(vm.query.VEN.val) ? 'no' : 'yes';
		if(vm.query.VEN.fail == 'yes') {
			vm.query.AcctType = validSvc.newProp('NONE');
			return;
		}

		// Vendor is valid, build out AcctType options
		var accts = [],
			venOptions = [],
			affs = getAffs(),
			x = filterSwapToCERX(vm.query);
		var ceid = x.CE,
			rxid = x.RX;

		affs = utilSvc.aff.findRx(utilSvc.aff.findCe(affs, ceid), rxid);

		// 340B
		venOptions = utilSvc.aff.venOptions(affs, ceid, rxid, ['340B'], true);
		if(venOptions.indexOf(vm.query.VEN.val) > -1) {
			accts.push('340B');

			// non-split default RX/vendor is 340B
			if(!vm.query.RxSplit) {
				vm.query.AcctType = validSvc.newProp('340B');
			}
		}

		// IND
		venOptions = utilSvc.aff.venOptions(affs, ceid, rxid, ['IND'], true);
		if(venOptions.indexOf(vm.query.VEN.val) > -1) {
			accts.push('IND');
		}

		// SPLIT, add GPO and WAC if found
		if(!!vm.query.RxSplit) {

			// GPO
			venOptions = utilSvc.aff.venOptions(affs, ceid, rxid, ['GPO'], true);
			if(venOptions.indexOf(vm.query.VEN.val) > -1) {
				accts.push('GPO');
			}

			// WAC
			venOptions = utilSvc.aff.venOptions(affs, ceid, rxid, ['WAC'],true);
			if(venOptions.indexOf(vm.query.VEN.val) > -1) {
				accts.push('WAC');
			}
		}

		var ownUseAffs = utilSvc.aff.findRx(utilSvc.aff.findCe(_ceOwnUseAffs, vm.query.CE.val),vm.query.RX.val);
		if(ownUseAffs.length > 0) {
			accts.push('OWN');
		}

		// build droplist
		vm.AcctTypeDroplist = utilSvc.ng.droplist(accts);
		vm.AcctTypeDroplist.unshift({label:'',value:'NONE'});
		vm.query.AcctType = utilSvc.ng.droplistAutoselect(vm.AcctTypeDroplist, vm.query.AcctType.val);
	
		queryChangeAcctType();	
	}
	
	function queryChangeAcctType() {

		if(vm.isWaiting) {
			return;
		}
		queryChange();
		resetOrderCategory();
		resetDOD();
		resetDirectRep();

		vm.query.AcctType.fail = validSvc.isEntity(vm.query.AcctType.val) ? 'no' : 'yes';
		if(vm.query.AcctType.fail == 'yes') {
			return;
		}

		// order category only shown for CP biz model
		var affs = getAffs(),
			x = filterSwapToCERX(vm.query);
		var ceid = x.CE,
			rxid = x.RX;
		affs = utilSvc.aff.findRx(utilSvc.aff.findCe(affs, ceid), rxid);
		var bizModels = utilSvc.aff.rxModelList(affs);

		// order category options shown on UI if affil is CP
		vm.query.RxCP = bizModels.indexOf('CP') > -1;

		// CE is DOD
		vm.query.isDOD = x.CE == 'DODUSA';
		var vens = [];

		// direct replenishment CE-RX-VEN-ACCT
		if(vm.query.RxCP && vm.query.UserType != 'RX') {
			vens = utilSvc.aff.findVen(affs, vm.query.VEN.val);
			vm.query.hasDirectRep = hasDirectReplenish(vens, vm.query.VEN.val);
		}

		// Creidt-based replenishment
		vens = utilSvc.aff.findVen(affs, vm.query.VEN.val);
		vm.query.hasISP = hasISP(vens, vm.query.VEN.val);

		// ASYNC: get alt accum info for this affiliation / account type
		vm.query.useAccumRx = false;
		vm.query.AccumRXID = 'NONE';
		var lbl = '';
		if (affs.length > 0) {
			lbl = affs[0].RxShortName;
		}
		vm.AccumRxDroplist = [{value:'NONE',label:lbl}];
		lookupUseAccumRx(affs[0]);

		queryChangeOrderCategory();
	}

	function hasDirectReplenish(affs, venid) {
		// loop affs (most likely 1) to find direct replenish switch
		var ii = 0,
			acct = null;
		for(var i = 0; i < affs.length; i++) {
			for(ii = 0; ii < affs[i].Ordering.length; ii++) {
				acct = affs[i].Ordering[ii];
				if(acct.Type == '340B' && acct.VENID == venid && !!acct.DirectRep) {
					return true;
				}
			}
		}
		return false;
	}

	function hasISP(affs, venid) {
		// loop affs (most likely 1) to find direct replenish switch
		var ii = 0,
			acct = null;
		for(var i = 0; i < affs.length; i++) {
			for(ii = 0; ii < affs[i].Ordering.length; ii++) {
				acct = affs[i].Ordering[ii];
				if(acct.VENID == venid && !!acct.ISP) {
					return true;
				}
			}
		}
		return false;
	}

	function queryChangeOrderCategory(toggleCheckmark) {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		// user clicked STANDARD checkbox option
		if(!!toggleCheckmark) {
			vm.query.OrderCategory.chk = vm.query.OrderCategory.chk == 'no' ? 'yes' : 'no';
		}

		// try available items
		vm.activeTab = 'ACCUM';
		getAvailableItems();
	}

	function queryChangeDOD() {
		// two DOD props call this, there is no validation needed
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		// try available items
		vm.activeTab = 'ACCUM';
		getAvailableItems();
	}

	function queryChangeDirectRep() {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		// reset child props, keep check state and query
		var chk = vm.query.DirectRep.chk == 'yes' ? 'no' : 'yes';
		resetDirectRep(vm.query.hasDirectRep);
		vm.query.DirectRep.chk = chk;

		if(chk == 'yes') {
			queryChangeDirectRepShipTo();
		}
		else {
			// try available items
			vm.activeTab = 'ACCUM';
			getAvailableItems();
		}
	}

	function queryChangeDirectRepShipTo() {
		if(vm.isWaiting || vm.query.DirectRep.chk != 'yes') {
			return;
		}
		queryChange();

		vm.query.DirectRep.fail = vm.query.DirectRep.val == 'NONE' ? 'yes' : 'no';		
		if(vm.query.DirectRep.fail == 'no') {
			// try available items
			vm.activeTab = 'ACCUM';
			getAvailableItems();
		}
	}

	function queryChangeDirectRepProfit() {
		if(vm.isWaiting || vm.query.DirectRep.chk != 'yes') {
			return;
		}

		// re-validate ship to
		queryChangeDirectRepShipTo();
	}

	function queryChangeISP(yesno) {
		if(vm.isWaiting) {
			return;
		}

		vm.query.IsISP = yesno;
		resetDirectRep();

		if (vm.query.RxCP && vm.query.UserType != 'RX') {
			if (vm.query.IsISP == 'yes') {
				vm.query.hasDirectRep = false;
			} else {
				// Re-eval direct replenish
				var affs = getAffs();
				affs = utilSvc.aff.findRx(utilSvc.aff.findCe(affs, vm.query.CE.val), vm.query.RX.val);
				var vens = utilSvc.aff.findVen(affs, vm.query.VEN.val);
				vm.query.hasDirectRep = hasDirectReplenish(vens, vm.query.VEN.val);
			}
		}

		vm.activeTab = 'ACCUM';
		getAvailableItems();
	}

	function queryChangeAccumRx() {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		// try available items
		vm.activeTab = 'ACCUM';
		getAvailableItems();
	}

	function resetOrderCategory() {
		vm.query.RxCP = false;
		vm.query.OrderCategory = newCheckProp('STANDARD');
	}

	function resetDOD() {
		vm.query.isDOD = false;
		vm.query.DodPharmaType = 'BG';
		vm.query.DodBillingType = 'BILL';
	}

	function resetDirectRep(isOn) {
		// direct replenishment
		vm.query.hasDirectRep = !!isOn;
		vm.query.usingDirectRep = false;
		vm.query.DirectRep = newCheckProp('NONE');
		vm.query.DirectRepProfit = 'yes';
	}

	function newCheckProp(val) {
		var prop = validSvc.newProp(val);
		prop.chk = 'no';
		return prop;
	}

	function queryChangeNdcFilter() {

		if(vm.isWaiting) {
			return;
		}
		queryChange();

		// toggle filter
		vm.query.NdcFilter = vm.query.NdcFilter == 'yes' ? 'no' : 'yes';

		// try available items?
		if(queryValid(vm.query)) {
			vm.activeTab = 'ACCUM';
			getAvailableItems();
		}

	}

	function queryValid(query) {

		// validate query data before calling api

		// primary/secondary VEN, AcctType required
		if(_primaryProp == 'CE') {
			query.primary.fail = validSvc.isCE(query.primary.val) ? 'no' : 'yes';
			query.secondary.fail = validSvc.isRX(query.secondary.val) ? 'no' : 'yes';
		}
		else {
			query.primary.fail = validSvc.isRX(query.primary.val) ? 'no' : 'yes';
			query.secondary.fail = validSvc.isCE(query.secondary.val) ? 'no' : 'yes';
		}

		if(query.primary.fail == 'no' && query.secondary.fail == 'no') {
			var x = filterSwapToCERX(query);
			query.CE.val = x.CE;
			query.RX.val = x.RX;
		}

		query.VEN.fail = validSvc.isVEN(query.VEN.val) ? 'no' : 'yes';
		query.AcctType.fail = validSvc.isEntity(query.AcctType.val) ? 'no' : 'yes';

		// direct replenish
		if(query.hasDirectRep && query.DirectRep.chk == 'yes') {
			query.DirectRep.fail = query.DirectRep.val == 'NONE' ? 'yes' : 'no';		
		}
		else {
			query.DirectRep.fail = '';
		}

		return query.primary.fail == 'no' &&
			query.secondary.fail == 'no' &&
			query.VEN.fail == 'no' &&
			query.AcctType.fail == 'no' &&
			query.DirectRep.fail != 'yes';

	}


	/**
	 *    TAB CHANGE
	 */

	function tabChange(tabName) {

		if(vm.isWaiting) {
			return;
		}

		closePopup(true);
		vm.activeTab = tabName;

		switch(tabName) {

			case 'ACCUM':
				break;

			case 'ORDER':
				vm.addToCart.items = []; // stop in-progress animations
				break;

			case 'ASSAY':
			case 'ASSAY_ORDER':
				vm.assay = assayDisplayVM(vm.assay, tabName); // display will load assay accum or order tab
				break;

			default:
				throw new Error('orderNewBCtl.tabChange, unknown tabName: ' + tabName);
		}

	}


	/**
	 *    CHECKBOX FILTERS
	 */

	function chkFilterToggle(chkName) {

		switch(chkName) {

			case 'accum':
				vm.chkHasAccum = !vm.chkHasAccum;
				if(vm.chkHasAccum) {
					vm.chkHasSurplus = false;
				}
				break;

			case 'surplus':
				vm.chkHasSurplus = !vm.chkHasSurplus;
				if(vm.chkHasSurplus) {
					vm.chkHasAccum = false;
				}
				break;

			default:
				throw new Error('orderNewBCtl.chkFilterClick, chkName unknown: ' + chkName);
		}

	}

	function chkFilters(accumItem) {

		// ng-repeat filter, check each accum item for accum and surplus

		// must have accumulation
		if(vm.chkHasAccum && accumItem.ItemUnits <= 0) {
			return false;
		}

		// must have surplus
		if(vm.chkHasSurplus && accumItem.SurplusUnits <= 0) {
			return false;
		}

		return true;

	}


	/**
	 *    GET AVAILABLE
	 */

	function getAvailableItems() {
		// for presplit order, we have a separate api
		if (vm.action == 'PRESPLIT') {
			return;
		}

		// request query valid
		if(!queryValid(vm.query)) {
			if(!vm.init) {
				msgSvc.ok('Cannot Search', 'Check search properties');
			}
			return;
		}

		// query is using direct replenish
		vm.query.usingDirectRep = vm.query.hasDirectRep && vm.query.DirectRep.chk == 'yes';

		// exit if waiting
		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true);

		// clear tabs
		if(!vm.init) {
			vm.accum = accumVM();
		}

		// send api request
		ordersRepo.getAvailableItems(vm.query, 'ItemCode').then(okAvailable, errAvailable);

		function okAvailable(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// No need to reconcile when order has not been split
			if (vm.action == 'PRESPLIT') {
				return;
			}
			var items = Array.isArray(r.Items) ? r.Items : [];

			// ASSAY has its own accumulation processing
			if(vm.query.OrderCategory.val == 'ASSAY') {
				// no VM, load directly into vm.accum
				vm.accum.Items = items;
				tabChange(vm.action == 'CREATE' ? 'ASSAY' : 'ASSAY_ORDER');
			}
			else {
				orderReconcile(items, r.TooMany);
			}
		}

		function errAvailable(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.error('Unknown get response', 'orders.new.ctl.errAvailable', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    GET ORDER DETAIL
	 *    returns a specific order and its items to edit
	 */

	function getOrderDetail(id, refreshOnly) {

		// check order id
		if(!validSvc.isText(id)) {
			throw new Error('order.edit.ctl.getOrderDetail, id is missing');
		}

		// exit if waiting
		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true);

		// on refresh, remember paging size
		_refreshPagingSize = $scope.tblPagingSize;
		if(!!refreshOnly && !!vm.order && !!vm.order.Paging && vm.order.Paging.Size > $scope.tblPagingSize) {
			_refreshPagingSize = vm.order.Paging.Size;
		}

		// clear order tab
		if(!vm.init) {
			vm.order = orderVM();
		}

		// send api request
		if (vm.action == 'PRESPLIT') {
			ordersRepo.getPreSplitOrderDetail(id).then(okOrder, errOrder);
		} else {
			ordersRepo.getOrderDetail(id).then(okOrder, errOrder);
		}
		
		function okOrder(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.order = orderVM(r);

			if(!!refreshOnly) {
				// restore paging size
				vm.order.Paging.Size = _refreshPagingSize;
			}
			else {
				// populate primary/secondary
				vm.query.primary.val = _primaryProp == 'CE' ? vm.order.CEID : vm.order.RXID;
				vm.query.primaryName = _primaryProp == 'CE' ? vm.order.CEID : vm.order.RxShortName;
				vm.query.secondary.val = _primaryProp == 'RX' ? vm.order.CEID : vm.order.RXID;
				vm.query.secondaryName = _primaryProp == 'RX' ? vm.order.CEID : vm.order.RxShortName;

				// populate query
				vm.query.CE = validSvc.newProp(vm.order.CEID);
				vm.query.RX = validSvc.newProp(vm.order.RXID);
				vm.query.VEN = validSvc.newProp(vm.order.VENID);
				vm.query.AcctType = validSvc.newProp(vm.order.AcctType);

				// get RX business models
				vm.query.RxBizModels = [];
				vm.query.RxSplit = false;

				// check if order is sequential or not
				vm.isSEQ = !!r.SequentialSplit;

				var affs = utilSvc.aff.findRx($scope.User.AffList, vm.query.RX.val);
				affs = utilSvc.aff.findCe(affs, vm.query.CE.val);

				// get RX business models
				vm.query.RxBizModels = utilSvc.aff.rxModelList(affs);
				if(vm.query.RxBizModels.indexOf('SPLIT') > -1 || vm.query.RxBizModels.indexOf('SPLITMATCH') > -1) {
					vm.query.RxSplit = true;
				}

				// de-construct order category into two query properties
				vm.query.RxCP = vm.query.RxBizModels.indexOf('CP') > -1;
				vm.query.OrderCategory = validSvc.isText(vm.order.Category) ? validSvc.newProp(vm.order.Category) : validSvc.newProp('STANDARD');
				vm.query.OrderCategory.chk = vm.order.AccumSearchAll ? 'yes' : 'no';

				// copy DOD to query for get available calls
				vm.query.isDOD = vm.order.isDOD;
				vm.query.DodPharmaType = vm.order.DodPharmaType;
				vm.query.DodBillingType = vm.order.DodBillingType;

				// direct replenish
				resetDirectRep();
				if(vm.order.DirectReplenish) {
					vm.query.hasDirectRep = true;
					vm.query.usingDirectRep = true;
					vm.query.DirectRep.chk = 'yes';
					vm.query.DirectRep.val = vm.order.CeKeep;
					vm.query.DirectRepProfit = vm.order.DirectRepProfit;
				}

				var ceEditableCPAffs = utilSvc.aff.findCeCanCreateCpList(affs);
				var ceCanEditCPOrder = !!ceEditableCPAffs && ceEditableCPAffs.length > 0;
				// CE user cannot edit non-split pharmacy orders unless they have permission on affiliation
				if(vm.query.UserType == 'CE' && !vm.query.RxSplit && !vm.isSEQ && !!!ceCanEditCPOrder) {
					vm.action = 'HISTORY';
				}

				// RX user should not edit presplit orders
				if(vm.query.UserType == 'RX' && vm.action == 'PRESPLIT') {
					vm.action = 'HISTORY';
				}

				tabChange(vm.query.OrderCategory.val == 'ASSAY' ? 'ASSAY_ORDER' : 'ORDER');  // ASSAY has its own order tab
			}

			// load accumulation after order render
			if(vm.action != 'HISTORY' && vm.action != 'PRESPLIT') {
				$timeout(getAvailableItems, 200);
			}

			// ENT-26353: populate ReviewSubstitute for existing presplit orders
			if(vm.action == 'PRESPLIT') {
				affLookup(vm.query.CE.val, vm.query.RX.val, '');
			}

		}

		function errOrder(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Unknown order get response', 'ordersNewCtl.errOrder', r.status, utilSvc.http.safeResponse(r));
				routeNavTo('LIST', '', true);
			}

		}

	}


	/**
	 *    ORDER CREATE / UPDATE
	 */

	function orderItemsValid(items) {

		// alt UI checks for valid quantities before sending to repository
		// note: this allows a user to enter a wrong quantity without needing a getAvailable() items refresh

		items = Array.isArray(items) ? items : [];

		var allItemsValid = true,
			needSurplus = false,
			validItemCount = 0,
			qty = 0,
			isPreSplit = vm.action == 'PRESPLIT',
			isAssayOrder = vm.query.OrderCategory.val == 'ASSAY';

		for(var i = 0; i < items.length; i++) {

			// user entered order qty
			qty = items[i].UserUnits;
			items[i].fail = false;
			items[i].msg = '';

			// must be integer
			if(!validSvc.isInteger(qty)) {
				items[i].fail = true;
				items[i].msg = "must be integer";
				allItemsValid = false;
				continue;
			}
			qty = parseInt(qty);
			items[i].UserUnits = qty;
			items[i].UserUnitsEdit = qty;

			// must be > 0
			if(qty <= 0) {
				// skip, user can zero out individual items
				continue;
			}

			// pre-split and assay don't use surplus
			if(!isPreSplit && !isAssayOrder) {

				// must be less than OnOrder + accum + surplus
				var savedQty = onOrderQty(items[i].ItemCode);
				if(qty > savedQty + items[i].ItemUnits + items[i].SurplusUnits) {
					items[i].fail = true;
					items[i].msg = "qty must be less than new + surplus";
					allItemsValid = false;
					continue;
				}

				// mark any items which need more surplus (this is not a fail)
				var needSurplusQty = qty - savedQty - items[i].ItemUnits;
				if(needSurplusQty > 0) {
					items[i].needSurplus = needSurplusQty;
					needSurplus = true;
				}
				else {
					items[i].needSurplus = 0;
				}
			}

			// valid items
			validItemCount++;
		}

		// did any fail validation?
		if(!allItemsValid) {
			return {
				valid: false
			};
		}

		// modify ItemUnits for api save: add OnOrder qty and any neededSurplus if any
		for(var v = 0; v < items.length; v++) {
			items[v].ItemUnits += onOrderQty(items[v].ItemCode) + items[v].needSurplus;
		}

		// valid, send results back
		return {
			valid: true,
			count: validItemCount,
			needSurplus: needSurplus
		};

	}

	function buildOrderSurplus(items) {

		// at least 1 item in this order needs to increase surplus
		// note: surplus increases are called right before creating or updating orders

		// build surplus list
		var surplusListItems = [];
		for(var i = 0; i < items.length; i++) {
			if(items[i].needSurplus > 0) {
				surplusListItems.push({
					ItemCode: items[i].ItemCode,
					SurplusUnits: parseInt(items[i].needSurplus),
					AccumulatorId: items[i].AccumulatorId
				});
			}
		}

		return surplusListItems;

	}

	function orderCreate() {

		// valid query
		if(!queryValid(vm.query)) {
			msgSvc.ok('Order Create', 'Pharmacy, Facility and Vendor required before creating an order');
			return;
		}

		// items exist
		if(vm.order.Items.length < 1) {
			msgSvc.ok('No Items', 'There are no items to order');
			return;
		}

		// already waiting?
		if(vm.isWaiting) {
			return;
		}

		// rx shortname
		var x = filterSwapToCERX(vm.query);
		var rxName = utilSvc.aff.rxShortNameById(getAffs(), x.RX);

		// confirm create order
		msgSvc.confirm({
			id: 'orders.new.confirm.create',
			title: 'Create Order',
			msg: 'Create ' + rxName + ' Order with ' + vm.order.Items.length.toString() + ' items?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(msgConfirm, msgConfirm);

		function msgConfirm(r) {
			// user said yes
			if(!!r && r.result == 'YES') {

				// valid order items (note if all items are valid, the ItemUnits are modified for api save)
				var checkItems = orderItemsValid(vm.order.Items);
				if(!checkItems.valid) {
					msgSvc.ok('Cannot Save', 'Check order quantities.');
					return;
				}
				else if(checkItems.count < 1) {
					msgSvc.ok('Cannot Save', 'At least 1 order item must have quantity.');
					return;
				}

				vm.isWaiting = true;

				// do any items need more surplus?
				if(checkItems.needSurplus) {
					var surplusItems = buildOrderSurplus(vm.order.Items);
					ordersRepo.surplusChange('order/surplus/remove', surplusItems).then(createOrderApi, errSurplusApi);
				}
				else {
					createOrderApi();
				}
			}
		}

		function createOrderApi() {
			ordersRepo.orderCreate(vm.query, vm.order.Items).then(okUpsert, errUpsert);
		}

	}

	function orderUpdate() {

		// check order id
		if(!validSvc.isText(vm.order.Id)) {
			throw new Error('order.edit.ctl.orderUpdate, id is missing');
		}

		// items exist
		if(vm.order.Items.length < 1) {
			msgSvc.ok('Order Save', 'There are no items to save');
			return;
		}

		// already waiting?
		if(vm.isWaiting) {
			return;
		}

		// confirm save order
		msgSvc.confirm({
			id: 'orders.new.confirm.save',
			title: 'Save Order',
			msg: 'Save ' + vm.order.RxShortName + ' Order with ' + vm.order.Items.length.toString() + ' items?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(msgConfirm, msgConfirm);

		function msgConfirm(r) {
			// user said yes
			if(!!r && r.result == 'YES') {

				// valid order items (note if all items are valid, the ItemUnits are modified for api save)
				var checkItems = orderItemsValid(vm.order.Items);
				if(!checkItems.valid) {
					msgSvc.ok('Cannot Save', 'Check order quantities.');
					return;
				}
				if(checkItems.count < 1) {
					msgSvc.ok('Cannot Save', 'At least 1 order item must have quantity.');
					return;
				}

				vm.isWaiting = true;

				// do any items need more surplus?
				if(checkItems.needSurplus) {
					var surplusItems = buildOrderSurplus(vm.order.Items);
					ordersRepo.surplusChange('order/surplus/remove', surplusItems).then(updateOrderApi, errSurplusApi);
				}
				else {
					updateOrderApi();
				}
			}
		}

		function updateOrderApi() {
			vm.isWaiting = true;
			msgSvc.wait(true);
			ordersRepo.orderUpdate(vm.order).then(okUpsert, errUpsert);
		}

	}

	function presplitRemoveItem(ndc) {
		if(vm.isWaiting) {
			return;
		}

		var idx = findItembyNDC(ndc, vm.order.Items);
		if(idx < 0) {
			throw new Error('order.new.ctl.presplitRemove, order item not found by NDC: ' + ndc);
		}

		// pre-split marks row for delete, then sends to api
		vm.order.Items[idx].State = 'REMOVE';
		presplitSaveOrder(true);
	}

	function presplitSaveOrder(remove) {
		// valid order items (note if all items are valid, the ItemUnits are modified for api save)
		var checkItems = orderItemsValid(vm.order.Items);
		if(!checkItems.valid) {
			msgSvc.ok('Cannot Save', 'Check order quantities.');
			return;
		}
		else if(checkItems.count < 1 && !!!remove) {
			msgSvc.ok('Cannot Save', 'At least 1 order item must have quantity.');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);
		ordersRepo.orderPreSplitUpdate(vm.order).then(okUpsert, errUpsert);
	}

	function okUpsert(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		switch(vm.action) {
			case 'CREATE':
				// after create route to update
				var x = filterSwapToCERX(vm.query);
				var rxName = utilSvc.aff.rxShortNameById(getAffs(), x.RX);
				msgSvc.ok(rxName,'Order Created');
				routeNavTo('UPDATE', r.Id, true);
				break;
			case 'UPDATE':
				// refresh order details
				msgSvc.ok(vm.order.RxShortName,'Order Saved');
				getOrderDetail(r.Id, true);
				break;
			case 'PRESPLIT':
				// if this is a catalog add, show prompt
				if(!!vm.popup && vm.popup.ready) {
					if(vm.popup.type == 'CATALOG-SEARCH') {
						if(!!vm.catalog.addItem && validSvc.isText(vm.catalog.addItem.ItemCode)) {
							msgSvc.confirm({
								id: 'orders.presplit.catalog.additem',
								title: vm.catalog.addItem.ItemCode + ' Added to Order',
								msg: 'Search Options',
								buttons: [
									{text:'OK', result:'CONTINUE', cancel: false},
									{text:'NEW SEARCH', result:'NEWSEARCH', cancel: false},
									{text:'EXIT', result:'EXIT', cancel: true}
								]
							}).then(msgCatalogContinue, msgCatalogContinue);
						}
					}
					else if(vm.popup.type == 'PRESPLIT-OPTIMIZE') {
						msgSvc.ok('Optimize Saved', 'Optimize adjustments are applied to order.');
					}
				}

				// reset catalog and refresh order details
				vm.catalog.addItem = null;
				getOrderDetail(r.Id, true);
				break;
			default:
				throw new Error('orderNewCtl.okUpsert, unknown order action: ' + vm.action);
		}
	}

	function msgCatalogContinue(r) {
		r = r || {result:'EXIT'};
		switch(r.result) {
			case 'NEWSEARCH':
				resetCatalogSearch();
				break;
			case 'CONTINUE':
				// no action needed
				break;
			case 'EXIT':
				closePopup();
				break;
		}
	}

	function errUpsert(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);
		_pendingOrder = {};

		// already handled
		if(!!!r) {
			return;
		}

		if(r.status == 409) {
			// conflict
			errSvc.info('Could not create or save, already exist in the database. Verify and try again.', 'orderNewCtl.errUpsert', r.status);
			getAvailableItems();
		}
		else if (r.status == 422) {
			var aggMsg = "";
			for(var i=0; i < r.data.Entity.Fields.length;i++) {
				aggMsg += r.data.Entity.Fields[i].Rule + "\n";
			}

			// validation
			vm.order.Items = r.order.Items;
			msgSvc.ok('Cannot Save', aggMsg);
			getAvailableItems();
		}
		else {
			errSvc.error('Unexpected api error', 'order.edit.errUpsert', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 * 	ORDER PLACE
	 * 	note: separating this off status update, place logic is tangled inside status update logic
	 */
	
	function orderPlace() {
		// place process
		// 1. save order
		// 2. update status to PLACE
	
		// valid order items (note if all items are valid, the ItemUnits are modified for api save)
		var checkItems = orderItemsValid(vm.order.Items);
		if(!checkItems.valid) {
			msgSvc.ok('Cannot Place Order', 'Check order quantities.');
			return;
		}
		if(checkItems.count < 1) {
			msgSvc.ok('Cannot Place Order', 'At least 1 order item must have quantity.');
			return;
		}

		_pendingOrder = {
			Id: vm.order.Id,
			Status: 'PLACE',
			needSurplus: checkItems.needSurplus
		};

		var msgobj = {
			id: 'orders.edit.confirm.place',
			title: 'Place Order',
			msg: 'Confirm you wish to place this order, once placed it cannot be undone.',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		};

		if (vm.order.Category == 'ASSAY') {
			msgobj.notes =  {
				prompt: 'optional reference PO',
				maxlength: 50,
				out: ''
			};
		}

		msgSvc.confirm(
			msgobj
		).then(msgConfirmPlace, msgConfirmPlace);
	}

	function msgConfirmPlace(r) {
		// exit: user cancel
		if(!!!r || r.result != 'YES') {
			_pendingOrder = {};
			return;
		}

		if (vm.order.Category == 'ASSAY') {
			if (!!r.notes) {
				var regexPO = /[^A-Za-z0-9]/;
				if(regexPO.test(r.notes.toString())) {
					msgSvc.ok('PO Number Invalid', 'must be 3 to 30 letters, numbers');
					return;
				}
				vm.order.ReferencePO = r.notes;
			}
		}

		vm.order.SendEDI = vm.order.Category == 'ASSAY' ? false : vendorHasEDI(vm.order); // don't send ASSAY orders by EDI
		if(vm.order.SendEDI && (vm.order.Category == 'SPECIALTY' || vm.order.Category == 'DROPSHIP')) {
			// confirm EDI option for non-standard orders
			msgSvc.confirm({
				id: 'orders.edit.confirm.edi',
				title: 'SEND EDI',
				msg: vm.order.VENID + ' supports EDI, would you like to send this order by EDI to the vendor?',
				buttons: [
					{text:'SEND EDI', result:'EDI', cancel: false},
					{text:'NO EDI', result:'CANCEL', cancel: true}
				]
			}).then(msgConfirmPlaceEDI, msgConfirmPlaceEDI);
		}
		else {
			userConfirmedPlace();
		}
	}

	function msgConfirmPlaceEDI(r) {
		// order is getting placed either way, we are looking for the EDI decision
		vm.order.SendEDI = !!r && r.result == 'EDI';
		userConfirmedPlace();
	}

	function userConfirmedPlace() {
		vm.isWaiting = true;

		// do any items need more surplus?
		if(_pendingOrder.needSurplus) {
			var surplusItems = buildOrderSurplus(vm.order.Items);
			ordersRepo.surplusChange('order/surplus/remove', surplusItems).then(savePlaceOrder, errSurplusApi);
		}
		else {
			savePlaceOrder();
		}
	}

	function savePlaceOrder() {
		// save order first
		ordersRepo.orderPlace(vm.order).then(okSaveToPlace, errUpsert);
	}

	function okSaveToPlace(r) {
		// place order after save
		_pendingOrder.Id = r.Id;
		ordersRepo.orderStatus(_pendingOrder.Id, 'PLACE').then(okPlaceOrderDone, errStat);
	}

	function okPlaceOrderDone() {
		// after order place, give user EDI or NON-EDI message
		var title = vm.order.SendEDI ? '' : 'NON-',
		venid = vm.order.VENID;
		var msg = vm.order.SendEDI ? 
			venid + ' order placed and sent EDI.' :
			venid + ' order placed but NOT sent by EDI automatically. Use the Excel export link to send order details to the vendor manually.';

		msgSvc.okAsync(title + 'EDI Order Placed', msg, 'order.placed.ok').then(okGoToPlaceUI, okGoToPlaceUI);
	}

	function okGoToPlaceUI() {
		var id = _pendingOrder.Id;
		_pendingOrder = {};
		routeNavTo('PLACE', id, true);
	}

	function vendorHasEDI(order) {
		// find first occurence of vendor, check for edi support
		// note: ideally this would be vendorRepo.getDetail but CE/RX users do not have a claim for that endpoint

		var affs = getAffs();
		affs = utilSvc.aff.findRx(utilSvc.aff.findCe(affs, order.CEID), order.RXID);
		affs = utilSvc.aff.findVen(affs, order.VENID);
		affs = utilSvc.aff.findVenType(affs, [order.AcctType]);

		return affs.length > 0;
	}


	/**
	 *    STATUS CHANGE
	 *    cancel / delete, etc
	 */

	function orderCancel() {
		orderStatus(vm.order.Id, 'CANCEL', 'Cancel Order', 'Confirm you wish to cancel this order, this cannot be undone.');
	}

	function orderSubmitSplit() {
		for(var i = 0; i < vm.order.Items.length; i++) {
			if (vm.order.Items[i].OrderUnits <= 0) {
				msgSvc.ok('QUANTITY CHECK', 'Quantity must be a number greater than 0.');
				return;
			}
		}
		orderStatus(vm.order.Id, 'SPLIT', 'Split Order', 'Confirm you wish to split this order, once split it cannot be undone.');
	}

	function orderStatus(id, status, title, msg) {

		_pendingOrder = {
			Id: id,
			Status: status
		};

		msgSvc.confirm({
			id: 'orders.edit.confirm.status',
			title: title,
			msg: msg,
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(msgConfirmStatus, msgConfirmStatus);

		function msgConfirmStatus(r) {
			// user said yes
			if(!!r && r.result == 'YES') {
				ordersRepo.orderStatus(_pendingOrder.Id, _pendingOrder.Status).then(okStat, errStat);
			}
		}

		function okStat(r) {
			if(_pendingOrder.Status == 'CANCEL') {
				routeNavTo('CANCEL', r.Id, true);
			}
			else if(_pendingOrder.Status == 'SPLIT') {
				routeNavTo('VIEW', r.Id, true);
			}
			else {
				routeNavTo('UPDATE', r.Id, true);
			}
		}
	}

	function errStat(r) {
		vm.isWaiting = false;

		if(!!!r || r === null) {
			// already handled
		}
		else if(r.status == 409) {
			// conflict
			errSvc.info('Could not change order status to: ' + _pendingOrder.Status + '. Verify and try again.');
			routeNavTo(vm.action, _pendingOrder.Id, true);
		}
		else if(r.status == 422 && _pendingOrder.Status == 'PLACE' && validSvc.isText(r.msg)) {
			msgSvc.ok('Cannot Place Order', r.msg);
			routeNavTo(vm.action, _pendingOrder.Id, true);
		}
		else {
			errSvc.error('Status ' + _pendingOrder.Status + ' failed with unexpected error.', 'orderNewCtl.errStat', r.status, utilSvc.http.safeResponse(r));
			routeNavTo('LIST', '', true);
		}

	}


	/**
	 *    CART ANIMATIONS
	 */

	function addToCartAnim(drugText) {

		// stop flooding if user is repeatedly clicking
		if(vm.addToCart.items.length > 2) {
			return;
		}

		vm.addToCart.items.push({txt: drugText.substr(0, 50), run: false});

		// startup if anim is off
		if(!vm.addToCart.show) {
			vm.addToCart.show = true;
			$timeout(addToCartRunAnim, 100);
		}

	}

	function addToCartRunAnim() {

		// runs animation for each drug added to cart, stops when array is empty

		// items to process
		if(vm.addToCart.items.length > 0) {

			// start current
			var current = vm.addToCart.items[0];
			if(!current.run) {
				current.run = true;
				vm.addToCart.txt = current.txt;
				vm.addToCart.run = true;
				$timeout(addToCartRunAnim, 1200);
			}
			else {
				// stop current, remove from items
				vm.addToCart.txt = '';
				vm.addToCart.run = false;
				vm.addToCart.items.shift();
				$timeout(addToCartRunAnim, 1200);
			}
		}
		else {
			vm.addToCart.show = false;
		}

	}


	/**
	 *    ORDER CART TRANSFERS
	 *    add/remove 1 or all item quantity
	 */

	function orderAddItem(ndc, qty) {

		// move 1 item to cart

		if(vm.isWaiting) {
			return;
		}

		var idx = findItembyNDC(ndc, vm.accum.Items);
		if(idx < 0) {
			throw new Error('order.new.ctl.orderAddItem, accum item not found by NDC: ' + ndc);
		}

		// valid qty
		if(!transferQtyValid(qty, vm.accum.Items[idx].ItemUnits, true)) {
			return;
		}
		var addItem = vm.accum.Items.splice(idx, 1)[0];
		addItem.uniqueId = 'ADDID' + Date.now().toString() + '-' + idx.toString();

		// remove OnOrder qty from accumulation
		var savedQty =  onOrderQty(ndc);
		addItem.ItemUnits -= savedQty;

		// set order qty
		addItem.UserUnits = parseInt(qty);
		addItem.UserUnitsEdit = addItem.UserUnits;

		// remainder qty = saved + new accumulation + surplus - order units
		var remainder = savedQty + addItem.ItemUnits + addItem.SurplusUnits - addItem.UserUnits;
		addItem.RemainderUnits = remainder > 0 ? remainder : 0;

		vm.order.Items.push(addItem);
		if(!!addItem.CII) {
			vm.order.hasCII = true;
		}
		if(!!addItem.IsSpecialty) {
			vm.order.hasSpecialty = true;
		}

		// animate
		addToCartAnim(addItem.VenLabel);

	}

	function orderEditQty(ndc, qty) {

		// change user units to order on accum tab (before user adds it to the cart)

		if(vm.isWaiting) {
			return;
		}

		var idx = findItembyNDC(ndc, vm.accum.Items);
		if(idx < 0) {
			throw new Error('orderNewCtl.orderEditQty, accum item not found by NDC: ' + ndc);
		}
		var item = vm.accum.Items[idx];

		// valid qty
		if(!transferQtyValid(qty, item.ItemUnits, true)) {
			return;
		}

		item.OrderAddQty = parseInt(qty);

		closePopup(true);
	}

	function orderEditPreSplitQty(venItemNum, qty) {

		// change user units to order on accum tab (before user adds it to the cart)

		if (vm.isWaiting) {
			return;
		}

		var idx = findItembyVenItemNum(venItemNum, vm.order.Items);
		if (idx < 0) {
			throw new Error('orderNewCtl.cartEditQty, order item not found by NDC: ' + venItemNum);
		}
		var orderItem = vm.order.Items[idx];
		// valid qty
		if (!transferQtyValid(qty, 99999, true)) {
			return;
		}

		if (orderItem.UserUnits != 0 && qty > 3 * orderItem.UserUnits) {
			msgSvc.confirm({
				id: 'orders.new.confirm.edit.quantity',
				title: 'Quantity Check',
				msg: 'Entered quantity ' + qty + ' is 3 times higher than the original quantity - are you sure you want this quantity?',
				buttons: [
					{ text: 'OK', result: 'YES', cancel: false },
					{ text: 'Cancel', result: 'CANCEL', cancel: true }
				]
			}).then(userConfirmQty, userConfirmQty);
		}
		else {
			userConfirmQty({result:'YES'});
		}

		closePopup(true);

		function userConfirmQty(r) {
			if (!!r && r.result == 'YES') {
				orderItem.UserUnits = parseInt(qty);
				orderItem.UserUnitsEdit = orderItem.UserUnits;
				presplitSaveOrder();
			}
		}
	}


	function cartEditQty(ndc, qty) {

		// change cart qty

		if(vm.isWaiting) {
			return;
		}

		var idx = findItembyNDC(ndc, vm.order.Items);
		if(idx < 0) {
			throw new Error('orderNewCtl.cartEditQty, order item not found by NDC: ' + ndc);
		}
		var orderItem = vm.order.Items[idx];

		// valid qty
		var orderableQty = orderItem.UserUnits + orderItem.RemainderUnits;
		if(!transferQtyValid(qty, orderableQty, true)) {
			return;
		}

		closePopup(true);

		orderItem.UserUnits = parseInt(qty);
		orderItem.UserUnitsEdit = orderItem.UserUnits;
		orderItem.RemainderUnits = orderableQty - orderItem.UserUnits;

	}

	function orderAddAll() {

		// move all items to cart

		if(vm.isWaiting) {
			return;
		}

		var addItem = null,
			hasCII = false,
			hasSpecialty = false,
			nowId = Date.now().toString();

		for(var i = vm.accum.Items.length - 1; i >= 0; i--) {
			addItem = vm.accum.Items[i];

			// item must have accumulation to order it
			if(addItem.ItemUnits > 0) {
				addItem.uniqueId = 'ADDALLID' + nowId + '-' + i.toString();

				// remove saved qty from accumulation
				var savedQty = onOrderQty(addItem.ItemCode);
				addItem.OrderUnits = savedQty;
				addItem.ItemUnits -= savedQty;

				// order all accumulation
				addItem.UserUnits = savedQty + addItem.ItemUnits;
				addItem.UserUnitsEdit = addItem.UserUnits;

				// remainder qty = saved + new accumulation + surplus - order units
				var remainder = savedQty + addItem.ItemUnits + addItem.SurplusUnits - addItem.UserUnits;
				addItem.RemainderUnits = remainder > 0 ? remainder : 0;

				vm.order.Items.push(addItem);
				vm.accum.Items.splice(i, 1);

				if(!hasCII && !!addItem.CII) {
					hasCII = true;
				}
				if(!hasSpecialty && !!addItem.IsSpecialty) {
					hasSpecialty = true;
				}
			}
		}

		vm.order.hasCII = hasCII;
		vm.order.hasSpecialty = hasSpecialty;

		// if everything ordered, reset accum list, show cart tab
		if(vm.accum.Items.length < 1) {
			vm.accum.Items = [];
			tabChange('ORDER');
		}
		else {
			msgSvc.ok('All New Accumulation Ordered', vm.accum.Items.length + ' Surplus items were not added.');
		}

	}

	function orderRemoveItem(ndc) {
		// move 1 item from cart to accum list
		if(vm.isWaiting) {
			return;
		}

		var idx = findItembyNDC(ndc, vm.order.Items);
		if(idx < 0) {
			throw new Error('order.new.ctl.orderRemoveItem, order item not found by NDC: ' + ndc);
		}
				
		var removeItem = vm.order.Items.splice(idx, 1)[0];

		// add saved qty back to accumulation
		removeItem.ItemUnits += onOrderQty(ndc);
		removeItem.OrderAddQty = removeItem.ItemUnits;
		removeItem.BacklogAddQty = removeItem.ItemUnits;

		// default: order all accumulation
		removeItem.UserUnits = removeItem.ItemUnits;

		// has surplus
		removeItem.BacklogRemoveQty = removeItem.SurplusUnits;

		vm.accum.Items.push(removeItem);

		var i = 0;
		var oItems = vm.order.Items;
		// does order still have CII drugs?
		if(!!removeItem.CII) {
			vm.order.hasCII = false;
			
			for(i = 0; i < oItems.length; i++) {
				if(!!oItems[i].CII) {
					vm.order.hasCII = true;
					break;
				}
			}
		}

		// does order still have Specialty drugs?
		if(!!removeItem.IsSpecialty) {
			vm.order.hasSpecialty = false;
			for(i = 0; i < oItems.length; i++) {
				if(!!oItems[i].IsSpecialty) {
					vm.order.hasSpecialty = true;
					break;
				}
			}
		}

	}

	function orderRemoveAll() {
		// move all cart items to accum list
		if(vm.isWaiting) {
			return;
		}

		var removeItem = null;
		for(var i = 0; i < vm.order.Items.length; i++) {
			removeItem = vm.order.Items[i];

			// add saved qty back to accumulation
			removeItem.ItemUnits += onOrderQty(removeItem.ItemCode);
			removeItem.OrderAddQty = removeItem.ItemUnits;
			removeItem.BacklogAddQty = removeItem.ItemUnits;

			// default: order all accumulation
			removeItem.UserUnits = removeItem.ItemUnits;

			// has surplus
			removeItem.BacklogRemoveQty = removeItem.SurplusUnits;

			vm.accum.Items.push(removeItem);
		}

		// clear order list
		vm.order.Items = [];
		vm.order.hasCII = false;
		vm.order.hasSpecialty = false;

		// show accum
		tabChange('ACCUM');

		// refresh
		getAvailableItems();

	}


	/**
	 *    ORDER RECONCILE
	 *    update order / accum quantities with new data from server
	 */

	function orderReconcile(dataItems, tooManyItems) {

		var idx = -1,
			orderLine = null,
			dataLen = 0,
			savedQty,
			remainderQty = 0;

		dataItems = Array.isArray(dataItems) ? dataItems : [];
		dataLen = dataItems.length;

		// loop order lines
		for(var i = 0; i < vm.order.Items.length; i++) {

			orderLine = vm.order.Items[i];

			// reset accum/surplus
			orderLine.ItemUnits = 0;
			orderLine.SurplusUnits = 0;

			// find this order item in new data
			if(dataLen > 0) {
				idx = findItembyNDC(orderLine.ItemCode, dataItems);
				if(idx >= 0) {
					orderLine.ItemUnits = dataItems[idx].ItemUnits;
					orderLine.SurplusUnits = dataItems[idx].SurplusUnits;

					// remove from dataItems
					dataItems.splice(idx, 1);
				}
			}

			// remainder qty = saved + new accumulation + surplus - order units
			savedQty = onOrderQty(orderLine.ItemCode);
			remainderQty = savedQty + orderLine.ItemUnits + orderLine.SurplusUnits - orderLine.UserUnits;

			// remainder exceeded?
			if(remainderQty < 0) {
				orderLine.fail = true;
				orderLine.msg = 'qty greater than available';
			}
			else {
				orderLine.fail = false;
				orderLine.msg = '';
			}

			// zero out remainder for display if < 0
			orderLine.RemainderUnits = remainderQty > 0 ? remainderQty : 0;

			// assign reconciled item back to order
			vm.order.Items[i] = orderLine;

		}

		// load any remaining non-order items into accum list
		vm.accum = accumVM(dataItems);
		vm.accum.Paging.TooMany = tooManyItems;

	}


	/**
	 *    SURPLUS TRANSFERS
	 *    add/remove 1 or all items
	 */

	function surplusAddQty(ndc, qty) {

		// move qty from accum to backlog

		if(vm.isWaiting) {
			return;
		}

		var idx = findItembyNDC(ndc, vm.accum.Items);
		if(idx < 0) {
			throw new Error('orderNewCtl.surplusAddQty, accum item not found by NDC: ' + ndc);
		}
		var item = vm.accum.Items[idx];

		// valid qty
		if(!transferQtyValid(qty, item.ItemUnits, true)) {
			return;
		}
		vm.isWaiting = true;
		closePopup(true);

		// call api
		ordersRepo.surplusAdd({
			ItemCode: item.ItemCode,
			SurplusUnits: parseInt(qty),
			AccumulatorId: item.AccumulatorId
		}).then(okSurplusApi, errSurplusApi);

	}

	function surplusRemoveQty(ndc, qty) {

		// move from backlog to accum

		if(vm.isWaiting) {
			return;
		}

		var idx = findItembyNDC(ndc, vm.accum.Items);
		if(idx < 0) {
			throw new Error('orderNewCtl.surplusRemoveQty, accum item not found by NDC: ' + ndc);
		}
		var item = vm.accum.Items[idx];

		// valid qty
		if(!transferQtyValid(qty, item.SurplusUnits, true)) {
			return;
		}
		vm.isWaiting = true;
		closePopup(true);

		// call api
		ordersRepo.surplusRemove({
			ItemCode: item.ItemCode,
			SurplusUnits: parseInt(qty),
			AccumulatorId: item.AccumulatorId
		}).then(okSurplusApi, errSurplusApi);

	}

	function surplusAddAll() {

		// add all accum to surplus

		if(vm.isWaiting) {
			return;
		}

		// show confirmation
		msgSvc.confirm({
			id: 'orders.new.confirm.transfer.all',
			title: 'Transfer All Items',
			msg: 'Transfer all New accumulation to Surplus?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'Cancel', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

		function userConfirm(r) {
			if(!!r && r.result == 'YES') {
				ordersRepo.surplusAddAll(vm.query.CE.val, vm.query.RX.val).then(okSurplusApi, errSurplusApi);
			}
		}

	}

	function surplusRemoveAll() {

		// remove all surplus to accum

		if(vm.isWaiting) {
			return;
		}

		// show confirmation
		msgSvc.confirm({
			id: 'orders.new.confirm.transfer.all',
			title: 'Transfer All Items',
			msg: 'Transfer all Surplus to New accumulation?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'Cancel', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

		function userConfirm(r) {
			if(!!r && r.result == 'YES') {
				ordersRepo.surplusRemoveAll(vm.query.CE.val, vm.query.RX.val).then(okSurplusApi, errSurplusApi);
			}
		}

	}


	/**
	 *    BACKLOG API HANDLERS
	 *    all add/remove methods use these api handlers
	 */

	function okSurplusApi(r) {
		vm.isWaiting = false;
		getAvailableItems();
	}

	function errSurplusApi(r) {
		vm.isWaiting = false;
		_pendingOrder = {};

		if(!!!r) {
			// already handled
			getAvailableItems();
		}
		else if(r.status == 409 || r.status == 422) {
			// conflict
			errSvc.info('Could not modify Backlog. Verify and try again, another user may have changed backlog quantities.', 'orderNewCtl.errSurplusApi', r.status);
			getAvailableItems();
		}
		else {
			errSvc.error('Unknown surplus add / update error response', 'orderNewCtl.errSurplusApi', r.status, utilSvc.http.safeResponse(r));
			routeNavTo('LIST', '', true);
		}

	}

	/**
	 *    CATALOG
	 */

	function catalogListVM(data) {
		data = data || {};
		return {
			DataItems: Array.isArray(data.Items) ? data.Items : [],
			Items: [], // loaded by filterChange()
			TooMany: !!data.TooMany
		};
	}

	function catalogSearch() {
		if (vm.isWaiting) {
			return;
		}

		// search query valid
		var result = catalogQueryValid(vm.query);
		if(result != '') {
			msgSvc.ok('Search', 'Check filter properties. ' + result);
			return;
		}

		// reset pending catalog item
		vm.catalog.addItem = null;

		vm.isWaiting = true;
		msgSvc.wait(true);

		// send api request
		ordersRepo.getNewSplitAvailable(vm.query).then(okCatalogSearch, errCatalogSearch);

		function okCatalogSearch(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.catalog.tbl = catalogListVM(r);
			vm.catalog.tbl.Items = vm.filterList(vm.catalog.tbl.DataItems, vm.catalog.flt);

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: 'CATALOG',
				Size: vm.catalog.flt.PageSize,
				Page: vm.catalog.flt.Page,
				Total: vm.catalog.flt.PageTotal,
				RowCount: vm.catalog.flt.Count,
				ItemCount: vm.catalog.tbl.Items.length,
				DataCount: vm.catalog.tbl.DataItems.length
			});

			vm.catalog.flt.Ready = true;
		}

		function errCatalogSearch(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if (!!r) {
				errSvc.error('Unknown get response', 'orders.new.ctl.errAvailable', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function catalogQueryValid(q) {
		var resultText = '';
		
		var ndc = q.ItemCode.val,
			desc = q.Desc.val,
			venum = q.VenItemNum.val;

		// ndc or venum is required
		if(!validSvc.isText(ndc) && !validSvc.isText(desc) && !validSvc.isText(venum)) {
			q.ItemCode.fail = 'yes';
			q.Desc.fail = 'yes';
			q.VenItemNum.fail = 'yes';
			resultText = (resultText.length > 0 ? ', ' : '') + 'NDC or Description or Vendor Item # required';
		}

		// ndc, optional 5 to 13 characters
		q.ItemCode.fail = 'no';
		if(validSvc.isText(ndc)) {
			ndc = ndc.toString().trim();
			ndc = ndc.replace(/[^0-9]+/g,'');
			q.ItemCode.val = ndc;

			if(ndc.length < 3 || ndc.length > 11 || !validSvc.isInteger(parseInt(ndc))) {
				q.ItemCode.fail = 'yes';
				resultText = (resultText.length > 0 ? ', ' : '') + 'NDC must be 3 to 11 numbers';
			}
		}

		// desc, optional 5 to 30 characters
		q.Desc.fail = 'no';
		if(validSvc.isText(desc) && (desc.length < 3 || desc.length > 50)) {
			q.Desc.fail = 'yes';
			resultText = (resultText.length > 0 ? ', ' : '') + 'Description must be 3 to 50 characters';
		}

		// venum, optional 5 to 30 characters
		q.VenItemNum.fail = 'no';
		if(validSvc.isText(venum) && (venum.length < 5 || venum.length > 30)) {
			q.VenItemNum.fail = 'yes';
			resultText = (resultText.length > 0 ? ', ' : '') + 'Vendor Item # must be 5 to 30 characters';
		}

		return resultText;
	}

	function resetCatalogSearch() {
		vm.query.ItemCode = validSvc.newProp();
		vm.query.Desc = validSvc.newProp();
		vm.query.VenItemNum = validSvc.newProp();
		vm.catalog.flt = vm.initFilters({
			SortBy: ['VenItemNum']
		});
		vm.catalog.tbl = catalogListVM();
		vm.catalog.addItem = null;
	}

	function catalogFilterChange(immediate) {
		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if (!vm.catalog.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.catalog.flt.Dirty = true;

		// already working
		if (vm.catalog.flt.Busy) {
			return;
		}
		vm.catalog.flt.Busy = true;
		vm.catalog.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function () {

			vm.catalog.tbl.Items = vm.filterList(vm.catalog.tbl.DataItems, vm.catalog.flt);
			vm.catalog.flt.Busy = false;

			// run again? data changed during filtering
			if (vm.catalog.flt.Dirty) {
				catalogFilterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: 'CATALOG',
				Size: vm.catalog.flt.PageSize,
				Page: vm.catalog.flt.Page,
				Total: vm.catalog.flt.PageTotal,
				RowCount: vm.catalog.flt.Count,
				ItemCount: vm.catalog.tbl.Items.length,
				DataCount: vm.catalog.tbl.DataItems.length
			});

		}, delayTime);
	}

	function presplitAddItem(item) {

		if(vm.isWaiting) {
			return;
		}
		vm.catalog.addItem = null;

		// Check if added NDC is already in order
		for(var i = 0; i < vm.order.Items.length; i++) {
			if (vm.order.Items[i].ItemCode == item.ItemCode && vm.order.Items[i].ItemCode != "") {
				msgSvc.ok('Cannot Add Item', 'NDC is already in order.');
				return;
			}
		}

		vm.catalog.addItem = {
			ItemCode: item.ItemCode,
			VenDrugCode: item.VenItemNum,
			VenLabel: item.Description,
		};

		// use controller upsert functions to stay on page
		vm.isWaiting = true;
		msgSvc.wait(true);
		ordersRepo.orderPreSplitAdd(vm.order, vm.catalog.addItem).then(okUpsert, errUpsert);
	}
	

	/**
	 *    EXCEL
	 */

	function getExcel() {

		// already working?
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		// convert RXID to short name
		var x = filterSwapToCERX(vm.query);
		x.RX = utilSvc.aff.rxShortNameById($scope.User.AffList, x.RX);

		// build primary/secondary file name
		var entityNames = '';
		if(_primaryProp == 'CE') {
			entityNames = vm.query.primary.val + '-' + x.RX;
		}
		else {
			entityNames = x.RX + '-' + vm.query.secondary.val;
		}

		_pendingExcelFilename = 'Verity-Order-' + entityNames + '-' + vm.order.AcctType + '-' + vm.order.Name + '.xlsx';
		ordersRepo.getOrderExcel(vm.order.Id, _pendingExcelFilename).then(okServerExcel, errServerExcel);

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Create Excel Error', 'orderNewCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    POPUP
	 */

	function openPopup(evt, item, popType) {

		// shared handler to open a popup in any table/column

		if(vm.isWaiting) {
			return;
		}

		var popContentId = 'orderPopupContent',
			offsetY = -50,
			offsetX = -30,
			popWidth = '',
			useYoffsetTop = false,
			useYoffset = true, // move to vertical location of row clicked
			useXoffset = true, // move to horizontal location of mouse click
			useInputFocus = true; // is this popup for quantity editing? if so set focus after popup is shown

		switch(popType) {
			case 'PRESPLIT-EDIT':
				vm.popup = {
					type: popType,
					title: 'Edit Qty',
					desc: 'Adjust cart units',
					ready: false,
					VendItemNum: item.VendItemNum,
					EditQty: item.UserUnits
				};
				popContentId += 'PRESPLIT';
				offsetX = -50;
				break;
			case 'CART':
				vm.popup = {
					type: popType,
					title: 'Edit Qty',
					desc: 'Adjust cart units',
					ready: false,
					ItemCode: item.ItemCode,
					EditQty: item.UserUnits
				};
				popContentId += 'CART';
				break;
			case 'SURPLUS-ADD':
				vm.popup = {
					type: popType,
					title: 'Save Qty',
					desc: 'Save units to Surplus',
					ready: false,
					ItemCode: item.ItemCode,
					EditQty: item.ItemUnits
				};
				popContentId += 'ACCUM';
				break;
			case 'SURPLUS-REMOVE':
				vm.popup = {
					type: popType,
					title: 'Use Qty',
					desc: 'Add Suplus units to Accumulation',
					ready: false,
					ItemCode: item.ItemCode,
					EditQty: item.SurplusUnits
				};
				popContentId += 'ACCUM';
				break;
			case 'ORDER-QTY':
				vm.popup = {
					type: popType,
					title: 'Edit Qty',
					desc: 'Adjust order units',
					ready: false,
					ItemCode: item.ItemCode,
					EditQty: item.OrderAddQty
				};
				popContentId += 'ACCUM';
				break;
			case 'CATALOG-SEARCH':
				vm.popup = {
					type: popType,
					title: 'Catalog Search',
					ready: false,
				};
				popContentId += 'PRESPLIT';
				popWidth = '95%';
				useXoffset = false; // center on screen
				useInputFocus = false;
				resetCatalogSearch();
				break;
			case 'PRESPLIT-ITEM-LOG':
			case 'PRESPLIT-ORDER-LOG':
				vm.popup = {
					type: popType,
					title: popType == 'PRESPLIT-ITEM-LOG' ? 'Pre-Split Item Detail' : 'Pre-Split Order Detail',
					ready: false,
					ChangeLog: item.ChangeLog,
					maxEditsHeight: item.ChangeLog.length <= 7,
				};
				popContentId += 'PRESPLIT';
				useXoffset = false; // center on screen
				useYoffset = popType == 'PRESPLIT-ITEM-LOG';
				popWidth = '70%';
				useInputFocus = false;
				break;
			case 'PRESPLIT-OPTIMIZE':
				if(!hasOptimizeItems(vm.order.Items)) {
					var msg = vm.order.UseBestCost ? ' Verisave' : '';
					msg += vm.order.UseMultiVendor ? msg.length > 0 ? ' or Multi Vendor' : 'Multi Vendor' : '';
					msgSvc.ok('Optimize Order', 'No order items with quantity are ' + msg);
					return;
				}
				vm.popup = {
					type: popType,
					title: 'Optimized Selections',
					ready: false,
					hasEdits: false,
					Items: [],
					SortBy: ['-TopSaving'],
					Overrides: getPopupOverridesFromOrder(vm.order.Items)
				};
				popContentId += 'PRESPLIT';
				popWidth = '90%';
				useXoffset = false; // center on screen
				offsetY = -150; // top of table
				useYoffsetTop = true;
				useYoffset = false; // keep at top
				useInputFocus = false;

				optimizePreSplit();
				break;
			default:
				throw new Error('orderNewCtl.openPopup, unknown popType: ' + popType);
		}

		// remember INPUT element to focus on (if used)
		vm.popup.inputFocusId = useInputFocus ? popContentId + 'INPUT' : '';

		// loop html element parents looking for popup container top
		if(useXoffset || useYoffset) {
			var elem = evt.target,
				scrollTopFound = false;
			while(!!elem) {
				if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
					break;
				}
				// add offset, get next element
				if(useYoffset) {
					// scroll container found, reduce offset if this container is scrolled
					if(!scrollTopFound && !!elem.className && elem.className.indexOf('table-fixed-header-scroll') > -1) {
						scrollTopFound = true;
						offsetY -=  Math.floor(elem.scrollTop);
					}

					offsetY += elem.offsetTop;
				}
				if(useXoffset) {
					offsetX += elem.offsetLeft;
				}
				elem = elem.offsetParent;
			}
			elem = null;
		}

		// get popup by id
		var popElem = document.getElementById(popContentId);
		if(!!popElem) {

			if(useYoffset || useYoffsetTop) {
				popElem.style.top = offsetY.toString() + 'px';
			}
			else {
				popElem.style.top = '0px';

			}

			if(useXoffset) {
				popElem.style.left = offsetX.toString() + 'px';
			}
			else {
				popElem.style.left = '0px';
			}

			// adjust width
			popElem.style.width = popWidth;
		}

		// set row hover
		item.popHover = true;

		// wait for digest before showing
		$timeout(function() {
			if(vm.popup && vm.popup.type != 'PRESPLIT-OPTIMIZE') {  // optimizePreSplit() handles popup for optimizer
				vm.popup.ready = true;
				if(validSvc.isText(vm.popup.inputFocusId)) {
					$timeout(setInputFocus, 300);
				}
			}
		}, 200);
	}

	function setInputFocus() {
		// set focus on input box, pre-select text
		if(!!vm.popup) {
			try {
				var inputElem = document.getElementById(vm.popup.inputFocusId);
				if(!!inputElem) {
					inputElem.focus();
					inputElem.setSelectionRange(0,9999);
				}
			}
			catch(err) {
				// do nothing
			}
		}
	}

	function savePopup() {

		if(vm.isWaiting) {
			// something else is running and didn't close the popup, bad! sick!
			closePopup(true);
		}

		switch(vm.popup.type) {

			case 'CART':
				cartEditQty(vm.popup.ItemCode, vm.popup.EditQty);
				break;

			case 'SURPLUS-ADD':
				surplusAddQty(vm.popup.ItemCode, vm.popup.EditQty);
				break;

			case 'SURPLUS-REMOVE':
				surplusRemoveQty(vm.popup.ItemCode, vm.popup.EditQty);
				break;

			case 'ORDER-QTY':
				orderEditQty(vm.popup.ItemCode,vm.popup.EditQty);
				break;

			case 'PRESPLIT-EDIT':
				orderEditPreSplitQty(vm.popup.VendItemNum,vm.popup.EditQty);
				break;

			default:
				throw new Error('orderNewCtl.openPopup, unknown popType: ' + vm.popup.type);
		}

	}

	function closePopup(removeHover) {

		// clean up popup

		var popType = vm.popup.type,
			items = [];

		vm.popup = {};

		// remove any highlighted table rows
		if(!!removeHover) {

			if(popType == 'CART' || popType == 'PRESPLIT-EDIT' || popType == "PRESPLIT-ITEM-LOG") {
				if(!!vm.order && Array.isArray(vm.order.Items)) {
					items = vm.order.Items;
				}
			}
			else {
				if(!!vm.accum && Array.isArray(vm.accum.Items)) {
					items = vm.accum.Items;
				}
			}

			for(var i = 0; i < items.length; i++) {
				if(!!items[i].popHover) {
					items[i].popHover = false;
					break;
				}
			}

		}

	}


	/**
	 *    HELP TEXT LINK
	 */

	function helpLinkClick() {

		// dynamically choose the right help text to open up

		if(vm.isWaiting) {
			return;
		}

		if(vm.action == 'PRESPLIT') {
			vm.helpLink('order-newsplit', 'New Split Order');
			return;
		}

		switch(vm.activeTab) {

			case 'ORDER':
			case 'HISTORY':
				vm.helpLink('order-new-cart', 'Order Items');
				break;

			case 'ACCUM':
				if(vm.query.RxSplit) {
					vm.helpLink('order-new-accum-split', 'Accumulation');
				}
				else {
					vm.helpLink('order-new-accum-contract', 'Accumulation');
				}
				break;

			case 'ASSAY':
				vm.helpLink('order-new-assay', 'Assay Order');
				break;

			default:
				vm.helpLink('order-new-search', 'New Order Search');

		}

	}

	/**
	 * 		PRE-SPLIT CHANGE ITEM(S)
	 */

	function presplitChangeAllItems(changeType) {
		// remove or change all presplit order items
		if(vm.isWaiting) {
			return;
		}

		var title = '',
			msg = '',
			noSwap = false;

		switch(changeType) {
			case 'REMOVE':
				title = 'Remove All';
				msg = 'Remove all order items from this pre-split order? Confirm this cannot be reversed.';
				break;
			case 'VERISAVE':
				title = 'Verisave Change';
				noSwap = !!vm.order.NoVerisaveSwap;
				msg = noSwap ? 'Remove' : 'Use';
				msg += ' Verisave on all order items?';
				break;
			case 'MULTIVENDOR':
				title = 'Multi Vendor Change';
				noSwap = !!vm.order.NoMultiVendorSwap;
				msg = noSwap ? 'Remove' : 'Use';
				msg += ' Multi Vendor on all order items?';
				break;
			default:
				throw new Error('orderNew.presplitChangeAllItems, unknown change type: ' + changeType);
		}

		msgSvc.confirm({
			id: 'order.presplit.changeall',
			title: title.toUpperCase(),
			msg: msg,
			notes: {
				prompt: 'optional change note',
				maxlength: 100
			},
			buttons: [
				{text:'OK', result:'YES'},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

		function userConfirm(r) {
			if (!!!r || r.result != 'YES') {
				return;
			}

			var orderItems = vm.order.Items,
				notes = validSvc.isText(r.notes) ? r.notes : '',
				isRemove = changeType == 'REMOVE',
				isVerisave = changeType == 'VERISAVE',
				isMultiVendor = changeType == 'MULTIVENDOR';

			orderItems.forEach(function(item){
				item.Notes = notes;
				if(isVerisave) {
					item.NoVerisaveSwap = noSwap;
				}
				else if(isMultiVendor) {
					item.NoMultiVendorSwap = noSwap;
				}
				else if(isRemove) {
					item.State = 'REMOVE';
				}
			});
									
			presplitSaveOrder(isRemove);
		}
	}

	function presplitToggleItem(optType, item) {
		// toggle order item for Verisave or Multi Vendor
		if(vm.isWaiting) {
			return;
		}

		var title = '',
			noSwap = false;

		switch(optType) {
			case 'VERISAVE':
				title = 'Verisave';
				noSwap = !!!item.NoVerisaveSwap;
				break;
			case 'MULTIVENDOR':
				title = 'Multi Vendor';
				noSwap = !!!item.NoMultiVendorSwap;
				break;
			default:
				throw new Error('orderNew.presplitToggleItem, unknown swap type: ' + optType);
		}

		msgSvc.confirm({
			id: item.ItemCode,
			title: title.toUpperCase() + ' CHANGE',
			msg: noSwap ? 'Do Not ' + title + ' this item?' : title + ' this item?',
			notes: {
				prompt: 'optional notes',
				maxlength: 100
			},
			buttons: [
				{text:'OK', result:'YES'},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

		function userConfirm(r) {
			if (!!r && r.result == 'YES') {
				var notes = validSvc.isText(r.notes) ? r.notes : '';
				item.Notes = notes;

				// toggle pre-split order item
				if(optType == 'VERISAVE') {
					item.NoVerisaveSwap = noSwap;
				}
				else {
					item.NoMultiVendorSwap = noSwap;
				}
				
				presplitSaveOrder();
			}
		}
	}

	function hasOptimizeItems(items) {
		// order has items which could be optimized
		items = Array.isArray(items) ? items : [];

		var item = {};
		for(var i = 0; i < items.length; i++) {
			item = items[i];
			if(item.OrderUnits > 0 && (!!!item.NoVerisaveSwap || !!!item.NoMultiVendorSwap)) {
				return true;
			}
		}
		return false;
	}

	function getPopupOverridesFromOrder(items) {
		// look in order items to find saved Optimized items
		if(!Array.isArray(items) || items.length < 1) {
			return [];
		}

		var overrides = [],
			optimize = {};
		items.forEach(function(item) {
			optimize = item.Optimize;
			if(optimize) {
				overrides.push({
					Id: item.Id,
					ItemUnits: item.UserUnits,
					ItemCode: optimize.ItemCode,
					VenDrugCode: optimize.VenDrugCode,
					Vendor: optimize.Vendor,
					Saving: optimize.Saving			
				});
			}
		});

		return overrides;
	}

	function optimizeEdit(editType, origItem, optionId) {
		if(vm.isWaiting || !!!vm.popup || !!!origItem) {
			return;
		}

		switch(editType) {
			case 'QTY':
				// modify original item qty
				if(!validSvc.isInteger(origItem.UserUnitsEdit) || origItem.UserUnitsEdit < 1) {
					msgSvc.ok('Cannot Update', 'Optimize quantity must be a positive integer greater than zero');
					return;
				}
				origItem.UserUnits = parseInt(origItem.UserUnitsEdit);
				break;

			case 'OPTION':
				// pick option
				if(!Array.isArray(origItem.Options) || !validSvc.isText(optionId)) {
					throw new Error('order.new.optimizeEdit, no options to edit for item: ' + origItem.Id);
				}
				if(origItem.UserUnitsEdit != origItem.UserUnits) {
					msgSvc.ok('Cannot Update', 'Quantity is changed from ' + origItem.UserUnits + ' to ' + origItem.UserUnitsEdit + ' but not saved, click quantity save first.');
					return;
				}
				origItem.useOriginal = optionId == 'ORIGINAL'; // do not optimize, use original
				origItem.Options.forEach(function(opt){
					opt.checked = opt.Id == optionId;
				});
				break;
			default:
				throw new Error('order.new.optimizeEdit, unknown editType: ' + editType);
		}
		vm.popup.edit = true;

		// create override (default is useOriginal)
		var override = {
			Id: origItem.Id,
			ItemUnits: origItem.UserUnits,
			ItemCode: origItem.ItemCode,
			VenDrugCode: origItem.VenDrugCode,
			Vendor: vm.order.Vendor,
			Saving: 0,
			Note: origItem.Note
		};

		// remove optimizations
		if(origItem.useOriginal) {
			override.NoVerisave = true;
			override.NoMultiVendor = true;
		}
		else if(!!!origItem.dropped) {
			// find option selected
			var option = origItem.Options.find(function(opt){
				return opt.checked;
			});
			if(!!!option) {
				msgSvc.ok('Cannot Save', 'Please choose an option first before adjusting quantity.');
				return;
			}
			override.ItemCode = option.ItemCode;
			override.VenDrugCode = option.VenDrugCode;
			override.Vendor = option.Vendor;
			override.Saving = option.Saving;
		}

		// add to overrides and call endpoint
		var foundOverrideIdx = vm.popup.Overrides.findIndex(function(ov){
			return ov.Id == origItem.Id;
		});
		if(foundOverrideIdx > -1) {
			vm.popup.Overrides[foundOverrideIdx] = override;
		}
		else {
			vm.popup.Overrides.push(override);
		}

		// prompt user for note on OPTION override
		if(editType == 'OPTION') {
			_pendingOverrideIdx = foundOverrideIdx > -1 ? foundOverrideIdx : vm.popup.Overrides.length - 1;
			var prepopulateNote = vm.popup.Overrides[_pendingOverrideIdx].Note;
			msgSvc.confirm({
				id: 'order.optimize.override',
				title: 'Optimize Selection',
				msg: 'Change Note',
				notes: {
					prompt: 'optional change note',
					maxlength: 100,
					out: prepopulateNote // pre-populate previous note on same override (user gets 1 note per override)
				},
				buttons: [
					{text:'SAVE NOTE', result:'SAVE'},
					{text:'CANCEL', result:'CANCEL', cancel: true}
				]
			}).then(userConfirmOptimizeChange, userConfirmOptimizeChange);	
		}
		else {
			optimizePreSplit();
		}

	}

	function userConfirmOptimizeChange(r) {
		if (!!!r || r.result != 'SAVE') {
			return;
		}

		// get override, set its note
		if(!!r && r.result == 'SAVE' && 
			_pendingOverrideIdx > -1 && !!vm.popup && Array.isArray(vm.popup.Overrides) &&
			vm.popup.Overrides.length > _pendingOverrideIdx) {
			vm.popup.Overrides[_pendingOverrideIdx].Note = validSvc.isText(r.notes) ? r.notes : '';
			_pendingOverrideIdx = -1;
		}

		// no matter what call optimize again
		optimizePreSplit();
	}

	function optimizeListVM(dataItems) {
		// API passes back optimized line items with options
		// UI will reconcile items with previous popup Items and Overrides
		var popItems = Array.isArray(vm.popup.Items) ? vm.popup.Items : [],
			overrides = Array.isArray(vm.popup.Overrides) ? vm.popup.Overrides : [],
			reconciledPopItems = [],
			reconciledOverrides = [],
			options = [],
			opt = {},
			i = 0,
			optionChosen = false;

		function optionMatch(ov, opt) {
			return !!ov && !!opt && ov.ItemCode == opt.ItemCode && ov.VenDrugCode == opt.VenDrugCode && ov.Vendor == opt.Vendor;
		}

		// loop original items
		dataItems.forEach(function(origItem) {
			origItem.useOriginal = false;
			origItem.UserUnits = origItem.ItemUnits;
			origItem.UserUnitsEdit = origItem.ItemUnits;
			optionChosen = false;

			// reconcile optimize items returned against previous popup items
			if(popItems.length > 0) {
				var popIdx = popItems.findIndex(function(popItem){
					return popItem.Id == origItem.Id;
				});
				if(popIdx > -1) {
					reconciledPopItems.push(origItem.Id);
				}
			}

			// find override for this original (if exists)
			var ovIdx = overrides.findIndex(function(ov){
				return ov.Id == origItem.Id;
			});
			var ov = ovIdx > -1 ? overrides[ovIdx] : undefined;

			// add note from override
			origItem.Note = !!ov && validSvc.isText(ov.Note) ? ov.Note : '';
      
			// user chose original
			if(!!ov && ov.NoVerisave && ov.NoMultiVendor) {
				origItem.useOriginal = true;
				reconciledOverrides.push(ov);
				optionChosen = true;
			}

			// loop optimize options
			options = Array.isArray(origItem.TopAlts) ? origItem.TopAlts : [];
			origItem.Options = [];
			origItem.TopSaving = 0;
			for(i = 0; i < options.length; i++) {
				opt = options[i];
				opt.BestOption = i == 0;
				opt.Id = 'opt' + i.toString();

				// check this option if it matches an overrride
				opt.checked = false;
				if(!optionChosen && !!ov && optionMatch(ov, opt)) {
					opt.checked = true;
					reconciledOverrides.push(ov);
					optionChosen = true;
				}
				opt.LastInvoice = validSvc.isDate( opt.LastInvoice) ? opt.LastInvoice : null; 
        
				if (opt.Saving >= 0 || vm.query.ReviewSubstitute) {
					origItem.Options.push(opt);
					if(opt.Saving > origItem.TopSaving) {
						origItem.TopSaving = opt.Saving;
					}
				}
			}

			// if user hasn't chosen an option choose the first one (highest Savings)
			if(!optionChosen) {
				// choose first option
				if(origItem.Options.length > 0) {
					origItem.Options[0].checked = true;
				}
			}
		});

		// items were dropped from the response
		if(popItems.length > 0 && reconciledPopItems.length < popItems.length) {
			popItems.forEach(function(popItem){
				if(reconciledPopItems.indexOf(popItem.Id) < 0) {
					// this item is dropped, add it back with no optimization choices
					popItem.dropped = true;
					popItem.Options = [];
					dataItems.push(popItem);

					var popOv = overrides.find(function(ov){
						return ov.Id == popItem.Id;
					});

					// get notes from the override (if any)
					popItem.Note = !!popOv && validSvc.isText(popOv.Note) ? popOv.Note : '';
					
					// tbd... add back a qty change (this is already applied to the popup item so below should not be needed)
					// if(!!popOv && popOv.ItemUnits > 0 && popOv.ItemUnits != popItem.UserUnits) {
					// 	reconciledOverrides.push({
					// 		Id: popItem.Id,
					// 		ItemUnits: popOv.ItemUnits,
					// 		ItemCode: popItem.ItemCode,
					// 		VenDrugCode: popItem.VenDrugCode,
					// 		Vendor: popItem.Vendor,
					// 		Saving: 0,
					// 		Note: ''
					// 	});
					// }
				}
			});
		}

		return {
			Items: dataItems,
			Overrides: reconciledOverrides
		};
	}

	function optimizePreSplit() {
		// get list of optimizations (Verisave and Multi Vendor)
		// VM format is 1 original to many options

		vm.isWaiting = true;
		msgSvc.wait(true);

		ordersRepo.optimizePreSplit(vm.order.Id, vm.popup.Overrides).then(okOptimize, errOptimize);

		function okOptimize(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			
			var parseOptimizeList = optimizeListVM(r);

			// nothing to optimize
			if(parseOptimizeList.Items.length < 1) {
				vm.popup = {};
				var msg = vm.order.UseBestCost ? ' Verisave' : '';
				msg += vm.order.UseMultiVendor ? msg.length > 0 ? ' or Multi Vendor' : 'Multi Vendor' : '';
				msgSvc.okAsync('Optimizations Not Found', 'No ' + msg + ' selections will be made for this order.', 'order.optimize.ok').then(asyncClosePopup, asyncClosePopup);
				return;
			}

			// refresh popup
			vm.popup.Items = parseOptimizeList.Items;
			vm.popup.Overrides = parseOptimizeList.Overrides;
			vm.popup.ready = true;
		}

		function errOptimize(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			vm.popup = {};

			if (!!r) {
				errSvc.warn('Unknown list response', 'orders.new.errOptimize', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function optimizeApplyToOrder() {
		// apply user optimize choices to the presplit order
		if(vm.isWaiting) {
			return;
		}

		// check for unfinished quantity editing
		var origItems = vm.popup.Items,
			qtyFail = false;
		origItems.forEach(function(origItem) {
			origItem.qtyFail = false;
			if(origItem.UserUnitsEdit != origItem.UserUnits) {
				origItem.qtyFail = true;
				qtyFail = true;
			}
		});
		if(qtyFail) {
			msgSvc.ok('Cannot Apply To Order', 'Save all optimized Quantity Edits before applying to order.');
			return;
		}

		msgSvc.confirm({
			id: 'order.optimize.apply',
			title: 'APPLY OPTIMIZATION',
			msg: 'Confirm optimizations to this order. This cannot be undone.',
			buttons: [
				{text:'OK', result:'YES'},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(optimizeApplyConfirm, optimizeApplyConfirm);
	}

	function optimizeApplyConfirm(r) {
		if (!!!r || r.result != 'YES') {
			return;
		}
		
		var orderItems = vm.order.Items,
			origItems = vm.popup.Items,
			ordItem = {};
		
		// loop popup items
		origItems.forEach(function(origItem) {

			// get order item
			ordItem = orderItems.find(function(ord){
				return ord.Id == origItem.Id;
			});

			// setup qty, notes, Optimize
			ordItem.UserUnits = origItem.UserUnits;
			ordItem.Notes = origItem.Note;
			ordItem.Optimize = {};
			
			// use original, do not optimize
			if(origItem.useOriginal) {
				ordItem.NoVerisaveSwap = true;
				ordItem.NoMultiVendorSwap = true;
			}
			else {
				// get option chosen
				var option = origItem.Options.find(function(op){
					return op.checked;
				});

				// don't add the Best option, api doesn't want the BestOption as an Optimization
				if(!!option && !option.BestOption)  {
					// apply Verisave
					if(!ordItem.NoVerisaveSwap) {
						ordItem.Optimize.ItemCode = option.ItemCode;
						ordItem.Optimize.VenDrugCode = option.VenDrugCode;
					}
	
					// apply Multi Vendor
					if(!ordItem.NoMultiVendorSwap) {
						ordItem.Optimize.Vendor = option.Vendor;
					}
	
					// apply savings
					if(!ordItem.NoVerisaveSwap || !ordItem.NoMultiVendorSwap) {
						ordItem.Optimize.Saving = option.Saving;
					}
				}
			}
		});

		// close popup
		vm.popup = {};

		// save order with optimizations
		presplitSaveOrder();
	}


	/**
	 * 	VERISAVE - replaced by OPTIMIZE, keep this JIC
	 *

	function verisaveListVM(dataItems) {
		dataItems = Array.isArray(dataItems) ? dataItems : [];
		var item = {},
			origItem = {};

		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.OrigItems = Array.isArray(item.OrigItems) ? item.OrigItems : [];
			for(var ii = 0; ii < item.OrigItems.length;ii++) {
				origItem.optimize = true;
				origItem = item.OrigItems[ii];
				origItem.NoVerisaveSwap = 'no';
				origItem.NoMultiVendorSwap = 'no';
			}
		}
		return dataItems;
	}

	function verisaveList() {
		// get list of verisave substitutions
		// VM format is 1 consolidated ndc to many original ndcs

		vm.isWaiting = true;
		msgSvc.wait(true);

		ordersRepo.verisaveList(vm.order.Id).then(okVerisaveList, errVerisaveList);

		function okVerisaveList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			
			var items = verisaveListVM(r);
			if(items.length < 1) {
				// use async so popup is dismissed before trying to render OK box
				vm.popup = {};
				msgSvc.okAsync('No Verisave', 'No Verisave selections will be made for this order.', 'order.verisave.ok').then(asyncClosePopup, asyncClosePopup);
			}
			else {
				vm.popup.Items = items;
				vm.popup.ready = true;
			}
		}

		function errVerisaveList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if (!!r) {
				errSvc.error('Unknown list response', 'orders.new.errVerisaveList', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function verisaveToggle(item) {
		var newState = 'YES';
		var title = 'CONFIRM VERISAVE?';
		var message = 'Verisave this line item?';
		if (item.checked == 'yes') {
			newState = 'NO';
			title = "DO NOT VERISAVE?";
			message = 'Do not Verisave this line item?';
		}
		var conf = {
			id: item.ItemCode,
			title: title,
			msg: message,
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		};
		conf.notes = {
			prompt: 'optional notes',
			maxlength: 100,
			out: ''
		};
		msgSvc.confirm(conf).then(userConfirm, userConfirm);

		function userConfirm(r) {
			if (!!r && r.result == 'YES') {
				item.checked = item.checked == 'yes' ? item.checked = 'no' : 'yes';
				var notes = validSvc.isText(r.notes) ? r.notes : '';
				item.notes = notes;
				if(!vm.popup.hasEdits && item.checked == 'no') {
					vm.popup.hasEdits = true;
				}
			}
		}
	}

	function toggleNoVerisaveSwap(item) {
		event.stopPropagation();
		var newState = 'YES';
		var title = 'CONFIRM VERISAVE?';
		var message = 'Verisave this line item?';
		if (!!!item.NoVerisaveSwap) {
			newState = 'NO';
			title = "DO NOT VERISAVE?";
			message = 'Do not Verisave this line item?';
		}
		var conf = {
			id: item.ItemCode,
			title: title,
			msg: message,
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		};
		conf.notes = {
			prompt: 'optional notes',
			maxlength: 100,
			out: ''
		};
		msgSvc.confirm(conf).then(userConfirm, userConfirm);

		function userConfirm(r) {
			if (!!r && r.result == 'YES') {
				item.NoVerisaveSwap = !!!item.NoVerisaveSwap;
				var notes = validSvc.isText(r.notes) ? r.notes : '';
				item.Notes = notes;
				vm.presplitSaveOrder();
			}
		}
	}
	*/

	function asyncClosePopup() {
		closePopup();
	}

	/**
	 * 		ASSAY
	 */
	function assayEdit(item) {
		var qty = parseInt(item.AssayQty),
			au = parseInt(item.AssayUnits);

		if(validSvc.isInteger(qty) && validSvc.isInteger(au) && qty > 0 && au > 0) {
			item.AssayTotalUnits = au * qty;
		}
		else {
			item.AssayTotalUnits = 0;
		}
	}

	function assayAddToCart(item) {
		if(vm.isWaiting) {
			return;
		}

		function validInt(val) {
			if(validSvc.isInteger(item.AssayQty)) {
				val = parseInt(val);
				if(val >= 1 && val <= 1000000) {
					return val;
				}
			}
			return 0;
		}

		// validate assay totals
		var assayQty = validInt(item.AssayQty),
			assayUnits = validInt(item.AssayUnits);
		if(assayQty < 1) {
			msgSvc.ok('Cannot Add', 'Order Pkgs is requried number between 1 and 1,000,000');
			return;
		}
		if(assayUnits < 1) {
			msgSvc.ok('Cannot Add', 'Units Per Pkg is requried number between 1 and 1,000,000');
			return;
		}
		var assayTotalUnits = assayQty * assayUnits;

		// get accumulator
		var accumIdx = findAssayIdxByNdc(item.ItemCode);
		if(accumIdx < 0) {
			throw new Error('orderNewCtl.assayAddToCart, assay Accumulator not found for ndc: ' + item.ItemCode);
		}
		var accumItem = vm.accum.Items[accumIdx];

		// qty available
		if(assayTotalUnits > accumItem.ItemUnits) {
			msgSvc.ok('Cannot Add', 'Order Units are greater than Units Available');
			return;
		}

		// create new order item
		var orderItem = JSON.parse(JSON.stringify(accumItem)); // copy accum item, not display item
		orderItem.uniqueId = 'OID' + Date.now().toString() + '-' + accumIdx.toString();
		orderItem.isDirty = true;
		orderItem.fail = false;
		orderItem.msg = '';
		
		// add assay properties, push to cart
		orderItem.AssayQty = assayQty;
		orderItem.AssayUnits = assayUnits;
		orderItem.AssayTotalUnits = assayTotalUnits;
		orderItem.LotExpiration = validSvc.isDate(item.LotExpiration) ? utilSvc.dt.toText(new Date(item.LotExpiration)) : null;
		orderItem.VenDrugCode = item.VenDrugCode;
		orderItem.LotNumber = item.LotNumber;
		
		// add spoof validation properties (regular order uses UserUnits for validation)
		orderItem.UserUnits = assayQty;
		orderItem.ItemUnits = assayQty; // spoof available

		vm.order.Items.push(orderItem);

		// adjust accum and display remainder
		accumItem.ItemUnits -= orderItem.AssayTotalUnits;
		item.AssayRemainder = accumItem.ItemUnits;

		// reset display editing
		item.AssayTotalUnits = 0;
		item.AssayQty = 0;
		item.fail = false;
		item.msg = '';

		// adjust number of items in cart
		var ndcOnOrder = ndcCartInfo(item.ItemCode);
		item.AssayInCart = ndcOnOrder.count;

		// update grand total
		vm.assay.totalAssayQty += assayQty;
		vm.assay.totalAssayUnits += assayTotalUnits;

		addToCartAnim(item.VenLabel);
	}

	function findAssayIdxByUniqueId(uid) {
		var items = Array.isArray(vm.order.Items) ? vm.order.Items : [];
		for(var i = 0; i < items.length; i++) {
			if(items[i].uniqueId == uid) {
				return i;
			}
		}
		return -1;
	}

	function findAssayIdxByNdc(ndc) {
		var items = Array.isArray(vm.accum.Items) ? vm.accum.Items : [];
		for(var i = 0; i < items.length; i++) {
			if(items[i].ItemCode == ndc) {
				return i;
			}
		}
		return -1;
	}

	function assayRemoveFromCart(item) {
		if(vm.isWaiting) {
			return;
		}

		// find in cart by unique id
		var orderIdx = findAssayIdxByUniqueId(item.uniqueId);
		if(orderIdx < 0) {
			throw new Error('orderNewCtl.assayRemoveFromCart, assay order item not found for unique id: ' + item.uniqueId);
		}

		// adjust accumulation
		var accumIdx = findAssayIdxByNdc(item.ItemCode);
		if(accumIdx < 0) {

			// no accum for this ndc, add item back to vm.accum Items
			var accumItem = JSON.parse(JSON.stringify(item));
			accumItem.uniqueId = 'AID' + Date.now().toString() + '-' + vm.accum.Items.length.toString();
			accumItem.AssayQty = 0;
			accumItem.AssayUnits = 0;
			accumItem.AssayTotalUnits = 0;
			accumItem.LotExpiration = '';
			
			accumItem.AssayInCart = 0;
			accumItem.AssayRemainder = item.AssayTotalUnits;
			accumItem.ItemUnits = item.AssayTotalUnits;
			vm.accum.Items.push(accumItem);
		}
		else {
			vm.accum.Items[accumIdx].ItemUnits += item.AssayTotalUnits;
		}

		// update grand total
		vm.assay.totalAssayQty -= item.AssayQty;
		vm.assay.totalAssayUnits -= item.AssayTotalUnits;

		// remove from order
		vm.order.Items.splice(orderIdx, 1);

		// nothing left in cart, go back to accum
		if(vm.order.Items.length < 1) {
			tabChange('ASSAY');
		}
		else {
			tabChange('ASSAY_ORDER');
		}
	}


	/**
	 *    HELPERS
	 */

	function routeNavTo(action, orderId, reload) {

		// nav to route by action type

		switch(action) {
			case 'LIST':
				$state.go('orders.list', {}, {reload: 'orders.list'});
				break;
			case 'UPDATE':
				$state.go('orders.edit', {id: orderId}, {reload: 'orders.edit'});
				break;
			case 'PRESPLIT':
				$state.go('orders.presplit', {id: orderId}, {reload: 'orders.presplit'});
				break;
			case 'PLACE':
				$state.go('orders.place', {id: orderId}, {reload: 'orders.place'});
				break;
			case 'CANCEL':
				$state.go('orders.cancel', {id: orderId}, {reload: 'orders.cancel'});
				break;
			case 'VIEW':
				$state.go('orders.view', {id: orderId}, {reload: 'orders.view'});
				break;

			default:
				throw new Error('ordersNewCtl.routeNavTo, unknown router action: ' + action);
		}

	}

	function navToFeature(navType, navData) {
		if (vm.isWaiting) {
			return;
		}

		var breadcrumb = {};
		breadcrumb = {
			icon: 'sprite-history',
			route: 'orders.place',
			routeData: {id: vm.order.Id},
			msg: 'Return to Order Detail'
		};

		var morder = {
			CE: vm.order.CEID,
			RX: vm.order.RXID,
			Vendor: vm.order.VENID,
			AccumGrp: vm.order.AcctType,
			PoName: vm.order.Name,
			PoDt: vm.order.CreatedOn,
			DirectReplenish: vm.order.DirectReplenish,
			DontInvoiceDrugs: vm.order.CeKeep == 'KEEP',
			Items:[]
		};
		if (!!vm.order.Items) {
			for(var i=0; i<vm.order.Items.length; i++){
				var item = {
					ItemCode: vm.order.Items[i].ItemCode,
					Description: vm.order.Items[i].VenLabel,
					VendItemNum: vm.order.Items[i].VenDrugCode,
					OrderedUnits: vm.order.Items[i].UserUnits,
					PriorUnits: vm.order.Items[i].InvoicedUnits,
					UnitPrice: vm.order.Items[i].Price,
					IsAssay: vm.order.Items[i].IsAssay,
				};
				if (item.PriorUnits < item.OrderedUnits) {
					morder.Items.push(item);
				}
			}
		}

		switch (navType) {
			case 'ADDINVOICE':
				var params = {
					order: morder,
					breadcrumb: breadcrumb
				};
				$state.go('invoice.add', params, { reload: 'invoice.add' });
				break;
			default:
				alert('order.new.ctl.navToFeature, unknown navType: ' + navType);
		}
	}

	function transferQtyValid(qty, maxQty, showUI) {

		// transfer methods call this helper to validate the user entered qty

		// params
		if(!validSvc.isInteger(maxQty)) {
			throw new Error('order.new.ctl.transferQtyValid, max qty is not an integer: ' + maxQty);
		}

		// valid user entry
		if(validSvc.isInteger(qty) && qty > 0 && qty <= maxQty) {
			return true;
		}
		else if(showUI) {
			msgSvc.ok('Quantity Check', 'Quantity must be a number greater than 0 and no more than ' + maxQty);
		}

		return false;

	}

	function findItembyNDC(ndc, items) {
		for(var i = 0; i < items.length; i++) {
			if(items[i].ItemCode === ndc) {
				return i;
			}
		}
		return -1;
	}

	function findItembyVenItemNum(vin, items) {
		for(var i = 0; i < items.length; i++) {
			if(items[i].VendItemNum === vin) {
				return i;
			}
		}
		return -1;
	}

	function onOrderQty(ndc) {
		var idx = findItembyNDC(ndc, _onOrderQty);
		if(idx > -1) {
			return _onOrderQty[idx].ItemUnits;
		}
		else {
			return 0;
		}
	}

	function filterSwapToCERX(query) {
		return {
			CE: _primaryProp == 'CE' ? vm.query.primary.val : vm.query.secondary.val,
			RX: _primaryProp == 'RX' ? vm.query.primary.val : vm.query.secondary.val
		};
	}

	vm.hasNegativeSavings = function(opItemOrig) {
		return opItemOrig.Options && 
		       opItemOrig.Options.some(function(opt) { 
		           return opt.Saving < 0; 
		       });
	};

	function orderCategoryTitle(orderCat, accumSearchAll) {
		switch(orderCat) {
			case 'STANDARD':
				return !!accumSearchAll ? 'Standard w/ Drop-ship, Specialty' : 'Standard';
			case 'DROPSHIP':
				return 'Drop-ship';
			case 'SPECIALTY':
				return 'Specialty';
			case 'ASSAY':
				return 'Assay';
			default:
				return 'Standard';				
		}
	}
}
 
ordersNewSplitCtl.$inject = ['$window', '$state', '$rootScope', '$scope', '$timeout', 'ordersRepo', 'lookupRepo', 'prefsRepo', 'sessionRepo', 'eventSvc', 'msgSvc', 'utilSvc', 'validSvc', 'errSvc'];
angular
.module('espui.orders')
.controller('OrdersNewSplitCtl', ordersNewSplitCtl);


/* @ngInject */
function ordersNewSplitCtl($window, $state, $rootScope, $scope, $timeout, ordersRepo, lookupRepo, prefsRepo, sessionRepo, eventSvc, msgSvc, utilSvc, validSvc, errSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _primaryProp = 'CE';

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.isSEQ = false;

	// droplists
	vm.primaryDroplist = [];
	vm.secondaryDroplist = [];
	vm.VenDroplist = [];

	// query
	vm.query = {};
	vm.queryChangePrimary = queryChangePrimary;
	vm.queryChangeSecondary = queryChangeSecondary;
	vm.queryChangeVEN = queryChangeVEN;

	// submit
	vm.createNewSplitOrder = createNewSplitOrder;

	// query filter swap
	vm.queryFilterSwap = queryFilterSwap;

	// tabs
	vm.order = {};

	// popup
	vm.popup = {};

	// rxlookup
	vm.rxSequentialOptions = [];
	vm.rxSequentialOptionsVendorMap = {};

	/**
	 *    INIT
	 */

	init();

	function init() {

		vm.init = true;
		vm.action = 'CREATE';

		vm.query = ordersRepo.queryVM();
		initFilterSwap(vm.query);

		// CREATE
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		var affs = getAffs();
		var rxList = utilSvc.aff.rxList(affs);
		checkRxSequentialSplit(rxList, function() {
			initPrimaryDroplist(vm.query);
			queryChangePrimary();	
		});

		vm.init = false;
	}

	function getAffs() {
		var accts = ['340B', 'GPO', 'WAC', 'IND', 'OWN'],
			bizModels = ['SPLIT', 'SPLITMATCH'];

		// ordering affiliates
		var affs = utilSvc.aff.findStatus($scope.User.AffList, ['ACTIVE']);
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
		affs = utilSvc.aff.findRxModel(affs, bizModels);
		affs = utilSvc.aff.findVenType(affs, accts, true);

		return affs;
	}

	function initFilterSwap(query) {

		// transfer ceid/rxid from query into filter swap primary/secondary format

		// get saved user pref
		_primaryProp = $rootScope.User.FilterSwap.OrderNew;
		if(_primaryProp != 'RX' && _primaryProp != 'CE') {
			_primaryProp = 'CE'; // default
		}

		query.primaryLabel = _primaryProp == 'RX' ? 'Pharmacy' : 'Facility';
		query.primary = validSvc.newProp(_primaryProp == 'RX' ? query.RX.val : query.CE.val);
		query.primaryName = '';
		vm.primaryDroplist = utilSvc.ng.droplistNONE();

		query.secondaryLabel = _primaryProp == 'RX' ? 'Facility' : 'Pharmacy';
		query.secondary = validSvc.newProp(_primaryProp == 'RX' ? query.CE.val : query.RX.val);
		query.secondaryName = '';
		vm.secondaryDroplist = utilSvc.ng.droplistNONE();

	}

	function initPrimaryDroplist(query) {

		// CREATE uses query droplists, setup Primary droplist

		if(_primaryProp == 'RX') {
			vm.primaryDroplist = utilSvc.aff.rxDroplist(getAffs());
		}
		else {
			vm.primaryDroplist = utilSvc.aff.ceDroplist(getAffs());
		}
		query.primary = utilSvc.ng.droplistAutoselect(vm.primaryDroplist, query.primary.val);

	}

	/**
	 *    QUERY FILTER SWAP
	 */

	function queryFilterSwap() {

		if(vm.isWaiting) {
			return;
		}

		// remember ce/rx before swap
		var x = filterSwapToCERX(vm.query);

		// swap, update scope and session
		_primaryProp = _primaryProp == 'CE' ? 'RX' : 'CE';
		$rootScope.User.FilterSwap.OrderNew = _primaryProp;
		sessionRepo.set('User', $rootScope.User);

		// reset view and query
		vm.query.CE = validSvc.newProp(x.CE);
		vm.query.RX = validSvc.newProp(x.RX);
		initFilterSwap(vm.query);

		initPrimaryDroplist(vm.query);
		queryChangePrimary();

		$timeout(function() {
			// save user pref to db (run this after get available items runs)
			prefsRepo.save('FILTERSWAP', angular.toJson($rootScope.User.FilterSwap)).then(okSavePref, errSavePref);
		}, 300);

	}

	function okSavePref(r) {
		// no action
	}

	function errSavePref(r) {
		if(!!r) {
			errSvc.warn('Unknown api error during filter swap preference save', 'orderNewCtl.filterSwap', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    QUERY CHANGE EVENTS
	 */

	function queryChange() {
		vm.query.ready = false;
		vm.query.PoName = validSvc.newProp('');
	}

	function queryChangePrimary() {

		queryChange();
		vm.secondaryDroplist = utilSvc.ng.droplistNONE();
		vm.VenDroplist = utilSvc.ng.droplistNONE();
		vm.query.SeqSplit = false;

		vm.query.primary.fail = validSvc.isEntity(vm.query.primary.val) ? 'no' : 'yes';
		if(vm.query.primary.fail == 'yes') {
			vm.secondary = validSvc.newProp('NONE');
			vm.query.VEN = validSvc.newProp('NONE');
			vm.query.AcctType = validSvc.newProp('NONE');
			return;
		}

		var affs = getAffs();

		// primary is RX?
		if(_primaryProp == 'RX') {
			vm.query.RX = validSvc.newProp(vm.query.primary.val);

			// limit affs to this RX
			affs = utilSvc.aff.findRx(affs, vm.query.primary.val);

			// get RX business models
			vm.query.RxBizModels = utilSvc.aff.rxModelList(affs);
			var accts = ['340B','IND'];
			if(vm.query.RxBizModels.indexOf('SPLIT') > -1 || vm.query.RxBizModels.indexOf('SPLITMATCH') > -1) {
				vm.query.RxSplit = true;
				accts.push('GPO');
				accts.push('WAC');
			}

			if(vm.rxSequentialOptions.indexOf(vm.query.RX.val) > -1) {
				vm.query.SeqSplit = true;
			}

			// limit CE options by RX biz model + vendor accounts
			affs = utilSvc.aff.findVenType(affs, accts, true);

			// CE options
			vm.secondaryDroplist = utilSvc.aff.ceDroplist(affs);
		}
		else {
			vm.query.CE = validSvc.newProp(vm.query.primary.val);

			// RX options
			vm.secondaryDroplist = utilSvc.aff.rxDroplist(affs, vm.query.primary.val);
		}

		// Skip CE selection when order is sequential splitting, use first CE from list
		if (vm.query.SeqSplit && vm.secondaryDroplist.length > 1) {
			vm.secondaryDroplist = vm.secondaryDroplist.slice(0, 2);
		}
		vm.query.secondary = utilSvc.ng.droplistAutoselect(vm.secondaryDroplist, vm.query.secondary.val);
		queryChangeSecondary();

	}

	function queryChangeSecondary() {
		queryChange();
		vm.VenDroplist = utilSvc.ng.droplistNONE();

		vm.query.secondary.fail = validSvc.isEntity(vm.query.secondary.val) ? 'no' : 'yes';
		if(vm.query.secondary.fail == 'yes') {
			vm.query.VEN = validSvc.newProp('NONE');
			vm.query.AcctType = validSvc.newProp('NONE');
			return;
		}

		var affs = getAffs(),
			accts = ['340B','IND'];

		// limit affs to this CE/RX
		var x = filterSwapToCERX(vm.query);
		affs = utilSvc.aff.findCe(affs, x.CE);
		affs = utilSvc.aff.findRx(affs, x.RX);

		// secondary is RX, get RX business models
		if(_primaryProp == 'CE') {
			vm.query.RX = validSvc.newProp(vm.query.secondary.val);

			// Is this query for a split? Defaults to false
			vm.query.RxSplit = false;
			vm.query.RxBizModels = utilSvc.aff.rxModelList(affs);
			if(vm.query.RxBizModels.indexOf('SPLIT') > -1 || vm.query.RxBizModels.indexOf('SPLITMATCH') > -1) {
				vm.query.RxSplit = true;
			}
		}
		else {
			vm.query.CE = validSvc.newProp(vm.query.secondary.val);
		}

		// include splitting accounts?
		if(vm.query.RxSplit) {
			accts.push('GPO');
			accts.push('WAC');
			accts.push('OWN');
		}

		// VENDOR options
		x = filterSwapToCERX(vm.query);
		var venOptions = !!!vm.query.SeqSplit ? utilSvc.aff.venOptions(affs, x.CE, x.RX, accts, true) : [vm.rxSequentialOptionsVendorMap[x.RX]];
		vm.VenDroplist = utilSvc.ng.droplist(
			venOptions,
			'',
			'',
			[{label:'Choose a Vendor', value:'NONE'}]);
		vm.query.VEN = utilSvc.ng.droplistAutoselect(vm.VenDroplist, vm.query.VEN.val);

		queryChangeVEN();

	}

	function queryChangeVEN() {

		queryChange('VENDOR');

		vm.query.VEN.fail = validSvc.isVEN(vm.query.VEN.val) ? 'no' : 'yes';
		if(vm.query.VEN.fail == 'yes') {
			vm.query.AcctType = validSvc.newProp('NONE');
			return;
		}

		// build droplist
		vm.query.ready = true;
		updateUserChoice();
	}

	function createNewSplitOrder() {
		// valid query
		if(!validSvc.isText(vm.query.PoName.val)) {
			msgSvc.ok('Split Order Create', 'Order Name cannot be empty');
			return;
		}
		vm.query.PoName.val = vm.query.PoName.val.toUpperCase();
		
		// already waiting?
		if(vm.isWaiting) {
			return;
		}
		
		// confirm create order
		msgSvc.confirm({
			id: 'orders.newsplit.confirm.create',
			title: 'Create Split Order',
			msg: 'Create Split Order with name ' + vm.query.PoName.val + ' ?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(msgConfirm, msgConfirm);

		function msgConfirm(r) {
			// user said yes
			if(!!r && r.result == 'YES') {
				vm.isWaiting = true;
				createSplitOrderApi();
			}
		}

		function createSplitOrderApi() {
			ordersRepo.orderCreateSplit(vm.query).then(okUpsert, errUpsert);
		}

	}

	function okUpsert(r) {
		vm.isWaiting = false;

		if(!!!r.Id) {
			throw new Error('order.new.ctl.okUpsert.doneUpsert, missing id');
		} else {
			msgSvc.ok('Split Order Created');
			$state.go('orders.presplit', {id: r.Id}, {reload: 'orders.presplit'});
		}
		vm.query.PoName = validSvc.newProp('');
	}

	function errUpsert(r) {
		vm.isWaiting = false;

		if(r === null) {
			// already handled
		}
		else if(r.status == 409) {
			// conflict
			msgSvc.ok('Cannot Save Order', 'PO name already exists. Please verify and try again.');
		}
		else if (r.status == 422) {
			var aggMsg = "";
			for(var i=0; i < r.data.Entity.Fields.length;i++) {
				aggMsg += r.data.Entity.Fields[i].Rule + "\n";
			}
			msgSvc.ok('Cannot Save Order', aggMsg, 'orders.save.422');
			vm.query = r.query;
		}
		else {
			errSvc.error('Unexpected api error', 'order.edit.errUpsert', r.status, utilSvc.http.safeResponse(r));
		}

	}

	function checkRxSequentialSplit(rxs, callback) {
		lookupRepo.RxInfo(rxs).then(okRxLookup, errRxLookup);

		function okRxLookup(r) {
			var rxList = r;
			for (var i=0;i<rxList.length;i++) {
				if(rxList[i].SequentialSplit) {
					vm.rxSequentialOptions.push(rxList[i].NickName);
					vm.rxSequentialOptionsVendorMap[rxList[i].NickName] = rxList[i].CustomPriceVendor;
				}
			}
			callback();
		}

		function errRxLookup(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;
			errSvc.error('Unknown get response', 'orders.new.ctl.rxlookup', r.status, utilSvc.http.safeResponse(r));
		}
	}

	function filterSwapToCERX(query) {
		return {
			CE: _primaryProp == 'CE' ? vm.query.primary.val : vm.query.secondary.val,
			RX: _primaryProp == 'RX' ? vm.query.primary.val : vm.query.secondary.val
		};
	}

	function updateUserChoice() {
		// update CE and Rx user choice
		eventSvc.rootEmit('context.change', {
			CE: vm.query.CE.val,
			RX: vm.query.RX.val,
			VEN: vm.query.VEN.val,
		});
	}
}

 
ordersSplitDetailCtl.$inject = ['$state', '$scope', '$rootScope', '$timeout', 'ordersRepo', 'msgSvc', 'utilSvc', 'validSvc', 'errSvc'];angular
.module('espui.orders')
.controller('OrdersSplitDetailCtl', ordersSplitDetailCtl);

/* @ngInject */
function ordersSplitDetailCtl($state, $scope, $rootScope, $timeout, ordersRepo, msgSvc, utilSvc, validSvc, errSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _parentOrderId = '',
		_focusOrderId = '',
		_showFocusOrder = 'init',
		_pagingEventListener = null,
		_pending = {};

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	msgSvc.addHelpLink(vm);
	
	// properties
	vm.isSEQ = false;
	vm.userCanEdit = false;
	vm.action = '';
	vm.isWaiting = false;
	vm.isVeriSaveOnly = false;

	// models
	vm.order = {};
	vm.splitInfo = {};
	vm.tbl = {};
	vm.focusOrder = null;

	// filters
	vm.flt = {};
	vm.fltSplitDetail = {};
	vm.filterChange = filterChange;
	
	// order editing
	vm.placeOrder = placeOrder;
	vm.cancelOrder = cancelOrder;
	vm.lineQtyUpdate = lineQtyUpdate;
	vm.removeNonPriceSelect = removeNonPriceSelect;

	// popup
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;
	vm.popup.flt = {};
	vm.popup.fltSplitDetail = {};

	// popup for line item qty edits
	vm.popupLineItem = {};
	vm.openPopupLineItem = openPopupLineItem;
	vm.closePopupLineItem = closePopupLineItem;

	// focus order
	vm.setFocusOrder = setFocusOrder;

	// split log
	vm.getSplitLog = getSplitLog;

	// add invoice
	vm.canAddInvoice = false;
	vm.everInvoiced = false;

	// savings
	vm.ShowSavingsView = ShowSavingsView;

	vm.navToFeature = navToFeature;

	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});


	/**
	 *    DESTROY
	 */
	$scope.$on('$destroy', function() {

		if(_pagingEventListener) {
			_pagingEventListener();
		}

	});


	/**
	 *    INIT
	 */

	init();

	function init() {
		var params = $state.params;
		if(!!!params || !validSvc.isText(params.id)) {
			throw new Error('ordersSplitDetailCtl.init, missing params.id');
		}

		vm.isVeriSaveOnly = !!$scope.User.VeriSaveOnly;

		// SPLIT parent has no parent id, a specific order to focus on will always have a parent id
		_parentOrderId = validSvc.isText(params.parentId) ? params.parentId : params.id;
		_focusOrderId = validSvc.isText(params.parentId) ? params.id : '';

		// routing, breadcrumbing
		$state.current.routeInfo = $state.current.routeInfo || {};
		var routeInfo = angular.fromJson(angular.toJson($state.current.routeInfo));
		if(!!params.breadcrumb) {
			// must be cleared when navigating using a breadcrumb
			$rootScope.$emit('espui>route.reset', {route: $state.current.name});
			routeInfo.breadcrumb = params.breadcrumb;
		}

		// main title
		$scope.$emit('shared.main.setInfo', routeInfo);

		// user edit claim
		vm.userCanEdit = utilSvc.user.hasFeature($scope, 'orders.edit');

		// setup filter once
		vm.flt = vm.initFilters({
			SortBy: ['ItemCode']
		});
		vm.fltSplitDetail = vm.initFilters();

		getSplitOrder();
	}


	/**
	 *    VIEW MODELS
	 */

	function hasEdits(item) {
		// line item has qty change from original

		if(item.acct340B_OriginalItemUnits == item.acct340B_ItemUnits &&
			item.acctGPO_OriginalItemUnits == item.acctGPO_ItemUnits &&
			item.acctOWN_OriginalItemUnits == item.acctOWN_ItemUnits &&
			item.acctWACMED_OriginalItemUnits == item.acctWACMED_ItemUnits &&
			item.acctWAC_OriginalItemUnits == item.acctWAC_ItemUnits) {
				return false;
		}
		else {
			return true;
		}
	}

	function vendorDrugCodeSwaps(item, originalDrugCode) {
		// build vendor drug code swap list if any drug code doesn't match the original code

		var result = [];

		// missing original code
		if(!validSvc.isText(originalDrugCode)) {
			return result;
		}
		
		var testCode = item.acct340B_VenDrugCode;
		if(validSvc.isText(testCode) && testCode != originalDrugCode) {
			result.push({acct: '340B', code: testCode});
		}
		testCode = item.acctGPO_VenDrugCode;
		if(validSvc.isText(testCode) && testCode != originalDrugCode) {
			result.push({acct: 'GPO', code: testCode});
		}
		testCode = item.acctOWN_VenDrugCode;
		if(validSvc.isText(testCode) && testCode != originalDrugCode) {
			result.push({acct: 'OWN', code: testCode});
		}
		testCode = item.acctWACMED_VenDrugCode;
		if(validSvc.isText(testCode) && testCode != originalDrugCode) {
			result.push({acct: 'WACMED', code: testCode});
		}
		testCode = item.acctWAC_VenDrugCode;
		if(validSvc.isText(testCode) && testCode != originalDrugCode) {
			result.push({acct: 'WAC', code: testCode});
		}
		
		return result;
	}

	function addEmptyCEDetails(item) {
		// some items might be missing CEDetails, build an empty flattened item

		item.acct340B_Id = '';
		item.acct340B_OriginalItemUnits = 0;
		item.acct340B_ItemUnits = 0;
		item.acct340B_InvoicedUnits = 0;
		item.acct340B_UnitPrice = 0;
		item.acct340B_TotalPrice = 0;
		item.acct340B_VenDrugCode = '';

		item.acctGPO_Id = '';
		item.acctGPO_OriginalItemUnits = 0;
		item.acctGPO_ItemUnits = 0;
		item.acctGPO_InvoicedUnits = 0;
		item.acctGPO_UnitPrice = 0;
		item.acctGPO_TotalPrice = 0;
		item.acctGPO_VenDrugCode = '';

		item.acctOWN_Id = '';
		item.acctOWN_OriginalItemUnits = 0;
		item.acctOWN_ItemUnits = 0;
		item.acctOWN_InvoicedUnits = 0;
		item.acctOWN_UnitPrice = 0;
		item.acctOWN_TotalPrice = 0;
		item.acctOWN_VenDrugCode = '';

		item.acctWACMED_Id = '';
		item.acctWACMED_OriginalItemUnits = 0;
		item.acctWACMED_ItemUnits = 0;
		item.acctWACMED_InvoicedUnits = 0;
		item.acctWACMED_UnitPrice = 0;
		item.acctWACMED_TotalPrice = 0;
		item.acctWACMED_VenDrugCode = '';

		item.acctWAC_Id = '';
		item.acctWAC_OriginalItemUnits = 0;
		item.acctWAC_ItemUnits = 0;
		item.acctWAC_InvoicedUnits = 0;
		item.acctWAC_UnitPrice = 0;
		item.acctWAC_TotalPrice = 0;
		item.acctWAC_VenDrugCode = '';

		item.AckMsg = '';

		// quantity editing off
		item.acct340B_CanEdit = false;
		item.acctGPO_CanEdit = false;
		item.acctOWN_CanEdit = false;
		item.acctWACMED_CanEdit = false;
		item.acctWAC_CanEdit = false;

		return item;
	}

	function flattenAcctProps(item, isSEQ, isParentOrder, regularSplitDetails) {
		// convert sub-objects into flattened properties for html bind

		// need this to get the order type Id from CEDetails on parent order items
		var isRegularSplit = !!!isSEQ && !!isParentOrder && !!regularSplitDetails;

		item.acct340B_Id = isRegularSplit ? regularSplitDetails.SplitDetails340B.Id : item.SplitDetails340B.Id;
		item.acct340B_OriginalItemUnits = item.SplitDetails340B.SplitOrigItemUnits;
		item.acct340B_ItemUnits = item.SplitDetails340B.ItemUnits;
		item.acct340B_UnitPrice = (!!!item.SplitDetails340B.UnitPrice && (isRegularSplit || !isParentOrder)) ? regularSplitDetails.Price340B : item.SplitDetails340B.UnitPrice;
		item.acct340B_TotalPrice = item.SplitDetails340B.TotalPrice;
		item.acct340B_VenDrugCode = item.SplitDetails340B.VendItemNum;
		item.acct340B_InvoicedUnits = item.SplitDetails340B.InvoicedUnits;

		item.acctGPO_Id = isRegularSplit ? regularSplitDetails.SplitDetailsGPO.Id : item.SplitDetailsGPO.Id;
		item.acctGPO_OriginalItemUnits = item.SplitDetailsGPO.SplitOrigItemUnits;
		item.acctGPO_ItemUnits = item.SplitDetailsGPO.ItemUnits;
		item.acctGPO_UnitPrice = (!!!item.SplitDetailsGPO.UnitPrice && (isRegularSplit || !isParentOrder)) ? regularSplitDetails.PriceGPO : item.SplitDetailsGPO.UnitPrice;
		item.acctGPO_TotalPrice = item.SplitDetailsGPO.TotalPrice;
		item.acctGPO_VenDrugCode = item.SplitDetailsGPO.VendItemNum;
		item.acctGPO_InvoicedUnits = item.SplitDetailsGPO.InvoicedUnits;

		item.acctOWN_Id = isRegularSplit ? regularSplitDetails.SplitDetailsOWN.Id : item.SplitDetailsOWN.Id;
		item.acctOWN_OriginalItemUnits = item.SplitDetailsOWN.SplitOrigItemUnits;
		item.acctOWN_ItemUnits = item.SplitDetailsOWN.ItemUnits;
		item.acctOWN_UnitPrice = (!!!item.SplitDetailsOWN.UnitPrice && (isRegularSplit || !isParentOrder)) ? regularSplitDetails.PriceWAC : item.SplitDetailsOWN.UnitPrice;
		item.acctOWN_TotalPrice = item.SplitDetailsOWN.TotalPrice;
		item.acctOWN_VenDrugCode = item.SplitDetailsOWN.VendItemNum;
		item.acctOWN_InvoicedUnits = item.SplitDetailsOWN.InvoicedUnits;

		item.acctWACMED_Id = isRegularSplit ? regularSplitDetails.SplitDetailsWACMED.Id : item.SplitDetailsWACMED.Id;
		item.acctWACMED_OriginalItemUnits = item.SplitDetailsWACMED.SplitOrigItemUnits;
		item.acctWACMED_ItemUnits = item.SplitDetailsWACMED.ItemUnits;
		item.acctWACMED_UnitPrice = (!!!item.SplitDetailsWACMED.UnitPrice && (isRegularSplit || !isParentOrder)) ? regularSplitDetails.PriceWAC : item.SplitDetailsWACMED.UnitPrice;
		item.acctWACMED_TotalPrice = item.SplitDetailsWACMED.TotalPrice;
		item.acctWACMED_VenDrugCode = item.SplitDetailsWACMED.VendItemNum;
		item.acctWACMED_InvoicedUnits = item.SplitDetailsWACMED.InvoicedUnits;

		item.acctWAC_Id = isRegularSplit ? regularSplitDetails.SplitDetailsWAC.Id : item.SplitDetailsWAC.Id;
		item.acctWAC_OriginalItemUnits = item.SplitDetailsWAC.SplitOrigItemUnits;
		item.acctWAC_ItemUnits = item.SplitDetailsWAC.ItemUnits;
		item.acctWAC_UnitPrice = (!!!item.SplitDetailsWAC.UnitPrice && (isRegularSplit || !isParentOrder)) ? regularSplitDetails.PriceWAC : item.SplitDetailsWAC.UnitPrice;
		item.acctWAC_TotalPrice = item.SplitDetailsWAC.TotalPrice;
		item.acctWAC_VenDrugCode = item.SplitDetailsWAC.VendItemNum;
		item.acctWAC_InvoicedUnits = item.SplitDetailsWAC.InvoicedUnits;

		// acknowledged quantity
		item.AckMsg = '';
		if(item.SplitDetails340B.AckedUnits + item.SplitDetailsGPO.AckedUnits + item.SplitDetailsOWN.AckedUnits +
			item.SplitDetailsWACMED.AckedUnits + item.SplitDetailsWAC.AckedUnits > 0) {
			item.AckMsg = 'Acknowledged Units: ' + acctMsgBuilder(item.SplitDetails340B.AckedUnits,
				item.SplitDetailsGPO.AckedUnits,
				item.SplitDetailsOWN.AckedUnits,
				item.SplitDetailsWACMED.AckedUnits,
				item.SplitDetailsWAC.AckedUnits);
		}

		// drop flattened sub-objects
		item.SplitDetails340B = null;
		item.SplitDetailsGPO = null;
		item.SplitDetailsOWN = null;
		item.SplitDetailsWACMED = null;
		item.SplitDetailsWAC = null;

		return item;
	}

	function canEditItem(item, splitInfo, isSEQ, hasMultiVendors, isParentOrder) {
		// user quantity edits
		// split parent items are editable
		// seqential split parent items are NOT editable
		item.acct340B_CanEdit = false;
		item.acctGPO_CanEdit = false;
		item.acctOWN_CanEdit = false;
		item.acctWACMED_CanEdit = false;
		item.acctWAC_CanEdit = false;

		var	isComplex = isSEQ || hasMultiVendors;

		if(vm.userCanEdit && (!isComplex || (isComplex && !isParentOrder))) {

			var orderInfo = null;
			if(item.acct340B_OriginalItemUnits > 0 && validSvc.isText(item.acct340B_Id)) {
				orderInfo = lookupOrderInfo(splitInfo, '340B', item.CEID, item.Vendor);
				if(!!orderInfo && orderInfo.ObjectState == 'REVIEW') {
					item.acct340B_CanEdit = true;
				}
			}
			if(item.acctGPO_OriginalItemUnits > 0 && validSvc.isText(item.acctGPO_Id)) {
				orderInfo = lookupOrderInfo(splitInfo, 'GPO', item.CEID, item.Vendor);
				if(!!orderInfo && orderInfo.ObjectState == 'REVIEW') {
					item.acctGPO_CanEdit = true;
				}
			}
			if(item.acctOWN_OriginalItemUnits > 0 && validSvc.isText(item.acctOWN_Id)) {
				orderInfo = lookupOrderInfo(splitInfo, 'OWN', isSEQ, item.CEID);
				if(!!orderInfo && orderInfo.ObjectState == 'REVIEW') {
					item.acctOWN_CanEdit = true;
				}
			}
			if(item.acctWACMED_OriginalItemUnits > 0 && validSvc.isText(item.acctWACMED_Id)) {
				orderInfo = lookupOrderInfo(splitInfo, 'WACMED', item.CEID, item.Vendor);
				if(!!orderInfo && orderInfo.ObjectState == 'REVIEW') {
					item.acctWACMED_CanEdit = true;
				}
			}
			if(item.acctWAC_OriginalItemUnits > 0 && validSvc.isText(item.acctWAC_Id)) {
				orderInfo = lookupOrderInfo(splitInfo, 'WAC', item.CEID, item.Vendor);
				if(!!orderInfo && orderInfo.ObjectState == 'REVIEW') {
					item.acctWAC_CanEdit = true;
				}
			}
		}
		return item;
	}

	function parentOrderVM(order, splitInfo, isSEQ) {
		var parentOrder = orderVM(order);

		// order meta info
		parentOrder.hasBestCost = !!parentOrder.BestCost;
		parentOrder.Status = '';
		parentOrder.Manual = order.Manual;
		parentOrder.canEdit = vm.userCanEdit && splitInfo.parentStatus == 'REVIEW';
		parentOrder.ShowWAC = !!parentOrder.ShowWAC;
		parentOrder.saving = [];
		parentOrder.hasMultiVendors = false;

		var saveTitle = vm.isVeriSaveOnly ? 'Savings' : 'V340B Savings';

		var item = {},
			items = parentOrder.Items,
			subItem = {},
			ii = 0,
			savingitems = {
				NoSavingOrigCost: {title: "Base Cost", isTotal: true, total: 0, items: []},
				VendorSaving: {title: "VENDOR", includeOriginal: true, total: 0, items: []},
				VeriSaveSaving: {title: "VERISAVE", includeOriginal: true, total: 0, items: []},
				NdcOptimizerSaving: {title: "NDC Optimizer", total: 0, items: []},
				PriceSelectSaving: {title: "Price Select", total: 0, items: []},
				WacReductionSaving: {title: "WAC % Reduction", total: 0, items: []},	
				V340BFinalSaving: {title: saveTitle, total: 0, items: []},
			};
			
		// Check vendor
		for(var idx = 0; idx < items.length; idx++) {
			item = items[idx];
			if (item.Vendor != "" && item.Vendor != parentOrder.VENID) {
				parentOrder.hasMultiVendors = true;
			}
		}

		for(var i = 0; i < items.length; i++) {
			item = items[i];
			item.lineType = 'header';
			item.CEDetails = Array.isArray(item.CEDetails) ? item.CEDetails : [];
			if(item.CEDetails.length < 1) {
				item = addEmptyCEDetails(item);
			}
			else {
				// flatten acct properties, tweak editing
				item = flattenAcctProps(item, isSEQ, true, item.CEDetails[0]);
				item = canEditItem(item, splitInfo, isSEQ, parentOrder.hasMultiVendors, true);
			}
			
			// split / change log edits
			item.SplitLog = Array.isArray(item.SplitLog) ? item.SplitLog : [];
			item.ChangeLog = Array.isArray(item.ChangeLog) ? item.ChangeLog : [];
			item.hasEdits = item.ChangeLog.length > 0;

			// use MULTI as original item code for searching
			if (!!item.VerisaveSwapped) {
				item.OrigItemCode = 'MULTI';
			}

			// sequential split has sub items
			if(isSEQ) {
				var subItems = item.CEDetails,
					flattenItems = [],
					subOrderEdits = false,
					orderItemVenDrugCode = item.VenDrugCode.toString(),
					subItemCodeSwap = false;
				for(ii = 0; ii < subItems.length; ii++) {
					subItem = flattenAcctProps(subItems[ii], true, false, subItems[ii]);
					subItem.Vendor = item.Vendor;
					subItem = canEditItem(subItem, splitInfo, isSEQ, parentOrder.hasMultiVendors,false);
					subItem.hasEdits = hasEdits(subItem);
					if(subItem.hasEdits) {
						subOrderEdits = true;
					}
					subItem.CodeSwaps = vendorDrugCodeSwaps(subItem, orderItemVenDrugCode);
					if(subItem.CodeSwaps.length > 0) {
						subItemCodeSwap = true;
					}
					subItem.parentId = item.Id;
					flattenItems.push(subItem);
				}
				item.SubItems = flattenItems;
				item.SubItemsEdits = subOrderEdits;
				item.SubItemsCodeSwap = subItemCodeSwap;
				item.CEDetails = [];
			}
			// Saving statistics
			for (var key in savingitems) {
				var amount = item.SavingResults[key];
				if (amount > 0) {
					savingitems[key].total += amount;
					savingitems[key].items.push({
						OrigItemCode: item.OrigItemCode,
						ItemCode: item.ItemCode,
						Amount: amount,
						Description: item.VenLabel,
						Items: item.VerisaveSwapped
					});
				}
			}
		}

		parentOrder.saving.push(savingitems.NoSavingOrigCost);
		parentOrder.saving.push(savingitems.NdcOptimizerSaving);
		parentOrder.saving.push(savingitems.PriceSelectSaving);
		parentOrder.saving.push(savingitems.VeriSaveSaving);
		parentOrder.saving.push(savingitems.VendorSaving);
		parentOrder.saving.push(savingitems.WacReductionSaving);
		parentOrder.saving.push(savingitems.V340BFinalSaving);

		return parentOrder;
	}

	function orderVM(order) {

		// can edit this order (opens up line item editing)
		order.canEdit = vm.userCanEdit && order.ObjectState == 'REVIEW';

		// api uses WAC and WACREM interchanably, standardize on "WAC"
		order.OrderType = order.OrderType == 'WACREM' ? 'WAC' : order.OrderType;

		// nullify golang "zero" dates
		if(!validSvc.isDate(order.PlaceDate)) {
			order.PlaceDate = null;
		}
		if(!validSvc.isDate(order.AckDate)) {
			order.AckDate = null;
		}
		if(!validSvc.isDate(order.InvoiceDate)) {
			order.InvoiceDate = null;
		}
		if(!validSvc.isDate(order.CancelDate)) {
			order.CancelDate = null;
		}

		// fix null items array
		order.Items = Array.isArray(order.Items) ? order.Items : [];

		return order;
	}

	function tableVM(items) {
		for (var i=0; i<items.length; i++){
			items[i].SavingResults_NoSavingOrigCost = items[i].SavingResults.NoSavingOrigCost;
			items[i].SavingResults_NdcOptimizerSaving = items[i].SavingResults.NdcOptimizerSaving;
			items[i].SavingResults_PriceSelectSaving = items[i].SavingResults.PriceSelectSaving;
			items[i].SavingResults_VeriSaveSaving = items[i].SavingResults.VeriSaveSaving;
			items[i].SavingResults_VendorSaving = items[i].SavingResults.VendorSaving;
			items[i].SavingResults_V340BFinalSaving = items[i].SavingResults.V340BFinalSaving;
		}
		return {
			DataItems: Array.isArray(items) ? items : [],
			Items: []
		};
	}


	/**
	 *    GET SPLIT ORDER
	 */

	function getSplitLog(id) {
		if(vm.isWaiting || !!!vm.popup || !validSvc.isText(id)) {
			return;
		}

		vm.popup.tab = 'LOG';
		vm.isWaiting = true;
		msgSvc.wait(true);

		ordersRepo.getSplitLog(id).then(okSplitLog, errSplitLog);

		function okSplitLog(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			r = Array.isArray(r) ? r : [];

			// popup still exists
			if(!!!vm.popup && (vm.popup.type != 'SPLIT_DETAIL' && vm.popup.type != 'FOCUS_ORDER')) {
				return;
			}

			vm.popup.SplitLog = r;
			vm.popup.maxSplitHeight = r.length <= 10;
		}

		function errSplitLog(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			if(!!r) {
				errSvc.warn('Unknown split log response', 'orderSplitDetail.getSplitLog', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}

	function getSplitOrder(isReload) {
		// this will be called after edits without refreshing the route

		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;
	
		// keep UI on reloads
		if(isReload) {
			vm.action = 'RELOAD';
			if(vm.popup.type != 'SPLIT_DETAIL' && vm.popup.type != 'FOCUS_ORDER') { // keep popup on reloads
				closePopup();
			}
		}
		else {
			vm.splitInfo = {};
			vm.order = {};
			vm.focusOrder = null;
			vm.tbl = {};
			closePopup();
			vm.popupLineItem = {};
			vm.action = '';
		}

		// send api request
		msgSvc.wait(true);
		ordersRepo.getSplitOrder(_parentOrderId).then(okOrder, errOrder);

		function okOrder(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// order array must always contain the SPLIT original parent order
			r = Array.isArray(r) ? r : [];
			var parentOrder = findOrderByType(r, 'SPLIT');
			if(!!!parentOrder) {
				throw new Error('orderSplitDetailCtl.okOrder, SPLIT parent is missing in order list');
			}
			// set split meta info (this is used everywhere in controller and html)
			vm.isSEQ = !!parentOrder.SequentialSplit;
			vm.splitInfo = parseChildOrders(r, parentOrder, vm.isSEQ);

			// upgrade parent order to final VM using split info
			parentOrder = parentOrderVM(parentOrder, vm.splitInfo, vm.isSEQ);

			// setup focus order if exists
			if(validSvc.isText(_focusOrderId)) {
				vm.focusOrder = loadFocusOrder(_focusOrderId, vm.splitInfo, parentOrder, vm.isSEQ);
				if(!!!vm.focusOrder) {
					_focusOrderId = '';
				}
			}

			// reloading?
			var reloaded = false;
			if(vm.action == 'RELOAD') {
				reloaded = reconcileOrderItems(vm.tbl, parentOrder.Items);
			}
			if(reloaded) {
				// only update data background items on table
				// display values are updated after table render
				vm.tbl.DataItems = parentOrder.Items;
			}
			else {
				// reset all UI display state
				vm.action = '';
				vm.order = parentOrder;
				vm.tbl = tableVM(vm.order.Items);
				closePopup();
				vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			}

			$timeout(function(){
				// update paging ui
				$scope.$broadcast('widget.paging', {
					Size: vm.flt.PageSize,
					Page: vm.flt.Page,
					Total: vm.flt.PageTotal,
					RowCount: vm.flt.Count,
					ItemCount: vm.tbl.Items.length,
					DataCount: vm.tbl.DataItems.length
				});
		
				vm.flt.Ready = true;
				
				if(vm.action == 'RELOAD') {
					if(reloadDisplayValues()) {
						$timeout(function(){
							vm.action = 'LIST';
						},500);
					}
					else {
						// reload issues, reload the page
						getSplitOrder();
					}
				}
				else {
					vm.action = 'LIST';

					// user is navigating to see a specific focus order
					if(_showFocusOrder == 'init' && !!vm.focusOrder) {
						_showFocusOrder = 'yes';
						openPopup({}, 'FOCUS_ORDER', vm.focusOrder);
					}
				}
			},300);
		}

		function errOrder(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			if(!!r) {
				errSvc.error('Unknown get response', 'orderSplitDetail.getSplitOrder', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}

	function setFocusOrder(id) {
		// user can see order items by clicking order title, move focus to another order

		if(vm.isWaiting || !validSvc.isText(id)) {
			return;
		}

		_focusOrderId = '';
		_showFocusOrder = 'no';
		vm.focusOrder = loadFocusOrder(id, vm.splitInfo, vm.order, vm.isSEQ);
		if(!!vm.focusOrder) {
			_focusOrderId = id;
			_showFocusOrder = 'yes';
			openPopup({}, 'FOCUS_ORDER', vm.focusOrder);
		}
	}

	function loadFocusOrder(focusId, splitInfo, parentOrder, isSEQ) {
		// if specific order was requested, derive its data or return null

		if(!validSvc.isText(focusId) || focusId == parentOrder.Id || parentOrder.Items.length < 1) {
			return null;
		}

		// get focus order from splitInfo object keys
		var focusOrder = findSplitInfoOrderById(splitInfo, focusId);
		if(!!!focusOrder) {
			return null;
		}

		var ordType = focusOrder.OrderType;
		var focusItems = loadFocusOrderItems(splitInfo, focusOrder.CEID, focusOrder.VENID, ordType, parentOrder.Items, isSEQ, focusOrder.ObjectState == 'REVIEW', focusOrder.multiVendorOrder);
		if(focusItems.length < 1) {
			return null;
		}

		return {
			title: ordType + ' Order: ' + focusOrder.Name,
			Items: focusItems,
			acct: ordType,
			orderDetail: focusOrder,
			show340B: ordType == '340B',
			showGPO: ordType == 'GPO',
			showOWN: ordType == 'OWN',
			showWACMED: ordType == 'WACMED',
			showWAC: ordType == 'WAC'
		};
	}

	function loadFocusOrderItems(splitInfo, ceid, vendor, ordType, items, isSEQ, isReview, isMV) {
		// get focus order values out of parent order items by matching the CE, Vendor and NDC information

		var result = [];

		if(!validSvc.isText(ordType) || !Array.isArray(items) || items.length < 1) {
			return [];
		}

		// cherry pick this order's itemsout of order items
		var item = {},
			subItems = [],
			subItem = {},
			focusItem = {},
			ii = 0,
			ordTypeOriginalUnits = 'acct' + ordType + '_OriginalItemUnits',
			ordTypeItemUnits = 'acct' + ordType + '_ItemUnits';

		for(var i = 0; i < items.length; i++) {
			item = items[i];

			if (item.Vendor != vendor) {
				continue;
			}
			if(!isSEQ) {
				// non-split items are in the header
				if(item[ordTypeOriginalUnits] > 0) {
					if (isReview || (!isReview && item[ordTypeItemUnits] > 0)) {
						focusItem = angular.fromJson(angular.toJson(item)); // de-ref before adding
						// if multivendor, set CanEdit
						if (isMV) {
							focusItem = canEditItem(focusItem, splitInfo, isSEQ, isMV, false);
						}
						result.push(focusItem);
					}
				}
			}
			else {
				// sequential split items are inside each parent item
				// loop each item's sub-items to match the ceid
				subItems = Array.isArray(item.SubItems) ? item.SubItems : [];
				for(ii = 0; ii < subItems.length; ii++) {
					subItem = subItems[ii];
					if(subItem.CEID == ceid && subItem[ordTypeOriginalUnits] > 0) {
						if (isReview || (!isReview && subItem[ordTypeItemUnits] > 0)) {
							focusItem = angular.fromJson(angular.toJson(subItem)); // de-ref before adding
	
							// add parent item drug info
							focusItem.ItemCode = item.ItemCode;
							focusItem.VenDrugCode = item.VenDrugCode;
							focusItem.VenLabel = item.VenLabel;
							focusItem.WholesaleUnits = item.WholesaleUnits;
	
							result.push(focusItem);
						}
					}
				}
			}			
		}

		return result;
	}

	function parseChildOrders(orderList, parentOrder, isSEQ) {
		// parse all child split orders
		// this builds two maps, account summary and order lookup
		// 340B example:
		//		splitInfo.acct340B is an order type summary across all 340B orders,
		//			it has an array of all 340B orders
		//		splitInfo.order_340B is a regular split lookup 1 340B order
		//		splitInfo.order_CEID_340B is a seq split lookup for 1 340B order

		// Check vendors
		var mvOrder = false;
		for(var idx = 0; idx < parentOrder.Items.length; idx++) {
			item = parentOrder.Items[idx];
			if (item.Vendor != "" && item.Vendor != parentOrder.VENID) {
				mvOrder = true;
				break;
			}
		}
		
		var splitInfo = {
				parentStatus: ''
			},
			item = {},
			acctInfo = {},
			ordType = '',
			status = '',
			orderKey = '';

		for(var i = 0; i < orderList.length; i++) {
			item = orderVM(orderList[i]);
			if(item.OrderType != 'SPLIT') {
				item.multiVendorOrder = mvOrder;
				ordType = item.OrderType;
				// split info map by order type, this is used as a lookup later
				orderKey = orderMapKey(ordType, item.CEID, item.VENID);

				splitInfo[orderKey] = item;

				// get acct summary property
				acctInfo = splitInfo['acct'+ ordType] || { 
					status: '',
					orders: [],
					itemCount: 0
				};
				acctInfo.orders.push(item);
				acctInfo.itemCount += item.ItemCount;
								
				// derive parent order and account summary statuses
				status = item.ObjectState;
				acctInfo.status = deriveSummaryStatus(acctInfo.status, status);
				splitInfo.parentStatus = deriveSummaryStatus(splitInfo.parentStatus, status);

				for(var ii=0; ii<parentOrder.Items.length; ii++) {
					var orderitem = parentOrder.Items[ii];
					var details = orderitem['SplitDetails'+ordType];
					// set boolean for manual invoice flags
					if(details.InvoicedUnits < details.ItemUnits) {
						splitInfo[orderKey].canAddInvoice = true;
					}
					if (details.InvoicedUnits > 0) {
						splitInfo[orderKey].everInvoiced = true;
					}
				}
				splitInfo['acct'+ ordType] = acctInfo;
			}
		}

		return splitInfo;
	}

	function deriveSummaryStatus(summary, newStatus) {
		// modify summary status based on each in-coming status

		// review overrides all others
		if(newStatus == 'REVIEW') {
			return newStatus;
		}

		switch(summary) {
			case 'REVIEW':
			case 'PLACE-CANCEL':
				// already handled
				return summary;
			case 'PLACE':
				return newStatus == 'CANCELLED' ? 'PLACE-CANCEL' : 'PLACE';
			case 'CANCELLED':
				return newStatus == 'PLACE' ? 'PLACE-CANCEL' : 'CANCELLED';
			default:
				// summary has no value, set to incoming status
				return newStatus;
		}
	}

	function reconcileOrderItems(tbl, orderItems) {
		// reload data into table after a qty update WITHOUT dumping the table (which causes a complete re-render)
		// note: on qty edit trying to keep the page scroll position

		var tblDataItems = Array.isArray(tbl.DataItems) ? tbl.DataItems : [];
		orderItems = Array.isArray(orderItems) ? orderItems : [];
		if(orderItems.length < 1 || orderItems.length != tblDataItems.length) {
			return false;
		}

		// verify all data ids match
		for(var i = 0; i < orderItems; i++) {
			if(!!!findLineItemById(tblDataItems, orderItems[i].Id)) {
				return false;
			}
		}

		return true;
	}

	function reloadQuantities(displayItem, orderItem) {
		displayItem.acct340B_Id = orderItem.acct340B_Id;
		displayItem.acct340B_OriginalItemUnits = orderItem.acct340B_OriginalItemUnits;
		displayItem.acct340B_ItemUnits = orderItem.acct340B_ItemUnits;
		displayItem.acct340B_UnitPrice = orderItem.acct340B_UnitPrice;
		displayItem.acct340B_TotalPrice = orderItem.acct340B_TotalPrice;
		
		displayItem.acctGPO_Id = orderItem.acctGPO_Id;
		displayItem.acctGPO_OriginalItemUnits = orderItem.acctGPO_OriginalItemUnits;
		displayItem.acctGPO_ItemUnits = orderItem.acctGPO_ItemUnits;
		displayItem.acctGPO_UnitPrice = orderItem.acctGPO_UnitPrice;
		displayItem.acctGPO_TotalPrice = orderItem.acctGPO_TotalPrice;

		displayItem.acctOWN_Id = orderItem.acctOWN_Id;
		displayItem.acctOWN_OriginalItemUnits = orderItem.acctOWN_OriginalItemUnits;
		displayItem.acctOWN_ItemUnits = orderItem.acctOWN_ItemUnits;
		displayItem.acctOWN_UnitPrice = orderItem.acctOWN_UnitPrice;
		displayItem.acctOWN_TotalPrice = orderItem.acctOWN_TotalPrice;
		
		displayItem.acctWACMED_Id = orderItem.acctWACMED_Id;
		displayItem.acctWACMED_OriginalItemUnits = orderItem.acctWACMED_OriginalItemUnits;
		displayItem.acctWACMED_ItemUnits = orderItem.acctWACMED_ItemUnits;
		displayItem.acctWACMED_UnitPrice = orderItem.acctWACMED_UnitPrice;
		displayItem.acctWACMED_TotalPrice = orderItem.acctWACMED_TotalPrice;

		displayItem.acctWAC_Id = orderItem.acctWAC_Id;
		displayItem.acctWAC_OriginalItemUnits = orderItem.acctWAC_OriginalItemUnits;
		displayItem.acctWAC_ItemUnits = orderItem.acctWAC_ItemUnits;
		displayItem.acctWAC_UnitPrice = orderItem.acctWAC_UnitPrice;
		displayItem.acctWAC_TotalPrice = orderItem.acctWAC_TotalPrice;

		displayItem.TotalItemUnits = orderItem.TotalItemUnits;
		displayItem.TotalPrice = orderItem.TotalPrice;
		displayItem.AckMsg = orderItem.AckMsg;
	}

	function reloadDisplayValues() {
		// update display quantity without dropping object references

		// get order item from table data
		var orderItem = findLineItemById(vm.tbl.DataItems, _pending.orderItemId);
		if(!!!orderItem) {
			return false;
		}

		// get order item from table display
		var displayItem = findLineItemById(vm.tbl.Items, _pending.orderItemId);
		if(!!!displayItem) {
			return false;
		}

		// update logs and edits
		displayItem.hasEdits = true;
		displayItem.SplitLog = orderItem.SplitLog;
		displayItem.ChangeLog = orderItem.ChangeLog;
		displayItem.SubItems = orderItem.SubItems;
		displayItem.SubItemsEdits = true;
		displayItem.SubItemsCodeSwap = orderItem.SubItemsCodeSwap;

		// update item quantities
		reloadQuantities(displayItem, orderItem);

		// exit if there is no popup display to update
		if(!!!vm.popup || (vm.popup.type != 'SPLIT_DETAIL' && vm.popup.type != 'FOCUS_ORDER')) {
			return true;
		}
		var popType = vm.popup.type;
		
		// update popup focus order item
		if(popType == 'FOCUS_ORDER' && !vm.isSEQ) {
			// get order item from popup focus items
			var popupFocusItem = findLineItemByNdcDrugCode(vm.popup.Items, _pending.ndcDrugCode);
			if(!!!popupFocusItem) {
				return false;
			}

			// update item quantities
			popupFocusItem.hasEdits = true;
			reloadQuantities(popupFocusItem, orderItem);
		}

		// sequential updates
		if(vm.isSEQ) {

			// get order sub item
			var subItemOrder = findLineItemByCEID(orderItem.SubItems, _pending.ceid);
			if(!!!subItemOrder) {
				return false;
			}

			var popupItem = {};
			if(popType == 'SPLIT_DETAIL') {
				vm.popup.SplitLog = orderItem.SplitLog;
				vm.popup.Edits = orderItem.ChangeLog;

				// split detail unique key is CEID
				popupItem = findLineItemByCEID(vm.popup.Items, _pending.ceid);
			}
			else {
				// focus order unique key is ndc + vendor drug code
				popupItem = findLineItemByNdcDrugCode(vm.popup.Items, _pending.ndcDrugCode);
			}

			// update popup quantities
			if(!!!popupItem) {
				return false;
			}
			popupItem.hasEdits = true;
			reloadQuantities(popupItem, subItemOrder);
		}

		return true;
	}


	/**
	 *    ORDER STATUS: PLACE / CANCEL
	 */

	function placeOrder() {
		// only parent order uses PLACE
		// note: affects all child split orders which aren't already status CANCELLED
		if(vm.isWaiting) {
			return;
		}

		_pending = {
			status: 'PLACE',
			id: _parentOrderId,
			title: 'Place Order',
			msg: 'Confirm you wish to place this order, once placed it cannot be undone.'
		};
		orderStatusPrompt();
	}

	function cancelOrder(id, name) {
		if(vm.isWaiting) {
			return;
		}

		var isParent = _parentOrderId == id;
		_pending = {
			status: 'CANCEL',
			id: id,
			title: name == 'SPLIT' ? 'Cancel All Split Orders' : 'Cancel ' + name,
			msg: 'Confirm you wish to cancel, this cannot be undone.'
		};
		orderStatusPrompt();
	}
	
	function orderStatusPrompt() {
		msgSvc.confirm({
			id: 'orders.split.review',
			title: _pending.title,
			msg: _pending.msg,
			buttons: [
				{text:'YES', result:'YES', cancel: false},
				{text:'NO', result:'CANCEL', cancel: true}
			]
		}).then(orderStatusConfirm, orderStatusConfirm);
	}

	function orderStatusConfirm(r) {
		// user said yes
		if(!!r && r.result == 'YES') {
			vm.isWaiting = true;
			msgSvc.wait(true);
			ordersRepo.orderStatus(_pending.id, _pending.status).then(okStatus, errStatus);
		}

		function okStatus(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			msgSvc.ok(_pending.title + ' Complete');
			getSplitOrder();
		}

		function errStatus(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Split ' + _pending.status + ' failed with unexpected api error.', 'ordersSplitDetailCtl.orderReview', r.status, utilSvc.http.safeResponse(r));
				getSplitOrder();
			}
		}
	}

	
	/**
	 *    POPUP
	 */

	function openPopup(evt, popType, item) {
		// consolidated all popup logic into single function

		if(vm.isWaiting) {
			return;
		}

		var offsetY = 0,
			popLeft = 0,
			popWidth = '',
			popRight = '',
			isLineItem = false;

		switch(popType) {
			case 'FOCUS_ORDER':
				// user is viewing a specific order
				vm.popup = {
					type: popType,
					ready: false,
					title: item.title,
					Items: item.Items,
					acct: item.acct,
					orderDetail: item.orderDetail,
					show340B: item.show340B,
					showGPO: item.showGPO,
					showOWN: item.showOWN,
					showWACMED: item.showWACMED,
					showWAC: item.showWAC,
					flt: {}
				};
				vm.popupsort = {
					SortBy : []
				};
				popWidth = '90%';
				popRight = '0';
				break;

			case 'SPLIT_DETAIL':
				// details for both split and seq split
				var defaultTab = vm.isSEQ ? 'SEQITEMS' : 'LOG';

				vm.popup = {
					type: popType,
					ready: false,
					tab: defaultTab,
					title: 'Item Detail for ' + item.ItemCode + ' ' + item.VenLabel,
					Items: vm.filterList(item.SubItems, vm.fltSplitDetail),
					hasCodeSwaps: item.SubItemsCodeSwap,
					SplitLog: [],
					SplitLogLineId: item.Id,
					maxSplitHeight: true,
					Edits: item.ChangeLog,
					maxEditsHeight: item.ChangeLog.length <= 10,
					show340B: true,
					showGPO: true,
					showOWN: !!vm.splitInfo.acctOWN,
					showWACMED: !!vm.splitInfo.acctWACMED,
					showWAC: true
				};
				offsetY = -200;
				popWidth = vm.isSEQ ? '90%' : '60%';
				popRight = '0';

				// ASYNC: get split log
				if (defaultTab == 'LOG') {
					getSplitLog(item.Id);
				}
				break;
			
			case 'SPLIT_ORDER_DETAIL':
				defaultTab = 'EDITS';

				vm.popup = {
					type: popType,
					ready: false,
					tab: defaultTab,
					title: 'Order Detail',
					Edits: !!item.ChangeLog ? item.ChangeLog : [],
					maxEditsHeight: !!!item.ChangeLog || item.ChangeLog.length <= 10,
				};
				offsetY = 0;
				popWidth = '60%';
				popRight = '0';
				break;
	
			case 'ACCTDETAIL':
				// order type summary

				// for non-sequential split open as a FOCUS_ORDER
				if(!vm.isSEQ) {
					// get the account order (there is only 1 for regular split)
					var splitAcct = vm.splitInfo['acct' + item.acct];
					if(!!splitAcct && Array.isArray(splitAcct.orders) && splitAcct.orders.length == 1) {
							setFocusOrder(splitAcct.orders[0].Id);
						return;
					}
				}
				vm.popup = {
					type: popType,
					acct: item.acct,
					splitInfo: vm.splitInfo['acct' + item.acct],
					ready: false,
					title: item.acct + ' Order Detail'
				};
				popWidth = '60%';
				popRight = '0';
				offsetY = 0;
				break;
			case 'SAVINGDETAIL':
				var saveTitle = vm.isVeriSaveOnly ? 'Savings Detail - ' : 'V340B Savings Detail - ';
				saveTitle += 'PO#: ' + vm.order.Name + '  ' + vm.order.Items.length + ' items ordered';
				vm.popup = {
					type: popType,
					ready: false,
					title: saveTitle,
					savings: []
				};

				// clean up savings here instead of in html
				var saveItems = Array.isArray(vm.order.saving) ? vm.order.saving : [],
					saving = {};
				for(var si = 0; si < saveItems.length; si++) {
					saving = saveItems[si];
					if(!!saving && saving.total > 0 && Array.isArray(saving.items) && saving.items.length > 0) {
						vm.popup.savings.push(saving);
					}
				}

				offsetY = 0;
				popWidth = '60%';
				popRight = '0';
				break;

			case 'MULTIORIGINAL':
				vm.popup = {
					type: popType,
					ready: false,
					title: 'Original NDCs',
					originalNDC: item.ItemCode,
					items: item.VerisaveSwapped
				};
				offsetY = 0;
				popWidth = '60%';
				popRight = '0';
				break;
			default:
				alert('openPopup unknown popType: ' + popType);
		}

		// move popup to table row position
		// loop html element parents looking for popup container top
		if(popType == 'SPLIT_DETAIL' || popType == 'MULTIORIGINAL') {
			var elem = evt.target,
				scrollTopFound = false;
			while(!!elem) {

				// top element found
				if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
					break;
				}

				// scroll container found, reduce offset if this container is scrolled
				if(!scrollTopFound && !!elem.className && elem.className.indexOf('table-fixed-header-scroll') > -1) {
					scrollTopFound = true;
					offsetY -=  Math.floor(elem.scrollTop);
				}

				// add offset, get next element
				offsetY += elem.offsetTop;
				elem = elem.offsetParent;
			}
			elem = null;
		}
	
		// move popup to clicked row
		var popElem = document.getElementById('tablePopupContent');
		if(!!popElem) {
			popElem.style.top = offsetY.toString() + 'px';
			popElem.style.width = popWidth;
			popElem.style.right = popRight;
			popElem.style.left = popLeft.toString() + 'px';
		}
	
		// wait for digest before showing
		$timeout(function() {
			vm.popup.ready = true;
		}, 100);
	}

	function closePopup() {
		if(!!!vm.popup) {
			return;
		}

		// line item editing click off, do not close entire popup
		if(vm.popupLineItem.ready && (vm.popup.tab == 'SEQITEMS' || vm.popup.type == 'FOCUS_ORDER')) {
			closePopupLineItem();
			return;
		}

		if(!!vm.popup && vm.popup.type == 'FOCUS_ORDER') {
			_focusOrderId = '';
			_showFocusOrder = 'no';
			vm.focusOrder = null;
		}
		vm.popup = {};
		vm.popupsort = {};
	}


	/**
	 * 	POPUP: LINE ITEM (needs its own popup to show it over sequential split popup)
	 */

	function openPopupLineItem(evt, popType, item) {

		if(vm.isWaiting) {
			return;
		}

		var offsetY = -40,
			popLeft = -10,
			popWidth = '140px',
			popRight = 'auto',
			acctPropName = 'acct' + popType;

		vm.popupLineItem = {
			type: 'LINEITEM',
			ready: false,
			title: popType + ' Qty',
			acct: popType,
			orderItemId: vm.isSEQ ? item.parentId : item.Id,
			ndcDrugCode: item.ItemCode + '|' + item.VenDrugCode,
			ceid: vm.isSEQ ? item.CEID : '',
			acctId: item[acctPropName + '_Id'],
			hoverId: item.Id,
			qty: utilSvc.num.parse(item[acctPropName + '_ItemUnits']),
			qtyOriginal: utilSvc.num.parse(item[acctPropName + '_OriginalItemUnits'])
		};

		// move popup to table row position
		// loop html element parents looking for popup container top
		var elem = evt.target,
			scrollTopFound = false;
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
				break;
			}

			// scroll container found, reduce offset if this container is scrolled
			if(!scrollTopFound && !!elem.className && elem.className.indexOf('table-fixed-header-scroll') > -1) {
				offsetY -= Math.floor(elem.scrollTop);
			}

			// add offset, get next element
			offsetY += elem.offsetTop;
			popLeft += elem.offsetLeft;
			elem = elem.offsetParent;
		}
		elem = null;
	
		// move popup to clicked row
		var popElem = document.getElementById('tablePopupContentLINEITEM');
		if(!!popElem) {
			popElem.style.top = offsetY.toString() + 'px';
			popElem.style.width = popWidth;
			popElem.style.right = popRight;
			popElem.style.left = popLeft.toString() + 'px';
		}
	
		// wait for digest before showing
		$timeout(function() {
			vm.popupLineItem.ready = true;

			// set focus on line item input box
			$timeout(function() {
					// set focus, select text
					try {
						var inputElem = document.getElementById('popupLineItemInput');
						if(!!inputElem) {
							inputElem.focus();
							inputElem.setSelectionRange(0,9999);
						}
					}
					catch(err) {
						// do nothing
					}
			}, 300);
		}, 200);
	}

	function closePopupLineItem() {
		vm.popupLineItem = {};
	}

	/**
	 *    Savings View
	 */
	function ShowSavingsView() {
		vm.flt = vm.initFilters({
			SortBy: ['ItemCode']
		});
		vm.flt.Ready = true;
		if (!!vm.showSavings) {
			vm.flt.Numbers.SavingResults_V340BFinalSaving = '> 0';
		} else {
			vm.flt.Numbers.SavingResults_V340BFinalSaving = '';
		}
		vm.filterChange();
	}

	/**
	 *    FILTER: CHANGE
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			/* debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					saveViewState(vm.query, vm.reportTab, vm.flt);
				}
			},1000);
			*/

		}, delayTime);

	}


	/**
	 *    LINEITEM EDITING
	 */

	function lineQtyUpdate() {
		// update each acct qty

		if(vm.isWaiting || !!!vm.popupLineItem || vm.popupLineItem.type != 'LINEITEM') {
			return;
		}
		
		var qtyEdit = utilSvc.num.parse(vm.popupLineItem.qty);
		if(!validSvc.isInteger(qtyEdit) || qtyEdit < 0) {
			msgSvc.ok('Quantity Check', 'Quantity must be a number zero or greater');
			return;
		}

		// validate qty reduced
		if (vm.popupLineItem.acct != 'WAC' && qtyEdit > vm.popupLineItem.qtyOriginal) {
			msgSvc.ok('Quantity Check', qtyEdit + ' is more than initial ' + vm.popupLineItem.acct + ' quantity: ' + vm.popupLineItem.qtyOriginal);
			return;
		}
		_pending = {
			acct: vm.popupLineItem.acct,
			orderItemId: vm.popupLineItem.orderItemId,
			ndcDrugCode: vm.popupLineItem.ndcDrugCode,
			ceid: vm.popupLineItem.ceid
		};

		ordersRepo.splitLineItemUpdate(vm.popupLineItem.acctId, parseInt(utilSvc.num.parse(vm.popupLineItem.qty))).then(okLineQtyUpdate, errLineQtyUpdate);
		vm.isWaiting = true;
		msgSvc.wait(true);
		vm.popupLineItem = {};
	}
	
	function okLineQtyUpdate(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);
		getSplitOrder(true);
	}
	
	function errLineQtyUpdate(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);
	
		if(!!!r) {
			// already handled
		}
		else if(r.status === 409) {
			// conflict
			msgSvc.ok('Cannot Save ' + _pending.acct + ' Quantity', 'Refreshing order details');
			getSplitOrder();
		}
		else if (r.status === 422) {
			// validation
			msgSvc.ok('Cannot Save Line Item', r.msg);
		}
		else {
			errSvc.warn('Unexpected api error', 'orderSplitDetailCtl.errLineQtyUpdate', r.status, utilSvc.http.safeResponse(r));
			getSplitOrder();
		}
	}

	function removeNonPriceSelect() {
		//remove non price slected items
		if(vm.isWaiting) {
			return;
		}

		// confirm
		msgSvc.confirm({
			id: 'remove.nonprice.select',
			title: 'WAC Non Price Select',
			msg: 'Remove all Non Price Select WAC Items?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirmPriceSelect, userConfirmPriceSelect);
	}
	
	function userConfirmPriceSelect(r) {

		if(!!r && r.result == 'YES') {	
			ordersRepo.removeNonPriceSelect(_parentOrderId).then(okPriceSelect, errPriceSelect);
			vm.isWaiting = true;
			msgSvc.wait(true);
		}

		function okPriceSelect(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			getSplitOrder();
		}

		function errPriceSelect(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!!r) {
				// already handled
			}
			else if(r.status === 409) {
				// conflict
				msgSvc.ok('Cannot Remove Items', 'Refreshing the order details');
				getSplitOrder();
			}
			else {
				errSvc.warn('Unexpected api error', 'orderSplitDetailCtl.errPriceSelect', r.status, utilSvc.http.safeResponse(r));
				getSplitOrder();
			}
		}
	}

	function navToFeature(navType, navData) {
		if (vm.isWaiting) {
			return;
		}
		var breadcrumb = {};
		breadcrumb = {
			icon: 'sprite-orders-split',
			route: 'orders.splitdetail',
			routeData: {id: vm.popup.orderDetail.Id, parentId: _parentOrderId},
			msg: 'Return to Split Order Detail'
		};

		var morder = {
			CE: vm.popup.orderDetail.CEID,
			RX: vm.popup.orderDetail.RXID,
			Vendor: vm.popup.orderDetail.VENID,
			AccumGrp: vm.popup.orderDetail.AccumGrp,
			PoName: vm.popup.orderDetail.Name,
			PoDt: vm.popup.orderDetail.CreatedOn,
			Items:[]
		};
		if (!!vm.popup.Items) {
			for(var i=0; i<vm.popup.Items.length; i++){
				var itemUnits = 0,
					price = 0.00,
					invoicedUnits = 0;
				if (vm.popup.show340B) {
					itemUnits = vm.popup.Items[i].acct340B_ItemUnits;
					price = vm.popup.Items[i].acct340B_UnitPrice;
					invoicedUnits = vm.popup.Items[i].acct340B_InvoicedUnits;
				} else if (vm.popup.showGPO) {
					itemUnits = vm.popup.Items[i].acctGPO_ItemUnits;
					price = vm.popup.Items[i].acctGPO_UnitPrice;
					invoicedUnits = vm.popup.Items[i].acctGPO_InvoicedUnits;
				} else if (vm.popup.showWAC) {
					itemUnits = vm.popup.Items[i].acctWAC_ItemUnits;
					price = vm.popup.Items[i].acctWAC_UnitPrice;
					invoicedUnits = vm.popup.Items[i].acctWAC_InvoicedUnits;
				} else if (vm.popup.showWACMED) {
					itemUnits = vm.popup.Items[i].acctWACMED_ItemUnits;
					price = vm.popup.Items[i].acctWACMED_UnitPrice;
					invoicedUnits = vm.popup.Items[i].acctWACMED_InvoicedUnits;
				} else if (vm.popup.showOWN) {
					itemUnits = vm.popup.Items[i].acctOWN_ItemUnits;
					price = vm.popup.Items[i].acctOWN_UnitPrice;
					invoicedUnits = vm.popup.Items[i].acctOWN_InvoicedUnits;
				}

				var item = {
					ItemCode: vm.popup.Items[i].ItemCode,
					Description: vm.popup.Items[i].VenLabel,
					VendItemNum: vm.popup.Items[i].VenDrugCode,
					OrderedUnits: itemUnits,
					PriorUnits: invoicedUnits,
					UnitPrice: price,
					IsAssay: vm.popup.Items[i].IsAssay,
				};
				if (item.PriorUnits < item.OrderedUnits) {
					morder.Items.push(item);
				}
			}
		}
		switch (navType) {
			case 'ADDINVOICE':
				var params = {
					order: morder,
					breadcrumb: breadcrumb
				};
				$state.go('invoice.add', params, { reload: 'invoice.add' });
				break;
			default:
				alert('order.new.ctl.navToFeature, unknown navType: ' + navType);
		}
	}

	/**
	 *    HELPERS
	 */

	function findOrderById(orders, id) {
		for(var i = 0; i < orders.length; i++) {
			if(id == orders[i].Id) {
				return orders[i];
			}
		}
		return null;
	}

	function findOrderByType(orders, ordType) {
		for(var i = 0; i < orders.length; i++) {
			if(ordType == orders[i].OrderType) {
				return orders[i];
			}
		}
		return null;
	}

	function findLineItemById(items, id) {
		for (var i = 0; i < items.length; i++) {
			if (items[i].Id == id) {
				return items[i];
			}
		}
		return null;
	}

	function findLineItemByCEID(items, ceid) {
		for (var i = 0; i < items.length; i++) {
			if (items[i].CEID == ceid) {
				return items[i];
			}
		}
		return null;
	}

	function findLineItemByNdcDrugCode(items, ndcDrugCode) {
		for (var i = 0; i < items.length; i++) {
			if (items[i].ItemCode + '|' + items[i].VenDrugCode == ndcDrugCode) {
				return items[i];
			}
		}
		return null;
	}

	function findSplitInfoOrderById(splitInfo, id) {
		// test all owned object properties for an order with matching Id

		var checkOrder = null;
		for(var prop in splitInfo) {
			if(splitInfo.hasOwnProperty(prop)) {
				checkOrder = splitInfo[prop];
				if(!!checkOrder && validSvc.isText(checkOrder.Id) && checkOrder.Id == id) {
					return checkOrder;
				}
			}
		}
		return null;
	}

	function acctMsgBuilder(val340B, valGPO, valOWN, valWACMED, valWAC) {
		var result = '';
		if(val340B > 0) {
			result = '340B: ' + val340B;
		}
		if(valGPO > 0) {
			result = result.length > 0 ? result + ', GPO: ' + valGPO : 'GPO ' + valGPO;
		}
		if(valOWN > 0) {
			result = result.length > 0 ? result + ', OWN: ' + valOWN : 'OWN ' + valOWN;
		}
		if(valWACMED > 0) {
			result = result.length > 0 ? result + ', WACMED: ' + valWACMED : 'WACMED ' + valWACMED;
		}
		if(valWAC > 0) {
			result = result.length > 0 ? result + ', WAC: ' + valWAC : 'WAC ' + valWAC;
		}
		return result;
	}

	function orderMapKey(orderType, ceid, vendor) {
		// build key to lookup an order for split or seq split
		var orderKey = 'order_' + ceid + '_' + vendor + '_';
		return orderKey + orderType;
	}

	function lookupOrderInfo(splitInfo, orderType, ceid, vend) {
		var orderKey = orderMapKey(orderType, ceid, vend);
		if(!!splitInfo) {
			return splitInfo[orderKey];
		}
	}
}
 
invoiceRepo.$inject = ['$rootScope', '$q', 'apiService', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc', 'vmSvc', 'msgSvc'];
angular
.module('espui.ops')
.factory('invoiceRepo', invoiceRepo);


/* @ngInject */
function invoiceRepo($rootScope, $q, apiService, errSvc, eventSvc, utilSvc, validSvc, vmSvc, msgSvc) {

	// private
	var _currentPurl = '',
		_apiPaging = vmSvc.api.paging(),
		_modelPending = null;

	// service definition
	var service = {

		queryVM: queryVM,
		contextVM: contextVM,

		// split
		getSplitInvoicesList: getSplitInvoicesList,
		getSplitInvDetail: getSplitInvDetail,
		getSplitInvBacking: getSplitInvBacking,
		excelSplitInvoices: excelSplitInvoices,

		// cp
		getCPInvoicesList: getCPInvoicesList,
		trueUpLineItem: trueUpLineItem,
		getCPInvBacking: getCPInvBacking,
		excelCPInvoices: excelCPInvoices,

		// review
		getReviewList: getReviewList,
		getReviewDetail: getReviewDetail,
		adjustInvoice: adjustInvoice,
		getExcel: getExcel,

		// manual
		createInvoice: createInvoice,
		uploadInvoices: uploadInvoices

	};

	return service;

	/**
	 *    CONTEXT
	 */

	function contextVM() {

		var uType = $rootScope.User.Type;

		return {
			uType: uType,
			isDebug: !!$rootScope.debug,
			isVerity: uType == 'VERITYSA' || uType == 'VERITY'
		};

	}

	/**
	 *    VIEW MODELS
	 */

	function queryVM() {
		var uType = $rootScope.User.Type;
		return {
			UserType: uType,
			isVerity: uType == 'VERITY' || uType == 'VERITYSA',
			CE: validSvc.newProp(validSvc.isCE($rootScope.User.CE, false, true) ? $rootScope.User.CE : 'ALL'),
			RX: validSvc.newProp($rootScope.User.RX),
			VEN: validSvc.newProp('NONE'),
			AcctType: validSvc.newProp('NONE'),
			StartDate: validSvc.newPropDateNull(),
			EndDate: validSvc.newPropDateNull(),
			ProgramAdmin: validSvc.newProp('NONE'),
			OverallocatedOnly: false,
			RebatesOnly: false
		};

	}


	/**
	 *    GET SPLIT INVOICE LIST
	 */

	function getSplitInvoicesList(query) {

		// check params
		if(!!!query.DateRangeValid || !validSvc.isCE(query.CE.val, false, true) || !validSvc.isRX(query.RX.val)) {
			throw new Error('invoiceRepo.getSplitInvoicesList, params missing' + utilSvc.json.stringify(query, true));
		}

		var defer = $q.defer();
		_currentPurl = 'invoice/split/list';

		// update CE and Rx user choice
		eventSvc.rootEmit('context.change', {
			CE: query.CE.val,
			RX: query.RX.val
		});

		// create api request
		var ceid = query.CE.val == 'ALL' ? [] : [query.CE.val];
		var apiRequest = {
			Context: {
				CEID: ceid,
				RXID: [query.RX.val]
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				RebatesOnly: query.RebatesOnly
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('-VendorInvoiceDate')]
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(getOk, getErr);

		function getOk(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return query and data
			defer.resolve({
				tooMany: _apiPaging.Size < r.data.Entity.length,
				data: r.data.Entity
			});

		}

		function getErr(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	/**
	 *    GET CP INVOICE LIST
	 */

	 function getCPInvoicesList(query) {

		// check params
		if(!!!query.DateRangeValid) {
			throw new Error('invoiceRepo.getCPInvoicesList, params missing' + utilSvc.json.stringify(query, true));
		}

		var defer = $q.defer();
		_currentPurl = 'invoice/cp/list';

		// update CE and Rx user choice
		eventSvc.rootEmit('context.change', {
			CE: query.CE.val,
			RX: query.RX.val,
		});

		// create api request
		var apiRequest = {
			Context: {
				CEID: validSvc.isCE(query.CE.val) ? [query.CE.val] : [],
				RXID: query.RX.vals
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				Tpa: query.ProgramAdmin.val == 'NONE' ? '' : query.ProgramAdmin.val,
				OverallocatedOnly: query.OverallocatedOnly,
				RebatesOnly: query.RebatesOnly,
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('-VendorInvoiceDate')]
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(getOk, getErr);

		function getOk(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return query and data
			defer.resolve({
				tooMany: _apiPaging.Size < r.data.Entity.length,
				data: r.data.Entity
			});

		}

		function getErr(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	/**
	 *    TRUE UP INVOICE LINE ITEM
	 */

	function trueUpLineItem(id, notes) {
		// params
		if (!!!id) {
			throw new Error('invoiceRepo.trueUpLineItem, id is required');
		}

		_currentPurl = 'invoice/cp/trueup';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
			},
			Params: {
				Id: id,
				Notes: notes
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okTrueUp, errTrueUp);

		function okTrueUp(r) {

			// entity returned (ignoring async JobId for now)
			if (!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});

		}

		function errTrueUp(r) {
			if (!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	/**
	 *    GET SPLIT INVOICE DETAIL
	 */

	function getSplitInvDetail(id) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('invoiceRepo.getSplitInvDetail, id is missing: ' + id);
		}

		_currentPurl = 'invoice/split/detail';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Entity: {
				Params: {
					Id: id
				}
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(getOk, getErr);


		function getOk(r) {

			// bad response format
			if(!!!r || isNaN(r.status) || !!!r.data || !!!r.data.Entity) {
				r = r || {};
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function getErr(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function getSplitInvBacking(invoiceId, lineId) {

		// params
		if(!validSvc.isText(invoiceId) || !validSvc.isText(lineId)) {
			throw new Error('orderRepo.getSplitInvBacking, invoice and line id required');
		}

		_currentPurl = 'invoice/split/backing';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Params: {
				InvoiceId: invoiceId,
				LineId: lineId
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(getOk, getErr);


		function getOk(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function getErr(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	/**
	 *    GET CP INVOICE DETAIL
	 */
	function getCPInvBacking(lineId) {

		// params
		if(!validSvc.isText(lineId)) {
			throw new Error('orderRepo.getSplitInvBacking, line id required');
		}

		_currentPurl = 'invoice/cp/backing';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Params: {
				LineId: lineId
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(getOk, getErr);


		function getOk(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function getErr(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	/**
	 *    GET REVIEW LIST
	 */

	function getReviewList(listType, query) {

		var ceid = [],
			rxid = query.RX.vals,
			tpaid = [];
		
		// params, adding more validation
		switch(query.SearchType) {
			case 'CE':
				if(!validSvc.isCE(query.CE.val)) {
					throw new Error('invoiceRepo.getReviewList, CE required');
				}
				ceid.push(query.CE.val);
				break;
			case 'TPA':
				if(query.TPA.val == 'NONE') {
					throw new Error('invoiceRepo.getReviewList, TPA required');
				}
				tpaid.push(query.TPA.val);
				break;
			default:
				throw new Error('invoiceRepo.getReviewList, unknown search type: ' + query.SearchType);
		}
		
		switch(listType) {
			case 'REVIEW':
				_currentPurl = 'invoice/review/list';
				break;
			case 'ACCEPT':
				_currentPurl = 'invoice/review/accepted/list';
				break;
			case 'REJECT':
				_currentPurl = 'invoice/review/rejected/list';
				break;
			default:
				throw new Error('invoiceRepo.getReviewList, listType unknown: ' + listType);
		}

		var defer = $q.defer();

		// CE context
		if(query.SearchType == 'CE') {
			eventSvc.rootEmit('context.change', {CE: query.CE.val});
		}
		
		// create api request
		var apiRequest = {
			Context: {
				CEID: ceid,
				TPAID: tpaid,
				RXID: rxid
			},
			Params: {
				DateProperty: query.DateType,
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val
			},
			Paging: {
				Page: 1,
				Size: 20000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('InvDate')]
		};

		apiService.post(_currentPurl, apiRequest).then(okGetReviewList, errGetReviewList);

		function okGetReviewList(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({
				data: r.data.Entity,
				tooMany: r.data.Entity.length > 20000
			});

		}

		function errGetReviewList(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    GET DETAIL
	 */

	function getReviewDetail(id) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('invoiceRepo.getReviewDetail, id is missing');
		}

		_currentPurl = 'invoice/review/get';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {},
			Entity: {
				Params: {
					Id: id
				}
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okGetReviewDetail, errGetReviewDetail);

		function okGetReviewDetail(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errGetReviewDetail(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    ADJUST INVOICE
	 *    handles invoice change to ACCEPT, REJECT, OFFSET, OVERRIDE
	 */

	 function adjustInvoice(id, items, action, notes) {

		if(!validSvc.isText(id)) {
			throw new Error('invoiceRepo.adjustInvoice, id is missing');
		}

		_currentPurl = 'invoice/';
		switch(action) {
			case 'ACCEPT':
				_currentPurl += 'review/accept';
				break;

			case 'REJECT':
				_currentPurl += 'review/reject';
				break;

			case 'OFFSET':
				_currentPurl += 'review/accepted/offset';
				break;

			case 'OVERRIDE':
				_currentPurl += 'review/rejected/override';
				break;

			default:
				throw new Error('invoiceReviewDetailCtl.adjustInvoice, unknown action: ' + action);
		}

		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {},
			Entity: {
				Id: id,
				Items: items,
				Note: notes,
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okResolve, errResolve);

		function okResolve(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errResolve(r) {
			if (r != null && r.status == 409) {
				msgSvc.ok('Cannot Update Invoice', 'This invoice is currently being processed');
			} else if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    CREATE MANUAL INVOICE
	 */

	function createInvoice(query, model) {

		_currentPurl = 'invoice/manual/create';
		_modelPending = model;
		var defer = $q.defer();

		// params
		if(!validSvc.isCE(query.CE) || !validSvc.isRX(query.RX) || !validSvc.isVEN(query.VEN) || !validSvc.isText(query.AccumGrp)) {
			throw new Error('invoiceRepo.createInvoice, query is missing one of CE/RX/VEN/ACCUMGRP');
		}

		// build items array
		var items = [];
		for(var i = 0; i < model.Items.length; i++) {
			items.push({
				ItemCode: model.Items[i].ItemCode.val,
				ItemDesc: !!model.Items[i].ItemDesc ? model.Items[i].ItemDesc.val : '',
				VendItemNum: model.Items[i].VendItemNum.val,
				OrderUnits: utilSvc.num.parse(model.Items[i].OrderUnits.val),
				UnitPrice: model.Items[i].UnitPrice.val
			});
		}

		var apiRequest = {
			Context: {
				CEID: [query.CE],
				RXID: [query.RX],
				VENID: [query.VEN]
			},
			Entity: {
				AccumulatorGroup: query.AccumGrp,
				AccumRXID: query.AccumRXID,
				InvType: model.InvType,
				DirectReplenish: model.DirectReplenish.val == 'yes',
				DontInvoiceDrugs: model.DontInvoiceDrugs.val  == 'yes',
				InvNumber: model.InvNumber.val,
				InvDt: model.InvDt.val,
				PoName: model.PoName.val,
				PoDt: model.PoDt.val,
				Items: items
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okCreateInv, errCreateInv);

		function okCreateInv(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function errCreateInv(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapApiErrorsToModel(r, _modelPending);
				defer.reject(r);
			}
			else {
				throw new Error('invoiceRepo.errCreateInv, unexpected error result');
			}

		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);
				if(fieldObj === undefined) {

					// look in line items, this could be an ndc
					var ndcFound = false;
					for(var ii = 0; ii < m.Items.length; ii++) {
						if(m.Items[ii].ItemCode.val == fieldName) {
							m.Items[ii].failTxt += (m.Items[ii].fail == 'yes' ? ', ' : '') + entity.Fields[i].Rule;
							m.Items[ii].fail = 'yes';
							ndcFound = true;
							break;
						}
					}

					if(!ndcFound) {
						throw new Error('invoiceRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
					}
				}
				else {
					// set failed state on model property
					fieldObj.fail = 'yes';
					fieldObj.msg = entity.Fields[i].Rule;
				}


			}

			return m;

		}


		return defer.promise;
	}


	/**
	 *    EXCEL
	 */

	function excelSplitInvoices(query, filename) {

		// params
		if(!validSvc.isCE(query.CE.val, false, true) || !validSvc.isRX(query.RX.val) || !validSvc.isText(filename)) {
			throw new Error('invoiceRepo.excelSplitInvoices, CE/RX id or filename are missing');
		}

		_currentPurl = 'invoice/split/excel';
		var defer = $q.defer();

		// create api request
		var ceid = query.CE.val == 'ALL' ? [] : [query.CE.val];
		var apiRequest = {
			Context: {
				CEID: ceid,
				RXID: [query.RX.val]
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				RebatesOnly: query.RebatesOnly
			}
		};

		// call api
		apiService.postGetBinary(_currentPurl, apiRequest).then(okSplitInvExcel, errSplitInvExcel);

		function okSplitInvExcel(r) {
			defer.resolve(r.data);
		}

		function errSplitInvExcel(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function excelCPInvoices(query, filename) {

		// params
		if(!validSvc.isRX(query.RX.vals) || !validSvc.isText(filename)) {
			throw new Error('invoiceRepo.excelCPInvoices, RX id or filename are missing');
		}

		_currentPurl = 'invoice/cp/excel';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: validSvc.isCE(query.CE.val) ? [query.CE.val] : [],
				RXID: query.RX.vals
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				Tpa: query.ProgramAdmin.val == 'NONE' ? '' : query.ProgramAdmin.val,
				OverallocatedOnly: query.OverallocatedOnly,
				RebatesOnly: query.RebatesOnly
			},
		};

		// call api
		apiService.postGetBinary(_currentPurl, apiRequest).then(okCPInvExcel, errCPInvExcel);

		function okCPInvExcel(r) {
			defer.resolve(r.data);
		}

		function errCPInvExcel(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function getExcel(invType, query, filename) {

		// params
		if(!!!query || !validSvc.isText(filename)) {
			throw new Error('invoiceRepo.excelSplitInvoices, CE, filename required');
		}

		var defer = $q.defer();
		var apiRequest = {};

		switch(invType) {
			
			case 'REVIEW':		
				// update CE user choice
				if(query.TPA.val == 'NONE' && !validSvc.isCE(query.CE.val)) {
					throw new Error('invoiceRepo.getExcelREVIEW, CE required');
				}		
				eventSvc.rootEmit('context.change', {CE: query.CE.val});
				_currentPurl = 'invoice/review/excel';
				apiRequest.Context = {
					CEID: query.SearchType == 'CE' ? [query.CE.val] : [],
					TPAID: query.SearchType == 'TPA' ? [query.TPA.val] : [],
				};
				apiRequest.Params = {
					DateProperty: query.DateType,
					StartDate: query.StartDate.val,
					EndDate: query.EndDate.val
				};
				break;

			case 'BACKING':
				_currentPurl = 'invoice/split/backing/excel';
				apiRequest.Params = {
					Id: query.InvoiceId,
					RebatesOnly: !!query.rebatesOnly
				};
				break;
			case 'CPBACKING':
				_currentPurl = 'invoice/cp/backing/excel';
				apiRequest.Params = {
					Id: query.InvoiceId,
					RebatesOnly: !!query.rebatesOnly
				};
				break;

			default:
				errSvc.warn('Get Excel not supported for Invoice Type: ' + invType);
				defer.reject(null);
				return;
		}

		apiService.postGetBinary(_currentPurl, apiRequest).then(okReviewInvExcel, errReviewInvExcel);

		function okReviewInvExcel(r) {
			defer.resolve(r.data);
		}

		function errReviewInvExcel(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    UPLOAD INVOICES
	 */

	function uploadInvoices(query, importFile) {

		// params
		if(!validSvc.isCE(query.CE) || (query.InvOption != 'IMPORT' && query.InvOption != 'IMPORT_MULTI') || !!!importFile) {
			throw new Error('invoiceRepo.uploadInvoices, required: CE, invoice option and file');
		}

		_currentPurl = 'invoice/manual/import';
		var defer = $q.defer();

        var apiRequest = {};
        switch(query.InvOption) {
            case 'IMPORT':
                if(!validSvc.isCE(query.CE) || !validSvc.isRX(query.RX) || !validSvc.isVEN(query.VEN) || !validSvc.isText(query.ACCUMGRP) || !!!importFile) {
                    throw new Error('invoiceRepo.uploadInvoices, required: CE/RX/VEN/ACCUMGRP and import file for: ' + query.CE + '/' + query.RX);
                }
                apiRequest = {
                    CEID: query.CE,
                    RXID: query.RX,
                    VENID: query.VEN,
                    ACCUMGRP: query.ACCUMGRP,
                    AccumRXID: query.AccumRXID,
                    DirectReplenish: query.DirectReplenish,
                    DontInvoiceDrugs: query.DontInvoiceDrugs,
                };
                break;
            case 'IMPORT_MULTI':
                // all multiple invoice lines will specify secondary properties, no need to send them
                apiRequest = {
                    CEID: query.CE,
                    MultiVendor: true
                };
                break;
            default:
                throw new Error('invoiceRepo.uploadInvoices, unknown invoice option: ' + query.InvOption);
        }


		// create multi-part form data
		var fd = new FormData();
		fd.append('context', angular.toJson(apiRequest)); // stringify JSON into one "context" property
		fd.append('file', importFile);

		apiService.postFile(_currentPurl, fd, false).then(okFileImport, errFileImport);

		function okFileImport(r) {

			// bad upsert response format
			if(!!!r || !!!r.data || !!!r.data.Entity) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errFileImport(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!!!r || !validSvc.isNumber(r.status) || !!!r.data) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status === 422) {
				r.importErrors = mapApiImportErrors(r.data.Entity);
				r.counts = {
					Processed: r.data.Entity.ProcessedCount,
					Received: r.data.Entity.ReceivedCount,
					Error: r.data.Entity.ErrorCount,
					Duplicate: r.data.Entity.DuplicateCount
				};
				defer.reject(r);
			}
			else {
				errSvc.error('Unexpected error', _currentPurl + 'invoiceRepo.errFileImport', r.status, utilSvc.http.safeResponse(r));
			}

		}

		function mapApiImportErrors(entity) {

			// map server 422 fields onto import error text lines

			if(Array.isArray(entity.RecordErrors) && entity.RecordErrors.length > 0) {
				return entity.RecordErrors;
			}
			else if(entity.ROOT.length > 0) {
				return [{Name: 'File Error', Rule: entity.ROOT.join(',')}];
			}
			else {
				throw new Error('invoiceRepo.422FileImport, Api returned no errors to display');
			}
		}

		return defer.promise;

	}


}
 
invoiceManualCtl.$inject = ['$window', '$state', '$rootScope', '$scope', '$timeout', 'invoiceRepo', 'catalogsRepo', 'lookupRepo', 'utilSvc', 'validSvc', 'msgSvc'];angular
.module('espui.invoice')
.controller('InvoiceManualCtl', invoiceManualCtl);

/* @ngInject */
function invoiceManualCtl($window, $state, $rootScope, $scope, $timeout, invoiceRepo, catalogsRepo, lookupRepo, utilSvc, validSvc, msgSvc) {

	var vm = this;
	var _datePickListener = null,
		_primaryProp = 'CE',
		_affs = [],
		_fileImportListener = null,
		_routeInfo = null,
		_initOrder = null,
		_pendingNdcLookup = null;

	// inherit
	utilSvc.ctl.addPaging(vm);
	msgSvc.addHelpLink(vm);

	// props
	vm.init = true;
	vm.model = {};
	vm.summary = {};
	vm.uType = '';
	vm.hasOrder = false;

	// query
	vm.query = {};
	vm.primaryDroplist = [];
	vm.secondaryDroplist = [];
	vm.VenDroplist = [];
	vm.AccumGrpDroplist = [];
	vm.AccumRxDroplist = [];

	// query change events
	vm.queryChangePrimary = queryChangePrimary;
	vm.queryChangeSecondary = queryChangeSecondary;
	vm.queryChangeVendor = queryChangeVendor;
	vm.queryChangeAccumGrp = queryChangeAccumGrp;

	// methods
	vm.submit = submit;
	vm.cancel = cancel;
	vm.lineItemAdd = lineItemAdd;
	vm.lineItemRemove = lineItemRemove;

	// date pick
	vm.dtPickShow = {};
	vm.dtPickOpen = dtPickOpen;

	// ndc search popup
	vm.popup = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;
	vm.popupSearch = popupSearch;

	// tabs
	vm.activeTab = '';
	vm.tabChange = tabChange;

	// file upload
	vm.importFiles = [];
	vm.importErrors = [];
	vm.importCounts = {};
	vm.importGuide = false;
	vm.importFilePrompt = importFilePrompt;

	// summary
	vm.updateSummary = updateSummary;

	// ndc lookup
	vm.getNdcDescription = getNdcDescription;
	
	/**
	 *    IMPORT FILE EVENT HOOK
	 *    used to update file list to import
	 *    note:
	 *          directive widget-input-file throws event: 'widget.input.file'
	 *          event object: {id:'id of element', files:[] array of files if browser supports HTML5 File Api}
	 */

	function listenForFileImport() {

		if(!!!_fileImportListener) {

			_fileImportListener = $scope.$on('widget.input.file', function(event, importInfo) {
				event.stopPropagation();

				if(!!importInfo && !!importInfo.files && importInfo.files.length > 0) {
					vm.importFiles = importInfo.files;
				}
				else {
					vm.importFiles = [];
				}

			});
		}

	}

	$scope.$on('$destroy', function() {
		if(!!_fileImportListener) {
			_fileImportListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		vm.init = true;

		var ctx = angular.fromJson(angular.toJson($state.params || {}));
		_routeInfo = angular.fromJson(angular.toJson($state.current.routeInfo));
		_initOrder = ctx.order;
		if (!!_initOrder) {
			vm.hasOrder = true;
		}
		if(!!ctx.breadcrumb) {
			// use breadcrumb sent in route params
			$rootScope.$emit('espui>route.reset', {route: $state.current.name});
			_routeInfo.breadcrumb = ctx.breadcrumb;
		}
		// main title
		$scope.$emit('shared.main.setInfo', _routeInfo);

		vm.uType = initQueryAndUser($scope.User);
				
		if(vm.uType == 'RX') {
			// ASYNC
			// lookup which affil pharmacies have invoice.add claim
			var affs = getAffs();
			lookupRepo.AffInfo(utilSvc.aff.ceList(affs), utilSvc.aff.rxList(affs)).then(okLookUpAffInfo, errLookUpAffInfo);
		}
		else {
			_affs = getAffs();
			initFinalize();
		}

	}

	function okLookUpAffInfo(affs) {

		// only affs with feature claim 'invoice.add' are allowed

		var claimAffs = [],
			aff = {},
			i = 0,
			ii = 0,
			affFeatureClaims = [],
			featClaim = {};

		// find affs with this claim
		affs = Array.isArray(affs) ? affs : [];
		for(i = 0; i < affs.length; i++) {
			aff = affs[i];

			affFeatureClaims = Array.isArray(aff.FeatureClaims) ? aff.FeatureClaims : [];
			for(ii = 0; ii < affFeatureClaims.length; ii++) {
				featClaim = affFeatureClaims[ii];
				if(!!featClaim.Allow && featClaim.Claim == 'invoice.add') {
					claimAffs.push(aff);
					break;
				}
			}
		}

		// exit if user can't see any pharmacy
		if(claimAffs.length < 1) {
			msgSvc.okAsync('Affiliations Not Available', 'None of your affiliations allow Add Invoice functionality. Contact your Verity administrator.', 'invoice.add.noaffs').then(goHome, goHome);
			return;
		}

		// re-build affs based on claim affs
		_affs = [];
		affs = getAffs();
		for(i = 0; i < affs.length; i++) {
			aff = affs[i];
			for(ii = 0; ii < claimAffs.length; ii++) {
				if(aff.CEID == claimAffs[ii].CEID && aff.RXID == claimAffs[ii].RXID) {
					_affs.push(aff);
				}
			}
		}

		initFinalize();
	}

	function goHome() {
		$state.go('home');
	}

	function errLookUpAffInfo(r) {
		if(!!r) {
			throw new Error('invoiceManualCtl.errLookUpAffInfo, unkown api error');
		}
	}

	function initFinalize() {

		// init primary
		if(_primaryProp == 'CE') {
			vm.primaryDroplist = utilSvc.aff.ceDroplist(_affs);
		}
		else {
			vm.primaryDroplist = utilSvc.aff.rxDroplist(_affs);
		}
		vm.query.primary = utilSvc.ng.droplistAutoselect(vm.primaryDroplist, vm.query.primary.val);

		initDetails();
		if (!!_initOrder) {
			vm.model.Items = [];
			if (Array.isArray(_initOrder.Items)){
				for(var i=0; i<_initOrder.Items.length; i++){
					vm.model.Items.push(lineItemVM(_initOrder.Items[i]));
				}
			}
		}
		updateSummary();
		queryChangePrimary();

		vm.init = false;
	}

	function initQueryAndUser(usr) {

		if(!!!_initOrder) {
			vm.query = {
                InvOption: '',
				primary: validSvc.newProp(usr[_primaryProp]),
				primaryLabel: _primaryProp == 'CE' ? 'Facility' : 'Pharmacy',
				secondary: _primaryProp == 'CE' ? validSvc.newProp(usr.RX) : validSvc.newProp(usr.CE),
				secondaryLabel: _primaryProp == 'CE' ? 'Pharmacy' : 'Facility',
				Vendor: validSvc.newProp('NONE'),
				AccumGrp: validSvc.newProp('NONE'),
				useAccumRx: false,
				AccumRXID: 'NONE',
				AccumRxName: ''
			};
		} else {
			vm.query = {
                InvOption: 'MANUAL',
				primary: validSvc.newProp(_initOrder.CE),
				primaryLabel: 'Facility',
				secondary: validSvc.newProp(_initOrder.RX),
				secondaryLabel: 'Pharmacy',
				Vendor: validSvc.newProp(_initOrder.Vendor),
				AccumGrp: validSvc.newProp(_initOrder.AccumGrp),
				useAccumRx: !!_initOrder.AccumRXID,
				AccumRXID: validSvc.isText(_initOrder.AccumRXID) ? _initOrder.AccumRXID : 'NONE',
				AccumRxName: validSvc.isText(_initOrder.AccumRXID) ? utilSvc.aff.rxShortNameByIdLookup(_initOrder.AccumRXID) : ''
			};
		}
		
		// remember user type
		var uType = $scope.User.Type;
		if(uType == 'VERITY' || uType == 'VERITYSA') {
			return 'VERITY';
		}
		else {
			return uType;
		}

	}

	function getAffs() {

		// affs specific to this feature
		// note: during init the affs are cached, once running they are emptied

		var affs = utilSvc.aff.findStatus($scope.User.AffList, ['ACTIVE','INACTIVE']);
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
		// if not Verity user type, further filter
		var uType = $scope.User.Type;
		if(uType != 'VERITY' && uType != 'VERITYSA') {		
			affs = utilSvc.aff.findVerityAdmin(affs);
		}
		return utilSvc.aff.findWithVendor(affs, true);

	}

	function initDetails() {

		vm.popup = {};
		vm.model = modelVM(_initOrder);

		// date picker
		vm.dtPickShow = {
			pending: '',
			InvDt: false,
			PoDt: false
		};

        if(vm.activeTab == 'MANUAL') {
            updateSummary();
        }   
	}


	/**
	 *    VIEW MODEL
	 */

	function modelVM(order) {

		var dtToday = utilSvc.dt.zeroTime(new Date()),
			dtMin = utilSvc.dt.zeroTime(utilSvc.dt.addMonths(new Date(), -12)); // 1 year back from today
		
		var newLine = lineItemVM();

		return {
			InvType: !!order ? 'DEBIT' : '',
			InvTypeInvalid: false,
			InvNumber: validSvc.newProp(''),
			DirectReplenish: !!order.DirectReplenish ? validSvc.newProp('yes') : validSvc.newProp('no'),
			DontInvoiceDrugs: !!vm.hasOrder ? (!!order.DontInvoiceDrugs ? validSvc.newProp('yes') : validSvc.newProp('no')) : validSvc.newProp(''),
			DontInvoiceDrugInvalid: false,
			InvDt: validSvc.newPropDate(dtToday, dtMin, dtToday),
			PoName: !!order ? validSvc.newProp(order.PoName): validSvc.newProp(''),
			PoDt: (!!order && !!order.PoDt) ? validSvc.newPropDate(utilSvc.dt.zeroTime(new Date(order.PoDt)), dtMin, dtToday) : validSvc.newPropDate(dtToday, dtMin, dtToday),
			Items: [newLine]
		};

	}

	function lineItemVM(item) {
		item = !!item ? item : {};

		return {
			fail: '',
			failTxt: '',
			ItemCode: validSvc.newProp(item.ItemCode) ,
			ItemDesc: item.Description,
			VendItemNum: !!item.VendItemNum ? validSvc.newProp(item.VendItemNum) : validSvc.newProp(''),
			OrderedUnits: !!item.OrderedUnits ? item.OrderedUnits : 0.00,
			PriorUnits: !!item.PriorUnits ? item.PriorUnits : 0.00,
			OrderUnits: !!item.OrderUnits ? validSvc.newProp(item.OrderUnits) : validSvc.newProp(0.00),
			UnitPrice: validSvc.newProp(0.00),
			OrderUnitPrice: !!item.UnitPrice ? item.UnitPrice : 0.00,
			IsAssay: !!item.IsAssay,
			TotalPrice: 0.00,
		};

	}


	/**
	 *    CHANGE EVENTS
	 */

	function queryChange(changed) {

		if(!vm.init) {
            // do not reset a valid import multi
            if(vm.activeTab == 'IMPORT_MULTI' && vm.query.InvOption == 'IMPORT_MULTI' && vm.query.primary.fail == 'no') {
                // do not reset a valid import multi
            } else {
			    vm.activeTab = '';
			    initDetails();
            }

			switch(changed) {

				case 'PRIMARY':
					vm.secondaryDroplist = utilSvc.ng.droplistNONE();
					vm.VenDroplist = utilSvc.ng.droplistNONE();
					vm.AccumGrpDroplist = utilSvc.ng.droplistNONE();
					break;

				case 'SECONDARY':
					vm.VenDroplist = utilSvc.ng.droplistNONE();
					vm.AccumGrpDroplist = utilSvc.ng.droplistNONE();
					break;

				case 'VENDOR':
					vm.AccumGrpDroplist = utilSvc.ng.droplistNONE();
					break;

				case 'ACCUMGRP':
					// no dependents
					break;

				default:
					throw new Error('invManualCtl.queryChange, unknown changed type: ' + changed);
			}
		}

	}

	function queryChangePrimary() {

		queryChange('PRIMARY');

		vm.query.primary.fail = validSvc.isEntity(vm.query.primary.val) ? 'no' : 'yes';
		if(vm.query.primary.fail == 'yes') {
            vm.activeTab = '';
            vm.query.InvOption = '';
			vm.query.secondary = validSvc.newProp('NONE');
			return;
		}

        switch(vm.query.InvOption) {
            case 'IMPORT_MULTI':
                // import multi only needs CE
                tabChange('IMPORT_MULTI');
                break;
            case 'IMPORT':
            case 'MANUAL':
                // secondary options
                if(_primaryProp == 'CE') {
                    vm.secondaryDroplist = utilSvc.aff.rxDroplist(_affs, vm.query.primary.val);
                }
                else {
                    vm.secondaryDroplist = utilSvc.aff.ceDroplist(_affs, vm.query.primary.val);
                }

                vm.query.secondary = utilSvc.ng.droplistAutoselect(vm.secondaryDroplist, vm.query.secondary.val);
                queryChangeSecondary();
                break;
            default:
                // do not cacade events if no InvOption is chosen
        }
	}

	function queryChangeSecondary() {

		queryChange('SECONDARY');

		vm.query.secondary.fail = validSvc.isEntity(vm.query.secondary.val) ? 'no' : 'yes';
		if(vm.query.secondary.fail == 'yes') {
			vm.query.Vendor = validSvc.newProp('NONE');
			return;
		}

		// vendor options
		var limits = {
			CE: _primaryProp == 'CE' ? vm.query.primary.val : vm.query.secondary.val,
			RX: _primaryProp == 'RX' ? vm.query.primary.val : vm.query.secondary.val,
			ACCUMGRP: ['340B', 'GPO', 'WAC', 'OWN'],
			includeNoEDI: true
		};
		vm.VenDroplist = utilSvc.aff.droplistByType(_affs, 'VEN', limits);
		vm.query.Vendor = utilSvc.ng.droplistAutoselect(vm.VenDroplist, vm.query.Vendor.val);

		queryChangeVendor();

	}

	function queryChangeVendor() {

		queryChange('VENDOR');

		vm.query.Vendor.fail = validSvc.isEntity(vm.query.Vendor.val) ? 'no' : 'yes';
		if(vm.query.Vendor.fail == 'yes') {
			vm.query.AccumGrp = validSvc.newProp('NONE');
			return;
		}

		// accum grp options
		var limits = {
			CE: _primaryProp == 'CE' ? vm.query.primary.val : vm.query.secondary.val,
			RX: _primaryProp == 'RX' ? vm.query.primary.val : vm.query.secondary.val,
			VEN: vm.query.Vendor.val,
			includeNoEDI: true
		};
		vm.AccumGrpDroplist = utilSvc.aff.droplistByType(_affs, 'ACCUMGRP', limits);
		vm.query.AccumGrp = utilSvc.ng.droplistAutoselect(vm.AccumGrpDroplist, vm.query.AccumGrp.val);

		queryChangeAccumGrp();

	}

	function queryChangeAccumGrp() {

		queryChange('ACCUMGRP');

		vm.query.AccumGrp.fail = validSvc.isEntity(vm.query.AccumGrp.val) ? 'no' : 'yes';
		if(vm.query.AccumGrp.fail == 'yes') {
			return;
		}

		var ceid = _primaryProp == 'CE' ? vm.query.primary.val : vm.query.secondary.val;
		var rxid = _primaryProp == 'RX' ? vm.query.primary.val : vm.query.secondary.val;
		var affs = utilSvc.aff.findRx(utilSvc.aff.findCe(_affs, ceid), rxid);
		if(vm.query.AccumGrp.val == '340B') {
			var venid = vm.query.Vendor.val;
			var vens = utilSvc.aff.findVen(affs, venid, true);
			vm.hasDirectRep = hasDirectReplenish(vens, venid);
		}

		if (affs.length > 0) {
			vm.BizModel = affs[0].RxBizModel;
		}

		// ASYNC: get alt accum info for this affiliation / account type
		if(!vm.hasOrder) {
			vm.query.useAccumRx = false;
			vm.query.AccumRXID = 'NONE';
			var lbl = '';
			if (affs.length > 0) {
				lbl = affs[0].RxShortName;
			}
			vm.AccumRxDroplist = [{value:'NONE',label: lbl}];
			lookupUseAccumRx(affs[0]);
		}
		
		tabChange(vm.query.InvOption);
	}

	function lookupUseAccumRx(aff) {
		// useAccuRx depends on CE and RX both allowing Alt Accum and RX is a ROLLUP member
		if(validSvc.isText(aff.RxParent)) {
			$timeout(function(){
				affLookup(aff.CEID, aff.RXID, aff.RxParent);
			},1000);
		}
	}

	function affLookup(ceid, rxid, rollup) {
		// used to get accumulating pharmacy info
		lookupRepo.AffInfo([ceid],[rxid]).then(okAffLook, errAffLook);

		function okAffLook(r) {
			if(!Array.isArray(r) || r.length != 1) {
				errAffLook({status:200, error:'Affiliation lookup returned invalid array', response:r});
				return;
			}

			// both CE and RX allow alt accumulation
			if(r[0].CeAltAccum && r[0].RxAltAccum) {
				var affs = utilSvc.aff.findStatus(utilSvc.aff.findCe($scope.User.AffList,ceid),['ACTIVE']); // active affiliation to ceid
				affs = utilSvc.aff.findRxParent(affs, rollup); // has same rollup parent

				// remove self from options
				var affOptions = [];
				affs.forEach(function(aff){
					if(aff.RXID != rxid) {
						affOptions.push(aff);
					}
				});
				if(affOptions.length > 0) {
					vm.query.useAccumRx = true;
					vm.AccumRxDroplist = utilSvc.aff.rxDroplist(affOptions);
					vm.AccumRxDroplist[0].label = utilSvc.aff.rxShortNameByIdLookup(rxid); // NONE is order pharmacy
				}
			}
		}

		function errAffLook(r) {
			if(!!r) {
				errSvc.error('Unknown ce own use response', 'inv.manual.errAffLookup', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function hasDirectReplenish(affs, venid) {
		// loop affs (most likely 1) to find direct replenish switch
		var ii = 0,
			acct = null;
		for(var i = 0; i < affs.length; i++) {
			if (!!affs[i].DirectRepInv) {
				return true;
			}
		}
		return false;
	}

	/**
	 *    LINE ITEM EVENTS
	 */

	function lineItemAdd() {
		vm.model.Items.push(lineItemVM());
	}

	function lineItemRemove(idx) {

		if(vm.model.Items.length < 2) {
			msgSvc.ok('Line Items Required', 'At least 1 line item is required.');
			return;
		}

		vm.model.Items.splice(idx, 1);
	}


	/**
	 *    SUBMIT
	 */

	function cancel() {

		if(vm.isWaiting) {
			return;
		}

		initDetails();

	}

	function modelValid() {

		// validate for both create and update
		var m = vm.model;

		// inv type, required
		m.InvTypeInvalid = (m.InvType != 'DEBIT' && m.InvType != 'CREDIT');

		// inv/po numbers, required
		m.InvNumber = validText(m.InvNumber, 1, 30);
		m.PoName = validText(m.PoName, 1, 30);
		m.PoName.val = m.PoName.fail == 'no' ? m.PoName.val.toUpperCase() : m.PoName.val;

		// direct replenish destination
		if(m.DirectReplenish.val == 'yes') {
			m.DontInvoiceDrugInvalid = m.DontInvoiceDrugs.val != 'yes' && m.DontInvoiceDrugs.val != 'no';
			m.DirectReplenish.fail = vm.query.AccumRXID != 'NONE' ? 'yes' : 'no';
			m.DirectReplenish.msg = m.DirectReplenish.fail == 'yes' ? 'Both Accum Pharmacy and Direct Replenish cannot be used together' : '';
		} else {
			m.DirectReplenish.fail = '';
			m.DontInvoiceDrugInvalid = false;
		}

		// inv date, required
		var invDT = validSvc.propDateValid(m.InvDt);
		m.InvDt.fail = !!invDT.fail ? 'yes' : '';
		m.InvDt.msg = !!invDT.fail ? invDT.msg : '';

		// po date, required
		var poDT = validSvc.propDateValid(m.PoDt);
		m.PoDt.fail = !!poDT.fail ? 'yes' : '';
		m.PoDt.msg = !!poDT.fail ? poDT.msg : '';

		// po date must be <= invoice date
		if(!invDT.fail && !poDT.fail && utilSvc.dt.diffMilli(m.InvDt.val, m.PoDt.val) > 0) {
			m.PoDt.fail = 'yes';
			m.PoDt.msg = 'must be on or before Invoice Date';
		}

		// decimals allowed for SPLIT/SPLITMATCH affiliations
		var okDecimals = false,
			affs = getAffs(),
			ceid = _primaryProp == 'CE' ? vm.query.primary.val : vm.query.secondary.val,
			rxid = _primaryProp == 'RX' ? vm.query.primary.val : vm.query.secondary.val;

		affs = utilSvc.aff.findCe(affs, ceid);
		affs = utilSvc.aff.findRx(affs, rxid);
		if(affs.length > 0 && (affs[0].RxBizModel == 'SPLIT' || affs[0].RxBizModel == 'SPLITMATCH')) {
			okDecimals = true;
		}

		var itemsValid = lineItemsValid(m.Items, okDecimals);

		// result
		return 	itemsValid &&
			!m.InvTypeInvalid &&
			!m.DontInvoiceDrugInvalid &&
			m.InvNumber.fail != 'yes' &&
			m.InvDt.fail != 'yes' &&
			m.PoName.fail != 'yes' &&
			m.PoDt.fail != 'yes' &&
			m.DirectReplenish.fail != 'yes';
	}

	function lineItemsValid(items, okDecimals) {

		var result = true,
			item = null;

		if(items.length < 1) {
			return false;
		}

		for(var i = 0; i < items.length; i++) {
			item = items[i];

			// reset server validation messages
			item.fail = '';
			item.failTxt = '';

			item.ItemCode = validText(item.ItemCode, 11, 13);
			item.VendItemNum = validText(item.VendItemNum, 2, 50);

			// OrderUnits is integer, validate min/max as float then convert to int
			if (!!item.IsAssay) {
				var maximum = -1;
				if (vm.BizModel != 'CP') {
					maximum = 250000;
				}
				item.OrderUnits = validFloat(item.OrderUnits, 0.0001, maximum);
			} else {
				item.OrderUnits = validFloat(item.OrderUnits, 0.0001, 1000);
			}
			if(item.OrderUnits.fail == 'no') {
				// must be integer
				if(!okDecimals && !validSvc.isInteger(item.OrderUnits.val)) {
					item.OrderUnits.fail = 'yes';
					item.OrderUnits.msg = 'no decimals allowed';
				}
			}

			// unit price is optional
			var uPrice = utilSvc.str.toText(item.UnitPrice).trim();
			if(uPrice.length > 0) {
				item.UnitPrice = validFloat(item.UnitPrice, 0, 1000000000);
			}
			else {
				item.UnitPrice = null;
			}

			if(result) {
				result = item.ItemCode.fail != 'yes' &&
					item.VendItemNum.fail != 'yes' &&
					item.OrderUnits.fail != 'yes' &&
					item.UnitPrice.fail != 'yes';
			}

		}

		return result;
	}

	function submit() {

		if(vm.isWaiting) {
			return;
		}

		// validate
		if(!modelValid()) {
			var errTxt = 'All fields must be valid' + (vm.model.Items.length > 0 ? '.' : ', at least 1 line item required.');
			msgSvc.ok('Cannot Create Invoice', errTxt);
			return;
		}
		vm.isWaiting = true;
		vm.popup = {};

		// confirm
		msgSvc.confirm({
			id: 'invoice.manual.confirm',
			title: 'Create ' + vm.model.InvType + ' Invoice',
			msg: 'Create ' + vm.query.AccumGrp.val + ' ' + vm.query.Vendor.val + ' invoice? Please check line items carefully, this is NOT reversible.',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

	}

	function userConfirm(r) {

		if(!!r && r.result == 'YES') {

			var apiQuery = {
				CE: _primaryProp == 'CE' ? vm.query.primary.val : vm.query.secondary.val,
				RX: _primaryProp == 'RX' ? vm.query.primary.val : vm.query.secondary.val,
				VEN: vm.query.Vendor.val,
				AccumGrp: vm.query.AccumGrp.val,
				AccumRXID: vm.query.AccumRXID != 'NONE' ? vm.query.AccumRXID : ''
			};

			invoiceRepo.createInvoice(apiQuery, vm.model).then(okCreate, errCreate);
		}
		else {
			vm.isWaiting = false;
		}

	}

	function okCreate(r) {
		vm.isWaiting = false;
		_initOrder = {};
		vm.hasOrder = false;

		msgSvc.okAsync(
			vm.model.InvType + ' Invoice Created',
			'Request for ' + vm.query.Vendor.val + ' Invoice started. Background process will finish shortly.',
			'invoice.manual.ok').then(initDetails);
	}

	function errCreate(r) {
		vm.isWaiting = false;

		if(!!!r) {
			// already handled
		}
		else if(r.status === 409) {
			// conflict
			msgSvc.ok('Cannot Create Invoice', 'This invoice number may already exist in the database. Verify and try again.');
		}
		else if (r.status === 422) {
			// validation
			msgSvc.ok('Cannot Create Invoice', 'All fields must be valid.');
			vm.model = r.model;
		}
		else {
			errSvc.error('Unexpected api error', 'invoiceManualCtl.errCreate', r.status, utilSvc.http.safeResponse(r));
		}

	}


	/**
	 *    DATE PICKER
	 *    EVENT HOOK, DESTROY AND TOGGLE
	 */

	_datePickListener = $scope.$on('widget.input.date.pick.change', function(event, evtData) {
		event.stopPropagation();

		// params
		if(!evtData || !validSvc.isText(evtData.uniqueId)) {
			alert('invoiceManualCtl.datePickEvt, evtData and uniqueId required');
			return;
		}
		var id = evtData.uniqueId;

		if(id != 'InvDt' && id != 'PoDt') {
			alert('invoiceManualCtl.datePickEvt, uniqueId unknown: ' + id);
			return;
		}

		vm.dtPickShow[id] = false;
		vm.model[id].val = evtData.setDate;

		// set max date of PO to match Invoice date
		if(id == 'InvDt') {
			vm.model.PoDt.max = evtData.setDate;
		}

	});

	$scope.$on('$destroy', function() {
		vm.popup = {};
		// clean up listener on destroy
		if(!!_datePickListener) {
			_datePickListener();
		}
	});

	function dtPickOpen(dtName) {
		vm.popup = {};

		if(dtName != 'InvDt' && dtName != 'PoDt') {
			alert('invoiceManualCtl.dtPickOpen, date pick name unknown: ' + dtName);
			return;
		}
		var dt = vm.model[dtName];
		vm.dtPickShow.pending = dtName;

		$scope.$broadcast('widget.input.date.pick', {
			uniqueId: dtName,
			setDate: dt.val,
			minDate: dt.min,
			maxDate: dt.max
		});

		$timeout(function(){
			if(validSvc.isText(vm.dtPickShow.pending)) {
				vm.dtPickShow[vm.dtPickShow.pending] = true;
			}
		},100);

	}


	/**
	 *    POPUP
	 *    used for NDC catalog search
	 */

	function openPopup(evt, lineItem, idx) {

		if(vm.isWaiting) {
			return;
		}

		// get ndc text from property
		var ndc = lineItem.ItemCode.val;

		vm.popup = {
			ready: false,
			NDC: validSvc.newProp(ndc),
			Desc: validSvc.newProp(''),
			propName: idx,
			Items: [],
			SortBy: 'NDC',
			Paging: {
				Size: 50
			}
		};

		// remember the clicked vertical location
		var elem = evt.target,
			offsetY = -100, // pop over
			hitRow = false;

		// loop html elements back to top of table
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
				break;
			}

			// add offset, get next element
			offsetY += elem.offsetTop;
			elem = elem.offsetParent;
		}
		elem = null;

		// move popup to clicked row
		var popup = document.getElementById('tablePopupContent');
		if(!!popup) {
			popup.style.top = offsetY.toString() + 'px';
		}

		// wait for digest before showing
		$timeout(function() {
			vm.popup.ready = true;
		}, 100);

	}

	function popupQueryValid() {

		var resultText = '';

		var ndc = vm.popup.NDC.val,
			desc = vm.popup.Desc.val;

		// ndc or desc is required
		if(!validSvc.isText(ndc) && !validSvc.isText(desc)) {
			vm.popup.NDC.fail = 'yes';
			vm.popup.Desc.fail = 'yes';
			resultText = (resultText.length > 0 ? ', ' : '') + 'NDC or Description search text is required';
		}

		// ndc, optional 3 to 13 characters
		if(validSvc.isText(ndc) && (ndc.length < 3 || ndc.length > 13)) {
			vm.popup.NDC.fail = 'yes';
			resultText = (resultText.length > 0 ? ', ' : '') + 'NDC must be 3 to 13 characters';
		}
		else {
			vm.popup.NDC.fail = 'no';
		}

		// description, optional 3 to 50 characters
		if(validSvc.isText(desc) && (desc.length < 3 || desc.length > 50)) {
			vm.popup.Desc.fail = 'yes';
			resultText = (resultText.length > 0 ? ', ' : '') + 'Description must be 3 to 50 characters';
		}
		else {
			vm.popup.Desc.fail = 'no';
		}

		return resultText;
	}

	function popupSearch(showMsg) {

		// search query valid
		var result = popupQueryValid();
		if(result !== '') {
			if(showMsg) {
				msgSvc.ok('NDC Search', 'Check filter properties. ' + result);
			}
			return;
		}

		// exit if waiting
		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true);

		vm.popup.Items = [];

		// send api request
		catalogsRepo.search(vm.popup).then(okSearch, errSearch);

		function okSearch(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.popup.Items = Array.isArray(r.Items) ? r.Items : [];
			vm.popup.Paging = {
				Page: 1,
				Size: 50,
				Total: vm.getTotalPages(vm.popup.Items.length, 50),
				TooMany: r.TooMany
			};

			// none found
			if(vm.popup.Items.length < 1) {
				msgSvc.ok('NDC Catalog Search', 'None found');
			}

		}

		function errSearch(r) {

			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Unknown get response', 'errPopupSearch', r.status, utilSvc.http.safeResponse(r));
			}

			vm.popup = {};

		}

	}

	function closePopup(item) {

		// user cancelled
		if(!item) {
			vm.popup = {};
			return;
		}

		var lineIdx = parseFloat(vm.popup.propName);
		if(!validSvc.isNumber(lineIdx)) {
			vm.popup = {};
			return;
		}

		vm.model.Items[lineIdx].ItemCode = validSvc.newProp(item.NDC);
		vm.model.Items[lineIdx].ItemDesc = item.Description;
		vm.model.Items[lineIdx].IsAssay = item.IsAssay;

		vm.popup = {};

	}


	/**
	 *    TAB CHANGE
	 */

	function tabChange(newTab) {

		if(vm.isWaiting) {
			return;
		}

		vm.importFiles = [];
		vm.importErrors = [];
		vm.importCounts = {};
		vm.importGuide = false;

		switch(newTab) {

			case 'MANUAL':
				break;

			case 'IMPORT':
            case 'IMPORT_MULTI':

				// check for File API and FormData upload browser support
				if(typeof($window.File) === 'undefined' ||
					typeof($window.FileReader) === 'undefined' ||
					typeof($window.FileList) === 'undefined' ||
					typeof($window.Blob) === 'undefined' ||
					typeof($window.FormData) === 'undefined') {
					msgSvc.ok('File Upload Not Supported', 'File Upload uses HTML5 FormData upload, your browser does not support it. Please upgrade to use file upload.');
					return;
				}

				listenForFileImport();
				break;

			default:
				alert('invoiceManualCtl.tabChange, unknown tab: ' + newTab);
		}

		vm.activeTab = newTab;

	}

	/**
	 *    Summary Total
	 */
	function updateSummary(){
		var totalorderunits = 0,
			totalassayorderunits = 0, 
			totalprice = 0;
		for(var i = 0; i < vm.model.Items.length; i++) {
			var item = vm.model.Items[i];
			var itemtotalprice = 0;
			if (validSvc.isNumber(item.OrderUnits.val)) {
				if (!!item.IsAssay) {
					totalassayorderunits += parseInt(item.OrderUnits.val);
				} else {
					totalorderunits += parseInt(item.OrderUnits.val);
				}
				itemtotalprice = parseInt(item.OrderUnits.val) * parseFloat(item.UnitPrice.val);
			}
			if (validSvc.isNumber(itemtotalprice)) {
				item.TotalPrice = itemtotalprice;	
				totalprice += itemtotalprice;
			}
		}
		vm.summary = {
			TotalOrderUnits: !!totalorderunits ? totalorderunits : 0.00,
			TotalAssayOrderUnits: !!totalassayorderunits ? totalassayorderunits : 0.00,
			TotalPrice: !!totalprice ? totalprice : 0.00,
		};
	}

	/**
	 *    IMPORT INVOICES FILE
	 */

	function importValidFile(newFile) {

		// required
		if(!!!newFile) {
			return 'no file selected';
		}

		// file size > 0 bytes, < 10 megabytes
		if(!validSvc.isNumber(newFile.size) || newFile.size < 1 || newFile.size > 10000000) {
			return 'file size must be 2 bytes to 10 megabytes';
		}

		return 'ok';

	}

	function uploadValid() {

		// files selected
		if(!!!vm.importFiles || vm.importFiles.length !== 1) {
			msgSvc.ok('File Import', 'Please choose 1 file to upload.');
			return false;
		}

		// validate file
		var fileFail = importValidFile(vm.importFiles[0]);
		if(fileFail != 'ok') {
			msgSvc.ok('File Import', 'Selected file error: ' + fileFail);
			return false;
		}

		// direct replenish destination
        if(vm.query.InvOption == 'IMPORT') {
            if(vm.model.DirectReplenish.val == 'yes') {
                vm.model.DontInvoiceDrugInvalid = vm.model.DontInvoiceDrugs.val != 'yes' && vm.model.DontInvoiceDrugs.val != 'no';
                vm.model.DirectReplenish.fail = vm.query.AccumRXID != 'NONE' ? 'yes' : 'no';
                vm.model.DirectReplenish.msg = vm.model.DirectReplenish.fail == 'yes' ? 'Both Accum Pharmacy and Direct Replenish cannot be used together' : '';
            }
            else {
                vm.model.DontInvoiceDrugInvalid = false;
                vm.model.DirectReplenish.fail = '';
            }
            if(vm.model.DontInvoiceDrugInvalid || vm.model.DirectReplenish.fail == 'yes') {
                return false;
            }
        }

		return true;

	}

	function importFilePrompt() {

		if(vm.isWaiting) {
			return;
		}

		if(!uploadValid()) {
			return;
		}

        var importMsg = '';
        switch(vm.query.InvOption) {
            case 'IMPORT':
                importMsg = 'Single Import for ' + vm.query.Vendor.val + '-' + vm.query.AccumGrp.val;
                break;
            case 'IMPORT_MULTI':
                importMsg = 'Multiple Import for ' + vm.query.primary.val;
                break;
            default:
                throw new Error('invoiceManualCtl.importFilePrompt, unknown InvOption: ' + vm.query.InvOption);
        }

		msgSvc.confirm({
			id: 'invoice.import.confirm',
			title: importMsg,
			msg: 'Warning: double check line items are correct. Once uploaded, invoice items cannot be changed or corrected.',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmUpload, confirmUpload);

	}

	function confirmUpload(r) {

		// user cancelled
		if(!!!r || r.result != 'YES') {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);
		vm.importErrors = [];
		vm.importCounts = {};

		var apiQuery = {
            InvOption: vm.query.InvOption,
			CE: _primaryProp == 'CE' ? vm.query.primary.val : vm.query.secondary.val,
        };

        if(vm.query.InvOption == 'IMPORT') {
			apiQuery.RX = _primaryProp == 'RX' ? vm.query.primary.val : vm.query.secondary.val;
			apiQuery.VEN = vm.query.Vendor.val;
			apiQuery.ACCUMGRP = vm.query.AccumGrp.val;
			apiQuery.AccumRXID = vm.query.AccumRXID != 'NONE' ? vm.query.AccumRXID : '';
			apiQuery.DirectReplenish = vm.model.DirectReplenish.val == 'yes';
			apiQuery.DontInvoiceDrugs = vm.model.DontInvoiceDrugs.val  == 'yes';
        }

		invoiceRepo.uploadInvoices(apiQuery, vm.importFiles[0]).then(okFileImport, errFileImport);

		function okFileImport(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;
			msgSvc.okAsync('File Import Success', 'Total ' + r.ProcessedCount + ' invoices imported.', 'invoice.import.ok').then(okFileImportDone, okFileImportDone);
		}

		function okFileImportDone() {
			tabChange('IMPORT');
		}

		function errFileImport(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(r === null) {
				return;
			}
			else if (r.status === 422) {
				vm.importFiles = [];
				vm.importErrors = r.importErrors;
				vm.importCounts = r.counts;
				if(r.counts.Processed > 0) {
					msgSvc.ok('File Import With Errors', r.counts.Processed + ' imported, ' + r.importErrors.length + ' errors');
				}
				else {
					msgSvc.ok('File Import Failed', 'No line items were imported, there are: ' + r.importErrors.length + ' line item errors');
				}
			}
			else {
				errSvc.error('Unexpected api error', 'invoiceManualCtl.errFileImport', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 * 	  NDC DESCRIPTION
	 */

	function getNdcDescription(lineItem) {
		// reference ndc from catalog

		// reset dependents
		lineItem.ItemDesc = '';
		lineItem.OrderUnits = validSvc.newProp(0);
		lineItem.IsAssay = false;

		// clean up input
		var ndc = validSvc.isInteger(lineItem.ItemCode.val) ? lineItem.ItemCode.val.toString() : '';
		if(ndc.length < 11) {
			return;
		}
		
		// call api (convert to catalog NDC format)
		_pendingNdcLookup = lineItem;
		catalogsRepo.getReferenceNdc(ndc).then(okGet, errGet);

		function okGet(r) {
			if(!!!r || !validSvc.isText(r.Description)) {
				errGet();
				return;
			}
			_pendingNdcLookup.ItemDesc = r.Description;
			_pendingNdcLookup.IsAssay = !!r.IsAssay;
		}
		function errGet(r) {
			_pendingNdcLookup.ItemDesc = 'NDC Not Found';
		}
	}
	

	/**
	 *    HELPERS
	 */

	function validText(prop, min, max) {

		// required
		if(!validSvc.isText(prop.val)) {
			prop.fail = 'yes';
			prop.msg = 'required';
			return prop;
		}

		// min
		if(prop.val.length < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum ' + min.toString() + ' characters';
			return prop;
		}

		// max
		if(prop.val.length > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum ' + max.toString() + ' characters';
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';
		return prop;

	}

	function validFloat(prop, min, max) {

		// parse into float
		var floatVal = utilSvc.num.parse(prop.val);

		// not a number
		if(!validSvc.isNumber(floatVal)) {
			prop.fail = 'yes';
			prop.msg = 'must be a number';
			return prop;
		}

		// min
		if(floatVal < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum: ' + min;
			return prop;
		}

		// max
		if(max > 0 && floatVal > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum: ' + max;
			return prop;
		}

		// success
		prop.val = floatVal;
		prop.fail = 'no';
		prop.msg = '';

		return prop;

	}

}

 
invoiceReviewDetailCtl.$inject = ['$scope', '$state', '$filter', 'invoiceRepo', 'validSvc', 'errSvc', 'utilSvc', 'msgSvc'];
angular
.module('espui.invoice')
.controller('InvoiceReviewDetailCtl', invoiceReviewDetailCtl);


/* @ngInject */
function invoiceReviewDetailCtl($scope, $state, $filter, invoiceRepo, validSvc, errSvc, utilSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this,
		_pendingAdjustment = {};

	// inherit sorting and paging features
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);

	// properties
	vm.isWaiting = false;
	vm.action = '';

	// summary
	vm.editAssayItem = editAssayItem;
	vm.filterChange = filterChange;

	// models
	vm.model = {};

	vm.adjustInvoice = adjustInvoice;


	/**
	 *    INIT
	 */

	init();

	function init() {

		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		// set context
		var ctx = $state.params;
		if(!!!ctx || !validSvc.isText(ctx.Id) || !validSvc.isText(ctx.tab)) {
			throw new Error('invoiceReviewDetailCtl.init, Id is missing');
		}
		vm.context = ctx;
		vm.context.canEdit = utilSvc.user.hasFeature($scope, 'invoice.review.edit');
		vm.context.isRxUser = $scope.User.Type == 'RX' || $scope.User.Type == 'RXROLLUP';

		vm.action = '';
		getDetail();

	}


	/**
	 *    DISPLAY VIEW MODELS
	 */

	function displayVM(data) {

		// add display properties, modify model for ui display

		data = data || {};

		// is pharmacy business model splitting?
		data.isSplitBizModel = false;
		if(validSvc.isText(data.Pharmacy)) {
			var affs = utilSvc.aff.findRx($scope.User.AffList, data.Pharmacy);
			affs = utilSvc.aff.findCe(affs, data.Ce);
			affs = utilSvc.aff.findRxModel(affs, ['SPLIT','SPLITMATCH']);
			if(affs.length > 0) {
				data.isSplitBizModel = true;
			}
		}

		data.ReviewReasonDesc = reviewReasonDesc(data.ReviewReason);
		vm.InvoiceInAssayUnits = !!data.InvoiceInAssayUnits;

		var items = Array.isArray(data.Items) ? data.Items : [],
			isAssay = false,
			item = {},
			isReviewTab = vm.context.tab == 'REVIEW';

		for (var i=0; i < items.length; i++) {
			item = items[i];

			// line item is assay
			isAssay = !!item.IsAssay;
			item.IsAssay = isAssay;
			if (!vm.IsAssay && isAssay) {
				vm.IsAssay = true; // order has assay items
			}
			item.canEditAssay = isAssay && isReviewTab;

			item.AssayOrderUnits = isAssay ? item.OrderUnits : '';
			item.AssayUnitPrice = isAssay ? item.UnitPrice : '';
			item.AssayRefPrice = isAssay ? item.RefPrice : '';
			item.AssayRefPriceTotal = isAssay ? item.RefPriceTotal : '';
			item.MedispanPrice = isAssay ? item.MedispanPrice : '';

			// assay medispan price indicator
			item = calculateMedispanPriceFlags(vm.InvoiceInAssayUnits, item);
		}
		vm.IsAssayReview = vm.IsAssay && isReviewTab;
		vm.showAssayRefColumns = vm.IsAssay && !!data.isSplitBizModel && !!!data.SplitRemainder;

		data.Items = items;
		data.Paging = {
			Page: 1,
			Size: $scope.tblPagingSize,
			Total: vm.getTotalPages(items.length, $scope.tblPagingSize)
		};
		data.SortBy = ['LineNumber'];

		return data;

	}

	function calculateMedispanPriceFlags(invoiceInAssayUnits, item) {
		// calculate medispan price flags
		item = item || {};
		item.MedispanUnitPriceFlag = false;
		item.MedispanRefPriceFlag = false;

		if(!item.IsAssay) {
			return item;
		}

		if(invoiceInAssayUnits) {
			item.MedispanUnitPriceFlag = item.UnitPrice > item.MedispanPrice;
			item.MedispanRefPriceFlag = item.RefPrice > item.MedispanPrice;
		}
		else {
			item.MedispanUnitPriceFlag = item.UnitPrice < item.MedispanPrice;
			item.MedispanRefPriceFlag = item.RefPrice < item.MedispanPrice;
		}

		return item;
	}

	function reviewReasonDesc(reasonCode) {

		switch(reasonCode) {

			case 'UNKNOWN PO':
				return 'Invoice PO either empty or not a V340B created order';

			case 'QUANTITY':
				return 'CR invoice line item has more quantity than found in previous debit invoices';

			case 'DUPE LI #':
				return 'Invoice has line items with the same line item number';

			case 'CATALOG N/A':
				return 'Price and/or package catalog item missing for NDC';
			
			case 'NON-BILLED':
				return 'Invoice received has $0 total';

			case 'OTHER':
				return 'Unknown error';

			default:
				return 'n/a';
		}

	}


	/**
	 *    GET DETAIL
	 */

	function getDetail() {

		invoiceRepo.getReviewDetail(vm.context.Id).then(okDetail, errDetail);

		function okDetail(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.model = displayVM(r);
			vm.flt = {};

			vm.action = 'DETAIL';
		}
		function errDetail(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r !== null) {
				r = r || {};
				errSvc.warn('Invoice Review Detail Get Error for id: ' + vm.context.Id, 'invoiceReviewDetailCtl.getDetail.errDetail', r.status, utilSvc.http.safeResponse(r));
			}
			$state.go('invoice.review', {}, {reload: 'invoice.review'});
		}

	}

	/**
	 *    EDIT ASSAY ITEM
	 *    - editType: 'OrderUnits', 'UnitPrice', 'RefPrice'
	 *.   totals calculated based on event edit type
	 */
	 function editAssayItem(item, editType){
		if(vm.isWaiting || !!!item) {
			return;
		}

		switch(editType) {
			case 'OrderUnits':
				if(!numOverZero(item.AssayOrderUnits)) {
					if(!vm.InvoiceInAssayUnits) {
						item.UnitPriceTotal = 0;
						item.RefPriceTotal = 0;
					}
					return;
				}
				item.OrderUnits = parseInt(item.AssayOrderUnits);

				// re-calculate pricing if invoice is priced in assay units
				if(vm.InvoiceInAssayUnits && item.OrderUnits > 0) {
					item.UnitPrice = validSvc.isNumber(item.UnitPriceTotal) ? decVal(item.UnitPriceTotal / item.OrderUnits, 2) : 0;
					item.AssayUnitPrice = item.UnitPrice;
					if(vm.showAssayRefColumns) {
						item.RefPrice = validSvc.isNumber(item.RefPriceTotal) ? decVal(item.RefPriceTotal / item.OrderUnits, 2) : 0;
						item.AssayRefPrice = item.RefPrice;
					}
				}

				// re-calculate totals
				item.UnitPriceTotal = validSvc.isNumber(item.UnitPrice) ? item.OrderUnits * item.UnitPrice : 0;
				if(vm.showAssayRefColumns) {
					item.RefPriceTotal = validSvc.isNumber(item.RefPrice) ? item.OrderUnits * item.RefPrice : 0;
				}
				item = calculateMedispanPriceFlags(vm.InvoiceInAssayUnits, item);
				break;

			case 'UnitPrice':
				if(!numOverZero(item.AssayUnitPrice) || !numOverZero(item.OrderUnits)) {
					if(!vm.InvoiceInAssayUnits) {
						item.UnitPriceTotal = 0;
					}
					return;
				}
				item.UnitPrice = parseFloat(item.AssayUnitPrice);
				item.UnitPriceTotal = item.OrderUnits * item.UnitPrice;
				item = calculateMedispanPriceFlags(vm.InvoiceInAssayUnits, item);
				break;

			case 'RefPrice':
				if(!vm.showAssayRefColumns) {
					throw new Error('invoiceReviewDetailCtl.editAssayItem, RefPrice edit not allowed when showAssayRefColumns is false');
				}
				if(!numOverZero(item.AssayRefPrice) || !numOverZero(item.OrderUnits)) {
					if(!vm.InvoiceInAssayUnits) {
						item.RefPriceTotal = 0;
					}
					return;
				}
				item.RefPrice = parseFloat(item.AssayRefPrice);
				item.RefPriceTotal = item.OrderUnits * item.RefPrice;
				item = calculateMedispanPriceFlags(vm.InvoiceInAssayUnits, item);
				break;
				
			default:
				throw new Error('invoiceReviewDetailCtl.editAssayItem, unknown editType: ' + editType);
		}
	}

	function decVal(val, decPlaces) {
		return parseFloat(val.toFixed(decPlaces));
	}

	
	/**
	 *    GLOBAL GREASE COLUMN FILTERS
	 */

	function filterChange(immediate) {
	}

	/**
	 *    RESOLVE INVOICE
	 */

	function adjustInvoice(action) {

		if(vm.isWaiting) {
			return;
		}

		var title = '';
		var items = [];

		switch(action) {

			case 'ACCEPT':
				title = 'Accept';
				if (!validAssayEdit()) {
					msgSvc.ok('Cannot Accept Invoice', 'All fields must be valid');		
					return;
				}
				for (var i = 0; i < vm.model.Items.length; i++) {
					var item = vm.model.Items[i];
					if (!item.IsAssay) {
						continue;
					}
					items.push({
						Id: item.Id,
						OrderUnits: parseInt(item.AssayOrderUnits),
						UnitPrice: parseFloat(item.UnitPrice),
						RefPrice: parseFloat(item.RefPrice)
					});
				} 
				break;

			case 'REJECT':
				title = 'Reject';
				break;

			case 'OFFSET':
				title = 'Offset Accepted';
				break;

			case 'OVERRIDE':
				title = 'Override Rejected';
				break;

			default:
				alert('invoiceReviewDetailCtl.adjustInvoice, unknown action: ' + action);
				return;
		}

		_pendingAdjustment = {
			action: action,
			title: title,
			id: vm.model.Id,
			inv: vm.model.InvNumber,
			items: items,
		};

		msgSvc.confirm({
			id: 'invoice.adjust.confirm',
			title: title + ' Invoice',
			msg: title + ' Invoice # ' + _pendingAdjustment.inv + '?',
			notes: {
				prompt: 'optional ' + action + ' notes',
				maxlength: 100,
				out: ''
			},
			buttons: [
				{text: action.toUpperCase(), result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(adjustConfirmed, adjustConfirmed);

	}

	function validAssayEdit(){
		try {
			for(var i = 0; i < vm.model.Items.length; i++) {
				var item = vm.model.Items[i];
				if (!item.IsAssay) {
					continue;
				}
				// validate order units
				item.OrderUnits = parseInt(item.AssayOrderUnits);
				if (!numOverZero(item.OrderUnits)) {
					return false;
				}
				// validate unit price
				item.UnitPrice = parseFloat(item.UnitPrice);
				item.UnitPriceTotal = parseFloat(item.UnitPriceTotal);
				if (!numOverZero(item.UnitPrice) || !numOverZero(item.UnitPriceTotal)) {
					return false;
				}
				if(vm.showAssayRefColumns) {
					// validate ref price
					item.RefPrice = parseFloat(item.RefPrice);
					item.RefPriceTotal = parseFloat(item.RefPriceTotal);
					if (!numOverZero(item.RefPrice) || !numOverZero(item.RefPriceTotal)) {
						return false;
					}
				}
				else {
					item.RefPrice = 0.0;
					item.RefPriceTotal = 0.0;
				}
			}
			return true;
		}
		catch(e) {
			return false;
		}
	}

	function numOverZero(val) {
		return validSvc.isNumber(val) && val > 0;
	}

	function adjustConfirmed(r) {

		// user cancelled
		if(vm.isWaiting || !!!r || r.result != 'YES') {
			_pendingAdjustment = {};
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		// send api request
		r.notes = validSvc.isText(r.notes) ? r.notes : '';
		invoiceRepo.adjustInvoice(_pendingAdjustment.id, _pendingAdjustment.items, _pendingAdjustment.action, r.notes).then(okAdjust, errAdjust);

		function okAdjust(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			msgSvc.okAsync(_pendingAdjustment.title + ' Invoice', 'Invoice #' + _pendingAdjustment.inv + ' modify request started. Refresh your invoice list to monitor final invoice status.', 'invoice.review.adjust').then(returnToList, returnToList);
		}

		function errAdjust(r) {

			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r !== null) {
				errSvc.error('Unknown response', 'invoiceReviewList.errAdjust', r.status, utilSvc.http.safeResponse(r));
			}
			else {
				returnToList();
			}

		}
	}

	function returnToList() {
		$state.go('invoice.review',{},{reload: 'invoice.review'});
	}


}
 
invoiceReviewCtl.$inject = ['$window', '$state', '$scope', '$timeout', '$filter', 'invoiceRepo', 'vendorRepo', 'sessionRepo', 'lookupRepo', 'msgSvc', 'utilSvc', 'validSvc', 'errSvc'];
angular
	.module('espui.invoice')
	.controller('InvoiceReviewCtl', invoiceReviewCtl);


/* @ngInject */
function invoiceReviewCtl($window, $state, $scope, $timeout, $filter, invoiceRepo, vendorRepo, sessionRepo, lookupRepo, msgSvc, utilSvc, validSvc, errSvc) {

	/*jshint validthis: true */
	var vm = this;
	var _pendingExcelFilename = '',
		_featureName = '',
		_pagingEventListener = null,
		_tabFlt = {},
		_returnVisit = false,
		_rollupAffs = [];

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	
	// tabs
	vm.activeTab = '';
	vm.tabChange = tabChange;
	
	// query
	vm.query = {};
	vm.CeDroplist = [];
	vm.RxDroplist = [];
	vm.TpaDroplist = [];
	vm.DateTypeDroplist = [];
	vm.queryChangeCE = queryChangeCE;
	vm.queryChangeRX = queryChangeRX;
	vm.queryChangeTPA = queryChangeTPA;
	vm.queryChangeSearchType = queryChangeSearchType;
	vm.dateRangeChange = dateRangeChange;
	vm.queryDateTypeChange = queryDateTypeChange;
	vm.queryChangeAffs = queryChangeAffs;

	// methods
	vm.getReviewList = getReviewList;
	vm.getDetail = getDetail;
	vm.createExcel = createExcel;

	// table and filters
	vm.tbl = {};
	vm.flt = {};
	vm.filterChange = filterChange;

	vm.helpLinkClick = helpLinkClick;


	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function (event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if (!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(vm.flt, vm.tbl, true);

	});


	/**
	 *    DESTROY
	 */
	$scope.$on('$destroy', function () {

		if (!!_pagingEventListener) {
			_pagingEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		_featureName = $state.current.name;

		vm.init = true;
		vm.query = initQueryAndTabFilters();
		vm.activeTab = 'REVIEW'; // default

		if(vm.query.rollups.length > 0) {
			// ASYNC: lookup rollup names
			initRollupOptions(vm.query.rollups);
		}
		else {
			// ASYNC: get tpa options, initFinish will be called to finish init
			initTpaOptions();
		}
	}

	function initRollupOptions(rollups) {
		// ASYNC routine to get RX short names

		lookupRepo.RxInfo(rollups).then(okLookupRx, errLookupRx);

		function okLookupRx(items) {
			items = Array.isArray(items) ? items : [];
			
			// create map of rollup names
			var rollupShortNames = {};
			items.forEach(function(rollInfo){
				rollupShortNames[rollInfo.NickName] = validSvc.isText(rollInfo.ShortName) ? rollInfo.ShortName : rollInfo.NickName;
			});
			
			// add names to rollup Affs
			_rollupAffs.forEach(function(aff){
				aff.RxShortName = rollupShortNames[aff.RXID];
			});

			// ASYNC: get tpa options, initFinish will be called to finish init
			initTpaOptions();
		}

		function errLookupRx(r) {
			if(!!r) {
				errSvc.error('Error loading rollup display properties', 'ctlBillingRx.initRollupOptions', r.status, utilSvc.http.safeResponse(r));
			}
			else {
				// ASYNC: get tpa options, initFinish will be called to finish init
				initTpaOptions();
			}
		}

	}

	function initTpaOptions() {
		vm.isWaiting = true;
		msgSvc.wait(true);

		vendorRepo.getTPAList().then(okGetTpa, errGetTpa);

		function okGetTpa(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			r = Array.isArray(r) ? r : [];
			var tpaOptions = [];

			// per Julie, filter to ACTIVE affiliation TPAS only
			var userTpas = utilSvc.aff.progAdminList(getAffs(false));
			r.forEach(function(tpa){
				if(userTpas.indexOf(tpa.Id) > -1) {
					tpaOptions.push(tpa);
				}
			});
			vm.TpaDroplist = utilSvc.aff.tpaDroplist(tpaOptions);

			initFinish();
		}

		function errGetTpa(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			if (!!r) {
				errSvc.error('invoiceReviewCtl.initTpaOptions, unknown api error', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function initFinish() {
		vm.activeTab = initViewState(vm.query, 'REVIEW');

		// fire date control event after widget scope is setup
		$timeout(function () {
			$scope.$broadcast('widget.input.date.range.mode', { mode: vm.query.DateRangeMode, keepDates: true });
		}, 300);
	}

	function queryVM() {

		var dtToday = utilSvc.dt.zeroTime(new Date()),
			dtMin = utilSvc.dt.zeroTime(utilSvc.dt.addDays(new Date(), (-3650))); // 10 years days back from today

		return {
			isCeUser: $scope.User.Type == 'CE',
			isRxUser: $scope.User.Type == 'RX',
			isVerity: $scope.User.Type == 'VERITY' || $scope.User.Type == 'VERITYSA',
			CE: validSvc.newProp('NONE'),
			RX: validSvc.newProp('ALL'),
			TPA: validSvc.newProp('NONE'),
			SearchType: 'CE',
			DateType: 'CREATED',
			StartDate: validSvc.newPropDate(dtMin, dtMin, dtToday),
			EndDate: validSvc.newPropDate(dtToday, dtMin, dtToday),
			showInactiveAffs: 'no'
		};
	}

	function initQueryAndTabFilters() {
		var q = queryVM();

		q.DateRangeList = utilSvc.widget.dateRangeList([]);
		q.DateRangeMode = 'MTD';

		// droplists
		vm.CeDroplist = utilSvc.ng.droplistNONE();
		vm.DateTypeDroplist = [
			{label:'Received Date', value:'CREATED'},
			{label:'Invoice Date', value:'INVOICED'}
		];

		// RxDroplist can have rollups (filled in later)
		var rollupAffs = getAffs(true); // get all affs for rollup cache on init
		q.rollups = findRxRollups(rollupAffs);
		vm.RxDroplist = droplistAllWithTitle();
		
		// setup all three tab filters at once
		_tabFlt = initTabFilters();

		return q;
	}

	function initTabFilters() {
		return {
			REVIEW: vm.initFilters({
				Config: {
					Dates: ['DateCreated', 'InvDt', 'PoDt', 'ReviewedDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['-DateCreated']
			}),
			ACCEPT: vm.initFilters({
				Config: {
					Dates: ['DateCreated', 'InvDt', 'PoDt', 'ReviewedDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['-DateCreated']
			}),
			REJECT: vm.initFilters({
				Config: {
					Dates: ['DateCreated', 'InvDt', 'PoDt', 'ReviewedDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['-DateCreated']
			})
		};
	}

	function initViewState(q, defaultTab) {

		_returnVisit = false;

		// get viewstate
		var rxid = '';
		var vs = sessionRepo.get('vs-invoice-review');
		if (!!vs) {
			_returnVisit = true;
			_tabFlt = vs.tabFlt;
			defaultTab = vs.activeTab;

			var dtToday = utilSvc.dt.zeroTime(new Date()),
				dtMin = utilSvc.dt.zeroTime(utilSvc.dt.addDays(new Date(), (-3650))); // 10 years days back from today

			// query
			q.CE.val = vs.query.CE;
			rxid = vs.query.RX;
			q.TPA.val = vs.query.TPA;
			q.SearchType = vs.query.SearchType;
			q.DateType = vs.query.DateType;
			q.DateRangeValid = vs.query.DateRangeValid;
			q.DateRangeMode = vs.query.DateRangeMode;
			q.StartDate = validSvc.newPropDate(vs.query.StartDate.val, dtMin, dtToday);
			q.EndDate = validSvc.newPropDate(vs.query.EndDate.val, dtMin, dtToday);
			q.showInactiveAffs = vs.query.showInactiveAffs;
		}
		else {
			q.CE.val = $scope.User.CE;
			rxid = validSvc.isRX($scope.User.RX) ? $scope.User.RX : 'ALL';
		}

		// initialize droplist props after viewstate check
		vm.CeDroplist = utilSvc.aff.ceDroplist(getAffs(q.showInactiveAffs == 'yes'));

		switch(q.SearchType) {
			case 'CE':
				q.CE = utilSvc.ng.droplistAutoselect(vm.CeDroplist, q.CE.val);
				queryChangeCE();
				break;
			case 'TPA':
				q.TPA = utilSvc.ng.droplistAutoselect(vm.TpaDroplist, q.TPA.val);
				queryChangeTPA();
				break;
			default:
				throw new Error('invoiceReviewList.initViewState, unknown search type: ' + q.SearchType);
		}

		// RX Droplist
		if(rxid != 'ALL') {
			q.RX = utilSvc.ng.droplistAutoselect(vm.RxDroplist, rxid);
		}
		q.RX.fail = validSvc.isRX(q.RX.val, false, true) ? 'no' : 'yes';


		return defaultTab;
	}

	function getAffs(useInactiveAffs) {
		var stats = !!useInactiveAffs ? ['ONBOARDING', 'ACTIVE', 'INACTIVE'] : ['ACTIVE'];
		var affs = utilSvc.aff.findStatus($scope.User.AffList, stats);
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
		return utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));
	}

	function findRxRollups(affs) {
		// search affs for ROLLUP parents

		_rollupAffs = [];

		var parentId = '',
			rollups = [];
		affs.forEach(function(aff){
			parentId = aff.RxParent;
			if(validSvc.isText(parentId)) {
				if(rollups.indexOf(parentId) < 0) {
					rollups.push(parentId);
				}
				_rollupAffs.push({
					CEID: aff.CEID,
					RXID: aff.RxParent,
					ProgAdmin: aff.ProgAdmin,
					AffState: aff.AffState,
					RxShortName: '' // filled in later after rx lookup
				});
			}
		});

		return rollups;
	}


	/**
	 *    DISPLAY VIEW MODEL
	 */

	function displayVM(dataItems, tooMany) {

		dataItems = Array.isArray(dataItems) ? dataItems : [];

		var notReview = vm.activeTab != 'REVIEW',
			noteTxt = '',
			item = {};

		for (var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];

			if (notReview) {
				noteTxt = '';
				item.OffsetTxt = !!item.Offset ? 'YES' : 'NO';

				// review by + note
				if (validSvc.isText(item.ReviewedNote)) {
					noteTxt = item.Reviewer + '|' + item.ReviewedNote;
				}

				// offset by + note
				if (validSvc.isText(item.OffsetNote)) {
					noteTxt += '|' + item.Offsetter + '|' + item.OffsetNote;
				}

				item.NoteTxt = noteTxt;

			}
		}

		return {
			Items: [],
			DataItems: dataItems,
			TooMany: !!tooMany
		};

	}


	/**
	 *    TAB CHANGE
	 */

	function tabChange(newTab) {
		if (vm.isWaiting) {
			return;
		}
		queryChange(true);

		// save current tab filter
		if(validSvc.isText(vm.activeTab) && newTab != vm.activeTab) {
			_tabFlt[vm.activeTab] = vm.resetFilters(vm.flt, true);
		}
		
		// load next tab filter
		vm.flt = vm.resetFilters(_tabFlt[newTab], true);
		vm.activeTab = newTab;
		
		getReviewList(true);
	}


	/**
	 *    QUERY CHANGE
	 */

	function queryChange(isTabChange) {
		if (!vm.init) {
			vm.action = '';
			vm.tbl = displayVM();
			if(!!!isTabChange) {
				// on a query change all tab filters are now bad, not just the active tab, reset them all
				_tabFlt = initTabFilters();
				vm.flt = vm.resetFilters(_tabFlt[vm.activeTab]);
			}

			$scope.$broadcast('widget.paging');
		}
	}

	function queryChangeSearchType() {
		queryChange();
		if(vm.query.SearchType == 'CE') {
			queryChangeCE();
		}
		else {
			vm.query.showInactiveAffs = 'no'; // reset to default
			queryChangeTPA();
		}
	}

	function queryChangeAffs() {
		if(vm.isWaiting) {
			return;
		}
		
		vm.query.showInactiveAffs = vm.query.showInactiveAffs == 'yes' ? 'no' : 'yes';

		// re-build CE droplist
		var affs = getAffs(vm.query.showInactiveAffs == 'yes');
		vm.CeDroplist = utilSvc.aff.ceDroplist(affs);
		vm.query.CE = utilSvc.ng.droplistAutoselect(vm.CeDroplist, vm.query.CE.val);

		queryChangeCE();
	}

	function queryChangeCE() {
		queryChange();
		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';

		rxDependent();
	}

	function queryChangeTPA() {
		queryChange();
		vm.query.TPA.fail = vm.query.TPA.val == 'NONE' ? 'yes' : 'no';

		rxDependent();
	}

	function queryDateTypeChange() {
		queryChange();
	}

	function dateRangeChange(dtMode, isValid) {
		vm.query.DateRangeMode = dtMode;
		vm.query.DateRangeValid = isValid;
		
		if(_returnVisit) {
			_returnVisit = false;
			tabChange(vm.activeTab);
		}
		else {
			queryChange();
		}
		vm.init = false;
	}


	/**
	 * 		RxDroplist
	 */

	function getRollupAffs(useInactiveAffs) {
		var stats = !!useInactiveAffs ? ['ONBOARDING', 'ACTIVE', 'INACTIVE'] : ['ACTIVE'];
		return utilSvc.aff.findStatus(_rollupAffs, stats);
	}

	function rxDependent() {
		// note used by both CE / TPA search types
		var q = vm.query;

		// reset RX
		vm.RxDroplist = droplistAllWithTitle();
		q.RX = validSvc.newProp('ALL');

		// get RX options (affs + rollups)
		var affs = getAffs(vm.query.showInactiveAffs == 'yes'),
			rollupAffs = getRollupAffs(vm.query.showInactiveAffs == 'yes');

		switch(q.SearchType) {
			case 'CE':
				if(q.CE.fail == 'yes') {
					return;
				}		
				affs = utilSvc.aff.findCe(affs, q.CE.val);
				rollupAffs = utilSvc.aff.findCe(rollupAffs, q.CE.val);
				break;
			case 'TPA':
				if(q.TPA.fail == 'yes') {
					return;
				}
				affs = utilSvc.aff.findProgAdmin(affs, q.TPA.val);
				rollupAffs = utilSvc.aff.findProgAdmin(rollupAffs, q.TPA.val);
				break;
			default:
				throw new Error('invoice.review.list, unknown query.SearchType: ' + query.SearchType);
		}

		// combine and sort affs, auto-select RX
		var mixAffs = utilSvc.array.sortASC(affs.concat(rollupAffs), 'RxShortName');
		if(mixAffs.length == 1) {
			q.RX.val = mixAffs[0].RXID;
		}

		// populate droplist (doing this manually)
		var uniqueRXIDS = [],
			rxDroplist = [];
		mixAffs.forEach(function(aff){
			if(uniqueRXIDS.indexOf(aff.RXID) < 0) {
				uniqueRXIDS.push(aff.RXID);
				rxDroplist.push({label:aff.RxShortName, value:aff.RXID});
			}
		});
		if(rxDroplist.length > 1) {
			rxDroplist = utilSvc.array.sortASC(rxDroplist, 'label');
			vm.RxDroplist = vm.RxDroplist.concat(rxDroplist);
		}
		else {
			vm.RxDroplist = rxDroplist;
		}

		queryChangeRX();
	}

	function queryChangeRX() {
		queryChange();
		
		// valid RX
		vm.query.RX.fail = validSvc.isRX(vm.query.RX.val, false, true) ? 'no' : 'yes';
	}


	/**
	 *    GLOBAL GREASE FILTER
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if (!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if (vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function () {

			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if (vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			$timeout(function () {
				if (!vm.flt.Busy && !vm.flt.Dirty) {
					saveViewState(vm.activeTab, vm.query, _tabFlt);
				}
			}, 1000);

		}, delayTime);

	}


	/**
	 *    GET REVIEW LIST
	 */

	function queryValid(q) {
		var rxOk = validSvc.isRX(q.RX.val, false, true);
		q.RX.fail = rxOk ? 'no' : 'yes';
		q.RX.vals = rxOk ? getRxVals(q) : [];

		switch(q.SearchType) {
			case 'CE':
				q.CE.fail = validSvc.isCE(q.CE.val) ? 'no' : 'yes';
				return q.CE.fail != 'yes' && rxOk && q.DateRangeValid;
			case 'TPA':
				q.TPA.fail = q.TPA.val == 'NONE' ? 'yes' : 'no';
				return q.TPA.fail != 'yes' && rxOk && q.DateRangeValid;
			default:
				throw new Error('invoiceReviewList.queryValid, unknown search type: ' + q.SearchType);
		}
	}

	function getRxVals(q) {
		// un-wind the RX choice into 1 or more pharmacies if its a rollup
		var rxid = q.RX.val;

		// invalid RX or unconstrained
		if(!validSvc.isRX(rxid) || rxid == 'ALL') {
			return [];
		}
		
		// is this a ROLLUP?
		var idxRollup = _rollupAffs.findIndex(function(aff){
			return aff.RXID == rxid;
		});
		if(idxRollup < 0) {
			// not found in rollups
			return [rxid];
		}

		// found rollup, constrain by CE or TPA
		var affs = getAffs(q.showInactiveAffs == 'yes');
		affs = utilSvc.aff.findRxParent(affs, rxid);
		switch(q.SearchType) {
			case 'CE':
				affs = utilSvc.aff.findCe(affs, q.CE.val);
				break;
			case 'TPA':
				affs = utilSvc.aff.findProgAdmin(affs, q.TPA.val);
				break;
			default:
				throw new Error('invoiceReviewList.getRxVals, unknown search type: ' + q.SearchType);
		}

		return utilSvc.aff.rxList(affs);
	}

	function getReviewList(isTabChange) {
		if (!queryValid(vm.query)) {
			if (!vm.init) {
				msgSvc.ok('Search', 'Check settings.');
			}
			return;
		}

		queryChange(isTabChange);

		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true);
		vm.action = 'LOAD';

		invoiceRepo.getReviewList(vm.activeTab, vm.query).then(okGetReviewList, errGetReviewList);

		function okGetReviewList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// setup filter, save viewstate
			vm.flt = vm.resetFilters(_tabFlt[vm.activeTab]);
			saveViewState(vm.activeTab, vm.query, _tabFlt);

			vm.tbl = displayVM(r.data, r.tooMany);
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			vm.flt.Ready = true;
			vm.action = 'LIST';
		}

		function errGetReviewList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if (!!r) {
				errSvc.error('Unknown get response', 'invoiceReviewList.errGetList', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    GET DETAIL
	 */

	function getDetail(id) {

		if (vm.isWaiting) {
			return;
		}

		if (!validSvc.isText(id)) {
			throw new Error('invoiceReviewList.getDetail, missing Id');
		}

		$state.go('invoice.review-detail', { Id: id, tab: vm.activeTab }, { reload: 'invoice.review-detail' });

	}


	/**
	 *    HELP LINK
	 */

	function helpLinkClick() {

		if (vm.isWaiting) {
			return;
		}

		var path = '',
			title = '';

		switch (vm.activeTab) {

			case 'REVIEW':
				path = 'order-invoicereview-review';
				title = 'Invoice Review Tab';
				break;

			case 'ACCEPT':
				path = 'order-invoicereview-accepted';
				title = 'Invoice Review Accepted Tab';
				break;

			case 'REJECT':
				path = 'order-invoicereview-rejected';
				title = 'Invoice Review Rejected Tab';
				break;

			default:
				return;
		}

		vm.helpLink(path, title);
	}


	/**
	 *    EXCEL
	 */

	function createExcel() {

		if (vm.isWaiting) {
			return;
		}

		// blob support?
		if (!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		var name_id = vm.query.SearchType == 'CE' ? vm.query.CE.val : utilSvc.ng.droplistLabel(vm.TpaDroplist, vm.query.TPA.val);

		_pendingExcelFilename = 'Verity-' + name_id + '-Invoice-Review.xlsx';
		invoiceRepo.getExcel('REVIEW', vm.query, _pendingExcelFilename).then(okServerExcel, errServerExcel);

		function okServerExcel(binaryData) {
			vm.isWaiting = false;

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch (err) {
				throw (err);
			}

			msgSvc.wait(false);

		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if (!!r) {
				errSvc.warn(_pendingExcelFilename + ' Excel Error', 'invoiceReviewCtl.excel', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    HELPERS
	 */

	function saveViewState(tab, query, tabFlt) {

		// update in use filters
		tabFlt[tab] = vm.flt;

		sessionRepo.set('vs-invoice-review', {
			activeTab: tab,
			query: {
				SearchType: query.SearchType,
				CE: query.CE.val,
				RX: query.RX.val,
				TPA: query.TPA.val,
				DateType: query.DateType,
				DateRangeValid: query.DateRangeValid,
				DateRangeMode: query.DateRangeMode,
				StartDate: query.StartDate,
				EndDate: query.EndDate,
				showInactiveAffs: query.showInactiveAffs,
			},
			tabFlt: tabFlt  // save all three tab filters
		});

	}

	function droplistAllWithTitle() {
		return [{ label: 'All Pharmacies', value: 'ALL' }];
	}

}
 
asyncReportsCtl.$inject = ['$window', '$state', '$scope', '$timeout', '$filter', 'reportRepo', 'validSvc', 'utilSvc', 'errSvc', 'msgSvc'];
angular
.module('espui.report')
.controller('AsyncReportsCtl', asyncReportsCtl);

/* @ngInject */
function asyncReportsCtl($window, $state, $scope, $timeout, $filter, reportRepo, validSvc, utilSvc, errSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this,
		_pendingFile = '',
		_pagingEventListener = null,
		_reportType = '';

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addTableViews(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.errOutput = {};

	// query
	vm.query = {};
	vm.StatusDroplist = [];

	// methods
	vm.getFileList = getFileList;
	vm.getFile = getFile;

	// table and filters
	vm.tbl = {};
	vm.flt = {};
	vm.filterChange = filterChange;

	// table view
	vm.tblViewConfig = {};
	vm.tblView = {};
	

	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		vm.init = true;

		// report type and params
		var params = $state.params;
		if(!!!params || !validSvc.isText(params.rptType)) {
			throw new Error('asyncReportsCtl.init, missing param rptType');
		}
		_reportType = params.rptType;
		
		if(!initQueryAndFilters(_reportType, params)) {
			vm.errOutput = {
				type: 'LOAD',
				title: 'Cannot Load Report Type: ' + _reportType,
				errors: paramsToErrors(params)
			};
			vm.action = 'ERROR';
			vm.init = false;
			return;
		}
		
		// load ok, setup table schema, get files
		vm.tblViewConfig = tblViewConfigSetup(tblViewSchemaVM(_reportType));
		getFileList();
	}

	function initQueryAndFilters(rptType, params) {

		var flt = vm.initFilters({
			Text: {
				StatusTxt: ''
			},
			Config: {
				Dates: ['StartDate', 'EndDate', 'CreateDate','ExpireDate'],
				DateFmt: 'M/d/yyyy'
			},
			SortBy: ['-CreateDate']
		});

		var q = {
			type: rptType,
			params: params
		};

		switch(rptType) {
			case 'CPFR':
			case 'UDS':
			case 'ESP340B':
            case 'TRUZO':
			case 'CLAIMREBATE':
			case 'CMS340B':
			case 'SPLIT_SAVINGS':
			case 'SPLITMATCH_SAVINGS':
			case 'SPLITFIN':
			case 'SPLITFIN_TRANS':
			case 'CATALOG_AFFILIATES':
			case 'ACCUM_DETAILS':
			case 'ACCUM_SLV_DETAILS':
			case 'CLAIM_DETAILS':
			case 'RE_EVAL':
				// query by user, no other filtering needed
				break;
			default:
				throw new Error('asyncReportsCtl.initQueryFilters, unknown report type: ' + rptType);
		}

		vm.query = q;
		vm.flt = flt;

		vm.StatusDroplist = [
			{label:'ALL', value:''},
			{label:'INPROGRESS', value:'INPROGRESS'},
			{label:'READY', value:'READY'}
		];

		return true;
	}


	/**
	 *    VIEW MODELS
	 */

	function fileListVM(repoData) {
		// build the display view model (from empty or from repo data)

		var items = Array.isArray(repoData) ? repoData : [],
			item = {},
			isClaimSub = vm.query.type == 'ESP340B',
            isTruzo = vm.query.type == 'TRUZO',
			isREB = vm.query.type == 'CLAIMREBATE';

		for(var i = 0; i < items.length; i++) {
			item = items[i];
			item.ProgAdmin = changeProgAdmin(item.ProgAdmin);
			item.ReportType = reportTypeFriendlyName(item.ReportType);

			// CEID, RXID are "Multiple" display properties
			item = multipleItemsProperty(item, 'CEID');
			item = multipleItemsProperty(item, 'RXID');
			item = multipleItemsProperty(item, 'VENID');

			// convert AccGrps to display string
			if(Array.isArray(item.AccGrps) && item.AccGrps.length > 0) {
				item.AccGrps = item.AccGrps.length > 1 ? item.AccGrps.join(',') : item.AccGrps[0];
			}
			else {
				item.AccGrps = 'ALL';
			}

			// add search details column
			if(isClaimSub || isTruzo) {
				item.Details = claimSubDetails(item);
			}
			else if(isREB) {
				item.Details = rebateDetails(item);
			}

			item.ExpireDate = validSvc.isDate(item.ExpireDate) ? item.ExpireDate : null;
		}

		return {
			DataItems: items,
			Items: []
		};

	}

	function multipleItemsProperty(item, propName) {
		// consolidate multiple array items into one searchable text field with "Multiple" display indicator
		var propVals = Array.isArray(item[propName]) ? item[propName] : [];

		item[propName] = propVals.join(', ');
		item[propName+'Multi'] = propVals.length > 3 ? 'yes' : 'no';

		return item;
	}
	function changeProgAdmin(progAdmin){
		var changedName = progAdmin;

		if (progAdmin == 'PSG'){
			changedName = 'OMNICELL';
		} else if (progAdmin == 'MORRISDICKSON'){
			changedName = 'CERVEY';
		}else if (progAdmin == '340BASICS'){
			changedName = 'NUVEM';
		}else if (progAdmin == 'SENTRY'){
			changedName = 'CRANEWARE';
		}
		return changedName;
	}
	function claimSubDetails(item) {
		// stringify claims submission search details
		var result = '';

		// dt type
		result += item.DateType == 'FILL' ? 'Fill Dates' : 'Matched Dates';

		// mfg
		if(Array.isArray(item.Manufacturer)) {
			result += ', Mfg: ' + item.Manufacturer.join(', ');
		}

		// replenished
		if(item.ReplenishedOnly == 'YES') {
			result += ', Replenished Only';
		}

		// match can have fill date cutoff
		if(!!item.UseFillDateCutoff) {
			result += ', Exclude Matched Dispenses ' + item.FillDateCutoff + ' days previous';
		}

		// options
		if(item.IncludePharmacy == 'YES') {
			result += '\n, Include Pharmacy';
		}
		if(item.IncludeMedical == 'YES') {
			result += '\n, Include Medical';
		}

		return result;
	}

	function rebateDetails(item) {
		// stringify rebate submission search details
		var result = '';

		// dt type
		switch(item.DateType) {
			case 'FILL':
				result += 'Fill Date';
				break;
			case 'MATCH':
				result += 'Matched Date';
				break;
			case 'PAYMENT':
				result += 'Payment Date';
				break;
			case 'SUBMITTED':
				result += 'Submitted Date';
				break;
			default:
				throw new Error('asyncReportsCtl.rebateDetails, unknown DateType: ' + item.DateType);
		}

		// options
		if(item.IncludePharmacy == 'YES') {
			result += '\n, Include Pharmacy';
		}
		if(item.IncludeMedical == 'YES') {
			result += '\n, Include Medical';
		}
		if(item.IncludePayments == 'YES') {
			result += '\n, Include Payments';
		}

		return result;
	}


	/**
	 * 	QUERY CHANGE
	 */

	function queryChange() {
		if(!vm.init) {
			vm.action = '';
			vm.errOutput = {};

			// table
			vm.tbl = {};
			$scope.$broadcast('widget.paging');
		}
	}


	/**
	 *    FILTER CHANGE
	 */

	function filterChange(immediate) {
		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			// filter values stored inside table view columns
			vm.flt = vm.tblViewGetColumnFilterValues(vm.tblView.cols, vm.flt);

			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: 'ASYNC_REPORTS',
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});
		}, delayTime);
	}


	/**
	 *    GET FILES
	 */

	function getFileList() {
		if(vm.isWaiting) {
			return;
		}
		queryChange();
		vm.init = false;

		// note: no query validation, REPO will validate query.params and return a 422 if needed
		wait(true);
		reportRepo.getAsyncFiles(vm.query).then(okGetList, errGetList);

		function okGetList(r) {
			wait(false);

			vm.tbl = fileListVM(r);
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: 'ASYNC_REPORTS',
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			tblViewReload(false, true); // keep filter paging on tab change

			vm.flt.Ready = true;
			vm.action = 'LIST';
		}

		function errGetList(r) {
			wait(false);

			if(!!r) {
				if(r.status == 422) {
					vm.errOutput = {
						type: '422',
						title: 'Query Invalid for Report Type: ' + _reportType,
						errors: r.errors
					};
					vm.action = 'ERROR';
				}
				else {
					errSvc.warn('unknown API error', 'asyncReportsCtl.getFileList', r.status, utilSvc.http.safeResponse(r));
				}
			}
		}
	}


	/**
	 *    GET FILE
	 */

	function getFile(item) {
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('File download requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		if(item.Status != 'READY') {
			msgSvc.ok('Cannot Download', 'File must be status READY to download, for INPROGRESS files please click REFRESH to check for updates.');
			return;
		}

		wait(true);

		_pendingFile = item;
		reportRepo.getAsyncFile(item.Id).then(okGetFile, errGetFile);

		function okGetFile(binaryData) {
			wait(false);

			// get binary file type
			var fileType = '';
			switch(_pendingFile.FileFormat) {
				case 'EXCEL':
					fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
					break;
				case 'ZIP':
				case 'CSV':
					fileType = 'application/zip';
					break;
				case 'PDF':
					fileType = 'application/pdf';
					break;
				default:
					throw new Error('asyncReportsCtl.getFile, unknown file format: ' + _pendingFile.FileFormat);
			}

			// convert binary stream to blob and save
			try {
				var fileBlob = new Blob([binaryData],{type:fileType});
				$window.saveAs(fileBlob, utilSvc.regex.cleanFilename(_pendingFile.Name));
			}
			catch(err) {
				throw(err);
			}
			_pendingFile = null;
		}

		function errGetFile(r) {
			wait(false);
			_pendingFile = null;

			if(!!r) {
				errSvc.warn('Get File Error', 'asyncReportsCtl.getAsyncFile', r.status, utilSvc.http.safeResponse(r));
			}	
		}
	}


	/**
	 * 	TABLE VIEW
	 */

	function tblViewSchemaVM(rptType) {
		// using a schema to change table dynamically, NOT for user custom tables, user CANNOT modify table

		var rptSchema = {
			title: '',
			storageKey: 'tv-async-reports-' + rptType.toLowerCase(),
			name: rptType,
			sortby: '-CreateDate',
			pgsize: 50,
			sections: {
				Us: {title:'Usage'},
				Ent: {title:'Entity'},
				Sp: {title: 'Search Parameters'},
				Fi: {title: 'File Info'}
			},
			cols: [
				{section:'Us', 		flt:'Text',		name:'Status', title:'Status', desc:''},
				{section:'Ent', 	flt:'Text',		name:'CEID', title:'Facility', desc:''},
				{section:'Ent', 	flt:'Text',		name:'RXID', title:'Pharmacy', desc:''},
				{section:'Sp', 		flt:'Dates',	name:'StartDate', title:'Start Date', desc:''},
				{section:'Sp', 		flt:'Dates',	name:'EndDate', title:'End Date', desc:''},
				{section:'Fi', 		flt:'Text',		name:'Name', title:'Name', desc:''},
				{section:'Fi', 		flt:'Dates',	name:'CreateDate', title:'Created', desc:''},
				{section:'Fi', 		flt:'Dates',	name:'ExpireDate', title:'Expires', desc:''}
			]
		};

		switch(rptType) {
			case 'CPFR':
				rptSchema.title = 'CP Financial';
				rptSchema.cols.splice(5,0, {section:'Sp',  	flt:'Text',		name:'AccGrps', title:'Account', desc:''});
				break;
			case 'UDS':
				rptSchema.title = 'UDS Reporting';
				break;
			case 'ESP340B':
				rptSchema.title = '340B ESP Claims Submission';
				rptSchema.cols.splice(5,0, {section:'Sp',  	flt:'Text',		name:'Details', title:'Details', desc:''});
				break;
			case 'TRUZO':
				rptSchema.title = 'Truzo Claims Submission';
				rptSchema.cols.splice(5,0, {section:'Sp',  	flt:'Text',		name:'Details', title:'Details', desc:''});
				break;
			case 'CLAIMREBATE':
				rptSchema.title = 'Beacon Claims Submission';
				rptSchema.cols.splice(5,0, {section:'Sp',  	flt:'Text',		name:'Details', title:'Details', desc:''});
				break;
			case 'CMS340B':
				rptSchema.title = 'CMS 340B Claims Repository';
				break;
			case 'SPLIT_SAVINGS':
				rptSchema.title = '340B Savings - Mixed Use';
				rptSchema.cols.splice(1,0, {section:'Us',  	flt:'Text',		name:'ReportType', title:'Type', desc:''});
				break;	
			case 'SPLITMATCH_SAVINGS':
				rptSchema.title = '340B Savings - Retail';
				rptSchema.cols.splice(1,0, {section:'Us',  	flt:'Text',		name:'ReportType', title:'Type', desc:''});
				break;
			case 'SPLITFIN':
				rptSchema.title = 'Split Savings';
				break;

			case 'CATALOG_AFFILIATES':
				rptSchema.title = 'Catalog - Affiliate';
				rptSchema.cols.splice(5,0, 
					{section:'Sp',  	flt:'Text',		name:'VENID', title:'Vendor', desc:''},
					{section:'Sp',  	flt:'Text',		name:'ExcludeStale', title:'Exclude Stale', desc:''},
					{section:'Sp',  	flt:'Text',		name:'ExcludeUnknown', title:'Exclude Unknown', desc:''}
				);
				// No start date end date
				rptSchema.cols.splice(3, 2);
				break;
			case 'ACCUM_DETAILS':
				rptSchema.title = 'Accumulator Details';
				break;
			case 'RE_EVAL':
				rptSchema.title = 'Re-Evaluation Results';
				break;
			case 'ACCUM_SLV_DETAILS':
				rptSchema.title = 'Accumulator SLV Detailed Summary';
				rptSchema.cols.splice(5,0, 
					{section:'Sp',  	flt:'Text',		name:'ProgAdmin', title:'Program Admin', desc:''},
					{section:'Sp',  	flt:'Text',		name:'GROUP', title:'Share Group', desc:''}
				);
				// No start date end date
				rptSchema.cols.splice(3, 2);
				rptSchema.cols.splice(1,0, {section:'Us',  	flt:'Text',		name:'ReportType', title:'Type', desc:''});
				break;
			case 'CLAIM_DETAILS':
				rptSchema.title = 'Claim Details';
				rptSchema.cols.splice(5,0, 
					{section:'Sp',  	flt:'Text',		name:'AccumType', title:'Accum Type', desc:''},
					{section:'Sp',  	flt:'Text',		name:'ReturnMatched', title:'Include Matched', desc:''},
					{section:'Sp',  	flt:'Text',		name:'RxNumber', title:'Rx#', desc:''},
					{section:'Sp',  	flt:'Text',		name:'ItemCode', title:'NDC', desc:''},
					{section:'Sp',  	flt:'Text',		name:'NPI', title:'NPI', desc:''}
				);
				break;
			default:
				throw new Error('asyncReportsCtl.tblViewSchemaVM, unknown report type: ' + rptType);
		}

		return rptSchema;
	}

	function reportTypeFriendlyName(rptType) {
		switch(rptType) {
			case 'CPFR':
				return 'CP FINANCIAL';
			case 'UDS':
				return 'UDS';
			case 'ESP340B':
				return '340B CLAIMS SUBMISSION';
            case 'TRUZO':
				return 'TRUZO CLAIMS SUBMISSION';
			case 'CLAIMREBATE':
				return 'BEACON CLAIMS SUBMISSION';
			case 'SPLIT_SAVINGS':
				return 'MIXED USE';
			case 'SPLITMATCH_SAVINGS':
				return 'RETAIL';
			case 'CMS340B':
				return 'CMS 340B CLAIMS REPOSITORY';
			default:
				return '';
		}
	}

	function tblViewConfigSetup(tblSchema) {
		// config setup converts all column schema into config columns / keys

		var cols = tblSchema.cols,
			col = {},
			colKeys = {},
			colAllowed = [];

		for(var i = 0; i < cols.length; i++) {
			col = cols[i];

			// tbd... logic to remove conditional columns based on user type, query result, etc

			// keep column
			colAllowed.push(col.name);
			colKeys[col.name] = col;
		}

		// update columns for this table
		tblSchema.cols = colAllowed;
		tblSchema.colKeys = colKeys;

		return tblSchema;
	}

	function tblViewReload(skipInitViews, fltKeepPaging) {
		// init and load table view structure
		if(!!!skipInitViews || !!!vm.tblView) {
			vm.tblView = vm.tblViewInit(vm.tblViewConfig, null); // not using user table views from session
		}

		// add column titles and filters
		vm.tblView = vm.tblViewLoadTitlesAndFilters(vm.tblViewConfig, vm.tblView, vm.flt);
		
		if(!!vm.flt) {
			// remove any filter properties not shown in current table view
			vm.flt = vm.tblViewSyncFilter(vm.tblViewConfig, vm.tblView, vm.flt, fltKeepPaging);
			filterChange(true);
		}
	}


	/**
	 * 	HELPERS
	 */

	function wait(isOn) {
		vm.isWaiting = !!isOn;
		msgSvc.wait(!!isOn);
	}

	function paramsToErrors(params) {
		// convert route params to an array of error entries
		var result = [];

		if(!!!params) {
			return result;
		}

		for (var propName in params) {
			if (params.hasOwnProperty(propName)) {
				result.push({Name:propName, Rule: JSON.stringify(params[propName])});
			}
		}
	}
}
 
reportAuditCtl.$inject = ['$state', '$scope', '$timeout', '$window', 'visitsRepo', 'reportRepo', 'utilSvc', 'validSvc', 'msgSvc', 'errSvc'];
angular
.module('espui.report')
.controller('ReportAuditCtl', reportAuditCtl);

/* @ngInject */
function reportAuditCtl($state, $scope, $timeout, $window, visitsRepo, reportRepo, utilSvc, validSvc, msgSvc, errSvc) {

	var vm = this;
	var _datePickListener = null,
		_pendingExcelFilename = '';

	// inherit sorting and paging features
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	msgSvc.addHelpLink(vm);

	// props
	vm.init = true;
	vm.action = '';
	vm.CeDroplist = [];
	vm.StatusDroplist = [];

	vm.flt = {
		Text: {
			StatusTxt: ''
		},
		Dates: {}
	};

	// models
	vm.query = {};
	vm.display = {};

	// methods
	vm.queryChangeCE = queryChangeCE;
	vm.getFileList = getFileList;
	vm.openFileRequest = openFileRequest;
	vm.createNewReport = createNewReport;
	vm.cancelNewReport = cancelNewReport;
	vm.confirmPHIAttestation = confirmPHIAttestation;
	vm.getExcel = getExcel;

	// date pick
	vm.dtPickShow = {};
	vm.dtPickOpen = dtPickOpen;

	// rx scroll lists
	vm.RxSplitFlt = '';
	vm.RxSplitList = [];
	vm.RxCpFlt = '';
	vm.RxCpList = [];
	vm.rxListClick = rxListClick;

	// phi
	vm.canIncludePHI = false;


	/**
	 *    INIT
	 */

	init();

	function init() {

		vm.init = true;
		vm.action = '';
		vm.uType = $scope.User.Type;
		
		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		// droplists
		vm.CeDroplist = utilSvc.aff.ceDroplist($scope.User.AffList);
		vm.StatusDroplist = utilSvc.ng.droplist(['INPROGRESS', 'READY'],'','',[{label:'ALL', value:''}]);

		// date picker
		vm.dtPickShow = {
			pending: '',
			EndDate: false,
			StartDate: false
		};

		vm.query = {
			CE: utilSvc.ng.droplistAutoselect(vm.CeDroplist, $scope.User.CE)
		};
		if (!!vm.query.CE.val) {
			queryChangeCE();
		}
		vm.query = initAuditRequest(vm.query);

		getFileList();

		vm.init = false;

	}

	function initAuditRequest(query) {
		query.Sample = 'no';
		query.SampleSize = validSvc.newProp(30);

		vm.RxSplitFlt = '';
		vm.RxSplitList = [];
		vm.RxCpFlt = '';
		vm.RxCpList = [];
		query.RxList = [];

		query.SplitBill = 'no';
		query.SplitBillAddGPO = 'no';
		query.SplitBillAddAlwaysNeverNDC = 'no';
		query.Contract = 'no';
		query.ContractAddNeverOrderNDC = 'no';
		query.FromPSA = 'no';
		query.ContractIncludeGenerics = 'yes';
		query.ContractIncludeCII = 'yes';
		query.Notes = 'no';
		query.IncludePHI = 'no';
		query.confirmIncludePHI = 'no';
		query.Non340bDrugs = 'no';

		return query;
	}


	/**
	 *    VIEW MODEL
	 */

	function displayVM(repoData) {

		// build the display view model (from empty or from repo data)

		var items = Array.isArray(repoData) ? repoData : [];

		var statTxt = '';
		for(var i = 0; i < items.length; i++) {
			items[i].ExpireDate = validSvc.isDate(items[i].ExpireDate) ? items[i].ExpireDate : null;

			// add completion to INPROGRESS status
			statTxt = items[i].Status;
			if(statTxt == 'INPROGRESS') {
				if(validSvc.isInteger(items[i].PercentComplete)) {
					statTxt += ' (' + parseInt(items[i].PercentComplete) + '%)';
				}
			}
			items[i].StatusTxt = statTxt;
		}

		var pageSize = items.length > 0 ? items.length : 1;

		return {
			Items: items,
			SortBy: ['CreateDate'],
			Paging: {
				Page: 1,
				Size: pageSize,
				Total: vm.getTotalPages(items.length, pageSize)
			}
		};

	}


	/**
	 *    CHANGE EVENT5
	 */

	function queryChangeCE() {
		vm.action = '';
		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';
		if (!!vm.query.CE.val && vm.query.CE.fail != 'yes' && vm.uType == 'CE') {
			vm.isWaiting = true;
			msgSvc.wait(true);	
			visitsRepo.CeBenefitsAndLocations(vm.query.CE.val).then(okGetCE, errGetCE);
		}
		vm.query = initAuditRequest(vm.query);
	}


	// Get CE detail
	function okGetCE(r) {
		msgSvc.wait(false);
		vm.isWaiting = false;
		vm.canIncludePHI = !!r.ExistsPubKeyPHI && !!r.EnableAuditPHI && vm.uType == 'CE';
		vm.canPHICheckboxEdit = true;
	}

	function errGetCE(r) {
		msgSvc.wait(false);
		vm.isWaiting = false;

		if(r !== null) {
			errSvc.warn('Not able to get CE ' + ceid);
			$state.go(_viewErrRoute, {}, {reload: _viewErrRoute});
		}
	}


	/**
	 *    GET FILE LIST
	 */

	function getFileList() {

		if(vm.isWaiting) {
			return;
		}

		vm.action = '';
		vm.query = initAuditRequest(vm.query);

		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';
		if(vm.query.CE.fail == 'yes') {
			if(!vm.init) {
				msgSvc.ok('Search', 'Choose a Facility');
			}
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		// send list
		reportRepo.auditGetFileList(vm.query.CE.val).then(okGetList, errGetList);

		function okGetList(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			vm.display = displayVM(r);
			vm.action = 'LIST';
		}

		function errGetList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('unknown API error', 'reportAuditCtl.getFileList', r.status, utilSvc.http.safeResponse(r));
				init();
			}
		}

	}


	/**
	 *    AUDIT FILE REQUEST
	 */

	function openFileRequest() {

		if(vm.isWaiting) {
			return;
		}

		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';
		if(vm.query.CE.fail == 'yes') {
			msgSvc.ok('Create File', 'Choose a Facility');
			return;
		}
		vm.query = initAuditRequest(vm.query);

		// setup dates
		var dtToday = utilSvc.dt.zeroTime(new Date()),
			dtMin = utilSvc.dt.zeroTime(new Date(1992, 10, 1)); // min is Nov 1992
		vm.query.EndDate = validSvc.newPropDate(dtToday, dtMin, dtToday);
		vm.query.StartDate = validSvc.newPropDate(dtToday, dtMin, dtToday);

		// setup rx lists
		var affs = utilSvc.aff.findStatus($scope.User.AffList);
		var splitAffs = utilSvc.aff.findRxModel(affs, ['SPLIT']),
			cpAffs = utilSvc.aff.findRxModel(affs, ['CP','CPTPA','SPLITMATCH']);

		vm.RxSplitFlt = '';
		vm.RxSplitList = utilSvc.aff.rxDroplist(splitAffs, vm.query.CE.val, false);
		if(vm.RxSplitList.length > 5) {
			vm.RxSplitList.unshift({label:'ALL', value: 'ALL'});
		}

		vm.RxCpFlt = '';
		vm.RxCpList = utilSvc.aff.rxDroplist(cpAffs, vm.query.CE.val, false);
		if(vm.RxCpList.length > 5) {
			vm.RxCpList.unshift({label:'ALL', value: 'ALL'});
		}

		// phi
		vm.hasPHIAttested = utilSvc.user.hasFeature($scope, 'audit.phi');
		vm.action = 'CREATE';
	}

	function cancelNewReport() {

		if(vm.isWaiting) {
			return;
		}

		vm.query = initAuditRequest(vm.query);
		getFileList();

	}

	function rxListClick(listName, item) {

		// check all 1 or all list items on or off

		if(vm.isWaiting) {
			return;
		}

		var targetList = vm[listName];
		if(!Array.isArray(targetList)) {
			msgSvc.ok('Error', 'auditCtl.rxListClick, unknown list name');
			return;
		}

		// find item in list
		var idx = -1,
			i = 0;
		for(i = 0; i < targetList.length; i++) {
			if(targetList[i].value == item.value) {
				idx = i;
				break;
			}
		}
		if(idx < 0) {
			msgSvc.ok('Error', 'auditCtl.rxListClick, list item not found');
			return;
		}

		var chkToggle = !!!targetList[idx].checked;

		if(idx === 0 && targetList[0].label == 'ALL') {
			// all list items
			for(i = 0; i < targetList.length; i++) {
				targetList[i].checked = chkToggle;
			}
		}
		else {
			// 1 list item
			targetList[idx].checked = chkToggle;
			if(chkToggle === false && targetList[0].label == 'ALL') {
				targetList[0].checked = false;
			}
		}

	}

	function confirmPHIAttestation() {
		if(vm.isWaiting) {
			return;
		}

		msgSvc.confirm({
			id: 'report.audit.phi.confirm',
			title: 'SAVE AUDIT PHI ATTESTATION',
			msg: 'Click \'SAVE\' to record your attestation',
			buttons: [
				{text:'SAVE', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmAttestSave, confirmAttestSave);

		function confirmAttestSave(r) {
			// user said yes to proceed
			if(!!r && r.result == 'YES') {	
				vm.isWaiting = true;
				reportRepo.signPHIAttestation().then(okSign, errSign);
			}
		}

		function okSign(r) {
			vm.isWaiting = false;
			vm.canPHICheckboxEdit = false;
			vm.query.confirmIncludePHI = 'yes';
			msgSvc.ok('Attestation signed successfully');	
		}
	
		function errSign(r) {
			vm.isWaiting = false;
			errSvc.info('Could not sign attestation, please try again');
		}
	}

	function requestValid(m) {

		// end date, required
		var endDT = validSvc.propDateValid(m.EndDate);
		m.EndDate.fail = !!endDT.fail ? 'yes' : '';
		m.EndDate.msg = !!endDT.fail ? endDT.msg : '';

		// start date, required
		var startDT = validSvc.propDateValid(m.StartDate);
		m.StartDate.fail = !!startDT.fail ? 'yes' : '';
		m.StartDate.msg = !!startDT.fail ? startDT.msg : '';

		// start date must be <= end date
		if(!endDT.fail && !startDT.fail) {
			if(utilSvc.dt.diffMilli(m.EndDate.val, m.StartDate.val) > 0) {
				m.StartDate.fail = 'yes';
				m.StartDate.msg = 'must be on or before End Date';
			}
			else if(utilSvc.dt.diffDays(m.StartDate.val, m.EndDate.val) > 190) {
				m.EndDate.fail = 'yes';
				m.EndDate.msg = 'date range must be less than 190 days';
			}
		}

		// sample size, optional
		if(m.Sample == 'yes') {
			m.SampleSize = validIntegerProp(m.SampleSize, 10, 100);
		}
		else {
			m.SampleSize = validSvc.newProp(30);
		}

		// split bill, optional
		if(m.SplitBill == 'no') {
			m.SplitBillAddGPO = 'no';
			m.SplitBillAddAlwaysNeverNDC = 'no';
		}

		// contract, optional
		if(m.Contract == 'no') {
			m.ContractAddNeverOrderNDC = 'no';
		}

		return 	m.EndDate.fail != 'yes' && m.StartDate.fail != 'yes' && m.SampleSize.fail != 'yes';

	}

	function validRxLists(q) {

		// at least 1 rx must be checked if feature is selected

		var errMsg = '',
			rxlist = [],
			items = [],
			i = 0,
			hasSplit = false,
			hasCP = false;

		if(vm.query.SplitBill == 'yes') {
			items = vm.RxSplitList;
			i = items[0].label == 'ALL' ? 1 : 0;
			for(i; i < items.length; i++) {
				if(!!items[i].checked) {
					hasSplit = true;
					if(rxlist.indexOf(items[i].value) < 0) {
						rxlist.push(items[i].value);
					}
				}
			}
			if(!hasSplit) {
				errMsg = 'No Split Billing';
			}
		}

		if(vm.query.Contract == 'yes') {
			items = vm.RxCpList;
			i = items[0].label == 'ALL' ? 1 : 0;
			for(i; i < items.length; i++) {
				if(!!items[i].checked) {
					hasCP = true;
					if(rxlist.indexOf(items[i].value) < 0) {
						rxlist.push(items[i].value);
					}
				}
			}
			if(!hasCP) {
				errMsg += errMsg.length > 0 ? ' or ' : 'No ';
				errMsg += 'Contract';
			}
		}

		errMsg += errMsg.length > 0 ? ' pharmacies chosen' : '';

		return {
			list: rxlist,
			errMsg: errMsg
		};
	}

	function createNewReport() {

		if(vm.isWaiting) {
			return;
		}

		// validate
		if(!requestValid(vm.query)) {
			msgSvc.ok('Audit Report', 'Cannot create, check request properties');
			return;
		}

		// both split and contract can't be no
		if(vm.query.SplitBill == 'no' && vm.query.Contract == 'no') {
			msgSvc.ok('Audit Report', 'Cannot create, choose either Split Billing or Contract, one must be chosen.');
			return;
		}

		if(vm.query.IncludePHI == 'yes' && vm.query.confirmIncludePHI == 'no' && !!!vm.hasPHIAttested) {
			msgSvc.ok('Audit Report', 'Cannot create, please confirm the agreement to include PHI.');
			return;
		}

		// at least 1 rx chosen by split or contract option
		var rxLists = validRxLists(vm.query);
		if(rxLists.errMsg.length > 0) {
			msgSvc.ok('Audit Report', 'Cannot create, ' + rxLists.errMsg);
			return;
		}
		vm.query.RxList = rxLists.list;

		vm.isWaiting = true;

		var titleTxt = 'Audit Report';
		if(vm.query.Sample == 'yes') {
			titleTxt = 'Sample ' + titleTxt;
		}

		// confirm
		msgSvc.confirm({
			id: 'report.audit.confirm',
			title: titleTxt,
			msg: 'Create Audit Report for ' + vm.query.CE.val + '?',
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(userConfirm, userConfirm);

	}

	function userConfirm(r) {

		if(!!r && r.result == 'YES') {
			reportRepo.auditRequestFile(vm.query).then(okRequestFile, errRequestFile);
		}
		else {
			vm.isWaiting = false;
		}

	}

	function okRequestFile(r) {
		vm.isWaiting = false;

		msgSvc.okAsync(
			'File Request In Process...',
			'Filename added to list as: ' + r.Filename,
			'report.audit.createfile.ok').then(getFileList);
	}

	function errRequestFile(r) {
		vm.isWaiting = false;

		if(!!r) {
			errSvc.warn('Unexpected api error', 'errRequestFile.errCreate', r.status, utilSvc.http.safeResponse(r));
			init();
		}

	}


	/**
	 *    GET EXCEL FILE
	 */

	function getExcel(item) {

		// already working?
		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		if(item.Status == 'INPROGRESS') {
			msgSvc.ok('IN PROGRESS', 'File is not available, please click SEARCH again to check for file status updates.');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		_pendingExcelFilename = item.Name;
		reportRepo.auditGetExcel(vm.query.CE.val, _pendingExcelFilename).then(okAuditExcel, errAuditExcel);

		function okAuditExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/zip'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

			_pendingExcelFilename = false;

		}

		function errAuditExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
			_pendingExcelFilename = false;

			if(!!r) {
				errSvc.warn('Create Excel Error', 'report.audit.getExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    DATE PICKER
	 *    EVENT HOOK, DESTROY AND TOGGLE
	 */

	_datePickListener = $scope.$on('widget.input.date.pick.change', function(event, evtData) {
		event.stopPropagation();

		// params
		if(!evtData || !validSvc.isText(evtData.uniqueId)) {
			alert('reportAuditCtl.datePickEvt, evtData and uniqueId required');
			return;
		}
		var id = evtData.uniqueId;

		if(id != 'EndDate' && id != 'StartDate') {
			alert('reportAuditCtl.datePickEvt, uniqueId unknown: ' + id);
			return;
		}

		vm.dtPickShow[id] = false;
		vm.query[id].val = evtData.setDate;

		// set StartDate max <= EndDate
		if(id == 'EndDate') {
			vm.query.StartDate.max = evtData.setDate;
		}

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_datePickListener) {
			_datePickListener();
		}
	});

	function dtPickOpen(dtName) {

		if(dtName != 'EndDate' && dtName != 'StartDate') {
			alert('reportAuditCtl.dtPickOpen, date pick name unknown: ' + dtName);
			return;
		}
		var dt = vm.query[dtName];
		vm.dtPickShow.pending = dtName;

		$scope.$broadcast('widget.input.date.pick', {
			uniqueId: dtName,
			setDate: dt.val,
			minDate: dt.min,
			maxDate: dt.max
		});

		$timeout(function(){
			if(validSvc.isText(vm.dtPickShow.pending)) {
				vm.dtPickShow[vm.dtPickShow.pending] = true;
			}
		},100);
	}

	function validIntegerProp(prop, min, max) {

		// parse into float
		var floatVal;
		try {
			floatVal = parseFloat(prop.val);
		}
		catch(err) {
			// do nothing
		}

		// not a number
		if(!validSvc.isInteger(floatVal)) {
			prop.fail = 'yes';
			prop.msg = 'must be an integer';
			return prop;
		}

		// min
		if(floatVal < min) {
			prop.fail = 'yes';
			prop.msg = 'minimum: ' + min;
			return prop;
		}

		// max
		if(floatVal > max) {
			prop.fail = 'yes';
			prop.msg = 'maximum: ' + max;
			return prop;
		}

		// success
		prop.fail = 'no';
		prop.msg = '';

		return prop;

	}

}

 
billingRxCtl.$inject = ['$window', '$state', '$scope', '$timeout', '$filter', 'reportRepo', 'sessionRepo', 'lookupRepo', 'reportPDF', 'validSvc', 'utilSvc', 'errSvc', 'msgSvc'];
angular
.module('espui.report')
.controller('BillingRxCtl', billingRxCtl);


/* @ngInject */
function billingRxCtl($window, $state, $scope, $timeout, $filter, reportRepo, sessionRepo, lookupRepo, reportPDF, validSvc, utilSvc, errSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this,
		_pendingExcelFilename = '',
		_pendingViewState = false,
		_returnVisit = false,
		_pagingEventListener = null,
		_tabFilters = {},
		_mouseLeaveDelay = {},
		_rollupAffs = [];

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addMultiselect(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.reportTab = '';

	// droplists
	vm.RollupDroplist = [];

	// query
	vm.query = {};
	vm.queryChangeCE = queryChangeCE;
	vm.queryChangeRX = queryChangeRX;
	vm.queryChangeReportType = queryChangeReportType;
	vm.dateRangeChange = dateRangeChange;

	// model
	vm.display = {};

	// methods
	vm.tabChange = tabChange;
	vm.getDetail = getDetail;
	vm.batchPDF = batchPDF;
	vm.clickRollupReport = clickRollupReport;
	vm.getFileList = getFileList;
	vm.createNewReport = createNewReport;
	vm.cancelNewReport = cancelNewReport;

	// rollup
	vm.rollupPDF = rollupPDF;
	vm.rollupExcel = rollupExcel;
	vm.rollupAdminFeesPDF= rollupAdminFeesPDF;
	vm.getRollupExcel = getRollupExcel;

	// table and filters
	vm.tbl = {};
	vm.flt = {};
	vm.filterChange = filterChange;

	// multiselect
	vm.CeMultiselect = {};
	vm.RxMultiselect = {};
	vm.multiselectCeToggle = multiselectCeToggle;
	vm.multiselectRxToggle = multiselectRxToggle;
	vm.multiselectMouseHover = multiselectMouseHover;


	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		vm.init = true;
		vm.display = resetDisplayVM();

		// load query
		_returnVisit = initQueryAndFilters();

		// IND
		if(vm.query.ReportType == 'IND') {
			queryChangeReportType('IND');

			// default tab
			if(!!!vm.reportTab) {
				vm.reportTab = 'INDLIST';
			}

			if(_returnVisit) {
				_returnVisit = false;
				tabChange(vm.reportTab);
			}
		}
		else {
			// ROLLUP return visit: ASYNC call is made inside initQueryAndFilters() method

			// default rollup tab
			if(!!!vm.reportTab) {
				vm.reportTab = 'ROLLUPSUMMARY';
			}

		}

		// fire date control event after widget scope is setup
		$timeout(function() {
			$scope.$broadcast('widget.input.date.range.mode', {mode: vm.query.DateRangeMode, keepDates: true});
		}, 100);

	}

	function getBillingAffs() {
		var affs = utilSvc.aff.findStatus($scope.User.AffList);
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
		return utilSvc.aff.findRxBilling(affs);
	}

	function getRollups() {
		return utilSvc.aff.findRxType($scope.User.AffList, ['ROLLUP']);
	}

	function initQueryAndFilters() {

		vm.query = reportRepo.queryBillingVM();
		vm.query.CE.vals = [];
		vm.query.RX.vals = [];
		vm.query.multi = false;

		vm.query.RX.fail = validSvc.isRX(vm.query.RX.val) ? 'no' : 'yes';

		_tabFilters = {
			INDLIST: vm.initFilters({
				Config: {
					Dates: ['BillDate', 'VendorShipDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['-BillDate']
			}),
			DEFERRED: vm.initFilters({
				Config: {
					Dates: ['VendorShipDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['-VendorShipDate']
			}),
			TRUEUP: vm.initFilters({
				Config: {
					Dates: ['VendorShipDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['-VendorShipDate']
			}),
			ROLLUPSEARCH: vm.initFilters({
				Config: {
					Dates: ['CreateDate','ExpireDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['-CreateDate']
			})
		};

		// date default
		vm.query.DateRangeValid = false;
		vm.query.DateRangeList = utilSvc.widget.dateRangeList([]);
		vm.query.DateRangeMode = 'MTD';

		vm.RollupDroplist = utilSvc.ng.droplistNONE();

		var billingAffs = getBillingAffs();

		// RX multiselect
		var rxList = utilSvc.aff.rxList(billingAffs);
		vm.RxMultiselect = {
			type: 'RX',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Pharmacy',
			vals: [],
			list: vm.multiselectBuild(rxList, false),
			flt: ''
		};

		// CE multiselect
		vm.CeMultiselect = {
			type: 'CE',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Facility',
			vals: [],
			list: [],
			flt: ''
		};

		// get viewstate
		var returnVisit = false,
			vs = sessionRepo.get('vs-report-billing-rx');
		if(!!vs) {

			var vsq = vs.query;
			if(vsq.ReportType == 'IND' || (vsq.ReportType == 'ROLLUP' && vm.query.UserHasRxRollup)) {
				vm.reportTab = vs.reportTab;

				vm.query.ReportType = vsq.ReportType;
				vm.query.RxRollup = validSvc.newProp(vsq.RxRollup);
				vm.query.RxRollup.fail = validSvc.isRX(vsq.RxRollup) ? 'no' : 'yes';

				vm.multiselectReturnVisit(vm.RxMultiselect, '', vsq.RX);
				vm.CeMultiselect.vals = vsq.CE;
				vm.CeMultiselect = multiselectRebuildSecondary(vm.RxMultiselect, vm.CeMultiselect, billingAffs, true);
				vm.query.CE.fail = vm.CeMultiselect.vals.length < 1 ? 'yes' : 'no';
				vm.query.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';

				if((vsq.ReportType == 'IND' && vm.query.CE.fail == 'no' && vm.query.RX.fail == 'no') ||
					(vsq.ReportType == 'ROLLUP' && vm.query.RxRollup.fail == 'no')) {
					returnVisit = true;

					vm.query.StartDate.val = new Date(vsq.StartDate);
					vm.query.EndDate.val = new Date(vsq.EndDate);
					vm.query.DateRangeMode = vsq.DateRangeMode;
					vm.query.DateRangeValid = true;

					// filters
					_tabFilters = vs.tabFilters;
					if(!!_tabFilters[vm.reportTab]) {
						_tabFilters[vm.reportTab] = vm.resetFilters(_tabFilters[vm.reportTab], true);
					}
				}
			}
		}

		// user has ROLLUPS?
		if(vm.query.UserHasRxRollup) {

			if(vm.query.UserType == 'RX') {
				// ASYNC: find rollup parents in user's rx aff list
				findRxUserRollups($scope.User.AffList);
			}
			else {
				// all other users already have ROLLUPS in their affs list
				var rollups = getRollups();
				if(rollups.length > 0) {
					// ASYNC: load ROLLUPS, get short names from server
					loadRollupDisplay(utilSvc.aff.rxList(rollups));
				}
				else {
					vm.query.UserHasRxRollup = false;
				}
			}
		}

		// force to IND if user can't get to ROLLUP type
		if(!vm.query.UserHasRxRollup) {
			vm.query.ReportType = 'IND';
		}

		// set titles
		vm.multiselectTitle(vm.CeMultiselect, true);
		vm.multiselectTitle(vm.RxMultiselect, true);

		return returnVisit;

	}

	function findRxUserRollups(affs) {

		// search affs for ROLLUP parents

		var parentId = '',
			rollups = [];
		for(var i = 0; i < affs.length; i++) {
			parentId = affs[i].RxParent;
			if(validSvc.isText(parentId) && rollups.indexOf(parentId) < 0) {
				rollups.push(parentId);
			}
		}

		if(rollups.length > 0) {
			loadRollupDisplay(rollups);
		}
		else {
			vm.query.UserHasRxRollup = false;
		}
	}

	function loadRollupDisplay(rollups) {

		// ASYNC routine to get RX short names

		lookupRepo.RxInfo(rollups).then(okLookupRx, errLookupRx);

		function okLookupRx(items) {

			// save rollup affs array
			_rollupAffs = [];
			items = Array.isArray(items) ? items : [];
			for(var i = 0; i < items.length; i++) {
				_rollupAffs.push({
					RXID:items[i].NickName,
					RxName: items[i].Name,
					RxShortName: items[i].ShortName
				});
			}

			vm.RollupDroplist = utilSvc.aff.rxDroplist(_rollupAffs);
			vm.RollupDroplist[0].label = 'Choose a Rollup Pharmacy';

			// return visit?
			if(_returnVisit && vm.query.ReportType == 'ROLLUP') {
				_returnVisit = false;

				vm.query.RxRollup = utilSvc.ng.droplistAutoselect(vm.RollupDroplist, vm.query.RxRollup.val);
				vm.query.RxRollup.fail = validSvc.isRX(vm.query.RxRollup.val) ? 'no' : 'yes';
				if(vm.query.RxRollup.fail == 'no') {
					tabChange(vm.reportTab);
				}
			}

		}

		function errLookupRx(r) {
			if(!!r) {
				errSvc.warn('Error loading rollup display properties', 'ctlBillingRx.loadRollupDisplay', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    DISPLAY VIEW MODELS
	 */

	function resetDisplayVM() {
		return {
			hasData: false,
			DataItems: [],
			Items: [],
			CEDetails: [],
			SortBy: [],
			Paging: {}
		};
	}

	function displayVM(tabName, repoData, tooMany) {

		// IND view model

		var items = Array.isArray(repoData) ? repoData : [],
			isDEF = tabName == 'DEFERRED',
			isTRUEUP = tabName == 'TRUEUP',
			item = {};

		// re-format server data
		for(var i = 0; i < items.length; i++) {
			item = items[i];
			if(isDEF) {
				item.Description = validSvc.isText(item.Description) ? item.Description.replace(/\[DEFERRED\]+/g,'').trim() : '';
				item.Quantity = validSvc.isNumber(item.Quantity) ? item.Quantity : '';
			}
			else if(isTRUEUP) {
				item.Quantity = validSvc.isNumber(item.TruedUpQnty) ? item.TruedUpQnty : '';
				item.TruedUpNote = validSvc.isText(item.TruedUpNote) ? item.TruedUpNote : '';
				item.TruedUpDate = validSvc.isDate(item.TruedUpDate) ? item.TruedUpDate : null;

				item.ModifiedTxt = !!item.TruedUpDate ? utilSvc.dt.toText(item.TruedUpDate) : '';
				item.ModifiedTxt += !!item.TruedUpBy ? item.TruedUpBy : '';
			}
			else {
				item.TotalDue = parseFloat(item.TotalDue.toFixed(2));
			}
		}

		return {
			hasData: items.length > 0,
			Items: [],
			DataItems: items,
			TooMany: !!tooMany
		};
	}


	function rollupSearchVM(repoData) {

		// build the display view model (from empty or from repo data)

		var items = Array.isArray(repoData) ? repoData : [];

		var statTxt = '';
		for(var i = 0; i < items.length; i++) {
			items[i].ExpireDate = validSvc.isDate(items[i].ExpireDate) ? items[i].ExpireDate : null;

			// add completion to INPROGRESS status
			statTxt = items[i].Status;
			if(statTxt == 'INPROGRESS') {
				if(validSvc.isInteger(items[i].PercentComplete)) {
					statTxt += ' (' + parseInt(items[i].PercentComplete) + '%)';
				}
			}
			items[i].StatusTxt = statTxt;
		}

		return {
			Items: items
		};

	}

	function displayRollupVM(data) {

		// ROLLUP SUMMARY view model

		data = data || {};
		data.Items = Array.isArray(data.Items) ? data.Items : [];
		data.hasData = data.Items.length > 0;

		return data;

	}

	function displayRollupDetailVM(data) {

		// ROLLUP DETAIL view model
		// data structure is: CE > RX list > Invoice list

		data = data || {};
		data.CEDetails = Array.isArray(data.CEDetails) ? data.CEDetails : [];
		data.hasData = data.CEDetails.length > 0;

		// re-format server data
		var ceItem = null,
			rxItems = null,
			invItems = null;

		// loop CE items
		for(var i = 0; i < data.CEDetails.length; i++) {
			ceItem = data.CEDetails[i];
			ceItem.TotalDue = parseFloat(ceItem.TotalDue.toFixed(2));
			ceItem.TotalDispenseFees = parseFloat(ceItem.TotalDispenseFees.toFixed(2));

			// loop RX items
			rxItems = Array.isArray(ceItem.PharmacyInvoices) ? ceItem.PharmacyInvoices : [];
			for (var ii = 0; ii < rxItems.length; ii++) {

				// loop invoices
				invItems = Array.isArray(rxItems[ii].Invoices) ? rxItems[ii].Invoices : [];
				for(var iii = 0; iii < invItems.length; iii++) {
					invItems[iii].TotalDue = parseFloat(invItems[iii].TotalDue.toFixed(2));
					invItems[iii].TotalDispenseFees = parseFloat(invItems[iii].TotalDispenseFees.toFixed(2));
				}
				rxItems[ii].Invoices = invItems;
			}
			ceItem.PharmacyInvoices = rxItems;

		}

		return data;

	}


	/**
	 *    QUERY CHANGE
	 */

	function queryChange() {

		if(!vm.init) {
			vm.action = '';
			vm.tbl = {};
			vm.display = resetDisplayVM();

			vm.flt = vm.resetFilters(vm.flt);
			$scope.$broadcast('widget.paging');
			_pendingViewState = false;
		}

	}

	function queryChangeReportType(rptType) {

		queryChange();

		vm.query.ReportType = rptType;
		if(rptType == 'IND') {
			vm.reportTab = 'INDLIST';
		}
		else {
			vm.reportTab = 'ROLLUPSUMMARY';
		}

		queryChangeRX();

	}

	function multiselectCeToggle(evt, id) {
		vm.RxMultiselect.show = false;
		multiselectToggle(evt, vm.CeMultiselect, id);
	}

	function multiselectRxToggle(evt, id) {
		vm.CeMultiselect.show = false;
		multiselectToggle(evt, vm.RxMultiselect, id);
	}

	function queryChangeRX(val) {

		queryChange();

		if(vm.query.ReportType == 'IND') {
			vm.multiselectClick(vm.RxMultiselect, val);
			vm.multiselectTitle(vm.RxMultiselect, true);
			vm.query.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';

			// rebuild CE
			vm.CeMultiselect = multiselectRebuildSecondary(vm.RxMultiselect, vm.CeMultiselect, getBillingAffs(), true);
			vm.query.CE.fail = vm.CeMultiselect.vals.length < 1 ? 'yes' : 'no';
		}
		else {
			vm.query.RxRollup.fail = validSvc.isRX(vm.query.RxRollup.val) ? 'no' : 'yes';
		}

	}

	function queryChangeCE(val) {

		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.multiselectClick(vm.CeMultiselect, val);
		vm.multiselectTitle(vm.CeMultiselect, true);

		vm.query.CE.fail = vm.CeMultiselect.vals.length < 1 ? 'yes' : 'no';

	}

	function dateRangeChange(dtMode, isValid) {

		vm.query.DateRangeMode = dtMode;
		vm.query.DateRangeValid = isValid;

		if(!vm.init) {
			queryChange();
		}
		vm.init = false;

	}


	/**
	 *    GLOBAL GREASE FILTER
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {
			if(!Array.isArray(vm.tbl.DataItems)) {
				vm.flt.Busy = false;
				return;
			}

			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: vm.reportTab,
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			if(!_pendingViewState) {
				_pendingViewState = true;
				$timeout(function() {
					if(!vm.flt.Busy && !vm.flt.Dirty) {
						saveViewState(vm.query, vm.reportTab, vm.flt);
					}
				},1000);
			}

		}, delayTime);

	}


	/**
	 *    TAB CHANGE / SUBMIT
	 */

	function queryValid(query) {

		var result = false;

		if(query.ReportType == 'IND') {

			// validate
			var ceVals = multiselectQueryVals(vm.CeMultiselect),
				rxVals = multiselectQueryVals(vm.RxMultiselect);
			vm.query.CE.fail = ceVals.length < 1 ? 'yes' : 'no';
			vm.query.RX.fail = rxVals.length < 1 ? 'yes' : 'no';

			// assign multi values
			if(vm.query.DateRangeValid && vm.query.CE.fail == 'no' && vm.query.RX.fail == 'no') {
				result = true;

				vm.query.CE.vals = ceVals;
				vm.query.RX.vals = rxVals;
				vm.query.multi = false;
				if((ceVals[0] == 'ALL' || ceVals.length > 1) && (rxVals[0] == 'ALL' || rxVals.length > 1)) {
					vm.query.multi = true;
					vm.reportTab = 'INDLIST'; // force to list tab, deferred not shown for multi
				}
			}
		}
		else {
			vm.query.RxRollup.fail = validSvc.isRX(vm.query.RxRollup.val) ? 'no' : 'yes';
			result = vm.query.RxRollup.fail == 'no';
		}

		return result;
	}

	function tabChange(tabName) {

		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.reportTab = tabName;
		if(!queryValid(vm.query)) {
			if(!vm.init) {
				msgSvc.ok('Search', 'Check filter settings');
			}
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		vm.action = 'TABLOAD';

		switch(vm.reportTab) {

			case 'INDLIST':
				reportRepo.getBillRxList(vm.query).then(okGetData, errGetData);
				break;

			case 'ROLLUPSUMMARY':
				reportRepo.rollupSummary(vm.query).then(okGetData, errGetData);
				break;

			case 'ROLLUPDETAIL':
				reportRepo.rollupDetail(vm.query).then(okGetData, errGetData);
				break;

			case 'DEFERRED':
				reportRepo.getBillDeferred(vm.query).then(okGetData, errGetData);
				break;

			case 'TRUEUP':
				reportRepo.getBillTrueUp(vm.query).then(okGetData, errGetData);
				break;
	
			default:
				throw new Error('billingRxCtl.tabChange, unknown report tab: ' + vm.reportTab);
		}

	}

	function okGetData(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		switch(vm.reportTab) {

			case 'INDLIST':
			case 'DEFERRED':
			case 'TRUEUP':
				vm.flt = vm.resetFilters(_tabFilters[vm.reportTab], true);

				vm.tbl = displayVM(vm.reportTab, r.data, r.tooMany);
				vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);

				// conditionally show ROLLUP Excel link if query has data
				if(vm.query.ReportType == 'ROLLUP' && vm.reportTab == 'DEFERRED') {
					vm.display = {
						hasData: vm.tbl.DataItems.length > 0
					};
				}

				vm.flt.Ready = true;

				// update paging ui
				$scope.$broadcast('widget.paging', {
					uniqueId: vm.reportTab,
					Size: vm.flt.PageSize,
					Page: vm.flt.Page,
					Total: vm.flt.PageTotal,
					RowCount: vm.flt.Count,
					ItemCount: vm.tbl.Items.length,
					DataCount: vm.tbl.DataItems.length
				});
				break;

			case 'ROLLUPSUMMARY':
				vm.display = displayRollupVM(r);
				break;

			case 'ROLLUPDETAIL':
				vm.display = displayRollupDetailVM(r);
				break;

			default:
				throw new Error('billingRxCtl.okGetData, unknown report tab: ' + vm.reportTab);
		}

		saveViewState(vm.query, vm.reportTab, vm.flt);
		vm.action = 'LIST';

	}

	function errGetData(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		if(!!r) {
			errSvc.warn('unknown error getting data for tab: ' + vm.reportTab, 'BillListCtl.errGetData', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    INVOICE DETAIL
	 *    invoice list for 1 RX Id
	 */

	function getDetail(id) {
		if(vm.isWaiting) {
			return;
		}
		$state.go('report.billing-rxdetail', {id: id}, {reload: 'report.billing-rxdetail'});
	}


	/**
	 *    PDF
	 */

	function pdfBatchVM(pdf) {
		return {
			Id: pdf.Id,
			BillDate: pdf.BillDate,
			OrderNumber: pdf.OrderNumber,
			BillNumber: pdf.BillNumber,
			TotalDue: pdf.TotalDue,
			CE: pdf.CEID,
			RX: pdf.RXID
		};
	}

	function rollupBatchInvoices(items) {

		items = Array.isArray(items) ? items : [];

		var result = [],
			uniqueInvoiceId = [],
			ii = 0,
			iii = 0,
			rxItems = [],
			invItems = [],
			invItem = {},
			ceid = '',
			rxid = '';

		// loop CE entries
		for(var i = 0; i < items.length; i++) {
			ceid = items[i].CEID;

			// loop RX list per CE
			rxItems = items[i].PharmacyInvoices;
			for(ii = 0; ii < rxItems.length; ii++) {
				rxid = rxItems[ii].RXID;

				// loop invoices
				invItems = rxItems[ii].Invoices;
				for(iii = 0; iii < invItems.length; iii++) {
					invItem = invItems[iii];

					if(uniqueInvoiceId.indexOf(invItem.Id) < 0) {
						uniqueInvoiceId.push(invItem.Id);

						// add CE/RX to each invoice
						invItem.CEID = ceid;
						invItem.RXID = rxid;

						// use POName as OrderNumber
						invItem.OrderNumber = invItem.POName;
						result.push(pdfBatchVM(invItem));
					}
				}
			}
		}

		return result;

	}

	function batchPDF() {

		// batch create several invoices

		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('PDF feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		var pdfs = [];

		if(vm.reportTab == 'ROLLUPDETAIL') {
			pdfs = rollupBatchInvoices(vm.display.CEDetails);
		}
		else if(vm.reportTab == 'INDLIST') {
			for (var i = 0; i < vm.tbl.Items.length; i++) {
				pdfs.push(pdfBatchVM(vm.tbl.Items[i]));
			}
		}
		else {
			msgSvc.ok('Cannot Batch', 'Unknown report tab for batching: ' + vm.reportTab);
			return;
		}

		if(pdfs.length < 1) {
			msgSvc.ok('Cannot PDF Batch', 'At least 1 invoice must be displayed to process.');
			return;
		}

		$state.go('report.billing-rxpdfbatch', {pdfBatch:pdfs}, {reload: 'report.billing-rxpdfbatch'});

	}

	function rollupPDF() {

		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('PDF feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		var rxid = vm.query.RxRollup.val,
			affs = utilSvc.aff.findRx(_rollupAffs, rxid);

		// get rx names
		var rxName = affs[0].RxShortName;

		// format data for display
		var rptData = {
			RXID: rxid,
			RxShortName: rxName,
			RXNAME: rxName,
			StartDate: vm.query.StartDate.val,
			EndDate: vm.query.EndDate.val,
			Items: [],
			TotalRxAdminFees: numberFmt(vm.display.TotalRxAdminFees, '0.00','', 2),
			TotalOrderInvoicedDue: numberFmt(vm.display.TotalOrderInvoicedDue, '0.00','', 2),
			TotalDue: numberFmt(vm.display.TotalDue, '0.00','', 2)
		};

		var invItems = vm.display.Items;
		for(var i = 0; i < invItems.length; i++) {
			rptData.Items.push({
				RXNAME: invItems[i].RXNAME,
				RXID: invItems[i].RXID,
				RxAdminFees: numberFmt(invItems[i].RxAdminFees, '0.00','', 2),
				TotalAmount: numberFmt(invItems[i].TotalAmount, '0.00','', 2)
			});
		}

		reportPDF.rxRollup(rptData).then(okRollupPDF, errRollupPDF);

		function okRollupPDF(pdfBlob, rptName) {
			vm.isWaiting = false;
			msgSvc.wait(false);
		}

		function errRollupPDF(err) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			err = err || {};
			errSvc.warn('Create PDF Error', 'billing.rx.rollupPDF', '', err.message);
		}

	}


	/**
	 *    EXCEL
	 */

	function rollupExcel() {

		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		// format filename
		var rxName = utilSvc.aff.rxShortNameById(_rollupAffs, vm.query.RxRollup.val);
		_pendingExcelFilename = 'Verity-' + rxName + '-Report-' + utilSvc.dt.monthShortText(vm.query.StartDate.val) + vm.query.StartDate.val.getFullYear().toString() + '.xlsx';

		reportRepo.rollupExcel(vm.query, _pendingExcelFilename).then(okRollupExcel, errRollupExcel);

		function okRollupExcel(binaryData) {

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}); //'application/octet-stream'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

			vm.isWaiting = false;
			msgSvc.wait(false);
		}

		function errRollupExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Create Excel Error', 'billing.rx.rollupExcel', r.status, err.message);
			}
		}

	}
	function rollupAdminFeesPDF() {
		console.log("pdf fun called");

		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		// format filename
		var rxName = utilSvc.aff.rxShortNameById(_rollupAffs, vm.query.RxRollup.val);
		_pendingExcelFilename = 'Verity-' + rxName + '-Report-' + utilSvc.dt.monthShortText(vm.query.StartDate.val) + vm.query.StartDate.val.getFullYear().toString() + '.pdf';

		reportRepo.rollupAdminFeesPDF(vm.query, _pendingExcelFilename).then(okRollupPDF, errRollupPDF);

		function okRollupPDF(binaryData) {

			// convert binary stream to blob and save
			try {
				var pdfBlob = new Blob([binaryData],{type:'application/pdf'}); 
				$window.saveAs(pdfBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

			vm.isWaiting = false;
			msgSvc.wait(false);
		}

		function errRollupPDF(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Create Excel Error', 'billing.rx.rollupExcel', r.status, err.message);
			}
		}

	}



	/**
	 *    MULTISELECT HELPERS
	 */

	function multiselectRebuildSecondary(primary, secondary, affs, usingALL) {

		// rebuild secondary multiselect based on values in primary multiselect

		usingALL = !!usingALL;

		if(primary.vals.length < 1) {
			secondary.list = [];
			secondary.vals = [];
		}
		else {
			affs = primary.type == 'CE' ? utilSvc.aff.findCeList(affs, primary.vals) : utilSvc.aff.findRxList(affs, primary.vals);
			var secList = primary.type == 'CE' ? utilSvc.aff.rxList(affs) : utilSvc.aff.ceList(affs);
			var vals = secondary.vals,
				newVals = [];

			if(vals.length === 1 && vals[0] == 'ALL') {
				newVals = ['ALL'];
				usingALL = true;
			}
			else {
				// add new val only if it exists in new secList
				for(var i = 0; i < vals.length; i++) {
					if(secList.indexOf(vals[i]) > -1) {
						newVals.push(vals[i]);
					}
				}
			}

			// assign new check list
			if(usingALL && secList.length > 1) {
				secList.unshift('ALL');
			}
			if(secondary.type == 'RX') {
				secondary.list = vm.multiselectBuildRX(secList, false, affs);
			}
			else {
				secondary.list = vm.multiselectBuild(secList, false);
			}

			// assign vals
			if((!usingALL && secList.length === newVals.length) || (usingALL && ((newVals.length > 0 && newVals[0] == 'ALL') || secList.length - 1 === newVals.length))) {
				// all vals are checked
				secondary.vals = [];
				vm.multiselectClick(secondary, 'ALL');
			}
			else {
				vm.multiselectReturnVisit(secondary, '', newVals);
			}
		}

		// set RX title
		vm.multiselectTitle(secondary, true);

		return secondary;

	}

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if(vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		multiselect.flt = '';

		// don't bother with width if hiding
		if(multiselect.show) {
			multiselect.show = false;
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;

	}

	function multiselectMouseHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}

	function multiselectQueryVals(multiselect) {

		// unpack the vals multiselect into a list of entities to query

		var checklist = multiselect.list,
			vals = multiselect.vals;

		if(vals.length < 1) {
			return [];
		}
		else if(vals.length === 1 && vals[0] == 'ALL') {
			// using ALL checkbox, return all values except ALL checkbox
			var result = [],
				i = checklist[0].val == 'ALL' ? 1 : 0;
			for(i; i < checklist.length; i++) {
				result.push(checklist[i].val);
			}
			return result;
		}
		else {
			return vals;
		}
	}


	/**
	 *    HELPERS
	 */

	function numberFmt(val, zeroFmt, prefix, decPlaces) {

		// helper to format incoming number data

		// nan
		if(!validSvc.isNumber(val)) {
			return '';
		}

		// zero
		if(val === 0) {
			return zeroFmt;
		}

		return prefix + utilSvc.str.toText($filter('number')(val, decPlaces));

	}

	function saveViewState(query, reportTab, flt) {
		// update tab filters
		if(!!_tabFilters[reportTab]) {
			_tabFilters[reportTab] = flt;
		}

		sessionRepo.set('vs-report-billing-rx', {
			reportTab: reportTab,
			query: {
				ReportType: query.ReportType,
				RxRollup: query.RxRollup.val,
				RX: query.RX.vals,
				CE: query.CE.vals,
				DateRangeMode: query.DateRangeMode,
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val
			},
			tabFilters: _tabFilters
		});

		_pendingViewState = false;
	}

	function clickRollupReport() {
		vm.action = "CREATE_ASYNC";
	}

	function cancelNewReport() {
	
			if(vm.isWaiting) {
				return;
			}
	
			vm.action = '';
	}

	function getFileList() {

		if(vm.isWaiting) {
			return;
		}
		vm.action = '';


		vm.query.RxRollup.fail = validSvc.isRX(vm.query.RxRollup.val) ? 'no' : 'yes';
		if(vm.query.RxRollup.fail == 'yes') {
			if(!vm.init) {
				msgSvc.ok('Search', 'Choose a Rollup Pharmacy');
			}
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		// send list
		reportRepo.rxRollupInvReportList(vm.query.RxRollup.val).then(okGetList, errGetList);

		function okGetList(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			vm.display = rollupSearchVM(r);
			vm.action = 'ROLLUPSEARCH';
			vm.flt = vm.resetFilters(_tabFilters[vm.action]);
		}

		function errGetList(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('unknown API error', 'reportRxRollupInvReportCtl.getFileList', r.status, utilSvc.http.safeResponse(r));
				init();
			}
		}
	}

	function createNewReport() {

		if(vm.isWaiting) {
			return;
		}

		// validate
		if(!queryValid(vm.query)) {
			msgSvc.ok('Excel Pharmacy Invoice Report', 'Cannot create, check request properties');
			return;
		}


		vm.isWaiting = true;
		msgSvc.wait(true);
	
		reportRepo.asyncRxInvoiceReport(vm.query).then(okCreateReport, errCreateReport);

		function okCreateReport(r) {
			vm.isWaiting = false;
			//msgSvc.wait(false); //TODO
			//saveViewState(vm.query, vm.reportTab, vm.flt); //TODO

			msgSvc.okAsync(
				'File Request In Process...',
				'Filename added to list as: ' + r.Filename,
				'report.audit.createfile.ok').then(getFileList);			
		}

		function errCreateReport() {
			vm.isWaiting = false;
			msgSvc.wait(false);
	
			if(!!r) {
				errSvc.warn('unknown error creating pharmacy invoice excel report', 'ctlBillingRx.errCreateReport', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}


		/**
	 *    GET EXCEL FILE
	 */

		 function getRollupExcel(item) {

			// already working?
			if(vm.isWaiting) {
				return;
			}
	
			// blob support?
			if(!validSvc.blobSupported()) {
				errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
				return;
			}
	
			if(item.Status == 'INPROGRESS') {
				msgSvc.ok('IN PROGRESS', 'File is not available, please click Excel Reports button again to refresh');
				return;
			}
	
			vm.isWaiting = true;
			msgSvc.wait(true);
	
			_pendingExcelFilename = item.Name;
			reportRepo.rxRollupInvGetExcel(vm.query.RxRollup.val, _pendingExcelFilename).then(okrxRollupInvExcel, errRxRollupInvExcel);

	
			function okrxRollupInvExcel(binaryData) {
				vm.isWaiting = false;
				msgSvc.wait(false);
	
				// convert binary stream to blob and save
				try {
					var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}); //'application/octet-stream'});
					$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
				}
				catch(err) {
					throw(err);
				}
	
				_pendingExcelFilename = false;
	
			}
	
			function errRxRollupInvExcel(r) {
				vm.isWaiting = false;
				msgSvc.wait(false);
				_pendingExcelFilename = false;
	
				if(!!r) {
					errSvc.warn('Create Excel Error', 'report.rxrollupinv.getExcel', r.status, utilSvc.http.safeResponse(r));
				}
	
			}
	
		}

}

 
billingRxDetailCtl.$inject = ['$scope', '$state', '$window', '$filter', '$timeout', 'reportRepo', 'reportPDF', 'utilSvc', 'validSvc', 'msgSvc', 'errSvc'];
angular
.module('espui.report')
.controller('BillingRxDetailCtl', billingRxDetailCtl);

/* @ngInject */
function billingRxDetailCtl($scope, $state, $window, $filter, $timeout, reportRepo, reportPDF, utilSvc, validSvc, msgSvc, errSvc) {

	var vm = this;
	var _cancelPdfBatch = false,
		_tryBlobSupport = false;

	// inherit
	msgSvc.addHelpLink(vm);

	// properties
	vm.isWaiting = false;
	vm.action = '';

	// models
	vm.pdfBatch = [];
	vm.pdfBatchDone = [];
	vm.bill = {};

	// generate PDF / Excel
	vm.createPDF = createPDF;
	vm.pdfCancel = pdfCancel;
	vm.pdfStartBatch = pdfStartBatch;
	vm.createExcel = createExcel;

	// backing
	vm.backing = {};
	vm.getBacking = getBacking;
	vm.closeBacking = closeBacking;
	vm.navToFeature = navToFeature;

	/**
	 *    INIT
	 */

	init();

	function init() {

		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		// pdf batch?
		if($state.current.name == 'report.billing-rxpdfbatch') {
			vm.action = 'PDFLIST';

			// params
			var pdfs = $state.params.pdfBatch;
			if(!Array.isArray(pdfs) || pdfs.length < 1) {
				errSvc.warn('Pharmacy Invoice Batch param is missing.');
				$state.go('report.billing-rx', {}, {reload: 'report.billing-rx'});
				return;
			}

			// load and de-reference pdf array from route
			vm.pdfBatch = angular.fromJson(angular.toJson(pdfs));
			$state.params.pdfBatch = null;

		}
		else {
			vm.action = 'DETAIL';

			// params
			if(!validSvc.isText($state.params.id)) {
				errSvc.warn('Pharmacy Invoice number is missing.');
				$state.go('report.billing-rx', {}, {reload: 'report.billing-rx'});
				return;
			}

			var params = $state.params;
			vm.query = {Id: params.id, lineItemSelected: params.lineitemselected};
			getBillDetail($state.params.id);

			if (!!vm.query.lineItemSelected) {
				// Perform line item click after a short time
				$timeout(function(){
					getBacking({}, vm.query.lineItemSelected.item, vm.query.lineItemSelected.offsetTop);
				}, 300);
			}
		}


	}


	/**
	 *    BILL VM
	 */

	function billVM(data) {

		var model = data || { Items: [] };

		// bill property formatting

		model.TotalDue = numberFmt(model.TotalDue, '0.00','', 2);
		model.BillDate = new Date(model.BillDate);
		model.VendorShipDate = new Date(model.VendorShipDate);
		model.AccumRxName = !!model.AccumRXID ? utilSvc.aff.rxShortNameByIdLookup(model.AccumRXID) : '';

		// create final invoice line items (drug line + dispense fee line)
		var newLines = [],
			newLine = {},
			feeLine = {};

		for(var i = 0; i < model.Items.length; i++) {

			newLine = model.Items[i];

			if(newLine.DrugType == 'NOTADRUG') {

				// display description lines differently than drug lines
				newLines.push({
					Id: newLine.Id,
					ItemCode: newLine.ItemCode,
					Quantity: newLine.Quantity,
					LineNum: newLine.LineNum,
					LineDesc: newLine.Description,
					LineDesc2: '',
					LinePrice: numberFmt(newLine.Price, '0.00','', 2),
					LineAmount: numberFmt(newLine.TotalAmount, '0.00','', 2),
					VendLineItemId: newLine.VendLineItemId,
				});

			}
			else {

				// drug line
				newLines.push({
					Id: newLine.Id,
					ItemCode: newLine.ItemCode,
					Quantity: newLine.Quantity,
					LineNum: newLine.LineNum,
					//LineDesc: newLine.Description + ' , NDC: ' + newLine.ItemCode + ', Type: ' + newLine.DrugType,
					LineDesc: newLine.Description, // 'FENTANYL-BUPIVACAINE-0.9% NACL 2 MCG/ML-0.125% BAG (CMPD-RX)',
					LineDesc2: 'NDC: ' + newLine.ItemCode + ', Type: ' + newLine.DrugType,
					LinePrice: numberFmt(newLine.Price, '0.00','', 2),
					LineAmount: numberFmt(newLine.TotalAmount, '0.00','', 2),
					VendLineItemId: newLine.VendLineItemId,
				});

				// dispense fee sub-line
				feeLine = {
					Quantity: newLine.DispFeeQty,
					LineDesc: newLine.DrugType.toLowerCase() + ' dispense fees',
					LinePrice: '',
					LineAmount: numberFmt(newLine.DispFeeTotal, '0.00','', 2)
				};
				if(newLine.FeeModel == 'ORDERQUANTITY') {
					feeLine.LinePrice = numberFmt(newLine.DispFeePrice, '0.00','', 2);
				}

				newLines.push(feeLine);
			}

		}
		model.Items = newLines;

		return model;

	}


	/**
	 *    GET BILL DETAIL
	 *    returns a specific bill and its line items
	 */

	function getBillDetail(id) {

		if(vm.action != 'PDFBATCH') {
			vm.isWaiting = true;
			msgSvc.wait(true);
		}

		reportRepo.getBillRxDetail(id).then(okBillDetail, errBillDetail);

		function okBillDetail(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.bill = billVM(r);

			if(vm.action == 'PDFBATCH') {
				vm.pdfBatch.splice(0,1);
				createPDF();
			}

		}

		function errBillDetail(r) {
			msgSvc.wait(false);

			if(r === null) {
				// already handled, no msg
			}
			else {
				errSvc.error('Unknown get response', 'billDetailCtl.errBillDetail', '', utilSvc.http.safeResponse(r));
			}

			$state.go('report.billing-rx', {}, {reload: 'report.billing-rx'});

		}


	}


	/**
	 *    CREATE SUMMARY PDF
	 */

	function createPDF() {

		// blob support?
		if(!_tryBlobSupport) {
			if(!validSvc.blobSupported()) {
				errSvc.warn('PDF feature requires your browser to support HTML5 Blob functionality. Try using a different browser');

				if(vm.action == 'PDFBATCH') {
					$state.go('report.billing-rx', {}, {reload: 'report.billing-rx'});
				}
				return;
			}
			_tryBlobSupport = true;
		}

		if(vm.action != 'PDFBATCH') {
			vm.isWaiting = true;
			msgSvc.wait(true);
		}

		reportPDF.rxBilling(vm.bill).then(okPDF, errPDF);

		function okPDF() {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(vm.action == 'PDFBATCH') {

				vm.pdfBatchDone.push({
					CE: vm.bill.CEID,
					RX: vm.bill.RXID,
					BillDate: vm.bill.BillDate,
					OrderNumber: vm.bill.OrderNumber,
					BillNumber: vm.bill.BillNumber,
					TotalDue: vm.bill.TotalDue
				});

				if(vm.pdfBatch.length < 1) {
					msgSvc.ok('PDF Batch Complete');
				}
				else if(_cancelPdfBatch) {
					msgSvc.ok('PDF Batch Cancelled', vm.pdfBatch.length + ' pdf documents cancelled.');
					vm.pdfBatch = [];
				}
				else {
					$timeout(function() {
						getBillDetail(vm.pdfBatch[0]);
					}, 1000);
				}
			}
		}

		function errPDF(err) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			err = err || {};
			errSvc.warn('Create PDF Error', 'billDetailCtl.createPDF', '', err.message);

			if(vm.action == 'PDFBATCH') {
				$state.go('report.billing-rx', {}, {reload: 'report.billing-rx'});
			}

		}

	}


	/**
	 *    EXCEL FOR RX INVOICE DETAIL REPORT WITH BACKING DETAILS
	 */

	function createExcel() {

		if(vm.isWaiting) {
			return;
		}
		
		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}
	
		// use main waiting spinner, not the spinner on report tabs
		vm.isWaiting = true;
		msgSvc.wait(true);
	
		// format filename: 'PharmacyInvoice_<PHID>_<VerityBill#>_<VerityBillDate>.xlsx'
		var _pendingExcelFilename = 'PharmacyInvoice_' + vm.bill.RXID + '_' + vm.bill.BillNumber + "_" + utilSvc.dt.toServerString(vm.bill.BillDate) + '.xlsx';		

		// dump all caching and memory before creating Excel
		reportRepo.destroyRX();
		reportRepo.destroyCE();

		$timeout(function() {
			// small delay for digest cycle to delete repo memory
			reportRepo.rxInvoiceDetailGetExcel(vm.bill.Id, _pendingExcelFilename).then(okServerExcel, errServerExcel);
		}, 300);
	
		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);
	
			// convert binary back into Excel file
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}
		}
	
		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);
	
			if(!!r) {
				errSvc.warn('Create Excel Error', 'cpfin.ServerExcel', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}


	/**
	 *    NAV TO FEATURE
	 */

	 function navToFeature(navType, navData) {
		// nav to Accumu Detail
		if (vm.isWaiting) {
			return;
		}

		var breadcrumb = {
			icon: 'sprite-ndc-accum',
			route: 'report.billing-rxdetail',
			routeData: { id: vm.query.Id, rxid: vm.query.RX, lineitemselected: vm.query.lineItemSelected },
			msg: 'Return to Pharmacy Invoice Detail'
		};

		switch (navType) {
			case 'ACCUMDETAIL':
				var params = {
					Id: navData.AccumId,
					CE: navData.CEID,
					RX: navData.RXID, ShareGroup: null,
					CanEdit: $scope.User.Type == 'VERITYSA' || $scope.User.Type == 'VERITY' || $scope.User.Type == 'CE',
					breadcrumb: breadcrumb
				};
				$state.go('ops.accum-detail', params, { reload: 'ops.accum-detail' });
				break;
			default:
				alert('billDetailCtl.navToFeature, unknown navType: ' + navType);
		}

	}

	/**
	 *    LINE ITEM BACKING
	 */
	 function getBacking(evt, item, offsetTop) {
		if (vm.isWaiting) {
			return;
		}

		if (!item || !validSvc.isText(item.Id)) {
			msgSvc.ok('Line Item Backing', 'No backing dispenses available.');
			return;
		}

		msgSvc.wait(true);
		vm.query.lineItemSelected = { offsetTop: 0, item: item };
		vm.isWaiting = true;
		vm.backing = {
			ready: false,
			maxHeight: true,
			Items: [],
			lineNum: item.LineNum,
			desc: item.ItemCode + ': ' + item.LineDesc
		};
		vm.action = 'BACKING';

		// remember the clicked vertical location
		var elem = evt.target,
			offsetY = -100, // bump below row clicked
			hitRow = false;

		// loop html elements back to top of table
		while (!!elem) {

			// top element found
			if (!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
				break;
			}

			// add offset, get next element
			offsetY += elem.offsetTop;
			vm.query.lineItemSelected.offsetTop += elem.offsetTop;
			elem = elem.offsetParent;
		}
		// append offset manually in case we don't have element
		if (!!offsetTop) {
			vm.query.lineItemSelected.offsetTop = offsetTop;
			offsetY += offsetTop;
		}
		elem = null;

		// move popup to clicked row
		var popup = document.getElementById('tablePopupContent');
		if (!!popup) {
			popup.style.top = offsetY.toString() + 'px';
		}

		// send api request
		reportRepo.getBillRxBacking(item.Id).then(okGetBacking, errGetBacking);

		function okGetBacking(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;
			vm.backing.Items = Array.isArray(r) ? r : [];
			vm.backing.maxHeight = vm.backing.Items.length <= 5;
			vm.backing.ready = true;
		}

		function errGetBacking(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if (r != null) {
				errSvc.warn('Unknown get response', 'invoiceSplitDetail.getBacking', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}

	function closeBacking() {
		vm.backing = {};
		vm.action = 'DETAIL';
	}

	/**
	 *    PDF BATCH
	 */

	function pdfStartBatch() {

		// parse pdf list
		var createPdfs = [];
		for(var i = 0; i < vm.pdfBatch.length; i++) {
			if(!!!vm.pdfBatch[i].skip) {
				createPdfs.push(vm.pdfBatch[i].Id.toString());
			}
		}

		// at least 1 checked
		if(createPdfs.length < 1) {
			msgSvc.ok('Cannot Create', 'Select at least 1 pdf file to create.');
			return;
		}

		// start batch
		vm.action = 'PDFBATCH';
		vm.pdfBatch = createPdfs;
		getBillDetail(vm.pdfBatch[0]);

	}

	function pdfCancel() {

		if(vm.action == 'PDFLIST') {
			$state.go('report.billing-rx', {}, {reload: 'report.billing-rx'});
		}
		else {
			// batch is already started, set cancel on next async return
			_cancelPdfBatch = true;
		}

	}


	/**
	 *    HELPERS
	 */

	function numberFmt(val, zeroFmt, prefix, decPlaces) {

		// helper to format incoming number data

		// nan
		if(!validSvc.isNumber(val)) {
			return '';
		}

		// zero
		if(val === 0) {
			return zeroFmt;
		}

		return prefix + utilSvc.str.toText($filter('number')(val, decPlaces));

	}

} 
 
ClaimSubmissionCtl.$inject = ['$state', '$scope', '$timeout', 'reportRepo', 'validSvc', 'utilSvc', 'errSvc', 'msgSvc'];
angular
.module('espui.report')
.controller('ClaimSubmissionCtl', ClaimSubmissionCtl);


/* @ngInject */
function ClaimSubmissionCtl($state, $scope, $timeout, reportRepo, validSvc, utilSvc, errSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this,
		_featureName = '',
		_mouseLeaveDelay = {},
		_pagingEventListener = null,
		_maxFinalCutoff = 365, // use internal "_" instead of "vm" if property is not used in html
		_minFinalCutoff = 1, // use internal "_" instead of "vm" if property is not used in html
        _mfgList = [];

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addMultiselect(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.reportType = '';

	// droplist
	vm.dateTypeDroplist = [];

	// query
	vm.query = {};
	vm.queryChangeReportType = queryChangeReportType;
	vm.queryChangeFileType = queryChangeFileType;
	vm.queryChangeClaimType = queryChangeClaimType;
	vm.queryChangeCE = queryChangeCE;
	vm.dateRangeChange = dateRangeChange;
	vm.queryChangeDateType = queryChangeDateType;
	vm.toggleReplenishedOnly = toggleReplenishedOnly;
	vm.toggleFillDateCutoff = toggleFillDateCutoff;
	vm.toggleExtraColumns = toggleExtraColumns;
	vm.toggleRebateInclude = toggleRebateInclude;

	// multiselect
	vm.CeMultiselect = {};
	vm.RxMultiselect = {};
	vm.multiselectRxClick = multiselectRxClick;
	vm.multiselectCeToggle = multiselectCeToggle;
	vm.multiselectRxToggle = multiselectRxToggle;
	vm.multiselectMouseHover = multiselectMouseHover;

	// MfrMultiselect
	vm.MfrMultiselect = {};
	vm.multiselectMfrClick = multiselectMfrClick;
	vm.multiselectMfrToggle = multiselectMfrToggle;

	// tab bar
	vm.activeTab = '';
	vm.tabChange = tabChange;

	// async file create
	vm.createFile = createFile;

	// beacon auto config
	vm.config = configVM();
	vm.configSearch = configSearch;

	// config aff list
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;

	// flyout editing
    vm.flyout = flyoutVM();
	vm.editToggle = editToggle;
	vm.editToggleAll = editToggleAll;
    vm.editCancel = editCancel;
	vm.editSubmit = editSubmit;

    // truzo option
    vm.reportTypeTitle = reportTypeTitle;

    // ESP Auto Config
    vm.showESPAutoConfig = false;
	

	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {
		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		_featureName = $state.current.name;
		
		vm.init = true;

		// setup beacon auto config
		resetConfig();
		vm.config.enabled = utilSvc.user.hasFeature($scope, 'report.claimsub.rebate.config');
		vm.reportType = 'ESP'; // default report type

        // setup esp auto config (not available in test or prod)
		var env = $scope.appConfig.env;
        vm.showESPAutoConfig = (env == 'qa' || env == 'local' || env == 'dev');

		tabChange('CREATE');
		vm.init = false;
	}

	function getAffs() {
		var affs = utilSvc.aff.findStatus($scope.User.AffList);
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);

		var defaultBizModels = ['CP','CPTPA','SPLITMATCH'];
		switch(vm.reportType) {
			case 'ESP':
            case 'TRUZO':
                // TRUZO uses different biz models based on claim type
                switch(vm.query.ClaimType) {
                    case 'PHARMACY':
                        return utilSvc.aff.findRxModel(affs, defaultBizModels); // default
                    case 'MEDICAL':
                        return utilSvc.aff.findRxModel(affs, ['SPLIT']); // just split
                    default:
                        throw new Error('reportClaimSubCtl.getAffs, unknown Claim Type for TRUZO: ' + vm.query.ClaimType);
                }
                break;
			case 'CMS340B':
				// CMS 340B Data Repository: 340B pharmacy claims only
				return utilSvc.aff.findRxModel(affs, defaultBizModels);
			case 'REB':
				// REBATE uses different biz models based on file/claim type
				if(vm.activeTab == 'CONFIG') {
					// REBATE CONFIG SEARCH
					switch(vm.query.ClaimType) {
						case 'PHARMACY':
							return utilSvc.aff.findRxModel(affs, defaultBizModels); // default
						case 'MEDICAL':
							return utilSvc.aff.findRxModel(affs, ['SPLIT']); // just split
						default:
							throw new Error('reportClaimSubCtl.getAffs, unknown Claim Type for CONFIG: ' + vm.query.ClaimType);
					}
				}
				else {
					// REBATE CREATE FILE
					switch(vm.query.FileType) {
						case 'AUTO':
							defaultBizModels.push('SPLIT');
							return utilSvc.aff.findRxModel(affs, defaultBizModels); // use all biz models
						case 'MANUAL':
							switch(vm.query.ClaimType) {
								case 'PHARMACY':
									return utilSvc.aff.findRxModel(affs, defaultBizModels); // default
								case 'MEDICAL':
									return utilSvc.aff.findRxModel(affs, ['SPLIT']); // just split
								default:
									throw new Error('reportClaimSubCtl.getAffs, unknown Claim Type for CREATE: ' + vm.query.ClaimType);
							}
							break;
						default:
							throw new Error('reportClaimSubCtl.getAffs, unknown File Type: ' + vm.query.FileType);
					}
				}
				break;
			default:
				throw new Error('reportClaimSubCtl.getAffs, unknown Report Type: ' + vm.reportType);
		}
	}

	function getMfg() {
		// Get manufacturer which uses global exclusion NDC
		// this needs to be ASYNC, not off login response

        if(_mfgList.length < 1) {
            // build multiselect list
            var r = $scope.User.ManufacturerExclusionList;
            var mfgList = [{lbl:'All', val : 'ALL'}],
                mfg = {};
            for (var i = 0; i < r.length; i++) {
                mfg = r[i];
                mfgList.push({
                    lbl: mfg.Name + '(' + mfg.LabelerId + ')', // label is Name + LabelerId
                    val: mfg.LabelerId
                });
            }
            _mfgList = mfgList;
        }

		// force user to select 1 or more Mfg
		vm.MfrMultiselect.list = vm.multiselectBuildWithLabel(_mfgList, false); // false = do not select any items in the checklist
		vm.query.Mfr.fail = 'yes';
	}

	function resetQuery(rptType, fileType, claimType) {
		// called on showing CREATE or CONFIG panel

		// repo is setting default state for date type and checkboxes
		vm.query = reportRepo.queryClaimSubmitVM();

		// biz models
		vm.query.hasRxModelDefault = false;
		vm.query.hasRxModelSplit = false;

		// setup defaults
		vm.query.FileType = validSvc.isText(fileType) ? fileType : 'AUTO'; // REBATE default
		vm.query.ClaimType = validSvc.isText(claimType) ? claimType : 'PHARMACY'; // REBATE MANUAL or CONFIG default
		
		// default checkbox states
		vm.query.ReplenishedOnly = 'no';
		vm.query.ExtraColumns = 'yes';
		vm.query.UseFillDateCutoff = 'no';
		vm.query.IncludePayments = 'no';
		vm.query.IncludePharmacy = 'no';
		vm.query.IncludeMedical = 'no';

		// date defaults
		vm.dateTypeDroplist = getDateTypeList(rptType);
		vm.query.DateType = 'FILL';
		vm.query.DateRangeValid = false;
		vm.query.DateRangeList = utilSvc.widget.dateRangeList(['QTD','QTR','QTDLAST','CUSTOM92']);
		vm.query.DateRangeList.push({label: 'Month Start (1st to 15th)', value: 'MONTHSTART'});
		vm.query.DateRangeList.push({label: 'Month End (16th to EOM)', value: 'MONTHEND'});
		if(rptType == 'CMS340B') {
			// CMS 340B Data Repository allows a wider custom range
			vm.query.DateRangeList.push({label:'Custom Date Range (730 day max)', value: 'CUSTOM730'});
			// CMS 340B Data Repository collection begins 1/1/2026; disallow earlier dates
			var dtCmsMin = utilSvc.dt.zeroTime(new Date(2026, 0, 1));
			vm.query.StartDate.min = dtCmsMin;
			vm.query.EndDate.min = dtCmsMin;
		}
		else {
			vm.query.DateRangeList.push({label:'Custom Date Range (92 day max)', value: 'CUSTOM92'});
		}
		vm.query.DateRangeMode = 'MTD';

		// reset FillDateCutoff state (also adds err msg)
		resetFillDateCutoff();	
		
		var affs = getAffs();
		var ceList = utilSvc.aff.ceList(affs);
		if ($scope.User.Type == 'CE' && ceList.length > 1) {
			ceList.unshift('ALL');
		}

		// CE multiselect
		vm.CeMultiselect = {
			type: 'CE',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Facility',
			vals: [],
			list: ceList.length > 0 ? vm.multiselectBuild(ceList, false) : [{lbl:'No Facilities Available', val:'NONE'}],
			flt: ''
		};

		// RX multiselect
		vm.RxMultiselect = {
			type: 'RX',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Pharmacy',
			vals: [],
			list: [],
			flt: ''
		};

		// Mfr multiselect
		vm.MfrMultiselect = {
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: 'Choose a Manufacturer',
			titleNoOptions: 'Choose a Manufacturer',
			vals: [],
			list: [],
			flt: ''
		};	

		vm.query.CE.vals = [];
		vm.query.CE.fail = 'yes';
		queryChangeCE(vm.query.CE.val);

		// ESP requires MFR and Date
		if(rptType == 'ESP' || rptType == 'TRUZO') {
			getMfg();
		}

		// ASYNC: timeout lets page render before date control receives a mode update
		$timeout(function() {
			$scope.$broadcast('widget.input.date.range.mode', {mode: vm.query.DateRangeMode, keepDates: false});
		}, 100);
	}

	function getDateTypeList(rptType) {
		var defaultDateTypes = [
			{value:'FILL', label:'Fill Date'},
			{value:'MATCH', label:'Matched Date'}
		];
		switch(rptType) {
			case 'ESP':
            case 'TRUZO':
				return defaultDateTypes;
			case 'CMS340B':
				// CMS uses fill (dispense) date only
				return [{value:'FILL', label:'Fill Date'}];
			case 'REB':
				// AUTO adds Payment and Submitted
				if(vm.query.FileType == 'AUTO') {
					defaultDateTypes.push({value:'PAYMENT', label:'Payment Date'});
					defaultDateTypes.push({value:'SUBMITTED', label:'Submitted Date'});
				}
				return defaultDateTypes;
			default:
				throw new Error('Unsupported report type for Claim Submission: ' + rptType);
		}
	}

	function loadFiles() {
		resetConfig();
		asyncFileRefreshList();
	}

	/**
	 *    QUERY: CHANGE
	 */

	function queryChange() {
		if(!vm.init) {
			// reset config aff list on any query change
			resetConfig();
		}
	}

	function queryChangeReportType(rptType) {
		if(vm.isWaiting) {
			return;
		}
		queryChange();
		vm.reportType = rptType;
		tabChange('CREATE');
	}

	function queryChangeFileType(fileType) {
		// REBATE: MANUAL OR AUTO
		if(vm.isWaiting) {
			return;
		}
		queryChange();
		resetQuery(vm.reportType, fileType);
	}

	function queryChangeClaimType(claimType) {
		// REBATE MANUAL: PHARMACY OR MEDICAL
        // ESP / TRUZO FILE TYPE: PHARMACY OR MEDICAL
		if(vm.isWaiting) {
			return;
		}
		queryChange();
		resetQuery(vm.reportType, vm.query.FileType, claimType);
	}

	function queryChangeCE(val) {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.multiselectClick(vm.CeMultiselect, val);
		vm.multiselectTitle(vm.CeMultiselect, true);
		vm.query.CE.fail = vm.CeMultiselect.vals.length < 1 ? 'yes' : 'no';
		if(vm.query.CE.fail == 'yes') {
			vm.query.RX.fail = 'yes';
			return;
		}
		
		// CE change rebuilds RX multiselect options, default to ALL
		var affs = utilSvc.aff.findCeList(getAffs(), multiselectQueryVals(vm.CeMultiselect));
		var rxList = utilSvc.aff.rxList(affs);
		rxList.unshift('ALL');
		vm.RxMultiselect.list = vm.multiselectBuild(rxList, false);

		// default to ALL pharmacies
		multiselectRxClick('ALL');
	}

	function toggleReplenishedOnly() {
		if(vm.isWaiting) {
			return;
		}
		vm.query.ReplenishedOnly = vm.query.ReplenishedOnly == 'no' ? 'yes' : 'no';
	}

	function toggleExtraColumns() {
		if(vm.isWaiting) {
			return;
		}
		vm.query.ExtraColumns = vm.query.ExtraColumns == 'no' ? 'yes' : 'no';
	}

	function toggleRebateInclude(includeType) {
		if(vm.isWaiting) {
			return;
		}
		switch(includeType) {
			case 'PAYMENT':
				vm.query.IncludePayments = vm.query.IncludePayments == 'no' ? 'yes' : 'no';
				break;
			case 'PHARMACY':
				if(!vm.query.hasRxModelDefault) {
					msgSvc.ok('Cannot Include Pharmacy Claims', 'Selected affliations do not support pharmacy business models (CP, CPTPA, SPLITMATCH).');
					return;
				}
				vm.query.IncludePharmacy = vm.query.IncludePharmacy == 'no' ? 'yes' : 'no';
				break;
			case 'MEDICAL':
				if(!vm.query.hasRxModelSplit) {
					msgSvc.ok('Cannot Include Medical Claims', 'Selected affliations do not support SPLIT business model.');
					return;
				}
				vm.query.IncludeMedical = vm.query.IncludeMedical == 'no' ? 'yes' : 'no';
				break;
			default:
				throw new Error('Unsupported include type for Rebate Status File: ' + includeType);
		}
	}

	function toggleFillDateCutoff() {
		if(vm.isWaiting) {
			return;
		}
		if(vm.query.UseFillDateCutoff == 'no') {
			vm.query.UseFillDateCutoff = 'yes';
		}
		else {
			resetFillDateCutoff();
		}
	}

	function resetFillDateCutoff() {
		// reset UI checkbox and dependent property
		vm.query.UseFillDateCutoff = 'no';
		vm.query.FillDateCutoff = {
			val: '',
			fail: 'no',
			msg: 'number between ' + _minFinalCutoff + ' and ' + _maxFinalCutoff
		};
	}

	function dateRangeChange(dtMode, isValid) {
		vm.query.DateRangeMode = dtMode;
		vm.query.DateRangeValid = isValid;
	}



	function asyncFileRefreshList() {
		$timeout(function(){
			$state.go('report.claimsubmission.async-reports', {
				rptType: asyncFileId(vm.reportType),
				query: null
			}, {reload: 'report.claimsubmission.async-reports'});	
		}, 300);
	}

	function queryChangeDateType() {
		if(vm.isWaiting) {
			return;
		}

		// need to reset fill date validation so its not failing and hidden if date type = FILL
		resetFillDateCutoff();
	}

	function multiselectRxClick(val) {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.multiselectClick(vm.RxMultiselect, val);

		// RX required for any report type
		vm.query.RX.fail = vm.RxMultiselect.vals.length > 0 ? 'no' : 'yes';

		// update display title
		vm.multiselectTitle(vm.RxMultiselect, true);

		// keep track of business models possible
		deriveBizModels();

		// re-check include checkboxes
		if(vm.query.FileType == 'AUTO') {
			vm.query.IncludePharmacy = vm.query.IncludePharmacy == 'yes' && vm.query.hasRxModelDefault ? 'yes' : 'no';
			vm.query.IncludeMedical = vm.query.IncludeMedical == 'yes' && vm.query.hasRxModelSplit ? 'yes' : 'no';
		}
	}

	function deriveBizModels() {
		vm.query.hasRxModelDefault = false;
		vm.query.hasRxModelSplit = false;

		var ceVals = multiselectQueryVals(vm.CeMultiselect),
			rxVals = multiselectQueryVals(vm.RxMultiselect);
		if(ceVals.length < 1 || rxVals.length < 1) {
			return;
		}

		// get affs matching CE and RX selections
		var affs = utilSvc.aff.findCeList(getAffs(), ceVals);
		affs = utilSvc.aff.findRxList(affs, rxVals);

		var bizModels = utilSvc.aff.rxModelList(affs);
		vm.query.hasRxModelSplit = bizModels.indexOf('SPLIT') > -1;
		vm.query.hasRxModelDefault = bizModels.indexOf('CP') > -1 ||
			bizModels.indexOf('CPTPA') > -1 ||
			bizModels.indexOf('SPLITMATCH') > -1;
	}

	function multiselectMfrClick(val) {
		if(vm.isWaiting) {
			return;
		}
		vm.multiselectClick(vm.MfrMultiselect, val);

		// Mfr required for any report type
		vm.query.Mfr.fail = vm.MfrMultiselect.vals.length < 1 ? 'yes' : 'no';

		// update display title
		vm.multiselectTitle(vm.MfrMultiselect, true);
	}


	/**
	 *    QUERY SUBMIT
	 */

	function queryValid(q) {
		q.CE.vals = multiselectQueryVals(vm.CeMultiselect);
		q.CE.fail = q.CE.vals.length < 1 ? 'yes' : 'no';
		q.RX.vals = multiselectQueryVals(vm.RxMultiselect);
		q.RX.fail = q.RX.vals.length < 1 ? 'yes' : 'no';

		// conditional validations
		var dateOk = false;
		q.FillDateCutoff.fail = 'no';
		q.ClaimFilterFail = 'no';

		if(vm.reportType == 'ESP' || vm.reportType == 'TRUZO') {
			q.Mfr.vals = multiselectQueryVals(vm.MfrMultiselect); // convert checkmarks and ALL value into MFRIDs array
			q.Mfr.fail = q.Mfr.vals.length < 1 ? 'yes' : 'no';
			dateOk = q.DateRangeValid;

			// match date type could use a fill date cutoff
			if(q.DateType == 'MATCH' && q.UseFillDateCutoff == 'yes') {
				var cutOffValid = false;
				if(validSvc.isInteger(q.FillDateCutoff.val)) {
					var cutOffVal = parseInt(q.FillDateCutoff.val);
					if(cutOffVal >= _minFinalCutoff && cutOffVal <= _maxFinalCutoff) {
						cutOffValid = true; 
					}
				}
				q.FillDateCutoff.fail = cutOffValid ? 'no' : 'yes';
			}
		}
		else if(vm.reportType == 'CMS340B') {
			// CMS 340B Data Repository: CE/RX + standard fill-date range
			q.Mfr.vals = [];
			q.Mfr.fail = 'no';
			dateOk = q.DateRangeValid;
		}
		else {
			// REB file CREATE or CONFIG search
			q.Mfr.vals = [];
			q.Mfr.fail = 'no';
			dateOk = true;
			
			// file CREATE needs extra validation
			if(vm.activeTab == 'CREATE') {
				dateOk = q.DateRangeValid;

				// AUTO uses claim filter
				if(q.FileType == 'AUTO') {
					q.ClaimFilterFail = q.IncludePharmacy != 'yes' && q.IncludeMedical != 'yes' ? 'yes' : 'no'; // 1 required
				}
			}
		}

		return  dateOk &&
			q.CE.fail != 'yes' &&
			q.RX.fail != 'yes' &&
			q.Mfr.fail != 'yes' &&
			q.FillDateCutoff.fail != 'yes' &&
			q.ClaimFilterFail != 'yes';
	}

    /**
     *  TRUZO OPTION
     */

    function reportTypeTitle() {
        switch(vm.reportType) {
            case 'ESP':
                return 'Create ESP Claims File';
            case 'REB':
                return 'Create Beacon Rebate File';
            case 'TRUZO':
                return 'Create Truzo Claims File';
            case 'CMS340B':
                return 'Create CMS 340B Claims Repository File';
            default:
                return '';
        }
    }

	/**
	 *    CREATE FILE
	 */

	function tabChange(tab) {
		if(vm.isWaiting) {
			return;
		}
		vm.activeTab = tab;
		switch(tab) {
			case 'CREATE':
				resetConfig();
				resetQuery(vm.reportType);
				break;
			case 'LIST':
				loadFiles();
				break;
			case 'CONFIG':
				resetConfig();
				resetQuery(vm.reportType);
				break;
            default:
                throw new Error('claimSubCtl.tabChange, unknown tab: ' + tab);
		}
	}

	function createFile() {
		if(vm.isWaiting || vm.activeTab != 'CREATE') {
			return;
		}

		// blob support?
		if (!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		// validate
		if(!queryValid(vm.query)) {
			msgSvc.ok('Cannot Create File', 'Check settings');
			return;
		}

		wait(true);
		
		reportRepo.createAsyncFile(asyncFileRequestVM(vm.query)).then(okServerExcel, errServerExcel);
	}

	function asyncFileId(rptType) {
		switch(rptType) {
			case 'ESP':
				return 'ESP340B';
			case 'TRUZO':
				return 'TRUZO';
			case 'REB':
				return 'CLAIMREBATE';
			case 'CMS340B':
				return 'CMS340B';
			default:
				throw new Error('Unsupported report type for Claim Submission: ' + rptType);
		}
	}

	function asyncFileRequestVM(q) {
		var params = {
			ReportType: '', // see below to derive report type
			DateType: q.DateType,
			StartDate: q.StartDate.val,
			EndDate: q.EndDate.val,
		};

		switch(vm.reportType) {
			case 'ESP':
            case 'TRUZO':
				params.ReportType = vm.reportType == 'ESP' ? 'ESP340B' : 'TRUZO';

				params.Manufacturer = q.Mfr.vals;
				params.ReplenishedOnly = q.ReplenishedOnly == 'yes';
				params.ExtraColumns = vm.reportType == 'ESP' ? q.ExtraColumns == 'yes' : false; // TRUZO is always false

				// extra properties for match fill date cutoff
				if(q.DateType == 'MATCH' && q.UseFillDateCutoff == 'yes') {
					result.Params.UseFillDateCutoff = true;
					result.Params.FillDateCutoff = q.FillDateCutoff.val;
				}

                // set params
                params.IncludePayments = false; // not used for truzo
                params.IncludePharmacy = q.ClaimType == 'PHARMACY';
                params.IncludeMedical = q.ClaimType == 'MEDICAL';
				break;
			case 'REB':
				params.Manufacturer = [];
				params.FileType = q.FileType;
				
				// file type drives claim options
				if(q.FileType == 'MANUAL') {
					params.ReportType = 'CLAIMREBATE_MANUAL';

					// set params
					params.IncludePayments = false; // not used for manual
					params.IncludePharmacy = q.ClaimType == 'PHARMACY';
					params.IncludeMedical = q.ClaimType == 'MEDICAL';
				}
				else {
					params.ReportType = 'CLAIMREBATE';

					// set params
					params.IncludePayments = q.IncludePayments == 'yes';
					params.IncludePharmacy = q.IncludePharmacy == 'yes';
					params.IncludeMedical = q.IncludeMedical == 'yes';
				}
				break;
			case 'CMS340B':
				params.ReportType = 'CMS340B';
				break;

			default:
				throw new Error('Unsupported report type for Claim Submission: ' + vm.reportType);
		}
				
		return {
			Context: {
				CEID: q.CE.vals,
				RXID: q.RX.vals
			},
			Params: params
		};
	}

	function okServerExcel() {
		wait(false);
		tabChange('LIST');
		msgSvc.ok('Excel File Requested', 'Click the LOAD REPORT FILES button to view file status for this Excel Workbook.');
	}

	function errServerExcel(r) {
		wait(false);
		tabChange('LIST');
		if(!!r) {
			errSvc.warn('Create Excel Error', 'claimssub.ServerExcel', r.status, utilSvc.http.safeResponse(r));
		}
	}

	/**
	 *   BEACON AUTO CONFIG
	 */

	function configVM() {
		return {
			enabled: false,
			mode: ''
		};
	}

	function affListVM(data) {
		var items = Array.isArray(data) ? data : [],
			id = 0,
			isPharmacy = vm.query.ClaimType == 'PHARMACY';
		
		items.forEach(function(item){
			item.uniqueId = 'AFF' + (id++);
			item.CEID = item.Ce;
			item.RXID = item.Pharm;
			item.Enabled = !!item.SendEnabled ? 'YES' : 'NO';
			if(isPharmacy) {
				item.Delay = validSvc.isInteger(item.Delay) ? item.Delay : 0;
			}
			else {
				item.Delay = 'n/a';
			}
		});

		return {
			DataItems: items,
			Items: []
		};
	}

	function resetConfig() {
		vm.config.mode = '';
		vm.flt = vm.initFilters({SortBy:['CEID']});
		vm.tbl = affListVM([]);
		editCancel();
		$scope.$broadcast('widget.paging');
	}

	function queryConfigValid(q) {
		q.CE.vals = multiselectQueryVals(vm.CeMultiselect);
		q.CE.fail = q.CE.vals.length < 1 ? 'yes' : 'no';
		q.RX.vals = multiselectQueryVals(vm.RxMultiselect);
		q.RX.fail = q.RX.vals.length < 1 ? 'yes' : 'no';
		return q.CE.fail != 'yes' && q.RX.fail != 'yes';
	}

	function configSearch() {
		if(vm.isWaiting || vm.activeTab != 'CONFIG') {
			return;
		}

		if(!queryConfigValid(vm.query)) {
			msgSvc.ok('Cannot Search', 'Check settings');
			return;
		}
		vm.tbl = affListVM([]);

		wait(true);
		reportRepo.claimSubConfigSearch(vm.reportType, vm.query).then(okConfigSearch, errConfigSearch);

		function okConfigSearch(r) {
			wait(false);
			r = Array.isArray(r) ? r : [];			
			if(r.length < 1) {
				msgSvc.ok('No Affiliations Found', 'Modify search settings');
				return;
			}
			
			vm.tbl = affListVM(r);
			vm.flt.Ready = true;
			filterChange(true);

			vm.config.mode = 'LIST';
		}

		function errConfigSearch(r) {
			wait(false);
			if(!!r) {
				errSvc.warn('Config Search Error', 'claimssub.ConfigSearch', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}


	/**
	 * 	CONFIG AFF LIST FILTER CHANGE
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			vm.tbl.DataItems = Array.isArray(vm.tbl.DataItems) ? vm.tbl.DataItems : [];
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: 'CONFIG',
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			// update edit items if any
			filterChangeEditItems();

		}, delayTime);
	}


	/**
	 *   FLYOUT EDITING
	 */

	function flyoutVM(isOn) {
		return {
			show: !!isOn,
			selectAll: false,
			map:{},
			multi: false,
			title: '',
			Enabled: 'NO',
			Delay: validSvc.newProp(0),
			attest: false,
			attestEmail: '',
			attestEmailConfirm: ''
		};
	}

	function editCancel(attestCancel) {
		if(vm.isWaiting) {
			return;
		}

		// attest cancel returns to previous flyout state
		if(vm.flyout.attest && !!attestCancel) {
			vm.flyout.attest = false;
			return;
		}
		vm.flyout = flyoutVM();
	}

	function editToggleAll() {
		// toggle all filtered items
		if(vm.isWaiting) {
			return;
		}

		// on to off
		if(!!vm.flyout.selectAll) {
			editCancel();
			return;
		}

		// update edit map
		vm.flyout.map = {};
		vm.flyout.selectAll = true;
		vm.flyout.map = buildEditMap(vm.tbl.Items);
		vm.flyout.multi = vm.tbl.Items.length > 1;

		// update the flyout
		var editItems = getEditItems(vm.tbl.Items, vm.flyout.map);
		vm.flyout = refreshFlyout(editItems);
	}

	function buildEditMap(items) {
		var map = {};
		if(!Array.isArray(items)){
			return {};
		}
		items.forEach(function(item){
			map[item.uniqueId] = item.Id;
		});
		return map;
	}

	function getEditIds(map) {
		// parse object map for array of editing Ids
		var items = [];
		for(var prop in map) {
			if(map.hasOwnProperty(prop) && !!map[prop]) {
				items.push(map[prop]); // add Id to list
			}
		}
		return items;
	}

	function getEditItems(items, map) {
		// return full items if they match our map
		var result = [];
		if(!Array.isArray(items) || !!!map) {
			return result;
		}

		items.forEach(function(item){
			if(!!map[item.uniqueId]) {
				result.push(item);
			}
		});

		return result;
	}

	function filterChangeEditItems() {
		// resolve any filtering affects on the edit items

		// not in edit mode, nothing to do
		if(vm.tbl.Items.length < 1) {
			editCancel();
			return;
		}

		// nothing selected
		var editIds = getEditIds(vm.flyout.map);
		if(editIds.length < 1) {
			editCancel();
			return;
		}

		// count number of items still found in map
		var newMap = {},
			mapCount = 0,
			map = vm.flyout.map;
		vm.tbl.Items.forEach(function(item) {
			if(map[item.uniqueId]) {
				newMap[item.uniqueId] = map[item.uniqueId];
				mapCount++;
			}
		});
		
		// all items still in map, no need to refresh flyout
		if(mapCount == editIds.length) {
			return;
		}

		// everything is gone
		if(mapCount < 1) {
			editCancel();
			return;
		}

		// use new map
		vm.flyout.map = newMap;
		vm.flyout.multi = mapCount > 1;

		// update the flyout
		var editItems = getEditItems(vm.tbl.Items, vm.flyout.map);
		vm.flyout = refreshFlyout(editItems);
	}

	function editToggle(item) {
		if(vm.isWaiting || !vm.config.enabled) {
			return;
		}

		// update edit map
		var uniqueId = item.uniqueId, // key for the map
			Id = item.Id; // actual real Id value
		vm.flyout.map[uniqueId] = vm.flyout.map[uniqueId] == Id ? undefined : Id;

		var editIds = getEditIds(vm.flyout.map);
		vm.flyout.selectAll = editIds.length < vm.tbl.Items.length;
		if(editIds.length < 1) {
			editCancel();
			return;
		}
		vm.flyout.multi = editIds.length > 1;

		// update the flyout
		var editItems = getEditItems(vm.tbl.Items, vm.flyout.map);
		vm.flyout = refreshFlyout(editItems);
	}

	function refreshFlyout(editItems) {
		// nothing to edit, close flyout
		if(editItems.length < 1) {
			return flyoutVM();
		}

		// remember previous flyout map
		var enabledTxt = editItems[0].Enabled,
			delay = editItems[0].Delay,
			sameValues = true,
			item = {};

		// reset flyout display (keep filters and sort)
		vm.flyout.show = true;
		vm.flyout.title = vm.reportType == 'ESP' ? 'ESP Auto Submission' : 'Beacon Auto Submission';
		for(var i = 0; i < editItems.length; i++) {
			item = editItems[i];
			if(item.Enabled != enabledTxt || item.Delay != delay) {
				sameValues = false;
				break;
			}
		}

		// set flyout properties
		vm.flyout.Enabled = sameValues ? enabledTxt : 'NO';
		vm.flyout.Delay = validSvc.newProp(sameValues ? delay : 0);

		return vm.flyout;
	}

	function validateFlyoutChanges(fly) {
		// if valid return update object
		var result = {
			CEID: [],
			RXID: [],
			Affs: [],
			Enabled: '',
			Delay: 0,
			valid: false
		};

		var isPharmacy = vm.query.ClaimType == 'PHARMACY';

		// validate delay
		fly.Delay.fail = 'no';
		var delayVal = 0;
		if(isPharmacy) {
			delayVal = validSvc.isInteger(fly.Delay.val) ? parseInt(fly.Delay.val) : -1;
			if(delayVal < 0 || delayVal > 30) {
				fly.Delay.fail = 'yes';
				fly.Delay.msg = 'number between 0 and 30';
				msgSvc.ok('Cannot Save', 'Check properties');
				return result;
			}
		}

		// add values to result
		result.Enabled = fly.Enabled;
		result.Delay = delayVal;

		// get flyout items edited
		var editItems = getEditItems(vm.tbl.Items, vm.flyout.map);
		if(editItems.length < 1) {
			msgSvc.ok('Cannot Save', 'No items selected for edit');
			return result;
		}

		// find changed affiliations
		editItems.forEach(function(item) {
			if(item.Enabled != result.Enabled || (isPharmacy && item.Delay != result.Delay)) {
				// update CEID and RXID lists
				if(result.CEID.indexOf(item.CEID) < 0) {
					result.CEID.push(item.CEID);
				}
				if(result.RXID.indexOf(item.RXID) < 0) {
					result.RXID.push(item.RXID);
				}
				result.Affs.push(item.CEID + '|' + item.RXID);
			}
		});

		// no change
		if(result.Affs.length < 1) {
			var chgTxt = 'All chosen items already have Enabled: ' + result.Enabled;
			if(isPharmacy) {
				chgTxt += ' and Delay: ' + result.Delay;
			}
			msgSvc.ok('No Changes', chgTxt);
			return result;
		}

		// success
		result.valid = true;
		return result;
	}

	function editSubmit() {
		if(vm.isWaiting) {
			return;
		}

		// validate changes
		var configUpdate = validateFlyoutChanges(vm.flyout);
		if(!configUpdate.valid) {
			return;
		}

		// confirm or attest?
		if(!vm.flyout.attest) {
			// show attestation
			vm.flyout.attestEmail = $scope.User.UserName.toLowerCase();
			vm.flyout.attestEmailConfirm = '';
			vm.flyout.attest = true;
			return;
		}

		// validate attestation
		var emailConfirm = validSvc.isText(vm.flyout.attestEmailConfirm) ? vm.flyout.attestEmailConfirm.trim().toLowerCase() : '';
		if(emailConfirm != vm.flyout.attestEmail) {
			msgSvc.ok('Cannot Save', 'Email confirmation does not match: ' + vm.flyout.attestEmail);
			return;
		}

		wait(true);
		reportRepo.claimSubConfigSave(vm.reportType, vm.query.ClaimType, configUpdate).then(okEditConfig, errEditConfig);

		function okEditConfig(r) {
			wait();
			editCancel();
			msgSvc.ok('Configuration Saved', 'Updated ' + configUpdate.Affs.length.toString() + ' affiliations');
			
			// refresh config list
			configSearch();
		}

		function errEditConfig(r) {
			wait();
			if(!!r) {
				errSvc.warn('Cannot Save', 'claimsub.editSubmit', r.status, utilSvc.http.safeResponse(r));
			}
		}
	}


	/**
 	*    MULTISELECT HELPERS
 	*/
	function multiselectCeToggle(evt, id) {
		multiselectToggle(evt, vm.CeMultiselect, id);
	}

	function multiselectRxToggle(evt, id) {
		multiselectToggle(evt, vm.RxMultiselect, id);
	}

	function multiselectMfrToggle(evt, id) {
		multiselectToggle(evt, vm.MfrMultiselect, id);
	}

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if (vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		multiselect.flt = '';

		// don't bother with width if hiding
		if (multiselect.show) {
			multiselect.show = false;
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while (!!elem) {

			// top element found
			if (!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if (minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if (!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;

	}

	function multiselectMouseHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if (!!multiselect.show) {

			if (evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce, 500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for (var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if (multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if (mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if (!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if (debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}

	function multiselectQueryVals(multiselect) {

		// unpack the vals multiselect into a list of entities to query

		var checklist = multiselect.list,
			vals = multiselect.vals;

		if (vals.length < 1) {
			return [];
		}
		else if (vals.length === 1 && vals[0] == 'ALL') {
			// using ALL checkbox, return all values except ALL checkbox
			var result = [],
				i = checklist[0].val == 'ALL' ? 1 : 0;
			for (i; i < checklist.length; i++) {
				result.push(checklist[i].val);
			}
			return result;
		}
		else {
			return vals;
		}
	}


	/**
	 * 	HELPERS
	 */

	function wait(isOn) {
		vm.isWaiting = !!isOn;
		msgSvc.wait(!!isOn);   
	}

}
 
reportFindNpiRepo.$inject = ['$rootScope', '$q', 'apiService', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc'];
angular
.module('espui.report')
.factory('reportFindNpiRepo', reportFindNpiRepo);


/* @ngInject */
function reportFindNpiRepo($rootScope, $q, apiService, errSvc, eventSvc, utilSvc, validSvc) {

	var _currentPurl = '';

	var service = {

		getJobList: getJobList,
		jobCreate: jobCreate,

		getNpiSummary: getNpiSummary,
		getReferrals: getReferrals,

		getExcel: getExcel

	};

	return service;


	/**
	 *    JOB LIST / CREATE
	 */

	function getJobList() {

		var defer = $q.defer();
		_currentPurl = 'reports/findnpis/job/list';

		apiService.post(_currentPurl, {}).then(okGetJobList, errGetJobList);

		function okGetJobList(r) {

			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({
				ApiRxList: r.data.Entity.Pharmacies,
				Jobs: r.data.Entity.Jobs,
				TooMany: r.data.Entity.length > 20000
			});

		}

		function errGetJobList(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function jobCreate(ceid, rxSource, rxVals, startDate, endDate, notes) {

		// params
		if(!validSvc.isCE(ceid) || rxVals.length < 1 || !validSvc.isDate(startDate) || !validSvc.isDate(endDate)) {
			throw new Error('reportFindNpiRepo.jobCreate, CE, RX list, StartDate, EndDate required');
		}
		if(rxSource != 'POOL' && rxSource != 'AFFS') {
			throw new Error('reportFindNpiRepo.jobCreate, rxSource unknown: ' + rxSource);
		}

		_currentPurl = 'reports/findnpis/job/create';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid]
			},
			Params: {
				DispensePoolOnly: rxSource == 'POOL',
				Pharmacies: rxVals,
				StartDate: utilSvc.dt.toServerString(startDate),
				EndDate: utilSvc.dt.toServerString(endDate),
				Notes: notes
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okJobCreate, errJobCreate);

		function okJobCreate(r) {

			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});

		}

		
		function errJobCreate(r) {
			if(r === null) {
				defer.reject(null);
			}
			else if(!!r && r.status === 409) {
				defer.reject(r);
			}
			else {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}			
		}
		
		return defer.promise;

	}


	/**
	 *    NPI SUMMARY
	 */

	function getNpiSummary(ceid) {

		var defer = $q.defer();
		_currentPurl = 'reports/findnpis/summary';

		if(!validSvc.isCE(ceid)) {
			throw new Error('reportFindNpiRepo.getNpiSummary, CEID required');
		}

		var apiRequest = {
			Context: {
				CEID: [ceid]
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okGetNpiSummary, errGetNpiSummary);

		function okGetNpiSummary(r) {

			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errGetNpiSummary(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    REFERRAL LIST
	 */

	function apiDateType(dtType) {
		switch(dtType) {
			case 'Matched Date':
				return 'MATCH';
			case 'Filled Date':
				return 'SERVICE';
			case 'Written Date':
				return 'RXWRITTEN';
			default:
				throw new Error('reportFindNpiRepo.apiDateType, date type unknown: ' + dtType);
		}
	}

	function getReferrals(ceid, ref) {

		// params
		if(!validSvc.isCE(ceid) || !!!ref || ref.npiList.length < 1 || !validSvc.isDate(ref.StartDate.val) || !validSvc.isDate(ref.EndDate.val)) {
			throw new Error('reportFindNpiRepo.getReferrals, CE, npi list, search dates required');
		}

		_currentPurl = 'reports/findnpis/detail';
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: [ceid]
			},
			Params: {
				NPIs: ref.npiList,
				Profitable: ref.Profitable == 'yes',
				DateProperty: apiDateType(ref.DateType),
				StartDate: utilSvc.dt.toServerString(ref.StartDate.val),
				EndDate: utilSvc.dt.toServerString(ref.EndDate.val)
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okGetReferrals, errGetReferrals);

		function okGetReferrals(r) {

			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({
				Items: r.data.Entity,
				TooMany: r.data.Entity.length > 20000
			});

		}

		function errGetReferrals(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 * 	EXCEL
	 */

	function getExcel(tabName, npi, ref, filename) {

		// params
		if(!validSvc.isText(tabName) || !!!npi || !!!ref || !validSvc.isText(filename)) {
			throw new Error('reportFindNpiRepo.getExcel, tab, npi, ref, filename required');
		}

		// build npi list
		var npiList = [];
		for(var i = 0; i < npi.DataItems.length; i++) {
			if(npi.DataItems[i].chk) {
				npiList.push(npi.DataItems[i].NPI);
			}
		}

		var apiRequest = {
			Context: {
				CEID: [npi.CE]
			},
			Params: {
				Summary: tabName == 'NPI',
				NPIs: npiList
			}
		};

		// add ref search props
		if(tabName == 'REF') {
			apiRequest.Params = {
				Profitable: ref.Profitable == 'yes',
				DateProperty: apiDateType(ref.DateType),
				StartDate: utilSvc.dt.toServerString(ref.StartDate.val),
				EndDate: utilSvc.dt.toServerString(ref.EndDate.val)
			};
		}

		var defer = $q.defer();
		_currentPurl = 'reports/findnpis/excel';

		apiService.postGetBinary(_currentPurl, apiRequest).then(okGetExcel, errGetExcel);

		function okGetExcel(r) {
			defer.resolve(r.data);
		}

		function errGetExcel(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


}
 
reportRepo.$inject = ['$rootScope', '$q', 'apiService', 'errSvc', 'eventSvc', 'utilSvc', 'validSvc', 'vmSvc'];
angular
.module('espui.report')
.factory('reportRepo', reportRepo);


/* @ngInject */
function reportRepo($rootScope, $q, apiService, errSvc, eventSvc, utilSvc, validSvc, vmSvc) {

	// private
	var _pending = {},
		_cache = {
			ce: {},
			cesplitsave: {},
			rx: {}
		},
		_apiPaging = vmSvc.api.paging(),
		_modelPending = {},
		_currentPurl = '';

	// service definition
	var service = {

		destroy: destroy,
		destroyCE: destroyCE,
		destroyRX: destroyRX,

		// query
		queryVM: queryVM,
		queryBillingVM: queryBillingVM,
		queryClaimSubmitVM: queryClaimSubmitVM,

		// reports
		getReportData: getReportData,
		tpaReport: tpaReport,
	
		// billing
		getBillRxList: getBillRxList,
		getBillRxDetail: getBillRxDetail,
		getBillRxBacking: getBillRxBacking,
		getBillDeferred: getBillDeferred,
		getBillTrueUp: getBillTrueUp,
		rxRollupInvReportList: rxRollupInvReportList,
		rxRollupInvGetExcel: rxRollupInvGetExcel,
		rxInvoiceDetailGetExcel: rxInvoiceDetailGetExcel,

		// rollup
		rollupSummary: rollupSummary,
		rollupDetail: rollupDetail,

		// split savings
		getSplitSavings: getSplitSavings,
		getSplitSavingsRetail: getSplitSavingsRetail,
		getSplitFinancial: getSplitFinancial,

		// audit
		auditGetFileList: auditGetFileList,
		auditRequestFile: auditRequestFile,
		auditGetExcel: auditGetExcel,
		signPHIAttestation: signPHIAttestation,

		getIndigent: getIndigent,

		// unreplenished
		getUnreplenished: getUnreplenished,

		// wac nuet
		getWacNeut: getWacNeut,
		getWacNeutAffs: getWacNeutAffs,
		wacNeutExcel: wacNeutExcel,
		getWacneutDetail: getWacneutDetail,
		updateWacNeut: updateWacNeut,

		getTimeseries: getTimeseries,
		
		// remittance report
		getRemittance: getRemittance,

		// server excel
		serverExcel: serverExcel,
		rollupExcel: rollupExcel,
		rollupAdminFeesPDF: rollupAdminFeesPDF,
		remittanceExcel:remittanceExcel,
		remittanceExcelDetail:remittanceExcelDetail,
		asyncRxInvoiceReport: asyncRxInvoiceReport,

		// async files
		createAsyncFile: createAsyncFile,
		createCpfrExportJob: createCpfrExportJob,
		getAsyncFiles: getAsyncFiles,
		getAsyncFile: getAsyncFile,

		// claim submissions
		claimSubConfigSearch: claimSubConfigSearch,
		claimSubConfigSave: claimSubConfigSave,
	};

	return service;


	/**
	 *    DESTORY
	 *    release any cached data
	 */

	function destroy() {
		// CE AND RX controllers are destroying their caches directly
		// note: this destroy is call by the main ctl, its not used
	}

	function destroyCE() {

		// CE view is closing, dump its data
		_cache.ce = {};
		_cache.cesplitsave = {};

	}

	function destroyRX() {

		// RX view is closing, dump its data
		_cache.rx = {};

	}


	/**
	 *    QUERY VIEW MODEL
	 *    repo provides all data query for the controller
	 */

	function queryVM(ceid, rxid) {

		return {
			UserType: $rootScope.User.Type,
			ReportType: 'IND',
			CE: validSvc.newProp(validSvc.isText(ceid) ? ceid : $rootScope.User.CE),
			RX: validSvc.newProp(validSvc.isText(rxid) ? rxid : $rootScope.User.RX),
			RxRollup: validSvc.newProp('NONE'),
			DateRange: 'NONE',
			EndDate: validSvc.newPropDateNull(),
			StartDate: validSvc.newPropDateNull(),
			RangeMonth: validSvc.newPropDateNull(),
			RangeYear: validSvc.newPropDateNull(),
			CompareEndDate: validSvc.newPropDateNull(),
			CompareStartDate: validSvc.newPropDateNull(),
			CompareQuarter: validSvc.newProp(''),
			ExcludeUnaffils: false,
			FetchByImpDate: false,
			
		};

	}

	/**
	 *    QUERY VIEW MODEL FOR CLAIM SUBMISSION
	 */

	 function queryClaimSubmitVM() {

		return {
			CE: validSvc.newProp(),
			RX: validSvc.newProp(), // not using "val", multiselect loads into "vals"
			Mfr: validSvc.newProp('NONE'),
			DateType: 'FILL',
			StartDate: validSvc.newPropDateNull(),
			EndDate: validSvc.newPropDateNull(),	
			ReplenishedOnly: 'no',
			ExtraColumns: 'yes',
			UseFillDateCutoff: 'no',
			FillDateCutoff: validSvc.newProp(''),
		};

	}


	/**
	 *    QUERY FOR BILLING
	 */

	function queryBillingVM() {

		// user has access to RX Rollup reports?
		var qvm = queryVM();
		qvm.UserHasRxRollup = utilSvc.user.hasFeature($rootScope, 'report.rx.rollup');

		return qvm;

	}


	/**
	 *    GET REPORT DATA
	 *    both CE and RX share this function
	 */

	function getReportData(rptType, tabName, query, useCache) {

		// params
		if((rptType != 'ce' && rptType != 'rx' && rptType != 'cp') || !validSvc.isText(tabName) || !queryDatesValid(query)) {
			throw new Error('reportRepo.getReportData, query is not valid for tab: ' + tabName);
		}

		var defer = $q.defer();

		// using cache?
		if(!!useCache && !!_cache[rptType][tabName]) {
            var derefList = JSON.parse(JSON.stringify(_cache[rptType][tabName])); // de-ref the cache
			defer.resolve(derefList);
			return defer.promise;
		}

		// setup pending request info
		_pending = {
			type: rptType,
			tab: tabName,
			purl: '',
			sortBy: '',
			CE: query.CE.vals.length === 1 ? '' : query.CE.vals[0],
			RX: query.RX.vals.length === 1 ? '' : query.RX.vals[0]
		};

		// dates
		var dtStart = query.StartDate.val,
			dtEnd = query.EndDate.val;

		// add purl and sortBy
		switch(tabName) {

			case 'SUMMARY':
				_pending.purl = 'reports/' + rptType + '/summary';
				_pending.sortBy = 'Summary';
				break;
			case 'FIN_SUMMARY':
				_pending.purl = 'reports/cp/summary';
				_pending.sortBy = 'Summary';
				break;

			case 'COMPARE':
				_pending.purl = 'reports/' + rptType + '/summary';
				_pending.sortBy = 'Summary';
				dtStart = query.CompareStartDate.val;
				dtEnd = query.CompareEndDate.val;
				break;

			case 'ORDER':
				_pending.purl = 'reports/' + rptType + '/orders';
				_pending.sortBy = 'OrderDate';
				break;

			case 'FIN_ORDER':
				_pending.purl = 'reports/cp/orders';
				_pending.sortBy = 'OrderDate';
				break;

			case 'FIN_INVOICES':
				_pending.purl = 'reports/cp/invoices';
				_pending.sortBy = 'OrderDate';
				break;

			case 'FIN_INVOICE_ITEMS':
				_pending.purl = 'reports/cp/invoiceitems';
				_pending.sortBy = 'InvoiceDate';
				break;
	
			case 'INVOICE':
				_pending.purl = 'reports/' + rptType + '/invoices';
				_pending.sortBy = 'InvoiceDate';
				break;

			case 'DISP':
				_pending.purl = 'reports/' + rptType + '/orderdispenses';
				_pending.sortBy = 'InvoiceDate';
				break;

			case 'FIN_DISP':
				_pending.purl = 'reports/cp/usedinorders';
				_pending.sortBy = 'InvoiceDate';
				break;

			case 'FIN_TPA_CLAIMS':
				_pending.purl = 'reports/cp/tpainvoicedclaims';
				_pending.sortBy = 'InvoiceDate';
				break;

			case 'FIN_PAYMENTS':
				_pending.purl = 'reports/cp/payments';
				_pending.sortBy = 'PaymentDate';
				break;
	
			case 'COR':
				_pending.purl = 'reports/' + rptType + '/corrections';
				_pending.sortBy = 'InvoiceDate';
				break;

			default:
				throw new Error('reportRepo.getReportData, tab name unknown: ' + tabName);
		}

		var apiRequest = {
			Context: {
				CEID: query.CE.vals,
				RXID: query.RX.vals
			},
			Params: {
				StartDate: dtStart,
				EndDate: dtEnd,
				AccGrps: query.Acct == 'ALL' ? [] : [query.Acct],
				ExcludeUnaffils: query.ExcludeUnaffils,
				FetchByImpDate: query.FetchByImpDate,
                RxModels: query.rxModels, // cpfin needs to send this
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle(_pending.sortBy)]
		};

		apiService.post(_pending.purl, apiRequest).then(getOk, getErr);

		function getOk(r) {

			// SUMMARY is an Entity, not a list
			if(_pending.tab == 'SUMMARY' || _pending.tab == 'FIN_SUMMARY' || _pending.tab == 'COMPARE') {

				// bad "Get One" response format
				if(!validSvc.httpGetOneResp(r)) {
					errSvc.warn('Bad 200 api response format', _pending.purl + 'repo', '', utilSvc.http.safeResponse(r));
					defer.reject(null);
					return;
				}

				if((_pending.tab == 'SUMMARY' || _pending.tab == 'FIN_SUMMARY') && !!_pending.CE && !!_pending.RX) {
					// update CE and Rx user choice
					eventSvc.rootEmit('context.change', {
						CE: _pending.CE,
						RX: _pending.RX
					});

					// reset cache on summary ok
					_cache[_pending.type][_pending.tab] = r.data.Entity;
				}

				defer.resolve(r.data.Entity);

			}
			else {

				// bad "Get List" response format
				if(!validSvc.httpGetListResp(r)) {
					errSvc.warn('Bad 200 api response format', _pending.purl + 'repo', '', utilSvc.http.safeResponse(r));
					defer.reject(null);
					return;
				}

				// api fix: cut down rows returned
				if(Array.isArray(r.data.Entity) && r.data.Entity.length > _apiPaging.Size + 1) {
					r.data.Entity.splice(_apiPaging.Size + 1, r.data.Entity.length); // any number greater than array length
				}

				// build result
				var listResult = {
					Items: r.data.Entity,
					TooMany: r.data.Paging.Size > _apiPaging.Size,
					SortBy: _pending.sortBy
				};

				// add result to cache and return it
				_cache[_pending.type][_pending.tab] = listResult;
                var derefList = JSON.parse(JSON.stringify(listResult)); // de-ref the cache
				defer.resolve(derefList);

			}

		}

		function getErr(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _pending.purl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    SPLIT SAVINGS
	 */

	function getSplitSavings(tabName, query, isCompare) {

		// params
		if(query.CE.vals.length < 1 || query.RX.vals.length < 1 || !queryDatesValid(query)) {
			throw new Error('reportRepo.getSplitSavings, query is not valid');
		}

		var defer = $q.defer();
		_pending = {
			purl: tabName == 'SUMMARY' ? 'reports/splitsavings/summary' : 'reports/splitsavings/get',
			CE: query.CE.vals.length === 1 ? query.CE.vals[0] : '',
			RX: query.RX.vals.length === 1 ? query.RX.vals[0] : '',
		};

		// create api request
		var apiRequest = {
			Context: {
				CEID: query.CE.vals,
				RXID: query.RX.vals
			},
			Params: {
				StartDate: !!isCompare ? query.CompareStartDate.val : query.StartDate.val,
				EndDate: !!isCompare ? query.CompareEndDate.val : query.EndDate.val
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('InvoiceDate')]
		};

		// call api
		apiService.post(_pending.purl, apiRequest).then(okGetSavings, errGetSavings);

		function okGetSavings(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _pending.purl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update CE and Rx user choice (if only 1 CE / RX selected)
			if(validSvc.isText(_pending.CE) && validSvc.isText(_pending.RX)) {
				eventSvc.rootEmit('context.change', {
					CE: _pending.CE,
					RX: _pending.RX
				});
			}

			var items = Array.isArray(r.data.Entity.Items) ? r.data.Entity.Items : [];

			defer.resolve({
				data: r.data.Entity,
				tooMany: items.length > 20000
			});

		}

		function errGetSavings(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _pending.purl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	function getSplitSavingsRetail(tabName, query, isCompare) {

		// params
		if(query.CE.vals.length < 1 || query.RX.vals.length < 1 || !queryDatesValid(query)) {
			throw new Error('reportRepo.getSplitSavingsRetail, query is not valid');
		}

		var defer = $q.defer();
		_pending = {
			tab: tabName,
			purl: 'reports/splitsavings/splitmatch/',
			CE: query.CE.vals.length === 1 ? query.CE.vals[0] : '',
			RX: query.RX.vals.length === 1 ? query.RX.vals[0] : '',
		};

		var sortby = '';
		switch(tabName) {
			case 'SUMMARY':
				_pending.purl += 'summary';
				sortby = 'SUMMARY';
				break;
			case 'INVOICES':
				_pending.purl += 'invoices';
				sortby = 'InvoiceDate';
				break;
			case 'INVDETAIL':
				_pending.purl += 'invdetail';
				sortby = 'InvoiceDate';
				break;

			case 'CLAIMS':
				_pending.purl += 'claims';
				sortby = 'InvoiceDate';
				break;
			case 'FEES':
				_pending.purl += 'fees';
				sortby = 'InvoiceDate';
				break;
			default:
				throw new Error('reportRepo.getSplitSavingsRetail, unknown tab name: ' + tabName);
		}

		// create api request
		var apiRequest = {
			Context: {
				CEID: query.CE.vals,
				RXID: query.RX.vals
			},
			Params: {
				StartDate: !!isCompare ? query.CompareStartDate.val : query.StartDate.val,
				EndDate: !!isCompare ? query.CompareEndDate.val : query.EndDate.val
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle(sortby)]
		};

		// call api
		apiService.post(_pending.purl, apiRequest).then(okGetSavingsRetail, errGetSavingsRetail);

		function okGetSavingsRetail(r) {

			// bad api response format
			if((_pending.tab == 'SUMMARY' && !validSvc.httpGetOneResp(r)) || (_pending.tab != 'SUMMARY' && !validSvc.httpGetListResp(r))) {
				errSvc.warn('Bad 200 api response format', _pending.purl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update CE and Rx user choice (if only 1 CE / RX selected)
			if(validSvc.isText(_pending.CE) && validSvc.isText(_pending.RX)) {
				eventSvc.rootEmit('context.change', {
					CE: _pending.CE,
					RX: _pending.RX
				});
			}

			if(_pending.tab == 'SUMMARY') {
				defer.resolve(r.data.Entity);
			}
			else {
				var items = Array.isArray(r.data.Entity) ? r.data.Entity : [];
				defer.resolve({
					data: items,
					tooMany: items.length > 20000
				});
			}

		}

		function errGetSavingsRetail(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _pending.purl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function getSplitFinancial(tabName, query, isCompare) {

		// params
		if(query.CE.vals.length < 1 || query.RX.vals.length < 1 || !queryDatesValid(query)) {
			throw new Error('reportRepo.getSplitFinancial, query is not valid');
		}

		var defer = $q.defer();
		_pending = {
			tab: tabName,
			purl: 'reports/splitfin/',
			CE: query.CE.vals.length === 1 ? query.CE.vals[0] : '',
			RX: query.RX.vals.length === 1 ? query.RX.vals[0] : '',
		};

		var sortby = '';
		switch(tabName) {
			case 'SUMMARY':
				_pending.purl += 'summary';
				sortby = 'SUMMARY';
				break;
			case 'SAVINGS':
				_pending.purl += 'featuresavings';
				sortby = 'OrderDate';
				break;
			case 'INVOICES':
				_pending.purl += 'invoices';
				sortby = 'InvoiceDate';
				break;
			case 'INVDETAIL':
				_pending.purl += 'invdetail';
				sortby = 'InvoiceDate';
				break;
			case 'RETAILCLAIMS':
				_pending.purl += 'retailclaims';
				sortby = 'InvoiceDate';
				break;
			case 'FEES':
				_pending.purl += 'fees';
				sortby = 'InvoiceDate';
				break;
			default:
				throw new Error('reportRepo.getSplitFinancial, unknown tab name: ' + tabName);
		}

		// create api request
		var apiRequest = {
			Context: {
				CEID: query.CE.vals,
				RXID: query.RX.vals
			},
			Params: {
				StartDate: !!isCompare ? query.CompareStartDate.val : query.StartDate.val,
				EndDate: !!isCompare ? query.CompareEndDate.val : query.EndDate.val
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle(sortby)]
		};

		// call api
		apiService.post(_pending.purl, apiRequest).then(okGetSplitFinancial, errGetSplitFinancial);

		function okGetSplitFinancial(r) {

			// bad api response format
			if((_pending.tab == 'SUMMARY' && !validSvc.httpGetOneResp(r)) || (_pending.tab != 'SUMMARY' && !validSvc.httpGetListResp(r))) {
				errSvc.warn('Bad 200 api response format', _pending.purl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update CE and Rx user choice (if only 1 CE / RX selected)
			if(validSvc.isText(_pending.CE) && validSvc.isText(_pending.RX)) {
				eventSvc.rootEmit('context.change', {
					CE: _pending.CE,
					RX: _pending.RX
				});
			}

			if(_pending.tab == 'SUMMARY') {
				defer.resolve(r.data.Entity);
			}
			else {
				var items = Array.isArray(r.data.Entity) ? r.data.Entity : [];

				// cut off items if too many
				var tooMany = items.length > 20000;
				if(tooMany) {
					items = items.slice(0, 20000);
				}
				
				defer.resolve({
					data: items,
					tooMany: tooMany
				});
			}

		}

		function errGetSplitFinancial(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _pending.purl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    GET BILLING RX LIST
	 *    called by report.rx feature for RX types: DISPENSING or CENTRALFILL
	 */

	function getBillRxList(query) {

		// params
		if(query.CE.vals.length < 1 || query.RX.vals.length < 1 || !queryDatesValid(query)) {
			throw new Error('reportRepo.getBillRxList, query is not valid');
		}

		_currentPurl = 'reports/rx/billing/list';
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: query.CE.vals,
				RXID: query.RX.vals
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('-BillDate')]
		};

		eventSvc.rootEmit('context.change', {
			RX: query.RX.vals.length === 1 ? query.RX.vals[0] : '',
			CE: query.CE.vals.length === 1 ? query.CE.vals[0] : ''
		});

		apiService.post(_currentPurl, apiRequest).then(getListOk, getListErr);

		function getListOk(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({
				data: r.data.Entity,
				tooMany: r.data.Entity.length > _apiPaging.Size
			});

		}

		function getListErr(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    GET BILLING RX DETAIL
	 *    called by report.rxdetail for RX types: DISPENSING or CENTRAL FILL
	 */

	function getBillRxDetail(id) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('reportRepo.getBillRxDetail, id is missing: ' + id);
		}

		_currentPurl = 'reports/rx/billing/get';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Entity: {
				Context: {},
				Params: {
					Id: id
				}
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okGetDetail, errGetDetail);

		function okGetDetail(r) {

			// api fix: null items array
			if(!!r && !!r.data && !!r.Entity && !Array.isArray(r.data.Entity.Items)) {
				r.data.Entity.Items = [];
			}

			// bad response format
			if(!!!r || isNaN(r.status) || !!!r.data || !!!r.data.Entity) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errGetDetail(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    GET BILLING RX BACKING DETAIL
	 */
	 function getBillRxBacking(lineId) {

		// params
		if(!validSvc.isText(lineId)) {
			throw new Error('reportRepo.getBillRxBacking, line id required');
		}

		_currentPurl = 'reports/rx/billing/backing';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Params: {
				LineId: lineId
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(getOk, getErr);


		function getOk(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function getErr(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	
	/**
	 *    CREATE EXCEL FOR RX INVOICE DETAIL REPORT WITH BACKING DETAILS - INDIVIDUAL
	 */
	
	function rxInvoiceDetailGetExcel(id, filename) {

		// params
		if(!validSvc.isText(id) || !validSvc.isText(filename)) {
			throw new Error('reportRepo.rxInvoiceDetailGetExcel: id and file name are required');
		}
	
		_currentPurl = 'reports/rx/billing/detail/excel';    // need to have this endpoint in billing
		var defer = $q.defer();
	
		// create api request
		var apiRequest = {
			Params: {
				Id: id
			}
		};
	
		// call api
		apiService.postGetBinary(_currentPurl, apiRequest).then(okInvDetailExcel, errInvDetailExcel);
	
		function okInvDetailExcel(r) {
			defer.resolve(r.data);
		}
		
		function errInvDetailExcel(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}
	
		return defer.promise;
	}
	

	/**
	 *    GET BILLING DEFERRED ITEMS
	 */

	function getBillDeferred(query) {

		var ceid = [],
			rxid = [];

		switch(query.ReportType) {

			case 'IND':
				ceid = query.CE.vals;
				rxid = query.RX.vals;
				_currentPurl = 'reports/rx/billing/deferred';
				break;

			case 'ROLLUP':
				rxid.push(query.RxRollup.val);
				_currentPurl = 'reports/rx/rollup/deferred';
				break;

			default:
				throw new Error('reportRepo.getBillDeferred, report type unknown: ' + query.ReportType);
		}

		var apiRequest = {
			Context: {
				CEID: ceid,
				RXID: rxid
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('VendorShipDate')]
		};

		var defer = $q.defer();
		apiService.post(_currentPurl, apiRequest).then(okGetDeferred, errGetDeferred);

		function okGetDeferred(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({
				data: r.data.Entity,
				tooMany: r.data.Entity.length > _apiPaging.Size
			});

		}

		function errGetDeferred(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	/**
	 *    GET BILLING TRUE UP ITEMS
	 */

	function getBillTrueUp(query) {

		_currentPurl = 'reports/rx/rollup/trueup'; // deferred
		var apiRequest = {
			Context: {
				RXID: [query.RxRollup.val]
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val
			},
			Paging: _apiPaging
		};

		var defer = $q.defer();
		apiService.post(_currentPurl, apiRequest).then(okTrueUp, errTrueUp);

		function okTrueUp(r) {
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			var items = r.data.Entity || [];
			defer.resolve({
				data: items,
				tooMany: items.length > _apiPaging.Size
			});
		}

		function errTrueUp(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + ' repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    ROLLUP SUMMARY
	 */

	function rollupSummary(query) {

		// params
		if(!rxRollupQueryValid(query)) {
			throw new Error('reportRepo.rollupSummary, query is not valid');
		}

		_currentPurl = 'reports/rx/rollup/summary';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				RXID: [query.RxRollup.val]
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('RxRollSummary')]
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okRollSum, errRollSum);

		function okRollSum(r) {

			// bad response format
			if(!!!r || isNaN(r.status) || !!!r.data || !!!r.data.Entity || !Array.isArray(r.data.Entity.Items)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errRollSum(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    ROLLUP DETAIL
	 */

	function rollupDetail(query) {

		// params
		if(!rxRollupQueryValid(query)) {
			throw new Error('reportRepo.rollupDetail, query is not valid');
		}

		_currentPurl = 'reports/rx/rollup/detail';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				RXID: [query.RxRollup.val]
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('RxRollDetail')]
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okRollDetail, errRollDetail);

		function okRollDetail(r) {

			// bad response format
			if(!!!r || isNaN(r.status) || !!!r.data || !!!r.data.Entity || !Array.isArray(r.data.Entity.CEDetails)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errRollDetail(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *	ASYNC PHARMACY INVOICE
	 */

	function asyncRxInvoiceReport(query) {

		// params
		if(!rxRollupQueryValid(query)) {
			throw new Error('reportRepo.rxInvoiceReport, query is not valid');
		}

		_currentPurl = 'reports/rx/rollup/excelasync'; //'reports/rx/invoicereport';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				RXID: [query.RxRollup.val]
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val
			},
			//Paging: _apiPaging,
			//SortBy: [utilSvc.sorting.sortByApiStyle('RxRollSummary')]
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okRxInv, errRxInv);

		function okRxInv(r) {

			// bad response format
			
			if(!!!r || isNaN(r.status) || !!!r.data || !!!r.data.Entity) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}
			
			defer.resolve(r.data.Entity);

		}

		function errRxInv(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	/**
	 *    TPA REPORT
	 */

	function tpaReport(tabName, query) {

		_pending = {
			tab: tabName,
			purl: 'reports/tpa/',
			CE: '',
			RX: ''
		};

		// params
		if(tabName == 'INVRELATED') {
			_pending.CE = query.CE;
			_pending.RX = query.RX;
		}
		else if(!validSvc.isCE(query.CE.val) || (!validSvc.isRX(query.RX.val) && !validSvc.isRX(query.RxRollup.val))) {
			throw new Error('reportRepo.tpaReport, CE and RX or RxRollup required');
		}
		else {
			_pending.CE = query.CE.val;
			_pending.RX = query.ReportType == 'IND' ? query.RX.val : query.RxRollup.val;
		}

		var defer = $q.defer();

		switch(tabName) {
			case 'INVOICES':
				_pending.purl += 'invoices';
				break;
			case 'INVRELATED':
				_pending.purl += 'invoices/related';
				break;
			case 'ADJUSTMENTS':
				_pending.purl += 'adjustments';
				break;
			case 'SENTMATCH':
				_pending.purl += 'sentmatches';
				break;
			default:
				throw new Error('reportRepo.tpaReport, unknown tabName: ' + tabName);
		}

		var apiRequest = {
			Context: {
				CEID: [_pending.CE],
				RXID: [_pending.RX]
			},
			Paging: {
				Size: 20000
			},
			SortBy: [utilSvc.sorting.sortByApiStyle('ImportedDate')]
		};

		if(tabName == 'INVRELATED') {
			apiRequest.Params = {
				RxNumber: query.RxNumber,
				FillNumber: query.FillNumber
			};
		}
		else {
			apiRequest.Params = {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				RxNumber: validSvc.isText(query.RxNumber.val) ? query.RxNumber.val : ''
			};
		}

		apiService.post(_pending.purl, apiRequest).then(okTpaReport, errTpaReport);

		function okTpaReport(r) {

			// update CE and Rx user choice
			if(_pending.tab != 'INVRELATED') {
				eventSvc.rootEmit('context.change', {
					CE: _pending.CE,
					RX: _pending.RX
				});
			}

			switch(_pending.tab) {

				case 'INVOICES':
				case 'INVRELATED':
				case 'ADJUSTMENTS':
					// two tabs use same viewmodel
					if(!validSvc.httpGetOneResp(r)) {
						// bad "Get One" response format
						errSvc.warn('Bad 200 api response format', _pending.purl + 'repo', '', utilSvc.http.safeResponse(r));
						defer.reject(null);
						return;
					}

					var ent = r.data.Entity;
					if(_pending.tab == 'INVOICES' || _pending.tab == 'INVRELATED') {
						ent.Items = Array.isArray(ent.Items) ? ent.Items : [];
						defer.resolve({
							Summary: ent.InvoicesSummary,
							Items: ent.Items,
							TooMany: ent.Items.length > 20000
						});
					}
					else {
						ent.Adjustments = Array.isArray(ent.Adjustments) ? ent.Adjustments : [];
						defer.resolve({
							Summary: ent.AdjustmentsSummary,
							Items: ent.Adjustments,
							TooMany: ent.Adjustments.length > 20000
						});
					}
					break;

				case 'SENTMATCH':
					// uses list only, no summary in data
					if(!validSvc.httpGetListResp(r)) {
						// bad "Get List" response format
						errSvc.warn('Bad 200 api response format', _pending.purl + 'repo', '', utilSvc.http.safeResponse(r));
						defer.reject(null);
						return;
					}

					var items = r.data.Entity;
					items = Array.isArray(items) ? items : [];
					defer.resolve({
						Summary: {}, // add blank summary to simplify data return for controller
						Items: items,
						TooMany: items.length > 20000
					});
					break;

				default:
					throw new Error('reportRepo.tpaReport, unknown pending tab: ' + _pending.tab);
			}

		}

		function errTpaReport(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _pending.purl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    AUDIT GET FILE LIST
	 */

	function auditGetFileList(ceid) {

		// params
		if(!validSvc.isCE(ceid)) {
			throw new Error('reportRepo.auditGetFileList, ceid required');
		}

		_currentPurl = 'audit/list';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid]
			}
		};

		eventSvc.rootEmit('context.change', {
			CE: ceid
		});

		// call api
		apiService.post(_currentPurl, apiRequest).then(okGetAuditList, errGetAuditList);

		function okGetAuditList(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errGetAuditList(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    AUDIT REQUEST NEW FILE
	 */

	function auditRequestFile(query) {

		// params
		if(!!!query || !validSvc.isCE(query.CE.val) || !validSvc.isDate(query.StartDate.val) || !validSvc.isDate(query.EndDate.val)) {
			throw new Error('reportRepo.auditGetFileList, CE, StartDate, EndDate required');
		}

		_currentPurl = 'audit/create';
		// use audit phi endpoint if include phi is yes
		if (query.IncludePHI == 'yes') {
			_currentPurl = 'audit/create/phi';
		}

		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [query.CE.val],
				RXID: query.RxList
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				Sample: query.Sample == 'yes',
				SampleSize: parseInt(query.SampleSize.val),
				SplitBill: query.SplitBill == 'yes',
				SplitBillAddGPO: query.SplitBillAddGPO == 'yes',
				SplitBillAddAlwaysNeverNDC: query.SplitBillAddAlwaysNeverNDC == 'yes',
				Contract: query.Contract == 'yes',
				ContractAddNeverOrderNDC: query.ContractAddNeverOrderNDC == 'yes',
				FromPSA: query.FromPSA == 'yes',
				ContractIncludeGenerics: query.ContractIncludeGenerics == 'yes',
				ContractIncludeCII: query.ContractIncludeCII == 'yes',
				Notes: query.Notes == 'yes',
				Non340bDrugs: query.Non340bDrugs == 'yes'
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okAuditFileRequest, errAuditFileRequest);

		function okAuditFileRequest(r) {
			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errAuditFileRequest(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 *    SERVER EXCEL
	 *    file created on api server, expecting a binary file stream instead of JSON
	 */

	function serverExcel(rptType, query, filename) {

		// params
		if(!validSvc.isText(rptType) || !!!query || !validSvc.isText(filename)) {
			throw new Error('reportRepo.rollupExcel, rpt type, query and filename are required for rpt type: ' + rptType);
		}

		var defer = $q.defer();
		var ceList = [],
			rxList = [];

		switch(rptType) {

			case 'CE':
				_currentPurl = 'reports/ce/excel';
				ceList = query.CE.vals;
				rxList = query.RX.vals;
				break;

			case 'FIN':
				_currentPurl = 'reports/cp/excel';
				ceList = query.CE.vals;
				rxList = query.RX.vals;
				break;
	
			case 'CE-COMPARE':
				_currentPurl = 'reports/ce/summary/compare/excel';
				ceList = query.CE.vals;
				rxList = query.RX.vals;
				break;

			case 'FIN-COMPARE':
				_currentPurl = 'reports/cp/summary/compare/excel';
				ceList = query.CE.vals;
				rxList = query.RX.vals;
				break;
	
			case 'CE-TIMESERIES':
				_currentPurl = query.tsxl.subtype == 'FIN' ? 'reports/ce/summary/series/excel' : 'reports/matchstats/series/excel';
				ceList = query.CE.vals;
				rxList = query.RX.vals;
				break;

			case 'CP-TIMESERIES':
				_currentPurl = 'reports/cp/summary/series/excel';
				ceList = query.CE.vals;
				rxList = query.RX.vals;
				break;
	
			case 'RX-TIMESERIES':
				_currentPurl = query.tsxl.subtype == 'FIN' ? 'reports/rx/summary/series/excel' : 'reports/matchstats/series/excel';
				ceList = query.CE.vals;
				rxList = query.RX.vals;
				break;

			case 'MATCH-TIMESERIES':
				_currentPurl = 'reports/matchstats/series/excel';
				ceList = query.primeProp == 'CE' ? [query.Primary.val] : query.Secondary.val;
				rxList = query.primeProp == 'RX' ? [query.Primary.val] : query.Secondary.val;
				break;
	
			case 'RX':
				_currentPurl = 'reports/rx/excel';
				ceList = query.CE.vals;
				rxList = query.RX.vals;
				break;

			case 'RX-COMPARE':
				_currentPurl = 'reports/rx/summary/compare/excel';
				ceList = query.CE.vals;
				rxList = query.RX.vals;
				break;

			case 'SPLITSAVE':
				_currentPurl = 'reports/splitsavings/excel';
				ceList = query.CE.vals;
				rxList = query.RX.vals;
				break;

			case 'SPLITFIN':
			case 'SPLITFIN-COMPARE':
				_currentPurl = rptType == 'SPLITFIN' ? 'reports/splitfin/excel' : 'reports/splitfin/compare/excel';
				ceList = query.CE.vals;
				rxList = query.RX.vals;
				break;
	
			case 'SPLITSAVE-RETAIL':
				_currentPurl = 'reports/splitsavings/splitmatch/excel';
				ceList = query.CE.vals;
				rxList = query.RX.vals;
				break;

			case 'SPLITSAVE-COMPARE':
				_currentPurl = 'reports/splitsavings/compare/excel';
				ceList = query.CE.vals;
				rxList = query.RX.vals;
				break;

			case 'SPLITSAVE-COMPARE-RETAIL':
				_currentPurl = 'reports/splitsavings/splitmatch/compare/excel';
				ceList = query.CE.vals;
				rxList = query.RX.vals;
				break;

			case 'INDIGENT':
				_currentPurl = 'reports/indigent/excel';
				ceList.push(query.CE.val);
				rxList.push(query.RX.val);
				break;

			case 'WACNEUT':
				_currentPurl = 'reports/wacneut/excel';
				ceList = query.CE.vals;
				rxList = query.RX.vals;
				break;

			case 'UNREPLENISHED':
				_currentPurl = 'reports/unreplenished/excel';
				if (query.ReportType == 'ROLLUP') {
					rxList.push(query.RxRollup.val);
				} else {
					rxList = query.RX.vals;
				}
				break;

			default:
				throw new Error('reportRepo.serverExcel, rptType unknown: ' + rptType);

		}

		var apiRequest = {
			Context: {
				CEID: ceList,
				RXID: rxList
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				Filename: filename,
				AccGrps: query.Acct == 'ALL' ? [] : [query.Acct],
				ExcludeUnaffils: query.ExcludeUnaffils,
				FetchByImpDate: query.FetchByImpDate,
                RxModels: query.rxModels, // cpfin needs to send this
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('ServerExcel')]
		};

		switch(rptType) {

			case 'CE-COMPARE':
			case 'RX-COMPARE':
			case 'FIN-COMPARE':
			case 'SPLITSAVE-COMPARE':
			case 'SPLITSAVE-COMPARE-RETAIL':
				// add second date range for comparison
				apiRequest.Params.CompareStartDate = query.CompareStartDate.val;
				apiRequest.Params.CompareEndDate = query.CompareEndDate.val;
				break;

			case 'CE-TIMESERIES':
			case 'CP-TIMESERIES':
			case 'RX-TIMESERIES':
			case 'MATCH-TIMESERIES':
				// add timeseries params
				var ts = query.tsxl;
				apiRequest.Params.Type = ts.type;
				apiRequest.Params.IntervalType = ts.interval;
				apiRequest.Params.Metric = ts.type == 'METRIC' ? ts.metric : '';
				apiRequest.Params.ReportType = rptType == 'MATCH-TIMESERIES' ? 'CE' : rptType.substr(0, 2); // use CE report for ops match stats timeseries
				break;

			case 'TPA-SENTMATCH':
				// add tpa rx number
				if(validSvc.isText(query.RxNumber.val)) {
					apiRequest.Params.RxNumber = query.RxNumber.val;
				}
				break;
			case 'UNREPLENISHED':
				apiRequest.Context.VENID = query.Vendor.val == 'NONE' ? [] : [query.Vendor.val];
				apiRequest.Context.CEID = query.CE.val == 'NONE' || query.CE.val == 'ALL' ? [] : [query.CE.val];
				apiRequest.Params.Ndc = query.NDC.val;
				apiRequest.Params.Tpa = query.ProgramAdmin.val == 'NONE' ? '' : query.ProgramAdmin.val;
				apiRequest.Params.Specialty = query.Specialty.val;
				break;
		}

		apiService.postGetBinary(_currentPurl, apiRequest).then(okServerExcel, errServerExcel);

		function okServerExcel(r) {
			defer.resolve(r.data);
		}

		function errServerExcel(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	/**
	 *    RX ROLLUP INVOICE REPORT GET FILE LIST
	 */

	 function rxRollupInvReportList(rxid) {

		// params
		if(!validSvc.isRX(rxid)) {
			throw new Error('reportRepo.rxRollupInvReportList, rxid required');
		}

		_currentPurl = 'reports/rx/rollup/excellist';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				RXID: [rxid]
			}
		};

		eventSvc.rootEmit('context.change', {
			RX: rxid
		});

		// call api
		apiService.post(_currentPurl, apiRequest).then(okGetRxInvList, errGetRxInvList);

		function okGetRxInvList(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errGetRxInvList(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *  ASYNC RX EXCEL
	 */
	function rxRollupInvGetExcel(rxid, id) {

		// params
		if(!validSvc.isRX(rxid) || !validSvc.isText(id)) {
			throw new Error('reportRepo.rxRollupInvGetExcel, RX and id required');
		}

		_currentPurl = 'reports/rx/rollup/excelget';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				RXID: [rxid]
			},
			Params: {
				Filename: id
			}
		};

		// call api
		apiService.postGetBinary(_currentPurl, apiRequest).then(okRxRollupInvGetExcel, errRxRollupInvGetExcel);

		function okRxRollupInvGetExcel(r) {
			defer.resolve(r.data);
		}

		function errRxRollupInvGetExcel(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    ROLLUP EXCEL
	 *    file created on api server, expecting a binary file stream instead of JSON
	 */

	function rollupExcel(query, filename) {

		// params
		if(!rxRollupQueryValid(query) || !validSvc.isText(filename)) {
			throw new Error('reportRepo.rollupExcel, query or filename are missing');
		}

		_currentPurl = 'reports/rx/rollup/excel';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				RXID: [query.RxRollup.val]
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				Filename: filename
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('RxRollExcel')]
		};

		// call api
		apiService.postGetBinary(_currentPurl, apiRequest).then(okRollExcel, errRollExcel);

		function okRollExcel(r) {
			defer.resolve(r.data);
		}

		function errRollExcel(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function rollupAdminFeesPDF(query) {

		// params
		if(!rxRollupQueryValid(query)) {
			throw new Error('reportRepo.rollupExcel, query or filename are missing');
		}

		_currentPurl = 'reports/rx/rollup/adminfees/pdf';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				RXID: [query.RxRollup.val]
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
			}
		};

		// call api
		apiService.postGetBinary(_currentPurl, apiRequest).then(okRollExcel, errRollExcel);

		function okRollExcel(r) {
			defer.resolve(r.data);
		}

		function errRollExcel(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}



	/**
	 *    AUDIT EXCEL
	 */

	function auditGetExcel(ceid, id) {

		// params
		if(!validSvc.isCE(ceid) || !validSvc.isText(id)) {
			throw new Error('reportRepo.auditGetExcel, CE and id required');
		}

		_currentPurl = 'audit/get';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: [ceid]
			},
			Params: {
				Filename: id
			}
		};

		// call api
		apiService.postGetBinary(_currentPurl, apiRequest).then(okAuditGetExcel, errAuditGetExcel);

		function okAuditGetExcel(r) {
			defer.resolve(r.data);
		}

		function errAuditGetExcel(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	/**
	 *    AUDIT PHI
	 */

	function signPHIAttestation() {
		_currentPurl = 'user/perms/audit/phi';
		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
			},
			Params: {
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(okSign, errSign);

		function okSign(r) {
			refreshUserSilent();
			defer.resolve(r);
		}

		function errSign(r) {
			defer.reject(null);
		}

		return defer.promise;
	}

	/**
     *    USER SILENT REFRESH
     *    after sign attestation, refresh user
     */

	function refreshUserSilent() {

		// refresh login affs silent
		// note: don't care about the response, just doing a refresh for other features

		apiService.refreshUser().then(okAffRefreshSilent, errAffRefreshSilent);

		function okAffRefreshSilent(r) {
			// do nothing
		}

		function errAffRefreshSilent(r) {
			if (r !== null) {
				errSvc.warn('Report refresh user failed', 'reportRepo.errAffRefreshSilent', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}

	/**
	 *    GET INDIGENT
	 */

	function getIndigent(query) {

		// params
		if(!validSvc.isCE(query.CE.val) || !validSvc.isRX(query.RX.val) || !validSvc.isDate(query.StartDate.val)) {
			throw new Error('reportRepo.getIndigent, query is not valid');
		}

		var defer = $q.defer();
		_pending = {
			purl: 'reports/indigent/list',
			CE: query.CE.val,
			RX: query.RX.val
		};

		// create api request
		var apiRequest = {
			Context: {
				CEID: [query.CE.val],
				RXID: [query.RX.val]
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.StartDate.val
			},
			Paging: _apiPaging
		};

		apiService.post(_pending.purl, apiRequest).then(okGetIndigent, errGetIndigent);

		function okGetIndigent(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update CE and Rx user choice
			eventSvc.rootEmit('context.change', {
				CE: _pending.CE,
				RX: _pending.RX
			});

			var items = Array.isArray(r.data.Entity) ? r.data.Entity : [];

			defer.resolve({
				data: items,
				tooMany: items.length > 2000
			});

		}

		function errGetIndigent(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _pending.purl + 'repo', '', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function getRemittance(query) {
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				CEID: query.CE.vals,
				RXID: []
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val
			},
			Paging: _apiPaging
		};

		apiService.post('reports/remittance/list', apiRequest).then(okGetRemit, errGetRemit);

		function okGetRemit(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// update CE and Rx user choice
			eventSvc.rootEmit('context.change', {
				CE: _pending.CE,
				RX: _pending.RX
			});

			var items = Array.isArray(r.data.Entity) ? r.data.Entity : [];

			defer.resolve({
				data: items,
				tooMany: items.length > 2000
			});

		}

		function errGetRemit(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _pending.purl + 'repo', '', utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 *    GET UNREPLENISHED
	 */

	function getUnreplenished(query) {
		// params: sub-params too complicated to bother, see unreplenished queryValid() function
		 if(!!!query || !queryDatesValid(query)) {
			throw new Error('reportRepo.UninvoicedReport, query and dates required');
		}
		
		_currentPurl = 'reports/unreplenished/list';
		var defer = $q.defer();
		var apiRequest = {
			Context: {
				RXID: query.ReportType == 'ROLLUP' ? [query.RxRollup.val] : query.RX.vals,
				VENID: validSvc.isVEN(query.Vendor.val) ? [query.Vendor.val] : [],
				CEID: validSvc.isCE(query.CE.val) ? [query.CE.val] : []
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				VENID: validSvc.isVEN(query.Vendor.val) ? query.Vendor.val : '',
				Ndc: query.NDC.val,
				Tpa: query.ProgramAdmin.val == 'NONE' ? '' : query.ProgramAdmin.val,
				Specialty: query.Specialty.val
			},
			Paging: _apiPaging
		};

		apiService.post(_currentPurl, apiRequest).then(okGetUnreplenished, errGetUnreplenished);

		function okGetUnreplenished(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			var items = Array.isArray(r.data.Entity) ? r.data.Entity : [];

			defer.resolve({
				data: items,
				tooMany: items.length > 2000
			});

		}

		function errGetUnreplenished(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapProfileErrorsToModel(r, query);
				defer.reject(r);
			}
			else {
				throw new Error('userRepo.errSavePreferences, unexpected error result on purl: ' + _currentPurl);
			}
		}


	
		function mapProfileErrorsToModel(r, m) {

			// map server 422 fields onto model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: true,
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldObj,
				fieldName = '';

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);
				if(fieldObj === undefined) {
					throw new Error('userRepo.mapProfileErrorsToModel, api 422 field name not found: ' + fieldName);
				}

				// set failed state
				fieldObj.fail = 'yes';
				fieldObj.msg = entity.Fields[i].Rule;

			}

			return m;

		}


		return defer.promise;

	}


	/**
	 *    WAC NEUTRALIZER
	 */

	function getWacNeut(tabName, query) {

		// params
		if(query.CE.vals.length < 1 || query.RX.vals.length < 1 || !queryDatesValid(query)) {
			throw new Error('reportRepo.getWacNeut, query is not valid');
		}

		var defer = $q.defer();
		_pending = {
			tab: tabName,
			purl: 'reports/wacneut/'
		};

		var sortby = '';
		switch(tabName) {
			case 'SUMMARY':
				_pending.purl += 'summary';
				sortby = 'ItemCode';
				break;
			case 'DETAIL':
				_pending.purl += 'detail';
				sortby = 'TransDate';
				break;

			case 'PACK':
				_pending.purl += 'restockexceptions';
				sortby = 'ItemCode';
				break;
			default:
				throw new Error('reportRepo.getWacNeut, unknown tab name: ' + tabName);
		}

		var apiRequest = {
			Context: {
				CEID: query.CE.vals,
				RXID: query.RX.vals
			},
			Params: {
				CDC: query.CdcUser ? query.DC.val : '',
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
        		DateType: query.DateType
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle(sortby)]
		};
		apiService.post(_pending.purl, apiRequest).then(okGetWacNeut, errGetWacNeut);

		function okGetWacNeut(r) {

			// bad api response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _pending.purl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			var items = [];

			switch(tabName) {
				case 'SUMMARY':
					items = Array.isArray(r.data.Entity.Summary) ? r.data.Entity.Summary : [];
					break;
				case 'DETAIL':
					items = Array.isArray(r.data.Entity.Detail) ? r.data.Entity.Detail : [];
					break;
				case 'PACK':
					items = Array.isArray(r.data.Entity.UnidentifiedNDCExceptions) ? r.data.Entity.UnidentifiedNDCExceptions : [];
					break;
				default:
					throw new Error('reportRepo.getWacNeut, unknown tab name: ' + tabName);
			}

			defer.resolve({
				data: items,
				tooMany: items.length > 20000
			});

		}

		function errGetWacNeut(r) {
			if(!!r && r.status == 422) {
				defer.reject(r);
			}
			else if(!!r) {
				errSvc.warn('Api request failed', _pending.purl + ' repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				defer.reject(null);
			}
		}

		return defer.promise;

	}

	function getWacNeutAffs(dcList) {

		// params
		if(dcList.length < 1) {
			throw new Error('reportRepo.getWacNeutAffs, dc list required');
		}

		var defer = $q.defer();
		_currentPurl = 'reports/wacneut/affiliations';

		var apiRequest = {
			Context: {
				RXID: dcList
			}
		};

		apiService.post(_currentPurl, apiRequest).then(okGetWacNeutAffs, errGetWacNeutAffs);

		function okGetWacNeutAffs(r) {

			// bad api response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);

		}

		function errGetWacNeutAffs(r) {
			if(!!r && r.status == 422) {
				defer.reject(r);
			}
			else if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + ' repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				defer.reject(null);
			}
		}

		return defer.promise;

	}

	function remittanceExcel(query, filename) {
		var defer = $q.defer();
		_currentPurl = 'reports/remittance/excel';

		var apiRequest = {
			Context: {
				CEID: query.CE.vals,
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				Filename: filename
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('ServerExcel')]
		};

		apiService.postGetBinary(_currentPurl, apiRequest).then(okWacExcel, errWacExcel);

		function okWacExcel(r) {
			defer.resolve(r.data);
		}

		function errWacExcel(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function remittanceExcelDetail(item, filename) {
		var defer = $q.defer();
		_currentPurl = 'reports/remittance/detail/excel';

		var apiRequest = {
			Params: {
				CE : item.CE,
				ParentId : item.ParentId,
				Filename: filename
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('ServerExcel')]
		};

		apiService.postGetBinary(_currentPurl, apiRequest).then(okWacExcel, errWacExcel);

		function okWacExcel(r) {
			defer.resolve(r.data);
		}

		function errWacExcel(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}

	function wacNeutExcel(query, filename) {

		// params
		if(!!!query || !validSvc.isText(filename)) {
			throw new Error('reportRepo.wacNeutExcel, query and filename required');
		}

		var defer = $q.defer();
		_currentPurl = 'reports/wacneut/excel';

		var apiRequest = {
			Context: {
				CEID: query.CE.vals,
				RXID: query.RX.vals
			},
			Params: {
				CDC: query.CdcUser ? query.DC.val : '',
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				DateType: query.DateType,
				Filename: filename
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('ServerExcel')]
		};

		apiService.postGetBinary(_currentPurl, apiRequest).then(okWacExcel, errWacExcel);

		function okWacExcel(r) {
			defer.resolve(r.data);
		}

		function errWacExcel(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}




	function wacneutDetailVM(data) {
		data = data ? data : {};

		return {
			Id : data.Id,
			TransId : data.TransId,
			TransDate : data.TransDate,
			DrugDescription : data.DrugDescription,
			ItemCode : data.ItemCode,
			Quantity : data.Quantity,
			ChangeLog: data.ChangeLog,
			CanEdit:data.CanEdit
		};
	}

	function getWacneutDetail(id) {

		// params
		if(!validSvc.isText(id)) {
			throw new Error('reportRepo.getWacneutDetail, id is required');
		}

		_currentPurl = 'reports/wacneut/get';
		var defer = $q.defer();

		// create api request
		var apiReqest = {
			Params: {
				Id: id
			}
		}; 

		// call api
		apiService.post(_currentPurl, apiReqest).then(okGetDetail, errGetDetail);

		function okGetDetail(r) {

			// bad "Get One" response format
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}
			
			defer.resolve(wacneutDetailVM(r.data.Entity));

		}

		function errGetDetail(r) {
			if(r !== null) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}



	function updateWacNeut(model) {
		return upsert('reports/wacneut/update', model);
	}

	function upsert(purl, model) {

		_currentPurl = purl;
		_modelPending = model;
		var defer = $q.defer();

		var apiRequest = {
			Context: {
				RXID: [model.RXID]
			},
			Entity: {
				Id: model.Id.val,
				TransId : model.TransId.val,
				TransDate : model.TransDate.val,
				DrugDescription : model.DrugDescription.val,
				ItemCode : model.ItemCode.val,
				Quantity : model.Quantity.val,
			}
		};

		// call api
		apiService.post(_currentPurl, apiRequest).then(upsertOk, upsertErr);

		function upsertOk(r) {

			// bad upsert response format
			if(!validSvc.httpUpsert200Resp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', 200, utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			// return entity id
			defer.resolve(r.data.Entity);
		}

		function upsertErr(r) {

			if(r === null) {
				// already handled upstream
				defer.reject(null);
			}
			else if(!validSvc.httpUpsertErrResp(r)) {
				// bad error response format
				errSvc.warn('Api request failed with unknown error response format', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else if(r.status == 409) {
				defer.reject(r);
			}
			else if(r.status == 422) {
				// map 422 errors into model
				r.model = mapApiErrorsToModel(r, _modelPending);
				defer.reject(r);
			}
			else {
				throw new Error('upsertErr, unexpected error result');
			}

		}

		function mapApiErrorsToModel(r, m) {

			// map server 422 fields onto view model

			var entity = r.data.Entity;

			// root errors
			if(entity.ROOT.length > 0) {
				m.ROOT = {
					fail: 'yes',
					msg: entity.ROOT.join(', ')
				};
			}

			// field errors
			var fieldName = '',
				fieldObj = null;

			for(var i = 0; i < entity.Fields.length; i++) {

				fieldName = entity.Fields[i].Name;

				// parse model for property name
				fieldObj = utilSvc.obj.findChildProp(m, fieldName);
				if(fieldObj === undefined) {
					throw new Error('payorRepo.mapApiErrorsToModel, api 422 field name not found: ' + fieldName, _currentPurl, 422);
				}

				// set failed state
				fieldObj.fail = 'yes';
				fieldObj.msg = entity.Fields[i].Rule;

			}

			return m;

		}
		return defer.promise;
	}


	/**
	 * 	  TIMESERIES
	 */

	function getTimeseries(feature, ts, query) {

		// params
		if(!validSvc.isText(feature) || !!!ts) {
			throw new Error('reportRepo.getTimeseries, feature name and timeseries object required');
		}
		if(query.CE.vals.length < 1 || query.RX.vals.length < 1 || !queryDatesValid(query)) {
			throw new Error('reportRepo.getTimeseries, query is not valid');
		}

		var defer = $q.defer();

		// create api request
		var apiRequest = {
			Context: {
				CEID: query.CE.vals,
				RXID: query.RX.vals
			},
			Params: {
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val,
				IntervalType: ts.interval,
				ExcludeUnaffils: query.ExcludeUnaffils,
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('TIMESERIES')]
		};

		switch(feature) {

			case 'SPLITSAVE':
				apiRequest.Params.Aggregate = ts.type == 'AGGREGATE';
				if(query.ReportType == 'SPLIT') {
					_currentPurl = 'reports/splitsavings/series';
				}
				else {
					// split match query has a financial endpoint and a disp stats endpoint
					_currentPurl = ts.subtype == 'FIN' ? 'reports/splitsavings/splitmatch/series' : 'reports/matchstats/series';
				}
				break;

			case 'CONTRACT-CE':
				apiRequest.Params.Aggregate = ts.type == 'AGGREGATE';
				_currentPurl = ts.subtype == 'FIN' ? 'reports/ce/summary/series' : 'reports/matchstats/series';
				break;

			case 'CONTRACT-CP':
				apiRequest.Params.Aggregate = ts.type == 'AGGREGATE';
				_currentPurl = 'reports/cp/summary/series';
				break;
	
			case 'CONTRACT-RX':
				apiRequest.Params.Aggregate = ts.type == 'AGGREGATE';
				_currentPurl = ts.subtype == 'FIN' ? 'reports/rx/summary/series' : 'reports/matchstats/series';
				break;

			case 'MATCH':
				apiRequest.Params.Aggregate = ts.type == 'AGGREGATE';
				_currentPurl = 'reports/matchstats/series';
				break;

			case 'SPLITFIN':
				apiRequest.Params.Aggregate = ts.type == 'AGGREGATE';
				_currentPurl = 'reports/splitfin/series';
				break;
	
			default:
				throw new Error('reportRepo.getTimeseries, unknown feature: ' + feature);
		}

		// call api
		apiService.post(_currentPurl, apiRequest).then(okTS, errTS);

		function okTS(r) {

			// bad api response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _pending.purl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			var items = Array.isArray(r.data.Entity) ? r.data.Entity : [];
			defer.resolve(items);
		}

		function errTS(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _pending.purl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;

	}


	/**
	 * 	ASYNC FILES
	 */

	function createCpfrExportJob(exportRequest) {

		_currentPurl = 'reports/cp/export/create';
		var defer = $q.defer();

		if (!!!exportRequest) {
			throw new Error('reportRepo.createCpfrExportJob, export request required');
		}

		apiService.post(_currentPurl, exportRequest).then(okCreate, errCreate);

		function okCreate(r) {
			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + ' repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}
			defer.resolve(r.data.Entity);
		}

		function errCreate(r) {
			if(!!!r) {
				defer.reject(null);
			}
			else if(r.status != 422) {
				errSvc.warn('Api request failed', _currentPurl + ' repo', r.status, utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				defer.reject(r);
			}
		}

		return defer.promise;
	}

	function createAsyncFile(asyncRequest) {

		_currentPurl = 'reports/async/create';
		var defer = $q.defer();

		// params note: no validation property specific validation, controllers must know the async query format
		if (!!!asyncRequest) {
			throw new Error('reportRepo.createAsyncFile, async request required');
		}

		apiService.post(_currentPurl, asyncRequest).then(okCreateAsyncFile, errCreateAsyncFile);

		function okCreateAsyncFile(r) {

			if(!validSvc.httpGetOneResp(r)) {
				errSvc.warn('Bad 200 api response format', _pending.purl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errCreateAsyncFile(r) {
			if(!!!r) {
				// already handled
				defer.reject(null);
			}
			else if(r.status != 422) {
				errSvc.warn('Bad 200 api response format', _pending.purl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
			}
			else {
				defer.reject(r);
			}
		}

		return defer.promise;
	}

	function getAsyncFiles(query) {
		// params
		if (!!!query || !validSvc.isText(query.type)) {
			throw new Error('reportRepo.getAsyncFiles, query with report type required');
		}

		_currentPurl = 'reports/async/list';
		var defer = $q.defer();
		var apiRequest = buildAsyncListRequest(query);

		apiService.post(_currentPurl, apiRequest).then(okGetAsyncFiles, errGetAsyncFiles);

		function okGetAsyncFiles(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			var items = Array.isArray(r.data.Entity) ? r.data.Entity : [];

			defer.resolve(items);
		}

		function errGetAsyncFiles(r) {
			defer.reject(errAsyncHandler(r));
		}

		return defer.promise;
	}

	function buildAsyncListRequest(query) {
		var reportType = [query.type];

		switch(query.type) {
			case 'CPFR':
			case 'UDS':
			case 'ESP340B':
			case 'CATALOG_AFFILIATES':
			case 'ACCUM_DETAILS':
			case 'ACCUM_SLV_DETAILS':
			case 'CLAIM_DETAILS':
			case 'SPLITFIN':
				reportType.push('SPLITFIN_TRANS');
				break;
			case 'CLAIMREBATE':
				// rebate list uses both report types
				reportType.push('CLAIMREBATE_MANUAL');
				reportType.push('SPLITFIN_TRANS');
				break;
            case 'TRUZO':
				// truzo uses both report types
				reportType.push('TRUZO');
				reportType.push('SPLITFIN_TRANS');
                break;
			case 'RE_EVAL':
				break;
			case 'CMS340B':
				// CMS uses a single report type
				break;
			case 'SPLIT_SAVINGS':
				reportType.push('SPLITMATCH_SAVINGS');
				break;
			default:
				throw new Error('reportRepo.buildAsyncRequest, unknown report type: ' + query.type);
		}

		var request = {
			Context:{},
			Params:{
				ReportType: reportType
			}
		};

		return request;
	}

	function getAsyncFile(id) {
		// params
		if (!validSvc.isText(id)) {
			throw new Error('reportRepo.getAsyncFile, id required');
		}

		var defer = $q.defer();
		var apiRequest = {
			Params: {
				Id: id
			}
		};

		_currentPurl = 'reports/async/get';
		apiService.postGetBinary(_currentPurl, apiRequest).then(okGetAsyncFile, errGetAsyncFile);

		function okGetAsyncFile(r) {
			defer.resolve(r.data);
		}

		function errGetAsyncFile(r) {
			defer.reject(errAsyncHandler(r));
		}

		return defer.promise;

	}

	function errAsyncHandler(r) {
		// handler for both async file requests

		if (!!r) {
			if(r.status == 422) {
				return {errors: r.data.Entity.Fields};
			}
			else {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
		}

		return null;
	}

	/**
	 *    CLAIM SUBMISSION AUTO CONFIG
	 */

	 function claimSubConfigSearch(reportType, q) {
		// find auto config values by affiliation

		if(q.CE.vals.length < 1 || q.RX.vals.length < 1) {
			throw new Error('reportRepo.claimSubConfigSearch, query is not valid');
		}

		var defer = $q.defer();
		_currentPurl = reportType == 'ESP' ? 'claimsub/espconfig/list' : 'claimsub/rebateconfig/list';

		// create api request
		var apiRequest = {
			Context: {
				CEID: q.CE.vals,
				RXID: q.RX.vals
			},
			Params: {
				IncludePharmacy: q.ClaimType == 'PHARMACY',
				IncludeMedical: q.ClaimType == 'MEDICAL'
			},
			Paging: _apiPaging,
			SortBy: [utilSvc.sorting.sortByApiStyle('CEID')]
		};

		apiService.post(_currentPurl, apiRequest).then(okSearchConfigList, errSearchConfigList);

		function okSearchConfigList(r) {

			// bad "Get List" response format
			if(!validSvc.httpGetListResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve(r.data.Entity);
		}

		function errSearchConfigList(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}

	function claimSubConfigSave(reportType, claimType, m) {
		// params
		if(!validSvc.isText(claimType) || !!!m || !Array.isArray(m.CEID) || !Array.isArray(m.RXID) || !Array.isArray(m.Affs)) {
			throw new Error('reportRepo.claimSubConfigSave, ClaimType, CEID, RXID and Affs required');
		}
		
		var defer = $q.defer();
		_currentPurl = '';

		var apiRequest = {
			Context: {
				CEID: m.CEID,
				RXID: m.RXID
			}
		};
        
        switch(reportType) {
            case 'ESP':
                _currentPurl = 'claimsub/espconfig/save';
                apiRequest.Params = {
                    Affs: m.Affs,
                    ExtractEnabled: m.Enabled == 'YES',
                    Delay: claimType == 'PHARMACY' ? parseInt(m.Delay) : 0,
                    IncludePharmacy: claimType == 'PHARMACY',
                    IncludeMedical: claimType == 'MEDICAL'
                };
                break;
            case 'REB':
                _currentPurl = 'claimsub/rebateconfig/save';
                // tbd... the api may take out the "Rebate" prefix, to test leave them in for now
                apiRequest.Params = {
                    Affs: m.Affs,
                    RebateSendEnabled: m.Enabled == 'YES',
                    RebateDelay: claimType == 'PHARMACY' ? parseInt(m.Delay) : 0,
                    RebateIncludePharmacy: claimType == 'PHARMACY',
                    RebateIncludeMedical: claimType == 'MEDICAL'
                };
                break;
            default:
                throw new Error('reportRepo.claimSubConfigSave, unknown report type: ' + reportType);
        }

		apiService.post(_currentPurl, apiRequest).then(okSaveConfig, errSaveConfig);

		function okSaveConfig(r) {
			if(!validSvc.httpGetEntityResp(r)) {
				errSvc.warn('Bad 200 api response format', _currentPurl + 'repo', '', utilSvc.http.safeResponse(r));
				defer.reject(null);
				return;
			}

			defer.resolve({});
		}

		function errSaveConfig(r) {
			if(!!r) {
				errSvc.warn('Api request failed', _currentPurl + 'repo', r.status, utilSvc.http.safeResponse(r));
			}
			defer.reject(null);
		}

		return defer.promise;
	}


	/**
	 *    HELPERS
	 */

	function queryDatesValid(query) {
		return validSvc.isDate(query.StartDate.val) && validSvc.isDate(query.EndDate.val);
	}

	function queryValid(query) {
		return validSvc.isRX(query.RX.val) && validSvc.isCE(query.CE.val) && queryDatesValid(query);
	}

	function rxQueryValid(query) {
		return validSvc.isRX(query.RX.val) && queryDatesValid(query);
	}

	function rxRollupQueryValid(query) {
		return validSvc.isRX(query.RxRollup.val) && queryDatesValid(query);
	}

}
 
reportFindNpiCtl.$inject = ['$window', '$state', '$scope', '$timeout', 'reportFindNpiRepo', 'lookupRepo', 'sessionRepo', 'msgSvc', 'utilSvc', 'validSvc', 'errSvc', 'appConst'];
angular
.module('espui.report')
.controller('ReportFindNpiCtl', reportFindNpiCtl);


/* @ngInject */
function reportFindNpiCtl($window, $state, $scope, $timeout, reportFindNpiRepo, lookupRepo, sessionRepo, msgSvc, utilSvc, validSvc, errSvc, appConst) {

	/*jshint validthis: true */
	var vm = this,
		_pagingEventListener = null,
		_mouseLeaveDelay = {},
		_tabFilters = {},
		_pendingExcelFilename = '',
		_rxidPoolOptions = [];

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addMultiselect(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.canCreate = false;

	// tabs
	vm.activeTab = '';
	vm.tabChange = tabChange;

	// job list, job create
	vm.jobCreate = {};
	vm.jobCreateToggle = jobCreateToggle;
	vm.CeDroplist = [];
	vm.RxMultiselect = {};
	vm.JobsStatusDroplist = [];
	vm.jobCreateSubmit = jobCreateSubmit;
	vm.jobCreateCeClick = jobCreateCeClick;
	vm.jobCreateRxClick = jobCreateRxClick;
	vm.jobCreateRxSourceClick = jobCreateRxSourceClick;
	vm.multiselectRxToggle = multiselectRxToggle;
	vm.jobListClick = jobListClick;
	vm.jobListRefresh = getJobList;

	// npi summary
	vm.npi = {};
	vm.npiChkAll = npiChkAll;
	vm.npiChkItem = npiChkItem;

	// ref list
	vm.ref = {};
	vm.RefDateTypeDroplist = [];
	vm.refChangeDateType = refChangeDateType;
	vm.refQueryChange = refQueryChange;
	vm.refSearch = refSearch;

	// table, filters
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;

	// shared methods
	vm.dateRangeChange = dateRangeChange;
	vm.multiselectMouseHover = multiselectMouseHover;

	vm.getExcel = getExcel;


	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || vm.activeTab === ''){
			return;
		}
		switch(vm.activeTab){
			case 'NPI' : 
			if( !Array.isArray(vm.npi.Items) || vm.npi.Items.length < 1){
			return;
			} 
			break;
			case 'REF' : 
			if( !Array.isArray(vm.ref.Items) || vm.ref.Items.length < 1){
			return;
			} 
			break;
			default : 
			if( !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
				return;
			}
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});


	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		// user specific claims
		vm.canCreate = utilSvc.user.hasFeature($scope, 'report.findnpis.create');

		vm.init = true;

		vm.activeTab = initQueryAndFilters();
		tabChange(vm.activeTab);

		vm.init = false;

	}

	function initTabFilters() {

		return {
			JOBS: vm.initFilters({
				Exact: {
					Status: ''
				},
				Config: {
					Dates: ['CreateDate', 'StartDate', 'EndDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['-CreateDate']
			}),
			NPI: vm.initFilters({
				SortBy: ['-GrossSavings']
			}),
			REF: vm.initFilters({
				Config: {
					Dates: ['ServiceDate','RxWrittenDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['ServiceDate']
			})
		};
	}

	function initDateRangeUnlimited(q) {

		// expand date range to allow yearly and unlimited custom dates

		// add yearly options
		q.DateRangeList.push({label: 'Yearly', value: 'YEARLY'});
		q.DateRangeList.push({label: 'Year To Date', value: 'YTD'});

		// unlimited custom range (move min validation dates to app start)
		// note: reportRepo does this by default but want to explicitly set it JIC repo changes in future
		var dtToday = new Date(),
			dtAppStart = utilSvc.dt.zeroTime(appConst.app.liveDate),
			customRangeDays = parseInt(utilSvc.dt.diffDays(dtAppStart, dtToday));
		q.StartDate.min = dtAppStart;
		q.EndDate.min = dtAppStart;
		q.DateRangeList.push({label: 'Custom Date Range', value: 'CUSTOM' + customRangeDays.toString()});

		return q;

	}

	function initQueryAndFilters() {

		// job list
		vm.JobsStatusDroplist = utilSvc.ng.droplist(['NEW', 'INPROGRESS', 'READY'], '', '', [{label:'ALL', value:''}]);
		vm.RefDateTypeDroplist = utilSvc.ng.droplist(['Filled Date', 'Matched Date', 'Written Date']);

		// job create query
		var jlc = {
			CE: validSvc.newProp('NONE'),
			RX: validSvc.newProp('NONE'),
			StartDate: validSvc.newPropDate(),
			EndDate: validSvc.newPropDate(new Date()),
			DateRangeValid: false,
			DateRangeList: utilSvc.widget.dateRangeList(['CUSTOM92']),
			DateRangeMode: 'YTD'
		};
		vm.jobCreate = initDateRangeUnlimited(jlc);

		// rx multi placeholder for job create
		// this is setup after user clicks New Analysis (job create)
		vm.RxMultiselect = {
			type: 'RX',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Pharmacy',
			vals: [],
			list: [],
			flt: ''
		};

		// ref list query
		var ref = {
			npiSelected: [],
			Profitable: 'no',
			DateType: 'Filled Date',
			StartDate: validSvc.newPropDate(),
			EndDate: validSvc.newPropDate(new Date()),
			DateRangeValid: false,
			DateRangeList: utilSvc.widget.dateRangeList(['CUSTOM92']),
			DateRangeMode: 'YTD'
		};
		vm.ref = initDateRangeUnlimited(ref);

		// default filters
		_tabFilters = initTabFilters();


		return 'JOBS';

	}


	/**
	 *    VIEW MODELS
	 */

	function jobListVM(dataItems, tooMany) {

		dataItems = Array.isArray(dataItems) ? dataItems : [];

		var item = {},
			regexApiDateFmt = utilSvc.regex.apiDateStringFmt(),
			rx = [];

		// add uniqueId
		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.uniqueId = 'j' + i.toString();

			item.StartDate = utilSvc.dt.fromServerString(item.StartDate, regexApiDateFmt);
			item.EndDate = utilSvc.dt.fromServerString(item.EndDate, regexApiDateFmt);

			rx = Array.isArray(item.Pharmacies) ? item.Pharmacies : [];
			item.PharmacyTxt = rx.join(', ');

		}

		return {
			DataItems: dataItems,
			Items: [], // loaded by filterChange()
			TooMany: !!tooMany
		};

	}

	function npiSummaryVM(npi, dataItems) {
		dataItems = Array.isArray(dataItems) ? dataItems : [];

		var items = [],
			item = {};

		// build custom npi checklist items
		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];

			items.push({
				CE: item.CoveredEntity,
				RX: item.Pharmacy,
				NPI: item.PrescriberIdent,
				NpiName: item.PrescriberName,
				GrossSavings: item.GrossSavings,
				TotalDispenses: item.TotalDispenses,
				Errors: item.Errors,
				chk: true
			});
		}

		npi.DataItems = items;
		npi.Items = [];
		npi.chkAll = items.length > 0 ? 'yes' : 'no';
		npi.chkCount = items.length;

		return npi;

	}

	function referralListVM(ref, dataItems, tooMany) {

		dataItems = Array.isArray(dataItems) ? dataItems : [];

		var item = {};

		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];

			item.RxWrittenDate = validSvc.isDate(item.RxWrittenDate) ? item.RxWrittenDate : null;
			item.ServiceDate = validSvc.isDate(item.ServiceDate) ? item.ServiceDate : null;

			item.MCO = !!item.MCO ? 'YES' : 'NO';
			item.FFS = !!item.FFS ? 'YES' : 'NO';

			item.PriceErrTxt = !!item.NoReferenceItem ? 'Price ref not found ' : '';
			if(validSvc.isText(item.PricingError)) {
				item.PriceErrTxt += item.PricingError;
			}
		}

		ref.DataItems = dataItems;
		ref.Items = [];
		ref.TooMany = !!tooMany;

		return ref;
	}


	/**
	 *    JOB LIST
	 */

	function getJobList() {

		if(vm.isWaiting) {
			return;
		}

		// reset npi/ref dependent tabs
		vm.npi.CE = '';
		vm.npi = npiSummaryVM(vm.npi, []);
		refQueryChange();

		vm.isWaiting = true;
		msgSvc.wait(true);
		queryChange();

		reportFindNpiRepo.getJobList().then(okGetJobList, errGetJobList);
	}

	function okGetJobList(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		// load data
		vm.tbl = jobListVM(r.Jobs, r.TooMany);
		vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);

		// dispense pool pharmacies are sent back by API
		_rxidPoolOptions = Array.isArray(r.ApiRxList) ? r.ApiRxList : [];

		// update paging ui
		$scope.$broadcast('widget.paging', {
			uniqueId: vm.activeTab,
			Size: vm.flt.PageSize,
			Page: vm.flt.Page,
			Total: vm.flt.PageTotal,
			RowCount: vm.flt.Count,
			ItemCount: vm.tbl.Items.length,
			DataCount: vm.tbl.DataItems.length
		});

		vm.action = 'LIST';
		vm.flt.Ready = true;

	}

	function errGetJobList(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		if(!!r) {
			errSvc.warn('Unknown get response', 'reportFindNpiCtl.errGetJobList', r.status, utilSvc.http.safeResponse(r));
		}

	}


	/**
	 *    JOB CREATE
	 */

	function rebuildRxLabel(rxid, affs) {
		// RX Multiselect label is combination of short name and type + rollup parent
		var aff = utilSvc.aff.findRx(affs, rxid)[0];		
		var result = validSvc.isText(aff.RxShortName) ? aff.RxShortName : rxid;
		result += ' - ' + aff.RxType;
		if(validSvc.isText(aff.RxParent)) {
			result += ' - in Rollup: ' + utilSvc.aff.rxShortNameById(affs, aff.RxParent);
		}
		return result;
	}

	function rebuildRxMulti(multi, rxSource, ceid) {
		// rebuild rxid multiselect from dispense pool or affiliations source

		var affs = $scope.User.AffList,
			rxSourceList = [];

		switch(rxSource) {
			case 'POOL':
				rxSourceList = _rxidPoolOptions;
				multi.title = 'Choose a Pharmacy';
				break;
			case 'AFFS':
				if(!validSvc.isCE(ceid)) {
					throw new Error('referralsCtl.rebuildRxMulti, ceid required for AFFS');
				}
				// AFFS of CE chosen
				rxSourceList = utilSvc.aff.findCe(affs, ceid);
				rxSourceList = utilSvc.aff.findStatus(rxSourceList, ['ONBOARDING', 'ACTIVE']);
				rxSourceList = utilSvc.aff.findRxModel(rxSourceList, ['CP', 'CPTPA', 'SPLITMATCH']);
				rxSourceList = utilSvc.aff.rxList(rxSourceList);
				multi.title = 'All Options';
				break;
			default:
				throw new Error('referralsCtl.rebuildRxMulti, unknown source: ' + rxSource);
		}
		
		// build checklist (label is not standard)
		multi.vals = [];
		multi.list = [];
		var rxid = '',
			isAffSource = rxSource == 'AFFS';
		for(var i = 0; i < rxSourceList.length; i++) {
			rxid = rxSourceList[i];

			// do not add POOL rxid to an AFFS checklist
			if(isAffSource && _rxidPoolOptions.indexOf(rxid) > -1) {
				continue;
			}

			multi.list.push({
				val: rxid,
				lbl: rebuildRxLabel(rxid, affs),
				checked: false
			});
		}

		multi.list = utilSvc.array.sortASC(multi.list, 'lbl');

		return multi;
	}

	function jobCreateToggle() {

		if(vm.isWaiting) {
			return;
		}

		if(vm.action == 'CREATE') {
			// toggle off, back to list
			getJobList();
			return;
		}

		// toggle on, setup job create query
		var affs = $scope.User.AffList,
			jc = vm.jobCreate;

		// CE
		vm.CeDroplist = utilSvc.aff.ceDroplist(utilSvc.aff.findStatus(affs, ['ONBOARDING', 'ACTIVE']));
		jc.CE = validSvc.newProp('NONE');
		jc.CE.fail = 'yes';

		// RX, init to POOL
		jobCreateRxSourceClick('POOL');
		
		// reset date range values
		jc.DateRangeValid = false;
		jc.DateRangeMode = 'YTD';
		$timeout(function() {
			$scope.$broadcast('widget.input.date.range.mode', {uniqueId:'JLCREATE', mode: vm.jobCreate.DateRangeMode, keepDates: false});
		},200);

		vm.action = 'CREATE';
	}

	function jobCreateSubmit() {

		if(vm.isWaiting) {
			return;
		}

		var jlc = vm.jobCreate;
		jlc.CE.fail = validSvc.isCE(jlc.CE.val) ? 'no' : 'yes';
		jlc.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';

		if(jlc.CE.fail == 'yes' || jlc.RX.fail == 'yes' || !jlc.DateRangeValid) {
			msgSvc.ok('Cannot Start Analysis', 'Check settings');
			return;
		}

		var rxSourceTitle = vm.jobCreate.RxSource == 'POOL' ? 'Dispense Pool' : 'Affiliate';
		msgSvc.confirm({
			id: 'report.findnpis.create',
			title: 'Start New Analysis',
			msg: 'Confirm new ' + rxSourceTitle + ' analysis for ' + jlc.CE.val + '? IMPORTANT: any previous analysis for ' + jlc.CE.val + ' will be replaced.',
			notes: {
				prompt: 'optional analysis notes',
				maxlength: 100
			},
			buttons: [
				{text:'OK', result:'YES', cancel: false},
				{text:'CANCEL', result:'CANCEL', cancel: true}
			]
		}).then(confirmJobCreate, confirmJobCreate);

	}

	function confirmJobCreate(r) {

		// user cancelled
		if(!!!r || r.result != 'YES') {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		var nt = validSvc.isText(r.notes) ? r.notes : '',
			rxVals = multiselectQueryVals(vm.RxMultiselect),
			jc = vm.jobCreate;

		reportFindNpiRepo.jobCreate(jc.CE.val, jc.RxSource, rxVals, jc.StartDate.val, jc.EndDate.val, nt).then(okJobCreate, errJobCreate);

		function okJobCreate(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			msgSvc.okAsync('Analysis Started', vm.jobCreate.CE.val + ' analysis started. Processing may take hours or require a full business day to complete.', 'report.referral.createok').then(getJobList, getJobList);
		}

		function errJobCreate(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(!!r && r.status === 409) {
				msgSvc.ok('Create Failed', 'A job for this CE is still in progress.');
			}
			else if(!!r){
				errSvc.error('Unexpected api error', 'reportFindNpiReportCtl.errJobCreate', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}

	function jobCreateCeClick() {
		if(vm.isWaiting) {
			return;
		}
		
		vm.jobCreate.CE.fail = validSvc.isCE(vm.jobCreate.CE.val) ? 'no' : 'yes';
		if(vm.jobCreate.CE.fail == 'yes') {
			return;
		}

		// RX AFFS option is dependent on CE
		if(vm.jobCreate.RxSource == 'AFFS') {
			var multi = rebuildRxMulti(vm.RxMultiselect, vm.jobCreate.RxSource, vm.jobCreate.CE.val);
			if(multi.list.length > 0) {
				// add ALL option for AFFS pharmacies
				multi.list.unshift({
					val: 'ALL',
					lbl: 'ALL',
					checked: false
				});
				vm.RxMultiselect = multi;
				jobCreateRxClick('ALL');
			}
			else {
				// no AFFS pharmacies found
				multi.vals = [];
				multi.titleNoOptions = 'No Options Available';
				vm.RxMultiselect = multi;
				jobCreateRxClick('|CLEAR|');
				msgSvc.ok('Facility Affiliates', 'No options available outside Dispense Pool');
			}
		}
	}

	function jobCreateRxClick(val) {
		if(vm.isWaiting) {
			return;
		}

		vm.multiselectClick(vm.RxMultiselect, val);
		vm.multiselectTitle(vm.RxMultiselect, true);

		vm.jobCreate.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';
	}

	function jobCreateRxSourceClick(rxSource) {
		// switch RX options between POOL and AFFS

		if(vm.isWaiting) {
			return;
		}

		vm.jobCreate.RxSource = rxSource;

		switch(rxSource) {
			case 'POOL':
				vm.RxMultiselect = rebuildRxMulti(vm.RxMultiselect, rxSource);
				jobCreateRxClick('|CLEAR|');
				break;
			case 'AFFS':
				jobCreateCeClick();
				break;
			default:
				throw new Error('referralCtl.jobCreateRxSourceClick, unknown source: ' + rxSource);
		}

	}

	function multiselectRxToggle(evt, id) {
		multiselectToggle(evt, vm.RxMultiselect, id);
	}

	function jobListClick(item) {

		if(vm.isWaiting || !!!item || !validSvc.isCE(item.CE)) {
			return;
		}

		if(item.Status != 'READY') {
			msgSvc.ok(item.Status, 'Analysis is not ready, please click REFRESH to check for analysis status updates.');
			return;
		}

		vm.npi.CE = item.CE;
		tabChange('NPI');

	}


	/**
	 *    NPI
	 */

	function npiGetSummary() {

		if(vm.isWaiting || !validSvc.isCE(vm.npi.CE)) {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		vm.action = '';
		vm.activeTab = 'NPI';

		reportFindNpiRepo.getNpiSummary(vm.npi.CE).then(okGetNpiSummary, errGetNpiSummary);
	}

	function okGetNpiSummary(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		// load data
		vm.npi = npiSummaryVM(vm.npi, r);
		vm.npi.Items = vm.filterList(vm.npi.DataItems, vm.flt);

		// update paging ui
		$scope.$broadcast('widget.paging', {
			uniqueId: vm.activeTab,
			Size: vm.flt.PageSize,
			Page: vm.flt.Page,
			Total: vm.flt.PageTotal,
			RowCount: vm.flt.Count,
			ItemCount: vm.npi.Items.length,
			DataCount: vm.npi.DataItems.length
		});
		vm.action = 'LIST';
		vm.flt.Ready = true;

	}

	function errGetNpiSummary(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		if(!!r) {
			errSvc.warn('Unknown get response', 'reportFindNpiCtl.errGetNpiSummary', r.status, utilSvc.http.safeResponse(r));
		}

	}

	function npiChkAll() {

		// toggle all checked npi items

		if(vm.isWaiting || vm.activeTab != 'NPI') {
			return;
		}
		refQueryChange();

		vm.npi.chkAll = vm.npi.chkAll == 'yes' ? 'no' : 'yes';
		var chk = vm.npi.chkAll == 'yes';

		// apply to all npi list items
		for(var i = 0; i < vm.npi.DataItems.length; i++) {
			vm.npi.DataItems[i].chk = chk;
		}

		vm.npi.chkCount = chk ? vm.npi.DataItems.length : 0;

	}

	function npiChkItem(item) {
		refQueryChange();

		item.chk = !item.chk;

		// adjust overall check count
		vm.npi.chkCount += item.chk ? 1 : -1;
		if(vm.npi.chkCount == vm.npi.DataItems.length) {
			vm.npi.chkAll = 'yes';
		}
		else {
			vm.npi.chkAll = 'no';
		}
	}


	/**
	 *    REFERRAL LIST
	 */

	function refQueryChange() {

		vm.action = 'QUERY';
		vm.ref.DataItems = [];
		vm.ref.Items = [];
		vm.ref.npiList = [];
	}

	function refChangeDateType() {
		refQueryChange();
	}

	function refListLoad() {

		if(vm.isWaiting) {
			return;
		}

		if(vm.ref.npiList > 0) {
			refSearch();
			return;
		}

		// setup search
		vm.action = vm.npi.chkCount > 0 ? 'QUERY' : 'NONPI';
		vm.ref.DateType = 'Filled Date';
		vm.ref.DateRangeValid = false;
		vm.ref.DateRangeMode = 'YTD';

		// reset date range
		$timeout(function() {
			$scope.$broadcast('widget.input.date.range.mode', {uniqueId:'REF', mode: vm.ref.DateRangeMode, keepDates: false});
		},200);

	}

	function refSearch() {

		if(vm.isWaiting) {
			return;
		}

		if(!vm.ref.DateRangeValid) {
			msgSvc.ok('Cannot Search', 'Date range is invalid');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		// build npi list to search
		vm.ref.npiList = [];
		for(var i = 0; i < vm.npi.DataItems.length; i++) {
			if(vm.npi.DataItems[i].chk) {
				vm.ref.npiList.push(vm.npi.DataItems[i].NPI);
			}
		}

		reportFindNpiRepo.getReferrals(vm.npi.CE, vm.ref).then(okGetRefDetails, errGetRefDetails);
	}

	function okGetRefDetails(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		// tbd...saveViewState(vm.activeTab, vm.query, vm.flt);

		// load data
		vm.ref = referralListVM(vm.ref, r.Items, r.TooMany);
		vm.ref.Items = vm.filterList(vm.ref.DataItems, vm.flt);

		// update paging ui
		$scope.$broadcast('widget.paging', {
			uniqueId: vm.activeTab,
			Size: vm.flt.PageSize,
			Page: vm.flt.Page,
			Total: vm.flt.PageTotal,
			RowCount: vm.flt.Count,
			ItemCount: vm.ref.Items.length,
			DataCount: vm.ref.DataItems.length
		});

		vm.action = 'LIST';
		vm.flt.Ready = true;

	}

	function errGetRefDetails(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		if(!!r) {
			errSvc.warn('Unknown get response', 'reportFindNpiCtl.errGetRefDetails', r.status, utilSvc.http.safeResponse(r));
		}

	}


	/**
	 *    TAB AND QUERY CHANGE EVENTS
	 */

	function queryChange() {
		if(!vm.init) {
			vm.action = '';
			vm.tbl = {};
			vm.flt = vm.resetFilters(vm.flt);

			$scope.$broadcast('widget.paging');
		}
	}

	function dateRangeChange(uniqueId, dtMode, isValid) {

		switch(uniqueId) {
			case 'JLCREATE':
				vm.jobCreate.DateRangeMode = dtMode;
				vm.jobCreate.DateRangeValid = isValid;
				break;
			case 'REF':
				refQueryChange();
				vm.ref.DateRangeMode = dtMode;
				vm.ref.DateRangeValid = isValid;
				break;
		}

	}

	function tabChange(newTab) {

		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.activeTab = newTab;
		vm.flt = vm.resetFilters(_tabFilters[newTab]);

		switch(newTab) {

			case 'JOBS':
				getJobList();
				break;

			case 'NPI':
				npiGetSummary();
				break;

			case 'REF':
				refListLoad();
				break;

			default:
				msgSvc.ok('Error', 'referralsCtl.tabChange, unknown tab: ' + newTab);
		}

	}


	/**
	 *    GLOBAL GREASE COLUMN FILTERS
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			var targetTable = {};
			switch(vm.activeTab) {

				case 'JOBS':
					targetTable = vm.tbl;
					break;

				case 'NPI':
					targetTable = vm.npi;
					break;

				case 'REF':
					targetTable = vm.ref;
					break;

				default:
					msgSvc.ok('Filter Error', 'referralsCtl.filterChange, unknown tab: ' + vm.activeTab);
					return;
			}

			targetTable.Items = vm.filterList(targetTable.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: vm.activeTab,
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: targetTable.Items.length,
				DataCount: targetTable.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					//console.log('filter change save viewstate');
					// tbd... saveViewState(vm.query, vm.flt);
				}
			},1000);

		}, delayTime);

	}


	/**
	 *    EXCEL
	 *    get file from server
	 */

	function getExcel() {

		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		_pendingExcelFilename = 'Verity-' + vm.npi.CE + '-Referral-NPI.xlsx';

		reportFindNpiRepo.getExcel(vm.activeTab, vm.npi, vm.ref, _pendingExcelFilename).then(okServerExcel, errServerExcel);

		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r !== null) {
				errSvc.warn('Create Excel Error', 'referralsCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    MULTISELECT HELPERS
	 */

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if(vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		multiselect.flt = '';

		// don't bother with width if hiding
		if(multiselect.show) {
			multiselect.show = false;
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;

	}

	function multiselectMouseHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}


	/**
	 *    HELPERS
	 */

	function multiselectQueryVals(multiselect) {

		// unpack the vals multiselect into a list of entities to query

		var checklist = multiselect.list,
			vals = multiselect.vals;

		if (vals.length < 1) {
			return [];
		}
		else if (vals.length === 1 && vals[0] == 'ALL') {
			// using ALL checkbox, return all values except ALL checkbox
			var result = [],
				i = checklist[0].val == 'ALL' ? 1 : 0;
			for (i; i < checklist.length; i++) {
				result.push(checklist[i].val);
			}
			return result;
		}
		else {
			return vals;
		}
	}
}
 
indigentCtl.$inject = ['$scope', '$state', '$window', '$timeout', '$filter', 'reportRepo', 'sessionRepo', 'utilSvc', 'validSvc', 'msgSvc', 'errSvc'];
angular
.module('espui.report')
.controller('IndigentCtl', indigentCtl);

/* @ngInject */
function indigentCtl($scope, $state, $window, $timeout, $filter, reportRepo, sessionRepo, utilSvc, validSvc, msgSvc, errSvc) {

	// private props
	var _pendingExcelFilename = '',
		_featureName = '',
		_pagingEventListener = null,
		_datePickListener = null;

	var vm = this;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.CeDroplist = [];
	vm.RxDroplist = [];

	// query
	vm.query = {};
	vm.queryChangeCE = queryChangeCE;
	vm.queryChangeRX = queryChangeRX;
	vm.querySubmit = querySubmit;

	// StartDate date picker
	vm.dtPickShow = false;
	vm.dtPickOpen = dtPickOpen;

	// tbl and filters
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;

	// excel
	vm.createExcel = createExcel;


	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});


	/**
	 *    DATE PICK LISTENER
	 */

	_datePickListener = $scope.$on('widget.input.date.pick.change', function(event, evtData) {
		event.stopPropagation();

		// params
		if(!evtData) {
			alert('reportAuditCtl.datePickEvt, evtData required');
			return;
		}

		vm.dtPickShow = false;
		vm.query.StartDate.val = evtData.setDate;

		queryChange();

	});


	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
		if(!!_datePickListener) {
			_datePickListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		_featureName = $state.current.name;

		vm.init = true;

		if(!initQueryAndFilters()) {
			// no indigent options are available
			vm.action = 'NORESULTS';
			vm.init = false;
			return;
		}

		// CE options
		vm.CeDroplist = utilSvc.aff.ceDroplist(getAffs());
		vm.query.CE = utilSvc.ng.droplistAutoselect(vm.CeDroplist, vm.query.CE.val);
		queryChangeCE();

		vm.init = false;
	}

	function getAffs() {

		var affs = utilSvc.aff.findStatus($scope.User.AffList);
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
		affs = utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));

		return utilSvc.aff.findVenType(affs, ['IND'], true);

	}

	function initQueryAndFilters() {

		vm.query = reportRepo.queryVM();

		var flt = vm.initFilters({
			Config: {
				Dates: ['DispRxWrittenDate', 'DispFillDate'],
				DateFmt: 'M/d/yyyy'
			},
			SortBy: ['-DispFillDate']
		});

		// StartDate is a date picker (EndDate no longer used)
		var dtToday = utilSvc.dt.zeroTime(new Date());
		vm.query.StartDate.val = dtToday;
		vm.query.StartDate.max = dtToday;
		vm.query.StartDate.min = utilSvc.dt.zeroTime(utilSvc.dt.addDays(dtToday, -730));

		vm.CeDroplist = utilSvc.ng.droplistNONE();
		vm.RxDroplist = utilSvc.ng.droplistNONE();

		// no indigent affs found?
		var affs = getAffs();
		if(affs.length < 1) {
			return false;
		}

		// setup filters
		var vs = sessionRepo.get('vs-reports-indigent', {CE:vm.query.CE.val, RX:vm.query.RX.val});
		if(!!vs) {
			vm.query.StartDate.val = utilSvc.dt.zeroTime(new Date(vs.query.StartDate.val));
			vm.query.StartDate.min = utilSvc.dt.zeroTime(new Date(vs.query.StartDate.min));
			vm.query.StartDate.max = utilSvc.dt.zeroTime(new Date(vs.query.StartDate.max));

			flt = vm.resetFilters(vs.flt, true);
		}
		vm.flt = flt;

		return true;

	}


	/**
	 *    DISPLAY VM
	 */

	function displayVM(dataItems, tooMany) {

		// convert data into display view model

		dataItems = Array.isArray(dataItems) ? dataItems : [];

		// clean up incoming data
		var item = {};
		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.uniqueId = i;

			// nullify golang "zero" dates
			item.DispRxWrittenDate = validSvc.isDate(item.DispRxWrittenDate) ? item.DispRxWrittenDate : null;
			item.DispFillDate = validSvc.isDate(item.DispFillDate) ? item.DispFillDate : null;
		}

		return {
			Items: [],
			DataItems: dataItems,
			TooMany: !!tooMany
		};

	}


	/**
	 *    QUERY CHANGE
	 */

	function queryChange() {

		if(!vm.init) {
			vm.action = '';
			vm.tbl = {};
			vm.flt = vm.resetFilters(vm.flt);
			vm.dtPickShow = false;
			$scope.$broadcast('widget.paging');
		}

	}

	function queryChangeCE() {

		queryChange();

		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';

		// reset RX
		vm.RxDroplist = utilSvc.ng.droplistNONE();
		if(vm.query.CE.fail == 'yes') {
			vm.query.RX = validSvc.newProp('NONE');
			return;
		}

		// RX options
		vm.RxDroplist = utilSvc.aff.rxDroplist(getAffs(), vm.query.CE.val);
		vm.query.RX = utilSvc.ng.droplistAutoselect(vm.RxDroplist, vm.query.RX.val);

		queryChangeRX();

	}

	function queryChangeRX() {

		queryChange();
		vm.query.RX.fail = validSvc.isRX(vm.query.RX.val) ? 'no' : 'yes';

	}

	function dtPickOpen() {

		var dt = vm.query.StartDate;

		$scope.$broadcast('widget.input.date.pick', {
			uniqueId: 'dtPickStartDate',
			setDate: dt.val,
			minDate: dt.min,
			maxDate: dt.max
		});

		$timeout(function(){
			vm.dtPickShow = true;
		},100);

	}


	/**
	 *    GLOBAL GREASE FILTER
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					saveViewState(vm.query, vm.flt);
				}
			},1000);

		}, delayTime);

	}


	/**
	 *    QUERY SUBMIT
	 */

	function querySubmit() {

		if(vm.action == 'NORESULTS') {
			return;
		}

		// validate
		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';
		vm.query.RX.fail = validSvc.isRX(vm.query.RX.val) ? 'no' : 'yes';

		var startDT = validSvc.propDateValid(vm.query.StartDate);
		vm.query.StartDate.fail = !!startDT.fail ? 'yes' : '';
		vm.query.StartDate.msg = !!startDT.fail ? startDT.msg : '';

		if(vm.isWaiting) {
			return;
		}

		if(vm.query.StartDate.fail == 'yes' || vm.query.CE.fail == 'yes' || vm.query.RX.fail == 'yes') {
			msgSvc.ok('Search', 'Check filter settings.');
			return;
		}

		// stuff EndDate with StartDate value to pass api validation
		vm.query.EndDate.val = vm.query.StartDate.val;

		vm.isWaiting = true;
		msgSvc.wait(true);

		queryChange();

		reportRepo.getIndigent(vm.query).then(okData, errData);

		function okData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// query was good, save viewstate
			saveViewState(vm.query, vm.flt);

			vm.tbl = displayVM(r.data, r.TooMany);
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			vm.flt.Ready = true;
			vm.action = 'LIST';

		}

		function errData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('unknown error getting data', 'indigentCtl.querySubmit', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    EXCEL
	 *    get file from server
	 */

	function createExcel() {

		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		_pendingExcelFilename = 'Verity-' + vm.query.CE.val + '-Indigent-' + utilSvc.dt.monthShortText(vm.query.StartDate.val) + vm.query.StartDate.val.getFullYear().toString() + '.xlsx';

		// dump memory before creating Excel
		reportRepo.destroyRX();
		reportRepo.destroyCE();
		$timeout(function() {
			// small delay for digest cycle to delete repo memory
			reportRepo.serverExcel('INDIGENT', vm.query, _pendingExcelFilename).then(okServerExcel, errServerExcel);
		}, 300);


		function okServerExcel(binaryData) {

			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

		}

		function errServerExcel(r) {

			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r !== null) {
				r = r || {};
				errSvc.warn('Create Excel Error', 'indigentCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    HELPERS
	 */

	function numberFmt(val, zeroFmt, prefix, decPlaces) {

		// helper to format incoming number data

		// nan
		if(!validSvc.isNumber(val)) {
			return '';
		}

		// zero
		if(val === 0) {
			return zeroFmt;
		}

		return prefix + utilSvc.str.toText($filter('number')(val, decPlaces));

	}

	function saveViewState(query, flt) {

		sessionRepo.set('vs-reports-indigent', {
			ctx: {
				CE: query.CE.val,
				RX: query.RX.val
			},
			query: {
				StartDate: query.StartDate
			},
			flt: flt
		});

	}

}
 
reportPDF.$inject = ['$window', '$rootScope', '$q', '$filter', 'utilSvc', 'validSvc'];
angular
.module('espui.report')
.factory('reportPDF', reportPDF);


/* @ngInject */
function reportPDF($window, $rootScope, $q, $filter, utilSvc, validSvc) {

	/**
	 *    DEFAULT PDF PROPERTIES
	 *    shared by both RX and CE reports
	 */

	// style settings
	var _pgMargin = 50,
		_colorPrimary = '#0cbab3',
		_colorTxt = '#f0f0f',
		_colorWhite = '#fdfdfd',
		_colorLightGray = '#cccccc',
		_pgFont = 'Helvetica',
		_pgRightIndent = 80,
		_pxTitle = 24,
		_pxSubtitle = 16,
		_pxBigText = 12,
		_pxText = 10,
		_pxSmallText = 8;

	// page dimensions and _columns (setup later in initPdfDoc method)
	var _pgWidth = 0,
		_pgHeight = 0,
		_lineWidth = 0,
		_colWidth = 0,
		_col = {};


	/**
	 *    SERVICE DEFINITION
	 */

	var service = {
		rxSummary: rxSummary,
		ceSummary: ceSummary,
		rxBilling: rxBilling,
		rxRollup: rxRollup
	};

	return service;


	/**
	 *    PDF DOC INIT
	 *    setup default page properties based on passed in doc
	 */

	function initPdfDoc(doc) {

		// width calcs
		_pgWidth = doc.page.width;
		_pgHeight = doc.page.height;
		_lineWidth = _pgWidth - (_pgMargin * 2);

		// 5 _column setup
		_colWidth = _lineWidth / 5;
		_col = {
			'x1': _pgMargin,
			'x2': _pgMargin + _colWidth,
			'x3': _pgMargin + (2 * _colWidth),
			'x4': _pgMargin + (3 * _colWidth),
			'x5': _pgMargin + (4 * _colWidth)
		};

	}


	/**
	 *    BILLING
	 */

	function rxBillingTop(doc, rptData, columns, pageNum, continueItems) {

		// write out the top of each page

		// top right text (changes on continued pages)
		var topRightText = '';
		if(pageNum > 1) {
			topRightText = 'Bill Date: ' + $filter('date')(rptData.BillDate, "MMM dd, yyyy").toString() + ' - Page ' + pageNum.toString();
		}
		else {
			topRightText = 'Bill Date: ' + $filter('date')(rptData.BillDate, "MMM dd, yyyy").toString();
		}

		// header
		addHeader(doc,
			'Verity Solutions',
			'Pharmacy Invoice',
			topRightText
		);

		// rx, ce
		doc.fill(_colorTxt);
		addLineX(doc, 'Pharmacy:', _col.x1, rptData.RXNAME + '(' + rptData.RXID + ')', _col.x2);
		addLineX(doc, 'Facility:', _col.x1, rptData.CENAME + '(' + rptData.CEID + ', OPAID: ' + rptData.OpaId + ')', _col.x2);
		addLineX(doc, 'Verity Invoice #:', _col.x1, rptData.BillNumber, _col.x2);
		doc.moveDown();

		// vendor
		var halfCol = _colWidth / 2,
			saveY = doc.y;
		addLineX(doc, 'Vendor:', _col.x1, rptData.VENID, _col.x2);
		doc.y = saveY;
		addLineX(doc, 'Verity Order #:', _col.x3 + halfCol, rptData.OrderNumber, _col.x4 + halfCol);

		// invoice and order numbers
		saveY = doc.y;
		addLineX(doc, 'Vendor Ship Date:', _col.x1, $filter('date')(rptData.VendorShipDate, "MMM dd, yyyy").toString(), _col.x2);
		doc.y = saveY;
		addLineX(doc, 'Vendor Invoice #:', _col.x3 + halfCol, rptData.VendorInvoiceNum, _col.x4 + halfCol);

		// keep these, super helpful!
		//doc.fontSize(_pxText).text('Vendor: ' + rptData.VENID, _col.x1, saveY, {width: _lineWidth, align: 'left'});
		//doc.fontSize(_pxText).text('Vendor Invoice #: ' + rptData.VendorInvoiceNum, _col.x1, saveY, {width: _lineWidth, align: 'center'});
		//doc.fontSize(_pxText).text('Vendor Ship Date: ' + $filter('date')(rptData.VendorShipDate, "MMM dd, yyyy").toString(), _col.x1, saveY, {width: _lineWidth, align: 'right'});

		// more line items to come?
		if(continueItems) {

			// line items title
			var continueText = pageNum > 1 ? ' Continued...' : '';
			addSectionTitle(doc, 'Invoice Line Items' + continueText);
			doc.fill(_colorTxt);
			doc.y += 10;

			// line item headers
			saveY = doc.y;
			doc.fontSize(_pxSmallText).text('Quantity', columns.Quantity.x, saveY, {width: columns.Quantity.width, align: 'center'});
			doc.fontSize(_pxSmallText).text('Description', columns.Description.x, saveY, {width: columns.Description.width, align: 'center'});
			doc.fontSize(_pxSmallText).text('Price', columns.Price.x, saveY, {width: columns.Price.width, align: 'center'});
			doc.fontSize(_pxSmallText).text('Amount', columns.Amount.x, saveY, {width: columns.Amount.width, align: 'center'});

			// header underline
			doc.rect(columns.Quantity.x + 5, doc.y, columns.Quantity.width - 5, 0.5).fill(_colorTxt);
			doc.rect(columns.Description.x + 5, doc.y, columns.Description.width - 5, 0.5).fill(_colorTxt);
			doc.rect(columns.Price.x + 5, doc.y, columns.Price.width - 5, 0.5).fill(_colorTxt);
			doc.rect(columns.Amount.x + 5, doc.y, columns.Amount.width - 5, 0.5).fill(_colorTxt);
			doc.moveDown();
		}

	}

	function rxBillingNextPage(doc, rptData, columns, currentPage, continueItems) {

		// continue on the next page

		// footer
		addFooter(doc, new Date());

		// new page
		doc.addPage({
			size: 'letter',
			layout: 'portrait',
			margins: {
				top: _pgMargin,
				left: _pgMargin,
				bottom: 0,
				right: _pgMargin
			}
		});

		// re-write top of next page continued...
		rxBillingTop(doc, rptData, columns, currentPage, continueItems);

	}

	function rxBilling(rptData){

		// params
		if(!!!rptData) {
			throw new Error('report.pdf.billingSummary, data param missing');
		}

		var defer = $q.defer();

		// clean up invoice number alphanumeric with dash allowed
		var billNum = '';
		if(typeof(rptData.BillNumber) !== 'undefined') {
			billNum = rptData.BillNumber.toString().trim().toUpperCase();
			billNum = billNum.replace(/[^A-Z0-9-]+/g,'');
		}

		// build rpt name (Verity-RXNAME-Invoice-BillNumber-OCT2015.pdf)
		var rptName =  rptData.RXID + '-' + rptData.CEID +'-Verity'+'-Invoice-' + billNum + '-' + utilSvc.dt.monthShortText(rptData.BillDate) + rptData.BillDate.getDate().toString() + '-' + rptData.BillDate.getFullYear().toString() + '.pdf';

		// create pdf doc and stream
		var doc = new PDFDocument({
			size: 'letter',
			layout: 'portrait',
			margins: {
				top: _pgMargin,
				left: _pgMargin,
				bottom: 0,
				right: _pgMargin
			}
		});
		var stream = doc.pipe(blobStream());
		var saveY = doc.y;

		// setup doc margins and _columns
		initPdfDoc(doc);

		// default font for document
		doc.font(_pgFont);

		// line item columns
		// note: giving description 3.5 column width and giving the rest 0.5 column width
		var columns = {};
		columns.Quantity = {x: _col.x1, width: _colWidth * 0.5};
		columns.Description = {x: columns.Quantity.x + columns.Quantity.width, width: _colWidth * 3.5};
		columns.Price = {x: columns.Description.x + columns.Description.width, width: _colWidth * 0.5};
		columns.Amount = {x: columns.Price.x + columns.Price.width, width: _colWidth * 0.5};


		// top of page (same for every page)
		rxBillingTop(doc, rptData, columns, 1, true);

		// line items
		var newLine = null,
			currentPage = 1,
			isDrugLine = true;

		for(var i = 0; i < rptData.Items.length; i++) {

			// lines are in groups of 2, 1 drug, 1 fee
			if(i % 2 === 0) {
				isDrugLine = true;

				// continued on next page?
				if(doc.y > _pgHeight - _pgMargin - 40) {
					currentPage++;
					rxBillingNextPage(doc, rptData, columns, currentPage, true);
				}
				else if(i > 0) {
					// draw row seperator line
					doc.y += 5;
					doc.rect(_col.x1 + 5, doc.y, _lineWidth, 0.5).fill(_colorLightGray);
					doc.fill(_colorTxt);
					doc.y += 5;
				}

			}
			else {
				isDrugLine = false;
			}

			// write line
			newLine = rptData.Items[i];
			saveY = doc.y;
			doc.fontSize(_pxSmallText).text(newLine.Quantity === null ? '' : newLine.Quantity, columns.Quantity.x, saveY, {width: columns.Quantity.width, align: 'right'});
			doc.fontSize(_pxSmallText).text(newLine.LineDesc, columns.Description.x, saveY, {width: columns.Description.width, align: 'right'});
			doc.fontSize(_pxSmallText).text(newLine.LinePrice, columns.Price.x, saveY, {width: columns.Price.width, align: 'right'});
			doc.fontSize(_pxSmallText).text(newLine.LineAmount, columns.Amount.x, saveY, {width: columns.Amount.width, align: 'right'});

			// is this a drug line? add second description line
			if(isDrugLine) {
				doc.fontSize(_pxSmallText).text(newLine.LineDesc2, columns.Description.x, doc.y, {width: columns.Description.width, align: 'right'});
			}

		}

		// next page?
		var bumpDownTotal = 25;
		if(doc.y > _pgHeight - _pgMargin - 150) {
			currentPage++;
			rxBillingNextPage(doc, rptData, columns, currentPage, false);

			addSectionTitle(doc, 'Invoice Line Items Continued...', true); // true is no bottom line
			bumpDownTotal = 5;
		}

		// total due
		doc.y += bumpDownTotal;
		addTotalRight(doc, 'Total Due', rptData.TotalDue, true);
		doc.y += 10;

		// terms notice
		doc.fill(_colorTxt);
		doc.fontSize(_pxText).text('Terms: Due Upon Receipt');
		doc.moveDown();

		// remit to address (on left)
		doc.fontSize(_pxText).text('Please Remit Payment to:');
		doc.fontSize(_pxText).text('Verity Solutions');
		doc.fontSize(_pxText).text('PO Box 631392');
		doc.fontSize(_pxText).text('Cincinnati, OH  45263-1392');

		// questions
		addQuestions(doc, '340BAccounting@verity340b.com');

		// footer
		addFooter(doc, new Date());

		// flush doc, async wait for stream finish
		doc.end();
		stream.on('finish', function() {
			var pdfBlob = stream.toBlob('application/pdf');
			try {
				$window.saveAs(pdfBlob, utilSvc.regex.cleanFilename(rptName));
				defer.resolve(null);
			}
			catch(err) {
				defer.reject(err);
			}
		});

		return defer.promise;

	}


	/**
	 *    RX ROLLUP
	 */

	function rxRollupTop(doc, rptData, columns, pageNum, continueItems) {

		// write out the top of each page

		// top right text (changes on continued pages)
		var topRightText = $filter('date')(rptData.StartDate, "MMM dd, yyyy").toString() + ' - ' +
			$filter('date')(rptData.EndDate, "MMM dd, yyyy").toString();

		if(pageNum > 1) {
			topRightText += ' - Page ' + pageNum.toString();
		}

		// header
		addHeader(doc,
			'Verity Solutions',
			'Rollup Pharmacy Invoice',
			topRightText
		);

		// rx, ce
		doc.fill(_colorTxt);
		addLineX(doc, 'Rollup Pharmacy:', _col.x1, rptData.RXNAME + ' (' + rptData.RxShortName + ')', _col.x2);
		doc.moveDown();

		// more line items to come?
		if(continueItems) {

			// line items title
			var continueText = pageNum > 1 ? ' Continued...' : '';
			addSectionTitle(doc, 'Pharmacy List' + continueText);
			doc.fill(_colorTxt);
			doc.y += 10;

			// line item headers
			var saveY = doc.y;
			doc.fontSize(_pxSmallText).text('Pharmacy', columns.Description.x, saveY, {width: columns.Description.width, align: 'left'});
			doc.fontSize(_pxSmallText).text('Admin Fees', _col.x1, saveY, {width: _lineWidth - _pgRightIndent, align: 'right'});
			doc.fontSize(_pxSmallText).text('Order Invoiced', _col.x1, saveY, {width: _lineWidth, align: 'right'});

			// header underline
			doc.rect(_pgMargin, doc.y, _lineWidth, 0.5).fill(_colorTxt);
			doc.moveDown();
		}

	}

	function rxRollupNextPage(doc, rptData, columns, currentPage, continueItems) {

		// continue on the next page

		// footer
		addFooter(doc, new Date());

		// new page
		doc.addPage({
			size: 'letter',
			layout: 'portrait',
			margins: {
				top: _pgMargin,
				left: _pgMargin,
				bottom: 0,
				right: _pgMargin
			}
		});

		// re-write top of next page continued...
		rxRollupTop(doc, rptData, columns, currentPage, continueItems);

	}

	function rxRollup(rptData){

		// params
		if(!!!rptData) {
			throw new Error('report.pdf.rxRollup, rpt data is missing');
		}

		var defer = $q.defer();

		// build rpt name (Verity-CENAME-Report-OCT2015.pdf)
		var rxName = utilSvc.aff.rxShortNameById($rootScope.User.AffList, rptData.RXID);
		var rptName = 'Verity-' + rxName + '-Invoice-' + utilSvc.dt.monthShortText(rptData.StartDate) + rptData.StartDate.getFullYear().toString() + '.pdf';

		// create pdf doc and stream
		var doc = new PDFDocument({
			size: 'letter',
			layout: 'portrait',
			margins: {
				top: _pgMargin,
				left: _pgMargin,
				bottom: 0,
				right: _pgMargin
			}
		});
		var stream = doc.pipe(blobStream());
		var saveY = doc.y;

		// setup doc margins and _columns
		initPdfDoc(doc);

		// default font for document
		doc.font(_pgFont);

		// line item columns
		// note: giving description 3.5 column width and giving the rest 0.5 column width
		var columns = {};
		columns.Description = {x: _col.x1, width: _colWidth * 3.5};
		columns.RxAdminFees = {x: _col.x1 + columns.Description.width, width: _colWidth * 0.5};
		columns.Amount = {x: columns.Description.x + columns.Description.width, width: _colWidth * 1};


		// top of page (same for every page)
		rxRollupTop(doc, rptData, columns, 1, true);

		// line items
		var newLine = null,
			currentPage = 1,
			isDrugLine = true;

		for(var i = 0; i < rptData.Items.length; i++) {

			// continued on next page?
			if(doc.y > _pgHeight - _pgMargin - 40) {
				currentPage++;
				rxRollupNextPage(doc, rptData, columns, currentPage, true);
			}
			else if(i > 0) {
				// draw row seperator line
				doc.y += 5;
				doc.rect(_col.x1, doc.y, _lineWidth, 0.5).fill(_colorLightGray);
				doc.fill(_colorTxt);
				doc.y += 5;
			}

			// write line
			newLine = rptData.Items[i];
			saveY = doc.y;
			doc.fontSize(_pxSmallText).text(newLine.RXNAME + '  (' + newLine.RXID + ')', columns.Description.x, saveY, {width: columns.Description.width, align: 'left'});
			doc.fontSize(_pxSmallText).text(newLine.RxAdminFees, _col.x1, saveY, {width: _lineWidth - _pgRightIndent, align: 'right'});
			doc.fontSize(_pxSmallText).text(newLine.TotalAmount, _col.x1, saveY, {width: _lineWidth, align: 'right'});

		}

		// sub total values
		doc.y += 10;
		saveY = doc.y;
		doc.fill(_colorPrimary);
		doc.fontSize(_pxSmallText).text('Totals', columns.Description.x, saveY, {width: columns.Description.width, align: 'left'});
		doc.fontSize(_pxSmallText).text(rptData.TotalRxAdminFees, _col.x1, saveY, {width: _lineWidth - _pgRightIndent, align: 'right'});
		doc.fontSize(_pxSmallText).text(rptData.TotalOrderInvoicedDue, _col.x1, saveY, {width: _lineWidth, align: 'right'});

		// next page?
		var bumpDownTotal = 25;
		if(doc.y > _pgHeight - _pgMargin - 150) {
			currentPage++;
			rxRollupNextPage(doc, rptData, columns, currentPage, false);

			addSectionTitle(doc, 'Pharmacy List Continued...', true); // true is no bottom line
			bumpDownTotal = 5;
		}

		doc.y += bumpDownTotal;

		// grand total due
		addTotalRight(doc, 'Total Due', rptData.TotalDue, true);
		doc.y += 10;

		// terms notice
		doc.fill(_colorTxt);
		doc.fontSize(_pxText).text('Terms: Due Upon Receipt');
		doc.moveDown();

		// remit to address (on left)
		doc.fontSize(_pxText).text('Please Remit Payment to:');
		doc.fontSize(_pxText).text('Verity Solutions');
		doc.fontSize(_pxText).text('PO Box 631392');
		doc.fontSize(_pxText).text('Cincinnati, OH  45263-1392');

		// questions
		addQuestions(doc, '340BAccounting@verity340b.com');

		// footer
		addFooter(doc, new Date());

		// flush doc, async wait for stream finish
		doc.end();
		stream.on('finish', function() {
			var pdfBlob = stream.toBlob('application/pdf');
			try {
				$window.saveAs(pdfBlob, utilSvc.regex.cleanFilename(rptName));
				defer.resolve(null);
			}
			catch(err) {
				defer.reject(err);
			}
		});

		return defer.promise;

	}


	/**
	 *    CE / RX SUMMARY
	 */

	function summaryTop(doc, rptType, rptQuery, continued) {

		var headerTitle = rptType == 'CE' ? 'Facility' : 'Contract Pharmacy';
		var rightText = $filter('date')(rptQuery.StartDate, "MMM dd, yyyy").toString() + ' - ' +
			$filter('date')(rptQuery.EndDate, "MMM dd, yyyy").toString();

		// continued? start new page
		if(continued) {
			rightText += ' - Page 2';

			// new page
			doc.addPage({
				size: 'letter',
				layout: 'portrait',
				margins: {
					top: _pgMargin,
					left: _pgMargin,
					bottom: 0,
					right: _pgMargin
				}
			});
		}

		// header block
		addHeader(doc,
			'Verity 340B',
			headerTitle + ' Report',
			rightText
		);

		// multiple ce / rx title entities
		doc.fill(_colorTxt);
		if(rptType == 'CE') {
			addLineX(doc, 'Facility:', _col.x1, rptQuery.ceList.join(', '), _col.x2);
			if(rptQuery.ceList.length === 1 && rptQuery.rxALL) {
				addLineX(doc, 'Pharmacy:', _col.x1, 'All Pharmacies', _col.x2);
			}
			else {
				addLineX(doc, 'Pharmacy:', _col.x1, rptQuery.rxList.join(', '), _col.x2);
			}
		}
		else {
			addLineX(doc, 'Pharmacy:', _col.x1, rptQuery.rxList.join(', '), _col.x2);
			if(rptQuery.rxList.length === 1 && rptQuery.ceALL) {
				addLineX(doc, 'Facility:', _col.x1, 'All Facilities', _col.x2);
			}
			else {
				addLineX(doc, 'Facility:', _col.x1, rptQuery.ceList.join(', '), _col.x2);
			}
		}

		// continued?
		if(continued) {
			doc.y += 10;
			addTotalRight(doc, '', headerTitle + ' Report Continued...', false);
			doc.fill(_colorTxt);
			doc.y += 10;
		}

	}

	function rxSummary(rptInfo) {

		// params
		if(!!!rptInfo.query || !!!rptInfo.data) {
			throw new Error('report.pdf.rxSummary, params query or data are missing');
		}

		// convert params into report data format
		var rptQuery = rptInfo.query,
			rptData = rptInfo.data;

		var defer = $q.defer();

		// create pdf doc and stream
		var doc = new PDFDocument({
			size: 'letter',
			layout: 'portrait',
			margins: {
				top: _pgMargin,
				left: _pgMargin,
				bottom: 0,
				right: _pgMargin
			}
		});
		var stream = doc.pipe(blobStream());
		var saveY = doc.y;

		// setup doc margins and _columns
		initPdfDoc(doc);

		// default font for document
		doc.font(_pgFont);

		// header
		summaryTop(doc, 'RX', rptQuery, false);

		// gross pharmacy invoices
		addSectionTitle(doc, 'Gross Pharmacy Invoices');
		doc.fill(_colorTxt);
		addLineRight(doc, 'Pharmacy to Facility', rptData.PharmacyPrices);
		addLineRight(doc, 'Dispense Fees for Generic', rptData.GenericFees);
		addLineRight(doc, 'Dispense Fees for Brand', rptData.BrandFees);
		addLineRight(doc, 'Admin Fee', rptData.RxAdminFees);

		doc.fill(_colorPrimary);
		addLineSubTitle(doc, 'Credits');
		doc.fill(_colorTxt);

		addLineRight(doc, 'Merchandise', rptData.Credits);
		addLineRight(doc, 'Dispense Fees for Generic', rptData.CreditGenericFees);
		addLineRight(doc, 'Dispense Fees for Brand', rptData.CreditBrandFees);
		addTotalRight(doc, 'Total Due From Pharmacy', rptData.TotalDueFromPharmacy);

		// dispense statistics
		addSectionTitle(doc, 'Dispense Statistics');
		doc.fill(_colorTxt);
		addLineRight(doc, 'Evaluated', rptData.Dispenses);
		addLineRight(doc, 'New Eligible Dispenses', rptData.NewEligibleDispenses);

		// questions
		addQuestions(doc, 'support@verity340b.com');

		// footer
		addFooter(doc, new Date());

		// build rpt name (Verity-CENAME-Report-OCT2015.pdf)
		var rptName = 'Verity-' + rptQuery.reportName + '-Report-' + utilSvc.dt.monthShortText(rptQuery.StartDate) + rptQuery.StartDate.getFullYear().toString() + '.pdf';

		// flush doc, async wait for stream finish
		doc.end();
		stream.on('finish', function() {
			var pdfBlob = stream.toBlob('application/pdf');
			try {
				$window.saveAs(pdfBlob, utilSvc.regex.cleanFilename(rptName));
				defer.resolve(null);
			}
			catch(err) {
				defer.reject(err);
			}
		});

		return defer.promise;

	}

	function ceSummary(rptInfo) {

		// params
		if(!!!rptInfo.query || !!!rptInfo.data) {
			throw new Error('report.pdf.ceSummary, params query or data are missing');
		}

		// convert params into report data format
		var rptQuery = rptInfo.query,
			rptData = rptInfo.data;

		var defer = $q.defer();

		// create pdf doc and stream
		var doc = new PDFDocument({
			size: 'letter',
			layout: 'portrait',
			margins: {
				top: _pgMargin,
				left: _pgMargin,
				bottom: 0,
				right: _pgMargin
			}
		});
		var stream = doc.pipe(blobStream());
		var saveY = doc.y;

		// setup doc margins and _columns
		initPdfDoc(doc);

		// default font for document
		doc.font(_pgFont);

		// page 1 header
		summaryTop(doc, 'CE', rptQuery, false);

		// gross pharmacy invoices
		addSectionTitle(doc, 'Gross Pharmacy Invoices');
		doc.fill(_colorTxt);
		addLineRight(doc, 'Pharmacy to Facility', rptData.PharmacyPrices);
		addLineRight(doc, 'Dispense Fees for Generic', rptData.GenericFees);
		addLineRight(doc, 'Dispense Fees for Brand', rptData.BrandFees);
		addLineRight(doc, 'Other Dispense Fees', rptData.OtherDispenseFees);
		

		doc.fill(_colorPrimary);
		addLineSubTitle(doc, 'Credits');
		doc.fill(_colorTxt);

		addLineRight(doc, 'Pharmacy to Facility', rptData.Credits);
		addLineRight(doc, 'Dispense Fees for Generic', rptData.CreditGenericFees);
		addLineRight(doc, 'Dispense Fees for Brand', rptData.CreditBrandFees);
		addTotalRight(doc, 'Total Due From Pharmacy', rptData.TotalDueFromPharmacy);

		// 340B savings
		addSectionTitle(doc, '340B Savings');
		doc.fill(_colorTxt);
		addLineRight(doc, 'Total Due From Pharmacy', rptData.TotalDueFromPharmacy);
		addLineRight(doc, 'Verity Monthly Fee', rptData.VerityMonthlyFee);
		addLineRight(doc, 'Verity Order Fees', rptData.OrderFees);
		addLineRight(doc, 'Verity Referral Order Fees', rptData.ReferralFees);
		addLineRight(doc, 'Verity Monthly Matching Fees', rptData.VerityMonthlyMatchFees);
		addSubTotalRight(doc, 'Net To Facility', rptData.NetToCE);
		doc.fill(_colorTxt);
		addLineRight(doc, '340B Order Cost', rptData.CEPrices);

		doc.fill(_colorPrimary);
		addLineSubTitle(doc, 'Credits');
		doc.fill(_colorTxt);

		addLineRight(doc, 'Merchandise', rptData.CreditsCEPrices);
		addTotalRight(doc, 'Total 340B Savings', rptData.Total340bSavings);

		addSectionTitle(doc, 'Billing Corrections');
		doc.fill(_colorTxt);

		addLineRight(doc, 'Claim Reimbursements', rptData.CorrectionPrices);
		addLineRight(doc, 'Brand Fees', rptData.CorrectionBrandFees);
		addLineRight(doc, 'Generic Fees', rptData.CorrectionGenericFees);
		addTotalRight(doc, 'Total Due to Pharmacy', rptData.CorrectionTotalDue);
		addTotalRight(doc, 'Total Order Fees Due to Verity', rptData.CorrectionOrderFees);
		addTotalRight(doc, 'Total Referral Order Fees Due to Verity', rptData.CorrectionReferralFees);

		// next page
		addFooter(doc, new Date());
		summaryTop(doc, 'CE', rptQuery, true);

		// dispense stats
		addSectionTitle(doc, 'Dispense Statistics');
		doc.fill(_colorTxt);
		addLineRight(doc, 'Evaluated', rptData.Dispenses);
		addLineRight(doc, 'Not Matched', rptData.DispensesNotMatched);

		// match stats
		addSectionTitle(doc, 'Match Statistics');
		doc.fill(_colorTxt);
		addLineRight(doc, 'New Matches', rptData.NewMatchedDispenses);
		addLineRight(doc, 'Reversed Matches', rptData.ReversedMatches);
		addLineRight(doc, 'Fill Date Not Eligible', rptData.ProviderFiltered);
		addLineRight(doc, 'Medicaid Not Eligible', rptData.MedicaidFiltered);
		addLineRight(doc, 'Written Date Not Eligible', rptData.VisitProximityFiltered);
		addLineRight(doc, 'NPI Written Date Not Eligible', rptData.NpiProximityFiltered);
		addLineRight(doc, 'Reject Script Not Eligible', rptData.BlockedScriptFiltered);
		addLineRight(doc, 'Patient Location Not Eligible', rptData.LocationFiltered);
		addLineRight(doc, 'ePrescribe NPI Not Eligible', rptData.ErxNpiFiltered);
		addLineRight(doc, 'Misc Not Eligible', rptData.MiscFiltered);
		addTotalRight(doc, 'New Eligible Dispenses', rptData.NewEligibleDispenses);
		addTotalRight(doc, 'New Matches Accepted from Suspect', rptData.AcceptedSuspects);

		// match ratios
		addSectionTitle(doc, 'Match Ratios');
		doc.fill(_colorTxt);
		addLineRight(doc, 'Matched Dispenses', rptData.MatchedRatio + '%');
		addLineRight(doc, 'Eligible Dispenses', rptData.EligibleDispensesRatio + '%');
		addLineRight(doc, 'Eligible Matches', rptData.EligibleMatchesRatio + '%');

		// questions
		addQuestions(doc, 'support@verity340b.com');

		// footer
		addFooter(doc, new Date());

		// build rpt name (Verity-CENAME-Report-OCT2015.pdf)
		var rptName = 'Verity-' + rptQuery.reportName + '-Report-' + utilSvc.dt.monthShortText(rptQuery.StartDate) + rptQuery.StartDate.getFullYear().toString() + '.pdf';

		// flush doc, async wait for stream finish
		doc.end();
		stream.on('finish', function() {
			var pdfBlob = stream.toBlob('application/pdf');
			try {
				$window.saveAs(pdfBlob, utilSvc.regex.cleanFilename(rptName));
				defer.resolve(null);
			}
			catch(err) {
				defer.reject(err);
			}
		});

		return defer.promise;

	}


	/**
	 *    FORMAT HELPERS
	 */

	function addHeader(doc, title, subtitle, date) {

		// header text indent
		var titleIndent = {
			x: _pgMargin + 6,
			y: _pgMargin + 10
		};

		// bkg _color
		doc.rect(_pgMargin, _pgMargin, _lineWidth, 56).fill(_colorPrimary);

		// title
		doc.fill(_colorWhite);
		doc.y += 8;
		doc.fontSize(_pxTitle).text(title, _pgMargin + 6);

		// sub-title
		var saveY = doc.y;
		doc.fontSize(_pxSubtitle).text(subtitle, _pgMargin + 6);

		// date
		doc.fontSize(_pxSubtitle).text(date, _col.x1, saveY, {width: _lineWidth - 6, align: 'right'});

		doc.y += 15;

	}

	function addLineX(doc, desc, descX, detail, detailX) {
		doc.fontSize(_pxText).text(desc, descX, doc.y, {lineBreak: false});
		doc.fontSize(_pxText).text(detail, detailX, doc.y);
	}

	function addLineRight(doc, desc, detail) {
		doc.fontSize(_pxText).text(desc, _pgMargin, doc.y, {lineBreak: false});
		doc.fontSize(_pxText).text(detail, {align: 'right'});
	}

	function addLineSubTitle(doc, desc) {
		doc.fontSize(_pxText).text(desc, _pgMargin, doc.y);
	}

	function addSectionTitle(doc, desc, noline) {
		doc.fill(_colorPrimary);
		doc.y += 30;
		doc.fontSize(_pxSubtitle).text(desc, _pgMargin);
		if(!!!noline) {
			doc.rect(_pgMargin, doc.y, _lineWidth, 2).fill(_colorPrimary);
		}
		doc.fontSize(_pxText).moveDown();
	}

	function addSubTotalRight(doc, desc, detail) {

		// add _color
		doc.fill(_colorPrimary);

		// add top line
		var drawX = _pgWidth - _pgMargin - _pgRightIndent;
		doc.rect(drawX, doc.y - 1, _pgRightIndent, 1).fill(_colorPrimary);
		doc.y += 3;

		addLineRight(doc, desc, detail);

	}

	function addTotalRight(doc, desc, detail, topline) {

		// add _color
		doc.fill(_colorPrimary);

		// add topline?
		if(!!topline) {
			doc.rect(_pgMargin, doc.y, _lineWidth, 1).fill(_colorPrimary);
			doc.y += 5;
		}

		var saveY = doc.y;
		doc.fontSize(_pxBigText).text(desc, _col.x1, saveY, {width: _lineWidth - _pgRightIndent, align: 'right'});
		doc.fontSize(_pxBigText).text(detail, _col.x1, saveY, {width: _lineWidth, align: 'right'});

	}

	function addQuestions(doc, email) {
		var questionsY = _pgHeight - _pgMargin - 30;
		doc.x = _pgMargin;
		doc.y = questionsY;

		doc.fill(_colorPrimary);
		doc.fontSize(_pxBigText).text('Contact Email: ' + email);
		doc.fontSize(_pxBigText).text('Main Phone: 1-800-581-1378');
	}

	function addFooter(doc, genDate) {
		var footerStart = _pgHeight - _pgMargin + 10;
		doc.fill(_colorTxt);
		doc.rect(_pgMargin, footerStart - 5, _lineWidth, 1).fill(_colorTxt);
		// doc.fontSize(_pxSmallText).text('Verity, Inc. 11335 NE 122nd Way, Suite 200, Kirkland, WA 98034', _col.x1, footerStart, {lineBreak: false});
		doc.fontSize(_pxSmallText).text('Generated: ' +  $filter('date')(genDate, "MMM dd, yyyy").toString(), _col.x1, footerStart, {width: _lineWidth, align: 'right'});
	}

} 
remittanceReportCtl.$inject = ['$rootScope', '$scope', '$state', '$window', '$timeout', 'reportRepo', 'utilSvc', 'validSvc', 'msgSvc', 'errSvc', 'appConst'];
angular
.module('espui.report')
.controller('RemittanceReportCtl', remittanceReportCtl);

/* @ngInject */
function remittanceReportCtl($rootScope, $scope, $state, $window, $timeout, reportRepo, utilSvc, validSvc, msgSvc, errSvc, appConst) {

	var vm = this;
	var _pendingExcelFilename = '',
		_pagingEventListener = null,
		_mouseLeaveDelay = {};

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addMultiselect(vm);
	msgSvc.addHelpLink(vm);

	// props
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';

	// query
	vm.query = {};
	vm.queryChangeCE = queryChangeCE;
	vm.dateRangeChange = dateRangeChange;
	vm.querySubmit = querySubmit;
	vm.UserType  = $rootScope.User.Type;

	// models
	vm.tbl = {};

	// filters
	vm.flt = {};
	vm.filterChange = filterChange;

	// generate PDF / Excel
	vm.downloadPayments = downloadPayments;
	vm.getExcel = getExcel;

	// multiselect
	vm.CeMultiselect = {};
	vm.multiselectCeToggle = multiselectCeToggle;
	vm.multiselectMouseHover = multiselectMouseHover;


	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(vm.flt, vm.tbl.Items, true);

	});


	/**
	 *    DESTROY
	 *    release reportRepo cached data
	 */
	$scope.$on('$destroy', function() {
		if(_pagingEventListener) {
			_pagingEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		vm.init = true;
		initQueryAndFilters();

		// fire date control event after widget scope is setup
		$timeout(function() {
			$scope.$broadcast('widget.input.date.range.mode', {mode: vm.query.DateRangeMode, keepDates: false});
		}, 200);

	}

	function getAffs() {
		var affs = utilSvc.aff.findStatus($scope.User.AffList);
		return  utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
	}

	function initQueryAndFilters() {
		vm.flt = vm.initFilters({
			Config: {
				Dates: ['PaymentDate'],
				DateFmt: 'M/d/yyyy'
			},
			SortBy: ['-PaymentDate']
		});

		vm.query = reportRepo.queryVM();

		// date default
		vm.query.DateRangeValid = false;
		vm.query.DateRangeList = utilSvc.widget.dateRangeList(['CUSTOM92']);

		// add yearly options
		vm.query.DateRangeList.push({label: 'Last 12 Months', value: 'LTM'});
		vm.query.DateRangeList.push({label: 'Yearly', value: 'YEARLY'});
		vm.query.DateRangeList.push({label: 'Year To Date', value: 'YTD'});

		// unlimited custom range (move min validation dates to app start)
		// note: reportRepo does this by default but want to explicitly set it JIC repo changes in future
		var dtToday = new Date(),
			dtAppStart = utilSvc.dt.zeroTime(appConst.app.liveDate),
			customRangeDays = parseInt(utilSvc.dt.diffDays(dtAppStart, dtToday));
		vm.query.StartDate.min = dtAppStart;
		vm.query.EndDate.min = dtAppStart;
		vm.query.DateRangeList.push({label: 'Custom Date Range', value: 'CUSTOM' + customRangeDays.toString()});

		vm.query.DateRangeMode = 'MTD';

		// CE multiselect
		vm.CeMultiselect = {
			type: 'CE',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Facility',
			vals: [],
			list: vm.multiselectBuild(utilSvc.aff.ceList(getAffs()), false),
			flt: ''
		};
		vm.query.CE.vals = [];

		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';
		if(vm.query.CE.fail == 'no') {
			queryChangeCE(vm.query.CE.val);
		}
		else {
			queryChangeCE('|CLEAR|');
		}
	}


	/**
	 *    VIEWMODELS
	 */

	function displayVM(dataItems, tooMany) {
		dataItems = Array.isArray(dataItems) ? dataItems : [];

		return {
			DataItems: dataItems,
			Items: [], // items will be loaded by filterChange() method
			TooMany: !!tooMany
		};
	}


	/**
	 *    QUERY CHANGE
	 */

	function queryChange() {

		if(!vm.init) {
			vm.action = '';
			vm.tbl = {};
			$scope.$broadcast('widget.paging');
		}
	}

	function multiselectCeToggle(evt, id) {
		multiselectToggle(evt, vm.CeMultiselect, id);
	}

	function queryChangeCE(val) {

		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.multiselectClick(vm.CeMultiselect, val);
		vm.multiselectTitle(vm.CeMultiselect, true);

		vm.query.CE.fail = vm.CeMultiselect.vals.length < 1 ? 'yes' : 'no';
	}

	function dateRangeChange(dtMode, isValid) {
		queryChange();
		vm.query.DateRangeMode = dtMode;
		vm.query.DateRangeValid = isValid;
		vm.init = false;
	}


	/**
	 *    QUERY: SUBMIT
	 */

	function queryValid(q, ceVals) {
		q.CE.fail = ceVals.length < 1 ? 'yes' : 'no';
		return q.DateRangeValid && q.CE.fail == 'no';
	}

	function querySubmit() {

		// validate
		var ceVals = multiselectQueryVals(vm.CeMultiselect);
		if(!queryValid(vm.query, ceVals)) {
			msgSvc.ok('Search', 'Check filter settings');
			return;
		}

		if(vm.isWaiting) {
			return;
		}
		queryChange();

		// assign multi values
		vm.query.CE.vals = ceVals;

		vm.isWaiting = true;
		msgSvc.wait(true);
		reportRepo.getRemittance(vm.query).then(okData, errData);

		function okData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.tbl = displayVM(r.data, r.TooMany);
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			vm.flt.Ready = true;
			vm.action = 'LIST';
		}

		function errData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('unknown error getting data', 'indigentCtl.querySubmit', r.status, utilSvc.http.safeResponse(r));
			}

		}
	}


	/**
	 *    FILTER: CHANGE
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

		}, delayTime);

	}
	/**
	 *    EXCEL
	 *    get file from server
	 */


	function downloadPayments(item) {

		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		_pendingExcelFilename = item.CE  + "-"+ item.CheckNum + '-Payments.xlsx';

		$timeout(function() {
			// small delay for digest cycle to delete repo memory
			reportRepo.remittanceExcelDetail(item, _pendingExcelFilename).then(okServerExcel, errServerExcel);
		}, 300);


		function okServerExcel(binaryData) {

			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

		}

		function errServerExcel(r) {

			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r !== null) {
				r = r || {};
				errSvc.warn('Create Excel Error', 'indigentCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}

	function getExcel() {

		// already working?
		if (vm.isWaiting) {
			return;
		}

		// blob support?
		if (!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		_pendingExcelFilename = 'Verity-' + utilSvc.dt.toServerString(vm.query.StartDate.val) + '-' +
			utilSvc.dt.toServerString(vm.query.EndDate.val) + '-Payments.xlsx';

		$timeout(function() {
			// small delay for digest cycle to delete repo memory
			reportRepo.remittanceExcel(vm.query, _pendingExcelFilename).then(okServerExcel, errServerExcel);
		}, 300);


		function okServerExcel(binaryData) {

			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

		}

		function errServerExcel(r) {

			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r !== null) {
				r = r || {};
				errSvc.warn('Create Excel Error', 'indigentCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}

	/**
	 *    MULTISELECT HELPERS
	 */

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if(vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		multiselect.flt = '';

		// don't bother with width if hiding
		if(multiselect.show) {
			multiselect.show = false;
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;

	}

	function multiselectMouseHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}

	function multiselectQueryVals(multiselect) {

		// unpack the vals multiselect into a list of entities to query

		var checklist = multiselect.list,
			vals = multiselect.vals;

		if(vals.length < 1) {
			return [];
		}
		else if(vals.length === 1 && vals[0] == 'ALL') {
			// using ALL checkbox, return all values except ALL checkbox
			var result = [],
				i = checklist[0].val == 'ALL' ? 1 : 0;
			for(i; i < checklist.length; i++) {
				result.push(checklist[i].val);
			}
			return result;
		}
		else {
			return vals;
		}
	}

}
 
reportCtl.$inject = ['$scope', '$state', '$window', '$timeout', '$filter', 'reportRepo', 'lookupRepo', 'sessionRepo', 'prefsRepo', 'reportPDF', 'utilSvc', 'validSvc', 'msgSvc', 'errSvc', 'appConst', 'opsAsyncRepo'];
angular
.module('espui.report')
.controller('ReportCtl', reportCtl);

/* @ngInject */
function reportCtl($scope, $state, $window, $timeout, $filter, reportRepo, lookupRepo, sessionRepo, prefsRepo, reportPDF, utilSvc, validSvc, msgSvc, errSvc, appConst, opsAsyncRepo) {

	var vm = this;
	var _useCache = false,
		_rptType = '',
		_tsReportType = '',
		_pendingExcelFilename = '',
		_featureName = '',
		_pagingEventListener = null,
		_tblViewEventListener = null,
		_tabFilters = {},
		_mouseLeaveDelay = {},
		_savedReports = [],
		_savedReportPending = {},
		_ceRxOptions = [],
		_ceOwnUseLookup = {},
		_cpfrExcelJobId = null,
		_cpfrExcelPollStartTime = null,
		_asyncJobsRefreshTimer = null;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addMultiselect(vm);
	utilSvc.ctl.addTableViews(vm);
	msgSvc.addHelpLink(vm);

	// props
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.showInactiveAffs = 'yes';
	vm.excludeUnaffils = 'no';
	vm.fetchByImpDate = 'no'; //Search External Invoiced Claims by Import Date (CP Financial only)
	vm.popup = {};
	vm.ceHasOwnUse = 'no';
	vm.hasCPTPARx = 'no';

	// query
	vm.query = {};
	vm.queryChangeCE = queryChangeCE;
	vm.queryChangeRX = queryChangeRX;
	vm.dateRangeChange = dateRangeChange;
	vm.querySubmit = querySubmit;
	vm.queryChangeAcct = queryChangeAcct;
	vm.queryChangeInactiveAffs = queryChangeInactiveAffs;
	vm.queryChangeExcludeUnaffils = queryChangeExcludeUnaffils;
	vm.queryChangeFetchByImpDate = queryChangeFetchByImpDate;

	// models
	vm.summary = {};
	vm.tbl = {};

	// filters
	vm.flt = {};
	vm.filterChange = filterChange;

	// tabs
	vm.tabChange = tabChange;
	vm.reportTab = '';

	// generate PDF / Excel
	vm.createPDF = createPDF;
	vm.createExcel = createExcel;

	// summary compare
	vm.compare = {Data:{}};
	vm.compareDateRangeList = [];
	vm.compareToggle = compareToggle;
	vm.compareLoadData = compareLoadData;

	// html display helpers
	vm.displayQuarter = displayQuarter;
	vm.displayQuarterMonths = displayQuarterMonths;

	// multiselect / droplist
	vm.CeMultiselect = {};
	vm.RxMultiselect = {};
	vm.AcctDroplist = [];
	vm.multiselectCeToggle = multiselectCeToggle;
	vm.multiselectRxToggle = multiselectRxToggle;
	vm.multiselectMouseHover = multiselectMouseHover;
	vm.rxMultiHasModel = rxMultiHasModel;
	vm.rxMultiToggleModel = rxMultiToggleModel;
	vm.rxMultiModelFilter = rxMultiModelFilter;
	vm.rxShowClearSelections = rxShowClearSelections;

	// time series
	vm.ts = {};
	vm.tsMetricDroplist = [];
	vm.tsToggle = tsToggle;
	vm.tsChangeMetric = tsChangeMetric;
	vm.tsChangeInterval = tsChangeInterval;
	vm.tsChangeType = tsChangeType;
	vm.tsExcel = tsExcel;

	// cp financial
	vm.isFinancial = false;

	// table view
	vm.tblViewConfig = {};
	vm.tblView = {};
	vm.closePopup = closePopup;

	// async reports (legacy — other report types)
	vm.asyncReports = {};
	vm.toggleAsyncReports = toggleAsyncReports;

	// async jobs (CPFR export)
	vm.asyncJobs = {};
	vm.toggleAsyncJobs = toggleAsyncJobs;
	vm.asyncJobsRefresh = asyncJobsRefresh;
	vm.asyncJobsFilterChange = asyncJobsFilterChange;
	vm.asyncJobsSortBy = asyncJobsSortBy;
	vm.asyncJobsSortByIcon = asyncJobsSortByIcon;
	vm.asyncJobsDownload = asyncJobsDownload;
	vm.asyncJobsPageChange = asyncJobsPageChange;


	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(vm.flt, vm.tbl.Items, true);

	});


	/**
	 *    TIMESERIES EVENT
	 */

	var _tsEventListener = $scope.$on('widget.timeseries.action', function(event, evtData) {
		event.stopPropagation();

		// exit if timeseries or filter is already gone
		if(vm.reportTab != 'SUMMARY' || vm.action != 'TIMESERIES') {
			return;
		}

		var d = evtData || {};

		// filter changed
		if(d.action == 'flt' && !!d.flt) {
			vm.ts.dirty = true;

			// store table filter by interval
			var fltKey = vm.ts.type + vm.ts.interval;
			vm.ts.prefs.flt[fltKey] = d.flt;
		}

	});


	/**
	 *    SAVED REPORT EVENT
	 */

	var _savedReportListener = $scope.$on('widget.savedreports.action', function(event, evtData) {
		event.stopPropagation();
		//console.log('sr event: ' + evtData.action);

		if(vm.isWaiting) {
			return;
		}

		evtData = evtData || {};
		var reports = getSavedReports();

		switch(evtData.action) {

			case 'remove':
				_savedReportPending = evtSavedReportRemove(reports, evtData.id, evtData.current);
				break;

			case 'add':
				_savedReportPending = evtSavedReportAdd(reports, evtData.name);
				break;

			case 'current':
				_savedReportPending = evtSavedReportCurrent(reports, evtData.id);
				break;

			default:
				alert('reportCtl.evtSavedReport, unknown event type: ' + evtData.action);
		}

		// event failed
		if(!validSvc.isText(_savedReportPending.id) && _savedReportPending.action != 'remove') {
			//console.log('sr failed');
			return;
		}

		// send add/remove changes to server
		if(_savedReportPending.action == 'add' || _savedReportPending.action == 'remove') {
			sessionRepo.set(srKey(), {version: srVersion(), reports: reports});
			prefsRepo.savedReports(srKey(), srVersion(), reports).then(okSavedReportsToServer, errSavedReportsToServer);
		}
		else {
			// change current report: load data by calling date change event
			//console.log("ok sr, calling date event");
			$scope.$broadcast('widget.input.date.range.mode', {uniqueId: 'queryDates', mode: vm.query.DateRangeMode, keepDates: true});
		}
	});


	/**
	 *    TABLEVIEW EVENT
	 */

	_tblViewEventListener = $scope.$on('widget.tblview.editor.change', function(event, evtData) {
		event.stopPropagation();

		switch(evtData.type) {

			case 'edit':
				openPopup();
				break;

			case 'close':
				closePopup();
				break;

			case 'load':
				// load specific view requested
				vm.tblView.current = evtData.id;
				$timeout(function() {
					tblViewReload(true);
					
					// update user preference (delay the network call)
					if(isFinTab(vm.reportTab)) {
						$timeout(function() {
							var tblConfig = vm.tblViewConfig[vm.reportTab];
							if(!!tblConfig && !!vm.tblView && validSvc.isText(vm.tblView.current)) {
								prefsRepo.setCurrentTableView(tblConfig.storageKey, vm.tblView.current).then(okCurrentTableView, errCurrentTableView);
							}
						}, 2000);
					}
				}, 300);
				break;

			default:
				throw new Error('reportCPFIN, widget.tblview.editor.change, unknown event type: ' + evtData.type);
		}
	});


	/**
	 *    DESTROY
	 *    release reportRepo cached data
	 */
	$scope.$on('$destroy', function() {

		if(_pagingEventListener) {
			_pagingEventListener();
		}
		if(!!_tsEventListener) {
			_tsEventListener();
		}
		if(!!_savedReportListener) {
			_savedReportListener();
		}
		if(!!_tblViewEventListener) {
			_tblViewEventListener();
		}

		if(_rptType == 'CE') {
			reportRepo.destroyCE();
		}
		else {
			reportRepo.destroyRX();
		}

	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		_featureName = $state.current.name;

		switch(_featureName) {
			case 'report.ce':
				_rptType = 'CE';
				_tsReportType = 'CE';
				break;
			case 'report.cpfin':
				_rptType = 'CE';
				_tsReportType = 'CP';
				vm.isFinancial = true;
				vm.showInactiveAffs = 'no';
				vm.tblViewConfig = tblViewConfigSetup(tblViewSchemaVM());
				vm.asyncReports = initAsyncReports();
				vm.asyncJobs = initAsyncJobs();
				break;
			case 'report.rx':
				_rptType = 'RX';
				_tsReportType = 'RX';
				break;
			default:
				throw new Error('reportCtl.init, state unknown: ' + $state.current.name);
		}

		vm.init = true;
		var queryAffs = initQueryAndFilters();
		if(_rptType == 'CE') {
			// ASYNC: build CE options, own use, etc
			getCeRxOptions(queryAffs);
		}
		else {
			// RX is not async, finish now
			initFinalize();
		}
	}

	function initAsyncReports() {
		return {
			title: 'CP Financial - Saved Files',
			show: 'no'
		};
	}

	function getAffs() {
		var findStatus = vm.showInactiveAffs == 'yes' ? ['ONBOARDING', 'ACTIVE', 'INACTIVE'] : ['ONBOARDING', 'ACTIVE'];
		var affs = utilSvc.aff.findStatus($scope.User.AffList, findStatus);
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);

		// per Georgia, we should be limiting affiliation options by business model
		affs = utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));

		// per Georgia, CP Financial does not require Billing
		if(!vm.isFinancial) {
			affs = utilSvc.aff.findRxBilling(affs);
		}

		return affs;
	}

	function initQueryAndFilters() {

		vm.query = reportRepo.queryVM();

		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';
		vm.query.RX.fail = validSvc.isRX(vm.query.RX.val) ? 'no' : 'yes';
		vm.query.CE.vals = [];
		vm.query.RX.vals = [];

		vm.query.multi = false;
		vm.query.bigdate = false;
		vm.query.onlySummary = false;

		// date default
		vm.query.DateRangeValid = false;
		vm.query.DateRangeList = utilSvc.widget.dateRangeList(['CUSTOM92']);

		// add yearly options
		vm.query.DateRangeList.push({label: 'Last 12 Months', value: 'LTM'});
		vm.query.DateRangeList.push({label: 'Yearly', value: 'YEARLY'});
		vm.query.DateRangeList.push({label: 'Year To Date', value: 'YTD'});

		// unlimited custom range (move min validation dates to app start)
		// note: reportRepo does this by default but want to explicitly set it JIC repo changes in future
		var dtToday = new Date(),
			dtAppStart = utilSvc.dt.zeroTime(appConst.app.liveDate),
			customRangeDays = parseInt(utilSvc.dt.diffDays(dtAppStart, dtToday));
		vm.query.StartDate.min = dtAppStart;
		vm.query.EndDate.min = dtAppStart;
		vm.query.DateRangeList.push({label: 'Custom Date Range', value: 'CUSTOM' + customRangeDays.toString()});

		vm.query.DateRangeMode = 'MTD';

		vm.query.Acct = 'ALL';

		// compare date list is hard coded and hidden by CSS
		vm.compareDateRangeList = [
			{label:'Last Month To Date', value:'LMTD'},
			{label:'Monthly', value:'MONTHLY'},
			{label:'Last Quarter To Date', value:'LQTD'},
			{label:'Last Year To Date', value:'LYTD'},
			{label:'Previous Last 12 Months', value:'LLTM'}
		];

		// CE multiselect
		vm.CeMultiselect = {
			type: 'CE',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Facility',
			vals: [],
			list: [],
			flt: ''
		};

		// RX multiselect
		vm.RxMultiselect = {
			type: 'RX',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Pharmacy',
			vals: [],
			list: [],
			flt: '',
            fltRxModels: []
		};

		var affs = getAffs();

		if(_rptType == 'CE') {
			vm.AcctDroplist = utilSvc.ng.droplist(['ALL', '340B','OWN']);

			var ceList = utilSvc.aff.ceList(affs);
			vm.CeMultiselect.list = vm.multiselectBuild(ceList, false);
		}
		else if(_rptType == 'RX') {

			var rxList = utilSvc.aff.rxList(affs);
			vm.RxMultiselect.list = vm.multiselectBuildRX(rxList, false, affs);
			if(vm.query.RX.fail == 'no' && rxList.indexOf(vm.query.RX.val)) {
				queryChangeRX(vm.query.RX.val);
			}
			else {
				vm.query.CE.fail = 'yes';
				vm.query.RX.fail = 'yes';
			}
		}
		else {
			throw new Error('reportCtl.initQuery, rptType unknown: ' + _rptType);
		}

		return affs;

	}

	function getCeRxOptions(affs) {
		// ASYNC: build rx affs list, ce own use, find any rx rollup parents

		_ceRxOptions = [];

		var uniqueOptions = [],
			aff = {};
		
		for(var i = 0; i < affs.length; i++) {
			aff = affs[i];

			// add aff
			_ceRxOptions.push({
				CEID: aff.CEID,
				RXID: aff.RXID,
				RxType: aff.RxType,
				RxShortName: aff.RxShortName + ' - ' + aff.RxType,
                RxBizModel: aff.RxBizModel
			});

			// has rollup parent?
			if(validSvc.isText(aff.RxParent)) {

				// add unique CE / rollup aff options
				if(uniqueOptions.indexOf(aff.CEID + aff.RxParent) < 0) {
					uniqueOptions.push(aff.CEID + aff.RxParent);

					_ceRxOptions.push({
						CEID: aff.CEID,
						RXID: aff.RxParent,
						RxType: 'ROLLUP',
						RxShortName: '', // shortname filled in after lookup
                        RxBizModel: aff.RxBizModel
					});
				}
			}
		}

		// lookup CE own use
		vm.isWaiting = true;
		var ceList = utilSvc.aff.ceList(affs);
		if(ceList.length > 0) {
			lookupRepo.CeInfo(ceList).then(okCeLookup, errCeLookup);
		}
		else {
			okCeLookup([]);
		}
	}

	function okCeLookup(r) {
		vm.isWaiting = false;
		// build ce own use lookup, finish init or rx lookup next

		r = Array.isArray(r) ? r : [];
		_ceOwnUseLookup = {
			found: false
		};

		// loop CEs for own use
		var ceid = '';
		for(var i=0;i<r.length;i++) {
			if(!!r[i].OwnUseProgram) {
				_ceOwnUseLookup.found = true;
				ceid = r[i].NickName;
				_ceOwnUseLookup[ceid] = true;
			}
		}

		// lookup rx parents or finish CE
		var rxParents = utilSvc.aff.rxList(utilSvc.aff.findRxType(_ceRxOptions, ['ROLLUP']));
		if(rxParents.length < 1) {
			initFinalizeCE();
		}
		else {
			// get rollup short names
			vm.isWaiting = true;
			lookupRepo.RxInfo(rxParents).then(okLookupRx, errLookupRx);
		}
	}

	function errCeLookup(r) {
		vm.isWaiting = false;
		if(!!r) {
			errSvc.warn('Error loading ce lookup properties', 'CE reportCtl.errLookupCe', r.status, utilSvc.http.safeResponse(r));
		}
	}

	function okLookupRx(items) {
		vm.isWaiting = false;
		items = Array.isArray(items) ? items : [];

		var rxid = '',
			ii = 0;

		// add short names to rollups
		for(var i = 0; i < _ceRxOptions.length; i++) {
			if(_ceRxOptions[i].RxType == 'ROLLUP') {
				rxid = _ceRxOptions[i].RXID;
				for(ii = 0; ii < items.length; ii++) {
					if(rxid == items[ii].NickName) {
						_ceRxOptions[i].RxShortName = items[ii].ShortName + ' - ROLLUP';
					}
				}
			}
		}

		initFinalizeCE();

	}

	function errLookupRx(r) {
		vm.isWaiting = false;
		if(!!r) {
			errSvc.warn('Error loading rollup display properties', 'CE reportCtl.errLookupRx', r.status, utilSvc.http.safeResponse(r));
		}
	}

	function initFinalizeCE() {
		if(vm.query.CE.fail == 'no') {
			queryChangeCE(vm.query.CE.val);
		}
		else {
			vm.query.CE.fail = 'yes';
			vm.query.RX.fail = 'yes';
		}

		initFinalize();
	}

	function initFinalize() {
		// default tab filters
		_tabFilters = initFilters();

		// load saved reports, add widget details
		_savedReports = getSavedReports(true);

		// viewstate, return to report automatically tbd...

		// setup titles
		vm.multiselectTitle(vm.CeMultiselect, true);
		vm.multiselectTitle(vm.RxMultiselect, true);

		// fire date control event after widget is rendered
		$timeout(function() {
			$scope.$broadcast('widget.input.date.range.mode', {uniqueId: 'queryDates', mode: vm.query.DateRangeMode, keepDates: false});
			if(Array.isArray(_savedReports) && _savedReports.length > 0) {
				$scope.$broadcast('widget.savedreports', {action: 'reports', reports: _savedReports});
			}
		}, 200);
	}

	function loadSavedQuery(storeType, vsq) {

		// load query from viewstate or saved report

		var vsAffs = getAffs();
		if(vsAffs.length < 1) {
			return false;
		}

		if(_rptType == 'CE') {
			vm.CeMultiselect.list = vm.multiselectBuild(utilSvc.aff.ceList(vsAffs), false);
			vm.multiselectReturnVisit(vm.CeMultiselect, '', vsq.CE);

			// rebuild RX list, use _ceRxOptions (includes rollup parents) instead of raw affs
			vm.RxMultiselect.vals = vsq.RX;
			vm.RxMultiselect = multiselectRebuildSecondary(vm.CeMultiselect, vm.RxMultiselect, _ceRxOptions, true);

			// Acct is displayed if CE list has own use
			vm.query.Acct = validSvc.isText(vsq.Acct) ? vsq.Acct : 'ALL';
			vm.ceHasOwnUse = ceValsHaveOwnUse(vm.CeMultiselect.vals) ? 'yes' : 'no';
		}
		else {
			vm.RxMultiselect.list = vm.multiselectBuild(utilSvc.aff.rxList(vsAffs), false);
			vm.multiselectReturnVisit(vm.RxMultiselect, '', vsq.RX);

			// rebuild CE list
			vm.CeMultiselect.vals = vsq.CE;
			vm.CeMultiselect = multiselectRebuildSecondary(vm.RxMultiselect, vm.CeMultiselect, vsAffs, true);
		}

		// did multiselect rebuild work?
		vm.query.CE.fail = vm.CeMultiselect.vals.length < 1 ? 'yes' : 'no';
		vm.query.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';
		if(vm.query.CE.fail == 'yes' || vm.query.RX.fail == 'yes') {
			// fail both
			vm.query.CE.fail = 'yes';
			vm.query.RX.fail = 'yes';
			return false;
		}

		// assign sub-properties
		vm.query.DateRangeMode = storeType == 'sr' ? vsq.DateMode : vsq.DateRangeMode;
		vm.query.StartDate.val = validSvc.isDate(vsq.StartDate) ? new Date(vsq.StartDate) : null;
		vm.query.EndDate.val = validSvc.isDate(vsq.EndDate) ? new Date(vsq.EndDate) : null;
		vm.query.DateRangeValid = true;

		if(storeType == 'vs') {
			_tabFilters = vs.tabFilters;
		}

		return true;

	}

	function initFilters() {

		// setup table filters for all tabs

		return {
			SUMMARY: vm.initFilters({
				HideField: {
					SummaryOtherDispenseFees: true
				}
			}),

			FIN_SUMMARY:  vm.initFilters({
				HideField: {
					SummaryOtherDispenseFees: true
				}
			}),

			ORDER: vm.initFilters({
				Config: {
					Dates: ['OrderDate', 'InvoiceDate'],
					DateFmt: 'M/d/yyyy'
				},
				HideField: {
					OtherFees: true
				},
				SortBy: ['OrderDate']
			}),

			FIN_ORDER: vm.initFilters({
				Config: {
					Dates: ['OrderDate', 'InvoiceDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['OrderDate']
			}),

			FIN_INVOICES: vm.initFilters({
				Config: {
					Dates: ['OrderDate', 'InvoiceDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['OrderDate']
			}),

			FIN_INVOICE_ITEMS: vm.initFilters({
				Config: {
					Dates: ['OrderDate', 'InvoiceDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['InvoiceDate']
			}),

			INVOICE: vm.initFilters({
				Config: {
					Dates: ['OrderDate', 'InvoiceDate'],
					DateFmt: 'M/d/yyyy'
				},
				HideField: {
					OtherFees: true
				},
				SortBy: ['InvoiceDate']
			}),

			FIN_DISP: vm.initFilters({
				Config: {
					Dates: ['OrderDate', 'InvoiceDate', 'DispFillDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['InvoiceDate']
			}),

			FIN_TPA_CLAIMS: vm.initFilters({
				Config: {
					Dates: ['OrderDate', 'InvoiceDate', 'DispFillDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['InvoiceDate']
			}),

			FIN_PAYMENTS: vm.initFilters({
				Config: {
					Dates: ['PaymentDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['PaymentDate']
			}),

			DISP: vm.initFilters({
				Config: {
					Dates: ['OrderDate', 'InvoiceDate', 'DispFillDate'],
					DateFmt: 'M/d/yyyy'
				},
				HideSection: {
					Inv: false,
					Drug: false,
					Pat: true,
					Disp: false,
					Used: false
				},
				HideField: {
					OtherFees: true
				},
				SortBy: ['InvoiceDate']
			}),

			COR: vm.initFilters({
				Config: {
					Dates: ['DispFillDate', 'CorrectionDate'],
					DateFmt: 'M/d/yyyy'
				},
				HideSection: {
					Drug: false,
					Disp: false,
					Used: false,
					Cor: false
				},
				HideField: {
					OtherFees: true
				},
				SortBy: ['InvoiceDate']
			})
		};

	}


	/**
	 *    VIEWMODELS
	 */

	function displayVM(tab, dataItems, tooMany) {

		// shared by all report tabs except summary

		dataItems = Array.isArray(dataItems) ? dataItems : [];

		var rxRpt = _rptType == 'RX',
			item = {},
			tabFinOrder = tab == 'FIN_ORDER',
			tabInvoice = tab == 'INVOICE',
			tabDisp = tab == 'DISP',
			tabCor = tab == 'COR',
			tabFinInvoices = tab == 'FIN_INVOICES',
			tabFinInvItems = tab == 'FIN_INVOICE_ITEMS',
			tabFinDisp = tab == 'FIN_DISP',
			tabFinTpa = tab == 'FIN_TPA_CLAIMS';

		// hide/show other fees field
		var testOtherFees = false;
		if(!!vm.flt.HideField && tab == 'DISP') {
			testOtherFees = true;
			vm.flt.HideField.OtherFees = true;
		}

		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			
			// test tabs with bools, this will run much faster than string compare for every row
			if(tabInvoice || tabDisp || tabCor) {
				// TPA Source, pack it into the CEID field for tabs: Invoice Items, Used In Orders, Corrections
				if(rxRpt) {
					item.CETPA = tab == 'COR' ? item.CEID : item.OrderCEID;
					if(validSvc.isText(item.SourceTPA)) {
						item.CETPA += '|' + item.SourceTPA;
					}
				}
				// ce and rx referral yes/no
				item.DispReferral = !!item.DispReferral ? 'YES' : 'NO';
				// show Other Fees field if dispense fee exists
				if(testOtherFees && item.OtherDispenseFee !== 0) {
					testOtherFees = false;
					vm.flt.HideField.OtherFees = false;
				}
			}
			else if(tabFinInvoices) {
				item.Correction = !!item.Correction ? 'YES' : 'NO';
			}
			else if(tabFinDisp) {
				item.PharmacyCost = item.PharmacyCost;
				item.CorrectionDate = utilSvc.dt.isNull(item.CorrectionDate) ? null : item.CorrectionDate;
			}
			else if(tabFinTpa) {
				item.DispReferral = !!item.DispReferral ? 'YES' : 'NO';
				item.IRA = !!item.IRA ? 'YES' : 'NO';
			}

			// direct replenishment
			if(tabFinOrder || tabFinInvoices || tabFinInvItems || tabFinDisp) {
				item.DirectRep = !!item.DirectReplenish ? 'YES' : 'NO';
				item.IRA = !!item.IRA ? 'YES' : 'NO';
			}
		}

		return {
			DataItems: dataItems,
			Items: [], // items will be loaded by filterChange() method
			TooMany: !!tooMany
		};

	}

	function summaryVM(data) {

		// shared summary properties
		var rpt = {
			isCompare: false,

			// gross rx invoices
			PharmacyPrices: numberFmt(data.PharmacyPrices, '0.00','', 2),
			GenericEachFee: numberFmt(data.GenericEachFee, '0.00','', 2),
			GenericFees: numberFmt(data.GenericFees, '-','-', 2),
			OtherDispenseFees: numberFmt(data.OtherDispenseFees,'0.00','', 2),
			BrandEachFee: numberFmt(data.BrandEachFee, '0.00','', 2),
			BrandFees: numberFmt(data.BrandFees, '-','-', 2),
			AssayFees: numberFmt(data.AssayFees, '-','-', 2),
			Credits: numberFmt(data.Credits, '0.00','-', 2),
			CreditGenericFees: numberFmt(data.CreditGenericFees, '-','', 2),
			CreditBrandFees: numberFmt(data.CreditBrandFees, '-','', 2),
			CreditAssayFees: numberFmt(data.CreditAssayFees, '-','', 2),
			TotalDueFromPharmacy: numberFmt(data.TotalDueFromPharmacy, '0.00','', 2),

			// dispense stats
			Dispenses: numberFmt(data.Dispenses, '0','', 0),
			NewEligibleDispenses: numberFmt(data.NewEligibleDispenses, '0','', 0)
		};

		// Corrections (api controls the positive/negative)
		rpt.CorrectionPrices = numberFmtNoPrefix(data.CorrectionPrices, '-', 2);
		rpt.CorrectionGenericFees = numberFmtNoPrefix(data.CorrectionGenericFees, '-', 2);
		rpt.CorrectionBrandFees = numberFmtNoPrefix(data.CorrectionBrandFees, '-', 2);
		rpt.CorrectionOrderFees = numberFmtNoPrefix(data.CorrectionOrderFees, '-', 2);
		rpt.CorrectionReferralFees = numberFmtNoPrefix(data.CorrectionReferralFees, '-', 2);
		rpt.CorrectionAssayFees = numberFmtNoPrefix(data.CorrectionAssayFees, '-', 2);
		rpt.CorrectionTotalDue = numberFmtNoPrefix(data.CorrectionTotalDue, '-', 2);

		// RX props
		if(_rptType == 'RX') {
			rpt.RxAdminFees = numberFmt(data.RxAdminFees, '-','', 2);
		}

		// CE additional summary properties
		if(_rptType == 'CE') {

			// 340b savings
			rpt.VerityMonthlyFee = numberFmt(data.VerityMonthlyFee, '-','-', 2);
			rpt.OrderEachFee = numberFmt(data.OrderEachFee, '0.00','', 2);
			rpt.OrderFees = numberFmt(data.OrderFees, '-','-', 2);
			rpt.ReferralFees = numberFmt(data.ReferralFees, '-','-', 2);
			rpt.MatchingEachFee = numberFmt(data.MatchingEachFee, '0.00','', 2);
			rpt.VerityMonthlyMatchFees = numberFmt(data.VerityMonthlyMatchFees, '-','-', 2);
			rpt.NetToCE = numberFmt(data.NetToCE,'0.00','', 2);
			rpt.CEPrices = numberFmt(data.CEPrices,'0.00','-', 2);
			rpt.Total340bSavings = numberFmt(data.Total340bSavings, '0.00','', 2);

			rpt.CreditsCEPrices = numberFmt(data.CreditsCEPrices, '-','', 2);

			// dispense stats
			rpt.DispensesNotMatched = numberFmt(data.DispensesNotMatched, '0', '-', 0);
			rpt.NewMatchedDispenses = numberFmt(data.NewMatchedDispenses, '0','', 0);

			// match stats
			rpt.AcceptedSuspects = numberFmtNoPrefix(data.AcceptedSuspects, '0', 0);
			rpt.ProviderFiltered = numberFmt(data.ProviderFiltered, '0','-', 0);
			rpt.MedicaidFiltered = numberFmt(data.MedicaidFiltered, '0','-', 0);
			rpt.VisitProximityFiltered = numberFmt(data.VisitProximityFiltered, '0','-', 0);
			rpt.NpiProximityFiltered = numberFmt(data.NpiProximityFiltered, '0','-', 0);
			rpt.BlockedScriptFiltered = numberFmt(data.BlockedScriptFiltered, '0','-', 0);
			rpt.ErxNpiFiltered = numberFmt(data.ErxNpiFiltered, '0','-', 0);
			rpt.LocationFiltered = numberFmt(data.LocationFiltered, '0','-', 0);
			rpt.MiscFiltered = numberFmt(data.MiscFiltered, '0','-', 0);
			rpt.ReversedMatches = numberFmt(data.ReversedMatches, '0','-', 0);

			// match ratios
			rpt.MatchedRatio = numberFmtNoPrefix(data.MatchedRatio, '0', 0);
			rpt.EligibleDispensesRatio = numberFmtNoPrefix(data.EligibleDispensesRatio, '0', 0);
			rpt.EligibleMatchesRatio = numberFmtNoPrefix(data.EligibleMatchesRatio, '0', 0);
		}

		return rpt;

	}

	function finSummaryVM(data) {

		// financial summary properties
		var rpt = {
			isCompare: false,

			// gross rx invoices
			PharmacyPrices: numberFmtNoPrefix(data.PharmacyPrices, '0.00', 2),
			GenericEachFee: numberFmtNoPrefix(data.GenericEachFee, '0.00', 2),
			GenericFees: numberFmtNoPrefix(data.GenericFees, '0.00', 2),
			BrandEachFee: numberFmtNoPrefix(data.BrandEachFee, '0.00', 2),
			BrandFees: numberFmtNoPrefix(data.BrandFees, '0.00', 2),
			AssayFees: numberFmtNoPrefix(data.AssayFees, '0.00', 2),
			Credits: numberFmtNoPrefix(data.Credits, '0.00', 2),
			CreditGenericFees: numberFmtNoPrefix(data.CreditGenericFees, '0.00', 2),
			CreditBrandFees: numberFmtNoPrefix(data.CreditBrandFees, '0.00', 2),
			CreditAssayFees: numberFmtNoPrefix(data.CreditAssayFees, '0.00', 2),
			// 340B Savings
			TotalDueFromPharmacy: numberFmtNoPrefix(data.TotalDueFromPharmacy, '0.00', 2),
			TotalDue340bDirect: numberFmtNoPrefix(data.TotalDue340bDirect, '0.00', 2),
			OrderFees: numberFmtNoPrefix(data.OrderFees, '0.00', 2),
			ReferralFees: numberFmtNoPrefix(data.ReferralFees, '0.00', 2),

			// dispense stats
			Dispenses: numberFmtNoPrefix(data.Dispenses, '0', 0),
			NewEligibleDispenses: numberFmtNoPrefix(data.NewEligibleDispenses, '0', 0)
		};

		rpt.CorrectionReimburseClaimReverse = numberFmtNoPrefix(data.CorrectionReimburseClaimReverse, '0.00', 2);
		rpt.CorrectionReimburseClaimNewBacking = numberFmtNoPrefix(data.CorrectionReimburseClaimNewBacking, '0.00', 2);
		rpt.CorrectionPrices = numberFmtNoPrefix(data.CorrectionPrices,  '0.00', 2);
		rpt.CorrectionDispenseFeesGenericReversals = numberFmtNoPrefix(data.CorrectionDispenseFeesGenericReversals, '0.00', 2);
		rpt.CorrectionDispenseFeesGenericNewBacking = numberFmtNoPrefix(data.CorrectionDispenseFeesGenericNewBacking,'0.00', 2);
		rpt.CorrectionDispenseFeesBrandReversals = numberFmtNoPrefix(data.CorrectionDispenseFeesBrandReversals, '0.00', 2);
		rpt.CorrectionDispenseFeesBrandNewBacking = numberFmtNoPrefix(data.CorrectionDispenseFeesBrandNewBacking, '0.00', 2);
		rpt.CorrectionTotalDue = numberFmtNoPrefix(data.CorrectionTotalDue, '0.00', 2);

		// 340b savings
		rpt.VerityMonthlyFee = numberFmtNoPrefix(data.VerityMonthlyFee, '0.00', 2);
		rpt.OrderEachFee = numberFmtNoPrefix(data.OrderEachFee, '0.00', 2);
		rpt.OrderFees = numberFmtNoPrefix(data.OrderFees, '0.00', 2);
		rpt.ReferralFees = numberFmtNoPrefix(data.ReferralFees, '0.00', 2);
		rpt.MatchingEachFee = numberFmtNoPrefix(data.MatchingEachFee, '0.00', 2);
		rpt.VerityMonthlyMatchFees = numberFmtNoPrefix(data.VerityMonthlyMatchFees, '0.00', 2);
		rpt.NetToCE = numberFmtNoPrefix(data.NetToCE, '0.00', 2);
		rpt.CEPrices = numberFmtNoPrefix(data.CEPrices, '0.00', 2);
		rpt.OrderCostNet = numberFmtNoPrefix(data.OrderCostNet, '0.00', 2);
		rpt.Total340bSavings = numberFmtNoPrefix(data.Total340bSavings, '0.00', 2);
		rpt.CreditsCEPrices = numberFmtNoPrefix(data.CreditsCEPrices, '0.00', 2);

		// dispense stats
		rpt.DispensesNotMatched = numberFmtNoPrefix(data.DispensesNotMatched, '0', 0);
		rpt.NewMatchedDispenses = numberFmtNoPrefix(data.NewMatchedDispenses, '0', 0);

		// match stats
		rpt.AcceptedSuspects = numberFmtNoPrefix(data.AcceptedSuspects, '0', 0);
		rpt.ProviderFiltered = numberFmtNoPrefix(data.ProviderFiltered, '0', 0);
		rpt.MedicaidFiltered = numberFmtNoPrefix(data.MedicaidFiltered, '0', 0);
		rpt.VisitProximityFiltered = numberFmtNoPrefix(data.VisitProximityFiltered, '0', 0);
		rpt.NpiProximityFiltered = numberFmtNoPrefix(data.NpiProximityFiltered, '0', 0);
		rpt.BlockedScriptFiltered = numberFmtNoPrefix(data.BlockedScriptFiltered, '0', 0);
		rpt.ErxNpiFiltered = numberFmtNoPrefix(data.ErxNpiFiltered, '0', 0);
		rpt.ReversedMatches = numberFmtNoPrefix(data.ReversedMatches, '0', 0);
		rpt.MiscFiltered = numberFmt(data.MiscFiltered, '0','-', 0); // UI handles sign, not API, force negative
		rpt.LocationFiltered = numberFmt(data.LocationFiltered, '0','-', 0); // UI handles sign, not API, force negative

		// match ratios
		rpt.MatchedRatio = numberFmtNoPrefix(data.MatchedRatio, '0', 0);
		rpt.EligibleDispensesRatio = numberFmtNoPrefix(data.EligibleDispensesRatio, '0', 0);
		rpt.EligibleMatchesRatio = numberFmtNoPrefix(data.EligibleMatchesRatio, '0', 0);
		rpt.VerityMonthlyMatchFees = numberFmtNoPrefix(data.VerityMonthlyMatchFees, '0.00', 2);

		// tpa
		rpt.CPTPACreditsDispFeeBrand = numberFmtNoPrefix(data.CPTPACreditsDispFeeBrand, '0.00', 2);
		rpt.CPTPACreditsDispFeeGeneric = numberFmtNoPrefix(data.CPTPACreditsDispFeeGeneric, '0.00', 2);
		rpt.CPTPACreditsDrugCost = numberFmtNoPrefix(data.CPTPACreditsDrugCost, '0.00', 2);
		rpt.CPTPADispFeeBrand = numberFmtNoPrefix(data.CPTPADispFeeBrand, '0.00', 2);
		rpt.CPTPADispFeeGeneric = numberFmtNoPrefix(data.CPTPADispFeeGeneric, '0.00', 2);
		rpt.CPTPADrugCost = numberFmtNoPrefix(data.CPTPADrugCost, '0.00', 2);
		rpt.CPTPAAdjustments = numberFmtNoPrefix(data.CPTPAAdjustments, '0.00', 2);
		rpt.CPTPAPharmacyDue = numberFmtNoPrefix(data.CPTPAPharmacyDue, '0.00', 2);
		rpt.CPTPAOrderCostDebit = numberFmtNoPrefix(data.CPTPAOrderCostDebit, '0.00', 2);
		rpt.CPTPAOrderCostCredit = numberFmtNoPrefix(data.CPTPAOrderCostCredit, '0.00', 2);

		// intact
		rpt.IntacctVerityMonthlyFees = numberFmtNoPrefix(data.IntacctVerityMonthlyFees, '0.00', 2);
		rpt.IntacctVCCFee = numberFmtNoPrefix(data.IntacctVCCFee, '0.00', 2);
		rpt.IntacctVCCBenefitsPaid = numberFmtNoPrefix(data.IntacctVCCBenefitsPaid, '0.00', 2);
		rpt.IntacctExternalTPAFees = numberFmtNoPrefix(data.IntacctExternalTPAFees, '0.00', 2);
		rpt.IntacctTotalPayments = numberFmtNoPrefix(data.IntacctTotalPayments, '0.00', 2);
		rpt.IntacctFacilityTotalPayments = numberFmtNoPrefix(data.IntacctFacilityTotalPayments, '0.00', 2);
		rpt.IntacctTotalMonthlyFees = numberFmtNoPrefix(data.IntacctTotalMonthlyFees, '0.00', 2);

		return rpt;
	}


	/**
	 *    QUERY CHANGE
	 */

	function queryChange() {
		//console.log('query change');
		if(!vm.init) {

			vm.reportTab = '';
			vm.action = '';
			vm.summary = {};
			vm.compare = {Data:{}};

			// reset cache
			_useCache = false;
			reportRepo.destroyCE();
			reportRepo.destroyRX();

			// timeseries, saved reports
			tsReset();
			$scope.$broadcast('widget.savedreports');

			// table
			vm.tbl = {};
			$scope.$broadcast('widget.paging');

			// tableview
			closePopup();
		}

	}

	function multiselectCeToggle(evt, id) {
		vm.RxMultiselect.show = false;
		multiselectToggle(evt, vm.CeMultiselect, id);
	}

	function multiselectRxToggle(evt, id) {
		vm.CeMultiselect.show = false;
		multiselectToggle(evt, vm.RxMultiselect, id);
	}

    // MULTI BIZ MODEL PHARMACY EVENTS

	function rxMultiHasModel(rxModel) {
		if(!!!vm.RxMultiselect || !Array.isArray(vm.RxMultiselect.fltRxModels) || (rxModel != 'CP' && rxModel != 'CPTPA')) {
			return false;
		}
		return vm.RxMultiselect.fltRxModels.indexOf(rxModel) > -1;
	}

    function allRxModelOptionsChecked(list, rxModels) {
        if(!Array.isArray(list) || list.length < 1 || !Array.isArray(rxModels) || rxModels.length < 1) {
            return false;
        }

        var rxModel = '',
            item = null,
            allChecked = true;

        for (var i = 0; i < rxModels.length; i++) {
            rxModel = rxModels[i];
            for (var ii = 0; ii < list.length; ii++) {
                item = list[ii];

                // ignore ALL checklist item
                if(ii == 0 && item.val == 'ALL') {
                    continue;
                }

                // doesn't have this model
                if(!Array.isArray(item.rxModels) || item.rxModels.length < 1 || item.rxModels.indexOf(rxModel) < 0) {
                    continue;
                }

                // has model but not checked
                if(!item.checked) {
                    allChecked = false;
                    break;
                }
            }
            if(!allChecked) {
                break;
            }
        }
        return allChecked;
    }

    function toggleRxModel(multi, rxModel) {
		// add / remove rx model
		var fltModels = Array.isArray(multi.fltRxModels) ? multi.fltRxModels : [];
		var idx = fltModels.indexOf(rxModel);
		if(idx > -1) {
			fltModels.splice(idx, 1);
        }
		else {
            fltModels.push(rxModel);
		}
        return fltModels;
    }

    function itemHasRxModel(itemModels, rxModels) {
        // find if any of the item's models are in the list of models to filter by
        if(!Array.isArray(itemModels) || itemModels.length < 1 || !Array.isArray(rxModels) || rxModels.length < 1) {
            return false;
        }
        for(var i = 0; i < rxModels.length; i++) {
            if(itemModels.indexOf(rxModels[i]) > -1) {
                return true;
            }
        }
        return false;
    }

	function rxMultiToggleModel(rxModel) {
        // used by CPFR only
        // two rx model checkboxes control what is in the list and what "ALL" means
		if(vm.isWaiting || !!!vm.RxMultiselect || (rxModel != 'CP' && rxModel != 'CPTPA')) {
			return;
		}
        var multi = vm.RxMultiselect;
        var rxList = Array.isArray(multi.list) ? multi.list : [];
        
        // apply models to checklist
        var fltModels = toggleRxModel(multi, rxModel);
        multi.fltRxModels = fltModels;
        if(fltModels.length < 1) {
            // no models chosen, clear the list
            vm.multiselectClick(multi, '|CLEAR|');
        }
        else {
            // at least 1 model chosen, apply to checklist
            var isALL = Array.isArray(multi.vals) && multi.vals.length === 1 && multi.vals[0] == 'ALL',
                item = null;

            // rebuild vals from checklist
            multi.vals = [];
            for(var i = 0; i < rxList.length; i++) {
                item = rxList[i];
                // skip ALL checklist item
                if(i == 0 && item.val == 'ALL') {
                    continue;
                }

                if(itemHasRxModel(item.rxModels, fltModels) && (isALL || item.checked)) {
                    multi.vals.push(item.val);
                }
                else {
                    item.checked = false;
                }
            }
        }

        // reset ALL checkbox            
        if(rxList.length > 0 && rxList[0].val == 'ALL') {
            if(fltModels.length < 2) {
                // both models not selected, always uncheck ALL
                rxList[0].checked = false;
            }
            else {
                // use ALL if everything checked
                rxList[0].checked = allRxModelOptionsChecked(rxList, fltModels);
                if(rxList[0].checked && fltModels.length > 1) {
                    multi.vals = ['ALL'];
                }
            }
        }
        vm.multiselectTitle(multi, true);

        vm.query.RX.fail = multi.vals.length < 1 ? 'yes' : 'no';
	}

	function rxShowClearSelections() {
		// show Clear Selections display logic
        
        // only one filter can be on, hide if both on or both off
		var hasCP = rxMultiHasModel('CP');
		var hasCPTPA = rxMultiHasModel('CPTPA');
		if(hasCP == hasCPTPA) {
			return false;
		}

        // visible list count must be > 1
		var list = Array.isArray(vm.RxMultiselect.list) ? vm.RxMultiselect.list : [];
		var visibleCount = 0;
		for(var i = 0; i < list.length; i++) {
			if(list[i].val != 'ALL' && rxMultiModelFilter(list[i])) {
				visibleCount++;
                if(visibleCount > 1) {
                    break;
                }
			}
		}
		return visibleCount > 1;
	}

	function rxMultiModelFilter(item) {
		if(!!!item || !Array.isArray(item.rxModels)) {
			return false;
		}
		if(item.rxModels.indexOf('CP') > -1 && rxMultiHasModel('CP')) {
			return true;
		}
		if(item.rxModels.indexOf('CPTPA') > -1 && rxMultiHasModel('CPTPA')) {
			return true;
		}
		return false;
	}

	function ceValsHaveOwnUse(vals) {
		if(!Array.isArray(vals) || vals.length < 1 || !!!_ceOwnUseLookup.found) {
			return false;
		}
		for(var i = 0; i < vals.length; i++) {
			if(!!_ceOwnUseLookup[vals[i]]) {
				return true;
			}
		}
		return false;
	}

	function rxValsHaveCPTPA(vals) {
		// check if any selected RX values have CPTPA business model
		if(!Array.isArray(vals) || vals.length < 1 || !Array.isArray(_ceRxOptions) || _ceRxOptions.length < 1) {
			return false;
		}
		var checkAll = vals.length === 1 && vals[0] == 'ALL';
		for(var j = 0; j < _ceRxOptions.length; j++) {
			var opt = _ceRxOptions[j];
			if(opt.RxBizModel == 'CPTPA' && (checkAll || vals.indexOf(opt.RXID) > -1)) {
				return true;
			}
		}
		return false;
	}

	function queryChangeCE(val) {

		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.multiselectClick(vm.CeMultiselect, val);
		vm.multiselectTitle(vm.CeMultiselect, true);

		vm.query.CE.fail = vm.CeMultiselect.vals.length < 1 ? 'yes' : 'no';

		// CE > RX > Account
		if(_rptType == 'CE' && vm.query.CE.fail == 'no') {
			vm.RxMultiselect = multiselectRebuildSecondary(vm.CeMultiselect, vm.RxMultiselect, _ceRxOptions, true);
			vm.query.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';

			// Acct is displayed if CE list has own use
			vm.query.Acct = 'ALL';
			vm.ceHasOwnUse = ceValsHaveOwnUse(vm.CeMultiselect.vals) ? 'yes' : 'no';
			
			// Check if selected RX values include CPTPA
			console.log("Before fetchByImpDate value is and vm.hasCPTPARx is" + vm.fetchByImpDate, vm.hasCPTPARx);
			console.log("Checking CPTPA in queryChangeCE with vals: " + vm.RxMultiselect.vals);
			vm.hasCPTPARx = rxValsHaveCPTPA(vm.RxMultiselect.vals) ? 'yes' : 'no';
			console.log("Result of CPTPA check: " + vm.hasCPTPARx);
		}
	}

    function getRxModelVals(list, rxModel, useChecked) {
        // get all possible vals for this rx model
        var result = [];
        if(!Array.isArray(list) || list.length < 1 || (rxModel != 'CP' && rxModel != 'CPTPA')) {
            return result;
        }
        for(var i = 0; i < list.length; i++) {
            var item = list[i];
            if(Array.isArray(item.rxModels) && item.rxModels.indexOf(rxModel) > -1) {
                if(!useChecked || item.checked) {
                    result.push(item.val);
                }
            }
        }

        return result;
    }

    function adjustMultiValsByRxModel(val, vals, list, rxModel) {
        // handle multiselect check/uncheck for an rx model
        var isALL = vals.length > 0 && vals[0] == 'ALL';

        // ALL clicked: toggle OFF
        if(val == 'ALL' && isALL) {
            return [];
        }

        // ALL clicked: toggle ON
        if(val == 'ALL' && !isALL) {
            return getRxModelVals(list, rxModel, false); // ignore checked state, get them all
        }

        // list item clicked
        // to toggle a single val, convert ALL value into specific values, respect checked state in list
        var result = isALL ? getRxModelVals(list, rxModel, true) : vals;

        // toggle item
        var idx = result.indexOf(val);
        if(idx > -1) {
            result.splice(idx, 1);
        }
        else {
            result.push(val);
        }

        return result;
    }

    function applyMultiValsToRxModelList(vals, list, rxModel) {
        // apply vals to checklist by model
        var hasCP = rxModel === 'CP',
            hasCPTPA = rxModel === 'CPTPA',
            optionsCount = 0,
            optionsChecked = 0;

        for(var i = 0; i < list.length; i++) {
            var item = list[i];

            // skip ALL checklist item for now
            if(i === 0 && item.val == 'ALL') {
                continue;
            }

            // process only if it has a matching model
            if((hasCP && item.rxModels.indexOf('CP') > -1) ||
                (hasCPTPA && item.rxModels.indexOf('CPTPA') > -1)) {
                item.checked = vals.indexOf(item.val) > -1;
                optionsCount++;
                optionsChecked += item.checked ? 1 : 0;
            }
        }

        // ALL is never checked when only one model filter is active
        if(list.length > 0 && list[0].val == 'ALL') {
            list[0].checked = false;
        }

        return list;
    }

	function queryChangeRX(val) {

		if(vm.isWaiting) {
			return;
		}
		queryChange();

        // cpfr handles ALL toggle differently if both checkboxes are not selected
        if(vm.isFinancial) {
            var multi = vm.RxMultiselect;
            var fltModels = Array.isArray(multi.fltRxModels) ? multi.fltRxModels : [];

            // CLEAR was sent in or models is != 1, just apply the click without special filter logic
            if(val == '|CLEAR|' || fltModels.length !== 1) {
                vm.multiselectClick(multi, val);
            }
            else {
                // only 1 model is being used
                // use custom multiselect functions to apply check by rx model
                var rxModel = fltModels[0],
                    vals = Array.isArray(multi.vals) ? multi.vals : [],
                list = Array.isArray(multi.list) ? multi.list : [];

                vals = adjustMultiValsByRxModel(val, vals, list, rxModel);
                multi.vals = vals;
                
                list = applyMultiValsToRxModelList(vals, list, rxModel);
                multi.list = list;
            }
        }
        else {
            vm.multiselectClick(vm.RxMultiselect, val);
        }

		vm.multiselectTitle(vm.RxMultiselect, true);
		vm.query.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';

		// Check if selected RX values include CPTPA
		console.log("Before fetchByImpDate value is and vm.hasCPTPARx is" + vm.fetchByImpDate, vm.hasCPTPARx);
		console.log("Checking CPTPA in queryChangeRX with vals: " + vm.RxMultiselect.vals);
		vm.hasCPTPARx = rxValsHaveCPTPA(vm.RxMultiselect.vals) ? 'yes' : 'no';
		console.log("Result of CPTPA check: " + vm.hasCPTPARx);

		// rebuild CE
		if(_rptType == 'RX') {
			vm.CeMultiselect = multiselectRebuildSecondary(vm.RxMultiselect, vm.CeMultiselect, getAffs(), true);
			vm.query.CE.fail = vm.CeMultiselect.vals.length < 1 ? 'yes' : 'no';
		}
	}

	function queryChangeAcct() {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		// no other logic needed, dropdown limits options
		// there really is no validation, any value is allowed
	}

	function queryChangeInactiveAffs() {
		// add or remove INACTIVE status affiliations from CE/RX droplists
		// note: so far this is only for CP Financial

		if(vm.isWaiting) {
			return;
		}
		queryChange();
		
		vm.showInactiveAffs = vm.showInactiveAffs == 'no' ? 'yes' : 'no';

		// rebuild CE/RX options all the way back to init
		var affs = getAffs();
		var ceList = utilSvc.aff.ceList(affs);
		vm.CeMultiselect.list = vm.multiselectBuild(ceList, false);
		getCeRxOptions(affs);
	}

	function dateRangeChange(uniqueId, dtMode, isValid) {

		switch(uniqueId) {

			case 'queryDates':
				//console.log('dt change with sr action: ' + _savedReportPending.action);
				queryChange();
				vm.query.DateRangeMode = dtMode;
				vm.query.DateRangeValid = isValid;

				if(_savedReportPending.action == 'current') {
					//console.log('dt change: pending current before submit');
					querySubmit();
				}
				vm.init = false;

				break;

			case 'compareDates':
				// summary compare
				vm.compare.DateRangeMode = dtMode;
				vm.compare.DateRangeValid = isValid;

				// user must choose before query
				if(dtMode == 'QTR' || dtMode == 'YEARLY') {
					vm.action = 'COMPAREQUERY';
				}

				// when summary compare loads it fires this mode change, do query on this event
				if(vm.action != 'COMPAREQUERY') {
					compareLoadData();
				}
				break;

			default:
				alert('reportCtl.dateRangeChange, unknown date range id: ' + uniqueId);
		}

	}

	function queryChangeExcludeUnaffils() {
		// exclude unaffiliated fees from summary 
		if(vm.isWaiting) {
			return;
		}
		queryChange();
		
		vm.excludeUnaffils = vm.excludeUnaffils == 'no' ? 'yes' : 'no';
		// validate
		var ceVals = multiselectQueryVals(vm.CeMultiselect),
			rxVals = multiselectQueryVals(vm.RxMultiselect);

		if(queryValid(vm.query, ceVals, rxVals)) {
			querySubmit();
		}
	}

	function queryChangeFetchByImpDate() {
		// search external invoiced claims by import date
		if(vm.isWaiting) {
			return;
		}
		queryChange();
		
		vm.fetchByImpDate = vm.fetchByImpDate == 'no' ? 'yes' : 'no';
		// validate
		var ceVals = multiselectQueryVals(vm.CeMultiselect),
			rxVals = multiselectQueryVals(vm.RxMultiselect);

		if(queryValid(vm.query, ceVals, rxVals)) {
			querySubmit();
		}
	}
	/**
	 *    QUERY: SUBMIT
	 */

	function queryValid(q, ceVals, rxVals) {

		q.CE.fail = ceVals.length < 1 ? 'yes' : 'no';
		q.RX.fail = rxVals.length < 1 ? 'yes' : 'no';

		return 	q.DateRangeValid && q.CE.fail == 'no' && q.RX.fail == 'no';
	}

	function querySubmit() {
		//console.log('QUERY SUBMIT');

		// validate
		var ceVals = multiselectQueryVals(vm.CeMultiselect),
			rxVals = multiselectQueryVals(vm.RxMultiselect);

		if(!queryValid(vm.query, ceVals, rxVals)) {
			if(!vm.init) {
				msgSvc.ok('Search', 'Check filter settings');
				return;
			}
		}

		if(vm.isWaiting) {
			return;
		}
		queryChange();

		// assign multi values
		vm.query.CE.vals = ceVals;
		vm.query.RX.vals = rxVals;
		vm.query.multi = false;
		if((ceVals[0] == 'ALL' || ceVals.length > 1) && (rxVals[0] == 'ALL' || rxVals.length > 1)) {
			vm.query.multi = true;
		}

        // add rx models for cpfin query based on checked pharmacies
        vm.query.rxModels = vm.isFinancial ? multiselectRxModels(vm.RxMultiselect, true) : [];
        vm.query.useCP = vm.query.rxModels.indexOf('CP') > -1;
        vm.query.useCPTPA = vm.query.rxModels.indexOf('CPTPA') > -1;

		vm.query.bigdate = false;
		var dtMode = vm.query.DateRangeMode;
		if(dtMode == 'YEARLY' || dtMode == 'YTD' || dtMode == 'LTM' || dateRangeIsCustom(dtMode)) {
			vm.query.bigdate = utilSvc.dt.diffDays(vm.query.StartDate.val, vm.query.EndDate.val) > 92;
		}

		vm.query.onlySummary = vm.query.multi || vm.query.bigdate;
		vm.query.ExcludeUnaffils = vm.excludeUnaffils == 'yes';
		vm.query.FetchByImpDate = vm.fetchByImpDate == 'yes';

		// reset query, default to SUMMARY tab
		tabChange(vm.isFinancial ? 'FIN_SUMMARY' : 'SUMMARY');

	}


	/**
	 *    FILTER: CHANGE
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			// FIN tables have filter values stored inside table view columns
			if(isFinTab(vm.reportTab)) {
				vm.flt = vm.tblViewGetColumnFilterValues(vm.tblView.cols, vm.flt);
			}

			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: vm.reportTab,
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					saveViewState(vm.query, vm.reportTab, vm.flt);
				}
			},1000);

		}, delayTime);

	}


	/**
	 *    TAB: CHANGE
	 */

	function tabChange(tabName) {
		//console.log('TAB CHANGE');
		if(vm.isWaiting) {
			return;
		}

		// multiple CE/RX choices or big queries are allowed only on summary tab
		if(tabName != 'SUMMARY' && tabName != 'FIN_SUMMARY' && (vm.query.multi || vm.query.bigdate)) {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true, true);

		// reset UI
		vm.action = '';
		vm.summary = {};
		vm.compare = {Data:{}};
		vm.tbl = {};
		vm.popup = {};
		$scope.$broadcast('widget.paging');

		// switch filtering
		vm.flt = vm.resetFilters(_tabFilters[tabName]);
		vm.reportTab = tabName;

		loadReportTab(tabName);

	}


	/**
	 *    LOAD DATA
	 */

	function loadReportTab(tabName) {

		reportRepo.getReportData(_rptType.toLowerCase(), tabName, vm.query, _useCache).then(okData, errData);

		function okData(r) {
			//console.log('OK DATA');
			vm.isWaiting = false;
			msgSvc.wait(false);

			// query successful, keep data in repo
			_useCache = true;

			var rptTab = vm.reportTab;

			if(rptTab == 'SUMMARY' || rptTab == 'FIN_SUMMARY') {
				if (r.OtherDispenseFees) {
					vm.flt.HideField.SummaryOtherDispenseFees = false;
				} else {
					vm.flt.HideField.SummaryOtherDispenseFees = true;
				}
				vm.summary = vm.isFinancial ? finSummaryVM(r) : summaryVM(r);

				// show comparison prompt?
				vm.compare.prompt = false;
				switch(vm.query.DateRangeMode) {
					case 'MONTHLY':
						vm.compare.prompt = true;
						vm.compare.title = 'Compare With Previous Month';
						break;
					case 'MTD':
						vm.compare.prompt = true;
						vm.compare.title = 'Compare With Previous Month To Date';
						break;
					case 'QTD':
						vm.compare.prompt = true;
						vm.compare.title = 'Compare With Previous Quarter To Date';
						break;
					case 'QTDLAST':
					case 'QTR':
						vm.compare.prompt = true;
						vm.compare.title = 'Compare With Another Quarter';
						break;
					case 'YTD':
						vm.compare.prompt = true;
						vm.compare.title = 'Compare With Previous Year To Date';
						break;
					case 'LTM':
						vm.compare.prompt = true;
						vm.compare.title = 'Compare With Previous Last 12 Months';
						break;
					case 'YEARLY':
						vm.compare.prompt = true;
						vm.compare.title = 'Compare With Another Year';
						break;
				}

				// update saved report widget query				
				$timeout(function() {
					//console.log('sr update query: ' + _savedReportPending.id);
					$scope.$broadcast('widget.savedreports', {
						action: 'query',
						query: {
							details: savedReportWidgetDetailsFmt(
								vm.query.CE.vals,
								vm.query.RX.vals,
								vm.query.Acct,
								vm.query.DateRangeMode,
								vm.query.StartDate.val,
								vm.query.EndDate.val
								)
							},
							current: _savedReportPending.id
						});
					_savedReportPending = {};
				},500);
					
			}
			else {

				vm.tbl = displayVM(rptTab, r.Items, r.TooMany);
				vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);

				// update paging ui
				$scope.$broadcast('widget.paging', {
					uniqueId: rptTab,
					Size: vm.flt.PageSize,
					Page: vm.flt.Page,
					Total: vm.flt.PageTotal,
					RowCount: vm.flt.Count,
					ItemCount: vm.tbl.Items.length,
					DataCount: vm.tbl.DataItems.length
				});

				// tableview for this tab
				if(isFinTab(rptTab)) {
					tblViewReload(false, true); // keep filter paging on tab change
				}

				vm.flt.Ready = true;
			}


			vm.action = 'LIST';

		}

		function errData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Error loading report tab: ' + vm.reportTab, 'report.ctl.loadReportTab', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    SUMMARY COMPARISON
	 */

	function compareToggle() {

		// turn compare display on/off

		if(vm.action == 'COMPAREQUERY' || vm.action == 'COMPARE') {
			// toggle off
			vm.compare.Data = {};
			vm.action = 'LIST';
		}
		else {
			// toggle on

			vm.compare.DateRangeValid = false;

			// setup Compare dates based on query mode
			var compareKeepDates = false;
			switch(vm.query.DateRangeMode) {

				case 'MONTHLY':
					// default to previous month from query
					vm.compare.DateRangeMode = 'MONTHLY';
					compareKeepDates = true;
					vm.query.CompareStartDate.val = utilSvc.dt.addMonths(utilSvc.dt.monthStart(vm.query.StartDate.val), -1);
					vm.query.CompareEndDate.val = utilSvc.dt.monthEnd(vm.query.CompareStartDate.val);
					break;

				case 'MTD':
					vm.compare.DateRangeMode = 'LMTD';
					break;

				case 'QTD':
					vm.compare.DateRangeMode = 'LQTD';
					break;

				case 'QTDLAST':
				case 'QTR':
					vm.compare.DateRangeMode = 'QTR';
					break;

				case 'YTD':
					vm.compare.DateRangeMode = 'LYTD';
					break;

				case 'LTM':
					vm.compare.DateRangeMode = 'LLTM';
					break;

				case 'YEARLY':
					vm.compare.DateRangeMode = 'YEARLY';
					break;

				default:
					alert('reportCtl.compareToggle, unsupported query date mode for comparison: ' + vm.query.DateRangeMode);
					return;
			}

			$timeout(function() {
				// note: date mode change event will advance UI to action = COMPARE
				$scope.$broadcast('widget.input.date.range.mode', {uniqueId: 'compareDates', mode: vm.compare.DateRangeMode, keepDates: compareKeepDates});
			}, 100);

		}
	}

	function compareLoadData() {

		if(vm.isWaiting) {
			return;
		}

		// dates are valid?
		if(!vm.compare.DateRangeValid) {
			msgSvc.ok('Summary Compare', 'Check date values.');
			vm.action = 'COMPAREQUERY';
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true, true);

		var compareType = vm.isFinancial ? 'cp' : _rptType.toLowerCase();
		reportRepo.getReportData(compareType, 'COMPARE', vm.query, false).then(okCompData, errCompData);

		function okCompData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.compare.Data = vm.isFinancial ? finSummaryVM(r) : summaryVM(r);
			vm.action = 'COMPARE';
		}

		function errCompData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Error loading report tab: ' + vm.reportTab, 'report.loadSummaryCompare', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    TIME SERIES
	 */

	function timeseriesVM() {

		var defaultType = 'AGGREGATE',
			defaultInterval = 'MONTH';

		return {
			dirty: false,
			type: '',
			subtype: '',
			action: 'LOAD',
			metric: '',
			interval: '',
			prefs: {
				type: defaultType,
				subtype: 'FIN',
				metric: _tsReportType == 'RX' ? 'TotalDueFromPharmacy' : 'Total340bSavings',
				interval: defaultInterval,
				flt: {}
			},
			colHeaders: [],
			data: []
		};
	}

	function initTimeSeriesDroplist() {

		switch(_tsReportType) {
			case 'CP':
				return [
					{value:'PharmacyPrices', label:'V340B Direct Pharmacy Invoices - Pharmacy Invoiced Drug Cost', fmt: 'currency', subtype: 'FIN'},
					{value:'GenericFees', label:'V340B Direct Pharmacy Invoices - Dispense Fees for Generic', fmt: 'currency', subtype: 'FIN'},
					{value:'BrandFees', label:'V340B Direct Pharmacy Invoices - Dispense Fees for Brand', fmt: 'currency', subtype: 'FIN'},
					{value:'Credits', label:'V340B Direct Pharmacy Invoices - Credits Pharmacy To Facility', fmt: 'currency', subtype: 'FIN'},
					{value:'CreditGenericFees', label:'V340B Direct Pharmacy Invoices - Credits Dispense Fees for Generic', fmt: 'currency', subtype: 'FIN'},
					{value:'CreditBrandFees', label:'V340B Direct Pharmacy Invoices - Credits Dispense Fees for Brand', fmt: 'currency', subtype: 'FIN'},

					{value:'CorrectionReimburseClaimReverse', label:'V340B Direct Corrections - Reimbursement Claim Reversals and Blocks', fmt: 'currency', subtype: 'FIN'},
					{value:'CorrectionReimburseClaimNewBacking', label:'V340B Direct Corrections - Reimbursement Claim New Backing', fmt: 'currency', subtype: 'FIN'},
					{value:'CorrectionTotalDue', label:'V340B Direct Corrections - Net Reimbursement Claim Billing Corrections', fmt: 'currency', subtype: 'FIN'},
					{value:'CorrectionDispenseFeesGenericReversals', label:'V340B Direct Corrections - Dispense Fee for Generic Reversals and Blocks', fmt: 'currency', subtype: 'FIN'},
					{value:'CorrectionDispenseFeesGenericNewBacking', label:'V340B Direct Corrections - Dispense Fee for Generic New Backing', fmt: 'currency', subtype: 'FIN'},
					{value:'CorrectionDispenseFeesBrandReversals', label:'V340B Direct Corrections - Dispense Fee for Brand Reversals and Blocks', fmt: 'currency', subtype: 'FIN'},
					{value:'CorrectionDispenseFeesBrandNewBacking', label:'V340B Direct Corrections - Dispense Fee for Brand New Backing', fmt: 'currency', subtype: 'FIN'},

					{value:'CPTPADrugCost', label:'External TPA Pharmacy Invoices - Pharmacy Invoiced Drug Cost', fmt: 'currency', subtype: 'FIN'},
					{value:'CPTPADispFeeGeneric', label:'External TPA Pharmacy Invoices - Dispense Fees for Generic', fmt: 'currency', subtype: 'FIN'},
					{value:'CPTPADispFeeBrand', label:'External TPA Pharmacy Invoices - Dispense Fees for Brand', fmt: 'currency', subtype: 'FIN'},
					{value:'CPTPACreditsDrugCost', label:'External TPA Pharmacy Invoices - Credits Pharmacy Invoiced Drug Cost', fmt: 'currency', subtype: 'FIN'},
					{value:'CPTPACreditsDispFeeGeneric', label:'External TPA Pharmacy Invoices - Credits Dispense Fees for Generic', fmt: 'currency', subtype: 'FIN'},
					{value:'CPTPACreditsDispFeeBrand', label:'External TPA Pharmacy Invoices - Credits Dispense Fees for Brand', fmt: 'currency', subtype: 'FIN'},
					{value:'CPTPAAdjustments', label:'External TPA Pharmacy Invoices - Adjustments and True-Ups', fmt: 'currency', subtype: 'FIN'},
					{value:'CPTPAPharmacyDue', label:'External TPA Pharmacy Invoices - External TPA Pharmacy Due', fmt: 'currency', subtype: 'FIN'},

					{value:'TotalDueFromPharmacy', label:'340B Savings - Total Due From Pharmacy', fmt: 'currency', subtype: 'FIN'},
					{value:'VerityMonthlyFee', label:'340B Savings - Verity Monthly Fees', fmt: 'currency', subtype: 'FIN'},
					{value:'OrderFees', label:'340B Savings - Verity Order Fees', fmt: 'currency', subtype: 'FIN'},
					{value:'ReferralFees', label:'340B Savings - Verity Referral Order Fees', fmt: 'currency', subtype: 'FIN'},
					{value:'VerityMonthlyMatchFees', label:'340B Savings - Verity Monthly Matching Fees', fmt: 'currency', subtype: 'FIN'},
					{value:'IntacctVCCFee', label:'340B Savings - Verity Care Card Fees', fmt: 'currency', subtype: 'FIN'},
					{value:'IntacctVCCBenefitsPaid', label:'340B Savings - Verity Care Card Benefits Paid', fmt: 'currency', subtype: 'FIN'},
					{value:'IntacctExternalTPAFees', label:'340B Savings - External TPA Monthly Fees', fmt: 'currency', subtype: 'FIN'},
					{value:'NetToCE', label:'340B Savings - Net to Facility', fmt: 'currency', subtype: 'FIN'},
					{value:'CEPrices', label:'340B Savings - Verity Direct 340B Order Cost (Debits)', fmt: 'currency', subtype: 'FIN'},
					{value:'CreditsCEPrices', label:'340B Savings - Verity Direct 340B Order Cost (Credits)', fmt: 'currency', subtype: 'FIN'},
					{value:'CPTPAOrderCostDebit', label:'340B Savings - External TPA 340B Order Cost (Debits)', fmt: 'currency', subtype: 'FIN'},
					{value:'CPTPAOrderCostCredit', label:'340B Savings - External TPA 340B Order Cost (Credits)', fmt: 'currency', subtype: 'FIN'},
					{value:'OrderCostNet', label:'340B Savings - Net 340B Order Cost', fmt: 'currency', subtype: 'FIN'},
					{value:'Total340bSavings', label:'Total 340B Savings', fmt: 'currency', subtype: 'FIN'},
					{value:'IntacctTotalPayments', label:'Subtotal Selected Pharmacy Remittance', fmt: 'currency', subtype: 'FIN'},
					{value:'IntacctFacilityTotalPayments', label:'Total Facility Remittance Payments', fmt: 'currency', subtype: 'FIN'}
				];

			case 'CE':
				return [
					{value:'PharmacyPrices', label:'Gross Pharmacy - Pharmacy to Facility', fmt: 'currency', subtype: 'FIN'},
					{value:'GenericFees', label:'Gross Pharmacy - Dispense Fees for Generic', fmt: 'currency', subtype: 'FIN'},
					{value:'BrandFees', label:'Gross Pharmacy - Dispense Fees for Brand', fmt: 'currency', subtype: 'FIN'},
					{value:'Credits', label:'Gross Pharmacy - Pharmacy to Facility Credits', fmt: 'currency', subtype: 'FIN'},
					{value:'CreditGenericFees', label:'Gross Pharmacy - Dispense Fee Credits for Generic', fmt: 'currency', subtype: 'FIN'},
					{value:'CreditBrandFees', label:'Gross Pharmacy - Dispense Fee Credits for Brand', fmt: 'currency', subtype: 'FIN'},
					{value:'OtherDispenseFees', label:'Gross Pharmacy - Other Dispense Fees', fmt: 'currency', subtype: 'FIN'},
					{value:'TotalDueFromPharmacy', label:'Total Due From Pharmacy', fmt: 'currency', subtype: 'FIN'},

					{value:'VerityMonthlyFee', label:'340B Savings - Verity Monthly Fee', fmt: 'currency', subtype: 'FIN'},
					{value:'OrderFees', label:'340B Savings - Verity Order Fees', fmt: 'currency', subtype: 'FIN'},
					{value:'ReferralFees', label:'340B Savings - Verity Referral Order Fees', fmt: 'currency', subtype: 'FIN'},
					{value:'VerityMonthlyMatchFees', label:'340B Savings - Verity Monthly Matching Fees', fmt: 'currency', subtype: 'FIN'},
					{value:'NetToCE', label:'340B Savings - Net to Facility', fmt: 'currency', subtype: 'FIN'},
					{value:'CEPrices', label:'340B Savings - 340B Order Cost', fmt: 'currency', subtype: 'FIN'},
					{value:'CreditsCEPrices', label:'340B Savings - Merchandise Credits', fmt: 'currency', subtype: 'FIN'},
					{value:'Total340bSavings', label:'340B Savings - Total', fmt: 'currency', subtype: 'FIN'},

					{value:'CorrectionPrices', label:'Corrections - Claim Reimbursements', fmt: 'currency', subtype: 'FIN'},
					{value:'CorrectionBrandFees', label:'Corrections - Brand Fees', fmt: 'currency', subtype: 'FIN'},
					{value:'CorrectionGenericFees', label:'Corrections - Generic Fees', fmt: 'currency', subtype: 'FIN'},
					{value:'CorrectionTotalDue', label:'Corrections - Total Due to Pharmacy', fmt: 'currency', subtype: 'FIN'},
					{value:'CorrectionOrderFees', label:'Corrections - Total Order Fees Due to Verity', fmt: 'currency', subtype: 'FIN'},
					{value:'CorrectionReferralFees', label:'Corrections - Total Referral Order Fees Due to Verity', fmt: 'currency', subtype: 'FIN'},

					{value:'Dispenses', label:'Dispense - Evaluated', fmt: 'integer', subtype: 'DISP'},
					{value:'DispensesNotMatched', label:'Dispense - Not Matched', fmt: 'integer', subtype: 'DISP'},

					{value:'NewMatchedDispenses', label:'Match - New Matches', fmt: 'integer', subtype: 'DISP'},
					{value:'AcceptedSuspects', label:'Match - New Matches Accepted from Suspect', fmt: 'integer', subtype: 'DISP'},
					{value:'ReversedMatches', label:'Match - Reversed Matches', fmt: 'integer', subtype: 'DISP'},
					{value:'ProviderFiltered', label:'Match - Date Not Eligible', fmt: 'integer', subtype: 'DISP'},
					{value:'MedicaidFiltered', label:'Match - Medicaid Not Eligible', fmt: 'integer', subtype: 'DISP'},
					{value:'VisitProximityFiltered', label:'Match - Written Date Not Eligible', fmt: 'integer', subtype: 'DISP'},
					{value:'NpiProximityFiltered', label:'Match - NPI Written Date Not Eligible', fmt: 'integer', subtype: 'DISP'},
					{value:'BlockedScriptFiltered', label:'Match - Reject Script Not Eligible', fmt: 'integer', subtype: 'DISP'},
					{value:'LocationFiltered', label:'Match - Patient Location Not Eligible', fmt: 'integer', subtype: 'DISP'},
					{value:'ErxNpiFiltered', label:'Match - ePrescribe NPI Not Eligible', fmt: 'integer', subtype: 'DISP'},
					{value:'MiscFiltered', label:'Match - Misc Not Eligible', fmt: 'integer', subtype: 'DISP'},
					{value:'NewEligibleDispenses', label:'Match - New Eligible Dispenses', fmt: 'integer', subtype: 'DISP'},

					{value:'MatchedRatio', label:'Ratio - Matched Dispenses', fmt: 'integer', subtype: 'DISP'},
					{value:'EligibleDispensesRatio', label:'Ratio - Eligible Dispenses', fmt: 'integer', subtype: 'DISP'},
					{value:'EligibleMatchesRatio', label:'Ratio - Eligible Matches', fmt: 'integer', subtype: 'DISP'}
				];

			case 'RX':
				return [
					{value:'PharmacyPrices', label:'Gross Pharmacy - Pharmacy to Facility', fmt: 'currency', subtype: 'FIN'},
					{value:'GenericFees', label:'Gross Pharmacy - Dispense Fees for Generic', fmt: 'currency', subtype: 'FIN'},
					{value:'BrandFees', label:'Gross Pharmacy - Dispense Fees for Brand', fmt: 'currency', subtype: 'FIN'},
					{value:'RxAdminFees', label:'Gross Pharmacy - Admin Fee', fmt: 'currency', subtype: 'FIN'},
					{value:'Credits', label:'Gross Pharmacy - Pharmacy to Facility Credits', fmt: 'currency', subtype: 'FIN'},
					{value:'CreditGenericFees', label:'Gross Pharmacy - Dispense Fee Credits for Generic', fmt: 'currency', subtype: 'FIN'},
					{value:'CreditBrandFees', label:'Gross Pharmacy - Dispense Fee Credits for Brand', fmt: 'currency', subtype: 'FIN'},
					{value:'TotalDueFromPharmacy', label:'Total Due From Pharmacy', fmt: 'currency', subtype: 'FIN'},

					{value:'Dispenses', label:'Dispense - Evaluated', fmt: 'number', subtype: 'DISP'},
					{value:'NewEligibleDispenses', label:'Dispense - New Eligible Dispenses', fmt: 'number', subtype: 'DISP'}
				];

			default:
				alert('reportContractCtl.initTimeSeriesDroplist, unknown report type: ' + rptType);
				return [];
		}
	}

	function tsReset() {

		var ts = vm.ts;

		// save prefs if dirty
		if(!!ts.dirty && !!ts.prefs) {
			sessionRepo.set('ts-report-contract-' + _tsReportType.toLowerCase(), ts.prefs);
		}

		ts.dirty = false;
		ts.action = '';
		ts.colHeaders = [];
		ts.data = [];

		$scope.$broadcast('widget.timeseries');
	}

	function tsToggle() {

		// toggle time series display on/off

		if(vm.action == 'TIMESERIES') {
			tsReset();
			vm.action = 'LIST';
		}
		else {
			// toggle on
			vm.tsMetricDroplist = initTimeSeriesDroplist();
			vm.ts = timeseriesVM();

			// get timeseries viewstate
			var vs = sessionRepo.get('ts-report-contract-' + _tsReportType.toLowerCase());
			if(!!vs) {
				vm.ts.prefs = vs;
			}

			// move pref properties for easier html bind
			var prefs = vm.ts.prefs;
			vm.ts.type = prefs.type;
			vm.ts.subtype = prefs.subtype;
			vm.ts.interval = prefs.interval;
			vm.ts.metric = prefs.metric;

			vm.action = 'TIMESERIES';

			$timeout(function() {
				tsLoadData();
			}, 200);

		}
	}

	function tsLoadData() {

		if(vm.isWaiting) {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true, true);

		reportRepo.getTimeseries('CONTRACT-' + _tsReportType, vm.ts, vm.query).then(okTsData, errTsData);

		function okTsData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.ts = tsParseData(r, vm.ts);
			if(vm.ts.action != 'NODATA') {

				switch(vm.ts.type) {
					case 'AGGREGATE':
						tsLoadAggregate();
						break;
					case 'METRIC':
						tsChangeMetric();
						break;
					default:
						alert('reportContractCtl.tsLoadData, uknown timeseries type: ' + vm.ts.type);
						tsReset();
						vm.action = 'LIST';
				}
			}

		}

		function errTsData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Error loading contract time series for  ' + _tsReportType, 'report.loadTimeSeries', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}

	function tsGetMetricInfo(metric) {

		// find metric formats (they are overloaded into droplist array)

		var items = vm.tsMetricDroplist;
		for(var i = 0; i < items.length; i++) {
			if(items[i].value == metric) {
				return items[i];
			}
		}

		alert('reportContractCtl.tsGetMetricInfo, metric: ' + metric + ' not found for report type: ' + _tsReportType);
		return {};

	}

	function tsGetColumnHeaders(series, isQuarterly) {

		// pre-build column config (once per data load)

		var cols = [],
			dtSeg = [],
			mth = 0,
			day = 0,
			colTitle = '',
			months = utilSvc.ng.monthShortDroplist();

		// 1st column is always title
		cols.push({
			id: 'title',
			title: 'Affiliation',
			width: '120px',
			sort: true,
			flt: undefined,
			fltType: 'Text'
		});

		// loop series to pre-format column labels
		series = Array.isArray(series) ? series : [];
		for(var i = 0; i < series.length; i++) {

			// get fmt from "yyyy-mm-dd" to "MMM dd"
			dtSeg = series[i].Date.split('-');
			mth = parseInt(dtSeg[1]) - 1; // month list is zero based
			mth = months[mth].label;
			day = parseInt(dtSeg[2]);
			day = day.toString();

			if(isQuarterly) {
				colTitle = displayQuarter(new Date(dtSeg[0], dtSeg[1] - 1, 0));
			}
			else {
				colTitle = mth + ' ' + day;
			}

			cols.push({
				id: 'id' + dtSeg.join('_'),
				mth: mth,
				day: day,
				title: colTitle,
				width: '40px',
				sort: true,
				flt: undefined,
				fltType: 'Numbers'
			});
		}

		return cols;

	}

	function tsParseData(data, ts) {

		// parse api data into timeseries cached VM
		// cached VM holds pre-calculated columns / filters, etc

		ts.action = '';
		ts.colHeaders = [];
		ts.data = [];

		// no data
		var affs = Array.isArray(data) ? data : [];
		if(affs.length < 1 || !Array.isArray(affs[0].Series) || affs[0].Series.length < 1) {
			ts.action = 'NODATA';
			return ts;
		}

		var aff = {},
			dataRow ={},
			affSeries = [];

		ts.colHeaders = tsGetColumnHeaders(affs[0].Series, ts.interval == 'QUARTER');

		// parse api data into timeseries pre-format
		var isFIN = ts.subtype == 'FIN';

		for(var i = 0; i < affs.length; i++) {
			aff = affs[i];

			dataRow = {
				id: i,
				title: aff.CEID + ' / ' + aff.Pharmacy,
				series: []
			};

			// loop series, convert api summary data into VM
			affSeries = Array.isArray(aff.Series) ? aff.Series : [];
			for(var ii = 0; ii < affSeries.length; ii++) {
				if(isFIN) {
					dataRow.series.push(affSeries[ii].Summary);
				}
				else {
					// dispense stats
					dataRow.series.push(affSeries[ii].Stats);
				}
			}

			ts.data.push(dataRow);
		}

		return ts;

	}

	function tsChangeType() {

		// switch the timeseries display type

		if(vm.isWaiting || vm.action != 'TIMESERIES') {
			return;
		}

		// switch type
		vm.ts.dirty = true;
		vm.ts.prefs.type = vm.ts.type;
		vm.ts.prefs.subtype = vm.ts.subtype;

		// reset all data, load again
		tsReset();
		$timeout(function() {
			tsLoadData();
		}, 200);

	}

	function tsChangeInterval() {

		// switch the timeseries time interval
		// note: requires another data pull

		if(vm.isWaiting || vm.action != 'TIMESERIES') {
			return;
		}

		// switch interval
		vm.ts.dirty = true;
		vm.ts.prefs.interval = vm.ts.interval;
		tsReset();

		vm.ts.action = 'LOAD';

		$timeout(function() {
			tsLoadData();
		}, 200);

	}

	function tsChangeMetric() {

		// switch the timeseries metric, re-gen widget data

		if(vm.isWaiting || vm.action != 'TIMESERIES') {
			return;
		}

		var ts = vm.ts;

		// metric titles
		var colHeaders = vm.ts.colHeaders;
		colHeaders[0].title = 'Affiliation';

		// switch metric
		ts.dirty = true;
		ts.prefs.metric = ts.metric;
		var metricProp = ts.metric;

		// get details of this metric
		var metricInfo = tsGetMetricInfo(ts.metric);
		var metricFmt = metricInfo.fmt,
			metricSubtype = metricInfo.subtype;

		// requires new data if metric is from another sub-type
		var subtypeSame = ts.subtype == metricSubtype;
		ts.subtype = metricSubtype;
		if(!subtypeSame) {
			tsLoadData();
			return;
		}

		// refresh widget table rows / chart series
		var widgetRows = [],
			dataRows = ts.data,
			row = {},
			dataSeries = [],
			metricVal = 0,
			cid = '';

		// create data rows for this metric
		// note: rows are objects so angular can use filter/sort
		for(var i = 0; i < dataRows.length; i++) {

			row = {
				id: dataRows[i].id,
				title: dataRows[i].title,
				selected: false
			};

			dataSeries = dataRows[i].series;
			for(var ii = 0; ii < dataSeries.length; ii++) {
				cid = colHeaders[ii+1].id;

				// metric value
				metricVal = dataSeries[ii][metricProp];
				if(typeof(metricVal) === 'undefined') {
					metricVal = 0;
				}
				row[cid] = metricVal;

				// metric format in text
				row[cid + 'txt'] = tsFormatMetricValue(metricVal, metricFmt);
			}

			widgetRows.push(row);
		}

		ts.action = 'SHOW';

		// notify widget to render
		var fltKey = ts.type + ts.interval;
		$scope.$broadcast('widget.timeseries', {
			data: {
				uniqueId: 'contract-series',
				interval: ts.interval,
				table: {
					show: true,
					colHeaders: colHeaders,
					rows: widgetRows,
					flt: ts.prefs.flt[fltKey]
				},
				chart: {
					show: true,
					id: 'contract-series-chart',
					config: {
						colors: appConst.app.color.chartBars($window.espuiPrefs.skin),
						xAxis: {
							showText: true
						},
						yAxis: {
							showText: true,
							format: metricFmt
						}
					}
				}
			}
		});

	}

	function tsFormatMetricValue(val, fmt) {

		// convert metric number into final text

		switch(fmt) {
			case 'currency':
				return  numberFmt(val, '0', '$', 2);
			case 'number':
				return numberFmt(val, '0', '', 2);
			case 'integer':
				return numberFmt(val, '0', '', 0);
			default:
				alert('metric format unknown: ' + fmt);
				return val;
		}
	}

	function tsLoadAggregate() {

		// derive timeseries widget dataset for aggregate totals
		// note: aggregate means total of all affiliations per property for each time period

		if(vm.isWaiting || vm.action != 'TIMESERIES' || vm.ts.type != 'AGGREGATE') {
			return;
		}

		var ts = vm.ts,
			tsSubtype = vm.ts.subtype;

		// aggregate titles
		var colHeaders = vm.ts.colHeaders;
		colHeaders[0].title = 'Line Item';

		ts.dirty = true;

		// refresh widget table rows / chart series
		var props = [],
			prop = {},
			propName = '',
			propVal = 0,
			widgetRows = [],
			row = {},
			dataSeries = [],
			cid = '';

		// check aggregate should have only 1 row
		if(ts.data.length !== 1) {
			alert('reportContractCtl.tsLoadAggregate, data rows should be length 1 only');
			tsReset();
			vm.action = 'LIST';
			return;
		}
		dataSeries = ts.data[0].series;
		props = vm.tsMetricDroplist;

		// create widget info iterating selectable properties from drop down
		// note: rows are objects so angular can use filter/sort
		for(var i = 0; i < props.length; i++) {
			prop = props[i];

			// agg props have a sub-type, render props with the same sub-type chosen by user
			if(prop.subtype == tsSubtype) {
				propName = prop.value; // value in droplist is the viewmodel property name
				row = {
					id: propName,
					title: prop.label,
					selected: false
				};

				for(var ii = 0; ii < dataSeries.length; ii++) {
					cid = colHeaders[ii+1].id;

					// prop value
					propVal = dataSeries[ii][propName];
					if(typeof(propVal) === 'undefined') {
						propVal = 0;
					}
					row[cid] = propVal;

					// prop val format in text
					row[cid + 'txt'] = tsFormatMetricValue(propVal, prop.fmt);
				}

				widgetRows.push(row);
			}
		}

		ts.action = 'SHOW';

		// notify widget to render
		var fltKey = ts.type + ts.interval;
		$scope.$broadcast('widget.timeseries', {
			data: {
				uniqueId: 'contract-series',
				interval: vm.ts.interval,
				table: {
					show: true,
					colHeaders: colHeaders,
					rows: widgetRows,
					flt: ts.prefs.flt[fltKey]
				},
				chart: {
					show: true,
					id: 'contract-series-chart',
					config: {
						colors: appConst.app.color.chartBars($window.espuiPrefs.skin),
						xAxis: {
							showText: true
						},
						yAxis: {
							showText: true,
							format: 'number'
						}
					}
				}
			}
		});

	}


	/**
	 *     SAVED REPORTS EVENT HANDLERS
	 */

	function evtSavedReportRemove(reports, removeId, currentId) {

		var result = {
			action: 'remove'
		};

		// find rpt by id
		var removeIdx = getSavedReportById(reports, removeId);
		if(removeIdx < 0) {
			msgSvc.ok('Saved Search Not Found', 'Id missing: ' + removeId);
			return {};
		}
		reports.splice(removeIdx, 1);

		if(validSvc.isText(currentId) && removeId != currentId) {
			result.id = currentId;
		}

		return result;

	}

	function evtSavedReportAdd(reports, rptName) {

		var result = {
			action: 'add'
		};

		// check if query is valid
		var ceVals = multiselectQueryVals(vm.CeMultiselect),
			rxVals = multiselectQueryVals(vm.RxMultiselect);

		if(!queryValid(vm.query, ceVals, rxVals)) {
			msgSvc.ok('Cannot Add Saved Search', 'Check search settings');
			return {};
		}

		// pack up current query
		var ceALL = vm.CeMultiselect.vals[0] == 'ALL',
			rxALL = vm.RxMultiselect.vals[0] == 'ALL';
		var newRpt = {
			id: 'sr' + Date.now().toString(),
			name: rptName,
			CE: ceALL ? ['ALL'] : ceVals,
			RX: rxALL && !vm.isFinancial ? ['ALL'] : rxVals, // don't collapse to ALL for financial report, rx model filters cause issues
			Acct: vm.query.Acct,
			DateMode: vm.query.DateRangeMode
		};

		// keep dates? depends on date mode
		if(utilSvc.dt.dateModeKeepDates(newRpt.DateMode)) {
			newRpt.StartDate = vm.query.StartDate.val;
			newRpt.EndDate = vm.query.EndDate.val;
		}

		// add to report list, remember new rpt id
		reports.push(newRpt);
		result.id = newRpt.id;

		return result;

	}

	function evtSavedReportCurrent(reports, currentId) {

		var result = {
			action: 'current'
		};

		// find rpt by id
		var currentIdx = getSavedReportById(reports, currentId);
		if(currentIdx < 0) {
			msgSvc.ok('Saved Report Not Found', 'Id missing: ' + currentId);
			return {};
		}
		var currentRpt = reports[currentIdx];

		// re-init state
		queryChange();
		vm.init = true;  // this is true to protect query load, after date query change this is set to false

		// load up query from current
		var loadSR = loadSavedQuery('sr', currentRpt);
		vm.multiselectTitle(vm.CeMultiselect, true);
		vm.multiselectTitle(vm.RxMultiselect, true);

		// query load failed
		if(!loadSR) {
			msgSvc.ok('Saved Report Expired', 'Saved report could not be loaded, try removing this report and adding it with updated settings.');
			vm.init = false;
			return {};
		}

		result.id = currentId;

		return result;
	}

	function okSavedReportsToServer(r) {
		//console.log('sr ok saved for: ' + _savedReportPending.action);
		// load cache, refresh widget reports
		_savedReports = getSavedReports(true);
		$scope.$broadcast('widget.savedreports', {
			action: 'reports',
			current: _savedReportPending.action == 'add' ? _savedReportPending.id : '',
			reports: _savedReports
		});
		_savedReportPending = {};
	}

	function errSavedReportsToServer(r) {
		if(!!r) {
			errSvc.warn('Api error user prefs Saved Reports', 'splitSaveCtl.errSavedReportsToServer', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *     SAVED REPORTS WIDGET DETAILS
	 */

	function savedReportWidgetDetailsFmt(ceList, rxList, acct, dtMode, dtStart, dtEnd) {

		var result = [],
			lineTxt = '';

		// line 1: date
		lineTxt = utilSvc.dt.dateModeText(vm.query.DateRangeList, dtMode, dtStart, dtEnd);
		result.push(lineTxt);

		// CE, RX, Acct
		lineTxt = 'Facility: ' + ceList.join(', ');
		if(ceList.length + rxList.length === 2) {
			lineTxt += ', ';
		}
		else {
			result.push(lineTxt);
			lineTxt = '';
		}
		lineTxt += rxList[0] == 'ALL' ? 'All Pharmacies' : 'Pharmacy: ' + rxList.join(', ');

		if(validSvc.isText(acct) && acct != 'ALL') {
			lineTxt += 'Acct: ' + acct;
		}
		result.push(lineTxt);

		return result;

	}

	function savedReportFormatForWidgetDetails(reports) {

		// widget needs report details created for it
		// widget doesn't know the feature's specific query requirements

		var rpt = {},
			lineTxt = '';

		if(!Array.isArray(reports)) {
			return [];
		}

		for(var i = 0; i < reports.length; i++) {
			rpt = reports[i];
			rpt.details = savedReportWidgetDetailsFmt(
				rpt.CE,
				rpt.RX,
				rpt.Acct,
				rpt.DateMode,
				new Date(rpt.StartDate),
				new Date(rpt.EndDate)
			);
		}

		return reports;
	}


	/**
	 *     SAVED REPORTS HELPERS
	 */

	function getSavedReports(addWidgetDetails) {

		var vs = sessionRepo.get(srKey());
		if(!!vs && vs.version === srVersion()) { // ignore older versions
			var reports = Array.isArray(vs.reports) ? vs.reports : [];

			return !!addWidgetDetails ? savedReportFormatForWidgetDetails(reports) : reports;
		}

		return [];

	}

	function getSavedReportById(reports, id) {
		for(var i = 0; i < reports.length; i++) {
			if(reports[i].id == id) {
				return i;
			}
		}
		return -1;
	}

	function srKey() {
		if(vm.isFinancial) {
			return 'sr-report-cpfin';
		}
		else {
			return 'sr-report-contract-' + _rptType.toLowerCase();
		}
	}

	function srVersion() {
		return 1;
	}


	/**
	 *    CREATE SUMMARY PDF
	 */

	function createPDF() {

		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('PDF feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		var ceList = multiselectQueryVals(vm.CeMultiselect),
			rxVals = multiselectQueryVals(vm.RxMultiselect),
			rxList = [],
			ceALL = vm.CeMultiselect.vals[0] == 'ALL',
			rxALL = vm.RxMultiselect.vals[0] == 'ALL';
		ceList.sort();

		// rx uses rx short name, pull it out of check list
		var rxChecks = vm.RxMultiselect.list,
			rxk = {};
		for(var i = 0; i < rxChecks.length; i++) {
			rxk = rxChecks[i];
			if(rxVals.indexOf(rxk.val) > -1) {
				rxList.push(rxk.lbl);
			}
		}
		rxList.sort();

		var pdfQueryData = {
			reportName: _rptType == 'CE' ? ceList[0] : rxList[0],
			ceList: ceList,
			ceALL: ceALL,
			rxList: rxList,
			rxALL: rxALL,
			StartDate: vm.query.StartDate.val,
			EndDate: vm.query.EndDate.val
		};

		if(_rptType == 'CE') {
			if(ceList.length > 1) {
				pdfQueryData.reportName = 'Multiple-Entity';
			}
			reportPDF.ceSummary({query: pdfQueryData, data: vm.summary}).then(okPDF, errPDF);
		}
		else if(_rptType == 'RX') {
			if(rxList.length > 1) {
				pdfQueryData.reportName = 'Multiple-Entity';
			}
			reportPDF.rxSummary({query: pdfQueryData, data: vm.summary}).then(okPDF, errPDF);
		}

		function okPDF(pdfBlob, rptName) {
			vm.isWaiting = false;
			msgSvc.wait(false);
		}

		function errPDF(err) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			err = err || {};
			errSvc.warn('Create PDF Error', 'report.ctl.createPDF', '', err.message);
		}

	}


	/**
	 *    EXCEL
	 *    get file from server
	 */

	function createExcel(isCompare, isTimeSeries) {

		if(vm.isWaiting) {
			return;
		}
		
		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		// use main waiting spinner, not the spinner on report tabs
		vm.isWaiting = true;
		msgSvc.wait(true);

		// CP Financial — all exports go through async job queue
		if(vm.isFinancial) {
			var exportRequest = cpfrExportRequestVM(vm.query, isCompare);
			vm.popup = {
				type: 'EXCEL',
				title: 'Generating Excel File',
				ready: false
			};
			$timeout(function() { vm.popup.ready = true; }, 200);
			vm.isWaiting = false;
			msgSvc.wait(false);

			reportRepo.createCpfrExportJob(exportRequest).then(function(job) {
				_cpfrExcelJobId = job.JobID || job.jobId;
				_cpfrExcelPollStartTime = Date.now();
				_pollCpfrExcelJob();
			}, function(r) {
				vm.popup = {};
				if(!!r) {
					errSvc.warn('Create Excel Error', 'cpfin.createCpfrExportJob', r.status, utilSvc.http.safeResponse(r));
				}
			});
			return;
		}

		var excelType = _rptType.toString(),
			rptDateSuffix = '-Report-' + utilSvc.dt.monthShortText(vm.query.StartDate.val) + vm.query.StartDate.val.getFullYear().toString() + '.xlsx';

		// CE/RX names for filename
		if(excelType == 'CE') {
			_pendingExcelFilename = 'Verity-';

			// CP Financial
			if(vm.isFinancial) {
				_pendingExcelFilename += 'Contract-Pharmacy-Financial-Report-';
				excelType = 'FIN';
			}

			// CE details
			if(vm.query.CE.vals.length > 1) {
				_pendingExcelFilename += vm.query.CE.vals.length + '-CoveredEntities';
			}
			else {
				_pendingExcelFilename += vm.query.CE.vals[0];
			}
		}
		else if(excelType == 'RX') {
			if(vm.query.RX.vals.length > 1) {
				_pendingExcelFilename = 'Verity-' + vm.query.RX.vals.length + '-Pharmacies';
			}
			else {
				_pendingExcelFilename = 'Verity-' + utilSvc.aff.rxShortNameById(getAffs(), vm.query.RX.vals[0]);
			}
		}
		else {
			throw new Error('reportCtl.createExcel, unknown rpt type: ' + excelType);
		}

		// comparison
		if(!!isCompare) {
			_pendingExcelFilename += '-Comparison';
			excelType += '-COMPARE';
		}

		// timeseries
		if(!!isTimeSeries) {
			var ts = vm.ts;
			vm.query.tsxl = {
				type: ts.type,
				subtype: ts.subtype,
				metric: ts.metric,
				interval: ts.interval
			};
			_pendingExcelFilename += '-TimeSeries';
			excelType = _tsReportType + '-TIMESERIES';
		}

		_pendingExcelFilename += rptDateSuffix;

		// dump all caching and memory before creating Excel
		_useCache = false;
		reportRepo.destroyRX();
		reportRepo.destroyCE();
		$timeout(function() {
			// small delay for digest cycle to delete repo memory
			reportRepo.serverExcel(excelType, vm.query, _pendingExcelFilename).then(okServerExcel, errServerExcel);
		}, 300);
	}

	function cpfrExportRequestVM(q, isCompare) {
		var params = {
			ReportType: 'CPFR',
			StartDate: q.StartDate.val,
			EndDate: q.EndDate.val,
			AccGrps: q.Acct == 'ALL' ? [] : [q.Acct],
			ExcludeUnaffils: q.ExcludeUnaffils,
			FetchByImpDate: q.FetchByImpDate,
			RxModels: Array.isArray(q.rxModels) ? q.rxModels : []
		};

		if(!!isCompare && q.CompareStartDate && q.CompareEndDate) {
			params.CompareStartDate = q.CompareStartDate.val;
			params.CompareEndDate = q.CompareEndDate.val;
		}

		return {
			Context: {
				CEID: q.CE.vals,
				RXID: q.RX.vals
			},
			Params: params
		};
	}

	// keep legacy asyncFileRequestVM for other report types using old async path
	function asyncFileRequestVM(q) {
		return {
			Context: {
				CEID: q.CE.vals,
				RXID: q.RX.vals
			},
			Params: {
				ReportType: 'CPFR',
				StartDate: q.StartDate.val,
				EndDate: q.EndDate.val,
				AccGrps: q.Acct == 'ALL' ? [] : [q.Acct],
				ExcludeUnaffils: q.ExcludeUnaffils,
				FetchByImpDate: q.FetchByImpDate,
                RxModels: Array.isArray(q.rxModels) ? q.rxModels : []
			}
		};
	}


	/**
	 *    TIMESERIES EXCEL
	 */

	function tsExcel() {

		if(vm.isWaiting || vm.action != 'TIMESERIES' || !!!vm.ts) {
			return;
		}

		createExcel(false, true);
	}


	/**
	 *    EXCEL HELPERS
	 */

	function okServerExcel(binaryData) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		// async requests do not return a file
		if(_pendingExcelFilename == 'ASYNC') {
			_pendingExcelFilename = '';
			msgSvc.ok('Excel File Requested', 'Check the "Saved Files" link at top right to retrieve this Excel Workbook.');
			return;
		}

		// convert binary back into Excel file
		try {
			var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
			$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
		}
		catch(err) {
			throw(err);
		}
	}

	function errServerExcel(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		if(!!r) {
			errSvc.warn('Create Excel Error', 'cpfin.ServerExcel', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    MULTISELECT HELPERS
	 */

	function multiselectRebuildSecondary(primary, secondary, affs, usingALL) {

		// rebuild secondary multiselect based on values in primary multiselect

		usingALL = !!usingALL;

		if(primary.vals.length < 1) {
			secondary.list = [];
			secondary.vals = [];
		}
		else {
			affs = primary.type == 'CE' ? utilSvc.aff.findCeList(affs, primary.vals) : utilSvc.aff.findRxList(affs, primary.vals);
			var secList = primary.type == 'CE' ? utilSvc.aff.rxList(affs) : utilSvc.aff.ceList(affs);
			var vals = secondary.vals,
				newVals = [];

			if(vals.length === 1 && vals[0] == 'ALL') {
				newVals = ['ALL'];
				usingALL = true;
			}
			else {
				// add new val only if it exists in new secList
				for(var i = 0; i < vals.length; i++) {
					if(secList.indexOf(vals[i]) > -1) {
						newVals.push(vals[i]);
					}
				}
			}

			// assign new check list
			if(usingALL && secList.length > 1) {
				secList.unshift('ALL');
			}
			if(secondary.type == 'RX') {
				secondary.list = vm.multiselectBuildRX(secList, false, affs);
			}
			else {
				secondary.list = vm.multiselectBuild(secList, false);
			}

			// assign vals
			if((!usingALL && secList.length === newVals.length) || (usingALL && ((newVals.length > 0 && newVals[0] == 'ALL') || secList.length - 1 === newVals.length))) {
				// all vals are checked
				secondary.vals = [];
				vm.multiselectClick(secondary, 'ALL');
			}
			else {
				vm.multiselectReturnVisit(secondary, '', newVals);
			}
		}

		// set RX title
		vm.multiselectTitle(secondary, true);

		// set biz model filters
		if(vm.isFinancial && secondary.type == 'RX') {

			// default both model filters to ON on rebuild
			secondary.fltRxModels = ['CP','CPTPA'];

			// get affiliations using ce / rx
			var ceAffs = utilSvc.aff.findCeList(affs, multiselectQueryVals(primary));

			// loop secondary list, add rxModels
			var rxModels = [];

			secondary.list.forEach(function(item){
				if(item.val == 'ALL') {
					item.rxModels = ['CP','CPTPA'];
				}
				else {
					rxModels = utilSvc.aff.rxModelList(utilSvc.aff.findRx(ceAffs, item.val));
					item.rxModels = [];
					if(rxModels.indexOf('CP') > -1) {
						item.rxModels.push('CP');
					}
					if(rxModels.indexOf('CPTPA') > -1) {
						item.rxModels.push('CPTPA');
					}
				}
			});
		}

		return secondary;

	}

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if(vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		multiselect.flt = '';

		// don't bother with width if hiding
		if(multiselect.show) {
			multiselect.show = false;
			return;
		}

        // show
		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;

	}

	function multiselectMouseHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}

	function multiselectRxModels(multiselect, lookForChecked) {

		// return which rx models (CP, CPTPA) are represented among checked items
		// only report models that are in the active filter set (fltRxModels)

		var checklist = multiselect.list,
			vals = multiselect.vals,
			usingALL = vals.length === 1 && vals[0] == 'ALL',
			fltModels = Array.isArray(multiselect.fltRxModels) ? multiselect.fltRxModels : [],
			result = [],
            hasCP = false,
            hasCPTPA = false;

		for(var i = 0; i < checklist.length; i++) {
			var item = checklist[i];
			if(item.val == 'ALL' || !Array.isArray(item.rxModels)) {
				continue;
			}
			// item must be checked (or ALL is selected)
			if(usingALL || !lookForChecked || item.checked) {
                if(!hasCP && item.rxModels.indexOf('CP') >= 0 && fltModels.indexOf('CP') >= 0) {
                    result.push('CP');
                    hasCP = true;
                }
                if(!hasCPTPA && item.rxModels.indexOf('CPTPA') >= 0 && fltModels.indexOf('CPTPA') >= 0) {
                    result.push('CPTPA');
                    hasCPTPA = true;
                }
                if(hasCP && hasCPTPA) {
                    break;
                }
			}
		}

		return result;
	}

	function multiselectQueryVals(multiselect) {

		// unpack the vals multiselect into a list of entities to query

		var checklist = multiselect.list,
			vals = multiselect.vals,
            isRxFinancial = vm.isFinancial && multiselect.type == 'RX';
        var rxFinModels = isRxFinancial && Array.isArray(multiselect.fltRxModels) ? multiselect.fltRxModels : [];

        // no values
		if(vals.length < 1) {
			return [];
		}

        // ALL not used
        if(vals.length > 1 || (vals.length === 1 && vals[0] != 'ALL')) {
            return vals;
        }

        // using ALL value, return all list items
        var result = [],
            i = checklist[0].val == 'ALL' ? 1 : 0,
            item = {};
        for(i; i < checklist.length; i++) {
            item = checklist[i];

            if(isRxFinancial && Array.isArray(item.rxModels)) {
                // for financial report only return val if item has rx model
                for(var ii = 0; ii < rxFinModels.length; ii++) {
                    if(item.rxModels.indexOf(rxFinModels[ii]) >= 0) {
                        result.push(item.val);
                        break;
                    }
                }
            } else {
                result.push(item.val);
            }
        }

        return result;
	}


	/**
	 * 	TABLEVIEW
	 */

	 function tblViewSchemaVM(tabName) {

		// each tab has its own table schema

		var result = {

			FIN_ORDER: {
				title: 'V340B Direct Orders',
				storageKey: 'tv-rpt-cpfin-fin_order',
				name: 'FIN_ORDER',
				sortby: 'OrderDate',
				pgsize: 50,
				sections: {
					Aff: {title:'Affiliation'},
					Vord: {title: 'Verity Order'},
					Vinv: {title:  'Vendor Invoice'},
					Price: {title: 'Pricing'}
				},
				cols: [
					{section:'Aff', 		flt:'Text',		edit: false, name:'OrderCEID', title:'Facility', desc:'Name of the ordering Facility'},
					{section:'Aff', 		flt:'Text',		edit: false, name:'OrderRXID', title:'Order Pharmacy', desc:'Name of the ordering Contract Pharmacy'},
					{section:'Vord',		flt:'Dates',	name:'OrderDate', title:'Date', desc:'Order Date'},
					{section:'Vord', 		flt:'Text',		name:'OrderName', title:'Name', desc:'Order #'},
					{section:'Vinv',		flt:'Dates',	name:'InvoiceDate', title:'Date', desc:'Invoice Date'},
					{section:'Vinv',		flt:'Text',		name:'InvoiceNumber', title:'Number', desc:'Invoice #'},
					{section:'Vinv',		flt:'Text',		name:'InvoiceType', title:'Type', desc:'Invoice Type'},
					{section:'Vinv',		flt:'Text',		name:'VENID', title:'Vendor', desc:'Vendor'},
					{section:'Vinv',		flt:'Text',		default: false, name:'DirectRep', title:'Direct Replenish', desc:'Direct Replenish'},
					{section:'Price',		flt:'Numbers',	name:'Price', title:'340B Order Cost', desc:'340B Order Cost'}
				]
			},
			FIN_INVOICES: {
				title: 'V340B Direct Invoices',
				storageKey: 'tv-rpt-cpfin-fin_invoices',
				name: 'FIN_INVOICES',
				sortby: 'OrderDate',
				pgsize: 50,
				sections: {
					Aff: {title:'Affiliation'},
					Vord: {title: 'Verity Order'},
					Vinv: {title:  'Invoice'},
					RxPrice: {title: 'Pharmacy Pricing'},
					CePrice: {title: 'Facility 340B Pricing'},
					Cor: {title: 'Correction'},
					Pmt: {title: 'Payments'}
				},
				cols: [
					{section:'Aff', 		flt:'Text',		default: false, name:'CEID', title:'Facility', desc:'Name of the ordering Facility'},
					{section:'Aff', 		flt:'Text',		edit: false, name:'Pharmacy', title:'Pharmacy', desc:'Name of the ordering Contract Pharmacy'},
					
					{section:'Vord',		flt:'Dates',	name:'OrderDate', title:'Date', desc:'Order Date'},
					{section:'Vord', 		flt:'Text',		name:'OrderName', title:'Name', desc:'Order #'},
					
					{section:'Vinv',		flt:'Dates',	name:'InvoiceDate', title:'Date', desc:'Invoice Date'},
					{section:'Vinv',		flt:'Text',		name:'InvoiceNumber', title:'Number', desc:'Invoice #'},
					{section:'Vinv',		flt:'Dates',	name:'VerityBillDate', title:'Verity Bill Date', desc:'Verity Bill Date'},
					{section:'Vinv',		flt:'Text',		name:'VerityInvoiceNumber', title:'Verity Bill #', desc:'Verity Bill #'},
					{section:'Vinv',		flt:'Text',		name:'InvoiceType', title:'Type', desc:'Invoice Type'},
					{section:'Vinv',		flt:'Text',		default: false, name:'VENID', title:'Vendor', desc:'Vendor'},
					{section:'Vinv',		flt:'Text',		default: false, name:'DirectRep', title:'Direct Replenish', desc:'Direct Replenish'},
					
					{section:'RxPrice',		flt:'Numbers',	name:'PharmacyTotalPrice', title:'Total Price', desc:'Pharmacy Price'},
					{section:'RxPrice',		flt:'Numbers',	name:'DispenseFees', title:'Dispense Fees', desc:'Pharmacy Dispense Fees'},
					{section:'RxPrice',		flt:'Numbers',	name:'PharmacyTotalDue', title:'Invoice Due', desc:'Pharmacy Invoice Due'},
					
					{section:'CePrice',		flt:'Numbers',	name:'CETotalPrice', title:'Invoice Cost', desc:'CE 340B Invoice Cost'},
					{section:'CePrice',		flt:'Numbers',	name:'OrderFees', title:'Order Fees', desc:'CE Order Fees'},
					{section:'CePrice',		flt:'Numbers',	name:'ReferralFees', title:'Referral Fees', desc:'CE Referral Fees'},
					{section:'CePrice',		flt:'Numbers',	name:'CETotalDue', title:'Net Savings', desc:'Total Due to CE'},

					{section:'Cor', 		flt:'Text',		default: false, name:'Correction', title:'Correction', desc:'Correction'},

					{section:'Pmt',			flt:'Numbers',	default: false, name:'PaymentTotal', title:'Amount', desc:'Amount of all Payments'},
					{section:'Pmt',			flt:'Dates',	default: false, name:'PaymentsFirstDate', title:'Date', desc:'First payment date'},
					{section:'Pmt', 		flt:'Text',		default: false, name:'PaymentsFirstRef', title:'Ref #', desc:'First payment reference number'}
				]
			},
			FIN_INVOICE_ITEMS: {
				title: 'V340B Direct Invoice Items',
				storageKey: 'tv-rpt-cpfin-fin_invoice_items',
				name: 'FIN_INVOICE_ITEMS',
				sortby: 'InvoiceDate',
				pgsize: 50,
				sections: {
					Aff: {title:'Affiliation'},
					Vord: {title: 'Verity Order'},
					Inv: {title:  'Invoice'},
					Drug: {title: 'Drug Info'},
					RxPrice: {title: 'Pharmacy Pricing'},
					CePrice: {title: 'Facility 340B Pricing'},
					RefPrice: {title: 'Reference Pricing'}
				},
				cols: [
					{section:'Aff', 		flt:'Text',		default: false, name:'OrderCEID', title:'Facility', desc:'Name of the ordering Facility'},
					{section:'Aff', 		flt:'Text',		edit: false, name:'OrderRXID', title:'Pharmacy', desc:'Name of the ordering Contract Pharmacy'},
					
					{section:'Vord',		flt:'Dates',	name:'OrderDate', title:'Date', desc:'Order Date'},
					{section:'Vord', 		flt:'Text',		name:'OrderName', title:'Name', desc:'Order #'},
					
					{section:'Inv',			flt:'Dates',	name:'InvoiceDate', title:'Date', desc:'Invoice Date'},
					{section:'Inv',			flt:'Text',		name:'InvoiceNumber', title:'Number', desc:'Invoice #'},
					{section:'Inv',			flt:'Dates',	name:'VerityBillDate', title:'Verity Bill Date', desc:'Verity Bill Date'},
					{section:'Inv',			flt:'Text',		name:'VerityInvoiceNumber', title:'Verity Bill #', desc:'Verity Bill #'},
					{section:'Inv',			flt:'Text',		name:'InvoiceType', title:'Type', desc:'Invoice Type'},
					{section:'Inv',			flt:'Text',		default: false, name:'LineItemNumber', title:'Line #', desc:'Invoice line number'},
					{section:'Inv',			flt:'Text',		name:'Deferred', title:'Deferred', desc:'Invoice Deferred'},
					{section:'Inv',			flt:'Text',		default: false, name:'VendorItemNumber', title:'Vendor Item #', desc:'Vendor Item Number'},
					{section:'Inv',			flt:'Text',		default: false, name:'VENID', title:'Vendor', desc:'Vendor'},
					{section:'Inv',			flt:'Text',		default: false, name:'DirectRep', title:'Direct Replenish', desc:'Direct Replenish'},

					{section:'Drug',		flt:'Text',		name:'ItemCode', title:'NDC', desc:'NDC'},
					{section:'Drug',		flt:'Text',		default: false, name:'OrderedItemCode', title:'Ordered NDC', desc:'Ordered NDC'},
					{section:'Drug',		flt:'Text',		name:'ItemName', title:'Description', desc:'Item Description'},
					{section:'Drug',		flt:'Text',		default: false, name:'Manufacturer', title:'Mfg', desc:'Drug manufacturer'},
					
					{section:'RxPrice',		flt:'Numbers',	name:'OrderUnits', title:'Order Units', desc:'Packages Shipped'},
					{section:'RxPrice',		flt:'Numbers',	default: false, name:'PharmacyPackPrice', title:'Pkg Price', desc:'Pharmacy Package Price'},
					{section:'RxPrice',		flt:'Numbers',	name:'PharmacyTotalPrice', title:'Total Price', desc:'Pharmacy Total Price'},
					{section:'RxPrice',		flt:'Numbers',	name:'DispenseFees', title:'Dispense Fees', desc:'Pharmacy Dispense Fees'},
					{section:'RxPrice',		flt:'Numbers',	name:'PharmacyTotalDue', title:'Invoice Due', desc:'Pharmacy Invoice Due'},

					{section:'CePrice',		flt:'Numbers',	default: false, name:'CEPackPrice', title:'Pkg Price', desc:'Package 340B Price'},
					{section:'CePrice',		flt:'Numbers',	name:'CETotalPrice', title:'Invoice Cost', desc:'CE 340B Invoice Cost'},
					{section:'CePrice',		flt:'Numbers',	name:'OrderFees', title:'Order Fees', desc:'CE Order Fees'},
					{section:'CePrice',		flt:'Numbers',	name:'ReferralFees', title:'Referral Fees', desc:'CE Referral Fees'},
					{section:'CePrice',		flt:'Numbers',	name:'CETotalDue', title:'Net Savings', desc:'Total Due to CE'},

					{section:'RefPrice',	flt:'Numbers',	default: false, name:'WACPackPrice', title:'WAC Pkg Price', desc:'WAC Per Package Price'},
					{section:'RefPrice',	flt:'Numbers',	default: false, name:'WACPackDiscount', title:'WAC Pkg Discount', desc:'WAC Per Package Discount'}
				]
			},
			FIN_DISP: {
				title: 'V340B Direct Used In Orders',
				storageKey: 'tv-rpt-cpfin-fin_disp',
				name: 'FIN_DISP',
				sortby: 'InvoiceDate',
				pgsize: 50,
				sections: {
					Aff: {title:'Affiliation'},
					Pat: {title:'Patient'},
					Pro: {title:'Provider'},
					Disp: {title:'Disp'},
					Drug: {title: 'Drug Info'},
					Qty: {title:'Quantity'},
					CF: {title:'Claim Financials'},
					RxPrice: {title: 'Pricing & Cost'},
					Vord: {title: 'Verity Order'},
					Inv: {title:  'Invoice'},
					Pay: {title:  'Payor'},
					Cor: {title:'Correction'}
				},
				cols: [
					// affiliation - 3
					{section:'Aff', 		flt:'Text',		default: false, name:'OrderCEID', title:'Facility', desc:'Name of the ordering Facility'},
					{section:'Aff', 		flt:'Text',		edit: false, name:'OrderRXID', title:'Pharmacy', desc:'Name of the ordering Contract Pharmacy'},
					{section:'Aff', 		flt:'Text',		default: false, name:'DispPharmacy', title:'Dispense Pharmacy', desc:'Name of the dispense Contract Pharmacy'},

					// patient - 4
					{section:'Pat', 		flt:'Text',		name:'EncounterNumber', title:'Encounter ID', desc:'Encounter Number'},
					{section:'Pat', 		flt:'Text',		default: false, name:'EncounterLocation', title:'Encounter Location', desc:'Encounter Location'},
					{section:'Pat', 		flt:'Text',		default: false, name:'MRN', title:'MRN', desc:'MRN'},
					{section:'Pat', 		flt:'Text',		default: false, name:'PatientFname', title:'First Name', desc:'Patient First Name'},
					{section:'Pat', 		flt:'Text',		default: false, name:'PatientLname', title:'Last Initial', desc:'Patient Last Initial'},

					// provider - 3
					{section:'Pro', 		flt:'Text',		name:'DispNPI', title:'NPI', desc:'Prescriber NPI'},
					{section:'Pro', 		flt:'Text',		default: false, name:'PrescriberName', title:'Name', desc:'Prescriber Name'},
					{section:'Pro', 		flt:'Text',		default: false, name:'DispReferral', title:'Referral', desc:'Dispense Referral'},

					// dispense - 4
					{section:'Disp', 		flt:'Text',		name:'DispRxNumber', title:'Rx #', desc:'Dispense Number'},
					{section:'Disp', 		flt:'Text',		name:'DispFillNumber', title:'Fill Number', desc:'Dispense Fill Number'},
					{section:'Disp', 		flt:'Dates',	name:'DispRxWrittenDate', title:'Written Date', desc:'Dispense Written Date'},
					{section:'Disp', 		flt:'Dates',	name:'DispFillDate', title:'Fill Date', desc:'Dispense Fill Date'},

					// drug info - 5
					{section:'Drug',		flt:'Text',		name:'DispDrugType', title:'Drug Type', desc:'Drug Type'},
					{section:'Drug',		flt:'Text',		name:'ItemCode', title:'NDC', desc:'NDC'},
					{section:'Drug',		flt:'Text',		default: false, name:'OrderedItemCode', title:'Ordered NDC', desc:'Ordered NDC'},
					{section:'Drug',		flt:'Text',		name:'ItemName', title:'Description', desc:'Item Description'},
					{section:'Drug',		flt:'Text',		default: false, name:'Manufacturer', title:'Mfg', desc:'Drug manufacturer'},
					
					// quantity - 3
					{section:'Qty',			flt:'Numbers',	name:'DispQuantity', title:'Dispense', desc:'Dispense Qty'},
					{section:'Qty',			flt:'Numbers',	name:'OrderQuantity', title:'Used In Order', desc:'Qty Used in Order'},
					{section:'Qty',			flt:'Numbers',	default: false, name:'DispPercentUsed', title:'Order %', desc:'Used in Order %'},

					// claim financials - 4
					{section:'CF',			flt:'Numbers',	default: false, name:'DispPatientPaid', title:'Patient Paid', desc:'Patient Paid'},
					{section:'CF',			flt:'Numbers',	default: false, name:'DispTotalPaid', title:'Benefits Paid', desc:'Benefits Paid'},
					{section:'CF',			flt:'Numbers',	name:'DispAllTotalPaid', title:'Total Paid', desc:'Dispense Total Paid'},
					{section:'CF',			flt:'Numbers',	default: false, name:'NetTotalPaid', title:'Net Total Paid', desc:'Net Dispense Total Paid'},

					// pricing and cost - 7
					{section:'RxPrice',		flt:'Numbers',	name:'PharmacyCost', title:'Pharmacy Cost', desc:'Pharmacy Cost'},
					{section:'RxPrice',		flt:'Numbers',	name:'OrderFee', title:'Order Fee', desc:'Order Fee'},
					{section:'RxPrice',		flt:'Numbers',	name:'ReferralFee', title:'Referral Fee', desc:'Referral Fee'},
					{section:'RxPrice',		flt:'Numbers',	name:'DispenseFee', title:'Dispense Fee', desc:'Dispense Fee'},
					{section:'RxPrice',		flt:'Numbers',	default: false, name:'NetClaimProceeds', title:'Net Proceeds', desc:'Net Dispsense Proceeds'},
					{section:'RxPrice',		flt:'Numbers',	name:'Cost340b', title:'340B Cost', desc:'340B Cost'},
					{section:'RxPrice',		flt:'Numbers',	name:'GrossDispenseSavings', title:'Net Savings', desc:'Net Dispense Savings'},

					// verity order - 2
					{section:'Vord',		flt:'Dates',	default: false, name:'OrderDate', title:'Date', desc:'Order Date'},
					{section:'Vord', 		flt:'Text',		default: false, name:'OrderName', title:'Name', desc:'Order #'},
					
					// invoice - 9
					{section:'Inv',			flt:'Dates',	name:'InvoiceDate', title:'Date', desc:'Invoice Date'},
					{section:'Inv',			flt:'Text',		name:'InvoiceNumber', title:'Number', desc:'Invoice #'},
					{section:'Inv',			flt:'Dates',	name:'VerityBillDate', title:'Verity Bill Date', desc:'Verity Bill Date'},
					{section:'Inv',			flt:'Text',		name:'VerityInvoiceNumber', title:'Verity Bill #', desc:'Verity Bill #'},
					{section:'Inv',			flt:'Text',		name:'InvoiceType', title:'Type', desc:'Type'},
					{section:'Inv',			flt:'Text',		name:'LineItemNumber', title:'Line #', desc:'Invoice line number'},
					{section:'Inv',			flt:'Text',		default: false, name:'VendorItemNumber', title:'Vendor Item #', desc:'Vendor Item Number'},
					{section:'Inv',			flt:'Text',		default: false, name:'VENID', title:'Vendor', desc:'Vendor'},
					{section:'Inv',			flt:'Text',		default: false, name:'DirectRep', title:'Direct Replenish', desc:'Direct Replenish'},
					{section:'Inv',			flt:'Text',		default: false, name:'IRA', title:'IRA', desc:'IRA'},

					// payor - 1
					{section:'Pay', 		flt:'Text',		default: false, name:'BinPcnFormatted', title:'BIN PCN GRP', desc:'Payor BIN PCN GRP'},

					// correction - 3
					{section:'Cor',			flt:'Dates',	default: false, name:'CorrectionDate', title:'Date', desc:'Correction Date'},
					{section:'Cor',			flt:'Text',		default: false, name:'CorrectionReason', title:'Reason', desc:'Correction Reason'},
					{section:'Cor',			flt:'Text',		default: false, name:'CorrectionNotes', title:'Notes', desc:'Correction Notes'}
				]
			},
			FIN_TPA_CLAIMS: {
				title: 'External Invoiced Claims',
				storageKey: 'tv-rpt-cpfin-fin_tpa_inv',
				name: 'FIN_TPA_CLAIMS',
				sortby: 'InvoiceDate',
				pgsize: 50,
				sections: {
					Aff: {title:'Affiliation'},
					Imp: {title:'Import'},
					Pat: {title:'Patient'},
					Pro: {title:'Provider'},
					Disp: {title:'Disp'},
					Drug: {title: 'Drug Info'},
					Qty: {title:'Quantity'},
					CF: {title:'Claim Financials'},
					RxPrice: {title: 'Pricing & Cost'},
					Inv: {title:  'Invoice'},
					Pay: {title:  'Payor'},
					Adj: {title:'Adjustment'}
				},
				cols: [
					// affiliation - 2
					{section:'Aff', 		flt:'Text',		default: false, name:'OrderCEID', title:'Facility', desc:'Name of the ordering Facility'},
					{section:'Aff', 		flt:'Text',		edit: false, name:'OrderRXID', title:'Pharmacy', desc:'Name of the ordering Contract Pharmacy'},

					// import - 1
					{section:'Imp', 		flt:'Dates',	default: false, name:'ImportDate', title:'Date', desc:'Import Date'},

					// patient - 4
					{section:'Pat', 		flt:'Text',		name:'EncounterNumber', title:'Encounter ID', desc:'Encounter Number'},
					{section:'Pat', 		flt:'Text',		default: false, name:'EncounterLocation', title:'Encounter Location', desc:'Encounter Location'},
					{section:'Pat', 		flt:'Text',		default: false, name:'MRN', title:'MRN', desc:'MRN'},
					{section:'Pat', 		flt:'Text',		default: false, name:'PatientFname', title:'First Name', desc:'Patient First Name'},
					{section:'Pat', 		flt:'Text',		default: false, name:'PatientLname', title:'Last Initial', desc:'Patient Last Initial'},

					// provider - 3
					{section:'Pro', 		flt:'Text',		name:'DispNPI', title:'NPI', desc:'Prescriber NPI'},
					{section:'Pro', 		flt:'Text',		default: false, name:'PrescriberName', title:'Name', desc:'Prescriber Name'},
					{section:'Pro', 		flt:'Text',		default: false, name:'DispReferral', title:'Referral', desc:'Dispense Referral'},

					// dispense - 4
					{section:'Disp', 		flt:'Text',		name:'DispRxNumber', title:'Rx #', desc:'Dispense Number'},
					{section:'Disp', 		flt:'Text',		name:'DispFillNumber', title:'Fill Number', desc:'Dispense Fill Number'},
					{section:'Disp', 		flt:'Dates',	name:'DispRxWrittenDate', title:'Written Date', desc:'Dispense Written Date'},
					{section:'Disp', 		flt:'Dates',	name:'DispFillDate', title:'Fill Date', desc:'Dispense Fill Date'},

					// drug info - 5
					{section:'Drug',		flt:'Text',		name:'DispDrugType', title:'Drug Type', desc:'Drug Type'},
					{section:'Drug',		flt:'Text',		name:'ItemCode', title:'NDC', desc:'NDC'},
					{section:'Drug',		flt:'Text',		name:'ItemName', title:'Description', desc:'Item Description'},
					{section:'Drug',		flt:'Text',		default: false, name:'Manufacturer', title:'Mfg', desc:'Drug manufacturer'},
					{section:'Drug',		flt:'Text',		default: false, name:'IRA', title:'IRA', desc:'IRA'},

					
					// quantity - 3
					{section:'Qty',			flt:'Numbers',	name:'DispQuantity', title:'Dispense', desc:'Dispense Qty'},
					{section:'Qty',			flt:'Numbers',	name:'OrderQuantity', title:'Used In Order', desc:'Qty Used in Order'},
					{section:'Qty',			flt:'Numbers',	default: false, name:'DispPercentUsed', title:'Order %', desc:'Used in Order %'},

					// claim financials - 4
					{section:'CF',			flt:'Numbers',	default: false, name:'DispPatientPaid', title:'Patient Paid', desc:'Patient Paid'},
					{section:'CF',			flt:'Numbers',	default: false, name:'DispTotalPaid', title:'Benefits Paid', desc:'Benefits Paid'},
					{section:'CF',			flt:'Numbers',	name:'DispAllTotalPaid', title:'Total Paid', desc:'Dispense Total Paid'},
					{section:'CF',			flt:'Numbers',	default: false, name:'NetTotalPaid', title:'Net Total Paid', desc:'Net Dispense Total Paid'},

					// pricing and cost - 7
					{section:'RxPrice',		flt:'Numbers',	name:'PharmacyCost', title:'Pharmacy Cost', desc:'Pharmacy Cost'},
					{section:'RxPrice',		flt:'Numbers',	name:'OrderFee', title:'Order Fee', desc:'Order Fee'},
					{section:'RxPrice',		flt:'Numbers',	name:'ReferralFee', title:'Referral Fee', desc:'Referral Fee'},
					{section:'RxPrice',		flt:'Numbers',	name:'DispenseFee', title:'Dispense Fee', desc:'Dispense Fee'},
					{section:'RxPrice',		flt:'Numbers',	default: false, name:'NetClaimProceeds', title:'Net Proceeds', desc:'Net Dispsense Proceeds'},
					{section:'RxPrice',		flt:'Numbers',	name:'Cost340b', title:'340B Cost', desc:'340B Cost'},
					{section:'RxPrice',		flt:'Numbers',	name:'GrossDispenseSavings', title:'Net Savings', desc:'Net Dispense Savings'},
					
					// invoice - 4
					{section:'Inv',			flt:'Dates',	name:'InvoiceDate', title:'Date', desc:'Invoice Date'},
					{section:'Inv',			flt:'Text',		name:'InvoiceNumber', title:'Number', desc:'Invoice #'},
					{section:'Inv',			flt:'Text',		name:'TransactionType', title:'Tran Type', desc:'Transaction Type'},
					{section:'Inv',			flt:'Text',		name:'InvoiceType', title:'Invoice Type', desc:'Invoice Type'},

					// payor - 1
					{section:'Pay', 		flt:'Text',		default: false, name:'BinPcnFormatted', title:'BIN PCN GRP', desc:'Payor BIN PCN GRP'},

					// adjustment - 1
					{section:'Adj',			flt:'Text',		default: false, name:'AdjustmentReason', title:'Reason', desc:'Adjustment Reason'}
				]
			},
			FIN_PAYMENTS: {
				title: 'Verity Payments',
				storageKey: 'tv-rpt-cpfin-fin_payments',
				name: 'FIN_PAYMENTS',
				sortby: 'PaymentDate',
				pgsize: 50,
				sections: {
					CE: {title:'Entity'},
					Pmt: {title: 'Payment'}
				},
				cols: [
					{section:'CE', 			flt:'Text',		edit: false, name:'CE', title:'Facility', desc:'Name of the ordering Facility'},
					{section:'Pmt', 		flt:'Text',		name:'CheckNum', title:'Check or ACH #', desc:'Check or ACH #'},
					{section:'Pmt',			flt:'Numbers',	name:'PaidAmount', title:'Amount', desc:'Paid Amount'},
					{section:'Pmt',			flt:'Dates',	name:'PaymentDate', title:'Date', desc:'Payment Date'}
				]
			}
		};

		if(validSvc.isText(tabName)) {
			return result[tabName];
		}
		else {
			return result;
		}
	}

	function tblViewConfigSetup(tblSchema) {
		// config setup converts all column schema into config columns / keys

		var result = {},
			cols = [],
			col = {},
			colKeys = {},
			colAllowed = [];

		for(var tabName in tblSchema) {
			if(tblSchema.hasOwnProperty(tabName)) {
				cols = tblSchema[tabName].cols;
				colKeys = {};
				colAllowed = [];

				for(var i = 0; i < cols.length; i++) {
					col = cols[i];

					// tbd... logic to remove conditional columns based on user type, etc

					// keep column
					colAllowed.push(col.name);
					colKeys[col.name] = col;
				}

				// update columns for this table
				tblSchema[tabName].cols = colAllowed;
				tblSchema[tabName].colKeys = colKeys;

				// add to result (which may have more than 1 table in config)
				result[tabName] = tblSchema[tabName];
			}
		}

		return result;
	}

	/**
	 * TABLE VIEW EVENT HANDLERS	
	 */

	 function okCurrentTableView() {

		// update session
		if(isFinTab(vm.reportTab)) {

			var tblConfig = vm.tblViewConfig[vm.reportTab];
			var tvSaved = sessionRepo.get(tblConfig.storageKey);

			if(!!tvSaved && !!vm.tblView && validSvc.isText(vm.tblView.current)) {
				tvSaved.current = vm.tblView.current;
				sessionRepo.set(tblConfig.storageKey, tvSaved);
			}
		}
	}

	function errCurrentTableView() {
		// do nothing
	}

	function tblViewReload(skipInitViews, fltKeepPaging) {
		// init and load table view structure
		var tblConfig = vm.tblViewConfig[vm.reportTab];
		if(!!!skipInitViews || !!!vm.tblView) {
			vm.tblView = vm.tblViewInit(tblConfig, sessionRepo.get(tblConfig.storageKey));
		}

		// add column titles and filters
		vm.tblView = vm.tblViewLoadTitlesAndFilters(tblConfig, vm.tblView, vm.flt);
		
		// update table view bar
		$scope.$broadcast('widget.tblview', {
			uniqueId: vm.reportTab, // tabs share same tblview widget
			current: vm.tblView.current,
			views: vm.tblView.views
		});

		if(!!vm.flt) {
			// remove any filter properties not shown in current table view
			vm.flt = vm.tblViewSyncFilter(tblConfig, vm.tblView, vm.flt, fltKeepPaging);
			filterChange(true);
		}
	}


	/**
	 *    TABLEVIEW POPUP
	 */

	function openPopup() {
		if(vm.isWaiting) {
			return;
		}

		// table view only supports CP Financial tabs
		if(!isFinTab(vm.reportTab)) {
			throw new Error('reportCtl.openPoup, unknown table view report tab: ' + vm.reportTab);
		}

		vm.popup = {
			type: 'TBLVIEW',
			title: vm.tblViewConfig[vm.reportTab].title + ' Table View Editor',
			ready: false
		};

		$scope.$broadcast('widget.tblview.editor', {
			uniqueId: vm.reportTab,
			config: vm.tblViewConfig[vm.reportTab]
		});

		// wait for digest before showing
		$timeout(function() {
			vm.popup.ready = true;
		}, 100);		
	}

	function closePopup() {
		if(vm.popup.type == 'TBLVIEW') {
			// wait a render cycle
			$timeout(function() {
				tblViewReload(false, true); // re-init views, keep paging if possible
			}, 300);
		}
		if(vm.popup.type == 'EXCEL') {
			_cpfrExcelJobId = null;
			_cpfrExcelPollStartTime = null;
		}
		vm.popup = {};
	}


	/**
	 * 	ASYNC REPORTS (legacy)
	 */

	function toggleAsyncReports() {
		if(vm.isWaiting) {
			return;
		}
		vm.asyncReports.show = vm.asyncReports.show == 'yes' ? 'no' : 'yes';
		if(vm.asyncReports.show == 'yes') {
			$state.go('report.cpfin.async-reports', {
				rptType: 'CPFR',
				query: null
			}, {reload: 'report.cpfin.async-reports'});
		}
	}


	/**
	 * 	ASYNC JOBS (CPFR Export)
	 */

	function _pollCpfrExcelJob() {
		if(!_cpfrExcelJobId) {
			return;
		}

		// Check if popup was closed (user chose not to wait)
		if(vm.popup.type !== 'EXCEL') {
			_cpfrExcelJobId = null;
			_cpfrExcelPollStartTime = null;
			return;
		}

		// Check if polling has exceeded 20 seconds
		if(_cpfrExcelPollStartTime && (Date.now() - _cpfrExcelPollStartTime) > 20000) {
			_cpfrExcelJobId = null;
			_cpfrExcelPollStartTime = null;
			if(vm.popup.type === 'EXCEL') {
				vm.popup = {};
				msgSvc.ok('Large File Request', 'This request is taking longer than expected. The file will be available in "Saved Files" once it is complete.');
			}
			return;
		}

		opsAsyncRepo.status(_cpfrExcelJobId).then(function(job) {
			var status = job.Status || job.status;

			if(status == 'COMPLETE') {
				var readyId = _cpfrExcelJobId;
				_cpfrExcelJobId = null;
				_cpfrExcelPollStartTime = null;
				var attrs = job.attrs || {};
				var fileName = (attrs.fileName || 'cpfr-export').replace(/\.xlsx$/i, '');
				opsAsyncRepo.get(readyId, fileName).then(function() {
					vm.popup = {};
				}, function() {
					vm.popup = {};
				});
				return;
			}

			if(status == 'FAILED') {
				_cpfrExcelJobId = null;
				_cpfrExcelPollStartTime = null;
				vm.popup = {};
				errSvc.warn('Excel export failed', 'cpfin.pollCpfrExcelJob', '', job.Error || job.error || 'Unknown error');
				return;
			}

			// still processing — poll again in 3 seconds
			$timeout(function() {
				_pollCpfrExcelJob();
			}, 3000);

		}, function(r) {
			_cpfrExcelJobId = null;
			_cpfrExcelPollStartTime = null;
			vm.popup = {};
			if(!!r) {
				errSvc.warn('Excel status check failed', 'cpfin.pollCpfrExcelJob', r.status, utilSvc.http.safeResponse(r));
			}
		});
	}

	function initAsyncJobs() {
		return {
			title: 'CP Financial - Saved Files',
			show: 'no',
			flt: { Count: 0, Text: {} },
			tbl: { DataItems: [], Items: [] }
		};
	}

	function toggleAsyncJobs() {
		if(vm.isWaiting) {
			return;
		}
		vm.asyncJobs.show = vm.asyncJobs.show == 'yes' ? 'no' : 'yes';
		if(vm.asyncJobs.show == 'yes') {
			asyncJobsRefresh();
		}
	}

	function asyncJobsRefresh() {
		opsAsyncRepo.list({ JobType: 'CPFR_EXPORT' }).then(function(jobs) {
			vm.asyncJobs.tbl.DataItems = (jobs || []).map(function(item) {
				var attrs = item.attrs || {};
				return {
					jobId: item.jobId,
					status: item.status,
					fileName: attrs.fileName || 'CP Financial Export',
					requestedDate: item.requestedDate ? new Date(item.requestedDate) : null,
					expirationDate: item.expirationDate ? new Date(item.expirationDate) : null
				};
			});
			asyncJobsFilterChange();
		}, function() {
			vm.asyncJobs.tbl.DataItems = [];
			vm.asyncJobs.tbl.Items = [];
			vm.asyncJobs.flt.Count = 0;
		});
	}

	function asyncJobsFilterChange() {
		var items = vm.asyncJobs.tbl.DataItems;
		var flt = vm.asyncJobs.flt.Text;

		if(flt.status) {
			items = $filter('filter')(items, { status: flt.status });
		}
		if(flt.fileName) {
			items = $filter('filter')(items, { fileName: flt.fileName });
		}

		// Sort newest first by default
		items = $filter('orderBy')(items, vm.asyncJobs._sortField || 'requestedDate', vm.asyncJobs._sortReverse !== false);

		vm.asyncJobs.tbl.Items = items;
		vm.asyncJobs.flt.Count = items.length;
	}

	function asyncJobsSortBy(field) {
		if(vm.asyncJobs._sortField == field) {
			vm.asyncJobs._sortReverse = !vm.asyncJobs._sortReverse;
		}
		else {
			vm.asyncJobs._sortField = field;
			vm.asyncJobs._sortReverse = false;
		}
		vm.asyncJobs.tbl.Items = $filter('orderBy')(vm.asyncJobs.tbl.Items, field, vm.asyncJobs._sortReverse);
	}

	function asyncJobsSortByIcon(field) {
		if(vm.asyncJobs._sortField != field) {
			return '';
		}
		return vm.asyncJobs._sortReverse ? 'icon-sort-down' : 'icon-sort-up';
	}

	function asyncJobsDownload(jobItem) {
		var jobId = jobItem.jobId;
		var fileName = (jobItem.fileName || 'cpfr-export').replace(/\.xlsx$/i, '');
		opsAsyncRepo.get(jobId, fileName);
	}

	function asyncJobsPageChange() {
		// placeholder for paging widget compatibility
	}


	/**
	 *    HELPERS
	 */

	function numberFmt(val, zeroFmt, prefix, decPlaces) {

		// helper to format incoming number data

		// nan
		if(!validSvc.isNumber(val)) {
			return '';
		}

		// zero
		if(val === 0) {
			return zeroFmt;
		}

		return prefix + utilSvc.str.toText($filter('number')(val, decPlaces));

	}

	function numberFmtNoPrefix(val, zeroFmt, decPlaces) {

		// api controls the sign

		// nan
		if(!validSvc.isNumber(val)) {
			return '';
		}

		// prefix is only controled by value
		if(val < 0) {
			return numberFmt(Math.abs(val), zeroFmt,'-', decPlaces); // neg
		}
		else {
			return numberFmt(val, zeroFmt,'', decPlaces); // pos, no sign
		}
	}

	function saveViewState(query, tabName, flt) {

		_tabFilters[tabName] = flt;

		// tbd: global grease, not adding the re-hydrate for global grease yet so no use saving it
		/*
		sessionRepo.set('vs-' + _featureName.replace(/\./g,'-'), {
			reportTab: tabName,
			query: {
				CE: query.CE.val,
				RX: query.RX.val,
				DateRangeMode: query.DateRangeMode,
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val
			},
			flt: _tabFilters
		});
		*/

	}

	function displayQuarter(dt) {

		// return Q1, Q2 text from incoming date

		if(!validSvc.isDate(dt)) {
			return '';
		}

		var qtrNum = Math.floor(dt.getMonth() / 3) + 1;
		return 'Q' + qtrNum + ' ' + dt.getFullYear().toString();

	}

	function displayQuarterMonths(dtStart, dtEnd, useUpperCase) {

		// return 'MMM through MMM' text for this quarter

		if(!validSvc.isDate(dtStart) || !validSvc.isDate(dtEnd)) {
			return '';
		}

		if(!!useUpperCase) {
			return utilSvc.dt.monthShortText(dtStart).toUpperCase() + ' through ' + utilSvc.dt.monthShortText(dtEnd).toUpperCase();
		}
		else {
			return utilSvc.dt.monthShortText(dtStart) + ' through ' + utilSvc.dt.monthShortText(dtEnd);
		}

	}

	function dateRangeIsCustom(dtMode) {
		return dtMode.indexOf('CUSTOM') > -1;
	}

	function isFinTab(tabName) {
		switch(tabName) {
			case 'FIN_ORDER':
			case 'FIN_INVOICES':
			case 'FIN_INVOICE_ITEMS':
			case 'FIN_DISP':
			case 'FIN_TPA_CLAIMS':
			case 'FIN_PAYMENTS':
				return true;
			default:
				return false;
		}
	}
} 
splitFinCtl.$inject = ['$scope', '$state', '$window', '$timeout', '$filter', 'reportRepo', 'sessionRepo', 'prefsRepo', 'appConst', 'utilSvc', 'validSvc', 'msgSvc', 'errSvc'];
angular
.module('espui.report')
.controller('SplitFinCtl', splitFinCtl);

/* @ngInject */
function splitFinCtl($scope, $state, $window, $timeout, $filter, reportRepo, sessionRepo, prefsRepo, appConst, utilSvc, validSvc, msgSvc, errSvc) {

	// private props
	var _pendingExcelFilename = '',
		_returnVisit = false,
		_mouseLeaveDelay = {},
		_tabFilters = {},
		_savedReports = [],
		_savedReportPending = {};

	var vm = this;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addMultiselect(vm);
	utilSvc.ctl.addTableViews(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.tabAction = '';
	vm.isVeriSaveOnly = false;

	// tabs
	vm.reportTab = '';
	vm.tabChange = tabChange;

	// query
	vm.query = {};
	vm.queryChangeCE = queryChangeCE;
	vm.queryChangeRX = queryChangeRX;
	vm.dateRangeChange = dateRangeChange;
	vm.querySubmit = querySubmit;

	// models
	vm.summary = {};

	// excel
	vm.createExcel = createExcel;

	// charts
	vm.chartSavings = {};
	vm.chartWAC = {};

	// table and filters
	vm.tbl = {};
	vm.flt = {};
	vm.filterChange = filterChange;

	// summary compare
	vm.compare = {Data:{}};
	vm.compareDateRangeList = [];
	vm.compareToggle = compareToggle;
	vm.compareLoadData = compareLoadData;

	// html display helpers
	vm.displayQuarter = displayQuarter;
	vm.displayQuarterMonths = displayQuarterMonths;

	// multiselect
	vm.CeMultiselect = {};
	vm.RxMultiselect = {};
	vm.multiselectCeToggle = multiselectCeToggle;
	vm.multiselectRxToggle = multiselectRxToggle;
	vm.multiselectMouseHover = multiselectMouseHover;
	vm.rxMultiHasModel = rxMultiHasModel;
	vm.rxMultiToggleModel = rxMultiToggleModel;
	vm.rxMultiModelFilter = rxMultiModelFilter;

	// time series
	vm.ts = {};
	vm.tsMetricDroplist = [];
	vm.tsToggle = tsToggle;
	vm.tsChangeMetric = tsChangeMetric;
	vm.tsChangeInterval = tsChangeInterval;
	vm.tsChangeType = tsChangeType;

	// async reports
	vm.asyncReports = {};
	vm.toggleAsyncReports = toggleAsyncReports;

	// popup
	vm.closePopup = closePopup;	

	/**
	 *    PAGING EVENT
	 */

	var _pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});


	var _tblViewEventListener = $scope.$on('widget.tblview.editor.change', function(event, evtData) {
		event.stopPropagation();

		if(vm.reportTab != 'SAVINGS' && vm.reportTab != 'INVDETAIL' && vm.reportTab != 'INVOICES' && vm.reportTab != 'FEES' && vm.reportTab != 'RETAILCLAIMS') {
			return;
		}

		switch(evtData.type) {

			case 'edit':
				openPopup(null, 'TBLVIEW');
				break;

			case 'close':
				closePopup();
				break;

			case 'load':
				// load specific view requested
				vm.tblView.current = evtData.id;
				$timeout(function() {
					tblViewReload(true);

					// update user preference (delay the network call)
					if(isFinTab(vm.reportTab)) {
						$timeout(function() {
							var tblConfig = vm.tblViewConfig[vm.reportTab];
							if(!!tblConfig && !!vm.tblView && validSvc.isText(vm.tblView.current)) {
								prefsRepo.setCurrentTableView(tblConfig.storageKey, vm.tblView.current).then(okCurrentTableView, errCurrentTableView);
							}
						}, 2000);
					}
				}, 300);
				break;

			default:
				throw new Error('widget.tblview.editor.change, unknown event type: ' + evtData.type);
		}

	});

	function openPopup(item, popType, evt) {
		// multi-use popup, all popups re-use: vm.popup / openPopup / closePopup

		if(vm.isWaiting) {
			return;
		}

		switch(popType) {
			case 'TBLVIEW':
				popTblView(vm.activeTab);
				break;
			default:
				throw new Error('refferalList.openPopup, unknown pop type: ' + popType);
		}
	}

	function popTblView(tabName) {
		vm.popup = {
			type: 'TBLVIEW',
			title: 'Table View Editor',
			ready: false
		};

		$scope.$broadcast('widget.tblview.editor', {
			uniqueId: tabName,
			config: vm.tblViewConfig[vm.reportTab]
		});

		$timeout(function() {
			vm.popup.ready = true;
		}, 200);
	}

	function closePopup() {
		var popType = vm.popup.type;
		vm.popup = {};

		// refresh list view coming back from detail view
		if(popType == 'DETAIL') {
			querySubmit();
		}
		else if(popType == 'TBLVIEW') {
			tblViewReload(false, true); // re-init views, keep paging if possible
		}
	}

	/**
	 *    TIMESERIES EVENT
	 */

	var _tsEventListener = $scope.$on('widget.timeseries.action', function(event, evtData) {
		event.stopPropagation();

		// exit if timeseries or filter is already gone
		if(vm.reportTab != 'SUMMARY' || vm.summary.mode != 'TIMESERIES') {
			return;
		}

		var d = evtData || {};

		// filter changed
		if(d.action == 'flt' && !!d.flt) {
			vm.ts.dirty = true;

			// store table filter by interval
			var fltKey = vm.ts.type + vm.ts.interval;
			vm.ts.prefs.flt[fltKey] = d.flt;
		}

	});


	/**
	 *    SAVED REPORT EVENT
	 */

	var _savedReportListener = $scope.$on('widget.savedreports.action', function(event, evtData) {
		event.stopPropagation();

		evtData = evtData || {};
		var reports = getSavedReports();

		switch(evtData.action) {

			case 'remove':
				_savedReportPending = evtSavedReportRemove(reports, evtData.id, evtData.current);
				break;

			case 'add':
				_savedReportPending = evtSavedReportAdd(reports, evtData.name);
				break;

			case 'current':
				_savedReportPending = evtSavedReportCurrent(reports, evtData.id);
				break;

			default:
				alert('splitFinCtl.evtSavedReport, unknown event type: ' + evtData.action);
		}

		// save changes to server
		if(_savedReportPending.action == 'add' || _savedReportPending.action == 'remove') {

			// save to session and database
			sessionRepo.set(srKey(), {version: srVersion(), reports: reports});
			prefsRepo.savedReports(srKey(), srVersion(), reports).then(okSavedReportsToServer, errSavedReportsToServer);
		}

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
		if(!!_tsEventListener) {
			_tsEventListener();
		}
		if(!!_tblViewEventListener) {
			_tblViewEventListener();
		}
		if(!!_savedReportListener) {
			_savedReportListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {
		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		vm.init = true;
		
		// Verisaver
		vm.isVeriSaveOnly = !!$scope.User.VeriSaveOnly;

		initCharts();
		_returnVisit = initQueryAndViewstate();
		vm.asyncReports = initAsyncReports();
		vm.reportTab = 'SUMMARY';
		vm.tblViewConfig = tblViewConfigSetup(tblViewSchemaVM());
		_tabFilters = initFilters();

		// set CE if viewstate wasn't used
		if(!_returnVisit && vm.query.CE.fail == 'no') {
			queryChangeCE(vm.query.CE.val);
		}

		// widget events after render
		$timeout(function() {
			$scope.$broadcast('widget.input.date.range.mode', {uniqueId: 'queryDates', mode: vm.query.DateRangeMode, keepDates: _returnVisit});
			if(_savedReports.length > 0) {
				$scope.$broadcast('widget.savedreports', {action: 'reports', reports: _savedReports});
			}
		}, 200);

	}

	function getAffs() {
		var affs = utilSvc.aff.findRxModel($scope.User.AffList, utilSvc.aff.rxModelsByFeature('report.splitfinancial'));
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
		return utilSvc.aff.findStatus(affs);
	}

	function initTimeSeriesDroplist() {
		// TBD TIMESERIES
		return [
			{value:'SavingsTotal', label:'Total Savings', fmt: 'currency', subtype: 'FIN'},
			{value:'SpendTotal', label:'Total Spend', fmt: 'currency', subtype: 'FIN'},
			{value:'Savings340BTotal', label:'340B Savings', fmt: 'currency', subtype: 'FIN'},
			{value:'Spend340BTotal', label:'340B Spend', fmt: 'currency', subtype: 'FIN'},
			{value:'SavingsGPOTotal', label:'GPO Savings', fmt: 'currency', subtype: 'FIN'},
			{value:'SpendGPOTotal', label:'GPO Spend', fmt: 'currency', subtype: 'FIN'},
			{value:'SpendWACTotal', label:'WAC Spend', fmt: 'currency', subtype: 'FIN'},
			{value:'ExcessWACTotal', label:'WAC GPO Excess', fmt: 'currency', subtype: 'FIN'},
			{value:'VerisaveSavings', label:'Verisave Savings', fmt: 'currency', subtype: 'FIN'},
			{value:'SpendWACMedicaid', label:'WAC Detail - Medicaid Spend', fmt: 'currency', subtype: 'FIN'},
			{value:'ExcessWACMedicaid', label:'WAC Detail - Medicaid GPO Excess', fmt: 'currency', subtype: 'FIN'},
			{value:'SpendWACOptimal', label:'WAC Detail - Optimized Spend', fmt: 'currency', subtype: 'FIN'},
			{value:'SavingsWACOptimal', label:'WAC Detail - Optimized GPO Excess', fmt: 'currency', subtype: 'FIN'},
			{value:'SpendWACDiscretionary', label:'WAC Detail - Discretionary Spend', fmt: 'currency', subtype: 'FIN'},
			{value:'ExcessWACDiscretionary', label:'WAC Detail - Discretionary GPO Excess', fmt: 'currency', subtype: 'FIN'},
			{value:'SpendWACRemainder', label:'WAC Detail - Remainder Spend', fmt: 'currency', subtype: 'FIN'},
			{value:'ExcessWACRemainder', label:'WAC Detail - Remainder GPO Excess', fmt: 'currency', subtype: 'FIN'},
			{value:'SpendWACSplit', label:'WAC Detail - Verity Split Subtotal Spend', fmt: 'currency', subtype: 'FIN'},
			{value:'ExcessWACSplit', label:'WAC Detail - Verity Split Subtotal GPO Excess', fmt: 'currency', subtype: 'FIN'},
			{value:'SpendWACNonSplit', label:'WAC Detail - External Orders Spend', fmt: 'currency', subtype: 'FIN'},
			{value:'ExcessWACNonSplit', label:'WAC Detail - External Orders GPO Excess', fmt: 'currency', subtype: 'FIN'},

			{value:'SavingsTotal', label:'Total Savings', fmt: 'currency', subtype: 'FIN'},
			{value:'SpendTotal', label:'Total Spend', fmt: 'currency', subtype: 'FIN'},
			{value:'Savings340BTotal', label:'340B Savings', fmt: 'currency', subtype: 'FIN'},
			{value:'Spend340BTotal', label:'340B Spend', fmt: 'currency', subtype: 'FIN'},
			{value:'SpendWACTotal', label:'Retail Spend', fmt: 'currency', subtype: 'FIN'},
			{value:'Savings340BSplit', label:'340B Verity Split Savings', fmt: 'currency', subtype: 'FIN'},
			{value:'Spend340BSplit', label:'340B Verity Split Spend', fmt: 'currency', subtype: 'FIN'},
			{value:'Savings340BNonSplit', label:'340B External Savings', fmt: 'currency', subtype: 'FIN'},
			{value:'Spend340BNonSplit', label:'340B External Spend', fmt: 'currency', subtype: 'FIN'},
			{value:'SpendWACSplit', label:'Retail Verity Split Spend', fmt: 'currency', subtype: 'FIN'},
			{value:'SpendWACNonSplit', label:'Retail External Spend', fmt: 'currency', subtype: 'FIN'},

			{value:'Dispenses', label:'Dispense - Evaluated', fmt: 'integer', subtype: 'DISP'},
			{value:'DispensesNotMatched', label:'Dispense - Not Matched', fmt: 'integer', subtype: 'DISP'},

			{value:'NewMatchedDispenses', label:'Match - New Matches', fmt: 'integer', subtype: 'DISP'},
			{value:'AcceptedSuspects', label:'Match - New Matches Accepted from Suspect', fmt: 'integer', subtype: 'DISP'},
			{value:'ReversedMatches', label:'Match - Reversed Matches', fmt: 'integer', subtype: 'DISP'},
			{value:'ProviderFiltered', label:'Match - Date Not Eligible', fmt: 'integer', subtype: 'DISP'},
			{value:'MedicaidFiltered', label:'Match - Medicaid Not Eligible', fmt: 'integer', subtype: 'DISP'},
			{value:'VisitProximityFiltered', label:'Match - Written Date Not Eligible', fmt: 'integer', subtype: 'DISP'},
			{value:'NpiProximityFiltered', label:'Match - NPI Written Date Not Eligible', fmt: 'integer', subtype: 'DISP'},
			{value:'BlockedScriptFiltered', label:'Match - Reject Script Not Eligible', fmt: 'integer', subtype: 'DISP'},
			{value:'LocationFiltered', label:'Match - Patient Location Not Eligible', fmt: 'integer', subtype: 'DISP'},
			{value:'ErxNpiFiltered', label:'Match - ePrescribe NPI Not Eligible', fmt: 'integer', subtype: 'DISP'},
			{value:'MiscFiltered', label:'Match - Misc Not Eligible', fmt: 'integer', subtype: 'DISP'},
			{value:'NewEligibleDispenses', label:'Match - New Eligible Dispenses', fmt: 'integer', subtype: 'DISP'},

			{value:'MatchedRatio', label:'Ratio - Matched Dispenses', fmt: 'integer', subtype: 'DISP'},
			{value:'EligibleDispensesRatio', label:'Ratio - Eligible Dispenses', fmt: 'integer', subtype: 'DISP'},
			{value:'EligibleMatchesRatio', label:'Ratio - Eligible Matches', fmt: 'integer', subtype: 'DISP'}
		];
	}

	function initQueryAndViewstate() {

		var returnVisit = false;

		vm.query = reportRepo.queryVM();
		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';
		vm.query.CE.vals = [];
		vm.query.RX.vals = [];

		vm.query.multi = false;
		vm.query.bigdate = false;
		vm.query.onlySummary = false;

		// date default
		vm.query.DateRangeValid = false;
		vm.query.DateRangeList = utilSvc.widget.dateRangeList(['CUSTOM92']);

		// add yearly options
		vm.query.DateRangeList.push({label: 'Last 12 Months', value: 'LTM'});
		vm.query.DateRangeList.push({label: 'Yearly', value: 'YEARLY'});
		vm.query.DateRangeList.push({label: 'Year To Date', value: 'YTD'});

		// unlimited custom range (move min validation dates to app start)
		// note: reportRepo does this by default but want to explicitly set it JIC repo changes in future
		var dtToday = new Date(),
			dtAppStart = utilSvc.dt.zeroTime(appConst.app.liveDate),
			customRangeDays = parseInt(utilSvc.dt.diffDays(dtAppStart, dtToday));
		vm.query.StartDate.min = dtAppStart;
		vm.query.EndDate.min = dtAppStart;
		vm.query.DateRangeList.push({label: 'Custom Date Range', value: 'CUSTOM' + customRangeDays.toString()});

		vm.query.DateRangeMode = 'MTD';

		// compare date list is hard coded and hidden by CSS
		vm.compareDateRangeList = [
			{label:'Last Month To Date', value:'LMTD'},
			{label:'Monthly', value:'MONTHLY'},
			{label:'Last Quarter To Date', value:'LQTD'},
			{label:'Last Year To Date', value:'LYTD'},
			{label:'Previous Last 12 Months', value:'LLTM'}
		];

		// RX multiselect
		vm.RxMultiselect = {
			type: 'RX',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Pharmacy',
			vals: [],
			list: [],
			flt: '',
			fltRxModels: ['SPLIT', 'SPLITMATCH']
		};

		// CE multiselect
		vm.CeMultiselect = {
			type: 'CE',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Facility',
			vals: [],
			list: [],
			flt: ''
		};

		// default CE list
		var affs = getAffs();
		vm.CeMultiselect.list = vm.multiselectBuild(utilSvc.aff.ceList(affs), false);

		// default tab filters
		_tabFilters = initFilters();

		// load saved reports, add widget details
		_savedReports = getSavedReports(true);

		// get viewstate
		var vs = sessionRepo.get('vs-report-splitfin');
		if(!!vs) {

			var storeType = '',
				vsq = {};

			if(validSvc.isText(vs.savedReport)) {
				// get query from saved report
				var srx = getSavedReportById(_savedReports, vs.savedReport);
				if(srx > -1) {
					storeType = 'sr';
					var sr = _savedReports[srx];
					vsq = sr;
				}
			}
			else {
				// get query from viewstate
				storeType = 'vs';
				vsq = vs.query;
			}

			// load saved query
			if(!!storeType) {
				returnVisit = loadSavedQuery(storeType, vsq);
			}

			if(returnVisit) {
				if(storeType == 'sr') {
					_savedReportPending = {
						action: 'current',
						id: vs.savedReport
					};
				}
			}
			else {
				// viewstate not valid
				sessionRepo.clearKey('vs-report-splitfin');
			}
		}

		// set titles
		vm.multiselectTitle(vm.CeMultiselect, true);
		vm.multiselectTitle(vm.RxMultiselect, true);

		return returnVisit;

	}

	function loadSavedQuery(storeType, vsq) {

		// load query from viewstate or a saved report

		var affs = getAffs();

		vm.CeMultiselect.list = vm.multiselectBuild(utilSvc.aff.ceList(affs), false);
		vm.multiselectReturnVisit(vm.CeMultiselect, '', vsq.CE);

		// rebuild RX list
		vm.RxMultiselect.vals = vsq.RX;
		vm.RxMultiselect = multiselectRebuildSecondary(vm.CeMultiselect, vm.RxMultiselect, affs, true);

		// did rebuild work?
		vm.query.CE.fail = vm.CeMultiselect.vals.length < 1 ? 'yes' : 'no';
		vm.query.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';
		if(vm.query.CE.fail == 'yes' || vm.query.RX.fail == 'yes') {
			return false;
		}

		// assign sub-properties
		vm.query.DateRangeMode = storeType == 'sr' ? vsq.DateMode : vsq.DateRangeMode;
		vm.query.StartDate.val = validSvc.isDate(vsq.StartDate) ? new Date(vsq.StartDate) : null;
		vm.query.EndDate.val = validSvc.isDate(vsq.EndDate) ? new Date(vsq.EndDate) : null;
		vm.query.DateRangeValid = true;

		if(storeType == 'vs') {
			_tabFilters = vsq.tabFilters;
		}

		return true;

	}

	function initFilters() {
		return {
			SUMMARY: {
			},
			SAVINGS: vm.initFilters({
				Config: {
					Dates: ['OrderDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['-OrderDate']
			}),
			INVDETAIL: vm.initFilters({
				Config: {
					Dates: ['OrderDate', 'InvoiceDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['-OrderDate']
			}),
			INVOICES: vm.initFilters({
				Config: {
					Dates: ['OrderDate', 'InvoiceDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['-OrderDate']
			}),
			RETAILCLAIMS: vm.initFilters({
				Config: {
					Dates: ['OrderDate', 'InvoiceDate', 'RxWrittenDate', 'RxFillDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['-InvoiceDate']
			}),
			FEES: vm.initFilters({
				Config: {
					Dates: ['OrderDate', 'InvoiceDate', 'RxWrittenDate', 'RxFillDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['-InvoiceDate']
			}),
		};
	}

	function initCharts(resetUI) {

		// reset all charts

		// reset SVG?
		if(!!resetUI) {
			if(vm.chartSavings.status == 'DRAW') {
				$scope.$broadcast('widget.chart.sync', {uniqueId: vm.chartSavings.id, render: ''});
			}
			if(vm.chartWAC.status == 'DRAW') {
				$scope.$broadcast('widget.chart.sync', {uniqueId: vm.chartWAC.id, render: ''});
			}
		}

		vm.chartSavings = initChart('CHART_SAVINGS');
		vm.chartWAC = initChart('CHART_WAC');

	}

	function initChart(id) {

		// minimum pie chart config
		// note: this is a slimmed down from full home page widgets

		var title = '';
		switch(id) {
			case 'CHART_SAVINGS':
				title = 'Total Spend';
				break;
			case 'CHART_WAC':
				title = 'WAC Spend';
				break;
			default:
				throw new Error('splitFinCtl.initChart, chart id unknown: ' + id);
		}

		return {
			id: id,
			status: '',
			config: {
				chartType: 'PIE',
				colors: [],
				valFormat: 'number',
				donutHoleRadius: 0.4,
				label: {
					width: 50,
					height: 30
				}
			},
			text: {
				title: title
			},
			data: []
		};

	}

	function initAsyncReports() {
		return {
			title: 'Facility Financial - Saved Files',
			show: 'no'
		};
	}

	/**
	 *    VIEW MODELS
	 */

	function summaryVM(data) {
		// TBD
		data = data || {};

		// build rpt rows
		var items = [];

		// Split Order Invoices
		items.push({type:'blank'});
		items.push({type:'section-title', l:{txt:'Split Order Invoices'}, r:{txt:'External Order Invoices'}});
		items.push({type:'blank'});

		// 340B SPLIT
		items.push({type:'sub-section-title', l:{txt:'340B'}, r:{txt:'340B'}});
		items.push({type:'data', l:{key:'', txt:'Debits',val:data.MUSplit340BDebitsTotal,comp:0}, r:{key:'', txt:'Debits',val:data.MUExternal340BDebitsTotal,comp:0}});
		items.push({type:'data', l:{key:'', txt:'Credits',val:data.MUSplit340BCreditsTotal,comp:0}, r:{key:'', txt:'Credits',val:data.MUExternal340BCreditsTotal,comp:0}});
		items.push({type:'data', l:{key:'', txt:'Total Spend',val:data.MUSplit340BTotal,comp:0}, r:{key:'', txt:'Total Spend',val:data.MUExternal340BTotal,comp:0}});
		items.push({type:'sub-total', l:{key:'', txt:'Savings',val:data.MUSplit340BSavings,comp:0}, r:{key:'', txt:'Savings',val:data.MUExternal340BSavings,comp:0}});
		items.push({type:'blank'});

		// GPO SPLIT
		items.push({type:'sub-section-title', l:{txt:'GPO'}, r:{txt:'GPO'}});
		items.push({type:'data', l:{key:'', txt:'Debits',val:data.MUSplitGPODebitsTotal,comp:0}, r:{key:'', txt:'Debits',val:data.MUExternalGPODebitsTotal,comp:0}});
		items.push({type:'data-double-indent', l:{key:'', txt:'Price Select',val:data.MUSplitGPOPriceSelect,comp:0}, r:{hide:true}});
		items.push({type:'data', l:{key:'', txt:'Credits',val:data.MUSplitGPOCreditsTotal,comp:0}, r:{key:'', txt:'Credits',val:data.MUExternalGPOCreditsTotal,comp:0}});
		items.push({type:'sub-total', l:{key:'', txt:'Total Spend',val:data.MUSplitGPOTotal,comp:0}, r:{key:'', txt:'Total Spend',val:data.MUExternalGPOTotal,comp:0}});
		items.push({type:'blank'});

		// WAC MEDICAID (hide if not used)
		if(data.MUWacMedShow) {
			items.push({type:'sub-section-title', l:{txt:'WAC Medicaid'}, r:{txt:'WAC Medicaid'}});
			items.push({type:'data', l:{key:'', txt:'Debits',val:data.MUSplitWACMEDDebitsTotal,comp:0}, r:{key:'', txt:'Debits',val:data.MUExternalWACMEDDebitsTotal,comp:0}});
			items.push({type:'data', l:{key:'', txt:'Credits',val:data.MUSplitWACMEDCreditsTotal,comp:0}, r:{key:'', txt:'Credits',val:data.MUExternalWACMEDCreditsTotal,comp:0}});
			items.push({type:'sub-total', l:{key:'', txt:'Total Spend',val:data.MUSplitWACMEDTotal,comp:0}, r:{key:'', txt:'Total Spend',val:data.MUExternalWACMEDTotal,comp:0}});
			items.push({type:'blank'});
		}
		
		// WAC REM
		if(data.MUWacShow) {
			items.push({type:'sub-section-title', l:{txt:'WAC Remainder'}, r:{txt:'WAC Remainder'}});
			items.push({type:'data', l:{key:'', txt:'Debits',val:data.MUSplitWACDebitsTotal,comp:0}, r:{key:'', txt:'Debits',val:data.MUExternalWACDebitsTotal,comp:0}});
			// items.push({type:'data-double-indent', l:{key:'', txt:'Price Select',val:data.MUSplitWACPriceSelect,comp:0}, r:{}});
			items.push({type:'data', l:{key:'', txt:'Credits',val:data.MUSplitWACCreditsTotal,comp:0}, r:{key:'', txt:'Credits',val:data.MUExternalWACCreditsTotal,comp:0}});
			items.push({type:'sub-total', l:{key:'', txt:'Total Spend',val:data.MUSplitWACTotal,comp:0}, r:{key:'', txt:'Total Spend',val:data.MUExternalWACTotal,comp:0}});
			items.push({type:'blank'});
		}
		
		// NET ORDER SAVINGS
		items.push({type:'section-title-wide', txt:'Net Order Savings'});
		items.push({type:'data-no-indent', l:{key:'', txt:'340B Savings',val:data.MUSplit340BSavings,comp:0}, r:{key:'', txt:'340B Savings',val:data.MUExternal340BSavings,comp:0}}); // repeat from above
		items.push({type:'data-no-indent', l:{key:'', txt:'WAC Medicaid Variance',val:data.MUSplitWACMEDVariance,comp:0}, r:{key:'', txt:'WAC Medicaid Variance',val:data.MUExternalWACMEDVariance,comp:0}});
		items.push({type:'data-no-indent', l:{key:'', txt:'WAC Variance',val:data.MUSplitWACVariance,comp:0}, r:{key:'', txt:'WAC Variance',val:data.MUExternalWACVariance,comp:0}});
		items.push({type:'sub-total', l:{key:'', txt:'Split Order Net Savings',val:data.NetSavingsMUSplit,comp:0}, r:{key:'', txt:'External Order Net Savings',val:data.NetSavingsMUExternal,comp:0}});
		items.push({type:'blank'});
		items.push({type:'section-total-wide', txt:'TOTAL NET ORDER SAVINGS', val:data.TotalNetSavings,comp:0});
		items.push({type:'blank'});

		// Split Order Invoices
		items.push({type:'section-title', l:{txt:'Retail - Split Order Invoices'}, r:{txt:'Retail - External Order Invoices'}});
		items.push({type:'blank'});

		// 340B SPLIT
		items.push({type:'sub-section-title', l:{txt:'340B'}, r:{txt:'340B'}});
		items.push({type:'data', l:{key:'', txt:'Debits',val:data.RetailSplit340BDebitsTotal,comp:0}, r:{key:'', txt:'Debits',val:data.RetailExternal340BDebitsTotal,comp:0}});
		items.push({type:'data', l:{key:'', txt:'Credits',val:data.RetailSplit340BCreditsTotal,comp:0}, r:{key:'', txt:'Credits',val:data.RetailExternal340BCreditsTotal,comp:0}});
		items.push({type:'data', l:{key:'', txt:'Total Spend',val:data.RetailSplit340BTotal,comp:0}, r:{key:'', txt:'Total Spend',val:data.RetailExternal340BTotal,comp:0}});
		items.push({type:'sub-total', l:{key:'', txt:'Savings',val:data.RetailSplit340BSavings,comp:0}, r:{key:'', txt:'Savings',val:data.RetailExternal340BSavings,comp:0}});
		items.push({type:'blank'});

		// OWN USE
		if(data.RetailSplitOWNShow) {
			items.push({type:'sub-section-title', l:{txt:'Own Use'}, r:{txt:'Own Use'}});
			items.push({type:'data', l:{key:'', txt:'Debits',val:data.RetailSplitOWNDebitsTotal,comp:0}, r:{key:'', txt:'Debits',val:data.RetailExternalOWNDebitsTotal,comp:0}});
			items.push({type:'data', l:{key:'', txt:'Credits',val:data.RetailSplitOWNCreditsTotal,comp:0}, r:{key:'', txt:'Credits',val:data.RetailExternalOWNCreditsTotal,comp:0}});
			items.push({type:'sub-total', l:{key:'', txt:'Total Spend',val:data.RetailSplitOWNTotal,comp:0}, r:{key:'', txt:'Total Spend',val:data.RetailExternalOWNTotal,comp:0}});
			items.push({type:'sub-total', l:{key:'', txt:'Savings',val:data.RetailSplitOWNSavings,comp:0}, r:{key:'', txt:'Savings',val:data.RetailExternalOWNSavings,comp:0}});
			items.push({type:'blank'});
		}
		
		// GPO SPLIT
		if(data.RetailSplitGPOShow) {
			items.push({type:'sub-section-title', l:{txt:'GPO'}, r:{txt:'GPO'}});
			items.push({type:'data', l:{key:'', txt:'Debits',val:data.RetailSplitGPODebitsTotal,comp:0}, r:{key:'', txt:'Debits',val:data.RetailExternalGPODebitsTotal,comp:0}});
			items.push({type:'data', l:{key:'', txt:'Credits',val:data.RetailSplitGPOCreditsTotal,comp:0}, r:{key:'', txt:'Credits',val:data.RetailExternalGPOCreditsTotal,comp:0}});
			items.push({type:'sub-total', l:{key:'', txt:'Total Spend',val:data.RetailSplitGPOTotal,comp:0}, r:{key:'', txt:'Total Spend',val:data.RetailExternalGPOTotal,comp:0}});
			items.push({type:'blank'});
		}
		
		// WAC REM
		items.push({type:'sub-section-title', l:{txt:'Retail Remainder'}, r:{txt:'Retail Remainder'}});
		items.push({type:'data', l:{key:'', txt:'Debits',val:data.RetailSplitREMDebitsTotal,comp:0}, r:{key:'', txt:'Debits',val:data.RetailExternalREMDebitsTotal,comp:0}});
		items.push({type:'data-double-indent', l:{key:'', txt:'Price Select',val:data.RetailSplitREMPriceSelectTotal,comp:0}, r:{hide:true}});
		items.push({type:'data', l:{key:'', txt:'Credits',val:data.RetailSplitREMCreditsTotal,comp:0}, r:{key:'', txt:'Credits',val:data.RetailExternalREMCreditsTotal,comp:0}});
		items.push({type:'sub-total', l:{key:'', txt:'Total Spend',val:data.RetailSplitREMTotal,comp:0}, r:{key:'', txt:'Total Spend',val:data.RetailExternalREMTotal,comp:0}});
		items.push({type:'blank'});
		
		// NET RETAIL SAVINGS
		items.push({type:'section-title-wide', txt:'Net Retail Savings'});
		items.push({type:'data-no-indent', l:{key:'', txt:'340B Savings',val:data.RetailSplit340BSavings,comp:0}, r:{key:'', txt:'340B Savings',val:data.RetailExternal340BSavings,comp:0}}); // repeat from above
		items.push({type:'data-no-indent', l:{key:'', txt:'Retail Variance',val:data.RetailSplitREMVariance,comp:0}, r:{key:'', txt:'Retail Variance',val:data.RetailExternalREMVariance,comp:0}});
		items.push({type:'sub-total', l:{key:'', txt:'Split Retail Net Savings',val:data.NetSavingsRetail,comp:0}, r:{key:'', txt:'External Retail Net Savings',val:data.NetSavingsRetailExternal,comp:0}});
		items.push({type:'blank'});
		items.push({type:'section-total-wide', txt:'TOTAL NET RETAIL SAVINGS', val:data.TotalRetailNetSavings,comp:0});
		items.push({type:'blank'});

		// GRAND TOTALS
		items.push({type:'blank'});
		items.push({type:'section-title-wide', txt:'GRAND TOTALS'});

		// savings
		items.push({type:'sub-section-title', l:{txt:'Savings'}, r:{}});
		items.push({type:'data-no-indent', l:{key:'', txt:'Order Net Savings',val:data.TotalNetSavings,comp:0}, r:{hide:true}});
		items.push({type:'data-no-indent', l:{key:'', txt:'Retail Net Savings',val:data.TotalRetailNetSavings,comp:0}, r:{hide:true}});
		items.push({type:'sub-total', l:{key:'', txt:'Combined Net Savings',val:data.TotalSavings,comp:0}, r:{hide:true}});
		items.push({type:'blank'});

		// fees
		items.push({type:'sub-section-title', l:{txt:'Verity Fees'}, r:{}});
		items.push({type:'data-no-indent', l:{key:'', txt:'Verity Retail Monthly Fees',val:data.TotalVerityMonthlyFees,comp:0}, r:{hide:true}});
		items.push({type:'data-no-indent', l:{key:'', txt:'Order Fees',val:data.TotalVerityOrderFees,comp:0}, r:{hide:true}});
		items.push({type:'data-no-indent', l:{key:'', txt:'Referrral Order Fees',val:data.TotalVerityReferralFees,comp:0}, r:{hide:true}});
		items.push({type:'sub-total', l:{key:'', txt:'Total Verity Fees',val:data.TotalFees,comp:0}, r:{hide:true}});
		items.push({type:'blank'});
		items.push({type:'section-total-wide', txt:'SAVINGS GRAND TOTAL', val:data.TotalSavings});
		items.push({type:'blank'});

		// purchase optimization
		items.push({type:'sub-section-title', l:{txt:'Purchase Optimization Analysis'}, r:{}});
		items.push({type:'data-no-indent', l:{key:'', txt:'Base Cost',val:data.TotalBaseCost,comp:0}, r:{hide:true}});
		items.push({type:'data-no-indent', l:{key:'', txt:'NDC Optimizer',val:data.TotalNdcOptimizerSavings,comp:0}, r:{hide:true}});
		items.push({type:'data-no-indent', l:{key:'', txt:'Price Select',val:data.TotalPriceSelectSavings,comp:0}, r:{hide:true}});
		if(data.UseBestCost) {
		items.push({type:'data-no-indent', l:{key:'', txt:'VERISAVE®',val:data.TotalVerisaveSavings,comp:0}, r:{hide:true}});
		}
		items.push({type:'data-no-indent', l:{key:'', txt:'Multi-Vendor',val:data.TotalAltVendorSavings,comp:0}, r:{hide:true}});
		items.push({type:'sub-total', l:{key:'', txt:'Total Feature Savings',val:data.TotalFeatureSavings,comp:0}, r:{hide:true}});

		return {
			isCompare: false,
			Items:items
		};
	}

	function savingsVM(dataItems, tooMany) {
		dataItems = Array.isArray(dataItems) ? dataItems : [];

		// clean up incoming data
		var item = {};
		for (var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.uniqueId = i.toString();
		}

		return {
			Items: [],
			DataItems: dataItems,
			TooMany: !!tooMany
		};
	}

	function invoiceItemsVM(dataItems, tooMany) {
		dataItems = Array.isArray(dataItems) ? dataItems : [];
		var item = {};

		for (var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.uniqueId = i.toString();

			item.Split = !!item.Split ? 'YES' : 'NO';
			item.AlwaysSplit = !!item.AlwaysSplit ? 'YES' : 'NO';
			item.Manual = !!item.Manual ? 'YES' : 'NO';
			item.PriceSelect = !!item.PriceSelect ? 'YES' : 'NO';
			item.VERISAVE = !!item.VERISAVE ? 'YES' : 'NO';
		}

		return {
			DataItems: dataItems,
			Items: [], // items will be loaded by filterChange() method
			TooMany: !!tooMany
		};

	}

	function invoicesVM(dataItems, tooMany) {
		dataItems = Array.isArray(dataItems) ? dataItems : [];
		var item = {};

		for (var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.uniqueId = i.toString();

			item.Split = !!item.Split ? 'YES' : 'NO';
			item.Manual = !!item.Manual ? 'YES' : 'NO';
		}

		return {
			DataItems: dataItems,
			Items: [], // items will be loaded by filterChange() method
			TooMany: !!tooMany
		};
	}

	function retailClaimsVM(dataItems, tooMany) {
		dataItems = Array.isArray(dataItems) ? dataItems : [];
		var item = {};

		for (var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.uniqueId = i.toString();

			//item.Referral = !!item.Referral ? 'YES' : 'NO';
		}

		return {
			DataItems: dataItems,
			Items: [], // items will be loaded by filterChange() method
			TooMany: !!tooMany
		};
	}

	function feesVM(dataItems, tooMany) {
		dataItems = Array.isArray(dataItems) ? dataItems : [];
		var item = {};

		for (var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.uniqueId = i.toString();

			item.Referral = !!item.Referral ? 'YES' : 'NO';
		}

		return {
			DataItems: dataItems,
			Items: [], // items will be loaded by filterChange() method
			TooMany: !!tooMany
		};
	}

	function chartSavingsVM(r) {

		// pie chart, parse data into pie chart format

		r = r || {};

		var chart = initChart('CHART_SAVINGS'),
			data = [],
			wedge340B = validSvc.isNumber(r.Spend340BTotal) ? r.Spend340BTotal : 0,
			wedgeGPO = validSvc.isNumber(r.SpendGPOTotal) ? r.SpendGPOTotal : 0,
			wedgeWAC = validSvc.isNumber(r.SpendWACTotal) ? r.SpendWACTotal : 0;

		// no data?
		if((wedge340B + wedgeGPO + wedgeWAC) <= 0) {
			return chart;
		}

		// 340B
		chart.data.push({
			name: '340B',
			val: wedge340B,
			percent: Math.round(r.Spend340BPercent),
			color: appConst.app.color.chart340B
		});

		// GPO
		chart.data.push({
			name: 'GPO',
			val: wedgeGPO,
			percent: Math.round(r.SpendGPOPercent),
			color: appConst.app.color.chartGPO
		});

		// WAC
		chart.data.push({
			name: 'WAC',
			val: wedgeWAC,
			percent: Math.round(r.SpendWACPercent),
			color: appConst.app.color.chartWAC
		});

		// sort
		chart.data = utilSvc.array.sortDSC(chart.data, 'percent');

		// modify config colors to match account types (this chart doesn't use standard Verity widget colors)
		for(var i = 0; i < chart.data.length; i++) {
			chart.config.colors.push(appConst.app.color['chart' + chart.data[i].name]);
		}

		return chart;

	}

	function chartWACVM(r) {

		// pie chart, parse data into pie chart format

		r = r || {};

		var chart = initChart('CHART_WAC'),
			data = [];

		// no data?
		if(r.SpendWACTotal <= 0 || r.SpendWACMedicaidPercent + r.SpendWACOptimalPercent +
			r.SpendWACDiscretionaryPercent + r.SpendWACRemainderPercent + r.SpendWACNonSplitPercent <= 0) {
			return chart;
		}

		if(r.SpendWACMedicaidPercent >= 0.01) {
			data.push({
				name: 'Medicaid',
				val: r.SpendWACMedicaid,
				percent: r.SpendWACMedicaidPercent
			});
		}

		if(r.SpendWACOptimalPercent >= 0.01) {
			data.push({
				name: 'Optimized',
				val: r.SpendWACOptimal,
				percent: r.SpendWACOptimalPercent
			});
		}

		if(r.SpendWACDiscretionaryPercent >= 0.01) {
			data.push({
				name: 'Discretionary',
				val: r.SpendWACDiscretionary,
				percent: r.SpendWACDiscretionaryPercent
			});
		}

		if(r.SpendWACRemainderPercent >= 0.01) {
			data.push({
				name: 'Remainder',
				val: r.SpendWACRemainder,
				percent: r.SpendWACRemainderPercent
			});
		}

		if(r.SpendWACNonSplitPercent >= 0.01) {
			data.push({
				name: 'External',
				val: r.SpendWACNonSplit,
				percent: r.SpendWACNonSplitPercent
			});
		}

		// no data after value check?
		if(data.length < 1) {
			return chart;
		}
		chart.data = data;

		chart.data = utilSvc.array.sortDSC(chart.data, 'percent');
		chart.config.colors = appConst.app.color.chartBars($window.espuiPrefs.skin);

		return chart;

	}


	/**
	 *    QUERY / TAB CHANGE
	 */

	function queryChange() {

		if(!vm.init) {
			vm.tabAction = '';

			// summary
			initCharts(true);
			vm.summary = {};
			vm.compare = {Data:{}};

			// timeseries, saved reports
			tsReset();
			$scope.$broadcast('widget.savedreports');

			// tables
			vm.tbl = {};
			vm.flt = {};
			$scope.$broadcast('widget.paging');
		}

	}

	function multiselectCeToggle(evt, id) {
		vm.RxMultiselect.show = false;
		multiselectToggle(evt, vm.CeMultiselect, id);
	}

	function multiselectRxToggle(evt, id) {
		vm.CeMultiselect.show = false;
		multiselectToggle(evt, vm.RxMultiselect, id);
	}

	function rxMultiHasModel(rxModel) {
		if(!!!vm.RxMultiselect || !Array.isArray(vm.RxMultiselect.fltRxModels) || (rxModel != 'SPLIT' && rxModel != 'SPLITMATCH')) {
			return false;
		}
		return vm.RxMultiselect.fltRxModels.indexOf(rxModel) > -1;
	}

	function rxMultiToggleModel(rxModel) {
		if(vm.isWaiting || !!!vm.RxMultiselect || (rxModel != 'SPLIT' && rxModel != 'SPLITMATCH')) {
			return;
		}
		var fltModels = Array.isArray(vm.RxMultiselect.fltRxModels) ? vm.RxMultiselect.fltRxModels : [];
		var idx = fltModels.indexOf(rxModel);

		// already there toggle it out
		if(idx > -1) {
			fltModels.splice(idx, 1);
		}
		else {
			fltModels.push(rxModel);
		}

		vm.RxMultiselect.fltRxModels = fltModels;
	}

	function rxMultiModelFilter(item) {
		if(!!!item || !Array.isArray(item.rxModels)) {
			return false;
		}
		if(item.rxModels.indexOf('SPLIT') > -1 && rxMultiHasModel('SPLIT')) {
			return true;
		}
		if(item.rxModels.indexOf('SPLITMATCH') > -1 && rxMultiHasModel('SPLITMATCH')) {
			return true;
		}
		return false;
	}

	function queryChangeCE(val) {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.multiselectClick(vm.CeMultiselect, val);
		vm.multiselectTitle(vm.CeMultiselect, true);

		vm.query.CE.fail = vm.CeMultiselect.vals.length < 1 ? 'yes' : 'no';

		// rebuild RX
		vm.RxMultiselect = multiselectRebuildSecondary(vm.CeMultiselect, vm.RxMultiselect, getAffs(), true);
		vm.query.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';

	}

	function queryChangeRX(val) {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.multiselectClick(vm.RxMultiselect, val);
		vm.multiselectTitle(vm.RxMultiselect, true);

		vm.query.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';

	}

	function dateRangeChange(uniqueId, dtMode, isValid) {
		switch(uniqueId) {

			case 'queryDates':
				queryChange();
				vm.query.DateRangeMode = dtMode;
				vm.query.DateRangeValid = isValid;

				if(_returnVisit) {
					_returnVisit = false;
					querySubmit();
				}

				vm.init = false;
				break;

			case 'compareDates':
				// summary compare
				vm.compare.DateRangeMode = dtMode;
				vm.compare.DateRangeValid = isValid;

				// user must choose before query
				if(dtMode == 'QTR' || dtMode == 'YEARLY') {
					vm.summary.mode = 'COMPAREQUERY';
				}

				// when summary compare loads it fires this mode change, do query on this event
				if(vm.summary.mode != 'COMPAREQUERY') {
					compareLoadData();
				}
				break;

			default:
				alert('splitFinCtl.dateRangeChange, unknown date range id: ' + uniqueId);
		}

	}

	function tabChange(tabName) {

		if(vm.isWaiting) {
			return;
		}

		if(tabName != 'SUMMARY' && (vm.query.multi || vm.query.bigdate)) {
			return;
		}

		vm.flt = vm.resetFilters(_tabFilters[tabName]);
		vm.reportTab = tabName;

		switch(tabName) {

			case 'SUMMARY':
				// summary data is already cached
				vm.tbl.Items = [];
				$scope.$broadcast('widget.paging');
				break;

			case 'SAVINGS':
			case 'INVOICES':
			case 'INVDETAIL':
			case 'RETAILCLAIMS':
			case 'FEES':
				vm.tbl = {};
				$scope.$broadcast('widget.paging');
				getTabData(tabName);
				break;

			default:
				throw new Error('splitFinCtl.tabChange, unknown tab name: ' + tabName);

		}

	}


	/**
	 *    GLOBAL GREASE FILTER
	 */

	function updatePagingWidget(tabName, flt, tbl) {

		$scope.$broadcast('widget.paging', {
			uniqueId: tabName,
			Size: flt.PageSize,
			Page: flt.Page,
			Total: flt.PageTotal,
			RowCount: flt.Count,
			ItemCount: tbl.Items.length,
			DataCount: tbl.DataItems.length
		});

	}

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {
			if(vm.activeTab != 'SUMMARY') {
				vm.flt = vm.tblViewGetColumnFilterValues(vm.tblView.cols, vm.flt);
			}

			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			updatePagingWidget(vm.reportTab, vm.flt, vm.tbl);

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					saveViewState(vm.reportTab, vm.query, vm.flt, vm.CeMultiselect.vals, vm.RxMultiselect.vals);
				}
			},1000);

		}, delayTime);

	}


	/**
	 *    QUERY SUBMIT
	 */

	function queryValid(ceVals, rxVals) {

		vm.query.CE.fail = ceVals.length < 1 ? 'yes' : 'no';
		vm.query.RX.fail = rxVals.length < 1 ? 'yes' : 'no';

		return vm.query.DateRangeValid &&
			vm.query.CE.fail != 'yes' &&
			vm.query.RX.fail != 'yes';

	}

	function querySubmit() {

		// validate
		var ceVals = multiselectQueryVals(vm.CeMultiselect),
			rxVals = multiselectQueryVals(vm.RxMultiselect);

		if(!queryValid(ceVals, rxVals)) {
			if(!vm.init) {
				msgSvc.ok('Search', 'Check filter settings');
			}
			return;
		}

		queryChange();
		vm.summary = {};

		// assign multi values
		vm.query.CE.vals = ceVals;
		vm.query.RX.vals = rxVals;
		vm.query.multi = false;
		if((ceVals[0] == 'ALL' || ceVals.length > 1) && (rxVals[0] == 'ALL' || rxVals.length > 1)) {
			vm.query.multi = true;
		}

		vm.query.bigdate = false;
		var dtMode = vm.query.DateRangeMode;
		if(dtMode == 'YEARLY' || dtMode == 'YTD' || dtMode == 'LTM' || dateRangeIsCustom(dtMode)) {
			vm.query.bigdate = utilSvc.dt.diffDays(vm.query.StartDate.val, vm.query.EndDate.val) > 92;
		}

		vm.query.splittransinclude = false;
        
		// check if split transactions can be included
        vm.query.splittransinclude = utilSvc.dt.diffDays(vm.query.StartDate.val, vm.query.EndDate.val) < 190;

		vm.query.onlySummary = vm.query.multi || vm.query.bigdate;

		if (vm.reportTab != 'SUMMARY') {
			vm.reportTab = 'SUMMARY';
			tabChange(vm.reportTab);
		}

		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true);

		reportRepo.getSplitFinancial(vm.reportTab, vm.query, false).then(okData, errData);  // false = not a comparison query

		function okData(r) {
			vm.isWaiting = false;
			vm.tabAction = 'LIST';
			msgSvc.wait(false);

			if (vm.reportTab == 'SUMMARY') {
				// SPLIT request has both Summary and Detail tab data in one call
				vm.summary = summaryVM(r);
				vm.chartSavings = chartSavingsVM(r);
				vm.chartWAC = chartWACVM(r);

				// render charts after digest
				$timeout(function() {

					var chart = vm.chartSavings;
					if(chart.data.length > 0) {

						chart.status = 'DRAW';
						$scope.$broadcast('widget.chart.sync', {
							uniqueId: chart.id,
							config: chart.config,
							data: chart.data,
							render: 'animate'
						});
					}

					chart = vm.chartWAC;
					if(chart.data.length > 0) {
						chart.status = 'DRAW';
						$scope.$broadcast('widget.chart.sync', {
							uniqueId: chart.id,
							config: chart.config,
							data: chart.data,
							render: 'animate'
						});
					}

				},300);
			
				// show comparison prompt?
				vm.compare.prompt = false;
				switch(vm.query.DateRangeMode) {
					case 'MONTHLY':
						vm.compare.prompt = true;
						vm.compare.title = 'Compare With Previous Month';
						break;
					case 'MTD':
						vm.compare.prompt = true;
						vm.compare.title = 'Compare With Previous Month To Date';
						break;
					case 'QTD':
						vm.compare.prompt = true;
						vm.compare.title = 'Compare With Previous Quarter To Date';
						break;
					case 'QTDLAST':
					case 'QTR':
						vm.compare.prompt = true;
						vm.compare.title = 'Compare With Another Quarter';
						break;
					case 'YTD':
						vm.compare.prompt = true;
						vm.compare.title = 'Compare With Previous Year To Date';
						break;
					case 'YEARLY':
						vm.compare.prompt = true;
						vm.compare.title = 'Compare With Another Year';
						break;
					case 'LTM':
						vm.compare.prompt = true;
						vm.compare.title = 'Compare With Previous Last 12 Months';
						break;
				}

				vm.summary.mode = 'TOTALS';

				// update saved report widget query
				var srCurrent = '';
				if(validSvc.isText(_savedReportPending.id) && (_savedReportPending.action == 'add' || _savedReportPending.action == 'current')) {
					srCurrent = _savedReportPending.id;
				}
				_savedReportPending = {};

				$timeout(function() {
					$scope.$broadcast('widget.savedreports', {
						action: 'query',
						query: {
							details: savedReportWidgetDetailsFmt(
								vm.query.CE.vals,
								vm.query.RX.vals,
								vm.query.DateRangeMode,
								vm.query.StartDate.val,
								vm.query.EndDate.val
							)
						},
						current: srCurrent
					});
				},500);

				// query was good, save viewstate
				saveViewState('SUMMARY', vm.query, vm.flt, vm.CeMultiselect.vals, vm.RxMultiselect.vals, srCurrent);
			}
		}

		function errData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Error loading split savings report', 'splitFinCtl.querySubmit', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    SUMMARY COMPARISON
	 */

	function compareToggle() {

		// turn compare display on/off

		if(vm.summary.mode == 'COMPAREQUERY' || vm.summary.mode == 'COMPARE') {
			// toggle off
			vm.compare.Data = {};
			vm.summary.mode = 'TOTALS';
		}
		else {
			// toggle on

			vm.compare.DateRangeValid = false;

			// setup Compare dates based on query mode
			var compareKeepDates = false;
			switch(vm.query.DateRangeMode) {

				case 'MONTHLY':
					// default to previous month from query
					vm.compare.DateRangeMode = 'MONTHLY';
					compareKeepDates = true;
					vm.query.CompareStartDate.val = utilSvc.dt.addMonths(utilSvc.dt.monthStart(vm.query.StartDate.val), -1);
					vm.query.CompareEndDate.val = utilSvc.dt.monthEnd(vm.query.CompareStartDate.val);
					break;

				case 'MTD':
					vm.compare.DateRangeMode = 'LMTD';
					break;

				case 'QTD':
					vm.compare.DateRangeMode = 'LQTD';
					break;

				case 'QTDLAST':
				case 'QTR':
					vm.compare.DateRangeMode = 'QTR';
					break;

				case 'YTD':
					vm.compare.DateRangeMode = 'LYTD';
					break;

				case 'YEARLY':
					vm.compare.DateRangeMode = 'YEARLY';
					break;

				case 'LTM':
					vm.compare.DateRangeMode = 'LLTM';
					break;

				default:
					alert('splitSavingsCtl.compareToggle, unsupported query date mode for comparison: ' + vm.query.DateRangeMode);
					return;
			}

			$timeout(function() {
				// note: date mode change event will advance UI to action = COMPARE
				$scope.$broadcast('widget.input.date.range.mode', {uniqueId: 'compareDates', mode: vm.compare.DateRangeMode, keepDates: compareKeepDates});
			}, 100);

		}
	}

	function compareLoadData() {

		if(vm.isWaiting) {
			return;
		}

		// dates are valid?
		if(!vm.compare.DateRangeValid) {
			msgSvc.ok('Summary Compare', 'Check date values.');
			vm.summary.mode = 'COMPAREQUERY';
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true, true);

		reportRepo.getSplitFinancial('SUMMARY', vm.query, true).then(okCompData, errCompData);

		function okCompData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.compare.Data = summaryVM(r.data);
			vm.summary.mode = 'COMPARE';
		}

		function errCompData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Error loading report tab: ' + vm.reportTab, 'report.loadSummaryCompare', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    GET RETAIL TAB DATA
	 */

	function getTabData(tabName) {

		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true);
		
		reportRepo.getSplitFinancial(tabName, vm.query, false).then(okTabData, errTabData);  // false = not a comparison query

		function okTabData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			switch(vm.reportTab) {
				case 'SAVINGS':
					vm.tbl = savingsVM(r.data, r.tooMany);
					break;
				case 'INVOICES':
					vm.tbl = invoicesVM(r.data, r.tooMany);
					break;
				case 'INVDETAIL':
					vm.tbl = invoiceItemsVM(r.data, r.tooMany);
					break;
				case 'RETAILCLAIMS':
					vm.tbl = retailClaimsVM(r.data, r.tooMany);
					break;
				case 'FEES':
					vm.tbl = feesVM(r.data, r.tooMany);
					break;
				default:
					throw new Error('splitFinCtl.tabChange, unknown tab name: ' + tabName);
			}

			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);			
			updatePagingWidget(vm.reportTab, vm.flt, vm.tbl);
			tblViewReload(false, true); // keep paging if possible

			vm.flt.Ready = true;
			vm.tabAction = 'LIST';

		}

		function errTabData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Error loading split savings report', 'splitFinCtl.querySubmit', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    TIME SERIES
	 */

	function timeseriesVM() {
		// TBD...

		var defaultType = 'AGGREGATE',
			defaultInterval = 'MONTH';

		return {
			type: defaultType,
			subtype: 'FIN',
			metric: 'SavingsTotal',
			interval: defaultInterval,
			flt: {},
			dirty: false,
			action: 'LOAD',
			prefs: {},
			colHeaders: [],
			data: []
		};
	}

	function tsReset() {

		var ts = vm.ts;

		// save prefs if dirty
		if(!!ts.dirty && !!ts.prefs) {
			sessionRepo.set('ts-report-splitfin', ts.prefs);
		}

		ts.dirty = false;
		ts.action = '';
		ts.colHeaders = [];
		ts.data = [];

		$scope.$broadcast('widget.timeseries');
	}

	function tsToggle() {

		// toggle time series display on/off

		if(vm.summary.mode == 'TIMESERIES') {
			tsReset();
			vm.summary.mode = 'TOTALS';
		}
		else {
			// toggle on

			vm.tsMetricDroplist = initTimeSeriesDroplist();
			vm.ts = timeseriesVM();

			// get timeseries viewstate
			var vs = sessionRepo.get('ts-report-splitfin');
			if(!!vs) {
				vm.ts.prefs = vs;
			}

			// move pref properties for easier html bind
			var prefs = vm.ts.prefs;
			vm.ts.type = prefs.type;
			vm.ts.subtype = prefs.subtype;
			vm.ts.interval = prefs.interval;
			vm.ts.metric = prefs.metric;

			vm.summary.mode = 'TIMESERIES';

			$timeout(function() {
				tsLoadData();
			}, 200);

		}
	}

	function tsLoadData() {

		if(vm.isWaiting) {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true, true);

		reportRepo.getTimeseries('SPLITFIN', vm.ts, vm.query).then(okTsData, errTsData);

		function okTsData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.ts = tsParseData(r, vm.ts);
			if(vm.ts.action != 'NODATA') {

				switch(vm.ts.type) {
					case 'AGGREGATE':
						tsLoadAggregate();
						break;
					case 'METRIC':
						tsChangeMetric();
						break;
					default:
						alert('splitFinCtl.tsLoadData, uknown timeseries type: ' + vm.ts.type);
						tsReset();
						vm.summary.mode = 'TOTALS';
				}
			}

		}

		function errTsData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Error loading report tab: ' + vm.reportTab, 'report.loadSummaryCompare', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}

	function tsGetMetricInfo(metric) {

		// find metric formats (they are overloaded into droplist array)

		var items = vm.tsMetricDroplist;
		for(var i = 0; i < items.length; i++) {
			if(items[i].value == metric) {
				return items[i];
			}
		}

		alert('splitsaveCtl.tsGetMetricInfo, metric: ' + metric + ' not found for report type: SPLITFIN');
		return {};

	}

	function tsGetColumnHeaders(series, isQuarterly) {

		// pre-build column config (once per data load)

		var cols = [],
			id = '0',
			dtSeg = [],
			mth = 0,
			day = 0,
			colTitle = '',
			months = utilSvc.ng.monthShortDroplist();

		// 1st column is always title
		cols.push({
			id: 'title',
			title: 'Affiliation',
			width: '120px',
			sort: true,
			flt: undefined,
			fltType: 'Text'
		});

		// loop series to pre-format column labels
		series = Array.isArray(series) ? series : [];
		for(var i = 0; i < series.length; i++) {

			// get fmt from "yyyy-mm-dd" to "MMM dd"
			dtSeg = series[i].Date.split('-');
			mth = parseInt(dtSeg[1]) - 1; // month list is zero based
			mth = months[mth].label;
			day = parseInt(dtSeg[2]);
			day = day.toString();

			if(isQuarterly) {
				colTitle = displayQuarter(new Date(dtSeg[0], dtSeg[1] - 1, 0));
			}
			else {
				colTitle = mth + ' ' + day;
			}

			cols.push({
				id: 'id' + dtSeg.join('_'),
				mth: mth,
				day: day,
				title: colTitle,
				width: '40px',
				sort: true,
				flt: undefined,
				fltType: 'Numbers'
			});
		}

		return cols;

	}

	function tsParseData(data, ts) {
		// tbd...
		// parse api data into timeseries cached VM
		// cached VM holds pre-calculated columns / filters, etc

		ts.action = '';
		ts.colHeaders = [];
		ts.data = [];

		// no data
		var affs = Array.isArray(data) ? data : [];
		if(affs.length < 1 || !Array.isArray(affs[0].Series) || affs[0].Series.length < 1) {
			ts.action = 'NODATA';
			return ts;
		}

		var aff = {},
			dataRow ={},
			affSeries = [];

		ts.colHeaders = tsGetColumnHeaders(affs[0].Series, ts.interval == 'QUARTER');

		// parse api data into timeseries pre-format
		var isFIN = ts.subtype == 'FIN';

		for(var i = 0; i < affs.length; i++) {
			aff = affs[i];

			dataRow = {
				id: i,
				title: aff.CEID + ' / ' + aff.Pharmacy,
				series: []
			};

			// loop series, convert api summary data into VM
			affSeries = Array.isArray(aff.Series) ? aff.Series : [];
			for(var ii = 0; ii < affSeries.length; ii++) {
				if(isFIN) {
					dataRow.series.push(affSeries[ii].Summary);
				}
				else {
					// Retail (SPLITMATCH) can have DISP type
					dataRow.series.push(affSeries[ii].Stats);
				}
			}

			ts.data.push(dataRow);
		}

		return ts;

	}

	function tsChangeType() {

		// switch the timeseries display type

		if(vm.isWaiting || vm.summary.mode != 'TIMESERIES') {
			return;
		}

		// switch type
		vm.ts.dirty = true;
		vm.ts.prefs.type = vm.ts.type;
		vm.ts.prefs.subtype = vm.ts.subtype;

		// reset all data, load again
		tsReset();
		$timeout(function() {
			tsLoadData();
		}, 200);

	}

	function tsChangeInterval() {

		// switch the timeseries time interval
		// note: requires another data pull

		if(vm.isWaiting || vm.summary.mode != 'TIMESERIES') {
			return;
		}

		// switch interval
		vm.ts.dirty = true;
		vm.ts.prefs.interval = vm.ts.interval;
		tsReset();

		vm.ts.action = 'LOAD';

		$timeout(function() {
			tsLoadData();
		}, 200);

	}

	function tsChangeMetric() {

		// switch the timeseries metric, re-gen widget data

		if(vm.isWaiting || vm.summary.mode != 'TIMESERIES') {
			return;
		}

		var ts = vm.ts;

		// metric titles
		var colHeaders = vm.ts.colHeaders;
		colHeaders[0].title = 'Affiliation';

		// switch metric
		ts.dirty = true;
		ts.prefs.metric = ts.metric;
		var metricProp = ts.metric;

		// get details of this metric
		var metricInfo = tsGetMetricInfo(ts.metric);
		var metricFmt = metricInfo.fmt,
			metricSubtype = metricInfo.subtype;

		// TBD... new data required if sub type different?
		var subtypeSame = ts.subtype == metricSubtype;
		ts.subtype = metricSubtype;
		if(!subtypeSame) {
			tsLoadData();
			return;
		}

		// refresh widget table rows / chart series
		var widgetRows = [],
			dataRows = ts.data,
			row = {},
			dataSeries = [],
			metricVal = 0,
			cid = '';

		// create data rows for this metric
		// note: rows are objects so angular can use filter/sort
		for(var i = 0; i < dataRows.length; i++) {

			row = {
				id: dataRows[i].id,
				title: dataRows[i].title,
				selected: false
			};

			dataSeries = dataRows[i].series;
			for(var ii = 0; ii < dataSeries.length; ii++) {
				cid = colHeaders[ii+1].id;

				// metric value
				metricVal = dataSeries[ii][metricProp];
				if(typeof(metricVal) === 'undefined') {
					metricVal = 0;
				}
				row[cid] = metricVal;

				// metric format in text
				row[cid + 'txt'] = tsFormatMetricValue(metricVal, metricFmt);
			}

			widgetRows.push(row);
		}

		ts.action = 'SHOW';

		// notify widget to render
		var fltKey = ts.type + ts.interval;
		$scope.$broadcast('widget.timeseries', {
			data: {
				uniqueId: 'savings-series',
				interval: ts.interval,
				table: {
					show: true,
					colHeaders: colHeaders,
					rows: widgetRows,
					flt: ts.prefs.flt[fltKey]
				},
				chart: {
					show: true,
					id: 'savings-series-chart',
					config: {
						colors: appConst.app.color.chartBars($window.espuiPrefs.skin),
						xAxis: {
							showText: true
						},
						yAxis: {
							showText: true,
							format: metricFmt
						}
					}
				}
			}
		});

	}

	function tsFormatMetricValue(val, fmt) {

		// convert metric number into final text

		switch(fmt) {
			case 'currency':
				return  numberFmt(val, '0', '$', 2);
			case 'number':
				return numberFmt(val, '0', '', 2);
			case 'integer':
				return numberFmt(val, '0', '', 0);
			default:
				alert('metric format unknown: ' + fmt);
				return val;
		}
	}

	function tsLoadAggregate() {

		// derive timeseries widget dataset for aggregate totals
		// note: aggregate means total of all affiliations per property for each time period

		if(vm.isWaiting || vm.summary.mode != 'TIMESERIES' || vm.ts.type != 'AGGREGATE') {
			return;
		}

		var ts = vm.ts,
			tsSubtype = vm.ts.subtype;

		// aggregate titles
		var colHeaders = vm.ts.colHeaders;
		colHeaders[0].title = 'Line Item';

		ts.dirty = true;

		// refresh widget table rows / chart series
		var props = [],
			prop = {},
			propName = '',
			propVal = 0,
			widgetRows = [],
			row = {},
			dataSeries = [],
			cid = '';

		// check aggregate should have only 1 row
		if(ts.data.length !== 1) {
			alert('splitFinCtl.tsLoadAggregate, data rows should be length 1 only');
			tsReset();
			vm.summary.mode = 'TOTALS';
			return;
		}
		dataSeries = ts.data[0].series;
		props = vm.tsMetricDroplist;

		// create widget info iterating selectable properties from drop down
		// note: rows are objects so angular can use filter/sort
		for(var i = 0; i < props.length; i++) {
			prop = props[i];

			// agg props have a sub-type, render props with the same sub-type chosen by user
			if(prop.subtype == tsSubtype) {
				propName = prop.value; // value in droplist is the viewmodel property name
				row = {
					id: propName,
					title: prop.label,
					selected: false
				};

				for(var ii = 0; ii < dataSeries.length; ii++) {
					cid = colHeaders[ii+1].id;

					// prop value
					propVal = dataSeries[ii][propName];
					if(typeof(propVal) === 'undefined') {
						propVal = 0;
					}
					row[cid] = propVal;

					// prop val format in text
					row[cid + 'txt'] = tsFormatMetricValue(propVal, prop.fmt);
				}

				widgetRows.push(row);
			}
		}

		ts.action = 'SHOW';

		// notify widget to render
		var fltKey = ts.type + ts.interval;
		$scope.$broadcast('widget.timeseries', {
			data: {
				uniqueId: 'savings-series',
				interval: ts.interval,
				table: {
					show: true,
					colHeaders: colHeaders,
					rows: widgetRows,
					flt: ts.prefs.flt[fltKey]
				},
				chart: {
					show: true,
					id: 'savings-series-chart',
					config: {
						colors: appConst.app.color.chartBars($window.espuiPrefs.skin),
						xAxis: {
							showText: true
						},
						yAxis: {
							showText: true,
							format: 'number'
						}
					}
				}
			}
		});

	}


	/**
	 *     SAVED REPORTS EVENT HANDLERS
	 */

	function evtSavedReportRemove(reports, removeId, currentId) {

		var result = {
			action: 'remove'
		};

		// find rpt by id
		var removeIdx = getSavedReportById(reports, removeId);
		if(removeIdx < 0) {
			msgSvc.ok('Saved Search Not Found', 'Id missing: ' + removeId);
			return {};
		}
		reports.splice(removeIdx, 1);

		if(validSvc.isText(currentId) && removeId != currentId) {
			result.id = currentId;
		}

		return result;

	}

	function evtSavedReportAdd(reports, rptName) {

		var result = {
			action: 'add'
		};

		// check if query is valid
		var ceVals = multiselectQueryVals(vm.CeMultiselect),
			rxVals = multiselectQueryVals(vm.RxMultiselect);

		if(!validSvc.isText(vm.reportTab) || !queryValid(ceVals, rxVals)) {
			msgSvc.ok('Cannot Add Saved Search', 'Check search settings');
			return {};
		}

		// pack up current query
		var rxALL = vm.RxMultiselect.vals[0] == 'ALL';
		var newRpt = {
			id: 'sr' + Date.now().toString(),
			name: rptName,
			ReportType: 'SPLITFIN',
			CE: ceVals,
			RX: rxALL ? ['ALL'] : rxVals,
			DateMode: vm.query.DateRangeMode
		};

		// keep dates? depends on date mode
		if(utilSvc.dt.dateModeKeepDates(newRpt.DateMode)) {
			newRpt.StartDate = vm.query.StartDate.val;
			newRpt.EndDate = vm.query.EndDate.val;
		}

		// add to report list, remember new rpt id
		reports.push(newRpt);
		result.id = newRpt.id;

		return result;

	}

	function evtSavedReportCurrent(reports, currentId) {

		var result = {
			action: 'current'
		};

		// find rpt by id
		var currentIdx = getSavedReportById(reports, currentId);
		if(currentIdx < 0) {
			msgSvc.ok('Saved Search Not Found', 'Id missing: ' + currentId);
			return {};
		}
		var currentRpt = reports[currentIdx];

		// re-init state
		queryChange();
		vm.init = true;

		// load up query from current
		_returnVisit = loadSavedQuery('sr', currentRpt);
		vm.multiselectTitle(vm.CeMultiselect, true);
		vm.multiselectTitle(vm.RxMultiselect, true);

		if(_returnVisit) {
			result.id = currentId;
		}

		// reset date widget
		$timeout(function(){
			$scope.$broadcast('widget.input.date.range.mode', {uniqueId: 'queryDates', mode: vm.query.DateRangeMode, keepDates: _returnVisit});
		}, 300);

		return result;
	}

	function okSavedReportsToServer(r) {

		// load cache, add widget details
		_savedReports = getSavedReports(true);

		// refresh widget reports
		$scope.$broadcast('widget.savedreports', {
			action: 'reports',
			current: _savedReportPending.id,
			reports: _savedReports
		});

		_savedReportPending = {};

	}

	function errSavedReportsToServer(r) {
		if(!!r) {
			errSvc.warn('Api error user prefs Saved Reports', 'splitFinCtl.errSavedReportsToServer', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *     SAVED REPORTS WIDGET DETAILS
	 */

	function savedReportWidgetDetailsFmt(ceList, rxList, dtMode, dtStart, dtEnd) {

		var result = [],
			lineTxt = '';

		// line 1: type, date
		lineTxt += utilSvc.dt.dateModeText(vm.query.DateRangeList, dtMode, dtStart, dtEnd);
		result.push(lineTxt);

		// CE, RX
		lineTxt = 'Facility: ' + ceList.join(', ');
		if(ceList.length + rxList.length === 2) {
			lineTxt += ', ';
		}
		else {
			result.push(lineTxt);
			lineTxt = '';
		}
		lineTxt += rxList[0] == 'ALL' ? 'All Pharmacies' : 'Pharmacy: ' + rxList.join(', ');
		result.push(lineTxt);


		return result;

	}

	function savedReportFormatForWidgetDetails(reports) {

		// widget needs report details created for it
		// widget doesn't know the feature's specific query requirements

		var rpt = {},
			lineTxt = '';

		for(var i = 0; i < reports.length; i++) {
			rpt = reports[i];
			rpt.details = savedReportWidgetDetailsFmt(
				rpt.CE,
				rpt.RX,
				rpt.DateMode,
				new Date(rpt.StartDate),
				new Date(rpt.EndDate)
			);
		}

		return reports;
	}


	/**
	 *     SAVED REPORTS HELPERS
	 */

	function getSavedReports(addWidgetDetails) {

		var vs = sessionRepo.get(srKey());
		if(!!vs && vs.version === srVersion()) { // ignore older versions
			var reports = Array.isArray(vs.reports) ? vs.reports : [];

			return !!addWidgetDetails ? savedReportFormatForWidgetDetails(reports) : reports;
		}

		return [];

	}

	function getSavedReportById(reports, id) {
		for(var i = 0; i < reports.length; i++) {
			if(reports[i].id == id) {
				return i;
			}
		}
		return -1;
	}

	function srKey() {
		return 'sr-splitfin';
	}

	function srVersion() {
		return 1;
	}


	/**
	 *    EXCEL
	 *    get file from server
	 */

	function createExcel(isCompare) {
		vm.isCompare = isCompare;

		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			msgSvc.ok('Cannot Create Excel', 'Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;

		vm.query.CE.vals = multiselectQueryVals(vm.CeMultiselect);
		vm.query.RX.vals = multiselectQueryVals(vm.RxMultiselect);


		var affs = utilSvc.aff.findCeList($scope.User.AffList, vm.query.CE.vals);
		affs = utilSvc.aff.findRxList(affs, vm.query.RX.vals);
		affs = utilSvc.aff.findRxModel(affs, ['SPLIT']);

		if (affs.length > 0 && !!vm.query.splittransinclude) {
			msgSvc.confirm({
				id: 'report.splitfinancial',
				title: 'Include Split Transactions',
				msg: 'Confirm include split transaction backing?',
				buttons: [
					{text:'YES', result:'INCLUDE_SPLIT', cancel: false},
					{text:'NO', result:'NO_SPLIT', cancel: false},
					{text:'CANCEL', result:'CANCEL', cancel: true}
				]
			}).then(confirmInclude, confirmInclude);
		} else {
			confirmInclude({result: 'NO_SPLIT'});
		}
	}

	function confirmInclude(r) {
		r = r || {};
		switch(r.result) {
			case 'CANCEL':
				vm.isWaiting = false;
				break;

			case 'INCLUDE_SPLIT':
				// ASYNC: include split transactions
				_pendingExcelFilename = 'ASYNC';
				reportRepo.createAsyncFile(asyncFileRequestVM(vm.query, 'SPLITFIN_TRANS')).then(okServerExcel, errServerExcel);
				reportRepo.createAsyncFile(asyncFileRequestVM(vm.query, 'SPLITFIN')).then(okServerExcel, errServerExcel);
				break;

			case 'NO_SPLIT':
				// ASYNC: multiple entities or big date ranges
				if(!!!vm.isCompare && vm.query.onlySummary) {
					_pendingExcelFilename = 'ASYNC';
					reportRepo.createAsyncFile(asyncFileRequestVM(vm.query, 'SPLITFIN')).then(okServerExcel, errServerExcel);
				}
				else {
					// SYNC: create Excel now
					createExcelNow();
				}
				break;
			default:
				throw new Error('splitFinCtl.confirmInclude, unknown result: ' + r.result);
		}
	}

	function createExcelNow() {
		// create Excel file now
		// filename format:
		//Verity-<CEID>-340BSavings-Retail-<YYYYMMDD>-<YYYYMMDD>-<Timestamp>.xlsx

		var xlType = 'SPLITFIN';
		_pendingExcelFilename = 'Verity-FacilityFinancial';

		if(vm.query.CE.vals.length > 0) {
			_pendingExcelFilename += '-' + vm.query.CE.vals[0];
		}
		if(vm.isCompare) {
			_pendingExcelFilename += 'Compare-';
			xlType += '-COMPARE';
		}

		_pendingExcelFilename += utilSvc.dt.toServerString(vm.query.StartDate.val, 'NONE') + '-' + utilSvc.dt.toServerString(vm.query.EndDate.val, 'NONE') + '-' + Date.now().toString() + '.xlsx';

		// dump memory before creating Excel
		reportRepo.destroyRX();
		reportRepo.destroyCE();

		// load wait before calling Excel endpoint async
		msgSvc.wait(true);

		$timeout(function() {
			// small delay for digest cycle to delete repo memory
			reportRepo.serverExcel(xlType, vm.query, _pendingExcelFilename).then(okServerExcel, errServerExcel);
		}, 300);
	}

	function okServerExcel(binaryData) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		// async requests do not return a file
		if(_pendingExcelFilename == 'ASYNC') {
			msgSvc.ok('Excel File Requested', 'Check the "Saved Files" link at top right to retrieve this Excel Workbook.');
			return;
		}

		// convert binary stream to blob and save
		try {
			msgSvc.ok('Creating Excel File...');
			var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
			$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
		}
		catch(err) {
			throw(err);
		}

	}

	function errServerExcel(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		if(!!r) {
			errSvc.warn('Create Excel Error', 'splitFinCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
		}

	}			


	/**
	 * 	ASYNC REPORTS
	 */

	function asyncFileRequestVM(q, reportType) {
		return {
			Context: {
				CEID: q.CE.vals,
				RXID: q.RX.vals
			},
			Params: {
				ReportType: reportType,
				StartDate: q.StartDate.val,
				EndDate: q.EndDate.val
			}
		};
	}

	function toggleAsyncReports() {
		if(vm.isWaiting) {
			return;
		}
		vm.asyncReports.show = vm.asyncReports.show == 'yes' ? 'no' : 'yes';
		if(vm.asyncReports.show == 'yes') {
			$state.go('report.splitfinancial.async-reports', {
				rptType: 'SPLITFIN',
				query: null
			}, {reload: 'report.splitfinancial.async-reports'});
		}
	}
	
	/**
	 * 		TABLE VIEW
	 */

	function okCurrentTableView() {
		if (vm.action != 'LIST') {
			return;
		}
		var tblConfig = vm.tblViewConfig[vm.reportTab];
		var tvSaved = sessionRepo.get(tblConfig.storageKey);

		if (!!tvSaved && !!vm.tblView && validSvc.isText(vm.tblView.current)) {
			tvSaved.current = vm.tblView.current;
			sessionRepo.set(tblConfig.storageKey, tvSaved);
		}
	}

	function errCurrentTableView() {
		// do nothing
	}

	function tblViewReload(skipInitViews, fltKeepPaging) {
		// init and load table view structure
		var tblConfig = vm.tblViewConfig[vm.reportTab];
		if(!!!skipInitViews || !!!vm.tblView) {
			vm.tblView = vm.tblViewInit(tblConfig, sessionRepo.get(tblConfig.storageKey));
		}

		// add column titles and filters
		vm.tblView = vm.tblViewLoadTitlesAndFilters(tblConfig, vm.tblView, vm.flt);
		
		// update table view bar
		$scope.$broadcast('widget.tblview', {
			uniqueId: vm.reportTab, // tabs share same tblview widget
			current: vm.tblView.current,
			views: vm.tblView.views
		});

		if(!!vm.flt) {
			// remove any filter properties not shown in current table view
			vm.flt = vm.tblViewSyncFilter(tblConfig, vm.tblView, vm.flt, fltKeepPaging);
			filterChange(true);
		}
	}

	function tblViewSchemaVM(tabName) {

		var result = {
			SAVINGS: {
				storageKey: 'tv-rpt-split-fin-savings',
				name: 'SPLIT_FIN_SAVINGS',
				sortby: '-OrderDate',
				pgsize: 50,
				sections: {
					Affiliation: { title: 'Affiliation' },
					Order: { title: 'Order' },
					DrugInfo: { title: 'Drug Info' },
					Invoice: { title: 'Invoice' },
					PricingCost	: { title: 'Pricing & Cost' },
					Savings: { title: 'Savings' },
				},
				cols: [
					{ section: 'Affiliation', flt: 'Text', edit: false, name: 'Facility', colWidth: "45px", title: 'Facility', desc: 'Facility' },
					{ section: 'Affiliation', flt: 'Text', edit: false, name: 'Pharmacy', colWidth: "45px", title: 'Pharmacy', desc: 'Pharmacy' },
					
					{ section: 'Order', flt: 'Text', name: 'Order', colWidth: "45px", title: 'Name', desc: 'Order Name' },
					{ section: 'Order', flt: 'Dates', name: 'OrderDate', colWidth: "45px", title: 'Date', desc: 'Order Date' },
					
					{ section: 'DrugInfo', flt: 'Text', name: 'OrigVend', colWidth: "45px", title: 'Original Vendor', desc: 'Original Vendor' },
					{ section: 'DrugInfo', flt: 'Text', name: 'OrigVendItemNum', colWidth: "45px", title: 'Original Vendor Item Number', desc: 'Original Vendor Item Number' },
					{ section: 'DrugInfo', flt: 'Text', name: 'OrigNDC', colWidth: "45px", title: 'Original NDC', desc: 'Original NDC' },
					{ section: 'DrugInfo', flt: 'Text', name: 'OrigItemNum', colWidth: "45px", title: 'Original Item Name', desc: 'Original Item Name' },

					{ section: 'Invoice', flt: 'Text', name: 'Vendor', colWidth: "45px", title: 'Vendor', desc: 'Vendor' },
					{ section: 'Invoice', flt: 'Text', name: 'VendorItemNumber', colWidth: "45px", title: 'Vendor Item Number', desc: 'Vendor Item Number' },
					{ section: 'Invoice', flt: 'Text', name: 'OrderedNDC', colWidth: "45px", title: 'Ordered NDC', desc: 'Ordered NDC' },
					{ section: 'Invoice', flt: 'Text', name: 'ItemName', colWidth: "45px", title: 'Item Name', desc: 'Item Name' },
	
					{ section: 'PricingCost', flt: 'Numbers', name: 'OrderUnits', colWidth: "45px", title: 'Order Units', desc: 'Order Units' },
					{ section: 'PricingCost', flt: 'Numbers', default: false, name: 'SplitOrderUnits', colWidth: "45px", title: 'Split Order Units', desc: 'Split Order Units' },
					{ section: 'PricingCost', flt: 'Numbers', default: false, name: 'BaseCost', colWidth: "45px", title: 'Base Cost', desc: 'Base Cost' },
					{ section: 'PricingCost', flt: 'Numbers', default: false, name: 'OriginalCost', colWidth: "45px", title: 'Original Cost', desc: 'Original Cost' },
					{ section: 'PricingCost', flt: 'Numbers', name: 'FinalCost', colWidth: "45px", title: 'Final Cost', desc: 'Final Cost' },
					{ section: 'PricingCost', flt: 'Numbers', name: 'InvoiceOrderUnits', colWidth: "45px", title: 'Invoice Units', desc: 'Invoice Order Units' },
					{ section: 'PricingCost', flt: 'Numbers', default: false, name: 'AdjOrigCostInv', colWidth: "45px", title: 'Adjusted Original Cost Invoice', desc: 'Adjusted Original Cost Invoice' },
					{ section: 'PricingCost', flt: 'Numbers', name: 'InvoicePriceTotal', colWidth: "45px", title: 'Price Total', desc: 'Invoice Price Total' },
	
					{ section: 'Savings', flt: 'Numbers', default: false, name: 'PotentialVerisaveSavings', colWidth: "45px", title: 'Potential Verisave Savings', desc: 'Potential Verisave Savings' },
					{ section: 'Savings', flt: 'Numbers', default: false, name: 'PotentialMVSavings', colWidth: "45px", title: 'Potential Multi-Vendor Savings', desc: 'Potential Multi-Vendor Savings' },
					{ section: 'Savings', flt: 'Numbers', default: false, name: 'TotalPotentialFeatureSavings', colWidth: "45px", title: 'Total Potential Feature Savings', desc: 'Total Potential Feature Savings' },
					{ section: 'Savings', flt: 'Numbers', default: false, name: 'NDCOptimizerSavings', colWidth: "45px", title: 'NDC Optimizer Savings', desc: 'NDC Optimizer Savings' },
					{ section: 'Savings', flt: 'Numbers', default: false, name: 'PriceSelectSavings', colWidth: "45px", title: 'Price Select Savings', desc: 'Price Select Savings' },
					{ section: 'Savings', flt: 'Numbers', name: 'VerisaveSavings', colWidth: "45px", title: 'Verisave Savings', desc: 'Verisave Savings' },
					{ section: 'Savings', flt: 'Numbers', name: 'MVSSavings', colWidth: "45px", title: 'Multi-Vendor Savings', desc: 'Multi-Vendor Savings' },
					{ section: 'Savings', flt: 'Numbers', default: false, name: 'TotalFeatureSavings', colWidth: "45px", title: 'Total Feature Savings', desc: 'Total Feature Savings' },
					{ section: 'Savings', flt: 'Numbers', default: false, name: 'VerisaveFee', colWidth: "45px", title: 'Verisave Fee', desc: 'Verisave Fee' },
				]
			},
			INVDETAIL: {
				storageKey: 'tv-rpt-split-fin-invdetail',
				name: 'SPLIT_FIN_INVDETAIL',
				sortby: '-InvoiceDate',
				pgsize: 50,
				sections: {
					Affiliation: { title: 'Affiliation' },
					Order: { title: 'Verity Order' },
					Invoice: { title: 'Invoice' },
					DrugInfo: { title: 'Drug Info' },
					PharmacyPricing	: { title: 'Pharmacy Pricing' },
					ReferencePricing	: { title: 'Reference Pricing' },
				},
				cols: [
					{ section: 'Affiliation', flt: 'Text', edit: false, name: 'CE', colWidth: "45px", title: 'Facility', desc: 'Facility' },
					{ section: 'Affiliation', flt: 'Text', edit: false, name: 'Pharmacy', colWidth: "45px", title: 'Pharmacy', desc: 'Pharmacy' },

					{ section: 'Order', flt: 'Dates', name: 'OrderDate', colWidth: "45px", title: 'Date', desc: 'Date' },
					{ section: 'Order', flt: 'Text', name: 'OrderName', colWidth: "45px", title: 'Name', desc: 'Name' },
					{ section: 'Order', flt: 'Text', default: false, name: 'Split', colWidth: "45px", title: 'Split', desc: 'Split' },
					{ section: 'Order', flt: 'Text', default: false, name: 'AlwaysSplit', colWidth: "45px", title: 'AlwaysSplit', desc: 'AlwaysSplit' },
					{ section: 'Order', flt: 'Text', default: false, name: 'Manual', colWidth: "45px", title: 'Manual', desc: 'Manual' },
					{ section: 'Order', flt: 'Text', default: false, name: 'PriceSelect', colWidth: "45px", title: 'Price Select', desc: 'Price Select' },
					{ section: 'Order', flt: 'Text', default: false, name: 'VERISAVE', colWidth: "45px", title: 'Verisave', desc: 'Verisave' },

					{ section: 'Invoice', flt: 'Dates', name: 'InvoiceDate', colWidth: "45px", title: 'Invoice Date', desc: 'Invoice Date' },
					{ section: 'Invoice', flt: 'Text', name: 'InvoiceNumber', colWidth: "45px", title: 'Invoice Number', desc: 'Invoice Number' },
					{ section: 'Invoice', flt: 'Text', default: false, name: 'InvoiceType', colWidth: "45px", title: 'Invoice Type', desc: 'Invoice Type' },
					{ section: 'Invoice', flt: 'Numbers', default: false, name: 'Line', colWidth: "45px", title: 'Invoice Line Item', desc: 'Invoice Line Item' },
					{ section: 'Invoice', flt: 'Text', name: 'Vendor', colWidth: "45px", title: 'Vendor', desc: 'Vendor' },
					{ section: 'Invoice', flt: 'Text', default: false, name: 'VendorItemNumber', colWidth: "45px", title: 'Vendor Item Number', desc: 'Vendor Item Number' },
					{ section: 'Invoice', flt: 'Text', name: 'AccountType', colWidth: "45px", title: 'Account Type', desc: 'Account Type' },

					{ section: 'DrugInfo', flt: 'Text', name: 'NDC', colWidth: "45px", title: 'NDC', desc: 'NDC' },
					{ section: 'DrugInfo', flt: 'Text', default: false, name: 'GPI', colWidth: "45px", title: 'GPI', desc: 'GPI' },
					{ section: 'DrugInfo', flt: 'Text', name: 'VendorItemName', colWidth: "45px", title: 'Description', desc: 'Description' },
					{ section: 'DrugInfo', flt: 'Text', default: false, name: 'Manufacturer', colWidth: "45px", title: 'Manufacturer', desc: 'Manufacturer' },

					{ section: 'PharmacyPricing', flt: 'Numbers', name: 'OrderUnits', colWidth: "45px", title: 'Order Units', desc: 'Order Units' },
					{ section: 'PharmacyPricing', flt: 'Numbers', name: 'InvoicePrice', colWidth: "45px", title: 'Invoice Price', desc: 'Invoice Price' },
					{ section: 'PharmacyPricing', flt: 'Numbers', name: 'InvoicePriceTotal', colWidth: "45px", title: 'Invoice Total', desc: 'Invoice Total' },

					{ section: 'ReferencePricing', flt: 'Numbers', default: false, name: 'RefPrice', colWidth: "45px", title: 'Ref Price', desc: 'Ref Price' },
					{ section: 'ReferencePricing', flt: 'Numbers', default: false, name: 'RefPriceTotal', colWidth: "45px", title: 'Ref Price Total', desc: 'Ref Price Total' },
					{ section: 'ReferencePricing', flt: 'Text', default: false, name: 'RefPriceType', colWidth: "45px", title: 'Ref Price Type', desc: 'Ref Price Type' },
					{ section: 'ReferencePricing', flt: 'Numbers', default: false, name: 'Current340BPrice', colWidth: "45px", title: '340B Price', desc: '340B Price' },
					{ section: 'ReferencePricing', flt: 'Numbers', default: false, name: 'CurrentGPOPrice', colWidth: "45px", title: 'GPO Price', desc: 'GPO Price' },
					{ section: 'ReferencePricing', flt: 'Numbers', default: false, name: 'CurrentOwnUsePrice', colWidth: "45px", title: 'Own Use Price', desc: 'Own Use Price' },
					{ section: 'ReferencePricing', flt: 'Numbers', default: false, name: 'CurrentWACPrice', colWidth: "45px", title: 'WAC Price', desc: 'WAC Price' },
					{ section: 'ReferencePricing', flt: 'Numbers', default: false, name: 'NetSavings', colWidth: "45px", title: 'Total Savings', desc: 'Total Savings' },
				]
			},
			INVOICES: {
				storageKey: 'tv-rpt-split-fin-invoices',
				name: 'SPLIT_FIN_INVOICES',
				sortby: '-InvoiceDate',
				pgsize: 50,
				sections: {
					Affiliation: { title: 'Affiliation' },
					Order: { title: 'Verity Order' },
					Invoice: { title: 'Invoice' },
					PharmacyPricing	: { title: 'Pharmacy Pricing' },
					ReferencePricing : { title: 'Reference Pricing' },
				},
				cols: [
					{ section: 'Affiliation', flt: 'Text', edit: false, name: 'CE', colWidth: "45px", title: 'Facility', desc: 'Facility' },
					{ section: 'Affiliation', flt: 'Text', edit: false, name: 'Pharmacy', colWidth: "45px", title: 'Pharmacy', desc: 'Pharmacy' },

					{ section: 'Order', flt: 'Dates', name: 'OrderDate', colWidth: "45px", title: 'Date', desc: 'Date' },
					{ section: 'Order', flt: 'Text', name: 'OrderName', colWidth: "45px", title: 'Name', desc: 'Name' },
					{ section: 'Order', flt: 'Text', default: false, name: 'Split', colWidth: "45px", title: 'Split', desc: 'Split' },
					{ section: 'Order', flt: 'Text', default: false, name: 'Manual', colWidth: "45px", title: 'Manual', desc: 'Manual' },

					{ section: 'Invoice', flt: 'Dates', name: 'InvoiceDate', colWidth: "45px", title: 'Invoice Date', desc: 'Invoice Date' },
					{ section: 'Invoice', flt: 'Text', name: 'InvoiceNumber', colWidth: "45px", title: 'Invoice Number', desc: 'Invoice Number' },
					{ section: 'Invoice', flt: 'Text', name: 'InvoiceType', colWidth: "45px", title: 'Invoice Type', desc: 'Invoice Type' },
					{ section: 'Invoice', flt: 'Text', name: 'Vendor', colWidth: "45px", title: 'Vendor', desc: 'Vendor' },
					{ section: 'Invoice', flt: 'Text', name: 'AccountType', colWidth: "45px", title: 'Account Type', desc: 'Account Type' },
					
					{ section: 'PharmacyPricing', flt: 'Numbers', name: 'InvoicePriceTotal', colWidth: "45px", title: 'Invoice Total', desc: 'Invoice Total' },

					{ section: 'ReferencePricing', flt: 'Numbers', default: false, name: 'RefPriceTotal', colWidth: "45px", title: 'Ref Price Total', desc: 'Ref Price Total' },
					{ section: 'ReferencePricing', flt: 'Numbers', default: false, name: 'NetSavings', colWidth: "45px", title: 'Total Savings', desc: 'Total Savings' },
				]
			},
			RETAILCLAIMS: {
				storageKey: 'tv-rpt-split-fin-retailclaims',
				name: 'SPLIT_FIN_RETAIL_CLAIMS',
				sortby: '-InvoiceDate',
				pgsize: 50,
				sections: {
					Affiliation: { title: 'Affiliation' },
					Encounter: { title: 'Encounter' },
					Patient: { title: 'Patient' },
					Provider: { title: 'Provider' },
					RxDetail: { title: 'RxDetail' },
					Drug: { title: 'Drug' },
					Accumulations: { title: 'Accumulations' },
					OrderInvoice: { title: 'Order/Invoice' },
					Plan: { title: 'Plan' },
					Financials: { title: 'Financials' },
				},
				cols: [
					{ section: 'Affiliation', flt: 'Text', edit: false, name: 'Facility', colWidth: "45px", title: 'Facility', desc: 'Facility' },
					{ section: 'Affiliation', flt: 'Text', edit: false, name: 'Pharmacy', colWidth: "45px", title: 'Pharmacy', desc: 'Pharmacy' },
					{ section: 'Affiliation', flt: 'Text', default: false, name: 'DispensePharmacy', colWidth: "45px", title: 'DispensePharmacy', desc: 'Dispense Pharmacy' },
				
					{ section: 'Encounter', flt: 'Text', default: false, name: 'EncounterId', colWidth: "45px", title: 'Encounter Id', desc: 'Encounter Id' },
					{ section: 'Encounter', flt: 'Text', default: false, name: 'EncounterLocation', colWidth: "45px", title: 'Encounter Location', desc: 'Encounter Location' },				

					{ section: 'Patient', flt: 'Text', default: false, name: 'MRN', colWidth: "45px", title: 'Patient MRN', desc: 'Patient MRN' },
					{ section: 'Patient', flt: 'Text', default: false, name: 'PatientFirst', colWidth: "45px", title: 'Patient First', desc: 'Patient First Name' },
					{ section: 'Patient', flt: 'Text', default: false, name: 'PatientLastInitial', colWidth: "45px", title: 'Patient Last', desc: 'Patient Last Name' },

					{ section: 'Provider', flt: 'Text', default: false, name: 'ProviderNPI', colWidth: "45px", title: 'Provider NPI', desc: 'Provider NPI' },
					{ section: 'Provider', flt: 'Text', default: false, name: 'ProviderName', colWidth: "45px", title: 'Provider Name', desc: 'Provider Name' },				

					{ section: 'RxDetail', flt: 'Text', default: false, name: 'Referral', colWidth: "45px", title: 'Referral', desc: 'Referral' },
					{ section: 'RxDetail', flt: 'Text', name: 'RxNumber', colWidth: "45px", title: 'Rx Number', desc: 'Rx Number' },
					{ section: 'RxDetail', flt: 'Text', default: false, name: 'RxFillNumber', colWidth: "45px", title: 'Rx Fill #', desc: 'Rx Fill #' },
					{ section: 'RxDetail', flt: 'Dates', name: 'RxWrittenDate', colWidth: "45px", title: 'Rx Written Date', desc: 'Rx Written Date' },
					{ section: 'RxDetail', flt: 'Dates', name: 'RxFillDate', colWidth: "45px", title: 'Rx Fill Date', desc: 'Rx Fill Date' },				

					{ section: 'Drug', flt: 'Text', name: 'DrugType', colWidth: "45px", title: 'Drug Type', desc: 'Drug Type' },
					{ section: 'Drug', flt: 'Text', name: 'NDC', colWidth: "45px", title: 'NDC', desc: 'NDC' },
					{ section: 'Drug', flt: 'Text', default: false, name: 'OrderedNDC', colWidth: "45px", title: 'Ordered NDC', desc: 'Ordered NDC' },
					{ section: 'Drug', flt: 'Text', name: 'DrugName', colWidth: "45px", title: 'Item Description', desc: 'Item Description' },
					{ section: 'Drug', flt: 'Text', default: false, name: 'Manufacturer', colWidth: "45px", title: 'Manufacturer', desc: 'Manufacturer' },				

					{ section: 'Accumulations', flt: 'Numbers', name: 'DispenseQty', colWidth: "45px", title: 'Dispense Qty', desc: 'Dispense Qty' },
					{ section: 'Accumulations', flt: 'Numbers', default: false, name: 'Allocated', colWidth: "45px", title: 'Allocated', desc: 'Allocated' },
					{ section: 'Accumulations', flt: 'Numbers', name: 'UsedInOrderQty', colWidth: "45px", title: 'Used In Order Qty', desc: 'Used In Order Qty' },
					{ section: 'Accumulations', flt: 'Numbers', default: false, name: 'UsedInOrderPercent', colWidth: "45px", title: 'Used In Order %', desc: 'Used In Order %' },
				
					{ section: 'OrderInvoice', flt: 'Text', default: false, name: 'Vendor', colWidth: "45px", title: 'Vendor', desc: 'Vendor' },
					{ section: 'OrderInvoice', flt: 'Text', default: false, name: 'VendorItemNumber', colWidth: "45px", title: 'Vendor Item #', desc: 'Vendor Item #' },
					{ section: 'OrderInvoice', flt: 'Dates', default: false, name: 'OrderDate', colWidth: "45px", title: 'Order Date', desc: 'Order Date' },
					{ section: 'OrderInvoice', flt: 'Text', default: false, name: 'OrderName', colWidth: "45px", title: 'Order Name', desc: 'Order Name' },
					{ section: 'OrderInvoice', flt: 'Text', name: 'VendorInvoiceNumber', colWidth: "45px", title: 'Vendor Invoice #', desc: 'Vendor Invoice #' },
					{ section: 'OrderInvoice', flt: 'Dates', name: 'InvoiceDate', colWidth: "45px", title: 'Vendor Invoice Date', desc: 'Vendor Invoice Date' },
					{ section: 'OrderInvoice', flt: 'Text', default: false, name: 'InvoiceType', colWidth: "45px", title: 'Invoice Type', desc: 'Invoice Type' },
					{ section: 'OrderInvoice', flt: 'Numbers', default: false, name: 'InvoiceLineNumber', colWidth: "45px", title: 'Invoice Line #', desc: 'Invoice Line #' },
					{ section: 'OrderInvoice', flt: 'Text', default: false, name: 'AccountType', colWidth: "45px", title: 'Account Type', desc: 'Account Type' },				

					{ section: 'Plan', flt: 'Text', default: false, name: 'BinPcnGrp', colWidth: "45px", title: 'BIN/PCN/GRP', desc: 'BIN/PCN/GRP' },
					{ section: 'Plan', flt: 'Text', default: false, name: 'PlanType', colWidth: "45px", title: 'Plan Type', desc: 'Plan Type' },
					{ section: 'Plan', flt: 'Text', default: false, name: 'PlanName', colWidth: "45px", title: 'Plan Name', desc: 'Plan Name' },				

					{ section: 'Financials', flt: 'Numbers', default: false, name: 'PatientPaid', colWidth: "45px", title: 'Patient Paid', desc: 'Patient Paid' },
					{ section: 'Financials', flt: 'Numbers', default: false, name: 'BenefitsPaid', colWidth: "45px", title: 'Benefits Paid', desc: 'Benefits Paid' },
					{ section: 'Financials', flt: 'Numbers', name: 'TotalPaid', colWidth: "45px", title: 'Total Paid', desc: 'Total Paid' },
					{ section: 'Financials', flt: 'Numbers', default: false, name: 'NetTotalPaid', colWidth: "45px", title: 'Net Total Paid', desc: 'Net Total Paid' },
					{ section: 'Financials', flt: 'Numbers', default: false, name: 'UC', colWidth: "45px", title: 'U&C', desc: 'U&C' },
					{ section: 'Financials', flt: 'Numbers', default: false, name: 'AWP', colWidth: "45px", title: 'AWP', desc: 'AWP' },
					{ section: 'Financials', flt: 'Numbers', name: 'RetailPharmacyPrice', colWidth: "45px", title: 'Retail Price', desc: 'Retail Price' },
					{ section: 'Financials', flt: 'Numbers', name: 'InvoiceCostProrated', colWidth: "45px", title: 'Invoice Cost Prorated', desc: 'Invoice Cost Prorated' },
					{ section: 'Financials', flt: 'Numbers', name: 'OrderFee', colWidth: "45px", title: 'Order Fee', desc: 'Order Fee' },
					{ section: 'Financials', flt: 'Numbers', name: 'ReferralFee', colWidth: "45px", title: 'Referral Fee', desc: 'Referral Fee' },
					{ section: 'Financials', flt: 'Numbers', name: 'GrossDispenseSavings', colWidth: "45px", title: 'Gross Dispense Savings', desc: 'Gross Dispense Savings' },
					{ section: 'Financials', flt: 'Numbers', name: 'NetSavings', colWidth: "45px", title: 'Net Savings', desc: 'Net Savings' },	
				]
			},
			FEES: {
				storageKey: 'tv-rpt-split-fin-fees',
				name: 'SPLIT_FIN_FEES',
				sortby: '-InvoiceDate',
				pgsize: 50,
				sections: {
					Affiliation: { title: 'Affiliation' },
					Encounter: { title: 'Encounter' },
					Patient: { title: 'Patient' },
					Provider: { title: 'Provider' },
					RxDetail: { title: 'RxDetail' },
					Drug: { title: 'Drug' },
					Accumulations: { title: 'Accumulations' },
					OrderInvoice: { title: 'Order/Invoice' },
					Plan: { title: 'Plan' },
					Financials: { title: 'Financials' },
				},
				cols: [
					{ section: 'Affiliation', flt: 'Text', edit: false, name: 'Facility', colWidth: "45px", title: 'Facility', desc: 'Facility' },
					{ section: 'Affiliation', flt: 'Text', edit: false, name: 'Pharmacy', colWidth: "45px", title: 'Pharmacy', desc: 'Pharmacy' },
				
					{ section: 'Encounter', flt: 'Text', default: false, name: 'EncounterId', colWidth: "45px", title: 'Encounter Id', desc: 'Encounter Id' },
					{ section: 'Encounter', flt: 'Text', default: false, name: 'EncounterLocation', colWidth: "45px", title: 'Encounter Location', desc: 'Encounter Location' },				

					{ section: 'Patient', flt: 'Text', name: 'MRN', colWidth: "45px", title: 'Patient MRN', desc: 'Patient MRN' },
					{ section: 'Patient', flt: 'Text', default: false, name: 'PatientFirst', colWidth: "45px", title: 'Patient First', desc: 'Patient First Name' },
					{ section: 'Patient', flt: 'Text', default: false, name: 'PatientLastInitial', colWidth: "45px", title: 'Patient Last', desc: 'Patient Last Name' },

					{ section: 'Provider', flt: 'Text', name: 'ProviderNPI', colWidth: "45px", title: 'Provider NPI', desc: 'Provider NPI' },
					{ section: 'Provider', flt: 'Text', name: 'ProviderName', colWidth: "45px", title: 'Provider Name', desc: 'Provider Name' },				

					{ section: 'RxDetail', flt: 'Text', default: false, name: 'Referral', colWidth: "45px", title: 'Referral', desc: 'Referral' },
					{ section: 'RxDetail', flt: 'Text', name: 'RxNumber', colWidth: "45px", title: 'Rx Number', desc: 'Rx Number' },
					{ section: 'RxDetail', flt: 'Text', name: 'RxFillNumber', colWidth: "45px", title: 'Rx Fill #', desc: 'Rx Fill #' },
					{ section: 'RxDetail', flt: 'Dates', default: false, name: 'RxWrittenDate', colWidth: "45px", title: 'Rx Written Date', desc: 'Rx Written Date' },
					{ section: 'RxDetail', flt: 'Dates', name: 'RxFillDate', colWidth: "45px", title: 'Rx Fill Date', desc: 'Rx Fill Date' },				

					{ section: 'Drug', flt: 'Text', default: false, name: 'DrugType', colWidth: "45px", title: 'Drug Type', desc: 'Drug Type' },
					{ section: 'Drug', flt: 'Text', name: 'NDC', colWidth: "45px", title: 'NDC', desc: 'NDC' },
					{ section: 'Drug', flt: 'Text', default: false, name: 'OrderedNDC', colWidth: "45px", title: 'Ordered NDC', desc: 'Ordered NDC' },
					{ section: 'Drug', flt: 'Text', name: 'DrugName', colWidth: "45px", title: 'Drug Name', desc: 'Drug Name' },
					{ section: 'Drug', flt: 'Text', default: false, name: 'Manufacturer', colWidth: "45px", title: 'Manufacturer', desc: 'Manufacturer' },				

					{ section: 'Accumulations', flt: 'Numbers', name: 'DispenseQty', colWidth: "45px", title: 'Dispense Qty', desc: 'Dispense Qty' },
					{ section: 'Accumulations', flt: 'Numbers', default: false, name: 'Allocated', colWidth: "45px", title: 'Allocated', desc: 'Allocated' },
					{ section: 'Accumulations', flt: 'Numbers', name: 'UsedInOrderQty', colWidth: "45px", title: 'Used In Order Qty', desc: 'Used In Order Qty' },
					{ section: 'Accumulations', flt: 'Numbers', default: false, name: 'UsedInOrderPercent', colWidth: "45px", title: 'Used In Order %', desc: 'Used In Order %' },
				
					{ section: 'OrderInvoice', flt: 'Text', name: 'Vendor', colWidth: "45px", title: 'Vendor', desc: 'Vendor' },
					{ section: 'OrderInvoice', flt: 'Text', default: false, name: 'VendorItemNumber', colWidth: "45px", title: 'Vendor Item #', desc: 'Vendor Item #' },
					{ section: 'OrderInvoice', flt: 'Dates', name: 'OrderDate', colWidth: "45px", title: 'Order Date', desc: 'Order Date' },
					{ section: 'OrderInvoice', flt: 'Text', name: 'OrderName', colWidth: "45px", title: 'Order Name', desc: 'Order Name' },
					{ section: 'OrderInvoice', flt: 'Text', name: 'VendorInvoiceNumber', colWidth: "45px", title: 'Vendor Invoice #', desc: 'Vendor Invoice #' },
					{ section: 'OrderInvoice', flt: 'Dates', name: 'InvoiceDate', colWidth: "45px", title: 'Vendor Invoice Date', desc: 'Vendor Invoice Date' },
					{ section: 'OrderInvoice', flt: 'Text', name: 'InvoiceType', colWidth: "45px", title: 'Invoice Type', desc: 'Invoice Type' },
					{ section: 'OrderInvoice', flt: 'Numbers', default: false, name: 'InvoiceLineNumber', colWidth: "45px", title: 'Invoice Line #', desc: 'Invoice Line #' },
					{ section: 'OrderInvoice', flt: 'Text', name: 'AccountType', colWidth: "45px", title: 'Account Type', desc: 'Account Type' },				

					{ section: 'Plan', flt: 'Text', default: false, name: 'BinPcnGrp', colWidth: "45px", title: 'BIN/PCN/GRP', desc: 'BIN/PCN/GRP' },
					{ section: 'Plan', flt: 'Text', default: false, name: 'PlanType', colWidth: "45px", title: 'Plan Type', desc: 'Plan Type' },
					{ section: 'Plan', flt: 'Text', default: false, name: 'PlanName', colWidth: "45px", title: 'Plan Name', desc: 'Plan Name' },				

					{ section: 'Financials', flt: 'Numbers', default: false, name: 'PatientPaid', colWidth: "45px", title: 'Patient Paid', desc: 'Patient Paid' },
					{ section: 'Financials', flt: 'Numbers', default: false, name: 'BenefitsPaid', colWidth: "45px", title: 'Benefits Paid', desc: 'Benefits Paid' },
					{ section: 'Financials', flt: 'Numbers', default: false, name: 'TotalPaid', colWidth: "45px", title: 'Total Paid', desc: 'Total Paid' },
					{ section: 'Financials', flt: 'Numbers', default: false, name: 'NetTotalPaid', colWidth: "45px", title: 'Net Total Paid', desc: 'Net Total Paid' },
					{ section: 'Financials', flt: 'Numbers', default: false, name: 'UC', colWidth: "45px", title: 'U&C', desc: 'U&C' },
					{ section: 'Financials', flt: 'Numbers', default: false, name: 'AWP', colWidth: "45px", title: 'AWP', desc: 'AWP' },
					{ section: 'Financials', flt: 'Numbers', default: false, name: 'RetailPharmacyPrice', colWidth: "45px", title: 'Retail Price', desc: 'Retail Price' },
					{ section: 'Financials', flt: 'Numbers', name: 'InvoiceCostProrated', colWidth: "45px", title: 'Invoice Cost Prorated', desc: 'Invoice Cost Prorated' },
					{ section: 'Financials', flt: 'Numbers', name: 'RemainderCost', colWidth: "45px", title: 'Remainder Cost', desc: 'Remainder Cost' },
					{ section: 'Financials', flt: 'Numbers', name: 'OrderFee', colWidth: "45px", title: 'Order Fee', desc: 'Order Fee' },
					{ section: 'Financials', flt: 'Numbers', name: 'ReferralFee', colWidth: "45px", title: 'Referral Fee', desc: 'Referral Fee' },
					{ section: 'Financials', flt: 'Numbers', name: 'GrossDispenseSavings', colWidth: "45px", title: 'Gross Dispense Savings', desc: 'Gross Dispense Savings' },
					{ section: 'Financials', flt: 'Numbers', name: 'NetSavings', colWidth: "45px", title: 'Net Savings', desc: 'Net Savings' },				
				]
			},
		};

		if(validSvc.isText(tabName)) {
			return result[tabName];
		}
		else {
			return result;
		}
	}

	function tblViewConfigSetup(tblSchema) {
		// config setup converts all column schema into config columns / keys

		var result = {},
			cols = [],
			col = {},
			colKeys = {},
			colAllowed = [];

		for(var tabName in tblSchema) {
			if(tblSchema.hasOwnProperty(tabName)) {
				cols = tblSchema[tabName].cols;
				colKeys = {};
				colAllowed = [];

				for(var i = 0; i < cols.length; i++) {
					col = cols[i];

					// tbd... logic to remove conditional columns based on user type, etc

					// keep column
					colAllowed.push(col.name);
					colKeys[col.name] = col;
				}

				// update columns for this table
				tblSchema[tabName].cols = colAllowed;
				tblSchema[tabName].colKeys = colKeys;

				// add to result (which may have more than 1 table in config)
				result[tabName] = tblSchema[tabName];
			}
		}

		return result;
	}

	/**
	 *    MULTISELECT HELPERS
	 */

	function multiselectRebuildSecondary(primary, secondary, affs, usingALL) {

		// rebuild secondary multiselect based on values in primary multiselect

		usingALL = !!usingALL;

		if(primary.vals.length < 1) {
			secondary.list = [];
			secondary.vals = [];
		}
		else {
			affs = primary.type == 'CE' ? utilSvc.aff.findCeList(affs, primary.vals) : utilSvc.aff.findRxList(affs, primary.vals);
			var secList = primary.type == 'CE' ? utilSvc.aff.rxList(affs) : utilSvc.aff.ceList(affs);
			var vals = secondary.vals,
				newVals = [];

			if(vals.length === 1 && vals[0] == 'ALL') {
				newVals = ['ALL'];
				usingALL = true;
			}
			else {
				// add new val only if it exists in new secList
				for(var i = 0; i < vals.length; i++) {
					if(secList.indexOf(vals[i]) > -1) {
						newVals.push(vals[i]);
					}
				}
			}

			// assign new check list
			if(usingALL && secList.length > 1) {
				secList.unshift('ALL');
			}
			if(secondary.type == 'RX') {
				secondary.list = vm.multiselectBuildRX(secList, false, affs);
			}
			else {
				secondary.list = vm.multiselectBuild(secList, false);
			}

			// assign vals
			if((!usingALL && secList.length === newVals.length) || (usingALL && ((newVals.length > 0 && newVals[0] == 'ALL') || secList.length - 1 === newVals.length))) {
				// all vals are checked
				secondary.vals = [];
				vm.multiselectClick(secondary, 'ALL');
			}
			else {
				vm.multiselectReturnVisit(secondary, '', newVals);
			}
		}

		// set title
		vm.multiselectTitle(secondary, true);

		// set biz model filters
		if(secondary.type == 'RX') {
			// get affiliations using ce / rx
			var ceAffs = utilSvc.aff.findCeList(affs, multiselectQueryVals(primary));

			// loop secondary list, add in hasSPLIT / hasSPLITMATCH
			var rxModels = [];
			secondary.list.forEach(function(item){
				if(item.val == 'ALL') {
					item.rxModels = ['SPLIT','SPLITMATCH'];
				}
				else {
					rxModels = utilSvc.aff.rxModelList(utilSvc.aff.findRx(ceAffs, item.val));
					item.rxModels = [];
					if(rxModels.indexOf('SPLIT') > -1) {
						item.rxModels.push('SPLIT');
					}
					if(rxModels.indexOf('SPLITMATCH') > -1) {
						item.rxModels.push('SPLITMATCH');
					}
				}
			});
		}

		return secondary;

	}

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if(vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		multiselect.flt = '';
		if(multiselect.type == 'RX') {
			multiselect.fltRxModels = ['SPLIT', 'SPLITMATCH'];
		}

		// don't bother with width if hiding
		if(multiselect.show) {
			multiselect.show = false;
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;

	}

	function multiselectMouseHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}

	function multiselectQueryVals(multiselect) {

		// unpack the vals multiselect into a list of entities to query

		var checklist = multiselect.list,
			vals = multiselect.vals;

		if(vals.length < 1) {
			return [];
		}
		else if(vals.length === 1 && vals[0] == 'ALL') {
			// using ALL checkbox, return all values except ALL checkbox
			var result = [],
				i = checklist[0].val == 'ALL' ? 1 : 0;
			for(i; i < checklist.length; i++) {
				result.push(checklist[i].val);
			}
			return result;
		}
		else {
			return vals;
		}
	}


	/**
	 *    HELPERS
	 */

	function numberFmt(val, zeroFmt, prefix, decPlaces) {

		// helper to format incoming number data

		// nan
		if(!validSvc.isNumber(val)) {
			return '';
		}

		// zero
		if(val === 0) {
			return zeroFmt;
		}

		return prefix + utilSvc.str.toText($filter('number')(val, decPlaces));

	}

	function numberFmtNoPrefix(val, zeroFmt, decPlaces) {

		// api controls the sign

		// nan
		if(!validSvc.isNumber(val)) {
			return '';
		}

		// prefix is only controled by value
		if(val < 0) {
			return numberFmt(Math.abs(val), zeroFmt,'-', decPlaces); // neg
		}
		else {
			return numberFmt(val, zeroFmt,'', decPlaces); // pos, no sign
		}
	}

	function saveViewState(tabName, query, flt, ceids, rxids, savedRptId) {

		if(tabName != 'SUMMARY') {
			_tabFilters[tabName] = flt;
		}

		sessionRepo.set('vs-report-splitfin', {
			query: {
				CE: ceids,
				RX: rxids,
				DateRangeMode: query.DateRangeMode,
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val
			},
			tabFilters: _tabFilters,
			savedReport: validSvc.isText(savedRptId) ? savedRptId : ''
		});
	}

	function displayQuarter(dt) {

		// return Q1, Q2 text from incoming date

		if(!validSvc.isDate(dt)) {
			return '';
		}

		var qtrNum = Math.floor(dt.getMonth() / 3) + 1;
		return 'Q' + qtrNum + ' ' + dt.getFullYear().toString();

	}

	function displayQuarterMonths(dtStart, dtEnd, useUpperCase) {

		// return 'MMM through MMM' text for this quarter

		if(!validSvc.isDate(dtStart) || !validSvc.isDate(dtEnd)) {
			return '';
		}

		if(!!useUpperCase) {
			return utilSvc.dt.monthShortText(dtStart).toUpperCase() + ' through ' + utilSvc.dt.monthShortText(dtEnd).toUpperCase();
		}
		else {
			return utilSvc.dt.monthShortText(dtStart) + ' through ' + utilSvc.dt.monthShortText(dtEnd);
		}

	}

	function dateRangeIsCustom(dtMode) {
		return dtMode.indexOf('CUSTOM') > -1;
	}

	function isFinTab(tabName) {
		switch(tabName) {
			case 'SAVINGS':
			case 'INVDETAIL':
			case 'INVOICES':
			case 'RETAILCLAIMS':
			case 'FEES':
				return true;
			default:
				return false;
		}
	}
}
 
splitSaveCtl.$inject = ['$scope', '$state', '$window', '$timeout', '$filter', 'reportRepo', 'sessionRepo', 'prefsRepo', 'appConst', 'utilSvc', 'validSvc', 'msgSvc', 'errSvc'];
angular
.module('espui.report')
.controller('SplitSaveCtl', splitSaveCtl);

/* @ngInject */
function splitSaveCtl($scope, $state, $window, $timeout, $filter, reportRepo, sessionRepo, prefsRepo, appConst, utilSvc, validSvc, msgSvc, errSvc) {

	// private props
	var _canBlob = false,
		_pendingExcelFilename = '',
		_returnVisit = false,
		_mouseLeaveDelay = {},
		_tabFilters = {},
		_savedReports = [],
		_savedReportPending = {};

	var vm = this;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addMultiselect(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.tabAction = '';
	vm.isVeriSaveOnly = false;

	// tabs
	vm.reportTab = '';
	vm.tabChange = tabChange;

	// query
	vm.query = {};
	vm.queryChangeReportType = queryChangeReportType;
	vm.queryChangeCE = queryChangeCE;
	vm.queryChangeRX = queryChangeRX;
	vm.dateRangeChange = dateRangeChange;
	vm.querySubmit = querySubmit;

	// models
	vm.summary = {};

	// excel
	vm.createExcel = createExcel;

	// charts
	vm.chartSavings = {};
	vm.chartWAC = {};

	// table and filters
	vm.tbl = {};
	vm.flt = {};
	vm.filterChange = filterChange;

	// summary compare
	vm.compare = {Data:{}};
	vm.compareDateRangeList = [];
	vm.compareToggle = compareToggle;
	vm.compareLoadData = compareLoadData;

	// html display helpers
	vm.displayQuarter = displayQuarter;
	vm.displayQuarterMonths = displayQuarterMonths;

	// multiselect
	vm.CeMultiselect = {};
	vm.RxMultiselect = {};
	vm.multiselectCeToggle = multiselectCeToggle;
	vm.multiselectRxToggle = multiselectRxToggle;
	vm.multiselectMouseHover = multiselectMouseHover;

	// time series
	vm.ts = {};
	vm.tsMetricDroplist = [];
	vm.tsToggle = tsToggle;
	vm.tsChangeMetric = tsChangeMetric;
	vm.tsChangeInterval = tsChangeInterval;
	vm.tsChangeType = tsChangeType;

	// async reports
	vm.asyncReports = {};
	vm.toggleAsyncReports = toggleAsyncReports;
	

	/**
	 *    PAGING EVENT
	 */

	var _pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});


	/**
	 *    TIMESERIES EVENT
	 */

	var _tsEventListener = $scope.$on('widget.timeseries.action', function(event, evtData) {
		event.stopPropagation();

		// exit if timeseries or filter is already gone
		if(vm.reportTab != 'SUMMARY' || vm.summary.mode != 'TIMESERIES') {
			return;
		}

		var d = evtData || {};

		// filter changed
		if(d.action == 'flt' && !!d.flt) {
			vm.ts.dirty = true;

			// store table filter by interval
			var fltKey = vm.ts.type + vm.ts.interval;
			vm.ts.prefs.flt[fltKey] = d.flt;
		}

	});


	/**
	 *    SAVED REPORT EVENT
	 */

	var _savedReportListener = $scope.$on('widget.savedreports.action', function(event, evtData) {
		event.stopPropagation();

		evtData = evtData || {};
		var reports = getSavedReports();

		switch(evtData.action) {

			case 'remove':
				_savedReportPending = evtSavedReportRemove(reports, evtData.id, evtData.current);
				break;

			case 'add':
				_savedReportPending = evtSavedReportAdd(reports, evtData.name);
				break;

			case 'current':
				_savedReportPending = evtSavedReportCurrent(reports, evtData.id);
				break;

			default:
				alert('splitSaveCtl.evtSavedReport, unknown event type: ' + evtData.action);
		}

		// save changes to server
		if(_savedReportPending.action == 'add' || _savedReportPending.action == 'remove') {

			// save to session and database
			sessionRepo.set(srKey(), {version: srVersion(), reports: reports});
			prefsRepo.savedReports(srKey(), srVersion(), reports).then(okSavedReportsToServer, errSavedReportsToServer);
		}

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
		if(!!_tsEventListener) {
			_tsEventListener();
		}
		if(!!_savedReportListener) {
			_savedReportListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// Verisaver changes title
		vm.isVeriSaveOnly = !!$scope.User.VeriSaveOnly;
		var routeInfo = angular.fromJson(angular.toJson($state.current.routeInfo));
		if(vm.isVeriSaveOnly) {
			routeInfo.title = 'Savings';
		}

		// main title
		$scope.$emit('shared.main.setInfo', routeInfo);

		vm.init = true;

		initCharts();
		_returnVisit = initQueryAndViewstate();
		vm.asyncReports = initAsyncReports();

		// set CE if viewstate wasn't used
		if(!_returnVisit && vm.query.CE.fail == 'no') {
			queryChangeCE(vm.query.CE.val);
		}

		// widget events after render
		$timeout(function() {
			$scope.$broadcast('widget.input.date.range.mode', {uniqueId: 'queryDates', mode: vm.query.DateRangeMode, keepDates: _returnVisit});
			if(_savedReports.length > 0) {
				$scope.$broadcast('widget.savedreports', {action: 'reports', reports: _savedReports});
			}
		}, 200);

	}

	function getAffs(rxmodels) {
		var affs = utilSvc.aff.findStatus($scope.User.AffList);
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);
		return utilSvc.aff.findRxModel(affs, rxmodels);
	}

	function initTimeSeriesDroplist(rptType) {

		switch(rptType) {
			case 'SPLIT':
				return [
					{value:'SavingsTotal', label:'Total Savings', fmt: 'currency', subtype: 'FIN'},
					{value:'SpendTotal', label:'Total Spend', fmt: 'currency', subtype: 'FIN'},
					{value:'Savings340BTotal', label:'340B Savings', fmt: 'currency', subtype: 'FIN'},
					{value:'Spend340BTotal', label:'340B Spend', fmt: 'currency', subtype: 'FIN'},
					{value:'SavingsGPOTotal', label:'GPO Savings', fmt: 'currency', subtype: 'FIN'},
					{value:'SpendGPOTotal', label:'GPO Spend', fmt: 'currency', subtype: 'FIN'},
					{value:'SpendWACTotal', label:'WAC Spend', fmt: 'currency', subtype: 'FIN'},
					{value:'ExcessWACTotal', label:'WAC GPO Excess', fmt: 'currency', subtype: 'FIN'},
					{value:'VerisaveSavings', label:'Verisave Savings', fmt: 'currency', subtype: 'FIN'},
					{value:'SpendWACMedicaid', label:'WAC Detail - Medicaid Spend', fmt: 'currency', subtype: 'FIN'},
					{value:'ExcessWACMedicaid', label:'WAC Detail - Medicaid GPO Excess', fmt: 'currency', subtype: 'FIN'},
					{value:'SpendWACOptimal', label:'WAC Detail - Optimized Spend', fmt: 'currency', subtype: 'FIN'},
					{value:'SavingsWACOptimal', label:'WAC Detail - Optimized GPO Excess', fmt: 'currency', subtype: 'FIN'},
					{value:'SpendWACDiscretionary', label:'WAC Detail - Discretionary Spend', fmt: 'currency', subtype: 'FIN'},
					{value:'ExcessWACDiscretionary', label:'WAC Detail - Discretionary GPO Excess', fmt: 'currency', subtype: 'FIN'},
					{value:'SpendWACRemainder', label:'WAC Detail - Remainder Spend', fmt: 'currency', subtype: 'FIN'},
					{value:'ExcessWACRemainder', label:'WAC Detail - Remainder GPO Excess', fmt: 'currency', subtype: 'FIN'},
					{value:'SpendWACSplit', label:'WAC Detail - Verity Split Subtotal Spend', fmt: 'currency', subtype: 'FIN'},
					{value:'ExcessWACSplit', label:'WAC Detail - Verity Split Subtotal GPO Excess', fmt: 'currency', subtype: 'FIN'},
					{value:'SpendWACNonSplit', label:'WAC Detail - External Orders Spend', fmt: 'currency', subtype: 'FIN'},
					{value:'ExcessWACNonSplit', label:'WAC Detail - External Orders GPO Excess', fmt: 'currency', subtype: 'FIN'}
				];

			case 'SPLITMATCH':
				return [
					{value:'SavingsTotal', label:'Total Savings', fmt: 'currency', subtype: 'FIN'},
					{value:'SpendTotal', label:'Total Spend', fmt: 'currency', subtype: 'FIN'},
					{value:'Savings340BTotal', label:'340B Savings', fmt: 'currency', subtype: 'FIN'},
					{value:'Spend340BTotal', label:'340B Spend', fmt: 'currency', subtype: 'FIN'},
					{value:'SpendWACTotal', label:'Retail Spend', fmt: 'currency', subtype: 'FIN'},
					{value:'Savings340BSplit', label:'340B Verity Split Savings', fmt: 'currency', subtype: 'FIN'},
					{value:'Spend340BSplit', label:'340B Verity Split Spend', fmt: 'currency', subtype: 'FIN'},
					{value:'Savings340BNonSplit', label:'340B External Savings', fmt: 'currency', subtype: 'FIN'},
					{value:'Spend340BNonSplit', label:'340B External Spend', fmt: 'currency', subtype: 'FIN'},
					{value:'SpendWACSplit', label:'Retail Verity Split Spend', fmt: 'currency', subtype: 'FIN'},
					{value:'SpendWACNonSplit', label:'Retail External Spend', fmt: 'currency', subtype: 'FIN'},

					{value:'Dispenses', label:'Dispense - Evaluated', fmt: 'integer', subtype: 'DISP'},
					{value:'DispensesNotMatched', label:'Dispense - Not Matched', fmt: 'integer', subtype: 'DISP'},

					{value:'NewMatchedDispenses', label:'Match - New Matches', fmt: 'integer', subtype: 'DISP'},
					{value:'AcceptedSuspects', label:'Match - New Matches Accepted from Suspect', fmt: 'integer', subtype: 'DISP'},
					{value:'ReversedMatches', label:'Match - Reversed Matches', fmt: 'integer', subtype: 'DISP'},
					{value:'ProviderFiltered', label:'Match - Date Not Eligible', fmt: 'integer', subtype: 'DISP'},
					{value:'MedicaidFiltered', label:'Match - Medicaid Not Eligible', fmt: 'integer', subtype: 'DISP'},
					{value:'VisitProximityFiltered', label:'Match - Written Date Not Eligible', fmt: 'integer', subtype: 'DISP'},
					{value:'NpiProximityFiltered', label:'Match - NPI Written Date Not Eligible', fmt: 'integer', subtype: 'DISP'},
					{value:'BlockedScriptFiltered', label:'Match - Reject Script Not Eligible', fmt: 'integer', subtype: 'DISP'},
					{value:'LocationFiltered', label:'Match - Patient Location Not Eligible', fmt: 'integer', subtype: 'DISP'},
					{value:'ErxNpiFiltered', label:'Match - ePrescribe NPI Not Eligible', fmt: 'integer', subtype: 'DISP'},
					{value:'MiscFiltered', label:'Match - Misc Not Eligible', fmt: 'integer', subtype: 'DISP'},
					{value:'NewEligibleDispenses', label:'Match - New Eligible Dispenses', fmt: 'integer', subtype: 'DISP'},

					{value:'MatchedRatio', label:'Ratio - Matched Dispenses', fmt: 'integer', subtype: 'DISP'},
					{value:'EligibleDispensesRatio', label:'Ratio - Eligible Dispenses', fmt: 'integer', subtype: 'DISP'},
					{value:'EligibleMatchesRatio', label:'Ratio - Eligible Matches', fmt: 'integer', subtype: 'DISP'}
				];

			default:
				alert('splitSaveCtl.initTimeSeriesDroplist, unknown report type: ' + rptType);
				return [];
		}
	}

	function initQueryAndViewstate() {

		var returnVisit = false;

		vm.query = reportRepo.queryVM();
		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';
		vm.query.UserHasSplitMatch = getAffs(['SPLITMATCH']).length > 0;

		vm.query.CE.vals = [];
		vm.query.RX.vals = [];

		vm.query.multi = false;
		vm.query.bigdate = false;
		vm.query.onlySummary = false;

		// date default
		vm.query.DateRangeValid = false;
		vm.query.DateRangeList = utilSvc.widget.dateRangeList(['CUSTOM92']);

		// add yearly options
		vm.query.DateRangeList.push({label: 'Last 12 Months', value: 'LTM'});
		vm.query.DateRangeList.push({label: 'Yearly', value: 'YEARLY'});
		vm.query.DateRangeList.push({label: 'Year To Date', value: 'YTD'});

		// unlimited custom range (move min validation dates to app start)
		// note: reportRepo does this by default but want to explicitly set it JIC repo changes in future
		var dtToday = new Date(),
			dtAppStart = utilSvc.dt.zeroTime(appConst.app.liveDate),
			customRangeDays = parseInt(utilSvc.dt.diffDays(dtAppStart, dtToday));
		vm.query.StartDate.min = dtAppStart;
		vm.query.EndDate.min = dtAppStart;
		vm.query.DateRangeList.push({label: 'Custom Date Range', value: 'CUSTOM' + customRangeDays.toString()});

		vm.query.DateRangeMode = 'MTD';

		// compare date list is hard coded and hidden by CSS
		vm.compareDateRangeList = [
			{label:'Last Month To Date', value:'LMTD'},
			{label:'Monthly', value:'MONTHLY'},
			{label:'Last Quarter To Date', value:'LQTD'},
			{label:'Last Year To Date', value:'LYTD'},
			{label:'Previous Last 12 Months', value:'LLTM'}
		];

		// RX multiselect
		vm.RxMultiselect = {
			type: 'RX',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Pharmacy',
			vals: [],
			list: [],
			flt: ''
		};

		// CE multiselect
		vm.CeMultiselect = {
			type: 'CE',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Facility',
			vals: [],
			list: [],
			flt: ''
		};

		// default ReportType and CE list
		var defaultAffs = getAffs(['SPLIT']);
		if(defaultAffs.length > 0) {
			vm.query.ReportType = 'SPLIT';
		}
		else if(vm.query.UserHasSplitMatch) {
			vm.query.ReportType = 'SPLITMATCH';
			defaultAffs = getAffs(['SPLITMATCH']);
		}
		vm.CeMultiselect.list = vm.multiselectBuild(utilSvc.aff.ceList(defaultAffs), false);

		// default tab filters
		_tabFilters = initFilters(vm.query.UserHasSplitMatch);

		// load saved reports, add widget details
		_savedReports = getSavedReports(true);

		// get viewstate
		var vs = sessionRepo.get('vs-report-splitsavings');
		if(!!vs) {

			var storeType = '',
				rptType = '',
				vsq = {};

			if(validSvc.isText(vs.savedReport)) {
				// get query from saved report
				var srx = getSavedReportById(_savedReports, vs.savedReport);
				if(srx > -1) {
					storeType = 'sr';
					var sr = _savedReports[srx];
					rptType = sr.ReportType;
					vsq = sr;
				}
			}
			else {
				// get query from viewstate
				storeType = 'vs';
				rptType = vs.ReportType;
				vsq = vs.query;
			}

			// load saved query
			if(!!storeType) {
				returnVisit = loadSavedQuery(storeType, rptType, vsq);
			}

			if(returnVisit) {
				if(storeType == 'sr') {
					_savedReportPending = {
						action: 'current',
						id: vs.savedReport
					};
				}
			}
			else {
				// viewstate not valid
				sessionRepo.clearKey('vs-report-splitsavings');
			}
		}

		// set titles
		vm.multiselectTitle(vm.CeMultiselect, true);
		vm.multiselectTitle(vm.RxMultiselect, true);

		return returnVisit;

	}

	function loadSavedQuery(storeType, rptType, vsq) {

		// load query from viewstate or a saved report

		var vsAffs = getAffs([rptType]);
		if(vsAffs.length < 1) {
			return false;
		}

		vm.CeMultiselect.list = vm.multiselectBuild(utilSvc.aff.ceList(vsAffs), false);
		vm.multiselectReturnVisit(vm.CeMultiselect, '', vsq.CE);

		// rebuild RX list
		vm.RxMultiselect.vals = vsq.RX;
		vm.RxMultiselect = multiselectRebuildSecondary(vm.CeMultiselect, vm.RxMultiselect, vsAffs, true);

		// did rebuild work?
		vm.query.CE.fail = vm.CeMultiselect.vals.length < 1 ? 'yes' : 'no';
		vm.query.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';
		if(vm.query.CE.fail == 'yes' || vm.query.RX.fail == 'yes') {
			return false;
		}

		// assign sub-properties
		vm.query.ReportType = rptType;
		vm.query.DateRangeMode = storeType == 'sr' ? vsq.DateMode : vsq.DateRangeMode;
		vm.query.StartDate.val = validSvc.isDate(vsq.StartDate) ? new Date(vsq.StartDate) : null;
		vm.query.EndDate.val = validSvc.isDate(vsq.EndDate) ? new Date(vsq.EndDate) : null;
		vm.query.DateRangeValid = true;

		if(storeType == 'vs') {
			_tabFilters = vsq.tabFilters;
		}

		return true;

	}

	function initFilters(hasSplitMatch) {

		var result = {
			SUMMARY: vm.initFilters(), // not needed but makes tabChange code easier

			DETAIL: vm.initFilters({
				Config: {
					Dates: ['InvoiceDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['InvoiceDate']
			})
		};

		if(hasSplitMatch) {

			result.INVOICES = vm.initFilters({
				Config: {
					Dates: ['OrderDate', 'InvoiceDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['InvoiceDate']
			});

			result.INVDETAIL = vm.initFilters({
				Config: {
					Dates: ['OrderDate', 'InvoiceDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['InvoiceDate']
			});

			result.CLAIMS = vm.initFilters({
				Config: {
					Dates: ['OrderDate', 'DispFillDate', 'InvoiceDate'],
					DateFmt: 'M/d/yyyy'
				},
				HideSection: {
					Inv: false,
					Drug: false,
					Disp: true,
					Tot: false
				},
				SortBy: ['InvoiceDate']
			});
			result.FEES = vm.initFilters({
				Config: {
					Dates: ['OrderDate', 'DispFillDate', 'InvoiceDate'],
					DateFmt: 'M/d/yyyy'
				},
				HideSection: {
					Inv: false,
					Drug: false,
					Disp: true,
					Tot: false
				},
				SortBy: ['InvoiceDate']
			});
		}

		return result;

	}

	function initCharts(resetUI) {

		// reset all charts

		// reset SVG?
		if(!!resetUI) {
			if(vm.chartSavings.status == 'DRAW') {
				$scope.$broadcast('widget.chart.sync', {uniqueId: vm.chartSavings.id, render: ''});
			}
			if(vm.chartWAC.status == 'DRAW') {
				$scope.$broadcast('widget.chart.sync', {uniqueId: vm.chartWAC.id, render: ''});
			}
		}

		vm.chartSavings = initChart('CHART_SAVINGS');
		vm.chartWAC = initChart('CHART_WAC');

	}

	function initChart(id) {

		// minimum pie chart config
		// note: this is a slimmed down from full home page widgets

		var title = '';
		switch(id) {
			case 'CHART_SAVINGS':
				title = 'Total Spend';
				break;
			case 'CHART_WAC':
				title = 'WAC Spend';
				break;
			default:
				throw new Error('splitSaveCtl.initChart, chart id unknown: ' + id);
		}

		return {
			id: id,
			status: '',
			config: {
				chartType: 'PIE',
				colors: [],
				valFormat: 'number',
				donutHoleRadius: 0.4,
				label: {
					width: 50,
					height: 30
				}
			},
			text: {
				title: title
			},
			data: []
		};

	}

	function initAsyncReports() {
		return {
			title: '340B Savings - Saved Files',
			show: 'no'
		};
	}

	/**
	 *    VIEW MODELS
	 */

	function summaryVM(data) {

		// clean up summary percentages to integer
		data = data || {};
		data.Spend340BPercent = Math.round(data.Spend340BPercent);
		data.SpendOWNPercent = Math.round(data.SpendOWNPercent);
		data.SpendGPOPercent = Math.round(data.SpendGPOPercent);
		data.SpendWACPercent = Math.round(data.SpendWACPercent);

		return data;

	}

	function invoicesVM(data, tooMany) {

		data = data || {};
		var items = Array.isArray(data.Items) ? data.Items : [];

		for(var i = 0; i < items.length; i++) {
			items[i].Internal = !!items[i].Split ? 'YES' : 'NO';
		}

		return {
			DataItems: items,
			Items: [], // items will be loaded by filterChange() method
			TooMany: !!tooMany
		};

	}

	function retailSummaryVM(data) {
		data = data || {};

		var rpt = {
			isCompare: false,

			// 340b
			Spend340BSplit: data.Spend340BSplit,
			Savings340BSplit: data.Savings340BSplit,
			Spend340BNonSplit: data.Spend340BNonSplit,
			Savings340BNonSplit: data.Savings340BNonSplit,
			Spend340BTotal: data.Spend340BTotal,
			Savings340BTotal: data.Savings340BTotal,
			Spend340BPercent: data.Spend340BPercent,

			// GPO
			SpendGPOSplit: data.SpendGPOSplit,
			SavingsGPOSplit: data.SavingsGPOSplit,
			SpendGPONonSplit: data.SpendGPONonSplit,
			SavingsGPONonSplit: data.SavingsGPONonSplit,
			SpendGPOTotal: data.SpendGPOTotal,
			SavingsGPOTotal: data.SavingsGPOTotal,
			SpendGPOPercent: data.SpendGPOPercent,

			// OWN
			SpendOWNSplit: data.SpendOWNSplit,
			SavingsOWNSplit: data.SavingsOWNSplit,
			SpendOWNNonSplit: data.SpendOWNNonSplit,
			SavingsOWNNonSplit: data.SavingsOWNNonSplit,
			SpendOWNTotal: data.SpendOWNTotal,
			SavingsOWNTotal: data.SavingsOWNTotal,
			SpendOWNPercent: data.SpendOWNPercent,

			// retail
			SpendWACSplit: data.SpendWACSplit,
			SpendWACNonSplit: data.SpendWACNonSplit,
			SpendWACTotal: data.SpendWACTotal,
			SpendWACPercent: data.SpendWACPercent,

			// total
			VerityMonthlyReferralFees: data.VerityMonthlyReferralFees,
			VerityMonthlyOrderFees: data.VerityMonthlyOrderFees,

			SpendTotal: data.SpendTotal,
			SavingsTotal: data.SavingsTotal,

			// dispense stats
			Dispenses: numberFmt(data.Dispenses, '0','', 0),
			NewEligibleDispenses: numberFmt(data.NewEligibleDispenses, '0','', 0),

			// match stats
			DispensesNotMatched: numberFmt(data.DispensesNotMatched, '0', '-', 0),
			AcceptedSuspects: numberFmtNoPrefix(data.AcceptedSuspects, '0', 0),
			NewMatchedDispenses: numberFmt(data.NewMatchedDispenses, '0','', 0),
			ProviderFiltered: numberFmt(data.ProviderFiltered, '0','-', 0),
			MedicaidFiltered: numberFmt(data.MedicaidFiltered, '0','-', 0),
			VisitProximityFiltered: numberFmt(data.VisitProximityFiltered, '0','-', 0),
			NpiProximityFiltered: numberFmt(data.NpiProximityFiltered, '0','-', 0),
			BlockedScriptFiltered: numberFmt(data.BlockedScriptFiltered, '0','-', 0),
			ErxNpiFiltered: numberFmt(data.ErxNpiFiltered, '0','-', 0),
			LocationFiltered: numberFmt(data.LocationFiltered, '0','-', 0),
			MiscFiltered: numberFmt(data.MiscFiltered, '0','-', 0),
			ReversedMatches: numberFmt(data.ReversedMatches, '0','-', 0),

			// match ratios
			MatchedRatio: numberFmtNoPrefix(data.MatchedRatio, '0', 0),
			EligibleDispensesRatio: numberFmtNoPrefix(data.EligibleDispensesRatio, '0', 0),
			EligibleMatchesRatio: numberFmtNoPrefix(data.EligibleMatchesRatio, '0', 0),
			VerisaveSavings: numberFmtNoPrefix(data.VerisaveSavings, '0', 2),
			UseBestCost: data.UseBestCost,
			VerisaveOriginalCost: numberFmtNoPrefix(data.VerisaveOriginalCost, '0', 2),
			VerisaveInvoicedCost: numberFmtNoPrefix(data.VerisaveInvoicedCost, '0', 2),
		};

		return rpt;
	}

	function retailInvoicesVM(items, tooMany) {
		return {
			DataItems: items,
			Items: [], // items will be loaded by filterChange() method
			TooMany: !!tooMany
		};
	}

	function retailInvDetailVM(items, tooMany) {
		return {
			DataItems: items,
			Items: [], // items will be loaded by filterChange() method
			TooMany: !!tooMany
		};
	}

	function retailClaimsVM(items, tooMany) {
		return {
			DataItems: items,
			Items: [], // items will be loaded by filterChange() method
			TooMany: !!tooMany
		};
	}
	function retailFeesVM(items, tooMany) {
		items = Array.isArray(items) ? items : [];

		var item = {};
		for(var i = 0; i < items.length; i++) {
			item = items[i];
			// nullify golang "zero" dates
			item.OrderDate = validSvc.isDate(item.OrderDate) ? item.OrderDate : null;
			item.InvoiceDt = validSvc.isDate(item.InvoiceDt) ? item.InvoiceDt : null;
			item.DispRxWrittenDate = validSvc.isDate(item.DispRxWrittenDate) ? item.DispRxWrittenDate : null;
			item.DispFillDate = validSvc.isDate(item.DispFillDate) ? item.DispFillDate : null;
			item.DispenseDate = validSvc.isDate(item.DispenseDate) ? item.DispenseDate : null;
		}
		return {
			DataItems: items,
			Items: [], // items will be loaded by filterChange() method
			TooMany: !!tooMany
		};
	}

	function chartSavingsVM(r) {

		// pie chart, parse data into pie chart format

		r = r || {};

		var chart = initChart('CHART_SAVINGS'),
			data = [],
			wedge340B = validSvc.isNumber(r.Spend340BTotal) ? r.Spend340BTotal : 0,
			wedgeGPO = validSvc.isNumber(r.SpendGPOTotal) ? r.SpendGPOTotal : 0,
			wedgeWAC = validSvc.isNumber(r.SpendWACTotal) ? r.SpendWACTotal : 0;

		// no data?
		if((wedge340B + wedgeGPO + wedgeWAC) <= 0) {
			return chart;
		}

		// 340B
		chart.data.push({
			name: '340B',
			val: wedge340B,
			percent: Math.round(r.Spend340BPercent),
			color: appConst.app.color.chart340B
		});

		// GPO
		chart.data.push({
			name: 'GPO',
			val: wedgeGPO,
			percent: Math.round(r.SpendGPOPercent),
			color: appConst.app.color.chartGPO
		});

		// WAC
		chart.data.push({
			name: 'WAC',
			val: wedgeWAC,
			percent: Math.round(r.SpendWACPercent),
			color: appConst.app.color.chartWAC
		});

		// sort
		chart.data = utilSvc.array.sortDSC(chart.data, 'percent');

		// modify config colors to match account types (this chart doesn't use standard Verity widget colors)
		for(var i = 0; i < chart.data.length; i++) {
			chart.config.colors.push(appConst.app.color['chart' + chart.data[i].name]);
		}

		return chart;

	}

	function chartWACVM(r) {

		// pie chart, parse data into pie chart format

		r = r || {};

		var chart = initChart('CHART_WAC'),
			data = [];

		// no data?
		if(r.SpendWACTotal <= 0 || r.SpendWACMedicaidPercent + r.SpendWACOptimalPercent +
			r.SpendWACDiscretionaryPercent + r.SpendWACRemainderPercent + r.SpendWACNonSplitPercent <= 0) {
			return chart;
		}

		if(r.SpendWACMedicaidPercent >= 0.01) {
			data.push({
				name: 'Medicaid',
				val: r.SpendWACMedicaid,
				percent: r.SpendWACMedicaidPercent
			});
		}

		if(r.SpendWACOptimalPercent >= 0.01) {
			data.push({
				name: 'Optimized',
				val: r.SpendWACOptimal,
				percent: r.SpendWACOptimalPercent
			});
		}

		if(r.SpendWACDiscretionaryPercent >= 0.01) {
			data.push({
				name: 'Discretionary',
				val: r.SpendWACDiscretionary,
				percent: r.SpendWACDiscretionaryPercent
			});
		}

		if(r.SpendWACRemainderPercent >= 0.01) {
			data.push({
				name: 'Remainder',
				val: r.SpendWACRemainder,
				percent: r.SpendWACRemainderPercent
			});
		}

		if(r.SpendWACNonSplitPercent >= 0.01) {
			data.push({
				name: 'External',
				val: r.SpendWACNonSplit,
				percent: r.SpendWACNonSplitPercent
			});
		}

		// no data after value check?
		if(data.length < 1) {
			return chart;
		}
		chart.data = data;

		chart.data = utilSvc.array.sortDSC(chart.data, 'percent');
		chart.config.colors = appConst.app.color.chartBars($window.espuiPrefs.skin);

		return chart;

	}


	/**
	 *    QUERY / TAB CHANGE
	 */

	function queryChange() {

		if(!vm.init) {
			vm.tabAction = '';
			vm.reportTab = '';

			// summary
			initCharts(true);
			vm.summary = {};
			vm.compare = {Data:{}};

			// timeseries, saved reports
			tsReset();
			$scope.$broadcast('widget.savedreports');

			// tables
			vm.tbl = {};
			vm.flt = {};
			$scope.$broadcast('widget.paging');
		}

	}

	function multiselectCeToggle(evt, id) {
		vm.RxMultiselect.show = false;
		multiselectToggle(evt, vm.CeMultiselect, id);
	}

	function multiselectRxToggle(evt, id) {
		vm.CeMultiselect.show = false;
		multiselectToggle(evt, vm.RxMultiselect, id);
	}

	function queryChangeReportType(rptType) {
		queryChange();

		if(rptType != 'SPLIT' && rptType != 'SPLITMATCH') {
			throw new Error('splitSaveCtl.queryChangeRptType, unknown rpt type: ' + rptType);
		}

		vm.query.ReportType = rptType;
		vm.query.CE = validSvc.newProp('NONE');

		// rebuild CE droplist
		var affs = getAffs([rptType]);
		vm.CeMultiselect.list = vm.multiselectBuild(utilSvc.aff.ceList(affs), false);

		// clear values
		vm.CeMultiselect.vals = [];
		vm.multiselectTitle(vm.CeMultiselect, true);

	}

	function queryChangeCE(val) {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.multiselectClick(vm.CeMultiselect, val);
		vm.multiselectTitle(vm.CeMultiselect, true);

		vm.query.CE.fail = vm.CeMultiselect.vals.length < 1 ? 'yes' : 'no';

		// rebuild RX
		vm.RxMultiselect = multiselectRebuildSecondary(vm.CeMultiselect, vm.RxMultiselect, getAffs([vm.query.ReportType]), true);
		vm.query.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';

	}

	function queryChangeRX(val) {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.multiselectClick(vm.RxMultiselect, val);
		vm.multiselectTitle(vm.RxMultiselect, true);

		vm.query.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';

	}

	function dateRangeChange(uniqueId, dtMode, isValid) {
		switch(uniqueId) {

			case 'queryDates':
				queryChange();
				vm.query.DateRangeMode = dtMode;
				vm.query.DateRangeValid = isValid;

				if(_returnVisit) {
					_returnVisit = false;
					querySubmit();
				}

				vm.init = false;
				break;

			case 'compareDates':
				// summary compare
				vm.compare.DateRangeMode = dtMode;
				vm.compare.DateRangeValid = isValid;

				// user must choose before query
				if(dtMode == 'QTR' || dtMode == 'YEARLY') {
					vm.summary.mode = 'COMPAREQUERY';
				}

				// when summary compare loads it fires this mode change, do query on this event
				if(vm.summary.mode != 'COMPAREQUERY') {
					compareLoadData();
				}
				break;

			default:
				alert('splitSaveCtl.dateRangeChange, unknown date range id: ' + uniqueId);
		}

	}

	function tabChange(tabName) {

		if(vm.isWaiting) {
			return;
		}

		if(tabName != 'SUMMARY' && (vm.query.multi || vm.query.bigdate)) {
			return;
		}

		vm.flt = vm.resetFilters(_tabFilters[tabName]);
		vm.reportTab = tabName;
		vm.tabAction = '';

		switch(tabName) {

			case 'SUMMARY':
				// summary data is already cached
				vm.tbl.Items = [];
				$scope.$broadcast('widget.paging');
				break;

			case 'DETAIL':
			case 'INVOICES':
			case 'INVDETAIL':
			case 'CLAIMS':
			case 'FEES':
				vm.tbl = {};
				$scope.$broadcast('widget.paging');
				getTabData(tabName, vm.query);
				break;

			default:
				throw new Error('splitSaveCtl.tabChange, unknown tab name: ' + tabName);

		}

	}


	/**
	 *    GLOBAL GREASE FILTER
	 */

	function updatePagingWidget(tabName, flt, tbl) {

		$scope.$broadcast('widget.paging', {
			uniqueId: tabName,
			Size: flt.PageSize,
			Page: flt.Page,
			Total: flt.PageTotal,
			RowCount: flt.Count,
			ItemCount: tbl.Items.length,
			DataCount: tbl.DataItems.length
		});

	}

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			updatePagingWidget(vm.reportTab, vm.flt, vm.tbl);

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					saveViewState(vm.reportTab, vm.query, vm.flt, vm.CeMultiselect.vals, vm.RxMultiselect.vals);
				}
			},1000);

		}, delayTime);

	}


	/**
	 *    QUERY SUBMIT
	 */

	function queryValid(ceVals, rxVals) {

		vm.query.CE.fail = ceVals.length < 1 ? 'yes' : 'no';
		vm.query.RX.fail = rxVals.length < 1 ? 'yes' : 'no';

		return vm.query.DateRangeValid &&
			vm.query.CE.fail != 'yes' &&
			vm.query.RX.fail != 'yes';

	}

	function querySubmit() {

		// validate
		var ceVals = multiselectQueryVals(vm.CeMultiselect),
			rxVals = multiselectQueryVals(vm.RxMultiselect);

		if(!queryValid(ceVals, rxVals)) {
			if(!vm.init) {
				msgSvc.ok('Search', 'Check filter settings');
			}
			return;
		}

		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true);

		queryChange();
		vm.summary = {};

		// assign multi values
		vm.query.CE.vals = ceVals;
		vm.query.RX.vals = rxVals;
		vm.query.multi = false;
		if((ceVals[0] == 'ALL' || ceVals.length > 1) && (rxVals[0] == 'ALL' || rxVals.length > 1)) {
			vm.query.multi = true;
		}

		vm.query.bigdate = false;
		var dtMode = vm.query.DateRangeMode;
		if(dtMode == 'YEARLY' || dtMode == 'YTD' || dtMode == 'LTM' || dateRangeIsCustom(dtMode)) {
			vm.query.bigdate = utilSvc.dt.diffDays(vm.query.StartDate.val, vm.query.EndDate.val) > 92;
		}

		vm.query.onlySummary = vm.query.multi || vm.query.bigdate;


		if(vm.query.ReportType == 'SPLIT') {
			reportRepo.getSplitSavings('SUMMARY', vm.query, false).then(okData, errData);  // false = not a comparison query
		}
		else {
			reportRepo.getSplitSavingsRetail('SUMMARY', vm.query, false).then(okData, errData);
		}

		function okData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(vm.query.ReportType == 'SPLIT') {

				// SPLIT request has both Summary and Detail tab data in one call
				vm.summary = summaryVM(r.data);
				vm.chartSavings = chartSavingsVM(r.data);
				vm.chartWAC = chartWACVM(r.data);

				// render charts after digest
				$timeout(function() {

					var chart = vm.chartSavings;
					if(chart.data.length > 0) {

						chart.status = 'DRAW';
						$scope.$broadcast('widget.chart.sync', {
							uniqueId: chart.id,
							config: chart.config,
							data: chart.data,
							render: 'animate'
						});
					}

					chart = vm.chartWAC;
					if(chart.data.length > 0) {
						chart.status = 'DRAW';
						$scope.$broadcast('widget.chart.sync', {
							uniqueId: chart.id,
							config: chart.config,
							data: chart.data,
							render: 'animate'
						});
					}

				},300);

			}
			else if(vm.query.ReportType == 'SPLITMATCH') {

				// SPLITMATCH only has summaryVM in first call, other tabs call again
				vm.summary = retailSummaryVM(r);
			}

			// show comparison prompt?
			vm.compare.prompt = false;
			switch(vm.query.DateRangeMode) {
				case 'MONTHLY':
					vm.compare.prompt = true;
					vm.compare.title = 'Compare With Previous Month';
					break;
				case 'MTD':
					vm.compare.prompt = true;
					vm.compare.title = 'Compare With Previous Month To Date';
					break;
				case 'QTD':
					vm.compare.prompt = true;
					vm.compare.title = 'Compare With Previous Quarter To Date';
					break;
				case 'QTDLAST':
				case 'QTR':
					vm.compare.prompt = true;
					vm.compare.title = 'Compare With Another Quarter';
					break;
				case 'YTD':
					vm.compare.prompt = true;
					vm.compare.title = 'Compare With Previous Year To Date';
					break;
				case 'YEARLY':
					vm.compare.prompt = true;
					vm.compare.title = 'Compare With Another Year';
					break;
				case 'LTM':
					vm.compare.prompt = true;
					vm.compare.title = 'Compare With Previous Last 12 Months';
					break;
			}

			vm.reportTab = 'SUMMARY';
			vm.summary.mode = 'TOTALS';

			// update saved report widget query
			var srCurrent = '';
			if(validSvc.isText(_savedReportPending.id) && (_savedReportPending.action == 'add' || _savedReportPending.action == 'current')) {
				srCurrent = _savedReportPending.id;
			}
			_savedReportPending = {};

			$timeout(function() {
				$scope.$broadcast('widget.savedreports', {
					action: 'query',
					query: {
						details: savedReportWidgetDetailsFmt(
							vm.query.ReportType,
							vm.query.CE.vals,
							vm.query.RX.vals,
							vm.query.DateRangeMode,
							vm.query.StartDate.val,
							vm.query.EndDate.val
						)
					},
					current: srCurrent
				});
			},500);

			// query was good, save viewstate
			saveViewState('SUMMARY', vm.query, vm.flt, vm.CeMultiselect.vals, vm.RxMultiselect.vals, srCurrent);

		}

		function errData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Error loading split savings report', 'splitSaveCtl.querySubmit', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    SUMMARY COMPARISON
	 */

	function compareToggle() {

		// turn compare display on/off

		if(vm.summary.mode == 'COMPAREQUERY' || vm.summary.mode == 'COMPARE') {
			// toggle off
			vm.compare.Data = {};
			vm.summary.mode = 'TOTALS';
		}
		else {
			// toggle on

			vm.compare.DateRangeValid = false;

			// setup Compare dates based on query mode
			var compareKeepDates = false;
			switch(vm.query.DateRangeMode) {

				case 'MONTHLY':
					// default to previous month from query
					vm.compare.DateRangeMode = 'MONTHLY';
					compareKeepDates = true;
					vm.query.CompareStartDate.val = utilSvc.dt.addMonths(utilSvc.dt.monthStart(vm.query.StartDate.val), -1);
					vm.query.CompareEndDate.val = utilSvc.dt.monthEnd(vm.query.CompareStartDate.val);
					break;

				case 'MTD':
					vm.compare.DateRangeMode = 'LMTD';
					break;

				case 'QTD':
					vm.compare.DateRangeMode = 'LQTD';
					break;

				case 'QTDLAST':
				case 'QTR':
					vm.compare.DateRangeMode = 'QTR';
					break;

				case 'YTD':
					vm.compare.DateRangeMode = 'LYTD';
					break;

				case 'YEARLY':
					vm.compare.DateRangeMode = 'YEARLY';
					break;

				case 'LTM':
					vm.compare.DateRangeMode = 'LLTM';
					break;

				default:
					alert('splitSavingsCtl.compareToggle, unsupported query date mode for comparison: ' + vm.query.DateRangeMode);
					return;
			}

			$timeout(function() {
				// note: date mode change event will advance UI to action = COMPARE
				$scope.$broadcast('widget.input.date.range.mode', {uniqueId: 'compareDates', mode: vm.compare.DateRangeMode, keepDates: compareKeepDates});
			}, 100);

		}
	}

	function compareLoadData() {

		if(vm.isWaiting) {
			return;
		}

		// dates are valid?
		if(!vm.compare.DateRangeValid) {
			msgSvc.ok('Summary Compare', 'Check date values.');
			vm.summary.mode = 'COMPAREQUERY';
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true, true);

		if(vm.query.ReportType == 'SPLIT') {
			reportRepo.getSplitSavings('SUMMARY', vm.query, true).then(okCompData, errCompData);
		}
		else {
			reportRepo.getSplitSavingsRetail('SUMMARY', vm.query, true).then(okCompData, errCompData);
		}

		function okCompData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(vm.query.ReportType == 'SPLIT') {
				vm.compare.Data = summaryVM(r.data);
			}
			else {
				vm.compare.Data = retailSummaryVM(r);
			}
			vm.summary.mode = 'COMPARE';

		}

		function errCompData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Error loading report tab: ' + vm.reportTab, 'report.loadSummaryCompare', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}


	/**
	 *    GET RETAIL TAB DATA
	 */

	function getTabData(tabName, query) {

		if(vm.isWaiting) {
			return;
		}
		vm.isWaiting = true;
		msgSvc.wait(true);

		if(vm.query.ReportType == 'SPLIT') {
			reportRepo.getSplitSavings(tabName, vm.query, false).then(okTabData, errTabData);  // false = not a comparison query
		}
		else {
			reportRepo.getSplitSavingsRetail(tabName, vm.query, false).then(okTabData, errTabData);  // false = not a comparison query
		}
		function okTabData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			switch(vm.reportTab) {
				case 'DETAIL':
					vm.tbl = invoicesVM(r.data, r.tooMany);
					break;
				case 'INVOICES':
					vm.tbl = retailInvoicesVM(r.data, r.tooMany);
					break;
				case 'INVDETAIL':
					vm.tbl = retailInvDetailVM(r.data, r.tooMany);
					break;
				case 'CLAIMS':
					vm.tbl = retailClaimsVM(r.data, r.tooMany);
					break;
				case 'FEES':
					vm.tbl = retailFeesVM(r.data, r.tooMany);
					break;
				default:
					throw new Error('splitSaveCtl.tabChange, unknown tab name: ' + tabName);
			}

			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			updatePagingWidget(vm.reportTab, vm.flt, vm.tbl);

			vm.flt.Ready = true;
			vm.tabAction = 'LIST';

		}

		function errTabData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Error loading split savings report', 'splitSaveCtl.querySubmit', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 *    TIME SERIES
	 */

	function timeseriesVM(rptType) {

		var defaultType = 'AGGREGATE',
			defaultInterval = 'MONTH';

		var result = {
			dirty: false,
			type: '',
			subtype: '',
			action: 'LOAD',
			metric: '',
			interval: '',
			prefs: {},
			colHeaders: [],
			data: []
		};

		switch(rptType) {
			case 'SPLIT':
				result.prefs = {
					type: defaultType,
					subtype: 'FIN',
					metric: 'SavingsTotal',
					interval: defaultInterval,
					flt: {}
				};
				break;
			case 'SPLITMATCH':
				result.prefs = {
					type: defaultType,
					subtype: 'DISP',
					metric: 'Dispenses',
					interval: defaultInterval,
					flt: {}
				};
				break;
			default:
				msgSvc.ok('Unknown report type: ' + rptType, 'splitsaveCtl.timeseriesVM');
		}

		return result;
	}

	function tsReset() {

		var ts = vm.ts;

		// save prefs if dirty
		if(!!ts.dirty && !!ts.prefs) {
			sessionRepo.set('ts-report-splitsavings-' + vm.query.ReportType.toLowerCase(), ts.prefs);
		}

		ts.dirty = false;
		ts.action = '';
		ts.colHeaders = [];
		ts.data = [];

		$scope.$broadcast('widget.timeseries');
	}

	function tsToggle() {

		// toggle time series display on/off

		if(vm.summary.mode == 'TIMESERIES') {
			tsReset();
			vm.summary.mode = 'TOTALS';
		}
		else {
			// toggle on

			var rptType = vm.query.ReportType;
			vm.tsMetricDroplist = initTimeSeriesDroplist(rptType);
			vm.ts = timeseriesVM(rptType);

			// get timeseries viewstate
			var vs = sessionRepo.get('ts-report-splitsavings-' + rptType.toLowerCase());
			if(!!vs) {
				vm.ts.prefs = vs;
			}

			// move pref properties for easier html bind
			var prefs = vm.ts.prefs;
			vm.ts.type = prefs.type;
			vm.ts.subtype = prefs.subtype;
			vm.ts.interval = prefs.interval;
			vm.ts.metric = prefs.metric;

			vm.summary.mode = 'TIMESERIES';

			$timeout(function() {
				tsLoadData();
			}, 200);

		}
	}

	function tsLoadData() {

		if(vm.isWaiting) {
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true, true);

		reportRepo.getTimeseries('SPLITSAVE', vm.ts, vm.query).then(okTsData, errTsData);

		function okTsData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.ts = tsParseData(vm.query.ReportType, r, vm.ts);
			if(vm.ts.action != 'NODATA') {

				switch(vm.ts.type) {
					case 'AGGREGATE':
						tsLoadAggregate();
						break;
					case 'METRIC':
						tsChangeMetric();
						break;
					default:
						alert('splitSaveCtl.tsLoadData, uknown timeseries type: ' + vm.ts.type);
						tsReset();
						vm.summary.mode = 'TOTALS';
				}
			}

		}

		function errTsData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Error loading report tab: ' + vm.reportTab, 'report.loadSummaryCompare', r.status, utilSvc.http.safeResponse(r));
			}
		}

	}

	function tsGetMetricInfo(metric) {

		// find metric formats (they are overloaded into droplist array)

		var items = vm.tsMetricDroplist;
		for(var i = 0; i < items.length; i++) {
			if(items[i].value == metric) {
				return items[i];
			}
		}

		alert('splitsaveCtl.tsGetMetricInfo, metric: ' + metric + ' not found for report type: ' + vm.query.ReportType);
		return {};

	}

	function tsGetColumnHeaders(series, isQuarterly) {

		// pre-build column config (once per data load)

		var cols = [],
			id = '0',
			dtSeg = [],
			mth = 0,
			day = 0,
			colTitle = '',
			months = utilSvc.ng.monthShortDroplist();

		// 1st column is always title
		cols.push({
			id: 'title',
			title: 'Affiliation',
			width: '120px',
			sort: true,
			flt: undefined,
			fltType: 'Text'
		});

		// loop series to pre-format column labels
		series = Array.isArray(series) ? series : [];
		for(var i = 0; i < series.length; i++) {

			// get fmt from "yyyy-mm-dd" to "MMM dd"
			dtSeg = series[i].Date.split('-');
			mth = parseInt(dtSeg[1]) - 1; // month list is zero based
			mth = months[mth].label;
			day = parseInt(dtSeg[2]);
			day = day.toString();

			if(isQuarterly) {
				colTitle = displayQuarter(new Date(dtSeg[0], dtSeg[1] - 1, 0));
			}
			else {
				colTitle = mth + ' ' + day;
			}

			cols.push({
				id: 'id' + dtSeg.join('_'),
				mth: mth,
				day: day,
				title: colTitle,
				width: '40px',
				sort: true,
				flt: undefined,
				fltType: 'Numbers'
			});
		}

		return cols;

	}

	function tsParseData(rptType, data, ts) {

		// parse api data into timeseries cached VM
		// cached VM holds pre-calculated columns / filters, etc

		if(rptType != 'SPLIT' && rptType != 'SPLITMATCH') {
			throw new Error('splitSaveCtl.tsParseData, unknown rpt type: ' + rptType);
		}

		ts.action = '';
		ts.colHeaders = [];
		ts.data = [];

		// no data
		var affs = Array.isArray(data) ? data : [];
		if(affs.length < 1 || !Array.isArray(affs[0].Series) || affs[0].Series.length < 1) {
			ts.action = 'NODATA';
			return ts;
		}

		var aff = {},
			dataRow ={},
			affSeries = [];

		ts.colHeaders = tsGetColumnHeaders(affs[0].Series, ts.interval == 'QUARTER');

		// parse api data into timeseries pre-format
		var isFIN = ts.subtype == 'FIN';

		for(var i = 0; i < affs.length; i++) {
			aff = affs[i];

			dataRow = {
				id: i,
				title: aff.CEID + ' / ' + aff.Pharmacy,
				series: []
			};

			// loop series, convert api summary data into VM
			affSeries = Array.isArray(aff.Series) ? aff.Series : [];
			for(var ii = 0; ii < affSeries.length; ii++) {
				if(isFIN) {
					dataRow.series.push(affSeries[ii].Summary);
				}
				else {
					// Retail (SPLITMATCH) can have DISP type
					dataRow.series.push(affSeries[ii].Stats);
				}
			}

			ts.data.push(dataRow);
		}

		return ts;

	}

	function tsChangeType() {

		// switch the timeseries display type

		if(vm.isWaiting || vm.summary.mode != 'TIMESERIES') {
			return;
		}

		// switch type
		vm.ts.dirty = true;
		vm.ts.prefs.type = vm.ts.type;
		vm.ts.prefs.subtype = vm.ts.subtype;

		// reset all data, load again
		tsReset();
		$timeout(function() {
			tsLoadData();
		}, 200);

	}

	function tsChangeInterval() {

		// switch the timeseries time interval
		// note: requires another data pull

		if(vm.isWaiting || vm.summary.mode != 'TIMESERIES') {
			return;
		}

		// switch interval
		vm.ts.dirty = true;
		vm.ts.prefs.interval = vm.ts.interval;
		tsReset();

		vm.ts.action = 'LOAD';

		$timeout(function() {
			tsLoadData();
		}, 200);

	}

	function tsChangeMetric() {

		// switch the timeseries metric, re-gen widget data

		if(vm.isWaiting || vm.summary.mode != 'TIMESERIES') {
			return;
		}

		var ts = vm.ts,
			rptType = vm.query.ReportType;

		// metric titles
		var colHeaders = vm.ts.colHeaders;
		colHeaders[0].title = 'Affiliation';

		// switch metric
		ts.dirty = true;
		ts.prefs.metric = ts.metric;
		var metricProp = ts.metric;

		// get details of this metric
		var metricInfo = tsGetMetricInfo(ts.metric);
		var metricFmt = metricInfo.fmt,
			metricSubtype = metricInfo.subtype;

		// SPLIT MATCH requires new data if metric is from another sub-type
		var subtypeSame = ts.subtype == metricSubtype;
		ts.subtype = metricSubtype;
		if(vm.query.ReportType == 'SPLITMATCH' && !subtypeSame) {
			tsLoadData();
			return;
		}

		// refresh widget table rows / chart series
		var widgetRows = [],
			dataRows = ts.data,
			row = {},
			dataSeries = [],
			metricVal = 0,
			cid = '';

		// create data rows for this metric
		// note: rows are objects so angular can use filter/sort
		for(var i = 0; i < dataRows.length; i++) {

			row = {
				id: dataRows[i].id,
				title: dataRows[i].title,
				selected: false
			};

			dataSeries = dataRows[i].series;
			for(var ii = 0; ii < dataSeries.length; ii++) {
				cid = colHeaders[ii+1].id;

				// metric value
				metricVal = dataSeries[ii][metricProp];
				if(typeof(metricVal) === 'undefined') {
					metricVal = 0;
				}
				row[cid] = metricVal;

				// metric format in text
				row[cid + 'txt'] = tsFormatMetricValue(metricVal, metricFmt);
			}

			widgetRows.push(row);
		}

		ts.action = 'SHOW';

		// notify widget to render
		var fltKey = ts.type + ts.interval;
		$scope.$broadcast('widget.timeseries', {
			data: {
				uniqueId: 'savings-series',
				interval: ts.interval,
				table: {
					show: true,
					colHeaders: colHeaders,
					rows: widgetRows,
					flt: ts.prefs.flt[fltKey]
				},
				chart: {
					show: true,
					id: 'savings-series-chart',
					config: {
						colors: appConst.app.color.chartBars($window.espuiPrefs.skin),
						xAxis: {
							showText: true
						},
						yAxis: {
							showText: true,
							format: metricFmt
						}
					}
				}
			}
		});

	}

	function tsFormatMetricValue(val, fmt) {

		// convert metric number into final text

		switch(fmt) {
			case 'currency':
				return  numberFmt(val, '0', '$', 2);
			case 'number':
				return numberFmt(val, '0', '', 2);
			case 'integer':
				return numberFmt(val, '0', '', 0);
			default:
				alert('metric format unknown: ' + fmt);
				return val;
		}
	}

	function tsLoadAggregate() {

		// derive timeseries widget dataset for aggregate totals
		// note: aggregate means total of all affiliations per property for each time period

		if(vm.isWaiting || vm.summary.mode != 'TIMESERIES' || vm.ts.type != 'AGGREGATE') {
			return;
		}

		var ts = vm.ts,
			tsSubtype = vm.ts.subtype,
			rptType = vm.query.ReportType;

		// aggregate titles
		var colHeaders = vm.ts.colHeaders;
		colHeaders[0].title = 'Line Item';

		ts.dirty = true;

		// refresh widget table rows / chart series
		var props = [],
			prop = {},
			propName = '',
			propVal = 0,
			widgetRows = [],
			row = {},
			dataSeries = [],
			cid = '';

		// check aggregate should have only 1 row
		if(ts.data.length !== 1) {
			alert('splitSaveCtl.tsLoadAggregate, data rows should be length 1 only');
			tsReset();
			vm.summary.mode = 'TOTALS';
			return;
		}
		dataSeries = ts.data[0].series;
		props = vm.tsMetricDroplist;

		// create widget info iterating selectable properties from drop down
		// note: rows are objects so angular can use filter/sort
		for(var i = 0; i < props.length; i++) {
			prop = props[i];

			// agg props have a sub-type, render props with the same sub-type chosen by user
			if(prop.subtype == tsSubtype) {
				propName = prop.value; // value in droplist is the viewmodel property name
				row = {
					id: propName,
					title: prop.label,
					selected: false
				};

				for(var ii = 0; ii < dataSeries.length; ii++) {
					cid = colHeaders[ii+1].id;

					// prop value
					propVal = dataSeries[ii][propName];
					if(typeof(propVal) === 'undefined') {
						propVal = 0;
					}
					row[cid] = propVal;

					// prop val format in text
					row[cid + 'txt'] = tsFormatMetricValue(propVal, prop.fmt);
				}

				widgetRows.push(row);
			}
		}

		ts.action = 'SHOW';

		// notify widget to render
		var fltKey = ts.type + ts.interval;
		$scope.$broadcast('widget.timeseries', {
			data: {
				uniqueId: 'savings-series',
				interval: ts.interval,
				table: {
					show: true,
					colHeaders: colHeaders,
					rows: widgetRows,
					flt: ts.prefs.flt[fltKey]
				},
				chart: {
					show: true,
					id: 'savings-series-chart',
					config: {
						colors: appConst.app.color.chartBars($window.espuiPrefs.skin),
						xAxis: {
							showText: true
						},
						yAxis: {
							showText: true,
							format: 'number'
						}
					}
				}
			}
		});

	}


	/**
	 *     SAVED REPORTS EVENT HANDLERS
	 */

	function evtSavedReportRemove(reports, removeId, currentId) {

		var result = {
			action: 'remove'
		};

		// find rpt by id
		var removeIdx = getSavedReportById(reports, removeId);
		if(removeIdx < 0) {
			msgSvc.ok('Saved Search Not Found', 'Id missing: ' + removeId);
			return {};
		}
		reports.splice(removeIdx, 1);

		if(validSvc.isText(currentId) && removeId != currentId) {
			result.id = currentId;
		}

		return result;

	}

	function evtSavedReportAdd(reports, rptName) {

		var result = {
			action: 'add'
		};

		// check if query is valid
		var ceVals = multiselectQueryVals(vm.CeMultiselect),
			rxVals = multiselectQueryVals(vm.RxMultiselect);

		if(!validSvc.isText(vm.reportTab) || !queryValid(ceVals, rxVals)) {
			msgSvc.ok('Cannot Add Saved Search', 'Check search settings');
			return {};
		}

		// pack up current query
		var rxALL = vm.RxMultiselect.vals[0] == 'ALL';
		var newRpt = {
			id: 'sr' + Date.now().toString(),
			name: rptName,
			ReportType: vm.query.ReportType,
			CE: ceVals,
			RX: rxALL ? ['ALL'] : rxVals,
			DateMode: vm.query.DateRangeMode
		};

		// keep dates? depends on date mode
		if(utilSvc.dt.dateModeKeepDates(newRpt.DateMode)) {
			newRpt.StartDate = vm.query.StartDate.val;
			newRpt.EndDate = vm.query.EndDate.val;
		}

		// add to report list, remember new rpt id
		reports.push(newRpt);
		result.id = newRpt.id;

		return result;

	}

	function evtSavedReportCurrent(reports, currentId) {

		var result = {
			action: 'current'
		};

		// find rpt by id
		var currentIdx = getSavedReportById(reports, currentId);
		if(currentIdx < 0) {
			msgSvc.ok('Saved Search Not Found', 'Id missing: ' + currentId);
			return {};
		}
		var currentRpt = reports[currentIdx];

		// re-init state
		queryChange();
		vm.init = true;

		// load up query from current
		_returnVisit = loadSavedQuery('sr', currentRpt.ReportType, currentRpt);
		vm.multiselectTitle(vm.CeMultiselect, true);
		vm.multiselectTitle(vm.RxMultiselect, true);

		if(_returnVisit) {
			result.id = currentId;
		}

		// reset date widget
		$timeout(function(){
			$scope.$broadcast('widget.input.date.range.mode', {uniqueId: 'queryDates', mode: vm.query.DateRangeMode, keepDates: _returnVisit});
		}, 300);

		return result;
	}

	function okSavedReportsToServer(r) {

		// load cache, add widget details
		_savedReports = getSavedReports(true);

		// refresh widget reports
		$scope.$broadcast('widget.savedreports', {
			action: 'reports',
			current: _savedReportPending.id,
			reports: _savedReports
		});

		_savedReportPending = {};

	}

	function errSavedReportsToServer(r) {
		if(!!r) {
			errSvc.warn('Api error user prefs Saved Reports', 'splitSaveCtl.errSavedReportsToServer', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *     SAVED REPORTS WIDGET DETAILS
	 */

	function savedReportWidgetDetailsFmt(rptType, ceList, rxList, dtMode, dtStart, dtEnd) {

		var result = [],
			lineTxt = '';

		// line 1: type, date
		lineTxt = rptType == 'SPLIT' ? 'Mixed Use' : 'Retail';
		lineTxt += ' - ';
		lineTxt += utilSvc.dt.dateModeText(vm.query.DateRangeList, dtMode, dtStart, dtEnd);
		result.push(lineTxt);

		// CE, RX
		lineTxt = 'Facility: ' + ceList.join(', ');
		if(ceList.length + rxList.length === 2) {
			lineTxt += ', ';
		}
		else {
			result.push(lineTxt);
			lineTxt = '';
		}
		lineTxt += rxList[0] == 'ALL' ? 'All Pharmacies' : 'Pharmacy: ' + rxList.join(', ');
		result.push(lineTxt);


		return result;

	}

	function savedReportFormatForWidgetDetails(reports) {

		// widget needs report details created for it
		// widget doesn't know the feature's specific query requirements

		var rpt = {},
			lineTxt = '';

		for(var i = 0; i < reports.length; i++) {
			rpt = reports[i];
			rpt.details = savedReportWidgetDetailsFmt(
				rpt.ReportType,
				rpt.CE,
				rpt.RX,
				rpt.DateMode,
				new Date(rpt.StartDate),
				new Date(rpt.EndDate)
			);
		}

		return reports;
	}


	/**
	 *     SAVED REPORTS HELPERS
	 */

	function getSavedReports(addWidgetDetails) {

		var vs = sessionRepo.get(srKey());
		if(!!vs && vs.version === srVersion()) { // ignore older versions
			var reports = Array.isArray(vs.reports) ? vs.reports : [];

			return !!addWidgetDetails ? savedReportFormatForWidgetDetails(reports) : reports;
		}

		return [];

	}

	function getSavedReportById(reports, id) {
		for(var i = 0; i < reports.length; i++) {
			if(reports[i].id == id) {
				return i;
			}
		}
		return -1;
	}

	function srKey() {
		return 'sr-splitsavings';
	}

	function srVersion() {
		return 1;
	}


	/**
	 *    EXCEL
	 *    get file from server
	 */

	function createExcel(isCompare) {

		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			msgSvc.ok('Cannot Create Excel', 'Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		vm.query.CE.vals = multiselectQueryVals(vm.CeMultiselect);
		vm.query.RX.vals = multiselectQueryVals(vm.RxMultiselect);

		// ASYNC Excel request (multiple entities or big date ranges)
		if(!!!isCompare && vm.query.onlySummary) {
			_pendingExcelFilename = 'ASYNC';
			reportRepo.createAsyncFile(asyncFileRequestVM(vm.query)).then(okServerExcel, errServerExcel);
			return;
		}
		
		//Verity-<CEID>-340BSavings-Retail-<YYYYMMDD>-<YYYYMMDD>-<Timestamp>.xlsx

		var xlType = 'SPLITSAVE';
		_pendingExcelFilename = 'Verity';

		if(vm.query.CE.vals.length > 0) {
			_pendingExcelFilename += '-' + vm.query.CE.vals[0];
		}
		if(vm.query.ReportType == 'SPLITMATCH') {
			_pendingExcelFilename += '-340BSavings-Retail-';
		} else {
			_pendingExcelFilename += '-340BSavings-MixedUse-';
		}
		if(isCompare) {
			_pendingExcelFilename += 'Compare-';
			xlType += '-COMPARE';
		}
		if(vm.query.ReportType == 'SPLITMATCH') {
			xlType += '-RETAIL';
		}

		_pendingExcelFilename += utilSvc.dt.toServerString(vm.query.StartDate.val, 'NONE') + '-' + utilSvc.dt.toServerString(vm.query.EndDate.val, 'NONE') + '-' + Date.now().toString() + '.xlsx';

		// dump memory before creating Excel
		reportRepo.destroyRX();
		reportRepo.destroyCE();
		$timeout(function() {
			// small delay for digest cycle to delete repo memory
			reportRepo.serverExcel(xlType, vm.query, _pendingExcelFilename).then(okServerExcel, errServerExcel);
		}, 300);


		function okServerExcel(binaryData) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			// async requests do not return a file
			if(_pendingExcelFilename == 'ASYNC') {
				_pendingExcelFilename = '';
				msgSvc.ok('Excel File Requested', 'Check the "Saved Files" link at top right to retrieve this Excel Workbook.');
				return;
			}

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Create Excel Error', 'splitSaveCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}


	/**
	 * 	ASYNC REPORTS
	 */

	function asyncFileRequestVM(q) {
		return {
			Context: {
				CEID: q.CE.vals,
				RXID: q.RX.vals
			},
			Params: {
				ReportType: q.ReportType == 'SPLIT' ? 'SPLIT_SAVINGS' : 'SPLITMATCH_SAVINGS',
				StartDate: q.StartDate.val,
				EndDate: q.EndDate.val
			}
		};
	}

	function toggleAsyncReports() {
		if(vm.isWaiting) {
			return;
		}
		vm.asyncReports.show = vm.asyncReports.show == 'yes' ? 'no' : 'yes';
		if(vm.asyncReports.show == 'yes') {
			$state.go('report.splitsavings.async-reports', {
				rptType: 'SPLIT_SAVINGS', // note this shows both report types in one list SPLIT and SPLITMATCH
				query: null
			}, {reload: 'report.splitsavings.async-reports'});
		}
	}
	

	/**
	 *    MULTISELECT HELPERS
	 */

	function multiselectRebuildSecondary(primary, secondary, affs, usingALL) {

		// rebuild secondary multiselect based on values in primary multiselect

		usingALL = !!usingALL;

		if(primary.vals.length < 1) {
			secondary.list = [];
			secondary.vals = [];
		}
		else {
			affs = primary.type == 'CE' ? utilSvc.aff.findCeList(affs, primary.vals) : utilSvc.aff.findRxList(affs, primary.vals);
			var secList = primary.type == 'CE' ? utilSvc.aff.rxList(affs) : utilSvc.aff.ceList(affs);
			var vals = secondary.vals,
				newVals = [];

			if(vals.length === 1 && vals[0] == 'ALL') {
				newVals = ['ALL'];
				usingALL = true;
			}
			else {
				// add new val only if it exists in new secList
				for(var i = 0; i < vals.length; i++) {
					if(secList.indexOf(vals[i]) > -1) {
						newVals.push(vals[i]);
					}
				}
			}

			// assign new check list
			if(usingALL && secList.length > 1) {
				secList.unshift('ALL');
			}
			if(secondary.type == 'RX') {
				secondary.list = vm.multiselectBuildRX(secList, false, affs);
			}
			else {
				secondary.list = vm.multiselectBuild(secList, false);
			}

			// assign vals
			if((!usingALL && secList.length === newVals.length) || (usingALL && ((newVals.length > 0 && newVals[0] == 'ALL') || secList.length - 1 === newVals.length))) {
				// all vals are checked
				secondary.vals = [];
				vm.multiselectClick(secondary, 'ALL');
			}
			else {
				vm.multiselectReturnVisit(secondary, '', newVals);
			}
		}

		// set RX title
		vm.multiselectTitle(secondary, true);

		return secondary;

	}

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if(vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		multiselect.flt = '';

		// don't bother with width if hiding
		if(multiselect.show) {
			multiselect.show = false;
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;

	}

	function multiselectMouseHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}

	function multiselectQueryVals(multiselect) {

		// unpack the vals multiselect into a list of entities to query

		var checklist = multiselect.list,
			vals = multiselect.vals;

		if(vals.length < 1) {
			return [];
		}
		else if(vals.length === 1 && vals[0] == 'ALL') {
			// using ALL checkbox, return all values except ALL checkbox
			var result = [],
				i = checklist[0].val == 'ALL' ? 1 : 0;
			for(i; i < checklist.length; i++) {
				result.push(checklist[i].val);
			}
			return result;
		}
		else {
			return vals;
		}
	}


	/**
	 *    HELPERS
	 */

	function numberFmt(val, zeroFmt, prefix, decPlaces) {

		// helper to format incoming number data

		// nan
		if(!validSvc.isNumber(val)) {
			return '';
		}

		// zero
		if(val === 0) {
			return zeroFmt;
		}

		return prefix + utilSvc.str.toText($filter('number')(val, decPlaces));

	}

	function numberFmtNoPrefix(val, zeroFmt, decPlaces) {

		// api controls the sign

		// nan
		if(!validSvc.isNumber(val)) {
			return '';
		}

		// prefix is only controled by value
		if(val < 0) {
			return numberFmt(Math.abs(val), zeroFmt,'-', decPlaces); // neg
		}
		else {
			return numberFmt(val, zeroFmt,'', decPlaces); // pos, no sign
		}
	}


	function saveViewState(tabName, query, flt, ceids, rxids, savedRptId) {

		if(tabName != 'SUMMARY') {
			_tabFilters[tabName] = flt;
		}

		sessionRepo.set('vs-report-splitsavings', {
			query: {
				ReportType: query.ReportType,
				CE: ceids,
				RX: rxids,
				DateRangeMode: query.DateRangeMode,
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val
			},
			tabFilters: _tabFilters,
			savedReport: validSvc.isText(savedRptId) ? savedRptId : ''
		});
	}

	function displayQuarter(dt) {

		// return Q1, Q2 text from incoming date

		if(!validSvc.isDate(dt)) {
			return '';
		}

		var qtrNum = Math.floor(dt.getMonth() / 3) + 1;
		return 'Q' + qtrNum + ' ' + dt.getFullYear().toString();

	}

	function displayQuarterMonths(dtStart, dtEnd, useUpperCase) {

		// return 'MMM through MMM' text for this quarter

		if(!validSvc.isDate(dtStart) || !validSvc.isDate(dtEnd)) {
			return '';
		}

		if(!!useUpperCase) {
			return utilSvc.dt.monthShortText(dtStart).toUpperCase() + ' through ' + utilSvc.dt.monthShortText(dtEnd).toUpperCase();
		}
		else {
			return utilSvc.dt.monthShortText(dtStart) + ' through ' + utilSvc.dt.monthShortText(dtEnd);
		}

	}

	function dateRangeIsCustom(dtMode) {
		return dtMode.indexOf('CUSTOM') > -1;
	}

}
 
reportUdsCtl.$inject = ['$scope', '$state', '$window', '$timeout', '$filter', 'reportRepo', 'lookupRepo', 'utilSvc', 'validSvc', 'msgSvc', 'errSvc', 'appConst'];
angular
.module('espui.report')
.controller('ReportUdsCtl', reportUdsCtl);

/* @ngInject */
function reportUdsCtl($scope, $state, $window, $timeout, $filter, reportRepo, lookupRepo, utilSvc, validSvc, msgSvc, errSvc, appConst) {

	var vm = this;
	var _featureName = '',
		 _mouseLeaveDelay = {},
		_ceRxOptions = [];

	// inherit
	utilSvc.ctl.addMultiselect(vm);
	msgSvc.addHelpLink(vm);

	// props
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';
	vm.showInactiveAffs = '';
	vm.popup = {};

	// query
	vm.query = {};
	vm.queryChangeCE = queryChangeCE;
	vm.queryChangeRX = queryChangeRX;
	vm.dateRangeChange = dateRangeChange;
	vm.querySubmit = querySubmit;
	vm.queryChangeInactiveAffs = queryChangeInactiveAffs;

	// multiselect / droplist
	vm.CeMultiselect = {};
	vm.RxMultiselect = {};
	vm.multiselectCeToggle = multiselectCeToggle;
	vm.multiselectRxToggle = multiselectRxToggle;
	vm.multiselectMouseHover = multiselectMouseHover;

	// query popup
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);

		vm.init = true;
		_featureName = 'report.uds';
		var queryAffs = initQuery();

		// ASYNC: build CE options, own use, etc
		getCeRxOptions(queryAffs);
	}

	function getAffs() {
		var findStatus = vm.showInactiveAffs == 'yes' ? ['ONBOARDING', 'ACTIVE', 'INACTIVE'] : ['ONBOARDING', 'ACTIVE'];
		var affs = utilSvc.aff.findStatus($scope.User.AffList, findStatus);
		affs = utilSvc.aff.findRxType(affs, ['DISPENSING', 'CENTRALFILL']);

		// per Georgia, we should be limiting affiliation options by business model
		affs = utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));

		return affs;
	}

	function initQuery() {

		vm.query = reportRepo.queryVM();

		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val) ? 'no' : 'yes';
		vm.query.RX.fail = validSvc.isRX(vm.query.RX.val) ? 'no' : 'yes';
		vm.query.CE.vals = [];
		vm.query.RX.vals = [];

		// date default
		vm.query.DateRangeValid = false;
		vm.query.DateRangeList = utilSvc.widget.dateRangeList(['CUSTOM92']);

		// add yearly options
		vm.query.DateRangeList.push({label: 'Last 12 Months', value: 'LTM'});
		vm.query.DateRangeList.push({label: 'Yearly', value: 'YEARLY'});
		vm.query.DateRangeList.push({label: 'Year To Date', value: 'YTD'});

		// unlimited custom range (move min validation dates to app start)
		// note: reportRepo does this by default but want to explicitly set it JIC repo changes in future
		var dtToday = new Date(),
			dtAppStart = utilSvc.dt.zeroTime(appConst.app.liveDate),
			customRangeDays = parseInt(utilSvc.dt.diffDays(dtAppStart, dtToday));
		vm.query.StartDate.min = dtAppStart;
		vm.query.EndDate.min = dtAppStart;
		vm.query.DateRangeList.push({label: 'Custom Date Range', value: 'CUSTOM' + customRangeDays.toString()});

		vm.query.DateRangeMode = 'MTD';

		// CE multiselect
		vm.CeMultiselect = {
			type: 'CE',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Facility',
			vals: [],
			list: [],
			flt: ''
		};

		// RX multiselect
		vm.RxMultiselect = {
			type: 'RX',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Pharmacy',
			vals: [],
			list: [],
			flt: ''
		};


		vm.showInactiveAffs = 'no';
		var affs = getAffs();

		var ceList = utilSvc.aff.ceList(affs);
		vm.CeMultiselect.list = vm.multiselectBuild(ceList, false);

		return affs;
	}

	function getCeRxOptions(affs) {
		// ASYNC: build rx affs list, ce own use, find any rx rollup parents

		_ceRxOptions = [];

		var uniqueOptions = [],
			aff = {};
		
		for(var i = 0; i < affs.length; i++) {
			aff = affs[i];

			// add aff
			_ceRxOptions.push({
				CEID: aff.CEID,
				RXID: aff.RXID,
				RxType: aff.RxType,
				RxShortName: aff.RxShortName + ' - ' + aff.RxType
			});

			// has rollup parent?
			if(validSvc.isText(aff.RxParent)) {

				// add unique CE / rollup aff options
				if(uniqueOptions.indexOf(aff.CEID + aff.RxParent) < 0) {
					uniqueOptions.push(aff.CEID + aff.RxParent);

					_ceRxOptions.push({
						CEID: aff.CEID,
						RXID: aff.RxParent,
						RxType: 'ROLLUP',
						RxShortName: '' // shortname filled in after lookup
					});
				}
			}
		}

		// lookup rx parents or finish CE
		var rxParents = utilSvc.aff.rxList(utilSvc.aff.findRxType(_ceRxOptions, ['ROLLUP']));
		if(rxParents.length < 1) {
			initFinalize();
		}
		else {
			// get rollup short names
			vm.isWaiting = true;
			lookupRepo.RxInfo(rxParents).then(okLookupRx, errLookupRx);
		}
	}

	function okLookupRx(items) {
		vm.isWaiting = false;
		items = Array.isArray(items) ? items : [];

		var rxid = '',
			ii = 0;

		// add short names to rollups
		for(var i = 0; i < _ceRxOptions.length; i++) {
			if(_ceRxOptions[i].RxType == 'ROLLUP') {
				rxid = _ceRxOptions[i].RXID;
				for(ii = 0; ii < items.length; ii++) {
					if(rxid == items[ii].NickName) {
						_ceRxOptions[i].RxShortName = items[ii].ShortName + ' - ROLLUP';
					}
				}
			}
		}

		initFinalize();
	}

	function errLookupRx(r) {
		vm.isWaiting = false;
		if(!!r) {
			errSvc.warn('Error loading rollup display properties', 'CE reportUdsCtl.errLookupRx', r.status, utilSvc.http.safeResponse(r));
		}
	}
	
	function initFinalize() {
		if(vm.query.CE.fail == 'no') {
			queryChangeCE(vm.query.CE.val);
		}
		else {
			vm.query.CE.fail = 'yes';
			vm.query.RX.fail = 'yes';
		}

		vm.multiselectTitle(vm.CeMultiselect, true);
		vm.multiselectTitle(vm.RxMultiselect, true);

		// fire date control event after widget is rendered
		$timeout(function() {
			$scope.$broadcast('widget.input.date.range.mode', {uniqueId: 'queryDates', mode: vm.query.DateRangeMode, keepDates: false});
		}, 200);
	}


	/**
	 *    QUERY CHANGE
	 */

	function queryChange() {
		if(!vm.init) {
			// no changes needed yet, query is in the popup with no table to hide
		}
	}

	function multiselectCeToggle(evt, id) {
		vm.RxMultiselect.show = false;
		multiselectToggle(evt, vm.CeMultiselect, id);
	}

	function multiselectRxToggle(evt, id) {
		vm.CeMultiselect.show = false;
		multiselectToggle(evt, vm.RxMultiselect, id);
	}

	function queryChangeCE(val) {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.multiselectClick(vm.CeMultiselect, val);
		vm.multiselectTitle(vm.CeMultiselect, true);

		vm.query.CE.fail = vm.CeMultiselect.vals.length < 1 ? 'yes' : 'no';

		// CE > RX
		if(vm.query.CE.fail == 'no') {
			vm.RxMultiselect = multiselectRebuildSecondary(vm.CeMultiselect, vm.RxMultiselect, _ceRxOptions, true);
			vm.query.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';
		}
	}

	function queryChangeRX(val) {
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.multiselectClick(vm.RxMultiselect, val);
		vm.multiselectTitle(vm.RxMultiselect, true);

		vm.query.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';
	}

	function queryChangeInactiveAffs() {
		// add or remove INACTIVE status affiliations from CE/RX droplists
		// note: so far this is only for CP Financial

		if(vm.isWaiting) {
			return;
		}
		queryChange();
		
		vm.showInactiveAffs = vm.showInactiveAffs == 'no' ? 'yes' : 'no';

		// rebuild CE/RX options all the way back to init
		var affs = getAffs();
		var ceList = utilSvc.aff.ceList(affs);
		vm.CeMultiselect.list = vm.multiselectBuild(ceList, false);
		getCeRxOptions(affs);
	}

	function dateRangeChange(uniqueId, dtMode, isValid) {
		queryChange();
		vm.query.DateRangeMode = dtMode;
		vm.query.DateRangeValid = isValid;

		if(vm.init) {
			// setup saved files widget (its always shown by default)
			$timeout(function(){
				$state.go('report.uds.async-reports', {
					rptType: 'UDS',
					query: null
				}, {reload: 'report.uds.async-reports'});	
			}, 300);
		}
		vm.init = false;
	}


	/**
	 *    QUERY: SUBMIT
	 */

	function queryValid(q, ceVals, rxVals) {

		q.CE.fail = ceVals.length < 1 ? 'yes' : 'no';
		q.RX.fail = rxVals.length < 1 ? 'yes' : 'no';

		return 	q.DateRangeValid && q.CE.fail == 'no' && q.RX.fail == 'no';
	}

	function querySubmit() {

		// validate
		var ceVals = multiselectQueryVals(vm.CeMultiselect),
			rxVals = multiselectQueryVals(vm.RxMultiselect);
		if(!queryValid(vm.query, ceVals, rxVals)) {
			if(!vm.init) {
				msgSvc.ok('Cannot Create File', 'Check values');
				return;
			}
		}

		if(vm.isWaiting) {
			return;
		}
		queryChange();

		// assign multi values
		vm.query.CE.vals = ceVals;
		vm.query.RX.vals = rxVals;
		
		// reset UI
		vm.action = '';
		vm.popup = {};
		wait(true);
		
		reportRepo.createAsyncFile(asyncFileRequestVM(vm.query)).then(okServerExcel, errServerExcel);
	}

	function asyncFileRequestVM(q) {
		return {
			Context: {
				CEID: q.CE.vals,
				RXID: q.RX.vals
			},
			Params: {
				ReportType: 'UDS',
				StartDate: q.StartDate.val,
				EndDate: q.EndDate.val
			}
		};
	}


	/**
	 *    EXCEL HELPERS
	 */

	function okServerExcel() {
		wait(false);
		msgSvc.ok('Excel File Requested', 'Click the REFRESH button to view file status for this Excel Workbook.');
	}

	function errServerExcel(r) {
		wait(false);
		if(!!r) {
			errSvc.warn('Create Excel Error', 'cpfin.ServerExcel', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    MULTISELECT HELPERS
	 */

	function multiselectRebuildSecondary(primary, secondary, affs, usingALL) {

		// rebuild secondary multiselect based on values in primary multiselect

		usingALL = !!usingALL;

		if(primary.vals.length < 1) {
			secondary.list = [];
			secondary.vals = [];
		}
		else {
			affs = primary.type == 'CE' ? utilSvc.aff.findCeList(affs, primary.vals) : utilSvc.aff.findRxList(affs, primary.vals);
			var secList = primary.type == 'CE' ? utilSvc.aff.rxList(affs) : utilSvc.aff.ceList(affs);
			var vals = secondary.vals,
				newVals = [];

			if(vals.length === 1 && vals[0] == 'ALL') {
				newVals = ['ALL'];
				usingALL = true;
			}
			else {
				// add new val only if it exists in new secList
				for(var i = 0; i < vals.length; i++) {
					if(secList.indexOf(vals[i]) > -1) {
						newVals.push(vals[i]);
					}
				}
			}

			// assign new check list
			if(usingALL && secList.length > 1) {
				secList.unshift('ALL');
			}
			if(secondary.type == 'RX') {
				secondary.list = vm.multiselectBuildRX(secList, false, affs);
			}
			else {
				secondary.list = vm.multiselectBuild(secList, false);
			}

			// assign vals
			if((!usingALL && secList.length === newVals.length) || (usingALL && ((newVals.length > 0 && newVals[0] == 'ALL') || secList.length - 1 === newVals.length))) {
				// all vals are checked
				secondary.vals = [];
				vm.multiselectClick(secondary, 'ALL');
			}
			else {
				vm.multiselectReturnVisit(secondary, '', newVals);
			}
		}

		// set RX title
		vm.multiselectTitle(secondary, true);

		return secondary;

	}

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if(vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		multiselect.flt = '';

		// don't bother with width if hiding
		if(multiselect.show) {
			multiselect.show = false;
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;

	}

	function multiselectMouseHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}

	function multiselectQueryVals(multiselect) {

		// unpack the vals multiselect into a list of entities to query

		var checklist = multiselect.list,
			vals = multiselect.vals;

		if(vals.length < 1) {
			return [];
		}
		else if(vals.length === 1 && vals[0] == 'ALL') {
			// using ALL checkbox, return all values except ALL checkbox
			var result = [],
				i = checklist[0].val == 'ALL' ? 1 : 0;
			for(i; i < checklist.length; i++) {
				result.push(checklist[i].val);
			}
			return result;
		}
		else {
			return vals;
		}
	}


	/**
	 *    QUERY POPUP
	 */

	function openPopup() {
		if(vm.isWaiting || vm.popup.ready == 'yes') {
			return;
		}

		vm.popup = {
			ready: 'no'
		};

		// wait for digest before showing
		$timeout(function() {
			vm.popup.ready = 'yes';
		}, 100);		
	}

	function closePopup() {
		vm.popup = {};
	}


	/**
	 *    HELPERS
	 */

	function wait(isOn) {
		vm.isWaiting = !!isOn;
		msgSvc.wait(!!isOn);   
	}
} 
unreplenishedCtl.$inject = ['$scope', '$state', '$window', '$timeout', 'reportRepo', 'lookupRepo', 'utilSvc', 'validSvc', 'msgSvc', 'errSvc'];angular
.module('espui.report')
.controller('UnreplenishedCtl', unreplenishedCtl);

/* @ngInject */
function unreplenishedCtl($scope, $state, $window, $timeout, reportRepo, lookupRepo, utilSvc, validSvc, msgSvc, errSvc) {

	// private props
	var _pendingExcelFilename = '',
		_featureName = '',
		_pagingEventListener = null,
		_mouseLeaveDelay = {},
		_progAdminVubAffs = [];

	var vm = this;

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addMultiselect(vm);
	utilSvc.ctl.addFlexTop(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';

	// droplists
	vm.RollupDroplist = [];
	vm.VenDroplist = [];
	vm.ProgAdminDroplist = [];

	// query
	vm.query = {};
	vm.queryChangeCE = queryChangeCE;
	vm.querySubmit = querySubmit;
	vm.dateRangeChange = dateRangeChange;
	vm.queryChangeReportType = queryChangeReportType;
	vm.queryChangeProgAdmin = queryChangeProgAdmin;
	vm.queryChangeRollup = queryChangeRollup;
	
	// tbl and filters
	vm.flt = {};
	vm.tbl = {};
	vm.filterChange = filterChange;
	vm.filterSwap = filterSwap;
	
	// excel
	vm.createExcel = createExcel;
	
	// multiselect
	vm.RxMultiselect = {};
	vm.multiselectRxClick = multiselectRxClick;
	vm.multiselectRxToggle = multiselectRxToggle;
	vm.multiselectMouseHover = multiselectMouseHover;

	// flex top
	vm.flex = {};
	vm.flexTopExpand = flexTopExpand;


	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {
		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		_featureName = $state.current.name;

		vm.init = true;
		vm.flex = vm.flexInit();
		initQueryAndFilters();

		// default to IND
		queryChangeReportType('IND');
		
		// fire date control event after widget scope is setup
		$timeout(function() {
			$scope.$broadcast('widget.input.date.range.mode', {mode: vm.query.DateRangeMode, keepDates: true});
		}, 100);
		
		// ASYNC: finalize lookups later so feature UI can render immediately
		vm.isWaiting = true; // set to true so nothing is changed during init ASYC loading
		$timeout(initAsyncLoader, 1000);
	}

	function getAffs() {
		var affs = utilSvc.aff.findStatus($scope.User.AffList);
		affs = utilSvc.aff.findRxModel(affs, utilSvc.aff.rxModelsByFeature(_featureName));		
		return affs;
	}

	function isVerityUser(usrType) {
		return usrType == 'VERITY' || usrType == 'VERITYSA';
	}

	function initQueryAndFilters() {

		vm.query = reportRepo.queryBillingVM();
		vm.query.isVerity = isVerityUser(vm.query.UserType) ? 'yes' : 'no';
		vm.query.ReportType = '';
		vm.query.ProgramAdmin = validSvc.newProp('NONE');
		vm.query.Vendor = validSvc.newProp('NONE');
		vm.query.Specialty = validSvc.newProp('');
		vm.query.NDC = validSvc.newProp('');
		vm.query.CE.val = "NONE";
		vm.query.RX.vals = [];

		// not using viewstate (confirmed with Julie this is overkill for this feature)
		vm.flt = vm.initFilters({
			Config: {
				Dates: ['OrderDate'],
				DateFmt: 'M/d/yyyy'
			},
			SortBy: ['-OrderDate']
		});

		// date default
		vm.query.DateRangeValid = false;
		vm.query.DateRangeList = utilSvc.widget.dateRangeList([]);
		vm.query.DateRangeMode = 'MTD';

		// RX multiselect
		var affs = getAffs();
		var rxList = utilSvc.aff.rxList(affs);
		vm.RxMultiselect = {
			type: 'RX',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Pharmacy',
			vals: [],
			list: vm.multiselectBuild(rxList, false),
			flt: ''
		};

		// reset all query validation, ReportType change event will load these as needed
		resetQueryState();

		// build Prog Admin list from user's affiliation list, this ensures they do not get access to a Prog Admin on an affiliation they do not have access to
		vm.ProgAdminDroplist = progAdminsWithVHubDroplist(affs, vm.query.UserType);

		// note: the rest of query will load after ROLLUP
		// see initAsyncLoader() for ASYNC loading
	}

	function progAdminsWithVHubDroplist(affs, usrType) {
		// cache a list of affiliations with both a ProgAdmin and VHUB, return ProgAdmin droplist
		_progAdminVubAffs = [];

		for(var i = 0; i < affs.length; i++) {
			if(!!affs[i].RxVHUB && validSvc.isText(affs[i].ProgAdmin)) {
				_progAdminVubAffs.push(affs[i]);
			}
		}

		if(_progAdminVubAffs.length > 0) {
			return utilSvc.ng.droplist(utilSvc.aff.progAdminList(_progAdminVubAffs), '', '', [{label:'Choose a Program Admin', value:'NONE'}]);
		}
		else {
			return [];
		}
	}

	function initAsyncLoader() {
		// ASYNC loading of ROLLUP OPTIONS after UI has rendered so router is not hung up waiting for init
		var rollups = utilSvc.aff.findRxType($scope.User.AffList, ['ROLLUP']);
		var addrollups = utilSvc.aff.rxParentList($scope.User.AffList);
		var totalrollups = utilSvc.aff.rxList(rollups);
		for(var i = 0; i < addrollups.length; i++) {
			if(totalrollups.indexOf(addrollups[i]) < 0) {
				totalrollups.push(addrollups[i]);
			}
		}
		if(totalrollups.length > 0) {
			loadRollupDisplay(totalrollups);
		}
		else {
			finalizeInit();
		}
	}

	function loadRollupDisplay(rollups) {
		// ASYNC routine to get RX short names

		lookupRepo.RxInfo(rollups).then(okLookupRx, errInitLoad);

		function okLookupRx(items) {

			// save rollup affs array
			var rollupAffs = [];
			items = Array.isArray(items) ? items : [];
			if(items.length > 0) {
				for(var i = 0; i < items.length; i++) {
					rollupAffs.push({
						RXID:items[i].NickName,
						RxName: items[i].Name,
						RxShortName: items[i].ShortName
					});
				}

				vm.RollupDroplist = utilSvc.aff.rxDroplist(rollupAffs);
				vm.query.UserHasRxRollup = true;
			}

			finalizeInit();
		}
	}

	function errInitLoad(r) {
		if (!!r) {
			errSvc.warn('uninvoicedItemsCtl.errInitLoad, issue loading TPA and ROLLUP details', r.status, utilSvc.http.safeResponse(r));
		}
	}

	function finalizeInit() {
		// all ASYNC loads complete, enable UI
		vm.isWaiting = false;
		vm.init = false;
	}


	/**
	 *    DISPLAY VM
	 */

	function displayVM(dataItems, tooMany) {

		// convert data into display view model

		dataItems = Array.isArray(dataItems) ? dataItems : [];

		// clean up incoming data
		var item = {};
		for(var i = 0; i < dataItems.length; i++) {
			item = dataItems[i];
			item.Invoiced = (!!item.Invoiced ? "YES" : "NO");
			item.Specialty = (!!item.Specialty ? "YES" : "NO");
			item.uniqueId = i;
		}

		return {
			Items: [],
			DataItems: dataItems,
			TooMany: !!tooMany
		};

	}


	/**
	 *    QUERY CHANGE
	 */

	function resetQueryState() {
		vm.query.CE = validSvc.newProp('NONE');
		vm.query.RX = validSvc.newProp('NONE');
		vm.query.RxRollup = validSvc.newProp('NONE');
		vm.query.Vendor = validSvc.newProp('NONE');
		vm.query.ProgramAdmin = validSvc.newProp('NONE');
	}

	function queryChangeReportType(rptType) {

		// don't allow query changes during a load event
		if(vm.isWaiting) {
			return;
		}

		vm.query.ReportType = rptType;
		resetQueryState();

		switch(rptType) {
			case 'IND': // RX -> CE, reset RX options
				var rxList = utilSvc.aff.rxList(getAffs());
				if(rxList.length > 1) {
					rxList.unshift('ALL');
				}
				vm.RxMultiselect.list = vm.multiselectBuild(rxList, false);
				multiselectRxClick('|CLEAR|');
				break;
			case 'CE': // CE -> RX
				vm.CeDroplist = utilSvc.aff.ceDroplist(getAffs()); // use NONE (default)
				queryChangeCE();
				break;
			case 'ROLLUP': // ROLLUP -> PROG ADMIN
				// note: ROLLUP droplist is set once on init, don't change it
				queryChangeRollup();
				break;
			case 'PROGADMIN': // PROG ADMIN -> RX
				queryChangeProgAdmin();
				break;
			default:
				throw new Error('unreplenished.queryChangeReportType, unknown type: ' + rptType);
		}
	}

	function queryChange(keepSearchOptions) {
		vm.query.title = '';

		if(!vm.init) {
			vm.action = '';
			vm.tbl = {};
			vm.flt = vm.resetFilters(vm.flt);
			vm.dtPickShow = false;
			vm.flex = vm.flexInit();
			$scope.$broadcast('widget.paging');

			//reset search options
			if(!!!keepSearchOptions) {
				vm.query.title = '';
				vm.VenDroplist = utilSvc.ng.droplistNONE();
				vm.query.Vendor = validSvc.newProp('NONE');
				vm.query.Vendor.chk = false;
				vm.query.Specialty = validSvc.newProp('');
				vm.query.Specialty.chk = false;
				vm.query.NDC = validSvc.newProp('');
				vm.query.NDC.chk = false;
			}
		}
	}

	function dateRangeChange(dtMode, isValid) {

		vm.query.DateRangeMode = dtMode;
		vm.query.DateRangeValid = isValid;

		// protect async init loading, do not fire queryChange until init is done, see finalizeInit()
		if(!vm.init && !vm.isWaiting) {
			queryChange();
		}
	}

	function multiselectRxClick(val) {
		// 3 report type scenarios
		// IND: RX validate first will reset CE Droplist (must be selected, no ALL option)
		// CE: RX validate second after CE (must be ALL or specific)
		// PROGADMIN: RX validate second after prog admin (must be NONE or specific)

		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.multiselectClick(vm.RxMultiselect, val);
		vm.multiselectTitle(vm.RxMultiselect, true);
		vm.query.RX = validSvc.newProp('NONE');
		vm.query.RX.vals = multiselectQueryVals(vm.RxMultiselect); // convert checkmarks and ALL value into RXIDs array

		// RX required for any report type
		if(vm.query.RX.vals.length < 1) {
			vm.query.RX.fail = 'yes';
			return;
		}

		// rebuild dependent controls based on RX values
		var affs = utilSvc.aff.findRxList(getAffs(), vm.query.RX.vals);
		
		switch(vm.query.ReportType) {
			case 'IND':
				// IND RX first will rebuild CE dependent
				vm.query.CE = validSvc.newProp('ALL');
				vm.CeDroplist = utilSvc.aff.ceDroplist(affs, null, false, true); // use ALL
				queryChangeCE();
				break;
			case 'CE':
				// CE -> RX second will rebuild Vendor search option
				affs = utilSvc.aff.findCe(affs, vm.query.CE.val);
				vm.VenDroplist = utilSvc.ng.droplist(utilSvc.aff.venList(affs, ['340B', 'GPO', 'WAC', 'WACMED', 'OWNUSE', 'IND'], true), '', '', [{label:'Choose a Vendor', value:'NONE'}]);
				break;
			case 'PROGADMIN':
				// PROG ADMIN -> RX second will rebuild Vendor search option
				affs = utilSvc.aff.findProgAdmin(affs, vm.query.ProgramAdmin.val);
				vm.VenDroplist = utilSvc.ng.droplist(utilSvc.aff.venList(affs, ['340B', 'GPO', 'WAC', 'WACMED', 'OWNUSE', 'IND'], true), '', '', [{label:'Choose a Vendor', value:'NONE'}]);
				break;
			default:
				throw new Error('unreplenishedCtl.multiselectRxClick, report type unknown: ' + vm.query.ReportType);
		}	
	}

	function queryChangeRollup() {
		// report type: ROLLUP -> affects PROG ADMIN
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.query.RxRollup.fail = validSvc.isRX(vm.query.RxRollup.val) ? 'no' : 'yes';
		vm.query.RX.fail = 'no';

		// reset Prog Admin dependent (Julie is ok we don't need a custom Prog Admin list for each ROLLUP choice, just reset the value)
		vm.query.ProgramAdmin = validSvc.newProp('NONE');

		// set vendor search options: get affilitions with this RxParent (ROLLUP parent)
		if(vm.query.RxRollup.fail == 'no') {
			var affs = utilSvc.aff.findRxParent(getAffs(), vm.query.RxRollup.val);
			vm.VenDroplist = utilSvc.ng.droplist(utilSvc.aff.venList(affs, ['340B', 'GPO', 'WAC', 'WACMED', 'OWNUSE', 'IND'], true), '', '', [{label:'Choose a Vendor', value:'NONE'}]);
		}
	}

	function queryChangeCE() {
				// jksjdfiowejksdf
		// 2 report type scenarios:
		// CE: CE first rebuilds RX options
		// IND: CE second rebuilds Vendor options
		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.query.CE.fail = validSvc.isCE(vm.query.CE.val, false, true) ? 'no' : 'yes'; // ALL allowed for IND
		if(vm.query.CE.fail == 'yes') {
			return;
		}
		
		// rebuild dependents
		var affs = getAffs();

		switch(vm.query.ReportType) {
			case 'CE':
				// CE change rebuilds RX multiselect options, default to ALL per Julie
				affs = utilSvc.aff.findCe(affs,vm.query.CE.val);
				var rxList = utilSvc.aff.rxList(affs);
				rxList.unshift('ALL');
				vm.RxMultiselect.list = vm.multiselectBuild(rxList, false);
				multiselectRxClick('ALL');
				break;
			case 'IND':
				// CE second rebuilds vendors
				affs = utilSvc.aff.findRxList(affs, vm.query.RX.vals);
				affs = vm.query.CE.val == 'ALL' ? affs : utilSvc.aff.findCe(affs,vm.query.CE.val);				
				vm.VenDroplist = utilSvc.ng.droplist(utilSvc.aff.venList(affs, ['340B', 'GPO', 'WAC', 'WACMED'], true), '', '', [{label:'Choose a Vendor', value:'NONE'}]);
				break;
			default:
				throw new Error('unreplenishedCtl.queryChangeCE, report type unknown: ' + vm.query.ReportType);
		}
	}

	function queryChangeProgAdmin() {
		// 2 report type scenarios:
		// PROGADMIN: prog admin first then RX (optional)
		// ROLLUP: rollup first then prog admin
		if(vm.isWaiting) {
			return;
		}
		queryChange();
		
		switch(vm.query.ReportType) {
			case 'PROGADMIN':
				vm.query.ProgramAdmin.fail = vm.query.ProgramAdmin.val == 'NONE' ? 'yes' : 'no';
		
				// reset RX dependents
				if(vm.query.ProgramAdmin.fail == 'no') {
					var rxAffs = utilSvc.aff.findProgAdmin(_progAdminVubAffs, vm.query.ProgramAdmin.val);
					var rxList = utilSvc.aff.rxList(rxAffs);
					rxList.unshift('ALL');
					vm.RxMultiselect.list = vm.multiselectBuild(rxList, false);
					multiselectRxClick('ALL');
				}
				break;
			case 'ROLLUP':
				// prog admin is optional, rx is not needed
				vm.query.ProgramAdmin.fail = 'no';
				var affs = utilSvc.aff.findRxParent(getAffs(), vm.query.RxRollup.val);
				vm.VenDroplist = utilSvc.ng.droplist(utilSvc.aff.venList(affs, ['340B', 'GPO', 'WAC', 'WACMED', 'OWNUSE', 'IND'], true), '', '', [{label:'Choose a Vendor', value:'NONE'}]);	
				break;
			default:
				throw new Error('unreplenishedCtl.queryChangeProgAdmin, unknown report type: ' + vm.query.ReportType);
		}
	}


	/**
	 * 	FILTER SWAP / FLEX TOP
	 */

	function filterSwap() {
		if(vm.isWaiting) {
			return;
		}

		// toggle between IND and CE
		if (vm.query.ReportType == 'CE') {
			queryChangeReportType('IND');
		}
		else {
			queryChangeReportType('CE');
		}
	}

	function flexTopExpand() {

		// user opened search query, reset list display, show search expanded
		queryChange(true);

	}	

	/**
	 *    GLOBAL GREASE FILTER
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

		}, delayTime);

	}


	/**
	 *    QUERY SUBMIT
	 */

	function queryValid(q) {

		switch (q.ReportType) {
			case 'IND':
			case 'CE':
				q.RX.fail = q.RX.vals.length < 1 ? 'yes' : 'no';
				q.CE.fail = validSvc.isCE(q.CE.val, false, true) ? 'no' : 'yes'; // ALL OK
				break;
			case 'ROLLUP':
				q.RxRollup.fail = validSvc.isRX(q.RxRollup.val) ? 'no' : 'yes';
				q.RX.fail = 'no';
				q.ProgramAdmin.fail = 'no'; // its optional
				break;
			case 'PROGADMIN':
				q.ProgramAdmin.fail = q.ProgramAdmin.val == 'NONE' ? 'yes' : 'no';
				q.RX.fail = q.RX.vals.length < 1 ? 'yes' : 'no'; // something must be selected
				break;
			default:
				throw new Error('unreplenishedCtl.queryValid, unknown report type: ' + q.ReportType);
		}

		// search options
		q.Vendor.fail = 'no';
		if(q.Vendor.chk) {
			q.Vendor.fail = validSvc.isVEN(q.Vendor.val) ? 'no' : 'yes';
		}
		q.Specialty.fail = 'no';
		if(q.Specialty.chk && q.Specialty.val != 'YES' && q.Specialty.val != 'NO') {
			q.Specialty.fail = 'yes';
		}
		q.NDC.fail = 'no';
		if(q.NDC.chk) {
			// ndc format check
			var ndcValidate = ndcCleanUp(q.NDC.val, false);
			if(ndcValidate.fail) {
				q.NDC.fail = 'yes';
				q.NDC.msg = ndcValidate.msg;
			}
			else {
				q.NDC.val = ndcValidate.val;
			}
		}

		return (
			q.DateRangeValid &&
			q.CE.fail != 'yes' &&
			q.RX.fail != 'yes' &&
			q.RxRollup.fail != 'yes' &&
			q.ProgramAdmin.fail != 'yes' &&
			q.Vendor.fail != 'yes' &&
			q.NDC.fail != 'yes' &&
			q.Specialty.fail != 'yes'
		);
	}

	function querySubmit() {
		if(vm.isWaiting) {
			return;
		}

		// validate
		if(!queryValid(vm.query)) {
			msgSvc.ok('Search', 'Check filter settings');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		queryChange(true);

		// search options: only send checked fields
		vm.query.Vendor.val = vm.query.Vendor.chk ? vm.query.Vendor.val : "NONE";
		vm.query.NDC.val = vm.query.NDC.chk ? vm.query.NDC.val : "";
		vm.query.Specialty.val = vm.query.Specialty.chk ? vm.query.Specialty.val : "";

		reportRepo.getUnreplenished(vm.query).then(okData, errData);

		function okData(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			vm.tbl = displayVM(r.data, r.TooMany);
			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);

			// update paging ui
			$scope.$broadcast('widget.paging', {
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			vm.flt.Ready = true;
			vm.action = 'LIST';

			// force top collapse after good query
			vm.query.title = queryTitle();
			vm.flex = vm.flexCollapse(vm.flex, true);

		}

		function errData(r) {

			vm.isWaiting = false;

			if(r == null) {
				return;
			}

			if (!!r && r.status == 422) {
				// validation
				vm.query = r.model;
				msgSvc.ok('Search failed', 'Check filter settings');
			}
			else {
				errSvc.error('Bad search response', 'unreplenished.errSearch', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}

	/**
	 *    EXCEL
	 *    get file from server
	 */

	function createExcel() {

		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);
		var type = "";
		switch(vm.query.ReportType) {
			case 'IND': 
			    type = vm.query.RX.vals[0];
				break;
			case 'ROLLUP': 
				type = vm.query.RxRollup.val;
				break;
			case 'PROGADMIN':
				type = utilSvc.ng.droplistLabel(vm.ProgAdminDroplist, vm.query.ProgramAdmin.val);
				break;
			default:
				type = "" ;
		}
		// var rxid = vm.query.ReportType == 'IND' ? vm.query.RX.vals[0] : vm.query.RxRollup.val;
		_pendingExcelFilename = 'Verity-' + type + '-Unreplenished-' + utilSvc.dt.monthShortText(vm.query.StartDate.val) + vm.query.StartDate.val.getFullYear().toString() + '.xlsx';
		reportRepo.serverExcel('UNREPLENISHED', vm.query, _pendingExcelFilename).then(okServerExcel, errServerExcel);

		function okServerExcel(binaryData) {

			vm.isWaiting = false;
			msgSvc.wait(false);

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

		}

		function errServerExcel(r) {

			vm.isWaiting = false;
			msgSvc.wait(false);

			if(r !== null) {
				r = r || {};
				errSvc.warn('Create Excel Error', 'unreplenishedCtl.errServerExcel', r.status, utilSvc.http.safeResponse(r));
			}

		}

	}

	/**
	 *    MULTISELECT HELPERS
	 */

	 function multiselectRxToggle(evt, id) {
		multiselectToggle(evt, vm.RxMultiselect, id);
	}

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if(vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		multiselect.flt = '';

		// don't bother with width if hiding
		if(multiselect.show) {
			multiselect.show = false;
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;

	}

	function multiselectMouseHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}

	function multiselectQueryVals(multiselect) {

		// unpack the vals multiselect into a list of entities to query

		var checklist = multiselect.list,
			vals = multiselect.vals;

		if(vals.length < 1) {
			return [];
		}
		else if(vals.length === 1 && vals[0] == 'ALL') {
			// using ALL checkbox, return all values except ALL checkbox
			var result = [],
				i = checklist[0].val == 'ALL' ? 1 : 0;
			for(i; i < checklist.length; i++) {
				result.push(checklist[i].val);
			}
			return result;
		}
		else {
			return vals;
		}
	}


	//	HELPERS
	function ndcCleanUp(val, skipEmpty) {

		var zeroPad = "00000000000",
			ndcTest = '';

		// must be text
		if(!!!skipEmpty && !validSvc.isText(val)) {
			return validSvc.newProp(val, true, 'required');
		}

		// remove all non-numeric characters
		ndcTest = val.toString().trim();
		ndcTest = ndcTest.replace(/[^0-9]+/g,'');

		// empty
		if(ndcTest.length < 1) {
			if(!!skipEmpty) {
				return validSvc.newProp('', false, '');
			}
			else {
				return validSvc.newProp(ndcTest, true, 'empty');
			}
		}

		// max len
		if(ndcTest.length > 11) {
			return validSvc.newProp(ndcTest, true, 'max 11 characters');
		}

		// integer
		var intVal = parseInt(ndcTest);
		if(!validSvc.isInteger(intVal)) {
			return validSvc.newProp(ndcTest, true, 'must be an integer');
		}

		// all zeros
		if(intVal <= 0) {
			return validSvc.newProp(ndcTest, true, 'cannot be zero');
		}

		// pad zeros if needed, pass
		ndcTest = zeroPad.substr(0, 11 - ndcTest.length) + ndcTest;
		return validSvc.newProp(ndcTest, false, '');
	}

	function queryTitle() {
		// helper to generate query title when flextop closed
		
		var title = '';

		// CE/RX titles to handle ALL value or NONE
		var ceTitle = vm.query.CE.val == 'ALL' ? 'All Facilities' : vm.query.CE.val;
		var rxTitle = vm.RxMultiselect.title;
		if(vm.RxMultiselect.vals.length > 1) {
			rxTitle = 'Pharmacy: ' + rxTitle;
		}
		else if(vm.RxMultiselect.vals[0] == 'ALL') {
			rxTitle = 'ALL Pharmacies'; 
		}
		
		switch(vm.query.ReportType) {
			case 'IND':
				return rxTitle + ' / ' + ceTitle;
			case 'CE':
				return ceTitle + ' / ' + rxTitle;
			case 'ROLLUP':
				title = 'Rollup: ' + vm.query.RxRollup.val;
				if(vm.query.ProgramAdmin.val != 'NONE') {
					title += ' / ' + utilSvc.ng.droplistLabel(vm.ProgAdminDroplist, vm.query.ProgramAdmin.val);
				}
				return title;
			case 'PROGADMIN':
				return 'Program Admin: ' + utilSvc.ng.droplistLabel(vm.ProgAdminDroplist, vm.query.ProgramAdmin.val) + ' / ' + rxTitle;
			default:
				throw new Error('unreplenishedCtl.queryTitle, unknown Report Type: ' + vm.query.ReportType);
		}
	}

}
 
wacNeutCtl.$inject = ['$window', '$state', '$scope', '$timeout', '$filter', 'reportRepo', 'sessionRepo', 'validSvc', 'utilSvc', 'errSvc', 'msgSvc'];
angular
.module('espui.report')
.controller('WacNeutCtl', wacNeutCtl);


/* @ngInject */
function wacNeutCtl($window, $state, $scope, $timeout, $filter, reportRepo, sessionRepo, validSvc, utilSvc, errSvc, msgSvc) {

	/*jshint validthis: true */
	var vm = this,
		_pendingExcelFilename = '',
		_returnVisit = false,
		_featureName = '',
		_pagingEventListener = null,
		_tabFilters = {},
		_mouseLeaveDelay = {},
		_dcAffs = [];

	// inherit
	utilSvc.ctl.addSorting(vm);
	utilSvc.ctl.addPaging(vm);
	utilSvc.ctl.addFiltering(vm);
	utilSvc.ctl.addMultiselect(vm);
	msgSvc.addHelpLink(vm);

	// properties
	vm.init = true;
	vm.isWaiting = false;
	vm.action = '';

	// tabs
	vm.reportTab = '';
	vm.tabChange = tabChange; 

	// query
	vm.query = {};
	vm.queryChangeDC = queryChangeDC;
	vm.queryChangeCE = queryChangeCE;
	vm.queryChangeRX = queryChangeRX;
	vm.dateRangeChange = dateRangeChange;
	vm.queryChangeDateType = queryChangeDateType;

	// table and filters
	vm.tbl = {};
	vm.flt = {};
	vm.filterChange = filterChange;

	// droplist / multiselect
	vm.DcDroplist = [];
	vm.DateTypeDroplist = [];
	vm.CeMultiselect = {};
	vm.RxMultiselect = {};
	vm.multiselectCeToggle = multiselectCeToggle;
	vm.multiselectRxToggle = multiselectRxToggle;
	vm.multiselectMouseHover = multiselectMouseHover;

	vm.getExcel = getExcel;

	// edit
	vm.model = {};
	vm.openPopup = openPopup;
	vm.closePopup = closePopup;
	vm.submit = submit;

	/**
	 *    PAGING EVENT
	 */

	_pagingEventListener = $scope.$on('widget.paging.change', function(event, evtData) {
		event.stopPropagation();

		// exit if table is gone
		if(!vm.flt.Ready || !Array.isArray(vm.tbl.Items) || vm.tbl.Items.length < 1) {
			return;
		}

		// adjust Page or PageSize property
		vm.flt[evtData.propName] = parseInt(evtData.value);
		filterChange(true);

	});

	$scope.$on('$destroy', function() {
		// clean up listener on destroy
		if(!!_pagingEventListener) {
			_pagingEventListener();
		}
	});


	/**
	 *    INIT
	 */

	init();

	function init() {

		// main title
		$scope.$emit('shared.main.setInfo', $state.current.routeInfo);
		_featureName = $state.current.name;

		vm.init = true;
		vm.reportTab = 'SUMMARY';

		initQueryAndFilters();

		// CDC user? (user has 1 or more direct affiliations to a CDC)
		if(vm.query.CdcUser) {
			getWacneutAffs();
		}
		else {
			initFinalize();
		}

	}

	function initFinalize() {

		_returnVisit = applyViewState();

		// date change event checks for return visit
		$timeout(function() {
			$scope.$broadcast('widget.input.date.range.mode', {mode: vm.query.DateRangeMode, keepDates: true});
		}, 100);

	}

	function getDcAffs() {

		// find affs with a pharmacy which is a CDC

		var result = [],
			affs = $scope.User.AffList;

		for(var i = 0; i < affs.length; i++) {

			// pharmacy is a CDC
			if(!!affs[i].RxCDC) {
				result.push(affs[i]);
			}
		}

		return result;
	}

	function getAffsByDcPharmacy(affs, dcid) {

		var result = [];

		for(var i = 0; i < affs.length; i++) {
			if(affs[i].CdcPharmacy == dcid) {
				result.push(affs[i]);
			}
		}

		return result;
	}

	function getDcListFromAffs() {

		// build list of Dc pharmacies

		var result = [],
			affs = $scope.User.AffList,
			aff = {};

		for(var i = 0; i < affs.length; i++) {
			aff = affs[i];

			// wacneut aff points at CDC
			if(!!aff.AffWacNeut && validSvc.isText(aff.CdcPharmacy) && result.indexOf(aff.CdcPharmacy) < 0) {
				result.push(aff.CdcPharmacy);
			}
		}

		return result;
	}

	function initQueryAndFilters() {

		vm.query = reportRepo.queryVM();
		vm.query.DC = validSvc.newProp('NONE');
		vm.query.DC.fail = 'yes';

		vm.query.CE.vals = [];
		vm.query.RX.vals = [];
		vm.query.multi = false;

		_tabFilters = {
			SUMMARY: vm.initFilters({
				SortBy: ['ItemCode']
			}),
			DETAIL: vm.initFilters({
				Config: {
					Dates: ['TransDate'],
					DateFmt: 'M/d/yyyy'
				},
				HideSection: {
					Drug: false,
					Inv: true,
					Ven: true,
					Tot: false
				},
				SortBy: ['-TransDate']
			}),
			PACK: vm.initFilters({
				Config: {
					Dates: ['TransDate'],
					DateFmt: 'M/d/yyyy'
				},
				SortBy: ['ItemCode']
			})
		};

		// date default
		vm.query.DateRangeValid = false;
		vm.query.DateRangeList = utilSvc.widget.dateRangeList([]);
		vm.query.DateRangeMode = 'MTD';
    	vm.query.DateType = "TRANSACTION";

		// CDC user? (user has affiliations with a CDC pharmacy)
		var dcAffs = getDcAffs();
		vm.query.CdcUser = dcAffs.length > 0;
		if(vm.query.CdcUser) {
			vm.DcDroplist = utilSvc.aff.rxDroplist(dcAffs);
		}
		else {
			// user has no direct CDC affiliations, they should have an aff pointing at a CDC
			dcAffs = getDcListFromAffs();
			if(dcAffs.length < 1) {
				throw new Error('wacneutCtl.init, user has no direct CDC or wacneut affiliations');
			}
			vm.DcDroplist = utilSvc.ng.droplist(dcAffs, '', '',[{label:'Choose a Pharmacy', value: 'NONE'}]);
		}

		// multiselects for CE, RX
		vm.CeMultiselect = {
			type: 'CE',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Facility',
			vals: [],
			list: [],
			flt: ''
		};
		vm.RxMultiselect = {
			type: 'RX',
			show: false,
			dirty: false,
			focus: 'OPTIONS',
			title: '',
			titleNoOptions: 'Choose a Pharmacy',
			vals: [],
			list: [],
			flt: ''
		};
    	vm.DateTypeDroplist = [
			{label: 'Transaction Date', value: 'TRANSACTION'},
			{label: 'Extract Date', value: 'EXTRACT'},
		];


	}

	function applyViewState() {

		// get viewstate
		var returnVisit = false,
		vs = sessionRepo.get('vs-report-wacneut');
		if(!!vs) {

			var q = vm.query,
				vsq = vs.query;

			q.DC.val = vsq.DC;
			q.DC.fail = validSvc.isRX(q.DC.val) ? 'no' : 'yes';
			if(q.DC.fail == 'no') {

				// load dc affs for non-CDC user
				if(!vm.query.CdcUser) {
					_dcAffs = getAffsByDcPharmacy($scope.User.AffList, vm.query.DC.val);
				}
				var affs = getAffsByDcPharmacy(_dcAffs, vsq.DC);

				var ceList = utilSvc.aff.ceList(affs);
				ceList.unshift('ALL');
				vm.CeMultiselect.list = vm.multiselectBuild(ceList, false);
				vm.multiselectReturnVisit(vm.CeMultiselect, '', vsq.CE);
				vm.multiselectClick(vm.CeMultiselect, ''); // click event will change all checked to ALL value
				vm.multiselectTitle(vm.CeMultiselect);

				vm.RxMultiselect.vals = vsq.RX;
				vm.RxMultiselect = multiselectRebuildSecondary(vm.CeMultiselect, vm.RxMultiselect, affs, true);

				q.CE.fail = vm.CeMultiselect.vals.length < 1 ? 'yes' : 'no';
				q.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';
				if(q.CE.fail == 'no' && q.RX.fail == 'no') {
					returnVisit = true;

					vm.reportTab = vs.reportTab;

					q.StartDate.val = new Date(vsq.StartDate);
					q.EndDate.val = new Date(vsq.EndDate);
          q.DateType = vsq.DateType;		  
		  q.DateRangeValid = true;
          q = updateDateType(q, vsq.DateType);
          q.DateRangeMode = vsq.DateRangeMode;
          // filters
					_tabFilters = vs.tabFilters;

				}
			}
		}

		// set titles
		vm.multiselectTitle(vm.CeMultiselect, true);
		vm.multiselectTitle(vm.RxMultiselect, true);

		return returnVisit;

	}

  function queryChangeDateType() {
    if (vm.isWaiting) {
      return;
    }
    var q = vm.query;
    q.DateRangeValid = false;
    q = updateDateType(q, q.DateType);
    $timeout(function() {
			$scope.$broadcast('widget.input.date.range.mode', {mode: vm.query.DateRangeMode, keepDates: false});
		}, 100);
  }

  function updateDateType(q, dateType) {
    if (dateType == "TRANSACTION"){
      q.DateRangeList = utilSvc.widget.dateRangeList([]);
		  q.DateRangeMode = 'MTD';
    } else {
    	var datelist = [{label:'', value: 'NONE'}, {label:'Monthly', value: 'MONTHLY'}];
      q.DateRangeList = datelist;
      q.DateRangeMode = 'MONTHLY';
    }
    return q;
  }

	function getWacneutAffs() {

		// CDC user doesn't get wacneut affs, go get them

		// build list of CDCs
		var dcDrop = vm.DcDroplist,
			dcList = [];
		for(var i = 1; i < dcDrop.length; i++) {
			dcList.push(dcDrop[i].value);
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		reportRepo.getWacNeutAffs(dcList).then(okGetWacneutAffs, errGetWacneutAffs);
	}

	function okGetWacneutAffs(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		// add dc affs
		var dcAff = {},
			dcList = [];
		for(var i = 0; i < r.length; i++) {
			dcAff = r[i];

			// create unique list of Cdc pharmacies found
			if(dcList.indexOf(dcAff.CdcPharmacy) < 0) {
				dcList.push(dcAff.CdcPharmacy);
			}
		}
		_dcAffs = r;

		// remove any DC which doesn't have affs pointing at it
		for(var d = vm.DcDroplist.length - 1; d > 0; d--) {
			if(dcList.indexOf(vm.DcDroplist[d].value) < 0) {
				vm.DcDroplist.splice(d, 1);
			}
		}

		initFinalize();
	}

	function errGetWacneutAffs(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		if(!!r && r.status == 422 && !!r.data && !!r.data.Entity && Array.isArray(r.data.Entity.ROOT) && r.data.Entity.ROOT.length > 0) {
			msgSvc.ok('WAC Neutralizer', r.data.Entity.ROOT[0]);
		}
		else if(!!r) {
			errSvc.warn('unknown error getting data', 'wacneutCtl.errGetWacneutAffs', r.status, utilSvc.http.safeResponse(r));
		}
	}

	/**
	 * POPUP
	 * */

	function openPopup(evt, id) {
		// shared handler to open editing and import popups
		if (vm.isWaiting) {
			return;
		}

		vm.popup = {
			showLog: false,
			ready: false
		};

		getDetail(id);

		// wait for digest before showing
		$timeout(function () {
			vm.popup.ready = true;
		}, 200);

		// note: more properties added after api calls
		// see below, datafeed calls repo to get config values

		// remember the clicked vertical location
		var elem = evt.target,
			offsetY = -100, // pop over
			hitRow = false;

		// loop html elements back to top of table
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('table-popup-top') > -1) {
				break;
			}

			// add offset, get next element
			offsetY += elem.offsetTop;
			elem = elem.offsetParent;
		}
		elem = null;

		// move popup to clicked row
		var popup = document.getElementById('tablePopupContentWACNEUT');
		if(!!popup) {
			popup.style.top = offsetY.toString() + 'px';
		}
	}

	function closePopup() {
		vm.popup = {};
		vm.model = {};
	}

	/**
	 *    GET DETAIL
	 */

	 function getDetail(id) {
		vm.isWaiting = true;
		msgSvc.wait(true);

		reportRepo.getWacneutDetail(id).then(ok, err);

		function ok(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;
			vm.model = {};
			vm.model.DrugDescription = validSvc.newProp(r.DrugDescription);
			vm.model.Id = validSvc.newProp(r.Id);
			vm.model.ItemCode = validSvc.newProp(r.ItemCode);
			vm.model.Quantity = validSvc.newProp(r.Quantity);
			vm.model.TransDate = validSvc.newProp(r.TransDate);
			vm.model.TransId = validSvc.newProp(r.TransId);
			vm.model.CanEdit = r.CanEdit;

			// clean up change log null arrays
			var chgItems = Array.isArray(r.ChangeLog) ? r.ChangeLog : [];
			for (var i = 0; i < chgItems.length; i++) {
				chgItems[i].ChangedProperties = Array.isArray(chgItems[i].ChangedProperties) ? chgItems[i].ChangedProperties : [];
			}
			vm.model.ChangeLog = chgItems;
		}
		function err(r) {
			msgSvc.wait(false);
			vm.isWaiting = false;

			if(!!r) {
				throw new Error('wacneutCtl.getDetail.err, Could not find id: ' + id);
			}
		}
	}

	function submit() {
		if(vm.isWaiting || !vm.model.CanEdit) {
			return;
		}

		if(!validWacNeut()) {
			msgSvc.ok('Cannot Save', 'Check data values.');
			return;
		}

		vm.isWaiting = true;

		// update
		reportRepo.updateWacNeut(vm.model).then(okSubmit, errSubmit);
		
		function okSubmit(entity) {
			vm.isWaiting = false;
			msgSvc.ok('Item Saved', 'Item Saved');
			getDetail(vm.model.Id.val);
			$timeout(function () {
				querySubmit();
			}, 200);
		}

		function errSubmit(r) {

			vm.isWaiting = false;

			if(r == null) {
				return;
			}
			else if(r.status == 409) {
				// conflict
				msgSvc.ok('Could Not Save', 'May already exist in the database. Verify and try again.');
			}
			else if (r.status == 422) {
				// validation
				vm.model = r.model;
			}
			else {
				errSvc.error('Unknown add / update error response', 'wacneutCtl.errSubmit', r.status, utilSvc.http.safeResponse(r));
			}

		}
	}

	function validWacNeut() { 

		// validate WacNeut 

		// reset ROOT

		vm.model.ROOT = {};
		// TransId - required, <= 20 integers
		if(!validSvc.isText(vm.model.TransId.val) || !validSvc.isInteger(vm.model.TransId.val) || vm.model.TransId.val.toString().length > 20) {
			vm.model.TransId.fail = 'yes';
			vm.model.TransId.msg = 'required, integer up to 20 digits';
		}
		else {
			vm.model.TransId.fail = '';
		}


		return true;
	}

	/**
	 *    DISPLAY VIEW MODELS
	 */

	function displayVM(repoData, tooMany) {

		var items = Array.isArray(repoData) ? repoData : [];

		/* re-format server data
		for(var i = 0; i < items.length; i++) {
			items[i].TotalDue = parseFloat(items[i].TotalDue.toFixed(2));
		}
		*/

		return {
			Items: [],
			DataItems: items,
			TooMany: !!tooMany
		};
	}


	/**
	 *    QUERY CHANGE
	 */

	function queryChange() {

		if(!vm.init) {
			vm.action = '';
			vm.tbl = {};
			vm.flt = vm.resetFilters(vm.flt);
			$scope.$broadcast('widget.paging');
		}

	}

	function multiselectCeToggle(evt, id) {
		vm.RxMultiselect.show = false;
		multiselectToggle(evt, vm.CeMultiselect, id);
	}

	function multiselectRxToggle(evt, id) {
		vm.CeMultiselect.show = false;
		multiselectToggle(evt, vm.RxMultiselect, id);
	}

	function queryChangeDC() {

		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.query.DC.fail = validSvc.isRX(vm.query.DC.val) ? 'no' : 'yes';

		// clean out CE
		vm.CeMultiselect.vals = [];
		vm.multiselectTitle(vm.CeMultiselect, true);
		vm.query.CE = validSvc.newProp('NONE');
		vm.query.CE.fail = 'yes';

		if(vm.query.DC.fail == 'yes') {
			return;
		}

		// load dc affs for non-CDC user
		if(!vm.query.CdcUser) {
			_dcAffs = getAffsByDcPharmacy($scope.User.AffList, vm.query.DC.val);
		}

		// rebuild CE
		var affs = getAffsByDcPharmacy(_dcAffs, vm.query.DC.val);
		var ceList = utilSvc.aff.ceList(affs);
		ceList.unshift('ALL');
		vm.CeMultiselect.list = vm.multiselectBuild(ceList, false);

		// auto select CE?
		if(vm.CeMultiselect.list.length === 1) {
			queryChangeCE(vm.CeMultiselect.list[0].val);
		}

	}

	function queryChangeCE(val) {

		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.multiselectClick(vm.CeMultiselect, val);
		vm.multiselectTitle(vm.CeMultiselect, true);
		vm.query.CE.fail = vm.CeMultiselect.vals.length < 1 ? 'yes' : 'no';
		if(vm.query.CE.fail == 'yes') {
			return;
		}
		var ceVals = multiselectQueryVals(vm.CeMultiselect);

		// rebuild RX
		vm.RxMultiselect = multiselectRebuildSecondary(vm.CeMultiselect, vm.RxMultiselect, utilSvc.aff.findCeList(_dcAffs, ceVals), true);
		vm.query.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';

	}

	function queryChangeRX(val) {

		if(vm.isWaiting) {
			return;
		}
		queryChange();

		vm.multiselectClick(vm.RxMultiselect, val);
		vm.multiselectTitle(vm.RxMultiselect, true);
		vm.query.RX.fail = vm.RxMultiselect.vals.length < 1 ? 'yes' : 'no';

	}

	function dateRangeChange(dtMode, isValid) {

		vm.query.DateRangeMode = dtMode;
		vm.query.DateRangeValid = isValid;

		if(_returnVisit) {
			_returnVisit = false;
			querySubmit();
			return;
		}

		if(!vm.init) {
			queryChange();
		}
		vm.init = false;

	}


	/**
	 *    GLOBAL GREASE FILTER
	 */

	function filterChange(immediate) {

		// used for html property changes
		// includes UI debouncing and UI viewstate updates

		// exit if filter is off
		if(!vm.flt.Ready) {
			return;
		}

		// mark filters dirty
		vm.flt.Dirty = true;

		// already working
		if(vm.flt.Busy) {
			return;
		}
		vm.flt.Busy = true;
		vm.flt.Dirty = false;

		// debounce ui changes
		var delayTime = !!immediate ? 0 : 300;
		$timeout(function() {

			vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
			vm.flt.Busy = false;

			// run again? data changed during filtering
			if(vm.flt.Dirty) {
				filterChange(true);
				return;
			}

			// update paging ui
			$scope.$broadcast('widget.paging', {
				uniqueId: vm.reportTab,
				Size: vm.flt.PageSize,
				Page: vm.flt.Page,
				Total: vm.flt.PageTotal,
				RowCount: vm.flt.Count,
				ItemCount: vm.tbl.Items.length,
				DataCount: vm.tbl.DataItems.length
			});

			// debounce viewstate save, want to minimize these
			$timeout(function() {
				if(!vm.flt.Busy && !vm.flt.Dirty) {
					saveViewState(vm.query, vm.reportTab, vm.flt);
				}
			},1000);

		}, delayTime);

	}

	function tabChange(tabName) {

		if(vm.isWaiting) {
			return;
		}

		vm.reportTab = tabName;
		querySubmit();

	}


	/**
	 *    QUERY SUBMIT
	 */

	function queryValid(query) {

		// validate
		vm.query.DC.fail = validSvc.isRX(vm.query.DC.val) ? 'no' : 'yes';

		var ceVals = multiselectQueryVals(vm.CeMultiselect),
			rxVals = multiselectQueryVals(vm.RxMultiselect);
		vm.query.CE.fail = ceVals.length < 1 ? 'yes' : 'no';
		vm.query.RX.fail = rxVals.length < 1 ? 'yes' : 'no';

		// assign multi values
		if(vm.query.DateRangeValid && vm.query.DC.fail == 'no' && vm.query.CE.fail == 'no' && vm.query.RX.fail == 'no') {

			vm.query.CE.vals = ceVals;
			vm.query.RX.vals = rxVals;
			vm.query.multi = false;
			if((ceVals[0] == 'ALL' || ceVals.length > 1) && (rxVals[0] == 'ALL' || rxVals.length > 1)) {
				vm.query.multi = true;
			}

			return true;
		}

		return false;
	}

	function querySubmit() {

		if(vm.isWaiting) {
			return;
		}

		queryChange();

		if(!queryValid(vm.query)) {
			if(!vm.init) {
				msgSvc.ok('Search', 'Check filter settings');
			}
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		reportRepo.getWacNeut(vm.reportTab, vm.query).then(okGetData, errGetData);

	}

	function okGetData(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		vm.flt = vm.resetFilters(_tabFilters[vm.reportTab], true);

		vm.tbl = displayVM(r.data, r.tooMany);
		vm.tbl.Items = vm.filterList(vm.tbl.DataItems, vm.flt);
		vm.flt.Ready = true;

		// update paging ui
		$scope.$broadcast('widget.paging', {
			uniqueId: vm.reportTab,
			Size: vm.flt.PageSize,
			Page: vm.flt.Page,
			Total: vm.flt.PageTotal,
			RowCount: vm.flt.Count,
			ItemCount: vm.tbl.Items.length,
			DataCount: vm.tbl.DataItems.length
		});

		saveViewState(vm.query, vm.reportTab, vm.flt);
		vm.action = 'LIST';

	}

	function errGetData(r) {
		vm.isWaiting = false;
		msgSvc.wait(false);

		if(!!r && r.status == 422 && !!r.data && !!r.data.Entity && Array.isArray(r.data.Entity.ROOT) && r.data.Entity.ROOT.length > 0) {
			msgSvc.ok('WAC Neutralizer', r.data.Entity.ROOT[0]);
		}
		else if(!!r) {
			errSvc.warn('unknown error getting data for tab: ' + vm.reportTab, 'wacneutCtl.errGetData', r.status, utilSvc.http.safeResponse(r));
		}
	}


	/**
	 *    EXCEL
	 */

	function getExcel() {

		if(vm.isWaiting) {
			return;
		}

		// blob support?
		if(!validSvc.blobSupported()) {
			errSvc.warn('Excel feature requires your browser to support HTML5 Blob functionality. Try using a different browser');
			return;
		}

		vm.isWaiting = true;
		msgSvc.wait(true);

		// format filename
		_pendingExcelFilename = 'Verity-WAC-Neutralizer-Report-' + utilSvc.dt.monthShortText(vm.query.StartDate.val) + vm.query.StartDate.val.getFullYear().toString() + '.xlsx';
		reportRepo.wacNeutExcel(vm.query, _pendingExcelFilename).then(okServerExcel, errServerExcel);

		function okServerExcel(binaryData) {

			// convert binary stream to blob and save
			try {
				var excelBlob = new Blob([binaryData],{type:'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}); //'application/octet-stream'});
				$window.saveAs(excelBlob, utilSvc.regex.cleanFilename(_pendingExcelFilename));
			}
			catch(err) {
				throw(err);
			}

			vm.isWaiting = false;
			msgSvc.wait(false);
		}

		function errServerExcel(r) {
			vm.isWaiting = false;
			msgSvc.wait(false);

			if(!!r) {
				errSvc.warn('Create Excel Error', 'billing.rx.rollupExcel', r.status, err.message);
			}
		}

	}


	/**
	 *    MULTISELECT HELPERS
	 */

	function multiselectRebuildSecondary(primary, secondary, affs, usingALL) {

		// rebuild secondary multiselect based on values in primary multiselect

		usingALL = !!usingALL;
		var secList = [];

		if(primary.vals.length < 1) {
			secondary.list = [];
			secondary.vals = [];
		}
		else {

			affs = primary.type == 'CE' ? utilSvc.aff.findCeList(affs, multiselectQueryVals(primary)) : utilSvc.aff.findRxList(affs, primary.vals);
			secList = primary.type == 'CE' ? utilSvc.aff.rxList(affs) : utilSvc.aff.ceList(affs);

			var vals = secondary.vals,
				newVals = [];

			if(vals.length === 1 && vals[0] == 'ALL') {
				newVals = ['ALL'];
				usingALL = true;
			}
			else {
				// add new val only if it exists in new secList
				for(var i = 0; i < vals.length; i++) {
					if(secList.indexOf(vals[i]) > -1) {
						newVals.push(vals[i]);
					}
				}
			}

			// assign new check list
			if(usingALL && secList.length > 1) {
				secList.unshift('ALL');
			}
			if(secondary.type == 'RX') {
				secondary.list = vm.multiselectBuildRX(secList, false, affs);
			}
			else {
				secondary.list = vm.multiselectBuild(secList, false);
			}

			// assign vals
			if((!usingALL && secList.length === newVals.length) || (usingALL && ((newVals.length > 0 && newVals[0] == 'ALL') || secList.length - 1 === newVals.length))) {
				// all vals are checked
				secondary.vals = [];
				vm.multiselectClick(secondary, 'ALL');
			}
			else {
				vm.multiselectReturnVisit(secondary, '', newVals);
			}
		}

		// set title
		vm.multiselectTitle(secondary, true);

		return secondary;

	}

	function multiselectToggle(evt, multiselect, id) {

		// show / hide multiselect
		// note: sets width of multiselect dynamically, min width is specific in HTML as attribute "data-min-width-px"

		if(vm.isWaiting) {
			return;
		}

		// reset dropselect filter
		multiselect.flt = '';

		// don't bother with width if hiding
		if(multiselect.show) {
			multiselect.show = false;
			return;
		}

		var parentWidth = 0,
			minWidth = 0,
			elem = evt.target;

		// loop to find drop-select parent class
		while(!!elem) {

			// top element found
			if(!!elem.className && elem.className.indexOf('drop-select') > -1) {

				// get current dynamic width
				var rect = elem.getBoundingClientRect();
				parentWidth = rect.width;

				// get pre-configured min-width
				minWidth = utilSvc.num.parse(elem.getAttribute('data-min-width-px'));
				if(minWidth <= 0) {
					alert(id + ', data-min-width-px is missing, cannot adjust width');
				}

				break;
			}

			// next parent
			elem = elem.parentNode;
		}
		elem = null;

		// adjust width
		var adjustWidth = parentWidth > minWidth ? parentWidth : minWidth;
		elem = document.getElementById(id);
		if(!!elem) {
			elem.style.width = (adjustWidth + 10).toString() + 'px';
		}

		multiselect.show = true;

	}

	function multiselectMouseHover(id, evt) {

		// delay hiding on mouse leave for 2 seconds (in case user's mouse slips off list)

		var multiselect = vm[id];
		if(!!multiselect.show) {

			if(evt == 'leave') {
				// user mouse left, start 2 second delay
				_mouseLeaveDelay[id] = 500;
				$timeout(mouseOutDebounce,500);
			}
			else {
				// user mouse re-entered, stop leave sequence
				_mouseLeaveDelay[id] = 0;
			}
		}
	}

	function mouseOutDebounce() {

		// timer event fires every half second, re-check all multiselects mouse state
		var multiselect = {},
			mouseLeave = 0,
			debounce = false;

		// check all multi-select lists
		for(var prop in _mouseLeaveDelay) {

			if (_mouseLeaveDelay.hasOwnProperty(prop)) {
				multiselect = vm[prop];
				mouseLeave = _mouseLeaveDelay[prop];

				if(multiselect.show && mouseLeave > 0) {
					mouseLeave += 500;

					// over 1 seconds
					if(mouseLeave > 1000) {
						_mouseLeaveDelay[prop] = 0;
						multiselect.show = false;
					}
					else {
						// wait, try again
						_mouseLeaveDelay[prop] = mouseLeave;
						debounce = true;
					}
				}
				else if(!multiselect.show) {
					// reset debounce, multi was turned off for another reason (new query, etc)
					_mouseLeaveDelay[prop] = 0;
				}
			}
		}

		// bounce again?
		if(debounce) {
			$timeout(mouseOutDebounce, 500);
		}
	}

	function multiselectQueryVals(multiselect) {

		// unpack the vals multiselect into a list of entities to query

		var checklist = multiselect.list,
			vals = multiselect.vals;

		if(vals.length < 1) {
			return [];
		}
		else if(vals.length === 1 && vals[0] == 'ALL') {
			// using ALL checkbox, return all values except ALL checkbox
			var result = [],
				i = checklist[0].val == 'ALL' ? 1 : 0;
			for(i; i < checklist.length; i++) {
				result.push(checklist[i].val);
			}
			return result;
		}
		else {
			return vals;
		}
	}


	/**
	 *    HELPERS
	 */

	function numberFmt(val, zeroFmt, prefix, decPlaces) {

		// helper to format incoming number data

		// nan
		if(!validSvc.isNumber(val)) {
			return '';
		}

		// zero
		if(val === 0) {
			return zeroFmt;
		}

		return prefix + utilSvc.str.toText($filter('number')(val, decPlaces));

	}

	function saveViewState(query, reportTab, flt) {

		// update tab filters
		if(!!_tabFilters[reportTab]) {
			_tabFilters[reportTab] = flt;
		}

		sessionRepo.set('vs-report-wacneut', {
			reportTab: reportTab,
			query: {
				DC: query.DC.val,
				CE: query.CE.vals,
				RX: query.RX.vals,
				DateRangeMode: query.DateRangeMode,
				DateType: query.DateType,
				StartDate: query.StartDate.val,
				EndDate: query.EndDate.val
			},
			tabFilters: _tabFilters
		});
	}

}
 angular.module('espui.templates', ['core/ui/widget/field/widget-field-status.tpl.html', 'core/ui/widget/input/widget-input-date-pick.tpl.html', 'core/ui/widget/input/widget-input-date-range.tpl.html', 'core/ui/widget/input/widget-mui-ndc-auto-search.tpl.html', 'core/ui/widget/input/widget-scheduler.tpl.html', 'core/ui/widget/paging/widget-paging.tpl.html', 'core/ui/widget/savedreports/widget-saved-reports.tpl.html', 'core/ui/widget/table/widget-table-top-controls.tpl.html', 'core/ui/widget/table/widget-table-view-editor.tpl.html', 'core/ui/widget/timeseries/widget-timeseries.tpl.html', 'home/home.tpl.html', 'home/layout/ui/footer.tpl.html', 'home/layout/ui/header.tpl.html', 'home/layout/ui/msgbox.tpl.html', 'home/login/login.tpl.html', 'home/startup/startup.tpl.html', 'orders/ui/list.tpl.html', 'orders/ui/new.tpl.html', 'orders/ui/split.detail.tpl.html', 'shared/main/main.flex.tpl.html', 'shared/main/main.report.tpl.html', 'shared/main/main.reportB.tpl.html', 'shared/main/main.tpl.html', 'shared/main/mainB.tpl.html']);

angular.module("core/ui/widget/field/widget-field-status.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("core/ui/widget/field/widget-field-status.tpl.html",
    "<span><span class=\"field-icon icon-glyph ng-hide\" ng-show=\"!!vm.showIcon\" ng-class=\"{'icon-valid': watch.fail == 'no', 'icon-invalid': watch.fail == 'yes'}\"></span>\n" +
    "<span class=\"field-msg ng-hide\" ng-show=\"!!vm.showMsg && watch.fail == 'yes'\" ng-bind=\"watch.msg\"></span></span>\n" +
    "");
}]);

angular.module("core/ui/widget/input/widget-input-date-pick.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("core/ui/widget/input/widget-input-date-pick.tpl.html",
    "<div>\n" +
    "	<h5 class=\"dt-pick-title\">{{vm.title}}</h5>\n" +
    "	<table class=\"dt-pick-table\">\n" +
    "		<thead>\n" +
    "			<tr class=\"dt-pick-month-display\">\n" +
    "				<th><span class=\"icon-glyph icon-left\" ng-click=\"vm.mthChange(-1)\"></span></th>\n" +
    "				<th class=\"no-hover\" colspan=\"5\"><span>{{vm.mthTitle}}</span></th>\n" +
    "				<th><span class=\"icon-glyph icon-right\" ng-click=\"vm.mthChange(1)\"></span></th>\n" +
    "			</tr>\n" +
    "		</thead>\n" +
    "		<tbody>\n" +
    "			<tr class=\"dt-pick-col-header\">\n" +
    "				<td>M</td><td>T</td><td>W</td><td>T</td><td>F</td><td>S</td><td>S</td>\n" +
    "			</tr>\n" +
    "			<tr class=\"dt-pick-row\" ng-repeat=\"weekItem in vm.weeks\">\n" +
    "				<td ng-repeat=\"dayItem in weekItem.days\"><div ng-click=\"vm.dayClick(dayItem)\" ng-class=\"{'day-pick-off':dayItem.is == 'off', 'day-pick-ok':dayItem.is == 'ok','day-pick-set':dayItem.is == 'set','day-pick-range':dayItem.is == 'range','day-pick-end': dayItem.is == 'end'}\">{{dayItem.txt}}</div></td>\n" +
    "			</tr>\n" +
    "		</tbody>\n" +
    "	</table>\n" +
    "	<p class=\"dt-pick-alt ng-hide\" ng-show=\"vm.altShow\">\n" +
    "		<span class=\"icon-glyph\" ng-class=\"{'icon-checked': vm.altChecked, 'icon-unchecked': !vm.altChecked}\" ng-click=\"vm.altToggle()\"></span>{{vm.altText}}\n" +
    "	</p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core/ui/widget/input/widget-input-date-range.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("core/ui/widget/input/widget-input-date-range.tpl.html",
    "<div class=\"widget-input-date-range\">\n" +
    "	<div class=\"form-field input-drop\">\n" +
    "		<label class=\"same-width ng-hide\" ng-show=\"!!lblText\" for=\"DateRangeMode\">{{lblText}}</label>\n" +
    "		<select id=\"DateRangeMode\" ng-model=\"rangeMode\" ng-change=\"vm.modeChange()\"\n" +
    "			ng-options=\"mItem.value as mItem.label for mItem in rangeModeList\">\n" +
    "		</select>\n" +
    "	</div>\n" +
    "	<div class=\"form-field input-date ng-hide\" ng-show=\"!!vm.show.startDate\">\n" +
    "		<label for=\"StartDate\">Start Date</label>\n" +
    "		<span class=\"input-with-calendar\">\n" +
    "			<input widget-input-date type=\"text\" id=\"StartDate\" name=\"StartDate\" placeholder=\"m/d/yyyy\" maxlength=\"10\" ng-disabled=\"!!!vm.show.startDateEnabled\"\n" +
    "				ng-model=\"startDate.val\" dt-change=\"vm.customDateChange('StartDate', viewText)\"\n" +
    "			/>\n" +
    "			<span class=\"icon-glyph icon-calendar\" ng-show=\"!!vm.show.startDateEnabled\" ng-click=\"vm.dtPickOpen('StartDate', true);\"></span>\n" +
    "			<div widget-input-date-pick unique-id=\"StartDate\" dt-title=\"START DATE\" class=\"date-pick ng-hide\" ng-show=\"vm.dtPickShowStart\" ng-mouseleave=\"vm.dtPickMouseHover('Start', 'leave')\" ng-mouseenter=\"vm.dtPickMouseHover('Start', 'enter')\"></div>\n" +
    "		</span>\n" +
    "		<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': !!!startDate.fail, 'icon-invalid': !!startDate.fail}\"></span>\n" +
    "		<span class=\"field-msg\" ng-show=\"!vm.hideErrorText && !!startDate.fail\" ng-bind=\"startDate.msg\"></span>\n" +
    "	</div>\n" +
    "	<div class=\"form-field input-date ng-hide\" ng-show=\"!!vm.show.endDate\">\n" +
    "		<label for=\"EndDate\">End Date</label>\n" +
    "		<span class=\"input-with-calendar\">\n" +
    "			<input widget-input-date type=\"text\" id=\"EndDate\" name=\"EndDate\" placeholder=\"m/d/yyyy\" maxlength=\"10\" ng-disabled=\"!!!vm.show.endDateEnabled\"\n" +
    "				ng-model=\"endDate.val\" dt-change=\"vm.customDateChange('EndDate', viewText)\"\n" +
    "			/>\n" +
    "			<span class=\"icon-glyph icon-calendar\" ng-show=\"!!vm.show.endDateEnabled\" ng-click=\"vm.dtPickOpen('EndDate', true);\"></span>\n" +
    "			<div widget-input-date-pick unique-id=\"EndDate\" dt-title=\"END DATE\" class=\"date-pick ng-hide\" ng-show=\"vm.dtPickShowEnd\" ng-mouseleave=\"vm.dtPickMouseHover('End', 'leave')\" ng-mouseenter=\"vm.dtPickMouseHover('End', 'enter')\"></div>\n" +
    "		</span>\n" +
    "		<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': !!!endDate.fail, 'icon-invalid': !!endDate.fail}\"></span>\n" +
    "		<span class=\"field-msg\" ng-show=\"!vm.hideErrorText && !!endDate.fail\" ng-bind=\"endDate.msg\"></span>\n" +
    "	</div>\n" +
    "	<div class=\"form-field input-drop ng-hide\" ng-show=\"!!vm.show.monthlyMonth\">\n" +
    "		<label for=\"RangeMonth\">Month</label>\n" +
    "		<select id=\"RangeMonth\" ng-model=\"vm.monthlyMonth.val\" ng-change=\"vm.monthlyChange('MONTH')\"\n" +
    "			ng-options=\"mmItem.value as mmItem.label for mmItem in vm.monthlyMonthList\">\n" +
    "		</select>\n" +
    "		<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': !!!vm.monthlyMonth.fail, 'icon-invalid': !!vm.monthlyMonth.fail}\"></span>\n" +
    "		<span class=\"field-msg\" ng-show=\"!vm.hideErrorText && !!vm.monthlyMonth.fail\" ng-bind=\"vm.monthlyMonth.msg\"></span>\n" +
    "	</div>\n" +
    "	<div class=\"form-field input-drop ng-hide\" ng-show=\"!!vm.show.monthlyYear\">\n" +
    "		<label for=\"RangeYear\">Year</label>\n" +
    "		<select id=\"RangeYear\" ng-model=\"vm.monthlyYear.val\" ng-change=\"vm.monthlyChange('YEAR')\"\n" +
    "			ng-options=\"myItem.value as myItem.label for myItem in vm.monthlyYearList\">\n" +
    "		</select>\n" +
    "		<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': !!!vm.monthlyYear.fail, 'icon-invalid': !!vm.monthlyYear.fail}\"></span>\n" +
    "		<span class=\"field-msg\" ng-show=\"!vm.hideErrorText && !!vm.monthlyYear.fail\" ng-bind=\"vm.monthlyYear.msg\"></span>\n" +
    "	</div>\n" +
    "	<div class=\"form-field input-drop ng-hide\" ng-show=\"!!vm.show.qtrName\">\n" +
    "		<label for=\"qtrName\">Quarter</label>\n" +
    "		<select id=\"qtrName\" ng-model=\"vm.qtrName.val\" ng-change=\"vm.qtrChange('QTR')\"\n" +
    "			ng-options=\"qnameItem.value as qnameItem.label for qnameItem in vm.qtrNameList\">\n" +
    "		</select>\n" +
    "		<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': !!!vm.qtrName.fail, 'icon-invalid': !!vm.qtrName.fail}\"></span>\n" +
    "		<span class=\"field-msg\" ng-show=\"!vm.hideErrorText && !!vm.qtrName.fail\" ng-bind=\"vm.qtrName.msg\"></span>\n" +
    "	</div>\n" +
    "	<div class=\"form-field input-drop ng-hide\" ng-show=\"!!vm.show.qtrYear\">\n" +
    "		<label for=\"qtrYear\">Year</label>\n" +
    "		<select id=\"qtrYear\" ng-model=\"vm.qtrYear.val\" ng-change=\"vm.qtrChange('YEAR')\"\n" +
    "			ng-options=\"qyearItem.value as qyearItem.label for qyearItem in vm.qtrYearList\">\n" +
    "		</select>\n" +
    "		<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': !!!vm.qtrYear.fail, 'icon-invalid': !!vm.qtrYear.fail}\"></span>\n" +
    "		<span class=\"field-msg\" ng-show=\"!vm.hideErrorText && !!vm.qtrYear.fail\" ng-bind=\"vm.qtrYear.msg\"></span>\n" +
    "	</div>\n" +
    "	<div class=\"form-field input-drop ng-hide\" ng-show=\"!!vm.show.yearly\">\n" +
    "		<label for=\"yearly\">Year</label>\n" +
    "		<select id=\"yearly\" ng-model=\"vm.yearly.val\" ng-change=\"vm.yearlyChange()\"\n" +
    "			ng-options=\"yearlyItem.value as yearlyItem.label for yearlyItem in vm.YearlyList\">\n" +
    "		</select>\n" +
    "		<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': !!!vm.yearly.fail, 'icon-invalid': !!vm.yearly.fail}\"></span>\n" +
    "		<span class=\"field-msg\" ng-show=\"!vm.hideErrorText && !!vm.yearly.fail\" ng-bind=\"vm.yearly.msg\"></span>\n" +
    "		<span class=\"ng-hide\" ng-show=\"!!!vm.yearly.fail && vm.yearly.current\">(Year To Date)</span>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core/ui/widget/input/widget-mui-ndc-auto-search.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("core/ui/widget/input/widget-mui-ndc-auto-search.tpl.html",
    "<div class=\"wid-mui-ndc-auto-search\" ng-class=\"{'auto-search':vm.state == 'SEARCH', 'auto-search-found':vm.state == 'FOUND', 'auto-search-notfound':vm.state == 'NOTFOUND'}\">\n" +
    "	<input widget-input-ndc-format type=\"text\" id=\"{{vm.uniqueId}}\" maxlength=\"11\" format=\"nodash\" ng-model=\"vm.ndc\" ndc-change=\"vm.ndcInputChange();\" placeholder=\"\" ng-disabled=\"vm.state == 'SEARCH'\" />\n" +
    "	<label class=\"lbl-title\" ng-class=\"{'has-value':vm.state != 'EMPTY'}\" for=\"{{vm.uniqueId}}\" id=\"\">\n" +
    "		<div class=\"lbl-title-txt\">NDC (auto-search)</div>\n" +
    "	</label>\n" +
    "	<label class=\"status-text ng-hide\" ng-show=\"vm.state != 'EMPTY'\"><span>{{vm.stateTxt}}</span></label>\n" +
    "</div>");
}]);

angular.module("core/ui/widget/input/widget-scheduler.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("core/ui/widget/input/widget-scheduler.tpl.html",
    "<div class=\"widget-scheduler\">\n" +
    "	<!-- AUTO ORDER HEADER -->\n" +
    "	<div id=\"widgetSchedulerEnabledPrompt\" class=\"form-field input-radio ng-hide\" ng-show=\"vm.category != 'DATAEXPORTS'\">\n" +
    "		<label>{{vm.title}}</label>\n" +
    "		<ul class=\"ng-hide\" ng-show=\"vm.action == 'CREATE'\">\n" +
    "			<li><label class=\"auto-width\">Create account to edit auto order settings</label></li>\n" +
    "		</ul>\n" +
    "		<ul class=\"ng-hide\" ng-show=\"vm.action == 'UPDATE'\">\n" +
    "			<li><label class=\"auto-width\"><input type=\"radio\" name=\"{{vm.radioGroupEnabled}}\" ng-model=\"vm.model.Enabled\" ng-click=\"vm.enabledChange('off')\" value=\"off\">&nbsp;Off</label></li>\n" +
    "			<li style=\"margin-right:0;\">\n" +
    "				<label class=\"auto-width\"><input type=\"radio\" name=\"{{vm.radioGroupEnabled}}\" ng-model=\"vm.model.Enabled\" ng-click=\"vm.enabledChange('on')\" value=\"on\">&nbsp;On</label>\n" +
    "			</li>\n" +
    "			<li class=\"ng-hide\" ng-show=\"vm.model.fail == 'no'\">\n" +
    "				<div class=\"info-tip\">\n" +
    "					<label class=\"auto-width\"><a><span class=\"icon-glyph icon-msg-info\"></span></a></label>\n" +
    "					<div class=\"tip-content tip-left-100\" style=\"width:480px;\">\n" +
    "						<p class=\"tip-title\"><span class=\"icon-glyph icon-orders-auto\"></span>&nbsp;{{vm.title}}&nbsp;Auto Order</p>\n" +
    "						<p>AutoOrder is CREATED 2am PST on days specified.</p>\n" +
    "						<p>AutoOrder will be PLACED at 3pm PST the same day.</p>\n" +
    "						<p>Note: this feature is Contract Pharmacy only.</p>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</li>\n" +
    "			<li class=\"ng-hide\" ng-show=\"vm.model.fail == 'yes'\">\n" +
    "				<span class=\"field-icon icon-glyph icon-invalid\"></span>\n" +
    "			</li>\n" +
    "		</ul>\n" +
    "	</div>\n" +
    "	<!-- SCHEDULE -->\n" +
    "	<div class=\"ng-hide\" ng-show=\"vm.model.Enabled == 'on'\" ng-style=\"{'margin-left':vm.category != 'DATAEXPORTS' ? '50px' : ''}\">\n" +
    "		<div class=\"form-field input-radio\">\n" +
    "			<label>Schedule</label>\n" +
    "			<ul>\n" +
    "				<li ng-click=\"vm.scheduleTypeChange('WEEK')\">\n" +
    "					<label class=\"auto-width\"><input type=\"radio\" name=\"{{vm.radioGroupType}}\" ng-model=\"vm.model.Type\" value=\"WEEK\">&nbsp;Weekly</label>\n" +
    "				</li>\n" +
    "				<li ng-click=\"vm.scheduleTypeChange('MONTH')\">\n" +
    "					<label class=\"auto-width\"><input type=\"radio\" name=\"{{vm.radioGroupType}}\" ng-model=\"vm.model.Type\" value=\"MONTH\">&nbsp;Monthly</label>\n" +
    "				</li>\n" +
    "			</ul>\n" +
    "		</div>\n" +
    "		<!-- MONTH -->\n" +
    "		<div class=\"'ng-hide\" ng-show=\"vm.model.Type == 'MONTH'\">\n" +
    "			<div class=\"form-field input-radio\">\n" +
    "				<label>Month Option</label>\n" +
    "				<ul>\n" +
    "					<li ng-click=\"vm.monthOptionChange('MONTH-DAY')\">\n" +
    "						<label class=\"auto-width\"><input type=\"radio\" name=\"{{vm.radioGroupMonthOption}}\" ng-model=\"vm.model.MonthOption\" value=\"MONTH-DAY\">&nbsp;Day of Month</label>\n" +
    "					</li>\n" +
    "					<li ng-click=\"vm.monthOptionChange('MONTH-WEEK')\">\n" +
    "						<label class=\"auto-width\"><input type=\"radio\" name=\"{{vm.radioGroupMonthOption}}\" ng-model=\"vm.model.MonthOption\" value=\"MONTH-WEEK\">&nbsp;Week of Month</label>\n" +
    "					</li>\n" +
    "				</ul>\n" +
    "			</div>\n" +
    "			<!-- MONTH-DAY -->\n" +
    "			<div class=\"form-field input-drop ng-hide\" ng-show=\"vm.model.MonthOption == 'MONTH-DAY'\">\n" +
    "				<label>Day</label>\n" +
    "				<select ng-model=\"vm.model.DayOfMonth.val\" ng-change=\"vm.modelChange()\"\n" +
    "					ng-options=\"monthDayItem.value as monthDayItem.label for monthDayItem in vm.DayOfMonthDroplist\">\n" +
    "				</select>\n" +
    "				<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.model.DayOfMonth.fail == 'yes'}\"></span>\n" +
    "			</div>\n" +
    "			<!-- MONTH-WEEK -->\n" +
    "			<div class=\"form-field input-drop ng-hide\" ng-show=\"vm.model.MonthOption == 'MONTH-WEEK'\">\n" +
    "				<label>&nbsp;</label>\n" +
    "				<select ng-model=\"vm.model.WeekOfMonth.val\" ng-change=\"vm.modelChange()\"\n" +
    "					ng-options=\"weekMonthItem.value as weekMonthItem.label for weekMonthItem in vm.WeekOfMonthDroplist\">\n" +
    "				</select>\n" +
    "				<label class=\"auto-width\">&nbsp;&nbsp;Week of the Month</label>\n" +
    "				<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.model.WeekOfMonth.fail == 'yes'}\"></span>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<!-- WEEK -->\n" +
    "		<div class=\"form-field input-drop ng-hide\" ng-show=\"vm.model.Type == 'WEEK'\">\n" +
    "			<label>Every</label>\n" +
    "			<select ng-model=\"vm.model.Occurs.val\" ng-change=\"vm.modelChange()\"\n" +
    "				ng-options=\"weekOccursItem.value as weekOccursItem.label for weekOccursItem in vm.WeekOccursDroplist\">\n" +
    "			</select>\n" +
    "			<label class=\"auto-width\">&nbsp;&nbsp;Weeks</label>\n" +
    "			<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.model.Occurs.fail == 'yes'}\"></span>\n" +
    "		</div>\n" +
    "		<!-- WEEKDAYS -->\n" +
    "		<div class=\"form-field input-check ng-hide\" ng-show=\"vm.model.Type == 'WEEK' || vm.model.MonthOption == 'MONTH-WEEK'\">\n" +
    "			<label>Weekdays</label>\n" +
    "			<ul>\n" +
    "				<li ng-repeat=\"weekdayItem in vm.Weekdays\" ng-click=\"weekdayItem.chk = !!!weekdayItem.chk;vm.modelChange()\">\n" +
    "					<label class=\"auto-width\"><span class=\"icon-glyph\" ng-class=\"{'icon-checked': weekdayItem.chk, 'icon-unchecked': !weekdayItem.chk}\"></span>{{weekdayItem.lbl}}</label>\n" +
    "				</li>\n" +
    "			</ul>\n" +
    "			<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.model.Weekdays.fail == 'yes'}\"></span>\n" +
    "			<span class=\"field-msg\" ng-show=\"vm.model.Weekdays.fail == 'yes'\">check required</span>\n" +
    "		</div>\n" +
    "		<!-- AUTO ORDER -->\n" +
    "		<div class=\"form-field input-radio ng-hide\" ng-show=\"vm.category == 'DROPSHIP' || vm.category == 'SPECIALTY'\">\n" +
    "			<label>Auto-Place and Send EDI</label>\n" +
    "			<ul>\n" +
    "				<li>\n" +
    "					<label class=\"auto-width\"><input type=\"radio\" name=\"{{vm.radioGroupAutoEDI}}\" ng-model=\"vm.model.AutoPlaceSendEDI\" ng-click=\"vm.modelChange()\" value=\"no\">&nbsp;No</label>\n" +
    "				</li>\n" +
    "				<li>\n" +
    "					<label class=\"auto-width\"><input type=\"radio\" name=\"{{vm.radioGroupAutoEDI}}\" ng-model=\"vm.model.AutoPlaceSendEDI\" ng-click=\"vm.modelChange()\" value=\"yes\">&nbsp;Yes</label>\n" +
    "				</li>\n" +
    "			</ul>\n" +
    "		</div>\n" +
    "		<!-- PLACE IMMEDIATE -->\n" +
    "		<div class=\"form-field input-radio ng-hide\" ng-show=\"vm.category == 'STANDARD' || ((vm.category == 'DROPSHIP' || vm.category == 'SPECIALTY') && vm.model.AutoPlaceSendEDI == 'yes')\">\n" +
    "			<label>Place Immediately</label>\n" +
    "			<ul>\n" +
    "				<li>\n" +
    "					<label class=\"auto-width\"><input type=\"radio\" name=\"{{vm.radioGroupPlaceNow}}\" ng-model=\"vm.model.PlaceNow\" ng-click=\"vm.modelChange()\" value=\"no\">&nbsp;No</label>\n" +
    "				</li>\n" +
    "				<li>\n" +
    "					<label class=\"auto-width\"><input type=\"radio\" name=\"{{vm.radioGroupPlaceNow}}\" ng-model=\"vm.model.PlaceNow\" ng-click=\"vm.modelChange()\" value=\"yes\">&nbsp;Yes</label>\n" +
    "				</li>\n" +
    "			</ul>\n" +
    "		</div>\n" +
    "	</div></div>");
}]);

angular.module("core/ui/widget/paging/widget-paging.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("core/ui/widget/paging/widget-paging.tpl.html",
    "<div class=\"wid-paging\">\n" +
    "	<p class=\"wid-pg-filter ng-hide\" ng-show=\"vm.itemCount === 0\">\n" +
    "		<span>No records to display</span><span class=\"ng-hide\" ng-show=\"vm.dataCount > 0\">Note:&nbsp;{{(vm.dataCount) | number}}&nbsp;rows are hidden due to column filters.</span>\n" +
    "	</p>\n" +
    "	<p class=\"wid-pg-nav ng-hide\" ng-show=\"vm.itemCount > 0\">\n" +
    "		<span>Page</span>\n" +
    "		<span class=\"wid-nav-goto ng-hide\" ng-show=\"vm.gotoFirst > 0\" ng-click=\"vm.pgNumChange(1)\"><button>1</button>&nbsp;&nbsp;...</span>\n" +
    "		<button class=\"ng-hide\" ng-show=\"vm.setBack > 0\" ng-click=\"vm.pgNumChange(vm.setBack)\"><span class=\"icon-glyph glyphicon-backward\"></span></button>\n" +
    "		<button class=\"ng-hide\" ng-class=\"{'has-focus':vm.opt1 === vm.pgPage}\" ng-show=\"vm.opt1 > 0\" ng-click=\"vm.pgNumChange(vm.opt1)\">{{vm.opt1}}</button>\n" +
    "		<button class=\"ng-hide\" ng-class=\"{'has-focus':vm.opt2 === vm.pgPage}\" ng-show=\"vm.opt2 > 0\" ng-click=\"vm.pgNumChange(vm.opt2)\">{{vm.opt2}}</button>\n" +
    "		<button class=\"ng-hide\" ng-class=\"{'has-focus':vm.opt3 === vm.pgPage}\" ng-show=\"vm.opt3 > 0\" ng-click=\"vm.pgNumChange(vm.opt3)\">{{vm.opt3}}</button>\n" +
    "		<button class=\"ng-hide\" ng-class=\"{'has-focus':vm.opt4 === vm.pgPage}\" ng-show=\"vm.opt4 > 0\" ng-click=\"vm.pgNumChange(vm.opt4)\">{{vm.opt4}}</button>\n" +
    "		<button class=\"ng-hide\" ng-class=\"{'has-focus':vm.opt5 === vm.pgPage}\" ng-show=\"vm.opt5 > 0\" ng-click=\"vm.pgNumChange(vm.opt5)\">{{vm.opt5}}</button>\n" +
    "		<button class=\"ng-hide\" ng-show=\"vm.setFwd > 0\" ng-click=\"vm.pgNumChange(vm.setFwd)\"><span class=\"icon-glyph glyphicon-forward\"></span></button>\n" +
    "		<span class=\"wid-nav-goto ng-hide\" ng-show=\"vm.gotoLast > 0\" ng-click=\"vm.pgNumChange(vm.gotoLast)\">...&nbsp;&nbsp;<button>{{vm.gotoLast}}</button></span>\n" +
    "		<span><span>Page Size</span><select ng-model=\"vm.pgSizeNew\">\n" +
    "			<option>20</option>\n" +
    "			<option>50</option>\n" +
    "			<option>100</option>\n" +
    "			<option>250</option>\n" +
    "			<option>500</option>\n" +
    "			<option>1000</option>\n" +
    "		</select>&nbsp;<button class=\"has-focus ng-hide\" ng-show=\"vm.pgSizeNew != vm.pgSize\" ng-click=\"vm.pgSizeChange()\">Apply</button>\n" +
    "	</p>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core/ui/widget/savedreports/widget-saved-reports.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("core/ui/widget/savedreports/widget-saved-reports.tpl.html",
    "<div class=\"wid-saved-reports\">\n" +
    "	<a class=\"wsr-title\" href ng-click=\"vm.toggleListView();\"><span class=\"icon-glyph  icon-saved-report\"></span>&nbsp;{{vm.title}}</a>\n" +
    "	<div class=\"wsr-list ng-hide\" ng-class=\"{'scrolled': vm.reports.length > 3}\" ng-show=\"vm.showList\" ng-mouseleave=\"vm.listMouseHover('leave')\" ng-mouseenter=\"vm.listMouseHover('enter')\">\n" +
    "		<div class=\"wsr-list-title ng-hide\" ng-show=\"!vm.query.show\">\n" +
    "			<div class=\"ng-hide\" ng-show=\"vm.reports.length < 1 && vm.query.details.length < 1\">\n" +
    "				<p>A list of previously saved searches are shown here.</p>\n" +
    "				<p>To save a search:</p>\n" +
    "				<div style=\"margin-left:20px;\">\n" +
    "					<p>1. Complete the search settings and click load.</p>\n" +
    "					<p>2. Return here and the search will be available to save.</p>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "			<p class=\"wsr-add ng-hide\" ng-show=\"vm.reports.length > 0 && vm.current == '' && vm.query.details.length > 0\"><a href ng-click=\"vm.addReport('SHOW')\"><span class=\"icon-glyph icon-add\"></span>Save Current Search</a></p>\n" +
    "		</div>\n" +
    "		<div class=\"table-list ng-hide\" ng-show=\"vm.query.show\">\n" +
    "			<h6>Save Search</h6>\n" +
    "			<p ng-repeat=\"queryLine in vm.query.details\">{{queryLine}}</p>\n" +
    "			<form class=\"query-form\" name=\"wsrAddSearchForm\" novalidate>\n" +
    "				<fieldset>\n" +
    "					<div class=\"form-field\">\n" +
    "						<label>Title</label>\n" +
    "						<input type=\"text\" placeholder=\"title\" maxlength=\"30\" ng-model=\"vm.query.name\" style=\"width:20em;\" />\n" +
    "					</div>\n" +
    "					<div class=\"form-field form-submit\">\n" +
    "						<button type=\"button\" ng-click=\"vm.addReport('SAVE')\">SAVE</button>\n" +
    "						&nbsp;&nbsp;<button class=\"btn-cancel\" type=\"button\" ng-click=\"vm.addReport('CANCEL')\">CANCEL</button>\n" +
    "					</div>\n" +
    "				</fieldset>\n" +
    "			</form>\n" +
    "		</div>\n" +
    "		<div class=\"wsr-list-item ng-hide\" ng-show=\"!vm.query.show\" ng-repeat=\"rptItem in vm.reports | orderBy:['name']\">\n" +
    "			<div ng-click=\"vm.loadReport(rptItem.id)\">\n" +
    "				<h6>{{rptItem.name}}</h6>\n" +
    "				<p ng-repeat=\"detailLine in rptItem.details\">{{detailLine}}</p>\n" +
    "			</div>\n" +
    "			<p class=\"wsr-rpt-remove\"><a href ng-click=\"vm.removeReport(rptItem.id, rptItem.name)\"><span class=\"icon-glyph icon-remove\"></span>Remove Search</a></p>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core/ui/widget/table/widget-table-top-controls.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("core/ui/widget/table/widget-table-top-controls.tpl.html",
    "<div class=\"wid-table-top-controls\">\n" +
    "	<div class=\"tbl-views ng-hide\" ng-show=\"!!vm.viewCurrent\">\n" +
    "		<a class=\"tbl-views-title\" href ng-click=\"vm.viewListShow = true; $scope.$apply();\" title=\"Show Table Views...\"><span class=\"icon-wrap wrap-tblview\"><span class=\"icon-glyph icon-list\"></span></span>{{vm.viewsTitle}}</a>\n" +
    "		<div class=\"tbl-views-list\" ng-class=\"{'tbl-list-show':vm.viewListShow}\" ng-mouseleave=\"vm.viewListMouseHover('leave')\" ng-mouseenter=\"vm.viewListMouseHover('enter')\">\n" +
    "			<span class=\"icon-wrap wrap-arrow-right\"><span class=\"icon-glyph icon-arrow-right\"></span></span>Choose a Table View:&nbsp;&nbsp;&nbsp;\n" +
    "			<a href ng-click=\"vm.viewsClick(viewItem.id)\" ng-repeat=\"viewItem in vm.views\"><span class=\"icon-wrap wrap-tblview\"><span class=\"icon-glyph icon-list\"></span></span>{{viewItem.title}}</a>\n" +
    "			<a href ng-click=\"vm.viewsClick('edit')\"><span class=\"icon-glyph icon-edit\"></span>edit views...</a>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "	<span class=\"tbl-flt ng-hide\" ng-show=\"vm.fltDataItems > 0\"><span class=\"icon-wrap wrap-filter\"><span class=\"icon-glyph icon-filter\"></span></span>Filtering {{vm.fltCount | number}} of {{vm.fltDataItems | number}} records</span>\n" +
    "	<span class=\"tbl-flt ng-hide\" ng-show=\"vm.selectCount > 0\"><span class=\"icon-wrap wrap-filter\"><span class=\"icon-glyph icon-checked\"></span></span>Selecting {{vm.selectCount | number}} {{vm.childName}}</span>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core/ui/widget/table/widget-table-view-editor.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("core/ui/widget/table/widget-table-view-editor.tpl.html",
    "<div class=\"wid-table-view-editor\">\n" +
    "	<form name=\"formTblViewEditor\" class=\"query-form\" novalidate style=\"border:none;\">\n" +
    "		<fieldset>\n" +
    "			<div class=\"form-field input-drop wid-view-selector\">\n" +
    "				<div class=\"ng-hide\" ng-show=\"vm.action == 'CREATE'\">\n" +
    "					<label>Create Custom View</label>\n" +
    "					&nbsp;&nbsp;<button type=\"button\" class=\"btn-cancel\" ng-click=\"vm.cancel()\">CANCEL</button>\n" +
    "				</div>\n" +
    "				<div class=\"ng-hide\" ng-show=\"vm.action != 'CREATE'\">\n" +
    "					<label class=\"same-width\">Choose View</label>\n" +
    "					<select ng-model=\"vm.currentView\" ng-change=\"vm.changeView()\" style=\"min-width:10em;\"\n" +
    "						ng-options=\"viewItem.value as viewItem.label for viewItem in vm.ViewDroplist\">\n" +
    "					</select>\n" +
    "					<span style=\"display: inline-block; width: 10em;\">&nbsp;</span>\n" +
    "					&nbsp;&nbsp;<a href ng-click=\"vm.create()\"><span class=\"icon-glyph icon-add\"></span>Create View...</a>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "			<div class=\"ng-hide\" ng-show=\"!!vm.action\">\n" +
    "				<p>&nbsp;</p>\n" +
    "				<div class=\"form-field tblview-name\">\n" +
    "					<label class=\"same-width\">Name</label>\n" +
    "					<input type=\"text\" placeholder=\"title\" maxlength=\"30\" ng-model=\"vm.model.title.val\" ng-disabled=\"vm.action == 'DEFAULT'\" style=\"width:10em;\" />\n" +
    "					<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': vm.model.title.fail == 'no', 'icon-invalid': vm.model.title.fail == 'yes'}\"></span>\n" +
    "					<button type=\"button\" class=\"btn-delete ng-hide\" ng-show=\"vm.action == 'UPDATE'\" ng-click=\"vm.remove()\">REMOVE</button>\n" +
    "					<p class=\"field-msg\" ng-show=\"vm.model.title.fail == 'yes'\" ng-bind=\"vm.model.title.msg\" style=\"display:block; margin-left:8em; padding:0;\"></p>\n" +
    "				</div>\n" +
    "				<h6>Column List</h6>\n" +
    "				<p>Check any columns desired for the table view.</p>\n" +
    "				<!-- SCROLL COLUMN CHOICES -->\n" +
    "				<div ng-class=\"{'scroll-columns':vm.scroll}\">\n" +
    "					<div ng-repeat=\"sectionItem in vm.model.sections\">\n" +
    "						<div class=\"form-field\">\n" +
    "							<p class=\"field-title\">{{sectionItem.title}}</p>\n" +
    "						</div>\n" +
    "						<div class=\"form-field wid-prop-check\" ng-repeat=\"propItem in sectionItem.cols\">\n" +
    "							<label>\n" +
    "								<span class=\"icon-glyph glyphicon-asterisk ng-hide\" ng-show=\"propItem.edit == 'no'\"></span>\n" +
    "								<span class=\"icon-glyph ng-hide\" ng-show=\"propItem.edit == 'yes'\" ng-click=\"vm.propToggle(propItem);$scope.$apply();\" ng-class=\"{'icon-checked': propItem.chk == 'yes', 'icon-unchecked': propItem.chk == 'no'}\"></span>\n" +
    "								{{propItem.title}}\n" +
    "							</label>\n" +
    "							<div class=\"info-tip\">\n" +
    "								<label class=\"auto-width\"><a><span class=\"icon-glyph icon-msg-info\"></span></a></label>\n" +
    "								<div class=\"tip-content tip-left-100\" style=\"width:350px;\">\n" +
    "									<p class=\"tip-title\">{{propItem.title}}</p>\n" +
    "									<p>{{propItem.desc}}</p>\n" +
    "								</div>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<h6>Column Options</h6>\n" +
    "				<div style=\"padding-left:7px;\">\n" +
    "					<div class=\"fieldset-row\">\n" +
    "						<div class=\"form-field input-drop\">\n" +
    "							<label class=\"same-width\">Sort By</label>\n" +
    "							<select ng-model=\"vm.model.sortby.val\" ng-disabled=\"vm.action == 'DEFAULT'\"\n" +
    "								ng-options=\"sortItem.value as sortItem.label for sortItem in vm.SortByDroplist\">\n" +
    "							</select>\n" +
    "						</div>\n" +
    "						<div class=\"form-field input-drop\">\n" +
    "							<select ng-model=\"vm.model.sortbydir\" ng-disabled=\"vm.action == 'DEFAULT'\"\n" +
    "								ng-options=\"sortbydirItem.value as sortbydirItem.label for sortbydirItem in vm.SortByDirDroplist\">\n" +
    "							</select>\n" +
    "							<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': vm.model.sortby.fail == 'no', 'icon-invalid': vm.model.sortby.fail == 'yes'}\"></span>\n" +
    "							<span class=\"field-msg\" ng-show=\"vm.model.sortby.fail == 'yes'\" ng-bind=\"vm.model.sortby.msg\"></span>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<div class=\"form-field input-drop\">\n" +
    "						<label class=\"same-width\">Page Size</label>\n" +
    "						<select ng-model=\"vm.model.pgsize.val\" ng-disabled=\"vm.action == 'DEFAULT'\"\n" +
    "							ng-options=\"pgsizeItem.value as pgsizeItem.label for pgsizeItem in vm.PgSizeDroplist\">\n" +
    "						</select>\n" +
    "					</div>\n" +
    "					<div class=\"form-field form-submit ng-hide\" ng-show=\"vm.action != 'DEFAULT'\">\n" +
    "						<label class=\"same-width\">&nbsp;</label>\n" +
    "						<button type=\"button\" ng-click=\"vm.save()\">{{(vm.action == 'CREATE' ? 'CREATE' : 'SAVE')}}</button>\n" +
    "						&nbsp;&nbsp;<button type=\"button\" class=\"btn-cancel\" ng-click=\"vm.cancel()\">CANCEL</button>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</fieldset>\n" +
    "	</form>\n" +
    "</div>\n" +
    "");
}]);

angular.module("core/ui/widget/timeseries/widget-timeseries.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("core/ui/widget/timeseries/widget-timeseries.tpl.html",
    "<div class=\"wid-timeseries\">\n" +
    "	<div class=\"wid-ts-hscroll ng-hide\" ng-show=\"vm.table.show || vm.chart.show\">\n" +
    "		<a class=\"ng-hide\" ng-show=\"vm.hScrollPortTitle.showPrev\" href ng-click=\"vm.hScroll(-12)\"><span class=\"icon-glyph icon-arrow-left\"></span>Previous</a>\n" +
    "		<span>{{vm.table.intervalTxt}}&nbsp;Ending&nbsp;{{vm.hScrollPortTitle.start}}&nbsp;-&nbsp;{{vm.hScrollPortTitle.end}}</span>\n" +
    "		<a href class=\"ng-hide\" ng-show=\"vm.hScrollPortTitle.showNext\" ng-click=\"vm.hScroll(12)\">Next<span class=\"icon-glyph icon-arrow-right\"></span></a>\n" +
    "	</div>\n" +
    "	<div class=\"wid-ts-tbl ng-hide\" ng-show=\"vm.table.show\">\n" +
    "		<table style=\"table-layout: fixed;\">\n" +
    "			<colgroup>\n" +
    "				<col ng-repeat=\"colGroupItem in vm.displayCols\" ng-style=\"{'width':colGroupItem.width}\">\n" +
    "			</colgroup>\n" +
    "			<tbody>\n" +
    "				<!-- TITLES -->\n" +
    "				<tr class=\"column-titles\">\n" +
    "					<td ng-repeat=\"colTitleItem in vm.displayCols\" ng-click=\"vm.sortBy(colTitleItem.id, vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "						<a>{{colTitleItem.title}}<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon(colTitleItem.id, vm.flt.SortBy)\"></span></a>\n" +
    "					</td>\n" +
    "				</tr>\n" +
    "				<!-- FILTERS -->\n" +
    "				<tr class=\"column-filters\">\n" +
    "					<td ng-repeat=\"fltItem in vm.displayCols\">\n" +
    "						<input type=\"text\" ng-model=\"fltItem.flt\" ng-change=\"vm.filterChange()\" style=\"width:100%;\"/>\n" +
    "					</td>\n" +
    "				</tr>\n" +
    "				<!-- LIST ITEMS -->\n" +
    "				<tr class=\"table-list-item\" ng-class=\"{'row-shade':$even}\" ng-mouseenter=\"vm.tblHoverRow(rowItem.id)\" ng-repeat=\"rowItem in vm.displayRows\">\n" +
    "					<td>{{rowItem.title}}</td>\n" +
    "					<td ng-repeat=\"rowSeriesItem in rowItem.series track by rowSeriesItem.id\">{{rowSeriesItem.txt}}</td>\n" +
    "				</tr>\n" +
    "			</tbody>\n" +
    "		</table>\n" +
    "	</div>\n" +
    "	<div class=\"chart-widget ng-hide\" ng-show=\"!!vm.chart.show\" style=\"height:500px;\">\n" +
    "		<div widget-chart-timeseries unique-id=\"{{vm.chart.id}}\"></div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("home/home.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("home/home.tpl.html",
    "<div class=\"home-feature\">\n" +
    "	<!-- USER REVIEW -->\n" +
    "	<section class=\"home-user-review\" ng-show=\"vm.action == 'REVIEW'\">\n" +
    "		<div class=\"page-title-bkg title-bkg-0rows\">&nbsp;</div>\n" +
    "		<section class=\"page-title new-page-top\">\n" +
    "			<h4><span class=\"sprite sprite-dashboard\" aria-hidden=\"true\"></span>&nbsp;Dashboard</h4>\n" +
    "		</section>\n" +
    "		<div class=\"table-popup\">\n" +
    "			<div class=\"table-popup-content\">\n" +
    "				<h5 class=\"table-popup-title\" ng-click=\"vm.userReviewClick('CANCEL')\">Users Access Reviews<span class=\"icon-glyph icon-cancel\"></span></h5>\n" +
    "				<div class=\"popup-content\">\n" +
    "					<p>&nbsp;</p>\n" +
    "					<p class=\"ng-hide\" ng-show=\"!vm.userReview.isOverdue\">You have User Access Reviews due by {{vm.userReview.DueDate | date:'M/d/yyyy'}} for users:</p>\n" +
    "					<p class=\"ng-hide\" ng-show=\"vm.userReview.isOverdue\">User Access Reviews are OVERDUE:</p>\n" +
    "					<p>&nbsp;</p>\n" +
    "					<div ng-class=\"{'scroll-list': vm.userReview.Items.length > 10}\">\n" +
    "						<ul>\n" +
    "							<li ng-repeat=\"user in vm.userReview.Items\" style=\"display:block;\">\n" +
    "								<span class=\"icon-glyph icon-issue\"></span>\n" +
    "								<span ng-class=\"{'review-status-overdue':user.ReviewStatus == 'OVERDUE'}\">{{user.ReviewStatus}}</span>\n" +
    "								{{user.FirstName}}&nbsp;{{user.LastName}}&nbsp;-&nbsp;{{user.UserName}}\n" +
    "							</li>\n" +
    "						</ul>\n" +
    "					</div>\n" +
    "					<p>&nbsp;</p>\n" +
    "					<button type=\"button\" ng-click=\"vm.userReviewClick('REVIEW')\">REVIEW</button>\n" +
    "					&nbsp;&nbsp;<button type=\"button\" class=\"btn-cancel\" ng-click=\"vm.userReviewClick('CANCEL')\">REVIEW LATER</button>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</section>\n" +
    "	<!-- NO CHARTS / PROMPT -->\n" +
    "	<section class=\"home-splash ng-hide\" ng-show=\"vm.action == 'NOCHARTS' || vm.action == 'PROMPT' || vm.action == 'NODASH'\">\n" +
    "		<div class=\"dash-no-widgets ng-hide\" ng-show=\"vm.action == 'NODASH'\">\n" +
    "			<img ng-src=\"assets/img/app/rx-mortar.png?v={{vmApp.appVersion}}\" />\n" +
    "		</div>\n" +
    "		<div class=\"ng-hide\" ng-show=\"vm.action == 'NOCHARTS'\">\n" +
    "			<p>&nbsp;</p>\n" +
    "			<h5>Charts Not Available</h5>\n" +
    "			<p>{{vm.nodashMsg}}</p>\n" +
    "		</div>\n" +
    "		<div class=\"dash-user-prompt ng-hide\" ng-show=\"vm.action == 'PROMPT'\">\n" +
    "			<h1>Get customized insights and alerts</h1>\n" +
    "			<p><button type=\"button\" ng-click=\"vm.setupToggle()\">Setup Dashboard...</button></p>\n" +
    "			<img ng-src=\"assets/img/app/dash-graph.png?v={{vmApp.appVersion}}\" />\n" +
    "		</div>\n" +
    "	</section>\n" +
    "	<!-- LAYOUT OR SETUP -->\n" +
    "	<div class=\"home-layout ng-hide\" ng-show=\"vm.action == 'LAYOUT' || vm.action == 'SETUP'\">\n" +
    "		<div class=\"page-title-bkg title-bkg-0rows\">&nbsp;</div>\n" +
    "		<section class=\"page-title new-page-top\">\n" +
    "			<h4><span class=\"sprite sprite-dashboard\" aria-hidden=\"true\"></span>&nbsp;Dashboard</h4>\n" +
    "		</section>\n" +
    "		<!-- SETUP -->\n" +
    "		<section class=\"home-dash-setup ng-hide\" ng-show=\"vm.action == 'SETUP'\">\n" +
    "			<h5><span class=\"sprite sprite-money\"></span>&nbsp;Setup</h5>\n" +
    "			<p>Choose a default Facility and Pharmacy to get started.</p>\n" +
    "			<p>Charts are automatically chosen for you during the Setup process.</p>\n" +
    "		</section>\n" +
    "		<!-- CE RX DEFAULTS -->\n" +
    "		<div class=\"home-dash-defaults\">\n" +
    "			<form name=\"dashDefaults\" novalidate>\n" +
    "				<fieldset>\n" +
    "					<h5 class=\"ng-hide\" ng-show=\"vm.action == 'SETUP'\">Default Settings</h5>\n" +
    "					<div class=\"dash-cerx-layout\">\n" +
    "						<!-- CE/RX DROPLISTS -->\n" +
    "						<div class=\"fieldset-row dash-cerx\">\n" +
    "							<div class=\"form-field input-drop dash-ce\">\n" +
    "								<label ng-class=\"{'same-width': vm.action == 'SETUP', 'auto-width': vm.action == 'LAYOUT'}\" for=\"homeDashCE\">Facility</label>\n" +
    "								<select id=\"homeDashCE\" ng-model=\"vm.dashCE.val\" ng-change=\"vm.dashChangeCE()\" ng-disabled=\"vm.isWaiting\"\n" +
    "									ng-options=\"dashCeItem.value as dashCeItem.label group by ' ' for dashCeItem in vm.dashCeDroplist\">\n" +
    "								</select>\n" +
    "								<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.dashCE.fail == 'yes'}\"></span>\n" +
    "							</div>\n" +
    "							<div class=\"form-field input-drop dash-rx ng-hide\" ng-show=\"vm.dashCE.fail == 'no'\">\n" +
    "								<label class=\"auto-width\" for=\"homeDashRX\">Pharmacy</label>\n" +
    "								<select id=\"homeDashRX\" ng-model=\"vm.dashRX.val\" ng-change=\"vm.dashChangeRX()\" ng-disabled=\"vm.isWaiting\"\n" +
    "									ng-options=\"dashRxItem.value as dashRxItem.label group by ' ' for dashRxItem in vm.dashRxDroplist\">\n" +
    "								</select>\n" +
    "								<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.dashRX.fail == 'yes'}\"></span>\n" +
    "							</div>\n" +
    "							<div class=\"form-field dash-refresh ng-hide\" ng-show=\"vm.action == 'LAYOUT'\">\n" +
    "								<span><button type=\"button\" ng-click=\"vm.dashRefresh()\">REFRESH</button></span>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "						<!-- LAYOUT: LINKS TO RIGHT -->\n" +
    "						<div class=\"form-field edit-links ng-hide\" ng-show=\"vm.action == 'LAYOUT'\">\n" +
    "							<a href ng-click=\"vm.saveDashboard()\"><span class=\"icon-glyph icon-dashboard-save\"></span>&nbsp;Save Dashboard Settings</a>\n" +
    "							&nbsp;&nbsp;<a href ng-click=\"vm.clearDashboard()\"><span class=\"icon-glyph icon-remove\"></span>&nbsp;Clear Dashboard</a>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<!-- SETUP: SUBMIT -->\n" +
    "					<div class=\"form-field form-controls ng-hide\" ng-show=\"vm.action == 'SETUP'\">\n" +
    "						<label>&nbsp;</label>\n" +
    "						<button id=\"btnHomeSaveSetup\" type=\"button\" ng-click=\"vm.saveDashboard()\">SETUP DASHBOARD</button>\n" +
    "						&nbsp;&nbsp;<button id=\"btnHomeCancelSetup\" type=\"button\" class=\"btn-cancel\" ng-click=\"vm.setupToggle()\">CANCEL</button>\n" +
    "					</div>\n" +
    "				</fieldset>\n" +
    "			</form>\n" +
    "		</div>\n" +
    "		<!-- LAYOUT ROWS -->\n" +
    "		<div class=\"ng-hide\" ng-show=\"vm.action == 'LAYOUT' && vm.dashCE.fail == 'no' && vm.dashRX.fail == 'no'\">\n" +
    "			<div widget-scroll scroll-event=\"vm.scrollEvent(scrollTop)\"></div>\n" +
    "			<!-- ROW REPEAT-->\n" +
    "			<div class=\"bi-blocks clearfix\" ng-repeat=\"layoutRowItem in vm.layoutRows\">\n" +
    "				<!-- CHART REPEAT-->\n" +
    "				<div class=\"bi-block-wrapper {{chartItem.config.css + ' bi-w' + chartItem.layoutWidth.toString()}}\"  ng-repeat=\"chartItem in layoutRowItem.charts\">\n" +
    "					<div class=\"bi-block\">\n" +
    "						<div class=\"bi-title\">\n" +
    "							<span>{{chartItem.display.title}}</span>\n" +
    "							<div class=\"bi-controls\">\n" +
    "								<span class=\"icon-glyph icon-list ng-hide\" ng-show=\"!!!chartItem.panelMode && chartItem.status == 'DRAW'\" ng-click=\"chartItem.panelMode = 'TABLEVIEW'; $scope.$apply();\" aria-hidden=\"true\"></span>\n" +
    "								<span class=\"icon-glyph icon-zoom-in ng-hide\" ng-show=\"!!chartItem.link && !!!chartItem.panelMode && chartItem.status == 'DRAW'\" ng-click=\"chartItem.panelMode = 'LINK'\" aria-hidden=\"true\"></span>\n" +
    "								<span class=\"icon-glyph icon-info ng-hide\" ng-show=\"!!!chartItem.panelMode && (chartItem.status == 'EDIT' || chartItem.status == 'DRAW')\" ng-click=\"chartItem.panelMode = 'CALC'\" aria-hidden=\"true\"></span>\n" +
    "								<span class=\"icon-glyph icon-settings ng-hide\" ng-show=\"!!chartItem.query.canEdit && chartItem.status == 'DRAW'\" ng-click=\"vm.queryEdit(chartItem.id)\" aria-hidden=\"true\"></span>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "						<div class=\"bi-content\" ng-class=\"{'bi-edit-mode': chartItem.status == 'EDIT'}\">\n" +
    "							<div class=\"bi-info-panel\" ng-class=\"{'panel-show': !!chartItem.panelMode}\">\n" +
    "								<div class=\"ng-hide\" ng-show=\"chartItem.panelMode == 'CALC'\">\n" +
    "									<h5>Calculation Note</h5>\n" +
    "									<h1><span class=\"icon-glyph icon-info\"></span></h1>\n" +
    "									<p ng-repeat=\"infoPanelItem in chartItem.display.info\">{{infoPanelItem}}</p>\n" +
    "									<p><a href ng-click=\"chartItem.panelMode = ''\"><span class=\"icon-glyph icon-remove\"></span>Close</a></p>\n" +
    "								</div>\n" +
    "								<div class=\"ng-hide\" ng-show=\"chartItem.panelMode == 'LINK'\">\n" +
    "									<h5>Closer Look</h5>\n" +
    "									<h1><span class=\"icon-glyph icon-zoom-in\"></span></h1>\n" +
    "									<p>{{chartItem.link.title}}</p>\n" +
    "									<p><a href ng-click=\"vm.linkToFeature(chartItem.id)\">{{chartItem.link.display}}</a></p>\n" +
    "									<p><a href ng-click=\"chartItem.panelMode = ''\"><span class=\"icon-glyph icon-remove\"></span>Close</a></p>\n" +
    "								</div>\n" +
    "								<div class=\"ng-hide\" ng-show=\"chartItem.panelMode == 'LOAD'\">\n" +
    "									<h5>Loading Data</h5>\n" +
    "									<h1><span class=\"icon-glyph icon-wait\"></span></h1>\n" +
    "								</div>\n" +
    "								<div class=\"ng-hide\" ng-show=\"chartItem.panelMode == 'TABLEVIEW'\">\n" +
    "									<h5>Data Table</h5>\n" +
    "									<p><a href ng-click=\"chartItem.panelMode = ''\"><span class=\"icon-glyph icon-remove\"></span>Close</a></p>\n" +
    "									<div style=\"overflow-y: scroll;max-height: 150px; background-color: #fff;\" ng-switch=\"chartItem.config.chartType\">\n" +
    "										<table class=\"table-simple\" ng-switch-when=\"LINE\" style=\"width:auto; margin:0 auto 0 auto;\">\n" +
    "											<tbody>\n" +
    "												<tr><td>Date</td><td>Value</td></tr>\n" +
    "												<tr ng-repeat=\"tableViewItem in chartItem.data\" ng-class=\"{'row-shade':$even}\"><td style=\"font-size:0.8em;\">{{tableViewItem.date | date:'M/d/yyyy'}}</td><td style=\"font-size:0.8em;\">{{tableViewItem.val | number}}</td></tr>\n" +
    "											</tbody>\n" +
    "										</table>\n" +
    "										<table class=\"table-simple\" ng-switch-when=\"VBAR\" style=\"width:auto; margin:0 auto 0 auto;\">\n" +
    "											<tbody>\n" +
    "												<tr>\n" +
    "													<td ng-repeat=\"tableViewVbarTitleItem in chartItem.config.label.lines\">{{tableViewVbarTitleItem.title}}</td>\n" +
    "												</tr>\n" +
    "												<tr ng-repeat=\"tableViewVbarItem in chartItem.data\" ng-class=\"{'row-shade':$even}\">\n" +
    "													<td ng-repeat=\"tableViewVbarItemLine in chartItem.config.label.lines\" style=\"font-size:0.8em;\">\n" +
    "														{{tableViewVbarItem[tableViewVbarItemLine.dataProp]}}\n" +
    "													</td>\n" +
    "												</tr>\n" +
    "											</tbody>\n" +
    "										</table>\n" +
    "										<table class=\"table-simple\" ng-switch-when=\"PIE\" style=\"width:auto; margin:0 auto 0 auto;\">\n" +
    "											<tbody>\n" +
    "												<tr><td>Name</td><td>Percent</td><td>Value</td></tr>\n" +
    "												<tr ng-repeat=\"tableViewItem in chartItem.data\" ng-class=\"{'row-shade':$even}\">\n" +
    "													<td style=\"font-size:0.8em;\">{{tableViewItem.name | date:'M/d/yyyy'}}</td>\n" +
    "													<td style=\"font-size:0.8em;\">{{tableViewItem.percent | number}}%</td>\n" +
    "													<td style=\"font-size:0.8em;\">{{tableViewItem.val | number}}</td>\n" +
    "												</tr>\n" +
    "											</tbody>\n" +
    "										</table>\n" +
    "									</div>\n" +
    "								</div>\n" +
    "								<div class=\"ng-hide\" ng-show=\"chartItem.panelMode == 'NODATA'\">\n" +
    "									<h5>Data Series Empty</h5>\n" +
    "									<h1><span class=\"icon-glyph icon-no-data\"></span></h1>\n" +
    "									<p>Charting data not available. Extend the time period to view more results.</p>\n" +
    "									<p><a href ng-click=\"chartItem.panelMode = ''\"><span class=\"icon-glyph icon-remove\"></span>Close</a></p>\n" +
    "								</div>\n" +
    "								<div class=\"ng-hide\" ng-show=\"chartItem.panelMode == 'ERR'\">\n" +
    "									<h5><span class=\"icon-glyph icon-err-warn\"></span>Unexpected Data Error</h5>\n" +
    "									<p>{{chartItem.errMsg}}</p>\n" +
    "									<p>{{chartItem.errDetail}}</p>\n" +
    "									<p><a href ng-click=\"chartItem.panelMode = ''\"><span class=\"icon-glyph icon-remove\"></span>Close</a></p>\n" +
    "								</div>\n" +
    "								<div class=\"ng-hide\" ng-show=\"chartItem.panelMode == 'NOCHART'\">\n" +
    "									<h5><span class=\"icon-glyph icon-err-warn\"></span>Chart Not Available</h5>\n" +
    "									<p>{{chartItem.errMsg}}</p>\n" +
    "									<p>{{chartItem.errDetail}}</p>\n" +
    "									<p><a href ng-click=\"chartItem.panelMode = ''\"><span class=\"icon-glyph icon-remove\"></span>Close</a></p>\n" +
    "								</div>\n" +
    "							</div>\n" +
    "							<div class=\"bi-edit-panel ng-hide\" ng-show=\"chartItem.status == 'EDIT'\">\n" +
    "								<form name=\"{{chartItem.id}}\" ng-submit=\"vm.querySubmit(chartItem.id)\" novalidate>\n" +
    "									<h5><span class=\"icon-glyph icon-settings\"></span>Chart Settings</h5>\n" +
    "									<fieldset>\n" +
    "										<div ng-repeat=\"queryProp in chartItem.query.props\" ng-switch=\"queryProp.type\">\n" +
    "											<div class=\"form-field input-drop\" ng-switch-when=\"CE\">\n" +
    "												<label class=\"same-width\">Facility</label>\n" +
    "												<span class=\"ng-hide\" ng-show=\"queryProp.list.length < 1\" style=\"vertical-align:middle;padding-left:0;\">required</span>\n" +
    "												<span class=\"ng-hide\" ng-show=\"queryProp.list.length > 0\" style=\"padding-left:0;\">\n" +
    "													<select ng-model=\"queryProp.val\" ng-change=\"vm.queryChange(chartItem.id, 'CE')\"\n" +
    "														ng-options=\"queryPropCeItem.value as queryPropCeItem.label group by ' ' for queryPropCeItem in queryProp.list\">\n" +
    "													</select>\n" +
    "													<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': queryProp.fail == 'yes'}\"></span>\n" +
    "												</span>\n" +
    "											</div>\n" +
    "											<div class=\"form-field input-drop\" ng-switch-when=\"RX\">\n" +
    "												<label class=\"same-width\">Pharmacy</label>\n" +
    "												<span class=\"ng-hide\" ng-show=\"queryProp.list.length < 1\" style=\"vertical-align:middle;padding-left:0;\">required</span>\n" +
    "												<span class=\"ng-hide\" ng-show=\"queryProp.list.length > 0\" style=\"padding-left:0;\">\n" +
    "													<select ng-model=\"queryProp.val\" ng-change=\"vm.queryChange(chartItem.id, 'RX')\"\n" +
    "														ng-options=\"queryPropRxItem.value as queryPropRxItem.label group by ' ' for queryPropRxItem in queryProp.list\">\n" +
    "													</select>\n" +
    "													<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': queryProp.fail == 'yes'}\"></span>\n" +
    "												</span>\n" +
    "											</div>\n" +
    "											<div class=\"form-field input-drop\" ng-switch-when=\"Weeks\">\n" +
    "												<label class=\"same-width\">Weeks</label>\n" +
    "												<select ng-model=\"queryProp.val\" ng-change=\"vm.queryChange(chartItem.id, 'Weeks')\"\n" +
    "													ng-options=\"queryPropWeeksItem.value as queryPropWeeksItem.label for queryPropWeeksItem in queryProp.list\">\n" +
    "												</select>\n" +
    "												<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': queryProp.fail == 'yes'}\"></span>\n" +
    "											</div>\n" +
    "										</div>\n" +
    "										<div class=\"form-field\">\n" +
    "											<label class=\"same-width btn-spacer\">&nbsp;</label>\n" +
    "											<button class=\"btnLoadChart\" type=\"submit\">LOAD CHART</button>\n" +
    "										</div>\n" +
    "									</fieldset>\n" +
    "								</form>\n" +
    "							</div>\n" +
    "							<widget-chart-host class=\"bi-chart\" unique-id=\"chartItem.id\" chart-type=\"chartItem.config.chartType\"></widget-chart-host>\n" +
    "						</div>\n" +
    "						<p class=\"bi-footer\">{{chartItem.display.footer}}</p>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("home/layout/ui/footer.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("home/layout/ui/footer.tpl.html",
    "<div class=\"footer-box ng-hide\" ng-show=\"vmFooter.show\">\n" +
    "	<div class=\"footer-left\">\n" +
    "		<p class=\"subtitle\">Verity Solutions, Copyright ©2026</p>\n" +
    "	</div>\n" +
    "	<div class=\"footer-right\">\n" +
    "		<a href class=\"ng-hide\" ng-show=\"!!vmFooter.authValid\" ng-click=\"vmFooter.linkTo('TERMS')\">Terms of Use & Privacy Policy</a>\n" +
    "		<a href ng-click=\"vmFooter.linkTo('ABOUT')\">About Verity</a>\n" +
    "		<a href ng-click=\"vmFooter.linkTo('CONTACT')\">Contact Us</a>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("home/layout/ui/header.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("home/layout/ui/header.tpl.html",
    "<div class=\"masthead {{vmHeader.CSSmode}} ng-hide\" ng-show=\"vmHeader.show\">\n" +
    "	<div class=\"mast-left\">\n" +
    "		<img class=\"mast-logo\" ng-src=\"assets/img/brand/logo-reversed.svg?v={{vmApp.appVersion}}\" ng-show=\"!!vmHeader.cobrand\" />\n" +
    "		<nav class=\"main-menu\" ng-class=\"{'click-collapse': !!vmHeader.navCollapse}\" role=\"nav\">\n" +
    "			<ul>\n" +
    "				<li class=\"main-menu-title\" ng-repeat=\"menuSection in vmHeader.menu\">\n" +
    "					<a ng-click=\"vmHeader.navClick(menuSection)\" ng-bind=\"menuSection.title\"></a>\n" +
    "					<ul class=\"menu-sub-list ng-hide\" ng-show=\"!!!vmHeader.navCollapse && menuSection.navItems.length > 0\">\n" +
    "						<li ng-repeat=\"navItem in menuSection.navItems\">\n" +
    "							<a ng-click=\"vmHeader.navClick(navItem)\"><span class=\"sprite-menu\" ng-class=\"navItem.sprite\" aria-hidden=\"true\"></span>&nbsp;&nbsp;{{navItem.title}}</a>\n" +
    "						</li>\n" +
    "					</ul>\n" +
    "				</li>\n" +
    "				<li class=\"main-menu-title ng-hide\" ng-show=\"vmHeader.debug == 'on'\">\n" +
    "					<a>DEBUG</a>\n" +
    "					<ul class=\"menu-sub-list\">\n" +
    "						<li class=\"header-debug\" ng-repeat=\"debugItem in vmHeader.debugItems\">\n" +
    "							<a>{{debugItem}}</a>\n" +
    "						</li>\n" +
    "					</ul>\n" +
    "				</li>\n" +
    "				<li class=\"main-menu-title ng-hide\" ng-show=\"vmHeader.showHelp == 'yes'\">\n" +
    "					<a>HELP</a>\n" +
    "					<ul class=\"menu-sub-list\">\n" +
    "						<li>\n" +
    "							<a ng-click=\"vmHeader.gotoHelp('')\"><span class=\"sprite-menu sprite-about-corp\" aria-hidden=\"true\"></span>&nbsp;&nbsp;HELP CENTER</a>\n" +
    "						</li>\n" +
    "					</ul>\n" +
    "				</li>				\n" +
    "			</ul>\n" +
    "		</nav>\n" +
    "	</div>\n" +
    "	<div class=\"mast-right\">\n" +
    "		<div class=\"header-mode-title ng-hide\" ng-show=\"vmHeader.debug == 'on' || vmHeader.isImpersonate\">\n" +
    "			<h5>\n" +
    "				<span class=\"ng-hide\" ng-show=\"vmHeader.isImpersonate\">EMULATION</span>\n" +
    "				<span class=\"ng-hide\" ng-show=\"vmHeader.debug == 'on'\">{{vmHeader.debugENV | uppercase}}</span>\n" +
    "				<span>MODE</span>\n" +
    "			</h5>\n" +
    "		</div>\n" +
    "		<p class=\"app-version\">{{vmHeader.appVersion}}</p>\n" +
    "		<!-- horizontal user options -->\n" +
    "		<ul class=\"user-options\">\n" +
    "			<!--li>feedback link tbd </li -->\n" +
    "			<li class=\"mast-right-alert-title ng-hide\" ng-show=\"vmHeader.authValid && vmHeader.uType!='RX' && vmHeader.uType != 'RXROLLUP'\">\n" +
    "				<a href ng-click=\"vmHeader.toggleAlertList()\">\n" +
    "					<span class=\"icon-glyph\" ng-class=\"vmHeader.alertInfo.icon\" aria-hidden=\"true\">{{vmHeader.alertInfo.TotalFail}}</span>Alerts\n" +
    "				</a>\n" +
    "			</li>\n" +
    "			<li class=\"mast-right-account-title ng-hide\" ng-show=\"vmHeader.authValid\">\n" +
    "				<a href ng-click=\"vmHeader.toggleUserOptions()\">\n" +
    "					<span class=\"icon-glyph glyphicon-user\"></span>{{vmHeader.acctName}}\n" +
    "				</a>\n" +
    "			</li>\n" +
    "		</ul>\n" +
    "		<!-- alerts: vertical droplist -->\n" +
    "		<div class=\"alert-droplist ng-hide\" ng-show=\"vmHeader.alertInfo.show == 'yes'\">\n" +
    "			<div class=\"alert-list-title\">\n" +
    "				<h5><span class=\"icon-glyph icon-alert\"></span>&nbsp;Alerts</h5>\n" +
    "				<a ng-click=\"vmHeader.toggleAlertList()\"><span class=\"icon-gyph icon-exit\"></span>&nbsp;Close</a>\n" +
    "			</div>\n" +
    "			<p class=\"alert-list-notify\">Follow Alerts With Status:\n" +
    "				<span ng-click=\"vmHeader.alertNotifyToggle('notifyPass'); $scope.$apply();\"><span class=\"icon-glyph\" ng-class=\"{'icon-checked':vmHeader.alertInfo.notifyPass == 'yes', 'icon-unchecked':vmHeader.alertInfo.notifyPass == 'no'}\" ></span>Pass</span>\n" +
    "				<span ng-click=\"vmHeader.alertNotifyToggle('notifyFail'); $scope.$apply();\"><span class=\"icon-glyph\" ng-class=\"{'icon-checked':vmHeader.alertInfo.notifyFail == 'yes', 'icon-unchecked':vmHeader.alertInfo.notifyFail == 'no'}\" ></span>Fail</span>\n" +
    "			</p>\n" +
    "			<div class=\"alert-list-items\">\n" +
    "				<div class=\"alert-list-item-header\">\n" +
    "					<p class=\"ng-hide\" ng-show=\"vmHeader.alertInfo.items.length < 1\">No alerts found.</p>\n" +
    "					<ul class=\"ng-hide\" ng-show=\"vmHeader.alertInfo.items.length > 0\">\n" +
    "						<li class=\"alert-list-item-icon\">&nbsp;</li>\n" +
    "						<li class=\"alert-list-item-mtype\" ng-click=\"vmHeader.sortBy('MonitorType', vmHeader.alertInfo); $scope.$apply();\">\n" +
    "							<a>Monitor<span class=\"icon-glyph\" ng-class=\"vmHeader.sortByIcon('MonitorType', vmHeader.alertInfo.SortBy)\"></span></a>\n" +
    "						</li>\n" +
    "						<li class=\"alert-list-item-pass\" ng-click=\"vmHeader.sortBy('PassCount', vmHeader.alertInfo); $scope.$apply();\">\n" +
    "							<a>Pass<span class=\"icon-glyph\" ng-class=\"vmHeader.sortByIcon('PassCount', vmHeader.alertInfo.SortBy)\"></span></a>\n" +
    "						</li>\n" +
    "						<li class=\"alert-list-item-fail\" ng-click=\"vmHeader.sortBy('FailCount', vmHeader.alertInfo); $scope.$apply();\">\n" +
    "							<a>Fail<span class=\"icon-glyph\" ng-class=\"vmHeader.sortByIcon('FailCount', vmHeader.alertInfo.SortBy)\"></span></a>\n" +
    "						</li>\n" +
    "					</ul>\n" +
    "				</div>\n" +
    "				<div class=\"alert-list-item\" ng-class=\"{'row-shade':$even}\" ng-click=\"vmHeader.gotoAlert(headerAlertItem)\"\n" +
    "					ng-repeat=\"headerAlertItem in vmHeader.alertInfo.items\n" +
    "						| orderBy: vmHeader.alertInfo.SortBy\">\n" +
    "						<!-- tbd... user option to filter monitors by notify flags\n" +
    "						| filter:{'PassChange':vmHeader.alertInfo.notifyPass}:true\n" +
    "						| filter:{'FailChange':vmHeader.alertInfo.notifyFail}:true\n" +
    "						-->\n" +
    "					<ul class=\"clearfix\">\n" +
    "						<li class=\"alert-list-item-icon\"><span class=\"icon-glyph\" ng-class=\"headerAlertItem.icon\"></span></li>\n" +
    "						<li class=\"alert-list-item-mtype\">{{headerAlertItem.MonitorType}}</li>\n" +
    "						<li class=\"alert-list-item-pass\">{{headerAlertItem.PassCount | number}}</li>\n" +
    "						<li class=\"alert-list-item-fail\">{{headerAlertItem.FailCount | number}}</li>\n" +
    "					</ul>\n" +
    "					<p class=\"alert-list-item-dates\">Last Changed&nbsp;{{headerAlertItem.Changed | date:'M/d/yyyy h:mm a'}},&nbsp;&nbsp;Last Checked:&nbsp;{{headerAlertItem.LastChecked | date:'M/d/yyyy h:mm a'}}</p>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<!-- account options: vertical droplist -->\n" +
    "		<div class=\"account-droplist ng-hide\" ng-show=\"vmHeader.showUserOptions == 'yes'\">\n" +
    "			<ul>\n" +
    "				<li class=\"ng-hide\" ng-show=\"!vmHeader.isImpersonate\">\n" +
    "					<a ng-click=\"vmHeader.myAccount()\">\n" +
    "						<span class=\"sprite-menu sprite-users\" aria-hidden=\"true\"></span>&nbsp;&nbsp;My Account\n" +
    "					</a>\n" +
    "				</li>\n" +
    "				<li class=\"ng-hide\" ng-show=\"!vmHeader.isImpersonate\">\n" +
    "					<a ng-click=\"vmHeader.myPreferences()\">\n" +
    "						<span class=\"sprite-menu sprite-settings\" aria-hidden=\"true\"></span>&nbsp;&nbsp;Preferences\n" +
    "					</a>\n" +
    "				</li>\n" +
    "				<li class=\"ng-hide\" ng-show=\"!vmHeader.isImpersonate\">\n" +
    "					<a ng-click=\"vmHeader.newTab()\">\n" +
    "						<span class=\"sprite-menu sprite-settings\" aria-hidden=\"true\"></span>&nbsp;&nbsp;New Tab\n" +
    "					</a>\n" +
    "				</li>\n" +
    "				<li>\n" +
    "					<a id=\"header_logout\" ng-click=\"vmHeader.logout()\">\n" +
    "						<span class=\"sprite-menu sprite-off\" aria-hidden=\"true\"></span>&nbsp;&nbsp;Log Out\n" +
    "					</a>\n" +
    "				</li>\n" +
    "			</ul>\n" +
    "		</div>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("home/layout/ui/msgbox.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("home/layout/ui/msgbox.tpl.html",
    "<div class=\"ng-hide\" ng-show=\"!!vmMsgbox.visible\" ng-class=\"vmMsgbox.msgType\">\n" +
    "	<!-- FLARE SLIDE OUT -->\n" +
    "	<aside class=\"msg-help-flyout ng-hide\" ng-show=\"vmMsgbox.msgType == 'help-flyout'\" ng-class=\"{'flyshow':!!vmMsgbox.display.flyshow}\">\n" +
    "		<img class=\"flyout-bkg\" ng-src=\"/assets/img/app/inlinehelp-bkg.jpg?v={{vmApp.appVersion}}\" />\n" +
    "		<div class=\"flyout-banner\">\n" +
    "			<h3>Help\n" +
    "				<span class=\"flyout-banner-right\"><a href ng-click=\"vmMsgbox.goToHelpCenter()\">Go To Help Center</a></span>\n" +
    "			</h3>\n" +
    "		</div>\n" +
    "		<div class=\"flyout-content\">\n" +
    "			<div class=\"flyout-waiting\">\n" +
    "				<span>\n" +
    "					<img ng-src=\"/assets/img/app/waitB.gif?v={{vmApp.appVersion}}\" />\n" +
    "				</span>\n" +
    "			</div>\n" +
    "			<iframe widget-iframe-load ng-src=\"{{vmMsgbox.display.path}}\"\n" +
    "				class=\"msg-help-flyframe\" ng-class=\"{'fade-in': !!vmMsgbox.display.fadeIn}\"\n" +
    "				iframe-on-load=\"vmMsgbox.iframeOnLoad(src)\"></iframe>\n" +
    "		</div>\n" +
    "    </aside>\n" +
    "	<div class=\"msg-wait ng-hide\" ng-show=\"vmMsgbox.msgType == 'wait'\" ng-style=\"{top:vmMsgbox.waitTop}\">\n" +
    "		<span><img ng-src=\"/assets/img/app/waitB.gif?v={{vmApp.appVersion}}\" /></span>\n" +
    "		<p ng-bind=\"vmMsgbox.waitMsg\"></p>\n" +
    "	</div>\n" +
    "	<div class=\"msg-content ng-hide\" ng-show=\"vmMsgbox.msgType == 'ok' || vmMsgbox.msgType == 'timeout' || vmMsgbox.msgType == 'info' || vmMsgbox.msgType == 'confirm'\">\n" +
    "		<h3>\n" +
    "			<span class=\"icon-glyph\" ng-class=\"{'icon-clock': vmMsgbox.msgType == 'timeout','icon-msg-info':vmMsgbox.msgType == 'info','icon-msg-confirm':vmMsgbox.msgType == 'confirm'}\" aria-hidden=\"true\"></span>\n" +
    "			{{vmMsgbox.display.title}}\n" +
    "		</h3>\n" +
    "		<p>{{vmMsgbox.display.msg}}</p>\n" +
    "		<div class=\"msg-detail ng-hide\" ng-show=\"!!vmMsgbox.display.detail\">\n" +
    "			<a ng-click=\"vm.showDetail = !!!vm.showDetail;\">Details...</a>\n" +
    "			<p class=\"ng-hide\" ng-show=\"!!vm.showDetail\">{{vmMsgbox.display.detail}}</p>\n" +
    "		</div>\n" +
    "		<p class=\"ng-hide\" ng-show=\"!!vmMsgbox.display.notes.prompt\">\n" +
    "			<input type=\"text\" placeholder=\"{{vmMsgbox.display.notes.prompt}}\" maxlength=\"{{vmMsgbox.display.notes.maxlength}}\" ng-model=\"vmMsgbox.display.notes.out\" style=\"width:20em;\"/>\n" +
    "		</p>\n" +
    "		<p class=\"ng-hide\" ng-show=\"!!vmMsgbox.display.async\">\n" +
    "			Please note, there may be a brief delay before the display is updated. you might need to refresh your current view.\n" +
    "		</p>\n" +
    "		<ul class=\"msg-buttons\">\n" +
    "			<li class=\"ng-hide\" ng-show=\"!!!btn.hide\" ng-repeat=\"btn in vmMsgbox.display.buttons\">\n" +
    "				<button ng-class=\"{'btn-cancel': !!btn.cancel}\" ng-click=\"vmMsgbox.clicked(btn.result)\">{{btn.text}}</button>\n" +
    "			</li>\n" +
    "		</ul>\n" +
    "	</div>\n" +
    "	<div class=\"msg-error ng-hide\" ng-show=\"vmMsgbox.msgType == 'error.info' || vmMsgbox.msgType == 'error.warn' || vmMsgbox.msgType == 'error.unexpected'\">\n" +
    "		<h3>\n" +
    "			<span class=\"icon-glyph\" ng-class=\"{'icon-err-info':vmMsgbox.msgType == 'error.info','icon-err-warn':vmMsgbox.msgType == 'error.warn','icon-err-unexpected':vmMsgbox.msgType == 'error.unexpected'}\" aria-hidden=\"true\"></span>\n" +
    "			{{!!vmMsgbox.display.status ? vmMsgbox.display.status + ':&nbsp;' : ''}}{{vmMsgbox.display.title}}\n" +
    "		</h3>\n" +
    "		<p>{{vmMsgbox.display.msg}}</p>\n" +
    "		<div class=\"msg-detail ng-hide\" ng-show=\"!!vmMsgbox.display.detail || !!vmMsgbox.display.stack || !!vmMsgbox.display.line\">\n" +
    "			<a ng-click=\"vm.showDetail = !!!vm.showDetail;\">Details...</a>\n" +
    "			<div class=\"ng-hide\" ng-show=\"!!vm.showDetail\">\n" +
    "				<p class=\"ng-hide\" ng-show=\"!!vmMsgbox.display.detail\">{{vmMsgbox.display.detail}}</p>\n" +
    "				<p class=\"ng-hide\" ng-show=\"!!vmMsgbox.display.stack\">{{vmMsgbox.display.stack}}</p>\n" +
    "				<p class=\"ng-hide\" ng-show=\"!!vmMsgbox.display.line\">{{vmMsgbox.display.line}}</p>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<ul class=\"msg-buttons\">\n" +
    "			<li ng-repeat=\"btn in vmMsgbox.display.buttons\">\n" +
    "				<button ng-class=\"{'btn-cancel': !!btn.cancel}\" ng-click=\"vmMsgbox.clicked(btn.result)\">{{btn.text}}</button>\n" +
    "			</li>\n" +
    "		</ul>\n" +
    "	</div>\n" +
    "	<div class=\"msg-help ng-hide\" ng-show=\"vmMsgbox.msgType == 'help'\">\n" +
    "		<h4>\n" +
    "			<span class=\"icon-glyph icon-help\" aria-hidden=\"true\"></span>{{vmMsgbox.display.title}}&nbsp;Help\n" +
    "			<a href ng-click=\"vmMsgbox.clicked('CANCEL');\">Exit</a>\n" +
    "		</h4>\n" +
    "		<div class=\"msg-help-content\"><div ng-include=\"vmMsgbox.display.path\"></div></div>\n" +
    "	</div>\n" +
    "	<div class=\"msg-content release ng-hide\" ng-show=\"vmMsgbox.msgType == 'release'\">\n" +
    "		<h3>\n" +
    "			<img ng-src=\"assets/img/app/newspaper.svg?v={{vmApp.appVersion}}\" />\n" +
    "			New Release Update {{vmMsgbox.display.version}}\n" +
    "		</h3>\n" +
    "		<ul class=\"msg-buttons\">\n" +
    "			<li>\n" +
    "				<button ng-click=\"vmMsgbox.clicked('OPEN')\">VIEW RELEASE NOTES</button>\n" +
    "			</li>\n" +
    "			<li>\n" +
    "				<button class=\"btn-cancel\" ng-click=\"vmMsgbox.clicked('CANCEL')\">NO THANKS</button>\n" +
    "			</li>\n" +
    "		</ul>\n" +
    "		<p>&nbsp;</p>\n" +
    "	</div>\n" +
    "	<div class=\"msg-bkg\" ng-class=\"{'lighten': vmMsgbox.msgType == 'help-flyout'}\" ng-click=\"vmMsgbox.clicked('CANCEL');\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("home/login/login.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("home/login/login.tpl.html",
    "<div class=\"login-feature\" ng-class=\"vm.cobrandCSS()\">\n" +
    "	<div class=\"ng-hide login-bars\" ng-show=\"!vm.uiLanding && vm.action != 'loginland'\">\n" +
    "		<div class=\"sprite-login\" ng-class=\"[guiBar.name, guiBar.pos]\" ng-repeat=\"guiBar in vm.guiBars\">&nbsp;</div>\n" +
    "	</div>\n" +
    "	<form name=\"loginForm\" ng-class=\"{'login-form-wide-tou': vm.action == 'vtou', 'login-form-wide-ctou': vm.action == 'ctou', 'login-form-wide-resetna': vm.action == 'resetnotavailable'}\" ng-submit=\"vm.submit()\" novalidate>\n" +
    "		<div class=\"ng-hide\" ng-show=\"vm.uiLanding\">\n" +
    "			<img ng-src=\"assets/img/app/bd-landing.png?v={{vmApp.appVersion}}\" />\n" +
    "		</div>\n" +
    "		<fieldset>\n" +
    "			<p class=\"ng-hide\" ng-show=\"vm.uiLanding && vm.action != 'loginland'\">&nbsp;</p>\n" +
    "			<h3 class=\"login-title\" ng-class=\"{'loginland': vm.action == 'loginland'}\">\n" +
    "				<span class=\"login-img\"><span class=\"icon-glyph ng-hide\" ng-show=\"!vm.uiLanding\" ng-class=\"vm.loginIcon\" aria-hidden=\"true\"></span></span>\n" +
    "				{{vm.loginTitle}}\n" +
    "			</h3>\n" +
    "			<p class=\"login-subtitle ng-hide\" ng-show=\"vm.action == 'block'\">We cannot complete your login request. Contact Verity Solutions support at (800) 581-1378 or support@verity340b.com</p>\n" +
    "			<p class=\"login-subtitle\" ng-class=\"{'loginland': vm.action == 'loginland'}\">{{vm.loginMsg}}</p>\n" +
    "			<div class=\"form-field ng-hide\" ng-show=\"vm.showDismiss\">\n" +
    "				<label>&nbsp;</label><button type=\"button\" class=\"btn-alt\" ng-click=\"vm.dismissOK()\">OK</button>\n" +
    "			</div>\n" +
    "            <!-- LOGIN STEP 1 - USER EMAIL -->\n" +
    "			<div class=\"ng-hide\" ng-show=\"vm.action == 'login' || vm.action == 'partneractivate'\">\n" +
    "                <div class=\"form-field input-email\">\n" +
    "					<label for=\"Login1Email\">Account Email Address</label>\n" +
    "					<input id=\"Login1Email\" name=\"Email\" type=\"email\" placeholder=\"email address\" maxlength=\"254\" ng-model=\"vm.model.Email.val\" />\n" +
    "					<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': vm.model.Email.fail == 'no', 'icon-invalid': vm.model.Email.fail == 'yes'}\"></span>\n" +
    "					<p class=\"ng-hide\" ng-show=\"vm.model.Email.fail == 'yes'\"><span class=\"field-msg\">{{vm.model.Email.msg}}</span></p>\n" +
    "				</div>\n" +
    "                <!-- PARTNER SSO ERROR -->\n" +
    "                <div class=\"ng-hide\" ng-show=\"vm.partner.fail == 'yes'\">\n" +
    "                    <p>&nbsp;</p>\n" +
    "                    <p>{{vm.partner.msg}}</p>\n" +
    "                    <p ng-repeat=\"infoItem in vm.partner.info\" ng-switch=\"infoItem.type\">\n" +
    "                        <a href class=\"ng-hide\" ng-switch-when=\"link\" ng-click=\"vm.partnerLink(infoItem.link)\">{{infoItem.text}}</a>\n" +
    "                        <span class=\"ng-hide\" ng-switch-default>{{infoItem.text}}</span>\n" +
    "                    </p>\n" +
    "                </div>\n" +
    "                <div class=\"form-field form-controls\">\n" +
    "                    <button id=\"loginPartnerSSOFail\" type=\"button\" class=\"ng-hide\" ng-show=\"vm.partner.fail == 'yes'\" ng-click=\"vm.dismissOK()\">OK</button>\n" +
    "                    <button id=\"LoginSubmit1\" type=\"submit\" class=\"ng-hide\" ng-show=\"vm.partner.fail != 'yes'\">{{vm.action == 'partneractivate' ? 'ACTIVATE' : 'NEXT'}}</button>\n" +
    "                </div>\n" +
    "                <p>&nbsp;</p>\n" +
    "            </div>\n" +
    "            <!-- PARTNER START SSO -->\n" +
    "			<div class=\"ng-hide\" ng-show=\"vm.action == 'login-sso'\">\n" +
    "                <p>&nbsp;</p>\n" +
    "                <p>{{vm.partner.Name}}</p>\n" +
    "                <p>{{vm.model.Email.val}}</p>\n" +
    "				<div class=\"form-field form-controls ng-hide\" ng-show=\"vm.partner.fail == 'no'\">\n" +
    "                    <div class=\"form-field form-controls\">\n" +
    "                        <button id=\"loginPartnerSSOGo\" type=\"button\" ng-click=\"vm.partnerStartSSO()\">PARTNER SIGN-IN...</button>\n" +
    "                        <p style=\"padding:20px 0 0 0;\"><button id=\"loginPartnerDecline\" type=\"button\" class=\"btn-cancel\" ng-click=\"vm.dismissOK()\">CANCEL</button></p>\n" +
    "                    </div>\n" +
    "				</div>\n" +
    "                <p>&nbsp;</p>\n" +
    "            </div>\n" +
    "			<!-- MULTIPURPOSE LOGIN / PWD ENTRY -->\n" +
    "			<div class=\"ng-hide\" ng-show=\"vm.action == 'login-pwd' || vm.action == 'pwdactivate' || vm.action == 'pwdupdate' || vm.action == 'pwdresetemail'\">\n" +
    "				<div class=\"form-field input-email ng-hide\" ng-show=\"vm.action != 'pwdupdate'\">\n" +
    "					<label for=\"LoginEmail\">Account Email Address</label>\n" +
    "					<input id=\"LoginEmail\" name=\"Email\" type=\"email\" placeholder=\"email address\" maxlength=\"254\" ng-model=\"vm.model.Email.val\" />\n" +
    "					<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': vm.model.Email.fail == 'no', 'icon-invalid': vm.model.Email.fail == 'yes'}\"></span>\n" +
    "					<p class=\"ng-hide\" ng-show=\"vm.model.Email.fail == 'yes'\"><span class=\"field-msg\">{{vm.model.Email.msg}}</span></p>\n" +
    "				</div>\n" +
    "				<div class=\"fieldset-row\" ng-class=\"{'pwd-entry':vm.action == 'pwdactivate' || vm.action == 'pwdupdate' || vm.action == 'pwdresetemail'}\">\n" +
    "					<!-- PWD STRENGTH -->\n" +
    "					<div class=\"form-field pwd-strength ng-hide\" ng-show=\"vm.action == 'pwdactivate' || vm.action == 'pwdupdate' || vm.action == 'pwdresetemail'\">\n" +
    "						<p>Strength Check</p>\n" +
    "						<p class=\"strong-check\">\n" +
    "							<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': vm.model.Pwd.hasLength, 'icon-cancel':!vm.model.Pwd.hasLength}\"></span>\n" +
    "							Length 8 - 30 Characters\n" +
    "						</p>\n" +
    "						<p class=\"strong-check\">\n" +
    "							<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': vm.model.Pwd.hasUpper, 'icon-cancel':!vm.model.Pwd.hasUpper}\"></span>\n" +
    "							Upper Case Letter (A-Z)\n" +
    "						</p>\n" +
    "						<p class=\"strong-check\">\n" +
    "							<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': vm.model.Pwd.hasLower, 'icon-cancel':!vm.model.Pwd.hasLower}\"></span>\n" +
    "							Lower Case Letter (a-z)\n" +
    "						</p>\n" +
    "						<p class=\"strong-check\">\n" +
    "							<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': vm.model.Pwd.hasNumber, 'icon-cancel':!vm.model.Pwd.hasNumber}\"></span>\n" +
    "							Number (0-9)\n" +
    "						</p>\n" +
    "						<p class=\"strong-check\">\n" +
    "							<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': vm.model.Pwd.hasSymbol, 'icon-cancel':!vm.model.Pwd.hasSymbol}\"></span>\n" +
    "							Symbol (!@#$%^&*)\n" +
    "						</p>\n" +
    "						<p class=\"strong-check\">\n" +
    "							<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': !vm.model.Pwd.hasSpace, 'icon-cancel':vm.model.Pwd.hasSpace}\"></span>\n" +
    "							No Spaces\n" +
    "						</p>\n" +
    "						<p class=\"strong-check ng-hide\" ng-show=\"vm.model.Pwd.notAllowed != ''\">\n" +
    "							<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-cancel':true}\"></span>\n" +
    "							Invalid Characters:&nbsp;{{vm.model.Pwd.notAllowed}}\n" +
    "						</p>\n" +
    "					</div>\n" +
    "					<div class=\"form-field input-pwd\">\n" +
    "						<label for=\"LoginPwd\">Password</label>\n" +
    "						<input id=\"LoginPwd\" name=\"Pwd\" type=\"password\" placeholder=\"password\" maxlength=\"30\" ng-model=\"vm.model.Pwd.val\" ng-change=\"vm.onChangePwdText();$scope.$apply();\" />\n" +
    "						<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': vm.model.Pwd.fail == 'no', 'icon-invalid': vm.model.Pwd.fail == 'yes'}\"></span>\n" +
    "					</div>\n" +
    "					<div class=\"form-field input-pwd ng-hide\" ng-show=\"vm.action == 'pwdactivate' || vm.action == 'pwdupdate' || vm.action == 'pwdresetemail'\">\n" +
    "						<label for=\"LoginPwdConfirm\">Confirm Password</label>\n" +
    "						<input id=\"LoginPwdConfirm\" type=\"password\" placeholder=\"re-enter password\" maxlength=\"30\" ng-model=\"vm.model.PwdConfirm.val\" />\n" +
    "						<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': vm.model.PwdConfirm.fail == 'no', 'icon-invalid': vm.model.PwdConfirm.fail == 'yes'}\"></span>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<div class=\"form-field ng-hide\" ng-show=\"vm.model.Pwd.fail == 'yes' || vm.model.PwdConfirm.fail == 'yes'\" style=\"margin-top: 0;padding-top: 0;\">\n" +
    "					<span class=\"field-msg\">{{vm.model.Pwd.msg}}</span>\n" +
    "				</div>\n" +
    "				<div class=\"form-field form-controls ng-hide\" ng-show=\"vm.action == 'login-pwd'\">\n" +
    "					<button id=\"LoginSubmit\" type=\"submit\" class=\"\">SIGN IN</button>\n" +
    "					<p>&nbsp;</p>\n" +
    "					<p style=\"text-align: center;\"><a id=\"LoginForgotPwd\" href ng-click=\"vm.pwdForgot()\">Forgot password?</a></p>\n" +
    "				</div>\n" +
    "				<div class=\"form-field form-controls ng-hide\" ng-show=\"vm.action != 'login-pwd'\">\n" +
    "					<button id=\"PwdSubmit\" type=\"submit\">{{vm.action == 'pwdactivate' ? 'ACTIVATE' : 'UPDATE'}}</button>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "			<!-- UI LANDING DEPRECATED --\n" +
    "			<div class=\"loginland ng-hide\" ng-show=\"vm.action == 'loginland'\">\n" +
    "				<div class=\"form-field input-email\">\n" +
    "					<input id=\"LoginLandEmail\" name=\"Email\" type=\"email\" placeholder=\"Email\" maxlength=\"254\" ng-model=\"vm.model.Email.val\" ng-class=\"{'loginland-invalid':vm.model.Email.fail == 'yes'}\" />\n" +
    "				</div>\n" +
    "				<div class=\"form-field input-pwd\">\n" +
    "					<input id=\"LoginLandPwd\" name=\"Pwd\" type=\"password\" placeholder=\"Password\" maxlength=\"30\" ng-model=\"vm.model.Pwd.val\" ng-class=\"{'loginland-invalid':vm.model.Pwd.fail == 'yes'}\"/>\n" +
    "				</div>\n" +
    "				<div class=\"form-field loginland-err ng-hide\" ng-show=\"vm.model.Email.fail == 'yes' || vm.model.Pwd.fail == 'yes'\">\n" +
    "					<p class=\"ng-hide\" ng-show=\"vm.model.Email.fail == 'yes'\"><span class=\"field-msg\">{{vm.model.Email.msg}}</span></p>\n" +
    "					<p class=\"ng-hide\" ng-show=\"vm.model.Pwd.fail == 'yes'\"><span class=\"field-msg\">{{vm.model.Pwd.msg}}</span></p>\n" +
    "				</div>\n" +
    "				<div class=\"form-field form-controls\">\n" +
    "					<button id=\"LoginLandSubmit\" type=\"submit\" class=\"\">Sign In</button>\n" +
    "				</div>\n" +
    "				<p>&nbsp;</p>\n" +
    "				<p><span><a id=\"LoginLandForgotPwd\" href ng-click=\"vm.pwdForgot()\">Forgot Password?</a></span></p>\n" +
    "				<p>&nbsp;</p>\n" +
    "				<p style=\"text-align: center;\"><img ng-src=\"assets/img/brand/verity-power.png?v={{vmApp.appVersion}}\" /></p>\n" +
    "			</div-->\n" +
    "			<!-- FORGOT PWD / SECURITY QA -->\n" +
    "			<div class=\"ng-hide\" ng-show=\"vm.action == 'pwdforgot' || vm.action == 'pwdanswer' || vm.action == 'getanswer'\">\n" +
    "				<div class=\"form-field input-email pwd-forgot\">\n" +
    "					<label for=\"LoginChallengeEmail\">Account (Email)</label>\n" +
    "					<input id=\"LoginChallengeEmail\" type=\"email\" placeholder=\"email address\" maxlength=\"254\" ng-model=\"vm.model.Email.val\" ng-disabled=\"vm.action == 'pwdanswer' || vm.action == 'getanswer'\" />\n" +
    "					<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': vm.model.Email.fail == 'no', 'icon-invalid': vm.model.Email.fail == 'yes'}\"></span>\n" +
    "					<span class=\"field-msg ng-hide\" ng-show=\"vm.model.Email.fail == 'yes'\">{{vm.model.Email.msg}}</span>\n" +
    "				</div>\n" +
    "				<div class=\"ng-hide\" ng-show=\"vm.action == 'pwdanswer' || vm.action == 'getanswer'\">\n" +
    "					<div class=\"form-field input-txt pwd-forgot\">\n" +
    "						<label for=\"LoginChallengeQuestion\">{{vm.action == 'getanswer' ? 'Security Question' : 'Question'}}</label>\n" +
    "						<input id=\"LoginChallengeQuestion\" type=\"text\" placeholder=\"question\" maxlength=\"50\" ng-model=\"vm.model.Question.val\" ng-disabled=\"vm.action == 'pwdanswer'\" autocomplete=\"nada\" />\n" +
    "						<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': vm.model.Question.fail == 'no', 'icon-invalid': vm.model.Question.fail == 'yes'}\"></span>\n" +
    "						<span class=\"field-msg ng-hide\" ng-show=\"vm.model.Question.fail == 'yes'\">{{vm.model.Question.msg}}</span>\n" +
    "					</div>\n" +
    "					<div class=\"form-field input-txt pwd-forgot\">\n" +
    "						<label for=\"LoginChallengeAnswer\">{{vm.action == 'getanswer' ? 'Security Answer' : 'Answer'}}</label>\n" +
    "						<input id=\"LoginChallengeAnswer\" type=\"text\" placeholder=\"answer\" maxlength=\"50\" ng-model=\"vm.model.Answer.val\" autocomplete=\"nada\" />\n" +
    "						<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-valid': vm.model.Answer.fail == 'no', 'icon-invalid': vm.model.Answer.fail == 'yes'}\"></span>\n" +
    "						<span class=\"field-msg ng-hide\" ng-show=\"vm.model.Answer.fail == 'yes'\">{{vm.model.Answer.msg}}</span>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<div class=\"form-field form-controls pwd-forgot\">\n" +
    "					<label>&nbsp;</label>\n" +
    "					<button id=\"PwdForgotBtn\" type=\"button\" class=\"ng-hide\" ng-show=\"vm.action != 'getanswer'\" ng-click=\"vm.pwdRequest()\">RESET PASSWORD</button>\n" +
    "					<button id=\"QaSaveBtn\" type=\"button\" class=\"ng-hide\" ng-show=\"vm.action == 'getanswer'\" ng-click=\"vm.saveQA()\">SAVE</button>\n" +
    "					&nbsp;&nbsp;<button id=\"PwdForgotCancelBtn\" type=\"button\" class=\"btn-cancel ng-hide\" ng-show=\"vm.action != 'getanswer'\" ng-click=\"vm.dismissOK()\">CANCEL</button>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "			<!-- MFA -->\n" +
    "			<div class=\"ng-hide\" ng-show=\"vm.action == 'mfa'\">\n" +
    "				<!-- VALIDATE -->\n" +
    "				<div class=\"mfa-validate ng-hide\" ng-show=\"vm.mfa.Action == 'VALIDATE'\">\n" +
    "					<p style=\"padding-left:0;\">Check your <span class=\"icon-glyph\" ng-class=\"{'icon-phone':vm.mfa.Factor == 'sms', 'icon-email':vm.mfa.Factor == 'email'}\"></span>{{(vm.mfa.Factor == 'sms' ? ' Phone number (***)***-' + vm.mfa.Phone : 'Email address on file')}}</p>\n" +
    "					<p>&nbsp;</p>\n" +
    "					<div class=\"form-field input-txt\" style=\"display:inline-block;\">\n" +
    "						<label for=\"LoginTwoFactor\">Security Code</label>\n" +
    "						<input id=\"LoginTwoFactorCodeInputVALIDATE\" type=\"text\" placeholder=\"\" maxlength=\"6\" ng-model=\"vm.mfa.SecurityCode\" />\n" +
    "					</div>\n" +
    "					<span><button type=\"submit\" ng-click=\"vm.mfaTryCode('VALIDATE'); $scope.$apply();\">{{vm.mfa.Action}}&nbsp;{{(vm.mfa.Factor == 'sms' ? ' PHONE' : 'EMAIL')}}</button></span>\n" +
    "					<span class=\"ng-hide\" ng-show=\"vm.mfa.OktaCustomer\">\n" +
    "						<a href ng-click=\"vm.mfaSend(vm.mfa.Factor);\" style=\"font-size:0.9em;\"><span class=\"icon-glyph glyphicon-send\"></span>Re-Send code</a>\n" +
    "					</span>\n" +
    "					<!-- OKTA CUSTOMER VALIDATE OPTIONS -->\n" +
    "					<div class=\"ng-hide\" ng-show=\"vm.mfa.OktaCustomer && vm.mfa.Action == 'VALIDATE'\">\n" +
    "						<!-- REMEMBER OPTION -->\n" +
    "						<div style=\"margin-top:20px;\">\n" +
    "							<a href ng-click=\"vm.mfa.Remember = !vm.mfa.Remember; $scope.$apply();\" style=\"font-size:0.9em;\"><span class=\"icon-glyph\" style=\"padding-left:0;\" ng-class=\"{'icon-checked': vm.mfa.Remember, 'icon-unchecked': !vm.mfa.Remember}\"></span>Remember device for 30 days</a>\n" +
    "							<div class=\"info-tip\">\n" +
    "								<label class=\"auto-width\"><a><span class=\"icon-glyph icon-msg-info\"></span></a></label>\n" +
    "								<div class=\"tip-content tip-left-200\" style=\"width:440px;\">\n" +
    "									<p class=\"tip-title\">Remember Device</p>\n" +
    "									<p>For the next 30 days you will not be prompted for a security code.</p>\n" +
    "								</div>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "						<!-- SMS OPTION -->\n" +
    "						<div class=\"ng-hide\" ng-show=\"vm.mfa.Factor == 'email'\">\n" +
    "							<p style=\"padding-left:0;font-size:0.9em;\">\n" +
    "								<a href class=\"ng-hide\" ng-show=\"vm.mfa.Phone != ''\" ng-click=\"vm.mfaSend('sms');\"><span class=\"icon-glyph icon-phone\" style=\"padding-left:0;\"></span>Send code to phone (***)***-{{vm.mfa.Phone}}</a>\n" +
    "								<a href class=\"ng-hide\" ng-show=\"vm.mfa.Phone == ''\" ng-click=\"vm.mfaEnrollPhoneToggle(); $scope.$apply();\"><span class=\"icon-glyph\" style=\"padding-left:0;\" ng-class=\"{'icon-checked': vm.mfa.PhoneEdit == 'ENROLL', 'icon-unchecked':vm.mfa.PhoneEdit != 'ENROLL'}\"></span><span class=\"icon-glyph icon-phone\" style=\"padding-left:0;\"></span>Use mobile phone to receive codes</a>\n" +
    "							</p>\n" +
    "						</div>\n" +
    "						<div class=\"ng-hide\" ng-show=\"vm.mfa.Factor == 'sms'\">\n" +
    "							<p style=\"padding-left:0;font-size:0.9em;\">\n" +
    "								<a href ng-click=\"vm.mfaSend('email');\"><span class=\"icon-glyph icon-email\" style=\"padding-left:0;\"></span>Send to email on file</a>\n" +
    "							</p>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<p>&nbsp;</p>\n" +
    "				</div>\n" +
    "				<!-- EDIT -->\n" +
    "				<div class=\"mfa-edit ng-hide\" ng-show=\"vm.mfa.Action == 'EDIT'\">\n" +
    "					<!-- PHONE ENROLL -->\n" +
    "					<div class=\"ng-hide\" ng-show=\"vm.mfa.PhoneEdit == 'ENROLL'\">\n" +
    "						<p>&nbsp;</p>\n" +
    "						<p class=\"ng-hide\" ng-show=\"vm.mfa.PhoneEdit == 'ENROLL'\" style=\"padding-left:0;\">Area Code - Prefix - Suffix below, all fields are required.</p>\n" +
    "						<div class=\"form-field input-txt\" style=\"display:inline-block;\">\n" +
    "							<input id=\"LoginMfaPhoneArea\" type=\"text\" placeholder=\"\" maxlength=\"3\" ng-change=\"vm.mfaPhoneTabNext('area','LoginMfaPhonePrefix')\" ng-model=\"vm.mfa.PhoneEditArea\" style=\"width:3em; margin:0;\" />\n" +
    "							<span>-</span><input id=\"LoginMfaPhonePrefix\" type=\"text\" placeholder=\"\" maxlength=\"3\" ng-change=\"vm.mfaPhoneTabNext('prefix','LoginMfaPhoneSuffix')\" ng-model=\"vm.mfa.PhoneEditPrefix\" style=\"width:3em; margin:0;\" />\n" +
    "							<span>-</span><input id=\"LoginMfaPhoneSuffix\" type=\"text\" placeholder=\"\" maxlength=\"4\" ng-model=\"vm.mfa.PhoneEditSuffix\" style=\"width:4em;margin:0;\" />\n" +
    "						</div>\n" +
    "						<div class=\"form-field\">\n" +
    "							<label>&nbsp;</label><button type=\"button\" ng-click=\"vm.mfaEnrollPhoneSubmit(); $scope.$apply();\">ENROLL PHONE</button>\n" +
    "							<span><button class=\"btn-cancel\" type=\"button\" ng-click=\"vm.mfaEditCancel(); $scope.$apply();\">CANCEL</button></span>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<!-- PHONE: ACTIVATE -->\n" +
    "					<div class=\"ng-hide\" ng-show=\"vm.mfa.PhoneEdit == 'ACTIVATE'\">\n" +
    "						<p style=\"padding-left:0;\"><span class=\"icon-glyph icon-phone\"></span>Activation code sent to:  ({{vm.mfa.PhoneEditArea}})&nbsp;{{vm.mfa.PhoneEditPrefix}}-{{vm.mfa.PhoneEditSuffix}}</p>\n" +
    "						<p>&nbsp;</p>\n" +
    "						<div class=\"form-field input-txt\" style=\"display:inline-block;\">\n" +
    "							<label for=\"LoginTwoFactor\">Security Code</label>\n" +
    "							<input id=\"LoginTwoFactorCodeInputACTIVATE\" type=\"text\" placeholder=\"\" maxlength=\"6\" ng-model=\"vm.mfa.SecurityCode\" />\n" +
    "						</div>\n" +
    "						<span><button type=\"submit\" ng-click=\"vm.mfaTryCode('ACTIVATE'); $scope.$apply();\">ACTIVATE PHONE</button></span>\n" +
    "						<span class=\"ng-hide\" ng-show=\"vm.mfa.OktaCustomer\">\n" +
    "							<a href ng-click=\"vm.mfaSend(vm.mfa.Factor);\" style=\"font-size:0.9em;\"><span class=\"icon-glyph glyphicon-send\"></span>Re-Send code</a>\n" +
    "						</span>\n" +
    "						<p style=\"padding-left:0;margin-top:20px;\"><a href ng-click=\"vm.mfaEdit('ENROLL');\" style=\"font-size:0.9em;\"><span class=\"icon-glyph icon-arrow-left\"></span>Change phone number or cancel phone setup</a></p>\n" +
    "					</div>					\n" +
    "					<p>&nbsp;</p>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "			<!-- TOU -->\n" +
    "			<div class=\"ng-hide\" ng-show=\"vm.action == 'vtou' || vm.action == 'ctou'\">\n" +
    "				<div class=\"login-tou\" ng-bind-html=\"vm.termsText\"></div>\n" +
    "				<div class=\"form-field form-controls\">\n" +
    "					<button id=\"loginTermsAgree\" type=\"button\" ng-click=\"vm.termsAgree()\">CONTINUE</button>\n" +
    "					&nbsp;&nbsp;<button id=\"loginTermsDecline\" type=\"button\" class=\"btn-cancel\" ng-click=\"vm.dismissOK()\">CANCEL</button>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</fieldset>\n" +
    "	</form>\n" +
    "	<div class=\"login-cobrand-vpower ng-hide\" ng-show=\"vm.cobrand == 'express'\">\n" +
    "		<img ng-src=\"assets/img/brand/verity-power.png?v={{vmApp.appVersion}}\" />\n" +
    "	</div>\n" +
    "	<!--p><a href ng-click=\"vm.guiBarAdvance()\">GUI</a></p-->\n" +
    "</div>\n" +
    "");
}]);

angular.module("home/startup/startup.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("home/startup/startup.tpl.html",
    "<div class=\"startup-feature\" ng-class=\"vm.cobrandCSS()\">\n" +
    "	<form ng-class=\"{'startup-connect': vm.startMode == 'CONNECT', 'startup-maint': vm.startMode == 'MAINT'}\" novalidate>\n" +
    "		<div class=\"login-img\">\n" +
    "			<span class=\"icon-glyph\" ng-class=\"{'icon-wait': vm.startMode == 'CONNECT' || vm.startMode == 'ERROR', 'icon-maint': vm.startMode == 'MAINT'}\" aria-hidden=\"true\"></span>\n" +
    "		</div>\n" +
    "		<fieldset>\n" +
    "			<h3 class=\"login-title\">{{vm.startTitle}}</h3>\n" +
    "			<p>&nbsp;{{vm.startMsg}}</p>\n" +
    "			<div class=\"ng-hide\" ng-show=\"vm.startMode == 'ERROR' || vm.startMode == 'MAINT'\">\n" +
    "				<p>&nbsp;{{vm.startErrMsg}}</p>\n" +
    "				<div class=\"form-field form-controls\">\n" +
    "					<button id=\"RetrySubmit\" type=\"button\" class=\"btn-alt\" ng-click=\"vm.startUp()\">RETRY CONNECTION</button>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</fieldset>\n" +
    "	</form>\n" +
    "</div>\n" +
    "");
}]);

angular.module("orders/ui/list.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("orders/ui/list.tpl.html",
    "<div class=\"orders-feature orders-list\">\n" +
    "	<section class=\"query-panel\">\n" +
    "		<div class=\"panel-top-right ng-hide\" ng-show=\"!vm.flex.showHead && vm.query.SearchType == 'IND'\"><a href ng-click=\"vm.queryFilterSwap()\"><span class=\"icon-glyph glyphicon-share-alt\"></span>Filter Swap</a></div>\n" +
    "		<form class=\"query-form drawer\" name=\"queryForm\" ng-submit=\"vm.querySubmit()\" novalidate>\n" +
    "            <fieldset>\n" +
    "				<!-- DRAWER HEAD -->\n" +
    "				<div class=\"drawer-head ng-hide\" ng-show=\"vm.flex.showHead\">\n" +
    "					<a href ng-click=\"vm.flexTopExpand();$scope.$apply();\" title=\"Edit Search Properties...\"><span class=\"icon-glyph icon-search\"></span>{{vm.query.title}}</a>\n" +
    "					<span class=\"drawer-filter\">\n" +
    "						<span class=\"icon-glyph icon-filter\"></span>&nbsp;{{vm.query.DateTypeTxt}}&nbsp;Date Range:&nbsp;{{vm.query.StartDate.val | date:'M/d/yyyy'}}&nbsp;-&nbsp;{{vm.query.EndDate.val | date:'M/d/yyyy'}}\n" +
    "					</span>\n" +
    "					<span class=\"drawer-filter ng-hide\" ng-show=\"!!vm.query.OrderCategory.chk\">\n" +
    "						<span class=\"icon-glyph icon-filter\"></span>&nbsp;Order Category:&nbsp;{{vm.query.OrderCategory.val}}\n" +
    "					</span>\n" +
    "				</div>\n" +
    "				<!-- DRAWER BODY -->\n" +
    "				<div class=\"drawer-body ng-hide\" ng-show=\"vm.flex.showBody\">\n" +
    "					<div class=\"form-field input-radio ng-hide\" ng-show=\"!!vm.query.UserHasRxRollup || (vm.isVerityUser && vm.ProgAdminDroplist.length > 1)\">\n" +
    "						<label class=\"same-width\">Search Type</label>\n" +
    "						<ul>\n" +
    "							<li ng-click=\"vm.queryChangeSearchType('IND')\"><label><input type=\"radio\" name=\"ordListSearchType\" value=\"IND\" ng-model=\"vm.query.SearchType\" />&nbsp;Affiliations</label></li>\n" +
    "							<li class=\"ng-hide\" ng-show=\"!!vm.query.UserHasRxRollup\" ng-click=\"vm.queryChangeSearchType('ROLLUP')\"><label><input type=\"radio\" name=\"ordListSearchType\" value=\"ROLLUP\" ng-model=\"vm.query.SearchType\" />&nbsp;Rollup</label></li>\n" +
    "							<li class=\"ng-hide\" ng-show=\"vm.isVerityUser == 'yes' && vm.ProgAdminDroplist.length > 1\" ng-click=\"vm.queryChangeSearchType('PROGADMIN')\"><label><input type=\"radio\" name=\"ordListSearchType\" value=\"PROGADMIN\" ng-model=\"vm.query.SearchType\" />&nbsp;Program Admin</label></li>\n" +
    "						</ul>\n" +
    "					</div>\n" +
    "					<!-- INDIVIDUAL -->\n" +
    "					<div class=\"fieldset-row ng-hide\" ng-show=\"vm.query.SearchType == 'IND'\">\n" +
    "						<div class=\"form-field input-drop\">\n" +
    "							<label class=\"same-width\" for=\"orderListQueryPrimary\">{{vm.query.primaryLabel}}</label>\n" +
    "							<select id=\"orderListQueryPrimary\" ng-model=\"vm.query.primary.val\" ng-change=\"vm.queryChangePrimary()\"\n" +
    "								ng-options=\"prmItem.value as prmItem.label group by ' ' for prmItem in vm.primaryDroplist\">\n" +
    "							</select>\n" +
    "							<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.query.primary.fail == 'yes'}\"></span>\n" +
    "						</div>\n" +
    "						<div class=\"form-field input-drop ng-hide\" ng-show=\"vm.query.primary.fail == 'no' && vm.secondaryDroplist.length > 1\">\n" +
    "							<label for=\"orderListQuerySecondary\">{{vm.query.secondaryLabel}}</label>\n" +
    "							<select id=\"orderListQuerySecondary\" ng-model=\"vm.query.secondary.val\" ng-change=\"vm.queryChangeSecondary()\"\n" +
    "								ng-options=\"scdItem.value as scdItem.label group by ' ' for scdItem in vm.secondaryDroplist\">\n" +
    "							</select>\n" +
    "							<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.query.secondary.fail == 'yes'}\"></span>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<!-- ROLLUP -->\n" +
    "					<div class=\"form-field input-drop ng-hide\" ng-show=\"vm.query.SearchType == 'ROLLUP'\">\n" +
    "						<label class=\"same-width\">Rollup</label>\n" +
    "						<select id=\"RxRollup\" ng-model=\"vm.query.RxRollup.val\" ng-change=\"vm.queryChangeRollup()\"\n" +
    "							ng-options=\"rxRollupItem.value as rxRollupItem.label for rxRollupItem in vm.RollupDroplist\">\n" +
    "						</select>\n" +
    "						<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.query.RxRollup.fail == 'yes'}\"></span>\n" +
    "					</div>\n" +
    "					<!-- PROG ADMIN -->\n" +
    "					<div class=\"form-field input-drop ng-hide\" ng-show=\"vm.query.SearchType == 'PROGADMIN'\">\n" +
    "						<label class=\"auto-width\">Program Admin</label>\n" +
    "						<select id=\"ordListProgAdmin\" name=\"ProgramAdmin\" ng-model=\"vm.query.ProgramAdmin.val\" ng-change=\"vm.queryChangeProgAdmin()\"\n" +
    "							ng-options=\"progAdminItem.value as progAdminItem.label for progAdminItem in vm.ProgAdminDroplist\">\n" +
    "						</select>\n" +
    "						<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.query.ProgramAdmin.fail == 'yes'}\"></span>\n" +
    "						<span class=\"field-msg ng-hide\" ng-show=\"vm.query.ProgramAdmin.fail == 'yes'\">{{vm.query.ProgramAdmin.msg}}</span>\n" +
    "					</div>\n" +
    "					<!-- OPTIONS -->\n" +
    "					<div class=\"ng-hide\" ng-show=\"!vm.init && vm.query.primary.fail != 'yes' && vm.query.secondary.fail != 'yes' && vm.query.RxRollup.fail != 'yes' && vm.query.ProgramAdmin.fail != 'yes'\">\n" +
    "						<div class=\"form-field\">\n" +
    "							<label class=\"auto-width\"><span class=\"icon-glyph icon-filter\"></span>&nbsp;Search Options: (date required)</label>\n" +
    "							<div class=\"ng-hide\" ng-show=\"vm.query.SearchOptionsRequired.fail == 'yes'\">\n" +
    "								<p class=\"field-msg\" style=\"margin-left:2em;\">{{vm.query.SearchOptionsRequired.msg}}</p>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "						<div class=\"fieldset-row\">\n" +
    "							<div id=\"orderListDateRange\" widget-input-date-range\n" +
    "								start-date=\"vm.query.StartDate\" end-date=\"vm.query.EndDate\"\n" +
    "								range-mode-list=\"vm.query.DateRangeList\" range-change=\"vm.dateRangeChange(dtMode, isValid)\">\n" +
    "							</div>\n" +
    "						</div>\n" +
    "						<div class=\"form-field input-drop order-list-search-option\">\n" +
    "							<label class=\"same-width\"><span class=\"icon-glyph\" ng-click=\"vm.query.OrderCategory.chk = !vm.query.OrderCategory.chk; $scope.$apply();vm.queryChange();\" ng-class=\"{'icon-checked': vm.query.OrderCategory.chk, 'icon-unchecked': !vm.query.OrderCategory.chk}\"></span>Order Category</label>\n" +
    "							<select ng-model=\"vm.query.OrderCategory.val\"\n" +
    "								ng-options=\"ordCatItem.value as ordCatItem.label for ordCatItem in vm.OrderCategoryDroplist\">\n" +
    "							</select>\n" +
    "							<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.query.OrderCategory.chk && vm.query.OrderCategory.fail == 'yes'}\"></span>\n" +
    "							<span class=\"field-msg ng-hide\" ng-show=\"vm.query.OrderCategory.fail == 'yes'\">{{vm.query.OrderCategory.msg}}</span>	\n" +
    "						</div>\n" +
    "						<div class=\"form-field input-drop order-list-search-option ng-hide\" ng-show=\"!!vm.query.isCP\">\n" +
    "							<label class=\"same-width\" style=\"width: 15em\"><span class=\"icon-glyph\" ng-click=\"vm.query.DirectReplenish = !!!vm.query.DirectReplenish; $scope.$apply(); vm.queryChange();\" ng-class=\"{'icon-checked': vm.query.DirectReplenish, 'icon-unchecked': !vm.query.DirectReplenish}\"></span>Direct Replenishment</label>\n" +
    "						</div>\n" +
    "						<div class=\"form-field form-controls\">\n" +
    "							<label class=\"same-width\">&nbsp;</label>\n" +
    "							<button id=\"ordListSearchBtn\" type=\"submit\">SEARCH</button>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "            </fieldset>\n" +
    "		</form>\n" +
    "	</section>\n" +
    "	<!-- LIST -->\n" +
    "	<section class=\"table-list ng-hide\" ng-show=\"vm.action == 'LIST'\">\n" +
    "		<div class=\"table-list-title\">\n" +
    "			<span class=\"title-left\">Filtering {{vm.flt.Count | number}} of {{vm.tbl.DataItems.length | number}} records</span>\n" +
    "			<div class=\"title-right\">\n" +
    "				<a class=\"ng-hide\" ng-show=\"vm.tbl.DataItems.length > 0\" href ng-click=\"vm.getExcel()\"><span class=\"icon-glyph icon-pdf\"></span>Save Orders To Excel</a>\n" +
    "				<a class=\"help-text\" href ng-click=\"vm.helpLink('order-list', 'Order List')\"><span class=\"icon-glyph icon-help\"></span>Help</a>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<div class=\"table-fixed-header-scroll\">\n" +
    "			<table style=\"table-layout: auto;\">\n" +
    "				<colgroup>\n" +
    "					<col width=\"110px\" />\n" +
    "					<col width=\"25px\" />\n" +
    "					<col width=\"45px\" />\n" +
    "					<col width=\"45px\" />\n" +
    "					<col width=\"45px\" />\n" +
    "					<col width=\"45px\" />\n" +
    "					<col width=\"45px\" />\n" +
    "					<col width=\"45px\" />\n" +
    "					<col width=\"45px\" />\n" +
    "					<col width=\"45px\" />\n" +
    "					<col width=\"45px\" />\n" +
    "				</colgroup>\n" +
    "				<thead class=\"fixed-header\">\n" +
    "					<!-- SECTIONS -->\n" +
    "					<tr>\n" +
    "						<th colspan=\"5\">Order Info</th>\n" +
    "						<th colspan=\"6\">Process Dates</th>\n" +
    "					</tr>\n" +
    "					<!-- TITLES -->\n" +
    "					<tr class=\"column-titles\">\n" +
    "						<td class=\"order-checkbox-filters\" style=\"min-width: 110px; max-width: 120px;\">\n" +
    "							<a href ng-click=\"vm.sortBy('Name', vm.flt); $scope.$apply(); vm.filterChange();\">Order #<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('Name', vm.flt.SortBy)\"></span></a>\n" +
    "							<p class=\"ng-hide\" ng-show=\"!!vm.showAutoOrders\" ng-click=\"vm.flt.Checked.AutoOrdered =!vm.flt.Checked.AutoOrdered; $scope.$apply();vm.filterChange();\">\n" +
    "								<span class=\"icon-glyph\" ng-model=\"vm.flt.Checked.AutoOrdered\" ng-class=\"{'icon-checked':!!vm.flt.Checked.AutoOrdered,'icon-unchecked':!!!vm.flt.Checked.AutoOrdered}\"></span>Auto Order\n" +
    "							</p>\n" +
    "							<p class=\"ng-hide\" ng-show=\"!!vm.showReview\" ng-click=\"vm.flt.Checked.Review =!vm.flt.Checked.Review; $scope.$apply();vm.filterChange();\">\n" +
    "								<span class=\"icon-glyph\" ng-model=\"vm.flt.Checked.Review\" ng-class=\"{'icon-checked':!!vm.flt.Checked.Review,'icon-unchecked':!!!vm.flt.Checked.Review, 'no-pad':!!vm.showAutoOrders}\"></span>Review\n" +
    "							</p>\n" +
    "						</td>\n" +
    "						<td style=\"max-width:25px; min-width:25px;\">\n" +
    "							<a ng-click=\"vm.sortBy('OrderType', vm.flt); $scope.$apply(); vm.filterChange();\">Type<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('OrderType', vm.flt.SortBy)\"></span></a>\n" +
    "						</td>\n" +
    "						<td style=\"min-width:80px;\">\n" +
    "							<a ng-click=\"vm.sortBy('EntityTxt', vm.flt); $scope.$apply(); vm.filterChange();\">{{vm.tbl.EntityTitle}}<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('EntityTxt', vm.flt.SortBy)\"></span></a>\n" +
    "						</td>\n" +
    "						<td style=\"max-width:25px; min-width:25px;\">\n" +
    "							<a ng-click=\"vm.sortBy('OrderCategory', vm.flt); $scope.$apply(); vm.filterChange();\">Order Category<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('OrderCategory', vm.flt.SortBy)\"></span></a>\n" +
    "						</td>\n" +
    "						<td style=\"max-width:25px; min-width:25px;\">\n" +
    "							<a ng-click=\"vm.sortBy('DirectReplenish', vm.flt); $scope.$apply(); vm.filterChange();\">DIR<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('DirectReplenish', vm.flt.SortBy)\"></span></a>\n" +
    "						</td>\n" +
    "						<td style=\"min-width:80px;\">\n" +
    "							<span class=\"icon-glyph icon-checked\"></span>\n" +
    "							<a ng-click=\"vm.sortBy('CreatedOn', vm.flt); $scope.$apply(); vm.filterChange();\">Created<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('CreatedOn', vm.flt.SortBy)\"></span></a>\n" +
    "						</td>\n" +
    "						<td style=\"min-width:80px;\">\n" +
    "							<span class=\"icon-glyph\" ng-model=\"vm.flt.Checked.Place\" ng-class=\"{'icon-checked':!!vm.flt.Checked.Place,'icon-unchecked':!!!vm.flt.Checked.Place}\" ng-click=\"vm.flt.Checked.Place = !vm.flt.Checked.Place; vm.filterChange();\"></span>\n" +
    "							<a ng-click=\"vm.sortBy('PlaceDate', vm.flt); $scope.$apply(); vm.filterChange();\">Placed<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('PlaceDate', vm.flt.SortBy)\"></span></a>\n" +
    "						</td>\n" +
    "						<td style=\"min-width:90px; max-width: 110px;\">\n" +
    "							<span class=\"icon-glyph\" ng-model=\"vm.flt.Checked.Ack\" ng-class=\"{'icon-checked':!!vm.flt.Checked.Ack,'icon-unchecked':!!!vm.flt.Checked.Ack}\" ng-click=\"vm.flt.Checked.Ack =!vm.flt.Checked.Ack; vm.filterChange();\"></span>\n" +
    "							<a ng-click=\"vm.sortBy('AckDate', vm.flt); $scope.$apply(); vm.filterChange();\">Acknowledged<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('AckDate', vm.flt.SortBy)\"></span></a>\n" +
    "						</td>\n" +
    "						<td style=\"min-width:80px;\">\n" +
    "							<span class=\"icon-glyph\" ng-model=\"vm.flt.Checked.Invoice\" ng-class=\"{'icon-checked':!!vm.flt.Checked.Invoice,'icon-unchecked':!!!vm.flt.Checked.Invoice}\" ng-click=\"vm.flt.Checked.Invoice =!vm.flt.Checked.Invoice; vm.filterChange();\"></span>\n" +
    "							<a ng-click=\"vm.sortBy('InvoiceDate', vm.flt); $scope.$apply(); vm.filterChange();\">Invoiced<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('InvoiceDate', vm.flt.SortBy)\"></span></a>\n" +
    "						</td>\n" +
    "						<td style=\"min-width:80px; line-height: 22px;\">\n" +
    "							<a ng-click=\"vm.sortBy('InvoiceStatus', vm.flt); $scope.$apply(); vm.filterChange();\">Invoice Status<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('InvoiceStatus', vm.flt.SortBy)\"></span></a>\n" +
    "						</td>\n" +
    "						<td style=\"min-width:80px;\">\n" +
    "							<span class=\"icon-glyph\" ng-model=\"vm.flt.Checked.Cancel\" ng-class=\"{'icon-checked':!!vm.flt.Checked.Cancel,'icon-unchecked':!!!vm.flt.Checked.Cancel}\" ng-click=\"vm.flt.Checked.Cancel =!vm.flt.Checked.Cancel; vm.filterChange();\"></span>\n" +
    "							<a ng-click=\"vm.sortBy('CancelDate', vm.flt); $scope.$apply(); vm.filterChange();\">Cancelled<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('CancelDate', vm.flt.SortBy)\"></span></a>\n" +
    "						</td>\n" +
    "					</tr>\n" +
    "					<!-- FILTERS -->\n" +
    "					<tr class=\"column-filters\">\n" +
    "						<td>\n" +
    "							<input type=\"text\" ng-model=\"vm.flt.Text.Name\" ng-change=\"vm.filterChange()\" />\n" +
    "						</td>\n" +
    "						<td>\n" +
    "							<input type=\"text\" ng-model=\"vm.flt.Text.OrderType\" ng-change=\"vm.filterChange()\" />\n" +
    "						</td>\n" +
    "						<td>\n" +
    "							<input type=\"text\" ng-model=\"vm.flt.Text.EntityTxt\" ng-change=\"vm.filterChange()\" />\n" +
    "						</td>\n" +
    "						<td>\n" +
    "							<input type=\"text\" ng-model=\"vm.flt.Text.OrderCategory\" ng-change=\"vm.filterChange()\" />\n" +
    "						</td>\n" +
    "						<td>\n" +
    "							<input type=\"text\" ng-model=\"vm.flt.Text.DirectReplenish\" ng-change=\"vm.filterChange()\" />\n" +
    "						</td>\n" +
    "						<td>\n" +
    "							<input type=\"text\" ng-model=\"vm.flt.Dates.CreatedOn\" ng-change=\"vm.filterChange()\" />\n" +
    "						</td>\n" +
    "						<td>\n" +
    "							<input type=\"text\" ng-model=\"vm.flt.Dates.PlaceDate\" ng-change=\"vm.filterChange()\" />\n" +
    "						</td>\n" +
    "						<td>\n" +
    "							<input type=\"text\" ng-model=\"vm.flt.Dates.AckDate\" ng-change=\"vm.filterChange()\" />\n" +
    "						</td>\n" +
    "						<td>\n" +
    "							<input type=\"text\" ng-model=\"vm.flt.Dates.InvoiceDate\" ng-change=\"vm.filterChange()\" />\n" +
    "						</td>\n" +
    "						<td>\n" +
    "							<input type=\"text\" ng-model=\"vm.flt.Text.InvoiceStatus\" ng-change=\"vm.filterChange()\" />\n" +
    "						</td>\n" +
    "						<td>\n" +
    "							<input type=\"text\" ng-model=\"vm.flt.Dates.CancelDate\" ng-change=\"vm.filterChange()\" />\n" +
    "						</td>\n" +
    "					</tr>\n" +
    "				</thead>\n" +
    "				<tbody>\n" +
    "					<!-- LIST ITEMS -->\n" +
    "					<tr class=\"table-list-item\" ng-class=\"{'row-shade':$even}\" ng-click=\"vm.getDetail(item)\"\n" +
    "						ng-repeat=\"item in vm.tbl.Items track by item.uniqueId\">\n" +
    "						<td>\n" +
    "							<span class=\"icon-glyph flt-icon\" ng-class=\"{'flt-icon-auto': !!item.AutoOrdered, 'flt-icon-review':!!item.Review}\"></span>&nbsp;{{::item.Name}}\n" +
    "						</td>\n" +
    "						<td>{{::item.OrderType}}</td>\n" +
    "						<td>{{::item.EntityTxt}}</td>\n" +
    "						<td>{{::item.OrderCategory}}</td>\n" +
    "						<td>{{::item.DirectReplenish}}</td>\n" +
    "						<td>{{::item.CreatedOn | date:'M/d/yyyy h:mma'}}</td>\n" +
    "						<td>{{::item.PlaceDate | date:'M/d/yyyy h:mma'}}</td>\n" +
    "						<td>{{::item.AckDate | date:'M/d/yyyy h:mma'}}</td>\n" +
    "						<td>{{::item.InvoiceDate | date:'M/d/yyyy h:mma'}}</td>\n" +
    "						<td>{{::item.InvoiceStatus}}</td>\n" +
    "						<td>{{::item.CancelDate | date:'M/d/yyyy h:mma'}}</td>\n" +
    "					</tr>\n" +
    "				</tbody>\n" +
    "			</table>\n" +
    "		</div>\n" +
    "		<div widget-paging></div>\n" +
    "	</section>\n" +
    "</div>\n" +
    "<div scripty-lazy-load data-src=\"vendor/pdf/FileSaver.js\"></div>\n" +
    "<div scripty-lazy-load data-src=\"vendor/pdf/blob-stream.js\"></div>\n" +
    "");
}]);

angular.module("orders/ui/new.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("orders/ui/new.tpl.html",
    "<div class=\"orders-feature orders-new\">\n" +
    "	<section class=\"query-panel\">\n" +
    "		<div class=\"panel-above-right\">\n" +
    "			<a class=\"ng-hide\" ng-show=\"vm.action == 'CREATE'\" href ng-click=\"vm.queryFilterSwap()\"><span class=\"icon-glyph glyphicon-share-alt\"></span>Filter Swap</a>&nbsp;&nbsp;\n" +
    "			<a class=\"help-text-link ng-hide\" ng-show=\"!!!vm.activeTab\" href ng-click=\"vm.helpLinkClick()\"><span class=\"icon-glyph icon-help\"></span>Search Help</a>\n" +
    "			<a class=\"help-text-link ng-hide\" ng-show=\"vm.activeTab == 'ACCUM'\" href ng-click=\"vm.helpLinkClick()\"><span class=\"icon-glyph icon-help\"></span>Accumulation Help</a>\n" +
    "			<a class=\"help-text-link ng-hide\" ng-show=\"vm.activeTab == 'ASSAY'\" href ng-click=\"vm.helpLinkClick()\"><span class=\"icon-glyph icon-help\"></span>Assay Order Help</a>\n" +
    "			<a class=\"help-text-link ng-hide\" ng-show=\"vm.activeTab == 'ORDER' || vm.activeTab == 'HISTORY' && vm.action != 'PRESPLIT'\" href ng-click=\"vm.helpLinkClick()\"><span class=\"icon-glyph icon-help\"></span>Order Items Help</a>\n" +
    "		</div>\n" +
    "		<!-- CREATE QUERY -->\n" +
    "		<form class=\"query-form create-order ng-hide\" ng-show=\"vm.action == 'CREATE'\" novalidate>\n" +
    "			<fieldset>\n" +
    "				<!-- CE, RX, VEN -->\n" +
    "				<div class=\"fieldset-row\">\n" +
    "					<div class=\"form-field input-drop\">\n" +
    "						<label class=\"same-width\" for=\"orderCreateQueryPrimary\">{{vm.query.primaryLabel}}</label>\n" +
    "						<select id=\"orderCreateQueryPrimary\" ng-model=\"vm.query.primary.val\" ng-change=\"vm.queryChangePrimary()\"\n" +
    "							ng-options=\"prmItem.value as prmItem.label group by ' ' for prmItem in vm.primaryDroplist\">\n" +
    "						</select>\n" +
    "						<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.query.primary.fail == 'yes'}\"></span>\n" +
    "					</div>\n" +
    "					<div class=\"form-field input-drop ng-hide\" ng-show=\"vm.secondaryDroplist.length > 1\">\n" +
    "						<label for=\"orderCreateQuerySecondary\">{{vm.query.secondaryLabel}}</label>\n" +
    "						<select id=\"orderCreateQuerySecondary\" ng-model=\"vm.query.secondary.val\" ng-change=\"vm.queryChangeSecondary()\"\n" +
    "							ng-options=\"scdItem.value as scdItem.label group by ' ' for scdItem in vm.secondaryDroplist\">\n" +
    "						</select>\n" +
    "						<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.query.secondary.fail == 'yes'}\"></span>\n" +
    "					</div>\n" +
    "					<div class=\"form-field input-drop\" ng-show=\"vm.VenDroplist.length > 1\">\n" +
    "						<label for=\"orderCreateVEN\">Vendor</label>\n" +
    "						<select id=\"orderCreateVEN\" ng-model=\"vm.query.VEN.val\" ng-change=\"vm.queryChangeVEN()\"\n" +
    "							ng-options=\"venItem.value as venItem.label for venItem in vm.VenDroplist\">\n" +
    "						</select>\n" +
    "						<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.query.VEN.fail == 'yes'}\"></span>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<!-- ACCT, DIRECT REP, NDC FILTERING -->\n" +
    "				<div class=\"fieldset-row\">\n" +
    "					<div class=\"form-field input-drop ng-hide\" ng-show=\"vm.AcctTypeDroplist.length > 1\">\n" +
    "						<label class=\"same-width\" for=\"orderCreateAcctType\">Account</label>\n" +
    "						<select id=\"orderCreateAcctType\" ng-model=\"vm.query.AcctType.val\" ng-change=\"vm.queryChangeAcctType()\"\n" +
    "							ng-options=\"acctTypeItem.value as acctTypeItem.label for acctTypeItem in vm.AcctTypeDroplist\">\n" +
    "						</select>\n" +
    "						<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.query.AcctType.fail == 'yes'}\"></span>\n" +
    "					</div>\n" +
    "					<!-- ISP -->\n" +
    "					<div class=\"form-field input-radio ng-hide\" ng-show=\"!!vm.query.hasISP && vm.query.AcctType.fail == 'no'\">\n" +
    "						<label class=\"auto-width\">\n" +
    "							<label class=\"auto-width\">ISP</label>\n" +
    "							<ul>\n" +
    "								<li ng-click=\"vm.queryChangeISP('yes')\"><label class=\"auto-width\"><input type=\"radio\" name=\"newOrdISP\" ng-model=\"vm.query.IsISP\" value=\"yes\">&nbsp;Yes</label></li>\n" +
    "								<li ng-click=\"vm.queryChangeISP('no')\"><label class=\"auto-width\"><input type=\"radio\" name=\"newOrdISP\" ng-model=\"vm.query.IsISP\" value=\"no\">&nbsp;No</label></li>\n" +
    "							</ul>\n" +
    "						</label>\n" +
    "					</div>\n" +
    "					<!-- DIRECT REP -->\n" +
    "					<div class=\"form-field input-radio ng-hide\" ng-show=\"!!vm.query.hasDirectRep && vm.query.AcctType.fail == 'no'\">\n" +
    "						<label class=\"auto-width\" ng-click=\"vm.queryChangeDirectRep();$scope.$apply();\">\n" +
    "							<span class=\"icon-glyph\" ng-class=\"{'icon-checked': vm.query.DirectRep.chk == 'yes', 'icon-unchecked': vm.query.DirectRep.chk == 'no'}\" style=\"top:2px;\"></span>Direct Replenishment\n" +
    "						</label>\n" +
    "						<label class=\"auto-width ng-hide\" ng-show=\"vm.query.DirectRep.chk == 'yes'\">\n" +
    "							<select id=\"orderCreateAcctDirectShipTo\" ng-model=\"vm.query.DirectRep.val\" ng-change=\"vm.queryChangeDirectRepShipTo()\"\n" +
    "								ng-options=\"ordDirectShipToItem.value as ordDirectShipToItem.label for ordDirectShipToItem in vm.DirectRepShipToDroplist\">\n" +
    "							</select>\n" +
    "							<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.query.DirectRep.fail == 'yes'}\"></span>\n" +
    "							<label class=\"auto-width\">Use Profitability</label>\n" +
    "							<ul>\n" +
    "								<li ng-click=\"vm.queryChangeDirectRepProfit()\"><label class=\"auto-width\"><input type=\"radio\" name=\"newOrdDirectRepProfit\" ng-model=\"vm.query.DirectRepProfit\" value=\"yes\">&nbsp;Yes</label></li>\n" +
    "								<li ng-click=\"vm.queryChangeDirectRepProfit()\"><label class=\"auto-width\"><input type=\"radio\" name=\"newOrdDirectRepProfit\" ng-model=\"vm.query.DirectRepProfit\" value=\"no\">&nbsp;No</label></li>\n" +
    "							</ul>\n" +
    "						</label>\n" +
    "					</div>\n" +
    "					<!-- NDC FILTERING -->\n" +
    "					<div class=\"form-field input-radio ng-hide\" ng-show=\"vm.query.DirectRep.chk == 'no' && vm.query.AcctType.fail == 'no' && vm.query.RxCP\">\n" +
    "						<label class=\"auto-width ng-hide\" ng-show=\"vm.AcctTypeDroplist.length > 1\" ng-click=\"vm.queryChangeNdcFilter();$scope.$apply();\">\n" +
    "							<span class=\"icon-glyph\" ng-class=\"{'icon-checked': vm.query.NdcFilter == 'yes', 'icon-unchecked': vm.query.NdcFilter == 'no'}\" style=\"top:2px;\"></span>Apply NDC Filter to Accumulation Items\n" +
    "						</label>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<!-- ACCUM PHARMACY -->\n" +
    "				<div class=\"form-field input-drop ng-hide\" ng-show=\"!!vm.query.useAccumRx && vm.query.DirectRep.chk == 'no' && vm.query.AcctType.fail == 'no'\">\n" +
    "					<label class=\"same-width\">Accumulation Pharmacy</label>\n" +
    "					<select ng-model=\"vm.query.AccumRXID\" ng-change=\"vm.queryChangeAccumRx()\"\n" +
    "						ng-options=\"accumRxItem.value as accumRxItem.label group by ' ' for accumRxItem in vm.AccumRxDroplist\">\n" +
    "					</select>\n" +
    "					<div class=\"info-tip\">\n" +
    "						<label class=\"auto-width\"><a><span class=\"icon-glyph icon-msg-info\"></span></a></label>\n" +
    "						<div class=\"tip-content tip-left-100\" style=\"width:550px;margin:0;\">\n" +
    "							<p class=\"tip-title\">Accumulation Pharmacy</p>\n" +
    "							<p>If Facility and Pharmacy CP Rollup both allow use of an accumulation pharmacy this option is available.</p>\n" +
    "							<p>Accumulating pharmacy can be any co-member in the same Rollup affiliated to the same CE.</p>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<!-- CATEGORY -->\n" +
    "				<div class=\"fieldset-row ng-hide\" ng-show=\"!!vm.query.RxCP && vm.query.AcctType.fail == 'no'\">\n" +
    "					<div class=\"form-field input-drop\">\n" +
    "						<label class=\"same-width\">Order Category</label>\n" +
    "						<select ng-model=\"vm.query.OrderCategory.val\" ng-change=\"vm.queryChangeOrderCategory()\"\n" +
    "							ng-options=\"ordCatItem.value as ordCatItem.label for ordCatItem in vm.OrderCategoryDroplist\">\n" +
    "						</select>\n" +
    "						<label class=\"auto-width ng-hide\" ng-show=\"vm.query.OrderCategory.val == 'STANDARD'\" ng-click=\"vm.queryChangeOrderCategory(true);$scope.$apply();\">\n" +
    "							<span class=\"icon-glyph\" ng-class=\"{'icon-checked': vm.query.OrderCategory.chk == 'yes', 'icon-unchecked': vm.query.OrderCategory.chk == 'no'}\" style=\"top:2px;\"></span>Include Dropship and Specialty Items\n" +
    "						</label>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<!-- DOD -->\n" +
    "				<div class=\"fieldset-row ng-hide\" ng-show=\"!!vm.query.isDOD\">\n" +
    "					<div class=\"form-field input-drop\">\n" +
    "						<label class=\"same-width\" for=\"orderDodPharmaType\">DOD Drug Type</label>\n" +
    "						<select id=\"orderDodPharmaType\" ng-model=\"vm.query.DodPharmaType\" ng-change=\"vm.queryChangeDOD()\"\n" +
    "							ng-options=\"dodPharmaItem.value as dodPharmaItem.label for dodPharmaItem in vm.DodPharmaDroplist\">\n" +
    "						</select>\n" +
    "					</div>\n" +
    "					<div class=\"form-field input-drop\">\n" +
    "						<label class=\"auto-width\" for=\"orderDodBillingType\">DOD Billing Type</label>\n" +
    "						<select id=\"orderDodBillingType\" ng-model=\"vm.query.DodBillingType\" ng-change=\"vm.queryChangeDOD()\"\n" +
    "							ng-options=\"dodBillItem.value as dodBillItem.label for dodBillItem in vm.DodBillingDroplist\">\n" +
    "						</select>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "			</fieldset>\n" +
    "		</form>\n" +
    "		<!-- EDIT DETAILS -->\n" +
    "		<form class=\"query-form edit-order ng-hide\" ng-show=\"vm.action !== 'CREATE'\" novalidate>\n" +
    "			<fieldset class=\"edit-details\">\n" +
    "				<div class=\"ng-hide\" ng-show=\"!!vm.activeTab\">\n" +
    "					<p>\n" +
    "						<span>{{vm.query.primaryLabel}}:&nbsp;{{vm.query.primaryName}}</span>\n" +
    "						<span>{{vm.query.secondaryLabel}}:&nbsp;{{vm.query.secondaryName}}</span>\n" +
    "						<span class=\"ng-hide\" ng-show=\"!!vm.order.AccumRXID\">Accumulation Pharmacy:&nbsp;{{vm.order.AccumRxName}}</span>\n" +
    "						<span>Vendor:&nbsp;{{vm.order.VENID}}</span>\n" +
    "						<span class=\"ng-hide\" ng-show=\"vm.action != 'PRESPLIT'\">Account:&nbsp;{{vm.order.AcctType}}</span>\n" +
    "						<span class=\"ng-hide\" ng-show=\"vm.action == 'PRESPLIT'\">Order #:&nbsp;{{vm.order.Name}}</span>\n" +
    "					</p>\n" +
    "					<p class=\"ng-hide\" ng-show=\"vm.action != 'PRESPLIT'\">\n" +
    "						<span>Order #:&nbsp;{{vm.order.Name}}</span>\n" +
    "						<span>Category:&nbsp;{{vm.order.CategoryTitle}}</span>\n" +
    "						<span class=\"ng-hide\" ng-show=\"vm.order.IsISP == 'YES'\">ISP:&nbsp;{{vm.order.IsISP}}</span>\n" +
    "						<span class=\"ng-hide\" ng-show=\"vm.order.Category == 'ASSAY' && vm.order.ReferencePO != ''\">Reference PO:&nbsp;{{vm.order.ReferencePO}}</span>\n" +
    "						<span class=\"ng-hide\" ng-show=\"vm.order.isDOD\">DOD Drug Type:&nbsp;{{vm.order.DodPharmaTitle}}</span>\n" +
    "						<span class=\"ng-hide\" ng-show=\"vm.order.isDOD\">DOD Billing Type:&nbsp;{{vm.order.DodBillingTitle}}</span>\n" +
    "						<span class=\"ng-hide\" ng-show=\"vm.order.DirectReplenish\">Direct Replenishment:&nbsp;{{vm.order.DirectRepTitle}}</span>\n" +
    "					</p>\n" +
    "					<p>\n" +
    "						<span>Created On:&nbsp;{{vm.order.CreatedOn | date:'M/d/yyyy'}}&nbsp;&nbsp;By:&nbsp;{{vm.order.CreatedBy}}</span>\n" +
    "						<span class=\"auto-order-icon ng-hide\" ng-show=\"!!vm.order.AutoOrdered\"><span class=\"icon-glyph icon-orders-auto\"></span>&nbsp;Auto Ordered</span>\n" +
    "					</p>\n" +
    "					<p>\n" +
    "						<span>Status:</span>\n" +
    "						<span>\n" +
    "							<button type=\"button\" class=\"btn-off\">{{vm.order.ObjectState}}</button>\n" +
    "							<button type=\"button\" class=\"btn-off ng-hide\" ng-show=\"!!vm.order.Manual\">MANUAL</button>\n" +
    "							<button type=\"button\" class=\"btn-off ng-hide\" ng-show=\"vm.order.ObjectState=='PLACED' && !!vm.everInvoiced\">{{!!vm.canAddInvoice?'PARTIALLY INVOICED':'FULLY INVOICED'}}</button>\n" +
    "							<button type=\"button\" class=\"btn-cancel ng-hide\" ng-show=\"vm.action == 'UPDATE' || vm.action == 'PRESPLIT'\" ng-click=\"vm.orderCancel()\">CANCEL THIS ORDER</button>\n" +
    "							<button type=\"button\" class=\"ng-hide\" ng-show=\"vm.order.ObjectState=='PLACED' && !!vm.canAddInvoice\" ng-click=\"vm.navToFeature('ADDINVOICE',{});\">Add Invoice</button>\n" +
    "						</span>\n" +
    "						<span class=\"ng-hide\" ng-show=\"vm.order.ObjectState == 'CANCELLED'\">\n" +
    "							Cancelled On:&nbsp;{{vm.order.CancelDate | date:'M/d/yyyy'}}&nbsp;&nbsp;By:&nbsp;{{vm.order.CancelBy}}\n" +
    "						</span>\n" +
    "					</p>\n" +
    "				</div>\n" +
    "			</fieldset>\n" +
    "		</form>\n" +
    "	</section>\n" +
    "	<!-- TAB BAR -->\n" +
    "	<section class=\"tab-bar ng-hide\" ng-show=\"!!vm.activeTab && vm.activeTab != 'ASSAY' && vm.activeTab != 'ASSAY_ORDER'\">\n" +
    "		<ul>\n" +
    "			<li id=\"orderTabAccum\" class=\"ng-hide\" ng-show=\"vm.action == 'CREATE' || vm.action == 'UPDATE'\" ng-class=\"{'has-focus':vm.activeTab == 'ACCUM'}\" ng-click=\"vm.tabChange('ACCUM')\">\n" +
    "				<span>Accumulation</span>\n" +
    "				<span class=\"tab-counter ng-hide\" ng-show=\"vm.activeTab == 'ORDER' || vm.activeTab == 'BACKLOG'\">({{vm.accum.Items.length | number}}&nbsp;items)</span>\n" +
    "				<span class=\"tab-counter ng-hide\" ng-show=\"vm.activeTab == 'ACCUM'\">(Viewing Top {{vm.rowCount(vm.accum.Paging.Size, accumRows.length) | number}} of {{vm.accum.Items.length | number}} items)</span>\n" +
    "			</li>\n" +
    "			<li id=\"orderTabCart\" class=\"order-tab tab-move-right ng-hide\" ng-show=\"vm.action != 'HISTORY'\" ng-class=\"{'has-focus':vm.activeTab == 'ORDER'}\" ng-click=\"vm.tabChange('ORDER')\">\n" +
    "				<div class=\"order-add-to-cart ng-hide\" ng-show=\"!!vm.addToCart.show\" ng-class=\"{'fly-in': !!vm.addToCart.run}\">\n" +
    "					<span class=\"slider\"><span ng-bind=\"vm.addToCart.txt\"></span>&nbsp;<span class=\"icon-glyph icon-arrow-right\"></span></span>\n" +
    "				</div>\n" +
    "				<span class=\"icon-glyph icon-orders\" ng-class=\"{'cart-gulp': !!vm.addToCart.run}\"></span><span class=\"no-pad-width\">Cart</span>\n" +
    "				<span class=\"tab-counter ng-hide\" ng-show=\"vm.activeTab == 'ACCUM' || vm.activeTab == 'BACKLOG'\">({{vm.order.Items.length | number}}&nbsp;items)</span>\n" +
    "				<span class=\"tab-counter ng-hide\" ng-show=\"vm.activeTab == 'ORDER'\">(Viewing Top {{vm.rowCount(vm.order.Paging.Size, orderRows.length) | number}} of {{vm.order.Items.length | number}} items)</span>\n" +
    "			</li>\n" +
    "			<li id=\"orderGetExcelLink\" class=\"tab-move-right ng-hide\" ng-show=\"vm.action == 'HISTORY'\">\n" +
    "				<span><a href ng-click=\"vm.getExcel()\"><span class=\"icon-glyph icon-pdf\"></span>&nbsp;Save Order to Excel</span></a></span>\n" +
    "			</li>	\n" +
    "		</ul>\n" +
    "	</section>\n" +
    "	<!-- ASSAY TAB BAR -->\n" +
    "	<section class=\"tab-bar ng-hide\" ng-show=\"vm.activeTab == 'ASSAY' || vm.activeTab == 'ASSAY_ORDER'\">\n" +
    "		<ul>\n" +
    "			<li id=\"orderTabAssay\" class=\"ng-hide\" ng-show=\"vm.action == 'CREATE' || vm.action == 'UPDATE'\" ng-class=\"{'has-focus':vm.activeTab == 'ASSAY'}\" ng-click=\"vm.tabChange('ASSAY')\">\n" +
    "				<span>Assay</span>\n" +
    "				<span class=\"tab-counter\">({{vm.accum.Items.length | number}}&nbsp;items)</span>\n" +
    "				<span class=\"tab-counter ng-hide\" ng-show=\"vm.activeTab == 'ASSAY'\">(Viewing Top {{vm.rowCount(vm.assay.Paging.Size, assayRows.length) | number}} of {{vm.assay.Items.length | number}} items)</span>\n" +
    "			</li>\n" +
    "			<li id=\"orderTabAssayCart\" class=\"order-tab tab-move-right ng-hide\" ng-show=\"vm.action != 'HISTORY'\" ng-class=\"{'has-focus':vm.activeTab == 'ASSAY_ORDER'}\" ng-click=\"vm.tabChange('ASSAY_ORDER')\">\n" +
    "				<div class=\"order-add-to-cart ng-hide\" ng-show=\"!!vm.addToCart.show\" ng-class=\"{'fly-in': !!vm.addToCart.run}\">\n" +
    "					<span class=\"slider\"><span ng-bind=\"vm.addToCart.txt\"></span>&nbsp;<span class=\"icon-glyph icon-arrow-right\"></span></span>\n" +
    "				</div>\n" +
    "				<span class=\"icon-glyph icon-orders\" ng-class=\"{'cart-gulp': !!vm.addToCart.run}\"></span><span class=\"no-pad-width\">Cart</span>\n" +
    "				<span class=\"tab-counter ng-hide\" ng-show=\"vm.activeTab == 'ASSAY'\">({{vm.order.Items.length | number}}&nbsp;items)</span>\n" +
    "				<span class=\"tab-counter ng-hide\" ng-show=\"vm.activeTab == 'ASSAY_ORDER'\">(Viewing Top {{vm.rowCount(vm.assay.Paging.Size, assayRows.length) | number}} of {{vm.assay.Items.length | number}} items)</span>\n" +
    "			</li>\n" +
    "			<li id=\"orderGetExcelLink\" class=\"tab-move-right ng-hide\" ng-show=\"vm.action == 'HISTORY'\">\n" +
    "				<span><a href ng-click=\"vm.getExcel()\"><span class=\"icon-glyph icon-pdf\"></span>&nbsp;Save Order to Excel</span></a></span>\n" +
    "			</li>\n" +
    "		</ul>\n" +
    "	</section>	\n" +
    "	<section class=\"table-list\">\n" +
    "		<!-- ORDER TABLE -->\n" +
    "		<div id=\"orderPanelCart\" class=\"tab-panel order-panel ng-hide\" ng-show=\"vm.activeTab == 'ORDER' && vm.action != 'HISTORY' && vm.action != 'PRESPLIT' \">\n" +
    "			<p class=\"order-cii\" ng-show=\"!!vm.order.hasCII\">-- CII Drugs In Cart -- Ordering CII drugs assumes the pharmacy can access its ordering account at the vendor to approve CSOS items.</p>\n" +
    "			<p class=\"order-cii\" ng-show=\"!!vm.order.hasSpecialty\">-- Specialty Drugs In Cart -- Ordering of specialty drug requires special handling.</p>\n" +
    "			<div class=\"table-popup-top\">\n" +
    "				<div class=\"table-fixed-header-scroll\">\n" +
    "					<table>\n" +
    "						<colgroup>\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"70px\" />\n" +
    "							<col width=\"100px\" />\n" +
    "							<col width=\"80px\" />\n" +
    "							<col width=\"45px\" />\n" +
    "							<col class=\"ng-hide\" ng-show=\"vm.query.RxSplit\" width=\"45px\" />\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"58px\" />\n" +
    "						</colgroup>\n" +
    "						<thead class=\"fixed-header\">\n" +
    "							<!-- SECTIONS -->\n" +
    "							<tr>\n" +
    "								<th colspan=\"1\">Remove</th>\n" +
    "								<th colspan=\"5\">Drug Information</th>\n" +
    "								<th class=\"ng-hide\" ng-show=\"vm.query.RxSplit\" colspan=\"1\">Price</th>\n" +
    "								<th colspan=\"1\">Remainder</th>\n" +
    "								<th colspan=\"1\">Order</th>\n" +
    "							</tr>\n" +
    "							<!-- TITLES -->\n" +
    "							<tr class=\"column-titles\">\n" +
    "								<td>&nbsp;</td>\n" +
    "								<td ng-click=\"vm.sortBy('ItemCode', vm.order); $scope.$apply();\">\n" +
    "									<a>NDC<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('ItemCode', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('VenDrugCode', vm.order); $scope.$apply();\">\n" +
    "									<a>Item Number<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('VenDrugCode', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('VenLabel', vm.order); $scope.$apply();\">\n" +
    "									<a>Item Description<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('VenLabel', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('Manufacturer', vm.order); $scope.$apply();\">\n" +
    "									<a>Manufacturer<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('Manufacturer', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('WholesaleUnits', vm.order); $scope.$apply();\">\n" +
    "									<a>Wholesale Units<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('WholesaleUnits', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.query.RxSplit\" ng-click=\"vm.sortBy('Price', vm.order); $scope.$apply();\">\n" +
    "									<a>Price<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('Price', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('RemainderUnits', vm.order); $scope.$apply();\">\n" +
    "									<a>Remaining Qty<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('RemainderUnits', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<a href class=\"ng-hide\" ng-show=\"vm.action != 'CREATE'\" ng-click=\"vm.sortBy('UserUnits', vm.order); $scope.$apply();\">Order Qty<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('UserUnits', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "							</tr>\n" +
    "							<!-- FILTERS -->\n" +
    "							<tr class=\"column-filters\">\n" +
    "								<td>\n" +
    "									<a href class=\"ng-hide\" ng-show=\"vm.order.Items.length > 0\" ng-click=\"vm.orderRemoveAll()\">\n" +
    "										<button class=\"btn-alt\" type=\"button\" style=\"padding-left:0;\">\n" +
    "											<span class=\"icon-glyph icon-remove\"></span>Remove All\n" +
    "										</button>\n" +
    "									</a>\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input widget-input-ndc-format format=\"nodash\" type=\"text\" ng-model=\"orderFilter.ItemCode\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"orderFilter.VenDrugCode\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"orderFilter.VenLabel\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"orderFilter.Manufacturer\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"orderFilter.WholesaleUnits\" />\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.query.RxSplit\">\n" +
    "									<input type=\"text\" ng-model=\"orderFilter.Price\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"orderFilter.RemainderUnits\" />\n" +
    "								</td>\n" +
    "								<td style=\"text-align:center;\">\n" +
    "									<button id=\"btnOrderCreate\" type=\"button\" class=\"ng-hide\" ng-show=\"vm.action == 'CREATE' && vm.order.Items.length > 0\" ng-click=\"vm.orderCreate()\">CREATE ORDER</button>\n" +
    "									<button id=\"btnOrderSave\" type=\"button\" class=\"btn-alt ng-hide\" ng-show=\"vm.action == 'UPDATE'\" ng-click=\"vm.orderUpdate()\" style=\"width:auto; min-width:40%;\">SAVE</button>\n" +
    "									<button id=\"btnOrderPlace\" type=\"button\" class=\"ng-hide\" ng-show=\"vm.action == 'UPDATE'\" ng-click=\"vm.orderPlace()\" style=\"width:auto; min-width:40%;margin-left: 10px;\">PLACE</button>\n" +
    "								</td>\n" +
    "							</tr>\n" +
    "						</thead>\n" +
    "						<tbody>\n" +
    "							<!-- LIST ITEMS -->\n" +
    "							<tr class=\"table-list-item\" ng-class=\"{'row-shade':$even,'popup-hover':orderItem.popHover}\"\n" +
    "								ng-repeat=\"orderItem in vm.order.Items\n" +
    "									| filter:orderFilter\n" +
    "									| orderBy:vm.order.SortBy\n" +
    "									| limitTo:vm.order.Paging.Size as orderRows track by orderItem.uniqueId\">\n" +
    "								<td class=\"qty-prompt remove-item\">\n" +
    "									<div class=\"qty-display\">\n" +
    "										<button class=\"btn-alt\" type=\"button\" ng-click=\"vm.orderRemoveItem(orderItem.ItemCode)\" title=\"\"><span class=\"icon-glyph icon-remove\"></span></button>\n" +
    "									</div>\n" +
    "								</td>\n" +
    "								<td>{{orderItem.ItemCode}}\n" +
    "									<p class=\"order-cii-text ng-hide\" ng-show=\"!!orderItem.CII\">-- CII Drug --</p>\n" +
    "									<p class=\"order-cii-text ng-hide\" ng-show=\"!!orderItem.IsSpecialty\">-- Specialty Drug --</p>\n" +
    "									<span class=\"ng-hide\" ng-show=\"orderItem.Replaced\">(OUT)</span>\n" +
    "								</td>\n" +
    "								<td>{{orderItem.VenDrugCode}}</td>\n" +
    "								<td>{{orderItem.VenLabel}}</td>\n" +
    "								<td>{{orderItem.Manufacturer}}</td>\n" +
    "								<td>{{orderItem.WholesaleUnits}}</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.query.RxSplit\">{{orderItem.Price | zeroNumberFormat:'':2}}</td>\n" +
    "								<td style=\"padding-left: 20px;\">{{orderItem.RemainderUnits > 0 ? orderItem.RemainderUnits : null | number}}</td>\n" +
    "								<td class=\"qty-prompt\">\n" +
    "									<div class=\"qty-display\">\n" +
    "										<span class=\"qty-input\" ng-click=\"vm.openPopup($event, orderItem, 'CART')\" title=\"Edit Order Qty\">{{orderItem.UserUnits}}</span>\n" +
    "										<span class=\"icon-glyph icon-blank\"></span>\n" +
    "									</div>\n" +
    "									<p class=\"err-order-qty ng-hide\" ng-show=\"orderItem.fail\">{{orderItem.msg}}</p>\n" +
    "								</td>\n" +
    "							</tr>\n" +
    "						</tbody>\n" +
    "					</table>\n" +
    "				</div>\n" +
    "				<!-- TASK: NEED PAGING -->\n" +
    "				<p class=\"row-shade ng-hide\" ng-show=\"orderRows.length < 1\">\n" +
    "					No records to display{{vm.order.Items.length > orderRows.length ? '. Note: ' +  (vm.order.Items.length - orderRows.length).toString() + ' rows are hidden due to column filters.' : ''}}\n" +
    "				</p>\n" +
    "				<div style=\"text-align: center; margin:10px 0 10px 0;\">\n" +
    "					<a class=\"ng-hide\" ng-show=\"vm.order.Items.length > orderRows.length && vm.order.Paging.Size < vm.order.Items.length && vm.order.Paging.Size == orderRows.length\" href ng-click=\"vm.order.Paging.Size = vm.order.Paging.Size + 100\">Top {{vm.order.Paging.Size}} Rows Displayed, Show Next 100</a>\n" +
    "				</div>\n" +
    "				<!-- POPUP -->\n" +
    "				<div class=\"table-popup ng-hide\" ng-show=\"!!vm.popup.ready\">\n" +
    "					<div id=\"orderPopupContentCART\" class=\"table-popup-content inline-editor\">\n" +
    "						<h5 class=\"table-popup-title\" ng-click=\"vm.closePopup(true)\"><span>{{vm.popup.title}}</span><span class=\"icon-glyph icon-cancel\" ng-click=\"vm.closePopup(true)\"></span></h5>\n" +
    "						<div class=\"popup-content\">\n" +
    "							<p>{{vm.popup.desc}}</p>\n" +
    "							<div class=\"form-field\">\n" +
    "								<input id=\"orderPopupContentCARTINPUT\" class=\"qty-input\" type=\"text\" ng-model=\"vm.popup.EditQty\" />\n" +
    "								<button type=\"button\" ng-click=\"vm.savePopup()\"><span class=\"icon-glyph\" ng-class=\"{'icon-edit':vm.popup.type == 'CART', 'icon-orders-accum':vm.popup.type == 'SURPLUS-ADD','icon-add':vm.popup.type == 'SURPLUS-REMOVE','icon-orders':vm.popup.type == 'ORDER-QTY'}\"></span></button>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<div class=\"table-popup-bkg\" ng-click=\"vm.closePopup(true)\">&nbsp;</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<!-- PRESPLIT TABLE -->\n" +
    "		<div id=\"orderPanelCart\" class=\"tab-panel presplit-panel ng-hide\" ng-show=\"vm.activeTab == 'ORDER' && vm.action == 'PRESPLIT'\">\n" +
    "			<div class=\"table-list-title\">\n" +
    "				<div class=\"title-left\">&nbsp;</div>\n" +
    "				<div class=\"title-right\">\n" +
    "					<span class=\"no-pad\"><button class=\"btn-alt btn-verisave ng-hide\" ng-show=\"vm.order.Items.length > 0 && (!!vm.order.UseBestCost || !!vm.order.UseMultiVendor)\" ng-click=\"vm.openPopup($event, {}, 'PRESPLIT-OPTIMIZE')\">OPTIMIZE</button></span>\n" +
    "					<span class=\"no-pad\"><button class=\"ng-hide\" ng-show=\"vm.order.Items.length > 0\" id=\"btnOrderSubmit\" type=\"button\" ng-click=\"vm.orderSubmitSplit()\">SPLIT</button></span>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "			<p class=\"order-cii\" ng-show=\"!!vm.order.hasCII\">-- CII Drugs In Cart -- Ordering CII drugs assumes the pharmacy can access its ordering account at the vendor to approve CSOS items.</p>\n" +
    "			<p class=\"order-cii\" ng-show=\"!!vm.order.hasSpecialty\">-- Specialty Drugs In Cart -- Ordering of specialty drug requires special handling.</p>\n" +
    "			<div class=\"table-popup-top\">\n" +
    "				<div class=\"table-fixed-header-scroll\">\n" +
    "					<table>\n" +
    "						<colgroup>\n" +
    "							<col width=\"70px\" />\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"75px\" />\n" +
    "							<col width=\"75px\" />\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"45px\" class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\" /> <!-- 340B -->\n" +
    "							<col width=\"45px\" class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\"/> <!-- 340B -->\n" +
    "							<col width=\"45px\" class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\"/> <!-- GPO -->\n" +
    "							<col width=\"45px\"/> <!-- GPO OR VERISAVER -->\n" +
    "							<col width=\"45px\" class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\"/> <!-- WAC -->\n" +
    "							<col width=\"45px\" class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\"/> <!-- WAC -->\n" +
    "							<col width=\"50px\" />\n" +
    "							<col width=\"30px\" />\n" +
    "						</colgroup>\n" +
    "						<thead class=\"fixed-header\">\n" +
    "							<!-- SECTIONS -->\n" +
    "							<tr>\n" +
    "								<th colspan=\"1\">Usage</th>\n" +
    "								<th colspan=\"6\">Drug Information</th>\n" +
    "								<th colspan=\"2\" class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\">340B</th>\n" +
    "								<th colspan=\"2\" class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\">GPO</th>\n" +
    "								<th colspan=\"2\" class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\">WAC</th>\n" +
    "								<th colspan=\"{{(vm.isVeriSaveOnly ? 3 : 2)}}\">Order</th>\n" +
    "							</tr>\n" +
    "							<!-- TITLES -->\n" +
    "							<tr class=\"column-titles\">\n" +
    "								<td>\n" +
    "									<button class=\"btn\" ng-click=\"vm.openPopup($event, vm.order, 'CATALOG-SEARCH')\" type=\"button\" style=\"width:100%;box-shadow:none;\"><span class=\"icon-glyph icon-add\"></span>Add</button>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('ItemCode', vm.order); $scope.$apply();\">\n" +
    "									<a>NDC<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('ItemCode', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('GPI', vm.order); $scope.$apply();\">\n" +
    "									<a>GPI<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('GPI', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('VendItemNum', vm.order); $scope.$apply();\">\n" +
    "									<a>Item Number<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('VendItemNum', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('ItemDescription', vm.order); $scope.$apply();\">\n" +
    "									<a>Item Description<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('ItemDescription', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('Manufacturer', vm.order); $scope.$apply();\">\n" +
    "									<a>Manufacturer<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('Manufacturer', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('WholesaleUnits', vm.order); $scope.$apply();\">\n" +
    "									<a>Wholesale Units<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('WholesaleUnits', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\" ng-click=\"vm.sortBy('OrderUnits340B', vm.order); $scope.$apply();\">\n" +
    "									<a>Quantity<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('OrderUnits340B', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\" ng-click=\"vm.sortBy('Price340B', vm.order); $scope.$apply();\">\n" +
    "									<a>Price<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('Price340B', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\" ng-click=\"vm.sortBy('OrderUnitsGPO', vm.order); $scope.$apply();\">\n" +
    "									<a>Quantity<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('OrderUnitsGPO', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('PriceGPO', vm.order); $scope.$apply();\">\n" +
    "									<a>Price<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('PriceGPO', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\" ng-click=\"vm.sortBy('OrderUnitsWAC', vm.order); $scope.$apply();\">\n" +
    "									<a>Quantity	<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('OrderUnitsWAC', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\" ng-click=\"vm.sortBy('PriceWAC', vm.order); $scope.$apply();\">\n" +
    "									<a>Price<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('PriceWAC', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('UserUnits', vm.order); $scope.$apply();\">\n" +
    "									<a href >Quantity<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('UserUnits', vm.order.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td>Details</td>\n" +
    "							</tr>\n" +
    "							<!-- FILTERS -->\n" +
    "							<tr class=\"column-filters\">\n" +
    "								<td class=\"info-hover-note\">\n" +
    "									<div class=\"hover-tag ng-hide\" ng-show=\"vm.order.Items.length > 1\">\n" +
    "										<button type=\"button\" class=\"btn-alt\" ng-click=\"vm.presplitChangeAllItems('REMOVE');\">\n" +
    "											<span class=\"icon-glyph icon-remove\"></span>\n" +
    "										</button>\n" +
    "										<p class=\"info-hover-text\">\n" +
    "											<span>Remove All Order Items</span>\n" +
    "										</p>\n" +
    "									</div>\n" +
    "									<div class=\"hover-tag ng-hide\" ng-show=\"!!vm.order.UseBestCost && vm.order.Items.length > 1\">\n" +
    "										<button type=\"button\" ng-class=\"{'btn-cancel': !!vm.order.NoVerisaveSwap, 'btn-alt': !!!vm.order.NoVerisaveSwap}\"ng-click=\"vm.presplitChangeAllItems('VERISAVE');\">\n" +
    "											<span class=\"icon-glyph icon-ops\"></span>\n" +
    "										</button>\n" +
    "										<p class=\"info-hover-text\" ng-class=\"{'swap-off': !!vm.order.NoVerisaveSwap}\">\n" +
    "											<span>{{vm.order.NoVerisaveSwap ? 'Remove' : 'Use'}}&nbsp;Verisave On All Order Items</span>\n" +
    "										</p>\n" +
    "									</div>\n" +
    "									<div class=\"hover-tag ng-hide\" ng-show=\"!!vm.order.UseMultiVendor && vm.order.Items.length > 1\">\n" +
    "										<button type=\"button\" ng-class=\"{'btn-cancel': !!vm.order.NoMultiVendorSwap, 'btn-alt': !!!vm.order.NoMultiVendorSwap}\"ng-click=\"vm.presplitChangeAllItems('MULTIVENDOR');\">\n" +
    "											<span class=\"icon-glyph icon-vendor\"></span>\n" +
    "										</button>\n" +
    "										<p class=\"info-hover-text\" ng-class=\"{'swap-off': !!vm.order.NoMultiVendorSwap}\">\n" +
    "											<span>{{vm.order.NoMultiVendorSwap ? 'Remove' : 'Use'}}&nbsp;Multi Vendor On All Order Items</span>\n" +
    "										</p>\n" +
    "									</div>\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input widget-input-ndc-format format=\"nodash\" type=\"text\" ng-model=\"orderFilter.ItemCode\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input widget-input-ndc-format format=\"nodash\" type=\"text\" ng-model=\"orderFilter.GPI\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"orderFilter.VendItemNum\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"orderFilter.ItemDescription\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"orderFilter.Manufacturer\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"orderFilter.WholesaleUnits\" />\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\">\n" +
    "									<input type=\"text\" ng-model=\"orderFilter.OrderUnits340B\" />\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\">\n" +
    "									<input type=\"text\" ng-model=\"orderFilter.Price340B\" />\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\">\n" +
    "									<input type=\"text\" ng-model=\"orderFilter.OrderUnitsGPO\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"orderFilter.PriceGPO\" />\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\">\n" +
    "									<input type=\"text\" ng-model=\"orderFilter.OrderUnitsWAC\" />\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\">\n" +
    "									<input type=\"text\" ng-model=\"orderFilter.PriceWAC\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"orderFilter.UserUnits\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<a href class=\"ng-hide\" ng-show=\"vm.order.ChangeLog.length > 0\" ng-click=\"vm.openPopup($event, vm.order, 'PRESPLIT-ORDER-LOG')\">details...</a>\n" +
    "								</td>\n" +
    "							</tr>\n" +
    "						</thead>\n" +
    "						<tbody>\n" +
    "							<!-- LIST ITEMS -->\n" +
    "							<tr class=\"table-list-item\" ng-class=\"{'row-shade':$even,'popup-hover':orderItem.popHover,'has-edits':!!orderItem.ChangeLog && orderItem.ChangeLog.length > 0}\"\n" +
    "								ng-repeat=\"orderItem in vm.order.Items\n" +
    "									| filter:orderFilter\n" +
    "									| orderBy:vm.order.SortBy\n" +
    "									| limitTo:vm.order.Paging.Size as orderRows track by orderItem.uniqueId\">\n" +
    "								<td class=\"info-hover-note\">\n" +
    "									<div class=\"hover-tag\">\n" +
    "										<button type=\"button\" class=\"btn-alt\" ng-click=\"vm.presplitRemoveItem(orderItem.ItemCode)\">\n" +
    "											<span class=\"icon-glyph icon-remove\"></span>\n" +
    "										</button>\n" +
    "									</div>\n" +
    "									<div class=\"hover-tag ng-hide\" ng-show=\"!!vm.order.UseBestCost\">\n" +
    "										<button type=\"button\" ng-class=\"{'btn-cancel': !!orderItem.NoVerisaveSwap, 'btn-alt': !!!orderItem.NoVerisaveSwap}\"ng-click=\"vm.presplitToggleItem('VERISAVE',orderItem);\">\n" +
    "											<span class=\"icon-glyph icon-ops\"></span>\n" +
    "										</button>\n" +
    "										<p class=\"info-hover-text\" ng-class=\"{'swap-off': !!orderItem.NoVerisaveSwap}\">\n" +
    "											<span>{{orderItem.VerisaveTitle}}</span>\n" +
    "										</p>\n" +
    "									</div>\n" +
    "									<div class=\"hover-tag ng-hide\" ng-show=\"!!vm.order.UseMultiVendor\">\n" +
    "										<button type=\"button\" ng-class=\"{'btn-cancel': !!orderItem.NoMultiVendorSwap, 'btn-alt': !!!orderItem.NoMultiVendorSwap}\"ng-click=\"vm.presplitToggleItem('MULTIVENDOR',orderItem);\">\n" +
    "											<span class=\"icon-glyph icon-vendor\"></span>\n" +
    "										</button>\n" +
    "										<p class=\"info-hover-text\" ng-class=\"{'swap-off': !!orderItem.NoMultiVendorSwap}\">\n" +
    "											<span>{{orderItem.MultiVendorTitle}}</span>\n" +
    "										</p>\n" +
    "									</div>\n" +
    "								</td>\n" +
    "								<td>{{orderItem.ItemCode}}</td>\n" +
    "								<td>{{orderItem.GPI}}</td>\n" +
    "								<td>{{orderItem.VendItemNum}}</td>\n" +
    "								<td>{{orderItem.ItemDescription}}</td>\n" +
    "								<td>{{orderItem.Manufacturer}}</td>\n" +
    "								<td>{{orderItem.WholesaleUnits}}</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\">{{orderItem.OrderUnits340B | zeroNumberFormat:'':number}}</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\">{{orderItem.Price340B | zeroNumberFormat:'':2}}</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\">{{orderItem.OrderUnitsGPO | zeroNumberFormat:'':number}}</td>\n" +
    "								<td>{{orderItem.PriceGPO | zeroNumberFormat:'':2}}</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\">{{orderItem.OrderUnitsWAC | zeroNumberFormat:'':number}}</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\">{{orderItem.PriceWAC | zeroNumberFormat:'':2}}</td>\n" +
    "								<td class=\"qty-prompt\">\n" +
    "									<div class=\"qty-display\">\n" +
    "										<span class=\"qty-input\" ng-click=\"vm.openPopup($event, orderItem, 'PRESPLIT-EDIT')\" title=\"Edit Order Qty\">{{orderItem.UserUnits}}</span>\n" +
    "										<span class=\"icon-glyph icon-blank\"></span>\n" +
    "									</div>\n" +
    "									<p class=\"err-order-qty ng-hide\" ng-show=\"orderItem.fail\">{{orderItem.msg}}</p>\n" +
    "								</td>\n" +
    "								<td><a href class=\"ng-hide\" ng-show=\"orderItem.ChangeLog.length > 0\" ng-click=\"vm.openPopup($event, orderItem, 'PRESPLIT-ITEM-LOG')\">details...</a></td>\n" +
    "							</tr>\n" +
    "						</tbody>\n" +
    "					</table>\n" +
    "				</div>\n" +
    "				<!-- TASK: NEED PAGING -->\n" +
    "				<p class=\"ng-hide\" ng-show=\"orderRows.length < 1\" style=\"text-align: center\";>\n" +
    "					No records to display{{vm.order.Items.length > orderRows.length ? '. Note: ' +  (vm.order.Items.length - orderRows.length).toString() + ' rows are hidden due to column filters.' : ''}}\n" +
    "				</p>\n" +
    "				<div style=\"text-align: center; margin:10px 0 10px 0;\">\n" +
    "					<a class=\"ng-hide\" ng-show=\"vm.order.Items.length > orderRows.length && vm.order.Paging.Size < vm.order.Items.length && vm.order.Paging.Size == orderRows.length\" href ng-click=\"vm.order.Paging.Size = vm.order.Paging.Size + 100\">Top {{vm.order.Paging.Size}} Rows Displayed, Show Next 100</a>\n" +
    "				</div>\n" +
    "				<!-- PRESPLIT POPUP -->\n" +
    "				<div class=\"table-popup ng-hide\" ng-show=\"!!vm.popup.ready\">\n" +
    "					<div id=\"orderPopupContentPRESPLIT\" class=\"table-popup-content\" ng-class=\"{'inline-editor': vm.popup.type == 'PRESPLIT-EDIT'}\">\n" +
    "						<h5 class=\"table-popup-title\" ng-click=\"vm.closePopup(true)\"><span>{{vm.popup.title}}</span><span class=\"icon-glyph icon-cancel\" ng-click=\"vm.closePopup(true)\"></span></h5>\n" +
    "						<!-- PRESPLIT QTY EDIT -->\n" +
    "						<div class=\"popup-content ng-hide\" ng-show=\"vm.popup.type == 'PRESPLIT-EDIT'\">\n" +
    "							<p>{{vm.popup.desc}}</p>\n" +
    "							<div class=\"form-field\">\n" +
    "								<input id=\"orderPopupContentPRESPLITINPUT\" class=\"qty-input\" type=\"text\" ng-model=\"vm.popup.EditQty\" />\n" +
    "								<button type=\"button\" ng-click=\"vm.savePopup()\"><span class=\"icon-glyph icon-edit\"></span></button>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "						<!-- PRESPLIT CHANGE LOG -->\n" +
    "						<section class=\"ng-hide\" ng-show=\"vm.popup.type == 'PRESPLIT-ITEM-LOG' || vm.popup.type == 'PRESPLIT-ORDER-LOG'\">\n" +
    "							<div class=\"popup-content-scroll\" ng-class=\"{'popup-scroll-max-height': !!vm.popup.maxEditsHeight}\">\n" +
    "								<div ng-repeat=\"changeLogItem in vm.popup.ChangeLog track by $index\" ng-class=\"{'row-shade':$even}\">\n" +
    "									<!-- ORDER LOG -->\n" +
    "									<p class=\"ng-hide\" ng-show=\"vm.popup.type == 'PRESPLIT-ORDER-LOG'\">\n" +
    "										<span>{{changeLogItem.Id}}&nbsp;{{changeLogItem.Action == \"REMOVE\" ? 'Removed' : 'Added'}}</span>\n" +
    "									</p>\n" +
    "									<!-- ITEM LOG -->\n" +
    "									<div class=\"ng-hide\" ng-show=\"vm.popup.type == 'PRESPLIT-ITEM-LOG'\">\n" +
    "										<!-- OLD FORMAT -->\n" +
    "										<div class=\"ng-hide\" ng-show=\"changeLogItem.ChangeType == 'OLD'\" ng-switch=\"!!changeLogItem.NoVerisaveSwapOn\">\n" +
    "											<p ng-switch-when=\"false\">{{changeLogItem.OrderType}} Quantity Changed from {{changeLogItem.OldOrderUnits | number}} to {{changeLogItem.NewOrderUnits | number}}</p>\n" +
    "											<p ng-switch-when=\"true\">VERISAVE<span>{{changeLogItem.NoVerisaveSwapOn == 'ACTIVE' ? 'ON' : 'OFF'}}</span></p>\n" +
    "										</div>\n" +
    "										<!-- NEW FORMAT -->\n" +
    "										<div class=\"ng-hide\" ng-show=\"changeLogItem.ChangeType != 'OLD'\" ng-switch=\"changeLogItem.ChangeType\">\n" +
    "											<p ng-switch-when=\"UNITS\">QUANTITY from {{changeLogItem.OldOrderUnits | number}} to {{changeLogItem.NewOrderUnits | number}}</p>\n" +
    "											<p ng-switch-when=\"NOVERISAVE\">VERISAVE {{changeLogItem.NoVerisaveSwapOn == 'INACTIVE' ? 'ON':'OFF'}}</p>\n" +
    "											<p ng-switch-when=\"NOVENDOR\">MULTI VENDOR {{changeLogItem.NoMVSwapOn == 'INACTIVE' ? 'ON':'OFF'}}</p>\n" +
    "											<p ng-switch-when=\"SUBOPTIMAL\">OPTIMIZED {{changeLogItem.SubOptimized == 'ACTIVE' ? 'Alternate Choice':'Top Choice'}}</p>\n" +
    "										</div>										\n" +
    "									</div>\n" +
    "									<!-- ALL LOGS HAVE BELOW -->\n" +
    "									<div style=\"padding-left:30px;\">\n" +
    "									<p>By: {{changeLogItem.ModBy}}<span>on&nbsp;&nbsp;{{changeLogItem.ModDt | date:'M/d/yyyy h:mm a'}}</span></p>\n" +
    "									<p class=\"ng-hide\" ng-show=\"vm.isSEQ && !!changeLogItem.CEID\">Facility: {{changeLogItem.CEID}}</p>\n" +
    "									<p class=\"ng-hide\" ng-show=\"!!changeLogItem.Notes\">Notes: {{changeLogItem.Notes}}</p>\n" +
    "								</div>\n" +
    "							</div>\n" +
    "							<p class=\"ng-hide\" ng-show=\"!!!vm.popup.maxEditsHeight\">\n" +
    "								<a href ng-click=\"vm.popup.maxEditsHeight = true\"><span class=\"icon-glyph icon-expand-height\"></span>{{vm.popup.ChangeLog.length}}&nbsp;Entries, Expand Height</a>\n" +
    "							</p>\n" +
    "						</section>\n" +
    "						<!-- PRESPLIT CATALOG SEARCH -->\n" +
    "						<div class=\"ng-hide\" ng-show=\"vm.popup.type == 'CATALOG-SEARCH'\">\n" +
    "							<form class=\"query-form\" ng-submit=\"vm.catalogSearch()\" novalidate>\n" +
    "								<fieldset>\n" +
    "									<div class=\"fieldset-row\" style=\"padding-left:7px;\">\n" +
    "										<div class=\"form-field input-txt\">\n" +
    "											<label for=\"searchNDC\">NDC</label>\n" +
    "											<input widget-input-ndc-format format=\"nodash\" id=\"searchNDC\" type=\"text\" placeholder=\"ndc minimum 3 digits\" maxlength=\"11\" ng-model=\"vm.query.ItemCode.val\" style=\"width:14em;\">\n" +
    "											<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.query.ItemCode.fail == 'yes'}\"></span>\n" +
    "										</div>\n" +
    "										<div class=\"form-field input-txt\">\n" +
    "											<label for=\"searchDESC\">Description</label>\n" +
    "											<input id=\"searchDESC\" type=\"text\" placeholder=\"Medi-Span® description 3 to 50 characters\" maxlength=\"50\" ng-model=\"vm.query.Desc.val\" style=\"width:15em;\">\n" +
    "											<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.query.Desc.fail == 'yes'}\"></span>\n" +
    "										</div>\n" +
    "										<div class=\"form-field input-txt\">\n" +
    "											<label for=\"searchVenItemNum\">Vendor Item #</label>\n" +
    "											<input id=\"searchVenItemNum\" type=\"text\" placeholder=\"ven item # 5 chars min\" maxlength=\"30\" ng-model=\"vm.query.VenItemNum.val\" style=\"width:12em;\">\n" +
    "											<span class=\"field-icon icon-glyph\" ng-class=\"{'icon-invalid': vm.query.VenItemNum.fail == 'yes'}\"></span>\n" +
    "										</div>\n" +
    "										<span><button id=\"btnSearchCatalog\" type=\"submit\">SEARCH</button></span>\n" +
    "									</div>\n" +
    "								</fieldset>\n" +
    "							</form>\n" +
    "							<div class=\"popup-content-scroll table-list table-popup-top\">\n" +
    "								<p class=\"ng-hide\" ng-show=\"vm.catalog.tbl.TooMany\" style=\"color:red;\">** Results exceed maximum: 20,000 rows. Reduce the date range to limit results. **</p>\n" +
    "								<div class=\"table-fixed-header-scroll\">\n" +
    "									<table>\n" +
    "										<colgroup>\n" +
    "											<col width=\"45px\" />\n" +
    "											<col width=\"45px\" />\n" +
    "											<col width=\"45px\" />\n" +
    "											<col width=\"60px\" /> <!-- Description -->\n" +
    "											<col width=\"60px\" /> <!-- Manufacturer -->\n" +
    "											<col width=\"45px\" />\n" +
    "											<col width=\"45px\" />\n" +
    "											<col width=\"45px\" />\n" +
    "											<col width=\"45px\" />\n" +
    "											<col width=\"45px\" />\n" +
    "											<col width=\"45px\" />\n" +
    "											<col width=\"30px\" />\n" +
    "										</colgroup>\n" +
    "										<thead class=\"fixed-header\">\n" +
    "											<!-- SECTIONS -->\n" +
    "											<tr>\n" +
    "												<th colspan=\"8\">Drug Information</th>\n" +
    "												<th colspan=\"3\">Pricing</th>\n" +
    "												<th colspan=\"1\">Usage</th>\n" +
    "											</tr>\n" +
    "											<!-- TITLES -->\n" +
    "											<tr class=\"column-titles\">\n" +
    "												<td ng-click=\"vm.sortBy('ItemCode', vm.catalog.flt); $scope.$apply(); vm.catalogFilterChange();\">\n" +
    "													<a>NDC<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('ItemCode', vm.catalog.flt.SortBy)\"></span></a>\n" +
    "												</td>\n" +
    "												<td ng-click=\"vm.sortBy('GPI', vm.catalog.flt); $scope.$apply(); vm.catalogFilterChange();\">\n" +
    "													<a>GPI<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('GPI', vm.catalog.flt.SortBy)\"></span></a>\n" +
    "												</td>\n" +
    "												<td ng-click=\"vm.sortBy('VenItemNum', vm.catalog.flt); $scope.$apply(); vm.catalogFilterChange();\">\n" +
    "													<a>Vendor Item #<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('VenItemNum', vm.catalog.flt.SortBy)\"></span></a>\n" +
    "												</td>\n" +
    "												<td ng-click=\"vm.sortBy('Description', vm.catalog.flt); $scope.$apply(); vm.catalogFilterChange();\">\n" +
    "													<a>Description<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('Description', vm.catalog.flt.SortBy)\"></span></a>\n" +
    "												</td>\n" +
    "												<td ng-click=\"vm.sortBy('Manufacturer', vm.catalog.flt); $scope.$apply(); vm.catalogFilterChange();\">\n" +
    "													<a>Manufacturer<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('Manufacturer', vm.catalog.flt.SortBy)\"></span></a>\n" +
    "												</td>\n" +
    "												<td ng-click=\"vm.sortBy('DrugType', vm.catalog.flt); $scope.$apply(); vm.catalogFilterChange();\">\n" +
    "													<a>Drug Type<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('DrugType', vm.catalog.flt.SortBy)\"></span></a>\n" +
    "												</td>\n" +
    "												<td ng-click=\"vm.sortBy('PkgSz', vm.catalog.flt); $scope.$apply(); vm.catalogFilterChange();\">\n" +
    "													<a>Package Size<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('PkgSz', vm.catalog.flt.SortBy)\"></span></a>\n" +
    "												</td>\n" +
    "												<td ng-click=\"vm.sortBy('CaseSz', vm.catalog.flt); $scope.$apply(); vm.catalogFilterChange();\">\n" +
    "													<a>Case Size<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('CaseSz', vm.catalog.flt.SortBy)\"></span></a>\n" +
    "												</td>\n" +
    "												<td ng-click=\"vm.sortBy('Price340B', vm.catalog.flt); $scope.$apply(); vm.catalogFilterChange();\">\n" +
    "													<a>340B<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('Price340B', vm.catalog.flt.SortBy)\"></span></a>\n" +
    "												</td>\n" +
    "												<td ng-click=\"vm.sortBy('PriceGPO', vm.catalog.flt); $scope.$apply(); vm.catalogFilterChange();\">\n" +
    "													<a>GPO<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('PriceGPO', vm.catalog.flt.SortBy)\"></span></a>\n" +
    "												</td>\n" +
    "												<td ng-click=\"vm.sortBy('PriceWAC', vm.catalog.flt); $scope.$apply(); vm.catalogFilterChange();\">\n" +
    "													<a>WAC<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('PriceWAC', vm.catalog.flt.SortBy)\"></span></a>\n" +
    "												</td>\n" +
    "												<td>Add</td>\n" +
    "											</tr>\n" +
    "											<!-- FILTERS -->\n" +
    "											<tr class=\"column-filters\">\n" +
    "												<td>\n" +
    "													<input type=\"text\" ng-model=\"vm.catalog.flt.Text.ItemCode\" ng-change=\"vm.catalogFilterChange()\" />\n" +
    "												</td>\n" +
    "												<td>\n" +
    "													<input type=\"text\" ng-model=\"vm.catalog.flt.Text.GPI\" ng-change=\"vm.catalogFilterChange()\" />\n" +
    "												</td>\n" +
    "												<td>\n" +
    "													<input type=\"text\" ng-model=\"vm.catalog.flt.Text.VenItemNum\" ng-change=\"vm.catalogFilterChange()\" />\n" +
    "												</td>\n" +
    "												<td>\n" +
    "													<input type=\"text\" ng-model=\"vm.catalog.flt.Text.Description\" ng-change=\"vm.catalogFilterChange()\" />\n" +
    "												</td>\n" +
    "												<td>\n" +
    "													<input type=\"text\" ng-model=\"vm.catalog.flt.Text.Manufacturer\" ng-change=\"vm.catalogFilterChange()\" />\n" +
    "												</td>\n" +
    "												<td>\n" +
    "													<input type=\"text\" ng-model=\"vm.catalog.flt.Text.DrugType\" ng-change=\"vm.catalogFilterChange()\" />\n" +
    "												</td>\n" +
    "												<td>\n" +
    "													<input type=\"text\" ng-model=\"vm.catalog.flt.Text.PkgSz\" ng-change=\"vm.catalogFilterChange()\" />\n" +
    "												</td>\n" +
    "												<td>\n" +
    "													<input type=\"text\" ng-model=\"vm.catalog.flt.Text.CaseSz\" ng-change=\"vm.catalogFilterChange()\" />\n" +
    "												</td>\n" +
    "												<td>\n" +
    "													<input type=\"text\" ng-model=\"vm.catalog.flt.Text.Price340B\" ng-change=\"vm.catalogFilterChange()\" />\n" +
    "												</td>\n" +
    "												<td>\n" +
    "													<input type=\"text\" ng-model=\"vm.catalog.flt.Text.PriceGPO\" ng-change=\"vm.catalogFilterChange()\" />\n" +
    "												</td>\n" +
    "												<td>\n" +
    "													<input type=\"text\" ng-model=\"vm.catalog.flt.Text.PriceWAC\" ng-change=\"vm.catalogFilterChange()\" />\n" +
    "												</td>\n" +
    "												<td>&nbsp;</td>\n" +
    "											</tr>\n" +
    "										</thead>\n" +
    "										<tbody>\n" +
    "											<!-- LIST ITEMS -->\n" +
    "											<tr class=\"table-list-item\" ng-class=\"{'row-shade':$even}\" ng-repeat=\"catalogItem in vm.catalog.tbl.Items track by catalogItem.VenItemNum\">\n" +
    "												<td>{{::catalogItem.ItemCode}}</td>\n" +
    "												<td>{{::catalogItem.GPI}}</td>\n" +
    "												<td>{{::catalogItem.VenItemNum}}</td>\n" +
    "												<td>{{::catalogItem.Description}}</td>\n" +
    "												<td>{{::catalogItem.Manufacturer}}</td>\n" +
    "												<td>{{::catalogItem.DrugType}}</td>\n" +
    "												<td>{{::catalogItem.PkgSz | zeroNumberFormat:'':0}}</td>\n" +
    "												<td>{{::catalogItem.CaseSz | zeroNumberFormat:'':0}}</td>\n" +
    "												<td>{{::catalogItem.Price340B | zeroNumberFormat:'':2}}</td>\n" +
    "												<td>{{::catalogItem.PriceGPO | zeroNumberFormat:'':2}}</td>\n" +
    "												<td>{{::catalogItem.PriceWAC | zeroNumberFormat:'':2}}</td>\n" +
    "												<td>\n" +
    "													<button class=\"cart-prompt\" type=\"button\" ng-click=\"vm.presplitAddItem(catalogItem)\"><span class=\"icon-glyph icon-orders\"></span></button>\n" +
    "												</td>\n" +
    "											</tr>\n" +
    "										</tbody>\n" +
    "									</table>\n" +
    "								</div>\n" +
    "								<div widget-paging unique-id=\"CATALOG\"></div>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "						<!-- PRESPLIT OPTIMIZE -->\n" +
    "						<div class=\"table-list ng-hide\" ng-show=\"vm.popup.type == 'PRESPLIT-OPTIMIZE'\">\n" +
    "							<p>&nbsp;</p>\n" +
    "							<div class=\"table-list-title\">\n" +
    "								<span class=\"title-left\">Choose an optimization per original ndc.</span>\n" +
    "								<span class=\"title-right no-pad-right\">\n" +
    "									<button ng-click=\"vm.optimizeApplyToOrder()\">APPLY TO ORDER</button>\n" +
    "								</span>\n" +
    "							</div>\n" +
    "							<table>\n" +
    "								<colgroup>\n" +
    "									<col width=\"60px\" /> <!-- ndc -->\n" +
    "									<col width=\"60px\" /> <!-- item num -->\n" +
    "									<col width=\"100px\" /> <!-- desc -->\n" +
    "									<col width=\"60px\" /> <!-- qty -->\n" +
    "									<col width=\"60%\" /> <!-- optimize options -->\n" +
    "								</colgroup>\n" +
    "								<thead>\n" +
    "									<tr>\n" +
    "										<th colspan=\"4\">ORIGINAL</th>\n" +
    "										<th>OPTIMIZE OPTIONS</th>\n" +
    "									</tr>\n" +
    "								</thead>\n" +
    "								<tbody>\n" +
    "									<!-- TITLES -->\n" +
    "									<tr class=\"column-titles\">\n" +
    "										<td ng-click=\"vm.sortBy('ItemCode', vm.popup); $scope.$apply();\">\n" +
    "											<a>NDC<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('ItemCode', vm.popup.SortBy)\"></span></a>\n" +
    "										</td>\n" +
    "										<td ng-click=\"vm.sortBy('VenDrugCode', vm.popup); $scope.$apply();\">\n" +
    "											<a>Item Number<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('VenDrugCode', vm.popup.SortBy)\"></span></a>\n" +
    "										</td>\n" +
    "										<td ng-click=\"vm.sortBy('VenLabel', vm.popup); $scope.$apply();\">\n" +
    "											<a>Item Description<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('VenLabel', vm.popup.SortBy)\"></span></a>\n" +
    "										</td>\n" +
    "										<td ng-click=\"vm.sortBy('UserUnits', vm.popup); $scope.$apply();\">\n" +
    "											<a>Qty<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('UserUnits', vm.popup.SortBy)\"></span></a>\n" +
    "										</td>\n" +
    "										<td ng-click=\"vm.sortBy('TopSaving', vm.popup); $scope.$apply();\" style=\"text-align: right;\">\n" +
    "											<a>Top Savings<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('TopSaving', vm.popup.SortBy)\"></span></a>\n" +
    "										</td>\n" +
    "									</tr>\n" +
    "									<!-- ORIGINAL ITEMS  -->\n" +
    "									<tr class=\"table-list-item\" ng-class=\"{'row-shade':$even}\" ng-repeat=\"opItemOrig in vm.popup.Items | orderBy:vm.popup.SortBy\">\n" +
    "										<td>{{opItemOrig.ItemCode}}</td>\n" +
    "										<td>{{opItemOrig.VenDrugCode}}</td>\n" +
    "										<td>{{opItemOrig.VenLabel}}</td>\n" +
    "										<td class=\"optimize-qty\">\n" +
    "											<input type=\"text\" ng-model=\"opItemOrig.UserUnitsEdit\" style=\"width:65%;\"/>\n" +
    "											<button type=\"button\" class=\"btn-alt\" ng-click=\"vm.optimizeEdit('QTY',opItemOrig)\"><span class=\"icon-glyph icon-edit\"></span></button>\n" +
    "											<p class=\"ng-hide\" ng-show=\"!!opItemOrig.qtyFail\" style=\"color:red; text-align:left;\">Save Quantity</p>\n" +
    "										</td>\n" +
    "										<td>\n" +
    "											<!-- OPTIMIZE OPTIONS -->\n" +
    "											<table>\n" +
    "												<colgroup>\n" +
    "													<col width=\"20px\" /> <!-- check -->\n" +
    "													<col width=\"60px\" /> <!-- vendor -->\n" +
    "													<col width=\"60px\" /> <!-- ndc -->\n" +
    "													<col width=\"60px\" /> <!-- item num -->\n" +
    "													<col width=\"30px\" /> <!-- last invoice-->\n" +
    "													<col width=\"120px\" /> <!-- desc -->\n" +
    "													<col width=\"50px\" /> <!-- qty -->\n" +
    "													<col width=\"50px\" /> <!-- savings -->\n" +
    "												</colgroup>\n" +
    "												<tbody>\n" +
    "													<!-- TITLES -->\n" +
    "													<tr class=\"column-titles\">\n" +
    "														<td>&nbsp;</td>\n" +
    "														<td>Vendor</td>\n" +
    "														<td>NDC</td>\n" +
    "														<td>Item Number</td>\n" +
    "														<td>Last Invoice</td>\n" +
    "														<td>Item Description</td>\n" +
    "														<td>Qty</td>\n" +
    "														<td>Savings</td>\n" +
    "													</tr>\n" +
    "													<!-- LIST ITEMS  -->\n" +
    "													<tr class=\"table-list-item\" ng-repeat=\"opItem in opItemOrig.Options | orderBy:['-Saving']\">\n" +
    "														<td class=\"optimize-choice\"><span class=\"icon-glyph glyphicon-ok\" ng-class=\"{'option-chosen': opItem.checked}\" ng-click=\"vm.optimizeEdit('OPTION', opItemOrig, opItem.Id)\"></span></td>\n" +
    "														<td>{{opItem.Vendor}}</td>\n" +
    "														<td>{{opItem.ItemCode}}</td>\n" +
    "														<td>{{opItem.VenDrugCode}}</td>\n" +
    "														<td>{{opItem.LastInvoice | date:'M/d/yyyy'}}</td>\n" +
    "														<td>{{opItem.VenLabel}}</td>\n" +
    "														<td>{{opItem.ItemUnits | number}}</td>\n" +
    "												    	<td ng-style=\"{'color': opItem.Saving <= 0 ? 'red' : ''}\">{{opItem.Saving | currency : '$' : 2}}</td>\n" +
    "													</tr>\n" +
    "													<tr class=\"table-list-item ng-hide\" ng-show=\"!!opItemOrig.dropped\">\n" +
    "														<td class=\"optimize-choice\">&nbsp;</td>\n" +
    "														<td colspan=\"7\">Options not available at this quantity.</td>\n" +
    "													</tr>\n" +
    "													<tr class=\"table-list-item\">\n" +
    "														<td class=\"optimize-choice\"><span class=\"icon-glyph glyphicon-ok\" ng-class=\"{'option-chosen': opItemOrig.useOriginal}\" ng-click=\"vm.optimizeEdit('OPTION',opItemOrig, 'ORIGINAL')\"></span></td>\n" +
    "														<td colspan=\"7\">{{vm.hasNegativeSavings(opItemOrig) ?  'Do Not Substitute, Use Original NDC and Vendor': 'Do Not Optimize, Use Original NDC and Vendor' }}</td>\n" +
    "													</tr>\n" +
    "												</tbody>\n" +
    "											</table>\n" +
    "										</td>\n" +
    "									</tr>\n" +
    "								</tbody>\n" +
    "							</table>\n" +
    "							<p>&nbsp;</p>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<div class=\"table-popup-bkg\" ng-click=\"vm.closePopup(true)\">&nbsp;</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<!-- HISTORY TABLE -->\n" +
    "		<div id=\"orderPanelCart\" class=\"tab-panel order-panel ng-hide\" ng-show=\"vm.activeTab == 'ORDER' && vm.action == 'HISTORY'\">\n" +
    "			<div class=\"table-fixed-header-scroll\">\n" +
    "				<table>\n" +
    "					<colgroup>\n" +
    "						<col width=\"45px\" />\n" +
    "						<col width=\"70px\" />\n" +
    "						<col width=\"100px\" />\n" +
    "						<col width=\"100px\" />\n" +
    "						<col width=\"45px\" />\n" +
    "						<col width=\"55px\" />\n" +
    "						<col class=\"ng-hide\" ng-show=\"vm.order.hasCP\" width=\"45px\" />\n" +
    "						<col class=\"ng-hide\" ng-show=\"vm.order.hasCP\" width=\"45px\" />\n" +
    "					</colgroup>\n" +
    "					<thead class=\"fixed-header\">\n" +
    "						<!-- SECTIONS -->\n" +
    "						<tr>\n" +
    "							<th colspan=\"5\">Drug Information</th>\n" +
    "							<th colspan=\"1\">Order</th>\n" +
    "							<th class=\"ng-hide\" ng-show=\"vm.order.hasCP\" colspan=\"2\">Acknowledgement</th>\n" +
    "						</tr>\n" +
    "						<!-- TITLES -->\n" +
    "						<tr class=\"column-titles\">\n" +
    "							<td ng-click=\"vm.sortBy('ItemCode', vm.order); $scope.$apply();\">\n" +
    "								<a>NDC<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('ItemCode', vm.order.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td ng-click=\"vm.sortBy('VenDrugCode', vm.order); $scope.$apply();\">\n" +
    "								<a>Item Number<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('VenDrugCode', vm.order.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td ng-click=\"vm.sortBy('VenLabel', vm.order); $scope.$apply();\">\n" +
    "								<a>Item Description<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('VenLabel', vm.order.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td ng-click=\"vm.sortBy('Manufacturer', vm.order); $scope.$apply();\">\n" +
    "								<a>Manufacturer<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('Manufacturer', vm.order.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td ng-click=\"vm.sortBy('WholesaleUnits', vm.order); $scope.$apply();\">\n" +
    "								<a>Wholesale Units<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('WholesaleUnits', vm.order.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td>\n" +
    "								<a href ng-click=\"vm.sortBy('UserUnits', vm.order); $scope.$apply();\">Order Qty<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('UserUnits', vm.order.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "              				<td class=\"ng-hide\" ng-show=\"vm.order.hasCP\" >\n" +
    "								<a href ng-click=\"vm.sortBy('StatusCode', vm.order); $scope.$apply();\">Status Code<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('StatusCode', vm.order.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "              				<td class=\"ng-hide\" ng-show=\"vm.order.hasCP\"> \n" +
    "								<a href ng-click=\"vm.sortBy('ItemUnitsAck', vm.order); $scope.$apply();\">Ack Qty<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('ItemUnitsAck', vm.order.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "						</tr>\n" +
    "						<!-- FILTERS -->\n" +
    "						<tr class=\"column-filters\">\n" +
    "							<td>\n" +
    "								<input widget-input-ndc-format format=\"nodash\" type=\"text\" ng-model=\"orderFilter.ItemCode\" />\n" +
    "							</td>\n" +
    "							<td>\n" +
    "								<input type=\"text\" ng-model=\"orderFilter.VenDrugCode\" />\n" +
    "							</td>\n" +
    "							<td>\n" +
    "								<input type=\"text\" ng-model=\"orderFilter.VenLabel\" />\n" +
    "							</td>\n" +
    "							<td>\n" +
    "								<input type=\"text\" ng-model=\"orderFilter.Manufacturer\" />\n" +
    "							</td>\n" +
    "							<td>\n" +
    "								<input type=\"text\" ng-model=\"orderFilter.WholesaleUnits\" />\n" +
    "							</td>\n" +
    "							<td style=\"text-align:center;\">\n" +
    "								<input type=\"text\" ng-model=\"orderFilter.UserUnits\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.order.hasCP\">\n" +
    "								<input type=\"text\" ng-model=\"orderFilter.StatusCode\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.order.hasCP\">\n" +
    "								<input type=\"text\" ng-model=\"orderFilter.ItemUnitsAck\" />\n" +
    "							</td>\n" +
    "						</tr>\n" +
    "					</thead>\n" +
    "					<tbody>\n" +
    "						<!-- LIST ITEMS -->\n" +
    "						<tr class=\"table-list-item\" ng-class=\"{'row-shade':$even}\"\n" +
    "							ng-repeat=\"orderItem in vm.order.Items\n" +
    "								| filter:orderFilter\n" +
    "								| orderBy:vm.order.SortBy\n" +
    "								| limitTo:vm.order.Paging.Size as orderRows track by orderItem.uniqueId\">\n" +
    "							<td>{{orderItem.ItemCode}}\n" +
    "								<span class=\"ng-hide\" ng-show=\"orderItem.Replaced\">(OUT)</span>\n" +
    "							</td>\n" +
    "							<td>{{orderItem.VenDrugCode}}</td>\n" +
    "							<td>{{orderItem.VenLabel}}</td>\n" +
    "							<td>{{orderItem.Manufacturer}}</td>\n" +
    "							<td>{{orderItem.WholesaleUnits}}</td>\n" +
    "							<td>{{orderItem.UserUnitsEdit}}</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.order.hasCP\">{{orderItem.StatusCode}}</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.order.hasCP\">{{orderItem.ItemUnitsAck}}</td>\n" +
    "						</tr>\n" +
    "					</tbody>\n" +
    "				</table>\n" +
    "			</div>\n" +
    "      		<p class=\"ng-hide\" ng-show=\"orderRows.length < 1\">No records to display{{vm.order.Items.length > orderRows.length ? '. Note: ' +  (vm.order.Items.length - orderRows.length).toString() + ' rows are hidden due to column filters.' : ''}}</p>\n" +
    "			<!-- TASK: NEED PAGING -->\n" +
    "			<div style=\"text-align: center; margin:10px 0 10px 0;\">\n" +
    "				<a class=\"ng-hide\" ng-show=\"vm.order.Items.length > orderRows.length && vm.order.Paging.Size < vm.order.Items.length && vm.order.Paging.Size == orderRows.length\" href ng-click=\"vm.order.Paging.Size = vm.order.Paging.Size + 100\">Top {{vm.order.Paging.Size}} Rows Displayed, Show Next 100</a>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<!-- ACCUM TABLE -->\n" +
    "		<div id=\"orderPanelAccum\" class=\"tab-panel ng-hide\" ng-show=\"vm.activeTab == 'ACCUM'\">\n" +
    "			<div class=\"table-popup-top\">\n" +
    "				<div class=\"table-fixed-header-scroll\">\n" +
    "					<table>\n" +
    "						<colgroup>\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"100px\" />\n" +
    "							<col width=\"80px\" />\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"30px\" class=\"ng-hide\" ng-show=\"vm.query.usingDirectRep\"/> <!-- CE block -->\n" +
    "							<col width=\"30px\" class=\"ng-hide\" ng-show=\"vm.query.usingDirectRep\"/> <!-- VEN block -->\n" +
    "							<col width=\"45px\" class=\"ng-hide\" ng-show=\"vm.query.RxSplit || vm.accum.hasRefPrice || vm.query.usingDirectRep\" /> <!-- price -->\n" +
    "							<col width=\"45px\" class=\"ng-hide\" ng-show=\"vm.query.usingDirectRep\" /> <!-- profit -->\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"45px\" class=\"ng-hide\" ng-show=\"!vm.query.RxSplit && vm.query.AcctType.val != 'OWN' && !vm.query.usingDirectRep\" /> <!-- surplus -->\n" +
    "							<col width=\"45px\" />\n" +
    "						</colgroup>\n" +
    "						<thead class=\"fixed-header\">\n" +
    "							<!-- SECTIONS -->\n" +
    "							<tr>\n" +
    "								<th colspan=\"{{6 + (vm.query.usingDirectRep ? 2 : 0)}}\">Drug Information</th>\n" +
    "								<th colspan=\"1\" class=\"ng-hide\" ng-show=\"!vm.query.usingDirectRep && (vm.query.RxSplit || vm.accum.hasRefPrice)\">{{(vm.accum.hasRefPrice ? 'Ref ' : '')}}Price</th>\n" +
    "								<th colspan=\"2\" class=\"ng-hide\" ng-show=\"vm.query.usingDirectRep\">Pricing</th>\n" +
    "								<th colspan=\"{{1 + ((!vm.query.RxSplit && vm.query.AcctType.val != 'OWN' && !vm.query.usingDirectRep) ? 1 : 0)}}\">Quantity</th>\n" +
    "								<th colspan=\"1\">Order</th>\n" +
    "							</tr>\n" +
    "							<!-- TITLES -->\n" +
    "							<tr class=\"column-titles\">\n" +
    "								<td ng-click=\"vm.sortBy('ItemCode', vm.accum); $scope.$apply();\">\n" +
    "									<a>NDC<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('ItemCode', vm.accum.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('GPI', vm.accum); $scope.$apply();\">\n" +
    "									<a>GPI<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('GPI', vm.accum.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('VenDrugCode', vm.accum); $scope.$apply();\">\n" +
    "									<a>Item Number<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('VenDrugCode', vm.accum.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('VenLabel', vm.accum); $scope.$apply();\">\n" +
    "									<a>Item Description<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('VenLabel', vm.accum.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('Manufacturer', vm.accum); $scope.$apply();\">\n" +
    "									<a>Manufacturer<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('Manufacturer', vm.accum.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('WholesaleUnits', vm.accum); $scope.$apply();\">\n" +
    "									<a>Wholesale Units<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('WholesaleUnits', vm.accum.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.query.usingDirectRep\" ng-click=\"vm.sortBy('CEBlocked', vm.accum); $scope.$apply();\">\n" +
    "									<a>CE Block<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('CEBlocked', vm.accum.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.query.usingDirectRep\" ng-click=\"vm.sortBy('VendorBlocked', vm.accum); $scope.$apply();\">\n" +
    "									<a>Vendor Block<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('VendorBlocked', vm.accum.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.query.usingDirectRep && vm.accum.hasRefPrice\" ng-click=\"vm.sortBy('RefPrice', vm.accum); $scope.$apply();\">\n" +
    "									<a>Reference<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('RefPrice', vm.accum.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.query.usingDirectRep || vm.query.RxSplit\" ng-click=\"vm.sortBy('Price', vm.accum); $scope.$apply();\">\n" +
    "									<a>Price<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('Price', vm.accum.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.query.usingDirectRep\" ng-click=\"vm.sortBy('EstimatedProfit', vm.accum); $scope.$apply();\">\n" +
    "									<a>Profit<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('EstimatedProfit', vm.accum.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('ItemUnits', vm.accum); $scope.$apply();\" style=\"min-width:100px;\">\n" +
    "									<span class=\"icon-glyph ng-hide\" ng-show=\"!vm.query.RxSplit\" ng-model=\"vm.chkHasAccum\" ng-class=\"{'icon-checked':vm.chkHasAccum,'icon-unchecked':!vm.chkHasAccum}\" ng-click=\"vm.chkFilterToggle('accum')\" style=\"color:#00827A; cursor:pointer;\"></span>\n" +
    "									<a>{{vm.query.RxSplit ? 'Quantity' : 'New'}}<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('ItemUnits', vm.accum.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.query.RxSplit && vm.query.AcctType.val != 'OWN' && !vm.query.usingDirectRep\" ng-click=\"vm.sortBy('SurplusUnits', vm.accum); $scope.$apply();\" style=\"min-width:100px;\">\n" +
    "									<span class=\"icon-glyph\" ng-model=\"vm.chkHasSurplus\" ng-class=\"{'icon-checked':vm.chkHasSurplus,'icon-unchecked':!vm.chkHasSurplus}\" ng-click=\"vm.chkFilterToggle('surplus')\" style=\"color:#00827A; cursor:pointer;\"></span>\n" +
    "									<a>Surplus<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('SurplusUnits', vm.accum.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td>&nbsp;</td>\n" +
    "							</tr>\n" +
    "							<!-- FILTERS -->\n" +
    "							<tr class=\"column-filters\">\n" +
    "								<td>\n" +
    "									<input widget-input-ndc-format format=\"nodash\" type=\"text\" ng-model=\"accumFilter.ItemCode\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"accumFilter.GPI\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"accumFilter.VenDrugCode\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"accumFilter.VenLabel\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"accumFilter.Manufacturer\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"accumFilter.WholesaleUnits\" />\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.query.usingDirectRep\">\n" +
    "									<input type=\"text\" ng-model=\"accumFilter.CEBlocked\" />\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.query.usingDirectRep\">\n" +
    "									<input type=\"text\" ng-model=\"accumFilter.VendorBlocked\" />\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.query.RxSplit || vm.query.usingDirectRep\">\n" +
    "									<input type=\"text\" ng-model=\"accumFilter.Price\" />\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.query.usingDirectRep && vm.accum.hasRefPrice\">\n" +
    "									<input type=\"text\" ng-model=\"accumFilter.RefPrice\" />\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.query.usingDirectRep\">\n" +
    "									<input type=\"text\" ng-model=\"accumFilter.EstimatedProfit\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"accumFilter.ItemUnits\" />\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.query.RxSplit && vm.query.AcctType.val != 'OWN' && !vm.query.usingDirectRep\">\n" +
    "									<input type=\"text\" ng-model=\"accumFilter.SurplusUnits\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<button class=\"ng-hide\" ng-show=\"vm.accum.Items.length > 0\" id=\"orderBtnOrderAll\" type=\"button\" ng-click=\"vm.orderAddAll()\">ORDER ALL</button>\n" +
    "								</td>\n" +
    "							</tr>\n" +
    "						</thead>\n" +
    "						<tbody>\n" +
    "							<!-- LIST ITEMS -->\n" +
    "							<tr class=\"table-list-item\" ng-class=\"{'row-shade':$even,'popup-hover':accumItem.popHover}\"\n" +
    "								ng-repeat=\"accumItem in accumRows = (vm.accum.Items\n" +
    "									| filter:accumFilter\n" +
    "									| filter:vm.chkFilters\n" +
    "									| orderBy:vm.accum.SortBy\n" +
    "									| limitTo:vm.accum.Paging.Size)\">\n" +
    "								<td>{{accumItem.ItemCode}} \n" +
    "									<span class=\"ng-hide\" ng-show=\"accumItem.Replaced\">(OUT)</span>\n" +
    "								</td>\n" +
    "								<td>{{accumItem.GPI}}</td>\n" +
    "								<td>{{accumItem.VenDrugCode}}</td>\n" +
    "								<td>{{accumItem.VenLabel}}</td>\n" +
    "								<td>{{accumItem.Manufacturer}}</td>\n" +
    "								<td>{{accumItem.WholesaleUnits}}</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.query.usingDirectRep\">{{accumItem.CEBlocked}}</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.query.usingDirectRep\">{{accumItem.VendorBlocked}}</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.query.RxSplit || vm.query.usingDirectRep\" style=\"padding-left:18px;\">{{accumItem.Price | zeroNumberFormat:'':2}}</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"!vm.query.usingDirectRep && vm.accum.hasRefPrice\" style=\"padding-left:18px;\">{{accumItem.RefPrice | zeroNumberFormat:'':2}}</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.query.usingDirectRep\">{{accumItem.EstimatedProfit | zeroNumberFormat:'':2}}</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.query.RxSplit || vm.query.AcctType.val == 'OWN' || vm.query.usingDirectRep\" style=\"padding-left:18px;\">{{accumItem.ItemUnits | number}}</td>\n" +
    "								<td class=\"qty-prompt ng-hide\" ng-show=\"!vm.query.RxSplit && vm.query.AcctType.val != 'OWN' && !vm.query.usingDirectRep\">\n" +
    "									<div class=\"qty-display ng-hide\" ng-show=\"accumItem.ItemUnits > 0\">\n" +
    "										<span class=\"qty-input\" ng-click=\"vm.openPopup($event, accumItem, 'SURPLUS-ADD')\" title=\"Edit Surplus Qty\">{{accumItem.ItemUnits | number}}</span>\n" +
    "										<button class=\"btn-alt\" type=\"button\" ng-click=\"vm.surplusAddQty(accumItem.ItemCode, accumItem.ItemUnits)\" title=\"Save {{accumItem.ItemUnits | number}} Units To Surplus\"><span class=\"icon-glyph icon-orders-accum\"></span></button>\n" +
    "									</div>\n" +
    "								</td>\n" +
    "								<td class=\"qty-prompt ng-hide\" ng-show=\"!vm.query.RxSplit && vm.query.AcctType.val != 'OWN' && !vm.query.usingDirectRep\">\n" +
    "									<div class=\"qty-display ng-hide\" ng-show=\"accumItem.SurplusUnits > 0\">\n" +
    "										<span class=\"qty-input\" ng-click=\"vm.openPopup($event, accumItem, 'SURPLUS-REMOVE')\" title=\"Edit Surplus Qty\">{{accumItem.SurplusUnits | number}}</span>\n" +
    "										<button class=\"btn-alt\" type=\"button\" ng-click=\"vm.surplusRemoveQty(accumItem.ItemCode, accumItem.SurplusUnits)\" title=\"Use {{accumItem.SurplusUnits | number}} Surplus Units\"><span class=\"icon-glyph icon-add\"></span></button>\n" +
    "									</div>\n" +
    "								</td>\n" +
    "								<td class=\"qty-prompt\">\n" +
    "									<div class=\"qty-display ng-hide\" ng-show=\"accumItem.ItemUnits > 0\">\n" +
    "										<span class=\"qty-input\" ng-click=\"vm.openPopup($event, accumItem, 'ORDER-QTY')\" title=\"Edit Order Qty\">{{accumItem.OrderAddQty | number}}</span>\n" +
    "										<button class=\"cart-prompt\" type=\"button\" ng-click=\"vm.orderAddItem(accumItem.ItemCode, accumItem.OrderAddQty)\" title=\"Add {{accumItem.OrderAddQty | number}} To Cart\"><span class=\"icon-glyph icon-orders\"></span></button>\n" +
    "									</div>\n" +
    "								</td>\n" +
    "							</tr>\n" +
    "						</tbody>\n" +
    "					</table>\n" +
    "				</div>\n" +
    "				<!-- TASK: NEED PAGING -->\n" +
    "				<p class=\"table-list-item row-shade ng-hide\" ng-show=\"accumRows.length < 1\">\n" +
    "					No records to display{{vm.accum.Items.length > accumRows.length ? '. Note: ' +  (vm.accum.Items.length - accumRows.length).toString() + ' rows are hidden due to column filters.' : ''}}\n" +
    "				</p>\n" +
    "				<div style=\"text-align: center; margin:10px 0 10px 0;\">\n" +
    "					<a class=\"ng-hide\" ng-show=\"vm.accum.Items.length > accumRows.length && vm.accum.Paging.Size < vm.accum.Items.length && vm.accum.Paging.Size == accumRows.length\" href ng-click=\"vm.accum.Paging.Size = vm.accum.Paging.Size + 100\">Top {{vm.accum.Paging.Size}} Rows Displayed, Show Next 100</a>\n" +
    "				</div>\n" +
    "				<div class=\"ng-hide\" ng-show=\"!vm.query.RxSplit && vm.query.AcctType.val != 'OWN' && (vm.query.UserType == 'VERITY' || vm.query.UserType == 'VERITYSA')\" style=\"text-align: center; margin:20px 0 10px 0;\">\n" +
    "					Verity Admin Features:&nbsp;\n" +
    "					<a href ng-click=\"vm.surplusAddAll()\"><span class=\"icon-glyph icon-orders-accum\"></span>Move all accumulation to Surplus</a>\n" +
    "					&nbsp;&nbsp;<a href ng-click=\"vm.surplusRemoveAll()\"><span class=\"icon-glyph icon-add\"></span>Move all Surplus to accumulation</a>\n" +
    "				</div>\n" +
    "				<!-- POPUP -->\n" +
    "				<div class=\"table-popup ng-hide\" ng-show=\"!!vm.popup.ready\">\n" +
    "					<div id=\"orderPopupContentACCUM\" class=\"table-popup-content inline-editor\">\n" +
    "						<h5 class=\"table-popup-title\" ng-click=\"vm.closePopup(true)\"><span>{{vm.popup.title}}</span><span class=\"icon-glyph icon-cancel\" ng-click=\"vm.closePopup(true)\"></span></h5>\n" +
    "						<div class=\"popup-content\">\n" +
    "							<p>{{vm.popup.desc}}</p>\n" +
    "							<div class=\"form-field\">\n" +
    "								<input id=\"orderPopupContentACCUMINPUT\" class=\"qty-input\" type=\"text\" ng-model=\"vm.popup.EditQty\" />\n" +
    "								<button ng-class=\"{'btn-alt': vm.popup.type == 'SURPLUS-ADD' || vm.popup.type == 'SURPLUS-REMOVE'}\" type=\"button\" ng-click=\"vm.savePopup()\"><span class=\"icon-glyph\" ng-class=\"{'icon-orders-accum':vm.popup.type == 'SURPLUS-ADD','icon-add':vm.popup.type == 'SURPLUS-REMOVE','icon-edit':vm.popup.type == 'ORDER-QTY'}\"></span></button>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<div class=\"table-popup-bkg\" ng-click=\"vm.closePopup(true)\">&nbsp;</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "		<!-- ASSAY TABLE -->\n" +
    "		<div id=\"orderPanelAssay\" class=\"tab-panel ng-hide\" ng-show=\"vm.activeTab == 'ASSAY' || vm.activeTab == 'ASSAY_ORDER'\">\n" +
    "			<!--- Help2 Link here? -->\n" +
    "			<div class=\"table-popup-top\">\n" +
    "				<div class=\"table-fixed-header-scroll\">\n" +
    "					<table>\n" +
    "						<colgroup>\n" +
    "							<col width=\"45px\" class=\"ng-hide\" ng-show=\"vm.assay.showRemoveBtn\" />\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"45px\" class=\"ng-hide\" ng-show=\"vm.activeTab == 'ASSAY'\"/> <!-- GPI -->\n" +
    "							<col width=\"100px\" />\n" +
    "							<col width=\"80px\" />\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"45px\" /> <!-- assay pkg -->\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"45px\" /> <!-- assay ord -->\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"45px\" />\n" +
    "							<col width=\"40px\" class=\"ng-hide\" ng-show=\"vm.activeTab == 'ASSAY'\" />\n" +
    "						</colgroup>\n" +
    "						<thead class=\"fixed-header\">\n" +
    "							<!-- SECTIONS -->\n" +
    "							<tr>\n" +
    "								<th class=\"ng-hide\" ng-show=\"vm.assay.showRemoveBtn\">Usage</th>\n" +
    "								<th colspan=\"{{(vm.activeTab == 'ASSAY' ? 5 : 4)}}\">Drug Information</th>\n" +
    "								<th colspan=\"4\">Assay Package</th>\n" +
    "								<th colspan=\"{{(vm.activeTab == 'ASSAY' ? 4 : 3)}}\">Assay Order</th>\n" +
    "							</tr>\n" +
    "							<!-- TITLES -->\n" +
    "							<tr class=\"column-titles\">\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.assay.showRemoveBtn\">Remove</td>\n" +
    "								<td ng-click=\"vm.sortBy('ItemCode', vm.assay); $scope.$apply();\">\n" +
    "									<a>NDC<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('ItemCode', vm.assay.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.activeTab == 'ASSAY'\" ng-click=\"vm.sortBy('GPI', vm.assay); $scope.$apply();\">\n" +
    "									<a>GPI<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('GPI', vm.assay.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('VenLabel', vm.assay); $scope.$apply();\">\n" +
    "									<a>Item Description<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('VenLabel', vm.assay.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('Manufacturer', vm.assay); $scope.$apply();\">\n" +
    "									<a>Manufacturer<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('Manufacturer', vm.assay.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('WholesaleUnits', vm.assay); $scope.$apply();\">\n" +
    "									<a>Wholesale Units<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('WholesaleUnits', vm.assay.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<!-- assay pkg -->\n" +
    "								<td ng-click=\"vm.sortBy('VenDrugCode', vm.assay); $scope.$apply();\">\n" +
    "									<a>Assay VIN<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('VenDrugCode', vm.assay.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('LotNumber', vm.assay); $scope.$apply();\">\n" +
    "									<a>Lot Num<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('LotNumber', vm.assay.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('LotExpiration', vm.assay); $scope.$apply();\">\n" +
    "									<a>Lot Expires<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('LotExpiration', vm.assay.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('AssayUnits', vm.assay); $scope.$apply();\">\n" +
    "									<a>Units Per Pkg<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('AssayUnits', vm.assay.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<!-- assay ord -->\n" +
    "								<td ng-click=\"vm.sortBy('AssayQty', vm.assay); $scope.$apply();\" style=\"min-width:100px;\">\n" +
    "									<a>Order Pkgs<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('AssayQty', vm.assay.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('AssayTotalUnits', vm.assay); $scope.$apply();\" style=\"min-width:100px;\">\n" +
    "									<a>Order Units<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('AssayTotalUnits', vm.assay.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td ng-click=\"vm.sortBy('AssayRemainder', vm.assay); $scope.$apply();\" style=\"min-width:100px;\">\n" +
    "									<a>Units Avail<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('AssayRemainder', vm.assay.SortBy)\"></span></a>\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.activeTab == 'ASSAY'\">&nbsp;</td>\n" +
    "							</tr>\n" +
    "							<!-- FILTERS -->\n" +
    "							<tr class=\"column-filters\">\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.assay.showRemoveBtn\">&nbsp;</td>\n" +
    "								<td>\n" +
    "									<input widget-input-ndc-format format=\"nodash\" type=\"text\" ng-model=\"assayFilter.ItemCode\" />\n" +
    "								</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.activeTab == 'ASSAY'\">\n" +
    "									<input type=\"text\" ng-model=\"assayFilter.GPI\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"assayFilter.VenLabel\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"assayFilter.Manufacturer\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"assayFilter.WholesaleUnits\" />\n" +
    "								</td>\n" +
    "								<!-- assay pkg -->\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"assayFilter.VenDrugCode\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"assayFilter.LotNumber\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"assayFilter.LotExpiration\" />\n" +
    "								</td>\n" +
    "								<td>\n" +
    "									<input type=\"text\" ng-model=\"assayFilter.AssayUnits\" />\n" +
    "								</td>\n" +
    "								<!-- assay ord -->\n" +
    "								<td colspan=\"{{(vm.activeTab == 'ASSAY' ? 4 : 3)}}\" style=\"text-align:center;\">\n" +
    "									<button id=\"btnAssayCreate\" type=\"button\" class=\"ng-hide\" ng-show=\"vm.activeTab == 'ASSAY_ORDER' && vm.action == 'CREATE' && vm.order.Items.length > 0\" ng-click=\"vm.orderCreate()\" style=\"width:auto;min-width:30%;\">CREATE ORDER</button>\n" +
    "									<button id=\"btnAssaySave\" type=\"button\" class=\"btn-alt ng-hide\" ng-show=\"vm.activeTab == 'ASSAY_ORDER' && vm.action == 'UPDATE'\" ng-click=\"vm.orderUpdate()\" style=\"width:auto; min-width:40%;\">SAVE</button>\n" +
    "									<button id=\"btnAssayPlace\" type=\"button\" class=\"ng-hide\" ng-show=\"vm.activeTab == 'ASSAY_ORDER' && vm.action == 'UPDATE'\" ng-click=\"vm.orderPlace()\" style=\"width:auto; min-width:40%;margin-left: 10px;\">PLACE</button>\n" +
    "								</td>\n" +
    "							</tr>\n" +
    "						</thead>\n" +
    "						<tbody>\n" +
    "							<!-- LIST ITEMS -->\n" +
    "							<tr class=\"table-list-item\" ng-class=\"{'row-shade':$even,'popup-hover':assayItem.popHover}\"\n" +
    "								ng-repeat=\"assayItem in vm.assay.Items\n" +
    "									| filter:assayFilter\n" +
    "									| orderBy:vm.assay.SortBy\n" +
    "									| limitTo:vm.assay.Paging.Size as assayRows track by assayItem.uniqueId\">\n" +
    "								<td class=\"qty-prompt remove-item ng-hide\" ng-show=\"vm.assay.showRemoveBtn\">\n" +
    "									<div class=\"qty-display\">\n" +
    "										<button class=\"btn-alt\" type=\"button\" ng-click=\"vm.assayRemoveFromCart(assayItem)\" title=\"\"><span class=\"icon-glyph icon-remove\"></span></button>\n" +
    "									</div>\n" +
    "								</td>\n" +
    "								<td>{{assayItem.ItemCode}}</td>\n" +
    "								<td class=\"ng-hide\" ng-show=\"vm.activeTab == 'ASSAY'\">{{assayItem.GPI}}</td>\n" +
    "								<td>{{assayItem.VenLabel}}</td>\n" +
    "								<td>{{assayItem.Manufacturer}}</td>\n" +
    "								<td>{{assayItem.WholesaleUnits}}</td>\n" +
    "								<!-- assay pkg -->\n" +
    "								<td><input type=\"textbox\" ng-model=\"assayItem.VenDrugCode\" maxlength=\"40\" ng-disabled=\"vm.activeTab == 'ASSAY_ORDER'\"/></td>\n" +
    "								<td><input type=\"textbox\" ng-model=\"assayItem.LotNumber\" maxlength=\"40\" ng-disabled=\"vm.activeTab == 'ASSAY_ORDER'\"/></td>\n" +
    "								<td><input type=\"textbox\" ng-model=\"assayItem.LotExpiration\" ng-disabled=\"vm.activeTab == 'ASSAY_ORDER'\"/></td>\n" +
    "								<td><input type=\"textbox\" ng-model=\"assayItem.AssayUnits\" ng-change=\"vm.assayEdit(assayItem); $scope.$apply();\" ng-disabled=\"vm.activeTab == 'ASSAY_ORDER'\"/></td>\n" +
    "								<!-- assay ord -->\n" +
    "								<td><input type=\"textbox\" ng-model=\"assayItem.AssayQty\" ng-change=\"vm.assayEdit(assayItem); $scope.$apply();\" ng-disabled=\"vm.activeTab == 'ASSAY_ORDER'\"/></td>\n" +
    "								<td>{{assayItem.AssayTotalUnits}}</td>\n" +
    "								<td>{{assayItem.AssayRemainder}}</td>\n" +
    "								<td class=\"qty-prompt ng-hide\" ng-show=\"vm.activeTab == 'ASSAY'\">\n" +
    "									<div class=\"qty-display\">\n" +
    "										<button class=\"cart-prompt\" type=\"button\" ng-click=\"vm.assayAddToCart(assayItem)\" title=\"Add To Cart\"><span class=\"icon-glyph icon-orders\"></span></button>\n" +
    "									</div>\n" +
    "									<p class=\"ng-hide\" ng-show=\"!!!assayItem.fail && assayItem.AssayInCart > 0\">{{assayItem.AssayInCart}}&nbsp;cart items</p>\n" +
    "									<p class=\"err-order-qty ng-hide\" ng-show=\"assayItem.fail\">{{assayItem.msg}}</p>\n" +
    "								</td>\n" +
    "							</tr>\n" +
    "							<tr class=\"table-list-item\">\n" +
    "								<td colspan=\"{{(vm.assay.showRemoveBtn ? 9 : 8) + (vm.activeTab == 'ASSAY' ? 1 : 0)}}\"><p style=\"text-align:right;\">Order Total</p></td>\n" +
    "								<td>{{vm.assay.totalAssayQty}}</td>\n" +
    "								<td>{{vm.assay.totalAssayUnits}}</td>\n" +
    "								<td colspan=\"{{(vm.activeTab == 'ASSAY' ? 2 : 1)}}\">&nbsp;</td>\n" +
    "							</tr>\n" +
    "						</tbody>\n" +
    "					</table>\n" +
    "				</div>\n" +
    "				<!-- TASK: NEED PAGING -->\n" +
    "				<p class=\"table-list-item row-shade ng-hide\" ng-show=\"assayRows.length < 1\">\n" +
    "					No records to display{{vm.assay.Items.length > assayRows.length ? '. Note: ' +  (vm.assay.Items.length - assayRows.length).toString() + ' rows are hidden due to column filters.' : ''}}\n" +
    "				</p>\n" +
    "				<div style=\"text-align: center; margin:10px 0 10px 0;\">\n" +
    "					<a class=\"ng-hide\" ng-show=\"vm.assay.Items.length > assayRows.length && vm.assay.Paging.Size < vm.assay.Items.length && vm.assay.Paging.Size == assayRows.length\" href ng-click=\"vm.assay.Paging.Size = vm.assay.Paging.Size + 100\">Top {{vm.assay.Paging.Size}} Rows Displayed, Show Next 100</a>\n" +
    "				</div>\n" +
    "				<!-- POPUP -->\n" +
    "				<div class=\"table-popup ng-hide\" ng-show=\"!!vm.popup.ready\">\n" +
    "					<div id=\"orderPopupContentACCUM\" class=\"table-popup-content inline-editor\">\n" +
    "						<h5 class=\"table-popup-title\" ng-click=\"vm.closePopup(true)\"><span>{{vm.popup.title}}</span><span class=\"icon-glyph icon-cancel\" ng-click=\"vm.closePopup(true)\"></span></h5>\n" +
    "						<div class=\"popup-content\">\n" +
    "							<p>{{vm.popup.desc}}</p>\n" +
    "							<div class=\"form-field\">\n" +
    "								<input id=\"orderPopupContentASSAYINPUT\" class=\"qty-input\" type=\"text\" ng-model=\"vm.popup.EditQty\" />\n" +
    "								<button type=\"button\" ng-click=\"vm.savePopup()\"><span class=\"icon-glyph\" ng-class=\"{'icon-edit':vm.popup.type == 'ASSAY-QTY'}\"></span></button>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<div class=\"table-popup-bkg\" ng-click=\"vm.closePopup(true)\">&nbsp;</div>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "		</div>\n" +
    "	</section>\n" +
    "</div>\n" +
    "<div scripty-lazy-load data-src=\"vendor/pdf/FileSaver.js\"></div>\n" +
    "<div scripty-lazy-load data-src=\"vendor/pdf/blob-stream.js\"></div>\n" +
    "");
}]);

angular.module("orders/ui/split.detail.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("orders/ui/split.detail.tpl.html",
    "<div class=\"orders-feature orders-split\">\n" +
    "	<section class=\"query-panel\">\n" +
    "		<a class=\"help-text-link top-right\" href ng-click=\"vm.helpLink('order-list-splitdetails', 'Split Order Details')\"><span class=\"icon-glyph icon-help\"></span>Help</a>\n" +
    "		<form class=\"query-form\" novalidate>\n" +
    "			<fieldset class=\"edit-details\">\n" +
    "				<p>\n" +
    "					<span>Status:&nbsp;</span>\n" +
    "					<span><button type=\"button\" ng-disabled=\"true\" disabled=\"disabled\">{{vm.splitInfo.parentStatus}}</button></span>\n" +
    "					<span class=\"auto-order-icon ng-hide\" ng-show=\"!!vm.order.AutoOrdered\" style=\"padding:0 7px 0 7px;\"><span class=\"icon-glyph icon-orders-auto\" style=\"padding: 0 7px 0 7px;\"></span>&nbsp;Auto Ordered</span>\n" +
    "				</p>\n" +
    "				<p>\n" +
    "					<span>Facility:&nbsp;{{vm.order.CEID}}</span>\n" +
    "					<span>Pharmacy:&nbsp;{{vm.order.RxShortName}}</span>\n" +
    "					<span>Order #:&nbsp;{{vm.order.Name}}</span>\n" +
    "				</p>\n" +
    "				<p>\n" +
    "					<span>{{(!!vm.order.Manual ? 'Manual ' : ' ')}}Create on:&nbsp;{{vm.order.CreatedOn | date:'M/d/yyyy h:mm a'}}&nbsp;&nbsp;by:&nbsp;{{vm.order.CreatedBy}}</span>\n" +
    "					<span class=\"ng-hide\" ng-show=\"!!vm.order.PlaceDate\">Placed: {{vm.order.PlaceDate | date:'M/d/yyyy h:mm a'}}</span>\n" +
    "					<span class=\"ng-hide\" ng-show=\"!!vm.order.CancelDate\">Cancelled: {{vm.order.CancelDate | date:'M/d/yyyy h:mm a'}}</span>\n" +
    "				</p>\n" +
    "			</fieldset>\n" +
    "		</form>\n" +
    "	</section>\n" +
    "	<div class=\"table-popup-top ng-hide\" ng-show=\"vm.action == 'LIST' || vm.action == 'RELOAD'\">\n" +
    "		<!-- HEADER -->\n" +
    "		<section class=\"panel split-detail-header\">\n" +
    "			<ul class=\"split-header-acct\">\n" +
    "				<li class=\"v-savings\">\n" +
    "					<h6>{{(vm.isVeriSaveOnly ? 'Savings' : 'V340B Savings')}}</h6>\n" +
    "					<p>Base Cost: ${{vm.order.saving[0].total | zeroNumberFormat:'-':2}}</p>\n" +
    "					<p class=\"ng-hide\" ng-show=\"vm.order.saving[vm.order.saving.length-1].total > 0\">Savings: ${{vm.order.saving[vm.order.saving.length-1].total | zeroNumberFormat:'-':2}}</p>\n" +
    "					<p><a href ng-click=\"vm.openPopup($event, 'SAVINGDETAIL')\">view details...</a></p>\n" +
    "				</li>\n" +
    "				<li>\n" +
    "					<div class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acct340B\">\n" +
    "						<h6 class=\"ng-hide\" ng-show=\"vm.splitInfo.acct340B.orders.length == 1\">340B&nbsp;-&nbsp;{{vm.splitInfo.acct340B.orders[0].Name}}&nbsp;({{vm.splitInfo.acct340B.itemCount}}&nbsp;items)</h6>\n" +
    "						<h6 class=\"ng-hide\" ng-show=\"vm.splitInfo.acct340B.orders.length > 1\">340B&nbsp;-&nbsp;{{vm.splitInfo.acct340B.orders.length}}&nbsp;Orders&nbsp;({{vm.splitInfo.acct340B.itemCount}}&nbsp;items)</h6>\n" +
    "						<p>Status:&nbsp;{{vm.splitInfo.acct340B.status}}&nbsp;&nbsp;&nbsp;<a href ng-click=\"vm.openPopup($event, 'ACCTDETAIL', {acct:'340B'})\">view details...</a></p>\n" +
    "					</div>\n" +
    "				</li>\n" +
    "				<li>\n" +
    "					<div class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctOWN\">\n" +
    "						<h6 class=\"ng-hide\" ng-show=\"vm.splitInfo.acctOWN.orders.length == 1\">OWN&nbsp;-&nbsp;{{vm.splitInfo.acctOWN.orders[0].Name}}&nbsp;({{vm.splitInfo.acctOWN.itemCount}}&nbsp;items)</h6>\n" +
    "						<h6 class=\"ng-hide\" ng-show=\"vm.splitInfo.acctOWN.orders.length > 1\">OWN&nbsp;-&nbsp;{{vm.splitInfo.acctOWN.orders.length}}&nbsp;Orders&nbsp;({{vm.splitInfo.acctOWN.itemCount}}&nbsp;items)</h6>\n" +
    "						<p>Status:&nbsp;{{vm.splitInfo.acctOWN.status}}&nbsp;&nbsp;&nbsp;<a href ng-click=\"vm.openPopup($event, 'ACCTDETAIL', {acct:'OWN'})\">view details...</a></p>\n" +
    "					</div>\n" +
    "				</li>\n" +
    "				<li>\n" +
    "					<div class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctGPO\">\n" +
    "						<h6 class=\"ng-hide\" ng-show=\"vm.splitInfo.acctGPO.orders.length == 1\">GPO&nbsp;-&nbsp;{{vm.splitInfo.acctGPO.orders[0].Name}}&nbsp;({{vm.splitInfo.acctGPO.itemCount}}&nbsp;items)</h6>\n" +
    "						<h6 class=\"ng-hide\" ng-show=\"vm.splitInfo.acctGPO.orders.length > 1\">GPO&nbsp;-&nbsp;{{vm.splitInfo.acctGPO.orders.length}}&nbsp;Orders&nbsp;({{vm.splitInfo.acctGPO.itemCount}}&nbsp;items)</h6>\n" +
    "						<p>Status:&nbsp;{{vm.splitInfo.acctGPO.status}}&nbsp;&nbsp;&nbsp;<a href ng-click=\"vm.openPopup($event, 'ACCTDETAIL', {acct:'GPO'})\">view details...</a></p>\n" +
    "					</div>\n" +
    "				</li>\n" +
    "				<li>\n" +
    "					<div class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctWACMED\">\n" +
    "						<h6 class=\"ng-hide\" ng-show=\"vm.splitInfo.acctWACMED.orders.length == 1\">WACMED&nbsp;-&nbsp;{{vm.splitInfo.acctWACMED.orders[0].Name}}&nbsp;({{vm.splitInfo.acctWACMED.itemCount}}&nbsp;items)</h6>\n" +
    "						<h6 class=\"ng-hide\" ng-show=\"vm.splitInfo.acctWACMED.orders.length > 1\">WACMED&nbsp;-&nbsp;{{vm.splitInfo.acctWACMED.orders.length}}&nbsp;Orders&nbsp;({{vm.splitInfo.acctWACMED.itemCount}}&nbsp;items)</h6>\n" +
    "						<p>Status:&nbsp;{{vm.splitInfo.acctWACMED.status}}&nbsp;&nbsp;&nbsp;<a href ng-click=\"vm.openPopup($event, 'ACCTDETAIL', {acct:'WACMED'})\">view details...</a></p>\n" +
    "					</div>\n" +
    "				</li>\n" +
    "				<li>\n" +
    "					<div class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctWAC\">\n" +
    "						<h6 class=\"ng-hide\" ng-show=\"vm.splitInfo.acctWAC.orders.length == 1\">WAC&nbsp;-&nbsp;{{vm.splitInfo.acctWAC.orders[0].Name}}&nbsp;({{vm.splitInfo.acctWAC.itemCount}}&nbsp;items)</h6>\n" +
    "						<h6 class=\"ng-hide\" ng-show=\"vm.splitInfo.acctWAC.orders.length > 1\">WAC&nbsp;-&nbsp;{{vm.splitInfo.acctWAC.orders.length}}&nbsp;Orders&nbsp;({{vm.splitInfo.acctWAC.itemCount}}&nbsp;items)</h6>\n" +
    "						<p>Status:&nbsp;{{vm.splitInfo.acctWAC.status}}&nbsp;&nbsp;&nbsp;<a href ng-click=\"vm.openPopup($event, 'ACCTDETAIL', {acct:'WAC'})\">view details...</a></p>\n" +
    "					</div>\n" +
    "				</li>\n" +
    "			</ul>\n" +
    "			<!--div class=\"split-header-filters\"></div-->\n" +
    "		</section>\n" +
    "		<!-- LIST -->\n" +
    "		<section class=\"table-list\">\n" +
    "			<div class=\"table-list-title\">\n" +
    "				<span class=\"title-left\">Filtering {{vm.flt.Count | number}} of {{vm.tbl.DataItems.length | number}} records</span>\n" +
    "				<div class=\"title-right no-pad-right ng-hide\" ng-show=\"vm.order.canEdit\">\n" +
    "					&nbsp;&nbsp;<button type=\"button\" class=\"btn-alt\" ng-click=\"vm.removeNonPriceSelect()\">\n" +
    "						<span class=\"icon-glyph icon-money\"></span>REMOVE NON PRICE SELECT WAC ITEMS\n" +
    "					</button>\n" +
    "					&nbsp;&nbsp;<button type=\"button\" ng-click=\"vm.placeOrder()\">PLACE SPLIT ORDER</button>\n" +
    "					&nbsp;&nbsp;<button type=\"button\" class=\"btn-cancel\"  ng-click=\"vm.cancelOrder(vm.order.Id, 'SPLIT')\">CANCEL ALL ORDERS</button>\n" +
    "				</div>\n" +
    "				<div class=\"title-right\">\n" +
    "					<span class=\"no-pad-height\"><a href ng-click=\"vm.showSavings = !!!vm.showSavings; $scope.$apply(); vm.ShowSavingsView();\"><span class=\"icon-glyph\" ng-class=\"{'icon-checked': vm.showSavings, 'icon-unchecked': !vm.showSavings}\"></span>Show Feature Savings</a></span>\n" +
    "				</div>\n" +
    "			</div>\n" +
    "			<!-- MAIN TABLE -->\n" +
    "			<div class=\"table-fixed-header-scroll\">\n" +
    "				<table class=\"split-detail-table\">\n" +
    "					<colgroup>\n" +
    "						<col width=\"45px\" class=\"ng-hide\" ng-show=\"vm.order.hasBestCost && !vm.showSavings\"/>\n" +
    "						<col width=\"55px\" class=\"ng-hide\" ng-show=\"vm.order.hasMultiVendors && !vm.showSavings\"/> <!-- Vendor (drug info) -->\n" +
    "						<col width=\"55px\" /> <!-- drug info -->\n" +
    "						<col width=\"70px\" /> <!-- drug info -->\n" +
    "						<col width=\"110px\" /> <!-- drug info -->\n" +
    "						<col width=\"35px\" /> <!-- drug info -->\n" +
    "						<col width=\"35px\" class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\"/> <!-- split totals -->\n" +
    "						<col width=\"35px\" class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\"/> <!-- split totals -->\n" +
    "						<col width=\"35px\" class=\"ng-hide\" ng-show=\"!vm.showSavings && !vm.isVeriSaveOnly\"/> <!-- 340B -->\n" +
    "						<col width=\"35px\" class=\"ng-hide\" ng-show=\"!vm.showSavings && !vm.isVeriSaveOnly\"/> <!-- 340B -->\n" +
    "						<col width=\"35px\" class=\"ng-hide\" ng-show=\"!vm.showSavings && !vm.isVeriSaveOnly\"/> <!-- 340B -->\n" +
    "						<col width=\"35px\" class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctOWN && !vm.showSavings\" />\n" +
    "						<col width=\"35px\" class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctOWN && !vm.showSavings\" />\n" +
    "						<col width=\"35px\" class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctOWN && !vm.showSavings\" />\n" +
    "						<col width=\"35px\" class=\"ng-hide\" ng-show=\"!vm.showSavings\"/>\n" +
    "						<col width=\"35px\" class=\"ng-hide\" ng-show=\"!vm.showSavings\"/>\n" +
    "						<col width=\"35px\" class=\"ng-hide\" ng-show=\"!vm.showSavings\"/>\n" +
    "						<col width=\"35px\" class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctWACMED && !vm.showSavings\" />\n" +
    "						<col width=\"35px\" class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctWACMED && !vm.showSavings\" />\n" +
    "						<col width=\"35px\" class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctWACMED && !vm.showSavings\" />\n" +
    "						<col width=\"35px\" class=\"ng-hide\" ng-show=\"vm.order.ShowWAC && !vm.showSavings\"/>\n" +
    "						<col width=\"35px\" class=\"ng-hide\" ng-show=\"vm.order.ShowWAC && !vm.showSavings\"/>\n" +
    "						<col width=\"35px\" class=\"ng-hide\" ng-show=\"vm.order.ShowWAC && !vm.showSavings\"/>\n" +
    "						<col width=\"45px\" class=\"ng-hide\" ng-show=\"vm.showSavings\"/> <!-- save: original cost -->\n" +
    "						<col width=\"45px\" class=\"ng-hide\" ng-show=\"vm.showSavings && !vm.isVeriSaveOnly\"/> <!-- save: ndc optimizer -->\n" +
    "						<col width=\"45px\" class=\"ng-hide\" ng-show=\"vm.showSavings && !vm.isVeriSaveOnly\"/> <!-- save: price select -->\n" +
    "						<col width=\"45px\" class=\"ng-hide\" ng-show=\"vm.showSavings\"/> <!-- save: verisave -->\n" +
    "						<col width=\"45px\" class=\"ng-hide\" ng-show=\"vm.showSavings\"/> <!-- save: vendor -->\n" +
    "						<col width=\"45px\" class=\"ng-hide\" ng-show=\"vm.showSavings\"/> <!-- save: final cost -->\n" +
    "						<col width=\"35px\" class=\"ng-hide\" ng-show=\"!vm.showSavings\"/> <!-- details -->\n" +
    "					</colgroup>\n" +
    "					<thead class=\"fixed-header\">\n" +
    "						<!-- SECTIONS -->\n" +
    "						<tr>\n" +
    "							<th class=\"ng-hide\" ng-show=\"vm.order.hasBestCost && !vm.showSavings\" colspan=\"1\">VERISAVE</th>\n" +
    "							<th class=\"ng-hide\" ng-show=\"vm.order.hasMultiVendors && !vm.showSavings\" colspan=\"1\">Vendor</th>\n" +
    "							<th colspan=\"4\">Drug Information</th>\n" +
    "							<th colspan=\"2\" class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\">Split Totals</th>\n" +
    "							<th colspan=\"3\" class=\"ng-hide\" ng-show=\"!vm.showSavings && !vm.isVeriSaveOnly\">340B</th>\n" +
    "							<th colspan=\"3\" class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctOWN && !vm.showSavings\">OWN</th>\n" +
    "							<th colspan=\"3\" class=\"ng-hide\" ng-show=\"!vm.showSavings\">GPO</th>\n" +
    "							<th colspan=\"3\" class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctWACMED && !vm.showSavings\">WACMED</th>\n" +
    "							<th colspan=\"3\" class=\"ng-hide\" ng-show=\"vm.order.ShowWAC && !vm.showSavings\">WAC</th>\n" +
    "							<th class=\"ng-hide\" ng-show=\"vm.showSavings\" colspan=\"{{(vm.isVeriSaveOnly ? 4 : 6)}}\">Feature Savings</th>\n" +
    "							<th class=\"ng-hide\" ng-show=\"!vm.showSavings\">Usage</th>\n" +
    "						</tr>\n" +
    "						<!-- TITLES -->\n" +
    "						<tr class=\"column-titles\">\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.order.hasBestCost && !vm.showSavings\" ng-click=\"vm.sortBy('OrigItemCode', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Original NDC<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('OrigItemCode', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.order.hasMultiVendors && !vm.showSavings\" ng-click=\"vm.sortBy('Vendor', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Vendor<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('Vendor', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td ng-click=\"vm.sortBy('ItemCode', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>NDC<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('ItemCode', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td ng-click=\"vm.sortBy('VenDrugCode', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Item Number<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('VenDrugCode', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td ng-click=\"vm.sortBy('VenLabel', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Item Description<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('VenLabel', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td ng-click=\"vm.sortBy('WholesaleUnits', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<div class=\"info-tip\">\n" +
    "									<a style=\"white-space: initial;\">Wholesale Units<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('WholesaleUnits', vm.flt.SortBy)\"></span></a>\n" +
    "									<div class=\"tip-content tip-left-50\">\n" +
    "										<span class=\"icon-glyph tip-icon\"></span>\n" +
    "										<p class=\"tip-title\">Calculation Note</p>\n" +
    "										<p>Calculated as package size * case pack size.</p>\n" +
    "									</div>\n" +
    "								</div>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\" ng-click=\"vm.sortBy('TotalItemUnits', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Qty<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('TotalItemUnits', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\" ng-click=\"vm.sortBy('TotalPrice', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Price<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('TotalPrice', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.showSavings && !vm.isVeriSaveOnly\" ng-click=\"vm.sortBy('acct340B_ItemUnits', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Qty<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acct340B_ItemUnits', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.showSavings && !vm.isVeriSaveOnly\" ng-click=\"vm.sortBy('acct340B_UnitPrice', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Price<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acct340B_UnitPrice', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.showSavings && !vm.isVeriSaveOnly\" ng-click=\"vm.sortBy('acct340B_TotalPrice', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Total<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acct340B_TotalPrice', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctOWN && !vm.showSavings\" ng-click=\"vm.sortBy('acctOWN_ItemUnits', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Qty<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctOWN_ItemUnits', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctOWN && !vm.showSavings\" ng-click=\"vm.sortBy('acctOWN_UnitPrice', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Price<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctOWN_UnitPrice', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctOWN && !vm.showSavings\" ng-click=\"vm.sortBy('acctOWN_TotalPrice', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Total<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctOWN_TotalPrice', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.showSavings\" ng-click=\"vm.sortBy('acctGPO_ItemUnits', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Qty<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctGPO_ItemUnits', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.showSavings\" ng-click=\"vm.sortBy('acctGPO_UnitPrice', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Price<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctGPO_UnitPrice', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.showSavings\" ng-click=\"vm.sortBy('acctGPO_TotalPrice', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Total<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctGPO_TotalPrice', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctWACMED && !vm.showSavings\" ng-click=\"vm.sortBy('acctWACMED_ItemUnits', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Qty<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctWACMED_ItemUnits', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctWACMED && !vm.showSavings\" ng-click=\"vm.sortBy('acctWACMED_UnitPrice', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Price<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctWACMED_UnitPrice', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctWACMED && !vm.showSavings\" ng-click=\"vm.sortBy('acctWACMED_TotalPrice', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Total<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctWACMED_TotalPrice', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.order.ShowWAC && !vm.showSavings\" ng-click=\"vm.sortBy('acctWAC_ItemUnits', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Qty<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctWAC_ItemUnits', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.order.ShowWAC && !vm.showSavings\" ng-click=\"vm.sortBy('acctWAC_UnitPrice', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Price<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctWAC_UnitPrice', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.order.ShowWAC && !vm.showSavings\" ng-click=\"vm.sortBy('acctWAC_TotalPrice', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Total<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctWAC_TotalPrice', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.showSavings\" ng-click=\"vm.sortBy('SavingResults.NoSavingOrigCost', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Base Cost<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('SavingResults.NoSavingOrigCost', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.showSavings && !vm.isVeriSaveOnly\" ng-click=\"vm.sortBy('SavingResults.NdcOptimizerSaving', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>NDC Optimizer<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('SavingResults.NdcOptimizerSaving', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.showSavings && !vm.isVeriSaveOnly\" ng-click=\"vm.sortBy('SavingResults.PriceSelectSaving', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Price Select<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('SavingResults.PriceSelectSaving', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.showSavings\" ng-click=\"vm.sortBy('SavingResults.VeriSaveSaving', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Verisave<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('SavingResults.VeriSaveSaving', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.showSavings\" ng-click=\"vm.sortBy('SavingResults.VendorSaving', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Vendor<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('SavingResults.VendorSaving', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.showSavings\" ng-click=\"vm.sortBy('TotalPrice', vm.flt); $scope.$apply(); vm.filterChange();\">\n" +
    "								<a>Final Cost<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('TotalPrice', vm.flt.SortBy)\"></span></a>\n" +
    "							</td>\n" +
    "						<td class=\"ng-hide\" ng-show=\"!vm.showSavings\"><a>Details</a></td>\n" +
    "						</tr>\n" +
    "						<!-- FILTERS -->\n" +
    "						<tr class=\"column-filters\">\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.order.hasBestCost && !vm.showSavings\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Text.OrigItemCode\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.order.hasMultiVendors && !vm.showSavings\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Text.Vendor\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td>\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Text.ItemCode\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td>\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Text.VenDrugCode\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td>\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Text.VenLabel\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td>\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Text.WholesaleUnits\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.TotalItemUnits\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.TotalPrice\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.showSavings && !vm.isVeriSaveOnly\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.acct340B_ItemUnits\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.showSavings && !vm.isVeriSaveOnly\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.acct340B_UnitPrice\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.showSavings && !vm.isVeriSaveOnly\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.acct340B_TotalPrice\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctOWN && !vm.showSavings\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.acctOWN_ItemUnits\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctOWN && !vm.showSavings\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.acctOWN_UnitPrice\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctOWN && !vm.showSavings\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.acctOWN_TotalPrice\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.showSavings\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.acctGPO_ItemUnits\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.showSavings\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.acctGPO_UnitPrice\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.showSavings\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.acctGPO_TotalPrice\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctWACMED && !vm.showSavings\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.acctWACMED_ItemUnits\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctWACMED && !vm.showSavings\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.acctWACMED_UnitPrice\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctWACMED && !vm.showSavings\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.acctWACMED_TotalPrice\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.order.ShowWAC && !vm.showSavings\" >\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.acctWAC_ItemUnits\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td  class=\"ng-hide\" ng-show=\"vm.order.ShowWAC && !vm.showSavings\" >\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.acctWAC_UnitPrice\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.order.ShowWAC && !vm.showSavings\" >\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.acctWAC_TotalPrice\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.showSavings\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.SavingResults_NoSavingOrigCost\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.showSavings && !vm.isVeriSaveOnly\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.SavingResults_NdcOptimizerSaving\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.showSavings && !vm.isVeriSaveOnly\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.SavingResults_PriceSelectSaving\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.showSavings\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.SavingResults_VeriSaveSaving\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.showSavings\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.SavingResults_VendorSaving\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.showSavings\">\n" +
    "								<input type=\"text\" ng-model=\"vm.flt.Numbers.TotalPrice\" ng-change=\"vm.filterChange()\" />\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.showSavings\"><p><a href ng-click=\"vm.openPopup($event,'SPLIT_ORDER_DETAIL', vm.order)\">details...</a></p></td>\n" +
    "						</tr>\n" +
    "					</thead>\n" +
    "					<tbody>\n" +
    "						<tr class=\"table-list-item\" ng-class=\"{'row-shade':$even, 'popup-hover':orderItem.Id == vm.popup.hoverId, 'has-edits':orderItem.hasEdits}\" ng-repeat=\"orderItem in vm.tbl.Items\">\n" +
    "							<td class=\"ng-hide\" ng-show=\"orderItem.lineType != 'subline' && vm.order.hasBestCost && !vm.showSavings\"><a href class=\"ng-hide\" ng-show=\"!!orderItem.VerisaveSwapped\" ng-click=\"vm.openPopup($event,'MULTIORIGINAL', orderItem)\">MULTI</a><span  style=\"margin:0px;padding:1px\" title='{{orderItem.OrigVendItemName}}'>{{(orderItem.OrigBlendedCost != orderItem.BlendedCost ? (!!orderItem.VerisaveSwapped ? '' : orderItem.OrigItemCode )  : '' )}}</span></td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"orderItem.lineType != 'subline' && vm.order.hasMultiVendors && !vm.showSavings\">{{orderItem.Vendor}}</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"orderItem.lineType != 'subline'\">{{orderItem.ItemCode}}<span class=\"icon-glyph icon-money ng-hide\" ng-show=\"!!orderItem.PriceSelected\" style=\"margin:0;padding:1px;\"></span></td>\n" +
    "							<td class=\"sub-line ng-hide\" ng-show=\"orderItem.lineType == 'subline' && vm.order.hasBestCost\" colspan=\"4\">{{orderItem.CEID}}</td>\n" +
    "							<td class=\"sub-line ng-hide\" ng-show=\"orderItem.lineType == 'subline' && !vm.order.hasBestCost\">{{orderItem.CEID}}</td>\n" +
    "							<td>{{orderItem.VenDrugCode}}</td>\n" +
    "							<td>{{orderItem.VenLabel}}</td>\n" +
    "							<td>{{orderItem.WholesaleUnits}}</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\" title=\"{{orderItem.AckMsg}}\">{{orderItem.TotalItemUnits | zeroNumberFormat:''}}</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.isVeriSaveOnly\">{{orderItem.TotalPrice | zeroNumberFormat:'':2}}</td>\n" +
    "							<!-- 340B -->\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!!orderItem.acct340B_CanEdit && !vm.showSavings && !vm.isVeriSaveOnly\">{{orderItem.acct340B_ItemUnits | zeroNumberFormat:''}} </td>\n" +
    "							<td class=\"qty-prompt ng-hide\" ng-show=\"!!orderItem.acct340B_CanEdit && !vm.showSavings && !vm.isVeriSaveOnly\">\n" +
    "								<div class=\"qty-display\">\n" +
    "									<span class=\"qty-input\" ng-click=\"vm.openPopupLineItem($event, '340B', orderItem)\" title=\"Edit 340B Qty\">{{orderItem.acct340B_ItemUnits}}</span>\n" +
    "								</div>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.showSavings && !vm.isVeriSaveOnly\">{{orderItem.acct340B_UnitPrice | zeroNumberFormat:'':2}}</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.showSavings && !vm.isVeriSaveOnly\">{{orderItem.acct340B_TotalPrice | zeroNumberFormat:'':2}}</td>\n" +
    "							<!-- OWN -->\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctOWN && !!!orderItem.acctOWN_CanEdit && !vm.showSavings\">{{orderItem.acctOWN_ItemUnits | zeroNumberFormat:''}} </td>\n" +
    "							<td class=\"qty-prompt ng-hide\" ng-show=\"!!vm.splitInfo.acctOWN && !!orderItem.acctOWN_CanEdit && !vm.showSavings\">\n" +
    "								<div class=\"qty-display\">\n" +
    "									<span class=\"qty-input\" ng-click=\"vm.openPopupLineItem($event, 'OWN', orderItem)\" title=\"Edit OWN Qty\">{{orderItem.acctOWN_ItemUnits}}</span>\n" +
    "								</div>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctOWN && !vm.showSavings\">{{orderItem.acctOWN_UnitPrice | zeroNumberFormat:'':2}}</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctOWN && !vm.showSavings\">{{orderItem.acctOWN_TotalPrice | zeroNumberFormat:'':2}}</td>\n" +
    "							<!-- GPO -->\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!!orderItem.acctGPO_CanEdit && !vm.showSavings\">{{orderItem.acctGPO_ItemUnits | zeroNumberFormat:''}} </td>\n" +
    "							<td class=\"qty-prompt ng-hide\" ng-show=\"!!orderItem.acctGPO_CanEdit && !vm.showSavings\">\n" +
    "								<div class=\"qty-display\">\n" +
    "									<span class=\"qty-input\" ng-click=\"vm.openPopupLineItem($event, 'GPO', orderItem)\" title=\"Edit GPO Qty\">{{orderItem.acctGPO_ItemUnits}}</span>\n" +
    "								</div>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.showSavings\">{{orderItem.acctGPO_UnitPrice | zeroNumberFormat:'':2}}</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.showSavings\">{{orderItem.acctGPO_TotalPrice | zeroNumberFormat:'':2}}</td>\n" +
    "							<!-- WACMED -->\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctWACMED && !!!orderItem.acctWACMED_CanEdit && !vm.showSavings\">{{orderItem.acctWACMED_ItemUnits | zeroNumberFormat:''}} </td>\n" +
    "							<td class=\"qty-prompt ng-hide\" ng-show=\"!!vm.splitInfo.acctWACMED && !!orderItem.acctWACMED_CanEdit && !vm.showSavings\">\n" +
    "								<div class=\"qty-display\">\n" +
    "									<span class=\"qty-input\" ng-click=\"vm.openPopupLineItem($event, 'WACMED', orderItem)\" title=\"Edit WACMED Qty\">{{orderItem.acctWACMED_ItemUnits}}</span>\n" +
    "								</div>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctWACMED && !vm.showSavings\">{{orderItem.acctWACMED_UnitPrice | zeroNumberFormat:'':2}}</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!!vm.splitInfo.acctWACMED && !vm.showSavings\">{{orderItem.acctWACMED_TotalPrice | zeroNumberFormat:'':2}}</td>\n" +
    "							<!-- WAC -->\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.order.ShowWAC && !!!orderItem.acctWAC_CanEdit && !vm.showSavings\">{{orderItem.acctWAC_ItemUnits | zeroNumberFormat:''}} </td>\n" +
    "							<td class=\"qty-prompt ng-hide\" ng-show=\"vm.order.ShowWAC && !!orderItem.acctWAC_CanEdit && !vm.showSavings\">\n" +
    "								<div class=\"qty-display\">\n" +
    "									<span class=\"qty-input\" ng-click=\"vm.openPopupLineItem($event, 'WAC', orderItem)\" title=\"Edit WAC Qty\">{{orderItem.acctWAC_ItemUnits}}</span>\n" +
    "								</div>\n" +
    "							</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.order.ShowWAC && !vm.showSavings\">{{orderItem.acctWAC_UnitPrice | zeroNumberFormat:'':2}}</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"vm.order.ShowWAC && !vm.showSavings\">{{orderItem.acctWAC_TotalPrice | zeroNumberFormat:'':2}}</td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"orderItem.lineType != 'subline' && vm.showSavings\">{{(orderItem.SavingResults.V340BFinalSaving > 0 ? orderItem.SavingResults.NoSavingOrigCost : 0 ) | zeroNumberFormat:'':2}} </td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"orderItem.lineType != 'subline' && vm.showSavings && !vm.isVeriSaveOnly\">{{(orderItem.SavingResults.V340BFinalSaving > 0 ? orderItem.SavingResults.NdcOptimizerSaving : 0 ) | zeroNumberFormat:'':2}} </td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"orderItem.lineType != 'subline' && vm.showSavings && !vm.isVeriSaveOnly\">{{(orderItem.SavingResults.V340BFinalSaving > 0 ? orderItem.SavingResults.PriceSelectSaving : 0 ) | zeroNumberFormat:'':2}} </td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"orderItem.lineType != 'subline' && vm.showSavings\">{{(orderItem.SavingResults.V340BFinalSaving > 0 ? orderItem.SavingResults.VeriSaveSaving : 0 ) | zeroNumberFormat:'':2}} </td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"orderItem.lineType != 'subline' && vm.showSavings\">{{(orderItem.SavingResults.V340BFinalSaving > 0 ? orderItem.SavingResults.VendorSaving : 0 ) | zeroNumberFormat:'':2}} </td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"orderItem.lineType != 'subline' && vm.showSavings\">{{(orderItem.TotalPrice > 0 ? orderItem.TotalPrice : 0 ) | zeroNumberFormat:'':2}} </td>\n" +
    "							<td class=\"ng-hide\" ng-show=\"!vm.showSavings\"><p><a href ng-click=\"vm.openPopup($event,'SPLIT_DETAIL', orderItem)\">details...</a></p></td>\n" +
    "						</tr>\n" +
    "					</tbody>\n" +
    "				</table>\n" +
    "			</div>\n" +
    "			<div widget-paging></div>\n" +
    "			<!-- POPUP MAIN -->\n" +
    "			<div class=\"table-popup ng-hide\" ng-show=\"!!vm.popup.ready\">\n" +
    "				<div id=\"tablePopupContent\" class=\"table-popup-content\">\n" +
    "					<h5 class=\"table-popup-title\" ng-click=\"vm.closePopup()\"><span>{{vm.popup.title}}</span><span class=\"icon-glyph icon-cancel\" ng-click=\"vm.closePopup()\"></span></h5>\n" +
    "					<!-- ACCT DETAIL-->\n" +
    "					<div class=\"pop-acct-detail ng-hide\" ng-show=\"vm.popup.type == 'ACCTDETAIL'\">\n" +
    "						<div class=\"order-details\" ng-repeat=\"orderDetail in vm.popup.splitInfo.orders | orderBy:['Name']\">\n" +
    "							<h6>{{orderDetail.Name}} ({{orderDetail.ItemCount | number}} items)&nbsp;&nbsp;<a href ng-click=\"vm.setFocusOrder(orderDetail.Id)\"><span class=\"icon-glyph icon-list\"></span>view items...</a></span></a></h6>\n" +
    "							<p>\n" +
    "								<span>Status:</span><button class=\"btn-off\" type=\"button\">{{orderDetail.ObjectState}}</button>\n" +
    "								<span class=\"ng-hide\" ng-show=\"orderDetail.ObjectState == 'REVIEW'\"><button type=\"button\" class=\"btn-cancel\" ng-click=\"vm.cancelOrder(orderDetail.Id, orderDetail.Name)\">CANCEL&nbsp;{{orderDetail.OrderType}}&nbsp;ORDER</button></span>\n" +
    "							</p>\n" +
    "							<p>\n" +
    "								<span>Facility: {{orderDetail.CEID}}</span>\n" +
    "								<span>Pharmacy: {{orderDetail.RxShortName}}</span>\n" +
    "								<span>Vendor: {{orderDetail.VENID}}</span>\n" +
    "							</p>\n" +
    "							<p>\n" +
    "								<span>Created: {{orderDetail.CreatedOn | date:'M/d/yyyy h:mm a'}}</span>\n" +
    "								<span class=\"ng-hide\" ng-show=\"!!orderDetail.PlaceDate\">Placed: {{orderDetail.PlaceDate | date:'M/d/yyyy h:mm a'}}</span>\n" +
    "								<span class=\"ng-hide\" ng-show=\"!!orderDetail.AckDate\">Acknowledged: {{orderDetail.AckDate | date:'M/d/yyyy h:mm a'}}</span>\n" +
    "								<span class=\"ng-hide\" ng-show=\"!!orderDetail.InvoiceDate\">Invoiced: {{orderDetail.InvoiceDate | date:'M/d/yyyy h:mm a'}}</span>\n" +
    "								<span class=\"ng-hide\" ng-show=\"!!orderDetail.CancelDate\">Cancelled: {{orderDetail.CancelDate | date:'M/d/yyyy h:mm a'}}&nbsp;by:&nbsp;{{orderDetail.CancelBy}}</span>\n" +
    "							</p>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<!-- SPLIT DETAIL -->\n" +
    "					<div class=\"pop-focus-detail ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL' || vm.popup.type == 'SPLIT_ORDER_DETAIL' ||vm.popup.type == 'FOCUS_ORDER'\">\n" +
    "						<!-- TAB BAR -->\n" +
    "						<div class=\"tab-bar ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL'\">\n" +
    "							<ul>\n" +
    "								<li class=\"ng-hide\" ng-show=\"vm.isSEQ\" ng-class=\"{'has-focus':vm.popup.tab == 'SEQITEMS'}\" ng-click=\"vm.popup.tab = 'SEQITEMS';\">\n" +
    "									<span>Sequential Items</span>\n" +
    "								</li>\n" +
    "								<li ng-class=\"{'has-focus':vm.popup.tab == 'LOG'}\" ng-click=\"vm.getSplitLog(vm.popup.SplitLogLineId)\">\n" +
    "									<span>Split Log</span>\n" +
    "								</li>\n" +
    "								<li class=\"ng-hide\" ng-show=\"vm.popup.Edits.length > 0\" ng-class=\"{'has-focus':vm.popup.tab == 'EDITS'}\" ng-click=\"vm.popup.tab = 'EDITS';\">\n" +
    "									<span>Edits</span>\n" +
    "								</li>\n" +
    "							</ul>\n" +
    "						</div>\n" +
    "						<!-- TAB: SPLIT LOG -->\n" +
    "						<div class=\"tab-panel ng-hide popup-content-scroll\" ng-show=\"vm.popup.tab == 'LOG'\" ng-class=\"{'popup-scroll-max-height': !!vm.popup.maxSplitHeight}\">\n" +
    "							<p ng-repeat=\"logLine in vm.popup.SplitLog track by $index\" ng-class=\"{'row-shade':$even}\">{{logLine}}</p>\n" +
    "							<p class=\"ng-hide\" ng-show=\"!!!vm.popup.maxSplitHeight\">\n" +
    "								<a href ng-click=\"vm.popup.maxSplitHeight = true\"><span class=\"icon-glyph icon-expand-height\"></span>{{vm.popup.SplitLog.length}}&nbsp;Entries, Expand Height</a>\n" +
    "							</p>\n" +
    "						</div>\n" +
    "						<!-- TAB: EDIT LOG -->\n" +
    "						<div class=\"tab-panel ng-hide popup-content-scroll\" ng-show=\"vm.popup.tab == 'EDITS'\" ng-class=\"{'popup-scroll-max-height': !!vm.popup.maxEditsHeight}\">\n" +
    "							<div ng-repeat=\"editLogLine in vm.popup.Edits track by $index\" ng-class=\"{'row-shade':$even}\">\n" +
    "								<p class='ng-hide' ng-show=\"vm.popup.type == 'SPLIT_DETAIL'\">\n" +
    "									<span class=\"ng-hide\" ng-show=\"!!!editLogLine.NoVerisaveSwapOn\">{{editLogLine.OrderType}} Quantity Changed from {{editLogLine.OldOrderUnits | number}} to {{editLogLine.NewOrderUnits | number}}</span>\n" +
    "									<span class=\"ng-hide\" ng-show=\"!!editLogLine.NoVerisaveSwapOn\">{{editLogLine.NoVerisaveSwapOn == 'ACTIVE' ? 'Do not' : ''}} VERISAVE</span>\n" +
    "									<span class=\"ng-hide\" ng-show=\"vm.isSEQ\">for Facility: {{editLogLine.CEID}}</span>\n" +
    "								</p>\n" +
    "								<p class='ng-hide' ng-show=\"vm.popup.type == 'SPLIT_ORDER_DETAIL'\">\n" +
    "									<span>Item {{editLogLine.Id}} {{editLogLine.Action == \"REMOVE\" ? 'removed from order' : 'added to order'}}</span>\n" +
    "									<span class=\"ng-hide\" ng-show=\"vm.isSEQ\">for Facility: {{editLogLine.CEID}}</span>\n" +
    "								</p>\n" +
    "								<p>Modified By: {{editLogLine.ModBy}} on {{editLogLine.ModDt | date:'M/d/yyyy h:mm a'}}</p>\n" +
    "							</div>\n" +
    "							<p class=\"ng-hide\" ng-show=\"!!!vm.popup.maxEditsHeight\">\n" +
    "								<a href ng-click=\"vm.popup.maxEditsHeight = true\"><span class=\"icon-glyph icon-expand-height\"></span>{{vm.popup.Edits.length}}&nbsp;Entries, Expand Height</a>\n" +
    "							</p>\n" +
    "						</div>\n" +
    "						<!-- TAB: SEQ ITEMS / FOCUS ORDER -->\n" +
    "						<div class=\"tab-panel ng-hide\" ng-show=\"vm.popup.tab == 'SEQITEMS' || vm.popup.type == 'FOCUS_ORDER'\">\n" +
    "							<div class=\"order-header-details ng-hide\" ng-show=\"vm.popup.type == 'FOCUS_ORDER'\" style=\"margin-bottom:10px;\">\n" +
    "								<p>\n" +
    "									<span>Status:</span><button class=\"btn-off\" type=\"button\">{{vm.popup.orderDetail.ObjectState}}</button>\n" +
    "									<button type=\"button\" class=\"btn-off ng-hide\" ng-show=\"vm.popup.orderDetail.ObjectState=='PLACED' && !!vm.popup.orderDetail.everInvoiced\">{{!!vm.popup.orderDetail.canAddInvoice?'PARTIALLY INVOICED':'FULLY INVOICED'}}</button>\n" +
    "									<span class=\"ng-hide\" ng-show=\"vm.popup.orderDetail.ObjectState == 'REVIEW'\"><button type=\"button\" class=\"btn-cancel\" ng-click=\"vm.cancelOrder(vm.popup.orderDetail.Id, vm.popup.orderDetail.Name)\">CANCEL&nbsp;{{vm.popup.orderDetail.OrderType}}&nbsp;ORDER</button></span>					\n" +
    "									<button type=\"button\" class=\"ng-hide\" ng-show=\"vm.popup.orderDetail.ObjectState == 'PLACED' && !!vm.popup.orderDetail.canAddInvoice\" ng-click=\"vm.navToFeature('ADDINVOICE',{})\">Add Invoice</button>\n" +
    "								</p>\n" +
    "								<p>\n" +
    "									<span>Facility: {{vm.popup.orderDetail.CEID}}</span>\n" +
    "									<span>Pharmacy: {{vm.popup.orderDetail.RxShortName}}</span>\n" +
    "									<span>Vendor: {{vm.popup.orderDetail.VENID}}</span>\n" +
    "								</p>\n" +
    "								<p>\n" +
    "									<span>Created: {{vm.popup.orderDetail.CreatedOn | date:'M/d/yyyy h:mm a'}}</span>\n" +
    "									<span class=\"ng-hide\" ng-show=\"!!vm.popup.orderDetail.PlaceDate\">Placed: {{vm.popup.orderDetail.PlaceDate | date:'M/d/yyyy h:mm a'}}</span>\n" +
    "									<span class=\"ng-hide\" ng-show=\"!!vm.popup.orderDetail.AckDate\">Acknowledged: {{vm.popup.orderDetail.AckDate | date:'M/d/yyyy h:mm a'}}</span>\n" +
    "									<span class=\"ng-hide\" ng-show=\"!!vm.popup.orderDetail.InvoiceDate\">Invoiced: {{vm.popup.orderDetail.InvoiceDate | date:'M/d/yyyy h:mm a'}}</span>\n" +
    "									<span class=\"ng-hide\" ng-show=\"!!vm.popup.orderDetail.CancelDate\">Cancelled: {{vm.popup.orderDetail.CancelDate | date:'M/d/yyyy h:mm a'}}&nbsp;by:&nbsp;{{vm.popup.orderDetail.CancelBy}}</span>\n" +
    "								</p>\n" +
    "							</div>\n" +
    "							<div class=\"table-fixed-header-scroll\">\n" +
    "								<table id=\"split_detail_table\" class=\"split-detail-table\" style=\"width:100%\">\n" +
    "									<colgroup>\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL'\" width=\"60px\"/> <!-- CE -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL' && vm.popup.hasCodeSwaps\" width=\"70px\" /> <!-- ven code swap -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL'\" width=\"35px\" /> <!-- split totals -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL'\" width=\"35px\" /> <!-- split totals -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.type == 'FOCUS_ORDER'\" width=\"55px\" /> <!-- drug info -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.type == 'FOCUS_ORDER'\" width=\"70px\" /> <!-- drug info -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.type == 'FOCUS_ORDER'\" width=\"110px\" /> <!-- drug info -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.type == 'FOCUS_ORDER'\" width=\"35px\" /> <!-- drug info -->	\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.show340B\" width=\"35px\" /> <!-- 340B -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.show340B\" width=\"35px\" /> <!-- 340B -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.show340B\" width=\"35px\" /> <!-- 340B -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.showOWN\" width=\"35px\" /> <!-- OWN -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.showOWN\" width=\"35px\" /> <!-- OWN -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.showOWN\" width=\"35px\" /> <!-- OWN -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.showGPO\" width=\"35px\" /> <!-- GPO -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.showGPO\" width=\"35px\" /> <!-- GPO -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.showGPO\" width=\"35px\" /> <!-- GPO -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.showWACMED\" width=\"35px\" /> <!-- WACMED -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.showWACMED\" width=\"35px\" /> <!-- WACMED -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.showWACMED\" width=\"35px\" /> <!-- WACMED -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.showWAC\" width=\"35px\" /> <!-- WAC -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.showWAC\" width=\"35px\" /> <!-- WAC -->\n" +
    "										<col class=\"ng-hide\" ng-show=\"vm.popup.showWAC\" width=\"35px\" /> <!-- WAC -->\n" +
    "									</colgroup>\n" +
    "									<thead class=\"fixed-header\">\n" +
    "										<!-- SECTIONS -->\n" +
    "										<tr>\n" +
    "											<th class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL'\">CEID</th>\n" +
    "											<th class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL' && vm.popup.hasCodeSwaps\">Drug Replacements</th>\n" +
    "											<th colspan=\"2\" class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL'\">Split Totals</th>\n" +
    "											<th colspan=\"4\" class=\"ng-hide\" ng-show=\"vm.popup.type == 'FOCUS_ORDER'\">Drug Information</th>\n" +
    "											<th colspan=\"3\" class=\"ng-hide\" ng-show=\"vm.popup.show340B\">340B</th>\n" +
    "											<th colspan=\"3\" class=\"ng-hide\" ng-show=\"vm.popup.showOWN\">OWN</th>\n" +
    "											<th colspan=\"3\" class=\"ng-hide\" ng-show=\"vm.popup.showGPO\">GPO</th>\n" +
    "											<th colspan=\"3\" class=\"ng-hide\" ng-show=\"vm.popup.showWACMED\">WACMED</th>\n" +
    "											<th colspan=\"3\" class=\"ng-hide\" ng-show=\"vm.popup.showWAC\">WAC</th>\n" +
    "										</tr>\n" +
    "										<!-- TITLES -->\n" +
    "										<tr class=\"column-titles\">\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL'\">CEID</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL' && vm.popup.hasCodeSwaps\">New Item Number</td> <!-- drug swap -->\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL'\">Qty</td> <!-- split totals -->\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL'\">Price</td> <!-- split totals -->\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'FOCUS_ORDER'\" ng-click=\"vm.sortBy('ItemCode', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>NDC<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('ItemCode', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td> <!-- drug info -->\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'FOCUS_ORDER'\" ng-click=\"vm.sortBy('VenDrugCode', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>Item Number<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('VenDrugCode', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td> <!-- drug info -- VenDrugCode -->\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'FOCUS_ORDER'\" ng-click=\"vm.sortBy('VenLabel', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>Item Description<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('VenLabel', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td> <!-- drug info -->\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'FOCUS_ORDER'\" ng-click=\"vm.sortBy('WholesaleUnits', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>Wholesale Units<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('WholesaleUnits', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td> <!-- drug info -->\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.show340B\" ng-click=\"vm.sortBy('acct340B_ItemUnits', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>Qty<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acct340B_ItemUnits', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td><!-- vm.popup.flt.acct340B_ItemUnits -->\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.show340B\" ng-click=\"vm.sortBy('acct340B_UnitPrice', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>Price<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acct340B_UnitPrice', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.show340B\" ng-click=\"vm.sortBy('acct340B_TotalPrice', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>Total<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acct340B_TotalPrice', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showOWN\" ng-click=\"vm.sortBy('acctOWN_ItemUnits', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>Qty<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctOWN_ItemUnits', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showOWN\" ng-click=\"vm.sortBy('acctOWN_UnitPrice', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>Price<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctOWN_UnitPrice', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showOWN\" ng-click=\"vm.sortBy('acctOWN_TotalPrice', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>Total<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctOWN_TotalPrice', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showGPO\" ng-click=\"vm.sortBy('acctGPO_ItemUnits', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>Qty<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctGPO_ItemUnits', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showGPO\" ng-click=\"vm.sortBy('acctGPO_UnitPrice', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>Price<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctGPO_UnitPrice', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showGPO\" ng-click=\"vm.sortBy('acctGPO_TotalPrice', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>Total<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctGPO_TotalPrice', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showWACMED\" ng-click=\"vm.sortBy('acctWACMED_ItemUnits', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>Qty<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctWACMED_ItemUnits', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showWACMED\" ng-click=\"vm.sortBy('acctWACMED_UnitPrice', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>Price<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctWACMED_UnitPrice', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showWACMED\" ng-click=\"vm.sortBy('acctWACMED_TotalPrice', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>Total<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctWACMED_TotalPrice', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showWAC\" ng-click=\"vm.sortBy('acctWAC_ItemUnits', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>Qty<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctWAC_ItemUnits', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showWAC\" ng-click=\"vm.sortBy('acctWAC_UnitPrice', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>Price<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctWAC_UnitPrice', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showWAC\" ng-click=\"vm.sortBy('acctWAC_TotalPrice', vm.popupsort); $scope.$apply();\">\n" +
    "												<a>Total<span class=\"icon-glyph\" ng-class=\"vm.sortByIcon('acctWAC_TotalPrice', vm.popupsort.SortBy)\"></span></a>\n" +
    "											</td>\n" +
    "										</tr>\n" +
    "										<!-- FILTERS -->\n" +
    "										<tr class=\"column-filters\">\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL'\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.CEID\" />\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL' && vm.popup.hasCodeSwaps\">  <!-- drug swap -->\n" +
    "												New Item Number\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL'\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.TotalItemUnits\" />\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL'\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.TotalPrice\" />\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'FOCUS_ORDER'\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.ItemCode\" /> <!-- drug info - NDC -->\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'FOCUS_ORDER'\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.VenDrugCode\" /> <!-- drug info - Item Number -->\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'FOCUS_ORDER'\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.VenLabel\" /> <!-- drug info - Item Description -->\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'FOCUS_ORDER'\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.WholesaleUnits\" /> <!-- drug info - Wholesale Units -->\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.show340B\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.acct340B_ItemUnits\" />\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.show340B\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.acct340B_UnitPrice\"/>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.show340B\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.acct340B_TotalPrice\" />\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showOWN\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.acctOWN_ItemUnits\" />\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showOWN\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.acctOWN_UnitPrice\" />\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showOWN\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.acctOWN_TotalPrice\" />\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showGPO\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.acctGPO_ItemUnits\" />\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showGPO\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.acctGPO_UnitPrice\"/>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showGPO\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.acctGPO_TotalPrice\" />\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showWACMED\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.acctWACMED_ItemUnits\" />\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showWACMED\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.acctWACMED_UnitPrice\" />\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showWACMED\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.acctWACMED_TotalPrice\" />\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showWAC\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.acctWAC_ItemUnits\" />\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showWAC\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.acctWAC_UnitPrice\" />\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showWAC\">\n" +
    "												<input type=\"text\" ng-model=\"vm.popup.flt.acctWAC_TotalPrice\" />\n" +
    "											</td>\n" +
    "										</tr>\n" +
    "									</thead>\n" +
    "									<tbody>\n" +
    "										<tr class=\"table-list-item\" ng-class=\"{'row-shade':$even, 'has-edits':seqOrderItem.hasEdits}\" ng-repeat=\"seqOrderItem in vm.popup.Items | filter: vm.popup.flt | orderBy: vm.popupsort.SortBy\">\n" +
    "											<!-- SPLIT DETAIL -->\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL'\">{{seqOrderItem.CEID}}<span class=\"icon-glyph icon-money ng-hide\" ng-show=\"!!seqOrderItem.PriceSelected\" style=\"margin:0;padding:1px;\"></span></td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL' && vm.popup.hasCodeSwaps\">\n" +
    "												<p ng-repeat=\"seqItemSwap in seqOrderItem.CodeSwaps\" style=\"margin:1px;\">{{seqItemSwap.acct}}: {{seqItemSwap.code}}</p>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL'\" title=\"{{seqOrderItem.AckMsg}}\">{{seqOrderItem.TotalItemUnits | zeroNumberFormat:''}}</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'SPLIT_DETAIL'\">{{seqOrderItem.TotalPrice | zeroNumberFormat:'':2}}</td>\n" +
    "											<!-- DRUG INFO -->\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'FOCUS_ORDER'\">{{seqOrderItem.ItemCode}}<span class=\"icon-glyph icon-money ng-hide\" ng-show=\"!!seqOrderItem.PriceSelected\" style=\"margin:0;padding:1px;\"></span></td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'FOCUS_ORDER'\">{{seqOrderItem.VenDrugCode}}\n" +
    "												<p ng-repeat=\"seqItemFocusSwap in seqOrderItem.CodeSwaps | filter: {'acct': vm.popup.acct}\" style=\"margin:1px;\">Replacement Code: {{seqItemSwap.code}}</p>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'FOCUS_ORDER'\">{{seqOrderItem.VenLabel}}</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.type == 'FOCUS_ORDER'\">{{seqOrderItem.WholesaleUnits}}</td>				\n" +
    "											<!-- 340B -->\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.show340B && !!!seqOrderItem.acct340B_CanEdit\">{{seqOrderItem.acct340B_ItemUnits | zeroNumberFormat:''}} </td>\n" +
    "											<td class=\"qty-prompt ng-hide\" ng-show=\"vm.popup.show340B && !!seqOrderItem.acct340B_CanEdit\">\n" +
    "												<div class=\"qty-display\">\n" +
    "													<span class=\"qty-input\" ng-click=\"vm.openPopupLineItem($event, '340B', seqOrderItem)\" title=\"Edit 340B Qty\">{{seqOrderItem.acct340B_ItemUnits}}</span>\n" +
    "												</div>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.show340B\">{{seqOrderItem.acct340B_UnitPrice | zeroNumberFormat:'':2}}</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.show340B\">{{seqOrderItem.acct340B_TotalPrice | zeroNumberFormat:'':2}}</td>\n" +
    "											<!-- OWN -->\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showOWN && !!!seqOrderItem.acctOWN_CanEdit\">{{seqOrderItem.acctOWN_ItemUnits | zeroNumberFormat:''}} </td>\n" +
    "											<td class=\"qty-prompt ng-hide\" ng-show=\"vm.popup.showOWN && !!seqOrderItem.acctOWN_CanEdit\">\n" +
    "												<div class=\"qty-display\">\n" +
    "													<span class=\"qty-input\" ng-click=\"vm.openPopupLineItem($event, 'OWN', seqOrderItem)\" title=\"Edit OWN Qty\">{{seqOrderItem.acctOWN_ItemUnits}}</span>\n" +
    "												</div>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showOWN\">{{seqOrderItem.acctOWN_UnitPrice | zeroNumberFormat:'':2}}</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showOWN\">{{seqOrderItem.acctOWN_TotalPrice | zeroNumberFormat:'':2}}</td>\n" +
    "											<!-- GPO -->\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showGPO && !!!seqOrderItem.acctGPO_CanEdit\">{{seqOrderItem.acctGPO_ItemUnits | zeroNumberFormat:''}} </td>\n" +
    "											<td class=\"qty-prompt ng-hide\" ng-show=\"vm.popup.showGPO && !!seqOrderItem.acctGPO_CanEdit\">\n" +
    "												<div class=\"qty-display\">\n" +
    "													<span class=\"qty-input\" ng-click=\"vm.openPopupLineItem($event, 'GPO', seqOrderItem)\" title=\"Edit GPO Qty\">{{seqOrderItem.acctGPO_ItemUnits}}</span>\n" +
    "												</div>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showGPO\">{{seqOrderItem.acctGPO_UnitPrice | zeroNumberFormat:'':2}}</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showGPO\">{{seqOrderItem.acctGPO_TotalPrice | zeroNumberFormat:'':2}}</td>\n" +
    "											<!-- WACMED -->\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showWACMED && !!!seqOrderItem.acctWACMED_CanEdit\">{{seqOrderItem.acctWACMED_ItemUnits | zeroNumberFormat:''}} </td>\n" +
    "											<td class=\"qty-prompt ng-hide\" ng-show=\"vm.popup.showWACMED && !!seqOrderItem.acctWACMED_CanEdit\">\n" +
    "												<div class=\"qty-display\">\n" +
    "													<span class=\"qty-input\" ng-click=\"vm.openPopupLineItem($event, 'WACMED', seqOrderItem)\" title=\"Edit WACMED Qty\">{{seqOrderItem.acctWACMED_ItemUnits}}</span>\n" +
    "												</div>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showWACMED\">{{seqOrderItem.acctWACMED_UnitPrice | zeroNumberFormat:'':2}}</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showWACMED\">{{seqOrderItem.acctWACMED_TotalPrice | zeroNumberFormat:'':2}}</td>\n" +
    "											<!-- WAC -->\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showWAC && !!!seqOrderItem.acctWAC_CanEdit\">{{seqOrderItem.acctWAC_ItemUnits | zeroNumberFormat:''}} </td>\n" +
    "											<td class=\"qty-prompt ng-hide\" ng-show=\"vm.popup.showWAC && !!seqOrderItem.acctWAC_CanEdit\">\n" +
    "												<div class=\"qty-display\">\n" +
    "													<span class=\"qty-input\" ng-click=\"vm.openPopupLineItem($event, 'WAC', seqOrderItem)\" title=\"Edit WAC Qty\">{{seqOrderItem.acctWAC_ItemUnits}}</span>\n" +
    "												</div>\n" +
    "											</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showWAC\">{{seqOrderItem.acctWAC_UnitPrice | zeroNumberFormat:'':2}}</td>\n" +
    "											<td class=\"ng-hide\" ng-show=\"vm.popup.showWAC\">{{seqOrderItem.acctWAC_TotalPrice | zeroNumberFormat:'':2}}</td>\n" +
    "										</tr>\n" +
    "									</tbody>\n" +
    "								</table>\n" +
    "							</div>\n" +
    "							<p>&nbsp;</p>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<!-- SAVING DETAIL -->\n" +
    "					<div class=\"pop-saving ng-hide\" ng-show=\"vm.popup.type == 'SAVINGDETAIL'\">\n" +
    "						<p class=\"ng-hide\" ng-show=\"vm.popup.savings.length < 1\">No savings</p>\n" +
    "						<div class=\"open-close\" ng-class=\"{'oc-open':!!saving.open}\" ng-repeat=\"saving in vm.popup.savings track by $index\">\n" +
    "							<div class=\"oc-head clearfix\" ng-click=\"saving.open = !saving.open;\">\n" +
    "								<span class=\"oc-left\">{{saving.title}} : ${{saving.total | zeroNumberFormat:'0':2}}</span>\n" +
    "								<span class=\"oc-right\"><span class=\"oc-icon icon-glyph\" ng-class=\"{'icon-down': !saving.open, 'icon-up': saving.open}\" aria-hidden=\"true\" ></span></span>\n" +
    "							</div>\n" +
    "							<div class=\"oc-body ng-hide\" ng-show=\"saving.open\">\n" +
    "								<table class=\"saving-detail-table\">\n" +
    "									<colgroup>\n" +
    "										<col class=\"ng-hide\" ng-show=\"!!saving.includeOriginal\" width=\"50px\" />\n" +
    "										<col ng-style=\"{width: !!saving.includeOriginal ? '50px':'100px' }\" />\n" +
    "										<col width=\"150px\" />\n" +
    "										<col width=\"50px\" />\n" +
    "									</colgroup>\n" +
    "									<tbody>\n" +
    "										<tr class=\"column-titles\">\n" +
    "											<td class=\"ng-hide\" ng-show=\"!!saving.includeOriginal\">\n" +
    "												<a>Original NDC</a>\n" +
    "											</td>\n" +
    "											<td>\n" +
    "												<a>NDC</a>\n" +
    "											</td>\n" +
    "											<td>\n" +
    "												<a>Item Description</a>\n" +
    "											</td>\n" +
    "											<td>\n" +
    "												<a>{{!!saving.isTotal ? 'Cost' : 'Savings'}}</a>\n" +
    "											</td>\n" +
    "										</tr>\n" +
    "										<tr class=\"table-list-item\" ng-class=\"{'row-shade':$even}\" ng-repeat-start=\"line in saving.items track by $index\">\n" +
    "											<td class=\"ng-hide\" ng-show=\"!!saving.includeOriginal\">{{line.OrigItemCode}}\n" +
    "												<span class=\"oc-icon icon-glyph icon-down\" ng-click=\"line.expandMultiItems = !!!line.expandMultiItems\" \n" +
    "												ng-show=\"line.OrigItemCode == 'MULTI'\" ng-class=\"{'icon-down': !!!line.expandMultiItems, 'icon-up': !!line.expandMultiItems}\"></span>\n" +
    "											</td>\n" +
    "											<td>{{line.ItemCode}}</td>\n" +
    "											<td>{{line.Description}}</td>\n" +
    "											<td>${{line.Amount | zeroNumberFormat:'':2}}</td>\n" +
    "										</tr>\n" +
    "										<tr class=\"table-list-item ng-hide\" ng-show=\"line.OrigItemCode == 'MULTI' && !!line.expandMultiItems\" ng-class=\"{'row-shade':$even}\" ng-repeat-end ng-repeat=\"origItem in line.Items track by $index\">\n" +
    "											<td>{{origItem.OrigItemCode}}</td>\n" +
    "											<td>{{''}}</td>\n" +
    "											<td>{{origItem.OrigVendItemName}}</td>\n" +
    "											<td>${{origItem.SavingResults.VeriSaveSaving | zeroNumberFormat:'':2}}</td>\n" +
    "										</tr>\n" +
    "									</tbody>\n" +
    "								</table>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "					<!-- MULTI ORIGINAL NDCS -->\n" +
    "					<div class=\"pop-ndc ng-hide\" ng-show=\"vm.popup.type == 'MULTIORIGINAL'\">\n" +
    "						<p style=\"margin-top: 10px; margin-bottom:10px;\">\n" +
    "							<span>{{vm.popup.items.length}} NDCs changed to Ordered NDC {{vm.popup.originalNDC}}</span>\n" +
    "						</p>\n" +
    "						<table class=\"split-detail-table\">\n" +
    "							<colgroup>\n" +
    "								<col width=\"150px\" />\n" +
    "								<col width=\"150px\" />\n" +
    "								<col width=\"150px\" />\n" +
    "								<col width=\"150px\" />\n" +
    "							</colgroup>\n" +
    "							<tbody>\n" +
    "								<tr class=\"column-titles\">\n" +
    "									<td>\n" +
    "										<a>Original NDC</a>\n" +
    "									</td>\n" +
    "									<td>\n" +
    "										<a>Item Description</a>\n" +
    "									</td>\n" +
    "									<td>\n" +
    "										<a>Original Cost</a>\n" +
    "									</td>\n" +
    "									<td>\n" +
    "										<a>Final Cost</a>\n" +
    "									</td>\n" +
    "								</tr>\n" +
    "								<tr ng-class=\"{'row-shade':$even}\" ng-repeat=\"line in vm.popup.items track by $index\">\n" +
    "									<td>{{line.OrigItemCode}}</td>\n" +
    "									<td>{{line.OrigVendItemName}}</td>\n" +
    "									<td>${{line.OrigBlendedCost}}</td>\n" +
    "									<td>${{line.BestCost}}</td>\n" +
    "								</tr>\n" +
    "							</tbody>\n" +
    "						</table>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<div class=\"table-popup-bkg\" ng-click=\"vm.closePopup()\">&nbsp;</div>\n" +
    "			</div>\n" +
    "			<!-- POPUP: LINE ITEM EDIT -->\n" +
    "			<!-- note: needs to be separated to popup over sequential edit popup -->\n" +
    "			<div class=\"table-popup table-popup-inline-editor ng-hide\" ng-show=\"!!vm.popupLineItem.ready\">\n" +
    "				<div id=\"tablePopupContentLINEITEM\" class=\"table-popup-content inline-editor\">\n" +
    "					<h5 class=\"table-popup-title\" ng-click=\"vm.closePopupLineItem()\"><span>{{vm.popupLineItem.title}}</span><span class=\"icon-glyph icon-cancel\" ng-click=\"vm.closePopupLineItem()\"></span></h5>\n" +
    "					<div class=\"popup-line-editor\">\n" +
    "						<div class=\"popup-content\">\n" +
    "							<div class=\"form-field\">\n" +
    "								<input id=\"popupLineItemInput\" class=\"qty-input\" type=\"text\" ng-model=\"vm.popupLineItem.qty\" />\n" +
    "								<button type=\"button\" ng-click=\"vm.lineQtyUpdate()\"><span class=\"icon-glyph icon-edit\"></span></button>\n" +
    "							</div>\n" +
    "						</div>\n" +
    "					</div>\n" +
    "				</div>\n" +
    "				<div class=\"table-popup-bkg inline-bkg ng-hide\" ng-show=\"!!vm.popupLineItem.ready\" ng-click=\"vm.closePopupLineItem()\">&nbsp;</div>\n" +
    "			</div>\n" +
    "		</section>\n" +
    "	</div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("shared/main/main.flex.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shared/main/main.flex.tpl.html",
    "<section class=\"page-title new-page-top new-page-flex\">\n" +
    "	<h4>\n" +
    "		<span class=\"sprite\" ng-class=\"vmMain.icon\" aria-hidden=\"true\"></span>&nbsp;{{vmMain.title}}\n" +
    "		<a class=\"breadcrumb ng-hide\" ng-show=\"!!vmMain.breadcrumb\" ng-click=\"vmMain.routeToBreadcrumb()\"><span class=\"sprite-link\" ng-class=\"vmMain.breadcrumb.icon\" aria-hidden=\"true\"></span>&nbsp;{{vmMain.breadcrumb.msg}}</a>\n" +
    "	</h4>\n" +
    "</section>\n" +
    "<div ui-view></div>\n" +
    "");
}]);

angular.module("shared/main/main.report.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shared/main/main.report.tpl.html",
    "<section class=\"page-title\">\n" +
    "	<h2>\n" +
    "		<span class=\"icon-glyph\" ng-class=\"vmMain.icon\" aria-hidden=\"true\"></span><span class=\"title-text\" ng-bind=\"vmMain.title\"></span>\n" +
    "		<a class=\"breadcrumb ng-hide\" ng-show=\"!!vmMain.breadcrumb\" ng-click=\"vmMain.routeToBreadcrumb()\"><span class=\"icon-glyph\" ng-class=\"vmMain.breadcrumb.icon\" aria-hidden=\"true\"></span>{{vmMain.breadcrumb.msg}}</a>\n" +
    "	</h2>\n" +
    "</section>\n" +
    "<div ui-view></div>\n" +
    "<div scripty-lazy-load data-src=\"vendor/pdf/FileSaver.js\"></div>\n" +
    "<div scripty-lazy-load data-src=\"vendor/pdf/blob-stream.js\"></div>\n" +
    "<div scripty-lazy-load data-src=\"vendor/pdf/pdfkit.js\"></div>\n" +
    "");
}]);

angular.module("shared/main/main.reportB.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shared/main/main.reportB.tpl.html",
    "<div class=\"page-title-bkg\" ng-class=\"{'title-bkg-0rows': vmMain.bkgHeight === '0rows', 'title-bkg-1rows': vmMain.bkgHeight === '1rows', 'title-bkg-2rows': vmMain.bkgHeight === '2rows', 'title-bkg-3rows': vmMain.bkgHeight === '3rows'}\">\n" +
    "	&nbsp;\n" +
    "</div>\n" +
    "<section class=\"page-title new-page-top\">\n" +
    "	<h4>\n" +
    "		<span class=\"sprite\" ng-class=\"vmMain.icon\" aria-hidden=\"true\"></span>&nbsp;{{vmMain.title}}\n" +
    "		<a class=\"breadcrumb ng-hide\" ng-show=\"!!vmMain.breadcrumb\" ng-click=\"vmMain.routeToBreadcrumb()\"><span class=\"sprite-link\" ng-class=\"vmMain.breadcrumb.icon\" aria-hidden=\"true\"></span>&nbsp;{{vmMain.breadcrumb.msg}}</a>\n" +
    "	</h4>\n" +
    "</section>\n" +
    "<div ui-view></div>\n" +
    "<div scripty-lazy-load data-src=\"vendor/pdf/FileSaver.js\"></div>\n" +
    "<div scripty-lazy-load data-src=\"vendor/pdf/blob-stream.js\"></div>\n" +
    "<div scripty-lazy-load data-src=\"vendor/pdf/pdfkit.js\"></div>\n" +
    "");
}]);

angular.module("shared/main/main.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shared/main/main.tpl.html",
    "<section class=\"page-title\">\n" +
    "	<h2>\n" +
    "		<span class=\"icon-glyph\" ng-class=\"vmMain.icon\" aria-hidden=\"true\"></span><span class=\"title-text\" ng-bind=\"vmMain.title\"></span>\n" +
    "		<a class=\"breadcrumb ng-hide\" ng-show=\"!!vmMain.breadcrumb\" ng-click=\"vmMain.routeToBreadcrumb()\"><span class=\"icon-glyph\" ng-class=\"vmMain.breadcrumb.icon\" aria-hidden=\"true\"></span>{{vmMain.breadcrumb.msg}}</a>\n" +
    "	</h2>\n" +
    "</section>\n" +
    "<div ui-view></div>\n" +
    "");
}]);

angular.module("shared/main/mainB.tpl.html", []).run(["$templateCache", function ($templateCache) {
  $templateCache.put("shared/main/mainB.tpl.html",
    "<div class=\"page-title-bkg\" ng-class=\"{'title-bkg-0rows': vmMain.bkgHeight === '0rows', 'title-bkg-1rows': vmMain.bkgHeight === '1rows', 'title-bkg-2rows': vmMain.bkgHeight === '2rows', 'title-bkg-3rows': vmMain.bkgHeight === '3rows'}\">\n" +
    "	&nbsp;\n" +
    "</div>\n" +
    "<section class=\"page-title new-page-top\">\n" +
    "	<h4>\n" +
    "		<span class=\"sprite\" ng-class=\"vmMain.icon\" aria-hidden=\"true\"></span>&nbsp;{{vmMain.title}}\n" +
    "		<a class=\"breadcrumb ng-hide\" ng-show=\"!!vmMain.breadcrumb\" ng-click=\"vmMain.routeToBreadcrumb()\"><span class=\"sprite-link\" ng-class=\"vmMain.breadcrumb.icon\" aria-hidden=\"true\"></span>&nbsp;{{vmMain.breadcrumb.msg}}</a>\n" +
    "	</h4>\n" +
    "</section>\n" +
    "<div ui-view></div>\n" +
    "");
}]);
}